
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("loA2J", function(module, exports) {
"use strict";

module.exports = (parcelRequire("02AJv"));

});
parcelRegister("02AJv", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $007cae67934ac0a3$export$ffb0004e005737fa; }, function (v) { return $007cae67934ac0a3$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $007cae67934ac0a3$export$34b9dba7ce09269b; }, function (v) { return $007cae67934ac0a3$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $007cae67934ac0a3$export$25062201e9e25d76; }, function (v) { return $007cae67934ac0a3$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $007cae67934ac0a3$export$ffb0004e005737fa;
var $007cae67934ac0a3$export$34b9dba7ce09269b;
var $007cae67934ac0a3$export$25062201e9e25d76;
"use strict";

var $iSvIT = parcelRequire("iSvIT");
var $007cae67934ac0a3$var$k = Symbol.for("react.element"), $007cae67934ac0a3$var$l = Symbol.for("react.fragment"), $007cae67934ac0a3$var$m = Object.prototype.hasOwnProperty, $007cae67934ac0a3$var$n = $iSvIT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $007cae67934ac0a3$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $007cae67934ac0a3$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$007cae67934ac0a3$var$m.call(a, b) && !$007cae67934ac0a3$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $007cae67934ac0a3$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $007cae67934ac0a3$var$n.current
    };
}
$007cae67934ac0a3$export$ffb0004e005737fa = $007cae67934ac0a3$var$l;
$007cae67934ac0a3$export$34b9dba7ce09269b = $007cae67934ac0a3$var$q;
$007cae67934ac0a3$export$25062201e9e25d76 = $007cae67934ac0a3$var$q;

});
parcelRegister("iSvIT", function(module, exports) {
"use strict";

module.exports = (parcelRequire("XRWij"));

});
parcelRegister("XRWij", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $0b3f5a02beded80c$export$dca3b0875bd9a954; }, function (v) { return $0b3f5a02beded80c$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $0b3f5a02beded80c$export$16fa2f45be04daa8; }, function (v) { return $0b3f5a02beded80c$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $0b3f5a02beded80c$export$ffb0004e005737fa; }, function (v) { return $0b3f5a02beded80c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $0b3f5a02beded80c$export$e2c29f18771995cb; }, function (v) { return $0b3f5a02beded80c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $0b3f5a02beded80c$export$221d75b3f55bb0bd; }, function (v) { return $0b3f5a02beded80c$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $0b3f5a02beded80c$export$5f8d39834fd61797; }, function (v) { return $0b3f5a02beded80c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $0b3f5a02beded80c$export$74bf444e3cd11ea5; }, function (v) { return $0b3f5a02beded80c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $0b3f5a02beded80c$export$ae55be85d98224ed; }, function (v) { return $0b3f5a02beded80c$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $0b3f5a02beded80c$export$3ba232387fd5d6dd; }, function (v) { return $0b3f5a02beded80c$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $0b3f5a02beded80c$export$e530037191fcd5d7; }, function (v) { return $0b3f5a02beded80c$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $0b3f5a02beded80c$export$fd42f52fd3ae1109; }, function (v) { return $0b3f5a02beded80c$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $0b3f5a02beded80c$export$c8a8987d4410bf2d; }, function (v) { return $0b3f5a02beded80c$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $0b3f5a02beded80c$export$d38cd72104c1f0e9; }, function (v) { return $0b3f5a02beded80c$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $0b3f5a02beded80c$export$7d1e3a5e95ceca43; }, function (v) { return $0b3f5a02beded80c$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $0b3f5a02beded80c$export$257a8862b851cb5b; }, function (v) { return $0b3f5a02beded80c$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $0b3f5a02beded80c$export$a8257692ac88316c; }, function (v) { return $0b3f5a02beded80c$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $0b3f5a02beded80c$export$488013bae63b21da; }, function (v) { return $0b3f5a02beded80c$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $0b3f5a02beded80c$export$7c73462e0d25e514; }, function (v) { return $0b3f5a02beded80c$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $0b3f5a02beded80c$export$7568632d0d33d16d; }, function (v) { return $0b3f5a02beded80c$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $0b3f5a02beded80c$export$88948ce120ea2619; }, function (v) { return $0b3f5a02beded80c$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $0b3f5a02beded80c$export$35808ee640e87ca7; }, function (v) { return $0b3f5a02beded80c$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $0b3f5a02beded80c$export$fae74005e78b1a27; }, function (v) { return $0b3f5a02beded80c$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $0b3f5a02beded80c$export$dc8fbce3eb94dc1e; }, function (v) { return $0b3f5a02beded80c$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $0b3f5a02beded80c$export$6a7bc4e911dc01cf; }, function (v) { return $0b3f5a02beded80c$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $0b3f5a02beded80c$export$6d9c69b0de29b591; }, function (v) { return $0b3f5a02beded80c$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $0b3f5a02beded80c$export$f680877a34711e37; }, function (v) { return $0b3f5a02beded80c$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $0b3f5a02beded80c$export$d5a552a76deda3c2; }, function (v) { return $0b3f5a02beded80c$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $0b3f5a02beded80c$export$aaabe4eda9ed9969; }, function (v) { return $0b3f5a02beded80c$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $0b3f5a02beded80c$export$e5c5a5f917a5871c; }, function (v) { return $0b3f5a02beded80c$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $0b3f5a02beded80c$export$1538c33de8887b59; }, function (v) { return $0b3f5a02beded80c$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $0b3f5a02beded80c$export$13e3392192263954; }, function (v) { return $0b3f5a02beded80c$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $0b3f5a02beded80c$export$b8f5890fc79d6aca; }, function (v) { return $0b3f5a02beded80c$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $0b3f5a02beded80c$export$60241385465d0a34; }, function (v) { return $0b3f5a02beded80c$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $0b3f5a02beded80c$export$306c0aa65ff9ec16; }, function (v) { return $0b3f5a02beded80c$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $0b3f5a02beded80c$export$7b286972b8d8ccbf; }, function (v) { return $0b3f5a02beded80c$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $0b3f5a02beded80c$export$83d89fbfd8236492; }, function (v) { return $0b3f5a02beded80c$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0b3f5a02beded80c$export$dca3b0875bd9a954;
var $0b3f5a02beded80c$export$16fa2f45be04daa8;
var $0b3f5a02beded80c$export$ffb0004e005737fa;
var $0b3f5a02beded80c$export$e2c29f18771995cb;
var $0b3f5a02beded80c$export$221d75b3f55bb0bd;
var $0b3f5a02beded80c$export$5f8d39834fd61797;
var $0b3f5a02beded80c$export$74bf444e3cd11ea5;
var $0b3f5a02beded80c$export$ae55be85d98224ed;
var $0b3f5a02beded80c$export$3ba232387fd5d6dd;
var $0b3f5a02beded80c$export$e530037191fcd5d7;
var $0b3f5a02beded80c$export$fd42f52fd3ae1109;
var $0b3f5a02beded80c$export$c8a8987d4410bf2d;
var $0b3f5a02beded80c$export$d38cd72104c1f0e9;
var $0b3f5a02beded80c$export$7d1e3a5e95ceca43;
var $0b3f5a02beded80c$export$257a8862b851cb5b;
var $0b3f5a02beded80c$export$a8257692ac88316c;
var $0b3f5a02beded80c$export$488013bae63b21da;
var $0b3f5a02beded80c$export$7c73462e0d25e514;
var $0b3f5a02beded80c$export$7568632d0d33d16d;
var $0b3f5a02beded80c$export$88948ce120ea2619;
var $0b3f5a02beded80c$export$35808ee640e87ca7;
var $0b3f5a02beded80c$export$fae74005e78b1a27;
var $0b3f5a02beded80c$export$dc8fbce3eb94dc1e;
var $0b3f5a02beded80c$export$6a7bc4e911dc01cf;
var $0b3f5a02beded80c$export$6d9c69b0de29b591;
var $0b3f5a02beded80c$export$f680877a34711e37;
var $0b3f5a02beded80c$export$d5a552a76deda3c2;
var $0b3f5a02beded80c$export$aaabe4eda9ed9969;
var $0b3f5a02beded80c$export$e5c5a5f917a5871c;
var $0b3f5a02beded80c$export$1538c33de8887b59;
var $0b3f5a02beded80c$export$13e3392192263954;
var $0b3f5a02beded80c$export$b8f5890fc79d6aca;
var $0b3f5a02beded80c$export$60241385465d0a34;
var $0b3f5a02beded80c$export$306c0aa65ff9ec16;
var $0b3f5a02beded80c$export$7b286972b8d8ccbf;
var $0b3f5a02beded80c$export$83d89fbfd8236492;
"use strict";
var $0b3f5a02beded80c$var$l = Symbol.for("react.element"), $0b3f5a02beded80c$var$n = Symbol.for("react.portal"), $0b3f5a02beded80c$var$p = Symbol.for("react.fragment"), $0b3f5a02beded80c$var$q = Symbol.for("react.strict_mode"), $0b3f5a02beded80c$var$r = Symbol.for("react.profiler"), $0b3f5a02beded80c$var$t = Symbol.for("react.provider"), $0b3f5a02beded80c$var$u = Symbol.for("react.context"), $0b3f5a02beded80c$var$v = Symbol.for("react.forward_ref"), $0b3f5a02beded80c$var$w = Symbol.for("react.suspense"), $0b3f5a02beded80c$var$x = Symbol.for("react.memo"), $0b3f5a02beded80c$var$y = Symbol.for("react.lazy"), $0b3f5a02beded80c$var$z = Symbol.iterator;
function $0b3f5a02beded80c$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b3f5a02beded80c$var$z && a[$0b3f5a02beded80c$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b3f5a02beded80c$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $0b3f5a02beded80c$var$C = Object.assign, $0b3f5a02beded80c$var$D = {};
function $0b3f5a02beded80c$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b3f5a02beded80c$var$D;
    this.updater = e || $0b3f5a02beded80c$var$B;
}
$0b3f5a02beded80c$var$E.prototype.isReactComponent = {};
$0b3f5a02beded80c$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$0b3f5a02beded80c$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $0b3f5a02beded80c$var$F() {}
$0b3f5a02beded80c$var$F.prototype = $0b3f5a02beded80c$var$E.prototype;
function $0b3f5a02beded80c$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $0b3f5a02beded80c$var$D;
    this.updater = e || $0b3f5a02beded80c$var$B;
}
var $0b3f5a02beded80c$var$H = $0b3f5a02beded80c$var$G.prototype = new $0b3f5a02beded80c$var$F;
$0b3f5a02beded80c$var$H.constructor = $0b3f5a02beded80c$var$G;
$0b3f5a02beded80c$var$C($0b3f5a02beded80c$var$H, $0b3f5a02beded80c$var$E.prototype);
$0b3f5a02beded80c$var$H.isPureReactComponent = !0;
var $0b3f5a02beded80c$var$I = Array.isArray, $0b3f5a02beded80c$var$J = Object.prototype.hasOwnProperty, $0b3f5a02beded80c$var$K = {
    current: null
}, $0b3f5a02beded80c$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0b3f5a02beded80c$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$0b3f5a02beded80c$var$J.call(b, d) && !$0b3f5a02beded80c$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $0b3f5a02beded80c$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $0b3f5a02beded80c$var$K.current
    };
}
function $0b3f5a02beded80c$var$N(a, b) {
    return {
        $$typeof: $0b3f5a02beded80c$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $0b3f5a02beded80c$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0b3f5a02beded80c$var$l;
}
function $0b3f5a02beded80c$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $0b3f5a02beded80c$var$P = /\/+/g;
function $0b3f5a02beded80c$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $0b3f5a02beded80c$var$escape("" + a.key) : b.toString(36);
}
function $0b3f5a02beded80c$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $0b3f5a02beded80c$var$l:
                case $0b3f5a02beded80c$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $0b3f5a02beded80c$var$Q(h, 0) : d, $0b3f5a02beded80c$var$I(c) ? (e = "", null != a && (e = a.replace($0b3f5a02beded80c$var$P, "$&/") + "/"), $0b3f5a02beded80c$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($0b3f5a02beded80c$var$O(c) && (c = $0b3f5a02beded80c$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($0b3f5a02beded80c$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($0b3f5a02beded80c$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $0b3f5a02beded80c$var$Q(k, g);
        h += $0b3f5a02beded80c$var$R(k, b, e, f, c);
    }
    else if (f = $0b3f5a02beded80c$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $0b3f5a02beded80c$var$Q(k, g++), h += $0b3f5a02beded80c$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $0b3f5a02beded80c$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $0b3f5a02beded80c$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $0b3f5a02beded80c$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $0b3f5a02beded80c$var$U = {
    current: null
}, $0b3f5a02beded80c$var$V = {
    transition: null
}, $0b3f5a02beded80c$var$W = {
    ReactCurrentDispatcher: $0b3f5a02beded80c$var$U,
    ReactCurrentBatchConfig: $0b3f5a02beded80c$var$V,
    ReactCurrentOwner: $0b3f5a02beded80c$var$K
};
function $0b3f5a02beded80c$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$0b3f5a02beded80c$export$dca3b0875bd9a954 = {
    map: $0b3f5a02beded80c$var$S,
    forEach: function(a, b, e) {
        $0b3f5a02beded80c$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $0b3f5a02beded80c$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $0b3f5a02beded80c$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$0b3f5a02beded80c$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$0b3f5a02beded80c$export$16fa2f45be04daa8 = $0b3f5a02beded80c$var$E;
$0b3f5a02beded80c$export$ffb0004e005737fa = $0b3f5a02beded80c$var$p;
$0b3f5a02beded80c$export$e2c29f18771995cb = $0b3f5a02beded80c$var$r;
$0b3f5a02beded80c$export$221d75b3f55bb0bd = $0b3f5a02beded80c$var$G;
$0b3f5a02beded80c$export$5f8d39834fd61797 = $0b3f5a02beded80c$var$q;
$0b3f5a02beded80c$export$74bf444e3cd11ea5 = $0b3f5a02beded80c$var$w;
$0b3f5a02beded80c$export$ae55be85d98224ed = $0b3f5a02beded80c$var$W;
$0b3f5a02beded80c$export$3ba232387fd5d6dd = $0b3f5a02beded80c$var$X;
$0b3f5a02beded80c$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $0b3f5a02beded80c$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $0b3f5a02beded80c$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$0b3f5a02beded80c$var$J.call(b, f) && !$0b3f5a02beded80c$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $0b3f5a02beded80c$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$0b3f5a02beded80c$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $0b3f5a02beded80c$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $0b3f5a02beded80c$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$0b3f5a02beded80c$export$c8a8987d4410bf2d = $0b3f5a02beded80c$var$M;
$0b3f5a02beded80c$export$d38cd72104c1f0e9 = function(a) {
    var b = $0b3f5a02beded80c$var$M.bind(null, a);
    b.type = a;
    return b;
};
$0b3f5a02beded80c$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$0b3f5a02beded80c$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $0b3f5a02beded80c$var$v,
        render: a
    };
};
$0b3f5a02beded80c$export$a8257692ac88316c = $0b3f5a02beded80c$var$O;
$0b3f5a02beded80c$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $0b3f5a02beded80c$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $0b3f5a02beded80c$var$T
    };
};
$0b3f5a02beded80c$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $0b3f5a02beded80c$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$0b3f5a02beded80c$export$7568632d0d33d16d = function(a) {
    var b = $0b3f5a02beded80c$var$V.transition;
    $0b3f5a02beded80c$var$V.transition = {};
    try {
        a();
    } finally{
        $0b3f5a02beded80c$var$V.transition = b;
    }
};
$0b3f5a02beded80c$export$88948ce120ea2619 = $0b3f5a02beded80c$var$X;
$0b3f5a02beded80c$export$35808ee640e87ca7 = function(a, b) {
    return $0b3f5a02beded80c$var$U.current.useCallback(a, b);
};
$0b3f5a02beded80c$export$fae74005e78b1a27 = function(a) {
    return $0b3f5a02beded80c$var$U.current.useContext(a);
};
$0b3f5a02beded80c$export$dc8fbce3eb94dc1e = function() {};
$0b3f5a02beded80c$export$6a7bc4e911dc01cf = function(a) {
    return $0b3f5a02beded80c$var$U.current.useDeferredValue(a);
};
$0b3f5a02beded80c$export$6d9c69b0de29b591 = function(a, b) {
    return $0b3f5a02beded80c$var$U.current.useEffect(a, b);
};
$0b3f5a02beded80c$export$f680877a34711e37 = function() {
    return $0b3f5a02beded80c$var$U.current.useId();
};
$0b3f5a02beded80c$export$d5a552a76deda3c2 = function(a, b, e) {
    return $0b3f5a02beded80c$var$U.current.useImperativeHandle(a, b, e);
};
$0b3f5a02beded80c$export$aaabe4eda9ed9969 = function(a, b) {
    return $0b3f5a02beded80c$var$U.current.useInsertionEffect(a, b);
};
$0b3f5a02beded80c$export$e5c5a5f917a5871c = function(a, b) {
    return $0b3f5a02beded80c$var$U.current.useLayoutEffect(a, b);
};
$0b3f5a02beded80c$export$1538c33de8887b59 = function(a, b) {
    return $0b3f5a02beded80c$var$U.current.useMemo(a, b);
};
$0b3f5a02beded80c$export$13e3392192263954 = function(a, b, e) {
    return $0b3f5a02beded80c$var$U.current.useReducer(a, b, e);
};
$0b3f5a02beded80c$export$b8f5890fc79d6aca = function(a) {
    return $0b3f5a02beded80c$var$U.current.useRef(a);
};
$0b3f5a02beded80c$export$60241385465d0a34 = function(a) {
    return $0b3f5a02beded80c$var$U.current.useState(a);
};
$0b3f5a02beded80c$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $0b3f5a02beded80c$var$U.current.useSyncExternalStore(a, b, e);
};
$0b3f5a02beded80c$export$7b286972b8d8ccbf = function() {
    return $0b3f5a02beded80c$var$U.current.useTransition();
};
$0b3f5a02beded80c$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("i5UxU", function(module, exports) {
"use strict";
function $d2c48e7cc7cae0b9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d2c48e7cc7cae0b9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d2c48e7cc7cae0b9$var$checkDCE();

module.exports = (parcelRequire("6NJyY"));

});
parcelRegister("6NJyY", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4f3aa993cc57516e$export$ae55be85d98224ed; }, function (v) { return $4f3aa993cc57516e$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4f3aa993cc57516e$export$d39a5bbd09211389; }, function (v) { return $4f3aa993cc57516e$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4f3aa993cc57516e$export$882461b6382ed46c; }, function (v) { return $4f3aa993cc57516e$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4f3aa993cc57516e$export$466bfc07425424d5; }, function (v) { return $4f3aa993cc57516e$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4f3aa993cc57516e$export$cd75ccfd720a3cd4; }, function (v) { return $4f3aa993cc57516e$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4f3aa993cc57516e$export$fa8d919ba61d84db; }, function (v) { return $4f3aa993cc57516e$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4f3aa993cc57516e$export$757ceba2d55c277e; }, function (v) { return $4f3aa993cc57516e$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4f3aa993cc57516e$export$b3890eb0ae9dca99; }, function (v) { return $4f3aa993cc57516e$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4f3aa993cc57516e$export$502457920280e6be; }, function (v) { return $4f3aa993cc57516e$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4f3aa993cc57516e$export$c78a37762a8d58e1; }, function (v) { return $4f3aa993cc57516e$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4f3aa993cc57516e$export$dc54d992c10e8a18; }, function (v) { return $4f3aa993cc57516e$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4f3aa993cc57516e$export$83d89fbfd8236492; }, function (v) { return $4f3aa993cc57516e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f3aa993cc57516e$export$ae55be85d98224ed;
var $4f3aa993cc57516e$export$d39a5bbd09211389;
var $4f3aa993cc57516e$export$882461b6382ed46c;
var $4f3aa993cc57516e$export$466bfc07425424d5;
var $4f3aa993cc57516e$export$cd75ccfd720a3cd4;
var $4f3aa993cc57516e$export$fa8d919ba61d84db;
var $4f3aa993cc57516e$export$757ceba2d55c277e;
var $4f3aa993cc57516e$export$b3890eb0ae9dca99;
var $4f3aa993cc57516e$export$502457920280e6be;
var $4f3aa993cc57516e$export$c78a37762a8d58e1;
var $4f3aa993cc57516e$export$dc54d992c10e8a18;
var $4f3aa993cc57516e$export$83d89fbfd8236492;
"use strict";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $iSvIT = parcelRequire("iSvIT");

var $lMj4E = parcelRequire("lMj4E");
function $4f3aa993cc57516e$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4f3aa993cc57516e$var$da = new Set, $4f3aa993cc57516e$var$ea = {};
function $4f3aa993cc57516e$var$fa(a, b) {
    $4f3aa993cc57516e$var$ha(a, b);
    $4f3aa993cc57516e$var$ha(a + "Capture", b);
}
function $4f3aa993cc57516e$var$ha(a, b) {
    $4f3aa993cc57516e$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4f3aa993cc57516e$var$da.add(b[a]);
}
var $4f3aa993cc57516e$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4f3aa993cc57516e$var$ja = Object.prototype.hasOwnProperty, $4f3aa993cc57516e$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4f3aa993cc57516e$var$la = {}, $4f3aa993cc57516e$var$ma = {};
function $4f3aa993cc57516e$var$na(a) {
    if ($4f3aa993cc57516e$var$ja.call($4f3aa993cc57516e$var$ma, a)) return !0;
    if ($4f3aa993cc57516e$var$ja.call($4f3aa993cc57516e$var$la, a)) return !1;
    if ($4f3aa993cc57516e$var$ka.test(a)) return $4f3aa993cc57516e$var$ma[a] = !0;
    $4f3aa993cc57516e$var$la[a] = !0;
    return !1;
}
function $4f3aa993cc57516e$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4f3aa993cc57516e$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4f3aa993cc57516e$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4f3aa993cc57516e$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4f3aa993cc57516e$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4f3aa993cc57516e$var$t[b] = new $4f3aa993cc57516e$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4f3aa993cc57516e$var$ra = /[\-:]([a-z])/g;
function $4f3aa993cc57516e$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4f3aa993cc57516e$var$ra, $4f3aa993cc57516e$var$ta);
    $4f3aa993cc57516e$var$t[b] = new $4f3aa993cc57516e$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4f3aa993cc57516e$var$ra, $4f3aa993cc57516e$var$ta);
    $4f3aa993cc57516e$var$t[b] = new $4f3aa993cc57516e$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4f3aa993cc57516e$var$ra, $4f3aa993cc57516e$var$ta);
    $4f3aa993cc57516e$var$t[b] = new $4f3aa993cc57516e$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4f3aa993cc57516e$var$t.xlinkHref = new $4f3aa993cc57516e$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4f3aa993cc57516e$var$t[a] = new $4f3aa993cc57516e$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4f3aa993cc57516e$var$ua(a, b, c, d) {
    var e = $4f3aa993cc57516e$var$t.hasOwnProperty(b) ? $4f3aa993cc57516e$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4f3aa993cc57516e$var$pa(b, c, e, d) && (c = null), d || null === e ? $4f3aa993cc57516e$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4f3aa993cc57516e$var$va = $iSvIT.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4f3aa993cc57516e$var$wa = Symbol.for("react.element"), $4f3aa993cc57516e$var$xa = Symbol.for("react.portal"), $4f3aa993cc57516e$var$ya = Symbol.for("react.fragment"), $4f3aa993cc57516e$var$za = Symbol.for("react.strict_mode"), $4f3aa993cc57516e$var$Aa = Symbol.for("react.profiler"), $4f3aa993cc57516e$var$Ba = Symbol.for("react.provider"), $4f3aa993cc57516e$var$Ca = Symbol.for("react.context"), $4f3aa993cc57516e$var$Da = Symbol.for("react.forward_ref"), $4f3aa993cc57516e$var$Ea = Symbol.for("react.suspense"), $4f3aa993cc57516e$var$Fa = Symbol.for("react.suspense_list"), $4f3aa993cc57516e$var$Ga = Symbol.for("react.memo"), $4f3aa993cc57516e$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4f3aa993cc57516e$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4f3aa993cc57516e$var$Ja = Symbol.iterator;
function $4f3aa993cc57516e$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4f3aa993cc57516e$var$Ja && a[$4f3aa993cc57516e$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4f3aa993cc57516e$var$u = Object.assign, $4f3aa993cc57516e$var$La;
function $4f3aa993cc57516e$var$Ma(a) {
    if (void 0 === $4f3aa993cc57516e$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4f3aa993cc57516e$var$La = b && b[1] || "";
    }
    return "\n" + $4f3aa993cc57516e$var$La + a;
}
var $4f3aa993cc57516e$var$Na = !1;
function $4f3aa993cc57516e$var$Oa(a, b) {
    if (!a || $4f3aa993cc57516e$var$Na) return "";
    $4f3aa993cc57516e$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4f3aa993cc57516e$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4f3aa993cc57516e$var$Ma(a) : "";
}
function $4f3aa993cc57516e$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4f3aa993cc57516e$var$Ma(a.type);
        case 16:
            return $4f3aa993cc57516e$var$Ma("Lazy");
        case 13:
            return $4f3aa993cc57516e$var$Ma("Suspense");
        case 19:
            return $4f3aa993cc57516e$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4f3aa993cc57516e$var$Oa(a.type, !1), a;
        case 11:
            return a = $4f3aa993cc57516e$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4f3aa993cc57516e$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4f3aa993cc57516e$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4f3aa993cc57516e$var$ya:
            return "Fragment";
        case $4f3aa993cc57516e$var$xa:
            return "Portal";
        case $4f3aa993cc57516e$var$Aa:
            return "Profiler";
        case $4f3aa993cc57516e$var$za:
            return "StrictMode";
        case $4f3aa993cc57516e$var$Ea:
            return "Suspense";
        case $4f3aa993cc57516e$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4f3aa993cc57516e$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4f3aa993cc57516e$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4f3aa993cc57516e$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4f3aa993cc57516e$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4f3aa993cc57516e$var$Qa(a.type) || "Memo";
        case $4f3aa993cc57516e$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4f3aa993cc57516e$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4f3aa993cc57516e$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4f3aa993cc57516e$var$Qa(b);
        case 8:
            return b === $4f3aa993cc57516e$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4f3aa993cc57516e$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4f3aa993cc57516e$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4f3aa993cc57516e$var$Ua(a) {
    var b = $4f3aa993cc57516e$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4f3aa993cc57516e$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4f3aa993cc57516e$var$Ua(a));
}
function $4f3aa993cc57516e$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4f3aa993cc57516e$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4f3aa993cc57516e$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4f3aa993cc57516e$var$Ya(a, b) {
    var c = b.checked;
    return $4f3aa993cc57516e$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4f3aa993cc57516e$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4f3aa993cc57516e$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4f3aa993cc57516e$var$$a(a, b) {
    b = b.checked;
    null != b && $4f3aa993cc57516e$var$ua(a, "checked", b, !1);
}
function $4f3aa993cc57516e$var$ab(a, b) {
    $4f3aa993cc57516e$var$$a(a, b);
    var c = $4f3aa993cc57516e$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4f3aa993cc57516e$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4f3aa993cc57516e$var$bb(a, b.type, $4f3aa993cc57516e$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4f3aa993cc57516e$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4f3aa993cc57516e$var$bb(a, b, c) {
    if ("number" !== b || $4f3aa993cc57516e$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4f3aa993cc57516e$var$db = Array.isArray;
function $4f3aa993cc57516e$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4f3aa993cc57516e$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4f3aa993cc57516e$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4f3aa993cc57516e$var$p(91));
    return $4f3aa993cc57516e$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4f3aa993cc57516e$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4f3aa993cc57516e$var$p(92));
            if ($4f3aa993cc57516e$var$db(c)) {
                if (1 < c.length) throw Error($4f3aa993cc57516e$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4f3aa993cc57516e$var$Sa(c)
    };
}
function $4f3aa993cc57516e$var$hb(a, b) {
    var c = $4f3aa993cc57516e$var$Sa(b.value), d = $4f3aa993cc57516e$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4f3aa993cc57516e$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4f3aa993cc57516e$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4f3aa993cc57516e$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4f3aa993cc57516e$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4f3aa993cc57516e$var$mb, $4f3aa993cc57516e$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4f3aa993cc57516e$var$mb = $4f3aa993cc57516e$var$mb || document.createElement("div");
        $4f3aa993cc57516e$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4f3aa993cc57516e$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4f3aa993cc57516e$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4f3aa993cc57516e$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4f3aa993cc57516e$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4f3aa993cc57516e$var$pb).forEach(function(a) {
    $4f3aa993cc57516e$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4f3aa993cc57516e$var$pb[b] = $4f3aa993cc57516e$var$pb[a];
    });
});
function $4f3aa993cc57516e$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4f3aa993cc57516e$var$pb.hasOwnProperty(a) && $4f3aa993cc57516e$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4f3aa993cc57516e$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4f3aa993cc57516e$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4f3aa993cc57516e$var$tb = $4f3aa993cc57516e$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4f3aa993cc57516e$var$ub(a, b) {
    if (b) {
        if ($4f3aa993cc57516e$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4f3aa993cc57516e$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4f3aa993cc57516e$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4f3aa993cc57516e$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4f3aa993cc57516e$var$p(62));
    }
}
function $4f3aa993cc57516e$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4f3aa993cc57516e$var$wb = null;
function $4f3aa993cc57516e$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4f3aa993cc57516e$var$yb = null, $4f3aa993cc57516e$var$zb = null, $4f3aa993cc57516e$var$Ab = null;
function $4f3aa993cc57516e$var$Bb(a) {
    if (a = $4f3aa993cc57516e$var$Cb(a)) {
        if ("function" !== typeof $4f3aa993cc57516e$var$yb) throw Error($4f3aa993cc57516e$var$p(280));
        var b = a.stateNode;
        b && (b = $4f3aa993cc57516e$var$Db(b), $4f3aa993cc57516e$var$yb(a.stateNode, a.type, b));
    }
}
function $4f3aa993cc57516e$var$Eb(a) {
    $4f3aa993cc57516e$var$zb ? $4f3aa993cc57516e$var$Ab ? $4f3aa993cc57516e$var$Ab.push(a) : $4f3aa993cc57516e$var$Ab = [
        a
    ] : $4f3aa993cc57516e$var$zb = a;
}
function $4f3aa993cc57516e$var$Fb() {
    if ($4f3aa993cc57516e$var$zb) {
        var a = $4f3aa993cc57516e$var$zb, b = $4f3aa993cc57516e$var$Ab;
        $4f3aa993cc57516e$var$Ab = $4f3aa993cc57516e$var$zb = null;
        $4f3aa993cc57516e$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4f3aa993cc57516e$var$Bb(b[a]);
    }
}
function $4f3aa993cc57516e$var$Gb(a, b) {
    return a(b);
}
function $4f3aa993cc57516e$var$Hb() {}
var $4f3aa993cc57516e$var$Ib = !1;
function $4f3aa993cc57516e$var$Jb(a, b, c) {
    if ($4f3aa993cc57516e$var$Ib) return a(b, c);
    $4f3aa993cc57516e$var$Ib = !0;
    try {
        return $4f3aa993cc57516e$var$Gb(a, b, c);
    } finally{
        if ($4f3aa993cc57516e$var$Ib = !1, null !== $4f3aa993cc57516e$var$zb || null !== $4f3aa993cc57516e$var$Ab) $4f3aa993cc57516e$var$Hb(), $4f3aa993cc57516e$var$Fb();
    }
}
function $4f3aa993cc57516e$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4f3aa993cc57516e$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4f3aa993cc57516e$var$p(231, b, typeof c));
    return c;
}
var $4f3aa993cc57516e$var$Lb = !1;
if ($4f3aa993cc57516e$var$ia) try {
    var $4f3aa993cc57516e$var$Mb = {};
    Object.defineProperty($4f3aa993cc57516e$var$Mb, "passive", {
        get: function() {
            $4f3aa993cc57516e$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4f3aa993cc57516e$var$Mb, $4f3aa993cc57516e$var$Mb);
    window.removeEventListener("test", $4f3aa993cc57516e$var$Mb, $4f3aa993cc57516e$var$Mb);
} catch (a) {
    $4f3aa993cc57516e$var$Lb = !1;
}
function $4f3aa993cc57516e$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $4f3aa993cc57516e$var$Ob = !1, $4f3aa993cc57516e$var$Pb = null, $4f3aa993cc57516e$var$Qb = !1, $4f3aa993cc57516e$var$Rb = null, $4f3aa993cc57516e$var$Sb = {
    onError: function(a) {
        $4f3aa993cc57516e$var$Ob = !0;
        $4f3aa993cc57516e$var$Pb = a;
    }
};
function $4f3aa993cc57516e$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4f3aa993cc57516e$var$Ob = !1;
    $4f3aa993cc57516e$var$Pb = null;
    $4f3aa993cc57516e$var$Nb.apply($4f3aa993cc57516e$var$Sb, arguments);
}
function $4f3aa993cc57516e$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4f3aa993cc57516e$var$Tb.apply(this, arguments);
    if ($4f3aa993cc57516e$var$Ob) {
        if ($4f3aa993cc57516e$var$Ob) {
            var l = $4f3aa993cc57516e$var$Pb;
            $4f3aa993cc57516e$var$Ob = !1;
            $4f3aa993cc57516e$var$Pb = null;
        } else throw Error($4f3aa993cc57516e$var$p(198));
        $4f3aa993cc57516e$var$Qb || ($4f3aa993cc57516e$var$Qb = !0, $4f3aa993cc57516e$var$Rb = l);
    }
}
function $4f3aa993cc57516e$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4f3aa993cc57516e$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4f3aa993cc57516e$var$Xb(a) {
    if ($4f3aa993cc57516e$var$Vb(a) !== a) throw Error($4f3aa993cc57516e$var$p(188));
}
function $4f3aa993cc57516e$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4f3aa993cc57516e$var$Vb(a);
        if (null === b) throw Error($4f3aa993cc57516e$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4f3aa993cc57516e$var$Xb(e), a;
                if (f === d) return $4f3aa993cc57516e$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4f3aa993cc57516e$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4f3aa993cc57516e$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4f3aa993cc57516e$var$p(190));
    }
    if (3 !== c.tag) throw Error($4f3aa993cc57516e$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4f3aa993cc57516e$var$Zb(a) {
    a = $4f3aa993cc57516e$var$Yb(a);
    return null !== a ? $4f3aa993cc57516e$var$$b(a) : null;
}
function $4f3aa993cc57516e$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4f3aa993cc57516e$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4f3aa993cc57516e$var$ac = $lMj4E.unstable_scheduleCallback, $4f3aa993cc57516e$var$bc = $lMj4E.unstable_cancelCallback, $4f3aa993cc57516e$var$cc = $lMj4E.unstable_shouldYield, $4f3aa993cc57516e$var$dc = $lMj4E.unstable_requestPaint, $4f3aa993cc57516e$var$A = $lMj4E.unstable_now, $4f3aa993cc57516e$var$ec = $lMj4E.unstable_getCurrentPriorityLevel, $4f3aa993cc57516e$var$fc = $lMj4E.unstable_ImmediatePriority, $4f3aa993cc57516e$var$gc = $lMj4E.unstable_UserBlockingPriority, $4f3aa993cc57516e$var$hc = $lMj4E.unstable_NormalPriority, $4f3aa993cc57516e$var$ic = $lMj4E.unstable_LowPriority, $4f3aa993cc57516e$var$jc = $lMj4E.unstable_IdlePriority, $4f3aa993cc57516e$var$kc = null, $4f3aa993cc57516e$var$lc = null, $4f3aa993cc57516e$var$B = null, $4f3aa993cc57516e$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $4f3aa993cc57516e$var$nc(a, b) {
    if ($4f3aa993cc57516e$var$lc && "function" === typeof $4f3aa993cc57516e$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $4f3aa993cc57516e$var$fc;
                break;
            case 4:
                d = $4f3aa993cc57516e$var$gc;
                break;
            case 16:
                d = $4f3aa993cc57516e$var$hc;
                break;
            case 536870912:
                d = $4f3aa993cc57516e$var$jc;
                break;
            default:
                d = $4f3aa993cc57516e$var$hc;
        }
        $4f3aa993cc57516e$var$lc.onCommitFiberRoot($4f3aa993cc57516e$var$kc, a, d, c);
    } catch (e) {}
}
function $4f3aa993cc57516e$var$oc(a) {
    $4f3aa993cc57516e$var$B = a;
}
function $4f3aa993cc57516e$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $4f3aa993cc57516e$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $4f3aa993cc57516e$var$rc() {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markCommitStopped && $4f3aa993cc57516e$var$B.markCommitStopped();
}
function $4f3aa993cc57516e$var$sc(a) {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentRenderStarted && $4f3aa993cc57516e$var$B.markComponentRenderStarted(a);
}
function $4f3aa993cc57516e$var$tc() {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentRenderStopped && $4f3aa993cc57516e$var$B.markComponentRenderStopped();
}
function $4f3aa993cc57516e$var$uc(a) {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentLayoutEffectUnmountStarted && $4f3aa993cc57516e$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $4f3aa993cc57516e$var$vc() {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentLayoutEffectUnmountStopped && $4f3aa993cc57516e$var$B.markComponentLayoutEffectUnmountStopped();
}
function $4f3aa993cc57516e$var$wc(a) {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markRenderStarted && $4f3aa993cc57516e$var$B.markRenderStarted(a);
}
function $4f3aa993cc57516e$var$xc() {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markRenderStopped && $4f3aa993cc57516e$var$B.markRenderStopped();
}
function $4f3aa993cc57516e$var$yc(a, b) {
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markStateUpdateScheduled && $4f3aa993cc57516e$var$B.markStateUpdateScheduled(a, b);
}
var $4f3aa993cc57516e$var$Ac = Math.clz32 ? Math.clz32 : $4f3aa993cc57516e$var$zc, $4f3aa993cc57516e$var$Bc = Math.log, $4f3aa993cc57516e$var$Cc = Math.LN2;
function $4f3aa993cc57516e$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4f3aa993cc57516e$var$Bc(a) / $4f3aa993cc57516e$var$Cc | 0) | 0;
}
function $4f3aa993cc57516e$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $4f3aa993cc57516e$var$Dc = 64, $4f3aa993cc57516e$var$Ec = 4194304;
function $4f3aa993cc57516e$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4f3aa993cc57516e$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4f3aa993cc57516e$var$Fc(h) : (f &= g, 0 !== f && (d = $4f3aa993cc57516e$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $4f3aa993cc57516e$var$Fc(g) : 0 !== f && (d = $4f3aa993cc57516e$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4f3aa993cc57516e$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4f3aa993cc57516e$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4f3aa993cc57516e$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4f3aa993cc57516e$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4f3aa993cc57516e$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4f3aa993cc57516e$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4f3aa993cc57516e$var$Kc() {
    var a = $4f3aa993cc57516e$var$Dc;
    $4f3aa993cc57516e$var$Dc <<= 1;
    0 === ($4f3aa993cc57516e$var$Dc & 4194240) && ($4f3aa993cc57516e$var$Dc = 64);
    return a;
}
function $4f3aa993cc57516e$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4f3aa993cc57516e$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4f3aa993cc57516e$var$Ac(b);
    a[b] = c;
}
function $4f3aa993cc57516e$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4f3aa993cc57516e$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4f3aa993cc57516e$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4f3aa993cc57516e$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $4f3aa993cc57516e$var$Pc(a, b, c) {
    if ($4f3aa993cc57516e$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $4f3aa993cc57516e$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $4f3aa993cc57516e$var$Qc(a, b) {
    if ($4f3aa993cc57516e$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $4f3aa993cc57516e$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $4f3aa993cc57516e$var$E = 0;
function $4f3aa993cc57516e$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4f3aa993cc57516e$var$Sc, $4f3aa993cc57516e$var$Tc, $4f3aa993cc57516e$var$Uc, $4f3aa993cc57516e$var$Vc, $4f3aa993cc57516e$var$Wc, $4f3aa993cc57516e$var$Xc = !1, $4f3aa993cc57516e$var$Yc = [], $4f3aa993cc57516e$var$Zc = null, $4f3aa993cc57516e$var$$c = null, $4f3aa993cc57516e$var$ad = null, $4f3aa993cc57516e$var$bd = new Map, $4f3aa993cc57516e$var$cd = new Map, $4f3aa993cc57516e$var$dd = [], $4f3aa993cc57516e$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4f3aa993cc57516e$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4f3aa993cc57516e$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4f3aa993cc57516e$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $4f3aa993cc57516e$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $4f3aa993cc57516e$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4f3aa993cc57516e$var$cd.delete(b.pointerId);
    }
}
function $4f3aa993cc57516e$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4f3aa993cc57516e$var$Cb(b), null !== b && $4f3aa993cc57516e$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4f3aa993cc57516e$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4f3aa993cc57516e$var$Zc = $4f3aa993cc57516e$var$gd($4f3aa993cc57516e$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $4f3aa993cc57516e$var$$c = $4f3aa993cc57516e$var$gd($4f3aa993cc57516e$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $4f3aa993cc57516e$var$ad = $4f3aa993cc57516e$var$gd($4f3aa993cc57516e$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4f3aa993cc57516e$var$bd.set(f, $4f3aa993cc57516e$var$gd($4f3aa993cc57516e$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4f3aa993cc57516e$var$cd.set(f, $4f3aa993cc57516e$var$gd($4f3aa993cc57516e$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4f3aa993cc57516e$var$id(a) {
    var b = $4f3aa993cc57516e$var$jd(a.target);
    if (null !== b) {
        var c = $4f3aa993cc57516e$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4f3aa993cc57516e$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4f3aa993cc57516e$var$Wc(a.priority, function() {
                        $4f3aa993cc57516e$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4f3aa993cc57516e$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4f3aa993cc57516e$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4f3aa993cc57516e$var$wb = d;
            c.target.dispatchEvent(d);
            $4f3aa993cc57516e$var$wb = null;
        } else return b = $4f3aa993cc57516e$var$Cb(c), null !== b && $4f3aa993cc57516e$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4f3aa993cc57516e$var$md(a, b, c) {
    $4f3aa993cc57516e$var$kd(a) && c.delete(b);
}
function $4f3aa993cc57516e$var$nd() {
    $4f3aa993cc57516e$var$Xc = !1;
    null !== $4f3aa993cc57516e$var$Zc && $4f3aa993cc57516e$var$kd($4f3aa993cc57516e$var$Zc) && ($4f3aa993cc57516e$var$Zc = null);
    null !== $4f3aa993cc57516e$var$$c && $4f3aa993cc57516e$var$kd($4f3aa993cc57516e$var$$c) && ($4f3aa993cc57516e$var$$c = null);
    null !== $4f3aa993cc57516e$var$ad && $4f3aa993cc57516e$var$kd($4f3aa993cc57516e$var$ad) && ($4f3aa993cc57516e$var$ad = null);
    $4f3aa993cc57516e$var$bd.forEach($4f3aa993cc57516e$var$md);
    $4f3aa993cc57516e$var$cd.forEach($4f3aa993cc57516e$var$md);
}
function $4f3aa993cc57516e$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4f3aa993cc57516e$var$Xc || ($4f3aa993cc57516e$var$Xc = !0, $lMj4E.unstable_scheduleCallback($lMj4E.unstable_NormalPriority, $4f3aa993cc57516e$var$nd)));
}
function $4f3aa993cc57516e$var$pd(a) {
    function b(b) {
        return $4f3aa993cc57516e$var$od(b, a);
    }
    if (0 < $4f3aa993cc57516e$var$Yc.length) {
        $4f3aa993cc57516e$var$od($4f3aa993cc57516e$var$Yc[0], a);
        for(var c = 1; c < $4f3aa993cc57516e$var$Yc.length; c++){
            var d = $4f3aa993cc57516e$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4f3aa993cc57516e$var$Zc && $4f3aa993cc57516e$var$od($4f3aa993cc57516e$var$Zc, a);
    null !== $4f3aa993cc57516e$var$$c && $4f3aa993cc57516e$var$od($4f3aa993cc57516e$var$$c, a);
    null !== $4f3aa993cc57516e$var$ad && $4f3aa993cc57516e$var$od($4f3aa993cc57516e$var$ad, a);
    $4f3aa993cc57516e$var$bd.forEach(b);
    $4f3aa993cc57516e$var$cd.forEach(b);
    for(c = 0; c < $4f3aa993cc57516e$var$dd.length; c++)d = $4f3aa993cc57516e$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4f3aa993cc57516e$var$dd.length && (c = $4f3aa993cc57516e$var$dd[0], null === c.blockedOn);)$4f3aa993cc57516e$var$id(c), null === c.blockedOn && $4f3aa993cc57516e$var$dd.shift();
}
var $4f3aa993cc57516e$var$qd = $4f3aa993cc57516e$var$va.ReactCurrentBatchConfig, $4f3aa993cc57516e$var$rd = !0;
function $4f3aa993cc57516e$var$sd(a, b, c, d) {
    var e = $4f3aa993cc57516e$var$E, f = $4f3aa993cc57516e$var$qd.transition;
    $4f3aa993cc57516e$var$qd.transition = null;
    try {
        $4f3aa993cc57516e$var$E = 1, $4f3aa993cc57516e$var$td(a, b, c, d);
    } finally{
        $4f3aa993cc57516e$var$E = e, $4f3aa993cc57516e$var$qd.transition = f;
    }
}
function $4f3aa993cc57516e$var$ud(a, b, c, d) {
    var e = $4f3aa993cc57516e$var$E, f = $4f3aa993cc57516e$var$qd.transition;
    $4f3aa993cc57516e$var$qd.transition = null;
    try {
        $4f3aa993cc57516e$var$E = 4, $4f3aa993cc57516e$var$td(a, b, c, d);
    } finally{
        $4f3aa993cc57516e$var$E = e, $4f3aa993cc57516e$var$qd.transition = f;
    }
}
function $4f3aa993cc57516e$var$td(a, b, c, d) {
    if ($4f3aa993cc57516e$var$rd) {
        var e = $4f3aa993cc57516e$var$ld(a, b, c, d);
        if (null === e) $4f3aa993cc57516e$var$vd(a, b, d, $4f3aa993cc57516e$var$wd, c), $4f3aa993cc57516e$var$fd(a, d);
        else if ($4f3aa993cc57516e$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($4f3aa993cc57516e$var$fd(a, d), b & 4 && -1 < $4f3aa993cc57516e$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $4f3aa993cc57516e$var$Cb(e);
                null !== f && $4f3aa993cc57516e$var$Sc(f);
                f = $4f3aa993cc57516e$var$ld(a, b, c, d);
                null === f && $4f3aa993cc57516e$var$vd(a, b, d, $4f3aa993cc57516e$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4f3aa993cc57516e$var$vd(a, b, d, null, c);
    }
}
var $4f3aa993cc57516e$var$wd = null;
function $4f3aa993cc57516e$var$ld(a, b, c, d) {
    $4f3aa993cc57516e$var$wd = null;
    a = $4f3aa993cc57516e$var$xb(d);
    a = $4f3aa993cc57516e$var$jd(a);
    if (null !== a) {
        if (b = $4f3aa993cc57516e$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4f3aa993cc57516e$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4f3aa993cc57516e$var$wd = a;
    return null;
}
function $4f3aa993cc57516e$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4f3aa993cc57516e$var$ec()){
                case $4f3aa993cc57516e$var$fc:
                    return 1;
                case $4f3aa993cc57516e$var$gc:
                    return 4;
                case $4f3aa993cc57516e$var$hc:
                case $4f3aa993cc57516e$var$ic:
                    return 16;
                case $4f3aa993cc57516e$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4f3aa993cc57516e$var$yd = null, $4f3aa993cc57516e$var$zd = null, $4f3aa993cc57516e$var$Ad = null;
function $4f3aa993cc57516e$var$Bd() {
    if ($4f3aa993cc57516e$var$Ad) return $4f3aa993cc57516e$var$Ad;
    var a, b = $4f3aa993cc57516e$var$zd, c = b.length, d, e = "value" in $4f3aa993cc57516e$var$yd ? $4f3aa993cc57516e$var$yd.value : $4f3aa993cc57516e$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4f3aa993cc57516e$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4f3aa993cc57516e$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4f3aa993cc57516e$var$Dd() {
    return !0;
}
function $4f3aa993cc57516e$var$Ed() {
    return !1;
}
function $4f3aa993cc57516e$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4f3aa993cc57516e$var$Dd : $4f3aa993cc57516e$var$Ed;
        this.isPropagationStopped = $4f3aa993cc57516e$var$Ed;
        return this;
    }
    $4f3aa993cc57516e$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4f3aa993cc57516e$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4f3aa993cc57516e$var$Dd);
        },
        persist: function() {},
        isPersistent: $4f3aa993cc57516e$var$Dd
    });
    return b;
}
var $4f3aa993cc57516e$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4f3aa993cc57516e$var$Hd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Gd), $4f3aa993cc57516e$var$Id = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Gd, {
    view: 0,
    detail: 0
}), $4f3aa993cc57516e$var$Jd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Id), $4f3aa993cc57516e$var$Kd, $4f3aa993cc57516e$var$Ld, $4f3aa993cc57516e$var$Md, $4f3aa993cc57516e$var$Od = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4f3aa993cc57516e$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4f3aa993cc57516e$var$Md && ($4f3aa993cc57516e$var$Md && "mousemove" === a.type ? ($4f3aa993cc57516e$var$Kd = a.screenX - $4f3aa993cc57516e$var$Md.screenX, $4f3aa993cc57516e$var$Ld = a.screenY - $4f3aa993cc57516e$var$Md.screenY) : $4f3aa993cc57516e$var$Ld = $4f3aa993cc57516e$var$Kd = 0, $4f3aa993cc57516e$var$Md = a);
        return $4f3aa993cc57516e$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4f3aa993cc57516e$var$Ld;
    }
}), $4f3aa993cc57516e$var$Pd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Od), $4f3aa993cc57516e$var$Qd = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Od, {
    dataTransfer: 0
}), $4f3aa993cc57516e$var$Rd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Qd), $4f3aa993cc57516e$var$Sd = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Id, {
    relatedTarget: 0
}), $4f3aa993cc57516e$var$Td = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Sd), $4f3aa993cc57516e$var$Ud = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4f3aa993cc57516e$var$Vd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Ud), $4f3aa993cc57516e$var$Wd = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4f3aa993cc57516e$var$Xd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Wd), $4f3aa993cc57516e$var$Yd = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Gd, {
    data: 0
}), $4f3aa993cc57516e$var$Zd = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$Yd), $4f3aa993cc57516e$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4f3aa993cc57516e$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4f3aa993cc57516e$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4f3aa993cc57516e$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4f3aa993cc57516e$var$be[a]) ? !!b[a] : !1;
}
function $4f3aa993cc57516e$var$Nd() {
    return $4f3aa993cc57516e$var$ce;
}
var $4f3aa993cc57516e$var$de = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $4f3aa993cc57516e$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4f3aa993cc57516e$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4f3aa993cc57516e$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4f3aa993cc57516e$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $4f3aa993cc57516e$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4f3aa993cc57516e$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4f3aa993cc57516e$var$ee = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$de), $4f3aa993cc57516e$var$fe = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4f3aa993cc57516e$var$ge = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$fe), $4f3aa993cc57516e$var$he = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4f3aa993cc57516e$var$Nd
}), $4f3aa993cc57516e$var$ie = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$he), $4f3aa993cc57516e$var$je = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4f3aa993cc57516e$var$ke = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$je), $4f3aa993cc57516e$var$le = $4f3aa993cc57516e$var$u({}, $4f3aa993cc57516e$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4f3aa993cc57516e$var$me = $4f3aa993cc57516e$var$Fd($4f3aa993cc57516e$var$le), $4f3aa993cc57516e$var$ne = [
    9,
    13,
    27,
    32
], $4f3aa993cc57516e$var$oe = $4f3aa993cc57516e$var$ia && "CompositionEvent" in window, $4f3aa993cc57516e$var$pe = null;
$4f3aa993cc57516e$var$ia && "documentMode" in document && ($4f3aa993cc57516e$var$pe = document.documentMode);
var $4f3aa993cc57516e$var$qe = $4f3aa993cc57516e$var$ia && "TextEvent" in window && !$4f3aa993cc57516e$var$pe, $4f3aa993cc57516e$var$re = $4f3aa993cc57516e$var$ia && (!$4f3aa993cc57516e$var$oe || $4f3aa993cc57516e$var$pe && 8 < $4f3aa993cc57516e$var$pe && 11 >= $4f3aa993cc57516e$var$pe), $4f3aa993cc57516e$var$se = String.fromCharCode(32), $4f3aa993cc57516e$var$te = !1;
function $4f3aa993cc57516e$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4f3aa993cc57516e$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4f3aa993cc57516e$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4f3aa993cc57516e$var$we = !1;
function $4f3aa993cc57516e$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $4f3aa993cc57516e$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4f3aa993cc57516e$var$te = !0;
            return $4f3aa993cc57516e$var$se;
        case "textInput":
            return a = b.data, a === $4f3aa993cc57516e$var$se && $4f3aa993cc57516e$var$te ? null : a;
        default:
            return null;
    }
}
function $4f3aa993cc57516e$var$ye(a, b) {
    if ($4f3aa993cc57516e$var$we) return "compositionend" === a || !$4f3aa993cc57516e$var$oe && $4f3aa993cc57516e$var$ue(a, b) ? (a = $4f3aa993cc57516e$var$Bd(), $4f3aa993cc57516e$var$Ad = $4f3aa993cc57516e$var$zd = $4f3aa993cc57516e$var$yd = null, $4f3aa993cc57516e$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4f3aa993cc57516e$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4f3aa993cc57516e$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4f3aa993cc57516e$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4f3aa993cc57516e$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $4f3aa993cc57516e$var$Be(a, b, c, d) {
    $4f3aa993cc57516e$var$Eb(d);
    b = $4f3aa993cc57516e$var$Ce(b, "onChange");
    0 < b.length && (c = new $4f3aa993cc57516e$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4f3aa993cc57516e$var$De = null, $4f3aa993cc57516e$var$Ee = null;
function $4f3aa993cc57516e$var$Fe(a) {
    $4f3aa993cc57516e$var$Ge(a, 0);
}
function $4f3aa993cc57516e$var$He(a) {
    var b = $4f3aa993cc57516e$var$Ie(a);
    if ($4f3aa993cc57516e$var$Wa(b)) return a;
}
function $4f3aa993cc57516e$var$Je(a, b) {
    if ("change" === a) return b;
}
var $4f3aa993cc57516e$var$Ke = !1;
if ($4f3aa993cc57516e$var$ia) {
    var $4f3aa993cc57516e$var$Le;
    if ($4f3aa993cc57516e$var$ia) {
        var $4f3aa993cc57516e$var$Me = "oninput" in document;
        if (!$4f3aa993cc57516e$var$Me) {
            var $4f3aa993cc57516e$var$Ne = document.createElement("div");
            $4f3aa993cc57516e$var$Ne.setAttribute("oninput", "return;");
            $4f3aa993cc57516e$var$Me = "function" === typeof $4f3aa993cc57516e$var$Ne.oninput;
        }
        $4f3aa993cc57516e$var$Le = $4f3aa993cc57516e$var$Me;
    } else $4f3aa993cc57516e$var$Le = !1;
    $4f3aa993cc57516e$var$Ke = $4f3aa993cc57516e$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $4f3aa993cc57516e$var$Oe() {
    $4f3aa993cc57516e$var$De && ($4f3aa993cc57516e$var$De.detachEvent("onpropertychange", $4f3aa993cc57516e$var$Pe), $4f3aa993cc57516e$var$Ee = $4f3aa993cc57516e$var$De = null);
}
function $4f3aa993cc57516e$var$Pe(a) {
    if ("value" === a.propertyName && $4f3aa993cc57516e$var$He($4f3aa993cc57516e$var$Ee)) {
        var b = [];
        $4f3aa993cc57516e$var$Be(b, $4f3aa993cc57516e$var$Ee, a, $4f3aa993cc57516e$var$xb(a));
        $4f3aa993cc57516e$var$Jb($4f3aa993cc57516e$var$Fe, b);
    }
}
function $4f3aa993cc57516e$var$Qe(a, b, c) {
    "focusin" === a ? ($4f3aa993cc57516e$var$Oe(), $4f3aa993cc57516e$var$De = b, $4f3aa993cc57516e$var$Ee = c, $4f3aa993cc57516e$var$De.attachEvent("onpropertychange", $4f3aa993cc57516e$var$Pe)) : "focusout" === a && $4f3aa993cc57516e$var$Oe();
}
function $4f3aa993cc57516e$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4f3aa993cc57516e$var$He($4f3aa993cc57516e$var$Ee);
}
function $4f3aa993cc57516e$var$Se(a, b) {
    if ("click" === a) return $4f3aa993cc57516e$var$He(b);
}
function $4f3aa993cc57516e$var$Te(a, b) {
    if ("input" === a || "change" === a) return $4f3aa993cc57516e$var$He(b);
}
function $4f3aa993cc57516e$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4f3aa993cc57516e$var$Ve = "function" === typeof Object.is ? Object.is : $4f3aa993cc57516e$var$Ue;
function $4f3aa993cc57516e$var$We(a, b) {
    if ($4f3aa993cc57516e$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4f3aa993cc57516e$var$ja.call(b, e) || !$4f3aa993cc57516e$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $4f3aa993cc57516e$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4f3aa993cc57516e$var$Ye(a, b) {
    var c = $4f3aa993cc57516e$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4f3aa993cc57516e$var$Xe(c);
    }
}
function $4f3aa993cc57516e$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4f3aa993cc57516e$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4f3aa993cc57516e$var$$e() {
    for(var a = window, b = $4f3aa993cc57516e$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4f3aa993cc57516e$var$Xa(a.document);
    }
    return b;
}
function $4f3aa993cc57516e$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4f3aa993cc57516e$var$bf(a) {
    var b = $4f3aa993cc57516e$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4f3aa993cc57516e$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4f3aa993cc57516e$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4f3aa993cc57516e$var$Ye(c, f);
                var g = $4f3aa993cc57516e$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4f3aa993cc57516e$var$cf = $4f3aa993cc57516e$var$ia && "documentMode" in document && 11 >= document.documentMode, $4f3aa993cc57516e$var$df = null, $4f3aa993cc57516e$var$ef = null, $4f3aa993cc57516e$var$ff = null, $4f3aa993cc57516e$var$gf = !1;
function $4f3aa993cc57516e$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4f3aa993cc57516e$var$gf || null == $4f3aa993cc57516e$var$df || $4f3aa993cc57516e$var$df !== $4f3aa993cc57516e$var$Xa(d) || (d = $4f3aa993cc57516e$var$df, "selectionStart" in d && $4f3aa993cc57516e$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4f3aa993cc57516e$var$ff && $4f3aa993cc57516e$var$We($4f3aa993cc57516e$var$ff, d) || ($4f3aa993cc57516e$var$ff = d, d = $4f3aa993cc57516e$var$Ce($4f3aa993cc57516e$var$ef, "onSelect"), 0 < d.length && (b = new $4f3aa993cc57516e$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4f3aa993cc57516e$var$df)));
}
function $4f3aa993cc57516e$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4f3aa993cc57516e$var$kf = {
    animationend: $4f3aa993cc57516e$var$jf("Animation", "AnimationEnd"),
    animationiteration: $4f3aa993cc57516e$var$jf("Animation", "AnimationIteration"),
    animationstart: $4f3aa993cc57516e$var$jf("Animation", "AnimationStart"),
    transitionend: $4f3aa993cc57516e$var$jf("Transition", "TransitionEnd")
}, $4f3aa993cc57516e$var$lf = {}, $4f3aa993cc57516e$var$mf = {};
$4f3aa993cc57516e$var$ia && ($4f3aa993cc57516e$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $4f3aa993cc57516e$var$kf.animationend.animation, delete $4f3aa993cc57516e$var$kf.animationiteration.animation, delete $4f3aa993cc57516e$var$kf.animationstart.animation), "TransitionEvent" in window || delete $4f3aa993cc57516e$var$kf.transitionend.transition);
function $4f3aa993cc57516e$var$nf(a) {
    if ($4f3aa993cc57516e$var$lf[a]) return $4f3aa993cc57516e$var$lf[a];
    if (!$4f3aa993cc57516e$var$kf[a]) return a;
    var b = $4f3aa993cc57516e$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4f3aa993cc57516e$var$mf) return $4f3aa993cc57516e$var$lf[a] = b[c];
    return a;
}
var $4f3aa993cc57516e$var$of = $4f3aa993cc57516e$var$nf("animationend"), $4f3aa993cc57516e$var$pf = $4f3aa993cc57516e$var$nf("animationiteration"), $4f3aa993cc57516e$var$qf = $4f3aa993cc57516e$var$nf("animationstart"), $4f3aa993cc57516e$var$rf = $4f3aa993cc57516e$var$nf("transitionend"), $4f3aa993cc57516e$var$sf = new Map, $4f3aa993cc57516e$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4f3aa993cc57516e$var$uf(a, b) {
    $4f3aa993cc57516e$var$sf.set(a, b);
    $4f3aa993cc57516e$var$fa(b, [
        a
    ]);
}
for(var $4f3aa993cc57516e$var$vf = 0; $4f3aa993cc57516e$var$vf < $4f3aa993cc57516e$var$tf.length; $4f3aa993cc57516e$var$vf++){
    var $4f3aa993cc57516e$var$wf = $4f3aa993cc57516e$var$tf[$4f3aa993cc57516e$var$vf], $4f3aa993cc57516e$var$xf = $4f3aa993cc57516e$var$wf.toLowerCase(), $4f3aa993cc57516e$var$yf = $4f3aa993cc57516e$var$wf[0].toUpperCase() + $4f3aa993cc57516e$var$wf.slice(1);
    $4f3aa993cc57516e$var$uf($4f3aa993cc57516e$var$xf, "on" + $4f3aa993cc57516e$var$yf);
}
$4f3aa993cc57516e$var$uf($4f3aa993cc57516e$var$of, "onAnimationEnd");
$4f3aa993cc57516e$var$uf($4f3aa993cc57516e$var$pf, "onAnimationIteration");
$4f3aa993cc57516e$var$uf($4f3aa993cc57516e$var$qf, "onAnimationStart");
$4f3aa993cc57516e$var$uf("dblclick", "onDoubleClick");
$4f3aa993cc57516e$var$uf("focusin", "onFocus");
$4f3aa993cc57516e$var$uf("focusout", "onBlur");
$4f3aa993cc57516e$var$uf($4f3aa993cc57516e$var$rf, "onTransitionEnd");
$4f3aa993cc57516e$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4f3aa993cc57516e$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4f3aa993cc57516e$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4f3aa993cc57516e$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4f3aa993cc57516e$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4f3aa993cc57516e$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4f3aa993cc57516e$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4f3aa993cc57516e$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4f3aa993cc57516e$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4f3aa993cc57516e$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4f3aa993cc57516e$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4f3aa993cc57516e$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($4f3aa993cc57516e$var$zf));
function $4f3aa993cc57516e$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4f3aa993cc57516e$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4f3aa993cc57516e$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4f3aa993cc57516e$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4f3aa993cc57516e$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($4f3aa993cc57516e$var$Qb) throw a = $4f3aa993cc57516e$var$Rb, $4f3aa993cc57516e$var$Qb = !1, $4f3aa993cc57516e$var$Rb = null, a;
}
function $4f3aa993cc57516e$var$F(a, b) {
    var c = b[$4f3aa993cc57516e$var$Cf];
    void 0 === c && (c = b[$4f3aa993cc57516e$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4f3aa993cc57516e$var$Df(b, a, 2, !1), c.add(d));
}
function $4f3aa993cc57516e$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4f3aa993cc57516e$var$Df(c, a, d, b);
}
var $4f3aa993cc57516e$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $4f3aa993cc57516e$var$Gf(a) {
    if (!a[$4f3aa993cc57516e$var$Ff]) {
        a[$4f3aa993cc57516e$var$Ff] = !0;
        $4f3aa993cc57516e$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4f3aa993cc57516e$var$Af.has(b) || $4f3aa993cc57516e$var$Ef(b, !1, a), $4f3aa993cc57516e$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4f3aa993cc57516e$var$Ff] || (b[$4f3aa993cc57516e$var$Ff] = !0, $4f3aa993cc57516e$var$Ef("selectionchange", !1, b));
    }
}
function $4f3aa993cc57516e$var$Df(a, b, c, d) {
    switch($4f3aa993cc57516e$var$xd(b)){
        case 1:
            var e = $4f3aa993cc57516e$var$sd;
            break;
        case 4:
            e = $4f3aa993cc57516e$var$ud;
            break;
        default:
            e = $4f3aa993cc57516e$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4f3aa993cc57516e$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4f3aa993cc57516e$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4f3aa993cc57516e$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4f3aa993cc57516e$var$Jb(function() {
        var d = f, e = $4f3aa993cc57516e$var$xb(c), g = [];
        a: {
            var h = $4f3aa993cc57516e$var$sf.get(a);
            if (void 0 !== h) {
                var k = $4f3aa993cc57516e$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $4f3aa993cc57516e$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4f3aa993cc57516e$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $4f3aa993cc57516e$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $4f3aa993cc57516e$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4f3aa993cc57516e$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4f3aa993cc57516e$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4f3aa993cc57516e$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4f3aa993cc57516e$var$ie;
                        break;
                    case $4f3aa993cc57516e$var$of:
                    case $4f3aa993cc57516e$var$pf:
                    case $4f3aa993cc57516e$var$qf:
                        k = $4f3aa993cc57516e$var$Vd;
                        break;
                    case $4f3aa993cc57516e$var$rf:
                        k = $4f3aa993cc57516e$var$ke;
                        break;
                    case "scroll":
                        k = $4f3aa993cc57516e$var$Jd;
                        break;
                    case "wheel":
                        k = $4f3aa993cc57516e$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4f3aa993cc57516e$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4f3aa993cc57516e$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $4f3aa993cc57516e$var$Kb(y, x), null != D && w.push($4f3aa993cc57516e$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4f3aa993cc57516e$var$wb && (m = c.relatedTarget || c.fromElement) && ($4f3aa993cc57516e$var$jd(m) || m[$4f3aa993cc57516e$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $4f3aa993cc57516e$var$jd(m) : null, null !== m && (C = $4f3aa993cc57516e$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $4f3aa993cc57516e$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $4f3aa993cc57516e$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $4f3aa993cc57516e$var$Ie(k);
                        v = null == m ? h : $4f3aa993cc57516e$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $4f3aa993cc57516e$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $4f3aa993cc57516e$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $4f3aa993cc57516e$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $4f3aa993cc57516e$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $4f3aa993cc57516e$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $4f3aa993cc57516e$var$Jf(w);
                                x = $4f3aa993cc57516e$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $4f3aa993cc57516e$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $4f3aa993cc57516e$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $4f3aa993cc57516e$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $4f3aa993cc57516e$var$Je;
                else if ($4f3aa993cc57516e$var$Ae(h)) {
                    if ($4f3aa993cc57516e$var$Ke) ca = $4f3aa993cc57516e$var$Te;
                    else {
                        ca = $4f3aa993cc57516e$var$Re;
                        var R = $4f3aa993cc57516e$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $4f3aa993cc57516e$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $4f3aa993cc57516e$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $4f3aa993cc57516e$var$bb(h, "number", h.value);
            }
            R = d ? $4f3aa993cc57516e$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($4f3aa993cc57516e$var$Ae(R) || "true" === R.contentEditable) $4f3aa993cc57516e$var$df = R, $4f3aa993cc57516e$var$ef = d, $4f3aa993cc57516e$var$ff = null;
                    break;
                case "focusout":
                    $4f3aa993cc57516e$var$ff = $4f3aa993cc57516e$var$ef = $4f3aa993cc57516e$var$df = null;
                    break;
                case "mousedown":
                    $4f3aa993cc57516e$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4f3aa993cc57516e$var$gf = !1;
                    $4f3aa993cc57516e$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($4f3aa993cc57516e$var$cf) break;
                case "keydown":
                case "keyup":
                    $4f3aa993cc57516e$var$hf(g, c, e);
            }
            var sa;
            if ($4f3aa993cc57516e$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $4f3aa993cc57516e$var$we ? $4f3aa993cc57516e$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($4f3aa993cc57516e$var$re && "ko" !== c.locale && ($4f3aa993cc57516e$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $4f3aa993cc57516e$var$we && (sa = $4f3aa993cc57516e$var$Bd()) : ($4f3aa993cc57516e$var$yd = e, $4f3aa993cc57516e$var$zd = "value" in $4f3aa993cc57516e$var$yd ? $4f3aa993cc57516e$var$yd.value : $4f3aa993cc57516e$var$yd.textContent, $4f3aa993cc57516e$var$we = !0)), R = $4f3aa993cc57516e$var$Ce(d, V), 0 < R.length && (V = new $4f3aa993cc57516e$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $4f3aa993cc57516e$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $4f3aa993cc57516e$var$qe ? $4f3aa993cc57516e$var$xe(a, c) : $4f3aa993cc57516e$var$ye(a, c)) d = $4f3aa993cc57516e$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $4f3aa993cc57516e$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $4f3aa993cc57516e$var$Ge(g, b);
    });
}
function $4f3aa993cc57516e$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4f3aa993cc57516e$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4f3aa993cc57516e$var$Kb(a, c), null != f && d.unshift($4f3aa993cc57516e$var$Hf(a, f, e)), f = $4f3aa993cc57516e$var$Kb(a, b), null != f && d.push($4f3aa993cc57516e$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4f3aa993cc57516e$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4f3aa993cc57516e$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4f3aa993cc57516e$var$Kb(c, f), null != k && g.unshift($4f3aa993cc57516e$var$Hf(c, k, h))) : e || (k = $4f3aa993cc57516e$var$Kb(c, f), null != k && g.push($4f3aa993cc57516e$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4f3aa993cc57516e$var$Lf = /\r\n?/g, $4f3aa993cc57516e$var$Mf = /\u0000|\uFFFD/g;
function $4f3aa993cc57516e$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4f3aa993cc57516e$var$Lf, "\n").replace($4f3aa993cc57516e$var$Mf, "");
}
function $4f3aa993cc57516e$var$Of(a, b, c) {
    b = $4f3aa993cc57516e$var$Nf(b);
    if ($4f3aa993cc57516e$var$Nf(a) !== b && c) throw Error($4f3aa993cc57516e$var$p(425));
}
function $4f3aa993cc57516e$var$Pf() {}
var $4f3aa993cc57516e$var$Qf = null, $4f3aa993cc57516e$var$Rf = null;
function $4f3aa993cc57516e$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4f3aa993cc57516e$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $4f3aa993cc57516e$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4f3aa993cc57516e$var$Vf = "function" === typeof Promise ? Promise : void 0, $4f3aa993cc57516e$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4f3aa993cc57516e$var$Vf ? function(a) {
    return $4f3aa993cc57516e$var$Vf.resolve(null).then(a).catch($4f3aa993cc57516e$var$Wf);
} : $4f3aa993cc57516e$var$Tf;
function $4f3aa993cc57516e$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4f3aa993cc57516e$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4f3aa993cc57516e$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4f3aa993cc57516e$var$pd(b);
}
function $4f3aa993cc57516e$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4f3aa993cc57516e$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4f3aa993cc57516e$var$ag = Math.random().toString(36).slice(2), $4f3aa993cc57516e$var$bg = "__reactFiber$" + $4f3aa993cc57516e$var$ag, $4f3aa993cc57516e$var$cg = "__reactProps$" + $4f3aa993cc57516e$var$ag, $4f3aa993cc57516e$var$If = "__reactContainer$" + $4f3aa993cc57516e$var$ag, $4f3aa993cc57516e$var$Cf = "__reactEvents$" + $4f3aa993cc57516e$var$ag, $4f3aa993cc57516e$var$dg = "__reactListeners$" + $4f3aa993cc57516e$var$ag, $4f3aa993cc57516e$var$eg = "__reactHandles$" + $4f3aa993cc57516e$var$ag;
function $4f3aa993cc57516e$var$jd(a) {
    var b = a[$4f3aa993cc57516e$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4f3aa993cc57516e$var$If] || c[$4f3aa993cc57516e$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4f3aa993cc57516e$var$$f(a); null !== a;){
                if (c = a[$4f3aa993cc57516e$var$bg]) return c;
                a = $4f3aa993cc57516e$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4f3aa993cc57516e$var$Cb(a) {
    a = a[$4f3aa993cc57516e$var$bg] || a[$4f3aa993cc57516e$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4f3aa993cc57516e$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4f3aa993cc57516e$var$p(33));
}
function $4f3aa993cc57516e$var$Db(a) {
    return a[$4f3aa993cc57516e$var$cg] || null;
}
var $4f3aa993cc57516e$var$fg = [], $4f3aa993cc57516e$var$gg = -1;
function $4f3aa993cc57516e$var$hg(a) {
    return {
        current: a
    };
}
function $4f3aa993cc57516e$var$G(a) {
    0 > $4f3aa993cc57516e$var$gg || (a.current = $4f3aa993cc57516e$var$fg[$4f3aa993cc57516e$var$gg], $4f3aa993cc57516e$var$fg[$4f3aa993cc57516e$var$gg] = null, $4f3aa993cc57516e$var$gg--);
}
function $4f3aa993cc57516e$var$H(a, b) {
    $4f3aa993cc57516e$var$gg++;
    $4f3aa993cc57516e$var$fg[$4f3aa993cc57516e$var$gg] = a.current;
    a.current = b;
}
var $4f3aa993cc57516e$var$ig = {}, $4f3aa993cc57516e$var$I = $4f3aa993cc57516e$var$hg($4f3aa993cc57516e$var$ig), $4f3aa993cc57516e$var$jg = $4f3aa993cc57516e$var$hg(!1), $4f3aa993cc57516e$var$kg = $4f3aa993cc57516e$var$ig;
function $4f3aa993cc57516e$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4f3aa993cc57516e$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4f3aa993cc57516e$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4f3aa993cc57516e$var$ng() {
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg);
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$I);
}
function $4f3aa993cc57516e$var$og(a, b, c) {
    if ($4f3aa993cc57516e$var$I.current !== $4f3aa993cc57516e$var$ig) throw Error($4f3aa993cc57516e$var$p(168));
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$I, b);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$jg, c);
}
function $4f3aa993cc57516e$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4f3aa993cc57516e$var$p(108, $4f3aa993cc57516e$var$Ra(a) || "Unknown", e));
    return $4f3aa993cc57516e$var$u({}, c, d);
}
function $4f3aa993cc57516e$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4f3aa993cc57516e$var$ig;
    $4f3aa993cc57516e$var$kg = $4f3aa993cc57516e$var$I.current;
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$I, a);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$jg, $4f3aa993cc57516e$var$jg.current);
    return !0;
}
function $4f3aa993cc57516e$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4f3aa993cc57516e$var$p(169));
    c ? (a = $4f3aa993cc57516e$var$pg(a, b, $4f3aa993cc57516e$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg), $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$I), $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$I, a)) : $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$jg, c);
}
var $4f3aa993cc57516e$var$sg = null, $4f3aa993cc57516e$var$tg = !1, $4f3aa993cc57516e$var$ug = !1;
function $4f3aa993cc57516e$var$vg(a) {
    null === $4f3aa993cc57516e$var$sg ? $4f3aa993cc57516e$var$sg = [
        a
    ] : $4f3aa993cc57516e$var$sg.push(a);
}
function $4f3aa993cc57516e$var$wg(a) {
    $4f3aa993cc57516e$var$tg = !0;
    $4f3aa993cc57516e$var$vg(a);
}
function $4f3aa993cc57516e$var$xg() {
    if (!$4f3aa993cc57516e$var$ug && null !== $4f3aa993cc57516e$var$sg) {
        $4f3aa993cc57516e$var$ug = !0;
        var a = 0, b = $4f3aa993cc57516e$var$E;
        try {
            var c = $4f3aa993cc57516e$var$sg;
            for($4f3aa993cc57516e$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4f3aa993cc57516e$var$sg = null;
            $4f3aa993cc57516e$var$tg = !1;
        } catch (e) {
            throw null !== $4f3aa993cc57516e$var$sg && ($4f3aa993cc57516e$var$sg = $4f3aa993cc57516e$var$sg.slice(a + 1)), $4f3aa993cc57516e$var$ac($4f3aa993cc57516e$var$fc, $4f3aa993cc57516e$var$xg), e;
        } finally{
            $4f3aa993cc57516e$var$E = b, $4f3aa993cc57516e$var$ug = !1;
        }
    }
    return null;
}
var $4f3aa993cc57516e$var$yg = [], $4f3aa993cc57516e$var$zg = 0, $4f3aa993cc57516e$var$Ag = null, $4f3aa993cc57516e$var$Bg = 0, $4f3aa993cc57516e$var$Cg = [], $4f3aa993cc57516e$var$Dg = 0, $4f3aa993cc57516e$var$Eg = null, $4f3aa993cc57516e$var$Fg = 1, $4f3aa993cc57516e$var$Gg = "";
function $4f3aa993cc57516e$var$Hg(a, b) {
    $4f3aa993cc57516e$var$yg[$4f3aa993cc57516e$var$zg++] = $4f3aa993cc57516e$var$Bg;
    $4f3aa993cc57516e$var$yg[$4f3aa993cc57516e$var$zg++] = $4f3aa993cc57516e$var$Ag;
    $4f3aa993cc57516e$var$Ag = a;
    $4f3aa993cc57516e$var$Bg = b;
}
function $4f3aa993cc57516e$var$Ig(a, b, c) {
    $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Fg;
    $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Gg;
    $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Eg;
    $4f3aa993cc57516e$var$Eg = a;
    var d = $4f3aa993cc57516e$var$Fg;
    a = $4f3aa993cc57516e$var$Gg;
    var e = 32 - $4f3aa993cc57516e$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4f3aa993cc57516e$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4f3aa993cc57516e$var$Fg = 1 << 32 - $4f3aa993cc57516e$var$Ac(b) + e | c << e | d;
        $4f3aa993cc57516e$var$Gg = f + a;
    } else $4f3aa993cc57516e$var$Fg = 1 << f | c << e | d, $4f3aa993cc57516e$var$Gg = a;
}
function $4f3aa993cc57516e$var$Jg(a) {
    null !== a.return && ($4f3aa993cc57516e$var$Hg(a, 1), $4f3aa993cc57516e$var$Ig(a, 1, 0));
}
function $4f3aa993cc57516e$var$Kg(a) {
    for(; a === $4f3aa993cc57516e$var$Ag;)$4f3aa993cc57516e$var$Ag = $4f3aa993cc57516e$var$yg[--$4f3aa993cc57516e$var$zg], $4f3aa993cc57516e$var$yg[$4f3aa993cc57516e$var$zg] = null, $4f3aa993cc57516e$var$Bg = $4f3aa993cc57516e$var$yg[--$4f3aa993cc57516e$var$zg], $4f3aa993cc57516e$var$yg[$4f3aa993cc57516e$var$zg] = null;
    for(; a === $4f3aa993cc57516e$var$Eg;)$4f3aa993cc57516e$var$Eg = $4f3aa993cc57516e$var$Cg[--$4f3aa993cc57516e$var$Dg], $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg] = null, $4f3aa993cc57516e$var$Gg = $4f3aa993cc57516e$var$Cg[--$4f3aa993cc57516e$var$Dg], $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg] = null, $4f3aa993cc57516e$var$Fg = $4f3aa993cc57516e$var$Cg[--$4f3aa993cc57516e$var$Dg], $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg] = null;
}
var $4f3aa993cc57516e$var$Lg = null, $4f3aa993cc57516e$var$Mg = null, $4f3aa993cc57516e$var$J = !1, $4f3aa993cc57516e$var$Ng = null;
function $4f3aa993cc57516e$var$Og(a, b) {
    var c = $4f3aa993cc57516e$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4f3aa993cc57516e$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4f3aa993cc57516e$var$Lg = a, $4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4f3aa993cc57516e$var$Lg = a, $4f3aa993cc57516e$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4f3aa993cc57516e$var$Eg ? {
                id: $4f3aa993cc57516e$var$Fg,
                overflow: $4f3aa993cc57516e$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4f3aa993cc57516e$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4f3aa993cc57516e$var$Lg = a, $4f3aa993cc57516e$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4f3aa993cc57516e$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4f3aa993cc57516e$var$Sg(a) {
    if ($4f3aa993cc57516e$var$J) {
        var b = $4f3aa993cc57516e$var$Mg;
        if (b) {
            var c = b;
            if (!$4f3aa993cc57516e$var$Qg(a, b)) {
                if ($4f3aa993cc57516e$var$Rg(a)) throw Error($4f3aa993cc57516e$var$p(418));
                b = $4f3aa993cc57516e$var$Zf(c.nextSibling);
                var d = $4f3aa993cc57516e$var$Lg;
                b && $4f3aa993cc57516e$var$Qg(a, b) ? $4f3aa993cc57516e$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $4f3aa993cc57516e$var$J = !1, $4f3aa993cc57516e$var$Lg = a);
            }
        } else {
            if ($4f3aa993cc57516e$var$Rg(a)) throw Error($4f3aa993cc57516e$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4f3aa993cc57516e$var$J = !1;
            $4f3aa993cc57516e$var$Lg = a;
        }
    }
}
function $4f3aa993cc57516e$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4f3aa993cc57516e$var$Lg = a;
}
function $4f3aa993cc57516e$var$Ug(a) {
    if (a !== $4f3aa993cc57516e$var$Lg) return !1;
    if (!$4f3aa993cc57516e$var$J) return $4f3aa993cc57516e$var$Tg(a), $4f3aa993cc57516e$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4f3aa993cc57516e$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $4f3aa993cc57516e$var$Mg)) {
        if ($4f3aa993cc57516e$var$Rg(a)) throw $4f3aa993cc57516e$var$Vg(), Error($4f3aa993cc57516e$var$p(418));
        for(; b;)$4f3aa993cc57516e$var$Og(a, b), b = $4f3aa993cc57516e$var$Zf(b.nextSibling);
    }
    $4f3aa993cc57516e$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4f3aa993cc57516e$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4f3aa993cc57516e$var$Mg = null;
        }
    } else $4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Lg ? $4f3aa993cc57516e$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4f3aa993cc57516e$var$Vg() {
    for(var a = $4f3aa993cc57516e$var$Mg; a;)a = $4f3aa993cc57516e$var$Zf(a.nextSibling);
}
function $4f3aa993cc57516e$var$Wg() {
    $4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Lg = null;
    $4f3aa993cc57516e$var$J = !1;
}
function $4f3aa993cc57516e$var$Xg(a) {
    null === $4f3aa993cc57516e$var$Ng ? $4f3aa993cc57516e$var$Ng = [
        a
    ] : $4f3aa993cc57516e$var$Ng.push(a);
}
var $4f3aa993cc57516e$var$Yg = $4f3aa993cc57516e$var$va.ReactCurrentBatchConfig;
function $4f3aa993cc57516e$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4f3aa993cc57516e$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4f3aa993cc57516e$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4f3aa993cc57516e$var$p(284));
        if (!c._owner) throw Error($4f3aa993cc57516e$var$p(290, a));
    }
    return a;
}
function $4f3aa993cc57516e$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4f3aa993cc57516e$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4f3aa993cc57516e$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $4f3aa993cc57516e$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4f3aa993cc57516e$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4f3aa993cc57516e$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4f3aa993cc57516e$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4f3aa993cc57516e$var$Ha && $4f3aa993cc57516e$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $4f3aa993cc57516e$var$Zg(a, b, c), d.return = a, d;
        d = $4f3aa993cc57516e$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4f3aa993cc57516e$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4f3aa993cc57516e$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4f3aa993cc57516e$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4f3aa993cc57516e$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4f3aa993cc57516e$var$wa:
                    return c = $4f3aa993cc57516e$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $4f3aa993cc57516e$var$Zg(a, null, b), c.return = a, c;
                case $4f3aa993cc57516e$var$xa:
                    return b = $4f3aa993cc57516e$var$fh(b, a.mode, c), b.return = a, b;
                case $4f3aa993cc57516e$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4f3aa993cc57516e$var$db(b) || $4f3aa993cc57516e$var$Ka(b)) return b = $4f3aa993cc57516e$var$gh(b, a.mode, c, null), b.return = a, b;
            $4f3aa993cc57516e$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4f3aa993cc57516e$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4f3aa993cc57516e$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4f3aa993cc57516e$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4f3aa993cc57516e$var$db(c) || $4f3aa993cc57516e$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $4f3aa993cc57516e$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4f3aa993cc57516e$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4f3aa993cc57516e$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4f3aa993cc57516e$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($4f3aa993cc57516e$var$db(d) || $4f3aa993cc57516e$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $4f3aa993cc57516e$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $4f3aa993cc57516e$var$Ka(h);
        if ("function" !== typeof l) throw Error($4f3aa993cc57516e$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4f3aa993cc57516e$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4f3aa993cc57516e$var$J && $4f3aa993cc57516e$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4f3aa993cc57516e$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4f3aa993cc57516e$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4f3aa993cc57516e$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4f3aa993cc57516e$var$Ha && $4f3aa993cc57516e$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4f3aa993cc57516e$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4f3aa993cc57516e$var$ya ? (d = $4f3aa993cc57516e$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4f3aa993cc57516e$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $4f3aa993cc57516e$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4f3aa993cc57516e$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4f3aa993cc57516e$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4f3aa993cc57516e$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($4f3aa993cc57516e$var$db(f)) return m(a, d, f, h);
            if ($4f3aa993cc57516e$var$Ka(f)) return w(a, d, f, h);
            $4f3aa993cc57516e$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4f3aa993cc57516e$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $4f3aa993cc57516e$var$hh = $4f3aa993cc57516e$var$bh(!0), $4f3aa993cc57516e$var$ih = $4f3aa993cc57516e$var$bh(!1), $4f3aa993cc57516e$var$jh = $4f3aa993cc57516e$var$hg(null), $4f3aa993cc57516e$var$kh = null, $4f3aa993cc57516e$var$lh = null, $4f3aa993cc57516e$var$mh = null;
function $4f3aa993cc57516e$var$nh() {
    $4f3aa993cc57516e$var$mh = $4f3aa993cc57516e$var$lh = $4f3aa993cc57516e$var$kh = null;
}
function $4f3aa993cc57516e$var$oh(a) {
    var b = $4f3aa993cc57516e$var$jh.current;
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jh);
    a._currentValue = b;
}
function $4f3aa993cc57516e$var$ph(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4f3aa993cc57516e$var$qh(a, b) {
    $4f3aa993cc57516e$var$kh = a;
    $4f3aa993cc57516e$var$mh = $4f3aa993cc57516e$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4f3aa993cc57516e$var$rh = !0), a.firstContext = null);
}
function $4f3aa993cc57516e$var$sh(a) {
    var b = a._currentValue;
    if ($4f3aa993cc57516e$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4f3aa993cc57516e$var$lh) {
            if (null === $4f3aa993cc57516e$var$kh) throw Error($4f3aa993cc57516e$var$p(308));
            $4f3aa993cc57516e$var$lh = a;
            $4f3aa993cc57516e$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4f3aa993cc57516e$var$lh = $4f3aa993cc57516e$var$lh.next = a;
    }
    return b;
}
var $4f3aa993cc57516e$var$th = null;
function $4f3aa993cc57516e$var$uh(a) {
    null === $4f3aa993cc57516e$var$th ? $4f3aa993cc57516e$var$th = [
        a
    ] : $4f3aa993cc57516e$var$th.push(a);
}
function $4f3aa993cc57516e$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4f3aa993cc57516e$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4f3aa993cc57516e$var$wh(a, d);
}
function $4f3aa993cc57516e$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4f3aa993cc57516e$var$xh = !1;
function $4f3aa993cc57516e$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4f3aa993cc57516e$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4f3aa993cc57516e$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4f3aa993cc57516e$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4f3aa993cc57516e$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4f3aa993cc57516e$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4f3aa993cc57516e$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4f3aa993cc57516e$var$wh(a, c);
}
function $4f3aa993cc57516e$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4f3aa993cc57516e$var$Oc(a, c);
    }
}
function $4f3aa993cc57516e$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4f3aa993cc57516e$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $4f3aa993cc57516e$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $4f3aa993cc57516e$var$u({}, q, r);
                            break a;
                        case 2:
                            $4f3aa993cc57516e$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4f3aa993cc57516e$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4f3aa993cc57516e$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4f3aa993cc57516e$var$p(191, e));
            e.call(d);
        }
    }
}
var $4f3aa993cc57516e$var$Hh = {}, $4f3aa993cc57516e$var$Ih = $4f3aa993cc57516e$var$hg($4f3aa993cc57516e$var$Hh), $4f3aa993cc57516e$var$Jh = $4f3aa993cc57516e$var$hg($4f3aa993cc57516e$var$Hh), $4f3aa993cc57516e$var$Kh = $4f3aa993cc57516e$var$hg($4f3aa993cc57516e$var$Hh);
function $4f3aa993cc57516e$var$Lh(a) {
    if (a === $4f3aa993cc57516e$var$Hh) throw Error($4f3aa993cc57516e$var$p(174));
    return a;
}
function $4f3aa993cc57516e$var$Mh(a, b) {
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Kh, b);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Jh, a);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ih, $4f3aa993cc57516e$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4f3aa993cc57516e$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4f3aa993cc57516e$var$kb(b, a);
    }
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Ih);
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ih, b);
}
function $4f3aa993cc57516e$var$Nh() {
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Ih);
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Jh);
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Kh);
}
function $4f3aa993cc57516e$var$Oh(a) {
    $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Kh.current);
    var b = $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Ih.current);
    var c = $4f3aa993cc57516e$var$kb(b, a.type);
    b !== c && ($4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Jh, a), $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ih, c));
}
function $4f3aa993cc57516e$var$Ph(a) {
    $4f3aa993cc57516e$var$Jh.current === a && ($4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Ih), $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Jh));
}
var $4f3aa993cc57516e$var$L = $4f3aa993cc57516e$var$hg(0);
function $4f3aa993cc57516e$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4f3aa993cc57516e$var$Rh = [];
function $4f3aa993cc57516e$var$Sh() {
    for(var a = 0; a < $4f3aa993cc57516e$var$Rh.length; a++)$4f3aa993cc57516e$var$Rh[a]._workInProgressVersionPrimary = null;
    $4f3aa993cc57516e$var$Rh.length = 0;
}
var $4f3aa993cc57516e$var$Th = $4f3aa993cc57516e$var$va.ReactCurrentDispatcher, $4f3aa993cc57516e$var$Uh = $4f3aa993cc57516e$var$va.ReactCurrentBatchConfig, $4f3aa993cc57516e$var$Vh = 0, $4f3aa993cc57516e$var$M = null, $4f3aa993cc57516e$var$N = null, $4f3aa993cc57516e$var$O = null, $4f3aa993cc57516e$var$Wh = !1, $4f3aa993cc57516e$var$Xh = !1, $4f3aa993cc57516e$var$Yh = 0, $4f3aa993cc57516e$var$Zh = 0;
function $4f3aa993cc57516e$var$P() {
    throw Error($4f3aa993cc57516e$var$p(321));
}
function $4f3aa993cc57516e$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4f3aa993cc57516e$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $4f3aa993cc57516e$var$ai(a, b, c, d, e, f) {
    $4f3aa993cc57516e$var$Vh = f;
    $4f3aa993cc57516e$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4f3aa993cc57516e$var$Th.current = null === a || null === a.memoizedState ? $4f3aa993cc57516e$var$bi : $4f3aa993cc57516e$var$ci;
    a = c(d, e);
    if ($4f3aa993cc57516e$var$Xh) {
        f = 0;
        do {
            $4f3aa993cc57516e$var$Xh = !1;
            $4f3aa993cc57516e$var$Yh = 0;
            if (25 <= f) throw Error($4f3aa993cc57516e$var$p(301));
            f += 1;
            $4f3aa993cc57516e$var$O = $4f3aa993cc57516e$var$N = null;
            b.updateQueue = null;
            $4f3aa993cc57516e$var$Th.current = $4f3aa993cc57516e$var$di;
            a = c(d, e);
        }while ($4f3aa993cc57516e$var$Xh);
    }
    $4f3aa993cc57516e$var$Th.current = $4f3aa993cc57516e$var$ei;
    b = null !== $4f3aa993cc57516e$var$N && null !== $4f3aa993cc57516e$var$N.next;
    $4f3aa993cc57516e$var$Vh = 0;
    $4f3aa993cc57516e$var$O = $4f3aa993cc57516e$var$N = $4f3aa993cc57516e$var$M = null;
    $4f3aa993cc57516e$var$Wh = !1;
    if (b) throw Error($4f3aa993cc57516e$var$p(300));
    return a;
}
function $4f3aa993cc57516e$var$fi() {
    var a = 0 !== $4f3aa993cc57516e$var$Yh;
    $4f3aa993cc57516e$var$Yh = 0;
    return a;
}
function $4f3aa993cc57516e$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4f3aa993cc57516e$var$O ? $4f3aa993cc57516e$var$M.memoizedState = $4f3aa993cc57516e$var$O = a : $4f3aa993cc57516e$var$O = $4f3aa993cc57516e$var$O.next = a;
    return $4f3aa993cc57516e$var$O;
}
function $4f3aa993cc57516e$var$hi() {
    if (null === $4f3aa993cc57516e$var$N) {
        var a = $4f3aa993cc57516e$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4f3aa993cc57516e$var$N.next;
    var b = null === $4f3aa993cc57516e$var$O ? $4f3aa993cc57516e$var$M.memoizedState : $4f3aa993cc57516e$var$O.next;
    if (null !== b) $4f3aa993cc57516e$var$O = b, $4f3aa993cc57516e$var$N = a;
    else {
        if (null === a) throw Error($4f3aa993cc57516e$var$p(310));
        $4f3aa993cc57516e$var$N = a;
        a = {
            memoizedState: $4f3aa993cc57516e$var$N.memoizedState,
            baseState: $4f3aa993cc57516e$var$N.baseState,
            baseQueue: $4f3aa993cc57516e$var$N.baseQueue,
            queue: $4f3aa993cc57516e$var$N.queue,
            next: null
        };
        null === $4f3aa993cc57516e$var$O ? $4f3aa993cc57516e$var$M.memoizedState = $4f3aa993cc57516e$var$O = a : $4f3aa993cc57516e$var$O = $4f3aa993cc57516e$var$O.next = a;
    }
    return $4f3aa993cc57516e$var$O;
}
function $4f3aa993cc57516e$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4f3aa993cc57516e$var$ji(a) {
    var b = $4f3aa993cc57516e$var$hi(), c = b.queue;
    if (null === c) throw Error($4f3aa993cc57516e$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4f3aa993cc57516e$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($4f3aa993cc57516e$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4f3aa993cc57516e$var$M.lanes |= n;
                $4f3aa993cc57516e$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4f3aa993cc57516e$var$Ve(d, b.memoizedState) || ($4f3aa993cc57516e$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4f3aa993cc57516e$var$M.lanes |= f, $4f3aa993cc57516e$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4f3aa993cc57516e$var$ki(a) {
    var b = $4f3aa993cc57516e$var$hi(), c = b.queue;
    if (null === c) throw Error($4f3aa993cc57516e$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4f3aa993cc57516e$var$Ve(f, b.memoizedState) || ($4f3aa993cc57516e$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4f3aa993cc57516e$var$li() {}
function $4f3aa993cc57516e$var$mi(a, b) {
    var c = $4f3aa993cc57516e$var$M, d = $4f3aa993cc57516e$var$hi(), e = b(), f = !$4f3aa993cc57516e$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $4f3aa993cc57516e$var$rh = !0);
    d = d.queue;
    $4f3aa993cc57516e$var$ni($4f3aa993cc57516e$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4f3aa993cc57516e$var$O && $4f3aa993cc57516e$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4f3aa993cc57516e$var$pi(9, $4f3aa993cc57516e$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $4f3aa993cc57516e$var$Q) throw Error($4f3aa993cc57516e$var$p(349));
        0 !== ($4f3aa993cc57516e$var$Vh & 30) || $4f3aa993cc57516e$var$ri(c, b, e);
    }
    return e;
}
function $4f3aa993cc57516e$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4f3aa993cc57516e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4f3aa993cc57516e$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4f3aa993cc57516e$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4f3aa993cc57516e$var$si(b) && $4f3aa993cc57516e$var$ti(a);
}
function $4f3aa993cc57516e$var$oi(a, b, c) {
    return c(function() {
        $4f3aa993cc57516e$var$si(b) && $4f3aa993cc57516e$var$ti(a);
    });
}
function $4f3aa993cc57516e$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4f3aa993cc57516e$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $4f3aa993cc57516e$var$ti(a) {
    var b = $4f3aa993cc57516e$var$wh(a, 1);
    null !== b && $4f3aa993cc57516e$var$ui(b, a, 1, -1);
}
function $4f3aa993cc57516e$var$vi(a) {
    var b = $4f3aa993cc57516e$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4f3aa993cc57516e$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4f3aa993cc57516e$var$wi.bind(null, $4f3aa993cc57516e$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4f3aa993cc57516e$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4f3aa993cc57516e$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4f3aa993cc57516e$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4f3aa993cc57516e$var$xi() {
    return $4f3aa993cc57516e$var$hi().memoizedState;
}
function $4f3aa993cc57516e$var$Ai(a, b, c, d) {
    var e = $4f3aa993cc57516e$var$gi();
    $4f3aa993cc57516e$var$M.flags |= a;
    e.memoizedState = $4f3aa993cc57516e$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4f3aa993cc57516e$var$Bi(a, b, c, d) {
    var e = $4f3aa993cc57516e$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4f3aa993cc57516e$var$N) {
        var g = $4f3aa993cc57516e$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4f3aa993cc57516e$var$$h(d, g.deps)) {
            e.memoizedState = $4f3aa993cc57516e$var$pi(b, c, f, d);
            return;
        }
    }
    $4f3aa993cc57516e$var$M.flags |= a;
    e.memoizedState = $4f3aa993cc57516e$var$pi(1 | b, c, f, d);
}
function $4f3aa993cc57516e$var$Ci(a, b) {
    return $4f3aa993cc57516e$var$Ai(8390656, 8, a, b);
}
function $4f3aa993cc57516e$var$ni(a, b) {
    return $4f3aa993cc57516e$var$Bi(2048, 8, a, b);
}
function $4f3aa993cc57516e$var$Di(a, b) {
    return $4f3aa993cc57516e$var$Bi(4, 2, a, b);
}
function $4f3aa993cc57516e$var$Ei(a, b) {
    return $4f3aa993cc57516e$var$Bi(4, 4, a, b);
}
function $4f3aa993cc57516e$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4f3aa993cc57516e$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4f3aa993cc57516e$var$Bi(4, 4, $4f3aa993cc57516e$var$Fi.bind(null, b, a), c);
}
function $4f3aa993cc57516e$var$Hi() {}
function $4f3aa993cc57516e$var$Ii(a, b) {
    var c = $4f3aa993cc57516e$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4f3aa993cc57516e$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4f3aa993cc57516e$var$Ji(a, b) {
    var c = $4f3aa993cc57516e$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4f3aa993cc57516e$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4f3aa993cc57516e$var$Ki(a, b, c) {
    if (0 === ($4f3aa993cc57516e$var$Vh & 21)) return a.baseState && (a.baseState = !1, $4f3aa993cc57516e$var$rh = !0), a.memoizedState = c;
    $4f3aa993cc57516e$var$Ve(c, b) || (c = $4f3aa993cc57516e$var$Kc(), $4f3aa993cc57516e$var$M.lanes |= c, $4f3aa993cc57516e$var$Fh |= c, a.baseState = !0);
    return b;
}
function $4f3aa993cc57516e$var$Li(a, b) {
    var c = $4f3aa993cc57516e$var$E;
    $4f3aa993cc57516e$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4f3aa993cc57516e$var$Uh.transition;
    $4f3aa993cc57516e$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4f3aa993cc57516e$var$E = c, $4f3aa993cc57516e$var$Uh.transition = d;
    }
}
function $4f3aa993cc57516e$var$Mi() {
    return $4f3aa993cc57516e$var$hi().memoizedState;
}
function $4f3aa993cc57516e$var$Ni(a, b, c) {
    var d = $4f3aa993cc57516e$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4f3aa993cc57516e$var$Pi(a)) $4f3aa993cc57516e$var$Qi(b, c);
    else if (c = $4f3aa993cc57516e$var$vh(a, b, c, d), null !== c) {
        var e = $4f3aa993cc57516e$var$Ri();
        $4f3aa993cc57516e$var$ui(c, a, d, e);
        $4f3aa993cc57516e$var$Si(c, b, d);
    }
    $4f3aa993cc57516e$var$yc(a, d);
}
function $4f3aa993cc57516e$var$wi(a, b, c) {
    var d = $4f3aa993cc57516e$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4f3aa993cc57516e$var$Pi(a)) $4f3aa993cc57516e$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4f3aa993cc57516e$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4f3aa993cc57516e$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4f3aa993cc57516e$var$vh(a, b, e, d);
        null !== c && (e = $4f3aa993cc57516e$var$Ri(), $4f3aa993cc57516e$var$ui(c, a, d, e), $4f3aa993cc57516e$var$Si(c, b, d));
    }
    $4f3aa993cc57516e$var$yc(a, d);
}
function $4f3aa993cc57516e$var$Pi(a) {
    var b = a.alternate;
    return a === $4f3aa993cc57516e$var$M || null !== b && b === $4f3aa993cc57516e$var$M;
}
function $4f3aa993cc57516e$var$Qi(a, b) {
    $4f3aa993cc57516e$var$Xh = $4f3aa993cc57516e$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4f3aa993cc57516e$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4f3aa993cc57516e$var$Oc(a, c);
    }
}
var $4f3aa993cc57516e$var$ei = {
    readContext: $4f3aa993cc57516e$var$sh,
    useCallback: $4f3aa993cc57516e$var$P,
    useContext: $4f3aa993cc57516e$var$P,
    useEffect: $4f3aa993cc57516e$var$P,
    useImperativeHandle: $4f3aa993cc57516e$var$P,
    useInsertionEffect: $4f3aa993cc57516e$var$P,
    useLayoutEffect: $4f3aa993cc57516e$var$P,
    useMemo: $4f3aa993cc57516e$var$P,
    useReducer: $4f3aa993cc57516e$var$P,
    useRef: $4f3aa993cc57516e$var$P,
    useState: $4f3aa993cc57516e$var$P,
    useDebugValue: $4f3aa993cc57516e$var$P,
    useDeferredValue: $4f3aa993cc57516e$var$P,
    useTransition: $4f3aa993cc57516e$var$P,
    useMutableSource: $4f3aa993cc57516e$var$P,
    useSyncExternalStore: $4f3aa993cc57516e$var$P,
    useId: $4f3aa993cc57516e$var$P,
    unstable_isNewReconciler: !1
}, $4f3aa993cc57516e$var$bi = {
    readContext: $4f3aa993cc57516e$var$sh,
    useCallback: function(a, b) {
        $4f3aa993cc57516e$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4f3aa993cc57516e$var$sh,
    useEffect: $4f3aa993cc57516e$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4f3aa993cc57516e$var$Ai(4194308, 4, $4f3aa993cc57516e$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4f3aa993cc57516e$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4f3aa993cc57516e$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4f3aa993cc57516e$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4f3aa993cc57516e$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4f3aa993cc57516e$var$Ni.bind(null, $4f3aa993cc57516e$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4f3aa993cc57516e$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4f3aa993cc57516e$var$vi,
    useDebugValue: $4f3aa993cc57516e$var$Hi,
    useDeferredValue: function(a) {
        return $4f3aa993cc57516e$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $4f3aa993cc57516e$var$vi(!1), b = a[0];
        a = $4f3aa993cc57516e$var$Li.bind(null, a[1]);
        $4f3aa993cc57516e$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4f3aa993cc57516e$var$M, e = $4f3aa993cc57516e$var$gi();
        if ($4f3aa993cc57516e$var$J) {
            if (void 0 === c) throw Error($4f3aa993cc57516e$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4f3aa993cc57516e$var$Q) throw Error($4f3aa993cc57516e$var$p(349));
            0 !== ($4f3aa993cc57516e$var$Vh & 30) || $4f3aa993cc57516e$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4f3aa993cc57516e$var$Ci($4f3aa993cc57516e$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4f3aa993cc57516e$var$pi(9, $4f3aa993cc57516e$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4f3aa993cc57516e$var$gi(), b = $4f3aa993cc57516e$var$Q.identifierPrefix;
        if ($4f3aa993cc57516e$var$J) {
            var c = $4f3aa993cc57516e$var$Gg;
            var d = $4f3aa993cc57516e$var$Fg;
            c = (d & ~(1 << 32 - $4f3aa993cc57516e$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4f3aa993cc57516e$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4f3aa993cc57516e$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4f3aa993cc57516e$var$ci = {
    readContext: $4f3aa993cc57516e$var$sh,
    useCallback: $4f3aa993cc57516e$var$Ii,
    useContext: $4f3aa993cc57516e$var$sh,
    useEffect: $4f3aa993cc57516e$var$ni,
    useImperativeHandle: $4f3aa993cc57516e$var$Gi,
    useInsertionEffect: $4f3aa993cc57516e$var$Di,
    useLayoutEffect: $4f3aa993cc57516e$var$Ei,
    useMemo: $4f3aa993cc57516e$var$Ji,
    useReducer: $4f3aa993cc57516e$var$ji,
    useRef: $4f3aa993cc57516e$var$xi,
    useState: function() {
        return $4f3aa993cc57516e$var$ji($4f3aa993cc57516e$var$ii);
    },
    useDebugValue: $4f3aa993cc57516e$var$Hi,
    useDeferredValue: function(a) {
        var b = $4f3aa993cc57516e$var$hi();
        return $4f3aa993cc57516e$var$Ki(b, $4f3aa993cc57516e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4f3aa993cc57516e$var$ji($4f3aa993cc57516e$var$ii)[0], b = $4f3aa993cc57516e$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4f3aa993cc57516e$var$li,
    useSyncExternalStore: $4f3aa993cc57516e$var$mi,
    useId: $4f3aa993cc57516e$var$Mi,
    unstable_isNewReconciler: !1
}, $4f3aa993cc57516e$var$di = {
    readContext: $4f3aa993cc57516e$var$sh,
    useCallback: $4f3aa993cc57516e$var$Ii,
    useContext: $4f3aa993cc57516e$var$sh,
    useEffect: $4f3aa993cc57516e$var$ni,
    useImperativeHandle: $4f3aa993cc57516e$var$Gi,
    useInsertionEffect: $4f3aa993cc57516e$var$Di,
    useLayoutEffect: $4f3aa993cc57516e$var$Ei,
    useMemo: $4f3aa993cc57516e$var$Ji,
    useReducer: $4f3aa993cc57516e$var$ki,
    useRef: $4f3aa993cc57516e$var$xi,
    useState: function() {
        return $4f3aa993cc57516e$var$ki($4f3aa993cc57516e$var$ii);
    },
    useDebugValue: $4f3aa993cc57516e$var$Hi,
    useDeferredValue: function(a) {
        var b = $4f3aa993cc57516e$var$hi();
        return null === $4f3aa993cc57516e$var$N ? b.memoizedState = a : $4f3aa993cc57516e$var$Ki(b, $4f3aa993cc57516e$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4f3aa993cc57516e$var$ki($4f3aa993cc57516e$var$ii)[0], b = $4f3aa993cc57516e$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4f3aa993cc57516e$var$li,
    useSyncExternalStore: $4f3aa993cc57516e$var$mi,
    useId: $4f3aa993cc57516e$var$Mi,
    unstable_isNewReconciler: !1
}, $4f3aa993cc57516e$var$Ti = $lMj4E.unstable_now, $4f3aa993cc57516e$var$Ui = 0, $4f3aa993cc57516e$var$Vi = -1, $4f3aa993cc57516e$var$Wi = -1, $4f3aa993cc57516e$var$Xi = -1, $4f3aa993cc57516e$var$Yi = !1, $4f3aa993cc57516e$var$Zi = !1;
function $4f3aa993cc57516e$var$$i(a, b) {
    if (0 <= $4f3aa993cc57516e$var$Wi) {
        var c = $4f3aa993cc57516e$var$Ti() - $4f3aa993cc57516e$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $4f3aa993cc57516e$var$Wi = -1;
    }
}
function $4f3aa993cc57516e$var$aj(a) {
    if (0 <= $4f3aa993cc57516e$var$Vi) {
        var b = $4f3aa993cc57516e$var$Ti() - $4f3aa993cc57516e$var$Vi;
        $4f3aa993cc57516e$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $4f3aa993cc57516e$var$bj(a) {
    if (0 <= $4f3aa993cc57516e$var$Xi) {
        var b = $4f3aa993cc57516e$var$Ti() - $4f3aa993cc57516e$var$Xi;
        $4f3aa993cc57516e$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $4f3aa993cc57516e$var$cj() {
    $4f3aa993cc57516e$var$Vi = $4f3aa993cc57516e$var$Ti();
}
function $4f3aa993cc57516e$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $4f3aa993cc57516e$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $4f3aa993cc57516e$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4f3aa993cc57516e$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4f3aa993cc57516e$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4f3aa993cc57516e$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4f3aa993cc57516e$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4f3aa993cc57516e$var$Ri(), e = $4f3aa993cc57516e$var$Oi(a), f = $4f3aa993cc57516e$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4f3aa993cc57516e$var$Bh(a, f, e);
        null !== b && ($4f3aa993cc57516e$var$ui(b, a, e, d), $4f3aa993cc57516e$var$Ch(b, a, e));
        $4f3aa993cc57516e$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4f3aa993cc57516e$var$Ri(), e = $4f3aa993cc57516e$var$Oi(a), f = $4f3aa993cc57516e$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4f3aa993cc57516e$var$Bh(a, f, e);
        null !== b && ($4f3aa993cc57516e$var$ui(b, a, e, d), $4f3aa993cc57516e$var$Ch(b, a, e));
        $4f3aa993cc57516e$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4f3aa993cc57516e$var$Ri(), d = $4f3aa993cc57516e$var$Oi(a), e = $4f3aa993cc57516e$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4f3aa993cc57516e$var$Bh(a, e, d);
        null !== b && ($4f3aa993cc57516e$var$ui(b, a, d, c), $4f3aa993cc57516e$var$Ch(b, a, d));
        null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markForceUpdateScheduled && $4f3aa993cc57516e$var$B.markForceUpdateScheduled(a, d);
    }
};
function $4f3aa993cc57516e$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4f3aa993cc57516e$var$We(c, d) || !$4f3aa993cc57516e$var$We(e, f) : !0;
}
function $4f3aa993cc57516e$var$ij(a, b, c) {
    var d = !1, e = $4f3aa993cc57516e$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4f3aa993cc57516e$var$sh(f) : (e = $4f3aa993cc57516e$var$mg(b) ? $4f3aa993cc57516e$var$kg : $4f3aa993cc57516e$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4f3aa993cc57516e$var$lg(a, e) : $4f3aa993cc57516e$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4f3aa993cc57516e$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4f3aa993cc57516e$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4f3aa993cc57516e$var$gj.enqueueReplaceState(b, b.state, null);
}
function $4f3aa993cc57516e$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4f3aa993cc57516e$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4f3aa993cc57516e$var$sh(f) : (f = $4f3aa993cc57516e$var$mg(b) ? $4f3aa993cc57516e$var$kg : $4f3aa993cc57516e$var$I.current, e.context = $4f3aa993cc57516e$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4f3aa993cc57516e$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4f3aa993cc57516e$var$gj.enqueueReplaceState(e, e.state, null), $4f3aa993cc57516e$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4f3aa993cc57516e$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $4f3aa993cc57516e$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4f3aa993cc57516e$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4f3aa993cc57516e$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4f3aa993cc57516e$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $4f3aa993cc57516e$var$pj(a, b, c) {
    c = $4f3aa993cc57516e$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4f3aa993cc57516e$var$qj || ($4f3aa993cc57516e$var$qj = !0, $4f3aa993cc57516e$var$rj = d);
        $4f3aa993cc57516e$var$nj(a, b);
    };
    return c;
}
function $4f3aa993cc57516e$var$sj(a, b, c) {
    c = $4f3aa993cc57516e$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4f3aa993cc57516e$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4f3aa993cc57516e$var$nj(a, b);
        "function" !== typeof d && (null === $4f3aa993cc57516e$var$tj ? $4f3aa993cc57516e$var$tj = new Set([
            this
        ]) : $4f3aa993cc57516e$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4f3aa993cc57516e$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4f3aa993cc57516e$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $4f3aa993cc57516e$var$vj.bind(null, a, b, c), $4f3aa993cc57516e$var$mc && $4f3aa993cc57516e$var$wj(a, c), b.then(d, d));
}
function $4f3aa993cc57516e$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4f3aa993cc57516e$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4f3aa993cc57516e$var$Ah(-1, 1), b.tag = 2, $4f3aa993cc57516e$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4f3aa993cc57516e$var$zj = $4f3aa993cc57516e$var$va.ReactCurrentOwner, $4f3aa993cc57516e$var$rh = !1;
function $4f3aa993cc57516e$var$Aj(a, b, c, d) {
    b.child = null === a ? $4f3aa993cc57516e$var$ih(b, null, c, d) : $4f3aa993cc57516e$var$hh(b, a.child, c, d);
}
function $4f3aa993cc57516e$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4f3aa993cc57516e$var$qh(b, e);
    $4f3aa993cc57516e$var$sc(b);
    d = $4f3aa993cc57516e$var$ai(a, b, c, d, f, e);
    c = $4f3aa993cc57516e$var$fi();
    $4f3aa993cc57516e$var$tc();
    if (null !== a && !$4f3aa993cc57516e$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4f3aa993cc57516e$var$Cj(a, b, e);
    $4f3aa993cc57516e$var$J && c && $4f3aa993cc57516e$var$Jg(b);
    b.flags |= 1;
    $4f3aa993cc57516e$var$Aj(a, b, d, e);
    return b.child;
}
function $4f3aa993cc57516e$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4f3aa993cc57516e$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4f3aa993cc57516e$var$Fj(a, b, f, d, e);
        a = $4f3aa993cc57516e$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4f3aa993cc57516e$var$We;
        if (c(g, d) && a.ref === b.ref) return $4f3aa993cc57516e$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $4f3aa993cc57516e$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4f3aa993cc57516e$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4f3aa993cc57516e$var$We(f, d) && a.ref === b.ref) {
            if ($4f3aa993cc57516e$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4f3aa993cc57516e$var$rh = !0);
            else return b.lanes = a.lanes, $4f3aa993cc57516e$var$Cj(a, b, e);
        }
    }
    return $4f3aa993cc57516e$var$Gj(a, b, c, d, e);
}
function $4f3aa993cc57516e$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ij, $4f3aa993cc57516e$var$Jj), $4f3aa993cc57516e$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ij, $4f3aa993cc57516e$var$Jj), $4f3aa993cc57516e$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ij, $4f3aa993cc57516e$var$Jj);
            $4f3aa993cc57516e$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$Ij, $4f3aa993cc57516e$var$Jj), $4f3aa993cc57516e$var$Jj |= d;
    $4f3aa993cc57516e$var$Aj(a, b, e, c);
    return b.child;
}
function $4f3aa993cc57516e$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4f3aa993cc57516e$var$Gj(a, b, c, d, e) {
    var f = $4f3aa993cc57516e$var$mg(c) ? $4f3aa993cc57516e$var$kg : $4f3aa993cc57516e$var$I.current;
    f = $4f3aa993cc57516e$var$lg(b, f);
    $4f3aa993cc57516e$var$qh(b, e);
    $4f3aa993cc57516e$var$sc(b);
    c = $4f3aa993cc57516e$var$ai(a, b, c, d, f, e);
    d = $4f3aa993cc57516e$var$fi();
    $4f3aa993cc57516e$var$tc();
    if (null !== a && !$4f3aa993cc57516e$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4f3aa993cc57516e$var$Cj(a, b, e);
    $4f3aa993cc57516e$var$J && d && $4f3aa993cc57516e$var$Jg(b);
    b.flags |= 1;
    $4f3aa993cc57516e$var$Aj(a, b, c, e);
    return b.child;
}
function $4f3aa993cc57516e$var$Lj(a, b, c, d, e) {
    if ($4f3aa993cc57516e$var$mg(c)) {
        var f = !0;
        $4f3aa993cc57516e$var$qg(b);
    } else f = !1;
    $4f3aa993cc57516e$var$qh(b, e);
    if (null === b.stateNode) $4f3aa993cc57516e$var$Mj(a, b), $4f3aa993cc57516e$var$ij(b, c, d), $4f3aa993cc57516e$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4f3aa993cc57516e$var$sh(l) : (l = $4f3aa993cc57516e$var$mg(c) ? $4f3aa993cc57516e$var$kg : $4f3aa993cc57516e$var$I.current, l = $4f3aa993cc57516e$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4f3aa993cc57516e$var$jj(b, g, d, l);
        $4f3aa993cc57516e$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4f3aa993cc57516e$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4f3aa993cc57516e$var$jg.current || $4f3aa993cc57516e$var$xh ? ("function" === typeof n && ($4f3aa993cc57516e$var$fj(b, c, n, d), k = b.memoizedState), (h = $4f3aa993cc57516e$var$xh || $4f3aa993cc57516e$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4f3aa993cc57516e$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4f3aa993cc57516e$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4f3aa993cc57516e$var$sh(k) : (k = $4f3aa993cc57516e$var$mg(c) ? $4f3aa993cc57516e$var$kg : $4f3aa993cc57516e$var$I.current, k = $4f3aa993cc57516e$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4f3aa993cc57516e$var$jj(b, g, d, k);
        $4f3aa993cc57516e$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $4f3aa993cc57516e$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $4f3aa993cc57516e$var$jg.current || $4f3aa993cc57516e$var$xh ? ("function" === typeof z && ($4f3aa993cc57516e$var$fj(b, c, z, d), m = b.memoizedState), (l = $4f3aa993cc57516e$var$xh || $4f3aa993cc57516e$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4f3aa993cc57516e$var$Nj(a, b, c, d, f, e);
}
function $4f3aa993cc57516e$var$Nj(a, b, c, d, e, f) {
    $4f3aa993cc57516e$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4f3aa993cc57516e$var$rg(b, c, !1), $4f3aa993cc57516e$var$Cj(a, b, f);
    d = b.stateNode;
    $4f3aa993cc57516e$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $4f3aa993cc57516e$var$Wi = -1;
    } else $4f3aa993cc57516e$var$sc(b), h = d.render(), $4f3aa993cc57516e$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $4f3aa993cc57516e$var$hh(b, a.child, null, f), b.child = $4f3aa993cc57516e$var$hh(b, null, g, f)) : $4f3aa993cc57516e$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && $4f3aa993cc57516e$var$rg(b, c, !0);
    return b.child;
}
function $4f3aa993cc57516e$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4f3aa993cc57516e$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4f3aa993cc57516e$var$og(a, b.context, !1);
    $4f3aa993cc57516e$var$Mh(a, b.containerInfo);
}
function $4f3aa993cc57516e$var$Rj(a, b, c, d, e) {
    $4f3aa993cc57516e$var$Wg();
    $4f3aa993cc57516e$var$Xg(e);
    b.flags |= 256;
    $4f3aa993cc57516e$var$Aj(a, b, c, d);
    return b.child;
}
var $4f3aa993cc57516e$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4f3aa993cc57516e$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4f3aa993cc57516e$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $4f3aa993cc57516e$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, e & 1);
    if (null === a) {
        $4f3aa993cc57516e$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $4f3aa993cc57516e$var$Vj(g, d, 0, null), a = $4f3aa993cc57516e$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4f3aa993cc57516e$var$Tj(c), b.memoizedState = $4f3aa993cc57516e$var$Sj, a) : $4f3aa993cc57516e$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4f3aa993cc57516e$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $4f3aa993cc57516e$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4f3aa993cc57516e$var$ch(h, f) : (f = $4f3aa993cc57516e$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4f3aa993cc57516e$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4f3aa993cc57516e$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4f3aa993cc57516e$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4f3aa993cc57516e$var$Wj(a, b) {
    b = $4f3aa993cc57516e$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4f3aa993cc57516e$var$Yj(a, b, c, d) {
    null !== d && $4f3aa993cc57516e$var$Xg(d);
    $4f3aa993cc57516e$var$hh(b, a.child, null, c);
    a = $4f3aa993cc57516e$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4f3aa993cc57516e$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4f3aa993cc57516e$var$mj(Error($4f3aa993cc57516e$var$p(422))), $4f3aa993cc57516e$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4f3aa993cc57516e$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4f3aa993cc57516e$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4f3aa993cc57516e$var$hh(b, a.child, null, g);
        b.child.memoizedState = $4f3aa993cc57516e$var$Tj(g);
        b.memoizedState = $4f3aa993cc57516e$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4f3aa993cc57516e$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4f3aa993cc57516e$var$p(419));
        d = $4f3aa993cc57516e$var$mj(f, d, void 0);
        return $4f3aa993cc57516e$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4f3aa993cc57516e$var$rh || h) {
        d = $4f3aa993cc57516e$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4f3aa993cc57516e$var$wh(a, e), $4f3aa993cc57516e$var$ui(d, a, e, -1));
        }
        $4f3aa993cc57516e$var$Zj();
        d = $4f3aa993cc57516e$var$mj(Error($4f3aa993cc57516e$var$p(421)));
        return $4f3aa993cc57516e$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4f3aa993cc57516e$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Zf(e.nextSibling);
    $4f3aa993cc57516e$var$Lg = b;
    $4f3aa993cc57516e$var$J = !0;
    $4f3aa993cc57516e$var$Ng = null;
    null !== a && ($4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Fg, $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Gg, $4f3aa993cc57516e$var$Cg[$4f3aa993cc57516e$var$Dg++] = $4f3aa993cc57516e$var$Eg, $4f3aa993cc57516e$var$Fg = a.id, $4f3aa993cc57516e$var$Gg = a.overflow, $4f3aa993cc57516e$var$Eg = b);
    b = $4f3aa993cc57516e$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4f3aa993cc57516e$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4f3aa993cc57516e$var$ph(a.return, b, c);
}
function $4f3aa993cc57516e$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4f3aa993cc57516e$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4f3aa993cc57516e$var$Aj(a, b, d.children, c);
    d = $4f3aa993cc57516e$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4f3aa993cc57516e$var$bk(a, c, b);
            else if (19 === a.tag) $4f3aa993cc57516e$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4f3aa993cc57516e$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4f3aa993cc57516e$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4f3aa993cc57516e$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4f3aa993cc57516e$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $4f3aa993cc57516e$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4f3aa993cc57516e$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4f3aa993cc57516e$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4f3aa993cc57516e$var$Wi = -1;
    $4f3aa993cc57516e$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4f3aa993cc57516e$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4f3aa993cc57516e$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4f3aa993cc57516e$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4f3aa993cc57516e$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $4f3aa993cc57516e$var$Oj(b);
            $4f3aa993cc57516e$var$Wg();
            break;
        case 5:
            $4f3aa993cc57516e$var$Oh(b);
            break;
        case 1:
            $4f3aa993cc57516e$var$mg(b.type) && $4f3aa993cc57516e$var$qg(b);
            break;
        case 4:
            $4f3aa993cc57516e$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, $4f3aa993cc57516e$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4f3aa993cc57516e$var$Uj(a, b, c);
                $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, $4f3aa993cc57516e$var$L.current & 1);
                a = $4f3aa993cc57516e$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, $4f3aa993cc57516e$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4f3aa993cc57516e$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, $4f3aa993cc57516e$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4f3aa993cc57516e$var$Hj(a, b, c);
    }
    return $4f3aa993cc57516e$var$Cj(a, b, c);
}
var $4f3aa993cc57516e$var$fk, $4f3aa993cc57516e$var$gk, $4f3aa993cc57516e$var$hk, $4f3aa993cc57516e$var$ik;
$4f3aa993cc57516e$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4f3aa993cc57516e$var$gk = function() {};
$4f3aa993cc57516e$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $4f3aa993cc57516e$var$Ya(a, e);
                d = $4f3aa993cc57516e$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4f3aa993cc57516e$var$u({}, e, {
                    value: void 0
                });
                d = $4f3aa993cc57516e$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4f3aa993cc57516e$var$fb(a, e);
                d = $4f3aa993cc57516e$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4f3aa993cc57516e$var$Pf);
        }
        $4f3aa993cc57516e$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4f3aa993cc57516e$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4f3aa993cc57516e$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4f3aa993cc57516e$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4f3aa993cc57516e$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4f3aa993cc57516e$var$jk(a, b) {
    if (!$4f3aa993cc57516e$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4f3aa993cc57516e$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4f3aa993cc57516e$var$kk(a, b, c) {
    var d = b.pendingProps;
    $4f3aa993cc57516e$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4f3aa993cc57516e$var$S(b), null;
        case 1:
            return $4f3aa993cc57516e$var$mg(b.type) && $4f3aa993cc57516e$var$ng(), $4f3aa993cc57516e$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4f3aa993cc57516e$var$Nh();
            $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg);
            $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$I);
            $4f3aa993cc57516e$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4f3aa993cc57516e$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4f3aa993cc57516e$var$Ng && ($4f3aa993cc57516e$var$lk($4f3aa993cc57516e$var$Ng), $4f3aa993cc57516e$var$Ng = null));
            $4f3aa993cc57516e$var$gk(a, b);
            $4f3aa993cc57516e$var$S(b);
            return null;
        case 5:
            $4f3aa993cc57516e$var$Ph(b);
            var e = $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4f3aa993cc57516e$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4f3aa993cc57516e$var$p(166));
                    $4f3aa993cc57516e$var$S(b);
                    return null;
                }
                a = $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Ih.current);
                if ($4f3aa993cc57516e$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$4f3aa993cc57516e$var$bg] = b;
                    d[$4f3aa993cc57516e$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $4f3aa993cc57516e$var$F("cancel", d);
                            $4f3aa993cc57516e$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4f3aa993cc57516e$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4f3aa993cc57516e$var$zf.length; e++)$4f3aa993cc57516e$var$F($4f3aa993cc57516e$var$zf[e], d);
                            break;
                        case "source":
                            $4f3aa993cc57516e$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4f3aa993cc57516e$var$F("error", d);
                            $4f3aa993cc57516e$var$F("load", d);
                            break;
                        case "details":
                            $4f3aa993cc57516e$var$F("toggle", d);
                            break;
                        case "input":
                            $4f3aa993cc57516e$var$Za(d, c);
                            $4f3aa993cc57516e$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $4f3aa993cc57516e$var$F("invalid", d);
                            break;
                        case "textarea":
                            $4f3aa993cc57516e$var$gb(d, c), $4f3aa993cc57516e$var$F("invalid", d);
                    }
                    $4f3aa993cc57516e$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $4f3aa993cc57516e$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $4f3aa993cc57516e$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $4f3aa993cc57516e$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4f3aa993cc57516e$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $4f3aa993cc57516e$var$Va(d);
                            $4f3aa993cc57516e$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $4f3aa993cc57516e$var$Va(d);
                            $4f3aa993cc57516e$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $4f3aa993cc57516e$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4f3aa993cc57516e$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4f3aa993cc57516e$var$bg] = b;
                    a[$4f3aa993cc57516e$var$cg] = d;
                    $4f3aa993cc57516e$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4f3aa993cc57516e$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4f3aa993cc57516e$var$F("cancel", a);
                                $4f3aa993cc57516e$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4f3aa993cc57516e$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4f3aa993cc57516e$var$zf.length; e++)$4f3aa993cc57516e$var$F($4f3aa993cc57516e$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4f3aa993cc57516e$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4f3aa993cc57516e$var$F("error", a);
                                $4f3aa993cc57516e$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $4f3aa993cc57516e$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4f3aa993cc57516e$var$Za(a, d);
                                e = $4f3aa993cc57516e$var$Ya(a, d);
                                $4f3aa993cc57516e$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4f3aa993cc57516e$var$u({}, d, {
                                    value: void 0
                                });
                                $4f3aa993cc57516e$var$F("invalid", a);
                                break;
                            case "textarea":
                                $4f3aa993cc57516e$var$gb(a, d);
                                e = $4f3aa993cc57516e$var$fb(a, d);
                                $4f3aa993cc57516e$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4f3aa993cc57516e$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4f3aa993cc57516e$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4f3aa993cc57516e$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4f3aa993cc57516e$var$ob(a, k) : "number" === typeof k && $4f3aa993cc57516e$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4f3aa993cc57516e$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4f3aa993cc57516e$var$F("scroll", a) : null != k && $4f3aa993cc57516e$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4f3aa993cc57516e$var$Va(a);
                                $4f3aa993cc57516e$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $4f3aa993cc57516e$var$Va(a);
                                $4f3aa993cc57516e$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4f3aa993cc57516e$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4f3aa993cc57516e$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4f3aa993cc57516e$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4f3aa993cc57516e$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4f3aa993cc57516e$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4f3aa993cc57516e$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4f3aa993cc57516e$var$p(166));
                a = $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Kh.current);
                $4f3aa993cc57516e$var$Lh($4f3aa993cc57516e$var$Ih.current);
                if ($4f3aa993cc57516e$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$4f3aa993cc57516e$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $4f3aa993cc57516e$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $4f3aa993cc57516e$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $4f3aa993cc57516e$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$4f3aa993cc57516e$var$bg] = b, b.stateNode = d;
            }
            $4f3aa993cc57516e$var$S(b);
            return null;
        case 13:
            $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4f3aa993cc57516e$var$J && null !== $4f3aa993cc57516e$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4f3aa993cc57516e$var$Vg(), $4f3aa993cc57516e$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $4f3aa993cc57516e$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4f3aa993cc57516e$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4f3aa993cc57516e$var$p(317));
                        f[$4f3aa993cc57516e$var$bg] = b;
                        $4f3aa993cc57516e$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $4f3aa993cc57516e$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $4f3aa993cc57516e$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $4f3aa993cc57516e$var$Ng && ($4f3aa993cc57516e$var$lk($4f3aa993cc57516e$var$Ng), $4f3aa993cc57516e$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $4f3aa993cc57516e$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4f3aa993cc57516e$var$L.current & 1) ? 0 === $4f3aa993cc57516e$var$T && ($4f3aa993cc57516e$var$T = 3) : $4f3aa993cc57516e$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4f3aa993cc57516e$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $4f3aa993cc57516e$var$Nh(), $4f3aa993cc57516e$var$gk(a, b), null === a && $4f3aa993cc57516e$var$Gf(b.stateNode.containerInfo), $4f3aa993cc57516e$var$S(b), null;
        case 10:
            return $4f3aa993cc57516e$var$oh(b.type._context), $4f3aa993cc57516e$var$S(b), null;
        case 17:
            return $4f3aa993cc57516e$var$mg(b.type) && $4f3aa993cc57516e$var$ng(), $4f3aa993cc57516e$var$S(b), null;
        case 19:
            $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L);
            f = b.memoizedState;
            if (null === f) return $4f3aa993cc57516e$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4f3aa993cc57516e$var$jk(f, !1);
                else {
                    if (0 !== $4f3aa993cc57516e$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4f3aa993cc57516e$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4f3aa993cc57516e$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, $4f3aa993cc57516e$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4f3aa993cc57516e$var$A() > $4f3aa993cc57516e$var$mk && (b.flags |= 128, d = !0, $4f3aa993cc57516e$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4f3aa993cc57516e$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $4f3aa993cc57516e$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4f3aa993cc57516e$var$J) return $4f3aa993cc57516e$var$S(b), null;
                    } else 2 * $4f3aa993cc57516e$var$A() - f.renderingStartTime > $4f3aa993cc57516e$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $4f3aa993cc57516e$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4f3aa993cc57516e$var$A(), b.sibling = null, a = $4f3aa993cc57516e$var$L.current, $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$L, d ? a & 1 | 2 : a & 1), b;
            $4f3aa993cc57516e$var$S(b);
            return null;
        case 22:
        case 23:
            return $4f3aa993cc57516e$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4f3aa993cc57516e$var$Jj & 1073741824) && ($4f3aa993cc57516e$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4f3aa993cc57516e$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4f3aa993cc57516e$var$p(156, b.tag));
}
function $4f3aa993cc57516e$var$ok(a, b) {
    $4f3aa993cc57516e$var$Kg(b);
    switch(b.tag){
        case 1:
            return $4f3aa993cc57516e$var$mg(b.type) && $4f3aa993cc57516e$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $4f3aa993cc57516e$var$dj(b), b) : null;
        case 3:
            return $4f3aa993cc57516e$var$Nh(), $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg), $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$I), $4f3aa993cc57516e$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4f3aa993cc57516e$var$Ph(b), null;
        case 13:
            $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4f3aa993cc57516e$var$p(340));
                $4f3aa993cc57516e$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $4f3aa993cc57516e$var$dj(b), b) : null;
        case 19:
            return $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L), null;
        case 4:
            return $4f3aa993cc57516e$var$Nh(), null;
        case 10:
            return $4f3aa993cc57516e$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $4f3aa993cc57516e$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4f3aa993cc57516e$var$pk = !1, $4f3aa993cc57516e$var$qk = !1, $4f3aa993cc57516e$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $4f3aa993cc57516e$var$U = null, $4f3aa993cc57516e$var$sk = null, $4f3aa993cc57516e$var$tk = null;
function $4f3aa993cc57516e$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $4f3aa993cc57516e$var$cj(), b.componentWillUnmount();
    } finally{
        $4f3aa993cc57516e$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $4f3aa993cc57516e$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $4f3aa993cc57516e$var$cj(), c(null);
            } finally{
                $4f3aa993cc57516e$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $4f3aa993cc57516e$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4f3aa993cc57516e$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $4f3aa993cc57516e$var$W(a, b, d);
    }
}
var $4f3aa993cc57516e$var$xk = !1;
function $4f3aa993cc57516e$var$yk(a, b) {
    $4f3aa993cc57516e$var$Qf = $4f3aa993cc57516e$var$rd;
    a = $4f3aa993cc57516e$var$$e();
    if ($4f3aa993cc57516e$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4f3aa993cc57516e$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $4f3aa993cc57516e$var$rd = !1;
    for($4f3aa993cc57516e$var$U = b; null !== $4f3aa993cc57516e$var$U;)if (b = $4f3aa993cc57516e$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4f3aa993cc57516e$var$U = a;
    else for(; null !== $4f3aa993cc57516e$var$U;){
        b = $4f3aa993cc57516e$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $4f3aa993cc57516e$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4f3aa993cc57516e$var$p(163));
            }
        } catch (D) {
            $4f3aa993cc57516e$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4f3aa993cc57516e$var$U = a;
            break;
        }
        $4f3aa993cc57516e$var$U = b.return;
    }
    m = $4f3aa993cc57516e$var$xk;
    $4f3aa993cc57516e$var$xk = !1;
    return m;
}
function $4f3aa993cc57516e$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentPassiveEffectUnmountStarted && $4f3aa993cc57516e$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $4f3aa993cc57516e$var$uc(b), $4f3aa993cc57516e$var$wk(b, c, f), 0 !== (a & 8) ? null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentPassiveEffectUnmountStopped && $4f3aa993cc57516e$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $4f3aa993cc57516e$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4f3aa993cc57516e$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentPassiveEffectMountStarted && $4f3aa993cc57516e$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentLayoutEffectMountStarted && $4f3aa993cc57516e$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentPassiveEffectMountStopped && $4f3aa993cc57516e$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentLayoutEffectMountStopped && $4f3aa993cc57516e$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $4f3aa993cc57516e$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $4f3aa993cc57516e$var$cj(), b(c);
            } finally{
                $4f3aa993cc57516e$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $4f3aa993cc57516e$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4f3aa993cc57516e$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4f3aa993cc57516e$var$bg], delete b[$4f3aa993cc57516e$var$cg], delete b[$4f3aa993cc57516e$var$Cf], delete b[$4f3aa993cc57516e$var$dg], delete b[$4f3aa993cc57516e$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4f3aa993cc57516e$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4f3aa993cc57516e$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4f3aa993cc57516e$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4f3aa993cc57516e$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4f3aa993cc57516e$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($4f3aa993cc57516e$var$Fk(a, b, c), a = a.sibling; null !== a;)$4f3aa993cc57516e$var$Fk(a, b, c), a = a.sibling;
}
function $4f3aa993cc57516e$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4f3aa993cc57516e$var$Gk(a, b, c), a = a.sibling; null !== a;)$4f3aa993cc57516e$var$Gk(a, b, c), a = a.sibling;
}
var $4f3aa993cc57516e$var$X = null, $4f3aa993cc57516e$var$Hk = !1;
function $4f3aa993cc57516e$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$4f3aa993cc57516e$var$Jk(a, b, c), c = c.sibling;
}
function $4f3aa993cc57516e$var$Jk(a, b, c) {
    if ($4f3aa993cc57516e$var$lc && "function" === typeof $4f3aa993cc57516e$var$lc.onCommitFiberUnmount) try {
        $4f3aa993cc57516e$var$lc.onCommitFiberUnmount($4f3aa993cc57516e$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4f3aa993cc57516e$var$qk || $4f3aa993cc57516e$var$vk(c, b);
        case 6:
            var d = $4f3aa993cc57516e$var$X, e = $4f3aa993cc57516e$var$Hk;
            $4f3aa993cc57516e$var$X = null;
            $4f3aa993cc57516e$var$Ik(a, b, c);
            $4f3aa993cc57516e$var$X = d;
            $4f3aa993cc57516e$var$Hk = e;
            null !== $4f3aa993cc57516e$var$X && ($4f3aa993cc57516e$var$Hk ? (a = $4f3aa993cc57516e$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4f3aa993cc57516e$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4f3aa993cc57516e$var$X && ($4f3aa993cc57516e$var$Hk ? (a = $4f3aa993cc57516e$var$X, c = c.stateNode, 8 === a.nodeType ? $4f3aa993cc57516e$var$Yf(a.parentNode, c) : 1 === a.nodeType && $4f3aa993cc57516e$var$Yf(a, c), $4f3aa993cc57516e$var$pd(a)) : $4f3aa993cc57516e$var$Yf($4f3aa993cc57516e$var$X, c.stateNode));
            break;
        case 4:
            d = $4f3aa993cc57516e$var$X;
            e = $4f3aa993cc57516e$var$Hk;
            $4f3aa993cc57516e$var$X = c.stateNode.containerInfo;
            $4f3aa993cc57516e$var$Hk = !0;
            $4f3aa993cc57516e$var$Ik(a, b, c);
            $4f3aa993cc57516e$var$X = d;
            $4f3aa993cc57516e$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4f3aa993cc57516e$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4f3aa993cc57516e$var$wk(c, b, g) : 0 !== (f & 4) && ($4f3aa993cc57516e$var$uc(c), c.mode & 2 ? ($4f3aa993cc57516e$var$cj(), $4f3aa993cc57516e$var$wk(c, b, g), $4f3aa993cc57516e$var$aj(c)) : $4f3aa993cc57516e$var$wk(c, b, g), $4f3aa993cc57516e$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $4f3aa993cc57516e$var$Ik(a, b, c);
            break;
        case 1:
            if (!$4f3aa993cc57516e$var$qk && ($4f3aa993cc57516e$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $4f3aa993cc57516e$var$uk(c, d);
            } catch (h) {
                $4f3aa993cc57516e$var$W(c, b, h);
            }
            $4f3aa993cc57516e$var$Ik(a, b, c);
            break;
        case 21:
            $4f3aa993cc57516e$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4f3aa993cc57516e$var$qk = (d = $4f3aa993cc57516e$var$qk) || null !== c.memoizedState, $4f3aa993cc57516e$var$Ik(a, b, c), $4f3aa993cc57516e$var$qk = d) : $4f3aa993cc57516e$var$Ik(a, b, c);
            break;
        default:
            $4f3aa993cc57516e$var$Ik(a, b, c);
    }
}
function $4f3aa993cc57516e$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4f3aa993cc57516e$var$rk);
        b.forEach(function(b) {
            var d = $4f3aa993cc57516e$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($4f3aa993cc57516e$var$mc) {
                    if (null !== $4f3aa993cc57516e$var$sk && null !== $4f3aa993cc57516e$var$tk) $4f3aa993cc57516e$var$wj($4f3aa993cc57516e$var$tk, $4f3aa993cc57516e$var$sk);
                    else throw Error($4f3aa993cc57516e$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $4f3aa993cc57516e$var$Mk(a, b, c) {
    $4f3aa993cc57516e$var$sk = c;
    $4f3aa993cc57516e$var$tk = a;
    $4f3aa993cc57516e$var$Nk(b, a);
    $4f3aa993cc57516e$var$tk = $4f3aa993cc57516e$var$sk = null;
}
function $4f3aa993cc57516e$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4f3aa993cc57516e$var$X = h.stateNode;
                        $4f3aa993cc57516e$var$Hk = !1;
                        break a;
                    case 3:
                        $4f3aa993cc57516e$var$X = h.stateNode.containerInfo;
                        $4f3aa993cc57516e$var$Hk = !0;
                        break a;
                    case 4:
                        $4f3aa993cc57516e$var$X = h.stateNode.containerInfo;
                        $4f3aa993cc57516e$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4f3aa993cc57516e$var$X) throw Error($4f3aa993cc57516e$var$p(160));
            $4f3aa993cc57516e$var$Jk(f, g, e);
            $4f3aa993cc57516e$var$X = null;
            $4f3aa993cc57516e$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4f3aa993cc57516e$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4f3aa993cc57516e$var$Nk(b, a), b = b.sibling;
}
function $4f3aa993cc57516e$var$Nk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            if (d & 4) {
                try {
                    $4f3aa993cc57516e$var$zk(3, a, a.return), $4f3aa993cc57516e$var$Ak(3, a);
                } catch (m) {
                    $4f3aa993cc57516e$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $4f3aa993cc57516e$var$cj(), $4f3aa993cc57516e$var$zk(5, a, a.return);
                    } catch (m) {
                        $4f3aa993cc57516e$var$W(a, a.return, m);
                    }
                    $4f3aa993cc57516e$var$aj(a);
                } else try {
                    $4f3aa993cc57516e$var$zk(5, a, a.return);
                } catch (m) {
                    $4f3aa993cc57516e$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            d & 512 && null !== c && $4f3aa993cc57516e$var$vk(c, c.return);
            break;
        case 5:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            d & 512 && null !== c && $4f3aa993cc57516e$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4f3aa993cc57516e$var$ob(e, "");
                } catch (m) {
                    $4f3aa993cc57516e$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4f3aa993cc57516e$var$$a(e, f);
                    $4f3aa993cc57516e$var$vb(h, g);
                    var l = $4f3aa993cc57516e$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $4f3aa993cc57516e$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $4f3aa993cc57516e$var$nb(e, q) : "children" === n ? $4f3aa993cc57516e$var$ob(e, q) : $4f3aa993cc57516e$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $4f3aa993cc57516e$var$ab(e, f);
                            break;
                        case "textarea":
                            $4f3aa993cc57516e$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $4f3aa993cc57516e$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4f3aa993cc57516e$var$eb(e, !!f.multiple, f.defaultValue, !0) : $4f3aa993cc57516e$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4f3aa993cc57516e$var$cg] = f;
                } catch (m) {
                    $4f3aa993cc57516e$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4f3aa993cc57516e$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $4f3aa993cc57516e$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4f3aa993cc57516e$var$pd(b.containerInfo);
            } catch (m) {
                $4f3aa993cc57516e$var$W(a, a.return, m);
            }
            break;
        case 4:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            break;
        case 13:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4f3aa993cc57516e$var$Qk = $4f3aa993cc57516e$var$A()));
            d & 4 && $4f3aa993cc57516e$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4f3aa993cc57516e$var$qk = (l = $4f3aa993cc57516e$var$qk) || n, $4f3aa993cc57516e$var$Ok(b, a), $4f3aa993cc57516e$var$qk = l) : $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($4f3aa993cc57516e$var$U = a, n = a.child; null !== n;){
                    for(q = $4f3aa993cc57516e$var$U = n; null !== $4f3aa993cc57516e$var$U;){
                        r = $4f3aa993cc57516e$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $4f3aa993cc57516e$var$cj(), $4f3aa993cc57516e$var$zk(4, r, r.return);
                                } finally{
                                    $4f3aa993cc57516e$var$aj(r);
                                }
                                else $4f3aa993cc57516e$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $4f3aa993cc57516e$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $4f3aa993cc57516e$var$uk(c, d);
                                    } catch (m) {
                                        $4f3aa993cc57516e$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $4f3aa993cc57516e$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4f3aa993cc57516e$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $4f3aa993cc57516e$var$U = z) : $4f3aa993cc57516e$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4f3aa993cc57516e$var$rb("display", g));
                            } catch (m) {
                                $4f3aa993cc57516e$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $4f3aa993cc57516e$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4f3aa993cc57516e$var$Ok(b, a);
            $4f3aa993cc57516e$var$Pk(a);
            d & 4 && $4f3aa993cc57516e$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $4f3aa993cc57516e$var$Ok(b, a), $4f3aa993cc57516e$var$Pk(a);
    }
}
function $4f3aa993cc57516e$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4f3aa993cc57516e$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4f3aa993cc57516e$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4f3aa993cc57516e$var$ob(e, ""), d.flags &= -33);
                    var f = $4f3aa993cc57516e$var$Ek(a);
                    $4f3aa993cc57516e$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4f3aa993cc57516e$var$Ek(a);
                    $4f3aa993cc57516e$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($4f3aa993cc57516e$var$p(161));
            }
        } catch (k) {
            $4f3aa993cc57516e$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4f3aa993cc57516e$var$Sk(a, b, c) {
    $4f3aa993cc57516e$var$sk = c;
    $4f3aa993cc57516e$var$tk = b;
    $4f3aa993cc57516e$var$U = a;
    $4f3aa993cc57516e$var$Tk(a, b, c);
    $4f3aa993cc57516e$var$tk = $4f3aa993cc57516e$var$sk = null;
}
function $4f3aa993cc57516e$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4f3aa993cc57516e$var$U;){
        var e = $4f3aa993cc57516e$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4f3aa993cc57516e$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4f3aa993cc57516e$var$qk;
                h = $4f3aa993cc57516e$var$pk;
                var l = $4f3aa993cc57516e$var$qk;
                $4f3aa993cc57516e$var$pk = g;
                if (($4f3aa993cc57516e$var$qk = k) && !l) for($4f3aa993cc57516e$var$U = e; null !== $4f3aa993cc57516e$var$U;)g = $4f3aa993cc57516e$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4f3aa993cc57516e$var$Uk(e) : null !== k ? (k.return = g, $4f3aa993cc57516e$var$U = k) : $4f3aa993cc57516e$var$Uk(e);
                for(; null !== f;)$4f3aa993cc57516e$var$U = f, $4f3aa993cc57516e$var$Tk(f, b, c), f = f.sibling;
                $4f3aa993cc57516e$var$U = e;
                $4f3aa993cc57516e$var$pk = h;
                $4f3aa993cc57516e$var$qk = l;
            }
            $4f3aa993cc57516e$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4f3aa993cc57516e$var$U = f) : $4f3aa993cc57516e$var$Vk(a, b, c);
    }
}
function $4f3aa993cc57516e$var$Vk(a) {
    for(; null !== $4f3aa993cc57516e$var$U;){
        var b = $4f3aa993cc57516e$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$4f3aa993cc57516e$var$qk) {
                            if (b.mode & 2) try {
                                $4f3aa993cc57516e$var$cj(), $4f3aa993cc57516e$var$Ak(5, b);
                            } finally{
                                $4f3aa993cc57516e$var$aj(b);
                            }
                            else $4f3aa993cc57516e$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4f3aa993cc57516e$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $4f3aa993cc57516e$var$cj(), d.componentDidMount();
                                } finally{
                                    $4f3aa993cc57516e$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4f3aa993cc57516e$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $4f3aa993cc57516e$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $4f3aa993cc57516e$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $4f3aa993cc57516e$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $4f3aa993cc57516e$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $4f3aa993cc57516e$var$Ui;
                        c = null === c ? "mount" : "update";
                        $4f3aa993cc57516e$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $4f3aa993cc57516e$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $4f3aa993cc57516e$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4f3aa993cc57516e$var$p(163));
                }
                $4f3aa993cc57516e$var$qk || b.flags & 512 && $4f3aa993cc57516e$var$Bk(b);
            } catch (v) {
                $4f3aa993cc57516e$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $4f3aa993cc57516e$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $4f3aa993cc57516e$var$U = k;
            break;
        }
        $4f3aa993cc57516e$var$U = b.return;
    }
}
function $4f3aa993cc57516e$var$Rk(a) {
    for(; null !== $4f3aa993cc57516e$var$U;){
        var b = $4f3aa993cc57516e$var$U;
        if (b === a) {
            $4f3aa993cc57516e$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4f3aa993cc57516e$var$U = c;
            break;
        }
        $4f3aa993cc57516e$var$U = b.return;
    }
}
function $4f3aa993cc57516e$var$Uk(a) {
    for(; null !== $4f3aa993cc57516e$var$U;){
        var b = $4f3aa993cc57516e$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $4f3aa993cc57516e$var$cj();
                        var c = b.return;
                        try {
                            $4f3aa993cc57516e$var$Ak(4, b);
                        } catch (l) {
                            $4f3aa993cc57516e$var$W(b, c, l);
                        }
                    } finally{
                        $4f3aa993cc57516e$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $4f3aa993cc57516e$var$Ak(4, b);
                        } catch (l) {
                            $4f3aa993cc57516e$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $4f3aa993cc57516e$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $4f3aa993cc57516e$var$Bk(b);
                    } catch (l) {
                        $4f3aa993cc57516e$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $4f3aa993cc57516e$var$Bk(b);
                    } catch (l) {
                        $4f3aa993cc57516e$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $4f3aa993cc57516e$var$W(b, b.return, l);
        }
        if (b === a) {
            $4f3aa993cc57516e$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $4f3aa993cc57516e$var$U = k;
            break;
        }
        $4f3aa993cc57516e$var$U = b.return;
    }
}
var $4f3aa993cc57516e$var$Xk = Math.ceil, $4f3aa993cc57516e$var$Yk = $4f3aa993cc57516e$var$va.ReactCurrentDispatcher, $4f3aa993cc57516e$var$Zk = $4f3aa993cc57516e$var$va.ReactCurrentOwner, $4f3aa993cc57516e$var$$k = $4f3aa993cc57516e$var$va.ReactCurrentBatchConfig, $4f3aa993cc57516e$var$K = 0, $4f3aa993cc57516e$var$Q = null, $4f3aa993cc57516e$var$Y = null, $4f3aa993cc57516e$var$Z = 0, $4f3aa993cc57516e$var$Jj = 0, $4f3aa993cc57516e$var$Ij = $4f3aa993cc57516e$var$hg(0), $4f3aa993cc57516e$var$T = 0, $4f3aa993cc57516e$var$al = null, $4f3aa993cc57516e$var$Fh = 0, $4f3aa993cc57516e$var$bl = 0, $4f3aa993cc57516e$var$cl = 0, $4f3aa993cc57516e$var$dl = null, $4f3aa993cc57516e$var$el = null, $4f3aa993cc57516e$var$Qk = 0, $4f3aa993cc57516e$var$mk = Infinity, $4f3aa993cc57516e$var$fl = null, $4f3aa993cc57516e$var$qj = !1, $4f3aa993cc57516e$var$rj = null, $4f3aa993cc57516e$var$tj = null, $4f3aa993cc57516e$var$gl = !1, $4f3aa993cc57516e$var$hl = null, $4f3aa993cc57516e$var$il = 0, $4f3aa993cc57516e$var$jl = [], $4f3aa993cc57516e$var$kl = 0, $4f3aa993cc57516e$var$ll = null, $4f3aa993cc57516e$var$ml = -1, $4f3aa993cc57516e$var$nl = 0;
function $4f3aa993cc57516e$var$Ri() {
    return 0 !== ($4f3aa993cc57516e$var$K & 6) ? $4f3aa993cc57516e$var$A() : -1 !== $4f3aa993cc57516e$var$ml ? $4f3aa993cc57516e$var$ml : $4f3aa993cc57516e$var$ml = $4f3aa993cc57516e$var$A();
}
function $4f3aa993cc57516e$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4f3aa993cc57516e$var$K & 2) && 0 !== $4f3aa993cc57516e$var$Z) return $4f3aa993cc57516e$var$Z & -$4f3aa993cc57516e$var$Z;
    if (null !== $4f3aa993cc57516e$var$Yg.transition) return 0 === $4f3aa993cc57516e$var$nl && ($4f3aa993cc57516e$var$nl = $4f3aa993cc57516e$var$Kc()), $4f3aa993cc57516e$var$nl;
    a = $4f3aa993cc57516e$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4f3aa993cc57516e$var$xd(a.type);
    return a;
}
function $4f3aa993cc57516e$var$ui(a, b, c, d) {
    if (50 < $4f3aa993cc57516e$var$kl) throw $4f3aa993cc57516e$var$kl = 0, $4f3aa993cc57516e$var$ll = null, Error($4f3aa993cc57516e$var$p(185));
    $4f3aa993cc57516e$var$Mc(a, c, d);
    if (0 === ($4f3aa993cc57516e$var$K & 2) || a !== $4f3aa993cc57516e$var$Q) $4f3aa993cc57516e$var$mc && $4f3aa993cc57516e$var$Pc(a, b, c), a === $4f3aa993cc57516e$var$Q && (0 === ($4f3aa993cc57516e$var$K & 2) && ($4f3aa993cc57516e$var$bl |= c), 4 === $4f3aa993cc57516e$var$T && $4f3aa993cc57516e$var$ol(a, $4f3aa993cc57516e$var$Z)), $4f3aa993cc57516e$var$pl(a, d), 1 === c && 0 === $4f3aa993cc57516e$var$K && 0 === (b.mode & 1) && ($4f3aa993cc57516e$var$mk = $4f3aa993cc57516e$var$A() + 500, $4f3aa993cc57516e$var$tg && $4f3aa993cc57516e$var$xg());
}
function $4f3aa993cc57516e$var$pl(a, b) {
    var c = a.callbackNode;
    $4f3aa993cc57516e$var$Ic(a, b);
    var d = $4f3aa993cc57516e$var$Gc(a, a === $4f3aa993cc57516e$var$Q ? $4f3aa993cc57516e$var$Z : 0);
    if (0 === d) null !== c && $4f3aa993cc57516e$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4f3aa993cc57516e$var$bc(c);
        if (1 === b) 0 === a.tag ? $4f3aa993cc57516e$var$wg($4f3aa993cc57516e$var$ql.bind(null, a)) : $4f3aa993cc57516e$var$vg($4f3aa993cc57516e$var$ql.bind(null, a)), $4f3aa993cc57516e$var$Xf(function() {
            0 === ($4f3aa993cc57516e$var$K & 6) && $4f3aa993cc57516e$var$xg();
        }), c = null;
        else {
            switch($4f3aa993cc57516e$var$Rc(d)){
                case 1:
                    c = $4f3aa993cc57516e$var$fc;
                    break;
                case 4:
                    c = $4f3aa993cc57516e$var$gc;
                    break;
                case 16:
                    c = $4f3aa993cc57516e$var$hc;
                    break;
                case 536870912:
                    c = $4f3aa993cc57516e$var$jc;
                    break;
                default:
                    c = $4f3aa993cc57516e$var$hc;
            }
            c = $4f3aa993cc57516e$var$rl(c, $4f3aa993cc57516e$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4f3aa993cc57516e$var$sl(a, b) {
    $4f3aa993cc57516e$var$Zi = $4f3aa993cc57516e$var$Yi = !1;
    $4f3aa993cc57516e$var$ml = -1;
    $4f3aa993cc57516e$var$nl = 0;
    if (0 !== ($4f3aa993cc57516e$var$K & 6)) throw Error($4f3aa993cc57516e$var$p(327));
    var c = a.callbackNode;
    if ($4f3aa993cc57516e$var$tl() && a.callbackNode !== c) return null;
    var d = $4f3aa993cc57516e$var$Gc(a, a === $4f3aa993cc57516e$var$Q ? $4f3aa993cc57516e$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4f3aa993cc57516e$var$ul(a, d);
    else {
        b = d;
        var e = $4f3aa993cc57516e$var$K;
        $4f3aa993cc57516e$var$K |= 2;
        var f = $4f3aa993cc57516e$var$vl();
        if ($4f3aa993cc57516e$var$Q !== a || $4f3aa993cc57516e$var$Z !== b) {
            if ($4f3aa993cc57516e$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($4f3aa993cc57516e$var$wj(a, $4f3aa993cc57516e$var$Z), g.clear());
                $4f3aa993cc57516e$var$Qc(a, b);
            }
            $4f3aa993cc57516e$var$fl = null;
            $4f3aa993cc57516e$var$mk = $4f3aa993cc57516e$var$A() + 500;
            $4f3aa993cc57516e$var$wl(a, b);
        }
        $4f3aa993cc57516e$var$wc(b);
        for(;;)try {
            $4f3aa993cc57516e$var$xl();
            break;
        } catch (h) {
            $4f3aa993cc57516e$var$yl(a, h);
        }
        $4f3aa993cc57516e$var$nh();
        $4f3aa993cc57516e$var$Yk.current = f;
        $4f3aa993cc57516e$var$K = e;
        null !== $4f3aa993cc57516e$var$Y ? (null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markRenderYielded && $4f3aa993cc57516e$var$B.markRenderYielded(), b = 0) : ($4f3aa993cc57516e$var$xc(), $4f3aa993cc57516e$var$Q = null, $4f3aa993cc57516e$var$Z = 0, b = $4f3aa993cc57516e$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4f3aa993cc57516e$var$Jc(a), 0 !== e && (d = e, b = $4f3aa993cc57516e$var$zl(a, e)));
        if (1 === b) throw c = $4f3aa993cc57516e$var$al, $4f3aa993cc57516e$var$wl(a, 0), $4f3aa993cc57516e$var$ol(a, d), $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A()), c;
        if (6 === b) $4f3aa993cc57516e$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4f3aa993cc57516e$var$Al(e) && (b = $4f3aa993cc57516e$var$ul(a, d), 2 === b && (f = $4f3aa993cc57516e$var$Jc(a), 0 !== f && (d = f, b = $4f3aa993cc57516e$var$zl(a, f))), 1 === b)) throw c = $4f3aa993cc57516e$var$al, $4f3aa993cc57516e$var$wl(a, 0), $4f3aa993cc57516e$var$ol(a, d), $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4f3aa993cc57516e$var$p(345));
                case 2:
                    $4f3aa993cc57516e$var$Cl(a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl);
                    break;
                case 3:
                    $4f3aa993cc57516e$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $4f3aa993cc57516e$var$Qk + 500 - $4f3aa993cc57516e$var$A(), 10 < b)) {
                        if (0 !== $4f3aa993cc57516e$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4f3aa993cc57516e$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4f3aa993cc57516e$var$Tf($4f3aa993cc57516e$var$Cl.bind(null, a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl), b);
                        break;
                    }
                    $4f3aa993cc57516e$var$Cl(a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl);
                    break;
                case 4:
                    $4f3aa993cc57516e$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $4f3aa993cc57516e$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $4f3aa993cc57516e$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4f3aa993cc57516e$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4f3aa993cc57516e$var$Tf($4f3aa993cc57516e$var$Cl.bind(null, a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl), d);
                        break;
                    }
                    $4f3aa993cc57516e$var$Cl(a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl);
                    break;
                case 5:
                    $4f3aa993cc57516e$var$Cl(a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl);
                    break;
                default:
                    throw Error($4f3aa993cc57516e$var$p(329));
            }
        }
    }
    $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A());
    return a.callbackNode === c ? $4f3aa993cc57516e$var$sl.bind(null, a) : null;
}
function $4f3aa993cc57516e$var$zl(a, b) {
    var c = $4f3aa993cc57516e$var$dl;
    a.current.memoizedState.isDehydrated && ($4f3aa993cc57516e$var$wl(a, b).flags |= 256);
    a = $4f3aa993cc57516e$var$ul(a, b);
    2 !== a && (b = $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$el = c, null !== b && $4f3aa993cc57516e$var$lk(b));
    return a;
}
function $4f3aa993cc57516e$var$lk(a) {
    null === $4f3aa993cc57516e$var$el ? $4f3aa993cc57516e$var$el = a : $4f3aa993cc57516e$var$el.push.apply($4f3aa993cc57516e$var$el, a);
}
function $4f3aa993cc57516e$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4f3aa993cc57516e$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4f3aa993cc57516e$var$ol(a, b) {
    b &= ~$4f3aa993cc57516e$var$cl;
    b &= ~$4f3aa993cc57516e$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4f3aa993cc57516e$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4f3aa993cc57516e$var$ql(a) {
    $4f3aa993cc57516e$var$Yi = $4f3aa993cc57516e$var$Zi;
    $4f3aa993cc57516e$var$Zi = !1;
    if (0 !== ($4f3aa993cc57516e$var$K & 6)) throw Error($4f3aa993cc57516e$var$p(327));
    $4f3aa993cc57516e$var$tl();
    var b = $4f3aa993cc57516e$var$Gc(a, 0);
    if (0 === (b & 1)) return $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A()), null;
    var c = $4f3aa993cc57516e$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4f3aa993cc57516e$var$Jc(a);
        0 !== d && (b = d, c = $4f3aa993cc57516e$var$zl(a, d));
    }
    if (1 === c) throw c = $4f3aa993cc57516e$var$al, $4f3aa993cc57516e$var$wl(a, 0), $4f3aa993cc57516e$var$ol(a, b), $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A()), c;
    if (6 === c) throw Error($4f3aa993cc57516e$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4f3aa993cc57516e$var$Cl(a, $4f3aa993cc57516e$var$el, $4f3aa993cc57516e$var$fl);
    $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A());
    return null;
}
function $4f3aa993cc57516e$var$Dl(a, b) {
    var c = $4f3aa993cc57516e$var$K;
    $4f3aa993cc57516e$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4f3aa993cc57516e$var$K = c, 0 === $4f3aa993cc57516e$var$K && ($4f3aa993cc57516e$var$mk = $4f3aa993cc57516e$var$A() + 500, $4f3aa993cc57516e$var$tg && $4f3aa993cc57516e$var$xg());
    }
}
function $4f3aa993cc57516e$var$El(a) {
    null !== $4f3aa993cc57516e$var$hl && 0 === $4f3aa993cc57516e$var$hl.tag && 0 === ($4f3aa993cc57516e$var$K & 6) && $4f3aa993cc57516e$var$tl();
    var b = $4f3aa993cc57516e$var$K;
    $4f3aa993cc57516e$var$K |= 1;
    var c = $4f3aa993cc57516e$var$$k.transition, d = $4f3aa993cc57516e$var$E;
    try {
        if ($4f3aa993cc57516e$var$$k.transition = null, $4f3aa993cc57516e$var$E = 1, a) return a();
    } finally{
        $4f3aa993cc57516e$var$E = d, $4f3aa993cc57516e$var$$k.transition = c, $4f3aa993cc57516e$var$K = b, 0 === ($4f3aa993cc57516e$var$K & 6) && $4f3aa993cc57516e$var$xg();
    }
}
function $4f3aa993cc57516e$var$nk() {
    $4f3aa993cc57516e$var$Jj = $4f3aa993cc57516e$var$Ij.current;
    $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$Ij);
}
function $4f3aa993cc57516e$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4f3aa993cc57516e$var$Uf(c));
    if (null !== $4f3aa993cc57516e$var$Y) for(c = $4f3aa993cc57516e$var$Y.return; null !== c;){
        var d = c;
        $4f3aa993cc57516e$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4f3aa993cc57516e$var$ng();
                break;
            case 3:
                $4f3aa993cc57516e$var$Nh();
                $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$jg);
                $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$I);
                $4f3aa993cc57516e$var$Sh();
                break;
            case 5:
                $4f3aa993cc57516e$var$Ph(d);
                break;
            case 4:
                $4f3aa993cc57516e$var$Nh();
                break;
            case 13:
                $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L);
                break;
            case 19:
                $4f3aa993cc57516e$var$G($4f3aa993cc57516e$var$L);
                break;
            case 10:
                $4f3aa993cc57516e$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $4f3aa993cc57516e$var$nk();
        }
        c = c.return;
    }
    $4f3aa993cc57516e$var$Q = a;
    $4f3aa993cc57516e$var$Y = a = $4f3aa993cc57516e$var$ch(a.current, null);
    $4f3aa993cc57516e$var$Z = $4f3aa993cc57516e$var$Jj = b;
    $4f3aa993cc57516e$var$T = 0;
    $4f3aa993cc57516e$var$al = null;
    $4f3aa993cc57516e$var$cl = $4f3aa993cc57516e$var$bl = $4f3aa993cc57516e$var$Fh = 0;
    $4f3aa993cc57516e$var$el = $4f3aa993cc57516e$var$dl = null;
    if (null !== $4f3aa993cc57516e$var$th) {
        for(b = 0; b < $4f3aa993cc57516e$var$th.length; b++)if (c = $4f3aa993cc57516e$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4f3aa993cc57516e$var$th = null;
    }
    return a;
}
function $4f3aa993cc57516e$var$yl(a, b) {
    do {
        var c = $4f3aa993cc57516e$var$Y;
        try {
            $4f3aa993cc57516e$var$nh();
            $4f3aa993cc57516e$var$Th.current = $4f3aa993cc57516e$var$ei;
            if ($4f3aa993cc57516e$var$Wh) {
                for(var d = $4f3aa993cc57516e$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4f3aa993cc57516e$var$Wh = !1;
            }
            $4f3aa993cc57516e$var$Vh = 0;
            $4f3aa993cc57516e$var$O = $4f3aa993cc57516e$var$N = $4f3aa993cc57516e$var$M = null;
            $4f3aa993cc57516e$var$Xh = !1;
            $4f3aa993cc57516e$var$Yh = 0;
            $4f3aa993cc57516e$var$Zk.current = null;
            if (null === c || null === c.return) {
                $4f3aa993cc57516e$var$T = 1;
                $4f3aa993cc57516e$var$al = b;
                $4f3aa993cc57516e$var$Y = null;
                break;
            }
            c.mode & 2 && $4f3aa993cc57516e$var$$i(c, !0);
            $4f3aa993cc57516e$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentSuspended && $4f3aa993cc57516e$var$B.markComponentSuspended(c, f, $4f3aa993cc57516e$var$Z);
            } else null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markComponentErrored && $4f3aa993cc57516e$var$B.markComponentErrored(c, b, $4f3aa993cc57516e$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $4f3aa993cc57516e$var$Z;
                k.flags |= 32768;
                $4f3aa993cc57516e$var$mc && $4f3aa993cc57516e$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $4f3aa993cc57516e$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $4f3aa993cc57516e$var$yj(z, h, k, g, b);
                        z.mode & 1 && $4f3aa993cc57516e$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4f3aa993cc57516e$var$uj(g, l, b);
                            $4f3aa993cc57516e$var$Zj();
                            break a;
                        }
                        f = Error($4f3aa993cc57516e$var$p(426));
                    }
                } else if ($4f3aa993cc57516e$var$J && k.mode & 1) {
                    var C = $4f3aa993cc57516e$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $4f3aa993cc57516e$var$yj(C, h, k, g, b);
                        $4f3aa993cc57516e$var$Xg($4f3aa993cc57516e$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $4f3aa993cc57516e$var$lj(f, k);
                4 !== $4f3aa993cc57516e$var$T && ($4f3aa993cc57516e$var$T = 2);
                null === $4f3aa993cc57516e$var$dl ? $4f3aa993cc57516e$var$dl = [
                    g
                ] : $4f3aa993cc57516e$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $4f3aa993cc57516e$var$pj(g, f, b);
                            $4f3aa993cc57516e$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $4f3aa993cc57516e$var$tj || !$4f3aa993cc57516e$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $4f3aa993cc57516e$var$sj(g, k, b);
                                $4f3aa993cc57516e$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $4f3aa993cc57516e$var$Fl(c);
        } catch (ca) {
            b = ca;
            $4f3aa993cc57516e$var$Y === c && null !== c && ($4f3aa993cc57516e$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4f3aa993cc57516e$var$vl() {
    var a = $4f3aa993cc57516e$var$Yk.current;
    $4f3aa993cc57516e$var$Yk.current = $4f3aa993cc57516e$var$ei;
    return null === a ? $4f3aa993cc57516e$var$ei : a;
}
function $4f3aa993cc57516e$var$Zj() {
    if (0 === $4f3aa993cc57516e$var$T || 3 === $4f3aa993cc57516e$var$T || 2 === $4f3aa993cc57516e$var$T) $4f3aa993cc57516e$var$T = 4;
    null === $4f3aa993cc57516e$var$Q || 0 === ($4f3aa993cc57516e$var$Fh & 268435455) && 0 === ($4f3aa993cc57516e$var$bl & 268435455) || $4f3aa993cc57516e$var$ol($4f3aa993cc57516e$var$Q, $4f3aa993cc57516e$var$Z);
}
function $4f3aa993cc57516e$var$ul(a, b) {
    var c = $4f3aa993cc57516e$var$K;
    $4f3aa993cc57516e$var$K |= 2;
    var d = $4f3aa993cc57516e$var$vl();
    if ($4f3aa993cc57516e$var$Q !== a || $4f3aa993cc57516e$var$Z !== b) {
        if ($4f3aa993cc57516e$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($4f3aa993cc57516e$var$wj(a, $4f3aa993cc57516e$var$Z), e.clear());
            $4f3aa993cc57516e$var$Qc(a, b);
        }
        $4f3aa993cc57516e$var$fl = null;
        $4f3aa993cc57516e$var$wl(a, b);
    }
    $4f3aa993cc57516e$var$wc(b);
    for(;;)try {
        $4f3aa993cc57516e$var$Gl();
        break;
    } catch (f) {
        $4f3aa993cc57516e$var$yl(a, f);
    }
    $4f3aa993cc57516e$var$nh();
    $4f3aa993cc57516e$var$K = c;
    $4f3aa993cc57516e$var$Yk.current = d;
    if (null !== $4f3aa993cc57516e$var$Y) throw Error($4f3aa993cc57516e$var$p(261));
    $4f3aa993cc57516e$var$xc();
    $4f3aa993cc57516e$var$Q = null;
    $4f3aa993cc57516e$var$Z = 0;
    return $4f3aa993cc57516e$var$T;
}
function $4f3aa993cc57516e$var$Gl() {
    for(; null !== $4f3aa993cc57516e$var$Y;)$4f3aa993cc57516e$var$Hl($4f3aa993cc57516e$var$Y);
}
function $4f3aa993cc57516e$var$xl() {
    for(; null !== $4f3aa993cc57516e$var$Y && !$4f3aa993cc57516e$var$cc();)$4f3aa993cc57516e$var$Hl($4f3aa993cc57516e$var$Y);
}
function $4f3aa993cc57516e$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($4f3aa993cc57516e$var$Wi = $4f3aa993cc57516e$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $4f3aa993cc57516e$var$Ti()), b = $4f3aa993cc57516e$var$Il(b, a, $4f3aa993cc57516e$var$Jj), $4f3aa993cc57516e$var$$i(a, !0)) : b = $4f3aa993cc57516e$var$Il(b, a, $4f3aa993cc57516e$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4f3aa993cc57516e$var$Fl(a) : $4f3aa993cc57516e$var$Y = b;
    $4f3aa993cc57516e$var$Zk.current = null;
}
function $4f3aa993cc57516e$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $4f3aa993cc57516e$var$kk(c, b, $4f3aa993cc57516e$var$Jj);
            else {
                var d = b;
                $4f3aa993cc57516e$var$Wi = $4f3aa993cc57516e$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $4f3aa993cc57516e$var$Ti());
                c = $4f3aa993cc57516e$var$kk(c, b, $4f3aa993cc57516e$var$Jj);
                $4f3aa993cc57516e$var$$i(b, !1);
            }
            if (null !== c) {
                $4f3aa993cc57516e$var$Y = c;
                return;
            }
        } else {
            c = $4f3aa993cc57516e$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4f3aa993cc57516e$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $4f3aa993cc57516e$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4f3aa993cc57516e$var$T = 6;
                $4f3aa993cc57516e$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4f3aa993cc57516e$var$Y = b;
            return;
        }
        $4f3aa993cc57516e$var$Y = b = a;
    }while (null !== b);
    0 === $4f3aa993cc57516e$var$T && ($4f3aa993cc57516e$var$T = 5);
}
function $4f3aa993cc57516e$var$Cl(a, b, c) {
    var d = $4f3aa993cc57516e$var$E, e = $4f3aa993cc57516e$var$$k.transition;
    try {
        $4f3aa993cc57516e$var$$k.transition = null, $4f3aa993cc57516e$var$E = 1, $4f3aa993cc57516e$var$Jl(a, b, c, d);
    } finally{
        $4f3aa993cc57516e$var$$k.transition = e, $4f3aa993cc57516e$var$E = d;
    }
    return null;
}
function $4f3aa993cc57516e$var$Jl(a, b, c, d) {
    do $4f3aa993cc57516e$var$tl();
    while (null !== $4f3aa993cc57516e$var$hl);
    if (0 !== ($4f3aa993cc57516e$var$K & 6)) throw Error($4f3aa993cc57516e$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markCommitStarted && $4f3aa993cc57516e$var$B.markCommitStarted(e);
    if (null === c) return $4f3aa993cc57516e$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4f3aa993cc57516e$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4f3aa993cc57516e$var$Nc(a, f);
    a === $4f3aa993cc57516e$var$Q && ($4f3aa993cc57516e$var$Y = $4f3aa993cc57516e$var$Q = null, $4f3aa993cc57516e$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4f3aa993cc57516e$var$gl || ($4f3aa993cc57516e$var$gl = !0, $4f3aa993cc57516e$var$rl($4f3aa993cc57516e$var$hc, function() {
        $4f3aa993cc57516e$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4f3aa993cc57516e$var$$k.transition;
        $4f3aa993cc57516e$var$$k.transition = null;
        var g = $4f3aa993cc57516e$var$E;
        $4f3aa993cc57516e$var$E = 1;
        var h = $4f3aa993cc57516e$var$K;
        $4f3aa993cc57516e$var$K |= 4;
        $4f3aa993cc57516e$var$Zk.current = null;
        $4f3aa993cc57516e$var$yk(a, c);
        $4f3aa993cc57516e$var$Ui = $4f3aa993cc57516e$var$Ti();
        $4f3aa993cc57516e$var$Mk(a, c, e);
        $4f3aa993cc57516e$var$bf($4f3aa993cc57516e$var$Rf);
        $4f3aa993cc57516e$var$rd = !!$4f3aa993cc57516e$var$Qf;
        $4f3aa993cc57516e$var$Rf = $4f3aa993cc57516e$var$Qf = null;
        a.current = c;
        null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markLayoutEffectsStarted && $4f3aa993cc57516e$var$B.markLayoutEffectsStarted(e);
        $4f3aa993cc57516e$var$Sk(c, a, e);
        null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markLayoutEffectsStopped && $4f3aa993cc57516e$var$B.markLayoutEffectsStopped();
        $4f3aa993cc57516e$var$dc();
        $4f3aa993cc57516e$var$K = h;
        $4f3aa993cc57516e$var$E = g;
        $4f3aa993cc57516e$var$$k.transition = f;
    } else a.current = c, $4f3aa993cc57516e$var$Ui = $4f3aa993cc57516e$var$Ti();
    $4f3aa993cc57516e$var$gl && ($4f3aa993cc57516e$var$gl = !1, $4f3aa993cc57516e$var$hl = a, $4f3aa993cc57516e$var$il = e);
    f = a.pendingLanes;
    0 === f && ($4f3aa993cc57516e$var$tj = null);
    $4f3aa993cc57516e$var$nc(c.stateNode, d);
    $4f3aa993cc57516e$var$mc && a.memoizedUpdaters.clear();
    $4f3aa993cc57516e$var$pl(a, $4f3aa993cc57516e$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4f3aa993cc57516e$var$qj) throw $4f3aa993cc57516e$var$qj = !1, a = $4f3aa993cc57516e$var$rj, $4f3aa993cc57516e$var$rj = null, a;
    0 !== ($4f3aa993cc57516e$var$il & 1) && 0 !== a.tag && $4f3aa993cc57516e$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($4f3aa993cc57516e$var$Zi = !0, a === $4f3aa993cc57516e$var$ll ? $4f3aa993cc57516e$var$kl++ : ($4f3aa993cc57516e$var$kl = 0, $4f3aa993cc57516e$var$ll = a)) : $4f3aa993cc57516e$var$kl = 0;
    $4f3aa993cc57516e$var$xg();
    $4f3aa993cc57516e$var$rc();
    return null;
}
function $4f3aa993cc57516e$var$tl() {
    if (null !== $4f3aa993cc57516e$var$hl) {
        var a = $4f3aa993cc57516e$var$Rc($4f3aa993cc57516e$var$il), b = $4f3aa993cc57516e$var$$k.transition, c = $4f3aa993cc57516e$var$E;
        try {
            $4f3aa993cc57516e$var$$k.transition = null;
            $4f3aa993cc57516e$var$E = 16 > a ? 16 : a;
            if (null === $4f3aa993cc57516e$var$hl) var d = !1;
            else {
                a = $4f3aa993cc57516e$var$hl;
                var e = $4f3aa993cc57516e$var$il;
                $4f3aa993cc57516e$var$hl = null;
                $4f3aa993cc57516e$var$il = 0;
                if (0 !== ($4f3aa993cc57516e$var$K & 6)) throw Error($4f3aa993cc57516e$var$p(331));
                null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markPassiveEffectsStarted && $4f3aa993cc57516e$var$B.markPassiveEffectsStarted(e);
                e = $4f3aa993cc57516e$var$K;
                $4f3aa993cc57516e$var$K |= 4;
                for($4f3aa993cc57516e$var$U = a.current; null !== $4f3aa993cc57516e$var$U;){
                    var f = $4f3aa993cc57516e$var$U, g = f.child;
                    if (0 !== ($4f3aa993cc57516e$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4f3aa993cc57516e$var$U = l; null !== $4f3aa993cc57516e$var$U;){
                                    var n = $4f3aa993cc57516e$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($4f3aa993cc57516e$var$Xi = $4f3aa993cc57516e$var$Ti(), $4f3aa993cc57516e$var$zk(8, q, f), $4f3aa993cc57516e$var$bj(q)) : $4f3aa993cc57516e$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $4f3aa993cc57516e$var$U = r;
                                    else for(; null !== $4f3aa993cc57516e$var$U;){
                                        n = $4f3aa993cc57516e$var$U;
                                        var z = n.sibling, m = n.return;
                                        $4f3aa993cc57516e$var$Ck(n);
                                        if (n === l) {
                                            $4f3aa993cc57516e$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $4f3aa993cc57516e$var$U = z;
                                            break;
                                        }
                                        $4f3aa993cc57516e$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $4f3aa993cc57516e$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4f3aa993cc57516e$var$U = g;
                    else b: for(; null !== $4f3aa993cc57516e$var$U;){
                        f = $4f3aa993cc57516e$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($4f3aa993cc57516e$var$Xi = $4f3aa993cc57516e$var$Ti(), $4f3aa993cc57516e$var$zk(9, k, k.return), $4f3aa993cc57516e$var$bj(k)) : $4f3aa993cc57516e$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $4f3aa993cc57516e$var$U = y;
                            break b;
                        }
                        $4f3aa993cc57516e$var$U = f.return;
                    }
                }
                var v = a.current;
                for($4f3aa993cc57516e$var$U = v; null !== $4f3aa993cc57516e$var$U;){
                    g = $4f3aa993cc57516e$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $4f3aa993cc57516e$var$U = D;
                    else b: for(g = v; null !== $4f3aa993cc57516e$var$U;){
                        h = $4f3aa993cc57516e$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $4f3aa993cc57516e$var$Xi = $4f3aa993cc57516e$var$Ti();
                                        try {
                                            $4f3aa993cc57516e$var$Ak(9, l);
                                        } finally{
                                            $4f3aa993cc57516e$var$bj(l);
                                        }
                                    } else $4f3aa993cc57516e$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $4f3aa993cc57516e$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $4f3aa993cc57516e$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $4f3aa993cc57516e$var$U = ca;
                            break b;
                        }
                        $4f3aa993cc57516e$var$U = h.return;
                    }
                }
                v = $4f3aa993cc57516e$var$jl;
                $4f3aa993cc57516e$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $4f3aa993cc57516e$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $4f3aa993cc57516e$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markPassiveEffectsStopped && $4f3aa993cc57516e$var$B.markPassiveEffectsStopped();
                $4f3aa993cc57516e$var$K = e;
                $4f3aa993cc57516e$var$xg();
                if ($4f3aa993cc57516e$var$lc && "function" === typeof $4f3aa993cc57516e$var$lc.onPostCommitFiberRoot) try {
                    $4f3aa993cc57516e$var$lc.onPostCommitFiberRoot($4f3aa993cc57516e$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $4f3aa993cc57516e$var$E = c, $4f3aa993cc57516e$var$$k.transition = b;
        }
    }
    return !1;
}
function $4f3aa993cc57516e$var$Wk(a) {
    $4f3aa993cc57516e$var$jl.push(a);
    $4f3aa993cc57516e$var$gl || ($4f3aa993cc57516e$var$gl = !0, $4f3aa993cc57516e$var$rl($4f3aa993cc57516e$var$hc, function() {
        $4f3aa993cc57516e$var$tl();
        return null;
    }));
}
function $4f3aa993cc57516e$var$Kl(a, b, c) {
    b = $4f3aa993cc57516e$var$lj(c, b);
    b = $4f3aa993cc57516e$var$pj(a, b, 1);
    a = $4f3aa993cc57516e$var$Bh(a, b, 1);
    b = $4f3aa993cc57516e$var$Ri();
    null !== a && ($4f3aa993cc57516e$var$Mc(a, 1, b), $4f3aa993cc57516e$var$pl(a, b));
}
function $4f3aa993cc57516e$var$W(a, b, c) {
    if (3 === a.tag) $4f3aa993cc57516e$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4f3aa993cc57516e$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4f3aa993cc57516e$var$tj || !$4f3aa993cc57516e$var$tj.has(d))) {
                a = $4f3aa993cc57516e$var$lj(c, a);
                a = $4f3aa993cc57516e$var$sj(b, a, 1);
                b = $4f3aa993cc57516e$var$Bh(b, a, 1);
                a = $4f3aa993cc57516e$var$Ri();
                null !== b && ($4f3aa993cc57516e$var$Mc(b, 1, a), $4f3aa993cc57516e$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4f3aa993cc57516e$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4f3aa993cc57516e$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $4f3aa993cc57516e$var$Q === a && ($4f3aa993cc57516e$var$Z & c) === c && (4 === $4f3aa993cc57516e$var$T || 3 === $4f3aa993cc57516e$var$T && ($4f3aa993cc57516e$var$Z & 130023424) === $4f3aa993cc57516e$var$Z && 500 > $4f3aa993cc57516e$var$A() - $4f3aa993cc57516e$var$Qk ? $4f3aa993cc57516e$var$wl(a, 0) : $4f3aa993cc57516e$var$cl |= c);
    $4f3aa993cc57516e$var$pl(a, b);
}
function $4f3aa993cc57516e$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4f3aa993cc57516e$var$Ec, $4f3aa993cc57516e$var$Ec <<= 1, 0 === ($4f3aa993cc57516e$var$Ec & 130023424) && ($4f3aa993cc57516e$var$Ec = 4194304)));
    var c = $4f3aa993cc57516e$var$Ri();
    a = $4f3aa993cc57516e$var$wh(a, b);
    null !== a && ($4f3aa993cc57516e$var$Mc(a, b, c), $4f3aa993cc57516e$var$pl(a, c));
}
function $4f3aa993cc57516e$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4f3aa993cc57516e$var$Ll(a, c);
}
function $4f3aa993cc57516e$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4f3aa993cc57516e$var$p(314));
    }
    null !== d && d.delete(b);
    $4f3aa993cc57516e$var$Ll(a, c);
}
var $4f3aa993cc57516e$var$Il;
$4f3aa993cc57516e$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4f3aa993cc57516e$var$jg.current) $4f3aa993cc57516e$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4f3aa993cc57516e$var$rh = !1, $4f3aa993cc57516e$var$ek(a, b, c);
            $4f3aa993cc57516e$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4f3aa993cc57516e$var$rh = !1, $4f3aa993cc57516e$var$J && 0 !== (b.flags & 1048576) && $4f3aa993cc57516e$var$Ig(b, $4f3aa993cc57516e$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4f3aa993cc57516e$var$Mj(a, b);
            a = b.pendingProps;
            var e = $4f3aa993cc57516e$var$lg(b, $4f3aa993cc57516e$var$I.current);
            $4f3aa993cc57516e$var$qh(b, c);
            $4f3aa993cc57516e$var$sc(b);
            e = $4f3aa993cc57516e$var$ai(null, b, d, a, e, c);
            var f = $4f3aa993cc57516e$var$fi();
            $4f3aa993cc57516e$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4f3aa993cc57516e$var$mg(d) ? (f = !0, $4f3aa993cc57516e$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4f3aa993cc57516e$var$yh(b), e.updater = $4f3aa993cc57516e$var$gj, b.stateNode = e, e._reactInternals = b, $4f3aa993cc57516e$var$kj(b, d, a, c), b = $4f3aa993cc57516e$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $4f3aa993cc57516e$var$J && f && $4f3aa993cc57516e$var$Jg(b), $4f3aa993cc57516e$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4f3aa993cc57516e$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4f3aa993cc57516e$var$Ml(d);
                a = $4f3aa993cc57516e$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $4f3aa993cc57516e$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4f3aa993cc57516e$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4f3aa993cc57516e$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4f3aa993cc57516e$var$Dj(null, b, d, $4f3aa993cc57516e$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($4f3aa993cc57516e$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4f3aa993cc57516e$var$ej(d, e), $4f3aa993cc57516e$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4f3aa993cc57516e$var$ej(d, e), $4f3aa993cc57516e$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $4f3aa993cc57516e$var$Oj(b);
                if (null === a) throw Error($4f3aa993cc57516e$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4f3aa993cc57516e$var$zh(a, b);
                $4f3aa993cc57516e$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4f3aa993cc57516e$var$lj(Error($4f3aa993cc57516e$var$p(423)), b);
                        b = $4f3aa993cc57516e$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4f3aa993cc57516e$var$lj(Error($4f3aa993cc57516e$var$p(424)), b);
                        b = $4f3aa993cc57516e$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($4f3aa993cc57516e$var$Mg = $4f3aa993cc57516e$var$Zf(b.stateNode.containerInfo.firstChild), $4f3aa993cc57516e$var$Lg = b, $4f3aa993cc57516e$var$J = !0, $4f3aa993cc57516e$var$Ng = null, c = $4f3aa993cc57516e$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4f3aa993cc57516e$var$Wg();
                    if (d === e) {
                        b = $4f3aa993cc57516e$var$Cj(a, b, c);
                        break a;
                    }
                    $4f3aa993cc57516e$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4f3aa993cc57516e$var$Oh(b), null === a && $4f3aa993cc57516e$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4f3aa993cc57516e$var$Sf(d, e) ? g = null : null !== f && $4f3aa993cc57516e$var$Sf(d, f) && (b.flags |= 32), $4f3aa993cc57516e$var$Kj(a, b), $4f3aa993cc57516e$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $4f3aa993cc57516e$var$Sg(b), null;
        case 13:
            return $4f3aa993cc57516e$var$Uj(a, b, c);
        case 4:
            return $4f3aa993cc57516e$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4f3aa993cc57516e$var$hh(b, null, d, c) : $4f3aa993cc57516e$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4f3aa993cc57516e$var$ej(d, e), $4f3aa993cc57516e$var$Bj(a, b, d, e, c);
        case 7:
            return $4f3aa993cc57516e$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4f3aa993cc57516e$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $4f3aa993cc57516e$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4f3aa993cc57516e$var$H($4f3aa993cc57516e$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4f3aa993cc57516e$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$4f3aa993cc57516e$var$jg.current) {
                            b = $4f3aa993cc57516e$var$Cj(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4f3aa993cc57516e$var$Ah(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var n = l.pending;
                                            null === n ? k.next = k : (k.next = n.next, n.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4f3aa993cc57516e$var$ph(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4f3aa993cc57516e$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4f3aa993cc57516e$var$ph(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4f3aa993cc57516e$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4f3aa993cc57516e$var$qh(b, c), e = $4f3aa993cc57516e$var$sh(e), $4f3aa993cc57516e$var$sc(b), d = d(e), $4f3aa993cc57516e$var$tc(), b.flags |= 1, $4f3aa993cc57516e$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4f3aa993cc57516e$var$ej(d, b.pendingProps), e = $4f3aa993cc57516e$var$ej(d.type, e), $4f3aa993cc57516e$var$Dj(a, b, d, e, c);
        case 15:
            return $4f3aa993cc57516e$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4f3aa993cc57516e$var$ej(d, e), $4f3aa993cc57516e$var$Mj(a, b), b.tag = 1, $4f3aa993cc57516e$var$mg(d) ? (a = !0, $4f3aa993cc57516e$var$qg(b)) : a = !1, $4f3aa993cc57516e$var$qh(b, c), $4f3aa993cc57516e$var$ij(b, d, e), $4f3aa993cc57516e$var$kj(b, d, e, c), $4f3aa993cc57516e$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $4f3aa993cc57516e$var$dk(a, b, c);
        case 22:
            return $4f3aa993cc57516e$var$Hj(a, b, c);
    }
    throw Error($4f3aa993cc57516e$var$p(156, b.tag));
};
function $4f3aa993cc57516e$var$wj(a, b) {
    $4f3aa993cc57516e$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $4f3aa993cc57516e$var$Pc(a, c, b);
    });
}
function $4f3aa993cc57516e$var$rl(a, b) {
    return $4f3aa993cc57516e$var$ac(a, b);
}
function $4f3aa993cc57516e$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $4f3aa993cc57516e$var$Pg(a, b, c, d) {
    return new $4f3aa993cc57516e$var$Nl(a, b, c, d);
}
function $4f3aa993cc57516e$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4f3aa993cc57516e$var$Ml(a) {
    if ("function" === typeof a) return $4f3aa993cc57516e$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4f3aa993cc57516e$var$Da) return 11;
        if (a === $4f3aa993cc57516e$var$Ga) return 14;
    }
    return 2;
}
function $4f3aa993cc57516e$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $4f3aa993cc57516e$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $4f3aa993cc57516e$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4f3aa993cc57516e$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4f3aa993cc57516e$var$ya:
            return $4f3aa993cc57516e$var$gh(c.children, e, f, b);
        case $4f3aa993cc57516e$var$za:
            g = 8;
            e |= 8;
            break;
        case $4f3aa993cc57516e$var$Aa:
            return a = $4f3aa993cc57516e$var$Pg(12, c, b, e | 2), a.elementType = $4f3aa993cc57516e$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $4f3aa993cc57516e$var$Ea:
            return a = $4f3aa993cc57516e$var$Pg(13, c, b, e), a.elementType = $4f3aa993cc57516e$var$Ea, a.lanes = f, a;
        case $4f3aa993cc57516e$var$Fa:
            return a = $4f3aa993cc57516e$var$Pg(19, c, b, e), a.elementType = $4f3aa993cc57516e$var$Fa, a.lanes = f, a;
        case $4f3aa993cc57516e$var$Ia:
            return $4f3aa993cc57516e$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4f3aa993cc57516e$var$Ba:
                    g = 10;
                    break a;
                case $4f3aa993cc57516e$var$Ca:
                    g = 9;
                    break a;
                case $4f3aa993cc57516e$var$Da:
                    g = 11;
                    break a;
                case $4f3aa993cc57516e$var$Ga:
                    g = 14;
                    break a;
                case $4f3aa993cc57516e$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4f3aa993cc57516e$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4f3aa993cc57516e$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4f3aa993cc57516e$var$gh(a, b, c, d) {
    a = $4f3aa993cc57516e$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4f3aa993cc57516e$var$Vj(a, b, c, d) {
    a = $4f3aa993cc57516e$var$Pg(22, a, d, b);
    a.elementType = $4f3aa993cc57516e$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4f3aa993cc57516e$var$dh(a, b, c) {
    a = $4f3aa993cc57516e$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4f3aa993cc57516e$var$fh(a, b, c) {
    b = $4f3aa993cc57516e$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4f3aa993cc57516e$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4f3aa993cc57516e$var$Lc(0);
    this.expirationTimes = $4f3aa993cc57516e$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4f3aa993cc57516e$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $4f3aa993cc57516e$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $4f3aa993cc57516e$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $4f3aa993cc57516e$var$mc && (b |= 2);
    f = $4f3aa993cc57516e$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4f3aa993cc57516e$var$yh(f);
    return a;
}
function $4f3aa993cc57516e$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4f3aa993cc57516e$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4f3aa993cc57516e$var$Rl(a) {
    if (!a) return $4f3aa993cc57516e$var$ig;
    a = a._reactInternals;
    a: {
        if ($4f3aa993cc57516e$var$Vb(a) !== a || 1 !== a.tag) throw Error($4f3aa993cc57516e$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4f3aa993cc57516e$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4f3aa993cc57516e$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4f3aa993cc57516e$var$mg(c)) return $4f3aa993cc57516e$var$pg(a, c, b);
    }
    return b;
}
function $4f3aa993cc57516e$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $4f3aa993cc57516e$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $4f3aa993cc57516e$var$Rl(null);
    c = a.current;
    d = $4f3aa993cc57516e$var$Ri();
    e = $4f3aa993cc57516e$var$Oi(c);
    f = $4f3aa993cc57516e$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4f3aa993cc57516e$var$Bh(c, f, e);
    a.current.lanes = e;
    $4f3aa993cc57516e$var$Mc(a, e, d);
    $4f3aa993cc57516e$var$pl(a, d);
    return a;
}
function $4f3aa993cc57516e$var$Tl(a, b, c, d) {
    var e = b.current, f = $4f3aa993cc57516e$var$Ri(), g = $4f3aa993cc57516e$var$Oi(e);
    null !== $4f3aa993cc57516e$var$B && "function" === typeof $4f3aa993cc57516e$var$B.markRenderScheduled && $4f3aa993cc57516e$var$B.markRenderScheduled(g);
    c = $4f3aa993cc57516e$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4f3aa993cc57516e$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4f3aa993cc57516e$var$Bh(e, b, g);
    null !== a && ($4f3aa993cc57516e$var$ui(a, e, g, f), $4f3aa993cc57516e$var$Ch(a, e, g));
    return g;
}
function $4f3aa993cc57516e$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4f3aa993cc57516e$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4f3aa993cc57516e$var$Wl(a, b) {
    $4f3aa993cc57516e$var$Vl(a, b);
    (a = a.alternate) && $4f3aa993cc57516e$var$Vl(a, b);
}
function $4f3aa993cc57516e$var$Xl() {
    return null;
}
var $4f3aa993cc57516e$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4f3aa993cc57516e$var$Zl(a) {
    this._internalRoot = a;
}
$4f3aa993cc57516e$var$$l.prototype.render = $4f3aa993cc57516e$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4f3aa993cc57516e$var$p(409));
    $4f3aa993cc57516e$var$Tl(a, b, null, null);
};
$4f3aa993cc57516e$var$$l.prototype.unmount = $4f3aa993cc57516e$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4f3aa993cc57516e$var$El(function() {
            $4f3aa993cc57516e$var$Tl(null, a, null, null);
        });
        b[$4f3aa993cc57516e$var$If] = null;
    }
};
function $4f3aa993cc57516e$var$$l(a) {
    this._internalRoot = a;
}
$4f3aa993cc57516e$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4f3aa993cc57516e$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4f3aa993cc57516e$var$dd.length && 0 !== b && b < $4f3aa993cc57516e$var$dd[c].priority; c++);
        $4f3aa993cc57516e$var$dd.splice(c, 0, a);
        0 === c && $4f3aa993cc57516e$var$id(a);
    }
};
function $4f3aa993cc57516e$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4f3aa993cc57516e$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4f3aa993cc57516e$var$cm() {}
function $4f3aa993cc57516e$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4f3aa993cc57516e$var$Ul(g);
                f.call(a);
            };
        }
        var g = $4f3aa993cc57516e$var$Sl(b, d, a, 0, null, !1, !1, "", $4f3aa993cc57516e$var$cm);
        a._reactRootContainer = g;
        a[$4f3aa993cc57516e$var$If] = g.current;
        $4f3aa993cc57516e$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $4f3aa993cc57516e$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4f3aa993cc57516e$var$Ul(k);
            h.call(a);
        };
    }
    var k = $4f3aa993cc57516e$var$Pl(a, 0, !1, null, null, !1, !1, "", $4f3aa993cc57516e$var$cm);
    a._reactRootContainer = k;
    a[$4f3aa993cc57516e$var$If] = k.current;
    $4f3aa993cc57516e$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $4f3aa993cc57516e$var$El(function() {
        $4f3aa993cc57516e$var$Tl(b, k, c, d);
    });
    return k;
}
function $4f3aa993cc57516e$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4f3aa993cc57516e$var$Ul(g);
                h.call(a);
            };
        }
        $4f3aa993cc57516e$var$Tl(b, g, a, e);
    } else g = $4f3aa993cc57516e$var$dm(c, b, a, e, d);
    return $4f3aa993cc57516e$var$Ul(g);
}
$4f3aa993cc57516e$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4f3aa993cc57516e$var$Fc(b.pendingLanes);
                0 !== c && ($4f3aa993cc57516e$var$Oc(b, c | 1), $4f3aa993cc57516e$var$pl(b, $4f3aa993cc57516e$var$A()), 0 === ($4f3aa993cc57516e$var$K & 6) && ($4f3aa993cc57516e$var$mk = $4f3aa993cc57516e$var$A() + 500, $4f3aa993cc57516e$var$xg()));
            }
            break;
        case 13:
            $4f3aa993cc57516e$var$El(function() {
                var b = $4f3aa993cc57516e$var$wh(a, 1);
                if (null !== b) {
                    var c = $4f3aa993cc57516e$var$Ri();
                    $4f3aa993cc57516e$var$ui(b, a, 1, c);
                }
            }), $4f3aa993cc57516e$var$Wl(a, 1);
    }
};
$4f3aa993cc57516e$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $4f3aa993cc57516e$var$wh(a, 134217728);
        if (null !== b) {
            var c = $4f3aa993cc57516e$var$Ri();
            $4f3aa993cc57516e$var$ui(b, a, 134217728, c);
        }
        $4f3aa993cc57516e$var$Wl(a, 134217728);
    }
};
$4f3aa993cc57516e$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $4f3aa993cc57516e$var$Oi(a), c = $4f3aa993cc57516e$var$wh(a, b);
        if (null !== c) {
            var d = $4f3aa993cc57516e$var$Ri();
            $4f3aa993cc57516e$var$ui(c, a, b, d);
        }
        $4f3aa993cc57516e$var$Wl(a, b);
    }
};
$4f3aa993cc57516e$var$Vc = function() {
    return $4f3aa993cc57516e$var$E;
};
$4f3aa993cc57516e$var$Wc = function(a, b) {
    var c = $4f3aa993cc57516e$var$E;
    try {
        return $4f3aa993cc57516e$var$E = a, b();
    } finally{
        $4f3aa993cc57516e$var$E = c;
    }
};
$4f3aa993cc57516e$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4f3aa993cc57516e$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4f3aa993cc57516e$var$Db(d);
                        if (!e) throw Error($4f3aa993cc57516e$var$p(90));
                        $4f3aa993cc57516e$var$Wa(d);
                        $4f3aa993cc57516e$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4f3aa993cc57516e$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $4f3aa993cc57516e$var$eb(a, !!c.multiple, b, !1);
    }
};
$4f3aa993cc57516e$var$Gb = $4f3aa993cc57516e$var$Dl;
$4f3aa993cc57516e$var$Hb = $4f3aa993cc57516e$var$El;
var $4f3aa993cc57516e$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $4f3aa993cc57516e$var$Cb,
        $4f3aa993cc57516e$var$Ie,
        $4f3aa993cc57516e$var$Db,
        $4f3aa993cc57516e$var$Eb,
        $4f3aa993cc57516e$var$Fb,
        $4f3aa993cc57516e$var$Dl
    ]
}, $4f3aa993cc57516e$var$gm = {
    findFiberByHostInstance: $4f3aa993cc57516e$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $4f3aa993cc57516e$var$u({}, a, {
            getLaneLabelMap: $4f3aa993cc57516e$var$pc,
            injectProfilingHooks: $4f3aa993cc57516e$var$oc
        }), $4f3aa993cc57516e$var$kc = b.inject(a), $4f3aa993cc57516e$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $4f3aa993cc57516e$var$gm.bundleType,
    version: $4f3aa993cc57516e$var$gm.version,
    rendererPackageName: $4f3aa993cc57516e$var$gm.rendererPackageName,
    rendererConfig: $4f3aa993cc57516e$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4f3aa993cc57516e$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4f3aa993cc57516e$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4f3aa993cc57516e$var$gm.findFiberByHostInstance || $4f3aa993cc57516e$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$4f3aa993cc57516e$export$ae55be85d98224ed = $4f3aa993cc57516e$var$fm;
$4f3aa993cc57516e$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4f3aa993cc57516e$var$am(b)) throw Error($4f3aa993cc57516e$var$p(200));
    return $4f3aa993cc57516e$var$Ql(a, b, null, c);
};
$4f3aa993cc57516e$export$882461b6382ed46c = function(a, b) {
    if (!$4f3aa993cc57516e$var$am(a)) throw Error($4f3aa993cc57516e$var$p(299));
    var c = !1, d = "", e = $4f3aa993cc57516e$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4f3aa993cc57516e$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$4f3aa993cc57516e$var$If] = b.current;
    $4f3aa993cc57516e$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $4f3aa993cc57516e$var$Zl(b);
};
$4f3aa993cc57516e$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4f3aa993cc57516e$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4f3aa993cc57516e$var$p(268, a));
    }
    a = $4f3aa993cc57516e$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4f3aa993cc57516e$export$cd75ccfd720a3cd4 = function(a) {
    return $4f3aa993cc57516e$var$El(a);
};
$4f3aa993cc57516e$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4f3aa993cc57516e$var$bm(b)) throw Error($4f3aa993cc57516e$var$p(200));
    return $4f3aa993cc57516e$var$em(null, a, b, !0, c);
};
$4f3aa993cc57516e$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4f3aa993cc57516e$var$am(a)) throw Error($4f3aa993cc57516e$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4f3aa993cc57516e$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4f3aa993cc57516e$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4f3aa993cc57516e$var$If] = b.current;
    $4f3aa993cc57516e$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4f3aa993cc57516e$var$$l(b);
};
$4f3aa993cc57516e$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4f3aa993cc57516e$var$bm(b)) throw Error($4f3aa993cc57516e$var$p(200));
    return $4f3aa993cc57516e$var$em(null, a, b, !1, c);
};
$4f3aa993cc57516e$export$502457920280e6be = function(a) {
    if (!$4f3aa993cc57516e$var$bm(a)) throw Error($4f3aa993cc57516e$var$p(40));
    return a._reactRootContainer ? ($4f3aa993cc57516e$var$El(function() {
        $4f3aa993cc57516e$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4f3aa993cc57516e$var$If] = null;
        });
    }), !0) : !1;
};
$4f3aa993cc57516e$export$c78a37762a8d58e1 = $4f3aa993cc57516e$var$Dl;
$4f3aa993cc57516e$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4f3aa993cc57516e$var$bm(c)) throw Error($4f3aa993cc57516e$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4f3aa993cc57516e$var$p(38));
    return $4f3aa993cc57516e$var$em(a, b, c, !1, d);
};
$4f3aa993cc57516e$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});
parcelRegister("lMj4E", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jLjgz"));

});
parcelRegister("jLjgz", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e6315a00f0f76bb0$export$c4744153514ff05d; }, function (v) { return $e6315a00f0f76bb0$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e6315a00f0f76bb0$export$3e506c1ccc9cc1a7; }, function (v) { return $e6315a00f0f76bb0$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e6315a00f0f76bb0$export$e26fe2ed2fa76875; }, function (v) { return $e6315a00f0f76bb0$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e6315a00f0f76bb0$export$502329bbf4b505b1; }, function (v) { return $e6315a00f0f76bb0$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e6315a00f0f76bb0$export$6e3807111c4874c4; }, function (v) { return $e6315a00f0f76bb0$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e6315a00f0f76bb0$export$c27134553091fb3a; }, function (v) { return $e6315a00f0f76bb0$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e6315a00f0f76bb0$export$33ee1acdc04fd2a2; }, function (v) { return $e6315a00f0f76bb0$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e6315a00f0f76bb0$export$b00a404bbd5edef2; }, function (v) { return $e6315a00f0f76bb0$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e6315a00f0f76bb0$export$8352ce38b91d0c62; }, function (v) { return $e6315a00f0f76bb0$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e6315a00f0f76bb0$export$d66a1c1c77bd778b; }, function (v) { return $e6315a00f0f76bb0$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e6315a00f0f76bb0$export$d3dfb8e4810cb555; }, function (v) { return $e6315a00f0f76bb0$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e6315a00f0f76bb0$export$839f9183b0465a69; }, function (v) { return $e6315a00f0f76bb0$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e6315a00f0f76bb0$export$72fdf0e06517287b; }, function (v) { return $e6315a00f0f76bb0$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e6315a00f0f76bb0$export$4b844e58a3e414b4; }, function (v) { return $e6315a00f0f76bb0$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e6315a00f0f76bb0$export$816d2913ae6b83b1; }, function (v) { return $e6315a00f0f76bb0$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e6315a00f0f76bb0$export$61bcfe829111a1d0; }, function (v) { return $e6315a00f0f76bb0$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e6315a00f0f76bb0$export$7ee8c9beb337bc3f; }, function (v) { return $e6315a00f0f76bb0$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e6315a00f0f76bb0$export$b5836b71941fa3ed; }, function (v) { return $e6315a00f0f76bb0$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e6315a00f0f76bb0$export$cf845f2c119da08a; }, function (v) { return $e6315a00f0f76bb0$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e6315a00f0f76bb0$export$c4744153514ff05d;
var $e6315a00f0f76bb0$export$3e506c1ccc9cc1a7;
var $e6315a00f0f76bb0$export$e26fe2ed2fa76875;
var $e6315a00f0f76bb0$export$502329bbf4b505b1;
var $e6315a00f0f76bb0$export$6e3807111c4874c4;
var $e6315a00f0f76bb0$export$c27134553091fb3a;
var $e6315a00f0f76bb0$export$33ee1acdc04fd2a2;
var $e6315a00f0f76bb0$export$b00a404bbd5edef2;
var $e6315a00f0f76bb0$export$8352ce38b91d0c62;
var $e6315a00f0f76bb0$export$d66a1c1c77bd778b;
var $e6315a00f0f76bb0$export$d3dfb8e4810cb555;
var $e6315a00f0f76bb0$export$839f9183b0465a69;
var $e6315a00f0f76bb0$export$72fdf0e06517287b;
var $e6315a00f0f76bb0$export$4b844e58a3e414b4;
var $e6315a00f0f76bb0$export$816d2913ae6b83b1;
var $e6315a00f0f76bb0$export$61bcfe829111a1d0;
var $e6315a00f0f76bb0$export$7ee8c9beb337bc3f;
var $e6315a00f0f76bb0$export$b5836b71941fa3ed;
var $e6315a00f0f76bb0$export$cf845f2c119da08a;
"use strict";
function $e6315a00f0f76bb0$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e6315a00f0f76bb0$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e6315a00f0f76bb0$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e6315a00f0f76bb0$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e6315a00f0f76bb0$var$g(C, c)) n < e && 0 > $e6315a00f0f76bb0$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e6315a00f0f76bb0$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e6315a00f0f76bb0$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e6315a00f0f76bb0$var$l = performance;
    $e6315a00f0f76bb0$export$c4744153514ff05d = function() {
        return $e6315a00f0f76bb0$var$l.now();
    };
} else {
    var $e6315a00f0f76bb0$var$p = Date, $e6315a00f0f76bb0$var$q = $e6315a00f0f76bb0$var$p.now();
    $e6315a00f0f76bb0$export$c4744153514ff05d = function() {
        return $e6315a00f0f76bb0$var$p.now() - $e6315a00f0f76bb0$var$q;
    };
}
var $e6315a00f0f76bb0$var$r = [], $e6315a00f0f76bb0$var$t = [], $e6315a00f0f76bb0$var$u = 1, $e6315a00f0f76bb0$var$v = null, $e6315a00f0f76bb0$var$y = 3, $e6315a00f0f76bb0$var$z = !1, $e6315a00f0f76bb0$var$A = !1, $e6315a00f0f76bb0$var$B = !1, $e6315a00f0f76bb0$var$D = "function" === typeof setTimeout ? setTimeout : null, $e6315a00f0f76bb0$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e6315a00f0f76bb0$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e6315a00f0f76bb0$var$G(a) {
    for(var b = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$t); null !== b;){
        if (null === b.callback) $e6315a00f0f76bb0$var$k($e6315a00f0f76bb0$var$t);
        else if (b.startTime <= a) $e6315a00f0f76bb0$var$k($e6315a00f0f76bb0$var$t), b.sortIndex = b.expirationTime, $e6315a00f0f76bb0$var$f($e6315a00f0f76bb0$var$r, b);
        else break;
        b = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$t);
    }
}
function $e6315a00f0f76bb0$var$H(a) {
    $e6315a00f0f76bb0$var$B = !1;
    $e6315a00f0f76bb0$var$G(a);
    if (!$e6315a00f0f76bb0$var$A) {
        if (null !== $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r)) $e6315a00f0f76bb0$var$A = !0, $e6315a00f0f76bb0$var$I($e6315a00f0f76bb0$var$J);
        else {
            var b = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$t);
            null !== b && $e6315a00f0f76bb0$var$K($e6315a00f0f76bb0$var$H, b.startTime - a);
        }
    }
}
function $e6315a00f0f76bb0$var$J(a, b) {
    $e6315a00f0f76bb0$var$A = !1;
    $e6315a00f0f76bb0$var$B && ($e6315a00f0f76bb0$var$B = !1, $e6315a00f0f76bb0$var$E($e6315a00f0f76bb0$var$L), $e6315a00f0f76bb0$var$L = -1);
    $e6315a00f0f76bb0$var$z = !0;
    var c = $e6315a00f0f76bb0$var$y;
    try {
        $e6315a00f0f76bb0$var$G(b);
        for($e6315a00f0f76bb0$var$v = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r); null !== $e6315a00f0f76bb0$var$v && (!($e6315a00f0f76bb0$var$v.expirationTime > b) || a && !$e6315a00f0f76bb0$var$M());){
            var d = $e6315a00f0f76bb0$var$v.callback;
            if ("function" === typeof d) {
                $e6315a00f0f76bb0$var$v.callback = null;
                $e6315a00f0f76bb0$var$y = $e6315a00f0f76bb0$var$v.priorityLevel;
                var e = d($e6315a00f0f76bb0$var$v.expirationTime <= b);
                b = $e6315a00f0f76bb0$export$c4744153514ff05d();
                "function" === typeof e ? $e6315a00f0f76bb0$var$v.callback = e : $e6315a00f0f76bb0$var$v === $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r) && $e6315a00f0f76bb0$var$k($e6315a00f0f76bb0$var$r);
                $e6315a00f0f76bb0$var$G(b);
            } else $e6315a00f0f76bb0$var$k($e6315a00f0f76bb0$var$r);
            $e6315a00f0f76bb0$var$v = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r);
        }
        if (null !== $e6315a00f0f76bb0$var$v) var w = !0;
        else {
            var m = $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$t);
            null !== m && $e6315a00f0f76bb0$var$K($e6315a00f0f76bb0$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e6315a00f0f76bb0$var$v = null, $e6315a00f0f76bb0$var$y = c, $e6315a00f0f76bb0$var$z = !1;
    }
}
var $e6315a00f0f76bb0$var$N = !1, $e6315a00f0f76bb0$var$O = null, $e6315a00f0f76bb0$var$L = -1, $e6315a00f0f76bb0$var$P = 5, $e6315a00f0f76bb0$var$Q = -1;
function $e6315a00f0f76bb0$var$M() {
    return $e6315a00f0f76bb0$export$c4744153514ff05d() - $e6315a00f0f76bb0$var$Q < $e6315a00f0f76bb0$var$P ? !1 : !0;
}
function $e6315a00f0f76bb0$var$R() {
    if (null !== $e6315a00f0f76bb0$var$O) {
        var a = $e6315a00f0f76bb0$export$c4744153514ff05d();
        $e6315a00f0f76bb0$var$Q = a;
        var b = !0;
        try {
            b = $e6315a00f0f76bb0$var$O(!0, a);
        } finally{
            b ? $e6315a00f0f76bb0$var$S() : ($e6315a00f0f76bb0$var$N = !1, $e6315a00f0f76bb0$var$O = null);
        }
    } else $e6315a00f0f76bb0$var$N = !1;
}
var $e6315a00f0f76bb0$var$S;
if ("function" === typeof $e6315a00f0f76bb0$var$F) $e6315a00f0f76bb0$var$S = function() {
    $e6315a00f0f76bb0$var$F($e6315a00f0f76bb0$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e6315a00f0f76bb0$var$T = new MessageChannel, $e6315a00f0f76bb0$var$U = $e6315a00f0f76bb0$var$T.port2;
    $e6315a00f0f76bb0$var$T.port1.onmessage = $e6315a00f0f76bb0$var$R;
    $e6315a00f0f76bb0$var$S = function() {
        $e6315a00f0f76bb0$var$U.postMessage(null);
    };
} else $e6315a00f0f76bb0$var$S = function() {
    $e6315a00f0f76bb0$var$D($e6315a00f0f76bb0$var$R, 0);
};
function $e6315a00f0f76bb0$var$I(a) {
    $e6315a00f0f76bb0$var$O = a;
    $e6315a00f0f76bb0$var$N || ($e6315a00f0f76bb0$var$N = !0, $e6315a00f0f76bb0$var$S());
}
function $e6315a00f0f76bb0$var$K(a, b) {
    $e6315a00f0f76bb0$var$L = $e6315a00f0f76bb0$var$D(function() {
        a($e6315a00f0f76bb0$export$c4744153514ff05d());
    }, b);
}
$e6315a00f0f76bb0$export$3e506c1ccc9cc1a7 = 5;
$e6315a00f0f76bb0$export$e26fe2ed2fa76875 = 1;
$e6315a00f0f76bb0$export$502329bbf4b505b1 = 4;
$e6315a00f0f76bb0$export$6e3807111c4874c4 = 3;
$e6315a00f0f76bb0$export$c27134553091fb3a = null;
$e6315a00f0f76bb0$export$33ee1acdc04fd2a2 = 2;
$e6315a00f0f76bb0$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e6315a00f0f76bb0$export$8352ce38b91d0c62 = function() {
    $e6315a00f0f76bb0$var$A || $e6315a00f0f76bb0$var$z || ($e6315a00f0f76bb0$var$A = !0, $e6315a00f0f76bb0$var$I($e6315a00f0f76bb0$var$J));
};
$e6315a00f0f76bb0$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e6315a00f0f76bb0$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e6315a00f0f76bb0$export$d3dfb8e4810cb555 = function() {
    return $e6315a00f0f76bb0$var$y;
};
$e6315a00f0f76bb0$export$839f9183b0465a69 = function() {
    return $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r);
};
$e6315a00f0f76bb0$export$72fdf0e06517287b = function(a) {
    switch($e6315a00f0f76bb0$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e6315a00f0f76bb0$var$y;
    }
    var c = $e6315a00f0f76bb0$var$y;
    $e6315a00f0f76bb0$var$y = b;
    try {
        return a();
    } finally{
        $e6315a00f0f76bb0$var$y = c;
    }
};
$e6315a00f0f76bb0$export$4b844e58a3e414b4 = function() {};
$e6315a00f0f76bb0$export$816d2913ae6b83b1 = function() {};
$e6315a00f0f76bb0$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e6315a00f0f76bb0$var$y;
    $e6315a00f0f76bb0$var$y = a;
    try {
        return b();
    } finally{
        $e6315a00f0f76bb0$var$y = c;
    }
};
$e6315a00f0f76bb0$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e6315a00f0f76bb0$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e6315a00f0f76bb0$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e6315a00f0f76bb0$var$f($e6315a00f0f76bb0$var$t, a), null === $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$r) && a === $e6315a00f0f76bb0$var$h($e6315a00f0f76bb0$var$t) && ($e6315a00f0f76bb0$var$B ? ($e6315a00f0f76bb0$var$E($e6315a00f0f76bb0$var$L), $e6315a00f0f76bb0$var$L = -1) : $e6315a00f0f76bb0$var$B = !0, $e6315a00f0f76bb0$var$K($e6315a00f0f76bb0$var$H, c - d))) : (a.sortIndex = e, $e6315a00f0f76bb0$var$f($e6315a00f0f76bb0$var$r, a), $e6315a00f0f76bb0$var$A || $e6315a00f0f76bb0$var$z || ($e6315a00f0f76bb0$var$A = !0, $e6315a00f0f76bb0$var$I($e6315a00f0f76bb0$var$J)));
    return a;
};
$e6315a00f0f76bb0$export$b5836b71941fa3ed = $e6315a00f0f76bb0$var$M;
$e6315a00f0f76bb0$export$cf845f2c119da08a = function(a) {
    var b = $e6315a00f0f76bb0$var$y;
    return function() {
        var c = $e6315a00f0f76bb0$var$y;
        $e6315a00f0f76bb0$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e6315a00f0f76bb0$var$y = c;
        }
    };
};

});




parcelRegister("hYbro", function(module, exports) {

$parcel$export(module.exports, "StyleSheetManager", function () { return $d150ea3204a4cc40$export$a473771da2f0ff7c; });
$parcel$export(module.exports, "css", function () { return $d150ea3204a4cc40$export$dbf350e5966cf602; });
$parcel$export(module.exports, "default", function () { return $d150ea3204a4cc40$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "createGlobalStyle", function () { return $d150ea3204a4cc40$export$f0f03736edb61697; });
$parcel$export(module.exports, "keyframes", function () { return $d150ea3204a4cc40$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "styled", function () { return $d150ea3204a4cc40$export$2e2bcd8739ae039; });

var $9z2vN = parcelRequire("9z2vN");
parcelRequire("dmK2Y");

var $iSvIT = parcelRequire("iSvIT");

var $awgDS = parcelRequire("awgDS");

var $3znPo = parcelRequire("3znPo");
var $1RKWh = parcelRequire("1RKWh");
var $ll93R = parcelRequire("ll93R");
var $e8dyh = parcelRequire("e8dyh");

var $8vGfR = parcelRequire("8vGfR");

var $XAEGR = parcelRequire("XAEGR");
var $d150ea3204a4cc40$var$f = ("undefined" != typeof $XAEGR && void 0 !== $XAEGR.env && undefined, "data-styled"), $d150ea3204a4cc40$var$m = "active", $d150ea3204a4cc40$var$y = "data-styled-version", $d150ea3204a4cc40$export$83d89fbfd8236492 = "6.1.19", $d150ea3204a4cc40$var$g = "/*!sc*/\n", $d150ea3204a4cc40$var$S = "undefined" != typeof window && "undefined" != typeof document, $d150ea3204a4cc40$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $XAEGR && $XAEGR.env, "undefined" != typeof $XAEGR && $XAEGR.env, false)), $d150ea3204a4cc40$var$b = {}, $d150ea3204a4cc40$var$E = /invalid hook call/i, $d150ea3204a4cc40$var$N = new Set, $d150ea3204a4cc40$var$P = function(t, n) {
    var o, s, i, a, e;
}, $d150ea3204a4cc40$var$_ = Object.freeze([]), $d150ea3204a4cc40$var$C = Object.freeze({});
function $d150ea3204a4cc40$var$I(e, t, n) {
    return void 0 === n && (n = $d150ea3204a4cc40$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $d150ea3204a4cc40$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $d150ea3204a4cc40$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $d150ea3204a4cc40$var$D = /(^-|-$)/g;
function $d150ea3204a4cc40$var$R(e) {
    return e.replace($d150ea3204a4cc40$var$O, "-").replace($d150ea3204a4cc40$var$D, "");
}
var $d150ea3204a4cc40$var$T = /(a)(d)/gi, $d150ea3204a4cc40$var$k = 52, $d150ea3204a4cc40$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $d150ea3204a4cc40$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $d150ea3204a4cc40$var$k; t = t / $d150ea3204a4cc40$var$k | 0)n = $d150ea3204a4cc40$var$j(t % $d150ea3204a4cc40$var$k) + n;
    return ($d150ea3204a4cc40$var$j(t % $d150ea3204a4cc40$var$k) + n).replace($d150ea3204a4cc40$var$T, "$1-$2");
}
var $d150ea3204a4cc40$var$V, $d150ea3204a4cc40$var$F = 5381, $d150ea3204a4cc40$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $d150ea3204a4cc40$var$z = function(e) {
    return $d150ea3204a4cc40$var$M($d150ea3204a4cc40$var$F, e);
};
function $d150ea3204a4cc40$var$$(e) {
    return $d150ea3204a4cc40$var$x($d150ea3204a4cc40$var$z(e) >>> 0);
}
function $d150ea3204a4cc40$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $d150ea3204a4cc40$var$L(e) {
    return "string" == typeof e && true;
}
var $d150ea3204a4cc40$var$G = "function" == typeof Symbol && Symbol.for, $d150ea3204a4cc40$var$Y = $d150ea3204a4cc40$var$G ? Symbol.for("react.memo") : 60115, $d150ea3204a4cc40$var$W = $d150ea3204a4cc40$var$G ? Symbol.for("react.forward_ref") : 60112, $d150ea3204a4cc40$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $d150ea3204a4cc40$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $d150ea3204a4cc40$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $d150ea3204a4cc40$var$J = (($d150ea3204a4cc40$var$V = {})[$d150ea3204a4cc40$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $d150ea3204a4cc40$var$V[$d150ea3204a4cc40$var$Y] = $d150ea3204a4cc40$var$U, $d150ea3204a4cc40$var$V);
function $d150ea3204a4cc40$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $d150ea3204a4cc40$var$Y ? $d150ea3204a4cc40$var$U : "$$typeof" in e ? $d150ea3204a4cc40$var$J[e.$$typeof] : $d150ea3204a4cc40$var$q;
}
var $d150ea3204a4cc40$var$Z = Object.defineProperty, $d150ea3204a4cc40$var$K = Object.getOwnPropertyNames, $d150ea3204a4cc40$var$Q = Object.getOwnPropertySymbols, $d150ea3204a4cc40$var$ee = Object.getOwnPropertyDescriptor, $d150ea3204a4cc40$var$te = Object.getPrototypeOf, $d150ea3204a4cc40$var$ne = Object.prototype;
function $d150ea3204a4cc40$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($d150ea3204a4cc40$var$ne) {
            var o = $d150ea3204a4cc40$var$te(t);
            o && o !== $d150ea3204a4cc40$var$ne && $d150ea3204a4cc40$var$oe(e, o, n);
        }
        var r = $d150ea3204a4cc40$var$K(t);
        $d150ea3204a4cc40$var$Q && (r = r.concat($d150ea3204a4cc40$var$Q(t)));
        for(var s = $d150ea3204a4cc40$var$X(e), i = $d150ea3204a4cc40$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $d150ea3204a4cc40$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $d150ea3204a4cc40$var$ee(t, c);
                try {
                    $d150ea3204a4cc40$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $d150ea3204a4cc40$var$re(e) {
    return "function" == typeof e;
}
function $d150ea3204a4cc40$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $d150ea3204a4cc40$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $d150ea3204a4cc40$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $d150ea3204a4cc40$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $d150ea3204a4cc40$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$d150ea3204a4cc40$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $d150ea3204a4cc40$var$le(e[o], t[o]);
    else if ($d150ea3204a4cc40$var$ce(t)) for(var o in t)e[o] = $d150ea3204a4cc40$var$le(e[o], t[o]);
    return e;
}
function $d150ea3204a4cc40$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $d150ea3204a4cc40$var$pe = {};
function $d150ea3204a4cc40$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $d150ea3204a4cc40$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $d150ea3204a4cc40$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $d150ea3204a4cc40$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($d150ea3204a4cc40$var$g);
        return t;
    }, e;
}(), $d150ea3204a4cc40$var$me = 1073741824, $d150ea3204a4cc40$var$ye = new Map, $d150ea3204a4cc40$var$ve = new Map, $d150ea3204a4cc40$var$ge = 1, $d150ea3204a4cc40$var$Se = function(e) {
    if ($d150ea3204a4cc40$var$ye.has(e)) return $d150ea3204a4cc40$var$ye.get(e);
    for(; $d150ea3204a4cc40$var$ve.has($d150ea3204a4cc40$var$ge);)$d150ea3204a4cc40$var$ge++;
    var t = $d150ea3204a4cc40$var$ge++;
    return $d150ea3204a4cc40$var$ye.set(e, t), $d150ea3204a4cc40$var$ve.set(t, e), t;
}, $d150ea3204a4cc40$var$we = function(e, t) {
    $d150ea3204a4cc40$var$ge = t + 1, $d150ea3204a4cc40$var$ye.set(e, t), $d150ea3204a4cc40$var$ve.set(t, e);
}, $d150ea3204a4cc40$var$be = "style[".concat($d150ea3204a4cc40$var$f, "][").concat($d150ea3204a4cc40$var$y, '="').concat($d150ea3204a4cc40$export$83d89fbfd8236492, '"]'), $d150ea3204a4cc40$var$Ee = new RegExp("^".concat($d150ea3204a4cc40$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $d150ea3204a4cc40$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $d150ea3204a4cc40$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($d150ea3204a4cc40$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($d150ea3204a4cc40$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($d150ea3204a4cc40$var$we(u, l), $d150ea3204a4cc40$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $d150ea3204a4cc40$var$_e = function(e) {
    for(var t = document.querySelectorAll($d150ea3204a4cc40$var$be), n = 0, o = t.length; n < o; n++){
        var r = t[n];
        r && r.getAttribute($d150ea3204a4cc40$var$f) !== $d150ea3204a4cc40$var$m && ($d150ea3204a4cc40$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $d150ea3204a4cc40$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $d150ea3204a4cc40$var$Ie = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($d150ea3204a4cc40$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($d150ea3204a4cc40$var$f, $d150ea3204a4cc40$var$m), o.setAttribute($d150ea3204a4cc40$var$y, $d150ea3204a4cc40$export$83d89fbfd8236492);
    var i = $d150ea3204a4cc40$var$Ce();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $d150ea3204a4cc40$var$Ae = function() {
    function e(e) {
        this.element = $d150ea3204a4cc40$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $d150ea3204a4cc40$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $d150ea3204a4cc40$var$Oe = function() {
    function e(e) {
        this.element = $d150ea3204a4cc40$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $d150ea3204a4cc40$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $d150ea3204a4cc40$var$Re = $d150ea3204a4cc40$var$S, $d150ea3204a4cc40$var$Te = {
    isServer: !$d150ea3204a4cc40$var$S,
    useCSSOMInjection: !$d150ea3204a4cc40$var$w
}, $d150ea3204a4cc40$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $d150ea3204a4cc40$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, $d150ea3204a4cc40$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $d150ea3204a4cc40$var$S && $d150ea3204a4cc40$var$Re && ($d150ea3204a4cc40$var$Re = !1, $d150ea3204a4cc40$var$_e(this)), $d150ea3204a4cc40$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $d150ea3204a4cc40$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($d150ea3204a4cc40$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($d150ea3204a4cc40$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $d150ea3204a4cc40$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $d150ea3204a4cc40$var$S && $d150ea3204a4cc40$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $d150ea3204a4cc40$var$De(n) : t ? new $d150ea3204a4cc40$var$Ae(n) : new $d150ea3204a4cc40$var$Oe(n);
        }(this.options), new $d150ea3204a4cc40$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($d150ea3204a4cc40$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($d150ea3204a4cc40$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($d150ea3204a4cc40$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $d150ea3204a4cc40$var$je = /&/g, $d150ea3204a4cc40$var$xe = /^\s*\/\/.*$/gm;
function $d150ea3204a4cc40$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $d150ea3204a4cc40$var$Ve(e.children, t)), e;
    });
}
function $d150ea3204a4cc40$var$Fe(e) {
    var t, n, o, r = void 0 === e ? $d150ea3204a4cc40$var$C : e, s = r.options, i = void 0 === s ? $d150ea3204a4cc40$var$C : s, a = r.plugins, c = void 0 === a ? $d150ea3204a4cc40$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $ll93R.RULESET && e.value.includes("&") && (e.props[0] = e.props[0].replace($d150ea3204a4cc40$var$je, n).replace(o, l));
    }), i.prefix && u.push($1RKWh.prefixer), u.push($e8dyh.stringify);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($d150ea3204a4cc40$var$xe, ""), l = $3znPo.compile(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $d150ea3204a4cc40$var$Ve(l, i.namespace));
        var p = [];
        return $e8dyh.serialize(l, $1RKWh.middleware(u.concat($1RKWh.rulesheet(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $d150ea3204a4cc40$var$he(15), $d150ea3204a4cc40$var$M(e, t.name);
    }, $d150ea3204a4cc40$var$F).toString() : "", p;
}
var $d150ea3204a4cc40$var$Me = new $d150ea3204a4cc40$var$ke, $d150ea3204a4cc40$var$ze = $d150ea3204a4cc40$var$Fe(), $d150ea3204a4cc40$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $d150ea3204a4cc40$var$Me,
    stylis: $d150ea3204a4cc40$var$ze
}), $d150ea3204a4cc40$export$91317688fc694efa = $d150ea3204a4cc40$export$8c190ef828af4c86.Consumer, $d150ea3204a4cc40$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext(void 0);
function $d150ea3204a4cc40$var$Ge() {
    return (0, $iSvIT.useContext)($d150ea3204a4cc40$export$8c190ef828af4c86);
}
function $d150ea3204a4cc40$export$a473771da2f0ff7c(e) {
    var t = (0, $iSvIT.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $d150ea3204a4cc40$var$Ge().styleSheet, l = (0, $iSvIT.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $iSvIT.useMemo)(function() {
        return $d150ea3204a4cc40$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $iSvIT.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($awgDS)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $iSvIT.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d150ea3204a4cc40$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d150ea3204a4cc40$var$Le.Provider, {
        value: u
    }, e.children));
}
var $d150ea3204a4cc40$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $d150ea3204a4cc40$var$ze);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $d150ea3204a4cc40$var$ue(this, function() {
            throw $d150ea3204a4cc40$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $d150ea3204a4cc40$var$ze), this.name + e.hash;
    }, e;
}(), $d150ea3204a4cc40$var$qe = function(e) {
    return e >= "A" && e <= "Z";
};
function $d150ea3204a4cc40$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $d150ea3204a4cc40$var$qe(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $d150ea3204a4cc40$var$Ue = function(e) {
    return null == e || !1 === e || "" === e;
}, $d150ea3204a4cc40$var$Je = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$d150ea3204a4cc40$var$Ue(i) && (Array.isArray(i) && i.isCss || $d150ea3204a4cc40$var$re(i) ? r.push("".concat($d150ea3204a4cc40$var$He(s), ":"), i, ";") : $d150ea3204a4cc40$var$ce(i) ? r.push.apply(r, (0, $9z2vN.__spreadArray)((0, $9z2vN.__spreadArray)([
            "".concat(s, " {")
        ], $d150ea3204a4cc40$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($d150ea3204a4cc40$var$He(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $8vGfR.default) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $d150ea3204a4cc40$var$Xe(e, t, n, o) {
    if ($d150ea3204a4cc40$var$Ue(e)) return [];
    if ($d150ea3204a4cc40$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($d150ea3204a4cc40$var$re(e)) {
        if (!$d150ea3204a4cc40$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $d150ea3204a4cc40$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $d150ea3204a4cc40$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $d150ea3204a4cc40$var$ce(e) ? $d150ea3204a4cc40$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($d150ea3204a4cc40$var$_, e.map(function(e) {
        return $d150ea3204a4cc40$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $d150ea3204a4cc40$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($d150ea3204a4cc40$var$re(n) && !$d150ea3204a4cc40$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $d150ea3204a4cc40$var$Ke = $d150ea3204a4cc40$var$z($d150ea3204a4cc40$export$83d89fbfd8236492), $d150ea3204a4cc40$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $d150ea3204a4cc40$var$Ze(e), this.componentId = t, this.baseHash = $d150ea3204a4cc40$var$M($d150ea3204a4cc40$var$Ke, t), this.baseStyle = n, $d150ea3204a4cc40$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $d150ea3204a4cc40$var$ie(o, this.staticRulesId);
            else {
                var r = $d150ea3204a4cc40$var$ae($d150ea3204a4cc40$var$Xe(this.rules, e, t, n)), s = $d150ea3204a4cc40$var$x($d150ea3204a4cc40$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $d150ea3204a4cc40$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $d150ea3204a4cc40$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $d150ea3204a4cc40$var$ae($d150ea3204a4cc40$var$Xe(u, e, t, n));
                    a = $d150ea3204a4cc40$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $d150ea3204a4cc40$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $d150ea3204a4cc40$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $d150ea3204a4cc40$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext(void 0), $d150ea3204a4cc40$export$b631efc24e9d5e2f = $d150ea3204a4cc40$export$2c657da244d00bd6.Consumer;
function $d150ea3204a4cc40$export$93d4e7f90805808f() {
    var e = (0, $iSvIT.useContext)($d150ea3204a4cc40$export$2c657da244d00bd6);
    if (!e) throw $d150ea3204a4cc40$var$he(18);
    return e;
}
function $d150ea3204a4cc40$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($d150ea3204a4cc40$export$2c657da244d00bd6), r = (0, $iSvIT.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $d150ea3204a4cc40$var$he(14);
            if ($d150ea3204a4cc40$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $d150ea3204a4cc40$var$he(8);
            return n ? (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d150ea3204a4cc40$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $d150ea3204a4cc40$var$rt = {}, $d150ea3204a4cc40$var$st = new Set;
function $d150ea3204a4cc40$var$it(e, r, s) {
    var i = $d150ea3204a4cc40$export$7ba318d8d2f06c76(e), a = e, c = !$d150ea3204a4cc40$var$L(e), p = r.attrs, d = void 0 === p ? $d150ea3204a4cc40$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $d150ea3204a4cc40$var$R(e);
        $d150ea3204a4cc40$var$rt[n] = ($d150ea3204a4cc40$var$rt[n] || 0) + 1;
        var o = "".concat(n, "-").concat($d150ea3204a4cc40$var$$($d150ea3204a4cc40$export$83d89fbfd8236492 + n + $d150ea3204a4cc40$var$rt[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $d150ea3204a4cc40$var$L(e) ? "styled.".concat(e) : "Styled(".concat($d150ea3204a4cc40$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($d150ea3204a4cc40$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $d150ea3204a4cc40$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($d150ea3204a4cc40$export$2c657da244d00bd6), m = $d150ea3204a4cc40$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $d150ea3204a4cc40$var$I(r, f, c) || $d150ea3204a4cc40$var$C, g = function(e, n, o) {
                for(var r, s = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $d150ea3204a4cc40$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $d150ea3204a4cc40$var$ie(s[c], a[c]) : "style" === c ? (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $d150ea3204a4cc40$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $d150ea3204a4cc40$var$Ge(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $d150ea3204a4cc40$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$d150ea3204a4cc40$var$L(S) && !$d150ea3204a4cc40$var$A.has(S) ? "class" : "className"] = N, s && (w.ref = s), (0, $iSvIT.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $d150ea3204a4cc40$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$d150ea3204a4cc40$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $d150ea3204a4cc40$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $d150ea3204a4cc40$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $d150ea3204a4cc40$var$at(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $d150ea3204a4cc40$var$ct = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $d150ea3204a4cc40$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($d150ea3204a4cc40$var$re(t) || $d150ea3204a4cc40$var$ce(t)) return $d150ea3204a4cc40$var$ct($d150ea3204a4cc40$var$Xe($d150ea3204a4cc40$var$at($d150ea3204a4cc40$var$_, (0, $9z2vN.__spreadArray)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $d150ea3204a4cc40$var$Xe(r) : $d150ea3204a4cc40$var$ct($d150ea3204a4cc40$var$Xe($d150ea3204a4cc40$var$at(r, n)));
}
function $d150ea3204a4cc40$var$ut(n, o, r) {
    if (void 0 === r && (r = $d150ea3204a4cc40$var$C), !o) throw $d150ea3204a4cc40$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $d150ea3204a4cc40$export$dbf350e5966cf602.apply(void 0, (0, $9z2vN.__spreadArray)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $d150ea3204a4cc40$var$ut(n, o, (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $d150ea3204a4cc40$var$ut(n, o, (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, r), e));
    }, s;
}
var $d150ea3204a4cc40$var$pt = function(e) {
    return $d150ea3204a4cc40$var$ut($d150ea3204a4cc40$var$it, e);
}, $d150ea3204a4cc40$export$2e2bcd8739ae039 = $d150ea3204a4cc40$var$pt;
$d150ea3204a4cc40$var$A.forEach(function(e) {
    $d150ea3204a4cc40$export$2e2bcd8739ae039[e] = $d150ea3204a4cc40$var$pt(e);
});
var $d150ea3204a4cc40$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $d150ea3204a4cc40$var$Ze(e), $d150ea3204a4cc40$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($d150ea3204a4cc40$var$ae($d150ea3204a4cc40$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $d150ea3204a4cc40$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $d150ea3204a4cc40$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $d150ea3204a4cc40$export$dbf350e5966cf602.apply(void 0, (0, $9z2vN.__spreadArray)([
        n
    ], r, !1)), a = "sc-global-".concat($d150ea3204a4cc40$var$$(JSON.stringify(i))), c = new $d150ea3204a4cc40$var$ht(i, a);
    var l = function(e) {
        var t = $d150ea3204a4cc40$var$Ge(), n = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($d150ea3204a4cc40$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $d150ea3204a4cc40$var$b, o, s);
        else {
            var i = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, n), {
                theme: $d150ea3204a4cc40$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).memo(l);
}
function $d150ea3204a4cc40$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $d150ea3204a4cc40$var$ae($d150ea3204a4cc40$export$dbf350e5966cf602.apply(void 0, (0, $9z2vN.__spreadArray)([
        t
    ], n, !1))), s = $d150ea3204a4cc40$var$$(r);
    return new $d150ea3204a4cc40$var$We(s, r);
}
function $d150ea3204a4cc40$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(n, r) {
        var s = $d150ea3204a4cc40$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useContext($d150ea3204a4cc40$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(e, (0, $9z2vN.__assign)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($d150ea3204a4cc40$var$B(e), ")"), $d150ea3204a4cc40$var$oe(n, e);
}
var $d150ea3204a4cc40$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $d150ea3204a4cc40$var$Ce(), o = $d150ea3204a4cc40$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($d150ea3204a4cc40$var$f, '="true"'),
                "".concat($d150ea3204a4cc40$var$y, '="').concat($d150ea3204a4cc40$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $d150ea3204a4cc40$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $d150ea3204a4cc40$var$he(2);
            var r = e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$d150ea3204a4cc40$var$f] = "", n[$d150ea3204a4cc40$var$y] = $d150ea3204a4cc40$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $d150ea3204a4cc40$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("style", (0, $9z2vN.__assign)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $d150ea3204a4cc40$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $d150ea3204a4cc40$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($d150ea3204a4cc40$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $d150ea3204a4cc40$var$he(3);
    }, e;
}(), $d150ea3204a4cc40$export$5c87cfe6c475f500 = {
    StyleSheet: $d150ea3204a4cc40$var$ke,
    mainSheet: $d150ea3204a4cc40$var$Me
};
var $d150ea3204a4cc40$var$St = "__sc-".concat($d150ea3204a4cc40$var$f, "__");

});
parcelRegister("9z2vN", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $cdd703b1c510bfa8$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $cdd703b1c510bfa8$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $cdd703b1c510bfa8$export$3c9a16f847548506; });
$parcel$export(module.exports, "__exportStar", function () { return $cdd703b1c510bfa8$export$f33643c0debef087; });
$parcel$export(module.exports, "__spreadArrays", function () { return $cdd703b1c510bfa8$export$6388937ca91ccae8; });
$parcel$export(module.exports, "__spreadArray", function () { return $cdd703b1c510bfa8$export$1216008129fb82ed; });
$parcel$export(module.exports, "__importDefault", function () { return $cdd703b1c510bfa8$export$da59b14a69baef04; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $cdd703b1c510bfa8$var$extendStatics = function(d, b) {
    $cdd703b1c510bfa8$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $cdd703b1c510bfa8$var$extendStatics(d, b);
};
function $cdd703b1c510bfa8$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $cdd703b1c510bfa8$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $cdd703b1c510bfa8$export$18ce0697a983be9b = function() {
    $cdd703b1c510bfa8$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $cdd703b1c510bfa8$export$18ce0697a983be9b.apply(this, arguments);
};
function $cdd703b1c510bfa8$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $cdd703b1c510bfa8$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $cdd703b1c510bfa8$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $cdd703b1c510bfa8$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $cdd703b1c510bfa8$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $cdd703b1c510bfa8$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $cdd703b1c510bfa8$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $cdd703b1c510bfa8$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $cdd703b1c510bfa8$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $cdd703b1c510bfa8$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $cdd703b1c510bfa8$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $cdd703b1c510bfa8$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $cdd703b1c510bfa8$export$45d3717a4c69092e(o, m, p);
}
function $cdd703b1c510bfa8$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $cdd703b1c510bfa8$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $cdd703b1c510bfa8$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($cdd703b1c510bfa8$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $cdd703b1c510bfa8$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $cdd703b1c510bfa8$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $cdd703b1c510bfa8$export$10c90e4f7922046c(v) {
    return this instanceof $cdd703b1c510bfa8$export$10c90e4f7922046c ? (this.v = v, this) : new $cdd703b1c510bfa8$export$10c90e4f7922046c(v);
}
function $cdd703b1c510bfa8$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $cdd703b1c510bfa8$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $cdd703b1c510bfa8$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $cdd703b1c510bfa8$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $cdd703b1c510bfa8$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $cdd703b1c510bfa8$export$19a8beecd37a4c45 === "function" ? $cdd703b1c510bfa8$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $cdd703b1c510bfa8$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $cdd703b1c510bfa8$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $cdd703b1c510bfa8$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $cdd703b1c510bfa8$export$45d3717a4c69092e(result, mod, k);
    }
    $cdd703b1c510bfa8$var$__setModuleDefault(result, mod);
    return result;
}
function $cdd703b1c510bfa8$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $cdd703b1c510bfa8$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $cdd703b1c510bfa8$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $cdd703b1c510bfa8$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $cdd703b1c510bfa8$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $cdd703b1c510bfa8$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $cdd703b1c510bfa8$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $cdd703b1c510bfa8$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $cdd703b1c510bfa8$export$2e2bcd8739ae039 = {
    __extends: $cdd703b1c510bfa8$export$a8ba968b8961cb8a,
    __assign: $cdd703b1c510bfa8$export$18ce0697a983be9b,
    __rest: $cdd703b1c510bfa8$export$3c9a16f847548506,
    __decorate: $cdd703b1c510bfa8$export$29e00dfd3077644b,
    __param: $cdd703b1c510bfa8$export$d5ad3fd78186038f,
    __metadata: $cdd703b1c510bfa8$export$f1db080c865becb9,
    __awaiter: $cdd703b1c510bfa8$export$1050f835b63b671e,
    __generator: $cdd703b1c510bfa8$export$67ebef60e6f28a6,
    __createBinding: $cdd703b1c510bfa8$export$45d3717a4c69092e,
    __exportStar: $cdd703b1c510bfa8$export$f33643c0debef087,
    __values: $cdd703b1c510bfa8$export$19a8beecd37a4c45,
    __read: $cdd703b1c510bfa8$export$8d051b38c9118094,
    __spread: $cdd703b1c510bfa8$export$afc72e2116322959,
    __spreadArrays: $cdd703b1c510bfa8$export$6388937ca91ccae8,
    __spreadArray: $cdd703b1c510bfa8$export$1216008129fb82ed,
    __await: $cdd703b1c510bfa8$export$10c90e4f7922046c,
    __asyncGenerator: $cdd703b1c510bfa8$export$e427f37a30a4de9b,
    __asyncDelegator: $cdd703b1c510bfa8$export$bbd80228419bb833,
    __asyncValues: $cdd703b1c510bfa8$export$e3b29a3d6162315f,
    __makeTemplateObject: $cdd703b1c510bfa8$export$4fb47efe1390b86f,
    __importStar: $cdd703b1c510bfa8$export$c21735bcef00d192,
    __importDefault: $cdd703b1c510bfa8$export$da59b14a69baef04,
    __classPrivateFieldGet: $cdd703b1c510bfa8$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $cdd703b1c510bfa8$export$d40a35129aaff81f,
    __classPrivateFieldIn: $cdd703b1c510bfa8$export$81fdc39f203e4e04,
    __addDisposableResource: $cdd703b1c510bfa8$export$88ac25d8e944e405,
    __disposeResources: $cdd703b1c510bfa8$export$8f076105dc360e92
};

});

parcelRegister("dmK2Y", function(module, exports) {

var $lqfB0 = parcelRequire("lqfB0");
var $9bb10c62c3c519a4$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $9bb10c62c3c519a4$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $lqfB0.default)(function(prop) {
    return $9bb10c62c3c519a4$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});
parcelRegister("lqfB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9881facedf34790$export$2e2bcd8739ae039; });
function $f9881facedf34790$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("awgDS", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("3znPo", function(module, exports) {

$parcel$export(module.exports, "compile", function () { return $29971fbb7ce9a5ad$export$ef7acd7185315e22; });

var $ll93R = parcelRequire("ll93R");

var $dYvPI = parcelRequire("dYvPI");

var $c2E28 = parcelRequire("c2E28");
function $29971fbb7ce9a5ad$export$ef7acd7185315e22(value) {
    return (0, $c2E28.dealloc)($29971fbb7ce9a5ad$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], value = (0, $c2E28.alloc)(value), 0, [
        0
    ], value));
}
function $29971fbb7ce9a5ad$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = "";
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $c2E28.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $dYvPI.charat)(characters, length - 1) == 58) {
                if ((0, $dYvPI.indexof)(characters += (0, $dYvPI.replace)((0, $c2E28.delimit)(character), "&", "&\f"), "&\f", (0, $dYvPI.abs)(index ? points[index - 1] : 0)) != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $c2E28.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $c2E28.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $c2E28.escaping)((0, $c2E28.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $c2E28.peek)()){
                case 42:
                case 47:
                    (0, $dYvPI.append)($29971fbb7ce9a5ad$export$4a34f930e789283c((0, $c2E28.commenter)((0, $c2E28.next)(), (0, $c2E28.caret)()), root, parent, declarations), declarations);
                    break;
                default:
                    characters += "/";
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $dYvPI.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $dYvPI.replace)(characters, /\f/g, "");
                    if (property > 0 && (0, $dYvPI.strlen)(characters) - length) (0, $dYvPI.append)(property > 32 ? $29971fbb7ce9a5ad$export$f8483753829ec8f3(characters + ";", rule, parent, length - 1, declarations) : $29971fbb7ce9a5ad$export$f8483753829ec8f3((0, $dYvPI.replace)(characters, " ", "") + ";", rule, parent, length - 2, declarations), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ";";
                // { rule/at-rule
                default:
                    (0, $dYvPI.append)(reference = $29971fbb7ce9a5ad$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length, rulesets), rulesets);
                    if (character === 123) {
                        if (offset === 0) $29971fbb7ce9a5ad$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $dYvPI.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $29971fbb7ce9a5ad$export$98e6a39c04603d36(value, reference, reference, rule && (0, $dYvPI.append)($29971fbb7ce9a5ad$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length, children), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $29971fbb7ce9a5ad$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ""
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = "", length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $dYvPI.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $c2E28.prev)() == 125) continue;
            }
            switch(characters += (0, $dYvPI.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += "\f", -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $dYvPI.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $c2E28.peek)() === 45) characters += (0, $c2E28.delimit)((0, $c2E28.next)());
                    atrule = (0, $c2E28.peek)(), offset = length = (0, $dYvPI.strlen)(type = characters += (0, $c2E28.identifier)((0, $c2E28.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $dYvPI.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $29971fbb7ce9a5ad$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length, siblings) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ""
    ];
    var size = (0, $dYvPI.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $dYvPI.substr)(value, post + 1, post = (0, $dYvPI.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $dYvPI.trim)(j > 0 ? rule[x] + " " + y : (0, $dYvPI.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $c2E28.node)(value, root, parent, offset === 0 ? (0, $ll93R.RULESET) : type, props, children, length, siblings);
}
function $29971fbb7ce9a5ad$export$4a34f930e789283c(value, root, parent, siblings) {
    return (0, $c2E28.node)(value, root, parent, (0, $ll93R.COMMENT), (0, $dYvPI.from)((0, $c2E28.char)()), (0, $dYvPI.substr)(value, 2, -2), 0, siblings);
}
function $29971fbb7ce9a5ad$export$f8483753829ec8f3(value, root, parent, length, siblings) {
    return (0, $c2E28.node)(value, root, parent, (0, $ll93R.DECLARATION), (0, $dYvPI.substr)(value, 0, length), (0, $dYvPI.substr)(value, length + 1, -1), length, siblings);
}

});
parcelRegister("ll93R", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $f89296895e9dbffd$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $f89296895e9dbffd$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $f89296895e9dbffd$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "COMMENT", function () { return $f89296895e9dbffd$export$a29989082612d0d9; });
$parcel$export(module.exports, "RULESET", function () { return $f89296895e9dbffd$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $f89296895e9dbffd$export$527d108ccf083c2b; });
$parcel$export(module.exports, "IMPORT", function () { return $f89296895e9dbffd$export$a763edbf796b780a; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $f89296895e9dbffd$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "LAYER", function () { return $f89296895e9dbffd$export$d773506282b3cfe6; });
var $f89296895e9dbffd$export$71ad59f2e432cfe8 = "-ms-";
var $f89296895e9dbffd$export$2c0f367103c8d01c = "-moz-";
var $f89296895e9dbffd$export$39dfd62a25e0fe93 = "-webkit-";
var $f89296895e9dbffd$export$a29989082612d0d9 = "comm";
var $f89296895e9dbffd$export$aa3a2e812ca8570d = "rule";
var $f89296895e9dbffd$export$527d108ccf083c2b = "decl";
var $f89296895e9dbffd$export$d3d35020fa5b54f0 = "@page";
var $f89296895e9dbffd$export$500415a86c544f73 = "@media";
var $f89296895e9dbffd$export$a763edbf796b780a = "@import";
var $f89296895e9dbffd$export$2790aeb8b4e5c826 = "@charset";
var $f89296895e9dbffd$export$1cc683e23b84b133 = "@viewport";
var $f89296895e9dbffd$export$9447a5efea57e862 = "@supports";
var $f89296895e9dbffd$export$ef011b4e114b1fba = "@document";
var $f89296895e9dbffd$export$6aad947bda0f3f46 = "@namespace";
var $f89296895e9dbffd$export$b44a8529a35fcb60 = "@keyframes";
var $f89296895e9dbffd$export$2c16de31893252e6 = "@font-face";
var $f89296895e9dbffd$export$3d846dd52e150c6f = "@counter-style";
var $f89296895e9dbffd$export$22314bfbb57653fe = "@font-feature-values";
var $f89296895e9dbffd$export$d773506282b3cfe6 = "@layer";
var $f89296895e9dbffd$export$1c5a554c78c0cd12 = "@scope";

});

parcelRegister("dYvPI", function(module, exports) {

$parcel$export(module.exports, "abs", function () { return $a2c99255e2359298$export$2335f513bbd82c6d; });
$parcel$export(module.exports, "from", function () { return $a2c99255e2359298$export$6788812c4e6611e6; });
$parcel$export(module.exports, "assign", function () { return $a2c99255e2359298$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "hash", function () { return $a2c99255e2359298$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $a2c99255e2359298$export$a9db5e087081082d; });
$parcel$export(module.exports, "trim", function () { return $a2c99255e2359298$export$87c2784dc9fc4ab; });
$parcel$export(module.exports, "match", function () { return $a2c99255e2359298$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $a2c99255e2359298$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $a2c99255e2359298$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "substr", function () { return $a2c99255e2359298$export$2f35ab04d2335697; });
$parcel$export(module.exports, "strlen", function () { return $a2c99255e2359298$export$36776f635604f274; });
$parcel$export(module.exports, "sizeof", function () { return $a2c99255e2359298$export$f9084667e487ed46; });
$parcel$export(module.exports, "append", function () { return $a2c99255e2359298$export$10d8903dec122b9d; });
$parcel$export(module.exports, "combine", function () { return $a2c99255e2359298$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "filter", function () { return $a2c99255e2359298$export$3dea766d36a8935f; });
/**
 * @param {number}
 * @return {number}
 */ var $a2c99255e2359298$export$2335f513bbd82c6d = Math.abs;
var $a2c99255e2359298$export$6788812c4e6611e6 = String.fromCharCode;
var $a2c99255e2359298$export$e6e34fd1f2686227 = Object.assign;
function $a2c99255e2359298$export$d6af199866bfb566(value, length) {
    return $a2c99255e2359298$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $a2c99255e2359298$export$a9db5e087081082d(value, 0)) << 2 ^ $a2c99255e2359298$export$a9db5e087081082d(value, 1)) << 2 ^ $a2c99255e2359298$export$a9db5e087081082d(value, 2)) << 2 ^ $a2c99255e2359298$export$a9db5e087081082d(value, 3) : 0;
}
function $a2c99255e2359298$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $a2c99255e2359298$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $a2c99255e2359298$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $a2c99255e2359298$export$f8e21b1e77979a08(value, search, position) {
    return value.indexOf(search, position);
}
function $a2c99255e2359298$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $a2c99255e2359298$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $a2c99255e2359298$export$36776f635604f274(value) {
    return value.length;
}
function $a2c99255e2359298$export$f9084667e487ed46(value) {
    return value.length;
}
function $a2c99255e2359298$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $a2c99255e2359298$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join("");
}
function $a2c99255e2359298$export$3dea766d36a8935f(array, pattern) {
    return array.filter(function(value) {
        return !$a2c99255e2359298$export$4659b591c19bdf3d(value, pattern);
    });
}

});

parcelRegister("c2E28", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $8c44b9b8c9dcc38a$export$35059013cd4a06db; });
$parcel$export(module.exports, "copy", function () { return $8c44b9b8c9dcc38a$export$784d13d8ee351f07; });
$parcel$export(module.exports, "lift", function () { return $8c44b9b8c9dcc38a$export$590e8b2c435046d9; });
$parcel$export(module.exports, "char", function () { return $8c44b9b8c9dcc38a$export$eba6f6f03b0a92e7; });
$parcel$export(module.exports, "prev", function () { return $8c44b9b8c9dcc38a$export$232faf9add678146; });
$parcel$export(module.exports, "next", function () { return $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $8c44b9b8c9dcc38a$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "caret", function () { return $8c44b9b8c9dcc38a$export$e88cb2efb12ae807; });
$parcel$export(module.exports, "alloc", function () { return $8c44b9b8c9dcc38a$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $8c44b9b8c9dcc38a$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $8c44b9b8c9dcc38a$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "tokenize", function () { return $8c44b9b8c9dcc38a$export$660b2ee2d4fb4eff; });
$parcel$export(module.exports, "whitespace", function () { return $8c44b9b8c9dcc38a$export$7af1228ff777d175; });
$parcel$export(module.exports, "identifier", function () { return $8c44b9b8c9dcc38a$export$c2ab62c7bf24634; });
$parcel$export(module.exports, "escaping", function () { return $8c44b9b8c9dcc38a$export$955ba06d119e085e; });
$parcel$export(module.exports, "commenter", function () { return $8c44b9b8c9dcc38a$export$4254d4e2b3745c4c; });

var $dYvPI = parcelRequire("dYvPI");
var $8c44b9b8c9dcc38a$export$53f1d5ea8de3d7c = 1;
var $8c44b9b8c9dcc38a$export$4e0c71f277ca26b3 = 1;
var $8c44b9b8c9dcc38a$export$f24224f1c91d8156 = 0;
var $8c44b9b8c9dcc38a$export$5880b8b5730aff45 = 0;
var $8c44b9b8c9dcc38a$export$c0306caf338ac095 = 0;
var $8c44b9b8c9dcc38a$export$30a86d91af8ff6e6 = "";
function $8c44b9b8c9dcc38a$export$35059013cd4a06db(value, root, parent, type, props, children, length, siblings) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $8c44b9b8c9dcc38a$export$53f1d5ea8de3d7c,
        column: $8c44b9b8c9dcc38a$export$4e0c71f277ca26b3,
        length: length,
        return: "",
        siblings: siblings
    };
}
function $8c44b9b8c9dcc38a$export$784d13d8ee351f07(root, props) {
    return (0, $dYvPI.assign)($8c44b9b8c9dcc38a$export$35059013cd4a06db("", null, null, "", null, null, 0, root.siblings), root, {
        length: -root.length
    }, props);
}
function $8c44b9b8c9dcc38a$export$590e8b2c435046d9(root) {
    while(root.root)root = $8c44b9b8c9dcc38a$export$784d13d8ee351f07(root.root, {
        children: [
            root
        ]
    });
    (0, $dYvPI.append)(root, root.siblings);
}
function $8c44b9b8c9dcc38a$export$eba6f6f03b0a92e7() {
    return $8c44b9b8c9dcc38a$export$c0306caf338ac095;
}
function $8c44b9b8c9dcc38a$export$232faf9add678146() {
    $8c44b9b8c9dcc38a$export$c0306caf338ac095 = $8c44b9b8c9dcc38a$export$5880b8b5730aff45 > 0 ? (0, $dYvPI.charat)($8c44b9b8c9dcc38a$export$30a86d91af8ff6e6, --$8c44b9b8c9dcc38a$export$5880b8b5730aff45) : 0;
    if ($8c44b9b8c9dcc38a$export$4e0c71f277ca26b3--, $8c44b9b8c9dcc38a$export$c0306caf338ac095 === 10) $8c44b9b8c9dcc38a$export$4e0c71f277ca26b3 = 1, $8c44b9b8c9dcc38a$export$53f1d5ea8de3d7c--;
    return $8c44b9b8c9dcc38a$export$c0306caf338ac095;
}
function $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f() {
    $8c44b9b8c9dcc38a$export$c0306caf338ac095 = $8c44b9b8c9dcc38a$export$5880b8b5730aff45 < $8c44b9b8c9dcc38a$export$f24224f1c91d8156 ? (0, $dYvPI.charat)($8c44b9b8c9dcc38a$export$30a86d91af8ff6e6, $8c44b9b8c9dcc38a$export$5880b8b5730aff45++) : 0;
    if ($8c44b9b8c9dcc38a$export$4e0c71f277ca26b3++, $8c44b9b8c9dcc38a$export$c0306caf338ac095 === 10) $8c44b9b8c9dcc38a$export$4e0c71f277ca26b3 = 1, $8c44b9b8c9dcc38a$export$53f1d5ea8de3d7c++;
    return $8c44b9b8c9dcc38a$export$c0306caf338ac095;
}
function $8c44b9b8c9dcc38a$export$4d3fb11e950abb9e() {
    return (0, $dYvPI.charat)($8c44b9b8c9dcc38a$export$30a86d91af8ff6e6, $8c44b9b8c9dcc38a$export$5880b8b5730aff45);
}
function $8c44b9b8c9dcc38a$export$e88cb2efb12ae807() {
    return $8c44b9b8c9dcc38a$export$5880b8b5730aff45;
}
function $8c44b9b8c9dcc38a$export$58adb3bec8346d0f(begin, end) {
    return (0, $dYvPI.substr)($8c44b9b8c9dcc38a$export$30a86d91af8ff6e6, begin, end);
}
function $8c44b9b8c9dcc38a$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $8c44b9b8c9dcc38a$export$2de70f21292aac9e(value) {
    return $8c44b9b8c9dcc38a$export$53f1d5ea8de3d7c = $8c44b9b8c9dcc38a$export$4e0c71f277ca26b3 = 1, $8c44b9b8c9dcc38a$export$f24224f1c91d8156 = (0, $dYvPI.strlen)($8c44b9b8c9dcc38a$export$30a86d91af8ff6e6 = value), $8c44b9b8c9dcc38a$export$5880b8b5730aff45 = 0, [];
}
function $8c44b9b8c9dcc38a$export$45918ac1574455b1(value) {
    return $8c44b9b8c9dcc38a$export$30a86d91af8ff6e6 = "", value;
}
function $8c44b9b8c9dcc38a$export$410ac95b9ec204b8(type) {
    return (0, $dYvPI.trim)($8c44b9b8c9dcc38a$export$58adb3bec8346d0f($8c44b9b8c9dcc38a$export$5880b8b5730aff45 - 1, $8c44b9b8c9dcc38a$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $8c44b9b8c9dcc38a$export$660b2ee2d4fb4eff(value) {
    return $8c44b9b8c9dcc38a$export$45918ac1574455b1($8c44b9b8c9dcc38a$export$5f8c09e3ae6f64e1($8c44b9b8c9dcc38a$export$2de70f21292aac9e(value)));
}
function $8c44b9b8c9dcc38a$export$7af1228ff777d175(type) {
    while($8c44b9b8c9dcc38a$export$c0306caf338ac095 = $8c44b9b8c9dcc38a$export$4d3fb11e950abb9e())if ($8c44b9b8c9dcc38a$export$c0306caf338ac095 < 33) $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f();
    else break;
    return $8c44b9b8c9dcc38a$export$9e1725a4cfeada27(type) > 2 || $8c44b9b8c9dcc38a$export$9e1725a4cfeada27($8c44b9b8c9dcc38a$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $8c44b9b8c9dcc38a$export$5f8c09e3ae6f64e1(children) {
    while($8c44b9b8c9dcc38a$export$48cfd1e771a65c4f())switch($8c44b9b8c9dcc38a$export$9e1725a4cfeada27($8c44b9b8c9dcc38a$export$c0306caf338ac095)){
        case 0:
            (0, $dYvPI.append)($8c44b9b8c9dcc38a$export$c2ab62c7bf24634($8c44b9b8c9dcc38a$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $dYvPI.append)($8c44b9b8c9dcc38a$export$410ac95b9ec204b8($8c44b9b8c9dcc38a$export$c0306caf338ac095), children);
            break;
        default:
            (0, $dYvPI.append)((0, $dYvPI.from)($8c44b9b8c9dcc38a$export$c0306caf338ac095), children);
    }
    return children;
}
function $8c44b9b8c9dcc38a$export$955ba06d119e085e(index, count) {
    while(--count && $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($8c44b9b8c9dcc38a$export$c0306caf338ac095 < 48 || $8c44b9b8c9dcc38a$export$c0306caf338ac095 > 102 || $8c44b9b8c9dcc38a$export$c0306caf338ac095 > 57 && $8c44b9b8c9dcc38a$export$c0306caf338ac095 < 65 || $8c44b9b8c9dcc38a$export$c0306caf338ac095 > 70 && $8c44b9b8c9dcc38a$export$c0306caf338ac095 < 97) break;
    return $8c44b9b8c9dcc38a$export$58adb3bec8346d0f(index, $8c44b9b8c9dcc38a$export$e88cb2efb12ae807() + (count < 6 && $8c44b9b8c9dcc38a$export$4d3fb11e950abb9e() == 32 && $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f() == 32));
}
function $8c44b9b8c9dcc38a$export$c889f2fcc19dbf12(type) {
    while($8c44b9b8c9dcc38a$export$48cfd1e771a65c4f())switch($8c44b9b8c9dcc38a$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $8c44b9b8c9dcc38a$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $8c44b9b8c9dcc38a$export$c889f2fcc19dbf12($8c44b9b8c9dcc38a$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $8c44b9b8c9dcc38a$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f();
            break;
    }
    return $8c44b9b8c9dcc38a$export$5880b8b5730aff45;
}
function $8c44b9b8c9dcc38a$export$4254d4e2b3745c4c(type, index) {
    while($8c44b9b8c9dcc38a$export$48cfd1e771a65c4f())// //
    if (type + $8c44b9b8c9dcc38a$export$c0306caf338ac095 === 57) break;
    else if (type + $8c44b9b8c9dcc38a$export$c0306caf338ac095 === 84 && $8c44b9b8c9dcc38a$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $8c44b9b8c9dcc38a$export$58adb3bec8346d0f(index, $8c44b9b8c9dcc38a$export$5880b8b5730aff45 - 1) + "*" + (0, $dYvPI.from)(type === 47 ? type : $8c44b9b8c9dcc38a$export$48cfd1e771a65c4f());
}
function $8c44b9b8c9dcc38a$export$c2ab62c7bf24634(index) {
    while(!$8c44b9b8c9dcc38a$export$9e1725a4cfeada27($8c44b9b8c9dcc38a$export$4d3fb11e950abb9e()))$8c44b9b8c9dcc38a$export$48cfd1e771a65c4f();
    return $8c44b9b8c9dcc38a$export$58adb3bec8346d0f(index, $8c44b9b8c9dcc38a$export$5880b8b5730aff45);
}

});


parcelRegister("1RKWh", function(module, exports) {

$parcel$export(module.exports, "middleware", function () { return $15bf26c7439d1356$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $15bf26c7439d1356$export$38bcb760f1d4871c; });
$parcel$export(module.exports, "prefixer", function () { return $15bf26c7439d1356$export$e08c7d021b829b7a; });

var $ll93R = parcelRequire("ll93R");

var $dYvPI = parcelRequire("dYvPI");

var $c2E28 = parcelRequire("c2E28");

var $e8dyh = parcelRequire("e8dyh");

var $knRUC = parcelRequire("knRUC");
function $15bf26c7439d1356$export$5a7767152ae0305f(collection) {
    var length = (0, $dYvPI.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = "";
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || "";
        return output;
    };
}
function $15bf26c7439d1356$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $15bf26c7439d1356$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $ll93R.DECLARATION:
                element.return = (0, $knRUC.prefix)(element.value, element.length, children);
                return;
            case 0, $ll93R.KEYFRAMES:
                return (0, $e8dyh.serialize)([
                    (0, $c2E28.copy)(element, {
                        value: (0, $dYvPI.replace)(element.value, "@", "@" + (0, $ll93R.WEBKIT))
                    })
                ], callback);
            case 0, $ll93R.RULESET:
                if (element.length) return (0, $dYvPI.combine)(children = element.props, function(value) {
                    switch((0, $dYvPI.match)(value, callback = /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    (0, $dYvPI.replace)(value, /:(read-\w+)/, ":" + (0, $ll93R.MOZ) + "$1")
                                ]
                            }));
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $dYvPI.assign)(element, {
                                props: (0, $dYvPI.filter)(children, callback)
                            });
                            break;
                        // :placeholder
                        case "::placeholder":
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    (0, $dYvPI.replace)(value, /:(plac\w+)/, ":" + (0, $ll93R.WEBKIT) + "input-$1")
                                ]
                            }));
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    (0, $dYvPI.replace)(value, /:(plac\w+)/, ":" + (0, $ll93R.MOZ) + "$1")
                                ]
                            }));
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    (0, $dYvPI.replace)(value, /:(plac\w+)/, (0, $ll93R.MS) + "input-$1")
                                ]
                            }));
                            (0, $c2E28.lift)((0, $c2E28.copy)(element, {
                                props: [
                                    value
                                ]
                            }));
                            (0, $dYvPI.assign)(element, {
                                props: (0, $dYvPI.filter)(children, callback)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $15bf26c7439d1356$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $ll93R.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $dYvPI.combine)((0, $c2E28.tokenize)(value), function(value, index, children) {
                    switch((0, $dYvPI.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $dYvPI.substr)(value, 1, (0, $dYvPI.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === "global") children[index] = "", children[++index] = "\f" + (0, $dYvPI.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? "" : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $dYvPI.sizeof)(children) > 1 ? "" : value;
                                case index = (0, $dYvPI.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("e8dyh", function(module, exports) {

$parcel$export(module.exports, "serialize", function () { return $a49c532ffd153b8d$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $a49c532ffd153b8d$export$fac44ee5b035f737; });

var $ll93R = parcelRequire("ll93R");

var $dYvPI = parcelRequire("dYvPI");
function $a49c532ffd153b8d$export$dfdc1655ccc5b9cb(children, callback) {
    var output = "";
    for(var i = 0; i < children.length; i++)output += callback(children[i], i, children, callback) || "";
    return output;
}
function $a49c532ffd153b8d$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $ll93R.LAYER:
            if (element.children.length) break;
        case 0, $ll93R.IMPORT:
        case 0, $ll93R.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $ll93R.COMMENT:
            return "";
        case 0, $ll93R.KEYFRAMES:
            return element.return = element.value + "{" + $a49c532ffd153b8d$export$dfdc1655ccc5b9cb(element.children, callback) + "}";
        case 0, $ll93R.RULESET:
            if (!(0, $dYvPI.strlen)(element.value = element.props.join(","))) return "";
    }
    return (0, $dYvPI.strlen)(children = $a49c532ffd153b8d$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

});

parcelRegister("knRUC", function(module, exports) {

$parcel$export(module.exports, "prefix", function () { return $ed6fc6783bfc4fd3$export$82e9f45cca5ba907; });

var $ll93R = parcelRequire("ll93R");

var $dYvPI = parcelRequire("dYvPI");
function $ed6fc6783bfc4fd3$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $dYvPI.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $ll93R.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $ll93R.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $ll93R.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MOZ) + value + (0, $ll93R.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $dYvPI.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + value + value;
        // order
        case 6165:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $ll93R.WEBKIT) + value + (0, $dYvPI.replace)(value, /(\w+).+(:[^]+)/, (0, $ll93R.WEBKIT) + "box-$1$2" + (0, $ll93R.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + "flex-item-" + (0, $dYvPI.replace)(value, /flex-|-self/g, "") + (!(0, $dYvPI.match)(value, /flex-|baseline/) ? (0, $ll93R.MS) + "grid-row-" + (0, $dYvPI.replace)(value, /flex-|-self/g, "") : "") + value;
        // align-content
        case 4675:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + "flex-line-pack" + (0, $dYvPI.replace)(value, /align-content|flex-|-self/g, "") + value;
        // flex-shrink
        case 5548:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $ll93R.WEBKIT) + "box-" + (0, $dYvPI.replace)(value, "-grow", "") + (0, $ll93R.WEBKIT) + value + (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $ll93R.WEBKIT) + (0, $dYvPI.replace)(value, /([^-])(transform)/g, "$1" + (0, $ll93R.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $dYvPI.replace)((0, $dYvPI.replace)((0, $dYvPI.replace)(value, /(zoom-|grab)/, (0, $ll93R.WEBKIT) + "$1"), /(image-set)/, (0, $ll93R.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $dYvPI.replace)(value, /(image-set\([^]*)/, (0, $ll93R.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $dYvPI.replace)((0, $dYvPI.replace)(value, /(.+:)(flex-)?(.*)/, (0, $ll93R.WEBKIT) + "box-pack:$3" + (0, $ll93R.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $ll93R.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $dYvPI.match)(value, /flex-|baseline/)) return (0, $ll93R.MS) + "grid-column-align" + (0, $dYvPI.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "template-", "") + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $dYvPI.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $dYvPI.indexof)(value + (children = children[length].value), "span", 0) ? value : (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "-start", "") + value + (0, $ll93R.MS) + "grid-row-span:" + (~(0, $dYvPI.indexof)(children, "span", 0) ? (0, $dYvPI.match)(children, /\d+/) : +(0, $dYvPI.match)(children, /\d+/) - +(0, $dYvPI.match)(value, /\d+/)) + ";";
            return (0, $ll93R.MS) + (0, $dYvPI.replace)(value, "-start", "") + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $dYvPI.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $ll93R.MS) + (0, $dYvPI.replace)((0, $dYvPI.replace)(value, "-end", "-span"), "span ", "") + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $dYvPI.replace)(value, /(.+)-inline(.+)/, (0, $ll93R.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $dYvPI.strlen)(value) - 1 - length > 6) switch((0, $dYvPI.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $dYvPI.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $dYvPI.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $ll93R.WEBKIT) + "$2-$3" + "$1" + (0, $ll93R.MOZ) + ((0, $dYvPI.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $dYvPI.indexof)(value, "stretch", 0) ? $ed6fc6783bfc4fd3$export$82e9f45cca5ba907((0, $dYvPI.replace)(value, "stretch", "fill-available"), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $dYvPI.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $ll93R.MS) + a + ":" + b + f + (c ? (0, $ll93R.MS) + a + "-span:" + (d ? e : +e - +b) + f : "") + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $dYvPI.charat)(value, length + 6) === 121) return (0, $dYvPI.replace)(value, ":", ":" + (0, $ll93R.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $dYvPI.charat)(value, (0, $dYvPI.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $dYvPI.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + (0, $ll93R.WEBKIT) + ((0, $dYvPI.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $ll93R.WEBKIT) + "$2$3" + "$1" + (0, $ll93R.MS) + "$2box$3") + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $dYvPI.replace)(value, ":", ":" + (0, $ll93R.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $dYvPI.replace)(value, "scroll-", "scroll-snap-") + value;
    }
    return value;
}

});


parcelRegister("8vGfR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6321feec59ec2af2$export$2e2bcd8739ae039; });
var $6321feec59ec2af2$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("XAEGR", function(module, exports) {
// shim for using process in browser
var $0b31f1c7efe34270$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $0b31f1c7efe34270$var$cachedSetTimeout;
var $0b31f1c7efe34270$var$cachedClearTimeout;
function $0b31f1c7efe34270$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $0b31f1c7efe34270$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $0b31f1c7efe34270$var$cachedSetTimeout = setTimeout;
        else $0b31f1c7efe34270$var$cachedSetTimeout = $0b31f1c7efe34270$var$defaultSetTimout;
    } catch (e) {
        $0b31f1c7efe34270$var$cachedSetTimeout = $0b31f1c7efe34270$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $0b31f1c7efe34270$var$cachedClearTimeout = clearTimeout;
        else $0b31f1c7efe34270$var$cachedClearTimeout = $0b31f1c7efe34270$var$defaultClearTimeout;
    } catch (e) {
        $0b31f1c7efe34270$var$cachedClearTimeout = $0b31f1c7efe34270$var$defaultClearTimeout;
    }
})();
function $0b31f1c7efe34270$var$runTimeout(fun) {
    if ($0b31f1c7efe34270$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($0b31f1c7efe34270$var$cachedSetTimeout === $0b31f1c7efe34270$var$defaultSetTimout || !$0b31f1c7efe34270$var$cachedSetTimeout) && setTimeout) {
        $0b31f1c7efe34270$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0b31f1c7efe34270$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $0b31f1c7efe34270$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $0b31f1c7efe34270$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $0b31f1c7efe34270$var$runClearTimeout(marker) {
    if ($0b31f1c7efe34270$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($0b31f1c7efe34270$var$cachedClearTimeout === $0b31f1c7efe34270$var$defaultClearTimeout || !$0b31f1c7efe34270$var$cachedClearTimeout) && clearTimeout) {
        $0b31f1c7efe34270$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $0b31f1c7efe34270$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $0b31f1c7efe34270$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $0b31f1c7efe34270$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $0b31f1c7efe34270$var$queue = [];
var $0b31f1c7efe34270$var$draining = false;
var $0b31f1c7efe34270$var$currentQueue;
var $0b31f1c7efe34270$var$queueIndex = -1;
function $0b31f1c7efe34270$var$cleanUpNextTick() {
    if (!$0b31f1c7efe34270$var$draining || !$0b31f1c7efe34270$var$currentQueue) return;
    $0b31f1c7efe34270$var$draining = false;
    if ($0b31f1c7efe34270$var$currentQueue.length) $0b31f1c7efe34270$var$queue = $0b31f1c7efe34270$var$currentQueue.concat($0b31f1c7efe34270$var$queue);
    else $0b31f1c7efe34270$var$queueIndex = -1;
    if ($0b31f1c7efe34270$var$queue.length) $0b31f1c7efe34270$var$drainQueue();
}
function $0b31f1c7efe34270$var$drainQueue() {
    if ($0b31f1c7efe34270$var$draining) return;
    var timeout = $0b31f1c7efe34270$var$runTimeout($0b31f1c7efe34270$var$cleanUpNextTick);
    $0b31f1c7efe34270$var$draining = true;
    var len = $0b31f1c7efe34270$var$queue.length;
    while(len){
        $0b31f1c7efe34270$var$currentQueue = $0b31f1c7efe34270$var$queue;
        $0b31f1c7efe34270$var$queue = [];
        while(++$0b31f1c7efe34270$var$queueIndex < len)if ($0b31f1c7efe34270$var$currentQueue) $0b31f1c7efe34270$var$currentQueue[$0b31f1c7efe34270$var$queueIndex].run();
        $0b31f1c7efe34270$var$queueIndex = -1;
        len = $0b31f1c7efe34270$var$queue.length;
    }
    $0b31f1c7efe34270$var$currentQueue = null;
    $0b31f1c7efe34270$var$draining = false;
    $0b31f1c7efe34270$var$runClearTimeout(timeout);
}
$0b31f1c7efe34270$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $0b31f1c7efe34270$var$queue.push(new $0b31f1c7efe34270$var$Item(fun, args));
    if ($0b31f1c7efe34270$var$queue.length === 1 && !$0b31f1c7efe34270$var$draining) $0b31f1c7efe34270$var$runTimeout($0b31f1c7efe34270$var$drainQueue);
};
// v8 likes predictible objects
function $0b31f1c7efe34270$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$0b31f1c7efe34270$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$0b31f1c7efe34270$var$process.title = "browser";
$0b31f1c7efe34270$var$process.browser = true;
$0b31f1c7efe34270$var$process.env = {};
$0b31f1c7efe34270$var$process.argv = [];
$0b31f1c7efe34270$var$process.version = ""; // empty string to avoid regexp issues
$0b31f1c7efe34270$var$process.versions = {};
function $0b31f1c7efe34270$var$noop() {}
$0b31f1c7efe34270$var$process.on = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.addListener = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.once = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.off = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.removeListener = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.removeAllListeners = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.emit = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.prependListener = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.prependOnceListener = $0b31f1c7efe34270$var$noop;
$0b31f1c7efe34270$var$process.listeners = function(name) {
    return [];
};
$0b31f1c7efe34270$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$0b31f1c7efe34270$var$process.cwd = function() {
    return "/";
};
$0b31f1c7efe34270$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$0b31f1c7efe34270$var$process.umask = function() {
    return 0;
};

});


parcelRegister("6LIwV", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $4ed9ac9919a71107$export$33752cf3ee811995; });

var $iSvIT = parcelRequire("iSvIT");
function $4ed9ac9919a71107$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $4ed9ac9919a71107$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $iSvIT.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $iSvIT.useRef)(true);
    var committed = (0, $iSvIT.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $4ed9ac9919a71107$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $iSvIT.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $4ed9ac9919a71107$export$33752cf3ee811995(callback, inputs) {
    return $4ed9ac9919a71107$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $4ed9ac9919a71107$export$1538c33de8887b59 = $4ed9ac9919a71107$export$b6feb8998cd9b342;
var $4ed9ac9919a71107$export$35808ee640e87ca7 = $4ed9ac9919a71107$export$33752cf3ee811995;

});

parcelRegister("lEO1D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc442362296b5268$export$2e2bcd8739ae039; });

var $hpDko = parcelRequire("hpDko");
var $fc442362296b5268$export$2e2bcd8739ae039 = (0, $hpDko.default);

});
parcelRegister("hpDko", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cad3472f29b019cf$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $cad3472f29b019cf$var$AnalyticsNextContext = (0, $iSvIT.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $cad3472f29b019cf$export$2e2bcd8739ae039 = $cad3472f29b019cf$var$AnalyticsNextContext;

});


parcelRegister("iTUJK", function(module, exports) {

var $i4688 = parcelRequire("i4688");

var $hJIBp = parcelRequire("hJIBp");

var $7pyLt = parcelRequire("7pyLt");

var $2ewwU = parcelRequire("2ewwU");

var $4Wtxi = parcelRequire("4Wtxi");

var $3h3AR = parcelRequire("3h3AR");

var $awYF4 = parcelRequire("awYF4");
function $dc295fc881680285$var$_regeneratorRuntime() {
    "use strict";
    var r = $hJIBp(), e = r.m($dc295fc881680285$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $awYF4(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $dc295fc881680285$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $i4688(r, e);
            },
            AsyncIterator: $4Wtxi,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $2ewwU : $7pyLt)(a(r), e, t, o, u);
            },
            keys: $3h3AR,
            values: $awYF4
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $dc295fc881680285$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("i4688", function(module, exports) {
function $d26d5b1164921053$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $d26d5b1164921053$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hJIBp", function(module, exports) {

var $e6lVx = parcelRequire("e6lVx");
function $ce993cc1e8b439cd$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $e6lVx(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($e6lVx(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $e6lVx(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $e6lVx(u, "constructor", GeneratorFunctionPrototype), $e6lVx(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $e6lVx(GeneratorFunctionPrototype, o, "GeneratorFunction"), $e6lVx(u), $e6lVx(u, o, "Generator"), $e6lVx(u, n, function() {
        return this;
    }), $e6lVx(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $ce993cc1e8b439cd$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $ce993cc1e8b439cd$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("e6lVx", function(module, exports) {
function $a442a27732cf8eef$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $a442a27732cf8eef$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $a442a27732cf8eef$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a442a27732cf8eef$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $a442a27732cf8eef$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7pyLt", function(module, exports) {

var $2ewwU = parcelRequire("2ewwU");
function $5655d5bda341d702$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $2ewwU(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $5655d5bda341d702$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2ewwU", function(module, exports) {

var $hJIBp = parcelRequire("hJIBp");

var $4Wtxi = parcelRequire("4Wtxi");
function $1a061f4f5e6f423e$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $4Wtxi($hJIBp().w(r, e, t, o), n || Promise);
}
module.exports = $1a061f4f5e6f423e$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4Wtxi", function(module, exports) {

var $i4688 = parcelRequire("i4688");

var $e6lVx = parcelRequire("e6lVx");
function $39937d6ccfde10aa$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $i4688 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($e6lVx($39937d6ccfde10aa$var$AsyncIterator.prototype), $e6lVx($39937d6ccfde10aa$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $e6lVx(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $39937d6ccfde10aa$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3h3AR", function(module, exports) {
function $2625bf3cb9f37479$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $2625bf3cb9f37479$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("awYF4", function(module, exports) {

var $l0oHu = parcelRequire("l0oHu");
var $7aabf29fe1b84e48$var$_typeof = $l0oHu.default;
function $7aabf29fe1b84e48$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($7aabf29fe1b84e48$var$_typeof(e) + " is not iterable");
}
module.exports = $7aabf29fe1b84e48$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("l0oHu", function(module, exports) {
function $f4acc212c63eec21$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $f4acc212c63eec21$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $f4acc212c63eec21$var$_typeof(o);
}
module.exports = $f4acc212c63eec21$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("3JARs", function(module, exports) {
"use strict";
var $2b822aefd59332f9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2b822aefd59332f9$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2b822aefd59332f9$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5qykB")).Diagnostics;
    }
});

var $iYT8z = parcelRequire("iYT8z");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $iYT8z.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("55TRz")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("7SwFs")).Storage;
    }
});

$2b822aefd59332f9$var$__exportStar((parcelRequire("dKZ9p")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("hqcc3")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("5KhCn")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("2kIIc")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("5qykB")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("jztfU")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("9Hfh8")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("coZ0K")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("6JTa7")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("jPn3t")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("7EZoX")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("55TRz")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("bOemD")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("gz4N0")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("dPtPJ")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("cQgwj")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("dhnhE")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("1SxnD")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("dUoYx")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("dhpqv")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("uMJd2")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("97ZBs")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("iielb")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("aTw8M")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("bOkHD")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("csUVs")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("1hu68")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("6EaGJ")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("6avte")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("8UvOP")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("1SVzT")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("7SwFs")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("28nWn")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("3g9pm")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("k4L4P")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("jYNV8")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("j1v5J")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("aC8w1")), module.exports);

$2b822aefd59332f9$var$__exportStar((parcelRequire("8Hasm")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("55TRz")).Log,
    SDK_VERSION: (parcelRequire("csUVs")).SDK_VERSION
});

});
parcelRegister("dKZ9p", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $a03f0181cb5b44f9$var$_a, $a03f0181cb5b44f9$var$_b, $a03f0181cb5b44f9$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $55TRz = parcelRequire("55TRz");
const $a03f0181cb5b44f9$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $a03f0181cb5b44f9$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $a03f0181cb5b44f9$var$_getStatsigGlobal;
const $a03f0181cb5b44f9$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $a03f0181cb5b44f9$var$_getStatsigGlobalFlag;
const $a03f0181cb5b44f9$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $55TRz.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $a03f0181cb5b44f9$var$_getInstance;
const $a03f0181cb5b44f9$var$GLOBAL_KEY = "__STATSIG__";
const $a03f0181cb5b44f9$var$_window = typeof window !== "undefined" ? window : {};
const $a03f0181cb5b44f9$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $a03f0181cb5b44f9$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $a03f0181cb5b44f9$var$statsigGlobal = ($a03f0181cb5b44f9$var$_c = ($a03f0181cb5b44f9$var$_b = ($a03f0181cb5b44f9$var$_a = $a03f0181cb5b44f9$var$_window[$a03f0181cb5b44f9$var$GLOBAL_KEY]) !== null && $a03f0181cb5b44f9$var$_a !== void 0 ? $a03f0181cb5b44f9$var$_a : $a03f0181cb5b44f9$var$_global[$a03f0181cb5b44f9$var$GLOBAL_KEY]) !== null && $a03f0181cb5b44f9$var$_b !== void 0 ? $a03f0181cb5b44f9$var$_b : $a03f0181cb5b44f9$var$_globalThis[$a03f0181cb5b44f9$var$GLOBAL_KEY]) !== null && $a03f0181cb5b44f9$var$_c !== void 0 ? $a03f0181cb5b44f9$var$_c : {
    instance: module.exports._getInstance
};
$a03f0181cb5b44f9$var$_window[$a03f0181cb5b44f9$var$GLOBAL_KEY] = $a03f0181cb5b44f9$var$statsigGlobal;
$a03f0181cb5b44f9$var$_global[$a03f0181cb5b44f9$var$GLOBAL_KEY] = $a03f0181cb5b44f9$var$statsigGlobal;
$a03f0181cb5b44f9$var$_globalThis[$a03f0181cb5b44f9$var$GLOBAL_KEY] = $a03f0181cb5b44f9$var$statsigGlobal;

});
parcelRegister("55TRz", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $3b58c09c6103bc1c$var$DEBUG = " DEBUG ";
const $3b58c09c6103bc1c$var$_INFO = "  INFO ";
const $3b58c09c6103bc1c$var$_WARN = "  WARN ";
const $3b58c09c6103bc1c$var$ERROR = " ERROR ";
function $3b58c09c6103bc1c$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $3b58c09c6103bc1c$var$Log {
    static info(...args) {
        if ($3b58c09c6103bc1c$var$Log.level >= module.exports.LogLevel.Info) console.info($3b58c09c6103bc1c$var$_INFO, ...$3b58c09c6103bc1c$var$addTag(args));
    }
    static debug(...args) {
        if ($3b58c09c6103bc1c$var$Log.level >= module.exports.LogLevel.Debug) console.debug($3b58c09c6103bc1c$var$DEBUG, ...$3b58c09c6103bc1c$var$addTag(args));
    }
    static warn(...args) {
        if ($3b58c09c6103bc1c$var$Log.level >= module.exports.LogLevel.Warn) console.warn($3b58c09c6103bc1c$var$_WARN, ...$3b58c09c6103bc1c$var$addTag(args));
    }
    static error(...args) {
        if ($3b58c09c6103bc1c$var$Log.level >= module.exports.LogLevel.Error) console.error($3b58c09c6103bc1c$var$ERROR, ...$3b58c09c6103bc1c$var$addTag(args));
    }
}
module.exports.Log = $3b58c09c6103bc1c$var$Log;
$3b58c09c6103bc1c$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("5qykB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $3f3a02f382a583ea$var$MARKER_MAP = new Map();
const $3f3a02f382a583ea$var$ACT_START = "start";
const $3f3a02f382a583ea$var$ACT_END = "end";
const $3f3a02f382a583ea$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $3f3a02f382a583ea$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker({}, $3f3a02f382a583ea$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $3f3a02f382a583ea$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker(data, $3f3a02f382a583ea$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker(data, $3f3a02f382a583ea$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker({}, $3f3a02f382a583ea$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $3f3a02f382a583ea$var$_addMarker(sdkKey, $3f3a02f382a583ea$var$_createMarker(data, $3f3a02f382a583ea$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $3f3a02f382a583ea$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $3f3a02f382a583ea$var$_safeGetField(e, "code"),
            name: $3f3a02f382a583ea$var$_safeGetField(e, "name"),
            message: $3f3a02f382a583ea$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $3f3a02f382a583ea$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $3f3a02f382a583ea$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $3f3a02f382a583ea$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $3f3a02f382a583ea$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $3f3a02f382a583ea$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $3f3a02f382a583ea$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $3f3a02f382a583ea$var$MARKER_MAP.set(sdkKey, markers);
}
function $3f3a02f382a583ea$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("iYT8z", function(module, exports) {
"use strict";
var $dd1899b3dddfdeca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $hqcc3 = parcelRequire("hqcc3");

var $jPn3t = parcelRequire("jPn3t");

var $55TRz = parcelRequire("55TRz");

var $gz4N0 = parcelRequire("gz4N0");

var $1SxnD = parcelRequire("1SxnD");

var $bOkHD = parcelRequire("bOkHD");

var $7SwFs = parcelRequire("7SwFs");

var $k4L4P = parcelRequire("k4L4P");

var $j1v5J = parcelRequire("j1v5J");
const $dd1899b3dddfdeca$var$DEFAULT_QUEUE_SIZE = 100;
const $dd1899b3dddfdeca$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $dd1899b3dddfdeca$var$MAX_DEDUPER_KEYS = 1000;
const $dd1899b3dddfdeca$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $dd1899b3dddfdeca$var$MAX_FAILED_LOGS = 500;
const $dd1899b3dddfdeca$var$QUICK_FLUSH_WINDOW_MS = 200;
const $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP = {};
const $dd1899b3dddfdeca$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $dd1899b3dddfdeca$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($dd1899b3dddfdeca$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $dd1899b3dddfdeca$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $k4L4P.UrlConfiguration($gz4N0.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $dd1899b3dddfdeca$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $1SxnD._isServerEnv)()) return; // do not run in server environments
        $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $j1v5J._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $dd1899b3dddfdeca$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $dd1899b3dddfdeca$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($dd1899b3dddfdeca$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $dd1899b3dddfdeca$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$dd1899b3dddfdeca$var$EventLogger._safeFlushAndForget(this._sdkKey), $dd1899b3dddfdeca$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $1SxnD._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $bOkHD._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $hqcc3._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $dd1899b3dddfdeca$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $dd1899b3dddfdeca$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $j1v5J._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $55TRz.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $55TRz.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$gz4N0.NetworkParam.EventCount]: String(events.length)
            }
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $dd1899b3dddfdeca$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $7SwFs._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $55TRz.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$dd1899b3dddfdeca$var$__awaiter(this, void 0, void 0, function*() {
                if (!$7SwFs.Storage.isReady()) yield $7SwFs.Storage.isReadyResolver();
                const events = (0, $7SwFs._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $dd1899b3dddfdeca$var$RetryFailedLogsTrigger.Startup) $7SwFs.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $dd1899b3dddfdeca$var$RetryFailedLogsTrigger.GainedFocus) $7SwFs.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $55TRz.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $jPn3t._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $55TRz.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $1SxnD._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $dd1899b3dddfdeca$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $dd1899b3dddfdeca$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $dd1899b3dddfdeca$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $dd1899b3dddfdeca$var$EventLogger;

});
parcelRegister("hqcc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $jPn3t = parcelRequire("jPn3t");
function $caee52b870e9ea05$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $jPn3t._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $caee52b870e9ea05$var$_getUserStorageKey;
function $caee52b870e9ea05$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $caee52b870e9ea05$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $jPn3t._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $caee52b870e9ea05$var$_getStorageKey;

});
parcelRegister("jPn3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $3g9pm = parcelRequire("3g9pm");
const $e6f4aa009ab32763$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $e6f4aa009ab32763$var$_DJB2;
const $e6f4aa009ab32763$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $e6f4aa009ab32763$var$_DJB2Object;
const $e6f4aa009ab32763$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $3g9pm._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $e6f4aa009ab32763$var$_getSortedObject;

});
parcelRegister("3g9pm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $25fa29fb33e20ce3$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $25fa29fb33e20ce3$var$_typeOf;
function $25fa29fb33e20ce3$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $25fa29fb33e20ce3$var$_isTypeMatch;

});



parcelRegister("gz4N0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("1SxnD", function(module, exports) {

var $XAEGR = parcelRequire("XAEGR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $15e4ba390b2f6bcc$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $15e4ba390b2f6bcc$var$_getWindowSafe;
const $15e4ba390b2f6bcc$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $15e4ba390b2f6bcc$var$_getDocumentSafe;
const $15e4ba390b2f6bcc$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $XAEGR !== "undefined" && $XAEGR.versions != null && $XAEGR.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $15e4ba390b2f6bcc$var$_isServerEnv;
const $15e4ba390b2f6bcc$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $15e4ba390b2f6bcc$var$_addWindowEventListenerSafe;
const $15e4ba390b2f6bcc$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $15e4ba390b2f6bcc$var$_addDocumentEventListenerSafe;
const $15e4ba390b2f6bcc$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $15e4ba390b2f6bcc$var$_getCurrentPageUrlSafe;

});

parcelRegister("bOkHD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $89946c5b1dfe32a8$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $89946c5b1dfe32a8$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $89946c5b1dfe32a8$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $89946c5b1dfe32a8$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $89946c5b1dfe32a8$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $89946c5b1dfe32a8$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $89946c5b1dfe32a8$var$GATE_EXPOSURE_NAME || eventName === $89946c5b1dfe32a8$var$CONFIG_EXPOSURE_NAME || eventName === $89946c5b1dfe32a8$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $89946c5b1dfe32a8$var$_isExposureEvent;
const $89946c5b1dfe32a8$var$_createGateExposure = (user, gate)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $89946c5b1dfe32a8$var$_createExposure($89946c5b1dfe32a8$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, (_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : []);
};
module.exports._createGateExposure = $89946c5b1dfe32a8$var$_createGateExposure;
const $89946c5b1dfe32a8$var$_createConfigExposure = (user, config)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $89946c5b1dfe32a8$var$_createExposure($89946c5b1dfe32a8$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, (_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : []);
};
module.exports._createConfigExposure = $89946c5b1dfe32a8$var$_createConfigExposure;
const $89946c5b1dfe32a8$var$_createLayerParameterExposure = (user, layer, parameterName)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $89946c5b1dfe32a8$var$_createExposure($89946c5b1dfe32a8$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, secondaryExposures);
};
module.exports._createLayerParameterExposure = $89946c5b1dfe32a8$var$_createLayerParameterExposure;
const $89946c5b1dfe32a8$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("7SwFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $55TRz = parcelRequire("55TRz");

var $1SxnD = parcelRequire("1SxnD");
const $5bc6eaadc2c07331$var$inMemoryStore = {};
const $5bc6eaadc2c07331$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$5bc6eaadc2c07331$var$inMemoryStore[key] ? $5bc6eaadc2c07331$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $5bc6eaadc2c07331$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $5bc6eaadc2c07331$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($5bc6eaadc2c07331$var$inMemoryStore)
};
let $5bc6eaadc2c07331$var$_localStorageProvider = null;
try {
    const win = (0, $1SxnD._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $5bc6eaadc2c07331$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $55TRz.Log.warn("Failed to setup localStorageProvider.");
}
let $5bc6eaadc2c07331$var$_main = $5bc6eaadc2c07331$var$_localStorageProvider !== null && $5bc6eaadc2c07331$var$_localStorageProvider !== void 0 ? $5bc6eaadc2c07331$var$_localStorageProvider : $5bc6eaadc2c07331$var$_inMemoryProvider;
let $5bc6eaadc2c07331$var$_current = $5bc6eaadc2c07331$var$_main;
function $5bc6eaadc2c07331$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($5bc6eaadc2c07331$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$5bc6eaadc2c07331$var$_current.isReady(),
    isReadyResolver: ()=>$5bc6eaadc2c07331$var$_current.isReadyResolver(),
    getProviderName: ()=>$5bc6eaadc2c07331$var$_current.getProviderName(),
    getItem: (key)=>$5bc6eaadc2c07331$var$_inMemoryBreaker(()=>$5bc6eaadc2c07331$var$_current.getItem(key)),
    setItem: (key, value)=>$5bc6eaadc2c07331$var$_current.setItem(key, value),
    removeItem: (key)=>$5bc6eaadc2c07331$var$_current.removeItem(key),
    getAllKeys: ()=>$5bc6eaadc2c07331$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $5bc6eaadc2c07331$var$_main = newProvider;
        $5bc6eaadc2c07331$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $5bc6eaadc2c07331$var$_current = $5bc6eaadc2c07331$var$_inMemoryProvider;
        else $5bc6eaadc2c07331$var$_current = $5bc6eaadc2c07331$var$_main;
    }
};
function $5bc6eaadc2c07331$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $5bc6eaadc2c07331$var$_getObjectFromStorage;
function $5bc6eaadc2c07331$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $5bc6eaadc2c07331$var$_setObjectInStorage;

});

parcelRegister("k4L4P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $gz4N0 = parcelRequire("gz4N0");
const $e9d8b2d93e9761cd$var$ENDPOINT_DNS_KEY_MAP = {
    [$gz4N0.Endpoint._initialize]: "i",
    [$gz4N0.Endpoint._rgstr]: "e",
    [$gz4N0.Endpoint._download_config_specs]: "d"
};
class $e9d8b2d93e9761cd$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $e9d8b2d93e9761cd$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $gz4N0.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
}
module.exports.UrlConfiguration = $e9d8b2d93e9761cd$var$UrlConfiguration;

});

parcelRegister("j1v5J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $1SxnD = parcelRequire("1SxnD");
const $dd963a6db42919bd$var$FOREGROUND = "foreground";
const $dd963a6db42919bd$var$BACKGROUND = "background";
const $dd963a6db42919bd$var$LISTENERS = [];
let $dd963a6db42919bd$var$current = $dd963a6db42919bd$var$FOREGROUND;
let $dd963a6db42919bd$var$isUnloading = false;
const $dd963a6db42919bd$var$_isCurrentlyVisible = ()=>{
    return $dd963a6db42919bd$var$current === $dd963a6db42919bd$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $dd963a6db42919bd$var$_isCurrentlyVisible;
const $dd963a6db42919bd$var$_isUnloading = ()=>$dd963a6db42919bd$var$isUnloading;
module.exports._isUnloading = $dd963a6db42919bd$var$_isUnloading;
const $dd963a6db42919bd$var$_subscribeToVisiblityChanged = (listener)=>{
    $dd963a6db42919bd$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $dd963a6db42919bd$var$_subscribeToVisiblityChanged;
const $dd963a6db42919bd$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $dd963a6db42919bd$var$current) return;
    $dd963a6db42919bd$var$current = visibility;
    $dd963a6db42919bd$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $dd963a6db42919bd$var$_notifyVisibilityChanged;
(0, $1SxnD._addWindowEventListenerSafe)("focus", ()=>{
    $dd963a6db42919bd$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($dd963a6db42919bd$var$FOREGROUND);
});
(0, $1SxnD._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($dd963a6db42919bd$var$BACKGROUND));
(0, $1SxnD._addWindowEventListenerSafe)("beforeunload", ()=>{
    $dd963a6db42919bd$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($dd963a6db42919bd$var$BACKGROUND);
});
(0, $1SxnD._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $dd963a6db42919bd$var$FOREGROUND : $dd963a6db42919bd$var$BACKGROUND);
});

});


parcelRegister("csUVs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.12.0";
let $913441d8d4c80541$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$913441d8d4c80541$var$metadata,
    add: (additions)=>{
        $913441d8d4c80541$var$metadata = Object.assign(Object.assign({}, $913441d8d4c80541$var$metadata), additions);
    }
};

});

parcelRegister("5KhCn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2kIIc", function(module, exports) {
"use strict";
var $1b3021dc31797036$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $55TRz = parcelRequire("55TRz");

var $uMJd2 = parcelRequire("uMJd2");

var $1SVzT = parcelRequire("1SVzT");

var $7SwFs = parcelRequire("7SwFs");

var $28nWn = parcelRequire("28nWn");
const $1b3021dc31797036$var$CACHE_LIMIT = 10;
class $1b3021dc31797036$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $1b3021dc31797036$var$InMemoryCache();
    }
    attach(sdkKey, options) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $1SVzT._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $1SVzT._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $1b3021dc31797036$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $1b3021dc31797036$var$__awaiter(this, void 0, void 0, function*() {
            if (!$7SwFs.Storage.isReady()) yield $7SwFs.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $55TRz.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $1b3021dc31797036$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $1SVzT._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $1b3021dc31797036$var$__awaiter(this, void 0, void 0, function*() {
            let cachedData = null;
            if (cachedResult && this._isCachedResultValidFor204(cachedResult, user)) cachedData = cachedResult.data;
            const latest = yield this._fetchFromNetwork(cachedData, user, options);
            if (!latest) {
                $55TRz.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $28nWn._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $uMJd2.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $1b3021dc31797036$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $1b3021dc31797036$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $55TRz.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $7SwFs.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($7SwFs.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $28nWn._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $7SwFs.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $7SwFs._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $1b3021dc31797036$var$_getEvictableKey(lastModifiedTimeMap, $1b3021dc31797036$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $7SwFs.Storage.removeItem(evictable);
        }
        (0, $7SwFs._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $1b3021dc31797036$var$DataAdapterCore;
function $1b3021dc31797036$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $1SVzT._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $1b3021dc31797036$var$_makeDataAdapterResult;
class $1b3021dc31797036$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $55TRz.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $1b3021dc31797036$var$_getEvictableKey(this._data, $1b3021dc31797036$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $1b3021dc31797036$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("uMJd2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $hqcc3 = parcelRequire("hqcc3");

var $55TRz = parcelRequire("55TRz");

var $7SwFs = parcelRequire("7SwFs");

var $jYNV8 = parcelRequire("jYNV8");
const $05c899dbd4004dc4$var$PROMISE_MAP = {};
module.exports.StableID = {
    get: (sdkKey)=>{
        if ($05c899dbd4004dc4$var$PROMISE_MAP[sdkKey] == null) {
            let stableID = $05c899dbd4004dc4$var$_loadFromStorage(sdkKey);
            if (stableID == null) {
                stableID = (0, $jYNV8.getUUID)();
                $05c899dbd4004dc4$var$_persistToStorage(stableID, sdkKey);
            }
            $05c899dbd4004dc4$var$PROMISE_MAP[sdkKey] = stableID;
        }
        return $05c899dbd4004dc4$var$PROMISE_MAP[sdkKey];
    },
    setOverride: (override, sdkKey)=>{
        $05c899dbd4004dc4$var$PROMISE_MAP[sdkKey] = override;
        $05c899dbd4004dc4$var$_persistToStorage(override, sdkKey);
    }
};
function $05c899dbd4004dc4$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $hqcc3._getStorageKey)(sdkKey)}`;
}
function $05c899dbd4004dc4$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $05c899dbd4004dc4$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $7SwFs._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $55TRz.Log.warn("Failed to save StableID");
    }
}
function $05c899dbd4004dc4$var$_loadFromStorage(sdkKey) {
    const storageKey = $05c899dbd4004dc4$var$_getStableIDStorageKey(sdkKey);
    return (0, $7SwFs._getObjectFromStorage)(storageKey);
}

});
parcelRegister("jYNV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $e8ba5815e503e25c$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $e8ba5815e503e25c$var$getUUID;

});


parcelRegister("1SVzT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $jPn3t = parcelRequire("jPn3t");

var $55TRz = parcelRequire("55TRz");
function $15f77f6261230a3c$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $55TRz.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $15f77f6261230a3c$var$_normalizeUser;
function $15f77f6261230a3c$var$_getFullUserHash(user) {
    return user ? (0, $jPn3t._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $15f77f6261230a3c$var$_getFullUserHash;

});

parcelRegister("28nWn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $55TRz = parcelRequire("55TRz");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $18dee6362af9a955$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $55TRz.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $18dee6362af9a955$var$_typedJsonParse;

});


parcelRegister("jztfU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9Hfh8", function(module, exports) {
"use strict";
var $70f3fa9665d24cf0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $55TRz = parcelRequire("55TRz");

var $dUoYx = parcelRequire("dUoYx");

var $csUVs = parcelRequire("csUVs");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $70f3fa9665d24cf0$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $70f3fa9665d24cf0$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $70f3fa9665d24cf0$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $70f3fa9665d24cf0$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $55TRz.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$70f3fa9665d24cf0$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($70f3fa9665d24cf0$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $70f3fa9665d24cf0$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $dUoYx.SDKType._get(this._sdkKey);
                    const statsigMetadata = $csUVs.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $70f3fa9665d24cf0$var$_getDescription(unwrapped);
                    const body = JSON.stringify(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: body
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $70f3fa9665d24cf0$var$ErrorBoundary;
function $70f3fa9665d24cf0$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $70f3fa9665d24cf0$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $70f3fa9665d24cf0$var$UNKNOWN_ERROR;
    }
}
function $70f3fa9665d24cf0$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}

});
parcelRegister("dUoYx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $a203e0f231d343f5$var$SDK_CLIENT = {};
let $a203e0f231d343f5$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $a203e0f231d343f5$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($a203e0f231d343f5$var$suffix !== null && $a203e0f231d343f5$var$suffix !== void 0 ? $a203e0f231d343f5$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $a203e0f231d343f5$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$a203e0f231d343f5$var$suffix || $a203e0f231d343f5$var$suffix === "-react") $a203e0f231d343f5$var$suffix = "-" + binding;
    }
};

});


parcelRegister("coZ0K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6JTa7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("7EZoX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bOemD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _layer: "l",
    _paramStore: "p"
};
const $898f819a9c92efaf$var$EXIST_KEYS = new Set([]);
const $898f819a9c92efaf$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $898f819a9c92efaf$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($898f819a9c92efaf$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($898f819a9c92efaf$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $898f819a9c92efaf$var$createMemoKey;

});

parcelRegister("dPtPJ", function(module, exports) {
"use strict";
var $a1172e0bf6e4f372$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $dKZ9p = parcelRequire("dKZ9p");

var $dKZ9p = parcelRequire("dKZ9p");

var $5qykB = parcelRequire("5qykB");

var $55TRz = parcelRequire("55TRz");

var $gz4N0 = parcelRequire("gz4N0");

var $dKwAh = parcelRequire("dKwAh");

var $dUoYx = parcelRequire("dUoYx");

var $1SxnD = parcelRequire("1SxnD");

var $dhpqv = parcelRequire("dhpqv");

var $uMJd2 = parcelRequire("uMJd2");

var $iielb = parcelRequire("iielb");

var $csUVs = parcelRequire("csUVs");

var $j1v5J = parcelRequire("j1v5J");
const $a1172e0bf6e4f372$var$DEFAULT_TIMEOUT_MS = 10000;
const $a1172e0bf6e4f372$var$BACKOFF_BASE_MS = 500;
const $a1172e0bf6e4f372$var$BACKOFF_MAX_MS = 30000;
const $a1172e0bf6e4f372$var$RATE_LIMIT_WINDOW_MS = 1000;
const $a1172e0bf6e4f372$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $a1172e0bf6e4f372$var$LEAK_RATE = $a1172e0bf6e4f372$var$RATE_LIMIT_MAX_REQ_COUNT / $a1172e0bf6e4f372$var$RATE_LIMIT_WINDOW_MS;
const $a1172e0bf6e4f372$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $a1172e0bf6e4f372$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $a1172e0bf6e4f372$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $dKwAh.NetworkFallbackResolver(this._options);
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
            if (!$a1172e0bf6e4f372$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs("POST", args);
            const body = yield this._getPopulatedBody(argsInternal, args.data);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, body);
        });
    }
    post(args) {
        return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            argsInternal.body = yield this._getPopulatedBody(argsInternal, args.data);
            if (args.isStatsigEncodable) argsInternal.body = this._attemptToEncodeString(argsInternal, argsInternal.body);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
            if (!$a1172e0bf6e4f372$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $55TRz.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $j1v5J._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $a1172e0bf6e4f372$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $a1172e0bf6e4f372$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $a1172e0bf6e4f372$var$_getErrorMessage(abortController, error);
                const timedOut = $a1172e0bf6e4f372$var$_didTimeout(abortController);
                $a1172e0bf6e4f372$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$a1172e0bf6e4f372$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $iielb.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $55TRz.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $a1172e0bf6e4f372$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $a1172e0bf6e4f372$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $a1172e0bf6e4f372$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $gz4N0.Endpoint._initialize || args.urlConfig.endpoint === $gz4N0.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$gz4N0.NetworkParam.SdkKey]: args.sdkKey,
                [$gz4N0.NetworkParam.SdkType]: $dUoYx.SDKType._get(args.sdkKey),
                [$gz4N0.NetworkParam.SdkVersion]: $csUVs.SDK_VERSION,
                [$gz4N0.NetworkParam.Time]: String(Date.now()),
                [$gz4N0.NetworkParam.SessionID]: $dhpqv.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join("&");
            return `${url}${query ? `?${query}` : ""}`;
        });
    }
    _getPopulatedBody(args, data) {
        return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
            const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
            const stableID = $uMJd2.StableID.get(sdkKey);
            const sessionID = $dhpqv.SessionID.get(sdkKey);
            const sdkType = $dUoYx.SDKType._get(sdkKey);
            return JSON.stringify(Object.assign(Object.assign({}, data), {
                statsigMetadata: Object.assign(Object.assign({}, $csUVs.StatsigMetadataProvider.get()), {
                    stableID: stableID,
                    sessionID: sessionID,
                    sdkType: sdkType,
                    fallbackUrl: fallbackUrl
                })
            }));
        });
    }
    _attemptToEncodeString(args, input) {
        var _a, _b;
        const win = (0, $1SxnD._getWindowSafe)();
        if (this._options.disableStatsigEncoding || (0, $dKZ9p._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return input;
        try {
            const result = (_a = win.btoa(input).split("").reverse().join("")) !== null && _a !== void 0 ? _a : input;
            args.params = Object.assign(Object.assign({}, (_b = args.params) !== null && _b !== void 0 ? _b : {}), {
                [$gz4N0.NetworkParam.StatsigEncoded]: "1"
            });
            return result;
        } catch (_c) {
            $55TRz.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`);
            return input;
        }
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        return Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
    }
}
module.exports.NetworkCore = $a1172e0bf6e4f372$var$NetworkCore;
const $a1172e0bf6e4f372$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $55TRz.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
function $a1172e0bf6e4f372$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $a1172e0bf6e4f372$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $a1172e0bf6e4f372$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $gz4N0.Endpoint._initialize) return;
    $5qykB.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $a1172e0bf6e4f372$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $gz4N0.Endpoint._initialize) return;
    $5qykB.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $5qykB.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $a1172e0bf6e4f372$var$_exponentialBackoff(attempt) {
    return $a1172e0bf6e4f372$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($a1172e0bf6e4f372$var$BACKOFF_BASE_MS * (attempt * attempt), $a1172e0bf6e4f372$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("dKwAh", function(module, exports) {
"use strict";
var $a028d8c387a49e1e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $5ECxD = parcelRequire("5ECxD");

var $jPn3t = parcelRequire("jPn3t");

var $55TRz = parcelRequire("55TRz");

var $7SwFs = parcelRequire("7SwFs");
const $a028d8c387a49e1e$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $a028d8c387a49e1e$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $a028d8c387a49e1e$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $a028d8c387a49e1e$var$DEFAULT_TTL_MS;
        $a028d8c387a49e1e$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $a028d8c387a49e1e$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0)) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $a028d8c387a49e1e$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    getFallbackFromProvided(url) {
        const path = $a028d8c387a49e1e$var$_extractPathFromUrl(url);
        if (path) return url.replace(path, "");
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $a028d8c387a49e1e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$a028d8c387a49e1e$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig.endpoint, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, endpoint, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            url: newUrl,
            expiryTime: Date.now() + $a028d8c387a49e1e$var$DEFAULT_TTL_MS,
            previous: []
        };
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $a028d8c387a49e1e$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $a028d8c387a49e1e$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $a028d8c387a49e1e$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $5ECxD._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $a028d8c387a49e1e$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $a028d8c387a49e1e$var$NetworkFallbackResolver;
function $a028d8c387a49e1e$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $a028d8c387a49e1e$var$_isDomainFailure;
function $a028d8c387a49e1e$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $jPn3t._DJB2)(sdkKey)}`;
}
function $a028d8c387a49e1e$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $a028d8c387a49e1e$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $7SwFs.Storage.removeItem(hashKey);
        return;
    }
    $7SwFs.Storage.setItem(hashKey, JSON.stringify(info));
}
function $a028d8c387a49e1e$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $a028d8c387a49e1e$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $7SwFs.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $55TRz.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $a028d8c387a49e1e$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("5ECxD", function(module, exports) {
"use strict";
var $41de95b10da349ad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $41de95b10da349ad$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $41de95b10da349ad$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $41de95b10da349ad$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $41de95b10da349ad$var$MAX_START_LOOKUP = 200;
function $41de95b10da349ad$var$_fetchTxtRecords(networkFunc) {
    return $41de95b10da349ad$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($41de95b10da349ad$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $41de95b10da349ad$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $41de95b10da349ad$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $41de95b10da349ad$var$_fetchTxtRecords;
function $41de95b10da349ad$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $41de95b10da349ad$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $41de95b10da349ad$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("dhpqv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $hqcc3 = parcelRequire("hqcc3");

var $55TRz = parcelRequire("55TRz");

var $7SwFs = parcelRequire("7SwFs");

var $jYNV8 = parcelRequire("jYNV8");
const $9ab096136b79355e$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $9ab096136b79355e$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $9ab096136b79355e$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($9ab096136b79355e$var$PROMISE_MAP[sdkKey] == null) $9ab096136b79355e$var$PROMISE_MAP[sdkKey] = $9ab096136b79355e$var$_loadSession(sdkKey);
        const session = $9ab096136b79355e$var$PROMISE_MAP[sdkKey];
        return $9ab096136b79355e$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $9ab096136b79355e$var$PROMISE_MAP[sdkKey] = $9ab096136b79355e$var$_overrideSessionId(override, sdkKey);
    }
};
function $9ab096136b79355e$var$_loadSession(sdkKey) {
    let data = $9ab096136b79355e$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $jYNV8.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $9ab096136b79355e$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $9ab096136b79355e$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($9ab096136b79355e$var$_isIdle(data) || $9ab096136b79355e$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $jYNV8.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $9ab096136b79355e$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $9ab096136b79355e$var$_createSessionTimeout(sdkKey, $9ab096136b79355e$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $9ab096136b79355e$var$_createSessionTimeout(sdkKey, $9ab096136b79355e$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $9ab096136b79355e$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $9ab096136b79355e$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $9ab096136b79355e$var$MAX_SESSION_IDLE_TIME;
}
function $9ab096136b79355e$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $9ab096136b79355e$var$MAX_SESSION_AGE;
}
function $9ab096136b79355e$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $hqcc3._getStorageKey)(sdkKey)}`;
}
function $9ab096136b79355e$var$_persistToStorage(session, sdkKey) {
    const storageKey = $9ab096136b79355e$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $7SwFs._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $55TRz.Log.warn("Failed to save SessionID");
    }
}
function $9ab096136b79355e$var$_loadFromStorage(sdkKey) {
    const storageKey = $9ab096136b79355e$var$_getSessionIDStorageKey(sdkKey);
    return (0, $7SwFs._getObjectFromStorage)(storageKey);
}

});

parcelRegister("iielb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("cQgwj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dhnhE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("97ZBs", function(module, exports) {
"use strict";
var $6a548da03d03f113$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $dKZ9p = parcelRequire("dKZ9p");

var $dKZ9p = parcelRequire("dKZ9p");

var $9Hfh8 = parcelRequire("9Hfh8");

var $iYT8z = parcelRequire("iYT8z");

var $55TRz = parcelRequire("55TRz");

var $bOemD = parcelRequire("bOemD");

var $1SxnD = parcelRequire("1SxnD");

var $dhpqv = parcelRequire("dhpqv");

var $7SwFs = parcelRequire("7SwFs");
const $6a548da03d03f113$var$MAX_MEMO_CACHE_SIZE = 3000;
class $6a548da03d03f113$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($55TRz.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $7SwFs.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $dhpqv.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $7SwFs.Storage._setProvider(options.storageProvider);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $iYT8z.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $9Hfh8.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options);
        this.storageProvider = $7SwFs.Storage;
        this._primeReadyRipcord();
        $6a548da03d03f113$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $7SwFs.Storage._setDisabled(options.disableStorage);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $6a548da03d03f113$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $55TRz.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $bOemD.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $6a548da03d03f113$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $6a548da03d03f113$var$StatsigClientBase;
function $6a548da03d03f113$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $1SxnD._isServerEnv)()) return;
    const statsigGlobal = (0, $dKZ9p._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $55TRz.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("aTw8M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("1hu68", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6EaGJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6avte", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $55TRz = parcelRequire("55TRz");

var $3g9pm = parcelRequire("3g9pm");
const $47dc16a77154318b$var$DEFAULT_RULE = "default";
function $47dc16a77154318b$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $47dc16a77154318b$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $47dc16a77154318b$var$_makeFeatureGate(name, details, evaluation) {
    return $47dc16a77154318b$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $47dc16a77154318b$var$_makeFeatureGate;
function $47dc16a77154318b$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $47dc16a77154318b$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $47dc16a77154318b$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $47dc16a77154318b$var$_makeDynamicConfig;
function $47dc16a77154318b$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $47dc16a77154318b$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $47dc16a77154318b$var$_makeExperiment;
function $47dc16a77154318b$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $47dc16a77154318b$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $47dc16a77154318b$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $47dc16a77154318b$var$_makeLayer;
function $47dc16a77154318b$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $47dc16a77154318b$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $47dc16a77154318b$var$_mergeOverride;
function $47dc16a77154318b$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $3g9pm._isTypeMatch)(found, fallback)) {
            $55TRz.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $47dc16a77154318b$var$_makeTypedGet;

});

parcelRegister("8UvOP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aC8w1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $7ba40efde1ae281b$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $7ba40efde1ae281b$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});

parcelRegister("8Hasm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $654a734c2a3a6237$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $654a734c2a3a6237$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $654a734c2a3a6237$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});


parcelRegister("cBwPl", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("2RP26", function(module, exports) {
"use strict";
var $21681e131e42e80f$var$token = "%[a-f0-9]{2}";
var $21681e131e42e80f$var$singleMatcher = new RegExp("(" + $21681e131e42e80f$var$token + ")|([^%]+?)", "gi");
var $21681e131e42e80f$var$multiMatcher = new RegExp("(" + $21681e131e42e80f$var$token + ")+", "gi");
function $21681e131e42e80f$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $21681e131e42e80f$var$decodeComponents(left), $21681e131e42e80f$var$decodeComponents(right));
}
function $21681e131e42e80f$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($21681e131e42e80f$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $21681e131e42e80f$var$decodeComponents(tokens, i).join("");
            tokens = input.match($21681e131e42e80f$var$singleMatcher) || [];
        }
        return input;
    }
}
function $21681e131e42e80f$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $21681e131e42e80f$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $21681e131e42e80f$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $21681e131e42e80f$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $21681e131e42e80f$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("888c8", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("95zlx", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});

parcelRegister("dmWkz", function(module, exports) {
/* UAParser.js v1.0.37
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.37", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( 2| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

parcelRegister("egNzs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.QuoteType = void 0;

var $Tj5sm = parcelRequire("Tj5sm");
var $a6390311aed7e077$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["NewLine"] = 10] = "NewLine";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationMark"] = 33] = "ExclamationMark";
    CharCodes[CharCodes["Number"] = 35] = "Number";
    CharCodes[CharCodes["Amp"] = 38] = "Amp";
    CharCodes[CharCodes["SingleQuote"] = 39] = "SingleQuote";
    CharCodes[CharCodes["DoubleQuote"] = 34] = "DoubleQuote";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Slash"] = 47] = "Slash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["Semi"] = 59] = "Semi";
    CharCodes[CharCodes["Lt"] = 60] = "Lt";
    CharCodes[CharCodes["Eq"] = 61] = "Eq";
    CharCodes[CharCodes["Gt"] = 62] = "Gt";
    CharCodes[CharCodes["Questionmark"] = 63] = "Questionmark";
    CharCodes[CharCodes["UpperA"] = 65] = "UpperA";
    CharCodes[CharCodes["LowerA"] = 97] = "LowerA";
    CharCodes[CharCodes["UpperF"] = 70] = "UpperF";
    CharCodes[CharCodes["LowerF"] = 102] = "LowerF";
    CharCodes[CharCodes["UpperZ"] = 90] = "UpperZ";
    CharCodes[CharCodes["LowerZ"] = 122] = "LowerZ";
    CharCodes[CharCodes["LowerX"] = 120] = "LowerX";
    CharCodes[CharCodes["OpeningSquareBracket"] = 91] = "OpeningSquareBracket";
})($a6390311aed7e077$var$CharCodes || ($a6390311aed7e077$var$CharCodes = {}));
/** All the states the tokenizer can be in. */ var $a6390311aed7e077$var$State;
(function(State) {
    State[State["Text"] = 1] = "Text";
    State[State["BeforeTagName"] = 2] = "BeforeTagName";
    State[State["InTagName"] = 3] = "InTagName";
    State[State["InSelfClosingTag"] = 4] = "InSelfClosingTag";
    State[State["BeforeClosingTagName"] = 5] = "BeforeClosingTagName";
    State[State["InClosingTagName"] = 6] = "InClosingTagName";
    State[State["AfterClosingTagName"] = 7] = "AfterClosingTagName";
    // Attributes
    State[State["BeforeAttributeName"] = 8] = "BeforeAttributeName";
    State[State["InAttributeName"] = 9] = "InAttributeName";
    State[State["AfterAttributeName"] = 10] = "AfterAttributeName";
    State[State["BeforeAttributeValue"] = 11] = "BeforeAttributeValue";
    State[State["InAttributeValueDq"] = 12] = "InAttributeValueDq";
    State[State["InAttributeValueSq"] = 13] = "InAttributeValueSq";
    State[State["InAttributeValueNq"] = 14] = "InAttributeValueNq";
    // Declarations
    State[State["BeforeDeclaration"] = 15] = "BeforeDeclaration";
    State[State["InDeclaration"] = 16] = "InDeclaration";
    // Processing instructions
    State[State["InProcessingInstruction"] = 17] = "InProcessingInstruction";
    // Comments & CDATA
    State[State["BeforeComment"] = 18] = "BeforeComment";
    State[State["CDATASequence"] = 19] = "CDATASequence";
    State[State["InSpecialComment"] = 20] = "InSpecialComment";
    State[State["InCommentLike"] = 21] = "InCommentLike";
    // Special tags
    State[State["BeforeSpecialS"] = 22] = "BeforeSpecialS";
    State[State["SpecialStartSequence"] = 23] = "SpecialStartSequence";
    State[State["InSpecialTag"] = 24] = "InSpecialTag";
    State[State["BeforeEntity"] = 25] = "BeforeEntity";
    State[State["BeforeNumericEntity"] = 26] = "BeforeNumericEntity";
    State[State["InNamedEntity"] = 27] = "InNamedEntity";
    State[State["InNumericEntity"] = 28] = "InNumericEntity";
    State[State["InHexEntity"] = 29] = "InHexEntity";
})($a6390311aed7e077$var$State || ($a6390311aed7e077$var$State = {}));
function $a6390311aed7e077$var$isWhitespace(c) {
    return c === $a6390311aed7e077$var$CharCodes.Space || c === $a6390311aed7e077$var$CharCodes.NewLine || c === $a6390311aed7e077$var$CharCodes.Tab || c === $a6390311aed7e077$var$CharCodes.FormFeed || c === $a6390311aed7e077$var$CharCodes.CarriageReturn;
}
function $a6390311aed7e077$var$isEndOfTagSection(c) {
    return c === $a6390311aed7e077$var$CharCodes.Slash || c === $a6390311aed7e077$var$CharCodes.Gt || $a6390311aed7e077$var$isWhitespace(c);
}
function $a6390311aed7e077$var$isNumber(c) {
    return c >= $a6390311aed7e077$var$CharCodes.Zero && c <= $a6390311aed7e077$var$CharCodes.Nine;
}
function $a6390311aed7e077$var$isASCIIAlpha(c) {
    return c >= $a6390311aed7e077$var$CharCodes.LowerA && c <= $a6390311aed7e077$var$CharCodes.LowerZ || c >= $a6390311aed7e077$var$CharCodes.UpperA && c <= $a6390311aed7e077$var$CharCodes.UpperZ;
}
function $a6390311aed7e077$var$isHexDigit(c) {
    return c >= $a6390311aed7e077$var$CharCodes.UpperA && c <= $a6390311aed7e077$var$CharCodes.UpperF || c >= $a6390311aed7e077$var$CharCodes.LowerA && c <= $a6390311aed7e077$var$CharCodes.LowerF;
}
var $a6390311aed7e077$var$QuoteType;
(function(QuoteType) {
    QuoteType[QuoteType["NoValue"] = 0] = "NoValue";
    QuoteType[QuoteType["Unquoted"] = 1] = "Unquoted";
    QuoteType[QuoteType["Single"] = 2] = "Single";
    QuoteType[QuoteType["Double"] = 3] = "Double";
})($a6390311aed7e077$var$QuoteType = module.exports.QuoteType || (module.exports.QuoteType = {}));
/**
 * Sequences used to match longer strings.
 *
 * We don't have `Script`, `Style`, or `Title` here. Instead, we re-use the *End
 * sequences with an increased offset.
 */ var $a6390311aed7e077$var$Sequences = {
    Cdata: new Uint8Array([
        0x43,
        0x44,
        0x41,
        0x54,
        0x41,
        0x5b
    ]),
    CdataEnd: new Uint8Array([
        0x5d,
        0x5d,
        0x3e
    ]),
    CommentEnd: new Uint8Array([
        0x2d,
        0x2d,
        0x3e
    ]),
    ScriptEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x63,
        0x72,
        0x69,
        0x70,
        0x74
    ]),
    StyleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x73,
        0x74,
        0x79,
        0x6c,
        0x65
    ]),
    TitleEnd: new Uint8Array([
        0x3c,
        0x2f,
        0x74,
        0x69,
        0x74,
        0x6c,
        0x65
    ])
};
var $a6390311aed7e077$var$Tokenizer = /** @class */ function() {
    function Tokenizer(_a, cbs) {
        var _b = _a.xmlMode, xmlMode = _b === void 0 ? false : _b, _c = _a.decodeEntities, decodeEntities = _c === void 0 ? true : _c;
        this.cbs = cbs;
        /** The current state the tokenizer is in. */ this.state = $a6390311aed7e077$var$State.Text;
        /** The read buffer. */ this.buffer = "";
        /** The beginning of the section that is currently being read. */ this.sectionStart = 0;
        /** The index within the buffer that we are currently looking at. */ this.index = 0;
        /** Some behavior, eg. when decoding entities, is done while we are in another state. This keeps track of the other state type. */ this.baseState = $a6390311aed7e077$var$State.Text;
        /** For special parsing behavior inside of script and style tags. */ this.isSpecial = false;
        /** Indicates whether the tokenizer has been paused. */ this.running = true;
        /** The offset of the current buffer. */ this.offset = 0;
        this.currentSequence = undefined;
        this.sequenceIndex = 0;
        this.trieIndex = 0;
        this.trieCurrent = 0;
        /** For named entities, the index of the value. For numeric entities, the code point. */ this.entityResult = 0;
        this.entityExcess = 0;
        this.xmlMode = xmlMode;
        this.decodeEntities = decodeEntities;
        this.entityTrie = xmlMode ? $Tj5sm.xmlDecodeTree : $Tj5sm.htmlDecodeTree;
    }
    Tokenizer.prototype.reset = function() {
        this.state = $a6390311aed7e077$var$State.Text;
        this.buffer = "";
        this.sectionStart = 0;
        this.index = 0;
        this.baseState = $a6390311aed7e077$var$State.Text;
        this.currentSequence = undefined;
        this.running = true;
        this.offset = 0;
    };
    Tokenizer.prototype.write = function(chunk) {
        this.offset += this.buffer.length;
        this.buffer = chunk;
        this.parse();
    };
    Tokenizer.prototype.end = function() {
        if (this.running) this.finish();
    };
    Tokenizer.prototype.pause = function() {
        this.running = false;
    };
    Tokenizer.prototype.resume = function() {
        this.running = true;
        if (this.index < this.buffer.length + this.offset) this.parse();
    };
    /**
     * The current index within all of the written data.
     */ Tokenizer.prototype.getIndex = function() {
        return this.index;
    };
    /**
     * The start of the current section.
     */ Tokenizer.prototype.getSectionStart = function() {
        return this.sectionStart;
    };
    Tokenizer.prototype.stateText = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Lt || !this.decodeEntities && this.fastForwardTo($a6390311aed7e077$var$CharCodes.Lt)) {
            if (this.index > this.sectionStart) this.cbs.ontext(this.sectionStart, this.index);
            this.state = $a6390311aed7e077$var$State.BeforeTagName;
            this.sectionStart = this.index;
        } else if (this.decodeEntities && c === $a6390311aed7e077$var$CharCodes.Amp) this.state = $a6390311aed7e077$var$State.BeforeEntity;
    };
    Tokenizer.prototype.stateSpecialStartSequence = function(c) {
        var isEnd = this.sequenceIndex === this.currentSequence.length;
        var isMatch = isEnd ? $a6390311aed7e077$var$isEndOfTagSection(c) : (c | 0x20) === this.currentSequence[this.sequenceIndex];
        if (!isMatch) this.isSpecial = false;
        else if (!isEnd) {
            this.sequenceIndex++;
            return;
        }
        this.sequenceIndex = 0;
        this.state = $a6390311aed7e077$var$State.InTagName;
        this.stateInTagName(c);
    };
    /** Look for an end tag. For <title> tags, also decode entities. */ Tokenizer.prototype.stateInSpecialTag = function(c) {
        if (this.sequenceIndex === this.currentSequence.length) {
            if (c === $a6390311aed7e077$var$CharCodes.Gt || $a6390311aed7e077$var$isWhitespace(c)) {
                var endOfText = this.index - this.currentSequence.length;
                if (this.sectionStart < endOfText) {
                    // Spoof the index so that reported locations match up.
                    var actualIndex = this.index;
                    this.index = endOfText;
                    this.cbs.ontext(this.sectionStart, endOfText);
                    this.index = actualIndex;
                }
                this.isSpecial = false;
                this.sectionStart = endOfText + 2; // Skip over the `</`
                this.stateInClosingTagName(c);
                return; // We are done; skip the rest of the function.
            }
            this.sequenceIndex = 0;
        }
        if ((c | 0x20) === this.currentSequence[this.sequenceIndex]) this.sequenceIndex += 1;
        else if (this.sequenceIndex === 0) {
            if (this.currentSequence === $a6390311aed7e077$var$Sequences.TitleEnd) // We have to parse entities in <title> tags.
            {
                if (this.decodeEntities && c === $a6390311aed7e077$var$CharCodes.Amp) this.state = $a6390311aed7e077$var$State.BeforeEntity;
            } else if (this.fastForwardTo($a6390311aed7e077$var$CharCodes.Lt)) // Outside of <title> tags, we can fast-forward.
            this.sequenceIndex = 1;
        } else // If we see a `<`, set the sequence index to 1; useful for eg. `<</script>`.
        this.sequenceIndex = Number(c === $a6390311aed7e077$var$CharCodes.Lt);
    };
    Tokenizer.prototype.stateCDATASequence = function(c) {
        if (c === $a6390311aed7e077$var$Sequences.Cdata[this.sequenceIndex]) {
            if (++this.sequenceIndex === $a6390311aed7e077$var$Sequences.Cdata.length) {
                this.state = $a6390311aed7e077$var$State.InCommentLike;
                this.currentSequence = $a6390311aed7e077$var$Sequences.CdataEnd;
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
            }
        } else {
            this.sequenceIndex = 0;
            this.state = $a6390311aed7e077$var$State.InDeclaration;
            this.stateInDeclaration(c); // Reconsume the character
        }
    };
    /**
     * When we wait for one specific character, we can speed things up
     * by skipping through the buffer until we find it.
     *
     * @returns Whether the character was found.
     */ Tokenizer.prototype.fastForwardTo = function(c) {
        while(++this.index < this.buffer.length + this.offset){
            if (this.buffer.charCodeAt(this.index - this.offset) === c) return true;
        }
        /*
         * We increment the index at the end of the `parse` loop,
         * so set it to `buffer.length - 1` here.
         *
         * TODO: Refactor `parse` to increment index before calling states.
         */ this.index = this.buffer.length + this.offset - 1;
        return false;
    };
    /**
     * Comments and CDATA end with `-->` and `]]>`.
     *
     * Their common qualities are:
     * - Their end sequences have a distinct character they start with.
     * - That character is then repeated, so we have to check multiple repeats.
     * - All characters but the start character of the sequence can be skipped.
     */ Tokenizer.prototype.stateInCommentLike = function(c) {
        if (c === this.currentSequence[this.sequenceIndex]) {
            if (++this.sequenceIndex === this.currentSequence.length) {
                if (this.currentSequence === $a6390311aed7e077$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, this.index, 2);
                else this.cbs.oncomment(this.sectionStart, this.index, 2);
                this.sequenceIndex = 0;
                this.sectionStart = this.index + 1;
                this.state = $a6390311aed7e077$var$State.Text;
            }
        } else if (this.sequenceIndex === 0) // Fast-forward to the first character of the sequence
        {
            if (this.fastForwardTo(this.currentSequence[0])) this.sequenceIndex = 1;
        } else if (c !== this.currentSequence[this.sequenceIndex - 1]) // Allow long sequences, eg. --->, ]]]>
        this.sequenceIndex = 0;
    };
    /**
     * HTML only allows ASCII alpha characters (a-z and A-Z) at the beginning of a tag name.
     *
     * XML allows a lot more characters here (@see https://www.w3.org/TR/REC-xml/#NT-NameStartChar).
     * We allow anything that wouldn't end the tag.
     */ Tokenizer.prototype.isTagStartChar = function(c) {
        return this.xmlMode ? !$a6390311aed7e077$var$isEndOfTagSection(c) : $a6390311aed7e077$var$isASCIIAlpha(c);
    };
    Tokenizer.prototype.startSpecial = function(sequence, offset) {
        this.isSpecial = true;
        this.currentSequence = sequence;
        this.sequenceIndex = offset;
        this.state = $a6390311aed7e077$var$State.SpecialStartSequence;
    };
    Tokenizer.prototype.stateBeforeTagName = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.ExclamationMark) {
            this.state = $a6390311aed7e077$var$State.BeforeDeclaration;
            this.sectionStart = this.index + 1;
        } else if (c === $a6390311aed7e077$var$CharCodes.Questionmark) {
            this.state = $a6390311aed7e077$var$State.InProcessingInstruction;
            this.sectionStart = this.index + 1;
        } else if (this.isTagStartChar(c)) {
            var lower = c | 0x20;
            this.sectionStart = this.index;
            if (!this.xmlMode && lower === $a6390311aed7e077$var$Sequences.TitleEnd[2]) this.startSpecial($a6390311aed7e077$var$Sequences.TitleEnd, 3);
            else this.state = !this.xmlMode && lower === $a6390311aed7e077$var$Sequences.ScriptEnd[2] ? $a6390311aed7e077$var$State.BeforeSpecialS : $a6390311aed7e077$var$State.InTagName;
        } else if (c === $a6390311aed7e077$var$CharCodes.Slash) this.state = $a6390311aed7e077$var$State.BeforeClosingTagName;
        else {
            this.state = $a6390311aed7e077$var$State.Text;
            this.stateText(c);
        }
    };
    Tokenizer.prototype.stateInTagName = function(c) {
        if ($a6390311aed7e077$var$isEndOfTagSection(c)) {
            this.cbs.onopentagname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $a6390311aed7e077$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateBeforeClosingTagName = function(c) {
        if ($a6390311aed7e077$var$isWhitespace(c)) ;
        else if (c === $a6390311aed7e077$var$CharCodes.Gt) this.state = $a6390311aed7e077$var$State.Text;
        else {
            this.state = this.isTagStartChar(c) ? $a6390311aed7e077$var$State.InClosingTagName : $a6390311aed7e077$var$State.InSpecialComment;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateInClosingTagName = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt || $a6390311aed7e077$var$isWhitespace(c)) {
            this.cbs.onclosetag(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $a6390311aed7e077$var$State.AfterClosingTagName;
            this.stateAfterClosingTagName(c);
        }
    };
    Tokenizer.prototype.stateAfterClosingTagName = function(c) {
        // Skip everything until ">"
        if (c === $a6390311aed7e077$var$CharCodes.Gt || this.fastForwardTo($a6390311aed7e077$var$CharCodes.Gt)) {
            this.state = $a6390311aed7e077$var$State.Text;
            this.baseState = $a6390311aed7e077$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeName = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt) {
            this.cbs.onopentagend(this.index);
            if (this.isSpecial) {
                this.state = $a6390311aed7e077$var$State.InSpecialTag;
                this.sequenceIndex = 0;
            } else this.state = $a6390311aed7e077$var$State.Text;
            this.baseState = this.state;
            this.sectionStart = this.index + 1;
        } else if (c === $a6390311aed7e077$var$CharCodes.Slash) this.state = $a6390311aed7e077$var$State.InSelfClosingTag;
        else if (!$a6390311aed7e077$var$isWhitespace(c)) {
            this.state = $a6390311aed7e077$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateInSelfClosingTag = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt) {
            this.cbs.onselfclosingtag(this.index);
            this.state = $a6390311aed7e077$var$State.Text;
            this.baseState = $a6390311aed7e077$var$State.Text;
            this.sectionStart = this.index + 1;
            this.isSpecial = false; // Reset special state, in case of self-closing special tags
        } else if (!$a6390311aed7e077$var$isWhitespace(c)) {
            this.state = $a6390311aed7e077$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        }
    };
    Tokenizer.prototype.stateInAttributeName = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Eq || $a6390311aed7e077$var$isEndOfTagSection(c)) {
            this.cbs.onattribname(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.state = $a6390311aed7e077$var$State.AfterAttributeName;
            this.stateAfterAttributeName(c);
        }
    };
    Tokenizer.prototype.stateAfterAttributeName = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Eq) this.state = $a6390311aed7e077$var$State.BeforeAttributeValue;
        else if (c === $a6390311aed7e077$var$CharCodes.Slash || c === $a6390311aed7e077$var$CharCodes.Gt) {
            this.cbs.onattribend($a6390311aed7e077$var$QuoteType.NoValue, this.index);
            this.state = $a6390311aed7e077$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (!$a6390311aed7e077$var$isWhitespace(c)) {
            this.cbs.onattribend($a6390311aed7e077$var$QuoteType.NoValue, this.index);
            this.state = $a6390311aed7e077$var$State.InAttributeName;
            this.sectionStart = this.index;
        }
    };
    Tokenizer.prototype.stateBeforeAttributeValue = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.DoubleQuote) {
            this.state = $a6390311aed7e077$var$State.InAttributeValueDq;
            this.sectionStart = this.index + 1;
        } else if (c === $a6390311aed7e077$var$CharCodes.SingleQuote) {
            this.state = $a6390311aed7e077$var$State.InAttributeValueSq;
            this.sectionStart = this.index + 1;
        } else if (!$a6390311aed7e077$var$isWhitespace(c)) {
            this.sectionStart = this.index;
            this.state = $a6390311aed7e077$var$State.InAttributeValueNq;
            this.stateInAttributeValueNoQuotes(c); // Reconsume token
        }
    };
    Tokenizer.prototype.handleInAttributeValue = function(c, quote) {
        if (c === quote || !this.decodeEntities && this.fastForwardTo(quote)) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend(quote === $a6390311aed7e077$var$CharCodes.DoubleQuote ? $a6390311aed7e077$var$QuoteType.Double : $a6390311aed7e077$var$QuoteType.Single, this.index);
            this.state = $a6390311aed7e077$var$State.BeforeAttributeName;
        } else if (this.decodeEntities && c === $a6390311aed7e077$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $a6390311aed7e077$var$State.BeforeEntity;
        }
    };
    Tokenizer.prototype.stateInAttributeValueDoubleQuotes = function(c) {
        this.handleInAttributeValue(c, $a6390311aed7e077$var$CharCodes.DoubleQuote);
    };
    Tokenizer.prototype.stateInAttributeValueSingleQuotes = function(c) {
        this.handleInAttributeValue(c, $a6390311aed7e077$var$CharCodes.SingleQuote);
    };
    Tokenizer.prototype.stateInAttributeValueNoQuotes = function(c) {
        if ($a6390311aed7e077$var$isWhitespace(c) || c === $a6390311aed7e077$var$CharCodes.Gt) {
            this.cbs.onattribdata(this.sectionStart, this.index);
            this.sectionStart = -1;
            this.cbs.onattribend($a6390311aed7e077$var$QuoteType.Unquoted, this.index);
            this.state = $a6390311aed7e077$var$State.BeforeAttributeName;
            this.stateBeforeAttributeName(c);
        } else if (this.decodeEntities && c === $a6390311aed7e077$var$CharCodes.Amp) {
            this.baseState = this.state;
            this.state = $a6390311aed7e077$var$State.BeforeEntity;
        }
    };
    Tokenizer.prototype.stateBeforeDeclaration = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.OpeningSquareBracket) {
            this.state = $a6390311aed7e077$var$State.CDATASequence;
            this.sequenceIndex = 0;
        } else this.state = c === $a6390311aed7e077$var$CharCodes.Dash ? $a6390311aed7e077$var$State.BeforeComment : $a6390311aed7e077$var$State.InDeclaration;
    };
    Tokenizer.prototype.stateInDeclaration = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt || this.fastForwardTo($a6390311aed7e077$var$CharCodes.Gt)) {
            this.cbs.ondeclaration(this.sectionStart, this.index);
            this.state = $a6390311aed7e077$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateInProcessingInstruction = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt || this.fastForwardTo($a6390311aed7e077$var$CharCodes.Gt)) {
            this.cbs.onprocessinginstruction(this.sectionStart, this.index);
            this.state = $a6390311aed7e077$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeComment = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Dash) {
            this.state = $a6390311aed7e077$var$State.InCommentLike;
            this.currentSequence = $a6390311aed7e077$var$Sequences.CommentEnd;
            // Allow short comments (eg. <!-->)
            this.sequenceIndex = 2;
            this.sectionStart = this.index + 1;
        } else this.state = $a6390311aed7e077$var$State.InDeclaration;
    };
    Tokenizer.prototype.stateInSpecialComment = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Gt || this.fastForwardTo($a6390311aed7e077$var$CharCodes.Gt)) {
            this.cbs.oncomment(this.sectionStart, this.index, 0);
            this.state = $a6390311aed7e077$var$State.Text;
            this.sectionStart = this.index + 1;
        }
    };
    Tokenizer.prototype.stateBeforeSpecialS = function(c) {
        var lower = c | 0x20;
        if (lower === $a6390311aed7e077$var$Sequences.ScriptEnd[3]) this.startSpecial($a6390311aed7e077$var$Sequences.ScriptEnd, 4);
        else if (lower === $a6390311aed7e077$var$Sequences.StyleEnd[3]) this.startSpecial($a6390311aed7e077$var$Sequences.StyleEnd, 4);
        else {
            this.state = $a6390311aed7e077$var$State.InTagName;
            this.stateInTagName(c); // Consume the token again
        }
    };
    Tokenizer.prototype.stateBeforeEntity = function(c) {
        // Start excess with 1 to include the '&'
        this.entityExcess = 1;
        this.entityResult = 0;
        if (c === $a6390311aed7e077$var$CharCodes.Number) this.state = $a6390311aed7e077$var$State.BeforeNumericEntity;
        else if (c === $a6390311aed7e077$var$CharCodes.Amp) ;
        else {
            this.trieIndex = 0;
            this.trieCurrent = this.entityTrie[0];
            this.state = $a6390311aed7e077$var$State.InNamedEntity;
            this.stateInNamedEntity(c);
        }
    };
    Tokenizer.prototype.stateInNamedEntity = function(c) {
        this.entityExcess += 1;
        this.trieIndex = (0, $Tj5sm.determineBranch)(this.entityTrie, this.trieCurrent, this.trieIndex + 1, c);
        if (this.trieIndex < 0) {
            this.emitNamedEntity();
            this.index--;
            return;
        }
        this.trieCurrent = this.entityTrie[this.trieIndex];
        var masked = this.trieCurrent & $Tj5sm.BinTrieFlags.VALUE_LENGTH;
        // If the branch is a value, store it and continue
        if (masked) {
            // The mask is the number of bytes of the value, including the current byte.
            var valueLength = (masked >> 14) - 1;
            // If we have a legacy entity while parsing strictly, just skip the number of bytes
            if (!this.allowLegacyEntity() && c !== $a6390311aed7e077$var$CharCodes.Semi) this.trieIndex += valueLength;
            else {
                // Add 1 as we have already incremented the excess
                var entityStart = this.index - this.entityExcess + 1;
                if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
                // If this is a surrogate pair, consume the next two bytes
                this.entityResult = this.trieIndex;
                this.trieIndex += valueLength;
                this.entityExcess = 0;
                this.sectionStart = this.index + 1;
                if (valueLength === 0) this.emitNamedEntity();
            }
        }
    };
    Tokenizer.prototype.emitNamedEntity = function() {
        this.state = this.baseState;
        if (this.entityResult === 0) return;
        var valueLength = (this.entityTrie[this.entityResult] & $Tj5sm.BinTrieFlags.VALUE_LENGTH) >> 14;
        switch(valueLength){
            case 1:
                this.emitCodePoint(this.entityTrie[this.entityResult] & ~$Tj5sm.BinTrieFlags.VALUE_LENGTH);
                break;
            case 2:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                break;
            case 3:
                this.emitCodePoint(this.entityTrie[this.entityResult + 1]);
                this.emitCodePoint(this.entityTrie[this.entityResult + 2]);
        }
    };
    Tokenizer.prototype.stateBeforeNumericEntity = function(c) {
        if ((c | 0x20) === $a6390311aed7e077$var$CharCodes.LowerX) {
            this.entityExcess++;
            this.state = $a6390311aed7e077$var$State.InHexEntity;
        } else {
            this.state = $a6390311aed7e077$var$State.InNumericEntity;
            this.stateInNumericEntity(c);
        }
    };
    Tokenizer.prototype.emitNumericEntity = function(strict) {
        var entityStart = this.index - this.entityExcess - 1;
        var numberStart = entityStart + 2 + Number(this.state === $a6390311aed7e077$var$State.InHexEntity);
        if (numberStart !== this.index) {
            // Emit leading data if any
            if (entityStart > this.sectionStart) this.emitPartial(this.sectionStart, entityStart);
            this.sectionStart = this.index + Number(strict);
            this.emitCodePoint((0, $Tj5sm.replaceCodePoint)(this.entityResult));
        }
        this.state = this.baseState;
    };
    Tokenizer.prototype.stateInNumericEntity = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($a6390311aed7e077$var$isNumber(c)) {
            this.entityResult = this.entityResult * 10 + (c - $a6390311aed7e077$var$CharCodes.Zero);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    };
    Tokenizer.prototype.stateInHexEntity = function(c) {
        if (c === $a6390311aed7e077$var$CharCodes.Semi) this.emitNumericEntity(true);
        else if ($a6390311aed7e077$var$isNumber(c)) {
            this.entityResult = this.entityResult * 16 + (c - $a6390311aed7e077$var$CharCodes.Zero);
            this.entityExcess++;
        } else if ($a6390311aed7e077$var$isHexDigit(c)) {
            this.entityResult = this.entityResult * 16 + ((c | 0x20) - $a6390311aed7e077$var$CharCodes.LowerA + 10);
            this.entityExcess++;
        } else {
            if (this.allowLegacyEntity()) this.emitNumericEntity(false);
            else this.state = this.baseState;
            this.index--;
        }
    };
    Tokenizer.prototype.allowLegacyEntity = function() {
        return !this.xmlMode && (this.baseState === $a6390311aed7e077$var$State.Text || this.baseState === $a6390311aed7e077$var$State.InSpecialTag);
    };
    /**
     * Remove data that has already been consumed from the buffer.
     */ Tokenizer.prototype.cleanup = function() {
        // If we are inside of text or attributes, emit what we already have.
        if (this.running && this.sectionStart !== this.index) {
            if (this.state === $a6390311aed7e077$var$State.Text || this.state === $a6390311aed7e077$var$State.InSpecialTag && this.sequenceIndex === 0) {
                this.cbs.ontext(this.sectionStart, this.index);
                this.sectionStart = this.index;
            } else if (this.state === $a6390311aed7e077$var$State.InAttributeValueDq || this.state === $a6390311aed7e077$var$State.InAttributeValueSq || this.state === $a6390311aed7e077$var$State.InAttributeValueNq) {
                this.cbs.onattribdata(this.sectionStart, this.index);
                this.sectionStart = this.index;
            }
        }
    };
    Tokenizer.prototype.shouldContinue = function() {
        return this.index < this.buffer.length + this.offset && this.running;
    };
    /**
     * Iterates through the buffer, calling the function corresponding to the current state.
     *
     * States that are more likely to be hit are higher up, as a performance improvement.
     */ Tokenizer.prototype.parse = function() {
        while(this.shouldContinue()){
            var c = this.buffer.charCodeAt(this.index - this.offset);
            switch(this.state){
                case $a6390311aed7e077$var$State.Text:
                    this.stateText(c);
                    break;
                case $a6390311aed7e077$var$State.SpecialStartSequence:
                    this.stateSpecialStartSequence(c);
                    break;
                case $a6390311aed7e077$var$State.InSpecialTag:
                    this.stateInSpecialTag(c);
                    break;
                case $a6390311aed7e077$var$State.CDATASequence:
                    this.stateCDATASequence(c);
                    break;
                case $a6390311aed7e077$var$State.InAttributeValueDq:
                    this.stateInAttributeValueDoubleQuotes(c);
                    break;
                case $a6390311aed7e077$var$State.InAttributeName:
                    this.stateInAttributeName(c);
                    break;
                case $a6390311aed7e077$var$State.InCommentLike:
                    this.stateInCommentLike(c);
                    break;
                case $a6390311aed7e077$var$State.InSpecialComment:
                    this.stateInSpecialComment(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeAttributeName:
                    this.stateBeforeAttributeName(c);
                    break;
                case $a6390311aed7e077$var$State.InTagName:
                    this.stateInTagName(c);
                    break;
                case $a6390311aed7e077$var$State.InClosingTagName:
                    this.stateInClosingTagName(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeTagName:
                    this.stateBeforeTagName(c);
                    break;
                case $a6390311aed7e077$var$State.AfterAttributeName:
                    this.stateAfterAttributeName(c);
                    break;
                case $a6390311aed7e077$var$State.InAttributeValueSq:
                    this.stateInAttributeValueSingleQuotes(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeAttributeValue:
                    this.stateBeforeAttributeValue(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeClosingTagName:
                    this.stateBeforeClosingTagName(c);
                    break;
                case $a6390311aed7e077$var$State.AfterClosingTagName:
                    this.stateAfterClosingTagName(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeSpecialS:
                    this.stateBeforeSpecialS(c);
                    break;
                case $a6390311aed7e077$var$State.InAttributeValueNq:
                    this.stateInAttributeValueNoQuotes(c);
                    break;
                case $a6390311aed7e077$var$State.InSelfClosingTag:
                    this.stateInSelfClosingTag(c);
                    break;
                case $a6390311aed7e077$var$State.InDeclaration:
                    this.stateInDeclaration(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeDeclaration:
                    this.stateBeforeDeclaration(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeComment:
                    this.stateBeforeComment(c);
                    break;
                case $a6390311aed7e077$var$State.InProcessingInstruction:
                    this.stateInProcessingInstruction(c);
                    break;
                case $a6390311aed7e077$var$State.InNamedEntity:
                    this.stateInNamedEntity(c);
                    break;
                case $a6390311aed7e077$var$State.BeforeEntity:
                    this.stateBeforeEntity(c);
                    break;
                case $a6390311aed7e077$var$State.InHexEntity:
                    this.stateInHexEntity(c);
                    break;
                case $a6390311aed7e077$var$State.InNumericEntity:
                    this.stateInNumericEntity(c);
                    break;
                default:
                    // `this._state === State.BeforeNumericEntity`
                    this.stateBeforeNumericEntity(c);
            }
            this.index++;
        }
        this.cleanup();
    };
    Tokenizer.prototype.finish = function() {
        if (this.state === $a6390311aed7e077$var$State.InNamedEntity) this.emitNamedEntity();
        // If there is remaining data, emit it in a reasonable way
        if (this.sectionStart < this.index) this.handleTrailingData();
        this.cbs.onend();
    };
    /** Handle any trailing data. */ Tokenizer.prototype.handleTrailingData = function() {
        var endIndex = this.buffer.length + this.offset;
        if (this.state === $a6390311aed7e077$var$State.InCommentLike) {
            if (this.currentSequence === $a6390311aed7e077$var$Sequences.CdataEnd) this.cbs.oncdata(this.sectionStart, endIndex, 0);
            else this.cbs.oncomment(this.sectionStart, endIndex, 0);
        } else if (this.state === $a6390311aed7e077$var$State.InNumericEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $a6390311aed7e077$var$State.InHexEntity && this.allowLegacyEntity()) this.emitNumericEntity(false);
        else if (this.state === $a6390311aed7e077$var$State.InTagName || this.state === $a6390311aed7e077$var$State.BeforeAttributeName || this.state === $a6390311aed7e077$var$State.BeforeAttributeValue || this.state === $a6390311aed7e077$var$State.AfterAttributeName || this.state === $a6390311aed7e077$var$State.InAttributeName || this.state === $a6390311aed7e077$var$State.InAttributeValueSq || this.state === $a6390311aed7e077$var$State.InAttributeValueDq || this.state === $a6390311aed7e077$var$State.InAttributeValueNq || this.state === $a6390311aed7e077$var$State.InClosingTagName) ;
        else this.cbs.ontext(this.sectionStart, endIndex);
    };
    Tokenizer.prototype.emitPartial = function(start, endIndex) {
        if (this.baseState !== $a6390311aed7e077$var$State.Text && this.baseState !== $a6390311aed7e077$var$State.InSpecialTag) this.cbs.onattribdata(start, endIndex);
        else this.cbs.ontext(start, endIndex);
    };
    Tokenizer.prototype.emitCodePoint = function(cp) {
        if (this.baseState !== $a6390311aed7e077$var$State.Text && this.baseState !== $a6390311aed7e077$var$State.InSpecialTag) this.cbs.onattribentity(cp);
        else this.cbs.ontextentity(cp);
    };
    return Tokenizer;
}();
module.exports.default = $a6390311aed7e077$var$Tokenizer;

});
parcelRegister("Tj5sm", function(module, exports) {
"use strict";
var $0a63f173671c8c91$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0a63f173671c8c91$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0a63f173671c8c91$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0a63f173671c8c91$var$__createBinding(result, mod, k);
    }
    $0a63f173671c8c91$var$__setModuleDefault(result, mod);
    return result;
};
var $0a63f173671c8c91$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXML = module.exports.decodeHTMLStrict = module.exports.decodeHTMLAttribute = module.exports.decodeHTML = module.exports.determineBranch = module.exports.EntityDecoder = module.exports.DecodingMode = module.exports.BinTrieFlags = module.exports.fromCodePoint = module.exports.replaceCodePoint = module.exports.decodeCodePoint = module.exports.xmlDecodeTree = module.exports.htmlDecodeTree = void 0;

var $0a63f173671c8c91$var$decode_data_html_js_1 = $0a63f173671c8c91$var$__importDefault((parcelRequire("aXteA")));
module.exports.htmlDecodeTree = $0a63f173671c8c91$var$decode_data_html_js_1.default;

var $0a63f173671c8c91$var$decode_data_xml_js_1 = $0a63f173671c8c91$var$__importDefault((parcelRequire("hpIw9")));
module.exports.xmlDecodeTree = $0a63f173671c8c91$var$decode_data_xml_js_1.default;

var $0a63f173671c8c91$var$decode_codepoint_js_1 = $0a63f173671c8c91$var$__importStar((parcelRequire("iIWux")));
module.exports.decodeCodePoint = $0a63f173671c8c91$var$decode_codepoint_js_1.default;

Object.defineProperty(module.exports, "replaceCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("iIWux")).replaceCodePoint;
    }
});
Object.defineProperty(module.exports, "fromCodePoint", {
    enumerable: true,
    get: function() {
        return (parcelRequire("iIWux")).fromCodePoint;
    }
});
var $0a63f173671c8c91$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($0a63f173671c8c91$var$CharCodes || ($0a63f173671c8c91$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ var $0a63f173671c8c91$var$TO_LOWER_BIT = 32;
var $0a63f173671c8c91$var$BinTrieFlags;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($0a63f173671c8c91$var$BinTrieFlags = module.exports.BinTrieFlags || (module.exports.BinTrieFlags = {}));
function $0a63f173671c8c91$var$isNumber(code) {
    return code >= $0a63f173671c8c91$var$CharCodes.ZERO && code <= $0a63f173671c8c91$var$CharCodes.NINE;
}
function $0a63f173671c8c91$var$isHexadecimalCharacter(code) {
    return code >= $0a63f173671c8c91$var$CharCodes.UPPER_A && code <= $0a63f173671c8c91$var$CharCodes.UPPER_F || code >= $0a63f173671c8c91$var$CharCodes.LOWER_A && code <= $0a63f173671c8c91$var$CharCodes.LOWER_F;
}
function $0a63f173671c8c91$var$isAsciiAlphaNumeric(code) {
    return code >= $0a63f173671c8c91$var$CharCodes.UPPER_A && code <= $0a63f173671c8c91$var$CharCodes.UPPER_Z || code >= $0a63f173671c8c91$var$CharCodes.LOWER_A && code <= $0a63f173671c8c91$var$CharCodes.LOWER_Z || $0a63f173671c8c91$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $0a63f173671c8c91$var$isEntityInAttributeInvalidEnd(code) {
    return code === $0a63f173671c8c91$var$CharCodes.EQUALS || $0a63f173671c8c91$var$isAsciiAlphaNumeric(code);
}
var $0a63f173671c8c91$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($0a63f173671c8c91$var$EntityDecoderState || ($0a63f173671c8c91$var$EntityDecoderState = {}));
var $0a63f173671c8c91$var$DecodingMode;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($0a63f173671c8c91$var$DecodingMode = module.exports.DecodingMode || (module.exports.DecodingMode = {}));
/**
 * Token decoder with support of writing partial entities.
 */ var $0a63f173671c8c91$var$EntityDecoder = /** @class */ function() {
    function EntityDecoder(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors) {
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $0a63f173671c8c91$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $0a63f173671c8c91$var$DecodingMode.Strict;
    }
    /** Resets the instance to make it reusable. */ EntityDecoder.prototype.startEntity = function(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $0a63f173671c8c91$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    };
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.write = function(str, offset) {
        switch(this.state){
            case $0a63f173671c8c91$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $0a63f173671c8c91$var$CharCodes.NUM) {
                    this.state = $0a63f173671c8c91$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $0a63f173671c8c91$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $0a63f173671c8c91$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $0a63f173671c8c91$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $0a63f173671c8c91$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $0a63f173671c8c91$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    };
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericStart = function(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $0a63f173671c8c91$var$TO_LOWER_BIT) === $0a63f173671c8c91$var$CharCodes.LOWER_X) {
            this.state = $0a63f173671c8c91$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $0a63f173671c8c91$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    };
    EntityDecoder.prototype.addToNumericResult = function(str, start, end, base) {
        if (start !== end) {
            var digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    };
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericHex = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($0a63f173671c8c91$var$isNumber(char) || $0a63f173671c8c91$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    };
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNumericDecimal = function(str, offset) {
        var startIdx = offset;
        while(offset < str.length){
            var char = str.charCodeAt(offset);
            if ($0a63f173671c8c91$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    };
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ EntityDecoder.prototype.emitNumericEntity = function(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $0a63f173671c8c91$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $0a63f173671c8c91$var$DecodingMode.Strict) return 0;
        this.emitCodePoint((0, $0a63f173671c8c91$var$decode_codepoint_js_1.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $0a63f173671c8c91$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    };
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ EntityDecoder.prototype.stateNamedEntity = function(str, offset) {
        var decodeTree = this.decodeTree;
        var current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        var valueLength = (current & $0a63f173671c8c91$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            var char = str.charCodeAt(offset);
            this.treeIndex = $0a63f173671c8c91$var$determineBranch(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $0a63f173671c8c91$var$DecodingMode.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $0a63f173671c8c91$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $0a63f173671c8c91$var$BinTrieFlags.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $0a63f173671c8c91$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $0a63f173671c8c91$var$DecodingMode.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    };
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNotTerminatedNamedEntity = function() {
        var _a;
        var _b = this, result = _b.result, decodeTree = _b.decodeTree;
        var valueLength = (decodeTree[result] & $0a63f173671c8c91$var$BinTrieFlags.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    };
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.emitNamedEntityData = function(result, valueLength, consumed) {
        var decodeTree = this.decodeTree;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$0a63f173671c8c91$var$BinTrieFlags.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    };
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ EntityDecoder.prototype.end = function() {
        var _a;
        switch(this.state){
            case $0a63f173671c8c91$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $0a63f173671c8c91$var$DecodingMode.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $0a63f173671c8c91$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $0a63f173671c8c91$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $0a63f173671c8c91$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $0a63f173671c8c91$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    };
    return EntityDecoder;
}();
module.exports.EntityDecoder = $0a63f173671c8c91$var$EntityDecoder;
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $0a63f173671c8c91$var$getDecoder(decodeTree) {
    var ret = "";
    var decoder = new $0a63f173671c8c91$var$EntityDecoder(decodeTree, function(str) {
        return ret += (0, $0a63f173671c8c91$var$decode_codepoint_js_1.fromCodePoint)(str);
    });
    return function decodeWithTrie(str, decodeMode) {
        var lastIndex = 0;
        var offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            var len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        var result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
/**
 * Determines the branch of the current node that is taken given the current
 * character. This function is used to traverse the trie.
 *
 * @param decodeTree The trie.
 * @param current The current node.
 * @param nodeIdx The index right after the current node and its value.
 * @param char The current character.
 * @returns The index of the next node, or -1 if no branch is taken.
 */ function $0a63f173671c8c91$var$determineBranch(decodeTree, current, nodeIdx, char) {
    var branchCount = (current & $0a63f173671c8c91$var$BinTrieFlags.BRANCH_LENGTH) >> 7;
    var jumpOffset = current & $0a63f173671c8c91$var$BinTrieFlags.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        var value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    var lo = nodeIdx;
    var hi = lo + branchCount - 1;
    while(lo <= hi){
        var mid = lo + hi >>> 1;
        var midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
module.exports.determineBranch = $0a63f173671c8c91$var$determineBranch;
var $0a63f173671c8c91$var$htmlDecoder = $0a63f173671c8c91$var$getDecoder($0a63f173671c8c91$var$decode_data_html_js_1.default);
var $0a63f173671c8c91$var$xmlDecoder = $0a63f173671c8c91$var$getDecoder($0a63f173671c8c91$var$decode_data_xml_js_1.default);
/**
 * Decodes an HTML string.
 *
 * @param str The string to decode.
 * @param mode The decoding mode.
 * @returns The decoded string.
 */ function $0a63f173671c8c91$var$decodeHTML(str, mode) {
    if (mode === void 0) mode = $0a63f173671c8c91$var$DecodingMode.Legacy;
    return $0a63f173671c8c91$var$htmlDecoder(str, mode);
}
module.exports.decodeHTML = $0a63f173671c8c91$var$decodeHTML;
/**
 * Decodes an HTML string in an attribute.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0a63f173671c8c91$var$decodeHTMLAttribute(str) {
    return $0a63f173671c8c91$var$htmlDecoder(str, $0a63f173671c8c91$var$DecodingMode.Attribute);
}
module.exports.decodeHTMLAttribute = $0a63f173671c8c91$var$decodeHTMLAttribute;
/**
 * Decodes an HTML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0a63f173671c8c91$var$decodeHTMLStrict(str) {
    return $0a63f173671c8c91$var$htmlDecoder(str, $0a63f173671c8c91$var$DecodingMode.Strict);
}
module.exports.decodeHTMLStrict = $0a63f173671c8c91$var$decodeHTMLStrict;
/**
 * Decodes an XML string, requiring all entities to be terminated by a semicolon.
 *
 * @param str The string to decode.
 * @returns The decoded string.
 */ function $0a63f173671c8c91$var$decodeXML(str) {
    return $0a63f173671c8c91$var$xmlDecoder(str, $0a63f173671c8c91$var$DecodingMode.Strict);
}
module.exports.decodeXML = $0a63f173671c8c91$var$decodeXML;

});
parcelRegister("aXteA", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
'\u1D41<\xd5\u0131\u028A\u049D\u057B\u05D0\u0675\u06DE\u07A2\u07D6\u080F\u0A4A\u0A91\u0DA1\u0E6D\u0F09\u0F26\u10CA\u1228\u12E1\u1415\u149D\u14C3\u14DF\u1525\x00\x00\x00\x00\x00\x00\u156B\u16CD\u198D\u1C12\u1DDD\u1F7E\u2060\u21B0\u228D\u23C0\u23FB\u2442\u2824\u2912\u2D08\u2E48\u2FCE\u3016\u32BA\u3639\u37AC\u38FE\u3A28\u3A71\u3AE0\u3B2E\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803B\xc6\u40C6P\u803B&\u4026cute\u803B\xc1\u40C1reve;\u4102\u0100iyx}rc\u803B\xc2\u40C2;\u4410r;\uC000\ud835\udd04rave\u803B\xc0\u40C0pha;\u4391acr;\u4100d;\u6A53\u0100gp\x9d\xa1on;\u4104f;\uC000\ud835\udd38plyFunction;\u6061ing\u803B\xc5\u40C5\u0100cs\xbe\xc3r;\uC000\ud835\udc9cign;\u6254ilde\u803B\xc3\u40C3ml\u803B\xc4\u40C4\u0400aceforsu\xe5\xfb\xfe\u0117\u011C\u0122\u0127\u012A\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6AE7ed;\u6306y;\u4411\u0180crt\u0105\u010B\u0114ause;\u6235noullis;\u612Ca;\u4392r;\uC000\ud835\udd05pf;\uC000\ud835\udd39eve;\u42D8c\xf2\u0113mpeq;\u624E\u0700HOacdefhilorsu\u014D\u0151\u0156\u0180\u019E\u01A2\u01B5\u01B7\u01BA\u01DC\u0215\u0273\u0278\u027Ecy;\u4427PY\u803B\xa9\u40A9\u0180cpy\u015D\u0162\u017Aute;\u4106\u0100;i\u0167\u0168\u62D2talDifferentialD;\u6145leys;\u612D\u0200aeio\u0189\u018E\u0194\u0198ron;\u410Cdil\u803B\xc7\u40C7rc;\u4108nint;\u6230ot;\u410A\u0100dn\u01A7\u01ADilla;\u40B8terDot;\u40B7\xf2\u017Fi;\u43A7rcle\u0200DMPT\u01C7\u01CB\u01D1\u01D6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01E2\u01F8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020FoubleQuote;\u601Duote;\u6019\u0200lnpu\u021E\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6A74\u0180git\u022F\u0236\u023Aruent;\u6261nt;\u622FourIntegral;\u622E\u0100fr\u024C\u024E;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6A2Fcr;\uC000\ud835\udc9ep\u0100;C\u0284\u0285\u62D3ap;\u624D\u0580DJSZacefios\u02A0\u02AC\u02B0\u02B4\u02B8\u02CB\u02D7\u02E1\u02E6\u0333\u048D\u0100;o\u0179\u02A5trahd;\u6911cy;\u4402cy;\u4405cy;\u440F\u0180grs\u02BF\u02C4\u02C7ger;\u6021r;\u61A1hv;\u6AE4\u0100ay\u02D0\u02D5ron;\u410E;\u4414l\u0100;t\u02DD\u02DE\u6207a;\u4394r;\uC000\ud835\udd07\u0100af\u02EB\u0327\u0100cm\u02F0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031Ccute;\u40B4o\u0174\u030B\u030D;\u42D9bleAcute;\u42DDrave;\u4060ilde;\u42DCond;\u62C4ferentialD;\u6146\u0470\u033D\x00\x00\x00\u0342\u0354\x00\u0405f;\uC000\ud835\udd3b\u0180;DE\u0348\u0349\u034D\u40A8ot;\u60DCqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03CF\u03E2\u03F8ontourIntegra\xec\u0239o\u0274\u0379\x00\x00\u037B\xbb\u0349nArrow;\u61D3\u0100eo\u0387\u03A4ft\u0180ART\u0390\u0396\u03A1rrow;\u61D0ightArrow;\u61D4e\xe5\u02CAng\u0100LR\u03AB\u03C4eft\u0100AR\u03B3\u03B9rrow;\u67F8ightArrow;\u67FAightArrow;\u67F9ight\u0100AT\u03D8\u03DErrow;\u61D2ee;\u62A8p\u0241\u03E9\x00\x00\u03EFrrow;\u61D1ownArrow;\u61D5erticalBar;\u6225n\u0300ABLRTa\u0412\u042A\u0430\u045E\u047F\u037Crrow\u0180;BU\u041D\u041E\u0422\u6193ar;\u6913pArrow;\u61F5reve;\u4311eft\u02D2\u043A\x00\u0446\x00\u0450ightVector;\u6950eeVector;\u695Eector\u0100;B\u0459\u045A\u61BDar;\u6956ight\u01D4\u0467\x00\u0471eeVector;\u695Fector\u0100;B\u047A\u047B\u61C1ar;\u6957ee\u0100;A\u0486\u0487\u62A4rrow;\u61A7\u0100ct\u0492\u0497r;\uC000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04BD\u04C0\u04C4\u04CB\u04DE\u04E2\u04E7\u04EE\u04F5\u0521\u052F\u0536\u0552\u055D\u0560\u0565G;\u414AH\u803B\xd0\u40D0cute\u803B\xc9\u40C9\u0180aiy\u04D2\u04D7\u04DCron;\u411Arc\u803B\xca\u40CA;\u442Dot;\u4116r;\uC000\ud835\udd08rave\u803B\xc8\u40C8ement;\u6208\u0100ap\u04FA\u04FEcr;\u4112ty\u0253\u0506\x00\x00\u0512mallSquare;\u65FBerySmallSquare;\u65AB\u0100gp\u0526\u052Aon;\u4118f;\uC000\ud835\udd3csilon;\u4395u\u0100ai\u053C\u0549l\u0100;T\u0542\u0543\u6A75ilde;\u6242librium;\u61CC\u0100ci\u0557\u055Ar;\u6130m;\u6A73a;\u4397ml\u803B\xcb\u40CB\u0100ip\u056A\u056Fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058D\u05B2\u05CCy;\u4424r;\uC000\ud835\udd09lled\u0253\u0597\x00\x00\u05A3mallSquare;\u65FCerySmallSquare;\u65AA\u0370\u05BA\x00\u05BF\x00\x00\u05C4f;\uC000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05CB\u0600JTabcdfgorst\u05E8\u05EC\u05EF\u05FA\u0600\u0612\u0616\u061B\u061D\u0623\u066C\u0672cy;\u4403\u803B>\u403Emma\u0100;d\u05F7\u05F8\u4393;\u43DCreve;\u411E\u0180eiy\u0607\u060C\u0610dil;\u4122rc;\u411C;\u4413ot;\u4120r;\uC000\ud835\udd0a;\u62D9pf;\uC000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064E\u0656\u065B\u0666qual\u0100;L\u063E\u063F\u6265ess;\u62DBullEqual;\u6267reater;\u6AA2ess;\u6277lantEqual;\u6A7Eilde;\u6273cr;\uC000\ud835\udca2;\u626B\u0400Aacfiosu\u0685\u068B\u0696\u069B\u069E\u06AA\u06BE\u06CARDcy;\u442A\u0100ct\u0690\u0694ek;\u42C7;\u405Eirc;\u4124r;\u610ClbertSpace;\u610B\u01F0\u06AF\x00\u06B2f;\u610DizontalLine;\u6500\u0100ct\u06C3\u06C5\xf2\u06A9rok;\u4126mp\u0144\u06D0\u06D8ownHum\xf0\u012Fqual;\u624F\u0700EJOacdfgmnostu\u06FA\u06FE\u0703\u0707\u070E\u071A\u071E\u0721\u0728\u0744\u0778\u078B\u078F\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803B\xcd\u40CD\u0100iy\u0713\u0718rc\u803B\xce\u40CE;\u4418ot;\u4130r;\u6111rave\u803B\xcc\u40CC\u0180;ap\u0720\u072F\u073F\u0100cg\u0734\u0737r;\u412AinaryI;\u6148lie\xf3\u03DD\u01F4\u0749\x00\u0762\u0100;e\u074D\u074E\u622C\u0100gr\u0753\u0758ral;\u622Bsection;\u62C2isible\u0100CT\u076C\u0772omma;\u6063imes;\u6062\u0180gpt\u077F\u0783\u0788on;\u412Ef;\uC000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01EB\u079A\x00\u079Ecy;\u4406l\u803B\xcf\u40CF\u0280cfosu\u07AC\u07B7\u07BC\u07C2\u07D0\u0100iy\u07B1\u07B5rc;\u4134;\u4419r;\uC000\ud835\udd0dpf;\uC000\ud835\udd41\u01E3\u07C7\x00\u07CCr;\uC000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07E4\u07E8\u07EC\u07F1\u07FD\u0802\u0808cy;\u4425cy;\u440Cppa;\u439A\u0100ey\u07F6\u07FBdil;\u4136;\u441Ar;\uC000\ud835\udd0epf;\uC000\ud835\udd42cr;\uC000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082C\u0850\u0863\u09B3\u09B8\u09C7\u09CD\u0A37\u0A47cy;\u4409\u803B<\u403C\u0280cmnpr\u0837\u083C\u0841\u0844\u084Dute;\u4139bda;\u439Bg;\u67EAlacetrf;\u6112r;\u619E\u0180aey\u0857\u085C\u0861ron;\u413Ddil;\u413B;\u441B\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087E\u08A9\u08B1\u08E0\u08E6\u08FC\u092F\u095B\u0390\u096A\u0100nr\u0883\u088FgleBracket;\u67E8row\u0180;BR\u0899\u089A\u089E\u6190ar;\u61E4ightArrow;\u61C6eiling;\u6308o\u01F5\u08B7\x00\u08C3bleBracket;\u67E6n\u01D4\u08C8\x00\u08D2eeVector;\u6961ector\u0100;B\u08DB\u08DC\u61C3ar;\u6959loor;\u630Aight\u0100AV\u08EF\u08F5rrow;\u6194ector;\u694E\u0100er\u0901\u0917e\u0180;AV\u0909\u090A\u0910\u62A3rrow;\u61A4ector;\u695Aiangle\u0180;BE\u0924\u0925\u0929\u62B2ar;\u69CFqual;\u62B4p\u0180DTV\u0937\u0942\u094CownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61BFar;\u6958ector\u0100;B\u0965\u0966\u61BCar;\u6952ight\xe1\u039Cs\u0300EFGLST\u097E\u098B\u0995\u099D\u09A2\u09ADqualGreater;\u62DAullEqual;\u6266reater;\u6276ess;\u6AA1lantEqual;\u6A7Dilde;\u6272r;\uC000\ud835\udd0f\u0100;e\u09BD\u09BE\u62D8ftarrow;\u61DAidot;\u413F\u0180npw\u09D4\u0A16\u0A1Bg\u0200LRlr\u09DE\u09F7\u0A02\u0A10eft\u0100AR\u09E6\u09ECrrow;\u67F5ightArrow;\u67F7ightArrow;\u67F6eft\u0100ar\u03B3\u0A0Aight\xe1\u03BFight\xe1\u03CAf;\uC000\ud835\udd43er\u0100LR\u0A22\u0A2CeftArrow;\u6199ightArrow;\u6198\u0180cht\u0A3E\u0A40\u0A42\xf2\u084C;\u61B0rok;\u4141;\u626A\u0400acefiosu\u0A5A\u0A5D\u0A60\u0A77\u0A7C\u0A85\u0A8B\u0A8Ep;\u6905y;\u441C\u0100dl\u0A65\u0A6FiumSpace;\u605Flintrf;\u6133r;\uC000\ud835\udd10nusPlus;\u6213pf;\uC000\ud835\udd44c\xf2\u0A76;\u439C\u0480Jacefostu\u0AA3\u0AA7\u0AAD\u0AC0\u0B14\u0B19\u0D91\u0D97\u0D9Ecy;\u440Acute;\u4143\u0180aey\u0AB4\u0AB9\u0ABEron;\u4147dil;\u4145;\u441D\u0180gsw\u0AC7\u0AF0\u0B0Eative\u0180MTV\u0AD3\u0ADF\u0AE8ediumSpace;\u600Bhi\u0100cn\u0AE6\u0AD8\xeb\u0AD9eryThi\xee\u0AD9ted\u0100GL\u0AF8\u0B06reaterGreate\xf2\u0673essLes\xf3\u0A48Line;\u400Ar;\uC000\ud835\udd11\u0200Bnpt\u0B22\u0B28\u0B37\u0B3Areak;\u6060BreakingSpace;\u40A0f;\u6115\u0680;CDEGHLNPRSTV\u0B55\u0B56\u0B6A\u0B7C\u0BA1\u0BEB\u0C04\u0C5E\u0C84\u0CA6\u0CD8\u0D61\u0D85\u6AEC\u0100ou\u0B5B\u0B64ngruent;\u6262pCap;\u626DoubleVerticalBar;\u6226\u0180lqx\u0B83\u0B8A\u0B9Bement;\u6209ual\u0100;T\u0B92\u0B93\u6260ilde;\uC000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0BB6\u0BB7\u0BBD\u0BC9\u0BD3\u0BD8\u0BE5\u626Fqual;\u6271ullEqual;\uC000\u2267\u0338reater;\uC000\u226B\u0338ess;\u6279lantEqual;\uC000\u2A7E\u0338ilde;\u6275ump\u0144\u0BF2\u0BFDownHump;\uC000\u224E\u0338qual;\uC000\u224F\u0338e\u0100fs\u0C0A\u0C27tTriangle\u0180;BE\u0C1A\u0C1B\u0C21\u62EAar;\uC000\u29CF\u0338qual;\u62ECs\u0300;EGLST\u0C35\u0C36\u0C3C\u0C44\u0C4B\u0C58\u626Equal;\u6270reater;\u6278ess;\uC000\u226A\u0338lantEqual;\uC000\u2A7D\u0338ilde;\u6274ested\u0100GL\u0C68\u0C79reaterGreater;\uC000\u2AA2\u0338essLess;\uC000\u2AA1\u0338recedes\u0180;ES\u0C92\u0C93\u0C9B\u6280qual;\uC000\u2AAF\u0338lantEqual;\u62E0\u0100ei\u0CAB\u0CB9verseElement;\u620CghtTriangle\u0180;BE\u0CCB\u0CCC\u0CD2\u62EBar;\uC000\u29D0\u0338qual;\u62ED\u0100qu\u0CDD\u0D0CuareSu\u0100bp\u0CE8\u0CF9set\u0100;E\u0CF0\u0CF3\uC000\u228F\u0338qual;\u62E2erset\u0100;E\u0D03\u0D06\uC000\u2290\u0338qual;\u62E3\u0180bcp\u0D13\u0D24\u0D4Eset\u0100;E\u0D1B\u0D1E\uC000\u2282\u20D2qual;\u6288ceeds\u0200;EST\u0D32\u0D33\u0D3B\u0D46\u6281qual;\uC000\u2AB0\u0338lantEqual;\u62E1ilde;\uC000\u227F\u0338erset\u0100;E\u0D58\u0D5B\uC000\u2283\u20D2qual;\u6289ilde\u0200;EFT\u0D6E\u0D6F\u0D75\u0D7F\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uC000\ud835\udca9ilde\u803B\xd1\u40D1;\u439D\u0700Eacdfgmoprstuv\u0DBD\u0DC2\u0DC9\u0DD5\u0DDB\u0DE0\u0DE7\u0DFC\u0E02\u0E20\u0E22\u0E32\u0E3F\u0E44lig;\u4152cute\u803B\xd3\u40D3\u0100iy\u0DCE\u0DD3rc\u803B\xd4\u40D4;\u441Eblac;\u4150r;\uC000\ud835\udd12rave\u803B\xd2\u40D2\u0180aei\u0DEE\u0DF2\u0DF6cr;\u414Cga;\u43A9cron;\u439Fpf;\uC000\ud835\udd46enCurly\u0100DQ\u0E0E\u0E1AoubleQuote;\u601Cuote;\u6018;\u6A54\u0100cl\u0E27\u0E2Cr;\uC000\ud835\udcaaash\u803B\xd8\u40D8i\u016C\u0E37\u0E3Cde\u803B\xd5\u40D5es;\u6A37ml\u803B\xd6\u40D6er\u0100BP\u0E4B\u0E60\u0100ar\u0E50\u0E53r;\u603Eac\u0100ek\u0E5A\u0E5C;\u63DEet;\u63B4arenthesis;\u63DC\u0480acfhilors\u0E7F\u0E87\u0E8A\u0E8F\u0E92\u0E94\u0E9D\u0EB0\u0EFCrtialD;\u6202y;\u441Fr;\uC000\ud835\udd13i;\u43A6;\u43A0usMinus;\u40B1\u0100ip\u0EA2\u0EADncareplan\xe5\u069Df;\u6119\u0200;eio\u0EB9\u0EBA\u0EE0\u0EE4\u6ABBcedes\u0200;EST\u0EC8\u0EC9\u0ECF\u0EDA\u627Aqual;\u6AAFlantEqual;\u627Cilde;\u627Eme;\u6033\u0100dp\u0EE9\u0EEEuct;\u620Fortion\u0100;a\u0225\u0EF9l;\u621D\u0100ci\u0F01\u0F06r;\uC000\ud835\udcab;\u43A8\u0200Ufos\u0F11\u0F16\u0F1B\u0F1FOT\u803B"\u4022r;\uC000\ud835\udd14pf;\u611Acr;\uC000\ud835\udcac\u0600BEacefhiorsu\u0F3E\u0F43\u0F47\u0F60\u0F73\u0FA7\u0FAA\u0FAD\u1096\u10A9\u10B4\u10BEarr;\u6910G\u803B\xae\u40AE\u0180cnr\u0F4E\u0F53\u0F56ute;\u4154g;\u67EBr\u0100;t\u0F5C\u0F5D\u61A0l;\u6916\u0180aey\u0F67\u0F6C\u0F71ron;\u4158dil;\u4156;\u4420\u0100;v\u0F78\u0F79\u611Cerse\u0100EU\u0F82\u0F99\u0100lq\u0F87\u0F8Eement;\u620Builibrium;\u61CBpEquilibrium;\u696Fr\xbb\u0F79o;\u43A1ght\u0400ACDFTUVa\u0FC1\u0FEB\u0FF3\u1022\u1028\u105B\u1087\u03D8\u0100nr\u0FC6\u0FD2gleBracket;\u67E9row\u0180;BL\u0FDC\u0FDD\u0FE1\u6192ar;\u61E5eftArrow;\u61C4eiling;\u6309o\u01F5\u0FF9\x00\u1005bleBracket;\u67E7n\u01D4\u100A\x00\u1014eeVector;\u695Dector\u0100;B\u101D\u101E\u61C2ar;\u6955loor;\u630B\u0100er\u102D\u1043e\u0180;AV\u1035\u1036\u103C\u62A2rrow;\u61A6ector;\u695Biangle\u0180;BE\u1050\u1051\u1055\u62B3ar;\u69D0qual;\u62B5p\u0180DTV\u1063\u106E\u1078ownVector;\u694FeeVector;\u695Cector\u0100;B\u1082\u1083\u61BEar;\u6954ector\u0100;B\u1091\u1092\u61C0ar;\u6953\u0100pu\u109B\u109Ef;\u611DndImplies;\u6970ightarrow;\u61DB\u0100ch\u10B9\u10BCr;\u611B;\u61B1leDelayed;\u69F4\u0680HOacfhimoqstu\u10E4\u10F1\u10F7\u10FD\u1119\u111E\u1151\u1156\u1161\u1167\u11B5\u11BB\u11BF\u0100Cc\u10E9\u10EEHcy;\u4429y;\u4428FTcy;\u442Ccute;\u415A\u0280;aeiy\u1108\u1109\u110E\u1113\u1117\u6ABCron;\u4160dil;\u415Erc;\u415C;\u4421r;\uC000\ud835\udd16ort\u0200DLRU\u112A\u1134\u113E\u1149ownArrow\xbb\u041EeftArrow\xbb\u089AightArrow\xbb\u0FDDpArrow;\u6191gma;\u43A3allCircle;\u6218pf;\uC000\ud835\udd4a\u0272\u116D\x00\x00\u1170t;\u621Aare\u0200;ISU\u117B\u117C\u1189\u11AF\u65A1ntersection;\u6293u\u0100bp\u118F\u119Eset\u0100;E\u1197\u1198\u628Fqual;\u6291erset\u0100;E\u11A8\u11A9\u6290qual;\u6292nion;\u6294cr;\uC000\ud835\udcaear;\u62C6\u0200bcmp\u11C8\u11DB\u1209\u120B\u0100;s\u11CD\u11CE\u62D0et\u0100;E\u11CD\u11D5qual;\u6286\u0100ch\u11E0\u1205eeds\u0200;EST\u11ED\u11EE\u11F4\u11FF\u627Bqual;\u6AB0lantEqual;\u627Dilde;\u627FTh\xe1\u0F8C;\u6211\u0180;es\u1212\u1213\u1223\u62D1rset\u0100;E\u121C\u121D\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123E\u1244\u1249\u1255\u125E\u1271\u1276\u129F\u12C2\u12C8\u12D1ORN\u803B\xde\u40DEADE;\u6122\u0100Hc\u124E\u1252cy;\u440By;\u4426\u0100bu\u125A\u125C;\u4009;\u43A4\u0180aey\u1265\u126A\u126Fron;\u4164dil;\u4162;\u4422r;\uC000\ud835\udd17\u0100ei\u127B\u1289\u01F2\u1280\x00\u1287efore;\u6234a;\u4398\u0100cn\u128E\u1298kSpace;\uC000\u205F\u200ASpace;\u6009lde\u0200;EFT\u12AB\u12AC\u12B2\u12BC\u623Cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uC000\ud835\udd4bipleDot;\u60DB\u0100ct\u12D6\u12DBr;\uC000\ud835\udcafrok;\u4166\u0AE1\u12F7\u130E\u131A\u1326\x00\u132C\u1331\x00\x00\x00\x00\x00\u1338\u133D\u1377\u1385\x00\u13FF\u1404\u140A\u1410\u0100cr\u12FB\u1301ute\u803B\xda\u40DAr\u0100;o\u1307\u1308\u619Fcir;\u6949r\u01E3\u1313\x00\u1316y;\u440Eve;\u416C\u0100iy\u131E\u1323rc\u803B\xdb\u40DB;\u4423blac;\u4170r;\uC000\ud835\udd18rave\u803B\xd9\u40D9acr;\u416A\u0100di\u1341\u1369er\u0100BP\u1348\u135D\u0100ar\u134D\u1350r;\u405Fac\u0100ek\u1357\u1359;\u63DFet;\u63B5arenthesis;\u63DDon\u0100;P\u1370\u1371\u62C3lus;\u628E\u0100gp\u137B\u137Fon;\u4172f;\uC000\ud835\udd4c\u0400ADETadps\u1395\u13AE\u13B8\u13C4\u03E8\u13D2\u13D7\u13F3rrow\u0180;BD\u1150\u13A0\u13A4ar;\u6912ownArrow;\u61C5ownArrow;\u6195quilibrium;\u696Eee\u0100;A\u13CB\u13CC\u62A5rrow;\u61A5own\xe1\u03F3er\u0100LR\u13DE\u13E8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13F9\u13FA\u43D2on;\u43A5ing;\u416Ecr;\uC000\ud835\udcb0ilde;\u4168ml\u803B\xdc\u40DC\u0480Dbcdefosv\u1427\u142C\u1430\u1433\u143E\u1485\u148A\u1490\u1496ash;\u62ABar;\u6AEBy;\u4412ash\u0100;l\u143B\u143C\u62A9;\u6AE6\u0100er\u1443\u1445;\u62C1\u0180bty\u144C\u1450\u147Aar;\u6016\u0100;i\u144F\u1455cal\u0200BLST\u1461\u1465\u146A\u1474ar;\u6223ine;\u407Ceparator;\u6758ilde;\u6240ThinSpace;\u600Ar;\uC000\ud835\udd19pf;\uC000\ud835\udd4dcr;\uC000\ud835\udcb1dash;\u62AA\u0280cefos\u14A7\u14AC\u14B1\u14B6\u14BCirc;\u4174dge;\u62C0r;\uC000\ud835\udd1apf;\uC000\ud835\udd4ecr;\uC000\ud835\udcb2\u0200fios\u14CB\u14D0\u14D2\u14D8r;\uC000\ud835\udd1b;\u439Epf;\uC000\ud835\udd4fcr;\uC000\ud835\udcb3\u0480AIUacfosu\u14F1\u14F5\u14F9\u14FD\u1504\u150F\u1514\u151A\u1520cy;\u442Fcy;\u4407cy;\u442Ecute\u803B\xdd\u40DD\u0100iy\u1509\u150Drc;\u4176;\u442Br;\uC000\ud835\udd1cpf;\uC000\ud835\udd50cr;\uC000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153F\u154B\u154F\u155D\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417D;\u4417ot;\u417B\u01F2\u1554\x00\u155BoWidt\xe8\u0AD9a;\u4396r;\u6128pf;\u6124cr;\uC000\ud835\udcb5\u0BE1\u1583\u158A\u1590\x00\u15B0\u15B6\u15BF\x00\x00\x00\x00\u15C6\u15DB\u15EB\u165F\u166D\x00\u1695\u169B\u16B2\u16B9\x00\u16BEcute\u803B\xe1\u40E1reve;\u4103\u0300;Ediuy\u159C\u159D\u15A1\u15A3\u15A8\u15AD\u623E;\uC000\u223E\u0333;\u623Frc\u803B\xe2\u40E2te\u80BB\xb4\u0306;\u4430lig\u803B\xe6\u40E6\u0100;r\xb2\u15BA;\uC000\ud835\udd1erave\u803B\xe0\u40E0\u0100ep\u15CA\u15D6\u0100fp\u15CF\u15D4sym;\u6135\xe8\u15D3ha;\u43B1\u0100ap\u15DFc\u0100cl\u15E4\u15E7r;\u4101g;\u6A3F\u0264\u15F0\x00\x00\u160A\u0280;adsv\u15FA\u15FB\u15FF\u1601\u1607\u6227nd;\u6A55;\u6A5Clope;\u6A58;\u6A5A\u0380;elmrsz\u1618\u1619\u161B\u161E\u163F\u164F\u1659\u6220;\u69A4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163A\u163C\u163E;\u69A8;\u69A9;\u69AA;\u69AB;\u69AC;\u69AD;\u69AE;\u69AFt\u0100;v\u1645\u1646\u621Fb\u0100;d\u164C\u164D\u62BE;\u699D\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637C\u0100gp\u1663\u1667on;\u4105f;\uC000\ud835\udd52\u0380;Eaeiop\u12C1\u167B\u167D\u1682\u1684\u1687\u168A;\u6A70cir;\u6A6F;\u624Ad;\u624Bs;\u4027rox\u0100;e\u12C1\u1692\xf1\u1683ing\u803B\xe5\u40E5\u0180cty\u16A1\u16A6\u16A8r;\uC000\ud835\udcb6;\u402Amp\u0100;e\u12C1\u16AF\xf1\u0288ilde\u803B\xe3\u40E3ml\u803B\xe4\u40E4\u0100ci\u16C2\u16C8onin\xf4\u0272nt;\u6A11\u0800Nabcdefiklnoprsu\u16ED\u16F1\u1730\u173C\u1743\u1748\u1778\u177D\u17E0\u17E6\u1839\u1850\u170D\u193D\u1948\u1970ot;\u6AED\u0100cr\u16F6\u171Ek\u0200ceps\u1700\u1705\u170D\u1713ong;\u624Cpsilon;\u43F6rime;\u6035im\u0100;e\u171A\u171B\u623Dq;\u62CD\u0176\u1722\u1726ee;\u62BDed\u0100;g\u172C\u172D\u6305e\xbb\u172Drk\u0100;t\u135C\u1737brk;\u63B6\u0100oy\u1701\u1741;\u4431quo;\u601E\u0280cmprt\u1753\u175B\u1761\u1764\u1768aus\u0100;e\u010A\u0109ptyv;\u69B0s\xe9\u170Cno\xf5\u0113\u0180ahw\u176F\u1771\u1773;\u43B2;\u6136een;\u626Cr;\uC000\ud835\udd1fg\u0380costuvw\u178D\u179D\u17B3\u17C1\u17D5\u17DB\u17DE\u0180aiu\u1794\u1796\u179A\xf0\u0760rc;\u65EFp\xbb\u1371\u0180dpt\u17A4\u17A8\u17ADot;\u6A00lus;\u6A01imes;\u6A02\u0271\u17B9\x00\x00\u17BEcup;\u6A06ar;\u6605riangle\u0100du\u17CD\u17D2own;\u65BDp;\u65B3plus;\u6A04e\xe5\u1444\xe5\u14ADarow;\u690D\u0180ako\u17ED\u1826\u1835\u0100cn\u17F2\u1823k\u0180lst\u17FA\u05AB\u1802ozenge;\u69EBriangle\u0200;dlr\u1812\u1813\u1818\u181D\u65B4own;\u65BEeft;\u65C2ight;\u65B8k;\u6423\u01B1\u182B\x00\u1833\u01B2\u182F\x00\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183E\u184D\u0100;q\u1843\u1846\uC000=\u20E5uiv;\uC000\u2261\u20E5t;\u6310\u0200ptwx\u1859\u185E\u1867\u186Cf;\uC000\ud835\udd53\u0100;t\u13CB\u1863om\xbb\u13CCtie;\u62C8\u0600DHUVbdhmptuv\u1885\u1896\u18AA\u18BB\u18D7\u18DB\u18EC\u18FF\u1905\u190A\u1910\u1921\u0200LRlr\u188E\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18A1\u18A2\u18A4\u18A6\u18A8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18B3\u18B5\u18B7\u18B9;\u655D;\u655A;\u655C;\u6559\u0380;HLRhlr\u18CA\u18CB\u18CD\u18CF\u18D1\u18D3\u18D5\u6551;\u656C;\u6563;\u6560;\u656B;\u6562;\u655Fox;\u69C9\u0200LRlr\u18E4\u18E6\u18E8\u18EA;\u6555;\u6552;\u6510;\u650C\u0280;DUdu\u06BD\u18F7\u18F9\u18FB\u18FD;\u6565;\u6568;\u652C;\u6534inus;\u629Flus;\u629Eimes;\u62A0\u0200LRlr\u1919\u191B\u191D\u191F;\u655B;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193B\u6502;\u656A;\u6561;\u655E;\u653C;\u6524;\u651C\u0100ev\u0123\u1942bar\u803B\xa6\u40A6\u0200ceio\u1951\u1956\u195A\u1960r;\uC000\ud835\udcb7mi;\u604Fm\u0100;e\u171A\u171Cl\u0180;bh\u1968\u1969\u196B\u405C;\u69C5sub;\u67C8\u016C\u1974\u197El\u0100;e\u1979\u197A\u6022t\xbb\u197Ap\u0180;Ee\u012F\u1985\u1987;\u6AAE\u0100;q\u06DC\u06DB\u0CE1\u19A7\x00\u19E8\u1A11\u1A15\u1A32\x00\u1A37\u1A50\x00\x00\u1AB4\x00\x00\u1AC1\x00\x00\u1B21\u1B2E\u1B4D\u1B52\x00\u1BFD\x00\u1C0C\u0180cpr\u19AD\u19B2\u19DDute;\u4107\u0300;abcds\u19BF\u19C0\u19C4\u19CA\u19D5\u19D9\u6229nd;\u6A44rcup;\u6A49\u0100au\u19CF\u19D2p;\u6A4Bp;\u6A47ot;\u6A40;\uC000\u2229\uFE00\u0100eo\u19E2\u19E5t;\u6041\xee\u0693\u0200aeiu\u19F0\u19FB\u1A01\u1A05\u01F0\u19F5\x00\u19F8s;\u6A4Don;\u410Ddil\u803B\xe7\u40E7rc;\u4109ps\u0100;s\u1A0C\u1A0D\u6A4Cm;\u6A50ot;\u410B\u0180dmn\u1A1B\u1A20\u1A26il\u80BB\xb8\u01ADptyv;\u69B2t\u8100\xa2;e\u1A2D\u1A2E\u40A2r\xe4\u01B2r;\uC000\ud835\udd20\u0180cei\u1A3D\u1A40\u1A4Dy;\u4447ck\u0100;m\u1A47\u1A48\u6713ark\xbb\u1A48;\u43C7r\u0380;Ecefms\u1A5F\u1A60\u1A62\u1A6B\u1AA4\u1AAA\u1AAE\u65CB;\u69C3\u0180;el\u1A69\u1A6A\u1A6D\u42C6q;\u6257e\u0261\u1A74\x00\x00\u1A88rrow\u0100lr\u1A7C\u1A81eft;\u61BAight;\u61BB\u0280RSacd\u1A92\u1A94\u1A96\u1A9A\u1A9F\xbb\u0F47;\u64C8st;\u629Birc;\u629Aash;\u629Dnint;\u6A10id;\u6AEFcir;\u69C2ubs\u0100;u\u1ABB\u1ABC\u6663it\xbb\u1ABC\u02EC\u1AC7\u1AD4\u1AFA\x00\u1B0Aon\u0100;e\u1ACD\u1ACE\u403A\u0100;q\xc7\xc6\u026D\u1AD9\x00\x00\u1AE2a\u0100;t\u1ADE\u1ADF\u402C;\u4040\u0180;fl\u1AE8\u1AE9\u1AEB\u6201\xee\u1160e\u0100mx\u1AF1\u1AF6ent\xbb\u1AE9e\xf3\u024D\u01E7\u1AFE\x00\u1B07\u0100;d\u12BB\u1B02ot;\u6A6Dn\xf4\u0246\u0180fry\u1B10\u1B14\u1B17;\uC000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1B1Dr;\u6117\u0100ao\u1B25\u1B29rr;\u61B5ss;\u6717\u0100cu\u1B32\u1B37r;\uC000\ud835\udcb8\u0100bp\u1B3C\u1B44\u0100;e\u1B41\u1B42\u6ACF;\u6AD1\u0100;e\u1B49\u1B4A\u6AD0;\u6AD2dot;\u62EF\u0380delprvw\u1B60\u1B6C\u1B77\u1B82\u1BAC\u1BD4\u1BF9arr\u0100lr\u1B68\u1B6A;\u6938;\u6935\u0270\u1B72\x00\x00\u1B75r;\u62DEc;\u62DFarr\u0100;p\u1B7F\u1B80\u61B6;\u693D\u0300;bcdos\u1B8F\u1B90\u1B96\u1BA1\u1BA5\u1BA8\u622Arcap;\u6A48\u0100au\u1B9B\u1B9Ep;\u6A46p;\u6A4Aot;\u628Dr;\u6A45;\uC000\u222A\uFE00\u0200alrv\u1BB5\u1BBF\u1BDE\u1BE3rr\u0100;m\u1BBC\u1BBD\u61B7;\u693Cy\u0180evw\u1BC7\u1BD4\u1BD8q\u0270\u1BCE\x00\x00\u1BD2re\xe3\u1B73u\xe3\u1B75ee;\u62CEedge;\u62CFen\u803B\xa4\u40A4earrow\u0100lr\u1BEE\u1BF3eft\xbb\u1B80ight\xbb\u1BBDe\xe4\u1BDD\u0100ci\u1C01\u1C07onin\xf4\u01F7nt;\u6231lcty;\u632D\u0980AHabcdefhijlorstuwz\u1C38\u1C3B\u1C3F\u1C5D\u1C69\u1C75\u1C8A\u1C9E\u1CAC\u1CB7\u1CFB\u1CFF\u1D0D\u1D7B\u1D91\u1DAB\u1DBB\u1DC6\u1DCDr\xf2\u0381ar;\u6965\u0200glrs\u1C48\u1C4D\u1C52\u1C54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1C5A\u1C5B\u6010\xbb\u090A\u016B\u1C61\u1C67arow;\u690Fa\xe3\u0315\u0100ay\u1C6E\u1C73ron;\u410F;\u4434\u0180;ao\u0332\u1C7C\u1C84\u0100gr\u02BF\u1C81r;\u61CAtseq;\u6A77\u0180glm\u1C91\u1C94\u1C98\u803B\xb0\u40B0ta;\u43B4ptyv;\u69B1\u0100ir\u1CA3\u1CA8sht;\u697F;\uC000\ud835\udd21ar\u0100lr\u1CB3\u1CB5\xbb\u08DC\xbb\u101E\u0280aegsv\u1CC2\u0378\u1CD6\u1CDC\u1CE0m\u0180;os\u0326\u1CCA\u1CD4nd\u0100;s\u0326\u1CD1uit;\u6666amma;\u43DDin;\u62F2\u0180;io\u1CE7\u1CE8\u1CF8\u40F7de\u8100\xf7;o\u1CE7\u1CF0ntimes;\u62C7n\xf8\u1CF7cy;\u4452c\u026F\u1D06\x00\x00\u1D0Arn;\u631Eop;\u630D\u0280lptuw\u1D18\u1D1D\u1D22\u1D49\u1D55lar;\u4024f;\uC000\ud835\udd55\u0280;emps\u030B\u1D2D\u1D37\u1D3D\u1D42q\u0100;d\u0352\u1D33ot;\u6251inus;\u6238lus;\u6214quare;\u62A1blebarwedg\xe5\xfan\u0180adh\u112E\u1D5D\u1D67ownarrow\xf3\u1C83arpoon\u0100lr\u1D72\u1D76ef\xf4\u1CB4igh\xf4\u1CB6\u0162\u1D7F\u1D85karo\xf7\u0F42\u026F\u1D8A\x00\x00\u1D8Ern;\u631Fop;\u630C\u0180cot\u1D98\u1DA3\u1DA6\u0100ry\u1D9D\u1DA1;\uC000\ud835\udcb9;\u4455l;\u69F6rok;\u4111\u0100dr\u1DB0\u1DB4ot;\u62F1i\u0100;f\u1DBA\u1816\u65BF\u0100ah\u1DC0\u1DC3r\xf2\u0429a\xf2\u0FA6angle;\u69A6\u0100ci\u1DD2\u1DD5y;\u445Fgrarr;\u67FF\u0900Dacdefglmnopqrstux\u1E01\u1E09\u1E19\u1E38\u0578\u1E3C\u1E49\u1E61\u1E7E\u1EA5\u1EAF\u1EBD\u1EE1\u1F2A\u1F37\u1F44\u1F4E\u1F5A\u0100Do\u1E06\u1D34o\xf4\u1C89\u0100cs\u1E0E\u1E14ute\u803B\xe9\u40E9ter;\u6A6E\u0200aioy\u1E22\u1E27\u1E31\u1E36ron;\u411Br\u0100;c\u1E2D\u1E2E\u6256\u803B\xea\u40EAlon;\u6255;\u444Dot;\u4117\u0100Dr\u1E41\u1E45ot;\u6252;\uC000\ud835\udd22\u0180;rs\u1E50\u1E51\u1E57\u6A9Aave\u803B\xe8\u40E8\u0100;d\u1E5C\u1E5D\u6A96ot;\u6A98\u0200;ils\u1E6A\u1E6B\u1E72\u1E74\u6A99nters;\u63E7;\u6113\u0100;d\u1E79\u1E7A\u6A95ot;\u6A97\u0180aps\u1E85\u1E89\u1E97cr;\u4113ty\u0180;sv\u1E92\u1E93\u1E95\u6205et\xbb\u1E93p\u01001;\u1E9D\u1EA4\u0133\u1EA1\u1EA3;\u6004;\u6005\u6003\u0100gs\u1EAA\u1EAC;\u414Bp;\u6002\u0100gp\u1EB4\u1EB8on;\u4119f;\uC000\ud835\udd56\u0180als\u1EC4\u1ECE\u1ED2r\u0100;s\u1ECA\u1ECB\u62D5l;\u69E3us;\u6A71i\u0180;lv\u1EDA\u1EDB\u1EDF\u43B5on\xbb\u1EDB;\u43F5\u0200csuv\u1EEA\u1EF3\u1F0B\u1F23\u0100io\u1EEF\u1E31rc\xbb\u1E2E\u0269\u1EF9\x00\x00\u1EFB\xed\u0548ant\u0100gl\u1F02\u1F06tr\xbb\u1E5Dess\xbb\u1E7A\u0180aei\u1F12\u1F16\u1F1Als;\u403Dst;\u625Fv\u0100;D\u0235\u1F20D;\u6A78parsl;\u69E5\u0100Da\u1F2F\u1F33ot;\u6253rr;\u6971\u0180cdi\u1F3E\u1F41\u1EF8r;\u612Fo\xf4\u0352\u0100ah\u1F49\u1F4B;\u43B7\u803B\xf0\u40F0\u0100mr\u1F53\u1F57l\u803B\xeb\u40EBo;\u60AC\u0180cip\u1F61\u1F64\u1F67l;\u4021s\xf4\u056E\u0100eo\u1F6C\u1F74ctatio\xee\u0559nential\xe5\u0579\u09E1\u1F92\x00\u1F9E\x00\u1FA1\u1FA7\x00\x00\u1FC6\u1FCC\x00\u1FD3\x00\u1FE6\u1FEA\u2000\x00\u2008\u205Allingdotse\xf1\u1E44y;\u4444male;\u6640\u0180ilr\u1FAD\u1FB3\u1FC1lig;\u8000\uFB03\u0269\u1FB9\x00\x00\u1FBDg;\u8000\uFB00ig;\u8000\uFB04;\uC000\ud835\udd23lig;\u8000\uFB01lig;\uC000fj\u0180alt\u1FD9\u1FDC\u1FE1t;\u666Dig;\u8000\uFB02ns;\u65B1of;\u4192\u01F0\u1FEE\x00\u1FF3f;\uC000\ud835\udd57\u0100ak\u05BF\u1FF7\u0100;v\u1FFC\u1FFD\u62D4;\u6AD9artint;\u6A0D\u0100ao\u200C\u2055\u0100cs\u2011\u2052\u03B1\u201A\u2030\u2038\u2045\u2048\x00\u2050\u03B2\u2022\u2025\u2027\u202A\u202C\x00\u202E\u803B\xbd\u40BD;\u6153\u803B\xbc\u40BC;\u6155;\u6159;\u615B\u01B3\u2034\x00\u2036;\u6154;\u6156\u02B4\u203E\u2041\x00\x00\u2043\u803B\xbe\u40BE;\u6157;\u615C5;\u6158\u01B6\u204C\x00\u204E;\u615A;\u615D8;\u615El;\u6044wn;\u6322cr;\uC000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209F\u20A5\u20B0\u20B4\u20F0\u20F5\u20FA\u20FF\u2103\u2112\u2138\u0317\u213E\u2152\u219E\u0100;l\u064D\u2087;\u6A8C\u0180cmp\u2090\u2095\u209Dute;\u41F5ma\u0100;d\u209C\u1CDA\u43B3;\u6A86reve;\u411F\u0100iy\u20AA\u20AErc;\u411D;\u4433ot;\u4121\u0200;lqs\u063E\u0642\u20BD\u20C9\u0180;qs\u063E\u064C\u20C4lan\xf4\u0665\u0200;cdl\u0665\u20D2\u20D5\u20E5c;\u6AA9ot\u0100;o\u20DC\u20DD\u6A80\u0100;l\u20E2\u20E3\u6A82;\u6A84\u0100;e\u20EA\u20ED\uC000\u22DB\uFE00s;\u6A94r;\uC000\ud835\udd24\u0100;g\u0673\u061Bmel;\u6137cy;\u4453\u0200;Eaj\u065A\u210C\u210E\u2110;\u6A92;\u6AA5;\u6AA4\u0200Eaes\u211B\u211D\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6A8Arox\xbb\u2124\u0100;q\u212E\u212F\u6A88\u0100;q\u212E\u211Bim;\u62E7pf;\uC000\ud835\udd58\u0100ci\u2143\u2146r;\u610Am\u0180;el\u066B\u214E\u2150;\u6A8E;\u6A90\u8300>;cdlqr\u05EE\u2160\u216A\u216E\u2173\u2179\u0100ci\u2165\u2167;\u6AA7r;\u6A7Aot;\u62D7Par;\u6995uest;\u6A7C\u0280adels\u2184\u216A\u2190\u0656\u219B\u01F0\u2189\x00\u218Epro\xf8\u209Er;\u6978q\u0100lq\u063F\u2196les\xf3\u2088i\xed\u066B\u0100en\u21A3\u21ADrtneqq;\uC000\u2269\uFE00\xc5\u21AA\u0500Aabcefkosy\u21C4\u21C7\u21F1\u21F5\u21FA\u2218\u221D\u222F\u2268\u227Dr\xf2\u03A0\u0200ilmr\u21D0\u21D4\u21D7\u21DBrs\xf0\u1484f\xbb\u2024il\xf4\u06A9\u0100dr\u21E0\u21E4cy;\u444A\u0180;cw\u08F4\u21EB\u21EFir;\u6948;\u61ADar;\u610Firc;\u4125\u0180alr\u2201\u220E\u2213rts\u0100;u\u2209\u220A\u6665it\xbb\u220Alip;\u6026con;\u62B9r;\uC000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223A\u223E\u2243\u225E\u2263rr;\u61FFtht;\u623Bk\u0100lr\u2249\u2253eftarrow;\u61A9ightarrow;\u61AAf;\uC000\ud835\udd59bar;\u6015\u0180clt\u226F\u2274\u2278r;\uC000\ud835\udcbdas\xe8\u21F4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1C5B\u0AE1\u22A3\x00\u22AA\x00\u22B8\u22C5\u22CE\x00\u22D5\u22F3\x00\x00\u22F8\u2322\u2367\u2362\u237F\x00\u2386\u23AA\u23B4cute\u803B\xed\u40ED\u0180;iy\u0771\u22B0\u22B5rc\u803B\xee\u40EE;\u4438\u0100cx\u22BC\u22BFy;\u4435cl\u803B\xa1\u40A1\u0100fr\u039F\u22C9;\uC000\ud835\udd26rave\u803B\xec\u40EC\u0200;ino\u073E\u22DD\u22E9\u22EE\u0100in\u22E2\u22E6nt;\u6A0Ct;\u622Dfin;\u69DCta;\u6129lig;\u4133\u0180aop\u22FE\u231A\u231D\u0180cgt\u2305\u2308\u2317r;\u412B\u0180elp\u071F\u230F\u2313in\xe5\u078Ear\xf4\u0720h;\u4131f;\u62B7ed;\u41B5\u0280;cfot\u04F4\u232C\u2331\u233D\u2341are;\u6105in\u0100;t\u2338\u2339\u621Eie;\u69DDdo\xf4\u2319\u0280;celp\u0757\u234C\u2350\u235B\u2361al;\u62BA\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234Darhk;\u6A17rod;\u6A3C\u0200cgpt\u236F\u2372\u2376\u237By;\u4451on;\u412Ff;\uC000\ud835\udd5aa;\u43B9uest\u803B\xbf\u40BF\u0100ci\u238A\u238Fr;\uC000\ud835\udcben\u0280;Edsv\u04F4\u239B\u239D\u23A1\u04F3;\u62F9ot;\u62F5\u0100;v\u23A6\u23A7\u62F4;\u62F3\u0100;i\u0777\u23AElde;\u4129\u01EB\u23B8\x00\u23BCcy;\u4456l\u803B\xef\u40EF\u0300cfmosu\u23CC\u23D7\u23DC\u23E1\u23E7\u23F5\u0100iy\u23D1\u23D5rc;\u4135;\u4439r;\uC000\ud835\udd27ath;\u4237pf;\uC000\ud835\udd5b\u01E3\u23EC\x00\u23F1r;\uC000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240B\u2416\u2422\u2427\u242D\u2431\u2435\u243Bppa\u0100;v\u2413\u2414\u43BA;\u43F0\u0100ey\u241B\u2420dil;\u4137;\u443Ar;\uC000\ud835\udd28reen;\u4138cy;\u4445cy;\u445Cpf;\uC000\ud835\udd5ccr;\uC000\ud835\udcc0\u0B80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248D\u2491\u250E\u253D\u255A\u2580\u264E\u265E\u2665\u2679\u267D\u269A\u26B2\u26D8\u275D\u2768\u278B\u27C0\u2801\u2812\u0180art\u2477\u247A\u247Cr\xf2\u09C6\xf2\u0395ail;\u691Barr;\u690E\u0100;g\u0994\u248B;\u6A8Bar;\u6962\u0963\u24A5\x00\u24AA\x00\u24B1\x00\x00\x00\x00\x00\u24B5\u24BA\x00\u24C6\u24C8\u24CD\x00\u24F9ute;\u413Amptyv;\u69B4ra\xee\u084Cbda;\u43BBg\u0180;dl\u088E\u24C1\u24C3;\u6991\xe5\u088E;\u6A85uo\u803B\xab\u40ABr\u0400;bfhlpst\u0899\u24DE\u24E6\u24E9\u24EB\u24EE\u24F1\u24F5\u0100;f\u089D\u24E3s;\u691Fs;\u691D\xeb\u2252p;\u61ABl;\u6939im;\u6973l;\u61A2\u0180;ae\u24FF\u2500\u2504\u6AABil;\u6919\u0100;s\u2509\u250A\u6AAD;\uC000\u2AAD\uFE00\u0180abr\u2515\u2519\u251Drr;\u690Crk;\u6772\u0100ak\u2522\u252Cc\u0100ek\u2528\u252A;\u407B;\u405B\u0100es\u2531\u2533;\u698Bl\u0100du\u2539\u253B;\u698F;\u698D\u0200aeuy\u2546\u254B\u2556\u2558ron;\u413E\u0100di\u2550\u2554il;\u413C\xec\u08B0\xe2\u2529;\u443B\u0200cqrs\u2563\u2566\u256D\u257Da;\u6936uo\u0100;r\u0E19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694Bh;\u61B2\u0280;fgqs\u258B\u258C\u0989\u25F3\u25FF\u6264t\u0280ahlrt\u2598\u25A4\u25B7\u25C2\u25E8rrow\u0100;t\u0899\u25A1a\xe9\u24F6arpoon\u0100du\u25AF\u25B4own\xbb\u045Ap\xbb\u0966eftarrows;\u61C7ight\u0180ahs\u25CD\u25D6\u25DErrow\u0100;s\u08F4\u08A7arpoon\xf3\u0F98quigarro\xf7\u21F0hreetimes;\u62CB\u0180;qs\u258B\u0993\u25FAlan\xf4\u09AC\u0280;cdgs\u09AC\u260A\u260D\u261D\u2628c;\u6AA8ot\u0100;o\u2614\u2615\u6A7F\u0100;r\u261A\u261B\u6A81;\u6A83\u0100;e\u2622\u2625\uC000\u22DA\uFE00s;\u6A93\u0280adegs\u2633\u2639\u263D\u2649\u264Bppro\xf8\u24C6ot;\u62D6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248C\xf4\u099Bi\xed\u09B2\u0180ilr\u2655\u08E1\u265Asht;\u697C;\uC000\ud835\udd29\u0100;E\u099C\u2663;\u6A91\u0161\u2669\u2676r\u0100du\u25B2\u266E\u0100;l\u0965\u2673;\u696Alk;\u6584cy;\u4459\u0280;acht\u0A48\u2688\u268B\u2691\u2696r\xf2\u25C1orne\xf2\u1D08ard;\u696Bri;\u65FA\u0100io\u269F\u26A4dot;\u4140ust\u0100;a\u26AC\u26AD\u63B0che\xbb\u26AD\u0200Eaes\u26BB\u26BD\u26C9\u26D4;\u6268p\u0100;p\u26C3\u26C4\u6A89rox\xbb\u26C4\u0100;q\u26CE\u26CF\u6A87\u0100;q\u26CE\u26BBim;\u62E6\u0400abnoptwz\u26E9\u26F4\u26F7\u271A\u272F\u2741\u2747\u2750\u0100nr\u26EE\u26F1g;\u67ECr;\u61FDr\xeb\u08C1g\u0180lmr\u26FF\u270D\u2714eft\u0100ar\u09E6\u2707ight\xe1\u09F2apsto;\u67FCight\xe1\u09FDparrow\u0100lr\u2725\u2729ef\xf4\u24EDight;\u61AC\u0180afl\u2736\u2739\u273Dr;\u6985;\uC000\ud835\udd5dus;\u6A2Dimes;\u6A34\u0161\u274B\u274Fst;\u6217\xe1\u134E\u0180;ef\u2757\u2758\u1800\u65CAnge\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277C\u2785\u2787r\xf2\u08A8orne\xf2\u1D8Car\u0100;d\u0F98\u2783;\u696D;\u600Eri;\u62BF\u0300achiqt\u2798\u279D\u0A40\u27A2\u27AE\u27BBquo;\u6039r;\uC000\ud835\udcc1m\u0180;eg\u09B2\u27AA\u27AC;\u6A8D;\u6A8F\u0100bu\u252A\u27B3o\u0100;r\u0E1F\u27B9;\u601Arok;\u4142\u8400<;cdhilqr\u082B\u27D2\u2639\u27DC\u27E0\u27E5\u27EA\u27F0\u0100ci\u27D7\u27D9;\u6AA6r;\u6A79re\xe5\u25F2mes;\u62C9arr;\u6976uest;\u6A7B\u0100Pi\u27F5\u27F9ar;\u6996\u0180;ef\u2800\u092D\u181B\u65C3r\u0100du\u2807\u280Dshar;\u694Ahar;\u6966\u0100en\u2817\u2821rtneqq;\uC000\u2268\uFE00\xc5\u281E\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288E\u2893\u28A0\u28A5\u28A8\u28DA\u28E2\u28E4\u0A83\u28F3\u2902Dot;\u623A\u0200clpr\u284E\u2852\u2863\u287Dr\u803B\xaf\u40AF\u0100et\u2857\u2859;\u6642\u0100;e\u285E\u285F\u6720se\xbb\u285F\u0100;s\u103B\u2868to\u0200;dlu\u103B\u2873\u2877\u287Bow\xee\u048Cef\xf4\u090F\xf0\u13D1ker;\u65AE\u0100oy\u2887\u288Cmma;\u6A29;\u443Cash;\u6014asuredangle\xbb\u1626r;\uC000\ud835\udd2ao;\u6127\u0180cdn\u28AF\u28B4\u28C9ro\u803B\xb5\u40B5\u0200;acd\u1464\u28BD\u28C0\u28C4s\xf4\u16A7ir;\u6AF0ot\u80BB\xb7\u01B5us\u0180;bd\u28D2\u1903\u28D3\u6212\u0100;u\u1D3C\u28D8;\u6A2A\u0163\u28DE\u28E1p;\u6ADB\xf2\u2212\xf0\u0A81\u0100dp\u28E9\u28EEels;\u62A7f;\uC000\ud835\udd5e\u0100ct\u28F8\u28FDr;\uC000\ud835\udcc2pos\xbb\u159D\u0180;lm\u2909\u290A\u290D\u43BCtimap;\u62B8\u0C00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297E\u2989\u2998\u29DA\u29E9\u2A15\u2A1A\u2A58\u2A5D\u2A83\u2A95\u2AA4\u2AA8\u2B04\u2B07\u2B44\u2B7F\u2BAE\u2C34\u2C67\u2C7C\u2CE9\u0100gt\u2947\u294B;\uC000\u22D9\u0338\u0100;v\u2950\u0BCF\uC000\u226B\u20D2\u0180elt\u295A\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61CDightarrow;\u61CE;\uC000\u22D8\u0338\u0100;v\u297B\u0C47\uC000\u226A\u20D2ightarrow;\u61CF\u0100Dd\u298E\u2993ash;\u62AFash;\u62AE\u0280bcnpt\u29A3\u29A7\u29AC\u29B1\u29CCla\xbb\u02DEute;\u4144g;\uC000\u2220\u20D2\u0280;Eiop\u0D84\u29BC\u29C0\u29C5\u29C8;\uC000\u2A70\u0338d;\uC000\u224B\u0338s;\u4149ro\xf8\u0D84ur\u0100;a\u29D3\u29D4\u666El\u0100;s\u29D3\u0B38\u01F3\u29DF\x00\u29E3p\u80BB\xa0\u0B37mp\u0100;e\u0BF9\u0C00\u0280aeouy\u29F4\u29FE\u2A03\u2A10\u2A13\u01F0\u29F9\x00\u29FB;\u6A43on;\u4148dil;\u4146ng\u0100;d\u0D7E\u2A0Aot;\uC000\u2A6D\u0338p;\u6A42;\u443Dash;\u6013\u0380;Aadqsx\u0B92\u2A29\u2A2D\u2A3B\u2A41\u2A45\u2A50rr;\u61D7r\u0100hr\u2A33\u2A36k;\u6924\u0100;o\u13F2\u13F0ot;\uC000\u2250\u0338ui\xf6\u0B63\u0100ei\u2A4A\u2A4Ear;\u6928\xed\u0B98ist\u0100;s\u0BA0\u0B9Fr;\uC000\ud835\udd2b\u0200Eest\u0BC5\u2A66\u2A79\u2A7C\u0180;qs\u0BBC\u2A6D\u0BE1\u0180;qs\u0BBC\u0BC5\u2A74lan\xf4\u0BE2i\xed\u0BEA\u0100;r\u0BB6\u2A81\xbb\u0BB7\u0180Aap\u2A8A\u2A8D\u2A91r\xf2\u2971rr;\u61AEar;\u6AF2\u0180;sv\u0F8D\u2A9C\u0F8C\u0100;d\u2AA1\u2AA2\u62FC;\u62FAcy;\u445A\u0380AEadest\u2AB7\u2ABA\u2ABE\u2AC2\u2AC5\u2AF6\u2AF9r\xf2\u2966;\uC000\u2266\u0338rr;\u619Ar;\u6025\u0200;fqs\u0C3B\u2ACE\u2AE3\u2AEFt\u0100ar\u2AD4\u2AD9rro\xf7\u2AC1ightarro\xf7\u2A90\u0180;qs\u0C3B\u2ABA\u2AEAlan\xf4\u0C55\u0100;s\u0C55\u2AF4\xbb\u0C36i\xed\u0C5D\u0100;r\u0C35\u2AFEi\u0100;e\u0C1A\u0C25i\xe4\u0D90\u0100pt\u2B0C\u2B11f;\uC000\ud835\udd5f\u8180\xac;in\u2B19\u2B1A\u2B36\u40ACn\u0200;Edv\u0B89\u2B24\u2B28\u2B2E;\uC000\u22F9\u0338ot;\uC000\u22F5\u0338\u01E1\u0B89\u2B33\u2B35;\u62F7;\u62F6i\u0100;v\u0CB8\u2B3C\u01E1\u0CB8\u2B41\u2B43;\u62FE;\u62FD\u0180aor\u2B4B\u2B63\u2B69r\u0200;ast\u0B7B\u2B55\u2B5A\u2B5Flle\xec\u0B7Bl;\uC000\u2AFD\u20E5;\uC000\u2202\u0338lint;\u6A14\u0180;ce\u0C92\u2B70\u2B73u\xe5\u0CA5\u0100;c\u0C98\u2B78\u0100;e\u0C92\u2B7D\xf1\u0C98\u0200Aait\u2B88\u2B8B\u2B9D\u2BA7r\xf2\u2988rr\u0180;cw\u2B94\u2B95\u2B99\u619B;\uC000\u2933\u0338;\uC000\u219D\u0338ghtarrow\xbb\u2B95ri\u0100;e\u0CCB\u0CD6\u0380chimpqu\u2BBD\u2BCD\u2BD9\u2B04\u0B78\u2BE4\u2BEF\u0200;cer\u0D32\u2BC6\u0D37\u2BC9u\xe5\u0D45;\uC000\ud835\udcc3ort\u026D\u2B05\x00\x00\u2BD6ar\xe1\u2B56m\u0100;e\u0D6E\u2BDF\u0100;q\u0D74\u0D73su\u0100bp\u2BEB\u2BED\xe5\u0CF8\xe5\u0D0B\u0180bcp\u2BF6\u2C11\u2C19\u0200;Ees\u2BFF\u2C00\u0D22\u2C04\u6284;\uC000\u2AC5\u0338et\u0100;e\u0D1B\u2C0Bq\u0100;q\u0D23\u2C00c\u0100;e\u0D32\u2C17\xf1\u0D38\u0200;Ees\u2C22\u2C23\u0D5F\u2C27\u6285;\uC000\u2AC6\u0338et\u0100;e\u0D58\u2C2Eq\u0100;q\u0D60\u2C23\u0200gilr\u2C3D\u2C3F\u2C45\u2C47\xec\u0BD7lde\u803B\xf1\u40F1\xe7\u0C43iangle\u0100lr\u2C52\u2C5Ceft\u0100;e\u0C1A\u2C5A\xf1\u0C26ight\u0100;e\u0CCB\u2C65\xf1\u0CD7\u0100;m\u2C6C\u2C6D\u43BD\u0180;es\u2C74\u2C75\u2C79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2C8F\u2C94\u2C99\u2C9E\u2CA3\u2CB0\u2CB6\u2CD3\u2CE3ash;\u62ADarr;\u6904p;\uC000\u224D\u20D2ash;\u62AC\u0100et\u2CA8\u2CAC;\uC000\u2265\u20D2;\uC000>\u20D2nfin;\u69DE\u0180Aet\u2CBD\u2CC1\u2CC5rr;\u6902;\uC000\u2264\u20D2\u0100;r\u2CCA\u2CCD\uC000<\u20D2ie;\uC000\u22B4\u20D2\u0100At\u2CD8\u2CDCrr;\u6903rie;\uC000\u22B5\u20D2im;\uC000\u223C\u20D2\u0180Aan\u2CF0\u2CF4\u2D02rr;\u61D6r\u0100hr\u2CFA\u2CFDk;\u6923\u0100;o\u13E7\u13E5ear;\u6927\u1253\u1A95\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u2D2D\x00\u2D38\u2D48\u2D60\u2D65\u2D72\u2D84\u1B07\x00\x00\u2D8D\u2DAB\x00\u2DC8\u2DCE\x00\u2DDC\u2E19\u2E2B\u2E3E\u2E43\u0100cs\u2D31\u1A97ute\u803B\xf3\u40F3\u0100iy\u2D3C\u2D45r\u0100;c\u1A9E\u2D42\u803B\xf4\u40F4;\u443E\u0280abios\u1AA0\u2D52\u2D57\u01C8\u2D5Alac;\u4151v;\u6A38old;\u69BClig;\u4153\u0100cr\u2D69\u2D6Dir;\u69BF;\uC000\ud835\udd2c\u036F\u2D79\x00\x00\u2D7C\x00\u2D82n;\u42DBave\u803B\xf2\u40F2;\u69C1\u0100bm\u2D88\u0DF4ar;\u69B5\u0200acit\u2D95\u2D98\u2DA5\u2DA8r\xf2\u1A80\u0100ir\u2D9D\u2DA0r;\u69BEoss;\u69BBn\xe5\u0E52;\u69C0\u0180aei\u2DB1\u2DB5\u2DB9cr;\u414Dga;\u43C9\u0180cdn\u2DC0\u2DC5\u01CDron;\u43BF;\u69B6pf;\uC000\ud835\udd60\u0180ael\u2DD4\u2DD7\u01D2r;\u69B7rp;\u69B9\u0380;adiosv\u2DEA\u2DEB\u2DEE\u2E08\u2E0D\u2E10\u2E16\u6228r\xf2\u1A86\u0200;efm\u2DF7\u2DF8\u2E02\u2E05\u6A5Dr\u0100;o\u2DFE\u2DFF\u6134f\xbb\u2DFF\u803B\xaa\u40AA\u803B\xba\u40BAgof;\u62B6r;\u6A56lope;\u6A57;\u6A5B\u0180clo\u2E1F\u2E21\u2E27\xf2\u2E01ash\u803B\xf8\u40F8l;\u6298i\u016C\u2E2F\u2E34de\u803B\xf5\u40F5es\u0100;a\u01DB\u2E3As;\u6A36ml\u803B\xf6\u40F6bar;\u633D\u0AE1\u2E5E\x00\u2E7D\x00\u2E80\u2E9D\x00\u2EA2\u2EB9\x00\x00\u2ECB\u0E9C\x00\u2F13\x00\x00\u2F2B\u2FBC\x00\u2FC8r\u0200;ast\u0403\u2E67\u2E72\u0E85\u8100\xb6;l\u2E6D\u2E6E\u40B6le\xec\u0403\u0269\u2E78\x00\x00\u2E7Bm;\u6AF3;\u6AFDy;\u443Fr\u0280cimpt\u2E8B\u2E8F\u2E93\u1865\u2E97nt;\u4025od;\u402Eil;\u6030enk;\u6031r;\uC000\ud835\udd2d\u0180imo\u2EA8\u2EB0\u2EB4\u0100;v\u2EAD\u2EAE\u43C6;\u43D5ma\xf4\u0A76ne;\u660E\u0180;tv\u2EBF\u2EC0\u2EC8\u43C0chfork\xbb\u1FFD;\u43D6\u0100au\u2ECF\u2EDFn\u0100ck\u2ED5\u2EDDk\u0100;h\u21F4\u2EDB;\u610E\xf6\u21F4s\u0480;abcdemst\u2EF3\u2EF4\u1908\u2EF9\u2EFD\u2F04\u2F06\u2F0A\u2F0E\u402Bcir;\u6A23ir;\u6A22\u0100ou\u1D40\u2F02;\u6A25;\u6A72n\u80BB\xb1\u0E9Dim;\u6A26wo;\u6A27\u0180ipu\u2F19\u2F20\u2F25ntint;\u6A15f;\uC000\ud835\udd61nd\u803B\xa3\u40A3\u0500;Eaceinosu\u0EC8\u2F3F\u2F41\u2F44\u2F47\u2F81\u2F89\u2F92\u2F7E\u2FB6;\u6AB3p;\u6AB7u\xe5\u0ED9\u0100;c\u0ECE\u2F4C\u0300;acens\u0EC8\u2F59\u2F5F\u2F66\u2F68\u2F7Eppro\xf8\u2F43urlye\xf1\u0ED9\xf1\u0ECE\u0180aes\u2F6F\u2F76\u2F7Approx;\u6AB9qq;\u6AB5im;\u62E8i\xed\u0EDFme\u0100;s\u2F88\u0EAE\u6032\u0180Eas\u2F78\u2F90\u2F7A\xf0\u2F75\u0180dfp\u0EEC\u2F99\u2FAF\u0180als\u2FA0\u2FA5\u2FAAlar;\u632Eine;\u6312urf;\u6313\u0100;t\u0EFB\u2FB4\xef\u0EFBrel;\u62B0\u0100ci\u2FC0\u2FC5r;\uC000\ud835\udcc5;\u43C8ncsp;\u6008\u0300fiopsu\u2FDA\u22E2\u2FDF\u2FE5\u2FEB\u2FF1r;\uC000\ud835\udd2epf;\uC000\ud835\udd62rime;\u6057cr;\uC000\ud835\udcc6\u0180aeo\u2FF8\u3009\u3013t\u0100ei\u2FFE\u3005rnion\xf3\u06B0nt;\u6A16st\u0100;e\u3010\u3011\u403F\xf1\u1F19\xf4\u0F14\u0A80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30E0\u310E\u312B\u3147\u3162\u3172\u318E\u3206\u3215\u3224\u3229\u3258\u326E\u3272\u3290\u32B0\u32B7\u0180art\u3047\u304A\u304Cr\xf2\u10B3\xf2\u03DDail;\u691Car\xf2\u1C65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307F\u308F\u3094\u30CC\u0100eu\u306D\u3071;\uC000\u223D\u0331te;\u4155i\xe3\u116Emptyv;\u69B3g\u0200;del\u0FD1\u3089\u308B\u308D;\u6992;\u69A5\xe5\u0FD1uo\u803B\xbb\u40BBr\u0580;abcfhlpstw\u0FDC\u30AC\u30AF\u30B7\u30B9\u30BC\u30BE\u30C0\u30C3\u30C7\u30CAp;\u6975\u0100;f\u0FE0\u30B4s;\u6920;\u6933s;\u691E\xeb\u225D\xf0\u272El;\u6945im;\u6974l;\u61A3;\u619D\u0100ai\u30D1\u30D5il;\u691Ao\u0100;n\u30DB\u30DC\u6236al\xf3\u0F1E\u0180abr\u30E7\u30EA\u30EEr\xf2\u17E5rk;\u6773\u0100ak\u30F3\u30FDc\u0100ek\u30F9\u30FB;\u407D;\u405D\u0100es\u3102\u3104;\u698Cl\u0100du\u310A\u310C;\u698E;\u6990\u0200aeuy\u3117\u311C\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0FF2\xe2\u30FA;\u4440\u0200clqs\u3134\u3137\u313D\u3144a;\u6937dhar;\u6969uo\u0100;r\u020E\u020Dh;\u61B3\u0180acg\u314E\u315F\u0F44l\u0200;ips\u0F78\u3158\u315B\u109Cn\xe5\u10BBar\xf4\u0FA9t;\u65AD\u0180ilr\u3169\u1023\u316Esht;\u697D;\uC000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317D\u317F\xbb\u047B\u0100;l\u1091\u3184;\u696C\u0100;v\u318B\u318C\u43C1;\u43F1\u0180gns\u3195\u31F9\u31FCht\u0300ahlrst\u31A4\u31B0\u31C2\u31D8\u31E4\u31EErrow\u0100;t\u0FDC\u31ADa\xe9\u30C8arpoon\u0100du\u31BB\u31BFow\xee\u317Ep\xbb\u1092eft\u0100ah\u31CA\u31D0rrow\xf3\u0FEAarpoon\xf3\u0551ightarrows;\u61C9quigarro\xf7\u30CBhreetimes;\u62CCg;\u42DAingdotse\xf1\u1F32\u0180ahm\u320D\u3210\u3213r\xf2\u0FEAa\xf2\u0551;\u600Foust\u0100;a\u321E\u321F\u63B1che\xbb\u321Fmid;\u6AEE\u0200abpt\u3232\u323D\u3240\u3252\u0100nr\u3237\u323Ag;\u67EDr;\u61FEr\xeb\u1003\u0180afl\u3247\u324A\u324Er;\u6986;\uC000\ud835\udd63us;\u6A2Eimes;\u6A35\u0100ap\u325D\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6A12ar\xf2\u31E3\u0200achq\u327B\u3280\u10BC\u3285quo;\u603Ar;\uC000\ud835\udcc7\u0100bu\u30FB\u328Ao\u0100;r\u0214\u0213\u0180hir\u3297\u329B\u32A0re\xe5\u31F8mes;\u62CAi\u0200;efl\u32AA\u1059\u1821\u32AB\u65B9tri;\u69CEluhar;\u6968;\u611E\u0D61\u32D5\u32DB\u32DF\u332C\u3338\u3371\x00\u337A\u33A4\x00\x00\u33EC\u33F0\x00\u3428\u3448\u345A\u34AD\u34B1\u34CA\u34F1\x00\u3616\x00\x00\u3633cute;\u415Bqu\xef\u27BA\u0500;Eaceinpsy\u11ED\u32F3\u32F5\u32FF\u3302\u330B\u330F\u331F\u3326\u3329;\u6AB4\u01F0\u32FA\x00\u32FC;\u6AB8on;\u4161u\xe5\u11FE\u0100;d\u11F3\u3307il;\u415Frc;\u415D\u0180Eas\u3316\u3318\u331B;\u6AB6p;\u6ABAim;\u62E9olint;\u6A13i\xed\u1204;\u4441ot\u0180;be\u3334\u1D47\u3335\u62C5;\u6A66\u0380Aacmstx\u3346\u334A\u3357\u335B\u335E\u3363\u336Drr;\u61D8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0A36\u0A34t\u803B\xa7\u40A7i;\u403Bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uC000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33A0rp;\u666F\u0100hy\u338B\u338Fcy;\u4449;\u4448rt\u026D\u3399\x00\x00\u339Ci\xe4\u1464ara\xec\u2E6F\u803B\xad\u40AD\u0100gm\u33A8\u33B4ma\u0180;fv\u33B1\u33B2\u33B2\u43C3;\u43C2\u0400;deglnpr\u12AB\u33C5\u33C9\u33CE\u33D6\u33DE\u33E1\u33E6ot;\u6A6A\u0100;q\u12B1\u12B0\u0100;E\u33D3\u33D4\u6A9E;\u6AA0\u0100;E\u33DB\u33DC\u6A9D;\u6A9Fe;\u6246lus;\u6A24arr;\u6972ar\xf2\u113D\u0200aeit\u33F8\u3408\u340F\u3417\u0100ls\u33FD\u3404lsetm\xe9\u336Ahp;\u6A33parsl;\u69E4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341C\u341D\u6AAA\u0100;s\u3422\u3423\u6AAC;\uC000\u2AAC\uFE00\u0180flp\u342E\u3433\u3442tcy;\u444C\u0100;b\u3438\u3439\u402F\u0100;a\u343E\u343F\u69C4r;\u633Ff;\uC000\ud835\udd64a\u0100dr\u344D\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349F\u0100au\u3465\u346Fp\u0100;s\u1188\u346B;\uC000\u2293\uFE00p\u0100;s\u11B4\u3475;\uC000\u2294\uFE00u\u0100bp\u347F\u348F\u0180;es\u1197\u119C\u3486et\u0100;e\u1197\u348D\xf1\u119D\u0180;es\u11A8\u11AD\u3496et\u0100;e\u11A8\u349D\xf1\u11AE\u0180;af\u117B\u34A6\u05B0r\u0165\u34AB\u05B1\xbb\u117Car\xf2\u1148\u0200cemt\u34B9\u34BE\u34C2\u34C5r;\uC000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11BE\u0100ar\u34CE\u34D5r\u0100;f\u34D4\u17BF\u6606\u0100an\u34DA\u34EDight\u0100ep\u34E3\u34EApsilo\xee\u1EE0h\xe9\u2EAFs\xbb\u2852\u0280bcmnp\u34FB\u355E\u1209\u358B\u358E\u0480;Edemnprs\u350E\u350F\u3511\u3515\u351E\u3523\u352C\u3531\u3536\u6282;\u6AC5ot;\u6ABD\u0100;d\u11DA\u351Aot;\u6AC3ult;\u6AC1\u0100Ee\u3528\u352A;\u6ACB;\u628Alus;\u6ABFarr;\u6979\u0180eiu\u353D\u3552\u3555t\u0180;en\u350E\u3545\u354Bq\u0100;q\u11DA\u350Feq\u0100;q\u352B\u3528m;\u6AC7\u0100bp\u355A\u355C;\u6AD5;\u6AD3c\u0300;acens\u11ED\u356C\u3572\u3579\u357B\u3326ppro\xf8\u32FAurlye\xf1\u11FE\xf1\u11F3\u0180aes\u3582\u3588\u331Bppro\xf8\u331Aq\xf1\u3317g;\u666A\u0680123;Edehlmnps\u35A9\u35AC\u35AF\u121C\u35B2\u35B4\u35C0\u35C9\u35D5\u35DA\u35DF\u35E8\u35ED\u803B\xb9\u40B9\u803B\xb2\u40B2\u803B\xb3\u40B3;\u6AC6\u0100os\u35B9\u35BCt;\u6ABEub;\u6AD8\u0100;d\u1222\u35C5ot;\u6AC4s\u0100ou\u35CF\u35D2l;\u67C9b;\u6AD7arr;\u697Bult;\u6AC2\u0100Ee\u35E4\u35E6;\u6ACC;\u628Blus;\u6AC0\u0180eiu\u35F4\u3609\u360Ct\u0180;en\u121C\u35FC\u3602q\u0100;q\u1222\u35B2eq\u0100;q\u35E7\u35E4m;\u6AC8\u0100bp\u3611\u3613;\u6AD4;\u6AD6\u0180Aan\u361C\u3620\u362Drr;\u61D9r\u0100hr\u3626\u3628\xeb\u222E\u0100;o\u0A2B\u0A29war;\u692Alig\u803B\xdf\u40DF\u0BE1\u3651\u365D\u3660\u12CE\u3673\u3679\x00\u367E\u36C2\x00\x00\x00\x00\x00\u36DB\u3703\x00\u3709\u376C\x00\x00\x00\u3787\u0272\u3656\x00\x00\u365Bget;\u6316;\u43C4r\xeb\u0E5F\u0180aey\u3666\u366B\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uC000\ud835\udd31\u0200eiko\u3686\u369D\u36B5\u36BC\u01F2\u368B\x00\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369B\u43B8ym;\u43D1\u0100cn\u36A2\u36B2k\u0100as\u36A8\u36AEppro\xf8\u12C1im\xbb\u12ACs\xf0\u129E\u0100as\u36BA\u36AE\xf0\u12C1rn\u803B\xfe\u40FE\u01EC\u031F\u36C6\u22E7es\u8180\xd7;bd\u36CF\u36D0\u36D8\u40D7\u0100;a\u190F\u36D5r;\u6A31;\u6A30\u0180eps\u36E1\u36E3\u3700\xe1\u2A4D\u0200;bcf\u0486\u36EC\u36F0\u36F4ot;\u6336ir;\u6AF1\u0100;o\u36F9\u36FC\uC000\ud835\udd65rk;\u6ADA\xe1\u3362rime;\u6034\u0180aip\u370F\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374D\u3740\u3751\u3757\u375C\u375Fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65B5own\xbb\u1DBBeft\u0100;e\u2800\u373E\xf1\u092E;\u625Cight\u0100;e\u32AA\u374B\xf1\u105Aot;\u65ECinus;\u6A3Alus;\u6A39b;\u69CDime;\u6A3Bezium;\u63E2\u0180cht\u3772\u377D\u3781\u0100ry\u3777\u377B;\uC000\ud835\udcc9;\u4446cy;\u445Brok;\u4167\u0100io\u378B\u378Ex\xf4\u1777head\u0100lr\u3797\u37A0eftarro\xf7\u084Fightarrow\xbb\u0F5D\u0900AHabcdfghlmoprstuw\u37D0\u37D3\u37D7\u37E4\u37F0\u37FC\u380E\u381C\u3823\u3834\u3851\u385D\u386B\u38A9\u38CC\u38D2\u38EA\u38F6r\xf2\u03EDar;\u6963\u0100cr\u37DC\u37E2ute\u803B\xfa\u40FA\xf2\u1150r\u01E3\u37EA\x00\u37EDy;\u445Eve;\u416D\u0100iy\u37F5\u37FArc\u803B\xfb\u40FB;\u4443\u0180abh\u3803\u3806\u380Br\xf2\u13ADlac;\u4171a\xf2\u13C3\u0100ir\u3813\u3818sht;\u697E;\uC000\ud835\udd32rave\u803B\xf9\u40F9\u0161\u3827\u3831r\u0100lr\u382C\u382E\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384D\u026F\u383F\x00\x00\u384Arn\u0100;e\u3845\u3846\u631Cr\xbb\u3846op;\u630Fri;\u65F8\u0100al\u3856\u385Acr;\u416B\u80BB\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uC000\ud835\udd66\u0300adhlsu\u114B\u3878\u387D\u1372\u3891\u38A0own\xe1\u13B3arpoon\u0100lr\u3888\u388Cef\xf4\u382Digh\xf4\u382Fi\u0180;hl\u3899\u389A\u389C\u43C5\xbb\u13FAon\xbb\u389Aparrows;\u61C8\u0180cit\u38B0\u38C4\u38C8\u026F\u38B6\x00\x00\u38C1rn\u0100;e\u38BC\u38BD\u631Dr\xbb\u38BDop;\u630Eng;\u416Fri;\u65F9cr;\uC000\ud835\udcca\u0180dir\u38D9\u38DD\u38E2ot;\u62F0lde;\u4169i\u0100;f\u3730\u38E8\xbb\u1813\u0100am\u38EF\u38F2r\xf2\u38A8l\u803B\xfc\u40FCangle;\u69A7\u0780ABDacdeflnoprsz\u391C\u391F\u3929\u392D\u39B5\u39B8\u39BD\u39DF\u39E4\u39E8\u39F3\u39F9\u39FD\u3A01\u3A20r\xf2\u03F7ar\u0100;v\u3926\u3927\u6AE8;\u6AE9as\xe8\u03E1\u0100nr\u3932\u3937grt;\u699C\u0380eknprst\u34E3\u3946\u394B\u3952\u395D\u3964\u3996app\xe1\u2415othin\xe7\u1E96\u0180hir\u34EB\u2EC8\u3959op\xf4\u2FB5\u0100;h\u13B7\u3962\xef\u318D\u0100iu\u3969\u396Dgm\xe1\u33B3\u0100bp\u3972\u3984setneq\u0100;q\u397D\u3980\uC000\u228A\uFE00;\uC000\u2ACB\uFE00setneq\u0100;q\u398F\u3992\uC000\u228B\uFE00;\uC000\u2ACC\uFE00\u0100hr\u399B\u399Fet\xe1\u369Ciangle\u0100lr\u39AA\u39AFeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39C4\u39D2\u39D7\u0180;be\u2DEA\u39CB\u39CFar;\u62BBq;\u625Alip;\u62EE\u0100bt\u39DC\u1468a\xf2\u1469r;\uC000\ud835\udd33tr\xe9\u39AEsu\u0100bp\u39EF\u39F1\xbb\u0D1C\xbb\u0D59pf;\uC000\ud835\udd67ro\xf0\u0EFBtr\xe9\u39B4\u0100cu\u3A06\u3A0Br;\uC000\ud835\udccb\u0100bp\u3A10\u3A18n\u0100Ee\u3980\u3A16\xbb\u397En\u0100Ee\u3992\u3A1E\xbb\u3990igzag;\u699A\u0380cefoprs\u3A36\u3A3B\u3A56\u3A5B\u3A54\u3A61\u3A6Airc;\u4175\u0100di\u3A40\u3A51\u0100bg\u3A45\u3A49ar;\u6A5Fe\u0100;q\u15FA\u3A4F;\u6259erp;\u6118r;\uC000\ud835\udd34pf;\uC000\ud835\udd68\u0100;e\u1479\u3A66at\xe8\u1479cr;\uC000\ud835\udccc\u0AE3\u178E\u3A87\x00\u3A8B\x00\u3A90\u3A9B\x00\x00\u3A9D\u3AA8\u3AAB\u3AAF\x00\x00\u3AC3\u3ACE\x00\u3AD8\u17DC\u17DFtr\xe9\u17D1r;\uC000\ud835\udd35\u0100Aa\u3A94\u3A97r\xf2\u03C3r\xf2\u09F6;\u43BE\u0100Aa\u3AA1\u3AA4r\xf2\u03B8r\xf2\u09EBa\xf0\u2713is;\u62FB\u0180dpt\u17A4\u3AB5\u3ABE\u0100fl\u3ABA\u17A9;\uC000\ud835\udd69im\xe5\u17B2\u0100Aa\u3AC7\u3ACAr\xf2\u03CEr\xf2\u0A01\u0100cq\u3AD2\u17B8r;\uC000\ud835\udccd\u0100pt\u17D6\u3ADCr\xe9\u17D4\u0400acefiosu\u3AF0\u3AFD\u3B08\u3B0C\u3B11\u3B15\u3B1B\u3B21c\u0100uy\u3AF6\u3AFBte\u803B\xfd\u40FD;\u444F\u0100iy\u3B02\u3B06rc;\u4177;\u444Bn\u803B\xa5\u40A5r;\uC000\ud835\udd36cy;\u4457pf;\uC000\ud835\udd6acr;\uC000\ud835\udcce\u0100cm\u3B26\u3B29y;\u444El\u803B\xff\u40FF\u0500acdefhiosw\u3B42\u3B48\u3B54\u3B58\u3B64\u3B69\u3B6D\u3B74\u3B7A\u3B80cute;\u417A\u0100ay\u3B4D\u3B52ron;\u417E;\u4437ot;\u417C\u0100et\u3B5D\u3B61tr\xe6\u155Fa;\u43B6r;\uC000\ud835\udd37cy;\u4436grarr;\u61DDpf;\uC000\ud835\udd6bcr;\uC000\ud835\udccf\u0100jn\u3B85\u3B87;\u600Dj;\u600C'.split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("hpIw9", function(module, exports) {
"use strict";
// Generated using scripts/write-decode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = new Uint16Array(// prettier-ignore
"\u0200aglq	\x15\x18\x1b\u026D\x0f\x00\x00\x12p;\u4026os;\u4027t;\u403Et;\u403Cuot;\u4022".split("").map(function(c) {
    return c.charCodeAt(0);
}));

});

parcelRegister("iIWux", function(module, exports) {
"use strict";
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $da19b5450f2dc555$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.replaceCodePoint = module.exports.fromCodePoint = void 0;
var $da19b5450f2dc555$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
/**
 * Polyfill for `String.fromCodePoint`. It is used to create a string from a Unicode code point.
 */ module.exports.fromCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($da19b5450f2dc555$var$_a = String.fromCodePoint) !== null && $da19b5450f2dc555$var$_a !== void 0 ? $da19b5450f2dc555$var$_a : function(codePoint) {
    var output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
/**
 * Replace the given code point with a replacement character if it is a
 * surrogate or is outside the valid range. Otherwise return the code
 * point unchanged.
 */ function $da19b5450f2dc555$var$replaceCodePoint(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $da19b5450f2dc555$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
module.exports.replaceCodePoint = $da19b5450f2dc555$var$replaceCodePoint;
/**
 * Replace the code point if relevant, then convert it to a string.
 *
 * @deprecated Use `fromCodePoint(replaceCodePoint(codePoint))` instead.
 * @param codePoint The code point to decode.
 * @returns The decoded code point.
 */ function $da19b5450f2dc555$var$decodeCodePoint(codePoint) {
    return (0, module.exports.fromCodePoint)($da19b5450f2dc555$var$replaceCodePoint(codePoint));
}
module.exports.default = $da19b5450f2dc555$var$decodeCodePoint;

});



parcelRegister("95jpT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Doctype = module.exports.CDATA = module.exports.Tag = module.exports.Style = module.exports.Script = module.exports.Comment = module.exports.Directive = module.exports.Text = module.exports.Root = module.exports.isTag = module.exports.ElementType = void 0;
/** Types of elements found in htmlparser2's DOM */ var $69d3a46acdc8d3c7$var$ElementType;
(function(ElementType) {
    /** Type for the root element of a document */ ElementType["Root"] = "root";
    /** Type for Text */ ElementType["Text"] = "text";
    /** Type for <? ... ?> */ ElementType["Directive"] = "directive";
    /** Type for <!-- ... --> */ ElementType["Comment"] = "comment";
    /** Type for <script> tags */ ElementType["Script"] = "script";
    /** Type for <style> tags */ ElementType["Style"] = "style";
    /** Type for Any tag */ ElementType["Tag"] = "tag";
    /** Type for <![CDATA[ ... ]]> */ ElementType["CDATA"] = "cdata";
    /** Type for <!doctype ...> */ ElementType["Doctype"] = "doctype";
})($69d3a46acdc8d3c7$var$ElementType = module.exports.ElementType || (module.exports.ElementType = {}));
/**
 * Tests whether an element is a tag or not.
 *
 * @param elem Element to test
 */ function $69d3a46acdc8d3c7$var$isTag(elem) {
    return elem.type === $69d3a46acdc8d3c7$var$ElementType.Tag || elem.type === $69d3a46acdc8d3c7$var$ElementType.Script || elem.type === $69d3a46acdc8d3c7$var$ElementType.Style;
}
module.exports.isTag = $69d3a46acdc8d3c7$var$isTag;
// Exports for backwards compatibility
/** Type for the root element of a document */ module.exports.Root = $69d3a46acdc8d3c7$var$ElementType.Root;
/** Type for Text */ module.exports.Text = $69d3a46acdc8d3c7$var$ElementType.Text;
/** Type for <? ... ?> */ module.exports.Directive = $69d3a46acdc8d3c7$var$ElementType.Directive;
/** Type for <!-- ... --> */ module.exports.Comment = $69d3a46acdc8d3c7$var$ElementType.Comment;
/** Type for <script> tags */ module.exports.Script = $69d3a46acdc8d3c7$var$ElementType.Script;
/** Type for <style> tags */ module.exports.Style = $69d3a46acdc8d3c7$var$ElementType.Style;
/** Type for Any tag */ module.exports.Tag = $69d3a46acdc8d3c7$var$ElementType.Tag;
/** Type for <![CDATA[ ... ]]> */ module.exports.CDATA = $69d3a46acdc8d3c7$var$ElementType.CDATA;
/** Type for <!doctype ...> */ module.exports.Doctype = $69d3a46acdc8d3c7$var$ElementType.Doctype;

});

parcelRegister("jLFoA", function(module, exports) {
"use strict";
var $e642846a4bdc6357$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $e642846a4bdc6357$var$__assign = module.exports && module.exports.__assign || function() {
    $e642846a4bdc6357$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e642846a4bdc6357$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cloneNode = module.exports.hasChildren = module.exports.isDocument = module.exports.isDirective = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = module.exports.Element = module.exports.Document = module.exports.CDATA = module.exports.NodeWithChildren = module.exports.ProcessingInstruction = module.exports.Comment = module.exports.Text = module.exports.DataNode = module.exports.Node = void 0;

var $95jpT = parcelRequire("95jpT");
/**
 * This object will be used as the prototype for Nodes when creating a
 * DOM-Level-1-compliant structure.
 */ var $e642846a4bdc6357$var$Node = /** @class */ function() {
    function Node() {
        /** Parent of the node */ this.parent = null;
        /** Previous sibling */ this.prev = null;
        /** Next sibling */ this.next = null;
        /** The start index of the node. Requires `withStartIndices` on the handler to be `true. */ this.startIndex = null;
        /** The end index of the node. Requires `withEndIndices` on the handler to be `true. */ this.endIndex = null;
    }
    Object.defineProperty(Node.prototype, "parentNode", {
        // Read-write aliases for properties
        /**
         * Same as {@link parent}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.parent;
        },
        set: function(parent) {
            this.parent = parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "previousSibling", {
        /**
         * Same as {@link prev}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.prev;
        },
        set: function(prev) {
            this.prev = prev;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Node.prototype, "nextSibling", {
        /**
         * Same as {@link next}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.next;
        },
        set: function(next) {
            this.next = next;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Clone this node, and optionally its children.
     *
     * @param recursive Clone child nodes as well.
     * @returns A clone of the node.
     */ Node.prototype.cloneNode = function(recursive) {
        if (recursive === void 0) recursive = false;
        return $e642846a4bdc6357$var$cloneNode(this, recursive);
    };
    return Node;
}();
module.exports.Node = $e642846a4bdc6357$var$Node;
/**
 * A node that contains some data.
 */ var $e642846a4bdc6357$var$DataNode = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(DataNode, _super);
    /**
     * @param data The content of the data node
     */ function DataNode(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    Object.defineProperty(DataNode.prototype, "nodeValue", {
        /**
         * Same as {@link data}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.data;
        },
        set: function(data) {
            this.data = data;
        },
        enumerable: false,
        configurable: true
    });
    return DataNode;
}($e642846a4bdc6357$var$Node);
module.exports.DataNode = $e642846a4bdc6357$var$DataNode;
/**
 * Text within the document.
 */ var $e642846a4bdc6357$var$Text = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $95jpT.ElementType.Text;
        return _this;
    }
    Object.defineProperty(Text.prototype, "nodeType", {
        get: function() {
            return 3;
        },
        enumerable: false,
        configurable: true
    });
    return Text;
}($e642846a4bdc6357$var$DataNode);
module.exports.Text = $e642846a4bdc6357$var$Text;
/**
 * Comments within the document.
 */ var $e642846a4bdc6357$var$Comment = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(Comment, _super);
    function Comment() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $95jpT.ElementType.Comment;
        return _this;
    }
    Object.defineProperty(Comment.prototype, "nodeType", {
        get: function() {
            return 8;
        },
        enumerable: false,
        configurable: true
    });
    return Comment;
}($e642846a4bdc6357$var$DataNode);
module.exports.Comment = $e642846a4bdc6357$var$Comment;
/**
 * Processing instructions, including doc types.
 */ var $e642846a4bdc6357$var$ProcessingInstruction = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(ProcessingInstruction, _super);
    function ProcessingInstruction(name, data) {
        var _this = _super.call(this, data) || this;
        _this.name = name;
        _this.type = $95jpT.ElementType.Directive;
        return _this;
    }
    Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    return ProcessingInstruction;
}($e642846a4bdc6357$var$DataNode);
module.exports.ProcessingInstruction = $e642846a4bdc6357$var$ProcessingInstruction;
/**
 * A `Node` that can have children.
 */ var $e642846a4bdc6357$var$NodeWithChildren = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(NodeWithChildren, _super);
    /**
     * @param children Children of the node. Only certain node types can have children.
     */ function NodeWithChildren(children) {
        var _this = _super.call(this) || this;
        _this.children = children;
        return _this;
    }
    Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
        // Aliases
        /** First child of the node. */ get: function() {
            var _a;
            return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
        /** Last child of the node. */ get: function() {
            return this.children.length > 0 ? this.children[this.children.length - 1] : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
        /**
         * Same as {@link children}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.children;
        },
        set: function(children) {
            this.children = children;
        },
        enumerable: false,
        configurable: true
    });
    return NodeWithChildren;
}($e642846a4bdc6357$var$Node);
module.exports.NodeWithChildren = $e642846a4bdc6357$var$NodeWithChildren;
var $e642846a4bdc6357$var$CDATA = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(CDATA, _super);
    function CDATA() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $95jpT.ElementType.CDATA;
        return _this;
    }
    Object.defineProperty(CDATA.prototype, "nodeType", {
        get: function() {
            return 4;
        },
        enumerable: false,
        configurable: true
    });
    return CDATA;
}($e642846a4bdc6357$var$NodeWithChildren);
module.exports.CDATA = $e642846a4bdc6357$var$CDATA;
/**
 * The root node of the document.
 */ var $e642846a4bdc6357$var$Document = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(Document, _super);
    function Document() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $95jpT.ElementType.Root;
        return _this;
    }
    Object.defineProperty(Document.prototype, "nodeType", {
        get: function() {
            return 9;
        },
        enumerable: false,
        configurable: true
    });
    return Document;
}($e642846a4bdc6357$var$NodeWithChildren);
module.exports.Document = $e642846a4bdc6357$var$Document;
/**
 * An element within the DOM.
 */ var $e642846a4bdc6357$var$Element = /** @class */ function(_super) {
    $e642846a4bdc6357$var$__extends(Element, _super);
    /**
     * @param name Name of the tag, eg. `div`, `span`.
     * @param attribs Object mapping attribute names to attribute values.
     * @param children Children of the node.
     */ function Element(name, attribs, children, type) {
        if (children === void 0) children = [];
        if (type === void 0) type = name === "script" ? $95jpT.ElementType.Script : name === "style" ? $95jpT.ElementType.Style : $95jpT.ElementType.Tag;
        var _this = _super.call(this, children) || this;
        _this.name = name;
        _this.attribs = attribs;
        _this.type = type;
        return _this;
    }
    Object.defineProperty(Element.prototype, "nodeType", {
        get: function() {
            return 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "tagName", {
        // DOM Level 1 aliases
        /**
         * Same as {@link name}.
         * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
         */ get: function() {
            return this.name;
        },
        set: function(name) {
            this.name = name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Element.prototype, "attributes", {
        get: function() {
            var _this = this;
            return Object.keys(this.attribs).map(function(name) {
                var _a, _b;
                return {
                    name: name,
                    value: _this.attribs[name],
                    namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
                    prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
                };
            });
        },
        enumerable: false,
        configurable: true
    });
    return Element;
}($e642846a4bdc6357$var$NodeWithChildren);
module.exports.Element = $e642846a4bdc6357$var$Element;
/**
 * @param node Node to check.
 * @returns `true` if the node is a `Element`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isTag(node) {
    return (0, $95jpT.isTag)(node);
}
module.exports.isTag = $e642846a4bdc6357$var$isTag;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `CDATA`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isCDATA(node) {
    return node.type === $95jpT.ElementType.CDATA;
}
module.exports.isCDATA = $e642846a4bdc6357$var$isCDATA;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Text`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isText(node) {
    return node.type === $95jpT.ElementType.Text;
}
module.exports.isText = $e642846a4bdc6357$var$isText;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `Comment`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isComment(node) {
    return node.type === $95jpT.ElementType.Comment;
}
module.exports.isComment = $e642846a4bdc6357$var$isComment;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isDirective(node) {
    return node.type === $95jpT.ElementType.Directive;
}
module.exports.isDirective = $e642846a4bdc6357$var$isDirective;
/**
 * @param node Node to check.
 * @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
 */ function $e642846a4bdc6357$var$isDocument(node) {
    return node.type === $95jpT.ElementType.Root;
}
module.exports.isDocument = $e642846a4bdc6357$var$isDocument;
/**
 * @param node Node to check.
 * @returns `true` if the node has children, `false` otherwise.
 */ function $e642846a4bdc6357$var$hasChildren(node) {
    return Object.prototype.hasOwnProperty.call(node, "children");
}
module.exports.hasChildren = $e642846a4bdc6357$var$hasChildren;
/**
 * Clone a node, and optionally its children.
 *
 * @param recursive Clone child nodes as well.
 * @returns A clone of the node.
 */ function $e642846a4bdc6357$var$cloneNode(node, recursive) {
    if (recursive === void 0) recursive = false;
    var result;
    if ($e642846a4bdc6357$var$isText(node)) result = new $e642846a4bdc6357$var$Text(node.data);
    else if ($e642846a4bdc6357$var$isComment(node)) result = new $e642846a4bdc6357$var$Comment(node.data);
    else if ($e642846a4bdc6357$var$isTag(node)) {
        var children = recursive ? $e642846a4bdc6357$var$cloneChildren(node.children) : [];
        var clone_1 = new $e642846a4bdc6357$var$Element(node.name, $e642846a4bdc6357$var$__assign({}, node.attribs), children);
        children.forEach(function(child) {
            return child.parent = clone_1;
        });
        if (node.namespace != null) clone_1.namespace = node.namespace;
        if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = $e642846a4bdc6357$var$__assign({}, node["x-attribsNamespace"]);
        if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = $e642846a4bdc6357$var$__assign({}, node["x-attribsPrefix"]);
        result = clone_1;
    } else if ($e642846a4bdc6357$var$isCDATA(node)) {
        var children = recursive ? $e642846a4bdc6357$var$cloneChildren(node.children) : [];
        var clone_2 = new $e642846a4bdc6357$var$CDATA(children);
        children.forEach(function(child) {
            return child.parent = clone_2;
        });
        result = clone_2;
    } else if ($e642846a4bdc6357$var$isDocument(node)) {
        var children = recursive ? $e642846a4bdc6357$var$cloneChildren(node.children) : [];
        var clone_3 = new $e642846a4bdc6357$var$Document(children);
        children.forEach(function(child) {
            return child.parent = clone_3;
        });
        if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
        result = clone_3;
    } else if ($e642846a4bdc6357$var$isDirective(node)) {
        var instruction = new $e642846a4bdc6357$var$ProcessingInstruction(node.name, node.data);
        if (node["x-name"] != null) {
            instruction["x-name"] = node["x-name"];
            instruction["x-publicId"] = node["x-publicId"];
            instruction["x-systemId"] = node["x-systemId"];
        }
        result = instruction;
    } else throw new Error("Not implemented yet: ".concat(node.type));
    result.startIndex = node.startIndex;
    result.endIndex = node.endIndex;
    if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
    return result;
}
module.exports.cloneNode = $e642846a4bdc6357$var$cloneNode;
function $e642846a4bdc6357$var$cloneChildren(childs) {
    var children = childs.map(function(child) {
        return $e642846a4bdc6357$var$cloneNode(child, true);
    });
    for(var i = 1; i < children.length; i++){
        children[i].prev = children[i - 1];
        children[i - 1].next = children[i];
    }
    return children;
}

});

parcelRegister("hfvOx", function(module, exports) {
"use strict";
var $c8ec84008f21813f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c8ec84008f21813f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c8ec84008f21813f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasChildren = module.exports.isDocument = module.exports.isComment = module.exports.isText = module.exports.isCDATA = module.exports.isTag = void 0;

$c8ec84008f21813f$var$__exportStar((parcelRequire("gOX3U")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("a1Ven")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("hUgLt")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("2gVOA")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("lM13u")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("lTMuX")), module.exports);

$c8ec84008f21813f$var$__exportStar((parcelRequire("e6I1o")), module.exports);

var $5MteQ = parcelRequire("5MteQ");
Object.defineProperty(module.exports, "isTag", {
    enumerable: true,
    get: function() {
        return $5MteQ.isTag;
    }
});
Object.defineProperty(module.exports, "isCDATA", {
    enumerable: true,
    get: function() {
        return $5MteQ.isCDATA;
    }
});
Object.defineProperty(module.exports, "isText", {
    enumerable: true,
    get: function() {
        return $5MteQ.isText;
    }
});
Object.defineProperty(module.exports, "isComment", {
    enumerable: true,
    get: function() {
        return $5MteQ.isComment;
    }
});
Object.defineProperty(module.exports, "isDocument", {
    enumerable: true,
    get: function() {
        return $5MteQ.isDocument;
    }
});
Object.defineProperty(module.exports, "hasChildren", {
    enumerable: true,
    get: function() {
        return $5MteQ.hasChildren;
    }
});

});
parcelRegister("gOX3U", function(module, exports) {
"use strict";
var $c3ef215f36cbe2a0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.innerText = module.exports.textContent = module.exports.getText = module.exports.getInnerHTML = module.exports.getOuterHTML = void 0;

var $5MteQ = parcelRequire("5MteQ");

var $c3ef215f36cbe2a0$var$dom_serializer_1 = $c3ef215f36cbe2a0$var$__importDefault((parcelRequire("2vT6S")));

var $95jpT = parcelRequire("95jpT");
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the outer HTML of.
 * @param options Options for serialization.
 * @returns `node`'s outer HTML.
 */ function $c3ef215f36cbe2a0$var$getOuterHTML(node, options) {
    return (0, $c3ef215f36cbe2a0$var$dom_serializer_1.default)(node, options);
}
module.exports.getOuterHTML = $c3ef215f36cbe2a0$var$getOuterHTML;
/**
 * @category Stringify
 * @deprecated Use the `dom-serializer` module directly.
 * @param node Node to get the inner HTML of.
 * @param options Options for serialization.
 * @returns `node`'s inner HTML.
 */ function $c3ef215f36cbe2a0$var$getInnerHTML(node, options) {
    return (0, $5MteQ.hasChildren)(node) ? node.children.map(function(node) {
        return $c3ef215f36cbe2a0$var$getOuterHTML(node, options);
    }).join("") : "";
}
module.exports.getInnerHTML = $c3ef215f36cbe2a0$var$getInnerHTML;
/**
 * Get a node's inner text. Same as `textContent`, but inserts newlines for `<br>` tags. Ignores comments.
 *
 * @category Stringify
 * @deprecated Use `textContent` instead.
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 */ function $c3ef215f36cbe2a0$var$getText(node) {
    if (Array.isArray(node)) return node.map($c3ef215f36cbe2a0$var$getText).join("");
    if ((0, $5MteQ.isTag)(node)) return node.name === "br" ? "\n" : $c3ef215f36cbe2a0$var$getText(node.children);
    if ((0, $5MteQ.isCDATA)(node)) return $c3ef215f36cbe2a0$var$getText(node.children);
    if ((0, $5MteQ.isText)(node)) return node.data;
    return "";
}
module.exports.getText = $c3ef215f36cbe2a0$var$getText;
/**
 * Get a node's text content. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the text content of.
 * @returns `node`'s text content.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent}
 */ function $c3ef215f36cbe2a0$var$textContent(node) {
    if (Array.isArray(node)) return node.map($c3ef215f36cbe2a0$var$textContent).join("");
    if ((0, $5MteQ.hasChildren)(node) && !(0, $5MteQ.isComment)(node)) return $c3ef215f36cbe2a0$var$textContent(node.children);
    if ((0, $5MteQ.isText)(node)) return node.data;
    return "";
}
module.exports.textContent = $c3ef215f36cbe2a0$var$textContent;
/**
 * Get a node's inner text, ignoring `<script>` and `<style>` tags. Ignores comments.
 *
 * @category Stringify
 * @param node Node to get the inner text of.
 * @returns `node`'s inner text.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Node/innerText}
 */ function $c3ef215f36cbe2a0$var$innerText(node) {
    if (Array.isArray(node)) return node.map($c3ef215f36cbe2a0$var$innerText).join("");
    if ((0, $5MteQ.hasChildren)(node) && (node.type === $95jpT.ElementType.Tag || (0, $5MteQ.isCDATA)(node))) return $c3ef215f36cbe2a0$var$innerText(node.children);
    if ((0, $5MteQ.isText)(node)) return node.data;
    return "";
}
module.exports.innerText = $c3ef215f36cbe2a0$var$innerText;

});
parcelRegister("5MteQ", function(module, exports) {
"use strict";
var $43581d96c95ecb11$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $43581d96c95ecb11$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $43581d96c95ecb11$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DomHandler = void 0;

var $95jpT = parcelRequire("95jpT");


$43581d96c95ecb11$var$__exportStar((parcelRequire("jLFoA")), module.exports);
// Default options
var $43581d96c95ecb11$var$defaultOpts = {
    withStartIndices: false,
    withEndIndices: false,
    xmlMode: false
};
var $43581d96c95ecb11$var$DomHandler = /** @class */ function() {
    /**
     * @param callback Called once parsing has completed.
     * @param options Settings for the handler.
     * @param elementCB Callback whenever a tag is closed.
     */ function DomHandler(callback, options, elementCB) {
        /** The elements of the DOM */ this.dom = [];
        /** The root element for the DOM */ this.root = new (parcelRequire("jLFoA")).Document(this.dom);
        /** Indicated whether parsing has been completed. */ this.done = false;
        /** Stack of open tags. */ this.tagStack = [
            this.root
        ];
        /** A data node that is still being written to. */ this.lastNode = null;
        /** Reference to the parser instance. Used for location information. */ this.parser = null;
        // Make it possible to skip arguments, for backwards-compatibility
        if (typeof options === "function") {
            elementCB = options;
            options = $43581d96c95ecb11$var$defaultOpts;
        }
        if (typeof callback === "object") {
            options = callback;
            callback = undefined;
        }
        this.callback = callback !== null && callback !== void 0 ? callback : null;
        this.options = options !== null && options !== void 0 ? options : $43581d96c95ecb11$var$defaultOpts;
        this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
    }
    DomHandler.prototype.onparserinit = function(parser) {
        this.parser = parser;
    };
    // Resets the handler back to starting state
    DomHandler.prototype.onreset = function() {
        this.dom = [];
        this.root = new (parcelRequire("jLFoA")).Document(this.dom);
        this.done = false;
        this.tagStack = [
            this.root
        ];
        this.lastNode = null;
        this.parser = null;
    };
    // Signals the handler that parsing is done
    DomHandler.prototype.onend = function() {
        if (this.done) return;
        this.done = true;
        this.parser = null;
        this.handleCallback(null);
    };
    DomHandler.prototype.onerror = function(error) {
        this.handleCallback(error);
    };
    DomHandler.prototype.onclosetag = function() {
        this.lastNode = null;
        var elem = this.tagStack.pop();
        if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
        if (this.elementCB) this.elementCB(elem);
    };
    DomHandler.prototype.onopentag = function(name, attribs) {
        var type = this.options.xmlMode ? $95jpT.ElementType.Tag : undefined;
        var element = new (parcelRequire("jLFoA")).Element(name, attribs, undefined, type);
        this.addNode(element);
        this.tagStack.push(element);
    };
    DomHandler.prototype.ontext = function(data) {
        var lastNode = this.lastNode;
        if (lastNode && lastNode.type === $95jpT.ElementType.Text) {
            lastNode.data += data;
            if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
        } else {
            var node = new (parcelRequire("jLFoA")).Text(data);
            this.addNode(node);
            this.lastNode = node;
        }
    };
    DomHandler.prototype.oncomment = function(data) {
        if (this.lastNode && this.lastNode.type === $95jpT.ElementType.Comment) {
            this.lastNode.data += data;
            return;
        }
        var node = new (parcelRequire("jLFoA")).Comment(data);
        this.addNode(node);
        this.lastNode = node;
    };
    DomHandler.prototype.oncommentend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.oncdatastart = function() {
        var text = new (parcelRequire("jLFoA")).Text("");
        var node = new (parcelRequire("jLFoA")).CDATA([
            text
        ]);
        this.addNode(node);
        text.parent = node;
        this.lastNode = text;
    };
    DomHandler.prototype.oncdataend = function() {
        this.lastNode = null;
    };
    DomHandler.prototype.onprocessinginstruction = function(name, data) {
        var node = new (parcelRequire("jLFoA")).ProcessingInstruction(name, data);
        this.addNode(node);
    };
    DomHandler.prototype.handleCallback = function(error) {
        if (typeof this.callback === "function") this.callback(error, this.dom);
        else if (error) throw error;
    };
    DomHandler.prototype.addNode = function(node) {
        var parent = this.tagStack[this.tagStack.length - 1];
        var previousSibling = parent.children[parent.children.length - 1];
        if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
        if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
        parent.children.push(node);
        if (previousSibling) {
            node.prev = previousSibling;
            previousSibling.next = node;
        }
        node.parent = parent;
        this.lastNode = null;
    };
    return DomHandler;
}();
module.exports.DomHandler = $43581d96c95ecb11$var$DomHandler;
module.exports.default = $43581d96c95ecb11$var$DomHandler;

});

parcelRegister("2vT6S", function(module, exports) {
"use strict";
var $1d4939b83b283fb2$var$__assign = module.exports && module.exports.__assign || function() {
    $1d4939b83b283fb2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1d4939b83b283fb2$var$__assign.apply(this, arguments);
};
var $1d4939b83b283fb2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1d4939b83b283fb2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1d4939b83b283fb2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1d4939b83b283fb2$var$__createBinding(result, mod, k);
    }
    $1d4939b83b283fb2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.render = void 0;

/*
 * Module dependencies
 */ var $1d4939b83b283fb2$var$ElementType = $1d4939b83b283fb2$var$__importStar((parcelRequire("95jpT")));

var $9l6ge = parcelRequire("9l6ge");

var $i4LPP = parcelRequire("i4LPP");
var $1d4939b83b283fb2$var$unencodedElements = new Set([
    "style",
    "script",
    "xmp",
    "iframe",
    "noembed",
    "noframes",
    "plaintext",
    "noscript"
]);
function $1d4939b83b283fb2$var$replaceQuotes(value) {
    return value.replace(/"/g, "&quot;");
}
/**
 * Format attributes
 */ function $1d4939b83b283fb2$var$formatAttributes(attributes, opts) {
    var _a;
    if (!attributes) return;
    var encode = ((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) === false ? $1d4939b83b283fb2$var$replaceQuotes : opts.xmlMode || opts.encodeEntities !== "utf8" ? $9l6ge.encodeXML : $9l6ge.escapeAttribute;
    return Object.keys(attributes).map(function(key) {
        var _a, _b;
        var value = (_a = attributes[key]) !== null && _a !== void 0 ? _a : "";
        if (opts.xmlMode === "foreign") /* Fix up mixed-case attribute names */ key = (_b = $i4LPP.attributeNames.get(key)) !== null && _b !== void 0 ? _b : key;
        if (!opts.emptyAttrs && !opts.xmlMode && value === "") return key;
        return "".concat(key, '="').concat(encode(value), '"');
    }).join(" ");
}
/**
 * Self-enclosing tags
 */ var $1d4939b83b283fb2$var$singleTag = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
/**
 * Renders a DOM node or an array of DOM nodes to a string.
 *
 * Can be thought of as the equivalent of the `outerHTML` of the passed node(s).
 *
 * @param node Node to be rendered.
 * @param options Changes serialization behavior
 */ function $1d4939b83b283fb2$var$render(node, options) {
    if (options === void 0) options = {};
    var nodes = "length" in node ? node : [
        node
    ];
    var output = "";
    for(var i = 0; i < nodes.length; i++)output += $1d4939b83b283fb2$var$renderNode(nodes[i], options);
    return output;
}
module.exports.render = $1d4939b83b283fb2$var$render;
module.exports.default = $1d4939b83b283fb2$var$render;
function $1d4939b83b283fb2$var$renderNode(node, options) {
    switch(node.type){
        case $1d4939b83b283fb2$var$ElementType.Root:
            return $1d4939b83b283fb2$var$render(node.children, options);
        // @ts-expect-error We don't use `Doctype` yet
        case $1d4939b83b283fb2$var$ElementType.Doctype:
        case $1d4939b83b283fb2$var$ElementType.Directive:
            return $1d4939b83b283fb2$var$renderDirective(node);
        case $1d4939b83b283fb2$var$ElementType.Comment:
            return $1d4939b83b283fb2$var$renderComment(node);
        case $1d4939b83b283fb2$var$ElementType.CDATA:
            return $1d4939b83b283fb2$var$renderCdata(node);
        case $1d4939b83b283fb2$var$ElementType.Script:
        case $1d4939b83b283fb2$var$ElementType.Style:
        case $1d4939b83b283fb2$var$ElementType.Tag:
            return $1d4939b83b283fb2$var$renderTag(node, options);
        case $1d4939b83b283fb2$var$ElementType.Text:
            return $1d4939b83b283fb2$var$renderText(node, options);
    }
}
var $1d4939b83b283fb2$var$foreignModeIntegrationPoints = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignObject",
    "desc",
    "title"
]);
var $1d4939b83b283fb2$var$foreignElements = new Set([
    "svg",
    "math"
]);
function $1d4939b83b283fb2$var$renderTag(elem, opts) {
    var _a;
    // Handle SVG / MathML in HTML
    if (opts.xmlMode === "foreign") {
        /* Fix up mixed-case element names */ elem.name = (_a = $i4LPP.elementNames.get(elem.name)) !== null && _a !== void 0 ? _a : elem.name;
        /* Exit foreign mode at integration points */ if (elem.parent && $1d4939b83b283fb2$var$foreignModeIntegrationPoints.has(elem.parent.name)) opts = $1d4939b83b283fb2$var$__assign($1d4939b83b283fb2$var$__assign({}, opts), {
            xmlMode: false
        });
    }
    if (!opts.xmlMode && $1d4939b83b283fb2$var$foreignElements.has(elem.name)) opts = $1d4939b83b283fb2$var$__assign($1d4939b83b283fb2$var$__assign({}, opts), {
        xmlMode: "foreign"
    });
    var tag = "<".concat(elem.name);
    var attribs = $1d4939b83b283fb2$var$formatAttributes(elem.attribs, opts);
    if (attribs) tag += " ".concat(attribs);
    if (elem.children.length === 0 && (opts.xmlMode ? opts.selfClosingTags !== false : opts.selfClosingTags && $1d4939b83b283fb2$var$singleTag.has(elem.name))) {
        if (!opts.xmlMode) tag += " ";
        tag += "/>";
    } else {
        tag += ">";
        if (elem.children.length > 0) tag += $1d4939b83b283fb2$var$render(elem.children, opts);
        if (opts.xmlMode || !$1d4939b83b283fb2$var$singleTag.has(elem.name)) tag += "</".concat(elem.name, ">");
    }
    return tag;
}
function $1d4939b83b283fb2$var$renderDirective(elem) {
    return "<".concat(elem.data, ">");
}
function $1d4939b83b283fb2$var$renderText(elem, opts) {
    var _a;
    var data = elem.data || "";
    // If entities weren't decoded, no need to encode them back
    if (((_a = opts.encodeEntities) !== null && _a !== void 0 ? _a : opts.decodeEntities) !== false && !(!opts.xmlMode && elem.parent && $1d4939b83b283fb2$var$unencodedElements.has(elem.parent.name))) data = opts.xmlMode || opts.encodeEntities !== "utf8" ? (0, $9l6ge.encodeXML)(data) : (0, $9l6ge.escapeText)(data);
    return data;
}
function $1d4939b83b283fb2$var$renderCdata(elem) {
    return "<![CDATA[".concat(elem.children[0].data, "]]>");
}
function $1d4939b83b283fb2$var$renderComment(elem) {
    return "<!--".concat(elem.data, "-->");
}

});
parcelRegister("9l6ge", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeXMLStrict = module.exports.decodeHTML5Strict = module.exports.decodeHTML4Strict = module.exports.decodeHTML5 = module.exports.decodeHTML4 = module.exports.decodeHTMLAttribute = module.exports.decodeHTMLStrict = module.exports.decodeHTML = module.exports.decodeXML = module.exports.DecodingMode = module.exports.EntityDecoder = module.exports.encodeHTML5 = module.exports.encodeHTML4 = module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.encode = module.exports.decodeStrict = module.exports.decode = module.exports.EncodingMode = module.exports.EntityLevel = void 0;

var $Tj5sm = parcelRequire("Tj5sm");

var $1D4n5 = parcelRequire("1D4n5");

var $8U86C = parcelRequire("8U86C");
/** The level of entities to support. */ var $6ccaee80db00c545$var$EntityLevel;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($6ccaee80db00c545$var$EntityLevel = module.exports.EntityLevel || (module.exports.EntityLevel = {}));
var $6ccaee80db00c545$var$EncodingMode;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($6ccaee80db00c545$var$EncodingMode = module.exports.EncodingMode || (module.exports.EncodingMode = {}));
/**
 * Decodes a string with entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 */ function $6ccaee80db00c545$var$decode(data, options) {
    if (options === void 0) options = $6ccaee80db00c545$var$EntityLevel.XML;
    var level = typeof options === "number" ? options : options.level;
    if (level === $6ccaee80db00c545$var$EntityLevel.HTML) {
        var mode = typeof options === "object" ? options.mode : undefined;
        return (0, $Tj5sm.decodeHTML)(data, mode);
    }
    return (0, $Tj5sm.decodeXML)(data);
}
module.exports.decode = $6ccaee80db00c545$var$decode;
/**
 * Decodes a string with entities. Does not allow missing trailing semicolons for entities.
 *
 * @param data String to decode.
 * @param options Decoding options.
 * @deprecated Use `decode` with the `mode` set to `Strict`.
 */ function $6ccaee80db00c545$var$decodeStrict(data, options) {
    var _a;
    if (options === void 0) options = $6ccaee80db00c545$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = $Tj5sm.DecodingMode.Strict;
    return $6ccaee80db00c545$var$decode(data, opts);
}
module.exports.decodeStrict = $6ccaee80db00c545$var$decodeStrict;
/**
 * Encodes a string with entities.
 *
 * @param data String to encode.
 * @param options Encoding options.
 */ function $6ccaee80db00c545$var$encode(data, options) {
    if (options === void 0) options = $6ccaee80db00c545$var$EntityLevel.XML;
    var opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $6ccaee80db00c545$var$EncodingMode.UTF8) return (0, $8U86C.escapeUTF8)(data);
    if (opts.mode === $6ccaee80db00c545$var$EncodingMode.Attribute) return (0, $8U86C.escapeAttribute)(data);
    if (opts.mode === $6ccaee80db00c545$var$EncodingMode.Text) return (0, $8U86C.escapeText)(data);
    if (opts.level === $6ccaee80db00c545$var$EntityLevel.HTML) {
        if (opts.mode === $6ccaee80db00c545$var$EncodingMode.ASCII) return (0, $1D4n5.encodeNonAsciiHTML)(data);
        return (0, $1D4n5.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $8U86C.encodeXML)(data);
}
module.exports.encode = $6ccaee80db00c545$var$encode;

var $8U86C = parcelRequire("8U86C");
Object.defineProperty(module.exports, "encodeXML", {
    enumerable: true,
    get: function() {
        return $8U86C.encodeXML;
    }
});
Object.defineProperty(module.exports, "escape", {
    enumerable: true,
    get: function() {
        return $8U86C.escape;
    }
});
Object.defineProperty(module.exports, "escapeUTF8", {
    enumerable: true,
    get: function() {
        return $8U86C.escapeUTF8;
    }
});
Object.defineProperty(module.exports, "escapeAttribute", {
    enumerable: true,
    get: function() {
        return $8U86C.escapeAttribute;
    }
});
Object.defineProperty(module.exports, "escapeText", {
    enumerable: true,
    get: function() {
        return $8U86C.escapeText;
    }
});

var $1D4n5 = parcelRequire("1D4n5");
Object.defineProperty(module.exports, "encodeHTML", {
    enumerable: true,
    get: function() {
        return $1D4n5.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeNonAsciiHTML", {
    enumerable: true,
    get: function() {
        return $1D4n5.encodeNonAsciiHTML;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "encodeHTML4", {
    enumerable: true,
    get: function() {
        return $1D4n5.encodeHTML;
    }
});
Object.defineProperty(module.exports, "encodeHTML5", {
    enumerable: true,
    get: function() {
        return $1D4n5.encodeHTML;
    }
});

var $Tj5sm = parcelRequire("Tj5sm");
Object.defineProperty(module.exports, "EntityDecoder", {
    enumerable: true,
    get: function() {
        return $Tj5sm.EntityDecoder;
    }
});
Object.defineProperty(module.exports, "DecodingMode", {
    enumerable: true,
    get: function() {
        return $Tj5sm.DecodingMode;
    }
});
Object.defineProperty(module.exports, "decodeXML", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeXML;
    }
});
Object.defineProperty(module.exports, "decodeHTML", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTMLStrict", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTMLAttribute", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTMLAttribute;
    }
});
// Legacy aliases (deprecated)
Object.defineProperty(module.exports, "decodeHTML4", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML5", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTML;
    }
});
Object.defineProperty(module.exports, "decodeHTML4Strict", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeHTML5Strict", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeHTMLStrict;
    }
});
Object.defineProperty(module.exports, "decodeXMLStrict", {
    enumerable: true,
    get: function() {
        return $Tj5sm.decodeXML;
    }
});

});
parcelRegister("1D4n5", function(module, exports) {
"use strict";
var $12fcd30457bc9fd9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeNonAsciiHTML = module.exports.encodeHTML = void 0;

var $12fcd30457bc9fd9$var$encode_html_js_1 = $12fcd30457bc9fd9$var$__importDefault((parcelRequire("cwwGX")));

var $8U86C = parcelRequire("8U86C");
var $12fcd30457bc9fd9$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
/**
 * Encodes all characters in the input using HTML entities. This includes
 * characters that are valid ASCII characters in HTML documents, such as `#`.
 *
 * To get a more compact output, consider using the `encodeNonAsciiHTML`
 * function, which will only encode characters that are not valid in HTML
 * documents, as well as non-ASCII characters.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $12fcd30457bc9fd9$var$encodeHTML(data) {
    return $12fcd30457bc9fd9$var$encodeHTMLTrieRe($12fcd30457bc9fd9$var$htmlReplacer, data);
}
module.exports.encodeHTML = $12fcd30457bc9fd9$var$encodeHTML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in HTML
 * documents using HTML entities. This function will not encode characters that
 * are valid in HTML documents, such as `#`.
 *
 * If a character has no equivalent entity, a numeric hexadecimal reference
 * (eg. `&#xfc;`) will be used.
 */ function $12fcd30457bc9fd9$var$encodeNonAsciiHTML(data) {
    return $12fcd30457bc9fd9$var$encodeHTMLTrieRe($8U86C.xmlReplacer, data);
}
module.exports.encodeNonAsciiHTML = $12fcd30457bc9fd9$var$encodeNonAsciiHTML;
function $12fcd30457bc9fd9$var$encodeHTMLTrieRe(regExp, str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = regExp.exec(str)) !== null){
        var i = match.index;
        ret += str.substring(lastIdx, i);
        var char = str.charCodeAt(i);
        var next = $12fcd30457bc9fd9$var$encode_html_js_1.default.get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                var nextChar = str.charCodeAt(i + 1);
                var value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            var cp = (0, $8U86C.getCodePoint)(str, i);
            ret += "&#x".concat(cp.toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("cwwGX", function(module, exports) {
"use strict";
// Generated using scripts/write-encode-map.ts
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $91e1d5182ba1bbf5$var$restoreDiff(arr) {
    for(var i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
// prettier-ignore
module.exports.default = new Map(/* #__PURE__ */ $91e1d5182ba1bbf5$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $91e1d5182ba1bbf5$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $91e1d5182ba1bbf5$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $91e1d5182ba1bbf5$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("8U86C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeText = module.exports.escapeAttribute = module.exports.escapeUTF8 = module.exports.escape = module.exports.encodeXML = module.exports.getCodePoint = module.exports.xmlReplacer = void 0;
module.exports.xmlReplacer = /["&'<>$\x80-\uFFFF]/g;
var $67b9d752bd430243$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
// For compatibility with node < 4, we wrap `codePointAt`
module.exports.getCodePoint = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? function(str, index) {
    return str.codePointAt(index);
} : function(c, index) {
    return (c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
};
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using XML entities.
 *
 * If a character has no equivalent entity, a
 * numeric hexadecimal reference (eg. `&#xfc;`) will be used.
 */ function $67b9d752bd430243$var$encodeXML(str) {
    var ret = "";
    var lastIdx = 0;
    var match;
    while((match = module.exports.xmlReplacer.exec(str)) !== null){
        var i = match.index;
        var char = str.charCodeAt(i);
        var next = $67b9d752bd430243$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += "".concat(str.substring(lastIdx, i), "&#x").concat((0, module.exports.getCodePoint)(str, i).toString(16), ";");
            // Increase by 1 if we have a surrogate pair
            lastIdx = module.exports.xmlReplacer.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
module.exports.encodeXML = $67b9d752bd430243$var$encodeXML;
/**
 * Encodes all non-ASCII characters, as well as characters not valid in XML
 * documents using numeric hexadecimal reference (eg. `&#xfc;`).
 *
 * Have a look at `escapeUTF8` if you want a more concise output at the expense
 * of reduced transportability.
 *
 * @param data String to escape.
 */ module.exports.escape = $67b9d752bd430243$var$encodeXML;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $67b9d752bd430243$var$getEscaper(regex, map) {
    return function escape(data) {
        var match;
        var lastIdx = 0;
        var result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
/**
 * Encodes all characters not valid in XML documents using XML entities.
 *
 * Note that the output will be character-set dependent.
 *
 * @param data String to escape.
 */ module.exports.escapeUTF8 = $67b9d752bd430243$var$getEscaper(/[&<>'"]/g, $67b9d752bd430243$var$xmlCodeMap);
/**
 * Encodes all characters that have to be escaped in HTML attributes,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeAttribute = $67b9d752bd430243$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
/**
 * Encodes all characters that have to be escaped in HTML text,
 * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
 *
 * @param data String to escape.
 */ module.exports.escapeText = $67b9d752bd430243$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});



parcelRegister("i4LPP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.attributeNames = module.exports.elementNames = void 0;
module.exports.elementNames = new Map([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "glyphRef",
    "linearGradient",
    "radialGradient",
    "textPath"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));
module.exports.attributeNames = new Map([
    "definitionURL",
    "attributeName",
    "attributeType",
    "baseFrequency",
    "baseProfile",
    "calcMode",
    "clipPathUnits",
    "diffuseConstant",
    "edgeMode",
    "filterUnits",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "kernelMatrix",
    "kernelUnitLength",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "limitingConeAngle",
    "markerHeight",
    "markerUnits",
    "markerWidth",
    "maskContentUnits",
    "maskUnits",
    "numOctaves",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "refX",
    "refY",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "specularConstant",
    "specularExponent",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stitchTiles",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textLength",
    "viewBox",
    "viewTarget",
    "xChannelSelector",
    "yChannelSelector",
    "zoomAndPan"
].map(function(val) {
    return [
        val.toLowerCase(),
        val
    ];
}));

});



parcelRegister("a1Ven", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prevElementSibling = module.exports.nextElementSibling = module.exports.getName = module.exports.hasAttrib = module.exports.getAttributeValue = module.exports.getSiblings = module.exports.getParent = module.exports.getChildren = void 0;

var $5MteQ = parcelRequire("5MteQ");
/**
 * Get a node's children.
 *
 * @category Traversal
 * @param elem Node to get the children of.
 * @returns `elem`'s children, or an empty array.
 */ function $74d6643d8b308e52$var$getChildren(elem) {
    return (0, $5MteQ.hasChildren)(elem) ? elem.children : [];
}
module.exports.getChildren = $74d6643d8b308e52$var$getChildren;
/**
 * Get a node's parent.
 *
 * @category Traversal
 * @param elem Node to get the parent of.
 * @returns `elem`'s parent node, or `null` if `elem` is a root node.
 */ function $74d6643d8b308e52$var$getParent(elem) {
    return elem.parent || null;
}
module.exports.getParent = $74d6643d8b308e52$var$getParent;
/**
 * Gets an elements siblings, including the element itself.
 *
 * Attempts to get the children through the element's parent first. If we don't
 * have a parent (the element is a root node), we walk the element's `prev` &
 * `next` to get all remaining nodes.
 *
 * @category Traversal
 * @param elem Element to get the siblings of.
 * @returns `elem`'s siblings, including `elem`.
 */ function $74d6643d8b308e52$var$getSiblings(elem) {
    var _a, _b;
    var parent = $74d6643d8b308e52$var$getParent(elem);
    if (parent != null) return $74d6643d8b308e52$var$getChildren(parent);
    var siblings = [
        elem
    ];
    var prev = elem.prev, next = elem.next;
    while(prev != null){
        siblings.unshift(prev);
        _a = prev, prev = _a.prev;
    }
    while(next != null){
        siblings.push(next);
        _b = next, next = _b.next;
    }
    return siblings;
}
module.exports.getSiblings = $74d6643d8b308e52$var$getSiblings;
/**
 * Gets an attribute from an element.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to retrieve.
 * @returns The element's attribute value, or `undefined`.
 */ function $74d6643d8b308e52$var$getAttributeValue(elem, name) {
    var _a;
    return (_a = elem.attribs) === null || _a === void 0 ? void 0 : _a[name];
}
module.exports.getAttributeValue = $74d6643d8b308e52$var$getAttributeValue;
/**
 * Checks whether an element has an attribute.
 *
 * @category Traversal
 * @param elem Element to check.
 * @param name Attribute name to look for.
 * @returns Returns whether `elem` has the attribute `name`.
 */ function $74d6643d8b308e52$var$hasAttrib(elem, name) {
    return elem.attribs != null && Object.prototype.hasOwnProperty.call(elem.attribs, name) && elem.attribs[name] != null;
}
module.exports.hasAttrib = $74d6643d8b308e52$var$hasAttrib;
/**
 * Get the tag name of an element.
 *
 * @category Traversal
 * @param elem The element to get the name for.
 * @returns The tag name of `elem`.
 */ function $74d6643d8b308e52$var$getName(elem) {
    return elem.name;
}
module.exports.getName = $74d6643d8b308e52$var$getName;
/**
 * Returns the next element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the next sibling of.
 * @returns `elem`'s next sibling that is a tag, or `null` if there is no next
 * sibling.
 */ function $74d6643d8b308e52$var$nextElementSibling(elem) {
    var _a;
    var next = elem.next;
    while(next !== null && !(0, $5MteQ.isTag)(next))_a = next, next = _a.next;
    return next;
}
module.exports.nextElementSibling = $74d6643d8b308e52$var$nextElementSibling;
/**
 * Returns the previous element sibling of a node.
 *
 * @category Traversal
 * @param elem The element to get the previous sibling of.
 * @returns `elem`'s previous sibling that is a tag, or `null` if there is no
 * previous sibling.
 */ function $74d6643d8b308e52$var$prevElementSibling(elem) {
    var _a;
    var prev = elem.prev;
    while(prev !== null && !(0, $5MteQ.isTag)(prev))_a = prev, prev = _a.prev;
    return prev;
}
module.exports.prevElementSibling = $74d6643d8b308e52$var$prevElementSibling;

});

parcelRegister("hUgLt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.prepend = module.exports.prependChild = module.exports.append = module.exports.appendChild = module.exports.replaceElement = module.exports.removeElement = void 0;
/**
 * Remove an element from the dom
 *
 * @category Manipulation
 * @param elem The element to be removed
 */ function $d094abc4f3fbe918$var$removeElement(elem) {
    if (elem.prev) elem.prev.next = elem.next;
    if (elem.next) elem.next.prev = elem.prev;
    if (elem.parent) {
        var childs = elem.parent.children;
        var childsIndex = childs.lastIndexOf(elem);
        if (childsIndex >= 0) childs.splice(childsIndex, 1);
    }
    elem.next = null;
    elem.prev = null;
    elem.parent = null;
}
module.exports.removeElement = $d094abc4f3fbe918$var$removeElement;
/**
 * Replace an element in the dom
 *
 * @category Manipulation
 * @param elem The element to be replaced
 * @param replacement The element to be added
 */ function $d094abc4f3fbe918$var$replaceElement(elem, replacement) {
    var prev = replacement.prev = elem.prev;
    if (prev) prev.next = replacement;
    var next = replacement.next = elem.next;
    if (next) next.prev = replacement;
    var parent = replacement.parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs[childs.lastIndexOf(elem)] = replacement;
        elem.parent = null;
    }
}
module.exports.replaceElement = $d094abc4f3fbe918$var$replaceElement;
/**
 * Append a child to an element.
 *
 * @category Manipulation
 * @param parent The element to append to.
 * @param child The element to be added as a child.
 */ function $d094abc4f3fbe918$var$appendChild(parent, child) {
    $d094abc4f3fbe918$var$removeElement(child);
    child.next = null;
    child.parent = parent;
    if (parent.children.push(child) > 1) {
        var sibling = parent.children[parent.children.length - 2];
        sibling.next = child;
        child.prev = sibling;
    } else child.prev = null;
}
module.exports.appendChild = $d094abc4f3fbe918$var$appendChild;
/**
 * Append an element after another.
 *
 * @category Manipulation
 * @param elem The element to append after.
 * @param next The element be added.
 */ function $d094abc4f3fbe918$var$append(elem, next) {
    $d094abc4f3fbe918$var$removeElement(next);
    var parent = elem.parent;
    var currNext = elem.next;
    next.next = currNext;
    next.prev = elem;
    elem.next = next;
    next.parent = parent;
    if (currNext) {
        currNext.prev = next;
        if (parent) {
            var childs = parent.children;
            childs.splice(childs.lastIndexOf(currNext), 0, next);
        }
    } else if (parent) parent.children.push(next);
}
module.exports.append = $d094abc4f3fbe918$var$append;
/**
 * Prepend a child to an element.
 *
 * @category Manipulation
 * @param parent The element to prepend before.
 * @param child The element to be added as a child.
 */ function $d094abc4f3fbe918$var$prependChild(parent, child) {
    $d094abc4f3fbe918$var$removeElement(child);
    child.parent = parent;
    child.prev = null;
    if (parent.children.unshift(child) !== 1) {
        var sibling = parent.children[1];
        sibling.prev = child;
        child.next = sibling;
    } else child.next = null;
}
module.exports.prependChild = $d094abc4f3fbe918$var$prependChild;
/**
 * Prepend an element before another.
 *
 * @category Manipulation
 * @param elem The element to prepend before.
 * @param prev The element be added.
 */ function $d094abc4f3fbe918$var$prepend(elem, prev) {
    $d094abc4f3fbe918$var$removeElement(prev);
    var parent = elem.parent;
    if (parent) {
        var childs = parent.children;
        childs.splice(childs.indexOf(elem), 0, prev);
    }
    if (elem.prev) elem.prev.next = prev;
    prev.parent = parent;
    prev.prev = elem.prev;
    prev.next = elem;
    elem.prev = prev;
}
module.exports.prepend = $d094abc4f3fbe918$var$prepend;

});

parcelRegister("2gVOA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findAll = module.exports.existsOne = module.exports.findOne = module.exports.findOneChild = module.exports.find = module.exports.filter = void 0;

var $5MteQ = parcelRequire("5MteQ");
/**
 * Search a node and its children for nodes passing a test function. If `node` is not an array, it will be wrapped in one.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param node Node to search. Will be included in the result set if it matches.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $1a79ec380a064842$var$filter(test, node, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return $1a79ec380a064842$var$find(test, Array.isArray(node) ? node : [
        node
    ], recurse, limit);
}
module.exports.filter = $1a79ec380a064842$var$filter;
/**
 * Search an array of nodes and their children for nodes passing a test function.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes passing `test`.
 */ function $1a79ec380a064842$var$find(test, nodes, recurse, limit) {
    var result = [];
    /** Stack of the arrays we are looking at. */ var nodeStack = [
        nodes
    ];
    /** Stack of the indices within the arrays. */ var indexStack = [
        0
    ];
    for(;;){
        // First, check if the current array has any more elements to look at.
        if (indexStack[0] >= nodeStack[0].length) {
            // If we have no more arrays to look at, we are done.
            if (indexStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (test(elem)) {
            result.push(elem);
            if (--limit <= 0) return result;
        }
        if (recurse && (0, $5MteQ.hasChildren)(elem) && elem.children.length > 0) {
            /*
             * Add the children to the stack. We are depth-first, so this is
             * the next array we look at.
             */ indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
module.exports.find = $1a79ec380a064842$var$find;
/**
 * Finds the first element inside of an array that matches a test function. This is an alias for `Array.prototype.find`.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns The first node in the array that passes `test`.
 * @deprecated Use `Array.prototype.find` directly.
 */ function $1a79ec380a064842$var$findOneChild(test, nodes) {
    return nodes.find(test);
}
module.exports.findOneChild = $1a79ec380a064842$var$findOneChild;
/**
 * Finds one element in a tree that passes a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Node or array of nodes to search.
 * @param recurse Also consider child nodes.
 * @returns The first node that passes `test`.
 */ function $1a79ec380a064842$var$findOne(test, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    var elem = null;
    for(var i = 0; i < nodes.length && !elem; i++){
        var node = nodes[i];
        if (!(0, $5MteQ.isTag)(node)) continue;
        else if (test(node)) elem = node;
        else if (recurse && node.children.length > 0) elem = $1a79ec380a064842$var$findOne(test, node.children, true);
    }
    return elem;
}
module.exports.findOne = $1a79ec380a064842$var$findOne;
/**
 * Checks if a tree of nodes contains at least one node passing a test.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns Whether a tree of nodes contains at least one node passing the test.
 */ function $1a79ec380a064842$var$existsOne(test, nodes) {
    return nodes.some(function(checked) {
        return (0, $5MteQ.isTag)(checked) && (test(checked) || $1a79ec380a064842$var$existsOne(test, checked.children));
    });
}
module.exports.existsOne = $1a79ec380a064842$var$existsOne;
/**
 * Search an array of nodes and their children for elements passing a test function.
 *
 * Same as `find`, but limited to elements and with less options, leading to reduced complexity.
 *
 * @category Querying
 * @param test Function to test nodes on.
 * @param nodes Array of nodes to search.
 * @returns All nodes passing `test`.
 */ function $1a79ec380a064842$var$findAll(test, nodes) {
    var result = [];
    var nodeStack = [
        nodes
    ];
    var indexStack = [
        0
    ];
    for(;;){
        if (indexStack[0] >= nodeStack[0].length) {
            if (nodeStack.length === 1) return result;
            // Otherwise, remove the current array from the stack.
            nodeStack.shift();
            indexStack.shift();
            continue;
        }
        var elem = nodeStack[0][indexStack[0]++];
        if (!(0, $5MteQ.isTag)(elem)) continue;
        if (test(elem)) result.push(elem);
        if (elem.children.length > 0) {
            indexStack.unshift(0);
            nodeStack.unshift(elem.children);
        }
    }
}
module.exports.findAll = $1a79ec380a064842$var$findAll;

});

parcelRegister("lM13u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getElementsByTagType = module.exports.getElementsByTagName = module.exports.getElementById = module.exports.getElements = module.exports.testElement = void 0;

var $5MteQ = parcelRequire("5MteQ");

var $2gVOA = parcelRequire("2gVOA");
/**
 * A map of functions to check nodes against.
 */ var $fd9ee638e63ac16f$var$Checks = {
    tag_name: function(name) {
        if (typeof name === "function") return function(elem) {
            return (0, $5MteQ.isTag)(elem) && name(elem.name);
        };
        else if (name === "*") return $5MteQ.isTag;
        return function(elem) {
            return (0, $5MteQ.isTag)(elem) && elem.name === name;
        };
    },
    tag_type: function(type) {
        if (typeof type === "function") return function(elem) {
            return type(elem.type);
        };
        return function(elem) {
            return elem.type === type;
        };
    },
    tag_contains: function(data) {
        if (typeof data === "function") return function(elem) {
            return (0, $5MteQ.isText)(elem) && data(elem.data);
        };
        return function(elem) {
            return (0, $5MteQ.isText)(elem) && elem.data === data;
        };
    }
};
/**
 * Returns a function to check whether a node has an attribute with a particular
 * value.
 *
 * @param attrib Attribute to check.
 * @param value Attribute value to look for.
 * @returns A function to check whether the a node has an attribute with a
 *   particular value.
 */ function $fd9ee638e63ac16f$var$getAttribCheck(attrib, value) {
    if (typeof value === "function") return function(elem) {
        return (0, $5MteQ.isTag)(elem) && value(elem.attribs[attrib]);
    };
    return function(elem) {
        return (0, $5MteQ.isTag)(elem) && elem.attribs[attrib] === value;
    };
}
/**
 * Returns a function that returns `true` if either of the input functions
 * returns `true` for a node.
 *
 * @param a First function to combine.
 * @param b Second function to combine.
 * @returns A function taking a node and returning `true` if either of the input
 *   functions returns `true` for the node.
 */ function $fd9ee638e63ac16f$var$combineFuncs(a, b) {
    return function(elem) {
        return a(elem) || b(elem);
    };
}
/**
 * Returns a function that executes all checks in `options` and returns `true`
 * if any of them match a node.
 *
 * @param options An object describing nodes to look for.
 * @returns A function that executes all checks in `options` and returns `true`
 *   if any of them match a node.
 */ function $fd9ee638e63ac16f$var$compileTest(options) {
    var funcs = Object.keys(options).map(function(key) {
        var value = options[key];
        return Object.prototype.hasOwnProperty.call($fd9ee638e63ac16f$var$Checks, key) ? $fd9ee638e63ac16f$var$Checks[key](value) : $fd9ee638e63ac16f$var$getAttribCheck(key, value);
    });
    return funcs.length === 0 ? null : funcs.reduce($fd9ee638e63ac16f$var$combineFuncs);
}
/**
 * Checks whether a node matches the description in `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param node The element to test.
 * @returns Whether the element matches the description in `options`.
 */ function $fd9ee638e63ac16f$var$testElement(options, node) {
    var test = $fd9ee638e63ac16f$var$compileTest(options);
    return test ? test(node) : true;
}
module.exports.testElement = $fd9ee638e63ac16f$var$testElement;
/**
 * Returns all nodes that match `options`.
 *
 * @category Legacy Query Functions
 * @param options An object describing nodes to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes that match `options`.
 */ function $fd9ee638e63ac16f$var$getElements(options, nodes, recurse, limit) {
    if (limit === void 0) limit = Infinity;
    var test = $fd9ee638e63ac16f$var$compileTest(options);
    return test ? (0, $2gVOA.filter)(test, nodes, recurse, limit) : [];
}
module.exports.getElements = $fd9ee638e63ac16f$var$getElements;
/**
 * Returns the node with the supplied ID.
 *
 * @category Legacy Query Functions
 * @param id The unique ID attribute value to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @returns The node with the supplied ID.
 */ function $fd9ee638e63ac16f$var$getElementById(id, nodes, recurse) {
    if (recurse === void 0) recurse = true;
    if (!Array.isArray(nodes)) nodes = [
        nodes
    ];
    return (0, $2gVOA.findOne)($fd9ee638e63ac16f$var$getAttribCheck("id", id), nodes, recurse);
}
module.exports.getElementById = $fd9ee638e63ac16f$var$getElementById;
/**
 * Returns all nodes with the supplied `tagName`.
 *
 * @category Legacy Query Functions
 * @param tagName Tag name to search for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `tagName`.
 */ function $fd9ee638e63ac16f$var$getElementsByTagName(tagName, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $2gVOA.filter)($fd9ee638e63ac16f$var$Checks["tag_name"](tagName), nodes, recurse, limit);
}
module.exports.getElementsByTagName = $fd9ee638e63ac16f$var$getElementsByTagName;
/**
 * Returns all nodes with the supplied `type`.
 *
 * @category Legacy Query Functions
 * @param type Element type to look for.
 * @param nodes Nodes to search through.
 * @param recurse Also consider child nodes.
 * @param limit Maximum number of nodes to return.
 * @returns All nodes with the supplied `type`.
 */ function $fd9ee638e63ac16f$var$getElementsByTagType(type, nodes, recurse, limit) {
    if (recurse === void 0) recurse = true;
    if (limit === void 0) limit = Infinity;
    return (0, $2gVOA.filter)($fd9ee638e63ac16f$var$Checks["tag_type"](type), nodes, recurse, limit);
}
module.exports.getElementsByTagType = $fd9ee638e63ac16f$var$getElementsByTagType;

});

parcelRegister("lTMuX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.uniqueSort = module.exports.compareDocumentPosition = module.exports.DocumentPosition = module.exports.removeSubsets = void 0;

var $5MteQ = parcelRequire("5MteQ");
/**
 * Given an array of nodes, remove any member that is contained by another
 * member.
 *
 * @category Helpers
 * @param nodes Nodes to filter.
 * @returns Remaining nodes that aren't contained by other nodes.
 */ function $ff145acc6f345c33$var$removeSubsets(nodes) {
    var idx = nodes.length;
    /*
     * Check if each node (or one of its ancestors) is already contained in the
     * array.
     */ while(--idx >= 0){
        var node = nodes[idx];
        /*
         * Remove the node if it is not unique.
         * We are going through the array from the end, so we only
         * have to check nodes that preceed the node under consideration in the array.
         */ if (idx > 0 && nodes.lastIndexOf(node, idx - 1) >= 0) {
            nodes.splice(idx, 1);
            continue;
        }
        for(var ancestor = node.parent; ancestor; ancestor = ancestor.parent)if (nodes.includes(ancestor)) {
            nodes.splice(idx, 1);
            break;
        }
    }
    return nodes;
}
module.exports.removeSubsets = $ff145acc6f345c33$var$removeSubsets;
/**
 * @category Helpers
 * @see {@link http://dom.spec.whatwg.org/#dom-node-comparedocumentposition}
 */ var $ff145acc6f345c33$var$DocumentPosition;
(function(DocumentPosition) {
    DocumentPosition[DocumentPosition["DISCONNECTED"] = 1] = "DISCONNECTED";
    DocumentPosition[DocumentPosition["PRECEDING"] = 2] = "PRECEDING";
    DocumentPosition[DocumentPosition["FOLLOWING"] = 4] = "FOLLOWING";
    DocumentPosition[DocumentPosition["CONTAINS"] = 8] = "CONTAINS";
    DocumentPosition[DocumentPosition["CONTAINED_BY"] = 16] = "CONTAINED_BY";
})($ff145acc6f345c33$var$DocumentPosition = module.exports.DocumentPosition || (module.exports.DocumentPosition = {}));
/**
 * Compare the position of one node against another node in any other document,
 * returning a bitmask with the values from {@link DocumentPosition}.
 *
 * Document order:
 * > There is an ordering, document order, defined on all the nodes in the
 * > document corresponding to the order in which the first character of the
 * > XML representation of each node occurs in the XML representation of the
 * > document after expansion of general entities. Thus, the document element
 * > node will be the first node. Element nodes occur before their children.
 * > Thus, document order orders element nodes in order of the occurrence of
 * > their start-tag in the XML (after expansion of entities). The attribute
 * > nodes of an element occur after the element and before its children. The
 * > relative order of attribute nodes is implementation-dependent.
 *
 * Source:
 * http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
 *
 * @category Helpers
 * @param nodeA The first node to use in the comparison
 * @param nodeB The second node to use in the comparison
 * @returns A bitmask describing the input nodes' relative position.
 *
 * See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
 * a description of these values.
 */ function $ff145acc6f345c33$var$compareDocumentPosition(nodeA, nodeB) {
    var aParents = [];
    var bParents = [];
    if (nodeA === nodeB) return 0;
    var current = (0, $5MteQ.hasChildren)(nodeA) ? nodeA : nodeA.parent;
    while(current){
        aParents.unshift(current);
        current = current.parent;
    }
    current = (0, $5MteQ.hasChildren)(nodeB) ? nodeB : nodeB.parent;
    while(current){
        bParents.unshift(current);
        current = current.parent;
    }
    var maxIdx = Math.min(aParents.length, bParents.length);
    var idx = 0;
    while(idx < maxIdx && aParents[idx] === bParents[idx])idx++;
    if (idx === 0) return $ff145acc6f345c33$var$DocumentPosition.DISCONNECTED;
    var sharedParent = aParents[idx - 1];
    var siblings = sharedParent.children;
    var aSibling = aParents[idx];
    var bSibling = bParents[idx];
    if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
        if (sharedParent === nodeB) return $ff145acc6f345c33$var$DocumentPosition.FOLLOWING | $ff145acc6f345c33$var$DocumentPosition.CONTAINED_BY;
        return $ff145acc6f345c33$var$DocumentPosition.FOLLOWING;
    }
    if (sharedParent === nodeA) return $ff145acc6f345c33$var$DocumentPosition.PRECEDING | $ff145acc6f345c33$var$DocumentPosition.CONTAINS;
    return $ff145acc6f345c33$var$DocumentPosition.PRECEDING;
}
module.exports.compareDocumentPosition = $ff145acc6f345c33$var$compareDocumentPosition;
/**
 * Sort an array of nodes based on their relative position in the document,
 * removing any duplicate nodes. If the array contains nodes that do not belong
 * to the same document, sort order is unspecified.
 *
 * @category Helpers
 * @param nodes Array of DOM nodes.
 * @returns Collection of unique nodes, sorted in document order.
 */ function $ff145acc6f345c33$var$uniqueSort(nodes) {
    nodes = nodes.filter(function(node, i, arr) {
        return !arr.includes(node, i + 1);
    });
    nodes.sort(function(a, b) {
        var relative = $ff145acc6f345c33$var$compareDocumentPosition(a, b);
        if (relative & $ff145acc6f345c33$var$DocumentPosition.PRECEDING) return -1;
        else if (relative & $ff145acc6f345c33$var$DocumentPosition.FOLLOWING) return 1;
        return 0;
    });
    return nodes;
}
module.exports.uniqueSort = $ff145acc6f345c33$var$uniqueSort;

});

parcelRegister("e6I1o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getFeed = void 0;

var $gOX3U = parcelRequire("gOX3U");

var $lM13u = parcelRequire("lM13u");
/**
 * Get the feed object from the root of a DOM tree.
 *
 * @category Feeds
 * @param doc - The DOM to to extract the feed from.
 * @returns The feed.
 */ function $a453c5fa9d6a7575$var$getFeed(doc) {
    var feedRoot = $a453c5fa9d6a7575$var$getOneElement($a453c5fa9d6a7575$var$isValidFeed, doc);
    return !feedRoot ? null : feedRoot.name === "feed" ? $a453c5fa9d6a7575$var$getAtomFeed(feedRoot) : $a453c5fa9d6a7575$var$getRssFeed(feedRoot);
}
module.exports.getFeed = $a453c5fa9d6a7575$var$getFeed;
/**
 * Parse an Atom feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $a453c5fa9d6a7575$var$getAtomFeed(feedRoot) {
    var _a;
    var childs = feedRoot.children;
    var feed = {
        type: "atom",
        items: (0, $lM13u.getElementsByTagName)("entry", childs).map(function(item) {
            var _a;
            var children = item.children;
            var entry = {
                media: $a453c5fa9d6a7575$var$getMediaElements(children)
            };
            $a453c5fa9d6a7575$var$addConditionally(entry, "id", "id", children);
            $a453c5fa9d6a7575$var$addConditionally(entry, "title", "title", children);
            var href = (_a = $a453c5fa9d6a7575$var$getOneElement("link", children)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
            if (href) entry.link = href;
            var description = $a453c5fa9d6a7575$var$fetch("summary", children) || $a453c5fa9d6a7575$var$fetch("content", children);
            if (description) entry.description = description;
            var pubDate = $a453c5fa9d6a7575$var$fetch("updated", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $a453c5fa9d6a7575$var$addConditionally(feed, "id", "id", childs);
    $a453c5fa9d6a7575$var$addConditionally(feed, "title", "title", childs);
    var href = (_a = $a453c5fa9d6a7575$var$getOneElement("link", childs)) === null || _a === void 0 ? void 0 : _a.attribs["href"];
    if (href) feed.link = href;
    $a453c5fa9d6a7575$var$addConditionally(feed, "description", "subtitle", childs);
    var updated = $a453c5fa9d6a7575$var$fetch("updated", childs);
    if (updated) feed.updated = new Date(updated);
    $a453c5fa9d6a7575$var$addConditionally(feed, "author", "email", childs, true);
    return feed;
}
/**
 * Parse a RSS feed.
 *
 * @param feedRoot The root of the feed.
 * @returns The parsed feed.
 */ function $a453c5fa9d6a7575$var$getRssFeed(feedRoot) {
    var _a, _b;
    var childs = (_b = (_a = $a453c5fa9d6a7575$var$getOneElement("channel", feedRoot.children)) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : [];
    var feed = {
        type: feedRoot.name.substr(0, 3),
        id: "",
        items: (0, $lM13u.getElementsByTagName)("item", feedRoot.children).map(function(item) {
            var children = item.children;
            var entry = {
                media: $a453c5fa9d6a7575$var$getMediaElements(children)
            };
            $a453c5fa9d6a7575$var$addConditionally(entry, "id", "guid", children);
            $a453c5fa9d6a7575$var$addConditionally(entry, "title", "title", children);
            $a453c5fa9d6a7575$var$addConditionally(entry, "link", "link", children);
            $a453c5fa9d6a7575$var$addConditionally(entry, "description", "description", children);
            var pubDate = $a453c5fa9d6a7575$var$fetch("pubDate", children) || $a453c5fa9d6a7575$var$fetch("dc:date", children);
            if (pubDate) entry.pubDate = new Date(pubDate);
            return entry;
        })
    };
    $a453c5fa9d6a7575$var$addConditionally(feed, "title", "title", childs);
    $a453c5fa9d6a7575$var$addConditionally(feed, "link", "link", childs);
    $a453c5fa9d6a7575$var$addConditionally(feed, "description", "description", childs);
    var updated = $a453c5fa9d6a7575$var$fetch("lastBuildDate", childs);
    if (updated) feed.updated = new Date(updated);
    $a453c5fa9d6a7575$var$addConditionally(feed, "author", "managingEditor", childs, true);
    return feed;
}
var $a453c5fa9d6a7575$var$MEDIA_KEYS_STRING = [
    "url",
    "type",
    "lang"
];
var $a453c5fa9d6a7575$var$MEDIA_KEYS_INT = [
    "fileSize",
    "bitrate",
    "framerate",
    "samplingrate",
    "channels",
    "duration",
    "height",
    "width"
];
/**
 * Get all media elements of a feed item.
 *
 * @param where Nodes to search in.
 * @returns Media elements.
 */ function $a453c5fa9d6a7575$var$getMediaElements(where) {
    return (0, $lM13u.getElementsByTagName)("media:content", where).map(function(elem) {
        var attribs = elem.attribs;
        var media = {
            medium: attribs["medium"],
            isDefault: !!attribs["isDefault"]
        };
        for(var _i = 0, MEDIA_KEYS_STRING_1 = $a453c5fa9d6a7575$var$MEDIA_KEYS_STRING; _i < MEDIA_KEYS_STRING_1.length; _i++){
            var attrib = MEDIA_KEYS_STRING_1[_i];
            if (attribs[attrib]) media[attrib] = attribs[attrib];
        }
        for(var _a = 0, MEDIA_KEYS_INT_1 = $a453c5fa9d6a7575$var$MEDIA_KEYS_INT; _a < MEDIA_KEYS_INT_1.length; _a++){
            var attrib = MEDIA_KEYS_INT_1[_a];
            if (attribs[attrib]) media[attrib] = parseInt(attribs[attrib], 10);
        }
        if (attribs["expression"]) media.expression = attribs["expression"];
        return media;
    });
}
/**
 * Get one element by tag name.
 *
 * @param tagName Tag name to look for
 * @param node Node to search in
 * @returns The element or null
 */ function $a453c5fa9d6a7575$var$getOneElement(tagName, node) {
    return (0, $lM13u.getElementsByTagName)(tagName, node, true, 1)[0];
}
/**
 * Get the text content of an element with a certain tag name.
 *
 * @param tagName Tag name to look for.
 * @param where Node to search in.
 * @param recurse Whether to recurse into child nodes.
 * @returns The text content of the element.
 */ function $a453c5fa9d6a7575$var$fetch(tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    return (0, $gOX3U.textContent)((0, $lM13u.getElementsByTagName)(tagName, where, recurse, 1)).trim();
}
/**
 * Adds a property to an object if it has a value.
 *
 * @param obj Object to be extended
 * @param prop Property name
 * @param tagName Tag name that contains the conditionally added property
 * @param where Element to search for the property
 * @param recurse Whether to recurse into child nodes.
 */ function $a453c5fa9d6a7575$var$addConditionally(obj, prop, tagName, where, recurse) {
    if (recurse === void 0) recurse = false;
    var val = $a453c5fa9d6a7575$var$fetch(tagName, where, recurse);
    if (val) obj[prop] = val;
}
/**
 * Checks if an element is a feed root node.
 *
 * @param value The name of the element to check.
 * @returns Whether an element is a feed root node.
 */ function $a453c5fa9d6a7575$var$isValidFeed(value) {
    return value === "rss" || value === "feed" || value === "rdf:RDF";
}

});


parcelRegister("5GZK9", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(""));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join("");
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join("");
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === "function" && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== "undefined" && angular != null) angular.module("LZString", []).factory("LZString", function() {
    return LZString;
});

});

parcelRegister("jxLBU", function(module, exports) {

$parcel$export(module.exports, "fg", function () { return $e3a607d5f614bf84$export$b40ec24ac8275656; });

var $ebIVQ = parcelRequire("ebIVQ");
function $e3a607d5f614bf84$export$ba05d765b8392e5e(flagResolver) {
    (0, $ebIVQ.setBooleanResolver)(flagResolver);
}
function $e3a607d5f614bf84$export$470e5c2be1411c89(name) {
    return (0, $ebIVQ.resolveBooleanFlag)(name);
}
function $e3a607d5f614bf84$export$b40ec24ac8275656(name) {
    return (0, $ebIVQ.resolveBooleanFlag)(name);
}

});
parcelRegister("ebIVQ", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $a544f25077142c31$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $a544f25077142c31$export$6333b6aff9fc6275; });

var $4LHd8 = parcelRequire("4LHd8");

var $2n3z5 = parcelRequire("2n3z5");

var $XAEGR = parcelRequire("XAEGR");
var $a544f25077142c31$var$pkgName = "@atlaskit/platform-feature-flags";
var $a544f25077142c31$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $a544f25077142c31$var$hasProcessEnv = typeof $XAEGR !== "undefined" && typeof $XAEGR.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $a544f25077142c31$var$ENV_ENABLE_PLATFORM_FF = $a544f25077142c31$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $a544f25077142c31$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $a544f25077142c31$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $a544f25077142c31$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $a544f25077142c31$var$ENV_ENABLE_PLATFORM_FF || $a544f25077142c31$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $a544f25077142c31$var$DEFAULT_PFF_GLOBAL = {
    booleanResolver: undefined
};
var $a544f25077142c31$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98] = $a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98] || $a544f25077142c31$var$DEFAULT_PFF_GLOBAL;
function $a544f25077142c31$export$f2b591175b3e424c(resolver) {
    $a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98].booleanResolver = resolver;
}
function $a544f25077142c31$export$6333b6aff9fc6275(flagKey) {
    if ($a544f25077142c31$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $2n3z5.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $a544f25077142c31$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL, _globalVar$PFF_GLOBAL2, _globalVar$PFF_GLOBAL3;
        // booleanResolver will be empty for products like Trello, Elevate, Recruit etc.
        // Currently only Confluence, Jira and Bitbucket has set it.
        if (((_globalVar$PFF_GLOBAL = $a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL === void 0 ? void 0 : _globalVar$PFF_GLOBAL.booleanResolver) === undefined || ((_globalVar$PFF_GLOBAL2 = $a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver) === null) // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        return (0, $4LHd8.default).checkGate(flagKey);
        var result = (_globalVar$PFF_GLOBAL3 = $a544f25077142c31$var$globalVar[$a544f25077142c31$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL3 === void 0 ? void 0 : _globalVar$PFF_GLOBAL3.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("4LHd8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $378d12014204ce62$export$2e2bcd8739ae039; });

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $014mj = parcelRequire("014mj");

var $gsDN3 = parcelRequire("gsDN3");

var $iTMFz = parcelRequire("iTMFz");



var $6GwB3 = parcelRequire("6GwB3");
var $378d12014204ce62$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $378d12014204ce62$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $VVGAy.default)(this, FeatureGates);
    }
    return (0, $b5cej.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$378d12014204ce62$var$_FeatureGates = $378d12014204ce62$var$FeatureGates;
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "client", new (0, $gsDN3.Client)());
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$378d12014204ce62$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $378d12014204ce62$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $378d12014204ce62$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$378d12014204ce62$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $378d12014204ce62$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $378d12014204ce62$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "initializeCalled", $378d12014204ce62$var$_FeatureGates.client.initializeCalled.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "initializeCompleted", $378d12014204ce62$var$_FeatureGates.client.initializeCompleted.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "initialize", $378d12014204ce62$var$_FeatureGates.client.initialize.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "initializeWithProvider", $378d12014204ce62$var$_FeatureGates.client.initializeWithProvider.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "initializeFromValues", $378d12014204ce62$var$_FeatureGates.client.initializeFromValues.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "manuallyLogGateExposure", $378d12014204ce62$var$_FeatureGates.client.manuallyLogGateExposure.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getExperiment", $378d12014204ce62$var$_FeatureGates.client.getExperiment.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "manuallyLogExperimentExposure", $378d12014204ce62$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "manuallyLogLayerExposure", $378d12014204ce62$var$_FeatureGates.client.manuallyLogLayerExposure.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "shutdownStatsig", $378d12014204ce62$var$_FeatureGates.client.shutdownStatsig.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "overrideGate", $378d12014204ce62$var$_FeatureGates.client.overrideGate.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "clearGateOverride", $378d12014204ce62$var$_FeatureGates.client.clearGateOverride.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "overrideConfig", $378d12014204ce62$var$_FeatureGates.client.overrideConfig.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "clearConfigOverride", $378d12014204ce62$var$_FeatureGates.client.clearConfigOverride.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "setOverrides", $378d12014204ce62$var$_FeatureGates.client.setOverrides.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getOverrides", $378d12014204ce62$var$_FeatureGates.client.getOverrides.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "clearAllOverrides", $378d12014204ce62$var$_FeatureGates.client.clearAllOverrides.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "isCurrentUser", $378d12014204ce62$var$_FeatureGates.client.isCurrentUser.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "onGateUpdated", $378d12014204ce62$var$_FeatureGates.client.onGateUpdated.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "onExperimentValueUpdated", $378d12014204ce62$var$_FeatureGates.client.onExperimentValueUpdated.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "onAnyUpdated", $378d12014204ce62$var$_FeatureGates.client.onAnyUpdated.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "updateUser", $378d12014204ce62$var$_FeatureGates.client.updateUser.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "updateUserWithProvider", $378d12014204ce62$var$_FeatureGates.client.updateUserWithProvider.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "updateUserWithValues", $378d12014204ce62$var$_FeatureGates.client.updateUserWithValues.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getPackageVersion", $378d12014204ce62$var$_FeatureGates.client.getPackageVersion.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getLayer", $378d12014204ce62$var$_FeatureGates.client.getLayer.bind($378d12014204ce62$var$_FeatureGates.client));
(0, $014mj.default)($378d12014204ce62$var$FeatureGates, "getLayerValue", $378d12014204ce62$var$_FeatureGates.client.getLayerValue.bind($378d12014204ce62$var$_FeatureGates.client));
var $378d12014204ce62$var$boundFGJS = $378d12014204ce62$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $378d12014204ce62$var$FeatureGates;
    else {
        var $378d12014204ce62$var$_boundFGJS, $378d12014204ce62$var$_boundFGJS$getPackage;
        $378d12014204ce62$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $378d12014204ce62$var$boundVersion = (($378d12014204ce62$var$_boundFGJS = $378d12014204ce62$var$boundFGJS) === null || $378d12014204ce62$var$_boundFGJS === void 0 || ($378d12014204ce62$var$_boundFGJS$getPackage = $378d12014204ce62$var$_boundFGJS.getPackageVersion) === null || $378d12014204ce62$var$_boundFGJS$getPackage === void 0 ? void 0 : $378d12014204ce62$var$_boundFGJS$getPackage.call($378d12014204ce62$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($378d12014204ce62$var$boundVersion !== (0, $iTMFz.CLIENT_VERSION)) {
            var $378d12014204ce62$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($378d12014204ce62$var$boundVersion, " when module version ").concat((0, $iTMFz.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($378d12014204ce62$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $378d12014204ce62$export$2e2bcd8739ae039 = $378d12014204ce62$var$boundFGJS;

});
parcelRegister("VVGAy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0ae21234f6dc3122$export$2e2bcd8739ae039; });
function $0ae21234f6dc3122$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("b5cej", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8119a5f478517b55$export$2e2bcd8739ae039; });

var $jszjU = parcelRequire("jszjU");
function $8119a5f478517b55$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $jszjU.default)(o.key), o);
    }
}
function $8119a5f478517b55$export$2e2bcd8739ae039(e, r, t) {
    return r && $8119a5f478517b55$var$_defineProperties(e.prototype, r), t && $8119a5f478517b55$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("jszjU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2ac07b4e3e37be4$export$2e2bcd8739ae039; });

var $asHcB = parcelRequire("asHcB");

var $4Bywo = parcelRequire("4Bywo");
function $e2ac07b4e3e37be4$export$2e2bcd8739ae039(t) {
    var i = (0, $4Bywo.default)(t, "string");
    return "symbol" == (0, $asHcB.default)(i) ? i : i + "";
}

});
parcelRegister("asHcB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79de07fb69918763$export$2e2bcd8739ae039; });
function $79de07fb69918763$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $79de07fb69918763$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $79de07fb69918763$export$2e2bcd8739ae039(o);
}

});

parcelRegister("4Bywo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35a565631e1dfc68$export$2e2bcd8739ae039; });

var $asHcB = parcelRequire("asHcB");
function $35a565631e1dfc68$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $asHcB.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $asHcB.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("014mj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $003379b661dd405e$export$2e2bcd8739ae039; });

var $jszjU = parcelRequire("jszjU");
function $003379b661dd405e$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jszjU.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("gsDN3", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $bfbe206489dee589$export$1f2bb630327ac4b6; });

var $g3yJ1 = parcelRequire("g3yJ1");

var $lQw4F = parcelRequire("lQw4F");

var $fZvJe = parcelRequire("fZvJe");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $014mj = parcelRequire("014mj");

var $6Xz9e = parcelRequire("6Xz9e");

var $7rvfj = parcelRequire("7rvfj");

var $4yxkK = parcelRequire("4yxkK");

var $fo7wp = parcelRequire("fo7wp");

var $abpnl = parcelRequire("abpnl");

var $56jWI = parcelRequire("56jWI");

var $9A1qQ = parcelRequire("9A1qQ");

var $93Utk = parcelRequire("93Utk");

var $gl6dF = parcelRequire("gl6dF");

var $6GwB3 = parcelRequire("6GwB3");

var $6ucNk = parcelRequire("6ucNk");

var $iTMFz = parcelRequire("iTMFz");
var $bfbe206489dee589$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $bfbe206489dee589$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bfbe206489dee589$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bfbe206489dee589$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bfbe206489dee589$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bfbe206489dee589$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $bfbe206489dee589$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $bfbe206489dee589$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $gl6dF.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, $VVGAy.default)(this, Client);
        (0, $014mj.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $014mj.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $014mj.default)(this, "initWithDefaults", false);
        (0, $014mj.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $014mj.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $014mj.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $014mj.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $014mj.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $014mj.default)(this, "subscriptions", new (0, $4yxkK.default)());
        (0, $014mj.default)(this, "dataAdapter", new (0, $93Utk.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $014mj.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $gl6dF.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $b5cej.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $6ucNk.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $6ucNk.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $6ucNk.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $6ucNk.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $iTMFz.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $bfbe206489dee589$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $iTMFz.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $6GwB3.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $6ucNk.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $6ucNk.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $6ucNk.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $9A1qQ.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $fo7wp.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $fo7wp.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $56jWI.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $6ucNk.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $6ucNk.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $bfbe206489dee589$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $9A1qQ.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $9A1qQ.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $lQw4F.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $bfbe206489dee589$var$_objectSpread($bfbe206489dee589$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $lQw4F.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $6ucNk.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $bfbe206489dee589$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $bfbe206489dee589$var$_objectSpread($bfbe206489dee589$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $bfbe206489dee589$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $6GwB3.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $g3yJ1.default)(newClientOptions, $bfbe206489dee589$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $6ucNk.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $bfbe206489dee589$var$_objectSpread($bfbe206489dee589$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $7rvfj.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $7rvfj.StatsigClient)($bfbe206489dee589$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $6ucNk.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $iTMFz.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $abpnl.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $abpnl.Layer).fromLayer((0, $7rvfj._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("g3yJ1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb07dcd910874627$export$2e2bcd8739ae039; });

var $3PVQE = parcelRequire("3PVQE");
function $bb07dcd910874627$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $3PVQE.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("3PVQE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2cb301f1a0b95ca0$export$2e2bcd8739ae039; });
function $2cb301f1a0b95ca0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lQw4F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe775592915d7ca5$export$2e2bcd8739ae039; });

var $eDD6X = parcelRequire("eDD6X");

var $5jUD8 = parcelRequire("5jUD8");

var $cMNmC = parcelRequire("cMNmC");

var $fn29v = parcelRequire("fn29v");
function $fe775592915d7ca5$export$2e2bcd8739ae039(r, e) {
    return (0, $eDD6X.default)(r) || (0, $5jUD8.default)(r, e) || (0, $cMNmC.default)(r, e) || (0, $fn29v.default)();
}

});
parcelRegister("eDD6X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa830be2895ee3ed$export$2e2bcd8739ae039; });
function $aa830be2895ee3ed$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("5jUD8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3dfaa7af21c5257a$export$2e2bcd8739ae039; });
function $3dfaa7af21c5257a$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("cMNmC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94f0425a4f941f72$export$2e2bcd8739ae039; });

var $ibCtm = parcelRequire("ibCtm");
function $94f0425a4f941f72$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $ibCtm.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $ibCtm.default)(r, a) : void 0;
    }
}

});
parcelRegister("ibCtm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d3d718e7e01434c3$export$2e2bcd8739ae039; });
function $d3d718e7e01434c3$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fn29v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30aac6c9380ca26$export$2e2bcd8739ae039; });
function $b30aac6c9380ca26$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fZvJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba452a25c96d4bca$export$2e2bcd8739ae039; });
function $ba452a25c96d4bca$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $ba452a25c96d4bca$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $ba452a25c96d4bca$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $ba452a25c96d4bca$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("6Xz9e", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $511384617b7e3169$var$runtime = (parcelRequire("iTUJK"))();
module.exports = $511384617b7e3169$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $511384617b7e3169$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $511384617b7e3169$var$runtime;
    else Function("r", "regeneratorRuntime = r")($511384617b7e3169$var$runtime);
}

});

parcelRegister("7rvfj", function(module, exports) {
"use strict";
var $56b34ad49c781519$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $56b34ad49c781519$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $56b34ad49c781519$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $paiCR = parcelRequire("paiCR");
module.exports.StatsigClient = $paiCR.default;

$56b34ad49c781519$var$__exportStar((parcelRequire("3JARs")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $paiCR.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("paiCR", function(module, exports) {
"use strict";
var $04ba5329cd56096d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3JARs = parcelRequire("3JARs");

var $kACaT = parcelRequire("kACaT");

var $b9OHF = parcelRequire("b9OHF");

var $iFLyc = parcelRequire("iFLyc");

var $luvC7 = parcelRequire("luvC7");
class $04ba5329cd56096d$var$StatsigClient extends $3JARs.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $3JARs._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $04ba5329cd56096d$var$StatsigClient) return instance;
        $3JARs.Log.warn((0, $3JARs._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $04ba5329cd56096d$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $3JARs.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $b9OHF.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $luvC7.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($3JARs.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($3JARs.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($3JARs.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($3JARs.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($3JARs.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $kACaT.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $3JARs.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $04ba5329cd56096d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $3JARs.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $3JARs.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $04ba5329cd56096d$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $3JARs.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $3JARs.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $3JARs.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $3JARs.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($3JARs.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $3JARs.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $3JARs.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $3JARs.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $3JARs.StatsigSession.get(this._sdkKey),
            stableID: $3JARs.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $04ba5329cd56096d$var$__awaiter(this, void 0, void 0, function*() {
            if (!$3JARs.Storage.isReady()) yield $3JARs.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $3JARs.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $3JARs._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $3JARs.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $3JARs._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $3JARs._createGateExposure)(this._user, result), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $3JARs._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $3JARs._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $3JARs._makeExperiment)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getExperimentOverride) === null || _b === void 0 ? void 0 : _b.call(_a, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $3JARs._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $3JARs._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $3JARs._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $3JARs._createLayerParameterExposure)(this._user, result, param), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        return {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $iFLyc._makeParamStoreGetter)(this, configuration, options)
        };
    }
}
module.exports.default = $04ba5329cd56096d$var$StatsigClient;

});
parcelRegister("kACaT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3JARs = parcelRequire("3JARs");
class $efd4c81e33729c50$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $3JARs._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        if (!result) return false;
        const values = (0, $3JARs._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        if (values.sdk_flags) $3JARs.SDKFlags.setFlags(this._sdkKey, values.sdk_flags);
        else $3JARs.SDKFlags.setFlags(this._sdkKey, {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $3JARs._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $3JARs.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            if ((0, $3JARs._getFullUserHash)(user) !== (0, $3JARs._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $efd4c81e33729c50$var$EvaluationStore;

});

parcelRegister("b9OHF", function(module, exports) {
"use strict";
var $81f7dd93016e75ad$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3JARs = parcelRequire("3JARs");

var $gUZMf = parcelRequire("gUZMf");
class $81f7dd93016e75ad$var$StatsigNetwork extends $3JARs.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._initializeUrlConfig = new $3JARs.UrlConfiguration($3JARs.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user) {
        return $81f7dd93016e75ad$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $3JARs._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) data = Object.assign(Object.assign({}, data), {
                sinceTime: cache.time,
                previousDerivedFields: "derived_fields" in cache ? cache.derived_fields : {},
                deltasResponseRequested: true,
                full_checksum: cache.full_checksum
            });
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $81f7dd93016e75ad$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $gUZMf._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $81f7dd93016e75ad$var$StatsigNetwork;

});
parcelRegister("gUZMf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $3JARs = parcelRequire("3JARs");
const $c511cbfe0e9e296e$var$MAX_DELTAS_SORT_DEPTH = 2;
function $c511cbfe0e9e296e$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $3JARs._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $c511cbfe0e9e296e$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $c511cbfe0e9e296e$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $3JARs._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $c511cbfe0e9e296e$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $c511cbfe0e9e296e$var$_resolveDeltasResponse;
function $c511cbfe0e9e296e$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $c511cbfe0e9e296e$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $c511cbfe0e9e296e$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $c511cbfe0e9e296e$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $c511cbfe0e9e296e$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $c511cbfe0e9e296e$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("iFLyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $3JARs = parcelRequire("3JARs");
const $d980f0e32759c270$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $d980f0e32759c270$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $d980f0e32759c270$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $3JARs._isTypeMatch)(value, fallback);
}
function $d980f0e32759c270$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $d980f0e32759c270$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $d980f0e32759c270$var$_shouldLogExposure(options) ? undefined : $d980f0e32759c270$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $d980f0e32759c270$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $d980f0e32759c270$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($d980f0e32759c270$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($d980f0e32759c270$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $d980f0e32759c270$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $d980f0e32759c270$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($d980f0e32759c270$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($d980f0e32759c270$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $d980f0e32759c270$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $d980f0e32759c270$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($d980f0e32759c270$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($d980f0e32759c270$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $d980f0e32759c270$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $3JARs._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $d980f0e32759c270$var$_getMappedStaticValue(param, options);
            case "gate":
                return $d980f0e32759c270$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $d980f0e32759c270$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $d980f0e32759c270$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $d980f0e32759c270$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $d980f0e32759c270$var$_makeParamStoreGetter;

});

parcelRegister("luvC7", function(module, exports) {
"use strict";
var $fa54ec2c99ed5dc3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $3JARs = parcelRequire("3JARs");

var $b9OHF = parcelRequire("b9OHF");
class $fa54ec2c99ed5dc3$var$StatsigEvaluationsDataAdapter extends $3JARs.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options) {
        super.attach(sdkKey, options);
        this._network = new $b9OHF.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $3JARs._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $3JARs._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $3JARs.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options) {
        var _a;
        return $fa54ec2c99ed5dc3$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $3JARs._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$3JARs.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $3JARs._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $fa54ec2c99ed5dc3$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("4yxkK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $351431c9a8530e7f$export$2e2bcd8739ae039; });

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $014mj = parcelRequire("014mj");

var $aWTIZ = parcelRequire("aWTIZ");
function $351431c9a8530e7f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $351431c9a8530e7f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $351431c9a8530e7f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $351431c9a8530e7f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $351431c9a8530e7f$export$a66cbd9b2289cd78 = "@all-features";
var $351431c9a8530e7f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $VVGAy.default)(this, Subscriptions);
        (0, $014mj.default)(this, "eventToValue", new Map());
        this.emitter = new (0, $aWTIZ.EventEmitter2)();
    }
    return (0, $b5cej.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $351431c9a8530e7f$var$_objectSpread($351431c9a8530e7f$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $351431c9a8530e7f$var$_objectSpread($351431c9a8530e7f$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $351431c9a8530e7f$var$_objectSpread($351431c9a8530e7f$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $351431c9a8530e7f$var$_objectSpread($351431c9a8530e7f$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($351431c9a8530e7f$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($351431c9a8530e7f$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($351431c9a8530e7f$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $351431c9a8530e7f$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("aWTIZ", function(module, exports) {

var $XAEGR = parcelRequire("XAEGR");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + " listeners added. " + "Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak) errorMsg += " Event name: " + eventName + ".";
        if (typeof $XAEGR !== "undefined" && $XAEGR.emitWarning) {
            var e = new Error(errorMsg);
            e.name = "MaxListenersExceededWarning";
            e.emitter = this;
            e.count = count;
            $XAEGR.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === "function") {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === "*" || currentType === "**" || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === "*") {
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === "**") {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === "*";
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) {
                    if (branch === "*" || branch === "**") {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree["*"];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree["**"];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== "_listeners" && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            "**": isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree["*"] && xxTree["*"]._listeners) searchListenerTree(handlers, type, xxTree["*"], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === "string" ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === "**" && type[i + 1] === "**") return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === "function") tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = ".";
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = "";
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== "function") throw new Error("many only accepts instances of Function");
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === "function") {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === "function") {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== "function") throw new Error("onAny only accepts instances of Function");
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === "function") {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== "function") throw new Error("on only accepts instances of Function");
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit("newListener", type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === "function") // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== "function") throw new Error("removeListener only takes instances of Function");
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("fo7wp", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $b33eee8abb1bcbc3$export$6dc24881a3d96325; });

var $asHcB = parcelRequire("asHcB");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $6ucNk = parcelRequire("6ucNk");
var $b33eee8abb1bcbc3$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $VVGAy.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $b5cej.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, $asHcB.default)(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, $asHcB.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $6ucNk.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("6ucNk", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $4b8f7827d6ed3cb1$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $4b8f7827d6ed3cb1$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $4b8f7827d6ed3cb1$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $4b8f7827d6ed3cb1$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $4b8f7827d6ed3cb1$export$18ad168d3dbac899; });

var $g3yJ1 = parcelRequire("g3yJ1");

var $lQw4F = parcelRequire("lQw4F");

var $014mj = parcelRequire("014mj");

var $7rvfj = parcelRequire("7rvfj");

var $ekFqm = parcelRequire("ekFqm");

var $56jWI = parcelRequire("56jWI");

var $6GwB3 = parcelRequire("6GwB3");
var $4b8f7827d6ed3cb1$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $4b8f7827d6ed3cb1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4b8f7827d6ed3cb1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4b8f7827d6ed3cb1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4b8f7827d6ed3cb1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4b8f7827d6ed3cb1$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $4b8f7827d6ed3cb1$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $ekFqm.isFedRamp)() ? (0, $6GwB3.PerimeterType).FEDRAMP_MODERATE : (0, $6GwB3.PerimeterType).COMMERCIAL
    }, options);
};
var $4b8f7827d6ed3cb1$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $lQw4F.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $lQw4F.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $lQw4F.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $lQw4F.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $4b8f7827d6ed3cb1$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $4b8f7827d6ed3cb1$var$_objectSpread({
            stableID: (0, $7rvfj.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $4b8f7827d6ed3cb1$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $g3yJ1.default)(options, $4b8f7827d6ed3cb1$var$_excluded);
    return $4b8f7827d6ed3cb1$var$_objectSpread($4b8f7827d6ed3cb1$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $4b8f7827d6ed3cb1$var$evaluationReasonMappings = Object.entries((0, $56jWI.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $lQw4F.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $4b8f7827d6ed3cb1$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $4b8f7827d6ed3cb1$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $lQw4F.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $56jWI.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("ekFqm", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $a6f310eea971191e$export$64d6499adf9b2e51; });

var $47mi4 = parcelRequire("47mi4");
function $a6f310eea971191e$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $47mi4.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("47mi4", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $2ff91b4787a1a933$export$ce553301d55c2fd8; });
var $2ff91b4787a1a933$export$ce553301d55c2fd8 = "fedramp-moderate";
var $2ff91b4787a1a933$export$f005e2e9f707cb5f = "commercial";
var $2ff91b4787a1a933$export$bd6b5a7802d76127 = "fedramp-fedex";
var $2ff91b4787a1a933$export$a739cd5aac835909 = "stg";
var $2ff91b4787a1a933$export$42dd0cdd351a4a9 = "prod";
var $2ff91b4787a1a933$export$404582bc18fe4d9e = "dev";

});


parcelRegister("56jWI", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $3b6cfc2350c6bddb$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $3b6cfc2350c6bddb$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("6GwB3", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $4ddff35a2f48ad34$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $4ddff35a2f48ad34$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $4ddff35a2f48ad34$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $4ddff35a2f48ad34$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $4ddff35a2f48ad34$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("abpnl", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $769e9d7ec926e828$export$936d0764594b6eb3; });

var $asHcB = parcelRequire("asHcB");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $6ucNk = parcelRequire("6ucNk");
var $769e9d7ec926e828$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $VVGAy.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $b5cej.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $asHcB.default)(val) === (0, $asHcB.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $6ucNk.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("9A1qQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f989636290e8193$export$2e2bcd8739ae039; });

var $014mj = parcelRequire("014mj");

var $fZvJe = parcelRequire("fZvJe");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $6Xz9e = parcelRequire("6Xz9e");

var $6GwB3 = parcelRequire("6GwB3");

var $iTMFz = parcelRequire("iTMFz");

var $78424 = parcelRequire("78424");
function $6f989636290e8193$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f989636290e8193$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f989636290e8193$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f989636290e8193$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f989636290e8193$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $6f989636290e8193$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $6f989636290e8193$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $6f989636290e8193$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $6f989636290e8193$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $6f989636290e8193$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $6f989636290e8193$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $6f989636290e8193$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $VVGAy.default)(this, Fetcher);
    }
    return (0, $b5cej.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $78424.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $78424.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $6f989636290e8193$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $6GwB3.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $6GwB3.FeatureGateEnvironment).Production:
                        return $6f989636290e8193$export$18c93900db9358a4;
                    case (0, $6GwB3.FeatureGateEnvironment).Staging:
                        return $6f989636290e8193$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $6GwB3.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $6GwB3.FeatureGateEnvironment).Development:
                        return $6f989636290e8193$export$f058dbf75c3bc647;
                    case (0, $6GwB3.FeatureGateEnvironment).Staging:
                        return $6f989636290e8193$export$942ba04389b0d5a2;
                    default:
                        return $6f989636290e8193$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $6f989636290e8193$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $6f989636290e8193$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $iTMFz.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("iTMFz", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $dc231dcb05fee1da$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $dc231dcb05fee1da$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("78424", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $530c687c3e2a69b1$export$286baf652d0b1206; });

var $b5cej = parcelRequire("b5cej");

var $VVGAy = parcelRequire("VVGAy");

var $cBzHf = parcelRequire("cBzHf");

var $b2yKv = parcelRequire("b2yKv");

var $e83zN = parcelRequire("e83zN");

var $cOSg8 = parcelRequire("cOSg8");
function $530c687c3e2a69b1$var$_callSuper(t, o, e) {
    return o = (0, $b2yKv.default)(o), (0, $cBzHf.default)(t, $530c687c3e2a69b1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $b2yKv.default)(t).constructor) : o.apply(t, e));
}
function $530c687c3e2a69b1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($530c687c3e2a69b1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $530c687c3e2a69b1$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $VVGAy.default)(this, ResponseError);
        return $530c687c3e2a69b1$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $e83zN.default)(ResponseError, _Error);
    return (0, $b5cej.default)(ResponseError);
}(/*#__PURE__*/ (0, $cOSg8.default)(Error));

});
parcelRegister("cBzHf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92d4a14d458baa1f$export$2e2bcd8739ae039; });

var $asHcB = parcelRequire("asHcB");

var $hk8Kb = parcelRequire("hk8Kb");
function $92d4a14d458baa1f$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $asHcB.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hk8Kb.default)(t);
}

});
parcelRegister("hk8Kb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9cb16488ecd6a32$export$2e2bcd8739ae039; });
function $c9cb16488ecd6a32$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("b2yKv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $809ad60aa0c586ae$export$2e2bcd8739ae039; });
function $809ad60aa0c586ae$export$2e2bcd8739ae039(t) {
    return $809ad60aa0c586ae$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $809ad60aa0c586ae$export$2e2bcd8739ae039(t);
}

});

parcelRegister("e83zN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a494963698e4ebdc$export$2e2bcd8739ae039; });

var $lCE2X = parcelRequire("lCE2X");
function $a494963698e4ebdc$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $lCE2X.default)(t, e);
}

});
parcelRegister("lCE2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbdc3601f0045ae0$export$2e2bcd8739ae039; });
function $fbdc3601f0045ae0$export$2e2bcd8739ae039(t, e) {
    return $fbdc3601f0045ae0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $fbdc3601f0045ae0$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("cOSg8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95543e4c56bd4a6b$export$2e2bcd8739ae039; });

var $b2yKv = parcelRequire("b2yKv");

var $lCE2X = parcelRequire("lCE2X");

var $5nIuR = parcelRequire("5nIuR");

var $fnREO = parcelRequire("fnREO");
function $95543e4c56bd4a6b$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $95543e4c56bd4a6b$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $5nIuR.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $fnREO.default)(t, arguments, (0, $b2yKv.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $lCE2X.default)(Wrapper, t);
    }, $95543e4c56bd4a6b$export$2e2bcd8739ae039(t);
}

});
parcelRegister("5nIuR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3eb19de1522961ec$export$2e2bcd8739ae039; });
function $3eb19de1522961ec$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("fnREO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b332a03c970b15ab$export$2e2bcd8739ae039; });

var $8wBtu = parcelRequire("8wBtu");

var $lCE2X = parcelRequire("lCE2X");
function $b332a03c970b15ab$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $8wBtu.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $lCE2X.default)(p, r.prototype), p;
}

});
parcelRegister("8wBtu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $634e618c54f36098$export$2e2bcd8739ae039; });
function $634e618c54f36098$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($634e618c54f36098$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("93Utk", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $6990330c34e83166$export$55fffef3474104af; });

var $fZvJe = parcelRequire("fZvJe");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $cBzHf = parcelRequire("cBzHf");

var $b2yKv = parcelRequire("b2yKv");

var $2Gp7N = parcelRequire("2Gp7N");

var $e83zN = parcelRequire("e83zN");

var $014mj = parcelRequire("014mj");

var $6Xz9e = parcelRequire("6Xz9e");

var $7rvfj = parcelRequire("7rvfj");
function $6990330c34e83166$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6990330c34e83166$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6990330c34e83166$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6990330c34e83166$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6990330c34e83166$var$_callSuper(t, o, e) {
    return o = (0, $b2yKv.default)(o), (0, $cBzHf.default)(t, $6990330c34e83166$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $b2yKv.default)(t).constructor) : o.apply(t, e));
}
function $6990330c34e83166$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($6990330c34e83166$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $6990330c34e83166$var$_superPropGet(t, o, e, r) {
    var p = (0, $2Gp7N.default)((0, $b2yKv.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $6990330c34e83166$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $VVGAy.default)(this, NoFetchDataAdapter);
        _this = $6990330c34e83166$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, $014mj.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $e83zN.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $b5cej.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $7rvfj.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $6990330c34e83166$var$_objectSpread($6990330c34e83166$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $7rvfj._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $6990330c34e83166$var$_objectSpread($6990330c34e83166$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $7rvfj._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $fZvJe.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6Xz9e))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $7rvfj._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $7rvfj.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $6990330c34e83166$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $6990330c34e83166$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $7rvfj.DataAdapterCore));

});
parcelRegister("2Gp7N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f42fe4345d851bc$export$2e2bcd8739ae039; });

var $f9Pga = parcelRequire("f9Pga");
function $1f42fe4345d851bc$export$2e2bcd8739ae039() {
    return $1f42fe4345d851bc$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $f9Pga.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $1f42fe4345d851bc$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("f9Pga", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b08f7561473607e0$export$2e2bcd8739ae039; });

var $b2yKv = parcelRequire("b2yKv");
function $b08f7561473607e0$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $b2yKv.default)(t)););
    return t;
}

});



parcelRegister("gl6dF", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $be536e8f9e72ca40$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $be536e8f9e72ca40$export$bcb28fbac1def494; });

var $014mj = parcelRequire("014mj");

var $lQw4F = parcelRequire("lQw4F");

var $VVGAy = parcelRequire("VVGAy");

var $b5cej = parcelRequire("b5cej");

var $3JARs = parcelRequire("3JARs");
function $be536e8f9e72ca40$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be536e8f9e72ca40$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be536e8f9e72ca40$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $014mj.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be536e8f9e72ca40$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be536e8f9e72ca40$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $be536e8f9e72ca40$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $be536e8f9e72ca40$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $be536e8f9e72ca40$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $be536e8f9e72ca40$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $be536e8f9e72ca40$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $be536e8f9e72ca40$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $be536e8f9e72ca40$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $be536e8f9e72ca40$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $be536e8f9e72ca40$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $be536e8f9e72ca40$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $be536e8f9e72ca40$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $VVGAy.default)(this, PersistentOverrideAdapter);
        this._overrides = $be536e8f9e72ca40$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $b5cej.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $be536e8f9e72ca40$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $be536e8f9e72ca40$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $be536e8f9e72ca40$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $lQw4F.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $lQw4F.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $lQw4F.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($be536e8f9e72ca40$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($be536e8f9e72ca40$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $be536e8f9e72ca40$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $3JARs._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, $be536e8f9e72ca40$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $lQw4F.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $lQw4F.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($be536e8f9e72ca40$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current.details), {}, {
                        reason: $be536e8f9e72ca40$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($be536e8f9e72ca40$var$djb2MapKey((0, $3JARs._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $be536e8f9e72ca40$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($be536e8f9e72ca40$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $3JARs._makeTypedGet)(current.name, overridden),
                    details: $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current.details), {}, {
                        reason: $be536e8f9e72ca40$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($be536e8f9e72ca40$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $3JARs._makeTypedGet)(current.name, overridden),
                    details: $be536e8f9e72ca40$var$_objectSpread($be536e8f9e72ca40$var$_objectSpread({}, current.details), {}, {
                        reason: $be536e8f9e72ca40$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});



parcelRegister("2n3z5", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $1ba07ea83044c979$export$1c9f709888824e05; });
var $1ba07ea83044c979$var$_process, $1ba07ea83044c979$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $1ba07ea83044c979$var$TESTS_MODE = (globalThis === null || globalThis === void 0 || ($1ba07ea83044c979$var$_process = globalThis.process) === null || $1ba07ea83044c979$var$_process === void 0 || ($1ba07ea83044c979$var$_process = $1ba07ea83044c979$var$_process.env) === null || $1ba07ea83044c979$var$_process === void 0 ? void 0 : $1ba07ea83044c979$var$_process.JEST_WORKER_ID) !== undefined;
var $1ba07ea83044c979$var$DEBUG_MODE = !$1ba07ea83044c979$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($1ba07ea83044c979$var$_process2 = globalThis.process) === null || $1ba07ea83044c979$var$_process2 === void 0 || ($1ba07ea83044c979$var$_process2 = $1ba07ea83044c979$var$_process2.env) === null || $1ba07ea83044c979$var$_process2 === void 0 ? void 0 : $1ba07ea83044c979$var$_process2.NODE_ENV) !== "production";
var $1ba07ea83044c979$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$1ba07ea83044c979$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("eDSbX", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $aa8ebe934f542083$export$765cacec8b0843f3; });

var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $aa8ebe934f542083$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">\n      <path fill='.concat(colors.iconColor, ' d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>\n      <path fill=').concat(colors.atlassianLogoTextColor, ' d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>\n    </svg>');
};
var $aa8ebe934f542083$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $aa8ebe934f542083$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("dQweN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1492366a1777558$export$2e2bcd8739ae039; });

var $f40k1 = parcelRequire("f40k1");

var $iSvIT = parcelRequire("iSvIT");

var $5GbdM = parcelRequire("5GbdM");

var $3Z0eC = parcelRequire("3Z0eC");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $a1492366a1777558$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $iSvIT.useState)((0, $5GbdM.default)()), _useState2 = (0, $f40k1.default)(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $iSvIT.useEffect)(function() {
        var observer = new (0, $3Z0eC.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $a1492366a1777558$export$2e2bcd8739ae039 = $a1492366a1777558$var$useThemeObserver;

});
parcelRegister("f40k1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af777aa7a00a39a6$export$2e2bcd8739ae039; });

var $ey4jy = parcelRequire("ey4jy");

var $058wm = parcelRequire("058wm");

var $laq8D = parcelRequire("laq8D");

var $aPqpl = parcelRequire("aPqpl");
function $af777aa7a00a39a6$export$2e2bcd8739ae039(r, e) {
    return (0, $ey4jy.default)(r) || (0, $058wm.default)(r, e) || (0, $laq8D.default)(r, e) || (0, $aPqpl.default)();
}

});
parcelRegister("ey4jy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a977966bcbf50aad$export$2e2bcd8739ae039; });
function $a977966bcbf50aad$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("058wm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f713da13d65daf$export$2e2bcd8739ae039; });
function $00f713da13d65daf$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("laq8D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f68eceab936ed048$export$2e2bcd8739ae039; });

var $kqYT8 = parcelRequire("kqYT8");
function $f68eceab936ed048$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $kqYT8.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $kqYT8.default)(r, a) : void 0;
    }
}

});
parcelRegister("kqYT8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee057784fd794d09$export$2e2bcd8739ae039; });
function $ee057784fd794d09$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aPqpl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e2326dba66ef955$export$2e2bcd8739ae039; });
function $7e2326dba66ef955$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("5GbdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42299451548c89ce$export$2e2bcd8739ae039; });

var $fsPZZ = parcelRequire("fsPZZ");

var $8wCsh = parcelRequire("8wCsh");

var $leIxH = parcelRequire("leIxH");

var $3Fdm9 = parcelRequire("3Fdm9");
function $42299451548c89ce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42299451548c89ce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42299451548c89ce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fsPZZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42299451548c89ce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $42299451548c89ce$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $leIxH.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $42299451548c89ce$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $8wCsh.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $8wCsh.THEME_DATA_ATTRIBUTE)) || "";
    return $42299451548c89ce$var$_objectSpread($42299451548c89ce$var$_objectSpread({}, (0, $3Fdm9.themeStringToObject)(theme)), $42299451548c89ce$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $42299451548c89ce$export$2e2bcd8739ae039 = $42299451548c89ce$var$getGlobalTheme;

});
parcelRegister("fsPZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b421ce68073b85d1$export$2e2bcd8739ae039; });

var $l6eGY = parcelRequire("l6eGY");
function $b421ce68073b85d1$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $l6eGY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("l6eGY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5c58e1531507b6d$export$2e2bcd8739ae039; });

var $d05Rs = parcelRequire("d05Rs");

var $gIdvF = parcelRequire("gIdvF");
function $f5c58e1531507b6d$export$2e2bcd8739ae039(t) {
    var i = (0, $gIdvF.default)(t, "string");
    return "symbol" == (0, $d05Rs.default)(i) ? i : i + "";
}

});
parcelRegister("d05Rs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $976fd25b7744b36b$export$2e2bcd8739ae039; });
function $976fd25b7744b36b$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $976fd25b7744b36b$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $976fd25b7744b36b$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gIdvF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ab3c2a12966360$export$2e2bcd8739ae039; });

var $d05Rs = parcelRequire("d05Rs");
function $c2ab3c2a12966360$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $d05Rs.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $d05Rs.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("8wCsh", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $634f2447850f2526$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $634f2447850f2526$export$a00eac3f8684bcd0; });
var $634f2447850f2526$export$4ef52930e33717cd = "data-theme";
var $634f2447850f2526$export$cb374d25ded7f6ab = "data-subtree-theme";
var $634f2447850f2526$export$a00eac3f8684bcd0 = "data-color-mode";
var $634f2447850f2526$export$2112803007239c61 = "data-contrast-mode";
var $634f2447850f2526$export$352e418ed5b6193a = "data-custom-theme";
var $634f2447850f2526$export$6f0c6fb8c80fcc92 = "ds";
var $634f2447850f2526$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border",
    "radius"
];
var $634f2447850f2526$export$dddac1532e822863 = "--".concat($634f2447850f2526$export$6f0c6fb8c80fcc92, "-token-not-found");
var $634f2447850f2526$export$9d7b58831ae93caa = "--".concat($634f2447850f2526$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("leIxH", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $f75d75048da66155$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $f75d75048da66155$export$7d43e72a58e3283f; });

var $jxLBU = parcelRequire("jxLBU");
var $f75d75048da66155$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $f75d75048da66155$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $f75d75048da66155$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "spacing",
    "shape",
    "typography",
    "motion"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $f75d75048da66155$var$themeOverrideIds = [];
var $f75d75048da66155$export$92ba366331403db2 = [].concat($f75d75048da66155$export$7d43e72a58e3283f, $f75d75048da66155$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $f75d75048da66155$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography": {
        id: "typography",
        displayName: "Atlassian Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-motion": {
        id: "motion",
        displayName: "Motion",
        palette: "motionPalette",
        attributes: {
            type: "motion"
        }
    }
};
var $f75d75048da66155$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: function shape() {
        if ((0, $jxLBU.fg)("platform-dst-shape-theme-default")) return "shape";
        return undefined;
    },
    spacing: "spacing",
    typography: "typography",
    motion: function motion() {
        if ((0, $jxLBU.fg)("platform-dst-motion-theme-default")) return "motion";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $f75d75048da66155$export$2e2bcd8739ae039 = $f75d75048da66155$var$themeConfig;

});

parcelRegister("3Fdm9", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $2aaf8fb3a2dd1c72$export$f19b488f7c0547ee; });

var $d05Rs = parcelRequire("d05Rs");

var $f40k1 = parcelRequire("f40k1");

var $leIxH = parcelRequire("leIxH");
var $2aaf8fb3a2dd1c72$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape",
    "motion"
];
var $2aaf8fb3a2dd1c72$var$customThemeOptions = "UNSAFE_themeOptions";
var $2aaf8fb3a2dd1c72$var$isThemeKind = function isThemeKind(themeKind) {
    return $2aaf8fb3a2dd1c72$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $2aaf8fb3a2dd1c72$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $leIxH.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $2aaf8fb3a2dd1c72$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $2aaf8fb3a2dd1c72$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ")// @ts-ignore - TS1501 TypeScript 5.9.2 upgrade
    .map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $f40k1.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $2aaf8fb3a2dd1c72$var$isColorMode(id)) themeObject[kind] = id;
        if ($2aaf8fb3a2dd1c72$var$isThemeKind(kind) && $2aaf8fb3a2dd1c72$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $2aaf8fb3a2dd1c72$var$customThemeOptions) try {
            themeObject[$2aaf8fb3a2dd1c72$var$customThemeOptions] = JSON.parse(id);
        } catch (_unused) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $2aaf8fb3a2dd1c72$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $f40k1.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $2aaf8fb3a2dd1c72$var$isColorMode(id) || // custom theme state
        kind === $2aaf8fb3a2dd1c72$var$customThemeOptions && (0, $d05Rs.default)(id) === "object" || // other theme states
        $2aaf8fb3a2dd1c72$var$isThemeKind(kind) && typeof id === "string" && $2aaf8fb3a2dd1c72$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $d05Rs.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("3Z0eC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e67403794310dda$export$2e2bcd8739ae039; });

var $fmzJz = parcelRequire("fmzJz");

var $cRjT3 = parcelRequire("cRjT3");

var $fsPZZ = parcelRequire("fsPZZ");

var $8wCsh = parcelRequire("8wCsh");

var $5GbdM = parcelRequire("5GbdM");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $2e67403794310dda$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, $fmzJz.default)(this, ThemeMutationObserver);
        (0, $fsPZZ.default)(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    return (0, $cRjT3.default)(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $5GbdM.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $8wCsh.THEME_DATA_ATTRIBUTE),
                            (0, $8wCsh.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
}();
(0, $fsPZZ.default)($2e67403794310dda$export$2e2bcd8739ae039, "observer", null);
(0, $fsPZZ.default)($2e67403794310dda$export$2e2bcd8739ae039, "callbacks", new Set());

});
parcelRegister("fmzJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f4a11f62103fe0$export$2e2bcd8739ae039; });
function $b2f4a11f62103fe0$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cRjT3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95c9dc6c42c7900e$export$2e2bcd8739ae039; });

var $l6eGY = parcelRequire("l6eGY");
function $95c9dc6c42c7900e$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $l6eGY.default)(o.key), o);
    }
}
function $95c9dc6c42c7900e$export$2e2bcd8739ae039(e, r, t) {
    return r && $95c9dc6c42c7900e$var$_defineProperties(e.prototype, r), t && $95c9dc6c42c7900e$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});



parcelRegister("hFZoE", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $cde5e41417f5b645$export$438460117ae6b7ee; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $cde5e41417f5b645$export$438460117ae6b7ee = {
    iconColor: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $cde5e41417f5b645$export$793fba32aed8942a = {
    iconGradientStart: "inherit",
    iconGradientStop: "inherit"
}; /**
 * The props for the <Wrapper /> that takes the svg and turns it into a component.
 */ 

});

parcelRegister("eJjXw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab94c01c4862d222$export$2e2bcd8739ae039; });
/* wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $5bCc2 = parcelRequire("5bCc2");

var $fsPZZ = parcelRequire("fsPZZ");

var $jUpi8 = parcelRequire("jUpi8");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $ab94c01c4862d222$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconColor",
    "textColor",
    "testId"
];
var $ab94c01c4862d222$var$CSS_VAR_COLOR = "--logo-color";
var $ab94c01c4862d222$var$CSS_VAR_FILL = "--logo-fill";
var $ab94c01c4862d222$var$styles = {
    root: "_1e0c1o8l _kqswh2mm _syaz1vry _lswu1xf6 _vwz4kb7n _uiztglyw _o5724jg8 _zbji1osq _3se11kw7",
    stop: "_vc881r31",
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $ab94c01c4862d222$var$Wrapper = function Wrapper(_ref) {
    var label = _ref.label, svg = _ref.svg, size = _ref.size, appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor, userDefinedTestId = _ref.testId, rest = (0, $jUpi8.default)(_ref, $ab94c01c4862d222$var$_excluded);
    // Only required for old logos with gradients, which set gradient values to `inherit` when no appearance is provided
    var shouldApplyStopColor = appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return /*#__PURE__*/ $iSvIT.createElement("span", (0, $5bCc2.default)({
        "data-testid": testId,
        style: (0, $fsPZZ.default)((0, $fsPZZ.default)({}, $ab94c01c4862d222$var$CSS_VAR_COLOR, iconColor), $ab94c01c4862d222$var$CSS_VAR_FILL, textColor),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest, {
        className: (0, $esG4f.default)([
            $ab94c01c4862d222$var$styles.root,
            shouldApplyStopColor && $ab94c01c4862d222$var$styles.stop,
            size && $ab94c01c4862d222$var$styles[size]
        ])
    }));
};
var $ab94c01c4862d222$export$2e2bcd8739ae039 = $ab94c01c4862d222$var$Wrapper;

});
parcelRegister("5bCc2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c6b9b305fca6696$export$2e2bcd8739ae039; });
function $3c6b9b305fca6696$export$2e2bcd8739ae039() {
    return $3c6b9b305fca6696$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $3c6b9b305fca6696$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jUpi8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7e6dda899d61be4$export$2e2bcd8739ae039; });

var $7b4RZ = parcelRequire("7b4RZ");
function $e7e6dda899d61be4$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $7b4RZ.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("7b4RZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $539d568014a638c1$export$2e2bcd8739ae039; });
function $539d568014a638c1$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("esG4f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8744fed0e6af905$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $a8744fed0e6af905$var$ATOMIC_GROUP_LENGTH = 5;
function $a8744fed0e6af905$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(" ")) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(" ");
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith("_") ? className.slice(0, $a8744fed0e6af905$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = "";
    for(const key in map)result += map[key] + " ";
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});


parcelRegister("3LDQa", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $2be4aa5a8371a8c5$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $2be4aa5a8371a8c5$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $2be4aa5a8371a8c5$export$7818df200941dbbf; });

var $bmhIM = parcelRequire("bmhIM");
var $2be4aa5a8371a8c5$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $bmhIM.B400);
            iconGradientStop = (0, $bmhIM.B200);
            iconColor = (0, $bmhIM.B200);
            textColor = "var(--ds-text, ".concat((0, $bmhIM.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $bmhIM.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $bmhIM.N600);
            iconGradientStop = (0, $bmhIM.N100);
            iconColor = (0, $bmhIM.N100);
            textColor = (0, $bmhIM.N400);
            atlassianLogoTextColor = (0, $bmhIM.N400);
            break;
        case "inverse":
            iconGradientStart = "#FFFFFF66";
            iconGradientStop = "#FFFFFF";
            iconColor = "#FFFFFF";
            textColor = "#FFFFFF";
            atlassianLogoTextColor = "#FFFFFF";
            break;
    }
    if (colorMode === "dark" && appearance === "inverse") {
        iconGradientStart = "#161A1D66";
        iconGradientStop = "#161A1D";
        iconColor = "#161A1D";
        textColor = "#161A1D";
        atlassianLogoTextColor = "#161A1D";
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2be4aa5a8371a8c5$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $bmhIM.N0);
            textColor = (0, $bmhIM.N0);
            atlassianLogoTextColor = (0, $bmhIM.N0);
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $2be4aa5a8371a8c5$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $2be4aa5a8371a8c5$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $2be4aa5a8371a8c5$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});
parcelRegister("bmhIM", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $844f7ed6bce3067a$export$215b7063051591f1; });
$parcel$export(module.exports, "B400", function () { return $844f7ed6bce3067a$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "N0", function () { return $844f7ed6bce3067a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N100", function () { return $844f7ed6bce3067a$export$d6447c357493214f; });
$parcel$export(module.exports, "N400", function () { return $844f7ed6bce3067a$export$eece5f492e429f08; });
$parcel$export(module.exports, "N600", function () { return $844f7ed6bce3067a$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $844f7ed6bce3067a$export$7d61b15e0da132af; });
// Reds
var $844f7ed6bce3067a$export$4b84fd0e2c617bd = "#FFEBE6";
var $844f7ed6bce3067a$export$b34b069eff244586 = "#FFBDAD";
var $844f7ed6bce3067a$export$be802dd0d8b57f35 = "#FF8F73";
var $844f7ed6bce3067a$export$60847d42f9da92a6 = "#FF7452";
var $844f7ed6bce3067a$export$4a7404f376229999 = "#FF5630";
var $844f7ed6bce3067a$export$2010d0fb4295b346 = "#DE350B";
var $844f7ed6bce3067a$export$2837b5a1a71d5c02 = "#BF2600";
var $844f7ed6bce3067a$export$8d9596b529bbb9cf = "#FFFAE6";
var $844f7ed6bce3067a$export$41060a744ab0b7ae = "#FFF0B3";
var $844f7ed6bce3067a$export$1cc05bbbf340e559 = "#FFE380";
var $844f7ed6bce3067a$export$5aae31392d72caaa = "#FFC400";
var $844f7ed6bce3067a$export$c6930421db9fa514 = "#FFAB00";
var $844f7ed6bce3067a$export$59619663aa6500fb = "#FF991F";
var $844f7ed6bce3067a$export$874739ea9e379ab6 = "#FF8B00";
var $844f7ed6bce3067a$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $844f7ed6bce3067a$export$69a3bf21b9686c2b = "#ABF5D1";
var $844f7ed6bce3067a$export$afbce1382ec95f73 = "#79F2C0";
var $844f7ed6bce3067a$export$747d86715d4175de = "#57D9A3";
var $844f7ed6bce3067a$export$940e1f69e873f202 = "#36B37E";
var $844f7ed6bce3067a$export$a49394138f7b8e85 = "#00875A";
var $844f7ed6bce3067a$export$6fa04827ac68a4fb = "#006644";
var $844f7ed6bce3067a$export$226de0355ed012f8 = "#DEEBFF";
var $844f7ed6bce3067a$export$8c13c2ee36917869 = "#B3D4FF";
var $844f7ed6bce3067a$export$ecfc1dff386a3e7a = "#4C9AFF";
var $844f7ed6bce3067a$export$215b7063051591f1 = "#2684FF";
var $844f7ed6bce3067a$export$e62e8919cca44969 = "#0065FF";
var $844f7ed6bce3067a$export$b3de0ae08da2ce64 = "#0052CC";
var $844f7ed6bce3067a$export$a6ee3d71bc067634 = "#0747A6";
var $844f7ed6bce3067a$export$67f15409e87642a1 = "#669DF1";
var $844f7ed6bce3067a$export$f0539dbc42dbb067 = "#8FB8F6";
var $844f7ed6bce3067a$export$363e4475840015bb = "#EAE6FF";
var $844f7ed6bce3067a$export$4b0a4417ed59760f = "#C0B6F2";
var $844f7ed6bce3067a$export$6011520a64d9a187 = "#998DD9";
var $844f7ed6bce3067a$export$a7175d4e9206bc80 = "#8777D9";
var $844f7ed6bce3067a$export$b48405b95304b5a1 = "#6554C0";
var $844f7ed6bce3067a$export$c71e4279dd54a18d = "#5243AA";
var $844f7ed6bce3067a$export$147899de772240ec = "#403294";
var $844f7ed6bce3067a$export$2cf711fe14c66f06 = "#E6FCFF";
var $844f7ed6bce3067a$export$7a8f4d33f6f9772c = "#B3F5FF";
var $844f7ed6bce3067a$export$776c9c497ef08533 = "#79E2F2";
var $844f7ed6bce3067a$export$69cb3ca10c1e330e = "#00C7E6";
var $844f7ed6bce3067a$export$9dc1ef0f3f48059b = "#00B8D9";
var $844f7ed6bce3067a$export$7c835c78b6fcdef8 = "#00A3BF";
var $844f7ed6bce3067a$export$6036577f95c3877e = "#008DA6";
var $844f7ed6bce3067a$export$29a4f05edc054374 = "#FFFFFF";
var $844f7ed6bce3067a$export$e655ef011c4aa1a2 = "#FAFBFC";
var $844f7ed6bce3067a$export$9fdfb749e33cdf97 = "#F4F5F7";
var $844f7ed6bce3067a$export$3e51e8f1440314ba = "#EBECF0";
var $844f7ed6bce3067a$export$1ce2d1575d444ceb = "#DFE1E6";
var $844f7ed6bce3067a$export$8754fc7e6d8b3000 = "#C1C7D0";
var $844f7ed6bce3067a$export$c2e91cbeada39b8b = "#B3BAC5";
var $844f7ed6bce3067a$export$5f71e19f3a7ad9de = "#A5ADBA";
var $844f7ed6bce3067a$export$eaa8c8a70ac22806 = "#97A0AF";
var $844f7ed6bce3067a$export$7c87d337fb91a97d = "#8993A4";
var $844f7ed6bce3067a$export$d6447c357493214f = "#7A869A";
var $844f7ed6bce3067a$export$f563ee71e9ee74cd = "#6B778C";
var $844f7ed6bce3067a$export$e2ef2124cf4024b1 = "#5E6C84";
var $844f7ed6bce3067a$export$eece5f492e429f08 = "#505F79";
var $844f7ed6bce3067a$export$c39c0fe0f26207ae = "#42526E";
var $844f7ed6bce3067a$export$7090862dc3038a9f = "#344563";
var $844f7ed6bce3067a$export$ad0bacf983b7ddaa = "#253858";
var $844f7ed6bce3067a$export$7d61b15e0da132af = "#172B4D";
var $844f7ed6bce3067a$export$fbda843f0a27fe96 = "#091E42";
var $844f7ed6bce3067a$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $844f7ed6bce3067a$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $844f7ed6bce3067a$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $844f7ed6bce3067a$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $844f7ed6bce3067a$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $844f7ed6bce3067a$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $844f7ed6bce3067a$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $844f7ed6bce3067a$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $844f7ed6bce3067a$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $844f7ed6bce3067a$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $844f7ed6bce3067a$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $844f7ed6bce3067a$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $844f7ed6bce3067a$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $844f7ed6bce3067a$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $844f7ed6bce3067a$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $844f7ed6bce3067a$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $844f7ed6bce3067a$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $844f7ed6bce3067a$export$2f6319cf7d736c2a = "#E6EDFA";
var $844f7ed6bce3067a$export$95126bc8884d6634 = "#DCE5F5";
var $844f7ed6bce3067a$export$8338d8c35d44ff1 = "#CED9EB";
var $844f7ed6bce3067a$export$5368d76ae4fbbda7 = "#B8C7E0";
var $844f7ed6bce3067a$export$9f0a771d16ec8d36 = "#ABBBD6";
var $844f7ed6bce3067a$export$abcf8c38338b4aa5 = "#9FB0CC";
var $844f7ed6bce3067a$export$97e81faa16a182c7 = "#8C9CB8";
var $844f7ed6bce3067a$export$bfe21c59123ecf33 = "#7988A3";
var $844f7ed6bce3067a$export$ee82aa2ea6a1558 = "#67758F";
var $844f7ed6bce3067a$export$682927c6ed76be02 = "#56637A";
var $844f7ed6bce3067a$export$91fd9994c5be9757 = "#455166";
var $844f7ed6bce3067a$export$d281fbfe3cff2df6 = "#3B475C";
var $844f7ed6bce3067a$export$3902c91d8b98a753 = "#313D52";
var $844f7ed6bce3067a$export$8e8133c1ba5845b5 = "#283447";
var $844f7ed6bce3067a$export$33ff357f6620b39 = "#202B3D";
var $844f7ed6bce3067a$export$633847cf062b69e0 = "#1B2638";
var $844f7ed6bce3067a$export$9776a6e503bdbf76 = "#121A29";
var $844f7ed6bce3067a$export$6c813d5160dff5db = "#0E1624";
var $844f7ed6bce3067a$export$3d4f271a500072a = "#0D1424";
var $844f7ed6bce3067a$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $844f7ed6bce3067a$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $844f7ed6bce3067a$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $844f7ed6bce3067a$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $844f7ed6bce3067a$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $844f7ed6bce3067a$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $844f7ed6bce3067a$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $844f7ed6bce3067a$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $844f7ed6bce3067a$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $844f7ed6bce3067a$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $844f7ed6bce3067a$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $844f7ed6bce3067a$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $844f7ed6bce3067a$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $844f7ed6bce3067a$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $844f7ed6bce3067a$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $844f7ed6bce3067a$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $844f7ed6bce3067a$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $844f7ed6bce3067a$export$d2adc5dedf09fced = "#292A2E";
var $844f7ed6bce3067a$export$f51762073d2bb381 = "#94C748";
var $844f7ed6bce3067a$export$95e26d54def96891 = "#B3DF72";

});



parcelRegister("dRxyd", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("lgqAv", function(module, exports) {
"use strict";

var $jfZcZ = parcelRequire("jfZcZ");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f7afb75b40466c62$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f7afb75b40466c62$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f7afb75b40466c62$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f7afb75b40466c62$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f7afb75b40466c62$var$TYPE_STATICS = {};
$f7afb75b40466c62$var$TYPE_STATICS[$jfZcZ.ForwardRef] = $f7afb75b40466c62$var$FORWARD_REF_STATICS;
$f7afb75b40466c62$var$TYPE_STATICS[$jfZcZ.Memo] = $f7afb75b40466c62$var$MEMO_STATICS;
function $f7afb75b40466c62$var$getStatics(component) {
    // React v16.11 and below
    if ($jfZcZ.isMemo(component)) return $f7afb75b40466c62$var$MEMO_STATICS;
     // React v16.12 and above
    return $f7afb75b40466c62$var$TYPE_STATICS[component["$$typeof"]] || $f7afb75b40466c62$var$REACT_STATICS;
}
var $f7afb75b40466c62$var$defineProperty = Object.defineProperty;
var $f7afb75b40466c62$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f7afb75b40466c62$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f7afb75b40466c62$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f7afb75b40466c62$var$getPrototypeOf = Object.getPrototypeOf;
var $f7afb75b40466c62$var$objectPrototype = Object.prototype;
function $f7afb75b40466c62$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($f7afb75b40466c62$var$objectPrototype) {
            var inheritedComponent = $f7afb75b40466c62$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f7afb75b40466c62$var$objectPrototype) $f7afb75b40466c62$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f7afb75b40466c62$var$getOwnPropertyNames(sourceComponent);
        if ($f7afb75b40466c62$var$getOwnPropertySymbols) keys = keys.concat($f7afb75b40466c62$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f7afb75b40466c62$var$getStatics(targetComponent);
        var sourceStatics = $f7afb75b40466c62$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f7afb75b40466c62$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f7afb75b40466c62$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f7afb75b40466c62$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $f7afb75b40466c62$var$hoistNonReactStatics;

});
parcelRegister("jfZcZ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("5PRGx"));

});
parcelRegister("5PRGx", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $43fb5be5048dc3fc$export$2b8d127b894957b9; }, function (v) { return $43fb5be5048dc3fc$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $43fb5be5048dc3fc$export$cea3a54a6425200c; }, function (v) { return $43fb5be5048dc3fc$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $43fb5be5048dc3fc$export$a7c73072b1a182ae; }, function (v) { return $43fb5be5048dc3fc$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $43fb5be5048dc3fc$export$9f27bc3417b4524d; }, function (v) { return $43fb5be5048dc3fc$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $43fb5be5048dc3fc$export$db77ccec0bb4ccac; }, function (v) { return $43fb5be5048dc3fc$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $43fb5be5048dc3fc$export$8392c0c9d3dcbd35; }, function (v) { return $43fb5be5048dc3fc$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $43fb5be5048dc3fc$export$ffb0004e005737fa; }, function (v) { return $43fb5be5048dc3fc$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $43fb5be5048dc3fc$export$b624eff549462981; }, function (v) { return $43fb5be5048dc3fc$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $43fb5be5048dc3fc$export$7897aa7841a5380c; }, function (v) { return $43fb5be5048dc3fc$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $43fb5be5048dc3fc$export$602eac185826482c; }, function (v) { return $43fb5be5048dc3fc$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $43fb5be5048dc3fc$export$e2c29f18771995cb; }, function (v) { return $43fb5be5048dc3fc$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $43fb5be5048dc3fc$export$5f8d39834fd61797; }, function (v) { return $43fb5be5048dc3fc$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $43fb5be5048dc3fc$export$74bf444e3cd11ea5; }, function (v) { return $43fb5be5048dc3fc$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $43fb5be5048dc3fc$export$92387174baf9b227; }, function (v) { return $43fb5be5048dc3fc$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $43fb5be5048dc3fc$export$ec112efeb987d9c6; }, function (v) { return $43fb5be5048dc3fc$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $43fb5be5048dc3fc$export$b706b080d889d2c9; }, function (v) { return $43fb5be5048dc3fc$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $43fb5be5048dc3fc$export$5be5a87408f70ddc; }, function (v) { return $43fb5be5048dc3fc$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $43fb5be5048dc3fc$export$45a5e7f76e0caa8d; }, function (v) { return $43fb5be5048dc3fc$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $43fb5be5048dc3fc$export$455c2e768291efa6; }, function (v) { return $43fb5be5048dc3fc$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $43fb5be5048dc3fc$export$9522e17588c12572; }, function (v) { return $43fb5be5048dc3fc$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $43fb5be5048dc3fc$export$2110ac352bb060b9; }, function (v) { return $43fb5be5048dc3fc$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $43fb5be5048dc3fc$export$56885ab8b9c456ab; }, function (v) { return $43fb5be5048dc3fc$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $43fb5be5048dc3fc$export$d927fcb6adf8f9de; }, function (v) { return $43fb5be5048dc3fc$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $43fb5be5048dc3fc$export$b82d16f27459e05a; }, function (v) { return $43fb5be5048dc3fc$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $43fb5be5048dc3fc$export$522c17b4f5e123e8; }, function (v) { return $43fb5be5048dc3fc$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $43fb5be5048dc3fc$export$1aabd8a0274ecfd6; }, function (v) { return $43fb5be5048dc3fc$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $43fb5be5048dc3fc$export$9b621391a187a31a; }, function (v) { return $43fb5be5048dc3fc$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $43fb5be5048dc3fc$export$f5bbd400c2f4426f; }, function (v) { return $43fb5be5048dc3fc$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $43fb5be5048dc3fc$export$2b8d127b894957b9;
var $43fb5be5048dc3fc$export$cea3a54a6425200c;
var $43fb5be5048dc3fc$export$a7c73072b1a182ae;
var $43fb5be5048dc3fc$export$9f27bc3417b4524d;
var $43fb5be5048dc3fc$export$db77ccec0bb4ccac;
var $43fb5be5048dc3fc$export$8392c0c9d3dcbd35;
var $43fb5be5048dc3fc$export$ffb0004e005737fa;
var $43fb5be5048dc3fc$export$b624eff549462981;
var $43fb5be5048dc3fc$export$7897aa7841a5380c;
var $43fb5be5048dc3fc$export$602eac185826482c;
var $43fb5be5048dc3fc$export$e2c29f18771995cb;
var $43fb5be5048dc3fc$export$5f8d39834fd61797;
var $43fb5be5048dc3fc$export$74bf444e3cd11ea5;
var $43fb5be5048dc3fc$export$92387174baf9b227;
var $43fb5be5048dc3fc$export$ec112efeb987d9c6;
var $43fb5be5048dc3fc$export$b706b080d889d2c9;
var $43fb5be5048dc3fc$export$5be5a87408f70ddc;
var $43fb5be5048dc3fc$export$45a5e7f76e0caa8d;
var $43fb5be5048dc3fc$export$455c2e768291efa6;
var $43fb5be5048dc3fc$export$9522e17588c12572;
var $43fb5be5048dc3fc$export$2110ac352bb060b9;
var $43fb5be5048dc3fc$export$56885ab8b9c456ab;
var $43fb5be5048dc3fc$export$d927fcb6adf8f9de;
var $43fb5be5048dc3fc$export$b82d16f27459e05a;
var $43fb5be5048dc3fc$export$522c17b4f5e123e8;
var $43fb5be5048dc3fc$export$1aabd8a0274ecfd6;
var $43fb5be5048dc3fc$export$9b621391a187a31a;
var $43fb5be5048dc3fc$export$f5bbd400c2f4426f;
"use strict";
var $43fb5be5048dc3fc$var$b = "function" === typeof Symbol && Symbol.for, $43fb5be5048dc3fc$var$c = $43fb5be5048dc3fc$var$b ? Symbol.for("react.element") : 60103, $43fb5be5048dc3fc$var$d = $43fb5be5048dc3fc$var$b ? Symbol.for("react.portal") : 60106, $43fb5be5048dc3fc$var$e = $43fb5be5048dc3fc$var$b ? Symbol.for("react.fragment") : 60107, $43fb5be5048dc3fc$var$f = $43fb5be5048dc3fc$var$b ? Symbol.for("react.strict_mode") : 60108, $43fb5be5048dc3fc$var$g = $43fb5be5048dc3fc$var$b ? Symbol.for("react.profiler") : 60114, $43fb5be5048dc3fc$var$h = $43fb5be5048dc3fc$var$b ? Symbol.for("react.provider") : 60109, $43fb5be5048dc3fc$var$k = $43fb5be5048dc3fc$var$b ? Symbol.for("react.context") : 60110, $43fb5be5048dc3fc$var$l = $43fb5be5048dc3fc$var$b ? Symbol.for("react.async_mode") : 60111, $43fb5be5048dc3fc$var$m = $43fb5be5048dc3fc$var$b ? Symbol.for("react.concurrent_mode") : 60111, $43fb5be5048dc3fc$var$n = $43fb5be5048dc3fc$var$b ? Symbol.for("react.forward_ref") : 60112, $43fb5be5048dc3fc$var$p = $43fb5be5048dc3fc$var$b ? Symbol.for("react.suspense") : 60113, $43fb5be5048dc3fc$var$q = $43fb5be5048dc3fc$var$b ? Symbol.for("react.suspense_list") : 60120, $43fb5be5048dc3fc$var$r = $43fb5be5048dc3fc$var$b ? Symbol.for("react.memo") : 60115, $43fb5be5048dc3fc$var$t = $43fb5be5048dc3fc$var$b ? Symbol.for("react.lazy") : 60116, $43fb5be5048dc3fc$var$v = $43fb5be5048dc3fc$var$b ? Symbol.for("react.block") : 60121, $43fb5be5048dc3fc$var$w = $43fb5be5048dc3fc$var$b ? Symbol.for("react.fundamental") : 60117, $43fb5be5048dc3fc$var$x = $43fb5be5048dc3fc$var$b ? Symbol.for("react.responder") : 60118, $43fb5be5048dc3fc$var$y = $43fb5be5048dc3fc$var$b ? Symbol.for("react.scope") : 60119;
function $43fb5be5048dc3fc$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $43fb5be5048dc3fc$var$c:
                switch(a = a.type, a){
                    case $43fb5be5048dc3fc$var$l:
                    case $43fb5be5048dc3fc$var$m:
                    case $43fb5be5048dc3fc$var$e:
                    case $43fb5be5048dc3fc$var$g:
                    case $43fb5be5048dc3fc$var$f:
                    case $43fb5be5048dc3fc$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $43fb5be5048dc3fc$var$k:
                            case $43fb5be5048dc3fc$var$n:
                            case $43fb5be5048dc3fc$var$t:
                            case $43fb5be5048dc3fc$var$r:
                            case $43fb5be5048dc3fc$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $43fb5be5048dc3fc$var$d:
                return u;
        }
    }
}
function $43fb5be5048dc3fc$var$A(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$m;
}
$43fb5be5048dc3fc$export$2b8d127b894957b9 = $43fb5be5048dc3fc$var$l;
$43fb5be5048dc3fc$export$cea3a54a6425200c = $43fb5be5048dc3fc$var$m;
$43fb5be5048dc3fc$export$a7c73072b1a182ae = $43fb5be5048dc3fc$var$k;
$43fb5be5048dc3fc$export$9f27bc3417b4524d = $43fb5be5048dc3fc$var$h;
$43fb5be5048dc3fc$export$db77ccec0bb4ccac = $43fb5be5048dc3fc$var$c;
$43fb5be5048dc3fc$export$8392c0c9d3dcbd35 = $43fb5be5048dc3fc$var$n;
$43fb5be5048dc3fc$export$ffb0004e005737fa = $43fb5be5048dc3fc$var$e;
$43fb5be5048dc3fc$export$b624eff549462981 = $43fb5be5048dc3fc$var$t;
$43fb5be5048dc3fc$export$7897aa7841a5380c = $43fb5be5048dc3fc$var$r;
$43fb5be5048dc3fc$export$602eac185826482c = $43fb5be5048dc3fc$var$d;
$43fb5be5048dc3fc$export$e2c29f18771995cb = $43fb5be5048dc3fc$var$g;
$43fb5be5048dc3fc$export$5f8d39834fd61797 = $43fb5be5048dc3fc$var$f;
$43fb5be5048dc3fc$export$74bf444e3cd11ea5 = $43fb5be5048dc3fc$var$p;
$43fb5be5048dc3fc$export$92387174baf9b227 = function(a) {
    return $43fb5be5048dc3fc$var$A(a) || $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$l;
};
$43fb5be5048dc3fc$export$ec112efeb987d9c6 = $43fb5be5048dc3fc$var$A;
$43fb5be5048dc3fc$export$b706b080d889d2c9 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$k;
};
$43fb5be5048dc3fc$export$5be5a87408f70ddc = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$h;
};
$43fb5be5048dc3fc$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $43fb5be5048dc3fc$var$c;
};
$43fb5be5048dc3fc$export$455c2e768291efa6 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$n;
};
$43fb5be5048dc3fc$export$9522e17588c12572 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$e;
};
$43fb5be5048dc3fc$export$2110ac352bb060b9 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$t;
};
$43fb5be5048dc3fc$export$56885ab8b9c456ab = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$r;
};
$43fb5be5048dc3fc$export$d927fcb6adf8f9de = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$d;
};
$43fb5be5048dc3fc$export$b82d16f27459e05a = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$g;
};
$43fb5be5048dc3fc$export$522c17b4f5e123e8 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$f;
};
$43fb5be5048dc3fc$export$1aabd8a0274ecfd6 = function(a) {
    return $43fb5be5048dc3fc$var$z(a) === $43fb5be5048dc3fc$var$p;
};
$43fb5be5048dc3fc$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $43fb5be5048dc3fc$var$e || a === $43fb5be5048dc3fc$var$m || a === $43fb5be5048dc3fc$var$g || a === $43fb5be5048dc3fc$var$f || a === $43fb5be5048dc3fc$var$p || a === $43fb5be5048dc3fc$var$q || "object" === typeof a && null !== a && (a.$$typeof === $43fb5be5048dc3fc$var$t || a.$$typeof === $43fb5be5048dc3fc$var$r || a.$$typeof === $43fb5be5048dc3fc$var$h || a.$$typeof === $43fb5be5048dc3fc$var$k || a.$$typeof === $43fb5be5048dc3fc$var$n || a.$$typeof === $43fb5be5048dc3fc$var$w || a.$$typeof === $43fb5be5048dc3fc$var$x || a.$$typeof === $43fb5be5048dc3fc$var$y || a.$$typeof === $43fb5be5048dc3fc$var$v);
};
$43fb5be5048dc3fc$export$f5bbd400c2f4426f = $43fb5be5048dc3fc$var$z;

});



parcelRegister("gnUbQ", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $beda617c2f4d9e44$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $beda617c2f4d9e44$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $beda617c2f4d9e44$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $beda617c2f4d9e44$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $beda617c2f4d9e44$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $beda617c2f4d9e44$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $beda617c2f4d9e44$export$3fae2929ed23c202(map, pl, field) {
    return $beda617c2f4d9e44$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $beda617c2f4d9e44$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $beda617c2f4d9e44$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $beda617c2f4d9e44$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
var $beda617c2f4d9e44$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $beda617c2f4d9e44$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("8NEa0", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $66820d552d796baa$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $66820d552d796baa$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $66820d552d796baa$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $66820d552d796baa$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $66820d552d796baa$export$4ee1db8ce44a209b; });

var $9z2vN = parcelRequire("9z2vN");

var $94939 = parcelRequire("94939");

var $lP9wQ = parcelRequire("lP9wQ");

var $lP6cc = parcelRequire("lP6cc");
function $66820d552d796baa$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $66820d552d796baa$var$defaultErrorHandler = function(error) {};
var $66820d552d796baa$var$defaultWarnHandler = function(warning) {};
var $66820d552d796baa$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $66820d552d796baa$var$defaultErrorHandler,
    onWarn: $66820d552d796baa$var$defaultWarnHandler
};
function $66820d552d796baa$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $66820d552d796baa$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $66820d552d796baa$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $66820d552d796baa$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $lP9wQ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    var getNumberFormat = (0, $lP9wQ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.number),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    var getPluralRules = (0, $lP9wQ.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $9z2vN.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $66820d552d796baa$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $lP9wQ.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $lP9wQ.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $94939.IntlMessageFormat)(message, locales, overrideFormats, (0, $9z2vN.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.message),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $lP9wQ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $lP9wQ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.list),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getDisplayNames: (0, $lP9wQ.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $66820d552d796baa$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $lP9wQ.strategies).variadic
        })
    };
}
function $66820d552d796baa$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $lP6cc.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("94939", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $699b81de35ec8128$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $9z2vN = parcelRequire("9z2vN");

var $i2ZbQ = parcelRequire("i2ZbQ");

var $lP9wQ = parcelRequire("lP9wQ");

var $j2lh9 = parcelRequire("j2lh9");
// -- MessageFormat --------------------------------------------------------
function $699b81de35ec8128$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $699b81de35ec8128$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $699b81de35ec8128$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $9z2vN.__assign)({}, defaultConfig));
}
function $699b81de35ec8128$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $699b81de35ec8128$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $lP9wQ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $699b81de35ec8128$var$createFastMemoizeCache(cache.number),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getDateTimeFormat: (0, $lP9wQ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $699b81de35ec8128$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $lP9wQ.strategies).variadic
        }),
        getPluralRules: (0, $lP9wQ.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $9z2vN.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $699b81de35ec8128$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $lP9wQ.strategies).variadic
        })
    };
}
var $699b81de35ec8128$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $j2lh9.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $j2lh9.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $9z2vN.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $699b81de35ec8128$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $699b81de35ec8128$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $i2ZbQ.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("i2ZbQ", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("jLPqv")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("jLPqv")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("jLPqv")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("jLPqv")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("jLPqv")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("jLPqv")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("jLPqv")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("jLPqv")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("jLPqv")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("jLPqv")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("jLPqv")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("jLPqv")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $d237e0f7e67bb514$export$98e6a39c04603d36; });

var $9z2vN = parcelRequire("9z2vN");

var $zIwe5 = parcelRequire("zIwe5");

var $eV8Pj = parcelRequire("eV8Pj");

var $jLPqv = parcelRequire("jLPqv");
function $d237e0f7e67bb514$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $jLPqv.isSelectElement)(el) || (0, $jLPqv.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $d237e0f7e67bb514$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $jLPqv.isNumberElement)(el) && (0, $jLPqv.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $jLPqv.isDateElement)(el) || (0, $jLPqv.isTimeElement)(el)) && (0, $jLPqv.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $jLPqv.isTagElement)(el)) $d237e0f7e67bb514$var$pruneLocation(el.children);
    });
}
function $d237e0f7e67bb514$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $9z2vN.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $eV8Pj.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $zIwe5.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $d237e0f7e67bb514$var$pruneLocation(result.val);
    return result.val;
}
var $d237e0f7e67bb514$export$d3c1bfa0f7d806e9 = (0, $eV8Pj.Parser);

});
parcelRegister("zIwe5", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $06b5cd804c8dc602$export$896afd8541959ee5; });
var $06b5cd804c8dc602$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($06b5cd804c8dc602$export$896afd8541959ee5 || ($06b5cd804c8dc602$export$896afd8541959ee5 = {}));

});

parcelRegister("eV8Pj", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $adcd3c59f858a742$export$7acfa6ed01010e37; });

var $9z2vN = parcelRequire("9z2vN");

var $zIwe5 = parcelRequire("zIwe5");

var $jLPqv = parcelRequire("jLPqv");

var $97Qso = parcelRequire("97Qso");
parcelRequire("fqgzG");
var $4zpL2 = parcelRequire("4zpL2");
var $dj054 = parcelRequire("dj054");

var $9MUUG = parcelRequire("9MUUG");
var $adcd3c59f858a742$var$_a;
var $adcd3c59f858a742$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $97Qso.SPACE_SEPARATOR_REGEX).source, "*"));
var $adcd3c59f858a742$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $97Qso.SPACE_SEPARATOR_REGEX).source, "*$"));
function $adcd3c59f858a742$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $adcd3c59f858a742$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $adcd3c59f858a742$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $adcd3c59f858a742$var$hasNativeFromEntries = !!Object.fromEntries;
var $adcd3c59f858a742$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $adcd3c59f858a742$var$hasTrimStart = !!String.prototype.trimStart;
var $adcd3c59f858a742$var$hasTrimEnd = !!String.prototype.trimEnd;
var $adcd3c59f858a742$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $adcd3c59f858a742$var$isSafeInteger = $adcd3c59f858a742$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $adcd3c59f858a742$var$re = $adcd3c59f858a742$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = (($adcd3c59f858a742$var$_a = $adcd3c59f858a742$var$re.exec("a")) === null || $adcd3c59f858a742$var$_a === void 0 ? void 0 : $adcd3c59f858a742$var$_a[0]) === "a";
} catch (_) {
    $adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $adcd3c59f858a742$var$startsWith = $adcd3c59f858a742$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $adcd3c59f858a742$var$fromCodePoint = $adcd3c59f858a742$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $adcd3c59f858a742$var$fromEntries = // native
$adcd3c59f858a742$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $adcd3c59f858a742$var$codePointAt = $adcd3c59f858a742$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $adcd3c59f858a742$var$trimStart = $adcd3c59f858a742$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($adcd3c59f858a742$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $adcd3c59f858a742$var$trimEnd = $adcd3c59f858a742$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($adcd3c59f858a742$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $adcd3c59f858a742$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $adcd3c59f858a742$var$matchIdentifierAtIndex;
if ($adcd3c59f858a742$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1 = $adcd3c59f858a742$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $adcd3c59f858a742$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $adcd3c59f858a742$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$adcd3c59f858a742$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $adcd3c59f858a742$var$codePointAt(s, index);
        if (c === undefined || $adcd3c59f858a742$var$_isWhiteSpace(c) || $adcd3c59f858a742$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $adcd3c59f858a742$var$fromCodePoint.apply(void 0, match);
};
var $adcd3c59f858a742$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $jLPqv.TYPE).pound,
                    location: $adcd3c59f858a742$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $zIwe5.ErrorKind).UNMATCHED_CLOSING_TAG, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $adcd3c59f858a742$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $jLPqv.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$adcd3c59f858a742$var$_isAlpha(this.char())) return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $zIwe5.ErrorKind).UNMATCHED_CLOSING_TAG, $adcd3c59f858a742$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $jLPqv.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $zIwe5.ErrorKind).UNCLOSED_TAG, $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $zIwe5.ErrorKind).INVALID_TAG, $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $adcd3c59f858a742$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $adcd3c59f858a742$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $jLPqv.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$adcd3c59f858a742$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $adcd3c59f858a742$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $adcd3c59f858a742$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $zIwe5.ErrorKind).EMPTY_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $zIwe5.ErrorKind).MALFORMED_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $jLPqv.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $zIwe5.ErrorKind).MALFORMED_ARGUMENT, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $adcd3c59f858a742$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $adcd3c59f858a742$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_TYPE, $adcd3c59f858a742$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $adcd3c59f858a742$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_STYLE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $adcd3c59f858a742$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $adcd3c59f858a742$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $adcd3c59f858a742$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $jLPqv.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $zIwe5.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $9MUUG.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $jLPqv.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $4zpL2.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $jLPqv.TYPE).date : (0, $jLPqv.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $jLPqv.TYPE).number : argType === "date" ? (0, $jLPqv.TYPE).date : (0, $jLPqv.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $adcd3c59f858a742$var$createLocation(typeEndPosition_1, (0, $9z2vN.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $zIwe5.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $jLPqv.TYPE).select,
                        value: value,
                        options: $adcd3c59f858a742$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $jLPqv.TYPE).plural,
                        value: value,
                        options: $adcd3c59f858a742$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $zIwe5.ErrorKind).INVALID_ARGUMENT_TYPE, $adcd3c59f858a742$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $zIwe5.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $zIwe5.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $adcd3c59f858a742$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $dj054.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $zIwe5.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $jLPqv.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $dj054.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $zIwe5.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $adcd3c59f858a742$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $zIwe5.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $adcd3c59f858a742$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $zIwe5.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $zIwe5.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $zIwe5.ErrorKind).MISSING_OTHER_CLAUSE, $adcd3c59f858a742$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $adcd3c59f858a742$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$adcd3c59f858a742$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $adcd3c59f858a742$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($adcd3c59f858a742$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $adcd3c59f858a742$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $adcd3c59f858a742$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $adcd3c59f858a742$var$_isAlphaOrSlash(codepoint) {
    return $adcd3c59f858a742$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $adcd3c59f858a742$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $adcd3c59f858a742$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $adcd3c59f858a742$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("jLPqv", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $e64a4c55aec85874$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $e64a4c55aec85874$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $e64a4c55aec85874$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $e64a4c55aec85874$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $e64a4c55aec85874$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $e64a4c55aec85874$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $e64a4c55aec85874$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $e64a4c55aec85874$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $e64a4c55aec85874$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $e64a4c55aec85874$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $e64a4c55aec85874$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $e64a4c55aec85874$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $e64a4c55aec85874$export$7680c41f1a55f4cf; });
var $e64a4c55aec85874$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($e64a4c55aec85874$export$b87f371cbc396fcf || ($e64a4c55aec85874$export$b87f371cbc396fcf = {}));
var $e64a4c55aec85874$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($e64a4c55aec85874$export$906452485466fa53 || ($e64a4c55aec85874$export$906452485466fa53 = {}));
function $e64a4c55aec85874$export$cfa10c5697238752(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.literal;
}
function $e64a4c55aec85874$export$4f55724281bdfaf9(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.argument;
}
function $e64a4c55aec85874$export$e11187b219e191e1(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.number;
}
function $e64a4c55aec85874$export$32d811605da75f40(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.date;
}
function $e64a4c55aec85874$export$34ec46f596b1702f(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.time;
}
function $e64a4c55aec85874$export$dcfe1c11d168b5a1(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.select;
}
function $e64a4c55aec85874$export$6c796d116f0a4fbc(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.plural;
}
function $e64a4c55aec85874$export$c0ece297bdd0c082(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.pound;
}
function $e64a4c55aec85874$export$5c83de34745812b(el) {
    return el.type === $e64a4c55aec85874$export$b87f371cbc396fcf.tag;
}
function $e64a4c55aec85874$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $e64a4c55aec85874$export$906452485466fa53.number);
}
function $e64a4c55aec85874$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $e64a4c55aec85874$export$906452485466fa53.dateTime);
}
function $e64a4c55aec85874$export$f0ac572c1121c662(value) {
    return {
        type: $e64a4c55aec85874$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $e64a4c55aec85874$export$425e864b0ba114f1(value, style) {
    return {
        type: $e64a4c55aec85874$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("97Qso", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $6a4d75562b3bb5ad$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $6a4d75562b3bb5ad$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $6a4d75562b3bb5ad$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("fqgzG", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("4zpL2")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("dj054")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("dj054")).parseNumberSkeletonFromString; });
parcelRequire("4zpL2");
parcelRequire("dj054");

});
parcelRegister("4zpL2", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $353e69429bc36371$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $353e69429bc36371$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $353e69429bc36371$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($353e69429bc36371$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "short" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("dj054", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $9afd1cbe03da4361$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $9afd1cbe03da4361$export$47c6f8480bda3e11; });

var $9z2vN = parcelRequire("9z2vN");

var $13QqM = parcelRequire("13QqM");
function $9afd1cbe03da4361$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $13QqM.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $9afd1cbe03da4361$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $9afd1cbe03da4361$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $9afd1cbe03da4361$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $9afd1cbe03da4361$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $9afd1cbe03da4361$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $9afd1cbe03da4361$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $9afd1cbe03da4361$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $9afd1cbe03da4361$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $9afd1cbe03da4361$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, all), $9afd1cbe03da4361$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, all), $9afd1cbe03da4361$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($9afd1cbe03da4361$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($9afd1cbe03da4361$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($9afd1cbe03da4361$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), $9afd1cbe03da4361$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($9afd1cbe03da4361$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), $9afd1cbe03da4361$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $9afd1cbe03da4361$var$parseSign(token.stem);
        if (signOpts) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $9afd1cbe03da4361$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("13QqM", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $0c5ebdf325f9961b$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $0c5ebdf325f9961b$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("9MUUG", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $7204be880d6ab633$export$29c5368be8904d27; });

var $dcRpX = parcelRequire("dcRpX");
function $7204be880d6ab633$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $7204be880d6ab633$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $7204be880d6ab633$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $dcRpX.timeData)[regionTag || ""] || (0, $dcRpX.timeData)[languageTag || ""] || (0, $dcRpX.timeData)["".concat(languageTag, "-001")] || (0, $dcRpX.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("dcRpX", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $99d5d4fb8b2486a4$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $99d5d4fb8b2486a4$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("lP9wQ", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $fe35c09d846f3c47$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $fe35c09d846f3c47$export$c5491a8691a23b9e; });
//
// Main
//
function $fe35c09d846f3c47$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $fe35c09d846f3c47$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $fe35c09d846f3c47$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $fe35c09d846f3c47$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $fe35c09d846f3c47$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $fe35c09d846f3c47$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $fe35c09d846f3c47$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fe35c09d846f3c47$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $fe35c09d846f3c47$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $fe35c09d846f3c47$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $fe35c09d846f3c47$var$monadic : $fe35c09d846f3c47$var$variadic;
    return $fe35c09d846f3c47$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $fe35c09d846f3c47$var$strategyVariadic(fn, options) {
    return $fe35c09d846f3c47$var$assemble(fn, this, $fe35c09d846f3c47$var$variadic, options.cache.create(), options.serializer);
}
function $fe35c09d846f3c47$var$strategyMonadic(fn, options) {
    return $fe35c09d846f3c47$var$assemble(fn, this, $fe35c09d846f3c47$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $fe35c09d846f3c47$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $fe35c09d846f3c47$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$fe35c09d846f3c47$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$fe35c09d846f3c47$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $fe35c09d846f3c47$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $fe35c09d846f3c47$var$ObjectWithoutPrototypeCache();
    }
};
var $fe35c09d846f3c47$export$c5491a8691a23b9e = {
    variadic: $fe35c09d846f3c47$var$strategyVariadic,
    monadic: $fe35c09d846f3c47$var$strategyMonadic
};

});

parcelRegister("j2lh9", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $ddbeb5205240cedc$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $ddbeb5205240cedc$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $ddbeb5205240cedc$export$275d4a3bb5f66fda; });
parcelRequire("i2ZbQ");
var $jLPqv = parcelRequire("jLPqv");

var $oJsBd = parcelRequire("oJsBd");
var $ddbeb5205240cedc$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($ddbeb5205240cedc$export$49694c2877b44c57 || ($ddbeb5205240cedc$export$49694c2877b44c57 = {}));
function $ddbeb5205240cedc$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $ddbeb5205240cedc$export$49694c2877b44c57.literal || part.type !== $ddbeb5205240cedc$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $ddbeb5205240cedc$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $ddbeb5205240cedc$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $jLPqv.isLiteralElement)(els[0])) return [
        {
            type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $jLPqv.isLiteralElement)(el)) {
            result.push({
                type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $jLPqv.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $oJsBd.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $jLPqv.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $ddbeb5205240cedc$export$49694c2877b44c57.literal : $ddbeb5205240cedc$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $jLPqv.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $jLPqv.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $jLPqv.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $ddbeb5205240cedc$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $jLPqv.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$ddbeb5205240cedc$export$df0c12a2d414a163(formatFn)) throw new (0, $oJsBd.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $ddbeb5205240cedc$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $ddbeb5205240cedc$export$49694c2877b44c57.literal : $ddbeb5205240cedc$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $jLPqv.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $oJsBd.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ddbeb5205240cedc$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $jLPqv.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $oJsBd.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $oJsBd.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $oJsBd.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $ddbeb5205240cedc$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $ddbeb5205240cedc$var$mergeLiteral(result);
}

});
parcelRegister("oJsBd", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $04a581784316d597$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $04a581784316d597$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $04a581784316d597$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $04a581784316d597$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $04a581784316d597$export$8bfc137e4d23fdf0; });

var $9z2vN = parcelRequire("9z2vN");
var $04a581784316d597$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($04a581784316d597$export$d4e71bc0b80dc0fb || ($04a581784316d597$export$d4e71bc0b80dc0fb = {}));
var $04a581784316d597$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $04a581784316d597$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $04a581784316d597$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($04a581784316d597$export$7369836851cc1329);
var $04a581784316d597$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $04a581784316d597$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($04a581784316d597$export$7369836851cc1329);
var $04a581784316d597$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $04a581784316d597$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($04a581784316d597$export$7369836851cc1329);

});



parcelRegister("lP6cc", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $fe332ac1850f4860$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $fe332ac1850f4860$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $fe332ac1850f4860$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $fe332ac1850f4860$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $fe332ac1850f4860$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $fe332ac1850f4860$export$2ddcb436d0aa3688; });

var $9z2vN = parcelRequire("9z2vN");
var $fe332ac1850f4860$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($fe332ac1850f4860$export$557d6acb76e8a244 || ($fe332ac1850f4860$export$557d6acb76e8a244 = {}));
var $fe332ac1850f4860$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $fe332ac1850f4860$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);
var $fe332ac1850f4860$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($fe332ac1850f4860$export$e3b7eee1dbc44895);
var $fe332ac1850f4860$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $fe332ac1850f4860$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($fe332ac1850f4860$export$c016d36112f6ddf8);

});


parcelRegister("8DOyJ", function(module, exports) {

var $c6xLk = parcelRequire("c6xLk");

var $e903j = parcelRequire("e903j");

var $7zITW = parcelRequire("7zITW");

var $2dglx = parcelRequire("2dglx");

var $4SjZI = parcelRequire("4SjZI");

var $5XBaI = parcelRequire("5XBaI");

var $iEft7 = parcelRequire("iEft7");
function $64a92f3db44660c3$var$_regeneratorRuntime() {
    "use strict";
    var r = $e903j(), e = r.m($64a92f3db44660c3$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $iEft7(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $64a92f3db44660c3$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $c6xLk(r, e);
            },
            AsyncIterator: $4SjZI,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $2dglx : $7zITW)(a(r), e, t, o, u);
            },
            keys: $5XBaI,
            values: $iEft7
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $64a92f3db44660c3$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c6xLk", function(module, exports) {
function $8d003c0e25d5425f$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $8d003c0e25d5425f$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e903j", function(module, exports) {

var $a8WUN = parcelRequire("a8WUN");
function $a4c1f26142aaa450$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $a8WUN(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($a8WUN(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $a8WUN(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $a8WUN(u, "constructor", GeneratorFunctionPrototype), $a8WUN(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $a8WUN(GeneratorFunctionPrototype, o, "GeneratorFunction"), $a8WUN(u), $a8WUN(u, o, "Generator"), $a8WUN(u, n, function() {
        return this;
    }), $a8WUN(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $a4c1f26142aaa450$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $a4c1f26142aaa450$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("a8WUN", function(module, exports) {
function $76285a0622efb52b$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $76285a0622efb52b$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $76285a0622efb52b$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $76285a0622efb52b$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $76285a0622efb52b$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("7zITW", function(module, exports) {

var $2dglx = parcelRequire("2dglx");
function $583ea1ba1d6939b4$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $2dglx(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $583ea1ba1d6939b4$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2dglx", function(module, exports) {

var $e903j = parcelRequire("e903j");

var $4SjZI = parcelRequire("4SjZI");
function $19c979b4ea27cf86$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $4SjZI($e903j().w(r, e, t, o), n || Promise);
}
module.exports = $19c979b4ea27cf86$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4SjZI", function(module, exports) {

var $c6xLk = parcelRequire("c6xLk");

var $a8WUN = parcelRequire("a8WUN");
function $38cbb70b85fd6cb7$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $c6xLk ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($a8WUN($38cbb70b85fd6cb7$var$AsyncIterator.prototype), $a8WUN($38cbb70b85fd6cb7$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $a8WUN(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $38cbb70b85fd6cb7$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5XBaI", function(module, exports) {
function $456f4c01de3b3969$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $456f4c01de3b3969$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("iEft7", function(module, exports) {

var $bIERV = parcelRequire("bIERV");
var $d937f629966a246f$var$_typeof = $bIERV.default;
function $d937f629966a246f$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($d937f629966a246f$var$_typeof(e) + " is not iterable");
}
module.exports = $d937f629966a246f$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bIERV", function(module, exports) {
function $88838175a27ffdef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $88838175a27ffdef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $88838175a27ffdef$var$_typeof(o);
}
module.exports = $88838175a27ffdef$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("5zPyl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40f835f4dda1a4b8$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useInteractionContext", function () { return $40f835f4dda1a4b8$export$11bcb6e9af2aca35; });

var $iSvIT = parcelRequire("iSvIT");

var $1zxzU = parcelRequire("1zxzU");
var $40f835f4dda1a4b8$export$2e2bcd8739ae039 = (0, $1zxzU.default);
function $40f835f4dda1a4b8$export$11bcb6e9af2aca35() {
    return (0, $iSvIT.useContext)((0, $1zxzU.default));
}

});
parcelRegister("1zxzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12531b3ec1c68be2$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");
var $12531b3ec1c68be2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);

});


parcelRegister("4CDPb", function(module, exports) {

$parcel$export(module.exports, "DefaultInteractionID", function () { return $35d99a5bf5d3f476$export$3109542b68df9ba1; });
$parcel$export(module.exports, "default", function () { return $35d99a5bf5d3f476$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "getInteractionId", function () { return $35d99a5bf5d3f476$export$37bca3107733ac1e; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $iSvIT = parcelRequire("iSvIT");
// Same structure as react's useRef.
// This allows modals to use a ref to scope their value
// const id = useRef(null);
// <InteractionIDContext.Provider value={id}>...<
// Subscription system for interaction ID changes
var $35d99a5bf5d3f476$var$listeners = new Set();
// Observable interaction ID implementation
var $35d99a5bf5d3f476$var$ObservableInteractionID = /*#__PURE__*/ function() {
    function ObservableInteractionID() {
        (0, $i385U.default)(this, ObservableInteractionID);
        (0, $dqOGO.default)(this, "_current", null);
    }
    return (0, $c19Op.default)(ObservableInteractionID, [
        {
            key: "current",
            get: function get() {
                return this._current;
            },
            set: function set(newId) {
                var oldId = this._current;
                this._current = newId;
                // Notify all listeners if the ID actually changed
                if (oldId !== newId) $35d99a5bf5d3f476$var$listeners.forEach(function(listener) {
                    return listener(newId);
                });
            }
        }
    ]);
}(); // Type declaration for globalThis extension
// Ensures a single DefaultInteractionID instance exists across the entire application,
// even when the module is loaded multiple times in different contexts
var $35d99a5bf5d3f476$var$initializeGlobalDefaultInteractionID = function initializeGlobalDefaultInteractionID() {
    // Return existing instance if already initialized
    if (globalThis.__UFO_DEFAULT_INTERACTION_ID__) return globalThis.__UFO_DEFAULT_INTERACTION_ID__;
    // Create and store new instance globally
    var instance = new $35d99a5bf5d3f476$var$ObservableInteractionID();
    globalThis.__UFO_DEFAULT_INTERACTION_ID__ = instance;
    return instance;
};
var $35d99a5bf5d3f476$export$3109542b68df9ba1 = $35d99a5bf5d3f476$var$initializeGlobalDefaultInteractionID();
var $35d99a5bf5d3f476$export$3e0c3023952f6774 = function subscribeToInteractionIdChanges(listener) {
    $35d99a5bf5d3f476$var$listeners.add(listener);
    return function() {
        $35d99a5bf5d3f476$var$listeners.delete(listener);
    };
};
// We use a context to allow modals to have their own lifecycle
var $35d99a5bf5d3f476$var$interactionContext = /*#__PURE__*/ (0, $iSvIT.createContext)($35d99a5bf5d3f476$export$3109542b68df9ba1);
var $35d99a5bf5d3f476$export$2e2bcd8739ae039 = $35d99a5bf5d3f476$var$interactionContext;
var $35d99a5bf5d3f476$export$37bca3107733ac1e = function getInteractionId() {
    return $35d99a5bf5d3f476$export$3109542b68df9ba1;
};
var $35d99a5bf5d3f476$export$9f6000531b78127e = function useInteractionId() {
    return $35d99a5bf5d3f476$export$3109542b68df9ba1;
};

});
parcelRegister("i385U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d23ec92d68398f5c$export$2e2bcd8739ae039; });
function $d23ec92d68398f5c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("c19Op", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bfd307d024eade1$export$2e2bcd8739ae039; });

var $9B17d = parcelRequire("9B17d");
function $8bfd307d024eade1$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9B17d.default)(o.key), o);
    }
}
function $8bfd307d024eade1$export$2e2bcd8739ae039(e, r, t) {
    return r && $8bfd307d024eade1$var$_defineProperties(e.prototype, r), t && $8bfd307d024eade1$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("9B17d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fc86f436176a23e$export$2e2bcd8739ae039; });

var $8pSiD = parcelRequire("8pSiD");

var $bmAkB = parcelRequire("bmAkB");
function $6fc86f436176a23e$export$2e2bcd8739ae039(t) {
    var i = (0, $bmAkB.default)(t, "string");
    return "symbol" == (0, $8pSiD.default)(i) ? i : i + "";
}

});
parcelRegister("8pSiD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $620ac7471c56f888$export$2e2bcd8739ae039; });
function $620ac7471c56f888$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $620ac7471c56f888$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620ac7471c56f888$export$2e2bcd8739ae039(o);
}

});

parcelRegister("bmAkB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $845dee666aa1512a$export$2e2bcd8739ae039; });

var $8pSiD = parcelRequire("8pSiD");
function $845dee666aa1512a$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8pSiD.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8pSiD.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("dqOGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c7505eda35abe96$export$2e2bcd8739ae039; });

var $9B17d = parcelRequire("9B17d");
function $9c7505eda35abe96$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9B17d.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});


parcelRegister("hkP9U", function(module, exports) {

$parcel$export(module.exports, "PreviousInteractionLog", function () { return $c9ebfcfabfbce032$export$dbba6cdedab4e68b; });
$parcel$export(module.exports, "postInteractionLog", function () { return $c9ebfcfabfbce032$export$d8f52e8f804021e8; });
$parcel$export(module.exports, "interactionExtraMetrics", function () { return $c9ebfcfabfbce032$export$481f88116dc8b7ad; });
$parcel$export(module.exports, "segmentUnmountCache", function () { return $c9ebfcfabfbce032$export$a2b14406ded37d60; });
$parcel$export(module.exports, "getActiveInteraction", function () { return $c9ebfcfabfbce032$export$2b3954d2e8509985; });
$parcel$export(module.exports, "remove", function () { return $c9ebfcfabfbce032$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "updatePageLoadInteractionName", function () { return $c9ebfcfabfbce032$export$f6f1cf5bedf83c71; });
$parcel$export(module.exports, "addCustomData", function () { return $c9ebfcfabfbce032$export$e4380431c2bdabee; });
$parcel$export(module.exports, "addCustomTiming", function () { return $c9ebfcfabfbce032$export$27cacb7d7f3fe20a; });
$parcel$export(module.exports, "addMark", function () { return $c9ebfcfabfbce032$export$728e28c22a0fba4; });
$parcel$export(module.exports, "markFirstSegmentLoad", function () { return $c9ebfcfabfbce032$export$85d1eb835f669bf; });
$parcel$export(module.exports, "addSpan", function () { return $c9ebfcfabfbce032$export$2c1d6e17cfa9bbc7; });
$parcel$export(module.exports, "addHold", function () { return $c9ebfcfabfbce032$export$7606887303596f82; });
$parcel$export(module.exports, "addHoldByID", function () { return $c9ebfcfabfbce032$export$10582acd678c213; });
$parcel$export(module.exports, "removeHoldByID", function () { return $c9ebfcfabfbce032$export$4983dfbbb996f7ae; });
$parcel$export(module.exports, "getCurrentInteractionType", function () { return $c9ebfcfabfbce032$export$2df109852219d16e; });
$parcel$export(module.exports, "addError", function () { return $c9ebfcfabfbce032$export$239c33984d9b1367; });
$parcel$export(module.exports, "addProfilerTimings", function () { return $c9ebfcfabfbce032$export$53d6f611de951a13; });
$parcel$export(module.exports, "sinkInteractionHandler", function () { return $c9ebfcfabfbce032$export$9e614a29a1ac213e; });
$parcel$export(module.exports, "sinkPostInteractionLogHandler", function () { return $c9ebfcfabfbce032$export$8a1ba7bef607358a; });
$parcel$export(module.exports, "tryComplete", function () { return $c9ebfcfabfbce032$export$673be905888f8839; });
$parcel$export(module.exports, "abort", function () { return $c9ebfcfabfbce032$export$5def58af4fd46132; });
$parcel$export(module.exports, "abortByNewInteraction", function () { return $c9ebfcfabfbce032$export$c4a545284f55edf2; });
$parcel$export(module.exports, "abortAll", function () { return $c9ebfcfabfbce032$export$614a7af2affc5dff; });
$parcel$export(module.exports, "addNewInteraction", function () { return $c9ebfcfabfbce032$export$1a1ed1e1fdb2006b; });
$parcel$export(module.exports, "addApdex", function () { return $c9ebfcfabfbce032$export$35220fd6cdd1b731; });
$parcel$export(module.exports, "addRequestInfo", function () { return $c9ebfcfabfbce032$export$57d55b4569823d8f; });
$parcel$export(module.exports, "addSegment", function () { return $c9ebfcfabfbce032$export$1c43f9ac826b6462; });
$parcel$export(module.exports, "removeSegment", function () { return $c9ebfcfabfbce032$export$d0365e48b58231c3; });
$parcel$export(module.exports, "interactionSpans", function () { return $c9ebfcfabfbce032$export$6ce04c7ca6810a7e; });

var $2sYxo = parcelRequire("2sYxo");

var $jzYu7 = parcelRequire("jzYu7");

var $dqOGO = parcelRequire("dqOGO");

var $1m3mf = parcelRequire("1m3mf");

var $aKGMT = parcelRequire("aKGMT");

var $k18d6 = parcelRequire("k18d6");

var $jxLBU = parcelRequire("jxLBU");

var $2J5Gv = parcelRequire("2J5Gv");

var $bs6hr = parcelRequire("bs6hr");

var $jyanA = parcelRequire("jyanA");

var $gjbIv = parcelRequire("gjbIv");

var $2EE0j = parcelRequire("2EE0j");

var $9jPnd = parcelRequire("9jPnd");

var $gZAnH = parcelRequire("gZAnH");

var $4CDPb = parcelRequire("4CDPb");

var $cQxll = parcelRequire("cQxll");

var $kbJIl = parcelRequire("kbJIl");

var $4Wnvy = parcelRequire("4Wnvy");

var $f8snl = parcelRequire("f8snl");

var $kgUIu = parcelRequire("kgUIu");
function $c9ebfcfabfbce032$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c9ebfcfabfbce032$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c9ebfcfabfbce032$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c9ebfcfabfbce032$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c9ebfcfabfbce032$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c9ebfcfabfbce032$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c9ebfcfabfbce032$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c9ebfcfabfbce032$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c9ebfcfabfbce032$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c9ebfcfabfbce032$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c9ebfcfabfbce032$export$dbba6cdedab4e68b = {
    id: undefined,
    name: undefined,
    type: undefined,
    isAborted: undefined,
    timestamp: undefined
};
var $c9ebfcfabfbce032$export$d8f52e8f804021e8 = new (0, $kgUIu.default)();
var $c9ebfcfabfbce032$export$481f88116dc8b7ad = new (0, $f8snl.default)();
var $c9ebfcfabfbce032$var$interactionQueue = [];
var $c9ebfcfabfbce032$var$segmentCache = new Map();
var $c9ebfcfabfbce032$export$a2b14406ded37d60 = new Map(); // Temporarily store segment unmount counts
var $c9ebfcfabfbce032$var$firstSegmentLoadMarked = false;
var $c9ebfcfabfbce032$var$segmentObservers = [];
function $c9ebfcfabfbce032$export$2b3954d2e8509985() {
    var interactionId = (0, $4CDPb.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $4Wnvy.interactions).get(interactionId.current);
}
function $c9ebfcfabfbce032$var$isPerformanceTracingEnabled() {
    var _getConfig;
    return ((_getConfig = (0, $bs6hr.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.enableAdditionalPerformanceMarks) || window.__REACT_UFO_ENABLE_PERF_TRACING || false;
}
var $c9ebfcfabfbce032$var$performanceEventObserver;
var $c9ebfcfabfbce032$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $c9ebfcfabfbce032$var$performanceEventObserver = $c9ebfcfabfbce032$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $c9ebfcfabfbce032$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === "click") $c9ebfcfabfbce032$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $c9ebfcfabfbce032$var$performanceEventObserver;
};
var $c9ebfcfabfbce032$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = $c9ebfcfabfbce032$export$2b3954d2e8509985();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === "press") {
        var responsiveness = interaction.responsiveness || {};
        // if happens there is another event interaction that has started after
        // the initial one, we don't want to replace the values if they have already
        // been set up
        responsiveness.experimentalInputToNextPaint = responsiveness.experimentalInputToNextPaint || entry.duration;
        responsiveness.inputDelay = responsiveness.experimentalInputToNextPaint || entry.processingStart - entry.startTime;
        interaction.responsiveness = responsiveness;
        // if the entry start time is lower than the one in the interaction
        // it means the interaction start time is not accurate, we assign
        // this value which will match the timestamp in the event
        if (entry.startTime < interaction.start) interaction.start = entry.startTime;
    }
};
function $c9ebfcfabfbce032$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, $1m3mf.default)(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $c9ebfcfabfbce032$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $c9ebfcfabfbce032$var$addSegmentObserver(observer) {
    $c9ebfcfabfbce032$var$segmentObservers.push(observer);
    var _iterator2 = $c9ebfcfabfbce032$var$_createForOfIteratorHelper($c9ebfcfabfbce032$var$segmentCache.values()), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var segmentInfo = _step2.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $c9ebfcfabfbce032$var$removeSegmentObserver(observer) {
    var index = $c9ebfcfabfbce032$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $c9ebfcfabfbce032$var$segmentObservers.splice(index, 1);
}
function $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId) {
    (0, $4Wnvy.interactions).delete(interactionId);
}
function $c9ebfcfabfbce032$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $c9ebfcfabfbce032$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $c9ebfcfabfbce032$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $c9ebfcfabfbce032$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, $dqOGO.default)({}, i, data[i])
        });
    });
}
function $c9ebfcfabfbce032$export$20265b12c6625451(interactionId, key, value) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction == null) return;
    // Allow null and undefined values
    if (value === null || value === undefined) {
        interaction.cohortingCustomData.set(key, value);
        return;
    }
    // Validate that the value is a primitive (number, boolean, or string)
    if (typeof value !== "number" && typeof value !== "boolean" && typeof value !== "string") return;
    // Validate string length (max 50 characters)
    if (typeof value === "string" && value.length > 50) return;
    interaction.cohortingCustomData.set(key, value);
}
function $c9ebfcfabfbce032$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, $jzYu7.default)(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: "tertiary-light"
                        }
                    }
                });
            } catch (_unused) {
            // do nothing
            }
        }
    }
}
function $c9ebfcfabfbce032$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $c9ebfcfabfbce032$export$85d1eb835f669bf(interactionId, labelStack) {
    var time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (!(0, $jxLBU.fg)("platform_mark_ufo_segment_first_load")) return;
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null && !$c9ebfcfabfbce032$var$firstSegmentLoadMarked) {
        $c9ebfcfabfbce032$var$firstSegmentLoadMarked = true;
        interaction.marks.push({
            type: "first_segment_load",
            name: "first_segment_load",
            labelStack: labelStack,
            time: time
        });
    }
}
function $c9ebfcfabfbce032$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $4Wnvy.interactions).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) performance.mark("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $c9ebfcfabfbce032$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end,
                detail: {
                    devtools: {
                        track: "\uD83D\uDEF8 reactUFO detailed timings",
                        color: "secondary"
                    }
                }
            });
        } catch (_unused2) {
        // do nothing
        }
    }
}
function $c9ebfcfabfbce032$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $4Wnvy.interactions).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: "secondary"
                }
            }
        });
    } catch (_unused3) {
    // do nothing
    }
}
function $c9ebfcfabfbce032$export$9e04fe1a58571ec(moduleId, timestamp) {
    $c9ebfcfabfbce032$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $c9ebfcfabfbce032$export$6f228d1fdc911d7(identifier, start, end) {
    $c9ebfcfabfbce032$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $c9ebfcfabfbce032$var$moduleLoadingRequests = {};
function $c9ebfcfabfbce032$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $c9ebfcfabfbce032$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $c9ebfcfabfbce032$var$labelStackToString(labelStack), name, startTime);
}
function $c9ebfcfabfbce032$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $c9ebfcfabfbce032$export$7606887303596f82(interactionId, labelStack, name, _experimental) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    var id = (0, $k18d6.v4)();
    if (!interaction) // add hold timestamp to post interaction log if interaction is complete
    $c9ebfcfabfbce032$export$d8f52e8f804021e8.addHoldInfo(labelStack, name, performance.now());
    if (interaction != null) {
        var start = performance.now();
        var holdActive = {
            labelStack: labelStack,
            name: name,
            start: start
        };
        var is3pHold = labelStack.some(function(l) {
            return "type" in l && l.type === "third-party";
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, $c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
        } else {
            interaction.holdActive.set(id, $c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, holdActive), {}, {
                start: start
            }));
            $c9ebfcfabfbce032$var$addHoldCriterion(id, labelStack, name, start);
        }
        return function() {
            var end = performance.now();
            if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: "secondary-light"
                        }
                    }
                });
            } catch (_unused4) {
            // do nothing
            }
            $c9ebfcfabfbce032$var$removeHoldCriterion(id);
            var currentInteraction = (0, $4Wnvy.interactions).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            var expHold = interaction.holdExpActive.get(id);
            if (currentInteraction != null) {
                if (currentHold != null) {
                    currentInteraction.holdInfo.push($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, currentHold), {}, {
                        end: end
                    }));
                    interaction.holdActive.delete(id);
                }
                if (expHold != null) {
                    currentInteraction.holdExpInfo.push($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, expHold), {}, {
                        end: end
                    }));
                    interaction.holdExpActive.delete(id);
                }
                if (interaction.hold3pActive) {
                    var current3pHold = interaction.hold3pActive.get(id);
                    if (current3pHold != null) {
                        if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                        currentInteraction.hold3pInfo.push($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, current3pHold), {}, {
                            end: end
                        }));
                        interaction.hold3pActive.delete(id);
                    }
                }
            }
        };
    }
    return function() {};
}
function $c9ebfcfabfbce032$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        var is3pHold = labelStack.some(function(l) {
            return "type" in l && l.type === "third-party";
        });
        if (is3pHold) {
            if (!interaction.hold3pActive) interaction.hold3pActive = new Map();
            interaction.hold3pActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
        } else {
            interaction.holdActive.set(id, {
                labelStack: labelStack,
                name: name,
                start: start,
                ignoreOnSubmit: ignoreOnSubmit
            });
            $c9ebfcfabfbce032$var$addHoldCriterion(id, labelStack, name, start);
        }
    }
    return function() {};
}
function $c9ebfcfabfbce032$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $4Wnvy.interactions).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $c9ebfcfabfbce032$var$removeHoldCriterion(id);
        }
        if (interaction.hold3pActive) {
            var current3pHold = interaction.hold3pActive.get(id);
            if (currentInteraction != null && current3pHold != null) {
                if (!currentInteraction.hold3pInfo) currentInteraction.hold3pInfo = [];
                currentInteraction.hold3pInfo.push($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, current3pHold), {}, {
                    end: end
                }));
                interaction.hold3pActive.delete(id);
            }
        }
    }
}
function $c9ebfcfabfbce032$export$2df109852219d16e(interactionId) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $c9ebfcfabfbce032$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $c9ebfcfabfbce032$export$9e04fe1a58571ec($c9ebfcfabfbce032$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $c9ebfcfabfbce032$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $c9ebfcfabfbce032$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $c9ebfcfabfbce032$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $c9ebfcfabfbce032$var$moduleLoadingRequests[info.identifier];
            $c9ebfcfabfbce032$export$6f228d1fdc911d7($c9ebfcfabfbce032$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $4CDPb.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $c9ebfcfabfbce032$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $4CDPb.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $c9ebfcfabfbce032$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $c9ebfcfabfbce032$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError, errorHash, errorStatusCode) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError,
        errorHash: errorHash,
        errorStatusCode: errorStatusCode
    });
}
function $c9ebfcfabfbce032$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack, errorHash, errorStatusCode) {
    (0, $4Wnvy.interactions).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack,
            errorHash: errorHash,
            errorStatusCode: errorStatusCode
        });
    });
}
function $c9ebfcfabfbce032$export$53d6f611de951a13(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig2;
    if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration,
            detail: {
                devtools: {
                    track: "\uD83D\uDEF8 reactUFO detailed timings",
                    color: "secondary-dark"
                }
            }
        });
    } catch (_unused5) {
    // do nothing
    }
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig2 = (0, $bs6hr.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.postInteractionLog) !== null && _getConfig2 !== void 0 && _getConfig2.enabled) $c9ebfcfabfbce032$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
}
function $c9ebfcfabfbce032$var$pushToQueue(id, data) {
    $c9ebfcfabfbce032$var$interactionQueue.push({
        id: id,
        data: data
    });
}
var $c9ebfcfabfbce032$var$handleInteraction = $c9ebfcfabfbce032$var$pushToQueue;
function $c9ebfcfabfbce032$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
function $c9ebfcfabfbce032$var$finishInteraction(id, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end,
            detail: {
                devtools: {
                    track: "main metrics",
                    trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                    color: "tertiary"
                }
            }
        });
        performance.mark("TTAI", {
            startTime: data.end,
            detail: {
                devtools: {
                    dataType: "marker"
                }
            }
        });
    } catch (_unused6) {
    // do nothing
    }
    if (data.featureFlags) data.featureFlags.during = Object.fromEntries((0, $gZAnH.currentFeatureFlagsAccessed));
    (0, $9jPnd.clearActiveTrace)();
    $c9ebfcfabfbce032$var$callCleanUpCallbacks(data);
    (0, $cQxll.flushSsrRenderProfilerTraces)();
    if (data.type === "page_load") data.hydration = (0, $bs6hr.getReactHydrationStats)();
    // By this time, stop the post interaction log observer if coinflip rate is 0
    var sanitisedUfoName = (0, $2EE0j.sanitizeUfoName)(data.ufoName);
    if (!(0, $2J5Gv.default)((0, $bs6hr.getPostInteractionRate)(sanitisedUfoName, data.type))) $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
    if (!(0, $2J5Gv.default)((0, $bs6hr.getExtraInteractionRate)(sanitisedUfoName, data.type))) $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(id);
    else if (!data.hold3pActive || data.hold3pActive.size === 0) {
        var _getConfig3;
        if (!((_getConfig3 = (0, $bs6hr.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.experimentalInteractionMetrics) !== null && _getConfig3 !== void 0 && _getConfig3.enabled)) $c9ebfcfabfbce032$export$cd7f480d6b8286c3(id);
    }
    if ((0, $jxLBU.fg)("platform_ufo_enable_terminal_errors")) {
        $c9ebfcfabfbce032$export$dbba6cdedab4e68b.id = data.id;
        $c9ebfcfabfbce032$export$dbba6cdedab4e68b.type = data.type;
        $c9ebfcfabfbce032$export$dbba6cdedab4e68b.timestamp = data.end;
    }
    $c9ebfcfabfbce032$export$dbba6cdedab4e68b.name = data.ufoName || "unknown";
    $c9ebfcfabfbce032$export$dbba6cdedab4e68b.isAborted = data.abortReason != null;
    if (data.ufoName) {
        var _interactionExtraMetr;
        if (((_interactionExtraMetr = $c9ebfcfabfbce032$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr === void 0 ? void 0 : _interactionExtraMetr.id) !== id) // If this same interaction was not already handled, handle it
        $c9ebfcfabfbce032$var$handleInteraction(id, data);
    }
    if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $c9ebfcfabfbce032$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator3 = $c9ebfcfabfbce032$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _step3$value = (0, $jzYu7.default)(_step3.value, 2), _step3$value$ = _step3$value[1], labelStack = _step3$value$.labelStack, start = _step3$value$.start, end = _step3$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($c9ebfcfabfbce032$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end,
                        detail: {
                            devtools: {
                                track: "\uD83D\uDEF8 reactUFO detailed timings",
                                color: "secondary-dark"
                            }
                        }
                    });
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        } catch (_unused7) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent("UFO_FINISH_INTERACTION", {
            detail: data
        }));
    } catch (_unused8) {
    // do nothing
    }
}
function $c9ebfcfabfbce032$export$9e614a29a1ac213e(sinkFn) {
    if ($c9ebfcfabfbce032$var$handleInteraction === $c9ebfcfabfbce032$var$pushToQueue) {
        $c9ebfcfabfbce032$var$handleInteraction = sinkFn;
        $c9ebfcfabfbce032$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $c9ebfcfabfbce032$var$interactionQueue.length = 0;
    }
}
function $c9ebfcfabfbce032$export$8a1ba7bef607358a(sinkFn) {
    $c9ebfcfabfbce032$export$d8f52e8f804021e8.sinkHandler(sinkFn);
}
// a flag to prevent multiple submitting
var $c9ebfcfabfbce032$var$activeSubmitted = false;
function $c9ebfcfabfbce032$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        var _interaction$hold3pAc;
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var noMoreExpHolds = interaction.holdExpActive.size === 0;
        var shouldUseRawDataThirdParty = (0, $bs6hr.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var postInteraction = /*#__PURE__*/ function() {
            var _ref = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee() {
                var _getConfig4, _interactionExtraMetr2;
                var _getConfig5, experimentalVC90, experimentalTTAI, _yield$getExperimenta, start, end, _getConfig6;
                return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_getConfig4 = (0, $bs6hr.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.postInteractionLog) !== null && _getConfig4 !== void 0 && _getConfig4.enabled)) {
                                _context.next = 17;
                                break;
                            }
                            if (!((_getConfig5 = (0, $bs6hr.getConfig)()) !== null && _getConfig5 !== void 0 && (_getConfig5 = _getConfig5.experimentalInteractionMetrics) !== null && _getConfig5 !== void 0 && _getConfig5.enabled)) {
                                _context.next = 16;
                                break;
                            }
                            _context.next = 4;
                            return (0, $jyanA.getExperimentalVCMetrics)(interaction);
                        case 4:
                            _context.t1 = _yield$getExperimenta = _context.sent;
                            _context.t0 = _context.t1 === null;
                            if (_context.t0) {
                                _context.next = 8;
                                break;
                            }
                            _context.t0 = _yield$getExperimenta === void 0;
                        case 8:
                            if (!_context.t0) {
                                _context.next = 12;
                                break;
                            }
                            _context.t2 = void 0;
                            _context.next = 13;
                            break;
                        case 12:
                            _context.t2 = _yield$getExperimenta["metric:experimental:vc90"];
                        case 13:
                            experimentalVC90 = _context.t2;
                            start = interaction.start, end = interaction.end;
                            experimentalTTAI = !interaction.abortReason ? Math.round(end - start) : undefined;
                        case 16:
                            $c9ebfcfabfbce032$export$d8f52e8f804021e8.onInteractionComplete($c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, interaction), {}, {
                                experimentalTTAI: experimentalTTAI,
                                experimentalVC90: experimentalVC90
                            }));
                        case 17:
                            if (((_interactionExtraMetr2 = $c9ebfcfabfbce032$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr2 === void 0 ? void 0 : _interactionExtraMetr2.id) !== interactionId) // If interactionExtraMetrics is not waiting for measuring this interaction
                            {
                                if ((_getConfig6 = (0, $bs6hr.getConfig)()) !== null && _getConfig6 !== void 0 && (_getConfig6 = _getConfig6.experimentalInteractionMetrics) !== null && _getConfig6 !== void 0 && _getConfig6.enabled) $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
                            }
                            $c9ebfcfabfbce032$var$activeSubmitted = false;
                        case 19:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function postInteraction() {
                return _ref.apply(this, arguments);
            };
        }();
        var noMoreActive3pHolds = ((_interaction$hold3pAc = interaction.hold3pActive) === null || _interaction$hold3pAc === void 0 ? void 0 : _interaction$hold3pAc.size) === 0 || interaction.hold3pActive === undefined;
        // If using raw data third party behavior, wait for 3p holds to clear
        if (shouldUseRawDataThirdParty) {
            // If there are no non-3p holds active, mark the interaction as successful
            // but don't finish until 3p holds are cleared
            if (noMoreActiveHolds && !noMoreActive3pHolds) {
                // Mark interaction as successful by setting endTime, but don't finish yet
                if (endTime !== undefined && interaction.end === 0) interaction.end = endTime;
                // Wait for 3p holds to clear before finishing
                return;
            }
            // If all holds (including 3p) are cleared, finish the interaction
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                if (!$c9ebfcfabfbce032$var$activeSubmitted) {
                    var _getConfig7, _getConfig8, _getConfig9;
                    // Set end3p to current time when 3p holds cleared, but ensure it's at least interaction.end
                    var currentTime = endTime !== null && endTime !== void 0 ? endTime : performance.now();
                    interaction.end3p = interaction.end !== 0 && currentTime < interaction.end ? interaction.end : currentTime;
                    $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction, interaction.end !== 0 ? interaction.end : endTime);
                    if ((_getConfig7 = (0, $bs6hr.getConfig)()) !== null && _getConfig7 !== void 0 && (_getConfig7 = _getConfig7.extraInteractionMetrics) !== null && _getConfig7 !== void 0 && _getConfig7.enabled) $c9ebfcfabfbce032$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig8 = (0, $bs6hr.getConfig)()) !== null && _getConfig8 !== void 0 && (_getConfig8 = _getConfig8.extraSearchPageInteraction) !== null && _getConfig8 !== void 0 && _getConfig8.enabled && interaction.ufoName === ((_getConfig9 = (0, $bs6hr.getConfig)()) === null || _getConfig9 === void 0 || (_getConfig9 = _getConfig9.extraSearchPageInteraction) === null || _getConfig9 === void 0 ? void 0 : _getConfig9.searchPageMetricName)) (0, $gjbIv.onSearchPageInteractionComplete)(interactionId, interaction);
                    $c9ebfcfabfbce032$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig0;
                    if ((_getConfig0 = (0, $bs6hr.getConfig)()) !== null && _getConfig0 !== void 0 && (_getConfig0 = _getConfig0.experimentalInteractionMetrics) !== null && _getConfig0 !== void 0 && _getConfig0.enabled) (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction, endTime || interaction.end);
                    postInteraction();
                }
            }
            // Send separated third-party event even when feature flag is active
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var data = $c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, interaction), {}, {
                    end: endTime || interaction.end
                });
                $c9ebfcfabfbce032$export$481f88116dc8b7ad.onInteractionComplete(interactionId, data);
            }
        } else {
            var _interactionExtraMetr3;
            // Original behavior when feature flag is not active
            if (noMoreActiveHolds && ((_interactionExtraMetr3 = $c9ebfcfabfbce032$export$481f88116dc8b7ad.finishedInteraction) === null || _interactionExtraMetr3 === void 0 ? void 0 : _interactionExtraMetr3.id) !== interactionId) {
                // If it's not waiting for extra metrics to complete, finish the interaction as normal
                if (!$c9ebfcfabfbce032$var$activeSubmitted) {
                    var _getConfig1, _getConfig10, _getConfig11;
                    $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction, endTime);
                    if ((_getConfig1 = (0, $bs6hr.getConfig)()) !== null && _getConfig1 !== void 0 && (_getConfig1 = _getConfig1.extraInteractionMetrics) !== null && _getConfig1 !== void 0 && _getConfig1.enabled) $c9ebfcfabfbce032$export$481f88116dc8b7ad.updateFinishedInteraction(interaction);
                    if ((_getConfig10 = (0, $bs6hr.getConfig)()) !== null && _getConfig10 !== void 0 && (_getConfig10 = _getConfig10.extraSearchPageInteraction) !== null && _getConfig10 !== void 0 && _getConfig10.enabled && interaction.ufoName === ((_getConfig11 = (0, $bs6hr.getConfig)()) === null || _getConfig11 === void 0 || (_getConfig11 = _getConfig11.extraSearchPageInteraction) === null || _getConfig11 === void 0 ? void 0 : _getConfig11.searchPageMetricName)) (0, $gjbIv.onSearchPageInteractionComplete)(interactionId, interaction);
                    $c9ebfcfabfbce032$var$activeSubmitted = true;
                }
                if (noMoreExpHolds) {
                    var _getConfig12;
                    if ((_getConfig12 = (0, $bs6hr.getConfig)()) !== null && _getConfig12 !== void 0 && (_getConfig12 = _getConfig12.experimentalInteractionMetrics) !== null && _getConfig12 !== void 0 && _getConfig12.enabled) (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                    postInteraction();
                }
            }
            if (noMoreActiveHolds && noMoreActive3pHolds) {
                var _data2 = $c9ebfcfabfbce032$var$_objectSpread($c9ebfcfabfbce032$var$_objectSpread({}, interaction), {}, {
                    end: endTime
                });
                $c9ebfcfabfbce032$export$481f88116dc8b7ad.onInteractionComplete(interactionId, _data2);
            }
        }
    }
}
function $c9ebfcfabfbce032$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $c9ebfcfabfbce032$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $bs6hr.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction, endTime);
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
            $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $c9ebfcfabfbce032$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction);
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
        $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction);
            $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
        }
    }
}
function $c9ebfcfabfbce032$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        var shouldUseRawDataThirdParty = (0, $bs6hr.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            // Set end3p to current time, but ensure it's at least interaction.end
            interaction.end3p = performance.now();
            $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction, endTime);
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
            $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        $c9ebfcfabfbce032$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction);
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
        $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction);
            $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
        }
    } else if ((0, $jxLBU.fg)("platform_reset_post_interaction_on_new_interaction")) {
        // post-interaction log is active after interaction is aborted by new one
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
    }
}
function $c9ebfcfabfbce032$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    var activeInteraction = $c9ebfcfabfbce032$export$2b3954d2e8509985();
    var finishInteractions = (0, $bs6hr.getFinishInteractionOnTransition)();
    (0, $4Wnvy.interactions).forEach(function(interaction, interactionId) {
        var isActiveInteraction = activeInteraction === interaction;
        var hasFinished = interaction.holdActive.size === 0;
        if (isActiveInteraction && abortReason === "transition" && interaction.type === "press" && finishInteractions !== null && finishInteractions !== void 0 && finishInteractions.includes(interaction.ufoName)) hasFinished = true;
        var shouldUseRawDataThirdParty = (0, $bs6hr.shouldUseRawDataThirdPartyBehavior)(interaction.ufoName, interaction.type);
        var noMoreActiveHolds = interaction.holdActive.size === 0;
        var has3pHoldsActive = interaction.hold3pActive && interaction.hold3pActive.size > 0;
        // If only third-party holds are active, finish as successful instead of aborting
        if (shouldUseRawDataThirdParty && noMoreActiveHolds && has3pHoldsActive) {
            var endTime = interaction.end !== 0 ? interaction.end : performance.now();
            interaction.end3p = performance.now();
            $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction, endTime);
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
            $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
            $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
            if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
                (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction, endTime);
                $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
            }
            return;
        }
        if (!hasFinished) {
            $c9ebfcfabfbce032$var$callCancelCallbacks(interaction);
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $c9ebfcfabfbce032$var$finishInteraction(interactionId, interaction);
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
        $c9ebfcfabfbce032$export$d8f52e8f804021e8.stopVCObserver();
        $c9ebfcfabfbce032$export$481f88116dc8b7ad.stopAll(interactionId);
        if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(interaction.ufoName, interaction.type))) {
            (0, $jyanA.onExperimentalInteractionComplete)(interactionId, interaction);
            $c9ebfcfabfbce032$export$cd7f480d6b8286c3(interactionId);
        }
    });
}
function $c9ebfcfabfbce032$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $4Wnvy.interactions).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $c9ebfcfabfbce032$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _config$extraSearchPa, _config$extraSearchPa2;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    $c9ebfcfabfbce032$export$481f88116dc8b7ad.reset();
    $c9ebfcfabfbce032$export$d8f52e8f804021e8.reset();
    var vcObserver;
    var previousTime = startTime;
    var timeoutTime = (0, $bs6hr.getInteractionTimeout)(ufoName);
    var timerID = setTimeout(function() {
        $c9ebfcfabfbce032$export$5def58af4fd46132(interactionId, "timeout");
    }, timeoutTime);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $c9ebfcfabfbce032$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $2J5Gv.default)((0, $bs6hr.getCapabilityRate)("feature_flag_access"));
    var config = (0, $bs6hr.getConfig)();
    var searchPageConfig = {
        enableSmartAnswersMutations: config === null || config === void 0 || (_config$extraSearchPa = config.extraSearchPageInteraction) === null || _config$extraSearchPa === void 0 ? void 0 : _config$extraSearchPa.enabled,
        searchPageRoute: config === null || config === void 0 || (_config$extraSearchPa2 = config.extraSearchPageInteraction) === null || _config$extraSearchPa2 === void 0 ? void 0 : _config$extraSearchPa2.searchPageRoute
    };
    if (config && config.vc) {
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders,
            searchPageConfig: searchPageConfig
        };
        vcObserver = (0, $kbJIl.newVCObserver)(vcOptions);
    }
    var priorAccessedFg = type === "press" && (0, $jxLBU.fg)("platform_ufo_drop_prior_fg_interactions") ? {} : Object.fromEntries((0, $gZAnH.allFeatureFlagsAccessed));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $c9ebfcfabfbce032$export$dbba6cdedab4e68b.name,
        isPreviousInteractionAborted: $c9ebfcfabfbce032$export$dbba6cdedab4e68b.isAborted === true,
        marks: [],
        customData: [],
        cohortingCustomData: new Map(),
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdExpInfo: [],
        holdActive: new Map(),
        holdExpActive: new Map(),
        // measure when we execute this code
        // from this, we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: priorAccessedFg,
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace,
        vcObserver: vcObserver,
        hold3pActive: new Map(),
        hold3pInfo: [],
        minorInteractions: []
    };
    if (addFeatureFlagsToInteraction) (0, $gZAnH.currentFeatureFlagsAccessed).clear();
    (0, $4Wnvy.interactions).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $c9ebfcfabfbce032$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $c9ebfcfabfbce032$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    // Add cleanup for per-interaction VC observer
    if (vcObserver) metrics.cleanupCallbacks.push(function() {
        vcObserver.stop(ufoName);
    });
    var awaitBM3TTIList = (0, $bs6hr.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $c9ebfcfabfbce032$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition" || type === "page_load") {
        var _getConfig13, _config$extraInteract;
        // Use per-interaction VC observer if available, otherwise fall back to global
        var observer = vcObserver;
        if (observer) observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
        // Start post interaction observer for all if config is enabled
        // in case ufoName is updated at later time
        if ((_getConfig13 = (0, $bs6hr.getConfig)()) !== null && _getConfig13 !== void 0 && (_getConfig13 = _getConfig13.postInteractionLog) !== null && _getConfig13 !== void 0 && _getConfig13.enabled) $c9ebfcfabfbce032$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
        if ((0, $2J5Gv.default)((0, $bs6hr.getExperimentalInteractionRate)(ufoName, type))) (0, $jyanA.experimentalVC).start({
            startTime: startTime
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) $c9ebfcfabfbce032$export$481f88116dc8b7ad.startVCObserver({
            startTime: startTime
        }, interactionId);
    }
    if (type === "press") {
        // Use per-interaction VC observer if available, otherwise fall back to global
        var _observer = vcObserver;
        if (_observer) _observer.start({
            startTime: startTime,
            experienceKey: ufoName
        });
    }
}
function $c9ebfcfabfbce032$export$4a759336b50e86e3(event) {
    var interaction = $c9ebfcfabfbce032$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") $c9ebfcfabfbce032$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
    }
}
function $c9ebfcfabfbce032$export$ad216cc25852d44b(apdex) {
    (0, $4Wnvy.interactions).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime,
                detail: {
                    devtools: {
                        track: "main metrics",
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: "primary-dark"
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdex.stopTime,
                detail: {
                    devtools: {
                        dataType: "marker"
                    }
                }
            });
        } catch (_unused9) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") $c9ebfcfabfbce032$export$4983dfbbb996f7ae(key, interaction.ufoName);
    });
}
function $c9ebfcfabfbce032$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        track: "main metrics",
                        trackGroup: "\uD83D\uDEF8 reactUFO metrics",
                        color: "primary-dark"
                    }
                }
            });
            performance.mark("[bm3] TTI", {
                startTime: apdexInfo.stopTime,
                detail: {
                    devtools: {
                        dataType: "marker"
                    }
                }
            });
        } catch (_unused0) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") $c9ebfcfabfbce032$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
    }
}
function $c9ebfcfabfbce032$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($c9ebfcfabfbce032$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $c9ebfcfabfbce032$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $c9ebfcfabfbce032$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($c9ebfcfabfbce032$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $c9ebfcfabfbce032$export$1c43f9ac826b6462(labelStack) {
    var key = $c9ebfcfabfbce032$var$getSegmentCacheKey(labelStack);
    var existingSegment = $c9ebfcfabfbce032$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $c9ebfcfabfbce032$var$segmentCache.set(key, segmentInfo);
        $c9ebfcfabfbce032$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $c9ebfcfabfbce032$export$d0365e48b58231c3(labelStack) {
    var key = $c9ebfcfabfbce032$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $c9ebfcfabfbce032$var$segmentCache.get(key);
    if (segmentInfo) {
        $c9ebfcfabfbce032$var$segmentCache.delete(JSON.stringify(labelStack));
        var cacheKey = (0, $2EE0j.stringifyLabelStackFully)(labelStack);
        $c9ebfcfabfbce032$export$a2b14406ded37d60.set(cacheKey, ($c9ebfcfabfbce032$export$a2b14406ded37d60.get(cacheKey) || 0) + 1);
        $c9ebfcfabfbce032$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $c9ebfcfabfbce032$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $4Wnvy.interactions).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if ($c9ebfcfabfbce032$var$isPerformanceTracingEnabled()) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time,
                    detail: {
                        devtools: {
                            track: "\uD83D\uDEF8 reactUFO detailed timings",
                            color: "tertiary"
                        }
                    }
                });
            } catch (_unused1) {
            // do nothing
            }
        }
    }
}
var $c9ebfcfabfbce032$export$6ce04c7ca6810a7e = [];
var $c9ebfcfabfbce032$var$defaultLabelStack = [
    {
        name: "custom"
    }
];
function $c9ebfcfabfbce032$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $c9ebfcfabfbce032$var$defaultLabelStack;
    var customSpan = {
        type: "custom",
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $c9ebfcfabfbce032$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("2sYxo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cbd27d23a3f1081$export$2e2bcd8739ae039; });
function $1cbd27d23a3f1081$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $1cbd27d23a3f1081$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $1cbd27d23a3f1081$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $1cbd27d23a3f1081$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("jzYu7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e410343bbd699987$export$2e2bcd8739ae039; });

var $5TPYD = parcelRequire("5TPYD");

var $zR4yc = parcelRequire("zR4yc");

var $9ywyf = parcelRequire("9ywyf");

var $fvRnZ = parcelRequire("fvRnZ");
function $e410343bbd699987$export$2e2bcd8739ae039(r, e) {
    return (0, $5TPYD.default)(r) || (0, $zR4yc.default)(r, e) || (0, $9ywyf.default)(r, e) || (0, $fvRnZ.default)();
}

});
parcelRegister("5TPYD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $011bc7e060abd528$export$2e2bcd8739ae039; });
function $011bc7e060abd528$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("zR4yc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06bc70123a0b1532$export$2e2bcd8739ae039; });
function $06bc70123a0b1532$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9ywyf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f508a10ae0bd5d1$export$2e2bcd8739ae039; });

var $5Qb9B = parcelRequire("5Qb9B");
function $6f508a10ae0bd5d1$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5Qb9B.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5Qb9B.default)(r, a) : void 0;
    }
}

});
parcelRegister("5Qb9B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440a75fbe2f9ddc8$export$2e2bcd8739ae039; });
function $440a75fbe2f9ddc8$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("fvRnZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4b32999591fc7ce$export$2e2bcd8739ae039; });
function $b4b32999591fc7ce$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("1m3mf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fca7351d3420ab1$export$2e2bcd8739ae039; });

var $8NyZq = parcelRequire("8NyZq");

var $10ocj = parcelRequire("10ocj");

var $9ywyf = parcelRequire("9ywyf");

var $7d9Dh = parcelRequire("7d9Dh");
function $0fca7351d3420ab1$export$2e2bcd8739ae039(r) {
    return (0, $8NyZq.default)(r) || (0, $10ocj.default)(r) || (0, $9ywyf.default)(r) || (0, $7d9Dh.default)();
}

});
parcelRegister("8NyZq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $667e0a8a38dadd68$export$2e2bcd8739ae039; });

var $5Qb9B = parcelRequire("5Qb9B");
function $667e0a8a38dadd68$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $5Qb9B.default)(r);
}

});

parcelRegister("10ocj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bb88fae90af8919$export$2e2bcd8739ae039; });
function $0bb88fae90af8919$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("7d9Dh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5401381df6ba4396$export$2e2bcd8739ae039; });
function $5401381df6ba4396$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("aKGMT", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $7d3f640153d7f398$var$runtime = (parcelRequire("cJ4Dw"))();
module.exports = $7d3f640153d7f398$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $7d3f640153d7f398$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7d3f640153d7f398$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7d3f640153d7f398$var$runtime);
}

});
parcelRegister("cJ4Dw", function(module, exports) {

var $8swrb = parcelRequire("8swrb");

var $h8ddZ = parcelRequire("h8ddZ");

var $grMNq = parcelRequire("grMNq");

var $9YfnU = parcelRequire("9YfnU");

var $7SSrB = parcelRequire("7SSrB");

var $27wbP = parcelRequire("27wbP");

var $cyOPu = parcelRequire("cyOPu");
function $943d48b01171fa98$var$_regeneratorRuntime() {
    "use strict";
    var r = $h8ddZ(), e = r.m($943d48b01171fa98$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $cyOPu(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $943d48b01171fa98$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $8swrb(r, e);
            },
            AsyncIterator: $7SSrB,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $9YfnU : $grMNq)(a(r), e, t, o, u);
            },
            keys: $27wbP,
            values: $cyOPu
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $943d48b01171fa98$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8swrb", function(module, exports) {
function $628a19a9ba2e8e6e$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $628a19a9ba2e8e6e$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("h8ddZ", function(module, exports) {

var $8Ac9L = parcelRequire("8Ac9L");
function $c78d7126f01bdb81$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $8Ac9L(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($8Ac9L(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $8Ac9L(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $8Ac9L(u, "constructor", GeneratorFunctionPrototype), $8Ac9L(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $8Ac9L(GeneratorFunctionPrototype, o, "GeneratorFunction"), $8Ac9L(u), $8Ac9L(u, o, "Generator"), $8Ac9L(u, n, function() {
        return this;
    }), $8Ac9L(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $c78d7126f01bdb81$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $c78d7126f01bdb81$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("8Ac9L", function(module, exports) {
function $63fb1d915078f27a$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $63fb1d915078f27a$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $63fb1d915078f27a$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $63fb1d915078f27a$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $63fb1d915078f27a$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("grMNq", function(module, exports) {

var $9YfnU = parcelRequire("9YfnU");
function $bf9504e2eabb5406$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $9YfnU(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $bf9504e2eabb5406$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9YfnU", function(module, exports) {

var $h8ddZ = parcelRequire("h8ddZ");

var $7SSrB = parcelRequire("7SSrB");
function $7425a6bbcfd04b17$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $7SSrB($h8ddZ().w(r, e, t, o), n || Promise);
}
module.exports = $7425a6bbcfd04b17$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7SSrB", function(module, exports) {

var $8swrb = parcelRequire("8swrb");

var $8Ac9L = parcelRequire("8Ac9L");
function $5bd7cf0992b943ff$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $8swrb ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($8Ac9L($5bd7cf0992b943ff$var$AsyncIterator.prototype), $8Ac9L($5bd7cf0992b943ff$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $8Ac9L(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $5bd7cf0992b943ff$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("27wbP", function(module, exports) {
function $18b5346a38427bf8$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $18b5346a38427bf8$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cyOPu", function(module, exports) {

var $9Ww7d = parcelRequire("9Ww7d");
var $925016adaca6a811$var$_typeof = $9Ww7d.default;
function $925016adaca6a811$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($925016adaca6a811$var$_typeof(e) + " is not iterable");
}
module.exports = $925016adaca6a811$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9Ww7d", function(module, exports) {
function $73d2714741ffd617$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $73d2714741ffd617$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $73d2714741ffd617$var$_typeof(o);
}
module.exports = $73d2714741ffd617$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("k18d6", function(module, exports) {

var $9XRyD = parcelRequire("9XRyD");

var $5LVAx = parcelRequire("5LVAx");
var $e92a450fcdfa04b3$var$uuid = $5LVAx;
$e92a450fcdfa04b3$var$uuid.v1 = $9XRyD;
$e92a450fcdfa04b3$var$uuid.v4 = $5LVAx;
module.exports = $e92a450fcdfa04b3$var$uuid;

});
parcelRegister("9XRyD", function(module, exports) {

var $iBitj = parcelRequire("iBitj");

var $cyw6l = parcelRequire("cyw6l");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $74132b30e690bae2$var$_nodeId;
var $74132b30e690bae2$var$_clockseq;
// Previous uuid creation time
var $74132b30e690bae2$var$_lastMSecs = 0;
var $74132b30e690bae2$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $74132b30e690bae2$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $74132b30e690bae2$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $74132b30e690bae2$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $iBitj();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $74132b30e690bae2$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $74132b30e690bae2$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $74132b30e690bae2$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $74132b30e690bae2$var$_lastMSecs + (nsecs - $74132b30e690bae2$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $74132b30e690bae2$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $74132b30e690bae2$var$_lastMSecs = msecs;
    $74132b30e690bae2$var$_lastNSecs = nsecs;
    $74132b30e690bae2$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $cyw6l(b);
}
module.exports = $74132b30e690bae2$var$v1;

});
parcelRegister("iBitj", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $d8aa02cec64c577a$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($d8aa02cec64c577a$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $d8aa02cec64c577a$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $d8aa02cec64c577a$var$getRandomValues($d8aa02cec64c577a$var$rnds8);
        return $d8aa02cec64c577a$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $d8aa02cec64c577a$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $d8aa02cec64c577a$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $d8aa02cec64c577a$var$rnds;
    };
}

});

parcelRegister("cyw6l", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $92418fa4f6b47ba9$var$byteToHex = [];
for(var $92418fa4f6b47ba9$var$i = 0; $92418fa4f6b47ba9$var$i < 256; ++$92418fa4f6b47ba9$var$i)$92418fa4f6b47ba9$var$byteToHex[$92418fa4f6b47ba9$var$i] = ($92418fa4f6b47ba9$var$i + 0x100).toString(16).substr(1);
function $92418fa4f6b47ba9$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $92418fa4f6b47ba9$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $92418fa4f6b47ba9$var$bytesToUuid;

});


parcelRegister("5LVAx", function(module, exports) {

var $iBitj = parcelRequire("iBitj");

var $cyw6l = parcelRequire("cyw6l");
function $433e036104e809ea$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $iBitj)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $cyw6l(rnds);
}
module.exports = $433e036104e809ea$var$v4;

});


parcelRegister("2J5Gv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1fc431983654b8c0$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $1fc431983654b8c0$var$coinflip(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}
var $1fc431983654b8c0$export$2e2bcd8739ae039 = $1fc431983654b8c0$var$coinflip;

});

parcelRegister("bs6hr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TTVC_REVISION", function () { return $85672e6349118ca5$export$f9bb3bb330fb9609; });
$parcel$export(module.exports, "setUFOConfig", function () { return $85672e6349118ca5$export$10d6139a8fb42158; });
$parcel$export(module.exports, "getConfig", function () { return $85672e6349118ca5$export$44487a86467333c3; });
$parcel$export(module.exports, "isUFOEnabled", function () { return $85672e6349118ca5$export$74bdb753f1cf4860; });
$parcel$export(module.exports, "isVCRevisionEnabled", function () { return $85672e6349118ca5$export$4babcefc81a3ef0b; });
$parcel$export(module.exports, "getMostRecentVCRevision", function () { return $85672e6349118ca5$export$70184d6e2c753893; });
$parcel$export(module.exports, "getReactHydrationStats", function () { return $85672e6349118ca5$export$2d8f8d64dc343d7b; });
$parcel$export(module.exports, "getInteractionRate", function () { return $85672e6349118ca5$export$9466a8f085fa7d4e; });
$parcel$export(module.exports, "getExperimentalInteractionRate", function () { return $85672e6349118ca5$export$563f73272328c0d; });
$parcel$export(module.exports, "getVCRawDataInteractionRate", function () { return $85672e6349118ca5$export$48f4e0d964030a96; });
$parcel$export(module.exports, "shouldUseRawDataThirdPartyBehavior", function () { return $85672e6349118ca5$export$9c69f5a724f05f38; });
$parcel$export(module.exports, "getPostInteractionRate", function () { return $85672e6349118ca5$export$1d459f020c06ae34; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $85672e6349118ca5$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getExtraInteractionRate", function () { return $85672e6349118ca5$export$203bd06a99c66a0d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $85672e6349118ca5$export$2d311b3fd18dcab1; });
$parcel$export(module.exports, "getUfoNameOverrides", function () { return $85672e6349118ca5$export$4f4649ef27b6f5d6; });
$parcel$export(module.exports, "getMinorInteractions", function () { return $85672e6349118ca5$export$b150ddad71c80d77; });
$parcel$export(module.exports, "getDoNotAbortActivePressInteraction", function () { return $85672e6349118ca5$export$3c170167645a0eff; });
$parcel$export(module.exports, "getFinishInteractionOnTransition", function () { return $85672e6349118ca5$export$20e8108b8ccdd0bd; });
$parcel$export(module.exports, "getInteractionTimeout", function () { return $85672e6349118ca5$export$c681731847989445; });

var $dqOGO = parcelRequire("dqOGO");

var $1m3mf = parcelRequire("1m3mf");

var $8pSiD = parcelRequire("8pSiD");

var $jxLBU = parcelRequire("jxLBU");
function $85672e6349118ca5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $85672e6349118ca5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $85672e6349118ca5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $85672e6349118ca5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $85672e6349118ca5$var$config;
var $85672e6349118ca5$export$f9bb3bb330fb9609 = "fy26.04";
function $85672e6349118ca5$export$2182e73d31080cbc() {
    return $85672e6349118ca5$export$f9bb3bb330fb9609;
}
var $85672e6349118ca5$export$d50dacda7fe6392b = 1000;
function $85672e6349118ca5$export$10d6139a8fb42158(newConfig) {
    var _newConfig$vc;
    // Handle edge cases with `enabledVCRevisions`
    var _ref = (_newConfig$vc = newConfig === null || newConfig === void 0 ? void 0 : newConfig.vc) !== null && _newConfig$vc !== void 0 ? _newConfig$vc : {}, enabledVCRevisions = _ref.enabledVCRevisions;
    if (enabledVCRevisions) {
        var _enabledVCRevisions$a;
        var byExperience = (0, $8pSiD.default)(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.byExperience) === "object" ? enabledVCRevisions.byExperience : {};
        var allRevisions = [].concat((0, $1m3mf.default)((_enabledVCRevisions$a = enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all) !== null && _enabledVCRevisions$a !== void 0 ? _enabledVCRevisions$a : []), (0, $1m3mf.default)(Object.values(byExperience).flat()));
        $85672e6349118ca5$var$config = $85672e6349118ca5$var$_objectSpread($85672e6349118ca5$var$_objectSpread({}, newConfig), {}, {
            vc: $85672e6349118ca5$var$_objectSpread($85672e6349118ca5$var$_objectSpread({}, newConfig.vc), {}, {
                enabledVCRevisions: {
                    all: Array.from(new Set(allRevisions)),
                    byExperience: byExperience
                }
            })
        });
    } else $85672e6349118ca5$var$config = newConfig;
}
function $85672e6349118ca5$export$44487a86467333c3() {
    return $85672e6349118ca5$var$config;
}
function $85672e6349118ca5$export$74bdb753f1cf4860() {
    var _config;
    // Default to enabled if config is not set or enabled is not explicitly false
    return ((_config = $85672e6349118ca5$var$config) === null || _config === void 0 ? void 0 : _config.enabled) !== false;
}
var $85672e6349118ca5$var$isValidConfigArray = function isValidConfigArray(array) {
    return Array.isArray(array) && array.length > 0;
};
function $85672e6349118ca5$export$87fbc8e01b137811() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    try {
        var _config$vc;
        if (!$85672e6349118ca5$var$config) return [];
        if ((_config$vc = $85672e6349118ca5$var$config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
            var _config$vc2, _enabledVCRevisions$b;
            var _ref2 = (_config$vc2 = $85672e6349118ca5$var$config.vc) !== null && _config$vc2 !== void 0 ? _config$vc2 : {}, enabledVCRevisions = _ref2.enabledVCRevisions;
            if ($85672e6349118ca5$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 || (_enabledVCRevisions$b = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b === void 0 ? void 0 : _enabledVCRevisions$b[experienceKey])) {
                var _enabledVCRevisions$b2;
                return (_enabledVCRevisions$b2 = enabledVCRevisions.byExperience) === null || _enabledVCRevisions$b2 === void 0 ? void 0 : _enabledVCRevisions$b2[experienceKey];
            }
            if ($85672e6349118ca5$var$isValidConfigArray(enabledVCRevisions === null || enabledVCRevisions === void 0 ? void 0 : enabledVCRevisions.all)) return enabledVCRevisions.all;
            return [
                $85672e6349118ca5$export$2182e73d31080cbc()
            ];
        }
        return [];
    } catch (_unused) {
        return [];
    }
}
function $85672e6349118ca5$export$4babcefc81a3ef0b(revision, experienceKey) {
    return $85672e6349118ca5$export$87fbc8e01b137811(experienceKey).includes(revision);
}
function $85672e6349118ca5$export$70184d6e2c753893() {
    var experienceKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var enabledVCRevisions = $85672e6349118ca5$export$87fbc8e01b137811(experienceKey);
    return enabledVCRevisions[enabledVCRevisions.length - 1];
}
function $85672e6349118ca5$export$2d8f8d64dc343d7b() {
    if (!$85672e6349118ca5$var$config) return undefined;
    try {
        var _config2, _config2$getReactHydr;
        var stats = (_config2 = $85672e6349118ca5$var$config) === null || _config2 === void 0 || (_config2$getReactHydr = _config2.getReactHydrationStats) === null || _config2$getReactHydr === void 0 ? void 0 : _config2$getReactHydr.call(_config2);
        return stats !== null && stats !== void 0 ? stats : undefined;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error("getReactHydrationStats threw an error: ", e);
        return undefined;
    }
}
function $85672e6349118ca5$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$85672e6349118ca5$var$config) return 0;
        var _config3 = $85672e6349118ca5$var$config, killswitch = _config3.killswitch, rates = _config3.rates, rules = _config3.rules, kind = _config3.kind, autoGeneratedRate = _config3.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        var isUnknown = name === "unknown";
        if (isUnknown) {
            if ((rates === null || rates === void 0 ? void 0 : rates[name]) != null) return rates[name];
            // Return default rate for unknown events when no explicit rate is configured
            return $85672e6349118ca5$export$d50dacda7fe6392b;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (_unused2) {
        // Fallback
        return 0;
    }
}
function $85672e6349118ca5$export$563f73272328c0d(name, interactionType) {
    try {
        if (!$85672e6349118ca5$var$config) return 0;
        var _config4 = $85672e6349118ca5$var$config, experimentalInteractionMetrics = _config4.experimentalInteractionMetrics;
        if (!(experimentalInteractionMetrics !== null && experimentalInteractionMetrics !== void 0 && experimentalInteractionMetrics.enabled)) return 0;
        if (experimentalInteractionMetrics.rates && typeof experimentalInteractionMetrics.rates[name] === "number") return experimentalInteractionMetrics.rates[name];
        if (experimentalInteractionMetrics.kind && typeof experimentalInteractionMetrics.kind[interactionType] === "number") return experimentalInteractionMetrics.kind[interactionType];
        return 0;
    } catch (_unused3) {
        return 0;
    }
}
function $85672e6349118ca5$export$48f4e0d964030a96(name, interactionType) {
    return $85672e6349118ca5$var$getConfigRate(name, interactionType, "enableVCRawDataRates");
}
function $85672e6349118ca5$export$9c69f5a724f05f38(name, interactionType) {
    if (!(0, $jxLBU.fg)("platform_ufo_raw_data_thirdparty")) return false;
    return $85672e6349118ca5$export$48f4e0d964030a96(name, interactionType) > 0;
}
function $85672e6349118ca5$export$1d459f020c06ae34(name, interactionType) {
    return $85672e6349118ca5$var$getConfigRate(name, interactionType, "postInteractionLog");
}
function $85672e6349118ca5$export$29b9ffb14861a1d(capability) {
    if ((0, $jxLBU.fg)("platform_ufo_remove_deprecated_config_fields")) return 1;
    try {
        if (!$85672e6349118ca5$var$config) return 0;
        var _config5 = $85672e6349118ca5$var$config, capabilityRate = _config5.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused4) {
        return 0;
    }
}
function $85672e6349118ca5$var$getConfigRate(name, interactionType, configName) {
    try {
        if (!$85672e6349118ca5$var$config) return 0;
        var gotConfig = $85672e6349118ca5$var$config[configName];
        if (!(gotConfig !== null && gotConfig !== void 0 && gotConfig.enabled)) return 0;
        if (interactionType !== "page_load" && interactionType !== "transition") return 0;
        if (gotConfig.rates && typeof gotConfig.rates[name] === "number") return gotConfig.rates[name];
        if ("kind" in gotConfig && gotConfig.kind && typeof gotConfig.kind[interactionType] === "number") return gotConfig.kind[interactionType];
        return 0;
    } catch (_unused5) {
        return 0;
    }
}
function $85672e6349118ca5$export$203bd06a99c66a0d(name, interactionType) {
    return $85672e6349118ca5$var$getConfigRate(name, interactionType, "extraInteractionMetrics");
}
var $85672e6349118ca5$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $85672e6349118ca5$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$85672e6349118ca5$var$config) return defaultMethod;
        var _config6 = $85672e6349118ca5$var$config, typingMethod = _config6.typingMethod;
        if (typingMethod != null && $85672e6349118ca5$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (_unused6) {
        return defaultMethod;
    }
}
function $85672e6349118ca5$export$2d311b3fd18dcab1() {
    try {
        if (!$85672e6349118ca5$var$config) return [];
        var _config7 = $85672e6349118ca5$var$config, awaitBM3TTI = _config7.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (_unused7) {
        return [];
    }
}
function $85672e6349118ca5$export$4f4649ef27b6f5d6() {
    try {
        if (!$85672e6349118ca5$var$config) return undefined;
        var _config8 = $85672e6349118ca5$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (_unused8) {
        return undefined;
    }
}
function $85672e6349118ca5$export$b150ddad71c80d77() {
    try {
        if (!$85672e6349118ca5$var$config) return undefined;
        var _config9 = $85672e6349118ca5$var$config, minorInteractions = _config9.minorInteractions;
        return minorInteractions;
    } catch (_unused9) {
        return undefined;
    }
}
function $85672e6349118ca5$export$3c170167645a0eff() {
    try {
        if (!$85672e6349118ca5$var$config) return undefined;
        var _config0 = $85672e6349118ca5$var$config, doNotAbortActivePressInteraction = _config0.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (_unused0) {
        return undefined;
    }
}
function $85672e6349118ca5$export$d6dc9444bd15f70f() {
    try {
        if (!$85672e6349118ca5$var$config) return undefined;
        var _config1 = $85672e6349118ca5$var$config, doNotAbortActivePressInteractionOnTransition = _config1.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (_unused1) {
        return undefined;
    }
}
function $85672e6349118ca5$export$20e8108b8ccdd0bd() {
    try {
        if (!$85672e6349118ca5$var$config) return undefined;
        var _config10 = $85672e6349118ca5$var$config, finishInteractionOnTransition = _config10.finishInteractionOnTransition;
        return finishInteractionOnTransition;
    } catch (_unused10) {
        return undefined;
    }
}
var $85672e6349118ca5$export$2a8604960d7d23d9 = 60000;
function $85672e6349118ca5$export$c681731847989445(ufoName) {
    try {
        if (!$85672e6349118ca5$var$config) return $85672e6349118ca5$export$2a8604960d7d23d9;
        var _config11 = $85672e6349118ca5$var$config, interactionTimeout = _config11.interactionTimeout;
        if (interactionTimeout != null && interactionTimeout[ufoName] != null) return interactionTimeout[ufoName];
        if (interactionTimeout != null && interactionTimeout.__globalInteractionTimeout != null) return interactionTimeout.__globalInteractionTimeout;
        else return $85672e6349118ca5$export$2a8604960d7d23d9;
    } catch (_unused11) {
        return $85672e6349118ca5$export$2a8604960d7d23d9;
    }
}

});

parcelRegister("jyanA", function(module, exports) {

$parcel$export(module.exports, "sinkExperimentalHandler", function () { return $e3b93e70c75fa9b3$export$7aa99c40634ac65f; });
$parcel$export(module.exports, "onExperimentalInteractionComplete", function () { return $e3b93e70c75fa9b3$export$1aed449484dedf63; });
$parcel$export(module.exports, "experimentalVC", function () { return $e3b93e70c75fa9b3$export$81b28dca2587ec47; });
$parcel$export(module.exports, "getExperimentalVCMetrics", function () { return $e3b93e70c75fa9b3$export$d17d2b5c5e8d732e; });

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $2TVum = parcelRequire("2TVum");

var $iHP94 = parcelRequire("iHP94");
function $e3b93e70c75fa9b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3b93e70c75fa9b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3b93e70c75fa9b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3b93e70c75fa9b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $e3b93e70c75fa9b3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $e3b93e70c75fa9b3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $e3b93e70c75fa9b3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $e3b93e70c75fa9b3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $e3b93e70c75fa9b3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $e3b93e70c75fa9b3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $e3b93e70c75fa9b3$var$interactionBuffer = [];
var $e3b93e70c75fa9b3$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $e3b93e70c75fa9b3$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $e3b93e70c75fa9b3$var$clearInteractionBuffer() {
    $e3b93e70c75fa9b3$var$interactionBuffer.length = 0;
}
function $e3b93e70c75fa9b3$var$appendInteractionData(interactionId, data) {
    $e3b93e70c75fa9b3$var$bufferInteractionData(interactionId, data);
}
function $e3b93e70c75fa9b3$export$c8a9e17ae62a073d(handler) {
    var _iterator = $e3b93e70c75fa9b3$var$_createForOfIteratorHelper($e3b93e70c75fa9b3$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $e3b93e70c75fa9b3$var$clearInteractionBuffer();
    $e3b93e70c75fa9b3$var$bufferInteractionData = handler;
}
function $e3b93e70c75fa9b3$export$7aa99c40634ac65f(sinkFn) {
    $e3b93e70c75fa9b3$export$c8a9e17ae62a073d(sinkFn);
}
function $e3b93e70c75fa9b3$export$1aed449484dedf63(interactionId, data) {
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    if (data.ufoName) {
        data.end = endTime;
        $e3b93e70c75fa9b3$var$appendInteractionData(interactionId, data);
        $e3b93e70c75fa9b3$var$clearInteractionBuffer();
    }
}
var $e3b93e70c75fa9b3$export$f9a59f57e0282541 = /*#__PURE__*/ function() {
    function ExperimentalVCMetrics() {
        (0, $i385U.default)(this, ExperimentalVCMetrics);
        (0, $dqOGO.default)(this, "vcObserver", null);
    }
    return (0, $c19Op.default)(ExperimentalVCMetrics, [
        {
            key: "initialize",
            value: function initialize(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $iHP94.VCObserver)($e3b93e70c75fa9b3$var$_objectSpread($e3b93e70c75fa9b3$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
                return this;
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        }
    ]);
}();
var $e3b93e70c75fa9b3$export$81b28dca2587ec47 = new $e3b93e70c75fa9b3$export$f9a59f57e0282541();
function $e3b93e70c75fa9b3$export$d17d2b5c5e8d732e(_x) {
    return $e3b93e70c75fa9b3$var$_getExperimentalVCMetrics.apply(this, arguments);
}
function $e3b93e70c75fa9b3$var$_getExperimentalVCMetrics() {
    $e3b93e70c75fa9b3$var$_getExperimentalVCMetrics = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(interaction) {
        var vcObserver, pageVisibilityUpToTTAI, _interaction$apdex, prefix, result, VC;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    // Use per-interaction VC observer if available, otherwise fall back to global experimentalVC
                    vcObserver = interaction.experimentalVCObserver || $e3b93e70c75fa9b3$export$81b28dca2587ec47.vcObserver;
                    pageVisibilityUpToTTAI = (0, $2TVum.getPageVisibilityState)(interaction.start, interaction.end);
                    if (!vcObserver) {
                        _context.next = 13;
                        break;
                    }
                    prefix = "ufo-experimental";
                    _context.next = 6;
                    return vcObserver.getVCResult({
                        start: interaction.start,
                        stop: interaction.end,
                        tti: (_interaction$apdex = interaction.apdex) === null || _interaction$apdex === void 0 || (_interaction$apdex = _interaction$apdex[0]) === null || _interaction$apdex === void 0 ? void 0 : _interaction$apdex.stopTime,
                        isEventAborted: !!interaction.abortReason,
                        prefix: prefix,
                        vc: interaction.vc,
                        experienceKey: interaction.ufoName,
                        interactionId: interaction.id,
                        interactionType: interaction.type,
                        isPageVisible: pageVisibilityUpToTTAI === "visible",
                        interactionAbortReason: interaction.abortReason
                    });
                case 6:
                    result = _context.sent;
                    VC = result === null || result === void 0 ? void 0 : result["metrics:vc"];
                    if (!(!VC || !(result !== null && result !== void 0 && result["".concat(prefix, ":vc:clean")]))) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 10:
                    if (!(interaction.abortReason || pageVisibilityUpToTTAI !== "visible")) {
                        _context.next = 12;
                        break;
                    }
                    return _context.abrupt("return", result);
                case 12:
                    return _context.abrupt("return", $e3b93e70c75fa9b3$var$_objectSpread($e3b93e70c75fa9b3$var$_objectSpread({}, result), {}, {
                        "metric:experimental:vc90": VC["90"]
                    }));
                case 13:
                    return _context.abrupt("return", null);
                case 14:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $e3b93e70c75fa9b3$var$_getExperimentalVCMetrics.apply(this, arguments);
}

});
parcelRegister("2TVum", function(module, exports) {

$parcel$export(module.exports, "getEarliestHiddenTiming", function () { return $21cd4fe60e4f668d$export$754443ce7c615bd7; });
$parcel$export(module.exports, "isOpenedInBackground", function () { return $21cd4fe60e4f668d$export$21a1a62a307062f1; });
$parcel$export(module.exports, "getHasHiddenTimingBeforeSetup", function () { return $21cd4fe60e4f668d$export$95f048bd8bcdda23; });
$parcel$export(module.exports, "setupHiddenTimingCapture", function () { return $21cd4fe60e4f668d$export$554cefe0f0373da4; });
$parcel$export(module.exports, "getPageVisibilityState", function () { return $21cd4fe60e4f668d$export$768b2008623433e1; });
$parcel$export(module.exports, "setupThrottleDetection", function () { return $21cd4fe60e4f668d$export$fa0d29a9c87052da; });
$parcel$export(module.exports, "isTabThrottled", function () { return $21cd4fe60e4f668d$export$62a28c860277b3bf; });
$parcel$export(module.exports, "getPageVisibilityTimeline", function () { return $21cd4fe60e4f668d$export$5a06b84e47ad70d9; });

var $2e1kT = parcelRequire("2e1kT");

var $jxLBU = parcelRequire("jxLBU");
var $21cd4fe60e4f668d$var$timings = [];
var $21cd4fe60e4f668d$var$wasHiddenFlag;
var $21cd4fe60e4f668d$var$setupFlag = false;
// Threshold for determining if page was opened in background.
// If setup runs within this time and page is hidden, we assume it was opened in a background tab.
var $21cd4fe60e4f668d$var$OPENED_IN_BACKGROUND_THRESHOLD_MS = 100;
var $21cd4fe60e4f668d$var$openedInBackground = null;
function $21cd4fe60e4f668d$var$isPageHidden() {
    if ("visibilityState" in document) return document.visibilityState === "hidden";
    else // @ts-expect-error - Property 'hidden' does not exist on type 'never'.
    return document.hidden;
}
var $21cd4fe60e4f668d$var$SIZE = 50;
var $21cd4fe60e4f668d$var$insertIndex = 0;
function $21cd4fe60e4f668d$export$754443ce7c615bd7(startTime, endTime) {
    var _timings$find;
    var earliestHiddenTiming = (_timings$find = $21cd4fe60e4f668d$var$timings.find(function(_ref) {
        var hidden = _ref.hidden, time = _ref.time;
        return hidden && time > 0 && time >= startTime && time <= endTime;
    })) === null || _timings$find === void 0 ? void 0 : _timings$find.time;
    if (typeof earliestHiddenTiming === "number") return Math.round(earliestHiddenTiming - startTime);
}
function $21cd4fe60e4f668d$export$21a1a62a307062f1(interactionType) {
    if (interactionType !== "page_load") return false;
    // Check native visibility-state entries first (most reliable, Chromium only)
    try {
        var entries = performance.getEntriesByType("visibility-state");
        if (entries.length > 0) return entries.some(function(entry) {
            return entry.name === "hidden" && entry.startTime <= $21cd4fe60e4f668d$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        });
    } catch (_unused) {
    // visibility-state not supported (Firefox/Safari)
    }
    // Fallback to cached value from setup (determined using time threshold)
    return $21cd4fe60e4f668d$var$openedInBackground === true;
}
function $21cd4fe60e4f668d$var$pushHidden(isPageHiddenFlag, time) {
    $21cd4fe60e4f668d$var$timings[$21cd4fe60e4f668d$var$insertIndex] = {
        time: time !== null && time !== void 0 ? time : performance.now(),
        hidden: isPageHiddenFlag
    };
    $21cd4fe60e4f668d$var$insertIndex = ($21cd4fe60e4f668d$var$insertIndex + 1) % $21cd4fe60e4f668d$var$SIZE;
    $21cd4fe60e4f668d$var$wasHiddenFlag = isPageHiddenFlag;
}
function $21cd4fe60e4f668d$var$handleChange() {
    var isPageHiddenFlag = $21cd4fe60e4f668d$var$isPageHidden();
    if (isPageHiddenFlag) {
        if (!$21cd4fe60e4f668d$var$wasHiddenFlag) $21cd4fe60e4f668d$var$pushHidden(isPageHiddenFlag);
        $21cd4fe60e4f668d$var$wasHiddenFlag = true;
    } else {
        if ($21cd4fe60e4f668d$var$wasHiddenFlag) $21cd4fe60e4f668d$var$pushHidden(isPageHiddenFlag);
        $21cd4fe60e4f668d$var$wasHiddenFlag = false;
    }
}
var $21cd4fe60e4f668d$var$hasHiddenTimingBeforeSetup = false;
function $21cd4fe60e4f668d$export$95f048bd8bcdda23() {
    return $21cd4fe60e4f668d$var$hasHiddenTimingBeforeSetup;
}
function $21cd4fe60e4f668d$var$setup() {
    try {
        var results = performance.getEntriesByType("visibility-state");
        results === null || results === void 0 || results.forEach(function(result) {
            if ((0, $jxLBU.fg)("platform_ufo_use_native_page_visibility_api")) $21cd4fe60e4f668d$var$pushHidden(result.name === "hidden", result.startTime);
            if (result.name === "hidden") $21cd4fe60e4f668d$var$hasHiddenTimingBeforeSetup = true;
        });
    } catch (_unused2) {
    /* do nothing */ /* note: visibility-state entry types are not available in Firefox/Safari: https://developer.mozilla.org/en-US/docs/Web/API/VisibilityStateEntry#browser_compatibility */ }
    (0, $2e1kT.bind)(window, {
        type: "pageshow",
        listener: $21cd4fe60e4f668d$var$handleChange
    });
    (0, $2e1kT.bind)(window, {
        type: "pagehide",
        listener: $21cd4fe60e4f668d$var$handleChange
    });
    (0, $2e1kT.bind)(document, {
        type: "visibilitychange",
        listener: $21cd4fe60e4f668d$var$handleChange
    });
}
function $21cd4fe60e4f668d$export$554cefe0f0373da4() {
    if (!$21cd4fe60e4f668d$var$setupFlag) {
        var isPageHiddenFlag = $21cd4fe60e4f668d$var$isPageHidden();
        var setupTime = performance.now();
        // Determine if page was opened in background.
        // If we're early in page lifecycle (< threshold) and page is hidden,
        // it's likely the page was opened in a background tab.
        if ($21cd4fe60e4f668d$var$openedInBackground === null) $21cd4fe60e4f668d$var$openedInBackground = isPageHiddenFlag && setupTime < $21cd4fe60e4f668d$var$OPENED_IN_BACKGROUND_THRESHOLD_MS;
        $21cd4fe60e4f668d$var$pushHidden(isPageHiddenFlag, 0);
        $21cd4fe60e4f668d$var$setup();
        $21cd4fe60e4f668d$var$setupFlag = true;
    }
}
function $21cd4fe60e4f668d$export$768b2008623433e1(start, end) {
    // Input validation - return default for invalid inputs
    if (!Number.isFinite(start) || !Number.isFinite(end)) return "visible";
    // Desirable default value is visible
    if ($21cd4fe60e4f668d$var$timings.length === 0) return "visible";
    var currentSize = $21cd4fe60e4f668d$var$timings.length;
    var hiddenState = "mixed";
    var startIdx = $21cd4fe60e4f668d$var$insertIndex;
    var endIdx = $21cd4fe60e4f668d$var$insertIndex;
    // currentSize is capped at SIZE.
    for(var i = 0; i < currentSize; i++){
        var tmpIdx = ($21cd4fe60e4f668d$var$insertIndex + i) % currentSize;
        // Add bounds checking before accessing array element
        if ($21cd4fe60e4f668d$var$timings[tmpIdx] && $21cd4fe60e4f668d$var$timings[tmpIdx].time <= end) {
            endIdx = tmpIdx;
            if ($21cd4fe60e4f668d$var$timings[tmpIdx].time <= start) startIdx = tmpIdx;
        }
    }
    // Add bounds checking before accessing timings array
    if (endIdx - startIdx === 0 && $21cd4fe60e4f668d$var$timings[startIdx]) hiddenState = $21cd4fe60e4f668d$var$timings[startIdx].hidden ? "hidden" : "visible";
    return hiddenState;
}
// Throttle detection configuration
// Expected interval for timer checks (in milliseconds)
var $21cd4fe60e4f668d$var$THROTTLE_CHECK_INTERVAL_MS = 1000;
// Threshold for considering a timer as throttled (50% drift tolerance)
var $21cd4fe60e4f668d$var$THROTTLE_DRIFT_THRESHOLD = 1.5;
// Maximum number of throttle measurements to store (circular buffer)
var $21cd4fe60e4f668d$var$THROTTLE_BUFFER_SIZE = 120;
// Circular buffer to store throttle measurements
var $21cd4fe60e4f668d$var$throttleMeasurements = [];
var $21cd4fe60e4f668d$var$throttleInsertIndex = 0;
var $21cd4fe60e4f668d$var$throttleIntervalId = null;
var $21cd4fe60e4f668d$var$lastThrottleCheckTime = null;
var $21cd4fe60e4f668d$var$throttleSetupDone = false;
function $21cd4fe60e4f668d$var$recordThrottleMeasurement(expectedElapsed, actualElapsed) {
    var isThrottled = actualElapsed > expectedElapsed * $21cd4fe60e4f668d$var$THROTTLE_DRIFT_THRESHOLD;
    $21cd4fe60e4f668d$var$throttleMeasurements[$21cd4fe60e4f668d$var$throttleInsertIndex] = {
        time: performance.now(),
        expectedElapsed: expectedElapsed,
        actualElapsed: actualElapsed,
        isThrottled: isThrottled
    };
    $21cd4fe60e4f668d$var$throttleInsertIndex = ($21cd4fe60e4f668d$var$throttleInsertIndex + 1) % $21cd4fe60e4f668d$var$THROTTLE_BUFFER_SIZE;
}
function $21cd4fe60e4f668d$var$throttleCheckCallback() {
    var currentTime = performance.now();
    if ($21cd4fe60e4f668d$var$lastThrottleCheckTime !== null) {
        var actualElapsed = currentTime - $21cd4fe60e4f668d$var$lastThrottleCheckTime;
        $21cd4fe60e4f668d$var$recordThrottleMeasurement($21cd4fe60e4f668d$var$THROTTLE_CHECK_INTERVAL_MS, actualElapsed);
    }
    $21cd4fe60e4f668d$var$lastThrottleCheckTime = currentTime;
}
function $21cd4fe60e4f668d$export$fa0d29a9c87052da() {
    if ($21cd4fe60e4f668d$var$throttleSetupDone) return;
    $21cd4fe60e4f668d$var$throttleSetupDone = true;
    // Record the initial timestamp
    $21cd4fe60e4f668d$var$lastThrottleCheckTime = performance.now();
    // Start the periodic timer for throttle detection
    $21cd4fe60e4f668d$var$throttleIntervalId = setInterval($21cd4fe60e4f668d$var$throttleCheckCallback, $21cd4fe60e4f668d$var$THROTTLE_CHECK_INTERVAL_MS);
}
function $21cd4fe60e4f668d$export$3279694d66e4a1() {
    if ($21cd4fe60e4f668d$var$throttleIntervalId !== null) {
        clearInterval($21cd4fe60e4f668d$var$throttleIntervalId);
        $21cd4fe60e4f668d$var$throttleIntervalId = null;
    }
    $21cd4fe60e4f668d$var$lastThrottleCheckTime = null;
    $21cd4fe60e4f668d$var$throttleSetupDone = false;
    $21cd4fe60e4f668d$var$throttleMeasurements.length = 0;
    $21cd4fe60e4f668d$var$throttleInsertIndex = 0;
}
function $21cd4fe60e4f668d$export$62a28c860277b3bf(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return false;
    // No measurements available
    if ($21cd4fe60e4f668d$var$throttleMeasurements.length === 0) return false;
    // Check if any measurement within the time window indicates throttling
    for(var i = 0; i < $21cd4fe60e4f668d$var$throttleMeasurements.length; i++){
        var measurement = $21cd4fe60e4f668d$var$throttleMeasurements[i];
        if (measurement && measurement.time >= startTime && measurement.time <= endTime && measurement.isThrottled) return true;
    }
    return false;
}
function $21cd4fe60e4f668d$export$77aaa9b1ce57d9bc(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    return $21cd4fe60e4f668d$var$throttleMeasurements.filter(function(measurement) {
        return measurement && measurement.time >= startTime && measurement.time <= endTime;
    });
}
function $21cd4fe60e4f668d$export$9332de935653b687(measurement) {
    $21cd4fe60e4f668d$var$throttleMeasurements[$21cd4fe60e4f668d$var$throttleInsertIndex] = measurement;
    $21cd4fe60e4f668d$var$throttleInsertIndex = ($21cd4fe60e4f668d$var$throttleInsertIndex + 1) % $21cd4fe60e4f668d$var$THROTTLE_BUFFER_SIZE;
}
function $21cd4fe60e4f668d$export$5a06b84e47ad70d9(startTime, endTime) {
    // Input validation
    if (!Number.isFinite(startTime) || !Number.isFinite(endTime) || startTime >= endTime) return [];
    if ($21cd4fe60e4f668d$var$timings.length === 0) return [];
    var result = [];
    // Find the most recent entry at or before startTime to establish initial state
    var initialEntry;
    var currentSize = $21cd4fe60e4f668d$var$timings.length;
    for(var i = 0; i < currentSize; i++){
        var idx = ($21cd4fe60e4f668d$var$insertIndex + i) % currentSize;
        var entry = $21cd4fe60e4f668d$var$timings[idx];
        if (entry && entry.time <= startTime) initialEntry = entry;
    }
    // Add the initial visibility state at the start of the window
    if (initialEntry) result.push({
        time: 0,
        hidden: initialEntry.hidden
    });
    // Add all entries within the time window
    for(var _i = 0; _i < currentSize; _i++){
        var _idx = ($21cd4fe60e4f668d$var$insertIndex + _i) % currentSize;
        var _entry = $21cd4fe60e4f668d$var$timings[_idx];
        if (_entry && _entry.time > startTime && _entry.time <= endTime) result.push({
            time: Math.round(_entry.time - startTime),
            hidden: _entry.hidden
        });
    }
    return result;
}
// Expose testing API on window for integration tests
if (typeof window !== "undefined") window.__reactUfoHiddenTiming = {
    __injectThrottleMeasurementForTesting: $21cd4fe60e4f668d$export$9332de935653b687
};

});
parcelRegister("2e1kT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $3KNHr = parcelRequire("3KNHr");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $3KNHr.bind;
    }
});

var $b9OuA = parcelRequire("b9OuA");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $b9OuA.bindAll;
    }
});

});
parcelRegister("3KNHr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $2bbc3849f8b31724$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $2bbc3849f8b31724$var$bind;

});

parcelRegister("b9OuA", function(module, exports) {
"use strict";
var $81f7b3ae5a742713$var$__assign = module.exports && module.exports.__assign || function() {
    $81f7b3ae5a742713$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81f7b3ae5a742713$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $3KNHr = parcelRequire("3KNHr");
function $81f7b3ae5a742713$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $81f7b3ae5a742713$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $81f7b3ae5a742713$var$__assign($81f7b3ae5a742713$var$__assign({}, original), {
        options: $81f7b3ae5a742713$var$__assign($81f7b3ae5a742713$var$__assign({}, $81f7b3ae5a742713$var$toOptions(sharedOptions)), $81f7b3ae5a742713$var$toOptions(original.options))
    });
    return binding;
}
function $81f7b3ae5a742713$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $81f7b3ae5a742713$var$getBinding(original, sharedOptions);
        return (0, $3KNHr.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $81f7b3ae5a742713$var$bindAll;

});



parcelRegister("iHP94", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $d9e3ea87f6d71c14$export$1f70d263701b1d01; });

var $1m3mf = parcelRequire("1m3mf");

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $6PaYK = parcelRequire("6PaYK");

var $jzYu7 = parcelRequire("jzYu7");

var $aKGMT = parcelRequire("aKGMT");

var $jxLBU = parcelRequire("jxLBU");

var $bs6hr = parcelRequire("bs6hr");

var $hkP9U = parcelRequire("hkP9U");

var $dKTgt = parcelRequire("dKTgt");

var $5dCyz = parcelRequire("5dCyz");

var $fHDWd = parcelRequire("fHDWd");

var $dSncP = parcelRequire("dSncP");

var $jfkkn = parcelRequire("jfkkn");
var $d9e3ea87f6d71c14$var$_excluded = [
    "__debug__element"
];
function $d9e3ea87f6d71c14$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d9e3ea87f6d71c14$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d9e3ea87f6d71c14$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d9e3ea87f6d71c14$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d9e3ea87f6d71c14$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
var $d9e3ea87f6d71c14$var$UNUSED_SECTOR = 0;
function $d9e3ea87f6d71c14$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, $jzYu7.default)(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, $6PaYK.default)(entry, $d9e3ea87f6d71c14$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $d9e3ea87f6d71c14$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, $i385U.default)(this, VCObserver);
        /* abort logic */ (0, $dqOGO.default)(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, $dqOGO.default)(this, "outOfBoundaryInfo", "");
        (0, $dqOGO.default)(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, $dqOGO.default)(this, "arraySize", 0);
        (0, $dqOGO.default)(this, "componentsLog", {});
        (0, $dqOGO.default)(this, "vcRatios", {});
        (0, $dqOGO.default)(this, "active", false);
        (0, $dqOGO.default)(this, "totalTime", 0);
        (0, $dqOGO.default)(this, "startTime", 0);
        (0, $dqOGO.default)(this, "_startMeasureTimestamp", -1);
        (0, $dqOGO.default)(this, "ssr", {
            reactRendered: -1
        });
        (0, $dqOGO.default)(this, "unbind", []);
        (0, $dqOGO.default)(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, $dqOGO.default)(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $d9e3ea87f6d71c14$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.heatmap,
                heatmapNext: _this.heatmapNext,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $d9e3ea87f6d71c14$var$_objectSpread({}, _this.componentsLog),
                viewport: $d9e3ea87f6d71c14$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, $dqOGO.default)(this, "getVCResult", /*#__PURE__*/ function() {
            var _ref4 = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(_ref3) {
                var start, stop, tti, prefix, ssr, vc, isEventAborted, experienceKey, interactionId, includeSSRRatio, startTime, fullPrefix, rawData, abortReason, abortReasonInfo, heatmap, heatmapNext, outOfBoundaryInfo, totalTime, componentsLog, viewport, devToolsEnabled, ratios, isTTVCv1Disabled, vcAbortedResultWithRevisions, ttvcV1Result, VC, VCBox, VCEntries, totalPainted, _componentsLog, vcNext, outOfBoundary, stopTime, ttvcV1DevToolInfo, ttvcV2DevToolInfo, shouldCreateDebugDetails, v1RevisionDebugDetails, v2RevisionDebugDetails, _window$__ufo_devtool2, _window2, _window$__ufo_devtool, _window, _window$__on_ufo_vc_d2, _window4, _window$__on_ufo_vc_d, _window3, isVCClean, revisionsData, speedIndex, SSRRatio, SSRRatioNext, SSRRatioPayload, isTTVCv3Enabled;
                return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc, isEventAborted = _ref3.isEventAborted, experienceKey = _ref3.experienceKey, interactionId = _ref3.interactionId, includeSSRRatio = _ref3.includeSSRRatio;
                            startTime = performance.now(); // add local measurement
                            fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
                            rawData = vc !== undefined ? vc : _this.getVCRawData();
                            if (!(rawData === null)) {
                                _context.next = 6;
                                break;
                            }
                            return _context.abrupt("return", {});
                        case 6:
                            abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, heatmapNext = rawData.heatmapNext, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
                            isTTVCv1Disabled = !(0, $bs6hr.isVCRevisionEnabled)("fy25.01", experienceKey);
                            if (!(abortReasonInfo !== null)) {
                                _context.next = 13;
                                break;
                            }
                            // exposing data to devtools
                            try {
                                if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                            } catch (_unused) {}
                            vcAbortedResultWithRevisions = (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:rev"), [
                                {
                                    revision: "fy25.02",
                                    clean: false,
                                    "metric:vc90": null,
                                    abortReason: abortReason.reason,
                                    abortTimestamp: Math.round(abortReason.timestamp)
                                }
                            ]);
                            if (!isTTVCv1Disabled) vcAbortedResultWithRevisions["".concat(fullPrefix, "vc:rev")].push({
                                revision: "fy25.01",
                                clean: false,
                                "metric:vc90": null,
                                abortReason: abortReason.reason,
                                abortTimestamp: Math.round(abortReason.timestamp)
                            });
                            return _context.abrupt("return", vcAbortedResultWithRevisions);
                        case 13:
                            ttvcV1Result = isTTVCv1Disabled ? {
                                VC: {},
                                VCBox: {},
                                VCEntries: {
                                    abs: [],
                                    rel: [],
                                    speedIndex: -1
                                },
                                totalPainted: -1
                            } : VCObserver.calculateVC({
                                heatmap: heatmap,
                                ssr: ssr,
                                componentsLog: $d9e3ea87f6d71c14$var$_objectSpread({}, componentsLog),
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            VC = ttvcV1Result.VC, VCBox = ttvcV1Result.VCBox, VCEntries = ttvcV1Result.VCEntries, totalPainted = ttvcV1Result.totalPainted;
                            _componentsLog = {};
                            Object.entries(_this.componentsLog).forEach(function(_ref5) {
                                var _ref6 = (0, $jzYu7.default)(_ref5, 2), _timestamp = _ref6[0], value = _ref6[1];
                                var timestamp = Number(_timestamp);
                                if (stop > timestamp) _componentsLog[timestamp] = value;
                            });
                            vcNext = VCObserver.calculateVC({
                                heatmap: heatmapNext,
                                ssr: ssr,
                                componentsLog: _componentsLog,
                                viewport: viewport,
                                fixSSRAttribution: includeSSRRatio
                            });
                            outOfBoundary = outOfBoundaryInfo ? (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {}; //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: vcNext.VCBox } : {};
                            stopTime = performance.now(); // exposing data to devtools
                            try {
                                if (!_this.isPostInteraction && devToolsEnabled) {
                                    ttvcV1DevToolInfo = isTTVCv1Disabled ? undefined : {
                                        entries: VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            "75": VC["75"],
                                            "80": VC["80"],
                                            "85": VC["85"],
                                            "90": VC["90"],
                                            "95": VC["95"],
                                            "98": VC["98"],
                                            "99": VC["99"],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmap,
                                        ratios: ratios
                                    };
                                    ttvcV2DevToolInfo = {
                                        entries: vcNext.VCEntries.rel,
                                        log: componentsLog,
                                        metrics: {
                                            "75": vcNext.VC["75"],
                                            "80": vcNext.VC["80"],
                                            "85": vcNext.VC["85"],
                                            "90": vcNext.VC["90"],
                                            "95": vcNext.VC["95"],
                                            "98": vcNext.VC["98"],
                                            "99": vcNext.VC["99"],
                                            tti: tti,
                                            ttai: stop - start
                                        },
                                        start: start,
                                        stop: stop,
                                        heatmap: heatmapNext,
                                        ratios: ratios
                                    };
                                    if (isTTVCv1Disabled) {
                                        window.__vc = ttvcV2DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    } else {
                                        window.__vc = ttvcV1DevToolInfo;
                                        window.__vcNext = ttvcV2DevToolInfo;
                                    }
                                    // Emitting a custom event to make it available in the Chrome extension
                                    window.dispatchEvent(new CustomEvent("vcReady", {
                                        detail: {
                                            log: $d9e3ea87f6d71c14$var$filterComponentsLog(componentsLog),
                                            entries: isTTVCv1Disabled ? vcNext.VCEntries.rel : VCEntries.rel
                                        }
                                    }));
                                }
                                if (!_this.isPostInteraction) {
                                    // Only create revision debug details if callbacks exist
                                    shouldCreateDebugDetails = typeof window.__ufo_devtool_onVCRevisionReady__ === "function" || typeof window.__on_ufo_vc_debug_data_ready === "function";
                                    if (shouldCreateDebugDetails) {
                                        v1RevisionDebugDetails = (0, $5dCyz.getVCRevisionDebugDetails)({
                                            revision: "fy25.01",
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        });
                                        v2RevisionDebugDetails = (0, $5dCyz.getVCRevisionDebugDetails)({
                                            revision: "fy25.02",
                                            isClean: !abortReasonInfo,
                                            abortReason: abortReason.reason,
                                            VCEntries: vcNext.VCEntries.rel,
                                            componentsLog: componentsLog,
                                            interactionId: interactionId
                                        }); // Add devtool callback for both v1 and v2
                                        if (typeof window.__ufo_devtool_onVCRevisionReady__ === "function") {
                                            // Handle v1 if not disabled
                                            if (!isTTVCv1Disabled) (_window$__ufo_devtool = (_window = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool === void 0 || _window$__ufo_devtool.call(_window, v1RevisionDebugDetails);
                                            // Handle v2
                                            (_window$__ufo_devtool2 = (_window2 = window).__ufo_devtool_onVCRevisionReady__) === null || _window$__ufo_devtool2 === void 0 || _window$__ufo_devtool2.call(_window2, v2RevisionDebugDetails);
                                        }
                                        if (typeof window.__on_ufo_vc_debug_data_ready === "function") {
                                            if (!isTTVCv1Disabled) (_window$__on_ufo_vc_d = (_window3 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d === void 0 || _window$__on_ufo_vc_d.call(_window3, v1RevisionDebugDetails);
                                            (_window$__on_ufo_vc_d2 = (_window4 = window).__on_ufo_vc_debug_data_ready) === null || _window$__on_ufo_vc_d2 === void 0 || _window$__on_ufo_vc_d2.call(_window4, v2RevisionDebugDetails);
                                        }
                                    }
                                }
                            } catch (_unused2) {
                            /*  do nothing */ }
                            isVCClean = !abortReasonInfo;
                            revisionsData = (0, $fHDWd.getVCRevisionsData)({
                                fullPrefix: fullPrefix,
                                interaction: {
                                    start: start,
                                    end: stop
                                },
                                isVCClean: isVCClean,
                                calculatedVC: {
                                    VC: VC,
                                    VCBox: VCBox
                                },
                                calculatedVCNext: {
                                    VC: vcNext.VC,
                                    VCBox: vcNext.VCBox
                                },
                                isEventAborted: isEventAborted,
                                experienceKey: experienceKey,
                                ratios: ratios
                            });
                            speedIndex = (0, $dqOGO.default)((0, $dqOGO.default)({}, "ufo:speedIndex", isTTVCv1Disabled ? vcNext.VCEntries.speedIndex : VCEntries.speedIndex), "ufo:next:speedIndex", vcNext.VCEntries.speedIndex);
                            SSRRatio = VCObserver.getSSRRatio(VCEntries.rel, ssr);
                            SSRRatioNext = VCObserver.getSSRRatio(vcNext.VCEntries.rel, ssr);
                            SSRRatioPayload = includeSSRRatio ? (0, $dqOGO.default)((0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:ssrRatio"), isTTVCv1Disabled ? SSRRatioNext : SSRRatio), "".concat(fullPrefix, "vc:next:ssrRatio"), SSRRatioNext) : {};
                            if (!isTTVCv1Disabled) {
                                _context.next = 29;
                                break;
                            }
                            return _context.abrupt("return", $d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:ratios"), ratios), outOfBoundary), {}, (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), SSRRatioPayload), {}, (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:ssrRatio"), SSRRatioNext), revisionsData), speedIndex));
                        case 29:
                            isTTVCv3Enabled = (0, $bs6hr.isVCRevisionEnabled)("fy25.03", experienceKey);
                            return _context.abrupt("return", $d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread($d9e3ea87f6d71c14$var$_objectSpread((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)({
                                "metrics:vc": VC
                            }, "".concat(fullPrefix, "vc:state"), true), "".concat(fullPrefix, "vc:clean"), isVCClean), "".concat(fullPrefix, "vc:dom"), VCBox), "".concat(fullPrefix, "vc:updates"), isTTVCv3Enabled ? undefined : VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:size"), viewport), "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), "".concat(fullPrefix, "vc:total"), totalPainted), "".concat(fullPrefix, "vc:ratios"), ratios), "".concat(fullPrefix, "vc:ssrRatio"), SSRRatio), outOfBoundary), {}, (0, $dqOGO.default)((0, $dqOGO.default)((0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:next"), vcNext.VC), "".concat(fullPrefix, "vc:next:updates"), isTTVCv3Enabled ? undefined : vcNext.VCEntries.rel.slice(0, 50)), "".concat(fullPrefix, "vc:next:dom"), vcNext.VCBox), SSRRatioPayload), {}, (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), revisionsData), speedIndex));
                        case 31:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref4.apply(this, arguments);
            };
        }());
        (0, $dqOGO.default)(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason, attributeName, oldValue, newValue) {
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmapNext);
                var interaction = (0, $hkP9U.getActiveInteraction)();
                var isTTVCv1Disabled = !(0, $bs6hr.isVCRevisionEnabled)("fy25.01", interaction === null || interaction === void 0 ? void 0 : interaction.ufoName);
                if (!isTTVCv1Disabled && (!ignoreReason || ignoreReason === "not-visible") && type !== "attr") _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    type: type,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                });
            }
        });
        (0, $dqOGO.default)(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, $dqOGO.default)(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, $dqOGO.default)(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case "wheel":
                    _this.setAbortReason($d9e3ea87f6d71c14$var$abortReason.scroll, time);
                    break;
                case "keydown":
                    // Don't abort press interactions on keydown events, as keydown is expected
                    // when users press Enter/Space to activate buttons or other interactive elements
                    if ((0, $jxLBU.fg)("platform_ufo_keypress_interaction_abort")) {
                        var interaction = (0, $hkP9U.getActiveInteraction)();
                        if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === "press") break;
                    }
                    _this.setAbortReason($d9e3ea87f6d71c14$var$abortReason.keypress, time);
                    break;
                case "resize":
                    _this.setAbortReason($d9e3ea87f6d71c14$var$abortReason.resize, time);
                    break;
            }
        });
        (0, $dqOGO.default)(this, "attachAbortListeners", function() {
            var _window5;
            _this.detachAbortListeners();
            var unbinds = (0, $dKTgt.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window5 = window) !== null && _window5 !== void 0 && _window5.__SSR_ABORT_LISTENERS__) Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref9) {
                var _ref0 = (0, $jzYu7.default)(_ref9, 2), key = _ref0[0], time = _ref0[1];
                if (time) _this.abortReasonCallback(key, time);
            });
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        var ssrEnablePageLayoutPlaceholder = options.ssrEnablePageLayoutPlaceholder, ssrPlaceholderHandler = options.ssrPlaceholderHandler;
        this.observers = new (0, $jfkkn.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            },
            SSRConfig: {
                enablePageLayoutPlaceholder: ssrEnablePageLayoutPlaceholder || false
            },
            ssrPlaceholderHandler: ssrPlaceholderHandler
        });
        this.heatmap = !(0, $bs6hr.isVCRevisionEnabled)("fy25.01") ? [] : this.getCleanHeatmap();
        this.heatmapNext = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    return (0, $c19Op.default)(VCObserver, [
        {
            key: "start",
            value: function start(_ref1) {
                var startTime = _ref1.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason("not-supported", startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref10) {
                    var ignoreReason = _ref10.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref11) {
                    var targetName = _ref11.targetName, ignoreReason = _ref11.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $d9e3ea87f6d71c14$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = !(0, $bs6hr.isVCRevisionEnabled)("fy25.01") ? [] : this.getCleanHeatmap();
                this.heatmapNext = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this2.arraySize).fill($d9e3ea87f6d71c14$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $dSncP.getViewportWidth)();
                this.viewport.h = (0, $dSncP.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($d9e3ea87f6d71c14$var$abortReason.error, time, "index - ".concat(row));
                        } catch (_unused3) {
                            this.setAbortReason($d9e3ea87f6d71c14$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                if (this.unbind) {
                    var unbind = this.unbind;
                    for(var i = 0; i < unbind.length; i++)unbind[i]();
                    this.unbind.length = 0;
                }
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "getSSRRatio",
            value: function getSSRRatio(entries, ssr) {
                if (ssr === undefined || entries.length === 0) return undefined;
                var maybeSSR = entries[0];
                if (maybeSSR.elements[0] === "SSR") return maybeSSR.vc;
                return 0;
            }
        },
        {
            key: "calculateVC",
            value: function calculateVC(_ref12) {
                var heatmap = _ref12.heatmap, _ref12$ssr = _ref12.ssr, ssr = _ref12$ssr === void 0 ? $d9e3ea87f6d71c14$var$UNUSED_SECTOR : _ref12$ssr, componentsLog = _ref12.componentsLog, viewport = _ref12.viewport, fixSSRAttribution = _ref12.fixSSRAttribution;
                var lastUpdate = {};
                var totalPainted = 0;
                var ssrTime = fixSSRAttribution ? Math.floor(ssr) : ssr;
                if (ssrTime !== $d9e3ea87f6d71c14$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssrTime]) componentsLog[ssrTime] = [];
                    componentsLog[ssrTime].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $d9e3ea87f6d71c14$var$UNUSED_SECTOR && ssrTime !== $d9e3ea87f6d71c14$var$UNUSED_SECTOR ? ssrTime : entry);
                        totalPainted += rounded !== $d9e3ea87f6d71c14$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $d9e3ea87f6d71c14$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var currRatio = v[1] / totalPainted;
                    var VCRatio = currRatio + acc;
                    var preciseCurrRatio = Math.round(100 * (v[1] / totalPainted));
                    var preciseAccRatio = Math.round(acc * 100);
                    VCRatio = (preciseCurrRatio + preciseAccRatio) / 100;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (0, $1m3mf.default)(new Set((_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.filter(function(v) {
                                return !v.ignoreReason;
                            }).map(function(v) {
                                return v.targetName;
                            })));
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref13, i) {
                    var _acc$abs, _componentsLog$timest, _acc$rel$vc, _acc$rel;
                    var _ref14 = (0, $jzYu7.default)(_ref13, 2), timestamp = _ref14[0], entryPainted = _ref14[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (0, $1m3mf.default)(new Set((_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.filter(function(v) {
                        return !v.ignoreReason;
                    }).map(function(v) {
                        return v.targetName;
                    })));
                    var ratioDelta = (currentlyPaintedRatio - ((_acc$rel$vc = (_acc$rel = acc.rel[i - 1]) === null || _acc$rel === void 0 ? void 0 : _acc$rel.vc) !== null && _acc$rel$vc !== void 0 ? _acc$rel$vc : 0)) / 100;
                    var speedIndex = timestamp * ratioDelta;
                    acc.speedIndex += speedIndex;
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: [],
                    speedIndex: 0
                });
                VCEntries.speedIndex = Math.round(VCEntries.speedIndex);
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
}();
/** config * */ (0, $dqOGO.default)($d9e3ea87f6d71c14$export$1f70d263701b1d01, "VCParts", [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
]);

});
parcelRegister("6PaYK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f8005a810103459$export$2e2bcd8739ae039; });

var $hXFIu = parcelRequire("hXFIu");
function $4f8005a810103459$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $hXFIu.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("hXFIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1384e6bedb92e48$export$2e2bcd8739ae039; });
function $d1384e6bedb92e48$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("dKTgt", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $a03a70ad9f23ccc0$export$9010aa71841a6887; });

var $2e1kT = parcelRequire("2e1kT");

var $hCUVQ = parcelRequire("hCUVQ");

var $dSncP = parcelRequire("dSncP");
function $a03a70ad9f23ccc0$export$9010aa71841a6887(window, initialViewPort, callback) {
    var unbindWheel = (0, $2e1kT.bind)(window, {
        type: (0, $hCUVQ.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $hCUVQ.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $2e1kT.bind)(window, {
        type: (0, $hCUVQ.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $hCUVQ.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $2e1kT.bind)(window, {
        type: (0, $hCUVQ.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $dSncP.getViewportWidth)() !== initialViewPort.w || (0, $dSncP.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $hCUVQ.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
}

});
parcelRegister("hCUVQ", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $cd5225c6a4a9051f$export$199edc0307b5587f; });
var $cd5225c6a4a9051f$export$199edc0307b5587f = {
    wheel: "wheel",
    keydown: "keydown",
    resize: "resize"
};

});

parcelRegister("dSncP", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $a1a251b7447e4da6$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $a1a251b7447e4da6$export$4f01c15d21ef9cc6; });
function $a1a251b7447e4da6$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $a1a251b7447e4da6$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused2) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("5dCyz", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionDebugDetails", function () { return $3ccc13334bddf60a$export$72e6dda9d5859230; });

var $jzYu7 = parcelRequire("jzYu7");

var $1m3mf = parcelRequire("1m3mf");
function $3ccc13334bddf60a$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3ccc13334bddf60a$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3ccc13334bddf60a$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3ccc13334bddf60a$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3ccc13334bddf60a$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3ccc13334bddf60a$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $3ccc13334bddf60a$export$72e6dda9d5859230(_ref) {
    var revision = _ref.revision, isClean = _ref.isClean, abortReason = _ref.abortReason, VCEntries = _ref.VCEntries, componentsLog = _ref.componentsLog, interactionId = _ref.interactionId;
    // Pre-sort VCEntries by time for efficient lookups
    var sortedVCEntries = (0, $1m3mf.default)(VCEntries).sort(function(a, b) {
        return a.time - b.time;
    });
    // Pre-calculate max viewport percentage up to each time for efficient lookups
    var maxViewportPercentageAtTime = new Map();
    var maxSoFar = 0;
    var _iterator = $3ccc13334bddf60a$var$_createForOfIteratorHelper(sortedVCEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var entry = _step.value;
            maxSoFar = Math.max(maxSoFar, entry.vc);
            maxViewportPercentageAtTime.set(entry.time, maxSoFar);
        }
    // Helper function to find the biggest previous viewport percentage
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
        // Binary search for the largest time <= targetTime
        var left = 0;
        var right = sortedVCEntries.length - 1;
        var result = -1;
        while(left <= right){
            var mid = Math.floor((left + right) / 2);
            if (sortedVCEntries[mid].time <= targetTime) {
                result = mid;
                left = mid + 1;
            } else right = mid - 1;
        }
        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVCEntries[result].time) || null : null;
    };
    var allVcLogs = [];
    // Add regular VC entries
    var _iterator2 = $3ccc13334bddf60a$var$_createForOfIteratorHelper(VCEntries), _step2;
    try {
        var _loop = function _loop() {
            var entry = _step2.value;
            var timeLogEntries = componentsLog[entry.time];
            allVcLogs.push({
                time: entry.time,
                viewportPercentage: entry.vc,
                entries: entry.elements.map(function(element) {
                    var logEntry = timeLogEntries === null || timeLogEntries === void 0 ? void 0 : timeLogEntries.find(function(log) {
                        return log.targetName === element;
                    });
                    return {
                        elementName: element,
                        type: logEntry === null || logEntry === void 0 ? void 0 : logEntry.type,
                        rect: logEntry === null || logEntry === void 0 ? void 0 : logEntry.intersectionRect,
                        visible: true,
                        attributeName: logEntry === null || logEntry === void 0 ? void 0 : logEntry.attributeName,
                        oldValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.oldValue,
                        newValue: logEntry === null || logEntry === void 0 ? void 0 : logEntry.newValue,
                        ignoreReason: logEntry === null || logEntry === void 0 ? void 0 : logEntry.ignoreReason
                    };
                })
            });
        };
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
    // Add ignored elements - only process timestamps that have ignored elements
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    for(var _i = 0, _Object$entries = Object.entries(componentsLog); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = (0, $jzYu7.default)(_Object$entries[_i], 2), timestamp = _Object$entries$_i[0], timeLogEntries = _Object$entries$_i[1];
        var ignoredElements = timeLogEntries.filter(function(log) {
            return log.ignoreReason;
        });
        if (ignoredElements.length === 0) continue;
        var time = Number(timestamp);
        var viewportPercentage = getBiggestPreviousViewportPercentage(time);
        allVcLogs.push({
            time: time,
            viewportPercentage: viewportPercentage,
            entries: ignoredElements.map(function(logEntry) {
                return {
                    elementName: logEntry.targetName,
                    type: logEntry.type,
                    rect: logEntry.intersectionRect,
                    visible: false,
                    attributeName: logEntry.attributeName,
                    oldValue: logEntry.oldValue,
                    newValue: logEntry.newValue,
                    ignoreReason: logEntry.ignoreReason
                };
            })
        });
    }
    // Sort once at the end
    allVcLogs.sort(function(a, b) {
        return a.time - b.time;
    });
    return {
        revision: revision,
        isClean: isClean,
        abortReason: abortReason,
        vcLogs: allVcLogs,
        interactionId: interactionId
    };
}

});

parcelRegister("fHDWd", function(module, exports) {

$parcel$export(module.exports, "getVCRevisionsData", function () { return $b6e9da098811477b$export$5c86a34c9becd6d0; });

var $dqOGO = parcelRequire("dqOGO");

var $bs6hr = parcelRequire("bs6hr");

var $2TVum = parcelRequire("2TVum");
function $b6e9da098811477b$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b6e9da098811477b$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b6e9da098811477b$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b6e9da098811477b$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b6e9da098811477b$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b6e9da098811477b$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b6e9da098811477b$var$VCParts = [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
];
var $b6e9da098811477b$var$READONLY_EMPTY_ARRAY = Array.from({
    length: 0
});
// Helper function to create vcDetails object to avoid code duplication
function $b6e9da098811477b$var$createVCDetails(calculatedVC, shouldHaveVCmetric) {
    if (!shouldHaveVCmetric || !calculatedVC || !calculatedVC.VC || !calculatedVC.VCBox) return {};
    var details = {};
    var VC = calculatedVC.VC, VCBox = calculatedVC.VCBox; // Destructure once to avoid repeated property access
    var _iterator = $b6e9da098811477b$var$_createForOfIteratorHelper($b6e9da098811477b$var$VCParts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            details[key] = {
                t: VC[key] || -1,
                e: VCBox[key] || $b6e9da098811477b$var$READONLY_EMPTY_ARRAY
            };
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return details;
}
function $b6e9da098811477b$export$5c86a34c9becd6d0(_ref) {
    var fullPrefix = _ref.fullPrefix, interaction = _ref.interaction, isVCClean = _ref.isVCClean, isEventAborted = _ref.isEventAborted, calculatedVC = _ref.calculatedVC, calculatedVCNext = _ref.calculatedVCNext, experienceKey = _ref.experienceKey, ratios = _ref.ratios;
    var pageVisibilityUpToTTAI = (0, $2TVum.getPageVisibilityState)(interaction.start, interaction.end);
    var isVisiblePageVisibleUpToTTAI = pageVisibilityUpToTTAI === "visible";
    var shouldHaveVCmetric = isVCClean && !isEventAborted && isVisiblePageVisibleUpToTTAI;
    var availableVCRevisionPayloads = [];
    if ((0, $bs6hr.isVCRevisionEnabled)("fy25.01", experienceKey)) {
        var revision = {
            revision: "fy25.01",
            clean: isVCClean,
            "metric:vc90": shouldHaveVCmetric ? calculatedVC.VC["90"] : null,
            vcDetails: $b6e9da098811477b$var$createVCDetails(calculatedVC, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) revision.ratios = ratios;
        availableVCRevisionPayloads.push(revision);
    }
    if ((0, $bs6hr.isVCRevisionEnabled)("fy25.02", experienceKey)) {
        var _revision = {
            revision: "fy25.02",
            clean: isVCClean,
            "metric:vc90": shouldHaveVCmetric ? calculatedVCNext.VC["90"] : null,
            vcDetails: $b6e9da098811477b$var$createVCDetails(calculatedVCNext, shouldHaveVCmetric)
        };
        if (shouldHaveVCmetric) _revision.ratios = ratios;
        availableVCRevisionPayloads.push(_revision);
    }
    return (0, $dqOGO.default)({}, "".concat(fullPrefix, "vc:rev"), availableVCRevisionPayloads);
}

});

parcelRegister("jfkkn", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $e02f2fb4e3bdb0a6$export$b65d046240060e78; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $lLzX6 = parcelRequire("lLzX6");

var $7GQjF = parcelRequire("7GQjF");

var $6mgdS = parcelRequire("6mgdS");

var $aZv6h = parcelRequire("aZv6h");
function $e02f2fb4e3bdb0a6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e02f2fb4e3bdb0a6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e02f2fb4e3bdb0a6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e02f2fb4e3bdb0a6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e02f2fb4e3bdb0a6$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
function $e02f2fb4e3bdb0a6$var$isElementVisible(target) {
    if (!target || typeof target.checkVisibility !== "function") return true;
    var isVisible = target.checkVisibility({
        contentVisibilityAuto: true,
        opacityProperty: true,
        visibilityProperty: true
    });
    return isVisible;
}
var $e02f2fb4e3bdb0a6$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, $i385U.default)(this, Observers);
        (0, $dqOGO.default)(this, "observedMutations", new WeakMap());
        (0, $dqOGO.default)(this, "elementsInView", new Set());
        (0, $dqOGO.default)(this, "callbacks", new Set());
        (0, $dqOGO.default)(this, "totalTime", 0);
        (0, $dqOGO.default)(this, "_startMeasureTimestamp", -1);
        (0, $dqOGO.default)(this, "ssr", {
            state: $e02f2fb4e3bdb0a6$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, $dqOGO.default)(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, $dqOGO.default)(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, $dqOGO.default)(this, "observeElement", function(node, mutation, type, ignoreReason, attributeName) {
            var _this$intersectionObs;
            var oldValue = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
            var newValue = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type,
                attributeName: attributeName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
        this.selectorConfig = $e02f2fb4e3bdb0a6$var$_objectSpread($e02f2fb4e3bdb0a6$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        // Use shared SSR placeholder handler if provided, otherwise create new one
        if (opts.ssrPlaceholderHandler) this.ssrPlaceholderHandler = opts.ssrPlaceholderHandler;
        else {
            var _opts$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $aZv6h.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_opts$SSRConfig = opts.SSRConfig) === null || _opts$SSRConfig === void 0 ? void 0 : _opts$SSRConfig.enablePageLayoutPlaceholder
            });
        }
    }
    return (0, $c19Op.default)(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === "function" && typeof window.MutationObserver === "function";
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $e02f2fb4e3bdb0a6$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        "hidden",
                        "style",
                        "src",
                        "class"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView.clear();
                this.callbacks.clear();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $e02f2fb4e3bdb0a6$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                if (!this.isBrowserSupported()) return null;
                return new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = "";
                        if (_this2.ssr.state === $e02f2fb4e3bdb0a6$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $e02f2fb4e3bdb0a6$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = "ssr-hydration";
                        }
                        if (_this2.ssr.state === $e02f2fb4e3bdb0a6$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = "ssr-hydration";
                            else _this2.ssr.state = $e02f2fb4e3bdb0a6$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $lLzX6.isContainedWithinMediaWrapper)(node)) ignoreReason = "image";
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, "html", ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") {
                            if (mutation.target instanceof HTMLElement) {
                                var _mutation$oldValue;
                                var attributeName = mutation.attributeName;
                                /*
              	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
              	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
              	Conceptually there is after all a mutation: there is an old value replaced with a new one,
              	and whether or not they are the same doesn't really matter.
              	And Custom elements should work the same way as MutationObserver."
              	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
              */ var oldValue = (_mutation$oldValue = mutation.oldValue) !== null && _mutation$oldValue !== void 0 ? _mutation$oldValue : undefined;
                                var newValue = attributeName ? mutation.target.getAttribute(attributeName) : undefined;
                                if (oldValue !== newValue) {
                                    if ((0, $7GQjF.default)(mutation)) ignoreReason = "non-visual-style";
                                    if ((0, $lLzX6.isContainedWithinMediaWrapper)(mutation.target)) ignoreReason = "image";
                                    _this2.observeElement(mutation.target, mutation, "attr", ignoreReason, attributeName, oldValue, newValue);
                                }
                            }
                        }
                    });
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (_unused) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                if (!this.isBrowserSupported()) return null;
                return new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            if (!$e02f2fb4e3bdb0a6$var$isElementVisible(target)) data.ignoreReason = "not-visible";
                            if ((0, $6mgdS.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(ir)) data.ignoreReason = "rll-placeholder";
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (_unused2) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason, data.attributeName, data.oldValue, data.newValue);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                });
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
}();

});
parcelRegister("lLzX6", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $fd89e026a139be04$export$f61fbc3b9c4a9019; });

var $2J0ye = parcelRequire("2J0ye");
function $fd89e026a139be04$export$f61fbc3b9c4a9019(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $2J0ye.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
}

});
parcelRegister("2J0ye", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $1fc03633e26b0362$export$7674290405cc25b0; });

var $dqOGO = parcelRequire("dqOGO");

var $iSvIT = parcelRequire("iSvIT");
var $1fc03633e26b0362$export$7674290405cc25b0 = "data-media-vc-wrapper";
var $1fc03633e26b0362$export$7028e9efe569888c = (0, $dqOGO.default)({}, $1fc03633e26b0362$export$7674290405cc25b0, true);
function $1fc03633e26b0362$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", $1fc03633e26b0362$export$7028e9efe569888c, children);
}

});


parcelRegister("7GQjF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5995098cff67c8c3$export$2e2bcd8739ae039; });
/**
 * Checks if a mutation record represents a non-visual style change
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a non-visual style mutation
 *
 * A mutation is considered non-visual if:
 * - The target has data-	vc-nvs="true" attribute
 * - The changed attribute is either 'class' or 'style'
 */ function $5995098cff67c8c3$var$isNonVisualStyleMutation(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName;
    if (!(target instanceof Element)) return false;
    if (attributeName !== "class" && attributeName !== "style") return false;
    if (target.getAttribute("data-vc-nvs") !== "true") return false;
    return true;
}
var $5995098cff67c8c3$export$2e2bcd8739ae039 = $5995098cff67c8c3$var$isNonVisualStyleMutation;

});

parcelRegister("6mgdS", function(module, exports) {

$parcel$export(module.exports, "RLLPlaceholderHandlers", function () { return $4a1161a6ffa65002$export$166779fc0f49d4df; });

var $1m3mf = parcelRequire("1m3mf");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");
var $4a1161a6ffa65002$var$GLOBAL_RLL_HANDLERS_KEY = "__REACT_UFO_RLL_PLACEHOLDER_HANDLERS__";
var $4a1161a6ffa65002$export$166779fc0f49d4df = /*#__PURE__*/ function() {
    function RLLPlaceholderHandlers() {
        (0, $i385U.default)(this, RLLPlaceholderHandlers);
        (0, $dqOGO.default)(this, "placeholders", []);
        if (typeof window !== "undefined" && typeof document !== "undefined" && typeof window.document !== "undefined") this.collectRLLPlaceholders();
    }
    /**
   * Gets the global singleton instance of RLLPlaceholderHandlers.
   * Creates the instance if it doesn't exist and stores it in globalThis.
   * @returns The singleton instance of RLLPlaceholderHandlers
   */ return (0, $c19Op.default)(RLLPlaceholderHandlers, [
        {
            key: "reset",
            value: function reset() {
                this.placeholders = [];
            }
        },
        {
            key: "collectRLLPlaceholders",
            value: function collectRLLPlaceholders() {
                if (typeof window === "undefined" || typeof document === "undefined" || typeof window.document === "undefined") return;
                var beginElements = document.querySelectorAll("input[data-lazy-begin]");
                var beginCount = beginElements.length;
                if (beginCount === 0) return;
                // Performance optimization: pre-allocate array with estimated size
                var allElements = [];
                // Performance optimization: use traditional for loop instead of forEach
                for(var i = 0; i < beginCount; i++){
                    var beginEl = beginElements[i];
                    var id = beginEl.getAttribute("data-lazy-begin");
                    if (!id) continue;
                    var elements = this.refElements(beginEl, id);
                    if (elements.length > 0) allElements.push.apply(allElements, (0, $1m3mf.default)(elements));
                }
                // Second pass: batch all getBoundingClientRect calls to minimize reflow cycles
                var allElementsLength = allElements.length;
                if (allElementsLength > 0) {
                    // Performance optimization: pre-allocate array with exact size
                    var intersectingRects = [];
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    for(var _i = 0; _i < allElementsLength; _i++){
                        var rect = allElements[_i].getBoundingClientRect();
                        // Performance optimization: inline intersection calculation to avoid function call overhead
                        var left = Math.max(rect.left, 0);
                        var top = Math.max(rect.top, 0);
                        var right = Math.min(rect.right, windowWidth);
                        var bottom = Math.min(rect.bottom, windowHeight);
                        // Check if there's a valid intersection with non-zero width and height
                        if (left < right && top < bottom) intersectingRects.push(new DOMRect(left, top, right - left, bottom - top));
                    }
                    this.placeholders = intersectingRects;
                }
            }
        },
        {
            key: "refElements",
            value: function refElements(fromEl, id) {
                var result = [];
                var el = fromEl.nextSibling;
                // Performance optimization: use while loop instead of recursive calls
                while(el){
                    var _el$dataset;
                    if (((_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.lazyEnd) === id) break;
                    if (el.nodeType === Node.ELEMENT_NODE) result.push(el);
                    el = el.nextSibling;
                }
                return result;
            }
        },
        {
            key: "getPlaceholders",
            value: function getPlaceholders() {
                return this.placeholders;
            }
        },
        {
            key: "isRLLPlaceholderHydration",
            value: function isRLLPlaceholderHydration(intersectingRect) {
                var placeholdersLength = this.placeholders.length;
                if (placeholdersLength === 0) return false;
                // Performance optimization: cache array length and use traditional for loop
                for(var i = 0; i < placeholdersLength; i++){
                    var placeholderRect = this.placeholders[i];
                    if (this.areRectsEqual(intersectingRect, placeholderRect)) return true;
                }
                return false;
            }
        },
        {
            key: "areRectsEqual",
            value: function areRectsEqual(rect1, rect2) {
                // Early exit for exact matches (most common case)
                if (rect1.left === rect2.left && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom) return true;
                // Performance optimization: check largest differences first for early exit
                var leftDiff = rect1.left - rect2.left;
                if (leftDiff > 1 || leftDiff < -1) return false;
                var rightDiff = rect1.right - rect2.right;
                if (rightDiff > 1 || rightDiff < -1) return false;
                var topDiff = rect1.top - rect2.top;
                if (topDiff > 1 || topDiff < -1) return false;
                var bottomDiff = rect1.bottom - rect2.bottom;
                if (bottomDiff > 1 || bottomDiff < -1) return false;
                return true;
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance() {
                if (typeof globalThis !== "undefined") {
                    if (!globalThis[$4a1161a6ffa65002$var$GLOBAL_RLL_HANDLERS_KEY]) globalThis[$4a1161a6ffa65002$var$GLOBAL_RLL_HANDLERS_KEY] = new RLLPlaceholderHandlers();
                    return globalThis[$4a1161a6ffa65002$var$GLOBAL_RLL_HANDLERS_KEY];
                }
                // Fallback for environments without globalThis (should be rare)
                return new RLLPlaceholderHandlers();
            }
        }
    ]);
}();

});

parcelRegister("aZv6h", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $8007b9c6040eb22c$export$c0102f1a1198d10f; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");
var $8007b9c6040eb22c$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $8007b9c6040eb22c$var$PAGE_LAYOUT_ID = "page-layout.root";
var $8007b9c6040eb22c$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers(_ref) {
        var _this = this;
        var _ref$enablePageLayout = _ref.enablePageLayoutPlaceholder, enablePageLayoutPlaceholder = _ref$enablePageLayout === void 0 ? false : _ref$enablePageLayout;
        (0, $i385U.default)(this, SSRPlaceholderHandlers);
        (0, $dqOGO.default)(this, "staticPlaceholders", new Map());
        (0, $dqOGO.default)(this, "callbacks", new Map());
        (0, $dqOGO.default)(this, "getSizeCallbacks", new Map());
        (0, $dqOGO.default)(this, "reactValidateCallbacks", new Map());
        (0, $dqOGO.default)(this, "EQUALITY_THRESHOLD", 1);
        (0, $dqOGO.default)(this, "getPlaceholderId", function(el) {
            var _el$dataset;
            var ssrPlaceholderId = el === null || el === void 0 || (_el$dataset = el.dataset) === null || _el$dataset === void 0 ? void 0 : _el$dataset.ssrPlaceholder;
            if (!!ssrPlaceholderId) return ssrPlaceholderId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $8007b9c6040eb22c$var$PAGE_LAYOUT_ID) return $8007b9c6040eb22c$var$PAGE_LAYOUT_ID;
            return "";
        });
        (0, $dqOGO.default)(this, "getPlaceholderReplacementId", function(el) {
            var _el$dataset2;
            var ssrPlaceholderReplaceId = el === null || el === void 0 || (_el$dataset2 = el.dataset) === null || _el$dataset2 === void 0 ? void 0 : _el$dataset2.ssrPlaceholderReplace;
            if (!!ssrPlaceholderReplaceId) return ssrPlaceholderReplaceId;
            if (_this.enablePageLayoutPlaceholder && (el === null || el === void 0 ? void 0 : el.dataset.testid) === $8007b9c6040eb22c$var$PAGE_LAYOUT_ID) return $8007b9c6040eb22c$var$PAGE_LAYOUT_ID;
            return "";
        });
        (0, $dqOGO.default)(this, "intersectionObserverCallback", function(_ref2) {
            var _this$intersectionObs;
            var target = _ref2.target, boundingClientRect = _ref2.boundingClientRect;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = _this.getPlaceholderId(target);
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    if (hasSameSizePosition || _this.isDummyRect(rect)) _resolve(hasSameSizePosition);
                    else requestAnimationFrame(function() {
                        var targetRect = _this.getEffectiveBoundingRect(target);
                        var hasSameSizePosition = _this.hasSameSizePosition(rect, targetRect);
                        _resolve(hasSameSizePosition);
                    });
                    _this.callbacks.delete(staticKey);
                }
            } else {
                var key = _this.getPlaceholderReplacementId(target);
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                if (_hasSameSizePosition || _this.isDummyRect(_rect)) _resolve2(_hasSameSizePosition);
                else requestAnimationFrame(function() {
                    var targetRect = _this.getEffectiveBoundingRect(target);
                    var hasSameSizePosition = _this.hasSameSizePosition(_rect, targetRect);
                    _resolve2(hasSameSizePosition);
                });
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        if (typeof IntersectionObserver === "function") // Only instantiate the IntersectionObserver if it's supported
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        this.enablePageLayoutPlaceholder = enablePageLayoutPlaceholder;
        if (window.document) try {
            // Collect initial placeholders using SSR dimensions
            this.collectPlaceholdersInternal();
        } catch (_unused) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    return (0, $c19Op.default)(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "collectPlaceholdersInternal",
            value: function collectPlaceholdersInternal() {
                var _this2 = this;
                var selector = this.enablePageLayoutPlaceholder ? '[data-ssr-placeholder],[data-testid="page-layout.root"]' : "[data-ssr-placeholder]";
                var existingElements = document.querySelectorAll(selector);
                existingElements.forEach(function(el) {
                    var placeholderId = el instanceof HTMLElement && _this2.getPlaceholderId(el);
                    if (placeholderId && !_this2.staticPlaceholders.has(placeholderId)) {
                        var _window$__SSR_PLACEHO, _this2$intersectionOb;
                        var width = -1;
                        var height = -1;
                        var x = -1;
                        var y = -1;
                        // Use SSR dimensions from window global if available
                        var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[placeholderId];
                        if (boundingClientRect) {
                            width = boundingClientRect.width;
                            height = boundingClientRect.height;
                            x = boundingClientRect.x;
                            y = boundingClientRect.y;
                        } else {
                            // Fallback to current bounding rect if SSR dimensions not available
                            var rect = el.getBoundingClientRect();
                            width = rect.width;
                            height = rect.height;
                            x = rect.x;
                            y = rect.y;
                        }
                        _this2.staticPlaceholders.set(placeholderId, {
                            width: width,
                            height: height,
                            x: x,
                            y: y
                        });
                        (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "collectExistingPlaceholders",
            value: function collectExistingPlaceholders() {
                if (!window.document) return;
                try {
                    // Collect placeholders using SSR dimensions or fallback to live dimensions
                    this.collectPlaceholdersInternal();
                } catch (_unused2) {
                // Silently fail if there are any issues
                } finally{
                    delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
                }
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(this.getPlaceholderId(element));
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(this.getPlaceholderReplacementId(element));
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return "ssrPlaceholderIgnored" in element.dataset;
            }
        },
        {
            key: "isPlaceholderV4",
            value: function isPlaceholderV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $8007b9c6040eb22c$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "isPlaceholderReplacementV4",
            value: function isPlaceholderReplacementV4(element) {
                var currentElement = element;
                var i = 0;
                while(currentElement && i < $8007b9c6040eb22c$var$ANCESTOR_LOOKUP_LIMIT){
                    if (Boolean(this.getPlaceholderReplacementId(currentElement))) return true;
                    currentElement = currentElement.parentElement;
                    i++;
                }
                return false;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $8007b9c6040eb22c$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "findNearestPlaceholderOrContainer",
            value: function findNearestPlaceholderOrContainer(element) {
                var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $8007b9c6040eb22c$var$ANCESTOR_LOOKUP_LIMIT;
                var ancestor = element;
                if (this.isPlaceholderIgnored(element) && element.parentElement) ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < limit){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    if (ancestor.parentElement) {
                        ancestor = ancestor.parentElement;
                        i++;
                    } else break;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this3 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                return new Promise(function(resolve) {
                    if (!_this3.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this3$intersectionOb;
                        _this3.callbacks.set(id, resolve);
                        (_this3$intersectionOb = _this3.intersectionObserver) === null || _this3$intersectionOb === void 0 || _this3$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "checkIfExistedAndSizeMatchingV3",
            value: function checkIfExistedAndSizeMatchingV3(el) {
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderId(el);
                var placeholderRects = this.staticPlaceholders.get(id);
                if (!placeholderRects) return false;
                return this.hasSameSizePosition(placeholderRects, this.getEffectiveBoundingRect(el));
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this4 = this;
                return new Promise(function(resolve) {
                    var _this4$intersectionOb;
                    _this4.getSizeCallbacks.set(_this4.getPlaceholderId(el), resolve);
                    (_this4$intersectionOb = _this4.intersectionObserver) === null || _this4$intersectionOb === void 0 || _this4$intersectionOb.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this5 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = this.getPlaceholderReplacementId(el);
                return new Promise(function(resolve) {
                    if (!_this5.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        var _this5$intersectionOb;
                        _this5.reactValidateCallbacks.set(id, resolve);
                        (_this5$intersectionOb = _this5.intersectionObserver) === null || _this5$intersectionOb === void 0 || _this5$intersectionOb.observe(el);
                    }
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholderV4",
            value: function validateReactComponentMatchToPlaceholderV4(el) {
                el = this.findNearestPlaceholderOrContainer(el, 2); // We are using 2 due to over-eagerness of the default, only check itself and 1 ancestor
                var id = this.getPlaceholderReplacementId(el);
                return this.staticPlaceholders.has(id);
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                if (!rect) return false;
                var horizontalCheck = Math.abs(rect.x - boundingClientRect.x) < this.EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < this.EQUALITY_THRESHOLD;
                var verticalCheck = Math.abs(rect.y - boundingClientRect.y) < this.EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < this.EQUALITY_THRESHOLD;
                return horizontalCheck && verticalCheck || false;
            }
        },
        {
            key: "getEffectiveBoundingRect",
            value: function getEffectiveBoundingRect(el) {
                var computedStyle = window.getComputedStyle(el);
                // If element has display: contents, collect bounding rect from children
                if (computedStyle.display === "contents") {
                    var children = Array.from(el.children);
                    if (children.length === 0) // No children, return zero rect
                    return new DOMRect(0, 0, 0, 0);
                    // Calculate union of all children's bounding rects
                    var minX = Infinity;
                    var minY = Infinity;
                    var maxX = -Infinity;
                    var maxY = -Infinity;
                    children.forEach(function(child) {
                        var childRect = child.getBoundingClientRect();
                        // Skip children with zero dimensions (likely also display: contents)
                        if (childRect.width > 0 || childRect.height > 0) {
                            minX = Math.min(minX, childRect.left);
                            minY = Math.min(minY, childRect.top);
                            maxX = Math.max(maxX, childRect.right);
                            maxY = Math.max(maxY, childRect.bottom);
                        }
                    });
                    // If no children with dimensions found, return zero rect
                    if (minX === Infinity) return new DOMRect(0, 0, 0, 0);
                    return new DOMRect(minX, minY, maxX - minX, maxY - minY);
                }
                // Normal element, return its bounding rect
                return el.getBoundingClientRect();
            }
        },
        {
            key: "isDummyRect",
            value: function isDummyRect(rect) {
                return rect && rect.width < 0 && rect.height < 0 || false;
            }
        }
    ]);
}();

});




parcelRegister("gjbIv", function(module, exports) {

$parcel$export(module.exports, "sinkExtraSearchPageInteractionHandler", function () { return $bdf7826f22910c60$export$e6a07a94f3e112d4; });
$parcel$export(module.exports, "onSearchPageInteractionComplete", function () { return $bdf7826f22910c60$export$74b9ce7e9d206a8; });
function $bdf7826f22910c60$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bdf7826f22910c60$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bdf7826f22910c60$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bdf7826f22910c60$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bdf7826f22910c60$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bdf7826f22910c60$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $bdf7826f22910c60$var$interactionBuffer = [];
var $bdf7826f22910c60$var$bufferInteractionData = function bufferInteractionData(interactionId, data) {
    $bdf7826f22910c60$var$interactionBuffer.push({
        interactionId: interactionId,
        data: data
    });
};
function $bdf7826f22910c60$var$clearInteractionBuffer() {
    $bdf7826f22910c60$var$interactionBuffer.length = 0;
}
function $bdf7826f22910c60$var$appendInteractionData(interactionId, data) {
    $bdf7826f22910c60$var$bufferInteractionData(interactionId, data);
}
function $bdf7826f22910c60$var$installInteractionSink(handler) {
    var _iterator = $bdf7826f22910c60$var$_createForOfIteratorHelper($bdf7826f22910c60$var$interactionBuffer), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, _interactionId = _step$value.interactionId, data = _step$value.data;
            handler(_interactionId, data);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    $bdf7826f22910c60$var$clearInteractionBuffer();
    $bdf7826f22910c60$var$bufferInteractionData = handler;
}
function $bdf7826f22910c60$export$e6a07a94f3e112d4(sinkFn) {
    $bdf7826f22910c60$var$installInteractionSink(sinkFn);
}
function $bdf7826f22910c60$export$74b9ce7e9d206a8(interactionId, data) {
    if (data.ufoName) {
        $bdf7826f22910c60$var$appendInteractionData(interactionId, data);
        $bdf7826f22910c60$var$clearInteractionBuffer();
    }
}

});

parcelRegister("2EE0j", function(module, exports) {

$parcel$export(module.exports, "sanitizeUfoName", function () { return $1eee592e840d423e$export$e08487ea3ae92adb; });
$parcel$export(module.exports, "isSegmentLabel", function () { return $1eee592e840d423e$export$1adbaf5c2363e4ae; });
$parcel$export(module.exports, "buildSegmentTree", function () { return $1eee592e840d423e$export$1569bc0edeecbcd8; });
$parcel$export(module.exports, "stringifyLabelStackFully", function () { return $1eee592e840d423e$export$caeee352b541de1f; });
$parcel$export(module.exports, "labelStackStartWith", function () { return $1eee592e840d423e$export$1787b1cd413c7e2; });
$parcel$export(module.exports, "optimizeLabelStack", function () { return $1eee592e840d423e$export$a0cd72da07c76b4c; });
$parcel$export(module.exports, "getOldSegmentsLabelStack", function () { return $1eee592e840d423e$export$b70bcfd92c93435e; });

var $6PaYK = parcelRequire("6PaYK");

var $dqOGO = parcelRequire("dqOGO");

var $bs6hr = parcelRequire("bs6hr");
var $1eee592e840d423e$var$_excluded = [
    "labelStack"
];
function $1eee592e840d423e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eee592e840d423e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eee592e840d423e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eee592e840d423e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1eee592e840d423e$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $1eee592e840d423e$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $1eee592e840d423e$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $1eee592e840d423e$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $1eee592e840d423e$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $1eee592e840d423e$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $1eee592e840d423e$export$e08487ea3ae92adb(name) {
    return name.replace(/_/g, "-");
}
function $1eee592e840d423e$export$1adbaf5c2363e4ae(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $1eee592e840d423e$export$1569bc0edeecbcd8(labelStacks) {
    var r = {
        n: "segment-tree-root",
        c: {}
    };
    var config = (0, $bs6hr.getConfig)();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    var addSegmentsMap = new Map();
    labelStacks.forEach(function(labelStack) {
        var stringifiedLabelStack = $1eee592e840d423e$export$88f21baa687271f4(labelStack);
        var currentNode = r;
        var _iterator = $1eee592e840d423e$var$_createForOfIteratorHelper(labelStack), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var label = _step.value;
                var isSegment = $1eee592e840d423e$export$1adbaf5c2363e4ae(label);
                var name = label.name;
                if (isSegment && segmentThreshold && segmentThreshold[name]) {
                    var threshold = segmentThreshold[name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                var id = isSegment ? label.segmentId : undefined;
                var key = id !== undefined ? id : name;
                var type = isSegment ? label.type : undefined;
                if (!currentNode.c) currentNode.c = {};
                if (!currentNode.c[key]) currentNode.c[key] = $1eee592e840d423e$var$_objectSpread({
                    n: name
                }, type ? {
                    t: type
                } : {});
                currentNode = currentNode.c[key];
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return {
        r: r
    };
}
function $1eee592e840d423e$export$caeee352b541de1f(labelStack) {
    return labelStack.map(function(l) {
        if ($1eee592e840d423e$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":").concat(l.segmentId);
        return l.name;
    }).join("/");
}
function $1eee592e840d423e$export$88f21baa687271f4(labelStack) {
    return labelStack.map(function(l) {
        if ($1eee592e840d423e$export$1adbaf5c2363e4ae(l)) return "".concat(l.name, ":segment");
        return l.name;
    }).join("/");
}
function $1eee592e840d423e$var$getLabelStackReference(labelStack) {
    return labelStack.map(function(l) {
        return $1eee592e840d423e$export$1adbaf5c2363e4ae(l) ? l.segmentId : l.name;
    }).join("/");
}
function $1eee592e840d423e$export$1787b1cd413c7e2(labelStack, startWith) {
    return $1eee592e840d423e$export$caeee352b541de1f(labelStack).startsWith($1eee592e840d423e$export$caeee352b541de1f(startWith));
}
function $1eee592e840d423e$export$a0cd72da07c76b4c(labelStack, reactUFOVersion) {
    return reactUFOVersion === "2.0.0" ? $1eee592e840d423e$var$getLabelStackReference(labelStack) : labelStack.map(function(ls) {
        return $1eee592e840d423e$var$_objectSpread($1eee592e840d423e$var$_objectSpread({
            n: ls.name
        }, ls.segmentId ? {
            s: ls.segmentId
        } : {}), ls.type ? {
            t: ls.type
        } : {});
    });
}
function $1eee592e840d423e$export$b70bcfd92c93435e(segments, _interactionType) {
    var config = (0, $bs6hr.getConfig)();
    var addSegmentsMap = new Map();
    var segmentThreshold = config === null || config === void 0 ? void 0 : config.segmentsThreshold;
    return segments.map(function(_ref) {
        var labelStack = _ref.labelStack, others = (0, $6PaYK.default)(_ref, $1eee592e840d423e$var$_excluded);
        var stringifiedLabelStack = $1eee592e840d423e$export$88f21baa687271f4(labelStack);
        var segmentsInfo = [];
        var _iterator2 = $1eee592e840d423e$var$_createForOfIteratorHelper(labelStack), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var ls = _step2.value;
                var isSegment = $1eee592e840d423e$export$1adbaf5c2363e4ae(ls);
                if (isSegment && segmentThreshold && segmentThreshold[ls.name]) {
                    var threshold = segmentThreshold[ls.name];
                    var count = addSegmentsMap.get(stringifiedLabelStack) || 0;
                    if (count < threshold) addSegmentsMap.set(stringifiedLabelStack, count + 1);
                    else break;
                }
                segmentsInfo.push($1eee592e840d423e$var$_objectSpread($1eee592e840d423e$var$_objectSpread({
                    n: ls.name
                }, ls.segmentId ? {
                    s: ls.segmentId
                } : {}), ls.type ? {
                    t: ls.type
                } : {}));
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        return $1eee592e840d423e$var$_objectSpread($1eee592e840d423e$var$_objectSpread({}, others), {}, {
            labelStack: segmentsInfo
        });
    });
}

});

parcelRegister("9jPnd", function(module, exports) {

$parcel$export(module.exports, "setInteractionActiveTrace", function () { return $6c8dbd14da296ba1$export$f2e521e495a88544; });
$parcel$export(module.exports, "getActiveTrace", function () { return $6c8dbd14da296ba1$export$b6ac780db3a3cc77; });
$parcel$export(module.exports, "clearActiveTrace", function () { return $6c8dbd14da296ba1$export$17ab21d7be720b; });
parcelRequire("f6ogN");
var $C3IJI = parcelRequire("C3IJI");
var $9uCpq = parcelRequire("9uCpq");

var $jxLBU = parcelRequire("jxLBU");

var $fhH6n = parcelRequire("fhH6n");

var $asp6Z = parcelRequire("asp6Z");
var $6c8dbd14da296ba1$var$state = {
    context: null
};
var $6c8dbd14da296ba1$var$traceIdKey = (0, $9uCpq.createContextKey)("traceId");
var $6c8dbd14da296ba1$var$spanIdKey = (0, $9uCpq.createContextKey)("spanId");
var $6c8dbd14da296ba1$var$experienceTypeKey = (0, $9uCpq.createContextKey)("type");
function $6c8dbd14da296ba1$export$295213bc4d0c54ad() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join("");
}
function $6c8dbd14da296ba1$export$f2e521e495a88544(interactionId, experienceType) {
    $6c8dbd14da296ba1$export$a1002be327997103(interactionId.replace(/-/g, ""), $6c8dbd14da296ba1$export$295213bc4d0c54ad(), experienceType);
}
function $6c8dbd14da296ba1$export$a1002be327997103(traceId, spanId, type) {
    if ((0, $jxLBU.fg)("platform_ufo_enable_otel_context_manager")) {
        var activeTraceContext = (0, $9uCpq.ROOT_CONTEXT).setValue($6c8dbd14da296ba1$var$traceIdKey, traceId).setValue($6c8dbd14da296ba1$var$spanIdKey, spanId).setValue($6c8dbd14da296ba1$var$experienceTypeKey, type);
        // Now we need to get the global Context Manager and set the active context
        // Using type assertion because we've "extended" the ContextManager type
        if ((0, $fhH6n.getContextManager)() instanceof (0, $fhH6n.UFOContextManager)) {
            var contextManager = (0, $fhH6n.getContextManager)();
            contextManager.setActive(activeTraceContext);
        }
    } else $6c8dbd14da296ba1$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
}
function $6c8dbd14da296ba1$export$b6ac780db3a3cc77() {
    if ((0, $jxLBU.fg)("platform_ufo_enable_otel_context_manager")) {
        // Get trace context from active context
        var activeTraceContext = {
            traceId: String((0, $C3IJI.context).active().getValue($6c8dbd14da296ba1$var$traceIdKey)),
            spanId: String((0, $C3IJI.context).active().getValue($6c8dbd14da296ba1$var$spanIdKey)),
            type: String((0, $C3IJI.context).active().getValue($6c8dbd14da296ba1$var$experienceTypeKey))
        };
        // Return activeTraceContext if traceId and spanId are not "undefined"
        return activeTraceContext.traceId !== "undefined" && activeTraceContext.spanId !== "undefined" ? activeTraceContext : undefined;
    } else return $6c8dbd14da296ba1$var$state.context || undefined;
}
function $6c8dbd14da296ba1$export$17ab21d7be720b() {
    if ((0, $jxLBU.fg)("platform_ufo_enable_otel_context_manager")) // Now we need to get the global Context Manager and set the active context
    // Using type assertion because we've "extended" the ContextManager type
    {
        if ((0, $fhH6n.getContextManager)() instanceof (0, $fhH6n.UFOContextManager)) {
            var contextManager = (0, $fhH6n.getContextManager)();
            // ROOT_CONTEXT is an empty context used to initialise ContextManagers
            contextManager.setActive((0, $9uCpq.ROOT_CONTEXT));
        }
    } else $6c8dbd14da296ba1$var$state.context = null;
}
function $6c8dbd14da296ba1$export$6e17cce6446848f9(_url) {
    if ($6c8dbd14da296ba1$export$b6ac780db3a3cc77() === undefined) return null;
    var _ref = $6c8dbd14da296ba1$export$b6ac780db3a3cc77(), traceId = _ref.traceId, spanId = _ref.spanId;
    return (0, $asp6Z.makeTraceHttpRequestHeaders)(traceId, spanId);
}
function $6c8dbd14da296ba1$export$a1e7396778592551(_url) {
    var traceHeaders = $6c8dbd14da296ba1$export$6e17cce6446848f9();
    return traceHeaders ? new URLSearchParams(traceHeaders).toString().toLowerCase() : null;
}

});
parcelRegister("f6ogN", function(module, exports) {

$parcel$export(module.exports, "context", function () { return (parcelRequire("C3IJI")).context; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $9uCpq = parcelRequire("9uCpq");















var $C3IJI = parcelRequire("C3IJI");

var $cqkEy = parcelRequire("cqkEy");

var $h6LG3 = parcelRequire("h6LG3");

var $7mFyY = parcelRequire("7mFyY");

var $9lxUT = parcelRequire("9lxUT");
var // Default export.
$afea3e136baa9a15$export$2e2bcd8739ae039 = {
    context: (0, $C3IJI.context),
    diag: (0, $cqkEy.diag),
    metrics: (0, $h6LG3.metrics),
    propagation: (0, $7mFyY.propagation),
    trace: (0, $9lxUT.trace)
};

});
parcelRegister("9uCpq", function(module, exports) {

$parcel$export(module.exports, "createContextKey", function () { return $6e94b5a90488f114$export$b8c322c5a7cfce78; });
$parcel$export(module.exports, "ROOT_CONTEXT", function () { return $6e94b5a90488f114$export$78df28f9b2f9a7dc; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $6e94b5a90488f114$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $6e94b5a90488f114$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $6e94b5a90488f114$export$78df28f9b2f9a7dc = new $6e94b5a90488f114$var$BaseContext();

});

parcelRegister("C3IJI", function(module, exports) {

$parcel$export(module.exports, "context", function () { return $07266f8c7d8eeb89$export$a078c61943f9dbbe; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $gHHrV = parcelRequire("gHHrV");
var $07266f8c7d8eeb89$export$a078c61943f9dbbe = (0, $gHHrV.ContextAPI).getInstance();

});
parcelRegister("gHHrV", function(module, exports) {

$parcel$export(module.exports, "ContextAPI", function () { return $c2925da288b7b526$export$4148866f0a453927; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bjGiw = parcelRequire("bjGiw");

var $cMnr6 = parcelRequire("cMnr6");

var $27KGI = parcelRequire("27KGI");
var $c2925da288b7b526$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $c2925da288b7b526$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $c2925da288b7b526$var$API_NAME = "context";
var $c2925da288b7b526$var$NOOP_CONTEXT_MANAGER = new (0, $bjGiw.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $c2925da288b7b526$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $cMnr6.registerGlobal)($c2925da288b7b526$var$API_NAME, contextManager, (0, $27KGI.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $c2925da288b7b526$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $c2925da288b7b526$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $cMnr6.getGlobal)($c2925da288b7b526$var$API_NAME) || $c2925da288b7b526$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $cMnr6.unregisterGlobal)($c2925da288b7b526$var$API_NAME, (0, $27KGI.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("bjGiw", function(module, exports) {

$parcel$export(module.exports, "NoopContextManager", function () { return $83d247873b85e783$export$a27e5df35d1539a6; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9uCpq = parcelRequire("9uCpq");
var $83d247873b85e783$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $83d247873b85e783$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $83d247873b85e783$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $9uCpq.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $83d247873b85e783$var$__spreadArray([
            thisArg
        ], $83d247873b85e783$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("cMnr6", function(module, exports) {

$parcel$export(module.exports, "registerGlobal", function () { return $94dc25a7538a8be9$export$d586ae880b433238; });
$parcel$export(module.exports, "getGlobal", function () { return $94dc25a7538a8be9$export$a4e55266d2135a7f; });
$parcel$export(module.exports, "unregisterGlobal", function () { return $94dc25a7538a8be9$export$d42ac835f38d1fb2; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $1UPTz = parcelRequire("1UPTz");

var $2Xc3n = parcelRequire("2Xc3n");

var $4H3Ri = parcelRequire("4H3Ri");
var $94dc25a7538a8be9$var$major = (0, $2Xc3n.VERSION).split(".")[0];
var $94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $94dc25a7538a8be9$var$major);
var $94dc25a7538a8be9$var$_global = (0, $1UPTz._globalThis);
function $94dc25a7538a8be9$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $94dc25a7538a8be9$var$_global[$94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $94dc25a7538a8be9$var$_global[$94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $2Xc3n.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $2Xc3n.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $2Xc3n.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $2Xc3n.VERSION) + ".");
    return true;
}
function $94dc25a7538a8be9$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $94dc25a7538a8be9$var$_global[$94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $4H3Ri.isCompatible)(globalVersion)) return;
    return (_b = $94dc25a7538a8be9$var$_global[$94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $94dc25a7538a8be9$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $2Xc3n.VERSION) + ".");
    var api = $94dc25a7538a8be9$var$_global[$94dc25a7538a8be9$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("1UPTz", function(module, exports) {

$parcel$export(module.exports, "_globalThis", function () { return $165346b74c2e4647$export$5c524ddf7208c00c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $165346b74c2e4647$export$5c524ddf7208c00c = typeof globalThis === "object" ? globalThis : typeof self === "object" ? self : typeof window === "object" ? window : typeof $parcel$global === "object" ? $parcel$global : {};

});

parcelRegister("2Xc3n", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $226a7109dacf297e$export$a4ad2735b021c132; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $226a7109dacf297e$export$a4ad2735b021c132 = "1.9.0";

});

parcelRegister("4H3Ri", function(module, exports) {

$parcel$export(module.exports, "isCompatible", function () { return $36ae2bd53551143c$export$7fc0d8c3ab188c4c; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2Xc3n = parcelRequire("2Xc3n");
var $36ae2bd53551143c$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $36ae2bd53551143c$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($36ae2bd53551143c$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($36ae2bd53551143c$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $36ae2bd53551143c$export$7fc0d8c3ab188c4c = $36ae2bd53551143c$export$a5733a4d26a1ec61((0, $2Xc3n.VERSION));

});


parcelRegister("27KGI", function(module, exports) {

$parcel$export(module.exports, "DiagAPI", function () { return $18c0737a7be995e6$export$5c8937ffc688cfd3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $c7Wlq = parcelRequire("c7Wlq");

var $3b4ke = parcelRequire("3b4ke");

var $6Qtqa = parcelRequire("6Qtqa");

var $cMnr6 = parcelRequire("cMnr6");
var $18c0737a7be995e6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $18c0737a7be995e6$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $18c0737a7be995e6$var$API_NAME = "diag";
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $18c0737a7be995e6$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $cMnr6.getGlobal)("diag");
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $18c0737a7be995e6$var$__spreadArray([], $18c0737a7be995e6$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $6Qtqa.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error("Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation");
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === "number") optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $cMnr6.getGlobal)("diag");
            var newLogger = (0, $3b4ke.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $6Qtqa.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : "<failed to generate stacktrace>";
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $cMnr6.registerGlobal)("diag", newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $cMnr6.unregisterGlobal)($18c0737a7be995e6$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $c7Wlq.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy("verbose");
        self.debug = _logProxy("debug");
        self.info = _logProxy("info");
        self.warn = _logProxy("warn");
        self.error = _logProxy("error");
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("c7Wlq", function(module, exports) {

$parcel$export(module.exports, "DiagComponentLogger", function () { return $8d43657d0db0c683$export$b4bccc12f5b13129; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cMnr6 = parcelRequire("cMnr6");
var $8d43657d0db0c683$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $8d43657d0db0c683$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $8d43657d0db0c683$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || "DiagComponentLogger";
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d43657d0db0c683$var$logProxy("debug", this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d43657d0db0c683$var$logProxy("error", this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d43657d0db0c683$var$logProxy("info", this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d43657d0db0c683$var$logProxy("warn", this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $8d43657d0db0c683$var$logProxy("verbose", this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $8d43657d0db0c683$var$logProxy(funcName, namespace, args) {
    var logger = (0, $cMnr6.getGlobal)("diag");
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $8d43657d0db0c683$var$__spreadArray([], $8d43657d0db0c683$var$__read(args), false));
}

});

parcelRegister("3b4ke", function(module, exports) {

$parcel$export(module.exports, "createLogLevelDiagLogger", function () { return $2505c11f32b0b7df$export$9a9cc475abb19689; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $6Qtqa = parcelRequire("6Qtqa");
function $2505c11f32b0b7df$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $6Qtqa.DiagLogLevel).NONE) maxLevel = (0, $6Qtqa.DiagLogLevel).NONE;
    else if (maxLevel > (0, $6Qtqa.DiagLogLevel).ALL) maxLevel = (0, $6Qtqa.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === "function" && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc("error", (0, $6Qtqa.DiagLogLevel).ERROR),
        warn: _filterFunc("warn", (0, $6Qtqa.DiagLogLevel).WARN),
        info: _filterFunc("info", (0, $6Qtqa.DiagLogLevel).INFO),
        debug: _filterFunc("debug", (0, $6Qtqa.DiagLogLevel).DEBUG),
        verbose: _filterFunc("verbose", (0, $6Qtqa.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("6Qtqa", function(module, exports) {

$parcel$export(module.exports, "DiagLogLevel", function () { return $4fbe6bd3d8e1f299$export$b7d7b4c0f3c95263; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $4fbe6bd3d8e1f299$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($4fbe6bd3d8e1f299$export$b7d7b4c0f3c95263 || ($4fbe6bd3d8e1f299$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("cqkEy", function(module, exports) {

$parcel$export(module.exports, "diag", function () { return $90b7ef05715cc78d$export$c042e7c2f59bc046; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $27KGI = parcelRequire("27KGI");
var $90b7ef05715cc78d$export$c042e7c2f59bc046 = (0, $27KGI.DiagAPI).instance();

});

parcelRegister("h6LG3", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $c747faeba7fcf1ef$export$b0c5c2fac8144e54; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $11k8v = parcelRequire("11k8v");
var $c747faeba7fcf1ef$export$b0c5c2fac8144e54 = (0, $11k8v.MetricsAPI).getInstance();

});
parcelRegister("11k8v", function(module, exports) {

$parcel$export(module.exports, "MetricsAPI", function () { return $0be5810dab86a753$export$1339f6eb6111c638; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $2HZ3i = parcelRequire("2HZ3i");

var $cMnr6 = parcelRequire("cMnr6");

var $27KGI = parcelRequire("27KGI");
var $0be5810dab86a753$var$API_NAME = "metrics";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $0be5810dab86a753$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $cMnr6.registerGlobal)($0be5810dab86a753$var$API_NAME, provider, (0, $27KGI.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $cMnr6.getGlobal)($0be5810dab86a753$var$API_NAME) || (0, $2HZ3i.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $cMnr6.unregisterGlobal)($0be5810dab86a753$var$API_NAME, (0, $27KGI.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("2HZ3i", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER_PROVIDER", function () { return $1f8ef4a2d118affc$export$d21fe83355c56e18; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lR3dw = parcelRequire("lR3dw");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $1f8ef4a2d118affc$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $lR3dw.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $1f8ef4a2d118affc$export$d21fe83355c56e18 = new $1f8ef4a2d118affc$export$51c513ea08316108();

});
parcelRegister("lR3dw", function(module, exports) {

$parcel$export(module.exports, "NOOP_METER", function () { return $fe910b12e618667e$export$65e277d35235a01f; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $fe910b12e618667e$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $fe910b12e618667e$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $fe910b12e618667e$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $fe910b12e618667e$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $fe910b12e618667e$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $fe910b12e618667e$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $fe910b12e618667e$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $fe910b12e618667e$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $fe910b12e618667e$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $fe910b12e618667e$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $fe910b12e618667e$export$b556ba0f560c45b = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($fe910b12e618667e$export$834a616d1cf278b);
var $fe910b12e618667e$export$df09a35db160df98 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($fe910b12e618667e$export$834a616d1cf278b);
var $fe910b12e618667e$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($fe910b12e618667e$export$834a616d1cf278b);
var $fe910b12e618667e$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($fe910b12e618667e$export$834a616d1cf278b);
var $fe910b12e618667e$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $fe910b12e618667e$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($fe910b12e618667e$export$a5a3e7829c289482);
var $fe910b12e618667e$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($fe910b12e618667e$export$a5a3e7829c289482);
var $fe910b12e618667e$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $fe910b12e618667e$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($fe910b12e618667e$export$a5a3e7829c289482);
var $fe910b12e618667e$export$65e277d35235a01f = new $fe910b12e618667e$export$c23c6f85dd4fc1e9();
var $fe910b12e618667e$export$e6d19fe5233efc54 = new $fe910b12e618667e$export$b556ba0f560c45b();
var $fe910b12e618667e$export$dd01300aacbcec1c = new $fe910b12e618667e$export$b7f4a3c7ea16c24();
var $fe910b12e618667e$export$689c32a6a552e1a6 = new $fe910b12e618667e$export$ef064c3e0426c607();
var $fe910b12e618667e$export$2f189cd99d2b7429 = new $fe910b12e618667e$export$df09a35db160df98();
var $fe910b12e618667e$export$163422b94c3edbcb = new $fe910b12e618667e$export$7a7e4b169d5c93a8();
var $fe910b12e618667e$export$ea67e3c6ff624776 = new $fe910b12e618667e$export$6990a2f90809ffc1();
var $fe910b12e618667e$export$5b8be9ab17b673b3 = new $fe910b12e618667e$export$3ec3555bc6f693a4();
function $fe910b12e618667e$export$bc3a498ccbb5c2b5() {
    return $fe910b12e618667e$export$65e277d35235a01f;
}

});




parcelRegister("7mFyY", function(module, exports) {

$parcel$export(module.exports, "propagation", function () { return $55cad40fa3d81132$export$3e49040daa9dba20; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $b82C6 = parcelRequire("b82C6");
var $55cad40fa3d81132$export$3e49040daa9dba20 = (0, $b82C6.PropagationAPI).getInstance();

});
parcelRegister("b82C6", function(module, exports) {

$parcel$export(module.exports, "PropagationAPI", function () { return $81a2780d4ee9cc5a$export$471eda0a6213cac9; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cMnr6 = parcelRequire("cMnr6");

var $ejh9x = parcelRequire("ejh9x");

var $cLPl2 = parcelRequire("cLPl2");

var $10vyQ = parcelRequire("10vyQ");

var $5lUOj = parcelRequire("5lUOj");

var $27KGI = parcelRequire("27KGI");
var $81a2780d4ee9cc5a$var$API_NAME = "propagation";
var $81a2780d4ee9cc5a$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $ejh9x.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $81a2780d4ee9cc5a$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $5lUOj.createBaggage);
        this.getBaggage = (0, $10vyQ.getBaggage);
        this.getActiveBaggage = (0, $10vyQ.getActiveBaggage);
        this.setBaggage = (0, $10vyQ.setBaggage);
        this.deleteBaggage = (0, $10vyQ.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $cMnr6.registerGlobal)($81a2780d4ee9cc5a$var$API_NAME, propagator, (0, $27KGI.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $cLPl2.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $cLPl2.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $cMnr6.unregisterGlobal)($81a2780d4ee9cc5a$var$API_NAME, (0, $27KGI.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $cMnr6.getGlobal)($81a2780d4ee9cc5a$var$API_NAME) || $81a2780d4ee9cc5a$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("ejh9x", function(module, exports) {

$parcel$export(module.exports, "NoopTextMapPropagator", function () { return $a6b025422308a9ef$export$8356c7eb3af7963b; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $a6b025422308a9ef$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("cLPl2", function(module, exports) {

$parcel$export(module.exports, "defaultTextMapGetter", function () { return $94c1b286bbf0842b$export$a0f575f55f38720a; });
$parcel$export(module.exports, "defaultTextMapSetter", function () { return $94c1b286bbf0842b$export$f70f1d111fccf1c1; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $94c1b286bbf0842b$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $94c1b286bbf0842b$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("10vyQ", function(module, exports) {

$parcel$export(module.exports, "getBaggage", function () { return $0bbe45e4a6538953$export$f3bffa0b5dd10d1e; });
$parcel$export(module.exports, "getActiveBaggage", function () { return $0bbe45e4a6538953$export$120a1756099436ee; });
$parcel$export(module.exports, "setBaggage", function () { return $0bbe45e4a6538953$export$adc9ca19eab3f500; });
$parcel$export(module.exports, "deleteBaggage", function () { return $0bbe45e4a6538953$export$4ca3a8a743c9f633; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gHHrV = parcelRequire("gHHrV");

var $9uCpq = parcelRequire("9uCpq");
/**
 * Baggage key
 */ var $0bbe45e4a6538953$var$BAGGAGE_KEY = (0, $9uCpq.createContextKey)("OpenTelemetry Baggage Key");
function $0bbe45e4a6538953$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($0bbe45e4a6538953$var$BAGGAGE_KEY) || undefined;
}
function $0bbe45e4a6538953$export$120a1756099436ee() {
    return $0bbe45e4a6538953$export$f3bffa0b5dd10d1e((0, $gHHrV.ContextAPI).getInstance().active());
}
function $0bbe45e4a6538953$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($0bbe45e4a6538953$var$BAGGAGE_KEY, baggage);
}
function $0bbe45e4a6538953$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($0bbe45e4a6538953$var$BAGGAGE_KEY);
}

});

parcelRegister("5lUOj", function(module, exports) {

$parcel$export(module.exports, "createBaggage", function () { return $3e5afb4c89d75b01$export$1034a425c7384452; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $27KGI = parcelRequire("27KGI");

var $513cE = parcelRequire("513cE");

var $lBBPm = parcelRequire("lBBPm");
var $3e5afb4c89d75b01$var$diag = (0, $27KGI.DiagAPI).instance();
function $3e5afb4c89d75b01$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $513cE.BaggageImpl)(new Map(Object.entries(entries)));
}
function $3e5afb4c89d75b01$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== "string") {
        $3e5afb4c89d75b01$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = "";
    }
    return {
        __TYPE__: (0, $lBBPm.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("513cE", function(module, exports) {

$parcel$export(module.exports, "BaggageImpl", function () { return $3a6f87cd10100549$export$b8c511fa1a5f4987; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $3a6f87cd10100549$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3a6f87cd10100549$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $3a6f87cd10100549$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $3a6f87cd10100549$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $3a6f87cd10100549$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("lBBPm", function(module, exports) {

$parcel$export(module.exports, "baggageEntryMetadataSymbol", function () { return $fbaa65638894a6ec$export$92dd2fe8ddb5cb7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $fbaa65638894a6ec$export$92dd2fe8ddb5cb7 = Symbol("BaggageEntryMetadata");

});




parcelRegister("9lxUT", function(module, exports) {

$parcel$export(module.exports, "trace", function () { return $6ce06258dafb396a$export$357889f174732d38; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $eYG4C = parcelRequire("eYG4C");
var $6ce06258dafb396a$export$357889f174732d38 = (0, $eYG4C.TraceAPI).getInstance();

});
parcelRegister("eYG4C", function(module, exports) {

$parcel$export(module.exports, "TraceAPI", function () { return $ae774e327409b8a2$export$2cccde6fcc7b568a; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cMnr6 = parcelRequire("cMnr6");

var $iwEle = parcelRequire("iwEle");

var $bHs1K = parcelRequire("bHs1K");

var $aNQnf = parcelRequire("aNQnf");

var $27KGI = parcelRequire("27KGI");
var $ae774e327409b8a2$var$API_NAME = "trace";
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $ae774e327409b8a2$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $iwEle.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $bHs1K.wrapSpanContext);
        this.isSpanContextValid = (0, $bHs1K.isSpanContextValid);
        this.deleteSpan = (0, $aNQnf.deleteSpan);
        this.getSpan = (0, $aNQnf.getSpan);
        this.getActiveSpan = (0, $aNQnf.getActiveSpan);
        this.getSpanContext = (0, $aNQnf.getSpanContext);
        this.setSpan = (0, $aNQnf.setSpan);
        this.setSpanContext = (0, $aNQnf.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $cMnr6.registerGlobal)($ae774e327409b8a2$var$API_NAME, this._proxyTracerProvider, (0, $27KGI.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $cMnr6.getGlobal)($ae774e327409b8a2$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $cMnr6.unregisterGlobal)($ae774e327409b8a2$var$API_NAME, (0, $27KGI.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $iwEle.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("iwEle", function(module, exports) {

$parcel$export(module.exports, "ProxyTracerProvider", function () { return $d7ca822285e724a9$export$4137aabcb4254962; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bG7AG = parcelRequire("bG7AG");

var $3QdFY = parcelRequire("3QdFY");
var $d7ca822285e724a9$var$NOOP_TRACER_PROVIDER = new (0, $3QdFY.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $d7ca822285e724a9$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $bG7AG.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $d7ca822285e724a9$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("bG7AG", function(module, exports) {

$parcel$export(module.exports, "ProxyTracer", function () { return $8809814d263940f8$export$df2c38268c6bb6b3; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5tIX0 = parcelRequire("5tIX0");
var $8809814d263940f8$var$NOOP_TRACER = new (0, $5tIX0.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $8809814d263940f8$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $8809814d263940f8$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("5tIX0", function(module, exports) {

$parcel$export(module.exports, "NoopTracer", function () { return $3fd287705e61c587$export$714c1036cabcd223; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gHHrV = parcelRequire("gHHrV");

var $aNQnf = parcelRequire("aNQnf");

var $imQXg = parcelRequire("imQXg");

var $bHs1K = parcelRequire("bHs1K");
var $3fd287705e61c587$var$contextApi = (0, $gHHrV.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $3fd287705e61c587$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $3fd287705e61c587$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $imQXg.NonRecordingSpan)();
        var parentFromContext = context && (0, $aNQnf.getSpanContext)(context);
        if ($3fd287705e61c587$var$isSpanContext(parentFromContext) && (0, $bHs1K.isSpanContextValid)(parentFromContext)) return new (0, $imQXg.NonRecordingSpan)(parentFromContext);
        else return new (0, $imQXg.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $3fd287705e61c587$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $aNQnf.setSpan)(parentContext, span);
        return $3fd287705e61c587$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $3fd287705e61c587$var$isSpanContext(spanContext) {
    return typeof spanContext === "object" && typeof spanContext["spanId"] === "string" && typeof spanContext["traceId"] === "string" && typeof spanContext["traceFlags"] === "number";
}

});
parcelRegister("aNQnf", function(module, exports) {

$parcel$export(module.exports, "getSpan", function () { return $7dd71b5de2e61e80$export$246e04ba06066af1; });
$parcel$export(module.exports, "getActiveSpan", function () { return $7dd71b5de2e61e80$export$1be426a8e585c83e; });
$parcel$export(module.exports, "setSpan", function () { return $7dd71b5de2e61e80$export$8ab2f2e6ee8ed0a8; });
$parcel$export(module.exports, "deleteSpan", function () { return $7dd71b5de2e61e80$export$a6bbfe9a17f7941c; });
$parcel$export(module.exports, "setSpanContext", function () { return $7dd71b5de2e61e80$export$c90bf5428c14cdb1; });
$parcel$export(module.exports, "getSpanContext", function () { return $7dd71b5de2e61e80$export$1a635f8f0b912781; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $9uCpq = parcelRequire("9uCpq");

var $imQXg = parcelRequire("imQXg");

var $gHHrV = parcelRequire("gHHrV");
/**
 * span key
 */ var $7dd71b5de2e61e80$var$SPAN_KEY = (0, $9uCpq.createContextKey)("OpenTelemetry Context Key SPAN");
function $7dd71b5de2e61e80$export$246e04ba06066af1(context) {
    return context.getValue($7dd71b5de2e61e80$var$SPAN_KEY) || undefined;
}
function $7dd71b5de2e61e80$export$1be426a8e585c83e() {
    return $7dd71b5de2e61e80$export$246e04ba06066af1((0, $gHHrV.ContextAPI).getInstance().active());
}
function $7dd71b5de2e61e80$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($7dd71b5de2e61e80$var$SPAN_KEY, span);
}
function $7dd71b5de2e61e80$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($7dd71b5de2e61e80$var$SPAN_KEY);
}
function $7dd71b5de2e61e80$export$c90bf5428c14cdb1(context, spanContext) {
    return $7dd71b5de2e61e80$export$8ab2f2e6ee8ed0a8(context, new (0, $imQXg.NonRecordingSpan)(spanContext));
}
function $7dd71b5de2e61e80$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $7dd71b5de2e61e80$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("imQXg", function(module, exports) {

$parcel$export(module.exports, "NonRecordingSpan", function () { return $d5f35bc8328f59af$export$972d28f7c6a8c6c7; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bsL0N = parcelRequire("bsL0N");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $d5f35bc8328f59af$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $bsL0N.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("bsL0N", function(module, exports) {

$parcel$export(module.exports, "INVALID_SPANID", function () { return $8586c6d4f9f4c2d7$export$55cc39fb0d4bb4c0; });
$parcel$export(module.exports, "INVALID_TRACEID", function () { return $8586c6d4f9f4c2d7$export$22be96e88d95e128; });
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", function () { return $8586c6d4f9f4c2d7$export$8591e4c852b66703; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $aSV3k = parcelRequire("aSV3k");
var $8586c6d4f9f4c2d7$export$55cc39fb0d4bb4c0 = "0000000000000000";
var $8586c6d4f9f4c2d7$export$22be96e88d95e128 = "00000000000000000000000000000000";
var $8586c6d4f9f4c2d7$export$8591e4c852b66703 = {
    traceId: $8586c6d4f9f4c2d7$export$22be96e88d95e128,
    spanId: $8586c6d4f9f4c2d7$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $aSV3k.TraceFlags).NONE
};

});
parcelRegister("aSV3k", function(module, exports) {

$parcel$export(module.exports, "TraceFlags", function () { return $7ecb33fc643a3bff$export$bf9049ad2b0883ff; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $7ecb33fc643a3bff$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($7ecb33fc643a3bff$export$bf9049ad2b0883ff || ($7ecb33fc643a3bff$export$bf9049ad2b0883ff = {}));

});




parcelRegister("bHs1K", function(module, exports) {

$parcel$export(module.exports, "isSpanContextValid", function () { return $8849737985f7239f$export$e4373b9a2c09216c; });
$parcel$export(module.exports, "wrapSpanContext", function () { return $8849737985f7239f$export$c19cc0f1911bdb85; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $bsL0N = parcelRequire("bsL0N");

var $imQXg = parcelRequire("imQXg");
var $8849737985f7239f$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $8849737985f7239f$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $8849737985f7239f$export$29dd34cf1269f6da(traceId) {
    return $8849737985f7239f$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $bsL0N.INVALID_TRACEID);
}
function $8849737985f7239f$export$8e51c6d8f0586aff(spanId) {
    return $8849737985f7239f$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $bsL0N.INVALID_SPANID);
}
function $8849737985f7239f$export$e4373b9a2c09216c(spanContext) {
    return $8849737985f7239f$export$29dd34cf1269f6da(spanContext.traceId) && $8849737985f7239f$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $8849737985f7239f$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $imQXg.NonRecordingSpan)(spanContext);
}

});



parcelRegister("3QdFY", function(module, exports) {

$parcel$export(module.exports, "NoopTracerProvider", function () { return $2cc0d63098ba2cf1$export$87d8e93756f9e86e; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $5tIX0 = parcelRequire("5tIX0");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $2cc0d63098ba2cf1$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $5tIX0.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("fhH6n", function(module, exports) {

$parcel$export(module.exports, "setContextManager", function () { return $b209e0a6b583b56c$export$4a00ab8a5dd9b5cf; });
$parcel$export(module.exports, "getContextManager", function () { return $b209e0a6b583b56c$export$831109c9f7727010; });
$parcel$export(module.exports, "UFOContextManager", function () { return $b209e0a6b583b56c$export$dd301b96c16f583d; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $9uCpq = parcelRequire("9uCpq");
/**
 * We need to store a reference to the Context manager so that we can get it later.
 * This is because the OTel JS API doesn't allow us to get the registered context manager,
 * and we need to get it because we need to call a function that's not available in the OTel API:
 * `setActive`. The OTel JS API design doesn't allow us to manually set the active context
 * despite the spec allowing for the capability. Sigh.
 *
 * I imagine this situation might not be permanent if we can move to a system were we can rely
 * solely on the API, but for the purposes of the first change being React UFO API compatible,
 * we'll need to do this.
 */ var $b209e0a6b583b56c$var$contextManager;
function $b209e0a6b583b56c$export$4a00ab8a5dd9b5cf(ctxMgr) {
    $b209e0a6b583b56c$var$contextManager = ctxMgr;
}
function $b209e0a6b583b56c$export$831109c9f7727010() {
    return $b209e0a6b583b56c$var$contextManager;
}
var $b209e0a6b583b56c$export$dd301b96c16f583d = /*#__PURE__*/ function() {
    function UFOContextManager() {
        (0, $i385U.default)(this, UFOContextManager);
        /**
     * whether the context manager is enabled or not
     */ (0, $dqOGO.default)(this, "_enabled", false);
        /**
     * Keeps the reference to current context
     */ (0, $dqOGO.default)(this, "_currentContext", (0, $9uCpq.ROOT_CONTEXT));
    }
    return (0, $c19Op.default)(UFOContextManager, [
        {
            key: "_bindFunction",
            value: /**
     *
     * @param context
     * @param target Function to be executed within the context
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            function _bindFunction() {
                var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $9uCpq.ROOT_CONTEXT);
                var target = arguments.length > 1 ? arguments[1] : undefined;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var manager = this;
                var contextWrapper = function contextWrapper() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return manager.with(context, function() {
                        return target.apply(_this, args);
                    });
                };
                Object.defineProperty(contextWrapper, "length", {
                    enumerable: false,
                    configurable: true,
                    writable: false,
                    value: target.length
                });
                return contextWrapper;
            }
        },
        {
            key: "active",
            value: function active() {
                return this._currentContext;
            }
        },
        {
            key: "bind",
            value: function bind(context, target) {
                // if no specific context to propagate is given, we use the current one
                if (context === undefined) context = this.active();
                if (typeof target === "function") return this._bindFunction(context, target);
                return target;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._currentContext = (0, $9uCpq.ROOT_CONTEXT);
                this._enabled = false;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                if (this._enabled) return this;
                this._enabled = true;
                this._currentContext = (0, $9uCpq.ROOT_CONTEXT);
                return this;
            }
        },
        {
            key: "with",
            value: function _with(context, fn, thisArg) {
                var previousContext = this._currentContext;
                this._currentContext = context || (0, $9uCpq.ROOT_CONTEXT);
                try {
                    for(var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++)args[_key2 - 3] = arguments[_key2];
                    return fn.call.apply(fn, [
                        thisArg
                    ].concat(args));
                } finally{
                    this._currentContext = previousContext;
                }
            }
        },
        {
            key: "setActive",
            value: function setActive(context) {
                if (this._enabled) this._currentContext = context;
            }
        }
    ]);
}();

});

parcelRegister("asp6Z", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $79cfff935833fba9$export$1115c5277eb10d5e; });
function $79cfff935833fba9$export$1115c5277eb10d5e(traceId, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-SpanId": spanId
    };
}

});


parcelRegister("gZAnH", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $c5ee9069fbd38489$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $c5ee9069fbd38489$export$2a5c8df26bb89760; });
$parcel$export(module.exports, "addFeatureFlagAccessed", function () { return $c5ee9069fbd38489$export$47fade9662f71000; });

var $e2aY6 = parcelRequire("e2aY6");
var $c5ee9069fbd38489$export$5b78c989c8db2561 = new Map();
var $c5ee9069fbd38489$export$2a5c8df26bb89760 = new Map();
function $c5ee9069fbd38489$export$47fade9662f71000(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === "function") globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $e2aY6.redactValue)(featureFlagValue);
    $c5ee9069fbd38489$export$5b78c989c8db2561.set(featureFlagName, value);
    $c5ee9069fbd38489$export$2a5c8df26bb89760.set(featureFlagName, value);
}

});
parcelRegister("e2aY6", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $a379c2aa4c78b4d2$export$fcc03ee4c944962f; });

var $8pSiD = parcelRequire("8pSiD");

var $7KVoA = parcelRequire("7KVoA");
function $a379c2aa4c78b4d2$var$startsAsObject(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (_unused) {
        return false;
    }
    return false;
}
function $a379c2aa4c78b4d2$var$isObject(value) {
    return value && (0, $8pSiD.default)(value) === "object" && value.constructor === Object;
}
function $a379c2aa4c78b4d2$var$isString(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (_unused2) {
        // swallow any errors
        result = false;
    }
    return result;
}
function $a379c2aa4c78b4d2$export$7b4abba432e57989(value) {
    return $a379c2aa4c78b4d2$var$isString(value) && $a379c2aa4c78b4d2$var$startsAsObject(value) || $a379c2aa4c78b4d2$var$isObject(value);
}
function $a379c2aa4c78b4d2$export$fcc03ee4c944962f(featureFlagValue) {
    return $a379c2aa4c78b4d2$export$7b4abba432e57989(featureFlagValue) ? (0, $7KVoA.NON_BOOLEAN_VALUE) : featureFlagValue;
}

});
parcelRegister("7KVoA", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $5a5959d3b5321357$export$42f4885608027d0c; });
var $5a5959d3b5321357$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("cQxll", function(module, exports) {

$parcel$export(module.exports, "flushSsrRenderProfilerTraces", function () { return $95a434a12e58239f$export$c8760e11c713fafc; });
$parcel$export(module.exports, "default", function () { return $95a434a12e58239f$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $bs6hr = parcelRequire("bs6hr");

var $hkP9U = parcelRequire("hkP9U");

var $XAEGR = parcelRequire("XAEGR");
var $95a434a12e58239f$var$_process;
// These are stored outside react context to be resilient to concurrent mode
// restarting the start marker from a suspense and losing the initial render
var $95a434a12e58239f$var$startTimes = new Map();
var $95a434a12e58239f$var$spanStates = new Map();
var $95a434a12e58239f$export$cf4e4023c0a34c8d = function clearState() {
    $95a434a12e58239f$var$startTimes.clear();
    $95a434a12e58239f$var$spanStates.clear();
};
// Keep track of the last interaction id and reset the start timers if it ever changes.
// This is to allow multi-step ssr to track the render timers from different "interaction"s seperately
var $95a434a12e58239f$var$lastActiveInteraction;
function $95a434a12e58239f$var$checkActiveInteractionAndResetStartMarksIfSet() {
    var _getActiveInteraction;
    var activeInteractionId = (_getActiveInteraction = (0, $hkP9U.getActiveInteraction)()) === null || _getActiveInteraction === void 0 ? void 0 : _getActiveInteraction.id;
    if (!!$95a434a12e58239f$var$lastActiveInteraction && $95a434a12e58239f$var$lastActiveInteraction !== activeInteractionId) $95a434a12e58239f$export$cf4e4023c0a34c8d();
    $95a434a12e58239f$var$lastActiveInteraction = activeInteractionId;
}
var $95a434a12e58239f$var$getIsNativeTracingEnabled = function getIsNativeTracingEnabled() {
    var _getConfig$ssr$enable, _getConfig;
    return (_getConfig$ssr$enable = (_getConfig = (0, $bs6hr.getConfig)()) === null || _getConfig === void 0 || (_getConfig = _getConfig.ssr) === null || _getConfig === void 0 ? void 0 : _getConfig.enableNativeTracing) !== null && _getConfig$ssr$enable !== void 0 ? _getConfig$ssr$enable : false;
};
var $95a434a12e58239f$var$onStartRender = function onStartRender(id, currentSegmentName, parentContext) {
    var _startTimes$get, _vm_internals__, _spanStates$get;
    if (!$95a434a12e58239f$var$startTimes.has(id)) $95a434a12e58239f$var$startTimes.set(id, []);
    (_startTimes$get = $95a434a12e58239f$var$startTimes.get(id)) === null || _startTimes$get === void 0 || _startTimes$get.push(performance.now());
    if (!$95a434a12e58239f$var$getIsNativeTracingEnabled()) return null;
    var startSpan = (_vm_internals__ = globalThis.__vm_internals__) === null || _vm_internals__ === void 0 || (_vm_internals__ = _vm_internals__.telemetry) === null || _vm_internals__ === void 0 ? void 0 : _vm_internals__.startSpan;
    var spanState = (_spanStates$get = $95a434a12e58239f$var$spanStates.get(id)) !== null && _spanStates$get !== void 0 ? _spanStates$get : null;
    if (!spanState && startSpan) {
        var span = startSpan(currentSegmentName, {
            parentSpanId: parentContext === null || parentContext === void 0 ? void 0 : parentContext.spanId
        });
        spanState = {
            span: span
        };
        $95a434a12e58239f$var$spanStates.set(id, spanState);
    }
    return spanState;
};
var $95a434a12e58239f$var$isInSSR = typeof __SERVER__ !== "undefined" && __SERVER__ || typeof $XAEGR !== "undefined" && Boolean((($95a434a12e58239f$var$_process = $XAEGR) === null || $95a434a12e58239f$var$_process === void 0 || ($95a434a12e58239f$var$_process = $95a434a12e58239f$var$_process.env) === null || $95a434a12e58239f$var$_process === void 0 ? void 0 : $95a434a12e58239f$var$_process.REACT_SSR) || false);
var $95a434a12e58239f$var$ProfilerMarker = function ProfilerMarker(_ref) {
    var onRender = _ref.onRender;
    onRender === null || onRender === void 0 || onRender();
    return null;
};
var $95a434a12e58239f$var$ParentSpanContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
var $95a434a12e58239f$export$c8760e11c713fafc = function flushSsrRenderProfilerTraces() {
    $95a434a12e58239f$var$spanStates.forEach(function(spanState) {
        if (spanState.latestEndTime != null) spanState.span.end(spanState.latestEndTime);
    });
    $95a434a12e58239f$var$spanStates.clear();
};
var $95a434a12e58239f$export$b8bd105b650b1c1e = function SsrRenderProfilerInner(_ref2) {
    var _currentSpanState$spa;
    var children = _ref2.children, labelStack = _ref2.labelStack, _onRender = _ref2.onRender;
    var reactProfilerId = (0, $iSvIT.useMemo)(function() {
        return labelStack.map(function(l) {
            return l.name;
        }).join("/");
    }, [
        labelStack
    ]);
    $95a434a12e58239f$var$checkActiveInteractionAndResetStartMarksIfSet();
    var parentSpan = (0, $iSvIT.useContext)($95a434a12e58239f$var$ParentSpanContext);
    var currentSpanState = $95a434a12e58239f$var$onStartRender(reactProfilerId, labelStack[labelStack.length - 1].name, parentSpan);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($95a434a12e58239f$var$ParentSpanContext.Provider, {
        value: (_currentSpanState$spa = currentSpanState === null || currentSpanState === void 0 ? void 0 : currentSpanState.span.getSpanContext()) !== null && _currentSpanState$spa !== void 0 ? _currentSpanState$spa : null
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($95a434a12e58239f$var$ProfilerMarker, {
        onRender: function onRender() {
            var startTimesForId = $95a434a12e58239f$var$startTimes.get(reactProfilerId);
            if (startTimesForId !== null && startTimesForId !== void 0 && startTimesForId.length) {
                var _endTime = performance.now();
                var firstStartTime = startTimesForId[0];
                var lastStartTime = startTimesForId[startTimesForId.length - 1];
                var baseDuration = _endTime - lastStartTime;
                var actualDuration = _endTime - firstStartTime;
                _onRender("mount", // this is incorrect, but on the server there is no mount phase
                actualDuration, baseDuration, firstStartTime, _endTime);
            }
            var spanState = $95a434a12e58239f$var$spanStates.get(reactProfilerId);
            if (spanState) spanState.latestEndTime = performance.now();
        }
    })));
};
var $95a434a12e58239f$var$SsrRenderProfiler = function SsrRenderProfiler(props) {
    if ($95a434a12e58239f$var$isInSSR) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($95a434a12e58239f$export$b8bd105b650b1c1e, props);
    // ensure structure similar to SSR implementation
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($95a434a12e58239f$var$ProfilerMarker, null), props.children);
};
var $95a434a12e58239f$export$2e2bcd8739ae039 = $95a434a12e58239f$var$SsrRenderProfiler;

});

parcelRegister("kbJIl", function(module, exports) {

$parcel$export(module.exports, "VCObserverWrapper", function () { return VCObserverWrapper; });
$parcel$export(module.exports, "newVCObserver", function () { return newVCObserver; });

var $1m3mf = parcelRequire("1m3mf");

var $2sYxo = parcelRequire("2sYxo");

var $dqOGO = parcelRequire("dqOGO");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $aKGMT = parcelRequire("aKGMT");

var $bs6hr = parcelRequire("bs6hr");

var $bUtSA = parcelRequire("bUtSA");

var $iHP94 = parcelRequire("iHP94");

var $9lGB5 = parcelRequire("9lGB5");

var $6mgdS = parcelRequire("6mgdS");

var $aZv6h = parcelRequire("aZv6h");

var $XAEGR = parcelRequire("XAEGR");
var _process;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var VCObserverWrapper = /*#__PURE__*/ function() {
    function VCObserverWrapper() {
        var _opts$ssrEnablePageLa;
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $i385U.default)(this, VCObserverWrapper);
        this.newVCObserver = null;
        this.oldVCObserver = null;
        // Initialize SSR placeholder handler once
        this.ssrPlaceholderHandler = new (0, $aZv6h.SSRPlaceholderHandlers)({
            enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa !== void 0 ? _opts$ssrEnablePageLa : false
        });
        if ((0, $bs6hr.isVCRevisionEnabled)("fy25.03") || (0, $bs6hr.isVCRevisionEnabled)("fy26.04")) {
            var _opts$ssrEnablePageLa2, _opts$trackLayoutShif;
            this.newVCObserver = new (0, $9lGB5.default)({
                selectorConfig: opts.selectorConfig,
                isPostInteraction: opts.isPostInteraction,
                SSRConfig: {
                    enablePageLayoutPlaceholder: (_opts$ssrEnablePageLa2 = opts.ssrEnablePageLayoutPlaceholder) !== null && _opts$ssrEnablePageLa2 !== void 0 ? _opts$ssrEnablePageLa2 : false
                },
                ssrPlaceholderHandler: this.ssrPlaceholderHandler,
                trackLayoutShiftOffenders: (_opts$trackLayoutShif = opts.trackLayoutShiftOffenders) !== null && _opts$trackLayoutShif !== void 0 ? _opts$trackLayoutShif : false,
                searchPageConfig: opts.searchPageConfig
            });
        }
        if ((0, $bs6hr.isVCRevisionEnabled)("fy25.01") || (0, $bs6hr.isVCRevisionEnabled)("fy25.02")) this.oldVCObserver = new (0, $iHP94.VCObserver)(_objectSpread(_objectSpread({}, opts), {}, {
            ssrPlaceholderHandler: this.ssrPlaceholderHandler
        }));
    }
    // Helper method to process SSR abort listeners
    return (0, $c19Op.default)(VCObserverWrapper, [
        {
            key: "processSsrAbortListeners",
            value: function processSsrAbortListeners() {
                var _window;
                // Process any SSR abort listeners that remain
                if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                    // Clean up any event listeners that may have been registered during SSR
                    // This is centralized here so only the wrapper handles unbinding, not individual observers
                    if (window.__SSR_ABORT_LISTENERS__.unbinds && Array.isArray(window.__SSR_ABORT_LISTENERS__.unbinds)) window.__SSR_ABORT_LISTENERS__.unbinds.forEach(function(unbind) {
                        if (typeof unbind === "function") unbind();
                    });
                    // After all observers had a chance to process abort events,
                    // we can safely delete the SSR_ABORT_LISTENERS object
                    delete window.__SSR_ABORT_LISTENERS__;
                }
            }
        },
        {
            key: "start",
            value: function start(_ref) {
                var startTime = _ref.startTime, experienceKey = _ref.experienceKey;
                if ((0, $bs6hr.isVCRevisionEnabled)("fy25.01", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy25.02", experienceKey)) {
                    var _this$oldVCObserver;
                    (_this$oldVCObserver = this.oldVCObserver) === null || _this$oldVCObserver === void 0 || _this$oldVCObserver.start({
                        startTime: startTime
                    });
                }
                if ((0, $bs6hr.isVCRevisionEnabled)("fy25.03", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy26.04", experienceKey)) {
                    var _this$newVCObserver;
                    (_this$newVCObserver = this.newVCObserver) === null || _this$newVCObserver === void 0 || _this$newVCObserver.start({
                        startTime: startTime
                    });
                }
                // Clean up any remaining SSR abort listeners after all observers have been started
                this.processSsrAbortListeners();
            }
        },
        {
            key: "stop",
            value: function stop(experienceKey) {
                if ((0, $bs6hr.isVCRevisionEnabled)("fy25.01", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy25.02", experienceKey)) {
                    var _this$oldVCObserver2;
                    (_this$oldVCObserver2 = this.oldVCObserver) === null || _this$oldVCObserver2 === void 0 || _this$oldVCObserver2.stop();
                }
                if ((0, $bs6hr.isVCRevisionEnabled)("fy25.03", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy26.04", experienceKey)) {
                    var _this$newVCObserver2;
                    (_this$newVCObserver2 = this.newVCObserver) === null || _this$newVCObserver2 === void 0 || _this$newVCObserver2.stop();
                }
                (0, $6mgdS.RLLPlaceholderHandlers).getInstance().reset();
                // Clear shared SSR placeholder handler
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                var _this$oldVCObserver$g, _this$oldVCObserver3;
                return (_this$oldVCObserver$g = (_this$oldVCObserver3 = this.oldVCObserver) === null || _this$oldVCObserver3 === void 0 ? void 0 : _this$oldVCObserver3.getVCRawData()) !== null && _this$oldVCObserver$g !== void 0 ? _this$oldVCObserver$g : null;
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(param) {
                    var _this$oldVCObserver4, _this$newVCObserver3, _v3v4Result$, _ref2;
                    var experienceKey, include3p, excludeSmartAnswersInSearch, includeSSRRatio, includeRawData, v1v2Result, v3v4Result, ssrRatio;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                experienceKey = param.experienceKey, include3p = param.include3p, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeSSRRatio = param.includeSSRRatio, includeRawData = param.includeRawData;
                                if (!((0, $bs6hr.isVCRevisionEnabled)("fy25.01", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy25.02", experienceKey))) {
                                    _context.next = 7;
                                    break;
                                }
                                _context.next = 4;
                                return (_this$oldVCObserver4 = this.oldVCObserver) === null || _this$oldVCObserver4 === void 0 ? void 0 : _this$oldVCObserver4.getVCResult(param);
                            case 4:
                                _context.t0 = _context.sent;
                                _context.next = 8;
                                break;
                            case 7:
                                _context.t0 = {};
                            case 8:
                                v1v2Result = _context.t0;
                                if (!((0, $bs6hr.isVCRevisionEnabled)("fy25.03", experienceKey) || (0, $bs6hr.isVCRevisionEnabled)("fy26.04", experienceKey))) {
                                    _context.next = 15;
                                    break;
                                }
                                _context.next = 12;
                                return (_this$newVCObserver3 = this.newVCObserver) === null || _this$newVCObserver3 === void 0 ? void 0 : _this$newVCObserver3.getVCResult({
                                    start: param.start,
                                    stop: param.stop,
                                    interactionId: param.interactionId,
                                    ssr: param.ssr,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    interactionType: param.interactionType,
                                    isPageVisible: param.isPageVisible,
                                    interactionAbortReason: param.interactionAbortReason,
                                    includeRawData: includeRawData,
                                    includeSSRInV3: param.includeSSRInV3,
                                    rawDataStopTime: param.rawDataStopTime,
                                    reportLayoutShiftOffenders: param.reportLayoutShiftOffenders
                                });
                            case 12:
                                _context.t1 = _context.sent;
                                _context.next = 16;
                                break;
                            case 15:
                                _context.t1 = [];
                            case 16:
                                v3v4Result = _context.t1;
                                if (!(!v3v4Result || v3v4Result.length === 0)) {
                                    _context.next = 19;
                                    break;
                                }
                                return _context.abrupt("return", v1v2Result !== null && v1v2Result !== void 0 ? v1v2Result : {});
                            case 19:
                                ssrRatio = v3v4Result === null || v3v4Result === void 0 || (_v3v4Result$ = v3v4Result[0]) === null || _v3v4Result$ === void 0 ? void 0 : _v3v4Result$.ssrRatio;
                                return _context.abrupt("return", _objectSpread(_objectSpread(_objectSpread({}, includeSSRRatio && ssrRatio !== undefined ? {
                                    "ufo:vc:ssrRatio": ssrRatio
                                } : {}), v1v2Result), {}, {
                                    "ufo:vc:rev": [].concat((0, $1m3mf.default)((_ref2 = v1v2Result === null || v1v2Result === void 0 ? void 0 : v1v2Result["ufo:vc:rev"]) !== null && _ref2 !== void 0 ? _ref2 : []), (0, $1m3mf.default)(v3v4Result !== null && v3v4Result !== void 0 ? v3v4Result : []))
                                }));
                            case 21:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                var _this$oldVCObserver5, _this$newVCObserver4;
                (_this$oldVCObserver5 = this.oldVCObserver) === null || _this$oldVCObserver5 === void 0 || _this$oldVCObserver5.setSSRElement(element);
                (_this$newVCObserver4 = this.newVCObserver) === null || _this$newVCObserver4 === void 0 || _this$newVCObserver4.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(startTime) {
                var _this$oldVCObserver6, _this$newVCObserver5;
                (_this$oldVCObserver6 = this.oldVCObserver) === null || _this$oldVCObserver6 === void 0 || _this$oldVCObserver6.setReactRootRenderStart(startTime || performance.now());
                (_this$newVCObserver5 = this.newVCObserver) === null || _this$newVCObserver5 === void 0 || _this$newVCObserver5.setReactRootRenderStart(startTime || performance.now());
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(stopTime) {
                var _this$oldVCObserver7, _this$newVCObserver6;
                (_this$oldVCObserver7 = this.oldVCObserver) === null || _this$oldVCObserver7 === void 0 || _this$oldVCObserver7.setReactRootRenderStop(stopTime || performance.now());
                (_this$newVCObserver6 = this.newVCObserver) === null || _this$newVCObserver6 === void 0 || _this$newVCObserver6.setReactRootRenderStop(stopTime || performance.now());
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
                this.ssrPlaceholderHandler.collectExistingPlaceholders();
            }
        }
    ]);
}();
// Some products set this variable to indicate it is running in SSR
var isServer = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.__SERVER__);
// Other products set this other variable to indicate it is running in SSR
var isReactSSR = typeof $XAEGR !== "undefined" && Boolean(((_process = $XAEGR) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.REACT_SSR) || false);
function isEnvironmentSupported() {
    // SSR environment aren't supported
    if (isReactSSR || isServer) return false;
    // Legacy browsers that doesn't support WeakRef
    // aren't valid
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.WeakRef) !== "function") return false;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.MutationObserver) !== "function" || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.IntersectionObserver) !== "function" || typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.PerformanceObserver) !== "function") return false;
    return true;
}
function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (!globalThis.__vcObserver) {
        var shouldMockVCObserver = !isEnvironmentSupported();
        globalThis.__vcObserver = shouldMockVCObserver ? new (0, $bUtSA.VCObserverNOOP)() : new VCObserverWrapper(opts);
    }
    return globalThis.__vcObserver;
}
function newVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var shouldMockVCObserver = !isEnvironmentSupported();
    var observer = shouldMockVCObserver ? new (0, $bUtSA.VCObserverNOOP)() : new VCObserverWrapper(opts);
    return observer;
}

});
parcelRegister("bUtSA", function(module, exports) {

$parcel$export(module.exports, "VCObserverNOOP", function () { return $8abc1a1ecf6fbf74$export$24d07287b49da906; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");
var $8abc1a1ecf6fbf74$export$24d07287b49da906 = /*#__PURE__*/ function() {
    function VCObserverNOOP() {
        (0, $i385U.default)(this, VCObserverNOOP);
    }
    return (0, $c19Op.default)(VCObserverNOOP, [
        {
            key: "start",
            value: function start(_) {}
        },
        {
            key: "stop",
            value: function stop() {}
        },
        {
            key: "getVCRawData",
            value: function getVCRawData() {
                return null;
            }
        },
        {
            key: "getVCResult",
            value: function getVCResult(_) {
                return Promise.resolve({
                    "ufo:vc:noop": true
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(_) {}
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart(_) {}
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop(_) {}
        }
    ]);
}();

});

parcelRegister("9lGB5", function(module, exports) {

$parcel$export(module.exports, "getHasAbortingEventDuringSSR", function () { return $6ce71e1ec36af88d$export$88af4849fcc5bbc9; });
$parcel$export(module.exports, "default", function () { return $6ce71e1ec36af88d$export$2e2bcd8739ae039; });

var $2sYxo = parcelRequire("2sYxo");

var $jzYu7 = parcelRequire("jzYu7");

var $8pSiD = parcelRequire("8pSiD");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $jxLBU = parcelRequire("jxLBU");

var $bs6hr = parcelRequire("bs6hr");

var $hkP9U = parcelRequire("hkP9U");

var $aZv6h = parcelRequire("aZv6h");

var $ewhaC = parcelRequire("ewhaC");

var $5PeWS = parcelRequire("5PeWS");

var $ipadY = parcelRequire("ipadY");

var $dM1tG = parcelRequire("dM1tG");

var $jDIhE = parcelRequire("jDIhE");

var $f0dWE = parcelRequire("f0dWE");

var $j5w43 = parcelRequire("j5w43");

var $c1W6p = parcelRequire("c1W6p");

var $h5rlm = parcelRequire("h5rlm");

var $48TSH = parcelRequire("48TSH");
var $6ce71e1ec36af88d$var$SSRState = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $6ce71e1ec36af88d$var$DEFAULT_SELECTOR_CONFIG = {
    id: false,
    testId: true,
    role: false,
    className: false,
    dataVC: true
};
var $6ce71e1ec36af88d$var$hasAbortingEventDuringSSR = false;
function $6ce71e1ec36af88d$export$88af4849fcc5bbc9() {
    return $6ce71e1ec36af88d$var$hasAbortingEventDuringSSR;
}
var $6ce71e1ec36af88d$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function VCObserverNew(config) {
        var _config$isPostInterac, _config$selectorConfi, _config$trackLayoutSh, _this = this;
        (0, $i385U.default)(this, VCObserverNew);
        (0, $dqOGO.default)(this, "viewportObserver", null);
        (0, $dqOGO.default)(this, "windowEventObserver", null);
        // SSR related properties
        (0, $dqOGO.default)(this, "ssrPlaceholderHandler", null);
        (0, $dqOGO.default)(this, "ssr", {
            state: $6ce71e1ec36af88d$var$SSRState.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        this.entriesTimeline = new (0, $ewhaC.default)();
        this.isPostInteraction = (_config$isPostInterac = config.isPostInteraction) !== null && _config$isPostInterac !== void 0 ? _config$isPostInterac : false;
        this.selectorConfig = (_config$selectorConfi = config.selectorConfig) !== null && _config$selectorConfi !== void 0 ? _config$selectorConfi : $6ce71e1ec36af88d$var$DEFAULT_SELECTOR_CONFIG;
        // Use shared SSR placeholder handler if provided, otherwise create new one if feature flag is enabled
        if (config.ssrPlaceholderHandler) this.ssrPlaceholderHandler = config.ssrPlaceholderHandler;
        else {
            var _config$SSRConfig$ena, _config$SSRConfig;
            this.ssrPlaceholderHandler = new (0, $aZv6h.SSRPlaceholderHandlers)({
                enablePageLayoutPlaceholder: (_config$SSRConfig$ena = (_config$SSRConfig = config.SSRConfig) === null || _config$SSRConfig === void 0 ? void 0 : _config$SSRConfig.enablePageLayoutPlaceholder) !== null && _config$SSRConfig$ena !== void 0 ? _config$SSRConfig$ena : false
            });
        }
        this.trackLayoutShiftOffenders = (_config$trackLayoutSh = config.trackLayoutShiftOffenders) !== null && _config$trackLayoutSh !== void 0 ? _config$trackLayoutSh : false;
        this.viewportObserver = new (0, $h5rlm.default)({
            onChange: function onChange(onChangeArg) {
                var time = onChangeArg.time, type = onChangeArg.type, elementRef = onChangeArg.elementRef, visible = onChangeArg.visible, rect = onChangeArg.rect, previousRect = onChangeArg.previousRect, mutationData = onChangeArg.mutationData;
                var elementName = "unknown";
                var element = elementRef.deref();
                if (element) elementName = _this.getElementName(element);
                var data = {
                    type: type,
                    elementName: elementName,
                    rect: rect,
                    previousRect: previousRect,
                    visible: visible,
                    attributeName: mutationData === null || mutationData === void 0 ? void 0 : mutationData.attributeName,
                    oldValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.oldValue,
                    newValue: mutationData === null || mutationData === void 0 ? void 0 : mutationData.newValue,
                    originalMutationTimestamp: mutationData === null || mutationData === void 0 ? void 0 : mutationData.timestamp
                };
                if (element) {
                    var labelStacks = $6ce71e1ec36af88d$var$getLabelStacks(element);
                    if (labelStacks) Object.assign(data, {
                        labelStacks: labelStacks
                    });
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: data
                });
            },
            // Pass SSR context to ViewportObserver
            getSSRState: function getSSRState() {
                return _this.getSSRState();
            },
            getSSRPlaceholderHandler: function getSSRPlaceholderHandler() {
                return _this.getSSRPlaceholderHandler();
            },
            searchPageConfig: config.searchPageConfig,
            trackLayoutShiftOffenders: this.trackLayoutShiftOffenders
        });
        this.windowEventObserver = new (0, $48TSH.default)({
            onEvent: function onEvent(_ref) {
                var time = _ref.time, type = _ref.type;
                // Don't abort press interactions on keydown events, as keydown is expected
                // when users press Enter/Space to activate buttons or other interactive elements
                if (type === "keydown" && (0, $jxLBU.fg)("platform_ufo_keypress_interaction_abort")) {
                    var interaction = (0, $hkP9U.getActiveInteraction)();
                    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === "press") return;
                }
                _this.entriesTimeline.push({
                    time: time,
                    data: {
                        type: "window:event",
                        eventType: type
                    }
                });
            }
        });
    }
    return (0, $c19Op.default)(VCObserverNew, [
        {
            key: "start",
            value: function start(_) {
                var _this$viewportObserve, _this2 = this;
                // Reset SSR state on start (matches old VCObserver behavior)
                this.ssr = {
                    state: $6ce71e1ec36af88d$var$SSRState.normal,
                    reactRootElement: null,
                    // Reset to null (matches old VCObserver)
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$viewportObserve = this.viewportObserver) === null || _this$viewportObserve === void 0 || _this$viewportObserve.start();
                if ((0, $jxLBU.fg)("ufo_fix_aborting_interaction_detection_during_ssr")) {
                    var _window, _this$windowEventObse;
                    this.entriesTimeline.clear();
                    if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                        var abortListeners = window.__SSR_ABORT_LISTENERS__;
                        var aborts = abortListeners.aborts;
                        if (aborts && (0, $8pSiD.default)(aborts) === "object") Object.entries(aborts).forEach(function(_ref2) {
                            var _ref3 = (0, $jzYu7.default)(_ref2, 2), key = _ref3[0], time = _ref3[1];
                            if (typeof time === "number") _this2.entriesTimeline.push({
                                time: time,
                                data: {
                                    type: "window:event",
                                    eventType: key
                                }
                            });
                        });
                    }
                    (_this$windowEventObse = this.windowEventObserver) === null || _this$windowEventObse === void 0 || _this$windowEventObse.start();
                } else {
                    var _window2, _this$windowEventObse2;
                    if ((_window2 = window) !== null && _window2 !== void 0 && _window2.__SSR_ABORT_LISTENERS__) {
                        var _abortListeners = window.__SSR_ABORT_LISTENERS__;
                        var _aborts = _abortListeners.aborts;
                        if (_aborts && (0, $8pSiD.default)(_aborts) === "object") Object.entries(_aborts).forEach(function(_ref4) {
                            var _ref5 = (0, $jzYu7.default)(_ref4, 2), key = _ref5[0], time = _ref5[1];
                            if (typeof time === "number") {
                                _this2.entriesTimeline.push({
                                    time: time,
                                    data: {
                                        type: "window:event",
                                        eventType: key
                                    }
                                });
                                if ((0, $jxLBU.fg)("ufo_detect_aborting_interaction_during_ssr")) $6ce71e1ec36af88d$var$hasAbortingEventDuringSSR = true;
                            }
                        });
                    }
                    (_this$windowEventObse2 = this.windowEventObserver) === null || _this$windowEventObse2 === void 0 || _this$windowEventObse2.start();
                    this.entriesTimeline.clear();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$viewportObserve2, _this$windowEventObse3;
                (_this$viewportObserve2 = this.viewportObserver) === null || _this$viewportObserve2 === void 0 || _this$viewportObserve2.stop();
                (_this$windowEventObse3 = this.windowEventObserver) === null || _this$windowEventObse3 === void 0 || _this$windowEventObse3.stop();
                // Clear SSR state on stop (matches old VCObserver behavior)
                this.ssr.reactRootElement = null;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $6ce71e1ec36af88d$var$SSRState.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "collectSSRPlaceholders",
            value: function collectSSRPlaceholders() {
            // This is handled by the shared SSRPlaceholderHandlers in VCObserverWrapper
            // Individual observers don't need to implement this
            }
        },
        {
            key: "getSSRState",
            value: function getSSRState() {
                return this.ssr;
            }
        },
        {
            key: "getSSRPlaceholderHandler",
            value: function getSSRPlaceholderHandler() {
                return this.ssrPlaceholderHandler;
            }
        },
        {
            key: "addSSR",
            value: function addSSR(ssr) {
                this.entriesTimeline.push({
                    time: ssr,
                    data: {
                        elementName: "SSR",
                        type: "mutation:element",
                        rect: {
                            height: (0, $jDIhE.default)(),
                            width: (0, $f0dWE.default)(),
                            left: 0,
                            top: 0,
                            x: 0,
                            y: 0,
                            bottom: (0, $jDIhE.default)(),
                            right: (0, $f0dWE.default)(),
                            toJSON: function toJSON() {
                                return null;
                            }
                        },
                        visible: true
                    }
                });
            }
        },
        {
            key: "getVCResult",
            value: function() {
                var _getVCResult = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(param) {
                    var start, stop, interactionId, interactionType, interactionAbortReason, isPageVisible, include3p, includeSSRRatio, excludeSmartAnswersInSearch, includeRawData, rawDataStopTime, results, feVCCalculationStartTime, calculator_fy25_03, orderedEntries, fy25_03, calculator_fy26_04, calculator_next, calculatorParams, isFy2604Enabled, _yield$Promise$all, _yield$Promise$all2, fy26_04, vcNext, feVCCalculationEndTime, shouldIncludeRawData, rawVCCalculationStartTime, rawHandler, rawStopTime, rawOrderedEntries, raw;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                start = param.start, stop = param.stop, interactionId = param.interactionId, interactionType = param.interactionType, interactionAbortReason = param.interactionAbortReason, isPageVisible = param.isPageVisible, include3p = param.include3p, includeSSRRatio = param.includeSSRRatio, excludeSmartAnswersInSearch = param.excludeSmartAnswersInSearch, includeRawData = param.includeRawData, rawDataStopTime = param.rawDataStopTime;
                                results = [];
                                this.addStartEntry(start);
                                feVCCalculationStartTime = performance.now();
                                calculator_fy25_03 = new (0, $ipadY.default)();
                                if (param.includeSSRInV3 && param.ssr) this.addSSR(param.ssr);
                                orderedEntries = this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: stop
                                });
                                if (!(0, $bs6hr.isVCRevisionEnabled)("fy25.03")) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 10;
                                return calculator_fy25_03.calculate({
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                });
                            case 10:
                                _context.t0 = _context.sent;
                                _context.next = 14;
                                break;
                            case 13:
                                _context.t0 = null;
                            case 14:
                                fy25_03 = _context.t0;
                                if (fy25_03) results.push(fy25_03);
                                // From TTVC v4 onwards, ensuring that SSR entry is always auto-added, whenever it is configured.
                                if (param.ssr) this.addSSR(param.ssr);
                                calculator_fy26_04 = new (0, $dM1tG.default)();
                                calculator_next = new (0, $j5w43.default)();
                                calculatorParams = {
                                    orderedEntries: orderedEntries,
                                    startTime: start,
                                    stopTime: stop,
                                    interactionId: interactionId,
                                    interactionType: interactionType,
                                    isPostInteraction: this.isPostInteraction,
                                    include3p: include3p,
                                    excludeSmartAnswersInSearch: excludeSmartAnswersInSearch,
                                    includeSSRRatio: includeSSRRatio,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: interactionAbortReason,
                                    reportLayoutShiftOffenders: this.trackLayoutShiftOffenders
                                };
                                isFy2604Enabled = (0, $bs6hr.isVCRevisionEnabled)("fy26.04");
                                _context.next = 23;
                                return Promise.all([
                                    isFy2604Enabled ? calculator_fy26_04.calculate(calculatorParams) : null,
                                    (0, $bs6hr.isVCRevisionEnabled)("next") ? calculator_next.calculate(calculatorParams) : null
                                ]);
                            case 23:
                                _yield$Promise$all = _context.sent;
                                _yield$Promise$all2 = (0, $jzYu7.default)(_yield$Promise$all, 2);
                                fy26_04 = _yield$Promise$all2[0];
                                vcNext = _yield$Promise$all2[1];
                                if (fy26_04) results.push(fy26_04);
                                if (vcNext) results.push(vcNext);
                                feVCCalculationEndTime = performance.now(); // Always include raw data when fy26.04 is not in the client config so the server
                                // can recalculate fy26.04 metrics (ssrRatio, labelStacks, speedIndex) from raw observations.
                                shouldIncludeRawData = includeRawData || !isFy2604Enabled;
                                if (!shouldIncludeRawData) {
                                    _context.next = 41;
                                    break;
                                }
                                rawVCCalculationStartTime = performance.now();
                                rawHandler = new (0, $c1W6p.default)(); // Use rawDataStopTime (end3p) when available to capture observations during 3p holds
                                rawStopTime = rawDataStopTime !== null && rawDataStopTime !== void 0 ? rawDataStopTime : stop;
                                rawOrderedEntries = rawDataStopTime ? this.entriesTimeline.getOrderedEntries({
                                    start: start,
                                    stop: rawStopTime
                                }) : orderedEntries;
                                _context.next = 38;
                                return rawHandler.getRawData({
                                    entries: rawOrderedEntries,
                                    startTime: start,
                                    stopTime: rawStopTime,
                                    isPageVisible: isPageVisible
                                });
                            case 38:
                                raw = _context.sent;
                                results.forEach(function(result) {
                                    delete result.vcDetails;
                                    delete result.ratios;
                                });
                                if (raw) {
                                    raw.rawVCTime = Number((performance.now() - rawVCCalculationStartTime).toFixed(2));
                                    raw.feVCTime = Number((feVCCalculationEndTime - feVCCalculationStartTime).toFixed(2));
                                    results.push(raw);
                                }
                            case 41:
                                return _context.abrupt("return", results);
                            case 42:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getVCResult(_x) {
                    return _getVCResult.apply(this, arguments);
                }
                return getVCResult;
            }()
        },
        {
            key: "addStartEntry",
            value: function addStartEntry(startTime) {
                this.entriesTimeline.push({
                    time: startTime,
                    data: {
                        type: "mutation:element",
                        elementName: "START",
                        visible: true,
                        rect: {
                            x: 0,
                            y: 0,
                            width: window.innerWidth,
                            height: window.innerHeight,
                            top: 0,
                            left: 0,
                            bottom: window.innerHeight,
                            right: window.innerWidth,
                            toJSON: function toJSON() {
                                return {
                                    x: this.x,
                                    y: this.y,
                                    width: this.width,
                                    height: this.height,
                                    top: this.top,
                                    left: this.left,
                                    bottom: this.bottom,
                                    right: this.right
                                };
                            }
                        }
                    }
                });
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                return (0, $5PeWS.default)(this.selectorConfig, element);
            }
        }
    ]);
}();
function $6ce71e1ec36af88d$var$labelStackFromFiber(fiber) {
    var _fiber$child;
    var value = fiber === null || fiber === void 0 || (_fiber$child = fiber.child) === null || _fiber$child === void 0 || (_fiber$child = _fiber$child.memoizedProps) === null || _fiber$child === void 0 ? void 0 : _fiber$child.value;
    return Array.isArray(value === null || value === void 0 ? void 0 : value.labelStack) ? value.labelStack : [];
}
function $6ce71e1ec36af88d$var$labelStackToString(labelStack) {
    return labelStack.map(function(label) {
        return label.name;
    }).join("/");
}
function $6ce71e1ec36af88d$var$labelStackToSegment(labelStack) {
    var segmentIndex = -1;
    for(var i = labelStack.length - 1; i >= 0; i--)if (labelStack[i].segmentId) {
        segmentIndex = i;
        break;
    }
    return labelStack.slice(0, segmentIndex + 1).map(function(label) {
        return label.name;
    }).join("/");
}
function $6ce71e1ec36af88d$var$traverseFiber(fiber) {
    var segment = "unknown";
    var labelStackString = "unknown";
    var currentFiber = fiber;
    while(currentFiber){
        if (currentFiber.type) {
            var componentName = currentFiber.type.displayName || currentFiber.type.name;
            if (componentName === "UFOSegment" || componentName === "UFOLabel") {
                var labelStack = $6ce71e1ec36af88d$var$labelStackFromFiber(currentFiber);
                labelStackString = $6ce71e1ec36af88d$var$labelStackToString(labelStack) || "unknown";
                segment = $6ce71e1ec36af88d$var$labelStackToSegment(labelStack) || "unknown";
                break;
            }
        }
        currentFiber = currentFiber.return;
    }
    return {
        segment: segment,
        labelStack: labelStackString
    };
}
function $6ce71e1ec36af88d$var$getLabelStacks(element) {
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith("__reactFiber$");
    });
    if (!reactFiberKey) return null;
    var fiber = element[reactFiberKey];
    return fiber ? $6ce71e1ec36af88d$var$traverseFiber(fiber) : null;
}

});
parcelRegister("ewhaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9215f85c7be72fb$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");
var $a9215f85c7be72fb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function EntriesTimeline() {
        (0, $i385U.default)(this, EntriesTimeline);
        this.unorderedEntries = [];
        this.sortedEntriesCache = new Map();
    }
    return (0, $c19Op.default)(EntriesTimeline, [
        {
            key: "push",
            value: function push(entry) {
                this.unorderedEntries.push(entry);
                this.sortedEntriesCache.clear();
            }
        },
        {
            key: "getCacheKey",
            value: function getCacheKey(start, stop) {
                return "".concat(start !== null && start !== void 0 ? start : "null", "_").concat(stop !== null && stop !== void 0 ? stop : "null");
            }
        },
        {
            key: "getOrderedEntries",
            value: function getOrderedEntries(_ref) {
                var _this$sortedEntriesCa;
                var start = _ref.start, stop = _ref.stop;
                var cacheKey = this.getCacheKey(start, stop);
                var cachedSortedEntries = (_this$sortedEntriesCa = this.sortedEntriesCache.get(cacheKey)) === null || _this$sortedEntriesCa === void 0 ? void 0 : _this$sortedEntriesCa.deref();
                if (cachedSortedEntries) return cachedSortedEntries;
                var filteredEntries = this.unorderedEntries.filter(function(e) {
                    return e.time >= (start !== null && start !== void 0 ? start : 0) && e.time <= (stop !== null && stop !== void 0 ? stop : performance.now());
                });
                var sortedEntries = filteredEntries.sort(function(a, b) {
                    return a.time - b.time;
                });
                this.sortedEntriesCache.set(cacheKey, new WeakRef(sortedEntries));
                return sortedEntries;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.unorderedEntries = [];
                this.sortedEntriesCache.clear();
            }
        }
    ]);
}();

});

parcelRegister("5PeWS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43dd4fabf1742a20$export$2e2bcd8739ae039; });
var $43dd4fabf1742a20$var$nameCache = new WeakMap();
function $43dd4fabf1742a20$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) {
        var elementInstance = "Unknown";
        // Types of elements according to LLM
        if (element instanceof Text) elementInstance = "Text";
        else if (element instanceof DocumentFragment) elementInstance = "DocumentFragment";
        else if (element instanceof Document) elementInstance = "Document";
        else if (element instanceof Comment) elementInstance = "Comment";
        else if (element instanceof ProcessingInstruction) elementInstance = "ProcessingInstruction";
        else if (element instanceof Attr) elementInstance = "Attr";
        else if (element instanceof CDATASection) elementInstance = "CDATASection";
        if (element.parentElement && element.parentElement instanceof HTMLElement) {
            var parentElementSelector = $43dd4fabf1742a20$var$getElementName(selectorConfig, element.parentElement);
            return "".concat(parentElementSelector, " > ").concat(elementInstance);
        } else return elementInstance;
    }
    var cachedName = $43dd4fabf1742a20$var$nameCache.get(element);
    if (cachedName) return cachedName;
    // Get the tag name of the element.
    var tagName = element.localName;
    var encodeValue = function encodeValue(s) {
        if (typeof encodeURIComponent !== "function") return "";
        try {
            return encodeURIComponent(s);
        } catch (_unused) {
            return "malformed_value";
        }
    };
    // Helper function to construct attribute selectors.
    var getAttributeSelector = function getAttributeSelector(attributeName) {
        var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        if (element && typeof element.getAttribute !== "function") return "";
        var attrValue = element.getAttribute(attributeName);
        if (!attrValue) return "";
        var encondedAttrValue = encodeValue(attrValue);
        return "".concat(prefix, "[").concat(attributeName, '="').concat(encondedAttrValue, '"]');
    };
    // Construct the data-vc attribute selector if specified in the config.
    var dataVC = selectorConfig.dataVC !== false ? getAttributeSelector("data-vc") : "";
    // Construct the ID selector if specified in the config and the element has an ID.
    var id = selectorConfig.id && element.id ? "#".concat(encodeValue(element.id)) : "";
    // Construct the test ID selector if specified in the config.
    var testId = selectorConfig.testId ? getAttributeSelector("data-testid") || getAttributeSelector("data-test-id") : "";
    // Construct the role selector if specified in the config.
    var role = selectorConfig.role ? getAttributeSelector("role") : "";
    var classNames = Array.from(element.classList).map(encodeValue).join(".");
    // Construct the class list selector if specified in the config.
    var classList = selectorConfig.className && classNames ? ".".concat(classNames) : "";
    // Combine primary attribute selectors (id, testId, role) into a single string.
    var primaryAttributes = [
        id,
        testId,
        role
    ].filter(Boolean).join("");
    // Use dataVC if available, otherwise use the primary attributes.
    var attributes = dataVC || primaryAttributes;
    // If no attributes or class list, recursively get the parent's name.
    if (!attributes && !classList) {
        var parentName = element.parentElement ? $43dd4fabf1742a20$var$getElementName(selectorConfig, element.parentElement) : "unknown";
        return "".concat(parentName, " > ").concat(tagName);
    }
    // Return the final constructed name: tagName + attributes or classList.
    var name = "".concat(tagName).concat(attributes || classList);
    $43dd4fabf1742a20$var$nameCache.set(element, name);
    return name;
}
var $43dd4fabf1742a20$export$2e2bcd8739ae039 = $43dd4fabf1742a20$var$getElementName;

});

parcelRegister("ipadY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6627e23aabe7175$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $5U5sG = parcelRequire("5U5sG");

var $lBHLA = parcelRequire("lBHLA");

var $5cxCk = parcelRequire("5cxCk");

var $jxLBU = parcelRequire("jxLBU");

var $hz5zq = parcelRequire("hz5zq");

var $c9boa = parcelRequire("c9boa");

var $yB9S8 = parcelRequire("yB9S8");

var $gahJn = parcelRequire("gahJn");

var $ls8zS = parcelRequire("ls8zS");
function $d6627e23aabe7175$var$_callSuper(t, o, e) {
    return o = (0, $lBHLA.default)(o), (0, $5U5sG.default)(t, $d6627e23aabe7175$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lBHLA.default)(t).constructor) : o.apply(t, e));
}
function $d6627e23aabe7175$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d6627e23aabe7175$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d6627e23aabe7175$var$ABORTING_WINDOW_EVENT = [
    "wheel",
    "scroll",
    "keydown",
    "resize"
];
var $d6627e23aabe7175$var$REVISION_NO = "fy25.03";
var $d6627e23aabe7175$var$getConsideredEntryTypes = function getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch) {
    var entryTypes = [
        "mutation:child-element",
        "mutation:element",
        "mutation:attribute",
        "layout-shift",
        "layout-shift:same-rect",
        "window:event"
    ];
    // Only include third-party elements in TTVC calculation when explicitly requested
    if (include3p) {
        entryTypes.push("mutation:third-party-element");
        entryTypes.push("mutation:third-party-attribute");
    }
    if (!excludeSmartAnswersInSearch) {
        entryTypes.push("mutation:smart-answers-element");
        entryTypes.push("mutation:smart-answers-attribute");
    }
    entryTypes.push("mutation:media");
    // Still included as part of TTVC v3
    entryTypes.push("mutation:attribute:non-visual-input-name");
    return entryTypes;
};
var $d6627e23aabe7175$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AbstractVCCalculator) {
    function VCCalculator_FY25_03(revisionNo) {
        (0, $i385U.default)(this, VCCalculator_FY25_03);
        return $d6627e23aabe7175$var$_callSuper(this, VCCalculator_FY25_03, [
            revisionNo !== null && revisionNo !== void 0 ? revisionNo : $d6627e23aabe7175$var$REVISION_NO
        ]);
    }
    (0, $5cxCk.default)(VCCalculator_FY25_03, _AbstractVCCalculator);
    return (0, $c19Op.default)(VCCalculator_FY25_03, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                if (!$d6627e23aabe7175$var$getConsideredEntryTypes(include3p, excludeSmartAnswersInSearch).includes(entry.data.type)) return false;
                if (entry.data.type === "mutation:attribute:framework-routing") return false;
                if (entry.data.type === "mutation:media" && (0, $jxLBU.fg)("media-perf-uplift-mutation-fix")) {
                    var entryData = entry.data;
                    var attributeName = entryData.attributeName;
                    if (attributeName && (/data-(test|file|context)-\S+/g.test(attributeName) || attributeName === "data-cursor" || attributeName === "alt" || (attributeName === "localid" || attributeName === "contenteditable" || attributeName === "anchor-name") && (0, $hz5zq.expVal)("platform_editor_media_vc_fixes", "isEnabled", false))) return false;
                    // special case for style attribute to ignore only anchor-name changes
                    if ((0, $hz5zq.expVal)("platform_editor_media_vc_fixes", "isEnabled", false)) {
                        if ((0, $c9boa.containsDnDMutationInStyle)({
                            attributeName: entryData.attributeName,
                            oldValue: entryData.oldValue,
                            newValue: entryData.newValue
                        })) return false;
                    }
                }
                if (entry.data.type === "mutation:attribute") {
                    var _entryData = entry.data;
                    var _attributeName = _entryData.attributeName;
                    if (!_attributeName || (0, $gahJn.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(_attributeName)) return false;
                    if (_attributeName.startsWith("data-test") || (0, $gahJn.NON_VISUAL_ARIA_ATTRIBUTES).includes(_attributeName) || (0, $gahJn.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $jxLBU.fg)("platform_ufo_exclude_3p_extensions_from_ttvc") || (0, $gahJn.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $jxLBU.fg)("platform_ufo_exclude_dark_reader_extension") || (0, $gahJn.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES).includes(_attributeName) && (0, $jxLBU.fg)("platform_ufo_exclude_fdprocessedid_attribute")) return false;
                    return true;
                }
                if ((0, $ls8zS.default)(entry.data) && !entry.data.visible) return false;
                return true;
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = "";
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === "window:event") {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($d6627e23aabe7175$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === "keydown" ? "keypress" : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $yB9S8.default));

});
parcelRegister("5U5sG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44c66b49b6655ccd$export$2e2bcd8739ae039; });

var $8pSiD = parcelRequire("8pSiD");

var $8WnkY = parcelRequire("8WnkY");
function $44c66b49b6655ccd$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $8pSiD.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $8WnkY.default)(t);
}

});
parcelRegister("8WnkY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6825d7d40c189db3$export$2e2bcd8739ae039; });
function $6825d7d40c189db3$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("lBHLA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fbaf00c981eaf498$export$2e2bcd8739ae039; });
function $fbaf00c981eaf498$export$2e2bcd8739ae039(t) {
    return $fbaf00c981eaf498$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $fbaf00c981eaf498$export$2e2bcd8739ae039(t);
}

});

parcelRegister("5cxCk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c98266f0341deb8$export$2e2bcd8739ae039; });

var $1lOcY = parcelRequire("1lOcY");
function $3c98266f0341deb8$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1lOcY.default)(t, e);
}

});
parcelRegister("1lOcY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0fbeb2ee12c769b2$export$2e2bcd8739ae039; });
function $0fbeb2ee12c769b2$export$2e2bcd8739ae039(t, e) {
    return $0fbeb2ee12c769b2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0fbeb2ee12c769b2$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("hz5zq", function(module, exports) {

$parcel$export(module.exports, "expVal", function () { return $cc9a06b0e696c6fb$export$9db1624a8af791a4; });

var $j8nYv = parcelRequire("j8nYv");

var $gZAnH = parcelRequire("gZAnH");
var $cc9a06b0e696c6fb$export$9db1624a8af791a4 = function expVal(experimentName, experimentParam, defaultValue) {
    // If client is not initialized, we return the default value
    if (!(0, $j8nYv.default).initializeCompleted()) return defaultValue;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    var experimentValue = (0, $j8nYv.default).getExperimentValue(experimentName, experimentParam, defaultValue);
    (0, $gZAnH.addFeatureFlagAccessed)("".concat(experimentName, ":").concat(experimentParam), experimentValue);
    return experimentValue;
};

});
parcelRegister("j8nYv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dee15c9be7792257$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $7Y0WY = parcelRequire("7Y0WY");

var $bIWeV = parcelRequire("bIWeV");



var $dee15c9be7792257$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $dee15c9be7792257$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $i385U.default)(this, FeatureGates);
    }
    return (0, $c19Op.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$dee15c9be7792257$var$_FeatureGates = $dee15c9be7792257$var$FeatureGates;
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "client", new (0, $7Y0WY.Client)());
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$dee15c9be7792257$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.",
                gateName: gateName,
                error: error
            });
            $dee15c9be7792257$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $dee15c9be7792257$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== "undefined" && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$dee15c9be7792257$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: "An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.",
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $dee15c9be7792257$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $dee15c9be7792257$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "initializeCalled", $dee15c9be7792257$var$_FeatureGates.client.initializeCalled.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "initializeCompleted", $dee15c9be7792257$var$_FeatureGates.client.initializeCompleted.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "initialize", $dee15c9be7792257$var$_FeatureGates.client.initialize.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "initializeWithProvider", $dee15c9be7792257$var$_FeatureGates.client.initializeWithProvider.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "initializeFromValues", $dee15c9be7792257$var$_FeatureGates.client.initializeFromValues.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "manuallyLogGateExposure", $dee15c9be7792257$var$_FeatureGates.client.manuallyLogGateExposure.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getExperiment", $dee15c9be7792257$var$_FeatureGates.client.getExperiment.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "manuallyLogExperimentExposure", $dee15c9be7792257$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "manuallyLogLayerExposure", $dee15c9be7792257$var$_FeatureGates.client.manuallyLogLayerExposure.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "shutdownStatsig", $dee15c9be7792257$var$_FeatureGates.client.shutdownStatsig.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "overrideGate", $dee15c9be7792257$var$_FeatureGates.client.overrideGate.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "clearGateOverride", $dee15c9be7792257$var$_FeatureGates.client.clearGateOverride.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "overrideConfig", $dee15c9be7792257$var$_FeatureGates.client.overrideConfig.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "clearConfigOverride", $dee15c9be7792257$var$_FeatureGates.client.clearConfigOverride.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "setOverrides", $dee15c9be7792257$var$_FeatureGates.client.setOverrides.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getOverrides", $dee15c9be7792257$var$_FeatureGates.client.getOverrides.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "clearAllOverrides", $dee15c9be7792257$var$_FeatureGates.client.clearAllOverrides.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "isCurrentUser", $dee15c9be7792257$var$_FeatureGates.client.isCurrentUser.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "onGateUpdated", $dee15c9be7792257$var$_FeatureGates.client.onGateUpdated.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "onExperimentValueUpdated", $dee15c9be7792257$var$_FeatureGates.client.onExperimentValueUpdated.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "onAnyUpdated", $dee15c9be7792257$var$_FeatureGates.client.onAnyUpdated.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "updateUser", $dee15c9be7792257$var$_FeatureGates.client.updateUser.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "updateUserWithProvider", $dee15c9be7792257$var$_FeatureGates.client.updateUserWithProvider.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "updateUserWithValues", $dee15c9be7792257$var$_FeatureGates.client.updateUserWithValues.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getPackageVersion", $dee15c9be7792257$var$_FeatureGates.client.getPackageVersion.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getLayer", $dee15c9be7792257$var$_FeatureGates.client.getLayer.bind($dee15c9be7792257$var$_FeatureGates.client));
(0, $dqOGO.default)($dee15c9be7792257$var$FeatureGates, "getLayerValue", $dee15c9be7792257$var$_FeatureGates.client.getLayerValue.bind($dee15c9be7792257$var$_FeatureGates.client));
var $dee15c9be7792257$var$boundFGJS = $dee15c9be7792257$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $dee15c9be7792257$var$FeatureGates;
    else {
        var $dee15c9be7792257$var$_boundFGJS, $dee15c9be7792257$var$_boundFGJS$getPackage;
        $dee15c9be7792257$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $dee15c9be7792257$var$boundVersion = (($dee15c9be7792257$var$_boundFGJS = $dee15c9be7792257$var$boundFGJS) === null || $dee15c9be7792257$var$_boundFGJS === void 0 || ($dee15c9be7792257$var$_boundFGJS$getPackage = $dee15c9be7792257$var$_boundFGJS.getPackageVersion) === null || $dee15c9be7792257$var$_boundFGJS$getPackage === void 0 ? void 0 : $dee15c9be7792257$var$_boundFGJS$getPackage.call($dee15c9be7792257$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($dee15c9be7792257$var$boundVersion !== (0, $bIWeV.CLIENT_VERSION)) {
            var $dee15c9be7792257$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($dee15c9be7792257$var$boundVersion, " when module version ").concat((0, $bIWeV.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($dee15c9be7792257$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $dee15c9be7792257$export$2e2bcd8739ae039 = $dee15c9be7792257$var$boundFGJS;

});
parcelRegister("7Y0WY", function(module, exports) {

$parcel$export(module.exports, "Client", function () { return $5ccedfab077aa129$export$1f2bb630327ac4b6; });

var $6PaYK = parcelRequire("6PaYK");

var $jzYu7 = parcelRequire("jzYu7");

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $hRKKo = parcelRequire("hRKKo");

var $7qNrp = parcelRequire("7qNrp");

var $fYlfz = parcelRequire("fYlfz");

var $3kT4C = parcelRequire("3kT4C");

var $k9w74 = parcelRequire("k9w74");

var $iVz86 = parcelRequire("iVz86");

var $brdI8 = parcelRequire("brdI8");

var $fttHr = parcelRequire("fttHr");

var $aDYvN = parcelRequire("aDYvN");

var $iAXQo = parcelRequire("iAXQo");

var $bIWeV = parcelRequire("bIWeV");
var $5ccedfab077aa129$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $5ccedfab077aa129$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5ccedfab077aa129$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5ccedfab077aa129$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5ccedfab077aa129$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5ccedfab077aa129$var$DEFAULT_CLIENT_KEY = "client-default-key";
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $5ccedfab077aa129$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/rgstr";
var $5ccedfab077aa129$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $fttHr.LOCAL_STORAGE_KEY) : _ref$localStorageKey, overrideAdapter = _ref.overrideAdapter;
        (0, $i385U.default)(this, Client);
        (0, $dqOGO.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $dqOGO.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $dqOGO.default)(this, "initWithDefaults", false);
        (0, $dqOGO.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $dqOGO.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $dqOGO.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $dqOGO.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $dqOGO.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $dqOGO.default)(this, "subscriptions", new (0, $7qNrp.default)());
        (0, $dqOGO.default)(this, "dataAdapter", new (0, $brdI8.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $dqOGO.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = overrideAdapter || new (0, $fttHr.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $c19Op.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $iAXQo.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $iAXQo.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, "initialize", _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $iAXQo.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $iAXQo.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $bIWeV.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, "initializeWithProvider", _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $5ccedfab077aa129$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $bIWeV.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $aDYvN.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $iAXQo.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $iAXQo.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, "has_updates")) initializeValues["has_updates"] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, "initializeFromValues", _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x0) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error("Client must be initialized before using this method");
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $iAXQo.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $iVz86.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x1, _x10, _x11) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x12, _x13) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x14, _x15) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes("Unrecognized");
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $fYlfz.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $fYlfz.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $k9w74.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $iAXQo.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $iAXQo.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $5ccedfab077aa129$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $iVz86.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $iVz86.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $jzYu7.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x16, _x17, _x18) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $5ccedfab077aa129$var$_objectSpread($5ccedfab077aa129$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $jzYu7.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x19, _x20, _x21, _x22) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $iAXQo.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $5ccedfab077aa129$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $5ccedfab077aa129$var$_objectSpread($5ccedfab077aa129$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $5ccedfab077aa129$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $aDYvN.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $6PaYK.default)(newClientOptions, $5ccedfab077aa129$var$_excluded);
                                this.user = (0, $iAXQo.toStatsigUser)(identifiers, customAttributes);
                                statsigOptions = $5ccedfab077aa129$var$_objectSpread($5ccedfab077aa129$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter,
                                    logEventCompressionMode: (0, $hRKKo.LogEventCompressionMode).Forced
                                }); // Statsig validates the provided stableId against their own cookie, so we either need
                                // to update the cookie to match, or disable the validation completely.
                                if (identifiers.stableId) (0, $hRKKo.StableID).setOverride(identifiers.stableId, sdkKey);
                                else statsigOptions.disableStableID = true;
                                _context9.prev = 12;
                                this.statsigClient = new (0, $hRKKo.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $hRKKo.StatsigClient)($5ccedfab077aa129$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x23, _x24, _x25) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee1(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee1$(_context1) {
                        while(true)switch(_context1.prev = _context1.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context1.next = 3;
                                    break;
                                }
                                throw new Error("The client must be initialized before you can update the user.");
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context1.next = 5;
                                    break;
                                }
                                return _context1.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context1.prev = 6;
                                _context1.next = 9;
                                return this.initPromise;
                            case 9:
                                _context1.next = 13;
                                break;
                            case 11:
                                _context1.prev = 11;
                                _context1.t0 = _context1["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee0() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee0$(_context0) {
                                        while(true)switch(_context0.prev = _context0.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context0.next = 4;
                                                    break;
                                                }
                                                _context0.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context0.stop();
                                        }
                                    }, _callee0);
                                })));
                                return _context1.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context1.stop();
                        }
                    }, _callee1, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x26, _x27, _x28) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee10(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context10.prev = 1;
                                _context10.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context10.sent;
                                user = (0, $iAXQo.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch);
                                _context10.next = 13;
                                break;
                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context10.t0 instanceof Error ? _context10.t0.message : JSON.stringify(_context10.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context10.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context10.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                if (!this.user) {
                                    _context10.next = 21;
                                    break;
                                }
                                _context10.next = 21;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 21:
                                _context10.next = 27;
                                break;
                            case 23:
                                _context10.prev = 23;
                                _context10.t1 = _context10["catch"](15);
                                success = false;
                                errorMessage = String(_context10.t1);
                            case 27:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context10.next = 34;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context10.next = 35;
                                break;
                            case 34:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 35:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            23
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x29, _x30, _x31) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $bIWeV.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $3kT4C.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $3kT4C.Layer).fromLayer((0, $hRKKo._makeLayer)(layerName, {
                        reason: "Error"
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("hRKKo", function(module, exports) {
"use strict";
var $d01ba5f4e74478f4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d01ba5f4e74478f4$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d01ba5f4e74478f4$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $41hQI = parcelRequire("41hQI");
module.exports.StatsigClient = $41hQI.default;

$d01ba5f4e74478f4$var$__exportStar((parcelRequire("j59CT")), module.exports);
const $d01ba5f4e74478f4$var$__STATSIG__ = Object.assign((0, (parcelRequire("j59CT"))._getStatsigGlobal)(), {
    StatsigClient: $41hQI.default
});
module.exports.default = $d01ba5f4e74478f4$var$__STATSIG__;

});
parcelRegister("j59CT", function(module, exports) {
"use strict";
var $de45f38402c71997$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $de45f38402c71997$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $de45f38402c71997$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("5szBU")).Diagnostics;
    }
});

var $hclID = parcelRequire("hclID");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $hclID.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("g8WEt")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("fKAAs")).Storage;
    }
});

$de45f38402c71997$var$__exportStar((parcelRequire("6HoVP")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("c2aJN")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("cYMEg")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("yJ56z")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("5szBU")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("ea6GU")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("dllvA")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("aVLEJ")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("68Fr7")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("kGC0i")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("6UKxA")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("g8WEt")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("k3zZ4")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("d5ILt")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("93J8g")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("eAn3U")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("89sy5")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("hPuKI")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("aJPTq")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("iBcMN")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("k6VhX")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("7HFbw")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("dsrTl")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("dKQUU")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("hFfJc")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("9TqN6")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("f47S3")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("c2Lgq")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("6Y0ob")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("03IQa")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("Xgsr2")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("4b3RQ")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("fKAAs")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("aYx2w")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("66phf")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("3juip")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("6gVGc")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("g8rdD")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("9NjL7")), module.exports);

$de45f38402c71997$var$__exportStar((parcelRequire("ekQ4B")), module.exports);
Object.assign((0, (parcelRequire("6HoVP"))._getStatsigGlobal)(), {
    Log: (parcelRequire("g8WEt")).Log,
    SDK_VERSION: (parcelRequire("f47S3")).SDK_VERSION
});

});
parcelRegister("6HoVP", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $4e0a1929bc55c92e$var$_a, $4e0a1929bc55c92e$var$_b, $4e0a1929bc55c92e$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $g8WEt = parcelRequire("g8WEt");
const $4e0a1929bc55c92e$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== "undefined" ? __STATSIG__ : $4e0a1929bc55c92e$var$statsigGlobal;
    } catch (e) {
        return $4e0a1929bc55c92e$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $4e0a1929bc55c92e$var$_getStatsigGlobal;
const $4e0a1929bc55c92e$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $4e0a1929bc55c92e$var$_getStatsigGlobalFlag;
const $4e0a1929bc55c92e$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $g8WEt.Log.warn("Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.");
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $4e0a1929bc55c92e$var$_getInstance;
const $4e0a1929bc55c92e$var$GLOBAL_KEY = "__STATSIG__";
const $4e0a1929bc55c92e$var$_window = typeof window !== "undefined" ? window : {};
const $4e0a1929bc55c92e$var$_global = typeof $parcel$global !== "undefined" ? $parcel$global : {};
const $4e0a1929bc55c92e$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : {};
const $4e0a1929bc55c92e$var$statsigGlobal = ($4e0a1929bc55c92e$var$_c = ($4e0a1929bc55c92e$var$_b = ($4e0a1929bc55c92e$var$_a = $4e0a1929bc55c92e$var$_window[$4e0a1929bc55c92e$var$GLOBAL_KEY]) !== null && $4e0a1929bc55c92e$var$_a !== void 0 ? $4e0a1929bc55c92e$var$_a : $4e0a1929bc55c92e$var$_global[$4e0a1929bc55c92e$var$GLOBAL_KEY]) !== null && $4e0a1929bc55c92e$var$_b !== void 0 ? $4e0a1929bc55c92e$var$_b : $4e0a1929bc55c92e$var$_globalThis[$4e0a1929bc55c92e$var$GLOBAL_KEY]) !== null && $4e0a1929bc55c92e$var$_c !== void 0 ? $4e0a1929bc55c92e$var$_c : {
    instance: module.exports._getInstance
};
$4e0a1929bc55c92e$var$_window[$4e0a1929bc55c92e$var$GLOBAL_KEY] = $4e0a1929bc55c92e$var$statsigGlobal;
$4e0a1929bc55c92e$var$_global[$4e0a1929bc55c92e$var$GLOBAL_KEY] = $4e0a1929bc55c92e$var$statsigGlobal;
$4e0a1929bc55c92e$var$_globalThis[$4e0a1929bc55c92e$var$GLOBAL_KEY] = $4e0a1929bc55c92e$var$statsigGlobal;

});
parcelRegister("g8WEt", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $bc0ae3b88fdfdd99$var$DEBUG = " DEBUG ";
const $bc0ae3b88fdfdd99$var$_INFO = "  INFO ";
const $bc0ae3b88fdfdd99$var$_WARN = "  WARN ";
const $bc0ae3b88fdfdd99$var$ERROR = " ERROR ";
function $bc0ae3b88fdfdd99$var$addTag(args) {
    args.unshift("[Statsig]");
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $bc0ae3b88fdfdd99$var$Log {
    static info(...args) {
        if ($bc0ae3b88fdfdd99$var$Log.level >= module.exports.LogLevel.Info) console.info($bc0ae3b88fdfdd99$var$_INFO, ...$bc0ae3b88fdfdd99$var$addTag(args));
    }
    static debug(...args) {
        if ($bc0ae3b88fdfdd99$var$Log.level >= module.exports.LogLevel.Debug) console.debug($bc0ae3b88fdfdd99$var$DEBUG, ...$bc0ae3b88fdfdd99$var$addTag(args));
    }
    static warn(...args) {
        if ($bc0ae3b88fdfdd99$var$Log.level >= module.exports.LogLevel.Warn) console.warn($bc0ae3b88fdfdd99$var$_WARN, ...$bc0ae3b88fdfdd99$var$addTag(args));
    }
    static error(...args) {
        if ($bc0ae3b88fdfdd99$var$Log.level >= module.exports.LogLevel.Error) console.error($bc0ae3b88fdfdd99$var$ERROR, ...$bc0ae3b88fdfdd99$var$addTag(args));
    }
}
module.exports.Log = $bc0ae3b88fdfdd99$var$Log;
$bc0ae3b88fdfdd99$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("5szBU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $3f9b30c3d24412d1$var$MARKER_MAP = new Map();
const $3f9b30c3d24412d1$var$ACT_START = "start";
const $3f9b30c3d24412d1$var$ACT_END = "end";
const $3f9b30c3d24412d1$var$DIAGNOSTICS_EVENT = "statsig::diagnostics";
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $3f9b30c3d24412d1$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker({}, $3f9b30c3d24412d1$var$ACT_START, "overall"));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: "InitializeError",
                message: "Failed to initialize"
            },
            evaluationDetails: evaluationDetails
        }, $3f9b30c3d24412d1$var$ACT_END, "overall"));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker(data, $3f9b30c3d24412d1$var$ACT_START, "initialize", "network_request"));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker(data, $3f9b30c3d24412d1$var$ACT_END, "initialize", "network_request"));
    },
    _markInitProcessStart: (sdkKey)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker({}, $3f9b30c3d24412d1$var$ACT_START, "initialize", "process"));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $3f9b30c3d24412d1$var$_addMarker(sdkKey, $3f9b30c3d24412d1$var$_createMarker(data, $3f9b30c3d24412d1$var$ACT_END, "initialize", "process"));
    },
    _clearMarkers: (sdkKey)=>{
        $3f9b30c3d24412d1$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === "object")) return;
        return {
            code: $3f9b30c3d24412d1$var$_safeGetField(e, "code"),
            name: $3f9b30c3d24412d1$var$_safeGetField(e, "name"),
            message: $3f9b30c3d24412d1$var$_safeGetField(e, "message")
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get("x-statsig-region"),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $3f9b30c3d24412d1$var$_makeDiagnosticsEvent(user, {
            context: "initialize",
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $3f9b30c3d24412d1$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $3f9b30c3d24412d1$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $3f9b30c3d24412d1$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $3f9b30c3d24412d1$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $3f9b30c3d24412d1$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $3f9b30c3d24412d1$var$MARKER_MAP.set(sdkKey, markers);
}
function $3f9b30c3d24412d1$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("hclID", function(module, exports) {
"use strict";
var $c8546790c7d42c3d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $c2aJN = parcelRequire("c2aJN");

var $kGC0i = parcelRequire("kGC0i");

var $g8WEt = parcelRequire("g8WEt");

var $d5ILt = parcelRequire("d5ILt");

var $hPuKI = parcelRequire("hPuKI");

var $9TqN6 = parcelRequire("9TqN6");

var $c2Lgq = parcelRequire("c2Lgq");

var $fKAAs = parcelRequire("fKAAs");

var $3juip = parcelRequire("3juip");

var $g8rdD = parcelRequire("g8rdD");
const $c8546790c7d42c3d$var$DEFAULT_QUEUE_SIZE = 100;
const $c8546790c7d42c3d$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $c8546790c7d42c3d$var$MAX_DEDUPER_KEYS = 1000;
const $c8546790c7d42c3d$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $c8546790c7d42c3d$var$MAX_FAILED_LOGS = 500;
const $c8546790c7d42c3d$var$QUICK_FLUSH_WINDOW_MS = 200;
const $c8546790c7d42c3d$var$EVENT_LOGGER_MAP = {};
const $c8546790c7d42c3d$var$RetryFailedLogsTrigger = {
    Startup: "startup",
    GainedFocus: "gained_focus"
};
class $c8546790c7d42c3d$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $c8546790c7d42c3d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $c8546790c7d42c3d$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($c8546790c7d42c3d$var$RetryFailedLogsTrigger.GainedFocus);
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $c2Lgq.LoggingEnabledOption.disabled : $c2Lgq.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $g8WEt.Log.warn("Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.");
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $c8546790c7d42c3d$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $3juip.UrlConfiguration($d5ILt.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $c8546790c7d42c3d$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $hPuKI._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always") return;
        $c8546790c7d42c3d$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $g8rdD._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === "background") $c8546790c7d42c3d$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === "foreground") $c8546790c7d42c3d$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($c8546790c7d42c3d$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $c8546790c7d42c3d$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $c8546790c7d42c3d$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $c8546790c7d42c3d$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $c8546790c7d42c3d$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$c8546790c7d42c3d$var$EventLogger._safeFlushAndForget(this._sdkKey), $c8546790c7d42c3d$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== "always" && (0, $hPuKI._isServerEnv)()) return false;
        if (!(0, $9TqN6._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $c2aJN._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata["gate"],
            metadata["config"],
            metadata["ruleID"],
            metadata["allocatedExperiment"],
            metadata["parameterName"],
            String(metadata["isExplicitParameter"]),
            metadata["reason"]
        ].join("|");
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $c8546790c7d42c3d$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $c8546790c7d42c3d$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $c8546790c7d42c3d$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === "disabled") {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $g8rdD._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: "pre_logs_flushed",
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: "logs_flushed",
                        events: events
                    });
                    return true;
                } else {
                    $g8WEt.Log.warn("Failed to flush events.");
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $g8WEt.Log.warn("Failed to flush events.");
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $c8546790c7d42c3d$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$d5ILt.NetworkParam.EventCount]: String(events.length)
            },
            credentials: "same-origin"
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $c8546790c7d42c3d$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $fKAAs._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $g8WEt.Log.warn("Unable to save failed logs to storage");
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$c8546790c7d42c3d$var$__awaiter(this, void 0, void 0, function*() {
                if (!$fKAAs.Storage.isReady()) yield $fKAAs.Storage.isReadyResolver();
                const events = (0, $fKAAs._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $c8546790c7d42c3d$var$RetryFailedLogsTrigger.Startup) $fKAAs.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $c8546790c7d42c3d$var$RetryFailedLogsTrigger.GainedFocus) $fKAAs.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $g8WEt.Log.warn("Failed to flush stored logs");
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $kGC0i._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $g8WEt.Log.debug("Enqueued Event:", final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: "statsig::non_exposed_checks",
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $hPuKI._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $c8546790c7d42c3d$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $c8546790c7d42c3d$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $c8546790c7d42c3d$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $c8546790c7d42c3d$var$EventLogger;

});
parcelRegister("c2aJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $kGC0i = parcelRequire("kGC0i");
function $8c2e003a51614612$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(",")}`,
        `k:${sdkKey}`
    ];
    return (0, $kGC0i._DJB2)(parts.join("|"));
}
module.exports._getUserStorageKey = $8c2e003a51614612$var$_getUserStorageKey;
function $8c2e003a51614612$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $8c2e003a51614612$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $kGC0i._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $8c2e003a51614612$var$_getStorageKey;

});
parcelRegister("kGC0i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $66phf = parcelRequire("66phf");
const $f0f535abc3abe1f1$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $f0f535abc3abe1f1$var$_DJB2;
const $f0f535abc3abe1f1$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $f0f535abc3abe1f1$var$_DJB2Object;
const $f0f535abc3abe1f1$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $66phf._typeOf)(value) !== "object") {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $f0f535abc3abe1f1$var$_getSortedObject;

});
parcelRegister("66phf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $4716e91fe8eb6c0b$var$_typeOf(input) {
    return Array.isArray(input) ? "array" : typeof input;
}
module.exports._typeOf = $4716e91fe8eb6c0b$var$_typeOf;
function $4716e91fe8eb6c0b$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? "array" : x === null ? "null" : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $4716e91fe8eb6c0b$var$_isTypeMatch;

});



parcelRegister("d5ILt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: "initialize",
    _rgstr: "rgstr",
    _download_config_specs: "download_config_specs"
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: "https://prodregistryv2.org/v1",
    [module.exports.Endpoint._initialize]: "https://featureassets.org/v1",
    [module.exports.Endpoint._download_config_specs]: "https://api.statsigcdn.com/v1"
};
module.exports.NetworkParam = {
    EventCount: "ec",
    SdkKey: "k",
    SdkType: "st",
    SdkVersion: "sv",
    Time: "t",
    SessionID: "sid",
    StatsigEncoded: "se",
    IsGzipped: "gz"
};

});

parcelRegister("hPuKI", function(module, exports) {

var $XAEGR = parcelRequire("XAEGR");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $cfaf0de7444efc2a$var$_getWindowSafe = ()=>{
    return typeof window !== "undefined" ? window : null;
};
module.exports._getWindowSafe = $cfaf0de7444efc2a$var$_getWindowSafe;
const $cfaf0de7444efc2a$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $cfaf0de7444efc2a$var$_getDocumentSafe;
const $cfaf0de7444efc2a$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $XAEGR !== "undefined" && $XAEGR.versions != null && $XAEGR.versions.node != null;
    const isVercel = typeof EdgeRuntime === "string";
    return isVercel || isNode;
};
module.exports._isServerEnv = $cfaf0de7444efc2a$var$_isServerEnv;
const $cfaf0de7444efc2a$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === "function") win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $cfaf0de7444efc2a$var$_addWindowEventListenerSafe;
const $cfaf0de7444efc2a$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === "function") doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $cfaf0de7444efc2a$var$_addDocumentEventListenerSafe;
const $cfaf0de7444efc2a$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $cfaf0de7444efc2a$var$_getCurrentPageUrlSafe;
const $cfaf0de7444efc2a$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return "beforeunload";
    const eventType = "onpagehide" in win ? "pagehide" : "beforeunload";
    return eventType;
};
module.exports._getUnloadEvent = $cfaf0de7444efc2a$var$_getUnloadEvent;

});

parcelRegister("9TqN6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $733e0841529d0792$var$CONFIG_EXPOSURE_NAME = "statsig::config_exposure";
const $733e0841529d0792$var$GATE_EXPOSURE_NAME = "statsig::gate_exposure";
const $733e0841529d0792$var$LAYER_EXPOSURE_NAME = "statsig::layer_exposure";
const $733e0841529d0792$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata["bootstrapMetadata"] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $733e0841529d0792$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $733e0841529d0792$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $733e0841529d0792$var$GATE_EXPOSURE_NAME || eventName === $733e0841529d0792$var$CONFIG_EXPOSURE_NAME || eventName === $733e0841529d0792$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $733e0841529d0792$var$_isExposureEvent;
const $733e0841529d0792$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = gate.__evaluation.version;
    return $733e0841529d0792$var$_createExposure($733e0841529d0792$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $733e0841529d0792$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $733e0841529d0792$var$_createGateExposure;
function $733e0841529d0792$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === "string") return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $733e0841529d0792$var$_mapExposures;
const $733e0841529d0792$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata["configVersion"] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata["rulePassed"] = String(config.__evaluation.passed);
    return $733e0841529d0792$var$_createExposure($733e0841529d0792$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $733e0841529d0792$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $733e0841529d0792$var$_createConfigExposure;
const $733e0841529d0792$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = "";
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : "";
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata["configVersion"] = layer.__evaluation.version;
    return $733e0841529d0792$var$_createExposure($733e0841529d0792$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $733e0841529d0792$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $733e0841529d0792$var$_createLayerParameterExposure;
const $733e0841529d0792$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata["reason"] = details.reason;
    if (details.lcut) metadata["lcut"] = String(details.lcut);
    if (details.receivedAt) metadata["receivedAt"] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("c2Lgq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: "d",
    /** Compress request bodies unless a network proxy is configured */ Enabled: "e",
    /** Always compress request bodies, even when a proxy is configured */ Forced: "f"
};
module.exports.LoggingEnabledOption = {
    disabled: "disabled",
    browserOnly: "browser-only",
    always: "always"
};

});

parcelRegister("fKAAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $g8WEt = parcelRequire("g8WEt");

var $hPuKI = parcelRequire("hPuKI");
const $b7778851e6dda591$var$inMemoryStore = {};
const $b7778851e6dda591$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>"InMemory",
    getItem: (key)=>$b7778851e6dda591$var$inMemoryStore[key] ? $b7778851e6dda591$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $b7778851e6dda591$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $b7778851e6dda591$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($b7778851e6dda591$var$inMemoryStore)
};
let $b7778851e6dda591$var$_localStorageProvider = null;
try {
    const win = (0, $hPuKI._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === "function") $b7778851e6dda591$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>"LocalStorage",
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $g8WEt.Log.warn("Failed to setup localStorageProvider.");
}
let $b7778851e6dda591$var$_main = $b7778851e6dda591$var$_localStorageProvider !== null && $b7778851e6dda591$var$_localStorageProvider !== void 0 ? $b7778851e6dda591$var$_localStorageProvider : $b7778851e6dda591$var$_inMemoryProvider;
let $b7778851e6dda591$var$_current = $b7778851e6dda591$var$_main;
function $b7778851e6dda591$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === "SecurityError") {
            module.exports.Storage._setProvider($b7778851e6dda591$var$_inMemoryProvider);
            return null;
        }
        if (error instanceof Error && error.name === "QuotaExceededError") {
            const allKeys = module.exports.Storage.getAllKeys();
            const statsigKeys = allKeys.filter((key)=>key.startsWith("statsig."));
            error.message = `${error.message}. Statsig Keys: ${statsigKeys.length}`;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$b7778851e6dda591$var$_current.isReady(),
    isReadyResolver: ()=>$b7778851e6dda591$var$_current.isReadyResolver(),
    getProviderName: ()=>$b7778851e6dda591$var$_current.getProviderName(),
    getItem: (key)=>$b7778851e6dda591$var$_inMemoryBreaker(()=>$b7778851e6dda591$var$_current.getItem(key)),
    setItem: (key, value)=>$b7778851e6dda591$var$_inMemoryBreaker(()=>$b7778851e6dda591$var$_current.setItem(key, value)),
    removeItem: (key)=>$b7778851e6dda591$var$_current.removeItem(key),
    getAllKeys: ()=>$b7778851e6dda591$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $b7778851e6dda591$var$_main = newProvider;
        $b7778851e6dda591$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $b7778851e6dda591$var$_current = $b7778851e6dda591$var$_inMemoryProvider;
        else $b7778851e6dda591$var$_current = $b7778851e6dda591$var$_main;
    }
};
function $b7778851e6dda591$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : "null");
}
module.exports._getObjectFromStorage = $b7778851e6dda591$var$_getObjectFromStorage;
function $b7778851e6dda591$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $b7778851e6dda591$var$_setObjectInStorage;

});

parcelRegister("3juip", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $kGC0i = parcelRequire("kGC0i");

var $d5ILt = parcelRequire("d5ILt");
const $269aa59aba4d8e64$var$ENDPOINT_DNS_KEY_MAP = {
    [$d5ILt.Endpoint._initialize]: "i",
    [$d5ILt.Endpoint._rgstr]: "e",
    [$d5ILt.Endpoint._download_config_specs]: "d"
};
class $269aa59aba4d8e64$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $269aa59aba4d8e64$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith("/") ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $d5ILt.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(",");
        return (0, $kGC0i._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $269aa59aba4d8e64$var$UrlConfiguration;

});

parcelRegister("g8rdD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $hPuKI = parcelRequire("hPuKI");
const $bbf281d465dd9c8c$var$FOREGROUND = "foreground";
const $bbf281d465dd9c8c$var$BACKGROUND = "background";
const $bbf281d465dd9c8c$var$LISTENERS = [];
let $bbf281d465dd9c8c$var$current = $bbf281d465dd9c8c$var$FOREGROUND;
let $bbf281d465dd9c8c$var$isUnloading = false;
const $bbf281d465dd9c8c$var$_isCurrentlyVisible = ()=>{
    return $bbf281d465dd9c8c$var$current === $bbf281d465dd9c8c$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $bbf281d465dd9c8c$var$_isCurrentlyVisible;
const $bbf281d465dd9c8c$var$_isUnloading = ()=>$bbf281d465dd9c8c$var$isUnloading;
module.exports._isUnloading = $bbf281d465dd9c8c$var$_isUnloading;
const $bbf281d465dd9c8c$var$_subscribeToVisiblityChanged = (listener)=>{
    $bbf281d465dd9c8c$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $bbf281d465dd9c8c$var$_subscribeToVisiblityChanged;
const $bbf281d465dd9c8c$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $bbf281d465dd9c8c$var$current) return;
    $bbf281d465dd9c8c$var$current = visibility;
    $bbf281d465dd9c8c$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $bbf281d465dd9c8c$var$_notifyVisibilityChanged;
(0, $hPuKI._addWindowEventListenerSafe)("focus", ()=>{
    $bbf281d465dd9c8c$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($bbf281d465dd9c8c$var$FOREGROUND);
});
(0, $hPuKI._addWindowEventListenerSafe)("blur", ()=>(0, module.exports._notifyVisibilityChanged)($bbf281d465dd9c8c$var$BACKGROUND));
(0, $hPuKI._addDocumentEventListenerSafe)("visibilitychange", ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === "visible" ? $bbf281d465dd9c8c$var$FOREGROUND : $bbf281d465dd9c8c$var$BACKGROUND);
});
(0, $hPuKI._addWindowEventListenerSafe)((0, $hPuKI._getUnloadEvent)(), ()=>{
    $bbf281d465dd9c8c$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($bbf281d465dd9c8c$var$BACKGROUND);
});

});


parcelRegister("f47S3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = "3.22.0";
let $af7d55bcd39d2baa$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: "js-mono"
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$af7d55bcd39d2baa$var$metadata,
    add: (additions)=>{
        $af7d55bcd39d2baa$var$metadata = Object.assign(Object.assign({}, $af7d55bcd39d2baa$var$metadata), additions);
    }
};

});

parcelRegister("cYMEg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("yJ56z", function(module, exports) {
"use strict";
var $0686254e42c84bb0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $g8WEt = parcelRequire("g8WEt");

var $7HFbw = parcelRequire("7HFbw");

var $4b3RQ = parcelRequire("4b3RQ");

var $fKAAs = parcelRequire("fKAAs");

var $aYx2w = parcelRequire("aYx2w");
const $0686254e42c84bb0$var$CACHE_LIMIT = 10;
class $0686254e42c84bb0$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $0686254e42c84bb0$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $4b3RQ._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $4b3RQ._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $0686254e42c84bb0$var$_makeDataAdapterResult("Bootstrap", data, null, normalized));
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $7HFbw.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $0686254e42c84bb0$var$__awaiter(this, void 0, void 0, function*() {
            if (!$fKAAs.Storage.isReady()) yield $fKAAs.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $g8WEt.Log.debug("Fetching latest value timed out");
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $0686254e42c84bb0$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $4b3RQ._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: "Prefetch"
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $0686254e42c84bb0$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $g8WEt.Log.debug("No response returned for latest value");
                return null;
            }
            const response = (0, $aYx2w._typedJsonParse)(latest, "has_updates", "Response");
            const sdkKey = this._getSdkKey();
            const stableID = $7HFbw.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $0686254e42c84bb0$var$_makeDataAdapterResult("Network", latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $0686254e42c84bb0$var$_makeDataAdapterResult("NetworkNotModified", cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $g8WEt.Log.error(`${this._adapterName} is not attached to a Client`);
        return "";
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $fKAAs.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($fKAAs.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $aYx2w._typedJsonParse)(cache, "source", "Cached Result");
        return result ? Object.assign(Object.assign({}, result), {
            source: "Cache"
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $fKAAs.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $fKAAs._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $0686254e42c84bb0$var$_getEvictableKey(lastModifiedTimeMap, $0686254e42c84bb0$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $fKAAs.Storage.removeItem(evictable);
        }
        (0, $fKAAs._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $0686254e42c84bb0$var$DataAdapterCore;
function $0686254e42c84bb0$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $4b3RQ._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $0686254e42c84bb0$var$_makeDataAdapterResult;
class $0686254e42c84bb0$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $g8WEt.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $0686254e42c84bb0$var$_getEvictableKey(this._data, $0686254e42c84bb0$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $0686254e42c84bb0$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === "object" && typeof current === "object") return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("7HFbw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $c2aJN = parcelRequire("c2aJN");

var $g8WEt = parcelRequire("g8WEt");

var $hPuKI = parcelRequire("hPuKI");

var $fKAAs = parcelRequire("fKAAs");

var $6gVGc = parcelRequire("6gVGc");
const $59bc7f023afeba97$var$PROMISE_MAP = {};
const $59bc7f023afeba97$var$COOKIE_ENABLED_MAP = {};
const $59bc7f023afeba97$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($59bc7f023afeba97$var$DISABLED_MAP[sdkKey]) return null;
        if ($59bc7f023afeba97$var$PROMISE_MAP[sdkKey] != null) return $59bc7f023afeba97$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $59bc7f023afeba97$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $59bc7f023afeba97$var$PROMISE_MAP[sdkKey] = stableID;
            $59bc7f023afeba97$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $59bc7f023afeba97$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $6gVGc.getUUID)();
        $59bc7f023afeba97$var$_persistToStorage(stableID, sdkKey);
        $59bc7f023afeba97$var$_persistToCookie(stableID, sdkKey);
        $59bc7f023afeba97$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $59bc7f023afeba97$var$PROMISE_MAP[sdkKey] = override;
        $59bc7f023afeba97$var$_persistToStorage(override, sdkKey);
        $59bc7f023afeba97$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $59bc7f023afeba97$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $59bc7f023afeba97$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $59bc7f023afeba97$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $c2aJN._getStorageKey)(sdkKey)}`;
}
function $59bc7f023afeba97$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $59bc7f023afeba97$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $fKAAs._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $g8WEt.Log.warn("Failed to save StableID to storage");
    }
}
function $59bc7f023afeba97$var$_loadFromStorage(sdkKey) {
    const storageKey = $59bc7f023afeba97$var$_getStableIDStorageKey(sdkKey);
    return (0, $fKAAs._getObjectFromStorage)(storageKey);
}
function $59bc7f023afeba97$var$_loadFromCookie(sdkKey) {
    if (!$59bc7f023afeba97$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $hPuKI._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(";");
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split("=");
        if (key === $59bc7f023afeba97$var$_getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $59bc7f023afeba97$var$_persistToCookie(stableID, sdkKey) {
    if (!$59bc7f023afeba97$var$COOKIE_ENABLED_MAP[sdkKey] || !document) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$59bc7f023afeba97$var$_getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $59bc7f023afeba97$var$_getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $c2aJN._getStorageKey)(sdkKey)}`;
}

});
parcelRegister("6gVGc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $4910faad8db58033$var$getUUID() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== "undefined" && performance.now && performance.now() * 1000 || 0;
    const y = "89ab"[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === "x" ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $4910faad8db58033$var$getUUID;

});


parcelRegister("4b3RQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $kGC0i = parcelRequire("kGC0i");

var $g8WEt = parcelRequire("g8WEt");
function $30ab308180f62348$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $g8WEt.Log.error("Failed to JSON.stringify user");
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $30ab308180f62348$var$_normalizeUser;
function $30ab308180f62348$var$_getFullUserHash(user) {
    return user ? (0, $kGC0i._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $30ab308180f62348$var$_getFullUserHash;

});

parcelRegister("aYx2w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $g8WEt = parcelRequire("g8WEt");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $7fd922f78805cbc1$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === "object" && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $g8WEt.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $7fd922f78805cbc1$var$_typedJsonParse;

});


parcelRegister("ea6GU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dllvA", function(module, exports) {
"use strict";
var $9b6deba743f76912$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $g8WEt = parcelRequire("g8WEt");

var $aJPTq = parcelRequire("aJPTq");

var $f47S3 = parcelRequire("f47S3");
module.exports.EXCEPTION_ENDPOINT = "https://statsigapi.net/v1/sdk_exception";
const $9b6deba743f76912$var$UNKNOWN_ERROR = "[Statsig] UnknownError";
class $9b6deba743f76912$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance) {
        try {
            const obj = instance;
            $9b6deba743f76912$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ("$EB" in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError("eb:wrap", err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $9b6deba743f76912$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $g8WEt.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$9b6deba743f76912$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($9b6deba743f76912$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : "No Name";
                    const resolvedError = $9b6deba743f76912$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: "error",
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $aJPTq.SDKType._get(this._sdkKey);
                    const statsigMetadata = $f47S3.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $9b6deba743f76912$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $9b6deba743f76912$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: "POST",
                        headers: {
                            "STATSIG-API-KEY": this._sdkKey,
                            "STATSIG-SDK-TYPE": String(sdkType),
                            "STATSIG-SDK-VERSION": String(statsigMetadata.sdkVersion),
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: "error",
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $9b6deba743f76912$var$ErrorBoundary;
function $9b6deba743f76912$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === "string") return new Error(error);
    else return new Error("An unknown error occurred.");
}
function $9b6deba743f76912$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $9b6deba743f76912$var$UNKNOWN_ERROR;
    }
}
function $9b6deba743f76912$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === "function").forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $9b6deba743f76912$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.entries(options).forEach(([option, value])=>{
        const valueType = typeof value;
        switch(valueType){
            case "number":
            case "bigint":
            case "boolean":
                loggingCopy[String(option)] = value;
                break;
            case "string":
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = "set";
                break;
            case "object":
                if (option === "environment") loggingCopy["environment"] = value;
                else if (option === "networkConfig") loggingCopy["networkConfig"] = value;
                else loggingCopy[String(option)] = value != null ? "set" : "unset";
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("aJPTq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $7d165c314fcffd3f$var$SDK_CLIENT = {};
let $7d165c314fcffd3f$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $7d165c314fcffd3f$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : "js-mono") + ($7d165c314fcffd3f$var$suffix !== null && $7d165c314fcffd3f$var$suffix !== void 0 ? $7d165c314fcffd3f$var$suffix : "");
    },
    _setClientType (sdkKey, client) {
        $7d165c314fcffd3f$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$7d165c314fcffd3f$var$suffix || $7d165c314fcffd3f$var$suffix === "-react") $7d165c314fcffd3f$var$suffix = "-" + binding;
    }
};

});


parcelRegister("aVLEJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("68Fr7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6UKxA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k3zZ4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: "g",
    _dynamicConfig: "c",
    _experiment: "e",
    _configList: "cl",
    _layer: "l",
    _paramStore: "p"
};
const $e9a00027e5b277a1$var$EXIST_KEYS = new Set([]);
const $e9a00027e5b277a1$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    "userPersistedValues"
]);
function $e9a00027e5b277a1$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($e9a00027e5b277a1$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($e9a00027e5b277a1$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $e9a00027e5b277a1$var$createMemoKey;

});

parcelRegister("93J8g", function(module, exports) {
"use strict";
var $6987672e7b9cf7bb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $6HoVP = parcelRequire("6HoVP");

var $6HoVP = parcelRequire("6HoVP");

var $5szBU = parcelRequire("5szBU");

var $g8WEt = parcelRequire("g8WEt");

var $d5ILt = parcelRequire("d5ILt");

var $7Bt5B = parcelRequire("7Bt5B");

var $ekQ4B = parcelRequire("ekQ4B");

var $aJPTq = parcelRequire("aJPTq");

var $hPuKI = parcelRequire("hPuKI");

var $iBcMN = parcelRequire("iBcMN");

var $7HFbw = parcelRequire("7HFbw");

var $dKQUU = parcelRequire("dKQUU");

var $f47S3 = parcelRequire("f47S3");

var $c2Lgq = parcelRequire("c2Lgq");

var $g8rdD = parcelRequire("g8rdD");
const $6987672e7b9cf7bb$var$DEFAULT_TIMEOUT_MS = 10000;
const $6987672e7b9cf7bb$var$BACKOFF_BASE_MS = 500;
const $6987672e7b9cf7bb$var$BACKOFF_MAX_MS = 30000;
const $6987672e7b9cf7bb$var$RATE_LIMIT_WINDOW_MS = 1000;
const $6987672e7b9cf7bb$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $6987672e7b9cf7bb$var$LEAK_RATE = $6987672e7b9cf7bb$var$RATE_LIMIT_MAX_REQ_COUNT / $6987672e7b9cf7bb$var$RATE_LIMIT_WINDOW_MS;
const $6987672e7b9cf7bb$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $6987672e7b9cf7bb$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $6987672e7b9cf7bb$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $7Bt5B.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function";
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$6987672e7b9cf7bb$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs("POST", args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $6987672e7b9cf7bb$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs("POST", args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs("GET", args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $6987672e7b9cf7bb$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$6987672e7b9cf7bb$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $g8WEt.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== "undefined" ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $g8rdD._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $6987672e7b9cf7bb$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>"No Text");
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = "NetworkError";
                    throw err;
                }
                const text = yield response.text();
                $6987672e7b9cf7bb$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $6987672e7b9cf7bb$var$_getErrorMessage(abortController, error);
                const timedOut = $6987672e7b9cf7bb$var$_didTimeout(abortController);
                $6987672e7b9cf7bb$var$_tryMarkInitEnd(args, response, currentAttempt, "", error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$6987672e7b9cf7bb$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: "error",
                        error: error,
                        tag: $dKQUU.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $g8WEt.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $6987672e7b9cf7bb$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $c2Lgq.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $c2Lgq.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $6987672e7b9cf7bb$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $6987672e7b9cf7bb$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $d5ILt.Endpoint._initialize || args.urlConfig.endpoint === $d5ILt.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$d5ILt.NetworkParam.SdkKey]: args.sdkKey,
            [$d5ILt.NetworkParam.SdkType]: $aJPTq.SDKType._get(args.sdkKey),
            [$d5ILt.NetworkParam.SdkVersion]: $f47S3.SDK_VERSION,
            [$d5ILt.NetworkParam.Time]: String(Date.now()),
            [$d5ILt.NetworkParam.SessionID]: $iBcMN.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join("&");
        return `${url}${query ? `?${query}` : ""}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $hPuKI._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== "string" || (0, $6HoVP._getStatsigGlobalFlag)("no-encode") != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split("").reverse().join("");
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$d5ILt.NetworkParam.StatsigEncoded]: "1"
            });
        } catch (e) {
            $g8WEt.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $6987672e7b9cf7bb$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== "string" || !$6987672e7b9cf7bb$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream("gzip");
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($g8WEt.Log.error);
                writer.close().catch($g8WEt.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$d5ILt.NetworkParam.IsGzipped]: "1"
                });
            } catch (e) {
                $g8WEt.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ("data" in args) $6987672e7b9cf7bb$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $6987672e7b9cf7bb$var$NetworkCore;
const $6987672e7b9cf7bb$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $g8WEt.Log.warn("Unable to make request without an SDK key");
        return false;
    }
    return true;
};
const $6987672e7b9cf7bb$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $7HFbw.StableID.get(sdkKey);
    const sessionID = $iBcMN.SessionID.get(sdkKey);
    const sdkType = $aJPTq.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $f47S3.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $6987672e7b9cf7bb$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $6HoVP._getStatsigGlobalFlag)("no-compress") != null || typeof CompressionStream === "undefined" || typeof TextEncoder === "undefined") return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $ekQ4B.SDKFlags.get(args.sdkKey, "enable_log_event_compression") === true;
    switch(options.logEventCompressionMode){
        case $c2Lgq.LogEventCompressionMode.Disabled:
            return false;
        case $c2Lgq.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $c2Lgq.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $6987672e7b9cf7bb$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string") return controller.signal.reason;
    if (typeof error === "string") return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return "Unknown Error";
}
function $6987672e7b9cf7bb$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === "string" && controller.signal.reason.includes("Timeout");
    return timeout || false;
}
function $6987672e7b9cf7bb$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $d5ILt.Endpoint._initialize) return;
    $5szBU.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $6987672e7b9cf7bb$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $d5ILt.Endpoint._initialize) return;
    $5szBU.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $5szBU.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $6987672e7b9cf7bb$var$_exponentialBackoff(attempt) {
    return $6987672e7b9cf7bb$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($6987672e7b9cf7bb$var$BACKOFF_BASE_MS * (attempt * attempt), $6987672e7b9cf7bb$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("7Bt5B", function(module, exports) {
"use strict";
var $58928da483d7fd21$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $65j6s = parcelRequire("65j6s");

var $kGC0i = parcelRequire("kGC0i");

var $g8WEt = parcelRequire("g8WEt");

var $fKAAs = parcelRequire("fKAAs");
const $58928da483d7fd21$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $58928da483d7fd21$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $58928da483d7fd21$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $58928da483d7fd21$var$DEFAULT_TTL_MS;
        $58928da483d7fd21$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $58928da483d7fd21$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $58928da483d7fd21$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $58928da483d7fd21$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$58928da483d7fd21$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError("tryFetchUpdatedFallbackInfo", error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $58928da483d7fd21$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $58928da483d7fd21$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $58928da483d7fd21$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $58928da483d7fd21$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $65j6s._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $58928da483d7fd21$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + "=")) continue;
                const parts = record.split("=");
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith("/")) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith("/") ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $58928da483d7fd21$var$NetworkFallbackResolver;
function $58928da483d7fd21$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : "";
    return timedOut || lowerErrorMsg.includes("uncaught exception") || lowerErrorMsg.includes("failed to fetch") || lowerErrorMsg.includes("networkerror when attempting to fetch resource");
}
module.exports._isDomainFailure = $58928da483d7fd21$var$_isDomainFailure;
function $58928da483d7fd21$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $kGC0i._DJB2)(sdkKey)}`;
}
function $58928da483d7fd21$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $58928da483d7fd21$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $fKAAs.Storage.removeItem(hashKey);
        return;
    }
    $fKAAs.Storage.setItem(hashKey, JSON.stringify(info));
}
function $58928da483d7fd21$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $58928da483d7fd21$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $fKAAs.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $g8WEt.Log.error("Failed to parse FallbackInfo");
        return null;
    }
}
function $58928da483d7fd21$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("65j6s", function(module, exports) {
"use strict";
var $46e20736fc9d295c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $46e20736fc9d295c$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $46e20736fc9d295c$var$DNS_QUERY_ENDPOINT = "https://cloudflare-dns.com/dns-query";
const $46e20736fc9d295c$var$DOMAIN_CHARS = [
    "i",
    "e",
    "d"
];
const $46e20736fc9d295c$var$MAX_START_LOOKUP = 200;
function $46e20736fc9d295c$var$_fetchTxtRecords(networkFunc) {
    return $46e20736fc9d295c$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($46e20736fc9d295c$var$DNS_QUERY_ENDPOINT, {
            method: "POST",
            headers: {
                "Content-Type": "application/dns-message",
                Accept: "application/dns-message"
            },
            body: $46e20736fc9d295c$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error("Failed to fetch TXT records from DNS");
            err.name = "DnsTxtFetchError";
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $46e20736fc9d295c$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $46e20736fc9d295c$var$_fetchTxtRecords;
function $46e20736fc9d295c$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $46e20736fc9d295c$var$MAX_START_LOOKUP && String.fromCharCode(byte) === "=" && $46e20736fc9d295c$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error("Failed to parse TXT records from DNS");
        err.name = "DnsTxtParseError";
        throw err;
    }
    // decode the remaining bytes as a string
    let result = "";
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(",");
}

});


parcelRegister("ekQ4B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $a6fb539e55e28502$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $a6fb539e55e28502$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $a6fb539e55e28502$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("iBcMN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $6HoVP = parcelRequire("6HoVP");

var $c2aJN = parcelRequire("c2aJN");

var $g8WEt = parcelRequire("g8WEt");

var $fKAAs = parcelRequire("fKAAs");

var $6gVGc = parcelRequire("6gVGc");
const $d8a599c31bcaee89$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $d8a599c31bcaee89$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $d8a599c31bcaee89$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($d8a599c31bcaee89$var$PROMISE_MAP[sdkKey] == null) $d8a599c31bcaee89$var$PROMISE_MAP[sdkKey] = $d8a599c31bcaee89$var$_loadSession(sdkKey);
        const session = $d8a599c31bcaee89$var$PROMISE_MAP[sdkKey];
        return $d8a599c31bcaee89$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $d8a599c31bcaee89$var$PROMISE_MAP[sdkKey] = $d8a599c31bcaee89$var$_overrideSessionId(override, sdkKey);
    }
};
function $d8a599c31bcaee89$var$_loadSession(sdkKey) {
    let data = $d8a599c31bcaee89$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $6gVGc.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $d8a599c31bcaee89$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $d8a599c31bcaee89$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($d8a599c31bcaee89$var$_isIdle(data) || $d8a599c31bcaee89$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $6gVGc.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }
    data.lastUpdate = now;
    $d8a599c31bcaee89$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $d8a599c31bcaee89$var$_createSessionTimeout(sdkKey, $d8a599c31bcaee89$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $d8a599c31bcaee89$var$_createSessionTimeout(sdkKey, $d8a599c31bcaee89$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $d8a599c31bcaee89$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $6HoVP._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: "session_expired"
        });
    }, duration);
}
function $d8a599c31bcaee89$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $d8a599c31bcaee89$var$MAX_SESSION_IDLE_TIME;
}
function $d8a599c31bcaee89$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $d8a599c31bcaee89$var$MAX_SESSION_AGE;
}
function $d8a599c31bcaee89$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $c2aJN._getStorageKey)(sdkKey)}`;
}
function $d8a599c31bcaee89$var$_persistToStorage(session, sdkKey) {
    const storageKey = $d8a599c31bcaee89$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $fKAAs._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $g8WEt.Log.warn("Failed to save SessionID");
    }
}
function $d8a599c31bcaee89$var$_loadFromStorage(sdkKey) {
    const storageKey = $d8a599c31bcaee89$var$_getSessionIDStorageKey(sdkKey);
    return (0, $fKAAs._getObjectFromStorage)(storageKey);
}

});

parcelRegister("dKQUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: "NetworkError"
};

});


parcelRegister("eAn3U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("89sy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("k6VhX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $ea40ce80328c5699$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $ea40ce80328c5699$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $ea40ce80328c5699$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === "object" && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $ea40ce80328c5699$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $ea40ce80328c5699$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $ea40ce80328c5699$var$_fastApproxSizeOf;

});

parcelRegister("dsrTl", function(module, exports) {
"use strict";
var $9cc38696b7a3d75c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $6HoVP = parcelRequire("6HoVP");

var $6HoVP = parcelRequire("6HoVP");

var $dllvA = parcelRequire("dllvA");

var $hclID = parcelRequire("hclID");

var $g8WEt = parcelRequire("g8WEt");

var $k3zZ4 = parcelRequire("k3zZ4");

var $hPuKI = parcelRequire("hPuKI");

var $iBcMN = parcelRequire("iBcMN");

var $7HFbw = parcelRequire("7HFbw");

var $c2Lgq = parcelRequire("c2Lgq");

var $fKAAs = parcelRequire("fKAAs");
const $9cc38696b7a3d75c$var$MAX_MEMO_CACHE_SIZE = 3000;
class $9cc38696b7a3d75c$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = "Uninitialized";
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($g8WEt.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $fKAAs.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $iBcMN.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $fKAAs.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $7HFbw.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $7HFbw.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $hclID.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $dllvA.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $fKAAs.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError("OA::loadFromStorage", e));
        this._primeReadyRipcord();
        $9cc38696b7a3d75c$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? "disabled" : "browser-only");
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $fKAAs.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $7HFbw.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($c2Lgq.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $9cc38696b7a3d75c$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: "pre_shutdown"
            });
            this._setStatus("Uninitialized", null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $g8WEt.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners["*"]) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: "values_updated",
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $k3zZ4.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $9cc38696b7a3d75c$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $9cc38696b7a3d75c$var$StatsigClientBase;
function $9cc38696b7a3d75c$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $hPuKI._isServerEnv)()) return;
    const statsigGlobal = (0, $6HoVP._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $g8WEt.Log.warn("Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.");
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("hFfJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = "statsig.cached";

});

parcelRegister("6Y0ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("03IQa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $g8WEt = parcelRequire("g8WEt");

var $66phf = parcelRequire("66phf");
function $00b3105315d3a6f0$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : "",
        __evaluation: evaluation,
        value: value
    };
}
function $00b3105315d3a6f0$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $00b3105315d3a6f0$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $00b3105315d3a6f0$var$_makeFeatureGate;
function $00b3105315d3a6f0$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $00b3105315d3a6f0$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $00b3105315d3a6f0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $00b3105315d3a6f0$var$_makeDynamicConfig;
function $00b3105315d3a6f0$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $00b3105315d3a6f0$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $00b3105315d3a6f0$var$_makeExperiment;
function $00b3105315d3a6f0$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $00b3105315d3a6f0$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $00b3105315d3a6f0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $00b3105315d3a6f0$var$_makeLayer;
function $00b3105315d3a6f0$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $00b3105315d3a6f0$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $00b3105315d3a6f0$var$_mergeOverride;
function $00b3105315d3a6f0$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $66phf._isTypeMatch)(found, fallback)) {
            $g8WEt.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $00b3105315d3a6f0$var$_makeTypedGet;

});

parcelRegister("Xgsr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("9NjL7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $7218045c3e43163b$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $7218045c3e43163b$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: "No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error."
};

});


parcelRegister("41hQI", function(module, exports) {
"use strict";
var $2ed519ebd8ef04f5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j59CT = parcelRequire("j59CT");

var $lzNzk = parcelRequire("lzNzk");

var $9m48f = parcelRequire("9m48f");

var $cHNMl = parcelRequire("cHNMl");

var $8v6UM = parcelRequire("8v6UM");
class $2ed519ebd8ef04f5$var$StatsigClient extends $j59CT.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $j59CT._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $2ed519ebd8ef04f5$var$StatsigClient) return instance;
        $j59CT.Log.warn((0, $j59CT._isServerEnv)() ? "StatsigClient.instance is not supported in server environments" : "Unable to find StatsigClient instance");
        return new $2ed519ebd8ef04f5$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "", {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $j59CT.SDKType._setClientType(sdkKey, "javascript-client");
        const network = new $9m48f.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $8v6UM.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($j59CT.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($j59CT.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($j59CT.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($j59CT.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($j59CT.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($j59CT.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $lzNzk.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $j59CT.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== "Uninitialized") return (0, $j59CT.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            "MultipleInitializations",
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $2ed519ebd8ef04f5$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push("NoCachedValues");
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === "Bootstrap") return (0, $j59CT.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $j59CT.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $2ed519ebd8ef04f5$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $2ed519ebd8ef04f5$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $j59CT.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus("Loading", result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $j59CT.createUpdateDetails)(false, this._store.getSource(), -1, new Error("User changed during update"), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $j59CT.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $j59CT.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($j59CT.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: "initialization_failure"
                });
            }
            $j59CT.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $j59CT.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $j59CT.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $j59CT.StatsigSession.get(this._sdkKey),
            stableID: $j59CT.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === "string" ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: "log_event_called",
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on("error", ()=>{
            this.loadingStatus === "Loading" && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $2ed519ebd8ef04f5$var$__awaiter(this, void 0, void 0, function*() {
            if (!$j59CT.Storage.isReady()) yield $j59CT.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $j59CT.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus("Ready", values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: "low"
        }).catch((err)=>{
            $j59CT.Log.error("An error occurred after update.", err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $j59CT._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $j59CT.StableID.setOverride(stableIdOverride, this._sdkKey);
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $j59CT._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $j59CT._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "gate_evaluation",
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $j59CT._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $j59CT._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "dynamic_config_evaluation",
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $j59CT._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $j59CT._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $j59CT._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: "experiment_evaluation",
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $j59CT._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $j59CT._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $j59CT._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: "layer_evaluation",
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $cHNMl._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $cHNMl._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $2ed519ebd8ef04f5$var$StatsigClient;

});
parcelRegister("lzNzk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j59CT = parcelRequire("j59CT");
class $fb53512f7b421967$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = "Uninitialized";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = "Loading";
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = "NoValues";
    }
    getValues() {
        return this._rawValues ? (0, $j59CT._typedJsonParse)(this._rawValues, "has_updates", "EvaluationStoreValues") : null;
    }
    setValues(result, user) {
        var _a;
        if (!result) return false;
        const values = (0, $j59CT._typedJsonParse)(result.data, "has_updates", "EvaluationResponse");
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $j59CT.SDKFlags.setFlags(this._sdkKey, (_a = values.sdk_flags) !== null && _a !== void 0 ? _a : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getConfigList() {
        var _a;
        if (!((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs)) return [];
        return Object.values(this._values.dynamic_configs).map((config)=>config.name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.exposures;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== "Bootstrap") return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $j59CT._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $j59CT.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add("StableIDMismatch");
            return;
        }
        if ("user" in values) {
            const bootstrapUser = values["user"];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $j59CT._getFullUserHash)(userForComparison) !== (0, $j59CT._getFullUserHash)(bootstrapUser)) this._warnings.add("PartialUserMatch");
        }
    }
    getCurrentSourceDetails() {
        if (this._source === "Uninitialized" || this._source === "NoValues") return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === "Bootstrap" && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== "Uninitialized" && reason !== "NoValues") {
            const subreason = isUnrecognized ? "Unrecognized" : "Recognized";
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === "Bootstrap" ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $fb53512f7b421967$var$EvaluationStore;

});

parcelRegister("9m48f", function(module, exports) {
"use strict";
var $6cf95fa89b702d9f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j59CT = parcelRequire("j59CT");

var $aLo7E = parcelRequire("aLo7E");
class $6cf95fa89b702d9f$var$StatsigNetwork extends $j59CT.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $j59CT.UrlConfiguration($j59CT.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $6cf95fa89b702d9f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $j59CT._typedJsonParse)(current, "has_updates", "InitializeResponse") : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : "djb2",
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : "djb2");
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: "derived_fields" in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $6cf95fa89b702d9f$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $aLo7E._resolveDeltasResponse)(cache, response.body);
            if (typeof result === "string") return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $6cf95fa89b702d9f$var$StatsigNetwork;

});
parcelRegister("aLo7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $j59CT = parcelRequire("j59CT");
const $7d61015d35cab0e5$var$MAX_DELTAS_SORT_DEPTH = 2;
function $7d61015d35cab0e5$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $j59CT._typedJsonParse)(deltasString, "checksum", "DeltasEvaluationResponse");
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $7d61015d35cab0e5$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $7d61015d35cab0e5$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $j59CT._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $7d61015d35cab0e5$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $7d61015d35cab0e5$var$_resolveDeltasResponse;
function $7d61015d35cab0e5$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $7d61015d35cab0e5$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $7d61015d35cab0e5$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $7d61015d35cab0e5$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $7d61015d35cab0e5$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $7d61015d35cab0e5$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("cHNMl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $j59CT = parcelRequire("j59CT");
const $94001d3986f7b044$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $94001d3986f7b044$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $94001d3986f7b044$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $j59CT._isTypeMatch)(value, fallback);
}
function $94001d3986f7b044$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $94001d3986f7b044$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $94001d3986f7b044$var$_shouldLogExposure(options) ? undefined : $94001d3986f7b044$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $94001d3986f7b044$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $94001d3986f7b044$var$_shouldLogExposure(options) ? undefined : $94001d3986f7b044$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($94001d3986f7b044$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $94001d3986f7b044$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $94001d3986f7b044$var$_shouldLogExposure(options) ? undefined : $94001d3986f7b044$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($94001d3986f7b044$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $94001d3986f7b044$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $94001d3986f7b044$var$_shouldLogExposure(options) ? undefined : $94001d3986f7b044$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($94001d3986f7b044$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $94001d3986f7b044$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $j59CT._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case "static":
                return $94001d3986f7b044$var$_getMappedStaticValue(param, options);
            case "gate":
                return $94001d3986f7b044$var$_getMappedGateValue(client, param, options);
            case "dynamic_config":
                return $94001d3986f7b044$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case "experiment":
                return $94001d3986f7b044$var$_getMappedExperimentValue(client, param, fallback, options);
            case "layer":
                return $94001d3986f7b044$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $94001d3986f7b044$var$_makeParamStoreGetter;

});

parcelRegister("8v6UM", function(module, exports) {
"use strict";
var $63069524838c87d0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $j59CT = parcelRequire("j59CT");

var $9m48f = parcelRequire("9m48f");
class $63069524838c87d0$var$StatsigEvaluationsDataAdapter extends $j59CT.DataAdapterCore {
    constructor(){
        super("EvaluationsDataAdapter", "evaluations");
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $9m48f.default) this._network = network;
        else this._network = new $9m48f.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $j59CT._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $j59CT._typedJsonParse)(data, "has_updates", "data");
        if (values && "user" in values) super.setData(data, values.user);
        else $j59CT.Log.error("StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.");
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $63069524838c87d0$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $j59CT._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$j59CT.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $j59CT._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $63069524838c87d0$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("7qNrp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56915019540c487c$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $kZv7b = parcelRequire("kZv7b");
function $56915019540c487c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56915019540c487c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56915019540c487c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56915019540c487c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56915019540c487c$export$a66cbd9b2289cd78 = "@all-features";
var $56915019540c487c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $i385U.default)(this, Subscriptions);
        (0, $dqOGO.default)(this, "eventToValue", new Map());
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($kZv7b)))();
    }
    return (0, $c19Op.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $56915019540c487c$var$_objectSpread($56915019540c487c$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $56915019540c487c$var$_objectSpread($56915019540c487c$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $56915019540c487c$var$_objectSpread($56915019540c487c$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $56915019540c487c$var$_objectSpread($56915019540c487c$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($56915019540c487c$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($56915019540c487c$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($56915019540c487c$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $56915019540c487c$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});
parcelRegister("kZv7b", function(module, exports) {
"use strict";
var $f481a3e403bb1ed3$var$has = Object.prototype.hasOwnProperty, $f481a3e403bb1ed3$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $f481a3e403bb1ed3$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $f481a3e403bb1ed3$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $f481a3e403bb1ed3$var$Events().__proto__) $f481a3e403bb1ed3$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $f481a3e403bb1ed3$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $f481a3e403bb1ed3$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $f481a3e403bb1ed3$var$EE(fn, context || emitter, once), evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $f481a3e403bb1ed3$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $f481a3e403bb1ed3$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $f481a3e403bb1ed3$var$EventEmitter() {
    this._events = new $f481a3e403bb1ed3$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($f481a3e403bb1ed3$var$has.call(events, name)) names.push($f481a3e403bb1ed3$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $f481a3e403bb1ed3$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $f481a3e403bb1ed3$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $f481a3e403bb1ed3$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $f481a3e403bb1ed3$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $f481a3e403bb1ed3$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $f481a3e403bb1ed3$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $f481a3e403bb1ed3$var$prefix ? $f481a3e403bb1ed3$var$prefix + event : event;
        if (this._events[evt]) $f481a3e403bb1ed3$var$clearEvent(this, evt);
    } else {
        this._events = new $f481a3e403bb1ed3$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$f481a3e403bb1ed3$var$EventEmitter.prototype.off = $f481a3e403bb1ed3$var$EventEmitter.prototype.removeListener;
$f481a3e403bb1ed3$var$EventEmitter.prototype.addListener = $f481a3e403bb1ed3$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$f481a3e403bb1ed3$var$EventEmitter.prefixed = $f481a3e403bb1ed3$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$f481a3e403bb1ed3$var$EventEmitter.EventEmitter = $f481a3e403bb1ed3$var$EventEmitter;
module.exports = $f481a3e403bb1ed3$var$EventEmitter;

});


parcelRegister("fYlfz", function(module, exports) {

$parcel$export(module.exports, "DynamicConfig", function () { return $ba0cf1745a3b0a7e$export$6dc24881a3d96325; });

var $8pSiD = parcelRequire("8pSiD");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $iAXQo = parcelRequire("iAXQo");
var $ba0cf1745a3b0a7e$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $i385U.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $c19Op.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? "array" : (0, $8pSiD.default)(defaultValue);
                var actualType = Array.isArray(val) ? "array" : (0, $8pSiD.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$__evaluat2, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $iAXQo.migrateEvaluationDetails)(experiment.details), (0, $iAXQo.migrateSecondaryExposures)((_experiment$__evaluat = (_experiment$__evaluat2 = experiment.__evaluation) === null || _experiment$__evaluat2 === void 0 ? void 0 : _experiment$__evaluat2.secondary_exposures) !== null && _experiment$__evaluat !== void 0 ? _experiment$__evaluat : []), (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("iAXQo", function(module, exports) {

$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $d89a028baa7c6afe$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $d89a028baa7c6afe$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $d89a028baa7c6afe$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $d89a028baa7c6afe$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $d89a028baa7c6afe$export$18ad168d3dbac899; });
$parcel$export(module.exports, "migrateSecondaryExposures", function () { return $d89a028baa7c6afe$export$55fd683752d01e67; });

var $6PaYK = parcelRequire("6PaYK");

var $jzYu7 = parcelRequire("jzYu7");

var $dqOGO = parcelRequire("dqOGO");

var $3g0T1 = parcelRequire("3g0T1");

var $k9w74 = parcelRequire("k9w74");

var $aDYvN = parcelRequire("aDYvN");
var $d89a028baa7c6afe$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $d89a028baa7c6afe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d89a028baa7c6afe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d89a028baa7c6afe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d89a028baa7c6afe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d89a028baa7c6afe$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $d89a028baa7c6afe$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $3g0T1.isFedRamp)() ? (0, $aDYvN.PerimeterType).FEDRAMP_MODERATE : (0, $aDYvN.PerimeterType).COMMERCIAL
    }, options);
};
var $d89a028baa7c6afe$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $jzYu7.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $jzYu7.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $jzYu7.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $jzYu7.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $d89a028baa7c6afe$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes) {
    var user = {
        customIDs: identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $d89a028baa7c6afe$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $6PaYK.default)(options, $d89a028baa7c6afe$var$_excluded);
    return $d89a028baa7c6afe$var$_objectSpread($d89a028baa7c6afe$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + "rgstr" : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === "undefined"
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $d89a028baa7c6afe$var$evaluationReasonMappings = Object.entries((0, $k9w74.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $jzYu7.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $d89a028baa7c6afe$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $d89a028baa7c6afe$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $jzYu7.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $k9w74.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};
var $d89a028baa7c6afe$export$55fd683752d01e67 = function migrateSecondaryExposures(secondaryExposures) {
    return secondaryExposures.map(function(exposure) {
        if (typeof exposure === "string") // This should ideally have gateValue and ruleID fields too, but it's not possible for us
        // to determine the correct values for these.
        return {
            gate: exposure
        };
        return exposure;
    });
};

});
parcelRegister("3g0T1", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $25f38dc377ef14a2$export$64d6499adf9b2e51; });

var $9Cuw7 = parcelRequire("9Cuw7");
function $25f38dc377ef14a2$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $9Cuw7.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("9Cuw7", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $700f55b58cd72555$export$ce553301d55c2fd8; });
var $700f55b58cd72555$export$ce553301d55c2fd8 = "fedramp-moderate";
var $700f55b58cd72555$export$f005e2e9f707cb5f = "commercial";
var $700f55b58cd72555$export$bd6b5a7802d76127 = "fedramp-fedex";
var $700f55b58cd72555$export$a739cd5aac835909 = "stg";
var $700f55b58cd72555$export$42dd0cdd351a4a9 = "prod";
var $700f55b58cd72555$export$404582bc18fe4d9e = "dev";

});


parcelRegister("k9w74", function(module, exports) {

$parcel$export(module.exports, "EvaluationReason", function () { return $eabd8ee4713aea40$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $eabd8ee4713aea40$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    // Order is important since the logic for migrating from a new client reason to an old one
    // returns the first which is a substring of the new client reason
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    // For when we could not migrate the reason from the new client
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("aDYvN", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $7bfc7c45c11f3268$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $7bfc7c45c11f3268$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $7bfc7c45c11f3268$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $7bfc7c45c11f3268$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $7bfc7c45c11f3268$export$42f4885608027d0c = "non_boolean"; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("3kT4C", function(module, exports) {

$parcel$export(module.exports, "Layer", function () { return $26ddf5d39cbe6ebb$export$936d0764594b6eb3; });

var $8pSiD = parcelRequire("8pSiD");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $iAXQo = parcelRequire("iAXQo");
var $26ddf5d39cbe6ebb$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "";
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $i385U.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $c19Op.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $8pSiD.default)(val) === (0, $8pSiD.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation$s, _layer$__evaluation, _layer$__evaluation$u, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $iAXQo.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (0, $iAXQo.migrateSecondaryExposures)((_layer$__evaluation$s = (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures) !== null && _layer$__evaluation$s !== void 0 ? _layer$__evaluation$s : []), (0, $iAXQo.migrateSecondaryExposures)((_layer$__evaluation$u = (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures) !== null && _layer$__evaluation$u !== void 0 ? _layer$__evaluation$u : []), (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("iVz86", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dc78cce96aeb39ec$export$2e2bcd8739ae039; });

var $dqOGO = parcelRequire("dqOGO");

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $aKGMT = parcelRequire("aKGMT");

var $aDYvN = parcelRequire("aDYvN");

var $bIWeV = parcelRequire("bIWeV");

var $hgah5 = parcelRequire("hgah5");
function $dc78cce96aeb39ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc78cce96aeb39ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc78cce96aeb39ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc78cce96aeb39ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $dc78cce96aeb39ec$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $dc78cce96aeb39ec$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $dc78cce96aeb39ec$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $dc78cce96aeb39ec$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $dc78cce96aeb39ec$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $dc78cce96aeb39ec$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $dc78cce96aeb39ec$export$4e8a0415edbfa1f7 = "https://atlassian-statsig-proxy-archetype.atl-paas.%s.atl-ic.net";
var $dc78cce96aeb39ec$export$cb3cd156f70d7e94 = "oasis-stg.com/flags";
var $dc78cce96aeb39ec$export$921fbc6cdfd4eee0 = "atlassian-isolated.net/flags";
var $dc78cce96aeb39ec$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $dc78cce96aeb39ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $i385U.default)(this, Fetcher);
    }
    return (0, $c19Op.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $hgah5.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $hgah5.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                var isolationContextId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                if (useGatewayUrl) return $dc78cce96aeb39ec$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $aDYvN.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $aDYvN.FeatureGateEnvironment).Production:
                        return $dc78cce96aeb39ec$export$18c93900db9358a4;
                    case (0, $aDYvN.FeatureGateEnvironment).Staging:
                        return $dc78cce96aeb39ec$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $aDYvN.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $aDYvN.FeatureGateEnvironment).Development:
                        return $dc78cce96aeb39ec$export$f058dbf75c3bc647;
                    case (0, $aDYvN.FeatureGateEnvironment).Staging:
                        var apiUrl = this.getApiUrl(isolationContextId);
                        if (apiUrl !== null) return apiUrl;
                        return $dc78cce96aeb39ec$export$942ba04389b0d5a2;
                    default:
                        var prodApiUrl = this.getApiUrl(isolationContextId);
                        if (prodApiUrl !== null) return prodApiUrl;
                        return $dc78cce96aeb39ec$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter, fetcherOptions.isolationContextId);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $dc78cce96aeb39ec$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $dc78cce96aeb39ec$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $bIWeV.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x0) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        },
        {
            key: "getApiUrl",
            value: function getApiUrl(isolationContextId) {
                var window1 = this.getWindowLocation();
                if (window1 === undefined) {
                    //this is needed when this SDK is used for SSR or plugin use cases where secret keys not available to use backend SDKs
                    if (!isolationContextId) return null;
                    return $dc78cce96aeb39ec$export$4e8a0415edbfa1f7.replace("%s", isolationContextId);
                }
                var protocol = window1.protocol, hostname = window1.hostname;
                // Match last subdomain fragment before oasis-stg.com
                var oasisMatch = hostname.match(/([^.]+)\.oasis-stg\.com$/);
                if (oasisMatch) return "".concat(protocol, "//api.").concat(oasisMatch[1], ".").concat($dc78cce96aeb39ec$export$cb3cd156f70d7e94);
                // Match last subdomain fragment before atlassian-isolated.net
                var isolatedMatch = hostname.match(/([^.]+)\.atlassian-isolated\.net$/);
                if (isolatedMatch) return "".concat(protocol, "//api.").concat(isolatedMatch[1], ".").concat($dc78cce96aeb39ec$export$921fbc6cdfd4eee0);
                return null;
            }
        },
        {
            key: "getWindowLocation",
            value: function getWindowLocation() {
                if (typeof window !== "undefined" && window.location) return window.location;
                return undefined;
            }
        }
    ]);
}();

});
parcelRegister("bIWeV", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $8890fafae443422a$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $8890fafae443422a$export$a59f8d67326bd1cb = "5.5.3";

});

parcelRegister("hgah5", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $c90be6a0c0889e11$export$286baf652d0b1206; });

var $c19Op = parcelRequire("c19Op");

var $i385U = parcelRequire("i385U");

var $5U5sG = parcelRequire("5U5sG");

var $lBHLA = parcelRequire("lBHLA");

var $5cxCk = parcelRequire("5cxCk");

var $adfss = parcelRequire("adfss");
function $c90be6a0c0889e11$var$_callSuper(t, o, e) {
    return o = (0, $lBHLA.default)(o), (0, $5U5sG.default)(t, $c90be6a0c0889e11$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lBHLA.default)(t).constructor) : o.apply(t, e));
}
function $c90be6a0c0889e11$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c90be6a0c0889e11$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c90be6a0c0889e11$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $i385U.default)(this, ResponseError);
        return $c90be6a0c0889e11$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $5cxCk.default)(ResponseError, _Error);
    return (0, $c19Op.default)(ResponseError);
}(/*#__PURE__*/ (0, $adfss.default)(Error));

});
parcelRegister("adfss", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76f71be4fdfb70fe$export$2e2bcd8739ae039; });

var $lBHLA = parcelRequire("lBHLA");

var $1lOcY = parcelRequire("1lOcY");

var $5N1hr = parcelRequire("5N1hr");

var $coINg = parcelRequire("coINg");
function $76f71be4fdfb70fe$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $76f71be4fdfb70fe$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $5N1hr.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $coINg.default)(t, arguments, (0, $lBHLA.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $1lOcY.default)(Wrapper, t);
    }, $76f71be4fdfb70fe$export$2e2bcd8739ae039(t);
}

});
parcelRegister("5N1hr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4372859ae7326067$export$2e2bcd8739ae039; });
function $4372859ae7326067$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("coINg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $906a78fe50d162e6$export$2e2bcd8739ae039; });

var $6tS8f = parcelRequire("6tS8f");

var $1lOcY = parcelRequire("1lOcY");
function $906a78fe50d162e6$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $6tS8f.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $1lOcY.default)(p, r.prototype), p;
}

});
parcelRegister("6tS8f", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b7f70ff099052fd$export$2e2bcd8739ae039; });
function $4b7f70ff099052fd$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4b7f70ff099052fd$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("brdI8", function(module, exports) {

$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $853cda00f4634f2b$export$55fffef3474104af; });

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $5U5sG = parcelRequire("5U5sG");

var $lBHLA = parcelRequire("lBHLA");

var $g32V5 = parcelRequire("g32V5");

var $5cxCk = parcelRequire("5cxCk");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $hRKKo = parcelRequire("hRKKo");
function $853cda00f4634f2b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $853cda00f4634f2b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $853cda00f4634f2b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $853cda00f4634f2b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $853cda00f4634f2b$var$_callSuper(t, o, e) {
    return o = (0, $lBHLA.default)(o), (0, $5U5sG.default)(t, $853cda00f4634f2b$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lBHLA.default)(t).constructor) : o.apply(t, e));
}
function $853cda00f4634f2b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($853cda00f4634f2b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $853cda00f4634f2b$var$_superPropGet(t, o, e, r) {
    var p = (0, $g32V5.default)((0, $lBHLA.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $853cda00f4634f2b$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $i385U.default)(this, NoFetchDataAdapter);
        _this = $853cda00f4634f2b$var$_callSuper(this, NoFetchDataAdapter, [
            "NoFetchDataAdapter",
            "nofetch"
        ]);
        (0, $dqOGO.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $5cxCk.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $c19Op.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: "Bootstrap",
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $hRKKo.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $853cda00f4634f2b$var$_objectSpread($853cda00f4634f2b$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $hRKKo._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $853cda00f4634f2b$var$_objectSpread($853cda00f4634f2b$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $hRKKo._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $hRKKo._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $hRKKo.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $853cda00f4634f2b$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $853cda00f4634f2b$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $hRKKo.DataAdapterCore));

});
parcelRegister("g32V5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $baef30f8b097cdd3$export$2e2bcd8739ae039; });

var $eIYfq = parcelRequire("eIYfq");
function $baef30f8b097cdd3$export$2e2bcd8739ae039() {
    return $baef30f8b097cdd3$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $eIYfq.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $baef30f8b097cdd3$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("eIYfq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab83e8ba1ff39626$export$2e2bcd8739ae039; });

var $lBHLA = parcelRequire("lBHLA");
function $ab83e8ba1ff39626$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $lBHLA.default)(t)););
    return t;
}

});



parcelRegister("fttHr", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $b4409a2a6c58b81d$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $b4409a2a6c58b81d$export$bcb28fbac1def494; });

var $dqOGO = parcelRequire("dqOGO");

var $jzYu7 = parcelRequire("jzYu7");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $j59CT = parcelRequire("j59CT");
function $b4409a2a6c58b81d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4409a2a6c58b81d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4409a2a6c58b81d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4409a2a6c58b81d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b4409a2a6c58b81d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $b4409a2a6c58b81d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $b4409a2a6c58b81d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $b4409a2a6c58b81d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $b4409a2a6c58b81d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $b4409a2a6c58b81d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $b4409a2a6c58b81d$var$LOCAL_OVERRIDE_REASON = "LocalOverride:Recognized";
var $b4409a2a6c58b81d$export$d8474cff104280f3 = "STATSIG_OVERRIDES";
var $b4409a2a6c58b81d$var$LEGACY_LOCAL_STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
var $b4409a2a6c58b81d$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $b4409a2a6c58b81d$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ":" + hash;
};
var $b4409a2a6c58b81d$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $i385U.default)(this, PersistentOverrideAdapter);
        this._overrides = $b4409a2a6c58b81d$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $c19Op.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $b4409a2a6c58b81d$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $b4409a2a6c58b81d$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $b4409a2a6c58b81d$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $jzYu7.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $jzYu7.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $jzYu7.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($b4409a2a6c58b81d$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($b4409a2a6c58b81d$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $b4409a2a6c58b81d$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $j59CT._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, $b4409a2a6c58b81d$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $jzYu7.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $jzYu7.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "gates"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "gates"));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($b4409a2a6c58b81d$var$djb2MapKey(current.name, "gates"));
                if (overridden == null) return null;
                return $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current.details), {}, {
                        reason: $b4409a2a6c58b81d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "configs"));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "layers"), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($b4409a2a6c58b81d$var$djb2MapKey((0, $j59CT._DJB2)(name), "layers"));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $b4409a2a6c58b81d$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($b4409a2a6c58b81d$var$djb2MapKey(current.name, "layers"));
                if (overridden == null) return null;
                return $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $j59CT._makeTypedGet)(current.name, overridden),
                    details: $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current.details), {}, {
                        reason: $b4409a2a6c58b81d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($b4409a2a6c58b81d$var$djb2MapKey(current.name, "configs"));
                if (overridden == null) return null;
                return $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $j59CT._makeTypedGet)(current.name, overridden),
                    details: $b4409a2a6c58b81d$var$_objectSpread($b4409a2a6c58b81d$var$_objectSpread({}, current.details), {}, {
                        reason: $b4409a2a6c58b81d$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("c9boa", function(module, exports) {

$parcel$export(module.exports, "containsDnDMutationInStyle", function () { return $8d7f28e0dbe07515$export$7867ddcf372cd2bf; });
$parcel$export(module.exports, "default", function () { return $8d7f28e0dbe07515$export$2e2bcd8739ae039; });
function $8d7f28e0dbe07515$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8d7f28e0dbe07515$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8d7f28e0dbe07515$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8d7f28e0dbe07515$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8d7f28e0dbe07515$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8d7f28e0dbe07515$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $8d7f28e0dbe07515$var$isDnDStyleChange = function isDnDStyleChange(style) {
    return style.startsWith("anchor-name: --node-anchor");
};
var $8d7f28e0dbe07515$var$parseStyleSet = function parseStyleSet(style) {
    if (!style) return null;
    var set = new Set();
    var _iterator = $8d7f28e0dbe07515$var$_createForOfIteratorHelper(style.split(";")), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var part = _step.value;
            var t = part.trim();
            if (t) set.add(t);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
};
/**
 * Checks if a mutation record represents a style change from Editor's
 * drag and drop feature, which don't cause visual shifts.
 * This should be removed once DnD has been fixed.
 * @param mutation - The mutation record to check
 * @returns boolean indicating if this is a DnD style mutation
 */ function $8d7f28e0dbe07515$export$e20e7bf2c822f3df(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    if (!(target instanceof Element)) return false;
    return $8d7f28e0dbe07515$export$7867ddcf372cd2bf({
        attributeName: attributeName,
        oldValue: oldValue,
        newValue: newValue
    });
}
function $8d7f28e0dbe07515$export$7867ddcf372cd2bf(_ref2) {
    var attributeName = _ref2.attributeName, oldValue = _ref2.oldValue, newValue = _ref2.newValue;
    if (attributeName !== "style") return false;
    var oldStyles = $8d7f28e0dbe07515$var$parseStyleSet(oldValue);
    var newStyles = $8d7f28e0dbe07515$var$parseStyleSet(newValue);
    var isDnDMutation = false;
    var _iterator2 = $8d7f28e0dbe07515$var$_createForOfIteratorHelper(oldStyles !== null && oldStyles !== void 0 ? oldStyles : []), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var s = _step2.value;
            if (!(newStyles !== null && newStyles !== void 0 && newStyles.has(s))) {
                if (!$8d7f28e0dbe07515$var$isDnDStyleChange(s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    var _iterator3 = $8d7f28e0dbe07515$var$_createForOfIteratorHelper(newStyles !== null && newStyles !== void 0 ? newStyles : []), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var _s = _step3.value;
            if (!(oldStyles !== null && oldStyles !== void 0 && oldStyles.has(_s))) {
                if (!$8d7f28e0dbe07515$var$isDnDStyleChange(_s)) return false;
                isDnDMutation = true;
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
    return isDnDMutation;
}
var $8d7f28e0dbe07515$export$2e2bcd8739ae039 = $8d7f28e0dbe07515$export$e20e7bf2c822f3df;

});

parcelRegister("yB9S8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $067ffff0c7ae1429$export$2e2bcd8739ae039; });

var $dqOGO = parcelRequire("dqOGO");

var $1m3mf = parcelRequire("1m3mf");

var $2sYxo = parcelRequire("2sYxo");

var $jzYu7 = parcelRequire("jzYu7");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $aKGMT = parcelRequire("aKGMT");

var $812Bk = parcelRequire("812Bk");

var $tg0pJ = parcelRequire("tg0pJ");

var $jDIhE = parcelRequire("jDIhE");

var $f0dWE = parcelRequire("f0dWE");
function $067ffff0c7ae1429$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $067ffff0c7ae1429$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $067ffff0c7ae1429$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $067ffff0c7ae1429$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $067ffff0c7ae1429$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $067ffff0c7ae1429$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $067ffff0c7ae1429$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $067ffff0c7ae1429$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $067ffff0c7ae1429$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $067ffff0c7ae1429$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Create comprehensive debug details including ignored entries
// Helper function for reporting ratios
function $067ffff0c7ae1429$var$roundDecimal(value) {
    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var factor = Math.pow(10, decimals);
    return Math.round(value * factor) / factor;
}
var $067ffff0c7ae1429$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AbstractVCCalculatorBase(revisionNo) {
        (0, $i385U.default)(this, AbstractVCCalculatorBase);
        this.revisionNo = revisionNo;
    }
    return (0, $c19Op.default)(AbstractVCCalculatorBase, [
        {
            key: "filterViewportEntries",
            value: function filterViewportEntries(entries) {
                return entries.filter(function(entry) {
                    return "rect" in entry.data;
                });
            }
        },
        {
            key: "calculateRatios",
            value: function calculateRatios(filteredEntries) {
                var ratios = {};
                var viewportWidth = (0, $f0dWE.default)();
                var viewportHeight = (0, $jDIhE.default)();
                var totalViewportArea = viewportWidth * viewportHeight;
                if (totalViewportArea === 0) return ratios;
                var elementRects = new Map();
                var _iterator = $067ffff0c7ae1429$var$_createForOfIteratorHelper(filteredEntries), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _entry = _step.value;
                        if ("rect" in _entry.data) {
                            var viewportEntry = _entry.data;
                            elementRects.set(viewportEntry.elementName, viewportEntry.rect);
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                var _iterator2 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(elementRects), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var _step2$value = (0, $jzYu7.default)(_step2.value, 2), elementName = _step2$value[0], rect = _step2$value[1];
                        var elementArea = rect.width * rect.height;
                        ratios[elementName] = $067ffff0c7ae1429$var$roundDecimal(elementArea / totalViewportArea);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return ratios;
            }
        },
        {
            key: "getLabelStacks",
            value: function getLabelStacks(filteredEntries, isPostInteraction) {
                var labelStacks = {};
                var _iterator3 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(filteredEntries), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _entry2 = _step3.value;
                        if ("elementName" in _entry2.data && _entry2.data.labelStacks) {
                            if (isPostInteraction) labelStacks[_entry2.data.elementName] = {
                                segment: _entry2.data.labelStacks.segment,
                                labelStack: _entry2.data.labelStacks.labelStack
                            };
                            else labelStacks[_entry2.data.elementName] = _entry2.data.labelStacks.labelStack;
                        }
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return labelStacks;
            }
        },
        {
            key: "calculateWithDebugInfo",
            value: function() {
                var _calculateWithDebugInfo = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, allEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders) {
                    var _window, _window2, _window3, _window4, _window6;
                    var percentiles, viewportEntries, _yield$calculateTTVCP, vcLogs, speedIndex, vcDetails, percentileIndex, entryDataBuffer, ssrRatio, layoutShiftInsights, previousViewportPercentage, _iterator4, _step4, _entry3, time, viewportPercentage, entries, elementNames, layoutShiftEntries, previousResult, i, percentile, enhancedVcLogs, shouldCalculate3p, shouldCalculateDebugDetails, sortedVcLogs, maxViewportPercentageAtTime, maxSoFar, _iterator5, _step5, log, getBiggestPreviousViewportPercentage, ignoredEntriesByTime, _iterator6, _step6, _entry4, _ignoredEntriesByTime, _viewportData$rect, _viewportData$previou, viewportData, timestamp, additionalVcLogs, _iterator7, _step7, _step7$value, _timestamp, ignoredEntries, _viewportPercentage, v3RevisionDebugDetails, _window5, _window5$__ufo_devtoo, _window7, _window7$__on_ufo_vc_;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                percentiles = [
                                    25,
                                    50,
                                    75,
                                    80,
                                    85,
                                    90,
                                    95,
                                    98,
                                    99,
                                    100
                                ];
                                viewportEntries = this.filterViewportEntries(filteredEntries);
                                _context.next = 4;
                                return (0, $812Bk.calculateTTVCPercentilesWithDebugInfo)({
                                    viewport: {
                                        width: (0, $f0dWE.default)(),
                                        height: (0, $jDIhE.default)()
                                    },
                                    startTime: startTime,
                                    stopTime: stopTime,
                                    orderedEntries: viewportEntries
                                });
                            case 4:
                                _yield$calculateTTVCP = _context.sent;
                                vcLogs = _yield$calculateTTVCP.entries;
                                speedIndex = _yield$calculateTTVCP.speedIndex;
                                vcDetails = {};
                                percentileIndex = 0;
                                entryDataBuffer = new Set();
                                ssrRatio = -1;
                                layoutShiftInsights = null;
                                previousViewportPercentage = 0;
                                if (!vcLogs) {
                                    _context.next = 35;
                                    break;
                                }
                                _iterator4 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(vcLogs);
                                _context.prev = 15;
                                _iterator4.s();
                            case 17:
                                if ((_step4 = _iterator4.n()).done) {
                                    _context.next = 27;
                                    break;
                                }
                                _entry3 = _step4.value;
                                time = _entry3.time, viewportPercentage = _entry3.viewportPercentage, entries = _entry3.entries;
                                if (includeSSRRatio && ssrRatio === -1 && entries.some(function(e) {
                                    return e.elementName === "SSR";
                                })) ssrRatio = viewportPercentage;
                                // Only process entries if we haven't reached all percentiles
                                if (!(percentileIndex >= percentiles.length)) {
                                    _context.next = 23;
                                    break;
                                }
                                return _context.abrupt("break", 27);
                            case 23:
                                // Check if this entry matches any checkpoint percentiles
                                if (viewportPercentage >= percentiles[percentileIndex]) {
                                    elementNames = (0, $1m3mf.default)(new Set(entries.map(function(e) {
                                        return e.elementName;
                                    }))); // Process all matching percentiles in one go
                                    while(percentileIndex < percentiles.length && viewportPercentage >= percentiles[percentileIndex]){
                                        vcDetails["".concat(percentiles[percentileIndex])] = {
                                            t: Math.round(time),
                                            e: elementNames
                                        };
                                        if (reportLayoutShiftOffenders && percentiles[percentileIndex] === 90 && entries.some(function(e) {
                                            return e.type === "layout-shift";
                                        })) {
                                            layoutShiftEntries = entries.filter(function(e) {
                                                return e.type === "layout-shift";
                                            });
                                            layoutShiftInsights = {
                                                layoutShiftOffendersResult: (0, $tg0pJ.detectLayoutShiftCause)({
                                                    viewportEntries: viewportEntries,
                                                    layoutShiftEntries: layoutShiftEntries,
                                                    time: time,
                                                    startTime: startTime
                                                }),
                                                layoutShiftEntriesCount: layoutShiftEntries.length,
                                                layoutShiftImpact: viewportPercentage - previousViewportPercentage
                                            };
                                        }
                                        percentileIndex++;
                                    }
                                    // Clear buffer after processing all matching percentiles
                                    entryDataBuffer.clear();
                                } else // Only add to buffer if we haven't reached all percentiles
                                entries.forEach(function(e) {
                                    return entryDataBuffer.add(e);
                                });
                                previousViewportPercentage = viewportPercentage;
                            case 25:
                                _context.next = 17;
                                break;
                            case 27:
                                _context.next = 32;
                                break;
                            case 29:
                                _context.prev = 29;
                                _context.t0 = _context["catch"](15);
                                _iterator4.e(_context.t0);
                            case 32:
                                _context.prev = 32;
                                _iterator4.f();
                                return _context.finish(32);
                            case 35:
                                // Fill in any missing percentiles with the last known values
                                previousResult = {
                                    t: 0,
                                    e: []
                                };
                                for(i = 0; i < percentiles.length; i++){
                                    percentile = percentiles[i];
                                    if (!(percentile in vcDetails)) vcDetails["".concat(percentile)] = previousResult;
                                    else previousResult = vcDetails["".concat(percentile)];
                                }
                                enhancedVcLogs = vcLogs ? vcLogs.map(function(log) {
                                    return $067ffff0c7ae1429$var$_objectSpread($067ffff0c7ae1429$var$_objectSpread({}, log), {}, {
                                        entries: log.entries.map(function(entry) {
                                            var _entry$rect, _entry$previousRect;
                                            return $067ffff0c7ae1429$var$_objectSpread($067ffff0c7ae1429$var$_objectSpread({}, entry), {}, {
                                                rect: (_entry$rect = entry.rect) === null || _entry$rect === void 0 ? void 0 : _entry$rect.toJSON(),
                                                previousRect: (_entry$previousRect = entry.previousRect) === null || _entry$previousRect === void 0 ? void 0 : _entry$previousRect.toJSON()
                                            });
                                        }),
                                        viewportPercentage: log.viewportPercentage
                                    });
                                }) : []; // If 3p metric enabled - calculate the debug details
                                shouldCalculate3p = include3p; // Only calculate enhanced debug details if devtool callbacks exist
                                shouldCalculateDebugDetails = !isPostInteraction && (typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.__ufo_devtool_onVCRevisionReady__) === "function" || typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.__on_ufo_vc_debug_data_ready) === "function" || typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.__ufo_devtool_vc_3p_debug_data) === "function");
                                if (shouldCalculateDebugDetails && allEntries && vcLogs) {
                                    // Pre-sort vcLogs by time for efficient lookups
                                    sortedVcLogs = (0, $1m3mf.default)(vcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    }); // Pre-calculate max viewport percentage up to each time for efficient lookups
                                    maxViewportPercentageAtTime = new Map();
                                    maxSoFar = 0;
                                    _iterator5 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(sortedVcLogs);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            log = _step5.value;
                                            if (log.viewportPercentage !== null) {
                                                maxSoFar = Math.max(maxSoFar, log.viewportPercentage);
                                                maxViewportPercentageAtTime.set(log.time, maxSoFar);
                                            }
                                        }
                                    // Helper function to find the biggest previous viewport percentage
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    getBiggestPreviousViewportPercentage = function getBiggestPreviousViewportPercentage(targetTime) {
                                        // Binary search for the largest time <= targetTime
                                        var left = 0;
                                        var right = sortedVcLogs.length - 1;
                                        var result = -1;
                                        while(left <= right){
                                            var mid = Math.floor((left + right) / 2);
                                            if (sortedVcLogs[mid].time <= targetTime) {
                                                result = mid;
                                                left = mid + 1;
                                            } else right = mid - 1;
                                        }
                                        return result >= 0 ? maxViewportPercentageAtTime.get(sortedVcLogs[result].time) || null : null;
                                    }; // Group ignored entries by timestamp
                                    ignoredEntriesByTime = new Map();
                                    _iterator6 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(allEntries);
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            _entry4 = _step6.value;
                                            if ("rect" in _entry4.data && !this.isEntryIncluded(_entry4, include3p, excludeSmartAnswersInSearch)) {
                                                viewportData = _entry4.data;
                                                timestamp = Math.round(_entry4.time);
                                                if (!ignoredEntriesByTime.has(timestamp)) ignoredEntriesByTime.set(timestamp, []);
                                                (_ignoredEntriesByTime = ignoredEntriesByTime.get(timestamp)) === null || _ignoredEntriesByTime === void 0 || _ignoredEntriesByTime.push($067ffff0c7ae1429$var$_objectSpread($067ffff0c7ae1429$var$_objectSpread({}, viewportData), {}, {
                                                    rect: (_viewportData$rect = viewportData.rect) === null || _viewportData$rect === void 0 ? void 0 : _viewportData$rect.toJSON(),
                                                    previousRect: (_viewportData$previou = viewportData.previousRect) === null || _viewportData$previou === void 0 ? void 0 : _viewportData$previou.toJSON(),
                                                    ignoreReason: viewportData.visible ? viewportData.type : "not-visible"
                                                }));
                                            }
                                        }
                                    // Add ignored entries to vcLogs
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                    additionalVcLogs = [];
                                    _iterator7 = $067ffff0c7ae1429$var$_createForOfIteratorHelper(ignoredEntriesByTime);
                                    try {
                                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                                            _step7$value = (0, $jzYu7.default)(_step7.value, 2), _timestamp = _step7$value[0], ignoredEntries = _step7$value[1];
                                            if (ignoredEntries.length > 0) {
                                                _viewportPercentage = getBiggestPreviousViewportPercentage(_timestamp);
                                                additionalVcLogs.push({
                                                    time: _timestamp,
                                                    viewportPercentage: _viewportPercentage,
                                                    entries: ignoredEntries
                                                });
                                            }
                                        }
                                    // Combine and sort all vcLogs
                                    } catch (err) {
                                        _iterator7.e(err);
                                    } finally{
                                        _iterator7.f();
                                    }
                                    enhancedVcLogs = [].concat((0, $1m3mf.default)(enhancedVcLogs), additionalVcLogs).sort(function(a, b) {
                                        return a.time - b.time;
                                    });
                                }
                                // Only create debug details if callbacks exist
                                v3RevisionDebugDetails = null;
                                if (shouldCalculateDebugDetails) v3RevisionDebugDetails = {
                                    revision: this.revisionNo,
                                    isClean: isVCClean && !interactionAbortReason && isPageVisible,
                                    abortReason: !isPageVisible ? "browser_backgrounded" : dirtyReason !== null && dirtyReason !== void 0 ? dirtyReason : interactionAbortReason,
                                    vcLogs: enhancedVcLogs,
                                    interactionId: interactionId,
                                    interactionType: interactionType
                                };
                                // Handle devtool callback
                                if (v3RevisionDebugDetails && typeof ((_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.__ufo_devtool_onVCRevisionReady__) === "function" && !include3p) try {
                                    (_window5 = window) === null || _window5 === void 0 || (_window5$__ufo_devtoo = _window5.__ufo_devtool_onVCRevisionReady__) === null || _window5$__ufo_devtoo === void 0 || _window5$__ufo_devtoo.call(_window5, v3RevisionDebugDetails);
                                } catch (e) {
                                    // if any error communicating with devtool, we don't want to break the app
                                    // eslint-disable-next-line no-console
                                    console.error("Error in onVCRevisionReady", e);
                                }
                                if (v3RevisionDebugDetails && typeof ((_window6 = window) === null || _window6 === void 0 ? void 0 : _window6.__on_ufo_vc_debug_data_ready) === "function" && !include3p) try {
                                    (_window7 = window) === null || _window7 === void 0 || (_window7$__on_ufo_vc_ = _window7.__on_ufo_vc_debug_data_ready) === null || _window7$__on_ufo_vc_ === void 0 || _window7$__on_ufo_vc_.call(_window7, v3RevisionDebugDetails);
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error("Error in onVCRevisionReady", e);
                                }
                                if (v3RevisionDebugDetails && shouldCalculate3p) try {
                                    // Log vc details with 3p for debugging
                                    window.__ufo_devtool_vc_3p_debug_data = v3RevisionDebugDetails;
                                } catch (e) {
                                    // eslint-disable-next-line no-console
                                    console.error("Error in 3pDebugData", e);
                                }
                                return _context.abrupt("return", {
                                    vcDetails: vcDetails,
                                    ssrRatio: ssrRatio,
                                    speedIndex: speedIndex,
                                    VC90layoutShiftInsights: layoutShiftInsights
                                });
                            case 47:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            15,
                            29,
                            32,
                            35
                        ]
                    ]);
                }));
                function calculateWithDebugInfo(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0, _x1, _x10, _x11, _x12, _x13) {
                    return _calculateWithDebugInfo.apply(this, arguments);
                }
                return calculateWithDebugInfo;
            }()
        },
        {
            key: "calculate",
            value: function() {
                var _calculate = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(_ref) {
                    var _this = this, _vcDetails$90$t, _vcDetails$;
                    var startTime, stopTime, orderedEntries, interactionId, isPostInteraction, include3p, excludeSmartAnswersInSearch, includeSSRRatio, interactionType, isPageVisible, interactionAbortReason, reportLayoutShiftOffenders, filteredEntries, isVCClean, dirtyReason, getVCCleanStatusResult, _yield$this$calculate, vcDetails, ssrRatio, speedIndex, VC90layoutShiftInsights, layoutShiftInsightsPayload, _layoutShiftOffenders, _layoutShiftOffenders2, _layoutShiftOffenders3, layoutShiftOffendersResult, layoutShiftEntriesCount, layoutShiftImpact, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                startTime = _ref.startTime, stopTime = _ref.stopTime, orderedEntries = _ref.orderedEntries, interactionId = _ref.interactionId, isPostInteraction = _ref.isPostInteraction, include3p = _ref.include3p, excludeSmartAnswersInSearch = _ref.excludeSmartAnswersInSearch, includeSSRRatio = _ref.includeSSRRatio, interactionType = _ref.interactionType, isPageVisible = _ref.isPageVisible, interactionAbortReason = _ref.interactionAbortReason, reportLayoutShiftOffenders = _ref.reportLayoutShiftOffenders;
                                filteredEntries = orderedEntries.filter(function(entry) {
                                    return _this.isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch);
                                });
                                getVCCleanStatusResult = this.getVCCleanStatus(filteredEntries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isVCClean) {
                                    _context2.next = 7;
                                    break;
                                }
                                return _context2.abrupt("return", {
                                    revision: this.revisionNo,
                                    "metric:vc90": null,
                                    clean: false,
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp
                                });
                            case 7:
                                _context2.next = 9;
                                return this.calculateWithDebugInfo(filteredEntries, startTime, stopTime, isPostInteraction, isVCClean, interactionType, isPageVisible, interactionId, dirtyReason, orderedEntries, include3p, excludeSmartAnswersInSearch, interactionAbortReason, includeSSRRatio, reportLayoutShiftOffenders);
                            case 9:
                                _yield$this$calculate = _context2.sent;
                                vcDetails = _yield$this$calculate.vcDetails;
                                ssrRatio = _yield$this$calculate.ssrRatio;
                                speedIndex = _yield$this$calculate.speedIndex;
                                VC90layoutShiftInsights = _yield$this$calculate.VC90layoutShiftInsights;
                                if (VC90layoutShiftInsights !== null && reportLayoutShiftOffenders) {
                                    layoutShiftOffendersResult = VC90layoutShiftInsights.layoutShiftOffendersResult, layoutShiftEntriesCount = VC90layoutShiftInsights.layoutShiftEntriesCount, layoutShiftImpact = VC90layoutShiftInsights.layoutShiftImpact;
                                    layoutShiftInsightsPayload = {
                                        impact: layoutShiftImpact,
                                        sources: layoutShiftEntriesCount !== null && layoutShiftEntriesCount !== void 0 ? layoutShiftEntriesCount : 0,
                                        same: {
                                            dir: (_layoutShiftOffenders = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameWay) !== null && _layoutShiftOffenders !== void 0 ? _layoutShiftOffenders : false,
                                            dist: (_layoutShiftOffenders2 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftVariables.allMovedSameAmount) !== null && _layoutShiftOffenders2 !== void 0 ? _layoutShiftOffenders2 : false
                                        },
                                        total_mut: (_layoutShiftOffenders3 = layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.length) !== null && _layoutShiftOffenders3 !== void 0 ? _layoutShiftOffenders3 : 0,
                                        mut: layoutShiftOffendersResult === null || layoutShiftOffendersResult === void 0 ? void 0 : layoutShiftOffendersResult.layoutShiftOffenders.sort(function(a, b) {
                                            return Math.abs(a.distanceToLS) - Math.abs(b.distanceToLS);
                                        }).slice(0, 5).map(function(offender) {
                                            return {
                                                e: offender.offender,
                                                size: -1,
                                                // @todo: calculate size
                                                attr: {
                                                    t_before: offender.happenedBefore,
                                                    t_distance: offender.distanceToLS,
                                                    p_above: offender.isAbove,
                                                    p_left: offender.isLeft,
                                                    p_right: offender.isRight,
                                                    p_h_overlap: offender.hasHorizontalOverlap,
                                                    p_v_overlap: offender.hasVerticalOverlap,
                                                    p_same_offset: offender.matchesLayoutShiftDelta ? "all" : "none"
                                                }
                                            };
                                        })
                                    };
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: true,
                                    "metric:vc90": (_vcDetails$90$t = vcDetails === null || vcDetails === void 0 || (_vcDetails$ = vcDetails["90"]) === null || _vcDetails$ === void 0 ? void 0 : _vcDetails$.t) !== null && _vcDetails$90$t !== void 0 ? _vcDetails$90$t : null,
                                    vcDetails: vcDetails !== null && vcDetails !== void 0 ? vcDetails : undefined,
                                    "vc90:ls": layoutShiftInsightsPayload !== null && layoutShiftInsightsPayload !== void 0 ? layoutShiftInsightsPayload : undefined
                                };
                                result.ratios = this.calculateRatios(filteredEntries);
                                if (ssrRatio !== -1) result.ssrRatio = ssrRatio;
                                // speedIndex is only included in the result when it has a meaningful value (> 0)
                                if (speedIndex > 0) result.speedIndex = speedIndex;
                                result.labelStacks = this.getLabelStacks(filteredEntries, isPostInteraction);
                                return _context2.abrupt("return", result);
                            case 21:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function calculate(_x14) {
                    return _calculate.apply(this, arguments);
                }
                return calculate;
            }()
        }
    ]);
}();

});
parcelRegister("812Bk", function(module, exports) {

$parcel$export(module.exports, "calculateTTVCPercentilesWithDebugInfo", function () { return $5d606f38ab01a199$export$96ea73435089b05a; });

var $jzYu7 = parcelRequire("jzYu7");

var $2sYxo = parcelRequire("2sYxo");

var $aKGMT = parcelRequire("aKGMT");

var $jxLBU = parcelRequire("jxLBU");

var $jyOmI = parcelRequire("jyOmI");
function $5d606f38ab01a199$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $5d606f38ab01a199$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $5d606f38ab01a199$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $5d606f38ab01a199$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $5d606f38ab01a199$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $5d606f38ab01a199$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $5d606f38ab01a199$var$calculateTTVCPercentiles(_x) {
    return $5d606f38ab01a199$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $5d606f38ab01a199$var$_calculateTTVCPercentiles() {
    $5d606f38ab01a199$var$_calculateTTVCPercentiles = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(_ref) {
        var viewport, orderedEntries, percentiles, startTime, canvas, elementMap, _iterator2, _step2, entry, rect, elementName, timePixelCounts, canvasDimenstions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    viewport = _ref.viewport, orderedEntries = _ref.orderedEntries, percentiles = _ref.percentiles, startTime = _ref.startTime;
                    canvas = new (0, $jyOmI.ViewportCanvas)(viewport, (0, $jxLBU.fg)("platform_ufo_canvas_heatmap_full_precision") ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator2 = $5d606f38ab01a199$var$_createForOfIteratorHelper(orderedEntries);
                    _context.prev = 4;
                    _iterator2.s();
                case 6:
                    if ((_step2 = _iterator2.n()).done) {
                        _context.next = 17;
                        break;
                    }
                    entry = _step2.value;
                    if ("rect" in entry.data) {
                        _context.next = 10;
                        break;
                    }
                    return _context.abrupt("continue", 15);
                case 10:
                    rect = entry.data.rect;
                    elementName = entry.data.elementName;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, new Set());
                    elementMap.get(entry.time).add(elementName);
                case 15:
                    _context.next = 6;
                    break;
                case 17:
                    _context.next = 22;
                    break;
                case 19:
                    _context.prev = 19;
                    _context.t0 = _context["catch"](4);
                    _iterator2.e(_context.t0);
                case 22:
                    _context.prev = 22;
                    _iterator2.f();
                    return _context.finish(22);
                case 25:
                    _context.next = 27;
                    return canvas.getPixelCounts();
                case 27:
                    timePixelCounts = _context.sent;
                    canvasDimenstions = canvas.getScaledDimensions();
                    totalPixels = canvasDimenstions.width * canvasDimenstions.height;
                    return _context.abrupt("return", $5d606f38ab01a199$export$89c8da9b65eff678(timePixelCounts, elementMap, percentiles, totalPixels, startTime));
                case 31:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                19,
                22,
                25
            ]
        ]);
    }));
    return $5d606f38ab01a199$var$_calculateTTVCPercentiles.apply(this, arguments);
}
function $5d606f38ab01a199$export$96ea73435089b05a(_x2) {
    return $5d606f38ab01a199$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
function $5d606f38ab01a199$var$_calculateTTVCPercentilesWithDebugInfo() {
    $5d606f38ab01a199$var$_calculateTTVCPercentilesWithDebugInfo = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(_ref2) {
        var viewport, orderedEntries, startTime, canvas, elementMap, _iterator3, _step3, entry, rect, timePixelCounts, canvasDimensions, totalPixels;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    viewport = _ref2.viewport, orderedEntries = _ref2.orderedEntries, startTime = _ref2.startTime;
                    canvas = new (0, $jyOmI.ViewportCanvas)(viewport, (0, $jxLBU.fg)("platform_ufo_canvas_heatmap_full_precision") ? 1 : 0.25);
                    elementMap = new Map();
                    _iterator3 = $5d606f38ab01a199$var$_createForOfIteratorHelper(orderedEntries);
                    _context2.prev = 4;
                    _iterator3.s();
                case 6:
                    if ((_step3 = _iterator3.n()).done) {
                        _context2.next = 16;
                        break;
                    }
                    entry = _step3.value;
                    if ("rect" in entry.data) {
                        _context2.next = 10;
                        break;
                    }
                    return _context2.abrupt("continue", 14);
                case 10:
                    rect = entry.data.rect;
                    canvas.drawRect(rect, entry.time);
                    if (!elementMap.has(entry.time)) elementMap.set(entry.time, []);
                    elementMap.get(entry.time).push(entry.data);
                case 14:
                    _context2.next = 6;
                    break;
                case 16:
                    _context2.next = 21;
                    break;
                case 18:
                    _context2.prev = 18;
                    _context2.t0 = _context2["catch"](4);
                    _iterator3.e(_context2.t0);
                case 21:
                    _context2.prev = 21;
                    _iterator3.f();
                    return _context2.finish(21);
                case 24:
                    _context2.next = 26;
                    return canvas.getPixelCounts();
                case 26:
                    timePixelCounts = _context2.sent;
                    canvasDimensions = canvas.getScaledDimensions();
                    totalPixels = canvasDimensions.width * canvasDimensions.height;
                    return _context2.abrupt("return", $5d606f38ab01a199$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime));
                case 30:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, null, [
            [
                4,
                18,
                21,
                24
            ]
        ]);
    }));
    return $5d606f38ab01a199$var$_calculateTTVCPercentilesWithDebugInfo.apply(this, arguments);
}
var $5d606f38ab01a199$export$2e2bcd8739ae039 = $5d606f38ab01a199$var$calculateTTVCPercentiles;
function $5d606f38ab01a199$export$89c8da9b65eff678(timePixelCounts, elementMap, unorderedPercentiles, totalPixels, startTime) {
    var results = {};
    var cumulativePixels = 0;
    var percentiles = unorderedPercentiles.sort(function(a, b) {
        return a - b;
    });
    // Sort entries by timestamp for consistent processing
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref3, _ref4) {
        var _ref5 = (0, $jzYu7.default)(_ref3, 1), timeA = _ref5[0];
        var _ref6 = (0, $jzYu7.default)(_ref4, 1), timeB = _ref6[0];
        return Number(timeA) - Number(timeB);
    });
    var percentileIndex = 0;
    var domElementsBuffer = new Set();
    var _iterator = $5d606f38ab01a199$var$_createForOfIteratorHelper(sortedEntries), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, $jzYu7.default)(_step.value, 2), time = _step$value[0], pixelCount = _step$value[1];
            cumulativePixels += pixelCount;
            var percentCovered = cumulativePixels / totalPixels * 100;
            var elementNames = elementMap.get(time) || new Set();
            elementNames.forEach(function(elName) {
                return domElementsBuffer.add(elName);
            });
            var matchesAnyCheckpoints = false;
            while(percentileIndex < percentiles.length && percentCovered >= percentiles[percentileIndex]){
                results["".concat(percentiles[percentileIndex])] = {
                    t: Math.round(Number(time - startTime)),
                    e: Array.from(domElementsBuffer)
                };
                percentileIndex++;
                matchesAnyCheckpoints = true;
            }
            if (matchesAnyCheckpoints) domElementsBuffer.clear();
            if (percentileIndex >= percentiles.length) break;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var previousResult = {
        t: 0,
        e: []
    };
    for(var i = 0; i < percentiles.length; i++){
        var percentile = percentiles[i];
        if (!(percentile in results)) results["".concat(percentile)] = previousResult;
        previousResult = results["".concat(percentile)];
    }
    return results;
}
function $5d606f38ab01a199$export$a532ce01ea38d882(timePixelCounts, elementMap, totalPixels, startTime) {
    var entries = new Array(elementMap.size);
    var cumulativePixels = 0;
    var speedIndex = 0;
    var previousPercentCovered = 0;
    var sortedEntries = Array.from(timePixelCounts.entries()).sort(function(_ref7, _ref8) {
        var _ref9 = (0, $jzYu7.default)(_ref7, 1), timeA = _ref9[0];
        var _ref0 = (0, $jzYu7.default)(_ref8, 1), timeB = _ref0[0];
        return Number(timeA) - Number(timeB);
    });
    for(var i = 0; i < sortedEntries.length; i++){
        var _sortedEntries$i = (0, $jzYu7.default)(sortedEntries[i], 2), time = _sortedEntries$i[0], pixelCount = _sortedEntries$i[1];
        cumulativePixels += pixelCount;
        var percentCovered = cumulativePixels / totalPixels * 100;
        var entryDatas = elementMap.get(time) || [];
        var relativeTime = Math.round(Number(time - startTime));
        entries[i] = {
            time: relativeTime,
            viewportPercentage: percentCovered,
            entries: Array.from(entryDatas)
        };
        // Speed index calculation: sum of (time × incremental viewport percentage)
        var ratioDelta = (percentCovered - previousPercentCovered) / 100;
        speedIndex += relativeTime * ratioDelta;
        previousPercentCovered = percentCovered;
    }
    return {
        entries: entries,
        speedIndex: Math.round(speedIndex)
    };
}

});
parcelRegister("jyOmI", function(module, exports) {

$parcel$export(module.exports, "ViewportCanvas", function () { return $e3d842ceac6186a9$export$3e59ac9de7402fb1; });

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $aKGMT = parcelRequire("aKGMT");

var $6lP48 = parcelRequire("6lP48");
var $e3d842ceac6186a9$export$3e59ac9de7402fb1 = /*#__PURE__*/ function() {
    /** The underlying Canvas instance (either OffscreenCanvas or HTMLCanvasElement) */ /** The 2D rendering context of the canvas */ /** Scale factor applied to the canvas (affects final pixel counts) */ /** Maps unique colors to their corresponding timestamps */ /** Counter used to generate unique colors */ /**
   * Creates a new ViewportCanvas instance.
   * @param viewport - The dimensions of the viewport
   * @param scaleFactor - Scale factor to apply to the canvas (default: 0.5)
   * @throws {Error} If canvas context cannot be obtained
   */ function ViewportCanvas(viewport) {
        var scaleFactor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        (0, $i385U.default)(this, ViewportCanvas);
        this.scaleFactor = scaleFactor;
        this.colorCounter = 1;
        this.colorTimeMap = new Map();
        var safeViewportWidth = Math.max(viewport.width, 1);
        var safeViewportHeight = Math.max(viewport.height, 1);
        // Calculate scaled dimensions
        this.scaledWidth = Math.max(Math.ceil(safeViewportWidth * scaleFactor), 1);
        this.scaledHeight = Math.max(Math.ceil(safeViewportHeight * scaleFactor), 1);
        this.scaleX = this.scaledWidth / safeViewportWidth;
        this.scaleY = this.scaledHeight / safeViewportHeight;
        // Initialize canvas with scaled dimensions
        this.canvas = this.createCanvas(this.scaledWidth, this.scaledHeight);
        var ctx = this.canvas.getContext("2d", {
            alpha: false,
            // Disable alpha channel for better performance
            willReadFrequently: true,
            // Optimize for frequent pixel reading
            colorSpace: "srgb" // Use standard RGB color space
        });
        if (!ctx) throw new Error("Could not get canvas context");
        this.ctx = ctx;
        this.ctx.globalCompositeOperation = "source-over";
        this.ctx.imageSmoothingEnabled = false; // Disable image smoothing for better performance
        this.clear();
    }
    /**
   * Creates a canvas instance, falling back to HTMLCanvasElement if OffscreenCanvas is not available
   */ return (0, $c19Op.default)(ViewportCanvas, [
        {
            key: "createCanvas",
            value: function createCanvas(width, height) {
                if (typeof OffscreenCanvas !== "undefined") return new OffscreenCanvas(width, height);
                var canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;
                return canvas;
            }
        },
        {
            key: "getScaledDimensions",
            value: function getScaledDimensions() {
                return {
                    width: this.scaledWidth,
                    height: this.scaledHeight
                };
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
            }
        },
        {
            key: "generateColor",
            value: function generateColor() {
                // Wrap around at 16,777,215 (0x00FFFFFF) to stay within 24-bit color space
                var rgbColor = this.colorCounter++ % 0x00ffffff;
                return $e3d842ceac6186a9$export$54591583ed0b20ce(rgbColor);
            }
        },
        {
            key: "drawRect",
            value: function drawRect(rect, timestamp) {
                var color = this.generateColor();
                this.colorTimeMap.set(color, timestamp);
                this.ctx.fillStyle = color;
                if (this.scaleFactor === 1) return this.ctx.fillRect(rect.x, rect.y, rect.width, rect.height);
                var scaledX = rect.x * this.scaleX;
                var scaledY = rect.y * this.scaleY;
                var scaledWidth = rect.width * this.scaleX;
                var scaledHeight = rect.height * this.scaleY;
                this.ctx.fillRect(Math.floor(scaledX), Math.ceil(scaledY), Math.max(scaledWidth, 1), Math.max(scaledHeight, 1));
            }
        },
        {
            key: "getPixelCounts",
            value: function() {
                var _getPixelCounts = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee() {
                    var imageData, timestampsAmount, pixelCounts, timePixelCounts, i, count, color, rgbColor, timestamp;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                imageData = this.ctx.getImageData(0, 0, this.canvas.width, this.canvas.height);
                                timestampsAmount = this.colorTimeMap.size;
                                _context.next = 4;
                                return $e3d842ceac6186a9$export$fafc9be44839f9c8(imageData, this.scaleFactor, timestampsAmount);
                            case 4:
                                pixelCounts = _context.sent;
                                // Convert color counts to timestamp counts
                                timePixelCounts = new Map();
                                i = 0;
                            case 7:
                                if (!(i < pixelCounts.length)) {
                                    _context.next = 18;
                                    break;
                                }
                                count = pixelCounts[i];
                                if (!(typeof count !== "number")) {
                                    _context.next = 11;
                                    break;
                                }
                                return _context.abrupt("continue", 15);
                            case 11:
                                color = i + 1;
                                rgbColor = $e3d842ceac6186a9$export$54591583ed0b20ce(color);
                                timestamp = this.colorTimeMap.get(rgbColor);
                                if (timestamp !== undefined) timePixelCounts.set(timestamp, (timePixelCounts.get(timestamp) || 0) + count);
                            case 15:
                                i++;
                                _context.next = 7;
                                break;
                            case 18:
                                return _context.abrupt("return", timePixelCounts);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getPixelCounts() {
                    return _getPixelCounts.apply(this, arguments);
                }
                return getPixelCounts;
            }()
        }
    ]);
}();
function $e3d842ceac6186a9$export$54591583ed0b20ce(n) {
    // Ensure the input is within the valid range for a 24-bit color
    if (n < 0 || n > 0xffffff) throw new Error("Input number must be between 0 and 16777215 (inclusive).");
    // Extract blue component (bits 0-7)
    var blue = n & 0xff;
    // Extract green component (bits 8-15)
    var green = n >> 8 & 0xff;
    // Extract red component (bits 16-23)
    var red = n >> 16 & 0xff;
    return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
}
function $e3d842ceac6186a9$export$fafc9be44839f9c8(_x, _x2, _x3) {
    return $e3d842ceac6186a9$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}
function $e3d842ceac6186a9$var$_calculateDrawnPixelsRaw() {
    $e3d842ceac6186a9$var$_calculateDrawnPixelsRaw = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2(imageData, _, arraySize) {
        var data, arr, i, color, colorIndex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    data = imageData.data;
                    arr = new Uint32Array(arraySize);
                    i = 0;
                case 3:
                    if (!(i < data.length)) {
                        _context2.next = 11;
                        break;
                    }
                    // Check alpha
                    if (data[i + 3] !== 0) {
                        // Combine RGB components into a single 24-bit color value:
                        // (data[i] << 16)   - Shift red component left 16 bits   (bits 16-23)
                        // (data[i + 1] << 8) - Shift green component left 8 bits (bits 8-15)
                        // data[i + 2]       - Blue component stays as is         (bits 0-7)
                        // The | operator combines all bits together
                        color = data[i] << 16 | data[i + 1] << 8 | data[i + 2];
                        colorIndex = color - 1;
                        arr[colorIndex] = (arr[colorIndex] || 0) + 1;
                    }
                    if (!(i % 10000 === 0)) {
                        _context2.next = 8;
                        break;
                    }
                    _context2.next = 8;
                    return (0, $6lP48.default)();
                case 8:
                    i += 4;
                    _context2.next = 3;
                    break;
                case 11:
                    return _context2.abrupt("return", arr);
                case 12:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return $e3d842ceac6186a9$var$_calculateDrawnPixelsRaw.apply(this, arguments);
}

});
parcelRegister("6lP48", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fc50d9d64d54a9$export$2e2bcd8739ae039; });

var $2sYxo = parcelRequire("2sYxo");

var $aKGMT = parcelRequire("aKGMT");
// See https://developer.mozilla.org/en-US/docs/Web/API/Prioritized_Task_Scheduling_API
function $49fc50d9d64d54a9$var$taskYield() {
    return $49fc50d9d64d54a9$var$_taskYield.apply(this, arguments);
}
function $49fc50d9d64d54a9$var$_taskYield() {
    $49fc50d9d64d54a9$var$_taskYield = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee() {
        var resolve, p;
        return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!("scheduler" in globalThis && // @ts-ignore
                    "yield" in globalThis.scheduler)) {
                        _context.next = 4;
                        break;
                    }
                    _context.next = 3;
                    return scheduler.yield();
                case 3:
                    return _context.abrupt("return");
                case 4:
                    resolve = function resolve() {};
                    p = new Promise(function(a) {
                        resolve = a;
                    });
                    setTimeout(resolve, 0);
                    _context.next = 9;
                    return p;
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return $49fc50d9d64d54a9$var$_taskYield.apply(this, arguments);
}
var $49fc50d9d64d54a9$export$2e2bcd8739ae039 = $49fc50d9d64d54a9$var$taskYield;

});



parcelRegister("tg0pJ", function(module, exports) {

$parcel$export(module.exports, "detectLayoutShiftCause", function () { return $057f1ff1384697c5$export$93ce39b765ea2cd3; });
function $057f1ff1384697c5$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $057f1ff1384697c5$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $057f1ff1384697c5$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $057f1ff1384697c5$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $057f1ff1384697c5$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $057f1ff1384697c5$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $057f1ff1384697c5$var$calculateOffenderState = function calculateOffenderState(current, matchesCurrentEntry) {
    // Once we know it's mixed across entries, we can short-circuit.
    if (current === "some") return "some";
    var entryState = matchesCurrentEntry ? "all" : "none";
    if (current == null) return entryState;
    // If the state flips between entries (all <-> none), it's "some".
    if (current !== entryState) return "some";
    return current;
};
var $057f1ff1384697c5$var$calculateLayoutShiftMovement = function calculateLayoutShiftMovement(layoutShiftEntries) {
    var movements = layoutShiftEntries.map(function(lsEntry) {
        var rect = lsEntry.rect;
        var previousRect = lsEntry.previousRect;
        if (!rect || !previousRect) return null;
        var dx = rect.x - previousRect.x;
        var dy = rect.y - previousRect.y;
        return {
            dx: dx,
            dy: dy,
            movedX: dx !== 0,
            movedY: dy !== 0,
            dirX: Math.sign(dx),
            dirY: Math.sign(dy),
            absDx: Math.abs(dx),
            absDy: Math.abs(dy)
        };
    });
    var hasMovement = function hasMovement(m) {
        return m !== null;
    };
    var validMovements = movements.filter(hasMovement);
    var allHaveRects = layoutShiftEntries.length > 0 && validMovements.length === layoutShiftEntries.length;
    if (!allHaveRects) return {
        allHaveRects: allHaveRects,
        allMovedSameWay: false,
        allMovedSameAmount: false
    };
    var first = validMovements[0];
    var allMovedSameWay = validMovements.every(function(m) {
        return m.movedX === first.movedX && m.movedY === first.movedY && m.dirX === first.dirX && m.dirY === first.dirY;
    });
    var allMovedSameAmount = allMovedSameWay && validMovements.every(function(m) {
        return m.absDx === first.absDx && m.absDy === first.absDy;
    });
    return {
        allHaveRects: allHaveRects,
        allMovedSameWay: allMovedSameWay,
        allMovedSameAmount: allMovedSameAmount,
        deltaX: first.dx,
        deltaY: first.dy
    };
};
var $057f1ff1384697c5$export$93ce39b765ea2cd3 = function detectLayoutShiftCause(_ref) {
    var viewportEntries = _ref.viewportEntries, layoutShiftEntries = _ref.layoutShiftEntries, time = _ref.time, startTime = _ref.startTime, _ref$offenderWindowMs = _ref.offenderWindowMs, offenderWindowMs = _ref$offenderWindowMs === void 0 ? 250 : _ref$offenderWindowMs;
    var checkpointTimestamp = startTime + time;
    var filteredLSPotentialOffenders = viewportEntries.filter(function(viewportEntry) {
        return (viewportEntry.time < checkpointTimestamp && viewportEntry.time > checkpointTimestamp - offenderWindowMs || viewportEntry.time > checkpointTimestamp && viewportEntry.time < checkpointTimestamp + offenderWindowMs) && viewportEntry.data.type !== "layout-shift";
    });
    // Summarize whether all layout-shift entries moved in a consistent direction and by the same amount.
    var layoutShiftVariables = $057f1ff1384697c5$var$calculateLayoutShiftMovement(layoutShiftEntries);
    // Classify each offender against *all* layout-shift entries when the layout shift is consistently moving in a
    // single axis (pure X or pure Y) so we can reason about whether an offender could have caused the movement.
    var layoutShiftOffenders = filteredLSPotentialOffenders.reduce(function(acc, offender) {
        var _offenderData$origina;
        var offenderData = offender.data;
        var offenderRect = offenderData.rect;
        if (!offenderRect) return acc;
        var offenderTimestamp = (_offenderData$origina = offenderData.originalMutationTimestamp) !== null && _offenderData$origina !== void 0 ? _offenderData$origina : offender.time;
        var happenedBefore = offenderTimestamp <= checkpointTimestamp;
        var offenderLeft = offenderRect.x;
        var offenderRight = offenderRect.x + offenderRect.width;
        var offenderTop = offenderRect.y;
        var offenderBottom = offenderRect.y + offenderRect.height;
        var shouldClassifyAgainstAllEntries = layoutShiftVariables.allMovedSameWay && "deltaX" in layoutShiftVariables && "deltaY" in layoutShiftVariables && layoutShiftVariables.deltaX === 0 !== (layoutShiftVariables.deltaY === 0);
        var isAbove = null;
        var isLeft = null;
        var isRight = null;
        var hasHorizontalOverlap = null;
        var hasVerticalOverlap = null;
        if (shouldClassifyAgainstAllEntries) {
            var _iterator = $057f1ff1384697c5$var$_createForOfIteratorHelper(layoutShiftEntries), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var lsEntry = _step.value;
                    var lsRect = lsEntry.rect;
                    if (!lsRect) continue;
                    var lsLeft = lsRect.x;
                    var lsRight = lsRect.x + lsRect.width;
                    var lsTop = lsRect.y;
                    var lsBottom = lsRect.y + lsRect.height;
                    isAbove = $057f1ff1384697c5$var$calculateOffenderState(isAbove, offenderBottom <= lsTop);
                    isLeft = $057f1ff1384697c5$var$calculateOffenderState(isLeft, offenderRight <= lsLeft);
                    isRight = $057f1ff1384697c5$var$calculateOffenderState(isRight, offenderLeft >= lsRight);
                    hasHorizontalOverlap = $057f1ff1384697c5$var$calculateOffenderState(hasHorizontalOverlap, offenderLeft < lsRight && offenderRight > lsLeft);
                    hasVerticalOverlap = $057f1ff1384697c5$var$calculateOffenderState(hasVerticalOverlap, offenderTop < lsBottom && offenderBottom > lsTop);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
        var matchesLayoutShiftDelta = false;
        if (shouldClassifyAgainstAllEntries && layoutShiftVariables.allMovedSameAmount && offenderData.previousRect) {
            var dx = offenderRect.x - offenderData.previousRect.x;
            var dy = offenderRect.y - offenderData.previousRect.y;
            var isPureX = layoutShiftVariables.deltaX !== 0 && layoutShiftVariables.deltaY === 0;
            var isPureY = layoutShiftVariables.deltaY !== 0 && layoutShiftVariables.deltaX === 0;
            if (isPureX) matchesLayoutShiftDelta = dx === layoutShiftVariables.deltaX && dy === 0;
            else if (isPureY) matchesLayoutShiftDelta = dy === layoutShiftVariables.deltaY && dx === 0;
        }
        acc.push({
            offender: offenderData.elementName,
            happenedBefore: happenedBefore,
            distanceToLS: Math.round(offenderTimestamp - checkpointTimestamp),
            isAbove: isAbove !== null && isAbove !== void 0 ? isAbove : "none",
            isLeft: isLeft !== null && isLeft !== void 0 ? isLeft : "none",
            isRight: isRight !== null && isRight !== void 0 ? isRight : "none",
            hasHorizontalOverlap: hasHorizontalOverlap !== null && hasHorizontalOverlap !== void 0 ? hasHorizontalOverlap : "none",
            hasVerticalOverlap: hasVerticalOverlap !== null && hasVerticalOverlap !== void 0 ? hasVerticalOverlap : "none",
            matchesLayoutShiftDelta: matchesLayoutShiftDelta
        });
        return acc;
    }, []);
    return {
        layoutShiftVariables: layoutShiftVariables,
        layoutShiftOffenders: layoutShiftOffenders
    };
};

});

parcelRegister("jDIhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4c402a899351f9c$export$2e2bcd8739ae039; });
function $e4c402a899351f9c$var$getViewportHeight() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (_unused) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}
var $e4c402a899351f9c$export$2e2bcd8739ae039 = $e4c402a899351f9c$var$getViewportHeight;

});

parcelRegister("f0dWE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aec1ac431ca7f323$export$2e2bcd8739ae039; });
function $aec1ac431ca7f323$var$getViewportWidth() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (_unused) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
var $aec1ac431ca7f323$export$2e2bcd8739ae039 = $aec1ac431ca7f323$var$getViewportWidth;

});


parcelRegister("gahJn", function(module, exports) {

$parcel$export(module.exports, "KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS", function () { return $bc4b558560302cb6$export$98812f4e79596e2b; });
$parcel$export(module.exports, "NON_VISUAL_ARIA_ATTRIBUTES", function () { return $bc4b558560302cb6$export$44331555a87fcd9e; });
$parcel$export(module.exports, "THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES", function () { return $bc4b558560302cb6$export$c4351da6279bef53; });
$parcel$export(module.exports, "MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES", function () { return $bc4b558560302cb6$export$2492353b2cc31cc0; });
$parcel$export(module.exports, "DARK_READER_BROWSER_EXTENSION_ATTRIBUTES", function () { return $bc4b558560302cb6$export$5a7b359ee5e32a5b; });
// TODO: AFO-3523
// Those are the attributes we have found when testing the 'fy25.03' manually.
// We still need to replace this hardcoded list with a proper automation
var $bc4b558560302cb6$export$98812f4e79596e2b = [
    "data-drop-target-for-element",
    "data-drop-target-for-external",
    "draggable",
    "data-is-observed",
    "data-aui-version",
    "data-testid",
    "data-vc",
    "data-ssr-placeholder",
    "data-ssr-placeholder-replace",
    "data-vc-nvs",
    "data-media-vc-wrapper",
    "data-renderer-start-pos",
    "data-table-local-id",
    "spellcheck",
    "data-auto-scrollable",
    "id",
    "tabindex",
    "data-is-ttvc-ready",
    "contenteditable",
    "data-has-collab-initialised",
    "translate"
];
var $bc4b558560302cb6$export$44331555a87fcd9e = [
    "aria-label",
    "aria-labelledby",
    "aria-describedby",
    "aria-hidden",
    "aria-expanded",
    "aria-controls",
    "aria-selected",
    "aria-checked",
    "aria-disabled",
    "aria-required",
    "aria-current",
    "aria-haspopup",
    "aria-pressed",
    "aria-atomic",
    "aria-live"
];
var $bc4b558560302cb6$export$c4351da6279bef53 = [
    "bis_skin_checked",
    "cz-shortcut-listen",
    "monica-version",
    "data-gr-ext-installed",
    "data-dashlane-rid",
    "sapling-installed",
    "data-gptw",
    // grammarly extensions
    "data-new-gr-c-s-loaded",
    "data-gr-aaa-notch-connection-id",
    "data-gr-aaa-loaded"
];
var $bc4b558560302cb6$export$2492353b2cc31cc0 = [
    "fdprocessedid",
    "data-dashlane-classification"
];
var $bc4b558560302cb6$export$5a7b359ee5e32a5b = [
    // dark reader extension
    "data-darkreader-inline-bgcolor",
    "data-darkreader-inline-bgimage",
    "data-darkreader-inline-border",
    "data-darkreader-inline-border-bottom",
    "data-darkreader-inline-border-left",
    "data-darkreader-inline-border-right",
    "data-darkreader-inline-border-top",
    "data-darkreader-inline-boxshadow",
    "data-darkreader-inline-color",
    "data-darkreader-inline-fill",
    "data-darkreader-inline-stroke",
    "data-darkreader-inline-outline",
    "data-darkreader-inline-stopcolor",
    "data-darkreader-inline-bg",
    "data-darkreader-inline-border-short",
    "data-darkreader-inline-border-bottom-short",
    "data-darkreader-inline-border-left-short",
    "data-darkreader-inline-border-right-short",
    "data-darkreader-inline-border-top-short"
];

});

parcelRegister("ls8zS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9e2ddd79781429d$export$2e2bcd8739ae039; });
function $f9e2ddd79781429d$var$isViewportEntryData(data) {
    if (data) {
        var hasElementName = typeof data.elementName === "string";
        var hasRect = typeof data.rect !== "undefined";
        if (hasRect && hasElementName) return true;
    }
    return false;
}
var $f9e2ddd79781429d$export$2e2bcd8739ae039 = $f9e2ddd79781429d$var$isViewportEntryData;

});


parcelRegister("dM1tG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a070e780aa744047$export$2e2bcd8739ae039; });

var $1m3mf = parcelRequire("1m3mf");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $5U5sG = parcelRequire("5U5sG");

var $lBHLA = parcelRequire("lBHLA");

var $g32V5 = parcelRequire("g32V5");

var $5cxCk = parcelRequire("5cxCk");

var $jxLBU = parcelRequire("jxLBU");

var $ipadY = parcelRequire("ipadY");

var $gahJn = parcelRequire("gahJn");
function $a070e780aa744047$var$_callSuper(t, o, e) {
    return o = (0, $lBHLA.default)(o), (0, $5U5sG.default)(t, $a070e780aa744047$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lBHLA.default)(t).constructor) : o.apply(t, e));
}
function $a070e780aa744047$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a070e780aa744047$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a070e780aa744047$var$_superPropGet(t, o, e, r) {
    var p = (0, $g32V5.default)((0, $lBHLA.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $a070e780aa744047$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [
        "mutation:display-contents-children-element"
    ];
    consideredEntryTypes.push("mutation:display-contents-children-attribute");
    return consideredEntryTypes;
};
var $a070e780aa744047$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [
        "layout-shift:same-rect",
        "mutation:attribute:non-visual-input-name"
    ];
    return excludedEntryTypes;
};
var $a070e780aa744047$var$fy26_04_excluded_attributes = [
    "data-is-hovered" // non-visual attribute
];
var $a070e780aa744047$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY25_) {
    function VCCalculator_FY26_04() {
        var revisionNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "fy26.04";
        (0, $i385U.default)(this, VCCalculator_FY26_04);
        return $a070e780aa744047$var$_callSuper(this, VCCalculator_FY26_04, [
            revisionNo
        ]);
    }
    (0, $5cxCk.default)(VCCalculator_FY26_04, _VCCalculator_FY25_);
    return (0, $c19Op.default)(VCCalculator_FY26_04, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var extra_fy26_04_excluded_attributes = (0, $jxLBU.fg)("platform_ufo_ignore_data_fabric_mode") ? [
                    "data-fabric-mode"
                ] : [];
                var entryData = entry.data;
                var attributeName = entryData.attributeName;
                if (entry.data.type === "mutation:attribute" && attributeName && extra_fy26_04_excluded_attributes.includes(attributeName)) return false;
                var isEntryIncludedInV3 = $a070e780aa744047$var$_superPropGet(VCCalculator_FY26_04, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV3 && !$a070e780aa744047$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                if (entry.data.type === "mutation:attribute" && (!attributeName || $a070e780aa744047$var$fy26_04_excluded_attributes.includes(attributeName) && (0, $jxLBU.fg)("platform_ufo_data-is-hovered-v4-exclusion"))) return false;
                var thirdPartyAttributes = [].concat((0, $1m3mf.default)((0, $gahJn.THIRD_PARTY_BROWSER_EXTENSION_ATTRIBUTES)), (0, $1m3mf.default)((0, $jxLBU.fg)("platform_ufo_exclude_dark_reader_extension") ? (0, $gahJn.DARK_READER_BROWSER_EXTENSION_ATTRIBUTES) : []), (0, $1m3mf.default)((0, $jxLBU.fg)("platform_ufo_exclude_fdprocessedid_attribute") ? (0, $gahJn.MORE_THIRD_PARTY_EXTENSION_ATTRIBUTES) : []));
                if (entryData.type === "mutation:display-contents-children-attribute") {
                    if (!attributeName || attributeName.startsWith("data-test") || (0, $gahJn.KNOWN_ATTRIBUTES_THAT_DOES_NOT_CAUSE_LAYOUT_SHIFTS).includes(attributeName) || (0, $gahJn.NON_VISUAL_ARIA_ATTRIBUTES).includes(attributeName) || thirdPartyAttributes.includes(attributeName)) return false;
                    return true;
                }
                return $a070e780aa744047$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        }
    ]);
}((0, $ipadY.default));

});

parcelRegister("j5w43", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de575b4b64b9a5ec$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $5U5sG = parcelRequire("5U5sG");

var $lBHLA = parcelRequire("lBHLA");

var $g32V5 = parcelRequire("g32V5");

var $5cxCk = parcelRequire("5cxCk");

var $dM1tG = parcelRequire("dM1tG");
function $de575b4b64b9a5ec$var$_callSuper(t, o, e) {
    return o = (0, $lBHLA.default)(o), (0, $5U5sG.default)(t, $de575b4b64b9a5ec$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $lBHLA.default)(t).constructor) : o.apply(t, e));
}
function $de575b4b64b9a5ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($de575b4b64b9a5ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $de575b4b64b9a5ec$var$_superPropGet(t, o, e, r) {
    var p = (0, $g32V5.default)((0, $lBHLA.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $de575b4b64b9a5ec$var$ABORTING_WINDOW_EVENT = [
    "wheel",
    "scroll",
    "keydown",
    "resize",
    "scroll-container"
];
var $de575b4b64b9a5ec$var$getConsideredEntryTypes = function getConsideredEntryTypes() {
    var consideredEntryTypes = [];
    return consideredEntryTypes;
};
var $de575b4b64b9a5ec$var$getExcludedEntryTypes = function getExcludedEntryTypes() {
    var excludedEntryTypes = [];
    return excludedEntryTypes;
};
var $de575b4b64b9a5ec$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_VCCalculator_FY26_) {
    function VCCalculator_Next() {
        (0, $i385U.default)(this, VCCalculator_Next);
        return $de575b4b64b9a5ec$var$_callSuper(this, VCCalculator_Next, [
            "next"
        ]);
    }
    (0, $5cxCk.default)(VCCalculator_Next, _VCCalculator_FY26_);
    return (0, $c19Op.default)(VCCalculator_Next, [
        {
            key: "isEntryIncluded",
            value: function isEntryIncluded(entry, include3p, excludeSmartAnswersInSearch) {
                var isEntryIncludedInV4 = $de575b4b64b9a5ec$var$_superPropGet(VCCalculator_Next, "isEntryIncluded", this, 3)([
                    entry,
                    include3p,
                    excludeSmartAnswersInSearch
                ]);
                if (isEntryIncludedInV4 && !$de575b4b64b9a5ec$var$getExcludedEntryTypes().includes(entry.data.type)) return true;
                return $de575b4b64b9a5ec$var$getConsideredEntryTypes().includes(entry.data.type);
            }
        },
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = "";
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === "window:event") {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($de575b4b64b9a5ec$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            if (eventType === "keydown") dirtyReason = "keypress";
                            else if (eventType === "scroll-container") dirtyReason = "scroll";
                            else dirtyReason = eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        }
    ]);
}((0, $dM1tG.default));

});

parcelRegister("c1W6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c22a5f844f1f663$export$2e2bcd8739ae039; });

var $1m3mf = parcelRequire("1m3mf");

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $2TVum = parcelRequire("2TVum");

var $jDIhE = parcelRequire("jDIhE");

var $f0dWE = parcelRequire("f0dWE");
function $8c22a5f844f1f663$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $8c22a5f844f1f663$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $8c22a5f844f1f663$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $8c22a5f844f1f663$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $8c22a5f844f1f663$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $8c22a5f844f1f663$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $8c22a5f844f1f663$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8c22a5f844f1f663$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8c22a5f844f1f663$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8c22a5f844f1f663$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8c22a5f844f1f663$var$ABORTING_WINDOW_EVENT = [
    "wheel",
    "scroll",
    "keydown",
    "resize"
];
var $8c22a5f844f1f663$var$MAX_OBSERVATIONS = 200;
var $8c22a5f844f1f663$var$encodeRect = function encodeRect(rect) {
    return [
        Math.round(rect.left * 10) / 10,
        Math.round(rect.top * 10) / 10,
        Math.round(rect.right * 10) / 10,
        Math.round(rect.bottom * 10) / 10
    ];
};
var $8c22a5f844f1f663$var$areRectsEqual = function areRectsEqual(left, right) {
    return left.every(function(value, index) {
        return value === right[index];
    });
};
function $8c22a5f844f1f663$var$isWindowEventEntryData(data) {
    return data.type === "window:event" && "eventType" in data;
}
var $8c22a5f844f1f663$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function RawDataHandler() {
        (0, $i385U.default)(this, RawDataHandler);
        (0, $dqOGO.default)(this, "revisionNo", "raw-handler");
    }
    return (0, $c19Op.default)(RawDataHandler, [
        {
            key: "getVCCleanStatus",
            value: function getVCCleanStatus(filteredEntries) {
                var dirtyReason = "";
                var abortTimestamp = -1;
                var hasAbortEvent = filteredEntries.some(function(entry) {
                    if (entry.data.type === "window:event") {
                        var data = entry.data;
                        var eventType = data.eventType;
                        if ($8c22a5f844f1f663$var$ABORTING_WINDOW_EVENT.includes(eventType)) {
                            dirtyReason = eventType === "keydown" ? "keypress" : eventType;
                            abortTimestamp = Math.round(entry.time);
                            return true;
                        }
                    }
                    return false;
                });
                if (hasAbortEvent && dirtyReason) return {
                    isVCClean: false,
                    dirtyReason: dirtyReason,
                    abortTimestamp: abortTimestamp
                };
                return {
                    isVCClean: true
                };
            }
        },
        {
            key: "getRawData",
            value: function() {
                var _getRawData = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(_ref) {
                    var entries, startTime, stopTime, isPageVisible, isVCClean, dirtyReason, getVCCleanStatusResult, _getEarliestHiddenTim, viewportEntries, windowEventEntries, targetNameToIdMap, elementMapEntriesMap, nextElementId, typeMap, typeMapEntriesMap, nextTypeId, attributeMap, attributeEntriesMap, nextAttributeId, eventTypeMap, eventTypeMapEntriesMap, nextEventTypeId, labelStacksMap, rawObservations, rawEventObservations, firstObservation, lastObservations, ssrEid, ssrObservation, ssrAlreadyIncluded, referencedEids, referencedChgs, referencedAtts, _iterator, _step, observation, _iterator2, _step2, eid, _iterator3, _step3, chg, _iterator4, _step4, att, firstEventObservation, lastEventObservations, referencedEvts, _iterator5, _step5, _observation, _iterator6, _step6, evt, result;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                entries = _ref.entries, startTime = _ref.startTime, stopTime = _ref.stopTime, isPageVisible = _ref.isPageVisible;
                                getVCCleanStatusResult = this.getVCCleanStatus(entries);
                                isVCClean = getVCCleanStatusResult.isVCClean;
                                dirtyReason = getVCCleanStatusResult.dirtyReason;
                                if (isPageVisible) {
                                    _context.next = 6;
                                    break;
                                }
                                return _context.abrupt("return", {
                                    revision: this.revisionNo,
                                    clean: false,
                                    "metric:vc90": null,
                                    abortReason: "browser_backgrounded",
                                    abortTimestamp: (_getEarliestHiddenTim = (0, $2TVum.getEarliestHiddenTiming)(startTime, stopTime)) !== null && _getEarliestHiddenTim !== void 0 ? _getEarliestHiddenTim : -1,
                                    viewport: {
                                        w: (0, $f0dWE.default)(),
                                        h: (0, $jDIhE.default)()
                                    }
                                });
                            case 6:
                                viewportEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && entry.data.visible;
                                });
                                windowEventEntries = entries.filter(function(entry) {
                                    return entry.time >= startTime && entry.time <= stopTime && entry.data && $8c22a5f844f1f663$var$isWindowEventEntryData(entry.data);
                                });
                                targetNameToIdMap = new Map();
                                elementMapEntriesMap = {};
                                nextElementId = 1;
                                typeMap = new Map();
                                typeMapEntriesMap = {};
                                nextTypeId = 1;
                                attributeMap = new Map();
                                attributeEntriesMap = {};
                                nextAttributeId = 1;
                                eventTypeMap = new Map();
                                eventTypeMapEntriesMap = {};
                                nextEventTypeId = 1;
                                labelStacksMap = {};
                                rawObservations = viewportEntries.map(function(entry) {
                                    var viewportEntry = entry.data;
                                    var targetName = viewportEntry.elementName || "";
                                    var type = viewportEntry.type || "";
                                    var rect = viewportEntry.rect;
                                    var attributeName = viewportEntry.attributeName || "";
                                    var eid = targetNameToIdMap.get(viewportEntry.elementName || "") || 0;
                                    if (eid === 0) {
                                        eid = nextElementId;
                                        nextElementId += 1;
                                        targetNameToIdMap.set(targetName, eid);
                                        elementMapEntriesMap[eid] = targetName;
                                    }
                                    // Capture labelStacks per element (only stored once per unique element)
                                    if (viewportEntry.labelStacks && !(eid in labelStacksMap)) {
                                        var labelInfo = {
                                            s: viewportEntry.labelStacks.segment,
                                            l: viewportEntry.labelStacks.labelStack
                                        };
                                        var shouldCompactImplicitUnknown = labelInfo.s === "unknown" && labelInfo.l === "unknown";
                                        labelStacksMap[eid] = shouldCompactImplicitUnknown ? "u" : labelInfo;
                                    }
                                    var chg = typeMap.get(type || "") || 0;
                                    if (chg === 0) {
                                        chg = nextTypeId;
                                        nextTypeId += 1;
                                        typeMap.set(type, chg);
                                        typeMapEntriesMap[chg] = type;
                                    }
                                    var att = 0;
                                    if (attributeName) {
                                        att = attributeMap.get(attributeName) || 0;
                                        if (att === 0) {
                                            att = nextAttributeId;
                                            nextAttributeId += 1;
                                            attributeMap.set(attributeName, att);
                                            attributeEntriesMap[att] = attributeName;
                                        }
                                    }
                                    var encodedRect = $8c22a5f844f1f663$var$encodeRect(rect);
                                    var encodedPreviousRect = viewportEntry.previousRect ? $8c22a5f844f1f663$var$encodeRect(viewportEntry.previousRect) : null;
                                    var shouldIncludePreviousRect = encodedPreviousRect === null || !$8c22a5f844f1f663$var$areRectsEqual(encodedRect, encodedPreviousRect);
                                    var observation = $8c22a5f844f1f663$var$_objectSpread($8c22a5f844f1f663$var$_objectSpread({
                                        t: Math.round(entry.time - startTime),
                                        r: encodedRect
                                    }, shouldIncludePreviousRect ? {
                                        pr: encodedPreviousRect
                                    } : {}), {}, {
                                        chg: chg,
                                        eid: eid || 0
                                    }, att > 0 ? {
                                        att: att
                                    } : {});
                                    return observation;
                                });
                                rawEventObservations = windowEventEntries.map(function(entry) {
                                    var windowEventEntry = entry.data;
                                    var eventType = windowEventEntry.eventType;
                                    var evtId = eventTypeMap.get(eventType) || 0;
                                    if (evtId === 0) {
                                        evtId = nextEventTypeId;
                                        nextEventTypeId += 1;
                                        eventTypeMap.set(eventType, evtId);
                                        eventTypeMapEntriesMap[evtId] = eventType;
                                    }
                                    var eventObservation = {
                                        t: Math.round(entry.time - startTime),
                                        evt: evtId
                                    };
                                    return eventObservation;
                                }); // If the number of observations is greater than the maximum allowed, we need to trim the observations to the maximum allowed.
                                // We do this by keeping the first observation, the SSR observation (if present), and the last MAX_OBSERVATIONS observations.
                                // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                                if (rawObservations.length > $8c22a5f844f1f663$var$MAX_OBSERVATIONS) {
                                    firstObservation = rawObservations[0];
                                    lastObservations = rawObservations.slice(-$8c22a5f844f1f663$var$MAX_OBSERVATIONS); // Find the SSR observation by looking up the eid that corresponds to 'SSR' element name
                                    ssrEid = targetNameToIdMap.get("SSR");
                                    ssrObservation = ssrEid ? rawObservations.find(function(obs) {
                                        return obs.eid === ssrEid && obs !== firstObservation;
                                    }) : undefined; // Include SSR observation if it exists and is not already in the kept observations
                                    ssrAlreadyIncluded = ssrObservation && lastObservations.some(function(obs) {
                                        return obs === ssrObservation;
                                    });
                                    rawObservations = [
                                        firstObservation
                                    ].concat((0, $1m3mf.default)(ssrObservation && !ssrAlreadyIncluded ? [
                                        ssrObservation
                                    ] : []), (0, $1m3mf.default)(lastObservations));
                                    // Collect referenced IDs from remaining observations
                                    referencedEids = new Set();
                                    referencedChgs = new Set();
                                    referencedAtts = new Set();
                                    _iterator = $8c22a5f844f1f663$var$_createForOfIteratorHelper(rawObservations);
                                    try {
                                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                                            observation = _step.value;
                                            if (observation.eid > 0) referencedEids.add(observation.eid);
                                            if (typeof observation.chg === "number" && observation.chg > 0) referencedChgs.add(observation.chg);
                                            if (observation.att !== undefined && observation.att > 0) referencedAtts.add(observation.att);
                                        }
                                    // Remove unreferenced entries from maps
                                    } catch (err) {
                                        _iterator.e(err);
                                    } finally{
                                        _iterator.f();
                                    }
                                    _iterator2 = $8c22a5f844f1f663$var$_createForOfIteratorHelper(Object.keys(elementMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                            eid = _step2.value;
                                            if (!referencedEids.has(eid)) {
                                                delete elementMapEntriesMap[eid];
                                                delete labelStacksMap[eid];
                                            }
                                        }
                                    } catch (err) {
                                        _iterator2.e(err);
                                    } finally{
                                        _iterator2.f();
                                    }
                                    _iterator3 = $8c22a5f844f1f663$var$_createForOfIteratorHelper(Object.keys(typeMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                                            chg = _step3.value;
                                            if (!referencedChgs.has(chg)) delete typeMapEntriesMap[chg];
                                        }
                                    } catch (err) {
                                        _iterator3.e(err);
                                    } finally{
                                        _iterator3.f();
                                    }
                                    _iterator4 = $8c22a5f844f1f663$var$_createForOfIteratorHelper(Object.keys(attributeEntriesMap).map(Number));
                                    try {
                                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                            att = _step4.value;
                                            if (!referencedAtts.has(att)) delete attributeEntriesMap[att];
                                        }
                                    } catch (err) {
                                        _iterator4.e(err);
                                    } finally{
                                        _iterator4.f();
                                    }
                                }
                                // If the number of event observations is greater than the maximum allowed, we need to trim the event observations to the maximum allowed.
                                // We do this by keeping the first observation and the last MAX_OBSERVATIONS observations.
                                // We then collect the referenced IDs from the remaining observations and remove the unreferenced entries from the maps
                                if (rawEventObservations.length > $8c22a5f844f1f663$var$MAX_OBSERVATIONS) {
                                    firstEventObservation = rawEventObservations[0];
                                    lastEventObservations = rawEventObservations.slice(-$8c22a5f844f1f663$var$MAX_OBSERVATIONS);
                                    rawEventObservations = [
                                        firstEventObservation
                                    ].concat((0, $1m3mf.default)(lastEventObservations));
                                    // Collect referenced IDs from remaining observations
                                    referencedEvts = new Set();
                                    _iterator5 = $8c22a5f844f1f663$var$_createForOfIteratorHelper(rawEventObservations);
                                    try {
                                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                            _observation = _step5.value;
                                            if (_observation.evt > 0) referencedEvts.add(_observation.evt);
                                        }
                                    // Remove unreferenced entries from maps
                                    } catch (err) {
                                        _iterator5.e(err);
                                    } finally{
                                        _iterator5.f();
                                    }
                                    _iterator6 = $8c22a5f844f1f663$var$_createForOfIteratorHelper(Object.keys(eventTypeMapEntriesMap).map(Number));
                                    try {
                                        for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                                            evt = _step6.value;
                                            if (!referencedEvts.has(evt)) delete eventTypeMapEntriesMap[evt];
                                        }
                                    } catch (err) {
                                        _iterator6.e(err);
                                    } finally{
                                        _iterator6.f();
                                    }
                                }
                                result = {
                                    revision: this.revisionNo,
                                    clean: isVCClean,
                                    "metric:vc90": null,
                                    rawData: {
                                        obs: rawObservations !== null && rawObservations !== void 0 ? rawObservations : undefined,
                                        eid: elementMapEntriesMap !== null && elementMapEntriesMap !== void 0 ? elementMapEntriesMap : undefined,
                                        chg: typeMapEntriesMap !== null && typeMapEntriesMap !== void 0 ? typeMapEntriesMap : undefined,
                                        att: attributeEntriesMap !== null && attributeEntriesMap !== void 0 ? attributeEntriesMap : undefined,
                                        evts: rawEventObservations.length > 0 ? rawEventObservations : undefined,
                                        evt: Object.keys(eventTypeMapEntriesMap).length > 0 ? eventTypeMapEntriesMap : undefined,
                                        lbl: Object.keys(labelStacksMap).length > 0 ? labelStacksMap : undefined,
                                        lblMode: Object.keys(labelStacksMap).length > 0 ? "sentinel-v1" : undefined
                                    },
                                    abortReason: dirtyReason,
                                    abortTimestamp: getVCCleanStatusResult.abortTimestamp,
                                    viewport: {
                                        w: (0, $f0dWE.default)(),
                                        h: (0, $jDIhE.default)()
                                    }
                                };
                                return _context.abrupt("return", result);
                            case 27:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function getRawData(_x) {
                    return _getRawData.apply(this, arguments);
                }
                return getRawData;
            }()
        }
    ]);
}();

});

parcelRegister("h5rlm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7081d2a6f7dfaaf$export$2e2bcd8739ae039; });

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $lLzX6 = parcelRequire("lLzX6");

var $c9boa = parcelRequire("c9boa");

var $7GQjF = parcelRequire("7GQjF");

var $6mgdS = parcelRequire("6mgdS");

var $gp9N4 = parcelRequire("gp9N4");

var $5k2oH = parcelRequire("5k2oH");

var $d4XtI = parcelRequire("d4XtI");

var $bZcvC = parcelRequire("bZcvC");

var $iYjll = parcelRequire("iYjll");

var $keFxD = parcelRequire("keFxD");

var $cW52z = parcelRequire("cW52z");

var $jg1cY = parcelRequire("jg1cY");

var $h45m4 = parcelRequire("h45m4");

var $960S0 = parcelRequire("960S0");
function $c7081d2a6f7dfaaf$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $c7081d2a6f7dfaaf$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $c7081d2a6f7dfaaf$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $c7081d2a6f7dfaaf$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $c7081d2a6f7dfaaf$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $c7081d2a6f7dfaaf$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $c7081d2a6f7dfaaf$var$createElementMutationsWatcher = function createElementMutationsWatcher(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref) {
        var target = _ref.target, rect = _ref.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return "ssr-hydration";
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return "ssr-hydration";
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return "mutation:ssr-placeholder";
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return "mutation:ssr-placeholder";
            }
        }
        if (hasSameDeletedNode && (0, $cW52z.default)(target)) return "mutation:remount";
        if ((0, $lLzX6.isContainedWithinMediaWrapper)(target)) return "mutation:media";
        if (isWithinThirdPartySegment) return "mutation:third-party-element";
        if (isWithinSmartAnswersSegment) return "mutation:smart-answers-element";
        var isInIgnoreLsMarker = (0, $cW52z.default)(target);
        if (!isInIgnoreLsMarker) return "mutation:element";
        var isRLLPlaceholder = (0, $6mgdS.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return "mutation:rll-placeholder";
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $h45m4.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return "mutation:element-replacement";
        return "mutation:element";
    };
};
var $c7081d2a6f7dfaaf$var$createElementMutationsWatcherNew = function createElementMutationsWatcherNew(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, hasSameDeletedNode, timestamp, isTargetReactRoot, getSSRState, getSSRPlaceholderHandler) {
    return function(_ref2) {
        var target = _ref2.target, rect = _ref2.rect;
        if (getSSRState) {
            var ssrState = getSSRState();
            var SSRStateEnum = {
                normal: 1,
                waitingForFirstRender: 2,
                ignoring: 3
            };
            if (ssrState.state === SSRStateEnum.waitingForFirstRender && timestamp > ssrState.renderStart && isTargetReactRoot) {
                ssrState.state = SSRStateEnum.ignoring;
                if (ssrState.renderStop === -1) // arbitrary 500ms DOM update window
                ssrState.renderStop = timestamp + 500;
                return {
                    type: "ssr-hydration",
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
            if (ssrState.state === SSRStateEnum.ignoring && timestamp > ssrState.renderStart && isTargetReactRoot) {
                if (timestamp <= ssrState.renderStop) return {
                    type: "ssr-hydration",
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                else ssrState.state = SSRStateEnum.normal;
            }
        }
        if (getSSRPlaceholderHandler) {
            var ssrPlaceholderHandler = getSSRPlaceholderHandler();
            if (ssrPlaceholderHandler) {
                if ((ssrPlaceholderHandler.isPlaceholderV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.checkIfExistedAndSizeMatchingV3(target)) return {
                    type: "mutation:ssr-placeholder",
                    mutationData: {
                        timestamp: timestamp
                    }
                };
                if ((ssrPlaceholderHandler.isPlaceholderReplacementV4(target) || ssrPlaceholderHandler.isPlaceholderIgnored(target)) && ssrPlaceholderHandler.validateReactComponentMatchToPlaceholderV4(target)) return {
                    type: "mutation:ssr-placeholder",
                    mutationData: {
                        timestamp: timestamp
                    }
                };
            }
        }
        if (hasSameDeletedNode && (0, $cW52z.default)(target)) return {
            type: "mutation:remount",
            mutationData: {
                timestamp: timestamp
            }
        };
        if ((0, $lLzX6.isContainedWithinMediaWrapper)(target)) return {
            type: "mutation:media",
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinThirdPartySegment) return {
            type: "mutation:third-party-element",
            mutationData: {
                timestamp: timestamp
            }
        };
        if (isWithinSmartAnswersSegment) return {
            type: "mutation:smart-answers-element",
            mutationData: {
                timestamp: timestamp
            }
        };
        var isInIgnoreLsMarker = (0, $cW52z.default)(target);
        if (!isInIgnoreLsMarker) return {
            type: "mutation:element",
            mutationData: {
                timestamp: timestamp
            }
        };
        var isRLLPlaceholder = (0, $6mgdS.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
        if (isRLLPlaceholder && isInIgnoreLsMarker) return {
            type: "mutation:rll-placeholder",
            mutationData: {
                timestamp: timestamp
            }
        };
        var wasDeleted = removedNodeRects.some(function(nr) {
            return (0, $h45m4.isSameRectDimensions)(nr, rect);
        });
        if (wasDeleted && isInIgnoreLsMarker) return {
            type: "mutation:element-replacement",
            mutationData: {
                timestamp: timestamp
            }
        };
        return {
            type: "mutation:element",
            mutationData: {
                timestamp: timestamp
            }
        };
    };
};
var $c7081d2a6f7dfaaf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    // SSR context functions
    function ViewportObserver(_ref3) {
        var _this = this;
        var onChange = _ref3.onChange, getSSRState = _ref3.getSSRState, getSSRPlaceholderHandler = _ref3.getSSRPlaceholderHandler, _ref3$trackLayoutShif = _ref3.trackLayoutShiftOffenders, trackLayoutShiftOffenders = _ref3$trackLayoutShif === void 0 ? false : _ref3$trackLayoutShif, searchPageConfig = _ref3.searchPageConfig;
        (0, $i385U.default)(this, ViewportObserver);
        (0, $dqOGO.default)(this, "handleIntersectionEntry", function(_ref4) {
            var target = _ref4.target, rect = _ref4.rect, time = _ref4.time, type = _ref4.type, mutationData = _ref4.mutationData;
            if (!target) return;
            var visible = (0, $keFxD.isElementVisible)(target);
            var lastElementRect = _this.mapVisibleNodeRects.get(target);
            _this.mapVisibleNodeRects.set(target, rect);
            _this.onChange({
                time: time,
                type: type,
                elementRef: new WeakRef(target),
                visible: visible,
                rect: rect,
                previousRect: lastElementRect,
                mutationData: mutationData
            });
        });
        (0, $dqOGO.default)(this, "handleChildListMutation", /*#__PURE__*/ function() {
            var _ref6 = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee(_ref5) {
                var target, addedNodes, removedNodes, timestamp, removedNodeRects, targetNode, _iterator, _step, _loop;
                return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context2) {
                    while(true)switch(_context2.prev = _context2.next){
                        case 0:
                            target = _ref5.target, addedNodes = _ref5.addedNodes, removedNodes = _ref5.removedNodes, timestamp = _ref5.timestamp;
                            removedNodeRects = removedNodes.map(function(ref) {
                                var n = ref.deref();
                                if (!n) return;
                                return _this.mapVisibleNodeRects.get(n);
                            });
                            targetNode = target.deref();
                            _iterator = $c7081d2a6f7dfaaf$var$_createForOfIteratorHelper(addedNodes);
                            _context2.prev = 4;
                            _loop = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _loop() {
                                var _this$getSSRState, _this$intersectionObs;
                                var addedNodeRef, addedNode, hasSameDeletedNode, _checkWithinComponent, isWithinThirdPartySegment, isWithinSmartAnswersSegment, isTargetReactRoot;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _loop$(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            addedNodeRef = _step.value;
                                            addedNode = addedNodeRef.deref();
                                            if (addedNode) {
                                                _context.next = 4;
                                                break;
                                            }
                                            return _context.abrupt("return", 1);
                                        case 4:
                                            hasSameDeletedNode = removedNodes.find(function(ref) {
                                                var n = ref.deref();
                                                if (!n || !addedNode) return false;
                                                return n.isEqualNode(addedNode);
                                            });
                                            _checkWithinComponent = (0, $bZcvC.default)(addedNode, "UFOThirdPartySegment", _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent.isWithin;
                                            isWithinSmartAnswersSegment = Boolean(_this.shouldCheckSmartAnswersMutations() && (0, $iYjll.isContainedWithinSmartAnswers)(addedNode));
                                            isTargetReactRoot = targetNode === ((_this$getSSRState = _this.getSSRState) === null || _this$getSSRState === void 0 || (_this$getSSRState = _this$getSSRState.call(_this)) === null || _this$getSSRState === void 0 ? void 0 : _this$getSSRState.reactRootElement);
                                            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.watchAndTag(addedNode, (_this.trackLayoutShiftOffenders ? $c7081d2a6f7dfaaf$var$createElementMutationsWatcherNew : $c7081d2a6f7dfaaf$var$createElementMutationsWatcher)(removedNodeRects, isWithinThirdPartySegment, isWithinSmartAnswersSegment, !!hasSameDeletedNode, timestamp, isTargetReactRoot, _this.getSSRState, _this.getSSRPlaceholderHandler));
                                        case 9:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _loop);
                            });
                            _iterator.s();
                        case 7:
                            if ((_step = _iterator.n()).done) {
                                _context2.next = 13;
                                break;
                            }
                            return _context2.delegateYield(_loop(), "t0", 9);
                        case 9:
                            if (!_context2.t0) {
                                _context2.next = 11;
                                break;
                            }
                            return _context2.abrupt("continue", 11);
                        case 11:
                            _context2.next = 7;
                            break;
                        case 13:
                            _context2.next = 18;
                            break;
                        case 15:
                            _context2.prev = 15;
                            _context2.t1 = _context2["catch"](4);
                            _iterator.e(_context2.t1);
                        case 18:
                            _context2.prev = 18;
                            _iterator.f();
                            return _context2.finish(18);
                        case 21:
                        case "end":
                            return _context2.stop();
                    }
                }, _callee, null, [
                    [
                        4,
                        15,
                        18,
                        21
                    ]
                ]);
            }));
            return function(_x) {
                return _ref6.apply(this, arguments);
            };
        }());
        (0, $dqOGO.default)(this, "handleAttributeMutation", function(_ref7) {
            var _this$intersectionObs2;
            var target = _ref7.target, attributeName = _ref7.attributeName, oldValue = _ref7.oldValue, newValue = _ref7.newValue, timestamp = _ref7.timestamp;
            (_this$intersectionObs2 = _this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.watchAndTag(target, function(_ref8) {
                var target = _ref8.target, rect = _ref8.rect;
                if ((0, $lLzX6.isContainedWithinMediaWrapper)(target)) return {
                    type: "mutation:media",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var _checkWithinComponent2 = (0, $bZcvC.default)(target, "UFOThirdPartySegment", _this.mapIs3pResult), isWithinThirdPartySegment = _checkWithinComponent2.isWithin;
                if (isWithinThirdPartySegment) return {
                    type: "mutation:third-party-attribute",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if (_this.shouldCheckSmartAnswersMutations() && (0, $iYjll.isContainedWithinSmartAnswers)(target)) return {
                    type: "mutation:smart-answers-attribute",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue
                    }
                };
                if ((0, $c9boa.default)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: "mutation:attribute:non-visual-style",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $7GQjF.default)({
                    target: target,
                    attributeName: attributeName,
                    type: "attributes"
                })) return {
                    type: "mutation:attribute:non-visual-style",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                if ((0, $jg1cY.isInputNameMutation)({
                    target: target,
                    attributeName: attributeName,
                    oldValue: oldValue,
                    newValue: newValue
                })) return {
                    type: "mutation:attribute:non-visual-input-name",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var isRLLPlaceholder = (0, $6mgdS.RLLPlaceholderHandlers).getInstance().isRLLPlaceholderHydration(rect);
                if (isRLLPlaceholder) return {
                    type: "mutation:rll-placeholder",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                var lastElementRect = _this.mapVisibleNodeRects.get(target);
                if (lastElementRect && (0, $960S0.isSameRectSize)(rect, lastElementRect)) return {
                    type: "mutation:attribute:no-layout-shift",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
                return {
                    type: "mutation:attribute",
                    mutationData: {
                        attributeName: attributeName,
                        oldValue: oldValue,
                        newValue: newValue,
                        timestamp: timestamp
                    }
                };
            });
        });
        (0, $dqOGO.default)(this, "handleLayoutShift", function(_ref9) {
            var time = _ref9.time, changedRects = _ref9.changedRects;
            var _iterator2 = $c7081d2a6f7dfaaf$var$_createForOfIteratorHelper(changedRects), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var changedRect = _step2.value;
                    var target = changedRect.node;
                    if (target) {
                        var isSameCurrentAndPreviousRects = (0, $h45m4.isSameRectDimensions)(changedRect.rect, changedRect.previousRect);
                        _this.onChange({
                            time: time,
                            elementRef: new WeakRef(target),
                            visible: true,
                            rect: changedRect.rect,
                            previousRect: changedRect.previousRect,
                            type: isSameCurrentAndPreviousRects ? "layout-shift:same-rect" : "layout-shift"
                        });
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        });
        (0, $dqOGO.default)(this, "shouldCheckSmartAnswersMutations", function() {
            var _this$searchPageConfi, _this$searchPageConfi2, _window;
            return ((_this$searchPageConfi = _this.searchPageConfig) === null || _this$searchPageConfi === void 0 ? void 0 : _this$searchPageConfi.enableSmartAnswersMutations) && ((_this$searchPageConfi2 = _this.searchPageConfig) === null || _this$searchPageConfi2 === void 0 ? void 0 : _this$searchPageConfi2.searchPageRoute) && ((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname) && window.location.pathname === _this.searchPageConfig.searchPageRoute;
        });
        this.mapVisibleNodeRects = new WeakMap();
        this.mapIs3pResult = new WeakMap();
        this.onChange = onChange;
        this.isStarted = false;
        this.intersectionObserver = null;
        this.mutationObserver = null;
        this.performanceObserver = null;
        this.trackLayoutShiftOffenders = trackLayoutShiftOffenders;
        // Initialize SSR context functions
        this.getSSRState = getSSRState;
        this.getSSRPlaceholderHandler = getSSRPlaceholderHandler;
        this.searchPageConfig = searchPageConfig;
    }
    return (0, $c19Op.default)(ViewportObserver, [
        {
            key: "initializeObservers",
            value: function initializeObservers() {
                if (this.isStarted) return;
                this.intersectionObserver = (0, $gp9N4.createIntersectionObserver)({
                    onEntry: this.handleIntersectionEntry
                });
                this.mutationObserver = (0, $5k2oH.default)({
                    onChildListMutation: this.handleChildListMutation,
                    onAttributeMutation: this.handleAttributeMutation
                });
                this.performanceObserver = (0, $d4XtI.default)({
                    onLayoutShift: this.handleLayoutShift
                });
            }
        },
        {
            key: "start",
            value: function start() {
                var _this$mutationObserve, _this$performanceObse;
                if (this.isStarted) return;
                this.initializeObservers();
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
                (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.observe({
                    type: "layout-shift",
                    buffered: true,
                    // @ts-ignore -error
                    durationThreshold: 30
                });
                this.isStarted = true;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$mutationObserve2, _this$intersectionObs3, _this$performanceObse2;
                if (!this.isStarted) return;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs3 = this.intersectionObserver) === null || _this$intersectionObs3 === void 0 || _this$intersectionObs3.disconnect();
                (_this$performanceObse2 = this.performanceObserver) === null || _this$performanceObse2 === void 0 || _this$performanceObse2.disconnect();
                this.isStarted = false;
                // Clean up caches when stopping
                (0, $bZcvC.cleanupCaches)(this.mapIs3pResult);
            }
        }
    ]);
}();

});
parcelRegister("gp9N4", function(module, exports) {

$parcel$export(module.exports, "createIntersectionObserver", function () { return $bf1693549bb3f5aa$export$c3799d33e0ae80a5; });

var $bxTrm = parcelRequire("bxTrm");
function $bf1693549bb3f5aa$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $bf1693549bb3f5aa$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $bf1693549bb3f5aa$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $bf1693549bb3f5aa$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $bf1693549bb3f5aa$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $bf1693549bb3f5aa$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $bf1693549bb3f5aa$var$isValidEntry(entry) {
    return entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0;
}
function $bf1693549bb3f5aa$export$c3799d33e0ae80a5(_ref) {
    var onEntry = _ref.onEntry, onObserved = _ref.onObserved;
    if (!window || typeof window.IntersectionObserver !== "function") return null;
    var callbacksPerElement = new WeakMap();
    var intersectionObserverCallback = function intersectionObserverCallback(entries) {
        var validEntries = [];
        var startTime = performance.now();
        entries.forEach(function(entry) {
            if (!(entry.target instanceof HTMLElement)) return;
            var tagOrCallback = callbacksPerElement.get(entry.target);
            if ((0, $bxTrm.isZeroDimensionRectangle)(entry.intersectionRect)) {
                var zeroDimensionRectangleTagCallback = function zeroDimensionRectangleTagCallback(props) {
                    var tagOrCallbackResult = typeof tagOrCallback === "function" ? tagOrCallback(props) : tagOrCallback;
                    // override as display-contents mutation
                    if (tagOrCallbackResult === "mutation:element") return "mutation:display-contents-children-element";
                    // override as display-contents mutation
                    if (tagOrCallbackResult && typeof tagOrCallbackResult !== "string" && tagOrCallbackResult.type === "mutation:attribute" && "oldValue" in tagOrCallbackResult.mutationData) {
                        var _tagOrCallbackResult$ = tagOrCallbackResult.mutationData, attributeName = _tagOrCallbackResult$.attributeName, oldValue = _tagOrCallbackResult$.oldValue, newValue = _tagOrCallbackResult$.newValue;
                        var isRoutingMutation = attributeName === "style" && (!oldValue && newValue === "display: none !important;" || oldValue === "display: none !important;" && !newValue);
                        if (isRoutingMutation) return {
                            type: "mutation:attribute:framework-routing",
                            mutationData: tagOrCallbackResult.mutationData
                        };
                        return {
                            type: "mutation:display-contents-children-attribute",
                            mutationData: tagOrCallbackResult.mutationData
                        };
                    }
                    return tagOrCallbackResult;
                };
                var _iterator = $bf1693549bb3f5aa$var$_createForOfIteratorHelper(entry.target.children), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var child = _step.value;
                        observer.observe(child);
                        callbacksPerElement.set(child, zeroDimensionRectangleTagCallback);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return;
            }
            if (!$bf1693549bb3f5aa$var$isValidEntry(entry)) return;
            var mutationTag = null;
            var mutationData = null;
            if (typeof tagOrCallback === "function") {
                var tagOrCallbackResult = tagOrCallback({
                    target: entry.target,
                    rect: entry.intersectionRect
                });
                if (!tagOrCallbackResult) mutationTag = "unknown";
                else if (typeof tagOrCallbackResult === "string") mutationTag = tagOrCallbackResult;
                else {
                    mutationTag = tagOrCallbackResult.type;
                    mutationData = tagOrCallbackResult.mutationData;
                }
            } else if (typeof tagOrCallback === "string") mutationTag = tagOrCallback;
            onEntry({
                target: entry.target,
                rect: entry.intersectionRect,
                time: entry.time,
                type: mutationTag !== null && mutationTag !== void 0 ? mutationTag : "unknown",
                mutationData: mutationData
            });
            validEntries.push(new WeakRef(entry.target));
            callbacksPerElement.delete(entry.target);
            observer.unobserve(entry.target);
        });
        onObserved === null || onObserved === void 0 || onObserved({
            time: startTime,
            elements: validEntries
        });
    };
    var observer = new IntersectionObserver(intersectionObserverCallback);
    return {
        disconnect: function disconnect() {
            observer.disconnect();
        },
        unobserve: function unobserve(target) {
            observer.unobserve(target);
        },
        watchAndTag: function watchAndTag(target, tagOrCallback) {
            callbacksPerElement.set(target, tagOrCallback);
            observer.observe(target);
        }
    };
}

});
parcelRegister("bxTrm", function(module, exports) {

$parcel$export(module.exports, "isZeroDimensionRectangle", function () { return $867dc815e9c4566b$export$80d6b07c2266a1c6; });
function $867dc815e9c4566b$export$80d6b07c2266a1c6(rect) {
    return rect.bottom === 0 && rect.top === 0 && rect.left === 0 && rect.right === 0 && rect.x === 0 && rect.y === 0 && rect.width === 0 && rect.height === 0;
}

});


parcelRegister("5k2oH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e00ae187716e8d7$export$2e2bcd8739ae039; });

var $hz5zq = parcelRequire("hz5zq");
function $3e00ae187716e8d7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $3e00ae187716e8d7$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $3e00ae187716e8d7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $3e00ae187716e8d7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $3e00ae187716e8d7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $3e00ae187716e8d7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Batched mutation data for performance optimization
function $3e00ae187716e8d7$var$createMutationObserver(_ref) {
    var onAttributeMutation = _ref.onAttributeMutation, onChildListMutation = _ref.onChildListMutation, onMutationFinished = _ref.onMutationFinished;
    if (!window || typeof window.IntersectionObserver !== "function") return null;
    var mutationObserverCallback = function mutationObserverCallback(mutations) {
        var targets = [];
        // Use nested Maps for O(1) batching performance
        // Short-lived Maps are safe since they're discarded after each callback
        var batchedMutations = new Map();
        var _iterator = $3e00ae187716e8d7$var$_createForOfIteratorHelper(mutations), _step;
        try {
            var _loop = function _loop() {
                var mut = _step.value;
                if (!(mut.target instanceof HTMLElement)) return 0; // continue
                if ((0, $hz5zq.expVal)("cc_editor_vc_exclude_flags", "isEnabled", false)) {
                    // Intended for excluding out of band mutations such as tooltips on hover, and page flags
                    // Currently being tested in Confluence
                    // Skip elements with data-vc-oob attribute
                    if (mut.target.dataset.vcOob) return {
                        v: void 0
                    };
                }
                if (mut.type === "attributes") {
                    var _mut$oldValue;
                    /*
            	"MutationObserver was explicitly designed to work that way, but I can't now recall the reasoning.
            	I think it might have been something along the lines that for consistency every setAttribute call should create a record.
            	Conceptually there is after all a mutation: there is an old value replaced with a new one,
            	and whether or not they are the same doesn't really matter.
            	And Custom elements should work the same way as MutationObserver."
            	https://github.com/whatwg/dom/issues/520#issuecomment-336574796
            */ var oldValue = (_mut$oldValue = mut.oldValue) !== null && _mut$oldValue !== void 0 ? _mut$oldValue : undefined;
                    var newValue = mut.attributeName ? mut.target.getAttribute(mut.attributeName) : undefined;
                    if (oldValue !== newValue) {
                        var _mut$attributeName;
                        onAttributeMutation({
                            target: mut.target,
                            attributeName: (_mut$attributeName = mut.attributeName) !== null && _mut$attributeName !== void 0 ? _mut$attributeName : "unknown",
                            oldValue: oldValue,
                            newValue: newValue,
                            timestamp: mut.timestamp || performance.now()
                        });
                    }
                    return 0; // continue
                } else if (mut.type === "childList") {
                    var _mut$addedNodes, _mut$removedNodes;
                    // In chromium browser MutationRecord has timestamp field, which we should use.
                    var timestamp = Math.round(mut.timestamp || performance.now());
                    // Get or create timestamp bucket
                    var timestampBucket = batchedMutations.get(timestamp);
                    if (!timestampBucket) {
                        timestampBucket = new Map();
                        batchedMutations.set(timestamp, timestampBucket);
                    }
                    // Get or create target batch within timestamp bucket
                    var batch = timestampBucket.get(mut.target);
                    if (!batch) {
                        batch = {
                            target: new WeakRef(mut.target),
                            addedNodes: [],
                            removedNodes: [],
                            timestamp: timestamp
                        };
                        timestampBucket.set(mut.target, batch);
                    }
                    // Accumulate added nodes
                    ((_mut$addedNodes = mut.addedNodes) !== null && _mut$addedNodes !== void 0 ? _mut$addedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.addedNodes.push(new WeakRef(node));
                    });
                    // Accumulate removed nodes
                    ((_mut$removedNodes = mut.removedNodes) !== null && _mut$removedNodes !== void 0 ? _mut$removedNodes : []).forEach(function(node) {
                        if (node instanceof HTMLElement) batch.removedNodes.push(new WeakRef(node));
                    });
                }
                targets.push(mut.target);
            }, _ret;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                _ret = _loop();
                if (_ret === 0) continue;
                if (_ret) return _ret.v;
            }
        // Process all batched childList mutations
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        var _iterator2 = $3e00ae187716e8d7$var$_createForOfIteratorHelper(batchedMutations.values()), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var timestampBucket = _step2.value;
                var _iterator3 = $3e00ae187716e8d7$var$_createForOfIteratorHelper(timestampBucket.values()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var batch = _step3.value;
                        onChildListMutation({
                            target: batch.target,
                            addedNodes: batch.addedNodes,
                            removedNodes: batch.removedNodes,
                            timestamp: batch.timestamp
                        });
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        onMutationFinished === null || onMutationFinished === void 0 || onMutationFinished({
            targets: targets
        });
    };
    var observer = new MutationObserver(mutationObserverCallback);
    return observer;
}
var $3e00ae187716e8d7$export$2e2bcd8739ae039 = $3e00ae187716e8d7$var$createMutationObserver;

});

parcelRegister("d4XtI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9859c93b86e871e3$export$2e2bcd8739ae039; });
function $9859c93b86e871e3$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9859c93b86e871e3$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9859c93b86e871e3$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9859c93b86e871e3$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9859c93b86e871e3$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9859c93b86e871e3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $9859c93b86e871e3$export$5e3f54cad8cb65e2(rect) {
    if (typeof window.devicePixelRatio !== "number") return rect;
    if (window.devicePixelRatio === 1) return rect;
    // eslint-disable-next-line compat/compat
    return new DOMRect(rect.x / window.devicePixelRatio, rect.y / window.devicePixelRatio, rect.width / window.devicePixelRatio, rect.height / window.devicePixelRatio);
}
function $9859c93b86e871e3$var$createPerformanceObserver(_ref) {
    var onLayoutShift = _ref.onLayoutShift;
    if (!window || typeof window.PerformanceObserver !== "function") return null;
    var performanceObserverCallback = function performanceObserverCallback(entries) {
        var _iterator = $9859c93b86e871e3$var$_createForOfIteratorHelper(entries.getEntries()), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.entryType === "layout-shift" && "sources" in entry) {
                    // see https://developer.mozilla.org/en-US/docs/Web/API/LayoutShiftAttribution for more info
                    var changedRects = entry.sources.reduceRight(function(acc, attr) {
                        acc.push({
                            rect: $9859c93b86e871e3$export$5e3f54cad8cb65e2(attr.currentRect),
                            previousRect: $9859c93b86e871e3$export$5e3f54cad8cb65e2(attr.previousRect),
                            node: attr.node
                        });
                        return acc;
                    }, []);
                    onLayoutShift({
                        time: entry.startTime,
                        changedRects: changedRects
                    });
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
    var observer = new PerformanceObserver(performanceObserverCallback);
    return observer;
}
var $9859c93b86e871e3$export$2e2bcd8739ae039 = $9859c93b86e871e3$var$createPerformanceObserver;

});

parcelRegister("bZcvC", function(module, exports) {

$parcel$export(module.exports, "cleanupCaches", function () { return $8b9f183b045116ad$export$6a35c3789c327630; });
$parcel$export(module.exports, "default", function () { return $8b9f183b045116ad$export$2e2bcd8739ae039; });

var $jxLBU = parcelRequire("jxLBU");

var $2J5Gv = parcelRequire("2J5Gv");

var $a1Qu3 = parcelRequire("a1Qu3");

var $kmRF9 = parcelRequire("kmRF9");
var $8b9f183b045116ad$var$DEFAULT_MAX_LEVEL = 20;
var $8b9f183b045116ad$var$INCREASED_DOM_WALK_MAX_LEVEL = 40;
var $8b9f183b045116ad$var$INCREASED_FIBER_WALK_MAX_LEVEL = 40;
function $8b9f183b045116ad$var$getDomWalkMaxLevel() {
    return (0, $jxLBU.fg)("platform_ufo_3p_forge_detection_fix") ? $8b9f183b045116ad$var$INCREASED_DOM_WALK_MAX_LEVEL : $8b9f183b045116ad$var$DEFAULT_MAX_LEVEL;
}
function $8b9f183b045116ad$var$getFiberWalkMaxLevel() {
    return (0, $jxLBU.fg)("platform_ufo_3p_forge_detection_fix") ? $8b9f183b045116ad$var$INCREASED_FIBER_WALK_MAX_LEVEL : $8b9f183b045116ad$var$DEFAULT_MAX_LEVEL;
}
// Cache cleanup
var $8b9f183b045116ad$var$callCount = 0;
var $8b9f183b045116ad$var$CLEANUP_THRESHOLD = 50;
function $8b9f183b045116ad$var$maybeCleanup(resultCache) {
    $8b9f183b045116ad$var$callCount++;
    if ($8b9f183b045116ad$var$callCount >= $8b9f183b045116ad$var$CLEANUP_THRESHOLD && (0, $2J5Gv.default)(0.3)) $8b9f183b045116ad$export$6a35c3789c327630(resultCache);
}
function $8b9f183b045116ad$export$6a35c3789c327630(resultCache) {
    resultCache = new WeakMap();
    $8b9f183b045116ad$var$callCount = 0;
    return resultCache;
}
function $8b9f183b045116ad$export$2e2bcd8739ae039(node, targetComponentName, resultCache) {
    $8b9f183b045116ad$var$maybeCleanup(resultCache);
    if (resultCache.has(node)) {
        var _resultCache$get;
        return {
            isWithin: (_resultCache$get = resultCache.get(node)) !== null && _resultCache$get !== void 0 ? _resultCache$get : false
        };
    }
    var fiber = null;
    var checkedNodes = [];
    var domWalkMaxLevel = $8b9f183b045116ad$var$getDomWalkMaxLevel();
    // Always use cached fiber strategy to handle non-React elements reliably
    fiber = (0, $kmRF9.default)(node, domWalkMaxLevel, checkedNodes);
    if (!fiber) {
        checkedNodes.forEach(function(checkedNode) {
            resultCache.set(checkedNode, false);
        });
        return {
            isWithin: false
        };
    }
    var isWithin = (0, $a1Qu3.default)(fiber, targetComponentName, $8b9f183b045116ad$var$getFiberWalkMaxLevel());
    checkedNodes.forEach(function(checkedNode) {
        resultCache.set(checkedNode, isWithin);
    });
    return {
        isWithin: isWithin
    };
}

});
parcelRegister("a1Qu3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74d2b593672fb02a$export$2e2bcd8739ae039; });

var $5Omt3 = parcelRequire("5Omt3");
function $74d2b593672fb02a$export$2e2bcd8739ae039(fiber, targetComponentName, maxLevel) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return false;
    if (!fiber) return false;
    var componentName = (0, $5Omt3.default)(fiber);
    if (componentName === targetComponentName) return true;
    // Recursively traverse up the fiber tree
    return $74d2b593672fb02a$export$2e2bcd8739ae039(fiber.return, targetComponentName, maxLevel - 1);
}

});
parcelRegister("5Omt3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $43b30cddf2d35c68$export$2e2bcd8739ae039; });

var $8pSiD = parcelRequire("8pSiD");
function $43b30cddf2d35c68$export$2e2bcd8739ae039(fiber) {
    var type = fiber === null || fiber === void 0 ? void 0 : fiber.type;
    if (!type) return undefined;
    if (typeof type === "function" || (0, $8pSiD.default)(type) === "object") return type.displayName || type.name;
    return undefined;
}

});


parcelRegister("kmRF9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed3f7d096cf5b6a6$export$2e2bcd8739ae039; });

var $5DtRn = parcelRequire("5DtRn");
function $ed3f7d096cf5b6a6$export$2e2bcd8739ae039(element, maxLevel, checkedNodes) {
    // Stop when no more levels to traverse
    if (maxLevel <= 0) return null;
    checkedNodes.push(element);
    var fiber = (0, $5DtRn.default)(element);
    if (fiber) return fiber;
    // Walk up the DOM tree to find the fiber
    var parent = element.parentElement;
    if (!parent) return null;
    // Recursively check parent
    return $ed3f7d096cf5b6a6$export$2e2bcd8739ae039(parent, maxLevel - 1, checkedNodes);
}

});
parcelRegister("5DtRn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41a7c1d160bf31d8$export$2e2bcd8739ae039; });
// Helper function to find React fiber on an element
function $41a7c1d160bf31d8$export$2e2bcd8739ae039(element) {
    // Use for...in loop instead of Object.keys().find() to avoid creating an array
    for(var key in element){
        if (key.startsWith("__reactFiber$") || key.startsWith("__reactInternalInstance$")) return element[key];
    }
    return null;
}

});



parcelRegister("iYjll", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinSmartAnswers", function () { return $dcfcd5be46e3dde9$export$16c2770458939f21; });

var $2pKi9 = parcelRequire("2pKi9");
function $dcfcd5be46e3dde9$export$16c2770458939f21(node) {
    var doc = (0, $2pKi9.getDocument)();
    if (!doc) return false;
    var smartAnswersElement = doc.getElementById("search-page-smart-answers");
    if (!smartAnswersElement) return false;
    // When the node is the smart answer element, .contains() still returns true
    return smartAnswersElement.contains(node);
}

});
parcelRegister("2pKi9", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $1c21d329236579e3$export$f65ca476c09acec0; });
var $1c21d329236579e3$export$f65ca476c09acec0 = function getDocument() {
    if (typeof document !== "undefined") return document;
    return null;
};

});


parcelRegister("keFxD", function(module, exports) {

$parcel$export(module.exports, "isElementVisible", function () { return $ebb556b853bc586b$export$e989c0fffaa6b27a; });
function $ebb556b853bc586b$export$e989c0fffaa6b27a(element) {
    if (!(element instanceof HTMLElement)) return true;
    try {
        var visible = element.checkVisibility({
            // @ts-ignore - visibilityProperty may not exist in all TS environments
            visibilityProperty: true,
            contentVisibilityAuto: true,
            opacityProperty: true
        });
        return visible;
    } catch (_unused) {
        // there is no support for checkVisibility
        return true;
    }
}

});

parcelRegister("cW52z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96aecfbf0eea0ad1$export$2e2bcd8739ae039; });
/**
 * Check if the element is in the VC ignore if no layout shift marker.
 * @param element - The element to check.
 * @returns True if the element has the data-vc-ignore-if-no-layout-shift attribute == 'true or its parent has it, false otherwise.
 */ function $96aecfbf0eea0ad1$export$2e2bcd8739ae039(element) {
    if (!element) return false;
    return element.getAttribute("data-vc-ignore-if-no-layout-shift") === "true" || $96aecfbf0eea0ad1$export$2e2bcd8739ae039(element.parentElement);
}

});

parcelRegister("jg1cY", function(module, exports) {

$parcel$export(module.exports, "isInputNameMutation", function () { return $e05072e6ca3463af$export$80a5724ceedcfd3d; });
// Detecting this is required due to a React/Chromium bug, where React itself triggers an attribute mutation for input elements
// Reference: https://atlassian.slack.com/archives/C08EK6TCUP6/p1764129900970719
function $e05072e6ca3463af$export$80a5724ceedcfd3d(_ref) {
    var target = _ref.target, attributeName = _ref.attributeName, oldValue = _ref.oldValue, newValue = _ref.newValue;
    return target instanceof HTMLInputElement && attributeName === "name" && (oldValue === "" || newValue === "");
}

});

parcelRegister("h45m4", function(module, exports) {

$parcel$export(module.exports, "isSameRectDimensions", function () { return $c6c6f6c6d706e313$export$fde63bc968551821; });
var $c6c6f6c6d706e313$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $c6c6f6c6d706e313$export$fde63bc968551821(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $c6c6f6c6d706e313$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $c6c6f6c6d706e313$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.x - b.x) <= $c6c6f6c6d706e313$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.y - b.y) <= $c6c6f6c6d706e313$var$DIMENSIONS_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});

parcelRegister("960S0", function(module, exports) {

$parcel$export(module.exports, "isSameRectSize", function () { return $69f5595953f33d32$export$597b41700f7dcd36; });
var $69f5595953f33d32$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX = 1;
function $69f5595953f33d32$export$597b41700f7dcd36(a, b) {
    if (!a || !b) return false;
    return Math.abs(a.width - b.width) <= $69f5595953f33d32$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX && Math.abs(a.height - b.height) <= $69f5595953f33d32$var$SIZE_CHECK_TOLERANCE_MARGIN_IN_PX;
}

});


parcelRegister("48TSH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $304341a322093d80$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $2e1kT = parcelRequire("2e1kT");
var $304341a322093d80$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function WindowEventObserver(opts) {
        (0, $i385U.default)(this, WindowEventObserver);
        (0, $dqOGO.default)(this, "unbindFns", []);
        this.onEvent = opts.onEvent;
    }
    return (0, $c19Op.default)(WindowEventObserver, [
        {
            key: "bindEvent",
            value: function bindEvent(type) {
                var _this = this;
                var unbindCallback = (0, $2e1kT.bind)(window, {
                    type: type,
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this.onEvent({
                            time: event.timeStamp,
                            type: type,
                            event: event
                        });
                    },
                    options: {
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "bindCaptureScrollEvent",
            value: function bindCaptureScrollEvent() {
                var _this2 = this;
                var unbindCallback = (0, $2e1kT.bind)(document, {
                    type: "scroll",
                    listener: function listener(event) {
                        if (!event.isTrusted) return;
                        _this2.onEvent({
                            time: event.timeStamp,
                            type: "scroll-container",
                            event: event
                        });
                    },
                    options: {
                        capture: true,
                        passive: true,
                        once: true
                    }
                });
                this.unbindFns.push(unbindCallback);
            }
        },
        {
            key: "start",
            value: function start() {
                this.bindEvent("wheel");
                this.bindEvent("scroll");
                this.bindEvent("keydown");
                this.bindEvent("resize");
                this.bindCaptureScrollEvent();
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.unbindFns.forEach(function(cb) {
                    cb();
                });
                this.unbindFns = [];
            }
        }
    ]);
}();

});



parcelRegister("4Wnvy", function(module, exports) {

$parcel$export(module.exports, "interactions", function () { return $398ed06507c756ef$export$cc97b17ef9aeb088; });
var $398ed06507c756ef$export$cc97b17ef9aeb088 = new Map();

});

parcelRegister("f8snl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b04d9d2dcf25bd1e$export$2e2bcd8739ae039; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $kbJIl = parcelRequire("kbJIl");

var $4Wnvy = parcelRequire("4Wnvy");

var $hkP9U = parcelRequire("hkP9U");
function $b04d9d2dcf25bd1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b04d9d2dcf25bd1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b04d9d2dcf25bd1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b04d9d2dcf25bd1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b04d9d2dcf25bd1e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function InteractionExtraMetrics() {
        (0, $i385U.default)(this, InteractionExtraMetrics);
        // Store the finished interaction (as non-3p interaction)
        (0, $dqOGO.default)(this, "finishedInteraction", null);
        // independent VC observer, that observes until `custom.post-interaction-logs` event is sent
        (0, $dqOGO.default)(this, "vcObserver", null);
        (0, $dqOGO.default)(this, "sinkHandlerFn", function() {});
    }
    return (0, $c19Op.default)(InteractionExtraMetrics, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $kbJIl.VCObserverWrapper)($b04d9d2dcf25bd1e$var$_objectSpread($b04d9d2dcf25bd1e$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref, interactionId) {
                var startTime = _ref.startTime;
                if (this.eligibleToMeasure(interactionId)) {
                    var _this$vcObserver;
                    (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                        startTime: startTime
                    });
                }
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "eligibleToMeasure",
            value: function eligibleToMeasure(interactionId) {
                var interaction = (0, $4Wnvy.interactions).get(interactionId);
                return (interaction === null || interaction === void 0 ? void 0 : interaction.type) === "page_load" || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === "transition";
            }
        },
        {
            key: "updateFinishedInteraction",
            value: function updateFinishedInteraction(interaction) {
                if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === "page_load" || (interaction === null || interaction === void 0 ? void 0 : interaction.type) === "transition") this.finishedInteraction = interaction;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: function sinkHandler(fn) {
                this.sinkHandlerFn = fn;
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(id, data) {
                if (data.ufoName) {
                    var _this$vcObserver3;
                    var updatedData = $b04d9d2dcf25bd1e$var$_objectSpread($b04d9d2dcf25bd1e$var$_objectSpread({}, data), {}, {
                        vcObserver: (_this$vcObserver3 = this.vcObserver) !== null && _this$vcObserver3 !== void 0 ? _this$vcObserver3 : undefined
                    });
                    this.sinkHandlerFn(id, updatedData, this.finishedInteraction, this.lastInteractionFinishVCResult);
                }
                this.stopVCObserver();
                (0, $hkP9U.remove)(id);
                this.reset();
            }
        },
        {
            key: "reset",
            value: function reset() {
                var _this$finishedInterac;
                this.stopVCObserver();
                if ((_this$finishedInterac = this.finishedInteraction) !== null && _this$finishedInterac !== void 0 && _this$finishedInterac.id) (0, $hkP9U.remove)(this.finishedInteraction.id);
                this.finishedInteraction = null;
                this.lastInteractionFinishVCResult = undefined;
            }
        },
        {
            key: "stopAll",
            value: function stopAll(id) {
                (0, $hkP9U.remove)(id);
                this.reset();
            }
        }
    ]);
}();

});

parcelRegister("kgUIu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec214bffbfe9e544$export$2e2bcd8739ae039; });

var $2sYxo = parcelRequire("2sYxo");

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $aKGMT = parcelRequire("aKGMT");

var $bs6hr = parcelRequire("bs6hr");

var $2TVum = parcelRequire("2TVum");

var $kbJIl = parcelRequire("kbJIl");
function $ec214bffbfe9e544$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec214bffbfe9e544$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec214bffbfe9e544$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec214bffbfe9e544$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec214bffbfe9e544$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $ec214bffbfe9e544$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, $i385U.default)(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, $dqOGO.default)(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, $dqOGO.default)(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, $dqOGO.default)(this, "sinkTimeoutId", null);
        (0, $dqOGO.default)(this, "holdInfo", []);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, $dqOGO.default)(this, "vcObserver", null);
        (0, $dqOGO.default)(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, $dqOGO.default)(this, "sinkHandlerFn", function() {});
    }
    return (0, $c19Op.default)(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                this.vcObserver = new (0, $kbJIl.VCObserverWrapper)($ec214bffbfe9e544$var$_objectSpread($ec214bffbfe9e544$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "stopVCObserver",
            value: function stopVCObserver() {
                var _this$vcObserver2;
                (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 || _this$vcObserver2.stop();
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                this.holdInfo = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function() {
                var _sendPostInteractionLog = (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee() {
                    var _this$vcObserver4, _config$vc, _config$vc2, _this$vcObserver5;
                    var _this$vcObserver3, pageVisibilityState, isPageVisible, config, postInteractionFinishVCResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!this.lastInteractionFinish || !this.sinkHandlerFn)) {
                                    _context.next = 4;
                                    break;
                                }
                                this.reset();
                                (_this$vcObserver3 = this.vcObserver) === null || _this$vcObserver3 === void 0 || _this$vcObserver3.stop();
                                return _context.abrupt("return");
                            case 4:
                                pageVisibilityState = (0, $2TVum.getPageVisibilityState)(this.lastInteractionFinish.start, this.lastInteractionFinish.end);
                                isPageVisible = pageVisibilityState === "visible";
                                config = (0, $bs6hr.getConfig)();
                                _context.next = 9;
                                return (_this$vcObserver4 = this.vcObserver) === null || _this$vcObserver4 === void 0 ? void 0 : _this$vcObserver4.getVCResult($ec214bffbfe9e544$var$_objectSpread($ec214bffbfe9e544$var$_objectSpread({
                                    start: this.lastInteractionFinish.start,
                                    stop: performance.now(),
                                    tti: -1,
                                    // no need for TTI value here
                                    isEventAborted: !!this.lastInteractionFinish.abortReason,
                                    prefix: "ufo",
                                    experienceKey: this.lastInteractionFinish.ufoName,
                                    interactionId: this.lastInteractionFinish.id,
                                    includeSSRInV3: config === null || config === void 0 || (_config$vc = config.vc) === null || _config$vc === void 0 ? void 0 : _config$vc.includeSSRInV3,
                                    includeSSRRatio: config === null || config === void 0 || (_config$vc2 = config.vc) === null || _config$vc2 === void 0 ? void 0 : _config$vc2.includeSSRRatio
                                }, this.vcObserverSSRConfig), {}, {
                                    interactionType: this.lastInteractionFinish.type,
                                    isPageVisible: isPageVisible,
                                    interactionAbortReason: this.lastInteractionFinish.abortReason
                                }));
                            case 9:
                                postInteractionFinishVCResult = _context.sent;
                                (_this$vcObserver5 = this.vcObserver) === null || _this$vcObserver5 === void 0 || _this$vcObserver5.stop();
                                this.sinkHandlerFn({
                                    lastInteractionFinish: this.lastInteractionFinish,
                                    reactProfilerTimings: this.reactProfilerTimings,
                                    postInteractionFinishVCResult: postInteractionFinishVCResult,
                                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult,
                                    postInteractionHoldInfo: this.holdInfo
                                });
                                this.reset();
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function sendPostInteractionLog() {
                    return _sendPostInteractionLog.apply(this, arguments);
                }
                return sendPostInteractionLog;
            }()
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type, experimentalTTAI = _ref2.experimentalTTAI, experimentalVC90 = _ref2.experimentalVC90, errors = _ref2.errors;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type,
                    experimentalTTAI: experimentalTTAI,
                    experimentalVC90: experimentalVC90,
                    errors: errors
                };
                var timeout = ((_getConfig = (0, $bs6hr.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $ec214bffbfe9e544$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(/*#__PURE__*/ (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee2() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return _this.sendPostInteractionLog();
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                })), timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        },
        {
            key: "addHoldInfo",
            value: function addHoldInfo(labelStack, name, start) {
                this.holdInfo.push({
                    name: name,
                    labelStack: labelStack,
                    start: start
                });
            }
        }
    ]);
}();

});


parcelRegister("527WA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3aa34d24d6225afa$export$2e2bcd8739ae039; });
// The UFORouteName object is a global singleton
var $3aa34d24d6225afa$var$UFORouteName = {
    current: null
};
var $3aa34d24d6225afa$export$2e2bcd8739ae039 = $3aa34d24d6225afa$var$UFORouteName;

});

parcelRegister("guaR7", function(module, exports) {
"use strict";
var $c007de6f511ef914$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c007de6f511ef914$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c007de6f511ef914$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$c007de6f511ef914$var$__exportStar((parcelRequire("5NuBn")), module.exports);

$c007de6f511ef914$var$__exportStar((parcelRequire("hsktY")), module.exports);

$c007de6f511ef914$var$__exportStar((parcelRequire("gWP54")), module.exports);

$c007de6f511ef914$var$__exportStar((parcelRequire("frwQP")), module.exports);

$c007de6f511ef914$var$__exportStar((parcelRequire("89j0J")), module.exports);

$c007de6f511ef914$var$__exportStar((parcelRequire("gHWn5")), module.exports);

});
parcelRegister("5NuBn", function(module, exports) {
"use strict";
var $4389443b899c9c0d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorMap = module.exports.setErrorMap = module.exports.defaultErrorMap = void 0;

const $4389443b899c9c0d$var$en_1 = $4389443b899c9c0d$var$__importDefault((parcelRequire("kEzUY")));
module.exports.defaultErrorMap = $4389443b899c9c0d$var$en_1.default;
let $4389443b899c9c0d$var$overrideErrorMap = $4389443b899c9c0d$var$en_1.default;
function $4389443b899c9c0d$var$setErrorMap(map) {
    $4389443b899c9c0d$var$overrideErrorMap = map;
}
module.exports.setErrorMap = $4389443b899c9c0d$var$setErrorMap;
function $4389443b899c9c0d$var$getErrorMap() {
    return $4389443b899c9c0d$var$overrideErrorMap;
}
module.exports.getErrorMap = $4389443b899c9c0d$var$getErrorMap;

});
parcelRegister("kEzUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $frwQP = parcelRequire("frwQP");

var $gHWn5 = parcelRequire("gHWn5");
const $f09367a4371caf32$var$errorMap = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $gHWn5.ZodIssueCode.invalid_type:
            if (issue.received === $frwQP.ZodParsedType.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $gHWn5.ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $frwQP.util.jsonStringifyReplacer)}`;
            break;
        case $gHWn5.ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$frwQP.util.joinValues(issue.keys, ", ")}`;
            break;
        case $gHWn5.ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case $gHWn5.ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$frwQP.util.joinValues(issue.options)}`;
            break;
        case $gHWn5.ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${$frwQP.util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $gHWn5.ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $gHWn5.ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $gHWn5.ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case $gHWn5.ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $frwQP.util.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $gHWn5.ZodIssueCode.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $gHWn5.ZodIssueCode.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $gHWn5.ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case $gHWn5.ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $gHWn5.ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $gHWn5.ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $frwQP.util.assertNever(issue);
    }
    return {
        message: message
    };
};
module.exports.default = $f09367a4371caf32$var$errorMap;

});
parcelRegister("frwQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getParsedType = module.exports.ZodParsedType = module.exports.objectUtil = module.exports.util = void 0;
var $b3e2dc270d5e64fb$var$util;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($b3e2dc270d5e64fb$var$util = module.exports.util || (module.exports.util = {}));
var $b3e2dc270d5e64fb$var$objectUtil;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($b3e2dc270d5e64fb$var$objectUtil = module.exports.objectUtil || (module.exports.objectUtil = {}));
module.exports.ZodParsedType = $b3e2dc270d5e64fb$var$util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $b3e2dc270d5e64fb$var$getParsedType = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return module.exports.ZodParsedType.undefined;
        case "string":
            return module.exports.ZodParsedType.string;
        case "number":
            return isNaN(data) ? module.exports.ZodParsedType.nan : module.exports.ZodParsedType.number;
        case "boolean":
            return module.exports.ZodParsedType.boolean;
        case "function":
            return module.exports.ZodParsedType.function;
        case "bigint":
            return module.exports.ZodParsedType.bigint;
        case "symbol":
            return module.exports.ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) return module.exports.ZodParsedType.array;
            if (data === null) return module.exports.ZodParsedType.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return module.exports.ZodParsedType.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return module.exports.ZodParsedType.map;
            if (typeof Set !== "undefined" && data instanceof Set) return module.exports.ZodParsedType.set;
            if (typeof Date !== "undefined" && data instanceof Date) return module.exports.ZodParsedType.date;
            return module.exports.ZodParsedType.object;
        default:
            return module.exports.ZodParsedType.unknown;
    }
};
module.exports.getParsedType = $b3e2dc270d5e64fb$var$getParsedType;

});

parcelRegister("gHWn5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ZodError = module.exports.quotelessJson = module.exports.ZodIssueCode = void 0;

var $frwQP = parcelRequire("frwQP");
module.exports.ZodIssueCode = $frwQP.util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $c29df0d7a02cfc83$var$quotelessJson = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
module.exports.quotelessJson = $c29df0d7a02cfc83$var$quotelessJson;
class $c29df0d7a02cfc83$var$ZodError extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $frwQP.util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
module.exports.ZodError = $c29df0d7a02cfc83$var$ZodError;
$c29df0d7a02cfc83$var$ZodError.create = (issues)=>{
    const error = new $c29df0d7a02cfc83$var$ZodError(issues);
    return error;
};

});



parcelRegister("hsktY", function(module, exports) {
"use strict";
var $cb54f096bda4acb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isAsync = module.exports.isValid = module.exports.isDirty = module.exports.isAborted = module.exports.OK = module.exports.DIRTY = module.exports.INVALID = module.exports.ParseStatus = module.exports.addIssueToContext = module.exports.EMPTY_PATH = module.exports.makeIssue = void 0;

var $5NuBn = parcelRequire("5NuBn");

const $cb54f096bda4acb4$var$en_1 = $cb54f096bda4acb4$var$__importDefault((parcelRequire("kEzUY")));
const $cb54f096bda4acb4$var$makeIssue = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
module.exports.makeIssue = $cb54f096bda4acb4$var$makeIssue;
module.exports.EMPTY_PATH = [];
function $cb54f096bda4acb4$var$addIssueToContext(ctx, issueData) {
    const issue = (0, module.exports.makeIssue)({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            (0, $5NuBn.getErrorMap)(),
            $cb54f096bda4acb4$var$en_1.default
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
module.exports.addIssueToContext = $cb54f096bda4acb4$var$addIssueToContext;
class $cb54f096bda4acb4$var$ParseStatus {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return module.exports.INVALID;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $cb54f096bda4acb4$var$ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return module.exports.INVALID;
            if (value.status === "aborted") return module.exports.INVALID;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
module.exports.ParseStatus = $cb54f096bda4acb4$var$ParseStatus;
module.exports.INVALID = Object.freeze({
    status: "aborted"
});
const $cb54f096bda4acb4$var$DIRTY = (value)=>({
        status: "dirty",
        value: value
    });
module.exports.DIRTY = $cb54f096bda4acb4$var$DIRTY;
const $cb54f096bda4acb4$var$OK = (value)=>({
        status: "valid",
        value: value
    });
module.exports.OK = $cb54f096bda4acb4$var$OK;
const $cb54f096bda4acb4$var$isAborted = (x)=>x.status === "aborted";
module.exports.isAborted = $cb54f096bda4acb4$var$isAborted;
const $cb54f096bda4acb4$var$isDirty = (x)=>x.status === "dirty";
module.exports.isDirty = $cb54f096bda4acb4$var$isDirty;
const $cb54f096bda4acb4$var$isValid = (x)=>x.status === "valid";
module.exports.isValid = $cb54f096bda4acb4$var$isValid;
const $cb54f096bda4acb4$var$isAsync = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
module.exports.isAsync = $cb54f096bda4acb4$var$isAsync;

});

parcelRegister("gWP54", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("89j0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.date = module.exports.boolean = module.exports.bigint = module.exports.array = module.exports.any = module.exports.coerce = module.exports.ZodFirstPartyTypeKind = module.exports.late = module.exports.ZodSchema = module.exports.Schema = module.exports.custom = module.exports.ZodReadonly = module.exports.ZodPipeline = module.exports.ZodBranded = module.exports.BRAND = module.exports.ZodNaN = module.exports.ZodCatch = module.exports.ZodDefault = module.exports.ZodNullable = module.exports.ZodOptional = module.exports.ZodTransformer = module.exports.ZodEffects = module.exports.ZodPromise = module.exports.ZodNativeEnum = module.exports.ZodEnum = module.exports.ZodLiteral = module.exports.ZodLazy = module.exports.ZodFunction = module.exports.ZodSet = module.exports.ZodMap = module.exports.ZodRecord = module.exports.ZodTuple = module.exports.ZodIntersection = module.exports.ZodDiscriminatedUnion = module.exports.ZodUnion = module.exports.ZodObject = module.exports.ZodArray = module.exports.ZodVoid = module.exports.ZodNever = module.exports.ZodUnknown = module.exports.ZodAny = module.exports.ZodNull = module.exports.ZodUndefined = module.exports.ZodSymbol = module.exports.ZodDate = module.exports.ZodBoolean = module.exports.ZodBigInt = module.exports.ZodNumber = module.exports.ZodString = module.exports.ZodType = void 0;
module.exports.NEVER = module.exports.void = module.exports.unknown = module.exports.union = module.exports.undefined = module.exports.tuple = module.exports.transformer = module.exports.symbol = module.exports.string = module.exports.strictObject = module.exports.set = module.exports.record = module.exports.promise = module.exports.preprocess = module.exports.pipeline = module.exports.ostring = module.exports.optional = module.exports.onumber = module.exports.oboolean = module.exports.object = module.exports.number = module.exports.nullable = module.exports.null = module.exports.never = module.exports.nativeEnum = module.exports.nan = module.exports.map = module.exports.literal = module.exports.lazy = module.exports.intersection = module.exports.instanceof = module.exports.function = module.exports.enum = module.exports.effect = module.exports.discriminatedUnion = void 0;

var $5NuBn = parcelRequire("5NuBn");

var $aXv8r = parcelRequire("aXv8r");

var $hsktY = parcelRequire("hsktY");

var $frwQP = parcelRequire("frwQP");

var $gHWn5 = parcelRequire("gHWn5");
class $5eede926564c4e6a$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $5eede926564c4e6a$var$handleResult = (ctx, result)=>{
    if ((0, $hsktY.isValid)(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $gHWn5.ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $5eede926564c4e6a$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $5eede926564c4e6a$var$ZodType {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return (0, $frwQP.getParsedType)(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: (0, $frwQP.getParsedType)(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $hsktY.ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: (0, $frwQP.getParsedType)(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ((0, $hsktY.isAsync)(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $frwQP.getParsedType)(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $5eede926564c4e6a$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: (0, $frwQP.getParsedType)(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ((0, $hsktY.isAsync)(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $5eede926564c4e6a$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $gHWn5.ZodIssueCode.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $5eede926564c4e6a$var$ZodEffects({
            schema: this,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $5eede926564c4e6a$var$ZodOptional.create(this, this._def);
    }
    nullable() {
        return $5eede926564c4e6a$var$ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $5eede926564c4e6a$var$ZodArray.create(this, this._def);
    }
    promise() {
        return $5eede926564c4e6a$var$ZodPromise.create(this, this._def);
    }
    or(option) {
        return $5eede926564c4e6a$var$ZodUnion.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $5eede926564c4e6a$var$ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $5eede926564c4e6a$var$ZodEffects({
            ...$5eede926564c4e6a$var$processCreateParams(this._def),
            schema: this,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5eede926564c4e6a$var$ZodDefault({
            ...$5eede926564c4e6a$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodDefault
        });
    }
    brand() {
        return new $5eede926564c4e6a$var$ZodBranded({
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...$5eede926564c4e6a$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $5eede926564c4e6a$var$ZodCatch({
            ...$5eede926564c4e6a$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $5eede926564c4e6a$var$ZodPipeline.create(this, target);
    }
    readonly() {
        return $5eede926564c4e6a$var$ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
module.exports.ZodType = $5eede926564c4e6a$var$ZodType;
module.exports.Schema = $5eede926564c4e6a$var$ZodType;
module.exports.ZodSchema = $5eede926564c4e6a$var$ZodType;
const $5eede926564c4e6a$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $5eede926564c4e6a$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $5eede926564c4e6a$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $5eede926564c4e6a$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $5eede926564c4e6a$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $5eede926564c4e6a$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $5eede926564c4e6a$var$emojiRegex;
const $5eede926564c4e6a$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $5eede926564c4e6a$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $5eede926564c4e6a$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $5eede926564c4e6a$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $5eede926564c4e6a$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $5eede926564c4e6a$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $5eede926564c4e6a$var$ZodString extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.string,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const status = new $hsktY.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$5eede926564c4e6a$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "email",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$5eede926564c4e6a$var$emojiRegex) $5eede926564c4e6a$var$emojiRegex = new RegExp($5eede926564c4e6a$var$_emojiRegex, "u");
                if (!$5eede926564c4e6a$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "emoji",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$5eede926564c4e6a$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "uuid",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$5eede926564c4e6a$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "cuid",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$5eede926564c4e6a$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "cuid2",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$5eede926564c4e6a$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "ulid",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                (0, $hsktY.addIssueToContext)(ctx, {
                    validation: "url",
                    code: $gHWn5.ZodIssueCode.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "regex",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $5eede926564c4e6a$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$5eede926564c4e6a$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        validation: "ip",
                        code: $gHWn5.ZodIssueCode.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $frwQP.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $gHWn5.ZodIssueCode.invalid_string,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $5eede926564c4e6a$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$aXv8r.errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$aXv8r.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$aXv8r.errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$aXv8r.errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $aXv8r.errorUtil.errToObj(message));
    }
    trim() {
        return new $5eede926564c4e6a$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $5eede926564c4e6a$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $5eede926564c4e6a$var$ZodString({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
module.exports.ZodString = $5eede926564c4e6a$var$ZodString;
$5eede926564c4e6a$var$ZodString.create = (params)=>{
    var _a;
    return new $5eede926564c4e6a$var$ZodString({
        checks: [],
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $5eede926564c4e6a$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $5eede926564c4e6a$var$ZodNumber extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.number,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        let ctx = undefined;
        const status = new $hsktY.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$frwQP.util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($5eede926564c4e6a$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $frwQP.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $aXv8r.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $aXv8r.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $aXv8r.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $aXv8r.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5eede926564c4e6a$var$ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $aXv8r.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5eede926564c4e6a$var$ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $aXv8r.errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $frwQP.util.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
module.exports.ZodNumber = $5eede926564c4e6a$var$ZodNumber;
$5eede926564c4e6a$var$ZodNumber.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodNumber({
        checks: [],
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodBigInt extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.bigint,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        let ctx = undefined;
        const status = new $hsktY.ParseStatus();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $frwQP.util.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $aXv8r.errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $aXv8r.errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $aXv8r.errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $aXv8r.errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $5eede926564c4e6a$var$ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $aXv8r.errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $5eede926564c4e6a$var$ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
module.exports.ZodBigInt = $5eede926564c4e6a$var$ZodBigInt;
$5eede926564c4e6a$var$ZodBigInt.create = (params)=>{
    var _a;
    return new $5eede926564c4e6a$var$ZodBigInt({
        checks: [],
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodBoolean extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.boolean,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodBoolean = $5eede926564c4e6a$var$ZodBoolean;
$5eede926564c4e6a$var$ZodBoolean.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodBoolean({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodDate extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.date,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_date
            });
            return $hsktY.INVALID;
        }
        const status = new $hsktY.ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $frwQP.util.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $5eede926564c4e6a$var$ZodDate({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $aXv8r.errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
module.exports.ZodDate = $5eede926564c4e6a$var$ZodDate;
$5eede926564c4e6a$var$ZodDate.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodDate,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodSymbol extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.symbol,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodSymbol = $5eede926564c4e6a$var$ZodSymbol;
$5eede926564c4e6a$var$ZodSymbol.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodSymbol({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodSymbol,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodUndefined extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.undefined,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodUndefined = $5eede926564c4e6a$var$ZodUndefined;
$5eede926564c4e6a$var$ZodUndefined.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodUndefined({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodUndefined,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodNull extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.null,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodNull = $5eede926564c4e6a$var$ZodNull;
$5eede926564c4e6a$var$ZodNull.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodNull({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNull,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodAny extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodAny = $5eede926564c4e6a$var$ZodAny;
$5eede926564c4e6a$var$ZodAny.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodAny({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodAny,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodUnknown extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodUnknown = $5eede926564c4e6a$var$ZodUnknown;
$5eede926564c4e6a$var$ZodUnknown.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodUnknown({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodUnknown,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodNever extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        (0, $hsktY.addIssueToContext)(ctx, {
            code: $gHWn5.ZodIssueCode.invalid_type,
            expected: $frwQP.ZodParsedType.never,
            received: ctx.parsedType
        });
        return $hsktY.INVALID;
    }
}
module.exports.ZodNever = $5eede926564c4e6a$var$ZodNever;
$5eede926564c4e6a$var$ZodNever.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodNever({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNever,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodVoid extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.void,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
}
module.exports.ZodVoid = $5eede926564c4e6a$var$ZodVoid;
$5eede926564c4e6a$var$ZodVoid.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodVoid({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodVoid,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodArray extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $frwQP.ZodParsedType.array) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.array,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: tooBig ? $gHWn5.ZodIssueCode.too_big : $gHWn5.ZodIssueCode.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: $gHWn5.ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: $gHWn5.ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $hsktY.ParseStatus.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $hsktY.ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $5eede926564c4e6a$var$ZodArray({
            ...this._def,
            minLength: {
                value: minLength,
                message: $aXv8r.errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $5eede926564c4e6a$var$ZodArray({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $aXv8r.errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $5eede926564c4e6a$var$ZodArray({
            ...this._def,
            exactLength: {
                value: len,
                message: $aXv8r.errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
module.exports.ZodArray = $5eede926564c4e6a$var$ZodArray;
$5eede926564c4e6a$var$ZodArray.create = (schema, params)=>{
    return new $5eede926564c4e6a$var$ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodArray,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
function $5eede926564c4e6a$var$deepPartialify(schema) {
    if (schema instanceof $5eede926564c4e6a$var$ZodObject) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $5eede926564c4e6a$var$ZodOptional.create($5eede926564c4e6a$var$deepPartialify(fieldSchema));
        }
        return new $5eede926564c4e6a$var$ZodObject({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $5eede926564c4e6a$var$ZodArray) return new $5eede926564c4e6a$var$ZodArray({
        ...schema._def,
        type: $5eede926564c4e6a$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $5eede926564c4e6a$var$ZodOptional) return $5eede926564c4e6a$var$ZodOptional.create($5eede926564c4e6a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5eede926564c4e6a$var$ZodNullable) return $5eede926564c4e6a$var$ZodNullable.create($5eede926564c4e6a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $5eede926564c4e6a$var$ZodTuple) return $5eede926564c4e6a$var$ZodTuple.create(schema.items.map((item)=>$5eede926564c4e6a$var$deepPartialify(item)));
    else return schema;
}
class $5eede926564c4e6a$var$ZodObject extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $frwQP.util.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $5eede926564c4e6a$var$ZodNever && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $5eede926564c4e6a$var$ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    (0, $hsktY.addIssueToContext)(ctx, {
                        code: $gHWn5.ZodIssueCode.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $hsktY.ParseStatus.mergeObjectSync(status, syncPairs);
        });
        else return $hsktY.ParseStatus.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $aXv8r.errorUtil.errToObj;
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $aXv8r.errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $5eede926564c4e6a$var$ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $frwQP.util.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $frwQP.util.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $5eede926564c4e6a$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $frwQP.util.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $frwQP.util.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $5eede926564c4e6a$var$ZodOptional)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $5eede926564c4e6a$var$ZodObject({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $5eede926564c4e6a$var$createZodEnum($frwQP.util.objectKeys(this.shape));
    }
}
module.exports.ZodObject = $5eede926564c4e6a$var$ZodObject;
$5eede926564c4e6a$var$ZodObject.create = (shape, params)=>{
    return new $5eede926564c4e6a$var$ZodObject({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $5eede926564c4e6a$var$ZodNever.create(),
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodObject,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
$5eede926564c4e6a$var$ZodObject.strictCreate = (shape, params)=>{
    return new $5eede926564c4e6a$var$ZodObject({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $5eede926564c4e6a$var$ZodNever.create(),
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodObject,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
$5eede926564c4e6a$var$ZodObject.lazycreate = (shape, params)=>{
    return new $5eede926564c4e6a$var$ZodObject({
        shape: shape,
        unknownKeys: "strip",
        catchall: $5eede926564c4e6a$var$ZodNever.create(),
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodObject,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodUnion extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $gHWn5.ZodError(result.ctx.common.issues));
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_union,
                unionErrors: unionErrors
            });
            return $hsktY.INVALID;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $gHWn5.ZodError(issues));
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_union,
                unionErrors: unionErrors
            });
            return $hsktY.INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
module.exports.ZodUnion = $5eede926564c4e6a$var$ZodUnion;
$5eede926564c4e6a$var$ZodUnion.create = (types, params)=>{
    return new $5eede926564c4e6a$var$ZodUnion({
        options: types,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodUnion,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $5eede926564c4e6a$var$getDiscriminator = (type)=>{
    if (type instanceof $5eede926564c4e6a$var$ZodLazy) return $5eede926564c4e6a$var$getDiscriminator(type.schema);
    else if (type instanceof $5eede926564c4e6a$var$ZodEffects) return $5eede926564c4e6a$var$getDiscriminator(type.innerType());
    else if (type instanceof $5eede926564c4e6a$var$ZodLiteral) return [
        type.value
    ];
    else if (type instanceof $5eede926564c4e6a$var$ZodEnum) return type.options;
    else if (type instanceof $5eede926564c4e6a$var$ZodNativeEnum) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $5eede926564c4e6a$var$ZodDefault) return $5eede926564c4e6a$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $5eede926564c4e6a$var$ZodUndefined) return [
        undefined
    ];
    else if (type instanceof $5eede926564c4e6a$var$ZodNull) return [
        null
    ];
    else return null;
};
class $5eede926564c4e6a$var$ZodDiscriminatedUnion extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.object) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $hsktY.INVALID;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $5eede926564c4e6a$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $5eede926564c4e6a$var$ZodDiscriminatedUnion({
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$5eede926564c4e6a$var$processCreateParams(params)
        });
    }
}
module.exports.ZodDiscriminatedUnion = $5eede926564c4e6a$var$ZodDiscriminatedUnion;
function $5eede926564c4e6a$var$mergeValues(a, b) {
    const aType = (0, $frwQP.getParsedType)(a);
    const bType = (0, $frwQP.getParsedType)(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $frwQP.ZodParsedType.object && bType === $frwQP.ZodParsedType.object) {
        const bKeys = $frwQP.util.objectKeys(b);
        const sharedKeys = $frwQP.util.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $5eede926564c4e6a$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $frwQP.ZodParsedType.array && bType === $frwQP.ZodParsedType.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $5eede926564c4e6a$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $frwQP.ZodParsedType.date && bType === $frwQP.ZodParsedType.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $5eede926564c4e6a$var$ZodIntersection extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ((0, $hsktY.isAborted)(parsedLeft) || (0, $hsktY.isAborted)(parsedRight)) return $hsktY.INVALID;
            const merged = $5eede926564c4e6a$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: $gHWn5.ZodIssueCode.invalid_intersection_types
                });
                return $hsktY.INVALID;
            }
            if ((0, $hsktY.isDirty)(parsedLeft) || (0, $hsktY.isDirty)(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
module.exports.ZodIntersection = $5eede926564c4e6a$var$ZodIntersection;
$5eede926564c4e6a$var$ZodIntersection.create = (left, right, params)=>{
    return new $5eede926564c4e6a$var$ZodIntersection({
        left: left,
        right: right,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodIntersection,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodTuple extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.array) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.array,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $hsktY.INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $hsktY.ParseStatus.mergeArray(status, results);
        });
        else return $hsktY.ParseStatus.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $5eede926564c4e6a$var$ZodTuple({
            ...this._def,
            rest: rest
        });
    }
}
module.exports.ZodTuple = $5eede926564c4e6a$var$ZodTuple;
$5eede926564c4e6a$var$ZodTuple.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $5eede926564c4e6a$var$ZodTuple({
        items: schemas,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodRecord extends $5eede926564c4e6a$var$ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.object) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.object,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $hsktY.ParseStatus.mergeObjectAsync(status, pairs);
        else return $hsktY.ParseStatus.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $5eede926564c4e6a$var$ZodType) return new $5eede926564c4e6a$var$ZodRecord({
            keyType: first,
            valueType: second,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodRecord,
            ...$5eede926564c4e6a$var$processCreateParams(third)
        });
        return new $5eede926564c4e6a$var$ZodRecord({
            keyType: $5eede926564c4e6a$var$ZodString.create(),
            valueType: first,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodRecord,
            ...$5eede926564c4e6a$var$processCreateParams(second)
        });
    }
}
module.exports.ZodRecord = $5eede926564c4e6a$var$ZodRecord;
class $5eede926564c4e6a$var$ZodMap extends $5eede926564c4e6a$var$ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.map) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.map,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $hsktY.INVALID;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $hsktY.INVALID;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
module.exports.ZodMap = $5eede926564c4e6a$var$ZodMap;
$5eede926564c4e6a$var$ZodMap.create = (keyType, valueType, params)=>{
    return new $5eede926564c4e6a$var$ZodMap({
        valueType: valueType,
        keyType: keyType,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodMap,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodSet extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.set) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.set,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: $gHWn5.ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                (0, $hsktY.addIssueToContext)(ctx, {
                    code: $gHWn5.ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $hsktY.INVALID;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $5eede926564c4e6a$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $5eede926564c4e6a$var$ZodSet({
            ...this._def,
            minSize: {
                value: minSize,
                message: $aXv8r.errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $5eede926564c4e6a$var$ZodSet({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $aXv8r.errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
module.exports.ZodSet = $5eede926564c4e6a$var$ZodSet;
$5eede926564c4e6a$var$ZodSet.create = (valueType, params)=>{
    return new $5eede926564c4e6a$var$ZodSet({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodSet,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodFunction extends $5eede926564c4e6a$var$ZodType {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.function) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.function,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        function makeArgsIssue(args, error) {
            return (0, $hsktY.makeIssue)({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $5NuBn.getErrorMap)(),
                    $5NuBn.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: $gHWn5.ZodIssueCode.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return (0, $hsktY.makeIssue)({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    (0, $5NuBn.getErrorMap)(),
                    $5NuBn.defaultErrorMap
                ].filter((x)=>!!x),
                issueData: {
                    code: $gHWn5.ZodIssueCode.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $5eede926564c4e6a$var$ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $hsktY.OK)(async function(...args) {
                const error = new $gHWn5.ZodError([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return (0, $hsktY.OK)(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $gHWn5.ZodError([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $gHWn5.ZodError([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $5eede926564c4e6a$var$ZodFunction({
            ...this._def,
            args: $5eede926564c4e6a$var$ZodTuple.create(items).rest($5eede926564c4e6a$var$ZodUnknown.create())
        });
    }
    returns(returnType) {
        return new $5eede926564c4e6a$var$ZodFunction({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $5eede926564c4e6a$var$ZodFunction({
            args: args ? args : $5eede926564c4e6a$var$ZodTuple.create([]).rest($5eede926564c4e6a$var$ZodUnknown.create()),
            returns: returns || $5eede926564c4e6a$var$ZodUnknown.create(),
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodFunction,
            ...$5eede926564c4e6a$var$processCreateParams(params)
        });
    }
}
module.exports.ZodFunction = $5eede926564c4e6a$var$ZodFunction;
class $5eede926564c4e6a$var$ZodLazy extends $5eede926564c4e6a$var$ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
module.exports.ZodLazy = $5eede926564c4e6a$var$ZodLazy;
$5eede926564c4e6a$var$ZodLazy.create = (getter, params)=>{
    return new $5eede926564c4e6a$var$ZodLazy({
        getter: getter,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodLazy,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodLiteral extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $gHWn5.ZodIssueCode.invalid_literal,
                expected: this._def.value
            });
            return $hsktY.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
module.exports.ZodLiteral = $5eede926564c4e6a$var$ZodLiteral;
$5eede926564c4e6a$var$ZodLiteral.create = (value, params)=>{
    return new $5eede926564c4e6a$var$ZodLiteral({
        value: value,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodLiteral,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
function $5eede926564c4e6a$var$createZodEnum(values, params) {
    return new $5eede926564c4e6a$var$ZodEnum({
        values: values,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEnum,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
}
class $5eede926564c4e6a$var$ZodEnum extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $hsktY.addIssueToContext)(ctx, {
                expected: $frwQP.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $gHWn5.ZodIssueCode.invalid_type
            });
            return $hsktY.INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            (0, $hsktY.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $gHWn5.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $5eede926564c4e6a$var$ZodEnum.create(values);
    }
    exclude(values) {
        return $5eede926564c4e6a$var$ZodEnum.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
module.exports.ZodEnum = $5eede926564c4e6a$var$ZodEnum;
$5eede926564c4e6a$var$ZodEnum.create = $5eede926564c4e6a$var$createZodEnum;
class $5eede926564c4e6a$var$ZodNativeEnum extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const nativeEnumValues = $frwQP.util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.string && ctx.parsedType !== $frwQP.ZodParsedType.number) {
            const expectedValues = $frwQP.util.objectValues(nativeEnumValues);
            (0, $hsktY.addIssueToContext)(ctx, {
                expected: $frwQP.util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $gHWn5.ZodIssueCode.invalid_type
            });
            return $hsktY.INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $frwQP.util.objectValues(nativeEnumValues);
            (0, $hsktY.addIssueToContext)(ctx, {
                received: ctx.data,
                code: $gHWn5.ZodIssueCode.invalid_enum_value,
                options: expectedValues
            });
            return $hsktY.INVALID;
        }
        return (0, $hsktY.OK)(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
module.exports.ZodNativeEnum = $5eede926564c4e6a$var$ZodNativeEnum;
$5eede926564c4e6a$var$ZodNativeEnum.create = (values, params)=>{
    return new $5eede926564c4e6a$var$ZodNativeEnum({
        values: values,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNativeEnum,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodPromise extends $5eede926564c4e6a$var$ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $frwQP.ZodParsedType.promise && ctx.common.async === false) {
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.promise,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        const promisified = ctx.parsedType === $frwQP.ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
        return (0, $hsktY.OK)(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
module.exports.ZodPromise = $5eede926564c4e6a$var$ZodPromise;
$5eede926564c4e6a$var$ZodPromise.create = (schema, params)=>{
    return new $5eede926564c4e6a$var$ZodPromise({
        type: schema,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodPromise,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodEffects extends $5eede926564c4e6a$var$ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                (0, $hsktY.addIssueToContext)(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $hsktY.INVALID;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $hsktY.INVALID;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!(0, $hsktY.isValid)(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!(0, $hsktY.isValid)(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $frwQP.util.assertNever(effect);
    }
}
module.exports.ZodEffects = $5eede926564c4e6a$var$ZodEffects;
module.exports.ZodTransformer = $5eede926564c4e6a$var$ZodEffects;
$5eede926564c4e6a$var$ZodEffects.create = (schema, effect, params)=>{
    return new $5eede926564c4e6a$var$ZodEffects({
        schema: schema,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEffects,
        effect: effect,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
$5eede926564c4e6a$var$ZodEffects.createWithPreprocess = (preprocess, schema, params)=>{
    return new $5eede926564c4e6a$var$ZodEffects({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodEffects,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodOptional extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $frwQP.ZodParsedType.undefined) return (0, $hsktY.OK)(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
module.exports.ZodOptional = $5eede926564c4e6a$var$ZodOptional;
$5eede926564c4e6a$var$ZodOptional.create = (type, params)=>{
    return new $5eede926564c4e6a$var$ZodOptional({
        innerType: type,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodOptional,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodNullable extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $frwQP.ZodParsedType.null) return (0, $hsktY.OK)(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
module.exports.ZodNullable = $5eede926564c4e6a$var$ZodNullable;
$5eede926564c4e6a$var$ZodNullable.create = (type, params)=>{
    return new $5eede926564c4e6a$var$ZodNullable({
        innerType: type,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNullable,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodDefault extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $frwQP.ZodParsedType.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
module.exports.ZodDefault = $5eede926564c4e6a$var$ZodDefault;
$5eede926564c4e6a$var$ZodDefault.create = (type, params)=>{
    return new $5eede926564c4e6a$var$ZodDefault({
        innerType: type,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodCatch extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ((0, $hsktY.isAsync)(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $gHWn5.ZodError(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $gHWn5.ZodError(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
module.exports.ZodCatch = $5eede926564c4e6a$var$ZodCatch;
$5eede926564c4e6a$var$ZodCatch.create = (type, params)=>{
    return new $5eede926564c4e6a$var$ZodCatch({
        innerType: type,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
class $5eede926564c4e6a$var$ZodNaN extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $frwQP.ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            (0, $hsktY.addIssueToContext)(ctx, {
                code: $gHWn5.ZodIssueCode.invalid_type,
                expected: $frwQP.ZodParsedType.nan,
                received: ctx.parsedType
            });
            return $hsktY.INVALID;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
module.exports.ZodNaN = $5eede926564c4e6a$var$ZodNaN;
$5eede926564c4e6a$var$ZodNaN.create = (params)=>{
    return new $5eede926564c4e6a$var$ZodNaN({
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodNaN,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
module.exports.BRAND = Symbol("zod_brand");
class $5eede926564c4e6a$var$ZodBranded extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
module.exports.ZodBranded = $5eede926564c4e6a$var$ZodBranded;
class $5eede926564c4e6a$var$ZodPipeline extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $hsktY.INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return (0, $hsktY.DIRTY)(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $hsktY.INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $5eede926564c4e6a$var$ZodPipeline({
            in: a,
            out: b,
            typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodPipeline
        });
    }
}
module.exports.ZodPipeline = $5eede926564c4e6a$var$ZodPipeline;
class $5eede926564c4e6a$var$ZodReadonly extends $5eede926564c4e6a$var$ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ((0, $hsktY.isValid)(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
module.exports.ZodReadonly = $5eede926564c4e6a$var$ZodReadonly;
$5eede926564c4e6a$var$ZodReadonly.create = (type, params)=>{
    return new $5eede926564c4e6a$var$ZodReadonly({
        innerType: type,
        typeName: $5eede926564c4e6a$var$ZodFirstPartyTypeKind.ZodReadonly,
        ...$5eede926564c4e6a$var$processCreateParams(params)
    });
};
const $5eede926564c4e6a$var$custom = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $5eede926564c4e6a$var$ZodAny.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $5eede926564c4e6a$var$ZodAny.create();
};
module.exports.custom = $5eede926564c4e6a$var$custom;
module.exports.late = {
    object: $5eede926564c4e6a$var$ZodObject.lazycreate
};
var $5eede926564c4e6a$var$ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($5eede926564c4e6a$var$ZodFirstPartyTypeKind = module.exports.ZodFirstPartyTypeKind || (module.exports.ZodFirstPartyTypeKind = {}));
// requires TS 4.4+
class $5eede926564c4e6a$var$Class {
    constructor(..._){}
}
const $5eede926564c4e6a$var$instanceOfType = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>(0, module.exports.custom)((data)=>data instanceof cls, params);
module.exports.instanceof = $5eede926564c4e6a$var$instanceOfType;
const $5eede926564c4e6a$var$stringType = $5eede926564c4e6a$var$ZodString.create;
module.exports.string = $5eede926564c4e6a$var$stringType;
const $5eede926564c4e6a$var$numberType = $5eede926564c4e6a$var$ZodNumber.create;
module.exports.number = $5eede926564c4e6a$var$numberType;
const $5eede926564c4e6a$var$nanType = $5eede926564c4e6a$var$ZodNaN.create;
module.exports.nan = $5eede926564c4e6a$var$nanType;
const $5eede926564c4e6a$var$bigIntType = $5eede926564c4e6a$var$ZodBigInt.create;
module.exports.bigint = $5eede926564c4e6a$var$bigIntType;
const $5eede926564c4e6a$var$booleanType = $5eede926564c4e6a$var$ZodBoolean.create;
module.exports.boolean = $5eede926564c4e6a$var$booleanType;
const $5eede926564c4e6a$var$dateType = $5eede926564c4e6a$var$ZodDate.create;
module.exports.date = $5eede926564c4e6a$var$dateType;
const $5eede926564c4e6a$var$symbolType = $5eede926564c4e6a$var$ZodSymbol.create;
module.exports.symbol = $5eede926564c4e6a$var$symbolType;
const $5eede926564c4e6a$var$undefinedType = $5eede926564c4e6a$var$ZodUndefined.create;
module.exports.undefined = $5eede926564c4e6a$var$undefinedType;
const $5eede926564c4e6a$var$nullType = $5eede926564c4e6a$var$ZodNull.create;
module.exports.null = $5eede926564c4e6a$var$nullType;
const $5eede926564c4e6a$var$anyType = $5eede926564c4e6a$var$ZodAny.create;
module.exports.any = $5eede926564c4e6a$var$anyType;
const $5eede926564c4e6a$var$unknownType = $5eede926564c4e6a$var$ZodUnknown.create;
module.exports.unknown = $5eede926564c4e6a$var$unknownType;
const $5eede926564c4e6a$var$neverType = $5eede926564c4e6a$var$ZodNever.create;
module.exports.never = $5eede926564c4e6a$var$neverType;
const $5eede926564c4e6a$var$voidType = $5eede926564c4e6a$var$ZodVoid.create;
module.exports.void = $5eede926564c4e6a$var$voidType;
const $5eede926564c4e6a$var$arrayType = $5eede926564c4e6a$var$ZodArray.create;
module.exports.array = $5eede926564c4e6a$var$arrayType;
const $5eede926564c4e6a$var$objectType = $5eede926564c4e6a$var$ZodObject.create;
module.exports.object = $5eede926564c4e6a$var$objectType;
const $5eede926564c4e6a$var$strictObjectType = $5eede926564c4e6a$var$ZodObject.strictCreate;
module.exports.strictObject = $5eede926564c4e6a$var$strictObjectType;
const $5eede926564c4e6a$var$unionType = $5eede926564c4e6a$var$ZodUnion.create;
module.exports.union = $5eede926564c4e6a$var$unionType;
const $5eede926564c4e6a$var$discriminatedUnionType = $5eede926564c4e6a$var$ZodDiscriminatedUnion.create;
module.exports.discriminatedUnion = $5eede926564c4e6a$var$discriminatedUnionType;
const $5eede926564c4e6a$var$intersectionType = $5eede926564c4e6a$var$ZodIntersection.create;
module.exports.intersection = $5eede926564c4e6a$var$intersectionType;
const $5eede926564c4e6a$var$tupleType = $5eede926564c4e6a$var$ZodTuple.create;
module.exports.tuple = $5eede926564c4e6a$var$tupleType;
const $5eede926564c4e6a$var$recordType = $5eede926564c4e6a$var$ZodRecord.create;
module.exports.record = $5eede926564c4e6a$var$recordType;
const $5eede926564c4e6a$var$mapType = $5eede926564c4e6a$var$ZodMap.create;
module.exports.map = $5eede926564c4e6a$var$mapType;
const $5eede926564c4e6a$var$setType = $5eede926564c4e6a$var$ZodSet.create;
module.exports.set = $5eede926564c4e6a$var$setType;
const $5eede926564c4e6a$var$functionType = $5eede926564c4e6a$var$ZodFunction.create;
module.exports.function = $5eede926564c4e6a$var$functionType;
const $5eede926564c4e6a$var$lazyType = $5eede926564c4e6a$var$ZodLazy.create;
module.exports.lazy = $5eede926564c4e6a$var$lazyType;
const $5eede926564c4e6a$var$literalType = $5eede926564c4e6a$var$ZodLiteral.create;
module.exports.literal = $5eede926564c4e6a$var$literalType;
const $5eede926564c4e6a$var$enumType = $5eede926564c4e6a$var$ZodEnum.create;
module.exports.enum = $5eede926564c4e6a$var$enumType;
const $5eede926564c4e6a$var$nativeEnumType = $5eede926564c4e6a$var$ZodNativeEnum.create;
module.exports.nativeEnum = $5eede926564c4e6a$var$nativeEnumType;
const $5eede926564c4e6a$var$promiseType = $5eede926564c4e6a$var$ZodPromise.create;
module.exports.promise = $5eede926564c4e6a$var$promiseType;
const $5eede926564c4e6a$var$effectsType = $5eede926564c4e6a$var$ZodEffects.create;
module.exports.effect = $5eede926564c4e6a$var$effectsType;
module.exports.transformer = $5eede926564c4e6a$var$effectsType;
const $5eede926564c4e6a$var$optionalType = $5eede926564c4e6a$var$ZodOptional.create;
module.exports.optional = $5eede926564c4e6a$var$optionalType;
const $5eede926564c4e6a$var$nullableType = $5eede926564c4e6a$var$ZodNullable.create;
module.exports.nullable = $5eede926564c4e6a$var$nullableType;
const $5eede926564c4e6a$var$preprocessType = $5eede926564c4e6a$var$ZodEffects.createWithPreprocess;
module.exports.preprocess = $5eede926564c4e6a$var$preprocessType;
const $5eede926564c4e6a$var$pipelineType = $5eede926564c4e6a$var$ZodPipeline.create;
module.exports.pipeline = $5eede926564c4e6a$var$pipelineType;
const $5eede926564c4e6a$var$ostring = ()=>$5eede926564c4e6a$var$stringType().optional();
module.exports.ostring = $5eede926564c4e6a$var$ostring;
const $5eede926564c4e6a$var$onumber = ()=>$5eede926564c4e6a$var$numberType().optional();
module.exports.onumber = $5eede926564c4e6a$var$onumber;
const $5eede926564c4e6a$var$oboolean = ()=>$5eede926564c4e6a$var$booleanType().optional();
module.exports.oboolean = $5eede926564c4e6a$var$oboolean;
module.exports.coerce = {
    string: (arg)=>$5eede926564c4e6a$var$ZodString.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$5eede926564c4e6a$var$ZodNumber.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$5eede926564c4e6a$var$ZodBoolean.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$5eede926564c4e6a$var$ZodBigInt.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$5eede926564c4e6a$var$ZodDate.create({
            ...arg,
            coerce: true
        })
};
module.exports.NEVER = $hsktY.INVALID;

});
parcelRegister("aXv8r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errorUtil = void 0;
var $7fa790deca21759f$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($7fa790deca21759f$var$errorUtil = module.exports.errorUtil || (module.exports.errorUtil = {}));

});



parcelRegister("hj6VI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.handleResponse = void 0;

var $9jILv = parcelRequire("9jILv");

var $cPUDX = parcelRequire("cPUDX");
async function $c99996221ff324c5$var$handleResponse(requestUrl, response) {
    // Use text() instead of json() as the error body might not be json data
    const body = await response.text();
    if (body.length === 0) throw new $9jILv.ResponseError(204, "Unexpected 204 response.", $cPUDX.RequestErrorKind.NoContentException, "");
    if (!response.ok) {
        const status = response.status;
        switch(status){
            case 401:
                throw new $9jILv.ResponseError(response.status, "Unauthorised request, likely due to an invalid API key.", $cPUDX.RequestErrorKind.UnauthorisedRequestException, JSON.stringify(body));
            case 400:
                throw new $9jILv.ResponseError(response.status, "Bad request, likely due to invalid parameters.", $cPUDX.RequestErrorKind.BadRequestException, JSON.stringify(body));
            case 404:
                throw new $9jILv.ResponseError(response.status, `Request to ${requestUrl} gave 404 resource not found exception.`, $cPUDX.RequestErrorKind.NotFoundException, JSON.stringify(body));
            case 429:
                throw new $9jILv.ResponseError(response.status, "Rate limiting exception occurred.", $cPUDX.RequestErrorKind.RateLimitedException, JSON.stringify(body));
            default:
                throw new $9jILv.ResponseError(response.status, `Non 2xx response status received.`, $cPUDX.RequestErrorKind.UnknownException, JSON.stringify(body));
        }
    }
    return body;
}
module.exports.handleResponse = $c99996221ff324c5$var$handleResponse;

});
parcelRegister("9jILv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResponseError = void 0;

var $cPUDX = parcelRequire("cPUDX");
/**
 * @class ResponseError - Thrown when a non 200 response was received from a fetch request.
 * @extends Error
 * @param {number} status - The status code of the response.
 * @param {string} message - The error message.
 * @param {RequestErrorKind} kind - The error kind.
 * @param {string} body - The response body.
 */ class $6c889cda5becc27f$var$ResponseError extends Error {
    constructor(status, message, kind = $cPUDX.RequestErrorKind.UnknownException, body){
        super(message);
        this.status = status;
        this.kind = kind;
        this.body = body;
    }
}
module.exports.ResponseError = $6c889cda5becc27f$var$ResponseError;

});
parcelRegister("cPUDX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestErrorKind = module.exports.FeatureGateProducts = void 0;
/**
 * @enum {FeatureGateProducts}
 * The union of Products will be used to filter appropriate feature gates and experiments
 */ var $95862fab95573400$var$FeatureGateProducts;
(function(FeatureGateProducts) {
    FeatureGateProducts["Jira"] = "jira";
    FeatureGateProducts["Confluence"] = "confluence";
    FeatureGateProducts["AdminHub"] = "adminhub";
    FeatureGateProducts["Platform"] = "platform";
})($95862fab95573400$var$FeatureGateProducts || (module.exports.FeatureGateProducts = $95862fab95573400$var$FeatureGateProducts = {}));
/**
 * @enum {string}
 * @property {BadRequestException} - The server request responds with 400, likely due to an invalid parameters.
 * @property {UnauthorisedRequestException} - The server request responds with 401, likely due to an invalid API key.
 * @property {UnknownException} - General exception thrown for all other non 200 request responses.
 * @property {IllegalStateException} - The client was unable to retrieve the `feature-flag-service` service proxy url upon instantiation
 * @property {NoContentException} - The server request responds with 204 due to empty response body.
 * @property {RateLimitedException} - The server request responds with 429 due to rate limiting.
 * @property {BadResponseException} - The server request responded with an unexpected type that could not be parsed.
 * @property {NotFoundException} - The server request responded with a 404, most likely due to a bad request url.
 * @property {ClientNotInitializedException} - The FeatureGates client was not initialized.
 */ var $95862fab95573400$var$RequestErrorKind;
(function(RequestErrorKind) {
    RequestErrorKind["BadRequestException"] = "BadRequestException";
    RequestErrorKind["UnauthorisedRequestException"] = "UnauthorisedRequestException";
    RequestErrorKind["IllegalStateException"] = "IllegalStateException";
    RequestErrorKind["UnknownException"] = "UnknownException";
    RequestErrorKind["NoContentException"] = "NoContentException";
    RequestErrorKind["RateLimitedException"] = "RateLimitedException";
    RequestErrorKind["BadResponseException"] = "BadResponseException";
    RequestErrorKind["NotFoundException"] = "NotFoundException";
    RequestErrorKind["ClientNotInitializedException"] = "ClientNotInitializedException";
})($95862fab95573400$var$RequestErrorKind || (module.exports.RequestErrorKind = $95862fab95573400$var$RequestErrorKind = {}));

});



parcelRegister("jgDTn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e06e74b229c8bd64$var$Environment;
(function(Environment) {
    Environment["TEST"] = "test";
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STAGE"] = "stage";
    Environment["PROD"] = "prod";
})($e06e74b229c8bd64$var$Environment = module.exports.Environment || (module.exports.Environment = {}));
var $e06e74b229c8bd64$var$XIDItemType;
(function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
})($e06e74b229c8bd64$var$XIDItemType = module.exports.XIDItemType || (module.exports.XIDItemType = {}));
var $e06e74b229c8bd64$var$XIDState;
(function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
})($e06e74b229c8bd64$var$XIDState = module.exports.XIDState || (module.exports.XIDState = {}));
var $e06e74b229c8bd64$var$XIDGenerateMode;
(function(XIDGenerateMode) {
    XIDGenerateMode["XC_ONLY"] = "XC_ONLY";
    XIDGenerateMode["UID_ONLY"] = "UID_ONLY";
    XIDGenerateMode["CACHE_ONLY"] = "CACHE_ONLY";
    XIDGenerateMode["XC_UID"] = "XC_UID";
    XIDGenerateMode["CACHE_XC_UID"] = "CACHE_XC_UID";
})($e06e74b229c8bd64$var$XIDGenerateMode = module.exports.XIDGenerateMode || (module.exports.XIDGenerateMode = {}));

});

parcelRegister("eujLS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a8c3342a98db43c8$export$2e2bcd8739ae039; });

var $7FlzC = parcelRequire("7FlzC");

var $9jrwD = parcelRequire("9jrwD");

var $9upMJ = parcelRequire("9upMJ");
// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var $a8c3342a98db43c8$var$setTimeoutFunc = setTimeout;
function $a8c3342a98db43c8$var$isArray(x) {
    return Boolean(x && typeof x.length !== "undefined");
}
function $a8c3342a98db43c8$var$noop() {}
// Polyfill for Function.prototype.bind
function $a8c3342a98db43c8$var$bind(fn, thisArg) {
    return function() {
        fn.apply(thisArg, arguments);
    };
}
/**
 * @constructor
 * @param {Function} fn
 */ function $a8c3342a98db43c8$var$Promise(fn) {
    if (!(this instanceof $a8c3342a98db43c8$var$Promise)) throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function") throw new TypeError("not a function");
    /** @type {!number} */ this._state = 0;
    /** @type {!boolean} */ this._handled = false;
    /** @type {Promise|undefined} */ this._value = undefined;
    /** @type {!Array<!Function>} */ this._deferreds = [];
    $a8c3342a98db43c8$var$doResolve(fn, this);
}
function $a8c3342a98db43c8$var$handle(self, deferred) {
    while(self._state === 3)self = self._value;
    if (self._state === 0) {
        self._deferreds.push(deferred);
        return;
    }
    self._handled = true;
    $a8c3342a98db43c8$var$Promise._immediateFn(function() {
        var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
        if (cb === null) {
            (self._state === 1 ? $a8c3342a98db43c8$var$resolve : $a8c3342a98db43c8$var$reject)(deferred.promise, self._value);
            return;
        }
        var ret;
        try {
            ret = cb(self._value);
        } catch (e) {
            $a8c3342a98db43c8$var$reject(deferred.promise, e);
            return;
        }
        $a8c3342a98db43c8$var$resolve(deferred.promise, ret);
    });
}
function $a8c3342a98db43c8$var$resolve(self, newValue) {
    try {
        // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
        if (newValue === self) throw new TypeError("A promise cannot be resolved with itself.");
        if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
            var then = newValue.then;
            if (newValue instanceof $a8c3342a98db43c8$var$Promise) {
                self._state = 3;
                self._value = newValue;
                $a8c3342a98db43c8$var$finale(self);
                return;
            } else if (typeof then === "function") {
                $a8c3342a98db43c8$var$doResolve($a8c3342a98db43c8$var$bind(then, newValue), self);
                return;
            }
        }
        self._state = 1;
        self._value = newValue;
        $a8c3342a98db43c8$var$finale(self);
    } catch (e) {
        $a8c3342a98db43c8$var$reject(self, e);
    }
}
function $a8c3342a98db43c8$var$reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    $a8c3342a98db43c8$var$finale(self);
}
function $a8c3342a98db43c8$var$finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) $a8c3342a98db43c8$var$Promise._immediateFn(function() {
        if (!self._handled) $a8c3342a98db43c8$var$Promise._unhandledRejectionFn(self._value);
    });
    for(var i = 0, len = self._deferreds.length; i < len; i++)$a8c3342a98db43c8$var$handle(self, self._deferreds[i]);
    self._deferreds = null;
}
/**
 * @constructor
 */ function $a8c3342a98db43c8$var$Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
}
/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */ function $a8c3342a98db43c8$var$doResolve(fn, self) {
    var done = false;
    try {
        fn(function(value) {
            if (done) return;
            done = true;
            $a8c3342a98db43c8$var$resolve(self, value);
        }, function(reason) {
            if (done) return;
            done = true;
            $a8c3342a98db43c8$var$reject(self, reason);
        });
    } catch (ex) {
        if (done) return;
        done = true;
        $a8c3342a98db43c8$var$reject(self, ex);
    }
}
$a8c3342a98db43c8$var$Promise.prototype["catch"] = function(onRejected) {
    return this.then(null, onRejected);
};
$a8c3342a98db43c8$var$Promise.prototype.then = function(onFulfilled, onRejected) {
    // @ts-ignore
    var prom = new this.constructor($a8c3342a98db43c8$var$noop);
    $a8c3342a98db43c8$var$handle(this, new $a8c3342a98db43c8$var$Handler(onFulfilled, onRejected, prom));
    return prom;
};
$a8c3342a98db43c8$var$Promise.prototype["finally"] = (0, $7FlzC.default);
$a8c3342a98db43c8$var$Promise.all = function(arr) {
    return new $a8c3342a98db43c8$var$Promise(function(resolve, reject) {
        if (!$a8c3342a98db43c8$var$isArray(arr)) return reject(new TypeError("Promise.all accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            try {
                if (val && (typeof val === "object" || typeof val === "function")) {
                    var then = val.then;
                    if (typeof then === "function") {
                        then.call(val, function(val) {
                            res(i, val);
                        }, reject);
                        return;
                    }
                }
                args[i] = val;
                if (--remaining === 0) resolve(args);
            } catch (ex) {
                reject(ex);
            }
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
};
$a8c3342a98db43c8$var$Promise.any = (0, $9upMJ.default);
$a8c3342a98db43c8$var$Promise.allSettled = (0, $9jrwD.default);
$a8c3342a98db43c8$var$Promise.resolve = function(value) {
    if (value && typeof value === "object" && value.constructor === $a8c3342a98db43c8$var$Promise) return value;
    return new $a8c3342a98db43c8$var$Promise(function(resolve) {
        resolve(value);
    });
};
$a8c3342a98db43c8$var$Promise.reject = function(value) {
    return new $a8c3342a98db43c8$var$Promise(function(resolve, reject) {
        reject(value);
    });
};
$a8c3342a98db43c8$var$Promise.race = function(arr) {
    return new $a8c3342a98db43c8$var$Promise(function(resolve, reject) {
        if (!$a8c3342a98db43c8$var$isArray(arr)) return reject(new TypeError("Promise.race accepts an array"));
        for(var i = 0, len = arr.length; i < len; i++)$a8c3342a98db43c8$var$Promise.resolve(arr[i]).then(resolve, reject);
    });
};
// Use polyfill for setImmediate for performance gains
$a8c3342a98db43c8$var$Promise._immediateFn = // @ts-ignore
typeof setImmediate === "function" && function(fn) {
    // @ts-ignore
    setImmediate(fn);
} || function(fn) {
    $a8c3342a98db43c8$var$setTimeoutFunc(fn, 0);
};
$a8c3342a98db43c8$var$Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== "undefined" && console) console.warn("Possible Unhandled Promise Rejection:", err); // eslint-disable-line no-console
};
var $a8c3342a98db43c8$export$2e2bcd8739ae039 = $a8c3342a98db43c8$var$Promise;

});
parcelRegister("7FlzC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $594d18c5dcffbe52$export$2e2bcd8739ae039; });
/**
 * @this {Promise}
 */ function $594d18c5dcffbe52$var$finallyConstructor(callback) {
    var constructor = this.constructor;
    return this.then(function(value) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            return value;
        });
    }, function(reason) {
        // @ts-ignore
        return constructor.resolve(callback()).then(function() {
            // @ts-ignore
            return constructor.reject(reason);
        });
    });
}
var $594d18c5dcffbe52$export$2e2bcd8739ae039 = $594d18c5dcffbe52$var$finallyConstructor;

});

parcelRegister("9jrwD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c7b3d5a31f5351a$export$2e2bcd8739ae039; });
function $6c7b3d5a31f5351a$var$allSettled(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError(typeof arr + " " + arr + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return resolve([]);
        var remaining = args.length;
        function res(i, val) {
            if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                    then.call(val, function(val) {
                        res(i, val);
                    }, function(e) {
                        args[i] = {
                            status: "rejected",
                            reason: e
                        };
                        if (--remaining === 0) resolve(args);
                    });
                    return;
                }
            }
            args[i] = {
                status: "fulfilled",
                value: val
            };
            if (--remaining === 0) resolve(args);
        }
        for(var i = 0; i < args.length; i++)res(i, args[i]);
    });
}
var $6c7b3d5a31f5351a$export$2e2bcd8739ae039 = $6c7b3d5a31f5351a$var$allSettled;

});

parcelRegister("9upMJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e8aeac2b1cbfcf9$export$2e2bcd8739ae039; });
/**
 * @constructor
 */ function $6e8aeac2b1cbfcf9$var$AggregateError(errors, message) {
    this.name = "AggregateError", this.errors = errors;
    this.message = message || "";
}
$6e8aeac2b1cbfcf9$var$AggregateError.prototype = Error.prototype;
function $6e8aeac2b1cbfcf9$var$any(arr) {
    var P = this;
    return new P(function(resolve, reject) {
        if (!(arr && typeof arr.length !== "undefined")) return reject(new TypeError("Promise.any accepts an array"));
        var args = Array.prototype.slice.call(arr);
        if (args.length === 0) return reject();
        var rejectionReasons = [];
        for(var i = 0; i < args.length; i++)try {
            P.resolve(args[i]).then(resolve).catch(function(error) {
                rejectionReasons.push(error);
                if (rejectionReasons.length === args.length) reject(new $6e8aeac2b1cbfcf9$var$AggregateError(rejectionReasons, "All promises were rejected"));
            });
        } catch (ex) {
            reject(ex);
        }
    });
}
var $6e8aeac2b1cbfcf9$export$2e2bcd8739ae039 = $6e8aeac2b1cbfcf9$var$any;

});


parcelRegister("dB5ic", function(module, exports) {

$parcel$export(module.exports, "startLighthouseObserver", function () { return $9e62d6103f8bf55b$export$5ecf2aafafee3e0; });
$parcel$export(module.exports, "getLighthouseMetrics", function () { return $9e62d6103f8bf55b$export$b46cecdf698e4bb5; });

var $axfmD = parcelRequire("axfmD");

var $lmE5S = parcelRequire("lmE5S");

var $laSND = parcelRequire("laSND");

var $gFDYV = parcelRequire("gFDYV");

var $kwLSV = parcelRequire("kwLSV");
function $9e62d6103f8bf55b$export$5ecf2aafafee3e0() {
    (0, $kwLSV.startLSObserver)();
    (0, $kwLSV.startLTObserver)();
}
function $9e62d6103f8bf55b$export$b46cecdf698e4bb5(_ref) {
    var start = _ref.start, stop = _ref.stop;
    var tbt = (0, $laSND.getTBT)(start, stop, (0, $gFDYV.EntriesBuffer)[(0, $lmE5S.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    var cls = (0, $axfmD.getCLS)(start, stop, (0, $gFDYV.EntriesBuffer)[(0, $lmE5S.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        "metric:tbt": Math.round(tbt.total),
        "metric:tbt:observed": Math.round(tbt.observed),
        "metric:cls": cls
    };
}

});
parcelRegister("axfmD", function(module, exports) {

$parcel$export(module.exports, "getCLS", function () { return $7ab8e771dff87e48$export$fc6227831ee7c7; });

var $jxLBU = parcelRequire("jxLBU");
function $7ab8e771dff87e48$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7ab8e771dff87e48$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7ab8e771dff87e48$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7ab8e771dff87e48$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7ab8e771dff87e48$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7ab8e771dff87e48$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7ab8e771dff87e48$var$isSameRects(rect1, rect2) {
    return rect1.x === rect2.x && rect1.y === rect2.y && rect1.width === rect2.width && rect1.height === rect2.height && rect1.top === rect2.top && rect1.right === rect2.right && rect1.bottom === rect2.bottom && rect1.left === rect2.left;
}
function $7ab8e771dff87e48$export$fc6227831ee7c7(start, stop, buffer) {
    var layoutShifts = buffer.getAll().filter(function(_entry) {
        var entry = _entry;
        var isWithinObservationWindow = entry.startTime >= start && entry.startTime <= stop;
        if ((0, $jxLBU.fg)("platform_ufo_filter_cls_logs_same_rects_positions")) {
            var _entry$sources;
            var allSourcesHaveSameRects = entry === null || entry === void 0 || (_entry$sources = entry.sources) === null || _entry$sources === void 0 ? void 0 : _entry$sources.every(function(_ref) {
                var previousRect = _ref.previousRect, currentRect = _ref.currentRect;
                return $7ab8e771dff87e48$var$isSameRects(previousRect, currentRect);
            });
            return isWithinObservationWindow && !allSourcesHaveSameRects;
        }
        return isWithinObservationWindow;
    });
    var sessionWindows = [];
    var currentWindow = null;
    // Group layout shifts into session windows
    var _iterator = $7ab8e771dff87e48$var$_createForOfIteratorHelper(layoutShifts), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var shift = _step.value;
            var startTime = shift.startTime;
            var endTime = shift.startTime + shift.duration;
            var score = shift.value;
            if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
                // Start a new session window
                currentWindow = {
                    startTime: startTime,
                    endTime: endTime,
                    score: score
                };
                sessionWindows.push(currentWindow);
            } else {
                // Add layout shift to current session window
                currentWindow.endTime = endTime;
                currentWindow.score += score;
            }
        }
    // Find session window with highest cumulative score
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var maxScore = sessionWindows.reduce(function(max, sessionWindow) {
        return sessionWindow.score > max ? sessionWindow.score : max;
    }, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
}

});

parcelRegister("lmE5S", function(module, exports) {

$parcel$export(module.exports, "PerformanceObserverEntryTypes", function () { return $f8dac0d138fe0d89$export$a4def92db6fc8e17; });
var $f8dac0d138fe0d89$export$a4def92db6fc8e17 = {
    LayoutShift: "layout-shift",
    LongTask: "longtask"
};

});

parcelRegister("laSND", function(module, exports) {

$parcel$export(module.exports, "getTBT", function () { return $f6a50a2d2f5ee5d8$export$2d6e933b35bd3407; });
var $f6a50a2d2f5ee5d8$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
function $f6a50a2d2f5ee5d8$export$2d6e933b35bd3407(start, stop, buffer) {
    return buffer.getAll().filter(function(entry) {
        return entry.startTime <= stop && entry.duration > $f6a50a2d2f5ee5d8$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop);
    }).reduce(function(tbt, entry) {
        var longTaskStop = entry.startTime + entry.duration;
        var intersectStart = Math.max(entry.startTime + $f6a50a2d2f5ee5d8$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        var intersectStop = Math.min(longTaskStop, stop);
        var longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $f6a50a2d2f5ee5d8$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });
}

});

parcelRegister("gFDYV", function(module, exports) {

$parcel$export(module.exports, "EntriesBuffer", function () { return $c22f7d34527db346$export$f7dc16cbd16f7bbe; });

var $i385U = parcelRequire("i385U");

var $c19Op = parcelRequire("c19Op");

var $dqOGO = parcelRequire("dqOGO");

var $lmE5S = parcelRequire("lmE5S");
var $c22f7d34527db346$export$2c6e86519c9e8188 = /*#__PURE__*/ function() {
    function BufferWithMaxLength() {
        var maxLength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
        (0, $i385U.default)(this, BufferWithMaxLength);
        (0, $dqOGO.default)(this, "buffer", []);
        (0, $dqOGO.default)(this, "full", false);
        this.maxLength = maxLength;
    }
    return (0, $c19Op.default)(BufferWithMaxLength, [
        {
            key: "push",
            value: function push(item) {
                if (this.full || this.maxLength === this.buffer.length) {
                    this.full = true;
                    this.buffer.shift();
                }
                this.buffer.push(item);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                return this.buffer;
            }
        }
    ]);
}();
var $c22f7d34527db346$export$f7dc16cbd16f7bbe = (0, $dqOGO.default)((0, $dqOGO.default)({}, (0, $lmE5S.PerformanceObserverEntryTypes).LongTask, new $c22f7d34527db346$export$2c6e86519c9e8188()), (0, $lmE5S.PerformanceObserverEntryTypes).LayoutShift, new $c22f7d34527db346$export$2c6e86519c9e8188());

});

parcelRegister("kwLSV", function(module, exports) {

$parcel$export(module.exports, "startLSObserver", function () { return $ef1bf0c5b07f0f80$export$768ccc3ab7bac3ea; });
$parcel$export(module.exports, "startLTObserver", function () { return $ef1bf0c5b07f0f80$export$54fb8b6aaf70ec9c; });

var $lmE5S = parcelRequire("lmE5S");

var $gFDYV = parcelRequire("gFDYV");
var $ef1bf0c5b07f0f80$var$pe = null;
function $ef1bf0c5b07f0f80$var$getObserver() {
    if (typeof PerformanceObserver !== "function") // Only instantiate the IntersectionObserver if it's supported
    return null;
    if ($ef1bf0c5b07f0f80$var$pe !== null) return $ef1bf0c5b07f0f80$var$pe;
    var performanceObserverCallback = function performanceObserverCallback(list) {
        list.getEntries().forEach(function(entry) {
            if (entry.entryType === (0, $lmE5S.PerformanceObserverEntryTypes).LayoutShift) (0, $gFDYV.EntriesBuffer)[(0, $lmE5S.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $lmE5S.PerformanceObserverEntryTypes).LongTask) (0, $gFDYV.EntriesBuffer)[(0, $lmE5S.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    };
    $ef1bf0c5b07f0f80$var$pe = new PerformanceObserver(performanceObserverCallback);
    return $ef1bf0c5b07f0f80$var$pe;
}
function $ef1bf0c5b07f0f80$export$768ccc3ab7bac3ea() {
    var _getObserver;
    (_getObserver = $ef1bf0c5b07f0f80$var$getObserver()) === null || _getObserver === void 0 || _getObserver.observe({
        type: (0, $lmE5S.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
}
function $ef1bf0c5b07f0f80$export$54fb8b6aaf70ec9c() {
    var _getObserver2;
    (_getObserver2 = $ef1bf0c5b07f0f80$var$getObserver()) === null || _getObserver2 === void 0 || _getObserver2.observe({
        type: (0, $lmE5S.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
}

});


parcelRegister("iGJx8", function(module, exports) {

$parcel$export(module.exports, "createPressureStateReport", function () { return $d9af783aa53769aa$export$1f0ff35da084986e; });
$parcel$export(module.exports, "createMemoryStateReport", function () { return $d9af783aa53769aa$export$3b47ebb9832b4e24; });
$parcel$export(module.exports, "initialisePressureObserver", function () { return $d9af783aa53769aa$export$117ebc554c6e9f2f; });
$parcel$export(module.exports, "initialiseMemoryObserver", function () { return $d9af783aa53769aa$export$a3271f53e91faab7; });

var $1m3mf = parcelRequire("1m3mf");
var $d9af783aa53769aa$var$BUFFER_MAX_LENGTH = 1000; // ensure we don't blow up this buffer
var $d9af783aa53769aa$var$pressureRecordBuffer = [];
var $d9af783aa53769aa$var$pressureObserver = null;
var $d9af783aa53769aa$var$memoryRecordBuffer = [];
var $d9af783aa53769aa$var$memoryInterval;
function $d9af783aa53769aa$export$6c1060bed5fea050() {
    $d9af783aa53769aa$var$pressureRecordBuffer.length = 0;
}
function $d9af783aa53769aa$export$aa672c7221b183b0() {
    $d9af783aa53769aa$var$memoryRecordBuffer.length = 0;
}
function $d9af783aa53769aa$export$ec86686c1d2e65bc(filter) {
    $d9af783aa53769aa$var$pressureRecordBuffer = $d9af783aa53769aa$var$pressureRecordBuffer.filter(function(_ref) {
        var time = _ref.time;
        return time > filter;
    });
}
function $d9af783aa53769aa$export$c0142ac82f5d0c28(filter) {
    $d9af783aa53769aa$var$memoryRecordBuffer = $d9af783aa53769aa$var$memoryRecordBuffer.filter(function(_ref2) {
        var time = _ref2.time;
        return time > filter;
    });
}
function $d9af783aa53769aa$export$1f0ff35da084986e(start, end) {
    try {
        // To differentiate between the API not available, vs no PressureRecords added
        if (!("PressureObserver" in globalThis)) return null;
        var pressureStateCount = $d9af783aa53769aa$var$pressureRecordBuffer.reduce(function(pressureReport, _ref3) {
            var time = _ref3.time, state = _ref3.state;
            if (time >= start && time <= end) pressureReport[state] += 1;
            return pressureReport;
        }, {
            nominal: 0,
            fair: 0,
            serious: 0,
            critical: 0
        });
        var pressureStateTotal = Object.values(pressureStateCount).reduce(function(total, count) {
            return total + count;
        }) || 1;
        $d9af783aa53769aa$export$ec86686c1d2e65bc(end);
        return {
            count: pressureStateCount,
            percentage: {
                nominal: Math.round(pressureStateCount.nominal / pressureStateTotal * 100),
                fair: Math.round(pressureStateCount.fair / pressureStateTotal * 100),
                serious: Math.round(pressureStateCount.serious / pressureStateTotal * 100),
                critical: Math.round(pressureStateCount.critical / pressureStateTotal * 100)
            }
        };
    } catch (_unused) {
        return null;
    }
}
function $d9af783aa53769aa$var$convertBytesToMegabytes(bytes) {
    return Math.round(Math.round(bytes / 1048576 * 100) / 100);
}
function $d9af783aa53769aa$export$3b47ebb9832b4e24(start, end) {
    try {
        if (!("memory" in performance)) return null;
        var accumulatedMemoryUsage = $d9af783aa53769aa$var$memoryRecordBuffer.reduce(function(acc, snapshot) {
            if (snapshot.time >= start && snapshot.time <= end) {
                acc.totalJSHeapSize += snapshot.totalJSHeapSize;
                acc.usedJSHeapSize += snapshot.usedJSHeapSize;
                acc.snapshotCount += 1;
            }
            return acc;
        }, {
            totalJSHeapSize: 0,
            usedJSHeapSize: 0,
            snapshotCount: 0
        });
        var memoryStateReport = {
            jsHeapSizeLimitInMB: $d9af783aa53769aa$var$convertBytesToMegabytes($d9af783aa53769aa$var$memoryRecordBuffer[0].jsHeapSizeLimit),
            // just use the first record, since this value always remains the same over time
            avgTotalJSHeapSizeInMB: $d9af783aa53769aa$var$convertBytesToMegabytes(accumulatedMemoryUsage.totalJSHeapSize / accumulatedMemoryUsage.snapshotCount),
            avgUsedJSHeapSizeInMB: $d9af783aa53769aa$var$convertBytesToMegabytes(accumulatedMemoryUsage.usedJSHeapSize / accumulatedMemoryUsage.snapshotCount)
        };
        $d9af783aa53769aa$export$c0142ac82f5d0c28(end);
        return memoryStateReport;
    } catch (_unused2) {
        return null;
    }
}
function $d9af783aa53769aa$export$117ebc554c6e9f2f() {
    try {
        if ("PressureObserver" in globalThis) {
            $d9af783aa53769aa$var$pressureObserver = new PressureObserver(function(records) {
                if ($d9af783aa53769aa$var$pressureRecordBuffer.length + records.length <= $d9af783aa53769aa$var$BUFFER_MAX_LENGTH) {
                    var _pressureRecordBuffer;
                    (_pressureRecordBuffer = $d9af783aa53769aa$var$pressureRecordBuffer).push.apply(_pressureRecordBuffer, (0, $1m3mf.default)(records));
                }
            });
            $d9af783aa53769aa$var$pressureObserver.observe("cpu", {
                sampleInterval: 100
            }).catch(function() {
            // Silently handle permission policy restrictions or other observe failures
            // This prevents unhandled promise rejections from being reported to Sentry
            });
        }
    } catch (_unused3) {
    /* do nothing, this is a best efforts metric */ }
}
function $d9af783aa53769aa$export$a3271f53e91faab7() {
    try {
        // only set up the interval if `performance.memory` is available in the browser
        if ("memory" in performance) $d9af783aa53769aa$var$memoryInterval = setInterval(function() {
            // another check of `performance.memory` availability to satisfy typescript
            if ("memory" in performance) {
                var memory = performance.memory;
                if ($d9af783aa53769aa$var$memoryRecordBuffer.length <= $d9af783aa53769aa$var$BUFFER_MAX_LENGTH) $d9af783aa53769aa$var$memoryRecordBuffer.push({
                    time: performance.now(),
                    jsHeapSizeLimit: memory.jsHeapSizeLimit,
                    totalJSHeapSize: memory.totalJSHeapSize,
                    usedJSHeapSize: memory.usedJSHeapSize
                });
            }
        }, 100);
    } catch (_unused4) {
    /* do nothing, this is a best efforts metric */ }
}
function $d9af783aa53769aa$export$10899ada382f2ae3() {
    clearInterval($d9af783aa53769aa$var$memoryInterval);
}
function $d9af783aa53769aa$export$b9fdd785f0fc1d40() {
    var _pressureObserver;
    (_pressureObserver = $d9af783aa53769aa$var$pressureObserver) === null || _pressureObserver === void 0 || _pressureObserver.disconnect();
}

});

parcelRegister("bgsrj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("044UL"));

});
parcelRegister("044UL", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $00c42fc5bf826bbd$export$c4744153514ff05d; }, function (v) { return $00c42fc5bf826bbd$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $00c42fc5bf826bbd$export$3e506c1ccc9cc1a7; }, function (v) { return $00c42fc5bf826bbd$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $00c42fc5bf826bbd$export$e26fe2ed2fa76875; }, function (v) { return $00c42fc5bf826bbd$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $00c42fc5bf826bbd$export$502329bbf4b505b1; }, function (v) { return $00c42fc5bf826bbd$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $00c42fc5bf826bbd$export$6e3807111c4874c4; }, function (v) { return $00c42fc5bf826bbd$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $00c42fc5bf826bbd$export$c27134553091fb3a; }, function (v) { return $00c42fc5bf826bbd$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $00c42fc5bf826bbd$export$33ee1acdc04fd2a2; }, function (v) { return $00c42fc5bf826bbd$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $00c42fc5bf826bbd$export$b00a404bbd5edef2; }, function (v) { return $00c42fc5bf826bbd$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $00c42fc5bf826bbd$export$8352ce38b91d0c62; }, function (v) { return $00c42fc5bf826bbd$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $00c42fc5bf826bbd$export$d66a1c1c77bd778b; }, function (v) { return $00c42fc5bf826bbd$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $00c42fc5bf826bbd$export$d3dfb8e4810cb555; }, function (v) { return $00c42fc5bf826bbd$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $00c42fc5bf826bbd$export$839f9183b0465a69; }, function (v) { return $00c42fc5bf826bbd$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $00c42fc5bf826bbd$export$72fdf0e06517287b; }, function (v) { return $00c42fc5bf826bbd$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $00c42fc5bf826bbd$export$4b844e58a3e414b4; }, function (v) { return $00c42fc5bf826bbd$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $00c42fc5bf826bbd$export$816d2913ae6b83b1; }, function (v) { return $00c42fc5bf826bbd$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $00c42fc5bf826bbd$export$61bcfe829111a1d0; }, function (v) { return $00c42fc5bf826bbd$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $00c42fc5bf826bbd$export$7ee8c9beb337bc3f; }, function (v) { return $00c42fc5bf826bbd$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $00c42fc5bf826bbd$export$b5836b71941fa3ed; }, function (v) { return $00c42fc5bf826bbd$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $00c42fc5bf826bbd$export$cf845f2c119da08a; }, function (v) { return $00c42fc5bf826bbd$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $00c42fc5bf826bbd$export$c4744153514ff05d;
var $00c42fc5bf826bbd$export$3e506c1ccc9cc1a7;
var $00c42fc5bf826bbd$export$e26fe2ed2fa76875;
var $00c42fc5bf826bbd$export$502329bbf4b505b1;
var $00c42fc5bf826bbd$export$6e3807111c4874c4;
var $00c42fc5bf826bbd$export$c27134553091fb3a;
var $00c42fc5bf826bbd$export$33ee1acdc04fd2a2;
var $00c42fc5bf826bbd$export$b00a404bbd5edef2;
var $00c42fc5bf826bbd$export$8352ce38b91d0c62;
var $00c42fc5bf826bbd$export$d66a1c1c77bd778b;
var $00c42fc5bf826bbd$export$d3dfb8e4810cb555;
var $00c42fc5bf826bbd$export$839f9183b0465a69;
var $00c42fc5bf826bbd$export$72fdf0e06517287b;
var $00c42fc5bf826bbd$export$4b844e58a3e414b4;
var $00c42fc5bf826bbd$export$816d2913ae6b83b1;
var $00c42fc5bf826bbd$export$61bcfe829111a1d0;
var $00c42fc5bf826bbd$export$7ee8c9beb337bc3f;
var $00c42fc5bf826bbd$export$b5836b71941fa3ed;
var $00c42fc5bf826bbd$export$cf845f2c119da08a;
"use strict";
function $00c42fc5bf826bbd$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $00c42fc5bf826bbd$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $00c42fc5bf826bbd$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $00c42fc5bf826bbd$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $00c42fc5bf826bbd$var$g(C, c)) n < e && 0 > $00c42fc5bf826bbd$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $00c42fc5bf826bbd$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $00c42fc5bf826bbd$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $00c42fc5bf826bbd$var$l = performance;
    $00c42fc5bf826bbd$export$c4744153514ff05d = function() {
        return $00c42fc5bf826bbd$var$l.now();
    };
} else {
    var $00c42fc5bf826bbd$var$p = Date, $00c42fc5bf826bbd$var$q = $00c42fc5bf826bbd$var$p.now();
    $00c42fc5bf826bbd$export$c4744153514ff05d = function() {
        return $00c42fc5bf826bbd$var$p.now() - $00c42fc5bf826bbd$var$q;
    };
}
var $00c42fc5bf826bbd$var$r = [], $00c42fc5bf826bbd$var$t = [], $00c42fc5bf826bbd$var$u = 1, $00c42fc5bf826bbd$var$v = null, $00c42fc5bf826bbd$var$y = 3, $00c42fc5bf826bbd$var$z = !1, $00c42fc5bf826bbd$var$A = !1, $00c42fc5bf826bbd$var$B = !1, $00c42fc5bf826bbd$var$D = "function" === typeof setTimeout ? setTimeout : null, $00c42fc5bf826bbd$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $00c42fc5bf826bbd$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $00c42fc5bf826bbd$var$G(a) {
    for(var b = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$t); null !== b;){
        if (null === b.callback) $00c42fc5bf826bbd$var$k($00c42fc5bf826bbd$var$t);
        else if (b.startTime <= a) $00c42fc5bf826bbd$var$k($00c42fc5bf826bbd$var$t), b.sortIndex = b.expirationTime, $00c42fc5bf826bbd$var$f($00c42fc5bf826bbd$var$r, b);
        else break;
        b = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$t);
    }
}
function $00c42fc5bf826bbd$var$H(a) {
    $00c42fc5bf826bbd$var$B = !1;
    $00c42fc5bf826bbd$var$G(a);
    if (!$00c42fc5bf826bbd$var$A) {
        if (null !== $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r)) $00c42fc5bf826bbd$var$A = !0, $00c42fc5bf826bbd$var$I($00c42fc5bf826bbd$var$J);
        else {
            var b = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$t);
            null !== b && $00c42fc5bf826bbd$var$K($00c42fc5bf826bbd$var$H, b.startTime - a);
        }
    }
}
function $00c42fc5bf826bbd$var$J(a, b) {
    $00c42fc5bf826bbd$var$A = !1;
    $00c42fc5bf826bbd$var$B && ($00c42fc5bf826bbd$var$B = !1, $00c42fc5bf826bbd$var$E($00c42fc5bf826bbd$var$L), $00c42fc5bf826bbd$var$L = -1);
    $00c42fc5bf826bbd$var$z = !0;
    var c = $00c42fc5bf826bbd$var$y;
    try {
        $00c42fc5bf826bbd$var$G(b);
        for($00c42fc5bf826bbd$var$v = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r); null !== $00c42fc5bf826bbd$var$v && (!($00c42fc5bf826bbd$var$v.expirationTime > b) || a && !$00c42fc5bf826bbd$var$M());){
            var d = $00c42fc5bf826bbd$var$v.callback;
            if ("function" === typeof d) {
                $00c42fc5bf826bbd$var$v.callback = null;
                $00c42fc5bf826bbd$var$y = $00c42fc5bf826bbd$var$v.priorityLevel;
                var e = d($00c42fc5bf826bbd$var$v.expirationTime <= b);
                b = $00c42fc5bf826bbd$export$c4744153514ff05d();
                "function" === typeof e ? $00c42fc5bf826bbd$var$v.callback = e : $00c42fc5bf826bbd$var$v === $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r) && $00c42fc5bf826bbd$var$k($00c42fc5bf826bbd$var$r);
                $00c42fc5bf826bbd$var$G(b);
            } else $00c42fc5bf826bbd$var$k($00c42fc5bf826bbd$var$r);
            $00c42fc5bf826bbd$var$v = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r);
        }
        if (null !== $00c42fc5bf826bbd$var$v) var w = !0;
        else {
            var m = $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$t);
            null !== m && $00c42fc5bf826bbd$var$K($00c42fc5bf826bbd$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $00c42fc5bf826bbd$var$v = null, $00c42fc5bf826bbd$var$y = c, $00c42fc5bf826bbd$var$z = !1;
    }
}
var $00c42fc5bf826bbd$var$N = !1, $00c42fc5bf826bbd$var$O = null, $00c42fc5bf826bbd$var$L = -1, $00c42fc5bf826bbd$var$P = 5, $00c42fc5bf826bbd$var$Q = -1;
function $00c42fc5bf826bbd$var$M() {
    return $00c42fc5bf826bbd$export$c4744153514ff05d() - $00c42fc5bf826bbd$var$Q < $00c42fc5bf826bbd$var$P ? !1 : !0;
}
function $00c42fc5bf826bbd$var$R() {
    if (null !== $00c42fc5bf826bbd$var$O) {
        var a = $00c42fc5bf826bbd$export$c4744153514ff05d();
        $00c42fc5bf826bbd$var$Q = a;
        var b = !0;
        try {
            b = $00c42fc5bf826bbd$var$O(!0, a);
        } finally{
            b ? $00c42fc5bf826bbd$var$S() : ($00c42fc5bf826bbd$var$N = !1, $00c42fc5bf826bbd$var$O = null);
        }
    } else $00c42fc5bf826bbd$var$N = !1;
}
var $00c42fc5bf826bbd$var$S;
if ("function" === typeof $00c42fc5bf826bbd$var$F) $00c42fc5bf826bbd$var$S = function() {
    $00c42fc5bf826bbd$var$F($00c42fc5bf826bbd$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $00c42fc5bf826bbd$var$T = new MessageChannel, $00c42fc5bf826bbd$var$U = $00c42fc5bf826bbd$var$T.port2;
    $00c42fc5bf826bbd$var$T.port1.onmessage = $00c42fc5bf826bbd$var$R;
    $00c42fc5bf826bbd$var$S = function() {
        $00c42fc5bf826bbd$var$U.postMessage(null);
    };
} else $00c42fc5bf826bbd$var$S = function() {
    $00c42fc5bf826bbd$var$D($00c42fc5bf826bbd$var$R, 0);
};
function $00c42fc5bf826bbd$var$I(a) {
    $00c42fc5bf826bbd$var$O = a;
    $00c42fc5bf826bbd$var$N || ($00c42fc5bf826bbd$var$N = !0, $00c42fc5bf826bbd$var$S());
}
function $00c42fc5bf826bbd$var$K(a, b) {
    $00c42fc5bf826bbd$var$L = $00c42fc5bf826bbd$var$D(function() {
        a($00c42fc5bf826bbd$export$c4744153514ff05d());
    }, b);
}
$00c42fc5bf826bbd$export$3e506c1ccc9cc1a7 = 5;
$00c42fc5bf826bbd$export$e26fe2ed2fa76875 = 1;
$00c42fc5bf826bbd$export$502329bbf4b505b1 = 4;
$00c42fc5bf826bbd$export$6e3807111c4874c4 = 3;
$00c42fc5bf826bbd$export$c27134553091fb3a = null;
$00c42fc5bf826bbd$export$33ee1acdc04fd2a2 = 2;
$00c42fc5bf826bbd$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$00c42fc5bf826bbd$export$8352ce38b91d0c62 = function() {
    $00c42fc5bf826bbd$var$A || $00c42fc5bf826bbd$var$z || ($00c42fc5bf826bbd$var$A = !0, $00c42fc5bf826bbd$var$I($00c42fc5bf826bbd$var$J));
};
$00c42fc5bf826bbd$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $00c42fc5bf826bbd$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$00c42fc5bf826bbd$export$d3dfb8e4810cb555 = function() {
    return $00c42fc5bf826bbd$var$y;
};
$00c42fc5bf826bbd$export$839f9183b0465a69 = function() {
    return $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r);
};
$00c42fc5bf826bbd$export$72fdf0e06517287b = function(a) {
    switch($00c42fc5bf826bbd$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $00c42fc5bf826bbd$var$y;
    }
    var c = $00c42fc5bf826bbd$var$y;
    $00c42fc5bf826bbd$var$y = b;
    try {
        return a();
    } finally{
        $00c42fc5bf826bbd$var$y = c;
    }
};
$00c42fc5bf826bbd$export$4b844e58a3e414b4 = function() {};
$00c42fc5bf826bbd$export$816d2913ae6b83b1 = function() {};
$00c42fc5bf826bbd$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $00c42fc5bf826bbd$var$y;
    $00c42fc5bf826bbd$var$y = a;
    try {
        return b();
    } finally{
        $00c42fc5bf826bbd$var$y = c;
    }
};
$00c42fc5bf826bbd$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $00c42fc5bf826bbd$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $00c42fc5bf826bbd$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $00c42fc5bf826bbd$var$f($00c42fc5bf826bbd$var$t, a), null === $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$r) && a === $00c42fc5bf826bbd$var$h($00c42fc5bf826bbd$var$t) && ($00c42fc5bf826bbd$var$B ? ($00c42fc5bf826bbd$var$E($00c42fc5bf826bbd$var$L), $00c42fc5bf826bbd$var$L = -1) : $00c42fc5bf826bbd$var$B = !0, $00c42fc5bf826bbd$var$K($00c42fc5bf826bbd$var$H, c - d))) : (a.sortIndex = e, $00c42fc5bf826bbd$var$f($00c42fc5bf826bbd$var$r, a), $00c42fc5bf826bbd$var$A || $00c42fc5bf826bbd$var$z || ($00c42fc5bf826bbd$var$A = !0, $00c42fc5bf826bbd$var$I($00c42fc5bf826bbd$var$J)));
    return a;
};
$00c42fc5bf826bbd$export$b5836b71941fa3ed = $00c42fc5bf826bbd$var$M;
$00c42fc5bf826bbd$export$cf845f2c119da08a = function(a) {
    var b = $00c42fc5bf826bbd$var$y;
    return function() {
        var c = $00c42fc5bf826bbd$var$y;
        $00c42fc5bf826bbd$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $00c42fc5bf826bbd$var$y = c;
        }
    };
};

});


parcelRegister("kqzaL", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = Promise.all([
    $bBxN9("dEWH7"),
    $bBxN9("iUQuj")
]).then(()=>parcelRequire("2KPwO"));

});
parcelRegister("bBxN9", function(module, exports) {
"use strict";

function $872d5cbd7458b7c1$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("hzK4Z")).resolve(id));
}
module.exports = $872d5cbd7458b7c1$var$load;

});


parcelRegister("1fAwT", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("Xjgsy").then(()=>parcelRequire("7vY2N"));

});

parcelRegister("cuj5u", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = Promise.all([
    $bBxN9("dEWH7"),
    $bBxN9("7Ucuv")
]).then(()=>parcelRequire("j83KJ"));

});

parcelRegister("h7Bj2", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("kSWyx").then(()=>parcelRequire("hX9Am"));

});

parcelRegister("exI7W", function(module, exports) {

$parcel$export(module.exports, "configure", function () { return $a966607d78ed4ed2$export$8d21e34596265fa2; });
$parcel$export(module.exports, "getConfig", function () { return $a966607d78ed4ed2$export$44487a86467333c3; });

var $jzYu7 = parcelRequire("jzYu7");

var $bs6hr = parcelRequire("bs6hr");
function $a966607d78ed4ed2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $a966607d78ed4ed2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $a966607d78ed4ed2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $a966607d78ed4ed2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $a966607d78ed4ed2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $a966607d78ed4ed2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $a966607d78ed4ed2$var$defaultAllowedParams = [
    "operationName",
    "operation",
    "q"
];
function $a966607d78ed4ed2$var$getAllowedParams() {
    var config = (0, $bs6hr.getConfig)();
    return (config === null || config === void 0 ? void 0 : config.allowedResourcesParams) || $a966607d78ed4ed2$var$defaultAllowedParams;
}
function $a966607d78ed4ed2$var$handleQueryParams(urlString) {
    try {
        if (typeof urlString !== "string") return urlString;
        var url = new URL(urlString);
        var params = new URLSearchParams(url.search);
        var allowedParams = $a966607d78ed4ed2$var$getAllowedParams();
        var _iterator = $a966607d78ed4ed2$var$_createForOfIteratorHelper(params), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, $jzYu7.default)(_step.value, 1), key = _step$value[0];
                if (!allowedParams.includes(key)) url.searchParams.delete(key);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return url.toString();
    } catch (_unused) {
        return urlString;
    }
}
var $a966607d78ed4ed2$var$config = {
    mapResources: function mapResources(url) {
        return url;
    },
    sanitiseEndpoints: function sanitiseEndpoints(url) {
        return $a966607d78ed4ed2$var$handleQueryParams(url);
    }
};
function $a966607d78ed4ed2$export$8d21e34596265fa2(resourceTimingConfig) {
    var newConfig = {
        mapResources: resourceTimingConfig.mapResources,
        sanitiseEndpoints: function sanitiseEndpoints(url) {
            var sanitised = resourceTimingConfig.sanitiseEndpoints(url);
            if (sanitised) return $a966607d78ed4ed2$var$handleQueryParams(sanitised);
            return sanitised;
        }
    };
    $a966607d78ed4ed2$var$config = newConfig;
}
function $a966607d78ed4ed2$export$44487a86467333c3() {
    return $a966607d78ed4ed2$var$config;
}

});

parcelRegister("dg5xP", function(module, exports) {
$parcel$export(module.exports, "AnimatedContainer", function () { return (parcelRequire("dWr7M")).AnimatedContainer; });
$parcel$export(module.exports, "ArrowControls", function () { return (parcelRequire("kRXzx")).ArrowControls; });
$parcel$export(module.exports, "Carousel", function () { return (parcelRequire("1TMwu")).Carousel; });
$parcel$export(module.exports, "Expand", function () { return (parcelRequire("69DYH")).Expand; });
$parcel$export(module.exports, "Label", function () { return (parcelRequire("sm53h")).Label; });
$parcel$export(module.exports, "labelThemeOptions", function () { return (parcelRequire("sm53h")).labelThemeOptions; });
$parcel$export(module.exports, "LanguageSelectForm", function () { return (parcelRequire("ipl9a")).LanguageSelectForm; });
$parcel$export(module.exports, "LogoAtlassian", function () { return (parcelRequire("986bT")).LogoAtlassian; });
$parcel$export(module.exports, "LogoTrello", function () { return (parcelRequire("yF2IO")).LogoTrello; });
$parcel$export(module.exports, "Markdown", function () { return (parcelRequire("6vqJG")).Markdown; });
$parcel$export(module.exports, "Modal", function () { return (parcelRequire("kukfL")).Modal; });
$parcel$export(module.exports, "ModalTrigger", function () { return (parcelRequire("23mX4")).ModalTrigger; });
$parcel$export(module.exports, "ScrollFade", function () { return (parcelRequire("h5qkC")).ScrollFade; });
$parcel$export(module.exports, "Stack", function () { return (parcelRequire("j30bs")).Stack; });
$parcel$export(module.exports, "Tooltip", function () { return (parcelRequire("cFwv0")).Tooltip; });
$parcel$export(module.exports, "Video", function () { return (parcelRequire("opvSz")).Video; });
$parcel$export(module.exports, "FooterContextProvider", function () { return (parcelRequire("8OmrV")).FooterContextProvider; });
$parcel$export(module.exports, "useFooterContext", function () { return (parcelRequire("8OmrV")).useFooterContext; });
$parcel$export(module.exports, "Column", function () { return (parcelRequire("5l0yg")).Column; });
$parcel$export(module.exports, "Container", function () { return (parcelRequire("5l0yg")).Container; });
$parcel$export(module.exports, "isColumnProperties", function () { return (parcelRequire("5l0yg")).isColumnProperties; });
$parcel$export(module.exports, "Row", function () { return (parcelRequire("5l0yg")).Row; });
$parcel$export(module.exports, "AnalyticsAttributesProvider", function () { return (parcelRequire("g4xTJ")).AnalyticsAttributesProvider; });
$parcel$export(module.exports, "AnalyticsProvider", function () { return (parcelRequire("kzY5l")).AnalyticsProvider; });
$parcel$export(module.exports, "OnetrustProvider", function () { return (parcelRequire("eSKWD")).OnetrustProvider; });
$parcel$export(module.exports, "RouteProvider", function () { return (parcelRequire("5atKW")).RouteProvider; });
$parcel$export(module.exports, "useAnalytics", function () { return (parcelRequire("kzY5l")).useAnalytics; });
$parcel$export(module.exports, "useAnalyticsAttributes", function () { return (parcelRequire("g4xTJ")).useAnalyticsAttributes; });
$parcel$export(module.exports, "useBreakpoints", function () { return (parcelRequire("1pYrM")).useBreakpoints; });
$parcel$export(module.exports, "useClickAway", function () { return (parcelRequire("jTu6p")).useClickAway; });
$parcel$export(module.exports, "useCoordinates", function () { return (parcelRequire("dJnrX")).useCoordinates; });
$parcel$export(module.exports, "useCyclingOrder", function () { return (parcelRequire("dS1rq")).useCyclingOrder; });
$parcel$export(module.exports, "useEnterprisePricingCalculator", function () { return (parcelRequire("KmL3B")).useEnterprisePricingCalculator; });
$parcel$export(module.exports, "useEscapePress", function () { return (parcelRequire("8L0gU")).useEscapePress; });
$parcel$export(module.exports, "useHostname", function () { return (parcelRequire("d9N4n")).useHostname; });
$parcel$export(module.exports, "useIdentityUrl", function () { return (parcelRequire("aSdFq")).useIdentityUrl; });
$parcel$export(module.exports, "useIsLoggedIn", function () { return (parcelRequire("eOLtZ")).useIsLoggedIn; });
$parcel$export(module.exports, "useLanguage", function () { return (parcelRequire("fuZB8")).useLanguage; });
$parcel$export(module.exports, "useMarketoForm", function () { return (parcelRequire("ajAMQ")).useMarketoForm; });
$parcel$export(module.exports, "useMember", function () { return (parcelRequire("5XW95")).useMember; });
$parcel$export(module.exports, "useModal", function () { return (parcelRequire("ljbip")).useModal; });
$parcel$export(module.exports, "useOnetrust", function () { return (parcelRequire("eSKWD")).useOnetrust; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("5uiii")).useQuery; });
$parcel$export(module.exports, "useRoute", function () { return (parcelRequire("5atKW")).useRoute; });
$parcel$export(module.exports, "useViewportDimensions", function () { return (parcelRequire("jFObu")).useViewportDimensions; });
$parcel$export(module.exports, "AppleLogo", function () { return (parcelRequire("ioseP")).AppleLogo; });
$parcel$export(module.exports, "ArrowRight", function () { return (parcelRequire("dtAdv")).ArrowRight; });
$parcel$export(module.exports, "ChevronDown", function () { return (parcelRequire("5FSC2")).ChevronDown; });
$parcel$export(module.exports, "ChevronLeft", function () { return (parcelRequire("1fo9X")).ChevronLeft; });
$parcel$export(module.exports, "ChevronRight", function () { return (parcelRequire("fBLkH")).ChevronRight; });
$parcel$export(module.exports, "GoogleLogo", function () { return (parcelRequire("17IGc")).GoogleLogo; });
$parcel$export(module.exports, "MicrosoftLogo", function () { return (parcelRequire("buTNb")).MicrosoftLogo; });
$parcel$export(module.exports, "SlackLogo", function () { return (parcelRequire("6Owxa")).SlackLogo; });
$parcel$export(module.exports, "BxpButton", function () { return (parcelRequire("8HF11")).BxpButton; });
$parcel$export(module.exports, "getAppearance", function () { return (parcelRequire("8HF11")).getAppearance; });
$parcel$export(module.exports, "getProminence", function () { return (parcelRequire("8HF11")).getProminence; });
$parcel$export(module.exports, "getSpacing", function () { return (parcelRequire("8HF11")).getSpacing; });
$parcel$export(module.exports, "LinkButton", function () { return (parcelRequire("82f25")).LinkButton; });
$parcel$export(module.exports, "Picture", function () { return (parcelRequire("41Ir1")).Picture; });
$parcel$export(module.exports, "EmailShareButton", function () { return (parcelRequire("eHuqC")).EmailShareButton; });
$parcel$export(module.exports, "FacebookShareButton", function () { return (parcelRequire("5PhOG")).FacebookShareButton; });
$parcel$export(module.exports, "TwitterShareButton", function () { return (parcelRequire("gFZ4z")).TwitterShareButton; });
parcelRequire("dWr7M");
parcelRequire("1QYlM");
parcelRequire("98CRR");
parcelRequire("69DYH");
parcelRequire("lQ5eN");
parcelRequire("lXPwV");
parcelRequire("986bT");
parcelRequire("yF2IO");
parcelRequire("6vqJG");
parcelRequire("33B4V");
parcelRequire("bwVZm");
parcelRequire("j30bs");
parcelRequire("jaddM");
parcelRequire("bsCGL");
parcelRequire("opvSz");
parcelRequire("j0YqN");
parcelRequire("gxKgX");
parcelRequire("fyI6f");
parcelRequire("bggJi");
parcelRequire("FfaIO");
parcelRequire("fR9Sp");
parcelRequire("54eIv");

});
parcelRegister("dWr7M", function(module, exports) {

$parcel$export(module.exports, "AnimatedContainer", function () { return $ff0fc3f4a8dc4884$export$9382739d0e79620f; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $ff0fc3f4a8dc4884$export$9382739d0e79620f = ({ time: time = 600, children: children, style: style })=>{
    const [buffer, setBuffer] = (0, $iSvIT.useState)({
        children: children,
        keys: children.map((child)=>child.key?.toString() ?? ""),
        shadowStyles: {},
        status: "ready",
        styles: {}
    });
    //visible buffered children wrappers
    const containerDivs = (0, $iSvIT.useRef)({});
    //parent container ref
    const containerRef = (0, $iSvIT.useRef)(null);
    //hidden unbuffered children wrappers
    const shadowDivs = (0, $iSvIT.useRef)({});
    //"shadow" container that transparently materializes when a change occurs
    const shadowRef = (0, $iSvIT.useRef)(null);
    //timer to run cleanup callback after animation finishes
    const timer = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        //get keys from children
        const keys = children.map((child)=>child.key?.toString() ?? "");
        //stop if no changes
        if (keys.join() === buffer.keys.join()) return;
        //identify what needs to happen
        const changes = {
            adding: keys.filter((key)=>!buffer.keys.includes(key)),
            moving: keys.filter((key)=>buffer.keys.includes(key)),
            removing: buffer.keys.filter((key)=>!keys.includes(key))
        };
        //lookup object containing css for containerDivs
        const styles = {};
        if (buffer.status === "ready") {
            //freeze parent style
            const { height: height, top: top, left: left } = containerRef.current?.getBoundingClientRect() ?? {
                left: 0,
                top: 0
            };
            //freeze child styles
            buffer.keys.forEach((key)=>{
                const css = containerDivs.current[key]?.getBoundingClientRect();
                styles[key] = {
                    height: css?.height,
                    left: css ? css.left - left : undefined,
                    position: "absolute",
                    top: css ? css.top - top : undefined,
                    width: css?.width
                };
            });
            //add new elements
            const newElements = children.filter((child)=>child.key && changes.adding.includes(child.key?.toString()));
            //make sure new elements are hidden
            changes.adding.forEach((key)=>{
                styles[key] = {
                    opacity: 0,
                    position: "absolute",
                    transform: "scale(0)"
                };
            });
            //style the shadow
            let shadowStyles = {
                opacity: 0,
                position: "absolute",
                top: 0,
                zIndex: -10
            };
            //copy layout styles from container to shadow
            if (containerRef.current) {
                const elementStyles = window.getComputedStyle(containerRef.current);
                const containerStyles = {
                    alignContent: elementStyles.getPropertyValue("align-content"),
                    alignItems: elementStyles.getPropertyValue("align-items"),
                    columnGap: elementStyles.getPropertyValue("column-gap"),
                    display: elementStyles.getPropertyValue("display"),
                    flexDirection: elementStyles.getPropertyValue("flex-direction"),
                    flexFlow: elementStyles.getPropertyValue("flex-flow"),
                    flexWrap: elementStyles.getPropertyValue("flex-wrap"),
                    gap: elementStyles.getPropertyValue("gap"),
                    grid: elementStyles.getPropertyValue("grid"),
                    gridAutoColumns: elementStyles.getPropertyValue("grid-auto-columns"),
                    gridAutoFlow: elementStyles.getPropertyValue("grid-auto-flow"),
                    gridAutoRows: elementStyles.getPropertyValue("grid-auto-rows"),
                    gridTemplate: elementStyles.getPropertyValue("grid-template"),
                    gridTemplateAreas: elementStyles.getPropertyValue("grid-template-areas"),
                    gridTemplateColumns: elementStyles.getPropertyValue("grid-template-columns"),
                    justifyContent: elementStyles.getPropertyValue("justify-content"),
                    justifyItems: elementStyles.getPropertyValue("justify-items"),
                    placeContent: elementStyles.getPropertyValue("place-content"),
                    placeItems: elementStyles.getPropertyValue("place-items"),
                    rowGap: elementStyles.getPropertyValue("row-gap"),
                    width: elementStyles.getPropertyValue("width")
                };
                shadowStyles = {
                    ...shadowStyles,
                    ...containerStyles
                };
            }
            setBuffer({
                ...buffer,
                children: [
                    ...buffer.children,
                    ...newElements
                ],
                height: height,
                shadowStyles: shadowStyles,
                status: "changing",
                styles: styles
            });
        } else if (buffer.status === "changing") {
            const { height: height, left: left, top: top } = shadowRef.current?.getBoundingClientRect() ?? {
                left: 0,
                top: 0
            };
            changes.adding.forEach((key)=>{
                const target = shadowDivs.current[key]?.getBoundingClientRect();
                styles[key] = {
                    ...buffer.styles[key],
                    height: target?.height,
                    left: target ? target.left - left : undefined,
                    opacity: 1,
                    top: target ? target.top - top : undefined,
                    transform: "scale(1)",
                    transition: `opacity ${time}ms, transform ${time}ms`,
                    width: target?.width
                };
            });
            changes.moving.forEach((key)=>{
                if (!shadowDivs.current[key]) return;
                const target = shadowDivs.current[key]?.getBoundingClientRect();
                styles[key] = {
                    ...buffer.styles[key],
                    height: target?.height ? target.height : undefined,
                    left: target?.left ? target.left - left : undefined,
                    top: target?.top ? target.top - top : undefined,
                    transition: `height ${time}ms, left ${time}ms, top ${time}ms`,
                    width: target?.width ? target.width : undefined
                };
            });
            changes.removing.forEach((key)=>{
                styles[key] = {
                    ...buffer.styles[key],
                    opacity: 0,
                    transform: "scale(0)",
                    transition: `opacity ${time}ms, transform ${time}ms`
                };
            });
            if (timer.current) clearTimeout(timer.current);
            timer.current = setTimeout(()=>{
                setBuffer({
                    children: children,
                    height: undefined,
                    keys: keys,
                    shadowStyles: {},
                    status: "ready",
                    styles: {}
                });
            }, time);
            setBuffer({
                ...buffer,
                height: height,
                status: "running",
                styles: styles
            });
        }
    }, [
        time,
        buffer,
        children
    ]);
    //clean up
    (0, $iSvIT.useEffect)(()=>{
        return ()=>{
            if (timer.current) clearTimeout(timer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: containerRef,
        style: {
            ...style,
            height: buffer.height,
            position: "relative",
            transition: `height ${time}ms`
        },
        children: [
            buffer.children.map((child)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    ref: (el)=>child.key && (containerDivs.current[child.key] = el),
                    style: child.key ? buffer.styles[child.key] : undefined,
                    children: child
                }, child.key)),
            buffer.status === "changing" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: shadowRef,
                style: {
                    ...buffer.shadowStyles
                },
                children: children.map((child)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        ref: (el)=>child.key && (shadowDivs.current[child.key] = el),
                        children: child
                    }, child.key))
            })
        ]
    });
};

});

parcelRegister("1QYlM", function(module, exports) {
$parcel$export(module.exports, "ArrowControls", function () { return (parcelRequire("kRXzx")).ArrowControls; });
parcelRequire("kRXzx");

});
parcelRegister("kRXzx", function(module, exports) {

$parcel$export(module.exports, "ArrowControls", function () { return $55135b652dfcbecf$export$68cb0131e7342311; });

var $loA2J = parcelRequire("loA2J");

var $2jErs = parcelRequire("2jErs");
const $55135b652dfcbecf$export$68cb0131e7342311 = ({ next: next, nextAriaDisabled: nextAriaDisabled, nextLabel: nextLabel, prev: prev, prevAriaDisabled: prevAriaDisabled, prevLabel: prevLabel })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2jErs.Arrow), {
                "aria-label": prevLabel,
                "aria-disabled": prevAriaDisabled,
                "data-testid": "arrow_prev",
                onClick: prev,
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            width: "30",
                            height: "30",
                            rx: "15"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M16.7167 8.21674L10.2168 14.7167L16.5001 20.9999",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $2jErs.Arrow), {
                "aria-label": nextLabel,
                "aria-disabled": nextAriaDisabled,
                "data-testid": "arrow_next",
                onClick: next,
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                            x: "30",
                            y: "30",
                            width: "30",
                            height: "30",
                            rx: "15",
                            transform: "rotate(-180 30 30)"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                            d: "M13.2833 21.7833L19.7832 15.2833L13.4999 9.00007",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            })
        ]
    });
};

});
parcelRegister("2jErs", function(module, exports) {

$parcel$export(module.exports, "Arrow", function () { return $6cbcdb77c21e5935$export$21b07c8f274aebd5; });
/** @jsxImportSource react */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
// Styled-component for SSR CSS generation
const $6cbcdb77c21e5935$var$ArrowStyled = (0, $hYbro.default).button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 0;
    opacity: 1;
    flex-shrink: 0;

    &:hover {
        opacity: 0.8;
    }

    &[aria-disabled="true"] {
        opacity: 0.4;
        cursor: not-allowed;
    }

    & svg {
        display: block;
        width: 30px;
        height: 30px;
    }

    & svg rect {
        fill: rgba(244, 245, 247, 1);
    }

    & svg path {
        stroke: rgba(122, 134, 154, 1);
        stroke-width: 2;
        fill: none;
    }
`;
const $6cbcdb77c21e5935$export$21b07c8f274aebd5 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($6cbcdb77c21e5935$var$ArrowStyled, {
        ...props
    });

});



parcelRegister("98CRR", function(module, exports) {
$parcel$export(module.exports, "Carousel", function () { return (parcelRequire("1TMwu")).Carousel; });
parcelRequire("1TMwu");

});
parcelRegister("1TMwu", function(module, exports) {

$parcel$export(module.exports, "Carousel", function () { return $4a58bd4de9493567$export$144901db2ea8e967; });
/* eslint-disable complexity, react-hooks/exhaustive-deps */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kRXzx = parcelRequire("kRXzx");
parcelRequire("fyI6f");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");

var $dF0AD = parcelRequire("dF0AD");

var $22YSu = parcelRequire("22YSu");
const $4a58bd4de9493567$export$144901db2ea8e967 = ({ arrows: arrows, dotsOnDesktop: dotsOnDesktop, dotsOnMobile: dotsOnMobile, children: children, onChange: onChange, selectedIndex: selectedIndex, initialAutoplay: initialAutoplay = false, transitionTimeInSeconds: transitionTimeInSeconds = 0.3, dotLabel: dotLabel = "Dot", prevArrowLabel: prevArrowLabel = "Previous", nextArrowLabel: nextArrowLabel = "Next", controlsAlignStart: controlsAlignStart = false })=>{
    //current slide #
    const [slide, setSlide] = (0, $iSvIT.useState)(selectedIndex ? selectedIndex : 0);
    //current track offset
    const [marginLeft, setMarginLeft] = (0, $iSvIT.useState)(0);
    //drag information (start of drag, margin at start)
    const [drag, setDrag] = (0, $iSvIT.useState)(null);
    //current frame size
    const [frameWidth, setFrameWidth] = (0, $iSvIT.useState)(0);
    const [preventScroll, setPreventScroll] = (0, $iSvIT.useState)(false);
    const [autoplay, setAutoplay] = (0, $iSvIT.useState)(initialAutoplay);
    const frameRef = (0, $iSvIT.useRef)(null);
    const slideRef = (0, $iSvIT.useRef)(null);
    //analytics
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    //enforce array-ness of children
    const slides = !children ? [] : !Array.isArray(children) ? [
        children
    ] : children;
    const hasMultipleSlides = slides.length > 1;
    const gapSize = 16;
    //maintain current width of the frame
    (0, $iSvIT.useEffect)(()=>{
        const handleResize = ()=>{
            setFrameWidth(frameRef.current?.offsetWidth ?? 0);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        frameRef
    ]);
    //prevent vertical scrolling when sliding carousel
    (0, $iSvIT.useEffect)(()=>{
        if (preventScroll) {
            document.body.classList.add("prevent-scroll");
            document.ontouchmove = (e)=>{
                e.preventDefault();
            };
        } else {
            document.body.classList.remove("prevent-scroll");
            document.ontouchmove = ()=>true;
        }
        return ()=>{
            document.body.classList.remove("prevent-scroll");
            document.ontouchmove = ()=>true;
        };
    }, [
        preventScroll
    ]);
    //listen to slide updates
    (0, $iSvIT.useEffect)(()=>{
        sendTrackEvent("carouselChanged", {
            ...analyticsAttributes,
            eventComponent: "carousel",
            event: "changed",
            label: `Slide ${slide + 1}`,
            labelEnglish: `Slide ${slide + 1}`
        });
        if (slideRef?.current) (0, $dF0AD.updateSlideAccessibility)(slideRef.current);
        if (onChange) onChange(slide);
    }, [
        slide
    ]);
    //change slide from parent element
    (0, $iSvIT.useEffect)(()=>{
        if (selectedIndex !== undefined && selectedIndex !== slide) {
            //stop autoplay if it's running
            if (autoplay) setAutoplay(false);
            setSlide(selectedIndex);
        }
    }, [
        selectedIndex
    ]);
    //handle autoplay
    (0, $iSvIT.useEffect)(()=>{
        const timeout = autoplay && initialAutoplay ? setTimeout(()=>{
            nextSlide();
        }, 5000) : null;
        return ()=>{
            if (timeout) clearTimeout(timeout);
        };
    }, [
        autoplay,
        initialAutoplay,
        slide
    ]);
    //go to the current slide
    const goToSlide = ()=>{
        setMarginLeft(0 - slide * frameWidth - slide * gapSize);
    };
    //set margin when window resizes or slide changes
    (0, $iSvIT.useEffect)(goToSlide, [
        slide,
        frameWidth
    ]);
    //go to previous slide
    const prevSlide = (e)=>{
        if (!hasMultipleSlides) return;
        if (e) //arrow was clicked; stop autoplay if it's running
        {
            if (autoplay) setAutoplay(false);
        }
        setSlide((slide ? slide : slides.length) - 1);
    };
    //go to next slide
    const nextSlide = (e)=>{
        if (!hasMultipleSlides) return;
        if (e) //arrow was clicked; stop autoplay if it's running
        {
            if (autoplay) setAutoplay(false);
        }
        setSlide(slide + 1 === slides.length ? 0 : slide + 1);
    };
    const dragStart = (x, y)=>{
        setDrag({
            dragStart: [
                x,
                y
            ],
            startingMargin: marginLeft
        });
    };
    const dragging = (x, y)=>{
        //check if drag started on carousel
        if (drag === null) return;
        //stop autoplay if it's running
        if (autoplay) setAutoplay(false);
        //exit if dragging vertically
        const horizontalOffset = x - drag.dragStart[0];
        const verticalOffset = y - drag.dragStart[1];
        if (Math.abs(horizontalOffset) < Math.abs(verticalOffset)) return;
        //horizontal touch, lock vertical scroll
        if (!preventScroll) setPreventScroll(true);
        //move track
        const dragAmount = horizontalOffset + drag.startingMargin;
        const maxAmount = 0;
        const minAmount = 0 - frameWidth * (slides.length - 1) - (slides.length - 1) * gapSize;
        const friction = 3;
        const amountWithFriction = dragAmount > maxAmount ? dragAmount / friction : dragAmount < minAmount ? minAmount + (dragAmount - minAmount) / friction : dragAmount;
        setMarginLeft(amountWithFriction);
    };
    const dragEnd = (x)=>{
        if (drag !== null) {
            const dragAmount = drag.dragStart[0] - x;
            const dragDistance = frameWidth / 3; //more than one third
            setDrag(null);
            setPreventScroll(false);
            if (dragAmount > dragDistance && slide !== slides.length - 1) //go to next item
            nextSlide();
            else if (dragAmount < 0 - dragDistance && slide) //go to previous item
            prevSlide();
            else //restore current item
            goToSlide();
        }
    };
    const dotsControls = /*#__PURE__*/ (0, $loA2J.jsx)((0, $22YSu.Dots), {
        mobile: dotsOnMobile,
        desktop: dotsOnDesktop,
        children: slides.map((child, index)=>!!child && /*#__PURE__*/ (0, $loA2J.jsx)((0, $22YSu.Dot), {
                "data-selected": index === slide,
                "data-testid": `dot_${index}`,
                "aria-label": `${dotLabel} ${index + 1}`,
                onClick: ()=>{
                    //stop autoplay if it's running
                    if (autoplay) setAutoplay(false);
                    setSlide(index);
                },
                transitionTimeInSeconds: transitionTimeInSeconds
            }, index))
    });
    const showMobileControls = (0, $iSvIT.useMemo)(()=>hasMultipleSlides && (dotsOnMobile || arrows), [
        hasMultipleSlides,
        dotsOnMobile,
        arrows
    ]);
    const showDesktopControls = (0, $iSvIT.useMemo)(()=>hasMultipleSlides && (dotsOnDesktop || arrows), [
        hasMultipleSlides,
        dotsOnDesktop,
        arrows
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $22YSu.Frame), {
        "data-testid": "carousel",
        ref: frameRef,
        children: [
            showDesktopControls && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $22YSu.DesktopControls), {
                alignStart: controlsAlignStart,
                children: [
                    dotsOnDesktop && dotsControls,
                    arrows && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kRXzx.ArrowControls), {
                        next: nextSlide,
                        nextLabel: nextArrowLabel,
                        prev: prevSlide,
                        prevLabel: prevArrowLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $22YSu.Mask), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $22YSu.Track), {
                    style: {
                        cursor: drag ? "grabbing" : "grab",
                        gap: gapSize,
                        marginLeft: marginLeft,
                        transition: drag ? "none" : `margin-left ${transitionTimeInSeconds}s ease`,
                        width: frameWidth ? frameWidth * slides.length + (slides.length - 1) * gapSize : "auto"
                    },
                    onTouchStart: ({ touches: touches })=>{
                        if (touches[0]) dragStart(touches[0].clientX, touches[0].clientY);
                    },
                    onTouchMove: ({ touches: touches })=>{
                        if (touches[0]) dragging(touches[0].clientX, touches[0].clientY);
                    },
                    onTouchEnd: ({ changedTouches: changedTouches })=>{
                        if (changedTouches[0]) dragEnd(changedTouches[0].clientX);
                    },
                    onMouseDown: (event)=>{
                        dragStart(event.clientX, event.clientY);
                    },
                    onMouseMove: (event)=>{
                        dragging(event.clientX, event.clientY);
                    },
                    onMouseUp: (event)=>{
                        dragEnd(event.clientX);
                    },
                    onMouseLeave: (event)=>{
                        dragEnd(event.clientX);
                    },
                    children: slides.map((child, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $22YSu.Slide), {
                            "aria-hidden": slide !== index,
                            // add ref to first slide only
                            ref: index === 0 ? slideRef : undefined,
                            children: child
                        }, index))
                })
            }),
            showMobileControls && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $22YSu.MobileControls), {
                children: [
                    dotsOnMobile && dotsControls,
                    arrows && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kRXzx.ArrowControls), {
                        next: nextSlide,
                        nextLabel: nextArrowLabel,
                        prev: prevSlide,
                        prevLabel: prevArrowLabel
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("fyI6f", function(module, exports) {
$parcel$export(module.exports, "AnalyticsProvider", function () { return (parcelRequire("kzY5l")).AnalyticsProvider; });
$parcel$export(module.exports, "useAnalytics", function () { return (parcelRequire("kzY5l")).useAnalytics; });
$parcel$export(module.exports, "AnalyticsAttributesProvider", function () { return (parcelRequire("g4xTJ")).AnalyticsAttributesProvider; });
$parcel$export(module.exports, "useAnalyticsAttributes", function () { return (parcelRequire("g4xTJ")).useAnalyticsAttributes; });
$parcel$export(module.exports, "useBreakpoints", function () { return (parcelRequire("1pYrM")).useBreakpoints; });
$parcel$export(module.exports, "useClickAway", function () { return (parcelRequire("jTu6p")).useClickAway; });
$parcel$export(module.exports, "useCoordinates", function () { return (parcelRequire("dJnrX")).useCoordinates; });
$parcel$export(module.exports, "useCyclingOrder", function () { return (parcelRequire("dS1rq")).useCyclingOrder; });
$parcel$export(module.exports, "useEnterprisePricingCalculator", function () { return (parcelRequire("KmL3B")).useEnterprisePricingCalculator; });
$parcel$export(module.exports, "useEscapePress", function () { return (parcelRequire("8L0gU")).useEscapePress; });
$parcel$export(module.exports, "useHostname", function () { return (parcelRequire("d9N4n")).useHostname; });
$parcel$export(module.exports, "useIsLoggedIn", function () { return (parcelRequire("eOLtZ")).useIsLoggedIn; });
$parcel$export(module.exports, "useLanguage", function () { return (parcelRequire("fuZB8")).useLanguage; });
$parcel$export(module.exports, "useMarketoForm", function () { return (parcelRequire("ajAMQ")).useMarketoForm; });
$parcel$export(module.exports, "useMember", function () { return (parcelRequire("5XW95")).useMember; });
$parcel$export(module.exports, "useModal", function () { return (parcelRequire("ljbip")).useModal; });
$parcel$export(module.exports, "OnetrustProvider", function () { return (parcelRequire("eSKWD")).OnetrustProvider; });
$parcel$export(module.exports, "useOnetrust", function () { return (parcelRequire("eSKWD")).useOnetrust; });
$parcel$export(module.exports, "useQuery", function () { return (parcelRequire("5uiii")).useQuery; });
$parcel$export(module.exports, "useRequestUrl", function () { return (parcelRequire("9Ck2b")).useRequestUrl; });
$parcel$export(module.exports, "RouteProvider", function () { return (parcelRequire("5atKW")).RouteProvider; });
$parcel$export(module.exports, "useRoute", function () { return (parcelRequire("5atKW")).useRoute; });
$parcel$export(module.exports, "useIdentityUrl", function () { return (parcelRequire("aSdFq")).useIdentityUrl; });
$parcel$export(module.exports, "useViewportDimensions", function () { return (parcelRequire("jFObu")).useViewportDimensions; });
parcelRequire("kzY5l");
parcelRequire("g4xTJ");
parcelRequire("1pYrM");
parcelRequire("jTu6p");
parcelRequire("dJnrX");
parcelRequire("dS1rq");
parcelRequire("KmL3B");
parcelRequire("8L0gU");
parcelRequire("d9N4n");
parcelRequire("eOLtZ");
parcelRequire("fuZB8");
parcelRequire("ajAMQ");
parcelRequire("5XW95");
parcelRequire("ljbip");
parcelRequire("eSKWD");
parcelRequire("5uiii");
parcelRequire("9Ck2b");
parcelRequire("5atKW");
parcelRequire("8l4ko");
parcelRequire("aSdFq");
parcelRequire("jFObu");

});
parcelRegister("kzY5l", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", function () { return $f3d35a6403acc434$export$e955abb82869dc84; });
$parcel$export(module.exports, "AnalyticsProvider", function () { return $f3d35a6403acc434$export$1b581a2ec13e37f1; });
/* eslint-disable react/prop-types */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $47vbe = parcelRequire("47vbe");

var $eSKWD = parcelRequire("eSKWD");
const $f3d35a6403acc434$export$83cd6c3eba7d8d9e = /*#__PURE__*/ (0, $iSvIT.createContext)({
    sendPageEvent: ()=>{
        throw new Error("Missing provider");
    },
    sendTrackEvent: ()=>{
        throw new Error("Missing provider");
    }
});
const $f3d35a6403acc434$export$e955abb82869dc84 = ()=>{
    const context = (0, $iSvIT.useContext)($f3d35a6403acc434$export$83cd6c3eba7d8d9e);
    if (context === undefined) throw new Error("`useAnalyticsContext` must be used within a `AnalyticsContext.Provider`");
    return context;
};
const $f3d35a6403acc434$export$1b581a2ec13e37f1 = ({ children: children })=>{
    const sendPageEvent = (_name, _payload)=>undefined;
    const sendTrackEvent = (_name, _payload)=>undefined;
    const { environment: environment, skipAnalytics: skipAnalytics } = (0, $47vbe.useConfig)();
    const [trackEvents, setTrackEvents] = (0, $iSvIT.useState)({
        sendPageEvent: sendPageEvent,
        sendTrackEvent: sendTrackEvent
    });
    const { hasOptedOut: hasOptedOut } = (0, $eSKWD.useOnetrust)();
    const isLocalhost = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
    (0, $iSvIT.useEffect)(()=>{
        const scriptId = "atl-global-wrapper";
        const loadAnalyticsWrapper = ()=>{
            if (isLocalhost) {
                setTrackEvents({
                    sendPageEvent: sendPageEvent,
                    sendTrackEvent: sendTrackEvent
                });
                return;
            }
            const script = document.createElement("script");
            script.async = true;
            script.src = environment === "production" ? "https://atl-global.atlassian.com/js/atl-global.min.js" : "https://atl-global.stg.atlassian.com/js/atl-global.min.js";
            script.id = scriptId;
            const setWrapperEvents = ()=>{
                setTrackEvents({
                    sendPageEvent: (name, payload)=>{
                        window.ace?.analytics.Tracking.pageView(name, payload);
                    },
                    sendTrackEvent: (name, payload)=>{
                        window.ace?.analytics.Tracking.trackEvent(name, payload);
                    }
                });
            };
            if (hasOptedOut || skipAnalytics) setTrackEvents({
                sendPageEvent: sendPageEvent,
                sendTrackEvent: sendTrackEvent
            });
            else if (!document.getElementById(scriptId)) {
                document.body.appendChild(script);
                script.onload = ()=>{
                    window.ace?.analytics.Initializer.initAnalytics("trello");
                    setWrapperEvents();
                };
            } else setWrapperEvents();
        };
        loadAnalyticsWrapper();
        if (hasOptedOut && document.getElementById(scriptId)) {
            const script = document.getElementById(scriptId);
            document.body.removeChild(script);
        }
    }, [
        environment,
        hasOptedOut,
        isLocalhost,
        skipAnalytics
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($f3d35a6403acc434$export$83cd6c3eba7d8d9e.Provider, {
        value: {
            ...trackEvents
        },
        children: children
    });
};

});
parcelRegister("47vbe", function(module, exports) {

$parcel$export(module.exports, "useConfig", function () { return $30000096701acb39$export$b3611e87cd5ba6ce; });
$parcel$export(module.exports, "ConfigProvider", function () { return $30000096701acb39$export$5261e812c31263e7; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
function $30000096701acb39$export$b3611e87cd5ba6ce() {
    return (0, $iSvIT.useContext)($30000096701acb39$var$ConfigContext);
}
const $30000096701acb39$export$5261e812c31263e7 = ({ config: config = {}, children: children })=>{
    return (0, $loA2J.jsx)($30000096701acb39$var$ConfigContext.Provider, {
        value: Object.assign(Object.assign({}, $30000096701acb39$var$DEFAULT_CONFIG), config),
        children: children
    });
};
const $30000096701acb39$export$9248fd2c8ae6c490 = "BXP_CONFIG";
const $30000096701acb39$var$DEFAULT_CONFIG = {
    environment: "development",
    version: "n/a",
    trelloClientBaseUrl: ""
};
const $30000096701acb39$var$ConfigContext = /*#__PURE__*/ (0, $iSvIT.createContext)($30000096701acb39$var$DEFAULT_CONFIG);

});

parcelRegister("eSKWD", function(module, exports) {

$parcel$export(module.exports, "useOnetrust", function () { return $ed9204ab600b32ee$export$87808802fa28156; });
$parcel$export(module.exports, "OnetrustProvider", function () { return $ed9204ab600b32ee$export$e981880cd8b65d61; });
/* eslint-disable react/prop-types */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $47vbe = parcelRequire("47vbe");
parcelRequire("bNHtH");
var $aYCAT = parcelRequire("aYCAT");

var $5XW95 = parcelRequire("5XW95");
const $ed9204ab600b32ee$export$176269f5c5bd3866 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    hasOptedOut: true,
    privacyLink: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {})
});
const $ed9204ab600b32ee$export$87808802fa28156 = ()=>{
    const context = (0, $iSvIT.useContext)($ed9204ab600b32ee$export$176269f5c5bd3866);
    if (context === undefined) throw new Error("`useOnetrust` must be used within a `Onetrust.Provider`");
    return context;
};
const $ed9204ab600b32ee$export$e981880cd8b65d61 = ({ children: children })=>{
    const { environment: environment } = (0, $47vbe.useConfig)();
    const member = (0, $5XW95.useMember)();
    const [hasOptedOut, setHasOptedOut] = (0, $iSvIT.useState)(true);
    const privacyLink = /*#__PURE__*/ (0, $loA2J.jsx)("li", {
        className: "atl-policy-link-container",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
            href: "http://",
            className: "atl-policy-link atl-policy-link-text",
            children: "Notice at Collection"
        })
    });
    (0, $iSvIT.useEffect)(()=>{
        // to be removed when the migration to cloud.session.token is complete
        if (member.status === "pending") return;
        if (member.status === "resolved") window.OTWrapperGetIdentifier = ()=>{
            return member.value.aaId;
        };
        const cookieName = "OptanonConsent";
        const optanonConsentCookieValue = (0, $aYCAT.getCookie)(cookieName);
        setHasOptedOut(optanonConsentCookieValue ? optanonConsentCookieValue.includes(",2:0") : false);
        // Check both script element existence and OneTrust initialization
        // SSR may have injected the script but it may not have loaded yet due to defer
        const oneTrustScriptExists = document.head.querySelector("#onetrust, #Onetrust");
        // OneTrust is injected by the OneTrust wrapper script and may not be typed
        const oneTrustInitialized = typeof window !== "undefined" && typeof window.OneTrust !== "undefined";
        if (!oneTrustScriptExists && !oneTrustInitialized) {
            const scriptId = "onetrust";
            const script = document.createElement("script");
            script.async = true;
            script.type = "text/javascript";
            script.id = scriptId;
            if (environment === "production") {
                script.src = "https://atl-onetrust-wrapper.atlassian.com/assets/atl-onetrust-wrapper.min.js";
                script.setAttribute("data-domain", "dcb287ca-43c0-462c-a090-46b2debf69e2");
                script.setAttribute("data-test", "false");
            } else {
                script.src = "https://atl-onetrust-wrapper.stg-east.frontend.public.atl-paas.net/assets/atl-onetrust-wrapper.min.js";
                script.setAttribute("data-domain", "dc680e5f-1f51-48c1-8bd3-d6db0aeece4a");
                script.setAttribute("data-test", "true");
            }
            script.setAttribute("data-geofence", "false");
            script.setAttribute("data-sync", "true");
            script.setAttribute("data-persist", "true");
            document.head.appendChild(script);
        }
    }, [
        environment,
        member,
        hasOptedOut
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($ed9204ab600b32ee$export$176269f5c5bd3866.Provider, {
        value: {
            hasOptedOut: hasOptedOut,
            privacyLink: privacyLink
        },
        children: children
    });
};

});
parcelRegister("bNHtH", function(module, exports) {
$parcel$export(module.exports, "smoothScrollTo", function () { return (parcelRequire("f7URE")).smoothScrollTo; });
$parcel$export(module.exports, "getCookie", function () { return (parcelRequire("aYCAT")).getCookie; });
$parcel$export(module.exports, "getColorInitial", function () { return (parcelRequire("hqPCQ")).getColorInitial; });
parcelRequire("idHT0");
parcelRequire("gI9BD");
parcelRequire("f7URE");
parcelRequire("aYCAT");
parcelRequire("hqPCQ");

});
parcelRegister("idHT0", function(module, exports) {

});

parcelRegister("gI9BD", function(module, exports) {
function $0450c67f237b05b6$export$49317cb72279665e(value) {
    return value?.type === "page";
}
function $0450c67f237b05b6$export$46149ed0abb1c97c(value) {
    if (!$0450c67f237b05b6$export$49317cb72279665e(value)) throw new TypeError(`Value is not of type PageModel: ${value}`);
}

});

parcelRegister("f7URE", function(module, exports) {

$parcel$export(module.exports, "smoothScrollTo", function () { return $34aee2c7de10e971$export$d5f7947ff20d6949; });
//smooth vertical scroll to element
function $34aee2c7de10e971$export$d5f7947ff20d6949(target) {
    //exit if these aren't defined
    if (!document || !window) return;
    //most browsers can handle this
    if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({
            top: target,
            behavior: "smooth"
        });
        return;
    }
    //fallback safari behavior
    $34aee2c7de10e971$var$scrollTo(target);
}
function $34aee2c7de10e971$var$getScrollPosition() {
    return document.documentElement.scrollTop || document.body.scrollTop;
}
//recursive scroll
function $34aee2c7de10e971$var$scrollTo(target) {
    const current = $34aee2c7de10e971$var$getScrollPosition();
    const scrollBy = Math.ceil((target - current) * 0.2);
    if (Math.abs(scrollBy) < 5) {
        //close enough, finish up
        window.scrollTo({
            top: target
        });
        //scroll correction (window.scrollto doesn't work as expected in safari at low zoom)
        const secondCheck = $34aee2c7de10e971$var$getScrollPosition();
        if (target !== secondCheck) {
            const distance = (target - secondCheck) * 2; //scroll by double the px difference
            window.scrollBy({
                top: distance
            });
        }
    } else {
        //move by this amount and enqueue next scroll
        window.scrollBy({
            top: scrollBy
        });
        setTimeout(()=>{
            window.requestAnimationFrame(()=>$34aee2c7de10e971$var$scrollTo(target));
        }, 10);
    }
}

});

parcelRegister("aYCAT", function(module, exports) {

$parcel$export(module.exports, "getCookie", function () { return $f2b6562c9eb37ead$export$4be65e66cfa2648a; });
$parcel$export(module.exports, "setCookie", function () { return $f2b6562c9eb37ead$export$110700823644f4a6; });
const $f2b6562c9eb37ead$export$4be65e66cfa2648a = (key)=>{
    const encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&");
    const regex = new RegExp("(?:(?:^|.*;)\\s*" + encodedName + "\\s*\\=\\s*([^;]*).*$)|^.*$");
    return decodeURIComponent(document.cookie.replace(regex, "$1")) || null;
};
const $f2b6562c9eb37ead$export$110700823644f4a6 = (key, value, days)=>{
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = key + "=" + value + expires + "; path=/";
};
const $f2b6562c9eb37ead$export$6a874b7a74007875 = (key)=>{
    $f2b6562c9eb37ead$export$110700823644f4a6(key, "", -1);
};

});

parcelRegister("hqPCQ", function(module, exports) {

$parcel$export(module.exports, "getColorInitial", function () { return $354ae923e4db6b6f$export$cd85023e78927017; });
function $354ae923e4db6b6f$export$cd85023e78927017(color, randomIfUndefined = false) {
    //return initial letter
    if (color) return color.charAt(0);
    //by default stop here
    if (!randomIfUndefined) return;
    //return random color
    //TODO: get design approval to add Purple (used by UiNavLink)
    const colors = [
        "B",
        "G",
        "M",
        "R",
        "T",
        "Y"
    ];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
}

});


parcelRegister("5XW95", function(module, exports) {

$parcel$export(module.exports, "useMember", function () { return $3b827dbf16ebddc4$export$5f6dc815edc3d62f; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $iSvIT = parcelRequire("iSvIT");

var $7hIo5 = parcelRequire("7hIo5");

var $dajlT = parcelRequire("dajlT");
function $3b827dbf16ebddc4$export$5f6dc815edc3d62f(id = "me") {
    const client = (0, $dajlT.useTrelloClient)();
    return (0, $7hIo5.useAsync)((0, $iSvIT.useCallback)(()=>client.getMember({
            id: id,
            fields: [
                "organizations"
            ],
            organizations: "all",
            organizationFields: [
                "name",
                "displayName",
                "memberships",
                "url",
                "products"
            ],
            credits: "freeTrial"
        }), [
        id
    ]));
}

});
parcelRegister("7hIo5", function(module, exports) {

$parcel$export(module.exports, "useAsync", function () { return $54dc8d61a4833517$export$cdf1dc76b55502e3; });

var $iSvIT = parcelRequire("iSvIT");
function $54dc8d61a4833517$export$cdf1dc76b55502e3(operation) {
    const [result, setResult] = (0, $iSvIT.useState)({
        status: "pending"
    });
    (0, $iSvIT.useEffect)(()=>{
        operation().then((value)=>setResult({
                status: "resolved",
                value: value
            })).catch((error)=>setResult({
                status: "rejected",
                error: error
            }));
    }, [
        operation
    ]);
    return result;
}

});

parcelRegister("dajlT", function(module, exports) {

$parcel$export(module.exports, "useTrelloClient", function () { return $0f5283eee3b0aea2$export$d9c1da6dc240e7a2; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("bwkIl");
var $20fPV = parcelRequire("20fPV");

var $btBHj = parcelRequire("btBHj");
const $0f5283eee3b0aea2$var$defaultClient = typeof window !== "undefined" && (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") ? (0, $btBHj.stubTrelloClient)() : new (0, $20fPV.TrelloClient)();
const $0f5283eee3b0aea2$export$d13a80d5b9774b22 = /*#__PURE__*/ (0, $iSvIT.createContext)($0f5283eee3b0aea2$var$defaultClient);
const $0f5283eee3b0aea2$export$427208b626198d5e = ({ client: client, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($0f5283eee3b0aea2$export$d13a80d5b9774b22.Provider, {
        value: client,
        children: children
    });
};
function $0f5283eee3b0aea2$export$d9c1da6dc240e7a2() {
    return (0, $iSvIT.useContext)($0f5283eee3b0aea2$export$d13a80d5b9774b22);
}

});
parcelRegister("bwkIl", function(module, exports) {
$parcel$export(module.exports, "TrelloClient", function () { return (parcelRequire("20fPV")).TrelloClient; });
$parcel$export(module.exports, "paidProductCodes", function () { return (parcelRequire("7fKir")).paidProductCodes; });
parcelRequire("20fPV");
parcelRequire("1d101");
parcelRequire("btBHj");
parcelRequire("7fKir");

});
parcelRegister("20fPV", function(module, exports) {

$parcel$export(module.exports, "TrelloClient", function () { return $97059ee9a0e34f21$export$235c4986b8ca4832; });

var $aYuhG = parcelRequire("aYuhG");

var $3OHMm = parcelRequire("3OHMm");
class $97059ee9a0e34f21$export$235c4986b8ca4832 {
    constructor({ baseUrl: baseUrl = "" } = {}){
        this.baseUrl = baseUrl;
    }
    /**
   * @see https://developer.atlassian.com/cloud/trello/rest/#api-members-id-get
   */ async getMember({ id: id = "me", organizations: organizations, organizationFields: organizationFields, credits: credits } = {}) {
        const searchParams = (0, $3OHMm.encodeSearchParams)({
            organizations: organizations,
            organization_fields: organizationFields,
            credits: credits
        });
        const response = await (0, (/*@__PURE__*/$parcel$interopDefault($aYuhG)))(`${this.baseUrl}/1/members/${id}${searchParams ? `?${searchParams}` : ""}`, {
            credentials: "include"
        });
        if (response.ok) return await response.json();
        else throw Error(await response.text());
    }
}

});
parcelRegister("aYuhG", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof $parcel$global !== "undefined" && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== "undefined" && globalThis1 || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== "undefined" && $parcel$global || {};
        var support = {
            searchParams: "URLSearchParams" in g,
            iterable: "Symbol" in g && "iterator" in Symbol,
            blob: "FileReader" in g && "Blob" in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: "FormData" in g,
            arrayBuffer: "ArrayBuffer" in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                "[object Int8Array]",
                "[object Uint8Array]",
                "[object Uint8ClampedArray]",
                "[object Int16Array]",
                "[object Uint16Array]",
                "[object Int32Array]",
                "[object Uint32Array]",
                "[object Float32Array]",
                "[object Float64Array]"
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== "string") name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== "string") value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ", " + value : value;
        };
        Headers.prototype["delete"] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError("Already read"));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : "utf-8";
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join("");
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = "";
                } else if (typeof body === "string") this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get("content-type")) {
                    if (typeof body === "string") this.headers.set("content-type", "text/plain;charset=UTF-8");
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set("content-type", this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error("could not read as ArrayBuffer");
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error("could not read FormData body as text");
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            "CONNECT",
            "DELETE",
            "GET",
            "HEAD",
            "OPTIONS",
            "PATCH",
            "POST",
            "PUT",
            "TRACE"
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError("Already read");
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || "same-origin";
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || "GET");
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ("AbortController" in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === "GET" || this.method === "HEAD") && body) throw new TypeError("Body not allowed for GET or HEAD requests");
            this._initBody(body);
            if (this.method === "GET" || this.method === "HEAD") {
                if (options.cache === "no-store" || options.cache === "no-cache") {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split("&").forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split("=");
                    var name = split.shift().replace(/\+/g, " ");
                    var value = split.join("=").replace(/\+/g, " ");
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split("\r").map(function(header) {
                return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(":");
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(":").trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn("Response " + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = "default";
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? "" : "" + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || "";
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ""
            });
            response.ok = false;
            response.status = 0;
            response.type = "error";
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError("Invalid status code");
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException("Aborted", "AbortError"));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
                    var body = "response" in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request failed"));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError("Network request timed out"));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException("Aborted", "AbortError"));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === "" && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === "include") xhr.withCredentials = true;
                else if (request.credentials === "omit") xhr.withCredentials = false;
                if ("responseType" in xhr) {
                    if (support.blob) xhr.responseType = "blob";
                    else if (support.arrayBuffer) xhr.responseType = "arraybuffer";
                }
                if (init && typeof init.headers === "object" && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener("abort", abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener("abort", abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === "undefined" ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, "__esModule", {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("3OHMm", function(module, exports) {

$parcel$export(module.exports, "encodeSearchParams", function () { return $1db68e8838894f0d$export$ef4261a06d5d811c; });
function $1db68e8838894f0d$export$ef4261a06d5d811c(record) {
    const searchParams = Object.keys(record).reduce((result, key)=>{
        const value = record[key];
        if (typeof value === "undefined") return result;
        else if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") return [
            ...result,
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        ];
        else return [
            ...result,
            `${encodeURIComponent(key)}=${value.map(encodeURIComponent).join(",")}`
        ];
    }, []);
    if (searchParams.length > 0) return searchParams.join("&");
    else return null;
}

});


parcelRegister("1d101", function(module, exports) {

});

parcelRegister("btBHj", function(module, exports) {

$parcel$export(module.exports, "stubTrelloClient", function () { return $ccf8d3df404d027f$export$41d88c7868678f8e; });
function $ccf8d3df404d027f$export$41d88c7868678f8e({ getMember: getMember = async ()=>$ccf8d3df404d027f$export$83184f8f2f1e28a9() } = {}) {
    return {
        getMember: getMember
    };
}
function $ccf8d3df404d027f$export$83184f8f2f1e28a9({ id: id = "some-member-id", aaId: aaId = "some-member-aaId", username: username = "charlie", email: email = "charlie@atlassian.com", fullName: fullName = "Charles Atlas", credits: credits = [], idPremOrgsAdmin: idPremOrgsAdmin = [
    "atlassian-org-id",
    "atlassian_marketing-org-id"
], organizations: organizations = [
    {
        id: "atlassian-org-id",
        name: "atlassian",
        displayName: "Atlassian",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian"
    },
    {
        displayName: "BXP Dev Team",
        name: "bxpdevteam",
        id: "bxpdevteam-org-id",
        url: "https://trello.com/bxpdevteam"
    },
    {
        displayName: "BXPT",
        name: "bxpt",
        id: "bxpt-org-id",
        url: "https://trello.com/bxpt"
    },
    {
        displayName: "BXPT Trello",
        name: "bxptuser",
        id: "bxptuser-org-id",
        url: "https://trello.com/bxptuser"
    },
    {
        displayName: "Marketing",
        name: "atlassian_marketing",
        id: "atlassian_marketing-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian_marketing"
    },
    {
        displayName: "Web Team",
        name: "atlassianwebteam",
        id: "atlassianwebteam-org-id",
        url: "https://trello.com/atlassianwebteam"
    }
] } = {}) {
    return {
        id: id,
        aaId: aaId,
        username: username,
        email: email,
        fullName: fullName,
        credits: credits,
        idPremOrgsAdmin: idPremOrgsAdmin,
        organizations: organizations
    };
}
function $ccf8d3df404d027f$export$a28dfb590d0010e7({ id: id = "some-member-id", aaId: aaId = "some-member-aaId", username: username = "charlie", email: email = "charlie@atlassian.com", fullName: fullName = "Charles Atlas", credits: credits = [], idPremOrgsAdmin: idPremOrgsAdmin = [
    "atlassian-org-id",
    "atlassian_marketing-org-id"
], organizations: organizations = [
    {
        id: "atlassian-org-id",
        name: "atlassian",
        displayName: "Atlassian",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian"
    },
    {
        displayName: "Marketing",
        name: "atlassian_marketing",
        id: "atlassian_marketing-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian_marketing"
    }
] } = {}) {
    return {
        id: id,
        aaId: aaId,
        username: username,
        email: email,
        fullName: fullName,
        credits: credits,
        idPremOrgsAdmin: idPremOrgsAdmin,
        organizations: organizations
    };
}
function $ccf8d3df404d027f$export$58325cadb9670f95({ id: id = "some-member-id", aaId: aaId = "some-member-aaId", username: username = "charlie", email: email = "charlie@atlassian.com", fullName: fullName = "Charles Atlas", credits: credits = [], idPremOrgsAdmin: idPremOrgsAdmin = [
    "atlassian-org-id",
    "atlassian_marketing-org-id"
], organizations: organizations = [
    {
        id: "atlassian-org-id",
        name: "atlassian",
        displayName: "Atlassian",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "normal",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian"
    },
    {
        displayName: "BXP Dev Team",
        name: "bxpdevteam",
        id: "bxpdevteam-org-id",
        url: "https://trello.com/bxpdevteam"
    },
    {
        displayName: "BXPT",
        name: "bxpt",
        id: "bxpt-org-id",
        url: "https://trello.com/bxpt"
    },
    {
        displayName: "BXPT Trello",
        name: "bxptuser",
        id: "bxptuser-org-id",
        url: "https://trello.com/bxptuser"
    },
    {
        displayName: "Marketing",
        name: "atlassian_marketing",
        id: "atlassian_marketing-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "normal",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian_marketing"
    },
    {
        displayName: "Web Team",
        name: "atlassianwebteam",
        id: "atlassianwebteam-org-id",
        url: "https://trello.com/atlassianwebteam"
    }
] } = {}) {
    return {
        id: id,
        aaId: aaId,
        username: username,
        email: email,
        fullName: fullName,
        credits: credits,
        idPremOrgsAdmin: idPremOrgsAdmin,
        organizations: organizations
    };
}
function $ccf8d3df404d027f$export$bec563ccab374ccf({ id: id = "some-member-id", aaId: aaId = "some-member-aaId", username: username = "charlie", email: email = "charlie@atlassian.com", fullName: fullName = "Charles Atlas", credits: credits = [
    "gold"
], idPremOrgsAdmin: idPremOrgsAdmin = [
    "atlassian-org-id",
    "atlassian_marketing-org-id"
], organizations: organizations = [
    {
        id: "atlassian-org-id",
        name: "atlassian",
        displayName: "Atlassian",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian"
    },
    {
        displayName: "BXP Dev Team",
        name: "bxpdevteam",
        id: "bxpdevteam-org-id",
        url: "https://trello.com/bxpdevteam"
    },
    {
        displayName: "BXPT",
        name: "bxpt",
        id: "bxpt-org-id",
        url: "https://trello.com/bxpt"
    },
    {
        displayName: "BXPT Trello",
        name: "bxptuser",
        id: "bxptuser-org-id",
        url: "https://trello.com/bxptuser"
    },
    {
        displayName: "Marketing",
        name: "atlassian_marketing",
        id: "atlassian_marketing-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian_marketing"
    },
    {
        displayName: "Web Team",
        name: "atlassianwebteam",
        id: "atlassianwebteam-org-id",
        url: "https://trello.com/atlassianwebteam"
    }
] } = {}) {
    return {
        id: id,
        aaId: aaId,
        username: username,
        email: email,
        fullName: fullName,
        credits: credits,
        idPremOrgsAdmin: idPremOrgsAdmin,
        organizations: organizations
    };
}
function $ccf8d3df404d027f$export$3ac1b9509c979905({ id: id = "some-member-id", aaId: aaId = "some-member-aaId", username: username = "charlie", email: email = "charlie@atlassian.com", fullName: fullName = "Charles Atlas", credits: credits = [], idPremOrgsAdmin: idPremOrgsAdmin = [
    "atlassian-org-id",
    "atlassian_marketing-org-id"
], organizations: organizations = [
    {
        id: "atlassian-org-id",
        name: "atlassian",
        displayName: "Atlassian",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian",
        products: [
            110
        ]
    },
    {
        displayName: "BXP Dev Team",
        name: "bxpdevteam",
        id: "bxpdevteam-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/bxpdevteam",
        products: []
    },
    {
        displayName: "BXPT",
        name: "bxpt",
        id: "bxpt-org-id",
        url: "https://trello.com/bxpt"
    },
    {
        displayName: "BXPT Trello",
        name: "bxptuser",
        id: "bxptuser-org-id",
        url: "https://trello.com/bxptuser"
    },
    {
        displayName: "Marketing",
        name: "atlassian_marketing",
        id: "atlassian_marketing-org-id",
        memberships: [
            {
                id: "some-id",
                idMember: "some-member-id",
                memberType: "admin",
                unconfirmed: false,
                deactivated: false
            }
        ],
        url: "https://trello.com/atlassian_marketing",
        products: [
            107
        ]
    },
    {
        displayName: "Web Team",
        name: "atlassianwebteam",
        id: "atlassianwebteam-org-id",
        url: "https://trello.com/atlassianwebteam"
    }
] } = {}) {
    return {
        id: id,
        aaId: aaId,
        username: username,
        email: email,
        fullName: fullName,
        credits: credits,
        idPremOrgsAdmin: idPremOrgsAdmin,
        organizations: organizations
    };
}

});

parcelRegister("7fKir", function(module, exports) {

$parcel$export(module.exports, "paidProductCodes", function () { return $349d8cd8f4af96f9$export$72903c66a89949c9; });
const $349d8cd8f4af96f9$export$72903c66a89949c9 = [
    100,
    108,
    109,
    110,
    111,
    112,
    97,
    96,
    101,
    98,
    99,
    102,
    107
];

});






parcelRegister("g4xTJ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsAttributes", function () { return $0a46ce35731ba9bc$export$1fd8522aeddaccda; });
$parcel$export(module.exports, "AnalyticsAttributesProvider", function () { return $0a46ce35731ba9bc$export$71c3cf5fbcf643ed; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $0a46ce35731ba9bc$export$d85a999a714c8f14 = /*#__PURE__*/ (0, $iSvIT.createContext)({});
function $0a46ce35731ba9bc$export$1fd8522aeddaccda() {
    const context = (0, $iSvIT.useContext)($0a46ce35731ba9bc$export$d85a999a714c8f14);
    if (context === undefined) throw new Error("`useAnalyticsAttributes` must be used within a `AnalyticsContext.Provider`");
    return context;
}
const $0a46ce35731ba9bc$export$71c3cf5fbcf643ed = ({ value: value, children: children })=>{
    const analyticsAttributes = $0a46ce35731ba9bc$export$1fd8522aeddaccda();
    return /*#__PURE__*/ (0, $loA2J.jsx)($0a46ce35731ba9bc$export$d85a999a714c8f14.Provider, {
        value: {
            ...analyticsAttributes,
            ...value
        },
        children: children
    });
};

});

parcelRegister("1pYrM", function(module, exports) {

$parcel$export(module.exports, "useBreakpoints", function () { return $6ae5866d723e02d4$export$e818ed21e924bde4; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $iSvIT = parcelRequire("iSvIT");

var $7AG7X = parcelRequire("7AG7X");
parcelRequire("h6yBX");
var $bQJY8 = parcelRequire("bQJY8");
function $6ae5866d723e02d4$export$e818ed21e924bde4(throttleDelay = 100) {
    const [matchingBreakpoints, setMatchingBreakpoints] = (0, $iSvIT.useState)([
        "xs"
    ]);
    //xs | sm | md | lg | xl
    const breakpointKeys = Object.keys((0, $bQJY8.breakpoints));
    (0, $iSvIT.useEffect)(()=>{
        const resize = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            setMatchingBreakpoints(breakpointKeys.filter((breakpoint)=>typeof window.matchMedia == "function" && window.matchMedia(`(min-width: ${(0, $bQJY8.breakpoints)[breakpoint]}px)`).matches));
        }, throttleDelay);
        resize();
        window.addEventListener("resize", resize);
        return ()=>{
            window.removeEventListener("resize", resize);
        };
    }, [
        throttleDelay
    ]);
    return matchingBreakpoints;
}

});
parcelRegister("7AG7X", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $586c92cacdb16610$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $586c92cacdb16610$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $586c92cacdb16610$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $586c92cacdb16610$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $586c92cacdb16610$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $586c92cacdb16610$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $586c92cacdb16610$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $586c92cacdb16610$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $586c92cacdb16610$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $586c92cacdb16610$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $586c92cacdb16610$var$root = $586c92cacdb16610$var$freeGlobal || $586c92cacdb16610$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $586c92cacdb16610$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $586c92cacdb16610$var$objectToString = $586c92cacdb16610$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $586c92cacdb16610$var$nativeMax = Math.max, $586c92cacdb16610$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $586c92cacdb16610$var$now = function() {
    return $586c92cacdb16610$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $586c92cacdb16610$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($586c92cacdb16610$var$FUNC_ERROR_TEXT);
    wait = $586c92cacdb16610$var$toNumber(wait) || 0;
    if ($586c92cacdb16610$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $586c92cacdb16610$var$nativeMax($586c92cacdb16610$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $586c92cacdb16610$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $586c92cacdb16610$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($586c92cacdb16610$var$now());
    }
    function debounced() {
        var time = $586c92cacdb16610$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $586c92cacdb16610$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($586c92cacdb16610$var$FUNC_ERROR_TEXT);
    if ($586c92cacdb16610$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $586c92cacdb16610$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $586c92cacdb16610$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $586c92cacdb16610$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $586c92cacdb16610$var$isSymbol(value) {
    return typeof value == "symbol" || $586c92cacdb16610$var$isObjectLike(value) && $586c92cacdb16610$var$objectToString.call(value) == $586c92cacdb16610$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $586c92cacdb16610$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($586c92cacdb16610$var$isSymbol(value)) return $586c92cacdb16610$var$NAN;
    if ($586c92cacdb16610$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $586c92cacdb16610$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($586c92cacdb16610$var$reTrim, "");
    var isBinary = $586c92cacdb16610$var$reIsBinary.test(value);
    return isBinary || $586c92cacdb16610$var$reIsOctal.test(value) ? $586c92cacdb16610$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $586c92cacdb16610$var$reIsBadHex.test(value) ? $586c92cacdb16610$var$NAN : +value;
}
module.exports = $586c92cacdb16610$var$throttle;

});

parcelRegister("h6yBX", function(module, exports) {
$parcel$export(module.exports, "cssColorsFromBackgroundField", function () { return (parcelRequire("54E1V")).cssColorsFromBackgroundField; });
$parcel$export(module.exports, "getColorsFromBackgroundField", function () { return (parcelRequire("54E1V")).getColorsFromBackgroundField; });
$parcel$export(module.exports, "isBackgroundFieldArray", function () { return (parcelRequire("8korH")).isBackgroundFieldArray; });
$parcel$export(module.exports, "generateFieldsStyles", function () { return (parcelRequire("2EK56")).generateFieldsStyles; });
$parcel$export(module.exports, "blockquoteCSS", function () { return (parcelRequire("jY3ml")).blockquoteCSS; });
$parcel$export(module.exports, "breakpoints", function () { return (parcelRequire("bQJY8")).breakpoints; });
$parcel$export(module.exports, "colorContrastCSS", function () { return (parcelRequire("i2LPb")).colorContrastCSS; });
$parcel$export(module.exports, "colorCSS", function () { return (parcelRequire("i2LPb")).colorCSS; });
$parcel$export(module.exports, "colorCSSforSVG", function () { return (parcelRequire("i2LPb")).colorCSSforSVG; });
$parcel$export(module.exports, "colorHex", function () { return (parcelRequire("i2LPb")).colorHex; });
$parcel$export(module.exports, "containerWidths", function () { return (parcelRequire("8DhG7")).containerWidths; });
$parcel$export(module.exports, "getContainerWidth", function () { return (parcelRequire("8DhG7")).getContainerWidth; });
$parcel$export(module.exports, "BIG_NAV_PX_HEIGHT", function () { return (parcelRequire("6IIwI")).BIG_NAV_PX_HEIGHT; });
$parcel$export(module.exports, "SMALL_NAV_PX_HEIGHT", function () { return (parcelRequire("6IIwI")).SMALL_NAV_PX_HEIGHT; });
$parcel$export(module.exports, "SUB_NAV_PX_HEIGHT", function () { return (parcelRequire("6IIwI")).SUB_NAV_PX_HEIGHT; });
$parcel$export(module.exports, "formCSS", function () { return (parcelRequire("aY5bH")).formCSS; });
$parcel$export(module.exports, "gradientCSS", function () { return (parcelRequire("aKIz7")).gradientCSS; });
$parcel$export(module.exports, "gradientExists", function () { return (parcelRequire("aKIz7")).gradientExists; });
$parcel$export(module.exports, "gradients", function () { return (parcelRequire("aKIz7")).gradients; });
$parcel$export(module.exports, "h2", function () { return (parcelRequire("7XWgk")).h2; });
$parcel$export(module.exports, "h4", function () { return (parcelRequire("7XWgk")).h4; });
$parcel$export(module.exports, "h5", function () { return (parcelRequire("7XWgk")).h5; });
$parcel$export(module.exports, "maxWidth", function () { return (parcelRequire("aT9Ik")).maxWidth; });
$parcel$export(module.exports, "minWidth", function () { return (parcelRequire("aT9Ik")).minWidth; });
$parcel$export(module.exports, "getOrderedListCSS", function () { return (parcelRequire("9iTli")).getOrderedListCSS; });
$parcel$export(module.exports, "radius", function () { return (parcelRequire("fpcku")).radius; });
$parcel$export(module.exports, "shadow", function () { return (parcelRequire("a7xVp")).shadow; });
$parcel$export(module.exports, "scrollMargin", function () { return (parcelRequire("2vQ6x")).scrollMargin; });
$parcel$export(module.exports, "spacing", function () { return (parcelRequire("2vQ6x")).spacing; });
$parcel$export(module.exports, "fontSizes", function () { return (parcelRequire("kL1mL")).fontSizes; });
$parcel$export(module.exports, "getTextSizeCSS", function () { return (parcelRequire("kL1mL")).getTextSizeCSS; });
$parcel$export(module.exports, "theme", function () { return (parcelRequire("bC5c7")).theme; });
$parcel$export(module.exports, "zIndex", function () { return (parcelRequire("1D7YE")).zIndex; });

$parcel$export(module.exports, "GlobalStyles", function () { return $4c2d466db883f535$export$c507fb1c2e1ac13a; });

var $hYbro = parcelRequire("hYbro");

var $jwUN6 = parcelRequire("jwUN6");

var $9cuU2 = parcelRequire("9cuU2");

var $3fxcR = parcelRequire("3fxcR");

var $buaFU = parcelRequire("buaFU");

var $kqfZ3 = parcelRequire("kqfZ3");
parcelRequire("54E1V");
parcelRequire("4kY1Y");
parcelRequire("2EK56");
parcelRequire("jY3ml");
parcelRequire("bQJY8");
parcelRequire("i2LPb");
parcelRequire("8DhG7");
parcelRequire("6IIwI");
parcelRequire("aY5bH");
parcelRequire("aKIz7");
parcelRequire("7XWgk");
parcelRequire("aT9Ik");
parcelRequire("9iTli");
parcelRequire("fpcku");
parcelRequire("a7xVp");
parcelRequire("2vQ6x");
parcelRequire("Zp1a0");
parcelRequire("kL1mL");
parcelRequire("bC5c7");
parcelRequire("1D7YE");
const $4c2d466db883f535$export$c507fb1c2e1ac13a = (0, $hYbro.createGlobalStyle)`
  :root {
    /* Trello color RGB values */
    --color-trelloblue-rgb: 0, 121, 191;
    --color-B50-rgb: 222, 235, 255;
    --color-B75-rgb: 178, 212, 255;
    --color-B100-rgb: 76, 154, 255;
    --color-B200-rgb: 38, 132, 255;
    --color-B300-rgb: 0, 101, 255;
    --color-B400-rgb: 0, 82, 204;
    --color-B500-rgb: 7, 71, 166;
    --color-G50-rgb: 227, 252, 239;
    --color-G75-rgb: 171, 245, 209;
    --color-G100-rgb: 121, 242, 192;
    --color-G200-rgb: 87, 217, 163;
    --color-G300-rgb: 54, 179, 126;
    --color-G400-rgb: 0, 135, 90;
    --color-G500-rgb: 0, 102, 68;
    --color-M50-rgb: 255, 242, 251;
    --color-M75-rgb: 252, 198, 235;
    --color-M100-rgb: 249, 156, 219;
    --color-M200-rgb: 237, 80, 180;
    --color-M300-rgb: 214, 38, 136;
    --color-M400-rgb: 178, 40, 101;
    --color-M500-rgb: 134, 36, 67;
    --color-N0-rgb: 255, 255, 255;
    --color-N10-rgb: 250, 251, 252;
    --color-N20-rgb: 244, 245, 247;
    --color-N30-rgb: 235, 236, 250;
    --color-N40-rgb: 223, 225, 230;
    --color-N50-rgb: 193, 199, 208;
    --color-N60-rgb: 179, 186, 197;
    --color-N70-rgb: 151, 160, 175;
    --color-N80-rgb: 107, 119, 140;
    --color-N90-rgb: 94, 108, 132;
    --color-N100-rgb: 66, 82, 110;
    --color-N200-rgb: 52, 69, 99;
    --color-N300-rgb: 7, 71, 166;
    --color-N400-rgb: 37, 56, 88;
    --color-N500-rgb: 22, 43, 77;
    --color-N600-rgb: 9, 30, 66;
    --color-N700-rgb: 7, 22, 48;
    --color-N800-rgb: 5, 16, 34;
    --color-N900-rgb: 23, 43, 77;
    --color-O50-rgb: 255, 241, 224;
    --color-O75-rgb: 254, 217, 181;
    --color-O100-rgb: 255, 171, 0;
    --color-O200-rgb: 255, 139, 0;
    --color-O300-rgb: 237, 106, 0;
    --color-O400-rgb: 202, 74, 0;
    --color-O500-rgb: 153, 55, 0;
    --color-P50-rgb: 244, 237, 255;
    --color-P75-rgb: 223, 196, 255;
    --color-P100-rgb: 196, 144, 255;
    --color-P200-rgb: 153, 76, 255;
    --color-P300-rgb: 131, 36, 229;
    --color-P400-rgb: 103, 36, 178;
    --color-P500-rgb: 77, 36, 133;
    --color-R50-rgb: 255, 237, 238;
    --color-R75-rgb: 255, 196, 200;
    --color-R100-rgb: 255, 143, 153;
    --color-R200-rgb: 255, 82, 100;
    --color-R300-rgb: 222, 53, 76;
    --color-R400-rgb: 191, 38, 62;
    --color-R500-rgb: 138, 34, 53;
    --color-T50-rgb: 227, 253, 255;
    --color-T75-rgb: 180, 244, 252;
    --color-T100-rgb: 128, 233, 247;
    --color-T200-rgb: 0, 199, 229;
    --color-T300-rgb: 0, 163, 191;
    --color-T400-rgb: 0, 128, 153;
    --color-T500-rgb: 0, 97, 115;
    --color-Y50-rgb: 255, 250, 230;
    --color-Y75-rgb: 255, 240, 179;
    --color-Y100-rgb: 255, 196, 0;
    --color-Y200-rgb: 255, 171, 0;
    --color-Y300-rgb: 243, 147, 0;
    --color-Y400-rgb: 216, 115, 0;
    --color-Y500-rgb: 164, 86, 0;
  }

  ${(0, $buaFU.normalize)}
  ${(0, $kqfZ3.typography)}
  ${(0, $9cuU2.elements)}
  ${(0, $jwUN6.components)}
  ${(0, $3fxcR.hideRecaptcha)}
`;

});
parcelRegister("jwUN6", function(module, exports) {

$parcel$export(module.exports, "components", function () { return $1d8bf3d266660a9a$export$9b5ac10f59f76296; });

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $1d8bf3d266660a9a$export$9b5ac10f59f76296 = (0, $hYbro.css)`
    .tooltip-content {
        a {
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
        }
        p {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.5rem")}
            &:last-child {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0")}
            }
        }
    }
`;

});
parcelRegister("i2LPb", function(module, exports) {

$parcel$export(module.exports, "colorContrastCSS", function () { return $0ac05032e62e9932$export$316e7bbdfec09207; });
$parcel$export(module.exports, "colorIsDark", function () { return $0ac05032e62e9932$export$76249e090d1c76db; });
$parcel$export(module.exports, "colorCSS", function () { return $0ac05032e62e9932$export$4bb09f62a76c64a; });
$parcel$export(module.exports, "headingColorContrastCSS", function () { return $0ac05032e62e9932$export$70868f441b1b3b06; });
$parcel$export(module.exports, "borderColorCSS", function () { return $0ac05032e62e9932$export$7912b4fc4933581a; });
$parcel$export(module.exports, "colorExists", function () { return $0ac05032e62e9932$export$873acafc2fdc1d12; });
$parcel$export(module.exports, "colorCSSforSVG", function () { return $0ac05032e62e9932$export$7385aefa2ffd8ee7; });
$parcel$export(module.exports, "colorHex", function () { return $0ac05032e62e9932$export$d795a87d7e5092e6; });
//return black or white based on the best contrast for a given colorId
function $0ac05032e62e9932$export$316e7bbdfec09207(colorId, opacity = 1) {
    return $0ac05032e62e9932$export$76249e090d1c76db(colorId) ? $0ac05032e62e9932$export$4bb09f62a76c64a("N0", opacity) : $0ac05032e62e9932$export$4bb09f62a76c64a("N900", opacity);
}
function $0ac05032e62e9932$export$70868f441b1b3b06(colorId, opacity = 1) {
    if ($0ac05032e62e9932$export$76249e090d1c76db(colorId) && !colorId.startsWith("N") && colorId !== "trelloblue") return $0ac05032e62e9932$export$4bb09f62a76c64a(`${colorId[0]}50`, opacity);
    else if (!$0ac05032e62e9932$export$76249e090d1c76db(colorId) && !colorId.startsWith("N")) return $0ac05032e62e9932$export$4bb09f62a76c64a(`${colorId[0]}500`, opacity);
    else return $0ac05032e62e9932$export$316e7bbdfec09207(colorId);
}
function $0ac05032e62e9932$export$7912b4fc4933581a(colorId, opacity = 0.5) {
    if (colorId === "trelloblue") return $0ac05032e62e9932$export$4bb09f62a76c64a("B100", opacity);
    return $0ac05032e62e9932$export$4bb09f62a76c64a(`${colorId[0]}100`, opacity);
}
function $0ac05032e62e9932$export$4bb09f62a76c64a(colorId, opacity = 1) {
    if (colorId && $0ac05032e62e9932$export$873acafc2fdc1d12(colorId)) {
        const [red, green, blue] = $0ac05032e62e9932$export$8f45430ccf837300[colorId].rgb;
        return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
    } else return "transparent";
}
function $0ac05032e62e9932$export$7385aefa2ffd8ee7(colorId) {
    if (!colorId || !$0ac05032e62e9932$export$873acafc2fdc1d12(colorId)) return "currentColor";
    return encodeURIComponent($0ac05032e62e9932$export$d795a87d7e5092e6(colorId));
}
function $0ac05032e62e9932$export$d795a87d7e5092e6(colorId) {
    function hex(c) {
        const hex = c.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }
    const [red, green, blue] = $0ac05032e62e9932$export$8f45430ccf837300[colorId].rgb;
    return `#${hex(red)}${hex(green)}${hex(blue)}`;
}
function $0ac05032e62e9932$export$873acafc2fdc1d12(colorId) {
    return typeof colorId === "string" && Object.keys($0ac05032e62e9932$export$8f45430ccf837300).includes(colorId);
}
function $0ac05032e62e9932$export$76249e090d1c76db(colorId) {
    return $0ac05032e62e9932$export$873acafc2fdc1d12(colorId) && $0ac05032e62e9932$export$8f45430ccf837300[colorId].isDark;
}
const $0ac05032e62e9932$export$8f45430ccf837300 = {
    trelloblue: {
        rgb: [
            0,
            121,
            191
        ],
        isDark: true
    },
    B50: {
        rgb: [
            222,
            235,
            255
        ],
        isDark: false
    },
    B75: {
        rgb: [
            178,
            212,
            255
        ],
        isDark: false
    },
    B100: {
        rgb: [
            76,
            154,
            255
        ],
        isDark: false
    },
    B200: {
        rgb: [
            38,
            132,
            255
        ],
        isDark: false
    },
    B300: {
        rgb: [
            0,
            101,
            255
        ],
        isDark: true
    },
    B400: {
        rgb: [
            0,
            82,
            204
        ],
        isDark: true
    },
    B500: {
        rgb: [
            7,
            71,
            166
        ],
        isDark: true
    },
    G50: {
        rgb: [
            227,
            252,
            239
        ],
        isDark: false
    },
    G75: {
        rgb: [
            171,
            245,
            209
        ],
        isDark: false
    },
    G100: {
        rgb: [
            121,
            242,
            192
        ],
        isDark: false
    },
    G200: {
        rgb: [
            87,
            217,
            163
        ],
        isDark: false
    },
    G300: {
        rgb: [
            54,
            179,
            126
        ],
        isDark: false
    },
    G400: {
        rgb: [
            0,
            135,
            90
        ],
        isDark: true
    },
    G500: {
        rgb: [
            0,
            102,
            68
        ],
        isDark: true
    },
    M50: {
        rgb: [
            255,
            242,
            251
        ],
        isDark: false
    },
    M75: {
        rgb: [
            252,
            198,
            235
        ],
        isDark: false
    },
    M100: {
        rgb: [
            249,
            156,
            219
        ],
        isDark: false
    },
    M200: {
        rgb: [
            237,
            80,
            180
        ],
        isDark: false
    },
    M300: {
        rgb: [
            214,
            38,
            136
        ],
        isDark: true
    },
    M400: {
        rgb: [
            178,
            40,
            101
        ],
        isDark: true
    },
    M500: {
        rgb: [
            134,
            36,
            67
        ],
        isDark: true
    },
    N0: {
        rgb: [
            255,
            255,
            255
        ],
        isDark: false
    },
    N10: {
        rgb: [
            250,
            251,
            252
        ],
        isDark: false
    },
    N20: {
        rgb: [
            244,
            245,
            247
        ],
        isDark: false
    },
    N30: {
        rgb: [
            235,
            236,
            250
        ],
        isDark: false
    },
    N40: {
        rgb: [
            223,
            225,
            230
        ],
        isDark: false
    },
    N50: {
        rgb: [
            193,
            199,
            208
        ],
        isDark: false
    },
    N60: {
        rgb: [
            179,
            186,
            197
        ],
        isDark: false
    },
    N70: {
        rgb: [
            165,
            173,
            186
        ],
        isDark: false
    },
    N80: {
        rgb: [
            151,
            160,
            175
        ],
        isDark: false
    },
    N90: {
        rgb: [
            137,
            147,
            164
        ],
        isDark: false
    },
    N100: {
        rgb: [
            122,
            134,
            154
        ],
        isDark: false
    },
    N200: {
        rgb: [
            108,
            121,
            143
        ],
        isDark: true
    },
    N300: {
        rgb: [
            94,
            108,
            132
        ],
        isDark: true
    },
    N400: {
        rgb: [
            80,
            95,
            121
        ],
        isDark: true
    },
    N500: {
        rgb: [
            66,
            82,
            110
        ],
        isDark: true
    },
    N600: {
        rgb: [
            52,
            69,
            99
        ],
        isDark: true
    },
    N700: {
        rgb: [
            37,
            56,
            88
        ],
        isDark: true
    },
    N800: {
        rgb: [
            23,
            43,
            77
        ],
        isDark: true
    },
    N900: {
        rgb: [
            9,
            30,
            66
        ],
        isDark: true
    },
    P50: {
        rgb: [
            234,
            230,
            255
        ],
        isDark: false
    },
    P75: {
        rgb: [
            192,
            182,
            242
        ],
        isDark: false
    },
    P100: {
        rgb: [
            153,
            141,
            217
        ],
        isDark: false
    },
    P200: {
        rgb: [
            135,
            119,
            217
        ],
        isDark: false
    },
    P300: {
        rgb: [
            101,
            84,
            192
        ],
        isDark: true
    },
    P400: {
        rgb: [
            82,
            67,
            170
        ],
        isDark: true
    },
    P500: {
        rgb: [
            64,
            50,
            148
        ],
        isDark: true
    },
    R50: {
        rgb: [
            255,
            235,
            229
        ],
        isDark: false
    },
    R75: {
        rgb: [
            255,
            189,
            173
        ],
        isDark: false
    },
    R100: {
        rgb: [
            255,
            143,
            115
        ],
        isDark: false
    },
    R200: {
        rgb: [
            255,
            116,
            82
        ],
        isDark: false
    },
    R300: {
        rgb: [
            255,
            86,
            48
        ],
        isDark: false
    },
    R400: {
        rgb: [
            222,
            53,
            11
        ],
        isDark: true
    },
    R500: {
        rgb: [
            191,
            38,
            0
        ],
        isDark: true
    },
    T50: {
        rgb: [
            230,
            252,
            255
        ],
        isDark: false
    },
    T75: {
        rgb: [
            179,
            245,
            255
        ],
        isDark: false
    },
    T100: {
        rgb: [
            121,
            226,
            242
        ],
        isDark: false
    },
    T200: {
        rgb: [
            0,
            199,
            229
        ],
        isDark: false
    },
    T300: {
        rgb: [
            0,
            184,
            217
        ],
        isDark: false
    },
    T400: {
        rgb: [
            0,
            163,
            191
        ],
        isDark: false
    },
    T500: {
        rgb: [
            0,
            141,
            166
        ],
        isDark: true
    },
    Y50: {
        rgb: [
            255,
            250,
            229
        ],
        isDark: false
    },
    Y75: {
        rgb: [
            255,
            240,
            178
        ],
        isDark: false
    },
    Y100: {
        rgb: [
            255,
            227,
            128
        ],
        isDark: false
    },
    Y200: {
        rgb: [
            255,
            196,
            0
        ],
        isDark: false
    },
    Y300: {
        rgb: [
            255,
            171,
            0
        ],
        isDark: false
    },
    Y400: {
        rgb: [
            255,
            153,
            31
        ],
        isDark: false
    },
    Y500: {
        rgb: [
            255,
            139,
            0
        ],
        isDark: false
    }
};

});

parcelRegister("jAJVK", function(module, exports) {

$parcel$export(module.exports, "redundantCssFromKebab", function () { return $666fbd7af6718f95$export$35e5e348ad44a51c; });
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $hYbro = parcelRequire("hYbro");
const $666fbd7af6718f95$export$c6c3579c35aca1dd = (camelKey, kebabKey, value)=>(0, $hYbro.css)({
        [camelKey]: value,
        [kebabKey]: value
    });
function $666fbd7af6718f95$var$kebabToCamel(key) {
    if (key.startsWith("--")) return key;
    const hasLeadingDash = key.startsWith("-");
    const parts = key.split("-").filter(Boolean);
    if (!parts.length) return key;
    const capitalize = (s)=>s.length ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    const first = parts[0];
    if (!first) return key;
    const rest = parts.slice(1);
    if (hasLeadingDash) return [
        capitalize(first),
        ...rest.map(capitalize)
    ].join("");
    return [
        first,
        ...rest.map(capitalize)
    ].join("");
}
function $666fbd7af6718f95$var$camelToKebab(key) {
    if (key.startsWith("Webkit")) return "-webkit-" + key.slice(6).replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
    if (key.startsWith("Moz")) return "-moz-" + key.slice(3).replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
    if (key.startsWith("ms")) return "-ms-" + key.slice(2).replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
    if (key.startsWith("O") && key.length > 1 && /[A-Z]/.test(key.charAt(1))) return "-o-" + key.slice(1).replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
    return key.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
const $666fbd7af6718f95$export$35e5e348ad44a51c = (kebabKey, value)=>{
    const camelKey = $666fbd7af6718f95$var$kebabToCamel(kebabKey);
    const normalizedKebab = kebabKey.includes("-") ? kebabKey : $666fbd7af6718f95$var$camelToKebab(kebabKey);
    return $666fbd7af6718f95$export$c6c3579c35aca1dd(camelKey, normalizedKebab, value);
};

});


parcelRegister("9cuU2", function(module, exports) {

$parcel$export(module.exports, "elements", function () { return $0e732e3f7e8d89d0$export$7a5d735b2ab6389d; });

var $hYbro = parcelRequire("hYbro");

var $6IIwI = parcelRequire("6IIwI");

var $7XWgk = parcelRequire("7XWgk");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");

var $bC5c7 = parcelRequire("bC5c7");
const $0e732e3f7e8d89d0$export$7a5d735b2ab6389d = (0, $hYbro.css)`
    :root {
        ${(0, $jAJVK.redundantCssFromKebab)("-fontfamilytext", `${(0, $6IIwI.FONT_FAMILY_TEXT)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("-fontfamilydisplay", `${(0, $6IIwI.FONT_FAMILY_DISPLAY)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "16px")}
    }
    body {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.text}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("min-height", "100vh")}
        &.prevent-scroll {
            ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
        }
    }
    .app-root {
        ${(0, $jAJVK.redundantCssFromKebab)("min-height", "100vh")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
        > div,
        > header,
        > main,
        > footer {
            ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        }
        > :not(main) {
            ${(0, $jAJVK.redundantCssFromKebab)("flex-grow", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("flex-shrink", "0")}
        }
        > main {
            ${(0, $jAJVK.redundantCssFromKebab)("flex-grow", "1")}
        }
    }
    // Reassign text font-family for certain languages
    // See: https://hello.atlassian.net/browse/BXPT-897
    html[lang="vi"] body {
        ${(0, $jAJVK.redundantCssFromKebab)("-fontfamilytext", `${(0, $6IIwI.FONT_FAMILY_SYSTEM)}`)}
    }
    h1,
    .h1 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $7XWgk.h1)}
    }
    h2,
    .h2 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $7XWgk.h2)}
    }
    h3,
    .h3 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $7XWgk.h3)}
    }
    h4,
    .h4 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $7XWgk.h4)}
    }
    h5,
    .h5 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $7XWgk.h5)}
    }
    h6,
    .h6 {
        ${(0, $7XWgk.h6)}
    }
    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "1.5rem")}
    }
    ul,
    ol {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-inline-start", "1.5rem")}
    }
    li {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.25rem")}
    }
    li:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0")}
    }
    img {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    }
    a {
        ${(0, $jAJVK.redundantCssFromKebab)("color", "rgba(0, 82, 204, 1)")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
        &:hover {
            ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "underline !important")}
        }
    }
    /* Light background containers should have blue links - but NOT in header */
    main [style*="background-color: rgb(255, 255, 255)"] a,
    main [style*="background-color: rgb(244, 245, 247)"] a,
    main [data-testid="block"] a {
        ${(0, $jAJVK.redundantCssFromKebab)("color", "rgba(0, 82, 204, 1) !important")}
    }
    /* Header links inherit color from their respective styled-components */
    header a,
    header button {
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    }
`;

});
parcelRegister("6IIwI", function(module, exports) {

$parcel$export(module.exports, "BIG_NAV_PX_HEIGHT", function () { return $6456de2706f006ab$export$f891d1e18a355be5; });
$parcel$export(module.exports, "SMALL_NAV_PX_HEIGHT", function () { return $6456de2706f006ab$export$d0f37a93e2704e1b; });
$parcel$export(module.exports, "SUB_NAV_PX_HEIGHT", function () { return $6456de2706f006ab$export$8e57507d63b351ce; });
$parcel$export(module.exports, "FONT_FAMILY_DISPLAY", function () { return $6456de2706f006ab$export$8309a0253bbc50; });
$parcel$export(module.exports, "FONT_FAMILY_TEXT", function () { return $6456de2706f006ab$export$5ca0c2a5858f9313; });
$parcel$export(module.exports, "FONT_FAMILY_SYSTEM", function () { return $6456de2706f006ab$export$6848d347edcabf46; });
$parcel$export(module.exports, "FONT_FAMILY_CODE", function () { return $6456de2706f006ab$export$8fe1407ce2149a59; });
const $6456de2706f006ab$export$f891d1e18a355be5 = 60;
const $6456de2706f006ab$export$d0f37a93e2704e1b = 70;
const $6456de2706f006ab$export$8e57507d63b351ce = 56; //mobile-only, eg /guide
const $6456de2706f006ab$export$8309a0253bbc50 = `'Charlie Display', sans-serif`;
const $6456de2706f006ab$export$5ca0c2a5858f9313 = `'Charlie Text', sans-serif`;
const $6456de2706f006ab$export$6848d347edcabf46 = `-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const $6456de2706f006ab$export$8fe1407ce2149a59 = `'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace`;

});

parcelRegister("7XWgk", function(module, exports) {

$parcel$export(module.exports, "h1", function () { return $a329a650c48b8674$export$448e4850cad7c7b0; });
$parcel$export(module.exports, "h2", function () { return $a329a650c48b8674$export$a943aa9a0fca3f0b; });
$parcel$export(module.exports, "h3", function () { return $a329a650c48b8674$export$7edd4a21fac8ce55; });
$parcel$export(module.exports, "h4", function () { return $a329a650c48b8674$export$51a85cc1b68f452c; });
$parcel$export(module.exports, "h5", function () { return $a329a650c48b8674$export$f44841a11990acb2; });
$parcel$export(module.exports, "h6", function () { return $a329a650c48b8674$export$c9ccd321d64f47e3; });

var $hYbro = parcelRequire("hYbro");

var $bQJY8 = parcelRequire("bQJY8");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");
const $a329a650c48b8674$var$baseHeadingStyle = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "0")}
`;
const $a329a650c48b8674$export$448e4850cad7c7b0 = (0, $hYbro.css)`
    ${$a329a650c48b8674$var$baseHeadingStyle}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xl}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25")}
    @media (min-width: ${(0, $bQJY8.breakpoints).md}px) {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "2.75rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.18181818")}
    }
    @media (min-width: ${(0, $bQJY8.breakpoints).lg}px) {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "3rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25")}
    }
`;
const $a329a650c48b8674$export$a943aa9a0fca3f0b = (0, $hYbro.css)`
    ${$a329a650c48b8674$var$baseHeadingStyle}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.33333333")}
    @media (min-width: ${(0, $bQJY8.breakpoints).md}px) {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxl}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.33333333")}
    }
`;
const $a329a650c48b8674$export$7edd4a21fac8ce55 = (0, $hYbro.css)`
    ${$a329a650c48b8674$var$baseHeadingStyle}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.2")}
    @media (min-width: ${(0, $bQJY8.breakpoints).md}px) {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.33333333")}
    }
`;
const $a329a650c48b8674$export$51a85cc1b68f452c = (0, $hYbro.css)`
    ${$a329a650c48b8674$var$baseHeadingStyle}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25")}
    @media (min-width: ${(0, $bQJY8.breakpoints).md}px) {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.2")}
    }
`;
const $a329a650c48b8674$export$f44841a11990acb2 = (0, $hYbro.css)`
    ${$a329a650c48b8674$var$baseHeadingStyle}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "uppercase")}
`;
const $a329a650c48b8674$export$c9ccd321d64f47e3 = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.2")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "0")}
`;

});
parcelRegister("bQJY8", function(module, exports) {

$parcel$export(module.exports, "breakpoints", function () { return $2f7b1ad91c08dcb2$export$d07517a676ce386f; });
const $2f7b1ad91c08dcb2$export$d07517a676ce386f = Object.freeze({
    xs: $2f7b1ad91c08dcb2$var$createBreakpoint(0),
    sm: $2f7b1ad91c08dcb2$var$createBreakpoint(576),
    md: $2f7b1ad91c08dcb2$var$createBreakpoint(768),
    lg: $2f7b1ad91c08dcb2$var$createBreakpoint(992),
    xl: $2f7b1ad91c08dcb2$var$createBreakpoint(1200)
});
function $2f7b1ad91c08dcb2$var$createBreakpoint(value) {
    return value;
}

});

parcelRegister("kL1mL", function(module, exports) {

$parcel$export(module.exports, "getTextSizeCSS", function () { return $cd762dbc5bad6eb7$export$8c3e8b7fd6619b1e; });
$parcel$export(module.exports, "fontSizes", function () { return $cd762dbc5bad6eb7$export$67baea80019ff381; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
function $cd762dbc5bad6eb7$export$8c3e8b7fd6619b1e(textSize) {
    if (!textSize) return (0, $hYbro.css)``;
    return textSize === "Large" ? (0, $hYbro.css)`
              ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${$cd762dbc5bad6eb7$export$67baea80019ff381.lg}`)}
              ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.75")}
          ` : (0, $hYbro.css)`
              ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${$cd762dbc5bad6eb7$export$67baea80019ff381.sm}`)}
          `;
}
const $cd762dbc5bad6eb7$export$67baea80019ff381 = {
    xxs: "0.75rem",
    // 12px
    xs: "0.875rem",
    // 14px
    sm: "1rem",
    // 16px
    md: "1.25rem",
    // 20px
    lg: "1.5rem",
    // 24px
    xl: "2rem",
    // 32px
    xxl: "2.25rem" // 36px
};

});


parcelRegister("bC5c7", function(module, exports) {

$parcel$export(module.exports, "theme", function () { return $09cdce95d630c616$export$bca14c5b3b88a9c9; });

var $6IIwI = parcelRequire("6IIwI");
const $09cdce95d630c616$var$fontFamily = {
    display: `var(--font-family-display, ${(0, $6IIwI.FONT_FAMILY_DISPLAY)})`,
    text: `var(--font-family-text, ${(0, $6IIwI.FONT_FAMILY_TEXT)})`
};
const $09cdce95d630c616$export$bca14c5b3b88a9c9 = {
    fontFamily: $09cdce95d630c616$var$fontFamily
};

});


parcelRegister("3fxcR", function(module, exports) {

$parcel$export(module.exports, "hideRecaptcha", function () { return $f82ac5bc229dd15d$export$e08bc9259e3bcb08; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $f82ac5bc229dd15d$export$e08bc9259e3bcb08 = (0, $hYbro.css)`
    .grecaptcha-badge {
        ${(0, $jAJVK.redundantCssFromKebab)("visibility", "hidden")}
    }
`;

});

parcelRegister("buaFU", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $83d5950e11a030ca$export$a3295358bff77e; });

var $hYbro = parcelRequire("hYbro");

var $54E1V = parcelRequire("54E1V");

var $i2LPb = parcelRequire("i2LPb");

var $6IIwI = parcelRequire("6IIwI");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");
const $83d5950e11a030ca$export$a3295358bff77e = (0, $hYbro.css)`
    *,
    *::before,
    *::after {
        ${(0, $jAJVK.redundantCssFromKebab)("box-sizing", "border-box")}
    }

    body {
        ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "N0"
})}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $6IIwI.FONT_FAMILY_SYSTEM)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.5")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-size-adjust", "100%")}
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-tap-highlight-color", "rgba(0, 0, 0, 0)")}
    }

    hr {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "1rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", "currentColor")}
        ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", "0.125")}
    }

    hr:not([size]) {
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1px")}
    }

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    }

    abbr[title],
    abbr[data-original-title] {
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "underline dotted")}
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "help")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration-skip-ink", "none")}
    }

    address {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "inherit")}
    }

    ol,
    ul {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "2rem")}
    }

    ol,
    ul,
    dl {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    }

    ol ol,
    ul ul,
    ol ul,
    ul ol {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }

    dt {
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
    }

    dd {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "0")}
    }

    blockquote {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 1rem")}
    }

    b,
    strong {
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "bolder")}
    }

    small {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.875em")}
    }

    sub,
    sup {
        ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.75em")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "baseline")}
    }

    sub {
        ${(0, $jAJVK.redundantCssFromKebab)("bottom", "-0.25em")}
    }

    sup {
        ${(0, $jAJVK.redundantCssFromKebab)("top", "-0.5em")}
    }

    a {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("B400")}`)}
    }

    a:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("B500")}`)}
    }

    a:not([href]),
    a:not([href]):hover {
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    }

    pre,
    code,
    kbd,
    samp {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $6IIwI.FONT_FAMILY_CODE)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "1em")}
    }

    pre {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.875em")}
    }

    pre code {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("word-break", "normal")}
    }

    code {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.875em")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("M500")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("word-wrap", "break-word")}
    }

    a > code {
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    }

    kbd {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.2rem 0.4rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.875em")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N900")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.2rem")}
    }

    kbd kbd {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "1em")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
    }

    figure {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 1rem")}
    }

    img {
        ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "middle")}
    }

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
        ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "middle")}
    }

    table {
        ${(0, $jAJVK.redundantCssFromKebab)("border-collapse", "collapse")}
    }

    caption {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N100")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
        ${(0, $jAJVK.redundantCssFromKebab)("caption-side", "bottom")}
    }

    th {
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "inherit")}
    }

    label {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.25rem")}
    }

    button {
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0")}
    }

    input,
    button,
    select,
    optgroup,
    textarea {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "inherit")}
    }

    button,
    input {
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "visible")}
    }

    button,
    select {
        ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "none")}
    }

    select {
        ${(0, $jAJVK.redundantCssFromKebab)("word-wrap", "normal")}
    }

    [list]::-webkit-calendar-picker-indicator {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }

    button,
    [type="button"],
    [type="reset"],
    [type="submit"] {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-appearance", "button")}
    }

    button:not(:disabled),
    [type="button"]:not(:disabled),
    [type="reset"]:not(:disabled),
    [type="submit"]:not(:disabled) {
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
    }

    ::-moz-focus-inner {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-style", "none")}
    }

    input[type="date"],
    input[type="time"],
    input[type="datetime-local"],
    input[type="month"] {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-appearance", "textfield")}
    }

    textarea {
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("resize", "vertical")}
    }

    fieldset {
        ${(0, $jAJVK.redundantCssFromKebab)("min-width", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
    }

    legend {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
        ${(0, $jAJVK.redundantCssFromKebab)("white-space", "normal")}
    }

    mark {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.2em")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("Y50")}`)}
    }

    progress {
        ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "baseline")}
    }

    ::-webkit-datetime-edit {
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "visible")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "0")}
    }

    [type="search"] {
        ${(0, $jAJVK.redundantCssFromKebab)("outline-offset", "-2px")}
        /* stylelint-disable-next-line property-no-vendor-prefix */
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-appearance", "textfield")}
    }

    ::-webkit-search-decoration {
        /* stylelint-disable-next-line property-no-vendor-prefix */
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-appearance", "none")}
    }

    ::-webkit-color-swatch-wrapper {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }

    ::-webkit-file-upload-button {
        ${(0, $jAJVK.redundantCssFromKebab)("font", "inherit")}
        /* stylelint-disable-next-line property-no-vendor-prefix */
        ${(0, $jAJVK.redundantCssFromKebab)("-webkit-appearance", "button")}
    }

    output {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
    }

    summary {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "list-item")}
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
    }

    template {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }

    main {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }

    [hidden] {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none !important")}
    }
`;

});
parcelRegister("54E1V", function(module, exports) {

$parcel$export(module.exports, "getColorsFromBackgroundField", function () { return $de4cc645d1c70934$export$d062c5d280c36484; });
$parcel$export(module.exports, "cssColorsFromBackgroundField", function () { return $de4cc645d1c70934$export$df9398e51bebdb66; });

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $aKIz7 = parcelRequire("aKIz7");

var $jAJVK = parcelRequire("jAJVK");
function $de4cc645d1c70934$export$d425c5dd99c3e3d7(value) {
    return !!value;
}
function $de4cc645d1c70934$export$d062c5d280c36484(background) {
    if ($de4cc645d1c70934$export$d425c5dd99c3e3d7(background)) {
        const { gradient: gradient, angle: angle, color: color } = background;
        if (gradient && (0, $aKIz7.gradientExists)(gradient)) return {
            background: (0, $aKIz7.gradientCSS)(gradient, angle),
            color: (0, $aKIz7.gradientContrastCSS)(gradient),
            medium: (0, $aKIz7.gradientContrastCSS)(gradient, 0.2),
            linkColor: (0, $aKIz7.gradientIsDark)(gradient) ? (0, $i2LPb.colorCSS)("N0", 0.8) : (0, $i2LPb.colorCSS)("B400"),
            linkHoverColor: (0, $aKIz7.gradientIsDark)(gradient) ? (0, $i2LPb.colorCSS)("N0") : (0, $i2LPb.colorCSS)("B500")
        };
        else if (color && (0, $i2LPb.colorExists)(color)) return {
            background: (0, $i2LPb.colorCSS)(color),
            color: (0, $i2LPb.colorContrastCSS)(color),
            medium: (0, $i2LPb.colorContrastCSS)(color, 0.2),
            headingColor: (0, $i2LPb.headingColorContrastCSS)(color),
            borderColor: (0, $i2LPb.borderColorCSS)(color),
            linkColor: (0, $i2LPb.colorIsDark)(color) ? (0, $i2LPb.colorCSS)("N0", 0.8) : (0, $i2LPb.colorCSS)("B400"),
            linkHoverColor: (0, $i2LPb.colorIsDark)(color) ? (0, $i2LPb.colorCSS)("N0") : (0, $i2LPb.colorCSS)("B500")
        };
    }
    return {};
}
function $de4cc645d1c70934$export$df9398e51bebdb66(backgroundField) {
    if (!$de4cc645d1c70934$export$d425c5dd99c3e3d7(backgroundField)) return null;
    const { background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor } = $de4cc645d1c70934$export$d062c5d280c36484(backgroundField);
    if (backgroundField.gradient) return (0, $hYbro.css)`
            ${(0, $jAJVK.redundantCssFromKebab)("background", `${background}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${color}`)}

            a {
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${linkColor}`)}
                &:hover {
                    ${(0, $jAJVK.redundantCssFromKebab)("color", `${linkHoverColor}`)}
                }
            }

            *:focus {
                ${(0, $jAJVK.redundantCssFromKebab)("outline", `2px solid ${color}`)}
                &:not(:focus-visible) {
                    ${(0, $jAJVK.redundantCssFromKebab)("outline", "0 !important")}
                }
            }
        `;
    else return (0, $hYbro.css)`
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${background}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${color}`)}

            a {
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${linkColor}`)}
                &:hover {
                    ${(0, $jAJVK.redundantCssFromKebab)("color", `${linkHoverColor}`)}
                }
            }

            *:focus {
                ${(0, $jAJVK.redundantCssFromKebab)("outline", `2px solid ${color}`)}
                &:not(:focus-visible) {
                    ${(0, $jAJVK.redundantCssFromKebab)("outline", "0 !important")}
                }
            }
        `;
}

});
parcelRegister("aKIz7", function(module, exports) {

$parcel$export(module.exports, "gradientContrastCSS", function () { return $52e38fdfa926376f$export$fc1c6c256b11f413; });
$parcel$export(module.exports, "gradientIsDark", function () { return $52e38fdfa926376f$export$55edeabf632c7b46; });
$parcel$export(module.exports, "gradientCSS", function () { return $52e38fdfa926376f$export$947f9d73cc0b554f; });
$parcel$export(module.exports, "gradientExists", function () { return $52e38fdfa926376f$export$75aff727aa04f8fe; });
$parcel$export(module.exports, "gradients", function () { return $52e38fdfa926376f$export$fc5727d09955ec17; });

var $i2LPb = parcelRequire("i2LPb");
function $52e38fdfa926376f$export$fc1c6c256b11f413(gradientId, opacity = 1) {
    return $52e38fdfa926376f$export$55edeabf632c7b46(gradientId) ? (0, $i2LPb.colorCSS)("N0", opacity) : (0, $i2LPb.colorCSS)("N900", opacity);
}
function $52e38fdfa926376f$export$947f9d73cc0b554f(gradientId, angle = 0) {
    if (gradientId && $52e38fdfa926376f$export$75aff727aa04f8fe(gradientId)) {
        const cssForStops = $52e38fdfa926376f$export$fc5727d09955ec17[gradientId].colors.map((colorId)=>(0, $i2LPb.colorCSS)(colorId)).join(",");
        return `linear-gradient(${angle}deg, ${cssForStops}) no-repeat`;
    } else return "transparent";
}
function $52e38fdfa926376f$export$75aff727aa04f8fe(gradientId) {
    return typeof gradientId === "string" && Object.keys($52e38fdfa926376f$export$fc5727d09955ec17).includes(gradientId);
}
function $52e38fdfa926376f$export$55edeabf632c7b46(gradientId) {
    return $52e38fdfa926376f$export$75aff727aa04f8fe(gradientId) && $52e38fdfa926376f$export$fc5727d09955ec17[gradientId].isDark;
}
const $52e38fdfa926376f$export$fc5727d09955ec17 = {
    W500: {
        colors: [
            "M400",
            "R200"
        ],
        isDark: true
    },
    W400: {
        colors: [
            "M300",
            "R100"
        ],
        isDark: false
    },
    W300: {
        colors: [
            "M200",
            "Y100"
        ],
        isDark: false
    },
    W200: {
        colors: [
            "M100",
            "Y50"
        ],
        isDark: false
    },
    W100: {
        colors: [
            "M50",
            "N0"
        ],
        isDark: false
    },
    WP500: {
        colors: [
            "P500",
            "M400"
        ],
        isDark: true
    },
    WP400: {
        colors: [
            "P400",
            "M200"
        ],
        isDark: true
    },
    WP300: {
        colors: [
            "P300",
            "M100"
        ],
        isDark: true
    },
    WP200: {
        colors: [
            "P75",
            "M75"
        ],
        isDark: false
    },
    WP100: {
        colors: [
            "P50",
            "N0"
        ],
        isDark: false
    },
    CP500: {
        colors: [
            "P500",
            "N800"
        ],
        isDark: true
    },
    CP400: {
        colors: [
            "P500",
            "B100"
        ],
        isDark: true
    },
    CP300: {
        colors: [
            "P300",
            "T50"
        ],
        isDark: false
    },
    CP200: {
        colors: [
            "P75",
            "B50"
        ],
        isDark: false
    },
    CP100: {
        colors: [
            "T50",
            "N0"
        ],
        isDark: false
    },
    C600: {
        colors: [
            "N900",
            "B500"
        ],
        isDark: true
    },
    C500: {
        colors: [
            "T500",
            "N800"
        ],
        isDark: true
    },
    C400: {
        colors: [
            "T400",
            "B500"
        ],
        isDark: true
    },
    C300: {
        colors: [
            "T300",
            "B300"
        ],
        isDark: false
    },
    C200: {
        colors: [
            "B75",
            "B50"
        ],
        isDark: false
    },
    C100: {
        colors: [
            "B50",
            "N0"
        ],
        isDark: false
    },
    S500: {
        colors: [
            "N800",
            "N600"
        ],
        isDark: true
    },
    S400: {
        colors: [
            "N600",
            "N80"
        ],
        isDark: true
    },
    S300: {
        colors: [
            "N300",
            "N50"
        ],
        isDark: false
    },
    S200: {
        colors: [
            "B75",
            "N30"
        ],
        isDark: false
    },
    S100: {
        colors: [
            "B40",
            "N0"
        ],
        isDark: false
    }
};

});



parcelRegister("kqfZ3", function(module, exports) {

$parcel$export(module.exports, "typography", function () { return $463aac7f2a80b3f6$export$d846a084e680d8e; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $463aac7f2a80b3f6$export$d846a084e680d8e = (0, $hYbro.css)`
    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "100")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6EnDcOBYnO67MYVJcpQLUc/85d36587de9855f3cd9f4e23f2119cf8/Charlie_Display-Thin.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/5Bpl6vErvLYCi1EdOqI2IK/b57fbec62ffab536b59e311837de9042/Charlie_Display-Thin.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "100")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/67WF3xGxF81QiZRksym42A/cf7c507569cbbee461ff241902706970/Charlie_Display-Thin_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/PanXvQtfIyAqIFbGpM8IM/b9b87b3c6ffee63861eb501a0cb160d1/Charlie_Display-Thin_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "200")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/8JLDocv5sujCQIY4WEZsz/ebe26b857bf93efe919a72c3697afa82/Charlie_Display-Light.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/1rikelY7zYfVVcGF0ufCMx/5525e29555ebb0b403de182f334e7f2b/Charlie_Display-Light.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "200")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/8JLDocv5sujCQIY4WEZsz/ebe26b857bf93efe919a72c3697afa82/Charlie_Display-Light.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/1rikelY7zYfVVcGF0ufCMx/5525e29555ebb0b403de182f334e7f2b/Charlie_Display-Light.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6nq3flI8NfgICrz3jZjLyD/81918253d594b7bb77eb898a468d4328/Charlie_Display-Regular.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/2GTE85R9nfLI58KxINGukf/9d35203b2fe1d4a89031954f118b6c9f/Charlie_Display-Regular.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6zBd9BZlMVg6Lzzo0c9JTB/d9954046ee355a5fdbf2c5212675e67e/Charlie_Display-Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/68hDvJoBF5iblYktO69b1g/7fd2a9f3582c8fc11d9d27fcfed38dd8/Charlie_Display-Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/3KRSiun937K2pXBPYiUwgB/17f578e7699c12924de360e09c018c7c/Charlie_Display-Semibold.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/oQSiwcfMwyNafeeJ3DIku/364b1a7409856a36ab05c2b43a1f9bde/Charlie_Display-Semibold.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/65xdTmUlQXTZEebPv41QKG/d21f19bb0e731f88caa3be64700a49f0/Charlie_Display-Semibold_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/T73q5xRByE5hy55AGMp54/67810084a3efdb1999b56f6542c85d01/Charlie_Display-Semibold_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/55uCHq9XzIzIG8yO7WRqfM/b62779fff17f06743e490f6d98a2001a/Charlie_Display-Bold.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/7lMBcxnaE1rq1n9am4LaWV/b17259435611992f2a6ffe48ca213f84/Charlie_Display-Bold.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/2o3Zm0no6lPnln5cHb7JR6/55f0b66048535d78193f516062ff58e4/Charlie_Display-Bold_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/2hEATjlHYKgFNGG3XEE8FL/e5e32f1fdd86414237477cc7130acf13/Charlie_Display-Bold_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "800")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/2QtjA2B9aCIa8HvyZcNWqL/886e02c2b15732bc62dc9550078d991c/Charlie_Display-Black.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/7mOCTVLMRdYynIubPDry0Y/85324db781253d544cf91d5c9078a820/Charlie_Display-Black.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "800")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/42ZnX9r0FEEC9i6aTjhGvx/9928d2d161b763db60a50c3edf0bfe78/Charlie_Display-Black_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/7J5fycblWMmgmMrC850GL9/610d735e3d4680bb111cfb40507beab7/Charlie_Display-Black_Italic.woff)
                format("woff");
    }

    /*
  @font-face {
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", "'Charlie Display'")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "900")}
    src: url(/fonts/charlie-display/Charlie_Display-Ultra.woff2) format('woff2'),
         url(/fonts/charlie-display/Charlie_Display-Ultra.woff) format('woff');
  }
  */

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Display"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "900")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/2aGTtufjwlwNeuEifuVsDA/933ed19de4d808d8c9618a0a96f282f0/Charlie_Display-Ultra.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/61USbw5Es8ifbW4QjjYATl/19979d7f1ff46dfe7c7b79e15aacc4bc/Charlie_Display-Ultra.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "100")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/1vzZOZUcRsW8G3dlrVRc9E/6b8b429a3a35eeda98227874727af9ef/Charlie_Text-Thin.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/csqcs1t6l1ByKLqji08Sd/7354daf990b1232c01f11b79c86b8b73/Charlie_Text-Thin.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "100")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/7JQoYrWJG8qtt0hqnGgei9/6d94ac079ded70cdced3b8b448890c3e/Charlie_Text-Thin_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/XA1kYory8Dhr5QrsKMlYY/df361dee9663b39de9eb21a1279b9399/Charlie_Text-Thin_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "200")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/1rfmGoSYAfdBOsdsg9qKLL/9ea188cbd87592d6ab6012f191958252/Charlie_Text-Light.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/1XWcCzbf5viNQnIbOqfeI4/8ccdfc8336f9ecb15e2f849c3fc51340/Charlie_Text-Light.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "200")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6S05s3tlC46wX9fKFizj1K/2cfa443b8c44adce54d1159035e38b23/Charlie_Text-Light_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/3kW42zdybmQkfndtF54bd1/910ddde712b570829f385b62476b2ea9/Charlie_Text-Light_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/41EruTPEOU9hcBwH94UVuZ/73ac40404d750278b451bf2adf186b1b/Charlie_Text-Regular.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/6h4LgfzSDGYFyOvrNTr21p/99d04355f5ef0b92b882013bb0857cf9/Charlie_Text-Regular.woff)
                format("woff");
    }

    /*
  @font-face {
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", "'Charlie Text'")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
    src: url(/fonts/charlie-text/Charlie_Text-Italic.woff2) format('woff2'),
         url(/fonts/charlie-text/Charlie_Text-Italic.woff) format('woff');
  }
  */

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/2d4nxzJwX8hfIqUN71D4OD/5e2c0c2a3677d935e91dd46635d5149d/Charlie_Text-Semibold.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/4Y73c86mEJg3PJBgQe0L8t/a5d27d39320e9703ed48dd3bdb308408/Charlie_Text-Semibold.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6oQuHbLiijMuGvWxuUyHsz/62fe2908bcad6b7e9fef8ca4db7f0f53/Charlie_Text-Semibold_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/3pI1pIJKtGUJG42qu4eZSU/56114eff490f7cc794552a7c9b4c8c8b/Charlie_Text-Semibold_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/6fvn66mVrRz4Yw3gQoPaJJ/458e6a69f0036d1e566e028fcbc26a50/Charlie_Text-Bold.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/3JvzHM3Atfe3nL2nvb4AqL/5bb9a76be7a4b053dbb276d9ffc6654a/Charlie_Text-Bold.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "700")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/3nA8vWk7MPMalamC0inRjz/11825f8df63da9f9b792cb5478e32bd5/Charlie_Text-Bold_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/5Ba4myVpyls8UQB3g5MPQj/86da6172a058cc143a707f21f5e5d058/Charlie_Text-Bold_Italic.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "800")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/2AZXOOAKgaXV55fqGI098Y/bb085d34b97c542aedea66d5e4d9bc95/Charlie_Text-Black.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/3czBeZah9GZg8dI5cMd2er/7a13c24355717ba63712c3550921339f/Charlie_Text-Black.woff)
                format("woff");
    }

    @font-face {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", '"Charlie Text"')}
        ${(0, $jAJVK.redundantCssFromKebab)("font-style", "italic")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-display", "swap")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "800")}
        src: url(https://assets.ctfassets.net/rz1oowkt5gyp/59WTxSNNVWGolxmuwpW2j4/87fd7ad49eedaf1949839a7395399b6a/Charlie_Text-Black_Italic.woff2)
                format("woff2"),
            url(https://assets.ctfassets.net/rz1oowkt5gyp/1UikYvlUIsLZk1JeznIrD8/87bd38612d2caae1f6ebd621027cbc4e/Charlie_Text-Black_Italic.woff)
                format("woff");
    }
`;

});

parcelRegister("4kY1Y", function(module, exports) {
$parcel$export(module.exports, "isBackgroundFieldArray", function () { return (parcelRequire("8korH")).isBackgroundFieldArray; });
parcelRequire("l7BxF");
parcelRequire("8korH");
parcelRequire("g9EAR");
parcelRequire("3lnSb");
parcelRequire("97TpM");
parcelRequire("1n3li");
parcelRequire("gDL9p");
parcelRequire("7o07x");
parcelRequire("fvr5a");
parcelRequire("WpqBN");
parcelRequire("iL9ZR");

});
parcelRegister("l7BxF", function(module, exports) {

$parcel$export(module.exports, "isAttachment", function () { return $f41fa3b613d192bc$export$c2f9f9e35f505ab8; });
function $f41fa3b613d192bc$export$c2f9f9e35f505ab8(value) {
    return [
        "scroll",
        "fixed",
        "local",
        "initial",
        "inherit"
    ].includes(value);
}

});

parcelRegister("8korH", function(module, exports) {

$parcel$export(module.exports, "isBackgroundFieldArray", function () { return $a332ad665e8ae6ea$export$598772d44fba01f5; });
parcelRequire("adnhq");
var $6JrLY = parcelRequire("6JrLY");

var $l7BxF = parcelRequire("l7BxF");

var $g9EAR = parcelRequire("g9EAR");

var $3lnSb = parcelRequire("3lnSb");

var $97TpM = parcelRequire("97TpM");

var $gDL9p = parcelRequire("gDL9p");

var $7o07x = parcelRequire("7o07x");

var $fvr5a = parcelRequire("fvr5a");

var $WpqBN = parcelRequire("WpqBN");

var $iL9ZR = parcelRequire("iL9ZR");
function $a332ad665e8ae6ea$export$7180ca172329ed36(value) {
    if (!(0, $6JrLY.isObject)(value)) return false;
    const temp = value;
    return (0, $l7BxF.isAttachment)(temp.attachment) && (0, $g9EAR.isBlendMode)(temp.blendMode) && (0, $97TpM.isClip)(temp.clip) && (0, $gDL9p.isImage)(temp.image) && (0, $7o07x.isOrigin)(temp.origin) && (0, $fvr5a.isPosition)(temp.position) && (0, $WpqBN.isRepeat)(temp.repeat) && (0, $iL9ZR.isSize)(temp.size);
}
function $a332ad665e8ae6ea$export$f1c93727546bd7c9(value) {
    if (!(0, $6JrLY.isObject)(value)) return false;
    const temp = value;
    return Array.isArray(temp.breakpoints) && temp.breakpoints.every((breakpoint)=>(0, $3lnSb.isBreakpoint)(breakpoint)) && typeof temp.color === "string" && Array.isArray(temp.properties) && temp.properties.every((property)=>$a332ad665e8ae6ea$export$7180ca172329ed36(property));
}
function $a332ad665e8ae6ea$export$598772d44fba01f5(value) {
    if (!Array.isArray(value) || value.length < 1) return false;
    return value.every((item)=>$a332ad665e8ae6ea$export$f1c93727546bd7c9(item));
}

});
parcelRegister("adnhq", function(module, exports) {
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("6JrLY")).isObject; });
$parcel$export(module.exports, "isRecord", function () { return (parcelRequire("4Uqkn")).isRecord; });
parcelRequire("coUeQ");
parcelRequire("66Jr8");
parcelRequire("hEGXQ");
parcelRequire("6JrLY");
parcelRequire("5XKZS");
parcelRequire("4Uqkn");
parcelRequire("4qhvN");
parcelRequire("eopap");

});
parcelRegister("coUeQ", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $907359b80f97ce13$export$43bee75e5e14138e; });
function $907359b80f97ce13$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
}
function $907359b80f97ce13$export$3c63dcefc1d74c49(value) {
    if (!$907359b80f97ce13$export$43bee75e5e14138e(value)) throw new TypeError(`Value is not of type array.`);
}

});

parcelRegister("66Jr8", function(module, exports) {
function $47268c60259a0d57$export$630801d484da15df(value) {
    return value === null;
}
function $47268c60259a0d57$export$31947e1aefef4655(value) {
    if ($47268c60259a0d57$export$7909a8efff3699c9(value)) throw new TypeError(`Value is not null.`);
}
function $47268c60259a0d57$export$7909a8efff3699c9(value) {
    return value !== null;
}
function $47268c60259a0d57$export$9c14e1a1fcf1d102(value) {
    if ($47268c60259a0d57$export$630801d484da15df(value)) throw new TypeError(`Value is null.`);
}

});

parcelRegister("hEGXQ", function(module, exports) {
function $cda77fe387bd0c59$export$7e4aa119212bc614(value) {
    return typeof value === "number";
}
function $cda77fe387bd0c59$export$98639c528a8f7f90(value) {
    if (!$cda77fe387bd0c59$export$7e4aa119212bc614(value)) throw new TypeError(`Value is not of type number.`);
}
function $cda77fe387bd0c59$export$9240adf59a14d18b(value) {
    return value;
}

});

parcelRegister("6JrLY", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $4e6c7d2895107f98$export$a6cdc56e425d0d0a; });
/* eslint-disable @typescript-eslint/ban-types */ function $4e6c7d2895107f98$export$a6cdc56e425d0d0a(value) {
    return value !== null && typeof value === "object";
}
function $4e6c7d2895107f98$export$28450c73da0c0cec(value) {
    if (!$4e6c7d2895107f98$export$a6cdc56e425d0d0a(value)) throw new TypeError(`Value is not of type object.`);
}

});

parcelRegister("5XKZS", function(module, exports) {
function $4576eb12c448144c$export$6003a5f097c73977(predicate) {
    return (value)=>!predicate(value);
}

});

parcelRegister("4Uqkn", function(module, exports) {

$parcel$export(module.exports, "isRecord", function () { return $3930d080279dffc9$export$6ba840931da50680; });

var $coUeQ = parcelRequire("coUeQ");

var $6JrLY = parcelRequire("6JrLY");
function $3930d080279dffc9$export$6ba840931da50680(value) {
    return (0, $6JrLY.isObject)(value) && !(0, $coUeQ.isArray)(value);
}
function $3930d080279dffc9$export$3372e6121710b67c(value) {
    if (!$3930d080279dffc9$export$6ba840931da50680(value)) throw TypeError(`Value is not of type Record<string | number | symbol, unknown>`);
}
function $3930d080279dffc9$export$5bf60f6fb0235abd(record) {
    return Object.keys(record);
}

});

parcelRegister("4qhvN", function(module, exports) {
function $33872ca448932a64$export$844ec244b1367d54(value) {
    return typeof value === "string";
}
function $33872ca448932a64$export$7ff2c3a8f780f104(value) {
    if (!$33872ca448932a64$export$844ec244b1367d54(value)) throw new TypeError(`Value is not of type string.`);
}
function $33872ca448932a64$export$25e58f6be9d2ebe5(value) {
    return value;
}

});

parcelRegister("eopap", function(module, exports) {
function $a7a6d436923f1876$export$fce6876652108ab(value) {
    return value === undefined;
}
function $a7a6d436923f1876$export$53402e64a64c3f87(value) {
    if (!$a7a6d436923f1876$export$fce6876652108ab(value)) throw new TypeError(`Value is not undefined.`);
}
function $a7a6d436923f1876$export$e7321bf46d18757f(value) {
    return value !== undefined;
}
function $a7a6d436923f1876$export$f232a18cc1f66d93(value) {
    if (!$a7a6d436923f1876$export$e7321bf46d18757f(value)) throw new TypeError(`Value is undefined.`);
}

});


parcelRegister("g9EAR", function(module, exports) {

$parcel$export(module.exports, "isBlendMode", function () { return $2d7dc782ba6ac968$export$f3ee9daa084c076a; });
function $2d7dc782ba6ac968$export$f3ee9daa084c076a(value) {
    return [
        "normal",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "saturation",
        "color",
        "luminosity"
    ].includes(value);
}

});

parcelRegister("3lnSb", function(module, exports) {

$parcel$export(module.exports, "isBreakpoint", function () { return $f4bec70fefea956f$export$6899cdff5ad9e85c; });
function $f4bec70fefea956f$export$6899cdff5ad9e85c(value) {
    return [
        "xs",
        "sm",
        "md",
        "lg",
        "xl"
    ].includes(value);
}

});

parcelRegister("97TpM", function(module, exports) {

$parcel$export(module.exports, "isClip", function () { return $192a1bd77367dc6d$export$a063616e452ccfa; });
function $192a1bd77367dc6d$export$a063616e452ccfa(value) {
    return [
        "border-box",
        "padding-box",
        "content-box",
        "initial",
        "inherit"
    ].includes(value);
}

});

parcelRegister("gDL9p", function(module, exports) {

$parcel$export(module.exports, "isImage", function () { return $4b64144a2e63a644$export$fb85bc5d6d9ef19b; });
parcelRequire("adnhq");
var $6JrLY = parcelRequire("6JrLY");
function $4b64144a2e63a644$export$125b59614f576538(value) {
    return [
        "image",
        "gradient"
    ].includes(value);
}
function $4b64144a2e63a644$export$4ed21a0a126be250(value) {
    return [
        0,
        60,
        90,
        120,
        180,
        240,
        270,
        300
    ].includes(value);
}
function $4b64144a2e63a644$export$fb85bc5d6d9ef19b(value) {
    if (!(0, $6JrLY.isObject)(value)) return false;
    const temp = value;
    return $4b64144a2e63a644$export$125b59614f576538(temp.type) && (0, $6JrLY.isObject)(temp.image) && typeof temp.image.id === "string" && typeof temp.image.value === "string" && (0, $6JrLY.isObject)(temp.gradient) && typeof temp.gradient.value === "string" && $4b64144a2e63a644$export$4ed21a0a126be250(temp.gradient.angle);
}

});

parcelRegister("7o07x", function(module, exports) {

$parcel$export(module.exports, "isOrigin", function () { return $96b2034f7b4c6738$export$6a266b5097894154; });
function $96b2034f7b4c6738$export$6a266b5097894154(value) {
    return [
        "border-box",
        "padding-box",
        "content-box",
        "initial",
        "inherit"
    ].includes(value);
}

});

parcelRegister("fvr5a", function(module, exports) {

$parcel$export(module.exports, "isPosition", function () { return $e9db61012e9621e5$export$1680e4b48df7f4f2; });
parcelRequire("adnhq");
var $6JrLY = parcelRequire("6JrLY");

var $1n3li = parcelRequire("1n3li");
function $e9db61012e9621e5$export$959c5d0e52b8565b(value) {
    return [
        "keywords",
        "units"
    ].includes(value);
}
function $e9db61012e9621e5$export$58c4c96d995e7e60(value) {
    return [
        "left",
        "center",
        "right"
    ].includes(value);
}
function $e9db61012e9621e5$export$8f72a12be1e0284d(value) {
    return [
        "top",
        "center",
        "bottom"
    ].includes(value);
}
function $e9db61012e9621e5$export$1680e4b48df7f4f2(value) {
    if (typeof value !== "object" || Array.isArray(value) || value === null) return false;
    const temp = value;
    return $e9db61012e9621e5$export$959c5d0e52b8565b(temp.fieldType) && (0, $6JrLY.isObject)(temp.keywords) && $e9db61012e9621e5$export$58c4c96d995e7e60(temp.keywords.horizontal) && $e9db61012e9621e5$export$8f72a12be1e0284d(temp.keywords.vertical) && (0, $6JrLY.isObject)(temp.units) && (0, $1n3li.isCSSUnits)(temp.units.unit) && typeof temp.units.horizontal === "number" && typeof temp.units.vertical === "number";
}

});
parcelRegister("1n3li", function(module, exports) {

$parcel$export(module.exports, "isCSSUnits", function () { return $6d967ac363a56fa5$export$d019e76bca6c5732; });
function $6d967ac363a56fa5$export$d019e76bca6c5732(value) {
    return [
        "px",
        "%"
    ].includes(value);
}

});


parcelRegister("WpqBN", function(module, exports) {

$parcel$export(module.exports, "isRepeat", function () { return $c747d4ae0015fdfe$export$291f7ac08cbed5b2; });
function $c747d4ae0015fdfe$export$291f7ac08cbed5b2(value) {
    return [
        "repeat",
        "repeat-x",
        "repeat-y",
        "no-repeat",
        "initial",
        "inherit"
    ].includes(value);
}

});

parcelRegister("iL9ZR", function(module, exports) {

$parcel$export(module.exports, "isSize", function () { return $1402ad0d2bad78d1$export$f72d8951b36b047e; });
parcelRequire("adnhq");
var $6JrLY = parcelRequire("6JrLY");

var $1n3li = parcelRequire("1n3li");
function $1402ad0d2bad78d1$export$673e06471e88d29a(value) {
    return [
        "keyword",
        "units"
    ].includes(value);
}
function $1402ad0d2bad78d1$export$a560a896f022975d(value) {
    return [
        "auto",
        "cover",
        "contain",
        "initial",
        "inherit"
    ].includes(value);
}
function $1402ad0d2bad78d1$export$f72d8951b36b047e(value) {
    if (!(0, $6JrLY.isObject)(value)) return false;
    const temp = value;
    return $1402ad0d2bad78d1$export$673e06471e88d29a(temp.fieldType) && $1402ad0d2bad78d1$export$a560a896f022975d(temp.keyword) && (0, $6JrLY.isObject)(temp.units) && (0, $1n3li.isCSSUnits)(temp.units.unit) && typeof temp.units.width === "number" && typeof temp.units.height === "number" && typeof temp.units.isAutoWidth === "boolean" && typeof temp.units.isAutoHeight === "boolean";
}

});



parcelRegister("2EK56", function(module, exports) {

$parcel$export(module.exports, "generateFieldsStyles", function () { return $f29d0292673f7016$export$b22672c0d1f194e0; });

var $hYbro = parcelRequire("hYbro");

var $54E1V = parcelRequire("54E1V");

var $bQJY8 = parcelRequire("bQJY8");

var $i2LPb = parcelRequire("i2LPb");

var $aKIz7 = parcelRequire("aKIz7");

var $jAJVK = parcelRequire("jAJVK");
function $f29d0292673f7016$export$b22672c0d1f194e0(fields) {
    const allStyles = fields.map((field)=>$f29d0292673f7016$export$4ddfe5edfe3e28c6(field));
    return (0, $hYbro.css)`
        ${allStyles}
    `;
}
function $f29d0292673f7016$export$4ddfe5edfe3e28c6(field) {
    const allBreakpointStyles = [];
    field.breakpoints.forEach((breakpoint)=>{
        if (breakpoint === "xs") allBreakpointStyles.push($f29d0292673f7016$export$3124946bb8d7fa98(field.color, field.properties, (0, $bQJY8.breakpoints).xs, (0, $bQJY8.breakpoints).sm));
        if (breakpoint === "sm") allBreakpointStyles.push($f29d0292673f7016$export$3124946bb8d7fa98(field.color, field.properties, (0, $bQJY8.breakpoints).sm, (0, $bQJY8.breakpoints).md));
        if (breakpoint === "md") allBreakpointStyles.push($f29d0292673f7016$export$3124946bb8d7fa98(field.color, field.properties, (0, $bQJY8.breakpoints).md, (0, $bQJY8.breakpoints).lg));
        if (breakpoint === "lg") allBreakpointStyles.push($f29d0292673f7016$export$3124946bb8d7fa98(field.color, field.properties, (0, $bQJY8.breakpoints).lg, (0, $bQJY8.breakpoints).xl));
        if (breakpoint === "xl") allBreakpointStyles.push($f29d0292673f7016$export$3124946bb8d7fa98(field.color, field.properties, (0, $bQJY8.breakpoints).xl));
    });
    return (0, $hYbro.css)`
        ${allBreakpointStyles}
    `;
}
function $f29d0292673f7016$export$3124946bb8d7fa98(color, propertiesArr, lower, upper) {
    const mediaQuery = $f29d0292673f7016$export$6365b86438881493(lower, upper);
    const bgStyles = $f29d0292673f7016$export$f764aad4aba43d47(color, propertiesArr);
    // Return empty if no styles to apply
    if (!bgStyles || Array.isArray(bgStyles) && bgStyles.length === 0) return (0, $hYbro.css)``;
    return (0, $hYbro.css)`
        @media ${mediaQuery} {
            ${bgStyles}
        }
    `;
}
function $f29d0292673f7016$export$6365b86438881493(lower, upper) {
    if (upper) return `(min-width: ${lower}px) and (max-width: ${upper - 1}px)`;
    else return `(min-width: ${lower}px)`;
}
function $f29d0292673f7016$export$f764aad4aba43d47(color, propertiesArr) {
    const textColor = $f29d0292673f7016$export$c6b7257b000708b9(color);
    if (!propertiesArr.length) return textColor || (0, $hYbro.css)``;
    const bgProps = $f29d0292673f7016$export$c95b1852843d1cd9(propertiesArr);
    return textColor ? (0, $hYbro.css)`
              ${bgProps}
              ${textColor}
          ` : bgProps;
}
function $f29d0292673f7016$export$c95b1852843d1cd9(propertiesArr) {
    return (0, $hYbro.css)`
        ${(0, $jAJVK.redundantCssFromKebab)("background-attachment", `${$f29d0292673f7016$export$191acd2d897d7b72(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-blend-mode", `${$f29d0292673f7016$export$deffd73bc5fc4224(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-clip", `${$f29d0292673f7016$export$2e96b263e9ea729d(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-image", `${$f29d0292673f7016$export$cd2b50685893b99f(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-origin", `${$f29d0292673f7016$export$314bd9eb1cb6c627(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-position", `${$f29d0292673f7016$export$52f0b14945c01396(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", `${$f29d0292673f7016$export$f9501e57764437ac(propertiesArr)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("background-size", `${$f29d0292673f7016$export$6f226e9944d63d1d(propertiesArr)}`)}
    `;
}
function $f29d0292673f7016$export$c6b7257b000708b9(color) {
    return color === "transparent" ? (0, $hYbro.css)`
              ${(0, $jAJVK.redundantCssFromKebab)("background-color", "transparent")}
          ` : (0, $54E1V.cssColorsFromBackgroundField)({
        color: color
    });
}
function $f29d0292673f7016$export$191acd2d897d7b72(propertiesArr) {
    return propertiesArr.map((properties)=>properties.attachment).join(", ");
}
function $f29d0292673f7016$export$deffd73bc5fc4224(propertiesArr) {
    return propertiesArr.map((properties)=>properties.blendMode).join(", ");
}
function $f29d0292673f7016$export$2e96b263e9ea729d(propertiesArr) {
    return propertiesArr.map((properties)=>properties.clip).join(", ");
}
function $f29d0292673f7016$export$cd2b50685893b99f(propertiesArr) {
    return propertiesArr.map((properties)=>$f29d0292673f7016$export$7bbe71215a7470f4(properties.image)).join(", ");
}
function $f29d0292673f7016$export$314bd9eb1cb6c627(propertiesArr) {
    return propertiesArr.map((properties)=>properties.origin).join(", ");
}
function $f29d0292673f7016$export$f9501e57764437ac(propertiesArr) {
    return propertiesArr.map((properties)=>properties.repeat).join(", ");
}
function $f29d0292673f7016$export$6f226e9944d63d1d(propertiesArr) {
    return propertiesArr.map((properties)=>$f29d0292673f7016$export$efeee65e01c519f5(properties.size)).join(", ");
}
function $f29d0292673f7016$export$52f0b14945c01396(propertiesArr) {
    return propertiesArr.map((properties)=>$f29d0292673f7016$export$991da5164b4af9c4(properties.position)).join(", ");
}
function $f29d0292673f7016$export$7bbe71215a7470f4(image) {
    if (image.type === "image") {
        if (image.image.value === "none") return "none";
        else return `url("${image.image.value}")`;
    } else return $f29d0292673f7016$export$a408029d7a9d5bd1(image.gradient.value, image.gradient.angle);
}
function $f29d0292673f7016$export$991da5164b4af9c4(position) {
    if (position.fieldType === "keywords") {
        //hack for safari subpixel rounding bug
        const positionVertical = position.keywords.vertical === "bottom" ? "bottom -0.5px" : position.keywords.vertical;
        return `${position.keywords.horizontal} ${positionVertical}`;
    } else return `${position.units.horizontal}${position.units.unit} ${position.units.vertical}${position.units.unit}`;
}
function $f29d0292673f7016$export$efeee65e01c519f5(size) {
    if (size.fieldType === "keyword") return size.keyword;
    else {
        const width = size.units.isAutoWidth ? "auto" : `${size.units.width}${size.units.unit}`;
        const height = size.units.isAutoHeight ? "auto" : `${size.units.height}${size.units.unit}`;
        return `${width} ${height}`;
    }
}
function $f29d0292673f7016$export$a408029d7a9d5bd1(gradientId, angle) {
    if ((0, $aKIz7.gradientExists)(gradientId)) {
        const cssForStops = (0, $aKIz7.gradients)[gradientId].colors.map((colorId)=>(0, $i2LPb.colorCSS)(colorId)).join(",");
        return `linear-gradient(${angle}deg, ${cssForStops})`;
    } else return "none";
}

});

parcelRegister("jY3ml", function(module, exports) {

$parcel$export(module.exports, "blockquoteCSS", function () { return $da74d78c339a12c2$export$f0729bdc0fa770f3; });

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");
const $da74d78c339a12c2$export$f0729bdc0fa770f3 = (0, $hYbro.css)`
    blockquote {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.5")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "1rem")}

        > * {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "1rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "4.5rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-end", "1rem")}

            @media (max-width: 576px) {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "0.7rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "4rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "1rem")}
            }
        }

        &::before {
            ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("T400")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("content", "'\"'")}
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "300")}
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", "6.5rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "-0.8rem")}

            @media (max-width: 576px) {
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", "5.5rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "-1rem")}
            }
        }
    }
`;

});

parcelRegister("8DhG7", function(module, exports) {

$parcel$export(module.exports, "containerWidths", function () { return $b83a8dcc8788a06f$export$6a69b95c124db40c; });
$parcel$export(module.exports, "getContainerWidth", function () { return $b83a8dcc8788a06f$export$4bc9150518443cd1; });
const $b83a8dcc8788a06f$export$6a69b95c124db40c = {
    sm: 540,
    md: 720,
    lg: 960,
    xl: 1140,
    xxl: 1320
};
function $b83a8dcc8788a06f$export$4bc9150518443cd1(breakpoint, span = 12) {
    return `${$b83a8dcc8788a06f$export$6a69b95c124db40c[breakpoint] * span / 12}px`;
}

});

parcelRegister("aY5bH", function(module, exports) {

$parcel$export(module.exports, "formCSS", function () { return $05ff6ecf55fd0511$export$8f3bd2fbe416f2aa; });

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $fpcku = parcelRequire("fpcku");

var $jAJVK = parcelRequire("jAJVK");
const $05ff6ecf55fd0511$export$8f3bd2fbe416f2aa = (0, $hYbro.css)`
    input,
    select,
    textarea,
    button[type="submit"] {
        ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("N20")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.75rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.4rem 0.8rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "250ms ease-out")}
        &:focus {
            ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("B300", 0.5)}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 3px ${(0, $i2LPb.colorCSS)("B300", 0.15)}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}
        }
    }
    select {
        ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
    }
    textarea {
        ${(0, $jAJVK.redundantCssFromKebab)("min-height", "6.25rem")}
    }
    button[type="submit"] {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B300")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("B300")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.7rem 1rem 0.8rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
        &:hover {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B400")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("B400")}`)}
        }
        &:active {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B500")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("B500")}`)}
        }
        &:focus {
            ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("B400", 0.5)}`)}
        }
    }
`;

});
parcelRegister("fpcku", function(module, exports) {

$parcel$export(module.exports, "radius", function () { return $0c0fbf2ceb3f2f08$export$872dd985a098dd45; });
const $0c0fbf2ceb3f2f08$export$872dd985a098dd45 = {
    button: "0.3rem",
    small: "0.5rem",
    medium: "1rem",
    large: "3rem"
};

});


parcelRegister("aT9Ik", function(module, exports) {

$parcel$export(module.exports, "minWidth", function () { return $5c86b445e6ee27c6$export$ee148fbbe8357dd2; });
$parcel$export(module.exports, "maxWidth", function () { return $5c86b445e6ee27c6$export$488fda99655ff65a; });
/**
 * Usage: `@media ${minWidth.lg} { * CSS rules * }`
 */ const $5c86b445e6ee27c6$export$ee148fbbe8357dd2 = {
    sm: "(min-width: 576px)",
    md: "(min-width: 768px)",
    lg: "(min-width: 992px)",
    xl: "(min-width: 1200px)"
};
const $5c86b445e6ee27c6$export$488fda99655ff65a = {
    sm: "(max-width: 575.98px)",
    md: "(max-width: 767.98px)",
    lg: "(max-width: 991.98px)",
    xl: "(max-width: 1199.98px)"
};

});

parcelRegister("9iTli", function(module, exports) {

$parcel$export(module.exports, "getOrderedListCSS", function () { return $b16626c32ce3ad5d$export$def8e8b3047d9ef2; });

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");
function $b16626c32ce3ad5d$export$def8e8b3047d9ef2(appearance) {
    if (!appearance) return (0, $hYbro.css)`
            ol,
            ul {
                ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
                p {
                    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
                }
            }
        `;
    const beforeContent = appearance === "UpperAlpha" ? "content: counter(ol-counter, upper-alpha);" : "content: '0' counter(ol-counter);";
    const nthChildStyle = appearance === "Number" ? "li:nth-child(n + 10)::before { content: counter(ol-counter); }" : "";
    return (0, $hYbro.css)`
        ol {
            ${(0, $jAJVK.redundantCssFromKebab)("counter-reset", "ol-counter")}
            ${(0, $jAJVK.redundantCssFromKebab)("list-style", "none")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding-inline-start", "0")}
            li {
                ${(0, $jAJVK.redundantCssFromKebab)("counter-increment", "ol-counter")}
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "2rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("padding-inline-start", "5rem")}
                @media (max-width: 576px) {
                    ${(0, $jAJVK.redundantCssFromKebab)("padding-inline-start", "4rem")}
                }
                strong {
                    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
                }
                p {
                    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0")}
                    ${(0, $jAJVK.redundantCssFromKebab)("display", "inline")}
                }
                &::before {
                    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
                    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
                    ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "-5rem")}
                    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("T400")}`)}
                    ${beforeContent}
                    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
                    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "2.5rem")}
                    ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "-0.5rem")}
                    @media (max-width: 576px) {
                        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xl}`)}
                        ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "-4rem")}
                        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "-0.25rem")}
                    }
                }
            }
            ${nthChildStyle}
        }
    `;
}

});

parcelRegister("a7xVp", function(module, exports) {

$parcel$export(module.exports, "shadow", function () { return $ac311f41a89671cc$export$b8972b998723d602; });

var $i2LPb = parcelRequire("i2LPb");
const $ac311f41a89671cc$export$b8972b998723d602 = {
    dark: `0 0.5rem 1rem 0 ${(0, $i2LPb.colorCSS)("N900", 0.25)}`,
    normal: `0 0.5rem 1rem 0 ${(0, $i2LPb.colorCSS)("N900", 0.15)}`,
    normal_inset: `inset 0 1.5rem 1rem -1rem ${(0, $i2LPb.colorCSS)("N900", 0.15)}`,
    small: `1px 1px 5px 0 ${(0, $i2LPb.colorCSS)("N900", 0.15)}`
};

});

parcelRegister("2vQ6x", function(module, exports) {

$parcel$export(module.exports, "spacing", function () { return $4406baf82a5dc88a$export$5458b64234d1333c; });
$parcel$export(module.exports, "scrollMargin", function () { return $4406baf82a5dc88a$export$40bd1ce025856f01; });
const $4406baf82a5dc88a$export$5458b64234d1333c = {
    none: "0",
    tight: ".5rem",
    compact: "1rem",
    cozy: "3rem",
    comfortable: "5rem",
    outerspace: "8rem"
};
const $4406baf82a5dc88a$export$40bd1ce025856f01 = {
    top: 72
};

});

parcelRegister("Zp1a0", function(module, exports) {

var $hYbro = parcelRequire("hYbro");

var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");

var $kL1mL = parcelRequire("kL1mL");
const $321a327e477158a8$export$ce0bf16b48dc1858 = (0, $hYbro.css)`
    table {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "1.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("overflow-x", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        th {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N20")}`)}
        }
        th,
        td {
            ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.33rem 0.5rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "top")}
        }
    }
`;

});

parcelRegister("1D7YE", function(module, exports) {

$parcel$export(module.exports, "zIndex", function () { return $423bbe5bd252a3e6$export$56446adcecbeec34; });
const $423bbe5bd252a3e6$export$56446adcecbeec34 = {
    header: 100,
    headerShroud: 90,
    subNav: 80,
    subNavShroud: 70,
    tooltip: 110
};

});



parcelRegister("jTu6p", function(module, exports) {

$parcel$export(module.exports, "useClickAway", function () { return $0dc8f76536e42a3d$export$682608ebc9a33151; });

var $iSvIT = parcelRequire("iSvIT");
function $0dc8f76536e42a3d$export$682608ebc9a33151(ref, onClick) {
    (0, $iSvIT.useEffect)(()=>{
        const documentClick = (event)=>{
            if (event.target !== ref.current) onClick();
        };
        document.addEventListener("click", documentClick);
        return ()=>{
            document.removeEventListener("click", documentClick);
        };
    }, [
        ref,
        onClick
    ]);
}

});

parcelRegister("dJnrX", function(module, exports) {

$parcel$export(module.exports, "useCoordinates", function () { return $2e44b2b6f3af1e6e$export$bd084be4209354b; });

var $iSvIT = parcelRequire("iSvIT");

var $ctjgr = parcelRequire("ctjgr");
function $2e44b2b6f3af1e6e$export$bd084be4209354b(ref) {
    const rect = (0, $ctjgr.useRect)(ref);
    const [coordinates, setCoordinates] = (0, $iSvIT.useState)([
        0,
        0
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (rect) {
            const { top: top, bottom: bottom, left: left, right: right } = rect;
            const height = bottom - top;
            const width = right - left;
            const center = [
                left + width / 2,
                top + height / 2 + window.pageYOffset
            ];
            setCoordinates(center);
        }
    }, [
        rect,
        setCoordinates
    ]);
    return coordinates;
}

});
parcelRegister("ctjgr", function(module, exports) {

$parcel$export(module.exports, "useRect", function () { return $914722ea7549a2da$export$9823a655542017cd; });

var $iSvIT = parcelRequire("iSvIT");


var $hFdJK = parcelRequire("hFdJK");

var $ekrHv = parcelRequire("ekrHv");

var $bejoI = parcelRequire("bejoI");

/**
 * Welcome to @reach/rect!
 *
 * Measures DOM elements (aka. bounding client rect).
 *
 * @see getBoundingClientRect https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect
 * @see Docs                  https://reach.tech/rect
 * @see Source                https://github.com/reach/reach-ui/tree/main/packages/rect
 */ /**
 * Rect
 *
 * @param props
 */ var $914722ea7549a2da$export$c79fc6492f3af13d = function Rect(_ref) {
    var onChange = _ref.onChange, _ref$observe = _ref.observe, observe = _ref$observe === void 0 ? true : _ref$observe, children = _ref.children;
    var ref = (0, $iSvIT.useRef)(null);
    var rect = $914722ea7549a2da$export$9823a655542017cd(ref, {
        observe: observe,
        onChange: onChange
    });
    return children({
        ref: ref,
        rect: rect
    });
};
/**
 * useRect
 *
 * @param nodeRef
 * @param observe
 * @param onChange
 */ function $914722ea7549a2da$export$9823a655542017cd(nodeRef, observeOrOptions, deprecated_onChange) {
    var observe;
    var onChange;
    if ((0, $bejoI.isBoolean)(observeOrOptions)) observe = observeOrOptions;
    else {
        var _observeOrOptions$obs;
        observe = (_observeOrOptions$obs = observeOrOptions == null ? void 0 : observeOrOptions.observe) != null ? _observeOrOptions$obs : true;
        onChange = observeOrOptions == null ? void 0 : observeOrOptions.onChange;
    }
    if ((0, $bejoI.isFunction)(deprecated_onChange)) onChange = deprecated_onChange;
    var _React$useState = (0, $iSvIT.useState)(nodeRef.current), element = _React$useState[0], setElement = _React$useState[1];
    var initialRectIsSet = (0, $iSvIT.useRef)(false);
    var initialRefIsSet = (0, $iSvIT.useRef)(false);
    var _React$useState2 = (0, $iSvIT.useState)(null), rect = _React$useState2[0], setRect = _React$useState2[1];
    var onChangeRef = (0, $iSvIT.useRef)(onChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $ekrHv.useIsomorphicLayoutEffect)(function() {
        onChangeRef.current = onChange;
        if (nodeRef.current !== element) setElement(nodeRef.current);
    });
    (0, $ekrHv.useIsomorphicLayoutEffect)(function() {
        if (element && !initialRectIsSet.current) {
            initialRectIsSet.current = true;
            setRect(element.getBoundingClientRect());
        }
    }, [
        element
    ]);
    (0, $ekrHv.useIsomorphicLayoutEffect)(function() {
        if (!observe) return;
        var elem = element; // State initializes before refs are placed, meaning the element state will
        // be undefined on the first render. We still want the rect on the first
        // render, so initially we'll use the nodeRef that was passed instead of
        // state for our measurements.
        if (!initialRefIsSet.current) {
            initialRefIsSet.current = true;
            elem = nodeRef.current;
        }
        if (!elem) return;
        var observer = (0, $hFdJK.default)(elem, function(rect) {
            onChangeRef.current == null || onChangeRef.current(rect);
            setRect(rect);
        });
        observer.observe();
        return function() {
            observer.unobserve();
        };
    }, [
        observe,
        element,
        nodeRef
    ]);
    return rect;
}
var $914722ea7549a2da$export$2e2bcd8739ae039 = $914722ea7549a2da$export$c79fc6492f3af13d;

});
parcelRegister("hFdJK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdc0ebd74e373645$export$2e2bcd8739ae039; });
var $cdc0ebd74e373645$var$props = [
    "bottom",
    "height",
    "left",
    "right",
    "top",
    "width"
];
var $cdc0ebd74e373645$var$rectChanged = function rectChanged(a, b) {
    if (a === void 0) a = {};
    if (b === void 0) b = {};
    return $cdc0ebd74e373645$var$props.some(function(prop) {
        return a[prop] !== b[prop];
    });
};
var $cdc0ebd74e373645$var$observedNodes = /*#__PURE__*/ new Map();
var $cdc0ebd74e373645$var$rafId;
var $cdc0ebd74e373645$var$run = function run() {
    var changedStates = [];
    $cdc0ebd74e373645$var$observedNodes.forEach(function(state, node) {
        var newRect = node.getBoundingClientRect();
        if ($cdc0ebd74e373645$var$rectChanged(newRect, state.rect)) {
            state.rect = newRect;
            changedStates.push(state);
        }
    });
    changedStates.forEach(function(state) {
        state.callbacks.forEach(function(cb) {
            return cb(state.rect);
        });
    });
    $cdc0ebd74e373645$var$rafId = window.requestAnimationFrame(run);
};
function $cdc0ebd74e373645$var$observeRect(node, cb) {
    return {
        observe: function observe() {
            var wasEmpty = $cdc0ebd74e373645$var$observedNodes.size === 0;
            if ($cdc0ebd74e373645$var$observedNodes.has(node)) $cdc0ebd74e373645$var$observedNodes.get(node).callbacks.push(cb);
            else $cdc0ebd74e373645$var$observedNodes.set(node, {
                rect: undefined,
                hasRectChanged: false,
                callbacks: [
                    cb
                ]
            });
            if (wasEmpty) $cdc0ebd74e373645$var$run();
        },
        unobserve: function unobserve() {
            var state = $cdc0ebd74e373645$var$observedNodes.get(node);
            if (state) {
                // Remove the callback
                var index = state.callbacks.indexOf(cb);
                if (index >= 0) state.callbacks.splice(index, 1); // Remove the node reference
                if (!state.callbacks.length) $cdc0ebd74e373645$var$observedNodes["delete"](node); // Stop the loop
                if (!$cdc0ebd74e373645$var$observedNodes.size) cancelAnimationFrame($cdc0ebd74e373645$var$rafId);
            }
        }
    };
}
var $cdc0ebd74e373645$export$2e2bcd8739ae039 = $cdc0ebd74e373645$var$observeRect;

});

parcelRegister("ekrHv", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $a6e86bbc42420090$export$700979bc83e7db82; });

var $iSvIT = parcelRequire("iSvIT");

var $738gW = parcelRequire("738gW");
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $a6e86bbc42420090$export$700979bc83e7db82 = /*#__PURE__*/ (0, $738gW.canUseDOM)() ? (0, $iSvIT.useLayoutEffect) : (0, $iSvIT.useEffect);

});
parcelRegister("738gW", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", function () { return $521f3ae432bc8fd0$export$71594e8a50f746f4; });
function $521f3ae432bc8fd0$export$71594e8a50f746f4() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

});


parcelRegister("bejoI", function(module, exports) {

$parcel$export(module.exports, "isBoolean", function () { return $82d00c78d08bc8bf$export$f9ce7b637dfbe238; });
$parcel$export(module.exports, "isFunction", function () { return $82d00c78d08bc8bf$export$f6e2535fb5126e54; });
/**
 * Checks whether or not a value is a boolean.
 *
 * @param value
 */ function $82d00c78d08bc8bf$export$f9ce7b637dfbe238(value) {
    return typeof value === "boolean";
}
/**
 * Checks whether or not a value is a function.
 *
 * @param value
 */ function $82d00c78d08bc8bf$export$f6e2535fb5126e54(value) {
    // eslint-disable-next-line eqeqeq
    return !!(value && ({}).toString.call(value) == "[object Function]");
}
/**
 * Checks whether or not a value is a number.
 *
 * @param value
 */ function $82d00c78d08bc8bf$export$7e4aa119212bc614(value) {
    return typeof value === "number" && !isNaN(value);
}
/**
 * Checks whether or not a value is a string.
 *
 * @param value
 */ function $82d00c78d08bc8bf$export$844ec244b1367d54(value) {
    return typeof value === "string";
}

});



parcelRegister("dS1rq", function(module, exports) {

$parcel$export(module.exports, "useCyclingOrder", function () { return $0cefe882f0c65d82$export$2951b196429bf1b1; });

var $iSvIT = parcelRequire("iSvIT");
function $0cefe882f0c65d82$export$2951b196429bf1b1(items, updatedAt, isReversed = false) {
    const [lastUpdate, setLastUpdate] = (0, $iSvIT.useState)(updatedAt);
    const [orderedItems, setOrderedItems] = (0, $iSvIT.useState)(items);
    (0, $iSvIT.useEffect)(()=>{
        // zero or one items can't be cycled through
        if (orderedItems.length < 2) return;
        else if (updatedAt > lastUpdate) {
            if (isReversed) {
                const lastItem = orderedItems.slice(-1);
                const remainingItems = orderedItems.slice(0, -1);
                setOrderedItems([
                    ...lastItem,
                    ...remainingItems
                ]);
            } else {
                const firstItem = orderedItems.slice(0, 1);
                const remainingItems = orderedItems.slice(1, orderedItems.length);
                setOrderedItems([
                    ...remainingItems,
                    ...firstItem
                ]);
            }
            setLastUpdate(updatedAt);
        }
    }, [
        isReversed,
        lastUpdate,
        orderedItems,
        updatedAt
    ]);
    return orderedItems;
}

});

parcelRegister("KmL3B", function(module, exports) {

$parcel$export(module.exports, "useEnterprisePricingCalculator", function () { return $a12d5599683c666c$export$809706612c823f6c; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $iSvIT = parcelRequire("iSvIT");
parcelRequire("ltPTP");
var $bnR9G = parcelRequire("bnR9G");
var $hIzNO = parcelRequire("hIzNO");
function $a12d5599683c666c$export$809706612c823f6c(potentialTiers, minUsers, maxUsers) {
    const tiers = (0, $bnR9G.isEnterprisePricingTiers)(potentialTiers) ? potentialTiers : [];
    const calculator = (0, $iSvIT.useMemo)(()=>new (0, $hIzNO.EnterprisePricingCalculator)(tiers, minUsers, maxUsers), [
        tiers,
        minUsers,
        maxUsers
    ]);
    return calculator;
}

});
parcelRegister("ltPTP", function(module, exports) {
$parcel$export(module.exports, "EnterprisePriceCalculationsError", function () { return (parcelRequire("hIzNO")).EnterprisePriceCalculationsError; });
$parcel$export(module.exports, "EnterprisePricingCalculator", function () { return (parcelRequire("hIzNO")).EnterprisePricingCalculator; });
$parcel$export(module.exports, "isEnterprisePricingTiers", function () { return (parcelRequire("bnR9G")).isEnterprisePricingTiers; });
$parcel$export(module.exports, "isFlatRatePricing", function () { return (parcelRequire("bnR9G")).isFlatRatePricing; });
parcelRequire("hIzNO");
parcelRequire("bnR9G");
parcelRequire("aR3P8");

});
parcelRegister("hIzNO", function(module, exports) {

$parcel$export(module.exports, "EnterprisePriceCalculationsError", function () { return $08105516ade72d53$export$f8005404720966a4; });
$parcel$export(module.exports, "EnterprisePricingCalculator", function () { return $08105516ade72d53$export$18f3dce6da137ad0; });
var $08105516ade72d53$export$f8005404720966a4;
(function(EnterprisePriceCalculationsError) {
    EnterprisePriceCalculationsError["INVALID_TIER"] = "INVALID_TIER";
    EnterprisePriceCalculationsError["MIN_USERS_ERROR"] = "MIN_USERS_ERROR";
    EnterprisePriceCalculationsError["MAX_USERS_ERROR"] = "MAX_USERS_ERROR";
})($08105516ade72d53$export$f8005404720966a4 || ($08105516ade72d53$export$f8005404720966a4 = {}));
function $08105516ade72d53$export$df8298fa09a34da6(tiers) {
    const sortedTiers = [
        ...tiers
    ].sort((a, b)=>a.above - b.above);
    const accumulatedTiers = sortedTiers.reduce((accumulated, tier, i)=>{
        if (i === 0) accumulated[i] = {
            ...tier,
            prevTierAccumulatedPrice: 0
        };
        else {
            const prev = accumulated[i - 1];
            if (prev) accumulated[i] = {
                ...tier,
                prevTierAccumulatedPrice: (tier.above - prev.above) * prev.at + prev.prevTierAccumulatedPrice
            };
        }
        return accumulated;
    }, []);
    return accumulatedTiers.sort((a, b)=>b.above - a.above);
}
class $08105516ade72d53$export$18f3dce6da137ad0 {
    constructor(tiers, minUsers = 1, maxUsers = 10000000){
        this.defaultCalculations = {
            annualPrice: "0",
            annualPricePerUser: "0.00",
            monthlyPricePerUser: "0.00"
        };
        this.tiers = $08105516ade72d53$export$df8298fa09a34da6(tiers);
        this.minUsers = minUsers;
        this.maxUsers = maxUsers;
    }
    getPricesByUserCount(userCount) {
        const tier = this.tiers.find((tier)=>userCount > tier.above);
        if (userCount < this.minUsers) return [
            "MIN_USERS_ERROR",
            this.defaultCalculations
        ];
        if (userCount > this.maxUsers) return [
            "MAX_USERS_ERROR",
            this.defaultCalculations
        ];
        if (!tier) return [
            "INVALID_TIER",
            this.defaultCalculations
        ];
        const annualPrice = (userCount - tier.above) * tier.at + tier.prevTierAccumulatedPrice;
        const annualPricePerUser = annualPrice / userCount;
        const monthlyPricePerUser = annualPricePerUser / 12;
        return [
            undefined,
            {
                annualPrice: annualPrice.toLocaleString("en", {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }),
                annualPricePerUser: annualPricePerUser.toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }),
                monthlyPricePerUser: monthlyPricePerUser.toLocaleString("en", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
            }
        ];
    }
}

});

parcelRegister("bnR9G", function(module, exports) {

$parcel$export(module.exports, "isEnterprisePricingTiers", function () { return $76fde9d4fe859c8d$export$ebc2e2a6d73275c0; });
$parcel$export(module.exports, "isFlatRatePricing", function () { return $76fde9d4fe859c8d$export$1fd9659895081cd8; });
parcelRequire("adnhq");
var $4Uqkn = parcelRequire("4Uqkn");
function $76fde9d4fe859c8d$export$efb48a3868be6fcd(tier) {
    if (!(0, $4Uqkn.isRecord)(tier)) return false;
    return typeof tier.at === "number" && typeof tier.above === "number";
}
function $76fde9d4fe859c8d$export$ebc2e2a6d73275c0(tiers) {
    if (!Array.isArray(tiers)) return false;
    return tiers.every($76fde9d4fe859c8d$export$efb48a3868be6fcd);
}
function $76fde9d4fe859c8d$export$1fd9659895081cd8(pricing) {
    return !!pricing && !Array.isArray(pricing) && typeof pricing.monthly === "number" && typeof pricing.annually === "number";
}

});

parcelRegister("aR3P8", function(module, exports) {

});



parcelRegister("8L0gU", function(module, exports) {

$parcel$export(module.exports, "useEscapePress", function () { return $104c7c45638fe5bd$export$833d752f309bd5c9; });

var $iSvIT = parcelRequire("iSvIT");
const $104c7c45638fe5bd$export$833d752f309bd5c9 = (onPress)=>{
    (0, $iSvIT.useEffect)(()=>{
        const escPress = (event)=>{
            if (event.key === "Escape") onPress();
        };
        document.addEventListener("keydown", escPress);
        return ()=>{
            document.removeEventListener("keydown", escPress);
        };
    }, [
        onPress
    ]);
};

});

parcelRegister("d9N4n", function(module, exports) {

$parcel$export(module.exports, "useHostname", function () { return $295f72572ecff9d8$export$871151d6a2c8e8f7; });

var $iSvIT = parcelRequire("iSvIT");
const $295f72572ecff9d8$export$871151d6a2c8e8f7 = ()=>{
    const [hostname, setHostname] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        if (!hostname) setHostname(window.location.origin);
    }, [
        hostname
    ]);
    return hostname;
};

});

parcelRegister("eOLtZ", function(module, exports) {

$parcel$export(module.exports, "useIsLoggedIn", function () { return $6a89b12e5aed21fd$export$79c3258edc7d1573; });

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("bNHtH");
var $aYCAT = parcelRequire("aYCAT");
// On SSR, trello-template.tsx injects window.__IS_LOGGED_IN__ from the HTTP
// request's idMember cookie so both SSR and client start with the same state.
// This prevents a header button color flash/switch for logged-in users.
const $6a89b12e5aed21fd$var$getInitialLoggedInState = ()=>{
    if (typeof window === "undefined") return undefined;
    // Use server-injected value if present (set before hydration from SSR HTML)
    if (window.__IS_LOGGED_IN__ !== undefined) return window.__IS_LOGGED_IN__;
    // Fallback: read cookie directly (covers non-SSR static mode)
    return (0, $aYCAT.getCookie)("idMember") ? true : false;
};
const $6a89b12e5aed21fd$export$79c3258edc7d1573 = ()=>{
    const [isLoggedIn] = (0, $iSvIT.useState)($6a89b12e5aed21fd$var$getInitialLoggedInState);
    return isLoggedIn;
};

});

parcelRegister("fuZB8", function(module, exports) {

$parcel$export(module.exports, "useLanguage", function () { return $ba5d87cfb6be5f78$export$c1fd9f444a3dc711; });
$parcel$export(module.exports, "StaticLanguageProvider", function () { return $ba5d87cfb6be5f78$export$1af1520ea7632638; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $3tsVE = parcelRequire("3tsVE");
const $ba5d87cfb6be5f78$export$910b680d1eea6990 = "en";
const $ba5d87cfb6be5f78$export$8d7132fbfb8bc5cb = /*#__PURE__*/ (0, $iSvIT.createContext)($ba5d87cfb6be5f78$export$910b680d1eea6990);
function $ba5d87cfb6be5f78$export$c1fd9f444a3dc711() {
    return (0, $iSvIT.useContext)($ba5d87cfb6be5f78$export$8d7132fbfb8bc5cb);
}
const $ba5d87cfb6be5f78$export$d0f634db572e14fb = ({ children: children })=>{
    const { lang: lang = $ba5d87cfb6be5f78$export$910b680d1eea6990 } = (0, $3tsVE.parse)(document.cookie);
    return /*#__PURE__*/ (0, $loA2J.jsx)($ba5d87cfb6be5f78$export$8d7132fbfb8bc5cb.Provider, {
        value: lang,
        children: children
    });
};
const $ba5d87cfb6be5f78$export$1af1520ea7632638 = ({ language: language, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($ba5d87cfb6be5f78$export$8d7132fbfb8bc5cb.Provider, {
        value: language,
        children: children
    });
};

});
parcelRegister("3tsVE", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $287a8538cb4acff5$export$98e6a39c04603d36; }, function (v) { return $287a8538cb4acff5$export$98e6a39c04603d36 = v; });
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ var $287a8538cb4acff5$export$98e6a39c04603d36;
var $287a8538cb4acff5$export$dfdc1655ccc5b9cb;
"use strict";
$287a8538cb4acff5$export$98e6a39c04603d36 = $287a8538cb4acff5$var$parse;
$287a8538cb4acff5$export$dfdc1655ccc5b9cb = $287a8538cb4acff5$var$serialize;
/**
 * Module variables.
 * @private
 */ var $287a8538cb4acff5$var$decode = decodeURIComponent;
var $287a8538cb4acff5$var$encode = encodeURIComponent;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */ var $287a8538cb4acff5$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */ function $287a8538cb4acff5$var$parse(str, options) {
    if (typeof str !== "string") throw new TypeError("argument str must be a string");
    var obj = {};
    var opt = options || {};
    var pairs = str.split(";");
    var dec = opt.decode || $287a8538cb4acff5$var$decode;
    for(var i = 0; i < pairs.length; i++){
        var pair = pairs[i];
        var index = pair.indexOf("=");
        // skip things that don't look like key=value
        if (index < 0) continue;
        var key = pair.substring(0, index).trim();
        // only assign once
        if (undefined == obj[key]) {
            var val = pair.substring(index + 1, pair.length).trim();
            // quoted values
            if (val[0] === '"') val = val.slice(1, -1);
            obj[key] = $287a8538cb4acff5$var$tryDecode(val, dec);
        }
    }
    return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */ function $287a8538cb4acff5$var$serialize(name, val, options) {
    var opt = options || {};
    var enc = opt.encode || $287a8538cb4acff5$var$encode;
    if (typeof enc !== "function") throw new TypeError("option encode is invalid");
    if (!$287a8538cb4acff5$var$fieldContentRegExp.test(name)) throw new TypeError("argument name is invalid");
    var value = enc(val);
    if (value && !$287a8538cb4acff5$var$fieldContentRegExp.test(value)) throw new TypeError("argument val is invalid");
    var str = name + "=" + value;
    if (null != opt.maxAge) {
        var maxAge = opt.maxAge - 0;
        if (isNaN(maxAge) || !isFinite(maxAge)) throw new TypeError("option maxAge is invalid");
        str += "; Max-Age=" + Math.floor(maxAge);
    }
    if (opt.domain) {
        if (!$287a8538cb4acff5$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=" + opt.domain;
    }
    if (opt.path) {
        if (!$287a8538cb4acff5$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=" + opt.path;
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=" + opt.expires.toUTCString();
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */ function $287a8538cb4acff5$var$tryDecode(str, decode) {
    try {
        return decode(str);
    } catch (e) {
        return str;
    }
}

});


parcelRegister("ajAMQ", function(module, exports) {

$parcel$export(module.exports, "useMarketoForm", function () { return $eaec163bb246f17c$export$44382482aed502ec; });

var $iSvIT = parcelRequire("iSvIT");
function $eaec163bb246f17c$export$44382482aed502ec({ munchkinId: munchkinId, munchkinIdStg: munchkinIdStg, formId: formId, formIdStg: formIdStg, businessEmailValidation: businessEmailValidation }, container) {
    const [marketo, setMarketo] = (0, $iSvIT.useState)();
    const [status, setStatus] = (0, $iSvIT.useState)("LOADING");
    const setFormStatus = ()=>setStatus("FORM");
    const setSuccessStatus = ()=>setStatus("SUCCESS");
    const setErrorStatus = ()=>setStatus("ERROR");
    (0, $iSvIT.useEffect)(()=>{
        // Only run in browser environment
        if (typeof window === "undefined" || typeof document === "undefined") return;
        const mktoConfig = location.hostname === "trello.com" || location.hostname === "www.trello.com" ? {
            url: "https://pages.eml.atlassian.com",
            munchkinId: munchkinId,
            prefsUrl: "https://preferences.atlassian.com/rest/forms/config",
            formId: formId
        } : {
            url: "https://app-ab35.marketo.com",
            munchkinId: munchkinIdStg,
            prefsUrl: "https://preferences.stg.atlassian.com/rest/forms/config",
            formId: formIdStg
        };
        const scriptId = `marketo-${mktoConfig.munchkinId}`;
        const script = document.getElementById(scriptId);
        const waitForMarketo = (scriptElement)=>{
            function stopWaiting() {
                scriptElement.removeEventListener("load", updateMarketo);
                window.clearInterval(pollId);
            }
            function updateMarketo() {
                if (window.MktoForms2) {
                    setMarketo(window.MktoForms2);
                    stopWaiting();
                }
            }
            // Another form can create the shared script before MktoForms2 exists.
            scriptElement.addEventListener("load", updateMarketo);
            const pollId = window.setInterval(updateMarketo, 250);
            updateMarketo();
            return stopWaiting;
        };
        if (!marketo) {
            if (script) return waitForMarketo(script);
            else {
                const script = document.createElement("script");
                script.async = true;
                script.src = `${mktoConfig.url}/js/forms2/js/forms2.min.js`;
                script.id = scriptId;
                document.body.appendChild(script);
                return waitForMarketo(script);
            }
        } else if (status === "LOADING" && container) $eaec163bb246f17c$var$loadMarketoForm(marketo, mktoConfig, container, businessEmailValidation, setFormStatus, setSuccessStatus, setErrorStatus);
    }, [
        marketo,
        status,
        container,
        munchkinId,
        munchkinIdStg,
        formId,
        formIdStg,
        businessEmailValidation
    ]);
    return status;
}
function $eaec163bb246f17c$var$loadMarketoForm(// eslint-disable-next-line @typescript-eslint/no-explicit-any
marketo, mktoConfig, container, businessEmailValidation, // this is an error validation messages
setFormStatus, setSuccessStatus, setErrorStatus) {
    const { $: $, loadForm: loadForm } = marketo;
    loadForm(mktoConfig.url, mktoConfig.munchkinId, mktoConfig.formId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (form)=>{
        if (!form) {
            setErrorStatus();
            return;
        }
        const $container = $(container);
        $container.hide();
        $container.append(form.render());
        const $form = $container.find("form");
        //overwrite form ID based on config
        $form.attr("id", `foo-bar-mktoForm_${mktoConfig.formId}`);
        //remove the elements we don't want
        $("#mktoForms2BaseStyle, #mktoForms2ThemeStyle, .mktoForm style, .mktoGutter, .mktoClear, .mktoOffset").remove();
        //remove style attributes from form and child elements
        $form.removeAttr("style");
        $form.find("*").removeAttr("style");
        //populate hidden date fields
        const optinDate = new Date().toISOString();
        $form.find("input[name=form_anyConsentUpdatedAt]").val(optinDate);
        $form.find("input[name=form_gmoiUpdatedAt]").val(optinDate);
        $form.find("input[name=form_privacyPolicyUpdatedAt]").val(optinDate);
        //new updated at
        const $addSubs = $form.find("input[name=form_additionalSubscriptions]");
        const $addSubsUpdated = $form.find("input[name=form_additionalSubscriptionsUpdatedAt]");
        if ($addSubs.length && $addSubs.first().val().length && $addSubsUpdated.length) $addSubsUpdated.first().val(optinDate);
        //populate hidden url fields
        const pageUrl = window.location.href;
        $form.find("input[name=form_gmoiFormUrl]").val(pageUrl);
        $form.find("input[name=form_privacyPolicyFormUrl]").val(pageUrl);
        //option to set the submit button text from the html
        const submitText = $form.attr("data-submit");
        if (submitText) $form.find("button").text(submitText);
        form.onSubmit(function() {
            // Pull utms from localStorage
            try {
                const marketingContext = localStorage.getItem("marketingContext");
                if (marketingContext) {
                    const parsedMarketingContext = JSON.parse(marketingContext);
                    const utms = parsedMarketingContext.utm;
                    if ($form.find("input[name=UTM_SFDC_Campaign_ID__c]")) $form.find("input[name=UTM_SFDC_Campaign_ID__c]").val(utms.sfdcCampaignId);
                    if ($form.find("input[name=utmSource]")) $form.find("input[name=utmSource]").val(utms.source);
                    if ($form.find("input[name=utmMedium]")) $form.find("input[name=utmMedium]").val(utms.medium);
                    if ($form.find("input[name=utmCampaign]")) $form.find("input[name=utmCampaign]").val(utms.campaign);
                    if ($form.find("input[name=utmContent]")) $form.find("input[name=utmContent]").val(utms.content);
                }
            } catch (error) {
                console.error("Failed to get utms from local marketingContext", error);
            }
        });
        //callback when form is submitted
        form.onSuccess(function() {
            setSuccessStatus();
            return false;
        });
        //add-on validation method for email format
        //this is meant to minic the validation method in the magnolia-resources marketo-form component
        form.onValidate(function() {
            const field = form.getFormElem().find("input[type=email]"), value = field.val(), domain = value.toLowerCase().substring(value.indexOf("@")), parts = domain.split("."), freemail = [
                "@gmail",
                "@yahoo",
                "@aol",
                "@comcast",
                "@hotmail",
                "@ymail",
                "@msn",
                "@mac",
                "@sina",
                "@freemail",
                "@me",
                "@icloud",
                "@live",
                "@gnail",
                "@gmsil",
                "@gmial",
                "@gamil",
                "@gail"
            ];
            // if businessEmailValidation is undefined, we'll assume domain restriction not enforced.
            const freeDomainRestriction = ()=>{
                if (businessEmailValidation) {
                    const restrictedDomain = domain.substring(1);
                    // Assume businessEmailValidation comes with {{domain}} tag.
                    const businessEmailValidationErrorMessage = businessEmailValidation.replace("{{domain}}", restrictedDomain);
                    form.submitable(false);
                    field.focus();
                    form.showErrorMessage(businessEmailValidationErrorMessage, field);
                } else form.submitable(true);
            };
            // Restricted domain validation
            if (freemail.filter((f)=>{
                if (f === "@comcast" && domain === "@comcast.com") return false;
                return parts.indexOf(f) !== -1;
            }).length === 0) form.submitable(true);
            else freeDomainRestriction();
        });
        //get preferences
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $.getJSON(mktoConfig.prefsUrl, function(data) {
            //set and hide country if it's available
            const $country = $("select#Country");
            if ($country.length && data.locale) {
                $country.closest(".mktoFormRow").hide();
                $country.val(data.locale);
            }
            //gdpr checking
            const $gdprInput = $("input[name=form_gmoiGranted]");
            if ($gdprInput.length && !data.localeRequiresMarketingCommunicationOptIn) {
                $gdprInput.closest(".mktoFormRow").hide();
                $gdprInput.prop("checked", true);
            }
            //done checking, show form
            $container.show();
            setFormStatus();
        });
    });
}

});

parcelRegister("ljbip", function(module, exports) {

$parcel$export(module.exports, "useModal", function () { return $d45295e1626e8380$export$33ffd74ebf07f060; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $iSvIT = parcelRequire("iSvIT");
const $d45295e1626e8380$export$33ffd74ebf07f060 = (id, isOpen)=>{
    const [container, setContainer] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (!isOpen) {
            setContainer(null);
            return;
        } else {
            const modelRoot = document.createElement("div");
            modelRoot.setAttribute("id", `modal-${id}`);
            document.body.appendChild(modelRoot);
            setContainer(modelRoot);
            return ()=>{
                document.body.removeChild(modelRoot);
            };
        }
    }, [
        isOpen
    ]);
    return container;
};

});

parcelRegister("5uiii", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $eaff90bdb651ae13$export$dd0a697e1782aedd; });

var $iSvIT = parcelRequire("iSvIT");

var $7YcSr = parcelRequire("7YcSr");
function $eaff90bdb651ae13$export$dd0a697e1782aedd() {
    const { search: search } = (0, $7YcSr.useLocation)();
    return (0, $iSvIT.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
}

});
parcelRegister("7YcSr", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $5cd820244ff825e3$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $5cd820244ff825e3$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $5cd820244ff825e3$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $5cd820244ff825e3$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $5cd820244ff825e3$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $5cd820244ff825e3$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $5cd820244ff825e3$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $5cd820244ff825e3$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $5cd820244ff825e3$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $5cd820244ff825e3$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $5cd820244ff825e3$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $5cd820244ff825e3$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $5cd820244ff825e3$export$b273b3273281a049; });
$parcel$export(module.exports, "UNSAFE_logV6DeprecationWarnings", function () { return $5cd820244ff825e3$export$db5148ec97d6af7a; });
$parcel$export(module.exports, "Router", function () { return $5cd820244ff825e3$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $5cd820244ff825e3$export$52b333d321859367; });
$parcel$export(module.exports, "parsePath", function () { return (parcelRequire("iDzsU")).parsePath; });
/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $iDzsU = parcelRequire("iDzsU");
function $5cd820244ff825e3$var$_extends() {
    $5cd820244ff825e3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5cd820244ff825e3$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $5cd820244ff825e3$export$3add0d5dce533e2e = /*#__PURE__*/ $iSvIT.createContext(null);
const $5cd820244ff825e3$export$145dfa71566a64dc = /*#__PURE__*/ $iSvIT.createContext(null);
const $5cd820244ff825e3$var$AwaitContext = /*#__PURE__*/ $iSvIT.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $5cd820244ff825e3$export$26749e8557646306 = /*#__PURE__*/ $iSvIT.createContext(null);
const $5cd820244ff825e3$export$c7914228fb69b0f5 = /*#__PURE__*/ $iSvIT.createContext(null);
const $5cd820244ff825e3$export$9072aa6dd1f93057 = /*#__PURE__*/ $iSvIT.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $5cd820244ff825e3$var$RouteErrorContext = /*#__PURE__*/ $iSvIT.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $5cd820244ff825e3$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $5cd820244ff825e3$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $iDzsU.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $5cd820244ff825e3$export$9c954a9d03d32f4a() {
    return $iSvIT.useContext($5cd820244ff825e3$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $5cd820244ff825e3$export$45d76561a5302f2b() {
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    return $iSvIT.useContext($5cd820244ff825e3$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $5cd820244ff825e3$export$1b3f31771c5d07c() {
    return $iSvIT.useContext($5cd820244ff825e3$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $5cd820244ff825e3$export$6c330e8992e8a295(pattern) {
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    let { pathname: pathname } = $5cd820244ff825e3$export$45d76561a5302f2b();
    return $iSvIT.useMemo(()=>(0, $iDzsU.matchPath)(pattern, (0, $iDzsU.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $5cd820244ff825e3$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $5cd820244ff825e3$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $iSvIT.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $5cd820244ff825e3$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $5cd820244ff825e3$var$useNavigateStable() : $5cd820244ff825e3$var$useNavigateUnstable();
}
function $5cd820244ff825e3$var$useNavigateUnstable() {
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    let dataRouterContext = $iSvIT.useContext($5cd820244ff825e3$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306);
    let { matches: matches } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5cd820244ff825e3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $iDzsU.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $iSvIT.useRef(false);
    $5cd820244ff825e3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iSvIT.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $iDzsU.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $iDzsU.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $5cd820244ff825e3$var$OutletContext = /*#__PURE__*/ $iSvIT.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $5cd820244ff825e3$export$4138103a3ae699cc() {
    return $iSvIT.useContext($5cd820244ff825e3$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $5cd820244ff825e3$export$a3be3530d8e40d0b(context) {
    let outlet = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $5cd820244ff825e3$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $5cd820244ff825e3$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306);
    let { matches: matches } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5cd820244ff825e3$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $iDzsU.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $iSvIT.useMemo(()=>(0, $iDzsU.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $5cd820244ff825e3$export$5d3fca4a98652595(routes, locationArg) {
    return $5cd820244ff825e3$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $5cd820244ff825e3$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    let { navigator: navigator } = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306);
    let { matches: parentMatches } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $5cd820244ff825e3$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $iDzsU.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $iDzsU.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $iDzsU.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $5cd820244ff825e3$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $iDzsU.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $iDzsU.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $5cd820244ff825e3$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $iDzsU.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5cd820244ff825e3$var$DefaultErrorComponent() {
    let error = $5cd820244ff825e3$export$ed527bf60f6e05f2();
    let message = (0, $iDzsU.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, /*#__PURE__*/ $iSvIT.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $iSvIT.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $iSvIT.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $5cd820244ff825e3$var$defaultErrorElement = /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$DefaultErrorComponent, null);
class $5cd820244ff825e3$var$RenderErrorBoundary extends $iSvIT.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $5cd820244ff825e3$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $iSvIT.useContext($5cd820244ff825e3$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $5cd820244ff825e3$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $iDzsU.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $5cd820244ff825e3$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5cd820244ff825e3$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $iSvIT.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $5cd820244ff825e3$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($5cd820244ff825e3$var$DataRouterHook || {});
var $5cd820244ff825e3$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($5cd820244ff825e3$var$DataRouterStateHook || {});
function $5cd820244ff825e3$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $5cd820244ff825e3$var$useDataRouterContext(hookName) {
    let ctx = $iSvIT.useContext($5cd820244ff825e3$export$3add0d5dce533e2e);
    !ctx && (0, $iDzsU.UNSAFE_invariant)(false);
    return ctx;
}
function $5cd820244ff825e3$var$useDataRouterState(hookName) {
    let state = $iSvIT.useContext($5cd820244ff825e3$export$145dfa71566a64dc);
    !state && (0, $iDzsU.UNSAFE_invariant)(false);
    return state;
}
function $5cd820244ff825e3$var$useRouteContext(hookName) {
    let route = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    !route && (0, $iDzsU.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $5cd820244ff825e3$var$useCurrentRouteId(hookName) {
    let route = $5cd820244ff825e3$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $iDzsU.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $5cd820244ff825e3$export$5fc8298006ad9e58() {
    return $5cd820244ff825e3$var$useCurrentRouteId($5cd820244ff825e3$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $5cd820244ff825e3$export$d0fd4b7106de2769() {
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $5cd820244ff825e3$export$600dc272ed516c15() {
    let dataRouterContext = $5cd820244ff825e3$var$useDataRouterContext($5cd820244ff825e3$var$DataRouterHook.UseRevalidator);
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseRevalidator);
    return $iSvIT.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $5cd820244ff825e3$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseMatches);
    return $iSvIT.useMemo(()=>matches.map((m)=>(0, $iDzsU.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $5cd820244ff825e3$export$1448a5050d252c4d() {
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseLoaderData);
    let routeId = $5cd820244ff825e3$var$useCurrentRouteId($5cd820244ff825e3$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $5cd820244ff825e3$export$fd5d37484eab868d(routeId) {
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $5cd820244ff825e3$export$fdc00f3f26066d5e() {
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseActionData);
    let routeId = $5cd820244ff825e3$var$useCurrentRouteId($5cd820244ff825e3$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $5cd820244ff825e3$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $iSvIT.useContext($5cd820244ff825e3$var$RouteErrorContext);
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseRouteError);
    let routeId = $5cd820244ff825e3$var$useCurrentRouteId($5cd820244ff825e3$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $5cd820244ff825e3$export$78a72ddb39bdd145() {
    let value = $iSvIT.useContext($5cd820244ff825e3$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $5cd820244ff825e3$export$17f53340677d5831() {
    let value = $iSvIT.useContext($5cd820244ff825e3$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $5cd820244ff825e3$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $5cd820244ff825e3$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5cd820244ff825e3$var$useDataRouterContext($5cd820244ff825e3$var$DataRouterHook.UseBlocker);
    let state = $5cd820244ff825e3$var$useDataRouterState($5cd820244ff825e3$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $iSvIT.useState("");
    let blockerFunction = $iSvIT.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $5cd820244ff825e3$var$_extends({}, currentLocation, {
                pathname: (0, $iDzsU.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $5cd820244ff825e3$var$_extends({}, nextLocation, {
                pathname: (0, $iDzsU.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $iSvIT.useEffect(()=>{
        let key = String(++$5cd820244ff825e3$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $iSvIT.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $iDzsU.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $5cd820244ff825e3$var$useNavigateStable() {
    let { router: router } = $5cd820244ff825e3$var$useDataRouterContext($5cd820244ff825e3$var$DataRouterHook.UseNavigateStable);
    let id = $5cd820244ff825e3$var$useCurrentRouteId($5cd820244ff825e3$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $iSvIT.useRef(false);
    $5cd820244ff825e3$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $iSvIT.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $5cd820244ff825e3$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $5cd820244ff825e3$var$alreadyWarned$1 = {};
function $5cd820244ff825e3$var$warningOnce(key, cond, message) {
    if (!cond && !$5cd820244ff825e3$var$alreadyWarned$1[key]) $5cd820244ff825e3$var$alreadyWarned$1[key] = true;
}
const $5cd820244ff825e3$var$alreadyWarned = {};
function $5cd820244ff825e3$var$warnOnce(key, message) {}
const $5cd820244ff825e3$var$logDeprecation = (flag, msg, link)=>$5cd820244ff825e3$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $5cd820244ff825e3$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $5cd820244ff825e3$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $5cd820244ff825e3$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $5cd820244ff825e3$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $5cd820244ff825e3$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $5cd820244ff825e3$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $5cd820244ff825e3$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5cd820244ff825e3$var$START_TRANSITION = "startTransition";
const $5cd820244ff825e3$var$startTransitionImpl = $iSvIT[$5cd820244ff825e3$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5cd820244ff825e3$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iSvIT.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iSvIT.useCallback((newState)=>{
        if (v7_startTransition && $5cd820244ff825e3$var$startTransitionImpl) $5cd820244ff825e3$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iSvIT.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $iSvIT.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $iSvIT.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iSvIT.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $iSvIT.useEffect(()=>$5cd820244ff825e3$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $5cd820244ff825e3$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $5cd820244ff825e3$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $5cd820244ff825e3$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $iSvIT.useRef();
    if (historyRef.current == null) historyRef.current = (0, $iDzsU.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iSvIT.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iSvIT.useCallback((newState)=>{
        v7_startTransition && $5cd820244ff825e3$var$startTransitionImpl ? $5cd820244ff825e3$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iSvIT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iSvIT.useEffect(()=>$5cd820244ff825e3$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $5cd820244ff825e3$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $iSvIT.useContext($5cd820244ff825e3$export$26749e8557646306);
    let { matches: matches } = $iSvIT.useContext($5cd820244ff825e3$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $5cd820244ff825e3$export$45d76561a5302f2b();
    let navigate = $5cd820244ff825e3$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $iDzsU.resolveTo)(to, (0, $iDzsU.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $iSvIT.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $5cd820244ff825e3$export$910ae8079b2c2852(props) {
    return $5cd820244ff825e3$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $5cd820244ff825e3$export$e7b0ac011bb776c6(_props) {
    (0, $iDzsU.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $5cd820244ff825e3$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $iDzsU.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$5cd820244ff825e3$export$9c954a9d03d32f4a() && (0, $iDzsU.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $iSvIT.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $5cd820244ff825e3$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $iDzsU.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $iSvIT.useMemo(()=>{
        let trailingPathname = (0, $iDzsU.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $5cd820244ff825e3$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $5cd820244ff825e3$export$5d3fca4a98652595($5cd820244ff825e3$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $5cd820244ff825e3$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$ResolveAwait, null, children));
}
var $5cd820244ff825e3$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($5cd820244ff825e3$var$AwaitRenderStatus || {});
const $5cd820244ff825e3$var$neverSettledPromise = new Promise(()=>{});
class $5cd820244ff825e3$var$AwaitErrorBoundary extends $iSvIT.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $5cd820244ff825e3$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $5cd820244ff825e3$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $5cd820244ff825e3$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $5cd820244ff825e3$var$AwaitRenderStatus.error : "_data" in promise ? $5cd820244ff825e3$var$AwaitRenderStatus.success : $5cd820244ff825e3$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $5cd820244ff825e3$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $5cd820244ff825e3$var$AwaitRenderStatus.error && promise._error instanceof (0, $iDzsU.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $5cd820244ff825e3$var$neverSettledPromise;
        if (status === $5cd820244ff825e3$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $5cd820244ff825e3$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $5cd820244ff825e3$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $iSvIT.createElement($5cd820244ff825e3$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $5cd820244ff825e3$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $5cd820244ff825e3$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $5cd820244ff825e3$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $iSvIT.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $iSvIT.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $iSvIT.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $5cd820244ff825e3$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $5cd820244ff825e3$export$e7b0ac011bb776c6) && (0, $iDzsU.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $iDzsU.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5cd820244ff825e3$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $5cd820244ff825e3$export$daf73786167a7f72(matches) {
    return $5cd820244ff825e3$var$_renderMatches(matches);
}
function $5cd820244ff825e3$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $iSvIT.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $iSvIT.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $iSvIT.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $5cd820244ff825e3$export$f30f7e456d254e83(routes, opts) {
    return (0, $iDzsU.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5cd820244ff825e3$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $iDzsU.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $5cd820244ff825e3$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

});
parcelRegister("iDzsU", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $d917612a19e73212$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $d917612a19e73212$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $d917612a19e73212$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $d917612a19e73212$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $d917612a19e73212$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $d917612a19e73212$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $d917612a19e73212$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $d917612a19e73212$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $d917612a19e73212$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $d917612a19e73212$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $d917612a19e73212$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $d917612a19e73212$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $d917612a19e73212$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $d917612a19e73212$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $d917612a19e73212$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $d917612a19e73212$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $d917612a19e73212$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d917612a19e73212$var$_extends() {
    $d917612a19e73212$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d917612a19e73212$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d917612a19e73212$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d917612a19e73212$export$e19cd5f9376f8cee || ($d917612a19e73212$export$e19cd5f9376f8cee = {}));
const $d917612a19e73212$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d917612a19e73212$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d917612a19e73212$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d917612a19e73212$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d917612a19e73212$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d917612a19e73212$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d917612a19e73212$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d917612a19e73212$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d917612a19e73212$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d917612a19e73212$export$fe53371bee54353d(to);
    }
    return $d917612a19e73212$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d917612a19e73212$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d917612a19e73212$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d917612a19e73212$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d917612a19e73212$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d917612a19e73212$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d917612a19e73212$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d917612a19e73212$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d917612a19e73212$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d917612a19e73212$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d917612a19e73212$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d917612a19e73212$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d917612a19e73212$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d917612a19e73212$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d917612a19e73212$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d917612a19e73212$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d917612a19e73212$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d917612a19e73212$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d917612a19e73212$export$e19cd5f9376f8cee.Push;
        let location = $d917612a19e73212$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d917612a19e73212$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d917612a19e73212$export$e19cd5f9376f8cee.Replace;
        let location = $d917612a19e73212$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d917612a19e73212$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d917612a19e73212$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $d917612a19e73212$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d917612a19e73212$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d917612a19e73212$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d917612a19e73212$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d917612a19e73212$var$ResultType || ($d917612a19e73212$var$ResultType = {}));
const $d917612a19e73212$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d917612a19e73212$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d917612a19e73212$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d917612a19e73212$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d917612a19e73212$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d917612a19e73212$var$isIndexRoute(route)) {
            let indexRoute = $d917612a19e73212$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d917612a19e73212$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d917612a19e73212$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $d917612a19e73212$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $d917612a19e73212$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $d917612a19e73212$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d917612a19e73212$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d917612a19e73212$var$flattenRoutes(routes);
    $d917612a19e73212$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $d917612a19e73212$export$30d21fd6d7295f52(pathname);
        matches = $d917612a19e73212$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $d917612a19e73212$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d917612a19e73212$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d917612a19e73212$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d917612a19e73212$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d917612a19e73212$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d917612a19e73212$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d917612a19e73212$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d917612a19e73212$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d917612a19e73212$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d917612a19e73212$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d917612a19e73212$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d917612a19e73212$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d917612a19e73212$var$paramRe = /^:[\w-]+$/;
const $d917612a19e73212$var$dynamicSegmentValue = 3;
const $d917612a19e73212$var$indexRouteValue = 2;
const $d917612a19e73212$var$emptySegmentValue = 1;
const $d917612a19e73212$var$staticSegmentValue = 10;
const $d917612a19e73212$var$splatPenalty = -2;
const $d917612a19e73212$var$isSplat = (s)=>s === "*";
function $d917612a19e73212$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d917612a19e73212$var$isSplat)) initialScore += $d917612a19e73212$var$splatPenalty;
    if (index) initialScore += $d917612a19e73212$var$indexRouteValue;
    return segments.filter((s)=>!$d917612a19e73212$var$isSplat(s)).reduce((score, segment)=>score + ($d917612a19e73212$var$paramRe.test(segment) ? $d917612a19e73212$var$dynamicSegmentValue : segment === "" ? $d917612a19e73212$var$emptySegmentValue : $d917612a19e73212$var$staticSegmentValue), initialScore);
}
function $d917612a19e73212$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d917612a19e73212$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d917612a19e73212$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d917612a19e73212$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d917612a19e73212$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d917612a19e73212$export$a5c6d149b50c1d86($d917612a19e73212$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d917612a19e73212$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $d917612a19e73212$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d917612a19e73212$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d917612a19e73212$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $d917612a19e73212$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d917612a19e73212$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d917612a19e73212$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d917612a19e73212$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d917612a19e73212$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d917612a19e73212$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d917612a19e73212$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $d917612a19e73212$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d917612a19e73212$var$isAbsoluteUrl = (url)=>$d917612a19e73212$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $d917612a19e73212$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($d917612a19e73212$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $d917612a19e73212$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $d917612a19e73212$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $d917612a19e73212$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $d917612a19e73212$var$normalizeSearch(search),
        hash: $d917612a19e73212$var$normalizeHash(hash)
    };
}
function $d917612a19e73212$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d917612a19e73212$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d917612a19e73212$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d917612a19e73212$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $d917612a19e73212$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $d917612a19e73212$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d917612a19e73212$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d917612a19e73212$var$_extends({}, toArg);
        $d917612a19e73212$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d917612a19e73212$var$getInvalidPathError("?", "pathname", "search", to));
        $d917612a19e73212$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d917612a19e73212$var$getInvalidPathError("#", "pathname", "hash", to));
        $d917612a19e73212$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d917612a19e73212$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d917612a19e73212$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d917612a19e73212$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d917612a19e73212$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d917612a19e73212$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d917612a19e73212$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d917612a19e73212$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $d917612a19e73212$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d917612a19e73212$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d917612a19e73212$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $d917612a19e73212$export$4051a07651545597(data, init) {
    return new $d917612a19e73212$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $d917612a19e73212$export$42a99a7a4bc0e76a extends Error {
}
class $d917612a19e73212$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d917612a19e73212$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d917612a19e73212$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d917612a19e73212$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d917612a19e73212$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d917612a19e73212$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $d917612a19e73212$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d917612a19e73212$var$unwrapTrackedPromise(value) {
    if (!$d917612a19e73212$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $d917612a19e73212$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d917612a19e73212$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d917612a19e73212$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d917612a19e73212$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d917612a19e73212$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d917612a19e73212$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d917612a19e73212$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $d917612a19e73212$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d917612a19e73212$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d917612a19e73212$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d917612a19e73212$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d917612a19e73212$var$validMutationMethods = new Set($d917612a19e73212$var$validMutationMethodsArr);
const $d917612a19e73212$var$validRequestMethodsArr = [
    "get",
    ...$d917612a19e73212$var$validMutationMethodsArr
];
const $d917612a19e73212$var$validRequestMethods = new Set($d917612a19e73212$var$validRequestMethodsArr);
const $d917612a19e73212$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d917612a19e73212$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d917612a19e73212$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d917612a19e73212$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d917612a19e73212$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d917612a19e73212$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d917612a19e73212$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d917612a19e73212$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d917612a19e73212$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d917612a19e73212$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d917612a19e73212$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d917612a19e73212$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $d917612a19e73212$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $d917612a19e73212$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d917612a19e73212$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d917612a19e73212$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d917612a19e73212$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$d917612a19e73212$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$d917612a19e73212$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d917612a19e73212$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $d917612a19e73212$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d917612a19e73212$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d917612a19e73212$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d917612a19e73212$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d917612a19e73212$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d917612a19e73212$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d917612a19e73212$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d917612a19e73212$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d917612a19e73212$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d917612a19e73212$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d917612a19e73212$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d917612a19e73212$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d917612a19e73212$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d917612a19e73212$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d917612a19e73212$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d917612a19e73212$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d917612a19e73212$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d917612a19e73212$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d917612a19e73212$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d917612a19e73212$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d917612a19e73212$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d917612a19e73212$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d917612a19e73212$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d917612a19e73212$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d917612a19e73212$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d917612a19e73212$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $d917612a19e73212$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $d917612a19e73212$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d917612a19e73212$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d917612a19e73212$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $d917612a19e73212$var$findNearestBoundary(matches).route.id,
            {
                type: $d917612a19e73212$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d917612a19e73212$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d917612a19e73212$var$isErrorResult(result) && $d917612a19e73212$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d917612a19e73212$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $d917612a19e73212$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d917612a19e73212$var$_extends({
            matches: updatedMatches || matches
        }, $d917612a19e73212$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d917612a19e73212$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $d917612a19e73212$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $d917612a19e73212$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $d917612a19e73212$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $d917612a19e73212$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d917612a19e73212$var$ResultType.error,
            error: $d917612a19e73212$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d917612a19e73212$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $d917612a19e73212$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d917612a19e73212$var$isDeferredResult(result)) throw $d917612a19e73212$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($d917612a19e73212$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d917612a19e73212$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $d917612a19e73212$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d917612a19e73212$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d917612a19e73212$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($d917612a19e73212$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $d917612a19e73212$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d917612a19e73212$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d917612a19e73212$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $d917612a19e73212$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d917612a19e73212$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $d917612a19e73212$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d917612a19e73212$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $d917612a19e73212$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d917612a19e73212$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d917612a19e73212$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $d917612a19e73212$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d917612a19e73212$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d917612a19e73212$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d917612a19e73212$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d917612a19e73212$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d917612a19e73212$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d917612a19e73212$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $d917612a19e73212$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d917612a19e73212$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d917612a19e73212$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d917612a19e73212$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $d917612a19e73212$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($d917612a19e73212$var$isRedirectResult(actionResult) || $d917612a19e73212$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d917612a19e73212$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($d917612a19e73212$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $d917612a19e73212$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d917612a19e73212$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($d917612a19e73212$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($d917612a19e73212$var$isDeferredResult(actionResult)) throw $d917612a19e73212$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d917612a19e73212$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d917612a19e73212$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d917612a19e73212$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d917612a19e73212$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d917612a19e73212$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d917612a19e73212$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d917612a19e73212$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $d917612a19e73212$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d917612a19e73212$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d917612a19e73212$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d917612a19e73212$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d917612a19e73212$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d917612a19e73212$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d917612a19e73212$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d917612a19e73212$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $d917612a19e73212$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d917612a19e73212$var$isDeferredResult(result)) result = await $d917612a19e73212$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d917612a19e73212$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d917612a19e73212$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d917612a19e73212$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d917612a19e73212$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d917612a19e73212$export$3e9cee6b33872309(!$d917612a19e73212$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d917612a19e73212$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $d917612a19e73212$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $d917612a19e73212$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $d917612a19e73212$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d917612a19e73212$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d917612a19e73212$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $d917612a19e73212$export$e19cd5f9376f8cee.Replace : $d917612a19e73212$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d917612a19e73212$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d917612a19e73212$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $d917612a19e73212$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d917612a19e73212$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d917612a19e73212$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $d917612a19e73212$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $d917612a19e73212$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($d917612a19e73212$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $d917612a19e73212$var$ResultType.redirect,
                response: $d917612a19e73212$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $d917612a19e73212$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $d917612a19e73212$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $d917612a19e73212$var$ResultType.error,
                    error: $d917612a19e73212$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $d917612a19e73212$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $d917612a19e73212$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d917612a19e73212$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $d917612a19e73212$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d917612a19e73212$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d917612a19e73212$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d917612a19e73212$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d917612a19e73212$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d917612a19e73212$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d917612a19e73212$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d917612a19e73212$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d917612a19e73212$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $d917612a19e73212$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d917612a19e73212$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d917612a19e73212$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $d917612a19e73212$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $d917612a19e73212$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $d917612a19e73212$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $d917612a19e73212$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $d917612a19e73212$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d917612a19e73212$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $d917612a19e73212$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d917612a19e73212$export$4d0306f8f6a4585b = Symbol("deferred");
function $d917612a19e73212$export$3336b097a6fbc59a(routes, opts) {
    $d917612a19e73212$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d917612a19e73212$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $d917612a19e73212$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $d917612a19e73212$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d917612a19e73212$var$createLocation("", $d917612a19e73212$export$fe53371bee54353d(url), null, "default");
        let matches = $d917612a19e73212$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d917612a19e73212$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d917612a19e73212$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d917612a19e73212$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d917612a19e73212$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d917612a19e73212$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($d917612a19e73212$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d917612a19e73212$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d917612a19e73212$var$createLocation("", $d917612a19e73212$export$fe53371bee54353d(url), null, "default");
        let matches = $d917612a19e73212$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d917612a19e73212$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d917612a19e73212$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d917612a19e73212$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d917612a19e73212$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d917612a19e73212$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d917612a19e73212$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($d917612a19e73212$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d917612a19e73212$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $d917612a19e73212$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d917612a19e73212$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d917612a19e73212$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $d917612a19e73212$var$isResponse(result) ? result : $d917612a19e73212$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($d917612a19e73212$var$isDataStrategyResult(e) && $d917612a19e73212$var$isResponse(e.result)) {
                if (e.type === $d917612a19e73212$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d917612a19e73212$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d917612a19e73212$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d917612a19e73212$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $d917612a19e73212$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($d917612a19e73212$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($d917612a19e73212$var$isDeferredResult(result)) {
            let error = $d917612a19e73212$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d917612a19e73212$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d917612a19e73212$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d917612a19e73212$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d917612a19e73212$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $d917612a19e73212$var$_extends({}, context, {
                statusCode: $d917612a19e73212$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $d917612a19e73212$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $d917612a19e73212$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d917612a19e73212$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? $d917612a19e73212$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $d917612a19e73212$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d917612a19e73212$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d917612a19e73212$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $d917612a19e73212$var$callDataStrategyImpl(dataStrategy || $d917612a19e73212$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($d917612a19e73212$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $d917612a19e73212$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($d917612a19e73212$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $d917612a19e73212$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d917612a19e73212$export$fec11da027c70692(routes, context, error) {
    let newContext = $d917612a19e73212$var$_extends({}, context, {
        statusCode: $d917612a19e73212$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d917612a19e73212$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $d917612a19e73212$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d917612a19e73212$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d917612a19e73212$export$cae722b0cc860f13(to ? to : ".", $d917612a19e73212$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $d917612a19e73212$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $d917612a19e73212$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d917612a19e73212$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d917612a19e73212$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d917612a19e73212$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d917612a19e73212$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d917612a19e73212$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d917612a19e73212$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d917612a19e73212$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d917612a19e73212$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d917612a19e73212$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d917612a19e73212$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d917612a19e73212$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d917612a19e73212$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d917612a19e73212$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d917612a19e73212$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d917612a19e73212$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d917612a19e73212$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d917612a19e73212$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d917612a19e73212$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d917612a19e73212$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $d917612a19e73212$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $d917612a19e73212$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $d917612a19e73212$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $d917612a19e73212$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $d917612a19e73212$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $d917612a19e73212$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($d917612a19e73212$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d917612a19e73212$var$shouldRevalidateLoader(match, $d917612a19e73212$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d917612a19e73212$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d917612a19e73212$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d917612a19e73212$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d917612a19e73212$var$shouldRevalidateLoader(fetcherMatch, $d917612a19e73212$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d917612a19e73212$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $d917612a19e73212$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d917612a19e73212$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d917612a19e73212$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $d917612a19e73212$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $d917612a19e73212$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$d917612a19e73212$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $d917612a19e73212$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $d917612a19e73212$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$d917612a19e73212$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d917612a19e73212$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d917612a19e73212$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d917612a19e73212$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d917612a19e73212$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d917612a19e73212$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $d917612a19e73212$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $d917612a19e73212$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $d917612a19e73212$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $d917612a19e73212$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $d917612a19e73212$var$ResultType.data,
                result: undefined
            });
        };
        return $d917612a19e73212$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $d917612a19e73212$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d917612a19e73212$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d917612a19e73212$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d917612a19e73212$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d917612a19e73212$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $d917612a19e73212$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d917612a19e73212$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($d917612a19e73212$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $d917612a19e73212$var$ResultType.error,
                error: e
            };
        }
        if (type === $d917612a19e73212$var$ResultType.error) return {
            type: $d917612a19e73212$var$ResultType.error,
            error: new $d917612a19e73212$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $d917612a19e73212$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $d917612a19e73212$var$ResultType.error) {
        if ($d917612a19e73212$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $d917612a19e73212$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $d917612a19e73212$var$ResultType.error,
                error: new $d917612a19e73212$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $d917612a19e73212$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $d917612a19e73212$var$ResultType.error,
            error: result,
            statusCode: $d917612a19e73212$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($d917612a19e73212$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $d917612a19e73212$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($d917612a19e73212$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $d917612a19e73212$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $d917612a19e73212$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $d917612a19e73212$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $d917612a19e73212$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d917612a19e73212$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d917612a19e73212$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $d917612a19e73212$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($d917612a19e73212$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $d917612a19e73212$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d917612a19e73212$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d917612a19e73212$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d917612a19e73212$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d917612a19e73212$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d917612a19e73212$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d917612a19e73212$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d917612a19e73212$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $d917612a19e73212$export$3e9cee6b33872309(!$d917612a19e73212$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d917612a19e73212$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $d917612a19e73212$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d917612a19e73212$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($d917612a19e73212$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d917612a19e73212$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d917612a19e73212$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $d917612a19e73212$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($d917612a19e73212$var$isErrorResult(result)) {
            let boundaryMatch = $d917612a19e73212$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d917612a19e73212$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d917612a19e73212$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d917612a19e73212$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d917612a19e73212$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d917612a19e73212$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d917612a19e73212$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d917612a19e73212$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d917612a19e73212$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d917612a19e73212$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d917612a19e73212$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d917612a19e73212$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d917612a19e73212$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d917612a19e73212$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d917612a19e73212$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d917612a19e73212$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($d917612a19e73212$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $d917612a19e73212$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(path) : path;
    return $d917612a19e73212$export$fe53371bee54353d($d917612a19e73212$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d917612a19e73212$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d917612a19e73212$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $d917612a19e73212$var$ResultType.data || result.type === $d917612a19e73212$var$ResultType.error);
}
function $d917612a19e73212$var$isRedirectDataStrategyResultResult(result) {
    return $d917612a19e73212$var$isResponse(result.result) && $d917612a19e73212$var$redirectStatusCodes.has(result.result.status);
}
function $d917612a19e73212$var$isDeferredResult(result) {
    return result.type === $d917612a19e73212$var$ResultType.deferred;
}
function $d917612a19e73212$var$isErrorResult(result) {
    return result.type === $d917612a19e73212$var$ResultType.error;
}
function $d917612a19e73212$var$isRedirectResult(result) {
    return (result && result.type) === $d917612a19e73212$var$ResultType.redirect;
}
function $d917612a19e73212$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d917612a19e73212$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d917612a19e73212$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d917612a19e73212$var$isRedirectResponse(result) {
    if (!$d917612a19e73212$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d917612a19e73212$var$isValidMethod(method) {
    return $d917612a19e73212$var$validRequestMethods.has(method.toLowerCase());
}
function $d917612a19e73212$var$isMutationMethod(method) {
    return $d917612a19e73212$var$validMutationMethods.has(method.toLowerCase());
}
async function $d917612a19e73212$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d917612a19e73212$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d917612a19e73212$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $d917612a19e73212$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $d917612a19e73212$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($d917612a19e73212$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $d917612a19e73212$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $d917612a19e73212$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $d917612a19e73212$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d917612a19e73212$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d917612a19e73212$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d917612a19e73212$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d917612a19e73212$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d917612a19e73212$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d917612a19e73212$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d917612a19e73212$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d917612a19e73212$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d917612a19e73212$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d917612a19e73212$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d917612a19e73212$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d917612a19e73212$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d917612a19e73212$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d917612a19e73212$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d917612a19e73212$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d917612a19e73212$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d917612a19e73212$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d917612a19e73212$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d917612a19e73212$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});



parcelRegister("9Ck2b", function(module, exports) {

$parcel$export(module.exports, "useRequestUrl", function () { return $5aef26f9cbfaa01a$export$f66b18f7c926e973; });

var $iSvIT = parcelRequire("iSvIT");
const $5aef26f9cbfaa01a$export$f66b18f7c926e973 = ()=>{
    const [requestUrl, setRequestUrl] = (0, $iSvIT.useState)("");
    (0, $iSvIT.useEffect)(()=>{
        if (!requestUrl) setRequestUrl(window.location.href);
    }, [
        requestUrl
    ]);
    return requestUrl;
};

});

parcelRegister("5atKW", function(module, exports) {

$parcel$export(module.exports, "useRoute", function () { return $1e8fb6ac244a2392$export$3f79f0b98112cf57; });
$parcel$export(module.exports, "RouteProvider", function () { return $1e8fb6ac244a2392$export$56484b1710c65ae5; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $1e8fb6ac244a2392$export$aac280ed165a4397 = /*#__PURE__*/ (0, $iSvIT.createContext)("");
function $1e8fb6ac244a2392$export$3f79f0b98112cf57() {
    return (0, $iSvIT.useContext)($1e8fb6ac244a2392$export$aac280ed165a4397);
}
const $1e8fb6ac244a2392$export$56484b1710c65ae5 = ({ value: value, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($1e8fb6ac244a2392$export$aac280ed165a4397.Provider, {
        value: value,
        children: children
    });
};

});

parcelRegister("8l4ko", function(module, exports) {

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("fisC4");
var $7YcSr = parcelRequire("7YcSr");
parcelRequire("h6yBX");
var $2vQ6x = parcelRequire("2vQ6x");
const $1a359ee13ebeb6d4$export$575807fd64485974 = (path)=>{
    const location = (0, $7YcSr.useLocation)();
    (0, $iSvIT.useEffect)(()=>{
        if (!location.hash) window.scrollTo(0, 0);
        else if (location.hash.startsWith("#")) {
            const fragment = document.querySelector(location.hash);
            if (fragment) {
                const { top: top } = fragment.getBoundingClientRect();
                window.scroll({
                    top: top + window.scrollY - (0, $2vQ6x.scrollMargin).top,
                    behavior: "smooth"
                });
            }
        }
    }, [
        path,
        location
    ]);
};

});
parcelRegister("fisC4", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_ViewTransitionContext", function () { return $b22ebb65d5418d26$export$7ad602f0e94e62d1; });
$parcel$export(module.exports, "UNSAFE_FetchersContext", function () { return $b22ebb65d5418d26$export$148fd98d095596d4; });
$parcel$export(module.exports, "Router", function () { return (parcelRequire("7YcSr")).Router; });
$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return (parcelRequire("7YcSr")).UNSAFE_DataRouterContext; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return (parcelRequire("7YcSr")).UNSAFE_DataRouterStateContext; });
$parcel$export(module.exports, "createPath", function () { return (parcelRequire("iDzsU")).createPath; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("7YcSr")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("7YcSr")).useNavigate; });
/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $iDzsU = parcelRequire("iDzsU");
var $7YcSr = parcelRequire("7YcSr");
var $iDzsU = parcelRequire("iDzsU");

var $9np2o = parcelRequire("9np2o");
function $b22ebb65d5418d26$var$_extends() {
    $b22ebb65d5418d26$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b22ebb65d5418d26$var$_extends.apply(this, arguments);
}
function $b22ebb65d5418d26$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $b22ebb65d5418d26$var$defaultMethod = "get";
const $b22ebb65d5418d26$var$defaultEncType = "application/x-www-form-urlencoded";
function $b22ebb65d5418d26$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $b22ebb65d5418d26$var$isButtonElement(object) {
    return $b22ebb65d5418d26$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $b22ebb65d5418d26$var$isFormElement(object) {
    return $b22ebb65d5418d26$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $b22ebb65d5418d26$var$isInputElement(object) {
    return $b22ebb65d5418d26$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $b22ebb65d5418d26$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $b22ebb65d5418d26$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$b22ebb65d5418d26$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $b22ebb65d5418d26$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $b22ebb65d5418d26$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $b22ebb65d5418d26$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $b22ebb65d5418d26$var$_formDataSupportsSubmitter = null;
function $b22ebb65d5418d26$var$isFormDataSubmitterSupported() {
    if ($b22ebb65d5418d26$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $b22ebb65d5418d26$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $b22ebb65d5418d26$var$_formDataSupportsSubmitter = true;
    }
    return $b22ebb65d5418d26$var$_formDataSupportsSubmitter;
}
const $b22ebb65d5418d26$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $b22ebb65d5418d26$var$getFormEncType(encType) {
    if (encType != null && !$b22ebb65d5418d26$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $b22ebb65d5418d26$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($b22ebb65d5418d26$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $9np2o.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $b22ebb65d5418d26$var$defaultMethod;
        encType = $b22ebb65d5418d26$var$getFormEncType(target.getAttribute("enctype")) || $b22ebb65d5418d26$var$defaultEncType;
        formData = new FormData(target);
    } else if ($b22ebb65d5418d26$var$isButtonElement(target) || $b22ebb65d5418d26$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $9np2o.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $b22ebb65d5418d26$var$defaultMethod;
        encType = $b22ebb65d5418d26$var$getFormEncType(target.getAttribute("formenctype")) || $b22ebb65d5418d26$var$getFormEncType(form.getAttribute("enctype")) || $b22ebb65d5418d26$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$b22ebb65d5418d26$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($b22ebb65d5418d26$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $b22ebb65d5418d26$var$defaultMethod;
        action = null;
        encType = $b22ebb65d5418d26$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $b22ebb65d5418d26$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $b22ebb65d5418d26$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $b22ebb65d5418d26$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $b22ebb65d5418d26$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $b22ebb65d5418d26$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $b22ebb65d5418d26$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9np2o.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b22ebb65d5418d26$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9np2o.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b22ebb65d5418d26$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7YcSr.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b22ebb65d5418d26$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9np2o.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $b22ebb65d5418d26$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $9np2o.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $b22ebb65d5418d26$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7YcSr.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $b22ebb65d5418d26$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $b22ebb65d5418d26$var$_extends({}, state, {
        errors: $b22ebb65d5418d26$var$deserializeErrors(state.errors)
    });
    return state;
}
function $b22ebb65d5418d26$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $9np2o.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $b22ebb65d5418d26$export$7ad602f0e94e62d1 = /*#__PURE__*/ $iSvIT.createContext({
    isTransitioning: false
});
const $b22ebb65d5418d26$export$148fd98d095596d4 = /*#__PURE__*/ $iSvIT.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $b22ebb65d5418d26$var$START_TRANSITION = "startTransition";
const $b22ebb65d5418d26$var$startTransitionImpl = $iSvIT[$b22ebb65d5418d26$var$START_TRANSITION];
const $b22ebb65d5418d26$var$FLUSH_SYNC = "flushSync";
const $b22ebb65d5418d26$var$flushSyncImpl = $i5UxU[$b22ebb65d5418d26$var$FLUSH_SYNC];
const $b22ebb65d5418d26$var$USE_ID = "useId";
const $b22ebb65d5418d26$var$useIdImpl = $iSvIT[$b22ebb65d5418d26$var$USE_ID];
function $b22ebb65d5418d26$var$startTransitionSafe(cb) {
    if ($b22ebb65d5418d26$var$startTransitionImpl) $b22ebb65d5418d26$var$startTransitionImpl(cb);
    else cb();
}
function $b22ebb65d5418d26$var$flushSyncSafe(cb) {
    if ($b22ebb65d5418d26$var$flushSyncImpl) $b22ebb65d5418d26$var$flushSyncImpl(cb);
    else cb();
}
class $b22ebb65d5418d26$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $b22ebb65d5418d26$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $iSvIT.useState(router.state);
    let [pendingState, setPendingState] = $iSvIT.useState();
    let [vtContext, setVtContext] = $iSvIT.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $iSvIT.useState();
    let [transition, setTransition] = $iSvIT.useState();
    let [interruption, setInterruption] = $iSvIT.useState();
    let fetcherData = $iSvIT.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $iSvIT.useCallback((cb)=>{
        if (v7_startTransition) $b22ebb65d5418d26$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $iSvIT.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $b22ebb65d5418d26$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $b22ebb65d5418d26$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $b22ebb65d5418d26$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $b22ebb65d5418d26$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $b22ebb65d5418d26$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $iSvIT.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $iSvIT.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $b22ebb65d5418d26$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $iSvIT.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $iSvIT.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $iSvIT.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $iSvIT.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $iSvIT.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $iSvIT.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $iSvIT.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $iSvIT.useEffect(()=>(0, $7YcSr.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $iSvIT.createElement($b22ebb65d5418d26$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $iSvIT.createElement($b22ebb65d5418d26$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $iSvIT.createElement($b22ebb65d5418d26$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $b22ebb65d5418d26$var$MemoizedDataRoutes = /*#__PURE__*/ $iSvIT.memo($b22ebb65d5418d26$var$DataRoutes);
function $b22ebb65d5418d26$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7YcSr.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $b22ebb65d5418d26$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $iSvIT.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9np2o.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iSvIT.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iSvIT.useCallback((newState)=>{
        v7_startTransition && $b22ebb65d5418d26$var$startTransitionImpl ? $b22ebb65d5418d26$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iSvIT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iSvIT.useEffect(()=>(0, $7YcSr.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $b22ebb65d5418d26$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $iSvIT.useRef();
    if (historyRef.current == null) historyRef.current = (0, $9np2o.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $iSvIT.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iSvIT.useCallback((newState)=>{
        v7_startTransition && $b22ebb65d5418d26$var$startTransitionImpl ? $b22ebb65d5418d26$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iSvIT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iSvIT.useEffect(()=>(0, $7YcSr.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $b22ebb65d5418d26$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $iSvIT.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $iSvIT.useCallback((newState)=>{
        v7_startTransition && $b22ebb65d5418d26$var$startTransitionImpl ? $b22ebb65d5418d26$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $iSvIT.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $iSvIT.useEffect(()=>(0, $7YcSr.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $b22ebb65d5418d26$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $b22ebb65d5418d26$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $b22ebb65d5418d26$export$a6c7ac8248d6e38a = /*#__PURE__*/ $iSvIT.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $b22ebb65d5418d26$var$_objectWithoutPropertiesLoose(_ref7, $b22ebb65d5418d26$var$_excluded);
    let { basename: basename } = $iSvIT.useContext((0, $7YcSr.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $b22ebb65d5418d26$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($b22ebb65d5418d26$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $9np2o.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7YcSr.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $b22ebb65d5418d26$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $iSvIT.createElement("a", $b22ebb65d5418d26$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $b22ebb65d5418d26$export$b0d92dbee9b5b60d = /*#__PURE__*/ $iSvIT.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $b22ebb65d5418d26$var$_objectWithoutPropertiesLoose(_ref8, $b22ebb65d5418d26$var$_excluded2);
    let path = (0, $7YcSr.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $7YcSr.useLocation)();
    let routerState = $iSvIT.useContext((0, $7YcSr.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $iSvIT.useContext((0, $7YcSr.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $b22ebb65d5418d26$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $9np2o.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $iSvIT.createElement($b22ebb65d5418d26$export$a6c7ac8248d6e38a, $b22ebb65d5418d26$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $b22ebb65d5418d26$export$a7fed597f4b8afd8 = /*#__PURE__*/ $iSvIT.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $b22ebb65d5418d26$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $b22ebb65d5418d26$var$_objectWithoutPropertiesLoose(_ref9, $b22ebb65d5418d26$var$_excluded3);
    let submit = $b22ebb65d5418d26$export$47c85c6e3a081d3();
    let formAction = $b22ebb65d5418d26$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $iSvIT.createElement("form", $b22ebb65d5418d26$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $b22ebb65d5418d26$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $b22ebb65d5418d26$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $b22ebb65d5418d26$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($b22ebb65d5418d26$var$DataRouterHook || ($b22ebb65d5418d26$var$DataRouterHook = {}));
var $b22ebb65d5418d26$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($b22ebb65d5418d26$var$DataRouterStateHook || ($b22ebb65d5418d26$var$DataRouterStateHook = {}));
// Internal hooks
function $b22ebb65d5418d26$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $b22ebb65d5418d26$var$useDataRouterContext(hookName) {
    let ctx = $iSvIT.useContext((0, $7YcSr.UNSAFE_DataRouterContext));
    !ctx && (0, $9np2o.UNSAFE_invariant)(false);
    return ctx;
}
function $b22ebb65d5418d26$var$useDataRouterState(hookName) {
    let state = $iSvIT.useContext((0, $7YcSr.UNSAFE_DataRouterStateContext));
    !state && (0, $9np2o.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $b22ebb65d5418d26$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7YcSr.useNavigate)();
    let location = (0, $7YcSr.useLocation)();
    let path = (0, $7YcSr.useResolvedPath)(to, {
        relative: relative
    });
    return $iSvIT.useCallback((event)=>{
        if ($b22ebb65d5418d26$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $iDzsU.createPath)(location) === (0, $iDzsU.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $b22ebb65d5418d26$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $iSvIT.useRef($b22ebb65d5418d26$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $iSvIT.useRef(false);
    let location = (0, $7YcSr.useLocation)();
    let searchParams = $iSvIT.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $b22ebb65d5418d26$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7YcSr.useNavigate)();
    let setSearchParams = $iSvIT.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $b22ebb65d5418d26$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $b22ebb65d5418d26$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $b22ebb65d5418d26$var$fetcherId = 0;
let $b22ebb65d5418d26$var$getUniqueFetcherId = ()=>"__" + String(++$b22ebb65d5418d26$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $b22ebb65d5418d26$export$47c85c6e3a081d3() {
    let { router: router } = $b22ebb65d5418d26$var$useDataRouterContext($b22ebb65d5418d26$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $iSvIT.useContext((0, $7YcSr.UNSAFE_NavigationContext));
    let currentRouteId = (0, $7YcSr.UNSAFE_useRouteId)();
    return $iSvIT.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $b22ebb65d5418d26$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $b22ebb65d5418d26$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $b22ebb65d5418d26$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $b22ebb65d5418d26$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $iSvIT.useContext((0, $7YcSr.UNSAFE_NavigationContext));
    let routeContext = $iSvIT.useContext((0, $7YcSr.UNSAFE_RouteContext));
    !routeContext && (0, $9np2o.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $b22ebb65d5418d26$var$_extends({}, (0, $7YcSr.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7YcSr.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $9np2o.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $iDzsU.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $b22ebb65d5418d26$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $b22ebb65d5418d26$var$useDataRouterContext($b22ebb65d5418d26$var$DataRouterHook.UseFetcher);
    let state = $b22ebb65d5418d26$var$useDataRouterState($b22ebb65d5418d26$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $iSvIT.useContext($b22ebb65d5418d26$export$148fd98d095596d4);
    let route = $iSvIT.useContext((0, $7YcSr.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $9np2o.UNSAFE_invariant)(false);
    !route && (0, $9np2o.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $9np2o.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $b22ebb65d5418d26$var$useIdImpl ? $b22ebb65d5418d26$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $iSvIT.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($b22ebb65d5418d26$var$getUniqueFetcherId());
    // Registration/cleanup
    $iSvIT.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $iSvIT.useCallback((href, opts)=>{
        !routeId && (0, $9np2o.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $b22ebb65d5418d26$export$47c85c6e3a081d3();
    let submit = $iSvIT.useCallback((target, opts)=>{
        submitImpl(target, $b22ebb65d5418d26$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $iSvIT.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $iSvIT.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $iSvIT.createElement($b22ebb65d5418d26$export$a7fed597f4b8afd8, $b22ebb65d5418d26$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $9np2o.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $iSvIT.useMemo(()=>$b22ebb65d5418d26$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $b22ebb65d5418d26$export$fa996778a3a31087() {
    let state = $b22ebb65d5418d26$var$useDataRouterState($b22ebb65d5418d26$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $b22ebb65d5418d26$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $b22ebb65d5418d26$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $b22ebb65d5418d26$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $b22ebb65d5418d26$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $b22ebb65d5418d26$var$useDataRouterContext($b22ebb65d5418d26$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $b22ebb65d5418d26$var$useDataRouterState($b22ebb65d5418d26$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $iSvIT.useContext((0, $7YcSr.UNSAFE_NavigationContext));
    let location = (0, $7YcSr.useLocation)();
    let matches = (0, $7YcSr.useMatches)();
    let navigation = (0, $7YcSr.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $iSvIT.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $b22ebb65d5418d26$var$usePageHide($iSvIT.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $b22ebb65d5418d26$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $b22ebb65d5418d26$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($b22ebb65d5418d26$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iSvIT.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $b22ebb65d5418d26$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $b22ebb65d5418d26$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iSvIT.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($b22ebb65d5418d26$var$_extends({}, location, {
                    pathname: (0, $9np2o.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($b22ebb65d5418d26$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $iSvIT.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b22ebb65d5418d26$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $iSvIT.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $b22ebb65d5418d26$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $iSvIT.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $b22ebb65d5418d26$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7YcSr.useBlocker)(when);
    $iSvIT.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $iSvIT.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $b22ebb65d5418d26$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $iSvIT.useContext($b22ebb65d5418d26$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $9np2o.UNSAFE_invariant)(false);
    let { basename: basename } = $b22ebb65d5418d26$var$useDataRouterContext($b22ebb65d5418d26$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7YcSr.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $9np2o.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $9np2o.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $9np2o.matchPath)(path.pathname, nextPath) != null || (0, $9np2o.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("9np2o", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $6d39aefd4d32c9ac$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $6d39aefd4d32c9ac$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $6d39aefd4d32c9ac$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $6d39aefd4d32c9ac$export$3e9cee6b33872309; });
$parcel$export(module.exports, "UNSAFE_convertRoutesToDataRoutes", function () { return $6d39aefd4d32c9ac$export$4a6d22b32134ea5d; });
$parcel$export(module.exports, "stripBasename", function () { return $6d39aefd4d32c9ac$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $6d39aefd4d32c9ac$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $6d39aefd4d32c9ac$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $6d39aefd4d32c9ac$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $6d39aefd4d32c9ac$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_NAVIGATION", function () { return $6d39aefd4d32c9ac$export$ed3e14b2f9e105d0; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $6d39aefd4d32c9ac$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $6d39aefd4d32c9ac$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $6d39aefd4d32c9ac$export$baddd0131ee8c05b; });
$parcel$export(module.exports, "createStaticHandler", function () { return $6d39aefd4d32c9ac$export$3336b097a6fbc59a; });
/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $6d39aefd4d32c9ac$var$_extends() {
    $6d39aefd4d32c9ac$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6d39aefd4d32c9ac$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $6d39aefd4d32c9ac$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($6d39aefd4d32c9ac$export$e19cd5f9376f8cee || ($6d39aefd4d32c9ac$export$e19cd5f9376f8cee = {}));
const $6d39aefd4d32c9ac$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $6d39aefd4d32c9ac$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $6d39aefd4d32c9ac$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $6d39aefd4d32c9ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $6d39aefd4d32c9ac$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $6d39aefd4d32c9ac$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $6d39aefd4d32c9ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $6d39aefd4d32c9ac$export$fe53371bee54353d(to);
    }
    return $6d39aefd4d32c9ac$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $6d39aefd4d32c9ac$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $6d39aefd4d32c9ac$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $6d39aefd4d32c9ac$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $6d39aefd4d32c9ac$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $6d39aefd4d32c9ac$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $6d39aefd4d32c9ac$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $6d39aefd4d32c9ac$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $6d39aefd4d32c9ac$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $6d39aefd4d32c9ac$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $6d39aefd4d32c9ac$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $6d39aefd4d32c9ac$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $6d39aefd4d32c9ac$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $6d39aefd4d32c9ac$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $6d39aefd4d32c9ac$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($6d39aefd4d32c9ac$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push;
        let location = $6d39aefd4d32c9ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $6d39aefd4d32c9ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace;
        let location = $6d39aefd4d32c9ac$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $6d39aefd4d32c9ac$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $6d39aefd4d32c9ac$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($6d39aefd4d32c9ac$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($6d39aefd4d32c9ac$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $6d39aefd4d32c9ac$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($6d39aefd4d32c9ac$var$ResultType || ($6d39aefd4d32c9ac$var$ResultType = {}));
const $6d39aefd4d32c9ac$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $6d39aefd4d32c9ac$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($6d39aefd4d32c9ac$var$isIndexRoute(route)) {
            let indexRoute = $6d39aefd4d32c9ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $6d39aefd4d32c9ac$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $6d39aefd4d32c9ac$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $6d39aefd4d32c9ac$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $6d39aefd4d32c9ac$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $6d39aefd4d32c9ac$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6d39aefd4d32c9ac$var$flattenRoutes(routes);
    $6d39aefd4d32c9ac$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $6d39aefd4d32c9ac$export$30d21fd6d7295f52(pathname);
        matches = $6d39aefd4d32c9ac$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $6d39aefd4d32c9ac$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $6d39aefd4d32c9ac$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6d39aefd4d32c9ac$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $6d39aefd4d32c9ac$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6d39aefd4d32c9ac$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $6d39aefd4d32c9ac$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $6d39aefd4d32c9ac$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $6d39aefd4d32c9ac$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $6d39aefd4d32c9ac$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6d39aefd4d32c9ac$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6d39aefd4d32c9ac$var$paramRe = /^:[\w-]+$/;
const $6d39aefd4d32c9ac$var$dynamicSegmentValue = 3;
const $6d39aefd4d32c9ac$var$indexRouteValue = 2;
const $6d39aefd4d32c9ac$var$emptySegmentValue = 1;
const $6d39aefd4d32c9ac$var$staticSegmentValue = 10;
const $6d39aefd4d32c9ac$var$splatPenalty = -2;
const $6d39aefd4d32c9ac$var$isSplat = (s)=>s === "*";
function $6d39aefd4d32c9ac$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6d39aefd4d32c9ac$var$isSplat)) initialScore += $6d39aefd4d32c9ac$var$splatPenalty;
    if (index) initialScore += $6d39aefd4d32c9ac$var$indexRouteValue;
    return segments.filter((s)=>!$6d39aefd4d32c9ac$var$isSplat(s)).reduce((score, segment)=>score + ($6d39aefd4d32c9ac$var$paramRe.test(segment) ? $6d39aefd4d32c9ac$var$dynamicSegmentValue : segment === "" ? $6d39aefd4d32c9ac$var$emptySegmentValue : $6d39aefd4d32c9ac$var$staticSegmentValue), initialScore);
}
function $6d39aefd4d32c9ac$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $6d39aefd4d32c9ac$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6d39aefd4d32c9ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $6d39aefd4d32c9ac$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $6d39aefd4d32c9ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6d39aefd4d32c9ac$export$a5c6d149b50c1d86($6d39aefd4d32c9ac$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6d39aefd4d32c9ac$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $6d39aefd4d32c9ac$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $6d39aefd4d32c9ac$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $6d39aefd4d32c9ac$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $6d39aefd4d32c9ac$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6d39aefd4d32c9ac$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $6d39aefd4d32c9ac$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $6d39aefd4d32c9ac$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $6d39aefd4d32c9ac$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $6d39aefd4d32c9ac$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6d39aefd4d32c9ac$var$isAbsoluteUrl = (url)=>$6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $6d39aefd4d32c9ac$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($6d39aefd4d32c9ac$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $6d39aefd4d32c9ac$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $6d39aefd4d32c9ac$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $6d39aefd4d32c9ac$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $6d39aefd4d32c9ac$var$normalizeSearch(search),
        hash: $6d39aefd4d32c9ac$var$normalizeHash(hash)
    };
}
function $6d39aefd4d32c9ac$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6d39aefd4d32c9ac$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $6d39aefd4d32c9ac$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $6d39aefd4d32c9ac$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $6d39aefd4d32c9ac$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $6d39aefd4d32c9ac$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(toArg);
    else {
        to = $6d39aefd4d32c9ac$var$_extends({}, toArg);
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $6d39aefd4d32c9ac$var$getInvalidPathError("?", "pathname", "search", to));
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $6d39aefd4d32c9ac$var$getInvalidPathError("#", "pathname", "hash", to));
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $6d39aefd4d32c9ac$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6d39aefd4d32c9ac$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $6d39aefd4d32c9ac$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $6d39aefd4d32c9ac$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $6d39aefd4d32c9ac$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $6d39aefd4d32c9ac$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $6d39aefd4d32c9ac$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $6d39aefd4d32c9ac$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $6d39aefd4d32c9ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $6d39aefd4d32c9ac$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $6d39aefd4d32c9ac$export$4051a07651545597(data, init) {
    return new $6d39aefd4d32c9ac$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $6d39aefd4d32c9ac$export$42a99a7a4bc0e76a extends Error {
}
class $6d39aefd4d32c9ac$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $6d39aefd4d32c9ac$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $6d39aefd4d32c9ac$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $6d39aefd4d32c9ac$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $6d39aefd4d32c9ac$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $6d39aefd4d32c9ac$var$unwrapTrackedPromise(value) {
    if (!$6d39aefd4d32c9ac$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $6d39aefd4d32c9ac$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $6d39aefd4d32c9ac$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6d39aefd4d32c9ac$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $6d39aefd4d32c9ac$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6d39aefd4d32c9ac$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $6d39aefd4d32c9ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $6d39aefd4d32c9ac$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $6d39aefd4d32c9ac$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $6d39aefd4d32c9ac$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $6d39aefd4d32c9ac$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $6d39aefd4d32c9ac$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $6d39aefd4d32c9ac$var$validMutationMethods = new Set($6d39aefd4d32c9ac$var$validMutationMethodsArr);
const $6d39aefd4d32c9ac$var$validRequestMethodsArr = [
    "get",
    ...$6d39aefd4d32c9ac$var$validMutationMethodsArr
];
const $6d39aefd4d32c9ac$var$validRequestMethods = new Set($6d39aefd4d32c9ac$var$validRequestMethodsArr);
const $6d39aefd4d32c9ac$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $6d39aefd4d32c9ac$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $6d39aefd4d32c9ac$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6d39aefd4d32c9ac$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $6d39aefd4d32c9ac$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $6d39aefd4d32c9ac$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $6d39aefd4d32c9ac$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $6d39aefd4d32c9ac$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $6d39aefd4d32c9ac$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6d39aefd4d32c9ac$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $6d39aefd4d32c9ac$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $6d39aefd4d32c9ac$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $6d39aefd4d32c9ac$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $6d39aefd4d32c9ac$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$6d39aefd4d32c9ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$6d39aefd4d32c9ac$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $6d39aefd4d32c9ac$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $6d39aefd4d32c9ac$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $6d39aefd4d32c9ac$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $6d39aefd4d32c9ac$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$6d39aefd4d32c9ac$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $6d39aefd4d32c9ac$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $6d39aefd4d32c9ac$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $6d39aefd4d32c9ac$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $6d39aefd4d32c9ac$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $6d39aefd4d32c9ac$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($6d39aefd4d32c9ac$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $6d39aefd4d32c9ac$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $6d39aefd4d32c9ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $6d39aefd4d32c9ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $6d39aefd4d32c9ac$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $6d39aefd4d32c9ac$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $6d39aefd4d32c9ac$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $6d39aefd4d32c9ac$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $6d39aefd4d32c9ac$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $6d39aefd4d32c9ac$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $6d39aefd4d32c9ac$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $6d39aefd4d32c9ac$var$findNearestBoundary(matches).route.id,
            {
                type: $6d39aefd4d32c9ac$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $6d39aefd4d32c9ac$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($6d39aefd4d32c9ac$var$isErrorResult(result) && $6d39aefd4d32c9ac$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $6d39aefd4d32c9ac$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $6d39aefd4d32c9ac$var$_extends({
            matches: updatedMatches || matches
        }, $6d39aefd4d32c9ac$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $6d39aefd4d32c9ac$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6d39aefd4d32c9ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $6d39aefd4d32c9ac$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $6d39aefd4d32c9ac$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $6d39aefd4d32c9ac$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $6d39aefd4d32c9ac$var$ResultType.error,
            error: $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($6d39aefd4d32c9ac$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $6d39aefd4d32c9ac$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) throw $6d39aefd4d32c9ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($6d39aefd4d32c9ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $6d39aefd4d32c9ac$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $6d39aefd4d32c9ac$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $6d39aefd4d32c9ac$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($6d39aefd4d32c9ac$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $6d39aefd4d32c9ac$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $6d39aefd4d32c9ac$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $6d39aefd4d32c9ac$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $6d39aefd4d32c9ac$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $6d39aefd4d32c9ac$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $6d39aefd4d32c9ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6d39aefd4d32c9ac$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $6d39aefd4d32c9ac$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $6d39aefd4d32c9ac$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $6d39aefd4d32c9ac$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $6d39aefd4d32c9ac$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $6d39aefd4d32c9ac$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $6d39aefd4d32c9ac$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $6d39aefd4d32c9ac$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $6d39aefd4d32c9ac$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6d39aefd4d32c9ac$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $6d39aefd4d32c9ac$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($6d39aefd4d32c9ac$var$isRedirectResult(actionResult) || $6d39aefd4d32c9ac$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $6d39aefd4d32c9ac$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($6d39aefd4d32c9ac$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $6d39aefd4d32c9ac$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $6d39aefd4d32c9ac$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($6d39aefd4d32c9ac$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($6d39aefd4d32c9ac$var$isDeferredResult(actionResult)) throw $6d39aefd4d32c9ac$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $6d39aefd4d32c9ac$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $6d39aefd4d32c9ac$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $6d39aefd4d32c9ac$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $6d39aefd4d32c9ac$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $6d39aefd4d32c9ac$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $6d39aefd4d32c9ac$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $6d39aefd4d32c9ac$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $6d39aefd4d32c9ac$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $6d39aefd4d32c9ac$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $6d39aefd4d32c9ac$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $6d39aefd4d32c9ac$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) result = await $6d39aefd4d32c9ac$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $6d39aefd4d32c9ac$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($6d39aefd4d32c9ac$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $6d39aefd4d32c9ac$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($6d39aefd4d32c9ac$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!$6d39aefd4d32c9ac$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $6d39aefd4d32c9ac$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $6d39aefd4d32c9ac$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $6d39aefd4d32c9ac$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $6d39aefd4d32c9ac$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Replace : $6d39aefd4d32c9ac$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $6d39aefd4d32c9ac$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($6d39aefd4d32c9ac$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $6d39aefd4d32c9ac$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $6d39aefd4d32c9ac$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $6d39aefd4d32c9ac$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $6d39aefd4d32c9ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $6d39aefd4d32c9ac$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($6d39aefd4d32c9ac$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $6d39aefd4d32c9ac$var$ResultType.redirect,
                response: $6d39aefd4d32c9ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $6d39aefd4d32c9ac$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $6d39aefd4d32c9ac$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $6d39aefd4d32c9ac$var$ResultType.error,
                    error: $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $6d39aefd4d32c9ac$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $6d39aefd4d32c9ac$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $6d39aefd4d32c9ac$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $6d39aefd4d32c9ac$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $6d39aefd4d32c9ac$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $6d39aefd4d32c9ac$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $6d39aefd4d32c9ac$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $6d39aefd4d32c9ac$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $6d39aefd4d32c9ac$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $6d39aefd4d32c9ac$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$6d39aefd4d32c9ac$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $6d39aefd4d32c9ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $6d39aefd4d32c9ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $6d39aefd4d32c9ac$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $6d39aefd4d32c9ac$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $6d39aefd4d32c9ac$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $6d39aefd4d32c9ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $6d39aefd4d32c9ac$export$4d0306f8f6a4585b = Symbol("deferred");
function $6d39aefd4d32c9ac$export$3336b097a6fbc59a(routes, opts) {
    $6d39aefd4d32c9ac$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $6d39aefd4d32c9ac$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $6d39aefd4d32c9ac$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6d39aefd4d32c9ac$var$createLocation("", $6d39aefd4d32c9ac$export$fe53371bee54353d(url), null, "default");
        let matches = $6d39aefd4d32c9ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6d39aefd4d32c9ac$var$isValidMethod(method) && method !== "HEAD") {
            let error = $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $6d39aefd4d32c9ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $6d39aefd4d32c9ac$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($6d39aefd4d32c9ac$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $6d39aefd4d32c9ac$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $6d39aefd4d32c9ac$var$createLocation("", $6d39aefd4d32c9ac$export$fe53371bee54353d(url), null, "default");
        let matches = $6d39aefd4d32c9ac$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$6d39aefd4d32c9ac$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $6d39aefd4d32c9ac$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $6d39aefd4d32c9ac$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($6d39aefd4d32c9ac$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$6d39aefd4d32c9ac$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($6d39aefd4d32c9ac$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $6d39aefd4d32c9ac$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $6d39aefd4d32c9ac$var$isResponse(result) ? result : $6d39aefd4d32c9ac$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($6d39aefd4d32c9ac$var$isDataStrategyResult(e) && $6d39aefd4d32c9ac$var$isResponse(e.result)) {
                if (e.type === $6d39aefd4d32c9ac$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($6d39aefd4d32c9ac$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6d39aefd4d32c9ac$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $6d39aefd4d32c9ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($6d39aefd4d32c9ac$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) {
            let error = $6d39aefd4d32c9ac$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $6d39aefd4d32c9ac$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($6d39aefd4d32c9ac$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($6d39aefd4d32c9ac$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $6d39aefd4d32c9ac$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $6d39aefd4d32c9ac$var$_extends({}, context, {
                statusCode: $6d39aefd4d32c9ac$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $6d39aefd4d32c9ac$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $6d39aefd4d32c9ac$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $6d39aefd4d32c9ac$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? $6d39aefd4d32c9ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $6d39aefd4d32c9ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $6d39aefd4d32c9ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $6d39aefd4d32c9ac$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $6d39aefd4d32c9ac$var$callDataStrategyImpl(dataStrategy || $6d39aefd4d32c9ac$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($6d39aefd4d32c9ac$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $6d39aefd4d32c9ac$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($6d39aefd4d32c9ac$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $6d39aefd4d32c9ac$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $6d39aefd4d32c9ac$export$fec11da027c70692(routes, context, error) {
    let newContext = $6d39aefd4d32c9ac$var$_extends({}, context, {
        statusCode: $6d39aefd4d32c9ac$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $6d39aefd4d32c9ac$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $6d39aefd4d32c9ac$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $6d39aefd4d32c9ac$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $6d39aefd4d32c9ac$export$cae722b0cc860f13(to ? to : ".", $6d39aefd4d32c9ac$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $6d39aefd4d32c9ac$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $6d39aefd4d32c9ac$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $6d39aefd4d32c9ac$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $6d39aefd4d32c9ac$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $6d39aefd4d32c9ac$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$6d39aefd4d32c9ac$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$6d39aefd4d32c9ac$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $6d39aefd4d32c9ac$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $6d39aefd4d32c9ac$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$6d39aefd4d32c9ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$6d39aefd4d32c9ac$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $6d39aefd4d32c9ac$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $6d39aefd4d32c9ac$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $6d39aefd4d32c9ac$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $6d39aefd4d32c9ac$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $6d39aefd4d32c9ac$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($6d39aefd4d32c9ac$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $6d39aefd4d32c9ac$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $6d39aefd4d32c9ac$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $6d39aefd4d32c9ac$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $6d39aefd4d32c9ac$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $6d39aefd4d32c9ac$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $6d39aefd4d32c9ac$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $6d39aefd4d32c9ac$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($6d39aefd4d32c9ac$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $6d39aefd4d32c9ac$var$shouldRevalidateLoader(match, $6d39aefd4d32c9ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $6d39aefd4d32c9ac$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $6d39aefd4d32c9ac$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $6d39aefd4d32c9ac$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $6d39aefd4d32c9ac$var$shouldRevalidateLoader(fetcherMatch, $6d39aefd4d32c9ac$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $6d39aefd4d32c9ac$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $6d39aefd4d32c9ac$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $6d39aefd4d32c9ac$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $6d39aefd4d32c9ac$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $6d39aefd4d32c9ac$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$6d39aefd4d32c9ac$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $6d39aefd4d32c9ac$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $6d39aefd4d32c9ac$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$6d39aefd4d32c9ac$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $6d39aefd4d32c9ac$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $6d39aefd4d32c9ac$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $6d39aefd4d32c9ac$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$6d39aefd4d32c9ac$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $6d39aefd4d32c9ac$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $6d39aefd4d32c9ac$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $6d39aefd4d32c9ac$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $6d39aefd4d32c9ac$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $6d39aefd4d32c9ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $6d39aefd4d32c9ac$var$ResultType.data,
                result: undefined
            });
        };
        return $6d39aefd4d32c9ac$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $6d39aefd4d32c9ac$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $6d39aefd4d32c9ac$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $6d39aefd4d32c9ac$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $6d39aefd4d32c9ac$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $6d39aefd4d32c9ac$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($6d39aefd4d32c9ac$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $6d39aefd4d32c9ac$var$ResultType.error,
                error: e
            };
        }
        if (type === $6d39aefd4d32c9ac$var$ResultType.error) return {
            type: $6d39aefd4d32c9ac$var$ResultType.error,
            error: new $6d39aefd4d32c9ac$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $6d39aefd4d32c9ac$var$ResultType.error) {
        if ($6d39aefd4d32c9ac$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $6d39aefd4d32c9ac$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $6d39aefd4d32c9ac$var$ResultType.error,
                error: new $6d39aefd4d32c9ac$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $6d39aefd4d32c9ac$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.error,
            error: result,
            statusCode: $6d39aefd4d32c9ac$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($6d39aefd4d32c9ac$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($6d39aefd4d32c9ac$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $6d39aefd4d32c9ac$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $6d39aefd4d32c9ac$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $6d39aefd4d32c9ac$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $6d39aefd4d32c9ac$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $6d39aefd4d32c9ac$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($6d39aefd4d32c9ac$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $6d39aefd4d32c9ac$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $6d39aefd4d32c9ac$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($6d39aefd4d32c9ac$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $6d39aefd4d32c9ac$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $6d39aefd4d32c9ac$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $6d39aefd4d32c9ac$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $6d39aefd4d32c9ac$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $6d39aefd4d32c9ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(!$6d39aefd4d32c9ac$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($6d39aefd4d32c9ac$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $6d39aefd4d32c9ac$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $6d39aefd4d32c9ac$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $6d39aefd4d32c9ac$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $6d39aefd4d32c9ac$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($6d39aefd4d32c9ac$var$isErrorResult(result)) {
            let boundaryMatch = $6d39aefd4d32c9ac$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $6d39aefd4d32c9ac$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($6d39aefd4d32c9ac$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $6d39aefd4d32c9ac$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $6d39aefd4d32c9ac$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $6d39aefd4d32c9ac$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $6d39aefd4d32c9ac$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $6d39aefd4d32c9ac$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $6d39aefd4d32c9ac$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $6d39aefd4d32c9ac$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $6d39aefd4d32c9ac$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $6d39aefd4d32c9ac$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $6d39aefd4d32c9ac$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $6d39aefd4d32c9ac$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($6d39aefd4d32c9ac$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $6d39aefd4d32c9ac$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(path) : path;
    return $6d39aefd4d32c9ac$export$fe53371bee54353d($6d39aefd4d32c9ac$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $6d39aefd4d32c9ac$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $6d39aefd4d32c9ac$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $6d39aefd4d32c9ac$var$ResultType.data || result.type === $6d39aefd4d32c9ac$var$ResultType.error);
}
function $6d39aefd4d32c9ac$var$isRedirectDataStrategyResultResult(result) {
    return $6d39aefd4d32c9ac$var$isResponse(result.result) && $6d39aefd4d32c9ac$var$redirectStatusCodes.has(result.result.status);
}
function $6d39aefd4d32c9ac$var$isDeferredResult(result) {
    return result.type === $6d39aefd4d32c9ac$var$ResultType.deferred;
}
function $6d39aefd4d32c9ac$var$isErrorResult(result) {
    return result.type === $6d39aefd4d32c9ac$var$ResultType.error;
}
function $6d39aefd4d32c9ac$var$isRedirectResult(result) {
    return (result && result.type) === $6d39aefd4d32c9ac$var$ResultType.redirect;
}
function $6d39aefd4d32c9ac$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $6d39aefd4d32c9ac$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $6d39aefd4d32c9ac$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $6d39aefd4d32c9ac$var$isRedirectResponse(result) {
    if (!$6d39aefd4d32c9ac$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $6d39aefd4d32c9ac$var$isValidMethod(method) {
    return $6d39aefd4d32c9ac$var$validRequestMethods.has(method.toLowerCase());
}
function $6d39aefd4d32c9ac$var$isMutationMethod(method) {
    return $6d39aefd4d32c9ac$var$validMutationMethods.has(method.toLowerCase());
}
async function $6d39aefd4d32c9ac$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$6d39aefd4d32c9ac$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($6d39aefd4d32c9ac$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $6d39aefd4d32c9ac$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $6d39aefd4d32c9ac$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($6d39aefd4d32c9ac$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $6d39aefd4d32c9ac$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $6d39aefd4d32c9ac$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $6d39aefd4d32c9ac$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $6d39aefd4d32c9ac$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $6d39aefd4d32c9ac$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $6d39aefd4d32c9ac$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $6d39aefd4d32c9ac$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $6d39aefd4d32c9ac$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $6d39aefd4d32c9ac$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $6d39aefd4d32c9ac$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $6d39aefd4d32c9ac$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $6d39aefd4d32c9ac$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $6d39aefd4d32c9ac$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $6d39aefd4d32c9ac$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $6d39aefd4d32c9ac$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $6d39aefd4d32c9ac$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $6d39aefd4d32c9ac$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($6d39aefd4d32c9ac$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $6d39aefd4d32c9ac$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($6d39aefd4d32c9ac$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $6d39aefd4d32c9ac$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});



parcelRegister("aSdFq", function(module, exports) {

$parcel$export(module.exports, "useIdentityUrl", function () { return $ca3740a7efd4c14e$export$f47199443d77bd99; });

var $4LHd8 = parcelRequire("4LHd8");

var $47vbe = parcelRequire("47vbe");
const $ca3740a7efd4c14e$export$e4ac48734a35d102 = "trello_advanced_cobranding_url";
const $ca3740a7efd4c14e$export$f47199443d77bd99 = ({ confirmReturnUrl: confirmReturnUrl, email: email, prompt: prompt, returnUrl: returnUrl, isLogin: isLogin } = {})=>{
    const { environment: environment } = (0, $47vbe.useConfig)();
    const isProduction = environment === "production";
    const baseUrl = isProduction ? "id.atlassian.com" : "id.stg.internal.atlassian.com";
    const host = isProduction ? "trello.com" : "trellis.coffee";
    const isAdvancedCobrandingEnabled = (0, $4LHd8.default).checkGate($ca3740a7efd4c14e$export$e4ac48734a35d102);
    // Param passed twice to Identity (in primary URL and encoded in continue/callback URL)
    // See https://hello.atlassian.net/browse/BXPT-1348?focusedCommentId=8509655
    // Omitted for trello--direct-signup (advanced co-branding) — see TJC-9006
    const display = "eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ==";
    const continueParams = new URLSearchParams();
    if (!isAdvancedCobrandingEnabled) continueParams.set("display", display);
    if (returnUrl) continueParams.append("returnUrl", returnUrl);
    if (confirmReturnUrl) continueParams.append("confirmReturnUrl", confirmReturnUrl);
    if (!isLogin) continueParams.append("createMember", "true");
    const application = isAdvancedCobrandingEnabled ? "trello--direct-signup" : "trello";
    const continueQuery = continueParams.toString();
    const continueValue = continueQuery ? `https://${host}/auth/atlassian/callback?${continueQuery}` : `https://${host}/auth/atlassian/callback`;
    const params = new URLSearchParams({
        application: application,
        continue: continueValue
    });
    if (!isAdvancedCobrandingEnabled) params.append("display", display);
    if (email) params.append("login_hint", email);
    if (prompt) params.append("prompt", prompt);
    const action = isLogin ? "login" : "signup";
    return `https://${baseUrl}/${action}?${params}`;
};

});

parcelRegister("jFObu", function(module, exports) {

$parcel$export(module.exports, "useViewportDimensions", function () { return $3aa835095930c782$export$8067ef2932747809; });

var $iSvIT = parcelRequire("iSvIT");

var $7AG7X = parcelRequire("7AG7X");
function $3aa835095930c782$export$8067ef2932747809(throttleDelay = 100) {
    const [viewportDimensions, setViewportDimensions] = (0, $iSvIT.useState)({
        viewportWidth: 0,
        viewportHeight: 0,
        pageXOffset: 0,
        pageYOffset: 0
    });
    (0, $iSvIT.useEffect)(()=>{
        if (viewportDimensions.viewportWidth === 0 && viewportDimensions.viewportHeight === 0) setViewportDimensions({
            viewportWidth: window.innerWidth,
            viewportHeight: window.innerHeight,
            pageXOffset: window.pageXOffset,
            pageYOffset: window.pageYOffset
        });
        const resize = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            setViewportDimensions({
                viewportWidth: window.innerWidth,
                viewportHeight: window.innerHeight,
                pageXOffset: window.pageXOffset,
                pageYOffset: window.pageYOffset
            });
        }, throttleDelay);
        window.addEventListener("resize", resize);
        return ()=>{
            window.removeEventListener("resize", resize);
        };
    }, [
        viewportDimensions,
        setViewportDimensions,
        throttleDelay
    ]);
    return viewportDimensions;
}

});


parcelRegister("dF0AD", function(module, exports) {

$parcel$export(module.exports, "updateSlideAccessibility", function () { return $d8e8f4c72d3e6907$export$30c3f801c2c93a74; });
function $d8e8f4c72d3e6907$export$30c3f801c2c93a74(firstSlide) {
    updateSlideChildren(firstSlide);
    let nextSlide = firstSlide.nextElementSibling;
    while(nextSlide){
        updateSlideChildren(nextSlide);
        nextSlide = nextSlide.nextElementSibling;
    }
    function updateSlideChildren(slide) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
        const focusableChildren = slide.querySelectorAll("a, button");
        const slideIsHidden = slide.getAttribute("aria-hidden") === "true";
        focusableChildren.forEach((el)=>slideIsHidden ? el.setAttribute("tabindex", "-1") : el.removeAttribute("tabindex"));
    }
}

});

parcelRegister("22YSu", function(module, exports) {

$parcel$export(module.exports, "Mask", function () { return $d20331a9cbf9e626$export$991dcf7284de63d; });
$parcel$export(module.exports, "Frame", function () { return $d20331a9cbf9e626$export$b89a827e9254211a; });
$parcel$export(module.exports, "Track", function () { return $d20331a9cbf9e626$export$13921ac0cc260818; });
$parcel$export(module.exports, "Slide", function () { return $d20331a9cbf9e626$export$d8dc01b5c85a37b9; });
$parcel$export(module.exports, "MobileControls", function () { return $d20331a9cbf9e626$export$72b2940f2d08f09a; });
$parcel$export(module.exports, "DesktopControls", function () { return $d20331a9cbf9e626$export$9443fd0e1d783a6; });
$parcel$export(module.exports, "Dots", function () { return $d20331a9cbf9e626$export$8da50d3722682be0; });
$parcel$export(module.exports, "Dot", function () { return $d20331a9cbf9e626$export$d046b3c4a416f60d; });
/** @jsxImportSource react */ 
var $hYbro = parcelRequire("hYbro");
const $d20331a9cbf9e626$export$991dcf7284de63d = (0, $hYbro.default).div({
    overflow: "hidden"
});
const $d20331a9cbf9e626$export$b89a827e9254211a = (0, $hYbro.default).div({
    "display": "flex",
    "flexDirection": "column",
    "flex-direction": "column",
    "gap": "1.5rem"
});
const $d20331a9cbf9e626$export$13921ac0cc260818 = (0, $hYbro.default).div({
    "alignItems": "stretch",
    "align-items": "stretch",
    "display": "flex"
});
const $d20331a9cbf9e626$export$d8dc01b5c85a37b9 = (0, $hYbro.default).div({
    "boxSizing": "content-box",
    "box-sizing": "content-box",
    "userSelect": "none",
    "user-select": "none",
    "width": "100%"
});
const $d20331a9cbf9e626$var$ControlsStyled = (0, $hYbro.default).div({
    "alignItems": "center",
    "align-items": "center",
    "justifyContent": "space-around",
    "justify-content": "space-around",
    "gap": "1.5rem",
    "display": "flex"
});
const $d20331a9cbf9e626$export$c7c44baae9d9f25f = $d20331a9cbf9e626$var$ControlsStyled;
const $d20331a9cbf9e626$export$72b2940f2d08f09a = (0, $hYbro.default).div({
    "alignItems": "center",
    "align-items": "center",
    "justifyContent": "center",
    "justify-content": "center",
    "gap": "1.5rem",
    "display": "flex",
    "flexWrap": "wrap",
    "flex-wrap": "wrap",
    "position": "relative",
    "zIndex": 1,
    "z-index": 1,
    "@media (min-width: 992px)": {
        display: "none"
    }
});
const $d20331a9cbf9e626$export$9443fd0e1d783a6 = (0, $hYbro.default).div(({ alignStart: alignStart })=>({
        "alignItems": "center",
        "align-items": "center",
        "justifyContent": alignStart ? "flex-start" : "flex-end",
        "justify-content": alignStart ? "flex-start" : "flex-end",
        "gap": "1.5rem",
        "display": "none",
        "flexWrap": "wrap",
        "flex-wrap": "wrap",
        "position": "relative",
        "zIndex": 1,
        "z-index": 1,
        "@media (min-width: 992px)": {
            display: "flex"
        }
    }));
const $d20331a9cbf9e626$export$8da50d3722682be0 = (0, $hYbro.default).div(({ mobile: mobile, desktop: desktop })=>({
        "alignItems": "center",
        "align-items": "center",
        "display": mobile || desktop ? "flex" : "none",
        "gap": "0.5rem"
    }));
const $d20331a9cbf9e626$export$d046b3c4a416f60d = (0, $hYbro.default).button(({ transitionTimeInSeconds: transitionTimeInSeconds })=>({
        "backgroundColor": "currentcolor",
        "background-color": "currentcolor",
        "border": 0,
        "borderRadius": "0.25rem",
        "border-radius": "0.25rem",
        "color": "inherit",
        "cursor": "pointer",
        "display": "block",
        "height": "0.5rem",
        "padding": 0,
        "width": "0.5rem",
        "transition": `all ${transitionTimeInSeconds}s ease`
    }));

});



parcelRegister("69DYH", function(module, exports) {

$parcel$export(module.exports, "Expand", function () { return $5695db35c7126e76$export$49bd1dfb0ad29c40; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $5695db35c7126e76$export$49bd1dfb0ad29c40 = ({ show: show, children: children, time: time = 350 })=>{
    const startTimer = (0, $iSvIT.useRef)(null);
    const endTimer = (0, $iSvIT.useRef)(null);
    const container = (0, $iSvIT.useRef)(null);
    const styles = {
        hidden: {
            display: "none"
        },
        invisible: {
            opacity: 0,
            overflow: "hidden",
            transition: `opacity ${time}ms, height ${time}ms`
        },
        visible: {
            opacity: 1,
            overflow: "hidden",
            transition: `opacity ${time}ms, height ${time}ms`
        },
        shown: {}
    };
    const [status, setStatus] = (0, $iSvIT.useState)({
        visibility: show ? "shown" : "hidden",
        height: show ? container.current?.scrollHeight : 0
    });
    (0, $iSvIT.useEffect)(()=>{
        if (show === true) {
            if (status.visibility === "hidden") setStatus({
                visibility: "invisible",
                height: 0
            });
            else if (status.visibility === "invisible") {
                //get height
                setStatus({
                    visibility: "visible",
                    height: container.current?.scrollHeight
                });
                if (endTimer.current) clearTimeout(endTimer.current);
                endTimer.current = setTimeout(()=>{
                    setStatus({
                        visibility: "shown"
                    });
                }, time);
            }
        } else if (show === false) {
            if (status.visibility === "shown") setStatus({
                visibility: "visible",
                height: container.current?.scrollHeight
            });
            else if (status.visibility === "visible") {
                if (startTimer.current) clearTimeout(startTimer.current);
                startTimer.current = setTimeout(()=>{
                    setStatus({
                        visibility: "invisible",
                        height: 0
                    });
                }, 50);
                if (endTimer.current) clearTimeout(endTimer.current);
                endTimer.current = setTimeout(()=>{
                    setStatus({
                        visibility: "hidden"
                    });
                }, time);
            }
        }
    }, [
        show,
        status,
        time
    ]); //clean up
    (0, $iSvIT.useEffect)(()=>{
        return ()=>{
            if (startTimer.current) clearTimeout(startTimer.current);
            if (endTimer.current) clearTimeout(endTimer.current);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            ...styles[status.visibility],
            height: status.height
        },
        ref: container,
        children: children
    });
};

});

parcelRegister("lQ5eN", function(module, exports) {
$parcel$export(module.exports, "Label", function () { return (parcelRequire("sm53h")).Label; });
$parcel$export(module.exports, "labelThemeOptions", function () { return (parcelRequire("sm53h")).labelThemeOptions; });
parcelRequire("sm53h");

});
parcelRegister("sm53h", function(module, exports) {

$parcel$export(module.exports, "labelThemeOptions", function () { return $851efdb0d83e489e$export$c78c526ea885a201; });
$parcel$export(module.exports, "Label", function () { return $851efdb0d83e489e$export$b04be29aa201d4f5; });

var $loA2J = parcelRequire("loA2J");

var $bsCGL = parcelRequire("bsCGL");

var $8w0J1 = parcelRequire("8w0J1");
parcelRequire("aki0G");
var $d1c7A = parcelRequire("d1c7A");
var $fe1Ts = parcelRequire("fe1Ts");
var $F50D1 = parcelRequire("F50D1");
var $fDQPA = parcelRequire("fDQPA");
var $fwctp = parcelRequire("fwctp");
var $k3ymz = parcelRequire("k3ymz");
var $1P0HA = parcelRequire("1P0HA");
const $851efdb0d83e489e$export$c78c526ea885a201 = [
    "Yellow",
    "Green",
    "Teal",
    "Magenta",
    "Blue",
    "Purple",
    "Neutral"
];
const $851efdb0d83e489e$export$b04be29aa201d4f5 = ({ className: className, text: text, theme: theme })=>{
    const patterns = {
        Blue: $d1c7A.Blue,
        Green: $fe1Ts.Green,
        Magenta: $F50D1.Magenta,
        Neutral: $fDQPA.Neutral,
        Purple: $fwctp.Purple,
        Teal: $k3ymz.Teal,
        Yellow: $1P0HA.Yellow
    };
    const colors = {
        Blue: "B200",
        Green: "G200",
        Magenta: "M200",
        Neutral: "N600",
        Purple: "P200",
        Teal: "T200",
        Yellow: "Y200"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8w0J1.LabelDiv), {
        "aria-hidden": true,
        className: className,
        color: colors[theme],
        children: [
            patterns[theme],
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bsCGL.Typewriter), {
                text: text
            })
        ]
    });
};

});
parcelRegister("bsCGL", function(module, exports) {

$parcel$export(module.exports, "Typewriter", function () { return $328a7c872b9c4165$export$1202d0f7e4d2d4ba; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $328a7c872b9c4165$export$1202d0f7e4d2d4ba = ({ text: text })=>{
    const [showText, setShowText] = (0, $iSvIT.useState)(text);
    (0, $iSvIT.useEffect)(()=>{
        let timer;
        if (showText !== text) timer = setTimeout(()=>{
            const newText = !showText.length || text.startsWith(showText) ? text.substring(0, showText.length + 1) : showText.substring(0, showText.length - 1);
            setShowText(newText);
        }, 50);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        showText,
        text
    ]);
    //non-breaking space maintains height when text is empty
    return showText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: showText
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: "\xa0"
    });
};

});

parcelRegister("8w0J1", function(module, exports) {

$parcel$export(module.exports, "LabelDiv", function () { return $7a9225efa9fd0439$export$a2c28a5b953c3955; });
/** @jsxImportSource react */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $7a9225efa9fd0439$export$a2c28a5b953c3955 = ({ color: color, style: style, children: children, ...props })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            alignItems: "center",
            backgroundColor: (0, $i2LPb.colorCSS)(color),
            borderRadius: "0.3925rem",
            boxShadow: `-5px 5px 0 0 ${(0, $i2LPb.colorCSS)("N900", 0.1)}`,
            color: (0, $i2LPb.colorCSS)("N0"),
            display: "flex",
            fontSize: "18.83px",
            gap: "0.5rem",
            paddingRight: "0.5rem",
            position: "absolute",
            transition: "box-shadow 0.1s, background-color 1s",
            userSelect: "none",
            whiteSpace: "nowrap",
            ...style
        },
        ...props,
        children: children
    });

});

parcelRegister("aki0G", function(module, exports) {
$parcel$export(module.exports, "Blue", function () { return (parcelRequire("d1c7A")).Blue; });
$parcel$export(module.exports, "Green", function () { return (parcelRequire("fe1Ts")).Green; });
$parcel$export(module.exports, "Magenta", function () { return (parcelRequire("F50D1")).Magenta; });
$parcel$export(module.exports, "Neutral", function () { return (parcelRequire("fDQPA")).Neutral; });
$parcel$export(module.exports, "Purple", function () { return (parcelRequire("fwctp")).Purple; });
$parcel$export(module.exports, "Teal", function () { return (parcelRequire("k3ymz")).Teal; });
$parcel$export(module.exports, "Yellow", function () { return (parcelRequire("1P0HA")).Yellow; });
parcelRequire("d1c7A");
parcelRequire("fe1Ts");
parcelRequire("F50D1");
parcelRequire("fDQPA");
parcelRequire("fwctp");
parcelRequire("k3ymz");
parcelRequire("1P0HA");

});
parcelRegister("d1c7A", function(module, exports) {

$parcel$export(module.exports, "Blue", function () { return $b1aecce8b384c3b3$export$c9cacf6069bed432; });

var $loA2J = parcelRequire("loA2J");
const $b1aecce8b384c3b3$export$c9cacf6069bed432 = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
    fill: "currentColor",
    height: "26",
    width: "26",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M0 6.277h25.108v6.277H0zM0 18.83h25.108v6.278H0z"
    })
});

});

parcelRegister("fe1Ts", function(module, exports) {

$parcel$export(module.exports, "Green", function () { return $94fc2e89bd9b4b30$export$fcb7d257bdd6bd00; });

var $loA2J = parcelRequire("loA2J");
const $94fc2e89bd9b4b30$export$fcb7d257bdd6bd00 = /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
    fill: "currentColor",
    height: "26",
    width: "26",
    children: [
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M3.923 6.277a3.138 3.138 0 0 1 3.139-3.139h9.415a6.277 6.277 0 0 1 6.277 6.277H7.062a3.138 3.138 0 0 1-3.139-3.138zM3.923 18.83a3.138 3.138 0 0 1 3.139-3.138h15.692a6.277 6.277 0 0 1-6.277 6.277H7.062a3.138 3.138 0 0 1-3.139-3.138z"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M16.477 9.415h6.277v6.277h-6.277z"
        })
    ]
});

});

parcelRegister("F50D1", function(module, exports) {

$parcel$export(module.exports, "Magenta", function () { return $964fa88ecaf144f6$export$e84d3f61cd5850bd; });

var $loA2J = parcelRequire("loA2J");
const $964fa88ecaf144f6$export$e84d3f61cd5850bd = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
    fill: "currentColor",
    height: "26",
    width: "26",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M19.615 6.277a3.139 3.139 0 1 1 6.277 0 3.139 3.139 0 0 1-6.277 0zM3.923 18.83a3.138 3.138 0 1 1 6.277 0 3.138 3.138 0 0 1-6.277 0zM3.923 6.277a3.138 3.138 0 0 1 3.139-3.139h6.277a3.139 3.139 0 0 1 0 6.277H7.062a3.138 3.138 0 0 1-3.139-3.138zM13.338 18.83a3.138 3.138 0 0 1 3.139-3.138h6.277a3.138 3.138 0 1 1 0 6.277h-6.277a3.138 3.138 0 0 1-3.139-3.138z"
    })
});

});

parcelRegister("fDQPA", function(module, exports) {

$parcel$export(module.exports, "Neutral", function () { return $652957368679a70c$export$d162730f58d427bd; });

var $loA2J = parcelRequire("loA2J");
const $652957368679a70c$export$d162730f58d427bd = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
    fill: "currentColor",
    height: "26",
    width: "26",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M3.139 6.277a3.138 3.138 0 0 1 6.277 0V18.83a3.138 3.138 0 1 1-6.277 0zM15.692 18.83a3.138 3.138 0 1 1 6.277 0v6.278h-6.277zM15.692 0h6.277v6.277a3.138 3.138 0 1 1-6.277 0z"
    })
});

});

parcelRegister("fwctp", function(module, exports) {

$parcel$export(module.exports, "Purple", function () { return $e2c68f4bbff14314$export$adf659a53d7e76e0; });

var $loA2J = parcelRequire("loA2J");
const $e2c68f4bbff14314$export$adf659a53d7e76e0 = /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
    fill: "currentColor",
    height: "26",
    width: "26",
    children: [
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M15.692 21.97h6.277v3.138h-6.277zM15.692 0h6.277v3.138h-6.277zM3.139 9.415h6.277v6.277H3.139zM3.139 7.846c0-2.6 2.107-4.708 4.707-4.708h1.57v6.277H3.139zM21.97 4.708c0 2.6-2.108 4.707-4.708 4.707h-1.57V3.138h6.277z"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M9.416 3.138h6.277v6.277H9.416zM21.97 15.692h3.138v6.277h-3.139zM0 15.692h3.138v6.277H0z"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M15.692 20.4c0-2.6 2.108-4.708 4.708-4.708h1.57v6.277h-6.278zM9.416 17.262c0 2.6-2.108 4.707-4.708 4.707h-1.57v-6.277h6.278z"
        })
    ]
});

});

parcelRegister("k3ymz", function(module, exports) {

$parcel$export(module.exports, "Teal", function () { return $15f640c0fe189124$export$fb85f7292a7c9aa9; });

var $loA2J = parcelRequire("loA2J");
const $15f640c0fe189124$export$fb85f7292a7c9aa9 = /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
    fill: "currentColor",
    height: "19",
    width: "19",
    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
        d: "M17.849 6.64 6.639 17.849a3.804 3.804 0 1 1-5.38-5.38l11.21-11.21a3.804 3.804 0 0 1 5.38 5.38z"
    })
});

});

parcelRegister("1P0HA", function(module, exports) {

$parcel$export(module.exports, "Yellow", function () { return $372b1966f5d6fe90$export$b4b6743fe286b651; });

var $loA2J = parcelRequire("loA2J");
const $372b1966f5d6fe90$export$b4b6743fe286b651 = /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
    width: "26",
    height: "26",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M22.646 15.692h3.139v6.277h-3.139v-6.277Zm-21.969 0h3.138v6.277H.677v-6.277Zm3.138 0h6.277v1.57c0 2.6-2.107 4.707-4.707 4.707h-1.57v-6.277Zm6.277-12.554h6.277v6.277h-6.277V3.138Zm6.278 0h1.569c2.6 0 4.707 2.108 4.707 4.708v1.57H16.37V3.137ZM3.815 9.415h6.277v6.277H3.815V9.415Z"
        }),
        /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M3.815 7.846c0-2.6 2.108-4.708 4.708-4.708h1.57v6.277H3.814V7.846ZM16.37 9.415h6.276v6.277H16.37V9.415Zm0 6.277h6.276v6.277h-1.569a4.708 4.708 0 0 1-4.708-4.707v-1.57Z"
        })
    ]
});

});




parcelRegister("lXPwV", function(module, exports) {
$parcel$export(module.exports, "LanguageSelectForm", function () { return (parcelRequire("ipl9a")).LanguageSelectForm; });
parcelRequire("ipl9a");

});
parcelRegister("ipl9a", function(module, exports) {

$parcel$export(module.exports, "LanguageSelectForm", function () { return $7a1babc4d0ac1944$export$677c178a98154469; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $fuZB8 = parcelRequire("fuZB8");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");

var $4iWIP = parcelRequire("4iWIP");

var $aYCAT = parcelRequire("aYCAT");

var $fOwkE = parcelRequire("fOwkE");
const $7a1babc4d0ac1944$export$677c178a98154469 = ({ iconColor: iconColor = "N0", selectLanguageLabel: selectLanguageLabel, showGlobeIcon: showGlobeIcon = true })=>{
    const currentLanguage = (0, $fuZB8.useLanguage)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const ENGLISH_LANGUAGE_VARIANTS = [
        "en-AU",
        "en-US",
        "en-GB"
    ];
    const languagesToDisplay = (0, $4iWIP.LANGUAGES).filter(({ code: code })=>!ENGLISH_LANGUAGE_VARIANTS.includes(code));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOwkE.LanguageForm), {
        showGlobeIcon: showGlobeIcon,
        iconColor: iconColor,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("select", {
            "aria-label": selectLanguageLabel,
            value: currentLanguage,
            onChange: ({ target: target })=>{
                const { value: selectedLanguage } = target;
                const segments = location.pathname.split("/").slice(1);
                sendTrackEvent("selectedLanguage", {
                    ...analyticsAttributes,
                    event: "selected",
                    eventComponent: "language",
                    label: `${selectedLanguage} language`,
                    labelEnglish: `${selectedLanguage} language`,
                    uuid: `${selectedLanguage}_language`
                });
                // Set language cookie for persistence (including "en")
                // Cookie expires in 1 year
                (0, $aYCAT.setCookie)("lang", selectedLanguage, 365);
                // Navigate to the new language URL with explicit locale prefix
                if ((0, $4iWIP.isLanguageCode)(segments[0]) && segments.length === 1) // Currently on /es or /fr, going to another language homepage
                location.assign(`/${selectedLanguage}`);
                else if ((0, $4iWIP.isLanguageCode)(segments[0])) // Currently on /es/enterprise, replace locale prefix
                location.assign(`/${selectedLanguage}/${segments.slice(1).join("/")}`);
                else if (location.pathname === "/") // Currently on homepage, add locale prefix
                location.assign(`/${selectedLanguage}`);
                else // Currently on /enterprise (no locale), add locale prefix
                location.assign(`/${selectedLanguage}/${segments.join("/")}`);
            },
            "data-testid": "language-select",
            children: languagesToDisplay.map(({ code: code, name: name })=>/*#__PURE__*/ (0, $loA2J.jsx)("option", {
                    value: code,
                    "data-uuid": `${code}_language`,
                    children: name
                }, code))
        })
    });
};

});
parcelRegister("4iWIP", function(module, exports) {

$parcel$export(module.exports, "LANGUAGES", function () { return $32f1fce4d9592568$export$2092376fd002e13; });
$parcel$export(module.exports, "isLanguageCode", function () { return $32f1fce4d9592568$export$22d957cf8e8d42ff; });
const $32f1fce4d9592568$export$25650286fa34b05f = $32f1fce4d9592568$export$b6e4117edbe490a2("en", "English");
const $32f1fce4d9592568$export$2092376fd002e13 = Object.freeze([
    $32f1fce4d9592568$export$b6e4117edbe490a2("cs", "\u010Ce\u0161tina"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("de", "Deutsch"),
    $32f1fce4d9592568$export$25650286fa34b05f,
    $32f1fce4d9592568$export$b6e4117edbe490a2("en-AU", "English (AU)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("en-GB", "English (UK)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("en-US", "English (US)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("es", "Espa\xf1ol"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("fr", "Fran\xe7ais"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("it", "Italiano"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("hu", "Magyar"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("nl", "Nederlands"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("nb", "Norsk (bokm\xe5l)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("pl", "Polski"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("pt-BR", "Portugu\xeas (Brasil)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("fi", "Suomi"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("sv", "Svenska"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("vi", "Ti\u1EBFng Vi\u1EC7t"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("tr", "T\xfcrk\xe7e"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("ru", "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("uk", "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("th", "\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("zh-Hans", "\u4E2D\u6587 (\u7B80\u4F53)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("zh-Hant", "\u4E2D\u6587 (\u7E41\u9AD4)"),
    $32f1fce4d9592568$export$b6e4117edbe490a2("ja", "\u65E5\u672C\u8A9E")
]);
const $32f1fce4d9592568$export$aa1f2e3112258da = Object.freeze($32f1fce4d9592568$export$2092376fd002e13.map(({ code: code })=>code));
const $32f1fce4d9592568$export$5a85a9696cf4944a = $32f1fce4d9592568$export$aa1f2e3112258da.filter((languageCode)=>!$32f1fce4d9592568$export$7a4deeb7a78bed10(languageCode));
const $32f1fce4d9592568$export$13c02bdda694746 = $32f1fce4d9592568$export$25650286fa34b05f.code;
function $32f1fce4d9592568$export$b6e4117edbe490a2(code, name) {
    return Object.freeze({
        code: code,
        name: name
    });
}
function $32f1fce4d9592568$export$22d957cf8e8d42ff(value) {
    return $32f1fce4d9592568$export$aa1f2e3112258da.some((languageCode)=>value === languageCode);
}
function $32f1fce4d9592568$export$7a4deeb7a78bed10(languageCode) {
    switch(languageCode){
        case "en":
        case "en-AU":
        case "en-US":
        case "en-GB":
            return true;
        default:
            return false;
    }
}

});

parcelRegister("fOwkE", function(module, exports) {

$parcel$export(module.exports, "LanguageForm", function () { return $bac99c42766f1905$export$bbde9229d5a5b92; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
const $bac99c42766f1905$var$globeSize = "20px";
const $bac99c42766f1905$export$bbde9229d5a5b92 = ({ iconColor: iconColor, showGlobeIcon: showGlobeIcon, style: style, children: children, ...props })=>{
    const dropdownArrowSvg = `data:image/svg+xml,%3Csvg fill='${(0, $i2LPb.colorCSSforSVG)(iconColor)}' height='8' viewBox='0 0 13 8' width='13' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='m11.7305.59279c.3626.362629.3885.93447.0777 1.32699l-.0777.08722-4.99999 4.99999c-.36263.36263-.93446.38853-1.32697.0777l-.08725-.0777-4.999959-4.99997c-.3905249-.39052-.3905242-1.023685 0-1.414209.362629-.36263.934469-.388553 1.326989-.077728l.08722.077728 4.29292 4.292139 4.29284-4.29216c.3626-.36263.9345-.388532 1.327-.077707z' /%3E%3C/svg%3E`;
    const globeSvg = `data:image/svg+xml,%3Csvg fill='${(0, $i2LPb.colorCSSforSVG)(iconColor)}' width='25px' height='24px' viewBox='0 0 25 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z' %3E%3C/path%3E%3C/svg%3E%0A`;
    const formStyle = {
        display: "inline-block",
        maxWidth: "100%",
        minHeight: $bac99c42766f1905$var$globeSize,
        paddingLeft: showGlobeIcon ? "2rem" : undefined,
        position: "relative",
        ...style
    };
    const selectStyle = {
        appearance: "none",
        backgroundColor: "transparent",
        backgroundImage: `url("${dropdownArrowSvg}")`,
        backgroundPosition: "center right",
        backgroundRepeat: "no-repeat",
        border: 0,
        color: "inherit",
        cursor: "pointer",
        display: "block",
        fontFamily: "inherit",
        fontSize: (0, $kL1mL.fontSizes).sm,
        paddingRight: "1rem",
        position: "relative",
        maxWidth: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis"
    };
    const globeIconStyle = showGlobeIcon ? {
        backgroundImage: `url("${globeSvg}")`,
        backgroundPosition: "center left",
        backgroundRepeat: "no-repeat",
        backgroundSize: $bac99c42766f1905$var$globeSize,
        bottom: 0,
        content: '""',
        left: 0,
        minHeight: $bac99c42766f1905$var$globeSize,
        minWidth: $bac99c42766f1905$var$globeSize,
        position: "absolute",
        top: 0
    } : {};
    return /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
        style: formStyle,
        ...props,
        children: [
            showGlobeIcon && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: globeIconStyle
            }),
            (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.map(children, (child)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).isValidElement(child) && child.type === "select") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).cloneElement(child, {
                    style: {
                        ...selectStyle,
                        ...child.props.style || {}
                    }
                });
                return child;
            })
        ]
    });
};

});



parcelRegister("986bT", function(module, exports) {

$parcel$export(module.exports, "LogoAtlassian", function () { return $c3ab564905ee771f$export$70e18b5d5fa92844; });

var $loA2J = parcelRequire("loA2J");
const $c3ab564905ee771f$export$70e18b5d5fa92844 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-label": "Atlassian",
        fill: "currentColor",
        role: "img",
        viewBox: "0 0 539.669 67",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M296.309 27.06c0 8 3.73 14.42 18.31 17.23 8.7 1.82 10.52 3.23 10.52 6.13s-1.82 4.64-8 4.64a44.89 44.89 0 0 1-21.13-5.72v13.1c4.39 2.15 10.19 4.56 21 4.56 15.25 0 21.3-6.79 21.3-16.9m0 0c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6 0-3.15 2.82-4.47 8-4.47 6.3 0 12.51 1.91 18.4 4.56V14.63a41.58 41.58 0 0 0-18-3.73c-14.09 0-21.38 6.13-21.38 16.16M492.189 11.73v54.44h11.6V24.66l4.89 11.02 16.41 30.49h14.58V11.73h-11.6v35.14l-4.39-10.2-13.18-24.94h-18.31zM405.729 11.73h12.68v54.44h-12.68zM391.099 50.1c0-9.53-5.05-14-19.31-17.07-7.87-1.74-9.78-3.48-9.78-6 0-3.15 2.82-4.47 8-4.47 6.3 0 12.51 1.91 18.4 4.56V14.63a41.58 41.58 0 0 0-18-3.73c-14.09 0-21.38 6.13-21.38 16.16 0 8 3.73 14.42 18.31 17.23 8.7 1.82 10.52 3.23 10.52 6.13s-1.82 4.64-8 4.64a44.89 44.89 0 0 1-21.13-5.72v13.1c4.39 2.15 10.19 4.56 21 4.56 15.25 0 21.3-6.79 21.3-16.9M197.829 11.73v54.44h26.06l4.1-11.76h-17.4V11.73h-12.76zM146.339 11.73V23.5h14.09v42.67h12.76V23.5h15.08V11.73h-41.93zM127.839 11.73h-16.72l-19 54.44h14.55l2.66-9.17a36 36 0 0 0 20.34 0l2.69 9.17h14.5Zm-8.36 35.46a24.76 24.76 0 0 1-7-1l7-23.77 7 23.77a24.76 24.76 0 0 1-7 1ZM268.809 11.73h-16.72l-19 54.44h14.5l2.71-9.17a36 36 0 0 0 20.3 0l2.69 9.17h14.5Zm-8.36 35.46a24.76 24.76 0 0 1-7-1l7-23.77 7 23.77a24.76 24.76 0 0 1-7 1ZM464.089 11.73h-16.72l-19 54.44h14.5l2.71-9.17a36 36 0 0 0 20.3 0l2.69 9.17h14.5Zm-8.36 35.46a24.76 24.76 0 0 1-7-1l7-23.77 7 23.77a24.76 24.76 0 0 1-7 1Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.036 30.875a1.636 1.636 0 0 0-1.397-.564 1.348 1.348 0 0 0-1 .803L.153 64.068a1.444 1.444 0 0 0 1.291 2.09H24.4a1.389 1.389 0 0 0 1.286-.8c4.823-9.952 1.838-25.417-6.649-34.483ZM66.05 64.08C65.741 63.46 35.163 2.275 34.41.754A1.302 1.302 0 0 0 33.31 0L33.26 0a1.579 1.579 0 0 0-1.3.812l-.002.001c-8.289 13.131-9.228 28.985-2.511 42.41l11.065 22.13a1.438 1.438 0 0 0 1.296.817h22.951a1.444 1.444 0 0 0 1.292-2.09Z"
            })
        ]
    });
};

});

parcelRegister("yF2IO", function(module, exports) {

$parcel$export(module.exports, "LogoTrello", function () { return $97da89bc4ab0bc79$export$cb757e539c4b2eac; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("kswg3");
var $8rVeu = parcelRequire("8rVeu");
var $AbilK = parcelRequire("AbilK");
var $hHOlA = parcelRequire("hHOlA");
var $h8ILU = parcelRequire("h8ILU");
const $97da89bc4ab0bc79$export$cb757e539c4b2eac = ({ eyebrow: eyebrow, height: height, width: width, appearance: appearance, id: id = "" })=>{
    const intrinsicWidth = 312;
    const intrinsicHeight = eyebrow ? 105 : 64;
    let actualWidth = width;
    let actualHeight = height;
    if (!width && height) actualWidth = intrinsicWidth / intrinsicHeight * height;
    else if (width && !height) actualHeight = intrinsicHeight / intrinsicWidth * width;
    else if (!width && !height) {
        actualWidth = intrinsicWidth;
        actualHeight = intrinsicHeight;
    }
    const props = {
        id: id,
        actualHeight: actualHeight,
        actualWidth: actualWidth,
        intrinsicHeight: intrinsicHeight,
        intrinsicWidth: intrinsicWidth
    };
    if (appearance === "white") {
        if (eyebrow) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8rVeu.WhiteEyebrowLogo), {
            ...props
        });
        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $AbilK.WhiteLogo), {
            ...props
        });
    }
    if (eyebrow) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hHOlA.DefaultEyebrowLogo), {
        ...props
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $h8ILU.DefaultLogo), {
        ...props
    });
};

});
parcelRegister("kswg3", function(module, exports) {
$parcel$export(module.exports, "DefaultEyebrowLogo", function () { return (parcelRequire("hHOlA")).DefaultEyebrowLogo; });
$parcel$export(module.exports, "DefaultLogo", function () { return (parcelRequire("h8ILU")).DefaultLogo; });
$parcel$export(module.exports, "WhiteEyebrowLogo", function () { return (parcelRequire("8rVeu")).WhiteEyebrowLogo; });
$parcel$export(module.exports, "WhiteLogo", function () { return (parcelRequire("AbilK")).WhiteLogo; });
parcelRequire("hHOlA");
parcelRequire("h8ILU");
parcelRequire("8rVeu");
parcelRequire("AbilK");

});
parcelRegister("hHOlA", function(module, exports) {

$parcel$export(module.exports, "DefaultEyebrowLogo", function () { return $b8e3ec6699001d66$export$858dad3946aee522; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $1PyXV = parcelRequire("1PyXV");
const $b8e3ec6699001d66$export$858dad3946aee522 = ({ actualHeight: actualHeight, actualWidth: actualWidth, intrinsicHeight: intrinsicHeight, intrinsicWidth: intrinsicWidth, id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1PyXV.Logo), {
        as: "svg",
        "aria-label": "Atlassian Trello",
        height: actualHeight,
        role: "img",
        viewBox: [
            0,
            0,
            intrinsicWidth,
            intrinsicHeight
        ].join(" "),
        width: actualWidth,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                id: `trello-logo-gradient-default${id}`,
                x1: "49.992%",
                x2: "49.992%",
                y1: "100%",
                y2: ".016%",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "0",
                        stopColor: (0, $i2LPb.colorHex)("B400")
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "1",
                        stopColor: (0, $i2LPb.colorHex)("B200")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m55.3 40.6h-47.5c-4.1 0-7.4 3.3-7.4 7.4v47.6c0 4.1 3.3 7.4 7.4 7.4h47.5c4.1 0 7.4-3.3 7.4-7.4v-47.6c0-4.1-3.3-7.4-7.4-7.4zm-28.1 44.9c0 1.4-1.1 2.5-2.5 2.5h-10.4c-1.4 0-2.5-1.1-2.5-2.5v-30.9c0-1.4 1.1-2.5 2.5-2.5h10.4c1.4 0 2.5 1.1 2.5 2.5zm24-14.2c0 1.4-1.1 2.5-2.4 2.5h-10.5c-1.4 0-2.5-1.1-2.5-2.5v-16.7c0-1.4 1.1-2.5 2.5-2.5h10.4c1.4 0 2.5 1.1 2.5 2.5z",
                fill: `url(#trello-logo-gradient-default${id})`
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fill: (0, $i2LPb.colorHex)("N700"),
                transform: "translate(87 40)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m42.6 5.2v12.1h-14.3v45.7h-13.8v-45.8h-14.3v-12z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m60.2 63h-12.7v-45h12.7v8.6c2.4-6.1 6.3-9.7 13.2-9.2v13.3c-9-.7-13.2 1.5-13.2 8.7z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m143 63.4c-8.4 0-13.6-4-13.6-13.5v-49.3h12.8v47.5c0 2.7 1.8 3.7 4 3.7.6 0 1.3 0 1.9-.1v11.1c-1.7.4-3.4.6-5.1.6z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m169.8 63.4c-8.4 0-13.6-4-13.6-13.5v-49.3h12.8v47.5c0 2.7 1.8 3.7 4 3.7.6 0 1.3 0 1.9-.1v11.1c-1.7.4-3.4.6-5.1.6z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m181 40.5c0-13.9 8-23.4 21.8-23.4s21.6 9.5 21.6 23.4-7.9 23.6-21.6 23.6-21.8-9.8-21.8-23.6zm12.5 0c0 6.8 2.8 12.1 9.3 12.1s9.1-5.4 9.1-12.1-2.8-12-9.1-12-9.3 5.2-9.3 12z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m90.6 44.6c3.6.4 7.2.6 10.7.6 9.8 0 18-2.6 18-12.1 0-9.2-8.5-16.1-18.7-16.1-13.7 0-22.5 10-22.5 23.8 0 14.4 7.6 23 24.7 23 5.1.1 10.1-.8 14.9-2.6v-10.8c-4.4 1.4-9.4 2.8-14.4 2.8-6.8.1-11.5-2.2-12.7-8.6zm9.8-17.7c3.6 0 6.5 2.4 6.5 5.8 0 4.3-4.6 5.7-9.8 5.7-2.2 0-4.5-.2-6.7-.5.2-2.1.8-4.1 1.8-6 1.6-3.1 4.8-5 8.2-5z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fill: (0, $i2LPb.colorHex)("B400"),
                transform: "translate(94)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m98.9 16.7c0-4-2.6-5.8-7.4-7-3-.8-3.7-1.4-3.7-2.4 0-1.2 1.1-1.8 3.1-1.8 2.4.1 4.8.7 7 1.8v-5c-2.1-1-4.5-1.5-6.8-1.5-5.3 0-8.2 2.5-8.2 6.6 0 3.9 2.6 5.9 7 6.9 3.1.7 4 1.2 4 2.5 0 1-.7 1.8-3 1.8-2.8-.1-5.6-.9-8.1-2.3v5.3c2.5 1.2 5.2 1.9 8 1.9 5.4 0 8.1-2.7 8.1-6.8z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m159.3 1.2v22h4.7v-16.8l2 4.4 6.6 12.3h5.9v-22h-4.7v14.2l-1.8-4.1-5.3-10.1h-7.4z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m129.6 1.2h-5.1v22h5.1z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m43.2 1.2v22h10.5l1.6-4.8h-7v-17.2z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m22.4 1.2v4.8h5.7v17.2h5.1v-17.2h6.1v-4.8z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m15 1.2h-6.7l-7.7 22h5.9l1.1-3.7c1.3.4 2.7.6 4.1.6s2.8-.2 4.1-.6l1.1 3.7h5.9zm-3.4 14.3c-1 0-1.9-.1-2.8-.4l2.8-9.6 2.8 9.6c-.9.3-1.8.4-2.8.4z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m71.7 1.2h-6.7l-7.7 22h5.9l1.1-3.7c1.3.4 2.7.6 4.1.6s2.8-.2 4.1-.6l1.1 3.7h5.9zm-3.3 14.3c-1 0-1.9-.1-2.8-.4l2.8-9.6 2.8 9.6c-.9.3-1.9.4-2.8.4z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m148 1.2h-6.7l-7.7 22h5.9l1.1-3.7c1.3.4 2.7.6 4.1.6s2.8-.2 4.1-.6l1.1 3.7h5.9zm-3.4 14.3c-1 0-1.9-.1-2.8-.4l2.8-9.6 2.8 9.6c-.9.3-1.8.4-2.8.4z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m119.2 16.7c0-4-2.6-5.8-7.4-7-3-.8-3.7-1.4-3.7-2.4 0-1.2 1.1-1.8 3-1.8 2.4.1 4.8.7 7 1.8v-5c-2.2-1-4.5-1.5-6.9-1.5-5.3 0-8.2 2.5-8.2 6.6 0 3.9 2.6 5.9 7 6.9 3.1.7 4 1.2 4 2.5 0 1-.7 1.8-3 1.8-2.8-.1-5.6-.9-8.1-2.3v5.3c2.5 1.2 5.2 1.9 8 1.9 5.7 0 8.3-2.7 8.3-6.8z"
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("1PyXV", function(module, exports) {

$parcel$export(module.exports, "Logo", function () { return $cc0f8234c901fbad$export$e6ff31bff12b7ff4; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $cc0f8234c901fbad$export$e6ff31bff12b7ff4 = (0, $hYbro.styled).svg`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
`;
const $cc0f8234c901fbad$export$2bc3a170ad333299 = {};

});


parcelRegister("h8ILU", function(module, exports) {

$parcel$export(module.exports, "DefaultLogo", function () { return $3b8be6c86a83374c$export$523e896ec86fba5b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $1PyXV = parcelRequire("1PyXV");
const $3b8be6c86a83374c$export$523e896ec86fba5b = ({ actualHeight: actualHeight, actualWidth: actualWidth, intrinsicHeight: intrinsicHeight, intrinsicWidth: intrinsicWidth, id: id })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1PyXV.Logo), {
        as: "svg",
        "aria-label": "Trello",
        height: actualHeight,
        role: "img",
        viewBox: [
            0,
            0,
            intrinsicWidth,
            intrinsicHeight
        ].join(" "),
        width: actualWidth,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                id: `trello-logo-gradient-default${id}`,
                x1: "50.048061%",
                x2: "50.048061%",
                y1: "100%",
                y2: "0%",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "0",
                        stopColor: (0, $i2LPb.colorHex)("B400")
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "1",
                        stopColor: (0, $i2LPb.colorHex)("B200")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m55.59.07h-47.59c-4.09405078 0-7.41448241 3.31595294-7.42006073 7.41v47.52c-.00791682 1.9730991.77030774 3.8681213 2.16269326 5.2661365 1.39238553 1.3980151 3.28425224 2.1838635 5.25736747 2.1838635h47.59c1.9713817-.0026407 3.8606757-.7896772 5.250897-2.1874031s2.1670753-3.2912295 2.1591638-5.2625969v-47.52c-.0055694-4.09014608-3.3199147-7.40449138-7.4100608-7.41zm-28.09 44.93c-.0026377.6594819-.2678382 1.2907542-.7369724 1.7542587-.4691341.4635046-1.1035619.721065-1.7630276.7158222h-10.4c-1.3602365-.005588-2.46-1.1098333-2.46-2.4700809v-30.95c0-1.3602476 1.0997635-2.4644929 2.46-2.47h10.4c1.3618668.0054804 2.4645196 1.1081332 2.47 2.47zm24-14.21c0 .6603158-.2642968 1.2931595-.7340204 1.7572465-.4697237.464087-1.1057125.7207735-1.7659796.7129359h-10.4c-1.3618668-.0056628-2.4645196-1.1083156-2.47-2.4701824v-16.74c.0054804-1.3618668 1.1081332-2.4645196 2.47-2.47h10.4c1.3602365.0055071 2.4600111 1.1097524 2.46 2.47z",
                fill: `url(#trello-logo-gradient-default${id})`
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fill: (0, $i2LPb.colorHex)("N700"),
                transform: "translate(87)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m42.92 4.64v12.06h-14.29v45.75h-13.78v-45.75h-14.29v-12.06z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m60.46 62.45h-12.74v-45h12.74v8.62c2.42-6.07 6.29-9.68 13.18-9.24v13.33c-9-.7-13.18 1.5-13.18 8.71z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m143.24 62.8c-8.35 0-13.6-4-13.6-13.46v-49.27h12.83v47.51c0 2.73 1.8 3.7 4 3.7.634638.0128631 1.269419-.0172055 1.9-.09v11.09c-1.677893.4087549-3.404213.5837425-5.13.52z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m170 62.8c-8.35 0-13.61-4-13.61-13.46v-49.27h12.83v47.51c0 2.73 1.81 3.7 4.05 3.7.631315.0130885 1.262786-.0169816 1.89-.09v11.09c-1.687411.4126716-3.42418.5876949-5.16.52z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m181.31 39.93c0-13.9 8-23.41 21.78-23.41s21.61 9.48 21.61 23.41-7.92 23.58-21.61 23.58-21.78-9.77-21.78-23.58zm12.49 0c0 6.77 2.84 12.14 9.29 12.14s9.13-5.37 9.13-12.14-2.75-12-9.13-12-9.29 5.22-9.29 12z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m90.84 44c3.5670052.3919324 7.1516349.602204 10.74.63 9.76 0 18-2.62 18-12.07 0-9.17-8.47-16.06-18.66-16.06-13.72 0-22.51 9.95-22.51 23.85 0 14.43 7.58 23 24.71 23 5.081836.0413682 10.127233-.8605644 14.88-2.66v-10.78c-4.4 1.41-9.35 2.81-14.43 2.81-6.82 0-11.57-2.24-12.73-8.72zm9.82-17.68c3.61 0 6.51 2.45 6.51 5.8 0 4.31-4.55 5.66-9.79 5.66-2.2301144-.0102442-4.4563338-.1874058-6.66-.53.1664561-2.1013033.7692883-4.1448022 1.77-6 1.6348247-2.9938883 4.7590565-4.8714866 8.17-4.91z"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("8rVeu", function(module, exports) {

$parcel$export(module.exports, "WhiteEyebrowLogo", function () { return $d3205799215dc6b9$export$e74a58f82ac53a13; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $1PyXV = parcelRequire("1PyXV");
const $d3205799215dc6b9$export$e74a58f82ac53a13 = ({ actualHeight: actualHeight, actualWidth: actualWidth, intrinsicHeight: intrinsicHeight, intrinsicWidth: intrinsicWidth, id: id })=>{
    const white = (0, $i2LPb.colorHex)("N0");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1PyXV.Logo), {
        as: "svg",
        "aria-label": "Atlassian Trello",
        fill: white,
        height: actualHeight,
        role: "img",
        viewBox: [
            0,
            0,
            intrinsicWidth,
            intrinsicHeight
        ].join(" "),
        width: actualWidth,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                    id: `trello-logo-gradient-white${id}`,
                    x1: "49.992%",
                    x2: "49.992%",
                    y1: "100%",
                    y2: ".016%",
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "0%",
                            stopColor: white,
                            stopOpacity: ".5"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "15%",
                            stopColor: white,
                            stopOpacity: ".65"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "30%",
                            stopColor: white,
                            stopOpacity: ".78"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "46%",
                            stopColor: white,
                            stopOpacity: ".88"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "62%",
                            stopColor: white,
                            stopOpacity: ".95"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "80%",
                            stopColor: white,
                            stopOpacity: ".99"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                            offset: "100%",
                            stopColor: white
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.6 5.2 42.6 17.3 28.3 17.3 28.3 63 14.5 63 14.5 17.2.2 17.2.2 5.2z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M60.2,63 L47.5,63 L47.5,18 L60.2,18 L60.2,26.6 C62.6,20.5 66.5,16.9 73.4,17.4 L73.4,30.7 C64.4,30 60.2,32.2 60.2,39.4 L60.2,63 Z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M143,63.4 C134.6,63.4 129.4,59.4 129.4,49.9 L129.4,0.6 L142.2,0.6 L142.2,48.1 C142.2,50.8 144,51.8 146.2,51.8 C146.8,51.8 147.5,51.8 148.1,51.7 L148.1,62.8 C146.4,63.2 144.7,63.4 143,63.4 L143,63.4 Z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M169.8,63.4 C161.4,63.4 156.2,59.4 156.2,49.9 L156.2,0.6 L169,0.6 L169,48.1 C169,50.8 170.8,51.8 173,51.8 C173.6,51.8 174.3,51.8 174.9,51.7 L174.9,62.8 C173.2,63.2 171.5,63.4 169.8,63.4 L169.8,63.4 Z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M181,40.5 C181,26.6 189,17.1 202.8,17.1 C216.6,17.1 224.4,26.6 224.4,40.5 C224.4,54.4 216.5,64.1 202.8,64.1 C189.1,64.1 181,54.3 181,40.5 Z M193.5,40.5 C193.5,47.3 196.3,52.6 202.8,52.6 C209.3,52.6 211.9,47.2 211.9,40.5 C211.9,33.8 209.1,28.5 202.8,28.5 C196.5,28.5 193.5,33.7 193.5,40.5 Z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M90.6,44.6 C94.2,45 97.8,45.2 101.3,45.2 C111.1,45.2 119.3,42.6 119.3,33.1 C119.3,23.9 110.8,17 100.6,17 C86.9,17 78.1,27 78.1,40.8 C78.1,55.2 85.7,63.8 102.8,63.8 C107.9,63.9 112.9,63 117.7,61.2 L117.7,50.4 C113.3,51.8 108.3,53.2 103.3,53.2 C96.5,53.3 91.8,51 90.6,44.6 L90.6,44.6 Z M100.4,26.9 C104,26.9 106.9,29.3 106.9,32.7 C106.9,37 102.3,38.4 97.1,38.4 C94.9,38.4 92.6,38.2 90.4,37.9 C90.6,35.8 91.2,33.8 92.2,31.9 C93.8,28.8 97,26.9 100.4,26.9 Z",
                transform: "translate(87 40)"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: `url(#trello-logo-gradient-white${id})`,
                d: "M55.3,40.6 L7.8,40.6 C3.7,40.6 0.4,43.9 0.4,48 L0.4,95.6 C0.4,99.7 3.7,103 7.8,103 L55.3,103 C59.4,103 62.7,99.7 62.7,95.6 L62.7,48 C62.7,43.9 59.4,40.6 55.3,40.6 Z M27.2,85.5 C27.2,86.9 26.1,88 24.7,88 L14.3,88 C12.9,88 11.8,86.9 11.8,85.5 L11.8,54.6 C11.8,53.2 12.9,52.1 14.3,52.1 L24.7,52.1 C26.1,52.1 27.2,53.2 27.2,54.6 L27.2,85.5 Z M51.2,71.3 C51.2,72.7 50.1,73.8 48.8,73.8 L38.3,73.8 C36.9,73.8 35.8,72.7 35.8,71.3 L35.8,54.6 C35.8,53.2 36.9,52.1 38.3,52.1 L48.7,52.1 C50.1,52.1 51.2,53.2 51.2,54.6 L51.2,71.3 Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                opacity: ".7",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M98.9,16.7 C98.9,12.7 96.3,10.9 91.5,9.7 C88.5,8.9 87.8,8.3 87.8,7.3 C87.8,6.1 88.9,5.5 90.9,5.5 C93.3,5.6 95.7,6.2 97.9,7.3 L97.9,2.3 C95.8,1.3 93.4,0.8 91.1,0.8 C85.8,0.8 82.9,3.3 82.9,7.4 C82.9,11.3 85.5,13.3 89.9,14.3 C93,15 93.9,15.5 93.9,16.8 C93.9,17.8 93.2,18.6 90.9,18.6 C88.1,18.5 85.3,17.7 82.8,16.3 L82.8,21.6 C85.3,22.8 88,23.5 90.8,23.5 C96.2,23.5 98.9,20.8 98.9,16.7 L98.9,16.7 Z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M159.3 1.2 159.3 23.2 164 23.2 164 6.4 166 10.8 172.6 23.1 178.5 23.1 178.5 1.1 173.8 1.1 173.8 15.3 172 11.2 166.7 1.1 159.3 1.1z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M129.6 1.2 124.5 1.2 124.5 23.2 129.6 23.2z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M43.2 1.2 43.2 23.2 53.7 23.2 55.3 18.4 48.3 18.4 48.3 1.2z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M22.4 1.2 22.4 6 28.1 6 28.1 23.2 33.2 23.2 33.2 6 39.3 6 39.3 1.2z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M15,1.2 L8.3,1.2 L0.6,23.2 L6.5,23.2 L7.6,19.5 C8.9,19.9 10.3,20.1 11.7,20.1 C13.1,20.1 14.5,19.9 15.8,19.5 L16.9,23.2 L22.8,23.2 L15,1.2 Z M11.6,15.5 C10.6,15.5 9.7,15.4 8.8,15.1 L11.6,5.5 L14.4,15.1 C13.5,15.4 12.6,15.5 11.6,15.5 Z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M71.7,1.2 L65,1.2 L57.3,23.2 L63.2,23.2 L64.3,19.5 C65.6,19.9 67,20.1 68.4,20.1 C69.8,20.1 71.2,19.9 72.5,19.5 L73.6,23.2 L79.5,23.2 L71.7,1.2 Z M68.4,15.5 C67.4,15.5 66.5,15.4 65.6,15.1 L68.4,5.5 L71.2,15.1 C70.3,15.4 69.3,15.5 68.4,15.5 Z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M148,1.2 L141.3,1.2 L133.6,23.2 L139.5,23.2 L140.6,19.5 C141.9,19.9 143.3,20.1 144.7,20.1 C146.1,20.1 147.5,19.9 148.8,19.5 L149.9,23.2 L155.8,23.2 L148,1.2 Z M144.6,15.5 C143.6,15.5 142.7,15.4 141.8,15.1 L144.6,5.5 L147.4,15.1 C146.5,15.4 145.6,15.5 144.6,15.5 Z",
                        transform: "translate(94)"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M119.2,16.7 C119.2,12.7 116.6,10.9 111.8,9.7 C108.8,8.9 108.1,8.3 108.1,7.3 C108.1,6.1 109.2,5.5 111.1,5.5 C113.5,5.6 115.9,6.2 118.1,7.3 L118.1,2.3 C115.9,1.3 113.6,0.8 111.2,0.8 C105.9,0.8 103,3.3 103,7.4 C103,11.3 105.6,13.3 110,14.3 C113.1,15 114,15.5 114,16.8 C114,17.8 113.3,18.6 111,18.6 C108.2,18.5 105.4,17.7 102.9,16.3 L102.9,21.6 C105.4,22.8 108.1,23.5 110.9,23.5 C116.6,23.5 119.2,20.8 119.2,16.7 L119.2,16.7 Z",
                        transform: "translate(94)"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("AbilK", function(module, exports) {

$parcel$export(module.exports, "WhiteLogo", function () { return $34d04d79259250ea$export$2585aa712867193d; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $1PyXV = parcelRequire("1PyXV");
const $34d04d79259250ea$export$2585aa712867193d = ({ actualHeight: actualHeight, actualWidth: actualWidth, intrinsicHeight: intrinsicHeight, intrinsicWidth: intrinsicWidth, id: id })=>{
    const white = (0, $i2LPb.colorHex)("N0");
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $1PyXV.Logo), {
        as: "svg",
        "aria-label": "Trello",
        fill: white,
        height: actualHeight,
        role: "img",
        viewBox: [
            0,
            0,
            intrinsicWidth,
            intrinsicHeight
        ].join(" "),
        width: actualWidth,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("linearGradient", {
                id: `trello-logo-gradient-white${id}`,
                x1: "49.999978%",
                x2: "49.999978%",
                y1: "99.983977%",
                y2: ".032046%",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "0",
                        stopColor: white,
                        stopOpacity: ".5"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: ".15",
                        stopColor: white,
                        stopOpacity: ".65"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: ".3",
                        stopColor: white,
                        stopOpacity: ".78"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: ".46",
                        stopColor: white,
                        stopOpacity: ".88"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: ".62",
                        stopColor: white,
                        stopOpacity: ".95"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: ".8",
                        stopColor: white,
                        stopOpacity: ".99"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("stop", {
                        offset: "1",
                        stopColor: white
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m55.75 0h-47.56c-4.09243 0-7.41 3.31757-7.41 7.41v47.59c0 4.09243 3.31757 7.41 7.41 7.41h47.56c4.09243 0 7.410027-3.31757 7.410027-7.41v-47.57c.0052867-1.96871715-.7730611-3.85862176-2.163282-5.25259496s-3.2780207-2.17740504-5.246745-2.17740504zm-28.1 45c0 1.3602476-1.0997635 2.4644929-2.46 2.47h-10.43c-1.3618668-.0054804-2.4645196-1.1081332-2.47-2.47v-31c.0054804-1.3618668 1.1081332-2.4645196 2.47-2.47h10.43c1.3602365.0055071 2.46 1.1097524 2.46 2.47zm24-14.21c-.0054804 1.3618668-1.1081332 2.4645196-2.47 2.47h-10.43c-1.3602365-.0055071-2.46-1.1097524-2.46-2.47v-16.79c0-1.3602476 1.0997635-2.4644929 2.46-2.47h10.43c1.3618668.0054804 2.4645196 1.1081332 2.47 2.47z",
                fill: `url(#trello-logo-gradient-white${id})`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m130.08 4.59v12.06h-14.3v45.75h-13.78v-45.75h-14.28v-12.06z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m147.62 62.4h-12.74v-45h12.74v8.62c2.41-6.07 6.28-9.67 13.17-9.23v13.32c-8.95-.7-13.17 1.5-13.17 8.71z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m230.4 62.76c-8.35 0-13.61-4.05-13.61-13.47v-49.29h12.83v47.53c0 2.73 1.81 3.7 4 3.7.631315.0130885 1.262786-.0169816 1.89-.09v11.09c-1.670462.4130783-3.39032.5914589-5.11.53z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m257.17 62.76c-8.35 0-13.6-4.05-13.6-13.47v-49.29h12.83v47.53c0 2.73 1.81 3.7 4 3.7.634638.0128631 1.269419-.0172055 1.9-.09v11.09c-1.677002.4145441-3.403668.5929326-5.13.53z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m268.47 39.88c0-13.9 8-23.41 21.78-23.41s21.61 9.53 21.61 23.41-7.92 23.58-21.61 23.58-21.78-9.77-21.78-23.58zm12.48 0c0 6.78 2.84 12.14 9.3 12.14s9.13-5.36 9.13-12.14-2.76-12-9.13-12-9.25 5.22-9.25 12z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m178 44c3.570328.3922021 7.1583.602474 10.75.63 9.75 0 18-2.62 18-12.06 0-9.17-8.47-16.07-18.66-16.07-13.72 0-22.5 10-22.5 23.85 0 14.43 7.58 23 24.71 23 5.085091.0521078 10.135127-.8466563 14.89-2.65v-10.83c-4.39 1.4-9.35 2.8-14.43 2.8-6.86 0-11.58-2.24-12.76-8.67zm9.83-17.68c3.61 0 6.51 2.45 6.51 5.8 0 4.32-4.56 5.66-9.79 5.66-2.230114-.0102442-4.456334-.1874058-6.66-.53.163357-2.1005717.762772-4.1440305 1.76-6 1.624894-3.0101722 4.749674-4.9072236 8.17-4.96z"
            })
        ]
    });
};

});



parcelRegister("6vqJG", function(module, exports) {

$parcel$export(module.exports, "Markdown", function () { return $6a6cb3cb29634830$export$7460c8b7e4ce9582; });
// @ts-nocheck

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iCJQh = parcelRequire("iCJQh");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("fyI6f");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
const $6a6cb3cb29634830$export$7460c8b7e4ce9582 = ({ children: children = "", links: links = true })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    if (!children || !children.trim()) return null;
    const content = children.replace(/&nbsp;/g, " ").replace(/&amp;nbsp;/g, " ").replace(/\u00A0/g, " ").trim();
    if (!content) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: parseMarkdown(content)
    });
    function parseMarkdown(text) {
        const lines = text.split("\n").filter((line)=>{
            const cleaned = line.replace(/&nbsp;/g, "").replace(/\u00A0/g, "").trim();
            return cleaned.length > 0;
        });
        const elements = [];
        let listItems = [];
        let listKey = 0;
        let blockquoteLines = [];
        let blockquoteKey = 0;
        const flushList = ()=>{
            if (listItems.length > 0) {
                elements.push(/*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                    children: listItems
                }, `list-${listKey++}`));
                listItems = [];
            }
        };
        const flushBlockquote = ()=>{
            if (blockquoteLines.length > 0) {
                elements.push(/*#__PURE__*/ (0, $loA2J.jsx)("blockquote", {
                    children: blockquoteLines
                }, `blockquote-${blockquoteKey++}`));
                blockquoteLines = [];
            }
        };
        lines.forEach((line, lineIndex)=>{
            const lineElements = mapLineToReactElement(line, lineIndex);
            // Check if this line is a list item
            const trimmedLine = line.trim();
            const isListItem = /^[\*\-\+]\s+/.test(trimmedLine);
            const isBlockquote = /^>\s*/.test(trimmedLine);
            if (isBlockquote) {
                // Flush any pending lists
                flushList();
                // Extract blockquote content (remove the > marker)
                const blockquoteContent = trimmedLine.replace(/^>\s*/, "");
                if (blockquoteContent) {
                    const children = parseInlineContent(blockquoteContent);
                    blockquoteLines.push(/*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: children
                    }, `bq-p-${lineIndex}`));
                }
            } else if (isListItem) {
                // Flush any pending blockquotes
                flushBlockquote();
                // Extract list item content (remove the bullet marker)
                const listContent = trimmedLine.replace(/^[\*\-\+]\s+/, "");
                const children = parseInlineContent(listContent);
                listItems.push(/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                    children: children
                }, `li-${lineIndex}`));
            } else {
                // Not a list item or blockquote, flush any pending
                flushList();
                flushBlockquote();
                elements.push(...lineElements);
            }
        });
        // Flush any remaining list items and blockquotes
        flushList();
        flushBlockquote();
        return elements;
    }
    function mapLineToReactElement(line, index) {
        const trimmedLine = line.trim();
        // Skip list items - they're handled in parseMarkdown
        if (/^[\*\-\+]\s+/.test(trimmedLine)) return [];
        // Skip blockquotes - they're handled in parseMarkdown
        if (/^>\s*/.test(trimmedLine)) return [];
        // Thematic break (e.g. ___, --- , ***)
        if (/^(?:_{3,}|\*{3,}|-{3,})$/.test(trimmedLine)) return [
            /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                role: "presentation"
            }, `hr-${index}`)
        ];
        // Check for headers
        const headerMatch = /^(#{1,6})\s+(.+)$/.exec(trimmedLine);
        if (headerMatch) {
            const level = headerMatch[1].length;
            const content = headerMatch[2];
            const children = parseInlineContent(content);
            switch(level){
                case 1:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                            children: children
                        }, `h1-${index}`)
                    ];
                case 2:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            children: children
                        }, `h2-${index}`)
                    ];
                case 3:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            children: children
                        }, `h3-${index}`)
                    ];
                case 4:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                            children: children
                        }, `h4-${index}`)
                    ];
                case 5:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                            children: children
                        }, `h5-${index}`)
                    ];
                case 6:
                    return [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h6", {
                            children: children
                        }, `h6-${index}`)
                    ];
            }
        }
        // Regular paragraph content - wrap in <p> tag for proper spacing
        const children = parseInlineContent(trimmedLine);
        return children.length > 0 ? [
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: children
            }, `p-${index}`)
        ] : [];
    }
    function parseInlineContent(text) {
        const cleaned = text.replace(/&nbsp;/g, " ").replace(/\u00A0/g, " ");
        const keyRef = {
            value: 0
        };
        return parseInlineSegment(cleaned, keyRef);
        // eslint-disable-next-line complexity
        function parseInlineSegment(segment, keyRef) {
            const nodes = [];
            let i = 0;
            let textStart = 0;
            const pushText = (end)=>{
                if (end <= textStart) return;
                const textContent = segment.slice(textStart, end);
                nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: (0, $iCJQh.decode)(textContent)
                }, `text-${keyRef.value++}`));
                textStart = end;
            };
            while(i < segment.length){
                // Handle escape sequences (e.g., \*, \[, \], etc.)
                if (segment[i] === "\\" && i + 1 < segment.length) {
                    const nextChar = segment[i + 1];
                    // Check if next character is a special markdown character
                    if ([
                        "*",
                        "_",
                        "[",
                        "]",
                        "(",
                        ")",
                        "\\"
                    ].includes(nextChar)) {
                        pushText(i);
                        // Skip the backslash and just push the escaped character
                        nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                            children: nextChar
                        }, `text-${keyRef.value++}`));
                        i += 2;
                        textStart = i;
                        continue;
                    }
                }
                // Images: ![alt](src)
                if (segment[i] === "!" && i + 1 < segment.length && segment[i + 1] === "[") {
                    const endText = segment.indexOf("]", i + 2);
                    const hasParen = endText !== -1 && segment[endText + 1] === "(";
                    if (hasParen) {
                        const endHref = segment.indexOf(")", endText + 2);
                        if (endHref !== -1) {
                            const altText = segment.slice(i + 2, endText);
                            const src = segment.slice(endText + 2, endHref);
                            pushText(i);
                            nodes.push(// eslint-disable-next-line no-restricted-syntax
                            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                src: src,
                                alt: altText
                            }, `img-${keyRef.value++}`));
                            i = endHref + 1;
                            textStart = i;
                            continue;
                        }
                    }
                }
                // Links: [text](href) or clickable images: [![alt](imgSrc)](linkHref)
                if (segment[i] === "[") {
                    // Find the matching closing bracket, accounting for nested brackets
                    let bracketCount = 1;
                    let endText = -1;
                    for(let j = i + 1; j < segment.length && bracketCount > 0; j++){
                        if (segment[j] === "[" && segment[j - 1] !== "\\") bracketCount++;
                        else if (segment[j] === "]" && segment[j - 1] !== "\\") {
                            bracketCount--;
                            if (bracketCount === 0) {
                                endText = j;
                                break;
                            }
                        }
                    }
                    const hasParen = endText !== -1 && segment[endText + 1] === "(";
                    if (hasParen) {
                        // Find the matching closing paren, accounting for nested parens
                        let parenCount = 1;
                        let endHref = -1;
                        for(let j = endText + 2; j < segment.length && parenCount > 0; j++){
                            if (segment[j] === "(" && segment[j - 1] !== "\\") parenCount++;
                            else if (segment[j] === ")" && segment[j - 1] !== "\\") {
                                parenCount--;
                                if (parenCount === 0) {
                                    endHref = j;
                                    break;
                                }
                            }
                        }
                        if (endHref !== -1) {
                            const linkText = segment.slice(i + 1, endText);
                            // Extract href and optional title (e.g., "url" or "url \"title\"")
                            const hrefContent = segment.slice(endText + 2, endHref);
                            const hrefMatch = /^([^\s"]+)(?:\s+"[^"]*")?$/.exec(hrefContent);
                            const href = hrefMatch ? hrefMatch[1] : hrefContent;
                            pushText(i);
                            // Check if linkText is an image: ![alt](src)
                            const imageMatch = /^!\[([^\]]*)\]\(([^\)]+)\)$/.exec(linkText);
                            if (imageMatch) {
                                // This is a clickable image: [![alt](imgSrc)](linkHref)
                                const altText = imageMatch[1];
                                const imgSrc = imageMatch[2];
                                if (links) nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                    href: href,
                                    onClick: ()=>sendTrackEvent("clickedAnchor", {
                                            eventContainer: "markdown",
                                            ...analyticsAttributes,
                                            event: "clicked",
                                            eventComponent: "link",
                                            href: href,
                                            label: altText
                                        }),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                        src: imgSrc,
                                        alt: altText
                                    })
                                }, `link-${keyRef.value++}`));
                                else nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: href,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                                        src: imgSrc,
                                        alt: altText
                                    })
                                }, `link-${keyRef.value++}`));
                            } else {
                                // Regular link with text
                                const linkChildren = parseInlineSegment(linkText, keyRef);
                                if (links) nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                    href: href,
                                    onClick: ()=>sendTrackEvent("clickedAnchor", {
                                            eventContainer: "markdown",
                                            ...analyticsAttributes,
                                            event: "clicked",
                                            eventComponent: "link",
                                            href: href,
                                            label: linkText
                                        }),
                                    children: linkChildren
                                }, `link-${keyRef.value++}`));
                                else nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: href,
                                    children: linkChildren
                                }, `link-${keyRef.value++}`));
                            }
                            i = endHref + 1;
                            textStart = i;
                            continue;
                        }
                    }
                }
                // Strikethrough: ~~text~~
                if (segment.startsWith("~~", i)) {
                    const closeIndex = segment.indexOf("~~", i + 2);
                    if (closeIndex !== -1) {
                        const inner = segment.slice(i + 2, closeIndex);
                        if (inner.length > 0) {
                            pushText(i);
                            nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)("del", {
                                children: parseInlineSegment(inner, keyRef)
                            }, `del-${keyRef.value++}`));
                            i = closeIndex + 2;
                            textStart = i;
                            continue;
                        }
                    }
                }
                // Bold: **text** or __text__
                const hasStrongMarker = segment.startsWith("**", i) || segment.startsWith("__", i);
                if (hasStrongMarker) {
                    const marker = segment.slice(i, i + 2);
                    const closeIndex = segment.indexOf(marker, i + 2);
                    if (closeIndex !== -1) {
                        const inner = segment.slice(i + 2, closeIndex);
                        if (inner.length > 0) {
                            pushText(i);
                            nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                                children: parseInlineSegment(inner, keyRef)
                            }, `strong-${keyRef.value++}`));
                            i = closeIndex + 2;
                            textStart = i;
                            continue;
                        }
                    }
                }
                // Italic/Emphasis: *text* or _text_
                // Check for single * or _ (but not ** or __)
                const hasEmMarker = segment[i] === "*" && segment[i + 1] !== "*" || segment[i] === "_" && segment[i + 1] !== "_";
                if (hasEmMarker) {
                    const marker = segment[i];
                    const closeIndex = segment.indexOf(marker, i + 1);
                    if (closeIndex !== -1 && segment[i + 1] !== marker && segment[closeIndex + 1] !== marker) {
                        const inner = segment.slice(i + 1, closeIndex);
                        if (inner.length > 0 && !inner.includes("\n")) {
                            pushText(i);
                            nodes.push(/*#__PURE__*/ (0, $loA2J.jsx)("em", {
                                children: parseInlineSegment(inner, keyRef)
                            }, `em-${keyRef.value++}`));
                            i = closeIndex + 1;
                            textStart = i;
                            continue;
                        }
                    }
                }
                i++;
            }
            pushText(segment.length);
            return nodes;
        }
    }
};

});
parcelRegister("iCJQh", function(module, exports) {
(function(root) {
    // Detect free variables `exports`.
    var freeExports = exports;
    // Detect free variable `module`.
    var freeModule = module && module.exports == freeExports && module;
    // Detect free variable `global`, from Node.js or Browserified code,
    // and use it as `root`.
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) root = freeGlobal;
    /*--------------------------------------------------------------------------*/ // All astral symbols.
    var regexAstralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    // All ASCII symbols (not just printable ASCII) except those listed in the
    // first column of the overrides table.
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides
    var regexAsciiWhitelist = /[\x01-\x7F]/g;
    // All BMP symbols that are not ASCII newlines, printable ASCII symbols, or
    // code points listed in the first column of the overrides table on
    // https://html.spec.whatwg.org/multipage/syntax.html#table-charref-overrides.
    var regexBmpWhitelist = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
    var regexEncodeNonAscii = /<\u20D2|=\u20E5|>\u20D2|\u205F\u200A|\u219D\u0338|\u2202\u0338|\u2220\u20D2|\u2229\uFE00|\u222A\uFE00|\u223C\u20D2|\u223D\u0331|\u223E\u0333|\u2242\u0338|\u224B\u0338|\u224D\u20D2|\u224E\u0338|\u224F\u0338|\u2250\u0338|\u2261\u20E5|\u2264\u20D2|\u2265\u20D2|\u2266\u0338|\u2267\u0338|\u2268\uFE00|\u2269\uFE00|\u226A\u0338|\u226A\u20D2|\u226B\u0338|\u226B\u20D2|\u227F\u0338|\u2282\u20D2|\u2283\u20D2|\u228A\uFE00|\u228B\uFE00|\u228F\u0338|\u2290\u0338|\u2293\uFE00|\u2294\uFE00|\u22B4\u20D2|\u22B5\u20D2|\u22D8\u0338|\u22D9\u0338|\u22DA\uFE00|\u22DB\uFE00|\u22F5\u0338|\u22F9\u0338|\u2933\u0338|\u29CF\u0338|\u29D0\u0338|\u2A6D\u0338|\u2A70\u0338|\u2A7D\u0338|\u2A7E\u0338|\u2AA1\u0338|\u2AA2\u0338|\u2AAC\uFE00|\u2AAD\uFE00|\u2AAF\u0338|\u2AB0\u0338|\u2AC5\u0338|\u2AC6\u0338|\u2ACB\uFE00|\u2ACC\uFE00|\u2AFD\u20E5|[\xA0-\u0113\u0116-\u0122\u0124-\u012B\u012E-\u014D\u0150-\u017E\u0192\u01B5\u01F5\u0237\u02C6\u02C7\u02D8-\u02DD\u0311\u0391-\u03A1\u03A3-\u03A9\u03B1-\u03C9\u03D1\u03D2\u03D5\u03D6\u03DC\u03DD\u03F0\u03F1\u03F5\u03F6\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E\u045F\u2002-\u2005\u2007-\u2010\u2013-\u2016\u2018-\u201A\u201C-\u201E\u2020-\u2022\u2025\u2026\u2030-\u2035\u2039\u203A\u203E\u2041\u2043\u2044\u204F\u2057\u205F-\u2063\u20AC\u20DB\u20DC\u2102\u2105\u210A-\u2113\u2115-\u211E\u2122\u2124\u2127-\u2129\u212C\u212D\u212F-\u2131\u2133-\u2138\u2145-\u2148\u2153-\u215E\u2190-\u219B\u219D-\u21A7\u21A9-\u21AE\u21B0-\u21B3\u21B5-\u21B7\u21BA-\u21DB\u21DD\u21E4\u21E5\u21F5\u21FD-\u2205\u2207-\u2209\u220B\u220C\u220F-\u2214\u2216-\u2218\u221A\u221D-\u2238\u223A-\u2257\u2259\u225A\u225C\u225F-\u2262\u2264-\u228B\u228D-\u229B\u229D-\u22A5\u22A7-\u22B0\u22B2-\u22BB\u22BD-\u22DB\u22DE-\u22E3\u22E6-\u22F7\u22F9-\u22FE\u2305\u2306\u2308-\u2310\u2312\u2313\u2315\u2316\u231C-\u231F\u2322\u2323\u232D\u232E\u2336\u233D\u233F\u237C\u23B0\u23B1\u23B4-\u23B6\u23DC-\u23DF\u23E2\u23E7\u2423\u24C8\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2550-\u256C\u2580\u2584\u2588\u2591-\u2593\u25A1\u25AA\u25AB\u25AD\u25AE\u25B1\u25B3-\u25B5\u25B8\u25B9\u25BD-\u25BF\u25C2\u25C3\u25CA\u25CB\u25EC\u25EF\u25F8-\u25FC\u2605\u2606\u260E\u2640\u2642\u2660\u2663\u2665\u2666\u266A\u266D-\u266F\u2713\u2717\u2720\u2736\u2758\u2772\u2773\u27C8\u27C9\u27E6-\u27ED\u27F5-\u27FA\u27FC\u27FF\u2902-\u2905\u290C-\u2913\u2916\u2919-\u2920\u2923-\u292A\u2933\u2935-\u2939\u293C\u293D\u2945\u2948-\u294B\u294E-\u2976\u2978\u2979\u297B-\u297F\u2985\u2986\u298B-\u2996\u299A\u299C\u299D\u29A4-\u29B7\u29B9\u29BB\u29BC\u29BE-\u29C5\u29C9\u29CD-\u29D0\u29DC-\u29DE\u29E3-\u29E5\u29EB\u29F4\u29F6\u2A00-\u2A02\u2A04\u2A06\u2A0C\u2A0D\u2A10-\u2A17\u2A22-\u2A27\u2A29\u2A2A\u2A2D-\u2A31\u2A33-\u2A3C\u2A3F\u2A40\u2A42-\u2A4D\u2A50\u2A53-\u2A58\u2A5A-\u2A5D\u2A5F\u2A66\u2A6A\u2A6D-\u2A75\u2A77-\u2A9A\u2A9D-\u2AA2\u2AA4-\u2AB0\u2AB3-\u2AC8\u2ACB\u2ACC\u2ACF-\u2ADB\u2AE4\u2AE6-\u2AE9\u2AEB-\u2AF3\u2AFD\uFB00-\uFB04]|\uD835[\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDD6B]/g;
    var encodeMap = {
        "\xad": "shy",
        "\u200C": "zwnj",
        "\u200D": "zwj",
        "\u200E": "lrm",
        "\u2063": "ic",
        "\u2062": "it",
        "\u2061": "af",
        "\u200F": "rlm",
        "\u200B": "ZeroWidthSpace",
        "\u2060": "NoBreak",
        "\u0311": "DownBreve",
        "\u20DB": "tdot",
        "\u20DC": "DotDot",
        "	": "Tab",
        "\n": "NewLine",
        "\u2008": "puncsp",
        "\u205F": "MediumSpace",
        "\u2009": "thinsp",
        "\u200A": "hairsp",
        "\u2004": "emsp13",
        "\u2002": "ensp",
        "\u2005": "emsp14",
        "\u2003": "emsp",
        "\u2007": "numsp",
        "\xa0": "nbsp",
        "\u205F\u200A": "ThickSpace",
        "\u203E": "oline",
        "_": "lowbar",
        "\u2010": "dash",
        "\u2013": "ndash",
        "\u2014": "mdash",
        "\u2015": "horbar",
        ",": "comma",
        ";": "semi",
        "\u204F": "bsemi",
        ":": "colon",
        "\u2A74": "Colone",
        "!": "excl",
        "\xa1": "iexcl",
        "?": "quest",
        "\xbf": "iquest",
        ".": "period",
        "\u2025": "nldr",
        "\u2026": "mldr",
        "\xb7": "middot",
        "'": "apos",
        "\u2018": "lsquo",
        "\u2019": "rsquo",
        "\u201A": "sbquo",
        "\u2039": "lsaquo",
        "\u203A": "rsaquo",
        '"': "quot",
        "\u201C": "ldquo",
        "\u201D": "rdquo",
        "\u201E": "bdquo",
        "\xab": "laquo",
        "\xbb": "raquo",
        "(": "lpar",
        ")": "rpar",
        "[": "lsqb",
        "]": "rsqb",
        "{": "lcub",
        "}": "rcub",
        "\u2308": "lceil",
        "\u2309": "rceil",
        "\u230A": "lfloor",
        "\u230B": "rfloor",
        "\u2985": "lopar",
        "\u2986": "ropar",
        "\u298B": "lbrke",
        "\u298C": "rbrke",
        "\u298D": "lbrkslu",
        "\u298E": "rbrksld",
        "\u298F": "lbrksld",
        "\u2990": "rbrkslu",
        "\u2991": "langd",
        "\u2992": "rangd",
        "\u2993": "lparlt",
        "\u2994": "rpargt",
        "\u2995": "gtlPar",
        "\u2996": "ltrPar",
        "\u27E6": "lobrk",
        "\u27E7": "robrk",
        "\u27E8": "lang",
        "\u27E9": "rang",
        "\u27EA": "Lang",
        "\u27EB": "Rang",
        "\u27EC": "loang",
        "\u27ED": "roang",
        "\u2772": "lbbrk",
        "\u2773": "rbbrk",
        "\u2016": "Vert",
        "\xa7": "sect",
        "\xb6": "para",
        "@": "commat",
        "*": "ast",
        "/": "sol",
        "undefined": null,
        "&": "amp",
        "#": "num",
        "%": "percnt",
        "\u2030": "permil",
        "\u2031": "pertenk",
        "\u2020": "dagger",
        "\u2021": "Dagger",
        "\u2022": "bull",
        "\u2043": "hybull",
        "\u2032": "prime",
        "\u2033": "Prime",
        "\u2034": "tprime",
        "\u2057": "qprime",
        "\u2035": "bprime",
        "\u2041": "caret",
        "`": "grave",
        "\xb4": "acute",
        "\u02DC": "tilde",
        "^": "Hat",
        "\xaf": "macr",
        "\u02D8": "breve",
        "\u02D9": "dot",
        "\xa8": "die",
        "\u02DA": "ring",
        "\u02DD": "dblac",
        "\xb8": "cedil",
        "\u02DB": "ogon",
        "\u02C6": "circ",
        "\u02C7": "caron",
        "\xb0": "deg",
        "\xa9": "copy",
        "\xae": "reg",
        "\u2117": "copysr",
        "\u2118": "wp",
        "\u211E": "rx",
        "\u2127": "mho",
        "\u2129": "iiota",
        "\u2190": "larr",
        "\u219A": "nlarr",
        "\u2192": "rarr",
        "\u219B": "nrarr",
        "\u2191": "uarr",
        "\u2193": "darr",
        "\u2194": "harr",
        "\u21AE": "nharr",
        "\u2195": "varr",
        "\u2196": "nwarr",
        "\u2197": "nearr",
        "\u2198": "searr",
        "\u2199": "swarr",
        "\u219D": "rarrw",
        "\u219D\u0338": "nrarrw",
        "\u219E": "Larr",
        "\u219F": "Uarr",
        "\u21A0": "Rarr",
        "\u21A1": "Darr",
        "\u21A2": "larrtl",
        "\u21A3": "rarrtl",
        "\u21A4": "mapstoleft",
        "\u21A5": "mapstoup",
        "\u21A6": "map",
        "\u21A7": "mapstodown",
        "\u21A9": "larrhk",
        "\u21AA": "rarrhk",
        "\u21AB": "larrlp",
        "\u21AC": "rarrlp",
        "\u21AD": "harrw",
        "\u21B0": "lsh",
        "\u21B1": "rsh",
        "\u21B2": "ldsh",
        "\u21B3": "rdsh",
        "\u21B5": "crarr",
        "\u21B6": "cularr",
        "\u21B7": "curarr",
        "\u21BA": "olarr",
        "\u21BB": "orarr",
        "\u21BC": "lharu",
        "\u21BD": "lhard",
        "\u21BE": "uharr",
        "\u21BF": "uharl",
        "\u21C0": "rharu",
        "\u21C1": "rhard",
        "\u21C2": "dharr",
        "\u21C3": "dharl",
        "\u21C4": "rlarr",
        "\u21C5": "udarr",
        "\u21C6": "lrarr",
        "\u21C7": "llarr",
        "\u21C8": "uuarr",
        "\u21C9": "rrarr",
        "\u21CA": "ddarr",
        "\u21CB": "lrhar",
        "\u21CC": "rlhar",
        "\u21D0": "lArr",
        "\u21CD": "nlArr",
        "\u21D1": "uArr",
        "\u21D2": "rArr",
        "\u21CF": "nrArr",
        "\u21D3": "dArr",
        "\u21D4": "iff",
        "\u21CE": "nhArr",
        "\u21D5": "vArr",
        "\u21D6": "nwArr",
        "\u21D7": "neArr",
        "\u21D8": "seArr",
        "\u21D9": "swArr",
        "\u21DA": "lAarr",
        "\u21DB": "rAarr",
        "\u21DD": "zigrarr",
        "\u21E4": "larrb",
        "\u21E5": "rarrb",
        "\u21F5": "duarr",
        "\u21FD": "loarr",
        "\u21FE": "roarr",
        "\u21FF": "hoarr",
        "\u2200": "forall",
        "\u2201": "comp",
        "\u2202": "part",
        "\u2202\u0338": "npart",
        "\u2203": "exist",
        "\u2204": "nexist",
        "\u2205": "empty",
        "\u2207": "Del",
        "\u2208": "in",
        "\u2209": "notin",
        "\u220B": "ni",
        "\u220C": "notni",
        "\u03F6": "bepsi",
        "\u220F": "prod",
        "\u2210": "coprod",
        "\u2211": "sum",
        "+": "plus",
        "\xb1": "pm",
        "\xf7": "div",
        "\xd7": "times",
        "<": "lt",
        "\u226E": "nlt",
        "<\u20D2": "nvlt",
        "=": "equals",
        "\u2260": "ne",
        "=\u20E5": "bne",
        "\u2A75": "Equal",
        ">": "gt",
        "\u226F": "ngt",
        ">\u20D2": "nvgt",
        "\xac": "not",
        "|": "vert",
        "\xa6": "brvbar",
        "\u2212": "minus",
        "\u2213": "mp",
        "\u2214": "plusdo",
        "\u2044": "frasl",
        "\u2216": "setmn",
        "\u2217": "lowast",
        "\u2218": "compfn",
        "\u221A": "Sqrt",
        "\u221D": "prop",
        "\u221E": "infin",
        "\u221F": "angrt",
        "\u2220": "ang",
        "\u2220\u20D2": "nang",
        "\u2221": "angmsd",
        "\u2222": "angsph",
        "\u2223": "mid",
        "\u2224": "nmid",
        "\u2225": "par",
        "\u2226": "npar",
        "\u2227": "and",
        "\u2228": "or",
        "\u2229": "cap",
        "\u2229\uFE00": "caps",
        "\u222A": "cup",
        "\u222A\uFE00": "cups",
        "\u222B": "int",
        "\u222C": "Int",
        "\u222D": "tint",
        "\u2A0C": "qint",
        "\u222E": "oint",
        "\u222F": "Conint",
        "\u2230": "Cconint",
        "\u2231": "cwint",
        "\u2232": "cwconint",
        "\u2233": "awconint",
        "\u2234": "there4",
        "\u2235": "becaus",
        "\u2236": "ratio",
        "\u2237": "Colon",
        "\u2238": "minusd",
        "\u223A": "mDDot",
        "\u223B": "homtht",
        "\u223C": "sim",
        "\u2241": "nsim",
        "\u223C\u20D2": "nvsim",
        "\u223D": "bsim",
        "\u223D\u0331": "race",
        "\u223E": "ac",
        "\u223E\u0333": "acE",
        "\u223F": "acd",
        "\u2240": "wr",
        "\u2242": "esim",
        "\u2242\u0338": "nesim",
        "\u2243": "sime",
        "\u2244": "nsime",
        "\u2245": "cong",
        "\u2247": "ncong",
        "\u2246": "simne",
        "\u2248": "ap",
        "\u2249": "nap",
        "\u224A": "ape",
        "\u224B": "apid",
        "\u224B\u0338": "napid",
        "\u224C": "bcong",
        "\u224D": "CupCap",
        "\u226D": "NotCupCap",
        "\u224D\u20D2": "nvap",
        "\u224E": "bump",
        "\u224E\u0338": "nbump",
        "\u224F": "bumpe",
        "\u224F\u0338": "nbumpe",
        "\u2250": "doteq",
        "\u2250\u0338": "nedot",
        "\u2251": "eDot",
        "\u2252": "efDot",
        "\u2253": "erDot",
        "\u2254": "colone",
        "\u2255": "ecolon",
        "\u2256": "ecir",
        "\u2257": "cire",
        "\u2259": "wedgeq",
        "\u225A": "veeeq",
        "\u225C": "trie",
        "\u225F": "equest",
        "\u2261": "equiv",
        "\u2262": "nequiv",
        "\u2261\u20E5": "bnequiv",
        "\u2264": "le",
        "\u2270": "nle",
        "\u2264\u20D2": "nvle",
        "\u2265": "ge",
        "\u2271": "nge",
        "\u2265\u20D2": "nvge",
        "\u2266": "lE",
        "\u2266\u0338": "nlE",
        "\u2267": "gE",
        "\u2267\u0338": "ngE",
        "\u2268\uFE00": "lvnE",
        "\u2268": "lnE",
        "\u2269": "gnE",
        "\u2269\uFE00": "gvnE",
        "\u226A": "ll",
        "\u226A\u0338": "nLtv",
        "\u226A\u20D2": "nLt",
        "\u226B": "gg",
        "\u226B\u0338": "nGtv",
        "\u226B\u20D2": "nGt",
        "\u226C": "twixt",
        "\u2272": "lsim",
        "\u2274": "nlsim",
        "\u2273": "gsim",
        "\u2275": "ngsim",
        "\u2276": "lg",
        "\u2278": "ntlg",
        "\u2277": "gl",
        "\u2279": "ntgl",
        "\u227A": "pr",
        "\u2280": "npr",
        "\u227B": "sc",
        "\u2281": "nsc",
        "\u227C": "prcue",
        "\u22E0": "nprcue",
        "\u227D": "sccue",
        "\u22E1": "nsccue",
        "\u227E": "prsim",
        "\u227F": "scsim",
        "\u227F\u0338": "NotSucceedsTilde",
        "\u2282": "sub",
        "\u2284": "nsub",
        "\u2282\u20D2": "vnsub",
        "\u2283": "sup",
        "\u2285": "nsup",
        "\u2283\u20D2": "vnsup",
        "\u2286": "sube",
        "\u2288": "nsube",
        "\u2287": "supe",
        "\u2289": "nsupe",
        "\u228A\uFE00": "vsubne",
        "\u228A": "subne",
        "\u228B\uFE00": "vsupne",
        "\u228B": "supne",
        "\u228D": "cupdot",
        "\u228E": "uplus",
        "\u228F": "sqsub",
        "\u228F\u0338": "NotSquareSubset",
        "\u2290": "sqsup",
        "\u2290\u0338": "NotSquareSuperset",
        "\u2291": "sqsube",
        "\u22E2": "nsqsube",
        "\u2292": "sqsupe",
        "\u22E3": "nsqsupe",
        "\u2293": "sqcap",
        "\u2293\uFE00": "sqcaps",
        "\u2294": "sqcup",
        "\u2294\uFE00": "sqcups",
        "\u2295": "oplus",
        "\u2296": "ominus",
        "\u2297": "otimes",
        "\u2298": "osol",
        "\u2299": "odot",
        "\u229A": "ocir",
        "\u229B": "oast",
        "\u229D": "odash",
        "\u229E": "plusb",
        "\u229F": "minusb",
        "\u22A0": "timesb",
        "\u22A1": "sdotb",
        "\u22A2": "vdash",
        "\u22AC": "nvdash",
        "\u22A3": "dashv",
        "\u22A4": "top",
        "\u22A5": "bot",
        "\u22A7": "models",
        "\u22A8": "vDash",
        "\u22AD": "nvDash",
        "\u22A9": "Vdash",
        "\u22AE": "nVdash",
        "\u22AA": "Vvdash",
        "\u22AB": "VDash",
        "\u22AF": "nVDash",
        "\u22B0": "prurel",
        "\u22B2": "vltri",
        "\u22EA": "nltri",
        "\u22B3": "vrtri",
        "\u22EB": "nrtri",
        "\u22B4": "ltrie",
        "\u22EC": "nltrie",
        "\u22B4\u20D2": "nvltrie",
        "\u22B5": "rtrie",
        "\u22ED": "nrtrie",
        "\u22B5\u20D2": "nvrtrie",
        "\u22B6": "origof",
        "\u22B7": "imof",
        "\u22B8": "mumap",
        "\u22B9": "hercon",
        "\u22BA": "intcal",
        "\u22BB": "veebar",
        "\u22BD": "barvee",
        "\u22BE": "angrtvb",
        "\u22BF": "lrtri",
        "\u22C0": "Wedge",
        "\u22C1": "Vee",
        "\u22C2": "xcap",
        "\u22C3": "xcup",
        "\u22C4": "diam",
        "\u22C5": "sdot",
        "\u22C6": "Star",
        "\u22C7": "divonx",
        "\u22C8": "bowtie",
        "\u22C9": "ltimes",
        "\u22CA": "rtimes",
        "\u22CB": "lthree",
        "\u22CC": "rthree",
        "\u22CD": "bsime",
        "\u22CE": "cuvee",
        "\u22CF": "cuwed",
        "\u22D0": "Sub",
        "\u22D1": "Sup",
        "\u22D2": "Cap",
        "\u22D3": "Cup",
        "\u22D4": "fork",
        "\u22D5": "epar",
        "\u22D6": "ltdot",
        "\u22D7": "gtdot",
        "\u22D8": "Ll",
        "\u22D8\u0338": "nLl",
        "\u22D9": "Gg",
        "\u22D9\u0338": "nGg",
        "\u22DA\uFE00": "lesg",
        "\u22DA": "leg",
        "\u22DB": "gel",
        "\u22DB\uFE00": "gesl",
        "\u22DE": "cuepr",
        "\u22DF": "cuesc",
        "\u22E6": "lnsim",
        "\u22E7": "gnsim",
        "\u22E8": "prnsim",
        "\u22E9": "scnsim",
        "\u22EE": "vellip",
        "\u22EF": "ctdot",
        "\u22F0": "utdot",
        "\u22F1": "dtdot",
        "\u22F2": "disin",
        "\u22F3": "isinsv",
        "\u22F4": "isins",
        "\u22F5": "isindot",
        "\u22F5\u0338": "notindot",
        "\u22F6": "notinvc",
        "\u22F7": "notinvb",
        "\u22F9": "isinE",
        "\u22F9\u0338": "notinE",
        "\u22FA": "nisd",
        "\u22FB": "xnis",
        "\u22FC": "nis",
        "\u22FD": "notnivc",
        "\u22FE": "notnivb",
        "\u2305": "barwed",
        "\u2306": "Barwed",
        "\u230C": "drcrop",
        "\u230D": "dlcrop",
        "\u230E": "urcrop",
        "\u230F": "ulcrop",
        "\u2310": "bnot",
        "\u2312": "profline",
        "\u2313": "profsurf",
        "\u2315": "telrec",
        "\u2316": "target",
        "\u231C": "ulcorn",
        "\u231D": "urcorn",
        "\u231E": "dlcorn",
        "\u231F": "drcorn",
        "\u2322": "frown",
        "\u2323": "smile",
        "\u232D": "cylcty",
        "\u232E": "profalar",
        "\u2336": "topbot",
        "\u233D": "ovbar",
        "\u233F": "solbar",
        "\u237C": "angzarr",
        "\u23B0": "lmoust",
        "\u23B1": "rmoust",
        "\u23B4": "tbrk",
        "\u23B5": "bbrk",
        "\u23B6": "bbrktbrk",
        "\u23DC": "OverParenthesis",
        "\u23DD": "UnderParenthesis",
        "\u23DE": "OverBrace",
        "\u23DF": "UnderBrace",
        "\u23E2": "trpezium",
        "\u23E7": "elinters",
        "\u2423": "blank",
        "\u2500": "boxh",
        "\u2502": "boxv",
        "\u250C": "boxdr",
        "\u2510": "boxdl",
        "\u2514": "boxur",
        "\u2518": "boxul",
        "\u251C": "boxvr",
        "\u2524": "boxvl",
        "\u252C": "boxhd",
        "\u2534": "boxhu",
        "\u253C": "boxvh",
        "\u2550": "boxH",
        "\u2551": "boxV",
        "\u2552": "boxdR",
        "\u2553": "boxDr",
        "\u2554": "boxDR",
        "\u2555": "boxdL",
        "\u2556": "boxDl",
        "\u2557": "boxDL",
        "\u2558": "boxuR",
        "\u2559": "boxUr",
        "\u255A": "boxUR",
        "\u255B": "boxuL",
        "\u255C": "boxUl",
        "\u255D": "boxUL",
        "\u255E": "boxvR",
        "\u255F": "boxVr",
        "\u2560": "boxVR",
        "\u2561": "boxvL",
        "\u2562": "boxVl",
        "\u2563": "boxVL",
        "\u2564": "boxHd",
        "\u2565": "boxhD",
        "\u2566": "boxHD",
        "\u2567": "boxHu",
        "\u2568": "boxhU",
        "\u2569": "boxHU",
        "\u256A": "boxvH",
        "\u256B": "boxVh",
        "\u256C": "boxVH",
        "\u2580": "uhblk",
        "\u2584": "lhblk",
        "\u2588": "block",
        "\u2591": "blk14",
        "\u2592": "blk12",
        "\u2593": "blk34",
        "\u25A1": "squ",
        "\u25AA": "squf",
        "\u25AB": "EmptyVerySmallSquare",
        "\u25AD": "rect",
        "\u25AE": "marker",
        "\u25B1": "fltns",
        "\u25B3": "xutri",
        "\u25B4": "utrif",
        "\u25B5": "utri",
        "\u25B8": "rtrif",
        "\u25B9": "rtri",
        "\u25BD": "xdtri",
        "\u25BE": "dtrif",
        "\u25BF": "dtri",
        "\u25C2": "ltrif",
        "\u25C3": "ltri",
        "\u25CA": "loz",
        "\u25CB": "cir",
        "\u25EC": "tridot",
        "\u25EF": "xcirc",
        "\u25F8": "ultri",
        "\u25F9": "urtri",
        "\u25FA": "lltri",
        "\u25FB": "EmptySmallSquare",
        "\u25FC": "FilledSmallSquare",
        "\u2605": "starf",
        "\u2606": "star",
        "\u260E": "phone",
        "\u2640": "female",
        "\u2642": "male",
        "\u2660": "spades",
        "\u2663": "clubs",
        "\u2665": "hearts",
        "\u2666": "diams",
        "\u266A": "sung",
        "\u2713": "check",
        "\u2717": "cross",
        "\u2720": "malt",
        "\u2736": "sext",
        "\u2758": "VerticalSeparator",
        "\u27C8": "bsolhsub",
        "\u27C9": "suphsol",
        "\u27F5": "xlarr",
        "\u27F6": "xrarr",
        "\u27F7": "xharr",
        "\u27F8": "xlArr",
        "\u27F9": "xrArr",
        "\u27FA": "xhArr",
        "\u27FC": "xmap",
        "\u27FF": "dzigrarr",
        "\u2902": "nvlArr",
        "\u2903": "nvrArr",
        "\u2904": "nvHarr",
        "\u2905": "Map",
        "\u290C": "lbarr",
        "\u290D": "rbarr",
        "\u290E": "lBarr",
        "\u290F": "rBarr",
        "\u2910": "RBarr",
        "\u2911": "DDotrahd",
        "\u2912": "UpArrowBar",
        "\u2913": "DownArrowBar",
        "\u2916": "Rarrtl",
        "\u2919": "latail",
        "\u291A": "ratail",
        "\u291B": "lAtail",
        "\u291C": "rAtail",
        "\u291D": "larrfs",
        "\u291E": "rarrfs",
        "\u291F": "larrbfs",
        "\u2920": "rarrbfs",
        "\u2923": "nwarhk",
        "\u2924": "nearhk",
        "\u2925": "searhk",
        "\u2926": "swarhk",
        "\u2927": "nwnear",
        "\u2928": "toea",
        "\u2929": "tosa",
        "\u292A": "swnwar",
        "\u2933": "rarrc",
        "\u2933\u0338": "nrarrc",
        "\u2935": "cudarrr",
        "\u2936": "ldca",
        "\u2937": "rdca",
        "\u2938": "cudarrl",
        "\u2939": "larrpl",
        "\u293C": "curarrm",
        "\u293D": "cularrp",
        "\u2945": "rarrpl",
        "\u2948": "harrcir",
        "\u2949": "Uarrocir",
        "\u294A": "lurdshar",
        "\u294B": "ldrushar",
        "\u294E": "LeftRightVector",
        "\u294F": "RightUpDownVector",
        "\u2950": "DownLeftRightVector",
        "\u2951": "LeftUpDownVector",
        "\u2952": "LeftVectorBar",
        "\u2953": "RightVectorBar",
        "\u2954": "RightUpVectorBar",
        "\u2955": "RightDownVectorBar",
        "\u2956": "DownLeftVectorBar",
        "\u2957": "DownRightVectorBar",
        "\u2958": "LeftUpVectorBar",
        "\u2959": "LeftDownVectorBar",
        "\u295A": "LeftTeeVector",
        "\u295B": "RightTeeVector",
        "\u295C": "RightUpTeeVector",
        "\u295D": "RightDownTeeVector",
        "\u295E": "DownLeftTeeVector",
        "\u295F": "DownRightTeeVector",
        "\u2960": "LeftUpTeeVector",
        "\u2961": "LeftDownTeeVector",
        "\u2962": "lHar",
        "\u2963": "uHar",
        "\u2964": "rHar",
        "\u2965": "dHar",
        "\u2966": "luruhar",
        "\u2967": "ldrdhar",
        "\u2968": "ruluhar",
        "\u2969": "rdldhar",
        "\u296A": "lharul",
        "\u296B": "llhard",
        "\u296C": "rharul",
        "\u296D": "lrhard",
        "\u296E": "udhar",
        "\u296F": "duhar",
        "\u2970": "RoundImplies",
        "\u2971": "erarr",
        "\u2972": "simrarr",
        "\u2973": "larrsim",
        "\u2974": "rarrsim",
        "\u2975": "rarrap",
        "\u2976": "ltlarr",
        "\u2978": "gtrarr",
        "\u2979": "subrarr",
        "\u297B": "suplarr",
        "\u297C": "lfisht",
        "\u297D": "rfisht",
        "\u297E": "ufisht",
        "\u297F": "dfisht",
        "\u299A": "vzigzag",
        "\u299C": "vangrt",
        "\u299D": "angrtvbd",
        "\u29A4": "ange",
        "\u29A5": "range",
        "\u29A6": "dwangle",
        "\u29A7": "uwangle",
        "\u29A8": "angmsdaa",
        "\u29A9": "angmsdab",
        "\u29AA": "angmsdac",
        "\u29AB": "angmsdad",
        "\u29AC": "angmsdae",
        "\u29AD": "angmsdaf",
        "\u29AE": "angmsdag",
        "\u29AF": "angmsdah",
        "\u29B0": "bemptyv",
        "\u29B1": "demptyv",
        "\u29B2": "cemptyv",
        "\u29B3": "raemptyv",
        "\u29B4": "laemptyv",
        "\u29B5": "ohbar",
        "\u29B6": "omid",
        "\u29B7": "opar",
        "\u29B9": "operp",
        "\u29BB": "olcross",
        "\u29BC": "odsold",
        "\u29BE": "olcir",
        "\u29BF": "ofcir",
        "\u29C0": "olt",
        "\u29C1": "ogt",
        "\u29C2": "cirscir",
        "\u29C3": "cirE",
        "\u29C4": "solb",
        "\u29C5": "bsolb",
        "\u29C9": "boxbox",
        "\u29CD": "trisb",
        "\u29CE": "rtriltri",
        "\u29CF": "LeftTriangleBar",
        "\u29CF\u0338": "NotLeftTriangleBar",
        "\u29D0": "RightTriangleBar",
        "\u29D0\u0338": "NotRightTriangleBar",
        "\u29DC": "iinfin",
        "\u29DD": "infintie",
        "\u29DE": "nvinfin",
        "\u29E3": "eparsl",
        "\u29E4": "smeparsl",
        "\u29E5": "eqvparsl",
        "\u29EB": "lozf",
        "\u29F4": "RuleDelayed",
        "\u29F6": "dsol",
        "\u2A00": "xodot",
        "\u2A01": "xoplus",
        "\u2A02": "xotime",
        "\u2A04": "xuplus",
        "\u2A06": "xsqcup",
        "\u2A0D": "fpartint",
        "\u2A10": "cirfnint",
        "\u2A11": "awint",
        "\u2A12": "rppolint",
        "\u2A13": "scpolint",
        "\u2A14": "npolint",
        "\u2A15": "pointint",
        "\u2A16": "quatint",
        "\u2A17": "intlarhk",
        "\u2A22": "pluscir",
        "\u2A23": "plusacir",
        "\u2A24": "simplus",
        "\u2A25": "plusdu",
        "\u2A26": "plussim",
        "\u2A27": "plustwo",
        "\u2A29": "mcomma",
        "\u2A2A": "minusdu",
        "\u2A2D": "loplus",
        "\u2A2E": "roplus",
        "\u2A2F": "Cross",
        "\u2A30": "timesd",
        "\u2A31": "timesbar",
        "\u2A33": "smashp",
        "\u2A34": "lotimes",
        "\u2A35": "rotimes",
        "\u2A36": "otimesas",
        "\u2A37": "Otimes",
        "\u2A38": "odiv",
        "\u2A39": "triplus",
        "\u2A3A": "triminus",
        "\u2A3B": "tritime",
        "\u2A3C": "iprod",
        "\u2A3F": "amalg",
        "\u2A40": "capdot",
        "\u2A42": "ncup",
        "\u2A43": "ncap",
        "\u2A44": "capand",
        "\u2A45": "cupor",
        "\u2A46": "cupcap",
        "\u2A47": "capcup",
        "\u2A48": "cupbrcap",
        "\u2A49": "capbrcup",
        "\u2A4A": "cupcup",
        "\u2A4B": "capcap",
        "\u2A4C": "ccups",
        "\u2A4D": "ccaps",
        "\u2A50": "ccupssm",
        "\u2A53": "And",
        "\u2A54": "Or",
        "\u2A55": "andand",
        "\u2A56": "oror",
        "\u2A57": "orslope",
        "\u2A58": "andslope",
        "\u2A5A": "andv",
        "\u2A5B": "orv",
        "\u2A5C": "andd",
        "\u2A5D": "ord",
        "\u2A5F": "wedbar",
        "\u2A66": "sdote",
        "\u2A6A": "simdot",
        "\u2A6D": "congdot",
        "\u2A6D\u0338": "ncongdot",
        "\u2A6E": "easter",
        "\u2A6F": "apacir",
        "\u2A70": "apE",
        "\u2A70\u0338": "napE",
        "\u2A71": "eplus",
        "\u2A72": "pluse",
        "\u2A73": "Esim",
        "\u2A77": "eDDot",
        "\u2A78": "equivDD",
        "\u2A79": "ltcir",
        "\u2A7A": "gtcir",
        "\u2A7B": "ltquest",
        "\u2A7C": "gtquest",
        "\u2A7D": "les",
        "\u2A7D\u0338": "nles",
        "\u2A7E": "ges",
        "\u2A7E\u0338": "nges",
        "\u2A7F": "lesdot",
        "\u2A80": "gesdot",
        "\u2A81": "lesdoto",
        "\u2A82": "gesdoto",
        "\u2A83": "lesdotor",
        "\u2A84": "gesdotol",
        "\u2A85": "lap",
        "\u2A86": "gap",
        "\u2A87": "lne",
        "\u2A88": "gne",
        "\u2A89": "lnap",
        "\u2A8A": "gnap",
        "\u2A8B": "lEg",
        "\u2A8C": "gEl",
        "\u2A8D": "lsime",
        "\u2A8E": "gsime",
        "\u2A8F": "lsimg",
        "\u2A90": "gsiml",
        "\u2A91": "lgE",
        "\u2A92": "glE",
        "\u2A93": "lesges",
        "\u2A94": "gesles",
        "\u2A95": "els",
        "\u2A96": "egs",
        "\u2A97": "elsdot",
        "\u2A98": "egsdot",
        "\u2A99": "el",
        "\u2A9A": "eg",
        "\u2A9D": "siml",
        "\u2A9E": "simg",
        "\u2A9F": "simlE",
        "\u2AA0": "simgE",
        "\u2AA1": "LessLess",
        "\u2AA1\u0338": "NotNestedLessLess",
        "\u2AA2": "GreaterGreater",
        "\u2AA2\u0338": "NotNestedGreaterGreater",
        "\u2AA4": "glj",
        "\u2AA5": "gla",
        "\u2AA6": "ltcc",
        "\u2AA7": "gtcc",
        "\u2AA8": "lescc",
        "\u2AA9": "gescc",
        "\u2AAA": "smt",
        "\u2AAB": "lat",
        "\u2AAC": "smte",
        "\u2AAC\uFE00": "smtes",
        "\u2AAD": "late",
        "\u2AAD\uFE00": "lates",
        "\u2AAE": "bumpE",
        "\u2AAF": "pre",
        "\u2AAF\u0338": "npre",
        "\u2AB0": "sce",
        "\u2AB0\u0338": "nsce",
        "\u2AB3": "prE",
        "\u2AB4": "scE",
        "\u2AB5": "prnE",
        "\u2AB6": "scnE",
        "\u2AB7": "prap",
        "\u2AB8": "scap",
        "\u2AB9": "prnap",
        "\u2ABA": "scnap",
        "\u2ABB": "Pr",
        "\u2ABC": "Sc",
        "\u2ABD": "subdot",
        "\u2ABE": "supdot",
        "\u2ABF": "subplus",
        "\u2AC0": "supplus",
        "\u2AC1": "submult",
        "\u2AC2": "supmult",
        "\u2AC3": "subedot",
        "\u2AC4": "supedot",
        "\u2AC5": "subE",
        "\u2AC5\u0338": "nsubE",
        "\u2AC6": "supE",
        "\u2AC6\u0338": "nsupE",
        "\u2AC7": "subsim",
        "\u2AC8": "supsim",
        "\u2ACB\uFE00": "vsubnE",
        "\u2ACB": "subnE",
        "\u2ACC\uFE00": "vsupnE",
        "\u2ACC": "supnE",
        "\u2ACF": "csub",
        "\u2AD0": "csup",
        "\u2AD1": "csube",
        "\u2AD2": "csupe",
        "\u2AD3": "subsup",
        "\u2AD4": "supsub",
        "\u2AD5": "subsub",
        "\u2AD6": "supsup",
        "\u2AD7": "suphsub",
        "\u2AD8": "supdsub",
        "\u2AD9": "forkv",
        "\u2ADA": "topfork",
        "\u2ADB": "mlcp",
        "\u2AE4": "Dashv",
        "\u2AE6": "Vdashl",
        "\u2AE7": "Barv",
        "\u2AE8": "vBar",
        "\u2AE9": "vBarv",
        "\u2AEB": "Vbar",
        "\u2AEC": "Not",
        "\u2AED": "bNot",
        "\u2AEE": "rnmid",
        "\u2AEF": "cirmid",
        "\u2AF0": "midcir",
        "\u2AF1": "topcir",
        "\u2AF2": "nhpar",
        "\u2AF3": "parsim",
        "\u2AFD": "parsl",
        "\u2AFD\u20E5": "nparsl",
        "\u266D": "flat",
        "\u266E": "natur",
        "\u266F": "sharp",
        "\xa4": "curren",
        "\xa2": "cent",
        "$": "dollar",
        "\xa3": "pound",
        "\xa5": "yen",
        "\u20AC": "euro",
        "\xb9": "sup1",
        "\xbd": "half",
        "\u2153": "frac13",
        "\xbc": "frac14",
        "\u2155": "frac15",
        "\u2159": "frac16",
        "\u215B": "frac18",
        "\xb2": "sup2",
        "\u2154": "frac23",
        "\u2156": "frac25",
        "\xb3": "sup3",
        "\xbe": "frac34",
        "\u2157": "frac35",
        "\u215C": "frac38",
        "\u2158": "frac45",
        "\u215A": "frac56",
        "\u215D": "frac58",
        "\u215E": "frac78",
        "\uD835\uDCB6": "ascr",
        "\uD835\uDD52": "aopf",
        "\uD835\uDD1E": "afr",
        "\uD835\uDD38": "Aopf",
        "\uD835\uDD04": "Afr",
        "\uD835\uDC9C": "Ascr",
        "\xaa": "ordf",
        "\xe1": "aacute",
        "\xc1": "Aacute",
        "\xe0": "agrave",
        "\xc0": "Agrave",
        "\u0103": "abreve",
        "\u0102": "Abreve",
        "\xe2": "acirc",
        "\xc2": "Acirc",
        "\xe5": "aring",
        "\xc5": "angst",
        "\xe4": "auml",
        "\xc4": "Auml",
        "\xe3": "atilde",
        "\xc3": "Atilde",
        "\u0105": "aogon",
        "\u0104": "Aogon",
        "\u0101": "amacr",
        "\u0100": "Amacr",
        "\xe6": "aelig",
        "\xc6": "AElig",
        "\uD835\uDCB7": "bscr",
        "\uD835\uDD53": "bopf",
        "\uD835\uDD1F": "bfr",
        "\uD835\uDD39": "Bopf",
        "\u212C": "Bscr",
        "\uD835\uDD05": "Bfr",
        "\uD835\uDD20": "cfr",
        "\uD835\uDCB8": "cscr",
        "\uD835\uDD54": "copf",
        "\u212D": "Cfr",
        "\uD835\uDC9E": "Cscr",
        "\u2102": "Copf",
        "\u0107": "cacute",
        "\u0106": "Cacute",
        "\u0109": "ccirc",
        "\u0108": "Ccirc",
        "\u010D": "ccaron",
        "\u010C": "Ccaron",
        "\u010B": "cdot",
        "\u010A": "Cdot",
        "\xe7": "ccedil",
        "\xc7": "Ccedil",
        "\u2105": "incare",
        "\uD835\uDD21": "dfr",
        "\u2146": "dd",
        "\uD835\uDD55": "dopf",
        "\uD835\uDCB9": "dscr",
        "\uD835\uDC9F": "Dscr",
        "\uD835\uDD07": "Dfr",
        "\u2145": "DD",
        "\uD835\uDD3B": "Dopf",
        "\u010F": "dcaron",
        "\u010E": "Dcaron",
        "\u0111": "dstrok",
        "\u0110": "Dstrok",
        "\xf0": "eth",
        "\xd0": "ETH",
        "\u2147": "ee",
        "\u212F": "escr",
        "\uD835\uDD22": "efr",
        "\uD835\uDD56": "eopf",
        "\u2130": "Escr",
        "\uD835\uDD08": "Efr",
        "\uD835\uDD3C": "Eopf",
        "\xe9": "eacute",
        "\xc9": "Eacute",
        "\xe8": "egrave",
        "\xc8": "Egrave",
        "\xea": "ecirc",
        "\xca": "Ecirc",
        "\u011B": "ecaron",
        "\u011A": "Ecaron",
        "\xeb": "euml",
        "\xcb": "Euml",
        "\u0117": "edot",
        "\u0116": "Edot",
        "\u0119": "eogon",
        "\u0118": "Eogon",
        "\u0113": "emacr",
        "\u0112": "Emacr",
        "\uD835\uDD23": "ffr",
        "\uD835\uDD57": "fopf",
        "\uD835\uDCBB": "fscr",
        "\uD835\uDD09": "Ffr",
        "\uD835\uDD3D": "Fopf",
        "\u2131": "Fscr",
        "\uFB00": "fflig",
        "\uFB03": "ffilig",
        "\uFB04": "ffllig",
        "\uFB01": "filig",
        "fj": "fjlig",
        "\uFB02": "fllig",
        "\u0192": "fnof",
        "\u210A": "gscr",
        "\uD835\uDD58": "gopf",
        "\uD835\uDD24": "gfr",
        "\uD835\uDCA2": "Gscr",
        "\uD835\uDD3E": "Gopf",
        "\uD835\uDD0A": "Gfr",
        "\u01F5": "gacute",
        "\u011F": "gbreve",
        "\u011E": "Gbreve",
        "\u011D": "gcirc",
        "\u011C": "Gcirc",
        "\u0121": "gdot",
        "\u0120": "Gdot",
        "\u0122": "Gcedil",
        "\uD835\uDD25": "hfr",
        "\u210E": "planckh",
        "\uD835\uDCBD": "hscr",
        "\uD835\uDD59": "hopf",
        "\u210B": "Hscr",
        "\u210C": "Hfr",
        "\u210D": "Hopf",
        "\u0125": "hcirc",
        "\u0124": "Hcirc",
        "\u210F": "hbar",
        "\u0127": "hstrok",
        "\u0126": "Hstrok",
        "\uD835\uDD5A": "iopf",
        "\uD835\uDD26": "ifr",
        "\uD835\uDCBE": "iscr",
        "\u2148": "ii",
        "\uD835\uDD40": "Iopf",
        "\u2110": "Iscr",
        "\u2111": "Im",
        "\xed": "iacute",
        "\xcd": "Iacute",
        "\xec": "igrave",
        "\xcc": "Igrave",
        "\xee": "icirc",
        "\xce": "Icirc",
        "\xef": "iuml",
        "\xcf": "Iuml",
        "\u0129": "itilde",
        "\u0128": "Itilde",
        "\u0130": "Idot",
        "\u012F": "iogon",
        "\u012E": "Iogon",
        "\u012B": "imacr",
        "\u012A": "Imacr",
        "\u0133": "ijlig",
        "\u0132": "IJlig",
        "\u0131": "imath",
        "\uD835\uDCBF": "jscr",
        "\uD835\uDD5B": "jopf",
        "\uD835\uDD27": "jfr",
        "\uD835\uDCA5": "Jscr",
        "\uD835\uDD0D": "Jfr",
        "\uD835\uDD41": "Jopf",
        "\u0135": "jcirc",
        "\u0134": "Jcirc",
        "\u0237": "jmath",
        "\uD835\uDD5C": "kopf",
        "\uD835\uDCC0": "kscr",
        "\uD835\uDD28": "kfr",
        "\uD835\uDCA6": "Kscr",
        "\uD835\uDD42": "Kopf",
        "\uD835\uDD0E": "Kfr",
        "\u0137": "kcedil",
        "\u0136": "Kcedil",
        "\uD835\uDD29": "lfr",
        "\uD835\uDCC1": "lscr",
        "\u2113": "ell",
        "\uD835\uDD5D": "lopf",
        "\u2112": "Lscr",
        "\uD835\uDD0F": "Lfr",
        "\uD835\uDD43": "Lopf",
        "\u013A": "lacute",
        "\u0139": "Lacute",
        "\u013E": "lcaron",
        "\u013D": "Lcaron",
        "\u013C": "lcedil",
        "\u013B": "Lcedil",
        "\u0142": "lstrok",
        "\u0141": "Lstrok",
        "\u0140": "lmidot",
        "\u013F": "Lmidot",
        "\uD835\uDD2A": "mfr",
        "\uD835\uDD5E": "mopf",
        "\uD835\uDCC2": "mscr",
        "\uD835\uDD10": "Mfr",
        "\uD835\uDD44": "Mopf",
        "\u2133": "Mscr",
        "\uD835\uDD2B": "nfr",
        "\uD835\uDD5F": "nopf",
        "\uD835\uDCC3": "nscr",
        "\u2115": "Nopf",
        "\uD835\uDCA9": "Nscr",
        "\uD835\uDD11": "Nfr",
        "\u0144": "nacute",
        "\u0143": "Nacute",
        "\u0148": "ncaron",
        "\u0147": "Ncaron",
        "\xf1": "ntilde",
        "\xd1": "Ntilde",
        "\u0146": "ncedil",
        "\u0145": "Ncedil",
        "\u2116": "numero",
        "\u014B": "eng",
        "\u014A": "ENG",
        "\uD835\uDD60": "oopf",
        "\uD835\uDD2C": "ofr",
        "\u2134": "oscr",
        "\uD835\uDCAA": "Oscr",
        "\uD835\uDD12": "Ofr",
        "\uD835\uDD46": "Oopf",
        "\xba": "ordm",
        "\xf3": "oacute",
        "\xd3": "Oacute",
        "\xf2": "ograve",
        "\xd2": "Ograve",
        "\xf4": "ocirc",
        "\xd4": "Ocirc",
        "\xf6": "ouml",
        "\xd6": "Ouml",
        "\u0151": "odblac",
        "\u0150": "Odblac",
        "\xf5": "otilde",
        "\xd5": "Otilde",
        "\xf8": "oslash",
        "\xd8": "Oslash",
        "\u014D": "omacr",
        "\u014C": "Omacr",
        "\u0153": "oelig",
        "\u0152": "OElig",
        "\uD835\uDD2D": "pfr",
        "\uD835\uDCC5": "pscr",
        "\uD835\uDD61": "popf",
        "\u2119": "Popf",
        "\uD835\uDD13": "Pfr",
        "\uD835\uDCAB": "Pscr",
        "\uD835\uDD62": "qopf",
        "\uD835\uDD2E": "qfr",
        "\uD835\uDCC6": "qscr",
        "\uD835\uDCAC": "Qscr",
        "\uD835\uDD14": "Qfr",
        "\u211A": "Qopf",
        "\u0138": "kgreen",
        "\uD835\uDD2F": "rfr",
        "\uD835\uDD63": "ropf",
        "\uD835\uDCC7": "rscr",
        "\u211B": "Rscr",
        "\u211C": "Re",
        "\u211D": "Ropf",
        "\u0155": "racute",
        "\u0154": "Racute",
        "\u0159": "rcaron",
        "\u0158": "Rcaron",
        "\u0157": "rcedil",
        "\u0156": "Rcedil",
        "\uD835\uDD64": "sopf",
        "\uD835\uDCC8": "sscr",
        "\uD835\uDD30": "sfr",
        "\uD835\uDD4A": "Sopf",
        "\uD835\uDD16": "Sfr",
        "\uD835\uDCAE": "Sscr",
        "\u24C8": "oS",
        "\u015B": "sacute",
        "\u015A": "Sacute",
        "\u015D": "scirc",
        "\u015C": "Scirc",
        "\u0161": "scaron",
        "\u0160": "Scaron",
        "\u015F": "scedil",
        "\u015E": "Scedil",
        "\xdf": "szlig",
        "\uD835\uDD31": "tfr",
        "\uD835\uDCC9": "tscr",
        "\uD835\uDD65": "topf",
        "\uD835\uDCAF": "Tscr",
        "\uD835\uDD17": "Tfr",
        "\uD835\uDD4B": "Topf",
        "\u0165": "tcaron",
        "\u0164": "Tcaron",
        "\u0163": "tcedil",
        "\u0162": "Tcedil",
        "\u2122": "trade",
        "\u0167": "tstrok",
        "\u0166": "Tstrok",
        "\uD835\uDCCA": "uscr",
        "\uD835\uDD66": "uopf",
        "\uD835\uDD32": "ufr",
        "\uD835\uDD4C": "Uopf",
        "\uD835\uDD18": "Ufr",
        "\uD835\uDCB0": "Uscr",
        "\xfa": "uacute",
        "\xda": "Uacute",
        "\xf9": "ugrave",
        "\xd9": "Ugrave",
        "\u016D": "ubreve",
        "\u016C": "Ubreve",
        "\xfb": "ucirc",
        "\xdb": "Ucirc",
        "\u016F": "uring",
        "\u016E": "Uring",
        "\xfc": "uuml",
        "\xdc": "Uuml",
        "\u0171": "udblac",
        "\u0170": "Udblac",
        "\u0169": "utilde",
        "\u0168": "Utilde",
        "\u0173": "uogon",
        "\u0172": "Uogon",
        "\u016B": "umacr",
        "\u016A": "Umacr",
        "\uD835\uDD33": "vfr",
        "\uD835\uDD67": "vopf",
        "\uD835\uDCCB": "vscr",
        "\uD835\uDD19": "Vfr",
        "\uD835\uDD4D": "Vopf",
        "\uD835\uDCB1": "Vscr",
        "\uD835\uDD68": "wopf",
        "\uD835\uDCCC": "wscr",
        "\uD835\uDD34": "wfr",
        "\uD835\uDCB2": "Wscr",
        "\uD835\uDD4E": "Wopf",
        "\uD835\uDD1A": "Wfr",
        "\u0175": "wcirc",
        "\u0174": "Wcirc",
        "\uD835\uDD35": "xfr",
        "\uD835\uDCCD": "xscr",
        "\uD835\uDD69": "xopf",
        "\uD835\uDD4F": "Xopf",
        "\uD835\uDD1B": "Xfr",
        "\uD835\uDCB3": "Xscr",
        "\uD835\uDD36": "yfr",
        "\uD835\uDCCE": "yscr",
        "\uD835\uDD6A": "yopf",
        "\uD835\uDCB4": "Yscr",
        "\uD835\uDD1C": "Yfr",
        "\uD835\uDD50": "Yopf",
        "\xfd": "yacute",
        "\xdd": "Yacute",
        "\u0177": "ycirc",
        "\u0176": "Ycirc",
        "\xff": "yuml",
        "\u0178": "Yuml",
        "\uD835\uDCCF": "zscr",
        "\uD835\uDD37": "zfr",
        "\uD835\uDD6B": "zopf",
        "\u2128": "Zfr",
        "\u2124": "Zopf",
        "\uD835\uDCB5": "Zscr",
        "\u017A": "zacute",
        "\u0179": "Zacute",
        "\u017E": "zcaron",
        "\u017D": "Zcaron",
        "\u017C": "zdot",
        "\u017B": "Zdot",
        "\u01B5": "imped",
        "\xfe": "thorn",
        "\xde": "THORN",
        "\u0149": "napos",
        "\u03B1": "alpha",
        "\u0391": "Alpha",
        "\u03B2": "beta",
        "\u0392": "Beta",
        "\u03B3": "gamma",
        "\u0393": "Gamma",
        "\u03B4": "delta",
        "\u0394": "Delta",
        "\u03B5": "epsi",
        "\u03F5": "epsiv",
        "\u0395": "Epsilon",
        "\u03DD": "gammad",
        "\u03DC": "Gammad",
        "\u03B6": "zeta",
        "\u0396": "Zeta",
        "\u03B7": "eta",
        "\u0397": "Eta",
        "\u03B8": "theta",
        "\u03D1": "thetav",
        "\u0398": "Theta",
        "\u03B9": "iota",
        "\u0399": "Iota",
        "\u03BA": "kappa",
        "\u03F0": "kappav",
        "\u039A": "Kappa",
        "\u03BB": "lambda",
        "\u039B": "Lambda",
        "\u03BC": "mu",
        "\xb5": "micro",
        "\u039C": "Mu",
        "\u03BD": "nu",
        "\u039D": "Nu",
        "\u03BE": "xi",
        "\u039E": "Xi",
        "\u03BF": "omicron",
        "\u039F": "Omicron",
        "\u03C0": "pi",
        "\u03D6": "piv",
        "\u03A0": "Pi",
        "\u03C1": "rho",
        "\u03F1": "rhov",
        "\u03A1": "Rho",
        "\u03C3": "sigma",
        "\u03A3": "Sigma",
        "\u03C2": "sigmaf",
        "\u03C4": "tau",
        "\u03A4": "Tau",
        "\u03C5": "upsi",
        "\u03A5": "Upsilon",
        "\u03D2": "Upsi",
        "\u03C6": "phi",
        "\u03D5": "phiv",
        "\u03A6": "Phi",
        "\u03C7": "chi",
        "\u03A7": "Chi",
        "\u03C8": "psi",
        "\u03A8": "Psi",
        "\u03C9": "omega",
        "\u03A9": "ohm",
        "\u0430": "acy",
        "\u0410": "Acy",
        "\u0431": "bcy",
        "\u0411": "Bcy",
        "\u0432": "vcy",
        "\u0412": "Vcy",
        "\u0433": "gcy",
        "\u0413": "Gcy",
        "\u0453": "gjcy",
        "\u0403": "GJcy",
        "\u0434": "dcy",
        "\u0414": "Dcy",
        "\u0452": "djcy",
        "\u0402": "DJcy",
        "\u0435": "iecy",
        "\u0415": "IEcy",
        "\u0451": "iocy",
        "\u0401": "IOcy",
        "\u0454": "jukcy",
        "\u0404": "Jukcy",
        "\u0436": "zhcy",
        "\u0416": "ZHcy",
        "\u0437": "zcy",
        "\u0417": "Zcy",
        "\u0455": "dscy",
        "\u0405": "DScy",
        "\u0438": "icy",
        "\u0418": "Icy",
        "\u0456": "iukcy",
        "\u0406": "Iukcy",
        "\u0457": "yicy",
        "\u0407": "YIcy",
        "\u0439": "jcy",
        "\u0419": "Jcy",
        "\u0458": "jsercy",
        "\u0408": "Jsercy",
        "\u043A": "kcy",
        "\u041A": "Kcy",
        "\u045C": "kjcy",
        "\u040C": "KJcy",
        "\u043B": "lcy",
        "\u041B": "Lcy",
        "\u0459": "ljcy",
        "\u0409": "LJcy",
        "\u043C": "mcy",
        "\u041C": "Mcy",
        "\u043D": "ncy",
        "\u041D": "Ncy",
        "\u045A": "njcy",
        "\u040A": "NJcy",
        "\u043E": "ocy",
        "\u041E": "Ocy",
        "\u043F": "pcy",
        "\u041F": "Pcy",
        "\u0440": "rcy",
        "\u0420": "Rcy",
        "\u0441": "scy",
        "\u0421": "Scy",
        "\u0442": "tcy",
        "\u0422": "Tcy",
        "\u045B": "tshcy",
        "\u040B": "TSHcy",
        "\u0443": "ucy",
        "\u0423": "Ucy",
        "\u045E": "ubrcy",
        "\u040E": "Ubrcy",
        "\u0444": "fcy",
        "\u0424": "Fcy",
        "\u0445": "khcy",
        "\u0425": "KHcy",
        "\u0446": "tscy",
        "\u0426": "TScy",
        "\u0447": "chcy",
        "\u0427": "CHcy",
        "\u045F": "dzcy",
        "\u040F": "DZcy",
        "\u0448": "shcy",
        "\u0428": "SHcy",
        "\u0449": "shchcy",
        "\u0429": "SHCHcy",
        "\u044A": "hardcy",
        "\u042A": "HARDcy",
        "\u044B": "ycy",
        "\u042B": "Ycy",
        "\u044C": "softcy",
        "\u042C": "SOFTcy",
        "\u044D": "ecy",
        "\u042D": "Ecy",
        "\u044E": "yucy",
        "\u042E": "YUcy",
        "\u044F": "yacy",
        "\u042F": "YAcy",
        "\u2135": "aleph",
        "\u2136": "beth",
        "\u2137": "gimel",
        "\u2138": "daleth"
    };
    var regexEscape = /["&'<>`]/g;
    var escapeMap = {
        '"': "&quot;",
        "&": "&amp;",
        "'": "&#x27;",
        "<": "&lt;",
        // See https://mathiasbynens.be/notes/ambiguous-ampersands: in HTML, the
        // following is not strictly necessary unless it’s part of a tag or an
        // unquoted attribute value. We’re only escaping it to support those
        // situations, and for XML support.
        ">": "&gt;",
        // In Internet Explorer ≤ 8, the backtick character can be used
        // to break out of (un)quoted attribute values or HTML comments.
        // See http://html5sec.org/#102, http://html5sec.org/#108, and
        // http://html5sec.org/#133.
        "`": "&#x60;"
    };
    var regexInvalidEntity = /&#(?:[xX][^a-fA-F0-9]|[^0-9xX])/;
    var regexInvalidRawCodePoint = /[\0-\x08\x0B\x0E-\x1F\x7F-\x9F\uFDD0-\uFDEF\uFFFE\uFFFF]|[\uD83F\uD87F\uD8BF\uD8FF\uD93F\uD97F\uD9BF\uD9FF\uDA3F\uDA7F\uDABF\uDAFF\uDB3F\uDB7F\uDBBF\uDBFF][\uDFFE\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
    var regexDecode = /&(CounterClockwiseContourIntegral|DoubleLongLeftRightArrow|ClockwiseContourIntegral|NotNestedGreaterGreater|NotSquareSupersetEqual|DiacriticalDoubleAcute|NotRightTriangleEqual|NotSucceedsSlantEqual|NotPrecedesSlantEqual|CloseCurlyDoubleQuote|NegativeVeryThinSpace|DoubleContourIntegral|FilledVerySmallSquare|CapitalDifferentialD|OpenCurlyDoubleQuote|EmptyVerySmallSquare|NestedGreaterGreater|DoubleLongRightArrow|NotLeftTriangleEqual|NotGreaterSlantEqual|ReverseUpEquilibrium|DoubleLeftRightArrow|NotSquareSubsetEqual|NotDoubleVerticalBar|RightArrowLeftArrow|NotGreaterFullEqual|NotRightTriangleBar|SquareSupersetEqual|DownLeftRightVector|DoubleLongLeftArrow|leftrightsquigarrow|LeftArrowRightArrow|NegativeMediumSpace|blacktriangleright|RightDownVectorBar|PrecedesSlantEqual|RightDoubleBracket|SucceedsSlantEqual|NotLeftTriangleBar|RightTriangleEqual|SquareIntersection|RightDownTeeVector|ReverseEquilibrium|NegativeThickSpace|longleftrightarrow|Longleftrightarrow|LongLeftRightArrow|DownRightTeeVector|DownRightVectorBar|GreaterSlantEqual|SquareSubsetEqual|LeftDownVectorBar|LeftDoubleBracket|VerticalSeparator|rightleftharpoons|NotGreaterGreater|NotSquareSuperset|blacktriangleleft|blacktriangledown|NegativeThinSpace|LeftDownTeeVector|NotLessSlantEqual|leftrightharpoons|DoubleUpDownArrow|DoubleVerticalBar|LeftTriangleEqual|FilledSmallSquare|twoheadrightarrow|NotNestedLessLess|DownLeftTeeVector|DownLeftVectorBar|RightAngleBracket|NotTildeFullEqual|NotReverseElement|RightUpDownVector|DiacriticalTilde|NotSucceedsTilde|circlearrowright|NotPrecedesEqual|rightharpoondown|DoubleRightArrow|NotSucceedsEqual|NonBreakingSpace|NotRightTriangle|LessEqualGreater|RightUpTeeVector|LeftAngleBracket|GreaterFullEqual|DownArrowUpArrow|RightUpVectorBar|twoheadleftarrow|GreaterEqualLess|downharpoonright|RightTriangleBar|ntrianglerighteq|NotSupersetEqual|LeftUpDownVector|DiacriticalAcute|rightrightarrows|vartriangleright|UpArrowDownArrow|DiacriticalGrave|UnderParenthesis|EmptySmallSquare|LeftUpVectorBar|leftrightarrows|DownRightVector|downharpoonleft|trianglerighteq|ShortRightArrow|OverParenthesis|DoubleLeftArrow|DoubleDownArrow|NotSquareSubset|bigtriangledown|ntrianglelefteq|UpperRightArrow|curvearrowright|vartriangleleft|NotLeftTriangle|nleftrightarrow|LowerRightArrow|NotHumpDownHump|NotGreaterTilde|rightthreetimes|LeftUpTeeVector|NotGreaterEqual|straightepsilon|LeftTriangleBar|rightsquigarrow|ContourIntegral|rightleftarrows|CloseCurlyQuote|RightDownVector|LeftRightVector|nLeftrightarrow|leftharpoondown|circlearrowleft|SquareSuperset|OpenCurlyQuote|hookrightarrow|HorizontalLine|DiacriticalDot|NotLessGreater|ntriangleright|DoubleRightTee|InvisibleComma|InvisibleTimes|LowerLeftArrow|DownLeftVector|NotSubsetEqual|curvearrowleft|trianglelefteq|NotVerticalBar|TildeFullEqual|downdownarrows|NotGreaterLess|RightTeeVector|ZeroWidthSpace|looparrowright|LongRightArrow|doublebarwedge|ShortLeftArrow|ShortDownArrow|RightVectorBar|GreaterGreater|ReverseElement|rightharpoonup|LessSlantEqual|leftthreetimes|upharpoonright|rightarrowtail|LeftDownVector|Longrightarrow|NestedLessLess|UpperLeftArrow|nshortparallel|leftleftarrows|leftrightarrow|Leftrightarrow|LeftRightArrow|longrightarrow|upharpoonleft|RightArrowBar|ApplyFunction|LeftTeeVector|leftarrowtail|NotEqualTilde|varsubsetneqq|varsupsetneqq|RightTeeArrow|SucceedsEqual|SucceedsTilde|LeftVectorBar|SupersetEqual|hookleftarrow|DifferentialD|VerticalTilde|VeryThinSpace|blacktriangle|bigtriangleup|LessFullEqual|divideontimes|leftharpoonup|UpEquilibrium|ntriangleleft|RightTriangle|measuredangle|shortparallel|longleftarrow|Longleftarrow|LongLeftArrow|DoubleLeftTee|Poincareplane|PrecedesEqual|triangleright|DoubleUpArrow|RightUpVector|fallingdotseq|looparrowleft|PrecedesTilde|NotTildeEqual|NotTildeTilde|smallsetminus|Proportional|triangleleft|triangledown|UnderBracket|NotHumpEqual|exponentiale|ExponentialE|NotLessTilde|HilbertSpace|RightCeiling|blacklozenge|varsupsetneq|HumpDownHump|GreaterEqual|VerticalLine|LeftTeeArrow|NotLessEqual|DownTeeArrow|LeftTriangle|varsubsetneq|Intersection|NotCongruent|DownArrowBar|LeftUpVector|LeftArrowBar|risingdotseq|GreaterTilde|RoundImplies|SquareSubset|ShortUpArrow|NotSuperset|quaternions|precnapprox|backepsilon|preccurlyeq|OverBracket|blacksquare|MediumSpace|VerticalBar|circledcirc|circleddash|CircleMinus|CircleTimes|LessGreater|curlyeqprec|curlyeqsucc|diamondsuit|UpDownArrow|Updownarrow|RuleDelayed|Rrightarrow|updownarrow|RightVector|nRightarrow|nrightarrow|eqslantless|LeftCeiling|Equilibrium|SmallCircle|expectation|NotSucceeds|thickapprox|GreaterLess|SquareUnion|NotPrecedes|NotLessLess|straightphi|succnapprox|succcurlyeq|SubsetEqual|sqsupseteq|Proportion|Laplacetrf|ImaginaryI|supsetneqq|NotGreater|gtreqqless|NotElement|ThickSpace|TildeEqual|TildeTilde|Fouriertrf|rmoustache|EqualTilde|eqslantgtr|UnderBrace|LeftVector|UpArrowBar|nLeftarrow|nsubseteqq|subsetneqq|nsupseteqq|nleftarrow|succapprox|lessapprox|UpTeeArrow|upuparrows|curlywedge|lesseqqgtr|varepsilon|varnothing|RightFloor|complement|CirclePlus|sqsubseteq|Lleftarrow|circledast|RightArrow|Rightarrow|rightarrow|lmoustache|Bernoullis|precapprox|mapstoleft|mapstodown|longmapsto|dotsquare|downarrow|DoubleDot|nsubseteq|supsetneq|leftarrow|nsupseteq|subsetneq|ThinSpace|ngeqslant|subseteqq|HumpEqual|NotSubset|triangleq|NotCupCap|lesseqgtr|heartsuit|TripleDot|Leftarrow|Coproduct|Congruent|varpropto|complexes|gvertneqq|LeftArrow|LessTilde|supseteqq|MinusPlus|CircleDot|nleqslant|NotExists|gtreqless|nparallel|UnionPlus|LeftFloor|checkmark|CenterDot|centerdot|Mellintrf|gtrapprox|bigotimes|OverBrace|spadesuit|therefore|pitchfork|rationals|PlusMinus|Backslash|Therefore|DownBreve|backsimeq|backprime|DownArrow|nshortmid|Downarrow|lvertneqq|eqvparsl|imagline|imagpart|infintie|integers|Integral|intercal|LessLess|Uarrocir|intlarhk|sqsupset|angmsdaf|sqsubset|llcorner|vartheta|cupbrcap|lnapprox|Superset|SuchThat|succnsim|succneqq|angmsdag|biguplus|curlyvee|trpezium|Succeeds|NotTilde|bigwedge|angmsdah|angrtvbd|triminus|cwconint|fpartint|lrcorner|smeparsl|subseteq|urcorner|lurdshar|laemptyv|DDotrahd|approxeq|ldrushar|awconint|mapstoup|backcong|shortmid|triangle|geqslant|gesdotol|timesbar|circledR|circledS|setminus|multimap|naturals|scpolint|ncongdot|RightTee|boxminus|gnapprox|boxtimes|andslope|thicksim|angmsdaa|varsigma|cirfnint|rtriltri|angmsdab|rppolint|angmsdac|barwedge|drbkarow|clubsuit|thetasym|bsolhsub|capbrcup|dzigrarr|doteqdot|DotEqual|dotminus|UnderBar|NotEqual|realpart|otimesas|ulcorner|hksearow|hkswarow|parallel|PartialD|elinters|emptyset|plusacir|bbrktbrk|angmsdad|pointint|bigoplus|angmsdae|Precedes|bigsqcup|varkappa|notindot|supseteq|precneqq|precnsim|profalar|profline|profsurf|leqslant|lesdotor|raemptyv|subplus|notnivb|notnivc|subrarr|zigrarr|vzigzag|submult|subedot|Element|between|cirscir|larrbfs|larrsim|lotimes|lbrksld|lbrkslu|lozenge|ldrdhar|dbkarow|bigcirc|epsilon|simrarr|simplus|ltquest|Epsilon|luruhar|gtquest|maltese|npolint|eqcolon|npreceq|bigodot|ddagger|gtrless|bnequiv|harrcir|ddotseq|equivDD|backsim|demptyv|nsqsube|nsqsupe|Upsilon|nsubset|upsilon|minusdu|nsucceq|swarrow|nsupset|coloneq|searrow|boxplus|napprox|natural|asympeq|alefsym|congdot|nearrow|bigstar|diamond|supplus|tritime|LeftTee|nvinfin|triplus|NewLine|nvltrie|nvrtrie|nwarrow|nexists|Diamond|ruluhar|Implies|supmult|angzarr|suplarr|suphsub|questeq|because|digamma|Because|olcross|bemptyv|omicron|Omicron|rotimes|NoBreak|intprod|angrtvb|orderof|uwangle|suphsol|lesdoto|orslope|DownTee|realine|cudarrl|rdldhar|OverBar|supedot|lessdot|supdsub|topfork|succsim|rbrkslu|rbrksld|pertenk|cudarrr|isindot|planckh|lessgtr|pluscir|gesdoto|plussim|plustwo|lesssim|cularrp|rarrsim|Cayleys|notinva|notinvb|notinvc|UpArrow|Uparrow|uparrow|NotLess|dwangle|precsim|Product|curarrm|Cconint|dotplus|rarrbfs|ccupssm|Cedilla|cemptyv|notniva|quatint|frac35|frac38|frac45|frac56|frac58|frac78|tridot|xoplus|gacute|gammad|Gammad|lfisht|lfloor|bigcup|sqsupe|gbreve|Gbreve|lharul|sqsube|sqcups|Gcedil|apacir|llhard|lmidot|Lmidot|lmoust|andand|sqcaps|approx|Abreve|spades|circeq|tprime|divide|topcir|Assign|topbot|gesdot|divonx|xuplus|timesd|gesles|atilde|solbar|SOFTcy|loplus|timesb|lowast|lowbar|dlcorn|dlcrop|softcy|dollar|lparlt|thksim|lrhard|Atilde|lsaquo|smashp|bigvee|thinsp|wreath|bkarow|lsquor|lstrok|Lstrok|lthree|ltimes|ltlarr|DotDot|simdot|ltrPar|weierp|xsqcup|angmsd|sigmav|sigmaf|zeetrf|Zcaron|zcaron|mapsto|vsupne|thetav|cirmid|marker|mcomma|Zacute|vsubnE|there4|gtlPar|vsubne|bottom|gtrarr|SHCHcy|shchcy|midast|midcir|middot|minusb|minusd|gtrdot|bowtie|sfrown|mnplus|models|colone|seswar|Colone|mstpos|searhk|gtrsim|nacute|Nacute|boxbox|telrec|hairsp|Tcedil|nbumpe|scnsim|ncaron|Ncaron|ncedil|Ncedil|hamilt|Scedil|nearhk|hardcy|HARDcy|tcedil|Tcaron|commat|nequiv|nesear|tcaron|target|hearts|nexist|varrho|scedil|Scaron|scaron|hellip|Sacute|sacute|hercon|swnwar|compfn|rtimes|rthree|rsquor|rsaquo|zacute|wedgeq|homtht|barvee|barwed|Barwed|rpargt|horbar|conint|swarhk|roplus|nltrie|hslash|hstrok|Hstrok|rmoust|Conint|bprime|hybull|hyphen|iacute|Iacute|supsup|supsub|supsim|varphi|coprod|brvbar|agrave|Supset|supset|igrave|Igrave|notinE|Agrave|iiiint|iinfin|copysr|wedbar|Verbar|vangrt|becaus|incare|verbar|inodot|bullet|drcorn|intcal|drcrop|cularr|vellip|Utilde|bumpeq|cupcap|dstrok|Dstrok|CupCap|cupcup|cupdot|eacute|Eacute|supdot|iquest|easter|ecaron|Ecaron|ecolon|isinsv|utilde|itilde|Itilde|curarr|succeq|Bumpeq|cacute|ulcrop|nparsl|Cacute|nprcue|egrave|Egrave|nrarrc|nrarrw|subsup|subsub|nrtrie|jsercy|nsccue|Jsercy|kappav|kcedil|Kcedil|subsim|ulcorn|nsimeq|egsdot|veebar|kgreen|capand|elsdot|Subset|subset|curren|aacute|lacute|Lacute|emptyv|ntilde|Ntilde|lagran|lambda|Lambda|capcap|Ugrave|langle|subdot|emsp13|numero|emsp14|nvdash|nvDash|nVdash|nVDash|ugrave|ufisht|nvHarr|larrfs|nvlArr|larrhk|larrlp|larrpl|nvrArr|Udblac|nwarhk|larrtl|nwnear|oacute|Oacute|latail|lAtail|sstarf|lbrace|odblac|Odblac|lbrack|udblac|odsold|eparsl|lcaron|Lcaron|ograve|Ograve|lcedil|Lcedil|Aacute|ssmile|ssetmn|squarf|ldquor|capcup|ominus|cylcty|rharul|eqcirc|dagger|rfloor|rfisht|Dagger|daleth|equals|origof|capdot|equest|dcaron|Dcaron|rdquor|oslash|Oslash|otilde|Otilde|otimes|Otimes|urcrop|Ubreve|ubreve|Yacute|Uacute|uacute|Rcedil|rcedil|urcorn|parsim|Rcaron|Vdashl|rcaron|Tstrok|percnt|period|permil|Exists|yacute|rbrack|rbrace|phmmat|ccaron|Ccaron|planck|ccedil|plankv|tstrok|female|plusdo|plusdu|ffilig|plusmn|ffllig|Ccedil|rAtail|dfisht|bernou|ratail|Rarrtl|rarrtl|angsph|rarrpl|rarrlp|rarrhk|xwedge|xotime|forall|ForAll|Vvdash|vsupnE|preceq|bigcap|frac12|frac13|frac14|primes|rarrfs|prnsim|frac15|Square|frac16|square|lesdot|frac18|frac23|propto|prurel|rarrap|rangle|puncsp|frac25|Racute|qprime|racute|lesges|frac34|abreve|AElig|eqsim|utdot|setmn|urtri|Equal|Uring|seArr|uring|searr|dashv|Dashv|mumap|nabla|iogon|Iogon|sdote|sdotb|scsim|napid|napos|equiv|natur|Acirc|dblac|erarr|nbump|iprod|erDot|ucirc|awint|esdot|angrt|ncong|isinE|scnap|Scirc|scirc|ndash|isins|Ubrcy|nearr|neArr|isinv|nedot|ubrcy|acute|Ycirc|iukcy|Iukcy|xutri|nesim|caret|jcirc|Jcirc|caron|twixt|ddarr|sccue|exist|jmath|sbquo|ngeqq|angst|ccaps|lceil|ngsim|UpTee|delta|Delta|rtrif|nharr|nhArr|nhpar|rtrie|jukcy|Jukcy|kappa|rsquo|Kappa|nlarr|nlArr|TSHcy|rrarr|aogon|Aogon|fflig|xrarr|tshcy|ccirc|nleqq|filig|upsih|nless|dharl|nlsim|fjlig|ropar|nltri|dharr|robrk|roarr|fllig|fltns|roang|rnmid|subnE|subne|lAarr|trisb|Ccirc|acirc|ccups|blank|VDash|forkv|Vdash|langd|cedil|blk12|blk14|laquo|strns|diams|notin|vDash|larrb|blk34|block|disin|uplus|vdash|vBarv|aelig|starf|Wedge|check|xrArr|lates|lbarr|lBarr|notni|lbbrk|bcong|frasl|lbrke|frown|vrtri|vprop|vnsup|gamma|Gamma|wedge|xodot|bdquo|srarr|doteq|ldquo|boxdl|boxdL|gcirc|Gcirc|boxDl|boxDL|boxdr|boxdR|boxDr|TRADE|trade|rlhar|boxDR|vnsub|npart|vltri|rlarr|boxhd|boxhD|nprec|gescc|nrarr|nrArr|boxHd|boxHD|boxhu|boxhU|nrtri|boxHu|clubs|boxHU|times|colon|Colon|gimel|xlArr|Tilde|nsime|tilde|nsmid|nspar|THORN|thorn|xlarr|nsube|nsubE|thkap|xhArr|comma|nsucc|boxul|boxuL|nsupe|nsupE|gneqq|gnsim|boxUl|boxUL|grave|boxur|boxuR|boxUr|boxUR|lescc|angle|bepsi|boxvh|varpi|boxvH|numsp|Theta|gsime|gsiml|theta|boxVh|boxVH|boxvl|gtcir|gtdot|boxvL|boxVl|boxVL|crarr|cross|Cross|nvsim|boxvr|nwarr|nwArr|sqsup|dtdot|Uogon|lhard|lharu|dtrif|ocirc|Ocirc|lhblk|duarr|odash|sqsub|Hacek|sqcup|llarr|duhar|oelig|OElig|ofcir|boxvR|uogon|lltri|boxVr|csube|uuarr|ohbar|csupe|ctdot|olarr|olcir|harrw|oline|sqcap|omacr|Omacr|omega|Omega|boxVR|aleph|lneqq|lnsim|loang|loarr|rharu|lobrk|hcirc|operp|oplus|rhard|Hcirc|orarr|Union|order|ecirc|Ecirc|cuepr|szlig|cuesc|breve|reals|eDDot|Breve|hoarr|lopar|utrif|rdquo|Umacr|umacr|efDot|swArr|ultri|alpha|rceil|ovbar|swarr|Wcirc|wcirc|smtes|smile|bsemi|lrarr|aring|parsl|lrhar|bsime|uhblk|lrtri|cupor|Aring|uharr|uharl|slarr|rbrke|bsolb|lsime|rbbrk|RBarr|lsimg|phone|rBarr|rbarr|icirc|lsquo|Icirc|emacr|Emacr|ratio|simne|plusb|simlE|simgE|simeq|pluse|ltcir|ltdot|empty|xharr|xdtri|iexcl|Alpha|ltrie|rarrw|pound|ltrif|xcirc|bumpe|prcue|bumpE|asymp|amacr|cuvee|Sigma|sigma|iiint|udhar|iiota|ijlig|IJlig|supnE|imacr|Imacr|prime|Prime|image|prnap|eogon|Eogon|rarrc|mdash|mDDot|cuwed|imath|supne|imped|Amacr|udarr|prsim|micro|rarrb|cwint|raquo|infin|eplus|range|rangd|Ucirc|radic|minus|amalg|veeeq|rAarr|epsiv|ycirc|quest|sharp|quot|zwnj|Qscr|race|qscr|Qopf|qopf|qint|rang|Rang|Zscr|zscr|Zopf|zopf|rarr|rArr|Rarr|Pscr|pscr|prop|prod|prnE|prec|ZHcy|zhcy|prap|Zeta|zeta|Popf|popf|Zdot|plus|zdot|Yuml|yuml|phiv|YUcy|yucy|Yscr|yscr|perp|Yopf|yopf|part|para|YIcy|Ouml|rcub|yicy|YAcy|rdca|ouml|osol|Oscr|rdsh|yacy|real|oscr|xvee|andd|rect|andv|Xscr|oror|ordm|ordf|xscr|ange|aopf|Aopf|rHar|Xopf|opar|Oopf|xopf|xnis|rhov|oopf|omid|xmap|oint|apid|apos|ogon|ascr|Ascr|odot|odiv|xcup|xcap|ocir|oast|nvlt|nvle|nvgt|nvge|nvap|Wscr|wscr|auml|ntlg|ntgl|nsup|nsub|nsim|Nscr|nscr|nsce|Wopf|ring|npre|wopf|npar|Auml|Barv|bbrk|Nopf|nopf|nmid|nLtv|beta|ropf|Ropf|Beta|beth|nles|rpar|nleq|bnot|bNot|nldr|NJcy|rscr|Rscr|Vscr|vscr|rsqb|njcy|bopf|nisd|Bopf|rtri|Vopf|nGtv|ngtr|vopf|boxh|boxH|boxv|nges|ngeq|boxV|bscr|scap|Bscr|bsim|Vert|vert|bsol|bull|bump|caps|cdot|ncup|scnE|ncap|nbsp|napE|Cdot|cent|sdot|Vbar|nang|vBar|chcy|Mscr|mscr|sect|semi|CHcy|Mopf|mopf|sext|circ|cire|mldr|mlcp|cirE|comp|shcy|SHcy|vArr|varr|cong|copf|Copf|copy|COPY|malt|male|macr|lvnE|cscr|ltri|sime|ltcc|simg|Cscr|siml|csub|Uuml|lsqb|lsim|uuml|csup|Lscr|lscr|utri|smid|lpar|cups|smte|lozf|darr|Lopf|Uscr|solb|lopf|sopf|Sopf|lneq|uscr|spar|dArr|lnap|Darr|dash|Sqrt|LJcy|ljcy|lHar|dHar|Upsi|upsi|diam|lesg|djcy|DJcy|leqq|dopf|Dopf|dscr|Dscr|dscy|ldsh|ldca|squf|DScy|sscr|Sscr|dsol|lcub|late|star|Star|Uopf|Larr|lArr|larr|uopf|dtri|dzcy|sube|subE|Lang|lang|Kscr|kscr|Kopf|kopf|KJcy|kjcy|KHcy|khcy|DZcy|ecir|edot|eDot|Jscr|jscr|succ|Jopf|jopf|Edot|uHar|emsp|ensp|Iuml|iuml|eopf|isin|Iscr|iscr|Eopf|epar|sung|epsi|escr|sup1|sup2|sup3|Iota|iota|supe|supE|Iopf|iopf|IOcy|iocy|Escr|esim|Esim|imof|Uarr|QUOT|uArr|uarr|euml|IEcy|iecy|Idot|Euml|euro|excl|Hscr|hscr|Hopf|hopf|TScy|tscy|Tscr|hbar|tscr|flat|tbrk|fnof|hArr|harr|half|fopf|Fopf|tdot|gvnE|fork|trie|gtcc|fscr|Fscr|gdot|gsim|Gscr|gscr|Gopf|gopf|gneq|Gdot|tosa|gnap|Topf|topf|geqq|toea|GJcy|gjcy|tint|gesl|mid|Sfr|ggg|top|ges|gla|glE|glj|geq|gne|gEl|gel|gnE|Gcy|gcy|gap|Tfr|tfr|Tcy|tcy|Hat|Tau|Ffr|tau|Tab|hfr|Hfr|ffr|Fcy|fcy|icy|Icy|iff|ETH|eth|ifr|Ifr|Eta|eta|int|Int|Sup|sup|ucy|Ucy|Sum|sum|jcy|ENG|ufr|Ufr|eng|Jcy|jfr|els|ell|egs|Efr|efr|Jfr|uml|kcy|Kcy|Ecy|ecy|kfr|Kfr|lap|Sub|sub|lat|lcy|Lcy|leg|Dot|dot|lEg|leq|les|squ|div|die|lfr|Lfr|lgE|Dfr|dfr|Del|deg|Dcy|dcy|lne|lnE|sol|loz|smt|Cup|lrm|cup|lsh|Lsh|sim|shy|map|Map|mcy|Mcy|mfr|Mfr|mho|gfr|Gfr|sfr|cir|Chi|chi|nap|Cfr|vcy|Vcy|cfr|Scy|scy|ncy|Ncy|vee|Vee|Cap|cap|nfr|scE|sce|Nfr|nge|ngE|nGg|vfr|Vfr|ngt|bot|nGt|nis|niv|Rsh|rsh|nle|nlE|bne|Bfr|bfr|nLl|nlt|nLt|Bcy|bcy|not|Not|rlm|wfr|Wfr|npr|nsc|num|ocy|ast|Ocy|ofr|xfr|Xfr|Ofr|ogt|ohm|apE|olt|Rho|ape|rho|Rfr|rfr|ord|REG|ang|reg|orv|And|and|AMP|Rcy|amp|Afr|ycy|Ycy|yen|yfr|Yfr|rcy|par|pcy|Pcy|pfr|Pfr|phi|Phi|afr|Acy|acy|zcy|Zcy|piv|acE|acd|zfr|Zfr|pre|prE|psi|Psi|qfr|Qfr|zwj|Or|ge|Gg|gt|gg|el|oS|lt|Lt|LT|Re|lg|gl|eg|ne|Im|it|le|DD|wp|wr|nu|Nu|dd|lE|Sc|sc|pi|Pi|ee|af|ll|Ll|rx|gE|xi|pm|Xi|ic|pr|Pr|in|ni|mp|mu|ac|Mu|or|ap|Gt|GT|ii);|&(Aacute|Agrave|Atilde|Ccedil|Eacute|Egrave|Iacute|Igrave|Ntilde|Oacute|Ograve|Oslash|Otilde|Uacute|Ugrave|Yacute|aacute|agrave|atilde|brvbar|ccedil|curren|divide|eacute|egrave|frac12|frac14|frac34|iacute|igrave|iquest|middot|ntilde|oacute|ograve|oslash|otilde|plusmn|uacute|ugrave|yacute|AElig|Acirc|Aring|Ecirc|Icirc|Ocirc|THORN|Ucirc|acirc|acute|aelig|aring|cedil|ecirc|icirc|iexcl|laquo|micro|ocirc|pound|raquo|szlig|thorn|times|ucirc|Auml|COPY|Euml|Iuml|Ouml|QUOT|Uuml|auml|cent|copy|euml|iuml|macr|nbsp|ordf|ordm|ouml|para|quot|sect|sup1|sup2|sup3|uuml|yuml|AMP|ETH|REG|amp|deg|eth|not|reg|shy|uml|yen|GT|LT|gt|lt)(?!;)([=a-zA-Z0-9]?)|&#([0-9]+)(;?)|&#[xX]([a-fA-F0-9]+)(;?)|&([0-9a-zA-Z]+)/g;
    var decodeMap = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "abreve": "\u0103",
        "Abreve": "\u0102",
        "ac": "\u223E",
        "acd": "\u223F",
        "acE": "\u223E\u0333",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "acy": "\u0430",
        "Acy": "\u0410",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "af": "\u2061",
        "afr": "\uD835\uDD1E",
        "Afr": "\uD835\uDD04",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "alefsym": "\u2135",
        "aleph": "\u2135",
        "alpha": "\u03B1",
        "Alpha": "\u0391",
        "amacr": "\u0101",
        "Amacr": "\u0100",
        "amalg": "\u2A3F",
        "amp": "&",
        "AMP": "&",
        "and": "\u2227",
        "And": "\u2A53",
        "andand": "\u2A55",
        "andd": "\u2A5C",
        "andslope": "\u2A58",
        "andv": "\u2A5A",
        "ang": "\u2220",
        "ange": "\u29A4",
        "angle": "\u2220",
        "angmsd": "\u2221",
        "angmsdaa": "\u29A8",
        "angmsdab": "\u29A9",
        "angmsdac": "\u29AA",
        "angmsdad": "\u29AB",
        "angmsdae": "\u29AC",
        "angmsdaf": "\u29AD",
        "angmsdag": "\u29AE",
        "angmsdah": "\u29AF",
        "angrt": "\u221F",
        "angrtvb": "\u22BE",
        "angrtvbd": "\u299D",
        "angsph": "\u2222",
        "angst": "\xc5",
        "angzarr": "\u237C",
        "aogon": "\u0105",
        "Aogon": "\u0104",
        "aopf": "\uD835\uDD52",
        "Aopf": "\uD835\uDD38",
        "ap": "\u2248",
        "apacir": "\u2A6F",
        "ape": "\u224A",
        "apE": "\u2A70",
        "apid": "\u224B",
        "apos": "'",
        "ApplyFunction": "\u2061",
        "approx": "\u2248",
        "approxeq": "\u224A",
        "aring": "\xe5",
        "Aring": "\xc5",
        "ascr": "\uD835\uDCB6",
        "Ascr": "\uD835\uDC9C",
        "Assign": "\u2254",
        "ast": "*",
        "asymp": "\u2248",
        "asympeq": "\u224D",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "awconint": "\u2233",
        "awint": "\u2A11",
        "backcong": "\u224C",
        "backepsilon": "\u03F6",
        "backprime": "\u2035",
        "backsim": "\u223D",
        "backsimeq": "\u22CD",
        "Backslash": "\u2216",
        "Barv": "\u2AE7",
        "barvee": "\u22BD",
        "barwed": "\u2305",
        "Barwed": "\u2306",
        "barwedge": "\u2305",
        "bbrk": "\u23B5",
        "bbrktbrk": "\u23B6",
        "bcong": "\u224C",
        "bcy": "\u0431",
        "Bcy": "\u0411",
        "bdquo": "\u201E",
        "becaus": "\u2235",
        "because": "\u2235",
        "Because": "\u2235",
        "bemptyv": "\u29B0",
        "bepsi": "\u03F6",
        "bernou": "\u212C",
        "Bernoullis": "\u212C",
        "beta": "\u03B2",
        "Beta": "\u0392",
        "beth": "\u2136",
        "between": "\u226C",
        "bfr": "\uD835\uDD1F",
        "Bfr": "\uD835\uDD05",
        "bigcap": "\u22C2",
        "bigcirc": "\u25EF",
        "bigcup": "\u22C3",
        "bigodot": "\u2A00",
        "bigoplus": "\u2A01",
        "bigotimes": "\u2A02",
        "bigsqcup": "\u2A06",
        "bigstar": "\u2605",
        "bigtriangledown": "\u25BD",
        "bigtriangleup": "\u25B3",
        "biguplus": "\u2A04",
        "bigvee": "\u22C1",
        "bigwedge": "\u22C0",
        "bkarow": "\u290D",
        "blacklozenge": "\u29EB",
        "blacksquare": "\u25AA",
        "blacktriangle": "\u25B4",
        "blacktriangledown": "\u25BE",
        "blacktriangleleft": "\u25C2",
        "blacktriangleright": "\u25B8",
        "blank": "\u2423",
        "blk12": "\u2592",
        "blk14": "\u2591",
        "blk34": "\u2593",
        "block": "\u2588",
        "bne": "=\u20E5",
        "bnequiv": "\u2261\u20E5",
        "bnot": "\u2310",
        "bNot": "\u2AED",
        "bopf": "\uD835\uDD53",
        "Bopf": "\uD835\uDD39",
        "bot": "\u22A5",
        "bottom": "\u22A5",
        "bowtie": "\u22C8",
        "boxbox": "\u29C9",
        "boxdl": "\u2510",
        "boxdL": "\u2555",
        "boxDl": "\u2556",
        "boxDL": "\u2557",
        "boxdr": "\u250C",
        "boxdR": "\u2552",
        "boxDr": "\u2553",
        "boxDR": "\u2554",
        "boxh": "\u2500",
        "boxH": "\u2550",
        "boxhd": "\u252C",
        "boxhD": "\u2565",
        "boxHd": "\u2564",
        "boxHD": "\u2566",
        "boxhu": "\u2534",
        "boxhU": "\u2568",
        "boxHu": "\u2567",
        "boxHU": "\u2569",
        "boxminus": "\u229F",
        "boxplus": "\u229E",
        "boxtimes": "\u22A0",
        "boxul": "\u2518",
        "boxuL": "\u255B",
        "boxUl": "\u255C",
        "boxUL": "\u255D",
        "boxur": "\u2514",
        "boxuR": "\u2558",
        "boxUr": "\u2559",
        "boxUR": "\u255A",
        "boxv": "\u2502",
        "boxV": "\u2551",
        "boxvh": "\u253C",
        "boxvH": "\u256A",
        "boxVh": "\u256B",
        "boxVH": "\u256C",
        "boxvl": "\u2524",
        "boxvL": "\u2561",
        "boxVl": "\u2562",
        "boxVL": "\u2563",
        "boxvr": "\u251C",
        "boxvR": "\u255E",
        "boxVr": "\u255F",
        "boxVR": "\u2560",
        "bprime": "\u2035",
        "breve": "\u02D8",
        "Breve": "\u02D8",
        "brvbar": "\xa6",
        "bscr": "\uD835\uDCB7",
        "Bscr": "\u212C",
        "bsemi": "\u204F",
        "bsim": "\u223D",
        "bsime": "\u22CD",
        "bsol": "\\",
        "bsolb": "\u29C5",
        "bsolhsub": "\u27C8",
        "bull": "\u2022",
        "bullet": "\u2022",
        "bump": "\u224E",
        "bumpe": "\u224F",
        "bumpE": "\u2AAE",
        "bumpeq": "\u224F",
        "Bumpeq": "\u224E",
        "cacute": "\u0107",
        "Cacute": "\u0106",
        "cap": "\u2229",
        "Cap": "\u22D2",
        "capand": "\u2A44",
        "capbrcup": "\u2A49",
        "capcap": "\u2A4B",
        "capcup": "\u2A47",
        "capdot": "\u2A40",
        "CapitalDifferentialD": "\u2145",
        "caps": "\u2229\uFE00",
        "caret": "\u2041",
        "caron": "\u02C7",
        "Cayleys": "\u212D",
        "ccaps": "\u2A4D",
        "ccaron": "\u010D",
        "Ccaron": "\u010C",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "ccirc": "\u0109",
        "Ccirc": "\u0108",
        "Cconint": "\u2230",
        "ccups": "\u2A4C",
        "ccupssm": "\u2A50",
        "cdot": "\u010B",
        "Cdot": "\u010A",
        "cedil": "\xb8",
        "Cedilla": "\xb8",
        "cemptyv": "\u29B2",
        "cent": "\xa2",
        "centerdot": "\xb7",
        "CenterDot": "\xb7",
        "cfr": "\uD835\uDD20",
        "Cfr": "\u212D",
        "chcy": "\u0447",
        "CHcy": "\u0427",
        "check": "\u2713",
        "checkmark": "\u2713",
        "chi": "\u03C7",
        "Chi": "\u03A7",
        "cir": "\u25CB",
        "circ": "\u02C6",
        "circeq": "\u2257",
        "circlearrowleft": "\u21BA",
        "circlearrowright": "\u21BB",
        "circledast": "\u229B",
        "circledcirc": "\u229A",
        "circleddash": "\u229D",
        "CircleDot": "\u2299",
        "circledR": "\xae",
        "circledS": "\u24C8",
        "CircleMinus": "\u2296",
        "CirclePlus": "\u2295",
        "CircleTimes": "\u2297",
        "cire": "\u2257",
        "cirE": "\u29C3",
        "cirfnint": "\u2A10",
        "cirmid": "\u2AEF",
        "cirscir": "\u29C2",
        "ClockwiseContourIntegral": "\u2232",
        "CloseCurlyDoubleQuote": "\u201D",
        "CloseCurlyQuote": "\u2019",
        "clubs": "\u2663",
        "clubsuit": "\u2663",
        "colon": ":",
        "Colon": "\u2237",
        "colone": "\u2254",
        "Colone": "\u2A74",
        "coloneq": "\u2254",
        "comma": ",",
        "commat": "@",
        "comp": "\u2201",
        "compfn": "\u2218",
        "complement": "\u2201",
        "complexes": "\u2102",
        "cong": "\u2245",
        "congdot": "\u2A6D",
        "Congruent": "\u2261",
        "conint": "\u222E",
        "Conint": "\u222F",
        "ContourIntegral": "\u222E",
        "copf": "\uD835\uDD54",
        "Copf": "\u2102",
        "coprod": "\u2210",
        "Coproduct": "\u2210",
        "copy": "\xa9",
        "COPY": "\xa9",
        "copysr": "\u2117",
        "CounterClockwiseContourIntegral": "\u2233",
        "crarr": "\u21B5",
        "cross": "\u2717",
        "Cross": "\u2A2F",
        "cscr": "\uD835\uDCB8",
        "Cscr": "\uD835\uDC9E",
        "csub": "\u2ACF",
        "csube": "\u2AD1",
        "csup": "\u2AD0",
        "csupe": "\u2AD2",
        "ctdot": "\u22EF",
        "cudarrl": "\u2938",
        "cudarrr": "\u2935",
        "cuepr": "\u22DE",
        "cuesc": "\u22DF",
        "cularr": "\u21B6",
        "cularrp": "\u293D",
        "cup": "\u222A",
        "Cup": "\u22D3",
        "cupbrcap": "\u2A48",
        "cupcap": "\u2A46",
        "CupCap": "\u224D",
        "cupcup": "\u2A4A",
        "cupdot": "\u228D",
        "cupor": "\u2A45",
        "cups": "\u222A\uFE00",
        "curarr": "\u21B7",
        "curarrm": "\u293C",
        "curlyeqprec": "\u22DE",
        "curlyeqsucc": "\u22DF",
        "curlyvee": "\u22CE",
        "curlywedge": "\u22CF",
        "curren": "\xa4",
        "curvearrowleft": "\u21B6",
        "curvearrowright": "\u21B7",
        "cuvee": "\u22CE",
        "cuwed": "\u22CF",
        "cwconint": "\u2232",
        "cwint": "\u2231",
        "cylcty": "\u232D",
        "dagger": "\u2020",
        "Dagger": "\u2021",
        "daleth": "\u2138",
        "darr": "\u2193",
        "dArr": "\u21D3",
        "Darr": "\u21A1",
        "dash": "\u2010",
        "dashv": "\u22A3",
        "Dashv": "\u2AE4",
        "dbkarow": "\u290F",
        "dblac": "\u02DD",
        "dcaron": "\u010F",
        "Dcaron": "\u010E",
        "dcy": "\u0434",
        "Dcy": "\u0414",
        "dd": "\u2146",
        "DD": "\u2145",
        "ddagger": "\u2021",
        "ddarr": "\u21CA",
        "DDotrahd": "\u2911",
        "ddotseq": "\u2A77",
        "deg": "\xb0",
        "Del": "\u2207",
        "delta": "\u03B4",
        "Delta": "\u0394",
        "demptyv": "\u29B1",
        "dfisht": "\u297F",
        "dfr": "\uD835\uDD21",
        "Dfr": "\uD835\uDD07",
        "dHar": "\u2965",
        "dharl": "\u21C3",
        "dharr": "\u21C2",
        "DiacriticalAcute": "\xb4",
        "DiacriticalDot": "\u02D9",
        "DiacriticalDoubleAcute": "\u02DD",
        "DiacriticalGrave": "`",
        "DiacriticalTilde": "\u02DC",
        "diam": "\u22C4",
        "diamond": "\u22C4",
        "Diamond": "\u22C4",
        "diamondsuit": "\u2666",
        "diams": "\u2666",
        "die": "\xa8",
        "DifferentialD": "\u2146",
        "digamma": "\u03DD",
        "disin": "\u22F2",
        "div": "\xf7",
        "divide": "\xf7",
        "divideontimes": "\u22C7",
        "divonx": "\u22C7",
        "djcy": "\u0452",
        "DJcy": "\u0402",
        "dlcorn": "\u231E",
        "dlcrop": "\u230D",
        "dollar": "$",
        "dopf": "\uD835\uDD55",
        "Dopf": "\uD835\uDD3B",
        "dot": "\u02D9",
        "Dot": "\xa8",
        "DotDot": "\u20DC",
        "doteq": "\u2250",
        "doteqdot": "\u2251",
        "DotEqual": "\u2250",
        "dotminus": "\u2238",
        "dotplus": "\u2214",
        "dotsquare": "\u22A1",
        "doublebarwedge": "\u2306",
        "DoubleContourIntegral": "\u222F",
        "DoubleDot": "\xa8",
        "DoubleDownArrow": "\u21D3",
        "DoubleLeftArrow": "\u21D0",
        "DoubleLeftRightArrow": "\u21D4",
        "DoubleLeftTee": "\u2AE4",
        "DoubleLongLeftArrow": "\u27F8",
        "DoubleLongLeftRightArrow": "\u27FA",
        "DoubleLongRightArrow": "\u27F9",
        "DoubleRightArrow": "\u21D2",
        "DoubleRightTee": "\u22A8",
        "DoubleUpArrow": "\u21D1",
        "DoubleUpDownArrow": "\u21D5",
        "DoubleVerticalBar": "\u2225",
        "downarrow": "\u2193",
        "Downarrow": "\u21D3",
        "DownArrow": "\u2193",
        "DownArrowBar": "\u2913",
        "DownArrowUpArrow": "\u21F5",
        "DownBreve": "\u0311",
        "downdownarrows": "\u21CA",
        "downharpoonleft": "\u21C3",
        "downharpoonright": "\u21C2",
        "DownLeftRightVector": "\u2950",
        "DownLeftTeeVector": "\u295E",
        "DownLeftVector": "\u21BD",
        "DownLeftVectorBar": "\u2956",
        "DownRightTeeVector": "\u295F",
        "DownRightVector": "\u21C1",
        "DownRightVectorBar": "\u2957",
        "DownTee": "\u22A4",
        "DownTeeArrow": "\u21A7",
        "drbkarow": "\u2910",
        "drcorn": "\u231F",
        "drcrop": "\u230C",
        "dscr": "\uD835\uDCB9",
        "Dscr": "\uD835\uDC9F",
        "dscy": "\u0455",
        "DScy": "\u0405",
        "dsol": "\u29F6",
        "dstrok": "\u0111",
        "Dstrok": "\u0110",
        "dtdot": "\u22F1",
        "dtri": "\u25BF",
        "dtrif": "\u25BE",
        "duarr": "\u21F5",
        "duhar": "\u296F",
        "dwangle": "\u29A6",
        "dzcy": "\u045F",
        "DZcy": "\u040F",
        "dzigrarr": "\u27FF",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "easter": "\u2A6E",
        "ecaron": "\u011B",
        "Ecaron": "\u011A",
        "ecir": "\u2256",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "ecolon": "\u2255",
        "ecy": "\u044D",
        "Ecy": "\u042D",
        "eDDot": "\u2A77",
        "edot": "\u0117",
        "eDot": "\u2251",
        "Edot": "\u0116",
        "ee": "\u2147",
        "efDot": "\u2252",
        "efr": "\uD835\uDD22",
        "Efr": "\uD835\uDD08",
        "eg": "\u2A9A",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "egs": "\u2A96",
        "egsdot": "\u2A98",
        "el": "\u2A99",
        "Element": "\u2208",
        "elinters": "\u23E7",
        "ell": "\u2113",
        "els": "\u2A95",
        "elsdot": "\u2A97",
        "emacr": "\u0113",
        "Emacr": "\u0112",
        "empty": "\u2205",
        "emptyset": "\u2205",
        "EmptySmallSquare": "\u25FB",
        "emptyv": "\u2205",
        "EmptyVerySmallSquare": "\u25AB",
        "emsp": "\u2003",
        "emsp13": "\u2004",
        "emsp14": "\u2005",
        "eng": "\u014B",
        "ENG": "\u014A",
        "ensp": "\u2002",
        "eogon": "\u0119",
        "Eogon": "\u0118",
        "eopf": "\uD835\uDD56",
        "Eopf": "\uD835\uDD3C",
        "epar": "\u22D5",
        "eparsl": "\u29E3",
        "eplus": "\u2A71",
        "epsi": "\u03B5",
        "epsilon": "\u03B5",
        "Epsilon": "\u0395",
        "epsiv": "\u03F5",
        "eqcirc": "\u2256",
        "eqcolon": "\u2255",
        "eqsim": "\u2242",
        "eqslantgtr": "\u2A96",
        "eqslantless": "\u2A95",
        "Equal": "\u2A75",
        "equals": "=",
        "EqualTilde": "\u2242",
        "equest": "\u225F",
        "Equilibrium": "\u21CC",
        "equiv": "\u2261",
        "equivDD": "\u2A78",
        "eqvparsl": "\u29E5",
        "erarr": "\u2971",
        "erDot": "\u2253",
        "escr": "\u212F",
        "Escr": "\u2130",
        "esdot": "\u2250",
        "esim": "\u2242",
        "Esim": "\u2A73",
        "eta": "\u03B7",
        "Eta": "\u0397",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "euro": "\u20AC",
        "excl": "!",
        "exist": "\u2203",
        "Exists": "\u2203",
        "expectation": "\u2130",
        "exponentiale": "\u2147",
        "ExponentialE": "\u2147",
        "fallingdotseq": "\u2252",
        "fcy": "\u0444",
        "Fcy": "\u0424",
        "female": "\u2640",
        "ffilig": "\uFB03",
        "fflig": "\uFB00",
        "ffllig": "\uFB04",
        "ffr": "\uD835\uDD23",
        "Ffr": "\uD835\uDD09",
        "filig": "\uFB01",
        "FilledSmallSquare": "\u25FC",
        "FilledVerySmallSquare": "\u25AA",
        "fjlig": "fj",
        "flat": "\u266D",
        "fllig": "\uFB02",
        "fltns": "\u25B1",
        "fnof": "\u0192",
        "fopf": "\uD835\uDD57",
        "Fopf": "\uD835\uDD3D",
        "forall": "\u2200",
        "ForAll": "\u2200",
        "fork": "\u22D4",
        "forkv": "\u2AD9",
        "Fouriertrf": "\u2131",
        "fpartint": "\u2A0D",
        "frac12": "\xbd",
        "frac13": "\u2153",
        "frac14": "\xbc",
        "frac15": "\u2155",
        "frac16": "\u2159",
        "frac18": "\u215B",
        "frac23": "\u2154",
        "frac25": "\u2156",
        "frac34": "\xbe",
        "frac35": "\u2157",
        "frac38": "\u215C",
        "frac45": "\u2158",
        "frac56": "\u215A",
        "frac58": "\u215D",
        "frac78": "\u215E",
        "frasl": "\u2044",
        "frown": "\u2322",
        "fscr": "\uD835\uDCBB",
        "Fscr": "\u2131",
        "gacute": "\u01F5",
        "gamma": "\u03B3",
        "Gamma": "\u0393",
        "gammad": "\u03DD",
        "Gammad": "\u03DC",
        "gap": "\u2A86",
        "gbreve": "\u011F",
        "Gbreve": "\u011E",
        "Gcedil": "\u0122",
        "gcirc": "\u011D",
        "Gcirc": "\u011C",
        "gcy": "\u0433",
        "Gcy": "\u0413",
        "gdot": "\u0121",
        "Gdot": "\u0120",
        "ge": "\u2265",
        "gE": "\u2267",
        "gel": "\u22DB",
        "gEl": "\u2A8C",
        "geq": "\u2265",
        "geqq": "\u2267",
        "geqslant": "\u2A7E",
        "ges": "\u2A7E",
        "gescc": "\u2AA9",
        "gesdot": "\u2A80",
        "gesdoto": "\u2A82",
        "gesdotol": "\u2A84",
        "gesl": "\u22DB\uFE00",
        "gesles": "\u2A94",
        "gfr": "\uD835\uDD24",
        "Gfr": "\uD835\uDD0A",
        "gg": "\u226B",
        "Gg": "\u22D9",
        "ggg": "\u22D9",
        "gimel": "\u2137",
        "gjcy": "\u0453",
        "GJcy": "\u0403",
        "gl": "\u2277",
        "gla": "\u2AA5",
        "glE": "\u2A92",
        "glj": "\u2AA4",
        "gnap": "\u2A8A",
        "gnapprox": "\u2A8A",
        "gne": "\u2A88",
        "gnE": "\u2269",
        "gneq": "\u2A88",
        "gneqq": "\u2269",
        "gnsim": "\u22E7",
        "gopf": "\uD835\uDD58",
        "Gopf": "\uD835\uDD3E",
        "grave": "`",
        "GreaterEqual": "\u2265",
        "GreaterEqualLess": "\u22DB",
        "GreaterFullEqual": "\u2267",
        "GreaterGreater": "\u2AA2",
        "GreaterLess": "\u2277",
        "GreaterSlantEqual": "\u2A7E",
        "GreaterTilde": "\u2273",
        "gscr": "\u210A",
        "Gscr": "\uD835\uDCA2",
        "gsim": "\u2273",
        "gsime": "\u2A8E",
        "gsiml": "\u2A90",
        "gt": ">",
        "Gt": "\u226B",
        "GT": ">",
        "gtcc": "\u2AA7",
        "gtcir": "\u2A7A",
        "gtdot": "\u22D7",
        "gtlPar": "\u2995",
        "gtquest": "\u2A7C",
        "gtrapprox": "\u2A86",
        "gtrarr": "\u2978",
        "gtrdot": "\u22D7",
        "gtreqless": "\u22DB",
        "gtreqqless": "\u2A8C",
        "gtrless": "\u2277",
        "gtrsim": "\u2273",
        "gvertneqq": "\u2269\uFE00",
        "gvnE": "\u2269\uFE00",
        "Hacek": "\u02C7",
        "hairsp": "\u200A",
        "half": "\xbd",
        "hamilt": "\u210B",
        "hardcy": "\u044A",
        "HARDcy": "\u042A",
        "harr": "\u2194",
        "hArr": "\u21D4",
        "harrcir": "\u2948",
        "harrw": "\u21AD",
        "Hat": "^",
        "hbar": "\u210F",
        "hcirc": "\u0125",
        "Hcirc": "\u0124",
        "hearts": "\u2665",
        "heartsuit": "\u2665",
        "hellip": "\u2026",
        "hercon": "\u22B9",
        "hfr": "\uD835\uDD25",
        "Hfr": "\u210C",
        "HilbertSpace": "\u210B",
        "hksearow": "\u2925",
        "hkswarow": "\u2926",
        "hoarr": "\u21FF",
        "homtht": "\u223B",
        "hookleftarrow": "\u21A9",
        "hookrightarrow": "\u21AA",
        "hopf": "\uD835\uDD59",
        "Hopf": "\u210D",
        "horbar": "\u2015",
        "HorizontalLine": "\u2500",
        "hscr": "\uD835\uDCBD",
        "Hscr": "\u210B",
        "hslash": "\u210F",
        "hstrok": "\u0127",
        "Hstrok": "\u0126",
        "HumpDownHump": "\u224E",
        "HumpEqual": "\u224F",
        "hybull": "\u2043",
        "hyphen": "\u2010",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "ic": "\u2063",
        "icirc": "\xee",
        "Icirc": "\xce",
        "icy": "\u0438",
        "Icy": "\u0418",
        "Idot": "\u0130",
        "iecy": "\u0435",
        "IEcy": "\u0415",
        "iexcl": "\xa1",
        "iff": "\u21D4",
        "ifr": "\uD835\uDD26",
        "Ifr": "\u2111",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "ii": "\u2148",
        "iiiint": "\u2A0C",
        "iiint": "\u222D",
        "iinfin": "\u29DC",
        "iiota": "\u2129",
        "ijlig": "\u0133",
        "IJlig": "\u0132",
        "Im": "\u2111",
        "imacr": "\u012B",
        "Imacr": "\u012A",
        "image": "\u2111",
        "ImaginaryI": "\u2148",
        "imagline": "\u2110",
        "imagpart": "\u2111",
        "imath": "\u0131",
        "imof": "\u22B7",
        "imped": "\u01B5",
        "Implies": "\u21D2",
        "in": "\u2208",
        "incare": "\u2105",
        "infin": "\u221E",
        "infintie": "\u29DD",
        "inodot": "\u0131",
        "int": "\u222B",
        "Int": "\u222C",
        "intcal": "\u22BA",
        "integers": "\u2124",
        "Integral": "\u222B",
        "intercal": "\u22BA",
        "Intersection": "\u22C2",
        "intlarhk": "\u2A17",
        "intprod": "\u2A3C",
        "InvisibleComma": "\u2063",
        "InvisibleTimes": "\u2062",
        "iocy": "\u0451",
        "IOcy": "\u0401",
        "iogon": "\u012F",
        "Iogon": "\u012E",
        "iopf": "\uD835\uDD5A",
        "Iopf": "\uD835\uDD40",
        "iota": "\u03B9",
        "Iota": "\u0399",
        "iprod": "\u2A3C",
        "iquest": "\xbf",
        "iscr": "\uD835\uDCBE",
        "Iscr": "\u2110",
        "isin": "\u2208",
        "isindot": "\u22F5",
        "isinE": "\u22F9",
        "isins": "\u22F4",
        "isinsv": "\u22F3",
        "isinv": "\u2208",
        "it": "\u2062",
        "itilde": "\u0129",
        "Itilde": "\u0128",
        "iukcy": "\u0456",
        "Iukcy": "\u0406",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "jcirc": "\u0135",
        "Jcirc": "\u0134",
        "jcy": "\u0439",
        "Jcy": "\u0419",
        "jfr": "\uD835\uDD27",
        "Jfr": "\uD835\uDD0D",
        "jmath": "\u0237",
        "jopf": "\uD835\uDD5B",
        "Jopf": "\uD835\uDD41",
        "jscr": "\uD835\uDCBF",
        "Jscr": "\uD835\uDCA5",
        "jsercy": "\u0458",
        "Jsercy": "\u0408",
        "jukcy": "\u0454",
        "Jukcy": "\u0404",
        "kappa": "\u03BA",
        "Kappa": "\u039A",
        "kappav": "\u03F0",
        "kcedil": "\u0137",
        "Kcedil": "\u0136",
        "kcy": "\u043A",
        "Kcy": "\u041A",
        "kfr": "\uD835\uDD28",
        "Kfr": "\uD835\uDD0E",
        "kgreen": "\u0138",
        "khcy": "\u0445",
        "KHcy": "\u0425",
        "kjcy": "\u045C",
        "KJcy": "\u040C",
        "kopf": "\uD835\uDD5C",
        "Kopf": "\uD835\uDD42",
        "kscr": "\uD835\uDCC0",
        "Kscr": "\uD835\uDCA6",
        "lAarr": "\u21DA",
        "lacute": "\u013A",
        "Lacute": "\u0139",
        "laemptyv": "\u29B4",
        "lagran": "\u2112",
        "lambda": "\u03BB",
        "Lambda": "\u039B",
        "lang": "\u27E8",
        "Lang": "\u27EA",
        "langd": "\u2991",
        "langle": "\u27E8",
        "lap": "\u2A85",
        "Laplacetrf": "\u2112",
        "laquo": "\xab",
        "larr": "\u2190",
        "lArr": "\u21D0",
        "Larr": "\u219E",
        "larrb": "\u21E4",
        "larrbfs": "\u291F",
        "larrfs": "\u291D",
        "larrhk": "\u21A9",
        "larrlp": "\u21AB",
        "larrpl": "\u2939",
        "larrsim": "\u2973",
        "larrtl": "\u21A2",
        "lat": "\u2AAB",
        "latail": "\u2919",
        "lAtail": "\u291B",
        "late": "\u2AAD",
        "lates": "\u2AAD\uFE00",
        "lbarr": "\u290C",
        "lBarr": "\u290E",
        "lbbrk": "\u2772",
        "lbrace": "{",
        "lbrack": "[",
        "lbrke": "\u298B",
        "lbrksld": "\u298F",
        "lbrkslu": "\u298D",
        "lcaron": "\u013E",
        "Lcaron": "\u013D",
        "lcedil": "\u013C",
        "Lcedil": "\u013B",
        "lceil": "\u2308",
        "lcub": "{",
        "lcy": "\u043B",
        "Lcy": "\u041B",
        "ldca": "\u2936",
        "ldquo": "\u201C",
        "ldquor": "\u201E",
        "ldrdhar": "\u2967",
        "ldrushar": "\u294B",
        "ldsh": "\u21B2",
        "le": "\u2264",
        "lE": "\u2266",
        "LeftAngleBracket": "\u27E8",
        "leftarrow": "\u2190",
        "Leftarrow": "\u21D0",
        "LeftArrow": "\u2190",
        "LeftArrowBar": "\u21E4",
        "LeftArrowRightArrow": "\u21C6",
        "leftarrowtail": "\u21A2",
        "LeftCeiling": "\u2308",
        "LeftDoubleBracket": "\u27E6",
        "LeftDownTeeVector": "\u2961",
        "LeftDownVector": "\u21C3",
        "LeftDownVectorBar": "\u2959",
        "LeftFloor": "\u230A",
        "leftharpoondown": "\u21BD",
        "leftharpoonup": "\u21BC",
        "leftleftarrows": "\u21C7",
        "leftrightarrow": "\u2194",
        "Leftrightarrow": "\u21D4",
        "LeftRightArrow": "\u2194",
        "leftrightarrows": "\u21C6",
        "leftrightharpoons": "\u21CB",
        "leftrightsquigarrow": "\u21AD",
        "LeftRightVector": "\u294E",
        "LeftTee": "\u22A3",
        "LeftTeeArrow": "\u21A4",
        "LeftTeeVector": "\u295A",
        "leftthreetimes": "\u22CB",
        "LeftTriangle": "\u22B2",
        "LeftTriangleBar": "\u29CF",
        "LeftTriangleEqual": "\u22B4",
        "LeftUpDownVector": "\u2951",
        "LeftUpTeeVector": "\u2960",
        "LeftUpVector": "\u21BF",
        "LeftUpVectorBar": "\u2958",
        "LeftVector": "\u21BC",
        "LeftVectorBar": "\u2952",
        "leg": "\u22DA",
        "lEg": "\u2A8B",
        "leq": "\u2264",
        "leqq": "\u2266",
        "leqslant": "\u2A7D",
        "les": "\u2A7D",
        "lescc": "\u2AA8",
        "lesdot": "\u2A7F",
        "lesdoto": "\u2A81",
        "lesdotor": "\u2A83",
        "lesg": "\u22DA\uFE00",
        "lesges": "\u2A93",
        "lessapprox": "\u2A85",
        "lessdot": "\u22D6",
        "lesseqgtr": "\u22DA",
        "lesseqqgtr": "\u2A8B",
        "LessEqualGreater": "\u22DA",
        "LessFullEqual": "\u2266",
        "LessGreater": "\u2276",
        "lessgtr": "\u2276",
        "LessLess": "\u2AA1",
        "lesssim": "\u2272",
        "LessSlantEqual": "\u2A7D",
        "LessTilde": "\u2272",
        "lfisht": "\u297C",
        "lfloor": "\u230A",
        "lfr": "\uD835\uDD29",
        "Lfr": "\uD835\uDD0F",
        "lg": "\u2276",
        "lgE": "\u2A91",
        "lHar": "\u2962",
        "lhard": "\u21BD",
        "lharu": "\u21BC",
        "lharul": "\u296A",
        "lhblk": "\u2584",
        "ljcy": "\u0459",
        "LJcy": "\u0409",
        "ll": "\u226A",
        "Ll": "\u22D8",
        "llarr": "\u21C7",
        "llcorner": "\u231E",
        "Lleftarrow": "\u21DA",
        "llhard": "\u296B",
        "lltri": "\u25FA",
        "lmidot": "\u0140",
        "Lmidot": "\u013F",
        "lmoust": "\u23B0",
        "lmoustache": "\u23B0",
        "lnap": "\u2A89",
        "lnapprox": "\u2A89",
        "lne": "\u2A87",
        "lnE": "\u2268",
        "lneq": "\u2A87",
        "lneqq": "\u2268",
        "lnsim": "\u22E6",
        "loang": "\u27EC",
        "loarr": "\u21FD",
        "lobrk": "\u27E6",
        "longleftarrow": "\u27F5",
        "Longleftarrow": "\u27F8",
        "LongLeftArrow": "\u27F5",
        "longleftrightarrow": "\u27F7",
        "Longleftrightarrow": "\u27FA",
        "LongLeftRightArrow": "\u27F7",
        "longmapsto": "\u27FC",
        "longrightarrow": "\u27F6",
        "Longrightarrow": "\u27F9",
        "LongRightArrow": "\u27F6",
        "looparrowleft": "\u21AB",
        "looparrowright": "\u21AC",
        "lopar": "\u2985",
        "lopf": "\uD835\uDD5D",
        "Lopf": "\uD835\uDD43",
        "loplus": "\u2A2D",
        "lotimes": "\u2A34",
        "lowast": "\u2217",
        "lowbar": "_",
        "LowerLeftArrow": "\u2199",
        "LowerRightArrow": "\u2198",
        "loz": "\u25CA",
        "lozenge": "\u25CA",
        "lozf": "\u29EB",
        "lpar": "(",
        "lparlt": "\u2993",
        "lrarr": "\u21C6",
        "lrcorner": "\u231F",
        "lrhar": "\u21CB",
        "lrhard": "\u296D",
        "lrm": "\u200E",
        "lrtri": "\u22BF",
        "lsaquo": "\u2039",
        "lscr": "\uD835\uDCC1",
        "Lscr": "\u2112",
        "lsh": "\u21B0",
        "Lsh": "\u21B0",
        "lsim": "\u2272",
        "lsime": "\u2A8D",
        "lsimg": "\u2A8F",
        "lsqb": "[",
        "lsquo": "\u2018",
        "lsquor": "\u201A",
        "lstrok": "\u0142",
        "Lstrok": "\u0141",
        "lt": "<",
        "Lt": "\u226A",
        "LT": "<",
        "ltcc": "\u2AA6",
        "ltcir": "\u2A79",
        "ltdot": "\u22D6",
        "lthree": "\u22CB",
        "ltimes": "\u22C9",
        "ltlarr": "\u2976",
        "ltquest": "\u2A7B",
        "ltri": "\u25C3",
        "ltrie": "\u22B4",
        "ltrif": "\u25C2",
        "ltrPar": "\u2996",
        "lurdshar": "\u294A",
        "luruhar": "\u2966",
        "lvertneqq": "\u2268\uFE00",
        "lvnE": "\u2268\uFE00",
        "macr": "\xaf",
        "male": "\u2642",
        "malt": "\u2720",
        "maltese": "\u2720",
        "map": "\u21A6",
        "Map": "\u2905",
        "mapsto": "\u21A6",
        "mapstodown": "\u21A7",
        "mapstoleft": "\u21A4",
        "mapstoup": "\u21A5",
        "marker": "\u25AE",
        "mcomma": "\u2A29",
        "mcy": "\u043C",
        "Mcy": "\u041C",
        "mdash": "\u2014",
        "mDDot": "\u223A",
        "measuredangle": "\u2221",
        "MediumSpace": "\u205F",
        "Mellintrf": "\u2133",
        "mfr": "\uD835\uDD2A",
        "Mfr": "\uD835\uDD10",
        "mho": "\u2127",
        "micro": "\xb5",
        "mid": "\u2223",
        "midast": "*",
        "midcir": "\u2AF0",
        "middot": "\xb7",
        "minus": "\u2212",
        "minusb": "\u229F",
        "minusd": "\u2238",
        "minusdu": "\u2A2A",
        "MinusPlus": "\u2213",
        "mlcp": "\u2ADB",
        "mldr": "\u2026",
        "mnplus": "\u2213",
        "models": "\u22A7",
        "mopf": "\uD835\uDD5E",
        "Mopf": "\uD835\uDD44",
        "mp": "\u2213",
        "mscr": "\uD835\uDCC2",
        "Mscr": "\u2133",
        "mstpos": "\u223E",
        "mu": "\u03BC",
        "Mu": "\u039C",
        "multimap": "\u22B8",
        "mumap": "\u22B8",
        "nabla": "\u2207",
        "nacute": "\u0144",
        "Nacute": "\u0143",
        "nang": "\u2220\u20D2",
        "nap": "\u2249",
        "napE": "\u2A70\u0338",
        "napid": "\u224B\u0338",
        "napos": "\u0149",
        "napprox": "\u2249",
        "natur": "\u266E",
        "natural": "\u266E",
        "naturals": "\u2115",
        "nbsp": "\xa0",
        "nbump": "\u224E\u0338",
        "nbumpe": "\u224F\u0338",
        "ncap": "\u2A43",
        "ncaron": "\u0148",
        "Ncaron": "\u0147",
        "ncedil": "\u0146",
        "Ncedil": "\u0145",
        "ncong": "\u2247",
        "ncongdot": "\u2A6D\u0338",
        "ncup": "\u2A42",
        "ncy": "\u043D",
        "Ncy": "\u041D",
        "ndash": "\u2013",
        "ne": "\u2260",
        "nearhk": "\u2924",
        "nearr": "\u2197",
        "neArr": "\u21D7",
        "nearrow": "\u2197",
        "nedot": "\u2250\u0338",
        "NegativeMediumSpace": "\u200B",
        "NegativeThickSpace": "\u200B",
        "NegativeThinSpace": "\u200B",
        "NegativeVeryThinSpace": "\u200B",
        "nequiv": "\u2262",
        "nesear": "\u2928",
        "nesim": "\u2242\u0338",
        "NestedGreaterGreater": "\u226B",
        "NestedLessLess": "\u226A",
        "NewLine": "\n",
        "nexist": "\u2204",
        "nexists": "\u2204",
        "nfr": "\uD835\uDD2B",
        "Nfr": "\uD835\uDD11",
        "nge": "\u2271",
        "ngE": "\u2267\u0338",
        "ngeq": "\u2271",
        "ngeqq": "\u2267\u0338",
        "ngeqslant": "\u2A7E\u0338",
        "nges": "\u2A7E\u0338",
        "nGg": "\u22D9\u0338",
        "ngsim": "\u2275",
        "ngt": "\u226F",
        "nGt": "\u226B\u20D2",
        "ngtr": "\u226F",
        "nGtv": "\u226B\u0338",
        "nharr": "\u21AE",
        "nhArr": "\u21CE",
        "nhpar": "\u2AF2",
        "ni": "\u220B",
        "nis": "\u22FC",
        "nisd": "\u22FA",
        "niv": "\u220B",
        "njcy": "\u045A",
        "NJcy": "\u040A",
        "nlarr": "\u219A",
        "nlArr": "\u21CD",
        "nldr": "\u2025",
        "nle": "\u2270",
        "nlE": "\u2266\u0338",
        "nleftarrow": "\u219A",
        "nLeftarrow": "\u21CD",
        "nleftrightarrow": "\u21AE",
        "nLeftrightarrow": "\u21CE",
        "nleq": "\u2270",
        "nleqq": "\u2266\u0338",
        "nleqslant": "\u2A7D\u0338",
        "nles": "\u2A7D\u0338",
        "nless": "\u226E",
        "nLl": "\u22D8\u0338",
        "nlsim": "\u2274",
        "nlt": "\u226E",
        "nLt": "\u226A\u20D2",
        "nltri": "\u22EA",
        "nltrie": "\u22EC",
        "nLtv": "\u226A\u0338",
        "nmid": "\u2224",
        "NoBreak": "\u2060",
        "NonBreakingSpace": "\xa0",
        "nopf": "\uD835\uDD5F",
        "Nopf": "\u2115",
        "not": "\xac",
        "Not": "\u2AEC",
        "NotCongruent": "\u2262",
        "NotCupCap": "\u226D",
        "NotDoubleVerticalBar": "\u2226",
        "NotElement": "\u2209",
        "NotEqual": "\u2260",
        "NotEqualTilde": "\u2242\u0338",
        "NotExists": "\u2204",
        "NotGreater": "\u226F",
        "NotGreaterEqual": "\u2271",
        "NotGreaterFullEqual": "\u2267\u0338",
        "NotGreaterGreater": "\u226B\u0338",
        "NotGreaterLess": "\u2279",
        "NotGreaterSlantEqual": "\u2A7E\u0338",
        "NotGreaterTilde": "\u2275",
        "NotHumpDownHump": "\u224E\u0338",
        "NotHumpEqual": "\u224F\u0338",
        "notin": "\u2209",
        "notindot": "\u22F5\u0338",
        "notinE": "\u22F9\u0338",
        "notinva": "\u2209",
        "notinvb": "\u22F7",
        "notinvc": "\u22F6",
        "NotLeftTriangle": "\u22EA",
        "NotLeftTriangleBar": "\u29CF\u0338",
        "NotLeftTriangleEqual": "\u22EC",
        "NotLess": "\u226E",
        "NotLessEqual": "\u2270",
        "NotLessGreater": "\u2278",
        "NotLessLess": "\u226A\u0338",
        "NotLessSlantEqual": "\u2A7D\u0338",
        "NotLessTilde": "\u2274",
        "NotNestedGreaterGreater": "\u2AA2\u0338",
        "NotNestedLessLess": "\u2AA1\u0338",
        "notni": "\u220C",
        "notniva": "\u220C",
        "notnivb": "\u22FE",
        "notnivc": "\u22FD",
        "NotPrecedes": "\u2280",
        "NotPrecedesEqual": "\u2AAF\u0338",
        "NotPrecedesSlantEqual": "\u22E0",
        "NotReverseElement": "\u220C",
        "NotRightTriangle": "\u22EB",
        "NotRightTriangleBar": "\u29D0\u0338",
        "NotRightTriangleEqual": "\u22ED",
        "NotSquareSubset": "\u228F\u0338",
        "NotSquareSubsetEqual": "\u22E2",
        "NotSquareSuperset": "\u2290\u0338",
        "NotSquareSupersetEqual": "\u22E3",
        "NotSubset": "\u2282\u20D2",
        "NotSubsetEqual": "\u2288",
        "NotSucceeds": "\u2281",
        "NotSucceedsEqual": "\u2AB0\u0338",
        "NotSucceedsSlantEqual": "\u22E1",
        "NotSucceedsTilde": "\u227F\u0338",
        "NotSuperset": "\u2283\u20D2",
        "NotSupersetEqual": "\u2289",
        "NotTilde": "\u2241",
        "NotTildeEqual": "\u2244",
        "NotTildeFullEqual": "\u2247",
        "NotTildeTilde": "\u2249",
        "NotVerticalBar": "\u2224",
        "npar": "\u2226",
        "nparallel": "\u2226",
        "nparsl": "\u2AFD\u20E5",
        "npart": "\u2202\u0338",
        "npolint": "\u2A14",
        "npr": "\u2280",
        "nprcue": "\u22E0",
        "npre": "\u2AAF\u0338",
        "nprec": "\u2280",
        "npreceq": "\u2AAF\u0338",
        "nrarr": "\u219B",
        "nrArr": "\u21CF",
        "nrarrc": "\u2933\u0338",
        "nrarrw": "\u219D\u0338",
        "nrightarrow": "\u219B",
        "nRightarrow": "\u21CF",
        "nrtri": "\u22EB",
        "nrtrie": "\u22ED",
        "nsc": "\u2281",
        "nsccue": "\u22E1",
        "nsce": "\u2AB0\u0338",
        "nscr": "\uD835\uDCC3",
        "Nscr": "\uD835\uDCA9",
        "nshortmid": "\u2224",
        "nshortparallel": "\u2226",
        "nsim": "\u2241",
        "nsime": "\u2244",
        "nsimeq": "\u2244",
        "nsmid": "\u2224",
        "nspar": "\u2226",
        "nsqsube": "\u22E2",
        "nsqsupe": "\u22E3",
        "nsub": "\u2284",
        "nsube": "\u2288",
        "nsubE": "\u2AC5\u0338",
        "nsubset": "\u2282\u20D2",
        "nsubseteq": "\u2288",
        "nsubseteqq": "\u2AC5\u0338",
        "nsucc": "\u2281",
        "nsucceq": "\u2AB0\u0338",
        "nsup": "\u2285",
        "nsupe": "\u2289",
        "nsupE": "\u2AC6\u0338",
        "nsupset": "\u2283\u20D2",
        "nsupseteq": "\u2289",
        "nsupseteqq": "\u2AC6\u0338",
        "ntgl": "\u2279",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "ntlg": "\u2278",
        "ntriangleleft": "\u22EA",
        "ntrianglelefteq": "\u22EC",
        "ntriangleright": "\u22EB",
        "ntrianglerighteq": "\u22ED",
        "nu": "\u03BD",
        "Nu": "\u039D",
        "num": "#",
        "numero": "\u2116",
        "numsp": "\u2007",
        "nvap": "\u224D\u20D2",
        "nvdash": "\u22AC",
        "nvDash": "\u22AD",
        "nVdash": "\u22AE",
        "nVDash": "\u22AF",
        "nvge": "\u2265\u20D2",
        "nvgt": ">\u20D2",
        "nvHarr": "\u2904",
        "nvinfin": "\u29DE",
        "nvlArr": "\u2902",
        "nvle": "\u2264\u20D2",
        "nvlt": "<\u20D2",
        "nvltrie": "\u22B4\u20D2",
        "nvrArr": "\u2903",
        "nvrtrie": "\u22B5\u20D2",
        "nvsim": "\u223C\u20D2",
        "nwarhk": "\u2923",
        "nwarr": "\u2196",
        "nwArr": "\u21D6",
        "nwarrow": "\u2196",
        "nwnear": "\u2927",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "oast": "\u229B",
        "ocir": "\u229A",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ocy": "\u043E",
        "Ocy": "\u041E",
        "odash": "\u229D",
        "odblac": "\u0151",
        "Odblac": "\u0150",
        "odiv": "\u2A38",
        "odot": "\u2299",
        "odsold": "\u29BC",
        "oelig": "\u0153",
        "OElig": "\u0152",
        "ofcir": "\u29BF",
        "ofr": "\uD835\uDD2C",
        "Ofr": "\uD835\uDD12",
        "ogon": "\u02DB",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ogt": "\u29C1",
        "ohbar": "\u29B5",
        "ohm": "\u03A9",
        "oint": "\u222E",
        "olarr": "\u21BA",
        "olcir": "\u29BE",
        "olcross": "\u29BB",
        "oline": "\u203E",
        "olt": "\u29C0",
        "omacr": "\u014D",
        "Omacr": "\u014C",
        "omega": "\u03C9",
        "Omega": "\u03A9",
        "omicron": "\u03BF",
        "Omicron": "\u039F",
        "omid": "\u29B6",
        "ominus": "\u2296",
        "oopf": "\uD835\uDD60",
        "Oopf": "\uD835\uDD46",
        "opar": "\u29B7",
        "OpenCurlyDoubleQuote": "\u201C",
        "OpenCurlyQuote": "\u2018",
        "operp": "\u29B9",
        "oplus": "\u2295",
        "or": "\u2228",
        "Or": "\u2A54",
        "orarr": "\u21BB",
        "ord": "\u2A5D",
        "order": "\u2134",
        "orderof": "\u2134",
        "ordf": "\xaa",
        "ordm": "\xba",
        "origof": "\u22B6",
        "oror": "\u2A56",
        "orslope": "\u2A57",
        "orv": "\u2A5B",
        "oS": "\u24C8",
        "oscr": "\u2134",
        "Oscr": "\uD835\uDCAA",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "osol": "\u2298",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "otimes": "\u2297",
        "Otimes": "\u2A37",
        "otimesas": "\u2A36",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "ovbar": "\u233D",
        "OverBar": "\u203E",
        "OverBrace": "\u23DE",
        "OverBracket": "\u23B4",
        "OverParenthesis": "\u23DC",
        "par": "\u2225",
        "para": "\xb6",
        "parallel": "\u2225",
        "parsim": "\u2AF3",
        "parsl": "\u2AFD",
        "part": "\u2202",
        "PartialD": "\u2202",
        "pcy": "\u043F",
        "Pcy": "\u041F",
        "percnt": "%",
        "period": ".",
        "permil": "\u2030",
        "perp": "\u22A5",
        "pertenk": "\u2031",
        "pfr": "\uD835\uDD2D",
        "Pfr": "\uD835\uDD13",
        "phi": "\u03C6",
        "Phi": "\u03A6",
        "phiv": "\u03D5",
        "phmmat": "\u2133",
        "phone": "\u260E",
        "pi": "\u03C0",
        "Pi": "\u03A0",
        "pitchfork": "\u22D4",
        "piv": "\u03D6",
        "planck": "\u210F",
        "planckh": "\u210E",
        "plankv": "\u210F",
        "plus": "+",
        "plusacir": "\u2A23",
        "plusb": "\u229E",
        "pluscir": "\u2A22",
        "plusdo": "\u2214",
        "plusdu": "\u2A25",
        "pluse": "\u2A72",
        "PlusMinus": "\xb1",
        "plusmn": "\xb1",
        "plussim": "\u2A26",
        "plustwo": "\u2A27",
        "pm": "\xb1",
        "Poincareplane": "\u210C",
        "pointint": "\u2A15",
        "popf": "\uD835\uDD61",
        "Popf": "\u2119",
        "pound": "\xa3",
        "pr": "\u227A",
        "Pr": "\u2ABB",
        "prap": "\u2AB7",
        "prcue": "\u227C",
        "pre": "\u2AAF",
        "prE": "\u2AB3",
        "prec": "\u227A",
        "precapprox": "\u2AB7",
        "preccurlyeq": "\u227C",
        "Precedes": "\u227A",
        "PrecedesEqual": "\u2AAF",
        "PrecedesSlantEqual": "\u227C",
        "PrecedesTilde": "\u227E",
        "preceq": "\u2AAF",
        "precnapprox": "\u2AB9",
        "precneqq": "\u2AB5",
        "precnsim": "\u22E8",
        "precsim": "\u227E",
        "prime": "\u2032",
        "Prime": "\u2033",
        "primes": "\u2119",
        "prnap": "\u2AB9",
        "prnE": "\u2AB5",
        "prnsim": "\u22E8",
        "prod": "\u220F",
        "Product": "\u220F",
        "profalar": "\u232E",
        "profline": "\u2312",
        "profsurf": "\u2313",
        "prop": "\u221D",
        "Proportion": "\u2237",
        "Proportional": "\u221D",
        "propto": "\u221D",
        "prsim": "\u227E",
        "prurel": "\u22B0",
        "pscr": "\uD835\uDCC5",
        "Pscr": "\uD835\uDCAB",
        "psi": "\u03C8",
        "Psi": "\u03A8",
        "puncsp": "\u2008",
        "qfr": "\uD835\uDD2E",
        "Qfr": "\uD835\uDD14",
        "qint": "\u2A0C",
        "qopf": "\uD835\uDD62",
        "Qopf": "\u211A",
        "qprime": "\u2057",
        "qscr": "\uD835\uDCC6",
        "Qscr": "\uD835\uDCAC",
        "quaternions": "\u210D",
        "quatint": "\u2A16",
        "quest": "?",
        "questeq": "\u225F",
        "quot": '"',
        "QUOT": '"',
        "rAarr": "\u21DB",
        "race": "\u223D\u0331",
        "racute": "\u0155",
        "Racute": "\u0154",
        "radic": "\u221A",
        "raemptyv": "\u29B3",
        "rang": "\u27E9",
        "Rang": "\u27EB",
        "rangd": "\u2992",
        "range": "\u29A5",
        "rangle": "\u27E9",
        "raquo": "\xbb",
        "rarr": "\u2192",
        "rArr": "\u21D2",
        "Rarr": "\u21A0",
        "rarrap": "\u2975",
        "rarrb": "\u21E5",
        "rarrbfs": "\u2920",
        "rarrc": "\u2933",
        "rarrfs": "\u291E",
        "rarrhk": "\u21AA",
        "rarrlp": "\u21AC",
        "rarrpl": "\u2945",
        "rarrsim": "\u2974",
        "rarrtl": "\u21A3",
        "Rarrtl": "\u2916",
        "rarrw": "\u219D",
        "ratail": "\u291A",
        "rAtail": "\u291C",
        "ratio": "\u2236",
        "rationals": "\u211A",
        "rbarr": "\u290D",
        "rBarr": "\u290F",
        "RBarr": "\u2910",
        "rbbrk": "\u2773",
        "rbrace": "}",
        "rbrack": "]",
        "rbrke": "\u298C",
        "rbrksld": "\u298E",
        "rbrkslu": "\u2990",
        "rcaron": "\u0159",
        "Rcaron": "\u0158",
        "rcedil": "\u0157",
        "Rcedil": "\u0156",
        "rceil": "\u2309",
        "rcub": "}",
        "rcy": "\u0440",
        "Rcy": "\u0420",
        "rdca": "\u2937",
        "rdldhar": "\u2969",
        "rdquo": "\u201D",
        "rdquor": "\u201D",
        "rdsh": "\u21B3",
        "Re": "\u211C",
        "real": "\u211C",
        "realine": "\u211B",
        "realpart": "\u211C",
        "reals": "\u211D",
        "rect": "\u25AD",
        "reg": "\xae",
        "REG": "\xae",
        "ReverseElement": "\u220B",
        "ReverseEquilibrium": "\u21CB",
        "ReverseUpEquilibrium": "\u296F",
        "rfisht": "\u297D",
        "rfloor": "\u230B",
        "rfr": "\uD835\uDD2F",
        "Rfr": "\u211C",
        "rHar": "\u2964",
        "rhard": "\u21C1",
        "rharu": "\u21C0",
        "rharul": "\u296C",
        "rho": "\u03C1",
        "Rho": "\u03A1",
        "rhov": "\u03F1",
        "RightAngleBracket": "\u27E9",
        "rightarrow": "\u2192",
        "Rightarrow": "\u21D2",
        "RightArrow": "\u2192",
        "RightArrowBar": "\u21E5",
        "RightArrowLeftArrow": "\u21C4",
        "rightarrowtail": "\u21A3",
        "RightCeiling": "\u2309",
        "RightDoubleBracket": "\u27E7",
        "RightDownTeeVector": "\u295D",
        "RightDownVector": "\u21C2",
        "RightDownVectorBar": "\u2955",
        "RightFloor": "\u230B",
        "rightharpoondown": "\u21C1",
        "rightharpoonup": "\u21C0",
        "rightleftarrows": "\u21C4",
        "rightleftharpoons": "\u21CC",
        "rightrightarrows": "\u21C9",
        "rightsquigarrow": "\u219D",
        "RightTee": "\u22A2",
        "RightTeeArrow": "\u21A6",
        "RightTeeVector": "\u295B",
        "rightthreetimes": "\u22CC",
        "RightTriangle": "\u22B3",
        "RightTriangleBar": "\u29D0",
        "RightTriangleEqual": "\u22B5",
        "RightUpDownVector": "\u294F",
        "RightUpTeeVector": "\u295C",
        "RightUpVector": "\u21BE",
        "RightUpVectorBar": "\u2954",
        "RightVector": "\u21C0",
        "RightVectorBar": "\u2953",
        "ring": "\u02DA",
        "risingdotseq": "\u2253",
        "rlarr": "\u21C4",
        "rlhar": "\u21CC",
        "rlm": "\u200F",
        "rmoust": "\u23B1",
        "rmoustache": "\u23B1",
        "rnmid": "\u2AEE",
        "roang": "\u27ED",
        "roarr": "\u21FE",
        "robrk": "\u27E7",
        "ropar": "\u2986",
        "ropf": "\uD835\uDD63",
        "Ropf": "\u211D",
        "roplus": "\u2A2E",
        "rotimes": "\u2A35",
        "RoundImplies": "\u2970",
        "rpar": ")",
        "rpargt": "\u2994",
        "rppolint": "\u2A12",
        "rrarr": "\u21C9",
        "Rrightarrow": "\u21DB",
        "rsaquo": "\u203A",
        "rscr": "\uD835\uDCC7",
        "Rscr": "\u211B",
        "rsh": "\u21B1",
        "Rsh": "\u21B1",
        "rsqb": "]",
        "rsquo": "\u2019",
        "rsquor": "\u2019",
        "rthree": "\u22CC",
        "rtimes": "\u22CA",
        "rtri": "\u25B9",
        "rtrie": "\u22B5",
        "rtrif": "\u25B8",
        "rtriltri": "\u29CE",
        "RuleDelayed": "\u29F4",
        "ruluhar": "\u2968",
        "rx": "\u211E",
        "sacute": "\u015B",
        "Sacute": "\u015A",
        "sbquo": "\u201A",
        "sc": "\u227B",
        "Sc": "\u2ABC",
        "scap": "\u2AB8",
        "scaron": "\u0161",
        "Scaron": "\u0160",
        "sccue": "\u227D",
        "sce": "\u2AB0",
        "scE": "\u2AB4",
        "scedil": "\u015F",
        "Scedil": "\u015E",
        "scirc": "\u015D",
        "Scirc": "\u015C",
        "scnap": "\u2ABA",
        "scnE": "\u2AB6",
        "scnsim": "\u22E9",
        "scpolint": "\u2A13",
        "scsim": "\u227F",
        "scy": "\u0441",
        "Scy": "\u0421",
        "sdot": "\u22C5",
        "sdotb": "\u22A1",
        "sdote": "\u2A66",
        "searhk": "\u2925",
        "searr": "\u2198",
        "seArr": "\u21D8",
        "searrow": "\u2198",
        "sect": "\xa7",
        "semi": ";",
        "seswar": "\u2929",
        "setminus": "\u2216",
        "setmn": "\u2216",
        "sext": "\u2736",
        "sfr": "\uD835\uDD30",
        "Sfr": "\uD835\uDD16",
        "sfrown": "\u2322",
        "sharp": "\u266F",
        "shchcy": "\u0449",
        "SHCHcy": "\u0429",
        "shcy": "\u0448",
        "SHcy": "\u0428",
        "ShortDownArrow": "\u2193",
        "ShortLeftArrow": "\u2190",
        "shortmid": "\u2223",
        "shortparallel": "\u2225",
        "ShortRightArrow": "\u2192",
        "ShortUpArrow": "\u2191",
        "shy": "\xad",
        "sigma": "\u03C3",
        "Sigma": "\u03A3",
        "sigmaf": "\u03C2",
        "sigmav": "\u03C2",
        "sim": "\u223C",
        "simdot": "\u2A6A",
        "sime": "\u2243",
        "simeq": "\u2243",
        "simg": "\u2A9E",
        "simgE": "\u2AA0",
        "siml": "\u2A9D",
        "simlE": "\u2A9F",
        "simne": "\u2246",
        "simplus": "\u2A24",
        "simrarr": "\u2972",
        "slarr": "\u2190",
        "SmallCircle": "\u2218",
        "smallsetminus": "\u2216",
        "smashp": "\u2A33",
        "smeparsl": "\u29E4",
        "smid": "\u2223",
        "smile": "\u2323",
        "smt": "\u2AAA",
        "smte": "\u2AAC",
        "smtes": "\u2AAC\uFE00",
        "softcy": "\u044C",
        "SOFTcy": "\u042C",
        "sol": "/",
        "solb": "\u29C4",
        "solbar": "\u233F",
        "sopf": "\uD835\uDD64",
        "Sopf": "\uD835\uDD4A",
        "spades": "\u2660",
        "spadesuit": "\u2660",
        "spar": "\u2225",
        "sqcap": "\u2293",
        "sqcaps": "\u2293\uFE00",
        "sqcup": "\u2294",
        "sqcups": "\u2294\uFE00",
        "Sqrt": "\u221A",
        "sqsub": "\u228F",
        "sqsube": "\u2291",
        "sqsubset": "\u228F",
        "sqsubseteq": "\u2291",
        "sqsup": "\u2290",
        "sqsupe": "\u2292",
        "sqsupset": "\u2290",
        "sqsupseteq": "\u2292",
        "squ": "\u25A1",
        "square": "\u25A1",
        "Square": "\u25A1",
        "SquareIntersection": "\u2293",
        "SquareSubset": "\u228F",
        "SquareSubsetEqual": "\u2291",
        "SquareSuperset": "\u2290",
        "SquareSupersetEqual": "\u2292",
        "SquareUnion": "\u2294",
        "squarf": "\u25AA",
        "squf": "\u25AA",
        "srarr": "\u2192",
        "sscr": "\uD835\uDCC8",
        "Sscr": "\uD835\uDCAE",
        "ssetmn": "\u2216",
        "ssmile": "\u2323",
        "sstarf": "\u22C6",
        "star": "\u2606",
        "Star": "\u22C6",
        "starf": "\u2605",
        "straightepsilon": "\u03F5",
        "straightphi": "\u03D5",
        "strns": "\xaf",
        "sub": "\u2282",
        "Sub": "\u22D0",
        "subdot": "\u2ABD",
        "sube": "\u2286",
        "subE": "\u2AC5",
        "subedot": "\u2AC3",
        "submult": "\u2AC1",
        "subne": "\u228A",
        "subnE": "\u2ACB",
        "subplus": "\u2ABF",
        "subrarr": "\u2979",
        "subset": "\u2282",
        "Subset": "\u22D0",
        "subseteq": "\u2286",
        "subseteqq": "\u2AC5",
        "SubsetEqual": "\u2286",
        "subsetneq": "\u228A",
        "subsetneqq": "\u2ACB",
        "subsim": "\u2AC7",
        "subsub": "\u2AD5",
        "subsup": "\u2AD3",
        "succ": "\u227B",
        "succapprox": "\u2AB8",
        "succcurlyeq": "\u227D",
        "Succeeds": "\u227B",
        "SucceedsEqual": "\u2AB0",
        "SucceedsSlantEqual": "\u227D",
        "SucceedsTilde": "\u227F",
        "succeq": "\u2AB0",
        "succnapprox": "\u2ABA",
        "succneqq": "\u2AB6",
        "succnsim": "\u22E9",
        "succsim": "\u227F",
        "SuchThat": "\u220B",
        "sum": "\u2211",
        "Sum": "\u2211",
        "sung": "\u266A",
        "sup": "\u2283",
        "Sup": "\u22D1",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "supdot": "\u2ABE",
        "supdsub": "\u2AD8",
        "supe": "\u2287",
        "supE": "\u2AC6",
        "supedot": "\u2AC4",
        "Superset": "\u2283",
        "SupersetEqual": "\u2287",
        "suphsol": "\u27C9",
        "suphsub": "\u2AD7",
        "suplarr": "\u297B",
        "supmult": "\u2AC2",
        "supne": "\u228B",
        "supnE": "\u2ACC",
        "supplus": "\u2AC0",
        "supset": "\u2283",
        "Supset": "\u22D1",
        "supseteq": "\u2287",
        "supseteqq": "\u2AC6",
        "supsetneq": "\u228B",
        "supsetneqq": "\u2ACC",
        "supsim": "\u2AC8",
        "supsub": "\u2AD4",
        "supsup": "\u2AD6",
        "swarhk": "\u2926",
        "swarr": "\u2199",
        "swArr": "\u21D9",
        "swarrow": "\u2199",
        "swnwar": "\u292A",
        "szlig": "\xdf",
        "Tab": "	",
        "target": "\u2316",
        "tau": "\u03C4",
        "Tau": "\u03A4",
        "tbrk": "\u23B4",
        "tcaron": "\u0165",
        "Tcaron": "\u0164",
        "tcedil": "\u0163",
        "Tcedil": "\u0162",
        "tcy": "\u0442",
        "Tcy": "\u0422",
        "tdot": "\u20DB",
        "telrec": "\u2315",
        "tfr": "\uD835\uDD31",
        "Tfr": "\uD835\uDD17",
        "there4": "\u2234",
        "therefore": "\u2234",
        "Therefore": "\u2234",
        "theta": "\u03B8",
        "Theta": "\u0398",
        "thetasym": "\u03D1",
        "thetav": "\u03D1",
        "thickapprox": "\u2248",
        "thicksim": "\u223C",
        "ThickSpace": "\u205F\u200A",
        "thinsp": "\u2009",
        "ThinSpace": "\u2009",
        "thkap": "\u2248",
        "thksim": "\u223C",
        "thorn": "\xfe",
        "THORN": "\xde",
        "tilde": "\u02DC",
        "Tilde": "\u223C",
        "TildeEqual": "\u2243",
        "TildeFullEqual": "\u2245",
        "TildeTilde": "\u2248",
        "times": "\xd7",
        "timesb": "\u22A0",
        "timesbar": "\u2A31",
        "timesd": "\u2A30",
        "tint": "\u222D",
        "toea": "\u2928",
        "top": "\u22A4",
        "topbot": "\u2336",
        "topcir": "\u2AF1",
        "topf": "\uD835\uDD65",
        "Topf": "\uD835\uDD4B",
        "topfork": "\u2ADA",
        "tosa": "\u2929",
        "tprime": "\u2034",
        "trade": "\u2122",
        "TRADE": "\u2122",
        "triangle": "\u25B5",
        "triangledown": "\u25BF",
        "triangleleft": "\u25C3",
        "trianglelefteq": "\u22B4",
        "triangleq": "\u225C",
        "triangleright": "\u25B9",
        "trianglerighteq": "\u22B5",
        "tridot": "\u25EC",
        "trie": "\u225C",
        "triminus": "\u2A3A",
        "TripleDot": "\u20DB",
        "triplus": "\u2A39",
        "trisb": "\u29CD",
        "tritime": "\u2A3B",
        "trpezium": "\u23E2",
        "tscr": "\uD835\uDCC9",
        "Tscr": "\uD835\uDCAF",
        "tscy": "\u0446",
        "TScy": "\u0426",
        "tshcy": "\u045B",
        "TSHcy": "\u040B",
        "tstrok": "\u0167",
        "Tstrok": "\u0166",
        "twixt": "\u226C",
        "twoheadleftarrow": "\u219E",
        "twoheadrightarrow": "\u21A0",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "uarr": "\u2191",
        "uArr": "\u21D1",
        "Uarr": "\u219F",
        "Uarrocir": "\u2949",
        "ubrcy": "\u045E",
        "Ubrcy": "\u040E",
        "ubreve": "\u016D",
        "Ubreve": "\u016C",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ucy": "\u0443",
        "Ucy": "\u0423",
        "udarr": "\u21C5",
        "udblac": "\u0171",
        "Udblac": "\u0170",
        "udhar": "\u296E",
        "ufisht": "\u297E",
        "ufr": "\uD835\uDD32",
        "Ufr": "\uD835\uDD18",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uHar": "\u2963",
        "uharl": "\u21BF",
        "uharr": "\u21BE",
        "uhblk": "\u2580",
        "ulcorn": "\u231C",
        "ulcorner": "\u231C",
        "ulcrop": "\u230F",
        "ultri": "\u25F8",
        "umacr": "\u016B",
        "Umacr": "\u016A",
        "uml": "\xa8",
        "UnderBar": "_",
        "UnderBrace": "\u23DF",
        "UnderBracket": "\u23B5",
        "UnderParenthesis": "\u23DD",
        "Union": "\u22C3",
        "UnionPlus": "\u228E",
        "uogon": "\u0173",
        "Uogon": "\u0172",
        "uopf": "\uD835\uDD66",
        "Uopf": "\uD835\uDD4C",
        "uparrow": "\u2191",
        "Uparrow": "\u21D1",
        "UpArrow": "\u2191",
        "UpArrowBar": "\u2912",
        "UpArrowDownArrow": "\u21C5",
        "updownarrow": "\u2195",
        "Updownarrow": "\u21D5",
        "UpDownArrow": "\u2195",
        "UpEquilibrium": "\u296E",
        "upharpoonleft": "\u21BF",
        "upharpoonright": "\u21BE",
        "uplus": "\u228E",
        "UpperLeftArrow": "\u2196",
        "UpperRightArrow": "\u2197",
        "upsi": "\u03C5",
        "Upsi": "\u03D2",
        "upsih": "\u03D2",
        "upsilon": "\u03C5",
        "Upsilon": "\u03A5",
        "UpTee": "\u22A5",
        "UpTeeArrow": "\u21A5",
        "upuparrows": "\u21C8",
        "urcorn": "\u231D",
        "urcorner": "\u231D",
        "urcrop": "\u230E",
        "uring": "\u016F",
        "Uring": "\u016E",
        "urtri": "\u25F9",
        "uscr": "\uD835\uDCCA",
        "Uscr": "\uD835\uDCB0",
        "utdot": "\u22F0",
        "utilde": "\u0169",
        "Utilde": "\u0168",
        "utri": "\u25B5",
        "utrif": "\u25B4",
        "uuarr": "\u21C8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "uwangle": "\u29A7",
        "vangrt": "\u299C",
        "varepsilon": "\u03F5",
        "varkappa": "\u03F0",
        "varnothing": "\u2205",
        "varphi": "\u03D5",
        "varpi": "\u03D6",
        "varpropto": "\u221D",
        "varr": "\u2195",
        "vArr": "\u21D5",
        "varrho": "\u03F1",
        "varsigma": "\u03C2",
        "varsubsetneq": "\u228A\uFE00",
        "varsubsetneqq": "\u2ACB\uFE00",
        "varsupsetneq": "\u228B\uFE00",
        "varsupsetneqq": "\u2ACC\uFE00",
        "vartheta": "\u03D1",
        "vartriangleleft": "\u22B2",
        "vartriangleright": "\u22B3",
        "vBar": "\u2AE8",
        "Vbar": "\u2AEB",
        "vBarv": "\u2AE9",
        "vcy": "\u0432",
        "Vcy": "\u0412",
        "vdash": "\u22A2",
        "vDash": "\u22A8",
        "Vdash": "\u22A9",
        "VDash": "\u22AB",
        "Vdashl": "\u2AE6",
        "vee": "\u2228",
        "Vee": "\u22C1",
        "veebar": "\u22BB",
        "veeeq": "\u225A",
        "vellip": "\u22EE",
        "verbar": "|",
        "Verbar": "\u2016",
        "vert": "|",
        "Vert": "\u2016",
        "VerticalBar": "\u2223",
        "VerticalLine": "|",
        "VerticalSeparator": "\u2758",
        "VerticalTilde": "\u2240",
        "VeryThinSpace": "\u200A",
        "vfr": "\uD835\uDD33",
        "Vfr": "\uD835\uDD19",
        "vltri": "\u22B2",
        "vnsub": "\u2282\u20D2",
        "vnsup": "\u2283\u20D2",
        "vopf": "\uD835\uDD67",
        "Vopf": "\uD835\uDD4D",
        "vprop": "\u221D",
        "vrtri": "\u22B3",
        "vscr": "\uD835\uDCCB",
        "Vscr": "\uD835\uDCB1",
        "vsubne": "\u228A\uFE00",
        "vsubnE": "\u2ACB\uFE00",
        "vsupne": "\u228B\uFE00",
        "vsupnE": "\u2ACC\uFE00",
        "Vvdash": "\u22AA",
        "vzigzag": "\u299A",
        "wcirc": "\u0175",
        "Wcirc": "\u0174",
        "wedbar": "\u2A5F",
        "wedge": "\u2227",
        "Wedge": "\u22C0",
        "wedgeq": "\u2259",
        "weierp": "\u2118",
        "wfr": "\uD835\uDD34",
        "Wfr": "\uD835\uDD1A",
        "wopf": "\uD835\uDD68",
        "Wopf": "\uD835\uDD4E",
        "wp": "\u2118",
        "wr": "\u2240",
        "wreath": "\u2240",
        "wscr": "\uD835\uDCCC",
        "Wscr": "\uD835\uDCB2",
        "xcap": "\u22C2",
        "xcirc": "\u25EF",
        "xcup": "\u22C3",
        "xdtri": "\u25BD",
        "xfr": "\uD835\uDD35",
        "Xfr": "\uD835\uDD1B",
        "xharr": "\u27F7",
        "xhArr": "\u27FA",
        "xi": "\u03BE",
        "Xi": "\u039E",
        "xlarr": "\u27F5",
        "xlArr": "\u27F8",
        "xmap": "\u27FC",
        "xnis": "\u22FB",
        "xodot": "\u2A00",
        "xopf": "\uD835\uDD69",
        "Xopf": "\uD835\uDD4F",
        "xoplus": "\u2A01",
        "xotime": "\u2A02",
        "xrarr": "\u27F6",
        "xrArr": "\u27F9",
        "xscr": "\uD835\uDCCD",
        "Xscr": "\uD835\uDCB3",
        "xsqcup": "\u2A06",
        "xuplus": "\u2A04",
        "xutri": "\u25B3",
        "xvee": "\u22C1",
        "xwedge": "\u22C0",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yacy": "\u044F",
        "YAcy": "\u042F",
        "ycirc": "\u0177",
        "Ycirc": "\u0176",
        "ycy": "\u044B",
        "Ycy": "\u042B",
        "yen": "\xa5",
        "yfr": "\uD835\uDD36",
        "Yfr": "\uD835\uDD1C",
        "yicy": "\u0457",
        "YIcy": "\u0407",
        "yopf": "\uD835\uDD6A",
        "Yopf": "\uD835\uDD50",
        "yscr": "\uD835\uDCCE",
        "Yscr": "\uD835\uDCB4",
        "yucy": "\u044E",
        "YUcy": "\u042E",
        "yuml": "\xff",
        "Yuml": "\u0178",
        "zacute": "\u017A",
        "Zacute": "\u0179",
        "zcaron": "\u017E",
        "Zcaron": "\u017D",
        "zcy": "\u0437",
        "Zcy": "\u0417",
        "zdot": "\u017C",
        "Zdot": "\u017B",
        "zeetrf": "\u2128",
        "ZeroWidthSpace": "\u200B",
        "zeta": "\u03B6",
        "Zeta": "\u0396",
        "zfr": "\uD835\uDD37",
        "Zfr": "\u2128",
        "zhcy": "\u0436",
        "ZHcy": "\u0416",
        "zigrarr": "\u21DD",
        "zopf": "\uD835\uDD6B",
        "Zopf": "\u2124",
        "zscr": "\uD835\uDCCF",
        "Zscr": "\uD835\uDCB5",
        "zwj": "\u200D",
        "zwnj": "\u200C"
    };
    var decodeMapLegacy = {
        "aacute": "\xe1",
        "Aacute": "\xc1",
        "acirc": "\xe2",
        "Acirc": "\xc2",
        "acute": "\xb4",
        "aelig": "\xe6",
        "AElig": "\xc6",
        "agrave": "\xe0",
        "Agrave": "\xc0",
        "amp": "&",
        "AMP": "&",
        "aring": "\xe5",
        "Aring": "\xc5",
        "atilde": "\xe3",
        "Atilde": "\xc3",
        "auml": "\xe4",
        "Auml": "\xc4",
        "brvbar": "\xa6",
        "ccedil": "\xe7",
        "Ccedil": "\xc7",
        "cedil": "\xb8",
        "cent": "\xa2",
        "copy": "\xa9",
        "COPY": "\xa9",
        "curren": "\xa4",
        "deg": "\xb0",
        "divide": "\xf7",
        "eacute": "\xe9",
        "Eacute": "\xc9",
        "ecirc": "\xea",
        "Ecirc": "\xca",
        "egrave": "\xe8",
        "Egrave": "\xc8",
        "eth": "\xf0",
        "ETH": "\xd0",
        "euml": "\xeb",
        "Euml": "\xcb",
        "frac12": "\xbd",
        "frac14": "\xbc",
        "frac34": "\xbe",
        "gt": ">",
        "GT": ">",
        "iacute": "\xed",
        "Iacute": "\xcd",
        "icirc": "\xee",
        "Icirc": "\xce",
        "iexcl": "\xa1",
        "igrave": "\xec",
        "Igrave": "\xcc",
        "iquest": "\xbf",
        "iuml": "\xef",
        "Iuml": "\xcf",
        "laquo": "\xab",
        "lt": "<",
        "LT": "<",
        "macr": "\xaf",
        "micro": "\xb5",
        "middot": "\xb7",
        "nbsp": "\xa0",
        "not": "\xac",
        "ntilde": "\xf1",
        "Ntilde": "\xd1",
        "oacute": "\xf3",
        "Oacute": "\xd3",
        "ocirc": "\xf4",
        "Ocirc": "\xd4",
        "ograve": "\xf2",
        "Ograve": "\xd2",
        "ordf": "\xaa",
        "ordm": "\xba",
        "oslash": "\xf8",
        "Oslash": "\xd8",
        "otilde": "\xf5",
        "Otilde": "\xd5",
        "ouml": "\xf6",
        "Ouml": "\xd6",
        "para": "\xb6",
        "plusmn": "\xb1",
        "pound": "\xa3",
        "quot": '"',
        "QUOT": '"',
        "raquo": "\xbb",
        "reg": "\xae",
        "REG": "\xae",
        "sect": "\xa7",
        "shy": "\xad",
        "sup1": "\xb9",
        "sup2": "\xb2",
        "sup3": "\xb3",
        "szlig": "\xdf",
        "thorn": "\xfe",
        "THORN": "\xde",
        "times": "\xd7",
        "uacute": "\xfa",
        "Uacute": "\xda",
        "ucirc": "\xfb",
        "Ucirc": "\xdb",
        "ugrave": "\xf9",
        "Ugrave": "\xd9",
        "uml": "\xa8",
        "uuml": "\xfc",
        "Uuml": "\xdc",
        "yacute": "\xfd",
        "Yacute": "\xdd",
        "yen": "\xa5",
        "yuml": "\xff"
    };
    var decodeMapNumeric = {
        "0": "\uFFFD",
        "128": "\u20AC",
        "130": "\u201A",
        "131": "\u0192",
        "132": "\u201E",
        "133": "\u2026",
        "134": "\u2020",
        "135": "\u2021",
        "136": "\u02C6",
        "137": "\u2030",
        "138": "\u0160",
        "139": "\u2039",
        "140": "\u0152",
        "142": "\u017D",
        "145": "\u2018",
        "146": "\u2019",
        "147": "\u201C",
        "148": "\u201D",
        "149": "\u2022",
        "150": "\u2013",
        "151": "\u2014",
        "152": "\u02DC",
        "153": "\u2122",
        "154": "\u0161",
        "155": "\u203A",
        "156": "\u0153",
        "158": "\u017E",
        "159": "\u0178"
    };
    var invalidReferenceCodePoints = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        11,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        127,
        128,
        129,
        130,
        131,
        132,
        133,
        134,
        135,
        136,
        137,
        138,
        139,
        140,
        141,
        142,
        143,
        144,
        145,
        146,
        147,
        148,
        149,
        150,
        151,
        152,
        153,
        154,
        155,
        156,
        157,
        158,
        159,
        64976,
        64977,
        64978,
        64979,
        64980,
        64981,
        64982,
        64983,
        64984,
        64985,
        64986,
        64987,
        64988,
        64989,
        64990,
        64991,
        64992,
        64993,
        64994,
        64995,
        64996,
        64997,
        64998,
        64999,
        65000,
        65001,
        65002,
        65003,
        65004,
        65005,
        65006,
        65007,
        65534,
        65535,
        131070,
        131071,
        196606,
        196607,
        262142,
        262143,
        327678,
        327679,
        393214,
        393215,
        458750,
        458751,
        524286,
        524287,
        589822,
        589823,
        655358,
        655359,
        720894,
        720895,
        786430,
        786431,
        851966,
        851967,
        917502,
        917503,
        983038,
        983039,
        1048574,
        1048575,
        1114110,
        1114111
    ];
    /*--------------------------------------------------------------------------*/ var stringFromCharCode = String.fromCharCode;
    var object = {};
    var hasOwnProperty = object.hasOwnProperty;
    var has = function(object, propertyName) {
        return hasOwnProperty.call(object, propertyName);
    };
    var contains = function(array, value) {
        var index = -1;
        var length = array.length;
        while(++index < length){
            if (array[index] == value) return true;
        }
        return false;
    };
    var merge = function(options, defaults) {
        if (!options) return defaults;
        var result = {};
        var key;
        for(key in defaults)// A `hasOwnProperty` check is not needed here, since only recognized
        // option names are used anyway. Any others are ignored.
        result[key] = has(options, key) ? options[key] : defaults[key];
        return result;
    };
    // Modified version of `ucs2encode`; see https://mths.be/punycode.
    var codePointToSymbol = function(codePoint, strict) {
        var output = "";
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint > 0x10FFFF) {
            // See issue #4:
            // “Otherwise, if the number is in the range 0xD800 to 0xDFFF or is
            // greater than 0x10FFFF, then this is a parse error. Return a U+FFFD
            // REPLACEMENT CHARACTER.”
            if (strict) parseError("character reference outside the permissible Unicode range");
            return "\uFFFD";
        }
        if (has(decodeMapNumeric, codePoint)) {
            if (strict) parseError("disallowed character reference");
            return decodeMapNumeric[codePoint];
        }
        if (strict && contains(invalidReferenceCodePoints, codePoint)) parseError("disallowed character reference");
        if (codePoint > 0xFFFF) {
            codePoint -= 0x10000;
            output += stringFromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        output += stringFromCharCode(codePoint);
        return output;
    };
    var hexEscape = function(codePoint) {
        return "&#x" + codePoint.toString(16).toUpperCase() + ";";
    };
    var decEscape = function(codePoint) {
        return "&#" + codePoint + ";";
    };
    var parseError = function(message) {
        throw Error("Parse error: " + message);
    };
    /*--------------------------------------------------------------------------*/ var encode = function(string, options) {
        options = merge(options, encode.options);
        var strict = options.strict;
        if (strict && regexInvalidRawCodePoint.test(string)) parseError("forbidden code point");
        var encodeEverything = options.encodeEverything;
        var useNamedReferences = options.useNamedReferences;
        var allowUnsafeSymbols = options.allowUnsafeSymbols;
        var escapeCodePoint = options.decimal ? decEscape : hexEscape;
        var escapeBmpSymbol = function(symbol) {
            return escapeCodePoint(symbol.charCodeAt(0));
        };
        if (encodeEverything) {
            // Encode ASCII symbols.
            string = string.replace(regexAsciiWhitelist, function(symbol) {
                // Use named references if requested & possible.
                if (useNamedReferences && has(encodeMap, symbol)) return "&" + encodeMap[symbol] + ";";
                return escapeBmpSymbol(symbol);
            });
            // Shorten a few escapes that represent two symbols, of which at least one
            // is within the ASCII range.
            if (useNamedReferences) string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;").replace(/&#x66;&#x6A;/g, "&fjlig;");
            // Encode non-ASCII symbols.
            if (useNamedReferences) // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        // Note: any remaining non-ASCII symbols are handled outside of the `if`.
        } else if (useNamedReferences) {
            // Apply named character references.
            // Encode `<>"'&` using named character references.
            if (!allowUnsafeSymbols) string = string.replace(regexEscape, function(string) {
                return "&" + encodeMap[string] + ";"; // no need to check `has()` here
            });
            // Shorten escapes that represent two symbols, of which at least one is
            // `<>"'&`.
            string = string.replace(/&gt;\u20D2/g, "&nvgt;").replace(/&lt;\u20D2/g, "&nvlt;");
            // Encode non-ASCII symbols that can be replaced with a named reference.
            string = string.replace(regexEncodeNonAscii, function(string) {
                // Note: there is no need to check `has(encodeMap, string)` here.
                return "&" + encodeMap[string] + ";";
            });
        } else if (!allowUnsafeSymbols) // Encode `<>"'&` using hexadecimal escapes, now that they’re not handled
        // using named character references.
        string = string.replace(regexEscape, escapeBmpSymbol);
        return string// Encode astral symbols.
        .replace(regexAstralSymbols, function($0) {
            // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
            var high = $0.charCodeAt(0);
            var low = $0.charCodeAt(1);
            var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
            return escapeCodePoint(codePoint);
        })// Encode any remaining BMP symbols that are not printable ASCII symbols
        // using a hexadecimal escape.
        .replace(regexBmpWhitelist, escapeBmpSymbol);
    };
    // Expose default options (so they can be overridden globally).
    encode.options = {
        "allowUnsafeSymbols": false,
        "encodeEverything": false,
        "strict": false,
        "useNamedReferences": false,
        "decimal": false
    };
    var decode = function(html, options) {
        options = merge(options, decode.options);
        var strict = options.strict;
        if (strict && regexInvalidEntity.test(html)) parseError("malformed character reference");
        return html.replace(regexDecode, function($0, $1, $2, $3, $4, $5, $6, $7, $8) {
            var codePoint;
            var semicolon;
            var decDigits;
            var hexDigits;
            var reference;
            var next;
            if ($1) {
                reference = $1;
                // Note: there is no need to check `has(decodeMap, reference)`.
                return decodeMap[reference];
            }
            if ($2) {
                // Decode named character references without trailing `;`, e.g. `&amp`.
                // This is only a parse error if it gets converted to `&`, or if it is
                // followed by `=` in an attribute context.
                reference = $2;
                next = $3;
                if (next && options.isAttributeValue) {
                    if (strict && next == "=") parseError("`&` did not start a character reference");
                    return $0;
                } else {
                    if (strict) parseError("named character reference was not terminated by a semicolon");
                    // Note: there is no need to check `has(decodeMapLegacy, reference)`.
                    return decodeMapLegacy[reference] + (next || "");
                }
            }
            if ($4) {
                // Decode decimal escapes, e.g. `&#119558;`.
                decDigits = $4;
                semicolon = $5;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(decDigits, 10);
                return codePointToSymbol(codePoint, strict);
            }
            if ($6) {
                // Decode hexadecimal escapes, e.g. `&#x1D306;`.
                hexDigits = $6;
                semicolon = $7;
                if (strict && !semicolon) parseError("character reference was not terminated by a semicolon");
                codePoint = parseInt(hexDigits, 16);
                return codePointToSymbol(codePoint, strict);
            }
            // If we’re still here, `if ($7)` is implied; it’s an ambiguous
            // ampersand for sure. https://mths.be/notes/ambiguous-ampersands
            if (strict) parseError("named character reference was not terminated by a semicolon");
            return $0;
        });
    };
    // Expose default options (so they can be overridden globally).
    decode.options = {
        "isAttributeValue": false,
        "strict": false
    };
    var escape = function(string) {
        return string.replace(regexEscape, function($0) {
            // Note: there is no need to check `has(escapeMap, $0)` here.
            return escapeMap[$0];
        });
    };
    /*--------------------------------------------------------------------------*/ var he = {
        "version": "1.2.0",
        "encode": encode,
        "decode": decode,
        "escape": escape,
        "unescape": decode
    };
    // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define(function() {
        return he;
    });
    else if (freeExports && !freeExports.nodeType) {
        if (freeModule) freeModule.exports = he;
        else for(var key in he)has(he, key) && (freeExports[key] = he[key]);
    } else root.he = he;
})(this);

});

parcelRegister("jp1nv", function(module, exports) {

$parcel$export(module.exports, "Anchor", function () { return $e2016bccb1099984$export$b688253958b8dfe7; });

var $loA2J = parcelRequire("loA2J");

var $iCJQh = parcelRequire("iCJQh");

var $d1QMb = parcelRequire("d1QMb");
var $e2016bccb1099984$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $e2016bccb1099984$var$decodeChildren = (children)=>{
    if (typeof children === "string") return (0, $iCJQh.decode)(children);
    return children;
};
const $e2016bccb1099984$export$b688253958b8dfe7 = (_a)=>{
    var { children: children, testId: testId } = _a, anchorProps = $e2016bccb1099984$var$__rest(_a, [
        "children",
        "testId"
    ]);
    const { href: href } = anchorProps;
    const TRUSTED_HOSTS = [
        "id.atlassian.com",
        "id.stg.internal.atlassian.com"
    ];
    const decodedChildren = $e2016bccb1099984$var$decodeChildren(children);
    if (!href) {
        // Remove empty string `href` from render if present
        const { href: emptyHref } = anchorProps, rest = $e2016bccb1099984$var$__rest(anchorProps, [
            "href"
        ]);
        return (0, $loA2J.jsx)("span", Object.assign({}, rest, {
            "data-testid": testId,
            children: decodedChildren
        }));
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($d1QMb)))(href)) {
        const { host: host } = new URL(href);
        const isTrustedUrl = TRUSTED_HOSTS.includes(host);
        return (0, $loA2J.jsx)("a", Object.assign({}, anchorProps, {
            target: isTrustedUrl ? undefined : "_blank",
            rel: isTrustedUrl ? undefined : "noopener",
            "data-testid": testId,
            children: decodedChildren
        }));
    } else if (href.startsWith("#") || href.startsWith("mailto:")) return (0, $loA2J.jsx)("a", Object.assign({}, anchorProps, {
        "data-testid": testId,
        children: decodedChildren
    }));
    else return (0, $loA2J.jsx)("a", Object.assign({}, anchorProps, {
        "data-testid": testId,
        href: href,
        children: decodedChildren
    }));
};

});
parcelRegister("d1QMb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $97c44e98b910af5f$var$isURL;

var $97c44e98b910af5f$var$_assertString = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("eyQfv")));

var $97c44e98b910af5f$var$_checkHost = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("gIcim")));

var $97c44e98b910af5f$var$_includesString = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("dvdWM")));

var $97c44e98b910af5f$var$_isFQDN = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("152c6")));

var $97c44e98b910af5f$var$_isIP = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("gONPj")));

var $97c44e98b910af5f$var$_merge = $97c44e98b910af5f$var$_interopRequireDefault((parcelRequire("d6uF6")));
function $97c44e98b910af5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $97c44e98b910af5f$var$_slicedToArray(r, e) {
    return $97c44e98b910af5f$var$_arrayWithHoles(r) || $97c44e98b910af5f$var$_iterableToArrayLimit(r, e) || $97c44e98b910af5f$var$_unsupportedIterableToArray(r, e) || $97c44e98b910af5f$var$_nonIterableRest();
}
function $97c44e98b910af5f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $97c44e98b910af5f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $97c44e98b910af5f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $97c44e98b910af5f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $97c44e98b910af5f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $97c44e98b910af5f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $97c44e98b910af5f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
/*
options for isURL method

protocols - valid protocols can be modified with this option.
require_tld - If set to false isURL will not check if the URL's host includes a top-level domain.
require_protocol - if set to true isURL will return false if protocol is not present in the URL.
require_host - if set to false isURL will not check if host is present in the URL.
require_port - if set to true isURL will check if port is present in the URL.
require_valid_protocol - isURL will check if the URL's protocol is present in the protocols option.
allow_underscores - if set to true, the validator will allow underscores in the URL.
host_whitelist - if set to an array of strings or regexp, and the domain matches none of the strings
                 defined in it, the validation fails.
host_blacklist - if set to an array of strings or regexp, and the domain matches any of the strings
                 defined in it, the validation fails.
allow_trailing_dot - if set to true, the validator will allow the domain to end with
                     a `.` character.
allow_protocol_relative_urls - if set to true protocol relative URLs will be allowed.
allow_fragments - if set to false isURL will return false if fragments are present.
allow_query_components - if set to false isURL will return false if query components are present.
disallow_auth - if set to true, the validator will fail if the URL contains an authentication
                component, e.g. `http://username:password@example.com`
validate_length - if set to false isURL will skip string length validation. `max_allowed_length`
                  will be ignored if this is set as `false`.
max_allowed_length - if set, isURL will not allow URLs longer than the specified value (default is
                     2084 that IE maximum URL length).

*/ var $97c44e98b910af5f$var$default_url_options = {
    protocols: [
        "http",
        "https",
        "ftp"
    ],
    require_tld: true,
    require_protocol: false,
    require_host: true,
    require_port: false,
    require_valid_protocol: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_protocol_relative_urls: false,
    allow_fragments: true,
    allow_query_components: true,
    validate_length: true,
    max_allowed_length: 2084
};
var $97c44e98b910af5f$var$wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;
function $97c44e98b910af5f$var$isURL(url, options) {
    (0, $97c44e98b910af5f$var$_assertString.default)(url);
    if (!url || /[\s<>]/.test(url)) return false;
    if (url.indexOf("mailto:") === 0) return false;
    options = (0, $97c44e98b910af5f$var$_merge.default)(options, $97c44e98b910af5f$var$default_url_options);
    if (options.validate_length && url.length > options.max_allowed_length) return false;
    if (!options.allow_fragments && (0, $97c44e98b910af5f$var$_includesString.default)(url, "#")) return false;
    if (!options.allow_query_components && ((0, $97c44e98b910af5f$var$_includesString.default)(url, "?") || (0, $97c44e98b910af5f$var$_includesString.default)(url, "&"))) return false;
    var protocol, auth, host, hostname, port, port_str, split, ipv6;
    split = url.split("#");
    url = split.shift();
    split = url.split("?");
    url = split.shift();
    // Replaced the 'split("://")' logic with a regex to match the protocol.
    // This correctly identifies schemes like `javascript:` which don't use `//`.
    // However, we need to be careful not to confuse authentication credentials (user:password@host)
    // with protocols. A colon before an @ symbol might be part of auth, not a protocol separator.
    var protocol_match = url.match(/^([a-z][a-z0-9+\-.]*):/i);
    var had_explicit_protocol = false;
    var cleanUpProtocol = function cleanUpProtocol(potential_protocol) {
        had_explicit_protocol = true;
        protocol = potential_protocol.toLowerCase();
        if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) // The identified protocol is not in the allowed list.
        return false;
        // Remove the protocol from the URL string.
        return url.substring(protocol_match[0].length);
    };
    if (protocol_match) {
        var potential_protocol = protocol_match[1];
        var after_colon = url.substring(protocol_match[0].length);
        // Check if what follows looks like authentication credentials (user:password@host)
        // rather than a protocol. This happens when:
        // 1. There's no `//` after the colon (protocols like `http://` have this)
        // 2. There's an `@` symbol before any `/`
        // 3. The part before `@` contains only valid auth characters (alphanumeric, -, _, ., %, :)
        var starts_with_slashes = after_colon.slice(0, 2) === "//";
        if (!starts_with_slashes) {
            var first_slash_position = after_colon.indexOf("/");
            var before_slash = first_slash_position === -1 ? after_colon : after_colon.substring(0, first_slash_position);
            var at_position = before_slash.indexOf("@");
            if (at_position !== -1) {
                var before_at = before_slash.substring(0, at_position);
                var valid_auth_regex = /^[a-zA-Z0-9\-_.%:]*$/;
                var is_valid_auth = valid_auth_regex.test(before_at);
                if (is_valid_auth) {
                    // This looks like authentication (e.g., user:password@host), not a protocol
                    if (options.require_protocol) return false;
                // Don't consume the colon; let the auth parsing handle it later
                } else {
                    // This looks like a malicious protocol (e.g., javascript:alert();@host)
                    url = cleanUpProtocol(potential_protocol);
                    if (url === false) return false;
                }
            } else {
                // No @ symbol found. Check if this could be a port number instead of a protocol.
                // If what's after the colon is numeric (or starts with a digit and contains only
                // valid port characters until a path separator), it's likely hostname:port, not a protocol.
                var looks_like_port = /^[0-9]/.test(after_colon);
                if (looks_like_port) {
                    // This looks like hostname:port, not a protocol
                    if (options.require_protocol) return false;
                // Don't consume anything; let it be parsed as hostname:port
                } else {
                    // This is definitely a protocol
                    url = cleanUpProtocol(potential_protocol);
                    if (url === false) return false;
                }
            }
        } else {
            // Starts with '//', this is definitely a protocol like http://
            url = cleanUpProtocol(potential_protocol);
            if (url === false) return false;
        }
    } else if (options.require_protocol) return false;
    // Handle leading '//' only as protocol-relative when there was NO explicit protocol.
    // If there was an explicit protocol, '//' is the normal separator
    // and should be stripped unconditionally.
    if (url.slice(0, 2) === "//") {
        if (!had_explicit_protocol && !options.allow_protocol_relative_urls) return false;
        url = url.slice(2);
    }
    if (url === "") return false;
    split = url.split("/");
    url = split.shift();
    if (url === "" && !options.require_host) return true;
    split = url.split("@");
    if (split.length > 1) {
        if (options.disallow_auth) return false;
        if (split[0] === "") return false;
        auth = split.shift();
        if (auth.indexOf(":") >= 0 && auth.split(":").length > 2) return false;
        var _auth$split = auth.split(":"), _auth$split2 = $97c44e98b910af5f$var$_slicedToArray(_auth$split, 2), user = _auth$split2[0], password = _auth$split2[1];
        if (user === "" && password === "") return false;
    }
    hostname = split.join("@");
    port_str = null;
    ipv6 = null;
    var ipv6_match = hostname.match($97c44e98b910af5f$var$wrapped_ipv6);
    if (ipv6_match) {
        host = "";
        ipv6 = ipv6_match[1];
        port_str = ipv6_match[2] || null;
    } else {
        split = hostname.split(":");
        host = split.shift();
        if (split.length) port_str = split.join(":");
    }
    if (port_str !== null && port_str.length > 0) {
        port = parseInt(port_str, 10);
        if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) return false;
    } else if (options.require_port) return false;
    if (options.host_whitelist) return (0, $97c44e98b910af5f$var$_checkHost.default)(host, options.host_whitelist);
    if (host === "" && !options.require_host) return true;
    if (!(0, $97c44e98b910af5f$var$_isIP.default)(host) && !(0, $97c44e98b910af5f$var$_isFQDN.default)(host, options) && (!ipv6 || !(0, $97c44e98b910af5f$var$_isIP.default)(ipv6, 6))) return false;
    host = host || ipv6;
    if (options.host_blacklist && (0, $97c44e98b910af5f$var$_checkHost.default)(host, options.host_blacklist)) return false;
    return true;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("eyQfv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a99cc543345e3828$var$assertString;
function $a99cc543345e3828$var$assertString(input) {
    if (input === undefined || input === null) throw new TypeError("Expected a string but received a ".concat(input));
    if (input.constructor.name !== "String") throw new TypeError("Expected a string but received a ".concat(input.constructor.name));
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("gIcim", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2aa4af4d5702e15$var$checkHost;
function $c2aa4af4d5702e15$var$isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
}
function $c2aa4af4d5702e15$var$checkHost(host, matches) {
    for(var i = 0; i < matches.length; i++){
        var match = matches[i];
        if (host === match || $c2aa4af4d5702e15$var$isRegExp(match) && match.test(host)) return true;
    }
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("dvdWM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9d48fd3c0ad8125b$var$includes = function includes(str, val) {
    return str.indexOf(val) !== -1;
};
var $9d48fd3c0ad8125b$var$_default = module.exports.default = $9d48fd3c0ad8125b$var$includes;
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});

parcelRegister("152c6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c97f5cecba1d1f5$var$isFQDN;

var $0c97f5cecba1d1f5$var$_assertString = $0c97f5cecba1d1f5$var$_interopRequireDefault((parcelRequire("eyQfv")));

var $0c97f5cecba1d1f5$var$_merge = $0c97f5cecba1d1f5$var$_interopRequireDefault((parcelRequire("d6uF6")));
function $0c97f5cecba1d1f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
var $0c97f5cecba1d1f5$var$default_fqdn_options = {
    require_tld: true,
    allow_underscores: false,
    allow_trailing_dot: false,
    allow_numeric_tld: false,
    allow_wildcard: false,
    ignore_max_length: false
};
function $0c97f5cecba1d1f5$var$isFQDN(str, options) {
    (0, $0c97f5cecba1d1f5$var$_assertString.default)(str);
    options = (0, $0c97f5cecba1d1f5$var$_merge.default)(options, $0c97f5cecba1d1f5$var$default_fqdn_options);
    /* Remove the optional trailing dot before checking validity */ if (options.allow_trailing_dot && str[str.length - 1] === ".") str = str.substring(0, str.length - 1);
    /* Remove the optional wildcard before checking validity */ if (options.allow_wildcard === true && str.indexOf("*.") === 0) str = str.substring(2);
    var parts = str.split(".");
    var tld = parts[parts.length - 1];
    if (options.require_tld) {
        // disallow fqdns without tld
        if (parts.length < 2) return false;
        if (!options.allow_numeric_tld && !/^([a-z\u00A1-\u00A8\u00AA-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) return false;
        // disallow spaces
        if (/\s/.test(tld)) return false;
    }
    // reject numeric TLDs
    if (!options.allow_numeric_tld && /^\d+$/.test(tld)) return false;
    return parts.every(function(part) {
        if (part.length > 63 && !options.ignore_max_length) return false;
        if (!/^[a-z_\u00a1-\uffff0-9-]+$/i.test(part)) return false;
        // disallow full-width chars
        if (/[\uff01-\uff5e]/.test(part)) return false;
        // disallow parts starting or ending with hyphen
        if (/^-|-$/.test(part)) return false;
        if (!options.allow_underscores && /_/.test(part)) return false;
        return true;
    });
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});
parcelRegister("d6uF6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98a39eb6f3e9b291$var$merge;
function $98a39eb6f3e9b291$var$merge() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var defaults = arguments.length > 1 ? arguments[1] : undefined;
    for(var key in defaults)if (typeof obj[key] === "undefined") obj[key] = defaults[key];
    return obj;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});


parcelRegister("gONPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c3e7f763a675597a$var$isIP;

var $c3e7f763a675597a$var$_assertString = $c3e7f763a675597a$var$_interopRequireDefault((parcelRequire("eyQfv")));
function $c3e7f763a675597a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $c3e7f763a675597a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c3e7f763a675597a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c3e7f763a675597a$var$_typeof(o);
}
/**
11.3.  Examples

   The following addresses

             fe80::1234 (on the 1st link of the node)
             ff02::5678 (on the 5th link of the node)
             ff08::9abc (on the 10th organization of the node)

   would be represented as follows:

             fe80::1234%1
             ff02::5678%5
             ff08::9abc%10

   (Here we assume a natural translation from a zone index to the
   <zone_id> part, where the Nth zone of any scope is translated into
   "N".)

   If we use interface names as <zone_id>, those addresses could also be
   represented as follows:

            fe80::1234%ne0
            ff02::5678%pvc1.3
            ff08::9abc%interface10

   where the interface "ne0" belongs to the 1st link, "pvc1.3" belongs
   to the 5th link, and "interface10" belongs to the 10th organization.
 * * */ var $c3e7f763a675597a$var$IPv4SegmentFormat = "(?:[0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])";
var $c3e7f763a675597a$var$IPv4AddressFormat = "(".concat($c3e7f763a675597a$var$IPv4SegmentFormat, "[.]){3}").concat($c3e7f763a675597a$var$IPv4SegmentFormat);
var $c3e7f763a675597a$var$IPv4AddressRegExp = new RegExp("^".concat($c3e7f763a675597a$var$IPv4AddressFormat, "$"));
var $c3e7f763a675597a$var$IPv6SegmentFormat = "(?:[0-9a-fA-F]{1,4})";
var $c3e7f763a675597a$var$IPv6AddressRegExp = new RegExp("^(" + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){7}(?:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){6}(?:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){5}(?::").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,2}|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){4}(?:(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){0,1}:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,3}|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){3}(?:(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){0,2}:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,4}|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){2}(?:(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){0,3}:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,5}|:)|") + "(?:".concat($c3e7f763a675597a$var$IPv6SegmentFormat, ":){1}(?:(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){0,4}:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(:").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,6}|:)|") + "(?::((?::".concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){0,5}:").concat($c3e7f763a675597a$var$IPv4AddressFormat, "|(?::").concat($c3e7f763a675597a$var$IPv6SegmentFormat, "){1,7}|:))") + ")(%[0-9a-zA-Z.]{1,})?$");
function $c3e7f763a675597a$var$isIP(ipAddress) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, $c3e7f763a675597a$var$_assertString.default)(ipAddress);
    // accessing 'arguments' for backwards compatibility: isIP(ipAddress [, version])
    // eslint-disable-next-line prefer-rest-params
    var version = ($c3e7f763a675597a$var$_typeof(options) === "object" ? options.version : arguments[1]) || "";
    if (!version) return $c3e7f763a675597a$var$isIP(ipAddress, {
        version: 4
    }) || $c3e7f763a675597a$var$isIP(ipAddress, {
        version: 6
    });
    if (version.toString() === "4") return $c3e7f763a675597a$var$IPv4AddressRegExp.test(ipAddress);
    if (version.toString() === "6") return $c3e7f763a675597a$var$IPv6AddressRegExp.test(ipAddress);
    return false;
}
module.exports = module.exports.default;
module.exports.default = module.exports.default;

});




parcelRegister("33B4V", function(module, exports) {
$parcel$export(module.exports, "Modal", function () { return (parcelRequire("kukfL")).Modal; });

$parcel$export(module.exports, "ModalTrigger", function () { return (parcelRequire("23mX4")).ModalTrigger; });
parcelRequire("kukfL");

var $23mX4 = parcelRequire("23mX4");

});
parcelRegister("kukfL", function(module, exports) {

$parcel$export(module.exports, "Modal", function () { return $c96b4a9b7677b445$export$2b77a92f1a5ad772; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");
parcelRequire("dg5xP");
var $ljbip = parcelRequire("ljbip");

var $23mX4 = parcelRequire("23mX4");
const $c96b4a9b7677b445$export$2b77a92f1a5ad772 = ({ modal: modal, isOpen: isOpen, close: close, children: children })=>{
    const modalRoot = (0, $ljbip.useModal)(modal.id, isOpen);
    const [animation, setAnimation] = (0, $iSvIT.useState)("out");
    const modelContentRef = (0, $iSvIT.useRef)(null);
    (0, $iSvIT.useEffect)(()=>{
        if (isOpen) {
            setAnimation("in");
            window.addEventListener("keydown", escPress);
            document.body.classList.add("prevent-scroll");
        }
        return ()=>{
            window.removeEventListener("keydown", escPress);
            document.body.classList.remove("prevent-scroll");
        };
    }, [
        isOpen
    ]);
    const escPress = (event)=>{
        if (event.key === "Escape") closeModal();
    };
    const closeModal = ()=>{
        setAnimation("out");
        document.body.classList.remove("prevent-scroll");
    };
    if (!modalRoot) return null;
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(/*#__PURE__*/ (0, $loA2J.jsx)((0, $23mX4.Overlay), {
        "data-testid": `ui-modal-${modal.id}-overlay`,
        animation: animation,
        transitionSpeed: modal.content.transitionSpeed,
        onTransitionEnd: (event)=>{
            if (animation === "out" && event.target === event.currentTarget) close();
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $23mX4.ModalContentContainer), {
            "data-testid": `ui-modal-${modal.id}-container`,
            ref: modelContentRef,
            transitionSpeed: modal.content.transitionSpeed,
            transitionType: modal.content.transitionType,
            animation: animation,
            onClick: (event)=>{
                if (event.target === modelContentRef.current) closeModal();
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $23mX4.ModalContent), {
                "data-testid": `ui-modal-${modal.id}-content`,
                modalSize: modal.content.modalSize,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $23mX4.CloseButton), {
                        "data-testid": `ui-modal-${modal.id}-close-button`,
                        type: "button",
                        title: modal.content.closeText,
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                            height: "24",
                            viewBox: "0 0 24 24",
                            width: "24",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "m14.8523165 12 8.5569494 8.5569494c.7876455.7876455.7876455 2.0646711 0 2.8523165-.7876454.7876455-2.064671.7876455-2.8523165 0l-8.5569494-8.5569494-8.55694944 8.5569494c-.78764544.7876455-2.06467103.7876455-2.85231647 0-.78764545-.7876454-.78764545-2.064671 0-2.8523165l8.55694943-8.5569494-8.55694943-8.55694944c-.78764545-.78764544-.78764545-2.06467103 0-2.85231647.78764544-.78764545 2.06467103-.78764545 2.85231647 0l8.55694944 8.55694943 8.5569494-8.55694943c.7876455-.78764545 2.0646711-.78764545 2.8523165 0 .7876455.78764544.7876455 2.06467103 0 2.85231647z",
                                fill: "#403294"
                            })
                        })
                    }),
                    children
                ]
            })
        })
    }), modalRoot);
};

});
parcelRegister("23mX4", function(module, exports) {

$parcel$export(module.exports, "Overlay", function () { return $a2afd725a93eb1b7$export$c6fdb837b070b4ff; });
$parcel$export(module.exports, "ModalContentContainer", function () { return $a2afd725a93eb1b7$export$fa73c85326cd7178; });
$parcel$export(module.exports, "ModalContent", function () { return $a2afd725a93eb1b7$export$6da19a24bf249f17; });
$parcel$export(module.exports, "CloseButton", function () { return $a2afd725a93eb1b7$export$de65de8213222d10; });
$parcel$export(module.exports, "ModalTrigger", function () { return $a2afd725a93eb1b7$export$fb10b32cfe19f1e; });
/* eslint-disable react/prop-types */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $8aYqw = parcelRequire("8aYqw");
const $a2afd725a93eb1b7$export$c6fdb837b070b4ff = ({ animation: animation, transitionSpeed: transitionSpeed, style: style, ...props })=>{
    const overlayStyle = {
        opacity: animation === "in" ? 1 : 0,
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        overflow: "auto",
        position: "fixed",
        height: "100vh",
        width: "100vw",
        top: 0,
        left: 0,
        zIndex: 1000,
        transition: `opacity ${(0, $8aYqw.animationSpeed).getSpeed(transitionSpeed)}ms ease-out`,
        ...style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: overlayStyle,
        ...props
    });
};
const $a2afd725a93eb1b7$export$fa73c85326cd7178 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ animation: animation, transitionType: transitionType, transitionSpeed: transitionSpeed, style: style, ...props }, ref)=>{
    const speed = (0, $8aYqw.animationSpeed).getSpeed(transitionSpeed);
    let containerStyle = {
        alignItems: "center",
        justifyContent: "center",
        display: "flex",
        padding: "25px",
        position: "absolute",
        minHeight: "100vh",
        width: "100vw",
        top: 0,
        left: 0,
        transition: `all ${speed}ms ease-out`
    };
    // Apply transition-specific styles
    switch(transitionType){
        case "SlideDown FadeOut":
        case "SlideDown InstantRemove":
            containerStyle = {
                ...containerStyle,
                transform: animation === "in" ? "translate3d(0, 0, 0)" : "translate3d(0, -25%, 0)",
                opacity: animation === "in" ? 1 : 0
            };
            break;
        case "SlideDown SlideBelow":
            containerStyle = {
                ...containerStyle,
                transform: animation === "in" ? "translate3d(0, 0, 0)" : "translate3d(0, 25%, 0)"
            };
            break;
        case "ScaleUp ScaleDown":
            containerStyle = {
                ...containerStyle,
                transform: animation === "in" ? "scale(1)" : "scale(0)"
            };
            break;
        default:
            containerStyle = {
                ...containerStyle,
                opacity: animation === "in" ? 1 : 0
            };
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: ref,
        style: {
            ...containerStyle,
            ...style
        },
        ...props
    });
});
const $a2afd725a93eb1b7$export$6da19a24bf249f17 = ({ modalSize: modalSize, style: style, ...props })=>{
    let sizeStyle = {};
    switch(modalSize){
        case "Large":
            sizeStyle = {
                width: "1140px",
                maxWidth: "100%"
            };
            break;
        case "Medium":
            sizeStyle = {
                width: "720px",
                maxWidth: "100%"
            };
            break;
        case "Small":
            sizeStyle = {
                width: "540px",
                maxWidth: "100%"
            };
            break;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            position: "relative",
            maxWidth: "100%",
            ...sizeStyle,
            ...style
        },
        ...props
    });
};
const $a2afd725a93eb1b7$export$de65de8213222d10 = ({ style: style, ...props })=>{
    const buttonStyle = {
        appearance: "none",
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#ffffff",
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        position: "absolute",
        textAlign: "center",
        top: "-25px",
        right: "-25px",
        height: "50px",
        width: "50px",
        zIndex: 1,
        ...style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("button", {
        style: buttonStyle,
        ...props
    });
};
const $a2afd725a93eb1b7$export$fb10b32cfe19f1e = ({ style: style, as: Tag = "span", ...props })=>/*#__PURE__*/ (0, $loA2J.jsx)(Tag, {
        style: {
            cursor: "pointer",
            ...style
        },
        ...props
    });

});
parcelRegister("8aYqw", function(module, exports) {

$parcel$export(module.exports, "animationSpeed", function () { return $4ca6f5bfc0ff264f$export$4c757589c8e1a492; });
/* animations.ts generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable complexity */ function $4ca6f5bfc0ff264f$export$1bc0d9220727f0d9(modalSize) {
    switch(modalSize){
        case "FitToContent":
            return "";
        case "Large":
            return null;
        case "Medium":
            return null;
        case "Small":
            return null;
        default:
            return "";
    }
}
const $4ca6f5bfc0ff264f$export$4c757589c8e1a492 = {
    Slow: 500,
    Medium: 333,
    Fast: 200,
    Instant: 0,
    default: 333,
    getSpeed (speed) {
        switch(speed){
            case "Slow":
                return this.Slow;
            case "Medium":
                return this.Medium;
            case "Fast":
                return this.Fast;
            case "Instant":
                return this.Instant;
            default:
                return this.default;
        }
    }
};
function $4ca6f5bfc0ff264f$export$7115a8d0ad71a89c(animation, transitionType, transitionSpeed) {
    switch(transitionType){
        case "FadeIn FadeOut":
            return null;
        case "SlideDown FadeOut":
            return null;
        case "SlideDown SlideBelow":
            return null;
        case "SlideDown InstantRemove":
            return null;
        case "ScaleUp ScaleDown":
            return null;
        default:
            return "";
    }
}
const $4ca6f5bfc0ff264f$export$82e6205b15e6c637 = null;
const $4ca6f5bfc0ff264f$export$c091916f1530334c = null;
const $4ca6f5bfc0ff264f$export$abdd11a06a163232 = null;
const $4ca6f5bfc0ff264f$export$25d01035ac3d9d7 = null;
const $4ca6f5bfc0ff264f$export$114dbff7fb2bf04f = null;
const $4ca6f5bfc0ff264f$export$5cc820d597bd2dd4 = null;

});




parcelRegister("bwVZm", function(module, exports) {
$parcel$export(module.exports, "ScrollFade", function () { return (parcelRequire("h5qkC")).ScrollFade; });
parcelRequire("h5qkC");

});
parcelRegister("h5qkC", function(module, exports) {

$parcel$export(module.exports, "ScrollFade", function () { return $0db641097cd86d65$export$a9bd2e52d875b47a; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7AG7X = parcelRequire("7AG7X");

var $1uGGP = parcelRequire("1uGGP");
const $0db641097cd86d65$export$a9bd2e52d875b47a = ({ children: children, height: height, style: style = {}, color: color = "N0" })=>{
    const [isNearTheEnd, setIsNearTheEnd] = (0, $iSvIT.useState)(false);
    const fadeHeight = 40;
    const scrollHandler = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))((e)=>{
        if (!e?.currentTarget) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = e.currentTarget;
        const scrollRemaining = scrollHeight - scrollTop - clientHeight;
        const nearTheEnd = scrollRemaining < fadeHeight;
        if (nearTheEnd !== isNearTheEnd) setIsNearTheEnd(!isNearTheEnd);
    }, 100);
    style.height = height;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1uGGP.Wrapper), {
        style: style,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            onScroll: scrollHandler,
            style: {
                height: height,
                overflowY: height ? "auto" : undefined
            },
            children: [
                children,
                height && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1uGGP.Fade), {
                    fadeHeight: fadeHeight,
                    fadeColor: color,
                    style: {
                        bottom: isNearTheEnd ? 0 - height : 0
                    }
                })
            ]
        })
    });
};

});
parcelRegister("1uGGP", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $15eea153390cee52$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "Fade", function () { return $15eea153390cee52$export$c983850c6c9d8b0e; });
/** @jsxImportSource react */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $i2LPb = parcelRequire("i2LPb");
const $15eea153390cee52$export$e6dfd72ab29f8598 = ({ children: children, ...props })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            position: "relative"
        },
        ...props,
        children: children
    });
const $15eea153390cee52$export$c983850c6c9d8b0e = ({ fadeHeight: fadeHeight, fadeColor: fadeColor, style: style, ...props })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            background: `linear-gradient(${(0, $i2LPb.colorCSS)(fadeColor, 0)}, ${(0, $i2LPb.colorCSS)(fadeColor, 1)})`,
            height: `${fadeHeight}px`,
            left: 0,
            position: "absolute",
            transition: "bottom 0.25s",
            width: "100%",
            ...style
        },
        ...props
    });

});



parcelRegister("j30bs", function(module, exports) {

$parcel$export(module.exports, "Stack", function () { return $db80ee8c17321022$export$694e0d28c7ffc90c; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("h6yBX");
var $2vQ6x = parcelRequire("2vQ6x");
const $db80ee8c17321022$export$694e0d28c7ffc90c = ({ orientation: orientation, spacing: spacing = "none", fullHeight: fullHeight, verticalAlign: verticalAlign, style: style, ...props })=>{
    const stackStyle = {
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        gap: (0, $2vQ6x.spacing)[spacing]
    };
    // Handle fullHeight styles
    if (fullHeight) stackStyle.height = "100%";
    // Handle alignment based on orientation
    if (orientation === "horizontal") switch(verticalAlign){
        case "Top":
            stackStyle.alignItems = "start";
            break;
        case "Bottom":
            stackStyle.alignItems = "end";
            break;
        default:
            stackStyle.alignItems = "center";
    }
    else switch(verticalAlign){
        case "Top":
            stackStyle.justifyContent = "start";
            break;
        case "Bottom":
            stackStyle.justifyContent = "end";
            break;
        case "Middle":
            stackStyle.justifyContent = "center";
            break;
        default:
            stackStyle.justifyContent = "space-between";
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            ...stackStyle,
            ...style
        },
        ...props
    });
};

});

parcelRegister("jaddM", function(module, exports) {
$parcel$export(module.exports, "Tooltip", function () { return (parcelRequire("cFwv0")).Tooltip; });
parcelRequire("cFwv0");

});
parcelRegister("cFwv0", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return $1751f2529a98a132$export$28c660c63b792dea; });

var $loA2J = parcelRequire("loA2J");

var $i5UxU = parcelRequire("i5UxU");
parcelRequire("dg5xP");
var $ljbip = parcelRequire("ljbip");

var $jnPD5 = parcelRequire("jnPD5");
const $1751f2529a98a132$export$28c660c63b792dea = ({ document: document, modalId: modalId, isOpen: isOpen, parentRef: parentRef })=>{
    const modal = (0, $ljbip.useModal)(modalId, isOpen);
    if (!modal) return null;
    return /*#__PURE__*/ (0, $i5UxU.createPortal)(/*#__PURE__*/ (0, $loA2J.jsx)((0, $jnPD5.TooltipContent), {
        toolTipText: document,
        trigger: parentRef
    }), modal);
};

});
parcelRegister("jnPD5", function(module, exports) {

$parcel$export(module.exports, "TooltipContent", function () { return $85cf4f6b61d57ddb$export$e9003e2be37ec060; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $ctjgr = parcelRequire("ctjgr");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $jFObu = parcelRequire("jFObu");
var $dJnrX = parcelRequire("dJnrX");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $1D7YE = parcelRequire("1D7YE");
const $85cf4f6b61d57ddb$export$e9003e2be37ec060 = ({ toolTipText: toolTipText, trigger: trigger })=>{
    const ref = (0, $iSvIT.useRef)(null);
    const rect = (0, $ctjgr.useRect)(ref);
    const triggerRect = (0, $ctjgr.useRect)(trigger);
    const { viewportWidth: viewportWidth } = (0, $jFObu.useViewportDimensions)();
    const coordinates = (0, $dJnrX.useCoordinates)(trigger);
    const height = rect ? rect.bottom - rect.top : 0;
    const isTop = triggerRect ? triggerRect.top > height : true;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                style: $85cf4f6b61d57ddb$export$ccb075cf47cfc30a({
                    coordinates: coordinates,
                    isTop: isTop,
                    hide: height === 0
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                ref: ref,
                className: "tooltip-content",
                "data-testid": "tooltip-content",
                style: $85cf4f6b61d57ddb$export$71b2d35c36ffe93d({
                    coordinates: coordinates,
                    viewportWidth: viewportWidth,
                    isTop: isTop,
                    height: height
                }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                    document: toolTipText
                })
            })
        ]
    });
};
function $85cf4f6b61d57ddb$export$71b2d35c36ffe93d({ coordinates: coordinates, viewportWidth: viewportWidth, isTop: isTop, height: height }) {
    const [x, y] = coordinates;
    const width = 200;
    const half = width / 2;
    const edgeOffset = 8;
    const translateX = `${-x + edgeOffset}px`;
    const translateY = isTop ? `calc(-1rem - ${height}px)` : "1.5rem";
    const horizontalPosition = viewportWidth - x < half ? "right" : x < half ? "left" : "center";
    const css = {
        backgroundColor: `${(0, $i2LPb.colorCSS)("B500")}`,
        borderRadius: "5px",
        boxShadow: isTop ? "2px -2px 4px rgba(0, 0, 0, 0.25)" : "2px 2px 4px rgba(0, 0, 0, 0.25)",
        color: `${(0, $i2LPb.colorCSS)("N0")}`,
        fontSize: "0.875rem",
        left: horizontalPosition === "right" ? "auto" : `${x}px`,
        opacity: height === 0 ? "0" : "1",
        padding: "0.75rem",
        paddingTop: "0.5rem",
        position: "absolute",
        right: horizontalPosition === "right" ? `${edgeOffset}px` : "auto",
        top: `${y}px`,
        transform: horizontalPosition === "right" ? `translate3d(0, ${translateY}, 0)` : horizontalPosition === "left" ? `translate3d(${translateX}, ${translateY}, 0)` : `translate3d(-50%, ${translateY}, 0)`,
        width: `${width}px`,
        zIndex: isTop ? (0, $1D7YE.zIndex).tooltip : 1
    };
    return css;
}
function $85cf4f6b61d57ddb$export$ccb075cf47cfc30a({ coordinates: coordinates, isTop: isTop, hide: hide }) {
    const [x, y] = coordinates;
    const css = {
        borderBottom: isTop ? "none" : `0.5rem solid ${(0, $i2LPb.colorCSS)("B500")}`,
        borderLeft: `0.5rem solid transparent`,
        borderRight: `0.5rem solid transparent`,
        borderTop: isTop ? `0.5rem solid ${(0, $i2LPb.colorCSS)("B500")}` : "none",
        display: "block",
        height: 0,
        left: `${x}px`,
        opacity: hide ? "0" : "1",
        position: "absolute",
        top: isTop ? `${y - 2}px` : `${y + 2}px`,
        transform: isTop ? "translate3d(-0.5rem, -1rem, 0)" : "translate3d(-0.5rem, 1rem, 0)",
        width: 0
    };
    return css;
}

});
parcelRegister("1XX9N", function(module, exports) {

$parcel$export(module.exports, "RichText", function () { return $16e9307d06caa1f5$export$f284d8638abd8920; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iCJQh = parcelRequire("iCJQh");

var $jp1nv = parcelRequire("jp1nv");

var $dcmqH = parcelRequire("dcmqH");
const $16e9307d06caa1f5$export$f284d8638abd8920 = ({ className: className, document: document })=>{
    // Safety check for undefined document or content
    if (!document || !document.content) return (0, $loA2J.jsx)("div", {
        className: className
    });
    return (0, $loA2J.jsx)("div", {
        className: className,
        children: Array.from(document.content).map($16e9307d06caa1f5$var$mapNodeToReactElement).reduce((acc, val)=>acc.concat(val), [])
    });
};
function $16e9307d06caa1f5$var$mapNodeToReactElement(node, index) {
    var _a; // eslint-disable-next-line react-hooks/rules-of-hooks -- Called within React context
    const renderer = (0, $dcmqH.useRenderer)();
    switch(node.type){
        case "blockquote":
            return [
                $16e9307d06caa1f5$var$mapBlockquoteToReactElement(node, index)
            ];
        case "bulletList":
            return [
                (0, $loA2J.jsx)("ul", {
                    children: node.content.map($16e9307d06caa1f5$var$mapNodeToReactElement)
                }, `ul-${index}`)
            ];
        case "heading":
            return [
                $16e9307d06caa1f5$var$mapHeadingToReactElement(node, index)
            ];
        case "listItem":
            return [
                (0, $loA2J.jsx)("li", {
                    children: node.content.map($16e9307d06caa1f5$var$mapNodeToReactElement)
                }, `li-${index}`)
            ];
        case "paragraph":
            return [
                (0, $loA2J.jsx)("p", {
                    children: (_a = node.content) === null || _a === void 0 ? void 0 : _a.map($16e9307d06caa1f5$var$mapNodeToReactElement)
                }, `p-${index}`)
            ];
        case "rule":
            return [
                (0, $loA2J.jsx)("hr", {
                    role: "presentation"
                }, `hr-${index}`)
            ];
        case "text":
            return $16e9307d06caa1f5$var$mapTextToReactElement(node, index);
        case "orderedList":
            return [
                (0, $loA2J.jsx)("ol", {
                    children: node.content.map($16e9307d06caa1f5$var$mapNodeToReactElement)
                }, `ol-${index}`)
            ];
        case "bxpEmbeddedViewBlock":
            return [
                (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: renderer(node.model)
                }, `block-${index}`)
            ];
        case "bxpEmbeddedViewInline":
            return [
                (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: renderer(node.model)
                }, `inline-${index}`)
            ];
    }
}
function $16e9307d06caa1f5$var$mapBlockquoteToReactElement({ content: content }, index) {
    return (0, $loA2J.jsx)("blockquote", {
        children: content.map($16e9307d06caa1f5$var$mapNodeToReactElement)
    }, `blockquote-${index}`);
}
function $16e9307d06caa1f5$var$mapHeadingToReactElement({ attrs: attrs, content: content = [] }, index) {
    const children = content.map($16e9307d06caa1f5$var$mapNodeToReactElement);
    switch(attrs.level){
        case 1:
            return (0, $loA2J.jsx)("h1", {
                children: children
            }, `h1-${index}`);
        case 2:
            return (0, $loA2J.jsx)("h2", {
                children: children
            }, `h2-${index}`);
        case 3:
            return (0, $loA2J.jsx)("h3", {
                children: children
            }, `h3-${index}`);
        case 4:
            return (0, $loA2J.jsx)("h4", {
                children: children
            }, `h4-${index}`);
        case 5:
            return (0, $loA2J.jsx)("h5", {
                children: children
            }, `h5-${index}`);
        case 6:
            return (0, $loA2J.jsx)("h6", {
                children: children
            }, `h6-${index}`);
    }
}
function $16e9307d06caa1f5$var$mapTextToReactElement({ text: text, marks: marks = [] }, index) {
    const [mark, ...otherMarks] = marks;
    if (mark) {
        const children = $16e9307d06caa1f5$var$mapTextToReactElement({
            type: "text",
            text: text,
            marks: otherMarks
        }, index);
        switch(mark.type){
            case "code":
                return [
                    (0, $loA2J.jsx)("code", {
                        children: children
                    }, `code-${index}`)
                ];
            case "em":
                return [
                    (0, $loA2J.jsx)("em", {
                        children: children
                    }, `em-${index}`)
                ];
            case "strong":
                return [
                    (0, $loA2J.jsx)("strong", {
                        children: children
                    }, `strong-${index}`)
                ];
            case "underline":
                return [
                    (0, $loA2J.jsx)("u", {
                        children: children
                    }, `u-${index}`)
                ];
            case "link":
                return [
                    (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                        href: mark.attrs.href,
                        children: children
                    }, `a-${index}`)
                ];
        }
    } else {
        const [firstChunk, ...otherChunks] = text.split("\n");
        if (otherChunks.length > 0) {
            const otherElements = otherChunks.map((otherChunk, _index)=>[
                    (0, $loA2J.jsx)("br", {}, `br-${_index}`),
                    (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                        children: (0, $iCJQh.decode)(otherChunk || "")
                    }, `other-fragment-${_index}`)
                ]).reduce((acc, val)=>acc.concat(val), []);
            return [
                (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                    children: (0, $iCJQh.decode)(firstChunk || "")
                }, `first-fragment-${index}`),
                ...otherElements
            ];
        } else return [
            (0, $loA2J.jsx)((0, $iSvIT.Fragment), {
                children: (0, $iCJQh.decode)(text)
            }, `fragment-${index}`)
        ];
    }
}

});
parcelRegister("dcmqH", function(module, exports) {

$parcel$export(module.exports, "useRenderer", function () { return $99bdcb640f83a2d3$export$e0259e2a2ab69ea; });
$parcel$export(module.exports, "RendererProvider", function () { return $99bdcb640f83a2d3$export$e785a56df110cbc9; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $99bdcb640f83a2d3$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, $iSvIT.createContext)(()=>{
    throw new Error("Not implemented yet.");
});
function $99bdcb640f83a2d3$export$e0259e2a2ab69ea() {
    return (0, $iSvIT.useContext)($99bdcb640f83a2d3$export$1e9ea4edb6d1bfe6);
} // eslint-disable-next-line react/function-component-definition -- Existing pattern
function $99bdcb640f83a2d3$export$e785a56df110cbc9({ renderer: renderer, children: children }) {
    return (0, $loA2J.jsx)($99bdcb640f83a2d3$export$1e9ea4edb6d1bfe6.Provider, {
        value: renderer,
        children: children
    });
}

});





parcelRegister("opvSz", function(module, exports) {

$parcel$export(module.exports, "Video", function () { return $d1f9f659923ff76f$export$ae01dedf5c052bb; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $d1f9f659923ff76f$export$ae01dedf5c052bb = ({ autoplay: autoplay, loop: loop, controls: controls, muted: muted, poster: poster, width: width, height: height, sources: sources, children: children })=>{
    //ref for autoplay
    const ref = (0, $iSvIT.useRef)(null);
    //set scroll handler
    (0, $iSvIT.useEffect)(()=>{
        //decide whether to play at current scroll
        const checkAutoPlay = ()=>{
            if (!autoplay || !ref?.current) return;
            //don't play it twice
            if (ref.current.played.length) return;
            //get vertical offset where half of video is showing
            const clientRect = ref.current.getBoundingClientRect();
            const startPlayingAt = window.innerHeight - clientRect.height / 2;
            //play if offset is greater than current scroll
            if (clientRect.top < startPlayingAt) ref.current.play().catch((error)=>console.warn(error));
        };
        //fire on render in case
        checkAutoPlay();
        //add event listener
        window.addEventListener("scroll", checkAutoPlay, {
            passive: true
        });
        //clean up event listener when unmounting
        return ()=>{
            window.removeEventListener("scroll", checkAutoPlay);
        };
    }, [
        ref,
        autoplay
    ]);
    //return video tag
    const videoStyle = {
        display: "block",
        height: "auto",
        width: "100%"
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
        style: videoStyle,
        "data-testid": "ui-video",
        ref: ref,
        loop: loop,
        controls: controls,
        muted: muted,
        poster: poster,
        width: width,
        height: height,
        children: [
            sources?.map((source)=>/*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    src: source,
                    type: $d1f9f659923ff76f$var$getVideoType(source)
                }, source)),
            children
        ]
    });
};
//get type property of video by url, eg video/mp4
function $d1f9f659923ff76f$var$getVideoType(url) {
    const fileName = url.split("/").pop();
    const fileExtension = fileName?.split(".").pop();
    if (fileExtension) {
        if ([
            "mp4"
        ].includes(fileExtension)) return "video/mp4";
        if ([
            "webm"
        ].includes(fileExtension)) return "video/webm";
        if ([
            "ogg",
            "ogv"
        ].includes(fileExtension)) return "video/ogg";
    }
    return undefined;
}

});

parcelRegister("j0YqN", function(module, exports) {
$parcel$export(module.exports, "FooterContextProvider", function () { return (parcelRequire("8OmrV")).FooterContextProvider; });
$parcel$export(module.exports, "useFooterContext", function () { return (parcelRequire("8OmrV")).useFooterContext; });
parcelRequire("8OmrV");
parcelRequire("dajlT");

});
parcelRegister("8OmrV", function(module, exports) {

$parcel$export(module.exports, "useFooterContext", function () { return $a09740d5c8573868$export$5d07e41d1ad42614; });
$parcel$export(module.exports, "FooterContextProvider", function () { return $a09740d5c8573868$export$614d1b8b16c175e6; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $a09740d5c8573868$var$defaultFooterHeight = 260;
const $a09740d5c8573868$export$5630640b68817ed6 = /*#__PURE__*/ (0, $iSvIT.createContext)({
    footerHeight: $a09740d5c8573868$var$defaultFooterHeight,
    setFooterHeight: ()=>{
    //placeholder function, do nothing
    }
});
function $a09740d5c8573868$export$5d07e41d1ad42614() {
    return (0, $iSvIT.useContext)($a09740d5c8573868$export$5630640b68817ed6);
}
const $a09740d5c8573868$export$614d1b8b16c175e6 = ({ children: children })=>{
    const [footerHeight, setFooterHeight] = (0, $iSvIT.useState)($a09740d5c8573868$var$defaultFooterHeight);
    return /*#__PURE__*/ (0, $loA2J.jsx)($a09740d5c8573868$export$5630640b68817ed6.Provider, {
        value: {
            footerHeight: footerHeight,
            setFooterHeight: setFooterHeight
        },
        children: children
    });
};

});


parcelRegister("gxKgX", function(module, exports) {
$parcel$export(module.exports, "Column", function () { return (parcelRequire("5l0yg")).Column; });
$parcel$export(module.exports, "Container", function () { return (parcelRequire("5l0yg")).Container; });
$parcel$export(module.exports, "isColumnProperties", function () { return (parcelRequire("5l0yg")).isColumnProperties; });
$parcel$export(module.exports, "Row", function () { return (parcelRequire("5l0yg")).Row; });
parcelRequire("5l0yg");

});
parcelRegister("5l0yg", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $bd208779080013e6$export$42a852a2b6b56249; });
$parcel$export(module.exports, "Row", function () { return $bd208779080013e6$export$b59bdbef9ce70de2; });
$parcel$export(module.exports, "isColumnProperties", function () { return $bd208779080013e6$export$e8bad1e171c1271e; });
$parcel$export(module.exports, "Column", function () { return $bd208779080013e6$export$816b5d811295e6bc; });

var $loA2J = parcelRequire("loA2J");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $8DhG7 = parcelRequire("8DhG7");
var $2vQ6x = parcelRequire("2vQ6x");
var $fpcku = parcelRequire("fpcku");
var $54E1V = parcelRequire("54E1V");
const $bd208779080013e6$export$42a852a2b6b56249 = (0, $hYbro.styled).div`
    margin-left: auto;
    margin-right: auto;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
    max-width: ${(0, $8DhG7.containerWidths).xl}px;
`;
const $bd208779080013e6$var$InternalRow = (0, $hYbro.styled).div`
    align-items: ${({ $alignItems: $alignItems })=>$alignItems};
    justify-content: ${({ $justifyContent: $justifyContent })=>$justifyContent};
    display: flex;
    flex-wrap: wrap;
    margin-left: -1rem;
    margin-right: -1rem;
`;
const $bd208779080013e6$export$b59bdbef9ce70de2 = ({ verticalAlign: verticalAlign = "stretch", align: align = "left", ...props })=>{
    let alignItems = "stretch";
    switch(verticalAlign.toLowerCase()){
        case "top":
            alignItems = "flex-start";
            break;
        case "bottom":
            alignItems = "flex-end";
            break;
        case "center":
            alignItems = "center";
            break;
    }
    let justifyContent = "flex-start";
    switch(align.toLowerCase()){
        case "center":
            justifyContent = "center";
            break;
        case "right":
            justifyContent = "flex-end";
            break;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)($bd208779080013e6$var$InternalRow, {
        $alignItems: alignItems,
        $justifyContent: justifyContent,
        ...props
    });
};
function $bd208779080013e6$export$e8bad1e171c1271e(properties) {
    return !!properties; // TODO: check properties is actually UiColumnProperties;
}
//up to 5 decimals in percentage widths for webkit (eg 7 => 58.333333%)
function $bd208779080013e6$var$spanWidth(span) {
    const regex = RegExp(/^-?\d+(?:\.\d{0,5})?/);
    const percentage = regex.exec((parseInt(span) * 100 / 12).toString());
    return percentage ? `${percentage[0]}%` : "auto";
}
function $bd208779080013e6$var$getColumnStyles({ align: align, offset: offset, push: push, order: order, radius: radius, span: span, ...directions }) {
    const styles = {};
    if (align) styles.textAlign = align;
    if (offset) styles.marginLeft = $bd208779080013e6$var$spanWidth(offset);
    if (push) styles.left = $bd208779080013e6$var$spanWidth(push);
    if (order) styles.order = parseInt(order);
    if (span) {
        if (span === "0") styles.display = "none";
        else {
            styles.display = "block";
            styles.flex = "0 0 auto";
            styles.width = $bd208779080013e6$var$spanWidth(span);
        }
    }
    [
        "top",
        "bottom",
        "left",
        "right"
    ].forEach((direction)=>{
        const space = directions[direction];
        if (space) {
            const marginKey = `margin${direction.charAt(0).toUpperCase() + direction.slice(1)}`;
            const paddingKey = `padding${direction.charAt(0).toUpperCase() + direction.slice(1)}`;
            if (space.startsWith("-")) {
                // z-index added to keep negative-margin div on top
                styles[marginKey] = `-${(0, $2vQ6x.spacing)[space.substring(1)]}`;
                styles[paddingKey] = "1rem";
                styles.zIndex = 1;
            } else {
                styles[marginKey] = "0";
                styles[paddingKey] = (0, $2vQ6x.spacing)[space];
            }
        }
    });
    if (radius) styles.borderRadius = (0, $fpcku.radius)[radius];
    return styles;
}
// Helper to generate media query styles for a breakpoint
function $bd208779080013e6$var$generateBreakpointStyles(breakpoint, minWidth) {
    if (!breakpoint) return "";
    const styles = $bd208779080013e6$var$getColumnStyles(breakpoint);
    let cssString = "";
    Object.entries(styles).forEach(([key, value])=>{
        const cssKey = key.replace(/([A-Z])/g, "-$1").toLowerCase();
        cssString += `${cssKey}: ${value};`;
    });
    if (!minWidth) return cssString;
    return `
        @media (min-width: ${minWidth}) {
            ${cssString}
        }
    `;
}
// Styled component with responsive breakpoint support using transient props
const $bd208779080013e6$var$StyledColumnDiv = (0, $hYbro.styled).div`
    padding: 1rem;
    position: relative;
    scroll-margin-top: ${(0, $2vQ6x.scrollMargin).top}px;
    text-align: center;
    width: 100%;

    ${({ $backgroundField: $backgroundField })=>$backgroundField ? (0, $54E1V.cssColorsFromBackgroundField)($backgroundField) : ""}
    ${({ $xs: $xs })=>$xs ? $bd208779080013e6$var$generateBreakpointStyles($xs) : ""}
    ${({ $sm: $sm })=>$sm ? $bd208779080013e6$var$generateBreakpointStyles($sm, "576px") : ""}
    ${({ $md: $md })=>$md ? $bd208779080013e6$var$generateBreakpointStyles($md, "768px") : ""}
    ${({ $lg: $lg })=>$lg ? $bd208779080013e6$var$generateBreakpointStyles($lg, "992px") : ""}
    ${({ $xl: $xl })=>$xl ? $bd208779080013e6$var$generateBreakpointStyles($xl, "1200px") : ""}
`;
const $bd208779080013e6$export$816b5d811295e6bc = ({ children: children, className: classesFromProps = "", xs: xs, sm: sm, md: md, lg: lg, xl: xl, backgroundField: backgroundField, ...props })=>{
    // Build className for text alignment classes
    let classNames = classesFromProps;
    for (const [key, value] of Object.entries({
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl
    }))if (!!value && value?.align?.length) classNames += ` ${key}-text-${value.align}`;
    classNames = classNames.toLowerCase();
    return /*#__PURE__*/ (0, $loA2J.jsx)($bd208779080013e6$var$StyledColumnDiv, {
        className: classNames,
        $backgroundField: backgroundField,
        $xs: xs,
        $sm: sm,
        $md: md,
        $lg: lg,
        $xl: xl,
        ...props,
        children: children
    });
};

});


parcelRegister("bggJi", function(module, exports) {
$parcel$export(module.exports, "AppleLogo", function () { return (parcelRequire("ioseP")).AppleLogo; });
$parcel$export(module.exports, "ArrowRight", function () { return (parcelRequire("dtAdv")).ArrowRight; });
$parcel$export(module.exports, "ChevronDown", function () { return (parcelRequire("5FSC2")).ChevronDown; });
$parcel$export(module.exports, "ChevronLeft", function () { return (parcelRequire("1fo9X")).ChevronLeft; });
$parcel$export(module.exports, "ChevronRight", function () { return (parcelRequire("fBLkH")).ChevronRight; });
$parcel$export(module.exports, "GoogleLogo", function () { return (parcelRequire("17IGc")).GoogleLogo; });
$parcel$export(module.exports, "MicrosoftLogo", function () { return (parcelRequire("buTNb")).MicrosoftLogo; });
$parcel$export(module.exports, "Play", function () { return (parcelRequire("6gLDf")).Play; });
$parcel$export(module.exports, "RightArrow", function () { return (parcelRequire("9wehj")).RightArrow; });
$parcel$export(module.exports, "SlackLogo", function () { return (parcelRequire("6Owxa")).SlackLogo; });
parcelRequire("ioseP");
parcelRequire("dtAdv");
parcelRequire("5FSC2");
parcelRequire("1fo9X");
parcelRequire("fBLkH");
parcelRequire("17IGc");
parcelRequire("buTNb");
parcelRequire("6gLDf");
parcelRequire("9wehj");
parcelRequire("6Owxa");
parcelRequire("feqEs");

});
parcelRegister("ioseP", function(module, exports) {

$parcel$export(module.exports, "AppleLogo", function () { return $01c1ad1923929b3d$export$570c8af14df4c066; });

var $loA2J = parcelRequire("loA2J");
const $01c1ad1923929b3d$export$570c8af14df4c066 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        fill: "currentColor",
        viewBox: "0 0 170 170",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.197-2.12-9.973-3.17-14.34-3.17-4.58 0-9.492 1.05-14.746 3.17-5.262 2.13-9.501 3.24-12.742 3.35-4.929.21-9.842-1.96-14.746-6.52-3.13-2.73-7.045-7.41-11.735-14.04-5.032-7.08-9.169-15.29-12.41-24.65-3.471-10.11-5.211-19.9-5.211-29.378 0-10.857 2.346-20.221 7.045-28.068 3.693-6.303 8.606-11.275 14.755-14.925s12.793-5.51 19.948-5.629c3.915 0 9.049 1.211 15.429 3.591 6.362 2.388 10.447 3.599 12.238 3.599 1.339 0 5.877-1.416 13.57-4.239 7.275-2.618 13.415-3.702 18.445-3.275 13.63 1.1 23.87 6.473 30.68 16.153-12.19 7.386-18.22 17.731-18.1 31.002.11 10.337 3.86 18.939 11.23 25.769 3.34 3.17 7.07 5.62 11.22 7.36-.9 2.61-1.85 5.11-2.86 7.51zM119.11 7.24c0 8.102-2.96 15.667-8.86 22.669-7.12 8.324-15.732 13.134-25.071 12.375a25.222 25.222 0 0 1-.188-3.07c0-7.778 3.386-16.102 9.399-22.908 3.002-3.446 6.82-6.311 11.45-8.597 4.62-2.252 8.99-3.497 13.1-3.71.12 1.083.17 2.166.17 3.24z"
        })
    });

});

parcelRegister("dtAdv", function(module, exports) {

$parcel$export(module.exports, "ArrowRight", function () { return $c6af895ff90c6cbf$export$acad20503ad73ac1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $c6af895ff90c6cbf$export$acad20503ad73ac1 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "arrow-right",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "#fff",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.793 5.79298C11.7001 5.88577 11.6263 5.99597 11.576 6.11729C11.5257 6.2386 11.4998 6.36865 11.4998 6.49998C11.4998 6.63131 11.5257 6.76136 11.576 6.88267C11.6263 7.00399 11.7001 7.11419 11.793 7.20698L15.586 11H6C5.73478 11 5.48043 11.1053 5.29289 11.2929C5.10536 11.4804 5 11.7348 5 12C5 12.2652 5.10536 12.5196 5.29289 12.7071C5.48043 12.8946 5.73478 13 6 13H15.586L11.793 16.793C11.7001 16.8858 11.6263 16.996 11.576 17.1173C11.5257 17.2386 11.4998 17.3686 11.4998 17.5C11.4998 17.6313 11.5257 17.7614 11.576 17.8827C11.6263 18.004 11.7001 18.1142 11.793 18.207C12.183 18.597 12.817 18.597 13.208 18.207L18.707 12.707C18.8881 12.5266 18.993 12.2835 19 12.028V11.971C18.9928 11.7158 18.888 11.4731 18.707 11.293L13.208 5.79298C13.1151 5.70001 13.0048 5.62625 12.8834 5.57592C12.762 5.5256 12.6319 5.49969 12.5005 5.49969C12.3691 5.49969 12.239 5.5256 12.1176 5.57592C11.9962 5.62625 11.8859 5.70001 11.793 5.79298Z",
                fill: color ? (0, $i2LPb.colorCSS)(color) : "currentColor"
            })
        ]
    });
};

});

parcelRegister("5FSC2", function(module, exports) {

$parcel$export(module.exports, "ChevronDown", function () { return $e1b2eb30a7c5c593$export$4e3778eb35f54199; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $e1b2eb30a7c5c593$export$4e3778eb35f54199 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: color ? (0, $i2LPb.colorCSS)(color) : "currentColor",
        height: "8",
        viewBox: "0 0 13 8",
        width: "13",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m11.7305.59279c.3626.362629.3885.93447.0777 1.32699l-.0777.08722-4.99999 4.99999c-.36263.36263-.93446.38853-1.32697.0777l-.08725-.0777-4.999959-4.99997c-.3905249-.39052-.3905242-1.023685 0-1.414209.362629-.36263.934469-.388553 1.326989-.077728l.08722.077728 4.29292 4.292139 4.29284-4.29216c.3626-.36263.9345-.388532 1.327-.077707z"
        })
    });
};

});

parcelRegister("1fo9X", function(module, exports) {

$parcel$export(module.exports, "ChevronLeft", function () { return $127762f6ddeea52a$export$29ab0a58e0457c56; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $127762f6ddeea52a$export$29ab0a58e0457c56 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: color ? (0, $i2LPb.colorCSS)(color) : "currentColor",
        height: "13",
        viewBox: "0 0 8 13",
        width: "8",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m6.73047.592759c.36263.36263.38853.934451.0777 1.326971l-.0777.08724-4.29279 4.29223 4.29281 4.2935c.36263.3627.38853.9345.07771 1.327l-.07771.0873c-.36263.3626-.93447.3885-1.32699.0776l-.08722-.0776-5.00001-5.00004c-.3626298-.36263-.3885324-.9345-.077707-1.32702l.077707-.0872 4.99998-4.999981c.39053-.390524 1.02369-.390525 1.41422 0z"
        })
    });
};

});

parcelRegister("fBLkH", function(module, exports) {

$parcel$export(module.exports, "ChevronRight", function () { return $89bb2afabfcd135f$export$6172d85aadfc9b96; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $89bb2afabfcd135f$export$6172d85aadfc9b96 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: color ? (0, $i2LPb.colorCSS)(color) : "currentColor",
        height: "13",
        viewBox: "0 0 8 13",
        width: "8",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m6.73053 5.59279c.36263.36263.38855.93447.07773 1.32699l-.07773.08722-4.99999 5c-.39052.3905-1.023684.3905-1.414209 0-.3626298-.3626-.3885324-.9345-.077707-1.327l.077707-.0872 4.292859-4.29362-4.292859-4.29216c-.3626291-.36263-.3885324-.9345-.077707-1.327017l.077707-.087201c.36263-.36263.934469-.388554 1.326989-.077729l.08722.077729z"
        })
    });
};

});

parcelRegister("17IGc", function(module, exports) {

$parcel$export(module.exports, "GoogleLogo", function () { return $4ed3192b811c26db$export$deb5eaa840e39fbf; });

var $loA2J = parcelRequire("loA2J");
const $4ed3192b811c26db$export$deb5eaa840e39fbf = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 18 18",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.64 9.205c0-.639-.057-1.252-.164-1.841H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615Z",
                fill: "#4285F4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18Z",
                fill: "#34A853"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332Z",
                fill: "#FBBC05"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58Z",
                fill: "#EA4335"
            })
        ]
    });

});

parcelRegister("buTNb", function(module, exports) {

$parcel$export(module.exports, "MicrosoftLogo", function () { return $950a75687f924faf$export$416f81fce45348; });

var $loA2J = parcelRequire("loA2J");
const $950a75687f924faf$export$416f81fce45348 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 21 21",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#f25022",
                d: "M1 1h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#00a4ef",
                d: "M1 11h9v9H1z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#7fba00",
                d: "M11 1h9v9h-9z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "#ffb900",
                d: "M11 11h9v9h-9z"
            })
        ]
    });

});

parcelRegister("6gLDf", function(module, exports) {

$parcel$export(module.exports, "Play", function () { return $51fabf55c505a6cf$export$480db61f4dcd7727; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $51fabf55c505a6cf$export$480db61f4dcd7727 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "none",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m5 5h14v14h-14z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                clipRule: "evenodd",
                d: "m10.0138 16.3878c-.83597.4912-1.5138.105-1.5138-.8645v-7.04491c0-.97008.6755-1.358 1.5138-.86566l6.465 3.79747c.5548.3261.5589.8517 0 1.1801z",
                fill: color ? (0, $i2LPb.colorCSS)(color) : "currentColor",
                fillRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "11.5",
                stroke: color ? (0, $i2LPb.colorCSS)(color) : "currentColor"
            })
        ]
    });
};

});

parcelRegister("9wehj", function(module, exports) {

$parcel$export(module.exports, "RightArrow", function () { return $f30a2f6abc65a260$export$6208675820d4cc50; });

var $loA2J = parcelRequire("loA2J");
const $f30a2f6abc65a260$export$6208675820d4cc50 = ({ color: color = "currentColor" })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fill: "none",
                d: "M0 0h24v24H0z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z",
                fill: color
            })
        ]
    });
};

});

parcelRegister("6Owxa", function(module, exports) {

$parcel$export(module.exports, "SlackLogo", function () { return $d5777f2994dc11d8$export$741d0a87d063b83b; });

var $loA2J = parcelRequire("loA2J");
const $d5777f2994dc11d8$export$741d0a87d063b83b = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "70 70 130 130",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z",
                fill: "#e01e5a"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9,s-12.9-5.8-12.9-12.9V151.2z",
                fill: "#e01e5a"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z",
                fill: "#36c5f0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9,s5.8-12.9,12.9-12.9H118.8z",
                fill: "#36c5f0"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z",
                fill: "#2eb67d"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9,c7.1,0,12.9,5.8,12.9,12.9V118.8z",
                fill: "#2eb67d"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z",
                fill: "#ecb22e"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9,c0,7.1-5.8,12.9-12.9,12.9H151.2z",
                fill: "#ecb22e"
            })
        ]
    });

});

parcelRegister("feqEs", function(module, exports) {

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $02bb0de264764e18$export$78acf4525d8a74c4 = ({ color: color })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "none",
        height: "19",
        viewBox: "0 0 21 19",
        width: "21",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            stroke: color ? (0, $i2LPb.colorCSS)(color) : "currentColor",
            strokeLinecap: "round",
            strokeWidth: "3",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m3 16.8492 14.8492-14.84921"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m3.12132 2 14.84928 14.8492"
                })
            ]
        })
    });
};

});


parcelRegister("FfaIO", function(module, exports) {
$parcel$export(module.exports, "LinkButton", function () { return (parcelRequire("82f25")).LinkButton; });
$parcel$export(module.exports, "BxpButton", function () { return (parcelRequire("8HF11")).BxpButton; });
$parcel$export(module.exports, "getAppearance", function () { return (parcelRequire("8HF11")).getAppearance; });
$parcel$export(module.exports, "getProminence", function () { return (parcelRequire("8HF11")).getProminence; });
$parcel$export(module.exports, "getSpacing", function () { return (parcelRequire("8HF11")).getSpacing; });
parcelRequire("82f25");
parcelRequire("8HF11");

});
parcelRegister("82f25", function(module, exports) {

$parcel$export(module.exports, "LinkButton", function () { return $241c6d3532544338$export$29d11c0fe2fc51d8; });

var $loA2J = parcelRequire("loA2J");

var $iCJQh = parcelRequire("iCJQh");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("bggJi");
var $9wehj = parcelRequire("9wehj");
var $6gLDf = parcelRequire("6gLDf");

var $8HF11 = parcelRequire("8HF11");
const $241c6d3532544338$export$29d11c0fe2fc51d8 = ({ appearance: appearance, style: style, children: children, decorator: decorator, id: id, className: className, isBlock: isBlock, prominence: prominence, onClick: onClick, spacing: spacing, url: url, testId: testId, tabIndex: tabIndex, ...rest })=>{
    // Decode HTML entities if children is a string
    const decodedChildren = typeof children === "string" ? (0, $iCJQh.decode)(children) : children;
    const buttonText = /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                children: decodedChildren
            }),
            decorator === "Arrow" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9wehj.RightArrow), {}),
            decorator === "Play" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6gLDf.Play), {})
        ]
    });
    const appearanceCss = (0, $8HF11.getAppearance)(appearance, style);
    const prominenceCss = (0, $8HF11.getProminence)(prominence, style);
    const spacingCss = (0, $8HF11.getSpacing)(spacing);
    const elementProps = {
        id: id,
        onClick: onClick,
        tabIndex: tabIndex,
        ...rest
    };
    return onClick && !url ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HF11.BxpButton), {
        $bxpIsBlock: false,
        $bxpAppearance: appearanceCss,
        $bxpProminence: prominenceCss,
        $bxpSpacing: spacingCss,
        className: className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
            ...elementProps,
            "data-testid": testId,
            type: "button",
            children: buttonText
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HF11.BxpLink), {
        $bxpIsBlock: false,
        $bxpAppearance: appearanceCss,
        $bxpProminence: prominenceCss,
        $bxpSpacing: spacingCss,
        className: className,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
            ...elementProps,
            href: url,
            testId: testId,
            children: buttonText
        })
    });
};

});
parcelRegister("8HF11", function(module, exports) {

$parcel$export(module.exports, "BxpLink", function () { return $28620f14250b631e$export$7077c3ae9042dfbd; });
$parcel$export(module.exports, "BxpButton", function () { return $28620f14250b631e$export$bd427773a239b4e7; });
$parcel$export(module.exports, "getAppearance", function () { return $28620f14250b631e$export$d1dcfd32a1d228ca; });
$parcel$export(module.exports, "getProminence", function () { return $28620f14250b631e$export$85b153470641a7e8; });
$parcel$export(module.exports, "getSpacing", function () { return $28620f14250b631e$export$f63796f8a9382bfb; });
/* eslint-disable complexity */ // @ts-nocheck

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $28620f14250b631e$export$7077c3ae9042dfbd = (0, $hYbro.default).div`
    ${({ $bxpIsBlock: $bxpIsBlock })=>(0, $jAJVK.redundantCssFromKebab)("display", $bxpIsBlock ? "block" : "inline-block")}
    ${({ $bxpSpacing: $bxpSpacing })=>$bxpSpacing}

    &&&& a,
    &&&& a:any-link,
    &&&& a:link,
    &&&& a:visited,
    &&&& > span {
        ${(0, $jAJVK.redundantCssFromKebab)("user-select", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "all 250ms ease-out")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}

        &:hover,
        &:focus {
            ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
        }

        span {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        }

        ${({ $bxpAppearance: $bxpAppearance })=>$bxpAppearance}
        ${({ $bxpProminence: $bxpProminence })=>$bxpProminence}
    }

    ${({ $bxpIsBlock: $bxpIsBlock })=>$bxpIsBlock ? (0, $hYbro.css)`
                  &&&& > a,
                  &&&& > span {
                      display: flex;
                      width: 100%;
                      justify-content: center;
                  }
              ` : ""}
`;
const $28620f14250b631e$export$bd427773a239b4e7 = (0, $hYbro.default).div`
    ${({ $bxpIsBlock: $bxpIsBlock })=>(0, $jAJVK.redundantCssFromKebab)("display", $bxpIsBlock ? "block" : "inline-block")}
    ${({ $bxpSpacing: $bxpSpacing })=>$bxpSpacing}

    &&&& button {
        ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("user-select", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "all 250ms ease-out")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
        ${({ $bxpAppearance: $bxpAppearance })=>$bxpAppearance}
        ${({ $bxpProminence: $bxpProminence })=>$bxpProminence}
    }

    ${({ $bxpIsBlock: $bxpIsBlock })=>$bxpIsBlock ? (0, $hYbro.css)`
                  &&&& > button {
                      display: flex;
                      width: 100%;
                      justify-content: center;
                  }
              ` : ""}
`;
function $28620f14250b631e$export$d1dcfd32a1d228ca(appearance, style) {
    switch(appearance){
        case "Creative":
            return style == "Outline" ? $28620f14250b631e$var$creativeOutlineButton : $28620f14250b631e$var$creativeButton;
        case "Light":
            return style == "Outline" ? $28620f14250b631e$var$lightOutlineButton : $28620f14250b631e$var$lightButton;
        case "Muted":
            return style == "Outline" ? $28620f14250b631e$var$mutedOutlineButton : $28620f14250b631e$var$mutedButton;
        case "Neutral":
            return style == "Outline" ? $28620f14250b631e$var$neutralOutlineButton : $28620f14250b631e$var$neutralButton;
        case "Primary":
            return style == "Outline" ? $28620f14250b631e$var$primaryOutlineButton : $28620f14250b631e$var$primaryButton;
        case "Secondary":
            return style == "Outline" ? $28620f14250b631e$var$secondaryOutlineButton : $28620f14250b631e$var$secondaryButton;
        case "Purple":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("P") : $28620f14250b631e$var$colorButton("P");
        case "Magenta":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("M") : $28620f14250b631e$var$colorButton("M");
        case "Teal":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("T") : $28620f14250b631e$var$colorButton("T");
        case "Red":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("R") : $28620f14250b631e$var$colorButton("R");
        case "Yellow":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("Y") : $28620f14250b631e$var$colorButton("Y");
        case "Green":
            return style == "Outline" ? $28620f14250b631e$var$colorOutlineButton("G") : $28620f14250b631e$var$colorButton("G");
        default:
            return style == "Outline" ? $28620f14250b631e$var$primaryOutlineButton : $28620f14250b631e$var$defaultButton;
    }
}
function $28620f14250b631e$export$85b153470641a7e8(prominence, style) {
    switch(prominence){
        case "Elevated":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
                ${style !== "No padding" ? "padding: 0.8rem 1.25rem 0.9rem;" : ""}
            `;
        case "Reduced":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
                ${style !== "No padding" ? "padding: 0.4rem 0.5rem 0.5rem;" : ""}
            `;
        default:
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
                ${style !== "No padding" ? "padding: 0.7rem 1rem 0.8rem;" : ""}
            `;
    }
}
function $28620f14250b631e$export$f63796f8a9382bfb(spacing) {
    switch(spacing){
        case "Left":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "0.75rem")}
            `;
        case "Right":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-end", "0.75rem")}
            `;
        case "LeftRight":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "0.75rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-end", "0.75rem")}
            `;
        case "LeftBottom":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.75rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "0.75rem")}
            `;
        case "RightBottom":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.75rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-end", "0.75rem")}
            `;
        case "LeftRightBottom":
            return (0, $hYbro.css)`
                ${(0, $jAJVK.redundantCssFromKebab)("margin-block-end", "0.75rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "0.75rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-end", "0.75rem")}
            `;
        default:
            return (0, $hYbro.css)``;
    }
}
const $28620f14250b631e$var$defaultButton = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "all 250ms ease-out")}

    span {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
    }

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-inline-start", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-block-start", "2px")}
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "translate3d(0px, 0, 0)")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "transform 250ms ease-out")}
    }

    &:hover svg,
    &:focus svg {
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "translate3d(3px, 0, 0)")}
    }
`;
const $28620f14250b631e$var$removeTextDecorationStyles = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}

    &:hover,
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    }
`;
const $28620f14250b631e$var$creativeButton = (0, $hYbro.css)`
    ${$28620f14250b631e$var$defaultButton}
    ${$28620f14250b631e$var$removeTextDecorationStyles}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("G300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}

    &:hover,
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("G400")}`)}
    }

    &:active {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G500")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("G500")}`)}
    }

    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("G400", 0.5)}`)}
    }
`;
const $28620f14250b631e$var$creativeOutlineButton = (0, $hYbro.css)`
    ${$28620f14250b631e$var$defaultButton}
    ${$28620f14250b631e$var$removeTextDecorationStyles}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0", 0.9)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("G300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}

    &:hover,
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G400", 0.1)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("G400")}`)}
    }

    &:active {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G500", 0.1)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("G500")}`)}
    }

    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("G400", 0.5)}`)}
    }
`;
const $28620f14250b631e$var$lightButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N0")}`,
    "color": `${(0, $i2LPb.colorCSS)("N900")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("N20"),
        borderColor: (0, $i2LPb.colorCSS)("N20")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N40"),
        borderColor: (0, $i2LPb.colorCSS)("N40")
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N20", 0.5)}`
    }
});
const $28620f14250b631e$var$lightOutlineButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N900")}`,
    "color": `${(0, $i2LPb.colorCSS)("N900")}`,
    "&:hover, &:focus": {
        borderColor: (0, $i2LPb.colorCSS)("N900")
    },
    "&:active": {
        borderColor: (0, $i2LPb.colorCSS)("N900", 0.5)
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N0", 0.5)}`
    }
});
const $28620f14250b631e$var$mutedButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N40"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N40")}`,
    "color": `${(0, $i2LPb.colorCSS)("N900")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("N50"),
        borderColor: (0, $i2LPb.colorCSS)("N50")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N60"),
        borderColor: (0, $i2LPb.colorCSS)("N60"),
        color: `${(0, $i2LPb.colorCSS)("N900", 0.9)}`
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N50", 0.4)}`
    }
});
const $28620f14250b631e$var$mutedOutlineButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N80")}`,
    "color": `${(0, $i2LPb.colorCSS)("N800")}`,
    "&:hover, &:focus": {
        borderColor: (0, $i2LPb.colorCSS)("N90")
    },
    "&:active": {
        borderColor: (0, $i2LPb.colorCSS)("N100"),
        color: `${(0, $i2LPb.colorCSS)("N300")}`
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N90", 0.4)}`
    }
});
const $28620f14250b631e$var$neutralButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N90"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N90")}`,
    "color": `${(0, $i2LPb.colorCSS)("N0")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("N100"),
        borderColor: (0, $i2LPb.colorCSS)("N100")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N200"),
        borderColor: (0, $i2LPb.colorCSS)("N200")
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$neutralOutlineButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0", 0.9),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N90")}`,
    "color": `${(0, $i2LPb.colorCSS)("N800")}`,
    "&:hover, &:focus": {
        borderColor: (0, $i2LPb.colorCSS)("N100"),
        color: `${(0, $i2LPb.colorCSS)("N100")}`
    },
    "&:active": {
        borderColor: (0, $i2LPb.colorCSS)("N200"),
        color: `${(0, $i2LPb.colorCSS)("N200")}`
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$primaryButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("B300"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("B300")}`,
    "color": `${(0, $i2LPb.colorCSS)("N0")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("B500"),
        borderColor: (0, $i2LPb.colorCSS)("B500")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("B400"),
        borderColor: (0, $i2LPb.colorCSS)("B400")
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$primaryOutlineButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("B300")}`,
    "color": `${(0, $i2LPb.colorCSS)("N800")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("B50"),
        borderColor: (0, $i2LPb.colorCSS)("B300"),
        color: `${(0, $i2LPb.colorCSS)("N800")}`
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("B50"),
        borderColor: (0, $i2LPb.colorCSS)("B50"),
        color: `${(0, $i2LPb.colorCSS)("N800")}`
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$secondaryButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N800"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N800")}`,
    "color": `${(0, $i2LPb.colorCSS)("N0")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("N400"),
        borderColor: (0, $i2LPb.colorCSS)("N400")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N100"),
        borderColor: (0, $i2LPb.colorCSS)("N100")
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$secondaryOutlineButton = (0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N800")}`,
    "color": `${(0, $i2LPb.colorCSS)("N800")}`,
    "&:hover, &:focus": {
        backgroundColor: (0, $i2LPb.colorCSS)("N40"),
        borderColor: (0, $i2LPb.colorCSS)("N800"),
        color: `${(0, $i2LPb.colorCSS)("N800")}`
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N40"),
        borderColor: (0, $i2LPb.colorCSS)("N40"),
        color: `${(0, $i2LPb.colorCSS)("N800")}`
    },
    "&:focus": {
        boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)("N100", 0.5)}`
    }
});
const $28620f14250b631e$var$colorButton = (color)=>(0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
        "backgroundColor": (0, $i2LPb.colorCSS)(`${color}50`),
        "border": `1px solid ${(0, $i2LPb.colorCSS)(`${color}300`)}`,
        "color": `${(0, $i2LPb.colorCSS)("N800")}`,
        "&:hover, &:focus": {
            backgroundColor: (0, $i2LPb.colorCSS)("N0"),
            borderColor: (0, $i2LPb.colorCSS)(`${color}300`)
        },
        "&:active": {
            backgroundColor: (0, $i2LPb.colorCSS)(`${color}50`),
            borderColor: (0, $i2LPb.colorCSS)(`${color}50`)
        },
        "&:focus": {
            boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)(`${color}100`, 0.5)}`
        }
    });
const $28620f14250b631e$var$colorOutlineButton = (color)=>(0, $hYbro.css)($28620f14250b631e$var$defaultButton, $28620f14250b631e$var$removeTextDecorationStyles, {
        "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
        "border": `1px solid ${(0, $i2LPb.colorCSS)(`${color}300`)}`,
        "color": `${(0, $i2LPb.colorCSS)("N800")}`,
        "&:hover, &:focus": {
            backgroundColor: (0, $i2LPb.colorCSS)(`${color}50`),
            borderColor: (0, $i2LPb.colorCSS)(`${color}300`),
            color: `${(0, $i2LPb.colorCSS)("N800")}`
        },
        "&:active": {
            backgroundColor: (0, $i2LPb.colorCSS)(`${color}50`),
            borderColor: (0, $i2LPb.colorCSS)(`${color}50`),
            color: `${(0, $i2LPb.colorCSS)("N800")}`
        },
        "&:focus": {
            boxShadow: `0 0 0 0.2rem ${(0, $i2LPb.colorCSS)(`${color}100`, 0.5)}`
        }
    });

});



parcelRegister("fR9Sp", function(module, exports) {
$parcel$export(module.exports, "Picture", function () { return (parcelRequire("41Ir1")).Picture; });
parcelRequire("41Ir1");

});
parcelRegister("41Ir1", function(module, exports) {

$parcel$export(module.exports, "Picture", function () { return $6d29c0e21f07003e$export$f0d5dc2ce3e4cb5f; });
/* eslint-disable no-restricted-syntax */ // This file implements the Picture component itself, so <img> tags are allowed here

var $loA2J = parcelRequire("loA2J");

var $aAquZ = parcelRequire("aAquZ");
parcelRequire("h6yBX");
var $8DhG7 = parcelRequire("8DhG7");
var $bQJY8 = parcelRequire("bQJY8");
const $6d29c0e21f07003e$export$f0d5dc2ce3e4cb5f = ({ image: image, altText: altText, decorative: decorative })=>{
    const { url: url, title: title, width: width, height: height } = image;
    const altAttributeValue = altText ? altText : title;
    if (!url) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aAquZ.ViewModelError), {
        model: image
    }, `${Date.now()}`);
    /**
   * TODO: add Sentry error boundary with tags
   * scope.setTags({team: 'bxpt', modelType: 'asset', contentId: id})
   */ if (url.endsWith(".svg")) {
        const imageStyle = {
            maxWidth: "100%",
            height: "auto"
        };
        return /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            style: imageStyle,
            src: url,
            alt: decorative ? "" : altAttributeValue,
            width: width,
            height: height,
            loading: "lazy"
        });
    }
    /**
   * If a valid width is found, restrict image width based on container size
   *
   * When large images are uploaded, this guarantees images will be full resolution
   * by assuming the image can be the full width of the container. If that width is
   * not available then use the native image size.
   */ if (width && Number.isInteger(width) && width > 0) {
        function getWidthForContainer(imgWidth, containerWidth, pixelDensity = 1) {
            if (imgWidth > containerWidth * pixelDensity) return containerWidth * pixelDensity;
            return imgWidth;
        }
        const xlWidth = getWidthForContainer(width, (0, $8DhG7.containerWidths).xl);
        const xlWidthRetina = getWidthForContainer(width, (0, $8DhG7.containerWidths).xl, 2);
        const lgWidth = getWidthForContainer(width, (0, $8DhG7.containerWidths).lg);
        const lgWidthRetina = getWidthForContainer(width, (0, $8DhG7.containerWidths).lg, 2);
        const mdWidth = getWidthForContainer(width, (0, $8DhG7.containerWidths).md);
        const mdWidthRetina = getWidthForContainer(width, (0, $8DhG7.containerWidths).md, 2);
        const smWidth = getWidthForContainer(width, (0, $8DhG7.containerWidths).sm);
        const smWidthRetina = getWidthForContainer(width, (0, $8DhG7.containerWidths).sm, 2);
        return /*#__PURE__*/ (0, $loA2J.jsxs)("picture", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    type: "image/webp",
                    media: `(min-width: ${(0, $bQJY8.breakpoints).xl}px)`,
                    srcSet: `${url}?w=${xlWidthRetina}&fm=webp 2x, ${url}?w=${xlWidth}&fm=webp`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    media: `(min-width: ${(0, $bQJY8.breakpoints).xl}px)`,
                    srcSet: `${url}?w=${xlWidthRetina} 2x, ${url}?w=${xlWidth}`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    type: "image/webp",
                    media: `(min-width: ${(0, $bQJY8.breakpoints).lg}px)`,
                    srcSet: `${url}?w=${lgWidthRetina}&fm=webp 2x, ${url}?w=${lgWidth}&fm=webp`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    media: `(min-width: ${(0, $bQJY8.breakpoints).lg}px)`,
                    srcSet: `${url}?w=${lgWidthRetina} 2x, ${url}?w=${lgWidth}`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    type: "image/webp",
                    media: `(min-width: ${(0, $bQJY8.breakpoints).md}px)`,
                    srcSet: `${url}?w=${mdWidthRetina}&fm=webp 2x, ${url}?w=${mdWidth}&fm=webp`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    media: `(min-width: ${(0, $bQJY8.breakpoints).md}px)`,
                    srcSet: `${url}?w=${mdWidthRetina} 2x, ${url}?w=${mdWidth}`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    type: "image/webp",
                    media: `(min-width: ${(0, $bQJY8.breakpoints).sm}px)`,
                    srcSet: `${url}?w=${smWidthRetina}&fm=webp 2x, ${url}?w=${smWidth}&fm=webp`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    media: `(min-width: ${(0, $bQJY8.breakpoints).sm}px)`,
                    srcSet: `${url}?w=${smWidthRetina} 2x, ${url}?w=${smWidth}`
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    srcSet: `${url}?w=${smWidthRetina} 2x`,
                    src: `${url}?w=${smWidth}`,
                    alt: decorative ? "" : altAttributeValue,
                    width: width / 2,
                    height: height ? height / 2 : undefined,
                    loading: "lazy"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $loA2J.jsxs)("picture", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                type: "image/webp",
                media: `(min-width: ${(0, $bQJY8.breakpoints).lg}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).xl}&fm=webp`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                media: `(min-width: ${(0, $bQJY8.breakpoints).lg}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).xl}`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                type: "image/webp",
                media: `(min-width: ${(0, $bQJY8.breakpoints).md}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).lg}&fm=webp`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                media: `(min-width: ${(0, $bQJY8.breakpoints).md}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).lg}`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                type: "image/webp",
                media: `(min-width: ${(0, $bQJY8.breakpoints).sm}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).md}&fm=webp`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                media: `(min-width: ${(0, $bQJY8.breakpoints).sm}px)`,
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).md}`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                type: "image/webp",
                srcSet: `${url}?w=${(0, $bQJY8.breakpoints).sm}&fm=webp`
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                style: {
                    maxWidth: "100%",
                    height: "auto"
                },
                src: `${url}?w=${(0, $bQJY8.breakpoints).sm}`,
                alt: decorative ? "" : altAttributeValue,
                width: width ? width / 2 : undefined,
                height: height ? height / 2 : undefined,
                loading: "lazy"
            })
        ]
    });
};

});
parcelRegister("aAquZ", function(module, exports) {

$parcel$export(module.exports, "ViewModelError", function () { return $7b51d24bd0d59829$export$575f7cbf51b0a0a1; });
/* ViewModelError.js generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $kqM0X = parcelRequire("kqM0X");

var $47vbe = parcelRequire("47vbe");

var $fqQ6h = parcelRequire("fqQ6h");
const $7b51d24bd0d59829$export$575f7cbf51b0a0a1 = ({ model: model })=>{
    if ((0, $fqQ6h.isUnpublishedEntry)(model) || (0, $fqQ6h.isUnpublishedAsset)(model)) $kqM0X.captureException(new Error("View Model Error"), {
        tags: {
            team: "bxpt",
            modelType: model.sys.linkType,
            contentId: model.sys.id
        }
    });
    const { environment: environment } = (0, $47vbe.useConfig)();
    if (environment === "production") return null;
    const goToUrl = `https://app.contentful.com/spaces/rz1oowkt5gyp/environments/${environment}`;
    return (0, $loA2J.jsxs)($7b51d24bd0d59829$var$WarningBlock, {
        children: [
            (0, $fqQ6h.isUnpublishedEntry)(model) && (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    (0, $loA2J.jsxs)($7b51d24bd0d59829$var$WarningText, {
                        children: [
                            "There is an unpublished ",
                            (0, $loA2J.jsx)("b", {
                                children: "entry"
                            }),
                            " here."
                        ]
                    }),
                    (0, $loA2J.jsxs)($7b51d24bd0d59829$var$WarningLink, {
                        href: `${goToUrl}/entries/${model.sys.id}`,
                        children: [
                            "Go to entry ID: ",
                            model.sys.id
                        ]
                    })
                ]
            }),
            (0, $fqQ6h.isUnpublishedAsset)(model) && (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    (0, $loA2J.jsxs)($7b51d24bd0d59829$var$WarningText, {
                        children: [
                            "There is an unpublished ",
                            (0, $loA2J.jsx)("b", {
                                children: "asset"
                            }),
                            " here."
                        ]
                    }),
                    (0, $loA2J.jsxs)($7b51d24bd0d59829$var$WarningLink, {
                        href: `${goToUrl}/assets/${model.sys.id}`,
                        children: [
                            "Go to asset ID: ",
                            model.sys.id
                        ]
                    })
                ]
            })
        ]
    });
};
const $7b51d24bd0d59829$var$WarningBlock = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_bfhk1j28 _syaz1kw7 _2rkooqnp _ca0qoqnp _u5f31k8s _n3tdoqnp _19bv1k8s _otyr19as _19it9m56",
            __cmplp.className
        ])
    });
});
const $7b51d24bd0d59829$var$WarningText = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1wyb1k92",
            __cmplp.className
        ])
    });
});
const $7b51d24bd0d59829$var$WarningLink = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1wyb1j6v _l7ed6mu8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kqM0X", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $edfb7b00f8706f1f$export$f5282963edea4a68; });
$parcel$export(module.exports, "getCurrentScope", function () { return $edfb7b00f8706f1f$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $edfb7b00f8706f1f$export$6bb76d6eba7e258c; });

var $36mep = parcelRequire("36mep");
var $6BXtB = parcelRequire("6BXtB");
var $g7Zy6 = parcelRequire("g7Zy6");
var $6K6d1 = parcelRequire("6K6d1");
var $kj8fe = parcelRequire("kj8fe");

var $Hklh0 = parcelRequire("Hklh0");

var $6TY3y = parcelRequire("6TY3y");

var $5jEOI = parcelRequire("5jEOI");

var $82CWW = parcelRequire("82CWW");

var $1Em6z = parcelRequire("1Em6z");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $edfb7b00f8706f1f$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().captureException(exception, (0, $1Em6z.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $edfb7b00f8706f1f$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $edfb7b00f8706f1f$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $edfb7b00f8706f1f$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $edfb7b00f8706f1f$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $5jEOI.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $edfb7b00f8706f1f$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $5jEOI.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $edfb7b00f8706f1f$export$9a4fed82c350c2bd(callback) {
    return (0, $5jEOI.runWithAsyncContext)(()=>{
        return callback((0, $5jEOI.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $edfb7b00f8706f1f$export$e57ac09b143d92a2(span, callback) {
    return $edfb7b00f8706f1f$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $edfb7b00f8706f1f$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $edfb7b00f8706f1f$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $edfb7b00f8706f1f$export$c7be4b0125a10cba();
    const client = $edfb7b00f8706f1f$export$6bb76d6eba7e258c();
    if (!client) (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $kj8fe.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $edfb7b00f8706f1f$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $edfb7b00f8706f1f$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $6K6d1.timestampInSeconds)();
    function finishCheckIn(status) {
        $edfb7b00f8706f1f$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $6K6d1.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $6BXtB.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $edfb7b00f8706f1f$export$4909b86c8034bf73(timeout) {
    const client = $edfb7b00f8706f1f$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $edfb7b00f8706f1f$export$8360e631d277ea4d(timeout) {
    const client = $edfb7b00f8706f1f$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $edfb7b00f8706f1f$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $edfb7b00f8706f1f$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $edfb7b00f8706f1f$export$3f95c6f800b78024() {
    return !!$edfb7b00f8706f1f$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $edfb7b00f8706f1f$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $5jEOI.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $edfb7b00f8706f1f$export$c0d84948cecf78d8(context) {
    const client = $edfb7b00f8706f1f$export$6bb76d6eba7e258c();
    const isolationScope = (0, $5jEOI.getIsolationScope)();
    const currentScope = $edfb7b00f8706f1f$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $Hklh0.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $36mep.GLOBAL_OBJ).navigator || {};
    const session = (0, $82CWW.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $82CWW.updateSession)(currentSession, {
        status: "exited"
    });
    $edfb7b00f8706f1f$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $edfb7b00f8706f1f$export$17a5be43989a0bc1() {
    const isolationScope = (0, $5jEOI.getIsolationScope)();
    const currentScope = $edfb7b00f8706f1f$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $82CWW.closeSession)(session);
    $edfb7b00f8706f1f$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $edfb7b00f8706f1f$var$_sendSessionUpdate() {
    const isolationScope = (0, $5jEOI.getIsolationScope)();
    const currentScope = $edfb7b00f8706f1f$export$c7be4b0125a10cba();
    const client = $edfb7b00f8706f1f$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $edfb7b00f8706f1f$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $edfb7b00f8706f1f$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $edfb7b00f8706f1f$var$_sendSessionUpdate();
}

});
parcelRegister("36mep", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $24232d556808797c$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $24232d556808797c$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $24232d556808797c$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $24232d556808797c$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $24232d556808797c$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $24232d556808797c$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $24232d556808797c$var$isGlobalObj(window) || typeof self == "object" && $24232d556808797c$var$isGlobalObj(self) || typeof $parcel$global == "object" && $24232d556808797c$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $24232d556808797c$export$256479dc0cea61c4() {
    return $24232d556808797c$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $24232d556808797c$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $24232d556808797c$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("6BXtB", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $4d045596cded65d9$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $4d045596cded65d9$export$49034edbe6b62415; });
$parcel$export(module.exports, "isString", function () { return $4d045596cded65d9$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $4d045596cded65d9$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $4d045596cded65d9$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $4d045596cded65d9$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $4d045596cded65d9$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $4d045596cded65d9$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $4d045596cded65d9$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $4d045596cded65d9$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $4d045596cded65d9$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $4d045596cded65d9$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $4d045596cded65d9$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$e6127cc7fe7395c3(wat) {
    switch($4d045596cded65d9$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $4d045596cded65d9$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$var$isBuiltin(wat, className) {
    return $4d045596cded65d9$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$9f9636d330b71954(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$ef9e2056653f0c8e(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$12e869b2a583f783(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$844ec244b1367d54(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$c3825b437cbdea5c(wat) {
    return wat === null || $4d045596cded65d9$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$53b83ca8eaab0383(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $4d045596cded65d9$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $4d045596cded65d9$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$49841c62b9eff15(wat) {
    return $4d045596cded65d9$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $4d045596cded65d9$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$bc2894c7158efbac(wat) {
    return $4d045596cded65d9$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $4d045596cded65d9$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("g7Zy6", function(module, exports) {

$parcel$export(module.exports, "consoleSandbox", function () { return $bbdd0b2aad9824b5$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $bbdd0b2aad9824b5$export$af88d00dbe7f521; });

var $2BDpo = parcelRequire("2BDpo");

var $36mep = parcelRequire("36mep");
/** Prefix for logging strings */ const $bbdd0b2aad9824b5$var$PREFIX = "Sentry Logger ";
const $bbdd0b2aad9824b5$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $bbdd0b2aad9824b5$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $bbdd0b2aad9824b5$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $36mep.GLOBAL_OBJ))) return callback();
    const console = (0, $36mep.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($bbdd0b2aad9824b5$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $bbdd0b2aad9824b5$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $bbdd0b2aad9824b5$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $2BDpo.DEBUG_BUILD) $bbdd0b2aad9824b5$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $bbdd0b2aad9824b5$export$cda52e2a8927a2ca(()=>{
                (0, $36mep.GLOBAL_OBJ).console[name](`${$bbdd0b2aad9824b5$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $bbdd0b2aad9824b5$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $bbdd0b2aad9824b5$export$af88d00dbe7f521 = $bbdd0b2aad9824b5$var$makeLogger();

});
parcelRegister("2BDpo", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $1e5d9b2ae869b348$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1e5d9b2ae869b348$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("6K6d1", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $4e8bdaf04afd7274$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $4e8bdaf04afd7274$export$ee52dced521e3e18; });

var $36mep = parcelRequire("36mep");
const $4e8bdaf04afd7274$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $4e8bdaf04afd7274$export$7740643b9eeaf0c4() {
    return Date.now() / $4e8bdaf04afd7274$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $4e8bdaf04afd7274$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $36mep.GLOBAL_OBJ);
    if (!performance || !performance.now) return $4e8bdaf04afd7274$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $4e8bdaf04afd7274$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $4e8bdaf04afd7274$export$ee52dced521e3e18 = $4e8bdaf04afd7274$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $4e8bdaf04afd7274$export$c5907b5a8838db13 = $4e8bdaf04afd7274$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $4e8bdaf04afd7274$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $4e8bdaf04afd7274$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $36mep.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $4e8bdaf04afd7274$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $4e8bdaf04afd7274$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $4e8bdaf04afd7274$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $4e8bdaf04afd7274$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("kj8fe", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $ec8bfa30d324554f$export$19f53698e68b2496; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $ec8bfa30d324554f$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "arrayify", function () { return $ec8bfa30d324554f$export$3131421a7d01b4fb; });

var $2OoK0 = parcelRequire("2OoK0");

var $03yIt = parcelRequire("03yIt");

var $36mep = parcelRequire("36mep");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $ec8bfa30d324554f$export$19f53698e68b2496() {
    const gbl = (0, $36mep.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $ec8bfa30d324554f$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $ec8bfa30d324554f$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $ec8bfa30d324554f$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $ec8bfa30d324554f$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $ec8bfa30d324554f$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $ec8bfa30d324554f$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $ec8bfa30d324554f$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $ec8bfa30d324554f$export$d364f2020ab30578(input) {
    const match = input.match($ec8bfa30d324554f$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $ec8bfa30d324554f$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $03yIt.snipLine)(line, 0));
    frame.context_line = (0, $03yIt.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $03yIt.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $ec8bfa30d324554f$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $2OoK0.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $ec8bfa30d324554f$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("2OoK0", function(module, exports) {

$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $20c3715a6c95a488$export$e73679ffaf56810e; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $20c3715a6c95a488$export$62ff257738bf57f5; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $20c3715a6c95a488$export$d25f2688db1bb433; });

var $bzCJD = parcelRequire("bzCJD");

var $2BDpo = parcelRequire("2BDpo");

var $6BXtB = parcelRequire("6BXtB");

var $g7Zy6 = parcelRequire("g7Zy6");

var $03yIt = parcelRequire("03yIt");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $20c3715a6c95a488$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $20c3715a6c95a488$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $20c3715a6c95a488$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $2BDpo.DEBUG_BUILD) && (0, $g7Zy6.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $20c3715a6c95a488$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $20c3715a6c95a488$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $20c3715a6c95a488$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $20c3715a6c95a488$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $20c3715a6c95a488$export$62ff257738bf57f5(value) {
    if ((0, $6BXtB.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$20c3715a6c95a488$var$getOwnProperties(value)
    };
    else if ((0, $6BXtB.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $20c3715a6c95a488$var$serializeEventTarget(value.target),
            currentTarget: $20c3715a6c95a488$var$serializeEventTarget(value.currentTarget),
            ...$20c3715a6c95a488$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $6BXtB.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $20c3715a6c95a488$var$serializeEventTarget(target) {
    try {
        return (0, $6BXtB.isElement)(target) ? (0, $bzCJD.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $20c3715a6c95a488$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $20c3715a6c95a488$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($20c3715a6c95a488$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $03yIt.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $03yIt.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $20c3715a6c95a488$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $20c3715a6c95a488$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $20c3715a6c95a488$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($20c3715a6c95a488$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $20c3715a6c95a488$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($20c3715a6c95a488$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $20c3715a6c95a488$var$isPojo(input) {
    if (!(0, $6BXtB.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $20c3715a6c95a488$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $6BXtB.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("bzCJD", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $86d1028e6729003b$export$5647df6b7814ac86; });

var $6BXtB = parcelRequire("6BXtB");

var $36mep = parcelRequire("36mep");
// eslint-disable-next-line deprecation/deprecation
const $86d1028e6729003b$var$WINDOW = (0, $36mep.getGlobalObject)();
const $86d1028e6729003b$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $86d1028e6729003b$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $86d1028e6729003b$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $86d1028e6729003b$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $86d1028e6729003b$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($86d1028e6729003b$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $6BXtB.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $86d1028e6729003b$export$1cfafeee2987818b() {
    try {
        return $86d1028e6729003b$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $86d1028e6729003b$export$c660c1f3ab49225c(selector) {
    if ($86d1028e6729003b$var$WINDOW.document && $86d1028e6729003b$var$WINDOW.document.querySelector) return $86d1028e6729003b$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $86d1028e6729003b$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$86d1028e6729003b$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("03yIt", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $00ab35e0e10f33c4$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $00ab35e0e10f33c4$export$4215662d762d6f9d; });

var $6BXtB = parcelRequire("6BXtB");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $00ab35e0e10f33c4$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $00ab35e0e10f33c4$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $00ab35e0e10f33c4$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $6BXtB.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $00ab35e0e10f33c4$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $6BXtB.isString)(value)) return false;
    if ((0, $6BXtB.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $6BXtB.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $00ab35e0e10f33c4$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$00ab35e0e10f33c4$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("Hklh0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $0823cbc994e308c3$export$849dbeeeda01ae98; });
const $0823cbc994e308c3$export$849dbeeeda01ae98 = "production";

});

parcelRegister("6TY3y", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $50667714352d11e2$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $50667714352d11e2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("5jEOI", function(module, exports) {

$parcel$export(module.exports, "getCurrentHub", function () { return $3dee637e91f33f35$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $3dee637e91f33f35$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $3dee637e91f33f35$export$70d775fb1f267027; });

var $g7Zy6 = parcelRequire("g7Zy6");
var $6K6d1 = parcelRequire("6K6d1");
var $36mep = parcelRequire("36mep");
var $6BXtB = parcelRequire("6BXtB");
var $kj8fe = parcelRequire("kj8fe");

var $Hklh0 = parcelRequire("Hklh0");

var $6TY3y = parcelRequire("6TY3y");

var $2nY72 = parcelRequire("2nY72");

var $82CWW = parcelRequire("82CWW");

var $fYzWj = parcelRequire("fYzWj");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $3dee637e91f33f35$export$24a86ef7798177e4 = parseFloat((0, $fYzWj.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $3dee637e91f33f35$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $3dee637e91f33f35$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $3dee637e91f33f35$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $2nY72.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $2nY72.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $6BXtB.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $3dee637e91f33f35$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $6K6d1.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $g7Zy6.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $3dee637e91f33f35$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $3dee637e91f33f35$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $6TY3y.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $g7Zy6.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $g7Zy6.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $82CWW.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $Hklh0.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $36mep.GLOBAL_OBJ).navigator || {};
        const session = (0, $82CWW.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $82CWW.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $3dee637e91f33f35$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $6TY3y.DEBUG_BUILD) && (0, $g7Zy6.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $3dee637e91f33f35$export$19eade501500c6c1() {
    (0, $36mep.GLOBAL_OBJ).__SENTRY__ = (0, $36mep.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $36mep.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$export$4188a14ad302d1bc(hub) {
    const registry = $3dee637e91f33f35$export$19eade501500c6c1();
    const oldHub = $3dee637e91f33f35$export$bfa8a924a84a76b7(registry);
    $3dee637e91f33f35$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $3dee637e91f33f35$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $3dee637e91f33f35$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $3dee637e91f33f35$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $3dee637e91f33f35$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$var$getGlobalHub(registry = $3dee637e91f33f35$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$3dee637e91f33f35$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $3dee637e91f33f35$export$bfa8a924a84a76b7(registry).isOlderThan($3dee637e91f33f35$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $3dee637e91f33f35$export$849f05434e95d2f2(registry, new $3dee637e91f33f35$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $3dee637e91f33f35$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$export$236689a79f5aa020(carrier, parent = $3dee637e91f33f35$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$3dee637e91f33f35$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $3dee637e91f33f35$export$bfa8a924a84a76b7(carrier).isOlderThan($3dee637e91f33f35$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $3dee637e91f33f35$export$849f05434e95d2f2(carrier, new $3dee637e91f33f35$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $3dee637e91f33f35$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $3dee637e91f33f35$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $3dee637e91f33f35$export$70d775fb1f267027(callback, options = {}) {
    const registry = $3dee637e91f33f35$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $3dee637e91f33f35$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $36mep.getGlobalSingleton)("hub", ()=>new $3dee637e91f33f35$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $3dee637e91f33f35$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("2nY72", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $1bcc5bd56efce644$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $1bcc5bd56efce644$export$aa55d5ab8e05984f; });

var $6K6d1 = parcelRequire("6K6d1");
var $6BXtB = parcelRequire("6BXtB");
var $g7Zy6 = parcelRequire("g7Zy6");
var $kj8fe = parcelRequire("kj8fe");

var $7oA1A = parcelRequire("7oA1A");

var $82CWW = parcelRequire("82CWW");

var $gbOeN = parcelRequire("gbOeN");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $1bcc5bd56efce644$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $1bcc5bd56efce644$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $1bcc5bd56efce644$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $1bcc5bd56efce644$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $1bcc5bd56efce644$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $1bcc5bd56efce644$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $82CWW.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $1bcc5bd56efce644$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $6BXtB.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $1bcc5bd56efce644$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $1bcc5bd56efce644$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $6K6d1.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $gbOeN.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $7oA1A.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $7oA1A.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        if (!this._client) {
            (0, $g7Zy6.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        if (!this._client) {
            (0, $g7Zy6.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $kj8fe.uuid4)();
        if (!this._client) {
            (0, $g7Zy6.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $1bcc5bd56efce644$export$aa55d5ab8e05984f() {
    if (!$1bcc5bd56efce644$var$globalScope) $1bcc5bd56efce644$var$globalScope = new $1bcc5bd56efce644$export$775b6bb06e53a214();
    return $1bcc5bd56efce644$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $1bcc5bd56efce644$export$c83048efd17527d6(scope) {
    $1bcc5bd56efce644$var$globalScope = scope;
}
function $1bcc5bd56efce644$var$generatePropagationContext() {
    return {
        traceId: (0, $kj8fe.uuid4)(),
        spanId: (0, $kj8fe.uuid4)().substring(16)
    };
}

});
parcelRegister("7oA1A", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $5626b80a09db9e7a$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $5626b80a09db9e7a$export$bf2a096c3e883e79; });

var $36mep = parcelRequire("36mep");
var $6BXtB = parcelRequire("6BXtB");
var $g7Zy6 = parcelRequire("g7Zy6");
var $iQ4Il = parcelRequire("iQ4Il");

var $6TY3y = parcelRequire("6TY3y");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $5626b80a09db9e7a$export$3c4238858b85e8ac() {
    return (0, $36mep.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $5626b80a09db9e7a$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $5626b80a09db9e7a$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $5626b80a09db9e7a$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $iQ4Il.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $6TY3y.DEBUG_BUILD) && processor.id && result === null && (0, $g7Zy6.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $6BXtB.isThenable)(result)) result.then((final)=>$5626b80a09db9e7a$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $5626b80a09db9e7a$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("iQ4Il", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", function () { return $db70bd7481d602fa$export$6f292d4960313241; });

var $6BXtB = parcelRequire("6BXtB");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $db70bd7481d602fa$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($db70bd7481d602fa$var$States || ($db70bd7481d602fa$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $db70bd7481d602fa$export$1fda8aa4d135f8aa(value) {
    return new $db70bd7481d602fa$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $db70bd7481d602fa$export$78e43115b553f358(reason) {
    return new $db70bd7481d602fa$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $db70bd7481d602fa$export$6f292d4960313241 {
    constructor(executor){
        $db70bd7481d602fa$export$6f292d4960313241.prototype.__init.call(this);
        $db70bd7481d602fa$export$6f292d4960313241.prototype.__init2.call(this);
        $db70bd7481d602fa$export$6f292d4960313241.prototype.__init3.call(this);
        $db70bd7481d602fa$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $db70bd7481d602fa$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $db70bd7481d602fa$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $db70bd7481d602fa$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($db70bd7481d602fa$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($db70bd7481d602fa$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $db70bd7481d602fa$var$States.PENDING) return;
            if ((0, $6BXtB.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $db70bd7481d602fa$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $db70bd7481d602fa$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $db70bd7481d602fa$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("82CWW", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $5dacb93d477475f2$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $5dacb93d477475f2$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $5dacb93d477475f2$export$56521d9ba90f62ee; });

var $2OoK0 = parcelRequire("2OoK0");
var $6K6d1 = parcelRequire("6K6d1");
var $kj8fe = parcelRequire("kj8fe");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $5dacb93d477475f2$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $6K6d1.timestampInSeconds)();
    const session = {
        sid: (0, $kj8fe.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$5dacb93d477475f2$var$sessionToJSON(session)
    };
    if (context) $5dacb93d477475f2$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $5dacb93d477475f2$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $6K6d1.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $kj8fe.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $5dacb93d477475f2$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $5dacb93d477475f2$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $5dacb93d477475f2$var$sessionToJSON(session) {
    return (0, $2OoK0.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("gbOeN", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $bc94a48f572e4194$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $bc94a48f572e4194$export$25ac7e259a513db4; });

var $kj8fe = parcelRequire("kj8fe");
var $2OoK0 = parcelRequire("2OoK0");

var $0V6hl = parcelRequire("0V6hl");

var $dxMF5 = parcelRequire("dxMF5");

var $4rAO0 = parcelRequire("4rAO0");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $bc94a48f572e4194$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $bc94a48f572e4194$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $bc94a48f572e4194$var$applySpanToEvent(event, span);
    $bc94a48f572e4194$var$applyFingerprintToEvent(event, fingerprint);
    $bc94a48f572e4194$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $bc94a48f572e4194$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $bc94a48f572e4194$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $bc94a48f572e4194$export$b1a120a2871faa46(data, "extra", extra);
    $bc94a48f572e4194$export$b1a120a2871faa46(data, "tags", tags);
    $bc94a48f572e4194$export$b1a120a2871faa46(data, "user", user);
    $bc94a48f572e4194$export$b1a120a2871faa46(data, "contexts", contexts);
    $bc94a48f572e4194$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $bc94a48f572e4194$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $bc94a48f572e4194$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $2OoK0.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $2OoK0.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $2OoK0.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $2OoK0.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $bc94a48f572e4194$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $bc94a48f572e4194$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $bc94a48f572e4194$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $4rAO0.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $dxMF5.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $0V6hl.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $4rAO0.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $bc94a48f572e4194$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $kj8fe.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("0V6hl", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $002c4b203f05a770$export$a117f995597e25df; });

var $2OoK0 = parcelRequire("2OoK0");

var $Hklh0 = parcelRequire("Hklh0");

var $kqM0X = parcelRequire("kqM0X");

var $dxMF5 = parcelRequire("dxMF5");

var $4rAO0 = parcelRequire("4rAO0");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $002c4b203f05a770$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $2OoK0.dropUndefinedKeys)({
        environment: options.environment || (0, $Hklh0.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $002c4b203f05a770$export$a117f995597e25df(span) {
    const client = (0, $kqM0X.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $002c4b203f05a770$export$366bad00d6815eed((0, $4rAO0.spanToJSON)(span).trace_id || "", client, (0, $kqM0X.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $dxMF5.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $4rAO0.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $4rAO0.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("dxMF5", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $9dc41aa202c12aed$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $9dc41aa202c12aed$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("4rAO0", function(module, exports) {

$parcel$export(module.exports, "spanToTraceContext", function () { return $33c63be125b579b1$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $33c63be125b579b1$export$92d8c23565496537; });
$parcel$export(module.exports, "spanIsSampled", function () { return $33c63be125b579b1$export$5caecac1caaf3a71; });

var $2OoK0 = parcelRequire("2OoK0");
var $3crK5 = parcelRequire("3crK5");
var $6K6d1 = parcelRequire("6K6d1");
// These are aligned with OpenTelemetry trace flags
const $33c63be125b579b1$export$208d5b368507fb8b = 0x0;
const $33c63be125b579b1$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $33c63be125b579b1$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $33c63be125b579b1$export$92d8c23565496537(span);
    return (0, $2OoK0.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $33c63be125b579b1$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $33c63be125b579b1$export$5caecac1caaf3a71(span);
    return (0, $3crK5.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $33c63be125b579b1$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $33c63be125b579b1$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $33c63be125b579b1$var$ensureTimestampInSeconds(input.getTime());
    return (0, $6K6d1.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $33c63be125b579b1$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $33c63be125b579b1$export$92d8c23565496537(span) {
    if ($33c63be125b579b1$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $33c63be125b579b1$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $33c63be125b579b1$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $33c63be125b579b1$export$eb571cd9b5d98de8);
}

});
parcelRegister("3crK5", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $254803242595bb55$export$f35d907436da45cf; });

var $hwN4i = parcelRequire("hwN4i");

var $kj8fe = parcelRequire("kj8fe");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $254803242595bb55$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $254803242595bb55$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($254803242595bb55$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $254803242595bb55$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $254803242595bb55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $hwN4i.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $kj8fe.uuid4)(),
            spanId: (0, $kj8fe.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $kj8fe.uuid4)(),
            parentSpanId: parentSpanId || (0, $kj8fe.uuid4)().substring(16),
            spanId: (0, $kj8fe.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $254803242595bb55$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $254803242595bb55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $hwN4i.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $kj8fe.uuid4)(),
        spanId: (0, $kj8fe.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $kj8fe.uuid4)(),
        parentSpanId: parentSpanId || (0, $kj8fe.uuid4)().substring(16),
        spanId: (0, $kj8fe.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $254803242595bb55$export$f35d907436da45cf(traceId = (0, $kj8fe.uuid4)(), spanId = (0, $kj8fe.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("hwN4i", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $cc2b7cbf2b929a9a$export$5b96ee2c8421f107; });

var $2BDpo = parcelRequire("2BDpo");

var $6BXtB = parcelRequire("6BXtB");

var $g7Zy6 = parcelRequire("g7Zy6");
const $cc2b7cbf2b929a9a$export$9ca9946bd449ac06 = "baggage";
const $cc2b7cbf2b929a9a$export$6e69537d67fa20f = "sentry-";
const $cc2b7cbf2b929a9a$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $cc2b7cbf2b929a9a$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $cc2b7cbf2b929a9a$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $6BXtB.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $cc2b7cbf2b929a9a$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $cc2b7cbf2b929a9a$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($cc2b7cbf2b929a9a$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($cc2b7cbf2b929a9a$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $cc2b7cbf2b929a9a$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$cc2b7cbf2b929a9a$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $cc2b7cbf2b929a9a$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $cc2b7cbf2b929a9a$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $cc2b7cbf2b929a9a$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $cc2b7cbf2b929a9a$export$bdd844ddb2def819) {
            (0, $2BDpo.DEBUG_BUILD) && (0, $g7Zy6.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRegister("fYzWj", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $ba185676cd030925$export$31499a9cd224b78c; });
const $ba185676cd030925$export$31499a9cd224b78c = "7.120.4";

});


parcelRegister("1Em6z", function(module, exports) {

$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $133aac710f486dd2$export$76b5f966996d1653; });

var $kj8fe = parcelRequire("kj8fe");
var $6K6d1 = parcelRequire("6K6d1");
var $36mep = parcelRequire("36mep");
var $f9UJw = parcelRequire("f9UJw");
var $03yIt = parcelRequire("03yIt");

var $Hklh0 = parcelRequire("Hklh0");

var $7oA1A = parcelRequire("7oA1A");

var $2nY72 = parcelRequire("2nY72");

var $gbOeN = parcelRequire("gbOeN");

var $4rAO0 = parcelRequire("4rAO0");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $133aac710f486dd2$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $kj8fe.uuid4)(),
        timestamp: event.timestamp || (0, $6K6d1.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $133aac710f486dd2$var$applyClientOptions(prepared, options);
    $133aac710f486dd2$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $133aac710f486dd2$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $133aac710f486dd2$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $kj8fe.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $2nY72.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $gbOeN.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $gbOeN.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $gbOeN.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $7oA1A.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $7oA1A.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $133aac710f486dd2$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $133aac710f486dd2$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $133aac710f486dd2$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $Hklh0.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $03yIt.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $03yIt.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $03yIt.truncate)(request.url, maxValueLength);
}
const $133aac710f486dd2$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $133aac710f486dd2$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $36mep.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $133aac710f486dd2$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $133aac710f486dd2$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $133aac710f486dd2$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $133aac710f486dd2$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $133aac710f486dd2$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $f9UJw.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $f9UJw.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $f9UJw.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $f9UJw.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $f9UJw.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $4rAO0.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $f9UJw.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $133aac710f486dd2$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $2nY72.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $133aac710f486dd2$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($133aac710f486dd2$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($133aac710f486dd2$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $133aac710f486dd2$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $2nY72.Scope) || typeof hint === "function";
}
const $133aac710f486dd2$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $133aac710f486dd2$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$133aac710f486dd2$var$captureContextKeys.includes(key));
}

});
parcelRegister("f9UJw", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $b093b4512846ac1d$export$a3295358bff77e; });

var $6BXtB = parcelRequire("6BXtB");

var $aqbsU = parcelRequire("aqbsU");

var $2OoK0 = parcelRequire("2OoK0");

var $bixGM = parcelRequire("bixGM");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b093b4512846ac1d$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $b093b4512846ac1d$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $b093b4512846ac1d$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $b093b4512846ac1d$export$a3295358bff77e(object, depth);
    if ($b093b4512846ac1d$var$jsonSize(normalized) > maxSize) return $b093b4512846ac1d$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $b093b4512846ac1d$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $aqbsU.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $6BXtB.isNaN)(value)) return value;
    const stringified = $b093b4512846ac1d$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $b093b4512846ac1d$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $2OoK0.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $b093b4512846ac1d$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $b093b4512846ac1d$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $6BXtB.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $6BXtB.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $bixGM.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $b093b4512846ac1d$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $b093b4512846ac1d$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $b093b4512846ac1d$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b093b4512846ac1d$var$jsonSize(value) {
    return $b093b4512846ac1d$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $b093b4512846ac1d$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("aqbsU", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $796539e0d2527fbb$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $796539e0d2527fbb$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("bixGM", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $839b821ae11a7858$export$aad197c7121a6651; });

var $inCGJ = parcelRequire("inCGJ");
const $839b821ae11a7858$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $839b821ae11a7858$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $839b821ae11a7858$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $839b821ae11a7858$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $839b821ae11a7858$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($839b821ae11a7858$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $839b821ae11a7858$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $839b821ae11a7858$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $839b821ae11a7858$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $839b821ae11a7858$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $839b821ae11a7858$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($839b821ae11a7858$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($839b821ae11a7858$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $839b821ae11a7858$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $839b821ae11a7858$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $839b821ae11a7858$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $839b821ae11a7858$var$defaultFunctionName;
        return fn.name || $839b821ae11a7858$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $839b821ae11a7858$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $839b821ae11a7858$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $inCGJ.node)(getModule)
    ];
}

});
parcelRegister("inCGJ", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $d61862a8e131b406$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $d61862a8e131b406$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $d61862a8e131b406$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $d61862a8e131b406$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("fqQ6h", function(module, exports) {

$parcel$export(module.exports, "isUnpublishedEntry", function () { return $b3c1b2bf8dbbd754$export$cb28c8526fc53134; });
$parcel$export(module.exports, "isUnpublishedAsset", function () { return $b3c1b2bf8dbbd754$export$46a82fc320789744; });
parcelRequire("adnhq");
var $4Uqkn = parcelRequire("4Uqkn");
function $b3c1b2bf8dbbd754$export$cb28c8526fc53134(model) {
    if (!(0, $4Uqkn.isRecord)(model)) return false;
    return (0, $4Uqkn.isRecord)(model.sys) && model.sys.type === "Link" && model.sys.linkType === "Entry" && typeof model.sys.id === "string";
}
function $b3c1b2bf8dbbd754$export$46a82fc320789744(model) {
    if (!(0, $4Uqkn.isRecord)(model)) return false;
    return (0, $4Uqkn.isRecord)(model.sys) && model.sys.type === "Link" && model.sys.linkType === "Asset" && typeof model.sys.id === "string";
}

});




parcelRegister("54eIv", function(module, exports) {
$parcel$export(module.exports, "EmailShareButton", function () { return (parcelRequire("eHuqC")).EmailShareButton; });
$parcel$export(module.exports, "FacebookShareButton", function () { return (parcelRequire("5PhOG")).FacebookShareButton; });
$parcel$export(module.exports, "TwitterShareButton", function () { return (parcelRequire("gFZ4z")).TwitterShareButton; });
parcelRequire("eHuqC");
parcelRequire("5PhOG");
parcelRequire("gFZ4z");
parcelRequire("aKUKM");

});
parcelRegister("eHuqC", function(module, exports) {

$parcel$export(module.exports, "EmailShareButton", function () { return $b6958e99991af290$export$13f6c2fca7b40a73; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
parcelRequire("fyI6f");
var $kzY5l = parcelRequire("kzY5l");
parcelRequire("aKUKM");
var $gFzJ7 = parcelRequire("gFzJ7");

var $9fcw6 = parcelRequire("9fcw6");
const $b6958e99991af290$export$13f6c2fca7b40a73 = ({ block: block = false, buttonColor: buttonColor = (0, $i2LPb.colorCSS)("N300"), buttonText: buttonText = "Email", buttonTextColor: buttonTextColor = "white", iconColor: iconColor = "white", message: message, shareUrl: shareUrl, uuid: uuid, type: type })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const url = encodeURI(`mailto:?subject=Trello&body=${message}\n\n${shareUrl}`);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9fcw6.GenericShareButton), {
        $block: block,
        $buttonColor: buttonColor,
        $colorOverride: buttonTextColor,
        href: url,
        title: buttonText,
        onClick: ()=>sendTrackEvent("clickedAnchor", {
                event: "clicked",
                eventComponent: "button",
                eventContainer: type,
                label: buttonText,
                labelEnglish: "Email",
                uuid: `${uuid}_emailButton`,
                href: url
            }),
        "data-uuid": `${uuid}_emailButton`,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9fcw6.InnerShareButton), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $gFzJ7.EmailIcon), {
                    color: iconColor
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    children: buttonText
                })
            ]
        })
    });
};

});
parcelRegister("aKUKM", function(module, exports) {
$parcel$export(module.exports, "EmailIcon", function () { return (parcelRequire("gFzJ7")).EmailIcon; });
$parcel$export(module.exports, "FacebookIcon", function () { return (parcelRequire("fwYBK")).FacebookIcon; });
$parcel$export(module.exports, "TwitterIcon", function () { return (parcelRequire("jEr47")).TwitterIcon; });
parcelRequire("gFzJ7");
parcelRequire("fwYBK");
parcelRequire("jEr47");

});
parcelRegister("gFzJ7", function(module, exports) {

$parcel$export(module.exports, "EmailIcon", function () { return $9db8180dfafda11e$export$229c2a4b55a611f4; });

var $loA2J = parcelRequire("loA2J");
const $9db8180dfafda11e$export$229c2a4b55a611f4 = ({ color: color = "currentColor", height: height = 15, width: width = 20 })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        viewBox: "0 0 20 15",
        height: height,
        width: width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fill: color,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m2.5 2.5v10h15v-10zm-2.5-.83742559c0-.91821449.75960159-1.66257441 1.67078882-1.66257441h16.65842238c.9227512 0 1.6707888.74385233 1.6707888 1.66257441v11.67485119c0 .9182145-.7596016 1.6625744-1.6707888 1.6625744h-16.65842238c-.92275118 0-1.67078882-.7438523-1.67078882-1.6625744z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m1.72652251.25537511-1.48964008 2.01831895 9.76654427 6.46055241 9.6627916-6.40809291-1.3864108-2.09057502-8.2798075 5.46912408z"
                })
            ]
        })
    });
};

});

parcelRegister("fwYBK", function(module, exports) {

$parcel$export(module.exports, "FacebookIcon", function () { return $2273050181432046$export$3fdaca054b3d1181; });

var $loA2J = parcelRequire("loA2J");
const $2273050181432046$export$3fdaca054b3d1181 = ({ color: color = "currentColor", height: height = 21, width: width = 11 })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        viewBox: "0 0 11 21",
        height: `${height}`,
        width: `${width}`,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m7.14285714 21v-9.5723926h3.23376626l.4935065-3.73619636h-3.72727276v-2.38343558c0-1.19815951.40259741-1.81656442 1.85714286-1.81656442h2v-3.33680981c-.7012987-.10306749-1.67532468-.15460123-2.90909091-.15460123-2.92207792 0-4.83116883 1.80368098-4.83116883 4.93435583v2.75705521h-3.25974026v3.73619636h3.25974026v9.5723926z",
            fill: `${color}`
        })
    });
};

});

parcelRegister("jEr47", function(module, exports) {

$parcel$export(module.exports, "TwitterIcon", function () { return $73b91151d486941f$export$9a9e0252a352cccf; });

var $loA2J = parcelRequire("loA2J");
const $73b91151d486941f$export$9a9e0252a352cccf = ({ color: color = "currentColor", height: height = 20, width: width = 25 })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        viewBox: "0 0 25 20",
        height: height,
        width: width,
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m22.0897436 4.96153846c.0128205.30769231.025641.53846154.025641.67948718 0 2.70512821-.7692308 5.46153846-2.3974359 7.93589746s-3.7948718 4.4358974-6.9358974 5.5641025c-1.5769231.5769231-3.25641027.8589744-5.05128207.8589744-2.80769231 0-5.38461538-.7564103-7.73076923-2.2692308.55128205.0512821.94871795.0769231 1.20512821.0769231 2.34615384 0 4.42307692-.7179487 6.25641025-2.1666667-2.19230769-.051282-4.05128205-1.5-4.71794872-3.5128205.2948718.0641026.61538462.0897436.96153847.0897436.44871794 0 .88461538-.051282 1.3076923-.1666666-2.3076923-.474359-4.02564102-2.52564107-4.02564102-4.948718v-.07692307c.7051282.39743589 1.47435897.61538461 2.28205128.64102564-1.38461539-.93589744-2.24358974-2.48717949-2.24358974-4.21794872 0-.91025641.23076923-1.74358974.67948718-2.51282051 2.55128205 3.08974359 6.26923076 5.05128205 10.41025639 5.25641025-.0769231-.32051282-.1153846-.7051282-.1153846-1.15384615 0-2.78205128 2.2564103-5.03846154 5.0384615-5.03846154 1.448718 0 2.6666667.52564103 3.6794872 1.58974359 1.1794872-.24358974 2.2564103-.65384615 3.2179487-1.23076923-.3717948 1.16666667-1.1923077 2.17948718-2.2307692 2.80769231.974359-.11538462 1.948718-.38461539 2.9102564-.80769231-.7051282 1.03846154-1.5384615 1.91025641-2.525641 2.6025641z",
            fill: color
        })
    });
};

});


parcelRegister("9fcw6", function(module, exports) {

$parcel$export(module.exports, "GenericShareButton", function () { return $acd91b2c4de3624b$export$99573040031a0a90; });
$parcel$export(module.exports, "InnerShareButton", function () { return $acd91b2c4de3624b$export$26c338e8d5ef7760; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
const $acd91b2c4de3624b$export$99573040031a0a90 = ({ $buttonColor: $buttonColor, $colorOverride: $colorOverride, $block: $block = false, style: style, ...props })=>{
    const color = $colorOverride ? $colorOverride : (0, $i2LPb.colorContrastCSS)($buttonColor);
    const buttonStyle = {
        backgroundColor: $buttonColor,
        borderRadius: "0.3rem",
        color: color,
        fontSize: (0, $kL1mL.fontSizes).sm,
        display: $block ? "block" : "inline-block",
        minWidth: $block ? undefined : "150px",
        padding: "0.75rem",
        textAlign: "left",
        textDecoration: "none",
        ...style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
        style: buttonStyle,
        ...props
    });
};
const $acd91b2c4de3624b$export$26c338e8d5ef7760 = ({ style: style, children: children, ...props })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            ...style
        },
        ...props,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Children.map(children, (child, index)=>index === 0 ? child : /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                style: {
                    marginLeft: "0.5rem"
                },
                children: child
            }))
    });

});


parcelRegister("5PhOG", function(module, exports) {

$parcel$export(module.exports, "FacebookShareButton", function () { return $5435506268c6fa81$export$335375f378a49277; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("fyI6f");
var $kzY5l = parcelRequire("kzY5l");
var $9Ck2b = parcelRequire("9Ck2b");
parcelRequire("aKUKM");
var $fwYBK = parcelRequire("fwYBK");

var $9fcw6 = parcelRequire("9fcw6");
const $5435506268c6fa81$export$335375f378a49277 = ({ block: block = false, buttonColor: buttonColor = "#4267B2", buttonText: //facebook brand blue
buttonText = "Facebook", buttonTextColor: buttonTextColor = "white", iconColor: iconColor = "white", shareUrl: shareUrl, uuid: uuid, type: type })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const requestUrl = (0, $9Ck2b.useRequestUrl)();
    const url = encodeURI(`https://www.facebook.com/sharer/sharer.php?u=${shareUrl || requestUrl}`);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9fcw6.GenericShareButton), {
        $block: block,
        $buttonColor: buttonColor,
        $colorOverride: buttonTextColor,
        href: url,
        title: "Facebook",
        onClick: ()=>sendTrackEvent("clickedAnchor", {
                event: "clicked",
                eventComponent: "button",
                eventContainer: type,
                label: buttonText,
                labelEnglish: "Facebook",
                uuid: `${uuid}_facebookButton`,
                href: url
            }),
        "data-uuid": `${uuid}_facebookButton`,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9fcw6.InnerShareButton), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $fwYBK.FacebookIcon), {
                    color: iconColor
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    children: buttonText
                })
            ]
        })
    });
};

});

parcelRegister("gFZ4z", function(module, exports) {

$parcel$export(module.exports, "TwitterShareButton", function () { return $4c9ac8b089aaadb0$export$4f75eaceed353fa1; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("fyI6f");
var $kzY5l = parcelRequire("kzY5l");
var $9Ck2b = parcelRequire("9Ck2b");
parcelRequire("aKUKM");
var $jEr47 = parcelRequire("jEr47");

var $9fcw6 = parcelRequire("9fcw6");
const $4c9ac8b089aaadb0$export$4f75eaceed353fa1 = ({ block: block = false, buttonColor: buttonColor = "#1DA1F2", buttonText: //twitter brand blue
buttonText = "Twitter", buttonTextColor: buttonTextColor = "white", hashtags: hashtags = [], iconColor: iconColor = "white", message: message, shareUrl: shareUrl, uuid: uuid, type: type })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const requestUrl = (0, $9Ck2b.useRequestUrl)();
    const params = {
        text: message,
        url: shareUrl || requestUrl,
        related: "trello"
    };
    const queryString = new URLSearchParams(hashtags.length ? {
        ...params,
        hashtags: hashtags.map((hashtag)=>hashtag.replace("#", "")).join(",")
    } : params);
    const url = `https://twitter.com/intent/tweet?${queryString}`;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9fcw6.GenericShareButton), {
        $block: block,
        $buttonColor: buttonColor,
        $colorOverride: buttonTextColor,
        href: url,
        title: "Twitter",
        onClick: ()=>sendTrackEvent("clickedAnchor", {
                event: "clicked",
                eventComponent: "button",
                eventContainer: type,
                label: buttonText,
                labelEnglish: "Twitter",
                uuid: `${uuid}_twitterButton`,
                href: url
            }),
        "data-uuid": `${uuid}_twitterButton`,
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9fcw6.InnerShareButton), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $jEr47.TwitterIcon), {
                    color: iconColor
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                    children: buttonText
                })
            ]
        })
    });
};

});



parcelRegister("4J1z5", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $370c9421b0866d1c$var$ReactIs, $370c9421b0866d1c$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("3uBPk"))();

});
parcelRegister("3uBPk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $aUb9R = parcelRequire("aUb9R");
function $28b1840c082e4298$var$emptyFunction() {}
function $28b1840c082e4298$var$emptyFunctionWithReset() {}
$28b1840c082e4298$var$emptyFunctionWithReset.resetWarningCache = $28b1840c082e4298$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $aUb9R) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $28b1840c082e4298$var$emptyFunctionWithReset,
        resetWarningCache: $28b1840c082e4298$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("aUb9R", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $7f07ca1daed2da03$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $7f07ca1daed2da03$var$ReactPropTypesSecret;

});



parcelRegister("33PqJ", function(module, exports) {

$parcel$export(module.exports, "renderViewModel", function () { return $637be2c265745b51$export$eae4b1636bcb0988; });
$parcel$export(module.exports, "renderViewModels", function () { return $637be2c265745b51$export$2df8dd9bc16a4f25; });
// @ts-nocheck
/* eslint-disable complexity */ 
var $loA2J = parcelRequire("loA2J");

var $aAquZ = parcelRequire("aAquZ");
parcelRequire("er0Js");
var $dLzgL = parcelRequire("dLzgL");
var $8Jm34 = parcelRequire("8Jm34");
var $3BpTc = parcelRequire("3BpTc");
var $fQ8J7 = parcelRequire("fQ8J7");
var $1GNfM = parcelRequire("1GNfM");
var $78xz5 = parcelRequire("78xz5");
var $kYLJF = parcelRequire("kYLJF");
var $hz8fk = parcelRequire("hz8fk");
var $cVhUY = parcelRequire("cVhUY");
var $i4EQ3 = parcelRequire("i4EQ3");
var $bJVkU = parcelRequire("bJVkU");
var $7QvR0 = parcelRequire("7QvR0");
var $kLKPJ = parcelRequire("kLKPJ");
var $9mqJn = parcelRequire("9mqJn");
var $idgGb = parcelRequire("idgGb");
var $34Qin = parcelRequire("34Qin");
var $3cQdw = parcelRequire("3cQdw");
var $b5HjT = parcelRequire("b5HjT");
var $evXZH = parcelRequire("evXZH");
var $7uVQQ = parcelRequire("7uVQQ");
var $6bAq7 = parcelRequire("6bAq7");
var $aj3L4 = parcelRequire("aj3L4");
var $iuY7Y = parcelRequire("iuY7Y");
var $i3M2D = parcelRequire("i3M2D");
var $bwS4k = parcelRequire("bwS4k");
var $1kwIV = parcelRequire("1kwIV");
var $WYOXd = parcelRequire("WYOXd");
var $eBpzU = parcelRequire("eBpzU");
var $cVC5c = parcelRequire("cVC5c");
var $6y9ML = parcelRequire("6y9ML");
var $giOvo = parcelRequire("giOvo");
var $jAZan = parcelRequire("jAZan");
var $hZ3E2 = parcelRequire("hZ3E2");
var $7kKxD = parcelRequire("7kKxD");
var $1LBks = parcelRequire("1LBks");
var $9dr3y = parcelRequire("9dr3y");
var $cSWGN = parcelRequire("cSWGN");
var $3mNTO = parcelRequire("3mNTO");
var $oHr7c = parcelRequire("oHr7c");
var $amvj6 = parcelRequire("amvj6");
var $5EWJl = parcelRequire("5EWJl");
var $6nZh8 = parcelRequire("6nZh8");
var $4DJiw = parcelRequire("4DJiw");
var $5eeJ9 = parcelRequire("5eeJ9");
var $2mYBG = parcelRequire("2mYBG");
var $UWh9s = parcelRequire("UWh9s");
var $iCJRs = parcelRequire("iCJRs");
var $05cLg = parcelRequire("05cLg");
var $gZyDK = parcelRequire("gZyDK");
var $hTq4R = parcelRequire("hTq4R");
var $igwoQ = parcelRequire("igwoQ");
var $afuz0 = parcelRequire("afuz0");
var $fwgmr = parcelRequire("fwgmr");
var $7eagl = parcelRequire("7eagl");
var $ll4BP = parcelRequire("ll4BP");
var $1GqBm = parcelRequire("1GqBm");
var $5KlTr = parcelRequire("5KlTr");
var $kFkUp = parcelRequire("kFkUp");
var $5I0gh = parcelRequire("5I0gh");
var $gWGNf = parcelRequire("gWGNf");
var $7YDse = parcelRequire("7YDse");
var $DUdTi = parcelRequire("DUdTi");
var $8vA78 = parcelRequire("8vA78");
var $arJrv = parcelRequire("arJrv");
var $fFqco = parcelRequire("fFqco");
var $6mKPH = parcelRequire("6mKPH");
var $3PNQw = parcelRequire("3PNQw");
function $637be2c265745b51$export$eae4b1636bcb0988(viewModel) {
    switch(viewModel.type){
        case "page":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dLzgL.default), {
                model: viewModel
            }, viewModel.id);
        case "uiAccordion":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8Jm34.default), {
                model: viewModel
            }, viewModel.id);
        case "uiAddToSlackSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3BpTc.UiAddToSlackSection), {
                model: viewModel
            }, viewModel.id);
        case "uiAnimatedHeroSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fQ8J7.default), {
                model: viewModel
            }, viewModel.id);
        case "uiBlock":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1GNfM.default), {
                model: viewModel
            }, viewModel.id);
        case "uiButton":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $78xz5.default), {
                model: viewModel
            }, viewModel.id);
        case "uiCallout":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kYLJF.default), {
                model: viewModel
            }, viewModel.id);
        case "uiCaption":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hz8fk.default), {
                model: viewModel
            }, viewModel.id);
        case "uiCard":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cVhUY.default), {
                model: viewModel
            }, viewModel.id);
        case "uiCarousel":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i4EQ3.default), {
                model: viewModel
            }, viewModel.id);
        case "uiColumn":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bJVkU.default), {
                model: viewModel
            }, viewModel.id);
        case "uiContactForm":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7QvR0.default), {
                model: viewModel
            }, viewModel.id);
        case "uiDownloadButton":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kLKPJ.default), {
                model: viewModel
            }, viewModel.id);
        case "uiEmailSignup":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9mqJn.default), {
                model: viewModel
            }, viewModel.id);
        case "uiFeatureSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $idgGb.default), {
                model: viewModel
            }, viewModel.id);
        case "uiFooterNav":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $34Qin.default), {
                model: viewModel
            }, viewModel.id);
        case "uiFooterNavBasic":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3cQdw.default), {
                model: viewModel
            }, viewModel.id);
        case "uiGuide":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $b5HjT.default), {
                model: viewModel
            }, viewModel.id);
        case "uiHeaderNav":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $evXZH.default), {
                model: viewModel
            }, viewModel.id);
        case "uiHeading":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7uVQQ.default), {
                model: viewModel
            }, viewModel.id);
        case "uiIcon":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6bAq7.default), {
                model: viewModel
            }, viewModel.id);
        case "uiImage":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aj3L4.default), {
                model: viewModel
            }, viewModel.id);
        case "uiImageSet":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iuY7Y.default), {
                model: viewModel
            }, viewModel.id);
        case "uiIntegration":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $i3M2D.default), {
                model: viewModel
            }, viewModel.id);
        case "uiIntegrationSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bwS4k.default), {
                model: viewModel
            }, viewModel.id);
        case "uiLoginContainer":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1kwIV.default), {
                model: viewModel
            }, viewModel.id);
        case "uiLoginSignupForm":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $WYOXd.default), {
                model: viewModel
            }, viewModel.id);
        case "uiLink":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eBpzU.default), {
                model: viewModel
            }, viewModel.id);
        case "uiLinkBlock":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cVC5c.default), {
                model: viewModel
            }, viewModel.id);
        case "uiListCarousel":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6y9ML.default), {
                model: viewModel
            }, viewModel.id);
        case "uiMarkdown":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $giOvo.default), {
                model: viewModel
            }, viewModel.id);
        case "uiMarketoForm":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jAZan.UiMarketoForm), {
                model: viewModel
            }, viewModel.id);
        case "uiModal":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hZ3E2.default), {
                model: viewModel
            }, viewModel.id);
        case "uiNavBanner":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7kKxD.default), {
                model: viewModel
            }, viewModel.id);
        case "uiNavBlogArticle":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LBks.default), {
                model: viewModel
            }, viewModel.id);
        case "uiNavImages":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $9dr3y.default), {
                model: viewModel
            }, viewModel.id);
        case "uiNavLink":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cSWGN.default), {
                model: viewModel
            }, viewModel.id);
        case "uiPowerUp":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3mNTO.default), {
                model: viewModel
            }, viewModel.id);
        case "uiPricingCalculator":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $oHr7c.default), {
                model: viewModel
            }, viewModel.id);
        case "uiPricingComparisonTable":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $amvj6.default), {
                model: viewModel
            }, viewModel.id);
        case "uiPricingGrid":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5EWJl.default), {
                model: viewModel
            }, viewModel.id);
        case "uiQuote":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6nZh8.default), {
                model: viewModel
            }, viewModel.id);
        case "uiRecommendShare":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4DJiw.default), {
                model: viewModel
            }, viewModel.id);
        case "uiRotatingImages":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5eeJ9.default), {
                model: viewModel
            }, viewModel.id);
        case "uiRotatingItems":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2mYBG.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $UWh9s.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSectionGroup":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iCJRs.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSocialLoginSignupButton":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $05cLg.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSocialProof":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gZyDK.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSocialShare":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hTq4R.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSpacer":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $igwoQ.default), {
                model: viewModel
            }, viewModel.id);
        case "uiSplitSection":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $afuz0.default), {
                model: viewModel
            }, viewModel.id);
        case "uiStack":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fwgmr.default), {
                model: viewModel
            }, viewModel.id);
        case "uiStatuspage":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7eagl.default), {
                model: viewModel
            }, viewModel.id);
        case "uiStoryline":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ll4BP.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTab":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $1GqBm.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTabPanel":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5KlTr.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTemplateGallery":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $kFkUp.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTextBlock":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5I0gh.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTrelloBoard":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $gWGNf.default), {
                model: viewModel
            }, viewModel.id);
        case "uiTooltip":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7YDse.default), {
                model: viewModel
            }, viewModel.id);
        case "uiValueProp":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $DUdTi.default), {
                model: viewModel
            }, viewModel.id);
        case "uiVariationContainer":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8vA78.default), {
                model: viewModel
            }, viewModel.id);
        case "uiVideo":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $arJrv.default), {
                model: viewModel
            }, viewModel.id);
        case "uiVideoPlayer":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $fFqco.default), {
                model: viewModel
            }, viewModel.id);
        case "uiWebinarLink":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6mKPH.default), {
                model: viewModel
            }, viewModel.id);
        case "uiWorkspacePicker":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $3PNQw.default), {
                model: viewModel
            }, viewModel.id);
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aAquZ.ViewModelError), {
                model: viewModel
            }, `${Date.now()}`);
    }
}
function $637be2c265745b51$export$2df8dd9bc16a4f25(viewModels) {
    return viewModels.map((viewModel, index)=>{
        // Clone the element and add index to key to prevent duplicates
        const element = $637be2c265745b51$export$eae4b1636bcb0988(viewModel);
        return {
            ...element,
            key: `${viewModel.id}-${index}`
        };
    });
}

});
parcelRegister("er0Js", function(module, exports) {
$parcel$export(module.exports, "Page", function () { return (parcelRequire("dLzgL")).default; });
$parcel$export(module.exports, "UiAccordion", function () { return (parcelRequire("8Jm34")).default; });
$parcel$export(module.exports, "UiAddToSlackSection", function () { return (parcelRequire("3BpTc")).UiAddToSlackSection; });
$parcel$export(module.exports, "UiAnimatedHeroSection", function () { return (parcelRequire("fQ8J7")).default; });
$parcel$export(module.exports, "UiBlock", function () { return (parcelRequire("1GNfM")).default; });
$parcel$export(module.exports, "UiButton", function () { return (parcelRequire("78xz5")).default; });
$parcel$export(module.exports, "UiCallout", function () { return (parcelRequire("kYLJF")).default; });
$parcel$export(module.exports, "UiCaption", function () { return (parcelRequire("hz8fk")).default; });
$parcel$export(module.exports, "UiCard", function () { return (parcelRequire("cVhUY")).default; });
$parcel$export(module.exports, "UiCarousel", function () { return (parcelRequire("i4EQ3")).default; });
$parcel$export(module.exports, "UiColumn", function () { return (parcelRequire("bJVkU")).default; });
$parcel$export(module.exports, "UiContactForm", function () { return (parcelRequire("7QvR0")).default; });
$parcel$export(module.exports, "UiDownloadButton", function () { return (parcelRequire("kLKPJ")).default; });
$parcel$export(module.exports, "UiEmailSignup", function () { return (parcelRequire("9mqJn")).default; });
$parcel$export(module.exports, "UiFeatureSection", function () { return (parcelRequire("idgGb")).default; });
$parcel$export(module.exports, "UiFooterNav", function () { return (parcelRequire("34Qin")).default; });
$parcel$export(module.exports, "UiFooterNavBasic", function () { return (parcelRequire("3cQdw")).default; });
$parcel$export(module.exports, "UiGuide", function () { return (parcelRequire("b5HjT")).default; });
$parcel$export(module.exports, "UiHeaderNav", function () { return (parcelRequire("evXZH")).default; });
$parcel$export(module.exports, "UiHeading", function () { return (parcelRequire("7uVQQ")).default; });
$parcel$export(module.exports, "UiIcon", function () { return (parcelRequire("6bAq7")).default; });
$parcel$export(module.exports, "UiImage", function () { return (parcelRequire("aj3L4")).default; });
$parcel$export(module.exports, "UiImageSet", function () { return (parcelRequire("iuY7Y")).default; });
$parcel$export(module.exports, "UiIntegration", function () { return (parcelRequire("i3M2D")).default; });
$parcel$export(module.exports, "UiIntegrationSection", function () { return (parcelRequire("bwS4k")).default; });
$parcel$export(module.exports, "UiLink", function () { return (parcelRequire("eBpzU")).default; });
$parcel$export(module.exports, "UiLinkBlock", function () { return (parcelRequire("cVC5c")).default; });
$parcel$export(module.exports, "UiListCarousel", function () { return (parcelRequire("6y9ML")).default; });
$parcel$export(module.exports, "UiLoginContainer", function () { return (parcelRequire("1kwIV")).default; });
$parcel$export(module.exports, "UiLoginSignupForm", function () { return (parcelRequire("WYOXd")).default; });
$parcel$export(module.exports, "UiMarkdown", function () { return (parcelRequire("giOvo")).default; });
$parcel$export(module.exports, "UiMarketoForm", function () { return (parcelRequire("jAZan")).UiMarketoForm; });
$parcel$export(module.exports, "UiModal", function () { return (parcelRequire("hZ3E2")).default; });
$parcel$export(module.exports, "UiNavBanner", function () { return (parcelRequire("7kKxD")).default; });
$parcel$export(module.exports, "UiNavBlogArticle", function () { return (parcelRequire("1LBks")).default; });
$parcel$export(module.exports, "UiNavImages", function () { return (parcelRequire("9dr3y")).default; });
$parcel$export(module.exports, "UiNavLink", function () { return (parcelRequire("cSWGN")).default; });
$parcel$export(module.exports, "UiPowerUp", function () { return (parcelRequire("3mNTO")).default; });
$parcel$export(module.exports, "UiPricingCalculator", function () { return (parcelRequire("oHr7c")).default; });
$parcel$export(module.exports, "UiPricingComparisonTable", function () { return (parcelRequire("amvj6")).default; });
$parcel$export(module.exports, "UiPricingGrid", function () { return (parcelRequire("5EWJl")).default; });
$parcel$export(module.exports, "UiQuote", function () { return (parcelRequire("6nZh8")).default; });
$parcel$export(module.exports, "UiRecommendShare", function () { return (parcelRequire("4DJiw")).default; });
$parcel$export(module.exports, "UiRotatingImages", function () { return (parcelRequire("5eeJ9")).default; });
$parcel$export(module.exports, "UiRotatingItems", function () { return (parcelRequire("2mYBG")).default; });
$parcel$export(module.exports, "UiSection", function () { return (parcelRequire("UWh9s")).default; });
$parcel$export(module.exports, "UiSectionGroup", function () { return (parcelRequire("iCJRs")).default; });
$parcel$export(module.exports, "UiSocialLoginSignupButton", function () { return (parcelRequire("05cLg")).default; });
$parcel$export(module.exports, "UiSocialProof", function () { return (parcelRequire("gZyDK")).default; });
$parcel$export(module.exports, "UiSocialShare", function () { return (parcelRequire("hTq4R")).default; });
$parcel$export(module.exports, "UiSpacer", function () { return (parcelRequire("igwoQ")).default; });
$parcel$export(module.exports, "UiSplitSection", function () { return (parcelRequire("afuz0")).default; });
$parcel$export(module.exports, "UiStack", function () { return (parcelRequire("fwgmr")).default; });
$parcel$export(module.exports, "UiStatuspage", function () { return (parcelRequire("7eagl")).default; });
$parcel$export(module.exports, "UiStoryline", function () { return (parcelRequire("ll4BP")).default; });
$parcel$export(module.exports, "UiTemplateGallery", function () { return (parcelRequire("kFkUp")).default; });
$parcel$export(module.exports, "UiTab", function () { return (parcelRequire("1GqBm")).default; });
$parcel$export(module.exports, "UiTabPanel", function () { return (parcelRequire("5KlTr")).default; });
$parcel$export(module.exports, "UiTextBlock", function () { return (parcelRequire("5I0gh")).default; });
$parcel$export(module.exports, "UiTooltip", function () { return (parcelRequire("7YDse")).default; });
$parcel$export(module.exports, "UiTrelloBoard", function () { return (parcelRequire("gWGNf")).default; });
$parcel$export(module.exports, "UiValueProp", function () { return (parcelRequire("DUdTi")).default; });
$parcel$export(module.exports, "UiVariationContainer", function () { return (parcelRequire("8vA78")).default; });
$parcel$export(module.exports, "UiVideo", function () { return (parcelRequire("arJrv")).default; });
$parcel$export(module.exports, "UiVideoPlayer", function () { return (parcelRequire("fFqco")).default; });
$parcel$export(module.exports, "UiWebinarLink", function () { return (parcelRequire("6mKPH")).default; });
$parcel$export(module.exports, "UiWorkspacePicker", function () { return (parcelRequire("3PNQw")).default; });
parcelRequire("8pRwQ");
parcelRequire("2Af9Y");
parcelRequire("3BpTc");
parcelRequire("hMNNV");
parcelRequire("iUERz");
parcelRequire("9R436");
parcelRequire("7y502");
parcelRequire("joEuS");
parcelRequire("gozH7");
parcelRequire("joINu");
parcelRequire("3987v");
parcelRequire("k90ou");
parcelRequire("8K0lh");
parcelRequire("6HVQO");
parcelRequire("AsXlI");
parcelRequire("bBU2O");
parcelRequire("8EDHj");
parcelRequire("jAJUr");
parcelRequire("igAe9");
parcelRequire("ceRCf");
parcelRequire("9IEYk");
parcelRequire("98nMD");
parcelRequire("kk7um");
parcelRequire("84a3c");
parcelRequire("5gfhl");
parcelRequire("43Skq");
parcelRequire("cREQo");
parcelRequire("hT6nC");
parcelRequire("ccItR");
parcelRequire("gdM6R");
parcelRequire("cq2VZ");
parcelRequire("jAZan");
parcelRequire("hUFVr");
parcelRequire("8B6bM");
parcelRequire("4pmfd");
parcelRequire("3u5UV");
parcelRequire("kF7qb");
parcelRequire("KjeNh");
parcelRequire("gbRkW");
parcelRequire("iwZ32");
parcelRequire("d54or");
parcelRequire("fm4PM");
parcelRequire("kqJ1d");
parcelRequire("8EnPN");
parcelRequire("l5K6U");
parcelRequire("i8HBj");
parcelRequire("5Zoby");
parcelRequire("4cY9r");
parcelRequire("daM1b");
parcelRequire("48HDR");
parcelRequire("fbvTT");
parcelRequire("7IaHu");
parcelRequire("eWbFa");
parcelRequire("jdSVj");
parcelRequire("9xxJV");
parcelRequire("dJcnZ");
parcelRequire("gfGkO");
parcelRequire("hKaLV");
parcelRequire("a4Vai");
parcelRequire("6HMlA");
parcelRequire("5H7uq");
parcelRequire("aOuoE");
parcelRequire("8JcfN");
parcelRequire("gQfpJ");
parcelRequire("8mwpD");
parcelRequire("c41JF");
parcelRequire("6jyNq");

});
parcelRegister("8pRwQ", function(module, exports) {

$parcel$export(module.exports, "Page", function () { return (parcelRequire("dLzgL")).default; });

var $dLzgL = parcelRequire("dLzgL");

});
parcelRegister("dLzgL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9b135dc593abe701$export$2e2bcd8739ae039; });
/* eslint-disable react-hooks/exhaustive-deps */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dcmqH = parcelRequire("dcmqH");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $8OmrV = parcelRequire("8OmrV");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");
const $9b135dc593abe701$var$Page = ({ model: model })=>{
    const { sendPageEvent: sendPageEvent } = (0, $kzY5l.useAnalytics)();
    const { entryTitle: entryTitle, title: title, route: route, variant: variant, header: // Default to undefined if not present
    header, sections: sections = [], footer: footer, noIndexTag: noIndexTag } = model.content;
    const sharedPageAttributes = {
        stack: "arcadia",
        isIndexed: !noIndexTag
    };
    (0, $iSvIT.useEffect)(()=>{
        sendPageEvent("", {
            ...sharedPageAttributes,
            path: route.content.path,
            title: title,
            pageVariant: variant
        });
    }, [
        route.content.path,
        sendPageEvent,
        title,
        variant
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $dcmqH.RendererProvider), {
        renderer: (0, $33PqJ.renderViewModel),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8OmrV.FooterContextProvider), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g4xTJ.AnalyticsAttributesProvider), {
                value: {
                    ...sharedPageAttributes,
                    labelEnglish: entryTitle
                },
                children: [
                    header && (0, $33PqJ.renderViewModel)(header),
                    /*#__PURE__*/ (0, $loA2J.jsx)("main", {
                        id: "skip-target",
                        tabIndex: -1,
                        children: (0, $33PqJ.renderViewModels)(sections)
                    }),
                    footer && (0, $33PqJ.renderViewModel)(footer)
                ]
            })
        })
    });
};
var $9b135dc593abe701$export$2e2bcd8739ae039 = $9b135dc593abe701$var$Page;

});


parcelRegister("2Af9Y", function(module, exports) {

$parcel$export(module.exports, "UiAccordion", function () { return (parcelRequire("8Jm34")).default; });

var $8Jm34 = parcelRequire("8Jm34");

});
parcelRegister("8Jm34", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95dcda617684df66$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("fisC4");
var $7YcSr = parcelRequire("7YcSr");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");
var $5l0yg = parcelRequire("5l0yg");
var $69DYH = parcelRequire("69DYH");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");

var $8HfGf = parcelRequire("8HfGf");
const $95dcda617684df66$var$UiAccordion = ({ model: { type: type, content: { title: title, items: items, appearance: appearance, background: background } } })=>{
    const parentTitle = title;
    const [openKeys, setOpenKeys] = (0, $iSvIT.useState)([]);
    const [trackedKeys, setTrackedKeys] = (0, $iSvIT.useState)([]);
    const navigate = (0, $7YcSr.useNavigate)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    (0, $iSvIT.useEffect)(()=>{
        setOpenKeys(window.location.hash.slice(1).split(",").filter((key)=>key));
    }, []);
    const toggleOpenKeys = (id, title, entryTitle, parentTitle)=>{
        const newOpenKeys = [
            ...openKeys.filter((key)=>id !== key)
        ];
        if (!openKeys.includes(id)) {
            newOpenKeys.push(id);
            if (!trackedKeys.includes(id)) {
                sendTrackEvent("expandedAccordionItem", {
                    ...analyticsAttributes,
                    event: "expanded",
                    eventComponent: "accordion",
                    eventContainer: type,
                    uuid: id,
                    label: title,
                    labelEnglish: entryTitle,
                    parentLabel: parentTitle
                });
                setTrackedKeys([
                    ...trackedKeys,
                    id
                ]);
            }
        }
        navigate(`#${newOpenKeys.join()}`);
        setOpenKeys(newOpenKeys);
    };
    const renderMarkdown = (content, itemTitle, itemEntryTitle, itemParentTitle)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
            value: {
                eventColumn: itemTitle,
                eventContainer: type,
                labelEnglish: itemEntryTitle,
                parentLabel: itemParentTitle
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                children: content
            })
        });
    return appearance === "Grid" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
        children: items?.filter(({ type: type })=>type === "uiAccordionItem").map(({ id: id, content: { entryTitle: entryTitle, title: title, ariaLabel: ariaLabel, content: content } })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    align: "left"
                },
                md: {
                    span: "6"
                },
                lg: {
                    span: "4"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8HfGf.GridItem), {
                    "data-open": openKeys.includes(id),
                    css: (0, $54E1V.cssColorsFromBackgroundField)(background),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8HfGf.AccordionButton), {
                                "aria-expanded": openKeys.includes(id),
                                "aria-label": ariaLabel,
                                "data-testid": "grid-accordion-click",
                                onClick: ()=>toggleOpenKeys(id, title, entryTitle, parentTitle),
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: openKeys.includes(id) ? "-" : "+"
                                    }),
                                    title
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                            show: openKeys.includes(id),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HfGf.GridItemContent), {
                                children: renderMarkdown(content, title, entryTitle, parentTitle)
                            })
                        })
                    ]
                })
            }, id))
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HfGf.List), {
        children: items?.filter(({ type: type })=>type === "uiAccordionItem").map(({ id: id, content: { entryTitle: entryTitle, title: title, ariaLabel: ariaLabel, content: content } }, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $8HfGf.ListItem), {
                "data-open": openKeys.includes(id),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8HfGf.AccordionButton), {
                            "aria-expanded": openKeys.includes(id),
                            "aria-label": ariaLabel,
                            "data-testid": "list-accordion-click",
                            onClick: ()=>toggleOpenKeys(id, title, entryTitle, parentTitle),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                    "aria-hidden": "true",
                                    children: openKeys.includes(id) ? "-" : "+"
                                }),
                                title
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                        show: openKeys.includes(id),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HfGf.ListItemContent), {
                            children: renderMarkdown(content, title, entryTitle, parentTitle)
                        })
                    })
                ]
            }, index))
    });
};
var $95dcda617684df66$export$2e2bcd8739ae039 = $95dcda617684df66$var$UiAccordion;

});
parcelRegister("8HfGf", function(module, exports) {

$parcel$export(module.exports, "AccordionButton", function () { return $ff4efc03a1298979$export$b9675c0bae9f505a; });
$parcel$export(module.exports, "GridItem", function () { return $ff4efc03a1298979$export$9eb849b9b922d396; });
$parcel$export(module.exports, "GridItemContent", function () { return $ff4efc03a1298979$export$5460f05d11135219; });
$parcel$export(module.exports, "List", function () { return $ff4efc03a1298979$export$54c2e3dc7acea9f5; });
$parcel$export(module.exports, "ListItem", function () { return $ff4efc03a1298979$export$a7b06bfba60a8a78; });
$parcel$export(module.exports, "ListItemContent", function () { return $ff4efc03a1298979$export$a09b9fc02aa00007; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");
var $fpcku = parcelRequire("fpcku");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $ff4efc03a1298979$export$b9675c0bae9f505a = (0, $hYbro.styled).button`
    ${(0, $jAJVK.redundantCssFromKebab)("background", "inherit")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "none")}
`;
const $ff4efc03a1298979$export$9eb849b9b922d396 = (0, $hYbro.styled).div`
    ${({ backgroundField: backgroundField })=>(0, $54E1V.cssColorsFromBackgroundField)(backgroundField)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).medium}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("min-height", "6.05rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.9rem 1.25rem 1.15rem 2.5rem")}

    > h3 {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

        button {
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "inherit")}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

            span {
                ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
                ${(0, $jAJVK.redundantCssFromKebab)("left", "-1.25rem")}
            }
        }
    }
`;
const $ff4efc03a1298979$export$5460f05d11135219 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "90%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 0")}

    ul {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.5rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "1.5rem")}
    }

    li {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.25rem 0")}
    }

    > *:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
`;
const $ff4efc03a1298979$export$54c2e3dc7acea9f5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
`;
const $ff4efc03a1298979$export$a7b06bfba60a8a78 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `0.5px solid ${(0, $i2LPb.colorCSS)("N50")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 0")}

    > h3 {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

        button {
            ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "inherit")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1.25rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

            span {
                ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
                ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            }
        }
    }

    &:first-child {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "0")}
    }

    &:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0")}
    }
`;
const $ff4efc03a1298979$export$a09b9fc02aa00007 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "90%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 1.25rem")}
    img {
        ${(0, $jAJVK.redundantCssFromKebab)("clear", "right")}
        ${(0, $jAJVK.redundantCssFromKebab)("float", "right")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 1rem 1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-height", "250px")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "250px")}
        /* uncomment when lightbox is supported
  &:hover {
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", "1px 1px 4px 0 rgba(0, 0, 0, 0.25)")}
    ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
  }
  */
    }
    table {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        th {
            ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.3rem")}
        }
        td {
            ${(0, $jAJVK.redundantCssFromKebab)("border-top", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.3rem")}
        }
    }
    ul {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.5rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "1.5rem")}
    }
    li {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.25rem 0")}
    }
    > *:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
`;

});



parcelRegister("3BpTc", function(module, exports) {

$parcel$export(module.exports, "UiAddToSlackSection", function () { return $05fb125a4c06c85a$export$63863b2e4f6541d1; });

var $hmtod = parcelRequire("hmtod");

const $05fb125a4c06c85a$export$63863b2e4f6541d1 = (0, $hmtod.default)(// Node16 module resolution requires .js extension, cast via unknown to satisfy type checker
()=>(parcelRequire("aaIKW")));

});
parcelRegister("hmtod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95065cb00e305e0f$export$2e2bcd8739ae039; });

var $iSvIT = parcelRequire("iSvIT");

var $kLFwA = parcelRequire("kLFwA");

var $kgisD = parcelRequire("kgisD");

var $evupF = parcelRequire("evupF");

var $h33Ke = parcelRequire("h33Ke");

var $lgqAv = parcelRequire("lgqAv");
/* eslint-disable import/prefer-default-export */ function $95065cb00e305e0f$var$invariant(condition, message) {
    if (condition) return;
    var error = new Error("loadable: " + message);
    error.framesToPop = 1;
    error.name = "Invariant Violation";
    throw error;
}
function $95065cb00e305e0f$var$warn(message) {
    // eslint-disable-next-line no-console
    console.warn("loadable: " + message);
}
var $95065cb00e305e0f$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createContext();
var $95065cb00e305e0f$var$LOADABLE_REQUIRED_CHUNKS_KEY = "__LOADABLE_REQUIRED_CHUNKS__";
function $95065cb00e305e0f$var$getRequiredChunkKey(namespace) {
    return "" + namespace + $95065cb00e305e0f$var$LOADABLE_REQUIRED_CHUNKS_KEY;
}
var $95065cb00e305e0f$var$sharedInternals = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getRequiredChunkKey: $95065cb00e305e0f$var$getRequiredChunkKey,
    invariant: $95065cb00e305e0f$var$invariant,
    Context: $95065cb00e305e0f$var$Context
});
var $95065cb00e305e0f$var$LOADABLE_SHARED = {
    initialChunks: {}
};
var $95065cb00e305e0f$var$STATUS_PENDING = "PENDING";
var $95065cb00e305e0f$var$STATUS_RESOLVED = "RESOLVED";
var $95065cb00e305e0f$var$STATUS_REJECTED = "REJECTED";
function $95065cb00e305e0f$var$resolveConstructor(ctor) {
    if (typeof ctor === "function") return {
        requireAsync: ctor,
        resolve: function resolve() {
            return undefined;
        },
        chunkName: function chunkName() {
            return undefined;
        }
    };
    return ctor;
}
var $95065cb00e305e0f$var$withChunkExtractor = function withChunkExtractor(Component) {
    var LoadableWithChunkExtractor = function LoadableWithChunkExtractor(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($95065cb00e305e0f$var$Context.Consumer, null, function(extractor) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, Object.assign({
                __chunkExtractor: extractor
            }, props));
        });
    };
    if (Component.displayName) LoadableWithChunkExtractor.displayName = Component.displayName + "WithChunkExtractor";
    return LoadableWithChunkExtractor;
};
var $95065cb00e305e0f$var$identity = function identity(v) {
    return v;
};
function $95065cb00e305e0f$var$createLoadable(_ref) {
    var _ref$defaultResolveCo = _ref.defaultResolveComponent, defaultResolveComponent = _ref$defaultResolveCo === void 0 ? $95065cb00e305e0f$var$identity : _ref$defaultResolveCo, _render = _ref.render, onLoad = _ref.onLoad;
    function loadable(loadableConstructor, options) {
        if (options === void 0) options = {};
        var ctor = $95065cb00e305e0f$var$resolveConstructor(loadableConstructor);
        var cache = {};
        /**
     * Cachekey represents the component to be loaded
     * if key changes - component has to be reloaded
     * @param props
     * @returns {null|Component}
     */ function _getCacheKey(props) {
            if (options.cacheKey) return options.cacheKey(props);
            if (ctor.resolve) return ctor.resolve(props);
            return "static";
        }
        /**
     * Resolves loaded `module` to a specific `Component
     * @param module
     * @param props
     * @param Loadable
     * @returns Component
     */ function resolve(module, props, Loadable) {
            var Component = options.resolveComponent ? options.resolveComponent(module, props) : defaultResolveComponent(module); // FIXME: suppressed due to https://github.com/gregberge/loadable-components/issues/990
            // if (options.resolveComponent && !ReactIs.isValidElementType(Component)) {
            //   throw new Error(
            //     `resolveComponent returned something that is not a React component!`,
            //   )
            // }
            (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))(Loadable, Component, {
                preload: true
            });
            return Component;
        }
        var cachedLoad = function cachedLoad(props) {
            var cacheKey = _getCacheKey(props);
            var promise = cache[cacheKey];
            if (!promise || promise.status === $95065cb00e305e0f$var$STATUS_REJECTED) {
                promise = ctor.requireAsync(props);
                promise.status = $95065cb00e305e0f$var$STATUS_PENDING;
                cache[cacheKey] = promise;
                promise.then(function() {
                    promise.status = $95065cb00e305e0f$var$STATUS_RESOLVED;
                }, function(error) {
                    console.error("loadable-components: failed to asynchronously load component", {
                        fileName: ctor.resolve(props),
                        chunkName: ctor.chunkName(props),
                        error: error ? error.message : error
                    });
                    promise.status = $95065cb00e305e0f$var$STATUS_REJECTED;
                });
            }
            return promise;
        };
        var InnerLoadable = /*#__PURE__*/ function(_React$Component) {
            (0, $h33Ke.default)(InnerLoadable, _React$Component);
            InnerLoadable.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
                var cacheKey = _getCacheKey(props);
                return (0, $kgisD.default)({}, state, {
                    cacheKey: cacheKey,
                    // change of a key triggers loading state automatically
                    loading: state.loading || state.cacheKey !== cacheKey
                });
            };
            function InnerLoadable(props) {
                var _this;
                _this = _React$Component.call(this, props) || this;
                _this.state = {
                    result: null,
                    error: null,
                    loading: true,
                    cacheKey: _getCacheKey(props)
                };
                $95065cb00e305e0f$var$invariant(!props.__chunkExtractor || ctor.requireSync, "SSR requires `@loadable/babel-plugin`, please install it"); // Server-side
                if (props.__chunkExtractor) {
                    // This module has been marked with no SSR
                    if (options.ssr === false) return (0, $evupF.default)(_this);
                     // We run load function, we assume that it won't fail and that it
                    // triggers a synchronous loading of the module
                    ctor.requireAsync(props)["catch"](function() {
                        return null;
                    }); // So we can require now the module synchronously
                    _this.loadSync();
                    props.__chunkExtractor.addChunk(ctor.chunkName(props));
                    return (0, $evupF.default)(_this);
                } // Client-side with `isReady` method present (SSR probably)
                // If module is already loaded, we use a synchronous loading
                // Only perform this synchronous loading if the component has not
                // been marked with no SSR, else we risk hydration mismatches
                if (options.ssr !== false && (ctor.isReady && ctor.isReady(props) || // is ready - was loaded during SSR process
                ctor.chunkName && $95065cb00e305e0f$var$LOADABLE_SHARED.initialChunks[ctor.chunkName(props)])) _this.loadSync();
                return _this;
            }
            var _proto = InnerLoadable.prototype;
            _proto.componentDidMount = function componentDidMount() {
                this.mounted = true; // retrieve loading promise from a global cache
                var cachedPromise = this.getCache(); // if promise exists, but rejected - clear cache
                if (cachedPromise && cachedPromise.status === $95065cb00e305e0f$var$STATUS_REJECTED) this.setCache();
                 // component might be resolved synchronously in the constructor
                if (this.state.loading) this.loadAsync();
            };
            _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
                // Component has to be reloaded on cacheKey change
                if (prevState.cacheKey !== this.state.cacheKey) this.loadAsync();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                this.mounted = false;
            };
            _proto.safeSetState = function safeSetState(nextState, callback) {
                if (this.mounted) this.setState(nextState, callback);
            } /**
       * returns a cache key for the current props
       * @returns {Component|string}
       */ ;
            _proto.getCacheKey = function getCacheKey() {
                return _getCacheKey(this.props);
            } /**
       * access the persistent cache
       */ ;
            _proto.getCache = function getCache() {
                return cache[this.getCacheKey()];
            } /**
       * sets the cache value. If called without value sets it as undefined
       */ ;
            _proto.setCache = function setCache(value) {
                if (value === void 0) value = undefined;
                cache[this.getCacheKey()] = value;
            };
            _proto.triggerOnLoad = function triggerOnLoad() {
                var _this2 = this;
                if (onLoad) setTimeout(function() {
                    onLoad(_this2.state.result, _this2.props);
                });
            } /**
       * Synchronously loads component
       * target module is expected to already exists in the module cache
       * or be capable to resolve synchronously (webpack target=node)
       */ ;
            _proto.loadSync = function loadSync() {
                // load sync is expecting component to be in the "loading" state already
                // sounds weird, but loading=true is the initial state of InnerLoadable
                if (!this.state.loading) return;
                try {
                    var loadedModule = ctor.requireSync(this.props);
                    var result = resolve(loadedModule, this.props, Loadable);
                    this.state.result = result;
                    this.state.loading = false;
                } catch (error) {
                    console.error("loadable-components: failed to synchronously load component, which expected to be available", {
                        fileName: ctor.resolve(this.props),
                        chunkName: ctor.chunkName(this.props),
                        error: error ? error.message : error
                    });
                    this.state.error = error;
                }
            } /**
       * Asynchronously loads a component.
       */ ;
            _proto.loadAsync = function loadAsync() {
                var _this3 = this;
                var promise = this.resolveAsync();
                promise.then(function(loadedModule) {
                    var result = resolve(loadedModule, _this3.props, Loadable);
                    _this3.safeSetState({
                        result: result,
                        loading: false
                    }, function() {
                        return _this3.triggerOnLoad();
                    });
                })["catch"](function(error) {
                    return _this3.safeSetState({
                        error: error,
                        loading: false
                    });
                });
                return promise;
            } /**
       * Asynchronously resolves(not loads) a component.
       * Note - this function does not change the state
       */ ;
            _proto.resolveAsync = function resolveAsync() {
                var _this$props = this.props, __chunkExtractor = _this$props.__chunkExtractor, forwardedRef = _this$props.forwardedRef, props = (0, $kLFwA.default)(_this$props, [
                    "__chunkExtractor",
                    "forwardedRef"
                ]);
                return cachedLoad(props);
            };
            _proto.render = function render() {
                var _this$props2 = this.props, forwardedRef = _this$props2.forwardedRef, propFallback = _this$props2.fallback, __chunkExtractor = _this$props2.__chunkExtractor, props = (0, $kLFwA.default)(_this$props2, [
                    "forwardedRef",
                    "fallback",
                    "__chunkExtractor"
                ]);
                var _this$state = this.state, error = _this$state.error, loading = _this$state.loading, result = _this$state.result;
                if (options.suspense) {
                    var cachedPromise = this.getCache() || this.loadAsync();
                    if (cachedPromise.status === $95065cb00e305e0f$var$STATUS_PENDING) throw this.loadAsync();
                }
                if (error) throw error;
                var fallback = propFallback || options.fallback || null;
                if (loading) return fallback;
                return _render({
                    fallback: fallback,
                    result: result,
                    options: options,
                    props: (0, $kgisD.default)({}, props, {
                        ref: forwardedRef
                    })
                });
            };
            return InnerLoadable;
        }((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Component);
        var EnhancedInnerLoadable = $95065cb00e305e0f$var$withChunkExtractor(InnerLoadable);
        var Loadable = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(EnhancedInnerLoadable, Object.assign({
                forwardedRef: ref
            }, props));
        });
        Loadable.displayName = "Loadable"; // In future, preload could use `<link rel="preload">`
        Loadable.preload = function(props) {
            Loadable.load(props);
        };
        Loadable.load = function(props) {
            return cachedLoad(props);
        };
        return Loadable;
    }
    function lazy(ctor, options) {
        return loadable(ctor, (0, $kgisD.default)({}, options, {
            suspense: true
        }));
    }
    return {
        loadable: loadable,
        lazy: lazy
    };
}
function $95065cb00e305e0f$var$defaultResolveComponent(loadedModule) {
    // eslint-disable-next-line no-underscore-dangle
    return loadedModule.__esModule ? loadedModule["default"] : loadedModule["default"] || loadedModule;
}
/* eslint-disable no-use-before-define, react/no-multi-comp */ var $95065cb00e305e0f$var$_createLoadable = /*#__PURE__*/ $95065cb00e305e0f$var$createLoadable({
    defaultResolveComponent: $95065cb00e305e0f$var$defaultResolveComponent,
    render: function render(_ref) {
        var Component = _ref.result, props = _ref.props;
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Component, props);
    }
}), $95065cb00e305e0f$var$loadable = $95065cb00e305e0f$var$_createLoadable.loadable, $95065cb00e305e0f$var$lazy = $95065cb00e305e0f$var$_createLoadable.lazy;
/* eslint-disable no-use-before-define, react/no-multi-comp */ var $95065cb00e305e0f$var$_createLoadable$1 = /*#__PURE__*/ $95065cb00e305e0f$var$createLoadable({
    onLoad: function onLoad(result, props) {
        if (result && props.forwardedRef) {
            if (typeof props.forwardedRef === "function") props.forwardedRef(result);
            else props.forwardedRef.current = result;
        }
    },
    render: function render(_ref) {
        var result = _ref.result, props = _ref.props;
        if (props.children) return props.children(result);
        return null;
    }
}), $95065cb00e305e0f$var$loadable$1 = $95065cb00e305e0f$var$_createLoadable$1.loadable, $95065cb00e305e0f$var$lazy$1 = $95065cb00e305e0f$var$_createLoadable$1.lazy;
/* eslint-disable no-underscore-dangle, camelcase */ var $95065cb00e305e0f$var$BROWSER = typeof window !== "undefined";
function $95065cb00e305e0f$export$6486163faa357bc8(done, _temp) {
    if (done === void 0) done = function done() {};
    var _ref = _temp === void 0 ? {} : _temp, _ref$namespace = _ref.namespace, namespace = _ref$namespace === void 0 ? "" : _ref$namespace, _ref$chunkLoadingGlob = _ref.chunkLoadingGlobal, chunkLoadingGlobal = _ref$chunkLoadingGlob === void 0 ? "__LOADABLE_LOADED_CHUNKS__" : _ref$chunkLoadingGlob;
    if (!$95065cb00e305e0f$var$BROWSER) {
        $95065cb00e305e0f$var$warn("`loadableReady()` must be called in browser only");
        done();
        return Promise.resolve();
    }
    var requiredChunks = null;
    if ($95065cb00e305e0f$var$BROWSER) {
        var id = $95065cb00e305e0f$var$getRequiredChunkKey(namespace);
        var dataElement = document.getElementById(id);
        if (dataElement) {
            requiredChunks = JSON.parse(dataElement.textContent);
            var extElement = document.getElementById(id + "_ext");
            if (extElement) {
                var _JSON$parse = JSON.parse(extElement.textContent), namedChunks = _JSON$parse.namedChunks;
                namedChunks.forEach(function(chunkName) {
                    $95065cb00e305e0f$var$LOADABLE_SHARED.initialChunks[chunkName] = true;
                });
            } else // version mismatch
            throw new Error("loadable-component: @loadable/server does not match @loadable/component");
        }
    }
    if (!requiredChunks) {
        $95065cb00e305e0f$var$warn("`loadableReady()` requires state, please use `getScriptTags` or `getScriptElements` server-side");
        done();
        return Promise.resolve();
    }
    var resolved = false;
    return new Promise(function(resolve) {
        window[chunkLoadingGlobal] = window[chunkLoadingGlobal] || [];
        var loadedChunks = window[chunkLoadingGlobal];
        var originalPush = loadedChunks.push.bind(loadedChunks);
        function checkReadyState() {
            if (requiredChunks.every(function(chunk) {
                return loadedChunks.some(function(_ref2) {
                    var chunks = _ref2[0];
                    return chunks.indexOf(chunk) > -1;
                });
            })) {
                if (!resolved) {
                    resolved = true;
                    resolve();
                }
            }
        }
        loadedChunks.push = function() {
            originalPush.apply(void 0, arguments);
            checkReadyState();
        };
        checkReadyState();
    }).then(done);
}
/* eslint-disable no-underscore-dangle */ var $95065cb00e305e0f$var$loadable$2 = $95065cb00e305e0f$var$loadable;
$95065cb00e305e0f$var$loadable$2.lib = $95065cb00e305e0f$var$loadable$1;
var $95065cb00e305e0f$export$488013bae63b21da = $95065cb00e305e0f$var$lazy;
$95065cb00e305e0f$export$488013bae63b21da.lib = $95065cb00e305e0f$var$lazy$1;
var $95065cb00e305e0f$export$ae55be85d98224ed = $95065cb00e305e0f$var$sharedInternals;
var $95065cb00e305e0f$export$2e2bcd8739ae039 = $95065cb00e305e0f$var$loadable$2;

});
parcelRegister("kLFwA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1e8685e9f78e129$export$2e2bcd8739ae039; });
function $f1e8685e9f78e129$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("kgisD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec039f33c4489dd5$export$2e2bcd8739ae039; });
function $ec039f33c4489dd5$export$2e2bcd8739ae039() {
    return $ec039f33c4489dd5$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ec039f33c4489dd5$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("evupF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8fb8d56763fae3e$export$2e2bcd8739ae039; });
function $a8fb8d56763fae3e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("h33Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c6959f1d5a769307$export$2e2bcd8739ae039; });

var $8ahyL = parcelRequire("8ahyL");
function $c6959f1d5a769307$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $8ahyL.default)(t, o);
}

});
parcelRegister("8ahyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f1ce0e9c582112c$export$2e2bcd8739ae039; });
function $5f1ce0e9c582112c$export$2e2bcd8739ae039(t, e) {
    return $5f1ce0e9c582112c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $5f1ce0e9c582112c$export$2e2bcd8739ae039(t, e);
}

});



parcelRegister("aaIKW", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("iZt0G").then(()=>parcelRequire("8kmO5"));

});


parcelRegister("hMNNV", function(module, exports) {

$parcel$export(module.exports, "UiAnimatedHeroSection", function () { return (parcelRequire("fQ8J7")).default; });

var $fQ8J7 = parcelRequire("fQ8J7");

});
parcelRegister("fQ8J7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f63d6b1e9e95bfc$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
var $j30bs = parcelRequire("j30bs");

var $33PqJ = parcelRequire("33PqJ");

var $j7ypx = parcelRequire("j7ypx");

var $75m4l = parcelRequire("75m4l");
const $6f63d6b1e9e95bfc$var$UiAnimatedHeroSection = ({ model: { content: { content: content, background: background, callsToAction: callsToAction, images: images, labels: labels } } })=>{
    const imagesDoubled = [
        ...images.content.items,
        ...images.content.items
    ].map(//prevent duplicate key errors
    (image, index)=>({
            ...image,
            id: `${image.id}-${index}`
        }));
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.Wrapper), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $75m4l.Section), {
            background: background,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.MobileWave), {
                    height: "31",
                    preserveAspectRatio: "none",
                    viewBox: "0 0 428 31",
                    width: "428",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M0 31h428V0C204.857 53.535 199.059-31.763 0 27.14V31Z"
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Column), {
                                xs: {
                                    top: "outerspace"
                                },
                                lg: {
                                    align: "left",
                                    span: "6"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                        document: content
                                    }),
                                    callsToAction && /*#__PURE__*/ (0, $loA2J.jsx)((0, $j30bs.Stack), {
                                        spacing: "compact",
                                        children: (0, $33PqJ.renderViewModels)(callsToAction)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.MobileImages), {
                                        children: (0, $33PqJ.renderViewModel)(images)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.DesktopImageColumnA), {
                                children: (0, $33PqJ.renderViewModels)(imagesDoubled)
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.DesktopImageColumnB), {
                                children: (0, $33PqJ.renderViewModels)(imagesDoubled.reverse())
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $j7ypx.Labels), {
                                options: labels
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $75m4l.DesktopWave), {
                    height: "99",
                    preserveAspectRatio: "none",
                    viewBox: "0 0 1440 99",
                    width: "1440",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M0 99h1440V0C689.239 179.5 669.733-106.498 0 91v8Z"
                    })
                })
            ]
        })
    });
};
var $6f63d6b1e9e95bfc$export$2e2bcd8739ae039 = $6f63d6b1e9e95bfc$var$UiAnimatedHeroSection;

});
parcelRegister("j7ypx", function(module, exports) {

$parcel$export(module.exports, "Labels", function () { return $245756d21e3a5ed1$export$c9ed62821215deda; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $sm53h = parcelRequire("sm53h");
const $245756d21e3a5ed1$export$c9ed62821215deda = ({ options: options })=>{
    const VISIBLE_LABEL_COUNT = 4;
    const LABEL_ROTATION_TIMEOUT = 7000;
    const initialLabels = options.slice(0, VISIBLE_LABEL_COUNT).map((text, index)=>({
            text: text,
            theme: (0, $sm53h.labelThemeOptions)[index]
        }));
    const [currentLabels, setCurrentLabels] = (0, $iSvIT.useState)(initialLabels);
    const [labelCounter, setLabelCounter] = (0, $iSvIT.useState)(0);
    //periodically rotate
    (0, $iSvIT.useEffect)(()=>{
        const timer = setTimeout(()=>{
            const newLabel = {
                text: options[(labelCounter + VISIBLE_LABEL_COUNT) % options.length] ?? "",
                theme: (0, $sm53h.labelThemeOptions)[(labelCounter + VISIBLE_LABEL_COUNT) % (0, $sm53h.labelThemeOptions).length]
            };
            currentLabels.splice(labelCounter % VISIBLE_LABEL_COUNT, 1, newLabel);
            setLabelCounter(labelCounter + 1);
            setCurrentLabels([
                ...currentLabels
            ]);
        }, LABEL_ROTATION_TIMEOUT);
        return ()=>clearTimeout(timer);
    }, [
        currentLabels,
        labelCounter,
        LABEL_ROTATION_TIMEOUT,
        VISIBLE_LABEL_COUNT,
        options
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: currentLabels.map(({ text: text, theme: theme }, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $sm53h.Label), {
                className: `label label-${index}`,
                text: text,
                theme: theme
            }, index))
    });
};

});

parcelRegister("75m4l", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $71834a324a596025$export$6e2c8f0811a474ce; });
$parcel$export(module.exports, "MobileImages", function () { return $71834a324a596025$export$59b3ddb75da68b03; });
$parcel$export(module.exports, "Wrapper", function () { return $71834a324a596025$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "DesktopImageColumnA", function () { return $71834a324a596025$export$47e368dc623d01f4; });
$parcel$export(module.exports, "DesktopImageColumnB", function () { return $71834a324a596025$export$c75f42f5e57a6fcb; });
$parcel$export(module.exports, "MobileWave", function () { return $71834a324a596025$export$87161b556dd8a59; });
$parcel$export(module.exports, "DesktopWave", function () { return $71834a324a596025$export$125b344e377b5c83; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $2EK56 = parcelRequire("2EK56");
var $8DhG7 = parcelRequire("8DhG7");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
const $71834a324a596025$var$config = {
    bounceDuration: 4,
    //s
    columnGap: 16,
    //px
    columnWidth: 456,
    //px
    scrollDuration: 120 //s
};
const $71834a324a596025$var$bounce = (0, $hYbro.keyframes)`
    from {
        box-shadow: -5px 5px 0 0 ${(0, $i2LPb.colorCSS)("N900", 0.1)};
        transform: translate(0, 0);
    }
    to {
        box-shadow: -10px 10px 0 0 ${(0, $i2LPb.colorCSS)("N900", 0.05)};
        transform: translate(10px, -10px);
    }
`;
const $71834a324a596025$var$scroll = (0, $hYbro.keyframes)`
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(-50%);
    }
`;
const $71834a324a596025$export$6e2c8f0811a474ce = (0, $hYbro.styled).section`
    ${({ background: background })=>background && (0, $2EK56.generateFieldsStyles)(background)};
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

    .label {
        ${(0, $jAJVK.redundantCssFromKebab)("animation-direction", "alternate")}
        ${(0, $jAJVK.redundantCssFromKebab)("animation-duration", `${$71834a324a596025$var$config.bounceDuration}s`)}
        ${(0, $jAJVK.redundantCssFromKebab)("animation-iteration-count", "infinite")}
        animation-name: ${$71834a324a596025$var$bounce};
        ${(0, $jAJVK.redundantCssFromKebab)("animation-timing-function", "ease-in-out")}

        &-0 {
            ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).lg}px) / 2 + 550px)`)}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "25%")}

            @media ${(0, $aT9Ik.minWidth).xl} {
                ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).xl}px) / 2 + 650px)`)}
            }
        }

        &-1 {
            ${(0, $jAJVK.redundantCssFromKebab)("animation-delay", "1s")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).lg}px) / 2 + 516px)`)}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "65%")}

            @media ${(0, $aT9Ik.minWidth).xl} {
                ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).xl}px) / 2 + 616px)`)}
            }
        }

        &-2 {
            ${(0, $jAJVK.redundantCssFromKebab)("animation-delay", "2s")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).lg}px) / 2 + 1040px)`)}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "15%")}

            @media ${(0, $aT9Ik.minWidth).xl} {
                ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).xl}px) / 2 + 1156px)`)}
            }
        }

        &-3 {
            ${(0, $jAJVK.redundantCssFromKebab)("animation-delay", "3s")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).lg}px) / 2 + 1010px)`)}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "50%")}

            @media ${(0, $aT9Ik.minWidth).xl} {
                ${(0, $jAJVK.redundantCssFromKebab)("left", `calc((100% - ${(0, $8DhG7.containerWidths).xl}px) / 2 + 1126px)`)}
            }
        }

        @media (prefers-reduced-motion) {
            ${(0, $jAJVK.redundantCssFromKebab)("animation-name", "none")}
        }

        @media ${(0, $aT9Ik.maxWidth).lg} {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
        }
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "7rem")}
    }

    @media ${(0, $aT9Ik.minWidth).xl} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "9rem")}
    }
`;
const $71834a324a596025$export$59b3ddb75da68b03 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "2rem -1rem -5rem !important")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }
`;
const $71834a324a596025$export$e6dfd72ab29f8598 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "6rem")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "1rem")}
    }
`;
const $71834a324a596025$var$DesktopImageColumn = (0, $hYbro.styled).div`
    animation-name: ${$71834a324a596025$var$scroll};
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("pointer-events", "none")}

    /* prevent mouse image 'lifting' */
    img {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
        /* jitterFree way to create spacing between images */
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "translate3d(0, 0, 0)")}
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("animation-duration", `${$71834a324a596025$var$config.scrollDuration}s`)}
        ${(0, $jAJVK.redundantCssFromKebab)("animation-iteration-count", "infinite")}
        ${(0, $jAJVK.redundantCssFromKebab)("animation-timing-function", "linear")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        left: calc(
            (100% - ${(0, $8DhG7.containerWidths).lg}px) / 2 +
                (${(0, $8DhG7.containerWidths).lg}px * 0.6)
        );
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("top", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", `${$71834a324a596025$var$config.columnWidth}px`)}
    }

    @media ${(0, $aT9Ik.minWidth).xl} {
        left: calc(
            (100% - ${(0, $8DhG7.containerWidths).xl}px) / 2 +
                (${(0, $8DhG7.containerWidths).xl}px * 0.6)
        );
    }

    @media (prefers-reduced-motion) {
        ${(0, $jAJVK.redundantCssFromKebab)("animation-name", "none")}
    }
`;
const $71834a324a596025$export$47e368dc623d01f4 = (0, $hYbro.styled)($71834a324a596025$var$DesktopImageColumn)({
    "flexDirection": "column",
    "flex-direction": "column"
});
const $71834a324a596025$export$c75f42f5e57a6fcb = (0, $hYbro.styled)($71834a324a596025$var$DesktopImageColumn)({
    "animationDirection": "reverse",
    "animation-direction": "reverse",
    "flexDirection": "column",
    "flex-direction": "column",
    "marginLeft": `${$71834a324a596025$var$config.columnWidth + $71834a324a596025$var$config.columnGap}px`
});
const $71834a324a596025$export$b8bb87b40c00c04e = (0, $hYbro.styled).svg`
    ${(0, $jAJVK.redundantCssFromKebab)("bottom", "-0.5px")}
    ${(0, $jAJVK.redundantCssFromKebab)("fill", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-height", "179px")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("right", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $71834a324a596025$export$87161b556dd8a59 = (0, $hYbro.styled)($71834a324a596025$export$b8bb87b40c00c04e)({
    "display": "block",
    "@media (min-width: 992px)": {
        display: "none"
    }
});
const $71834a324a596025$export$125b344e377b5c83 = (0, $hYbro.styled)($71834a324a596025$export$b8bb87b40c00c04e)({
    "display": "none",
    "@media (min-width: 992px)": {
        display: "block"
    }
});

});



parcelRegister("iUERz", function(module, exports) {

$parcel$export(module.exports, "UiBlock", function () { return (parcelRequire("1GNfM")).default; });

var $1GNfM = parcelRequire("1GNfM");

});
parcelRegister("1GNfM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a9eaa14446c1d27f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $j30bs = parcelRequire("j30bs");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");

var $jRcEO = parcelRequire("jRcEO");
const $a9eaa14446c1d27f$var$UiBlock = ({ model: { content: { title: title, shadow: shadow, roundedCorners: roundedCorners, background: background, children: children, verticalAlign: verticalAlign, appearance: appearance, fullHeight: fullHeight, orientation: orientation, spacing: spacing, border: border } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            labelEnglish: title
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jRcEO.Block), {
            "data-testid": "block",
            shadow: shadow,
            roundedCorners: roundedCorners,
            appearance: appearance,
            fullHeight: fullHeight,
            border: border,
            ...(0, $54E1V.getColorsFromBackgroundField)(background),
            backgroundField: background,
            children: children && /*#__PURE__*/ (0, $loA2J.jsx)((0, $j30bs.Stack), {
                fullHeight: fullHeight,
                orientation: orientation,
                spacing: spacing,
                verticalAlign: verticalAlign,
                children: (0, $33PqJ.renderViewModels)(children)
            })
        })
    });
};
var $a9eaa14446c1d27f$export$2e2bcd8739ae039 = $a9eaa14446c1d27f$var$UiBlock;

});
parcelRegister("jRcEO", function(module, exports) {

$parcel$export(module.exports, "Block", function () { return $eb0788149ce956d7$export$d96a8827a60d6b69; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $54E1V = parcelRequire("54E1V");
const $eb0788149ce956d7$export$d96a8827a60d6b69 = ({ appearance: appearance, background: background, backgroundField: backgroundField, border: border, borderColor: borderColor, color: color, fullHeight: fullHeight, headingColor: headingColor, linkColor: linkColor, linkHoverColor: linkHoverColor, roundedCorners: roundedCorners, shadow: shadow, style: propStyle, ...props })=>{
    const style = {
        ...propStyle || {}
    };
    // Padding based on appearance
    if (border && borderColor || appearance === "Medium Padding") style.padding = "1.5rem";
    else if (appearance !== "No Padding") style.padding = "1.5rem 3rem";
    // Full height
    if (fullHeight) style.height = "100%";
    // Border
    if (border && borderColor) style.border = `1px solid ${borderColor}`;
    // Appearance-specific styles
    switch(appearance){
        case "Highlighted":
            style.textAlign = "left";
            style.padding = "1.5rem 2.2rem";
            break;
        case "Neutral Border":
            style.border = `1px solid ${(0, $i2LPb.colorCSS)("N60")}`;
            break;
        case "Speech Bubble Left":
        case "Speech Bubble Right":
            style.borderRadius = (0, $fpcku.radius).medium;
            style.marginBottom = "2rem";
            style.width = "max-content";
            style.maxWidth = "70%";
            style.textAlign = "left";
            style.fontWeight = "300";
            style.padding = "1rem 1.7rem";
            style.position = "relative";
            if (appearance === "Speech Bubble Left") style.marginRight = "auto";
            else style.marginLeft = "auto";
            break;
    }
    // Rounded corners
    if (roundedCorners) {
        style.borderRadius = (0, $fpcku.radius)[roundedCorners.toLowerCase()];
        style.overflow = "hidden";
    }
    // Shadow
    if (shadow) style.boxShadow = `0 0 1rem ${(0, $i2LPb.colorCSS)("N900", 0.25)}`;
    // Apply background colors (only plain CSS properties, not styled-components css)
    if (backgroundField) {
        const bgColors = (0, $54E1V.getColorsFromBackgroundField)(backgroundField);
        if (bgColors.background) {
            // Use background for gradients, background-color for solid colors
            if (backgroundField.gradient) style.background = bgColors.background;
            else style.backgroundColor = bgColors.background;
        }
        if (bgColors.color) style.color = bgColors.color;
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};

});



parcelRegister("9R436", function(module, exports) {

$parcel$export(module.exports, "UiButton", function () { return (parcelRequire("78xz5")).default; });

var $78xz5 = parcelRequire("78xz5");

});
parcelRegister("78xz5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5616f2dce68997fb$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $82f25 = parcelRequire("82f25");
const $5616f2dce68997fb$var$UiButton = ({ model: model })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { entryTitle: entryTitle, text: text, ariaLabel: ariaLabel, url: url, buttonTheme: buttonTheme } = model.content;
    const theme = buttonTheme ? {
        ...buttonTheme.content
    } : {};
    // Remove `title` (entryTitle) from props since it is a valid attribute
    const { title: title, ...buttonThemeProps } = theme;
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const props = {
        onClick: ()=>sendTrackEvent("clickedUiButton", {
                eventContainer: "content",
                ...analyticsAttributes,
                event: "clicked",
                eventComponent: "button",
                label: text,
                labelEnglish: entryTitle,
                uuid: model.id,
                href: url,
                theme: theme
            }),
        url: url,
        ...buttonThemeProps
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
        ...props,
        "aria-label": ariaLabel,
        "data-uuid": model.id,
        children: text
    });
};
var $5616f2dce68997fb$export$2e2bcd8739ae039 = $5616f2dce68997fb$var$UiButton;

});


parcelRegister("7y502", function(module, exports) {

$parcel$export(module.exports, "UiCallout", function () { return (parcelRequire("kYLJF")).default; });

var $kYLJF = parcelRequire("kYLJF");

});
parcelRegister("kYLJF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f310b7a230f4693$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");

var $2Qp9H = parcelRequire("2Qp9H");
const $8f310b7a230f4693$var$UiCallout = ({ model: model })=>{
    const { type: type, content: { entryTitle: entryTitle, media: media, mediaOnRight: mediaOnRight, heading: heading, text: text, icon: icon, theme: theme } } = model;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventComponent: type,
            labelEnglish: entryTitle,
            parentLabel: heading
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2Qp9H.Callout), {
            mediaOnRight: mediaOnRight,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Qp9H.CalloutMedia), {
                    children: (0, $33PqJ.renderViewModel)(media)
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2Qp9H.CalloutText), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $2Qp9H.CalloutHeading), {
                            children: [
                                icon && /*#__PURE__*/ (0, $loA2J.jsx)((0, $2Qp9H.CalloutIcon), {
                                    $color: theme,
                                    children: (0, $33PqJ.renderViewModel)(icon)
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: heading
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                            document: text
                        })
                    ]
                })
            ]
        })
    });
};
var $8f310b7a230f4693$export$2e2bcd8739ae039 = $8f310b7a230f4693$var$UiCallout;

});
parcelRegister("2Qp9H", function(module, exports) {

$parcel$export(module.exports, "Callout", function () { return $ceb0c7b30fb9bdbb$export$97a5aca3dea8edc7; });
$parcel$export(module.exports, "CalloutMedia", function () { return $ceb0c7b30fb9bdbb$export$19bcf7cef7cd957c; });
$parcel$export(module.exports, "CalloutHeading", function () { return $ceb0c7b30fb9bdbb$export$cc051492b47c023d; });
$parcel$export(module.exports, "CalloutIcon", function () { return $ceb0c7b30fb9bdbb$export$344a41dfe1204a4b; });
$parcel$export(module.exports, "CalloutText", function () { return $ceb0c7b30fb9bdbb$export$3663ba83ba0b087e; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");
var $fpcku = parcelRequire("fpcku");
var $a7xVp = parcelRequire("a7xVp");
var $aT9Ik = parcelRequire("aT9Ik");
var $7XWgk = parcelRequire("7XWgk");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
parcelRequire("bNHtH");
var $hqPCQ = parcelRequire("hqPCQ");
const $ceb0c7b30fb9bdbb$export$97a5aca3dea8edc7 = (0, $hYbro.styled).div`
    ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "N0"
})}
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow).normal}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "2rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "row")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem")}
        max-width: 960px;
        ${({ mediaOnRight: mediaOnRight })=>mediaOnRight && "flex-direction: row-reverse;"}
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1400px) {
        max-width: 1320px;
    }
`;
const $ceb0c7b30fb9bdbb$export$19bcf7cef7cd957c = (0, $hYbro.styled).div`
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "55%")}
    }
`;
const $ceb0c7b30fb9bdbb$export$cc051492b47c023d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1.5rem")}

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "2rem")}
    }

    h3 {
        ${(0, $7XWgk.h5)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }
`;
const $ceb0c7b30fb9bdbb$export$344a41dfe1204a4b = (0, $hYbro.styled).div`
    display: none;
    ${({ $color: $color })=>$color && `
        @media ${(0, $aT9Ik.minWidth).lg} {
            color: ${(0, $i2LPb.colorCSS)(`${(0, $hqPCQ.getColorInitial)($color)}200`)};
            display: block;
        }
    `}
`;
const $ceb0c7b30fb9bdbb$export$3663ba83ba0b087e = (0, $hYbro.styled).div`
    p:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 2rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "45%")}
    }
`;

});



parcelRegister("joEuS", function(module, exports) {

$parcel$export(module.exports, "UiCaption", function () { return (parcelRequire("hz8fk")).default; });

var $hz8fk = parcelRequire("hz8fk");

});
parcelRegister("hz8fk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf194feb89ee1a7d$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");

var $33PqJ = parcelRequire("33PqJ");

var $dzSUq = parcelRequire("dzSUq");
const $bf194feb89ee1a7d$var$UiCaption = ({ model: model })=>{
    const { caption: caption, appearance: appearance } = model.content;
    return caption.content ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dzSUq.CaptionWrapper), {
        "data-testid": "caption",
        roundedCorners: caption.content.content.content.roundedCorners,
        children: [
            (0, $33PqJ.renderViewModel)(caption.content.content),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dzSUq.Caption), {
                appearance: appearance,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                    document: caption.content.caption
                })
            })
        ]
    }) : null;
};
var $bf194feb89ee1a7d$export$2e2bcd8739ae039 = $bf194feb89ee1a7d$var$UiCaption;

});
parcelRegister("dzSUq", function(module, exports) {

$parcel$export(module.exports, "CaptionWrapper", function () { return $b5542d8514d4452c$export$4ebf02146448fa37; });
$parcel$export(module.exports, "Caption", function () { return $b5542d8514d4452c$export$32fbfacc5d962e0c; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");
const $b5542d8514d4452c$export$4ebf02146448fa37 = (0, $hYbro.styled).div({
    overflow: "hidden",
    position: "relative"
}, ({ roundedCorners: roundedCorners })=>{
    if (!roundedCorners) return "";
    const key = roundedCorners.toLowerCase();
    // @ts-expect-error - dynamic key access
    const radiusValue = (0, $fpcku.radius)[key];
    return radiusValue ? `border-radius: ${radiusValue};` : "";
});
const $b5542d8514d4452c$export$32fbfacc5d962e0c = (0, $hYbro.styled).div({
    "fontSize": (0, $kL1mL.fontSizes).sm,
    "lineHeight": 1.25,
    "h1, h2, h3, h4, h5, h6, p": {
        "margin": "0 0 0.275rem",
        "&:last-child": {
            marginBottom: 0
        }
    },
    "strong": {
        fontWeight: 500
    }
}, ({ appearance: appearance })=>appearance == "Overlay 1" && `
      background-color: ${(0, $i2LPb.colorCSS)("P500", 0.75)};
      bottom: 0;
      color: ${(0, $i2LPb.colorCSS)("N0")};
      left: 0;
      padding: 1rem;
      position: absolute;
      right: 0;
    `);

});



parcelRegister("gozH7", function(module, exports) {

$parcel$export(module.exports, "UiCard", function () { return (parcelRequire("cVhUY")).default; });

var $cVhUY = parcelRequire("cVhUY");

});
parcelRegister("cVhUY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c5a865dc89f412d$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("lJZAY");
var $kzY5l = parcelRequire("kzY5l");
var $82f25 = parcelRequire("82f25");
parcelRequire("h6yBX");
var $8korH = parcelRequire("8korH");

var $l7Ope = parcelRequire("l7Ope");
const $2c5a865dc89f412d$var$UiCard = ({ model: model })=>{
    const { entryTitle: entryTitle, title: title, content: content, decoration: decoration, linkText: linkText, linkAppearance: linkAppearance, route: route } = model.content;
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    return linkText ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $l7Ope.Card), {
        $decoration: (0, $8korH.isBackgroundFieldArray)(decoration) ? decoration : undefined,
        $appearance: linkAppearance,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: content
            }),
            route.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                url: route.content.path,
                appearance: linkAppearance,
                prominence: "Reduced",
                isBlock: true,
                onClick: ()=>sendTrackEvent("clickedUiCard", {
                        event: "clicked",
                        eventComponent: "CTA",
                        eventContainer: model.type,
                        label: `${title}_${linkText}`,
                        labelEnglish: entryTitle,
                        uuid: model.id,
                        href: route.content.path,
                        theme: linkAppearance
                    }),
                testId: "cta",
                children: linkText
            })
        ]
    }) : route.content ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $l7Ope.CardLink), {
        $decoration: (0, $8korH.isBackgroundFieldArray)(decoration) ? decoration : undefined,
        href: route.content.path,
        onClick: ()=>sendTrackEvent("clickedUiCard", {
                event: "clicked",
                eventComponent: model.type,
                eventContainer: "content",
                label: title,
                labelEnglish: entryTitle,
                uuid: model.id,
                href: route.content.path
            }),
        "data-testid": "card-link",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                children: content
            })
        ]
    }) : null;
};
var $2c5a865dc89f412d$export$2e2bcd8739ae039 = $2c5a865dc89f412d$var$UiCard;

});
parcelRegister("lJZAY", function(module, exports) {
$parcel$export(module.exports, "AnalyticsAttributesProvider", function () { return (parcelRequire("g4xTJ")).AnalyticsAttributesProvider; });
$parcel$export(module.exports, "LinkButton", function () { return (parcelRequire("82f25")).LinkButton; });
$parcel$export(module.exports, "useAnalytics", function () { return (parcelRequire("kzY5l")).useAnalytics; });
parcelRequire("cExkZ");
parcelRequire("791z3");
parcelRequire("bwkIl");
parcelRequire("dg5xP");
parcelRequire("bLXK9");
parcelRequire("d0igB");
parcelRequire("4iWIP");
parcelRequire("h6yBX");
parcelRequire("bNHtH");
parcelRequire("er0Js");
parcelRequire("lBdjQ");

});
parcelRegister("cExkZ", function(module, exports) {

$parcel$export(module.exports, "App", function () { return $844dd9667d105553$export$86fbec116b87613f; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $9KLDf = parcelRequire("9KLDf");

var $47vbe = parcelRequire("47vbe");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $5atKW = parcelRequire("5atKW");
var $eSKWD = parcelRequire("eSKWD");
var $kzY5l = parcelRequire("kzY5l");

var $fuZB8 = parcelRequire("fuZB8");

var $h6yBX = parcelRequire("h6yBX");
parcelRequire("er0Js");
var $dLzgL = parcelRequire("dLzgL");
const $844dd9667d105553$var$getEnvironment = ()=>{
    const env = "production";
    if (env === "production") return "production";
    if (env === "staging") return "staging";
    return "development";
};
const $844dd9667d105553$export$d76071d5de2774fc = "BXP-APP";
const $844dd9667d105553$export$86fbec116b87613f = ({ defaultPageModel: defaultPageModel })=>{
    const variant = defaultPageModel.content.variant || undefined;
    const routePath = defaultPageModel.content.route.content.path;
    const locale = defaultPageModel.locale || "en";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.StrictMode), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $47vbe.ConfigProvider), {
            config: {
                environment: $844dd9667d105553$var$getEnvironment()
            },
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9KLDf.StaticRouter), {
                location: routePath,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fuZB8.StaticLanguageProvider), {
                    language: locale,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                        value: {
                            eventContainer: "content",
                            path: routePath,
                            pageVariant: variant
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5atKW.RouteProvider), {
                            value: routePath,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eSKWD.OnetrustProvider), {
                                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $kzY5l.AnalyticsProvider), {
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $h6yBX.GlobalStyles), {}),
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $dLzgL.default), {
                                            model: defaultPageModel
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};

});
parcelRegister("9KLDf", function(module, exports) {

$parcel$export(module.exports, "StaticRouter", function () { return $066193a08d3f65b6$export$cac06da4d76d935b; });

var $iSvIT = parcelRequire("iSvIT");

var $9np2o = parcelRequire("9np2o");

var $7YcSr = parcelRequire("7YcSr");
parcelRequire("fisC4");
var $7YcSr = parcelRequire("7YcSr");
var $fisC4 = parcelRequire("fisC4");
var $iDzsU = parcelRequire("iDzsU");parcelRequire("7YcSr");
var $iDzsU = parcelRequire("iDzsU");
/**
 * A `<Router>` that may not navigate to any other location. This is useful
 * on the server where there is no stateful UI.
 */ function $066193a08d3f65b6$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/", future: future }) {
    if (typeof locationProp === "string") locationProp = (0, $iDzsU.parsePath)(locationProp);
    let action = (0, $9np2o.Action).Pop;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $066193a08d3f65b6$var$getStatelessNavigator();
    return /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        future: future,
        static: true
    });
}
/**
 * A Data Router that may not navigate to any other location. This is useful
 * on the server where there is no stateful UI.
 */ function $066193a08d3f65b6$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate = true, nonce: nonce }) {
    !(router && context) && (0, $9np2o.UNSAFE_invariant)(false);
    let dataRouterContext = {
        router: router,
        navigator: $066193a08d3f65b6$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = new Map();
    let hydrateScript = "";
    if (hydrate !== false) {
        let data = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $066193a08d3f65b6$var$serializeErrors(context.errors)
        };
        // Use JSON.parse here instead of embedding a raw JS object here to speed
        // up parsing on the client.  Dual-stringify is needed to ensure all quotes
        // are properly escaped in the resulting string.  See:
        //   https://v8.dev/blog/cost-of-javascript-2019#json
        let json = $066193a08d3f65b6$var$htmlEscape(JSON.stringify(JSON.stringify(data)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /*#__PURE__*/ $iSvIT.createElement($iSvIT.Fragment, null, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $iSvIT.createElement((0, $fisC4.UNSAFE_FetchersContext).Provider, {
        value: fetchersContext
    }, /*#__PURE__*/ $iSvIT.createElement((0, $fisC4.UNSAFE_ViewTransitionContext).Provider, {
        value: {
            isTransitioning: false
        }
    }, /*#__PURE__*/ $iSvIT.createElement((0, $7YcSr.Router), {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, /*#__PURE__*/ $iSvIT.createElement($066193a08d3f65b6$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /*#__PURE__*/ $iSvIT.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $066193a08d3f65b6$var$DataRoutes({ routes: routes, future: future, state: state }) {
    return (0, $7YcSr.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
function $066193a08d3f65b6$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // deserializeErrors in react-router-dom/index.tsx :)
        if ((0, $9np2o.isRouteErrorResponse)(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) // Do not serialize stack traces from SSR for security reasons
        serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $066193a08d3f65b6$var$getStatelessNavigator() {
    return {
        createHref: $066193a08d3f65b6$var$createHref,
        encodeLocation: $066193a08d3f65b6$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless ` + `environment. This error was probably triggered when you did a ` + `\`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless ` + `environment. This error was probably triggered when you did a ` + `\`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere ` + `in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless ` + `environment. This error was probably triggered when you did a ` + `\`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless ` + `environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless ` + `environment.`);
        }
    };
}
function $066193a08d3f65b6$export$3336b097a6fbc59a(routes, opts) {
    return (0, $9np2o.createStaticHandler)(routes, {
        ...opts,
        mapRouteProperties: (0, $7YcSr.UNSAFE_mapRouteProperties)
    });
}
function $066193a08d3f65b6$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = (0, $9np2o.UNSAFE_convertRoutesToDataRoutes)(routes, (0, $7YcSr.UNSAFE_mapRouteProperties), undefined, manifest);
    // Because our context matches may be from a framework-agnostic set of
    // routes passed to createStaticHandler(), we update them here with our
    // newly created/enhanced data routes
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v7_fetcherPersist: false,
                v7_normalizeFormMethod: false,
                v7_partialHydration: opts.future?.v7_partialHydration === true,
                v7_prependBasename: false,
                v7_relativeSplatPath: opts.future?.v7_relativeSplatPath === true,
                v7_skipActionErrorRevalidation: false
            };
        },
        get state () {
            return {
                historyAction: (0, $9np2o.Action).Pop,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: (0, $9np2o.IDLE_NAVIGATION),
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: new Map(),
                blockers: new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return undefined;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $066193a08d3f65b6$var$createHref,
        encodeLocation: $066193a08d3f65b6$var$encodeLocation,
        getFetcher () {
            return 0, $9np2o.IDLE_FETCHER;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return 0, $9np2o.IDLE_BLOCKER;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: new Map(),
        _internalActiveDeferreds: new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        }
    };
}
function $066193a08d3f65b6$var$createHref(to) {
    return typeof to === "string" ? to : (0, $iDzsU.createPath)(to);
}
function $066193a08d3f65b6$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : (0, $iDzsU.createPath)(to);
    // Treating this as a full URL will strip any trailing spaces so we need to
    // pre-encode them since they might be part of a matching splat param from
    // an ancestor route
    href = href.replace(/ $/, "%20");
    let encoded = $066193a08d3f65b6$var$ABSOLUTE_URL_REGEX.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
const $066193a08d3f65b6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
// This utility is based on https://github.com/zertosh/htmlescape
// License: https://github.com/zertosh/htmlescape/blob/0527ca7156a524d256101bb310a9f970f63078ad/LICENSE
const $066193a08d3f65b6$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $066193a08d3f65b6$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $066193a08d3f65b6$var$htmlEscape(str) {
    return str.replace($066193a08d3f65b6$var$ESCAPE_REGEX, (match)=>$066193a08d3f65b6$var$ESCAPE_LOOKUP[match]);
}

});


parcelRegister("791z3", function(module, exports) {
// @ts-nocheck

var $id59A = parcelRequire("id59A");
parcelRequire("d0igB");
var $apAtT = parcelRequire("apAtT");
parcelRequire("er0Js");
var $dLzgL = parcelRequire("dLzgL");
var $8Jm34 = parcelRequire("8Jm34");
var $3BpTc = parcelRequire("3BpTc");
var $1GNfM = parcelRequire("1GNfM");
var $78xz5 = parcelRequire("78xz5");
var $hz8fk = parcelRequire("hz8fk");
var $cVhUY = parcelRequire("cVhUY");
var $i4EQ3 = parcelRequire("i4EQ3");
var $bJVkU = parcelRequire("bJVkU");
var $7QvR0 = parcelRequire("7QvR0");
var $kLKPJ = parcelRequire("kLKPJ");
var $9mqJn = parcelRequire("9mqJn");
var $idgGb = parcelRequire("idgGb");
var $34Qin = parcelRequire("34Qin");
var $b5HjT = parcelRequire("b5HjT");
var $evXZH = parcelRequire("evXZH");
var $aj3L4 = parcelRequire("aj3L4");
var $iuY7Y = parcelRequire("iuY7Y");
var $i3M2D = parcelRequire("i3M2D");
var $bwS4k = parcelRequire("bwS4k");
var $eBpzU = parcelRequire("eBpzU");
var $cVC5c = parcelRequire("cVC5c");
var $6y9ML = parcelRequire("6y9ML");
var $1kwIV = parcelRequire("1kwIV");
var $giOvo = parcelRequire("giOvo");
var $jAZan = parcelRequire("jAZan");
var $hZ3E2 = parcelRequire("hZ3E2");
var $7kKxD = parcelRequire("7kKxD");
var $9dr3y = parcelRequire("9dr3y");
var $cSWGN = parcelRequire("cSWGN");
var $3mNTO = parcelRequire("3mNTO");
var $oHr7c = parcelRequire("oHr7c");
var $5EWJl = parcelRequire("5EWJl");
var $6nZh8 = parcelRequire("6nZh8");
var $4DJiw = parcelRequire("4DJiw");
var $2mYBG = parcelRequire("2mYBG");
var $UWh9s = parcelRequire("UWh9s");
var $hTq4R = parcelRequire("hTq4R");
var $igwoQ = parcelRequire("igwoQ");
var $afuz0 = parcelRequire("afuz0");
var $fwgmr = parcelRequire("fwgmr");
var $7eagl = parcelRequire("7eagl");
var $ll4BP = parcelRequire("ll4BP");
var $1GqBm = parcelRequire("1GqBm");
var $5KlTr = parcelRequire("5KlTr");
var $kFkUp = parcelRequire("kFkUp");
var $5I0gh = parcelRequire("5I0gh");
var $7YDse = parcelRequire("7YDse");
var $gWGNf = parcelRequire("gWGNf");
var $DUdTi = parcelRequire("DUdTi");
var $8vA78 = parcelRequire("8vA78");
var $arJrv = parcelRequire("arJrv");
var $fFqco = parcelRequire("fFqco");
var $6mKPH = parcelRequire("6mKPH");
var $3PNQw = parcelRequire("3PNQw");
const $258b47ceb3f10002$export$4a62ebed867ca755 = (0, $id59A.createBlueprint)({
    models: $apAtT,
    views: {
        page: (0, $dLzgL.default),
        uiAccordion: (0, $8Jm34.default),
        uiAddToSlackSection: (0, $3BpTc.UiAddToSlackSection),
        uiBlock: (0, $1GNfM.default),
        uiButton: (0, $78xz5.default),
        uiCaption: (0, $hz8fk.default),
        uiCard: (0, $cVhUY.default),
        uiCarousel: (0, $i4EQ3.default),
        uiColumn: (0, $bJVkU.default),
        uiContactForm: (0, $7QvR0.default),
        uiDownloadButton: (0, $kLKPJ.default),
        uiEmailSignup: (0, $9mqJn.default),
        uiFeatureSection: (0, $idgGb.default),
        uiFooterNav: (0, $34Qin.default),
        uiGuide: (0, $b5HjT.default),
        uiHeaderNav: (0, $evXZH.default),
        uiImage: (0, $aj3L4.default),
        uiImageSet: (0, $iuY7Y.default),
        uiIntegration: (0, $i3M2D.default),
        uiIntegrationSection: (0, $bwS4k.default),
        uiLink: (0, $eBpzU.default),
        uiLinkBlock: (0, $cVC5c.default),
        uiListCarousel: (0, $6y9ML.default),
        uiLoginContainer: (0, $1kwIV.default),
        uiMarkdown: (0, $giOvo.default),
        uiMarketoForm: (0, $jAZan.UiMarketoForm),
        uiModal: (0, $hZ3E2.default),
        uiNavBanner: (0, $7kKxD.default),
        uiNavImages: (0, $9dr3y.default),
        uiNavLink: (0, $cSWGN.default),
        uiPowerUp: (0, $3mNTO.default),
        uiPricingCalculator: (0, $oHr7c.default),
        uiPricingGrid: (0, $5EWJl.default),
        uiQuote: (0, $6nZh8.default),
        uiRecommendShare: (0, $4DJiw.default),
        uiRotatingItems: (0, $2mYBG.default),
        uiSection: (0, $UWh9s.default),
        uiSocialShare: (0, $hTq4R.default),
        uiSpacer: (0, $igwoQ.default),
        uiSplitSection: (0, $afuz0.default),
        uiStack: (0, $fwgmr.default),
        uiStatuspage: (0, $7eagl.default),
        uiStoryline: (0, $ll4BP.default),
        uiTab: (0, $1GqBm.default),
        uiTabPanel: (0, $5KlTr.default),
        uiTemplateGallery: (0, $kFkUp.default),
        uiTextBlock: (0, $5I0gh.default),
        uiTooltip: (0, $7YDse.default),
        uiTrelloBoard: (0, $gWGNf.default),
        uiValueProp: (0, $DUdTi.default),
        uiVariationContainer: (0, $8vA78.default),
        uiVideo: (0, $arJrv.default),
        uiVideoPlayer: (0, $fFqco.default),
        uiWebinarLink: (0, $6mKPH.default),
        uiWorkspacePicker: (0, $3PNQw.default)
    },
    contentful: {
        spaceId: "rz1oowkt5gyp"
    }
});

});
parcelRegister("id59A", function(module, exports) {

$parcel$export(module.exports, "createBlueprint", function () { return $d41d704ff0f6955e$export$c36843a66e0feeb9; });
function $d41d704ff0f6955e$export$c36843a66e0feeb9(blueprint) {
    return blueprint;
}

});

parcelRegister("d0igB", function(module, exports) {

$parcel$export(module.exports, "models", function () { return (parcelRequire("apAtT")); });

var $apAtT = parcelRequire("apAtT");
parcelRequire("7d0lE");

});
parcelRegister("apAtT", function(module, exports) {

var $bzbgb = parcelRequire("bzbgb");

var $75WaX = parcelRequire("75WaX");

var $8Cnfz = parcelRequire("8Cnfz");

var $3X98u = parcelRequire("3X98u");

var $9dZ43 = parcelRequire("9dZ43");

var $9PnOP = parcelRequire("9PnOP");

var $gAlaW = parcelRequire("gAlaW");

var $7lLfv = parcelRequire("7lLfv");

var $a8n8K = parcelRequire("a8n8K");

var $HzPHo = parcelRequire("HzPHo");

var $cTYxr = parcelRequire("cTYxr");

var $bCFh4 = parcelRequire("bCFh4");

var $eEFTY = parcelRequire("eEFTY");

var $lnVLJ = parcelRequire("lnVLJ");

var $NdtUV = parcelRequire("NdtUV");

var $bMPjs = parcelRequire("bMPjs");

var $4o9VJ = parcelRequire("4o9VJ");

var $jIiwz = parcelRequire("jIiwz");

var $1xD3G = parcelRequire("1xD3G");

var $4vgjx = parcelRequire("4vgjx");

var $8SCwm = parcelRequire("8SCwm");

var $1tosp = parcelRequire("1tosp");

var $14nS1 = parcelRequire("14nS1");

var $1F5ux = parcelRequire("1F5ux");

var $b1Gz9 = parcelRequire("b1Gz9");

var $kccpf = parcelRequire("kccpf");

var $iodlq = parcelRequire("iodlq");

var $iV52U = parcelRequire("iV52U");

var $2vu9w = parcelRequire("2vu9w");

var $hiww2 = parcelRequire("hiww2");

var $8rJvC = parcelRequire("8rJvC");

var $7xW5g = parcelRequire("7xW5g");

var $3F0rb = parcelRequire("3F0rb");

var $03kyV = parcelRequire("03kyV");

var $9ly95 = parcelRequire("9ly95");

var $dEH6b = parcelRequire("dEH6b");

var $880n0 = parcelRequire("880n0");

var $hCiMM = parcelRequire("hCiMM");

var $fEU0B = parcelRequire("fEU0B");

var $6fdKk = parcelRequire("6fdKk");

var $3FUFs = parcelRequire("3FUFs");

var $823Lo = parcelRequire("823Lo");

var $i5AWx = parcelRequire("i5AWx");

var $9vcm2 = parcelRequire("9vcm2");

var $4FAtX = parcelRequire("4FAtX");

var $27Kka = parcelRequire("27Kka");

var $6JW3a = parcelRequire("6JW3a");

var $6Hre7 = parcelRequire("6Hre7");

var $gPQkE = parcelRequire("gPQkE");

var $lyQai = parcelRequire("lyQai");

var $8dEGA = parcelRequire("8dEGA");

var $fe2CQ = parcelRequire("fe2CQ");

var $j0aXe = parcelRequire("j0aXe");

var $kMHk9 = parcelRequire("kMHk9");

var $8bBEQ = parcelRequire("8bBEQ");

var $5Bq8e = parcelRequire("5Bq8e");

var $7KbAq = parcelRequire("7KbAq");

var $dCP1B = parcelRequire("dCP1B");

var $4Ca3j = parcelRequire("4Ca3j");

var $3f5N3 = parcelRequire("3f5N3");

var $55U2E = parcelRequire("55U2E");

var $gsrbH = parcelRequire("gsrbH");

var $5ZXkW = parcelRequire("5ZXkW");

var $1eN9m = parcelRequire("1eN9m");

var $3cgcI = parcelRequire("3cgcI");

var $lOx88 = parcelRequire("lOx88");

var $6lRzW = parcelRequire("6lRzW");

var $ls3bA = parcelRequire("ls3bA");

var $fwZpW = parcelRequire("fwZpW");

var $ed5st = parcelRequire("ed5st");

var $hZFwp = parcelRequire("hZFwp");

var $kqMZQ = parcelRequire("kqMZQ");

var $hcN58 = parcelRequire("hcN58");

var $1R3JI = parcelRequire("1R3JI");

var $jzXLL = parcelRequire("jzXLL");

var $jnmFp = parcelRequire("jnmFp");

var $6KLA8 = parcelRequire("6KLA8");

var $bJmvd = parcelRequire("bJmvd");

var $bfmTC = parcelRequire("bfmTC");

var $bhwOo = parcelRequire("bhwOo");

var $asWTs = parcelRequire("asWTs");
$parcel$exportWildcard(module.exports, $bzbgb);
$parcel$exportWildcard(module.exports, $75WaX);
$parcel$exportWildcard(module.exports, $8Cnfz);
$parcel$exportWildcard(module.exports, $3X98u);
$parcel$exportWildcard(module.exports, $9dZ43);
$parcel$exportWildcard(module.exports, $9PnOP);
$parcel$exportWildcard(module.exports, $gAlaW);
$parcel$exportWildcard(module.exports, $7lLfv);
$parcel$exportWildcard(module.exports, $a8n8K);
$parcel$exportWildcard(module.exports, $HzPHo);
$parcel$exportWildcard(module.exports, $cTYxr);
$parcel$exportWildcard(module.exports, $bCFh4);
$parcel$exportWildcard(module.exports, $eEFTY);
$parcel$exportWildcard(module.exports, $lnVLJ);
$parcel$exportWildcard(module.exports, $NdtUV);
$parcel$exportWildcard(module.exports, $bMPjs);
$parcel$exportWildcard(module.exports, $4o9VJ);
$parcel$exportWildcard(module.exports, $jIiwz);
$parcel$exportWildcard(module.exports, $1xD3G);
$parcel$exportWildcard(module.exports, $4vgjx);
$parcel$exportWildcard(module.exports, $8SCwm);
$parcel$exportWildcard(module.exports, $1tosp);
$parcel$exportWildcard(module.exports, $14nS1);
$parcel$exportWildcard(module.exports, $1F5ux);
$parcel$exportWildcard(module.exports, $b1Gz9);
$parcel$exportWildcard(module.exports, $kccpf);
$parcel$exportWildcard(module.exports, $iodlq);
$parcel$exportWildcard(module.exports, $iV52U);
$parcel$exportWildcard(module.exports, $2vu9w);
$parcel$exportWildcard(module.exports, $hiww2);
$parcel$exportWildcard(module.exports, $8rJvC);
$parcel$exportWildcard(module.exports, $7xW5g);
$parcel$exportWildcard(module.exports, $3F0rb);
$parcel$exportWildcard(module.exports, $03kyV);
$parcel$exportWildcard(module.exports, $9ly95);
$parcel$exportWildcard(module.exports, $dEH6b);
$parcel$exportWildcard(module.exports, $880n0);
$parcel$exportWildcard(module.exports, $hCiMM);
$parcel$exportWildcard(module.exports, $fEU0B);
$parcel$exportWildcard(module.exports, $6fdKk);
$parcel$exportWildcard(module.exports, $3FUFs);
$parcel$exportWildcard(module.exports, $823Lo);
$parcel$exportWildcard(module.exports, $i5AWx);
$parcel$exportWildcard(module.exports, $9vcm2);
$parcel$exportWildcard(module.exports, $4FAtX);
$parcel$exportWildcard(module.exports, $27Kka);
$parcel$exportWildcard(module.exports, $6JW3a);
$parcel$exportWildcard(module.exports, $6Hre7);
$parcel$exportWildcard(module.exports, $gPQkE);
$parcel$exportWildcard(module.exports, $lyQai);
$parcel$exportWildcard(module.exports, $8dEGA);
$parcel$exportWildcard(module.exports, $fe2CQ);
$parcel$exportWildcard(module.exports, $j0aXe);
$parcel$exportWildcard(module.exports, $kMHk9);
$parcel$exportWildcard(module.exports, $8bBEQ);
$parcel$exportWildcard(module.exports, $5Bq8e);
$parcel$exportWildcard(module.exports, $7KbAq);
$parcel$exportWildcard(module.exports, $dCP1B);
$parcel$exportWildcard(module.exports, $4Ca3j);
$parcel$exportWildcard(module.exports, $3f5N3);
$parcel$exportWildcard(module.exports, $55U2E);
$parcel$exportWildcard(module.exports, $gsrbH);
$parcel$exportWildcard(module.exports, $5ZXkW);
$parcel$exportWildcard(module.exports, $1eN9m);
$parcel$exportWildcard(module.exports, $3cgcI);
$parcel$exportWildcard(module.exports, $lOx88);
$parcel$exportWildcard(module.exports, $6lRzW);
$parcel$exportWildcard(module.exports, $ls3bA);
$parcel$exportWildcard(module.exports, $fwZpW);
$parcel$exportWildcard(module.exports, $ed5st);
$parcel$exportWildcard(module.exports, $hZFwp);
$parcel$exportWildcard(module.exports, $kqMZQ);
$parcel$exportWildcard(module.exports, $hcN58);
$parcel$exportWildcard(module.exports, $1R3JI);
$parcel$exportWildcard(module.exports, $jzXLL);
$parcel$exportWildcard(module.exports, $jnmFp);
$parcel$exportWildcard(module.exports, $6KLA8);
$parcel$exportWildcard(module.exports, $bJmvd);
$parcel$exportWildcard(module.exports, $bfmTC);
$parcel$exportWildcard(module.exports, $bhwOo);
$parcel$exportWildcard(module.exports, $asWTs);

});
parcelRegister("bzbgb", function(module, exports) {

$parcel$export(module.exports, "caption", function () { return $229b5ad81bb8eb15$export$8e3c2dfdc4f0453d; });

var $9ZXdX = parcelRequire("9ZXdX");
const $229b5ad81bb8eb15$export$8e3c2dfdc4f0453d = (0, $9ZXdX.model)({
    name: "Caption",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        content: {
            name: "Content",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiBlock"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        caption: {
            name: "Caption",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});
parcelRegister("9ZXdX", function(module, exports) {

$parcel$export(module.exports, "model", function () { return $7477c03f59aabee5$export$39a8f6bed6e94390; });
function $7477c03f59aabee5$export$39a8f6bed6e94390(definition) {
    return Object.freeze(definition);
}

});


parcelRegister("75WaX", function(module, exports) {

$parcel$export(module.exports, "integrationCategory", function () { return $2e5fa7233ddbd896$export$9700918073c579e2; });

var $9ZXdX = parcelRequire("9ZXdX");
const $2e5fa7233ddbd896$export$9700918073c579e2 = (0, $9ZXdX.model)({
    name: "Integration Category",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [
                {
                    unique: true
                }
            ],
            disabled: false,
            omitted: false
        },
        route: {
            name: "Route",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("8Cnfz", function(module, exports) {

$parcel$export(module.exports, "linkButtonTheme", function () { return $6cc3e06c4da1fe88$export$35956d091cfa87d2; });

var $9ZXdX = parcelRequire("9ZXdX");
const $6cc3e06c4da1fe88$export$35956d091cfa87d2 = (0, $9ZXdX.model)({
    name: "LinkButton theme",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Creative",
                        "Light",
                        "Muted",
                        "Neutral",
                        "Primary",
                        "Secondary",
                        "Purple",
                        "Magenta",
                        "Teal",
                        "Red",
                        "Yellow",
                        "Green"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        style: {
            name: "Style",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Outline",
                        "No padding"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        prominence: {
            name: "Prominence",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Elevated",
                        "Reduced"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        spacing: {
            name: "Spacing",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Left",
                        "Right",
                        "LeftRight",
                        "LeftBottom",
                        "RightBottom",
                        "LeftRightBottom"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        decorator: {
            name: "Decorator",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Arrow",
                        "Play"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        isBlock: {
            name: "Is Block",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("3X98u", function(module, exports) {

$parcel$export(module.exports, "page", function () { return $be64b8dfc849859f$export$523fb3936f49e028; });

var $9ZXdX = parcelRequire("9ZXdX");
const $be64b8dfc849859f$export$523fb3936f49e028 = (0, $9ZXdX.model)({
    name: "Page",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        route: {
            name: "Route",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        variant: {
            name: "Variant",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    unique: true
                }
            ],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        metaDescription: {
            name: "Meta Description",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        metaImage: {
            name: "Meta Image",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        canonical: {
            name: "Canonical",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        header: {
            name: "Header",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiHeaderNav",
                        "uiVariationContainer"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        sections: {
            name: "Sections",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiAddToSlackSection",
                            "uiFeatureSection",
                            "uiGuide",
                            "uiIntegrationSection",
                            "uiNavImages",
                            "uiRotatingItems",
                            "uiSection",
                            "uiSectionGroup",
                            "uiSpacer",
                            "uiSplitSection",
                            "uiStoryline",
                            "uiTabPanel",
                            "uiTemplateGallery",
                            "uiVariationContainer",
                            "uiAnimatedHeroSection"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        footer: {
            name: "Footer",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiFooterNav",
                        "uiFooterNavBasic"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        pageBackground: {
            name: "Page background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        noIndexTag: {
            name: "Hide page from search engines (noindex)",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        noFollowTag: {
            name: "Exclude from search rankings (nofollow)",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("9dZ43", function(module, exports) {

$parcel$export(module.exports, "route", function () { return $774a71bd0734b588$export$4cb887bfde2d34ca; });

var $9ZXdX = parcelRequire("9ZXdX");
const $774a71bd0734b588$export$4cb887bfde2d34ca = (0, $9ZXdX.model)({
    name: "Route",
    fields: {
        path: {
            name: "Path",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    unique: true
                }
            ],
            disabled: false,
            omitted: false
        },
        linkTitle: {
            name: "Link title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        linkImage: {
            name: "Link image",
            type: "Link",
            localized: true,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        }
    },
    description: "",
    displayField: "path"
});

});

parcelRegister("9PnOP", function(module, exports) {

$parcel$export(module.exports, "trelloTemplate", function () { return $a253959971be911d$export$2bbe616fdc768acd; });

var $9ZXdX = parcelRequire("9ZXdX");
const $a253959971be911d$export$2bbe616fdc768acd = (0, $9ZXdX.model)({
    name: "Trello Template",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "URL",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    regexp: {
                        pattern: "^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-/]))?$",
                        flags: null
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        avatar: {
            name: "Avatar",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        avatarPadding: {
            name: "Avatar padding",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        attribution: {
            name: "Attribution",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        backgroundImage: {
            name: "Background Image",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiImage"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("gAlaW", function(module, exports) {

$parcel$export(module.exports, "uiAccordion", function () { return $c50f68f474084029$export$7710f316487e26c1; });

var $9ZXdX = parcelRequire("9ZXdX");
const $c50f68f474084029$export$7710f316487e26c1 = (0, $9ZXdX.model)({
    name: "UI Accordion",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        items: {
            name: "Items",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiAccordionItem"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "List",
                        "Grid"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("7lLfv", function(module, exports) {

$parcel$export(module.exports, "uiAccordionItem", function () { return $1f575efae7a42004$export$2ca9aa728041599f; });

var $9ZXdX = parcelRequire("9ZXdX");
const $1f575efae7a42004$export$2ca9aa728041599f = (0, $9ZXdX.model)({
    name: "UI Accordion Item",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        ariaLabel: {
            name: "Aria Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        content: {
            name: "Content",
            type: "Text",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("a8n8K", function(module, exports) {

$parcel$export(module.exports, "uiAddToSlackSection", function () { return $e9e75c8cbe092ce8$export$24ab8a760ec3b8fd; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e9e75c8cbe092ce8$export$24ab8a760ec3b8fd = (0, $9ZXdX.model)({
    name: "UI Add to Slack Section",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "Button Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    nodes: {}
                },
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [],
                    message: "Nodes are not allowed"
                }
            ],
            disabled: false,
            omitted: false
        },
        loginText: {
            name: "Login Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        selectTeamText: {
            name: "Select Team Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        noTeamText: {
            name: "No Team Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("HzPHo", function(module, exports) {

$parcel$export(module.exports, "uiAnimatedHeroSection", function () { return $4d251aa4deba8cac$export$81160bddecb67601; });

var $9ZXdX = parcelRequire("9ZXdX");
const $4d251aa4deba8cac$export$81160bddecb67601 = (0, $9ZXdX.model)({
    name: "UI Animated Hero Section",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        labels: {
            name: "Labels",
            type: "Array",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Symbol",
                validations: []
            }
        },
        images: {
            name: "Images",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiRotatingImages"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        content: {
            name: "Content",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, and quote nodes are allowed"
                },
                {
                    nodes: {}
                }
            ],
            disabled: false,
            omitted: false
        },
        callsToAction: {
            name: "Calls to action",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiButton",
                            "uiEmailSignup",
                            "uiModal"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("cTYxr", function(module, exports) {

$parcel$export(module.exports, "uiBlock", function () { return $1cce00a9df861410$export$5f2ffa1792d0569e; });

var $9ZXdX = parcelRequire("9ZXdX");
const $1cce00a9df861410$export$5f2ffa1792d0569e = (0, $9ZXdX.model)({
    name: "UI Block",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        children: {
            name: "Children",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiButton",
                            "uiDownloadButton",
                            "uiEmailSignup",
                            "uiImage",
                            "uiLoginContainer",
                            "uiMarkdown",
                            "uiMarketoForm",
                            "uiModal",
                            "uiQuote",
                            "uiTextBlock",
                            "uiTrelloBoard",
                            "uiValueProp",
                            "uiVideo",
                            "uiVideoPlayer",
                            "uiWebinarLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        fullHeight: {
            name: "Full Height",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        shadow: {
            name: "Shadow",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        border: {
            name: "Border",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        roundedCorners: {
            name: "Rounded Corners",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Small",
                        "Medium",
                        "Large"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        orientation: {
            name: "Orientation",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "vertical",
                        "horizontal"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        spacing: {
            name: "Spacing",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "tight",
                        "compact",
                        "cozy",
                        "comfortable",
                        "outerspace"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        verticalAlign: {
            name: "Vertical Align",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Top",
                        "Middle",
                        "Bottom"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Highlighted",
                        "Medium Padding",
                        "Neutral Border",
                        "No Padding",
                        "Speech Bubble Left",
                        "Speech Bubble Right",
                        "Top Blue Stripe"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("bCFh4", function(module, exports) {

$parcel$export(module.exports, "uiButton", function () { return $8c49b901b93616a1$export$36a5b2891ceb6ddd; });

var $9ZXdX = parcelRequire("9ZXdX");
const $8c49b901b93616a1$export$36a5b2891ceb6ddd = (0, $9ZXdX.model)({
    name: "UI Button",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        ariaLabel: {
            name: "Aria Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "URL",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonTheme: {
            name: "Button theme",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "linkButtonTheme"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("eEFTY", function(module, exports) {

$parcel$export(module.exports, "uiCallout", function () { return $118a09781a760e25$export$8755852c35baf99f; });

var $9ZXdX = parcelRequire("9ZXdX");
const $118a09781a760e25$export$8755852c35baf99f = (0, $9ZXdX.model)({
    name: "UI Callout",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        media: {
            name: "Media",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiImage",
                        "uiVideo",
                        "uiVideoPlayer"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        mediaOnRight: {
            name: "Media on right",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        icon: {
            name: "Icon",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiIcon"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        theme: {
            name: "Theme",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Blue",
                        "Green",
                        "Magenta",
                        "Purple",
                        "Red",
                        "Teal",
                        "Yellow"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        heading: {
            name: "Heading",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("lnVLJ", function(module, exports) {

$parcel$export(module.exports, "uiCaption", function () { return $a52e926e93c68789$export$b89473cc47d0dd47; });

var $9ZXdX = parcelRequire("9ZXdX");
const $a52e926e93c68789$export$b89473cc47d0dd47 = (0, $9ZXdX.model)({
    name: "UI Caption",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        caption: {
            name: "Caption",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "caption"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "Overlay 1"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("NdtUV", function(module, exports) {

$parcel$export(module.exports, "uiCard", function () { return $9c30bf58a14a4cb1$export$976297bdedb44589; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9c30bf58a14a4cb1$export$976297bdedb44589 = (0, $9ZXdX.model)({
    name: "UI Card",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        content: {
            name: "Content",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        route: {
            name: "Route",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        linkText: {
            name: "Link Text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        linkAppearance: {
            name: "Link Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Creative",
                        "Light",
                        "Muted",
                        "Neutral",
                        "Primary",
                        "Secondary"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        decoration: {
            name: "Decoration",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("bMPjs", function(module, exports) {

$parcel$export(module.exports, "uiCarousel", function () { return $76f411134731fe73$export$750f2248bd87c031; });

var $9ZXdX = parcelRequire("9ZXdX");
const $76f411134731fe73$export$750f2248bd87c031 = (0, $9ZXdX.model)({
    name: "UI Carousel",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        blocks: {
            name: "Blocks",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiBlock",
                            "uiQuote",
                            "uiSocialProof",
                            "uiStack"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        arrows: {
            name: "Arrows on desktop",
            type: "Boolean",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        dots: {
            name: "Dots on desktop",
            type: "Boolean",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        dotLabel: {
            name: "Dot Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Dot"
            },
            disabled: false,
            omitted: false
        },
        prevArrowLabel: {
            name: "Prev Arrow Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Previous"
            },
            disabled: false,
            omitted: false
        },
        nextArrowLabel: {
            name: "Next Arrow Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Next"
            },
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("4o9VJ", function(module, exports) {

$parcel$export(module.exports, "uiColumn", function () { return $8dd2cb327e1160ab$export$32ca5bd4132cfb13; });

var $9ZXdX = parcelRequire("9ZXdX");
const $8dd2cb327e1160ab$export$32ca5bd4132cfb13 = (0, $9ZXdX.model)({
    name: "UI Column",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        elementId: {
            name: "Element id",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        blocks: {
            name: "Blocks",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiAccordion",
                            "uiBlock",
                            "uiButton",
                            "uiCallout",
                            "uiCaption",
                            "uiCard",
                            "uiCarousel",
                            "uiContactForm",
                            "uiDownloadButton",
                            "uiEmailSignup",
                            "uiHeading",
                            "uiImage",
                            "uiImageSet",
                            "uiLinkBlock",
                            "uiListCarousel",
                            "uiLoginContainer",
                            "uiLoginSignupForm",
                            "uiMarkdown",
                            "uiMarketoForm",
                            "uiModal",
                            "uiNavImages",
                            "uiPowerUp",
                            "uiPricingCalculator",
                            "uiPricingComparisonTable",
                            "uiPricingGrid",
                            "uiQuote",
                            "uiRecommendShare",
                            "uiRotatingImages",
                            "uiSocialProof",
                            "uiSocialShare",
                            "uiSpacer",
                            "uiStack",
                            "uiStatuspage",
                            "uiTextBlock",
                            "uiTooltip",
                            "uiTrelloBoard",
                            "uiValueProp",
                            "uiVideo",
                            "uiVideoPlayer",
                            "uiWebinarLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        properties: {
            name: "Properties",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("jIiwz", function(module, exports) {

$parcel$export(module.exports, "uiContactForm", function () { return $6e6e31924ba8ef65$export$7d6a3a35b3f702b8; });

var $9ZXdX = parcelRequire("9ZXdX");
const $6e6e31924ba8ef65$export$7d6a3a35b3f702b8 = (0, $9ZXdX.model)({
    name: "UI Contact Form",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        button: {
            name: "Button",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiButton"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("1xD3G", function(module, exports) {

$parcel$export(module.exports, "uiDownloadButton", function () { return $90fdb9a34c3feb4e$export$67ecda709c56c062; });

var $9ZXdX = parcelRequire("9ZXdX");
const $90fdb9a34c3feb4e$export$67ecda709c56c062 = (0, $9ZXdX.model)({
    name: "UI Download Button",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        mediaAsset: {
            name: "Media Asset",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkMimetypeGroup: [
                        "attachment",
                        "presentation",
                        "spreadsheet",
                        "pdfdocument",
                        "archive"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        buttonTheme: {
            name: "Button theme",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "linkButtonTheme"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("4vgjx", function(module, exports) {

$parcel$export(module.exports, "uiEmailSignup", function () { return $34ecbc2313e3cf84$export$21810a6c2a9a31e8; });

var $9ZXdX = parcelRequire("9ZXdX");
const $34ecbc2313e3cf84$export$21810a6c2a9a31e8 = (0, $9ZXdX.model)({
    name: "UI Email Signup",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        hideEmailInput: {
            name: "Hide email input?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        emailLabel: {
            name: "Email label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "Button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonLabel: {
            name: "Button label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        theme: {
            name: "Theme",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "linkButtonTheme"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        constrainInputWidth: {
            name: "Constrain input width",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("8SCwm", function(module, exports) {

$parcel$export(module.exports, "uiFeatureSection", function () { return $73c93cf0d179731f$export$b1746d73aeeab97a; });

var $9ZXdX = parcelRequire("9ZXdX");
const $73c93cf0d179731f$export$b1746d73aeeab97a = (0, $9ZXdX.model)({
    name: "UI Feature Section",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "7/5",
                        "5/7",
                        "6/1/5",
                        "5/1/6",
                        "8/4",
                        "4/8",
                        "7/1/4",
                        "4/1/7",
                        "6/6"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        horizontalOrientation: {
            name: "Horizontal Orientation",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Image right",
                        "Image left"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        verticalOrientation: {
            name: "Vertical Orientation",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Image top",
                        "Image bottom"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        eyebrow: {
            name: "Eyebrow",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        horizontalRule: {
            name: "Horizontal Rule",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        bodyCopy: {
            name: "Body Copy",
            type: "Text",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        media: {
            name: "Media",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiImage",
                        "uiVideo",
                        "uiVideoPlayer"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        callsToAction: {
            name: "Calls to Action",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiAccordion",
                            "uiButton",
                            "uiLink",
                            "uiLoginContainer"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("1tosp", function(module, exports) {

$parcel$export(module.exports, "uiFooterNav", function () { return $9ee5adcc605cf342$export$a164c70a35c43091; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9ee5adcc605cf342$export$a164c70a35c43091 = (0, $9ZXdX.model)({
    name: "UI Footer Nav",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        logInText: {
            name: "Log in text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Log In"
            },
            disabled: false,
            omitted: false
        },
        tabs: {
            name: "Tabs",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiNavLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        subNavLinks: {
            name: "Sub Nav Links",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        selectLanguageLabel: {
            name: "Select language label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Select a language"
            },
            disabled: false,
            omitted: false
        },
        hideLanguageSelector: {
            name: "Hide language selector",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        useEyebrowLogo: {
            name: "Use eyebrow logo",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("14nS1", function(module, exports) {

$parcel$export(module.exports, "uiFooterNavBasic", function () { return $2640b8d36896c8b9$export$bfba8e419380df1c; });

var $9ZXdX = parcelRequire("9ZXdX");
const $2640b8d36896c8b9$export$bfba8e419380df1c = (0, $9ZXdX.model)({
    name: "UI Footer Nav Basic",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        selectLanguageLabel: {
            name: "Select language label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            defaultValue: {
                "en-US": "Select a language"
            },
            disabled: false,
            omitted: false
        },
        tagline: {
            name: "Tagline",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code",
                        "superscript",
                        "subscript"
                    ],
                    message: "Only bold, italic, underline, code, superscript, and subscript marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "hr",
                        "embedded-entry-block",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 3, heading 4, heading 5, heading 6, horizontal rule, block entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        links: {
            name: "Links",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        isFullWidth: {
            name: "Full width?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("1F5ux", function(module, exports) {

$parcel$export(module.exports, "uiGuide", function () { return $d8a9312fa874799b$export$a54a2ee0d437db07; });

var $9ZXdX = parcelRequire("9ZXdX");
const $d8a9312fa874799b$export$a54a2ee0d437db07 = (0, $9ZXdX.model)({
    name: "UI Guide",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        chapters: {
            name: "Chapters",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiGuideChapter"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        nextChapterLabel: {
            name: "Next Chapter Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        numberedChapters: {
            name: "Numbered Chapters",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        headerOffset: {
            name: "Header Offset",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("b1Gz9", function(module, exports) {

$parcel$export(module.exports, "uiGuideChapter", function () { return $e2316f67eceb48b3$export$8f1812545c8f2410; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e2316f67eceb48b3$export$8f1812545c8f2410 = (0, $9ZXdX.model)({
    name: "UI Guide Chapter",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        route: {
            name: "Route",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        category: {
            name: "Category",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        sections: {
            name: "Sections",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiSection"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        subSections: {
            name: "Sub Sections",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiSection"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("kccpf", function(module, exports) {

$parcel$export(module.exports, "uiHeaderNav", function () { return $58948cb58b7e368b$export$60bdcbf891e8dde1; });

var $9ZXdX = parcelRequire("9ZXdX");
const $58948cb58b7e368b$export$60bdcbf891e8dde1 = (0, $9ZXdX.model)({
    name: "UI Header Nav",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        tabs: {
            name: "Tabs",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiHeaderNavTab",
                            "uiLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        goToBoardsText: {
            name: "Go to boards text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        logInText: {
            name: "Log in text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        signUpText: {
            name: "Sign up text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        useAtlassianAccess: {
            name: "Use Atlassian Access for sign up?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        goBackText: {
            name: "Go back text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        progressBar: {
            name: "Progress bar",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        startTransparent: {
            name: "Start transparent",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        skipToMainContent: {
            name: "Skip to main content",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Skip to main content"
            },
            disabled: false,
            omitted: false
        },
        navigationLabel: {
            name: "Navigation label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Navigation"
            },
            disabled: false,
            omitted: false
        },
        progressLabel: {
            name: "Progress label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Reading progress"
            },
            disabled: false,
            omitted: false
        },
        useEyebrowLogo: {
            name: "Use eyebrow logo",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("iodlq", function(module, exports) {

$parcel$export(module.exports, "uiHeaderNavTab", function () { return $59865cfc23794afd$export$618d161c0cbf7e19; });

var $9ZXdX = parcelRequire("9ZXdX");
const $59865cfc23794afd$export$618d161c0cbf7e19 = (0, $9ZXdX.model)({
    name: "UI Header Nav Tab",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        primaryTitle: {
            name: "Primary title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        primaryLinks: {
            name: "Primary links",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiNavLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        primaryBanner: {
            name: "Primary banner",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiNavBanner"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        primaryCta: {
            name: "Primary CTA",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        secondaryTitle: {
            name: "Secondary title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        secondaryDescription: {
            name: "Secondary description",
            type: "Text",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        secondaryBlogArticle: {
            name: "Secondary blog article",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiNavBlogArticle"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        secondaryLinks: {
            name: "Secondary links",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiNavLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        secondaryBanners: {
            name: "Secondary banners",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiNavBanner"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        secondaryCta: {
            name: "Secondary CTA",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("iV52U", function(module, exports) {

$parcel$export(module.exports, "uiHeading", function () { return $e5adeeba693d50c5$export$705964f417755732; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e5adeeba693d50c5$export$705964f417755732 = (0, $9ZXdX.model)({
    name: "UI Heading",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        headingLevel: {
            name: "Heading level",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6"
                    ]
                }
            ],
            defaultValue: {
                "en-US": "h1"
            },
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "Add h1-h6 and adjust level and appearance separately",
    displayField: "entryTitle"
});

});

parcelRegister("2vu9w", function(module, exports) {

$parcel$export(module.exports, "uiIcon", function () { return $f873180aa093acc9$export$3ce8277576dc8eb2; });

var $9ZXdX = parcelRequire("9ZXdX");
const $f873180aa093acc9$export$3ce8277576dc8eb2 = (0, $9ZXdX.model)({
    name: "UI Icon",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        icon: {
            name: "Icon",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    unique: true
                },
                {
                    in: [
                        "AddOn",
                        "Automation",
                        "Badge",
                        "BoardDuplicate",
                        "Bolt",
                        "Book",
                        "Bookmark",
                        "Box",
                        "Briefcase",
                        "BrowserCode",
                        "Building",
                        "ButlerAutomation",
                        "ButlerAutomationHead",
                        "Calendar",
                        "CalendarDate",
                        "Checklists",
                        "Checkmark",
                        "Clock",
                        "Cloud",
                        "DiagramNetwork",
                        "DiagramVenn",
                        "DollarSignCircle",
                        "Email",
                        "Filter",
                        "Flag",
                        "GitMerge",
                        "GlobeNetwork",
                        "GlobeNetworkLocation",
                        "Group",
                        "Headset",
                        "InfoCircle",
                        "Leaf",
                        "Lego",
                        "Lightbulb",
                        "MagicWand",
                        "MagnifyingGlass",
                        "Map",
                        "Megaphone",
                        "New",
                        "News",
                        "PageMultiple",
                        "PartyPopper",
                        "Pencil",
                        "PencilWriting",
                        "Process",
                        "RocketInclined",
                        "SecurityCheckmark",
                        "SmileyFace",
                        "Socket",
                        "Star",
                        "TrafficCone",
                        "Tray",
                        "TrelloCalendar",
                        "TrelloCard",
                        "TrelloCardTemplates",
                        "TrelloLabels",
                        "TrelloWorkspaces",
                        "Trophy",
                        "UserSettings",
                        "ViewCalendar",
                        "ViewTimeline"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("hiww2", function(module, exports) {

$parcel$export(module.exports, "uiImage", function () { return $1e9d8f250a1e240f$export$aafab3cc6ec04ff0; });

var $9ZXdX = parcelRequire("9ZXdX");
const $1e9d8f250a1e240f$export$aafab3cc6ec04ff0 = (0, $9ZXdX.model)({
    name: "UI Image",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        image: {
            name: "Image",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        altText: {
            name: "Alt text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        decorative: {
            name: "Decorative",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("8rJvC", function(module, exports) {

$parcel$export(module.exports, "uiImageSet", function () { return $11e86c00e4033d00$export$4cffe6bc4e2f6e02; });

var $9ZXdX = parcelRequire("9ZXdX");
const $11e86c00e4033d00$export$4cffe6bc4e2f6e02 = (0, $9ZXdX.model)({
    name: "UI Image Set",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        images: {
            name: "Images",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiImage"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        justified: {
            name: "Justified",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("7xW5g", function(module, exports) {

$parcel$export(module.exports, "uiIntegration", function () { return $3466db190af5ad7d$export$dcb5ef22d22fcde5; });

var $9ZXdX = parcelRequire("9ZXdX");
const $3466db190af5ad7d$export$dcb5ef22d22fcde5 = (0, $9ZXdX.model)({
    name: "UI Integration",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        featuredImage: {
            name: "Featured image",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        logo: {
            name: "Logo",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "Button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonUrl: {
            name: "Button URL",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        categories: {
            name: "Categories",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "integrationCategory"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("3F0rb", function(module, exports) {

$parcel$export(module.exports, "uiIntegrationSection", function () { return $e151db37d1f08ac1$export$5c00ee625c1e16c9; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e151db37d1f08ac1$export$5c00ee625c1e16c9 = (0, $9ZXdX.model)({
    name: "UI Integration Section",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        searchLabel: {
            name: "Search label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        filterByText: {
            name: "Filter by text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        ctaText: {
            name: "CTA text",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        featuredIntegrationsTitle: {
            name: "Featured integrations title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        featuredIntegrations: {
            name: "Featured integrations",
            type: "Array",
            localized: false,
            required: false,
            validations: [
                {
                    size: {
                        min: 3,
                        max: 3
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiIntegration"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        allIntegrationsRoute: {
            name: "All integrations route",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        allIntegrationsTitle: {
            name: "All integrations title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        viewAllButtonText: {
            name: "View all button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        viewLessButtonText: {
            name: "View less button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        searchResultsHeading: {
            name: "Search results heading",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        noSearchResults: {
            name: "No search results",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "table",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, table, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        allIntegrations: {
            name: "All integrations",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiIntegration"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("03kyV", function(module, exports) {

$parcel$export(module.exports, "uiLink", function () { return $56f7cc891cb1e53b$export$d68dcdbea9a76538; });

var $9ZXdX = parcelRequire("9ZXdX");
const $56f7cc891cb1e53b$export$d68dcdbea9a76538 = (0, $9ZXdX.model)({
    name: "UI Link",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        ariaLabel: {
            name: "Aria Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "URL",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("9ly95", function(module, exports) {

$parcel$export(module.exports, "uiLinkBlock", function () { return $248bcd0dc57eb8e5$export$c8257dd2fdfd2311; });

var $9ZXdX = parcelRequire("9ZXdX");
const $248bcd0dc57eb8e5$export$c8257dd2fdfd2311 = (0, $9ZXdX.model)({
    name: "UI Link Block",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "Url",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        block: {
            name: "Block",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiBlock",
                        "uiCaption"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        lift: {
            name: "Lift",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        lighten: {
            name: "Lighten",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "Makes a whole block of UI clickable",
    displayField: "entryTitle"
});

});

parcelRegister("dEH6b", function(module, exports) {

$parcel$export(module.exports, "uiListCarousel", function () { return $9972b10652d03098$export$f67bccc9f629c552; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9972b10652d03098$export$f67bccc9f629c552 = (0, $9ZXdX.model)({
    name: "UI List Carousel",
    fields: {
        title: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        captions: {
            name: "Captions",
            type: "Array",
            localized: false,
            required: true,
            validations: [
                {
                    size: {
                        min: 3,
                        max: 3
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "caption"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        autoplay: {
            name: "Autoplay",
            type: "Boolean",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        accentColor: {
            name: "Accent color",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Blue",
                        "Green",
                        "Magenta",
                        "Purple",
                        "Red",
                        "Teal",
                        "Yellow"
                    ]
                }
            ],
            defaultValue: {
                "en-US": "Blue"
            },
            disabled: false,
            omitted: false
        },
        orientation: {
            name: "Orientation",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Image right",
                        "Image left"
                    ]
                }
            ],
            defaultValue: {
                "en-US": "Image right"
            },
            disabled: false,
            omitted: false
        },
        hideDotsOnDesktop: {
            name: "Hide dots (on larger screens)",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        dotLabel: {
            name: "Dot label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Dot"
            },
            disabled: false,
            omitted: false
        },
        prevArrowLabel: {
            name: "Previous arrow label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Previous"
            },
            disabled: false,
            omitted: false
        },
        nextArrowLabel: {
            name: "Next arrow label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": "Next"
            },
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("880n0", function(module, exports) {

$parcel$export(module.exports, "uiLoginContainer", function () { return $199725e2c10174c6$export$59e88f669ae3234c; });

var $9ZXdX = parcelRequire("9ZXdX");
const $199725e2c10174c6$export$59e88f669ae3234c = (0, $9ZXdX.model)({
    name: "UI Login Container",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        defaultContent: {
            name: "Default Content",
            type: "Array",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiBlock",
                            "uiButton",
                            "uiColumn",
                            "uiLink"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        loggedInContent: {
            name: "Logged In Content",
            type: "Array",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiBlock",
                            "uiButton",
                            "uiColumn",
                            "uiLink",
                            "uiWorkspacePicker"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("hCiMM", function(module, exports) {

$parcel$export(module.exports, "uiLoginSignupForm", function () { return $6894d5da2a0fa8f9$export$40b6f4b87c5510dd; });

var $9ZXdX = parcelRequire("9ZXdX");
const $6894d5da2a0fa8f9$export$40b6f4b87c5510dd = (0, $9ZXdX.model)({
    name: "Ui Login Signup Form",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        disableLegacyAppearance: {
            name: "Disable legacy appearance?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        formType: {
            name: "Form type",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "login",
                        "signup"
                    ]
                }
            ],
            defaultValue: {
                "en-US": "signup"
            },
            disabled: false,
            omitted: false
        },
        heading: {
            name: "Form heading",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        emailFieldLabel: {
            name: "Email field label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        emailFieldPlaceholder: {
            name: "Email field placeholder",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        useEmailButton: {
            name: "Hide email input?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        emailButtonText: {
            name: "Email button text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: true,
            omitted: true
        },
        termsOfService: {
            name: "Terms of service",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "embedded-entry-block",
                        "embedded-entry-inline",
                        "unordered-list",
                        "ordered-list"
                    ],
                    message: "Only block entry, inline entry, unordered list, and ordered list nodes are allowed"
                },
                {
                    nodes: {}
                }
            ],
            disabled: false,
            omitted: false
        },
        continueButtonText: {
            name: "Continue button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        formSeparatorText: {
            name: "Form separator text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        socialButtons: {
            name: "Social Buttons",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiSocialLoginSignupButton"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        formFooterContent: {
            name: "Form footer content",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "ordered-list",
                        "unordered-list",
                        "embedded-entry-block",
                        "embedded-entry-inline"
                    ],
                    message: "Only ordered list, unordered list, block entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {}
                }
            ],
            disabled: false,
            omitted: false
        },
        browserWarningMessage: {
            name: "Browser warning message",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "ordered-list",
                        "unordered-list",
                        "embedded-entry-inline"
                    ],
                    message: "Only ordered list, unordered list, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        prompt: {
            name: "Prompt",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "none"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        useAtlassianAccess: {
            name: "Use Atlassian Access?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("fEU0B", function(module, exports) {

$parcel$export(module.exports, "uiMarkdown", function () { return $dcb44717f30a76c4$export$4c93d50b008b2ad6; });

var $9ZXdX = parcelRequire("9ZXdX");
const $dcb44717f30a76c4$export$4c93d50b008b2ad6 = (0, $9ZXdX.model)({
    name: "UI Markdown",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        content: {
            name: "Content",
            type: "Text",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        textSize: {
            name: "Text Size",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Large",
                        "Small"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        orderedListAppearance: {
            name: "Ordered list appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Number",
                        "UpperAlpha"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "content"
});

});

parcelRegister("6fdKk", function(module, exports) {

$parcel$export(module.exports, "uiMarketoForm", function () { return $837fc0d06e44d27c$export$880a44c96ea14d2; });

var $9ZXdX = parcelRequire("9ZXdX");
const $837fc0d06e44d27c$export$880a44c96ea14d2 = (0, $9ZXdX.model)({
    name: "UI Marketo Form",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        munchkinId: {
            name: "Munchkin id",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        formId: {
            name: "Form id",
            type: "Integer",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        munchkinIdStg: {
            name: "Munchkin id stg",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        formIdStg: {
            name: "Form id stg",
            type: "Integer",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "RichText",
            localized: true,
            required: false,
            validations: [
                {
                    nodes: {}
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "hyperlink"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, and link to Url nodes are allowed"
                }
            ],
            disabled: false,
            omitted: false
        },
        success: {
            name: "Success",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiBlock"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        successMessage: {
            name: "Success message",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        errorMessage: {
            name: "Error message",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        businessEmailValidation: {
            name: "Business email validation",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("3FUFs", function(module, exports) {

$parcel$export(module.exports, "uiModal", function () { return $11726173943ad048$export$1ee1c37d7d6c10cd; });

var $9ZXdX = parcelRequire("9ZXdX");
const $11726173943ad048$export$1ee1c37d7d6c10cd = (0, $9ZXdX.model)({
    name: "UI Modal",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        modalTrigger: {
            name: "Modal trigger",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiButton",
                        "uiImage"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        modalTriggerBlock: {
            name: "Modal trigger block",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        modalContent: {
            name: "Modal content",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiImage",
                        "uiVideoPlayer"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        closeText: {
            name: "Close text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        transitionType: {
            name: "Transition type",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "FadeIn FadeOut",
                        "SlideDown FadeOut",
                        "SlideDown SlideBelow",
                        "ScaleUp ScaleDown",
                        "SlideDown InstantRemove"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        transitionSpeed: {
            name: "Transition speed",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Slow",
                        "Medium",
                        "Fast",
                        "Instant"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        modalSize: {
            name: "Modal size",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "FitToContent",
                        "Small",
                        "Medium",
                        "Large"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("823Lo", function(module, exports) {

$parcel$export(module.exports, "uiNavBanner", function () { return $b3d6c89ddabb1661$export$6a962b5359937bdf; });

var $9ZXdX = parcelRequire("9ZXdX");
const $b3d6c89ddabb1661$export$6a962b5359937bdf = (0, $9ZXdX.model)({
    name: "UI Nav Banner",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        titleHeading: {
            name: "Title Heading",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Text",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        button: {
            name: "Button",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiButton"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        uiIcon: {
            name: "Icon",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiIcon"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        theme: {
            name: "Theme",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Blue",
                        "Green",
                        "Magenta",
                        "Purple",
                        "Red",
                        "Teal",
                        "Yellow"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("i5AWx", function(module, exports) {

$parcel$export(module.exports, "uiNavBlogArticle", function () { return $9053e75dc4d8f307$export$60d1f7d97e4a9e2a; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9053e75dc4d8f307$export$60d1f7d97e4a9e2a = (0, $9ZXdX.model)({
    name: "UI Nav Blog Article",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        cta: {
            name: "CTA",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        fallback: {
            name: "Fallback",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiNavBanner"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("9vcm2", function(module, exports) {

$parcel$export(module.exports, "uiNavImages", function () { return $c8483aeb071899c3$export$d06037bc029a9cd6; });

var $9ZXdX = parcelRequire("9ZXdX");
const $c8483aeb071899c3$export$d06037bc029a9cd6 = (0, $9ZXdX.model)({
    name: "UI Nav Images",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        theme: {
            name: "Theme",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Team card"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        pages: {
            name: "Pages",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "route"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("4FAtX", function(module, exports) {

$parcel$export(module.exports, "uiNavLink", function () { return $148290e63f12df09$export$4da54c5e7101d0e7; });

var $9ZXdX = parcelRequire("9ZXdX");
const $148290e63f12df09$export$4da54c5e7101d0e7 = (0, $9ZXdX.model)({
    name: "UI Nav Link",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        titleHeading: {
            name: "Title Heading",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Text",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "Url",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        uiIcon: {
            name: "Icon",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiIcon"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        iconColor: {
            name: "Icon Color",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Blue",
                        "Green",
                        "Magenta",
                        "Red",
                        "Teal",
                        "Yellow"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        addBackgroundColorOnHover: {
            name: "Add Background Color on Hover",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        decorator: {
            name: "Decorator",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Arrow Right"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("27Kka", function(module, exports) {

$parcel$export(module.exports, "uiPowerUp", function () { return $86a779fe4acbda3b$export$3debd7762b3eeaf9; });

var $9ZXdX = parcelRequire("9ZXdX");
const $86a779fe4acbda3b$export$3debd7762b3eeaf9 = (0, $9ZXdX.model)({
    name: "UI Power Up",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    nodes: {}
                },
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "hyperlink"
                    ],
                    message: "Only link to Url nodes are allowed"
                }
            ],
            disabled: false,
            omitted: false
        },
        button: {
            name: "Button",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiButton"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        logo: {
            name: "Logo",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiImage"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("6JW3a", function(module, exports) {

$parcel$export(module.exports, "uiPricingCalculator", function () { return $28cab69f3c5d3090$export$5a513bd677388c20; });

var $9ZXdX = parcelRequire("9ZXdX");
const $28cab69f3c5d3090$export$5a513bd677388c20 = (0, $9ZXdX.model)({
    name: "UI Pricing Calculator",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        userCountLabel: {
            name: "User count label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        priceLabel: {
            name: "Price label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        perUserPerMonthText: {
            name: "Per user per month text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        usdText: {
            name: "USD text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        annualTotalText: {
            name: "Annual total text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        averagePricePerUserText: {
            name: "Average price per user text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        generalError: {
            name: "General error",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        minUsersError: {
            name: "Min users error",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        maxUsersError: {
            name: "Max users error",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        plan: {
            name: "Plan",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiPricingPlan"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("6Hre7", function(module, exports) {

$parcel$export(module.exports, "uiPricingComparisonRow", function () { return $c61009d611373c9b$export$62b50b0724f2865f; });

var $9ZXdX = parcelRequire("9ZXdX");
const $c61009d611373c9b$export$62b50b0724f2865f = (0, $9ZXdX.model)({
    name: "UI Pricing Comparison Row",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        lozenge: {
            name: "Lozenge",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        link: {
            name: "Link",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        freeValue: {
            name: "Free value",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiPricingComparisonValue"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        standardValue: {
            name: "Standard value",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiPricingComparisonValue"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        premiumValue: {
            name: "Premium value",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiPricingComparisonValue"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        enterpriseValue: {
            name: "Enterprise value",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiPricingComparisonValue"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("gPQkE", function(module, exports) {

$parcel$export(module.exports, "uiPricingComparisonTable", function () { return $754b372c946dbefb$export$ba8652194dd34ff6; });

var $9ZXdX = parcelRequire("9ZXdX");
const $754b372c946dbefb$export$ba8652194dd34ff6 = (0, $9ZXdX.model)({
    name: "UI Pricing Comparison Table",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        searchFieldLabel: {
            name: "Search field label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        featureColumnHeader: {
            name: "Feature column header",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        freeColumnHeader: {
            name: "Free column header",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        standardColumnHeader: {
            name: "Standard column header",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        premiumColumnHeader: {
            name: "Premium column header",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        enterpriseColumnHeader: {
            name: "Enterprise column header",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        rows: {
            name: "Rows",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiPricingComparisonRow"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("lyQai", function(module, exports) {

$parcel$export(module.exports, "uiPricingComparisonValue", function () { return $15093155a65c289e$export$1cbf31c57a45d1aa; });

var $9ZXdX = parcelRequire("9ZXdX");
const $15093155a65c289e$export$1cbf31c57a45d1aa = (0, $9ZXdX.model)({
    name: "UI Pricing Comparison Value",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        value: {
            name: "Value",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    size: {
                        max: 255
                    }
                },
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "embedded-entry-block",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, block entry, link to Url, link to entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Check",
                        "Empty"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("8dEGA", function(module, exports) {

$parcel$export(module.exports, "uiPricingGrid", function () { return $2bc2b3c81dbda961$export$295d3cce4c718880; });

var $9ZXdX = parcelRequire("9ZXdX");
const $2bc2b3c81dbda961$export$295d3cce4c718880 = (0, $9ZXdX.model)({
    name: "UI Pricing Grid",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        plans: {
            name: "Plans",
            type: "Array",
            localized: false,
            required: true,
            validations: [
                {
                    size: {
                        min: 1,
                        max: 4
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiPricingPlan"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Abbreviated"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("fe2CQ", function(module, exports) {

$parcel$export(module.exports, "uiPricingPlan", function () { return $003f5460a022eda3$export$520c69dd333e7a14; });

var $9ZXdX = parcelRequire("9ZXdX");
const $003f5460a022eda3$export$520c69dd333e7a14 = (0, $9ZXdX.model)({
    name: "UI Pricing Plan",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        description: {
            name: "Description",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        beforeUserField: {
            name: "Before User Field",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        afterUserField: {
            name: "After User Field",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        userFieldLabel: {
            name: "User Field Label",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        beforePrice: {
            name: "Before Price",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        afterPrice: {
            name: "After Price",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        beforeSmallPrice: {
            name: "Before Small Price",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        afterSmallPrice: {
            name: "After Small Price",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        beforeUserMax: {
            name: "Before User Max",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        afterUserMax: {
            name: "After User Max",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        pricing: {
            name: "Pricing",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttons: {
            name: "Buttons",
            type: "Link",
            localized: true,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLoginContainer"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        highlight: {
            name: "Highlight",
            type: "Boolean",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        accordionReadMore: {
            name: "Accordion read more",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        featureList: {
            name: "Feature List",
            type: "Text",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        learnMore: {
            name: "Learn More",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiButton"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("j0aXe", function(module, exports) {

$parcel$export(module.exports, "uiQuote", function () { return $ab80c7015c1bb900$export$85d505a1e7fb8049; });

var $9ZXdX = parcelRequire("9ZXdX");
const $ab80c7015c1bb900$export$85d505a1e7fb8049 = (0, $9ZXdX.model)({
    name: "UI Quote",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        quote: {
            name: "Quote",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        attribution: {
            name: "Attribution",
            type: "Text",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        logo: {
            name: "Logo",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiImage"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("kMHk9", function(module, exports) {

$parcel$export(module.exports, "uiRecommendShare", function () { return $9740e1e16687d9eb$export$7e38958b46792844; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9740e1e16687d9eb$export$7e38958b46792844 = (0, $9ZXdX.model)({
    name: "UI Recommend Share",
    fields: {
        label: {
            name: "Label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        messages: {
            name: "Messages",
            type: "Array",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Symbol",
                validations: []
            }
        },
        facebookButtonLabel: {
            name: "Facebook Button Label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        twitterButtonLabel: {
            name: "Twitter Button Label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        emailButtonLabel: {
            name: "Email Button Label",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        loggedOutText: {
            name: "Logged Out Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "hyperlink",
                        "embedded-entry-block",
                        "embedded-entry-inline"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, link to Url, block entry, and inline entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ],
                                message: null
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ],
                                message: null
                            }
                        ]
                    }
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "label"
});

});

parcelRegister("8bBEQ", function(module, exports) {

$parcel$export(module.exports, "uiRotatingImages", function () { return $21a4ee3b39134619$export$b90be9745c7810d6; });

var $9ZXdX = parcelRequire("9ZXdX");
const $21a4ee3b39134619$export$b90be9745c7810d6 = (0, $9ZXdX.model)({
    name: "UI Rotating Images",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        items: {
            name: "Items",
            type: "Array",
            localized: false,
            required: true,
            validations: [
                {
                    size: {
                        min: 2
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiImage"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("5Bq8e", function(module, exports) {

$parcel$export(module.exports, "uiRotatingItems", function () { return $e89b79242da3d22e$export$8ca4db1b8453ed61; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e89b79242da3d22e$export$8ca4db1b8453ed61 = (0, $9ZXdX.model)({
    name: "UI Rotating Items",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        items: {
            name: "Items",
            type: "Array",
            localized: false,
            required: true,
            validations: [
                {
                    size: {
                        min: 2
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiSection"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("7KbAq", function(module, exports) {

$parcel$export(module.exports, "uiSection", function () { return $f7ce91b23ff35a07$export$ed6e34a769436df; });

var $9ZXdX = parcelRequire("9ZXdX");
const $f7ce91b23ff35a07$export$ed6e34a769436df = (0, $9ZXdX.model)({
    name: "UI Section",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        elementId: {
            name: "Element Id",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        guideSectionTitle: {
            name: "Guide Section Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        columns: {
            name: "Columns",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiColumn"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        verticalAlign: {
            name: "Vertical Align",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Center",
                        "Top",
                        "Bottom"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        sectionBackground: {
            name: "Section background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("dCP1B", function(module, exports) {

$parcel$export(module.exports, "uiSectionGroup", function () { return $96a0532608f34b4e$export$d35fd4a55f82bc5f; });

var $9ZXdX = parcelRequire("9ZXdX");
const $96a0532608f34b4e$export$d35fd4a55f82bc5f = (0, $9ZXdX.model)({
    name: "UI Section Group",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        sections: {
            name: "Sections",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiAddToSlackSection",
                            "uiAnimatedHeroSection",
                            "uiFeatureSection",
                            "uiGuide",
                            "uiIntegrationSection",
                            "uiNavImages",
                            "uiRotatingItems",
                            "uiSection",
                            "uiSpacer",
                            "uiStoryline",
                            "uiTemplateGallery",
                            "uiVariationContainer"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("4Ca3j", function(module, exports) {

$parcel$export(module.exports, "uiSocialLoginSignupButton", function () { return $84b3470385dbea81$export$8cf8d9b36356bb01; });

var $9ZXdX = parcelRequire("9ZXdX");
const $84b3470385dbea81$export$8cf8d9b36356bb01 = (0, $9ZXdX.model)({
    name: "Ui Social Login Signup Button",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        providerName: {
            name: "Provider name",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "google",
                        "microsoft",
                        "apple",
                        "slack"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "Button text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "Button to Login or Sign Up for Trello using a third party provider",
    displayField: "entryTitle"
});

});

parcelRegister("3f5N3", function(module, exports) {

$parcel$export(module.exports, "uiSocialProof", function () { return $4e484e1ce01d33cf$export$4b42beb6fe38c819; });

var $9ZXdX = parcelRequire("9ZXdX");
const $4e484e1ce01d33cf$export$4b42beb6fe38c819 = (0, $9ZXdX.model)({
    name: "UI Social Proof",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        customerQuote: {
            name: "Customer quote",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [],
                    message: "Nodes are not allowed"
                },
                {
                    nodes: {}
                }
            ],
            disabled: false,
            omitted: false
        },
        customerName: {
            name: "Customer name",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        customerDetails: {
            name: "Customer details",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        customerStoryLink: {
            name: "Customer story link",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        customerLogoImage: {
            name: "Customer logo",
            type: "Link",
            localized: false,
            required: true,
            validations: [
                {
                    linkContentType: [
                        "uiImage"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        productFact: {
            name: "Product fact",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        productFactLink: {
            name: "Product fact link",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiLink"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("55U2E", function(module, exports) {

$parcel$export(module.exports, "uiSocialShare", function () { return $110d3eb557bc8148$export$73510b5d78896d2f; });

var $9ZXdX = parcelRequire("9ZXdX");
const $110d3eb557bc8148$export$73510b5d78896d2f = (0, $9ZXdX.model)({
    name: "UI Social Share",
    fields: {
        text: {
            name: "Text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [
                {
                    size: {
                        min: 0,
                        max: 240
                    }
                }
            ],
            disabled: false,
            omitted: false
        },
        hashtags: {
            name: "Hashtags",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Symbol",
                validations: []
            }
        },
        facebookButtonText: {
            name: "Facebook Button Text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        twitterButtonText: {
            name: "Twitter Button Text",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "text"
});

});

parcelRegister("gsrbH", function(module, exports) {

$parcel$export(module.exports, "uiSpacer", function () { return $effce3541c7a75f7$export$50a373fdfca09c00; });

var $9ZXdX = parcelRequire("9ZXdX");
const $effce3541c7a75f7$export$50a373fdfca09c00 = (0, $9ZXdX.model)({
    name: "UI Spacer",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        size: {
            name: "Size",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "1",
                        "2",
                        "3",
                        "4",
                        "5",
                        "6",
                        "7",
                        "8"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("5ZXkW", function(module, exports) {

$parcel$export(module.exports, "uiSplitSection", function () { return $b631fc9214845999$export$b20f1787e7adb99; });

var $9ZXdX = parcelRequire("9ZXdX");
const $b631fc9214845999$export$b20f1787e7adb99 = (0, $9ZXdX.model)({
    name: "UI Split Section",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        useEyebrowLogo: {
            name: "Use eyebrow logo?",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        columnsLeft: {
            name: "Left side columns",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiColumn"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        backgroundLeft: {
            name: "Left side background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        columnsRight: {
            name: "Right side columns",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiColumn"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        backgroundRight: {
            name: "Right side background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        footer: {
            name: "Footer",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiFooterNavBasic"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "Use to create a 2 column landing page with different backgrounds",
    displayField: "entryTitle"
});

});

parcelRegister("1eN9m", function(module, exports) {

$parcel$export(module.exports, "uiStack", function () { return $02b29d6183cd4a77$export$e4533e9eef047155; });

var $9ZXdX = parcelRequire("9ZXdX");
const $02b29d6183cd4a77$export$e4533e9eef047155 = (0, $9ZXdX.model)({
    name: "UI Stack",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        orientation: {
            name: "Orientation",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "vertical",
                        "horizontal"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        spacing: {
            name: "Spacing",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "none",
                        "tight",
                        "compact",
                        "cozy",
                        "comfortable",
                        "outerspace"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        fullHeight: {
            name: "Full Height",
            type: "Boolean",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        children: {
            name: "Children",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiBlock"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("3cgcI", function(module, exports) {

$parcel$export(module.exports, "uiStatuspage", function () { return $28fdaafbd60b3a96$export$78f003d178c5f7c3; });

var $9ZXdX = parcelRequire("9ZXdX");
const $28fdaafbd60b3a96$export$78f003d178c5f7c3 = (0, $9ZXdX.model)({
    name: "UI Statuspage",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        statuspageId: {
            name: "Statuspage ID",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    unique: true
                }
            ],
            disabled: false,
            omitted: false
        },
        none: {
            name: "None",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        minor: {
            name: "Minor",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        major: {
            name: "Major",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        critical: {
            name: "Critical",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "URL",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    regexp: {
                        pattern: "^(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-/]))?$",
                        flags: null
                    }
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("lOx88", function(module, exports) {

$parcel$export(module.exports, "uiStoryline", function () { return $9cee91d81a27bf29$export$da9b21b05bb005fb; });

var $9ZXdX = parcelRequire("9ZXdX");
const $9cee91d81a27bf29$export$da9b21b05bb005fb = (0, $9ZXdX.model)({
    name: "UI Storyline",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        stories: {
            name: "Stories",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "caption"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("6lRzW", function(module, exports) {

$parcel$export(module.exports, "uiTab", function () { return $30adc78827d604ae$export$b679cac907c1abc3; });

var $9ZXdX = parcelRequire("9ZXdX");
const $30adc78827d604ae$export$b679cac907c1abc3 = (0, $9ZXdX.model)({
    name: "UI Tab",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        buttonText: {
            name: "buttonText",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        columns: {
            name: "columns",
            type: "Array",
            localized: false,
            required: true,
            validations: [
                {
                    size: {
                        min: 1,
                        max: 2
                    }
                }
            ],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiColumn"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("ls3bA", function(module, exports) {

$parcel$export(module.exports, "uiTabPanel", function () { return $d7b8ddb0451762ca$export$1f747aa3e8cba89e; });

var $9ZXdX = parcelRequire("9ZXdX");
const $d7b8ddb0451762ca$export$1f747aa3e8cba89e = (0, $9ZXdX.model)({
    name: "UI Tab Panel",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        tabs: {
            name: "tabs",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiTab"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("fwZpW", function(module, exports) {

$parcel$export(module.exports, "uiTemplateGallery", function () { return $41c1374a992034f7$export$2ce11296624bf1c9; });

var $9ZXdX = parcelRequire("9ZXdX");
const $41c1374a992034f7$export$2ce11296624bf1c9 = (0, $9ZXdX.model)({
    name: "UI Template Gallery",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        templates: {
            name: "Templates",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "trelloTemplate"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        carousel: {
            name: "Carousel",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        reduced: {
            name: "Reduced",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            defaultValue: {
                "en-US": false
            },
            disabled: false,
            omitted: false
        },
        horizontalAlignment: {
            name: "Horizontal alignment",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "left",
                        "center",
                        "right"
                    ]
                }
            ],
            defaultValue: {
                "en-US": "center"
            },
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("ed5st", function(module, exports) {

$parcel$export(module.exports, "uiTextBlock", function () { return $e685c07faee4223b$export$c678d0f46035428c; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e685c07faee4223b$export$c678d0f46035428c = (0, $9ZXdX.model)({
    name: "UI Text Block",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        text: {
            name: "Text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    enabledNodeTypes: [
                        "heading-1",
                        "heading-2",
                        "heading-3",
                        "heading-4",
                        "heading-5",
                        "heading-6",
                        "ordered-list",
                        "unordered-list",
                        "hr",
                        "blockquote",
                        "hyperlink",
                        "entry-hyperlink",
                        "embedded-entry-inline",
                        "embedded-entry-block"
                    ],
                    message: "Only heading 1, heading 2, heading 3, heading 4, heading 5, heading 6, ordered list, unordered list, horizontal rule, quote, link to Url, link to entry, inline entry, and block entry nodes are allowed"
                },
                {
                    nodes: {
                        "embedded-entry-block": [
                            {
                                linkContentType: [
                                    "uiImage",
                                    "uiLink"
                                ]
                            }
                        ],
                        "embedded-entry-inline": [
                            {
                                linkContentType: [
                                    "uiLink",
                                    "uiTooltip"
                                ]
                            }
                        ]
                    }
                },
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline",
                        "code"
                    ],
                    message: "Only bold, italic, underline, and code marks are allowed"
                }
            ],
            disabled: false,
            omitted: false
        },
        textSize: {
            name: "Text Size",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Large",
                        "Small"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        orderedListAppearance: {
            name: "Ordered list appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Number",
                        "UpperAlpha"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("hZFwp", function(module, exports) {

$parcel$export(module.exports, "uiTooltip", function () { return $ebf809bc3b4f9428$export$e71122faa2b336a5; });

var $9ZXdX = parcelRequire("9ZXdX");
const $ebf809bc3b4f9428$export$e71122faa2b336a5 = (0, $9ZXdX.model)({
    name: "UI Tooltip",
    fields: {
        triggerText: {
            name: "Trigger text",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        tooltipText: {
            name: "Tooltip text",
            type: "RichText",
            localized: true,
            required: true,
            validations: [
                {
                    nodes: {}
                },
                {
                    enabledMarks: [
                        "bold",
                        "italic",
                        "underline"
                    ],
                    message: "Only bold, italic, and underline marks are allowed"
                },
                {
                    enabledNodeTypes: [
                        "unordered-list",
                        "ordered-list",
                        "hyperlink"
                    ],
                    message: "Only unordered list, ordered list, and link to Url nodes are allowed"
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "triggerText"
});

});

parcelRegister("kqMZQ", function(module, exports) {

$parcel$export(module.exports, "uiTrelloBoard", function () { return $51c82e973808781d$export$6660194f53e1b488; });

var $9ZXdX = parcelRequire("9ZXdX");
const $51c82e973808781d$export$6660194f53e1b488 = (0, $9ZXdX.model)({
    name: "UI Trello Board",
    fields: {
        name: {
            name: "Name",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        layout: {
            name: "Layout",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [
                {
                    in: [
                        "Desktop",
                        "Mobile"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        lists: {
            name: "Lists",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiTrelloList"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        background: {
            name: "Background",
            type: "Object",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "name"
});

});

parcelRegister("hcN58", function(module, exports) {

$parcel$export(module.exports, "uiTrelloCard", function () { return $a3b5aace810537af$export$5a352529bd278782; });

var $9ZXdX = parcelRequire("9ZXdX");
const $a3b5aace810537af$export$5a352529bd278782 = (0, $9ZXdX.model)({
    name: "UI Trello Card",
    fields: {
        name: {
            name: "Name",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        image: {
            name: "Image",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        label: {
            name: "Label",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "red",
                        "purple",
                        "blue"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        users: {
            name: "Users",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkMimetypeGroup: [
                            "image"
                        ]
                    },
                    {
                        assetImageDimensions: {
                            width: {
                                min: 96,
                                max: 96
                            },
                            height: {
                                min: 96,
                                max: 96
                            }
                        }
                    }
                ],
                linkType: "Asset"
            }
        },
        hasDescription: {
            name: "Has Description",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        descriptionType: {
            name: "Description Type",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Text",
                        "Timer",
                        "CheckList",
                        "CheckListInProgress",
                        "CheckListDone"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "name"
});

});

parcelRegister("1R3JI", function(module, exports) {

$parcel$export(module.exports, "uiTrelloList", function () { return $f9a20c9baa663891$export$6367c402aff399d3; });

var $9ZXdX = parcelRequire("9ZXdX");
const $f9a20c9baa663891$export$6367c402aff399d3 = (0, $9ZXdX.model)({
    name: "UI Trello List",
    fields: {
        name: {
            name: "Name",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        cards: {
            name: "Cards",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiTrelloCard"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "name"
});

});

parcelRegister("jzXLL", function(module, exports) {

$parcel$export(module.exports, "uiValueProp", function () { return $e42a03523fcf1edc$export$26d4080079843ed9; });

var $9ZXdX = parcelRequire("9ZXdX");
const $e42a03523fcf1edc$export$26d4080079843ed9 = (0, $9ZXdX.model)({
    name: "UI Value Prop",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        image: {
            name: "Image",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        icon: {
            name: "Icon",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "uiIcon"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        },
        content: {
            name: "Content",
            type: "Text",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "No padding"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        link: {
            name: "Link",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkContentType: [
                        "route"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Entry"
        }
    },
    description: "",
    displayField: "content"
});

});

parcelRegister("jnmFp", function(module, exports) {

$parcel$export(module.exports, "uiVariationContainer", function () { return $fac233174ffc29f2$export$50d46ebe6bb527dc; });

var $9ZXdX = parcelRequire("9ZXdX");
const $fac233174ffc29f2$export$50d46ebe6bb527dc = (0, $9ZXdX.model)({
    name: "UI Variation Container",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        featureFlagName: {
            name: "Feature Flag Name",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        defaultVariation: {
            name: "Default Variation",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiHeaderNav",
                            "uiSection"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        },
        variations: {
            name: "Variations",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "variationItem"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("6KLA8", function(module, exports) {

$parcel$export(module.exports, "uiVideo", function () { return $c7234ae1f5c922d6$export$a256aa49ebfa9505; });

var $9ZXdX = parcelRequire("9ZXdX");
const $c7234ae1f5c922d6$export$a256aa49ebfa9505 = (0, $9ZXdX.model)({
    name: "UI Video",
    fields: {
        title: {
            name: "Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        loop: {
            name: "Loop",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        autoplay: {
            name: "Autoplay",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        muted: {
            name: "Muted",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        controls: {
            name: "Controls",
            type: "Boolean",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        poster: {
            name: "Poster",
            type: "Link",
            localized: false,
            required: false,
            validations: [
                {
                    linkMimetypeGroup: [
                        "image"
                    ]
                }
            ],
            disabled: false,
            omitted: false,
            linkType: "Asset"
        },
        sources: {
            name: "Sources",
            type: "Array",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkMimetypeGroup: [
                            "video"
                        ]
                    }
                ],
                linkType: "Asset"
            }
        }
    },
    description: "",
    displayField: "title"
});

});

parcelRegister("bJmvd", function(module, exports) {

$parcel$export(module.exports, "uiVideoPlayer", function () { return $da3f4c3a7ec99e07$export$19459a02d6d87afb; });

var $9ZXdX = parcelRequire("9ZXdX");
const $da3f4c3a7ec99e07$export$19459a02d6d87afb = (0, $9ZXdX.model)({
    name: "UI Video Player",
    fields: {
        entryTitle: {
            name: "Entry title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        videoProvider: {
            name: "Video provider",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [
                {
                    in: [
                        "Loom",
                        "Wistia"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        },
        videoId: {
            name: "Video id",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("bfmTC", function(module, exports) {

$parcel$export(module.exports, "uiWebinarLink", function () { return $c11106e73dcfc7d5$export$c64aa54a159084e; });

var $9ZXdX = parcelRequire("9ZXdX");
const $c11106e73dcfc7d5$export$c64aa54a159084e = (0, $9ZXdX.model)({
    name: "UI Webinar Link",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [],
            disabled: false,
            omitted: false
        },
        title: {
            name: "Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        url: {
            name: "URL",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        appearance: {
            name: "Appearance",
            type: "Symbol",
            localized: false,
            required: false,
            validations: [
                {
                    in: [
                        "Default",
                        "Webinars page"
                    ]
                }
            ],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("bhwOo", function(module, exports) {

$parcel$export(module.exports, "uiWorkspacePicker", function () { return $4cb26af542fad56b$export$f10042e8a083ce5d; });

var $9ZXdX = parcelRequire("9ZXdX");
const $4cb26af542fad56b$export$f10042e8a083ce5d = (0, $9ZXdX.model)({
    name: "UI Workspace Picker",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        dropdownTitle: {
            name: "Dropdown Title",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        noCreditsLeft: {
            name: "No Credits Left",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        noEligibleAdmin: {
            name: "No Eligible Admin",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        noWorkspace: {
            name: "No Workspace",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        noWorkspaceUrl: {
            name: "No Workspace URL",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        invalidLoginToken: {
            name: "Invalid Login Token",
            type: "Symbol",
            localized: true,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        urlAppendix: {
            name: "URL Appendix",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        }
    },
    description: "",
    displayField: "entryTitle"
});

});

parcelRegister("asWTs", function(module, exports) {

$parcel$export(module.exports, "variationItem", function () { return $7b933f99fcc6d838$export$3b8055797a4116b5; });

var $9ZXdX = parcelRequire("9ZXdX");
const $7b933f99fcc6d838$export$3b8055797a4116b5 = (0, $9ZXdX.model)({
    name: "Variation Item",
    fields: {
        entryTitle: {
            name: "Entry Title",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        variationValue: {
            name: "Variation Value",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        variationName: {
            name: "Variation Name",
            type: "Symbol",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false
        },
        variation: {
            name: "Variation",
            type: "Array",
            localized: false,
            required: true,
            validations: [],
            disabled: false,
            omitted: false,
            items: {
                type: "Link",
                validations: [
                    {
                        linkContentType: [
                            "uiHeaderNav",
                            "uiLoginSignupForm",
                            "uiSection",
                            "uiVariationContainer"
                        ]
                    }
                ],
                linkType: "Entry"
            }
        }
    },
    description: "",
    displayField: "entryTitle"
});

});


parcelRegister("7d0lE", function(module, exports) {

});



parcelRegister("bLXK9", function(module, exports) {
$parcel$export(module.exports, "mock$AssetModel", function () { return (parcelRequire("4z4jd")).mock$AssetModel; });
$parcel$export(module.exports, "mockAdfDocument", function () { return (parcelRequire("c1EPC")).mockAdfDocument; });
$parcel$export(module.exports, "mockAdfParagraph", function () { return (parcelRequire("c1EPC")).mockAdfParagraph; });
$parcel$export(module.exports, "mockAdfText", function () { return (parcelRequire("c1EPC")).mockAdfText; });
$parcel$export(module.exports, "mockLinkButtonThemeModel", function () { return (parcelRequire("1EWMu")).mockLinkButtonThemeModel; });
$parcel$export(module.exports, "mockLinkButtonThemeModelContent", function () { return (parcelRequire("1EWMu")).mockLinkButtonThemeModelContent; });
$parcel$export(module.exports, "mockUiButtonModel", function () { return (parcelRequire("1EWMu")).mockUiButtonModel; });
$parcel$export(module.exports, "mockUiButtonModelContent", function () { return (parcelRequire("1EWMu")).mockUiButtonModelContent; });
parcelRequire("97690");
parcelRequire("9EQYR");
parcelRequire("jewli");

});
parcelRegister("97690", function(module, exports) {
$parcel$export(module.exports, "mockDocument", function () { return (parcelRequire("hx6SC")).mockDocument; });
parcelRequire("hx6SC");

});
parcelRegister("hx6SC", function(module, exports) {

$parcel$export(module.exports, "mockDocument", function () { return $057a6f2f66e84383$export$5a78fa6ac6ebc36a; });
function $057a6f2f66e84383$export$5a78fa6ac6ebc36a({ content: content = [] } = {}) {
    return {
        type: "doc",
        version: 1,
        content: content
    };
}

});


parcelRegister("9EQYR", function(module, exports) {
parcelRequire("O1wtj");

});
parcelRegister("O1wtj", function(module, exports) {
function $bb28254e270891b1$export$b6707e1f4c5d230({ breakpoints: breakpoints = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
], color: color = "transparent", properties: properties = [] } = {}) {
    return {
        breakpoints: breakpoints,
        color: color,
        properties: properties
    };
}
function $bb28254e270891b1$export$d724b820990368a5({ attachment: attachment = "scroll", blendMode: blendMode = "normal", clip: clip = "border-box", image: image = $bb28254e270891b1$export$e8bc580a17525188(), origin: origin = "padding-box", position: position = $bb28254e270891b1$export$89513dae278c3d4f(), repeat: repeat = "repeat", size: size = $bb28254e270891b1$export$6be9d3e1bf8c202d() } = {}) {
    return {
        attachment: attachment,
        blendMode: blendMode,
        clip: clip,
        image: image,
        origin: origin,
        position: position,
        repeat: repeat,
        size: size
    };
}
function $bb28254e270891b1$export$e8bc580a17525188({ type: type = "gradient", image: image = $bb28254e270891b1$export$16f9298e61fac448(), gradient: gradient = $bb28254e270891b1$export$38b43bfe1b07e355() } = {}) {
    return {
        type: type,
        image: image,
        gradient: gradient
    };
}
function $bb28254e270891b1$export$16f9298e61fac448({ id: id = "", value: value = "none" } = {}) {
    return {
        id: id,
        value: value
    };
}
function $bb28254e270891b1$export$38b43bfe1b07e355({ value: value = "none", angle: angle = 0 } = {}) {
    return {
        value: value,
        angle: angle
    };
}
function $bb28254e270891b1$export$89513dae278c3d4f({ fieldType: fieldType = "units", keywords: keywords = $bb28254e270891b1$export$439bb7cafd6684d8(), units: units = $bb28254e270891b1$export$2be4abc861045343() } = {}) {
    return {
        fieldType: fieldType,
        keywords: keywords,
        units: units
    };
}
function $bb28254e270891b1$export$439bb7cafd6684d8({ horizontal: horizontal = "left", vertical: vertical = "top" } = {}) {
    return {
        horizontal: horizontal,
        vertical: vertical
    };
}
function $bb28254e270891b1$export$2be4abc861045343({ unit: unit = "%", horizontal: horizontal = 0, vertical: vertical = 0 } = {}) {
    return {
        unit: unit,
        horizontal: horizontal,
        vertical: vertical
    };
}
function $bb28254e270891b1$export$6be9d3e1bf8c202d({ fieldType: fieldType = "units", keyword: keyword = "auto", units: units = $bb28254e270891b1$export$7a147a505b8e6e5c() } = {}) {
    return {
        fieldType: fieldType,
        keyword: keyword,
        units: units
    };
}
function $bb28254e270891b1$export$7a147a505b8e6e5c({ unit: unit = "%", width: width = 100, height: height = 100, isAutoWidth: isAutoWidth = false, isAutoHeight: isAutoHeight = false } = {}) {
    return {
        unit: unit,
        width: width,
        height: height,
        isAutoWidth: isAutoWidth,
        isAutoHeight: isAutoHeight
    };
}

});


parcelRegister("jewli", function(module, exports) {
$parcel$export(module.exports, "mockAdfDocument", function () { return (parcelRequire("c1EPC")).mockAdfDocument; });
$parcel$export(module.exports, "mockAdfEmbeddedUiLink", function () { return (parcelRequire("c1EPC")).mockAdfEmbeddedUiLink; });
$parcel$export(module.exports, "mockAdfHeading", function () { return (parcelRequire("c1EPC")).mockAdfHeading; });
$parcel$export(module.exports, "mockAdfParagraph", function () { return (parcelRequire("c1EPC")).mockAdfParagraph; });
$parcel$export(module.exports, "mockAdfText", function () { return (parcelRequire("c1EPC")).mockAdfText; });
$parcel$export(module.exports, "mock$AssetModel", function () { return (parcelRequire("4z4jd")).mock$AssetModel; });
$parcel$export(module.exports, "mockRouteModel", function () { return (parcelRequire("i6DSV")).mockRouteModel; });
$parcel$export(module.exports, "mockUiBlockModel", function () { return (parcelRequire("58mqD")).mockUiBlockModel; });
$parcel$export(module.exports, "mockLinkButtonThemeModel", function () { return (parcelRequire("1EWMu")).mockLinkButtonThemeModel; });
$parcel$export(module.exports, "mockLinkButtonThemeModelContent", function () { return (parcelRequire("1EWMu")).mockLinkButtonThemeModelContent; });
$parcel$export(module.exports, "mockUiButtonModel", function () { return (parcelRequire("1EWMu")).mockUiButtonModel; });
$parcel$export(module.exports, "mockUiButtonModelContent", function () { return (parcelRequire("1EWMu")).mockUiButtonModelContent; });
$parcel$export(module.exports, "mockUiColumnModel", function () { return (parcelRequire("d4LwL")).mockUiColumnModel; });
$parcel$export(module.exports, "mockUiColumnModelContent", function () { return (parcelRequire("d4LwL")).mockUiColumnModelContent; });
$parcel$export(module.exports, "mockUiEmailSignupModel", function () { return (parcelRequire("cR7iC")).mockUiEmailSignupModel; });
$parcel$export(module.exports, "mockUiEmailSignupModelContent", function () { return (parcelRequire("cR7iC")).mockUiEmailSignupModelContent; });
$parcel$export(module.exports, "mockUiImageModel", function () { return (parcelRequire("jPjrf")).mockUiImageModel; });
$parcel$export(module.exports, "mockUiImageModelContent", function () { return (parcelRequire("jPjrf")).mockUiImageModelContent; });
$parcel$export(module.exports, "mockUiLinkModel", function () { return (parcelRequire("6vbsO")).mockUiLinkModel; });
$parcel$export(module.exports, "mockUiLinkModelContent", function () { return (parcelRequire("6vbsO")).mockUiLinkModelContent; });
$parcel$export(module.exports, "mockUiMarkdownModel", function () { return (parcelRequire("7TOUx")).mockUiMarkdownModel; });
$parcel$export(module.exports, "mockUiMarkdownModelContent", function () { return (parcelRequire("7TOUx")).mockUiMarkdownModelContent; });
$parcel$export(module.exports, "mockUiModalModel", function () { return (parcelRequire("jOjLE")).mockUiModalModel; });
$parcel$export(module.exports, "mockUiModalModelContent", function () { return (parcelRequire("jOjLE")).mockUiModalModelContent; });
$parcel$export(module.exports, "mockUiNavBannerModel", function () { return (parcelRequire("hRtfl")).mockUiNavBannerModel; });
$parcel$export(module.exports, "mockUiNavBannerModelContent", function () { return (parcelRequire("hRtfl")).mockUiNavBannerModelContent; });
$parcel$export(module.exports, "mockUiRotatingImagesModel", function () { return (parcelRequire("5qYLH")).mockUiRotatingImagesModel; });
$parcel$export(module.exports, "mockUiSocialLoginSignupButtonModel", function () { return (parcelRequire("b163B")).mockUiSocialLoginSignupButtonModel; });
$parcel$export(module.exports, "mockUiSocialLoginSignupButtonModelContent", function () { return (parcelRequire("b163B")).mockUiSocialLoginSignupButtonModelContent; });
$parcel$export(module.exports, "mockUiTooltipModel", function () { return (parcelRequire("ki2oO")).mockUiTooltipModel; });
$parcel$export(module.exports, "mockUiTooltipModelContent", function () { return (parcelRequire("ki2oO")).mockUiTooltipModelContent; });
parcelRequire("c1EPC");
parcelRequire("4z4jd");
parcelRequire("1xdvc");
parcelRequire("gfHA5");
parcelRequire("a636f");
parcelRequire("i6DSV");
parcelRequire("30lGq");
parcelRequire("jFH3L");
parcelRequire("gxVK1");
parcelRequire("gdxY9");
parcelRequire("11clp");
parcelRequire("58mqD");
parcelRequire("1EWMu");
parcelRequire("66JB4");
parcelRequire("lyL76");
parcelRequire("8aN1v");
parcelRequire("r3iNV");
parcelRequire("d4LwL");
parcelRequire("ghFfL");
parcelRequire("xNkXX");
parcelRequire("cR7iC");
parcelRequire("4Gewj");
parcelRequire("qApUh");
parcelRequire("gpr48");
parcelRequire("ayOep");
parcelRequire("8rvHt");
parcelRequire("iSIBp");
parcelRequire("6q5MG");
parcelRequire("irWgf");
parcelRequire("kffsB");
parcelRequire("jPjrf");
parcelRequire("6opKE");
parcelRequire("9uCbh");
parcelRequire("jpEQz");
parcelRequire("6vbsO");
parcelRequire("8c78l");
parcelRequire("jWtro");
parcelRequire("9MXPj");
parcelRequire("4mWFE");
parcelRequire("7TOUx");
parcelRequire("4ki4X");
parcelRequire("jOjLE");
parcelRequire("hRtfl");
parcelRequire("hZgu4");
parcelRequire("foFub");
parcelRequire("6OeXd");
parcelRequire("9Kxp6");
parcelRequire("66itQ");
parcelRequire("hnhzO");
parcelRequire("5PPc2");
parcelRequire("emjGG");
parcelRequire("5JUIj");
parcelRequire("9TF1T");
parcelRequire("99gNz");
parcelRequire("5qYLH");
parcelRequire("55a0J");
parcelRequire("lJ0QS");
parcelRequire("e6tNd");
parcelRequire("b163B");
parcelRequire("gM6H4");
parcelRequire("caPpv");
parcelRequire("7jB5b");
parcelRequire("6T6U4");
parcelRequire("l9tcl");
parcelRequire("eXBuX");
parcelRequire("22i1M");
parcelRequire("gzLQt");
parcelRequire("lFPYW");
parcelRequire("bw2q1");
parcelRequire("ki2oO");
parcelRequire("dKI7P");
parcelRequire("2ZHHC");
parcelRequire("125zO");
parcelRequire("203rx");
parcelRequire("1PzaA");
parcelRequire("lLNir");
parcelRequire("kP9Dy");
parcelRequire("1V2s8");

});
parcelRegister("c1EPC", function(module, exports) {

$parcel$export(module.exports, "mockAdfDocument", function () { return $b5bf8c78bc544a17$export$ddddd89816064f1c; });
$parcel$export(module.exports, "mockAdfText", function () { return $b5bf8c78bc544a17$export$a8eaff185e19068a; });
$parcel$export(module.exports, "mockAdfHeading", function () { return $b5bf8c78bc544a17$export$aa9b5793176b5bce; });
$parcel$export(module.exports, "mockAdfParagraph", function () { return $b5bf8c78bc544a17$export$5d38d967de80e6e9; });
$parcel$export(module.exports, "mockAdfLink", function () { return $b5bf8c78bc544a17$export$373997dd799fd0f9; });
$parcel$export(module.exports, "mockAdfEmbeddedUiLink", function () { return $b5bf8c78bc544a17$export$4b4db91fde5875d7; });
parcelRequire("jewli");
var $jPjrf = parcelRequire("jPjrf");
var $4z4jd = parcelRequire("4z4jd");
var $6vbsO = parcelRequire("6vbsO");
var $ki2oO = parcelRequire("ki2oO");
function $b5bf8c78bc544a17$export$ddddd89816064f1c({ version: version = 1, type: type = "doc", content: content = [] } = {}) {
    return {
        version: version,
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$a8eaff185e19068a({ type: type = "text", text: text = "The way to get started is to quit talking and begin doing.", ...optionals } = {}) {
    return {
        type: type,
        text: text,
        ...optionals
    };
}
function $b5bf8c78bc544a17$export$aa9b5793176b5bce({ type: type = "heading", attrs: attrs = {
    level: 1
}, ...optionals } = {}) {
    return {
        type: type,
        attrs: attrs,
        ...optionals
    };
}
function $b5bf8c78bc544a17$export$5d38d967de80e6e9({ type: type = "paragraph", content: content = [
    $b5bf8c78bc544a17$export$a8eaff185e19068a()
] } = {}) {
    return {
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$e20cbd3e56119f28({ type: type = "blockquote", content: content = [
    $b5bf8c78bc544a17$export$5d38d967de80e6e9()
] } = {}) {
    return {
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$e620efa253448b4f({ type: type = "rule" } = {}) {
    return {
        type: type
    };
}
function $b5bf8c78bc544a17$export$766095d4db3538ad({ type: type = "listItem", content: content = [
    $b5bf8c78bc544a17$export$5d38d967de80e6e9()
] } = {}) {
    return {
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$26e25dd763d23db6({ type: type = "orderedList", content: content = [
    $b5bf8c78bc544a17$export$766095d4db3538ad(),
    $b5bf8c78bc544a17$export$766095d4db3538ad(),
    $b5bf8c78bc544a17$export$766095d4db3538ad()
] } = {}) {
    return {
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$74a0fc6d24faaf5c({ type: type = "bulletList", content: content = [
    $b5bf8c78bc544a17$export$766095d4db3538ad(),
    $b5bf8c78bc544a17$export$766095d4db3538ad(),
    $b5bf8c78bc544a17$export$766095d4db3538ad()
] } = {}) {
    return {
        type: type,
        content: content
    };
}
function $b5bf8c78bc544a17$export$373997dd799fd0f9({ type: type = "link", attrs: attrs = {
    href: "/foobar"
}, ...optionals } = {}) {
    return {
        type: type,
        attrs: attrs,
        ...optionals
    };
}
function $b5bf8c78bc544a17$export$16d5d64abf702fe7({ type: type = "code" } = {}) {
    return {
        type: type
    };
}
function $b5bf8c78bc544a17$export$af540bd28decb87d({ type: type = "strong" } = {}) {
    return {
        type: type
    };
}
function $b5bf8c78bc544a17$export$1f10b64d501a3328({ type: type = "em" } = {}) {
    return {
        type: type
    };
}
function $b5bf8c78bc544a17$export$43c8ad3011cf2ce0({ type: type = "underline" } = {}) {
    return {
        type: type
    };
}
function $b5bf8c78bc544a17$export$212c89076f4f499e({ type: type = "bxpEmbeddedViewBlock", model: model = (0, $jPjrf.mockUiImageModel)({
    content: (0, $jPjrf.mockUiImageModelContent)({
        image: (0, $4z4jd.mock$AssetModel)({
            title: "Engineering Playbook",
            url: "/ui-modal/playbooks_boardtile_engineering.png",
            width: 1414,
            height: 712
        })
    })
}) } = {}) {
    return {
        type: type,
        model: model
    };
}
function $b5bf8c78bc544a17$export$4b4db91fde5875d7({ type: type = "bxpEmbeddedViewInline", model: model = (0, $6vbsO.mockUiLinkModel)({
    content: (0, $6vbsO.mockUiLinkModelContent)({
        url: "#test",
        text: "Learn more"
    })
}) } = {}) {
    return {
        type: type,
        model: model
    };
}
function $b5bf8c78bc544a17$export$f12b63763887bab4({ type: type = "bxpEmbeddedViewInline", model: model = (0, $ki2oO.mockUiTooltipModel)({
    content: (0, $ki2oO.mockUiTooltipModelContent)({
        triggerText: "Tooltip",
        tooltipText: $b5bf8c78bc544a17$export$ddddd89816064f1c({
            content: [
                $b5bf8c78bc544a17$export$a8eaff185e19068a()
            ]
        })
    })
}) } = {}) {
    return {
        type: type,
        model: model
    };
}
function $b5bf8c78bc544a17$export$1f7bfd0f6142285c({ type: type = "text", text: text = "The way to get started is\n to quit talking and\n begin doing.", ...optionals } = {}) {
    return {
        type: type,
        text: text,
        ...optionals
    };
}

});

parcelRegister("4z4jd", function(module, exports) {

$parcel$export(module.exports, "mock$AssetModel", function () { return $88042145d992edf9$export$811f78a651ed4874; });
function $88042145d992edf9$export$811f78a651ed4874({ id: id = "asset-123", title: title = "Placeholder image", url: url = "/placeholder/landscape.png", width: width = 1200, height: height = 600 } = {}) {
    return {
        id: id,
        title: title,
        url: `/bxp-trello-storybook${url}`,
        width: width,
        height: height
    };
}

});

parcelRegister("1xdvc", function(module, exports) {

$parcel$export(module.exports, "mockCaptionModel", function () { return $bb1ac23d3082a315$export$918452de9bc62f78; });
parcelRequire("jewli");
var $58mqD = parcelRequire("58mqD");
var $c1EPC = parcelRequire("c1EPC");
function $bb1ac23d3082a315$export$918452de9bc62f78({ id: id = "caption-1234", type: type = "caption", locale: locale = "en", content: content = $bb1ac23d3082a315$export$618deef171d3008e() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $bb1ac23d3082a315$export$618deef171d3008e({ title: title = "Example caption", content: content = (0, $58mqD.mockUiBlockModel)(), caption: caption = (0, $c1EPC.mockAdfDocument)(), ...optionals } = {}) {
    return {
        title: title,
        content: content,
        caption: caption,
        ...optionals
    };
}

});

parcelRegister("gfHA5", function(module, exports) {
parcelRequire("jewli");
var $i6DSV = parcelRequire("i6DSV");
function $1a4f4d961311c80e$export$53a7e9ee209eb79({ id: id = "integration-category-1234", type: type = "integrationCategory", locale: locale = "en", content: content = $1a4f4d961311c80e$export$30708152566b7e3() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $1a4f4d961311c80e$export$30708152566b7e3({ entryTitle: entryTitle = "Example Integration Category", title: title = "Lorem ipsum", route: route = (0, $i6DSV.mockRouteModel)(), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        route: route,
        ...optionals
    };
}

});

parcelRegister("a636f", function(module, exports) {

var $i6DSV = parcelRequire("i6DSV");
function $3168eaa0c5fb7e96$export$1fdc3f91f999337c({ id: id = "page-1234", type: type = "page", locale: locale = "en", content: content = $3168eaa0c5fb7e96$export$ce08ab12c437f014() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $3168eaa0c5fb7e96$export$ce08ab12c437f014({ title: title = "Example page", route: route = (0, $i6DSV.mockRouteModel)(), ...optionals } = {}) {
    return {
        title: title,
        route: route,
        ...optionals
    };
}

});
parcelRegister("i6DSV", function(module, exports) {

$parcel$export(module.exports, "mockRouteModel", function () { return $364f1d4f1b20d4be$export$da69dec0e1b3fca3; });
$parcel$export(module.exports, "mockRouteModelContent", function () { return $364f1d4f1b20d4be$export$3445ee2441bd7cb8; });
function $364f1d4f1b20d4be$export$da69dec0e1b3fca3({ id: id = "route-1234", type: type = "route", locale: locale = "en", content: content = $364f1d4f1b20d4be$export$3445ee2441bd7cb8() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $364f1d4f1b20d4be$export$3445ee2441bd7cb8({ path: path = "/foo/bar", ...optionals } = {}) {
    return {
        path: path,
        ...optionals
    };
}

});


parcelRegister("30lGq", function(module, exports) {

$parcel$export(module.exports, "mockTrelloTemplateModel", function () { return $9bd97854e693801f$export$c5e1ba36f2d93929; });

var $4z4jd = parcelRequire("4z4jd");
function $9bd97854e693801f$export$c5e1ba36f2d93929({ id: id = "trello-template-1234", type: type = "trelloTemplate", locale: locale = "en", content: content = $9bd97854e693801f$export$4be223b443e70a15() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $9bd97854e693801f$export$4be223b443e70a15({ entryTitle: entryTitle = "Example Template", title: title = "Title here", description: description = "Lorem ipsum sit dolor amet adepiscing consecutor qui", avatar: avatar = (0, $4z4jd.mock$AssetModel)(), url: url = "https://trello.com/templates/abc123", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        description: description,
        avatar: avatar,
        url: url,
        ...optionals
    };
}

});

parcelRegister("jFH3L", function(module, exports) {
function $9a32838397cd8cd9$export$456a0d4bc6682967({ id: id = "accordion-1234", type: type = "uiAccordion", locale: locale = "en", content: content = $9a32838397cd8cd9$export$4fb23d15c24e8c00() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $9a32838397cd8cd9$export$4fb23d15c24e8c00({ title: title = "Example Accordion", appearance: appearance = "List", ...optionals } = {}) {
    return {
        title: title,
        appearance: appearance,
        ...optionals
    };
}

});

parcelRegister("gxVK1", function(module, exports) {
function $2dcd39e1c8e54f5c$export$d98d828346981feb({ id: id = "accordion-item-1234", type: type = "uiAccordionItem", locale: locale = "en", content: content = $2dcd39e1c8e54f5c$export$e27b87b0c67b3460() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $2dcd39e1c8e54f5c$export$e27b87b0c67b3460({ entryTitle: entryTitle = "Example Accordion Item", title: title = "Lorem ipsum", ariaLabel: ariaLabel = "Add context to title", content: content = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas in mi consequat, tincidunt urna vel, finibus diam. Mauris vitae enim et arcu consequat mollis sed eget velit. Vivamus eu orci et enim eleifend congue. Curabitur hendrerit mattis enim. Donec consequat eu diam ut hendrerit.", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        ariaLabel: ariaLabel,
        content: content,
        ...optionals
    };
}

});

parcelRegister("gdxY9", function(module, exports) {
parcelRequire("97690");
var $hx6SC = parcelRequire("hx6SC");
function $23dd290108497743$export$363a46349f48b83a({ id: id = "some-ui-add-to-slack-section-id", locale: locale = "en", content: content = {
    entryTitle: "Add to Slack section",
    buttonText: (0, $hx6SC.mockDocument)(),
    loginText: (0, $hx6SC.mockDocument)(),
    selectTeamText: (0, $hx6SC.mockDocument)(),
    noTeamText: (0, $hx6SC.mockDocument)()
} } = {}) {
    return {
        id: id,
        type: "uiAddToSlackSection",
        locale: locale,
        content: content
    };
}

});

parcelRegister("11clp", function(module, exports) {
parcelRequire("jewli");
var $c1EPC = parcelRequire("c1EPC");
var $5qYLH = parcelRequire("5qYLH");
var $cR7iC = parcelRequire("cR7iC");
var $jOjLE = parcelRequire("jOjLE");
var $1EWMu = parcelRequire("1EWMu");
function $243beb4ecbde99d7$export$9c4e80ea117ec38d({ id: id = "stack-1234", type: type = "uiAnimatedHeroSection", locale: locale = "en", content: content = $243beb4ecbde99d7$export$4e265db088b2a0fe() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $243beb4ecbde99d7$export$4e265db088b2a0fe({ entryTitle: entryTitle = "Demo animated hero section", labels: labels = [
    "Analytics",
    "Design",
    "Engineering",
    "HR",
    "Marketing",
    "Operations",
    "Sales",
    "Startups",
    "Support"
], content: content = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfHeading)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "Work differently, together."
                })
            ]
        }),
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "Collaborate, manage projects, and reach new productivity peaks. From high rises to the home office, the way your team works is unique\u2014accomplish it all with Trello."
                })
            ]
        })
    ]
}), images: images = (0, $5qYLH.mockUiRotatingImagesModel)(), callsToAction: callsToAction = [
    (0, $cR7iC.mockUiEmailSignupModel)({
        content: (0, $cR7iC.mockUiEmailSignupModelContent)({
            buttonText: "Sign up - it\u2019s free",
            constrainInputWidth: true
        })
    }),
    (0, $jOjLE.mockUiModalModel)({
        content: (0, $jOjLE.mockUiModalModelContent)({
            modalTrigger: (0, $1EWMu.mockUiButtonModel)({
                content: (0, $1EWMu.mockUiButtonModelContent)({
                    text: "Watch video",
                    buttonTheme: (0, $1EWMu.mockLinkButtonThemeModel)({
                        content: (0, $1EWMu.mockLinkButtonThemeModelContent)({
                            style: "No padding",
                            decorator: "Play"
                        })
                    })
                })
            })
        })
    })
], background: background = [
    {
        color: "P400",
        properties: [
            {
                clip: "border-box",
                size: {
                    units: {
                        unit: "%",
                        width: 100,
                        height: 100,
                        isAutoWidth: false,
                        isAutoHeight: false
                    },
                    keyword: "auto",
                    fieldType: "keyword"
                },
                image: {
                    type: "gradient",
                    image: {
                        id: "",
                        value: "none"
                    },
                    gradient: {
                        angle: 60,
                        value: "WP400"
                    }
                },
                origin: "padding-box",
                repeat: "repeat",
                position: {
                    units: {
                        unit: "%",
                        vertical: 0,
                        horizontal: 0
                    },
                    keywords: {
                        vertical: "top",
                        horizontal: "left"
                    },
                    fieldType: "units"
                },
                blendMode: "normal",
                attachment: "scroll"
            }
        ],
        breakpoints: [
            "lg",
            "xl",
            "md",
            "sm",
            "xs"
        ]
    }
], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        labels: labels,
        content: content,
        images: images,
        callsToAction: callsToAction,
        background: background,
        ...optionals
    };
}

});

parcelRegister("58mqD", function(module, exports) {

$parcel$export(module.exports, "mockUiBlockModel", function () { return $6e5130b15771ee94$export$ffc810a730e9db3e; });
$parcel$export(module.exports, "mockUiBlockModelContent", function () { return $6e5130b15771ee94$export$acaffd33eeb7960f; });
function $6e5130b15771ee94$export$ffc810a730e9db3e({ id: id = "block-1234", type: type = "uiBlock", locale: locale = "en", content: content = $6e5130b15771ee94$export$acaffd33eeb7960f() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $6e5130b15771ee94$export$acaffd33eeb7960f({ title: title = "Lorem Ipsum", ...optionals } = {}) {
    return {
        title: title,
        ...optionals
    };
}

});

parcelRegister("1EWMu", function(module, exports) {

$parcel$export(module.exports, "mockUiButtonModel", function () { return $cd4ebbb6104d5000$export$8852069f0e0e9d92; });
$parcel$export(module.exports, "mockUiButtonModelContent", function () { return $cd4ebbb6104d5000$export$a265f341d94a87cb; });
$parcel$export(module.exports, "mockLinkButtonThemeModel", function () { return $cd4ebbb6104d5000$export$dc5da301f8bacbab; });
$parcel$export(module.exports, "mockLinkButtonThemeModelContent", function () { return $cd4ebbb6104d5000$export$307efc950c6ce796; });
function $cd4ebbb6104d5000$export$8852069f0e0e9d92({ id: id = "button-1234", type: type = "uiButton", locale: locale = "en", content: content = $cd4ebbb6104d5000$export$a265f341d94a87cb() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $cd4ebbb6104d5000$export$a265f341d94a87cb({ entryTitle: entryTitle = "Example Button", text: text = "Example button", url: url = "#example", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        text: text,
        url: url,
        ...optionals
    };
}
function $cd4ebbb6104d5000$export$dc5da301f8bacbab({ id: id = "button-theme-1234", type: type = "linkButtonTheme", locale: locale = "en", content: content = $cd4ebbb6104d5000$export$307efc950c6ce796() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $cd4ebbb6104d5000$export$307efc950c6ce796({ ...optionals } = {}) {
    return {
        ...optionals
    };
}

});

parcelRegister("66JB4", function(module, exports) {
parcelRequire("jewli");
var $jPjrf = parcelRequire("jPjrf");
var $c1EPC = parcelRequire("c1EPC");
function $1e3b559304a6bd0f$export$b3a737adc1325012({ id: id = "Callout-1234", type: type = "uiCallout", locale: locale = "en", content: content = $1e3b559304a6bd0f$export$c86380bd4a85963e() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $1e3b559304a6bd0f$export$c86380bd4a85963e({ entryTitle: entryTitle = "Example Callout", heading: heading = "Example Callout", media: media = (0, $jPjrf.mockUiImageModel)(), text: text = (0, $c1EPC.mockAdfDocument)(), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        heading: heading,
        media: media,
        text: text,
        ...optionals
    };
}

});

parcelRegister("lyL76", function(module, exports) {

var $1xdvc = parcelRequire("1xdvc");
function $0f298922f1988483$export$3bdaf4578a61547d({ id: id = "Caption-1234", type: type = "uiCaption", locale: locale = "en", content: content = $0f298922f1988483$export$df4d13679088680a() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $0f298922f1988483$export$df4d13679088680a({ title: title = "Lorem ipsum", caption: caption = (0, $1xdvc.mockCaptionModel)(), appearance: appearance = "Overlay 1", ...optionals } = {}) {
    return {
        title: title,
        caption: caption,
        appearance: appearance,
        ...optionals
    };
}

});

parcelRegister("8aN1v", function(module, exports) {

var $i6DSV = parcelRequire("i6DSV");
function $3839128b345eb811$export$ca72815252bebf27({ id: id = "Card-1234", type: type = "uiCard", locale: locale = "en", content: content = $3839128b345eb811$export$f20c0865184ba03f() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $3839128b345eb811$export$f20c0865184ba03f({ entryTitle: entryTitle = "Example Card", title: title = "Lorem ipsum", content: content = "Some card content goes here", route: route = (0, $i6DSV.mockRouteModel)({
    content: (0, $i6DSV.mockRouteModelContent)({
        path: "#test"
    })
}), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        content: content,
        route: route,
        ...optionals
    };
}

});

parcelRegister("r3iNV", function(module, exports) {
function $26496627b6186202$export$c14e90bd3c12a4a1({ id: id = "carousel-1234", type: type = "uiCarousel", locale: locale = "en", content: content = $26496627b6186202$export$a30c2d307590f487() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $26496627b6186202$export$a30c2d307590f487({ title: title = "Lorem ipsum", arrows: arrows = true, dots: dots = true, ...optionals } = {}) {
    return {
        title: title,
        arrows: arrows,
        dots: dots,
        ...optionals
    };
}

});

parcelRegister("d4LwL", function(module, exports) {

$parcel$export(module.exports, "mockUiColumnModel", function () { return $232235288cbb7801$export$30fee5dc0f845e27; });
$parcel$export(module.exports, "mockUiColumnModelContent", function () { return $232235288cbb7801$export$4ff15d27a0651634; });
function $232235288cbb7801$export$30fee5dc0f845e27({ id: id = "column-1234", type: type = "uiColumn", locale: locale = "en", content: content = $232235288cbb7801$export$4ff15d27a0651634() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $232235288cbb7801$export$4ff15d27a0651634({ title: title = "Lorem ipsum", ...optionals } = {}) {
    return {
        title: title,
        ...optionals
    };
}

});

parcelRegister("ghFfL", function(module, exports) {
function $fc23aba5c3788b7b$export$fad95db6bcea4638({ id: id = "contact-form-1234", type: type = "uiContactForm", locale: locale = "en", content: content = $fc23aba5c3788b7b$export$480211bef37adb93() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $fc23aba5c3788b7b$export$480211bef37adb93({ title: title = "Example contact form", ...optionals } = {}) {
    return {
        title: title,
        ...optionals
    };
}

});

parcelRegister("xNkXX", function(module, exports) {
function $346386cce057f714$export$182651649803eedc({ id: id = "download-button-1234", type: type = "uiDownloadButton", locale: locale = "en", content: content = $346386cce057f714$export$b17a018c6a3d0e3d() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $346386cce057f714$export$b17a018c6a3d0e3d({ entryTitle: entryTitle = "Example download button", text: text = "Download", mediaAsset: mediaAsset = {
    id: "asset-1234",
    title: "Example asset",
    url: "#download"
}, ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        text: text,
        mediaAsset: mediaAsset,
        ...optionals
    };
}

});

parcelRegister("cR7iC", function(module, exports) {

$parcel$export(module.exports, "mockUiEmailSignupModel", function () { return $7bfd1b6fa618e3ae$export$a8deaafe5cd313e4; });
$parcel$export(module.exports, "mockUiEmailSignupModelContent", function () { return $7bfd1b6fa618e3ae$export$d7f77096f7921924; });
parcelRequire("jewli");
var $1EWMu = parcelRequire("1EWMu");
function $7bfd1b6fa618e3ae$export$a8deaafe5cd313e4({ id: id = "email-signup-1234", type: type = "uiEmailSignup", locale: locale = "en", content: content = $7bfd1b6fa618e3ae$export$d7f77096f7921924() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $7bfd1b6fa618e3ae$export$d7f77096f7921924({ entryTitle: entryTitle = "Example Email Signup", emailLabel: emailLabel = "Email", buttonText: buttonText = "Sign up", theme: theme = (0, $1EWMu.mockLinkButtonThemeModel)({
    content: (0, $1EWMu.mockLinkButtonThemeModelContent)({
        appearance: "Primary"
    })
}), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        emailLabel: emailLabel,
        buttonText: buttonText,
        theme: theme,
        ...optionals
    };
}

});

parcelRegister("4Gewj", function(module, exports) {
function $4b7ef841c347d140$export$bac004f2a80dc234({ id: id = "feature-section-1234", type: type = "uiFeatureSection", locale: locale = "en", content: content = $4b7ef841c347d140$export$337d31a9bc99b52e() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $4b7ef841c347d140$export$337d31a9bc99b52e({ entryTitle: entryTitle = "value prop block entry", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        ...optionals
    };
}

});

parcelRegister("qApUh", function(module, exports) {
function $dcc88f072f9f823d$export$6ae935fd1c31cd5d({ id: id = "footer-nav-1234", type: type = "uiFooterNav", locale: locale = "en", content: content = $dcc88f072f9f823d$export$d975df6553f15148() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $dcc88f072f9f823d$export$d975df6553f15148({ entryTitle: entryTitle = "test-new-footer", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        ...optionals
    };
}

});

parcelRegister("gpr48", function(module, exports) {
function $f4a2b96b9521adf3$export$14b99d97d64ae424({ id: id = "footer-nav-basic-1234", type: type = "uiFooterNavBasic", locale: locale = "en", content: content = $f4a2b96b9521adf3$export$6c8de0fc28c1ae5c() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $f4a2b96b9521adf3$export$6c8de0fc28c1ae5c({ entryTitle: entryTitle = "Test basic footer", selectLanguageLabel: selectLanguageLabel = "Select a language", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        selectLanguageLabel: selectLanguageLabel,
        ...optionals
    };
}

});

parcelRegister("ayOep", function(module, exports) {
function $a2c8813de16e18f5$export$33b641f403fdc249({ id: id = "Guide-1234", type: type = "uiGuide", locale: locale = "en", content: content = $a2c8813de16e18f5$export$a501de45bd1c4238() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $a2c8813de16e18f5$export$a501de45bd1c4238({ title: title = "Lorem ipsum dolor sit amet, consectetur adipiscing elit", chapters: chapters = [], ...optionals } = {}) {
    return {
        title: title,
        chapters: chapters,
        ...optionals
    };
}

});

parcelRegister("8rvHt", function(module, exports) {

var $i6DSV = parcelRequire("i6DSV");
function $e1865b31bc07e9e1$export$98f332eb5049e1d5({ id: id = "GuideChapter-1234", type: type = "uiGuideChapter", locale: locale = "en", content: content = $e1865b31bc07e9e1$export$6223dd623ea846a() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $e1865b31bc07e9e1$export$6223dd623ea846a({ title: title = "Lorem ipsum dolor sit amet, consectetur adipiscing elit", route: route = (0, $i6DSV.mockRouteModel)(), category: category = "", sections: sections = [], ...optionals } = {}) {
    return {
        title: title,
        route: route,
        category: category,
        sections: sections,
        ...optionals
    };
}

});

parcelRegister("iSIBp", function(module, exports) {
function $475a2acf374d08f8$export$6bbaeeee2d39bff({ id: id = "header-1234", type: type = "uiHeaderNav", locale: locale = "en", content: content = $475a2acf374d08f8$export$eb2bcbc5b9e1ffa1() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $475a2acf374d08f8$export$eb2bcbc5b9e1ffa1({ entryTitle: entryTitle = "Lorem ipsum dolor sit amet, consectetur adipiscing elit", goBackText: goBackText = "Back", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        goBackText: goBackText,
        ...optionals
    };
}

});

parcelRegister("6q5MG", function(module, exports) {
function $0ed0f5fa02215284$export$c9a0134d9265b769({ id: id = "header-1234", type: type = "uiHeaderNavTab", locale: locale = "en", content: content = $0ed0f5fa02215284$export$62969768ab11b0ec() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $0ed0f5fa02215284$export$62969768ab11b0ec({ entryTitle: entryTitle = "Example nav tab", title: title = "Lorem", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        ...optionals
    };
}

});

parcelRegister("irWgf", function(module, exports) {
function $e1f6d8c0c7569159$export$681a148835de7b7e({ id: id = "heading-1234", type: type = "uiHeading", locale: locale = "en", content: content = $e1f6d8c0c7569159$export$877f62c2b5368c42() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $e1f6d8c0c7569159$export$877f62c2b5368c42({ entryTitle: entryTitle = "Heading", text: text = "Trello brings all your tasks, teammates, and tools together", headingLevel: headingLevel = "h1", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        text: text,
        headingLevel: headingLevel,
        ...optionals
    };
}

});

parcelRegister("kffsB", function(module, exports) {
function $71011e02cc213a0a$export$7903ab253a8085d9({ id: id = "icon-1234", type: type = "uiIcon", locale: locale = "en", content: content = $71011e02cc213a0a$export$4ef2bbdc1a24cfa1() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $71011e02cc213a0a$export$4ef2bbdc1a24cfa1({ entryTitle: entryTitle = "Lorem ipsum", icon: icon = "Box", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        icon: icon,
        ...optionals
    };
}

});

parcelRegister("jPjrf", function(module, exports) {

$parcel$export(module.exports, "mockUiImageModel", function () { return $bdd364c13f4730cd$export$80abe125d9ef5849; });
$parcel$export(module.exports, "mockUiImageModelContent", function () { return $bdd364c13f4730cd$export$9a3be7e6bbe963c3; });

var $4z4jd = parcelRequire("4z4jd");
function $bdd364c13f4730cd$export$80abe125d9ef5849({ id: id = "image-1234", type: type = "uiImage", locale: locale = "en", content: content = $bdd364c13f4730cd$export$9a3be7e6bbe963c3() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $bdd364c13f4730cd$export$9a3be7e6bbe963c3({ image: image = (0, $4z4jd.mock$AssetModel)() } = {}) {
    return {
        image: image
    };
}

});

parcelRegister("6opKE", function(module, exports) {
parcelRequire("jewli");
var $jPjrf = parcelRequire("jPjrf");
function $570ceee030c54efc$export$e1cda18f40a1bbb0({ id: id = "image-set-1234", type: type = "uiImageSet", locale: locale = "en", content: content = $570ceee030c54efc$export$68c0b6681d07b3a8() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $570ceee030c54efc$export$68c0b6681d07b3a8({ entryTitle: entryTitle = "image set", images: images = [
    (0, $jPjrf.mockUiImageModel)(),
    (0, $jPjrf.mockUiImageModel)(),
    (0, $jPjrf.mockUiImageModel)()
], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        images: images,
        ...optionals
    };
}

});

parcelRegister("9uCbh", function(module, exports) {

var $4z4jd = parcelRequire("4z4jd");
function $6e36bae61b49740a$export$a7edcc41df55845b({ id: id = "integration-1234", type: type = "uiIntegration", locale: locale = "en", content: content = $6e36bae61b49740a$export$aebef729daa8dfa9() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $6e36bae61b49740a$export$aebef729daa8dfa9({ entryTitle: entryTitle = "Integration Example", logo: logo = (0, $4z4jd.mock$AssetModel)(), title: title = "Lorem ipsum", description: description = "Lorem ipsum", buttonText: buttonText = "Lorem ipsum", buttonUrl: buttonUrl = "#lorem-ipsum", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        logo: logo,
        title: title,
        description: description,
        buttonText: buttonText,
        buttonUrl: buttonUrl,
        ...optionals
    };
}

});

parcelRegister("jpEQz", function(module, exports) {
parcelRequire("jewli");
var $i6DSV = parcelRequire("i6DSV");
function $f1cd20e3bab86055$export$2e71c1a901d9ffd9({ id: id = "integration-section-1234", type: type = "uiIntegrationSection", locale: locale = "en", content: content = $f1cd20e3bab86055$export$eb7ac968d95c2374() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $f1cd20e3bab86055$export$eb7ac968d95c2374({ entryTitle: entryTitle = "Integration Section Example", searchLabel: searchLabel = "Search all integrations", filterByText: filterByText = "Filter by:", viewAllButtonText: viewAllButtonText = "View all", viewLessButtonText: viewLessButtonText = "View less", allIntegrationsTitle: allIntegrationsTitle = "All integrations", allIntegrationsRoute: allIntegrationsRoute = (0, $i6DSV.mockRouteModel)(), allIntegrations: allIntegrations = [], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        searchLabel: searchLabel,
        filterByText: filterByText,
        viewAllButtonText: viewAllButtonText,
        viewLessButtonText: viewLessButtonText,
        allIntegrationsTitle: allIntegrationsTitle,
        allIntegrationsRoute: allIntegrationsRoute,
        allIntegrations: allIntegrations,
        ...optionals
    };
}

});

parcelRegister("6vbsO", function(module, exports) {

$parcel$export(module.exports, "mockUiLinkModel", function () { return $1e6868e00861ffe9$export$371c22dfd92e516; });
$parcel$export(module.exports, "mockUiLinkModelContent", function () { return $1e6868e00861ffe9$export$e3561d89643c1cad; });
function $1e6868e00861ffe9$export$371c22dfd92e516({ id: id = "link-1234", type: type = "uiLink", locale: locale = "en", content: content = $1e6868e00861ffe9$export$e3561d89643c1cad() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $1e6868e00861ffe9$export$e3561d89643c1cad({ entryTitle: entryTitle = "Example Link", text: text = "Example link", url: url = "#link", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        text: text,
        url: url,
        ...optionals
    };
}

});

parcelRegister("8c78l", function(module, exports) {

var $58mqD = parcelRequire("58mqD");
function $cac8d6269dde7bbe$export$ffdfb7a25cc724e7({ id: id = "link-block-1234", type: type = "uiLinkBlock", locale: locale = "en", content: content = $cac8d6269dde7bbe$export$c31479bbd1c3c50d() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $cac8d6269dde7bbe$export$c31479bbd1c3c50d({ entryTitle: entryTitle = "Example link block", title: title = "Go to Trello", url: url = "https://trello.com/home", block: block = (0, $58mqD.mockUiBlockModel)({
    content: (0, $58mqD.mockUiBlockModelContent)()
}), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        url: url,
        block: block,
        ...optionals
    };
}

});

parcelRegister("jWtro", function(module, exports) {

var $1xdvc = parcelRequire("1xdvc");
function $bb7d6bb2a896d30a$export$cdbe933811f58598({ id: id = "list-carousel-1", type: type = "uiListCarousel", locale: locale = "en", content: content = $bb7d6bb2a896d30a$export$54837fe419c5a212() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $bb7d6bb2a896d30a$export$54837fe419c5a212({ title: title = "Demo list carousel", captions: captions = [
    (0, $1xdvc.mockCaptionModel)()
], autoplay: autoplay = false, ...optionals } = {}) {
    return {
        title: title,
        captions: captions,
        autoplay: autoplay,
        ...optionals
    };
}

});

parcelRegister("9MXPj", function(module, exports) {
function $3b7292bbf9fc550e$export$d27c7caffa28a86d({ id: id = "login-container-1234", type: type = "uiLoginContainer", locale: locale = "en", content: content = $3b7292bbf9fc550e$export$acf69a3de41d9783() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $3b7292bbf9fc550e$export$acf69a3de41d9783({ title: title = "Example login container", ...optionals } = {}) {
    return {
        title: title,
        ...optionals
    };
}

});

parcelRegister("4mWFE", function(module, exports) {
parcelRequire("jewli");
var $c1EPC = parcelRequire("c1EPC");
var $6vbsO = parcelRequire("6vbsO");
var $b163B = parcelRequire("b163B");
function $3f9dd26896d9e0a6$export$c997730dee74c52a({ id: id = "login-signup-form-123", type: type = "uiLoginSignupForm", locale: locale = "en", content: content = $3f9dd26896d9e0a6$export$5079374adbd2d91() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $3f9dd26896d9e0a6$export$5079374adbd2d91({ entryTitle: entryTitle = "Example Login Signup Form", formType: formType = "signup", heading: heading = "Sign up for your account", emailFieldLabel: emailFieldLabel = "Email address", emailFieldPlaceholder: emailFieldPlaceholder = "Enter email", termsOfService: termsOfService = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "By signing up, you confirm that you've read and accepted our "
                }),
                (0, $c1EPC.mockAdfEmbeddedUiLink)({
                    model: (0, $6vbsO.mockUiLinkModel)({
                        content: (0, $6vbsO.mockUiLinkModelContent)({
                            url: "#terms",
                            text: "Terms of Service"
                        })
                    })
                }),
                (0, $c1EPC.mockAdfText)({
                    text: " and "
                }),
                (0, $c1EPC.mockAdfEmbeddedUiLink)({
                    model: (0, $6vbsO.mockUiLinkModel)({
                        content: (0, $6vbsO.mockUiLinkModelContent)({
                            url: "#privacy",
                            text: "Privacy Policy"
                        })
                    })
                }),
                (0, $c1EPC.mockAdfText)({
                    text: "."
                })
            ]
        })
    ]
}), continueButtonText: continueButtonText = "Continue", formSeparatorText: formSeparatorText = "OR", socialButtons: socialButtons = [
    (0, $b163B.mockUiSocialLoginSignupButtonModel)({
        content: (0, $b163B.mockUiSocialLoginSignupButtonModelContent)({
            providerName: "google",
            buttonText: "Continue with Google"
        })
    }),
    (0, $b163B.mockUiSocialLoginSignupButtonModel)({
        content: (0, $b163B.mockUiSocialLoginSignupButtonModelContent)({
            providerName: "microsoft",
            buttonText: "Continue with Microsoft"
        })
    }),
    (0, $b163B.mockUiSocialLoginSignupButtonModel)({
        content: (0, $b163B.mockUiSocialLoginSignupButtonModelContent)({
            providerName: "apple",
            buttonText: "Continue with Apple"
        })
    }),
    (0, $b163B.mockUiSocialLoginSignupButtonModel)({
        content: (0, $b163B.mockUiSocialLoginSignupButtonModelContent)({
            providerName: "slack",
            buttonText: "Continue with Slack"
        })
    })
], formFooterContent: formFooterContent = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfEmbeddedUiLink)({
                    model: (0, $6vbsO.mockUiLinkModel)({
                        content: (0, $6vbsO.mockUiLinkModelContent)({
                            url: "#login",
                            text: "Already have an account? Log In"
                        })
                    })
                })
            ]
        })
    ]
}), browserWarningMessage: browserWarningMessage = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "To use Trello, please use one of our "
                }),
                (0, $c1EPC.mockAdfEmbeddedUiLink)({
                    model: (0, $6vbsO.mockUiLinkModel)({
                        content: (0, $6vbsO.mockUiLinkModelContent)({
                            url: "#platforms",
                            text: "supported browsers"
                        })
                    })
                }),
                (0, $c1EPC.mockAdfText)({
                    text: ", with JavaScript and cookies enabled."
                })
            ]
        })
    ]
}), emailButtonText: emailButtonText = "Sign up with email", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        formType: formType,
        heading: heading,
        emailFieldLabel: emailFieldLabel,
        emailFieldPlaceholder: emailFieldPlaceholder,
        termsOfService: termsOfService,
        continueButtonText: continueButtonText,
        formSeparatorText: formSeparatorText,
        socialButtons: socialButtons,
        formFooterContent: formFooterContent,
        browserWarningMessage: browserWarningMessage,
        emailButtonText: emailButtonText,
        ...optionals
    };
}

});

parcelRegister("7TOUx", function(module, exports) {

$parcel$export(module.exports, "mockUiMarkdownModel", function () { return $ffdd07a2a78d1c7a$export$f907b9cfb8537921; });
$parcel$export(module.exports, "mockUiMarkdownModelContent", function () { return $ffdd07a2a78d1c7a$export$5aacec7d0c1319a1; });
function $ffdd07a2a78d1c7a$export$f907b9cfb8537921({ id: id = "markdown-1234", type: type = "uiMarkdown", locale: locale = "en", content: content = $ffdd07a2a78d1c7a$export$5aacec7d0c1319a1() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $ffdd07a2a78d1c7a$export$5aacec7d0c1319a1({ ...optionals } = {}) {
    return {
        ...optionals
    };
}

});

parcelRegister("4ki4X", function(module, exports) {
function $1eed9a6f7f73206c$export$3afced105aaf0541({ id: id = "marketo-form-1234", type: type = "uiMarketoForm", locale: locale = "en", content: content = $1eed9a6f7f73206c$export$eb3ea4024446e390() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $1eed9a6f7f73206c$export$eb3ea4024446e390({ title: title = "Marketo form title", munchkinId: munchkinId = "594-ATC-127", formId: formId = 1114, munchkinIdStg: munchkinIdStg = "353-DGC-691", formIdStg: formIdStg = 1157, successMessage: successMessage = "Thanks! Someone will reach out to you shortly.", errorMessage: errorMessage = "An error occurred while processing this request. Please try again.", ...optionals } = {}) {
    return {
        title: title,
        munchkinId: munchkinId,
        formId: formId,
        munchkinIdStg: munchkinIdStg,
        formIdStg: formIdStg,
        successMessage: successMessage,
        errorMessage: errorMessage,
        ...optionals
    };
}

});

parcelRegister("jOjLE", function(module, exports) {

$parcel$export(module.exports, "mockUiModalModel", function () { return $867ec12bbcd666ec$export$bbf6bb80fc4a95aa; });
$parcel$export(module.exports, "mockUiModalModelContent", function () { return $867ec12bbcd666ec$export$cd688509d8245287; });

var $jPjrf = parcelRequire("jPjrf");

var $1PzaA = parcelRequire("1PzaA");
function $867ec12bbcd666ec$export$bbf6bb80fc4a95aa({ id: id = "modal-1234", type: type = "uiModal", locale: locale = "en", content: content = $867ec12bbcd666ec$export$cd688509d8245287() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $867ec12bbcd666ec$export$cd688509d8245287({ title: title = "Example modal", modalTrigger: modalTrigger = (0, $jPjrf.mockUiImageModel)(), modalContent: modalContent = (0, $1PzaA.mockUiVideoPlayerModel)(), ...optionals } = {}) {
    return {
        title: title,
        modalTrigger: modalTrigger,
        modalContent: modalContent,
        ...optionals
    };
}

});
parcelRegister("1PzaA", function(module, exports) {

$parcel$export(module.exports, "mockUiVideoPlayerModel", function () { return $f01853ba35432af4$export$6ae1abe80f21f38; });
function $f01853ba35432af4$export$6ae1abe80f21f38({ id: id = "video-1234", type: type = "uiVideoPlayer", locale: locale = "en", content: content = $f01853ba35432af4$export$c9103622abf4a58e() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $f01853ba35432af4$export$c9103622abf4a58e({ videoProvider: videoProvider = "Wistia", videoId: videoId = "1z7vnaokt6", title: title = "Example Loom video" } = {}) {
    return {
        videoProvider: videoProvider,
        videoId: videoId,
        title: title
    };
}

});


parcelRegister("hRtfl", function(module, exports) {

$parcel$export(module.exports, "mockUiNavBannerModel", function () { return $577c3be94579f808$export$f710f17f358f0a98; });
$parcel$export(module.exports, "mockUiNavBannerModelContent", function () { return $577c3be94579f808$export$13ef957f95d3a475; });
function $577c3be94579f808$export$f710f17f358f0a98({ id: id = "ui-nav-banner-1234", type: type = "uiNavBanner", locale: locale = "en", content: content = $577c3be94579f808$export$13ef957f95d3a475() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $577c3be94579f808$export$13ef957f95d3a475({ entryTitle: entryTitle = "Trello Banner", titleHeading: titleHeading = "Lorem Ipsum", description: description = "Lorem ipsum sit dolor amet adepiscing consecutor qui", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        titleHeading: titleHeading,
        description: description,
        ...optionals
    };
}

});

parcelRegister("hZgu4", function(module, exports) {
parcelRequire("jewli");
var $6vbsO = parcelRequire("6vbsO");
var $hRtfl = parcelRequire("hRtfl");
var $1EWMu = parcelRequire("1EWMu");
function $d121f26cc450362e$export$f4840cc21d7883c2({ id: id = "ui-nav-blog-article-1234", type: type = "uiNavBlogArticle", locale: locale = "en", content: content = $d121f26cc450362e$export$409683d871e7c4ae() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $d121f26cc450362e$export$409683d871e7c4ae({ entryTitle: entryTitle = "Demo blog article", title: title = "Latest article", cta: cta = (0, $6vbsO.mockUiLinkModel)({
    content: (0, $6vbsO.mockUiLinkModelContent)({
        url: "https://blog.trello.com/",
        text: "More articles"
    })
}), fallback: fallback = (0, $hRtfl.mockUiNavBannerModel)({
    content: (0, $hRtfl.mockUiNavBannerModelContent)({
        titleHeading: "Helping teams work better, together",
        description: "Discover Trello use cases, productivity tips, best practices for team collaboration, and expert remote work advice.",
        button: (0, $1EWMu.mockUiButtonModel)({
            content: (0, $1EWMu.mockUiButtonModelContent)({
                url: "https://blog.trello.com",
                text: "Check out the Trello blog",
                buttonTheme: (0, $1EWMu.mockLinkButtonThemeModel)({
                    content: (0, $1EWMu.mockLinkButtonThemeModelContent)({
                        appearance: "Purple",
                        style: "Outline"
                    })
                })
            })
        })
    })
}) } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        cta: cta,
        fallback: fallback
    };
}

});

parcelRegister("foFub", function(module, exports) {

var $i6DSV = parcelRequire("i6DSV");
function $d043dd34dce8225e$export$65ae6b8f6a315d8e({ id: id = "nav-images-1234", type: type = "uiNavImages", locale: locale = "en", content: content = $d043dd34dce8225e$export$c600fb8a755e19de() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $d043dd34dce8225e$export$c600fb8a755e19de({ title: title = "This is a title", pages: pages = [
    "1",
    "2",
    "3"
].map((id)=>(0, $i6DSV.mockRouteModel)({
        id: id
    })), ...optionals } = {}) {
    return {
        title: title,
        pages: pages,
        ...optionals
    };
}

});

parcelRegister("6OeXd", function(module, exports) {
function $5317792c28ae69cf$export$dc6321d01727a824({ id: id = "ui-nav-link-1234", type: type = "uiNavLink", locale: locale = "en", content: content = $5317792c28ae69cf$export$4c2201b914da2f87() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $5317792c28ae69cf$export$4c2201b914da2f87({ entryTitle: entryTitle = "Trello Nav Link", titleHeading: titleHeading = "Lorem Ipsum", description: description = "Lorem ipsum sit dolor amet adepiscing consecutor qui", url: url = "/lorem-ipsum", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        titleHeading: titleHeading,
        description: description,
        url: url,
        ...optionals
    };
}

});

parcelRegister("9Kxp6", function(module, exports) {
parcelRequire("bLXK9");
var $c1EPC = parcelRequire("c1EPC");
var $1EWMu = parcelRequire("1EWMu");
var $4z4jd = parcelRequire("4z4jd");
parcelRequire("jewli");
var $jPjrf = parcelRequire("jPjrf");
function $c15edd315a9bb627$export$66aa31c7c6da205a({ id: id = "power-up-1234", type: type = "uiPowerUp", locale: locale = "en", content: content = $c15edd315a9bb627$export$75184ab9ba08aba3() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c15edd315a9bb627$export$75184ab9ba08aba3({ title: title = "Google Drive", description: description = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "Keep files organized alongside your projects."
                })
            ]
        })
    ]
}), button: button = (0, $1EWMu.mockUiButtonModel)({
    id: "test",
    type: "uiButton",
    locale: "en",
    content: (0, $1EWMu.mockUiButtonModelContent)({
        entryTitle: "Add Power-Up Button",
        text: "Add Power-Up",
        url: "/foo",
        buttonTheme: (0, $1EWMu.mockLinkButtonThemeModel)({
            id: "secondary-outline-reduced",
            type: "linkButtonTheme",
            locale: "en",
            content: (0, $1EWMu.mockLinkButtonThemeModelContent)({
                title: "secondary outline reduced",
                appearance: "Secondary",
                style: "Outline",
                prominence: "Reduced"
            })
        })
    })
}), logo: logo = (0, $jPjrf.mockUiImageModel)({
    id: "google-drive-icon",
    type: "uiImage",
    locale: "en",
    content: (0, $jPjrf.mockUiImageModelContent)({
        image: (0, $4z4jd.mock$AssetModel)({
            title: "Google Drive",
            url: "/ui-power-up/google-drive.png",
            width: 240,
            height: 240
        })
    })
}) } = {}) {
    return {
        title: title,
        description: description,
        button: button,
        logo: logo
    };
}

});

parcelRegister("66itQ", function(module, exports) {

var $1Fn7Y = parcelRequire("1Fn7Y");
function $c88399340601b322$export$9e3aad48c3bd00a3({ id: id = "pricing-calculator-1234", type: type = "uiPricingCalculator", locale: locale = "en", content: content = $c88399340601b322$export$7005b08067dbc0f2() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c88399340601b322$export$7005b08067dbc0f2({ title: title = "Pricing Calculator", userCountLabel: userCountLabel = "How many users?", priceLabel: priceLabel = "Your price:", annualTotalText: annualTotalText = "Total per year", perUserPerMonthText: perUserPerMonthText = "Per user per month", averagePricePerUserText: averagePricePerUserText = "Average price per user", usdText: usdText = "USD", generalError: generalError = "Please enter a number", minUsersError: minUsersError = "50 user minimum", maxUsersError: maxUsersError = "10,000,000 user maximum", plan: plan = (0, $1Fn7Y.mockUiPricingPlanModel)({
    content: (0, $1Fn7Y.mockUiPricingPlanModelContent)({
        pricing: [
            {
                at: 250,
                above: 0
            },
            {
                at: 150,
                above: 300
            },
            {
                at: 100,
                above: 500
            },
            {
                at: 50,
                above: 1000
            },
            {
                at: 45,
                above: 5000
            },
            {
                at: 39,
                above: 10000
            },
            {
                at: 35,
                above: 30000
            },
            {
                at: 29,
                above: 50000
            }
        ]
    })
}) } = {}) {
    return {
        title: title,
        userCountLabel: userCountLabel,
        priceLabel: priceLabel,
        annualTotalText: annualTotalText,
        perUserPerMonthText: perUserPerMonthText,
        averagePricePerUserText: averagePricePerUserText,
        usdText: usdText,
        generalError: generalError,
        minUsersError: minUsersError,
        maxUsersError: maxUsersError,
        plan: plan
    };
}

});
parcelRegister("1Fn7Y", function(module, exports) {

$parcel$export(module.exports, "mockUiPricingPlanModel", function () { return $7b0bbf6e4c00c069$export$9dd1353325955c4d; });
$parcel$export(module.exports, "mockUiPricingPlanModelContent", function () { return $7b0bbf6e4c00c069$export$85883d97e48f128; });
function $7b0bbf6e4c00c069$export$9dd1353325955c4d({ id: id = "pricing-plan-1234", type: type = "uiPricingPlan", locale: locale = "en", content: content = $7b0bbf6e4c00c069$export$85883d97e48f128() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $7b0bbf6e4c00c069$export$85883d97e48f128({ title: title = "Example pricing plan", highlight: highlight = false, ...optionals } = {}) {
    return {
        title: title,
        highlight: highlight,
        ...optionals
    };
}

});


parcelRegister("hnhzO", function(module, exports) {

$parcel$export(module.exports, "mockUiPricingComparisonRowModel", function () { return $57b43d93c38aeca9$export$6234f4cf4ba4d1c4; });

var $emjGG = parcelRequire("emjGG");
function $57b43d93c38aeca9$export$6234f4cf4ba4d1c4({ id: id = "pricing-comparison-row-1234", type: type = "uiPricingComparisonRow", locale: locale = "en", content: content = $57b43d93c38aeca9$export$4e54b23bd95de8ca() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $57b43d93c38aeca9$export$4e54b23bd95de8ca({ entryTitle: entryTitle = "Demo pricing comparison Row", title: title = "Demo pricing comparison Row", freeValue: freeValue = (0, $emjGG.mockUiPricingComparisonValueModel)({
    content: (0, $emjGG.mockUiPricingComparisonValueModelContent)({})
}), standardValue: standardValue = (0, $emjGG.mockUiPricingComparisonValueModel)({
    content: (0, $emjGG.mockUiPricingComparisonValueModelContent)({})
}), premiumValue: premiumValue = (0, $emjGG.mockUiPricingComparisonValueModel)({
    content: (0, $emjGG.mockUiPricingComparisonValueModelContent)({})
}), enterpriseValue: enterpriseValue = (0, $emjGG.mockUiPricingComparisonValueModel)({
    content: (0, $emjGG.mockUiPricingComparisonValueModelContent)({})
}), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        freeValue: freeValue,
        standardValue: standardValue,
        premiumValue: premiumValue,
        enterpriseValue: enterpriseValue,
        ...optionals
    };
}

});
parcelRegister("emjGG", function(module, exports) {

$parcel$export(module.exports, "mockUiPricingComparisonValueModel", function () { return $c8eed8461f0d3e54$export$24959c97840146ce; });
$parcel$export(module.exports, "mockUiPricingComparisonValueModelContent", function () { return $c8eed8461f0d3e54$export$770c7f890b52a053; });

var $c1EPC = parcelRequire("c1EPC");
function $c8eed8461f0d3e54$export$24959c97840146ce({ id: id = "pricing-comparison-value-1234", type: type = "uiPricingComparisonValue", locale: locale = "en", content: content = $c8eed8461f0d3e54$export$770c7f890b52a053() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c8eed8461f0d3e54$export$770c7f890b52a053({ entryTitle: entryTitle = "Demo pricing comparison value", value: value = (0, $c1EPC.mockAdfDocument)(), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        value: value,
        ...optionals
    };
}

});


parcelRegister("5PPc2", function(module, exports) {

var $hnhzO = parcelRequire("hnhzO");
function $36b1f719850ff557$export$ddde4c0d738aab0({ id: id = "pricing-comparison-table-1234", type: type = "uiPricingComparisonTable", locale: locale = "en", content: content = $36b1f719850ff557$export$89626b5004132671() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $36b1f719850ff557$export$89626b5004132671({ entryTitle: entryTitle = "Demo pricing comparison table", title: title = "Demo pricing comparison table", featureColumnHeader: featureColumnHeader = "Features", rows: rows = [
    (0, $hnhzO.mockUiPricingComparisonRowModel)()
], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        featureColumnHeader: featureColumnHeader,
        rows: rows,
        ...optionals
    };
}

});

parcelRegister("5JUIj", function(module, exports) {
function $8a7b9c58578465c8$export$cb7655366bffee24({ id: id = "pricing-table-1234", type: type = "uiPricingGrid", locale: locale = "en", content: content = $8a7b9c58578465c8$export$60236c07053d9dd5() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $8a7b9c58578465c8$export$60236c07053d9dd5({ title: title = "Lorem ipsum", plans: plans = [], ...optionals } = {}) {
    return {
        title: title,
        plans: plans,
        ...optionals
    };
}

});

parcelRegister("9TF1T", function(module, exports) {
function $cdb42101a7c4c1d1$export$7e759d7c7c5b8494({ id: id = "Quote-1234", type: type = "uiQuote", locale: locale = "en", content: content = $cdb42101a7c4c1d1$export$912f0af9d8be1eb1() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $cdb42101a7c4c1d1$export$912f0af9d8be1eb1({ entryTitle: entryTitle = "eBay", quote: quote = "Everyone loves it; it has democratized our finance function. In some ways Trello shattered hierarchy and brought us together.", attribution: attribution = "__BHARATH SUNDAR__ - Finance, eBay\n\nIndustry: __eCommerce__", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        quote: quote,
        attribution: attribution,
        ...optionals
    };
}

});

parcelRegister("99gNz", function(module, exports) {

var $c1EPC = parcelRequire("c1EPC");
function $ed1d3cb0fd05a5d2$export$6af9b43774cba7d0({ id: id = "recommend-share-1234", type: type = "uiRecommendShare", locale: locale = "en", content: content = $ed1d3cb0fd05a5d2$export$d3fb2acbcc6b42d5() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $ed1d3cb0fd05a5d2$export$d3fb2acbcc6b42d5({ emailButtonLabel: emailButtonLabel = "Email", facebookButtonLabel: facebookButtonLabel = "Share", label: label = "Your custom share link", loggedOutText: loggedOutText = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "Login",
                    marks: [
                        (0, $c1EPC.mockAdfLink)({
                            attrs: {
                                href: "/login?returnUrl=%2Frecommend"
                            }
                        })
                    ]
                }),
                (0, $c1EPC.mockAdfText)({
                    text: " and we\u2019ll give you a link you can use to get credit for your referrals."
                })
            ]
        })
    ]
}), messages: messages = [
    "You need @trello! It's like organization powered by rocket fuel. (And it's free!)"
], twitterButtonLabel: twitterButtonLabel = "Tweet" } = {}) {
    return {
        emailButtonLabel: emailButtonLabel,
        facebookButtonLabel: facebookButtonLabel,
        label: label,
        loggedOutText: loggedOutText,
        messages: messages,
        twitterButtonLabel: twitterButtonLabel
    };
}

});

parcelRegister("5qYLH", function(module, exports) {

$parcel$export(module.exports, "mockUiRotatingImagesModel", function () { return $69a709664a4cab9c$export$c3048347649af31b; });

var $4z4jd = parcelRequire("4z4jd");

var $jPjrf = parcelRequire("jPjrf");
function $69a709664a4cab9c$export$c3048347649af31b({ id: id = "rotating-images-1234", type: type = "uiRotatingImages", locale: locale = "en", content: content = $69a709664a4cab9c$export$8e1e1ab05676ec02() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
const $69a709664a4cab9c$var$viewDemoImages = [
    "map",
    "board",
    "calendar",
    "dash-cards",
    "table",
    "timeline"
];
function $69a709664a4cab9c$export$8e1e1ab05676ec02({ entryTitle: entryTitle = "Rotating images demo", items: items = $69a709664a4cab9c$var$viewDemoImages.map((id)=>(0, $jPjrf.mockUiImageModel)({
        id: id,
        content: (0, $jPjrf.mockUiImageModelContent)({
            image: (0, $4z4jd.mock$AssetModel)({
                title: id,
                url: `/ui-rotating-images/${id}.png`,
                width: 1836,
                height: 968
            })
        })
    })) } = {}) {
    return {
        entryTitle: entryTitle,
        items: items
    };
}

});

parcelRegister("55a0J", function(module, exports) {

var $4z4jd = parcelRequire("4z4jd");

var $d4LwL = parcelRequire("d4LwL");

var $jPjrf = parcelRequire("jPjrf");

var $7TOUx = parcelRequire("7TOUx");

var $lJ0QS = parcelRequire("lJ0QS");
function $c51c9914cdcee827$export$9dbe5e0a9ac4de44({ id: id = "rotating-items-1234", type: type = "uiRotatingItems", locale: locale = "en", content: content = $c51c9914cdcee827$export$ef61b80aee0a7e02() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c51c9914cdcee827$export$ef61b80aee0a7e02({ title: title = "Ui Rotating Items", items: items = [
    (0, $lJ0QS.mockUiSectionModel)({
        id: "1",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "S500"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 1",
                                        url: "/ui-rotating-items/set-01-image@2x.png",
                                        width: 998,
                                        height: 902
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 1st section",
                                        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "2",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "C300"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 2",
                                        url: "/ui-rotating-items/set-02-image@2x.png",
                                        width: 1200,
                                        height: 910
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 2nd section",
                                        "Nullam nulla est, pharetra non tempus eget, consectetur ut velit."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "3",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "WP400"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 3",
                                        url: "/ui-rotating-items/set-03-image@2x.png",
                                        width: 882,
                                        height: 886
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 3rd section",
                                        "Proin commodo nisi eget leo luctus pretium."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "4",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "S400"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 5,
                                offset: 1,
                                bottom: "none",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 4",
                                        url: "/ui-rotating-items/set-04-image@2x.png",
                                        width: 730,
                                        height: 1160
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "none",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 4th section",
                                        "Pellentesque molestie sit amet lectus vel sollicitudin."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "5",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "WP300"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 5",
                                        url: "/ui-rotating-items/set-05-image@2x.png",
                                        width: 992,
                                        height: 1010
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 5th section",
                                        "In malesuada gravida tortor non aliquet."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "6",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Center",
            background: {
                angle: 120,
                gradient: "C500"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 7,
                                bottom: "cozy",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 6",
                                        url: "/ui-rotating-items/set-06-image@2x.png",
                                        width: 1200,
                                        height: 944
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 5,
                                bottom: "none",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 6th section",
                                        "Curabitur sagittis velit quam, ac auctor urna maximus eu."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $lJ0QS.mockUiSectionModel)({
        id: "7",
        content: (0, $lJ0QS.mockUiSectionModelContent)({
            verticalAlign: "Bottom",
            background: {
                angle: 120,
                gradient: "CP500"
            },
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                span: 6,
                                bottom: "none",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        title: "Image 7",
                                        url: "/ui-rotating-items/set-07-image@2x.png",
                                        width: 1012,
                                        height: 1126
                                    })
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            md: {
                                align: "left",
                                span: 6,
                                bottom: "outerspace",
                                top: "cozy"
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    textSize: "Large",
                                    content: [
                                        "# 7th section",
                                        "Quisque semper enim sed metus pellentesque porttitor."
                                    ].join("\n\n")
                                })
                            })
                        ]
                    })
                })
            ]
        })
    })
] } = {}) {
    return {
        title: title,
        items: items
    };
}

});
parcelRegister("lJ0QS", function(module, exports) {

$parcel$export(module.exports, "mockUiSectionModel", function () { return $7f63e02d0c805586$export$2a7dc02383fc183c; });
$parcel$export(module.exports, "mockUiSectionModelContent", function () { return $7f63e02d0c805586$export$6733e51bf602e7f; });
function $7f63e02d0c805586$export$2a7dc02383fc183c({ id: id = "section-1234", type: type = "uiSection", locale: locale = "en", content: content = $7f63e02d0c805586$export$6733e51bf602e7f() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $7f63e02d0c805586$export$6733e51bf602e7f({ ...optionals } = {}) {
    return {
        ...optionals
    };
}

});


parcelRegister("e6tNd", function(module, exports) {
function $e635e6bb792fc7e4$export$be3eabc969c06802({ id: id = "section-group-1234", type: type = "uiSectionGroup", locale: locale = "en", content: content = $e635e6bb792fc7e4$export$9c24585b41b8e638() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $e635e6bb792fc7e4$export$9c24585b41b8e638({ entryTitle: entryTitle = "Demo section group", sections: sections = [], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        sections: sections,
        ...optionals
    };
}

});

parcelRegister("b163B", function(module, exports) {

$parcel$export(module.exports, "mockUiSocialLoginSignupButtonModel", function () { return $c43dc966e416ee5a$export$b8c45668014888f6; });
$parcel$export(module.exports, "mockUiSocialLoginSignupButtonModelContent", function () { return $c43dc966e416ee5a$export$e1cf7ae9e0ca9d57; });
function $c43dc966e416ee5a$export$b8c45668014888f6({ id: id = "button-1234", type: type = "uiSocialLoginSignupButton", locale: locale = "en", content: content = $c43dc966e416ee5a$export$e1cf7ae9e0ca9d57() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c43dc966e416ee5a$export$e1cf7ae9e0ca9d57({ entryTitle: entryTitle = "Example Social Login Signup Button", providerName: providerName = "google", buttonText: buttonText = "Continue with Google", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        providerName: providerName,
        buttonText: buttonText,
        ...optionals
    };
}

});

parcelRegister("gM6H4", function(module, exports) {
parcelRequire("jewli");
var $c1EPC = parcelRequire("c1EPC");
var $jPjrf = parcelRequire("jPjrf");
var $4z4jd = parcelRequire("4z4jd");
function $5c4eae111a12b3a9$export$16dc9facdf0ec75f({ id: id = "SocialProof-1234", type: type = "uiSocialProof", locale: locale = "en", content: content = $5c4eae111a12b3a9$export$70362dbf9dc43118() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $5c4eae111a12b3a9$export$70362dbf9dc43118({ entryTitle: entryTitle = "Women Who Code", customerQuote: customerQuote = (0, $c1EPC.mockAdfDocument)({
    content: [
        (0, $c1EPC.mockAdfParagraph)({
            content: [
                (0, $c1EPC.mockAdfText)({
                    text: "[Trello is] great for simplifying complex processes. As a manager, I can chunk [processes] down into bite-sized pieces for my team and then delegate that out, but still keep a bird's-eye view"
                })
            ]
        })
    ]
}), customerDetails: customerDetails = "Global Leadership Director at Women Who Code", customerLogoImage: customerLogoImage = (0, $jPjrf.mockUiImageModel)({
    content: (0, $jPjrf.mockUiImageModelContent)({
        image: (0, $4z4jd.mock$AssetModel)({
            url: "/ui-social-proof/women-who-code.svg"
        })
    })
}), customerName: customerName = "Joey Rosenberg", productFact: productFact = "75% of organizations report that Trello delivers value to their business within 30 days.", background: background = $5c4eae111a12b3a9$var$uiSocialProofBackground("P300", "WP300"), ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        customerQuote: customerQuote,
        customerDetails: customerDetails,
        customerLogoImage: customerLogoImage,
        customerName: customerName,
        productFact: productFact,
        background: background,
        ...optionals
    };
}
function $5c4eae111a12b3a9$var$uiSocialProofBackground(color, gradient) {
    return [
        {
            breakpoints: [
                "xs",
                "sm",
                "md",
                "lg",
                "xl"
            ],
            color: color,
            properties: [
                {
                    attachment: "scroll",
                    blendMode: "normal",
                    clip: "border-box",
                    image: {
                        type: "gradient",
                        image: {
                            id: "",
                            value: "none"
                        },
                        gradient: {
                            value: gradient,
                            angle: 60
                        }
                    },
                    origin: "padding-box",
                    position: {
                        fieldType: "units",
                        keywords: {
                            horizontal: "left",
                            vertical: "top"
                        },
                        units: {
                            unit: "%",
                            horizontal: 0,
                            vertical: 0
                        }
                    },
                    repeat: "repeat",
                    size: {
                        fieldType: "keyword",
                        keyword: "auto",
                        units: {
                            unit: "%",
                            width: 100,
                            height: 100,
                            isAutoWidth: false,
                            isAutoHeight: false
                        }
                    }
                }
            ]
        }
    ];
}

});

parcelRegister("caPpv", function(module, exports) {
function $7c0fb7224070cf60$export$218dfd102735686({ id: id = "SocialShare-1234", type: type = "uiSocialShare", locale: locale = "en", content: content = $7c0fb7224070cf60$export$8846bfe2379ec54c() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $7c0fb7224070cf60$export$8846bfe2379ec54c({ text: text = "Lorem Ipsum", twitterButtonText: twitterButtonText = "Tweet", facebookButtonText: facebookButtonText = "Share", ...optionals } = {}) {
    return {
        text: text,
        twitterButtonText: twitterButtonText,
        facebookButtonText: facebookButtonText,
        ...optionals
    };
}

});

parcelRegister("7jB5b", function(module, exports) {
function $b7f146ccdc91006f$export$8bb777bee10d0acf({ id: id = "spacer-1234", type: type = "uiSpacer", locale: locale = "en", content: content = $b7f146ccdc91006f$export$43a6ad563f5bdcd8() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $b7f146ccdc91006f$export$43a6ad563f5bdcd8({ entryTitle: entryTitle = "spacer-test", size: size = "1" } = {}) {
    return {
        entryTitle: entryTitle,
        size: size
    };
}

});

parcelRegister("6T6U4", function(module, exports) {
function $2556d0fc65d50910$export$78ce4126da51d1c({ id: id = "split-section-1234", type: type = "uiSplitSection", locale: locale = "en", content: content = $2556d0fc65d50910$export$807a90bdb267071b() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $2556d0fc65d50910$export$807a90bdb267071b({ entryTitle: entryTitle = "Test split section", useEyebrowLogo: useEyebrowLogo = false, ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        useEyebrowLogo: useEyebrowLogo,
        ...optionals
    };
}

});

parcelRegister("l9tcl", function(module, exports) {
function $c78eb2bbf160a89e$export$16259bbdb99a4f1c({ id: id = "stack-1234", type: type = "uiStack", locale: locale = "en", content: content = $c78eb2bbf160a89e$export$62836ef96b363d67() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $c78eb2bbf160a89e$export$62836ef96b363d67({ title: title = "Example stack", spacing: spacing = "none", orientation: orientation = "horizontal", fullHeight: fullHeight = false, ...optionals } = {}) {
    return {
        title: title,
        spacing: spacing,
        orientation: orientation,
        fullHeight: fullHeight,
        ...optionals
    };
}

});

parcelRegister("eXBuX", function(module, exports) {
function $dae96f2b95c1322f$export$9bc522f362a42a3({ id: id = "StatusPage-1234", type: type = "uiStatuspage", locale: locale = "en", content: content = $dae96f2b95c1322f$export$53cf4b120158d49b() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $dae96f2b95c1322f$export$53cf4b120158d49b({ title: title = "Example Statuspage component", statuspageId: statuspageId = "trello", none: none = "All systems \uD83D\uDC4D", minor: minor = "Minor incident!", major: major = "Major incident!", critical: critical = "Critical incident!", url: url = "https://trello.status.atlassian.com/", ...optionals } = {}) {
    return {
        title: title,
        statuspageId: statuspageId,
        none: none,
        minor: minor,
        major: major,
        critical: critical,
        url: url,
        ...optionals
    };
}

});

parcelRegister("22i1M", function(module, exports) {

var $1xdvc = parcelRequire("1xdvc");
function $5e63978932902f03$export$9962b15f090e757b({ id: id = "ui-storyline-1234", type: type = "uiStoryline", locale: locale = "en", content: content = $5e63978932902f03$export$7396e93a6fdfcf12() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $5e63978932902f03$export$7396e93a6fdfcf12({ title: title = "Title here", stories: stories = [
    (0, $1xdvc.mockCaptionModel)()
], ...optionals } = {}) {
    return {
        title: title,
        stories: stories,
        ...optionals
    };
}

});

parcelRegister("gzLQt", function(module, exports) {

var $jHhLr = parcelRequire("jHhLr");
parcelRequire("jewli");
var $d4LwL = parcelRequire("d4LwL");
var $7TOUx = parcelRequire("7TOUx");
var $jPjrf = parcelRequire("jPjrf");
var $4z4jd = parcelRequire("4z4jd");
function $1e628f0c3c96a007$export$347ad77515224e6d({ id: id = "tab-panel-1234", type: type = "uiTabPanel", locale: locale = "en", content: content = $1e628f0c3c96a007$export$5d88c98fafc212c0() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $1e628f0c3c96a007$export$5d88c98fafc212c0({ entryTitle: entryTitle = "Example Tab Panel Component", tabs: tabs = [
    (0, $jHhLr.mockUiTabModel)({
        content: (0, $jHhLr.mockUiTabModelContent)({
            buttonText: "Cards",
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "1",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 2
                            },
                            md: {
                                span: 5,
                                order: 1
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    content: `## Manage tasks with ease 

 \u{2713} &nbsp; **Members:** Keep everyone accountable and never have to ask \u{201C}who\u{2019}s doing that\u{201D} by adding members to cards for their projects and tasks. 

 \u{2713} &nbsp; **Due dates:** They're easy to set, hard to miss (with reminders!), and oh-so-satisfying to mark as \u{201C}done.\u{201D} 

 \u{2713} &nbsp; **Attachments:** No more digging through endless email chains to find attachments. Just drag and drop them onto a card so the right files stay with the right tasks. 

 \u{2713} &nbsp; **Checklists:** Your best tool to overpower overwhelming asks. Break big tasks into small ones, check things off the list, and watch that status bar go to 100% complete.`
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "2",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 1
                            },
                            md: {
                                span: 6,
                                offset: 1,
                                order: 2
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        url: "/ui-tab-panel/cards.png"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $jHhLr.mockUiTabModel)({
        content: (0, $jHhLr.mockUiTabModelContent)({
            buttonText: "Views",
            title: "Bring powerful new views to your team\u2019s work.",
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "3",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 2
                            },
                            md: {
                                span: 5,
                                order: 1
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    content: `\u{2713} &nbsp; **Success starts with a Trello board:** Similar to a Kanban board, a Trello board is the easiest way to go from idea to action. Plan projects and break down each step of the way to getting things done. 

 \u{2713} &nbsp; **Hit deadlines every time with Timeline:** Stay on top of every sprint and stay on track of every goal. Use Timeline to see how all of the moving parts piece together over time and drag and drop dates to make adjustments on the fly. 

 \u{2713} &nbsp; **Use Calendar to stay on top of tasks:** Whether scheduling a quarterly editorial calendar or staying on top of your to-dos, Calendar is like a crystal ball giving you a clear vision of what work lies ahead.`
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "4",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 1
                            },
                            md: {
                                span: 6,
                                offset: 1,
                                order: 2
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        url: "/ui-tab-panel/views.png"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }),
    (0, $jHhLr.mockUiTabModel)({
        content: (0, $jHhLr.mockUiTabModelContent)({
            buttonText: "Automation",
            title: "Create rules, buttons, and commands in Trello.",
            columns: [
                (0, $d4LwL.mockUiColumnModel)({
                    id: "5",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 2
                            },
                            md: {
                                span: 5,
                                order: 1
                            }
                        },
                        blocks: [
                            (0, $7TOUx.mockUiMarkdownModel)({
                                content: (0, $7TOUx.mockUiMarkdownModelContent)({
                                    content: `\u{2713} &nbsp; **Rules for boards:** Setting rules means important tasks won\u{2019}t fall through the cracks. Set a trigger and the actions to be performed, and let Butler run the show. 

 \u{2713} &nbsp; **Move work forward:** Get to the next step faster with custom card and board buttons. Perform a series of actions in a single click! 

 \u{2713} &nbsp; **Integrate your favorite apps:** Extend beyond your boards with integrations. Post messages to Slack, create Jira tickets, and send emails right from your boards. 

 \u{2713} &nbsp; **Intelligent automation tips:** As you use a Trello board, Butler will recognize repetitive actions and suggest automations that can be enabled in a single click.`
                                })
                            })
                        ]
                    })
                }),
                (0, $d4LwL.mockUiColumnModel)({
                    id: "6",
                    content: (0, $d4LwL.mockUiColumnModelContent)({
                        properties: {
                            xs: {
                                align: "left",
                                order: 1
                            },
                            md: {
                                span: 6,
                                offset: 1,
                                order: 2
                            }
                        },
                        blocks: [
                            (0, $jPjrf.mockUiImageModel)({
                                content: (0, $jPjrf.mockUiImageModelContent)({
                                    image: (0, $4z4jd.mock$AssetModel)({
                                        url: "/ui-tab-panel/automation.png"
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    })
] } = {}) {
    return {
        entryTitle: entryTitle,
        tabs: tabs
    };
}

});
parcelRegister("jHhLr", function(module, exports) {

$parcel$export(module.exports, "mockUiTabModel", function () { return $3b8c3904a0d17ca2$export$4c225535a3ec24b7; });
$parcel$export(module.exports, "mockUiTabModelContent", function () { return $3b8c3904a0d17ca2$export$11a1a7b29f8e9303; });
parcelRequire("jewli");
var $d4LwL = parcelRequire("d4LwL");
var $7TOUx = parcelRequire("7TOUx");
var $jPjrf = parcelRequire("jPjrf");
var $4z4jd = parcelRequire("4z4jd");
function $3b8c3904a0d17ca2$export$4c225535a3ec24b7({ id: id = "tab-1234", type: type = "uiTab", locale: locale = "en", content: content = $3b8c3904a0d17ca2$export$11a1a7b29f8e9303() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $3b8c3904a0d17ca2$export$11a1a7b29f8e9303({ entryTitle: entryTitle = "Example Tab Component", buttonText: buttonText = "Example", columns: columns = [
    (0, $d4LwL.mockUiColumnModel)({
        id: "1",
        content: (0, $d4LwL.mockUiColumnModelContent)({
            properties: {
                xs: {
                    align: "left",
                    order: 2
                },
                md: {
                    span: 5,
                    order: 1
                }
            },
            blocks: [
                (0, $7TOUx.mockUiMarkdownModel)({
                    content: (0, $7TOUx.mockUiMarkdownModelContent)({
                        content: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    })
                })
            ]
        })
    }),
    (0, $d4LwL.mockUiColumnModel)({
        id: "2",
        content: (0, $d4LwL.mockUiColumnModelContent)({
            properties: {
                xs: {
                    align: "left",
                    order: 1
                },
                md: {
                    span: 6,
                    offset: 1,
                    order: 2
                }
            },
            blocks: [
                (0, $jPjrf.mockUiImageModel)({
                    content: (0, $jPjrf.mockUiImageModelContent)({
                        image: (0, $4z4jd.mock$AssetModel)({
                            url: "/ui-callout/calendar-view.png"
                        })
                    })
                })
            ]
        })
    })
], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        buttonText: buttonText,
        columns: columns,
        ...optionals
    };
}

});


parcelRegister("lFPYW", function(module, exports) {

var $30lGq = parcelRequire("30lGq");
function $506cdab26d788f9b$export$5681542479834845({ id: id = "ui-template-gallery-1234", type: type = "uiTemplateGallery", locale: locale = "en", content: content = $506cdab26d788f9b$export$fbd9e6bc6ed31e98() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $506cdab26d788f9b$export$fbd9e6bc6ed31e98({ title: title = "Title here", templates: templates = [
    (0, $30lGq.mockTrelloTemplateModel)()
], ...optionals } = {}) {
    return {
        title: title,
        templates: templates,
        ...optionals
    };
}

});

parcelRegister("bw2q1", function(module, exports) {

var $c1EPC = parcelRequire("c1EPC");
function $59f4b6f67f3b1ad0$export$10ae4987c6810bb7({ id: id = "text-block-1234", type: type = "uiTextBlock", locale: locale = "en", content: content = $59f4b6f67f3b1ad0$export$3b35fb005ba337c4() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $59f4b6f67f3b1ad0$export$3b35fb005ba337c4({ text: text = (0, $c1EPC.mockAdfDocument)(), ...optionals } = {}) {
    return {
        text: text,
        ...optionals
    };
}

});

parcelRegister("ki2oO", function(module, exports) {

$parcel$export(module.exports, "mockUiTooltipModel", function () { return $050a246b5264f72e$export$b494be1b043574bf; });
$parcel$export(module.exports, "mockUiTooltipModelContent", function () { return $050a246b5264f72e$export$56f1e9c4940a1ab8; });

var $c1EPC = parcelRequire("c1EPC");
function $050a246b5264f72e$export$b494be1b043574bf({ id: id = "tooltip-1234", type: type = "uiTooltip", locale: locale = "en", content: content = $050a246b5264f72e$export$56f1e9c4940a1ab8() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $050a246b5264f72e$export$56f1e9c4940a1ab8({ triggerText: triggerText = "Example tooltip", tooltipText: tooltipText = (0, $c1EPC.mockAdfDocument)() } = {}) {
    return {
        triggerText: triggerText,
        tooltipText: tooltipText
    };
}

});

parcelRegister("dKI7P", function(module, exports) {
function $8fda098cd737408c$export$48c6a9fc6cc8b7bf({ id: id = "trello-board-1234", type: type = "uiTrelloBoard", locale: locale = "en", content: content = $8fda098cd737408c$export$5de9e2fedfd80578() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $8fda098cd737408c$export$5de9e2fedfd80578({ layout: layout = "Mobile", ...optionals } = {}) {
    return {
        layout: layout,
        ...optionals
    };
}
function $8fda098cd737408c$export$edd34a25e3fdc15c({ id: id = "trello-list-1234", type: type = "uiTrelloList", locale: locale = "en", content: content = $8fda098cd737408c$export$6be966eaa9390c15() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $8fda098cd737408c$export$6be966eaa9390c15({ ...optionals } = {}) {
    return {
        ...optionals
    };
}
function $8fda098cd737408c$export$edac827ac6b8e162({ id: id = "trello-card-1234", type: type = "uiTrelloCard", locale: locale = "en", content: content = $8fda098cd737408c$export$dc4d522df2ed20eb() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $8fda098cd737408c$export$dc4d522df2ed20eb({ name: name = "Lorem ipsum dolor sit amet, consectetur adipiscing elit", ...optionals } = {}) {
    return {
        name: name,
        ...optionals
    };
}

});

parcelRegister("2ZHHC", function(module, exports) {
function $e24b0cafed873bd0$export$432bbca89e5b5d89({ id: id = "value-prop-1234", type: type = "uiValueProp", locale: locale = "en", content: content = $e24b0cafed873bd0$export$6de7699cae421609() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $e24b0cafed873bd0$export$6de7699cae421609({ ...optionals } = {}) {
    return {
        ...optionals
    };
}

});

parcelRegister("125zO", function(module, exports) {
function $7cafece0d6e616bc$export$b982a3f2cfde12d9({ id: id = "variation-container-1234", type: type = "uiVariationContainer", locale: locale = "en", content: content = $7cafece0d6e616bc$export$c8693649f0677784() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $7cafece0d6e616bc$export$c8693649f0677784({ entryTitle: entryTitle = "Variation Container Example", featureFlagName: featureFlagName = "Example Feature Flag", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        featureFlagName: featureFlagName,
        ...optionals
    };
}

});

parcelRegister("203rx", function(module, exports) {

var $4z4jd = parcelRequire("4z4jd");
function $bba03d6035cc0d40$export$e47360af49dc7a4e({ id: id = "video-1234", type: type = "uiVideo", locale: locale = "en", content: content = $bba03d6035cc0d40$export$e2ea8a18f68164ca() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $bba03d6035cc0d40$export$e2ea8a18f68164ca({ poster: poster = (0, $4z4jd.mock$AssetModel)(), ...optionals } = {}) {
    return {
        title: "Test video title",
        poster: poster,
        ...optionals
    };
}

});

parcelRegister("lLNir", function(module, exports) {
function $0a15ba6d21fc9444$export$ecd4f9a9b7c83e0f({ id: id = "webinar-link-1234", type: type = "uiWebinarLink", locale: locale = "en", content: content = $0a15ba6d21fc9444$export$92b021804e690892() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $0a15ba6d21fc9444$export$92b021804e690892({ entryTitle: entryTitle = "Example webinar link", title: title = "Lorem ipsum dolor sit amet", url: url = "/foo/bar", ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        title: title,
        url: url,
        ...optionals
    };
}

});

parcelRegister("kP9Dy", function(module, exports) {
function $83686911a57ebeb2$export$6f4980e3be77dda8({ id: id = "some-ui-workspace-picker-id", locale: locale = "en", content: content = $83686911a57ebeb2$export$36fe209c3ecf2882() } = {}) {
    return {
        id: id,
        type: "uiWorkspacePicker",
        locale: locale,
        content: content
    };
}
function $83686911a57ebeb2$export$36fe209c3ecf2882({ entryTitle: entryTitle = "Lorem Ipsum", dropdownTitle: dropdownTitle = "This is a picker", noCreditsLeft: noCreditsLeft = "No credits", noEligibleAdmin: noEligibleAdmin = "No admin", noWorkspace: noWorkspace = "No Workspace", noWorkspaceUrl: noWorkspaceUrl = "http://www.trello/hello-world", invalidLoginToken: invalidLoginToken = "Login", urlAppendix: urlAppendix = "/some-url" } = {}) {
    return {
        entryTitle: entryTitle,
        dropdownTitle: dropdownTitle,
        noCreditsLeft: noCreditsLeft,
        noEligibleAdmin: noEligibleAdmin,
        noWorkspace: noWorkspace,
        noWorkspaceUrl: noWorkspaceUrl,
        invalidLoginToken: invalidLoginToken,
        urlAppendix: urlAppendix
    };
}

});

parcelRegister("1V2s8", function(module, exports) {
function $39e2c09fd44d918b$export$52336c6ba55e993({ id: id = "variation-container-1234", type: type = "variationItem", locale: locale = "en", content: content = $39e2c09fd44d918b$export$27f71d6dff53b157() } = {}) {
    return {
        id: id,
        type: type,
        locale: locale,
        content: content
    };
}
function $39e2c09fd44d918b$export$27f71d6dff53b157({ entryTitle: entryTitle = "Variation Item Example", variationValue: variationValue = "EXPCEN-0000-var1", variationName: variationName = "bxptFeatureFlagExample", variation: variation = [], ...optionals } = {}) {
    return {
        entryTitle: entryTitle,
        variationValue: variationValue,
        variationName: variationName,
        variation: variation,
        ...optionals
    };
}

});



parcelRegister("lBdjQ", function(module, exports) {
parcelRequire("fdYd7");

});
parcelRegister("fdYd7", function(module, exports) {
const $07e0dfebed00af9c$export$527cdbeeae0341a2 = " | Trello";

});



parcelRegister("l7Ope", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return $f3d99821b8f39b23$export$60332b2344f7fe41; });
$parcel$export(module.exports, "CardLink", function () { return $f3d99821b8f39b23$export$94b4c87f5c7de894; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $a7xVp = parcelRequire("a7xVp");
var $kL1mL = parcelRequire("kL1mL");
var $2EK56 = parcelRequire("2EK56");
const $f3d99821b8f39b23$var$cardCSS = (0, $hYbro.css)`
    background-color: ${(0, $i2LPb.colorCSS)("N0")};
    box-shadow: ${(0, $a7xVp.shadow).normal};
    color: ${(0, $i2LPb.colorCSS)("N800")} !important;
    display: block;
    min-height: 100%;
    overflow: hidden;
    padding: 8rem 1rem 1.5rem;
    position: relative;
    text-align: left;

    p {
        margin: 0.75rem auto 0;
        font-size: ${(0, $kL1mL.fontSizes).sm};
        min-height: 4.5rem;
    }

    &:before {
        content: "";
        display: block;
        height: 6.2rem;
        inset-inline-start: 0;
        position: absolute;
        inset-inline-end: 0;
        inset-block-start: 0;
        ${({ $decoration: $decoration })=>$decoration ? (0, $2EK56.generateFieldsStyles)($decoration) : `background-color: ${(0, $i2LPb.colorCSS)("N100")};`}
    }
`;
const $f3d99821b8f39b23$export$60332b2344f7fe41 = (0, $hYbro.styled).article`
    ${$f3d99821b8f39b23$var$cardCSS}

    p {
        margin-bottom: 2.5rem;
    }

    a {
        position: absolute;
        bottom: 1rem;
        left: 1rem;
        ${({ $appearance: $appearance })=>!$appearance && `
            color: inherit !important;
            font-size: ${(0, $kL1mL.fontSizes).sm};
            text-decoration: underline;
            text-underline-offset: 0.3rem;
            padding: 0 0 .5rem;
        `}
    }
`;
const $f3d99821b8f39b23$export$94b4c87f5c7de894 = (0, $hYbro.styled).a`
    ${$f3d99821b8f39b23$var$cardCSS}
    text-decoration: none;

    h3 {
        text-decoration: underline;
        text-underline-offset: 0.3rem;
    }
`;

});



parcelRegister("joINu", function(module, exports) {

$parcel$export(module.exports, "UiCarousel", function () { return (parcelRequire("i4EQ3")).default; });

var $i4EQ3 = parcelRequire("i4EQ3");

});
parcelRegister("i4EQ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3746bb563ae395b1$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $1TMwu = parcelRequire("1TMwu");

var $33PqJ = parcelRequire("33PqJ");

var $ffxLO = parcelRequire("ffxLO");
const $3746bb563ae395b1$var$UiCarousel = ({ model: model })=>{
    const { blocks: blocks, arrows: arrows = true, dots: dots, title: title, dotLabel: dotLabel, prevArrowLabel: prevArrowLabel, nextArrowLabel: nextArrowLabel } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventColumn: title,
            eventComponent: model.type
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1TMwu.Carousel), {
            arrows: arrows,
            dotsOnDesktop: dots,
            dotsOnMobile: true,
            dotLabel: dotLabel,
            prevArrowLabel: prevArrowLabel,
            nextArrowLabel: nextArrowLabel,
            children: blocks?.map((block)=>//so shadows won't be hidden by carousel's overflow-hidden
                block.type === "uiBlock" && block.content.shadow ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $ffxLO.ShadowWrapper), {
                    children: (0, $33PqJ.renderViewModel)(block)
                }, block.id) : (0, $33PqJ.renderViewModel)(block))
        })
    });
};
var $3746bb563ae395b1$export$2e2bcd8739ae039 = $3746bb563ae395b1$var$UiCarousel;

});
parcelRegister("ffxLO", function(module, exports) {

$parcel$export(module.exports, "ShadowWrapper", function () { return $41a249d1cdea4bba$export$4ebb490b3ccfc72f; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $41a249d1cdea4bba$export$4ebb490b3ccfc72f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
`;

});



parcelRegister("3987v", function(module, exports) {

$parcel$export(module.exports, "UiColumn", function () { return (parcelRequire("bJVkU")).default; });

var $bJVkU = parcelRequire("bJVkU");

});
parcelRegister("bJVkU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91c831b674f09bee$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");
const $91c831b674f09bee$var$UiColumn = ({ model: model })=>{
    const { title: title, blocks: blocks = [], elementId: elementId, properties: properties = {}, background: background } = model.content;
    if ((0, $5l0yg.isColumnProperties)(properties)) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
        id: elementId,
        className: "ui-column",
        backgroundField: background,
        ...properties,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
            value: {
                eventContainer: "uiColumn",
                labelEnglish: title
            },
            children: (0, $33PqJ.renderViewModels)(blocks)
        })
    });
    else throw new Error("TODO: handle case where properties does not pass schema check.");
};
var $91c831b674f09bee$export$2e2bcd8739ae039 = $91c831b674f09bee$var$UiColumn;

});


parcelRegister("k90ou", function(module, exports) {

$parcel$export(module.exports, "UiContactForm", function () { return (parcelRequire("7QvR0")).default; });

var $7QvR0 = parcelRequire("7QvR0");

});
parcelRegister("7QvR0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7d1c57e199438daa$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $5XW95 = parcelRequire("5XW95");
var $fuZB8 = parcelRequire("fuZB8");
var $82f25 = parcelRequire("82f25");

var $kcqyB = parcelRequire("kcqyB");
const $7d1c57e199438daa$var$UiContactForm = ({ model: model })=>{
    const member = (0, $5XW95.useMember)();
    const language = (0, $fuZB8.useLanguage)();
    const { button: button } = model.content;
    const [formOpen, setFormOpen] = (0, $iSvIT.useState)(!button); //if button exists, form starts closed
    //get user info
    const userid = member.status === "resolved" ? member.value.id : "";
    const email = member.status === "resolved" ? member.value.email : "";
    const username = member.status === "resolved" ? member.value.fullName : "";
    //load script
    (0, $iSvIT.useEffect)(()=>{
        //wait for member status to be resolved
        if (member.status === "pending") return;
        const script = document.createElement("script");
        script.async = true;
        script.src = `https://support-form-app-ui.${location.host === "trello.com" ? "prod-east" : "stg-east"}.frontend.public.atl-paas.net/assets/js-app-shim.js`;
        script.onload = ()=>{
            window.locale = language;
            window.jsAppShim({
                appTargetId: "support-form-app",
                assetManifest: "https://support-form-app-ui." + (location.host === "trello.com" ? "prod-east" : "stg-east") + `.frontend.public.atl-paas.net/assets/asset-manifest.json?v=${new Date().getTime()}`,
                position: "after",
                scripts: [
                    "trello.js"
                ],
                target: "#new-support-form-app"
            });
        };
        document.body.appendChild(script);
    }, [
        member,
        language
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            !formOpen && button?.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                ...button.content.buttonTheme?.content,
                onClick: ()=>{
                    setFormOpen(true);
                },
                url: button.content.url,
                children: button.content.text
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kcqyB.ContactFormContainer), {
                "data-trelloemail": email,
                "data-trellouserid": userid,
                "data-trellousername": username,
                id: "new-support-form-app-container",
                "data-open": formOpen,
                children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    id: "new-support-form-app"
                })
            })
        ]
    });
};
var $7d1c57e199438daa$export$2e2bcd8739ae039 = $7d1c57e199438daa$var$UiContactForm;

});
parcelRegister("kcqyB", function(module, exports) {

$parcel$export(module.exports, "ContactFormContainer", function () { return $bec30b0de3d4a2c8$export$a7d24dcdb3d6f02e; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");
var $aY5bH = parcelRequire("aY5bH");

var $jAJVK = parcelRequire("jAJVK");
// Convert object syntax to template literal for SSR compatibility
const $bec30b0de3d4a2c8$var$contactFormStyles = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

    #support-form-contact-title {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }

    div#support-form-app h5 {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }

    a[type="button"] {
        ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
    }

    .ak-message,
    #trello-login,
    section,
    .confirmation {
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}

        p {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}

            &:last-child {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.25rem")}
            }
        }

        span[role="presentation"] {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0.1rem")}
        }
    }

    .ak-message.warning,
    .ak-message.warning-1 {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("R50")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("R75")}`)}
    }

    #trello-login {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B50")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("B75")}`)}
    }

    .confirmation {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("G50")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("G75")}`)}

        h1#content_title {
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}

            br {
                ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
            }
        }

        .ak-message {
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
        }

        p#bottom-text {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.25rem")}
        }
    }

    ${(0, $aY5bH.formCSS)}

    form {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "1.5rem")}

        label {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
            ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.2")}

            > div {
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "normal")}
            }

            &[role="presentation"] {
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("R500")}`)}
            }
        }

        input,
        textarea,
        .custom-ak-select__control,
        button {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        }

        .custom-ak-select__menu > div {
            ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "0")}
        }

        .custom-ak-select__single-value {
            ${(0, $jAJVK.redundantCssFromKebab)("overflow", "visible")}
        }

        .custom-ak-select__value-container {
            ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0")}
        }

        #react-select-inquiryCategory-input {
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        }

        .custom-ak-select__control,
        .dropzone {
            ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("N20")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
        }

        .custom-ak-select__control,
        .dropzone,
        input,
        textarea {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
        }

        input,
        textarea {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        }

        .dropzone {
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}

            a[type="button"] {
                ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
                ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 !important")}
                ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "baseline")}
            }
        }

        #dropzone-attached-files {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}

            .dropzone-pill-wrapper {
                ${(0, $jAJVK.redundantCssFromKebab)("border-top", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
                ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 0")}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

                .dropzone-pill-text {
                    ${(0, $jAJVK.redundantCssFromKebab)("flex-grow", "1")}
                }

                .dropzone-pill-button {
                    ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
                }
            }
        }

        .form-error-message {
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("R500")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "-0.5rem 0 1.5rem")}

            h4,
            p {
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "normal")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}
            }
        }

        .captcha-field {
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "2rem 0 1rem")}
        }

        button[type="submit"] {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
        }

        .ak-field-group {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}

            input[type="checkbox"] {
                ${(0, $jAJVK.redundantCssFromKebab)("float", "left")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.4rem 0.25rem 0 0")}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
            }
        }
    }

    &[data-open="true"] {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }
`;
const $bec30b0de3d4a2c8$export$a7d24dcdb3d6f02e = (0, $hYbro.styled).div`
    ${$bec30b0de3d4a2c8$var$contactFormStyles}
`;

});



parcelRegister("8K0lh", function(module, exports) {

$parcel$export(module.exports, "UiDownloadButton", function () { return (parcelRequire("kLKPJ")).default; });

var $kLKPJ = parcelRequire("kLKPJ");

});
parcelRegister("kLKPJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $978fb24c2ea8e09d$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $82f25 = parcelRequire("82f25");
const $978fb24c2ea8e09d$var$UiDownloadButton = ({ model: model })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { entryTitle: entryTitle, text: text, buttonTheme: buttonTheme, mediaAsset: { url: url } } = model.content;
    const theme = buttonTheme?.content ? {
        ...buttonTheme.content
    } : {};
    const props = {
        onClick: ()=>sendTrackEvent("clickedUiDownloadButton", {
                event: "clicked",
                eventComponent: "button",
                eventContainer: "content",
                label: text,
                labelEnglish: entryTitle,
                uuid: model.id,
                href: url,
                theme: theme
            }),
        url: url,
        ...theme
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
        ...props,
        "data-uuid": model.id,
        children: text
    });
};
var $978fb24c2ea8e09d$export$2e2bcd8739ae039 = $978fb24c2ea8e09d$var$UiDownloadButton;

});


parcelRegister("6HVQO", function(module, exports) {

$parcel$export(module.exports, "UiEmailSignup", function () { return (parcelRequire("9mqJn")).default; });

var $9mqJn = parcelRequire("9mqJn");

});
parcelRegister("9mqJn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9c7ebdc3c301756d$export$2e2bcd8739ae039; });
/* eslint-disable complexity */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $aSdFq = parcelRequire("aSdFq");
var $82f25 = parcelRequire("82f25");
var $8HF11 = parcelRequire("8HF11");

var $youKs = parcelRequire("youKs");
const $9c7ebdc3c301756d$var$UiEmailSignup = ({ model: model })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { buttonLabel: buttonLabel, buttonText: buttonText, constrainInputWidth: constrainInputWidth, emailLabel: emailLabel, entryTitle: entryTitle, hideEmailInput: hideEmailInput, theme: theme } = model.content;
    const [email, setEmail] = (0, $iSvIT.useState)("");
    const signupUrl = (0, $aSdFq.useIdentityUrl)({
        email: email
    });
    const trackEvent = ()=>{
        sendTrackEvent("submittedUiEmailSignup", {
            event: "submitted",
            eventComponent: model.type,
            eventContainer: "content",
            href: "/signup_redirect",
            label: buttonText,
            labelEnglish: entryTitle,
            uuid: model.id
        });
    };
    const handleSubmit = async (e)=>{
        e.preventDefault();
        trackEvent();
        const recaptcha_key = window.location.href?.includes("trello.com") ? "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD" : "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";
        // Only attempt reCAPTCHA if the script has loaded
        if (typeof window !== "undefined" && window.grecaptcha) try {
            await new Promise((resolve)=>{
                window.grecaptcha.ready(()=>resolve());
            });
            await window.grecaptcha.execute(recaptcha_key, {
                action: "trello_submit"
            });
        } catch (error) {
            console.error("reCAPTCHA error:", error);
        // Continue with signup even if reCAPTCHA fails
        }
        location.assign(signupUrl);
    };
    // BXPT-1430: Remove link to AA signup link from <form> after experimentation is completed
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $youKs.Form), {
        action: signupUrl,
        "data-testid": "ui-email-signup-form",
        "data-uuid": model.id,
        onSubmit: handleSubmit,
        hideEmailInput: hideEmailInput,
        children: hideEmailInput ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
            appearance: theme?.content?.appearance,
            prominence: theme?.content?.prominence,
            style: theme?.content?.style,
            "aria-label": buttonLabel,
            onClick: trackEvent,
            url: signupUrl,
            children: buttonText
        }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $youKs.InputEmail), {
                    "aria-label": emailLabel,
                    $bxpProminence: (0, $8HF11.getProminence)(theme?.content?.prominence, theme?.content?.style),
                    $isWidthConstrained: constrainInputWidth,
                    "data-testid": "ui-email-signup-input",
                    name: "email",
                    onChange: (e)=>setEmail(e.currentTarget.value),
                    placeholder: emailLabel,
                    type: "email"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8HF11.BxpButton), {
                    $bxpAppearance: (0, $8HF11.getAppearance)(theme?.content?.appearance, theme?.content?.style),
                    $bxpProminence: (0, $8HF11.getProminence)(theme?.content?.prominence, theme?.content?.style),
                    $bxpSpacing: (0, $8HF11.getSpacing)(),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                        type: "submit",
                        "aria-label": buttonLabel,
                        children: buttonText
                    })
                })
            ]
        })
    });
};
var $9c7ebdc3c301756d$export$2e2bcd8739ae039 = $9c7ebdc3c301756d$var$UiEmailSignup;

});
parcelRegister("youKs", function(module, exports) {

$parcel$export(module.exports, "Form", function () { return $d405e00471781391$export$a7fed597f4b8afd8; });
$parcel$export(module.exports, "InputEmail", function () { return $d405e00471781391$export$497a6aaf7dad75ee; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $aT9Ik = parcelRequire("aT9Ik");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $d405e00471781391$export$a7fed597f4b8afd8 = (0, $hYbro.styled).form`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}

    @media ${(0, $aT9Ik.maxWidth).md} {
        /* BxpButton wrapper */
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Styling for child/nested elements */
        > div {
            ${(0, $jAJVK.redundantCssFromKebab)("flex-grow", "1")}

            a,
            button {
                ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
            }
        }
    }

    /* BXPT-1430: Remove this after experimentation is completed */
    ${({ hideEmailInput: hideEmailInput })=>hideEmailInput && `
            + span[class*="ModalTrigger"] {
                display: inline-block;
                margin-block-start: 1rem;
            }
            
            @media ${(0, $aT9Ik.minWidth).lg} {
                display: inline-flex;

                + span[class*="ModalTrigger"] {
                    margin-inline-start: 1rem;
                    margin-block-start: 0;
                }
            }
        `}

    .xs-text-left & {
        justify-content: start;
    }
    .xs-text-center & {
        justify-content: center;
    }

    @media ${(0, $aT9Ik.minWidth).sm} {
        .sm-text-left & {
            justify-content: start;
        }
        .sm-text-center & {
            justify-content: center;
        }
    }
    @media ${(0, $aT9Ik.minWidth).md} {
        flex-wrap: wrap;

        .md-text-left & {
            justify-content: start;
        }
        .md-text-center & {
            justify-content: center;
        }
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        .lg-text-left & {
            justify-content: start;
        }
        .lg-text-center & {
            justify-content: center;
        }
    }
    @media ${(0, $aT9Ik.minWidth).xl} {
        .xl-text-left & {
            justify-content: start;
        }
        .xl-text-center & {
            justify-content: center;
        }
    }
`;
const $d405e00471781391$export$497a6aaf7dad75ee = (0, $hYbro.styled).input`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    ${({ $bxpProminence: $bxpProminence })=>$bxpProminence};
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.3rem")}
    max-width: ${(props)=>props.$isWidthConstrained ? 300 : 376}px;
    ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "0.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-right", "0.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "250ms ease-out")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "376px")}

    &::placeholder {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N80")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", "1")}
    }

    @media ${(0, $aT9Ik.minWidth).md} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }
`;

});



parcelRegister("AsXlI", function(module, exports) {

$parcel$export(module.exports, "UiFeatureSection", function () { return (parcelRequire("idgGb")).default; });

var $idgGb = parcelRequire("idgGb");

});
parcelRegister("idgGb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c332bc5a0e08855$export$2e2bcd8739ae039; });
/* eslint-disable complexity */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $6vqJG = parcelRequire("6vqJG");

var $33PqJ = parcelRequire("33PqJ");

var $90Gfw = parcelRequire("90Gfw");

var $4C3lD = parcelRequire("4C3lD");
const $5c332bc5a0e08855$var$UiFeatureSection = ({ model: model })=>{
    const { entryTitle: entryTitle, appearance: appearance, title: title, eyebrow: eyebrow, horizontalRule: horizontalRule, bodyCopy: bodyCopy, horizontalOrientation: horizontalOrientation, verticalOrientation: verticalOrientation, media: media, callsToAction: callsToAction } = model.content;
    const verticalAlignment = verticalOrientation === "Image bottom" ? "bottom" : "top";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventColumn: title,
            labelEnglish: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
                verticalAlign: verticalAlignment,
                children: [
                    media && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                        md: (0, $4C3lD.getVariantMedia)(appearance, horizontalOrientation, verticalOrientation),
                        xs: !appearance && verticalOrientation === "Image bottom" ? {
                            order: "3"
                        } : {
                            order: "1"
                        },
                        children: (0, $33PqJ.renderViewModel)(media)
                    }),
                    appearance?.length === 5 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                        md: {
                            order: "2",
                            span: "1"
                        }
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Column), {
                        md: (0, $4C3lD.getVariantText)(appearance, horizontalOrientation, verticalOrientation),
                        xs: !appearance && verticalOrientation === "Image bottom" ? {
                            order: "1"
                        } : {
                            order: "3"
                        },
                        children: [
                            (title || eyebrow) && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $90Gfw.TitlesContainer), {
                                children: [
                                    eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)((0, $90Gfw.Eyebrow), {
                                        children: eyebrow
                                    }),
                                    title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $90Gfw.Title), {
                                        children: title
                                    })
                                ]
                            }),
                            horizontalRule && /*#__PURE__*/ (0, $loA2J.jsx)((0, $90Gfw.HorizontalLine), {}),
                            bodyCopy && /*#__PURE__*/ (0, $loA2J.jsx)((0, $90Gfw.BodyCopy), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                                    children: bodyCopy
                                })
                            }),
                            callsToAction && /*#__PURE__*/ (0, $loA2J.jsx)((0, $90Gfw.CTAs), {
                                appearance: appearance,
                                children: (0, $33PqJ.renderViewModels)(callsToAction)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $5c332bc5a0e08855$export$2e2bcd8739ae039 = $5c332bc5a0e08855$var$UiFeatureSection;

});
parcelRegister("90Gfw", function(module, exports) {

$parcel$export(module.exports, "TitlesContainer", function () { return $dc45443d4ed84528$export$f2edc0624664f4a4; });
$parcel$export(module.exports, "Title", function () { return $dc45443d4ed84528$export$f99233281efd08a0; });
$parcel$export(module.exports, "Eyebrow", function () { return $dc45443d4ed84528$export$71f050e2efa708bb; });
$parcel$export(module.exports, "HorizontalLine", function () { return $dc45443d4ed84528$export$a7746b673cb91227; });
$parcel$export(module.exports, "BodyCopy", function () { return $dc45443d4ed84528$export$5dacd22121771a60; });
$parcel$export(module.exports, "CTAs", function () { return $dc45443d4ed84528$export$ffb2b01a4b3107d7; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $kL1mL = parcelRequire("kL1mL");
// Styled-components for SSR CSS generation
const $dc45443d4ed84528$var$EyebrowStyled = (0, $hYbro.default).p({
    "fontSize": (0, $kL1mL.fontSizes).sm,
    "font-size": (0, $kL1mL.fontSizes).sm,
    "lineHeight": 1.25,
    "line-height": 1.25,
    "textTransform": "uppercase",
    "text-transform": "uppercase",
    "fontWeight": 700,
    "font-weight": 700,
    "marginBlockStart": 0,
    "margin-block-start": 0,
    "marginBlockEnd": "1rem",
    "margin-block-end": "1rem"
});
const $dc45443d4ed84528$var$HorizontalLineStyled = (0, $hYbro.default).hr({
    "marginTop": 0,
    "margin-top": 0
});
const $dc45443d4ed84528$var$TitlesContainerStyled = (0, $hYbro.default).div({
    "@media (min-width: 768px)": {
        textAlign: "left"
    }
});
const $dc45443d4ed84528$export$f2edc0624664f4a4 = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($dc45443d4ed84528$var$TitlesContainerStyled, {
        ...props
    });
};
const $dc45443d4ed84528$var$TitleStyled = (0, $hYbro.default).h2({
    "paddingBottom": "1rem",
    "@media (max-width: 767.98px)": {
        paddingBottom: "0.5rem"
    }
});
const $dc45443d4ed84528$export$f99233281efd08a0 = (props)=>{
    return;
};
const $dc45443d4ed84528$export$71f050e2efa708bb = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($dc45443d4ed84528$var$EyebrowStyled, {
        ...props
    });
const $dc45443d4ed84528$export$a7746b673cb91227 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($dc45443d4ed84528$var$HorizontalLineStyled, {
        role: "presentation",
        ...props
    });
const $dc45443d4ed84528$var$BodyCopyStyled = (0, $hYbro.default).div({});
const $dc45443d4ed84528$export$5dacd22121771a60 = (props)=>{
    const className = `bodycopy-markdown ${props.className || ""}`;
    return /*#__PURE__*/ (0, $loA2J.jsx)($dc45443d4ed84528$var$BodyCopyStyled, {
        ...props,
        className: className
    });
};
const $dc45443d4ed84528$var$CTAsStyled = (0, $hYbro.default).div({
    "@media (min-width: 768px)": {
        textAlign: "left"
    }
});
const $dc45443d4ed84528$export$ffb2b01a4b3107d7 = ({ appearance: appearance, ...props })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($dc45443d4ed84528$var$CTAsStyled, {
        ...props
    });
};

});

parcelRegister("4C3lD", function(module, exports) {

$parcel$export(module.exports, "getVariantText", function () { return $5330730cfdca176c$export$e20a441cc00fb56c; });
$parcel$export(module.exports, "getVariantMedia", function () { return $5330730cfdca176c$export$48d276ae9c490bc8; });
function $5330730cfdca176c$export$e20a441cc00fb56c(appearance, horizontalOrientation, verticalOrientation) {
    const sequence = horizontalOrientation === "Image left" ? "3" : "1";
    const cols = appearance ? horizontalOrientation === "Image left" ? appearance.charAt(appearance.length - 1) : appearance.charAt(0) : "";
    const defaultOrder = !appearance && verticalOrientation === "Image bottom" ? "1" : "3";
    return appearance ? {
        span: cols,
        order: sequence,
        align: "left"
    } : {
        span: "8",
        order: defaultOrder,
        align: "center",
        offset: "2"
    };
}
function $5330730cfdca176c$export$48d276ae9c490bc8(appearance, horizontalOrientation, verticalOrientation) {
    const sequence = horizontalOrientation === "Image left" ? "1" : "3";
    const cols = appearance ? horizontalOrientation === "Image left" ? appearance.charAt(0) : appearance.charAt(appearance.length - 1) : "";
    const alignment = horizontalOrientation === "Image left" ? "left" : "right";
    const defaultOrder = !appearance && verticalOrientation === "Image bottom" ? "3" : "1";
    return appearance ? {
        span: cols,
        order: sequence,
        align: alignment
    } : {
        span: "8",
        order: defaultOrder,
        align: "center",
        offset: "2"
    };
} //Appearances:
 // '7/5'
 // '5/7'
 // '6/1/5'
 // '5/1/6'
 // '8/4'
 // '4/8'
 // '7/1/4'
 // '4/1/7'
 // '6/6'

});



parcelRegister("bBU2O", function(module, exports) {

$parcel$export(module.exports, "UiFooterNav", function () { return (parcelRequire("34Qin")).default; });

var $34Qin = parcelRequire("34Qin");

});
parcelRegister("34Qin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b473817a7c51e7e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $eOLtZ = parcelRequire("eOLtZ");
var $kzY5l = parcelRequire("kzY5l");
var $8OmrV = parcelRequire("8OmrV");
var $aSdFq = parcelRequire("aSdFq");
var $eSKWD = parcelRequire("eSKWD");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $yF2IO = parcelRequire("yF2IO");
var $82f25 = parcelRequire("82f25");
var $ipl9a = parcelRequire("ipl9a");

var $33PqJ = parcelRequire("33PqJ");

var $egGVw = parcelRequire("egGVw");

var $6QpTg = parcelRequire("6QpTg");
const $3b473817a7c51e7e$var$UiFooterNav = ({ model: model })=>{
    const isLoggedIn = (0, $eOLtZ.useIsLoggedIn)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { id: id, content: { tabs: tabs, subNavLinks: subNavLinks, logInText: logInText, selectLanguageLabel: selectLanguageLabel, hideLanguageSelector: hideLanguageSelector = false, useEyebrowLogo: useEyebrowLogo } } = model;
    const { setFooterHeight: setFooterHeight } = (0, $8OmrV.useFooterContext)();
    const footerRef = (0, $iSvIT.useRef)(null);
    const identityLoginUrl = (0, $aSdFq.useIdentityUrl)({
        isLogin: true
    });
    const { privacyLink: privacyLink } = (0, $eSKWD.useOnetrust)();
    (0, $iSvIT.useEffect)(()=>{
        function handleResize() {
            if (footerRef.current) {
                const height = footerRef.current.offsetHeight;
                setFooterHeight(height);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        footerRef,
        setFooterHeight
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: "globalFooter"
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6QpTg.Footer), {
            ref: footerRef,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
                            verticalAlign: "Top",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                    xs: {
                                        align: "left",
                                        bottom: "none"
                                    },
                                    lg: {
                                        span: "2"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6QpTg.LogoAndLoginContainer), {
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $yF2IO.LogoTrello), {
                                                appearance: "white",
                                                eyebrow: useEyebrowLogo
                                            }),
                                            !isLoggedIn && logInText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                                                url: identityLoginUrl,
                                                onClick: ()=>sendTrackEvent("clickedFooterLogin", {
                                                        event: "clicked",
                                                        eventComponent: "link",
                                                        eventContainer: "globalFooter",
                                                        label: logInText,
                                                        labelEnglish: "Log in - footer",
                                                        uuid: id,
                                                        href: "/login"
                                                    }),
                                                "data-uuid": id,
                                                testId: "login",
                                                children: logInText
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                    lg: {
                                        span: "10"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6QpTg.TabsList), {
                                        children: tabs && tabs.map((tab, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                                children: (0, $33PqJ.renderViewModel)(tab)
                                            }, `tabs_${index}`))
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6QpTg.Divider), {}),
                /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
                            verticalAlign: "center",
                            children: [
                                !hideLanguageSelector && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                    xs: {
                                        align: "left",
                                        top: "none"
                                    },
                                    lg: {
                                        span: "2",
                                        top: "compact"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ipl9a.LanguageSelectForm), {
                                        selectLanguageLabel: selectLanguageLabel
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                    xs: {
                                        top: "none"
                                    },
                                    lg: {
                                        span: `${hideLanguageSelector ? "9" : "7"}`,
                                        align: "left",
                                        top: "compact"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6QpTg.SubNav), {
                                        hideLanguageSelector: hideLanguageSelector,
                                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                                            children: [
                                                privacyLink,
                                                subNavLinks?.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                                                        children: (0, $33PqJ.renderViewModel)(item)
                                                    }, `subNav_${index}`))
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                    lg: {
                                        span: "3",
                                        order: "12"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $egGVw.SocialNav), {})
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
var $3b473817a7c51e7e$export$2e2bcd8739ae039 = $3b473817a7c51e7e$var$UiFooterNav;

});
parcelRegister("egGVw", function(module, exports) {

$parcel$export(module.exports, "SocialNav", function () { return $d6c1f08a7cea751e$export$5da53c35c61a093; });

var $loA2J = parcelRequire("loA2J");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $6QpTg = parcelRequire("6QpTg");
const $d6c1f08a7cea751e$export$5da53c35c61a093 = ()=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6QpTg.SocialNavLinks), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                href: "https://www.instagram.com/trelloapp/",
                title: "Instagram",
                onClick: ()=>sendTrackEvent("clickedSocialNav", {
                        event: "clicked",
                        eventComponent: "link",
                        eventContainer: "globalFooter",
                        label: "Instagram",
                        labelEnglish: "Instagram",
                        uuid: "instagram",
                        href: "https://www.instagram.com/trelloapp/"
                    }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    height: "16",
                    viewBox: "0 0 16 16",
                    width: "16",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m7.9365485 4.00948853c2.1378796 0 3.8773322 1.74591892 3.8773322 3.89174604 0 2.14582713-1.7394526 3.89174603-3.8773322 3.89174603-2.13787961 0-3.87703593-1.7459189-3.87703593-3.89174603 0-2.14582712 1.73915632-3.89174604 3.87703593-3.89174604zm0 1.39893537c-1.36946341 0-2.48357803 1.11825631-2.48357803 2.49281067 0 1.37455435 1.11411462 2.49281063 2.48357803 2.49281063 1.36975965 0 2.483578-1.11825628 2.483578-2.49281063 0-1.37455436-1.11381835-2.49281067-2.483578-2.49281067zm4.1036506-2.58676679c.5095127 0 .9227511.41477468.9227511.92618144 0 .5117041-.4132384.92647878-.9227511.92647878-.5098089 0-.9230474-.41477468-.9230474-.92647878 0-.51140676.4132385-.92618144.9230474-.92618144zm-7.31121058-1.33500953c-1.79099628 0-3.24784704 1.46226656-3.24784704 3.25992082v6.3093323c0 1.7976543 1.45685076 3.2599209 3.24784704 3.2599209h6.28566818c1.7909963 0 3.2481433-1.4622666 3.2481433-3.2599209v-6.3093323c0-1.79765426-1.457147-3.25992082-3.2481433-3.25992082zm6.28566818 14.31582152h-6.28566818c-2.60740146 0-4.72898852-2.1291766-4.72898852-4.7465684v-6.3093323c0-2.61739173 2.12158706-4.7465684 4.72898852-4.7465684h6.28566818c2.6076977 0 4.7292848 2.12917667 4.7292848 4.7465684v6.3093323c0 2.6173918-2.1215871 4.7465684-4.7292848 4.7465684z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                href: "https://www.facebook.com/trelloapp/",
                title: "Facebook",
                onClick: ()=>sendTrackEvent("clickedSocialNav", {
                        event: "clicked",
                        eventComponent: "link",
                        eventContainer: "globalFooter",
                        label: "Facebook",
                        labelEnglish: "Facebook",
                        uuid: "facebook",
                        href: "https://www.facebook.com/trelloapp/"
                    }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    height: "16",
                    viewBox: "0 0 8 16",
                    width: "8",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m1.61157724 7.96343677v7.63998533c0 .1097869.08892957.199047.19830983.199047h2.82684468c.10938027 0 .19799997-.0892601.19799997-.199047v-7.76438973h2.04940817c.10287322 0 .1887042-.07930781.19738025-.18225245l.1970704-2.33942478c.00991549-.1160071-.08118309-.21584163-.19738026-.21584163h-2.24647856v-1.65986573c0-.38876376.31419714-.70412892.70183089-.70412892h1.57935189c.10969013 0 .19830983-.08926016.19830983-.19904704v-2.33942478c0-.11009789-.0886197-.19904704-.19830983-.19904704h-2.66850667c-1.56602795 0-2.83583059 1.27421209-2.83583059 2.8460617v2.25545181h-1.41326741c-.10938026 0-.19830983.08926015-.19830983.19904704v2.33942477c0 .10978689.08892957.19904705.19830983.19904705h1.41326741z"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                href: "https://www.linkedin.com/company/atlassian/",
                title: "LinkedIn",
                onClick: ()=>sendTrackEvent("clickedSocialNav", {
                        event: "clicked",
                        eventComponent: "link",
                        eventContainer: "globalFooter",
                        label: "LinkedIn",
                        labelEnglish: "LinkedIn",
                        uuid: "linkedin",
                        href: "https://www.linkedin.com/company/atlassian/"
                    }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    height: "16",
                    viewBox: "0 0 16 16",
                    width: "16",
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "m3.36409209 14.2159091h-3.17642414v-9.59186348h3.17642414z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "m1.77597952 3.31427557h-.0206972c-1.06590614 0-1.75528232-.7364835-1.75528232-1.65693805 0-.94122869.71047144-1.65733752 1.79707473-1.65733752 1.08660338 0 1.75528236.71610883 1.77597957 1.65733752 0 .92045455-.68937619 1.65693805-1.79707478 1.65693805z"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                d: "m14.8176077 14.2159091h-3.1760261v-5.13141424c0-1.28959517-.4599158-2.16910068-1.6092078-2.16910068-.87744213 0-1.40004662.59326174-1.62970603 1.16594902-.08398287.20494499-.10448108.4913885-.10448108.7780318v5.3565341h-3.17622514s.04159346-8.69198329 0-9.59186348h3.17622514v1.35810992c.42210364-.65358665 1.17735263-1.58322973 2.86258281-1.58322973 2.0898209 0 3.6568382 1.37089396 3.6568382 4.31702764z"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                href: "https://twitter.com/trello",
                title: "Twitter",
                onClick: ()=>sendTrackEvent("clickedSocialNav", {
                        event: "clicked",
                        eventComponent: "link",
                        eventContainer: "globalFooter",
                        label: "Twitter",
                        labelEnglish: "Twitter",
                        uuid: "twitter",
                        href: "https://twitter.com/trello"
                    }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    height: "16",
                    viewBox: "0 0 20 16",
                    width: "20",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m19.0426025 1.89416831c-.6070809.27573601-1.2752956.44311943-1.9307418.55341384.3110854-.05242868.7695883-.61749334.9529894-.84623773.2797448-.34874781.512285-.74604069.6430647-1.17517915.0166377-.03339901.0294061-.07573031-.0042561-.10097375-.0417876-.0166995-.0688722-.00815557-.1021475.00854393-.7316699.39340928-1.4881028.67885432-2.293288.88080182-.0669375.01669951-.1164636 0-.1582512-.04194294-.0669375-.07573032-.1296189-.1468003-.2004257-.20583111-.3385569-.28894028-.7018769-.51574287-1.1112406-.68312628-.5374349-.22020046-1.1247829-.313407-1.7040054-.27534766-.5633588.03650589-1.1166575.1961221-1.616561.4582655-.5010643.26253176-.9479595.62797907-1.3039279 1.0691567-.36834997.45593533-.63996937.99459147-.77887445 1.56548154-.13426201.55108368-.12342819 1.09634195-.04140068 1.65325103.01238152.09242982.00425615.10485736-.07893213.09242982-3.15032069-.47069303-5.76165874-1.60198743-7.88121865-4.0265226-.09208749-.10524572-.14200046-.10524572-.21745029.00815558-.92745255 1.3953796-.47746201 3.63777365.68137003 4.73955264.15438196.1468003.31302007.29360061.48442661.42758501-.0626814.0128159-.83381738-.07106999-1.52099123-.42758501-.09170057-.05864245-.13813124-.02485508-.1462566.07961392-.00851229.15107227.00425614.289717.02476302.45321681.17798422 1.41479763 1.15418898 2.72318446 2.49100524 3.23349028.15863811.06718638.33391387.12582883.50532041.15534423-.3048947.06679802-.6183017.11495474-1.49158515.04621491-.10872514-.02097147-.15051274.03339901-.10872514.13825637.65622008 1.79539099 2.07274232 2.32977519 3.13368304 2.63424989.14200046.0248551.28438783.0248551.42677521.0582541-.00851229.0128159-.01702458.0128159-.02514994.0252434-.35209922.5386562-1.57206498.9394443-2.14045371 1.1386733-1.03308233.3623404-2.15825213.5254519-3.25053355.4174876-.17450193-.0256318-.21125954-.02369-.25885097 0-.04759143.0295154-.00580383.0714584.05029989.1172849.22170643.1468003.44689516.2769011.67672696.4027299.69375153.3689426 1.41690916.6629316 2.17295517.8722579 3.90481903 1.082361 8.30335081.2869985 11.23506041-2.63658 2.3025741-2.2963762 3.109307-5.46268009 3.109307-8.63286759 0-.12427538.1462566-.19301521.2329271-.25825979.5989556-.45166336 1.0752569-.99226131 1.5221521-1.59616202.1002128-.13553785.0941388-.25631799.0941388-.30563979 0-.00854393 0-.0166995 0-.0166995 0-.05087524.006074-.03534082-.0716974 0"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                href: "https://www.youtube.com/channel/UCRcOkXoOrU6sN1yCz20VmQw",
                title: "Youtube",
                onClick: ()=>sendTrackEvent("clickedSocialNav", {
                        event: "clicked",
                        eventComponent: "link",
                        eventContainer: "globalFooter",
                        label: "Youtube",
                        labelEnglish: "Youtube",
                        uuid: "youtube",
                        href: "https://www.youtube.com/channel/UCRcOkXoOrU6sN1yCz20VmQw"
                    }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                    height: "14",
                    viewBox: "0 0 20 14",
                    width: "20",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "m12.6695433 7.17708642-4.43152592 2.43950617c-.19286329.10469136-.36604664-.03555555-.36604664-.25520987v-5.00740741c0-.22281482.17869373-.36266667.37155701-.25244445l4.46183305 2.56790124c.1971928.11259259.163737.39901234-.0358175.50765432zm7.0103835-2.87683951c0-2.37511111-1.9180056-4.30024691-4.2839264-4.30024691h-11.11168033c-2.3659208 0-4.28432007 1.9251358-4.28432007 4.30024691v5.22666667c0 2.37511112 1.91839927 4.30024692 4.28432007 4.30024692h11.11168033c2.3659208 0 4.2839264-1.9251358 4.2839264-4.30024692z"
                    })
                })
            })
        ]
    });
};

});
parcelRegister("6QpTg", function(module, exports) {

$parcel$export(module.exports, "Footer", function () { return $065b9f707ece0029$export$a06f1c675e846f6f; });
$parcel$export(module.exports, "LogoAndLoginContainer", function () { return $065b9f707ece0029$export$c3b9190e4baf8da8; });
$parcel$export(module.exports, "TabsList", function () { return $065b9f707ece0029$export$9712d22edc0d78c1; });
$parcel$export(module.exports, "Divider", function () { return $065b9f707ece0029$export$2e0a83ec2e27ecbb; });
$parcel$export(module.exports, "SubNav", function () { return $065b9f707ece0029$export$4a51633636d7017c; });
$parcel$export(module.exports, "SocialNavLinks", function () { return $065b9f707ece0029$export$ab97b357a891d316; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $54E1V = parcelRequire("54E1V");
var $kL1mL = parcelRequire("kL1mL");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
//style variables
const $065b9f707ece0029$var$textColor = (0, $i2LPb.colorCSS)("N0");
const $065b9f707ece0029$export$a06f1c675e846f6f = (0, $hYbro.styled).footer`
    ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "N800"
})} section {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${$065b9f707ece0029$var$textColor}`)}

        span {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        }

        svg {
            ${(0, $jAJVK.redundantCssFromKebab)("max-width", "125px")}
        }

        a,
        button {
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${$065b9f707ece0029$var$textColor}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}

            &:hover {
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${$065b9f707ece0029$var$textColor}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "underline")}
            }
        }

        ul {
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
            ${(0, $jAJVK.redundantCssFromKebab)("list-style-type", "none")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        }
        @media ${(0, $aT9Ik.maxWidth).lg} {
            form {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "1rem")}
            }
        }
    }
`;
const $065b9f707ece0029$export$c3b9190e4baf8da8 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "1.5rem 1rem 0 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "nowrap")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-between")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.75rem")}

    a {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "stretch")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "1rem 1rem 0 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    }
`;
const $065b9f707ece0029$export$9712d22edc0d78c1 = (0, $hYbro.styled).ul`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 0 1rem")}

    h4,
    p {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${$065b9f707ece0029$var$textColor}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "60%")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }

    div > p {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${$065b9f707ece0029$var$textColor}`)}
    }

    a {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }

    li {
        ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `1px solid ${(0, $i2LPb.colorCSS)("N400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 0 1rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 1rem 0")}
    }

    li:first-child {
        ${(0, $jAJVK.redundantCssFromKebab)("border-top", `1px solid ${(0, $i2LPb.colorCSS)("N400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 0 1rem 0")}
    }

    li:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

        h4,
        p {
            ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
        }

        a {
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.25rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}

            &:hover {
                ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none !important")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N600")}`)}
            }
        }

        li {
            ${(0, $jAJVK.redundantCssFromKebab)("border", "none")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "25%")}
        }

        li:first-child {
            ${(0, $jAJVK.redundantCssFromKebab)("border", "none")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        }
    }
`;
const $065b9f707ece0029$export$2e0a83ec2e27ecbb = (0, $hYbro.styled).div`
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("border-top", `1px solid ${(0, $i2LPb.colorCSS)("N400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "98%")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    }
`;
const $065b9f707ece0029$export$4a51633636d7017c = (0, $hYbro.styled).nav`
    ul {
        li {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "1rem")}
            a,
            button,
            span {
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
            }
        }
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ul {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
            ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "nowrap")}
            li {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-right", "1.5rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "0")}
                ${({ hideLanguageSelector: hideLanguageSelector })=>!hideLanguageSelector && `&:first-child { margin-left: 1rem; }`}
            }
        }
    }
`;
const $065b9f707ece0029$export$ab97b357a891d316 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "2rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "3rem 1rem 0 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 0 3rem 0")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-between")}
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }

    a {
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("border", `2px solid ${$065b9f707ece0029$var$textColor}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "24px")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 !important")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "24px")}

        svg {
            ${(0, $jAJVK.redundantCssFromKebab)("height", "60%")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "auto !important")}
            ${(0, $jAJVK.redundantCssFromKebab)("transition", "all 0.15s")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "60%")}

            path {
                ${(0, $jAJVK.redundantCssFromKebab)("fill", `${$065b9f707ece0029$var$textColor}`)}
            }
        }

        &:hover {
            svg {
                ${(0, $jAJVK.redundantCssFromKebab)("height", "50%")}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "50%")}

                path {
                    ${(0, $jAJVK.redundantCssFromKebab)("fill", `${$065b9f707ece0029$var$textColor}`)}
                }
            }
        }
    }
`;

});




parcelRegister("8EDHj", function(module, exports) {

$parcel$export(module.exports, "UiFooterNavBasic", function () { return (parcelRequire("3cQdw")).default; });

var $3cQdw = parcelRequire("3cQdw");

});
parcelRegister("3cQdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6e0200fba3832280$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $8OmrV = parcelRequire("8OmrV");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $ipl9a = parcelRequire("ipl9a");
var $986bT = parcelRequire("986bT");

var $33PqJ = parcelRequire("33PqJ");

var $1TVQe = parcelRequire("1TVQe");
const $6e0200fba3832280$var$UiFooterNavBasic = ({ model: model })=>{
    const { type: type, content: { entryTitle: entryTitle, links: links, selectLanguageLabel: selectLanguageLabel, tagline: tagline, isFullWidth: isFullWidth } } = model;
    const { setFooterHeight: setFooterHeight } = (0, $8OmrV.useFooterContext)();
    const footerRef = (0, $iSvIT.useRef)(null);
    const columnStyles = isFullWidth ? undefined : {
        offset: "2",
        span: "8"
    };
    (0, $iSvIT.useEffect)(()=>{
        function handleResize() {
            if (footerRef.current) {
                const height = footerRef.current.offsetHeight;
                setFooterHeight(height);
            }
        }
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, [
        footerRef,
        setFooterHeight
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: "globalFooter",
            eventComponent: type,
            parentLabel: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1TVQe.Footer), {
            ref: footerRef,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Column), {
                        md: columnStyles,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $ipl9a.LanguageSelectForm), {
                                iconColor: "N100",
                                selectLanguageLabel: selectLanguageLabel,
                                showGlobeIcon: false
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                                role: "presentation"
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $986bT.LogoAtlassian), {}),
                            !!links?.length && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1TVQe.Links), {
                                children: (0, $33PqJ.renderViewModels)(links)
                            }),
                            tagline && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                document: tagline,
                                className: "tagline"
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $6e0200fba3832280$export$2e2bcd8739ae039 = $6e0200fba3832280$var$UiFooterNavBasic;

});
parcelRegister("1TVQe", function(module, exports) {

$parcel$export(module.exports, "Footer", function () { return $52993ea99d130fca$export$a06f1c675e846f6f; });
$parcel$export(module.exports, "Links", function () { return $52993ea99d130fca$export$b2e089eb3692b073; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $52993ea99d130fca$export$a06f1c675e846f6f = (0, $hYbro.styled).footer`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xs}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "1.25rem 0")}

    select {
        ${(0, $jAJVK.redundantCssFromKebab)("border", `2px solid ${(0, $i2LPb.colorCSS)("N30")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N300")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.25rem 0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-position", "center right 0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "1rem 0 0.5rem")}
    }

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("B400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "1.25rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "150px")}
    }

    .tagline p {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "1rem 0 0")}
    }
`;
const $52993ea99d130fca$export$b2e089eb3692b073 = (0, $hYbro.styled).nav`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}

    a,
    button {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N300")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.125rem 0.75rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}

        &:hover {
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "underline")}
        }
    }
`;

});



parcelRegister("jAJUr", function(module, exports) {

$parcel$export(module.exports, "UiGuide", function () { return (parcelRequire("b5HjT")).default; });

var $b5HjT = parcelRequire("b5HjT");

});
parcelRegister("b5HjT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8e8d95abfc48fed$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iCJQh = parcelRequire("iCJQh");

var $7AG7X = parcelRequire("7AG7X");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("dg5xP");
var $5atKW = parcelRequire("5atKW");
var $kzY5l = parcelRequire("kzY5l");
var $h5qkC = parcelRequire("h5qkC");
var $82f25 = parcelRequire("82f25");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("h6yBX");
var $6IIwI = parcelRequire("6IIwI");
var $8korH = parcelRequire("8korH");
parcelRequire("bNHtH");
var $f7URE = parcelRequire("f7URE");

var $dbixt = parcelRequire("dbixt");
// eslint-disable-next-line complexity
const $c8e8d95abfc48fed$var$UiGuide = ({ model: model })=>{
    const [positionsInitialized, setPositionsInitialized] = (0, $iSvIT.useState)(false);
    const [indexInitialized, setIndexInitialized] = (0, $iSvIT.useState)(false);
    const [sectionPositions, setSectionPositions] = (0, $iSvIT.useState)([]);
    const [isSticky, setIsSticky] = (0, $iSvIT.useState)(false);
    const [scrolledSectionIndex, setScrolledSectionIndex] = (0, $iSvIT.useState)(-1);
    const [navIsOpen, setNavIsOpen] = (0, $iSvIT.useState)(false);
    const [navHeight, setNavHeight] = (0, $iSvIT.useState)(undefined);
    const route = (0, $5atKW.useRoute)();
    const navRef = (0, $iSvIT.useRef)(null);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    //get current chapter
    const { chapters: chapters, headerOffset: headerOffset, nextChapterLabel: nextChapterLabel, numberedChapters: numberedChapters } = model.content;
    const publishedChapters = chapters.filter(({ type: type })=>type === "uiGuideChapter");
    const chapterIndex = publishedChapters.findIndex((chapter)=>chapter.content.route.content.path === route);
    const chapter = chapterIndex === -1 ? null : publishedChapters[chapterIndex];
    //get bookmarkable sections
    const chapterSections = chapter?.content.sections.filter((section)=>section.content.elementId);
    //get next chapter
    const nextChapter = chapterIndex !== publishedChapters.length - 1 ? publishedChapters[chapterIndex + 1] : null;
    //next chapter button text
    const nextChapterButtonText = nextChapterLabel ? (0, $iCJQh.decode)(nextChapterLabel) : nextChapter?.content.title ? (0, $iCJQh.decode)(nextChapter.content.title) : undefined;
    //get y coordinates of bookmarkable sections
    const resetSectionPositions = ()=>{
        const newPositions = [];
        document.querySelectorAll("section[id]").forEach((element)=>{
            if (element instanceof HTMLElement) newPositions.push(element.offsetTop - 122);
        });
        setSectionPositions(newPositions);
        return newPositions;
    };
    const resetNavHeight = ()=>{
        if (!navRef.current) return;
        const { top: top } = navRef.current.getBoundingClientRect();
        //set height of ScrollFade (sticky only on lg and up)
        const newNavHeight = top <= (0, $6IIwI.BIG_NAV_PX_HEIGHT) ? window.innerHeight - (0, $6IIwI.BIG_NAV_PX_HEIGHT) : undefined;
        setNavHeight(newNavHeight);
    };
    //background color?
    const chapterBackground = (0, $8korH.isBackgroundFieldArray)(chapter?.content.background) ? chapter?.content.background : undefined;
    // store current category when rendering chapters in nav
    let currentCategory = undefined;
    (0, $iSvIT.useEffect)(()=>{
        const scrollHandler = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            const scrollToCheck = globalThis.scrollY + 10; //10px of leeway helps with zoomed-out browsers
            const newSectionIndex = sectionPositions[0] && sectionPositions[0] > scrollToCheck ? -1 : sectionPositions.filter((position)=>position <= scrollToCheck).length - 1;
            if (newSectionIndex !== scrolledSectionIndex) {
                //update highlighted nav element
                setScrolledSectionIndex(newSectionIndex);
                //update hash
                const newHash = chapterSections?.[newSectionIndex] ? `#${chapterSections[newSectionIndex]?.content.elementId}` : window.location.pathname;
                history.pushState(null, document.title, newHash);
            }
            //when sidebar changes stickiness, set ScrollFade height (lg and up)
            if (navRef.current) {
                const { top: top } = navRef.current.getBoundingClientRect();
                if (top <= (0, $6IIwI.BIG_NAV_PX_HEIGHT) !== isSticky) {
                    setIsSticky(!isSticky);
                    resetNavHeight();
                }
            }
        }, 100);
        const resizeHandler = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            resetSectionPositions();
            resetNavHeight();
        }, 100);
        //fire on startup
        if (!positionsInitialized) {
            resetSectionPositions();
            setPositionsInitialized(true);
        } else if (!indexInitialized) {
            scrollHandler();
            setIndexInitialized(true);
        }
        //set listeners
        window.addEventListener("resize", resizeHandler);
        document.addEventListener("scroll", scrollHandler);
        //remove listeners
        return ()=>{
            window.removeEventListener("resize", resizeHandler);
            document.removeEventListener("scroll", scrollHandler);
        };
    }, [
        chapterSections,
        scrolledSectionIndex,
        sectionPositions,
        setScrolledSectionIndex,
        indexInitialized,
        isSticky,
        positionsInitialized
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (navIsOpen) document.body.classList.add("prevent-scroll");
        else document.body.classList.remove("prevent-scroll");
        return ()=>document.body.classList.remove("prevent-scroll");
    }, [
        navIsOpen
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dbixt.Guide), {
        background: chapterBackground,
        "data-nav-open": navIsOpen,
        headerOffset: !!headerOffset,
        onClick: ()=>setNavIsOpen(false),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("aside", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)("button", {
                        onClick: (e)=>{
                            e.stopPropagation();
                            setNavIsOpen(!navIsOpen);
                        },
                        children: [
                            chapter?.content.title,
                            /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
                                width: "20",
                                height: "12",
                                viewBox: "0 0 20 12",
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                                    fill: "currentColor",
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M11.8177 11.2487L18.652 4.35367C19.0879 3.91292 19.3324 3.31805 19.3324 2.69817C19.3324 2.07829 19.0879 1.48341 18.652 1.04267C18.4379 0.825305 18.1828 0.652692 17.9014 0.534871C17.6199 0.417049 17.3179 0.356373 17.0128 0.356373C16.7078 0.356373 16.4057 0.417049 16.1243 0.534871C15.8429 0.652692 15.5877 0.825306 15.3737 1.04267L10.0117 6.449L4.62867 1.01933C4.41403 0.802116 4.15842 0.629658 3.87665 0.511954C3.59487 0.39425 3.29254 0.333643 2.98717 0.333644C2.6818 0.333644 2.37946 0.394251 2.09769 0.511954C1.81591 0.629658 1.5603 0.802116 1.34567 1.01933C0.910345 1.46038 0.666256 2.05514 0.666256 2.67483C0.666256 3.29453 0.910345 3.88929 1.34567 4.33034L8.20567 11.2487C8.68805 11.7287 9.3405 11.9987 10.021 12C10.672 12 11.3207 11.7503 11.8177 11.2487Z"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $h5qkC.ScrollFade), {
                        height: navHeight,
                        style: {
                            position: "sticky",
                            top: (0, $6IIwI.BIG_NAV_PX_HEIGHT)
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbixt.Nav), {
                            ref: navRef,
                            "data-open": navIsOpen,
                            "data-numbered": !!numberedChapters,
                            "data-first-chapter": chapterIndex === 0,
                            children: publishedChapters.map((chapter, index)=>{
                                let navHeading = null;
                                if (chapter.content.category !== currentCategory) {
                                    currentCategory = chapter.content.category;
                                    navHeading = /*#__PURE__*/ (0, $loA2J.jsx)("h5", {
                                        children: chapter.content.category
                                    });
                                }
                                return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
                                    children: [
                                        navHeading,
                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                            href: chapter.content.route.content.path,
                                            "aria-current": chapterIndex === index ? "page" : undefined,
                                            "data-uuid": `${model.id}_navMain`,
                                            onClick: ()=>{
                                                sendTrackEvent("clickedUiGuideNavLink", {
                                                    event: "clicked",
                                                    eventComponent: "link",
                                                    eventContainer: model.type,
                                                    label: chapter.content.title,
                                                    labelEnglish: chapter.content.entryTitle,
                                                    href: chapter.content.route.content.path,
                                                    title: chapter.content.title,
                                                    uuid: `${model.id}_navMain`
                                                });
                                            },
                                            children: (0, $iCJQh.decode)(chapter.content.title)
                                        }),
                                        chapter.content.route.content.path === route && !!chapterSections?.length && /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
                                            children: chapterSections.map((section, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                                    className: scrolledSectionIndex === index ? "active" : undefined,
                                                    href: `#${section.content.elementId}`,
                                                    onClick: (e)=>{
                                                        if (!window) return;
                                                        e.preventDefault();
                                                        //send event
                                                        sendTrackEvent("clickedUiGuideNavLink", {
                                                            event: "clicked",
                                                            eventComponent: "link",
                                                            eventContainer: model.type,
                                                            label: section.content.guideSectionTitle,
                                                            labelEnglish: section.content.title,
                                                            href: `#${section.content.elementId}`,
                                                            title: section.content.guideSectionTitle,
                                                            uuid: `${model.id}_navSub`
                                                        });
                                                        //zoom level may have changed
                                                        const latestPositions = resetSectionPositions();
                                                        const position = latestPositions[index];
                                                        //smooth scroll to element
                                                        if (position) (0, $f7URE.smoothScrollTo)(position);
                                                    },
                                                    "data-uuid": `${model.id}_navSub`,
                                                    children: (0, $iCJQh.decode)(section.content.guideSectionTitle || "")
                                                }, index))
                                        })
                                    ]
                                }, index);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("main", {
                children: [
                    chapter?.content.sections && (0, $33PqJ.renderViewModels)(chapter.content.sections),
                    nextChapter && /*#__PURE__*/ (0, $loA2J.jsx)("nav", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                            appearance: "Primary",
                            url: nextChapter.content.route.content.path,
                            decorator: "Arrow",
                            onClick: ()=>{
                                //send event
                                sendTrackEvent("clickedUiGuideNextChapterLink", {
                                    event: "clicked",
                                    eventComponent: "button",
                                    eventContainer: model.type,
                                    label: nextChapterButtonText,
                                    labelEnglish: "Next chapter",
                                    uuid: `${model.id}_next`,
                                    href: nextChapter.content.route.content.path,
                                    title: nextChapterButtonText
                                });
                            },
                            "data-uuid": `${model.id}_next`,
                            children: nextChapterButtonText
                        })
                    }),
                    chapter?.content.subSections && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dbixt.SubSections), {
                        className: "subSections",
                        children: (0, $33PqJ.renderViewModels)(chapter.content.subSections)
                    })
                ]
            })
        ]
    });
};
var $c8e8d95abfc48fed$export$2e2bcd8739ae039 = $c8e8d95abfc48fed$var$UiGuide;

});
parcelRegister("dbixt", function(module, exports) {

$parcel$export(module.exports, "Guide", function () { return $d9b7c319782f9beb$export$dd9cef36367ff841; });
$parcel$export(module.exports, "SubSections", function () { return $d9b7c319782f9beb$export$62c38c6892b4de75; });
$parcel$export(module.exports, "Nav", function () { return $d9b7c319782f9beb$export$39140c7d8b0ba7b3; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $6IIwI = parcelRequire("6IIwI");
var $i2LPb = parcelRequire("i2LPb");
var $1D7YE = parcelRequire("1D7YE");
var $2vQ6x = parcelRequire("2vQ6x");
var $8DhG7 = parcelRequire("8DhG7");
var $kL1mL = parcelRequire("kL1mL");
var $bC5c7 = parcelRequire("bC5c7");

var $jAJVK = parcelRequire("jAJVK");
const $d9b7c319782f9beb$export$dd9cef36367ff841 = (0, $hYbro.styled).div({
    counterReset: "listcounter -1"
}, ({ headerOffset: headerOffset })=>headerOffset && `padding-top: ${(0, $6IIwI.SMALL_NAV_PX_HEIGHT) + (0, $6IIwI.SUB_NAV_PX_HEIGHT)}px;`, {
    "position": "relative",
    "aside": {
        background: (0, $i2LPb.colorCSS)("N0"),
        boxShadow: `0 0.5rem 0.75rem 0 ${(0, $i2LPb.colorCSS)("N900", 0.15)}`,
        left: 0,
        position: "fixed",
        right: 0,
        top: `${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px`,
        zIndex: (0, $1D7YE.zIndex).subNav,
        button: {
            backgroundColor: (0, $i2LPb.colorCSS)("N0"),
            border: 0,
            color: (0, $i2LPb.colorCSS)("P500"),
            height: `${(0, $6IIwI.SUB_NAV_PX_HEIGHT)}px`,
            overflow: "hidden",
            padding: "0 3rem 0 1rem",
            position: "relative",
            textAlign: "left",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            width: "100%",
            svg: {
                position: "absolute",
                right: "1rem",
                top: "22px",
                transition: "0.2s transform ease"
            }
        },
        a: {
            color: "inherit",
            display: "block",
            textDecoration: "none"
        }
    },
    "main": {
        nav: {
            display: "flex",
            flexDirection: "row-reverse",
            padding: `${(0, $2vQ6x.spacing)["cozy"]} 1rem ${(0, $2vQ6x.spacing)["outerspace"]}`
        }
    },
    "&:after": {
        backgroundColor: "black",
        content: '""',
        opacity: 0,
        position: "fixed",
        transition: "0.2s opacity ease",
        zIndex: (0, $1D7YE.zIndex).subNavShroud
    },
    [`&[data-nav-open="true"]`]: {
        "aside": {
            "button svg": {
                transform: "rotate(180deg)"
            }
        },
        "&:after": {
            bottom: 0,
            opacity: 0.4,
            left: 0,
            top: 0,
            right: 0
        }
    },
    "@media (min-width: 992px)": {
        "display": "flex",
        "minHeight": "100vh",
        "paddingTop": `${(0, $6IIwI.BIG_NAV_PX_HEIGHT)}px`,
        "aside": {
            boxShadow: `0.5rem 0 0.75rem 0 ${(0, $i2LPb.colorCSS)("N900", 0.15)}`,
            clipPath: "inset(0 -1rem 0 0)",
            minHeight: "100%",
            padding: `${(0, $2vQ6x.spacing)["cozy"]} 0 0`,
            position: "static",
            width: `calc( ${(0, $8DhG7.getContainerWidth)("lg", 3)} + ((100vw - ${(0, $8DhG7.getContainerWidth)("lg")}) / 2) )`,
            zIndex: 0,
            button: {
                display: "none"
            }
        },
        "main": {
            "flexGrow": 1,
            "> section > container > section > div, > nav, > .subSections > section > div": {
                marginLeft: (0, $8DhG7.getContainerWidth)("lg", 1),
                width: (0, $8DhG7.getContainerWidth)("lg", 8)
            }
        },
        '&[data-nav-open="true"]:after': {
            bottom: "auto",
            left: "auto",
            opacity: 0,
            right: "auto",
            top: "auto"
        }
    },
    "@media (min-width: 1200px)": {
        "aside": {
            width: `calc( ${(0, $8DhG7.getContainerWidth)("xl", 3)} + ((100vw - ${(0, $8DhG7.getContainerWidth)("xl")}) / 2) )`
        },
        "main > section > div, main > nav, main > .subSections > section > div": {
            marginLeft: (0, $8DhG7.getContainerWidth)("xl", 1),
            width: (0, $8DhG7.getContainerWidth)("xl", 8)
        }
    }
});
const $d9b7c319782f9beb$export$62c38c6892b4de75 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", `0 0 ${(0, $2vQ6x.spacing)["outerspace"]}`)}
`;
const $d9b7c319782f9beb$export$39140c7d8b0ba7b3 = (0, $hYbro.styled).nav({
    "backgroundColor": (0, $i2LPb.colorCSS)("N10"),
    "height": 0,
    "opacity": 0,
    "overflow": "hidden",
    "transform": "translateY(-1rem)",
    "transition": "0.2s all ease",
    "h5": {
        color: (0, $i2LPb.colorCSS)("N500"),
        fontWeight: 400,
        margin: "1rem 0 0 1rem"
    },
    '&[data-open="true"]': {
        height: "auto",
        maxHeight: `calc(100vh - ${(0, $6IIwI.SUB_NAV_PX_HEIGHT) + (0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px)`,
        overflow: "auto",
        opacity: 1,
        paddingBottom: "0.5rem",
        transform: "translateY(0)"
    },
    "> a": {
        "counterIncrement": "listcounter",
        "padding": "0.5rem 1rem",
        "position": "relative",
        "&.active": {
            backgroundColor: (0, $i2LPb.colorCSS)("P50")
        },
        "&:first-child": {
            "paddingLeft": "1rem",
            "&::before": {
                visibility: "hidden"
            }
        }
    },
    '&[data-numbered="true"] > a': {
        "paddingLeft": "2.5rem",
        "&::before": {
            content: "counter(listcounter)",
            position: "absolute"
        },
        "&:first-child": {
            paddingLeft: "1rem"
        }
    },
    "nav": {
        display: "none"
    },
    "@media (min-width: 992px)": {
        "backgroundColor": "transparent",
        "display": "block",
        "fontSize": (0, $kL1mL.fontSizes).sm,
        "height": "auto",
        "margin": "0 0 0 auto",
        "padding": "2rem 2rem 2rem 1rem",
        "width": (0, $8DhG7.getContainerWidth)("lg", 3),
        "opacity": 1,
        "overflow": "auto",
        "transform": "none",
        "h5": {
            marginLeft: 0
        },
        "> a": {
            "marginTop": "0.5rem",
            "padding": "0.5rem 0",
            "&:first-child": {
                color: "inherit !important",
                fontFamily: (0, $bC5c7.theme).fontFamily.display,
                fontSize: (0, $kL1mL.fontSizes).lg,
                fontWeight: 500,
                lineHeight: 1.33333333,
                marginTop: 0,
                paddingLeft: 0,
                paddingTop: 0
            },
            "&:hover": {
                color: (0, $i2LPb.colorCSS)("P400")
            },
            "&::before": {
                left: 0
            },
            "&[aria-current]": {
                backgroundColor: "transparent",
                color: (0, $i2LPb.colorCSS)("P400"),
                fontWeight: 500
            }
        },
        '&[data-numbered="true"] > a': {
            "paddingLeft": "1.5rem",
            "&:first-child": {
                paddingLeft: 0
            }
        },
        '&[data-first-chapter="false"] > a:first-child::before': {
            backgroundImage: 'url(\'data:image/svg+xml;utf8,<svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="m14.707 6.29289c.3626.36263.3885.93445.0777 1.32697l-.0777.08725-4.2928 4.29219 4.2928 4.2936c.3626.3626.3885.9344.0777 1.327l-.0777.0872c-.3626.3626-.9345.3885-1.327.0777l-.0872-.0777-5.00003-5c-.36263-.3626-.38853-.9345-.07771-1.327l.07771-.0872 5.00003-5.00001c.3905-.39052 1.0236-.39052 1.4142 0z"/></svg>\')',
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
            color: (0, $i2LPb.colorCSS)("N900"),
            content: "''",
            height: "1.25rem",
            left: "-1.25rem",
            position: "absolute",
            top: "7px",
            visibility: "visible",
            width: "1.25rem"
        },
        "nav": {
            display: "block",
            a: {
                "borderLeft": "4px solid transparent",
                "padding": "0.5rem 0 0.5rem 1.25rem",
                "&.active, &:hover": {
                    color: (0, $i2LPb.colorCSS)("P400")
                },
                "&.active": {
                    borderColor: (0, $i2LPb.colorCSS)("P400")
                }
            }
        }
    },
    "@media (min-width: 1200px)": {
        width: (0, $8DhG7.getContainerWidth)("xl", 3)
    }
});

});



parcelRegister("igAe9", function(module, exports) {

$parcel$export(module.exports, "UiHeaderNav", function () { return (parcelRequire("evXZH")).default; });

var $evXZH = parcelRequire("evXZH");

});
parcelRegister("evXZH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78ead453ffc6bf0b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $k97FG = parcelRequire("k97FG");
parcelRequire("dg5xP");
var $aSdFq = parcelRequire("aSdFq");
var $eOLtZ = parcelRequire("eOLtZ");
parcelRequire("kqE35");
var $4reSe = parcelRequire("4reSe");
parcelRequire("caLfy");
var $f2jCl = parcelRequire("f2jCl");

var $bMCHM = parcelRequire("bMCHM");
const $78ead453ffc6bf0b$var$UiHeaderNav = ({ model: model })=>{
    const identitySignupUrl = (0, $aSdFq.useIdentityUrl)();
    const identityLoginUrl = (0, $aSdFq.useIdentityUrl)({
        isLogin: true
    });
    const hasScrolled = (0, $k97FG.useHasScrolled)(40);
    const isLoggedIn = (0, $eOLtZ.useIsLoggedIn)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $bMCHM.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    id: "skip-to-content",
                    href: "#skip-target",
                    className: "visually-hidden",
                    children: model.content.skipToMainContent ?? "Skip to main content"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $4reSe.default), {
                hasScrolled: hasScrolled,
                isLoggedIn: isLoggedIn,
                model: model,
                signUpUrl: identitySignupUrl,
                loginUrl: identityLoginUrl
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $f2jCl.default), {
                hasScrolled: hasScrolled,
                isLoggedIn: isLoggedIn,
                model: model,
                signUpUrl: identitySignupUrl,
                loginUrl: identityLoginUrl
            })
        ]
    });
};
var $78ead453ffc6bf0b$export$2e2bcd8739ae039 = $78ead453ffc6bf0b$var$UiHeaderNav;

});
parcelRegister("k97FG", function(module, exports) {

$parcel$export(module.exports, "useHasScrolled", function () { return $eaaa9948ebfc228b$export$d72634a873e43c21; });

var $iSvIT = parcelRequire("iSvIT");
const $eaaa9948ebfc228b$export$d72634a873e43c21 = (distance)=>{
    const [hasScrolled, setHasScrolled] = (0, $iSvIT.useState)(false);
    (0, $iSvIT.useEffect)(()=>{
        const scrollHandler = ()=>{
            setHasScrolled(globalThis.scrollY > distance);
        };
        scrollHandler();
        document.addEventListener("scroll", scrollHandler);
        return ()=>{
            document.removeEventListener("scroll", scrollHandler);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, []);
    return hasScrolled;
};

});

parcelRegister("kqE35", function(module, exports) {

$parcel$export(module.exports, "BigNav", function () { return (parcelRequire("4reSe")).default; });

var $4reSe = parcelRequire("4reSe");

var $7OiEX = parcelRequire("7OiEX");

var $5nQ8z = parcelRequire("5nQ8z");

var $3a3BT = parcelRequire("3a3BT");

});
parcelRegister("4reSe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a54761222c42879e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
parcelRequire("2krCx");
var $53IXH = parcelRequire("53IXH");
var $kffFQ = parcelRequire("kffFQ");

var $5Tuyz = parcelRequire("5Tuyz");

var $7OiEX = parcelRequire("7OiEX");

var $5nQ8z = parcelRequire("5nQ8z");

var $3a3BT = parcelRequire("3a3BT");
const $a54761222c42879e$var$BigNav = ({ hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, signUpUrl: signUpUrl, loginUrl: loginUrl, model: { id: id, content: { goToBoardsText: goToBoardsText, logInText: logInText, progressBar: progressBar, progressLabel: progressLabel, signUpText: signUpText, startTransparent: startTransparent, tabs: tabs = [], useEyebrowLogo: useEyebrowLogo } } })=>{
    const [activeTab, setActiveTab] = (0, $iSvIT.useState)();
    const innerHeightRef = (0, $iSvIT.useRef)(null);
    const [detailHeight, setDetailHeight] = (0, $iSvIT.useState)(0);
    function escPress(event) {
        if (event.key === "Escape") setActiveTab(undefined);
    }
    //listen for escape key when tab is open
    (0, $iSvIT.useEffect)(()=>{
        if (activeTab !== undefined) {
            window.addEventListener("keydown", escPress);
            document.body.classList.add("prevent-scroll");
        }
        return ()=>{
            window.removeEventListener("keydown", escPress);
            document.body.classList.remove("prevent-scroll");
        };
    }, [
        activeTab
    ]);
    //handle layout size changes
    (0, $iSvIT.useEffect)(()=>{
        if (!innerHeightRef.current || typeof ResizeObserver !== "function") return;
        const observer = new ResizeObserver((entries)=>{
            setDetailHeight(entries[0]?.contentRect.height ?? 0);
        });
        observer.observe(innerHeightRef.current);
        return ()=>observer.disconnect();
    }, [
        innerHeightRef
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: "globalNav"
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Tuyz.Header), {
            "data-open": activeTab !== undefined,
            onClick: ()=>setActiveTab(undefined),
            "data-testid": "bignav",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5Tuyz.InnerHeader), {
                "data-active": hasScrolled || activeTab !== undefined,
                "data-start-transparent": startTransparent?.toString(),
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5Tuyz.NavBar), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $53IXH.default), {
                                id: id,
                                eyebrow: useEyebrowLogo
                            }),
                            tabs && /*#__PURE__*/ (0, $loA2J.jsx)((0, $3a3BT.default), {
                                activeTab: activeTab,
                                setActiveTab: setActiveTab,
                                tabs: tabs
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7OiEX.default), {
                                goToBoardsText: goToBoardsText,
                                isLoggedIn: isLoggedIn,
                                logInText: logInText,
                                signUpText: signUpText,
                                signUpUrl: signUpUrl,
                                loginUrl: loginUrl,
                                uuid: id
                            }),
                            progressBar && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kffFQ.default), {
                                progressLabel: progressLabel
                            })
                        ]
                    }),
                    tabs.filter((tab)=>tab.type === "uiHeaderNavTab") && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Tuyz.DetailWrapper), {
                        style: {
                            height: detailHeight
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            ref: innerHeightRef,
                            children: tabs.map((tab, index)=>tab.type === "uiHeaderNavTab" && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                    style: {
                                        display: activeTab === index ? "block" : "none"
                                    },
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5nQ8z.default), {
                                        tab: tab,
                                        active: activeTab === index
                                    })
                                }, index))
                        })
                    })
                ]
            })
        })
    });
};
var $a54761222c42879e$export$2e2bcd8739ae039 = $a54761222c42879e$var$BigNav;

});
parcelRegister("2krCx", function(module, exports) {

$parcel$export(module.exports, "Logo", function () { return (parcelRequire("53IXH")).default; });
$parcel$export(module.exports, "HeaderTabLink", function () { return (parcelRequire("f5zGO")).default; });
$parcel$export(module.exports, "ProgressBar", function () { return (parcelRequire("kffFQ")).default; });

var $53IXH = parcelRequire("53IXH");

var $f5zGO = parcelRequire("f5zGO");

var $kffFQ = parcelRequire("kffFQ");

});
parcelRegister("53IXH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd82dfd19c20c4f6$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $7YcSr = parcelRequire("7YcSr");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $yF2IO = parcelRequire("yF2IO");

var $engzP = parcelRequire("engzP");
const $dd82dfd19c20c4f6$var$Logo = ({ id: id, eyebrow: eyebrow })=>{
    const HOMEPAGE_PATHNAME = "/home";
    const location = (0, $7YcSr.useLocation)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $engzP.default), {
        "aria-current": location?.pathname === HOMEPAGE_PATHNAME ? "page" : undefined,
        href: HOMEPAGE_PATHNAME,
        onClick: ()=>sendTrackEvent("clickedUiHeaderNavLogo", {
                ...analyticsAttributes,
                event: "clicked",
                eventComponent: "logo",
                label: "Trello logo",
                labelEnglish: "Trello logo",
                uuid: `${id}_logo`,
                href: HOMEPAGE_PATHNAME
            }),
        "data-uuid": `${id}_logo`,
        testId: "logo_link",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $yF2IO.LogoTrello), {
            height: eyebrow ? 37.5 : 22.5,
            appearance: "blue",
            id: id,
            eyebrow: eyebrow
        })
    });
};
var $dd82dfd19c20c4f6$export$2e2bcd8739ae039 = $dd82dfd19c20c4f6$var$Logo;

});
parcelRegister("engzP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e0dbf5e2ab1d97a$export$2e2bcd8739ae039; });

var $hYbro = parcelRequire("hYbro");

var $jp1nv = parcelRequire("jp1nv");
const $5e0dbf5e2ab1d97a$var$LogoLink = (0, $hYbro.styled)((0, $jp1nv.Anchor))({
    "alignItems": "center",
    "align-items": "center",
    "alignSelf": "stretch",
    "align-self": "stretch",
    "display": "flex",
    "padding": "1rem"
});
var $5e0dbf5e2ab1d97a$export$2e2bcd8739ae039 = $5e0dbf5e2ab1d97a$var$LogoLink;

});


parcelRegister("f5zGO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1574fef7f4f7d258$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $dtAdv = parcelRequire("dtAdv");

var $lr4IH = parcelRequire("lr4IH");
const $1574fef7f4f7d258$var$HeaderTabLink = ({ url: url, text: text, ariaLabel: ariaLabel, onClick: onClick, tabIndex: tabIndex })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $lr4IH.default), {
        href: url,
        "aria-label": ariaLabel,
        onClick: onClick,
        tabIndex: tabIndex,
        children: [
            text,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dtAdv.ArrowRight), {
                color: "B300"
            })
        ]
    });
};
var $1574fef7f4f7d258$export$2e2bcd8739ae039 = $1574fef7f4f7d258$var$HeaderTabLink;

});
parcelRegister("lr4IH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac9f52e03693516c$export$2e2bcd8739ae039; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $ac9f52e03693516c$var$Link = (0, $hYbro.styled).a`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.25rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "0.2s gap ease")}

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    }
`;
var $ac9f52e03693516c$export$2e2bcd8739ae039 = $ac9f52e03693516c$var$Link;

});


parcelRegister("kffFQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f3402e914a18486$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7AG7X = parcelRequire("7AG7X");
parcelRequire("dg5xP");
var $8OmrV = parcelRequire("8OmrV");

var $cu8wL = parcelRequire("cu8wL");
const $8f3402e914a18486$var$ProgressBar = ({ progressLabel: progressLabel })=>{
    const [yPercent, setYPercent] = (0, $iSvIT.useState)(0);
    const { footerHeight: footerHeight } = (0, $8OmrV.useFooterContext)();
    (0, $iSvIT.useEffect)(()=>{
        // define handler
        const scrollPercentHandler = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            const scrollTop = window.scrollY;
            const docHeight = document.body.offsetHeight;
            const windowHeight = window.innerHeight;
            const height = docHeight - windowHeight - footerHeight;
            const scrollPercent = Math.round(Math.min(100 / (height / scrollTop), 100));
            setYPercent(scrollPercent);
        }, 100);
        // set listener
        window.addEventListener("scroll", scrollPercentHandler);
        // remove listener
        return ()=>{
            window.removeEventListener("scroll", scrollPercentHandler);
        };
    }, [
        footerHeight
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cu8wL.Bar), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cu8wL.Progress), {
            role: "progressbar",
            "aria-label": progressLabel,
            "aria-valuenow": yPercent,
            "aria-valuemin": 0,
            "aria-valuemax": 100,
            style: {
                width: `${yPercent}%`
            },
            complete: yPercent === 100
        })
    });
};
var $8f3402e914a18486$export$2e2bcd8739ae039 = $8f3402e914a18486$var$ProgressBar;

});
parcelRegister("cu8wL", function(module, exports) {

$parcel$export(module.exports, "Bar", function () { return $3f5f034b41c97884$export$bbc6c6369b38e3d1; });
$parcel$export(module.exports, "Progress", function () { return $3f5f034b41c97884$export$b25a304ec7d746bb; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $3f5f034b41c97884$export$bbc6c6369b38e3d1 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("right", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("top", "0")}
`;
const $3f5f034b41c97884$export$b25a304ec7d746bb = (0, $hYbro.styled).div`
    background: ${({ complete: complete })=>complete ? (0, $i2LPb.colorCSS)("G300") : `linear-gradient(
    90deg,
    ${(0, $i2LPb.colorCSS)("T75")} 0%,
    ${(0, $i2LPb.colorCSS)("T300")} 99%
  )`};
    height: 0.25rem;
    transition: width 0.2s ease;
`;

});



parcelRegister("5Tuyz", function(module, exports) {

$parcel$export(module.exports, "DetailWrapper", function () { return $1dbc937b1592930d$export$24a5bd24803ffa4f; });
$parcel$export(module.exports, "Header", function () { return $1dbc937b1592930d$export$8b251419efc915eb; });
$parcel$export(module.exports, "InnerHeader", function () { return $1dbc937b1592930d$export$c07b820a2befd67c; });
$parcel$export(module.exports, "NavBar", function () { return $1dbc937b1592930d$export$ef8da11641c635de; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $1D7YE = parcelRequire("1D7YE");
var $aT9Ik = parcelRequire("aT9Ik");
var $a7xVp = parcelRequire("a7xVp");
var $6IIwI = parcelRequire("6IIwI");
var $8DhG7 = parcelRequire("8DhG7");
const $1dbc937b1592930d$export$24a5bd24803ffa4f = ({ children: children, style: style })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            overflow: "hidden",
            transition: "height 0.3s ease",
            ...style
        },
        children: children
    });
const $1dbc937b1592930d$var$StyledHeader = (0, $hYbro.default).header`
    background-color: ${(props)=>props.$isOpen ? (0, $i2LPb.colorCSS)("N900", 0.5) : (0, $i2LPb.colorCSS)("N900", 0)};
    display: none;
    height: ${(props)=>props.$isOpen ? "100vh" : 0};
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    cursor: ${(props)=>props.$isOpen ? "pointer" : "default"};
    transition: ${(props)=>props.$isOpen ? "background-color 0.6s ease, height 0s linear" : "background-color 0.6s ease, height 0s linear 0.6s"};
    z-index: ${(0, $1D7YE.zIndex).headerShroud};

    @media ${(0, $aT9Ik.minWidth).lg} {
        display: block;
    }
`;
const $1dbc937b1592930d$export$8b251419efc915eb = ({ children: children, "data-open": dataOpen })=>{
    const isOpen = dataOpen === "true";
    return /*#__PURE__*/ (0, $loA2J.jsx)($1dbc937b1592930d$var$StyledHeader, {
        $isOpen: isOpen,
        "$is-open": isOpen,
        children: children
    });
};
const $1dbc937b1592930d$export$c07b820a2befd67c = ({ children: children, "data-start-transparent": startTransparent, "data-active": dataActive })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const isStartTransparent = startTransparent === "true";
    const isActive = dataActive === "true";
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-start-transparent": startTransparent,
        "data-active": String(isActive || isHovered),
        style: {
            backgroundColor: isStartTransparent && !isActive && !isHovered ? (0, $i2LPb.colorCSS)("N0", 0.85) : (0, $i2LPb.colorCSS)("N0", 1),
            boxShadow: isActive || isHovered ? (0, $a7xVp.shadow).normal : "none",
            cursor: "default",
            position: "fixed",
            top: 0,
            transition: "0.5s background-color ease, 0.5s box-shadow ease",
            width: "100vw",
            zIndex: (0, $1D7YE.zIndex).header
        },
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: ()=>setIsHovered(true),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>setIsHovered(false),
        children: children
    });
};
const $1dbc937b1592930d$export$ef8da11641c635de = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            alignItems: "stretch",
            display: "flex",
            height: `${(0, $6IIwI.BIG_NAV_PX_HEIGHT)}px`,
            margin: "0 auto",
            maxWidth: `${(0, $8DhG7.containerWidths).xxl}px`,
            padding: "0 1rem",
            width: "100%"
        },
        children: children
    });

});

parcelRegister("7OiEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $951127b688605870$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");

var $hKC8D = parcelRequire("hKC8D");
const $951127b688605870$var$Buttons = ({ goToBoardsText: goToBoardsText, logInText: logInText, signUpText: signUpText, signUpUrl: signUpUrl, loginUrl: loginUrl, isLoggedIn: isLoggedIn, uuid: uuid })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    // When login state is not yet known render nothing — no layout shift risk
    // since ButtonGroup uses margin-left:auto and collapses cleanly.
    if (isLoggedIn === undefined) return null;
    return isLoggedIn === true && goToBoardsText ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKC8D.ButtonGroup), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKC8D.PrimaryButtonDark), {
            href: "/",
            onClick: ()=>sendTrackEvent("clickedGlobalNavButton", {
                    ...analyticsAttributes,
                    event: "clicked",
                    eventComponent: "globalNavButton",
                    label: goToBoardsText,
                    labelEnglish: "Go to your boards",
                    href: "/",
                    uuid: `${uuid}_goToBoards`
                }),
            "data-uuid": `${uuid}_goToBoards`,
            children: goToBoardsText
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hKC8D.ButtonGroup), {
        children: [
            logInText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKC8D.Button), {
                href: loginUrl,
                onClick: ()=>sendTrackEvent("clickedGlobalNavButton", {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: "globalNavButton",
                        label: logInText,
                        labelEnglish: "Log in",
                        href: loginUrl,
                        uuid: `${uuid}_logIn`
                    }),
                "data-uuid": `${uuid}_login`,
                children: logInText
            }),
            signUpText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $hKC8D.PrimaryButton), {
                href: signUpUrl,
                onClick: async ()=>{
                    const recaptcha_key = window.location.href?.includes("trello.com") ? "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD" : "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";
                    try {
                        await new Promise((resolve)=>{
                            window.grecaptcha.ready(()=>resolve());
                        });
                        await window.grecaptcha.execute(recaptcha_key, {
                            action: "trello_submit"
                        });
                    } catch (error) {
                        console.error("reCAPTCHA error:", error);
                    // Optionally handle the error, e.g. show an error message to the user
                    }
                    return sendTrackEvent("clickedGlobalNavButton", {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: "globalNavButton",
                        label: signUpText,
                        labelEnglish: "Get Trello for free",
                        href: signUpUrl,
                        uuid: `${uuid}_signup`
                    });
                },
                "data-uuid": `${uuid}_signup`,
                children: signUpText
            })
        ]
    });
};
var $951127b688605870$export$2e2bcd8739ae039 = $951127b688605870$var$Buttons;

});
parcelRegister("hKC8D", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $de03b6fc075aaa1b$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "PrimaryButton", function () { return $de03b6fc075aaa1b$export$ac16a6a04d9b7c84; });
$parcel$export(module.exports, "PrimaryButtonDark", function () { return $de03b6fc075aaa1b$export$702e7e4d5a807ca3; });
$parcel$export(module.exports, "ButtonGroup", function () { return $de03b6fc075aaa1b$export$69b1032f2ecdf404; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $de03b6fc075aaa1b$export$353f5b6fc5456de1 = (0, $hYbro.styled).a`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("align-self", "stretch")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "1.2rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    }
`;
const $de03b6fc075aaa1b$export$ac16a6a04d9b7c84 = (0, $hYbro.styled)($de03b6fc075aaa1b$export$353f5b6fc5456de1)`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", (0, $i2LPb.colorCSS)("B300"))}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")} !important`)}

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", (0, $i2LPb.colorCSS)("B500"))}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")} !important`)}
    }
`;
const $de03b6fc075aaa1b$export$702e7e4d5a807ca3 = (0, $hYbro.styled)($de03b6fc075aaa1b$export$353f5b6fc5456de1)({
    "backgroundColor": (0, $i2LPb.colorCSS)("N800"),
    "color": `${(0, $i2LPb.colorCSS)("N0")} !important`,
    "&:hover": {
        "backgroundColor": (0, $i2LPb.colorCSS)("N400"),
        "background-color": (0, $i2LPb.colorCSS)("N400")
    },
    "&:active": {
        "backgroundColor": (0, $i2LPb.colorCSS)("N100"),
        "background-color": (0, $i2LPb.colorCSS)("N100")
    }
});
const $de03b6fc075aaa1b$export$69b1032f2ecdf404 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "stretch")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "auto")}
`;

});


parcelRegister("5nQ8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a103d13d7a594764$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hGV8X = parcelRequire("hGV8X");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");

var $33PqJ = parcelRequire("33PqJ");

var $1LBks = parcelRequire("1LBks");
parcelRequire("2krCx");
var $f5zGO = parcelRequire("f5zGO");

var $bv11z = parcelRequire("bv11z");
const $a103d13d7a594764$var$TabDetail = ({ tab: { content: { entryTitle: entryTitle, title: title, primaryBanner: primaryBanner, primaryCta: primaryCta, primaryLinks: primaryLinks, primaryTitle: primaryTitle, secondaryCta: secondaryCta, secondaryBanners: secondaryBanners, secondaryBlogArticle: secondaryBlogArticle, secondaryDescription: secondaryDescription, secondaryLinks: secondaryLinks, secondaryTitle: secondaryTitle } }, active: active })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const [opacity, setOpacity] = (0, $iSvIT.useState)(0);
    (0, $iSvIT.useEffect)(()=>{
        setOpacity(active ? 1 : 0);
    }, [
        active
    ]);
    const tabAttributes = {
        ...analyticsAttributes,
        parentLabel: title,
        labelEnglish: entryTitle
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: tabAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hGV8X))), {
            active: active,
            focusTrapOptions: {
                allowOutsideClick: true,
                fallbackFocus: "#skip-to-content"
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $bv11z.Detail), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailPrimary), {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $bv11z.DetailInner), {
                            style: {
                                opacity: opacity
                            },
                            children: [
                                primaryTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: primaryTitle
                                }),
                                primaryLinks && /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailPrimaryLinks), {
                                    children: (0, $33PqJ.renderViewModels)(primaryLinks)
                                }),
                                primaryBanner && /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                    value: {
                                        eventComponent: "globalNavPrimaryButton"
                                    },
                                    children: (0, $33PqJ.renderViewModel)(primaryBanner)
                                }),
                                primaryCta?.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5zGO.default), {
                                    url: primaryCta.content.url,
                                    text: primaryCta.content.text,
                                    ariaLabel: primaryCta.content.ariaLabel,
                                    onClick: ()=>sendTrackEvent("clickedGlobalNavPrimaryLink", {
                                            ...tabAttributes,
                                            event: "clicked",
                                            eventComponent: "globalNavPrimaryLink",
                                            label: primaryCta.content.text,
                                            labelEnglish: primaryCta.content.entryTitle,
                                            parentLabel: title,
                                            href: primaryCta.content.url,
                                            uuid: primaryCta.id
                                        })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailSecondary), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailInner), {
                            style: {
                                opacity: opacity
                            },
                            children: secondaryBlogArticle?.content ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LBks.default), {
                                model: secondaryBlogArticle,
                                isShowing: active
                            }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                children: [
                                    secondaryTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                        children: secondaryTitle
                                    }),
                                    secondaryDescription && !secondaryLinks && //show desc on mobile solutions tab (has secondaryLinks) but not here
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                                        children: secondaryDescription
                                    }),
                                    secondaryLinks ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailSecondaryLinks), {
                                        children: (0, $33PqJ.renderViewModels)(secondaryLinks)
                                    }) : secondaryBanners && /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                        value: {
                                            eventComponent: "globalNavSecondaryButton"
                                        },
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $bv11z.DetailSecondaryBanners), {
                                            children: (0, $33PqJ.renderViewModels)(secondaryBanners)
                                        })
                                    }),
                                    secondaryCta?.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5zGO.default), {
                                        url: secondaryCta.content.url,
                                        text: secondaryCta.content.text,
                                        ariaLabel: secondaryCta.content.ariaLabel,
                                        onClick: ()=>sendTrackEvent("clickedGlobalNavSecondaryLink", {
                                                ...tabAttributes,
                                                event: "clicked",
                                                eventComponent: "globalNavSecondaryLink",
                                                label: secondaryCta.content.text,
                                                labelEnglish: secondaryCta.content.entryTitle,
                                                parentLabel: title,
                                                href: secondaryCta.content.url,
                                                uuid: secondaryCta.id
                                            })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var $a103d13d7a594764$export$2e2bcd8739ae039 = $a103d13d7a594764$var$TabDetail;

});
parcelRegister("hGV8X", function(module, exports) {
"use strict";
function $ce12af6b90d97e14$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ce12af6b90d97e14$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ce12af6b90d97e14$var$_typeof(obj);
}
function $ce12af6b90d97e14$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce12af6b90d97e14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ce12af6b90d97e14$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ce12af6b90d97e14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce12af6b90d97e14$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ce12af6b90d97e14$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ce12af6b90d97e14$var$_setPrototypeOf(subClass, superClass);
}
function $ce12af6b90d97e14$var$_setPrototypeOf(o, p) {
    $ce12af6b90d97e14$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce12af6b90d97e14$var$_setPrototypeOf(o, p);
}
function $ce12af6b90d97e14$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ce12af6b90d97e14$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ce12af6b90d97e14$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ce12af6b90d97e14$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ce12af6b90d97e14$var$_possibleConstructorReturn(this, result);
    };
}
function $ce12af6b90d97e14$var$_possibleConstructorReturn(self, call) {
    if (call && ($ce12af6b90d97e14$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ce12af6b90d97e14$var$_assertThisInitialized(self);
}
function $ce12af6b90d97e14$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ce12af6b90d97e14$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ce12af6b90d97e14$var$_getPrototypeOf(o) {
    $ce12af6b90d97e14$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce12af6b90d97e14$var$_getPrototypeOf(o);
}
function $ce12af6b90d97e14$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $iSvIT = parcelRequire("iSvIT");

var $i5UxU = parcelRequire("i5UxU");

var $4J1z5 = parcelRequire("4J1z5");

var $hGDKu = parcelRequire("hGDKu");
var $ce12af6b90d97e14$var$createFocusTrap = $hGDKu.createFocusTrap;

var $hbkpM = parcelRequire("hbkpM");
var $ce12af6b90d97e14$var$isFocusable = $hbkpM.isFocusable; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77
/* eslint-disable react/no-find-dom-node */ var $ce12af6b90d97e14$var$FocusTrap = /*#__PURE__*/ function(_React$Component) {
    $ce12af6b90d97e14$var$_inherits(FocusTrap, _React$Component);
    var _super = $ce12af6b90d97e14$var$_createSuper(FocusTrap);
    function FocusTrap(props) {
        var _this;
        $ce12af6b90d97e14$var$_classCallCheck(this, FocusTrap);
        _this = _super.call(this, props);
        $ce12af6b90d97e14$var$_defineProperty($ce12af6b90d97e14$var$_assertThisInitialized(_this), "getNodeForOption", function(optionName) {
            var _this$internalOptions;
            // use internal options first, falling back to original options
            var optionValue = (_this$internalOptions = this.internalOptions[optionName]) !== null && _this$internalOptions !== void 0 ? _this$internalOptions : this.originalOptions[optionName];
            if (typeof optionValue === "function") {
                for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
                optionValue = optionValue.apply(void 0, params);
            }
            if (optionValue === true) optionValue = undefined; // use default value
            if (!optionValue) {
                if (optionValue === undefined || optionValue === false) return optionValue;
                 // else, empty string (invalid), null (invalid), 0 (invalid)
                throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
            }
            var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
            if (typeof optionValue === "string") {
                var _this$getDocument;
                node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue); // resolve to node, or null if fails
                if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            }
            return node;
        });
        _this.handleDeactivate = _this.handleDeactivate.bind($ce12af6b90d97e14$var$_assertThisInitialized(_this));
        _this.handlePostDeactivate = _this.handlePostDeactivate.bind($ce12af6b90d97e14$var$_assertThisInitialized(_this));
        _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind($ce12af6b90d97e14$var$_assertThisInitialized(_this)); // focus-trap options used internally when creating the trap
        _this.internalOptions = {
            // We need to hijack the returnFocusOnDeactivate option,
            // because React can move focus into the element before we arrived at
            // this lifecycle hook (e.g. with autoFocus inputs). So the component
            // captures the previouslyFocusedElement in componentWillMount,
            // then (optionally) returns focus to it in componentWillUnmount.
            returnFocusOnDeactivate: false,
            // the rest of these are also related to deactivation of the trap, and we
            //  need to use them and control them as well
            checkCanReturnFocus: null,
            onDeactivate: _this.handleDeactivate,
            onPostDeactivate: _this.handlePostDeactivate,
            // we need to special-case this setting as well so that we can know if we should
            //  NOT return focus if the trap gets auto-deactivated as the result of an
            //  outside click (otherwise, we'll always think we should return focus because
            //  of how we manage that flag internally here)
            clickOutsideDeactivates: _this.handleClickOutsideDeactivates
        }; // original options provided by the consumer
        _this.originalOptions = {
            // because of the above `internalOptions`, we maintain our own flag for
            //  this option, and default it to `true` because that's focus-trap's default
            returnFocusOnDeactivate: true,
            // because of the above `internalOptions`, we keep these separate since
            //  they're part of the deactivation process which we configure (internally) to
            //  be shared between focus-trap and focus-trap-react
            onDeactivate: null,
            onPostDeactivate: null,
            checkCanReturnFocus: null,
            // the user's setting, defaulted to false since focus-trap defaults this to false
            clickOutsideDeactivates: false
        };
        var focusTrapOptions = props.focusTrapOptions;
        for(var optionName in focusTrapOptions){
            if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) continue;
            if (optionName === "returnFocusOnDeactivate" || optionName === "onDeactivate" || optionName === "onPostDeactivate" || optionName === "checkCanReturnFocus" || optionName === "clickOutsideDeactivates") {
                _this.originalOptions[optionName] = focusTrapOptions[optionName];
                continue; // exclude from internalOptions
            }
            _this.internalOptions[optionName] = focusTrapOptions[optionName];
        } // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
        //  node that was clicked, and `allowDeactivation` is the result of the consumer's
        //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
        //  function) whether to allow or deny auto-deactivation on click on this outside node
        _this.outsideClick = null; // elements from which to create the focus trap on mount; if a child is used
        //  instead of the `containerElements` prop, we'll get the child's related
        //  element when the trap renders and then is declared 'mounted'
        _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap
        _this.updatePreviousElement();
        return _this;
    }
    /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */ $ce12af6b90d97e14$var$_createClass(FocusTrap, [
        {
            key: "getDocument",
            value: function getDocument() {
                // SSR: careful to check if `document` exists before accessing it as a variable
                return this.props.focusTrapOptions.document || (typeof document !== "undefined" ? document : undefined);
            }
        },
        {
            key: "getReturnFocusNode",
            value: function getReturnFocusNode() {
                var node = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
                return node ? node : node === false ? false : this.previouslyFocusedElement;
            }
        },
        {
            key: "updatePreviousElement",
            value: function updatePreviousElement() {
                var currentDocument = this.getDocument();
                if (currentDocument) this.previouslyFocusedElement = currentDocument.activeElement;
            }
        },
        {
            key: "deactivateTrap",
            value: function deactivateTrap() {
                // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
                //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
                //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
                //  will initiate its auto-deactivation process, which will call our own
                //  handleDeactivate(), which will call into this method
                if (!this.focusTrap || !this.focusTrap.active) return;
                this.focusTrap.deactivate({
                    // NOTE: we never let the trap return the focus since we do that ourselves
                    returnFocus: false,
                    // we'll call this in our own post deactivate handler so make sure the trap doesn't
                    //  do it prematurely
                    checkCanReturnFocus: null,
                    // let it call the user's original deactivate handler, if any, instead of
                    //  our own which calls back into this function
                    onDeactivate: this.originalOptions.onDeactivate // NOTE: for post deactivate, don't specify anything so that it calls the
                });
            }
        },
        {
            key: "handleClickOutsideDeactivates",
            value: function handleClickOutsideDeactivates(event) {
                // use consumer's option (or call their handler) as the permission or denial
                var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === "function" ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
                 : this.originalOptions.clickOutsideDeactivates; // boolean
                if (allowDeactivation) // capture the outside target that was clicked so we can use it in the deactivation
                //  process since the consumer allowed it to cause auto-deactivation
                this.outsideClick = {
                    target: event.target,
                    allowDeactivation: allowDeactivation
                };
                return allowDeactivation;
            }
        },
        {
            key: "handleDeactivate",
            value: function handleDeactivate() {
                if (this.originalOptions.onDeactivate) this.originalOptions.onDeactivate.call(null); // call user's handler out of context
                this.deactivateTrap();
            }
        },
        {
            key: "handlePostDeactivate",
            value: function handlePostDeactivate() {
                var _this2 = this;
                var finishDeactivation = function finishDeactivation() {
                    var returnFocusNode = _this2.getReturnFocusNode();
                    var canReturnFocus = !!(_this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
                    returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && (!_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
                    _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
                    //  as a result of the click-through) -- in which case do NOT restore focus
                    //  to `returnFocusNode` because focus should remain on the outside node
                    !$ce12af6b90d97e14$var$isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions) // if no, the restore focus to `returnFocusNode` at this point
                    ));
                    var _this2$internalOption = _this2.internalOptions.preventScroll, preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;
                    if (canReturnFocus) // return focus to the element that had focus when the trap was activated
                    returnFocusNode.focus({
                        preventScroll: preventScroll
                    });
                    if (_this2.originalOptions.onPostDeactivate) _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"
                    _this2.outsideClick = null; // reset: no longer needed
                };
                if (this.originalOptions.checkCanReturnFocus) this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
                .then(finishDeactivation, finishDeactivation);
                else finishDeactivation();
            }
        },
        {
            key: "setupFocusTrap",
            value: function setupFocusTrap() {
                if (!this.focusTrap) {
                    var focusTrapElementDOMNodes = this.focusTrapElements.map(//  a new text node with the text wrapped in it instead of treating the
                    //  string as a selector and resolving it to a node in the DOM
                    $i5UxU.findDOMNode);
                    var nodesExist = focusTrapElementDOMNodes.some(Boolean);
                    if (nodesExist) {
                        // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
                        this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.internalOptions);
                        if (this.props.active) this.focusTrap.activate();
                        if (this.props.paused) this.focusTrap.pause();
                    }
                }
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.active) this.setupFocusTrap();
                 // else, wait for later activation in case the `focusTrapOptions` will be updated
            //  again before the trap is activated (e.g. if waiting to know what the document
            //  object will be, so the Trap must be rendered, but the consumer is waiting to
            //  activate until they have obtained the document from a ref)
            //  @see https://github.com/focus-trap/focus-trap-react/issues/539
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.focusTrap) {
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrap.updateContainerElements(this.props.containerElements);
                    var hasActivated = !prevProps.active && this.props.active;
                    var hasDeactivated = prevProps.active && !this.props.active;
                    var hasPaused = !prevProps.paused && this.props.paused;
                    var hasUnpaused = prevProps.paused && !this.props.paused;
                    if (hasActivated) {
                        this.updatePreviousElement();
                        this.focusTrap.activate();
                    }
                    if (hasDeactivated) {
                        this.deactivateTrap();
                        return; // un/pause does nothing on an inactive trap
                    }
                    if (hasPaused) this.focusTrap.pause();
                    if (hasUnpaused) this.focusTrap.unpause();
                } else {
                    // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
                    //  it either means it shouldn't be active, or it should be but none of
                    //  of given `containerElements` were present in the DOM the last time
                    //  we tried to create the trap
                    if (prevProps.containerElements !== this.props.containerElements) this.focusTrapElements = this.props.containerElements;
                     // don't create the trap unless it should be active in case the consumer
                    //  is still updating `focusTrapOptions`
                    //  @see https://github.com/focus-trap/focus-trap-react/issues/539
                    if (this.props.active) {
                        this.updatePreviousElement();
                        this.setupFocusTrap();
                    }
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deactivateTrap();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var child = this.props.children ? $iSvIT.Children.only(this.props.children) : undefined;
                if (child) {
                    if (child.type && child.type === $iSvIT.Fragment) throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
                    var composedRefCallback = function composedRefCallback(element) {
                        var containerElements = _this3.props.containerElements;
                        if (child) {
                            if (typeof child.ref === "function") child.ref(element);
                            else if (child.ref) child.ref.current = element;
                        }
                        _this3.focusTrapElements = containerElements ? containerElements : [
                            element
                        ];
                    };
                    var childWithRef = $iSvIT.cloneElement(child, {
                        ref: composedRefCallback
                    });
                    return childWithRef;
                }
                return null;
            }
        }
    ]);
    return FocusTrap;
}($iSvIT.Component); // support server-side rendering where `Element` will not be defined
var $ce12af6b90d97e14$var$ElementType = typeof Element === "undefined" ? Function : Element;
$ce12af6b90d97e14$var$FocusTrap.propTypes = {
    active: $4J1z5.bool,
    paused: $4J1z5.bool,
    focusTrapOptions: $4J1z5.shape({
        document: $4J1z5.object,
        onActivate: $4J1z5.func,
        onPostActivate: $4J1z5.func,
        checkCanFocusTrap: $4J1z5.func,
        onDeactivate: $4J1z5.func,
        onPostDeactivate: $4J1z5.func,
        checkCanReturnFocus: $4J1z5.func,
        initialFocus: $4J1z5.oneOfType([
            $4J1z5.instanceOf($ce12af6b90d97e14$var$ElementType),
            $4J1z5.string,
            $4J1z5.bool,
            $4J1z5.func
        ]),
        fallbackFocus: $4J1z5.oneOfType([
            $4J1z5.instanceOf($ce12af6b90d97e14$var$ElementType),
            $4J1z5.string,
            $4J1z5.func
        ]),
        escapeDeactivates: $4J1z5.oneOfType([
            $4J1z5.bool,
            $4J1z5.func
        ]),
        clickOutsideDeactivates: $4J1z5.oneOfType([
            $4J1z5.bool,
            $4J1z5.func
        ]),
        returnFocusOnDeactivate: $4J1z5.bool,
        setReturnFocus: $4J1z5.oneOfType([
            $4J1z5.instanceOf($ce12af6b90d97e14$var$ElementType),
            $4J1z5.string,
            $4J1z5.bool,
            $4J1z5.func
        ]),
        allowOutsideClick: $4J1z5.oneOfType([
            $4J1z5.bool,
            $4J1z5.func
        ]),
        preventScroll: $4J1z5.bool,
        tabbableOptions: $4J1z5.shape({
            displayCheck: $4J1z5.oneOf([
                "full",
                "non-zero-area",
                "none"
            ]),
            getShadowRoot: $4J1z5.oneOfType([
                $4J1z5.bool,
                $4J1z5.func
            ])
        })
    }),
    containerElements: $4J1z5.arrayOf($4J1z5.instanceOf($ce12af6b90d97e14$var$ElementType)),
    children: $4J1z5.oneOfType([
        $4J1z5.element,
        $4J1z5.instanceOf($ce12af6b90d97e14$var$ElementType) // DOM element
    ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
};
$ce12af6b90d97e14$var$FocusTrap.defaultProps = {
    active: true,
    paused: false,
    focusTrapOptions: {},
    _createFocusTrap: $ce12af6b90d97e14$var$createFocusTrap
};
module.exports = $ce12af6b90d97e14$var$FocusTrap;

});
parcelRegister("hGDKu", function(module, exports) {

$parcel$export(module.exports, "createFocusTrap", function () { return $ce05313a01fbcd49$export$360440dfcba94c00; });
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $hbkpM = parcelRequire("hbkpM");
function $ce05313a01fbcd49$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce05313a01fbcd49$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ce05313a01fbcd49$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ce05313a01fbcd49$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ce05313a01fbcd49$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce05313a01fbcd49$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ce05313a01fbcd49$var$activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                // move this existing trap to the front of the queue
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var $ce05313a01fbcd49$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var $ce05313a01fbcd49$var$isEscapeEvent = function isEscapeEvent(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var $ce05313a01fbcd49$var$isTabEvent = function isTabEvent(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var $ce05313a01fbcd49$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs
var $ce05313a01fbcd49$var$findIndex = function findIndex(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false; // break
        }
        return true; // next
    });
    return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $ce05313a01fbcd49$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var $ce05313a01fbcd49$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var $ce05313a01fbcd49$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = $ce05313a01fbcd49$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element) {
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
             // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue); // resolve to node, or null if fails
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption("initialFocus"); // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined) {
            // option not specified: use fallback options
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $hbkpM.tabbable)(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes
            var focusableNodes = (0, $hbkpM.focusable)(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    // NOTE: If tabindex is positive (in order to manipulate the tab order separate
                    //  from the DOM order), this __will not work__ because the list of focusableNodes,
                    //  while it contains tabbable nodes, does not sort its nodes in any order other
                    //  than DOM order, because it can't: Where would you place focusable (but not
                    //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
                    // Support for positive tabindex is already broken and hard to manage (possibly
                    //  not supportable, TBD), so this isn't going to make things worse than they
                    //  already are, and at least makes things better for the majority of cases where
                    //  tabindex is either 0/unset or negative.
                    // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return undefined;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return (0, $hbkpM.isTabbable)(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return (0, $hbkpM.isTabbable)(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus") // returning false not supported for this option
        ) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if ($ce05313a01fbcd49$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    }; // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $ce05313a01fbcd49$var$getActualTarget(e);
        if (findContainerIndex(target) >= 0) // allow the click since it ocurred inside the trap
        return;
        if ($ce05313a01fbcd49$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !(0, $hbkpM.isFocusable)(target, config.tabbableOptions)
            });
            return;
        } // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($ce05313a01fbcd49$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
         // otherwise, prevent the click
        e.preventDefault();
    }; // In case focus escapes the trap for some strange reason, pull it back in.
    var checkFocusIn = function checkFocusIn(e) {
        var target = $ce05313a01fbcd49$var$getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    }; // Hijack Tab events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkTab = function checkTab(e) {
        var target = $ce05313a01fbcd49$var$getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back in to...
                if (e.shiftKey) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = $ce05313a01fbcd49$var$findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $hbkpM.isFocusable)(target, config.tabbableOptions) && !(0, $hbkpM.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = $ce05313a01fbcd49$var$findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $hbkpM.isFocusable)(target, config.tabbableOptions) && !(0, $hbkpM.isTabbable)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        } // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkKey = function checkKey(e) {
        if ($ce05313a01fbcd49$var$isEscapeEvent(e) && $ce05313a01fbcd49$var$valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if ($ce05313a01fbcd49$var$isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick(e) {
        var target = $ce05313a01fbcd49$var$getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if ($ce05313a01fbcd49$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($ce05313a01fbcd49$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }; //
    // EVENT LISTENERS
    //
    var addListeners = function addListeners() {
        if (!state.active) return;
         // There can be only one listening focus trap at a time
        $ce05313a01fbcd49$var$activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        state.delayInitialFocusTimer = config.delayInitialFocus ? $ce05313a01fbcd49$var$delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    }; //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $ce05313a01fbcd49$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            removeListeners();
            state.active = false;
            state.paused = false;
            $ce05313a01fbcd49$var$activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation() {
                $ce05313a01fbcd49$var$delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    }; // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};

});
parcelRegister("hbkpM", function(module, exports) {

$parcel$export(module.exports, "tabbable", function () { return $c8234caf0592ea46$export$17100aea90429aa7; });
$parcel$export(module.exports, "focusable", function () { return $c8234caf0592ea46$export$ecc6d1fcdff4f700; });
$parcel$export(module.exports, "isTabbable", function () { return $c8234caf0592ea46$export$bebd5a1431fec25d; });
$parcel$export(module.exports, "isFocusable", function () { return $c8234caf0592ea46$export$4c063cf1350e6fed; });
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ var $c8234caf0592ea46$var$candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var $c8234caf0592ea46$var$candidateSelector = /* #__PURE__ */ $c8234caf0592ea46$var$candidateSelectors.join(",");
var $c8234caf0592ea46$var$NoElement = typeof Element === "undefined";
var $c8234caf0592ea46$var$matches = $c8234caf0592ea46$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $c8234caf0592ea46$var$getRootNode = !$c8234caf0592ea46$var$NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $c8234caf0592ea46$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($c8234caf0592ea46$var$candidateSelector));
    if (includeContainer && $c8234caf0592ea46$var$matches.call(el, $c8234caf0592ea46$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */ var $c8234caf0592ea46$var$getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $c8234caf0592ea46$var$matches.call(element, $c8234caf0592ea46$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
             // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var $c8234caf0592ea46$var$getTabindex = function getTabindex(node, isScope) {
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        //
        // isScope is positive for custom element with shadow root or slot that by default
        // have tabIndex -1, but need to be sorted by document order in order for their
        // content to be inserted in the correct position
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var $c8234caf0592ea46$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $c8234caf0592ea46$var$isInput = function isInput(node) {
    return node.tagName === "INPUT";
};
var $c8234caf0592ea46$var$isHiddenInput = function isHiddenInput(node) {
    return $c8234caf0592ea46$var$isInput(node) && node.type === "hidden";
};
var $c8234caf0592ea46$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var $c8234caf0592ea46$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $c8234caf0592ea46$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $c8234caf0592ea46$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = $c8234caf0592ea46$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $c8234caf0592ea46$var$isRadio = function isRadio(node) {
    return $c8234caf0592ea46$var$isInput(node) && node.type === "radio";
};
var $c8234caf0592ea46$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $c8234caf0592ea46$var$isRadio(node) && !$c8234caf0592ea46$var$isTabbableRadio(node);
};
var $c8234caf0592ea46$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $c8234caf0592ea46$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = $c8234caf0592ea46$var$matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($c8234caf0592ea46$var$matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
     // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    var nodeRootHost = $c8234caf0592ea46$var$getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $c8234caf0592ea46$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $c8234caf0592ea46$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if (nodeIsAttached) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
         // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.
    } else if (displayCheck === "non-zero-area") // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $c8234caf0592ea46$var$isZeroArea(node);
     // visible, as far as we can tell, or per current `displayCheck` mode
    return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $c8234caf0592ea46$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i); // when the first <legend> (in document order) is found
                    if (child.tagName === "LEGEND") // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $c8234caf0592ea46$var$matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                } // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    } // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $c8234caf0592ea46$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $c8234caf0592ea46$var$isHiddenInput(node) || $c8234caf0592ea46$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $c8234caf0592ea46$var$isDetailsWithSummary(node) || $c8234caf0592ea46$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $c8234caf0592ea46$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($c8234caf0592ea46$var$isNonTabbableRadio(node) || $c8234caf0592ea46$var$getTabindex(node) < 0 || !$c8234caf0592ea46$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $c8234caf0592ea46$var$isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
     // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */ var $c8234caf0592ea46$var$sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = $c8234caf0592ea46$var$getTabindex(element, isScope);
        var elements = isScope ? sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($c8234caf0592ea46$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $c8234caf0592ea46$export$17100aea90429aa7 = function tabbable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $c8234caf0592ea46$var$getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: $c8234caf0592ea46$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $c8234caf0592ea46$var$isValidShadowRootTabbable
    });
    else candidates = $c8234caf0592ea46$var$getCandidates(el, options.includeContainer, $c8234caf0592ea46$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $c8234caf0592ea46$var$sortByOrder(candidates);
};
var $c8234caf0592ea46$export$ecc6d1fcdff4f700 = function focusable(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $c8234caf0592ea46$var$getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: $c8234caf0592ea46$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $c8234caf0592ea46$var$getCandidates(el, options.includeContainer, $c8234caf0592ea46$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $c8234caf0592ea46$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($c8234caf0592ea46$var$matches.call(node, $c8234caf0592ea46$var$candidateSelector) === false) return false;
    return $c8234caf0592ea46$var$isNodeMatchingSelectorTabbable(options, node);
};
var $c8234caf0592ea46$var$focusableCandidateSelector = /* #__PURE__ */ $c8234caf0592ea46$var$candidateSelectors.concat("iframe").join(",");
var $c8234caf0592ea46$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if ($c8234caf0592ea46$var$matches.call(node, $c8234caf0592ea46$var$focusableCandidateSelector) === false) return false;
    return $c8234caf0592ea46$var$isNodeMatchingSelectorFocusable(options, node);
};

});



parcelRegister("1LBks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02d836dd514c3343$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aYuhG = parcelRequire("aYuhG");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $fuZB8 = parcelRequire("fuZB8");
var $41Ir1 = parcelRequire("41Ir1");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("2krCx");
var $f5zGO = parcelRequire("f5zGO");

var $616LX = parcelRequire("616LX");

var $8lkWk = parcelRequire("8lkWk");
const $02d836dd514c3343$var$UiNavBlogArticle = ({ model: { id: id, type: type, content: { entryTitle: entryTitle, fallback: fallback, title: title, cta: cta } }, isShowing: isShowing = true, tabIndex: tabIndex })=>{
    const feeds = {
        de: "https://blog.trello.com/de/tag/anwendungsf%C3%A4lle/rss.xml",
        en: "https://blog.trello.com/tag/use-cases/rss.xml",
        es: "https://blog.trello.com/es/tag/ejemplos-de-uso/rss.xml",
        fr: "https://blog.trello.com/fr/tag/id%C3%A9es-tableaux/rss.xml",
        pt: "https://blog.trello.com/br/tag/exemplos-de-uso/rss.xml"
    };
    const [article, setArticle] = (0, $iSvIT.useState)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const lang = (0, $fuZB8.useLanguage)().substring(0, 2);
    const [error, setError] = (0, $iSvIT.useState)(false);
    const feed = feeds[lang];
    (0, $iSvIT.useEffect)(()=>{
        let cancelled = false;
        async function fetchArticle(feed) {
            try {
                const response = await (0, (/*@__PURE__*/$parcel$interopDefault($aYuhG)))(feed);
                const text = await response.text();
                const article = (0, $616LX.default)(text);
                if (!cancelled) setArticle(article);
            } catch (e) {
                console.error(e);
                if (!cancelled) setError(true);
            }
        }
        if (isShowing && feed && !article && !error) fetchArticle(feed);
        return ()=>{
            cancelled = true;
        };
    }, [
        feed,
        isShowing,
        article,
        error
    ]);
    //lang is not supported or there's been an error, render fallback UiNavBanner
    if (!feed || error) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.FallbackBanner), {
        children: (0, $33PqJ.renderViewModel)(fallback)
    });
    //article is still loading, render placeholder skeleton
    if (!article) return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8lkWk.PlaceholderFrame), {
        "data-testid": "ui-blog-article",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.PlaceholderImage), {}),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.Eyebrow), {
                isPlaceholder: true
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.Title), {
                isPlaceholder: true
            })
        ]
    });
    //render article loaded from RSS feed
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8lkWk.Link), {
                href: article.url,
                onClick: ()=>sendTrackEvent("clickedUiBlogArticle", {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: type,
                        href: article.url,
                        label: article.title,
                        labelEnglish: entryTitle,
                        uuid: id
                    }),
                tabIndex: tabIndex,
                target: "_blank",
                "data-testid": "ui-blog-article",
                children: [
                    article.imageUrl && /*#__PURE__*/ (0, $loA2J.jsx)((0, $41Ir1.Picture), {
                        image: {
                            id: id,
                            url: article.imageUrl,
                            title: article.title || "",
                            width: 0,
                            height: 0
                        },
                        decorative: true
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.Eyebrow), {
                        children: article.eyebrow
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $8lkWk.Title), {
                        children: article.title
                    })
                ]
            }),
            cta.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5zGO.default), {
                url: cta.content.url,
                text: cta.content.text,
                ariaLabel: cta.content.ariaLabel,
                onClick: ()=>sendTrackEvent("clickedGlobalNavSecondaryLink", {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: "globalNavSecondaryLink",
                        label: cta.content.text,
                        labelEnglish: cta.content.entryTitle,
                        parentLabel: title,
                        href: cta.content.url,
                        uuid: cta.id
                    })
            })
        ]
    });
};
var $02d836dd514c3343$export$2e2bcd8739ae039 = $02d836dd514c3343$var$UiNavBlogArticle;

});
parcelRegister("616LX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $309babf7ab1db094$export$2e2bcd8739ae039; });
function $309babf7ab1db094$export$2e2bcd8739ae039(rss) {
    const xml = new DOMParser().parseFromString(rss, "text/xml");
    return {
        eyebrow: $309babf7ab1db094$var$parseEyebrow(xml) ?? "",
        imageUrl: $309babf7ab1db094$var$parseImageUrl(xml),
        title: $309babf7ab1db094$var$parseTitle(xml) ?? "",
        url: $309babf7ab1db094$var$parseUrl(xml) ?? ""
    };
}
function $309babf7ab1db094$var$parseEyebrow(xml) {
    const categories = [];
    xml.querySelectorAll("item > category").forEach((node)=>node.textContent && categories.push(node.textContent));
    return categories.length ? categories.join(" | ") : undefined;
}
function $309babf7ab1db094$var$parseImageUrl(xml) {
    const htmlString = xml.querySelector("item > description")?.textContent;
    if (!htmlString) return undefined;
    const html = new DOMParser().parseFromString(htmlString, "text/html");
    return html.querySelector("img")?.getAttribute("src")?.split("?")[0];
}
function $309babf7ab1db094$var$parseTitle(xml) {
    return xml.querySelector("item > title")?.textContent?.split(" | ")[0];
}
function $309babf7ab1db094$var$parseUrl(xml) {
    return xml.querySelector("item > link")?.textContent;
}

});

parcelRegister("8lkWk", function(module, exports) {

$parcel$export(module.exports, "PlaceholderImage", function () { return $c2df1b7732fef423$export$4e70ae8a78c1bcc; });
$parcel$export(module.exports, "Link", function () { return $c2df1b7732fef423$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "PlaceholderFrame", function () { return $c2df1b7732fef423$export$13cc94ea5f31c337; });
$parcel$export(module.exports, "Eyebrow", function () { return $c2df1b7732fef423$export$71f050e2efa708bb; });
$parcel$export(module.exports, "Title", function () { return $c2df1b7732fef423$export$f99233281efd08a0; });
$parcel$export(module.exports, "FallbackBanner", function () { return $c2df1b7732fef423$export$35a83781e90cb491; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $a7xVp = parcelRequire("a7xVp");

var $jAJVK = parcelRequire("jAJVK");
// Keyframe animation as CSS string
const $c2df1b7732fef423$var$placeholderGlowKeyframes = `
@keyframes placeholderGlow {
    50% {
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", "0.37")}
    }
}
`;
const $c2df1b7732fef423$var$placeholderStyle = {
    animationDuration: "2s",
    animationIterationCount: "infinite",
    animationName: "placeholderGlow",
    backgroundColor: "currentcolor",
    opacity: 0.5
};
const $c2df1b7732fef423$var$placeholderImageStyle = {
    ...$c2df1b7732fef423$var$placeholderStyle,
    height: 0,
    paddingBottom: "50%"
};
const $c2df1b7732fef423$var$placeholderTextStyle = {
    ...$c2df1b7732fef423$var$placeholderStyle,
    display: "inline-block"
};
const $c2df1b7732fef423$var$blogArticleStyle = {
    backgroundColor: (0, $i2LPb.colorCSS)("N0"),
    borderRadius: (0, $fpcku.radius).button,
    color: `${(0, $i2LPb.colorCSS)("N800")}`,
    display: "block",
    margin: "2rem 0 1.5rem",
    paddingBlockEnd: "1rem",
    textAlign: "left",
    textDecoration: "none",
    width: "100%"
};
const $c2df1b7732fef423$var$linkStyle = {
    ...$c2df1b7732fef423$var$blogArticleStyle,
    transition: "box-shadow 0.3s"
};
const $c2df1b7732fef423$var$eyebrowStyle = {
    color: (0, $i2LPb.colorCSS)("N400"),
    fontSize: (0, $kL1mL.fontSizes).xxs,
    margin: "1rem 1rem 0",
    textTransform: "uppercase"
};
const $c2df1b7732fef423$var$eyebrowPlaceholderStyle = {
    ...$c2df1b7732fef423$var$placeholderTextStyle,
    minHeight: "1rem",
    width: "80%"
};
const $c2df1b7732fef423$var$titleStyle = {
    fontSize: (0, $kL1mL.fontSizes).sm,
    margin: "0.5rem 1rem 0"
};
const $c2df1b7732fef423$var$titlePlaceholderStyle = {
    ...$c2df1b7732fef423$var$placeholderTextStyle,
    height: "3rem",
    width: "90%"
};
// Styled-components for SSR CSS generation
const $c2df1b7732fef423$var$PlaceholderTextStyled = (0, $hYbro.default).span({
    "animationDuration": "2s",
    "animation-duration": "2s",
    "animationIterationCount": "infinite",
    "animation-iteration-count": "infinite",
    "animationName": "placeholderGlow",
    "animation-name": "placeholderGlow",
    "backgroundColor": "currentcolor",
    "background-color": "currentcolor",
    "opacity": 0.5,
    "display": "inline-block"
});
const $c2df1b7732fef423$var$FallbackBannerStyled = (0, $hYbro.default).div({
    margin: "-1rem"
});
const $c2df1b7732fef423$var$PlaceholderImageStyled = (0, $hYbro.default).div({
    animationDuration: "2s",
    animationIterationCount: "infinite",
    animationName: "placeholderGlow",
    backgroundColor: "currentcolor",
    opacity: 0.5,
    height: 0,
    paddingBottom: "50%",
    borderRadius: (props)=>props.borderRadius
});
// Inject keyframes into document
if (typeof document !== "undefined" && !document.getElementById("placeholder-glow-keyframes")) {
    const style = document.createElement("style");
    style.id = "placeholder-glow-keyframes";
    style.textContent = $c2df1b7732fef423$var$placeholderGlowKeyframes;
    document.head.appendChild(style);
}
const $c2df1b7732fef423$export$4e70ae8a78c1bcc = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($c2df1b7732fef423$var$PlaceholderImageStyled, {
        borderRadius: `${(0, $fpcku.radius).button} ${(0, $fpcku.radius).button} 0 0`,
        ...props
    });
};
const $c2df1b7732fef423$export$5dd7e4f3fa008590 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($c2df1b7732fef423$var$PlaceholderTextStyled, {
        ...props
    });
const $c2df1b7732fef423$export$a6c7ac8248d6e38a = (props)=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    const style = {
        ...$c2df1b7732fef423$var$linkStyle,
        ...isHovered && {
            boxShadow: (0, $a7xVp.shadow).normal
        },
        ...props.style
    };
    return(// eslint-disable-next-line @atlassian/a11y/anchor-has-content
    /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        ...props,
        style: style,
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseEnter: (e)=>{
            setIsHovered(true);
            props.onMouseEnter?.(e);
        },
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: (e)=>{
            setIsHovered(false);
            props.onMouseLeave?.(e);
        }
    }));
};
const $c2df1b7732fef423$export$13cc94ea5f31c337 = (props)=>{
    const style = {
        ...$c2df1b7732fef423$var$blogArticleStyle,
        cursor: "wait",
        ...props.style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ...props,
        style: style
    });
};
const $c2df1b7732fef423$export$71f050e2efa708bb = ({ isPlaceholder: isPlaceholder, ...props })=>{
    const style = {
        ...$c2df1b7732fef423$var$eyebrowStyle,
        ...props.style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        ...props,
        style: style,
        children: isPlaceholder ? /*#__PURE__*/ (0, $loA2J.jsx)($c2df1b7732fef423$export$5dd7e4f3fa008590, {
            style: $c2df1b7732fef423$var$eyebrowPlaceholderStyle
        }) : props.children
    });
};
const $c2df1b7732fef423$export$f99233281efd08a0 = ({ isPlaceholder: isPlaceholder, ...props })=>{
    const style = {
        ...$c2df1b7732fef423$var$titleStyle,
        ...props.style
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("p", {
        ...props,
        style: style,
        children: isPlaceholder ? /*#__PURE__*/ (0, $loA2J.jsx)($c2df1b7732fef423$export$5dd7e4f3fa008590, {
            style: $c2df1b7732fef423$var$titlePlaceholderStyle
        }) : props.children
    });
};
const $c2df1b7732fef423$export$35a83781e90cb491 = (props)=>/*#__PURE__*/ (0, $loA2J.jsx)($c2df1b7732fef423$var$FallbackBannerStyled, {
        ...props
    });

});


parcelRegister("bv11z", function(module, exports) {

$parcel$export(module.exports, "Detail", function () { return $28610e5a57b146d6$export$47eb42ff093406d4; });
$parcel$export(module.exports, "DetailInner", function () { return $28610e5a57b146d6$export$93280720fe3dfb5; });
$parcel$export(module.exports, "DetailPrimary", function () { return $28610e5a57b146d6$export$2459550d045f64b5; });
$parcel$export(module.exports, "DetailPrimaryLinks", function () { return $28610e5a57b146d6$export$d59b443bd7930a49; });
$parcel$export(module.exports, "DetailSecondary", function () { return $28610e5a57b146d6$export$d10a5eb18334be24; });
$parcel$export(module.exports, "DetailSecondaryLinks", function () { return $28610e5a57b146d6$export$f7edaab43d374da7; });
$parcel$export(module.exports, "DetailSecondaryBanners", function () { return $28610e5a57b146d6$export$d478f98550c218dc; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $bC5c7 = parcelRequire("bC5c7");
var $kL1mL = parcelRequire("kL1mL");
var $a7xVp = parcelRequire("a7xVp");

var $jAJVK = parcelRequire("jAJVK");
const $28610e5a57b146d6$export$47eb42ff093406d4 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "row")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "960px")}
    }

    @media (min-width: 1200px) {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "1140px")}
    }

    @media (min-width: 1400px) {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "1320px")}
    }
`;
const $28610e5a57b146d6$export$3967cdd2743c76b8 = (0, $hYbro.styled).h3`
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.text}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $28610e5a57b146d6$export$93280720fe3dfb5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "opacity 0.3s ease")}
`;
const $28610e5a57b146d6$export$2459550d045f64b5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow)["normal_inset"]}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem 1rem 4.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("flex", "1 1 auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem 0 4.75rem 0")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
    }
`;
const $28610e5a57b146d6$export$6b3d5332e90ef1d4 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "start")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 2rem 0 auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "640px")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 2rem 0 1rem")}
    }

    @media (min-width: 1200px) {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "760px")}
    }
`;
const $28610e5a57b146d6$export$d59b443bd7930a49 = (0, $hYbro.styled).nav`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 -1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem 0")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $28610e5a57b146d6$export$b074e9978ddd39c9 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    
    @media (min-width: 768px) {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "50%")}
    }

    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "33.33333%")}
    }
`;
const $28610e5a57b146d6$export$d10a5eb18334be24 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("P50", 0.4)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow)["normal_inset"]}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem 1rem 4.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("flex", "0 0 280px")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem 0 4.75rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "280px")}
    }

    @media (min-width: 1200px) {
        ${(0, $jAJVK.redundantCssFromKebab)("flex", "0 0 332px")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "332px")}
    }
`;
const $28610e5a57b146d6$export$d000da6ba038bdb4 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    
    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto 0 2rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "240px")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }

    @media (min-width: 1200px) {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "285px")}
    }
`;
const $28610e5a57b146d6$export$cffdd68255d49e29 = (0, $hYbro.styled).h3`
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom-color", `${(0, $i2LPb.colorCSS)("P100")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.text}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $28610e5a57b146d6$export$f7edaab43d374da7 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1.5rem 0")}

    > * {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }
`;
const $28610e5a57b146d6$export$d478f98550c218dc = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}

    > * {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }
`;

});


parcelRegister("3a3BT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33c2e1f8aa5bbaed$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7YcSr = parcelRequire("7YcSr");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5FSC2 = parcelRequire("5FSC2");

var $47r81 = parcelRequire("47r81");
const $33c2e1f8aa5bbaed$var$Tabs = ({ tabs: tabs, activeTab: activeTab, setActiveTab: setActiveTab })=>{
    const location = (0, $7YcSr.useLocation)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const activeTabRef = (0, $iSvIT.useRef)(null);
    const [activeTabStyle, setActiveTabStyle] = (0, $iSvIT.useState)({
        width: 0
    });
    (0, $iSvIT.useEffect)(()=>{
        if (activeTabRef.current) setActiveTabStyle({
            left: activeTabRef.current.offsetLeft + 16,
            width: activeTabRef.current.clientWidth - 32
        });
        else if (activeTabStyle && activeTabStyle.left) {
            setActiveTabStyle({
                left: activeTabStyle.left,
                width: 0
            });
            setTimeout(()=>{
                setActiveTabStyle({
                    width: 0
                });
            }, 300);
        }
    }, [
        activeTab,
        activeTabRef,
        activeTabStyle
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $47r81.TabGroup), {
        children: [
            tabs?.map((tab, index)=>tab.type === "uiHeaderNavTab" ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $47r81.Tab), {
                    "aria-expanded": activeTab === index,
                    "data-active": activeTab === index,
                    "data-testid": "bignav-tab",
                    onClick: (e)=>{
                        if (activeTab === index) setActiveTab(undefined);
                        else {
                            sendTrackEvent("clickedGlobalNavTab", {
                                ...analyticsAttributes,
                                event: "clicked",
                                eventComponent: "globalNavTab",
                                label: tab.content.title,
                                labelEnglish: tab.content.entryTitle,
                                uuid: tab.id
                            });
                            setActiveTab(index);
                        }
                        e.stopPropagation();
                    },
                    ref: activeTab === index ? activeTabRef : null,
                    children: [
                        tab.content.title,
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5FSC2.ChevronDown), {})
                    ]
                }, index) : tab.type === "uiLink" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $47r81.Link), {
                    "aria-current": location?.pathname === tab.content.url ? "page" : undefined,
                    href: tab.content.url,
                    onClick: ()=>sendTrackEvent("clickedGlobalNavLink", {
                            ...analyticsAttributes,
                            event: "clicked",
                            eventComponent: "globalNavLink",
                            label: tab.content.text,
                            labelEnglish: tab.content.entryTitle,
                            href: tab.content.url,
                            uuid: tab.id
                        }),
                    children: tab.content.text
                }, index) : null),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $47r81.Underline), {
                style: activeTabStyle
            })
        ]
    });
};
var $33c2e1f8aa5bbaed$export$2e2bcd8739ae039 = $33c2e1f8aa5bbaed$var$Tabs;

});
parcelRegister("47r81", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $3c1bc1ed6a0e83a8$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "Tab", function () { return $3c1bc1ed6a0e83a8$export$3e41faf802a29e71; });
$parcel$export(module.exports, "TabGroup", function () { return $3c1bc1ed6a0e83a8$export$85fd4ed3b8ca1010; });
$parcel$export(module.exports, "Underline", function () { return $3c1bc1ed6a0e83a8$export$741ee5bff4f2bc22; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $3c1bc1ed6a0e83a8$var$tabCSS = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("align-self", "stretch")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1.25rem 1rem 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("user-select", "none")}

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("B300")}`)}
    }
`;
const $3c1bc1ed6a0e83a8$export$a6c7ac8248d6e38a = (0, $hYbro.styled).a`
    ${$3c1bc1ed6a0e83a8$var$tabCSS}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
`;
const $3c1bc1ed6a0e83a8$export$3e41faf802a29e71 = (0, $hYbro.styled).button`
    ${$3c1bc1ed6a0e83a8$var$tabCSS}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", "transparent")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.25rem")}

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    }

    &[data-active="true"] {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("B300")}`)}
    }
`;
const $3c1bc1ed6a0e83a8$export$85fd4ed3b8ca1010 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex", "1 1 auto")}
`;
const $3c1bc1ed6a0e83a8$export$741ee5bff4f2bc22 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("bottom", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "2px")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "left 0.3s ease, width 0.3s ease")}
`;

});




parcelRegister("caLfy", function(module, exports) {

$parcel$export(module.exports, "SmallNav", function () { return (parcelRequire("f2jCl")).default; });

var $f2jCl = parcelRequire("f2jCl");

var $53YIT = parcelRequire("53YIT");

});
parcelRegister("f2jCl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $844fbb3ff1856f51$export$2e2bcd8739ae039; });
/* eslint-disable complexity, react-hooks/exhaustive-deps */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hGV8X = parcelRequire("hGV8X");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $1fo9X = parcelRequire("1fo9X");
var $fBLkH = parcelRequire("fBLkH");
var $6vqJG = parcelRequire("6vqJG");
var $82f25 = parcelRequire("82f25");

var $7kKxD = parcelRequire("7kKxD");

var $1LBks = parcelRequire("1LBks");

var $cSWGN = parcelRequire("cSWGN");
parcelRequire("2krCx");
var $53IXH = parcelRequire("53IXH");
var $kffFQ = parcelRequire("kffFQ");
var $f5zGO = parcelRequire("f5zGO");

var $53YIT = parcelRequire("53YIT");

var $7tXee = parcelRequire("7tXee");
const $844fbb3ff1856f51$var$SmallNav = ({ hasScrolled: hasScrolled, isLoggedIn: isLoggedIn, signUpUrl: signUpUrl, loginUrl: loginUrl, model: { id: id, content: { goBackText: goBackText, goToBoardsText: goToBoardsText, logInText: logInText, navigationLabel: navigationLabel, progressBar: progressBar, progressLabel: progressLabel, signUpText: signUpText, startTransparent: startTransparent, tabs: tabs, useEyebrowLogo: useEyebrowLogo } } })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const [activeTab, setActiveTab] = (0, $iSvIT.useState)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = {
        eventContainer: "mobileNav"
    };
    const headerRef = (0, $iSvIT.useRef)(null);
    function close() {
        setIsOpen(false);
        setTimeout(()=>setActiveTab(undefined), 300);
    }
    function escPress(event) {
        if (event.key === "Escape") close();
    }
    function open() {
        sendTrackEvent("clickedMobileNavMenu", {
            ...analyticsAttributes,
            event: "clicked",
            eventComponent: "mobileNavMenu",
            label: "menu open",
            labelEnglish: "menu open",
            uuid: `${id}_mobileMenu`
        });
        setIsOpen(true);
    }
    (0, $iSvIT.useEffect)(()=>{
        if (isOpen) {
            window.addEventListener("keydown", escPress);
            document.body.classList.add("prevent-scroll");
        }
        return ()=>{
            window.removeEventListener("keydown", escPress);
            document.body.classList.remove("prevent-scroll");
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: analyticsAttributes,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hGV8X))), {
            active: isOpen,
            focusTrapOptions: {
                fallbackFocus: "#skip-to-content"
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.Header), {
                "data-scrolled": String(!isOpen && hasScrolled),
                "data-open": String(isOpen),
                "data-testid": "smallnav",
                startTransparent: startTransparent,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.NavBar), {
                        ref: headerRef,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.LogoWrapper), {
                                "data-hidden": activeTab !== undefined,
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $53IXH.default), {
                                    id: `${id}_mobile`,
                                    eyebrow: useEyebrowLogo
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.BackButton), {
                                "data-hidden": activeTab === undefined || !isOpen,
                                onClick: ()=>{
                                    sendTrackEvent("clickedMobileNavBackButton", {
                                        event: "clicked",
                                        eventComponent: "mobileNavBackButton",
                                        eventContainer: "mobileNav",
                                        label: goBackText,
                                        labelEnglish: "Back",
                                        uuid: `${id}_back`
                                    });
                                    setActiveTab(undefined);
                                },
                                tabIndex: activeTab === undefined || !isOpen ? -1 : undefined,
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1fo9X.ChevronLeft), {}),
                                    goBackText
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.MenuButton), {
                                "aria-expanded": isOpen,
                                "aria-label": navigationLabel,
                                onClick: ()=>isOpen ? close() : open(),
                                "data-testid": "menubutton",
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $53YIT.default), {
                                        isOpen: isOpen
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                        hidden: true,
                                        children: navigationLabel
                                    })
                                ]
                            }),
                            progressBar && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kffFQ.default), {
                                progressLabel: progressLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.PageContainer), {
                        open: isOpen,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.Page), {
                                "aria-hidden": !isOpen || activeTab !== undefined,
                                "data-offscreen": activeTab !== undefined ? "left" : undefined,
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.TabList), {
                                        children: tabs?.map((tab, index)=>tab.type === "uiHeaderNavTab" ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.Tab), {
                                                onClick: ()=>{
                                                    sendTrackEvent("clickedMobileNavTab", {
                                                        event: "clicked",
                                                        eventComponent: "mobileNavTab",
                                                        eventContainer: "mobileNav",
                                                        label: tab.content.title,
                                                        labelEnglish: tab.content.entryTitle,
                                                        uuid: tab.id
                                                    });
                                                    setActiveTab(index);
                                                },
                                                tabIndex: !isOpen || activeTab !== undefined ? -1 : undefined,
                                                children: [
                                                    tab.content.title,
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fBLkH.ChevronRight), {})
                                                ]
                                            }, index) : tab.type === "uiLink" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.Link), {
                                                href: tab.content.url,
                                                onClick: ()=>sendTrackEvent("clickedMobileNavLink", {
                                                        event: "clicked",
                                                        eventComponent: "mobileNavLink",
                                                        eventContainer: "mobileNav",
                                                        href: tab.content.url,
                                                        label: tab.content.text,
                                                        labelEnglish: tab.content.entryTitle,
                                                        uuid: tab.id
                                                    }),
                                                tabIndex: !isOpen || activeTab !== undefined ? -1 : undefined,
                                                children: tab.content.text
                                            }, index) : null)
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.Buttons), {
                                        children: [
                                            isLoggedIn === true && goToBoardsText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.ButtonDark), {
                                                href: "/",
                                                onClick: ()=>sendTrackEvent("clickedMobileNavButton", {
                                                        event: "clicked",
                                                        eventComponent: "mobileNavButton",
                                                        eventContainer: "mobileNav",
                                                        href: "/",
                                                        label: goToBoardsText,
                                                        labelEnglish: "Go to your boards",
                                                        uuid: `${id}_goToBoards`
                                                    }),
                                                tabIndex: !isOpen || activeTab !== undefined ? -1 : undefined,
                                                children: goToBoardsText
                                            }),
                                            (isLoggedIn === false || isLoggedIn === undefined) && logInText && signUpText && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.ButtonPrimary), {
                                                        href: signUpUrl,
                                                        onClick: ()=>sendTrackEvent("clickedMobileNavButton", {
                                                                event: "clicked",
                                                                eventComponent: "mobileNavButton",
                                                                eventContainer: "mobileNav",
                                                                href: signUpUrl,
                                                                label: signUpText,
                                                                labelEnglish: "Get Trello for free",
                                                                uuid: `${id}_signup`
                                                            }),
                                                        tabIndex: !isOpen || activeTab !== undefined ? -1 : undefined,
                                                        children: signUpText
                                                    }),
                                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.Button), {
                                                        href: loginUrl,
                                                        onClick: ()=>sendTrackEvent("clickedMobileNavButton", {
                                                                event: "clicked",
                                                                eventComponent: "mobileNavButton",
                                                                eventContainer: "mobileNav",
                                                                href: "/login",
                                                                label: logInText,
                                                                labelEnglish: "Log in",
                                                                uuid: `${id}_logIn`
                                                            }),
                                                        tabIndex: !isOpen || activeTab !== undefined ? -1 : undefined,
                                                        children: logInText
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    " ",
                                    " "
                                ]
                            }),
                            tabs?.map((tab, index)=>tab.type === "uiHeaderNavTab" ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.Page), {
                                    "aria-hidden": !isOpen || activeTab !== index,
                                    "data-offscreen": activeTab !== index ? "right" : undefined,
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                        value: {
                                            ...analyticsAttributes,
                                            parentLabel: tab.content.title,
                                            labelEnglish: tab.content.entryTitle
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7tXee.TabList), {
                                                children: [
                                                    tab.content.primaryTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                        children: tab.content.primaryTitle
                                                    }),
                                                    tab.content.primaryLinks && tab.content.primaryLinks.filter(({ type: type })=>type === "uiNavLink").map((link, linkIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.NavLinkContainer), {
                                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cSWGN.default), {
                                                                model: link,
                                                                tabIndex: activeTab !== index ? -1 : undefined
                                                            })
                                                        }, linkIndex)),
                                                    tab.content.primaryCta?.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $f5zGO.default), {
                                                        url: tab.content.primaryCta.content.url,
                                                        text: tab.content.primaryCta.content.text,
                                                        ariaLabel: tab.content.primaryCta.content.ariaLabel,
                                                        onClick: ()=>sendTrackEvent("clickedMobileNavPrimaryLink", {
                                                                ...analyticsAttributes,
                                                                event: "clicked",
                                                                eventComponent: "mobileNavPrimaryLink",
                                                                href: tab.content.primaryCta?.content.url,
                                                                label: tab.content.primaryCta?.content.text,
                                                                labelEnglish: tab.content.primaryCta?.content.entryTitle,
                                                                parentLabel: tab.content.title,
                                                                uuid: tab.content.primaryCta?.id
                                                            }),
                                                        tabIndex: activeTab !== index ? -1 : undefined
                                                    })
                                                ]
                                            }),
                                            tab.content.primaryBanner && tab.content.primaryBanner.type === "uiNavBanner" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                                value: {
                                                    eventComponent: "globalNavPrimaryButton"
                                                },
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7kKxD.default), {
                                                    model: tab.content.primaryBanner,
                                                    tabIndex: activeTab !== index ? -1 : undefined
                                                })
                                            }),
                                            (tab.content.secondaryTitle || tab.content.secondaryBlogArticle?.content) && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.Secondary), {
                                                children: tab.content.secondaryBlogArticle?.content ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1LBks.default), {
                                                    model: tab.content.secondaryBlogArticle,
                                                    tabIndex: activeTab !== index ? -1 : undefined,
                                                    isShowing: activeTab === index
                                                }) : /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                                            children: tab.content.secondaryTitle
                                                        }),
                                                        tab.content.secondaryDescription && /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                                                            children: tab.content.secondaryDescription
                                                        }),
                                                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.SecondaryCtaContainer), {
                                                            children: tab.content.secondaryCta?.content && /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                                                                url: tab.content.secondaryCta.content.url,
                                                                "aria-label": tab.content.secondaryCta.content.ariaLabel,
                                                                onClick: ()=>sendTrackEvent("clickedMobileNavSecondaryLink", {
                                                                        ...analyticsAttributes,
                                                                        event: "clicked",
                                                                        eventComponent: "mobileNavSecondaryLink",
                                                                        href: tab.content.secondaryCta?.content.url,
                                                                        label: tab.content.secondaryCta?.content.text,
                                                                        labelEnglish: tab.content.secondaryCta?.content.entryTitle,
                                                                        parentLabel: tab.content.title,
                                                                        uuid: tab.content.secondaryCta?.id
                                                                    }),
                                                                tabIndex: activeTab !== index ? -1 : undefined,
                                                                appearance: "Purple",
                                                                style: "Outline",
                                                                children: tab.content.secondaryCta.content.text
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                                value: {
                                                    eventComponent: "globalNavSecondaryButton"
                                                },
                                                children: tab.content.secondaryBanners?.filter(({ type: type })=>type === "uiNavBanner").map((banner, bannerIndex)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7tXee.Secondary), {
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7kKxD.default), {
                                                            model: banner,
                                                            tabIndex: activeTab !== index ? -1 : undefined
                                                        })
                                                    }, bannerIndex))
                                            })
                                        ]
                                    })
                                }, index) : null)
                        ]
                    })
                ]
            })
        })
    });
};
var $844fbb3ff1856f51$export$2e2bcd8739ae039 = $844fbb3ff1856f51$var$SmallNav;

});
parcelRegister("7kKxD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6e205344b702d8f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");
var $82f25 = parcelRequire("82f25");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("bNHtH");
var $hqPCQ = parcelRequire("hqPCQ");

var $eQ5uL = parcelRequire("eQ5uL");
const $d6e205344b702d8f$var$UiNavBanner = ({ model: { type: type, content: { titleHeading: titleHeading, description: description, button: button, theme: theme, uiIcon: uiIcon } }, tabIndex: tabIndex })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const themeInitial = (0, $hqPCQ.getColorInitial)(theme);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eQ5uL.Banner), {
        themeInitial: themeInitial,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eQ5uL.BannerTitleContainer), {
                        themeInitial: themeInitial,
                        children: [
                            uiIcon && /*#__PURE__*/ (0, $loA2J.jsx)((0, $eQ5uL.BannerIcon), {
                                themeInitial: themeInitial,
                                children: (0, $33PqJ.renderViewModel)(uiIcon)
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eQ5uL.BannerTitle), {
                                children: themeInitial ? /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                    children: titleHeading
                                }) : /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: titleHeading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $eQ5uL.BannerDescription), {
                        themeInitial: themeInitial,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                            children: description
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                children: button && /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                    url: button.content.url,
                    "aria-label": button.content.ariaLabel,
                    onClick: ()=>sendTrackEvent("clickedUiNavBannerButton", {
                            eventContainer: type,
                            eventComponent: "button",
                            ...analyticsAttributes,
                            event: "clicked",
                            parentLabel: titleHeading,
                            label: button.content.text,
                            labelEnglish: button.content.entryTitle,
                            uuid: button.id,
                            href: button.content.url
                        }),
                    "data-uuid": button.id,
                    testId: "ui-nav-banner-button",
                    appearance: button.content.buttonTheme?.content.appearance,
                    style: button.content.buttonTheme?.content.style,
                    tabIndex: tabIndex,
                    children: button.content.text
                })
            })
        ]
    });
};
var $d6e205344b702d8f$export$2e2bcd8739ae039 = $d6e205344b702d8f$var$UiNavBanner;

});
parcelRegister("eQ5uL", function(module, exports) {

$parcel$export(module.exports, "Banner", function () { return $4052acc37f4e18f6$export$3b4e64e77073e307; });
$parcel$export(module.exports, "BannerIcon", function () { return $4052acc37f4e18f6$export$9217ca52f16e0cac; });
$parcel$export(module.exports, "BannerTitleContainer", function () { return $4052acc37f4e18f6$export$9ae83523eb0eea32; });
$parcel$export(module.exports, "BannerTitle", function () { return $4052acc37f4e18f6$export$7878ee56deea4ecf; });
$parcel$export(module.exports, "BannerDescription", function () { return $4052acc37f4e18f6$export$7b9afe39810cbf9f; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $bC5c7 = parcelRequire("bC5c7");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $4052acc37f4e18f6$export$3b4e64e77073e307 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${({ themeInitial: themeInitial })=>themeInitial ? `padding: 1.5rem; ` : `padding: 1rem;
    @media (max-width: 992px) {
      padding: 0;
      margin-bottom: 1.5rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  `}
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    width: 100%;
    ${({ themeInitial: themeInitial })=>themeInitial && `background-color: ${(0, $i2LPb.colorCSS)(`${themeInitial}50`, 0.4)};`}
`;
const $4052acc37f4e18f6$export$9217ca52f16e0cac = (0, $hYbro.styled).div`
    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1.2rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "0.4rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-right", "0.8rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}

        path {
            fill: ${({ themeInitial: themeInitial })=>(0, $i2LPb.colorCSS)(themeInitial ? `${themeInitial}200` : "N100")};
        }
    }
`;
const $4052acc37f4e18f6$export$9ae83523eb0eea32 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${({ themeInitial: themeInitial })=>themeInitial && `line-height: 1rem; padding-bottom: 0.25rem;`}
`;
const $4052acc37f4e18f6$export$7878ee56deea4ecf = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "normal")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.text}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-right", "0.3rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem !important")}
    }
`;
const $4052acc37f4e18f6$export$7b9afe39810cbf9f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
    ${({ themeInitial: themeInitial })=>themeInitial && `line-height: 1rem; margin-bottom: 1rem;`}

    p {
        margin-bottom: 0.5rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    ul {
        margin-top: 0.25rem;
        margin-bottom: 0.5rem;
        padding-left: 1.5rem;
    }

    li {
        margin-bottom: 0.25rem;
    }
`;

});


parcelRegister("cSWGN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $69933a114f6cea7a$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7YcSr = parcelRequire("7YcSr");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $dtAdv = parcelRequire("dtAdv");
var $6vqJG = parcelRequire("6vqJG");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("bNHtH");
var $hqPCQ = parcelRequire("hqPCQ");

var $fOFXR = parcelRequire("fOFXR");
const $69933a114f6cea7a$var$UiNavLink = ({ model: { id: id, content: { entryTitle: entryTitle, titleHeading: titleHeading, description: description, url: url, iconColor: iconColor, addBackgroundColorOnHover: addBackgroundColorOnHover, decorator: decorator, uiIcon: uiIcon } }, tabIndex: tabIndex })=>{
    const location = (0, $7YcSr.useLocation)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const [decoratorOnHover, setDecoratorOnHover] = (0, $iSvIT.useState)(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fOFXR.NavLinkAnchor), {
        "aria-current": location?.pathname === url ? "page" : undefined,
        href: url,
        onClick: ()=>sendTrackEvent("clickedUiNavLink", {
                eventContainer: "navigation",
                ...analyticsAttributes,
                event: "clicked",
                eventComponent: "link",
                label: titleHeading,
                labelEnglish: entryTitle,
                uuid: id,
                href: url
            }),
        "data-uuid": id,
        hoverColorInitial: addBackgroundColorOnHover || iconColor ? (0, $hqPCQ.getColorInitial)(iconColor, true) : undefined,
        "data-testid": "ui-nav-link",
        onMouseEnter: ()=>setDecoratorOnHover(true),
        onMouseLeave: ()=>setDecoratorOnHover(false),
        tabIndex: tabIndex,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fOFXR.NavLinkTitleContainer), {
                children: [
                    uiIcon && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOFXR.NavIcon), {
                        iconColorInitial: iconColor?.charAt(0),
                        children: (0, $33PqJ.renderViewModel)(uiIcon)
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOFXR.NavLinkTitle), {
                        children: titleHeading
                    }),
                    decorator && decoratorOnHover && /*#__PURE__*/ (0, $loA2J.jsx)((0, $dtAdv.ArrowRight), {
                        color: "P300"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fOFXR.NavLinkDescription), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                    links: false,
                    children: description
                })
            })
        ]
    });
};
var $69933a114f6cea7a$export$2e2bcd8739ae039 = $69933a114f6cea7a$var$UiNavLink;

});
parcelRegister("fOFXR", function(module, exports) {

$parcel$export(module.exports, "NavLinkAnchor", function () { return $222c32aee602445b$export$3a8596ab6e120c0a; });
$parcel$export(module.exports, "NavIcon", function () { return $222c32aee602445b$export$62e09d66fce7f525; });
$parcel$export(module.exports, "NavLinkTitleContainer", function () { return $222c32aee602445b$export$221c9b882cb22247; });
$parcel$export(module.exports, "NavLinkTitle", function () { return $222c32aee602445b$export$fd957ae330a087bd; });
$parcel$export(module.exports, "NavLinkDescription", function () { return $222c32aee602445b$export$9e4d4f1b2cf2830a; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $bC5c7 = parcelRequire("bC5c7");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $222c32aee602445b$export$3a8596ab6e120c0a = (0, $hYbro.styled).a({
    display: "block",
    padding: "1rem",
    textAlign: "left",
    textDecoration: "none"
}, ({ hoverColorInitial: hoverColorInitial })=>hoverColorInitial && `
  &:active {
    background-color: ${(0, $i2LPb.colorCSS)(`${hoverColorInitial}50`, 0.5)};
  }

  &:focus:focus-visible {
    background-color: ${(0, $i2LPb.colorCSS)(`${hoverColorInitial}50`, 0.5)};
  }

  @media (min-width: 992px) {
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)(`${hoverColorInitial}50`, 0.5)};
      transition: background-color 0.3s ease;
    }
  }
  `);
const $222c32aee602445b$export$62e09d66fce7f525 = (0, $hYbro.styled).div({
    svg: {
        "path, rect": {
            fill: ({ iconColorInitial: iconColorInitial })=>iconColorInitial ? (0, $i2LPb.colorCSS)(`${iconColorInitial}100`) : (0, $i2LPb.colorCSS)(`N100`)
        },
        "height": "1.2rem",
        "width": "auto"
    },
    padding: "0.14rem 0.71rem 0 0.15rem"
});
const $222c32aee602445b$export$221c9b882cb22247 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0.6rem")}
`;
const $222c32aee602445b$export$fd957ae330a087bd = (0, $hYbro.styled).p`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.text}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "normal")}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 !important")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-right", "0.3rem")}
`;
const $222c32aee602445b$export$9e4d4f1b2cf2830a = (0, $hYbro.styled).div`
    p {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 !important")}
    }
`;

});


parcelRegister("53YIT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0092261b082084f6$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $6Ktor = parcelRequire("6Ktor");
const $0092261b082084f6$var$MenuIcon = ({ isOpen: isOpen })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $6Ktor.Icon), {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {}),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {})
        ]
    });
};
var $0092261b082084f6$export$2e2bcd8739ae039 = $0092261b082084f6$var$MenuIcon;

});
parcelRegister("6Ktor", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $d46450983ab074be$export$f04a61298a47a40f; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $d46450983ab074be$var$width = 24;
const $d46450983ab074be$var$height = 24;
const $d46450983ab074be$var$lineWidth = 3;
const $d46450983ab074be$export$f04a61298a47a40f = (0, $hYbro.styled).div.withConfig({
    shouldForwardProp: (prop)=>prop !== "isOpen"
})`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", "transparent")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", `${$d46450983ab074be$var$height}px`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", `${$d46450983ab074be$var$width}px`)}

    span {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N800")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${$d46450983ab074be$var$lineWidth}px`)}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", `${$d46450983ab074be$var$lineWidth}px`)}
        ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", "1")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "rotate(0deg)")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "0.3s ease")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", `${$d46450983ab074be$var$width}px`)}
    }

    ${({ isOpen: isOpen })=>isOpen ? `
                  span:nth-of-type(1) {
                      left: 0px;
                      top: ${($d46450983ab074be$var$height - $d46450983ab074be$var$lineWidth) / 2}px;
                      transform: rotate(45deg);
                  }
                  span:nth-of-type(2) {
                      top: ${($d46450983ab074be$var$height - $d46450983ab074be$var$lineWidth) / 2}px;
                      opacity: 0;
                      width: 0%;
                  }
                  span:nth-of-type(3) {
                      left: 0px;
                      top: ${($d46450983ab074be$var$height - $d46450983ab074be$var$lineWidth) / 2}px;
                      transform: rotate(-45deg);
                  }
              ` : `
                  span:nth-of-type(1) {
                      top: ${$d46450983ab074be$var$lineWidth / 2}px;
                      transform-origin: left center;
                  }
                  span:nth-of-type(2) {
                      top: ${($d46450983ab074be$var$height - $d46450983ab074be$var$lineWidth) / 2}px;
                      transform-origin: left center;
                  }
                  span:nth-of-type(3) {
                      top: ${$d46450983ab074be$var$height - $d46450983ab074be$var$lineWidth * 1.5}px;
                      transform-origin: left center;
                  }
              `}
`;

});


parcelRegister("7tXee", function(module, exports) {

$parcel$export(module.exports, "BackButton", function () { return $55f7bbfa9b5a1837$export$e0d897ee21382f67; });
$parcel$export(module.exports, "Button", function () { return $55f7bbfa9b5a1837$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "ButtonDark", function () { return $55f7bbfa9b5a1837$export$2e596590d09733bc; });
$parcel$export(module.exports, "ButtonPrimary", function () { return $55f7bbfa9b5a1837$export$2b47962e4e24eb4d; });
$parcel$export(module.exports, "Buttons", function () { return $55f7bbfa9b5a1837$export$665d5a662b7213f3; });
$parcel$export(module.exports, "Header", function () { return $55f7bbfa9b5a1837$export$8b251419efc915eb; });
$parcel$export(module.exports, "Link", function () { return $55f7bbfa9b5a1837$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "LogoWrapper", function () { return $55f7bbfa9b5a1837$export$f827d3c5a9c3f644; });
$parcel$export(module.exports, "MenuButton", function () { return $55f7bbfa9b5a1837$export$266a769812832828; });
$parcel$export(module.exports, "NavBar", function () { return $55f7bbfa9b5a1837$export$ef8da11641c635de; });
$parcel$export(module.exports, "NavLinkContainer", function () { return $55f7bbfa9b5a1837$export$2f002d790bd97360; });
$parcel$export(module.exports, "Page", function () { return $55f7bbfa9b5a1837$export$6955bcca4cd3539f; });
$parcel$export(module.exports, "PageContainer", function () { return $55f7bbfa9b5a1837$export$5f86df0ee0a255b5; });
$parcel$export(module.exports, "Secondary", function () { return $55f7bbfa9b5a1837$export$fe115c0fdaabaa29; });
$parcel$export(module.exports, "SecondaryCtaContainer", function () { return $55f7bbfa9b5a1837$export$c20936592ffee7a9; });
$parcel$export(module.exports, "Tab", function () { return $55f7bbfa9b5a1837$export$3e41faf802a29e71; });
$parcel$export(module.exports, "TabList", function () { return $55f7bbfa9b5a1837$export$e51a686c67fdaa2d; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $6IIwI = parcelRequire("6IIwI");
var $a7xVp = parcelRequire("a7xVp");
var $1D7YE = parcelRequire("1D7YE");
var $aT9Ik = parcelRequire("aT9Ik");
var $bC5c7 = parcelRequire("bC5c7");
var $kL1mL = parcelRequire("kL1mL");
const $55f7bbfa9b5a1837$var$BackButtonStyled = (0, $hYbro.default).button({
    alignItems: "center",
    background: "transparent",
    border: 0,
    color: (0, $i2LPb.colorCSS)("N800"),
    display: "flex",
    gap: "0.5rem",
    opacity: (props)=>props.hidden === "true" ? 0 : 1,
    padding: "1rem",
    transition: "opacity 0.3s ease",
    transitionDelay: "0.2s"
});
const $55f7bbfa9b5a1837$export$e0d897ee21382f67 = ({ children: children, "data-hidden": hidden, onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$BackButtonStyled, {
        hidden: hidden,
        "data-hidden": hidden,
        onClick: onClick,
        children: children
    });
const $55f7bbfa9b5a1837$var$ButtonStyled = (0, $hYbro.default).a({
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "background-color": (0, $i2LPb.colorCSS)("N0"),
    "border": `1px solid ${(0, $i2LPb.colorCSS)("B300")}`,
    "color": (0, $i2LPb.colorCSS)("N800"),
    "display": "block",
    "padding": "1rem",
    "textAlign": "center",
    "text-align": "center",
    "textDecoration": "none",
    "text-decoration": "none"
});
const $55f7bbfa9b5a1837$export$353f5b6fc5456de1 = ({ children: children, href: href })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$ButtonStyled, {
        href: href,
        children: children
    });
const $55f7bbfa9b5a1837$var$ButtonDarkStyled = (0, $hYbro.default).a({
    backgroundColor: (props)=>props.isActive ? (0, $i2LPb.colorCSS)("N100") : (0, $i2LPb.colorCSS)("N800"),
    border: `1px solid ${(props)=>props.isActive ? (0, $i2LPb.colorCSS)("N100") : (0, $i2LPb.colorCSS)("N800")}`,
    color: (0, $i2LPb.colorCSS)("N0"),
    display: "block",
    padding: "1rem",
    textAlign: "center",
    textDecoration: "none"
});
const $55f7bbfa9b5a1837$export$2e596590d09733bc = ({ children: children, href: href })=>{
    const [isActive, setIsActive] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    return /*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$ButtonDarkStyled, {
        isActive: isActive,
        href: href,
        onMouseDown: ()=>setIsActive(true),
        onMouseUp: ()=>setIsActive(false),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>setIsActive(false),
        children: children
    });
};
const $55f7bbfa9b5a1837$var$ButtonPrimaryStyled = (0, $hYbro.default).a({
    backgroundColor: (props)=>props.isActive ? (0, $i2LPb.colorCSS)("B500") : (0, $i2LPb.colorCSS)("B300"),
    border: `1px solid ${(props)=>props.isActive ? (0, $i2LPb.colorCSS)("B500") : (0, $i2LPb.colorCSS)("B300")}`,
    color: (0, $i2LPb.colorCSS)("N0"),
    display: "block",
    padding: "1rem",
    textAlign: "center",
    textDecoration: "none"
});
const $55f7bbfa9b5a1837$export$2b47962e4e24eb4d = ({ children: children, href: href })=>{
    const [isActive, setIsActive] = (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useState(false);
    return /*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$ButtonPrimaryStyled, {
        isActive: isActive,
        href: href,
        onMouseDown: ()=>setIsActive(true),
        onMouseUp: ()=>setIsActive(false),
        // eslint-disable-next-line @atlassian/a11y/mouse-events-have-key-events
        onMouseLeave: ()=>setIsActive(false),
        children: children
    });
};
const $55f7bbfa9b5a1837$var$ButtonsStyled = (0, $hYbro.default).div({
    "display": "flex",
    "flexDirection": "column",
    "flex-direction": "column",
    "gap": "1rem"
});
const $55f7bbfa9b5a1837$export$665d5a662b7213f3 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$ButtonsStyled, {
        children: children
    });
const $55f7bbfa9b5a1837$var$HeaderStyled = (0, $hYbro.default).header.withConfig({
    shouldForwardProp: (prop)=>![
            "isScrolled",
            "isOpen",
            "startTransparent"
        ].includes(prop)
})((props)=>({
        "backgroundColor": props.startTransparent && !props.isScrolled && !props.isOpen ? (0, $i2LPb.colorCSS)("N0", 0) : (0, $i2LPb.colorCSS)("N0", 1),
        "height": props.isOpen ? "100%" : `${0, $6IIwI.SMALL_NAV_PX_HEIGHT}px`,
        "overflow": "hidden",
        "position": "fixed",
        "top": 0,
        "boxShadow": props.isScrolled || props.isOpen ? (0, $a7xVp.shadow).normal : "none",
        "transition": props.isOpen ? "height 0.3s linear 0.1s, box-shadow 0.1s linear, background-color 0.1s linear" : "height 0.3s linear, box-shadow 0.3s linear 0.3s, background-color 0.3s linear 0.3s",
        "width": "100%",
        "zIndex": (0, $1D7YE.zIndex).headerShroud,
        "@media (min-width: 992px)": {
            display: "none"
        }
    }));
const $55f7bbfa9b5a1837$export$8b251419efc915eb = ({ children: children, startTransparent: startTransparent, "data-scrolled": scrolled, "data-open": open })=>{
    const isScrolled = scrolled === "true";
    const isOpen = open === "true";
    return /*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$HeaderStyled, {
        startTransparent: startTransparent,
        isScrolled: isScrolled,
        isOpen: isOpen,
        "data-scrolled": scrolled,
        "data-open": open,
        children: children
    });
};
const $55f7bbfa9b5a1837$var$LinkStyled = (0, $hYbro.default).a({
    "color": (0, $i2LPb.colorCSS)("N800"),
    "textDecoration": "none",
    "text-decoration": "none"
});
const $55f7bbfa9b5a1837$export$a6c7ac8248d6e38a = ({ children: children, href: href })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$LinkStyled, {
        href: href,
        children: children
    });
const $55f7bbfa9b5a1837$var$LogoWrapperStyled = (0, $hYbro.default).div({
    opacity: (props)=>props.hidden === "true" ? 0 : 1,
    transition: "all 0.3s ease",
    transitionDelay: "0.2s",
    marginLeft: (props)=>props.hidden === "true" ? "-141.69px" : "0"
});
const $55f7bbfa9b5a1837$export$f827d3c5a9c3f644 = ({ children: children, "data-hidden": hidden })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$LogoWrapperStyled, {
        hidden: hidden,
        "data-hidden": hidden,
        children: children
    });
const $55f7bbfa9b5a1837$var$MenuButtonStyled = (0, $hYbro.default).button({
    "alignItems": "center",
    "align-items": "center",
    "backgroundColor": "transparent",
    "background-color": "transparent",
    "display": "flex",
    "border": 0,
    "height": "3.5rem",
    "justifyContent": "center",
    "justify-content": "center",
    "marginLeft": "auto",
    "margin-left": "auto",
    "overflow": "hidden",
    "padding": 0,
    "width": "3.5rem"
});
const $55f7bbfa9b5a1837$export$266a769812832828 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$MenuButtonStyled, {
        onClick: onClick,
        children: children
    });
const $55f7bbfa9b5a1837$var$navBarStyle = {
    alignItems: "center",
    display: "flex",
    height: `${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px`,
    justifyContent: "space-between",
    padding: "0 1rem",
    zIndex: (0, $1D7YE.zIndex).header
};
const $55f7bbfa9b5a1837$export$ef8da11641c635de = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).forwardRef(({ children: children }, ref)=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        ref: ref,
        style: $55f7bbfa9b5a1837$var$navBarStyle,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            @media ${(0, $aT9Ik.minWidth).lg} {
                .navbar { height: ${(0, $6IIwI.BIG_NAV_PX_HEIGHT)}px; }
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "navbar",
                style: {
                    display: "contents"
                },
                children: children
            })
        ]
    }));
$55f7bbfa9b5a1837$export$ef8da11641c635de.displayName = "NavBar";
$55f7bbfa9b5a1837$export$ef8da11641c635de.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).node.isRequired
};
const $55f7bbfa9b5a1837$export$2f002d790bd97360 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            display: "block"
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            .nav-link-container > * {
                padding-left: 0 !important;
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "nav-link-container",
                children: children
            })
        ]
    });
const $55f7bbfa9b5a1837$export$6955bcca4cd3539f = ({ children: children, "data-offscreen": offscreen })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            backgroundColor: (0, $i2LPb.colorCSS)("N0"),
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            gap: "1rem",
            left: offscreen === "left" ? "-100vw" : offscreen === "right" ? "100vw" : 0,
            margin: "0 auto",
            maxWidth: "100%",
            overflow: "auto",
            padding: "1rem",
            position: "absolute",
            top: `${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px`,
            transition: "left 0.4s ease",
            width: "100%"
        },
        "data-offscreen": offscreen,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            .page-container h2 {
                margin-bottom: 0;
                color: ${(0, $i2LPb.colorCSS)("N800")};
                font-family: ${(0, $bC5c7.theme).fontFamily.text};
                font-size: ${(0, $kL1mL.fontSizes).sm};
                font-weight: 500;
            }
            .page-container h3 {
                color: ${(0, $i2LPb.colorCSS)("N800")};
                font-family: ${(0, $bC5c7.theme).fontFamily.text};
                font-size: ${(0, $kL1mL.fontSizes).sm};
                font-weight: 500;
            }
            .page-container p:last-child {
                margin-bottom: 0;
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "page-container",
                children: children
            })
        ]
    });
const $55f7bbfa9b5a1837$export$5f86df0ee0a255b5 = ({ children: children, open: open })=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: {
            opacity: open ? 1 : 0,
            transition: "opacity 0.6s ease",
            transitionDelay: "0.1s"
        },
        children: children
    });
const $55f7bbfa9b5a1837$export$fe115c0fdaabaa29 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            padding: "1.5rem 1rem",
            margin: "0 auto",
            maxWidth: "100%",
            backgroundColor: (0, $i2LPb.colorCSS)("P50", 0.4)
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            .secondary p {
                color: ${(0, $i2LPb.colorCSS)("N400")};
                font-size: ${(0, $kL1mL.fontSizes).xxs};
            }
            .secondary a {
                margin-bottom: 1.5rem;
            }
            .secondary a:last-of-type {
                margin-bottom: 0;
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "secondary",
                children: children
            })
        ]
    });
const $55f7bbfa9b5a1837$export$c20936592ffee7a9 = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            .secondary-cta-container a {
                margin-top: 1rem;
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "secondary-cta-container",
                children: children
            })
        ]
    });
const $55f7bbfa9b5a1837$var$TabStyled = (0, $hYbro.default).button({
    "background": "transparent",
    "border": 0,
    "color": (0, $i2LPb.colorCSS)("N800"),
    "display": "flex",
    "justifyContent": "space-between",
    "justify-content": "space-between",
    "padding": "0 0.5rem 0 0",
    "width": "100%"
});
const $55f7bbfa9b5a1837$export$3e41faf802a29e71 = ({ children: children, onClick: onClick })=>/*#__PURE__*/ (0, $loA2J.jsx)($55f7bbfa9b5a1837$var$TabStyled, {
        onClick: onClick,
        children: children
    });
const $55f7bbfa9b5a1837$export$e51a686c67fdaa2d = ({ children: children })=>/*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            borderTop: `1px solid ${(0, $i2LPb.colorCSS)("N40")}`
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("style", {
                children: `
            .tab-list > * {
                align-items: center;
                border-bottom: 1px solid ${(0, $i2LPb.colorCSS)("N40")};
                display: flex;
                min-height: ${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px;
            }
        `
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: "tab-list",
                children: children
            })
        ]
    });

});



parcelRegister("bMCHM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32000f5e94d2b0c0$export$2e2bcd8739ae039; });
/* UiHeaderNav.styles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
var $fpcku = parcelRequire("fpcku");
const $32000f5e94d2b0c0$var$Skip = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_19hj99m": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N800")),
            "--_r820ks": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N0")),
            "--_1mvqpig": (0, $43MIc.default)((0, $kL1mL.fontSizes).sm),
            "--_sqqeu8": (0, $43MIc.default)((0, $fpcku.radius).button),
            "--_pt5n8i": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N400")),
            "--_1ripcq3": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N100"))
        },
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1l9zhxbz _4z361wmp _1j91t94y _419z15vq _3qat15vq _1eyfstnw _1q7c1q9c _flj9t94y _kutm1o8l _12q41kwk _ns1o1k92 _1fq41kwk _1pku1k92 _3rlaysv5 _1bqf1j40 _50hf1bru _yfa417gb _1xd7kf2v _modm1r31 _8l6nglyw _1velnqa1 _18mhtlke _1vfy1ouz _1tsv11mc _1ycc1p8y _yiygph16 _1flvwlo8 _1khpph16 _1vjy1n9t _1mq41kwk _7ziq1kwk _1jno15gg",
            __cmplp.className
        ])
    });
});
var $32000f5e94d2b0c0$export$2e2bcd8739ae039 = $32000f5e94d2b0c0$var$Skip;

});
parcelRegister("43MIc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f4d3a6519d03dd1$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $2f4d3a6519d03dd1$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return "var(--c-, )";
}

});




parcelRegister("ceRCf", function(module, exports) {

$parcel$export(module.exports, "UiHeading", function () { return (parcelRequire("7uVQQ")).default; });

var $7uVQQ = parcelRequire("7uVQQ");

});
parcelRegister("7uVQQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da78e57c820d8b40$export$2e2bcd8739ae039; });
/* UiHeading.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $da78e57c820d8b40$var$baseHeadingStyle = {
    fontWeight: 500,
    marginBlockEnd: "0.5rem",
    marginBlockStart: 0
};
const $da78e57c820d8b40$var$UiHeading = ({ model: model })=>{
    const { text: text, headingLevel: headingLevel, appearance: appearance } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)($da78e57c820d8b40$var$Heading, {
        as: headingLevel,
        "data-appearance": appearance,
        children: text
    });
};
var $da78e57c820d8b40$export$2e2bcd8739ae039 = $da78e57c820d8b40$var$UiHeading;
const $da78e57c820d8b40$var$Heading = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1gv1bfng _xd6u1kwk _d5zpidpf _3a9gviql _wkzv10nf _besvyn4p _17v1zz36 _17v15znw _11b31wto _14q810nf _14q8j521 _1fsfbfng _i6911kwk _s2dcidpf _188k1k8s _1hej11ph _1467ahaf _113811ph _1138935s _zo1nbfng _13i01kwk _1d42idpf _live1k92 _ywjccjiy _ckye1k8s _ix8r11ph _ix8r935s _c9y4bfng _19281kwk _1gm4idpf _1xcr1j6v _ieya10nf _1chz1k92 _vmg7cjiy _vmg7155v _1233bfng _1233dgin _ouax1kwk _1yccidpf _1elr1j6v _nq8x10nf _nq8xj521 _uw7iangw _1nbk1j6v _n2o6bfng _n2o6dgin _1vsdcjiy _1vsd155v _1dqr1kwk _a1fnidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9IEYk", function(module, exports) {

$parcel$export(module.exports, "UiIcon", function () { return (parcelRequire("6bAq7")).default; });

var $6bAq7 = parcelRequire("6bAq7");

});
parcelRegister("6bAq7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $261cba4bc18d5f5f$export$2e2bcd8739ae039; });
parcelRequire("kT8hs");
var $64oAr = parcelRequire("64oAr");
var $7d5fo = parcelRequire("7d5fo");
parcelRequire("lfo7k");
var $kplTg = parcelRequire("kplTg");
var $jVVva = parcelRequire("jVVva");
var $g1skn = parcelRequire("g1skn");
parcelRequire("bIZDN");
var $776s6 = parcelRequire("776s6");
var $bplEM = parcelRequire("bplEM");
var $9zVah = parcelRequire("9zVah");
var $gwCR8 = parcelRequire("gwCR8");
var $j2riP = parcelRequire("j2riP");
var $hz3J3 = parcelRequire("hz3J3");
var $2bV1y = parcelRequire("2bV1y");
var $1mb5o = parcelRequire("1mb5o");
var $7ot2T = parcelRequire("7ot2T");
var $dmsf1 = parcelRequire("dmsf1");
var $2oRNf = parcelRequire("2oRNf");
var $glWVa = parcelRequire("glWVa");
var $4oGsD = parcelRequire("4oGsD");
parcelRequire("543Rs");
var $7XJmC = parcelRequire("7XJmC");
var $1LFoy = parcelRequire("1LFoy");
var $3e4OR = parcelRequire("3e4OR");
var $cpV4H = parcelRequire("cpV4H");
var $kNq6A = parcelRequire("kNq6A");
var $d4HaZ = parcelRequire("d4HaZ");
var $5lUQJ = parcelRequire("5lUQJ");
var $9XKqn = parcelRequire("9XKqn");
var $bUDSM = parcelRequire("bUDSM");
var $iN1pq = parcelRequire("iN1pq");
var $kvWNQ = parcelRequire("kvWNQ");
var $i3JeI = parcelRequire("i3JeI");
var $gwUdS = parcelRequire("gwUdS");
var $4pkbs = parcelRequire("4pkbs");
var $5XuiX = parcelRequire("5XuiX");
var $1nYEx = parcelRequire("1nYEx");
var $cOz25 = parcelRequire("cOz25");
var $iDiDE = parcelRequire("iDiDE");
var $dQEKa = parcelRequire("dQEKa");
var $9s2Jn = parcelRequire("9s2Jn");
var $klCBm = parcelRequire("klCBm");
var $eHTL4 = parcelRequire("eHTL4");
var $dyfX3 = parcelRequire("dyfX3");
parcelRequire("fvFan");
var $9Ddah = parcelRequire("9Ddah");
var $bXJC4 = parcelRequire("bXJC4");
var $4Qrq2 = parcelRequire("4Qrq2");
var $9rvwz = parcelRequire("9rvwz");
var $2ZEOJ = parcelRequire("2ZEOJ");
var $5jlAD = parcelRequire("5jlAD");
var $1XvHC = parcelRequire("1XvHC");
var $f2LmH = parcelRequire("f2LmH");
var $fvKpA = parcelRequire("fvKpA");
var $3cPV3 = parcelRequire("3cPV3");
parcelRequire("8O9uA");
var $7yLBx = parcelRequire("7yLBx");
var $g7ayi = parcelRequire("g7ayi");
var $ajBeJ = parcelRequire("ajBeJ");
var $2WzfD = parcelRequire("2WzfD");
var $8PI5q = parcelRequire("8PI5q");
var $b8WVW = parcelRequire("b8WVW");
var $fIdSO = parcelRequire("fIdSO");
var $0cwmv = parcelRequire("0cwmv");
var $4J4wN = parcelRequire("4J4wN");
var $ak4q3 = parcelRequire("ak4q3");
// Icon map to reduce cyclomatic complexity
const $261cba4bc18d5f5f$var$iconMap = {
    AddOn: $7yLBx.AddOn,
    Automation: $g7ayi.Automation,
    Badge: $7XJmC.Badge,
    BoardDuplicate: $ajBeJ.BoardDuplicate,
    Bolt: $1LFoy.Bolt,
    Book: $3e4OR.Book,
    Bookmark: $cpV4H.Bookmark,
    Box: $kNq6A.Box,
    Briefcase: $d4HaZ.Briefcase,
    BrowserCode: $9Ddah.BrowserCode,
    Building: $5lUQJ.Building,
    ButlerAutomation: $bXJC4.ButlerAutomation,
    ButlerAutomationHead: $2WzfD.ButlerAutomationHead,
    Calendar: $776s6.Calendar,
    CalendarDate: $bplEM.CalendarDate,
    Checklists: $9zVah.Checklists,
    Checkmark: $gwCR8.Checkmark,
    Clock: $9XKqn.Clock,
    Cloud: $4Qrq2.Cloud,
    DiagramNetwork: $j2riP.DiagramNetwork,
    DiagramVenn: $hz3J3.DiagramVenn,
    DollarSignCircle: $kplTg.DollarSignCircle,
    Email: $2bV1y.Email,
    Filter: $1mb5o.Filter,
    Flag: $bUDSM.Flag,
    GitMerge: $9rvwz.GitMerge,
    GlobeNetwork: $2ZEOJ.GlobeNetwork,
    GlobeNetworkLocation: $5jlAD.GlobeNetworkLocation,
    Group: $64oAr.Group,
    Headset: $iN1pq.Headset,
    InfoCircle: $jVVva.InfoCircle,
    Leaf: $kvWNQ.Leaf,
    Lego: $i3JeI.Lego,
    Lightbulb: $gwUdS.Lightbulb,
    MagicWand: $4pkbs.MagicWand,
    MagnifyingGlass: $5XuiX.MagnifyingGlass,
    Map: $7ot2T.Map,
    Megaphone: $1nYEx.Megaphone,
    New: $g1skn.New,
    News: $dmsf1.News,
    PageMultiple: $2oRNf.PageMultiple,
    PartyPopper: $cOz25.PartyPopper,
    Pencil: $iDiDE.Pencil,
    PencilWriting: $dQEKa.PencilWriting,
    Process: $glWVa.Process,
    RocketInclined: $8PI5q.RocketInclined,
    SecurityCheckmark: $9s2Jn.SecurityCheckmark,
    SmileyFace: $4oGsD.SmileyFace,
    Socket: $b8WVW.Socket,
    Star: $klCBm.Star,
    TrafficCone: $eHTL4.TrafficCone,
    Tray: $fIdSO.Tray,
    TrelloCalendar: $0cwmv.TrelloCalendar,
    TrelloCard: $1XvHC.TrelloCard,
    TrelloCardTemplates: $f2LmH.TrelloCardTemplates,
    TrelloLabels: $fvKpA.TrelloLabels,
    TrelloWorkspaces: $3cPV3.TrelloWorkspaces,
    Trophy: $dyfX3.Trophy,
    UserSettings: $7d5fo.UserSettings,
    ViewCalendar: $4J4wN.ViewCalendar,
    ViewTimeline: $ak4q3.ViewTimeline
};
const $261cba4bc18d5f5f$var$UiIcon = ({ model: model })=>{
    const IconComponent = $261cba4bc18d5f5f$var$iconMap[model.content.icon];
    return IconComponent ? IconComponent() : null;
};
var $261cba4bc18d5f5f$export$2e2bcd8739ae039 = $261cba4bc18d5f5f$var$UiIcon;

});
parcelRegister("kT8hs", function(module, exports) {
$parcel$export(module.exports, "Group", function () { return (parcelRequire("64oAr")).Group; });
$parcel$export(module.exports, "UserSettings", function () { return (parcelRequire("7d5fo")).UserSettings; });
parcelRequire("64oAr");
parcelRequire("7d5fo");

});
parcelRegister("64oAr", function(module, exports) {

$parcel$export(module.exports, "Group", function () { return $5939be01b890b8dd$export$eb2fcfdbd7ba97d4; });

var $loA2J = parcelRequire("loA2J");
const $5939be01b890b8dd$export$eb2fcfdbd7ba97d4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 98 61",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.219 60.477h-33.568c-1.464 0-2.65-1.186-2.65-2.65v-10.085c0-8.416 6.822-15.238 15.238-15.238h8.392c8.416 0 15.238 6.822 15.238 15.238v10.085c0 1.464-1.186 2.65-2.65 2.65zM8.245 17.854c0-6.18 5.01-11.189 11.189-11.189s11.19 5.01 11.19 11.189c0 6.18-5.01 11.19-11.189 11.19s-11.189-5.01-11.189-11.189zM95.111 60.477h-33.568c-1.464 0-2.65-1.186-2.65-2.65v-10.085c0-8.416 6.822-15.238 15.238-15.238h8.392c8.416 0 15.238 6.822 15.238 15.238v10.085c0 1.464-1.186 2.65-2.65 2.65zM67.137 17.854c0-6.18 5.01-11.189 11.19-11.189 6.18 0 11.189 5.01 11.189 11.189 0 6.18-5.01 11.19-11.189 11.19-6.18 0-11.189-5.01-11.189-11.189zM36.955 5.777c0-2.927 2.373-5.3 5.3-5.3 2.927 0 5.3 2.373 5.3 5.3 0 .333-.031.658-.089.974.463-.059.935-.09 1.414-.09 6.098 0 11.042 4.944 11.042 11.042 0 6.099-4.944 11.042-11.042 11.042-6.098 0-11.042-4.944-11.042-11.042 0-2.651.934-5.084 2.491-6.987-1.975-.771-3.374-2.692-3.374-4.94z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M65.665 60.472h-33.568c-1.464 0-2.65-1.186-2.65-2.65v-10.085c0-8.416 6.822-15.238 15.238-15.238h8.392c8.416 0 15.238 6.822 15.238 15.238v10.085c0 1.464-1.186 2.65-2.65 2.65zM37.839 17.851c.078 6.031 4.991 10.897 11.041 10.897s10.964-4.865 11.041-10.897h-2.501c-.557 0-1.081-.262-1.416-.708l-2.531-3.374c-.236-.315-.708-.315-.944 0l-2.531 3.374c-.334.446-.859.708-1.415.708z"
            })
        ]
    });
};

});

parcelRegister("7d5fo", function(module, exports) {

$parcel$export(module.exports, "UserSettings", function () { return $649d32ba67acee21$export$6587c76ebf15601c; });

var $loA2J = parcelRequire("loA2J");
const $649d32ba67acee21$export$6587c76ebf15601c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 64",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m31.6194.246094c-16.9662 0-30.719986 13.753806-30.719986 30.720006 0 10.338 5.106536 19.4833 12.934786 25.051v-2.0107c0-7.7017 6.2435-13.9452 13.9453-13.9452h7.68c2.8554 0 5.5104.8582 7.7211 2.3308.0583-.0738.1215-.1449.1896-.2131.9201-.92 2.3955-.9463 3.3473-.0788l.0826.0788.7104.7105c.7278-.4194 1.5176-.7432 2.3523-.9543v-1.0248c0-1.3394 1.0858-2.4252 2.4252-2.4252 1.3012 0 2.3631 1.0247 2.4227 2.3111l.0026.1141v1.098c.7994.2283 1.5549.5607 2.2508.9817l.8117-.8117c.7171-.7171 1.7716-.8913 2.6526-.5224 1.2358-3.3291 1.911-6.9306 1.911-10.6898 0-16.9662-13.7538-30.720006-30.72-30.720006zm-.0002 16.033706c-5.6554 0-10.24 4.5846-10.24 10.24s4.5846 10.24 10.24 10.24 10.24-4.5846 10.24-10.24-4.5846-10.24-10.24-10.24z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "m54.7108 40.7955c-.0596-1.2865-1.1215-2.3111-2.4226-2.3111-1.3395 0-2.4253 1.0858-2.4253 2.4252v1.0248c-.8347.2111-1.6245.5349-2.3523.9543l-.7104-.7105-.0826-.0788c-.9518-.8675-2.4272-.8412-3.3472.0788-.9472.9472-.9472 2.4827 0 3.4299l.7103.7103c-.4195.728-.7434 1.518-.9545 2.3529h-1.0242l-.1141.0026c-1.2865.0596-2.3111 1.1215-2.3111 2.4226 0 1.3395 1.0858 2.4253 2.4252 2.4253h1.0975c.2283.7993.5607 1.5547.9817 2.2505l-.8106.8106-.0789.0826c-.8675.9518-.8412 2.4272.0789 3.3473.9471.9471 2.4827.9471 3.4298 0l.8834-.8834c.6794.3723 1.4102.6624 2.1791.8569v1.2955l.0027.1142c.0596 1.2864 1.1214 2.3111 2.4226 2.3111 1.3394 0 2.4252-1.0858 2.4252-2.4253v-1.3687c.7348-.2098 1.4324-.5076 2.0807-.8813l.9816.9816.0826.0789c.9518.8674 2.4272.8412 3.3472-.0789.9472-.9471.9472-2.4827 0-3.4298l-.9816-.9817c.3735-.6482.6712-1.3456.881-2.0801h1.3693l.1142-.0026c1.2864-.0597 2.3111-1.1215 2.3111-2.4227 0-1.3394-1.0858-2.4252-2.4253-2.4252h-1.296c-.1944-.769-.4845-1.5-.857-2.1793l.8846-.8846.0788-.0826c.8675-.9517.8412-2.4271-.0788-3.3472-.9472-.9471-2.4828-.9471-3.4299 0l-.8117.8117c-.6959-.421-1.4513-.7534-2.2508-.9817v-1.098zm-2.5586 5.5789c-2.5335 0-4.5874 2.0538-4.5874 4.5874 0 2.5335 2.0539 4.5873 4.5874 4.5873s4.5874-2.0538 4.5874-4.5873c0-2.5336-2.0539-4.5874-4.5874-4.5874z",
                    opacity: ".5"
                })
            ]
        })
    });
};

});


parcelRegister("lfo7k", function(module, exports) {
$parcel$export(module.exports, "DollarSignCircle", function () { return (parcelRequire("kplTg")).DollarSignCircle; });
$parcel$export(module.exports, "InfoCircle", function () { return (parcelRequire("jVVva")).InfoCircle; });
$parcel$export(module.exports, "New", function () { return (parcelRequire("g1skn")).New; });
parcelRequire("kplTg");
parcelRequire("jVVva");
parcelRequire("g1skn");

});
parcelRegister("kplTg", function(module, exports) {

$parcel$export(module.exports, "DollarSignCircle", function () { return $2475f0e47d6f6243$export$7db165b2b706b17a; });

var $loA2J = parcelRequire("loA2J");
const $2475f0e47d6f6243$export$7db165b2b706b17a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 64",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            d: "M0 32C0 14.327 14.327 0 32 0s32 14.327 32 32-14.327 32-32 32S0 49.673 0 32zm34.356-18.268c4.362 1.11 7.603 5.026 7.688 9.713l.002.188v1.63a2.526 2.526 0 0 1-5.05.12l-.003-.12v-1.63a5.163 5.163 0 0 0-10.324-.15l-.002.15v.621a5.163 5.163 0 0 0 5.013 5.161l.15.002c5.58 0 10.114 4.473 10.214 10.028l.002.188v.621c0 4.77-3.27 8.777-7.69 9.901v2.504a2.526 2.526 0 0 1-5.05.119l-.002-.12v-2.503c-4.362-1.11-7.604-5.026-7.688-9.713l-.002-.188v-1.63a2.526 2.526 0 0 1 5.05-.12l.003.12v1.63a5.163 5.163 0 0 0 10.324.15l.002-.15v-.621a5.163 5.163 0 0 0-5.014-5.161l-.15-.002c-5.578 0-10.113-4.473-10.213-10.028l-.002-.188v-.621c0-4.77 3.27-8.777 7.69-9.901v-2.505a2.526 2.526 0 0 1 5.05-.119l.002.12z"
        })
    });
};

});

parcelRegister("jVVva", function(module, exports) {

$parcel$export(module.exports, "InfoCircle", function () { return $cbff165222028279$export$6e50c69d980cc044; });

var $loA2J = parcelRequire("loA2J");
const $cbff165222028279$export$6e50c69d980cc044 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 64",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            d: "M32 0C14.327 0 0 14.327 0 32s14.327 32 32 32 32-14.327 32-32S49.673 0 32 0zm.28 17.964a4.772 4.772 0 1 0 0-9.544 4.772 4.772 0 0 0 0 9.544zm5.615 27.79a2.526 2.526 0 0 1 .119 5.05l-.12.002H26.7a2.526 2.526 0 0 1-.119-5.05l.12-.003h3.087V26.666h-3.121a2.526 2.526 0 0 1-2.524-2.408l-.003-.118a2.526 2.526 0 0 1 2.408-2.524l.119-.003h5.647a2.526 2.526 0 0 1 2.524 2.408l.002.119v21.613z"
        })
    });
};

});

parcelRegister("g1skn", function(module, exports) {

$parcel$export(module.exports, "New", function () { return $feb87c7e3bbfeb6f$export$6fbbeb565555321b; });

var $loA2J = parcelRequire("loA2J");
const $feb87c7e3bbfeb6f$export$6fbbeb565555321b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 64",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.811 38.092c-.418-1.086-1.956-1.086-2.374 0l-1.605 4.168-4.168 1.606c-1.087.418-1.087 1.956 0 2.374l4.168 1.605 1.605 4.169c.418 1.086 1.956 1.086 2.374 0l1.606-4.169 4.168-1.605c1.087-.418 1.087-1.956 0-2.374l-4.168-1.606-1.606-4.168Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M32 0c17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32C14.327 64 0 49.673 0 32 0 14.327 14.327 0 32 0Zm14.633 24.45c-.419-1.087-1.956-1.087-2.375 0l-1.605 4.168-4.168 1.605c-1.087.419-1.087 1.956 0 2.375l4.168 1.605 1.605 4.168c.419 1.087 1.956 1.087 2.375 0l1.605-4.168 4.168-1.605c1.087-.419 1.087-1.956 0-2.375l-4.168-1.605-1.605-4.168ZM31.812 38.092c-.419-1.087-1.956-1.087-2.375 0l-1.605 4.168-4.168 1.605c-1.087.419-1.087 1.956 0 2.375l4.168 1.605 1.605 4.168c.419 1.087 1.956 1.087 2.375 0l1.605-4.168 4.168-1.605c1.087-.419 1.087-1.956 0-2.375l-4.168-1.605-1.605-4.168Zm-9.097-24.725c.503-1.304 2.348-1.304 2.85 0l1.975 5.128 5.127 1.975c1.305.502 1.305 2.347 0 2.85l-5.127 1.974-1.975 5.128c-.502 1.304-2.347 1.304-2.85 0l-1.974-5.128-5.128-1.975c-1.304-.502-1.304-2.347 0-2.85l5.128-1.974 1.974-5.128Z"
            })
        ]
    });
};

});


parcelRegister("bIZDN", function(module, exports) {
$parcel$export(module.exports, "Calendar", function () { return (parcelRequire("776s6")).Calendar; });
$parcel$export(module.exports, "CalendarDate", function () { return (parcelRequire("bplEM")).CalendarDate; });
$parcel$export(module.exports, "Checklists", function () { return (parcelRequire("9zVah")).Checklists; });
$parcel$export(module.exports, "Checkmark", function () { return (parcelRequire("gwCR8")).Checkmark; });
$parcel$export(module.exports, "DiagramNetwork", function () { return (parcelRequire("j2riP")).DiagramNetwork; });
$parcel$export(module.exports, "DiagramVenn", function () { return (parcelRequire("hz3J3")).DiagramVenn; });
$parcel$export(module.exports, "Email", function () { return (parcelRequire("2bV1y")).Email; });
$parcel$export(module.exports, "Filter", function () { return (parcelRequire("1mb5o")).Filter; });
$parcel$export(module.exports, "Map", function () { return (parcelRequire("7ot2T")).Map; });
$parcel$export(module.exports, "News", function () { return (parcelRequire("dmsf1")).News; });
$parcel$export(module.exports, "PageMultiple", function () { return (parcelRequire("2oRNf")).PageMultiple; });
$parcel$export(module.exports, "Process", function () { return (parcelRequire("glWVa")).Process; });
$parcel$export(module.exports, "SmileyFace", function () { return (parcelRequire("4oGsD")).SmileyFace; });
parcelRequire("776s6");
parcelRequire("bplEM");
parcelRequire("9zVah");
parcelRequire("gwCR8");
parcelRequire("j2riP");
parcelRequire("hz3J3");
parcelRequire("2bV1y");
parcelRequire("1mb5o");
parcelRequire("7ot2T");
parcelRequire("dmsf1");
parcelRequire("2oRNf");
parcelRequire("glWVa");
parcelRequire("4oGsD");

});
parcelRegister("776s6", function(module, exports) {

$parcel$export(module.exports, "Calendar", function () { return $d8fead7bf9ff1aaf$export$e1aef45b828286de; });

var $loA2J = parcelRequire("loA2J");
const $d8fead7bf9ff1aaf$export$e1aef45b828286de = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 33 41",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 14.523h32.653V9.195c0-2.326-1.703-4.21-3.804-4.21H3.804C1.704 4.984 0 6.868 0 9.194z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.205 14.523h8.401v6.68h-8.4zM9.352 24.36v6.315H0V24.36zm0 16.14v-6.667H0v2.457c0 2.325 1.703 4.21 3.804 4.21H28.85c2.1 0 3.804-1.885 3.804-4.21v-2.457H23.46V40.5h-2.853v-6.667h-8.4V40.5zm23.301-16.14v6.315H23.46V24.36zm-12.047 0v6.315h-8.4V24.36zM9.352 21.202v-6.679H0v6.68zm23.301 0v-6.679H23.46v6.68zM23.301 6.991c0 .872-.639 1.579-1.427 1.579-.765 0-1.39-.667-1.425-1.505l-.002-.074V2.079c0-.872.639-1.579 1.427-1.579.765 0 1.39.667 1.425 1.505l.002.074zm-11.096 0c0 .872-.639 1.579-1.427 1.579-.765 0-1.39-.667-1.425-1.505l-.002-.074V2.079C9.351 1.207 9.99.5 10.778.5c.765 0 1.39.667 1.425 1.505l.002.074z"
            })
        ]
    });
};

});

parcelRegister("bplEM", function(module, exports) {

$parcel$export(module.exports, "CalendarDate", function () { return $effe41f031a71771$export$99faa760c7908e4f; });

var $loA2J = parcelRequire("loA2J");
const $effe41f031a71771$export$99faa760c7908e4f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 58 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M57.826 13.473a6.737 6.737 0 0 0-6.737-6.737H6.737A6.737 6.737 0 0 0 0 13.473v.204a6.94 6.94 0 0 1 6.94-6.94h43.946a6.94 6.94 0 0 1 6.94 6.932zm0 8.984H0v35.368a6.737 6.737 0 0 0 6.737 6.737h44.352a6.737 6.737 0 0 0 6.737-6.737zM46.7 35.828a2.526 2.526 0 0 0-3.573 0l-4.109 4.108-4.108-4.108a2.526 2.526 0 0 0-3.662 3.479l.09.094 4.389 4.39-4.39 4.388a2.526 2.526 0 0 0-.09 3.479l.09.094a2.527 2.527 0 0 0 3.479.09l.094-.09 4.108-4.108 4.109 4.108.094.09a2.527 2.527 0 0 0 3.479-.09l.09-.094a2.527 2.527 0 0 0-.09-3.479l-4.39-4.389 4.39-4.39.09-.093a2.527 2.527 0 0 0-.09-3.479z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 22.458h57.826v-8.983a6.737 6.737 0 0 0-6.737-6.737H6.737A6.737 6.737 0 0 0 0 13.475z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.265 10.949a2.526 2.526 0 0 1-5.05.119l-.003-.119v-7.86a2.526 2.526 0 0 1 5.05-.119l.003.119zm-19.651 0a2.526 2.526 0 0 1-5.05.119l-.003-.119v-7.86a2.526 2.526 0 0 1 5.05-.119l.003.119z"
            })
        ]
    });
};

});

parcelRegister("9zVah", function(module, exports) {

$parcel$export(module.exports, "Checklists", function () { return $16c93a5bdbe63bea$export$bd1c95fb49389e9d; });

var $loA2J = parcelRequire("loA2J");
const $16c93a5bdbe63bea$export$bd1c95fb49389e9d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M53.437 16.715a2.796 2.796 0 0 0 .132-5.589l-.132-.003h-22.99a2.796 2.796 0 0 0-.131 5.589l.132.003zm0 13.672a2.796 2.796 0 0 1 .132 5.589l-.132.003h-22.99a2.796 2.796 0 0 1-.131-5.589l.132-.003zm0 18.636a2.796 2.796 0 0 1 .132 5.589l-.132.003h-22.99a2.796 2.796 0 0 1-.131-5.589l.132-.003z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M56.544 64.563A7.456 7.456 0 0 0 64 57.105V8.02A7.456 7.456 0 0 0 56.544.563H7.456A7.456 7.456 0 0 0 0 8.019v49.087a7.456 7.456 0 0 0 7.456 7.456zM18.532 8.52a2.796 2.796 0 0 1 4.044 3.86l-.1.104-6.243 6.213a2.796 2.796 0 0 1-3.84.1l-.105-.1-3.698-3.68a2.796 2.796 0 0 1 3.84-4.062l.105.099 1.725 1.716zm3.954 18.652a2.796 2.796 0 0 0-3.954-.01l-4.272 4.25-1.725-1.716-.105-.099a2.796 2.796 0 0 0-3.84 4.063l3.698 3.68.104.098a2.796 2.796 0 0 0 3.84-.099l6.245-6.213.099-.104a2.796 2.796 0 0 0-.09-3.85zm-3.954 18.63a2.796 2.796 0 0 1 4.044 3.86l-.1.104-6.243 6.214a2.796 2.796 0 0 1-3.84.098l-.105-.099L8.59 52.3a2.796 2.796 0 0 1 3.84-4.062l.105.099 1.725 1.717zm37.7-31.882a2.796 2.796 0 0 1-2.795 2.796h-22.99l-.132-.003a2.796 2.796 0 0 1 .131-5.59h22.99l.132.003a2.796 2.796 0 0 1 2.665 2.794zm-2.795 16.467a2.796 2.796 0 0 1 .131 5.59l-.131.003h-22.99a2.796 2.796 0 0 1-.132-5.59l.132-.003zm2.796 21.432a2.796 2.796 0 0 0-2.796-2.796h-22.99l-.132.003a2.796 2.796 0 0 0 .131 5.59h22.99l.132-.004a2.796 2.796 0 0 0 2.665-2.793z"
            })
        ]
    });
};

});

parcelRegister("gwCR8", function(module, exports) {

$parcel$export(module.exports, "Checkmark", function () { return $78aa704dd0c350ca$export$4f481e0a96cfbed6; });

var $loA2J = parcelRequire("loA2J");
const $78aa704dd0c350ca$export$4f481e0a96cfbed6 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.253 50.27a7.456 7.456 0 0 0 7.456-7.457V8.64h6.835A7.456 7.456 0 0 1 64 16.095v41.01a7.456 7.456 0 0 1-7.456 7.456h-41.01a7.456 7.456 0 0 1-7.456-7.456V50.27z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M7.456.563A7.456 7.456 0 0 0 0 8.018v41.01a7.456 7.456 0 0 0 7.456 7.456h41.01a7.456 7.456 0 0 0 7.456-7.456V8.019A7.456 7.456 0 0 0 48.466.563zm34.436 21.282c1-1.098.97-2.799-.09-3.86l-.096-.09a2.796 2.796 0 0 0-3.859.09l-14.719 14.72-5.053-5.053-.095-.091a2.796 2.796 0 0 0-3.859 4.045l7.03 7.03.095.09c1.098 1 2.799.97 3.86-.09L41.8 21.94z"
            })
        ]
    });
};

});

parcelRegister("j2riP", function(module, exports) {

$parcel$export(module.exports, "DiagramNetwork", function () { return $4e1d9e3592812c99$export$6e1112c8af42012b; });

var $loA2J = parcelRequire("loA2J");
const $4e1d9e3592812c99$export$6e1112c8af42012b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 61 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.96 8.784a2.4 2.4 0 0 1 4.14 2.426l-.06.103L29.506 37.98a2.4 2.4 0 0 1-4.14-2.426l.061-.103z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M4.457 13.666a2.4 2.4 0 0 1 3.306-.044l.088.086 21.334 21.867a2.4 2.4 0 0 1-3.348 3.438l-.088-.086L4.416 17.06a2.4 2.4 0 0 1 .041-3.393z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.77 35.02a2.4 2.4 0 0 1 3.479 3.304l-.085.09L7.83 59.746a2.4 2.4 0 0 1-3.479-3.305l.085-.09z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.97 35.833a2.4 2.4 0 0 1 3.005-1.388l.11.04 26.933 10.667a2.4 2.4 0 0 1-1.659 4.503l-.109-.04-26.933-10.667a2.4 2.4 0 0 1-1.348-3.115z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "27.466",
                cy: "36.716",
                r: "9.333"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "6.133",
                cy: "15.383",
                r: "6.133"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "54.133",
                cy: "47.383",
                r: "6.133"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "43.467",
                cy: "9.517",
                r: "9.333"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("circle", {
                cx: "6.133",
                cy: "58.049",
                r: "6.133"
            })
        ]
    });
};

});

parcelRegister("hz3J3", function(module, exports) {

$parcel$export(module.exports, "DiagramVenn", function () { return $e36475f57ae19757$export$24ec4ec2dde88eef; });

var $loA2J = parcelRequire("loA2J");
const $e36475f57ae19757$export$24ec4ec2dde88eef = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 67 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M33.214.184c12.442 0 22.527 10.085 22.527 22.526S45.656 45.237 33.214 45.237 10.687 35.152 10.687 22.71 20.773.184 33.214.184zm0 39.875c9.581 0 17.348-7.767 17.348-17.348S42.795 5.363 33.214 5.363 15.866 13.13 15.866 22.71c0 9.58 7.767 17.348 17.348 17.348z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.527 19.129c12.441 0 22.527 10.085 22.527 22.527S34.968 64.183 22.527 64.183 0 54.097 0 41.656s10.086-22.527 22.527-22.527zm0 39.875c9.58 0 17.348-7.767 17.348-17.348 0-9.582-7.767-17.349-17.348-17.349S5.179 32.074 5.179 41.656c0 9.58 7.767 17.348 17.348 17.348z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44.388 19.129c12.441 0 22.527 10.085 22.527 22.527S56.829 64.183 44.388 64.183 21.861 54.097 21.861 41.656s10.086-22.527 22.527-22.527zm0 39.875c9.581 0 17.348-7.767 17.348-17.348 0-9.582-7.767-17.349-17.348-17.349S27.04 32.074 27.04 41.656c0 9.58 7.767 17.348 17.348 17.348z"
            })
        ]
    });
};

});

parcelRegister("2bV1y", function(module, exports) {

$parcel$export(module.exports, "Email", function () { return $2125de4c9058a61d$export$5a6b8595f311cbb0; });

var $loA2J = parcelRequire("loA2J");
const $2125de4c9058a61d$export$5a6b8595f311cbb0 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 53",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M59.03.563A4.97 4.97 0 0 1 64 5.532L36.257 27.081a6.94 6.94 0 0 1-8.514 0L0 5.533A4.97 4.97 0 0 1 4.97.563z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 5.535V44.68a7.456 7.456 0 0 0 7.456 7.456h49.088A7.456 7.456 0 0 0 64 44.68V5.535l-27.426 21.3a7.456 7.456 0 0 1-9.148 0z"
            })
        ]
    });
};

});

parcelRegister("1mb5o", function(module, exports) {

$parcel$export(module.exports, "Filter", function () { return $ece032878f1fb7bf$export$ec91da630f36d5ea; });

var $loA2J = parcelRequire("loA2J");
const $ece032878f1fb7bf$export$ec91da630f36d5ea = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 33 41",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.26 38.154c0 2.086-2.542 3.13-4.029 1.656l-3.147-3.122a2.331 2.331 0 0 1-.691-1.655V21.568a2.35 2.35 0 0 1 2.36-2.341H17.9a2.35 2.35 0 0 1 2.36 2.34z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.555 24.078a2.366 2.366 0 0 1-1.936 1.001h-6.585a2.366 2.366 0 0 1-1.936-1.001L.425 8.906A2.327 2.327 0 0 1 0 7.567V2.841A2.35 2.35 0 0 1 2.36.5h27.933a2.35 2.35 0 0 1 2.36 2.34v4.727c0 .479-.148.946-.424 1.34z"
            })
        ]
    });
};

});

parcelRegister("7ot2T", function(module, exports) {

$parcel$export(module.exports, "Map", function () { return $857819043ff7d6d1$export$a5c7b93649eaf8f8; });

var $loA2J = parcelRequire("loA2J");
const $857819043ff7d6d1$export$a5c7b93649eaf8f8 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-current": "true",
        viewBox: "0 0 59 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44 .773V59.06l10.198 3.922c2.246.864 4.66-.794 4.66-3.2V8.842c0-1.418-.875-2.69-2.199-3.2zM14.857.773V59.06l14.858 5.714V6.488z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.714 6.488v58.285L44 59.06V.773zM2.198 5.642A3.429 3.429 0 0 0 0 8.842v50.94c0 2.405 2.414 4.063 4.66 3.2l10.197-3.923V.773z"
            })
        ]
    });
};

});

parcelRegister("dmsf1", function(module, exports) {

$parcel$export(module.exports, "News", function () { return $1bde599140cac12e$export$aec6fe3795564851; });

var $loA2J = parcelRequire("loA2J");
const $1bde599140cac12e$export$aec6fe3795564851 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 48 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7.518 26.638c0-1.544 1.165-2.796 2.602-2.796h10.41c1.437 0 2.602 1.252 2.602 2.796v11.184c0 1.545-1.165 2.796-2.602 2.796H10.12c-1.437 0-2.602-1.251-2.602-2.796z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M41.06 64.457c3.833 0 6.94-3.338 6.94-7.456V7.913C48 3.795 44.893.457 41.06.457H6.94C3.107.457 0 3.795 0 7.913v49.088c0 4.118 3.107 7.456 6.94 7.456zm-.036-48.877c-.007-1.545-1.179-2.79-2.616-2.781l-28.591.17-.123.003c-1.38.077-2.473 1.308-2.465 2.808.008 1.544 1.18 2.789 2.617 2.78l28.59-.169.123-.004c1.38-.077 2.473-1.307 2.466-2.808zm-2.602 8.432c1.437 0 2.603 1.251 2.603 2.796 0 1.5-1.1 2.724-2.48 2.793l-.123.003h-8.657c-1.437 0-2.602-1.252-2.602-2.796 0-1.5 1.1-2.725 2.48-2.793l.122-.003zm2.927 13.98c0-1.543-1.165-2.795-2.602-2.795h-8.982l-.122.003c-1.38.068-2.48 1.293-2.48 2.793 0 1.544 1.165 2.796 2.602 2.796h8.982l.122-.003c1.38-.069 2.48-1.293 2.48-2.793zm-2.941 8.22c1.437-.009 2.609 1.236 2.617 2.78.007 1.5-1.086 2.731-2.466 2.808l-.122.004-28.591.17c-1.438.008-2.61-1.237-2.617-2.781-.008-1.5 1.085-2.731 2.465-2.808l.123-.004zM10.12 23.842c-1.438 0-2.603 1.253-2.603 2.797v11.184c0 1.545 1.165 2.796 2.603 2.796h10.41c1.436 0 2.602-1.251 2.602-2.796V26.64c0-1.544-1.166-2.796-2.603-2.796z"
            })
        ]
    });
};

});

parcelRegister("2oRNf", function(module, exports) {

$parcel$export(module.exports, "PageMultiple", function () { return $d104e5de1bae7082$export$23b02afe38134aca; });

var $loA2J = parcelRequire("loA2J");
const $d104e5de1bae7082$export$23b02afe38134aca = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 77",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M64 15.272H49.185V.457zM42.074 76.31a7.111 7.111 0 0 0 7.111-7.11V30.087L34.37 15.273H7.111A7.111 7.111 0 0 0 0 22.384V69.2a7.111 7.111 0 0 0 7.111 7.111zm-1.482-37.037a2.667 2.667 0 0 0-2.666-2.667H11.852l-.126.003a2.667 2.667 0 0 0 .126 5.33h26.074l.125-.002a2.667 2.667 0 0 0 2.541-2.664zM24.89 50.236a2.667 2.667 0 0 1 .125 5.33l-.125.004H11.852a2.667 2.667 0 0 1-.126-5.33l.126-.004zm9.481-20.148h14.815L34.37 15.274z"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M56.889 61.494a7.111 7.111 0 0 0 7.11-7.111V15.272L49.185.457h-27.26a7.111 7.111 0 0 0-7.11 7.111v26.074h28.444v27.852zM34.37 30.086h14.815L34.37 15.271z",
                    opacity: ".5"
                })
            ]
        })
    });
};

});

parcelRegister("glWVa", function(module, exports) {

$parcel$export(module.exports, "Process", function () { return $410f438fe375154a$export$ddab65ae98aaa487; });

var $loA2J = parcelRequire("loA2J");
const $410f438fe375154a$export$ddab65ae98aaa487 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 87 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M86.855 16.099a9.429 9.429 0 0 0-9.426-9.245H43.714l-.12.002a2.571 2.571 0 0 0 .12 5.14H77.43l.138.003a4.286 4.286 0 0 1 4.147 4.283v9.714l-.002.14a4.286 4.286 0 0 1-4.283 4.146h-4.572v-2.571a3.429 3.429 0 0 0-3.428-3.429h-52A3.429 3.429 0 0 0 14 27.711v2.571H9.429l-.184.002A9.429 9.429 0 0 0 0 39.71v9.714l.002.183a9.429 9.429 0 0 0 9.427 9.246h34l.12-.003a2.571 2.571 0 0 0-.12-5.14h-34l-.14-.002a4.286 4.286 0 0 1-4.146-4.284V39.71l.002-.139a4.286 4.286 0 0 1 4.284-4.147H14v2.572a3.429 3.429 0 0 0 3.429 3.428h52a3.429 3.429 0 0 0 3.428-3.428v-2.572h4.572l.183-.002a9.429 9.429 0 0 0 9.245-9.427v-9.714z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M69.429 47.71a3.429 3.429 0 0 1 3.428 3.43v10.285a3.429 3.429 0 0 1-3.428 3.429h-52A3.429 3.429 0 0 1 14 61.425V51.14a3.429 3.429 0 0 1 3.429-3.43zM69.429.854a3.429 3.429 0 0 1 3.428 3.428v10.286a3.429 3.429 0 0 1-3.428 3.428h-52A3.429 3.429 0 0 1 14 14.568V4.282A3.429 3.429 0 0 1 17.429.854z"
            })
        ]
    });
};

});

parcelRegister("4oGsD", function(module, exports) {

$parcel$export(module.exports, "SmileyFace", function () { return $fae4df62b19591de$export$ce49b7e1855b43f5; });

var $loA2J = parcelRequire("loA2J");
const $fae4df62b19591de$export$ce49b7e1855b43f5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0 32.023c0-17.673 14.327-32 32-32s32 14.327 32 32-14.327 32-32 32-32-14.326-32-32zm58.991 0C58.991 17.116 46.907 5.032 32 5.032S5.009 17.116 5.009 32.023 17.093 59.014 32 59.014 58.991 46.93 58.991 32.023z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.499 34.958a2.504 2.504 0 0 1 3.212 1.492c1.817 4.967 6.71 8.373 12.291 8.373 5.577 0 10.468-3.402 12.288-8.363a2.504 2.504 0 0 1 4.702 1.725c-2.545 6.937-9.315 11.647-16.99 11.647-7.68 0-14.454-4.717-16.995-11.661a2.504 2.504 0 0 1 1.492-3.213zm9.936-10.448a4.73 4.73 0 1 1-9.461 0 4.73 4.73 0 0 1 9.46 0zm21.148 0a4.73 4.73 0 1 1-9.461 0 4.73 4.73 0 0 1 9.46 0z"
            })
        ]
    });
};

});


parcelRegister("543Rs", function(module, exports) {
$parcel$export(module.exports, "Badge", function () { return (parcelRequire("7XJmC")).Badge; });
$parcel$export(module.exports, "Bolt", function () { return (parcelRequire("1LFoy")).Bolt; });
$parcel$export(module.exports, "Book", function () { return (parcelRequire("3e4OR")).Book; });
$parcel$export(module.exports, "Bookmark", function () { return (parcelRequire("cpV4H")).Bookmark; });
$parcel$export(module.exports, "Box", function () { return (parcelRequire("kNq6A")).Box; });
$parcel$export(module.exports, "Briefcase", function () { return (parcelRequire("d4HaZ")).Briefcase; });
$parcel$export(module.exports, "Building", function () { return (parcelRequire("5lUQJ")).Building; });
$parcel$export(module.exports, "Clock", function () { return (parcelRequire("9XKqn")).Clock; });
$parcel$export(module.exports, "Flag", function () { return (parcelRequire("bUDSM")).Flag; });
$parcel$export(module.exports, "Headset", function () { return (parcelRequire("iN1pq")).Headset; });
$parcel$export(module.exports, "Leaf", function () { return (parcelRequire("kvWNQ")).Leaf; });
$parcel$export(module.exports, "Lego", function () { return (parcelRequire("i3JeI")).Lego; });
$parcel$export(module.exports, "Lightbulb", function () { return (parcelRequire("gwUdS")).Lightbulb; });
$parcel$export(module.exports, "MagicWand", function () { return (parcelRequire("4pkbs")).MagicWand; });
$parcel$export(module.exports, "MagnifyingGlass", function () { return (parcelRequire("5XuiX")).MagnifyingGlass; });
$parcel$export(module.exports, "Megaphone", function () { return (parcelRequire("1nYEx")).Megaphone; });
$parcel$export(module.exports, "PartyPopper", function () { return (parcelRequire("cOz25")).PartyPopper; });
$parcel$export(module.exports, "Pencil", function () { return (parcelRequire("iDiDE")).Pencil; });
$parcel$export(module.exports, "PencilWriting", function () { return (parcelRequire("dQEKa")).PencilWriting; });
$parcel$export(module.exports, "SecurityCheckmark", function () { return (parcelRequire("9s2Jn")).SecurityCheckmark; });
$parcel$export(module.exports, "Star", function () { return (parcelRequire("klCBm")).Star; });
$parcel$export(module.exports, "TrafficCone", function () { return (parcelRequire("eHTL4")).TrafficCone; });
$parcel$export(module.exports, "Trophy", function () { return (parcelRequire("dyfX3")).Trophy; });
parcelRequire("7XJmC");
parcelRequire("1LFoy");
parcelRequire("3e4OR");
parcelRequire("cpV4H");
parcelRequire("kNq6A");
parcelRequire("d4HaZ");
parcelRequire("5lUQJ");
parcelRequire("9XKqn");
parcelRequire("bUDSM");
parcelRequire("iN1pq");
parcelRequire("kvWNQ");
parcelRequire("i3JeI");
parcelRequire("gwUdS");
parcelRequire("4pkbs");
parcelRequire("5XuiX");
parcelRequire("1nYEx");
parcelRequire("cOz25");
parcelRequire("iDiDE");
parcelRequire("dQEKa");
parcelRequire("9s2Jn");
parcelRequire("klCBm");
parcelRequire("eHTL4");
parcelRequire("dyfX3");

});
parcelRegister("7XJmC", function(module, exports) {

$parcel$export(module.exports, "Badge", function () { return $3488826ffe5fe75a$export$37acb3580601e69a; });

var $loA2J = parcelRequire("loA2J");
const $3488826ffe5fe75a$export$37acb3580601e69a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 48 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.58 41.425a5.003 5.003 0 0 1 5.003-5.003h20.844a5.003 5.003 0 0 1 5.003 5.003v20.823c0 2.094-2.42 3.262-4.058 1.958l-9.81-7.802a2.501 2.501 0 0 0-3.114 0l-9.81 7.802C11 65.51 8.58 64.342 8.58 62.248z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47.745 24.494c0-13.111-10.629-23.74-23.74-23.74-13.11 0-23.74 10.629-23.74 23.74 0 13.11 10.63 23.74 23.74 23.74 13.111 0 23.74-10.63 23.74-23.74zm-27.582-5.986 2.267-4.593a2.28 2.28 0 0 1 4.089 0l2.266 4.593 5.069.736a2.28 2.28 0 0 1 1.942 2.468l-.014.116a2.28 2.28 0 0 1-.665 1.305l-3.667 3.574.865 5.049a2.28 2.28 0 0 1-1.746 2.61l-.115.022a2.28 2.28 0 0 1-1.447-.229l-4.533-2.383-4.533 2.383a2.28 2.28 0 0 1-3.02-.851l-.059-.106a2.28 2.28 0 0 1-.229-1.446l.865-5.049-3.667-3.574a2.28 2.28 0 0 1-.126-3.132l.085-.092a2.28 2.28 0 0 1 1.305-.665z"
            })
        ]
    });
};

});

parcelRegister("1LFoy", function(module, exports) {

$parcel$export(module.exports, "Bolt", function () { return $33aecbe22ecb2702$export$7f372b1b1996cd31; });

var $loA2J = parcelRequire("loA2J");
const $33aecbe22ecb2702$export$7f372b1b1996cd31 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 44 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.866 1.129c1.15-1.562 3.624-.556 3.357 1.365l-5.216 37.56H1.91c-1.533 0-2.414-1.743-1.506-2.977L26.866 1.129Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.456 24.668c1.533 0 2.414 1.743 1.506 2.977L16.5 63.594c-1.15 1.562-3.624.555-3.357-1.366l5.217-37.56h23.096Z"
            })
        ]
    });
};

});

parcelRegister("3e4OR", function(module, exports) {

$parcel$export(module.exports, "Book", function () { return $378c8b9a6671e567$export$c959ddfb5bf9a14a; });

var $loA2J = parcelRequire("loA2J");
const $378c8b9a6671e567$export$c959ddfb5bf9a14a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 52 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M51.71 44.992V4.603A3.728 3.728 0 0 0 47.984.875H10.08C4.59.875.138 5.326.138 10.817v44.116c0-5.49 4.452-9.941 9.942-9.941z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M51.71 52.137V44.99H10.08c-5.49 0-9.942 4.451-9.942 9.942s4.451 9.942 9.942 9.942h37.903a3.728 3.728 0 0 0 3.728-3.728v-3.417H12.817a2.796 2.796 0 0 1-.132-5.59l.132-.002z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("cpV4H", function(module, exports) {

$parcel$export(module.exports, "Bookmark", function () { return $cded7bcd98dda9d9$export$301ef70c5c7bdf65; });

var $loA2J = parcelRequire("loA2J");
const $cded7bcd98dda9d9$export$301ef70c5c7bdf65 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 51 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.392 33.239a2.71 2.71 0 0 1-5.418.127l-.003-.127v-13.25a2.71 2.71 0 0 1 5.418-.127l.003.127zM34.437 33.239a2.71 2.71 0 0 1-5.418.127l-.003-.127v-13.25a2.71 2.71 0 0 1 5.418-.127l.003.127z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M43.47.719a7.227 7.227 0 0 1 7.227 7.227v53.153c0 2.948-3.34 4.656-5.73 2.928L25.704 50.102 6.44 64.028c-2.39 1.728-5.73.02-5.73-2.928V7.946A7.227 7.227 0 0 1 7.938.719zm-21.078 32.52a2.71 2.71 0 0 1-5.417.128l-.003-.128V19.99a2.71 2.71 0 0 1 5.417-.127l.003.127zm9.335 2.71a2.71 2.71 0 0 0 2.71-2.71V19.99l-.003-.127a2.71 2.71 0 0 0-5.417.127v13.25l.003.127a2.71 2.71 0 0 0 2.707 2.583z"
            })
        ]
    });
};

});

parcelRegister("kNq6A", function(module, exports) {

$parcel$export(module.exports, "Box", function () { return $3f5e860e34f409cf$export$e71c4d32a2263218; });

var $loA2J = parcelRequire("loA2J");
const $3f5e860e34f409cf$export$e71c4d32a2263218 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.462 33.807h32.932v21.747H16.462V33.807Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.384.875h20.815v13.98h7.457V.876H57.47a7.456 7.456 0 0 1 7.457 7.456V57.42a7.456 7.456 0 0 1-7.457 7.456H8.384a7.456 7.456 0 0 1-7.456-7.456V8.33A7.456 7.456 0 0 1 8.384.875Zm40.277 33.554H17.083v20.505h31.578V34.429Z"
            })
        ]
    });
};

});

parcelRegister("d4HaZ", function(module, exports) {

$parcel$export(module.exports, "Briefcase", function () { return $00203a6998728ed6$export$e7d61f8a47ad0cdc; });

var $loA2J = parcelRequire("loA2J");
const $00203a6998728ed6$export$e7d61f8a47ad0cdc = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 63 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.265 11.485C21.265 5.54 26.085.72 32.03.72s10.767 4.82 10.767 10.766v3.588h-5.384v-3.587a5.383 5.383 0 0 0-5.224-5.381l-.16-.003a5.383 5.383 0 0 0-5.382 5.384v3.587h-5.383zm13.757 20.336h27.514v25.72a7.178 7.178 0 0 1-7.178 7.178H8.105A7.178 7.178 0 0 1 .928 57.54v-25.72h28.71v3.888a2.692 2.692 0 1 0 5.383 0z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M62.536 22.252a7.178 7.178 0 0 0-7.178-7.178H8.105a7.178 7.178 0 0 0-7.177 7.178v9.57h28.71v-5.086a2.692 2.692 0 0 1 5.384 0v5.086h27.514z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("5lUQJ", function(module, exports) {

$parcel$export(module.exports, "Building", function () { return $1eb1873262448132$export$bb414d9e15d07212; });

var $loA2J = parcelRequire("loA2J");
const $1eb1873262448132$export$bb414d9e15d07212 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 42",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.993 15.129a2.863 2.863 0 0 1 2.229 2.787 2.866 2.866 0 0 1-2.873 2.858 2.866 2.866 0 0 1-2.873-2.858c0-1.359.952-2.496 2.229-2.787h-10.61a2.865 2.865 0 0 1 2.636 2.849 2.866 2.866 0 0 1-2.873 2.859 2.866 2.866 0 0 1-2.873-2.859c0-1.5 1.16-2.73 2.636-2.85H10.243c-2.539 0-4.9 2.049-4.9 4.575V39.45H60.19V19.703c0-2.526-2.058-4.574-4.596-4.574H38.993Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M16.707 37.138V4.765c0-2.526 2.058-4.574 4.597-4.574h22.599c2.538 0 4.596 2.048 4.596 4.574v32.373h14.173a1.932 1.932 0 0 1 0 3.864H2.535a1.932 1.932 0 1 1 0-3.864h14.172Zm12.258 0v-5.974c0-1.949 1.588-3.53 3.546-3.53a3.538 3.538 0 0 1 3.547 3.53v5.974h-7.093Zm.766-19.16a2.866 2.866 0 0 0-2.873-2.858 2.866 2.866 0 0 0-2.873 2.859 2.866 2.866 0 0 0 2.873 2.858 2.866 2.866 0 0 0 2.873-2.858Zm8.618-2.92a2.866 2.866 0 0 1 2.873 2.858 2.866 2.866 0 0 1-2.873 2.859 2.866 2.866 0 0 1-2.873-2.859 2.866 2.866 0 0 1 2.873-2.859Zm-8.618-6.29a2.866 2.866 0 0 0-2.873-2.858 2.866 2.866 0 0 0-2.873 2.859 2.866 2.866 0 0 0 2.873 2.858A2.866 2.866 0 0 0 29.73 8.77Zm8.618-2.858a2.866 2.866 0 0 1 2.873 2.859 2.866 2.866 0 0 1-2.873 2.858 2.866 2.866 0 0 1-2.873-2.858A2.866 2.866 0 0 1 38.35 5.91Z"
            })
        ]
    });
};

});

parcelRegister("9XKqn", function(module, exports) {

$parcel$export(module.exports, "Clock", function () { return $946114cc83aa6bb4$export$9735c82c4bae3302; });

var $loA2J = parcelRequire("loA2J");
const $946114cc83aa6bb4$export$9735c82c4bae3302 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M32.036 6.035C17.154 6.035 5.09 18.1 5.09 32.983S17.154 59.93 32.036 59.93c14.883 0 26.948-12.065 26.948-26.947S46.919 6.035 32.036 6.035zM29.51 11.65v15.087a6.739 6.739 0 1 0 5.227 12.42l10.096 10.196.094.09a2.526 2.526 0 0 0 3.496-3.645L38.27 35.545a6.74 6.74 0 0 0-3.707-8.808V11.65l-.003-.13a2.526 2.526 0 0 0-5.05.13z",
                    opacity: ".5"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M32.036.984c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 5.052C17.153 6.036 5.09 18.1 5.09 32.983s12.064 26.948 26.947 26.948 26.947-12.065 26.947-26.948S46.92 6.036 32.036 6.036z"
                })
            ]
        })
    });
};

});

parcelRegister("bUDSM", function(module, exports) {

$parcel$export(module.exports, "Flag", function () { return $78e53642f02eb612$export$48ea269755562084; });

var $loA2J = parcelRequire("loA2J");
const $78e53642f02eb612$export$48ea269755562084 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 60 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.046 47.672h49.382c3.005 0 4.68-3.471 2.81-5.823L47.042 27.775a3.589 3.589 0 0 1 0-4.468L58.237 9.233c1.87-2.352.196-5.823-2.809-5.823H6.047z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M6.046 62.027a2.692 2.692 0 0 1-5.38.127l-.003-.127V3.41a2.692 2.692 0 0 1 5.38-.126l.003.126z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("iN1pq", function(module, exports) {

$parcel$export(module.exports, "Headset", function () { return $53124237245fad2c$export$2d2afa4e2c836258; });

var $loA2J = parcelRequire("loA2J");
const $53124237245fad2c$export$2d2afa4e2c836258 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 64",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M5.898 33.097a7.456 7.456 0 0 1 7.457-7.456h3.107c1.029 0 1.864.834 1.864 1.864V48.01c0 1.03-.835 1.864-1.864 1.864h-3.107a7.456 7.456 0 0 1-7.457-7.457zM47.53 27.505c0-1.03.834-1.864 1.863-1.864H52.5a7.456 7.456 0 0 1 7.456 7.456v9.32a7.456 7.456 0 0 1-7.456 7.457h-3.107a1.864 1.864 0 0 1-1.864-1.864zM27.024 57.64a6.214 6.214 0 1 1 12.428 0 6.214 6.214 0 0 1-12.428 0z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.928.164c12.91 0 23.4 10.361 23.609 23.221l.003.39v8.078a2.796 2.796 0 0 1-5.59.132l-.003-.132v-8.077c0-9.952-8.067-18.02-18.019-18.02-9.852 0-17.858 7.907-18.017 17.722l-.002.298v8.077a2.796 2.796 0 0 1-5.59.132l-.003-.132v-8.077C9.316 10.736 19.888.164 32.928.164zM53.743 43.97c1.5 0 2.725 1.182 2.794 2.665l.003.132v3.417c0 5.596-4.483 10.145-10.053 10.25l-.2.003H32.928a2.796 2.796 0 0 1-.132-5.59l.132-.003h13.36a4.66 4.66 0 0 0 4.657-4.509l.002-.15v-3.418a2.796 2.796 0 0 1 2.796-2.796zM.928 35.582a3.728 3.728 0 0 1 3.728-3.729h1.243V43.66H4.656a3.728 3.728 0 0 1-3.728-3.728zM64.928 35.582a3.728 3.728 0 0 0-3.728-3.729h-1.243V43.66H61.2c2.059 0 3.728-1.669 3.728-3.728z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("kvWNQ", function(module, exports) {

$parcel$export(module.exports, "Leaf", function () { return $507fca07b3b8bcd6$export$3024f3bfb62054a3; });

var $loA2J = parcelRequire("loA2J");
const $507fca07b3b8bcd6$export$3024f3bfb62054a3 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M15.132 52.75a29.697 29.697 0 0 0 19.403 7.177c16.466 0 29.815-13.349 29.815-29.815V7.238a6.94 6.94 0 0 0-6.94-6.94H34.535C18.07.298 4.721 13.646 4.721 30.112a29.695 29.695 0 0 0 6.985 19.178L1.341 59.655l-.097.101C.174 60.91.042 62.55.966 63.473c.95.95 2.66.782 3.817-.376z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M41.837.297h-7.302c-2.738 0-5.39.37-7.91 1.06v33.046L41.837 19.19zm-20.08 2.869C11.686 7.95 4.722 18.218 4.722 30.11a29.696 29.696 0 0 0 7.06 19.267c.118-.189.256-.371.416-.543l.097-.1 9.464-9.465zm-6.683 49.533a29.698 29.698 0 0 0 19.461 7.227c11.893 0 22.16-6.964 26.945-17.036H25.022l-9.286 9.286c-.206.206-.429.38-.662.523zm48.215-14.676a29.847 29.847 0 0 0 1.06-7.912v-7.3H45.102L29.889 38.022zm1.06-20.08V7.598a7.272 7.272 0 0 0-.77-3.266L49.97 17.943zM60.077.953a7.275 7.275 0 0 0-3.028-.656H46.704v14.027z"
            })
        ]
    });
};

});

parcelRegister("i3JeI", function(module, exports) {

$parcel$export(module.exports, "Lego", function () { return $bfa02fb78f8d79e3$export$a5ffdce5e33c0d1c; });

var $loA2J = parcelRequire("loA2J");
const $bfa02fb78f8d79e3$export$a5ffdce5e33c0d1c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 63",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.354 3.761A3.728 3.728 0 0 1 17.084.033h6.835a3.728 3.728 0 0 1 3.728 3.728v6.835a3.728 3.728 0 0 1-3.728 3.729h-6.835a3.728 3.728 0 0 1-3.728-3.729V3.761ZM38.209 3.761A3.728 3.728 0 0 1 41.937.033h6.835A3.728 3.728 0 0 1 52.5 3.761v6.835a3.728 3.728 0 0 1-3.728 3.729h-6.835a3.728 3.728 0 0 1-3.728-3.729V3.761Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M57.471 10.596a7.456 7.456 0 0 1 7.457 7.456v36.66a7.456 7.456 0 0 1-7.457 7.456H8.384a7.456 7.456 0 0 1-7.456-7.456v-36.66a7.456 7.456 0 0 1 7.456-7.456h49.087Z"
            })
        ]
    });
};

});

parcelRegister("gwUdS", function(module, exports) {

$parcel$export(module.exports, "Lightbulb", function () { return $0034bb8e34e31791$export$3d88f82d313e52c; });

var $loA2J = parcelRequire("loA2J");
const $0034bb8e34e31791$export$3d88f82d313e52c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 46 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M39.49 38c8.493-8.493 8.493-22.263 0-30.757-8.908-8.907-23.35-8.907-32.257 0-.244.244-.482.494-.715.75-8.08 8.887-7.424 22.642 1.463 30.722l3.995 3.632v7.384h22.77v-7.384l3.995-3.632c.255-.232.505-.47.749-.714ZM25.483 10.01a2.577 2.577 0 0 0-2.577-2.576c-8.38 0-15.173 6.793-15.173 15.173v.573l.003.12a2.577 2.577 0 0 0 5.15-.12v-.573l.002-.188c.1-5.447 4.547-9.832 10.018-9.832a2.577 2.577 0 0 0 2.577-2.577Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.976 54.884v1.995a7.683 7.683 0 0 0 7.682 7.683h7.405a7.683 7.683 0 0 0 7.682-7.683v-1.995h-22.77Z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("4pkbs", function(module, exports) {

$parcel$export(module.exports, "MagicWand", function () { return $9306ab92b7e3f461$export$8b253004761c5525; });

var $loA2J = parcelRequire("loA2J");
const $9306ab92b7e3f461$export$8b253004761c5525 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 64",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m41.026 15.924 7.058 7.057 14.18-14.18a1.859 1.859 0 0 0 0-2.628l-4.429-4.43a1.858 1.858 0 0 0-2.628 0zM41.925 4.171a3.717 3.717 0 1 1-7.434 0 3.717 3.717 0 0 1 7.434 0z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m48.084 22.982-7.057-7.058L1.811 55.14a4.99 4.99 0 1 0 7.058 7.057zm2.862-16.977-9.919 9.92zM56.037 31.746c.287-.11.604-.11.891 0l6.628 2.552c1.058.408 1.058 1.905 0 2.313l-6.628 2.552c-.287.11-.604.11-.89 0l-6.628-2.552c-1.058-.408-1.058-1.905 0-2.313z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M55.327 28.382c.407-1.059 1.904-1.059 2.312 0l2.552 6.627c.11.287.11.604 0 .89l-2.552 6.628c-.408 1.058-1.905 1.058-2.313 0L52.775 35.9a1.239 1.239 0 0 1 0-.89zM23.205 10.064c.287-.11.604-.11.891 0l6.628 2.553c1.058.407 1.058 1.904 0 2.312l-6.628 2.552a1.24 1.24 0 0 1-.89 0l-6.628-2.552c-1.058-.408-1.058-1.905 0-2.312z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.494 6.7c.408-1.058 1.905-1.058 2.313 0l2.552 6.627c.11.287.11.604 0 .891l-2.552 6.628c-.408 1.058-1.905 1.058-2.312 0l-2.553-6.628a1.239 1.239 0 0 1 0-.89z"
            })
        ]
    });
};

});

parcelRegister("5XuiX", function(module, exports) {

$parcel$export(module.exports, "MagnifyingGlass", function () { return $983ec051f130ffb3$export$bdf537af43a20db5; });

var $loA2J = parcelRequire("loA2J");
const $983ec051f130ffb3$export$bdf537af43a20db5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M62.55 56.212a5.076 5.076 0 0 1-7.178 7.177L39.738 47.757l7.178-7.178z",
                    opacity: ".5"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M28.021 49.573c11.832 0 21.423-9.591 21.423-21.423 0-11.831-9.591-21.422-21.423-21.422S6.6 16.318 6.6 28.15s9.59 21.423 21.422 21.423zM14.19 27.683a2.835 2.835 0 1 0 5.67 0v-.315c0-3.435 2.86-6.301 6.616-6.301a2.835 2.835 0 1 0 0-5.67c-6.683 0-12.286 5.203-12.286 11.97z",
                    opacity: ".5"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M55.114 27.97c0-14.964-12.13-27.094-27.093-27.094S.928 13.006.928 27.969c0 14.964 12.13 27.094 27.093 27.094s27.093-12.13 27.093-27.094zM28.021 49.573c11.832 0 21.423-9.591 21.423-21.423 0-11.831-9.592-21.423-21.423-21.423S6.598 16.32 6.598 28.151c0 11.832 9.592 21.423 21.423 21.423z"
                })
            ]
        })
    });
};

});

parcelRegister("1nYEx", function(module, exports) {

$parcel$export(module.exports, "Megaphone", function () { return $4b2833faa954f9e1$export$79c66221ddbb3eb1; });

var $loA2J = parcelRequire("loA2J");
const $4b2833faa954f9e1$export$79c66221ddbb3eb1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 63 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.027 36.587h-6.415a8.456 8.456 0 0 0-8.457 8.456v7.874c0 6.441 5.223 11.664 11.664 11.664 6.442 0 11.664-5.223 11.664-11.664v-7.874a8.456 8.456 0 0 0-8.456-8.456Zm-6.415 5.25h6.415a3.208 3.208 0 0 1 3.208 3.207v7.873a6.415 6.415 0 0 1-12.83 0v-7.873a3.208 3.208 0 0 1 3.207-3.208ZM2.785 18.508a2.625 2.625 0 0 1 2.621 2.5l.003.124v19.246a2.624 2.624 0 0 1-5.246.123l-.003-.123V21.132a2.624 2.624 0 0 1 2.625-2.624Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m2.784 39.212 55.592 16.192a3.5 3.5 0 0 0 4.478-3.36V4.084c0-2.46-2.472-4.153-4.766-3.262L2.784 22.299v16.913Z"
            })
        ]
    });
};

});

parcelRegister("cOz25", function(module, exports) {

$parcel$export(module.exports, "PartyPopper", function () { return $05ddb1583035f844$export$f0462cf72e962b45; });

var $loA2J = parcelRequire("loA2J");
const $05ddb1583035f844$export$f0462cf72e962b45 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M61.946 21.427a3.79 3.79 0 1 0-7.58 0 3.79 3.79 0 0 0 7.58 0zM14.386 19.583l-4.229 13 21.485 21.485 12.676-4.553zM3.956 51.651l4.228-13 17.542 17.542-12.675 4.553zM1.982 57.718.6 61.972a1.895 1.895 0 0 0 2.443 2.37l4.093-1.47zM50.233 47.39l8.45-3.036a3.79 3.79 0 0 0 1.329-6.315L24.922 4.717a3.79 3.79 0 0 0-6.214 1.576l-2.349 7.222z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                opacity: ".5",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M45.383 12.259c.292.112.615.112.908 0l6.758-2.603c1.08-.416 1.08-1.943 0-2.358l-6.758-2.603a1.263 1.263 0 0 0-.908 0l-6.76 2.603c-1.078.415-1.078 1.942 0 2.358z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M44.658 15.69c.415 1.079 1.942 1.079 2.358 0l2.603-6.76a1.264 1.264 0 0 0 0-.907l-2.603-6.759c-.416-1.08-1.943-1.08-2.358 0l-2.603 6.759a1.264 1.264 0 0 0 0 .908zM64.474 4.37a3.79 3.79 0 1 0-7.581 0 3.79 3.79 0 0 0 7.58 0zM16.859 11.98l-.5 1.535L50.234 47.39l-5.916 2.126-29.932-29.932-.94 2.888zM3.956 51.651 1.982 57.72l5.153 5.152 5.916-2.125zM25.727 56.193 8.184 38.651 6.73 43.124l3.413-10.492 21.453 21.453z"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("iDiDE", function(module, exports) {

$parcel$export(module.exports, "Pencil", function () { return $898c9f69929daaf2$export$889aff59bd27773b; });

var $loA2J = parcelRequire("loA2J");
const $898c9f69929daaf2$export$889aff59bd27773b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.68 8.957 4.863 36.775l4.402 4.647L36.895 13.79c.105-.105.217-.2.334-.285L32.68 8.957ZM18.89 51.582l-5.798-6.12 27.737-27.738.099-.103c.067-.074.129-.151.186-.23l6.006 6.005c-.117.085-.228.18-.334.285L18.968 51.5l-.078.083Zm3.817 4.03 4.41 4.654L55.553 31.83l-4.548-4.548c-.057.079-.12.156-.186.23l-.099.104-27.818 27.818a2.824 2.824 0 0 1-.195.177Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.68 8.957 55.554 31.83l6.191-6.19a7.418 7.418 0 0 0 0-10.492L49.362 2.766a7.418 7.418 0 0 0-10.49 0L32.68 8.957ZM4.862 36.775l-3.24 3.241A3.71 3.71 0 0 0 .535 42.64v18.245a3.71 3.71 0 0 0 3.71 3.71h17.008c.984 0 1.927-.391 2.623-1.087l3.24-3.24L4.863 36.774Z"
            })
        ]
    });
};

});

parcelRegister("dQEKa", function(module, exports) {

$parcel$export(module.exports, "PencilWriting", function () { return $d10c2f9b34b6a1b7$export$c5b8759462e730b4; });

var $loA2J = parcelRequire("loA2J");
const $d10c2f9b34b6a1b7$export$c5b8759462e730b4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 91 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m59.045 8.38 22.872 22.872 6.191-6.191a7.418 7.418 0 0 0 0-10.49L75.727 2.187a7.418 7.418 0 0 0-10.491 0zM31.227 36.197l-3.241 3.241a3.709 3.709 0 0 0-1.087 2.623v18.245a3.71 3.71 0 0 0 3.71 3.71h17.008a3.71 3.71 0 0 0 2.623-1.087l3.241-3.24z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                opacity: ".5",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M30.609 58.452a2.782 2.782 0 0 1 .13 5.56l-.13.004h-27.2a2.782 2.782 0 0 1-.131-5.56l.13-.004zM59.045 8.379 31.227 36.197l4.4 4.646L63.26 13.212a2.8 2.8 0 0 1 .333-.285zM45.253 51.003l-5.797-6.12 27.737-27.737.099-.104c.067-.074.129-.15.186-.23l6.005 6.005c-.117.085-.228.18-.333.286L45.332 50.92zm3.818 4.03 4.41 4.655 28.436-28.436-4.548-4.549c-.058.08-.12.156-.187.23l-.098.104-27.818 27.818a2.848 2.848 0 0 1-.195.177z"
                })
            })
        ]
    });
};

});

parcelRegister("9s2Jn", function(module, exports) {

$parcel$export(module.exports, "SecurityCheckmark", function () { return $2905ffdd1617e4e5$export$992764df22cf8b12; });

var $loA2J = parcelRequire("loA2J");
const $2905ffdd1617e4e5$export$992764df22cf8b12 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 56 65",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            d: "M55.361 7.453c.353-.886.583-1.464-.581-1.464h-3.922c-7.842 0-17.912-3.715-21.537-5.162a3.708 3.708 0 0 0-2.754 0C22.942 2.274 12.872 5.99 5.03 5.99H1.108c-1.164 0-.933.578-.581 1.464.222.558.493 1.239.493 1.973v20.736a34.371 34.371 0 0 0 18.621 30.55l6.728 3.468c.988.51 2.162.51 3.15 0l6.728-3.468a34.371 34.371 0 0 0 18.621-30.55V9.426c0-.734.271-1.415.493-1.973zm-14 15.865a2.578 2.578 0 0 0-.084-3.558l-.088-.084a2.578 2.578 0 0 0-3.558.084l-13.57 13.57-4.658-4.658-.088-.084a2.578 2.578 0 0 0-3.558 3.73l6.481 6.48.088.084a2.578 2.578 0 0 0 3.558-.084l15.393-15.392z"
        })
    });
};

});

parcelRegister("klCBm", function(module, exports) {

$parcel$export(module.exports, "Star", function () { return $2a8dcfacfce64c64$export$1644ba17714857f1; });

var $loA2J = parcelRequire("loA2J");
const $2a8dcfacfce64c64$export$1644ba17714857f1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 63",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m26.998 4.473-6.401 12.992-14.313 2.083a6.435 6.435 0 0 0-3.685 1.881l-.14.149a6.458 6.458 0 0 0 .257 8.971l10.357 10.113-2.445 14.28a6.46 6.46 0 0 0 .647 4.092l.092.17a6.433 6.433 0 0 0 8.602 2.537L32.771 55l12.802 6.742a6.429 6.429 0 0 0 4.084.648l.187-.035a6.45 6.45 0 0 0 5.07-7.412l-2.445-14.28L62.826 30.55a6.453 6.453 0 0 0 1.878-3.69l.024-.186c.401-3.454-2.013-6.621-5.47-7.125l-14.313-2.083-6.4-12.992a6.433 6.433 0 0 0-11.547 0Z"
        })
    });
};

});

parcelRegister("eHTL4", function(module, exports) {

$parcel$export(module.exports, "TrafficCone", function () { return $2a16e15dfaf19727$export$adf54dea6d40c719; });

var $loA2J = parcelRequire("loA2J");
const $2a16e15dfaf19727$export$adf54dea6d40c719 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 63",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9.828 57.19H3.186a2.571 2.571 0 0 0-.121 5.141l.12.003h58.858a2.572 2.572 0 0 0 .12-5.14l-.12-.003H55.4L35.878 3.092c-1.103-3.056-5.425-3.056-6.528 0z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m42.513 21.477 5.361 14.857h-30.52l5.362-14.858zm-27.014 20H49.73l5.671 15.714H9.828zm25.158-25.143L35.84 2.984c-1.09-3.02-5.36-3.02-6.45 0l-4.818 13.35z"
            })
        ]
    });
};

});

parcelRegister("dyfX3", function(module, exports) {

$parcel$export(module.exports, "Trophy", function () { return $b55ade534ae7272b$export$c902dcd836bd9c4f; });

var $loA2J = parcelRequire("loA2J");
const $b55ade534ae7272b$export$c902dcd836bd9c4f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 58",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.22.991a.013.013 0 0 0-.012.013v13.077c0 11.218 9.094 20.312 20.312 20.312 11.218 0 20.312-9.094 20.312-20.312V1.004a.013.013 0 0 0-.013-.013z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.298 33.942a7.222 7.222 0 1 0 14.444 0V26.72H25.298z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                opacity: ".5",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M26.355 27.974a2.638 2.638 0 0 0-2.523-2.636l-.114-.002h-3.25a14.42 14.42 0 0 1-9.992-4.003l-.284-.28A14.438 14.438 0 0 1 6.27 13.67l-.031-.165h8.451a2.638 2.638 0 0 0 2.635-2.524l.003-.114a2.638 2.638 0 0 0-2.523-2.636l-.115-.002H3.36a2.638 2.638 0 0 0-2.637 2.638c0 10.796 8.664 19.568 19.418 19.742l.327.003h3.25a2.638 2.638 0 0 0 2.638-2.638zM39.09 27.974a2.638 2.638 0 0 1 2.523-2.636l.115-.002h3.25c7.032 0 12.892-5.017 14.198-11.666l.03-.165h-8.45a2.638 2.638 0 0 1-2.636-2.524l-.003-.114a2.638 2.638 0 0 1 2.524-2.636l.114-.002h11.33a2.638 2.638 0 0 1 2.638 2.638c0 10.796-8.665 19.568-19.419 19.742l-.326.003h-3.25a2.638 2.638 0 0 1-2.638-2.638zM46.216 54.705a2.638 2.638 0 0 1-2.638 2.638H20.783l-.114-.002a2.638 2.638 0 0 1 .114-5.274h8.872V27.623h5.276v24.444h8.647l.114.003a2.638 2.638 0 0 1 2.524 2.635z"
                })
            })
        ]
    });
};

});


parcelRegister("fvFan", function(module, exports) {
$parcel$export(module.exports, "BrowserCode", function () { return (parcelRequire("9Ddah")).BrowserCode; });
$parcel$export(module.exports, "ButlerAutomation", function () { return (parcelRequire("bXJC4")).ButlerAutomation; });
$parcel$export(module.exports, "Cloud", function () { return (parcelRequire("4Qrq2")).Cloud; });
$parcel$export(module.exports, "GitMerge", function () { return (parcelRequire("9rvwz")).GitMerge; });
$parcel$export(module.exports, "GlobeNetwork", function () { return (parcelRequire("2ZEOJ")).GlobeNetwork; });
$parcel$export(module.exports, "GlobeNetworkLocation", function () { return (parcelRequire("5jlAD")).GlobeNetworkLocation; });
$parcel$export(module.exports, "TrelloCard", function () { return (parcelRequire("1XvHC")).TrelloCard; });
$parcel$export(module.exports, "TrelloCardTemplates", function () { return (parcelRequire("f2LmH")).TrelloCardTemplates; });
$parcel$export(module.exports, "TrelloLabels", function () { return (parcelRequire("fvKpA")).TrelloLabels; });
$parcel$export(module.exports, "TrelloWorkspaces", function () { return (parcelRequire("3cPV3")).TrelloWorkspaces; });
parcelRequire("9Ddah");
parcelRequire("bXJC4");
parcelRequire("4Qrq2");
parcelRequire("9rvwz");
parcelRequire("2ZEOJ");
parcelRequire("5jlAD");
parcelRequire("1XvHC");
parcelRequire("f2LmH");
parcelRequire("fvKpA");
parcelRequire("3cPV3");

});
parcelRegister("9Ddah", function(module, exports) {

$parcel$export(module.exports, "BrowserCode", function () { return $32fc2d2976574f46$export$a08f4612fe78677e; });

var $loA2J = parcelRequire("loA2J");
const $32fc2d2976574f46$export$a08f4612fe78677e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.002 25.73h45.359v27.34H10.002z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M56.63.877H7.491h49.137Zm7.43 17.398h-64v39.146a7.456 7.456 0 0 0 7.457 7.456h49.087a7.456 7.456 0 0 0 7.457-7.456V18.275ZM27.514 31.211a2.796 2.796 0 0 0-3.954 0l-6.835 6.834-.099.105a2.796 2.796 0 0 0 .1 3.85l6.834 6.835.104.099a2.796 2.796 0 0 0 3.85-.1l.1-.104a2.796 2.796 0 0 0-.1-3.85l-4.858-4.857 4.858-4.858.1-.104a2.796 2.796 0 0 0-.1-3.85Zm13.67 0a2.796 2.796 0 0 0-4.053 3.85l.1.104 4.858 4.858-4.859 4.857a2.796 2.796 0 0 0-.1 3.85l.1.105a2.796 2.796 0 0 0 3.85.099l.104-.1L48.018 42a2.796 2.796 0 0 0 .1-3.85l-.1-.105-6.835-6.835Z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M64.06 18.275h-64V8.333A7.456 7.456 0 0 1 7.518.877h49.087a7.456 7.456 0 0 1 7.457 7.456v9.942Zm-55.3-4.35a3.728 3.728 0 1 0 0-7.456 3.728 3.728 0 0 0 0 7.456Zm13.67-3.728a3.728 3.728 0 1 1-7.457 0 3.728 3.728 0 0 1 7.456 0Zm6.213 3.729a3.728 3.728 0 1 0 0-7.457 3.728 3.728 0 0 0 0 7.456Z",
                        opacity: ".5"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("bXJC4", function(module, exports) {

$parcel$export(module.exports, "ButlerAutomation", function () { return $8051448917965891$export$1dcfdaccfd79838f; });

var $loA2J = parcelRequire("loA2J");
const $8051448917965891$export$1dcfdaccfd79838f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 51 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M8.428 45.45a10.27 10.27 0 0 1 2.597-.375l.17-.002h28.61c.958 0 1.886.132 2.766.378a5.225 5.225 0 0 0 4.66-5.195V20.709a5.225 5.225 0 0 0-5.224-5.225H8.992a5.225 5.225 0 0 0-5.224 5.225v19.547a5.225 5.225 0 0 0 4.66 5.195zm3.357 3.922v1.116c0 7.575 6.14 13.715 13.715 13.715 7.574 0 13.714-6.14 13.714-13.715v-1.116zM22.182 30.53a4.06 4.06 0 1 1-8.12 0 4.06 4.06 0 0 1 8.12 0zm10.747 4.06a4.06 4.06 0 1 0 0-8.12 4.06 4.06 0 0 0 0 8.12z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.804 45.072c5.614 0 10.175 4.506 10.266 10.098l.001.17v.154a2.15 2.15 0 0 1-4.296.101l-.002-.101v-.155a5.969 5.969 0 0 0-5.822-5.966l-.147-.002h-28.61a5.969 5.969 0 0 0-5.966 5.821l-.002.147v.155a2.15 2.15 0 0 1-4.296.101l-.002-.101v-.155c0-5.613 4.505-10.175 10.097-10.265l.17-.002z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M25.5.203a5.85 5.85 0 0 0-2.149 11.293v3.989l.003.101a2.15 2.15 0 0 0 4.296-.101v-3.99A5.852 5.852 0 0 0 25.5.204zm.013 7.401a1.551 1.551 0 1 0-.025 0h.025z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("4Qrq2", function(module, exports) {

$parcel$export(module.exports, "Cloud", function () { return $8f5600744e65bfe9$export$e2767e27b246eae1; });

var $loA2J = parcelRequire("loA2J");
const $8f5600744e65bfe9$export$e2767e27b246eae1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 44",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M28.585.129a19.427 19.427 0 0 1 16.13 8.585c.89-.14 1.796-.211 2.71-.211 9.58 0 17.347 7.766 17.347 17.346 0 9.484-7.612 17.19-17.06 17.343l-.286.002H13.93C6.663 43.194.771 37.303.771 30.035c0-5.549 3.46-10.386 8.46-12.294C10.15 7.86 18.464.129 28.584.129z"
        })
    });
};

});

parcelRegister("9rvwz", function(module, exports) {

$parcel$export(module.exports, "GitMerge", function () { return $db5fcb549a2b2e12$export$ea6373a4a927c724; });

var $loA2J = parcelRequire("loA2J");
const $db5fcb549a2b2e12$export$ea6373a4a927c724 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M55.805 34.719a2.54 2.54 0 0 0-.12-5.079H35.078V18.348l-.002-.182a9.316 9.316 0 0 0-9.314-9.135H9.386l-.12.003a2.54 2.54 0 0 0 .12 5.079h16.375l.137.002a4.235 4.235 0 0 1 4.097 4.233v27.666l-.002.137a4.235 4.235 0 0 1-4.232 4.098H9.386l-.12.003a2.54 2.54 0 0 0 .12 5.079h16.375l.18-.002a9.316 9.316 0 0 0 9.136-9.315V34.722h20.609l.12-.003Z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.928.563c6.08 0 11.01 4.929 11.01 11.01 0 6.08-4.93 11.01-11.01 11.01S.918 17.653.918 11.573c0-6.081 4.93-11.01 11.01-11.01ZM11.928 41.78c6.08 0 11.01 4.929 11.01 11.01 0 6.08-4.93 11.01-11.01 11.01S.918 58.87.918 52.79c0-6.081 4.93-11.01 11.01-11.01ZM53.147 21.172c6.08 0 11.01 4.93 11.01 11.01s-4.93 11.01-11.01 11.01-11.01-4.93-11.01-11.01 4.93-11.01 11.01-11.01Z"
            })
        ]
    });
};

});

parcelRegister("2ZEOJ", function(module, exports) {

$parcel$export(module.exports, "GlobeNetwork", function () { return $2c8e3375c9b88665$export$99eb63777644763f; });

var $loA2J = parcelRequire("loA2J");
const $2c8e3375c9b88665$export$99eb63777644763f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M64.035 32.984c0 17.674-14.327 32-32 32-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M52.432 41.687c.432-2.65.656-5.37.656-8.14 0-3.165-.293-6.262-.852-9.264h10.602a32.024 32.024 0 0 1 1.197 8.702c0 3.016-.417 5.935-1.197 8.701zm8.505 5.052h-9.599a50.036 50.036 0 0 1-7.633 16.051 32.113 32.113 0 0 0 17.232-16.05zM29.199 1.11l.03-.003V19.23h-11.44A45.21 45.21 0 0 1 29.198 1.11zm.03 63.755a31.975 31.975 0 0 1-1.275-.137A45.154 45.154 0 0 1 17.43 46.74h11.798zm6.256-.063c-.4.043-.8.078-1.204.106V46.74H46.08a45.155 45.155 0 0 1-10.595 18.062zm-15.91-2.333A32.12 32.12 0 0 1 3.134 46.74h9.037a50.024 50.024 0 0 0 7.404 15.73zM1.232 41.686a32.024 32.024 0 0 1-1.197-8.701c0-3.016.417-5.935 1.198-8.702h10.04a50.53 50.53 0 0 0-.852 9.263c0 2.772.225 5.49.656 8.14zM3.134 19.23h9.356a50.088 50.088 0 0 1 8.253-16.196A32.11 32.11 0 0 0 3.133 19.23zM42.549 2.752A32.101 32.101 0 0 1 60.936 19.23H51.02a50.094 50.094 0 0 0-8.47-16.478zm-13.32 21.531H16.423a45.388 45.388 0 0 0-.95 9.263c0 2.78.25 5.5.731 8.14h13.023zm18.075 17.403c.48-2.64.732-5.36.732-8.14 0-3.175-.328-6.273-.95-9.263H34.28v17.403zM34.281 1.08v18.15h11.44a45.209 45.209 0 0 0-11.44-18.15z"
            })
        ]
    });
};

});

parcelRegister("5jlAD", function(module, exports) {

$parcel$export(module.exports, "GlobeNetworkLocation", function () { return $cf0e6a068744490d$export$a77ccf4e15db1c7a; });

var $loA2J = parcelRequire("loA2J");
const $cf0e6a068744490d$export$a77ccf4e15db1c7a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("mask", {
                id: "globe",
                width: "64",
                height: "63",
                x: "0",
                y: "0",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                    width: "62.129",
                    height: "62.129",
                    x: "63.02",
                    y: "62.691",
                    fill: "#fff",
                    rx: "31.064",
                    transform: "rotate(-180 63.02 62.691)"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                mask: "url(#globe)",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    fillRule: "evenodd",
                    d: "M59.749 80.947c26.938 0 48.776-21.838 48.776-48.776 0-26.939-21.838-48.776-48.776-48.776a48.553 48.553 0 0 0-28.067 8.879 48.553 48.553 0 0 0-28.067-8.88c-26.938 0-48.776 21.838-48.776 48.777 0 26.938 21.838 48.776 48.776 48.776a48.553 48.553 0 0 0 28.067-8.879 48.553 48.553 0 0 0 28.067 8.88Zm0-92.648a43.667 43.667 0 0 0-24.023 7.156c6.846 5.992 12.002 13.868 14.657 22.819H67.38a2.452 2.452 0 0 1 .115 4.902l-.115.003H51.564c.213 1.139.385 2.291.517 3.456a6.253 6.253 0 0 0-2.142 4.718c0 1.951.891 3.694 2.289 4.843a48.841 48.841 0 0 1-.473 3.877h15.624a2.452 2.452 0 0 1 .115 4.902l-.115.003H50.693c-2.552 9.401-7.844 17.675-14.966 23.909a43.666 43.666 0 0 0 24.022 7.155c24.23 0 43.872-19.642 43.872-43.871 0-24.23-19.642-43.872-43.872-43.872Zm-56.134 0a43.666 43.666 0 0 1 24.023 7.156C20.792 1.447 15.637 9.323 12.981 18.274H-1.29l-.116.002a2.453 2.453 0 0 0 .115 4.903H11.8a49.045 49.045 0 0 0-.828 8.992c0 2.69.218 5.33.637 7.902H-1.29l-.115.003a2.453 2.453 0 0 0 .115 4.902h13.961c2.552 9.401 7.844 17.675 14.967 23.909a43.667 43.667 0 0 1-24.023 7.155c-24.23 0-43.871-19.642-43.871-43.871 0-24.23 19.642-43.872 43.871-43.872Zm29.346 76.484a44.18 44.18 0 0 1-1.279 1.108c-.433-.36-.859-.73-1.278-1.107.372.227.81.359 1.278.359.469 0 .907-.132 1.279-.36Zm12.627-19.805A43.877 43.877 0 0 1 33.661 64.14c.298-.406.474-.907.474-1.449V44.978h11.453Zm1.899-12.807c0 2.698-.244 5.339-.71 7.902H34.135V24.66a6.253 6.253 0 0 1-2.18-4.751c0-1.9.845-3.602 2.18-4.751V.654a43.887 43.887 0 0 1 11.105 17.62h-.966c.14.521.215 1.07.215 1.635a6.238 6.238 0 0 1-.92 3.27h2.996c.604 2.902.922 5.91.922 8.992ZM18.33 46.669a43.909 43.909 0 0 0 11.373 17.47 2.44 2.44 0 0 1-.47-1.333l-.003-.116V44.978H26.3a6.24 6.24 0 0 0 1.295-3.815c0-.371-.033-.736-.095-1.09h1.73V23.18H16.8a44.315 44.315 0 0 0-.596 14.373 6.266 6.266 0 0 0 2.125 9.116ZM29.23.654a43.887 43.887 0 0 0-11.106 17.62H29.23V.654Z",
                    opacity: ".5"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m29.23.68-.028.002a43.887 43.887 0 0 0-11.077 17.592H29.23V.679Zm-1.237 61.76c.41.052.822.096 1.237.132V44.978H26.3a6.257 6.257 0 0 1-4.972 2.453 6.24 6.24 0 0 1-2.998-.762 43.87 43.87 0 0 0 9.663 15.77ZM16.205 37.552a44.305 44.305 0 0 1-.327-5.381c0-3.082.318-6.09.923-8.992h12.43v16.894H27.5a6.27 6.27 0 0 0-11.296-2.521Zm17.93 25.063c.392-.027.782-.062 1.17-.103a43.835 43.835 0 0 0 10.284-17.534H34.135v17.637Zm25.877-17.637A31.175 31.175 0 0 1 43.285 60.56a48.573 48.573 0 0 0 7.409-15.58h9.318Zm3.008-13.352a31.09 31.09 0 0 1-1.163 8.447H51.755c.208-1.276.367-2.57.474-3.877a6.267 6.267 0 1 0-.147-9.561 48.712 48.712 0 0 0-.517-3.456h10.292a31.089 31.089 0 0 1 1.163 8.447ZM50.383 18.274h9.628A31.163 31.163 0 0 0 42.16 2.277a48.628 48.628 0 0 1 8.223 15.997ZM3.899 44.978a31.181 31.181 0 0 0 15.96 15.269 48.565 48.565 0 0 1-7.187-15.269H3.899Zm7.711-4.905H2.053a31.088 31.088 0 0 1-1.162-8.447c0-2.928.405-5.762 1.162-8.447h9.748a49.047 49.047 0 0 0-.828 8.992c0 2.69.218 5.33.637 7.902Zm9.384-37.522A31.17 31.17 0 0 0 3.899 18.274h9.083A48.622 48.622 0 0 1 20.994 2.55Zm25.784 37.522c.466-2.563.71-5.204.71-7.902 0-3.082-.318-6.09-.923-8.992H43.57a6.264 6.264 0 0 1-5.347 2.997 6.243 6.243 0 0 1-4.088-1.516v15.413h12.643Zm-8.555-26.432c-1.562 0-2.99.572-4.088 1.516V.654a43.887 43.887 0 0 1 11.106 17.62h-.966a6.27 6.27 0 0 0-6.052-4.633Z"
            })
        ]
    });
};

});

parcelRegister("1XvHC", function(module, exports) {

$parcel$export(module.exports, "TrelloCard", function () { return $2cb85cf7c6ab2339$export$4ac305cbd8e60e82; });

var $loA2J = parcelRequire("loA2J");
const $2cb85cf7c6ab2339$export$4ac305cbd8e60e82 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M64.144 47.443a6.244 6.244 0 0 1-6.244 6.244H46.974V31.313h-8.326V10.5H10.551V6.338A6.244 6.244 0 0 1 16.795.094H57.9a6.244 6.244 0 0 1 6.244 6.244z",
                    opacity: ".5"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M6.908 57.329h40.065V31.312H6.908zm27.578-21.594a2.341 2.341 0 0 1 .11 4.68l-.11.003H14.193a2.341 2.341 0 0 1-.11-4.68l.11-.003zM26.42 48.483a2.341 2.341 0 0 0-2.341-2.341h-9.886l-.11.002a2.342 2.342 0 0 0 .11 4.68h9.886l.11-.002a2.342 2.342 0 0 0 2.231-2.339z",
                    opacity: ".5"
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M53.738 57.85a6.244 6.244 0 0 1-6.244 6.244H6.388A6.244 6.244 0 0 1 .145 57.85V16.744A6.244 6.244 0 0 1 6.388 10.5h41.106a6.244 6.244 0 0 1 6.244 6.244zm-32.52-39.025a2.342 2.342 0 0 0-2.342-2.341H8.99l-.11.003a2.342 2.342 0 0 0 .11 4.68h9.886l.11-.003a2.341 2.341 0 0 0 2.232-2.339zm25.756 0a3.122 3.122 0 1 0-6.244 0 3.122 3.122 0 0 0 6.244 0zm0 38.504H6.909V31.313h40.065z"
                })
            ]
        })
    });
};

});

parcelRegister("f2LmH", function(module, exports) {

$parcel$export(module.exports, "TrelloCardTemplates", function () { return $6355ed0931d16589$export$7f1a87d866e6e15f; });

var $loA2J = parcelRequire("loA2J");
const $6355ed0931d16589$export$7f1a87d866e6e15f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 64 64",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M64 47.003a6.073 6.073 0 0 1-6.072 6.073H52.34v-5.061H17.946a6.074 6.074 0 0 1-6.052-5.567H45.55V17.649H11.873V7.021A6.073 6.073 0 0 1 17.946.948h39.982A6.073 6.073 0 0 1 64 7.021v39.982Z",
                        opacity: ".5"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M52.339 17.143a6.073 6.073 0 0 0-6.074-6.073H6.073A6.073 6.073 0 0 0 0 17.143v31.884h52.339V17.143Zm-6.791.506H6.578v24.8h38.97v-24.8Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M46.266 63.198a6.073 6.073 0 0 0 6.073-6.073v-8.098H0v8.098a6.073 6.073 0 0 0 6.073 6.073h40.193Zm-20.202-9.363a2.277 2.277 0 0 1 .107 4.553l-.107.002H8.604a2.277 2.277 0 0 1-.108-4.552l.108-.003h17.46Zm15.689-1.265a3.543 3.543 0 1 1 0 7.085 3.543 3.543 0 0 1 0-7.085Z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("fvKpA", function(module, exports) {

$parcel$export(module.exports, "TrelloLabels", function () { return $efb6500bc7373d54$export$e1b5a7219182e12d; });

var $loA2J = parcelRequire("loA2J");
const $efb6500bc7373d54$export$e1b5a7219182e12d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.084 13.613a2.796 2.796 0 0 0 .131-5.589l-.131-.003H11.49a2.796 2.796 0 0 0-.131 5.59l.131.002zM31.375 13.613a2.796 2.796 0 0 0 .131-5.589l-.131-.003h-5.593a2.796 2.796 0 0 0-.131 5.59l.131.002zM45.666 13.613a2.796 2.796 0 0 0 .131-5.589l-.131-.003h-5.593a2.796 2.796 0 0 0-.131 5.59l.131.002z",
                opacity: ".5"
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M64.927 8.332v39.146h-64V8.332A7.456 7.456 0 0 1 8.385.876h49.087a7.456 7.456 0 0 1 7.456 7.456zM19.88 10.818a2.796 2.796 0 0 1-2.796 2.796H11.49l-.132-.003a2.796 2.796 0 0 1 .132-5.59h5.592l.132.004a2.796 2.796 0 0 1 2.664 2.793zm11.495 2.796a2.796 2.796 0 0 0 .132-5.59l-.132-.003h-5.592a2.796 2.796 0 0 0-.132 5.59l.132.003zm17.087-2.796a2.796 2.796 0 0 1-2.796 2.796h-5.592l-.132-.003a2.796 2.796 0 0 1 .132-5.59h5.592l.132.004a2.796 2.796 0 0 1 2.664 2.793z"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M57.47 64.876a7.456 7.456 0 0 0 7.457-7.456v-9.942h-64v9.942a7.456 7.456 0 0 0 7.457 7.456zM32.929 53.381a2.796 2.796 0 0 1 .131 5.59l-.131.003H11.49a2.796 2.796 0 0 1-.132-5.59l.132-.003zm19.261-1.553a4.35 4.35 0 1 1 0 8.699 4.35 4.35 0 0 1 0-8.699z",
                        opacity: ".5"
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("3cPV3", function(module, exports) {

$parcel$export(module.exports, "TrelloWorkspaces", function () { return $8bbe75ffb737e451$export$ad85ee75e3c446b7; });

var $loA2J = parcelRequire("loA2J");
const $8bbe75ffb737e451$export$ad85ee75e3c446b7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 65 65",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                fillRule: "evenodd",
                opacity: ".5",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M28.467 20.96a7.456 7.456 0 0 1-7.456 7.456H7.962A7.456 7.456 0 0 1 .506 20.96V7.91A7.456 7.456 0 0 1 7.962.455h13.049a7.456 7.456 0 0 1 7.456 7.456zM28.467 56.999a7.456 7.456 0 0 1-7.456 7.456H7.962A7.456 7.456 0 0 1 .506 57V43.95a7.456 7.456 0 0 1 7.456-7.456h13.049a7.456 7.456 0 0 1 7.456 7.456zM64.506 20.96a7.456 7.456 0 0 1-7.456 7.456H44a7.456 7.456 0 0 1-7.456-7.456V7.91A7.456 7.456 0 0 1 44 .455H57.05a7.456 7.456 0 0 1 7.456 7.456z"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.767 6.046a2.796 2.796 0 0 1 .132 5.59l-.132.002H9.204a2.796 2.796 0 0 1-.131-5.59l.131-.002zM14.486 16.61a2.796 2.796 0 0 1 .131 5.59l-.131.003H9.204a2.796 2.796 0 0 1-.131-5.59l.131-.003zM19.767 42.086a2.796 2.796 0 0 1 .132 5.59l-.132.002H9.204a2.796 2.796 0 0 1-.131-5.589l.131-.003zM14.486 52.65a2.796 2.796 0 0 1 .131 5.589l-.131.003H9.204a2.796 2.796 0 0 1-.131-5.59l.131-.003zM55.806 6.046a2.796 2.796 0 0 1 .132 5.59l-.132.002H45.243a2.796 2.796 0 0 1-.131-5.59l.131-.002zM50.525 16.61a2.796 2.796 0 0 1 .132 5.59l-.132.003h-5.282a2.796 2.796 0 0 1-.131-5.59l.131-.003z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M64.506 56.999a7.456 7.456 0 0 1-7.456 7.456H44A7.456 7.456 0 0 1 36.545 57V43.95A7.456 7.456 0 0 1 44 36.494H57.05a7.456 7.456 0 0 1 7.456 7.456zm-8.7-9.01a2.796 2.796 0 0 1 .133 5.59l-.132.003h-2.485v2.485a2.796 2.796 0 0 1-5.59.132l-.003-.132v-2.485h-2.485a2.796 2.796 0 0 1-.132-5.59l.132-.003h2.485v-2.485a2.796 2.796 0 0 1 5.59-.132l.003.132v2.485z"
            })
        ]
    });
};

});


parcelRegister("8O9uA", function(module, exports) {
$parcel$export(module.exports, "AddOn", function () { return (parcelRequire("7yLBx")).AddOn; });
$parcel$export(module.exports, "Automation", function () { return (parcelRequire("g7ayi")).Automation; });
$parcel$export(module.exports, "BoardDuplicate", function () { return (parcelRequire("ajBeJ")).BoardDuplicate; });
$parcel$export(module.exports, "ButlerAutomationHead", function () { return (parcelRequire("2WzfD")).ButlerAutomationHead; });
$parcel$export(module.exports, "RocketInclined", function () { return (parcelRequire("8PI5q")).RocketInclined; });
$parcel$export(module.exports, "Socket", function () { return (parcelRequire("b8WVW")).Socket; });
$parcel$export(module.exports, "Tray", function () { return (parcelRequire("fIdSO")).Tray; });
$parcel$export(module.exports, "TrelloCalendar", function () { return (parcelRequire("0cwmv")).TrelloCalendar; });
$parcel$export(module.exports, "ViewCalendar", function () { return (parcelRequire("4J4wN")).ViewCalendar; });
$parcel$export(module.exports, "ViewTimeline", function () { return (parcelRequire("ak4q3")).ViewTimeline; });
parcelRequire("7yLBx");
parcelRequire("g7ayi");
parcelRequire("ajBeJ");
parcelRequire("2WzfD");
parcelRequire("8PI5q");
parcelRequire("b8WVW");
parcelRequire("fIdSO");
parcelRequire("0cwmv");
parcelRequire("4J4wN");
parcelRequire("ak4q3");

});
parcelRegister("7yLBx", function(module, exports) {

$parcel$export(module.exports, "AddOn", function () { return $4849ee4ab1f3b13b$export$ac78e3ab94d5a7cf; });

var $loA2J = parcelRequire("loA2J");
const $4849ee4ab1f3b13b$export$ac78e3ab94d5a7cf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            fillRule: "evenodd",
            d: "M38 16.125L24 7.375L10 16.125V31.875L24 40.625L38 31.875V16.125ZM24 29C26.7614 29 29 26.7614 29 24C29 21.2386 26.7614 19 24 19C21.2386 19 19 21.2386 19 24C19 26.7614 21.2386 29 24 29Z"
        })
    });
};

});

parcelRegister("g7ayi", function(module, exports) {

$parcel$export(module.exports, "Automation", function () { return $b2e5aefce5834c06$export$132a1e91790bf469; });

var $loA2J = parcelRequire("loA2J");
const $b2e5aefce5834c06$export$132a1e91790bf469 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M11 28L27 6V20H37L21 42V28H11Z"
        })
    });
};

});

parcelRegister("ajBeJ", function(module, exports) {

$parcel$export(module.exports, "BoardDuplicate", function () { return $2ad560736a81a167$export$c2f1c2fcb8c5e49d; });

var $loA2J = parcelRequire("loA2J");
const $2ad560736a81a167$export$c2f1c2fcb8c5e49d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11 11H20.5V33H11V11Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.5 33V11H33V33H23.5Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36 20V36H20V40H40V20H36Z"
            })
        ]
    });
};

});

parcelRegister("2WzfD", function(module, exports) {

$parcel$export(module.exports, "ButlerAutomationHead", function () { return $43a0a68cd71e06be$export$d7c108e932d0f94f; });

var $loA2J = parcelRequire("loA2J");
const $43a0a68cd71e06be$export$d7c108e932d0f94f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        fillRule: "evenodd",
        "aria-hidden": "true",
        viewBox: "0 0 14 15",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M14 12.66a1.925 1.925 0 0 1-1.925 1.925H1.925A1.925 1.925 0 0 1 0 12.659V6.848c0-1.063.862-1.925 1.925-1.925h10.15c1.063 0 1.925.862 1.925 1.925v5.811ZM5.931 9.768a1.308 1.308 0 1 1-2.615 0 1.308 1.308 0 0 1 2.615 0Zm3.462 1.307a1.308 1.308 0 1 0 0-2.615 1.308 1.308 0 0 0 0 2.615Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7 0a1.884 1.884 0 0 0-.692 3.637V4.955a.692.692 0 0 0 1.384-.033V3.637A1.885 1.885 0 0 0 7 0Zm.01 2.384a.5.5 0 1 0-.02-1 .5.5 0 0 0 .02 1Z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("8PI5q", function(module, exports) {

$parcel$export(module.exports, "RocketInclined", function () { return $323ba55a51409cc6$export$835896da903516c5; });

var $loA2J = parcelRequire("loA2J");
const $323ba55a51409cc6$export$835896da903516c5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 91 91",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.06 81.71c-.312 1.371-2.011 1.861-3.006.867L8.09 68.615c-.994-.994-.504-2.694.867-3.006l8.853-2.02 9.27 9.268-2.02 8.853ZM69.42 47.785l7.4-29.61c.654-2.618-1.718-4.99-4.336-4.335l-29.61 7.405 26.545 26.54Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "m69.42 47.786-26.546-26.54-28.646 28.65a7.15 7.15 0 0 0 0 10.112l16.433 16.43a7.15 7.15 0 0 0 10.111 0L69.42 47.785ZM34.661 61.962a5.958 5.958 0 1 0 0-11.916 5.958 5.958 0 0 0 0 11.916Zm18.175-18.177a5.958 5.958 0 1 1-11.916 0 5.958 5.958 0 0 1 11.916 0Z",
                opacity: ".5"
            })
        ]
    });
};

});

parcelRegister("b8WVW", function(module, exports) {

$parcel$export(module.exports, "Socket", function () { return $1875914202b927c9$export$4798917dbf149b79; });

var $loA2J = parcelRequire("loA2J");
const $1875914202b927c9$export$4798917dbf149b79 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21 18H27V10H31V18H35V26L29 31V33H19V31L13 26V18H17V10H21V18Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29 36H19V40H29V36Z"
            })
        ]
    });
};

});

parcelRegister("fIdSO", function(module, exports) {

$parcel$export(module.exports, "Tray", function () { return $0350692bcfad8bb4$export$4589ed81930b555c; });

var $loA2J = parcelRequire("loA2J");
const $0350692bcfad8bb4$export$4589ed81930b555c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31 21L17 21L17 17L31 17V21Z"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                d: "M10 10V38H38V10H10ZM34 14H14V24H18C18 27.3137 20.6863 30 24 30C27.3137 30 30 27.3137 30 24H34V14Z"
            })
        ]
    });
};

});

parcelRegister("0cwmv", function(module, exports) {

$parcel$export(module.exports, "TrelloCalendar", function () { return $5ef1674b33616e65$export$f7c16fd7cf3dac0c; });

var $loA2J = parcelRequire("loA2J");
const $5ef1674b33616e65$export$f7c16fd7cf3dac0c = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 48 48",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M21 11H27V8H31V11H38V39H10V11H17V8H21V11ZM21 15V18H17V15H14V22H34V15H31V18H27V15H21Z"
        })
    });
};

});

parcelRegister("4J4wN", function(module, exports) {

$parcel$export(module.exports, "ViewCalendar", function () { return $af15f6ce87b2a45c$export$12ae82a8013eabea; });

var $loA2J = parcelRequire("loA2J");
const $af15f6ce87b2a45c$export$12ae82a8013eabea = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M6.66 6.667h18.68A2.66 2.66 0 0 1 28 9.325v16.016A2.659 2.659 0 0 1 25.34 28H6.66A2.66 2.66 0 0 1 4 25.341V9.325a2.659 2.659 0 0 1 2.66-2.658ZM6.667 12v12A1.333 1.333 0 0 0 8 25.333h16A1.333 1.333 0 0 0 25.333 24V12H6.667ZM8 5.333a1.333 1.333 0 0 1 2.667 0v1.334H8V5.333Zm13.333 0a1.333 1.333 0 0 1 2.667 0v1.334h-2.667V5.333Zm-12 12v-2.668H12v2.668H9.333Zm10.667 0v-2.668h2.667v2.668H20Zm-5.333 0v-2.668h2.668v2.668h-2.668Zm-5.334 5.334V20H12v2.667H9.333Zm5.334 0V20h2.668v2.667h-2.668Zm5.333 0V20h2.667v2.667H20Z"
        })
    });
};

});

parcelRegister("ak4q3", function(module, exports) {

$parcel$export(module.exports, "ViewTimeline", function () { return $8ec82aa4501741f4$export$226ad356dba437ae; });

var $loA2J = parcelRequire("loA2J");
const $8ec82aa4501741f4$export$226ad356dba437ae = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        fill: "currentColor",
        "aria-hidden": "true",
        viewBox: "0 0 32 32",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "M6 5.333h9.333a3.333 3.333 0 0 1 0 6.667H6a3.333 3.333 0 0 1 0-6.667Zm9.333 4a.667.667 0 0 0 0-1.333H6a.667.667 0 0 0 0 1.333h9.333Zm-6.666 4H18A3.333 3.333 0 1 1 18 20H8.667a3.333 3.333 0 0 1 0-6.667Zm9.333 4A.667.667 0 0 0 18 16H8.667a.667.667 0 0 0 0 1.333H18Zm6.667 4h-9.334a3.333 3.333 0 1 0 0 6.667h9.334a3.333 3.333 0 0 0 0-6.667Zm-9.334 4a.667.667 0 0 1 0-1.333h9.334a.667.667 0 1 1 0 1.333h-9.334Zm8-20H26A3.333 3.333 0 1 1 26 12h-2.667a3.333 3.333 0 1 1 0-6.667Zm2.667 4A.667.667 0 1 0 26 8h-2.667a.667.667 0 1 0 0 1.333H26Z"
        })
    });
};

});




parcelRegister("98nMD", function(module, exports) {

$parcel$export(module.exports, "UiImage", function () { return (parcelRequire("aj3L4")).default; });

var $aj3L4 = parcelRequire("aj3L4");

});
parcelRegister("aj3L4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e61eb72cb27e7775$export$2e2bcd8739ae039; });
/* UiImage.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
parcelRequire("dg5xP");
var $41Ir1 = parcelRequire("41Ir1");
const $e61eb72cb27e7775$var$UiImage = ({ model: { content: { image: image, altText: altText, decorative: decorative } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($e61eb72cb27e7775$var$StyledImage, {
        image: image,
        altText: altText,
        decorative: decorative
    });
};
const $e61eb72cb27e7775$var$StyledImage = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = (0, $41Ir1.Picture), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_19pkidpf _2hwxidpf _otyr1j6v _18u0idpf",
            __cmplp.className
        ])
    });
});
var $e61eb72cb27e7775$export$2e2bcd8739ae039 = $e61eb72cb27e7775$var$UiImage;

});


parcelRegister("kk7um", function(module, exports) {

$parcel$export(module.exports, "UiImageSet", function () { return (parcelRequire("iuY7Y")).default; });

var $iuY7Y = parcelRequire("iuY7Y");

});
parcelRegister("iuY7Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0709a5785eada87a$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $33PqJ = parcelRequire("33PqJ");

var $iKUf1 = parcelRequire("iKUf1");
const $0709a5785eada87a$var$UiImageSet = ({ model: { content: { images: images, justified: justified } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iKUf1.List), {
        justified: justified,
        children: images.map((image, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                children: (0, $33PqJ.renderViewModel)(image)
            }, `${image.id}_${index}`))
    });
};
var $0709a5785eada87a$export$2e2bcd8739ae039 = $0709a5785eada87a$var$UiImageSet;

});
parcelRegister("iKUf1", function(module, exports) {

$parcel$export(module.exports, "List", function () { return $2bc3a7343beb60d4$export$54c2e3dc7acea9f5; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $2bc3a7343beb60d4$export$54c2e3dc7acea9f5 = (0, $hYbro.styled).ul`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
    ${(0, $jAJVK.redundantCssFromKebab)("list-style-type", "none")}

    li {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem 1rem")}

        img {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "auto")}
        }
    }

    ${({ justified: justified })=>justified ? `
        justify-content: space-between;
        margin: 0 -1rem; 
        padding: 1rem 0;
      ` : `
        justify-content: center;
        margin: 0;
        padding: 1rem;
    `}
`;

});



parcelRegister("84a3c", function(module, exports) {

$parcel$export(module.exports, "UiIntegration", function () { return (parcelRequire("i3M2D")).default; });

var $i3M2D = parcelRequire("i3M2D");

});
parcelRegister("i3M2D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $274ec0446317bfa1$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $41Ir1 = parcelRequire("41Ir1");
var $82f25 = parcelRequire("82f25");

var $iwtuw = parcelRequire("iwtuw");
const $274ec0446317bfa1$var$UiIntegration = ({ model: { id: id, content: { entryTitle: entryTitle, title: title, description: description, featuredImage: featuredImage, logo: logo, buttonUrl: buttonUrl, buttonText: buttonText } }, featured: featured, ...rest })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const titleId = `integration_title_${id}`;
    const buttonId = `integration_btn_${id}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iwtuw.Integration), {
        ...rest,
        children: [
            featured && /*#__PURE__*/ (0, $loA2J.jsx)((0, $iwtuw.FeaturedImage), {
                url: featuredImage?.url
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iwtuw.Content), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iwtuw.LogoTitle), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $41Ir1.Picture), {
                                image: logo,
                                decorative: true
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                id: titleId,
                                children: title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iwtuw.Description), {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iwtuw.ButtonWrapper), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                            url: buttonUrl,
                            id: buttonId,
                            appearance: "Secondary",
                            "aria-labelledby": buttonId + " " + titleId,
                            style: "Outline",
                            onClick: ()=>sendTrackEvent("clickedIntegration", {
                                    eventContainer: "UiIntegrationGrid",
                                    event: "clicked",
                                    eventComponent: "button",
                                    label: buttonText,
                                    labelEnglish: "Integration Button",
                                    parentLabel: entryTitle,
                                    uuid: id,
                                    href: buttonUrl
                                }),
                            "data-uuid": id,
                            testId: "integration-button",
                            children: buttonText
                        })
                    })
                ]
            })
        ]
    });
};
var $274ec0446317bfa1$export$2e2bcd8739ae039 = $274ec0446317bfa1$var$UiIntegration;

});
parcelRegister("iwtuw", function(module, exports) {

$parcel$export(module.exports, "Integration", function () { return $74eeed92c72c976d$export$8912007324034abd; });
$parcel$export(module.exports, "Content", function () { return $74eeed92c72c976d$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "LogoTitle", function () { return $74eeed92c72c976d$export$b47bb6ac12baa207; });
$parcel$export(module.exports, "Description", function () { return $74eeed92c72c976d$export$393edc798c47379d; });
$parcel$export(module.exports, "ButtonWrapper", function () { return $74eeed92c72c976d$export$d53c836cccbb0d90; });
$parcel$export(module.exports, "FeaturedImage", function () { return $74eeed92c72c976d$export$f45d89e981ef6c69; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $a7xVp = parcelRequire("a7xVp");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $74eeed92c72c976d$export$8912007324034abd = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N10")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow)["normal"]}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $74eeed92c72c976d$export$7c6e2c02157bb7d2 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-grow", "1")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
`;
const $74eeed92c72c976d$export$b47bb6ac12baa207 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "start")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}

    img,
    picture {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("min-width", "2.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "2.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    }

    h3 {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.25rem 0 0")}
    }
`;
const $74eeed92c72c976d$export$393edc798c47379d = (0, $hYbro.styled).p`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
`;
const $74eeed92c72c976d$export$d53c836cccbb0d90 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "auto")}
`;
const $74eeed92c72c976d$export$f45d89e981ef6c69 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button} ${(0, $fpcku.radius).button} 0 0`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "92.7203%")}
    ${({ url: url })=>url ? `
    background-image: url(${url});
    background-size: cover;
  ` : `
    background-color: ${(0, $i2LPb.colorCSS)("N50")};
  `}
`;

});



parcelRegister("5gfhl", function(module, exports) {

$parcel$export(module.exports, "UiIntegrationSection", function () { return (parcelRequire("bwS4k")).default; });

var $bwS4k = parcelRequire("bwS4k");

});
parcelRegister("bwS4k", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e02f027d28c872b0$export$2e2bcd8739ae039; });
// @ts-nocheck
/* eslint-disable complexity, react-hooks/exhaustive-deps, local/no-objects-in-deps-list */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $dRxyd = parcelRequire("dRxyd");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $5atKW = parcelRequire("5atKW");
var $1pYrM = parcelRequire("1pYrM");
var $kzY5l = parcelRequire("kzY5l");
var $5l0yg = parcelRequire("5l0yg");
var $69DYH = parcelRequire("69DYH");
var $dWr7M = parcelRequire("dWr7M");
var $82f25 = parcelRequire("82f25");

var $4iWIP = parcelRequire("4iWIP");
parcelRequire("h6yBX");
var $6IIwI = parcelRequire("6IIwI");
parcelRequire("84a3c");
var $i3M2D = parcelRequire("i3M2D");

var $aAnju = parcelRequire("aAnju");

var $hoYED = parcelRequire("hoYED");

var $8PXXb = parcelRequire("8PXXb");
// Helper function to build categories list
const $e02f027d28c872b0$var$buildCategories = (allIntegrations, defaultCategory)=>{
    const categories = [
        defaultCategory
    ];
    allIntegrations.filter(({ type: type })=>type === "uiIntegration").forEach((integration)=>{
        integration.content.categories?.filter(({ type: type })=>type === "integrationCategory").forEach((category)=>{
            if (!categories.find((c)=>c.id === category.id)) categories.push({
                title: category.content.title,
                id: category.id,
                path: category.content.route?.content.path ?? "",
                entryTitle: category.content.entryTitle
            });
        });
    });
    categories.sort((a, b)=>b.id === defaultCategory.id ? 1 : a.title.localeCompare(b.title));
    return categories;
};
// Helper function to filter integrations
const $e02f027d28c872b0$var$filterIntegrations = (integrations, categoryId, searchTerm, viewingAll)=>{
    return integrations.filter((integration)=>{
        const categories = integration.content.categories?.filter(({ type: type })=>type === "integrationCategory").map((category)=>category.id) ?? [];
        return viewingAll || categories.includes(categoryId);
    }).filter((integration)=>{
        if (!searchTerm) return true;
        const needle = searchTerm.toLowerCase().trim().replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const haystack = [
            integration.content.title,
            integration.content.description
        ].join(" ").toLowerCase();
        return haystack.search(needle) !== -1;
    });
};
const $e02f027d28c872b0$var$UiIntegrationSection = ({ model: model, currentPath: currentPath, readMoreLimit: readMoreLimit = 24, randomize: randomize = true })=>{
    const routeFromHook = (0, $5atKW.useRoute)();
    const route = currentPath || routeFromHook;
    const [limited, setLimited] = (0, $iSvIT.useState)(true);
    const [mobileNavOpen, setMobileNavOpen] = (0, $iSvIT.useState)(false);
    const breakpoints = (0, $1pYrM.useBreakpoints)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const sectionRef = (0, $iSvIT.useRef)(null);
    const searchAnalytics = (0, $iSvIT.useRef)(null);
    // Initialize with published integrations so cards render immediately on SSR
    // and on first client paint (no empty → populated flicker).
    // useEffect below re-runs to shuffle if randomize=true.
    // Use model.content.allIntegrations directly — the destructured binding
    // is declared later in this function scope (temporal dead zone issue).
    const [shuffledIntegrations, setShuffledIntegrations] = (0, $iSvIT.useState)(()=>model.content.allIntegrations.filter(({ type: type })=>type === "uiIntegration"));
    const ANIMATION_CONTAINER_TIME = 600;
    const { searchLabel: searchLabel, featuredIntegrations: featuredIntegrations, featuredIntegrationsTitle: featuredIntegrationsTitle, filterByText: filterByText, allIntegrations: allIntegrations, allIntegrationsTitle: allIntegrationsTitle, allIntegrationsRoute: allIntegrationsRoute, viewAllButtonText: viewAllButtonText, viewLessButtonText: viewLessButtonText, searchResultsHeading: searchResultsHeading, noSearchResults: noSearchResults } = model.content;
    (0, $iSvIT.useEffect)(()=>{
        //filter out any deleted integrations
        const publishedIntegrations = allIntegrations.filter(({ type: type })=>type === "uiIntegration");
        setShuffledIntegrations(randomize ? (0, $dRxyd.shuffle)(publishedIntegrations) : publishedIntegrations);
        return ()=>{
            if (searchAnalytics.current) clearTimeout(searchAnalytics.current);
        };
    }, [
        allIntegrations,
        randomize
    ]);
    //start list of categories
    const defaultCategory = {
        title: allIntegrationsTitle,
        id: "",
        path: allIntegrationsRoute.content.path,
        entryTitle: "All integrations"
    };
    const categories = $e02f027d28c872b0$var$buildCategories(allIntegrations, defaultCategory);
    //determine current category
    const [filter, setFilter] = (0, $iSvIT.useState)({
        category: categories.find((category)=>category.path === route) ?? defaultCategory,
        search: ""
    });
    const viewingAll = filter.category.id === defaultCategory.id;
    //when filter changes…
    (0, $iSvIT.useEffect)(()=>{
        //update URL when category changes
        if (!$e02f027d28c872b0$var$languageUrls(filter.category.path).includes(location.pathname)) history.pushState(null, document.title, filter.category.path);
        //scroll to top when searching
        if (filter.search || filter.category !== defaultCategory) {
            if (window && sectionRef.current) {
                const sectionTop = sectionRef.current.getBoundingClientRect().top;
                const top = window.pageYOffset + sectionTop - (breakpoints.includes("lg") ? (0, $6IIwI.BIG_NAV_PX_HEIGHT) : (0, $6IIwI.SMALL_NAV_PX_HEIGHT) + (0, $6IIwI.SUB_NAV_PX_HEIGHT));
                window.scrollTo({
                    top: top,
                    behavior: "smooth"
                });
            }
        }
        //wait 2s and fire search analytics
        if (searchAnalytics.current) clearTimeout(searchAnalytics.current);
        if (filter.search) searchAnalytics.current = setTimeout(()=>{
            sendTrackEvent("searchedIntegrations", {
                event: "searched",
                eventComponent: model.type,
                eventContainer: "content",
                label: searchLabel,
                labelEnglish: "Search all integrations",
                uuid: model.id
            });
        }, 2000);
    }, [
        filter,
        defaultCategory,
        breakpoints,
        sendTrackEvent,
        model.type,
        model.id,
        searchLabel
    ]);
    //filter by categories and keywords
    const filteredIntegrations = $e02f027d28c872b0$var$filterIntegrations(shuffledIntegrations, filter.category.id, filter.search, viewingAll);
    //limit list
    const canBeLimited = filteredIntegrations.length > readMoreLimit;
    const integrations = canBeLimited && limited ? filteredIntegrations.slice(0, readMoreLimit) : filteredIntegrations;
    const toggleViewAll = (wasLimited)=>{
        setLimited(!wasLimited);
        if (wasLimited) // A11Y: When new content is manually loaded, reset focus to first new item
        setTimeout(()=>{
            document.querySelector("[data-focused-integration]")?.querySelector("a")?.focus();
        }, ANIMATION_CONTAINER_TIME);
    };
    //we have two versions of the nav (desktop in the sidebar, mobile in a fixed nav)
    const navOptions = {
        categories: categories,
        defaultCategory: defaultCategory,
        filter: filter,
        model: model,
        searchLabel: searchLabel,
        setFilter: setFilter,
        closeMobileNav: ()=>{
            if (mobileNavOpen) setMobileNavOpen(false);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8PXXb.Section), {
        "data-testid": "integration-section",
        ref: sectionRef,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $hoYED.default), {
                isOpen: mobileNavOpen,
                setIsOpen: setMobileNavOpen,
                buttonTestId: "integration-menu-button",
                title: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        filterByText,
                        " ",
                        /*#__PURE__*/ (0, $loA2J.jsx)("strong", {
                            children: filter.category.title
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aAnju.default), {
                    isMobile: true,
                    ...navOptions
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                            xs: {
                                span: "0"
                            },
                            lg: {
                                align: "left",
                                span: "3"
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aAnju.default), {
                                isMobile: false,
                                ...navOptions
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Column), {
                            xs: {
                                align: "left"
                            },
                            lg: {
                                span: "9"
                            },
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                                    show: !!featuredIntegrations && viewingAll && !filter.search,
                                    time: 500,
                                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8PXXb.Featured), {
                                        children: [
                                            featuredIntegrationsTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                                                className: "h4",
                                                children: featuredIntegrationsTitle
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                                                children: featuredIntegrations?.filter(({ type: type })=>type === "uiIntegration").map((featuredIntegration, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                                        sm: {
                                                            span: "6"
                                                        },
                                                        lg: {
                                                            span: "4"
                                                        },
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $i3M2D.default), {
                                                            featured: true,
                                                            model: featuredIntegration
                                                        })
                                                    }, index))
                                            })
                                        ]
                                    })
                                }),
                                !!shuffledIntegrations.length && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                                    children: [
                                        filter.category && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            role: "status",
                                            children: /*#__PURE__*/ (0, $loA2J.jsxs)("h2", {
                                                className: "h4",
                                                children: [
                                                    filter.search.length ? searchResultsHeading : filter.category.title,
                                                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                        children: filteredIntegrations.length
                                                    })
                                                ]
                                            })
                                        }),
                                        !!filter.search.length && !integrations.length && noSearchResults ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                            className: "noSearchResults",
                                            document: noSearchResults
                                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PXXb.Grid), {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dWr7M.AnimatedContainer), {
                                                time: ANIMATION_CONTAINER_TIME,
                                                children: integrations.map((integration, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $i3M2D.default), {
                                                        model: integration,
                                                        "data-focused-integration": index === readMoreLimit ? true : undefined
                                                    }, integration.id))
                                            })
                                        }),
                                        canBeLimited && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8PXXb.More), {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                                                appearance: "Primary",
                                                onClick: ()=>toggleViewAll(limited),
                                                testId: "toggle-view-all",
                                                children: limited ? viewAllButtonText : viewLessButtonText
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
function $e02f027d28c872b0$var$languageUrls(url) {
    return [
        url,
        ...(0, $4iWIP.LANGUAGES).map((language)=>`/${language.code}${url}`)
    ];
}
var $e02f027d28c872b0$export$2e2bcd8739ae039 = $e02f027d28c872b0$var$UiIntegrationSection;

});
parcelRegister("aAnju", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c17b752dc038fcb7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $69DYH = parcelRequire("69DYH");

var $eMlUq = parcelRequire("eMlUq");
const $c17b752dc038fcb7$var$Navigation = ({ categories: categories, closeMobileNav: closeMobileNav, defaultCategory: defaultCategory, filter: filter, isMobile: isMobile, model: { content: { searchLabel: searchLabel, filterByText: filterByText, ctaText: ctaText } }, setFilter: setFilter })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eMlUq.MenuInner), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("form", {
                action: "",
                onSubmit: (e)=>{
                    e.preventDefault();
                    closeMobileNav();
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.SearchInput), {
                    "aria-label": searchLabel,
                    name: searchLabel,
                    onChange: (e)=>setFilter({
                            category: defaultCategory,
                            search: e.target.value
                        }),
                    placeholder: searchLabel,
                    type: "search",
                    value: filter.search
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                show: !filter.search || !isMobile,
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("fieldset", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("legend", {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.FilterByHeading), {
                                        children: filterByText
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.CategoryList), {
                                    children: categories.map((category, index)=>{
                                        const isActiveCategory = filter.category.id === category.id;
                                        return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.CategoryListItem), {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.CategoryListItemLink), {
                                                href: category.path,
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    setFilter({
                                                        category: category,
                                                        search: ""
                                                    });
                                                    closeMobileNav();
                                                    sendTrackEvent("clickedIntegrationCategory", {
                                                        eventContainer: "UiIntegrationSection",
                                                        event: "clicked",
                                                        eventComponent: "link",
                                                        label: category.title,
                                                        labelEnglish: category.entryTitle,
                                                        uuid: category.id,
                                                        href: category.path
                                                    });
                                                },
                                                "data-uuid": category.id,
                                                "data-testid": "integration-category",
                                                className: isActiveCategory ? "active" : undefined,
                                                "aria-current": isActiveCategory ? "page" : false,
                                                children: category.title
                                            })
                                        }, `category-${index}`);
                                    })
                                })
                            ]
                        }),
                        ctaText && /*#__PURE__*/ (0, $loA2J.jsx)((0, $eMlUq.CtaText), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                document: ctaText
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var $c17b752dc038fcb7$export$2e2bcd8739ae039 = $c17b752dc038fcb7$var$Navigation;

});
parcelRegister("eMlUq", function(module, exports) {

$parcel$export(module.exports, "SearchInput", function () { return $768f646daed9c2ec$export$55d7609a8f1eccd2; });
$parcel$export(module.exports, "MenuInner", function () { return $768f646daed9c2ec$export$2b898aa2b465b417; });
$parcel$export(module.exports, "FilterByHeading", function () { return $768f646daed9c2ec$export$2b3802314f6b4162; });
$parcel$export(module.exports, "CtaText", function () { return $768f646daed9c2ec$export$46516fa7db6d8364; });
$parcel$export(module.exports, "CategoryList", function () { return $768f646daed9c2ec$export$79717968ed9ae6cd; });
$parcel$export(module.exports, "CategoryListItem", function () { return $768f646daed9c2ec$export$df71c001773f5d16; });
$parcel$export(module.exports, "CategoryListItemLink", function () { return $768f646daed9c2ec$export$5c2f8b9415d07032; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
const $768f646daed9c2ec$export$55d7609a8f1eccd2 = (0, $hYbro.styled).input`
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N100")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1rem 0.5rem 0.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    &[type="search"] {
        ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
    }
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 2px ${(0, $i2LPb.colorCSS)("N900")}`)}
    }
    &:placeholder-shown {
        ${(0, $jAJVK.redundantCssFromKebab)("background-image", 'url(\'data:image/svg+xml,%3Csvg width="20" height="20" viewBox="0 0 24 24" fill="%23aaa" xmlns="http://www.w3.org/2000/svg" %3E%3Cpath fillRule="evenodd" clipRule="evenodd" d="M16.436 15.085L20.376 19.095C20.5525 19.2858 20.6478 19.5378 20.6417 19.7976C20.6356 20.0575 20.5286 20.3047 20.3433 20.487C20.158 20.6693 19.9091 20.7722 19.6492 20.7741C19.3893 20.776 19.1389 20.6766 18.951 20.497L15.013 16.491C13.4935 17.6357 11.5959 18.1602 9.70428 17.9583C7.81266 17.7564 6.06845 16.8432 4.82482 15.4036C3.58118 13.9641 2.93106 12.1057 3.00608 10.2048C3.08111 8.30394 3.87568 6.5026 5.22891 5.16554C6.58214 3.82848 8.3929 3.05561 10.2945 3.00343C12.1962 2.95126 14.0466 3.62367 15.4711 4.88451C16.8956 6.14536 17.7878 7.90042 17.9669 9.79432C18.1461 11.6882 17.5988 13.5794 16.436 15.085ZM10.5 16C11.9587 16 13.3576 15.4206 14.3891 14.3891C15.4205 13.3577 16 11.9587 16 10.5C16 9.04134 15.4205 7.64239 14.3891 6.61094C13.3576 5.57949 11.9587 5.00003 10.5 5.00003C9.04131 5.00003 7.64236 5.57949 6.61091 6.61094C5.57946 7.64239 5 9.04134 5 10.5C5 11.9587 5.57946 13.3577 6.61091 14.3891C7.64236 15.4206 9.04131 16 10.5 16Z" /%3E%3C/svg%3E\')')}
        ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-position", "right 0.5rem center")}
    }
    &::-webkit-search-cancel-button {
        ${(0, $jAJVK.redundantCssFromKebab)("background-image", "url(data:image/png)")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-size", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "1rem")}
    }
`;
const $768f646daed9c2ec$export$2b898aa2b465b417 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1rem")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }
`;
const $768f646daed9c2ec$export$2b3802314f6b4162 = (0, $hYbro.styled).p`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N300")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}
`;
const $768f646daed9c2ec$export$46516fa7db6d8364 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 0 1rem 0.5rem")}

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

        & + p {
            ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "0.5rem")}
        }
    }
`;
const $768f646daed9c2ec$export$79717968ed9ae6cd = (0, $hYbro.styled).ul`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("list-style", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
`;
const $768f646daed9c2ec$export$df71c001773f5d16 = (0, $hYbro.styled).li`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.25rem 0")}
`;
const $768f646daed9c2ec$export$5c2f8b9415d07032 = (0, $hYbro.styled).a`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    /* https://caniuse.com/webkit-user-drag */
    ${(0, $jAJVK.redundantCssFromKebab)("-webkit-user-drag", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("user-select", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("P50")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "background-color 0.3s ease")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("P500")}`)}
    }

    &.active,
    &:focus:focus-visible {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("P50")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("P500")}`)}
    }
`;

});


parcelRegister("hoYED", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28a99513efffae2c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hGV8X = parcelRequire("hGV8X");
parcelRequire("dg5xP");
var $69DYH = parcelRequire("69DYH");

var $dZrs3 = parcelRequire("dZrs3");
const $28a99513efffae2c$var$SubNav = ({ title: title, children: children, isOpen: isOpen, setIsOpen: setIsOpen, buttonTestId: buttonTestId })=>{
    const subNav = (0, $iSvIT.useRef)(null);
    //prevent body scrolling when nav is open, close when escape pressed
    (0, $iSvIT.useEffect)(()=>{
        const escPress = (event)=>{
            if (event.key === "Escape") setIsOpen(false);
        };
        if (isOpen) {
            window.addEventListener("keydown", escPress);
            document.body.classList.add("prevent-scroll");
        }
        return ()=>{
            window.removeEventListener("keydown", escPress);
            document.body.classList.remove("prevent-scroll");
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hGV8X))), {
        active: isOpen,
        focusTrapOptions: {
            allowOutsideClick: true,
            fallbackFocus: "#skip-to-content"
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dZrs3.Shroud), {
            "data-open": isOpen,
            onClick: ()=>setIsOpen(false),
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $dZrs3.Nav), {
                "data-open": isOpen,
                onClick: (e)=>e.stopPropagation(),
                ref: subNav,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $dZrs3.Button), {
                        "data-open": isOpen,
                        "data-testid": buttonTestId,
                        onClick: ()=>setIsOpen(!isOpen),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                        show: isOpen,
                        children: children
                    })
                ]
            })
        })
    });
};
var $28a99513efffae2c$export$2e2bcd8739ae039 = $28a99513efffae2c$var$SubNav;

});
parcelRegister("dZrs3", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $d077c94b202a0137$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "Nav", function () { return $d077c94b202a0137$export$39140c7d8b0ba7b3; });
$parcel$export(module.exports, "Shroud", function () { return $d077c94b202a0137$export$566a674ebb72a490; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
var $6IIwI = parcelRequire("6IIwI");
var $a7xVp = parcelRequire("a7xVp");
var $1D7YE = parcelRequire("1D7YE");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
//margin to make room for focus outline
const $d077c94b202a0137$var$buttonMargin = 3;
const $d077c94b202a0137$export$353f5b6fc5456de1 = (0, $hYbro.styled).button`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", "transparent")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", `${(0, $6IIwI.SUB_NAV_PX_HEIGHT) - $d077c94b202a0137$var$buttonMargin * 2}px`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", `${$d077c94b202a0137$var$buttonMargin}px`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.75rem 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "calc(100% - 6px)")}
    &::after {
        ${(0, $jAJVK.redundantCssFromKebab)("background-image", 'url(\'data:image/svg+xml,%3Csvg fill="%23172b4d" height="8" viewBox="0 0 13 8" width="13" xmlns="http://www.w3.org/2000/svg" %3E%3Cpath d="m11.7305.59279c.3626.362629.3885.93447.0777 1.32699l-.0777.08722-4.99999 4.99999c-.36263.36263-.93446.38853-1.32697.0777l-.08725-.0777-4.999959-4.99997c-.3905249-.39052-.3905242-1.023685 0-1.414209.362629-.36263.934469-.388553 1.326989-.077728l.08722.077728 4.29292 4.292139 4.29284-4.29216c.3626-.36263.9345-.388532 1.327-.077707z" /%3E%3C/svg%3E\')')}
        ${(0, $jAJVK.redundantCssFromKebab)("background-position", "center center")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-size", "contain")}
        ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "-0.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("right", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("top", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "transform 0.5s ease")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "1rem")}
    }
    &[data-open="true"]::after {
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "rotateX(180deg)")}
    }
`;
const $d077c94b202a0137$export$39140c7d8b0ba7b3 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow).normal}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", `${(0, $6IIwI.SUB_NAV_PX_HEIGHT)}px`)}
    ${(0, $jAJVK.redundantCssFromKebab)("max-height", `calc(100% - ${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px)`)}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "fixed")}
    ${(0, $jAJVK.redundantCssFromKebab)("top", `${(0, $6IIwI.SMALL_NAV_PX_HEIGHT)}px`)}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("z-index", `${(0, $1D7YE.zIndex).subNav}`)}
`;
const $d077c94b202a0137$export$566a674ebb72a490 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N900", 0)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "fixed")}
    ${(0, $jAJVK.redundantCssFromKebab)("right", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("top", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "background-color 0.6s ease, height 0s linear 0.6s")}
    ${(0, $jAJVK.redundantCssFromKebab)("z-index", `${(0, $1D7YE.zIndex).subNavShroud}`)}
    &[data-open="true"] {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N900", 0.5)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "100vh")}
        ${(0, $jAJVK.redundantCssFromKebab)("transition", "background-color 0.6s ease, height 0s linear")}
        ${$d077c94b202a0137$export$39140c7d8b0ba7b3} {
            ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
        }
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }
`;

});


parcelRegister("8PXXb", function(module, exports) {

$parcel$export(module.exports, "Featured", function () { return $98150de2a31525ae$export$fdcdad4295c33f90; });
$parcel$export(module.exports, "Grid", function () { return $98150de2a31525ae$export$ef2184bd89960b14; });
$parcel$export(module.exports, "More", function () { return $98150de2a31525ae$export$d440bfe209149ca5; });
$parcel$export(module.exports, "Section", function () { return $98150de2a31525ae$export$6e2c8f0811a474ce; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
const $98150de2a31525ae$export$fdcdad4295c33f90 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "1rem")}
    }
`;
const $98150de2a31525ae$export$ef2184bd89960b14 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1400px) {
        max-width: 1320px;
    }

    > div {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "2rem")}
        @media ${(0, $aT9Ik.minWidth).sm} {
            ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "repeat(2, minmax(0, 1fr))")}
        }
        @media ${(0, $aT9Ik.minWidth).md} {
            ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "repeat(3, minmax(0, 1fr))")}
        }
    }
`;
const $98150de2a31525ae$export$d440bfe209149ca5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "3rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}
`;
const $98150de2a31525ae$export$6e2c8f0811a474ce = (0, $hYbro.styled).section`
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "2rem")}

    .noSearchResults {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "40rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}

        img {
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 3rem")}
        }

        p {
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 0.5rem")}
        }
    }

    h2 span {
        &::before {
            ${(0, $jAJVK.redundantCssFromKebab)("content", '" ("')}
        }

        &::after {
            ${(0, $jAJVK.redundantCssFromKebab)("content", '")"')}
        }
    }
`;

});



parcelRegister("43Skq", function(module, exports) {

$parcel$export(module.exports, "UiLink", function () { return (parcelRequire("eBpzU")).default; });

var $eBpzU = parcelRequire("eBpzU");

});
parcelRegister("eBpzU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ba0af59521171a7$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
const $4ba0af59521171a7$var$UiLink = ({ model: { id: id, content: { entryTitle: entryTitle, text: text, ariaLabel: ariaLabel, url: url } } })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
        href: url,
        "aria-label": ariaLabel,
        onClick: ()=>sendTrackEvent("clickedUiLink", {
                eventContainer: "content",
                ...analyticsAttributes,
                event: "clicked",
                eventComponent: "link",
                label: text,
                labelEnglish: entryTitle,
                uuid: id,
                href: url
            }),
        "data-uuid": id,
        children: text
    });
};
var $4ba0af59521171a7$export$2e2bcd8739ae039 = $4ba0af59521171a7$var$UiLink;

});


parcelRegister("cREQo", function(module, exports) {

$parcel$export(module.exports, "UiLinkBlock", function () { return (parcelRequire("cVC5c")).default; });

var $cVC5c = parcelRequire("cVC5c");

});
parcelRegister("cVC5c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27365947dcb9bf7c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $33PqJ = parcelRequire("33PqJ");

var $44blj = parcelRequire("44blj");
const $27365947dcb9bf7c$var$UiLinkBlock = ({ model: model })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { entryTitle: entryTitle, block: block, lift: lift, lighten: lighten, title: title, url: url } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $44blj.LinkBlock), {
        "data-testid": "ui-link-block",
        lift: lift,
        lighten: lighten,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
            "aria-label": title,
            "data-uuid": model.id,
            href: url,
            onClick: ()=>sendTrackEvent("clickedUiLinkBlock", {
                    event: "clicked",
                    eventComponent: "linkBlock",
                    eventContainer: "content",
                    href: url,
                    label: title,
                    labelEnglish: entryTitle,
                    uuid: model.id
                }),
            children: (0, $33PqJ.renderViewModel)(block)
        })
    });
};
var $27365947dcb9bf7c$export$2e2bcd8739ae039 = $27365947dcb9bf7c$var$UiLinkBlock;

});
parcelRegister("44blj", function(module, exports) {

$parcel$export(module.exports, "LinkBlock", function () { return $e482c9ac5a971c19$export$74bb22ad46f77c1c; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $e482c9ac5a971c19$export$74bb22ad46f77c1c = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("opacity", "1")}
    ${(0, $jAJVK.redundantCssFromKebab)("transform", "translate3d(0, 0, 0)")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "250ms ease-out")}

    > a {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    }

    &:hover,
    &:focus:focus-visible {
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", `${({ lighten: lighten })=>lighten ? 0.8 : 1}`)}
        transform: ${({ lift: lift })=>lift ? "translate3d(0, -4px, 0)" : "translate3d(0, 0, 0)"};
    }
`;

});



parcelRegister("hT6nC", function(module, exports) {

$parcel$export(module.exports, "UiListCarousel", function () { return (parcelRequire("6y9ML")).default; });

var $6y9ML = parcelRequire("6y9ML");

});
parcelRegister("6y9ML", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0796bf294a6c8742$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $j30bs = parcelRequire("j30bs");
var $1TMwu = parcelRequire("1TMwu");

var $33PqJ = parcelRequire("33PqJ");

var $eJJ6B = parcelRequire("eJJ6B");
const $0796bf294a6c8742$var$UiListCarousel = ({ model: { content: { title: title, captions: captions, autoplay: autoplay, accentColor: accentColor, hideDotsOnDesktop: hideDotsOnDesktop, orientation: orientation, dotLabel: dotLabel, prevArrowLabel: prevArrowLabel, nextArrowLabel: nextArrowLabel } } })=>{
    const [selectedIndex, setSelectedIndex] = (0, $iSvIT.useState)(0);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
        "data-testid": "list-carousel",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    span: "0",
                    top: "none",
                    bottom: "none"
                },
                lg: {
                    span: "4",
                    order: orientation === "Image left" ? "2" : "1"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eJJ6B.StackPadding), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $j30bs.Stack), {
                        spacing: "compact",
                        children: captions.filter(({ type: type })=>type === "caption").map((caption, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $eJJ6B.LinkItem), {
                                selected: index === selectedIndex,
                                accentColor: accentColor,
                                onClick: ()=>{
                                    setSelectedIndex(index);
                                    sendTrackEvent("carouselCaptionClicked", {
                                        ...analyticsAttributes,
                                        eventContainer: "uiListCarousel",
                                        event: "clicked",
                                        eventComponent: "caption",
                                        label: caption.content.title,
                                        labelEnglish: caption.content.entryTitle,
                                        parentLabel: title,
                                        uuid: caption.id
                                    });
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                    document: caption.content.caption
                                })
                            }, caption.id))
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    top: "none"
                },
                lg: {
                    span: "8",
                    top: hideDotsOnDesktop ? "compact" : undefined,
                    order: orientation === "Image left" ? "1" : "2"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1TMwu.Carousel), {
                    onChange: (index)=>setSelectedIndex(index),
                    selectedIndex: selectedIndex,
                    dotsOnDesktop: !hideDotsOnDesktop,
                    dotsOnMobile: false,
                    initialAutoplay: autoplay,
                    dotLabel: dotLabel,
                    prevArrowLabel: prevArrowLabel,
                    nextArrowLabel: nextArrowLabel,
                    controlsAlignStart: orientation === "Image left",
                    children: captions.filter(({ type: type })=>type === "caption").map((caption)=>(0, $33PqJ.renderViewModel)(caption.content.content))
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    top: "none",
                    bottom: "none"
                },
                lg: {
                    span: "0"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1TMwu.Carousel), {
                    onChange: (index)=>setSelectedIndex(index),
                    selectedIndex: selectedIndex,
                    dotsOnDesktop: false,
                    dotsOnMobile: true,
                    dotLabel: dotLabel,
                    prevArrowLabel: prevArrowLabel,
                    nextArrowLabel: nextArrowLabel,
                    children: captions.filter(({ type: type })=>type === "caption").map((caption)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $eJJ6B.LinkItem), {
                            selected: true,
                            accentColor: accentColor,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                document: caption.content.caption
                            })
                        }, caption.id))
                })
            })
        ]
    });
};
var $0796bf294a6c8742$export$2e2bcd8739ae039 = $0796bf294a6c8742$var$UiListCarousel;

});
parcelRegister("eJJ6B", function(module, exports) {

$parcel$export(module.exports, "LinkItem", function () { return $92c76227e2d77b89$export$532cb6865ebe8946; });
$parcel$export(module.exports, "StackPadding", function () { return $92c76227e2d77b89$export$3555d0c8c15e0d82; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $54E1V = parcelRequire("54E1V");
var $a7xVp = parcelRequire("a7xVp");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $92c76227e2d77b89$export$532cb6865ebe8946 = (0, $hYbro.styled).button({
    "borderRadius": (0, $fpcku.radius).button,
    "border": 0,
    "height": "100%",
    "padding": "1rem",
    "position": "relative",
    "textAlign": "left",
    "h1, h2, h3, p": {
        fontSize: (0, $kL1mL.fontSizes).sm
    },
    "*:last-child": {
        marginBottom: 0
    },
    "> div": {
        height: "100%"
    }
}, ({ selected: selected })=>selected ? {
        ...(0, $54E1V.cssColorsFromBackgroundField)({
            color: "N0"
        }),
        boxShadow: (0, $a7xVp.shadow).normal
    } : {
        backgroundColor: "transparent",
        color: "inherit"
    }, ({ selected: selected, accentColor: accentColor })=>selected && accentColor && {
        "&:after": {
            backgroundColor: (0, $i2LPb.colorCSS)(accentColor === "Magenta" ? "M100" : `${accentColor.substring(0, 1)}200`),
            borderRadius: `${(0, $fpcku.radius).button} 0 0 ${(0, $fpcku.radius).button}`,
            bottom: 0,
            content: '""',
            left: 0,
            position: "absolute",
            top: 0,
            width: "0.5rem"
        }
    }, ({ accentColor: accentColor })=>accentColor && {
        paddingLeft: "1.5rem"
    });
const $92c76227e2d77b89$export$3555d0c8c15e0d82 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 0")}
`;

});



parcelRegister("ccItR", function(module, exports) {

$parcel$export(module.exports, "UiLoginContainer", function () { return (parcelRequire("1kwIV")).default; });

var $1kwIV = parcelRequire("1kwIV");

});
parcelRegister("1kwIV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $24f99872a08941bb$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $eOLtZ = parcelRequire("eOLtZ");

var $33PqJ = parcelRequire("33PqJ");
const $24f99872a08941bb$var$UiLoginContainer = ({ model: model })=>{
    const loggedIn = (0, $eOLtZ.useIsLoggedIn)();
    const { defaultContent: defaultContent, loggedInContent: loggedInContent } = model.content;
    if (loggedIn === true && loggedInContent) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: loggedInContent.map((uiComponent)=>(0, $33PqJ.renderViewModel)(uiComponent))
    });
    else if (loggedIn === false && defaultContent) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: defaultContent.map((uiComponent)=>(0, $33PqJ.renderViewModel)(uiComponent))
    });
    else return null;
};
var $24f99872a08941bb$export$2e2bcd8739ae039 = $24f99872a08941bb$var$UiLoginContainer;

});


parcelRegister("gdM6R", function(module, exports) {

$parcel$export(module.exports, "UiLoginSignupForm", function () { return (parcelRequire("WYOXd")).default; });

var $WYOXd = parcelRequire("WYOXd");

});
parcelRegister("WYOXd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3be4a091750614b6$export$2e2bcd8739ae039; });
// @ts-nocheck

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5uiii = parcelRequire("5uiii");
var $aSdFq = parcelRequire("aSdFq");
parcelRequire("4cY9r");
var $05cLg = parcelRequire("05cLg");

var $4Ixzv = parcelRequire("4Ixzv");
const $3be4a091750614b6$var$UiLoginSignupForm = ({ model: model, navigationFn: navigationFn })=>{
    const { browserWarningMessage: browserWarningMessage, continueButtonText: continueButtonText, disableLegacyAppearance: disableLegacyAppearance, emailFieldLabel: emailFieldLabel, emailFieldPlaceholder: emailFieldPlaceholder, formFooterContent: formFooterContent, formSeparatorText: formSeparatorText, formType: formType = "signup", heading: heading, prompt: prompt, socialButtons: socialButtons, termsOfService: termsOfService, useEmailButton: useEmailButton } = model.content;
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const query = (0, $5uiii.useQuery)();
    const getParam = (param)=>query.get(param) ?? ""; // always return a string for Typescript simplicity
    const returnUrl = getParam("returnUrl");
    const confirmReturnUrl = getParam("confirmReturnUrl");
    const [email, setEmail] = (0, $iSvIT.useState)(getParam("email"));
    const [emailValid, setEmailValid] = (0, $iSvIT.useState)(false);
    const [browserNotSupported, setBrowserNotSupported] = (0, $iSvIT.useState)(false);
    const eventContainer = formType === "signup" ? "signUpForm" : "logInForm";
    const signupUrl = (0, $aSdFq.useIdentityUrl)({
        email: email,
        confirmReturnUrl: confirmReturnUrl,
        prompt: prompt,
        returnUrl: returnUrl
    });
    (0, $iSvIT.useEffect)(()=>{
        // Copied from https://bitbucket.org/trello/meta-compliant/src/6d43743a897f89c7840ee72eb344cad3ffda9d12/packages/common/js/login.coffee?at=main#lines-450
        setEmailValid(!!email.length && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email));
    }, [
        email
    ]);
    (0, $iSvIT.useEffect)(()=>{
        const cookiesDisabled = !navigator.cookieEnabled;
        // @ts-ignore -> Internet Explorer `documentMode` property
        const hasDocumentMode = !!document.documentMode;
        const hasIEUserAgent = /MSIE|Trident/.test(navigator.userAgent);
        if (cookiesDisabled || hasDocumentMode || hasIEUserAgent) setBrowserNotSupported(true);
    }, []);
    const handleSubmit = (e)=>{
        e.preventDefault();
        // See BXPT-1352 for idiosyncratic tracking rationale
        sendTrackEvent("submittedUiEmailSignup", {
            ...analyticsAttributes,
            event: "submitted",
            eventComponent: "uiEmailSignup",
            eventContainer: eventContainer,
            href: "",
            label: continueButtonText,
            labelEnglish: disableLegacyAppearance ? "Get started" : "Continue",
            uuid: model.id
        });
        if (emailValid) {
            if (navigationFn) navigationFn(signupUrl);
            else location.assign(signupUrl);
        }
    };
    // eslint-disable-next-line react/no-unstable-nested-components -- TODO: extract component
    const BrowserWarningBanner = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
            children: [
                browserWarningMessage && /*#__PURE__*/ (0, $loA2J.jsx)("noscript", {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                        document: browserWarningMessage,
                        className: "text text-incompatible"
                    })
                }),
                browserNotSupported && browserWarningMessage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                    document: browserWarningMessage,
                    className: "text text-incompatible"
                })
            ]
        });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: eventContainer
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4Ixzv.Section), {
            disableLegacyAppearance: disableLegacyAppearance,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)(BrowserWarningBanner, {}),
                heading && /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Ixzv.Heading), {
                    as: disableLegacyAppearance ? "h2" : "h1",
                    children: heading
                }),
                useEmailButton ? /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        termsOfService && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                            document: termsOfService,
                            className: "text text-tos"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Ixzv.BlockLinkButton), {
                            appearance: "Primary",
                            url: signupUrl,
                            onClick: ()=>sendTrackEvent("clickedEmailContinueButton", {
                                    ...analyticsAttributes,
                                    event: "clicked",
                                    eventContainer: eventContainer,
                                    eventComponent: "link",
                                    label: continueButtonText,
                                    labelEnglish: "Sign up with email",
                                    uuid: model.id,
                                    href: signupUrl
                                }),
                            children: continueButtonText
                        })
                    ]
                }) : /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
                    onSubmit: handleSubmit,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Ixzv.InputEmail), {
                            "aria-label": emailFieldLabel,
                            "data-testid": "email-input",
                            id: "email" // Used in AAAA team Pollinator tests
                            ,
                            name: "email",
                            onChange: (e)=>setEmail(e.currentTarget.value),
                            placeholder: emailFieldPlaceholder,
                            type: "email",
                            value: email
                        }),
                        termsOfService && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                            document: termsOfService,
                            className: "text text-tos"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Ixzv.SubmitButton), {
                            disableLegacyAppearance: disableLegacyAppearance,
                            disabled: !emailValid,
                            "data-testid": "signup-submit",
                            id: "signup-submit" // Used in AAAA team Pollinator tests
                            ,
                            type: "submit",
                            children: continueButtonText
                        })
                    ]
                }),
                !email.length && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                    children: [
                        formSeparatorText && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: "text",
                            children: formSeparatorText
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4Ixzv.SocialButtons), {
                            disableLegacyAppearance: disableLegacyAppearance,
                            children: socialButtons?.filter(({ type: type })=>type === "uiSocialLoginSignupButton").map((button, index)=>// @ts-expect-error - Loadable component type incompatibility
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $05cLg.default), {
                                    appearance: disableLegacyAppearance ? "outline" : "shadow",
                                    model: button,
                                    buttonType: formType
                                }, index))
                        })
                    ]
                }),
                formFooterContent && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                    document: formFooterContent,
                    className: "text text-footer"
                })
            ]
        })
    });
};
var $3be4a091750614b6$export$2e2bcd8739ae039 = $3be4a091750614b6$var$UiLoginSignupForm;

});
parcelRegister("4cY9r", function(module, exports) {

$parcel$export(module.exports, "UiSocialLoginSignupButton", function () { return (parcelRequire("05cLg")).default; });

var $05cLg = parcelRequire("05cLg");

});
parcelRegister("05cLg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $faef5e41bf0d9fef$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $fuZB8 = parcelRequire("fuZB8");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $17IGc = parcelRequire("17IGc");
var $buTNb = parcelRequire("buTNb");
var $ioseP = parcelRequire("ioseP");
var $6Owxa = parcelRequire("6Owxa");
parcelRequire("bNHtH");
var $aYCAT = parcelRequire("aYCAT");

var $bnOhh = parcelRequire("bnOhh");
const $faef5e41bf0d9fef$var$UiSocialLoginSignupButton = ({ model: model, buttonType: buttonType = "signup", appearance: appearance = "shadow" })=>{
    const { id: id, content: { buttonText: buttonText, entryTitle: entryTitle, providerName: providerName } } = model;
    const currentLanguage = (0, $fuZB8.useLanguage)();
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const dscInputRef = (0, $iSvIT.useRef)(null);
    const setDscValueOnSubmit = ()=>{
        if (dscInputRef.current) dscInputRef.current.value = (0, $aYCAT.getCookie)("dsc") ?? "";
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)("form", {
        action: "/authenticate_openid",
        method: "post",
        onSubmit: setDscValueOnSubmit,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                type: "hidden",
                name: "provider",
                value: "atlassian"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                type: "hidden",
                name: "subProvider",
                value: providerName
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                type: "hidden",
                name: "tosAccepted",
                value: "true"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                type: "hidden",
                name: "locale",
                value: currentLanguage
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                name: "dsc",
                "data-testid": "dsc-input",
                type: "hidden",
                value: "",
                ref: dscInputRef
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $bnOhh.Button), {
                id: providerName,
                appearance: appearance,
                onClick: ()=>{
                    const eventName = `clickedSocial${buttonType === "login" ? "Login" : "Signup"}Button`;
                    const eventComponents = {
                        microsoft: "signUpWithMicrosoftButton",
                        google: "signUpWithGmailButton",
                        // Preserve "Gmail" button naming (BXPT-1362)
                        apple: "signUpWithAppleButton",
                        slack: "signUpWithSlackButton"
                    };
                    sendTrackEvent(eventName, {
                        ...analyticsAttributes,
                        event: "clicked",
                        eventComponent: eventComponents[providerName],
                        label: buttonText,
                        labelEnglish: entryTitle,
                        uuid: id
                    });
                },
                type: "submit",
                children: [
                    $faef5e41bf0d9fef$var$getIcon(providerName),
                    buttonText
                ]
            })
        ]
    });
};
function $faef5e41bf0d9fef$var$getIcon(provider) {
    switch(provider){
        case "google":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $17IGc.GoogleLogo), {});
        case "microsoft":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $buTNb.MicrosoftLogo), {});
        case "apple":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $ioseP.AppleLogo), {});
        case "slack":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6Owxa.SlackLogo), {});
    }
}
var $faef5e41bf0d9fef$export$2e2bcd8739ae039 = $faef5e41bf0d9fef$var$UiSocialLoginSignupButton;

});
parcelRegister("bnOhh", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $fd3ad53cdbcc61be$export$353f5b6fc5456de1; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $a7xVp = parcelRequire("a7xVp");

var $jAJVK = parcelRequire("jAJVK");
const $fd3ad53cdbcc61be$export$353f5b6fc5456de1 = (0, $hYbro.styled).button`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N800")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xs}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    ${({ appearance: appearance })=>appearance === "shadow" ? `
      border: 0;
      box-shadow: ${(0, $a7xVp.shadow).small};
      font-weight: 500;
      padding: 0.5rem;
      ` : `
      border: 1px solid ${(0, $i2LPb.colorCSS)("N800")};
      padding: 0.75rem;
      text-decoration: none;
      `}

    &:focus, &:hover {
        background-color: ${(0, $i2LPb.colorCSS)("N10")};
        color: inherit;
        text-decoration: none;
    }

    &:focus-visible {
        outline-offset: 1px;
    }

    svg {
        display: block;
        width: 18px;
        height: 18px;
    }
`;

});



parcelRegister("4Ixzv", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $2c5fd9a1049fe225$export$6e2c8f0811a474ce; });
$parcel$export(module.exports, "InputEmail", function () { return $2c5fd9a1049fe225$export$497a6aaf7dad75ee; });
$parcel$export(module.exports, "SubmitButton", function () { return $2c5fd9a1049fe225$export$8b7b7cdfb85d78c5; });
$parcel$export(module.exports, "Heading", function () { return $2c5fd9a1049fe225$export$a8a3e93435678ff9; });
$parcel$export(module.exports, "SocialButtons", function () { return $2c5fd9a1049fe225$export$af92f9b5f8194b88; });
$parcel$export(module.exports, "BlockLinkButton", function () { return $2c5fd9a1049fe225$export$ef554111d0069ac; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("dg5xP");
var $8HF11 = parcelRequire("8HF11");
var $82f25 = parcelRequire("82f25");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $a7xVp = parcelRequire("a7xVp");
var $kL1mL = parcelRequire("kL1mL");
var $7XWgk = parcelRequire("7XWgk");

var $jAJVK = parcelRequire("jAJVK");
const $2c5fd9a1049fe225$export$6e2c8f0811a474ce = (0, $hYbro.styled).section`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.5rem")}
    ${({ disableLegacyAppearance: disableLegacyAppearance })=>!disableLegacyAppearance && `
    background-color: ${(0, $i2LPb.colorCSS)("N0")};
    border-radius: ${(0, $fpcku.radius).button};
    box-shadow: ${(0, $a7xVp.shadow).normal};
    margin: 0 auto;
    max-width: 400px;
    padding: 2rem;
  `}
    form {
        display: grid;
        gap: 1.5rem;
    }
    .text {
        text-align: center;
        &.text-tos {
            text-align: left;
        }
        &.text-footer {
            margin-top: 0.5rem;
        }

        &.text-incompatible {
            background-color: ${(0, $i2LPb.colorCSS)("R300")};
            margin: -2rem -2rem 0;
            padding: 1rem 2rem;
            a {
                color: ${(0, $i2LPb.colorCSS)("R50")};

                &:hover {
                    color: ${(0, $i2LPb.colorCSS)("N0")};
                }
            }

            p {
                color: ${(0, $i2LPb.colorCSS)("N0")};
            }
        }
    }

    p {
        color: ${(0, $i2LPb.colorCSS)("N300")};
        font-size: ${(0, $kL1mL.fontSizes).xs};
        margin: 0;

        & + p {
            margin-top: 1rem;
        }
    }
`;
const $2c5fd9a1049fe225$var$formInputCSS = `
  font-size: ${(0, $kL1mL.fontSizes).sm};
  padding: 0.5rem;
  width: 100%;
`;
const $2c5fd9a1049fe225$export$497a6aaf7dad75ee = (0, $hYbro.styled).input`
    ${$2c5fd9a1049fe225$var$formInputCSS}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N10")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `2px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ::placeholder {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N80")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("opacity", "1")}
    }
`;
const $2c5fd9a1049fe225$export$8b7b7cdfb85d78c5 = (0, $hYbro.styled).button`
    ${({ disableLegacyAppearance: disableLegacyAppearance })=>disableLegacyAppearance ? (0, $hYbro.css)({
        justifyContent: "center"
    }, (0, $8HF11.getAppearance)("Primary"), (0, $8HF11.getProminence)()) : `
    ${$2c5fd9a1049fe225$var$formInputCSS}
    background-color: ${(0, $i2LPb.colorCSS)("G300")};
    border: 0;
    color: ${(0, $i2LPb.colorCSS)("N0")};
    font-weight: 500;
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)("G200")};
    }
  `}
    &[disabled] {
        background-color: ${(0, $i2LPb.colorCSS)("N30")} !important;
        border: 0;
        color: ${(0, $i2LPb.colorCSS)("N100")} !important;
        cursor: not-allowed;
    }
`;
const $2c5fd9a1049fe225$export$a8a3e93435678ff9 = (0, $hYbro.styled).h1`
    ${(0, $7XWgk.h4)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
`;
const $2c5fd9a1049fe225$export$af92f9b5f8194b88 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${({ disableLegacyAppearance: disableLegacyAppearance })=>disableLegacyAppearance ? `
                  gap: 0.5rem;
                  grid-template-columns: 1fr 1fr;
              ` : `
                  gap: 1rem;
              `}
`;
const $2c5fd9a1049fe225$export$ef554111d0069ac = (0, $hYbro.styled)((0, $82f25.LinkButton))`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block !important")}
`;

});



parcelRegister("cq2VZ", function(module, exports) {

$parcel$export(module.exports, "UiMarkdown", function () { return (parcelRequire("giOvo")).default; });

var $giOvo = parcelRequire("giOvo");

});
parcelRegister("giOvo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6db6a4fd1e9123b8$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");
parcelRequire("h6yBX");
var $9iTli = parcelRequire("9iTli");
var $kL1mL = parcelRequire("kL1mL");

var $7zyOY = parcelRequire("7zyOY");
const $6db6a4fd1e9123b8$var$UiMarkdown = ({ model: model })=>{
    const { content: content, entryTitle: entryTitle, orderedListAppearance: orderedListAppearance, textSize: textSize } = model.content;
    // Apply styles at runtime via className
    const orderedListClass = orderedListAppearance ? (0, $9iTli.getOrderedListCSS)(orderedListAppearance) : "";
    const textSizeClass = textSize ? (0, $kL1mL.getTextSizeCSS)(textSize) : "";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: model.type,
            labelEnglish: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7zyOY.StyledMarkdown), {
            className: `${orderedListClass} ${textSizeClass}`,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                children: content
            })
        })
    });
};
var $6db6a4fd1e9123b8$export$2e2bcd8739ae039 = $6db6a4fd1e9123b8$var$UiMarkdown;

});
parcelRegister("7zyOY", function(module, exports) {

$parcel$export(module.exports, "StyledMarkdown", function () { return $e7a17e8e28cddbe8$export$5c24b9f68c75af1d; });
/* UiMarkdown.styled.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("h6yBX");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");
const $e7a17e8e28cddbe8$export$5c24b9f68c75af1d = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_2xg1rn": (0, $43MIc.default)((0, $kL1mL.fontSizes).lg),
            "--_ql89p2": (0, $43MIc.default)((0, $i2LPb.colorCSS)("T400")),
            "--_r820ks": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N0")),
            "--_148vzsg": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N900")),
            "--_1mvqpig": (0, $43MIc.default)((0, $kL1mL.fontSizes).sm),
            "--_u21z3s": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N20")),
            "--_3oyplr": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N40"))
        },
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_1aynoqnp _z3hhidpf _1unt1e5h _1ywo1e5h _19or1kwk _uxxm1kwk _1yw4oqnp _bt6voqnp _1dg11k8s _1pfe1k8s _1ouoidpf _4xv2idpf _1030idpf _5st0idpf _1oe4idpf _77lfidpf _6amgidpf _b9nuidpf _1row6mu8 _1eamidpf _1g9s1o8l _1437sd8f _1128bs82 _h5ez1j6v _17r81j6v _sw4ewebb _8cox1j6v _ljjy94pf _17nr12bs _gdfy1j6v _1pjkstnw _1osl1udo _172k1pov _839aowjs _1tnz1ymo _1n861gsg _1l5kgad4 _19sh1o0n _1iw01j40 _oxnu4wdv _1d9p1ule _1e8l1bru _v6xb1k8s _tg9f1wug _f8001osq _rjsb1730 _yxyoj12g _1mtpj12g _1xco1olw _zvc51olw _j3xc1kwk _1is91kwk _u5df1olw _1ce51olw _e74j1kwk _1w7e1kwk _1x3zjp4b _jjdgjp4b",
            __cmplp.className
        ])
    });
});

});



parcelRegister("jAZan", function(module, exports) {

$parcel$export(module.exports, "UiMarketoForm", function () { return $5db657ad1cb036f1$export$f7c0ed97d9b2245f; });

var $hmtod = parcelRequire("hmtod");

const $5db657ad1cb036f1$export$f7c0ed97d9b2245f = (0, $hmtod.default)(()=>(parcelRequire("86Kw6")), {
    ssr: false
});

});
parcelRegister("86Kw6", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("6ogYG").then(()=>parcelRequire("iWSAl"));

});


parcelRegister("hUFVr", function(module, exports) {

$parcel$export(module.exports, "UiModal", function () { return (parcelRequire("hZ3E2")).default; });

var $hZ3E2 = parcelRequire("hZ3E2");

});
parcelRegister("hZ3E2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58e61de582ece798$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $23mX4 = parcelRequire("23mX4");
var $kukfL = parcelRequire("kukfL");

var $33PqJ = parcelRequire("33PqJ");
const $58e61de582ece798$var$UiModal = ({ model: model })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const { id: id, content: content } = model;
    const { entryTitle: entryTitle, title: title, transitionType: transitionType, transitionSpeed: transitionSpeed, modalSize: modalSize, closeText: closeText, modalContent: modalContent } = content;
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventColumn: title,
            eventContainer: model.type,
            labelEnglish: entryTitle
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $23mX4.ModalTrigger), {
                "data-testid": "ui-modal-trigger",
                onClick: ()=>{
                    setIsOpen(true);
                    sendTrackEvent("modalOpened", {
                        ...analyticsAttributes,
                        event: "opened",
                        eventComponent: model.type,
                        label: title,
                        labelEnglish: entryTitle,
                        title: title,
                        uuid: model.id
                    });
                },
                as: model.content.modalTriggerBlock ? "div" : "span",
                children: (0, $33PqJ.renderViewModel)(model.content.modalTrigger)
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $kukfL.Modal), {
                modal: {
                    id: id,
                    content: {
                        transitionType: transitionType,
                        transitionSpeed: transitionSpeed,
                        modalSize: modalSize,
                        closeText: closeText
                    }
                },
                isOpen: isOpen,
                close: ()=>{
                    setIsOpen(false);
                    sendTrackEvent("modalClosed", {
                        ...analyticsAttributes,
                        event: "closed",
                        eventComponent: model.type,
                        label: title,
                        labelEnglish: entryTitle,
                        title: title,
                        uuid: model.id
                    });
                },
                children: (0, $33PqJ.renderViewModel)(modalContent)
            })
        ]
    });
};
var $58e61de582ece798$export$2e2bcd8739ae039 = $58e61de582ece798$var$UiModal;

});


parcelRegister("8B6bM", function(module, exports) {

$parcel$export(module.exports, "UiNavBanner", function () { return (parcelRequire("7kKxD")).default; });

var $7kKxD = parcelRequire("7kKxD");

});

parcelRegister("4pmfd", function(module, exports) {

$parcel$export(module.exports, "UiNavBlogArticle", function () { return (parcelRequire("1LBks")).default; });

var $1LBks = parcelRequire("1LBks");

});

parcelRegister("3u5UV", function(module, exports) {

$parcel$export(module.exports, "UiNavImages", function () { return (parcelRequire("9dr3y")).default; });

var $9dr3y = parcelRequire("9dr3y");

});
parcelRegister("9dr3y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b30e56f89558be73$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
var $41Ir1 = parcelRequire("41Ir1");
parcelRequire("6zQPu");
var $hTn52 = parcelRequire("hTn52");
const $b30e56f89558be73$var$UiNavImages = ({ model: model })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
        align: "center",
        children: model.content.pages.filter(({ type: type })=>type === "route").map(({ id: id, content: { path: path, linkTitle: linkTitle, linkImage: linkImage } })=>{
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                sm: {
                    span: "6"
                },
                md: {
                    span: "4"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $hTn52.default), {
                    href: path,
                    theme: model.content.theme,
                    containerId: model.id,
                    containerType: model.type,
                    label: linkTitle,
                    labelEnglish: path,
                    imageAlt: linkImage?.title,
                    children: [
                        linkImage && /*#__PURE__*/ (0, $loA2J.jsx)((0, $41Ir1.Picture), {
                            image: linkImage
                        }),
                        linkTitle && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            children: linkTitle
                        })
                    ]
                })
            }, id);
        })
    });
};
var $b30e56f89558be73$export$2e2bcd8739ae039 = $b30e56f89558be73$var$UiNavImages;

});
parcelRegister("6zQPu", function(module, exports) {

$parcel$export(module.exports, "Card", function () { return (parcelRequire("hTn52")).default; });

var $hTn52 = parcelRequire("hTn52");

});
parcelRegister("hTn52", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $901da30a7fcf97fa$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $bR9DD = parcelRequire("bR9DD");
const $901da30a7fcf97fa$var$Card = ({ theme: theme, href: href, children: children, containerId: containerId, containerType: containerType, label: label, labelEnglish: labelEnglish, imageAlt: imageAlt })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const props = {
        href: href,
        title: label,
        onClick: ()=>sendTrackEvent("clickedCard", {
                event: "clicked",
                eventComponent: "card",
                eventContainer: containerType,
                label: label,
                labelEnglish: labelEnglish,
                uuid: containerId,
                imageAlt: imageAlt,
                href: href,
                theme: theme
            })
    };
    switch(theme){
        case "Team card":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bR9DD.TeamCard), {
                ...props,
                "data-uuid": containerId,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: children
                })
            });
        default:
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bR9DD.DefaultCard), {
                ...props,
                "data-uuid": containerId,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
                    children: children
                })
            });
    }
};
var $901da30a7fcf97fa$export$2e2bcd8739ae039 = $901da30a7fcf97fa$var$Card;

});
parcelRegister("bR9DD", function(module, exports) {

$parcel$export(module.exports, "DefaultCard", function () { return $42ec5bb848f7ab2c$export$466e57f2f756c21c; });
$parcel$export(module.exports, "TeamCard", function () { return $42ec5bb848f7ab2c$export$c3e84fe0e2864908; });
/* Card.styles.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $aKIz7 = parcelRequire("aKIz7");
const $42ec5bb848f7ab2c$export$466e57f2f756c21c = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_r820ks": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N0")),
            "--_184g9oo": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N900", 0.25)),
            "--_1dw9rpf": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N600"))
        },
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_11q71j40 _2rkoi2wt _16qse3fl _1e0c1ule _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _19pk1kwk _2hwxidpf _otyr1kwk _18u0idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _v564kete _1llwbuuz _1tjqhzqs",
            __cmplp.className
        ])
    });
});
const $42ec5bb848f7ab2c$export$c3e84fe0e2864908 = /*#__PURE__*/ (0, $iSvIT.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1709zo3": (0, $43MIc.default)((0, $aKIz7.gradientCSS)("C200", 180)),
            "--_1isx3d2": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N100", 0.25)),
            "--_1dw9rpf": (0, $43MIc.default)((0, $i2LPb.colorCSS)("N600"))
        },
        ref: __cmplr,
        className: (0, $esG4f.default)([
            "_11q7wnug _16qs1lma _2rkoi2wt _1e0c1ule _ca0q1y44 _u5f31y44 _n3td1y44 _19bv1y44 _19pk1kwk _2hwxidpf _otyr1kwk _18u0idpf _4bfu1r31 _1hmsglyw _ajmmnqa1 _v564kete _1llwbuuz _1tjqhzqs",
            __cmplp.className
        ])
    });
});

});





parcelRegister("kF7qb", function(module, exports) {

$parcel$export(module.exports, "UiNavLink", function () { return (parcelRequire("cSWGN")).default; });

var $cSWGN = parcelRequire("cSWGN");

});

parcelRegister("KjeNh", function(module, exports) {

$parcel$export(module.exports, "UiPowerUp", function () { return (parcelRequire("3mNTO")).default; });

var $3mNTO = parcelRequire("3mNTO");

});
parcelRegister("3mNTO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca4f892b98e73962$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("lJZAY");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");

var $5TrFZ = parcelRequire("5TrFZ");
const $ca4f892b98e73962$var$UiPowerUp = ({ model: model })=>{
    const { title: title, description: description, logo: logo, button: button } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5TrFZ.PowerUpGrid), {
        children: [
            logo && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5TrFZ.ImageColumn), {
                children: (0, $33PqJ.renderViewModel)(logo)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5TrFZ.TextColumn), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                        document: description
                    })
                ]
            }),
            button && /*#__PURE__*/ (0, $loA2J.jsx)((0, $5TrFZ.CtaColumn), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                    value: {
                        parentLabel: title
                    },
                    children: (0, $33PqJ.renderViewModel)(button)
                })
            })
        ]
    });
};
var $ca4f892b98e73962$export$2e2bcd8739ae039 = $ca4f892b98e73962$var$UiPowerUp;

});
parcelRegister("5TrFZ", function(module, exports) {

$parcel$export(module.exports, "PowerUpGrid", function () { return $28d27a85151c788b$export$8d26305508bc2ddd; });
$parcel$export(module.exports, "ImageColumn", function () { return $28d27a85151c788b$export$183097b13d624433; });
$parcel$export(module.exports, "TextColumn", function () { return $28d27a85151c788b$export$278e4cc731490f23; });
$parcel$export(module.exports, "CtaColumn", function () { return $28d27a85151c788b$export$70f32325720a60e9; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $28d27a85151c788b$export$8d26305508bc2ddd = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-gap", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "1fr minmax(min-content, 25%)")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

    @media (min-width: 576px) {
        ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "80px 1fr minmax(min-content, 25%)")}
    }
`;
const $28d27a85151c788b$export$183097b13d624433 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}

    img {
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "80px")}
    }

    @media (min-width: 576px) {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }
`;
const $28d27a85151c788b$export$278e4cc731490f23 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorContrastCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

    *:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
`;
const $28d27a85151c788b$export$70f32325720a60e9 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("justify-self", "flex-end")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
`;

});



parcelRegister("gbRkW", function(module, exports) {

$parcel$export(module.exports, "UiPricingCalculator", function () { return (parcelRequire("oHr7c")).default; });

var $oHr7c = parcelRequire("oHr7c");

});
parcelRegister("oHr7c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $00f62c0be8858143$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $KmL3B = parcelRequire("KmL3B");
var $kzY5l = parcelRequire("kzY5l");
parcelRequire("ltPTP");
var $hIzNO = parcelRequire("hIzNO");

var $9d79U = parcelRequire("9d79U");
const $00f62c0be8858143$var$UiPricingCalculator = ({ model: model })=>{
    const { title: title, userCountLabel: userCountLabel, priceLabel: priceLabel, annualTotalText: annualTotalText, perUserPerMonthText: perUserPerMonthText, usdText: usdText, generalError: generalError, minUsersError: minUsersError, maxUsersError: maxUsersError, plan: plan } = model.content;
    const minUsers = 50;
    const maxUsers = 10000000;
    const calculator = (0, $KmL3B.useEnterprisePricingCalculator)(plan.content.pricing, minUsers, maxUsers);
    const [userCount, setUserCount] = (0, $iSvIT.useState)(minUsers);
    const [[error, prices], setPrice] = (0, $iSvIT.useState)(calculator.getPricesByUserCount(minUsers));
    const [used, setUsed] = (0, $iSvIT.useState)(false);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const hasError = !!error;
    const handleOnChange = (value)=>{
        const numberString = value.replace(/\D/g, "");
        const numberValue = numberString.length > 1 && numberString.startsWith("0") ? parseInt(numberString.replace(/^0+/, "")) : parseInt(numberString);
        setUserCount(isNaN(numberValue) ? "" : numberValue);
        setPrice(calculator.getPricesByUserCount(numberValue));
        //only send a single event when the user interacts with the input
        if (!used) {
            sendTrackEvent("usedPricingCalculator", {
                event: "used",
                eventComponent: model.type,
                eventContainer: "content",
                label: title,
                labelEnglish: "Pricing Calculator",
                uuid: model.id
            });
            setUsed(true);
        }
    };
    const inputId = `uipc-${model.id}`;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "ui-pricing-calculator",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.CalculatorHeading), {
                children: title
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                            htmlFor: inputId,
                            children: userCountLabel
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.NumberInput), {
                            "data-testid": "ui-pricing-calculator-input",
                            id: inputId,
                            max: maxUsers,
                            min: minUsers,
                            onChange: (event)=>handleOnChange(event.target.value),
                            step: "1",
                            type: "number",
                            value: userCount
                        })
                    })
                ]
            }),
            hasError && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.InfoLabel), {
                "data-testid": "ui-pricing-calculator-error",
                children: error === (0, $hIzNO.EnterprisePriceCalculationsError).MIN_USERS_ERROR ? minUsersError : error === (0, $hIzNO.EnterprisePriceCalculationsError).MAX_USERS_ERROR ? maxUsersError : generalError
            }),
            !hasError && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.PriceContainer), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.PriceLabel), {
                        children: priceLabel
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.PriceGrid), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.PriceItem), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.Price), {
                                        "data-testid": "ui-pricing-calculator-monthly-price",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("small", {
                                                children: "$"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                children: prices.monthlyPricePerUser
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("small", {
                                                children: usdText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.InfoLabel), {
                                        children: perUserPerMonthText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.PriceItem), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $9d79U.Price), {
                                        "data-testid": "ui-pricing-calculator-annual-price",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsx)("small", {
                                                children: "$"
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                children: prices.annualPrice
                                            }),
                                            /*#__PURE__*/ (0, $loA2J.jsx)("small", {
                                                children: usdText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d79U.InfoLabel), {
                                        children: annualTotalText
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $00f62c0be8858143$export$2e2bcd8739ae039 = $00f62c0be8858143$var$UiPricingCalculator;

});
parcelRegister("9d79U", function(module, exports) {

$parcel$export(module.exports, "CalculatorHeading", function () { return $786018e0f46d688d$export$a374960b388950ca; });
$parcel$export(module.exports, "NumberInput", function () { return $786018e0f46d688d$export$6bf0cd3a219bbade; });
$parcel$export(module.exports, "PriceContainer", function () { return $786018e0f46d688d$export$e4951ebfa34482d; });
$parcel$export(module.exports, "PriceGrid", function () { return $786018e0f46d688d$export$63a8e1e2f31d2a3; });
$parcel$export(module.exports, "PriceItem", function () { return $786018e0f46d688d$export$31ab31c01c517be2; });
$parcel$export(module.exports, "PriceLabel", function () { return $786018e0f46d688d$export$4ba25fc295a936e5; });
$parcel$export(module.exports, "Price", function () { return $786018e0f46d688d$export$3f58fdce283c1f4c; });
$parcel$export(module.exports, "InfoLabel", function () { return $786018e0f46d688d$export$6fdf58e0e61e341c; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $bC5c7 = parcelRequire("bC5c7");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $786018e0f46d688d$export$a374960b388950ca = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.33333333")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0.5rem")}
`;
const $786018e0f46d688d$export$6bf0cd3a219bbade = (0, $hYbro.styled).input`
    ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("N20")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N40")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "6px")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.4rem 0.8rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "250ms ease-out")}
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("B300", 0.5)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 0 0 3px ${(0, $i2LPb.colorCSS)("B300", 0.15)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}
    }
`;
const $786018e0f46d688d$export$e4951ebfa34482d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}
`;
const $786018e0f46d688d$export$63a8e1e2f31d2a3 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}

    > div {
        ${(0, $jAJVK.redundantCssFromKebab)("min-width", "50%")}
    }

    > div:first-of-type {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-right", "1rem")}
    }
`;
const $786018e0f46d688d$export$31ab31c01c517be2 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
`;
const $786018e0f46d688d$export$4ba25fc295a936e5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
`;
const $786018e0f46d688d$export$3f58fdce283c1f4c = (0, $hYbro.styled).div`
    small {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
    }

    span {
        ${(0, $jAJVK.redundantCssFromKebab)("font-family", `${(0, $bC5c7.theme).fontFamily.display}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxl}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "0.25rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-right", "0.25rem")}
    }
`;
const $786018e0f46d688d$export$6fdf58e0e61e341c = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
`;

});



parcelRegister("iwZ32", function(module, exports) {

$parcel$export(module.exports, "UiPricingComparisonTable", function () { return (parcelRequire("amvj6")).default; });

var $amvj6 = parcelRequire("amvj6");

});
parcelRegister("amvj6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f9234a106027d952$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jp1nv = parcelRequire("jp1nv");
var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $jz7Hj = parcelRequire("jz7Hj");
const $f9234a106027d952$var$UiPricingComparisonTable = ({ model: model })=>{
    const [currentSearch, setCurrentSearch] = (0, $iSvIT.useState)("");
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    (0, $iSvIT.useEffect)(()=>{
        const timer = setTimeout(()=>{
            if (currentSearch) sendTrackEvent("searchedProductFeatures", {
                event: "searched",
                eventComponent: model.type,
                eventContainer: "content",
                label: model.content.title,
                labelEnglish: model.content.entryTitle,
                uuid: model.id
            });
        }, 2000);
        return ()=>clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [
        currentSearch
    ]);
    const { title: title, featureColumnHeader: featureColumnHeader, freeColumnHeader: freeColumnHeader, standardColumnHeader: standardColumnHeader, premiumColumnHeader: premiumColumnHeader, enterpriseColumnHeader: enterpriseColumnHeader, searchFieldLabel: searchFieldLabel, rows: rows } = model.content;
    const td = (value, header)=>{
        return header ? /*#__PURE__*/ (0, $loA2J.jsx)("td", {
            "data-product": header,
            "data-appearance": value.content.appearance,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                document: value.content.value
            })
        }) : null;
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jz7Hj.Stack), {
        children: [
            searchFieldLabel && /*#__PURE__*/ (0, $loA2J.jsx)((0, $jz7Hj.SearchInput), {
                "aria-label": searchFieldLabel,
                onChange: (e)=>setCurrentSearch(e.target.value),
                placeholder: searchFieldLabel,
                type: "search",
                value: currentSearch
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $jz7Hj.Table), {
                "aria-label": title,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    scope: "col",
                                    children: featureColumnHeader
                                }),
                                freeColumnHeader && /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    scope: "col",
                                    children: freeColumnHeader
                                }),
                                standardColumnHeader && /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    scope: "col",
                                    children: standardColumnHeader
                                }),
                                premiumColumnHeader && /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    scope: "col",
                                    children: premiumColumnHeader
                                }),
                                enterpriseColumnHeader && /*#__PURE__*/ (0, $loA2J.jsx)("th", {
                                    scope: "col",
                                    children: enterpriseColumnHeader
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("tbody", {
                        children: rows.filter((row)=>!currentSearch.length || row.content.title.toLowerCase().includes(currentSearch.toLowerCase()) || row.content.lozenge?.toLowerCase().includes(currentSearch.toLowerCase()) || row.content.description?.toLowerCase().includes(currentSearch.toLowerCase())).map(({ content: { title: title, lozenge: lozenge, description: description, link: link, freeValue: freeValue, standardValue: standardValue, premiumValue: premiumValue, enterpriseValue: enterpriseValue } }, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsxs)("th", {
                                        scope: "row",
                                        children: [
                                            /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                                                children: [
                                                    title,
                                                    lozenge && /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                                                        children: lozenge
                                                    })
                                                ]
                                            }),
                                            description && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                children: description
                                            }),
                                            link && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                                    href: link.content.url,
                                                    "aria-label": link.content.ariaLabel,
                                                    onClick: ()=>sendTrackEvent("clickedUiLink", {
                                                            event: "clicked",
                                                            eventComponent: "link",
                                                            eventContainer: model.type,
                                                            eventColumn: title,
                                                            label: link.content.text,
                                                            labelEnglish: link.content.entryTitle,
                                                            uuid: link.id,
                                                            href: link.content.url
                                                        }),
                                                    "data-uuid": link.id,
                                                    testId: link.id,
                                                    children: link.content.text
                                                })
                                            })
                                        ]
                                    }),
                                    td(freeValue, freeColumnHeader),
                                    td(standardValue, standardColumnHeader),
                                    td(premiumValue, premiumColumnHeader),
                                    td(enterpriseValue, enterpriseColumnHeader)
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
};
var $f9234a106027d952$export$2e2bcd8739ae039 = $f9234a106027d952$var$UiPricingComparisonTable;

});
parcelRegister("jz7Hj", function(module, exports) {

$parcel$export(module.exports, "SearchInput", function () { return $7041a3f3974ae465$export$55d7609a8f1eccd2; });
$parcel$export(module.exports, "Stack", function () { return $7041a3f3974ae465$export$694e0d28c7ffc90c; });
$parcel$export(module.exports, "Table", function () { return $7041a3f3974ae465$export$54ec01a60f47d33d; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $aT9Ik = parcelRequire("aT9Ik");
var $6IIwI = parcelRequire("6IIwI");

var $jAJVK = parcelRequire("jAJVK");
const $7041a3f3974ae465$var$borderCSS = `1px solid ${(0, $i2LPb.colorCSS)("N40")}`;
const $7041a3f3974ae465$var$svgG300 = (0, $i2LPb.colorCSSforSVG)("G300");
const $7041a3f3974ae465$var$svgN100 = (0, $i2LPb.colorCSSforSVG)("N100");
const $7041a3f3974ae465$var$svgN400 = (0, $i2LPb.colorCSSforSVG)("N400");
const $7041a3f3974ae465$export$55d7609a8f1eccd2 = (0, $hYbro.styled).input`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N10")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("background-image", `url("data:image/svg+xml,%3Csvg fill='${$7041a3f3974ae465$var$svgN400}' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m0 0h24v24h-24z' fill='none'/%3E%3Cpath d='m16.436 15.085 3.94 4.01c.1765.1908.2718.4428.2657.7026s-.1131.5071-.2984.6893c-.1853.1823-.4342.2853-.6941.2872s-.5103-.0975-.6982-.2771l-3.938-4.006c-1.5195 1.1446-3.4171 1.6691-5.30872 1.4672s-3.63583-1.1151-4.87946-2.5546c-1.24364-1.4396-1.89376-3.2979-1.81874-5.1988.07503-1.90089.8696-3.70223 2.22283-5.03929s3.16399-2.10993 5.06559-2.16211c1.9017-.05217 3.7521.62024 5.1766 1.88108 1.4245 1.26085 2.3167 3.01591 2.4958 4.90981.1792 1.89391-.3681 3.78511-1.5309 5.29071zm-5.936.915c1.4587 0 2.8576-.5795 3.8891-1.6109 1.0314-1.0315 1.6109-2.4304 1.6109-3.8891 0-1.45869-.5795-2.85764-1.6109-3.88909-1.0315-1.03145-2.4304-1.61091-3.8891-1.61091-1.45869 0-2.85764.57946-3.88909 1.61091s-1.61091 2.4304-1.61091 3.88909c0 1.4587.57946 2.8576 1.61091 3.8891 1.03145 1.0314 2.4304 1.6109 3.88909 1.6109z'/%3E%3C/svg%3E")`)}
    ${(0, $jAJVK.redundantCssFromKebab)("background-position", "1rem center")}
    ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
    ${(0, $jAJVK.redundantCssFromKebab)("background-size", "1rem 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `${$7041a3f3974ae465$var$borderCSS}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).button}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "22rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 0.45rem 0.5rem 2.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    &::placeholder {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    }
`;
const $7041a3f3974ae465$export$694e0d28c7ffc90c = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-items", "center")}
    @media ${(0, $aT9Ik.minWidth).md} {
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "2.5rem")}
    }
`;
const $7041a3f3974ae465$export$54ec01a60f47d33d = (0, $hYbro.styled).table`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }
    th,
    th p:first-child {
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "uppercase")}
    }
    th:first-child {
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    }
    th,
    td {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.25rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    }
    thead {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }
    tbody {
        tr {
            ${(0, $jAJVK.redundantCssFromKebab)("border-top", `${$7041a3f3974ae465$var$borderCSS}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
            ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.5rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "1.25rem 0")}
        }
        th {
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "400")}
            ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "none")}

            /* Lozenge */
            span {
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("trelloblue")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.25rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "normal")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "0.5rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.125rem 0.5rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "uppercase")}
                ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "top")}
                ${(0, $jAJVK.redundantCssFromKebab)("white-space", "nowrap")}
            }
        }
        td {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
            ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "50% 50%")}
            ${(0, $jAJVK.redundantCssFromKebab)("place-items", "center end")}
            ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "uppercase")}
            &[data-appearance] {
                ${(0, $jAJVK.redundantCssFromKebab)("background-position", "center right")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
                ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
                ${(0, $jAJVK.redundantCssFromKebab)("text-indent", "100%")}
                ${(0, $jAJVK.redundantCssFromKebab)("white-space", "nowrap")}
                &[data-appearance="Check"] {
                    ${(0, $jAJVK.redundantCssFromKebab)("background-image", `url("data:image/svg+xml,%3Csvg fill='${$7041a3f3974ae465$var$svgG300}' height='10' viewBox='0 0 14 10' width='14' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m1.73534 4.3223c-.37429-.40612-1.006926-.43192-1.41304-.05763-.4061134.37428-.431915 1.00692-.057629 1.41303l3.612109 3.91927c.53753.52613 1.33768.52613 1.83436.02941.06126-.06015.06126-.06015.36425-.35811.29455-.28972.62275-.61271.97618-.96077 1.00987-.99447 2.01975-1.99061 2.96243-2.92273l.0403-.03988c1.6748-1.6562 2.9461-2.92124 3.6577-3.64266.3878-.39319.3834-1.026344-.0098-1.414177-.3932-.3878326-1.0263-.3834835-1.4141.009714-.7038.713543-1.9712 1.974673-3.6401 3.625043l-.04027.03982c-.94157.93105-1.95051 1.92626-2.95947 2.91984-.29042.286-.56377.55505-.81538.80259z'/%3E%3C/svg%3E")`)}
                }
                &[data-appearance="Empty"] {
                    ${(0, $jAJVK.redundantCssFromKebab)("background-image", `url("data:image/svg+xml,%3Csvg fill='${$7041a3f3974ae465$var$svgN100}' viewBox='0 0 20 20' height='20' width='20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z'%3E%3C/path%3E%3C/svg%3E")`)}
                }
            }
            &::before {
                ${(0, $jAJVK.redundantCssFromKebab)("content", "attr(data-product)")}
                ${(0, $jAJVK.redundantCssFromKebab)("justify-self", "flex-start")}
                ${(0, $jAJVK.redundantCssFromKebab)("text-indent", "0")}
            }
        }
    }

    @media ${(0, $aT9Ik.minWidth).md} {
        // table
        ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `${$7041a3f3974ae465$var$borderCSS}`)}

        th,
        td {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "table-cell")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "1.25rem 1rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "13%")}
        }
        tr {
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
        }
        th:first-of-type {
            ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
        }
        thead {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("display", "table-header-group")}
            ${(0, $jAJVK.redundantCssFromKebab)("inset-block-start", `${(0, $6IIwI.SMALL_NAV_PX_HEIGHT) - 1}px`)}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "sticky")}
            ${(0, $jAJVK.redundantCssFromKebab)("z-index", "1")}
            // Hack to create table borders when borders are collapsed
            ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `1px 0px 0px 0px ${(0, $i2LPb.colorCSS)("N0")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("filter", `drop-shadow(0px 1px 0px ${(0, $i2LPb.colorCSS)("N40")})`)}

            th {
                ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "0.75rem")}
            }
        }
        tbody {
            tr {
                ${(0, $jAJVK.redundantCssFromKebab)("display", "table-row")}
            }
            th,
            td {
                ${(0, $jAJVK.redundantCssFromKebab)("border-right", `${$7041a3f3974ae465$var$borderCSS}`)}
            }
            td {
                ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
                &[data-appearance] {
                    ${(0, $jAJVK.redundantCssFromKebab)("background-position", "center center")}
                    ${(0, $jAJVK.redundantCssFromKebab)("text-indent", "calc(100% + 2rem)")}
                    &[data-appearance="Empty"] {
                        ${(0, $jAJVK.redundantCssFromKebab)("background-image", "none")}
                    }
                }
                &::before {
                    ${(0, $jAJVK.redundantCssFromKebab)("content", "none")}
                }
            }
        }
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        thead {
            ${(0, $jAJVK.redundantCssFromKebab)("inset-block-start", `${(0, $6IIwI.BIG_NAV_PX_HEIGHT) - 1}px`)}
        }
    }
`;

});



parcelRegister("d54or", function(module, exports) {

$parcel$export(module.exports, "UiPricingGrid", function () { return (parcelRequire("5EWJl")).default; });

var $5EWJl = parcelRequire("5EWJl");

});
parcelRegister("5EWJl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0618bc302eae096c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("ltPTP");
var $bnR9G = parcelRequire("bnR9G");
parcelRequire("8IayY");
var $71cmW = parcelRequire("71cmW");
var $eHzo8 = parcelRequire("eHzo8");
var $hcWqg = parcelRequire("hcWqg");

var $eBzMS = parcelRequire("eBzMS");

var $eFGG9 = parcelRequire("eFGG9");
const $0618bc302eae096c$var$UiPricingGrid = ({ model: model })=>{
    const { appearance: appearance, plans: plans } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Grid), {
        planCount: plans.filter(({ type: type })=>type === "uiPricingPlan").length,
        children: plans.filter(({ type: type })=>type === "uiPricingPlan").map((plan, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PlanContainer), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $g4xTJ.AnalyticsAttributesProvider), {
                    value: {
                        eventColumn: plan.content.entryTitle,
                        eventContainer: plan.type
                    },
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                            lgOrder: index,
                            highlight: plan.content.highlight,
                            top: true,
                            first: index === 0,
                            show: true,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Title), {
                                as: appearance === "Abbreviated" ? "h3" : "h2",
                                children: plan.content.title
                            })
                        }),
                        (0, $bnR9G.isFlatRatePricing)(plan.content.pricing) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $71cmW.FlatRatePlan), {
                            model: plan,
                            index: index,
                            planCount: plans.length,
                            pricing: plan.content.pricing
                        }) : (0, $bnR9G.isEnterprisePricingTiers)(plan.content.pricing) ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $eHzo8.default), {
                            model: plan,
                            index: index,
                            planCount: plans.length,
                            pricing: plan.content.pricing
                        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $hcWqg.DefaultPlan), {
                            model: plan,
                            index: index,
                            planCount: plans.length
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                            lgOrder: index + plans.length * 3,
                            highlight: plan.content.highlight,
                            first: index === 0,
                            show: true,
                            children: plan.content.buttons && (0, $33PqJ.renderViewModel)(plan.content.buttons)
                        }),
                        appearance !== "Abbreviated" && /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                            lgOrder: index + plans.length * 4,
                            highlight: plan.content.highlight,
                            first: index === 0,
                            show: true,
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eBzMS.default), {
                                model: plan
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                            lgOrder: index + plans.length * 5,
                            highlight: plan.content.highlight,
                            bottom: true,
                            first: index === 0,
                            show: true,
                            children: plan.content.learnMore && (0, $33PqJ.renderViewModel)(plan.content.learnMore)
                        })
                    ]
                })
            }, index))
    });
};
var $0618bc302eae096c$export$2e2bcd8739ae039 = $0618bc302eae096c$var$UiPricingGrid;

});
parcelRegister("8IayY", function(module, exports) {
$parcel$export(module.exports, "DefaultPlan", function () { return (parcelRequire("hcWqg")).DefaultPlan; });
$parcel$export(module.exports, "FlatRatePlan", function () { return (parcelRequire("71cmW")).FlatRatePlan; });

$parcel$export(module.exports, "TieredPlan", function () { return (parcelRequire("eHzo8")).default; });
parcelRequire("hcWqg");
parcelRequire("71cmW");

var $eHzo8 = parcelRequire("eHzo8");

var $eBzMS = parcelRequire("eBzMS");

});
parcelRegister("hcWqg", function(module, exports) {

$parcel$export(module.exports, "DefaultPlan", function () { return $43d15ae03792b255$export$887eda872b8b76c9; });

var $loA2J = parcelRequire("loA2J");

var $eFGG9 = parcelRequire("eFGG9");
const $43d15ae03792b255$export$887eda872b8b76c9 = ({ model: model, index: index, planCount: planCount })=>{
    const { highlight: highlight, description: description, beforePrice: beforePrice, afterPrice: afterPrice, beforeSmallPrice: beforeSmallPrice, afterSmallPrice: afterSmallPrice } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Item), {
                lgOrder: index + planCount * 1,
                highlight: highlight,
                first: index === 0,
                show: true,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Price), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: beforePrice
                            }),
                            "0",
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: afterPrice
                            })
                        ]
                    }),
                    (beforeSmallPrice || afterSmallPrice) && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.PriceDetail), {
                        children: [
                            beforeSmallPrice,
                            afterSmallPrice
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                lgOrder: index + planCount * 2,
                highlight: highlight,
                first: index === 0,
                show: true,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Description), {
                    children: description
                })
            })
        ]
    });
};

});
parcelRegister("eFGG9", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $e106f5f8134f80df$export$ef2184bd89960b14; });
$parcel$export(module.exports, "PlanContainer", function () { return $e106f5f8134f80df$export$bf49f2cc54e47be2; });
$parcel$export(module.exports, "Item", function () { return $e106f5f8134f80df$export$6d08773d2e66f8f2; });
$parcel$export(module.exports, "Title", function () { return $e106f5f8134f80df$export$f99233281efd08a0; });
$parcel$export(module.exports, "Description", function () { return $e106f5f8134f80df$export$393edc798c47379d; });
$parcel$export(module.exports, "Price", function () { return $e106f5f8134f80df$export$3f58fdce283c1f4c; });
$parcel$export(module.exports, "PriceAppend", function () { return $e106f5f8134f80df$export$42651683b3831f35; });
$parcel$export(module.exports, "PriceDetail", function () { return $e106f5f8134f80df$export$6b2d42ed186bc6df; });
$parcel$export(module.exports, "PriceMax", function () { return $e106f5f8134f80df$export$3cea0fd11cbf35e; });
$parcel$export(module.exports, "FeatureList", function () { return $e106f5f8134f80df$export$aa18130def4b6cb4; });
$parcel$export(module.exports, "UserInputWrapper", function () { return $e106f5f8134f80df$export$41e8ce7872e6b86f; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
var $7XWgk = parcelRequire("7XWgk");

var $jAJVK = parcelRequire("jAJVK");
const $e106f5f8134f80df$var$borderStyle = `1px solid ${(0, $i2LPb.colorCSS)("N40")}`;
const $e106f5f8134f80df$var$highlightedBorderStyle = `2px solid ${(0, $i2LPb.colorCSS)("T300")}`;
const $e106f5f8134f80df$export$ef2184bd89960b14 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "1fr")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1rem")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 960px;
        grid-template-columns: repeat(
            ${(props)=>props.planCount},
            minmax(0, 1fr)
        );
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "0")}
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }

    @media (min-width: 1400px) {
        max-width: 1320px;
    }
`;
const $e106f5f8134f80df$export$bf49f2cc54e47be2 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "contents")}

    @media (max-width: 991px) {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }
`;
const $e106f5f8134f80df$export$6d08773d2e66f8f2 = (0, $hYbro.styled).div`
    background-color: ${(0, $i2LPb.colorCSS)("N0")};
    padding: 1.5rem 1rem 0;
    text-align: left;

    border-left: ${(props)=>props.highlight ? $e106f5f8134f80df$var$highlightedBorderStyle : $e106f5f8134f80df$var$borderStyle};
    border-right: ${(props)=>props.highlight ? $e106f5f8134f80df$var$highlightedBorderStyle : $e106f5f8134f80df$var$borderStyle};

    ${(props)=>props.top && `border-top: ${props.highlight ? $e106f5f8134f80df$var$highlightedBorderStyle : $e106f5f8134f80df$var$borderStyle};`}

    ${(props)=>props.bottom && `
        padding-bottom: 2rem;
        border-bottom: ${props.highlight ? $e106f5f8134f80df$var$highlightedBorderStyle : $e106f5f8134f80df$var$borderStyle};
        padding-top: 1rem;
        a, button {
            display: block;
            width: 100%;
        }
    `}
    
    ${(props)=>!props.show && "opacity: 0;"}
    
    @media (min-width: 992px) {
        margin-bottom: 0;
        ${(props)=>!props.first && !props.highlight && "border-left: 0;"}
    }

    order: ${(props)=>props.lgOrder + 1};
`;
const $e106f5f8134f80df$export$f99233281efd08a0 = (0, $hYbro.styled).h2`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "uppercase")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
`;
const $e106f5f8134f80df$export$393edc798c47379d = (0, $hYbro.styled).p`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
`;
const $e106f5f8134f80df$export$3f58fdce283c1f4c = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "3rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}
`;
const $e106f5f8134f80df$export$42651683b3831f35 = (0, $hYbro.styled).span`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
`;
const $e106f5f8134f80df$export$6b2d42ed186bc6df = (0, $hYbro.styled).p`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
`;
const $e106f5f8134f80df$export$3cea0fd11cbf35e = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}

    svg {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0.25rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "1.5rem")}
    }

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
`;
const $e106f5f8134f80df$export$aa18130def4b6cb4 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

    h3 {
        ${(0, $7XWgk.h5)}
    }

    button {
        ${(0, $jAJVK.redundantCssFromKebab)("background", "transparent")}
        ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem 1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("outline", "none !important")}
        ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}

        &::before {
            ${(0, $jAJVK.redundantCssFromKebab)("content", '"+"')}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
        }
    }

    &[data-open="true"] {
        button::before {
            ${(0, $jAJVK.redundantCssFromKebab)("content", '"-"')}
        }
    }

    @media (min-width: 992px) {
        button {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
        }

        > div {
            ${(0, $jAJVK.redundantCssFromKebab)("border-top", `${$e106f5f8134f80df$var$borderStyle}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "1.25rem")}
        }
    }

    ul {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("list-style-type", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 0 0 1.5rem")}

        li {
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 0.5rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

            code {
                ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("trelloblue")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.25rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
                ${(0, $jAJVK.redundantCssFromKebab)("font-family", "inherit")}
                ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxs}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.12rem 0.5rem 0.25rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "baseline")}
                ${(0, $jAJVK.redundantCssFromKebab)("white-space", "nowrap")}
            }

            &:last-child {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
            }

            &::before {
                ${(0, $jAJVK.redundantCssFromKebab)("background-image", "url(\"data:image/svg+xml,%3Csvg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.73534 4.3223C1.36105 3.91618 0.728414 3.89038 0.3223 4.26467C-0.0838134 4.63895 -0.109615 5.27159 0.264671 5.6777L3.87678 9.59697C4.41431 10.1231 5.21446 10.1231 5.71114 9.62638C5.7724 9.56623 5.7724 9.56623 6.07539 9.26827C6.36994 8.97855 6.69814 8.65556 7.05157 8.3075C8.06144 7.31303 9.07132 6.31689 10.014 5.38477L10.0543 5.34489C11.7291 3.68869 13.0004 2.42365 13.712 1.70223C14.0998 1.30904 14.0954 0.675886 13.7022 0.288053C13.309 -0.0997796 12.6759 -0.0954305 12.2881 0.297767C11.5843 1.01131 10.3169 2.27244 8.648 3.92281L8.60773 3.96263C7.66616 4.89368 6.65722 5.88889 5.64826 6.88247C5.35784 7.16847 5.08449 7.43752 4.83288 7.68506L1.73534 4.3223Z' fill='%2344C476'/%3E%3C/svg%3E%0A\")")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-repeat", "no-repeat")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-position", "center center")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-size", "contain")}
                ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
                ${(0, $jAJVK.redundantCssFromKebab)("height", "1rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("left", "-1.5rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
                ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
                ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
                ${(0, $jAJVK.redundantCssFromKebab)("text-indent", "-9999px")}
                ${(0, $jAJVK.redundantCssFromKebab)("top", "0.25rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "middle")}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "1rem")}
            }
        }
    }
`;
const $e106f5f8134f80df$var$trackHeight = 8;
const $e106f5f8134f80df$var$thumbSize = 24;
const $e106f5f8134f80df$export$41e8ce7872e6b86f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}

    input {
        &[type="number"] {
            ${(0, $jAJVK.redundantCssFromKebab)("appearance", "textfield")}
            ${(0, $jAJVK.redundantCssFromKebab)("border-color", `${(0, $i2LPb.colorCSS)("N900")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("border-style", "solid")}
            ${(0, $jAJVK.redundantCssFromKebab)("border-width", "0 0 1px")}
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0.25rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
            ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "4.5rem")}

            &::-webkit-outer-spin-button,
            &::-webkit-inner-spin-button {
                ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
            }
        }

        &[type="range"] {
            ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "1.75rem 0 0.75rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}

            &::-webkit-slider-runnable-track {
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N40")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${$e106f5f8134f80df$var$trackHeight / 2}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
                ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
                ${(0, $jAJVK.redundantCssFromKebab)("height", `${$e106f5f8134f80df$var$trackHeight}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
            }

            &::-webkit-slider-thumb {
                ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
                ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N30")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0px 2px 4px ${(0, $i2LPb.colorCSS)("N900", 0.25)}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
                ${(0, $jAJVK.redundantCssFromKebab)("height", `${$e106f5f8134f80df$var$thumbSize}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-top", `${$e106f5f8134f80df$var$trackHeight / 2 - $e106f5f8134f80df$var$thumbSize / 2}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("width", `${$e106f5f8134f80df$var$thumbSize}px`)}
            }

            &::-moz-range-track {
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N40")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${$e106f5f8134f80df$var$trackHeight / 2}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border", "0")}
                ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
                ${(0, $jAJVK.redundantCssFromKebab)("height", `${$e106f5f8134f80df$var$trackHeight}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
            }

            &::-moz-range-thumb {
                ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
                ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N30")}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0px 2px 4px ${(0, $i2LPb.colorCSS)("N900", 0.25)}`)}
                ${(0, $jAJVK.redundantCssFromKebab)("cursor", "pointer")}
                ${(0, $jAJVK.redundantCssFromKebab)("height", `${$e106f5f8134f80df$var$thumbSize}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("margin-top", `${$e106f5f8134f80df$var$trackHeight / 2 - $e106f5f8134f80df$var$thumbSize / 2}px`)}
                ${(0, $jAJVK.redundantCssFromKebab)("width", `${$e106f5f8134f80df$var$thumbSize}px`)}
            }
        }

        &:focus {
            ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}

            &::-webkit-slider-thumb {
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N800")}`)}
            }

            &::-moz-range-thumb {
                ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N800")}`)}
            }

            &:not(:focus-visible) {
                &::-webkit-slider-thumb {
                    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                }

                &::-moz-range-thumb {
                    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
                }
            }
        }
    }
`;

});


parcelRegister("71cmW", function(module, exports) {

$parcel$export(module.exports, "FlatRatePlan", function () { return $e2b4fc3e004482cb$export$25913a4102a884ba; });

var $loA2J = parcelRequire("loA2J");

var $eFGG9 = parcelRequire("eFGG9");
function $e2b4fc3e004482cb$var$formatPrice(price) {
    return Number.isInteger(price) ? price.toString() : price.toFixed(2);
}
const $e2b4fc3e004482cb$export$25913a4102a884ba = ({ model: model, index: index, planCount: planCount, pricing: pricing })=>{
    const { highlight: highlight, description: description, beforePrice: beforePrice, afterPrice: afterPrice, beforeSmallPrice: beforeSmallPrice, afterSmallPrice: afterSmallPrice } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Item), {
                lgOrder: index + planCount * 1,
                highlight: highlight,
                first: index === 0,
                show: true,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Price), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: beforePrice
                            }),
                            $e2b4fc3e004482cb$var$formatPrice(pricing.annually),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: afterPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceDetail), {
                        children: [
                            beforeSmallPrice,
                            "$",
                            $e2b4fc3e004482cb$var$formatPrice(pricing.monthly),
                            " ",
                            afterSmallPrice
                        ].join("")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Item), {
                lgOrder: index + planCount * 2,
                highlight: highlight,
                first: index === 0,
                show: true,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Description), {
                    children: description
                })
            })
        ]
    });
};

});

parcelRegister("eHzo8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e39a6bd7413b8c6$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $KmL3B = parcelRequire("KmL3B");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
parcelRequire("lfo7k");
var $jVVva = parcelRequire("jVVva");

var $eFGG9 = parcelRequire("eFGG9");
const $3e39a6bd7413b8c6$var$TieredPlan = ({ model: model, index: index, planCount: planCount, pricing: pricing })=>{
    const { highlight: highlight, description: description, beforeUserField: beforeUserField, afterUserField: afterUserField, userFieldLabel: userFieldLabel, beforePrice: beforePrice, afterPrice: afterPrice, beforeSmallPrice: beforeSmallPrice, afterSmallPrice: afterSmallPrice, beforeUserMax: beforeUserMax, afterUserMax: afterUserMax } = model.content;
    const minUsers = 50;
    const maxUsers = 5000;
    const calculator = (0, $KmL3B.useEnterprisePricingCalculator)(pricing, minUsers, maxUsers);
    const [users, setUsers] = (0, $iSvIT.useState)(minUsers);
    const [price, setPrice] = (0, $iSvIT.useState)(calculator.getPricesByUserCount(minUsers)[1].monthlyPricePerUser);
    const [smallPrice, setSmallPrice] = (0, $iSvIT.useState)(calculator.getPricesByUserCount(minUsers)[1].annualPricePerUser);
    const [usedInput, setUsedInput] = (0, $iSvIT.useState)(false);
    const [usedSlider, setUsedSlider] = (0, $iSvIT.useState)(false);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    (0, $iSvIT.useEffect)(()=>{
        setPrice(calculator.getPricesByUserCount(users)[1].monthlyPricePerUser);
        setSmallPrice(calculator.getPricesByUserCount(users)[1].annualPricePerUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [
        users
    ]);
    const updateUsers = (e)=>{
        setUsers(Math.min(maxUsers, parseInt(e.target.value || "0")));
        if (e.target.type === "range" && !usedSlider) {
            sendTrackEvent("usedSliderInput", {
                ...analyticsAttributes,
                event: "used",
                eventComponent: "slider",
                label: "Slided pricing calculator",
                labelEnglish: "Slided pricing calculator",
                uuid: `${model.id}_slider`
            });
            setUsedSlider(true);
        }
        if (e.target.type === "number" && !usedInput) {
            sendTrackEvent("usedNumberInput", {
                ...analyticsAttributes,
                event: "used",
                eventComponent: "numberInput",
                label: "Inputted number in pricing calculator",
                labelEnglish: "Inputted number in pricing calculator",
                uuid: `${model.id}_numberInput`
            });
            setUsedInput(true);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Item), {
                show: users >= minUsers,
                lgOrder: index + planCount * 1,
                highlight: highlight,
                first: index === 0,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Price), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: beforePrice
                            }),
                            price,
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceAppend), {
                                children: afterPrice
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.PriceDetail), {
                        children: [
                            beforeSmallPrice,
                            "$",
                            smallPrice,
                            " ",
                            afterSmallPrice
                        ].join("")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.Item), {
                lgOrder: index + planCount * 2,
                highlight: highlight,
                first: index === 0,
                show: true,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $eFGG9.Description), {
                        children: description
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.UserInputWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                                children: [
                                    beforeUserField,
                                    /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                        type: "number",
                                        value: users || "",
                                        min: minUsers,
                                        max: maxUsers,
                                        onChange: updateUsers,
                                        "aria-label": userFieldLabel,
                                        onBlur: (e)=>{
                                            //only need to enforce min here. max is enforced by updateUsers
                                            if (parseInt(e.target.value || "0") < minUsers) setUsers(minUsers);
                                        },
                                        onKeyDown: (e)=>[
                                                "e",
                                                "E",
                                                "+",
                                                "-",
                                                "."
                                            ].includes(e.key) && e.preventDefault()
                                    }),
                                    afterUserField
                                ]
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)("input", {
                                type: "range",
                                value: users,
                                min: minUsers,
                                max: maxUsers,
                                onChange: updateUsers,
                                "aria-label": userFieldLabel
                            }),
                            users === maxUsers && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.PriceMax), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $jVVva.InfoCircle), {}),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        children: [
                                            beforeUserMax,
                                            maxUsers.toLocaleString(),
                                            afterUserMax
                                        ].join(" ")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $3e39a6bd7413b8c6$export$2e2bcd8739ae039 = $3e39a6bd7413b8c6$var$TieredPlan;

});

parcelRegister("eBzMS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f2e4343bcee7ffa$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $1pYrM = parcelRequire("1pYrM");
var $69DYH = parcelRequire("69DYH");
var $6vqJG = parcelRequire("6vqJG");

var $eFGG9 = parcelRequire("eFGG9");
const $6f2e4343bcee7ffa$var$PlanFeatures = ({ model: model })=>{
    const [open, setOpen] = (0, $iSvIT.useState)(false);
    const [tracked, setTracked] = (0, $iSvIT.useState)(false);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const breakpoints = (0, $1pYrM.useBreakpoints)();
    const { entryTitle: entryTitle, accordionReadMore: accordionReadMore, featureList: featureList } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eFGG9.FeatureList), {
        "data-open": open,
        children: [
            accordionReadMore && /*#__PURE__*/ (0, $loA2J.jsx)("button", {
                "data-testid": "readMore",
                onClick: ()=>{
                    setOpen(!open);
                    if (!tracked) {
                        sendTrackEvent("pricingPlanFeaturesExpanded", {
                            ...analyticsAttributes,
                            event: "clicked",
                            eventComponent: "button",
                            label: accordionReadMore,
                            labelEnglish: "See what's included",
                            title: model.content.title,
                            uuid: `${model.id}_planFeatures`
                        });
                        setTracked(true);
                    }
                },
                children: accordionReadMore
            }),
            featureList && /*#__PURE__*/ (0, $loA2J.jsx)((0, $69DYH.Expand), {
                show: open || breakpoints.includes("lg"),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                    value: {
                        labelEnglish: entryTitle
                    },
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                        children: featureList
                    })
                })
            })
        ]
    });
};
var $6f2e4343bcee7ffa$export$2e2bcd8739ae039 = $6f2e4343bcee7ffa$var$PlanFeatures;

});




parcelRegister("fm4PM", function(module, exports) {

$parcel$export(module.exports, "UiQuote", function () { return (parcelRequire("6nZh8")).default; });

var $6nZh8 = parcelRequire("6nZh8");

});
parcelRegister("6nZh8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0f90f837e820a2a6$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");

var $33PqJ = parcelRequire("33PqJ");

var $eqcTJ = parcelRequire("eqcTJ");
const $0f90f837e820a2a6$var$UiQuote = ({ model: model })=>{
    const { entryTitle: entryTitle, quote: quote, attribution: attribution, logo: logo } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventColumn: quote,
            eventContainer: model.type,
            labelEnglish: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $eqcTJ.Figure), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("blockquote", {
                    children: quote
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("figcaption", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                            children: attribution
                        }),
                        logo && /*#__PURE__*/ (0, $loA2J.jsx)((0, $eqcTJ.LogoWrapper), {
                            children: (0, $33PqJ.renderViewModel)(logo)
                        })
                    ]
                })
            ]
        })
    });
};
var $0f90f837e820a2a6$export$2e2bcd8739ae039 = $0f90f837e820a2a6$var$UiQuote;

});
parcelRegister("eqcTJ", function(module, exports) {

$parcel$export(module.exports, "Figure", function () { return $2f0ae2594492cf73$export$820c702ddd5a7343; });
$parcel$export(module.exports, "LogoWrapper", function () { return $2f0ae2594492cf73$export$f827d3c5a9c3f644; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $2f0ae2594492cf73$export$820c702ddd5a7343 = (0, $hYbro.styled).figure`
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("align-content", "space-between")}

    blockquote {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.25")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

        &::before {
            ${(0, $jAJVK.redundantCssFromKebab)("background-image", "url(\"data:image/svg+xml,%3Csvg fill='none' height='31' viewBox='0 0 33 31' width='33' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='m32.4 24.1002c0-3.7-2.5-6-6.3-6h-2c.3-7.2 4.1-10.5 8.8-11.30001v-6.599995c-9.3.999995-14.3 7.499995-14.3 18.400005 0 8.6 2.9 11.7 7.5 11.7 3.9 0 6.3-2.7 6.3-6.2zm-18.5 0c0-3.7-2.5-6-6.29999-6h-2c.3-7.2 4.1-10.5 8.79999-11.30001v-6.599995c-9.29999.999995-14.299994 7.499995-14.299994 18.400005 0 8.6 2.900004 11.7 7.500004 11.7 3.89999 0 6.29999-2.7 6.29999-6.2z' fill='%2300a3bf'/%3E%3C/svg%3E\")")}
            ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
            ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
            ${(0, $jAJVK.redundantCssFromKebab)("height", "31px")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 1rem 1rem")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "33px")}
        }

        @media (min-width: 768px) {
            ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).xxl}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.34")}
        }
    }

    figcaption {
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "start")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
        ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}

        p {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0.5rem")}

            &:last-child {
                ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
            }
        }
    }

    @media (min-width: 992px) {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "8.33333%")}

        blockquote {
            &::before {
                ${(0, $jAJVK.redundantCssFromKebab)("left", "-4rem")}
                ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
                ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
                ${(0, $jAJVK.redundantCssFromKebab)("top", "0.9rem")}
            }
        }

        figcaption {
            ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "row")}
            ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-between")}

            > div:first-child {
                ${(0, $jAJVK.redundantCssFromKebab)("width", "66.66666%")}
            }
        }
    }
`;
const $2f0ae2594492cf73$export$f827d3c5a9c3f644 = (0, $hYbro.styled).div`
    img {
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "220px")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-height", "66px")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
    }
`;

});



parcelRegister("kqJ1d", function(module, exports) {

$parcel$export(module.exports, "UiRecommendShare", function () { return (parcelRequire("4DJiw")).default; });

var $4DJiw = parcelRequire("4DJiw");

});
parcelRegister("4DJiw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $28c1fbb05b3f988f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $5XW95 = parcelRequire("5XW95");
var $d9N4n = parcelRequire("d9N4n");
var $5PhOG = parcelRequire("5PhOG");
var $gFZ4z = parcelRequire("gFZ4z");
var $eHuqC = parcelRequire("eHuqC");

var $3wiG7 = parcelRequire("3wiG7");
const $28c1fbb05b3f988f$var$UiRecommendShare = ({ model: model })=>{
    const member = (0, $5XW95.useMember)();
    const hostname = (0, $d9N4n.useHostname)();
    const { emailButtonLabel: emailButtonLabel, facebookButtonLabel: facebookButtonLabel, label: label, loggedOutText: loggedOutText, messages: messages, twitterButtonLabel: twitterButtonLabel } = model.content;
    const message = messages[Math.floor(Math.random() * messages.length)];
    if (member.status === "rejected") return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
            document: loggedOutText
        })
    });
    if (member.status === "resolved" && hostname) {
        const recommendUrl = `${hostname}/${member.value.username}/recommend`;
        return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $3wiG7.ShareLabel), {
                            htmlFor: `share-label-${model.id}`,
                            children: label
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $3wiG7.ShareInput), {
                            type: "text",
                            defaultValue: recommendUrl,
                            readOnly: true,
                            id: `share-label-${model.id}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $3wiG7.ShareButtons), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5PhOG.FacebookShareButton), {
                            shareUrl: recommendUrl,
                            buttonText: facebookButtonLabel,
                            uuid: model.id,
                            type: model.type
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $gFZ4z.TwitterShareButton), {
                            shareUrl: recommendUrl,
                            message: message,
                            buttonText: twitterButtonLabel,
                            uuid: model.id,
                            type: model.type
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $eHuqC.EmailShareButton), {
                            shareUrl: recommendUrl,
                            message: message,
                            buttonText: emailButtonLabel,
                            uuid: model.id,
                            type: model.type
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
var $28c1fbb05b3f988f$export$2e2bcd8739ae039 = $28c1fbb05b3f988f$var$UiRecommendShare;

});
parcelRegister("3wiG7", function(module, exports) {

$parcel$export(module.exports, "ShareButtons", function () { return $d589107f63ec4359$export$6065a61077043bd0; });
$parcel$export(module.exports, "ShareInput", function () { return $d589107f63ec4359$export$80b5ab06104b52be; });
$parcel$export(module.exports, "ShareLabel", function () { return $d589107f63ec4359$export$33f8314080e9cc7d; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $d589107f63ec4359$export$6065a61077043bd0 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "max-content")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "-0.5rem 0 0 -0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "calc(100% + 0.5rem)")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 0 0.5rem 0")}

    > * {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0.5rem 0 0 0.5rem")}
    }

    @media screen and (min-width: 576px) {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
    }
`;
const $d589107f63ec4359$export$80b5ab06104b52be = (0, $hYbro.styled).input`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N20")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border", `1px solid ${(0, $i2LPb.colorCSS)("N60")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.3rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 0.75rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $d589107f63ec4359$export$33f8314080e9cc7d = (0, $hYbro.styled).label`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N100")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
`;

});



parcelRegister("8EnPN", function(module, exports) {

$parcel$export(module.exports, "UiRotatingImages", function () { return (parcelRequire("5eeJ9")).default; });

var $5eeJ9 = parcelRequire("5eeJ9");

});
parcelRegister("5eeJ9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48b217167ab6446d$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $dS1rq = parcelRequire("dS1rq");

var $33PqJ = parcelRequire("33PqJ");

var $hbngr = parcelRequire("hbngr");
const $48b217167ab6446d$var$UiRotatingImages = ({ model: model })=>{
    const [updatedAt, setUpdatedAt] = (0, $iSvIT.useState)(0);
    /**
   * initialized with reverse order because stacked grid
   * displays last item on top
   */ const items = (0, $dS1rq.useCyclingOrder)([
        ...model.content.items
    ].reverse(), updatedAt, true);
    const onAnimationEnd = ()=>{
        setUpdatedAt(Date.now());
    };
    const displayDuration = 5000;
    const transitionDuration = 500;
    if (items.length < 2) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: (0, $33PqJ.renderViewModels)(items)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $hbngr.Container), {
        children: items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $hbngr.RotatingItem), {
                hasAnimation: index === items.length - 1,
                displayDuration: displayDuration,
                transistionDuration: transitionDuration,
                onAnimationEnd: onAnimationEnd,
                children: (0, $33PqJ.renderViewModel)(item)
            }, item.id))
    });
};
var $48b217167ab6446d$export$2e2bcd8739ae039 = $48b217167ab6446d$var$UiRotatingImages;

});
parcelRegister("hbngr", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $d8b8400b2166bfbe$export$42a852a2b6b56249; });
$parcel$export(module.exports, "RotatingItem", function () { return $d8b8400b2166bfbe$export$147f22a28c3d15f3; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
function $d8b8400b2166bfbe$export$623f4224d6d6ed27(displayDuration, transitionDuration, reduceMotion) {
    const totalTime = displayDuration + transitionDuration * 2;
    let inPercent = transitionDuration / totalTime * 100;
    let movePercent = 5;
    //if user prefers reduced motion, don't move the image and fade in/out twice as fast
    if (reduceMotion) {
        inPercent = inPercent / 2;
        movePercent = 0;
    }
    return (0, $hYbro.keyframes)`
        0% {
            opacity: 0;
            transform: translateX(${movePercent}%);
        }
        ${inPercent.toFixed(6)}% {
            opacity: 1;
            transform: translateX(0);
        }
        ${(100 - inPercent).toFixed(6)}% {
            opacity: 1;
            transform: translateX(0);
        }
        100% {
            opacity: 0;
            transform: translateX(-${movePercent}%);
        }
    `;
}
const $d8b8400b2166bfbe$export$42a852a2b6b56249 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "100%")}
`;
const $d8b8400b2166bfbe$export$147f22a28c3d15f3 = (0, $hYbro.styled).div`
    animation-duration: ${({ hasAnimation: hasAnimation, displayDuration: displayDuration, transistionDuration: transistionDuration })=>hasAnimation ? `${displayDuration + transistionDuration}ms` : "0ms"};
    animation-name: ${({ hasAnimation: hasAnimation, displayDuration: displayDuration, transistionDuration: transistionDuration })=>hasAnimation ? $d8b8400b2166bfbe$export$623f4224d6d6ed27(displayDuration, transistionDuration) : "none"};
    animation-timing-function: ease-out;
    display: flex;
    grid-column: 1;
    grid-row: 1;
    height: 100%;
    opacity: 0;
    position: relative;

    @media (prefers-reduced-motion: reduce) {
        animation-name: ${({ hasAnimation: hasAnimation, displayDuration: displayDuration, transistionDuration: transistionDuration })=>hasAnimation ? $d8b8400b2166bfbe$export$623f4224d6d6ed27(displayDuration, transistionDuration, true) : "none"};
    }
`;

});



parcelRegister("l5K6U", function(module, exports) {

$parcel$export(module.exports, "UiRotatingItems", function () { return (parcelRequire("2mYBG")).default; });

var $2mYBG = parcelRequire("2mYBG");

});
parcelRegister("2mYBG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5979352f9038b04b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $dS1rq = parcelRequire("dS1rq");

var $33PqJ = parcelRequire("33PqJ");

var $lzB97 = parcelRequire("lzB97");
const $5979352f9038b04b$var$UiRotatingItems = ({ model: model })=>{
    const [updatedAt, setUpdatedAt] = (0, $iSvIT.useState)(0);
    /**
   * initialized with reverse order because stacked grid
   * displays last item on top
   */ const items = (0, $dS1rq.useCyclingOrder)([
        ...model.content.items
    ].reverse(), updatedAt, true);
    const onAnimationEnd = ()=>{
        setUpdatedAt(Date.now());
    };
    const displayDuration = 5000;
    const transitionDuration = 1000;
    if (items.length < 2) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: (0, $33PqJ.renderViewModels)(items)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lzB97.Container), {
        children: items.map((item, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $lzB97.RotatingItem), {
                hasAnimation: index === items.length - 1,
                displayDuration: displayDuration,
                transistionDuration: transitionDuration,
                onAnimationEnd: onAnimationEnd,
                children: (0, $33PqJ.renderViewModel)(item)
            }, item.id))
    });
};
var $5979352f9038b04b$export$2e2bcd8739ae039 = $5979352f9038b04b$var$UiRotatingItems;

});
parcelRegister("lzB97", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $0c5c8faacf09e6f4$export$42a852a2b6b56249; });
$parcel$export(module.exports, "RotatingItem", function () { return $0c5c8faacf09e6f4$export$147f22a28c3d15f3; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
function $0c5c8faacf09e6f4$export$623f4224d6d6ed27(displayDuration, transitionDuration) {
    const totalTime = displayDuration + transitionDuration;
    const transitionEventRawValue = displayDuration / totalTime * 100;
    const transitionEventPercent = `${transitionEventRawValue.toFixed(6)}%`;
    return (0, $hYbro.keyframes)`
        0% {
            opacity: 1;
        }
        ${transitionEventPercent} {
            opacity: 1;
        }
        100% {
            opacity: 0;
        }
    `;
}
const $0c5c8faacf09e6f4$export$42a852a2b6b56249 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
    ${(0, $jAJVK.redundantCssFromKebab)("grid-template-columns", "100%")}
`;
const $0c5c8faacf09e6f4$export$147f22a28c3d15f3 = (0, $hYbro.styled).div`
    animation-name: ${({ hasAnimation: hasAnimation, displayDuration: displayDuration, transistionDuration: transistionDuration })=>hasAnimation ? $0c5c8faacf09e6f4$export$623f4224d6d6ed27(displayDuration, transistionDuration) : "none"};
    animation-duration: ${({ hasAnimation: hasAnimation, displayDuration: displayDuration, transistionDuration: transistionDuration })=>hasAnimation ? `${displayDuration + transistionDuration}ms` : "0ms"};
    animation-timing-function: ease-out;
    opacity: ${({ hasAnimation: hasAnimation })=>hasAnimation ? 0 : 1};
    display: flex;
    grid-row: 1;
    grid-column: 1;
    height: 100%;
    position: relative;

    > .ui-section {
        height: 100%;
        width: 100%;
        display: flex;

        .ui-section__container,
        .ui-section__row {
            width: 100%;
            height: 100%;
            display: flex;
        }
    }
`;

});



parcelRegister("i8HBj", function(module, exports) {

$parcel$export(module.exports, "UiSection", function () { return (parcelRequire("UWh9s")).default; });

var $UWh9s = parcelRequire("UWh9s");

});
parcelRegister("UWh9s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $40aa7959ca4df46e$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");
var $bQJY8 = parcelRequire("bQJY8");

var $YK6Zf = parcelRequire("YK6Zf");
const $40aa7959ca4df46e$var$UiSection = ({ model: model })=>{
    const { title: title, columns: columns = [], background: background = null, elementId: elementId, sectionBackground: sectionBackground, verticalAlign: verticalAlign } = model.content;
    const hasSectionBackground = Array.isArray(sectionBackground) && sectionBackground.length > 0;
    const shouldUseInlineBackgroundFallback = !hasSectionBackground && !!background && (Boolean(background.color) || Boolean(background.gradient));
    const fallbackColors = shouldUseInlineBackgroundFallback ? (0, $54E1V.getColorsFromBackgroundField)(background) : {};
    const sectionStyle = shouldUseInlineBackgroundFallback ? {
        background: fallbackColors.background,
        color: fallbackColors.color
    } : undefined;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $YK6Zf.Section), {
        id: elementId,
        className: "ui-section",
        overflowingBreakpoints: $40aa7959ca4df46e$var$getOverflowingBreakpoints(columns),
        sectionBackground: sectionBackground,
        background: background,
        style: sectionStyle,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
            className: "ui-section__container",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                className: "ui-section__row",
                verticalAlign: verticalAlign,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                    value: {
                        eventContainer: "uiSection",
                        labelEnglish: title
                    },
                    children: (0, $33PqJ.renderViewModels)(columns)
                })
            })
        })
    });
};
//determine which breakpoints (xs, sm, etc) overflow the 12 column grid
//verbose to avoid ts error "type 'string' can't be used to index type ColumnProperties"
function $40aa7959ca4df46e$var$getOverflowingBreakpoints(columns) {
    const breakpointKeys = Object.keys((0, $bQJY8.breakpoints));
    return columns.reduce((overflowingBreakpoints, column)=>{
        const { properties: properties } = column.content;
        if ((0, $5l0yg.isColumnProperties)(properties)) breakpointKeys.filter((breakpoint)=>!overflowingBreakpoints.includes(breakpoint) && ($40aa7959ca4df46e$var$propertyHasNegativeOffset(properties[breakpoint]) || $40aa7959ca4df46e$var$propertyHasNegativePush(properties[breakpoint]) || $40aa7959ca4df46e$var$propertyExceedsSpan(properties[breakpoint]))).forEach((breakpoint)=>overflowingBreakpoints.push(breakpoint));
        return overflowingBreakpoints;
    }, []);
}
function $40aa7959ca4df46e$var$propertyHasNegativeOffset(property) {
    return property?.offset && parseInt(property.offset) < 0;
}
function $40aa7959ca4df46e$var$propertyHasNegativePush(property) {
    return property?.push && parseInt(property.push) < 0;
}
function $40aa7959ca4df46e$var$propertyExceedsSpan(property) {
    if (!property) return false;
    const span = property.span ? parseInt(property.span) : 0;
    const push = property.push ? parseInt(property.push) : 0;
    const offset = property.offset ? parseInt(property.offset) : 0;
    return span + push + offset > 12;
}
var $40aa7959ca4df46e$export$2e2bcd8739ae039 = $40aa7959ca4df46e$var$UiSection;

});
parcelRegister("YK6Zf", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $a2684d9d09e82582$export$6e2c8f0811a474ce; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $2EK56 = parcelRequire("2EK56");
var $54E1V = parcelRequire("54E1V");
var $2vQ6x = parcelRequire("2vQ6x");
var $aT9Ik = parcelRequire("aT9Ik");
const $a2684d9d09e82582$export$6e2c8f0811a474ce = (0, $hYbro.styled).section(({ background: background, sectionBackground: sectionBackground })=>sectionBackground ? (0, $2EK56.generateFieldsStyles)(sectionBackground) : background && (background.color || background.gradient) ? (0, $54E1V.cssColorsFromBackgroundField)(background) : "", ({ overflowingBreakpoints: overflowingBreakpoints })=>$a2684d9d09e82582$var$generateOverflowMediaQueries(overflowingBreakpoints), {
    scrollMarginTop: `${(0, $2vQ6x.scrollMargin).top}px`
});
//for each breakpoint that is overflowing, generate a media query to hide x-overflow
function $a2684d9d09e82582$var$generateOverflowMediaQueries(overflowingBreakpoints) {
    return overflowingBreakpoints.map((breakpoint)=>breakpoint === "xs" ? `overflow-x: hidden;` : `
        @media ${(0, $aT9Ik.minWidth)[breakpoint]} {
          overflow-x: hidden;
        }
      `).join("");
}

});



parcelRegister("5Zoby", function(module, exports) {

$parcel$export(module.exports, "UiSectionGroup", function () { return (parcelRequire("iCJRs")).default; });

var $iCJRs = parcelRequire("iCJRs");

});
parcelRegister("iCJRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da46648e97af50c4$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $33PqJ = parcelRequire("33PqJ");

var $6DkOr = parcelRequire("6DkOr");
const $da46648e97af50c4$var$UiSectionGroup = ({ model: { content: { sections: sections, background: background } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $6DkOr.SectionGroup), {
        background: background,
        children: (0, $33PqJ.renderViewModels)(sections)
    });
};
var $da46648e97af50c4$export$2e2bcd8739ae039 = $da46648e97af50c4$var$UiSectionGroup;

});
parcelRegister("6DkOr", function(module, exports) {

$parcel$export(module.exports, "SectionGroup", function () { return $100fc91d475719a3$export$b21cfa2051742f48; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $2EK56 = parcelRequire("2EK56");
const $100fc91d475719a3$export$b21cfa2051742f48 = (0, $hYbro.styled).div(({ background: background })=>background && (0, $2EK56.generateFieldsStyles)(background));

});



parcelRegister("daM1b", function(module, exports) {

$parcel$export(module.exports, "UiSocialProof", function () { return (parcelRequire("gZyDK")).default; });

var $gZyDK = parcelRequire("gZyDK");

});
parcelRegister("gZyDK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a4b6348f401def2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");

var $fkxGn = parcelRequire("fkxGn");
const $0a4b6348f401def2$var$UiSocialProof = ({ model: { id: id, type: type, content: { background: background, customerDetails: customerDetails, customerLogoImage: customerLogoImage, customerName: customerName, customerQuote: customerQuote, customerStoryLink: customerStoryLink, entryTitle: entryTitle, productFact: productFact, productFactLink: productFactLink } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: type,
            parentLabel: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fkxGn.ShadowWrapper), {
            children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fkxGn.SocialProof), {
                "data-uuid": id,
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fkxGn.QuoteFigure), {
                        background: background,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fkxGn.Quote), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                    document: customerQuote
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fkxGn.QuoteCaption), {
                                children: [
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        children: customerName
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                        children: customerDetails
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fkxGn.QuoteImageLink), {
                                        children: [
                                            customerLogoImage && (0, $33PqJ.renderViewModel)(customerLogoImage),
                                            customerStoryLink && (0, $33PqJ.renderViewModel)(customerStoryLink)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $fkxGn.ProductFact), {
                        background: background,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                children: productFact
                            }),
                            productFactLink && /*#__PURE__*/ (0, $loA2J.jsx)((0, $fkxGn.ProductFactLink), {
                                children: (0, $33PqJ.renderViewModel)(productFactLink)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $0a4b6348f401def2$export$2e2bcd8739ae039 = $0a4b6348f401def2$var$UiSocialProof;

});
parcelRegister("fkxGn", function(module, exports) {

$parcel$export(module.exports, "ProductFact", function () { return $8185f19dd8c470b3$export$d6fe9d88cf2c078b; });
$parcel$export(module.exports, "ProductFactLink", function () { return $8185f19dd8c470b3$export$f7374ca68a037573; });
$parcel$export(module.exports, "Quote", function () { return $8185f19dd8c470b3$export$82b8d343c504672; });
$parcel$export(module.exports, "QuoteCaption", function () { return $8185f19dd8c470b3$export$e5080f00770a4efa; });
$parcel$export(module.exports, "QuoteFigure", function () { return $8185f19dd8c470b3$export$e3a87e2262766a2b; });
$parcel$export(module.exports, "QuoteImageLink", function () { return $8185f19dd8c470b3$export$8f189b6e57d96683; });
$parcel$export(module.exports, "SocialProof", function () { return $8185f19dd8c470b3$export$d0fb2e88e6204069; });
$parcel$export(module.exports, "ShadowWrapper", function () { return $8185f19dd8c470b3$export$4ebb490b3ccfc72f; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $aT9Ik = parcelRequire("aT9Ik");
var $8korH = parcelRequire("8korH");
var $2EK56 = parcelRequire("2EK56");
var $7XWgk = parcelRequire("7XWgk");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
var $aKIz7 = parcelRequire("aKIz7");

var $jAJVK = parcelRequire("jAJVK");
const $8185f19dd8c470b3$var$sharedContainerStyles = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "2rem")}

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding", "2.5rem 2rem")}
    }
`;
const $8185f19dd8c470b3$export$d6fe9d88cf2c078b = (0, $hYbro.styled).div`
    ${$8185f19dd8c470b3$var$sharedContainerStyles}

    ${({ background: background })=>(0, $8korH.isBackgroundFieldArray)(background) && (0, $2EK56.generateFieldsStyles)(background)}
    
    h3 {
        ${(0, $7XWgk.h2)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "33.3333%")}
    }
`;
const $8185f19dd8c470b3$export$f7374ca68a037573 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "1rem")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "2rem")}
    }
`;
const $8185f19dd8c470b3$export$82b8d343c504672 = (0, $hYbro.styled).blockquote`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).lg}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

    > div p:last-child {
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "0")}
    }
`;
const $8185f19dd8c470b3$export$e5080f00770a4efa = (0, $hYbro.styled).figcaption`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "1rem")}

    &:before {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", "currentColor")}
        ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "1px")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "9rem")}
    }

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "3.25rem")}
    }
`;
const $8185f19dd8c470b3$export$e3a87e2262766a2b = (0, $hYbro.styled).figure`
    ${$8185f19dd8c470b3$var$sharedContainerStyles}

    ${({ background: background })=>{
    const gradient = $8185f19dd8c470b3$var$getGradientFromBackground(background);
    if (!gradient) return;
    return `
            background-image: url("data:image/svg+xml,%3Csvg fill='none' height='272' width='773' xmlns='http://www.w3.org/2000/svg' %3E%3Cpath d='M351.53 186.369c0-53.88-28.777-83.707-84.412-83.707h-.96c11.511-29.826 48.921-45.22 97.842-48.107V-33c-126.619 6.735-196.643 77.934-196.643 185.694 0 85.631 40.288 119.306 94.964 119.306 54.677 0 89.209-32.713 89.209-85.631Zm-203.357 0c0-53.88-28.777-83.707-84.413-83.707h-.959c11.51-29.826 48.921-45.22 97.842-48.107V-33C34.024-26.265-36 44.934-36 152.694-36 238.325 4.288 272 58.964 272s89.209-32.713 89.209-85.631Z' fill='url(%23b)' opacity='.15' /%3E%3Cdefs%3E%3ClinearGradient id='b' x1='290.667' y1='-33' x2='141.42' y2='307.405' gradientUnits='userSpaceOnUse' %3E%3Cstop stop-color='${(0, $i2LPb.colorCSSforSVG)(gradient.colors[1])}' /%3E%3Cstop stop-color='${(0, $i2LPb.colorCSSforSVG)(gradient.colors[0])}' offset='1' /%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E");
            background-repeat: no-repeat;
        `;
}}
    
    @media ${(0, $aT9Ik.minWidth).lg} {
        width: 66.6666%;
    }
`;
const $8185f19dd8c470b3$export$8f189b6e57d96683 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "auto")}

    a,
    img {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}
    }

    img {
        ${(0, $jAJVK.redundantCssFromKebab)("max-height", "2.25rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("align-items", "baseline")}
        ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
        ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-between")}

        a,
        img {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1.5rem")}
        }
    }
`;
const $8185f19dd8c470b3$export$d0fb2e88e6204069 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
    box-shadow: 0px 3px 5px ${(0, $i2LPb.colorCSS)("N900", 0.2)},
        0px 0px 1px ${(0, $i2LPb.colorCSS)("N900", 0.31)};
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "column")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-between")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-direction", "row")}
    }
`;
const $8185f19dd8c470b3$export$4ebb490b3ccfc72f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1px 0.5rem 0.5rem")}
`;
//get first gradient from background field
function $8185f19dd8c470b3$var$getGradientFromBackground(backgrounds) {
    if (!(0, $8korH.isBackgroundFieldArray)(backgrounds)) return;
    const backgroundsWithGradients = backgrounds.filter((background)=>background.properties.filter((property)=>property.image.gradient));
    const gradient = backgroundsWithGradients[0]?.properties[0]?.image.gradient.value;
    if (!gradient || !(0, $aKIz7.gradientExists)(gradient)) return;
    return (0, $aKIz7.gradients)[gradient];
}

});



parcelRegister("48HDR", function(module, exports) {

$parcel$export(module.exports, "UiSocialShare", function () { return (parcelRequire("hTq4R")).default; });

var $hTq4R = parcelRequire("hTq4R");

});
parcelRegister("hTq4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $890befb0b3f0da1b$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
var $5PhOG = parcelRequire("5PhOG");
var $gFZ4z = parcelRequire("gFZ4z");
const $890befb0b3f0da1b$var$UiSocialShare = ({ model: { id: id, type: type, content: { text: text, facebookButtonText: facebookButtonText, twitterButtonText: twitterButtonText, hashtags: hashtags } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5l0yg.Row), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    top: "tight",
                    bottom: "tight"
                },
                sm: {
                    span: "6"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5PhOG.FacebookShareButton), {
                    block: true,
                    buttonText: facebookButtonText,
                    uuid: id,
                    type: type
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                xs: {
                    top: "tight",
                    bottom: "tight"
                },
                sm: {
                    span: "6"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $gFZ4z.TwitterShareButton), {
                    block: true,
                    buttonText: twitterButtonText,
                    message: text,
                    hashtags: hashtags,
                    uuid: id,
                    type: type
                })
            })
        ]
    });
};
var $890befb0b3f0da1b$export$2e2bcd8739ae039 = $890befb0b3f0da1b$var$UiSocialShare;

});


parcelRegister("fbvTT", function(module, exports) {

$parcel$export(module.exports, "UiSpacer", function () { return (parcelRequire("igwoQ")).default; });

var $igwoQ = parcelRequire("igwoQ");

});
parcelRegister("igwoQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6af2d4cda152c2eb$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $bX04a = parcelRequire("bX04a");
const $6af2d4cda152c2eb$var$UiSpacer = ({ model: { content: { size: size } } })=>{
    const spacing = {
        "1": {
            desktop: "0.5rem",
            mobile: "0.25rem"
        },
        "2": {
            desktop: "1rem",
            mobile: "0.5rem"
        },
        "3": {
            desktop: "1.5rem",
            mobile: "1rem"
        },
        "4": {
            desktop: "2rem",
            mobile: "1.5rem"
        },
        "5": {
            desktop: "3rem",
            mobile: "2rem"
        },
        "6": {
            desktop: "4rem",
            mobile: "3rem"
        },
        "7": {
            desktop: "6rem",
            mobile: "4rem"
        },
        "8": {
            desktop: "8rem",
            mobile: "6rem"
        }
    };
    const getSpacingSize = (size, screen)=>spacing[size][screen];
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $bX04a.Spacer), {
        desktop: getSpacingSize(size, "desktop"),
        mobile: getSpacingSize(size, "mobile")
    });
};
var $6af2d4cda152c2eb$export$2e2bcd8739ae039 = $6af2d4cda152c2eb$var$UiSpacer;

});
parcelRegister("bX04a", function(module, exports) {

$parcel$export(module.exports, "Spacer", function () { return $5495375e6ea216dc$export$d7a54cba636a8cd6; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $5495375e6ea216dc$export$d7a54cba636a8cd6 = (0, $hYbro.styled).div(({ desktop: desktop, mobile: mobile })=>`
    ${(0, $jAJVK.redundantCssFromKebab)("height", `${mobile}`)}
    @media (min-width: 768px) {
      ${(0, $jAJVK.redundantCssFromKebab)("height", `${desktop}`)}
    }
  `);

});



parcelRegister("7IaHu", function(module, exports) {

$parcel$export(module.exports, "UiSplitSection", function () { return (parcelRequire("afuz0")).default; });

var $afuz0 = parcelRequire("afuz0");

});
parcelRegister("afuz0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0efa37bdc13b8429$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $yF2IO = parcelRequire("yF2IO");

var $33PqJ = parcelRequire("33PqJ");

var $7UAVm = parcelRequire("7UAVm");
const $0efa37bdc13b8429$var$UiSplitSection = ({ model: model })=>{
    const { entryTitle: entryTitle, useEyebrowLogo: useEyebrowLogo, columnsLeft: columnsLeft = [], columnsRight: columnsRight = [], backgroundLeft: backgroundLeft = null, backgroundRight: backgroundRight = null, footer: footer } = model.content;
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7UAVm.SectionWrapper), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7UAVm.SectionLeft), {
                        background: backgroundLeft,
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)("header", {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                            xs: {
                                                align: "left"
                                            },
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                                href: "/home",
                                                onClick: ()=>sendTrackEvent("clickedUiSplitSectionNavLogo", {
                                                        ...analyticsAttributes,
                                                        event: "clicked",
                                                        eventComponent: "logo",
                                                        label: "Trello logo",
                                                        labelEnglish: "Trello logo",
                                                        href: "/home"
                                                    }),
                                                testId: "logo_link",
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $yF2IO.LogoTrello), {
                                                    height: useEyebrowLogo ? 42 : 25,
                                                    appearance: "blue",
                                                    eyebrow: useEyebrowLogo
                                                })
                                            })
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                        value: {
                                            eventContainer: model.type,
                                            labelEnglish: entryTitle
                                        },
                                        children: (0, $33PqJ.renderViewModels)(columnsLeft)
                                    })
                                })
                            }),
                            footer && (0, $33PqJ.renderViewModel)(footer)
                        ]
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7UAVm.SectionRight), {
                        background: backgroundRight,
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                                    value: {
                                        eventContainer: model.type,
                                        labelEnglish: entryTitle
                                    },
                                    children: (0, $33PqJ.renderViewModels)(columnsRight)
                                })
                            })
                        })
                    })
                ]
            }),
            footer && (0, $33PqJ.renderViewModel)(footer)
        ]
    });
};
var $0efa37bdc13b8429$export$2e2bcd8739ae039 = $0efa37bdc13b8429$var$UiSplitSection;

});
parcelRegister("7UAVm", function(module, exports) {

$parcel$export(module.exports, "SectionWrapper", function () { return $b20d868427d30882$export$6dc9c7a2fd68ee6d; });
$parcel$export(module.exports, "SectionLeft", function () { return $b20d868427d30882$export$886611e0fac312f4; });
$parcel$export(module.exports, "SectionRight", function () { return $b20d868427d30882$export$2f6b3bb16902a1b3; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $aT9Ik = parcelRequire("aT9Ik");
var $54E1V = parcelRequire("54E1V");

var $jAJVK = parcelRequire("jAJVK");
const $b20d868427d30882$export$6dc9c7a2fd68ee6d = (0, $hYbro.styled).div`
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "grid")}
        ${(0, $jAJVK.redundantCssFromKebab)("grid-auto-columns", "40fr 60fr")}
        ${(0, $jAJVK.redundantCssFromKebab)("grid-auto-flow", "column")}
        ${(0, $jAJVK.redundantCssFromKebab)("min-height", "100vh")}

        + footer {
            ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
        }
    }
`;
const $b20d868427d30882$var$sharedSectionStyles = (0, $hYbro.css)`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-flow", "column")}
`;
const $b20d868427d30882$export$886611e0fac312f4 = (0, $hYbro.styled).section(({ background: background })=>background && (0, $54E1V.cssColorsFromBackgroundField)(background), {
    [`${$b20d868427d30882$var$sharedSectionStyles} header`]: {
        "@media (min-width: 992px)": {
            marginTop: "1.5rem",
            marginLeft: "1.5rem"
        }
    },
    footer: {
        "display": "none",
        "marginTop": "auto",
        "@media (min-width: 992px)": {
            display: "block"
        }
    }
});
const $b20d868427d30882$export$2f6b3bb16902a1b3 = (0, $hYbro.styled).section(({ background: background })=>background && (0, $54E1V.cssColorsFromBackgroundField)(background), $b20d868427d30882$var$sharedSectionStyles);

});



parcelRegister("eWbFa", function(module, exports) {

$parcel$export(module.exports, "UiStack", function () { return (parcelRequire("fwgmr")).default; });

var $fwgmr = parcelRequire("fwgmr");

});
parcelRegister("fwgmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e30b49a0e41bbfba$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $j30bs = parcelRequire("j30bs");

var $33PqJ = parcelRequire("33PqJ");
const $e30b49a0e41bbfba$var$UiStack = ({ model: { content: { orientation: orientation, children: children, spacing: spacing, fullHeight: fullHeight } } })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $j30bs.Stack), {
        "data-testid": "stack",
        orientation: orientation,
        spacing: spacing,
        fullHeight: fullHeight,
        children: children && (0, $33PqJ.renderViewModels)(children)
    });
};
var $e30b49a0e41bbfba$export$2e2bcd8739ae039 = $e30b49a0e41bbfba$var$UiStack;

});


parcelRegister("jdSVj", function(module, exports) {

$parcel$export(module.exports, "UiStatuspage", function () { return (parcelRequire("7eagl")).default; });

var $7eagl = parcelRequire("7eagl");

});
parcelRegister("7eagl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05bebc0b9a0dffe4$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $aYuhG = parcelRequire("aYuhG");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $bQ73S = parcelRequire("bQ73S");
async function $05bebc0b9a0dffe4$var$fetchStatus(statuspageId) {
    const apiUrl = `https://${statuspageId}.statuspage.io/api/v2/status.json`;
    const response = await (0, (/*@__PURE__*/$parcel$interopDefault($aYuhG)))(apiUrl);
    const content = await response.json();
    return content.status.indicator;
}
const $05bebc0b9a0dffe4$var$UiStatuspage = ({ model: model, status: status })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const [indicator, setIndicator] = (0, $iSvIT.useState)(status);
    const { statuspageId: statuspageId, url: url } = model.content;
    (0, $iSvIT.useEffect)(()=>{
        //local variable to prevent memory leak
        let isCancelled = false;
        if (!status) //get current status from statuspage
        $05bebc0b9a0dffe4$var$fetchStatus(statuspageId).then((fetchedIndicator)=>{
            if (!isCancelled) setIndicator(fetchedIndicator);
        }).catch((e)=>{
            console.error(e);
        });
        return ()=>{
            isCancelled = true;
        };
    }, [
        status,
        statuspageId
    ]);
    return indicator ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $bQ73S.Link), {
        indicator: indicator,
        href: url,
        target: "_blank",
        onClick: ()=>{
            sendTrackEvent("clickedUiStatuspage", {
                event: "clicked",
                eventComponent: model.type,
                eventContainer: "uiColumn",
                label: model.content[indicator],
                labelEnglish: indicator,
                uuid: model.id,
                href: url
            });
        },
        "data-uuid": model.id,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            children: model.content[indicator]
        })
    }) : null;
};
var $05bebc0b9a0dffe4$export$2e2bcd8739ae039 = $05bebc0b9a0dffe4$var$UiStatuspage;

});
parcelRegister("bQ73S", function(module, exports) {

$parcel$export(module.exports, "Link", function () { return $c1914f8ebe968a0c$export$a6c7ac8248d6e38a; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $kL1mL = parcelRequire("kL1mL");
var $i2LPb = parcelRequire("i2LPb");
const $c1914f8ebe968a0c$export$a6c7ac8248d6e38a = (0, $hYbro.styled).a({
    border: "1px solid transparent",
    borderRadius: (0, $fpcku.radius).button,
    display: "inline-flex",
    fontSize: (0, $kL1mL.fontSizes).md,
    padding: "0.4rem 1.5rem 0.5rem",
    textDecoration: "none"
}, ({ indicator: indicator })=>indicator == "none" && `background-color: ${(0, $i2LPb.colorCSS)("G400")};
    border-color: ${(0, $i2LPb.colorCSS)("G400")};
    color: ${(0, $i2LPb.colorCSS)("N0")};
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)("G500")};
      border-color: ${(0, $i2LPb.colorCSS)("G500")};
      color: ${(0, $i2LPb.colorCSS)("N0")};
    }`, ({ indicator: indicator })=>indicator == "minor" && `background-color: ${(0, $i2LPb.colorCSS)("Y200")};
    border-color: ${(0, $i2LPb.colorCSS)("Y200")};
    color: ${(0, $i2LPb.colorCSS)("N900")};
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)("Y300")};
      border-color: ${(0, $i2LPb.colorCSS)("Y300")};
      color: ${(0, $i2LPb.colorCSS)("N900")};
    }`, ({ indicator: indicator })=>indicator == "major" && `background-color: ${(0, $i2LPb.colorCSS)("Y400")};
    border-color: ${(0, $i2LPb.colorCSS)("Y400")};
    color: ${(0, $i2LPb.colorCSS)("N900")};
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)("Y500")};
      border-color: ${(0, $i2LPb.colorCSS)("Y500")};
      color: ${(0, $i2LPb.colorCSS)("N900")};
    }`, ({ indicator: indicator })=>indicator == "critical" && `background-color: ${(0, $i2LPb.colorCSS)("R400")};
    border-color: ${(0, $i2LPb.colorCSS)("R400")};
    color: ${(0, $i2LPb.colorCSS)("N0")};
    &:hover {
      background-color: ${(0, $i2LPb.colorCSS)("R500")};
      border-color: ${(0, $i2LPb.colorCSS)("R500")};
      color: ${(0, $i2LPb.colorCSS)("N0")};
    }`);

});



parcelRegister("9xxJV", function(module, exports) {

$parcel$export(module.exports, "UiStoryline", function () { return (parcelRequire("ll4BP")).default; });

var $ll4BP = parcelRequire("ll4BP");

});
parcelRegister("ll4BP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e2f41d82ab1297$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $7AG7X = parcelRequire("7AG7X");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");

var $33PqJ = parcelRequire("33PqJ");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");

var $2G2le = parcelRequire("2G2le");
const $57e2f41d82ab1297$var$UiStoryline = ({ model: model })=>{
    const { stories: stories, background: background } = model.content;
    const refs = (0, $iSvIT.useRef)([]);
    (0, $iSvIT.useEffect)(()=>{
        //check the stories to see if they're higher than the window midpoint
        const checkStories = (0, (/*@__PURE__*/$parcel$interopDefault($7AG7X)))(()=>{
            const midpoint = window.innerHeight / 2 - 90; //90 for the dot's margin-top
            refs.current.forEach((div)=>{
                div.classList.toggle("active", div.getBoundingClientRect().top < midpoint);
            });
        }, 100);
        //fire on render in case
        checkStories();
        //add event listener
        window.addEventListener("scroll", checkStories, {
            passive: true
        });
        //clean up event listener when unmounting
        return ()=>{
            window.removeEventListener("scroll", checkStories);
        };
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $2G2le.Storyline), {
        "data-testid": "storyline",
        ...(0, $54E1V.getColorsFromBackgroundField)(background),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
            children: stories.map(({ content: content }, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $2G2le.StorylineRow), {
                    // @ts-ignore - Ref callback type incompatibility
                    ref: (div)=>refs.current[index] = div,
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                            xs: {
                                top: "cozy"
                            },
                            md: {
                                align: "right",
                                bottom: "comfortable",
                                right: "cozy",
                                span: "6",
                                top: "comfortable"
                            },
                            children: (0, $33PqJ.renderViewModel)(content.content)
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                            xs: {
                                align: "left",
                                bottom: "cozy"
                            },
                            md: {
                                bottom: "comfortable",
                                left: "cozy",
                                span: "6",
                                top: "comfortable"
                            },
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
                                document: content.caption
                            })
                        })
                    ]
                }, index))
        })
    });
};
var $57e2f41d82ab1297$export$2e2bcd8739ae039 = $57e2f41d82ab1297$var$UiStoryline;

});
parcelRegister("2G2le", function(module, exports) {

$parcel$export(module.exports, "Storyline", function () { return $473da47dc53aeb1c$export$6066bbab274c29fe; });
$parcel$export(module.exports, "StorylineRow", function () { return $473da47dc53aeb1c$export$75093026e742bea0; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $aKIz7 = parcelRequire("aKIz7");

var $jAJVK = parcelRequire("jAJVK");
const $473da47dc53aeb1c$var$borderWidth = 6; //px
const $473da47dc53aeb1c$var$dotSize = 2.25; //rem
const $473da47dc53aeb1c$export$6066bbab274c29fe = ({ background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        ...background && {
            background: background
        },
        ...color && {
            color: color
        }
    };
    // Note: Media queries and pseudo-elements (::after) cannot be applied via inline styles in SSR
    // The vertical line and dot decorations would need CSS classes
    return /*#__PURE__*/ (0, $loA2J.jsx)("section", {
        style: style,
        ...props
    });
};
const $473da47dc53aeb1c$export$75093026e742bea0 = (0, $hYbro.styled)((0, $5l0yg.Row))`
    @media (min-width: 768px) {
        ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

        &:after {
            ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("P300")}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border", `${$473da47dc53aeb1c$var$borderWidth * 0.9}px solid currentColor`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
            ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
            ${(0, $jAJVK.redundantCssFromKebab)("height", `${$473da47dc53aeb1c$var$dotSize}rem`)}
            ${(0, $jAJVK.redundantCssFromKebab)("left", "50%")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", `${3.1 + $473da47dc53aeb1c$var$dotSize}rem 0 0 -${$473da47dc53aeb1c$var$dotSize / 2}rem`)}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", `${$473da47dc53aeb1c$var$dotSize}rem`)}
            ${(0, $jAJVK.redundantCssFromKebab)("z-index", "1")}
        }

        &.active:after {
            ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $aKIz7.gradientCSS)("WP300", 90)}`)}
        }
    }
`;

});



parcelRegister("dJcnZ", function(module, exports) {

$parcel$export(module.exports, "UiTemplateGallery", function () { return (parcelRequire("kFkUp")).default; });

var $kFkUp = parcelRequire("kFkUp");

});
parcelRegister("kFkUp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fec04ad151a93488$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");
parcelRequire("29PUl");
var $1k47M = parcelRequire("1k47M");
var $hVi3S = parcelRequire("hVi3S");

var $5Uefd = parcelRequire("5Uefd");
const $fec04ad151a93488$var$UiTemplateGalleryProps = ({ model: model })=>{
    const { templates: templates, carousel: carousel, reduced: reduced, horizontalAlignment: horizontalAlignment = "center" } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $5Uefd.Section), {
        "data-testid": "template-gallery",
        children: carousel ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $1k47M.default), {
            arrows: true,
            templates: templates,
            transitionTimeInSeconds: 0.6,
            reduced: reduced
        }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                align: horizontalAlignment,
                children: templates.filter(({ type: type })=>type === "trelloTemplate").map((template, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                        md: {
                            span: "6"
                        },
                        lg: {
                            span: "4"
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hVi3S.default), {
                            model: template,
                            reduced: reduced
                        })
                    }, index))
            })
        })
    });
};
var $fec04ad151a93488$export$2e2bcd8739ae039 = $fec04ad151a93488$var$UiTemplateGalleryProps;

});
parcelRegister("29PUl", function(module, exports) {

$parcel$export(module.exports, "FullWidthCarousel", function () { return (parcelRequire("1k47M")).default; });
$parcel$export(module.exports, "TrelloTemplate", function () { return (parcelRequire("hVi3S")).default; });

var $1k47M = parcelRequire("1k47M");

var $hVi3S = parcelRequire("hVi3S");

});
parcelRegister("1k47M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b39e25bc434cc4a2$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $1pYrM = parcelRequire("1pYrM");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");
var $kRXzx = parcelRequire("kRXzx");
parcelRequire("h6yBX");
var $8DhG7 = parcelRequire("8DhG7");

var $iR7dN = parcelRequire("iR7dN");

var $hVi3S = parcelRequire("hVi3S");
const $b39e25bc434cc4a2$var$FullWidthCarousel = ({ templates: templates, transitionTimeInSeconds: transitionTimeInSeconds = 0.3, arrows: arrows, prevArrowLabel: prevArrowLabel = "Previous", nextArrowLabel: nextArrowLabel = "Next", controlsAlignStart: controlsAlignStart = false, reduced: reduced })=>{
    const gapSize = 16;
    const [currentIndex, setCurrentIndex] = (0, $iSvIT.useState)(0);
    const [preventScroll, setPreventScroll] = (0, $iSvIT.useState)(false);
    const [windowWidth, setWindowWidth] = (0, $iSvIT.useState)(0);
    const [marginLeft, setMarginLeft] = (0, $iSvIT.useState)(0 - gapSize);
    const [linksDisabled, setLinksDisabled] = (0, $iSvIT.useState)(false);
    const [drag, setDrag] = (0, $iSvIT.useState)(null);
    const breakpoints = (0, $1pYrM.useBreakpoints)();
    //number of visible slides
    const show = breakpoints.includes("lg") ? 3 : 1;
    const slideWidth = breakpoints.includes("xl") ? (0, $8DhG7.containerWidths).xl / 3 : breakpoints.includes("lg") ? (0, $8DhG7.containerWidths).lg / 3 : breakpoints.includes("md") ? (0, $8DhG7.containerWidths).md * 5 / 6 : breakpoints.includes("sm") ? (0, $8DhG7.containerWidths).sm * 5 / 6 : windowWidth * 5 / 6;
    const atBeginning = typeof currentIndex !== "undefined" && currentIndex === 0;
    const atEnd = typeof currentIndex !== "undefined" && currentIndex >= templates.length - show;
    //analytics
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    //watch window width
    (0, $iSvIT.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    //move carousel (adjust marginLeft) when selectedIndex changes
    (0, $iSvIT.useEffect)(()=>{
        if (typeof currentIndex === "undefined") return;
        const newMargin = 0 - gapSize - currentIndex * slideWidth;
        setMarginLeft(newMargin);
    }, [
        currentIndex,
        breakpoints,
        windowWidth,
        slideWidth,
        templates.length
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (preventScroll) {
            document.body.classList.add("prevent-scroll");
            document.ontouchmove = (e)=>{
                e.preventDefault();
            };
        } else {
            document.body.classList.remove("prevent-scroll");
            document.ontouchmove = ()=>true;
        }
        return ()=>{
            document.body.classList.remove("prevent-scroll");
            document.ontouchmove = ()=>true;
        };
    }, [
        preventScroll
    ]);
    //listen to slide updates
    (0, $iSvIT.useEffect)(()=>{
        if (typeof currentIndex === "undefined") return;
        sendTrackEvent("carouselChanged", {
            ...analyticsAttributes,
            eventComponent: "carousel",
            event: "changed",
            label: `Slide ${currentIndex + 1}`,
            labelEnglish: `Slide ${currentIndex + 1}`
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [
        currentIndex
    ]);
    const next = ()=>{
        if (typeof currentIndex === "undefined") return;
        if (atEnd) {
            setMarginLeft(marginLeft - slideWidth / 5);
            setTimeout(()=>{
                setMarginLeft(marginLeft);
            }, 125);
        }
        const newIndex = Math.min(currentIndex + show, templates.length - show);
        setCurrentIndex(newIndex);
    };
    const prev = ()=>{
        if (typeof currentIndex === "undefined") return;
        if (atBeginning) {
            setMarginLeft(marginLeft + slideWidth / 5);
            setTimeout(()=>{
                setMarginLeft(marginLeft);
            }, 125);
        }
        const newIndex = Math.max(currentIndex - show, 0);
        setCurrentIndex(newIndex);
    };
    const dragStart = (x, y)=>{
        if (typeof currentIndex === "undefined") return;
        setDrag({
            dragStart: [
                x,
                y
            ],
            startingMargin: marginLeft,
            lastIndex: currentIndex
        });
        setLinksDisabled(true);
        setCurrentIndex(undefined);
    };
    const dragging = (x, y)=>{
        //check if drag started on carousel
        if (!drag) return;
        //exit if dragging vertically
        const horizontalOffset = x - drag.dragStart[0];
        const verticalOffset = y - drag.dragStart[1];
        if (Math.abs(horizontalOffset) < Math.abs(verticalOffset)) return;
        //horizontal touch, lock vertical scroll
        if (!preventScroll) setPreventScroll(true);
        //move track
        const dragAmount = horizontalOffset + drag.startingMargin;
        const maxAmount = 0;
        const minAmount = 0 - slideWidth * (templates.length - show) - (templates.length - 1) * gapSize;
        const friction = 3;
        const amountWithFriction = dragAmount > maxAmount ? dragAmount / friction : dragAmount < minAmount ? minAmount + (dragAmount - minAmount) / friction : dragAmount;
        setMarginLeft(amountWithFriction);
    };
    const dragEnd = (x)=>{
        if (!drag) return;
        const dragAmount = drag.dragStart[0] - x;
        const newIndex = Math.round(dragAmount / slideWidth) + drag.lastIndex;
        const max = templates.length - show;
        const useIndex = Math.max(0, Math.min(max, newIndex));
        if (Math.abs(dragAmount) > 20) //looks like a drag, keep links disabled for a beat
        setTimeout(()=>setLinksDisabled(false), 100);
        else //looks like a click, disable links right away
        setLinksDisabled(false);
        setPreventScroll(false);
        setCurrentIndex(useIndex);
        setDrag(null);
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iR7dN.Controls), {
                    alignStart: controlsAlignStart,
                    children: arrows && /*#__PURE__*/ (0, $loA2J.jsx)((0, $kRXzx.ArrowControls), {
                        next: next,
                        nextAriaDisabled: atEnd,
                        nextLabel: nextArrowLabel,
                        prevAriaDisabled: atBeginning,
                        prev: prev,
                        prevLabel: prevArrowLabel
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $iR7dN.DraggableContainer), {
                onTouchStart: ({ touches: touches })=>{
                    if (touches[0]) dragStart(touches[0].clientX, touches[0].clientY);
                },
                onTouchMove: ({ touches: touches })=>{
                    if (touches[0]) dragging(touches[0].clientX, touches[0].clientY);
                },
                onTouchEnd: ({ changedTouches: changedTouches })=>{
                    if (changedTouches[0]) dragEnd(changedTouches[0].clientX);
                },
                onMouseDown: (e)=>dragStart(e.clientX, e.clientY),
                onMouseMove: (e)=>dragging(e.clientX, e.clientY),
                onMouseUp: (e)=>dragEnd(e.clientX),
                onMouseLeave: (e)=>dragEnd(e.clientX),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                        style: {
                            marginLeft: marginLeft,
                            cursor: drag ? "grabbing" : "grab",
                            transition: drag ? "none" : `margin-left ${transitionTimeInSeconds}s ease`
                        },
                        children: templates.filter(({ type: type })=>type === "trelloTemplate").map((template, index)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                                xs: {
                                    span: "10"
                                },
                                lg: {
                                    span: "4"
                                },
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hVi3S.default), {
                                    model: template,
                                    reduced: reduced,
                                    disabled: linksDisabled
                                })
                            }, index))
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Container), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iR7dN.ScrollBar), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iR7dN.ScrollPosition), {
                        transitionTimeInSeconds: transitionTimeInSeconds,
                        style: {
                            width: `${100 / templates.length * show}%`,
                            left: `${(currentIndex ?? drag?.lastIndex ?? 0) / templates.length * 100}%`
                        }
                    })
                })
            })
        ]
    });
};
var $b39e25bc434cc4a2$export$2e2bcd8739ae039 = $b39e25bc434cc4a2$var$FullWidthCarousel;

});
parcelRegister("iR7dN", function(module, exports) {

$parcel$export(module.exports, "Controls", function () { return $ea26048dfd3ca217$export$c7c44baae9d9f25f; });
$parcel$export(module.exports, "DraggableContainer", function () { return $ea26048dfd3ca217$export$f8c33909bcff7bef; });
$parcel$export(module.exports, "ScrollBar", function () { return $ea26048dfd3ca217$export$342551df3dea21fb; });
$parcel$export(module.exports, "ScrollPosition", function () { return $ea26048dfd3ca217$export$f1829723616f2af0; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
const $ea26048dfd3ca217$export$c7c44baae9d9f25f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "space-around")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("z-index", "1")}
    justify-content: ${({ alignStart: alignStart })=>alignStart ? "flex-start" : "flex-end"};
`;
const $ea26048dfd3ca217$export$f8c33909bcff7bef = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("overflow-x", "hidden")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    & > div > div {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "nowrap")}
        ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "calc(100% + 2rem)")}
    }
    & > div > div > * {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-shrink", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("min-width", "0")}
    }
`;
const $ea26048dfd3ca217$export$342551df3dea21fb = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N20")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "1rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    @media ${(0, $aT9Ik.minWidth).sm} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    }
    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }
`;
const $ea26048dfd3ca217$export$f1829723616f2af0 = (0, $hYbro.styled).div({
    backgroundColor: (0, $i2LPb.colorCSS)("N80"),
    borderRadius: "0.5rem",
    height: "1rem",
    position: "absolute",
    transition: `left ${({ transitionTimeInSeconds: transitionTimeInSeconds })=>transitionTimeInSeconds}s ease`
});

});

parcelRegister("hVi3S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36242785e16a0678$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");

var $5n0DT = parcelRequire("5n0DT");
const $36242785e16a0678$var$TrelloTemplate = ({ disabled: disabled, model: { id: id, content: content }, reduced: reduced })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const { attribution: attribution, avatar: avatar, avatarPadding: avatarPadding, backgroundImage: backgroundImage, description: description, title: title } = content;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5n0DT.Template), {
        "data-testid": "individual-template",
        "data-uuid": id,
        draggable: "false",
        href: content.url,
        onClick: (e)=>{
            if (disabled) {
                e.preventDefault();
                return;
            }
            sendTrackEvent("clickedLinkInGallery", {
                event: "clicked",
                eventComponent: "link",
                eventContainer: "gallery",
                href: content.url,
                label: content.title,
                labelEnglish: content.entryTitle,
                uuid: id
            });
        },
        children: [
            reduced ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $5n0DT.ReducedTemplateHero), {
                image: backgroundImage?.content.image.url,
                ...(0, $54E1V.getColorsFromBackgroundField)(content.background)
            }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $5n0DT.TemplateHero), {
                image: backgroundImage?.content.image.url,
                ...(0, $54E1V.getColorsFromBackgroundField)(content.background)
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)((0, $5n0DT.TemplateContent), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5n0DT.TemplateAvatar), {
                        image: avatar,
                        padding: avatarPadding
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        children: title
                    }),
                    attribution && /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: "muted",
                        children: attribution
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        children: description
                    })
                ]
            })
        ]
    });
};
var $36242785e16a0678$export$2e2bcd8739ae039 = $36242785e16a0678$var$TrelloTemplate;

});
parcelRegister("5n0DT", function(module, exports) {

$parcel$export(module.exports, "Template", function () { return $dca39aa9d80a829f$export$14416b8d99d47caa; });
$parcel$export(module.exports, "TemplateHero", function () { return $dca39aa9d80a829f$export$48c4ff3ed021130b; });
$parcel$export(module.exports, "ReducedTemplateHero", function () { return $dca39aa9d80a829f$export$e080af1c2914abb2; });
$parcel$export(module.exports, "TemplateAvatar", function () { return $dca39aa9d80a829f$export$98447213c724cf8a; });
$parcel$export(module.exports, "TemplateContent", function () { return $dca39aa9d80a829f$export$708b164b8f6d17b5; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $fpcku = parcelRequire("fpcku");
var $a7xVp = parcelRequire("a7xVp");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $dca39aa9d80a829f$export$14416b8d99d47caa = (0, $hYbro.styled).a`
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", `${(0, $fpcku.radius).small}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow).normal}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("user-select", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("white-space", "normal")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "auto")}
    &:hover,
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `${(0, $a7xVp.shadow).dark}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("color", "inherit")}
    }
`;
const $dca39aa9d80a829f$export$48c4ff3ed021130b = ({ background: background, image: image, linkColor: linkColor, linkHoverColor: linkHoverColor, color: color, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        height: "6rem",
        ...image ? {
            backgroundImage: `url(${image}?w=1000)`,
            backgroundSize: "cover"
        } : background ? {
            background: background
        } : {}
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $dca39aa9d80a829f$export$e080af1c2914abb2 = ({ background: background, image: image, linkColor: linkColor, linkHoverColor: linkHoverColor, color: color, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        height: "2rem",
        backgroundSize: "cover",
        ...image ? {
            backgroundImage: `url(${image}?w=1000)`
        } : background ? {
            background: background
        } : {}
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $dca39aa9d80a829f$export$98447213c724cf8a = (0, $hYbro.styled).div(({ image: image, padding: padding = false })=>({
        backgroundColor: (0, $i2LPb.colorCSS)("N0"),
        backgroundImage: image?.url ? `url(${image.url})` : "none",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        borderColor: (0, $i2LPb.colorCSS)("N0"),
        borderRadius: (0, $fpcku.radius).small,
        borderStyle: "solid",
        borderWidth: padding ? `8px` : `3px`,
        height: "3rem",
        left: "1rem",
        position: "absolute",
        top: "-1.5rem",
        width: "3rem"
    }));
const $dca39aa9d80a829f$export$708b164b8f6d17b5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "2.25rem 1.5rem 1.5rem 1.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

    p {
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "0")}

        &.muted {
            ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N300")}`)}
        }

        & + p {
            ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "0.5rem")}
        }
    }
`;

});




parcelRegister("5Uefd", function(module, exports) {

$parcel$export(module.exports, "Section", function () { return $993ee62525a6b51e$export$6e2c8f0811a474ce; });

var $hYbro = parcelRequire("hYbro");

var $jAJVK = parcelRequire("jAJVK");
const $993ee62525a6b51e$export$6e2c8f0811a474ce = (0, $hYbro.styled).section`
    ${(0, $jAJVK.redundantCssFromKebab)("padding-bottom", "2rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "visible")}
`;

});



parcelRegister("gfGkO", function(module, exports) {

$parcel$export(module.exports, "UiTab", function () { return (parcelRequire("1GqBm")).default; });

var $1GqBm = parcelRequire("1GqBm");

});
parcelRegister("1GqBm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27e2dde5a066ffe3$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $5l0yg = parcelRequire("5l0yg");

var $33PqJ = parcelRequire("33PqJ");

var $k1jpC = parcelRequire("k1jpC");
const $27e2dde5a066ffe3$var$UiTab = ({ model: model })=>{
    const { buttonText: buttonText, columns: columns, title: title } = model.content;
    const [isSelected, setIsSelected] = (0, $iSvIT.useState)(false);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Column), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $k1jpC.Button), {
                        onClick: ()=>setIsSelected(true),
                        children: buttonText
                    })
                })
            }),
            isSelected && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
                children: [
                    title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $k1jpC.Title), {
                        children: title
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                        children: (0, $33PqJ.renderViewModels)(columns)
                    })
                ]
            })
        ]
    });
};
var $27e2dde5a066ffe3$export$2e2bcd8739ae039 = $27e2dde5a066ffe3$var$UiTab;

});
parcelRegister("k1jpC", function(module, exports) {

$parcel$export(module.exports, "Button", function () { return $b09e19537e68359b$export$353f5b6fc5456de1; });
$parcel$export(module.exports, "Title", function () { return $b09e19537e68359b$export$f99233281efd08a0; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");

var $jAJVK = parcelRequire("jAJVK");
const $b09e19537e68359b$export$353f5b6fc5456de1 = (0, $hYbro.styled).button`
    ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "P75"
})}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "21px")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "0px")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1.5rem")}
    &:active {
        ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "P500"
}) || ""}
    }
`;
const $b09e19537e68359b$export$f99233281efd08a0 = (0, $hYbro.styled).h2`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
`;

});



parcelRegister("hKaLV", function(module, exports) {

$parcel$export(module.exports, "UiTabPanel", function () { return (parcelRequire("5KlTr")).default; });

var $5KlTr = parcelRequire("5KlTr");

});
parcelRegister("5KlTr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f60c8703ebb9064f$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $5l0yg = parcelRequire("5l0yg");

var $33PqJ = parcelRequire("33PqJ");

var $1HS4G = parcelRequire("1HS4G");
const $f60c8703ebb9064f$var$UiTabPanel = ({ model: model })=>{
    const tabs = model.content.tabs.filter(({ type: type })=>type === "uiTab");
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const tabRefs = (0, $iSvIT.useRef)([]);
    const [index, setIndex] = (0, $iSvIT.useState)(0);
    const [focusIndex, setFocusIndex] = (0, $iSvIT.useState)(0);
    const firstTab = 0;
    const lastTab = tabs.length - 1;
    const moveFocusToTab = (currentTab)=>{
        const tabToFocus = tabRefs.current[currentTab];
        tabToFocus && tabToFocus.focus();
        setFocusIndex(currentTab);
    };
    const moveToIndex = (newIndex)=>{
        if (newIndex < 0) moveFocusToTab(lastTab);
        else if (newIndex > lastTab) moveFocusToTab(firstTab);
        else moveFocusToTab(newIndex);
    };
    const onKeydown = (event)=>{
        let stopEventBubbling = true;
        switch(event.key){
            case "ArrowLeft":
                moveToIndex(focusIndex - 1);
                break;
            case "ArrowRight":
                moveToIndex(focusIndex + 1);
                break;
            case "Home":
                moveToIndex(firstTab);
                break;
            case "End":
                moveToIndex(lastTab);
                break;
            default:
                stopEventBubbling = false;
                break;
        }
        if (stopEventBubbling) {
            event.stopPropagation();
            event.preventDefault();
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $1HS4G.Tabs), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1HS4G.TabList), {
                    role: "tablist",
                    "aria-labelledby": `tablist-${model.id}`,
                    children: tabs.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $1HS4G.Tab), {
                            id: `tab-${i}-${model.id}`,
                            tabIndex: i !== index ? -1 : 0,
                            ref: (element)=>{
                                if (element) tabRefs.current[i] = element;
                            },
                            "aria-selected": i === index,
                            type: "button",
                            role: "tab",
                            "aria-controls": `tabpanel-${i}}-${model.id}`,
                            onKeyDown: (event)=>onKeydown(event),
                            onClick: ()=>{
                                setIndex(i);
                                sendTrackEvent("tabpanelTabClicked", {
                                    ...analyticsAttributes,
                                    eventContainer: model.type,
                                    event: "clicked",
                                    eventComponent: "tab",
                                    label: tab.content.buttonText,
                                    labelEnglish: tab.content.entryTitle,
                                    uuid: tab.id
                                });
                            },
                            children: tab.content.buttonText
                        }, i))
                })
            }),
            tabs.map((tab, i)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $1HS4G.TabPanel), {
                    className: i !== index ? "is-hidden" : "",
                    id: `tabpanel-${i}-${model.id}`,
                    role: "tabpanel",
                    "aria-labelledby": `tab-${i}-${model.id}`,
                    children: [
                        model.content.tabs[i]?.content.title && /*#__PURE__*/ (0, $loA2J.jsx)((0, $1HS4G.Title), {
                            children: model.content.tabs[i]?.content.title
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $5l0yg.Row), {
                            children: (0, $33PqJ.renderViewModels)(tab.content.columns)
                        })
                    ]
                }, i))
        ]
    });
};
var $f60c8703ebb9064f$export$2e2bcd8739ae039 = $f60c8703ebb9064f$var$UiTabPanel;

});
parcelRegister("1HS4G", function(module, exports) {

$parcel$export(module.exports, "Tab", function () { return $5c2cdde35102ddfb$export$3e41faf802a29e71; });
$parcel$export(module.exports, "TabList", function () { return $5c2cdde35102ddfb$export$e51a686c67fdaa2d; });
$parcel$export(module.exports, "Tabs", function () { return $5c2cdde35102ddfb$export$b2539bed5023c21c; });
$parcel$export(module.exports, "TabPanel", function () { return $5c2cdde35102ddfb$export$3d96ec278d3efce4; });
$parcel$export(module.exports, "Title", function () { return $5c2cdde35102ddfb$export$f99233281efd08a0; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");
var $i2LPb = parcelRequire("i2LPb");
var $aT9Ik = parcelRequire("aT9Ik");

var $jAJVK = parcelRequire("jAJVK");
const $5c2cdde35102ddfb$export$3e41faf802a29e71 = (0, $hYbro.styled).button`
    ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "P75"
})}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "21px")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "3px solid transparent")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1.5rem")}
    &[aria-selected="true"] {
        ${(0, $54E1V.cssColorsFromBackgroundField)({
    color: "P500"
}) || ""}
    }
    &:hover,
    :focus,
    :active {
        ${(0, $jAJVK.redundantCssFromKebab)("border", `3px solid ${(0, $i2LPb.colorCSS)("B300")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}
    }
`;
const $5c2cdde35102ddfb$export$e51a686c67fdaa2d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "wrap")}
    ${(0, $jAJVK.redundantCssFromKebab)("gap", "0.5rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media ${(0, $aT9Ik.minWidth).lg} {
        ${(0, $jAJVK.redundantCssFromKebab)("flex-wrap", "nowrap")}
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;
const $5c2cdde35102ddfb$export$b2539bed5023c21c = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("justify-content", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 1rem")}
`;
const $5c2cdde35102ddfb$export$3d96ec278d3efce4 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("padding-top", "1rem")}
    &.is-hidden {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "none")}
    }
`;
const $5c2cdde35102ddfb$export$f99233281efd08a0 = (0, $hYbro.styled).h2`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "1rem 1rem 2rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "center")}
    
    @media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 768px) {
        max-width: 720px;
    }

    @media (min-width: 992px) {
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1140px;
    }
`;

});



parcelRegister("a4Vai", function(module, exports) {

$parcel$export(module.exports, "UiTextBlock", function () { return (parcelRequire("5I0gh")).default; });

var $5I0gh = parcelRequire("5I0gh");

});
parcelRegister("5I0gh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04b8d85a73c3d3f3$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $hYbro = parcelRequire("hYbro");

var $1XX9N = parcelRequire("1XX9N");
parcelRequire("h6yBX");
var $kL1mL = parcelRequire("kL1mL");
var $9iTli = parcelRequire("9iTli");
var $jY3ml = parcelRequire("jY3ml");
const $04b8d85a73c3d3f3$var$UiTextBlock = ({ model: model })=>{
    const { text: text, textSize: textSize, orderedListAppearance: orderedListAppearance } = model.content;
    return /*#__PURE__*/ (0, $loA2J.jsx)($04b8d85a73c3d3f3$export$2db84c782bfb16e2, {
        textSize: textSize,
        orderedListAppearance: orderedListAppearance,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1XX9N.RichText), {
            document: text
        })
    });
};
const $04b8d85a73c3d3f3$export$2db84c782bfb16e2 = (0, $hYbro.styled).div(({ textSize: textSize })=>(0, $kL1mL.getTextSizeCSS)(textSize), ({ orderedListAppearance: orderedListAppearance })=>(0, $9iTli.getOrderedListCSS)(orderedListAppearance), (0, $jY3ml.blockquoteCSS));
var $04b8d85a73c3d3f3$export$2e2bcd8739ae039 = $04b8d85a73c3d3f3$var$UiTextBlock;

});


parcelRegister("6HMlA", function(module, exports) {

$parcel$export(module.exports, "UiTooltip", function () { return (parcelRequire("7YDse")).default; });

var $7YDse = parcelRequire("7YDse");

});
parcelRegister("7YDse", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af16728de15b51fd$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("dg5xP");
var $8L0gU = parcelRequire("8L0gU");
var $jTu6p = parcelRequire("jTu6p");
var $cFwv0 = parcelRequire("cFwv0");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $af16728de15b51fd$var$UiTooltip = ({ model: model })=>{
    const [isOpen, setIsOpen] = (0, $iSvIT.useState)(false);
    const ref = (0, $iSvIT.useRef)(null);
    const { triggerText: triggerText, tooltipText: tooltipText } = model.content;
    (0, $8L0gU.useEscapePress)(()=>setIsOpen(false));
    (0, $jTu6p.useClickAway)(ref, ()=>setIsOpen(false));
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)($af16728de15b51fd$var$Trigger, {
                ref: ref,
                onClick: ()=>setIsOpen(true),
                "data-testid": "ui-tooltip-trigger",
                children: triggerText
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $cFwv0.Tooltip), {
                document: tooltipText,
                modalId: model.id,
                isOpen: isOpen,
                parentRef: ref
            })
        ]
    });
};
const $af16728de15b51fd$var$Trigger = (0, $hYbro.styled).button`
    ${(0, $jAJVK.redundantCssFromKebab)("appearance", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", "transparent")}
    ${(0, $jAJVK.redundantCssFromKebab)("border", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `2px dotted ${(0, $i2LPb.colorCSS)("N60")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "3px")}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N900")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0")}
    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("border-bottom", `2px dotted ${(0, $i2LPb.colorCSS)("N100")}`)}
    }
    &:focus {
        ${(0, $jAJVK.redundantCssFromKebab)("outline", "none")}
    }
`;
var $af16728de15b51fd$export$2e2bcd8739ae039 = $af16728de15b51fd$var$UiTooltip;

});


parcelRegister("5H7uq", function(module, exports) {

$parcel$export(module.exports, "UiTrelloBoard", function () { return (parcelRequire("gWGNf")).default; });

var $gWGNf = parcelRequire("gWGNf");

});
parcelRegister("gWGNf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c84d3dd69f8aa106$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $54E1V = parcelRequire("54E1V");
parcelRequire("15Myg");
var $eeZgq = parcelRequire("eeZgq");
var $iPh0n = parcelRequire("iPh0n");
var $87nL6 = parcelRequire("87nL6");

var $8qCKX = parcelRequire("8qCKX");
const $c84d3dd69f8aa106$var$UiTrelloBoard = ({ model: model })=>{
    const { layout: layout, name: name, lists: lists, background: background } = model.content;
    if (layout === "Mobile") return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.MobileClippingMask), {
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.MobilePhone), {
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.MobileForehead), {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {})
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.MobileButtons), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "silent"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "volume"
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: "lock"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.MobileScreen), {
                    children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.MobileBoard), {
                        ...(0, $54E1V.getColorsFromBackgroundField)(background),
                        children: [
                            name && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.MobileHeader), {
                                ...(0, $54E1V.getColorsFromBackgroundField)(background),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                                    children: name
                                })
                            }),
                            lists && /*#__PURE__*/ (0, $loA2J.jsx)($c84d3dd69f8aa106$var$TrelloLists, {
                                lists: lists
                            })
                        ]
                    })
                })
            ]
        })
    });
    else return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.Board), {
        ...(0, $54E1V.getColorsFromBackgroundField)(background),
        children: [
            name && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.BoardName), {
                ...(0, $54E1V.getColorsFromBackgroundField)(background),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                    children: name
                })
            }),
            lists && /*#__PURE__*/ (0, $loA2J.jsx)($c84d3dd69f8aa106$var$TrelloLists, {
                lists: lists
            })
        ]
    });
};
const $c84d3dd69f8aa106$var$TrelloLists = ({ lists: lists })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Lists), {
        children: lists.filter(({ type: type })=>type === "uiTrelloList").map((list)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.List), {
                children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.ListContent), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.ListName), {
                            children: list.content.name
                        }),
                        list.content.cards?.filter(({ type: type })=>type === "uiTrelloCard").map((card)=>/*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.Card), {
                                children: [
                                    !!card.content.image && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.CardImage), {
                                        src: card.content.image.url,
                                        alt: card.content.image.title
                                    }),
                                    /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.CardContent), {
                                        children: [
                                            !!card.content.label && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Labels), {
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Label), {
                                                    color: card.content.label
                                                })
                                            }),
                                            card.content.name,
                                            !!card.content.hasDescription ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Description), {
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eeZgq.TextIcon), {})
                                            }) : /*#__PURE__*/ (0, $loA2J.jsx)($c84d3dd69f8aa106$var$CardDescription, {
                                                children: card.content.descriptionType
                                            }),
                                            !!card.content.users && /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Users), {
                                                children: card.content.users.map((user)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.User), {
                                                        src: user.url,
                                                        width: user.width,
                                                        height: user.height,
                                                        alt: user.title
                                                    }, user.url))
                                            })
                                        ]
                                    })
                                ]
                            }, card.id))
                    ]
                })
            }, list.id))
    });
};
const $c84d3dd69f8aa106$var$CardDescription = ({ children: children })=>{
    switch(children){
        case "CheckList":
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.Description), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iPh0n.CheckListIcon), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: "0/3"
                    })
                ]
            });
        case "CheckListInProgress":
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.Description), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iPh0n.CheckListIcon), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: "2/5"
                    })
                ]
            });
        case "CheckListDone":
            return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $8qCKX.Description), {
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $iPh0n.CheckListIcon), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                        children: "7/7"
                    })
                ]
            });
        case "Text":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Description), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $eeZgq.TextIcon), {})
            });
        case "Timer":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8qCKX.Description), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $87nL6.TimerIcon), {})
            });
        default:
            return null;
    }
};
var $c84d3dd69f8aa106$export$2e2bcd8739ae039 = $c84d3dd69f8aa106$var$UiTrelloBoard;

});
parcelRegister("15Myg", function(module, exports) {
$parcel$export(module.exports, "CheckListIcon", function () { return (parcelRequire("iPh0n")).CheckListIcon; });
$parcel$export(module.exports, "TextIcon", function () { return (parcelRequire("eeZgq")).TextIcon; });
$parcel$export(module.exports, "TimerIcon", function () { return (parcelRequire("87nL6")).TimerIcon; });
parcelRequire("iPh0n");
parcelRequire("eeZgq");
parcelRequire("87nL6");

});
parcelRegister("iPh0n", function(module, exports) {

$parcel$export(module.exports, "CheckListIcon", function () { return $d4f670692c9a24ba$export$e4ff73ef1f59a143; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $d4f670692c9a24ba$export$e4ff73ef1f59a143 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        height: "16",
        viewBox: "0 0 111 112",
        width: "16",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "m80.2148438 13.8125h-59.4023438c-1.9511816 0-3.5952082.6684503-4.9321289 2.0053711-1.3369208 1.3369207-2.0053711 2.9809473-2.0053711 4.9321289v69.375c0 1.9511816.6684503 3.5952082 2.0053711 4.9321289 1.3369207 1.3369208 2.9809473 2.0053711 4.9321289 2.0053711h69.375c1.9511816 0 3.5952082-.6684503 4.9321289-2.0053711 1.3369208-1.3369207 2.0053711-2.9809473 2.0053711-4.9321289v-34.3623047l13.875-13.875v55.1748047c0 3.830097-1.354967 7.100084-4.064941 9.810059-2.709975 2.709974-5.979962 4.064941-9.810059 4.064941h-83.25c-3.8300973 0-7.10008411-1.354967-9.81005859-4.064941-2.70997449-2.709975-4.06494141-5.979962-4.06494141-9.810059v-83.25c0-3.83009728 1.35496692-7.10008411 4.06494141-9.81005859 2.70997448-2.70997449 5.97996129-4.06494141 9.81005859-4.06494141h80.2148438zm-54.4160157 44.5517578c-1.3007877-1.3730537-1.9511719-3.0170803-1.9511719-4.9321289s.6503842-3.5229427 1.9511719-4.8237305c1.3730538-1.3730537 3.0170803-2.0595703 4.9321289-2.0595703 1.9150487 0 3.5590752.6865166 4.9321289 2.0595703l19.6201172 19.6201172c1.3730538 1.3007878 2.0595703 2.9086819 2.0595703 4.8237305s-.6865165 3.5590752-2.0595703 4.9321289c-1.3730537 1.3730537-3.0170802 2.0595703-4.9321289 2.0595703-1.9150486 0-3.5590751-.6865166-4.9321289-2.0595703zm19.6201172 19.6201172c-1.3007877-1.3730537-1.9511719-3.0170803-1.9511719-4.9321289s.6503842-3.5229427 1.9511719-4.8237305l53.1152344-53.1152344c1.3730537-1.3730537 3.0170803-2.0595703 4.9321293-2.0595703 1.915048 0 3.559075.6865166 4.932129 2.0595703 1.300787 1.3730538 1.951171 3.0170803 1.951171 4.932129 0 1.9150486-.650384 3.5229427-1.951171 4.8237304l-53.1152349 53.1152344c-1.3730537 1.3730537-3.0170802 2.0595703-4.9321289 2.0595703-1.9150486 0-3.5590751-.6865166-4.9321289-2.0595703z",
                fill: (0, $i2LPb.colorCSS)("N500"),
                opacity: ".3"
            })
        })
    });
};

});

parcelRegister("eeZgq", function(module, exports) {

$parcel$export(module.exports, "TextIcon", function () { return $801b96cc69b2b67a$export$4a7d2a945910cc57; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $801b96cc69b2b67a$export$4a7d2a945910cc57 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        height: "10",
        viewBox: "0 0 16 10",
        width: "16",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m1 0h14c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 4h14c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1h-14c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1zm0 4h8c.55228475 0 1 .44771525 1 1s-.44771525 1-1 1h-8c-.55228475 0-1-.44771525-1-1s.44771525-1 1-1z",
            fill: (0, $i2LPb.colorCSS)("N500", 0.3),
            fillRule: "evenodd"
        })
    });
};

});

parcelRegister("87nL6", function(module, exports) {

$parcel$export(module.exports, "TimerIcon", function () { return $3c10af4f96a0e120$export$579848c7cccecf3f; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
const $3c10af4f96a0e120$export$579848c7cccecf3f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        height: "16",
        viewBox: "0 0 16 16",
        width: "16",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
            d: "m8.99166667.00833333c4.41827803 0 8.00000003 3.581722 8.00000003 8 0 4.41827797-3.581722 7.99999997-8.00000003 7.99999997-4.418278 0-8-3.581722-8-7.99999997 0-4.418278 3.581722-8 8-8zm0 1.6c-3.5346224 0-6.4 2.8653776-6.4 6.4 0 3.53462247 2.8653776 6.39999997 6.4 6.39999997 3.53462243 0 6.40000003-2.8653775 6.40000003-6.39999997 0-3.5346224-2.8653776-6.4-6.40000003-6.4zm0 1.6c.4418278 0 .8.3581722.8.8v4c0 .21913848-.08810957.41769786-.23083482.56218427-.00529651.0054089-.01062003.01077669-.01602947.01607701-.01302716.01217179-.02641977.02415821-.04020662.03568889-.03631155.03215553-.07663875.0608062-.1202302.08597373l-2.77122135 1.59996537c-.35076308.2025132-.79114077.1092154-1.03225063-.202448l-.06059967-.090355c-.22091388-.38263412-.0897857-.87192259.2928503-1.0928376l2.37752246-1.37324867.001-3.541c0-.4418278.3581722-.8.8-.8z",
            transform: "translate(-1)",
            fill: (0, $i2LPb.colorCSS)("N500"),
            opacity: ".3"
        })
    });
};

});


parcelRegister("8qCKX", function(module, exports) {

$parcel$export(module.exports, "Board", function () { return $58c47e177607d1fc$export$dc537a3a3893548e; });
$parcel$export(module.exports, "BoardName", function () { return $58c47e177607d1fc$export$d9f741b969b1b8ab; });
$parcel$export(module.exports, "Card", function () { return $58c47e177607d1fc$export$60332b2344f7fe41; });
$parcel$export(module.exports, "CardContent", function () { return $58c47e177607d1fc$export$64ef9b8c11710c47; });
$parcel$export(module.exports, "CardImage", function () { return $58c47e177607d1fc$export$8a8c015277a3d77a; });
$parcel$export(module.exports, "Description", function () { return $58c47e177607d1fc$export$393edc798c47379d; });
$parcel$export(module.exports, "Label", function () { return $58c47e177607d1fc$export$b04be29aa201d4f5; });
$parcel$export(module.exports, "Labels", function () { return $58c47e177607d1fc$export$c9ed62821215deda; });
$parcel$export(module.exports, "List", function () { return $58c47e177607d1fc$export$54c2e3dc7acea9f5; });
$parcel$export(module.exports, "ListContent", function () { return $58c47e177607d1fc$export$729aff264287c59d; });
$parcel$export(module.exports, "ListName", function () { return $58c47e177607d1fc$export$2ecf81b4baa68e0b; });
$parcel$export(module.exports, "Lists", function () { return $58c47e177607d1fc$export$e1553435d4022be; });
$parcel$export(module.exports, "MobileBoard", function () { return $58c47e177607d1fc$export$91f4b208671479a9; });
$parcel$export(module.exports, "MobileButtons", function () { return $58c47e177607d1fc$export$590eb9e8e9b3ae5e; });
$parcel$export(module.exports, "MobileClippingMask", function () { return $58c47e177607d1fc$export$b7d1a4836604cfd3; });
$parcel$export(module.exports, "MobileForehead", function () { return $58c47e177607d1fc$export$e719e093c3136d0f; });
$parcel$export(module.exports, "MobileHeader", function () { return $58c47e177607d1fc$export$494cf78290fbe4c7; });
$parcel$export(module.exports, "MobilePhone", function () { return $58c47e177607d1fc$export$97cc3d1b4d555b1d; });
$parcel$export(module.exports, "MobileScreen", function () { return $58c47e177607d1fc$export$b0b18219926fe622; });
$parcel$export(module.exports, "User", function () { return $58c47e177607d1fc$export$1f44aaf2ec115b54; });
$parcel$export(module.exports, "Users", function () { return $58c47e177607d1fc$export$a69f017b19597ff5; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");
var $aKIz7 = parcelRequire("aKIz7");

var $jAJVK = parcelRequire("jAJVK");
const $58c47e177607d1fc$export$dc537a3a3893548e = ({ background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        ...background && {
            background: background
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "1rem",
        boxShadow: `0 10px 20px ${(0, $i2LPb.colorCSS)("N400", 0.29)}`,
        cursor: "default",
        fontSize: (0, $kL1mL.fontSizes).sm,
        marginBottom: "30px",
        overflow: "hidden",
        padding: "1rem",
        position: "relative",
        textAlign: "left"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $58c47e177607d1fc$export$d9f741b969b1b8ab = ({ background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        marginBottom: "1rem",
        overflow: "auto"
    };
    // Note: Nested selector styles (h3) cannot be applied via inline styles
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $58c47e177607d1fc$export$60332b2344f7fe41 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N200")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "4px")}
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", "0.9rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "8px")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
`;
const $58c47e177607d1fc$export$64ef9b8c11710c47 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "6px 8px")}
`;
const $58c47e177607d1fc$export$8a8c015277a3d77a = (0, $hYbro.styled).img`
    ${(0, $jAJVK.redundantCssFromKebab)("display", "block")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
`;
const $58c47e177607d1fc$export$393edc798c47379d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N500", 0.3)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-bottom", "14px")}

    span {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "4px")}
        ${(0, $jAJVK.redundantCssFromKebab)("vertical-align", "middle")}
    }
`;
const $58c47e177607d1fc$export$b04be29aa201d4f5 = (0, $hYbro.styled).div`
    background-color: ${({ color: color })=>(0, $i2LPb.colorCSS)(color === "blue" ? "B200" : color === "purple" ? "P200" : "R200")};
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "3.5px")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "7px")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-right", "5px")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "30px")}
`;
const $58c47e177607d1fc$export$c9ed62821215deda = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "4px 0")}
`;
const $58c47e177607d1fc$export$54c2e3dc7acea9f5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("float", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-right", "10px")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "225.25px")}
`;
const $58c47e177607d1fc$export$729aff264287c59d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N30")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "6px")}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 2px 4px, ${(0, $i2LPb.colorCSS)("N900", 0.5)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "8px")}
`;
const $58c47e177607d1fc$export$2ecf81b4baa68e0b = (0, $hYbro.styled).h5`
    ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).sm}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("letter-spacing", "0.5px")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 0 8px 3px")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-transform", "none")}
`;
const $58c47e177607d1fc$export$e1553435d4022be = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("min-width", "1000px")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "auto")}
`;
const $58c47e177607d1fc$export$91f4b208671479a9 = ({ background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        ...background && {
            background: background
        },
        borderRadius: "6px",
        boxShadow: "none",
        margin: 0,
        overflow: "hidden",
        padding: "10px",
        textAlign: "left"
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $58c47e177607d1fc$export$590eb9e8e9b3ae5e = (0, $hYbro.styled).div`
    div {
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B400", 0.2)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "4px 0 0 4px")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "6px")}

        &.silent {
            ${(0, $jAJVK.redundantCssFromKebab)("height", "31px")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", "-6px")}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "70px")}
        }

        &.volume {
            ${(0, $jAJVK.redundantCssFromKebab)("height", "81px")}
            ${(0, $jAJVK.redundantCssFromKebab)("left", "-6px")}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "130px")}
        }

        &.lock {
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "0 4px 4px 0")}
            ${(0, $jAJVK.redundantCssFromKebab)("height", "61px")}
            ${(0, $jAJVK.redundantCssFromKebab)("right", "-6px")}
            ${(0, $jAJVK.redundantCssFromKebab)("top", "130px")}
        }
    }
`;
const $58c47e177607d1fc$export$b7d1a4836604cfd3 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "377px")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0 10px")}
`;
const $58c47e177607d1fc$export$e719e093c3136d0f = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "50px")}
    ${(0, $jAJVK.redundantCssFromKebab)("opacity", "0.5")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}

    div {
        ${(0, $jAJVK.redundantCssFromKebab)("height", "8px")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "4px")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "72px")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin", "-4px 0 0 -36px")}
        ${(0, $jAJVK.redundantCssFromKebab)("top", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("left", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B400", 0.5)}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}

        &:before {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B400", 0.5)}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
            ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
            ${(0, $jAJVK.redundantCssFromKebab)("height", "10px")}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "10px")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "-1px 0 0 -62px")}
        }

        &:after {
            ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("B400", 0.5)}`)}
            ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
            ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
            ${(0, $jAJVK.redundantCssFromKebab)("height", "16px")}
            ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
            ${(0, $jAJVK.redundantCssFromKebab)("width", "16px")}
            ${(0, $jAJVK.redundantCssFromKebab)("margin", "-4px 0 0 -91px")}
        }
    }
`;
const $58c47e177607d1fc$export$494cf78290fbe4c7 = ({ background: background, color: color, linkColor: linkColor, linkHoverColor: linkHoverColor, medium: medium, headingColor: headingColor, borderColor: borderColor, ...props })=>{
    const style = {
        margin: "-10px -10px 10px",
        ...color && {
            color: color
        },
        padding: "10px 0",
        position: "relative"
    };
    // Note: Nested selectors (h3, ::before, ::after) cannot be applied via inline styles
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        style: style,
        ...props
    });
};
const $58c47e177607d1fc$export$97cc3d1b4d555b1d = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "32px")}
    ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $aKIz7.gradientCSS)("blue-fade")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 10px 20px ${(0, $i2LPb.colorCSS)("N400", 0.29)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 auto")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "290px")}
    ${(0, $jAJVK.redundantCssFromKebab)("max-width", "100%")}
`;
const $58c47e177607d1fc$export$b0b18219926fe622 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("margin", "0 10px")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}

    ${$58c47e177607d1fc$export$54c2e3dc7acea9f5} {
        ${(0, $jAJVK.redundantCssFromKebab)("width", "185px")}
    }
`;
const $58c47e177607d1fc$export$1f44aaf2ec115b54 = (0, $hYbro.styled).img`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "28px")}
    ${(0, $jAJVK.redundantCssFromKebab)("float", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("margin-left", "5px")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "28px")}
`;
const $58c47e177607d1fc$export$a69f017b19597ff5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("bottom", "7px")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("right", "7px")}
`;

});



parcelRegister("aOuoE", function(module, exports) {

$parcel$export(module.exports, "UiValueProp", function () { return (parcelRequire("DUdTi")).default; });

var $DUdTi = parcelRequire("DUdTi");

});
parcelRegister("DUdTi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2778f32f15fca93$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");
var $6vqJG = parcelRequire("6vqJG");

var $33PqJ = parcelRequire("33PqJ");

var $aMqsH = parcelRequire("aMqsH");
const $e2778f32f15fca93$var$UiValueProp = ({ model: { id: id, type: type, content: { entryTitle: entryTitle, image: image, icon: icon, content: content, appearance: appearance, link: link } } })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const valueProp = /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            eventContainer: type,
            labelEnglish: entryTitle
        },
        children: /*#__PURE__*/ (0, $loA2J.jsxs)((0, $aMqsH.ValueProp), {
            $image: image,
            $appearance: appearance,
            children: [
                !image && icon && (0, $33PqJ.renderViewModel)(icon),
                /*#__PURE__*/ (0, $loA2J.jsx)((0, $6vqJG.Markdown), {
                    children: content
                })
            ]
        })
    });
    if (!link?.content) return valueProp;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aMqsH.ValuePropLink), {
        onClick: ()=>{
            //get readable title from markdown
            const linkTitle = $e2778f32f15fca93$var$getStringFromMarkdown(content);
            sendTrackEvent("clickedUiValuePropLink", {
                event: "clicked",
                eventComponent: "link",
                eventContainer: type,
                label: linkTitle,
                labelEnglish: entryTitle,
                uuid: id,
                href: link.content.path,
                title: linkTitle
            });
        },
        href: link.content.path,
        "data-uuid": id,
        children: valueProp
    });
};
function $e2778f32f15fca93$var$getStringFromMarkdown(content, maxLength = 50) {
    if (!content) return "";
    //remove special characters
    const plainText = content.replace(/[^a-z0-9]/gi, " ");
    //remove extra spaces
    const words = plainText.split(" ").filter((e)=>e).join(" ");
    //strip special characters
    return words.slice(0, maxLength);
}
var $e2778f32f15fca93$export$2e2bcd8739ae039 = $e2778f32f15fca93$var$UiValueProp;

});
parcelRegister("aMqsH", function(module, exports) {

$parcel$export(module.exports, "ValueProp", function () { return $9be61092694d6cef$export$9189f66f433f52d5; });
$parcel$export(module.exports, "ValuePropLink", function () { return $9be61092694d6cef$export$99ecde040dcecfff; });

var $hYbro = parcelRequire("hYbro");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $9be61092694d6cef$export$9189f66f433f52d5 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding-left", "4.5rem")}

    ${({ $image: $image })=>$image ? `
        background-image: url(${$image.url});
        background-repeat: no-repeat;
        background-position: 0.25rem top;
        background-size: 3rem auto;
    ` : ""}

    ${({ $appearance: $appearance })=>$appearance !== "No padding" ? "padding-bottom: 2rem;" : ""}

    > svg {
        height: 2.5rem;
        left: 0.5rem;
        position: absolute;
        top: 0.375rem;
        width: 2.5rem;
    }

    code {
        background: ${(0, $i2LPb.colorCSS)("trelloblue")};
        border-radius: 0.25rem;
        color: ${(0, $i2LPb.colorCSS)("N0")};
        display: inline-block;
        font-family: inherit;
        font-size: 75%;
        margin-left: 2px;
        padding: 0.12rem 0.5rem 0.25rem;
        position: relative;
        top: -2px;
        vertical-align: baseline;
        white-space: nowrap;
    }

    p {
        margin-bottom: 0.75rem;
    }

    p:last-child {
        margin-bottom: 0;
    }

    ul {
        margin-top: 0.5rem;
        margin-bottom: 0.75rem;
        padding-left: 1.5rem;
    }

    ul:last-child {
        margin-bottom: 0;
    }

    li {
        margin-bottom: 0.25rem;
    }

    li:last-child {
        margin-bottom: 0;
    }
`;
const $9be61092694d6cef$export$99ecde040dcecfff = (0, $hYbro.styled)((0, $jp1nv.Anchor))({
    "color": "inherit !important",
    "display": "block",
    "textDecoration": "none",
    "text-decoration": "none"
});

});



parcelRegister("8JcfN", function(module, exports) {

$parcel$export(module.exports, "UiVariationContainer", function () { return (parcelRequire("8vA78")).default; });

var $8vA78 = parcelRequire("8vA78");

});
parcelRegister("8vA78", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd94eeed6130d146$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $56Pri = parcelRequire("56Pri");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");

var $33PqJ = parcelRequire("33PqJ");
const $fd94eeed6130d146$var$UiVariationContainer = ({ model: model })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    const { featureFlagName: featureFlagName, variations: variations, defaultVariation: defaultVariation } = model.content;
    const flags = (0, $56Pri.useFeatureFlags)();
    const variant = variations?.find(({ content: content })=>content && content.variationValue === flags[content.variationName]);
    (0, $iSvIT.useEffect)(()=>{
        sendTrackEvent("renderedWithVariants", {
            eventContainer: "content",
            ...analyticsAttributes,
            event: "rendered",
            eventComponent: "uiVariationContainer",
            label: featureFlagName,
            labelEnglish: featureFlagName,
            uuid: model.id,
            containerVariant: variant?.content.variationValue ?? "default"
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: add missing dependencies
    }, [
        sendTrackEvent
    ]);
    if (variant) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            containerVariant: variant.content.variationValue
        },
        children: (0, $33PqJ.renderViewModels)(variant.content.variation)
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
        value: {
            containerVariant: "default"
        },
        children: defaultVariation ? (0, $33PqJ.renderViewModels)(defaultVariation) : null
    });
};
var $fd94eeed6130d146$export$2e2bcd8739ae039 = $fd94eeed6130d146$var$UiVariationContainer;

});
parcelRegister("56Pri", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", function () { return $3b856a0ed0987969$export$90335b3ff08f335; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
function $3b856a0ed0987969$export$90335b3ff08f335() {
    return (0, $iSvIT.useContext)($3b856a0ed0987969$var$FeatureFlagsContext);
}
const $3b856a0ed0987969$export$6d7e43f2d6e1c7c6 = ({ featureFlags: featureFlags, children: children })=>{
    return (0, $loA2J.jsx)($3b856a0ed0987969$var$FeatureFlagsContext.Provider, {
        value: Object.assign({}, featureFlags),
        children: children
    });
};
const $3b856a0ed0987969$export$be1c7fc4eaa3f7fe = "BXP_CONTENT_FEATURE_FLAGS";
const $3b856a0ed0987969$var$FeatureFlagsContext = /*#__PURE__*/ (0, $iSvIT.createContext)({});

});



parcelRegister("gQfpJ", function(module, exports) {

$parcel$export(module.exports, "UiVideo", function () { return (parcelRequire("arJrv")).default; });

var $arJrv = parcelRequire("arJrv");

});
parcelRegister("arJrv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $691ca60f6e42b185$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $opvSz = parcelRequire("opvSz");
const $691ca60f6e42b185$var$UiVideo = ({ model: model })=>{
    //get boolean model props
    const { autoplay: autoplay, loop: loop, controls: controls, muted: muted } = model.content;
    //simplify sources
    const sources = model.content.sources?.map((source)=>source.url);
    //return video tag
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $opvSz.Video), {
        "data-testid": "ui-video",
        ...$691ca60f6e42b185$var$getPosterProps(model.content.poster),
        loop: loop,
        controls: controls,
        muted: muted,
        autoplay: autoplay,
        sources: sources,
        children: model.content.title
    });
};
//get video poster, width, and height props from optionally-linked image asset
function $691ca60f6e42b185$var$getPosterProps(poster) {
    const props = {};
    if (poster) {
        props.poster = poster.url;
        if (poster.width) props.width = poster.width;
        if (poster.height) props.height = poster.height;
    }
    return props;
}
var $691ca60f6e42b185$export$2e2bcd8739ae039 = $691ca60f6e42b185$var$UiVideo;

});


parcelRegister("8mwpD", function(module, exports) {

$parcel$export(module.exports, "UiVideoPlayer", function () { return (parcelRequire("fFqco")).default; });

var $fFqco = parcelRequire("fFqco");

});
parcelRegister("fFqco", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aedaadf9b51a5ba$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $g4xTJ = parcelRequire("g4xTJ");

var $15cM5 = parcelRequire("15cM5");
const $0aedaadf9b51a5ba$var$UiVideoPlayer = ({ model: model })=>{
    const [embed, setEmbed] = (0, $iSvIT.useState)(null);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const analyticsAttributes = (0, $g4xTJ.useAnalyticsAttributes)();
    (0, $iSvIT.useEffect)(()=>{
        switch(model.content.videoProvider){
            case "Loom":
                setEmbed(/*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.VideoRatio16By9), {
                    "data-testid": "loom-video",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.ResponsiveVideoFrame), {
                        src: `https://www.loom.com/embed/${model.content.videoId}`,
                        frameBorder: "0",
                        allowFullScreen: true,
                        className: "loom_embed",
                        title: model.content.title
                    })
                }));
                return;
            case "Wistia":
                const wistiaJsonp = document.createElement("script");
                wistiaJsonp.src = `//fast.wistia.com/embed/medias/${model.content.videoId}.jsonp`;
                wistiaJsonp.dataset["testid"] = "wistia-jsonp";
                wistiaJsonp.async = true;
                const wistia = document.createElement("script");
                wistia.src = `//fast.wistia.com/assets/external/E-v1.js`;
                wistia.dataset["testid"] = "wistia";
                wistia.async = true;
                document.body.append(wistiaJsonp, wistia);
                const wistiaEmbedInitConfig = {
                    id: model.content.videoId,
                    onReady: (video)=>{
                        /* istanbul ignore next */ video.bind("play", ()=>{
                            sendTrackEvent("playedVideo", {
                                ...analyticsAttributes,
                                event: "played",
                                eventComponent: model.type,
                                label: model.content.title,
                                labelEnglish: model.content.entryTitle,
                                uuid: model.id,
                                title: model.content.title
                            });
                        });
                    }
                };
                /* istanbul ignore next */ window._wq = window._wq || [];
                window._wq.push(wistiaEmbedInitConfig);
                setEmbed(/*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.VideoRatio16By9), {
                    className: "wistia_responsive_padding",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.ResponsiveVideoWrapper), {
                        className: "wistia_responsive_wrapper",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.VideoEmbed), {
                            className: `wistia_embed wistia_async_${model.content.videoId} seo=false videoFoam=true`
                        })
                    })
                }));
                return ()=>{
                    document.body.removeChild(wistiaJsonp);
                    document.body.removeChild(wistia);
                    /* istanbul ignore next */ window._wq = window._wq || [];
                    window._wq.push({
                        revoke: wistiaEmbedInitConfig
                    });
                };
            default:
                setEmbed(/*#__PURE__*/ (0, $loA2J.jsx)("div", {
                    "data-testid": "unsupported-video-provider",
                    children: "Unsupported video provider"
                }));
                return;
        }
    }, [
        analyticsAttributes,
        model,
        sendTrackEvent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        "data-testid": "ui-video-player",
        children: embed ?? /*#__PURE__*/ (0, $loA2J.jsx)((0, $15cM5.VideoRatio16By9), {
            "aria-hidden": "true",
            "data-testid": "video-placeholder"
        })
    });
};
var $0aedaadf9b51a5ba$export$2e2bcd8739ae039 = $0aedaadf9b51a5ba$var$UiVideoPlayer;

});
parcelRegister("15cM5", function(module, exports) {

$parcel$export(module.exports, "VideoRatio16By9", function () { return $d15d333cc9183789$export$c72fad1e623cdbf6; });
$parcel$export(module.exports, "ResponsiveVideoWrapper", function () { return $d15d333cc9183789$export$d5c7f8b0ab8b2298; });
$parcel$export(module.exports, "ResponsiveVideoFrame", function () { return $d15d333cc9183789$export$116fbaef393f16fa; });
$parcel$export(module.exports, "VideoEmbed", function () { return $d15d333cc9183789$export$c8d62b6bfc1830cf; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");

var $jAJVK = parcelRequire("jAJVK");
const $d15d333cc9183789$export$c72fad1e623cdbf6 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("background-color", `${(0, $i2LPb.colorCSS)("N900", 0.25)}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "56.25% 0 0 0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("overflow", "hidden")}
`;
const $d15d333cc9183789$export$d5c7f8b0ab8b2298 = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("top", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $d15d333cc9183789$export$116fbaef393f16fa = (0, $hYbro.styled).iframe`
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("left", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
    ${(0, $jAJVK.redundantCssFromKebab)("top", "0")}
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
`;
const $d15d333cc9183789$export$c8d62b6bfc1830cf = (0, $hYbro.styled).div`
    ${(0, $jAJVK.redundantCssFromKebab)("width", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
`;

});



parcelRegister("c41JF", function(module, exports) {

$parcel$export(module.exports, "UiWebinarLink", function () { return (parcelRequire("6mKPH")).default; });

var $6mKPH = parcelRequire("6mKPH");

});
parcelRegister("6mKPH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9db0a9e36a6249b3$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");

var $c96zm = parcelRequire("c96zm");
const $9db0a9e36a6249b3$var$UiWebinarLink = ({ model: { type: type, content: content, id: id } })=>{
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $c96zm.WebinarLink), {
        onClick: ()=>sendTrackEvent("clickedUiWebinarLink", {
                event: "clicked",
                eventContainer: type,
                eventComponent: "content",
                label: content.title,
                labelEnglish: content.entryTitle,
                uuid: id,
                href: content.url,
                appearance: content.appearance
            }),
        href: content.url,
        appearance: content.appearance,
        target: "_blank",
        "data-uuid": id,
        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            children: content.title
        })
    });
};
var $9db0a9e36a6249b3$export$2e2bcd8739ae039 = $9db0a9e36a6249b3$var$UiWebinarLink;

});
parcelRegister("c96zm", function(module, exports) {

$parcel$export(module.exports, "WebinarLink", function () { return $446012ea57b04f5d$export$61d74fba5ac03a8d; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $kL1mL = parcelRequire("kL1mL");

var $jAJVK = parcelRequire("jAJVK");
const $446012ea57b04f5d$export$61d74fba5ac03a8d = (0, $hYbro.styled).a`
    ${(0, $jAJVK.redundantCssFromKebab)("align-items", "center")}
    ${(0, $jAJVK.redundantCssFromKebab)("background", `${(0, $i2LPb.colorCSS)("B400")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "6px")}
    ${(0, $jAJVK.redundantCssFromKebab)("box-shadow", `0 2px 0 ${(0, $i2LPb.colorCSS)("B500")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
    ${(0, $jAJVK.redundantCssFromKebab)("display", "flex")}
    ${(0, $jAJVK.redundantCssFromKebab)("height", "100%")}
    ${(0, $jAJVK.redundantCssFromKebab)("min-height", "6rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("opacity", "1")}
    ${(0, $jAJVK.redundantCssFromKebab)("padding", "0.5rem 1rem 0.5rem 6rem")}
    ${(0, $jAJVK.redundantCssFromKebab)("position", "relative")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-align", "left")}
    ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
    ${(0, $jAJVK.redundantCssFromKebab)("transition", "all 0.2s ease 0s")}

    /*text*/
    span {
        ${(0, $jAJVK.redundantCssFromKebab)("display", "inline-block")}
        ${(0, $jAJVK.redundantCssFromKebab)("font-size", `${(0, $kL1mL.fontSizes).md}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("font-weight", "500")}
        ${(0, $jAJVK.redundantCssFromKebab)("line-height", "1.2")}
    }

    /*play button circle*/
    &::before {
        ${(0, $jAJVK.redundantCssFromKebab)("border", "3px solid white")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-radius", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "4rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("left", "1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "-2rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("top", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "4rem")}
    }

    /*play button arrow*/
    &::after {
        ${(0, $jAJVK.redundantCssFromKebab)("border", "1rem solid transparent")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-left", "1.5rem solid white")}
        ${(0, $jAJVK.redundantCssFromKebab)("border-right", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("content", '""')}
        ${(0, $jAJVK.redundantCssFromKebab)("height", "0")}
        ${(0, $jAJVK.redundantCssFromKebab)("left", "2.5rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("margin-top", "-1rem")}
        ${(0, $jAJVK.redundantCssFromKebab)("position", "absolute")}
        ${(0, $jAJVK.redundantCssFromKebab)("top", "50%")}
        ${(0, $jAJVK.redundantCssFromKebab)("width", "0")}
    }

    &:hover {
        ${(0, $jAJVK.redundantCssFromKebab)("color", `${(0, $i2LPb.colorCSS)("N0")}`)}
        ${(0, $jAJVK.redundantCssFromKebab)("text-decoration", "none")}
        ${(0, $jAJVK.redundantCssFromKebab)("transform", "translateY(-2px)")}
    }

    ${({ appearance: appearance })=>appearance === "Webinars page" && `
      background: ${(0, $i2LPb.colorCSS)("P100", 0.5)};
      box-shadow: none;

      &::before {
        background: ${(0, $i2LPb.colorCSS)("N0")};
      }

      &::after {
        border-left-color: ${(0, $i2LPb.colorCSS)("P100", 0.5)};
      }

      &:hover {
        background: ${(0, $i2LPb.colorCSS)("P200", 0.75)};
        &::after {
          border-left-color: ${(0, $i2LPb.colorCSS)("P200", 0.75)};
        }
      }
    `}
`;

});



parcelRegister("6jyNq", function(module, exports) {

$parcel$export(module.exports, "UiWorkspacePicker", function () { return (parcelRequire("3PNQw")).default; });

var $3PNQw = parcelRequire("3PNQw");

});
parcelRegister("3PNQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $383aa57fbc5fac4c$export$2e2bcd8739ae039; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jp1nv = parcelRequire("jp1nv");
parcelRequire("lJZAY");
var $82f25 = parcelRequire("82f25");
parcelRequire("bwkIl");
var $7fKir = parcelRequire("7fKir");
parcelRequire("dg5xP");
var $kzY5l = parcelRequire("kzY5l");
var $5XW95 = parcelRequire("5XW95");

var $7BlmY = parcelRequire("7BlmY");
// eslint-disable-next-line complexity -- TODO: refactor to reduce complexity
const $383aa57fbc5fac4c$var$UiWorkspacePicker = ({ model: model })=>{
    const [dropdownOpen, setDropdownOpen] = (0, $iSvIT.useState)(false);
    const { sendTrackEvent: sendTrackEvent } = (0, $kzY5l.useAnalytics)();
    const member = (0, $5XW95.useMember)();
    const { dropdownTitle: dropdownTitle, noCreditsLeft: noCreditsLeft, noEligibleAdmin: noEligibleAdmin, noWorkspace: noWorkspace, noWorkspaceUrl: noWorkspaceUrl, invalidLoginToken: invalidLoginToken, urlAppendix: urlAppendix } = model.content;
    switch(member.status){
        case "pending":
            return null;
        case "rejected":
            return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.Dropdown), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                    appearance: "Light",
                    url: `/login?returnURL=${urlAppendix}`,
                    decorator: "Arrow",
                    children: invalidLoginToken
                })
            });
        case "resolved":
            const { organizations: organizations = [], id: id, credits: credits = [] } = member.value;
            const eligibleOrganizations = organizations.filter((organization)=>{
                const orgHasPaidProducts = organization.products ? organization.products.filter(function(product) {
                    return (0, $7fKir.paidProductCodes).includes(product);
                }).length > 0 : false;
                const userIsAdmin = organization.memberships ? organization.memberships.filter((membership)=>{
                    return membership.idMember == id && membership.memberType == "admin";
                }).length > 0 : false;
                return userIsAdmin && !orgHasPaidProducts;
            });
            if (organizations.length === 0 && credits.length === 0) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.Dropdown), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $82f25.LinkButton), {
                    appearance: "Light",
                    url: noWorkspaceUrl,
                    decorator: "Arrow",
                    children: noWorkspace
                })
            });
            else return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $7BlmY.Dropdown), {
                "data-testid": "dropdown",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.DropdownButton), {
                        onClick: ()=>setDropdownOpen(!dropdownOpen),
                        "data-testid": "dropdown-button",
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.BottomArrow), {
                            children: dropdownTitle
                        })
                    }),
                    dropdownOpen && eligibleOrganizations.length === 0 && credits.length === 0 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.DropdownWorkspace), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            "data-testid": "no-admins",
                            children: noEligibleAdmin
                        })
                    }),
                    dropdownOpen && eligibleOrganizations.length > 0 && credits.length === 0 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.DropdownWorkspace), {
                        children: eligibleOrganizations.map((workspace)=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $jp1nv.Anchor), {
                                href: `${workspace.url}${urlAppendix}`,
                                onClick: ()=>sendTrackEvent("clickedUiWorkspacePicker", {
                                        event: "clicked",
                                        eventComponent: model.type,
                                        eventContainer: "content",
                                        label: workspace.displayName,
                                        labelEnglish: workspace.displayName,
                                        uuid: id,
                                        href: `${workspace.url}${urlAppendix}`
                                    }),
                                "data-uuid": id,
                                testId: "workspace-link",
                                children: workspace.displayName
                            }, workspace.name))
                    }),
                    // if a member has credits, they aren't eligible for free trial
                    dropdownOpen && credits.length > 0 && /*#__PURE__*/ (0, $loA2J.jsx)((0, $7BlmY.DropdownWorkspace), {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                            "data-testid": "no-credits",
                            children: noCreditsLeft
                        })
                    })
                ]
            });
    }
};
var $383aa57fbc5fac4c$export$2e2bcd8739ae039 = $383aa57fbc5fac4c$var$UiWorkspacePicker;

});
parcelRegister("7BlmY", function(module, exports) {

$parcel$export(module.exports, "Dropdown", function () { return $e70733953bccd162$export$931cbfb6bfb85fc; });
$parcel$export(module.exports, "DropdownButton", function () { return $e70733953bccd162$export$181f40ec41159e56; });
$parcel$export(module.exports, "BottomArrow", function () { return $e70733953bccd162$export$4d426de01126250d; });
$parcel$export(module.exports, "DropdownWorkspace", function () { return $e70733953bccd162$export$3cbac6aa21e7e84d; });

var $hYbro = parcelRequire("hYbro");
parcelRequire("h6yBX");
var $i2LPb = parcelRequire("i2LPb");
var $fpcku = parcelRequire("fpcku");
const $e70733953bccd162$export$931cbfb6bfb85fc = (0, $hYbro.styled).div({
    textAlign: "left"
});
const $e70733953bccd162$export$181f40ec41159e56 = (0, $hYbro.styled).button({
    "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
    "borderRadius": (0, $fpcku.radius).button,
    "border": `1px solid ${(0, $i2LPb.colorCSS)("N0")}`,
    "color": (0, $i2LPb.colorCSS)("N900"),
    "cursor": "pointer",
    "padding": "0.5rem 1rem",
    "textAlign": "left",
    "textDecoration": "none",
    "&:hover": {
        backgroundColor: (0, $i2LPb.colorCSS)("N20"),
        borderColor: (0, $i2LPb.colorCSS)("N20")
    },
    "&:active": {
        backgroundColor: (0, $i2LPb.colorCSS)("N40"),
        borderColor: (0, $i2LPb.colorCSS)("N40")
    }
});
const $e70733953bccd162$export$4d426de01126250d = (0, $hYbro.styled).span({
    backgroundImage: `linear-gradient( 45deg, transparent 50%, ${(0, $i2LPb.colorCSS)("N900")} 50% ), linear-gradient(135deg, ${(0, $i2LPb.colorCSS)("N900")} 50%, transparent 50%)`,
    backgroundPosition: "calc(100% - 5px) calc(0.5em + 5px), calc(100%) calc(0.5em + 5px)",
    backgroundSize: "5px 5px, 5px 5px",
    backgroundRepeat: "no-repeat",
    paddingRight: "1.5rem"
});
const $e70733953bccd162$export$3cbac6aa21e7e84d = (0, $hYbro.styled).div({
    marginTop: "0.1rem",
    display: "block",
    position: "absolute",
    height: "100%",
    width: "90%",
    zIndex: 200,
    whiteSpace: "normal",
    a: {
        "display": "block",
        "border": `1px solid ${(0, $i2LPb.colorCSS)("N20")}`,
        "color": (0, $i2LPb.colorCSS)("N900"),
        "backgroundColor": (0, $i2LPb.colorCSS)("N0"),
        "padding": "0.5rem 1rem",
        "textDecoration": "none",
        "position": "relative",
        "maxWidth": "90%",
        "&:hover": {
            backgroundColor: (0, $i2LPb.colorCSS)("N10")
        }
    },
    span: {
        display: "block",
        border: `1px solid ${(0, $i2LPb.colorCSS)("N20")}`,
        color: (0, $i2LPb.colorCSS)("N900"),
        backgroundColor: (0, $i2LPb.colorCSS)("N0"),
        padding: "0.5rem 1rem",
        textDecoration: "none",
        position: "relative",
        maxWidth: "90%"
    }
});

});





parcelRegister("l3uAP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f5419be935041e76$export$2e2bcd8739ae039; });
function $f5419be935041e76$export$2e2bcd8739ae039() {
    return $f5419be935041e76$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f5419be935041e76$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("kl0zZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ece637e4cdb35a35$export$2e2bcd8739ae039; });

var $fwJHg = parcelRequire("fwJHg");
function $ece637e4cdb35a35$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $fwJHg.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("fwJHg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4dd4a993cc8892b$export$2e2bcd8739ae039; });

var $7MLDa = parcelRequire("7MLDa");

var $lgwRU = parcelRequire("lgwRU");
function $b4dd4a993cc8892b$export$2e2bcd8739ae039(t) {
    var i = (0, $lgwRU.default)(t, "string");
    return "symbol" == (0, $7MLDa.default)(i) ? i : i + "";
}

});
parcelRegister("7MLDa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5ab1f68eb43b60f8$export$2e2bcd8739ae039; });
function $5ab1f68eb43b60f8$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5ab1f68eb43b60f8$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5ab1f68eb43b60f8$export$2e2bcd8739ae039(o);
}

});

parcelRegister("lgwRU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7b496988ae854a8$export$2e2bcd8739ae039; });

var $7MLDa = parcelRequire("7MLDa");
function $f7b496988ae854a8$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $7MLDa.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $7MLDa.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("j6P2N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $de962c27d4548eae$export$2e2bcd8739ae039; });

var $46p8v = parcelRequire("46p8v");

var $Ge0q6 = parcelRequire("Ge0q6");

var $kFPUI = parcelRequire("kFPUI");

var $4zeIJ = parcelRequire("4zeIJ");
function $de962c27d4548eae$export$2e2bcd8739ae039(r, e) {
    return (0, $46p8v.default)(r) || (0, $Ge0q6.default)(r, e) || (0, $kFPUI.default)(r, e) || (0, $4zeIJ.default)();
}

});
parcelRegister("46p8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fcb38788f355acc$export$2e2bcd8739ae039; });
function $2fcb38788f355acc$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("Ge0q6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07eec99d04005445$export$2e2bcd8739ae039; });
function $07eec99d04005445$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("kFPUI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0cfe7f444343593$export$2e2bcd8739ae039; });

var $cdpW7 = parcelRequire("cdpW7");
function $f0cfe7f444343593$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cdpW7.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cdpW7.default)(r, a) : void 0;
    }
}

});
parcelRegister("cdpW7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e4ad1562c4156fb$export$2e2bcd8739ae039; });
function $8e4ad1562c4156fb$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("4zeIJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3535d97fc8c0ab57$export$2e2bcd8739ae039; });
function $3535d97fc8c0ab57$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9H5Ac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70ec75d348910055$export$2e2bcd8739ae039; });

var $kuVPc = parcelRequire("kuVPc");
function $70ec75d348910055$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $kuVPc.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("kuVPc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eec376c63d2e26ae$export$2e2bcd8739ae039; });
function $eec376c63d2e26ae$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("aYNGK", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return (parcelRequire("eWlfK")).BaseCrossFlowApiProvider; });
$parcel$export(module.exports, "Journeys", function () { return (parcelRequire("kQFoP")).Journeys; });

var $eWlfK = parcelRequire("eWlfK");

var $kQFoP = parcelRequire("kQFoP");

});
parcelRegister("eWlfK", function(module, exports) {

$parcel$export(module.exports, "BaseCrossFlowApiProvider", function () { return $ae06f7df3cb6d5e2$export$c0ddec072762f62a; });

var $dIoZD = parcelRequire("dIoZD");

var $iSvIT = parcelRequire("iSvIT");

var $iBeYk = parcelRequire("iBeYk");

var $dxC90 = parcelRequire("dxC90");

var $kQFoP = parcelRequire("kQFoP");
var $ae06f7df3cb6d5e2$var$LATEST_VERSION = (0, $dxC90.VERSION);
/**
 * Private Cross Flow context
 *
 * Not to be used directly other than by useCrossFlow and BaseCrossFlowApiProvider
 */ var $ae06f7df3cb6d5e2$var$CrossFlowContext = /*#__PURE__*/ (0, $iSvIT.createContext)(function() {
    return {
        isEnabled: false,
        reason: (0, $kQFoP.Reasons).NO_PROVIDER
    };
});
var $ae06f7df3cb6d5e2$export$59ce2d27e6cd8c9 = function createNegotiateApi(onOpen) {
    return function(version) {
        switch(version){
            case 0, $dxC90.VERSION:
                return {
                    isEnabled: true,
                    api: (0, $iBeYk.createAPIv0)(onOpen),
                    apiV1: (0, $dxC90.createAPIv1)(onOpen)
                };
            default:
                return {
                    isEnabled: false,
                    reason: (0, $kQFoP.Reasons).NO_API_SUPPORT
                };
        }
    };
};
var $ae06f7df3cb6d5e2$export$c0ddec072762f62a = function BaseCrossFlowApiProvider(_ref) {
    var onOpen = _ref.onOpen, children = _ref.children;
    var negotiateApi = (0, $iSvIT.useMemo)(function() {
        return $ae06f7df3cb6d5e2$export$59ce2d27e6cd8c9(onOpen);
    }, [
        onOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($ae06f7df3cb6d5e2$var$CrossFlowContext.Provider, {
        value: negotiateApi
    }, children);
};
var $ae06f7df3cb6d5e2$export$6e7a10fe635a0dfc = function useCrossFlow() {
    var negotiateApi = (0, $iSvIT.useContext)($ae06f7df3cb6d5e2$var$CrossFlowContext);
    return (0, $iSvIT.useMemo)(function() {
        return negotiateApi($ae06f7df3cb6d5e2$var$LATEST_VERSION);
    }, [
        negotiateApi
    ]);
};
function $ae06f7df3cb6d5e2$export$655b6c19a0daddb8(//component coming in here has no crossflow type yet, but expects it
WrappedComponent) {
    var ComponentWithCrossFlow = function ComponentWithCrossFlow(props) {
        var crossFlow = $ae06f7df3cb6d5e2$export$6e7a10fe635a0dfc();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(WrappedComponent, (0, $dIoZD.default)({}, props, {
            crossFlow: crossFlow
        }));
    };
    ComponentWithCrossFlow.displayName = "withCrossFlow(".concat(WrappedComponent.displayName || WrappedComponent.name || "Component", ")");
    return ComponentWithCrossFlow;
}

});
parcelRegister("dIoZD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fc2c58f6f389f41$export$2e2bcd8739ae039; });
function $9fc2c58f6f389f41$export$2e2bcd8739ae039() {
    return $9fc2c58f6f389f41$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $9fc2c58f6f389f41$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("iBeYk", function(module, exports) {

$parcel$export(module.exports, "createAPIv0", function () { return $d8a74bd41dbfdb8b$export$9ff7368ac93fcf2d; });
/**
 * Version 0 of public Cross Flow API
 */ var $d8a74bd41dbfdb8b$export$a4ad2735b021c132 = 0;
var $d8a74bd41dbfdb8b$export$9ff7368ac93fcf2d = function createAPIv0(onOpen) {
    return {
        open: function open(options) {
            return onOpen(options);
        }
    };
};

});

parcelRegister("dxC90", function(module, exports) {

$parcel$export(module.exports, "VERSION", function () { return $9dbbf21a0195a546$export$a4ad2735b021c132; });
$parcel$export(module.exports, "createAPIv1", function () { return $9dbbf21a0195a546$export$8fd5792fc468459f; });
/**
 * Version 1 of public Cross Flow API
 */ var $9dbbf21a0195a546$export$a4ad2735b021c132 = 1;
var $9dbbf21a0195a546$export$8fd5792fc468459f = function createAPIv1(onOpen) {
    return {
        open: function open(options) {
            return onOpen(options);
        }
    };
};

});

parcelRegister("kQFoP", function(module, exports) {

$parcel$export(module.exports, "Journeys", function () { return $f2d8c7116db25b6e$export$3411873bfd520bb6; });
$parcel$export(module.exports, "Reasons", function () { return $f2d8c7116db25b6e$export$da2d4f2f250d6f84; });
var $f2d8c7116db25b6e$export$3411873bfd520bb6 = {
    GET_STARTED: "get-started",
    DECIDE: "decide",
    DISCOVER: "discover"
};
var $f2d8c7116db25b6e$export$da2d4f2f250d6f84 = {
    NO_API_SUPPORT: "Could not provide requested API version",
    NO_PROVIDER: "Provider not found"
}; // equivalent of `typeof Reason.NO_API_SUPPORT | typeof Reason.NO_PROVIDER | ...`

});



parcelRegister("l4Fg9", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $f579f9fda8af5cca$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $f579f9fda8af5cca$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $f579f9fda8af5cca$export$9d7b58831ae93caa; });
var $f579f9fda8af5cca$export$4ef52930e33717cd = "data-theme";
var $f579f9fda8af5cca$export$a00eac3f8684bcd0 = "data-color-mode";
var $f579f9fda8af5cca$export$2112803007239c61 = "data-contrast-mode";
var $f579f9fda8af5cca$export$352e418ed5b6193a = "data-custom-theme";
var $f579f9fda8af5cca$export$6f0c6fb8c80fcc92 = "ds";
var $f579f9fda8af5cca$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $f579f9fda8af5cca$export$dddac1532e822863 = "--".concat($f579f9fda8af5cca$export$6f0c6fb8c80fcc92, "-token-not-found");
var $f579f9fda8af5cca$export$9d7b58831ae93caa = "--".concat($f579f9fda8af5cca$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("e6piB", function(module, exports) {

$parcel$export(module.exports, "UI_EVENT_TYPE", function () { return $a4454013130ff681$export$a1562d08625f5d7e; });
$parcel$export(module.exports, "TRACK_EVENT_TYPE", function () { return $a4454013130ff681$export$947dac6c72b26f81; });
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", function () { return $a4454013130ff681$export$f1d537d508d2945a; });
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", function () { return $a4454013130ff681$export$12346a674644c156; });
$parcel$export(module.exports, "DEFAULT_SOURCE", function () { return $a4454013130ff681$export$b055de0e665cb20c; });
// same types defined in analytics-web-client but avoid creating dependency with that
var $a4454013130ff681$export$a1562d08625f5d7e = "ui";
var $a4454013130ff681$export$947dac6c72b26f81 = "track";
var $a4454013130ff681$export$f1d537d508d2945a = "screen";
var $a4454013130ff681$export$12346a674644c156 = "operational";
var $a4454013130ff681$export$b055de0e665cb20c = "unknown";

});

parcelRegister("hJmQE", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", function () { return (parcelRequire("7OPxt")).CrossFlowExtensions; });
$parcel$export(module.exports, "Targets", function () { return (parcelRequire("VyZuY")).Targets; });

var $7OPxt = parcelRequire("7OPxt");

var $VyZuY = parcelRequire("VyZuY");

});
parcelRegister("7OPxt", function(module, exports) {

$parcel$export(module.exports, "CrossFlowExtensions", function () { return $5b152e75a0a9f099$export$a5e53d1dcbd6eb61; });

var $gs5nr = parcelRequire("gs5nr");

var $2YcSx = parcelRequire("2YcSx");
var $5b152e75a0a9f099$export$a5e53d1dcbd6eb61 = /*#__PURE__*/ (0, $gs5nr.default)(function CrossFlowExtensions(options) {
    (0, $2YcSx.default)(this, CrossFlowExtensions);
    Object.assign(this, options);
    Object.freeze(this);
});

});
parcelRegister("gs5nr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfa36ea912c6be3f$export$2e2bcd8739ae039; });

var $FwvSc = parcelRequire("FwvSc");
function $bfa36ea912c6be3f$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $FwvSc.default)(o.key), o);
    }
}
function $bfa36ea912c6be3f$export$2e2bcd8739ae039(e, r, t) {
    return r && $bfa36ea912c6be3f$var$_defineProperties(e.prototype, r), t && $bfa36ea912c6be3f$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("FwvSc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07cd0cdf1254b9b3$export$2e2bcd8739ae039; });

var $5b0vy = parcelRequire("5b0vy");

var $kK7gE = parcelRequire("kK7gE");
function $07cd0cdf1254b9b3$export$2e2bcd8739ae039(t) {
    var i = (0, $kK7gE.default)(t, "string");
    return "symbol" == (0, $5b0vy.default)(i) ? i : i + "";
}

});
parcelRegister("5b0vy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c4e5fb8643cd5fd$export$2e2bcd8739ae039; });
function $3c4e5fb8643cd5fd$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $3c4e5fb8643cd5fd$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3c4e5fb8643cd5fd$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kK7gE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f19dbdb9e59855bf$export$2e2bcd8739ae039; });

var $5b0vy = parcelRequire("5b0vy");
function $f19dbdb9e59855bf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $5b0vy.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $5b0vy.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("2YcSx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $229b2cd14f8b3882$export$2e2bcd8739ae039; });
function $229b2cd14f8b3882$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});


parcelRegister("VyZuY", function(module, exports) {

$parcel$export(module.exports, "Targets", function () { return $0ad07773d89e0d5b$export$59a8eb9cff113544; });
/**
 * We are keeping a manual list of targets for the purposes of type safety.
 */ var $0ad07773d89e0d5b$export$59a8eb9cff113544 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_CORE: "jira-core.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_PRODUCT_DISCOVERY: "jira-product-discovery",
    BITBUCKET: "bitbucket.ondemand",
    TRELLO: "trello",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    /**
   * @private
   * @deprecated Use ATLAS instead
   */ TEAM_CENTRAL: "townsquare",
    ATLAS: "townsquare",
    /**
   * @private
   * @deprecated
   */ AVOCADO: "avocado",
    ANALYTICS: "atlassian-analytics-free",
    COMPASS: "compass",
    LOOM: "loom"
}; /**
 * The list of supported targets in Cross-flow.
 *
 * While TypeScript does match this to the list of Targets provided in this library,
 * in essence any string value can be used to accomodate this type through the use of
 * type casting.
 */ 

});


parcelRegister("5MfkQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $434d54af154b9550$export$2e2bcd8739ae039; });
function $434d54af154b9550$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("iRbzA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dba6275e3d331a66$export$2e2bcd8739ae039; });

var $fwJHg = parcelRequire("fwJHg");
function $dba6275e3d331a66$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $fwJHg.default)(o.key), o);
    }
}
function $dba6275e3d331a66$export$2e2bcd8739ae039(e, r, t) {
    return r && $dba6275e3d331a66$var$_defineProperties(e.prototype, r), t && $dba6275e3d331a66$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("4rxeI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33c3771c31db7907$export$2e2bcd8739ae039; });

var $7MLDa = parcelRequire("7MLDa");

var $kLTGa = parcelRequire("kLTGa");
function $33c3771c31db7907$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $7MLDa.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $kLTGa.default)(t);
}

});
parcelRegister("kLTGa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f363282b2a0f24$export$2e2bcd8739ae039; });
function $f1f363282b2a0f24$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("1rjYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10c7ce0495cb110e$export$2e2bcd8739ae039; });
function $10c7ce0495cb110e$export$2e2bcd8739ae039(t) {
    return $10c7ce0495cb110e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $10c7ce0495cb110e$export$2e2bcd8739ae039(t);
}

});

parcelRegister("RIgEX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0a1749feea56a43b$export$2e2bcd8739ae039; });

var $8x224 = parcelRequire("8x224");
function $0a1749feea56a43b$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $8x224.default)(t, e);
}

});
parcelRegister("8x224", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6362fb5f700bb198$export$2e2bcd8739ae039; });
function $6362fb5f700bb198$export$2e2bcd8739ae039(t, e) {
    return $6362fb5f700bb198$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $6362fb5f700bb198$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("b63pT", function(module, exports) {

$parcel$export(module.exports, "source", function () { return $8142e7bb77bb98bb$export$b4d5da5f34fb77ad; });
$parcel$export(module.exports, "errorBoundaryAction", function () { return $8142e7bb77bb98bb$export$9d8252a268f4fa72; });
$parcel$export(module.exports, "errorBoundaryActionSubject", function () { return $8142e7bb77bb98bb$export$1045419caf49b395; });
$parcel$export(module.exports, "crossFlowActionSubject", function () { return $8142e7bb77bb98bb$export$d54c183f56e39aa5; });
$parcel$export(module.exports, "uiInitialized", function () { return $8142e7bb77bb98bb$export$e5c2c058fa8068a6; });
$parcel$export(module.exports, "openInvoked", function () { return $8142e7bb77bb98bb$export$e67cdcb8867a3bd0; });

var $e6piB = parcelRequire("e6piB");
var $8142e7bb77bb98bb$export$b4d5da5f34fb77ad = "crossFlowProvider";
var $8142e7bb77bb98bb$export$9d8252a268f4fa72 = "errorCaught";
var $8142e7bb77bb98bb$export$1045419caf49b395 = "errorBoundary";
var $8142e7bb77bb98bb$export$d54c183f56e39aa5 = "crossFlowSupport";
var $8142e7bb77bb98bb$export$e5c2c058fa8068a6 = "uiInitialized";
var $8142e7bb77bb98bb$export$e67cdcb8867a3bd0 = "openInvoked";

});

parcelRegister("23Zjb", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("czhA8").then(()=>parcelRequire("3DgVO"));

});

parcelRegister("a1Odi", function(module, exports) {

var $bBxN9 = parcelRequire("bBxN9");
module.exports = $bBxN9("cWCgP").then(()=>parcelRequire("dyZbY"));

});

// @ts-nocheck - init-trello.tsx bridges wac-web types (layout) and entries types which are incompatible at the boundary

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $3tsVE = parcelRequire("3tsVE");
var $0053835da9e1d91f$export$882461b6382ed46c;
var $0053835da9e1d91f$export$757ceba2d55c277e;
"use strict";

var $i5UxU = parcelRequire("i5UxU");
var $0053835da9e1d91f$var$i;
$0053835da9e1d91f$export$882461b6382ed46c = $i5UxU.createRoot;
$0053835da9e1d91f$export$757ceba2d55c277e = $i5UxU.hydrateRoot;



var $hYbro = parcelRequire("hYbro");
const $ed34083de3cb1795$var$randomUUID = typeof crypto !== "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $ed34083de3cb1795$export$2e2bcd8739ae039 = {
    randomUUID: $ed34083de3cb1795$var$randomUUID
};


// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $f0da5b1d3d1ebbd0$var$getRandomValues;
const $f0da5b1d3d1ebbd0$var$rnds8 = new Uint8Array(16);
function $f0da5b1d3d1ebbd0$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$f0da5b1d3d1ebbd0$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $f0da5b1d3d1ebbd0$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$f0da5b1d3d1ebbd0$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $f0da5b1d3d1ebbd0$var$getRandomValues($f0da5b1d3d1ebbd0$var$rnds8);
}


var $24b21a4192ec01ac$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $39c1b902990e8731$var$validate(uuid) {
    return typeof uuid === "string" && (0, $24b21a4192ec01ac$export$2e2bcd8739ae039).test(uuid);
}
var $39c1b902990e8731$export$2e2bcd8739ae039 = $39c1b902990e8731$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $e57576bdf67901d5$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$e57576bdf67901d5$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $e57576bdf67901d5$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $e57576bdf67901d5$var$byteToHex[arr[offset + 0]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 1]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 2]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 3]] + "-" + $e57576bdf67901d5$var$byteToHex[arr[offset + 4]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 5]] + "-" + $e57576bdf67901d5$var$byteToHex[arr[offset + 6]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 7]] + "-" + $e57576bdf67901d5$var$byteToHex[arr[offset + 8]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 9]] + "-" + $e57576bdf67901d5$var$byteToHex[arr[offset + 10]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 11]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 12]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 13]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 14]] + $e57576bdf67901d5$var$byteToHex[arr[offset + 15]];
}
function $e57576bdf67901d5$var$stringify(arr, offset = 0) {
    const uuid = $e57576bdf67901d5$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $39c1b902990e8731$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $e57576bdf67901d5$export$2e2bcd8739ae039 = $e57576bdf67901d5$var$stringify;


function $93c86ba4b7e7f969$var$v4(options, buf, offset) {
    if ((0, $ed34083de3cb1795$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $ed34083de3cb1795$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $f0da5b1d3d1ebbd0$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $e57576bdf67901d5$export$8fb373d660548968)(rnds);
}
var $93c86ba4b7e7f969$export$2e2bcd8739ae039 = $93c86ba4b7e7f969$var$v4;



var $iSvIT = parcelRequire("iSvIT");
/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $c3163505721bf9af$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $c3163505721bf9af$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $c3163505721bf9af$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === "undefined") return;
        attributes = $c3163505721bf9af$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = "";
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += "; " + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
        }
        return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === "undefined" || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split("; ") : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split("=");
            var value = parts.slice(1).join("=");
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, "", $c3163505721bf9af$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $c3163505721bf9af$var$init(this.converter, $c3163505721bf9af$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $c3163505721bf9af$var$init($c3163505721bf9af$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $c3163505721bf9af$export$2e2bcd8739ae039 = $c3163505721bf9af$var$init($c3163505721bf9af$var$defaultConverter, {
    path: "/"
});



var $6LIwV = parcelRequire("6LIwV");
function $0455b010a482158e$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $6cb7d6ee2084595b$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $0455b010a482158e$export$2e2bcd8739ae039)(r);
}


function $e4857a859f35efb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $65b317273216375e$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $0455b010a482158e$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $0455b010a482158e$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $022f2f8282e416e4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $3a0da52d64e885cc$export$2e2bcd8739ae039(r) {
    return (0, $6cb7d6ee2084595b$export$2e2bcd8739ae039)(r) || (0, $e4857a859f35efb5$export$2e2bcd8739ae039)(r) || (0, $65b317273216375e$export$2e2bcd8739ae039)(r) || (0, $022f2f8282e416e4$export$2e2bcd8739ae039)();
}


function $4b1df5cc5052334c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


function $2f6bea7d60c497b7$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $2f6bea7d60c497b7$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2f6bea7d60c497b7$export$2e2bcd8739ae039(o);
}



function $c444daea153e6be1$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $2f6bea7d60c497b7$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $2f6bea7d60c497b7$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $1ce7994e17975dcc$export$2e2bcd8739ae039(t) {
    var i = (0, $c444daea153e6be1$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $2f6bea7d60c497b7$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $735859b934da068c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $1ce7994e17975dcc$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $735859b934da068c$export$2e2bcd8739ae039(e, r, t) {
    return r && $735859b934da068c$var$_defineProperties(e.prototype, r), t && $735859b934da068c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $d614dfe438fd8b4e$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $63f2a10b9e4b0779$export$2e2bcd8739ae039(t) {
    return $63f2a10b9e4b0779$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $63f2a10b9e4b0779$export$2e2bcd8739ae039(t);
}


function $81f79ca93a97ff44$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(t)););
    return t;
}


function $8c19e8cbc55b319c$export$2e2bcd8739ae039() {
    return $8c19e8cbc55b319c$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $81f79ca93a97ff44$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $8c19e8cbc55b319c$export$2e2bcd8739ae039.apply(null, arguments);
}


function $999f8ae358b3330e$export$2e2bcd8739ae039(t, e) {
    return $999f8ae358b3330e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $999f8ae358b3330e$export$2e2bcd8739ae039(t, e);
}


function $e99985525351953a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $999f8ae358b3330e$export$2e2bcd8739ae039)(t, e);
}




function $c9862f14105c0820$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $2f6bea7d60c497b7$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(t);
}




function $4f3cde5c9cb9c65a$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $1ce7994e17975dcc$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}






function $6e174223bc5ee136$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6e174223bc5ee136$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6e174223bc5ee136$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6e174223bc5ee136$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $6e174223bc5ee136$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6e174223bc5ee136$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $6e174223bc5ee136$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, $4b1df5cc5052334c$export$2e2bcd8739ae039)(this, AnalyticsEvent);
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)(this, "_isAnalyticsEvent", true);
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6e174223bc5ee136$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, $735859b934da068c$export$2e2bcd8739ae039)(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, $2f6bea7d60c497b7$export$2e2bcd8739ae039)(updater) === "object") this.payload = $6e174223bc5ee136$var$_objectSpread($6e174223bc5ee136$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $78621497ad95fda9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $78621497ad95fda9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c9862f14105c0820$export$2e2bcd8739ae039)(this, result);
    };
}
function $78621497ad95fda9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $78621497ad95fda9$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $78621497ad95fda9$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $78621497ad95fda9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, $e99985525351953a$export$2e2bcd8739ae039)(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $78621497ad95fda9$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, $4b1df5cc5052334c$export$2e2bcd8739ae039)(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "_isUIAnalyticsEvent", true);
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, $3a0da52d64e885cc$export$2e2bcd8739ae039)(_this.context);
            var handlers = (0, $3a0da52d64e885cc$export$2e2bcd8739ae039)(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, $735859b934da068c$export$2e2bcd8739ae039)(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, $8c19e8cbc55b319c$export$2e2bcd8739ae039)((0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $6e174223bc5ee136$export$2e2bcd8739ae039));



var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");
var $3e2d3fe0a97f2dff$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $iSvIT.useContext)((0, $lEO1D.default));
};


function $bc1d71a60bfff1c9$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3e2d3fe0a97f2dff$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $6LIwV.useCallbackOne)(function(payload) {
        return new (0, $78621497ad95fda9$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



var $4LHd8 = parcelRequire("4LHd8");
var $6GwB3 = parcelRequire("6GwB3");
/**
 * @typedef {object} Cohort
 * @property {string} ATL_COHORT The cookie name
 * @property {object | null} readWriteAtlCohort The cohort object or null
 * @property {object | null} readAtlCohort The cohort object or null
 */ class $0c0b6320f31ec5e5$export$bd0cf18531183c14 {
    static getCookieUrl(cookieName, defaultUrl) {
        const cookieUrl = $0c0b6320f31ec5e5$export$bd0cf18531183c14.readCookie(cookieName);
        if (cookieUrl !== null) return cookieUrl;
        return defaultUrl;
    }
    static readCookie(name, requestCookie) {
        try {
            const nameEQ = name + "=";
            const ca = (requestCookie || document.cookie).split(";");
            for (let c of ca){
                while(c.startsWith(" "))c = c.substring(1, c.length);
                if (c.startsWith(nameEQ)) return c.substring(nameEQ.length, c.length);
            }
        } catch (e) {
            // Helpers.sendWrapperLoadError uses this method to get some context
            // for the reported error, so we don't want to call that here, otherwise
            // we would get stuck in an infinite loop
            // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
            if (name !== "login_user_detected") console.warn(`Error reading cookie - ${name}`, e);
        }
        return null;
    }
    static writeCookie(name, value, days, topLevelDomain) {
        const seconds = days ? days * 86400 : null;
        $0c0b6320f31ec5e5$export$bd0cf18531183c14.writeCookieInSeconds(name, value, seconds, topLevelDomain);
    }
    static writeCookieInSeconds(name, value, seconds, topLevelDomain) {
        try {
            let expires = "";
            if (seconds) {
                const date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            let cookie = name + "=" + value + expires + "; path=/;";
            let domain = window.location.hostname;
            if (domain !== "localhost" && topLevelDomain) {
                const domainTokens = domain.split(".");
                if (domainTokens.length > 2) {
                    const lastToken = domainTokens[domainTokens.length - 1];
                    const secondLastToken = domainTokens[domainTokens.length - 2];
                    if (isNaN(Number(lastToken)) || isNaN(Number(secondLastToken))) domain = "." + secondLastToken + "." + lastToken;
                } else if (domainTokens.length === 2) domain = "." + domain;
                cookie += " domain=" + domain + ";";
            }
            document.cookie = cookie;
        } catch (e) {
            console.warn(`Error writing cookie - ${name}`, e);
        }
    }
}



var $f2bbcecd7d3447b1$exports = {};

$parcel$export($f2bbcecd7d3447b1$exports, "extract", function () { return $f2bbcecd7d3447b1$export$f9380c9a627682d3; }, function (v) { return $f2bbcecd7d3447b1$export$f9380c9a627682d3 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "parse", function () { return $f2bbcecd7d3447b1$export$98e6a39c04603d36; }, function (v) { return $f2bbcecd7d3447b1$export$98e6a39c04603d36 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "stringify", function () { return $f2bbcecd7d3447b1$export$fac44ee5b035f737; }, function (v) { return $f2bbcecd7d3447b1$export$fac44ee5b035f737 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "parseUrl", function () { return $f2bbcecd7d3447b1$export$7a5253c0f62e0150; }, function (v) { return $f2bbcecd7d3447b1$export$7a5253c0f62e0150 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "stringifyUrl", function () { return $f2bbcecd7d3447b1$export$a8c1621ea79325d3; }, function (v) { return $f2bbcecd7d3447b1$export$a8c1621ea79325d3 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "pick", function () { return $f2bbcecd7d3447b1$export$357523c63a2253b9; }, function (v) { return $f2bbcecd7d3447b1$export$357523c63a2253b9 = v; });
$parcel$export($f2bbcecd7d3447b1$exports, "exclude", function () { return $f2bbcecd7d3447b1$export$44c361b8ec72ef7f; }, function (v) { return $f2bbcecd7d3447b1$export$44c361b8ec72ef7f = v; });
var $f2bbcecd7d3447b1$export$f9380c9a627682d3;
var $f2bbcecd7d3447b1$export$98e6a39c04603d36;
var $f2bbcecd7d3447b1$export$fac44ee5b035f737;
var $f2bbcecd7d3447b1$export$7a5253c0f62e0150;
var $f2bbcecd7d3447b1$export$a8c1621ea79325d3;
var $f2bbcecd7d3447b1$export$357523c63a2253b9;
var $f2bbcecd7d3447b1$export$44c361b8ec72ef7f;
"use strict";

var $cBwPl = parcelRequire("cBwPl");

var $2RP26 = parcelRequire("2RP26");

var $888c8 = parcelRequire("888c8");

var $95zlx = parcelRequire("95zlx");
const $f2bbcecd7d3447b1$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $f2bbcecd7d3447b1$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "[",
                            $f2bbcecd7d3447b1$var$encode(index, options),
                            "]=",
                            $f2bbcecd7d3447b1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "[]=",
                            $f2bbcecd7d3447b1$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "=",
                            $f2bbcecd7d3447b1$var$encode(value, options)
                        ].join("")
                    ];
                    return [
                        [
                            result,
                            $f2bbcecd7d3447b1$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $f2bbcecd7d3447b1$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $f2bbcecd7d3447b1$var$encode(key, options),
                            "=",
                            $f2bbcecd7d3447b1$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $f2bbcecd7d3447b1$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $f2bbcecd7d3447b1$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $f2bbcecd7d3447b1$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$f2bbcecd7d3447b1$var$decode(item, options)) : value === null ? value : $f2bbcecd7d3447b1$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $f2bbcecd7d3447b1$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $f2bbcecd7d3447b1$var$encode(value, options) {
    if (options.encode) return options.strict ? $cBwPl(value) : encodeURIComponent(value);
    return value;
}
function $f2bbcecd7d3447b1$var$decode(value, options) {
    if (options.decode) return $2RP26(value);
    return value;
}
function $f2bbcecd7d3447b1$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $f2bbcecd7d3447b1$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $f2bbcecd7d3447b1$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $f2bbcecd7d3447b1$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $f2bbcecd7d3447b1$var$extract(input) {
    input = $f2bbcecd7d3447b1$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $f2bbcecd7d3447b1$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $f2bbcecd7d3447b1$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $f2bbcecd7d3447b1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $f2bbcecd7d3447b1$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $888c8(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator"
        ].includes(options.arrayFormat) ? value : $f2bbcecd7d3447b1$var$decode(value, options);
        formatter($f2bbcecd7d3447b1$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $f2bbcecd7d3447b1$var$parseValue(value[k], options);
        else ret[key] = $f2bbcecd7d3447b1$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $f2bbcecd7d3447b1$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$f2bbcecd7d3447b1$export$f9380c9a627682d3 = $f2bbcecd7d3447b1$var$extract;
$f2bbcecd7d3447b1$export$98e6a39c04603d36 = $f2bbcecd7d3447b1$var$parse;
$f2bbcecd7d3447b1$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $f2bbcecd7d3447b1$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $f2bbcecd7d3447b1$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $f2bbcecd7d3447b1$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $f2bbcecd7d3447b1$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join("&");
        return $f2bbcecd7d3447b1$var$encode(key, options) + "=" + $f2bbcecd7d3447b1$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$f2bbcecd7d3447b1$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $888c8(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $f2bbcecd7d3447b1$var$parse($f2bbcecd7d3447b1$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $f2bbcecd7d3447b1$var$decode(hash, options)
    } : {});
};
$f2bbcecd7d3447b1$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $f2bbcecd7d3447b1$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $f2bbcecd7d3447b1$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $f2bbcecd7d3447b1$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $f2bbcecd7d3447b1$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $f2bbcecd7d3447b1$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$f2bbcecd7d3447b1$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$f2bbcecd7d3447b1$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $f2bbcecd7d3447b1$export$7a5253c0f62e0150(input, options);
    return $f2bbcecd7d3447b1$export$a8c1621ea79325d3({
        url: url,
        query: $95zlx(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$f2bbcecd7d3447b1$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $f2bbcecd7d3447b1$export$357523c63a2253b9(input, exclusionFilter, options);
};


/**
 * Test if we have localstorage enabled
 * @returns boolean
 */ const $2c637c10bc35918d$var$isLocalStorageEnabled = ()=>{
    try {
        // First check if localStorage object is accessible
        // In some environments (iframes, private browsing), accessing window.localStorage
        // itself can throw a SecurityError, so we need to check for existence first
        if (typeof window === "undefined" || !window) return false;
        // Assign to variable to ensure property access is wrapped in try-catch
        const storage = window.localStorage;
        if (!storage) return false;
        const key = `_storage_test`;
        storage.setItem(key, "yes");
        storage.removeItem(key);
        return true;
    } catch (e) {
        // SecurityError: Failed to read the 'localStorage' property from 'Window'
        // or QuotaExceededError, etc. All mean localStorage is not available
        return false;
    }
};
/**
 *
 * @param name name of the localstorage
 * @returns string
 */ const $2c637c10bc35918d$var$defaultExpiry = 3600; // one hour
const $2c637c10bc35918d$var$expiresKey = "_expiresIn";
const $2c637c10bc35918d$export$d3720feff416e85b = (name, skipExpiryCheck = false)=>{
    if (!$2c637c10bc35918d$var$isLocalStorageEnabled()) {
        console.log("Localstorage is not available. Please check if the browser supports localstorage.");
        return null;
    }
    const now = Date.now();
    const expiresIn = parseInt(localStorage.getItem(name + $2c637c10bc35918d$var$expiresKey) || "0");
    if (expiresIn < now && !skipExpiryCheck) {
        $2c637c10bc35918d$export$720fb0373088e6ec(name);
        return null;
    } else try {
        const value = localStorage.getItem(name);
        return value;
    } catch (e) {
        console.log(`Error reading ${name} from localstorage ${JSON.stringify(e)}`);
        return null;
    }
};
const $2c637c10bc35918d$export$1f73f60bdb811cb1 = (name, value, expires = $2c637c10bc35918d$var$defaultExpiry)=>{
    if (!$2c637c10bc35918d$var$isLocalStorageEnabled()) {
        console.log("Localstorage is not available. Please check if the browser supports localstorage.");
        return false;
    }
    expires = Math.abs(expires);
    const now = Date.now();
    const schedule = now + expires * 1000;
    try {
        localStorage.setItem(name, value);
        localStorage.setItem(name + $2c637c10bc35918d$var$expiresKey, schedule.toString());
    } catch (e) {
        console.log(`Error setting ${name} in localstorage ${JSON.stringify(e)}`);
        return false;
    }
    return true;
};
const $2c637c10bc35918d$export$720fb0373088e6ec = (name)=>{
    if (!$2c637c10bc35918d$var$isLocalStorageEnabled()) {
        console.log("Localstorage is not available. Please check if the browser supports localstorage.");
        return false;
    }
    try {
        localStorage.removeItem(name);
        localStorage.removeItem(name + $2c637c10bc35918d$var$expiresKey);
    } catch (e) {
        console.log(`Error removing ${name} in localstorage ${JSON.stringify(e)}`);
        return false;
    }
    return true;
};



class $60fe77bbcb3e6704$export$4a20ceb938e79e70 {
    static #_ = this.analyticsOptOut = true;
}





class $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b {
    static #_ = this.CROSS_DOMAIN_UTM_EXPIRY = 3600000 // 1hr in ms
    ;
    static sendGUPSQuery(headers, body, callback) {
        const gupsEndpoint = "https://www.atlassian.com/gateway/api/graphql";
        (0, $60bf2125eaedf843$export$4dc2b60021baefca).makeRestRequest("POST", gupsEndpoint, headers, body, false, callback);
    }
    static getMarketingContext(anonymousId, sessionId, domain, localLastUpdated, nullMarketingContext) {
        const query = `query getUnifiedProfile($anonymousId: ID) {
            growthUnifiedProfile_getUnifiedProfile(
                anonymousId: $anonymousId
            ){
                marketingContext {
                    sessionId, 
                    domain,
                    lastUpdated,
                    utm {
                        sfdcCampaignId,
                        medium,
                        source,
                        campaign,
                        content
                    }
                }
            }
        }`;
        const variables = {
            anonymousId: anonymousId
        };
        const payload = JSON.stringify({
            query: query,
            variables: variables
        });
        const headers = [
            {
                header: "Content-type",
                value: "application/json"
            },
            {
                header: "x-use-case",
                value: "voltron-marketing-context"
            }
        ];
        const callback = function(result) {
            if (result === "error") console.error("Failed request to retrieve marketingContext from GUPS");
            else {
                const parsedResponse = JSON.parse(result);
                const marketingContext = parsedResponse?.data?.growthUnifiedProfile_getUnifiedProfile?.marketingContext;
                let validSameDomainUtms;
                let validCrossDomainUtms;
                if (marketingContext) {
                    validSameDomainUtms = domain === marketingContext.domain && sessionId === marketingContext.sessionId;
                    validCrossDomainUtms = domain !== marketingContext.domain && sessionId && Number(sessionId) - Number(localLastUpdated) < $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b.CROSS_DOMAIN_UTM_EXPIRY;
                }
                if (validSameDomainUtms || validCrossDomainUtms) {
                    if (validSameDomainUtms) (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", JSON.stringify(marketingContext));
                    else if (validCrossDomainUtms) (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", JSON.stringify({
                        sessionId: sessionId,
                        domain: domain,
                        lastUpdated: sessionId,
                        utm: marketingContext.utm
                    }));
                    const gupsUtms = marketingContext.utm;
                    (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).utms = {
                        "utm_sfdc-campaign_id": gupsUtms.sfdcCampaignId,
                        "utm_campaign": gupsUtms.campaign,
                        "utm_source": gupsUtms.source,
                        "utm_medium": gupsUtms.medium,
                        "utm_content": gupsUtms.content
                    };
                } else {
                    (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", nullMarketingContext);
                    (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).utms = null;
                }
            }
        };
        try {
            $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b.sendGUPSQuery(headers, payload, callback);
        } catch (error) {
            console.error("Failed to retrieve marketingContext from GUPS with error:", error);
        }
    }
    static setMarketingContext(anonymousId, sessionId, domain, utms) {
        const mutation = `mutation SetMarketingContext {
            growthUnifiedProfile_createUnifiedProfile(profile: 
                { 
                    anonymousId: "${anonymousId}", 
                    unifiedProfile: { 
                        marketingContext : {
                            sessionId: "${sessionId}",
                            domain: "${domain}", 
                            utm: {
                                sfdcCampaignId: "${utms["utm_sfdc-campaign_id"]}"
                                source: "${utms["utm_source"]}"
                                medium: "${utms["utm_medium"]}"
                                content: "${utms["utm_content"]}"
                                campaign: "${utms["utm_campaign"]}"
                            }
                        }
                    } 
                }) {
                    marketingContext {
                        lastUpdated
                    }
                }
        }`;
        const headers = [
            {
                header: "Content-type",
                value: "application/json"
            },
            {
                header: "x-use-case",
                value: "create-voltron-marketing-context"
            }
        ];
        const payload = JSON.stringify({
            query: mutation
        });
        const callback = function(result) {
            if (result === "error") console.error("Failed request to set marketingContext in GUPS");
            else {
                let parsedResponse;
                try {
                    parsedResponse = JSON.parse(result);
                    const lastUpdated = parsedResponse.data.growthUnifiedProfile_createUnifiedProfile.marketingContext.lastUpdated;
                    (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", JSON.stringify({
                        sessionId: sessionId,
                        domain: domain,
                        lastUpdated: lastUpdated,
                        utm: {
                            sfdcCampaignId: utms["utm_sfdc-campaign_id"],
                            campaign: utms["utm_campaign"],
                            source: utms["utm_source"],
                            medium: utms["utm_medium"],
                            content: utms["utm_content"]
                        }
                    }));
                } catch (error) {
                    console.error("Failed to retrieve lastUpdated from GUPS with error:", error);
                }
            }
        };
        try {
            $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b.sendGUPSQuery(headers, payload, callback);
        } catch (error) {
            console.error("Failed to set marketingContext in GUPS with error:", error);
        }
    }
}


// This regex is the simplified RFC 5322 expression from http://www.regular-expressions.info/email.html with added %40 for encoded urls
const $60bf2125eaedf843$var$EMAIL_REGEX = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*[@(%40)](?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
const $60bf2125eaedf843$var$PATH_OVERRIDE = "/path-contained-email-address";
const $60bf2125eaedf843$var$CROSS_DOMAIN_UTM_EXPIRY = 3600000; // 1hr in ms
class $60bf2125eaedf843$export$4dc2b60021baefca {
    /**
   * Attempts to send an HTTP request.
   * @function makeRestRequest
   * @param {string} method the request method
   * @param {string} url the request URL
   * @param {Object[]} headers an array of headers to set in the request
   * @param {string} body the body of the request
   * @param {boolean} credentials whether to send request with credentials; defaults to false
   * @param {callback} callback optional callback function
   * @param {object} mockReq used in testing so we don't actually send a request
   */ static makeRestRequest(method, url, headers, body, credentials, callback, mockReq) {
        const xhr = mockReq || new XMLHttpRequest();
        xhr.open(method, url);
        xhr.withCredentials = credentials ? credentials : false;
        if (!!headers) // set headers
        for (const item of headers)xhr.setRequestHeader(item.header, item.value);
        if (!body) body = null;
        xhr.onreadystatechange = function() {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    if (callback) callback(xhr.responseText);
                } else if (callback) callback("error");
            }
        };
        xhr.send(body);
    }
    static sendWrapperLoadError(message, data) {
        const anonymousId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("ajs_anonymous_id");
        let decodedAnonymousId;
        if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
        decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
        const userId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("__aid_user_id");
        let decodedUserId;
        if (userId) decodedUserId = decodeURIComponent(userId);
        const xid = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("seg_xid");
        const body = {
            anonymousId: decodedAnonymousId || null,
            userId: decodedUserId || null,
            xid: xid || null,
            message: message || null,
            version: (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).version,
            additionalData: data || null
        };
        const env = "production";
        const url = env === "production" ? "https://www.atlassian.com/endpoint/atlglobalload" : "https://wac.stg.internal.atlassian.com/endpoint/atlglobalload";
        const headers = [
            {
                header: "Content-type",
                value: "application/json"
            },
            {
                header: "accept",
                value: "*/*"
            }
        ];
        $60bf2125eaedf843$export$4dc2b60021baefca.makeRestRequest("POST", url, headers, JSON.stringify(body), false);
    }
    static getParameterByName(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        const results = regex.exec(window.location.search);
        const value = results && results.length >= 2 ? results[1] : null;
        return !value ? "" : decodeURIComponent(value.replace(/\+/g, " "));
    }
    static getLocalMarketingContext() {
        try {
            const localMarketingContext = (0, $2c637c10bc35918d$export$d3720feff416e85b)("marketingContext", true);
            const parsedMarketingContext = localMarketingContext && JSON.parse(localMarketingContext) || null;
            return parsedMarketingContext;
        } catch (error) {
            console.error("Failed to parse marketingContext from localStorage:", error);
            return null;
        }
    }
    static getUtmsFromUrl(utms) {
        if (window.location.search.includes("utm_")) {
            for(const utmKey in utms)if (utms.hasOwnProperty(utmKey)) utms[utmKey] = $60bf2125eaedf843$export$4dc2b60021baefca.getParameterByName(utmKey);
            return utms;
        }
        return null;
    }
    static newUtmsMatchLocalUtms(urlUtms, localUtms) {
        return urlUtms["utm_sfdc-campaign_id"] === localUtms["sfdcCampaignId"] && urlUtms["utm_campaign"] === localUtms["campaign"] && urlUtms["utm_source"] === localUtms["source"] && urlUtms["utm_medium"] === localUtms["medium"] && urlUtms["utm_content"] === localUtms["content"];
    }
    static getAndSetUtms(utmKeys) {
        const urlUtms = $60bf2125eaedf843$export$4dc2b60021baefca.getUtmsFromUrl(utmKeys);
        let anonymousId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("ajs_anonymous_id");
        anonymousId = anonymousId && decodeURIComponent(anonymousId).replace(/['"]+/g, "");
        const awcSessionId = (0, $2c637c10bc35918d$export$d3720feff416e85b)("awc.session.id", true);
        const domain = window.location.hostname;
        const localMarketingContext = $60bf2125eaedf843$export$4dc2b60021baefca.getLocalMarketingContext();
        const nullMarketingContext = JSON.stringify({
            sessionId: awcSessionId,
            domain: domain,
            lastUpdated: awcSessionId,
            utm: {
                sfdcCampaignId: "",
                campaign: "",
                source: "",
                medium: "",
                content: ""
            }
        });
        if (urlUtms) {
            if (!localMarketingContext || localMarketingContext && (awcSessionId !== localMarketingContext.sessionId || !$60bf2125eaedf843$export$4dc2b60021baefca.newUtmsMatchLocalUtms(urlUtms, localMarketingContext.utm))) (0, $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b).setMarketingContext(anonymousId, awcSessionId, domain, urlUtms);
            return urlUtms;
        } else if (localMarketingContext) {
            const localUtms = {
                "utm_sfdc-campaign_id": localMarketingContext.utm.sfdcCampaignId,
                "utm_campaign": localMarketingContext.utm.campaign,
                "utm_source": localMarketingContext.utm.source,
                "utm_medium": localMarketingContext.utm.medium,
                "utm_content": localMarketingContext.utm.content
            };
            if (localMarketingContext.sessionId === null) {
                const hasUtms = Object.values(localUtms).some((value)=>value !== "");
                if (hasUtms) (0, $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b).setMarketingContext(anonymousId, awcSessionId, domain, localUtms);
                else (0, $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b).getMarketingContext(anonymousId, awcSessionId, domain, awcSessionId, nullMarketingContext);
            } else if (domain === localMarketingContext.domain) {
                if (localMarketingContext.sessionId === awcSessionId) return localUtms;
                else (0, $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b).getMarketingContext(anonymousId, awcSessionId, domain, localMarketingContext.lastUpdated, nullMarketingContext);
            } else {
                const validCrossDomainUtms = awcSessionId && Number(awcSessionId) - Number(localMarketingContext.lastUpdated) < $60bf2125eaedf843$var$CROSS_DOMAIN_UTM_EXPIRY;
                if (validCrossDomainUtms) {
                    // overwrite session.id and domain in marketingContext to enable single domain logic on subsequent data fetches
                    (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", JSON.stringify({
                        sessionId: awcSessionId,
                        domain: domain,
                        lastUpdated: awcSessionId,
                        utm: localMarketingContext.utm
                    }));
                    return localUtms;
                }
            }
        } else (0, $8c2d4cb0ccd370b9$export$bf3cce71df5bd3b).getMarketingContext(anonymousId, awcSessionId, domain, awcSessionId, nullMarketingContext);
        (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("marketingContext", nullMarketingContext);
        return null;
    }
    // taken from https://github.com/segmentio/canonical/blob/master/lib/index.js
    static canonical() {
        const tags = Array.from(document.getElementsByTagName("link"));
        for (const tag of tags){
            if (tag && tag.getAttribute("rel") === "canonical") return tag.getAttribute("href");
        }
        return null;
    }
    // taken from https://github.com/segmentio/analytics.js-core/blob/master/lib/pageDefaults.js
    static getCanonicalUrl() {
        const canon = $60bf2125eaedf843$export$4dc2b60021baefca.canonical();
        if (canon) return canon;
        const url = window.location.href;
        const i = url.indexOf("#");
        return i === -1 ? url : url.slice(0, i);
    }
    static addActualUrl(obj) {
        if (window.location.href !== $60bf2125eaedf843$export$4dc2b60021baefca.getCanonicalUrl()) {
            // respect cleaned url
            if (obj["url"]) obj["actualUrl"] = obj["url"];
            else obj["actualUrl"] = $60bf2125eaedf843$export$4dc2b60021baefca.maskURL(window.location.href);
        }
    }
    static isObject(o) {
        return o !== null && typeof o === "object" && Array.isArray(o) === false;
    }
    static urlContainsEmail(url) {
        return Boolean($60bf2125eaedf843$var$EMAIL_REGEX.exec(decodeURIComponent(url)));
    }
    // dropping attributes containing email
    static dropEmailQueryParams(obj) {
        const sanitizedObj = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (!$60bf2125eaedf843$export$4dc2b60021baefca.urlContainsEmail(value)) sanitizedObj[key] = value;
        });
        return sanitizedObj;
    }
    // mask search terms
    static maskSearchTerms(obj) {
        const sanitizedObj = {};
        Object.entries(obj).forEach(([key, value])=>{
            if (key === "term" || key === "q") sanitizedObj[key] = "[REDACTED]";
            else sanitizedObj[key] = value;
        });
        return sanitizedObj;
    }
    // dropping email from the url path
    static dropEmailFromPath(path) {
        let newPath = "";
        if ($60bf2125eaedf843$export$4dc2b60021baefca.urlContainsEmail(path)) {
            const pathArray = path.split("/");
            pathArray.forEach(function(value) {
                if (value !== "" && !$60bf2125eaedf843$export$4dc2b60021baefca.urlContainsEmail(value)) newPath = newPath + "/" + value;
            });
        }
        return newPath === "" ? path : newPath;
    }
    // convert query params object to query params string
    static convertQueryObjToString(obj) {
        let queryString = new URLSearchParams(obj).toString();
        if (queryString !== "") queryString = "?" + queryString;
        return queryString;
    }
    static emailAddressIsDetected() {
        return $60bf2125eaedf843$export$4dc2b60021baefca.urlContainsEmail(window.location.href) || $60bf2125eaedf843$export$4dc2b60021baefca.urlContainsEmail(document.referrer);
    }
    static hostnameFromUrl(url) {
        return url.replace(/http(s|):\/\//g, "").split(/(\/|:)/g)[0];
    }
    static addCleanedUrlAndPaths(obj) {
        obj["url"] = window.location.origin + $60bf2125eaedf843$var$PATH_OVERRIDE;
        obj["path"] = $60bf2125eaedf843$var$PATH_OVERRIDE;
        obj["search"] = "";
        return obj;
    }
    static addCleanedReferrer(obj) {
        obj["referrer"] = $60bf2125eaedf843$export$4dc2b60021baefca.urlWithoutPath(document.referrer) + $60bf2125eaedf843$var$PATH_OVERRIDE;
        return obj;
    }
    static urlWithoutPath(url) {
        const fakeTag = document.createElement("a");
        fakeTag.href = url;
        return fakeTag.protocol + "//" + fakeTag.host;
    }
    /**
   * Urls containing email address in url path or query params are dropped and
   * search term query params are masked.
   * Search terms (and all UGC) should no longer be tracked.
   */ static maskURL(input) {
        if (input === "" || input === undefined) return input;
        const url = new URL(input);
        let obj = (0, (/*@__PURE__*/$parcel$interopDefault($f2bbcecd7d3447b1$exports))).parse(url.search);
        obj = $60bf2125eaedf843$export$4dc2b60021baefca.dropEmailQueryParams(obj);
        if (url.pathname.includes("/search")) obj = $60bf2125eaedf843$export$4dc2b60021baefca.maskSearchTerms(obj);
        return url.origin + $60bf2125eaedf843$export$4dc2b60021baefca.dropEmailFromPath(url.pathname) + $60bf2125eaedf843$export$4dc2b60021baefca.convertQueryObjToString(obj);
    }
}


/**
 * See:
 *  - http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/24891600#24891600
 * for more context around the issue of psuedo-randomness used by browsers and the solution used below.
 *
 * and:
 *  - http://web.archive.org/web/20120503063359/http://baagoe.com/en/RandomMusings/javascript/
 * for info regarding the Alea code used below.
 */ const $7a78c48397fc3338$var$trueRandom = function() {
    function Mash() {
        let n = 0xefc8249d;
        const mash = function(data) {
            for(let i = 0; i < data.length; i++){
                n += data.charCodeAt(i);
                let h = 0.02519603282416938 * n;
                n = h >>> 0;
                h -= n;
                h *= n;
                n = h >>> 0;
                h -= n;
                n += h * 0x100000000; // 2^32
            }
            return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
        };
        return mash;
    }
    function Alea() {
        return function(args) {
            // Johannes BaagÃ¸e <baagoe@baagoe.com>, 2010
            let s0 = 0;
            let s1 = 0;
            let s2 = 0;
            let c = 1;
            if (args.length == 0) args = [
                +new Date()
            ];
            const mash = Mash();
            s0 = mash(" ");
            s1 = mash(" ");
            s2 = mash(" ");
            for (const item of args){
                s0 -= mash(item);
                if (s0 < 0) s0 += 1;
                s1 -= mash(item);
                if (s1 < 0) s1 += 1;
                s2 -= mash(item);
                if (s2 < 0) s2 += 1;
            }
            const random = function() {
                const t = 2091639 * s0 + c * 2.3283064365386963e-10; // 2^-32
                s0 = s1;
                s1 = s2;
                return s2 = t - (c = t | 0);
            };
            random.uint32 = function() {
                return random() * 0x100000000; // 2^32
            };
            random.fract53 = function() {
                return random() + (random() * 0x200000 | 0) * 1.1102230246251565e-16; // 2^-53
            };
            random.version = "Alea 0.9";
            random.args = args;
            return random;
        }(Array.prototype.slice.call(arguments));
    }
    return Alea();
}();
const $7a78c48397fc3338$export$dba5740cd1e5d9ea = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        const r = $7a78c48397fc3338$var$trueRandom() * 16 | 0, v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};


class $6a2182f9463e3314$export$f6d5d4774149a3bf {
    static guid() {
        try {
            return (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)();
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error getting uuidV4");
            return (0, $7a78c48397fc3338$export$dba5740cd1e5d9ea)();
        }
    }
    static guidNoDashes() {
        return (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)().replace(/-/g, "");
    }
    /**
   * Convert a GUID deterministically based on the passed in number
   * @param guid - guid to convert
   * @param number - a number to modify the guid by
   * @returns the modified guid or the original in case of failure
   */ static addNumberToGUID(guid, number) {
        // take the last 4 digits and convert to a hex string representation
        let hex = guid.slice(-4);
        let value = parseInt(hex, 16);
        if (isNaN(value)) return guid;
        const valLength = value.toString(16).length;
        value += number;
        // clamp to 2 bytes
        if (value > 65535) value -= 65536;
        else if (value < 0) value += 65536;
        // convert back to hex and make sure its as long as many digits as the initial value
        // This is needed for subtraction
        hex = value.toString(16);
        if (hex.length < valLength) hex = ("00000" + hex).slice(-valLength);
        // replace the last 4 digits of the guid with the last 4 digits of the converted value
        return guid.slice(0, guid.length - hex.length) + hex;
    }
    // guidHashCode takes in a String and returns a Number
    // e.g. "51c96b99-f1b0-4727-9802-a40c096929ae" => 411024693
    static guidHashCode(guid) {
        let hash = 0;
        for(let i = 0; i < guid.length; i++){
            hash += Math.pow(guid.charCodeAt(i) * 31, guid.length - i);
            hash = hash & hash; // Convert to 32bit integer
        }
        return Math.abs(hash);
    }
}



const $add74f19dfb8bf8a$export$69c4df819eb57a1b = "atlCohort";
const $add74f19dfb8bf8a$export$d2bea30496ddbdeb = "2";
const $add74f19dfb8bf8a$export$d28e176424fc1872 = [
    "index",
    "bucketedAtUTC",
    "version",
    "bucketId"
];
const $add74f19dfb8bf8a$var$cohortBuckets = {
    bucketAll: {
        bucketId: 0
    }
};
class $add74f19dfb8bf8a$export$b76685d1b5a37732 {
    /*
   Hypothetical way to add other buckets (adding their name to the types above):
       if (isMobileDevice()) {
          cohortBuckets.bucket_mobile = {
              bucketId: 1
          };
      }
       if (isEnglishSpeaking()) {
          cohortBuckets.bucket_english = {};
      }
       function isMobileDevice() {
          // some logic here...
          return true;
      }
  
      function isEnglishSpeaking() {
          // some logic here...
          return false;
      }
  */ /**
   * Tries to read the ATL_COHORT cookie and return it
   * @function readAtlCohort
   * @return {object | null} the cohort object or null
   */ static readAtlCohort() {
        const atlCohortCookie = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($add74f19dfb8bf8a$export$69c4df819eb57a1b);
        try {
            const decodedCookie = atlCohortCookie ? decodeURIComponent(atlCohortCookie) : null;
            const atlCohort = decodedCookie ? JSON.parse(decodedCookie) : null;
            if (!(0, $60bf2125eaedf843$export$4dc2b60021baefca).isObject(atlCohort)) return null;
            if (atlCohortCookie && atlCohortCookie !== decodedCookie) $add74f19dfb8bf8a$export$b76685d1b5a37732.writeAtlCohort(atlCohort);
            return atlCohort;
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error reading ALT_COHORT Cookie");
            return null;
        }
    }
    /**
   * Writes the stringified `atlCohort` object to the `ATL_COHORT` cookie
   * @function writeAtlCohort
   * @ignore
   * @param {object} atlCohort the cohort object
   */ static writeAtlCohort(atlCohort) {
        if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).isObject(atlCohort)) (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookie($add74f19dfb8bf8a$export$69c4df819eb57a1b, JSON.stringify(atlCohort), 3650, true);
    }
    /**
   * Checks to see if a bucket is in the `atlCohort` object and returns `true` if it does and `false` if it does not
   * @function bucketExists
   * @ignore
   * @param  {BucketName} key a bucket key
   * @param  {Partial<AtlCohort>} atlCohort the cohort object
   * @return {boolean} whether or not a bucket is in the cohort object
   */ static bucketExists(key, atlCohort) {
        if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).isObject(atlCohort)) {
            const bucket = atlCohort[key];
            if (bucket && (0, $60bf2125eaedf843$export$4dc2b60021baefca).isObject(bucket)) return $add74f19dfb8bf8a$export$d28e176424fc1872.every((bucketAttribute)=>typeof bucket[bucketAttribute] !== "undefined");
        }
        return false;
    }
    /**
   * Takes a `bucketKey` and returns and object with `index` and `bucketedAtUTC` properties and optional attribute properties
   * @function createBucket
   * @ignore
   * @param  {string} bucketKey
   * @param  {string} [anonymousIdOverride] optional pre-read anonymousId (e.g. from SSR request cookies),
   *                  used to avoid falling back to Math.random() when document.cookie is unavailable
   * @return {object} a bucket object
   */ static createBucket(bucketKey, anonymousIdOverride) {
        const bucketAttributes = $add74f19dfb8bf8a$var$cohortBuckets[bucketKey];
        const anonymousId = anonymousIdOverride ?? (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("ajs_anonymous_id");
        const strippedAnonymousId = decodeURIComponent(anonymousId || "").replace(/"/g, "");
        const bucket = {
            bucketedAtUTC: new Date().toISOString(),
            version: $add74f19dfb8bf8a$export$d2bea30496ddbdeb,
            index: strippedAnonymousId ? (0, $6a2182f9463e3314$export$f6d5d4774149a3bf).guidHashCode((0, $6a2182f9463e3314$export$f6d5d4774149a3bf).addNumberToGUID(strippedAnonymousId, bucketAttributes.bucketId)) % 100 : Math.ceil(Math.random() * 100),
            bucketId: bucketAttributes.bucketId
        };
        return bucket;
    }
    /**
   * Reads `ATL_COHORT` cookie and if there are any missing buckets, it adds them and writes them to the cookie. Returns the `atlCohort` object
   * @function readWriteAtlCohort
   * @param {boolean} writeOverride when present, trigger a cohort rewrite
   * @return {object | null} the cohort object or null
   */ static readWriteAtlCohort(writeOverride) {
        // if overriding the cohort, do not read the existing cohort; set to empty to force a write
        const atlCohort = writeOverride ? {} : $add74f19dfb8bf8a$export$b76685d1b5a37732.readAtlCohort() || {};
        const missingBuckets = Object.keys($add74f19dfb8bf8a$var$cohortBuckets).filter((bucket)=>!$add74f19dfb8bf8a$export$b76685d1b5a37732.bucketExists(bucket, atlCohort));
        if (missingBuckets.length) {
            missingBuckets.forEach((missingBucket)=>atlCohort[missingBucket] = $add74f19dfb8bf8a$export$b76685d1b5a37732.createBucket(missingBucket));
            $add74f19dfb8bf8a$export$b76685d1b5a37732.writeAtlCohort(atlCohort);
        }
        return atlCohort;
    }
}



var $iSvIT = parcelRequire("iSvIT");
var $7f3bb8df8d1300c9$exports = {};
"use strict";
Object.defineProperty($7f3bb8df8d1300c9$exports, "__esModule", {
    value: true
});
function $7f3bb8df8d1300c9$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $iSvIT = parcelRequire("iSvIT");
var $7f3bb8df8d1300c9$var$React__default = $7f3bb8df8d1300c9$var$_interopDefault($iSvIT);

var $dmWkz = parcelRequire("dmWkz");
var $7f3bb8df8d1300c9$var$ClientUAInstance = new $dmWkz();
var $7f3bb8df8d1300c9$var$browser = $7f3bb8df8d1300c9$var$ClientUAInstance.getBrowser();
var $7f3bb8df8d1300c9$var$cpu = $7f3bb8df8d1300c9$var$ClientUAInstance.getCPU();
var $7f3bb8df8d1300c9$var$device = $7f3bb8df8d1300c9$var$ClientUAInstance.getDevice();
var $7f3bb8df8d1300c9$var$engine = $7f3bb8df8d1300c9$var$ClientUAInstance.getEngine();
var $7f3bb8df8d1300c9$var$os = $7f3bb8df8d1300c9$var$ClientUAInstance.getOS();
var $7f3bb8df8d1300c9$var$ua = $7f3bb8df8d1300c9$var$ClientUAInstance.getUA();
var $7f3bb8df8d1300c9$var$setUa = function setUa(userAgentString) {
    return $7f3bb8df8d1300c9$var$ClientUAInstance.setUA(userAgentString);
};
var $7f3bb8df8d1300c9$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $dmWkz(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $7f3bb8df8d1300c9$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $7f3bb8df8d1300c9$var$ClientUAInstance,
    browser: $7f3bb8df8d1300c9$var$browser,
    cpu: $7f3bb8df8d1300c9$var$cpu,
    device: $7f3bb8df8d1300c9$var$device,
    engine: $7f3bb8df8d1300c9$var$engine,
    os: $7f3bb8df8d1300c9$var$os,
    ua: $7f3bb8df8d1300c9$var$ua,
    setUa: $7f3bb8df8d1300c9$var$setUa,
    parseUserAgent: $7f3bb8df8d1300c9$var$parseUserAgent
});
function $7f3bb8df8d1300c9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7f3bb8df8d1300c9$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7f3bb8df8d1300c9$var$ownKeys(Object(source), true).forEach(function(key) {
            $7f3bb8df8d1300c9$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7f3bb8df8d1300c9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7f3bb8df8d1300c9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $7f3bb8df8d1300c9$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $7f3bb8df8d1300c9$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7f3bb8df8d1300c9$var$_typeof(obj);
}
function $7f3bb8df8d1300c9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7f3bb8df8d1300c9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7f3bb8df8d1300c9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7f3bb8df8d1300c9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7f3bb8df8d1300c9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7f3bb8df8d1300c9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7f3bb8df8d1300c9$var$_extends() {
    $7f3bb8df8d1300c9$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f3bb8df8d1300c9$var$_extends.apply(this, arguments);
}
function $7f3bb8df8d1300c9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7f3bb8df8d1300c9$var$_setPrototypeOf(subClass, superClass);
}
function $7f3bb8df8d1300c9$var$_getPrototypeOf(o) {
    $7f3bb8df8d1300c9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7f3bb8df8d1300c9$var$_getPrototypeOf(o);
}
function $7f3bb8df8d1300c9$var$_setPrototypeOf(o, p) {
    $7f3bb8df8d1300c9$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7f3bb8df8d1300c9$var$_setPrototypeOf(o, p);
}
function $7f3bb8df8d1300c9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7f3bb8df8d1300c9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f3bb8df8d1300c9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f3bb8df8d1300c9$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7f3bb8df8d1300c9$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $7f3bb8df8d1300c9$var$_assertThisInitialized(self);
}
function $7f3bb8df8d1300c9$var$_slicedToArray(arr, i) {
    return $7f3bb8df8d1300c9$var$_arrayWithHoles(arr) || $7f3bb8df8d1300c9$var$_iterableToArrayLimit(arr, i) || $7f3bb8df8d1300c9$var$_unsupportedIterableToArray(arr, i) || $7f3bb8df8d1300c9$var$_nonIterableRest();
}
function $7f3bb8df8d1300c9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $7f3bb8df8d1300c9$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7f3bb8df8d1300c9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7f3bb8df8d1300c9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7f3bb8df8d1300c9$var$_arrayLikeToArray(o, minLen);
}
function $7f3bb8df8d1300c9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7f3bb8df8d1300c9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $7f3bb8df8d1300c9$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $7f3bb8df8d1300c9$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $7f3bb8df8d1300c9$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $7f3bb8df8d1300c9$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $7f3bb8df8d1300c9$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $7f3bb8df8d1300c9$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $7f3bb8df8d1300c9$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $7f3bb8df8d1300c9$var$InitialDeviceTypes;
    }
};
var $7f3bb8df8d1300c9$var$setUserAgent = function setUserAgent(userAgent) {
    return $7f3bb8df8d1300c9$var$setUa(userAgent);
};
var $7f3bb8df8d1300c9$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $7f3bb8df8d1300c9$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $7f3bb8df8d1300c9$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $7f3bb8df8d1300c9$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $7f3bb8df8d1300c9$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $7f3bb8df8d1300c9$var$setDefaults(browser.major),
        browserFullVersion: $7f3bb8df8d1300c9$var$setDefaults(browser.version),
        browserName: $7f3bb8df8d1300c9$var$setDefaults(browser.name),
        engineName: $7f3bb8df8d1300c9$var$setDefaults(engine.name),
        engineVersion: $7f3bb8df8d1300c9$var$setDefaults(engine.version),
        osName: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        userAgent: $7f3bb8df8d1300c9$var$setDefaults(ua)
    };
};
var $7f3bb8df8d1300c9$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $7f3bb8df8d1300c9$var$_objectSpread2({}, type, {
        vendor: $7f3bb8df8d1300c9$var$setDefaults(device.vendor),
        model: $7f3bb8df8d1300c9$var$setDefaults(device.model),
        os: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        ua: $7f3bb8df8d1300c9$var$setDefaults(ua)
    });
};
var $7f3bb8df8d1300c9$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $7f3bb8df8d1300c9$var$setDefaults(engine.name),
        engineVersion: $7f3bb8df8d1300c9$var$setDefaults(engine.version),
        osName: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        userAgent: $7f3bb8df8d1300c9$var$setDefaults(ua)
    };
};
var $7f3bb8df8d1300c9$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $7f3bb8df8d1300c9$var$setDefaults(engine.name),
        engineVersion: $7f3bb8df8d1300c9$var$setDefaults(engine.version),
        osName: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        userAgent: $7f3bb8df8d1300c9$var$setDefaults(ua)
    };
};
var $7f3bb8df8d1300c9$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $7f3bb8df8d1300c9$var$setDefaults(engine.name),
        engineVersion: $7f3bb8df8d1300c9$var$setDefaults(engine.version),
        osName: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        userAgent: $7f3bb8df8d1300c9$var$setDefaults(ua)
    };
};
var $7f3bb8df8d1300c9$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $7f3bb8df8d1300c9$var$setDefaults(device.vendor),
        model: $7f3bb8df8d1300c9$var$setDefaults(device.model),
        engineName: $7f3bb8df8d1300c9$var$setDefaults(engine.name),
        engineVersion: $7f3bb8df8d1300c9$var$setDefaults(engine.version),
        osName: $7f3bb8df8d1300c9$var$setDefaults(os.name),
        osVersion: $7f3bb8df8d1300c9$var$setDefaults(os.version),
        userAgent: $7f3bb8df8d1300c9$var$setDefaults(ua)
    };
};
function $7f3bb8df8d1300c9$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $7f3bb8df8d1300c9$var$parseUserAgent(userAgent) : $7f3bb8df8d1300c9$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $7f3bb8df8d1300c9$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $7f3bb8df8d1300c9$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $7f3bb8df8d1300c9$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $7f3bb8df8d1300c9$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $7f3bb8df8d1300c9$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $7f3bb8df8d1300c9$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $7f3bb8df8d1300c9$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $7f3bb8df8d1300c9$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $7f3bb8df8d1300c9$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Mobile;
};
var $7f3bb8df8d1300c9$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Tablet;
};
var $7f3bb8df8d1300c9$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Mobile || type === $7f3bb8df8d1300c9$var$DeviceTypes.Tablet;
};
var $7f3bb8df8d1300c9$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.SmartTv;
};
var $7f3bb8df8d1300c9$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Browser;
};
var $7f3bb8df8d1300c9$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Wearable;
};
var $7f3bb8df8d1300c9$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Console;
};
var $7f3bb8df8d1300c9$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $7f3bb8df8d1300c9$var$DeviceTypes.Embedded;
};
var $7f3bb8df8d1300c9$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $7f3bb8df8d1300c9$var$setDefaults(vendor);
};
var $7f3bb8df8d1300c9$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $7f3bb8df8d1300c9$var$setDefaults(model);
};
var $7f3bb8df8d1300c9$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $7f3bb8df8d1300c9$var$setDefaults(type, "browser");
}; // os types
var $7f3bb8df8d1300c9$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $7f3bb8df8d1300c9$var$OsTypes.Android;
};
var $7f3bb8df8d1300c9$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $7f3bb8df8d1300c9$var$OsTypes.Windows;
};
var $7f3bb8df8d1300c9$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $7f3bb8df8d1300c9$var$OsTypes.MAC_OS;
};
var $7f3bb8df8d1300c9$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $7f3bb8df8d1300c9$var$OsTypes.WindowsPhone;
};
var $7f3bb8df8d1300c9$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $7f3bb8df8d1300c9$var$OsTypes.IOS;
};
var $7f3bb8df8d1300c9$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $7f3bb8df8d1300c9$var$setDefaults(version);
};
var $7f3bb8df8d1300c9$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $7f3bb8df8d1300c9$var$setDefaults(name);
}; // browser types
var $7f3bb8df8d1300c9$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Chrome;
};
var $7f3bb8df8d1300c9$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Firefox;
};
var $7f3bb8df8d1300c9$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Chromium;
};
var $7f3bb8df8d1300c9$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Edge;
};
var $7f3bb8df8d1300c9$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Yandex;
};
var $7f3bb8df8d1300c9$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Safari || name === $7f3bb8df8d1300c9$var$BrowserTypes.MobileSafari;
};
var $7f3bb8df8d1300c9$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.MobileSafari;
};
var $7f3bb8df8d1300c9$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.Opera;
};
var $7f3bb8df8d1300c9$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.InternetExplorer || name === $7f3bb8df8d1300c9$var$BrowserTypes.Ie;
};
var $7f3bb8df8d1300c9$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.MIUI;
};
var $7f3bb8df8d1300c9$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $7f3bb8df8d1300c9$var$BrowserTypes.SamsungBrowser;
};
var $7f3bb8df8d1300c9$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $7f3bb8df8d1300c9$var$setDefaults(version);
};
var $7f3bb8df8d1300c9$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $7f3bb8df8d1300c9$var$setDefaults(major);
};
var $7f3bb8df8d1300c9$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $7f3bb8df8d1300c9$var$setDefaults(name);
}; // engine types
var $7f3bb8df8d1300c9$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $7f3bb8df8d1300c9$var$setDefaults(name);
};
var $7f3bb8df8d1300c9$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $7f3bb8df8d1300c9$var$setDefaults(version);
};
var $7f3bb8df8d1300c9$var$isElectronType = function isElectronType() {
    var nav = $7f3bb8df8d1300c9$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $7f3bb8df8d1300c9$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $7f3bb8df8d1300c9$var$getIOS13 = function getIOS13() {
    var nav = $7f3bb8df8d1300c9$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $7f3bb8df8d1300c9$var$getIPad13 = function getIPad13() {
    return $7f3bb8df8d1300c9$var$isIOS13Check("iPad");
};
var $7f3bb8df8d1300c9$var$getIphone13 = function getIphone13() {
    return $7f3bb8df8d1300c9$var$isIOS13Check("iPhone");
};
var $7f3bb8df8d1300c9$var$getIPod13 = function getIPod13() {
    return $7f3bb8df8d1300c9$var$isIOS13Check("iPod");
};
var $7f3bb8df8d1300c9$var$getUseragent = function getUseragent(userAg) {
    return $7f3bb8df8d1300c9$var$setDefaults(userAg);
};
function $7f3bb8df8d1300c9$var$buildSelectorsObject(options) {
    var _ref = options ? options : $7f3bb8df8d1300c9$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $7f3bb8df8d1300c9$var$isSmartTVType(device),
        isConsole: $7f3bb8df8d1300c9$var$isConsoleType(device),
        isWearable: $7f3bb8df8d1300c9$var$isWearableType(device),
        isEmbedded: $7f3bb8df8d1300c9$var$isEmbeddedType(device),
        isMobileSafari: $7f3bb8df8d1300c9$var$isMobileSafariType(browser) || $7f3bb8df8d1300c9$var$getIPad13(),
        isChromium: $7f3bb8df8d1300c9$var$isChromiumType(browser),
        isMobile: $7f3bb8df8d1300c9$var$isMobileAndTabletType(device) || $7f3bb8df8d1300c9$var$getIPad13(),
        isMobileOnly: $7f3bb8df8d1300c9$var$isMobileType(device),
        isTablet: $7f3bb8df8d1300c9$var$isTabletType(device) || $7f3bb8df8d1300c9$var$getIPad13(),
        isBrowser: $7f3bb8df8d1300c9$var$isBrowserType(device),
        isDesktop: $7f3bb8df8d1300c9$var$isBrowserType(device),
        isAndroid: $7f3bb8df8d1300c9$var$isAndroidType(os),
        isWinPhone: $7f3bb8df8d1300c9$var$isWinPhoneType(os),
        isIOS: $7f3bb8df8d1300c9$var$isIOSType(os) || $7f3bb8df8d1300c9$var$getIPad13(),
        isChrome: $7f3bb8df8d1300c9$var$isChromeType(browser),
        isFirefox: $7f3bb8df8d1300c9$var$isFirefoxType(browser),
        isSafari: $7f3bb8df8d1300c9$var$isSafariType(browser),
        isOpera: $7f3bb8df8d1300c9$var$isOperaType(browser),
        isIE: $7f3bb8df8d1300c9$var$isIEType(browser),
        osVersion: $7f3bb8df8d1300c9$var$getOsVersion(os),
        osName: $7f3bb8df8d1300c9$var$getOsName(os),
        fullBrowserVersion: $7f3bb8df8d1300c9$var$getBrowserFullVersion(browser),
        browserVersion: $7f3bb8df8d1300c9$var$getBrowserVersion(browser),
        browserName: $7f3bb8df8d1300c9$var$getBrowserName(browser),
        mobileVendor: $7f3bb8df8d1300c9$var$getMobileVendor(device),
        mobileModel: $7f3bb8df8d1300c9$var$getMobileModel(device),
        engineName: $7f3bb8df8d1300c9$var$getEngineName(engine),
        engineVersion: $7f3bb8df8d1300c9$var$getEngineVersion(engine),
        getUA: $7f3bb8df8d1300c9$var$getUseragent(ua),
        isEdge: $7f3bb8df8d1300c9$var$isEdgeType(browser) || $7f3bb8df8d1300c9$var$isEdgeChromiumType(ua),
        isYandex: $7f3bb8df8d1300c9$var$isYandexType(browser),
        deviceType: $7f3bb8df8d1300c9$var$getDeviceType(device),
        isIOS13: $7f3bb8df8d1300c9$var$getIOS13(),
        isIPad13: $7f3bb8df8d1300c9$var$getIPad13(),
        isIPhone13: $7f3bb8df8d1300c9$var$getIphone13(),
        isIPod13: $7f3bb8df8d1300c9$var$getIPod13(),
        isElectron: $7f3bb8df8d1300c9$var$isElectronType(),
        isEdgeChromium: $7f3bb8df8d1300c9$var$isEdgeChromiumType(ua),
        isLegacyEdge: $7f3bb8df8d1300c9$var$isEdgeType(browser) && !$7f3bb8df8d1300c9$var$isEdgeChromiumType(ua),
        isWindows: $7f3bb8df8d1300c9$var$isWindowsType(os),
        isMacOs: $7f3bb8df8d1300c9$var$isMacOsType(os),
        isMIUI: $7f3bb8df8d1300c9$var$isMIUIType(browser),
        isSamsungBrowser: $7f3bb8df8d1300c9$var$isSamsungBrowserType(browser)
    };
}
var $7f3bb8df8d1300c9$var$isSmartTV = $7f3bb8df8d1300c9$var$isSmartTVType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isConsole = $7f3bb8df8d1300c9$var$isConsoleType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isWearable = $7f3bb8df8d1300c9$var$isWearableType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isEmbedded = $7f3bb8df8d1300c9$var$isEmbeddedType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isMobileSafari = $7f3bb8df8d1300c9$var$isMobileSafariType($7f3bb8df8d1300c9$var$browser) || $7f3bb8df8d1300c9$var$getIPad13();
var $7f3bb8df8d1300c9$var$isChromium = $7f3bb8df8d1300c9$var$isChromiumType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isMobile = $7f3bb8df8d1300c9$var$isMobileAndTabletType($7f3bb8df8d1300c9$var$device) || $7f3bb8df8d1300c9$var$getIPad13();
var $7f3bb8df8d1300c9$var$isMobileOnly = $7f3bb8df8d1300c9$var$isMobileType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isTablet = $7f3bb8df8d1300c9$var$isTabletType($7f3bb8df8d1300c9$var$device) || $7f3bb8df8d1300c9$var$getIPad13();
var $7f3bb8df8d1300c9$var$isBrowser = $7f3bb8df8d1300c9$var$isBrowserType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isDesktop = $7f3bb8df8d1300c9$var$isBrowserType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isAndroid = $7f3bb8df8d1300c9$var$isAndroidType($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$isWinPhone = $7f3bb8df8d1300c9$var$isWinPhoneType($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$isIOS = $7f3bb8df8d1300c9$var$isIOSType($7f3bb8df8d1300c9$var$os) || $7f3bb8df8d1300c9$var$getIPad13();
var $7f3bb8df8d1300c9$var$isChrome = $7f3bb8df8d1300c9$var$isChromeType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isFirefox = $7f3bb8df8d1300c9$var$isFirefoxType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isSafari = $7f3bb8df8d1300c9$var$isSafariType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isOpera = $7f3bb8df8d1300c9$var$isOperaType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isIE = $7f3bb8df8d1300c9$var$isIEType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$osVersion = $7f3bb8df8d1300c9$var$getOsVersion($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$osName = $7f3bb8df8d1300c9$var$getOsName($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$fullBrowserVersion = $7f3bb8df8d1300c9$var$getBrowserFullVersion($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$browserVersion = $7f3bb8df8d1300c9$var$getBrowserVersion($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$browserName = $7f3bb8df8d1300c9$var$getBrowserName($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$mobileVendor = $7f3bb8df8d1300c9$var$getMobileVendor($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$mobileModel = $7f3bb8df8d1300c9$var$getMobileModel($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$engineName = $7f3bb8df8d1300c9$var$getEngineName($7f3bb8df8d1300c9$var$engine);
var $7f3bb8df8d1300c9$var$engineVersion = $7f3bb8df8d1300c9$var$getEngineVersion($7f3bb8df8d1300c9$var$engine);
var $7f3bb8df8d1300c9$var$getUA = $7f3bb8df8d1300c9$var$getUseragent($7f3bb8df8d1300c9$var$ua);
var $7f3bb8df8d1300c9$var$isEdge = $7f3bb8df8d1300c9$var$isEdgeType($7f3bb8df8d1300c9$var$browser) || $7f3bb8df8d1300c9$var$isEdgeChromiumType($7f3bb8df8d1300c9$var$ua);
var $7f3bb8df8d1300c9$var$isYandex = $7f3bb8df8d1300c9$var$isYandexType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$deviceType = $7f3bb8df8d1300c9$var$getDeviceType($7f3bb8df8d1300c9$var$device);
var $7f3bb8df8d1300c9$var$isIOS13 = $7f3bb8df8d1300c9$var$getIOS13();
var $7f3bb8df8d1300c9$var$isIPad13 = $7f3bb8df8d1300c9$var$getIPad13();
var $7f3bb8df8d1300c9$var$isIPhone13 = $7f3bb8df8d1300c9$var$getIphone13();
var $7f3bb8df8d1300c9$var$isIPod13 = $7f3bb8df8d1300c9$var$getIPod13();
var $7f3bb8df8d1300c9$var$isElectron = $7f3bb8df8d1300c9$var$isElectronType();
var $7f3bb8df8d1300c9$var$isEdgeChromium = $7f3bb8df8d1300c9$var$isEdgeChromiumType($7f3bb8df8d1300c9$var$ua);
var $7f3bb8df8d1300c9$var$isLegacyEdge = $7f3bb8df8d1300c9$var$isEdgeType($7f3bb8df8d1300c9$var$browser) && !$7f3bb8df8d1300c9$var$isEdgeChromiumType($7f3bb8df8d1300c9$var$ua);
var $7f3bb8df8d1300c9$var$isWindows = $7f3bb8df8d1300c9$var$isWindowsType($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$isMacOs = $7f3bb8df8d1300c9$var$isMacOsType($7f3bb8df8d1300c9$var$os);
var $7f3bb8df8d1300c9$var$isMIUI = $7f3bb8df8d1300c9$var$isMIUIType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$isSamsungBrowser = $7f3bb8df8d1300c9$var$isSamsungBrowserType($7f3bb8df8d1300c9$var$browser);
var $7f3bb8df8d1300c9$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $7f3bb8df8d1300c9$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $7f3bb8df8d1300c9$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $7f3bb8df8d1300c9$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isAndroid ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isBrowser ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isIE ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isIOS ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isMobile ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isTablet ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isWinPhone ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $7f3bb8df8d1300c9$var$isMobileOnly ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isSmartTV ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isConsole ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $7f3bb8df8d1300c9$var$isWearable ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
var $7f3bb8df8d1300c9$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $7f3bb8df8d1300c9$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $7f3bb8df8d1300c9$var$React__default.createElement($iSvIT.Fragment, null, children) : $7f3bb8df8d1300c9$var$React__default.createElement("div", props, children) : null;
};
function $7f3bb8df8d1300c9$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $7f3bb8df8d1300c9$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $7f3bb8df8d1300c9$var$_classCallCheck(this, _class);
            _this = $7f3bb8df8d1300c9$var$_possibleConstructorReturn(this, $7f3bb8df8d1300c9$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($7f3bb8df8d1300c9$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($7f3bb8df8d1300c9$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($7f3bb8df8d1300c9$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $7f3bb8df8d1300c9$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $7f3bb8df8d1300c9$var$_typeof(window)) !== undefined && $7f3bb8df8d1300c9$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $7f3bb8df8d1300c9$var$React__default.createElement(WrappedComponent, $7f3bb8df8d1300c9$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($7f3bb8df8d1300c9$var$React__default.Component);
}
function $7f3bb8df8d1300c9$var$useMobileOrientation() {
    var _useState = $iSvIT.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $7f3bb8df8d1300c9$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $iSvIT.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $iSvIT.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $7f3bb8df8d1300c9$var$_typeof(window)) !== undefined && $7f3bb8df8d1300c9$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $7f3bb8df8d1300c9$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $7f3bb8df8d1300c9$var$parseUserAgent(hookUserAgent);
}
function $7f3bb8df8d1300c9$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $7f3bb8df8d1300c9$var$useDeviceData(hookUserAgent);
    var selectors = $7f3bb8df8d1300c9$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$7f3bb8df8d1300c9$exports.AndroidView = $7f3bb8df8d1300c9$var$AndroidView;
$7f3bb8df8d1300c9$exports.BrowserTypes = $7f3bb8df8d1300c9$var$BrowserTypes;
$7f3bb8df8d1300c9$exports.BrowserView = $7f3bb8df8d1300c9$var$BrowserView;
$7f3bb8df8d1300c9$exports.ConsoleView = $7f3bb8df8d1300c9$var$ConsoleView;
$7f3bb8df8d1300c9$exports.CustomView = $7f3bb8df8d1300c9$var$CustomView;
$7f3bb8df8d1300c9$exports.IEView = $7f3bb8df8d1300c9$var$IEView;
$7f3bb8df8d1300c9$exports.IOSView = $7f3bb8df8d1300c9$var$IOSView;
$7f3bb8df8d1300c9$exports.MobileOnlyView = $7f3bb8df8d1300c9$var$MobileOnlyView;
$7f3bb8df8d1300c9$exports.MobileView = $7f3bb8df8d1300c9$var$MobileView;
$7f3bb8df8d1300c9$exports.OsTypes = $7f3bb8df8d1300c9$var$OsTypes;
$7f3bb8df8d1300c9$exports.SmartTVView = $7f3bb8df8d1300c9$var$SmartTVView;
$7f3bb8df8d1300c9$exports.TabletView = $7f3bb8df8d1300c9$var$TabletView;
$7f3bb8df8d1300c9$exports.WearableView = $7f3bb8df8d1300c9$var$WearableView;
$7f3bb8df8d1300c9$exports.WinPhoneView = $7f3bb8df8d1300c9$var$WinPhoneView;
$7f3bb8df8d1300c9$exports.browserName = $7f3bb8df8d1300c9$var$browserName;
$7f3bb8df8d1300c9$exports.browserVersion = $7f3bb8df8d1300c9$var$browserVersion;
$7f3bb8df8d1300c9$exports.deviceDetect = $7f3bb8df8d1300c9$var$deviceDetect;
$7f3bb8df8d1300c9$exports.deviceType = $7f3bb8df8d1300c9$var$deviceType;
$7f3bb8df8d1300c9$exports.engineName = $7f3bb8df8d1300c9$var$engineName;
$7f3bb8df8d1300c9$exports.engineVersion = $7f3bb8df8d1300c9$var$engineVersion;
$7f3bb8df8d1300c9$exports.fullBrowserVersion = $7f3bb8df8d1300c9$var$fullBrowserVersion;
$7f3bb8df8d1300c9$exports.getSelectorsByUserAgent = $7f3bb8df8d1300c9$var$getSelectorsByUserAgent;
$7f3bb8df8d1300c9$exports.getUA = $7f3bb8df8d1300c9$var$getUA;
$7f3bb8df8d1300c9$exports.isAndroid = $7f3bb8df8d1300c9$var$isAndroid;
$7f3bb8df8d1300c9$exports.isBrowser = $7f3bb8df8d1300c9$var$isBrowser;
$7f3bb8df8d1300c9$exports.isChrome = $7f3bb8df8d1300c9$var$isChrome;
$7f3bb8df8d1300c9$exports.isChromium = $7f3bb8df8d1300c9$var$isChromium;
$7f3bb8df8d1300c9$exports.isConsole = $7f3bb8df8d1300c9$var$isConsole;
$7f3bb8df8d1300c9$exports.isDesktop = $7f3bb8df8d1300c9$var$isDesktop;
$7f3bb8df8d1300c9$exports.isEdge = $7f3bb8df8d1300c9$var$isEdge;
$7f3bb8df8d1300c9$exports.isEdgeChromium = $7f3bb8df8d1300c9$var$isEdgeChromium;
$7f3bb8df8d1300c9$exports.isElectron = $7f3bb8df8d1300c9$var$isElectron;
$7f3bb8df8d1300c9$exports.isEmbedded = $7f3bb8df8d1300c9$var$isEmbedded;
$7f3bb8df8d1300c9$exports.isFirefox = $7f3bb8df8d1300c9$var$isFirefox;
$7f3bb8df8d1300c9$exports.isIE = $7f3bb8df8d1300c9$var$isIE;
$7f3bb8df8d1300c9$exports.isIOS = $7f3bb8df8d1300c9$var$isIOS;
$7f3bb8df8d1300c9$exports.isIOS13 = $7f3bb8df8d1300c9$var$isIOS13;
$7f3bb8df8d1300c9$exports.isIPad13 = $7f3bb8df8d1300c9$var$isIPad13;
$7f3bb8df8d1300c9$exports.isIPhone13 = $7f3bb8df8d1300c9$var$isIPhone13;
$7f3bb8df8d1300c9$exports.isIPod13 = $7f3bb8df8d1300c9$var$isIPod13;
$7f3bb8df8d1300c9$exports.isLegacyEdge = $7f3bb8df8d1300c9$var$isLegacyEdge;
$7f3bb8df8d1300c9$exports.isMIUI = $7f3bb8df8d1300c9$var$isMIUI;
$7f3bb8df8d1300c9$exports.isMacOs = $7f3bb8df8d1300c9$var$isMacOs;
$7f3bb8df8d1300c9$exports.isMobile = $7f3bb8df8d1300c9$var$isMobile;
$7f3bb8df8d1300c9$exports.isMobileOnly = $7f3bb8df8d1300c9$var$isMobileOnly;
$7f3bb8df8d1300c9$exports.isMobileSafari = $7f3bb8df8d1300c9$var$isMobileSafari;
$7f3bb8df8d1300c9$exports.isOpera = $7f3bb8df8d1300c9$var$isOpera;
$7f3bb8df8d1300c9$exports.isSafari = $7f3bb8df8d1300c9$var$isSafari;
$7f3bb8df8d1300c9$exports.isSamsungBrowser = $7f3bb8df8d1300c9$var$isSamsungBrowser;
$7f3bb8df8d1300c9$exports.isSmartTV = $7f3bb8df8d1300c9$var$isSmartTV;
$7f3bb8df8d1300c9$exports.isTablet = $7f3bb8df8d1300c9$var$isTablet;
$7f3bb8df8d1300c9$exports.isWearable = $7f3bb8df8d1300c9$var$isWearable;
$7f3bb8df8d1300c9$exports.isWinPhone = $7f3bb8df8d1300c9$var$isWinPhone;
$7f3bb8df8d1300c9$exports.isWindows = $7f3bb8df8d1300c9$var$isWindows;
$7f3bb8df8d1300c9$exports.isYandex = $7f3bb8df8d1300c9$var$isYandex;
$7f3bb8df8d1300c9$exports.mobileModel = $7f3bb8df8d1300c9$var$mobileModel;
$7f3bb8df8d1300c9$exports.mobileVendor = $7f3bb8df8d1300c9$var$mobileVendor;
$7f3bb8df8d1300c9$exports.osName = $7f3bb8df8d1300c9$var$osName;
$7f3bb8df8d1300c9$exports.osVersion = $7f3bb8df8d1300c9$var$osVersion;
$7f3bb8df8d1300c9$exports.parseUserAgent = $7f3bb8df8d1300c9$var$parseUserAgent;
$7f3bb8df8d1300c9$exports.setUserAgent = $7f3bb8df8d1300c9$var$setUserAgent;
$7f3bb8df8d1300c9$exports.useDeviceData = $7f3bb8df8d1300c9$var$useDeviceData;
$7f3bb8df8d1300c9$exports.useDeviceSelectors = $7f3bb8df8d1300c9$var$useDeviceSelectors;
$7f3bb8df8d1300c9$exports.useMobileOrientation = $7f3bb8df8d1300c9$var$useMobileOrientation;
$7f3bb8df8d1300c9$exports.withOrientationChange = $7f3bb8df8d1300c9$var$withOrientationChange;


var $5a5e255be41ec1f1$exports = {};
var $9a82279beb63eb09$exports = {};
"use strict";
var $9a82279beb63eb09$var$__createBinding = $9a82279beb63eb09$exports && $9a82279beb63eb09$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9a82279beb63eb09$var$__setModuleDefault = $9a82279beb63eb09$exports && $9a82279beb63eb09$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9a82279beb63eb09$var$__importStar = $9a82279beb63eb09$exports && $9a82279beb63eb09$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9a82279beb63eb09$var$__createBinding(result, mod, k);
    }
    $9a82279beb63eb09$var$__setModuleDefault(result, mod);
    return result;
};
var $9a82279beb63eb09$var$__importDefault = $9a82279beb63eb09$exports && $9a82279beb63eb09$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($9a82279beb63eb09$exports, "__esModule", {
    value: true
});
$9a82279beb63eb09$exports.DomUtils = $9a82279beb63eb09$exports.parseFeed = $9a82279beb63eb09$exports.getFeed = $9a82279beb63eb09$exports.ElementType = $9a82279beb63eb09$exports.Tokenizer = $9a82279beb63eb09$exports.createDomStream = $9a82279beb63eb09$exports.parseDOM = $9a82279beb63eb09$exports.parseDocument = $9a82279beb63eb09$exports.DefaultHandler = $9a82279beb63eb09$exports.DomHandler = $9a82279beb63eb09$exports.Parser = void 0;
var $6291674aa66edce1$exports = {};
"use strict";
var $6291674aa66edce1$var$__createBinding = $6291674aa66edce1$exports && $6291674aa66edce1$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6291674aa66edce1$var$__setModuleDefault = $6291674aa66edce1$exports && $6291674aa66edce1$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6291674aa66edce1$var$__importStar = $6291674aa66edce1$exports && $6291674aa66edce1$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6291674aa66edce1$var$__createBinding(result, mod, k);
    }
    $6291674aa66edce1$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($6291674aa66edce1$exports, "__esModule", {
    value: true
});
$6291674aa66edce1$exports.Parser = void 0;

var $6291674aa66edce1$var$Tokenizer_js_1 = $6291674aa66edce1$var$__importStar((parcelRequire("egNzs")));

var $Tj5sm = parcelRequire("Tj5sm");
var $6291674aa66edce1$var$formTags = new Set([
    "input",
    "option",
    "optgroup",
    "select",
    "button",
    "datalist",
    "textarea"
]);
var $6291674aa66edce1$var$pTag = new Set([
    "p"
]);
var $6291674aa66edce1$var$tableSectionTags = new Set([
    "thead",
    "tbody"
]);
var $6291674aa66edce1$var$ddtTags = new Set([
    "dd",
    "dt"
]);
var $6291674aa66edce1$var$rtpTags = new Set([
    "rt",
    "rp"
]);
var $6291674aa66edce1$var$openImpliesClose = new Map([
    [
        "tr",
        new Set([
            "tr",
            "th",
            "td"
        ])
    ],
    [
        "th",
        new Set([
            "th"
        ])
    ],
    [
        "td",
        new Set([
            "thead",
            "th",
            "td"
        ])
    ],
    [
        "body",
        new Set([
            "head",
            "link",
            "script"
        ])
    ],
    [
        "li",
        new Set([
            "li"
        ])
    ],
    [
        "p",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h1",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h2",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h3",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h4",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h5",
        $6291674aa66edce1$var$pTag
    ],
    [
        "h6",
        $6291674aa66edce1$var$pTag
    ],
    [
        "select",
        $6291674aa66edce1$var$formTags
    ],
    [
        "input",
        $6291674aa66edce1$var$formTags
    ],
    [
        "output",
        $6291674aa66edce1$var$formTags
    ],
    [
        "button",
        $6291674aa66edce1$var$formTags
    ],
    [
        "datalist",
        $6291674aa66edce1$var$formTags
    ],
    [
        "textarea",
        $6291674aa66edce1$var$formTags
    ],
    [
        "option",
        new Set([
            "option"
        ])
    ],
    [
        "optgroup",
        new Set([
            "optgroup",
            "option"
        ])
    ],
    [
        "dd",
        $6291674aa66edce1$var$ddtTags
    ],
    [
        "dt",
        $6291674aa66edce1$var$ddtTags
    ],
    [
        "address",
        $6291674aa66edce1$var$pTag
    ],
    [
        "article",
        $6291674aa66edce1$var$pTag
    ],
    [
        "aside",
        $6291674aa66edce1$var$pTag
    ],
    [
        "blockquote",
        $6291674aa66edce1$var$pTag
    ],
    [
        "details",
        $6291674aa66edce1$var$pTag
    ],
    [
        "div",
        $6291674aa66edce1$var$pTag
    ],
    [
        "dl",
        $6291674aa66edce1$var$pTag
    ],
    [
        "fieldset",
        $6291674aa66edce1$var$pTag
    ],
    [
        "figcaption",
        $6291674aa66edce1$var$pTag
    ],
    [
        "figure",
        $6291674aa66edce1$var$pTag
    ],
    [
        "footer",
        $6291674aa66edce1$var$pTag
    ],
    [
        "form",
        $6291674aa66edce1$var$pTag
    ],
    [
        "header",
        $6291674aa66edce1$var$pTag
    ],
    [
        "hr",
        $6291674aa66edce1$var$pTag
    ],
    [
        "main",
        $6291674aa66edce1$var$pTag
    ],
    [
        "nav",
        $6291674aa66edce1$var$pTag
    ],
    [
        "ol",
        $6291674aa66edce1$var$pTag
    ],
    [
        "pre",
        $6291674aa66edce1$var$pTag
    ],
    [
        "section",
        $6291674aa66edce1$var$pTag
    ],
    [
        "table",
        $6291674aa66edce1$var$pTag
    ],
    [
        "ul",
        $6291674aa66edce1$var$pTag
    ],
    [
        "rt",
        $6291674aa66edce1$var$rtpTags
    ],
    [
        "rp",
        $6291674aa66edce1$var$rtpTags
    ],
    [
        "tbody",
        $6291674aa66edce1$var$tableSectionTags
    ],
    [
        "tfoot",
        $6291674aa66edce1$var$tableSectionTags
    ]
]);
var $6291674aa66edce1$var$voidElements = new Set([
    "area",
    "base",
    "basefont",
    "br",
    "col",
    "command",
    "embed",
    "frame",
    "hr",
    "img",
    "input",
    "isindex",
    "keygen",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
var $6291674aa66edce1$var$foreignContextElements = new Set([
    "math",
    "svg"
]);
var $6291674aa66edce1$var$htmlIntegrationElements = new Set([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext",
    "annotation-xml",
    "foreignobject",
    "desc",
    "title"
]);
var $6291674aa66edce1$var$reNameEnd = /\s|\//;
var $6291674aa66edce1$var$Parser = /** @class */ function() {
    function Parser(cbs, options) {
        if (options === void 0) options = {};
        var _a, _b, _c, _d, _e;
        this.options = options;
        /** The start index of the last event. */ this.startIndex = 0;
        /** The end index of the last event. */ this.endIndex = 0;
        /**
         * Store the start index of the current open tag,
         * so we can update the start index for attributes.
         */ this.openTagStart = 0;
        this.tagname = "";
        this.attribname = "";
        this.attribvalue = "";
        this.attribs = null;
        this.stack = [];
        this.foreignContext = [];
        this.buffers = [];
        this.bufferOffset = 0;
        /** The index of the last written buffer. Used when resuming after a `pause()`. */ this.writeIndex = 0;
        /** Indicates whether the parser has finished running / `.end` has been called. */ this.ended = false;
        this.cbs = cbs !== null && cbs !== void 0 ? cbs : {};
        this.lowerCaseTagNames = (_a = options.lowerCaseTags) !== null && _a !== void 0 ? _a : !options.xmlMode;
        this.lowerCaseAttributeNames = (_b = options.lowerCaseAttributeNames) !== null && _b !== void 0 ? _b : !options.xmlMode;
        this.tokenizer = new ((_c = options.Tokenizer) !== null && _c !== void 0 ? _c : $6291674aa66edce1$var$Tokenizer_js_1.default)(this.options, this);
        (_e = (_d = this.cbs).onparserinit) === null || _e === void 0 || _e.call(_d, this);
    }
    // Tokenizer event handlers
    /** @internal */ Parser.prototype.ontext = function(start, endIndex) {
        var _a, _b;
        var data = this.getSlice(start, endIndex);
        this.endIndex = endIndex - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, data);
        this.startIndex = endIndex;
    };
    /** @internal */ Parser.prototype.ontextentity = function(cp) {
        var _a, _b;
        /*
         * Entities can be emitted on the character, or directly after.
         * We use the section start here to get accurate indices.
         */ var index = this.tokenizer.getSectionStart();
        this.endIndex = index - 1;
        (_b = (_a = this.cbs).ontext) === null || _b === void 0 || _b.call(_a, (0, $Tj5sm.fromCodePoint)(cp));
        this.startIndex = index;
    };
    Parser.prototype.isVoidElement = function(name) {
        return !this.options.xmlMode && $6291674aa66edce1$var$voidElements.has(name);
    };
    /** @internal */ Parser.prototype.onopentagname = function(start, endIndex) {
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        this.emitOpenTag(name);
    };
    Parser.prototype.emitOpenTag = function(name) {
        var _a, _b, _c, _d;
        this.openTagStart = this.startIndex;
        this.tagname = name;
        var impliesClose = !this.options.xmlMode && $6291674aa66edce1$var$openImpliesClose.get(name);
        if (impliesClose) while(this.stack.length > 0 && impliesClose.has(this.stack[this.stack.length - 1])){
            var element = this.stack.pop();
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, element, true);
        }
        if (!this.isVoidElement(name)) {
            this.stack.push(name);
            if ($6291674aa66edce1$var$foreignContextElements.has(name)) this.foreignContext.push(true);
            else if ($6291674aa66edce1$var$htmlIntegrationElements.has(name)) this.foreignContext.push(false);
        }
        (_d = (_c = this.cbs).onopentagname) === null || _d === void 0 || _d.call(_c, name);
        if (this.cbs.onopentag) this.attribs = {};
    };
    Parser.prototype.endOpenTag = function(isImplied) {
        var _a, _b;
        this.startIndex = this.openTagStart;
        if (this.attribs) {
            (_b = (_a = this.cbs).onopentag) === null || _b === void 0 || _b.call(_a, this.tagname, this.attribs, isImplied);
            this.attribs = null;
        }
        if (this.cbs.onclosetag && this.isVoidElement(this.tagname)) this.cbs.onclosetag(this.tagname, true);
        this.tagname = "";
    };
    /** @internal */ Parser.prototype.onopentagend = function(endIndex) {
        this.endIndex = endIndex;
        this.endOpenTag(false);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onclosetag = function(start, endIndex) {
        var _a, _b, _c, _d, _e, _f;
        this.endIndex = endIndex;
        var name = this.getSlice(start, endIndex);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        if ($6291674aa66edce1$var$foreignContextElements.has(name) || $6291674aa66edce1$var$htmlIntegrationElements.has(name)) this.foreignContext.pop();
        if (!this.isVoidElement(name)) {
            var pos = this.stack.lastIndexOf(name);
            if (pos !== -1) {
                if (this.cbs.onclosetag) {
                    var count = this.stack.length - pos;
                    while(count--)// We know the stack has sufficient elements.
                    this.cbs.onclosetag(this.stack.pop(), count !== 0);
                } else this.stack.length = pos;
            } else if (!this.options.xmlMode && name === "p") {
                // Implicit open before close
                this.emitOpenTag("p");
                this.closeCurrentTag(true);
            }
        } else if (!this.options.xmlMode && name === "br") {
            // We can't use `emitOpenTag` for implicit open, as `br` would be implicitly closed.
            (_b = (_a = this.cbs).onopentagname) === null || _b === void 0 || _b.call(_a, "br");
            (_d = (_c = this.cbs).onopentag) === null || _d === void 0 || _d.call(_c, "br", {}, true);
            (_f = (_e = this.cbs).onclosetag) === null || _f === void 0 || _f.call(_e, "br", false);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onselfclosingtag = function(endIndex) {
        this.endIndex = endIndex;
        if (this.options.xmlMode || this.options.recognizeSelfClosing || this.foreignContext[this.foreignContext.length - 1]) {
            this.closeCurrentTag(false);
            // Set `startIndex` for next node
            this.startIndex = endIndex + 1;
        } else // Ignore the fact that the tag is self-closing.
        this.onopentagend(endIndex);
    };
    Parser.prototype.closeCurrentTag = function(isOpenImplied) {
        var _a, _b;
        var name = this.tagname;
        this.endOpenTag(isOpenImplied);
        // Self-closing tags will be on the top of the stack
        if (this.stack[this.stack.length - 1] === name) {
            // If the opening tag isn't implied, the closing tag has to be implied.
            (_b = (_a = this.cbs).onclosetag) === null || _b === void 0 || _b.call(_a, name, !isOpenImplied);
            this.stack.pop();
        }
    };
    /** @internal */ Parser.prototype.onattribname = function(start, endIndex) {
        this.startIndex = start;
        var name = this.getSlice(start, endIndex);
        this.attribname = this.lowerCaseAttributeNames ? name.toLowerCase() : name;
    };
    /** @internal */ Parser.prototype.onattribdata = function(start, endIndex) {
        this.attribvalue += this.getSlice(start, endIndex);
    };
    /** @internal */ Parser.prototype.onattribentity = function(cp) {
        this.attribvalue += (0, $Tj5sm.fromCodePoint)(cp);
    };
    /** @internal */ Parser.prototype.onattribend = function(quote, endIndex) {
        var _a, _b;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).onattribute) === null || _b === void 0 || _b.call(_a, this.attribname, this.attribvalue, quote === $6291674aa66edce1$var$Tokenizer_js_1.QuoteType.Double ? '"' : quote === $6291674aa66edce1$var$Tokenizer_js_1.QuoteType.Single ? "'" : quote === $6291674aa66edce1$var$Tokenizer_js_1.QuoteType.NoValue ? undefined : null);
        if (this.attribs && !Object.prototype.hasOwnProperty.call(this.attribs, this.attribname)) this.attribs[this.attribname] = this.attribvalue;
        this.attribvalue = "";
    };
    Parser.prototype.getInstructionName = function(value) {
        var index = value.search($6291674aa66edce1$var$reNameEnd);
        var name = index < 0 ? value : value.substr(0, index);
        if (this.lowerCaseTagNames) name = name.toLowerCase();
        return name;
    };
    /** @internal */ Parser.prototype.ondeclaration = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("!".concat(name), "!".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onprocessinginstruction = function(start, endIndex) {
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex);
        if (this.cbs.onprocessinginstruction) {
            var name = this.getInstructionName(value);
            this.cbs.onprocessinginstruction("?".concat(name), "?".concat(value));
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.oncomment = function(start, endIndex, offset) {
        var _a, _b, _c, _d;
        this.endIndex = endIndex;
        (_b = (_a = this.cbs).oncomment) === null || _b === void 0 || _b.call(_a, this.getSlice(start, endIndex - offset));
        (_d = (_c = this.cbs).oncommentend) === null || _d === void 0 || _d.call(_c);
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.oncdata = function(start, endIndex, offset) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.endIndex = endIndex;
        var value = this.getSlice(start, endIndex - offset);
        if (this.options.xmlMode || this.options.recognizeCDATA) {
            (_b = (_a = this.cbs).oncdatastart) === null || _b === void 0 || _b.call(_a);
            (_d = (_c = this.cbs).ontext) === null || _d === void 0 || _d.call(_c, value);
            (_f = (_e = this.cbs).oncdataend) === null || _f === void 0 || _f.call(_e);
        } else {
            (_h = (_g = this.cbs).oncomment) === null || _h === void 0 || _h.call(_g, "[CDATA[".concat(value, "]]"));
            (_k = (_j = this.cbs).oncommentend) === null || _k === void 0 || _k.call(_j);
        }
        // Set `startIndex` for next node
        this.startIndex = endIndex + 1;
    };
    /** @internal */ Parser.prototype.onend = function() {
        var _a, _b;
        if (this.cbs.onclosetag) {
            // Set the end index for all remaining tags
            this.endIndex = this.startIndex;
            for(var index = this.stack.length; index > 0; this.cbs.onclosetag(this.stack[--index], true));
        }
        (_b = (_a = this.cbs).onend) === null || _b === void 0 || _b.call(_a);
    };
    /**
     * Resets the parser to a blank state, ready to parse a new HTML document
     */ Parser.prototype.reset = function() {
        var _a, _b, _c, _d;
        (_b = (_a = this.cbs).onreset) === null || _b === void 0 || _b.call(_a);
        this.tokenizer.reset();
        this.tagname = "";
        this.attribname = "";
        this.attribs = null;
        this.stack.length = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        (_d = (_c = this.cbs).onparserinit) === null || _d === void 0 || _d.call(_c, this);
        this.buffers.length = 0;
        this.bufferOffset = 0;
        this.writeIndex = 0;
        this.ended = false;
    };
    /**
     * Resets the parser, then parses a complete document and
     * pushes it to the handler.
     *
     * @param data Document to parse.
     */ Parser.prototype.parseComplete = function(data) {
        this.reset();
        this.end(data);
    };
    Parser.prototype.getSlice = function(start, end) {
        while(start - this.bufferOffset >= this.buffers[0].length)this.shiftBuffer();
        var slice = this.buffers[0].slice(start - this.bufferOffset, end - this.bufferOffset);
        while(end - this.bufferOffset > this.buffers[0].length){
            this.shiftBuffer();
            slice += this.buffers[0].slice(0, end - this.bufferOffset);
        }
        return slice;
    };
    Parser.prototype.shiftBuffer = function() {
        this.bufferOffset += this.buffers[0].length;
        this.writeIndex--;
        this.buffers.shift();
    };
    /**
     * Parses a chunk of data and calls the corresponding callbacks.
     *
     * @param chunk Chunk to parse.
     */ Parser.prototype.write = function(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".write() after done!"));
            return;
        }
        this.buffers.push(chunk);
        if (this.tokenizer.running) {
            this.tokenizer.write(chunk);
            this.writeIndex++;
        }
    };
    /**
     * Parses the end of the buffer and clears the stack, calls onend.
     *
     * @param chunk Optional final chunk to parse.
     */ Parser.prototype.end = function(chunk) {
        var _a, _b;
        if (this.ended) {
            (_b = (_a = this.cbs).onerror) === null || _b === void 0 || _b.call(_a, new Error(".end() after done!"));
            return;
        }
        if (chunk) this.write(chunk);
        this.ended = true;
        this.tokenizer.end();
    };
    /**
     * Pauses parsing. The parser won't emit events until `resume` is called.
     */ Parser.prototype.pause = function() {
        this.tokenizer.pause();
    };
    /**
     * Resumes parsing after `pause` was called.
     */ Parser.prototype.resume = function() {
        this.tokenizer.resume();
        while(this.tokenizer.running && this.writeIndex < this.buffers.length)this.tokenizer.write(this.buffers[this.writeIndex++]);
        if (this.ended) this.tokenizer.end();
    };
    /**
     * Alias of `write`, for backwards compatibility.
     *
     * @param chunk Chunk to parse.
     * @deprecated
     */ Parser.prototype.parseChunk = function(chunk) {
        this.write(chunk);
    };
    /**
     * Alias of `end`, for backwards compatibility.
     *
     * @param chunk Optional final chunk to parse.
     * @deprecated
     */ Parser.prototype.done = function(chunk) {
        this.end(chunk);
    };
    return Parser;
}();
$6291674aa66edce1$exports.Parser = $6291674aa66edce1$var$Parser;



Object.defineProperty($9a82279beb63eb09$exports, "Parser", {
    enumerable: true,
    get: function() {
        return $6291674aa66edce1$exports.Parser;
    }
});

var $5MteQ = parcelRequire("5MteQ");

var $5MteQ = parcelRequire("5MteQ");
Object.defineProperty($9a82279beb63eb09$exports, "DomHandler", {
    enumerable: true,
    get: function() {
        return $5MteQ.DomHandler;
    }
});
// Old name for DomHandler
Object.defineProperty($9a82279beb63eb09$exports, "DefaultHandler", {
    enumerable: true,
    get: function() {
        return $5MteQ.DomHandler;
    }
});
// Helper methods
/**
 * Parses the data, returns the resulting document.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 */ function $9a82279beb63eb09$var$parseDocument(data, options) {
    var handler = new $5MteQ.DomHandler(undefined, options);
    new $6291674aa66edce1$exports.Parser(handler, options).end(data);
    return handler.root;
}
$9a82279beb63eb09$exports.parseDocument = $9a82279beb63eb09$var$parseDocument;
/**
 * Parses data, returns an array of the root nodes.
 *
 * Note that the root nodes still have a `Document` node as their parent.
 * Use `parseDocument` to get the `Document` node instead.
 *
 * @param data The data that should be parsed.
 * @param options Optional options for the parser and DOM builder.
 * @deprecated Use `parseDocument` instead.
 */ function $9a82279beb63eb09$var$parseDOM(data, options) {
    return $9a82279beb63eb09$var$parseDocument(data, options).children;
}
$9a82279beb63eb09$exports.parseDOM = $9a82279beb63eb09$var$parseDOM;
/**
 * Creates a parser instance, with an attached DOM handler.
 *
 * @param callback A callback that will be called once parsing has been completed.
 * @param options Optional options for the parser and DOM builder.
 * @param elementCallback An optional callback that will be called every time a tag has been completed inside of the DOM.
 */ function $9a82279beb63eb09$var$createDomStream(callback, options, elementCallback) {
    var handler = new $5MteQ.DomHandler(callback, options, elementCallback);
    return new $6291674aa66edce1$exports.Parser(handler, options);
}
$9a82279beb63eb09$exports.createDomStream = $9a82279beb63eb09$var$createDomStream;

var $egNzs = parcelRequire("egNzs");
Object.defineProperty($9a82279beb63eb09$exports, "Tokenizer", {
    enumerable: true,
    get: function() {
        return $9a82279beb63eb09$var$__importDefault($egNzs).default;
    }
});

/*
 * All of the following exports exist for backwards-compatibility.
 * They should probably be removed eventually.
 */ $9a82279beb63eb09$exports.ElementType = $9a82279beb63eb09$var$__importStar((parcelRequire("95jpT")));


Object.defineProperty($9a82279beb63eb09$exports, "getFeed", {
    enumerable: true,
    get: function() {
        return (parcelRequire("hfvOx")).getFeed;
    }
});
var $9a82279beb63eb09$var$parseFeedDefaultOptions = {
    xmlMode: true
};
/**
 * Parse a feed.
 *
 * @param feed The feed that should be parsed, as a string.
 * @param options Optionally, options for parsing. When using this, you should set `xmlMode` to `true`.
 */ function $9a82279beb63eb09$var$parseFeed(feed, options) {
    if (options === void 0) options = $9a82279beb63eb09$var$parseFeedDefaultOptions;
    return (0, (parcelRequire("hfvOx")).getFeed)($9a82279beb63eb09$var$parseDOM(feed, options));
}
$9a82279beb63eb09$exports.parseFeed = $9a82279beb63eb09$var$parseFeed;

$9a82279beb63eb09$exports.DomUtils = $9a82279beb63eb09$var$__importStar((parcelRequire("hfvOx")));


var $3f3faafe3b230b68$exports = {};
"use strict";
$3f3faafe3b230b68$exports = (string)=>{
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a \unnnn escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};


var $b4c28a517d0c6172$exports = {};
"use strict";
Object.defineProperty($b4c28a517d0c6172$exports, "__esModule", {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $b4c28a517d0c6172$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $b4c28a517d0c6172$var$isPlainObject(o) {
    var ctor, prot;
    if ($b4c28a517d0c6172$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($b4c28a517d0c6172$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty("isPrototypeOf") === false) return false;
    // Most likely a plain Object
    return true;
}
$b4c28a517d0c6172$exports.isPlainObject = $b4c28a517d0c6172$var$isPlainObject;


var $5a5e255be41ec1f1$require$isPlainObject = $b4c28a517d0c6172$exports.isPlainObject;
var $8182c743591e3d4d$exports = {};
"use strict";
var $8182c743591e3d4d$var$isMergeableObject = function isMergeableObject(value) {
    return $8182c743591e3d4d$var$isNonNullObject(value) && !$8182c743591e3d4d$var$isSpecial(value);
};
function $8182c743591e3d4d$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $8182c743591e3d4d$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $8182c743591e3d4d$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $8182c743591e3d4d$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $8182c743591e3d4d$var$REACT_ELEMENT_TYPE = $8182c743591e3d4d$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $8182c743591e3d4d$var$isReactElement(value) {
    return value.$$typeof === $8182c743591e3d4d$var$REACT_ELEMENT_TYPE;
}
function $8182c743591e3d4d$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $8182c743591e3d4d$var$deepmerge($8182c743591e3d4d$var$emptyTarget(value), value, options) : value;
}
function $8182c743591e3d4d$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $8182c743591e3d4d$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $8182c743591e3d4d$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $8182c743591e3d4d$var$deepmerge;
}
function $8182c743591e3d4d$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function $8182c743591e3d4d$var$getKeys(target) {
    return Object.keys(target).concat($8182c743591e3d4d$var$getEnumerableOwnPropertySymbols(target));
}
function $8182c743591e3d4d$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $8182c743591e3d4d$var$propertyIsUnsafe(target, key) {
    return $8182c743591e3d4d$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $8182c743591e3d4d$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $8182c743591e3d4d$var$getKeys(target).forEach(function(key) {
        destination[key] = $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $8182c743591e3d4d$var$getKeys(source).forEach(function(key) {
        if ($8182c743591e3d4d$var$propertyIsUnsafe(target, key)) return;
        if ($8182c743591e3d4d$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $8182c743591e3d4d$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $8182c743591e3d4d$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $8182c743591e3d4d$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $8182c743591e3d4d$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $8182c743591e3d4d$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $8182c743591e3d4d$var$mergeObject(target, source, options);
}
$8182c743591e3d4d$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $8182c743591e3d4d$var$deepmerge(prev, next, options);
    }, {});
};
var $8182c743591e3d4d$var$deepmerge_1 = $8182c743591e3d4d$var$deepmerge;
$8182c743591e3d4d$exports = $8182c743591e3d4d$var$deepmerge_1;


var $5b9f703d39f199e9$exports = {};
/**
 * Srcset Parser
 *
 * By Alex Bell |  MIT License
 *
 * JS Parser for the string value that appears in markup <img srcset="here">
 *
 * @returns Array [{url: _, d: _, w: _, h:_}, ...]
 *
 * Based super duper closely on the reference algorithm at:
 * https://html.spec.whatwg.org/multipage/embedded-content.html#parse-a-srcset-attribute
 *
 * Most comments are copied in directly from the spec
 * (except for comments in parens).
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (0, $5b9f703d39f199e9$exports) // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    $5b9f703d39f199e9$exports = factory();
    else // Browser globals (root is window)
    root.parseSrcset = factory();
})($5b9f703d39f199e9$exports, function() {
    // 1. Let input be the value passed to this algorithm.
    return function(input) {
        // UTILITY FUNCTIONS
        // Manual is faster than RegEx
        // http://bjorn.tipling.com/state-and-regular-expressions-in-javascript
        // http://jsperf.com/whitespace-character/5
        function isSpace(c) {
            return c === " " || // space
            c === "	" || // horizontal tab
            c === "\n" || // new line
            c === "\f" || // form feed
            c === "\r"; // carriage return
        }
        function collectCharacters(regEx) {
            var chars, match = regEx.exec(input.substring(pos));
            if (match) {
                chars = match[0];
                pos += chars.length;
                return chars;
            }
        }
        var inputLength = input.length, // (Don't use \s, to avoid matching non-breaking space)
        regexLeadingSpaces = /^[ \t\n\r\u000c]+/, regexLeadingCommasOrSpaces = /^[, \t\n\r\u000c]+/, regexLeadingNotSpaces = /^[^ \t\n\r\u000c]+/, regexTrailingCommas = /[,]+$/, regexNonNegativeInteger = /^\d+$/, // ( Positive or negative or unsigned integers or decimals, without or without exponents.
        // Must include at least one digit.
        // According to spec tests any decimal point must be followed by a digit.
        // No leading plus sign is allowed.)
        // https://html.spec.whatwg.org/multipage/infrastructure.html#valid-floating-point-number
        regexFloatingPoint = /^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/, url, descriptors, currentDescriptor, state, c, // 2. Let position be a pointer into input, initially pointing at the start
        //    of the string.
        pos = 0, // 3. Let candidates be an initially empty source set.
        candidates = [];
        // 4. Splitting loop: Collect a sequence of characters that are space
        //    characters or U+002C COMMA characters. If any U+002C COMMA characters
        //    were collected, that is a parse error.
        while(true){
            collectCharacters(regexLeadingCommasOrSpaces);
            // 5. If position is past the end of input, return candidates and abort these steps.
            if (pos >= inputLength) return candidates; // (we're done, this is the sole return path)
            // 6. Collect a sequence of characters that are not space characters,
            //    and let that be url.
            url = collectCharacters(regexLeadingNotSpaces);
            // 7. Let descriptors be a new empty list.
            descriptors = [];
            // 8. If url ends with a U+002C COMMA character (,), follow these substeps:
            //		(1). Remove all trailing U+002C COMMA characters from url. If this removed
            //         more than one character, that is a parse error.
            if (url.slice(-1) === ",") {
                url = url.replace(regexTrailingCommas, "");
                // (Jump ahead to step 9 to skip tokenization and just push the candidate).
                parseDescriptors();
            //	Otherwise, follow these substeps:
            } else tokenize();
             // (close else of step 8)
        // 16. Return to the step labeled splitting loop.
        } // (Close of big while loop.)
        /**
		 * Tokenizes descriptor properties prior to parsing
		 * Returns undefined.
		 */ function tokenize() {
            // 8.1. Descriptor tokeniser: Skip whitespace
            collectCharacters(regexLeadingSpaces);
            // 8.2. Let current descriptor be the empty string.
            currentDescriptor = "";
            // 8.3. Let state be in descriptor.
            state = "in descriptor";
            while(true){
                // 8.4. Let c be the character at position.
                c = input.charAt(pos);
                //  Do the following depending on the value of state.
                //  For the purpose of this step, "EOF" is a special character representing
                //  that position is past the end of input.
                // In descriptor
                if (state === "in descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors and let current descriptor be the empty string.
                    // Set state to after descriptor.
                    if (isSpace(c)) {
                        if (currentDescriptor) {
                            descriptors.push(currentDescriptor);
                            currentDescriptor = "";
                            state = "after descriptor";
                        }
                    } else if (c === ",") {
                        pos += 1;
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // U+0028 LEFT PARENTHESIS (()
                    // Append c to current descriptor. Set state to in parens.
                    } else if (c === "(") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in parens";
                    // EOF
                    // If current descriptor is not empty, append current descriptor to
                    // descriptors. Jump to the step labeled descriptor parser.
                    } else if (c === "") {
                        if (currentDescriptor) descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // (end "in descriptor"
                // In parens
                } else if (state === "in parens") {
                    // U+0029 RIGHT PARENTHESIS ())
                    // Append c to current descriptor. Set state to in descriptor.
                    if (c === ")") {
                        currentDescriptor = currentDescriptor + c;
                        state = "in descriptor";
                    // EOF
                    // Append current descriptor to descriptors. Jump to the step labeled
                    // descriptor parser.
                    } else if (c === "") {
                        descriptors.push(currentDescriptor);
                        parseDescriptors();
                        return;
                    // Anything else
                    // Append c to current descriptor.
                    } else currentDescriptor = currentDescriptor + c;
                // After descriptor
                } else if (state === "after descriptor") {
                    // Do the following, depending on the value of c:
                    // Space character: Stay in this state.
                    if (isSpace(c)) ;
                    else if (c === "") {
                        parseDescriptors();
                        return;
                    // Anything else
                    // Set state to in descriptor. Set position to the previous character in input.
                    } else {
                        state = "in descriptor";
                        pos -= 1;
                    }
                }
                // Advance position to the next character in input.
                pos += 1;
            // Repeat this step.
            } // (close while true loop)
        }
        /**
		 * Adds descriptor properties to a candidate, pushes to the candidates array
		 * @return undefined
		 */ // Declared outside of the while loop so that it's only created once.
        function parseDescriptors() {
            // 9. Descriptor parser: Let error be no.
            var pError = false, // 10. Let width be absent.
            // 11. Let density be absent.
            // 12. Let future-compat-h be absent. (We're implementing it now as h)
            w, d, h, i, candidate = {}, desc, lastChar, value, intVal, floatVal;
            // 13. For each descriptor in descriptors, run the appropriate set of steps
            // from the following list:
            for(i = 0; i < descriptors.length; i++){
                desc = descriptors[i];
                lastChar = desc[desc.length - 1];
                value = desc.substring(0, desc.length - 1);
                intVal = parseInt(value, 10);
                floatVal = parseFloat(value);
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0077 LATIN SMALL LETTER W character
                if (regexNonNegativeInteger.test(value) && lastChar === "w") {
                    // If width and density are not both absent, then let error be yes.
                    if (w || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes.
                    // Otherwise, let width be the result.
                    if (intVal === 0) pError = true;
                    else w = intVal;
                // If the descriptor consists of a valid floating-point number followed by
                // a U+0078 LATIN SMALL LETTER X character
                } else if (regexFloatingPoint.test(value) && lastChar === "x") {
                    // If width, density and future-compat-h are not all absent, then let error
                    // be yes.
                    if (w || d || h) pError = true;
                    // Apply the rules for parsing floating-point number values to the descriptor.
                    // If the result is less than zero, let error be yes. Otherwise, let density
                    // be the result.
                    if (floatVal < 0) pError = true;
                    else d = floatVal;
                // If the descriptor consists of a valid non-negative integer followed by
                // a U+0068 LATIN SMALL LETTER H character
                } else if (regexNonNegativeInteger.test(value) && lastChar === "h") {
                    // If height and density are not both absent, then let error be yes.
                    if (h || d) pError = true;
                    // Apply the rules for parsing non-negative integers to the descriptor.
                    // If the result is zero, let error be yes. Otherwise, let future-compat-h
                    // be the result.
                    if (intVal === 0) pError = true;
                    else h = intVal;
                // Anything else, Let error be yes.
                } else pError = true;
            } // (close step 13 for loop)
            // 15. If error is still no, then append a new image source to candidates whose
            // URL is url, associated with a width width if not absent and a pixel
            // density density if not absent. Otherwise, there is a parse error.
            if (!pError) {
                candidate.url = url;
                if (w) candidate.w = w;
                if (d) candidate.d = d;
                if (h) candidate.h = h;
                candidates.push(candidate);
            } else if (console && console.log) console.log("Invalid srcset descriptor found in '" + input + "' at '" + desc + "'.");
        } // (close parseDescriptors fn)
    };
});


var $798e02f7da0a718d$exports = {};
"use strict";
var $1ef91c4708632651$exports = {};
"use strict";
var $9ae0bc11df520a21$exports = {};
var $9ae0bc11df520a21$var$x = String;
var $9ae0bc11df520a21$var$create = function() {
    return {
        isColorSupported: false,
        reset: $9ae0bc11df520a21$var$x,
        bold: $9ae0bc11df520a21$var$x,
        dim: $9ae0bc11df520a21$var$x,
        italic: $9ae0bc11df520a21$var$x,
        underline: $9ae0bc11df520a21$var$x,
        inverse: $9ae0bc11df520a21$var$x,
        hidden: $9ae0bc11df520a21$var$x,
        strikethrough: $9ae0bc11df520a21$var$x,
        black: $9ae0bc11df520a21$var$x,
        red: $9ae0bc11df520a21$var$x,
        green: $9ae0bc11df520a21$var$x,
        yellow: $9ae0bc11df520a21$var$x,
        blue: $9ae0bc11df520a21$var$x,
        magenta: $9ae0bc11df520a21$var$x,
        cyan: $9ae0bc11df520a21$var$x,
        white: $9ae0bc11df520a21$var$x,
        gray: $9ae0bc11df520a21$var$x,
        bgBlack: $9ae0bc11df520a21$var$x,
        bgRed: $9ae0bc11df520a21$var$x,
        bgGreen: $9ae0bc11df520a21$var$x,
        bgYellow: $9ae0bc11df520a21$var$x,
        bgBlue: $9ae0bc11df520a21$var$x,
        bgMagenta: $9ae0bc11df520a21$var$x,
        bgCyan: $9ae0bc11df520a21$var$x,
        bgWhite: $9ae0bc11df520a21$var$x
    };
};
$9ae0bc11df520a21$exports = $9ae0bc11df520a21$var$create();
$9ae0bc11df520a21$exports.createColors = $9ae0bc11df520a21$var$create;


var $fe2a6b54d849136b$exports = {};
"use strict";


class $1ef91c4708632651$var$CssSyntaxError extends Error {
    constructor(message, line, column, source, file, plugin){
        super(message);
        this.name = "CssSyntaxError";
        this.reason = message;
        if (file) this.file = file;
        if (source) this.source = source;
        if (plugin) this.plugin = plugin;
        if (typeof line !== "undefined" && typeof column !== "undefined") {
            if (typeof line === "number") {
                this.line = line;
                this.column = column;
            } else {
                this.line = line.line;
                this.column = line.column;
                this.endLine = column.line;
                this.endColumn = column.column;
            }
        }
        this.setMessage();
        if (Error.captureStackTrace) Error.captureStackTrace(this, $1ef91c4708632651$var$CssSyntaxError);
    }
    setMessage() {
        this.message = this.plugin ? this.plugin + ": " : "";
        this.message += this.file ? this.file : "<css input>";
        if (typeof this.line !== "undefined") this.message += ":" + this.line + ":" + this.column;
        this.message += ": " + this.reason;
    }
    showSourceCode(color) {
        if (!this.source) return "";
        let css = this.source;
        if (color == null) color = $9ae0bc11df520a21$exports.isColorSupported;
        if ($fe2a6b54d849136b$exports) {
            if (color) css = $fe2a6b54d849136b$exports(css);
        }
        let lines = css.split(/\r?\n/);
        let start = Math.max(this.line - 3, 0);
        let end = Math.min(this.line + 2, lines.length);
        let maxWidth = String(end).length;
        let mark, aside;
        if (color) {
            let { bold: bold, gray: gray, red: red } = $9ae0bc11df520a21$exports.createColors(true);
            mark = (text)=>bold(red(text));
            aside = (text)=>gray(text);
        } else mark = aside = (str)=>str;
        return lines.slice(start, end).map((line, index)=>{
            let number = start + 1 + index;
            let gutter = " " + (" " + number).slice(-maxWidth) + " | ";
            if (number === this.line) {
                let spacing = aside(gutter.replace(/\d/g, " ")) + line.slice(0, this.column - 1).replace(/[^\t]/g, " ");
                return mark(">") + aside(gutter) + line + "\n " + spacing + mark("^");
            }
            return " " + aside(gutter) + line;
        }).join("\n");
    }
    toString() {
        let code = this.showSourceCode();
        if (code) code = "\n\n" + code + "\n";
        return this.name + ": " + this.message + code;
    }
}
$1ef91c4708632651$exports = $1ef91c4708632651$var$CssSyntaxError;
$1ef91c4708632651$var$CssSyntaxError.default = $1ef91c4708632651$var$CssSyntaxError;


var $f96b5e8a06a46319$exports = {};
"use strict";
var $a86fcc2c0b06d3d6$exports = {};
"use strict";
var $35608d4e1c63af4a$export$ae5e7911ce0728f9;
var $35608d4e1c63af4a$export$94fa0a6beb22f989;
"use strict";
$35608d4e1c63af4a$export$ae5e7911ce0728f9 = Symbol("isClean");
$35608d4e1c63af4a$export$94fa0a6beb22f989 = Symbol("my");


var $a86fcc2c0b06d3d6$require$isClean = $35608d4e1c63af4a$export$ae5e7911ce0728f9;
var $a86fcc2c0b06d3d6$require$my = $35608d4e1c63af4a$export$94fa0a6beb22f989;

var $cf4b226eac7ecd1f$exports = {};
"use strict";
const $cf4b226eac7ecd1f$var$DEFAULT_RAW = {
    after: "\n",
    beforeClose: "\n",
    beforeComment: "\n",
    beforeDecl: "\n",
    beforeOpen: " ",
    beforeRule: "\n",
    colon: ": ",
    commentLeft: " ",
    commentRight: " ",
    emptyBody: "",
    indent: "    ",
    semicolon: false
};
function $cf4b226eac7ecd1f$var$capitalize(str) {
    return str[0].toUpperCase() + str.slice(1);
}
class $cf4b226eac7ecd1f$var$Stringifier {
    constructor(builder){
        this.builder = builder;
    }
    atrule(node, semicolon) {
        let name = "@" + node.name;
        let params = node.params ? this.rawValue(node, "params") : "";
        if (typeof node.raws.afterName !== "undefined") name += node.raws.afterName;
        else if (params) name += " ";
        if (node.nodes) this.block(node, name + params);
        else {
            let end = (node.raws.between || "") + (semicolon ? ";" : "");
            this.builder(name + params + end, node);
        }
    }
    beforeAfter(node, detect) {
        let value;
        if (node.type === "decl") value = this.raw(node, null, "beforeDecl");
        else if (node.type === "comment") value = this.raw(node, null, "beforeComment");
        else if (detect === "before") value = this.raw(node, null, "beforeRule");
        else value = this.raw(node, null, "beforeClose");
        let buf = node.parent;
        let depth = 0;
        while(buf && buf.type !== "root"){
            depth += 1;
            buf = buf.parent;
        }
        if (value.includes("\n")) {
            let indent = this.raw(node, null, "indent");
            if (indent.length) for(let step = 0; step < depth; step++)value += indent;
        }
        return value;
    }
    block(node, start) {
        let between = this.raw(node, "between", "beforeOpen");
        this.builder(start + between + "{", node, "start");
        let after;
        if (node.nodes && node.nodes.length) {
            this.body(node);
            after = this.raw(node, "after");
        } else after = this.raw(node, "after", "emptyBody");
        if (after) this.builder(after);
        this.builder("}", node, "end");
    }
    body(node) {
        let last = node.nodes.length - 1;
        while(last > 0){
            if (node.nodes[last].type !== "comment") break;
            last -= 1;
        }
        let semicolon = this.raw(node, "semicolon");
        for(let i = 0; i < node.nodes.length; i++){
            let child = node.nodes[i];
            let before = this.raw(child, "before");
            if (before) this.builder(before);
            this.stringify(child, last !== i || semicolon);
        }
    }
    comment(node) {
        let left = this.raw(node, "left", "commentLeft");
        let right = this.raw(node, "right", "commentRight");
        this.builder("/*" + left + node.text + right + "*/", node);
    }
    decl(node, semicolon) {
        let between = this.raw(node, "between", "colon");
        let string = node.prop + between + this.rawValue(node, "value");
        if (node.important) string += node.raws.important || " !important";
        if (semicolon) string += ";";
        this.builder(string, node);
    }
    document(node) {
        this.body(node);
    }
    raw(node, own, detect) {
        let value;
        if (!detect) detect = own;
        // Already had
        if (own) {
            value = node.raws[own];
            if (typeof value !== "undefined") return value;
        }
        let parent = node.parent;
        if (detect === "before") {
            // Hack for first rule in CSS
            if (!parent || parent.type === "root" && parent.first === node) return "";
            // `root` nodes in `document` should use only their own raws
            if (parent && parent.type === "document") return "";
        }
        // Floating child without parent
        if (!parent) return $cf4b226eac7ecd1f$var$DEFAULT_RAW[detect];
        // Detect style by other nodes
        let root = node.root();
        if (!root.rawCache) root.rawCache = {};
        if (typeof root.rawCache[detect] !== "undefined") return root.rawCache[detect];
        if (detect === "before" || detect === "after") return this.beforeAfter(node, detect);
        else {
            let method = "raw" + $cf4b226eac7ecd1f$var$capitalize(detect);
            if (this[method]) value = this[method](root, node);
            else root.walk((i)=>{
                value = i.raws[own];
                if (typeof value !== "undefined") return false;
            });
        }
        if (typeof value === "undefined") value = $cf4b226eac7ecd1f$var$DEFAULT_RAW[detect];
        root.rawCache[detect] = value;
        return value;
    }
    rawBeforeClose(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length > 0) {
                if (typeof i.raws.after !== "undefined") {
                    value = i.raws.after;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeComment(root, node) {
        let value;
        root.walkComments((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeDecl");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeDecl(root, node) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.before !== "undefined") {
                value = i.raws.before;
                if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                return false;
            }
        });
        if (typeof value === "undefined") value = this.raw(node, null, "beforeRule");
        else if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawBeforeOpen(root) {
        let value;
        root.walk((i)=>{
            if (i.type !== "decl") {
                value = i.raws.between;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawBeforeRule(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && (i.parent !== root || root.first !== i)) {
                if (typeof i.raws.before !== "undefined") {
                    value = i.raws.before;
                    if (value.includes("\n")) value = value.replace(/[^\n]+$/, "");
                    return false;
                }
            }
        });
        if (value) value = value.replace(/\S/g, "");
        return value;
    }
    rawColon(root) {
        let value;
        root.walkDecls((i)=>{
            if (typeof i.raws.between !== "undefined") {
                value = i.raws.between.replace(/[^\s:]/g, "");
                return false;
            }
        });
        return value;
    }
    rawEmptyBody(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length === 0) {
                value = i.raws.after;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawIndent(root) {
        if (root.raws.indent) return root.raws.indent;
        let value;
        root.walk((i)=>{
            let p = i.parent;
            if (p && p !== root && p.parent && p.parent === root) {
                if (typeof i.raws.before !== "undefined") {
                    let parts = i.raws.before.split("\n");
                    value = parts[parts.length - 1];
                    value = value.replace(/\S/g, "");
                    return false;
                }
            }
        });
        return value;
    }
    rawSemicolon(root) {
        let value;
        root.walk((i)=>{
            if (i.nodes && i.nodes.length && i.last.type === "decl") {
                value = i.raws.semicolon;
                if (typeof value !== "undefined") return false;
            }
        });
        return value;
    }
    rawValue(node, prop) {
        let value = node[prop];
        let raw = node.raws[prop];
        if (raw && raw.value === value) return raw.raw;
        return value;
    }
    root(node) {
        this.body(node);
        if (node.raws.after) this.builder(node.raws.after);
    }
    rule(node) {
        this.block(node, this.rawValue(node, "selector"));
        if (node.raws.ownSemicolon) this.builder(node.raws.ownSemicolon, node, "end");
    }
    stringify(node, semicolon) {
        /* c8 ignore start */ if (!this[node.type]) throw new Error("Unknown AST node type " + node.type + ". " + "Maybe you need to change PostCSS stringifier.");
        /* c8 ignore stop */ this[node.type](node, semicolon);
    }
}
$cf4b226eac7ecd1f$exports = $cf4b226eac7ecd1f$var$Stringifier;
$cf4b226eac7ecd1f$var$Stringifier.default = $cf4b226eac7ecd1f$var$Stringifier;


var $9d5cc43a7e8041f7$exports = {};
"use strict";

function $9d5cc43a7e8041f7$var$stringify(node, builder) {
    let str = new $cf4b226eac7ecd1f$exports(builder);
    str.stringify(node);
}
$9d5cc43a7e8041f7$exports = $9d5cc43a7e8041f7$var$stringify;
$9d5cc43a7e8041f7$var$stringify.default = $9d5cc43a7e8041f7$var$stringify;


function $a86fcc2c0b06d3d6$var$cloneNode(obj, parent) {
    let cloned = new obj.constructor();
    for(let i in obj){
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        if (i === "proxyCache") continue;
        let value = obj[i];
        let type = typeof value;
        if (i === "parent" && type === "object") {
            if (parent) cloned[i] = parent;
        } else if (i === "source") cloned[i] = value;
        else if (Array.isArray(value)) cloned[i] = value.map((j)=>$a86fcc2c0b06d3d6$var$cloneNode(j, cloned));
        else {
            if (type === "object" && value !== null) value = $a86fcc2c0b06d3d6$var$cloneNode(value);
            cloned[i] = value;
        }
    }
    return cloned;
}
class $a86fcc2c0b06d3d6$var$Node {
    constructor(defaults = {}){
        this.raws = {};
        this[$a86fcc2c0b06d3d6$require$isClean] = false;
        this[$a86fcc2c0b06d3d6$require$my] = true;
        for(let name in defaults)if (name === "nodes") {
            this.nodes = [];
            for (let node of defaults[name])if (typeof node.clone === "function") this.append(node.clone());
            else this.append(node);
        } else this[name] = defaults[name];
    }
    addToError(error) {
        error.postcssNode = this;
        if (error.stack && this.source && /\n\s{4}at /.test(error.stack)) {
            let s = this.source;
            error.stack = error.stack.replace(/\n\s{4}at /, `$&${s.input.from}:${s.start.line}:${s.start.column}$&`);
        }
        return error;
    }
    after(add) {
        this.parent.insertAfter(this, add);
        return this;
    }
    assign(overrides = {}) {
        for(let name in overrides)this[name] = overrides[name];
        return this;
    }
    before(add) {
        this.parent.insertBefore(this, add);
        return this;
    }
    cleanRaws(keepBetween) {
        delete this.raws.before;
        delete this.raws.after;
        if (!keepBetween) delete this.raws.between;
    }
    clone(overrides = {}) {
        let cloned = $a86fcc2c0b06d3d6$var$cloneNode(this);
        for(let name in overrides)cloned[name] = overrides[name];
        return cloned;
    }
    cloneAfter(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertAfter(this, cloned);
        return cloned;
    }
    cloneBefore(overrides = {}) {
        let cloned = this.clone(overrides);
        this.parent.insertBefore(this, cloned);
        return cloned;
    }
    error(message, opts = {}) {
        if (this.source) {
            let { end: end, start: start } = this.rangeBy(opts);
            return this.source.input.error(message, {
                column: start.column,
                line: start.line
            }, {
                column: end.column,
                line: end.line
            }, opts);
        }
        return new $1ef91c4708632651$exports(message);
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (prop === "root") return ()=>node.root().toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "prop" || prop === "value" || prop === "name" || prop === "params" || prop === "important" || /* c8 ignore next */ prop === "text") node.markDirty();
                return true;
            }
        };
    }
    markDirty() {
        if (this[$a86fcc2c0b06d3d6$require$isClean]) {
            this[$a86fcc2c0b06d3d6$require$isClean] = false;
            let next = this;
            while(next = next.parent)next[$a86fcc2c0b06d3d6$require$isClean] = false;
        }
    }
    next() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index + 1];
    }
    positionBy(opts, stringRepresentation) {
        let pos = this.source.start;
        if (opts.index) pos = this.positionInside(opts.index, stringRepresentation);
        else if (opts.word) {
            stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) pos = this.positionInside(index, stringRepresentation);
        }
        return pos;
    }
    positionInside(index, stringRepresentation) {
        let string = stringRepresentation || this.toString();
        let column = this.source.start.column;
        let line = this.source.start.line;
        for(let i = 0; i < index; i++)if (string[i] === "\n") {
            column = 1;
            line += 1;
        } else column += 1;
        return {
            column: column,
            line: line
        };
    }
    prev() {
        if (!this.parent) return undefined;
        let index = this.parent.index(this);
        return this.parent.nodes[index - 1];
    }
    rangeBy(opts) {
        let start = {
            column: this.source.start.column,
            line: this.source.start.line
        };
        let end = this.source.end ? {
            column: this.source.end.column + 1,
            line: this.source.end.line
        } : {
            column: start.column + 1,
            line: start.line
        };
        if (opts.word) {
            let stringRepresentation = this.toString();
            let index = stringRepresentation.indexOf(opts.word);
            if (index !== -1) {
                start = this.positionInside(index, stringRepresentation);
                end = this.positionInside(index + opts.word.length, stringRepresentation);
            }
        } else {
            if (opts.start) start = {
                column: opts.start.column,
                line: opts.start.line
            };
            else if (opts.index) start = this.positionInside(opts.index);
            if (opts.end) end = {
                column: opts.end.column,
                line: opts.end.line
            };
            else if (opts.endIndex) end = this.positionInside(opts.endIndex);
            else if (opts.index) end = this.positionInside(opts.index + 1);
        }
        if (end.line < start.line || end.line === start.line && end.column <= start.column) end = {
            column: start.column + 1,
            line: start.line
        };
        return {
            end: end,
            start: start
        };
    }
    raw(prop, defaultType) {
        let str = new $cf4b226eac7ecd1f$exports();
        return str.raw(this, prop, defaultType);
    }
    remove() {
        if (this.parent) this.parent.removeChild(this);
        this.parent = undefined;
        return this;
    }
    replaceWith(...nodes) {
        if (this.parent) {
            let bookmark = this;
            let foundSelf = false;
            for (let node of nodes){
                if (node === this) foundSelf = true;
                else if (foundSelf) {
                    this.parent.insertAfter(bookmark, node);
                    bookmark = node;
                } else this.parent.insertBefore(bookmark, node);
            }
            if (!foundSelf) this.remove();
        }
        return this;
    }
    root() {
        let result = this;
        while(result.parent && result.parent.type !== "document")result = result.parent;
        return result;
    }
    toJSON(_, inputs) {
        let fixed = {};
        let emitInputs = inputs == null;
        inputs = inputs || new Map();
        let inputsNextIndex = 0;
        for(let name in this){
            if (!Object.prototype.hasOwnProperty.call(this, name)) continue;
            if (name === "parent" || name === "proxyCache") continue;
            let value = this[name];
            if (Array.isArray(value)) fixed[name] = value.map((i)=>{
                if (typeof i === "object" && i.toJSON) return i.toJSON(null, inputs);
                else return i;
            });
            else if (typeof value === "object" && value.toJSON) fixed[name] = value.toJSON(null, inputs);
            else if (name === "source") {
                let inputId = inputs.get(value.input);
                if (inputId == null) {
                    inputId = inputsNextIndex;
                    inputs.set(value.input, inputsNextIndex);
                    inputsNextIndex++;
                }
                fixed[name] = {
                    end: value.end,
                    inputId: inputId,
                    start: value.start
                };
            } else fixed[name] = value;
        }
        if (emitInputs) fixed.inputs = [
            ...inputs.keys()
        ].map((input)=>input.toJSON());
        return fixed;
    }
    toProxy() {
        if (!this.proxyCache) this.proxyCache = new Proxy(this, this.getProxyProcessor());
        return this.proxyCache;
    }
    toString(stringifier = $9d5cc43a7e8041f7$exports) {
        if (stringifier.stringify) stringifier = stringifier.stringify;
        let result = "";
        stringifier(this, (i)=>{
            result += i;
        });
        return result;
    }
    warn(result, text, opts) {
        let data = {
            node: this
        };
        for(let i in opts)data[i] = opts[i];
        return result.warn(text, data);
    }
    get proxyOf() {
        return this;
    }
}
$a86fcc2c0b06d3d6$exports = $a86fcc2c0b06d3d6$var$Node;
$a86fcc2c0b06d3d6$var$Node.default = $a86fcc2c0b06d3d6$var$Node;


class $f96b5e8a06a46319$var$Declaration extends $a86fcc2c0b06d3d6$exports {
    constructor(defaults){
        if (defaults && typeof defaults.value !== "undefined" && typeof defaults.value !== "string") defaults = {
            ...defaults,
            value: String(defaults.value)
        };
        super(defaults);
        this.type = "decl";
    }
    get variable() {
        return this.prop.startsWith("--") || this.prop[0] === "$";
    }
}
$f96b5e8a06a46319$exports = $f96b5e8a06a46319$var$Declaration;
$f96b5e8a06a46319$var$Declaration.default = $f96b5e8a06a46319$var$Declaration;


var $a0c4a455532e6de7$exports = {};
"use strict";

var $a0c4a455532e6de7$require$isClean = $35608d4e1c63af4a$export$ae5e7911ce0728f9;
var $a0c4a455532e6de7$require$my = $35608d4e1c63af4a$export$94fa0a6beb22f989;
var $7d09741193654ec2$exports = {};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $e0f2ccdfb5ca0469$export$a143d493d941bafc;
var $e0f2ccdfb5ca0469$export$e4cf37d7f6fb9e0a;
var $e0f2ccdfb5ca0469$export$f99ded8fe4b79145;
var $e0f2ccdfb5ca0469$export$599f31c3813fae4d;
"use strict";
var $822d12052748efa5$export$a48f0734ac7c2329;
var $822d12052748efa5$export$d622b2ad8d90c771;
var $822d12052748efa5$export$6100ba28696e12de;
"use strict";
$822d12052748efa5$export$a48f0734ac7c2329 = $822d12052748efa5$var$byteLength;
$822d12052748efa5$export$d622b2ad8d90c771 = $822d12052748efa5$var$toByteArray;
$822d12052748efa5$export$6100ba28696e12de = $822d12052748efa5$var$fromByteArray;
var $822d12052748efa5$var$lookup = [];
var $822d12052748efa5$var$revLookup = [];
var $822d12052748efa5$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $822d12052748efa5$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $822d12052748efa5$var$i = 0, $822d12052748efa5$var$len = $822d12052748efa5$var$code.length; $822d12052748efa5$var$i < $822d12052748efa5$var$len; ++$822d12052748efa5$var$i){
    $822d12052748efa5$var$lookup[$822d12052748efa5$var$i] = $822d12052748efa5$var$code[$822d12052748efa5$var$i];
    $822d12052748efa5$var$revLookup[$822d12052748efa5$var$code.charCodeAt($822d12052748efa5$var$i)] = $822d12052748efa5$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$822d12052748efa5$var$revLookup["-".charCodeAt(0)] = 62;
$822d12052748efa5$var$revLookup["_".charCodeAt(0)] = 63;
function $822d12052748efa5$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $822d12052748efa5$var$byteLength(b64) {
    var lens = $822d12052748efa5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $822d12052748efa5$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $822d12052748efa5$var$toByteArray(b64) {
    var tmp;
    var lens = $822d12052748efa5$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $822d12052748efa5$var$Arr($822d12052748efa5$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $822d12052748efa5$var$revLookup[b64.charCodeAt(i)] << 18 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $822d12052748efa5$var$revLookup[b64.charCodeAt(i)] << 2 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $822d12052748efa5$var$revLookup[b64.charCodeAt(i)] << 10 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $822d12052748efa5$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $822d12052748efa5$var$tripletToBase64(num) {
    return $822d12052748efa5$var$lookup[num >> 18 & 0x3F] + $822d12052748efa5$var$lookup[num >> 12 & 0x3F] + $822d12052748efa5$var$lookup[num >> 6 & 0x3F] + $822d12052748efa5$var$lookup[num & 0x3F];
}
function $822d12052748efa5$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($822d12052748efa5$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $822d12052748efa5$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($822d12052748efa5$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($822d12052748efa5$var$lookup[tmp >> 2] + $822d12052748efa5$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($822d12052748efa5$var$lookup[tmp >> 10] + $822d12052748efa5$var$lookup[tmp >> 4 & 0x3F] + $822d12052748efa5$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $ea78cb4e94440f2a$export$aafa59e2e03f2942;
var $ea78cb4e94440f2a$export$68d8715fc104d294;
$ea78cb4e94440f2a$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$ea78cb4e94440f2a$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $e0f2ccdfb5ca0469$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$e0f2ccdfb5ca0469$export$a143d493d941bafc = $e0f2ccdfb5ca0469$var$Buffer;
$e0f2ccdfb5ca0469$export$e4cf37d7f6fb9e0a = $e0f2ccdfb5ca0469$var$SlowBuffer;
$e0f2ccdfb5ca0469$export$f99ded8fe4b79145 = 50;
const $e0f2ccdfb5ca0469$var$K_MAX_LENGTH = 0x7fffffff;
$e0f2ccdfb5ca0469$export$599f31c3813fae4d = $e0f2ccdfb5ca0469$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $e0f2ccdfb5ca0469$var$Buffer.TYPED_ARRAY_SUPPORT = $e0f2ccdfb5ca0469$var$typedArraySupport();
if (!$e0f2ccdfb5ca0469$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $e0f2ccdfb5ca0469$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($e0f2ccdfb5ca0469$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($e0f2ccdfb5ca0469$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $e0f2ccdfb5ca0469$var$createBuffer(length) {
    if (length > $e0f2ccdfb5ca0469$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $e0f2ccdfb5ca0469$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $e0f2ccdfb5ca0469$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $e0f2ccdfb5ca0469$var$allocUnsafe(arg);
    }
    return $e0f2ccdfb5ca0469$var$from(arg, encodingOrOffset, length);
}
$e0f2ccdfb5ca0469$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $e0f2ccdfb5ca0469$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $e0f2ccdfb5ca0469$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $e0f2ccdfb5ca0469$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($e0f2ccdfb5ca0469$var$isInstance(value, ArrayBuffer) || value && $e0f2ccdfb5ca0469$var$isInstance(value.buffer, ArrayBuffer)) return $e0f2ccdfb5ca0469$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($e0f2ccdfb5ca0469$var$isInstance(value, SharedArrayBuffer) || value && $e0f2ccdfb5ca0469$var$isInstance(value.buffer, SharedArrayBuffer))) return $e0f2ccdfb5ca0469$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $e0f2ccdfb5ca0469$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $e0f2ccdfb5ca0469$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $e0f2ccdfb5ca0469$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $e0f2ccdfb5ca0469$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $e0f2ccdfb5ca0469$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($e0f2ccdfb5ca0469$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($e0f2ccdfb5ca0469$var$Buffer, Uint8Array);
function $e0f2ccdfb5ca0469$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $e0f2ccdfb5ca0469$var$alloc(size, fill, encoding) {
    $e0f2ccdfb5ca0469$var$assertSize(size);
    if (size <= 0) return $e0f2ccdfb5ca0469$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $e0f2ccdfb5ca0469$var$createBuffer(size).fill(fill, encoding) : $e0f2ccdfb5ca0469$var$createBuffer(size).fill(fill);
    return $e0f2ccdfb5ca0469$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $e0f2ccdfb5ca0469$var$Buffer.alloc = function(size, fill, encoding) {
    return $e0f2ccdfb5ca0469$var$alloc(size, fill, encoding);
};
function $e0f2ccdfb5ca0469$var$allocUnsafe(size) {
    $e0f2ccdfb5ca0469$var$assertSize(size);
    return $e0f2ccdfb5ca0469$var$createBuffer(size < 0 ? 0 : $e0f2ccdfb5ca0469$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $e0f2ccdfb5ca0469$var$Buffer.allocUnsafe = function(size) {
    return $e0f2ccdfb5ca0469$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $e0f2ccdfb5ca0469$var$Buffer.allocUnsafeSlow = function(size) {
    return $e0f2ccdfb5ca0469$var$allocUnsafe(size);
};
function $e0f2ccdfb5ca0469$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$e0f2ccdfb5ca0469$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $e0f2ccdfb5ca0469$var$byteLength(string, encoding) | 0;
    let buf = $e0f2ccdfb5ca0469$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $e0f2ccdfb5ca0469$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $e0f2ccdfb5ca0469$var$checked(array.length) | 0;
    const buf = $e0f2ccdfb5ca0469$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $e0f2ccdfb5ca0469$var$fromArrayView(arrayView) {
    if ($e0f2ccdfb5ca0469$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $e0f2ccdfb5ca0469$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $e0f2ccdfb5ca0469$var$fromArrayLike(arrayView);
}
function $e0f2ccdfb5ca0469$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $e0f2ccdfb5ca0469$var$Buffer.prototype);
    return buf;
}
function $e0f2ccdfb5ca0469$var$fromObject(obj) {
    if ($e0f2ccdfb5ca0469$var$Buffer.isBuffer(obj)) {
        const len = $e0f2ccdfb5ca0469$var$checked(obj.length) | 0;
        const buf = $e0f2ccdfb5ca0469$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $e0f2ccdfb5ca0469$var$numberIsNaN(obj.length)) return $e0f2ccdfb5ca0469$var$createBuffer(0);
        return $e0f2ccdfb5ca0469$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $e0f2ccdfb5ca0469$var$fromArrayLike(obj.data);
}
function $e0f2ccdfb5ca0469$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $e0f2ccdfb5ca0469$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $e0f2ccdfb5ca0469$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $e0f2ccdfb5ca0469$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $e0f2ccdfb5ca0469$var$Buffer.alloc(+length);
}
$e0f2ccdfb5ca0469$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $e0f2ccdfb5ca0469$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$e0f2ccdfb5ca0469$var$Buffer.compare = function compare(a, b) {
    if ($e0f2ccdfb5ca0469$var$isInstance(a, Uint8Array)) a = $e0f2ccdfb5ca0469$var$Buffer.from(a, a.offset, a.byteLength);
    if ($e0f2ccdfb5ca0469$var$isInstance(b, Uint8Array)) b = $e0f2ccdfb5ca0469$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(a) || !$e0f2ccdfb5ca0469$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$e0f2ccdfb5ca0469$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$e0f2ccdfb5ca0469$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $e0f2ccdfb5ca0469$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $e0f2ccdfb5ca0469$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($e0f2ccdfb5ca0469$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(buf)) buf = $e0f2ccdfb5ca0469$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $e0f2ccdfb5ca0469$var$byteLength(string, encoding) {
    if ($e0f2ccdfb5ca0469$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $e0f2ccdfb5ca0469$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $e0f2ccdfb5ca0469$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $e0f2ccdfb5ca0469$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $e0f2ccdfb5ca0469$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$e0f2ccdfb5ca0469$var$Buffer.byteLength = $e0f2ccdfb5ca0469$var$byteLength;
function $e0f2ccdfb5ca0469$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $e0f2ccdfb5ca0469$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $e0f2ccdfb5ca0469$var$utf8Slice(this, start, end);
        case "ascii":
            return $e0f2ccdfb5ca0469$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $e0f2ccdfb5ca0469$var$latin1Slice(this, start, end);
        case "base64":
            return $e0f2ccdfb5ca0469$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e0f2ccdfb5ca0469$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$e0f2ccdfb5ca0469$var$Buffer.prototype._isBuffer = true;
function $e0f2ccdfb5ca0469$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$e0f2ccdfb5ca0469$var$swap(this, i, i + 1);
    return this;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $e0f2ccdfb5ca0469$var$swap(this, i, i + 3);
        $e0f2ccdfb5ca0469$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $e0f2ccdfb5ca0469$var$swap(this, i, i + 7);
        $e0f2ccdfb5ca0469$var$swap(this, i + 1, i + 6);
        $e0f2ccdfb5ca0469$var$swap(this, i + 2, i + 5);
        $e0f2ccdfb5ca0469$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $e0f2ccdfb5ca0469$var$utf8Slice(this, 0, length);
    return $e0f2ccdfb5ca0469$var$slowToString.apply(this, arguments);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.toLocaleString = $e0f2ccdfb5ca0469$var$Buffer.prototype.toString;
$e0f2ccdfb5ca0469$var$Buffer.prototype.equals = function equals(b) {
    if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $e0f2ccdfb5ca0469$var$Buffer.compare(this, b) === 0;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $e0f2ccdfb5ca0469$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($e0f2ccdfb5ca0469$var$customInspectSymbol) $e0f2ccdfb5ca0469$var$Buffer.prototype[$e0f2ccdfb5ca0469$var$customInspectSymbol] = $e0f2ccdfb5ca0469$var$Buffer.prototype.inspect;
$e0f2ccdfb5ca0469$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($e0f2ccdfb5ca0469$var$isInstance(target, Uint8Array)) target = $e0f2ccdfb5ca0469$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $e0f2ccdfb5ca0469$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($e0f2ccdfb5ca0469$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $e0f2ccdfb5ca0469$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($e0f2ccdfb5ca0469$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $e0f2ccdfb5ca0469$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $e0f2ccdfb5ca0469$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $e0f2ccdfb5ca0469$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $e0f2ccdfb5ca0469$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $e0f2ccdfb5ca0469$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $e0f2ccdfb5ca0469$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($e0f2ccdfb5ca0469$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $e0f2ccdfb5ca0469$var$utf8Write(buf, string, offset, length) {
    return $e0f2ccdfb5ca0469$var$blitBuffer($e0f2ccdfb5ca0469$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $e0f2ccdfb5ca0469$var$asciiWrite(buf, string, offset, length) {
    return $e0f2ccdfb5ca0469$var$blitBuffer($e0f2ccdfb5ca0469$var$asciiToBytes(string), buf, offset, length);
}
function $e0f2ccdfb5ca0469$var$base64Write(buf, string, offset, length) {
    return $e0f2ccdfb5ca0469$var$blitBuffer($e0f2ccdfb5ca0469$var$base64ToBytes(string), buf, offset, length);
}
function $e0f2ccdfb5ca0469$var$ucs2Write(buf, string, offset, length) {
    return $e0f2ccdfb5ca0469$var$blitBuffer($e0f2ccdfb5ca0469$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $e0f2ccdfb5ca0469$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $e0f2ccdfb5ca0469$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $e0f2ccdfb5ca0469$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $e0f2ccdfb5ca0469$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $e0f2ccdfb5ca0469$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $e0f2ccdfb5ca0469$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $822d12052748efa5$export$6100ba28696e12de(buf);
    else return $822d12052748efa5$export$6100ba28696e12de(buf.slice(start, end));
}
function $e0f2ccdfb5ca0469$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $e0f2ccdfb5ca0469$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $e0f2ccdfb5ca0469$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $e0f2ccdfb5ca0469$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $e0f2ccdfb5ca0469$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $e0f2ccdfb5ca0469$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $e0f2ccdfb5ca0469$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $e0f2ccdfb5ca0469$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $e0f2ccdfb5ca0469$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $e0f2ccdfb5ca0469$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $e0f2ccdfb5ca0469$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $e0f2ccdfb5ca0469$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $e0f2ccdfb5ca0469$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUintLE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUintBE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUint8 = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUint16LE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUint16BE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUint32LE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readUint32BE = $e0f2ccdfb5ca0469$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readBigUInt64LE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $e0f2ccdfb5ca0469$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e0f2ccdfb5ca0469$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.readBigUInt64BE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $e0f2ccdfb5ca0469$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e0f2ccdfb5ca0469$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readBigInt64LE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $e0f2ccdfb5ca0469$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e0f2ccdfb5ca0469$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.readBigInt64BE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $e0f2ccdfb5ca0469$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $e0f2ccdfb5ca0469$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return $ea78cb4e94440f2a$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 4, this.length);
    return $ea78cb4e94440f2a$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 8, this.length);
    return $ea78cb4e94440f2a$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkOffset(offset, 8, this.length);
    return $ea78cb4e94440f2a$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $e0f2ccdfb5ca0469$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUintLE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUintBE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUint8 = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUint16LE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUint16BE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUint32LE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeUint32BE = $e0f2ccdfb5ca0469$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $e0f2ccdfb5ca0469$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $e0f2ccdfb5ca0469$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $e0f2ccdfb5ca0469$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $e0f2ccdfb5ca0469$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeBigUInt64LE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $e0f2ccdfb5ca0469$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeBigUInt64BE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $e0f2ccdfb5ca0469$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeBigInt64LE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $e0f2ccdfb5ca0469$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeBigInt64BE = $e0f2ccdfb5ca0469$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $e0f2ccdfb5ca0469$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $e0f2ccdfb5ca0469$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $e0f2ccdfb5ca0469$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ea78cb4e94440f2a$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $e0f2ccdfb5ca0469$var$writeFloat(this, value, offset, true, noAssert);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $e0f2ccdfb5ca0469$var$writeFloat(this, value, offset, false, noAssert);
};
function $e0f2ccdfb5ca0469$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $e0f2ccdfb5ca0469$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ea78cb4e94440f2a$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $e0f2ccdfb5ca0469$var$writeDouble(this, value, offset, true, noAssert);
};
$e0f2ccdfb5ca0469$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $e0f2ccdfb5ca0469$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$e0f2ccdfb5ca0469$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$e0f2ccdfb5ca0469$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$e0f2ccdfb5ca0469$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$e0f2ccdfb5ca0469$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $e0f2ccdfb5ca0469$var$Buffer.isBuffer(val) ? val : $e0f2ccdfb5ca0469$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $e0f2ccdfb5ca0469$var$errors = {};
function $e0f2ccdfb5ca0469$var$E(sym, getMessage, Base) {
    $e0f2ccdfb5ca0469$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$e0f2ccdfb5ca0469$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$e0f2ccdfb5ca0469$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$e0f2ccdfb5ca0469$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $e0f2ccdfb5ca0469$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $e0f2ccdfb5ca0469$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $e0f2ccdfb5ca0469$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $e0f2ccdfb5ca0469$var$checkBounds(buf, offset, byteLength) {
    $e0f2ccdfb5ca0469$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $e0f2ccdfb5ca0469$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $e0f2ccdfb5ca0469$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $e0f2ccdfb5ca0469$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $e0f2ccdfb5ca0469$var$checkBounds(buf, offset, byteLength);
}
function $e0f2ccdfb5ca0469$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $e0f2ccdfb5ca0469$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $e0f2ccdfb5ca0469$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $e0f2ccdfb5ca0469$var$validateNumber(value, type);
        throw new $e0f2ccdfb5ca0469$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $e0f2ccdfb5ca0469$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $e0f2ccdfb5ca0469$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $e0f2ccdfb5ca0469$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $e0f2ccdfb5ca0469$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($e0f2ccdfb5ca0469$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $e0f2ccdfb5ca0469$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $e0f2ccdfb5ca0469$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $e0f2ccdfb5ca0469$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $e0f2ccdfb5ca0469$var$base64ToBytes(str) {
    return $822d12052748efa5$export$d622b2ad8d90c771($e0f2ccdfb5ca0469$var$base64clean(str));
}
function $e0f2ccdfb5ca0469$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $e0f2ccdfb5ca0469$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $e0f2ccdfb5ca0469$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $e0f2ccdfb5ca0469$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $e0f2ccdfb5ca0469$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $e0f2ccdfb5ca0469$var$BufferBigIntNotDefined : fn;
}
function $e0f2ccdfb5ca0469$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $7d09741193654ec2$require$Buffer = $e0f2ccdfb5ca0469$export$a143d493d941bafc;
"use strict";

var $7d09741193654ec2$require$SourceMapConsumer = $fe2a6b54d849136b$exports.SourceMapConsumer;
var $7d09741193654ec2$require$SourceMapGenerator = $fe2a6b54d849136b$exports.SourceMapGenerator;

var $7d09741193654ec2$require$dirname = $fe2a6b54d849136b$exports.dirname;
var $7d09741193654ec2$require$relative = $fe2a6b54d849136b$exports.relative;
var $7d09741193654ec2$require$resolve = $fe2a6b54d849136b$exports.resolve;
var $7d09741193654ec2$require$sep = $fe2a6b54d849136b$exports.sep;

var $7d09741193654ec2$require$pathToFileURL = $fe2a6b54d849136b$exports.pathToFileURL;
var $bd2a9823f230228f$exports = {};
"use strict";

var $bd2a9823f230228f$require$SourceMapConsumer = $fe2a6b54d849136b$exports.SourceMapConsumer;
var $bd2a9823f230228f$require$SourceMapGenerator = $fe2a6b54d849136b$exports.SourceMapGenerator;

var $bd2a9823f230228f$require$fileURLToPath = $fe2a6b54d849136b$exports.fileURLToPath;
var $bd2a9823f230228f$require$pathToFileURL = $fe2a6b54d849136b$exports.pathToFileURL;

var $bd2a9823f230228f$require$isAbsolute = $fe2a6b54d849136b$exports.isAbsolute;
var $bd2a9823f230228f$require$resolve = $fe2a6b54d849136b$exports.resolve;
var $0f57fad87e240a2f$exports = {};
let $0f57fad87e240a2f$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $0f57fad87e240a2f$var$customAlphabet = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $0f57fad87e240a2f$var$nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $0f57fad87e240a2f$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
$0f57fad87e240a2f$exports = {
    nanoid: $0f57fad87e240a2f$var$nanoid,
    customAlphabet: $0f57fad87e240a2f$var$customAlphabet
};


var $bd2a9823f230228f$require$nanoid = $0f57fad87e240a2f$exports.nanoid;


var $696a2f669b51b36f$exports = {};

var $696a2f669b51b36f$require$Buffer = $e0f2ccdfb5ca0469$export$a143d493d941bafc;
"use strict";

var $696a2f669b51b36f$require$SourceMapConsumer = $fe2a6b54d849136b$exports.SourceMapConsumer;
var $696a2f669b51b36f$require$SourceMapGenerator = $fe2a6b54d849136b$exports.SourceMapGenerator;

var $696a2f669b51b36f$require$existsSync = $fe2a6b54d849136b$exports.existsSync;
var $696a2f669b51b36f$require$readFileSync = $fe2a6b54d849136b$exports.readFileSync;

var $696a2f669b51b36f$require$dirname = $fe2a6b54d849136b$exports.dirname;
var $696a2f669b51b36f$require$join = $fe2a6b54d849136b$exports.join;
function $696a2f669b51b36f$var$fromBase64(str) {
    if ($696a2f669b51b36f$require$Buffer) return $696a2f669b51b36f$require$Buffer.from(str, "base64").toString();
    else /* c8 ignore next 2 */ return window.atob(str);
}
class $696a2f669b51b36f$var$PreviousMap {
    constructor(css, opts){
        if (opts.map === false) return;
        this.loadAnnotation(css);
        this.inline = this.startWith(this.annotation, "data:");
        let prev = opts.map ? opts.map.prev : undefined;
        let text = this.loadMap(opts.from, prev);
        if (!this.mapFile && opts.from) this.mapFile = opts.from;
        if (this.mapFile) this.root = $696a2f669b51b36f$require$dirname(this.mapFile);
        if (text) this.text = text;
    }
    consumer() {
        if (!this.consumerCache) this.consumerCache = new $696a2f669b51b36f$require$SourceMapConsumer(this.text);
        return this.consumerCache;
    }
    decodeInline(text) {
        let baseCharsetUri = /^data:application\/json;charset=utf-?8;base64,/;
        let baseUri = /^data:application\/json;base64,/;
        let charsetUri = /^data:application\/json;charset=utf-?8,/;
        let uri = /^data:application\/json,/;
        if (charsetUri.test(text) || uri.test(text)) return decodeURIComponent(text.substr(RegExp.lastMatch.length));
        if (baseCharsetUri.test(text) || baseUri.test(text)) return $696a2f669b51b36f$var$fromBase64(text.substr(RegExp.lastMatch.length));
        let encoding = text.match(/data:application\/json;([^,]+),/)[1];
        throw new Error("Unsupported source map encoding " + encoding);
    }
    getAnnotationURL(sourceMapString) {
        return sourceMapString.replace(/^\/\*\s*# sourceMappingURL=/, "").trim();
    }
    isMap(map) {
        if (typeof map !== "object") return false;
        return typeof map.mappings === "string" || typeof map._mappings === "string" || Array.isArray(map.sections);
    }
    loadAnnotation(css) {
        let comments = css.match(/\/\*\s*# sourceMappingURL=/gm);
        if (!comments) return;
        // sourceMappingURLs from comments, strings, etc.
        let start = css.lastIndexOf(comments.pop());
        let end = css.indexOf("*/", start);
        if (start > -1 && end > -1) // Locate the last sourceMappingURL to avoid pickin
        this.annotation = this.getAnnotationURL(css.substring(start, end));
    }
    loadFile(path) {
        this.root = $696a2f669b51b36f$require$dirname(path);
        if ($696a2f669b51b36f$require$existsSync(path)) {
            this.mapFile = path;
            return $696a2f669b51b36f$require$readFileSync(path, "utf-8").toString().trim();
        }
    }
    loadMap(file, prev) {
        if (prev === false) return false;
        if (prev) {
            if (typeof prev === "string") return prev;
            else if (typeof prev === "function") {
                let prevPath = prev(file);
                if (prevPath) {
                    let map = this.loadFile(prevPath);
                    if (!map) throw new Error("Unable to load previous source map: " + prevPath.toString());
                    return map;
                }
            } else if (prev instanceof $696a2f669b51b36f$require$SourceMapConsumer) return $696a2f669b51b36f$require$SourceMapGenerator.fromSourceMap(prev).toString();
            else if (prev instanceof $696a2f669b51b36f$require$SourceMapGenerator) return prev.toString();
            else if (this.isMap(prev)) return JSON.stringify(prev);
            else throw new Error("Unsupported previous source map format: " + prev.toString());
        } else if (this.inline) return this.decodeInline(this.annotation);
        else if (this.annotation) {
            let map = this.annotation;
            if (file) map = $696a2f669b51b36f$require$join($696a2f669b51b36f$require$dirname(file), map);
            return this.loadFile(map);
        }
    }
    startWith(string, start) {
        if (!string) return false;
        return string.substr(0, start.length) === start;
    }
    withContent() {
        return !!(this.consumer().sourcesContent && this.consumer().sourcesContent.length > 0);
    }
}
$696a2f669b51b36f$exports = $696a2f669b51b36f$var$PreviousMap;
$696a2f669b51b36f$var$PreviousMap.default = $696a2f669b51b36f$var$PreviousMap;


let $bd2a9823f230228f$var$fromOffsetCache = Symbol("fromOffsetCache");
let $bd2a9823f230228f$var$sourceMapAvailable = Boolean($bd2a9823f230228f$require$SourceMapConsumer && $bd2a9823f230228f$require$SourceMapGenerator);
let $bd2a9823f230228f$var$pathAvailable = Boolean($bd2a9823f230228f$require$resolve && $bd2a9823f230228f$require$isAbsolute);
class $bd2a9823f230228f$var$Input {
    constructor(css, opts = {}){
        if (css === null || typeof css === "undefined" || typeof css === "object" && !css.toString) throw new Error(`PostCSS received ${css} instead of CSS string`);
        this.css = css.toString();
        if (this.css[0] === "\uFEFF" || this.css[0] === "\uFFFE") {
            this.hasBOM = true;
            this.css = this.css.slice(1);
        } else this.hasBOM = false;
        if (opts.from) {
            if (!$bd2a9823f230228f$var$pathAvailable || /^\w+:\/\//.test(opts.from) || $bd2a9823f230228f$require$isAbsolute(opts.from)) this.file = opts.from;
            else this.file = $bd2a9823f230228f$require$resolve(opts.from);
        }
        if ($bd2a9823f230228f$var$pathAvailable && $bd2a9823f230228f$var$sourceMapAvailable) {
            let map = new $696a2f669b51b36f$exports(this.css, opts);
            if (map.text) {
                this.map = map;
                let file = map.consumer().file;
                if (!this.file && file) this.file = this.mapResolve(file);
            }
        }
        if (!this.file) this.id = "<input css " + $bd2a9823f230228f$require$nanoid(6) + ">";
        if (this.map) this.map.file = this.from;
    }
    error(message, line, column, opts = {}) {
        let result, endLine, endColumn;
        if (line && typeof line === "object") {
            let start = line;
            let end = column;
            if (typeof start.offset === "number") {
                let pos = this.fromOffset(start.offset);
                line = pos.line;
                column = pos.col;
            } else {
                line = start.line;
                column = start.column;
            }
            if (typeof end.offset === "number") {
                let pos = this.fromOffset(end.offset);
                endLine = pos.line;
                endColumn = pos.col;
            } else {
                endLine = end.line;
                endColumn = end.column;
            }
        } else if (!column) {
            let pos = this.fromOffset(line);
            line = pos.line;
            column = pos.col;
        }
        let origin = this.origin(line, column, endLine, endColumn);
        if (origin) result = new $1ef91c4708632651$exports(message, origin.endLine === undefined ? origin.line : {
            column: origin.column,
            line: origin.line
        }, origin.endLine === undefined ? origin.column : {
            column: origin.endColumn,
            line: origin.endLine
        }, origin.source, origin.file, opts.plugin);
        else result = new $1ef91c4708632651$exports(message, endLine === undefined ? line : {
            column: column,
            line: line
        }, endLine === undefined ? column : {
            column: endColumn,
            line: endLine
        }, this.css, this.file, opts.plugin);
        result.input = {
            column: column,
            endColumn: endColumn,
            endLine: endLine,
            line: line,
            source: this.css
        };
        if (this.file) {
            if ($bd2a9823f230228f$require$pathToFileURL) result.input.url = $bd2a9823f230228f$require$pathToFileURL(this.file).toString();
            result.input.file = this.file;
        }
        return result;
    }
    fromOffset(offset) {
        let lastLine, lineToIndex;
        if (!this[$bd2a9823f230228f$var$fromOffsetCache]) {
            let lines = this.css.split("\n");
            lineToIndex = new Array(lines.length);
            let prevIndex = 0;
            for(let i = 0, l = lines.length; i < l; i++){
                lineToIndex[i] = prevIndex;
                prevIndex += lines[i].length + 1;
            }
            this[$bd2a9823f230228f$var$fromOffsetCache] = lineToIndex;
        } else lineToIndex = this[$bd2a9823f230228f$var$fromOffsetCache];
        lastLine = lineToIndex[lineToIndex.length - 1];
        let min = 0;
        if (offset >= lastLine) min = lineToIndex.length - 1;
        else {
            let max = lineToIndex.length - 2;
            let mid;
            while(min < max){
                mid = min + (max - min >> 1);
                if (offset < lineToIndex[mid]) max = mid - 1;
                else if (offset >= lineToIndex[mid + 1]) min = mid + 1;
                else {
                    min = mid;
                    break;
                }
            }
        }
        return {
            col: offset - lineToIndex[min] + 1,
            line: min + 1
        };
    }
    mapResolve(file) {
        if (/^\w+:\/\//.test(file)) return file;
        return $bd2a9823f230228f$require$resolve(this.map.consumer().sourceRoot || this.map.root || ".", file);
    }
    origin(line, column, endLine, endColumn) {
        if (!this.map) return false;
        let consumer = this.map.consumer();
        let from = consumer.originalPositionFor({
            column: column,
            line: line
        });
        if (!from.source) return false;
        let to;
        if (typeof endLine === "number") to = consumer.originalPositionFor({
            column: endColumn,
            line: endLine
        });
        let fromUrl;
        if ($bd2a9823f230228f$require$isAbsolute(from.source)) fromUrl = $bd2a9823f230228f$require$pathToFileURL(from.source);
        else fromUrl = new URL(from.source, this.map.consumer().sourceRoot || $bd2a9823f230228f$require$pathToFileURL(this.map.mapFile));
        let result = {
            column: from.column,
            endColumn: to && to.column,
            endLine: to && to.line,
            line: from.line,
            url: fromUrl.toString()
        };
        if (fromUrl.protocol === "file:") {
            if ($bd2a9823f230228f$require$fileURLToPath) result.file = $bd2a9823f230228f$require$fileURLToPath(fromUrl);
            else /* c8 ignore next 2 */ throw new Error(`file: protocol is not available in this PostCSS build`);
        }
        let source = consumer.sourceContentFor(from.source);
        if (source) result.source = source;
        return result;
    }
    toJSON() {
        let json = {};
        for (let name of [
            "hasBOM",
            "css",
            "file",
            "id"
        ])if (this[name] != null) json[name] = this[name];
        if (this.map) {
            json.map = {
                ...this.map
            };
            if (json.map.consumerCache) json.map.consumerCache = undefined;
        }
        return json;
    }
    get from() {
        return this.file || this.id;
    }
}
$bd2a9823f230228f$exports = $bd2a9823f230228f$var$Input;
$bd2a9823f230228f$var$Input.default = $bd2a9823f230228f$var$Input;
if ($fe2a6b54d849136b$exports && $fe2a6b54d849136b$exports.registerInput) $fe2a6b54d849136b$exports.registerInput($bd2a9823f230228f$var$Input);


let $7d09741193654ec2$var$sourceMapAvailable = Boolean($7d09741193654ec2$require$SourceMapConsumer && $7d09741193654ec2$require$SourceMapGenerator);
let $7d09741193654ec2$var$pathAvailable = Boolean($7d09741193654ec2$require$dirname && $7d09741193654ec2$require$resolve && $7d09741193654ec2$require$relative && $7d09741193654ec2$require$sep);
class $7d09741193654ec2$var$MapGenerator {
    constructor(stringify, root, opts, cssString){
        this.stringify = stringify;
        this.mapOpts = opts.map || {};
        this.root = root;
        this.opts = opts;
        this.css = cssString;
        this.usesFileUrls = !this.mapOpts.from && this.mapOpts.absolute;
        this.memoizedFileURLs = new Map();
        this.memoizedPaths = new Map();
        this.memoizedURLs = new Map();
    }
    addAnnotation() {
        let content;
        if (this.isInline()) content = "data:application/json;base64," + this.toBase64(this.map.toString());
        else if (typeof this.mapOpts.annotation === "string") content = this.mapOpts.annotation;
        else if (typeof this.mapOpts.annotation === "function") content = this.mapOpts.annotation(this.opts.to, this.root);
        else content = this.outputFile() + ".map";
        let eol = "\n";
        if (this.css.includes("\r\n")) eol = "\r\n";
        this.css += eol + "/*# sourceMappingURL=" + content + " */";
    }
    applyPrevMaps() {
        for (let prev of this.previous()){
            let from = this.toUrl(this.path(prev.file));
            let root = prev.root || $7d09741193654ec2$require$dirname(prev.file);
            let map;
            if (this.mapOpts.sourcesContent === false) {
                map = new $7d09741193654ec2$require$SourceMapConsumer(prev.text);
                if (map.sourcesContent) map.sourcesContent = map.sourcesContent.map(()=>null);
            } else map = prev.consumer();
            this.map.applySourceMap(map, from, this.toUrl(this.path(root)));
        }
    }
    clearAnnotation() {
        if (this.mapOpts.annotation === false) return;
        if (this.root) {
            let node;
            for(let i = this.root.nodes.length - 1; i >= 0; i--){
                node = this.root.nodes[i];
                if (node.type !== "comment") continue;
                if (node.text.indexOf("# sourceMappingURL=") === 0) this.root.removeChild(i);
            }
        } else if (this.css) this.css = this.css.replace(/(\n)?\/\*#[\S\s]*?\*\/$/gm, "");
    }
    generate() {
        this.clearAnnotation();
        if ($7d09741193654ec2$var$pathAvailable && $7d09741193654ec2$var$sourceMapAvailable && this.isMap()) return this.generateMap();
        else {
            let result = "";
            this.stringify(this.root, (i)=>{
                result += i;
            });
            return [
                result
            ];
        }
    }
    generateMap() {
        if (this.root) this.generateString();
        else if (this.previous().length === 1) {
            let prev = this.previous()[0].consumer();
            prev.file = this.outputFile();
            this.map = $7d09741193654ec2$require$SourceMapGenerator.fromSourceMap(prev);
        } else {
            this.map = new $7d09741193654ec2$require$SourceMapGenerator({
                file: this.outputFile()
            });
            this.map.addMapping({
                generated: {
                    column: 0,
                    line: 1
                },
                original: {
                    column: 0,
                    line: 1
                },
                source: this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>"
            });
        }
        if (this.isSourcesContent()) this.setSourcesContent();
        if (this.root && this.previous().length > 0) this.applyPrevMaps();
        if (this.isAnnotation()) this.addAnnotation();
        if (this.isInline()) return [
            this.css
        ];
        else return [
            this.css,
            this.map
        ];
    }
    generateString() {
        this.css = "";
        this.map = new $7d09741193654ec2$require$SourceMapGenerator({
            file: this.outputFile()
        });
        let line = 1;
        let column = 1;
        let noSource = "<no source>";
        let mapping = {
            generated: {
                column: 0,
                line: 0
            },
            original: {
                column: 0,
                line: 0
            },
            source: ""
        };
        let lines, last;
        this.stringify(this.root, (str, node, type)=>{
            this.css += str;
            if (node && type !== "end") {
                mapping.generated.line = line;
                mapping.generated.column = column - 1;
                if (node.source && node.source.start) {
                    mapping.source = this.sourcePath(node);
                    mapping.original.line = node.source.start.line;
                    mapping.original.column = node.source.start.column - 1;
                    this.map.addMapping(mapping);
                } else {
                    mapping.source = noSource;
                    mapping.original.line = 1;
                    mapping.original.column = 0;
                    this.map.addMapping(mapping);
                }
            }
            lines = str.match(/\n/g);
            if (lines) {
                line += lines.length;
                last = str.lastIndexOf("\n");
                column = str.length - last;
            } else column += str.length;
            if (node && type !== "start") {
                let p = node.parent || {
                    raws: {}
                };
                let childless = node.type === "decl" || node.type === "atrule" && !node.nodes;
                if (!childless || node !== p.last || p.raws.semicolon) {
                    if (node.source && node.source.end) {
                        mapping.source = this.sourcePath(node);
                        mapping.original.line = node.source.end.line;
                        mapping.original.column = node.source.end.column - 1;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 2;
                        this.map.addMapping(mapping);
                    } else {
                        mapping.source = noSource;
                        mapping.original.line = 1;
                        mapping.original.column = 0;
                        mapping.generated.line = line;
                        mapping.generated.column = column - 1;
                        this.map.addMapping(mapping);
                    }
                }
            }
        });
    }
    isAnnotation() {
        if (this.isInline()) return true;
        if (typeof this.mapOpts.annotation !== "undefined") return this.mapOpts.annotation;
        if (this.previous().length) return this.previous().some((i)=>i.annotation);
        return true;
    }
    isInline() {
        if (typeof this.mapOpts.inline !== "undefined") return this.mapOpts.inline;
        let annotation = this.mapOpts.annotation;
        if (typeof annotation !== "undefined" && annotation !== true) return false;
        if (this.previous().length) return this.previous().some((i)=>i.inline);
        return true;
    }
    isMap() {
        if (typeof this.opts.map !== "undefined") return !!this.opts.map;
        return this.previous().length > 0;
    }
    isSourcesContent() {
        if (typeof this.mapOpts.sourcesContent !== "undefined") return this.mapOpts.sourcesContent;
        if (this.previous().length) return this.previous().some((i)=>i.withContent());
        return true;
    }
    outputFile() {
        if (this.opts.to) return this.path(this.opts.to);
        else if (this.opts.from) return this.path(this.opts.from);
        else return "to.css";
    }
    path(file) {
        if (this.mapOpts.absolute) return file;
        if (file.charCodeAt(0) === 60 /* `<` */ ) return file;
        if (/^\w+:\/\//.test(file)) return file;
        let cached = this.memoizedPaths.get(file);
        if (cached) return cached;
        let from = this.opts.to ? $7d09741193654ec2$require$dirname(this.opts.to) : ".";
        if (typeof this.mapOpts.annotation === "string") from = $7d09741193654ec2$require$dirname($7d09741193654ec2$require$resolve(from, this.mapOpts.annotation));
        let path = $7d09741193654ec2$require$relative(from, file);
        this.memoizedPaths.set(file, path);
        return path;
    }
    previous() {
        if (!this.previousMaps) {
            this.previousMaps = [];
            if (this.root) this.root.walk((node)=>{
                if (node.source && node.source.input.map) {
                    let map = node.source.input.map;
                    if (!this.previousMaps.includes(map)) this.previousMaps.push(map);
                }
            });
            else {
                let input = new $bd2a9823f230228f$exports(this.css, this.opts);
                if (input.map) this.previousMaps.push(input.map);
            }
        }
        return this.previousMaps;
    }
    setSourcesContent() {
        let already = {};
        if (this.root) this.root.walk((node)=>{
            if (node.source) {
                let from = node.source.input.from;
                if (from && !already[from]) {
                    already[from] = true;
                    let fromUrl = this.usesFileUrls ? this.toFileUrl(from) : this.toUrl(this.path(from));
                    this.map.setSourceContent(fromUrl, node.source.input.css);
                }
            }
        });
        else if (this.css) {
            let from = this.opts.from ? this.toUrl(this.path(this.opts.from)) : "<no source>";
            this.map.setSourceContent(from, this.css);
        }
    }
    sourcePath(node) {
        if (this.mapOpts.from) return this.toUrl(this.mapOpts.from);
        else if (this.usesFileUrls) return this.toFileUrl(node.source.input.from);
        else return this.toUrl(this.path(node.source.input.from));
    }
    toBase64(str) {
        if ($7d09741193654ec2$require$Buffer) return $7d09741193654ec2$require$Buffer.from(str).toString("base64");
        else return window.btoa(unescape(encodeURIComponent(str)));
    }
    toFileUrl(path) {
        let cached = this.memoizedFileURLs.get(path);
        if (cached) return cached;
        if ($7d09741193654ec2$require$pathToFileURL) {
            let fileURL = $7d09741193654ec2$require$pathToFileURL(path).toString();
            this.memoizedFileURLs.set(path, fileURL);
            return fileURL;
        } else throw new Error("`map.absolute` option is not available in this PostCSS build");
    }
    toUrl(path) {
        let cached = this.memoizedURLs.get(path);
        if (cached) return cached;
        if ($7d09741193654ec2$require$sep === "\\") path = path.replace(/\\/g, "/");
        let url = encodeURI(path).replace(/[#?]/g, encodeURIComponent);
        this.memoizedURLs.set(path, url);
        return url;
    }
}
$7d09741193654ec2$exports = $7d09741193654ec2$var$MapGenerator;



var $a5adda6408996a1c$exports = {};
"use strict";

var $a5adda6408996a1c$require$isClean = $35608d4e1c63af4a$export$ae5e7911ce0728f9;
var $a5adda6408996a1c$require$my = $35608d4e1c63af4a$export$94fa0a6beb22f989;

var $180cb4710d883b41$exports = {};
"use strict";

class $180cb4710d883b41$var$Comment extends $a86fcc2c0b06d3d6$exports {
    constructor(defaults){
        super(defaults);
        this.type = "comment";
    }
}
$180cb4710d883b41$exports = $180cb4710d883b41$var$Comment;
$180cb4710d883b41$var$Comment.default = $180cb4710d883b41$var$Comment;



let $a5adda6408996a1c$var$parse, $a5adda6408996a1c$var$Rule, $a5adda6408996a1c$var$AtRule, $a5adda6408996a1c$var$Root;
function $a5adda6408996a1c$var$cleanSource(nodes) {
    return nodes.map((i)=>{
        if (i.nodes) i.nodes = $a5adda6408996a1c$var$cleanSource(i.nodes);
        delete i.source;
        return i;
    });
}
function $a5adda6408996a1c$var$markDirtyUp(node) {
    node[$a5adda6408996a1c$require$isClean] = false;
    if (node.proxyOf.nodes) for (let i of node.proxyOf.nodes)$a5adda6408996a1c$var$markDirtyUp(i);
}
class $a5adda6408996a1c$var$Container extends $a86fcc2c0b06d3d6$exports {
    append(...children) {
        for (let child of children){
            let nodes = this.normalize(child, this.last);
            for (let node of nodes)this.proxyOf.nodes.push(node);
        }
        this.markDirty();
        return this;
    }
    cleanRaws(keepBetween) {
        super.cleanRaws(keepBetween);
        if (this.nodes) for (let node of this.nodes)node.cleanRaws(keepBetween);
    }
    each(callback) {
        if (!this.proxyOf.nodes) return undefined;
        let iterator = this.getIterator();
        let index, result;
        while(this.indexes[iterator] < this.proxyOf.nodes.length){
            index = this.indexes[iterator];
            result = callback(this.proxyOf.nodes[index], index);
            if (result === false) break;
            this.indexes[iterator] += 1;
        }
        delete this.indexes[iterator];
        return result;
    }
    every(condition) {
        return this.nodes.every(condition);
    }
    getIterator() {
        if (!this.lastEach) this.lastEach = 0;
        if (!this.indexes) this.indexes = {};
        this.lastEach += 1;
        let iterator = this.lastEach;
        this.indexes[iterator] = 0;
        return iterator;
    }
    getProxyProcessor() {
        return {
            get (node, prop) {
                if (prop === "proxyOf") return node;
                else if (!node[prop]) return node[prop];
                else if (prop === "each" || typeof prop === "string" && prop.startsWith("walk")) return (...args)=>{
                    return node[prop](...args.map((i)=>{
                        if (typeof i === "function") return (child, index)=>i(child.toProxy(), index);
                        else return i;
                    }));
                };
                else if (prop === "every" || prop === "some") return (cb)=>{
                    return node[prop]((child, ...other)=>cb(child.toProxy(), ...other));
                };
                else if (prop === "root") return ()=>node.root().toProxy();
                else if (prop === "nodes") return node.nodes.map((i)=>i.toProxy());
                else if (prop === "first" || prop === "last") return node[prop].toProxy();
                else return node[prop];
            },
            set (node, prop, value) {
                if (node[prop] === value) return true;
                node[prop] = value;
                if (prop === "name" || prop === "params" || prop === "selector") node.markDirty();
                return true;
            }
        };
    }
    index(child) {
        if (typeof child === "number") return child;
        if (child.proxyOf) child = child.proxyOf;
        return this.proxyOf.nodes.indexOf(child);
    }
    insertAfter(exist, add) {
        let existIndex = this.index(exist);
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex]).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex + 1, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex < index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    insertBefore(exist, add) {
        let existIndex = this.index(exist);
        let type = existIndex === 0 ? "prepend" : false;
        let nodes = this.normalize(add, this.proxyOf.nodes[existIndex], type).reverse();
        existIndex = this.index(exist);
        for (let node of nodes)this.proxyOf.nodes.splice(existIndex, 0, node);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (existIndex <= index) this.indexes[id] = index + nodes.length;
        }
        this.markDirty();
        return this;
    }
    normalize(nodes, sample) {
        if (typeof nodes === "string") nodes = $a5adda6408996a1c$var$cleanSource($a5adda6408996a1c$var$parse(nodes).nodes);
        else if (Array.isArray(nodes)) {
            nodes = nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type === "root" && this.type !== "document") {
            nodes = nodes.nodes.slice(0);
            for (let i of nodes)if (i.parent) i.parent.removeChild(i, "ignore");
        } else if (nodes.type) nodes = [
            nodes
        ];
        else if (nodes.prop) {
            if (typeof nodes.value === "undefined") throw new Error("Value field is missed in node creation");
            else if (typeof nodes.value !== "string") nodes.value = String(nodes.value);
            nodes = [
                new $f96b5e8a06a46319$exports(nodes)
            ];
        } else if (nodes.selector) nodes = [
            new $a5adda6408996a1c$var$Rule(nodes)
        ];
        else if (nodes.name) nodes = [
            new $a5adda6408996a1c$var$AtRule(nodes)
        ];
        else if (nodes.text) nodes = [
            new $180cb4710d883b41$exports(nodes)
        ];
        else throw new Error("Unknown node type in node creation");
        let processed = nodes.map((i)=>{
            /* c8 ignore next */ if (!i[$a5adda6408996a1c$require$my]) $a5adda6408996a1c$var$Container.rebuild(i);
            i = i.proxyOf;
            if (i.parent) i.parent.removeChild(i);
            if (i[$a5adda6408996a1c$require$isClean]) $a5adda6408996a1c$var$markDirtyUp(i);
            if (typeof i.raws.before === "undefined") {
                if (sample && typeof sample.raws.before !== "undefined") i.raws.before = sample.raws.before.replace(/\S/g, "");
            }
            i.parent = this.proxyOf;
            return i;
        });
        return processed;
    }
    prepend(...children) {
        children = children.reverse();
        for (let child of children){
            let nodes = this.normalize(child, this.first, "prepend").reverse();
            for (let node of nodes)this.proxyOf.nodes.unshift(node);
            for(let id in this.indexes)this.indexes[id] = this.indexes[id] + nodes.length;
        }
        this.markDirty();
        return this;
    }
    push(child) {
        child.parent = this;
        this.proxyOf.nodes.push(child);
        return this;
    }
    removeAll() {
        for (let node of this.proxyOf.nodes)node.parent = undefined;
        this.proxyOf.nodes = [];
        this.markDirty();
        return this;
    }
    removeChild(child) {
        child = this.index(child);
        this.proxyOf.nodes[child].parent = undefined;
        this.proxyOf.nodes.splice(child, 1);
        let index;
        for(let id in this.indexes){
            index = this.indexes[id];
            if (index >= child) this.indexes[id] = index - 1;
        }
        this.markDirty();
        return this;
    }
    replaceValues(pattern, opts, callback) {
        if (!callback) {
            callback = opts;
            opts = {};
        }
        this.walkDecls((decl)=>{
            if (opts.props && !opts.props.includes(decl.prop)) return;
            if (opts.fast && !decl.value.includes(opts.fast)) return;
            decl.value = decl.value.replace(pattern, callback);
        });
        this.markDirty();
        return this;
    }
    some(condition) {
        return this.nodes.some(condition);
    }
    walk(callback) {
        return this.each((child, i)=>{
            let result;
            try {
                result = callback(child, i);
            } catch (e) {
                throw child.addToError(e);
            }
            if (result !== false && child.walk) result = child.walk(callback);
            return result;
        });
    }
    walkAtRules(name, callback) {
        if (!callback) {
            callback = name;
            return this.walk((child, i)=>{
                if (child.type === "atrule") return callback(child, i);
            });
        }
        if (name instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "atrule" && name.test(child.name)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "atrule" && child.name === name) return callback(child, i);
        });
    }
    walkComments(callback) {
        return this.walk((child, i)=>{
            if (child.type === "comment") return callback(child, i);
        });
    }
    walkDecls(prop, callback) {
        if (!callback) {
            callback = prop;
            return this.walk((child, i)=>{
                if (child.type === "decl") return callback(child, i);
            });
        }
        if (prop instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "decl" && prop.test(child.prop)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "decl" && child.prop === prop) return callback(child, i);
        });
    }
    walkRules(selector, callback) {
        if (!callback) {
            callback = selector;
            return this.walk((child, i)=>{
                if (child.type === "rule") return callback(child, i);
            });
        }
        if (selector instanceof RegExp) return this.walk((child, i)=>{
            if (child.type === "rule" && selector.test(child.selector)) return callback(child, i);
        });
        return this.walk((child, i)=>{
            if (child.type === "rule" && child.selector === selector) return callback(child, i);
        });
    }
    get first() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[0];
    }
    get last() {
        if (!this.proxyOf.nodes) return undefined;
        return this.proxyOf.nodes[this.proxyOf.nodes.length - 1];
    }
}
$a5adda6408996a1c$var$Container.registerParse = (dependant)=>{
    $a5adda6408996a1c$var$parse = dependant;
};
$a5adda6408996a1c$var$Container.registerRule = (dependant)=>{
    $a5adda6408996a1c$var$Rule = dependant;
};
$a5adda6408996a1c$var$Container.registerAtRule = (dependant)=>{
    $a5adda6408996a1c$var$AtRule = dependant;
};
$a5adda6408996a1c$var$Container.registerRoot = (dependant)=>{
    $a5adda6408996a1c$var$Root = dependant;
};
$a5adda6408996a1c$exports = $a5adda6408996a1c$var$Container;
$a5adda6408996a1c$var$Container.default = $a5adda6408996a1c$var$Container;
/* c8 ignore start */ $a5adda6408996a1c$var$Container.rebuild = (node)=>{
    if (node.type === "atrule") Object.setPrototypeOf(node, $a5adda6408996a1c$var$AtRule.prototype);
    else if (node.type === "rule") Object.setPrototypeOf(node, $a5adda6408996a1c$var$Rule.prototype);
    else if (node.type === "decl") Object.setPrototypeOf(node, $f96b5e8a06a46319$exports.prototype);
    else if (node.type === "comment") Object.setPrototypeOf(node, $180cb4710d883b41$exports.prototype);
    else if (node.type === "root") Object.setPrototypeOf(node, $a5adda6408996a1c$var$Root.prototype);
    node[$a5adda6408996a1c$require$my] = true;
    if (node.nodes) node.nodes.forEach((child)=>{
        $a5adda6408996a1c$var$Container.rebuild(child);
    });
} /* c8 ignore stop */ ;


var $7f0176123800bc8f$exports = {};
"use strict";

let $7f0176123800bc8f$var$LazyResult, $7f0176123800bc8f$var$Processor;
class $7f0176123800bc8f$var$Document extends $a5adda6408996a1c$exports {
    constructor(defaults){
        // type needs to be passed to super, otherwise child roots won't be normalized correctly
        super({
            type: "document",
            ...defaults
        });
        if (!this.nodes) this.nodes = [];
    }
    toResult(opts = {}) {
        let lazy = new $7f0176123800bc8f$var$LazyResult(new $7f0176123800bc8f$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$7f0176123800bc8f$var$Document.registerLazyResult = (dependant)=>{
    $7f0176123800bc8f$var$LazyResult = dependant;
};
$7f0176123800bc8f$var$Document.registerProcessor = (dependant)=>{
    $7f0176123800bc8f$var$Processor = dependant;
};
$7f0176123800bc8f$exports = $7f0176123800bc8f$var$Document;
$7f0176123800bc8f$var$Document.default = $7f0176123800bc8f$var$Document;


var $b47694db842c95df$exports = {};
/* eslint-disable no-console */ "use strict";
let $b47694db842c95df$var$printed = {};
$b47694db842c95df$exports = function warnOnce(message) {
    if ($b47694db842c95df$var$printed[message]) return;
    $b47694db842c95df$var$printed[message] = true;
    if (typeof console !== "undefined" && console.warn) console.warn(message);
};


var $e6eaf3b49b2363e7$exports = {};
"use strict";
var $550f9a84a3022c76$exports = {};
"use strict";
class $550f9a84a3022c76$var$Warning {
    constructor(text, opts = {}){
        this.type = "warning";
        this.text = text;
        if (opts.node && opts.node.source) {
            let range = opts.node.rangeBy(opts);
            this.line = range.start.line;
            this.column = range.start.column;
            this.endLine = range.end.line;
            this.endColumn = range.end.column;
        }
        for(let opt in opts)this[opt] = opts[opt];
    }
    toString() {
        if (this.node) return this.node.error(this.text, {
            index: this.index,
            plugin: this.plugin,
            word: this.word
        }).message;
        if (this.plugin) return this.plugin + ": " + this.text;
        return this.text;
    }
}
$550f9a84a3022c76$exports = $550f9a84a3022c76$var$Warning;
$550f9a84a3022c76$var$Warning.default = $550f9a84a3022c76$var$Warning;


class $e6eaf3b49b2363e7$var$Result {
    constructor(processor, root, opts){
        this.processor = processor;
        this.messages = [];
        this.root = root;
        this.opts = opts;
        this.css = undefined;
        this.map = undefined;
    }
    toString() {
        return this.css;
    }
    warn(text, opts = {}) {
        if (!opts.plugin) {
            if (this.lastPlugin && this.lastPlugin.postcssPlugin) opts.plugin = this.lastPlugin.postcssPlugin;
        }
        let warning = new $550f9a84a3022c76$exports(text, opts);
        this.messages.push(warning);
        return warning;
    }
    warnings() {
        return this.messages.filter((i)=>i.type === "warning");
    }
    get content() {
        return this.css;
    }
}
$e6eaf3b49b2363e7$exports = $e6eaf3b49b2363e7$var$Result;
$e6eaf3b49b2363e7$var$Result.default = $e6eaf3b49b2363e7$var$Result;


var $6b068f93e39f4567$exports = {};
"use strict";

var $d37c44f40f853c47$exports = {};
"use strict";

var $d6034b1510050912$exports = {};
"use strict";
const $d6034b1510050912$var$SINGLE_QUOTE = "'".charCodeAt(0);
const $d6034b1510050912$var$DOUBLE_QUOTE = '"'.charCodeAt(0);
const $d6034b1510050912$var$BACKSLASH = "\\".charCodeAt(0);
const $d6034b1510050912$var$SLASH = "/".charCodeAt(0);
const $d6034b1510050912$var$NEWLINE = "\n".charCodeAt(0);
const $d6034b1510050912$var$SPACE = " ".charCodeAt(0);
const $d6034b1510050912$var$FEED = "\f".charCodeAt(0);
const $d6034b1510050912$var$TAB = "	".charCodeAt(0);
const $d6034b1510050912$var$CR = "\r".charCodeAt(0);
const $d6034b1510050912$var$OPEN_SQUARE = "[".charCodeAt(0);
const $d6034b1510050912$var$CLOSE_SQUARE = "]".charCodeAt(0);
const $d6034b1510050912$var$OPEN_PARENTHESES = "(".charCodeAt(0);
const $d6034b1510050912$var$CLOSE_PARENTHESES = ")".charCodeAt(0);
const $d6034b1510050912$var$OPEN_CURLY = "{".charCodeAt(0);
const $d6034b1510050912$var$CLOSE_CURLY = "}".charCodeAt(0);
const $d6034b1510050912$var$SEMICOLON = ";".charCodeAt(0);
const $d6034b1510050912$var$ASTERISK = "*".charCodeAt(0);
const $d6034b1510050912$var$COLON = ":".charCodeAt(0);
const $d6034b1510050912$var$AT = "@".charCodeAt(0);
const $d6034b1510050912$var$RE_AT_END = /[\t\n\f\r "#'()/;[\\\]{}]/g;
const $d6034b1510050912$var$RE_WORD_END = /[\t\n\f\r !"#'():;@[\\\]{}]|\/(?=\*)/g;
const $d6034b1510050912$var$RE_BAD_BRACKET = /.[\r\n"'(/\\]/;
const $d6034b1510050912$var$RE_HEX_ESCAPE = /[\da-f]/i;
$d6034b1510050912$exports = function tokenizer(input, options = {}) {
    let css = input.css.valueOf();
    let ignore = options.ignoreErrors;
    let code, next, quote, content, escape;
    let escaped, escapePos, prev, n, currentToken;
    let length = css.length;
    let pos = 0;
    let buffer = [];
    let returned = [];
    function position() {
        return pos;
    }
    function unclosed(what) {
        throw input.error("Unclosed " + what, pos);
    }
    function endOfFile() {
        return returned.length === 0 && pos >= length;
    }
    function nextToken(opts) {
        if (returned.length) return returned.pop();
        if (pos >= length) return;
        let ignoreUnclosed = opts ? opts.ignoreUnclosed : false;
        code = css.charCodeAt(pos);
        switch(code){
            case $d6034b1510050912$var$NEWLINE:
            case $d6034b1510050912$var$SPACE:
            case $d6034b1510050912$var$TAB:
            case $d6034b1510050912$var$CR:
            case $d6034b1510050912$var$FEED:
                next = pos;
                do {
                    next += 1;
                    code = css.charCodeAt(next);
                }while (code === $d6034b1510050912$var$SPACE || code === $d6034b1510050912$var$NEWLINE || code === $d6034b1510050912$var$TAB || code === $d6034b1510050912$var$CR || code === $d6034b1510050912$var$FEED);
                currentToken = [
                    "space",
                    css.slice(pos, next)
                ];
                pos = next - 1;
                break;
            case $d6034b1510050912$var$OPEN_SQUARE:
            case $d6034b1510050912$var$CLOSE_SQUARE:
            case $d6034b1510050912$var$OPEN_CURLY:
            case $d6034b1510050912$var$CLOSE_CURLY:
            case $d6034b1510050912$var$COLON:
            case $d6034b1510050912$var$SEMICOLON:
            case $d6034b1510050912$var$CLOSE_PARENTHESES:
                {
                    let controlChar = String.fromCharCode(code);
                    currentToken = [
                        controlChar,
                        controlChar,
                        pos
                    ];
                    break;
                }
            case $d6034b1510050912$var$OPEN_PARENTHESES:
                prev = buffer.length ? buffer.pop()[1] : "";
                n = css.charCodeAt(pos + 1);
                if (prev === "url" && n !== $d6034b1510050912$var$SINGLE_QUOTE && n !== $d6034b1510050912$var$DOUBLE_QUOTE && n !== $d6034b1510050912$var$SPACE && n !== $d6034b1510050912$var$NEWLINE && n !== $d6034b1510050912$var$TAB && n !== $d6034b1510050912$var$FEED && n !== $d6034b1510050912$var$CR) {
                    next = pos;
                    do {
                        escaped = false;
                        next = css.indexOf(")", next + 1);
                        if (next === -1) {
                            if (ignore || ignoreUnclosed) {
                                next = pos;
                                break;
                            } else unclosed("bracket");
                        }
                        escapePos = next;
                        while(css.charCodeAt(escapePos - 1) === $d6034b1510050912$var$BACKSLASH){
                            escapePos -= 1;
                            escaped = !escaped;
                        }
                    }while (escaped);
                    currentToken = [
                        "brackets",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    next = css.indexOf(")", pos + 1);
                    content = css.slice(pos, next + 1);
                    if (next === -1 || $d6034b1510050912$var$RE_BAD_BRACKET.test(content)) currentToken = [
                        "(",
                        "(",
                        pos
                    ];
                    else {
                        currentToken = [
                            "brackets",
                            content,
                            pos,
                            next
                        ];
                        pos = next;
                    }
                }
                break;
            case $d6034b1510050912$var$SINGLE_QUOTE:
            case $d6034b1510050912$var$DOUBLE_QUOTE:
                quote = code === $d6034b1510050912$var$SINGLE_QUOTE ? "'" : '"';
                next = pos;
                do {
                    escaped = false;
                    next = css.indexOf(quote, next + 1);
                    if (next === -1) {
                        if (ignore || ignoreUnclosed) {
                            next = pos + 1;
                            break;
                        } else unclosed("string");
                    }
                    escapePos = next;
                    while(css.charCodeAt(escapePos - 1) === $d6034b1510050912$var$BACKSLASH){
                        escapePos -= 1;
                        escaped = !escaped;
                    }
                }while (escaped);
                currentToken = [
                    "string",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $d6034b1510050912$var$AT:
                $d6034b1510050912$var$RE_AT_END.lastIndex = pos + 1;
                $d6034b1510050912$var$RE_AT_END.test(css);
                if ($d6034b1510050912$var$RE_AT_END.lastIndex === 0) next = css.length - 1;
                else next = $d6034b1510050912$var$RE_AT_END.lastIndex - 2;
                currentToken = [
                    "at-word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            case $d6034b1510050912$var$BACKSLASH:
                next = pos;
                escape = true;
                while(css.charCodeAt(next + 1) === $d6034b1510050912$var$BACKSLASH){
                    next += 1;
                    escape = !escape;
                }
                code = css.charCodeAt(next + 1);
                if (escape && code !== $d6034b1510050912$var$SLASH && code !== $d6034b1510050912$var$SPACE && code !== $d6034b1510050912$var$NEWLINE && code !== $d6034b1510050912$var$TAB && code !== $d6034b1510050912$var$CR && code !== $d6034b1510050912$var$FEED) {
                    next += 1;
                    if ($d6034b1510050912$var$RE_HEX_ESCAPE.test(css.charAt(next))) {
                        while($d6034b1510050912$var$RE_HEX_ESCAPE.test(css.charAt(next + 1)))next += 1;
                        if (css.charCodeAt(next + 1) === $d6034b1510050912$var$SPACE) next += 1;
                    }
                }
                currentToken = [
                    "word",
                    css.slice(pos, next + 1),
                    pos,
                    next
                ];
                pos = next;
                break;
            default:
                if (code === $d6034b1510050912$var$SLASH && css.charCodeAt(pos + 1) === $d6034b1510050912$var$ASTERISK) {
                    next = css.indexOf("*/", pos + 2) + 1;
                    if (next === 0) {
                        if (ignore || ignoreUnclosed) next = css.length;
                        else unclosed("comment");
                    }
                    currentToken = [
                        "comment",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    pos = next;
                } else {
                    $d6034b1510050912$var$RE_WORD_END.lastIndex = pos + 1;
                    $d6034b1510050912$var$RE_WORD_END.test(css);
                    if ($d6034b1510050912$var$RE_WORD_END.lastIndex === 0) next = css.length - 1;
                    else next = $d6034b1510050912$var$RE_WORD_END.lastIndex - 2;
                    currentToken = [
                        "word",
                        css.slice(pos, next + 1),
                        pos,
                        next
                    ];
                    buffer.push(currentToken);
                    pos = next;
                }
                break;
        }
        pos++;
        return currentToken;
    }
    function back(token) {
        returned.push(token);
    }
    return {
        back: back,
        endOfFile: endOfFile,
        nextToken: nextToken,
        position: position
    };
};



var $be3d3d8637ea2730$exports = {};
"use strict";

class $be3d3d8637ea2730$var$AtRule extends $a5adda6408996a1c$exports {
    constructor(defaults){
        super(defaults);
        this.type = "atrule";
    }
    append(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.append(...children);
    }
    prepend(...children) {
        if (!this.proxyOf.nodes) this.nodes = [];
        return super.prepend(...children);
    }
}
$be3d3d8637ea2730$exports = $be3d3d8637ea2730$var$AtRule;
$be3d3d8637ea2730$var$AtRule.default = $be3d3d8637ea2730$var$AtRule;
$a5adda6408996a1c$exports.registerAtRule($be3d3d8637ea2730$var$AtRule);


var $c794908ed4c96ae5$exports = {};
"use strict";

let $c794908ed4c96ae5$var$LazyResult, $c794908ed4c96ae5$var$Processor;
class $c794908ed4c96ae5$var$Root extends $a5adda6408996a1c$exports {
    constructor(defaults){
        super(defaults);
        this.type = "root";
        if (!this.nodes) this.nodes = [];
    }
    normalize(child, sample, type) {
        let nodes = super.normalize(child);
        if (sample) {
            if (type === "prepend") {
                if (this.nodes.length > 1) sample.raws.before = this.nodes[1].raws.before;
                else delete sample.raws.before;
            } else if (this.first !== sample) for (let node of nodes)node.raws.before = sample.raws.before;
        }
        return nodes;
    }
    removeChild(child, ignore) {
        let index = this.index(child);
        if (!ignore && index === 0 && this.nodes.length > 1) this.nodes[1].raws.before = this.nodes[index].raws.before;
        return super.removeChild(child);
    }
    toResult(opts = {}) {
        let lazy = new $c794908ed4c96ae5$var$LazyResult(new $c794908ed4c96ae5$var$Processor(), this, opts);
        return lazy.stringify();
    }
}
$c794908ed4c96ae5$var$Root.registerLazyResult = (dependant)=>{
    $c794908ed4c96ae5$var$LazyResult = dependant;
};
$c794908ed4c96ae5$var$Root.registerProcessor = (dependant)=>{
    $c794908ed4c96ae5$var$Processor = dependant;
};
$c794908ed4c96ae5$exports = $c794908ed4c96ae5$var$Root;
$c794908ed4c96ae5$var$Root.default = $c794908ed4c96ae5$var$Root;
$a5adda6408996a1c$exports.registerRoot($c794908ed4c96ae5$var$Root);


var $92d8d3cba5dd68fd$exports = {};
"use strict";

var $4593d3f828590853$exports = {};
"use strict";
let $4593d3f828590853$var$list = {
    comma (string) {
        return $4593d3f828590853$var$list.split(string, [
            ","
        ], true);
    },
    space (string) {
        let spaces = [
            " ",
            "\n",
            "	"
        ];
        return $4593d3f828590853$var$list.split(string, spaces);
    },
    split (string, separators, last) {
        let array = [];
        let current = "";
        let split = false;
        let func = 0;
        let inQuote = false;
        let prevQuote = "";
        let escape = false;
        for (let letter of string){
            if (escape) escape = false;
            else if (letter === "\\") escape = true;
            else if (inQuote) {
                if (letter === prevQuote) inQuote = false;
            } else if (letter === '"' || letter === "'") {
                inQuote = true;
                prevQuote = letter;
            } else if (letter === "(") func += 1;
            else if (letter === ")") {
                if (func > 0) func -= 1;
            } else if (func === 0) {
                if (separators.includes(letter)) split = true;
            }
            if (split) {
                if (current !== "") array.push(current.trim());
                current = "";
                split = false;
            } else current += letter;
        }
        if (last || current !== "") array.push(current.trim());
        return array;
    }
};
$4593d3f828590853$exports = $4593d3f828590853$var$list;
$4593d3f828590853$var$list.default = $4593d3f828590853$var$list;


class $92d8d3cba5dd68fd$var$Rule extends $a5adda6408996a1c$exports {
    constructor(defaults){
        super(defaults);
        this.type = "rule";
        if (!this.nodes) this.nodes = [];
    }
    get selectors() {
        return $4593d3f828590853$exports.comma(this.selector);
    }
    set selectors(values) {
        let match = this.selector ? this.selector.match(/,\s*/) : null;
        let sep = match ? match[0] : "," + this.raw("between", "beforeOpen");
        this.selector = values.join(sep);
    }
}
$92d8d3cba5dd68fd$exports = $92d8d3cba5dd68fd$var$Rule;
$92d8d3cba5dd68fd$var$Rule.default = $92d8d3cba5dd68fd$var$Rule;
$a5adda6408996a1c$exports.registerRule($92d8d3cba5dd68fd$var$Rule);


const $d37c44f40f853c47$var$SAFE_COMMENT_NEIGHBOR = {
    empty: true,
    space: true
};
function $d37c44f40f853c47$var$findLastWithPosition(tokens) {
    for(let i = tokens.length - 1; i >= 0; i--){
        let token = tokens[i];
        let pos = token[3] || token[2];
        if (pos) return pos;
    }
}
class $d37c44f40f853c47$var$Parser {
    constructor(input){
        this.input = input;
        this.root = new $c794908ed4c96ae5$exports();
        this.current = this.root;
        this.spaces = "";
        this.semicolon = false;
        this.customProperty = false;
        this.createTokenizer();
        this.root.source = {
            input: input,
            start: {
                column: 1,
                line: 1,
                offset: 0
            }
        };
    }
    atrule(token) {
        let node = new $be3d3d8637ea2730$exports();
        node.name = token[1].slice(1);
        if (node.name === "") this.unnamedAtrule(node, token);
        this.init(node, token[2]);
        let type;
        let prev;
        let shift;
        let last = false;
        let open = false;
        let params = [];
        let brackets = [];
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            type = token[0];
            if (type === "(" || type === "[") brackets.push(type === "(" ? ")" : "]");
            else if (type === "{" && brackets.length > 0) brackets.push("}");
            else if (type === brackets[brackets.length - 1]) brackets.pop();
            if (brackets.length === 0) {
                if (type === ";") {
                    node.source.end = this.getPosition(token[2]);
                    node.source.end.offset++;
                    this.semicolon = true;
                    break;
                } else if (type === "{") {
                    open = true;
                    break;
                } else if (type === "}") {
                    if (params.length > 0) {
                        shift = params.length - 1;
                        prev = params[shift];
                        while(prev && prev[0] === "space")prev = params[--shift];
                        if (prev) {
                            node.source.end = this.getPosition(prev[3] || prev[2]);
                            node.source.end.offset++;
                        }
                    }
                    this.end(token);
                    break;
                } else params.push(token);
            } else params.push(token);
            if (this.tokenizer.endOfFile()) {
                last = true;
                break;
            }
        }
        node.raws.between = this.spacesAndCommentsFromEnd(params);
        if (params.length) {
            node.raws.afterName = this.spacesAndCommentsFromStart(params);
            this.raw(node, "params", params);
            if (last) {
                token = params[params.length - 1];
                node.source.end = this.getPosition(token[3] || token[2]);
                node.source.end.offset++;
                this.spaces = node.raws.between;
                node.raws.between = "";
            }
        } else {
            node.raws.afterName = "";
            node.params = "";
        }
        if (open) {
            node.nodes = [];
            this.current = node;
        }
    }
    checkMissedSemicolon(tokens) {
        let colon = this.colon(tokens);
        if (colon === false) return;
        let founded = 0;
        let token;
        for(let j = colon - 1; j >= 0; j--){
            token = tokens[j];
            if (token[0] !== "space") {
                founded += 1;
                if (founded === 2) break;
            }
        }
        // If the token is a word, e.g. `!important`, `red` or any other valid property's value.
        // Then we need to return the colon after that word token. [3] is the "end" colon of that word.
        // And because we need it after that one we do +1 to get the next one.
        throw this.input.error("Missed semicolon", token[0] === "word" ? token[3] + 1 : token[2]);
    }
    colon(tokens) {
        let brackets = 0;
        let token, type, prev;
        for (let [i, element] of tokens.entries()){
            token = element;
            type = token[0];
            if (type === "(") brackets += 1;
            if (type === ")") brackets -= 1;
            if (brackets === 0 && type === ":") {
                if (!prev) this.doubleColon(token);
                else if (prev[0] === "word" && prev[1] === "progid") continue;
                else return i;
            }
            prev = token;
        }
        return false;
    }
    comment(token) {
        let node = new $180cb4710d883b41$exports();
        this.init(node, token[2]);
        node.source.end = this.getPosition(token[3] || token[2]);
        node.source.end.offset++;
        let text = token[1].slice(2, -2);
        if (/^\s*$/.test(text)) {
            node.text = "";
            node.raws.left = text;
            node.raws.right = "";
        } else {
            let match = text.match(/^(\s*)([^]*\S)(\s*)$/);
            node.text = match[2];
            node.raws.left = match[1];
            node.raws.right = match[3];
        }
    }
    createTokenizer() {
        this.tokenizer = $d6034b1510050912$exports(this.input);
    }
    decl(tokens, customProperty) {
        let node = new $f96b5e8a06a46319$exports();
        this.init(node, tokens[0][2]);
        let last = tokens[tokens.length - 1];
        if (last[0] === ";") {
            this.semicolon = true;
            tokens.pop();
        }
        node.source.end = this.getPosition(last[3] || last[2] || $d37c44f40f853c47$var$findLastWithPosition(tokens));
        node.source.end.offset++;
        while(tokens[0][0] !== "word"){
            if (tokens.length === 1) this.unknownWord(tokens);
            node.raws.before += tokens.shift()[1];
        }
        node.source.start = this.getPosition(tokens[0][2]);
        node.prop = "";
        while(tokens.length){
            let type = tokens[0][0];
            if (type === ":" || type === "space" || type === "comment") break;
            node.prop += tokens.shift()[1];
        }
        node.raws.between = "";
        let token;
        while(tokens.length){
            token = tokens.shift();
            if (token[0] === ":") {
                node.raws.between += token[1];
                break;
            } else {
                if (token[0] === "word" && /\w/.test(token[1])) this.unknownWord([
                    token
                ]);
                node.raws.between += token[1];
            }
        }
        if (node.prop[0] === "_" || node.prop[0] === "*") {
            node.raws.before += node.prop[0];
            node.prop = node.prop.slice(1);
        }
        let firstSpaces = [];
        let next;
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            firstSpaces.push(tokens.shift());
        }
        this.precheckMissedSemicolon(tokens);
        for(let i = tokens.length - 1; i >= 0; i--){
            token = tokens[i];
            if (token[1].toLowerCase() === "!important") {
                node.important = true;
                let string = this.stringFrom(tokens, i);
                string = this.spacesFromEnd(tokens) + string;
                if (string !== " !important") node.raws.important = string;
                break;
            } else if (token[1].toLowerCase() === "important") {
                let cache = tokens.slice(0);
                let str = "";
                for(let j = i; j > 0; j--){
                    let type = cache[j][0];
                    if (str.trim().indexOf("!") === 0 && type !== "space") break;
                    str = cache.pop()[1] + str;
                }
                if (str.trim().indexOf("!") === 0) {
                    node.important = true;
                    node.raws.important = str;
                    tokens = cache;
                }
            }
            if (token[0] !== "space" && token[0] !== "comment") break;
        }
        let hasWord = tokens.some((i)=>i[0] !== "space" && i[0] !== "comment");
        if (hasWord) {
            node.raws.between += firstSpaces.map((i)=>i[1]).join("");
            firstSpaces = [];
        }
        this.raw(node, "value", firstSpaces.concat(tokens), customProperty);
        if (node.value.includes(":") && !customProperty) this.checkMissedSemicolon(tokens);
    }
    doubleColon(token) {
        throw this.input.error("Double colon", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
    emptyRule(token) {
        let node = new $92d8d3cba5dd68fd$exports();
        this.init(node, token[2]);
        node.selector = "";
        node.raws.between = "";
        this.current = node;
    }
    end(token) {
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.semicolon = false;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.spaces = "";
        if (this.current.parent) {
            this.current.source.end = this.getPosition(token[2]);
            this.current.source.end.offset++;
            this.current = this.current.parent;
        } else this.unexpectedClose(token);
    }
    endFile() {
        if (this.current.parent) this.unclosedBlock();
        if (this.current.nodes && this.current.nodes.length) this.current.raws.semicolon = this.semicolon;
        this.current.raws.after = (this.current.raws.after || "") + this.spaces;
        this.root.source.end = this.getPosition(this.tokenizer.position());
    }
    freeSemicolon(token) {
        this.spaces += token[1];
        if (this.current.nodes) {
            let prev = this.current.nodes[this.current.nodes.length - 1];
            if (prev && prev.type === "rule" && !prev.raws.ownSemicolon) {
                prev.raws.ownSemicolon = this.spaces;
                this.spaces = "";
            }
        }
    }
    // Helpers
    getPosition(offset) {
        let pos = this.input.fromOffset(offset);
        return {
            column: pos.col,
            line: pos.line,
            offset: offset
        };
    }
    init(node, offset) {
        this.current.push(node);
        node.source = {
            input: this.input,
            start: this.getPosition(offset)
        };
        node.raws.before = this.spaces;
        this.spaces = "";
        if (node.type !== "comment") this.semicolon = false;
    }
    other(start) {
        let end = false;
        let type = null;
        let colon = false;
        let bracket = null;
        let brackets = [];
        let customProperty = start[1].startsWith("--");
        let tokens = [];
        let token = start;
        while(token){
            type = token[0];
            tokens.push(token);
            if (type === "(" || type === "[") {
                if (!bracket) bracket = token;
                brackets.push(type === "(" ? ")" : "]");
            } else if (customProperty && colon && type === "{") {
                if (!bracket) bracket = token;
                brackets.push("}");
            } else if (brackets.length === 0) {
                if (type === ";") {
                    if (colon) {
                        this.decl(tokens, customProperty);
                        return;
                    } else break;
                } else if (type === "{") {
                    this.rule(tokens);
                    return;
                } else if (type === "}") {
                    this.tokenizer.back(tokens.pop());
                    end = true;
                    break;
                } else if (type === ":") colon = true;
            } else if (type === brackets[brackets.length - 1]) {
                brackets.pop();
                if (brackets.length === 0) bracket = null;
            }
            token = this.tokenizer.nextToken();
        }
        if (this.tokenizer.endOfFile()) end = true;
        if (brackets.length > 0) this.unclosedBracket(bracket);
        if (end && colon) {
            if (!customProperty) while(tokens.length){
                token = tokens[tokens.length - 1][0];
                if (token !== "space" && token !== "comment") break;
                this.tokenizer.back(tokens.pop());
            }
            this.decl(tokens, customProperty);
        } else this.unknownWord(tokens);
    }
    parse() {
        let token;
        while(!this.tokenizer.endOfFile()){
            token = this.tokenizer.nextToken();
            switch(token[0]){
                case "space":
                    this.spaces += token[1];
                    break;
                case ";":
                    this.freeSemicolon(token);
                    break;
                case "}":
                    this.end(token);
                    break;
                case "comment":
                    this.comment(token);
                    break;
                case "at-word":
                    this.atrule(token);
                    break;
                case "{":
                    this.emptyRule(token);
                    break;
                default:
                    this.other(token);
                    break;
            }
        }
        this.endFile();
    }
    precheckMissedSemicolon() {
    // Hook for Safe Parser
    }
    raw(node, prop, tokens, customProperty) {
        let token, type;
        let length = tokens.length;
        let value = "";
        let clean = true;
        let next, prev;
        for(let i = 0; i < length; i += 1){
            token = tokens[i];
            type = token[0];
            if (type === "space" && i === length - 1 && !customProperty) clean = false;
            else if (type === "comment") {
                prev = tokens[i - 1] ? tokens[i - 1][0] : "empty";
                next = tokens[i + 1] ? tokens[i + 1][0] : "empty";
                if (!$d37c44f40f853c47$var$SAFE_COMMENT_NEIGHBOR[prev] && !$d37c44f40f853c47$var$SAFE_COMMENT_NEIGHBOR[next]) {
                    if (value.slice(-1) === ",") clean = false;
                    else value += token[1];
                } else clean = false;
            } else value += token[1];
        }
        if (!clean) {
            let raw = tokens.reduce((all, i)=>all + i[1], "");
            node.raws[prop] = {
                raw: raw,
                value: value
            };
        }
        node[prop] = value;
    }
    rule(tokens) {
        tokens.pop();
        let node = new $92d8d3cba5dd68fd$exports();
        this.init(node, tokens[0][2]);
        node.raws.between = this.spacesAndCommentsFromEnd(tokens);
        this.raw(node, "selector", tokens);
        this.current = node;
    }
    spacesAndCommentsFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space" && lastTokenType !== "comment") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    // Errors
    spacesAndCommentsFromStart(tokens) {
        let next;
        let spaces = "";
        while(tokens.length){
            next = tokens[0][0];
            if (next !== "space" && next !== "comment") break;
            spaces += tokens.shift()[1];
        }
        return spaces;
    }
    spacesFromEnd(tokens) {
        let lastTokenType;
        let spaces = "";
        while(tokens.length){
            lastTokenType = tokens[tokens.length - 1][0];
            if (lastTokenType !== "space") break;
            spaces = tokens.pop()[1] + spaces;
        }
        return spaces;
    }
    stringFrom(tokens, from) {
        let result = "";
        for(let i = from; i < tokens.length; i++)result += tokens[i][1];
        tokens.splice(from, tokens.length - from);
        return result;
    }
    unclosedBlock() {
        let pos = this.current.source.start;
        throw this.input.error("Unclosed block", pos.line, pos.column);
    }
    unclosedBracket(bracket) {
        throw this.input.error("Unclosed bracket", {
            offset: bracket[2]
        }, {
            offset: bracket[2] + 1
        });
    }
    unexpectedClose(token) {
        throw this.input.error("Unexpected }", {
            offset: token[2]
        }, {
            offset: token[2] + 1
        });
    }
    unknownWord(tokens) {
        throw this.input.error("Unknown word", {
            offset: tokens[0][2]
        }, {
            offset: tokens[0][2] + tokens[0][1].length
        });
    }
    unnamedAtrule(node, token) {
        throw this.input.error("At-rule without name", {
            offset: token[2]
        }, {
            offset: token[2] + token[1].length
        });
    }
}
$d37c44f40f853c47$exports = $d37c44f40f853c47$var$Parser;



function $6b068f93e39f4567$var$parse(css, opts) {
    let input = new $bd2a9823f230228f$exports(css, opts);
    let parser = new $d37c44f40f853c47$exports(input);
    try {
        parser.parse();
    } catch (e) {
        throw e;
    }
    return parser.root;
}
$6b068f93e39f4567$exports = $6b068f93e39f4567$var$parse;
$6b068f93e39f4567$var$parse.default = $6b068f93e39f4567$var$parse;
$a5adda6408996a1c$exports.registerParse($6b068f93e39f4567$var$parse);



const $a0c4a455532e6de7$var$TYPE_TO_CLASS_NAME = {
    atrule: "AtRule",
    comment: "Comment",
    decl: "Declaration",
    document: "Document",
    root: "Root",
    rule: "Rule"
};
const $a0c4a455532e6de7$var$PLUGIN_PROPS = {
    AtRule: true,
    AtRuleExit: true,
    Comment: true,
    CommentExit: true,
    Declaration: true,
    DeclarationExit: true,
    Document: true,
    DocumentExit: true,
    Once: true,
    OnceExit: true,
    postcssPlugin: true,
    prepare: true,
    Root: true,
    RootExit: true,
    Rule: true,
    RuleExit: true
};
const $a0c4a455532e6de7$var$NOT_VISITORS = {
    Once: true,
    postcssPlugin: true,
    prepare: true
};
const $a0c4a455532e6de7$var$CHILDREN = 0;
function $a0c4a455532e6de7$var$isPromise(obj) {
    return typeof obj === "object" && typeof obj.then === "function";
}
function $a0c4a455532e6de7$var$getEvents(node) {
    let key = false;
    let type = $a0c4a455532e6de7$var$TYPE_TO_CLASS_NAME[node.type];
    if (node.type === "decl") key = node.prop.toLowerCase();
    else if (node.type === "atrule") key = node.name.toLowerCase();
    if (key && node.append) return [
        type,
        type + "-" + key,
        $a0c4a455532e6de7$var$CHILDREN,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (key) return [
        type,
        type + "-" + key,
        type + "Exit",
        type + "Exit-" + key
    ];
    else if (node.append) return [
        type,
        $a0c4a455532e6de7$var$CHILDREN,
        type + "Exit"
    ];
    else return [
        type,
        type + "Exit"
    ];
}
function $a0c4a455532e6de7$var$toStack(node) {
    let events;
    if (node.type === "document") events = [
        "Document",
        $a0c4a455532e6de7$var$CHILDREN,
        "DocumentExit"
    ];
    else if (node.type === "root") events = [
        "Root",
        $a0c4a455532e6de7$var$CHILDREN,
        "RootExit"
    ];
    else events = $a0c4a455532e6de7$var$getEvents(node);
    return {
        eventIndex: 0,
        events: events,
        iterator: 0,
        node: node,
        visitorIndex: 0,
        visitors: []
    };
}
function $a0c4a455532e6de7$var$cleanMarks(node) {
    node[$a0c4a455532e6de7$require$isClean] = false;
    if (node.nodes) node.nodes.forEach((i)=>$a0c4a455532e6de7$var$cleanMarks(i));
    return node;
}
let $a0c4a455532e6de7$var$postcss = {};
class $a0c4a455532e6de7$var$LazyResult {
    constructor(processor, css, opts){
        this.stringified = false;
        this.processed = false;
        let root;
        if (typeof css === "object" && css !== null && (css.type === "root" || css.type === "document")) root = $a0c4a455532e6de7$var$cleanMarks(css);
        else if (css instanceof $a0c4a455532e6de7$var$LazyResult || css instanceof $e6eaf3b49b2363e7$exports) {
            root = $a0c4a455532e6de7$var$cleanMarks(css.root);
            if (css.map) {
                if (typeof opts.map === "undefined") opts.map = {};
                if (!opts.map.inline) opts.map.inline = false;
                opts.map.prev = css.map;
            }
        } else {
            let parser = $6b068f93e39f4567$exports;
            if (opts.syntax) parser = opts.syntax.parse;
            if (opts.parser) parser = opts.parser;
            if (parser.parse) parser = parser.parse;
            try {
                root = parser(css, opts);
            } catch (error) {
                this.processed = true;
                this.error = error;
            }
            if (root && !root[$a0c4a455532e6de7$require$my]) /* c8 ignore next 2 */ $a5adda6408996a1c$exports.rebuild(root);
        }
        this.result = new $e6eaf3b49b2363e7$exports(processor, root, opts);
        this.helpers = {
            ...$a0c4a455532e6de7$var$postcss,
            postcss: $a0c4a455532e6de7$var$postcss,
            result: this.result
        };
        this.plugins = this.processor.plugins.map((plugin)=>{
            if (typeof plugin === "object" && plugin.prepare) return {
                ...plugin,
                ...plugin.prepare(this.result)
            };
            else return plugin;
        });
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        if (this.processed) return Promise.resolve(this.result);
        if (!this.processing) this.processing = this.runAsync();
        return this.processing;
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    getAsyncError() {
        throw new Error("Use process(css).then(cb) to work with async plugins");
    }
    handleError(error, node) {
        let plugin = this.result.lastPlugin;
        try {
            if (node) node.addToError(error);
            this.error = error;
            if (error.name === "CssSyntaxError" && !error.plugin) {
                error.plugin = plugin.postcssPlugin;
                error.setMessage();
            } else plugin.postcssVersion;
        } catch (err) {
            /* c8 ignore next 3 */ // eslint-disable-next-line no-console
            if (console && console.error) console.error(err);
        }
        return error;
    }
    prepareVisitors() {
        this.listeners = {};
        let add = (plugin, type, cb)=>{
            if (!this.listeners[type]) this.listeners[type] = [];
            this.listeners[type].push([
                plugin,
                cb
            ]);
        };
        for (let plugin of this.plugins){
            if (typeof plugin === "object") for(let event in plugin){
                if (!$a0c4a455532e6de7$var$PLUGIN_PROPS[event] && /^[A-Z]/.test(event)) throw new Error(`Unknown event ${event} in ${plugin.postcssPlugin}. ` + `Try to update PostCSS (${this.processor.version} now).`);
                if (!$a0c4a455532e6de7$var$NOT_VISITORS[event]) {
                    if (typeof plugin[event] === "object") {
                        for(let filter in plugin[event])if (filter === "*") add(plugin, event, plugin[event][filter]);
                        else add(plugin, event + "-" + filter.toLowerCase(), plugin[event][filter]);
                    } else if (typeof plugin[event] === "function") add(plugin, event, plugin[event]);
                }
            }
        }
        this.hasListener = Object.keys(this.listeners).length > 0;
    }
    async runAsync() {
        this.plugin = 0;
        for(let i = 0; i < this.plugins.length; i++){
            let plugin = this.plugins[i];
            let promise = this.runOnRoot(plugin);
            if ($a0c4a455532e6de7$var$isPromise(promise)) try {
                await promise;
            } catch (error) {
                throw this.handleError(error);
            }
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a0c4a455532e6de7$require$isClean]){
                root[$a0c4a455532e6de7$require$isClean] = true;
                let stack = [
                    $a0c4a455532e6de7$var$toStack(root)
                ];
                while(stack.length > 0){
                    let promise = this.visitTick(stack);
                    if ($a0c4a455532e6de7$var$isPromise(promise)) try {
                        await promise;
                    } catch (e) {
                        let node = stack[stack.length - 1].node;
                        throw this.handleError(e, node);
                    }
                }
            }
            if (this.listeners.OnceExit) for (let [plugin, visitor] of this.listeners.OnceExit){
                this.result.lastPlugin = plugin;
                try {
                    if (root.type === "document") {
                        let roots = root.nodes.map((subRoot)=>visitor(subRoot, this.helpers));
                        await Promise.all(roots);
                    } else await visitor(root, this.helpers);
                } catch (e) {
                    throw this.handleError(e);
                }
            }
        }
        this.processed = true;
        return this.stringify();
    }
    runOnRoot(plugin) {
        this.result.lastPlugin = plugin;
        try {
            if (typeof plugin === "object" && plugin.Once) {
                if (this.result.root.type === "document") {
                    let roots = this.result.root.nodes.map((root)=>plugin.Once(root, this.helpers));
                    if ($a0c4a455532e6de7$var$isPromise(roots[0])) return Promise.all(roots);
                    return roots;
                }
                return plugin.Once(this.result.root, this.helpers);
            } else if (typeof plugin === "function") return plugin(this.result.root, this.result);
        } catch (error) {
            throw this.handleError(error);
        }
    }
    stringify() {
        if (this.error) throw this.error;
        if (this.stringified) return this.result;
        this.stringified = true;
        this.sync();
        let opts = this.result.opts;
        let str = $9d5cc43a7e8041f7$exports;
        if (opts.syntax) str = opts.syntax.stringify;
        if (opts.stringifier) str = opts.stringifier;
        if (str.stringify) str = str.stringify;
        let map = new $7d09741193654ec2$exports(str, this.result.root, this.result.opts);
        let data = map.generate();
        this.result.css = data[0];
        this.result.map = data[1];
        return this.result;
    }
    sync() {
        if (this.error) throw this.error;
        if (this.processed) return this.result;
        this.processed = true;
        if (this.processing) throw this.getAsyncError();
        for (let plugin of this.plugins){
            let promise = this.runOnRoot(plugin);
            if ($a0c4a455532e6de7$var$isPromise(promise)) throw this.getAsyncError();
        }
        this.prepareVisitors();
        if (this.hasListener) {
            let root = this.result.root;
            while(!root[$a0c4a455532e6de7$require$isClean]){
                root[$a0c4a455532e6de7$require$isClean] = true;
                this.walkSync(root);
            }
            if (this.listeners.OnceExit) {
                if (root.type === "document") for (let subRoot of root.nodes)this.visitSync(this.listeners.OnceExit, subRoot);
                else this.visitSync(this.listeners.OnceExit, root);
            }
        }
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this.css;
    }
    visitSync(visitors, node) {
        for (let [plugin, visitor] of visitors){
            this.result.lastPlugin = plugin;
            let promise;
            try {
                promise = visitor(node, this.helpers);
            } catch (e) {
                throw this.handleError(e, node.proxyOf);
            }
            if (node.type !== "root" && node.type !== "document" && !node.parent) return true;
            if ($a0c4a455532e6de7$var$isPromise(promise)) throw this.getAsyncError();
        }
    }
    visitTick(stack) {
        let visit = stack[stack.length - 1];
        let { node: node, visitors: visitors } = visit;
        if (node.type !== "root" && node.type !== "document" && !node.parent) {
            stack.pop();
            return;
        }
        if (visitors.length > 0 && visit.visitorIndex < visitors.length) {
            let [plugin, visitor] = visitors[visit.visitorIndex];
            visit.visitorIndex += 1;
            if (visit.visitorIndex === visitors.length) {
                visit.visitors = [];
                visit.visitorIndex = 0;
            }
            this.result.lastPlugin = plugin;
            try {
                return visitor(node.toProxy(), this.helpers);
            } catch (e) {
                throw this.handleError(e, node);
            }
        }
        if (visit.iterator !== 0) {
            let iterator = visit.iterator;
            let child;
            while(child = node.nodes[node.indexes[iterator]]){
                node.indexes[iterator] += 1;
                if (!child[$a0c4a455532e6de7$require$isClean]) {
                    child[$a0c4a455532e6de7$require$isClean] = true;
                    stack.push($a0c4a455532e6de7$var$toStack(child));
                    return;
                }
            }
            visit.iterator = 0;
            delete node.indexes[iterator];
        }
        let events = visit.events;
        while(visit.eventIndex < events.length){
            let event = events[visit.eventIndex];
            visit.eventIndex += 1;
            if (event === $a0c4a455532e6de7$var$CHILDREN) {
                if (node.nodes && node.nodes.length) {
                    node[$a0c4a455532e6de7$require$isClean] = true;
                    visit.iterator = node.getIterator();
                }
                return;
            } else if (this.listeners[event]) {
                visit.visitors = this.listeners[event];
                return;
            }
        }
        stack.pop();
    }
    walkSync(node) {
        node[$a0c4a455532e6de7$require$isClean] = true;
        let events = $a0c4a455532e6de7$var$getEvents(node);
        for (let event of events){
            if (event === $a0c4a455532e6de7$var$CHILDREN) {
                if (node.nodes) node.each((child)=>{
                    if (!child[$a0c4a455532e6de7$require$isClean]) this.walkSync(child);
                });
            } else {
                let visitors = this.listeners[event];
                if (visitors) {
                    if (this.visitSync(visitors, node.toProxy())) return;
                }
            }
        }
    }
    warnings() {
        return this.sync().warnings();
    }
    get content() {
        return this.stringify().content;
    }
    get css() {
        return this.stringify().css;
    }
    get map() {
        return this.stringify().map;
    }
    get messages() {
        return this.sync().messages;
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        return this.sync().root;
    }
    get [Symbol.toStringTag]() {
        return "LazyResult";
    }
}
$a0c4a455532e6de7$var$LazyResult.registerPostcss = (dependant)=>{
    $a0c4a455532e6de7$var$postcss = dependant;
};
$a0c4a455532e6de7$exports = $a0c4a455532e6de7$var$LazyResult;
$a0c4a455532e6de7$var$LazyResult.default = $a0c4a455532e6de7$var$LazyResult;
$c794908ed4c96ae5$exports.registerLazyResult($a0c4a455532e6de7$var$LazyResult);
$7f0176123800bc8f$exports.registerLazyResult($a0c4a455532e6de7$var$LazyResult);



var $e63745e9bcf952e5$exports = {};
"use strict";
var $c576eefbeaf937ae$exports = {};
"use strict";





class $c576eefbeaf937ae$var$NoWorkResult {
    constructor(processor, css, opts){
        css = css.toString();
        this.stringified = false;
        this._processor = processor;
        this._css = css;
        this._opts = opts;
        this._map = undefined;
        let root;
        let str = $9d5cc43a7e8041f7$exports;
        this.result = new $e6eaf3b49b2363e7$exports(this._processor, root, this._opts);
        this.result.css = css;
        let self = this;
        Object.defineProperty(this.result, "root", {
            get () {
                return self.root;
            }
        });
        let map = new $7d09741193654ec2$exports(str, root, this._opts, css);
        if (map.isMap()) {
            let [generatedCSS, generatedMap] = map.generate();
            if (generatedCSS) this.result.css = generatedCSS;
            if (generatedMap) this.result.map = generatedMap;
        }
    }
    async() {
        if (this.error) return Promise.reject(this.error);
        return Promise.resolve(this.result);
    }
    catch(onRejected) {
        return this.async().catch(onRejected);
    }
    finally(onFinally) {
        return this.async().then(onFinally, onFinally);
    }
    sync() {
        if (this.error) throw this.error;
        return this.result;
    }
    then(onFulfilled, onRejected) {
        return this.async().then(onFulfilled, onRejected);
    }
    toString() {
        return this._css;
    }
    warnings() {
        return [];
    }
    get content() {
        return this.result.css;
    }
    get css() {
        return this.result.css;
    }
    get map() {
        return this.result.map;
    }
    get messages() {
        return [];
    }
    get opts() {
        return this.result.opts;
    }
    get processor() {
        return this.result.processor;
    }
    get root() {
        if (this._root) return this._root;
        let root;
        let parser = $6b068f93e39f4567$exports;
        try {
            root = parser(this._css, this._opts);
        } catch (error) {
            this.error = error;
        }
        if (this.error) throw this.error;
        else {
            this._root = root;
            return root;
        }
    }
    get [Symbol.toStringTag]() {
        return "NoWorkResult";
    }
}
$c576eefbeaf937ae$exports = $c576eefbeaf937ae$var$NoWorkResult;
$c576eefbeaf937ae$var$NoWorkResult.default = $c576eefbeaf937ae$var$NoWorkResult;





class $e63745e9bcf952e5$var$Processor {
    constructor(plugins = []){
        this.version = "8.4.31";
        this.plugins = this.normalize(plugins);
    }
    normalize(plugins) {
        let normalized = [];
        for (let i of plugins){
            if (i.postcss === true) i = i();
            else if (i.postcss) i = i.postcss;
            if (typeof i === "object" && Array.isArray(i.plugins)) normalized = normalized.concat(i.plugins);
            else if (typeof i === "object" && i.postcssPlugin) normalized.push(i);
            else if (typeof i === "function") normalized.push(i);
            else if (typeof i === "object" && (i.parse || i.stringify)) ;
            else throw new Error(i + " is not a PostCSS plugin");
        }
        return normalized;
    }
    process(css, opts = {}) {
        if (this.plugins.length === 0 && typeof opts.parser === "undefined" && typeof opts.stringifier === "undefined" && typeof opts.syntax === "undefined") return new $c576eefbeaf937ae$exports(this, css, opts);
        else return new $a0c4a455532e6de7$exports(this, css, opts);
    }
    use(plugin) {
        this.plugins = this.plugins.concat(this.normalize([
            plugin
        ]));
        return this;
    }
}
$e63745e9bcf952e5$exports = $e63745e9bcf952e5$var$Processor;
$e63745e9bcf952e5$var$Processor.default = $e63745e9bcf952e5$var$Processor;
$c794908ed4c96ae5$exports.registerProcessor($e63745e9bcf952e5$var$Processor);
$7f0176123800bc8f$exports.registerProcessor($e63745e9bcf952e5$var$Processor);



var $001d7cb1e3539c57$exports = {};
"use strict";







function $001d7cb1e3539c57$var$fromJSON(json, inputs) {
    if (Array.isArray(json)) return json.map((n)=>$001d7cb1e3539c57$var$fromJSON(n));
    let { inputs: ownInputs, ...defaults } = json;
    if (ownInputs) {
        inputs = [];
        for (let input of ownInputs){
            let inputHydrated = {
                ...input,
                __proto__: $bd2a9823f230228f$exports.prototype
            };
            if (inputHydrated.map) inputHydrated.map = {
                ...inputHydrated.map,
                __proto__: $696a2f669b51b36f$exports.prototype
            };
            inputs.push(inputHydrated);
        }
    }
    if (defaults.nodes) defaults.nodes = json.nodes.map((n)=>$001d7cb1e3539c57$var$fromJSON(n, inputs));
    if (defaults.source) {
        let { inputId: inputId, ...source } = defaults.source;
        defaults.source = source;
        if (inputId != null) defaults.source.input = inputs[inputId];
    }
    if (defaults.type === "root") return new $c794908ed4c96ae5$exports(defaults);
    else if (defaults.type === "decl") return new $f96b5e8a06a46319$exports(defaults);
    else if (defaults.type === "rule") return new $92d8d3cba5dd68fd$exports(defaults);
    else if (defaults.type === "comment") return new $180cb4710d883b41$exports(defaults);
    else if (defaults.type === "atrule") return new $be3d3d8637ea2730$exports(defaults);
    else throw new Error("Unknown node type: " + json.type);
}
$001d7cb1e3539c57$exports = $001d7cb1e3539c57$var$fromJSON;
$001d7cb1e3539c57$var$fromJSON.default = $001d7cb1e3539c57$var$fromJSON;













function $798e02f7da0a718d$var$postcss(...plugins) {
    if (plugins.length === 1 && Array.isArray(plugins[0])) plugins = plugins[0];
    return new $e63745e9bcf952e5$exports(plugins);
}
$798e02f7da0a718d$var$postcss.plugin = function plugin(name, initializer) {
    let warningPrinted = false;
    function creator(...args) {
        // eslint-disable-next-line no-console
        if (console && console.warn && !warningPrinted) {
            warningPrinted = true;
            // eslint-disable-next-line no-console
            console.warn(name + ": postcss.plugin was deprecated. Migration guide:\n" + "https://evilmartians.com/chronicles/postcss-8-plugin-migration");
        }
        let transformer = initializer(...args);
        transformer.postcssPlugin = name;
        transformer.postcssVersion = new $e63745e9bcf952e5$exports().version;
        return transformer;
    }
    let cache;
    Object.defineProperty(creator, "postcss", {
        get () {
            if (!cache) cache = creator();
            return cache;
        }
    });
    creator.process = function(css, processOpts, pluginOpts) {
        return $798e02f7da0a718d$var$postcss([
            creator(pluginOpts)
        ]).process(css, processOpts);
    };
    return creator;
};
$798e02f7da0a718d$var$postcss.stringify = $9d5cc43a7e8041f7$exports;
$798e02f7da0a718d$var$postcss.parse = $6b068f93e39f4567$exports;
$798e02f7da0a718d$var$postcss.fromJSON = $001d7cb1e3539c57$exports;
$798e02f7da0a718d$var$postcss.list = $4593d3f828590853$exports;
$798e02f7da0a718d$var$postcss.comment = (defaults)=>new $180cb4710d883b41$exports(defaults);
$798e02f7da0a718d$var$postcss.atRule = (defaults)=>new $be3d3d8637ea2730$exports(defaults);
$798e02f7da0a718d$var$postcss.decl = (defaults)=>new $f96b5e8a06a46319$exports(defaults);
$798e02f7da0a718d$var$postcss.rule = (defaults)=>new $92d8d3cba5dd68fd$exports(defaults);
$798e02f7da0a718d$var$postcss.root = (defaults)=>new $c794908ed4c96ae5$exports(defaults);
$798e02f7da0a718d$var$postcss.document = (defaults)=>new $7f0176123800bc8f$exports(defaults);
$798e02f7da0a718d$var$postcss.CssSyntaxError = $1ef91c4708632651$exports;
$798e02f7da0a718d$var$postcss.Declaration = $f96b5e8a06a46319$exports;
$798e02f7da0a718d$var$postcss.Container = $a5adda6408996a1c$exports;
$798e02f7da0a718d$var$postcss.Processor = $e63745e9bcf952e5$exports;
$798e02f7da0a718d$var$postcss.Document = $7f0176123800bc8f$exports;
$798e02f7da0a718d$var$postcss.Comment = $180cb4710d883b41$exports;
$798e02f7da0a718d$var$postcss.Warning = $550f9a84a3022c76$exports;
$798e02f7da0a718d$var$postcss.AtRule = $be3d3d8637ea2730$exports;
$798e02f7da0a718d$var$postcss.Result = $e6eaf3b49b2363e7$exports;
$798e02f7da0a718d$var$postcss.Input = $bd2a9823f230228f$exports;
$798e02f7da0a718d$var$postcss.Rule = $92d8d3cba5dd68fd$exports;
$798e02f7da0a718d$var$postcss.Root = $c794908ed4c96ae5$exports;
$798e02f7da0a718d$var$postcss.Node = $a86fcc2c0b06d3d6$exports;
$a0c4a455532e6de7$exports.registerPostcss($798e02f7da0a718d$var$postcss);
$798e02f7da0a718d$exports = $798e02f7da0a718d$var$postcss;
$798e02f7da0a718d$var$postcss.default = $798e02f7da0a718d$var$postcss;


var $5a5e255be41ec1f1$require$postcssParse = $798e02f7da0a718d$exports.parse;
// Tags that can conceivably represent stand-alone media.
const $5a5e255be41ec1f1$var$mediaTags = [
    "img",
    "audio",
    "video",
    "picture",
    "svg",
    "object",
    "map",
    "iframe",
    "embed"
];
// Tags that are inherently vulnerable to being used in XSS attacks.
const $5a5e255be41ec1f1$var$vulnerableTags = [
    "script",
    "style"
];
function $5a5e255be41ec1f1$var$each(obj, cb) {
    if (obj) Object.keys(obj).forEach(function(key) {
        cb(obj[key], key);
    });
}
// Avoid false positives with .__proto__, .hasOwnProperty, etc.
function $5a5e255be41ec1f1$var$has(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
// Returns those elements of `a` for which `cb(a)` returns truthy
function $5a5e255be41ec1f1$var$filter(a, cb) {
    const n = [];
    $5a5e255be41ec1f1$var$each(a, function(v) {
        if (cb(v)) n.push(v);
    });
    return n;
}
function $5a5e255be41ec1f1$var$isEmptyObject(obj) {
    for(const key in obj){
        if ($5a5e255be41ec1f1$var$has(obj, key)) return false;
    }
    return true;
}
function $5a5e255be41ec1f1$var$stringifySrcset(parsedSrcset) {
    return parsedSrcset.map(function(part) {
        if (!part.url) throw new Error("URL missing");
        return part.url + (part.w ? ` ${part.w}w` : "") + (part.h ? ` ${part.h}h` : "") + (part.d ? ` ${part.d}x` : "");
    }).join(", ");
}
$5a5e255be41ec1f1$exports = $5a5e255be41ec1f1$var$sanitizeHtml;
// A valid attribute name.
// We use a tolerant definition based on the set of strings defined by
// html.spec.whatwg.org/multipage/parsing.html#before-attribute-name-state
// and html.spec.whatwg.org/multipage/parsing.html#attribute-name-state .
// The characters accepted are ones which can be appended to the attribute
// name buffer without triggering a parse error:
//   * unexpected-equals-sign-before-attribute-name
//   * unexpected-null-character
//   * unexpected-character-in-attribute-name
// We exclude the empty string because it's impossible to get to the after
// attribute name state with an empty attribute name buffer.
const $5a5e255be41ec1f1$var$VALID_HTML_ATTRIBUTE_NAME = /^[^\0\t\n\f\r /<=>]+$/;
// Ignore the _recursing flag; it's there for recursive
// invocation as a guard against this exploit:
// https://github.com/fb55/htmlparser2/issues/105
function $5a5e255be41ec1f1$var$sanitizeHtml(html, options, _recursing) {
    if (html == null) return "";
    if (typeof html === "number") html = html.toString();
    let result = "";
    // Used for hot swapping the result variable with an empty string in order to "capture" the text written to it.
    let tempResult = "";
    function Frame(tag, attribs) {
        const that = this;
        this.tag = tag;
        this.attribs = attribs || {};
        this.tagPosition = result.length;
        this.text = ""; // Node inner text
        this.mediaChildren = [];
        this.updateParentNodeText = function() {
            if (stack.length) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.text += that.text;
            }
        };
        this.updateParentNodeMediaChildren = function() {
            if (stack.length && $5a5e255be41ec1f1$var$mediaTags.includes(this.tag)) {
                const parentFrame = stack[stack.length - 1];
                parentFrame.mediaChildren.push(this.tag);
            }
        };
    }
    options = Object.assign({}, $5a5e255be41ec1f1$var$sanitizeHtml.defaults, options);
    options.parser = Object.assign({}, $5a5e255be41ec1f1$var$htmlParserDefaults, options.parser);
    const tagAllowed = function(name) {
        return options.allowedTags === false || (options.allowedTags || []).indexOf(name) > -1;
    };
    // vulnerableTags
    $5a5e255be41ec1f1$var$vulnerableTags.forEach(function(tag) {
        if (tagAllowed(tag) && !options.allowVulnerableTags) console.warn(`

\u{26A0}\u{FE0F} Your \`allowedTags\` option includes, \`${tag}\`, which is inherently\nvulnerable to XSS attacks. Please remove it from \`allowedTags\`.\nOr, to disable this warning, add the \`allowVulnerableTags\` option\nand ensure you are accounting for this risk.\n\n`);
    });
    // Tags that contain something other than HTML, or where discarding
    // the text when the tag is disallowed makes sense for other reasons.
    // If we are not allowing these tags, we should drop their content too.
    // For other tags you would drop the tag but keep its content.
    const nonTextTagsArray = options.nonTextTags || [
        "script",
        "style",
        "textarea",
        "option"
    ];
    let allowedAttributesMap;
    let allowedAttributesGlobMap;
    if (options.allowedAttributes) {
        allowedAttributesMap = {};
        allowedAttributesGlobMap = {};
        $5a5e255be41ec1f1$var$each(options.allowedAttributes, function(attributes, tag) {
            allowedAttributesMap[tag] = [];
            const globRegex = [];
            attributes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($3f3faafe3b230b68$exports(obj).replace(/\\\*/g, ".*"));
                else allowedAttributesMap[tag].push(obj);
            });
            if (globRegex.length) allowedAttributesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        });
    }
    const allowedClassesMap = {};
    const allowedClassesGlobMap = {};
    const allowedClassesRegexMap = {};
    $5a5e255be41ec1f1$var$each(options.allowedClasses, function(classes, tag) {
        // Implicitly allows the class attribute
        if (allowedAttributesMap) {
            if (!$5a5e255be41ec1f1$var$has(allowedAttributesMap, tag)) allowedAttributesMap[tag] = [];
            allowedAttributesMap[tag].push("class");
        }
        allowedClassesMap[tag] = classes;
        if (Array.isArray(classes)) {
            const globRegex = [];
            allowedClassesMap[tag] = [];
            allowedClassesRegexMap[tag] = [];
            classes.forEach(function(obj) {
                if (typeof obj === "string" && obj.indexOf("*") >= 0) globRegex.push($3f3faafe3b230b68$exports(obj).replace(/\\\*/g, ".*"));
                else if (obj instanceof RegExp) allowedClassesRegexMap[tag].push(obj);
                else allowedClassesMap[tag].push(obj);
            });
            if (globRegex.length) allowedClassesGlobMap[tag] = new RegExp("^(" + globRegex.join("|") + ")$");
        }
    });
    const transformTagsMap = {};
    let transformTagsAll;
    $5a5e255be41ec1f1$var$each(options.transformTags, function(transform, tag) {
        let transFun;
        if (typeof transform === "function") transFun = transform;
        else if (typeof transform === "string") transFun = $5a5e255be41ec1f1$var$sanitizeHtml.simpleTransform(transform);
        if (tag === "*") transformTagsAll = transFun;
        else transformTagsMap[tag] = transFun;
    });
    let depth;
    let stack;
    let skipMap;
    let transformMap;
    let skipText;
    let skipTextDepth;
    let addedText = false;
    initializeState();
    const parser = new $9a82279beb63eb09$exports.Parser({
        onopentag: function(name, attribs) {
            // If `enforceHtmlBoundary` is `true` and this has found the opening
            // `html` tag, reset the state.
            if (options.enforceHtmlBoundary && name === "html") initializeState();
            if (skipText) {
                skipTextDepth++;
                return;
            }
            const frame = new Frame(name, attribs);
            stack.push(frame);
            let skip = false;
            const hasText = !!frame.text;
            let transformedTag;
            if ($5a5e255be41ec1f1$var$has(transformTagsMap, name)) {
                transformedTag = transformTagsMap[name](name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (transformedTag.text !== undefined) frame.innerText = transformedTag.text;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (transformTagsAll) {
                transformedTag = transformTagsAll(name, attribs);
                frame.attribs = attribs = transformedTag.attribs;
                if (name !== transformedTag.tagName) {
                    frame.name = name = transformedTag.tagName;
                    transformMap[depth] = transformedTag.tagName;
                }
            }
            if (!tagAllowed(name) || options.disallowedTagsMode === "recursiveEscape" && !$5a5e255be41ec1f1$var$isEmptyObject(skipMap) || options.nestingLimit != null && depth >= options.nestingLimit) {
                skip = true;
                skipMap[depth] = true;
                if (options.disallowedTagsMode === "discard") {
                    if (nonTextTagsArray.indexOf(name) !== -1) {
                        skipText = true;
                        skipTextDepth = 1;
                    }
                }
                skipMap[depth] = true;
            }
            depth++;
            if (skip) {
                if (options.disallowedTagsMode === "discard") // We want the contents but not this tag
                return;
                tempResult = result;
                result = "";
            }
            result += "<" + name;
            if (name === "script") {
                if (options.allowedScriptHostnames || options.allowedScriptDomains) frame.innerText = "";
            }
            if (!allowedAttributesMap || $5a5e255be41ec1f1$var$has(allowedAttributesMap, name) || allowedAttributesMap["*"]) $5a5e255be41ec1f1$var$each(attribs, function(value, a) {
                if (!$5a5e255be41ec1f1$var$VALID_HTML_ATTRIBUTE_NAME.test(a)) {
                    // This prevents part of an attribute name in the output from being
                    // interpreted as the end of an attribute, or end of a tag.
                    delete frame.attribs[a];
                    return;
                }
                // If the value is empty, and this is a known non-boolean attribute, delete it
                // List taken from https://html.spec.whatwg.org/multipage/indices.html#attributes-3
                if (value === "" && (options.nonBooleanAttributes.includes(a) || options.nonBooleanAttributes.includes("*"))) {
                    delete frame.attribs[a];
                    return;
                }
                // check allowedAttributesMap for the element and attribute and modify the value
                // as necessary if there are specific values defined.
                let passedAllowedAttributesMapCheck = false;
                if (!allowedAttributesMap || $5a5e255be41ec1f1$var$has(allowedAttributesMap, name) && allowedAttributesMap[name].indexOf(a) !== -1 || allowedAttributesMap["*"] && allowedAttributesMap["*"].indexOf(a) !== -1 || $5a5e255be41ec1f1$var$has(allowedAttributesGlobMap, name) && allowedAttributesGlobMap[name].test(a) || allowedAttributesGlobMap["*"] && allowedAttributesGlobMap["*"].test(a)) passedAllowedAttributesMapCheck = true;
                else if (allowedAttributesMap && allowedAttributesMap[name]) {
                    for (const o of allowedAttributesMap[name])if ($5a5e255be41ec1f1$require$isPlainObject(o) && o.name && o.name === a) {
                        passedAllowedAttributesMapCheck = true;
                        let newValue = "";
                        if (o.multiple === true) {
                            // verify the values that are allowed
                            const splitStrArray = value.split(" ");
                            for (const s of splitStrArray)if (o.values.indexOf(s) !== -1) {
                                if (newValue === "") newValue = s;
                                else newValue += " " + s;
                            }
                        } else if (o.values.indexOf(value) >= 0) // verified an allowed value matches the entire attribute value
                        newValue = value;
                        value = newValue;
                    }
                }
                if (passedAllowedAttributesMapCheck) {
                    if (options.allowedSchemesAppliedToAttributes.indexOf(a) !== -1) {
                        if (naughtyHref(name, value)) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "script" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (options.allowedScriptHostnames || options.allowedScriptDomains) {
                                const allowedHostname = (options.allowedScriptHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedScriptDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (name === "iframe" && a === "src") {
                        let allowed = true;
                        try {
                            const parsed = parseUrl(value);
                            if (parsed.isRelativeUrl) // default value of allowIframeRelativeUrls is true
                            // unless allowedIframeHostnames or allowedIframeDomains specified
                            allowed = $5a5e255be41ec1f1$var$has(options, "allowIframeRelativeUrls") ? options.allowIframeRelativeUrls : !options.allowedIframeHostnames && !options.allowedIframeDomains;
                            else if (options.allowedIframeHostnames || options.allowedIframeDomains) {
                                const allowedHostname = (options.allowedIframeHostnames || []).find(function(hostname) {
                                    return hostname === parsed.url.hostname;
                                });
                                const allowedDomain = (options.allowedIframeDomains || []).find(function(domain) {
                                    return parsed.url.hostname === domain || parsed.url.hostname.endsWith(`.${domain}`);
                                });
                                allowed = allowedHostname || allowedDomain;
                            }
                        } catch (e) {
                            // Unparseable iframe src
                            allowed = false;
                        }
                        if (!allowed) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "srcset") try {
                        let parsed = $5b9f703d39f199e9$exports(value);
                        parsed.forEach(function(value) {
                            if (naughtyHref("srcset", value.url)) value.evil = true;
                        });
                        parsed = $5a5e255be41ec1f1$var$filter(parsed, function(v) {
                            return !v.evil;
                        });
                        if (!parsed.length) {
                            delete frame.attribs[a];
                            return;
                        } else {
                            value = $5a5e255be41ec1f1$var$stringifySrcset($5a5e255be41ec1f1$var$filter(parsed, function(v) {
                                return !v.evil;
                            }));
                            frame.attribs[a] = value;
                        }
                    } catch (e) {
                        // Unparseable srcset
                        delete frame.attribs[a];
                        return;
                    }
                    if (a === "class") {
                        const allowedSpecificClasses = allowedClassesMap[name];
                        const allowedWildcardClasses = allowedClassesMap["*"];
                        const allowedSpecificClassesGlob = allowedClassesGlobMap[name];
                        const allowedSpecificClassesRegex = allowedClassesRegexMap[name];
                        const allowedWildcardClassesGlob = allowedClassesGlobMap["*"];
                        const allowedClassesGlobs = [
                            allowedSpecificClassesGlob,
                            allowedWildcardClassesGlob
                        ].concat(allowedSpecificClassesRegex).filter(function(t) {
                            return t;
                        });
                        if (allowedSpecificClasses && allowedWildcardClasses) value = filterClasses(value, $8182c743591e3d4d$exports(allowedSpecificClasses, allowedWildcardClasses), allowedClassesGlobs);
                        else value = filterClasses(value, allowedSpecificClasses || allowedWildcardClasses, allowedClassesGlobs);
                        if (!value.length) {
                            delete frame.attribs[a];
                            return;
                        }
                    }
                    if (a === "style") {
                        if (options.parseStyleAttributes) try {
                            const abstractSyntaxTree = $5a5e255be41ec1f1$require$postcssParse(name + " {" + value + "}");
                            const filteredAST = filterCss(abstractSyntaxTree, options.allowedStyles);
                            value = stringifyStyleAttributes(filteredAST);
                            if (value.length === 0) {
                                delete frame.attribs[a];
                                return;
                            }
                        } catch (e) {
                            if (typeof window !== "undefined") console.warn('Failed to parse "' + name + " {" + value + "}" + "\", If you're running this in a browser, we recommend to disable style parsing: options.parseStyleAttributes: false, since this only works in a node environment due to a postcss dependency, More info: https://github.com/apostrophecms/sanitize-html/issues/547");
                            delete frame.attribs[a];
                            return;
                        }
                        else if (options.allowedStyles) throw new Error("allowedStyles option cannot be used together with parseStyleAttributes: false.");
                    }
                    result += " " + a;
                    if (value && value.length) result += '="' + escapeHtml(value, true) + '"';
                } else delete frame.attribs[a];
            });
            if (options.selfClosing.indexOf(name) !== -1) result += " />";
            else {
                result += ">";
                if (frame.innerText && !hasText && !options.textFilter) {
                    result += escapeHtml(frame.innerText);
                    addedText = true;
                }
            }
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
        },
        ontext: function(text) {
            if (skipText) return;
            const lastFrame = stack[stack.length - 1];
            let tag;
            if (lastFrame) {
                tag = lastFrame.tag;
                // If inner text was set by transform function then let's use it
                text = lastFrame.innerText !== undefined ? lastFrame.innerText : text;
            }
            if (options.disallowedTagsMode === "discard" && (tag === "script" || tag === "style")) // htmlparser2 gives us these as-is. Escaping them ruins the content. Allowing
            // script tags is, by definition, game over for XSS protection, so if that's
            // your concern, don't allow them. The same is essentially true for style tags
            // which have their own collection of XSS vectors.
            result += text;
            else {
                const escaped = escapeHtml(text, false);
                if (options.textFilter && !addedText) result += options.textFilter(escaped, tag);
                else if (!addedText) result += escaped;
            }
            if (stack.length) {
                const frame = stack[stack.length - 1];
                frame.text += text;
            }
        },
        onclosetag: function(name, isImplied) {
            if (skipText) {
                skipTextDepth--;
                if (!skipTextDepth) skipText = false;
                else return;
            }
            const frame = stack.pop();
            if (!frame) // Do not crash on bad markup
            return;
            if (frame.tag !== name) {
                // Another case of bad markup.
                // Push to stack, so that it will be used in future closing tags.
                stack.push(frame);
                return;
            }
            skipText = options.enforceHtmlBoundary ? name === "html" : false;
            depth--;
            const skip = skipMap[depth];
            if (skip) {
                delete skipMap[depth];
                if (options.disallowedTagsMode === "discard") {
                    frame.updateParentNodeText();
                    return;
                }
                tempResult = result;
                result = "";
            }
            if (transformMap[depth]) {
                name = transformMap[depth];
                delete transformMap[depth];
            }
            if (options.exclusiveFilter && options.exclusiveFilter(frame)) {
                result = result.substr(0, frame.tagPosition);
                return;
            }
            frame.updateParentNodeMediaChildren();
            frame.updateParentNodeText();
            if (// Already output />
            options.selfClosing.indexOf(name) !== -1 || // Escaped tag, closing tag is implied
            isImplied && !tagAllowed(name) && [
                "escape",
                "recursiveEscape"
            ].indexOf(options.disallowedTagsMode) >= 0) {
                if (skip) {
                    result = tempResult;
                    tempResult = "";
                }
                return;
            }
            result += "</" + name + ">";
            if (skip) {
                result = tempResult + escapeHtml(result);
                tempResult = "";
            }
            addedText = false;
        }
    }, options.parser);
    parser.write(html);
    parser.end();
    return result;
    function initializeState() {
        result = "";
        depth = 0;
        stack = [];
        skipMap = {};
        transformMap = {};
        skipText = false;
        skipTextDepth = 0;
    }
    function escapeHtml(s, quote) {
        if (typeof s !== "string") s = s + "";
        if (options.parser.decodeEntities) {
            s = s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
            if (quote) s = s.replace(/"/g, "&quot;");
        }
        // TODO: this is inadequate because it will pass `&0;`. This approach
        // will not work, each & must be considered with regard to whether it
        // is followed by a 100% syntactically valid entity or not, and escaped
        // if it is not. If this bothers you, don't set parser.decodeEntities
        // to false. (The default is true.)
        s = s.replace(/&(?![a-zA-Z0-9#]{1,20};)/g, "&amp;") // Match ampersands not part of existing HTML entity
        .replace(/</g, "&lt;").replace(/>/g, "&gt;");
        if (quote) s = s.replace(/"/g, "&quot;");
        return s;
    }
    function naughtyHref(name, href) {
        // Browsers ignore character codes of 32 (space) and below in a surprising
        // number of situations. Start reading here:
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet#Embedded_tab
        // eslint-disable-next-line no-control-regex
        href = href.replace(/[\x00-\x20]+/g, "");
        // Clobber any comments in URLs, which the browser might
        // interpret inside an XML data island, allowing
        // a javascript: URL to be snuck through
        while(true){
            const firstIndex = href.indexOf("<!--");
            if (firstIndex === -1) break;
            const lastIndex = href.indexOf("-->", firstIndex + 4);
            if (lastIndex === -1) break;
            href = href.substring(0, firstIndex) + href.substring(lastIndex + 3);
        }
        // Case insensitive so we don't get faked out by JAVASCRIPT #1
        // Allow more characters after the first so we don't get faked
        // out by certain schemes browsers accept
        const matches = href.match(/^([a-zA-Z][a-zA-Z0-9.\-+]*):/);
        if (!matches) {
            // Protocol-relative URL starting with any combination of '/' and '\'
            if (href.match(/^[/\\]{2}/)) return !options.allowProtocolRelative;
            // No scheme
            return false;
        }
        const scheme = matches[1].toLowerCase();
        if ($5a5e255be41ec1f1$var$has(options.allowedSchemesByTag, name)) return options.allowedSchemesByTag[name].indexOf(scheme) === -1;
        return !options.allowedSchemes || options.allowedSchemes.indexOf(scheme) === -1;
    }
    function parseUrl(value) {
        value = value.replace(/^(\w+:)?\s*[\\/]\s*[\\/]/, "$1//");
        if (value.startsWith("relative:")) // An attempt to exploit our workaround for base URLs being
        // mandatory for relative URL validation in the WHATWG
        // URL parser, reject it
        throw new Error("relative: exploit attempt");
        // naughtyHref is in charge of whether protocol relative URLs
        // are cool. Here we are concerned just with allowed hostnames and
        // whether to allow relative URLs.
        //
        // Build a placeholder "base URL" against which any reasonable
        // relative URL may be parsed successfully
        let base = "relative://relative-site";
        for(let i = 0; i < 100; i++)base += `/${i}`;
        const parsed = new URL(value, base);
        const isRelativeUrl = parsed && parsed.hostname === "relative-site" && parsed.protocol === "relative:";
        return {
            isRelativeUrl: isRelativeUrl,
            url: parsed
        };
    }
    /**
   * Filters user input css properties by allowlisted regex attributes.
   * Modifies the abstractSyntaxTree object.
   *
   * @param {object} abstractSyntaxTree  - Object representation of CSS attributes.
   * @property {array[Declaration]} abstractSyntaxTree.nodes[0] - Each object cointains prop and value key, i.e { prop: 'color', value: 'red' }.
   * @param {object} allowedStyles       - Keys are properties (i.e color), value is list of permitted regex rules (i.e /green/i).
   * @return {object}                    - The modified tree.
   */ function filterCss(abstractSyntaxTree, allowedStyles) {
        if (!allowedStyles) return abstractSyntaxTree;
        const astRules = abstractSyntaxTree.nodes[0];
        let selectedRule;
        // Merge global and tag-specific styles into new AST.
        if (allowedStyles[astRules.selector] && allowedStyles["*"]) selectedRule = $8182c743591e3d4d$exports(allowedStyles[astRules.selector], allowedStyles["*"]);
        else selectedRule = allowedStyles[astRules.selector] || allowedStyles["*"];
        if (selectedRule) abstractSyntaxTree.nodes[0].nodes = astRules.nodes.reduce(filterDeclarations(selectedRule), []);
        return abstractSyntaxTree;
    }
    /**
   * Extracts the style attributes from an AbstractSyntaxTree and formats those
   * values in the inline style attribute format.
   *
   * @param  {AbstractSyntaxTree} filteredAST
   * @return {string}             - Example: "color:yellow;text-align:center !important;font-family:helvetica;"
   */ function stringifyStyleAttributes(filteredAST) {
        return filteredAST.nodes[0].nodes.reduce(function(extractedAttributes, attrObject) {
            extractedAttributes.push(`${attrObject.prop}:${attrObject.value}${attrObject.important ? " !important" : ""}`);
            return extractedAttributes;
        }, []).join(";");
    }
    /**
    * Filters the existing attributes for the given property. Discards any attributes
    * which don't match the allowlist.
    *
    * @param  {object} selectedRule             - Example: { color: red, font-family: helvetica }
    * @param  {array} allowedDeclarationsList   - List of declarations which pass the allowlist.
    * @param  {object} attributeObject          - Object representing the current css property.
    * @property {string} attributeObject.type   - Typically 'declaration'.
    * @property {string} attributeObject.prop   - The CSS property, i.e 'color'.
    * @property {string} attributeObject.value  - The corresponding value to the css property, i.e 'red'.
    * @return {function}                        - When used in Array.reduce, will return an array of Declaration objects
    */ function filterDeclarations(selectedRule) {
        return function(allowedDeclarationsList, attributeObject) {
            // If this property is allowlisted...
            if ($5a5e255be41ec1f1$var$has(selectedRule, attributeObject.prop)) {
                const matchesRegex = selectedRule[attributeObject.prop].some(function(regularExpression) {
                    return regularExpression.test(attributeObject.value);
                });
                if (matchesRegex) allowedDeclarationsList.push(attributeObject);
            }
            return allowedDeclarationsList;
        };
    }
    function filterClasses(classes, allowed, allowedGlobs) {
        if (!allowed) // The class attribute is allowed without filtering on this tag
        return classes;
        classes = classes.split(/\s+/);
        return classes.filter(function(clss) {
            return allowed.indexOf(clss) !== -1 || allowedGlobs.some(function(glob) {
                return glob.test(clss);
            });
        }).join(" ");
    }
}
// Defaults are accessible to you so that you can use them as a starting point
// programmatically if you wish
const $5a5e255be41ec1f1$var$htmlParserDefaults = {
    decodeEntities: true
};
$5a5e255be41ec1f1$var$sanitizeHtml.defaults = {
    allowedTags: [
        // Sections derived from MDN element categories and limited to the more
        // benign categories.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element
        // Content sectioning
        "address",
        "article",
        "aside",
        "footer",
        "header",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "main",
        "nav",
        "section",
        // Text content
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "main",
        "ol",
        "p",
        "pre",
        "ul",
        // Inline text semantics
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        // Table content
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr"
    ],
    // Tags that cannot be boolean
    nonBooleanAttributes: [
        "abbr",
        "accept",
        "accept-charset",
        "accesskey",
        "action",
        "allow",
        "alt",
        "as",
        "autocapitalize",
        "autocomplete",
        "blocking",
        "charset",
        "cite",
        "class",
        "color",
        "cols",
        "colspan",
        "content",
        "contenteditable",
        "coords",
        "crossorigin",
        "data",
        "datetime",
        "decoding",
        "dir",
        "dirname",
        "download",
        "draggable",
        "enctype",
        "enterkeyhint",
        "fetchpriority",
        "for",
        "form",
        "formaction",
        "formenctype",
        "formmethod",
        "formtarget",
        "headers",
        "height",
        "hidden",
        "high",
        "href",
        "hreflang",
        "http-equiv",
        "id",
        "imagesizes",
        "imagesrcset",
        "inputmode",
        "integrity",
        "is",
        "itemid",
        "itemprop",
        "itemref",
        "itemtype",
        "kind",
        "label",
        "lang",
        "list",
        "loading",
        "low",
        "max",
        "maxlength",
        "media",
        "method",
        "min",
        "minlength",
        "name",
        "nonce",
        "optimum",
        "pattern",
        "ping",
        "placeholder",
        "popover",
        "popovertarget",
        "popovertargetaction",
        "poster",
        "preload",
        "referrerpolicy",
        "rel",
        "rows",
        "rowspan",
        "sandbox",
        "scope",
        "shape",
        "size",
        "sizes",
        "slot",
        "span",
        "spellcheck",
        "src",
        "srcdoc",
        "srclang",
        "srcset",
        "start",
        "step",
        "style",
        "tabindex",
        "target",
        "title",
        "translate",
        "type",
        "usemap",
        "value",
        "width",
        "wrap",
        // Event handlers
        "onauxclick",
        "onafterprint",
        "onbeforematch",
        "onbeforeprint",
        "onbeforeunload",
        "onbeforetoggle",
        "onblur",
        "oncancel",
        "oncanplay",
        "oncanplaythrough",
        "onchange",
        "onclick",
        "onclose",
        "oncontextlost",
        "oncontextmenu",
        "oncontextrestored",
        "oncopy",
        "oncuechange",
        "oncut",
        "ondblclick",
        "ondrag",
        "ondragend",
        "ondragenter",
        "ondragleave",
        "ondragover",
        "ondragstart",
        "ondrop",
        "ondurationchange",
        "onemptied",
        "onended",
        "onerror",
        "onfocus",
        "onformdata",
        "onhashchange",
        "oninput",
        "oninvalid",
        "onkeydown",
        "onkeypress",
        "onkeyup",
        "onlanguagechange",
        "onload",
        "onloadeddata",
        "onloadedmetadata",
        "onloadstart",
        "onmessage",
        "onmessageerror",
        "onmousedown",
        "onmouseenter",
        "onmouseleave",
        "onmousemove",
        "onmouseout",
        "onmouseover",
        "onmouseup",
        "onoffline",
        "ononline",
        "onpagehide",
        "onpageshow",
        "onpaste",
        "onpause",
        "onplay",
        "onplaying",
        "onpopstate",
        "onprogress",
        "onratechange",
        "onreset",
        "onresize",
        "onrejectionhandled",
        "onscroll",
        "onscrollend",
        "onsecuritypolicyviolation",
        "onseeked",
        "onseeking",
        "onselect",
        "onslotchange",
        "onstalled",
        "onstorage",
        "onsubmit",
        "onsuspend",
        "ontimeupdate",
        "ontoggle",
        "onunhandledrejection",
        "onunload",
        "onvolumechange",
        "onwaiting",
        "onwheel"
    ],
    disallowedTagsMode: "discard",
    allowedAttributes: {
        a: [
            "href",
            "name",
            "target"
        ],
        // We don't currently allow img itself by default, but
        // these attributes would make sense if we did.
        img: [
            "src",
            "srcset",
            "alt",
            "title",
            "width",
            "height",
            "loading"
        ]
    },
    // Lots of these won't come up by default because we don't allow them
    selfClosing: [
        "img",
        "br",
        "hr",
        "area",
        "base",
        "basefont",
        "input",
        "link",
        "meta"
    ],
    // URL schemes we permit
    allowedSchemes: [
        "http",
        "https",
        "ftp",
        "mailto",
        "tel"
    ],
    allowedSchemesByTag: {},
    allowedSchemesAppliedToAttributes: [
        "href",
        "src",
        "cite"
    ],
    allowProtocolRelative: true,
    enforceHtmlBoundary: false,
    parseStyleAttributes: true
};
$5a5e255be41ec1f1$var$sanitizeHtml.simpleTransform = function(newTagName, newAttribs, merge) {
    merge = merge === undefined ? true : merge;
    newAttribs = newAttribs || {};
    return function(tagName, attribs) {
        let attrib;
        if (merge) for(attrib in newAttribs)attribs[attrib] = newAttribs[attrib];
        else attribs = newAttribs;
        return {
            tagName: newTagName,
            attribs: attribs
        };
    };
};



var $loA2J = parcelRequire("loA2J");

var $loA2J = parcelRequire("loA2J");

var $loA2J = parcelRequire("loA2J");
/* index.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
var $1650107b0b0ea012$exports = {};
Object.defineProperty($1650107b0b0ea012$exports, "__esModule", {
    value: !0
});

var $iSvIT = parcelRequire("iSvIT");
var $63e9c72ca9cb1165$exports = {};
(function webpackUniversalModuleDefinition(root, factory) {
    $63e9c72ca9cb1165$exports = factory();
})($63e9c72ca9cb1165$exports, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": ()=>__WEBPACK_DEFAULT_EXPORT__
                });
                var Rive = (()=>{
                    var _scriptDir = typeof document !== "undefined" && document.currentScript ? document.currentScript.src : undefined;
                    return function(moduleArg = {}) {
                        var m = moduleArg, aa, ea;
                        m.ready = new Promise((a, b)=>{
                            aa = a;
                            ea = b;
                        });
                        function fa() {
                            function a(g) {
                                const n = d;
                                c = b = 0;
                                d = new Map();
                                n.forEach((p)=>{
                                    try {
                                        p(g);
                                    } catch (l) {
                                        console.error(l);
                                    }
                                });
                                this.ob();
                                e && e.Tb();
                            }
                            let b = 0, c = 0, d = new Map(), e = null, f = null;
                            this.requestAnimationFrame = function(g) {
                                b || (b = requestAnimationFrame(a.bind(this)));
                                const n = ++c;
                                d.set(n, g);
                                return n;
                            };
                            this.cancelAnimationFrame = function(g) {
                                d.delete(g);
                                b && 0 == d.size && (cancelAnimationFrame(b), b = 0);
                            };
                            this.Rb = function(g) {
                                f && (document.body.remove(f), f = null);
                                g || (f = document.createElement("div"), f.style.backgroundColor = "black", f.style.position = "fixed", f.style.right = 0, f.style.top = 0, f.style.color = "white", f.style.padding = "4px", f.innerHTML = "RIVE FPS", g = function(n) {
                                    f.innerHTML = "RIVE FPS " + n.toFixed(1);
                                }, document.body.appendChild(f));
                                e = new function() {
                                    let n = 0, p = 0;
                                    this.Tb = function() {
                                        var l = performance.now();
                                        p ? (++n, l -= p, 1000 < l && (g(1000 * n / l), n = p = 0)) : (p = l, n = 0);
                                    };
                                }();
                            };
                            this.Ob = function() {
                                f && (document.body.remove(f), f = null);
                                e = null;
                            };
                            this.ob = function() {};
                        }
                        function ha(a) {
                            console.assert(!0);
                            const b = new Map();
                            let c = -Infinity;
                            this.push = function(d) {
                                d = d + ((1 << a) - 1) >> a;
                                b.has(d) && clearTimeout(b.get(d));
                                b.set(d, setTimeout(function() {
                                    b.delete(d);
                                    0 == b.length ? c = -Infinity : d == c && (c = Math.max(...b.keys()), console.assert(c < d));
                                }, 1000));
                                c = Math.max(d, c);
                                return c << a;
                            };
                        }
                        const ia = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            ia && ia();
                            let a = m.decodeAudio;
                            m.decodeAudio = function(e, f) {
                                e = a(e);
                                f(e);
                            };
                            let b = m.decodeFont;
                            m.decodeFont = function(e, f) {
                                e = b(e);
                                f(e);
                            };
                            const c = m.FileAssetLoader;
                            m.ptrToAsset = (e)=>{
                                let f = m.ptrToFileAsset(e);
                                return f.isImage ? m.ptrToImageAsset(e) : f.isFont ? m.ptrToFontAsset(e) : f.isAudio ? m.ptrToAudioAsset(e) : f;
                            };
                            m.CustomFileAssetLoader = c.extend("CustomFileAssetLoader", {
                                __construct: function({ loadContents: e }) {
                                    this.__parent.__construct.call(this);
                                    this.Gb = e;
                                },
                                loadContents: function(e, f) {
                                    e = m.ptrToAsset(e);
                                    return this.Gb(e, f);
                                }
                            });
                            m.CDNFileAssetLoader = c.extend("CDNFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                },
                                loadContents: function(e) {
                                    let f = m.ptrToAsset(e);
                                    e = f.cdnUuid;
                                    if ("" === e) return !1;
                                    (function(g, n) {
                                        var p = new XMLHttpRequest();
                                        p.responseType = "arraybuffer";
                                        p.onreadystatechange = function() {
                                            4 == p.readyState && 200 == p.status && n(p);
                                        };
                                        p.open("GET", g, !0);
                                        p.send(null);
                                    })(f.cdnBaseUrl + "/" + e, (g)=>{
                                        f.decode(new Uint8Array(g.response));
                                    });
                                    return !0;
                                }
                            });
                            m.FallbackFileAssetLoader = c.extend("FallbackFileAssetLoader", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.kb = [];
                                },
                                addLoader: function(e) {
                                    this.kb.push(e);
                                },
                                loadContents: function(e, f) {
                                    for (let g of this.kb){
                                        if (g.loadContents(e, f)) return !0;
                                    }
                                    return !1;
                                }
                            });
                            let d = m.computeAlignment;
                            m.computeAlignment = function(e, f, g, n, p = 1.0) {
                                return d.call(this, e, f, g, n, p);
                            };
                        };
                        const ja = "createConicGradient createImageData createLinearGradient createPattern createRadialGradient getContextAttributes getImageData getLineDash getTransform isContextLost isPointInPath isPointInStroke measureText".split(" "), ka = new function() {
                            function a() {
                                if (!b) {
                                    var k = document.createElement("canvas"), t = {
                                        alpha: 1,
                                        depth: 0,
                                        stencil: 0,
                                        antialias: 0,
                                        premultipliedAlpha: 1,
                                        preserveDrawingBuffer: 0,
                                        powerPreference: "high-performance",
                                        failIfMajorPerformanceCaveat: 0,
                                        enableExtensionsByDefault: 1,
                                        explicitSwapControl: 1,
                                        renderViaOffscreenBackBuffer: 1
                                    };
                                    let r;
                                    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                                        if (r = k.getContext("webgl", t), c = 1, !r) return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    } else if (r = k.getContext("webgl2", t)) c = 2;
                                    else {
                                        if (r = k.getContext("webgl", t)) c = 1;
                                        else return console.log("No WebGL support. Image mesh will not be drawn."), !1;
                                    }
                                    r = new Proxy(r, {
                                        get (D, w) {
                                            if (D.isContextLost()) {
                                                if (p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to invoke ", w), p = !0), "function" === typeof D[w]) return function() {};
                                            } else return "function" === typeof D[w] ? function(...M) {
                                                return D[w].apply(D, M);
                                            } : D[w];
                                        },
                                        set (D, w, M) {
                                            if (D.isContextLost()) p || (console.error("Cannot render the mesh because the GL Context was lost. Tried to set property " + w), p = !0);
                                            else return D[w] = M, !0;
                                        }
                                    });
                                    d = Math.min(r.getParameter(r.MAX_RENDERBUFFER_SIZE), r.getParameter(r.MAX_TEXTURE_SIZE));
                                    function B(D, w, M) {
                                        w = r.createShader(w);
                                        r.shaderSource(w, M);
                                        r.compileShader(w);
                                        M = r.getShaderInfoLog(w);
                                        if (0 < (M || "").length) throw M;
                                        r.attachShader(D, w);
                                    }
                                    k = r.createProgram();
                                    B(k, r.VERTEX_SHADER, "attribute vec2 vertex;\n                attribute vec2 uv;\n                uniform vec4 mat;\n                uniform vec2 translate;\n                varying vec2 st;\n                void main() {\n                    st = uv;\n                    gl_Position = vec4(mat2(mat) * vertex + translate, 0, 1);\n                }");
                                    B(k, r.FRAGMENT_SHADER, "precision highp float;\n                uniform sampler2D image;\n                varying vec2 st;\n                void main() {\n                    gl_FragColor = texture2D(image, st);\n                }");
                                    r.bindAttribLocation(k, 0, "vertex");
                                    r.bindAttribLocation(k, 1, "uv");
                                    r.linkProgram(k);
                                    t = r.getProgramInfoLog(k);
                                    if (0 < (t || "").trim().length) throw t;
                                    e = r.getUniformLocation(k, "mat");
                                    f = r.getUniformLocation(k, "translate");
                                    r.useProgram(k);
                                    r.bindBuffer(r.ARRAY_BUFFER, r.createBuffer());
                                    r.enableVertexAttribArray(0);
                                    r.enableVertexAttribArray(1);
                                    r.bindBuffer(r.ELEMENT_ARRAY_BUFFER, r.createBuffer());
                                    r.uniform1i(r.getUniformLocation(k, "image"), 0);
                                    r.pixelStorei(r.UNPACK_PREMULTIPLY_ALPHA_WEBGL, !0);
                                    b = r;
                                }
                                return !0;
                            }
                            let b = null, c = 0, d = 0, e = null, f = null, g = 0, n = 0, p = !1;
                            a();
                            this.hc = function() {
                                a();
                                return d;
                            };
                            this.Mb = function(k) {
                                b.deleteTexture && b.deleteTexture(k);
                            };
                            this.Lb = function(k) {
                                if (!a()) return null;
                                const t = b.createTexture();
                                if (!t) return null;
                                b.bindTexture(b.TEXTURE_2D, t);
                                b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, k);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE);
                                b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MAG_FILTER, b.LINEAR);
                                2 == c ? (b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR_MIPMAP_LINEAR), b.generateMipmap(b.TEXTURE_2D)) : b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR);
                                return t;
                            };
                            const l = new ha(8), u = new ha(8), v = new ha(10), x = new ha(10);
                            this.Qb = function(k, t, r, B, D) {
                                if (a()) {
                                    var w = l.push(k), M = u.push(t);
                                    if (b.canvas) {
                                        if (b.canvas.width != w || b.canvas.height != M) b.canvas.width = w, b.canvas.height = M;
                                        b.viewport(0, M - t, k, t);
                                        b.disable(b.SCISSOR_TEST);
                                        b.clearColor(0, 0, 0, 0);
                                        b.clear(b.COLOR_BUFFER_BIT);
                                        b.enable(b.SCISSOR_TEST);
                                        r.sort((H, ba)=>ba.wb - H.wb);
                                        w = v.push(B);
                                        g != w && (b.bufferData(b.ARRAY_BUFFER, 8 * w, b.DYNAMIC_DRAW), g = w);
                                        w = 0;
                                        for (var T of r)b.bufferSubData(b.ARRAY_BUFFER, w, T.Ta), w += 4 * T.Ta.length;
                                        console.assert(w == 4 * B);
                                        for (var ca of r)b.bufferSubData(b.ARRAY_BUFFER, w, ca.Db), w += 4 * ca.Db.length;
                                        console.assert(w == 8 * B);
                                        w = x.push(D);
                                        n != w && (b.bufferData(b.ELEMENT_ARRAY_BUFFER, 2 * w, b.DYNAMIC_DRAW), n = w);
                                        T = 0;
                                        for (var ra of r)b.bufferSubData(b.ELEMENT_ARRAY_BUFFER, T, ra.indices), T += 2 * ra.indices.length;
                                        console.assert(T == 2 * D);
                                        ra = 0;
                                        ca = !0;
                                        w = T = 0;
                                        for (const H of r){
                                            H.image.Ka != ra && (b.bindTexture(b.TEXTURE_2D, H.image.Ja || null), ra = H.image.Ka);
                                            H.mc ? (b.scissor(H.Ya, M - H.Za - H.jb, H.Ac, H.jb), ca = !0) : ca && (b.scissor(0, M - t, k, t), ca = !1);
                                            r = 2 / k;
                                            const ba = -2 / t;
                                            b.uniform4f(e, H.ha[0] * r * H.Ba, H.ha[1] * ba * H.Ca, H.ha[2] * r * H.Ba, H.ha[3] * ba * H.Ca);
                                            b.uniform2f(f, H.ha[4] * r * H.Ba + r * (H.Ya - H.ic * H.Ba) - 1, H.ha[5] * ba * H.Ca + ba * (H.Za - H.jc * H.Ca) + 1);
                                            b.vertexAttribPointer(0, 2, b.FLOAT, !1, 0, w);
                                            b.vertexAttribPointer(1, 2, b.FLOAT, !1, 0, w + 4 * B);
                                            b.drawElements(b.TRIANGLES, H.indices.length, b.UNSIGNED_SHORT, T);
                                            w += 4 * H.Ta.length;
                                            T += 2 * H.indices.length;
                                        }
                                        console.assert(w == 4 * B);
                                        console.assert(T == 2 * D);
                                    }
                                }
                            };
                            this.canvas = function() {
                                return a() && b.canvas;
                            };
                        }(), la = m.onRuntimeInitialized;
                        m.onRuntimeInitialized = function() {
                            function a(q) {
                                switch(q){
                                    case l.srcOver:
                                        return "source-over";
                                    case l.screen:
                                        return "screen";
                                    case l.overlay:
                                        return "overlay";
                                    case l.darken:
                                        return "darken";
                                    case l.lighten:
                                        return "lighten";
                                    case l.colorDodge:
                                        return "color-dodge";
                                    case l.colorBurn:
                                        return "color-burn";
                                    case l.hardLight:
                                        return "hard-light";
                                    case l.softLight:
                                        return "soft-light";
                                    case l.difference:
                                        return "difference";
                                    case l.exclusion:
                                        return "exclusion";
                                    case l.multiply:
                                        return "multiply";
                                    case l.hue:
                                        return "hue";
                                    case l.saturation:
                                        return "saturation";
                                    case l.color:
                                        return "color";
                                    case l.luminosity:
                                        return "luminosity";
                                }
                            }
                            function b(q) {
                                return "rgba(" + ((16711680 & q) >>> 16) + "," + ((65280 & q) >>> 8) + "," + ((255 & q) >>> 0) + "," + ((4278190080 & q) >>> 24) / 255 + ")";
                            }
                            function c() {
                                0 < M.length && (ka.Qb(w.drawWidth(), w.drawHeight(), M, T, ca), M = [], ca = T = 0, w.reset(512, 512));
                                for (const q of D){
                                    for (const y of q.H)y();
                                    q.H = [];
                                }
                                D.clear();
                            }
                            la && la();
                            var d = m.RenderPaintStyle;
                            const e = m.RenderPath, f = m.RenderPaint, g = m.Renderer, n = m.StrokeCap, p = m.StrokeJoin, l = m.BlendMode, u = d.fill, v = d.stroke, x = m.FillRule.evenOdd;
                            let k = 1;
                            var t = m.RenderImage.extend("CanvasRenderImage", {
                                __construct: function({ la: q, xa: y } = {}) {
                                    this.__parent.__construct.call(this);
                                    this.Ka = k;
                                    k = k + 1 & 2147483647 || 1;
                                    this.la = q;
                                    this.xa = y;
                                },
                                __destruct: function() {
                                    this.Ja && (ka.Mb(this.Ja), URL.revokeObjectURL(this.Wa));
                                    this.__parent.__destruct.call(this);
                                },
                                decode: function(q) {
                                    var y = this;
                                    y.xa && y.xa(y);
                                    var F = new Image();
                                    y.Wa = URL.createObjectURL(new Blob([
                                        q
                                    ], {
                                        type: "image/png"
                                    }));
                                    F.onload = function() {
                                        y.Fb = F;
                                        y.Ja = ka.Lb(F);
                                        y.size(F.width, F.height);
                                        y.la && y.la(y);
                                    };
                                    F.src = y.Wa;
                                }
                            }), r = e.extend("CanvasRenderPath", {
                                __construct: function() {
                                    this.__parent.__construct.call(this);
                                    this.T = new Path2D();
                                },
                                rewind: function() {
                                    this.T = new Path2D();
                                },
                                addPath: function(q, y, F, G, A, I, J) {
                                    var K = this.T, X = K.addPath;
                                    q = q.T;
                                    const Q = new DOMMatrix();
                                    Q.a = y;
                                    Q.b = F;
                                    Q.c = G;
                                    Q.d = A;
                                    Q.e = I;
                                    Q.f = J;
                                    X.call(K, q, Q);
                                },
                                fillRule: function(q) {
                                    this.Va = q;
                                },
                                moveTo: function(q, y) {
                                    this.T.moveTo(q, y);
                                },
                                lineTo: function(q, y) {
                                    this.T.lineTo(q, y);
                                },
                                cubicTo: function(q, y, F, G, A, I) {
                                    this.T.bezierCurveTo(q, y, F, G, A, I);
                                },
                                close: function() {
                                    this.T.closePath();
                                }
                            }), B = f.extend("CanvasRenderPaint", {
                                color: function(q) {
                                    this.Xa = b(q);
                                },
                                thickness: function(q) {
                                    this.Ib = q;
                                },
                                join: function(q) {
                                    switch(q){
                                        case p.miter:
                                            this.Ia = "miter";
                                            break;
                                        case p.round:
                                            this.Ia = "round";
                                            break;
                                        case p.bevel:
                                            this.Ia = "bevel";
                                    }
                                },
                                cap: function(q) {
                                    switch(q){
                                        case n.butt:
                                            this.Ha = "butt";
                                            break;
                                        case n.round:
                                            this.Ha = "round";
                                            break;
                                        case n.square:
                                            this.Ha = "square";
                                    }
                                },
                                style: function(q) {
                                    this.Hb = q;
                                },
                                blendMode: function(q) {
                                    this.Eb = a(q);
                                },
                                clearGradient: function() {
                                    this.ja = null;
                                },
                                linearGradient: function(q, y, F, G) {
                                    this.ja = {
                                        yb: q,
                                        zb: y,
                                        bb: F,
                                        cb: G,
                                        Ra: []
                                    };
                                },
                                radialGradient: function(q, y, F, G) {
                                    this.ja = {
                                        yb: q,
                                        zb: y,
                                        bb: F,
                                        cb: G,
                                        Ra: [],
                                        ec: !0
                                    };
                                },
                                addStop: function(q, y) {
                                    this.ja.Ra.push({
                                        color: q,
                                        stop: y
                                    });
                                },
                                completeGradient: function() {},
                                draw: function(q, y, F) {
                                    let G = this.Hb;
                                    var A = this.Xa, I = this.ja;
                                    q.globalCompositeOperation = this.Eb;
                                    if (null != I) {
                                        A = I.yb;
                                        var J = I.zb;
                                        const X = I.bb;
                                        var K = I.cb;
                                        const Q = I.Ra;
                                        I.ec ? (I = X - A, K -= J, A = q.createRadialGradient(A, J, 0, A, J, Math.sqrt(I * I + K * K))) : A = q.createLinearGradient(A, J, X, K);
                                        for(let da = 0, R = Q.length; da < R; da++)J = Q[da], A.addColorStop(J.stop, b(J.color));
                                        this.Xa = A;
                                        this.ja = null;
                                    }
                                    switch(G){
                                        case v:
                                            q.strokeStyle = A;
                                            q.lineWidth = this.Ib;
                                            q.lineCap = this.Ha;
                                            q.lineJoin = this.Ia;
                                            q.stroke(y);
                                            break;
                                        case u:
                                            q.fillStyle = A, q.fill(y, F);
                                    }
                                }
                            });
                            const D = new Set();
                            let w = null, M = [], T = 0, ca = 0;
                            var ra = m.CanvasRenderer = g.extend("Renderer", {
                                __construct: function(q) {
                                    this.__parent.__construct.call(this);
                                    this.S = [
                                        1,
                                        0,
                                        0,
                                        1,
                                        0,
                                        0
                                    ];
                                    this.C = q.getContext("2d");
                                    this.Ua = q;
                                    this.H = [];
                                },
                                save: function() {
                                    this.S.push(...this.S.slice(this.S.length - 6));
                                    this.H.push(this.C.save.bind(this.C));
                                },
                                restore: function() {
                                    const q = this.S.length - 6;
                                    if (6 > q) throw "restore() called without matching save().";
                                    this.S.splice(q);
                                    this.H.push(this.C.restore.bind(this.C));
                                },
                                transform: function(q, y, F, G, A, I) {
                                    const J = this.S, K = J.length - 6;
                                    J.splice(K, 6, J[K] * q + J[K + 2] * y, J[K + 1] * q + J[K + 3] * y, J[K] * F + J[K + 2] * G, J[K + 1] * F + J[K + 3] * G, J[K] * A + J[K + 2] * I + J[K + 4], J[K + 1] * A + J[K + 3] * I + J[K + 5]);
                                    this.H.push(this.C.transform.bind(this.C, q, y, F, G, A, I));
                                },
                                rotate: function(q) {
                                    const y = Math.sin(q);
                                    q = Math.cos(q);
                                    this.transform(q, y, -y, q, 0, 0);
                                },
                                _drawPath: function(q, y) {
                                    this.H.push(y.draw.bind(y, this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                _drawRiveImage: function(q, y, F) {
                                    var G = q.Fb;
                                    if (G) {
                                        var A = this.C, I = a(y);
                                        this.H.push(function() {
                                            A.globalCompositeOperation = I;
                                            A.globalAlpha = F;
                                            A.drawImage(G, 0, 0);
                                            A.globalAlpha = 1;
                                        });
                                    }
                                },
                                _getMatrix: function(q) {
                                    const y = this.S, F = y.length - 6;
                                    for(let G = 0; 6 > G; ++G)q[G] = y[F + G];
                                },
                                _drawImageMesh: function(q, y, F, G, A, I, J, K, X, Q) {
                                    var da = this.C.canvas.width, R = this.C.canvas.height;
                                    const Yb = X - J, Zb = Q - K;
                                    J = Math.max(J, 0);
                                    K = Math.max(K, 0);
                                    X = Math.min(X, da);
                                    Q = Math.min(Q, R);
                                    const Ga = X - J, Ha = Q - K;
                                    console.assert(Ga <= Math.min(Yb, da));
                                    console.assert(Ha <= Math.min(Zb, R));
                                    if (!(0 >= Ga || 0 >= Ha)) {
                                        X = Ga < Yb || Ha < Zb;
                                        da = Q = 1;
                                        var sa = Math.ceil(Ga * Q), ta = Math.ceil(Ha * da);
                                        R = ka.hc();
                                        sa > R && (Q *= R / sa, sa = R);
                                        ta > R && (da *= R / ta, ta = R);
                                        w || (w = new m.DynamicRectanizer(R), w.reset(512, 512));
                                        R = w.addRect(sa, ta);
                                        0 > R && (c(), D.add(this), R = w.addRect(sa, ta), console.assert(0 <= R));
                                        var $b = R & 65535, ac = R >> 16;
                                        M.push({
                                            ha: this.S.slice(this.S.length - 6),
                                            image: q,
                                            Ya: $b,
                                            Za: ac,
                                            ic: J,
                                            jc: K,
                                            Ac: sa,
                                            jb: ta,
                                            Ba: Q,
                                            Ca: da,
                                            Ta: new Float32Array(G),
                                            Db: new Float32Array(A),
                                            indices: new Uint16Array(I),
                                            mc: X,
                                            wb: q.Ka << 1 | (X ? 1 : 0)
                                        });
                                        T += G.length;
                                        ca += I.length;
                                        var za = this.C, qd = a(y);
                                        this.H.push(function() {
                                            za.save();
                                            za.resetTransform();
                                            za.globalCompositeOperation = qd;
                                            za.globalAlpha = F;
                                            const bc = ka.canvas();
                                            bc && za.drawImage(bc, $b, ac, sa, ta, J, K, Ga, Ha);
                                            za.restore();
                                        });
                                    }
                                },
                                _clipPath: function(q) {
                                    this.H.push(this.C.clip.bind(this.C, q.T, q.Va === x ? "evenodd" : "nonzero"));
                                },
                                clear: function() {
                                    D.add(this);
                                    this.H.push(this.C.clearRect.bind(this.C, 0, 0, this.Ua.width, this.Ua.height));
                                },
                                flush: function() {},
                                translate: function(q, y) {
                                    this.transform(1, 0, 0, 1, q, y);
                                }
                            });
                            m.makeRenderer = function(q) {
                                const y = new ra(q), F = y.C;
                                return new Proxy(y, {
                                    get (G, A) {
                                        if ("function" === typeof G[A]) return function(...I) {
                                            return G[A].apply(G, I);
                                        };
                                        if ("function" === typeof F[A]) {
                                            if (-1 < ja.indexOf(A)) throw Error("RiveException: Method call to '" + A + "()' is not allowed, as the renderer cannot immediately pass through the return                 values of any canvas 2d context methods.");
                                            return function(...I) {
                                                y.H.push(F[A].bind(F, ...I));
                                            };
                                        }
                                        return G[A];
                                    },
                                    set (G, A, I) {
                                        if (A in F) return y.H.push(()=>{
                                            F[A] = I;
                                        }), !0;
                                    }
                                });
                            };
                            m.decodeImage = function(q, y) {
                                new t({
                                    la: y
                                }).decode(q);
                            };
                            m.renderFactory = {
                                makeRenderPaint: function() {
                                    return new B();
                                },
                                makeRenderPath: function() {
                                    return new r();
                                },
                                makeRenderImage: function() {
                                    let q = ba;
                                    return new t({
                                        xa: ()=>{
                                            q.total++;
                                        },
                                        la: ()=>{
                                            q.loaded++;
                                            if (q.loaded === q.total) {
                                                const y = q.ready;
                                                y && (y(), q.ready = null);
                                            }
                                        }
                                    });
                                }
                            };
                            let H = m.load, ba = null;
                            m.load = function(q, y, F = !0) {
                                const G = new m.FallbackFileAssetLoader();
                                void 0 !== y && G.addLoader(y);
                                F && (y = new m.CDNFileAssetLoader(), G.addLoader(y));
                                return new Promise(function(A) {
                                    let I = null;
                                    ba = {
                                        total: 0,
                                        loaded: 0,
                                        ready: function() {
                                            A(I);
                                        }
                                    };
                                    I = H(q, G);
                                    0 == ba.total && A(I);
                                });
                            };
                            let rd = m.RendererWrapper.prototype.align;
                            m.RendererWrapper.prototype.align = function(q, y, F, G, A = 1.0) {
                                rd.call(this, q, y, F, G, A);
                            };
                            d = new fa();
                            m.requestAnimationFrame = d.requestAnimationFrame.bind(d);
                            m.cancelAnimationFrame = d.cancelAnimationFrame.bind(d);
                            m.enableFPSCounter = d.Rb.bind(d);
                            m.disableFPSCounter = d.Ob;
                            d.ob = c;
                            m.resolveAnimationFrame = c;
                            m.cleanup = function() {
                                w && w.delete();
                            };
                        };
                        var ma = Object.assign({}, m), na = "./this.program", oa = "object" == typeof window, pa = "function" == typeof importScripts, qa = "", ua, va;
                        if (oa || pa) pa ? qa = self.location.href : "undefined" != typeof document && document.currentScript && (qa = document.currentScript.src), _scriptDir && (qa = _scriptDir), 0 !== qa.indexOf("blob:") ? qa = qa.substr(0, qa.replace(/[?#].*/, "").lastIndexOf("/") + 1) : qa = "", pa && (va = (a)=>{
                            var b = new XMLHttpRequest();
                            b.open("GET", a, !1);
                            b.responseType = "arraybuffer";
                            b.send(null);
                            return new Uint8Array(b.response);
                        }), ua = (a, b, c)=>{
                            var d = new XMLHttpRequest();
                            d.open("GET", a, !0);
                            d.responseType = "arraybuffer";
                            d.onload = ()=>{
                                200 == d.status || 0 == d.status && d.response ? b(d.response) : c();
                            };
                            d.onerror = c;
                            d.send(null);
                        };
                        var wa = m.print || console.log.bind(console), xa = m.printErr || console.error.bind(console);
                        Object.assign(m, ma);
                        ma = null;
                        m.thisProgram && (na = m.thisProgram);
                        var ya;
                        m.wasmBinary && (ya = m.wasmBinary);
                        var noExitRuntime = m.noExitRuntime || !0;
                        "object" != typeof WebAssembly && Aa("no native wasm support detected");
                        var Ba, z, Ca = !1, C, E, Da, Ea, L, N, Fa, Ia;
                        function Ja() {
                            var a = Ba.buffer;
                            m.HEAP8 = C = new Int8Array(a);
                            m.HEAP16 = Da = new Int16Array(a);
                            m.HEAP32 = L = new Int32Array(a);
                            m.HEAPU8 = E = new Uint8Array(a);
                            m.HEAPU16 = Ea = new Uint16Array(a);
                            m.HEAPU32 = N = new Uint32Array(a);
                            m.HEAPF32 = Fa = new Float32Array(a);
                            m.HEAPF64 = Ia = new Float64Array(a);
                        }
                        var Ka, La = [], Ma = [], Na = [];
                        function Oa() {
                            var a = m.preRun.shift();
                            La.unshift(a);
                        }
                        var Pa = 0, Qa = null, Ra = null;
                        function Aa(a) {
                            if (m.onAbort) m.onAbort(a);
                            a = "Aborted(" + a + ")";
                            xa(a);
                            Ca = !0;
                            a = new WebAssembly.RuntimeError(a + ". Build with -sASSERTIONS for more info.");
                            ea(a);
                            throw a;
                        }
                        function Sa(a) {
                            return a.startsWith("data:application/octet-stream;base64,");
                        }
                        var Ta;
                        Ta = "canvas_advanced.wasm";
                        if (!Sa(Ta)) {
                            var Ua = Ta;
                            Ta = m.locateFile ? m.locateFile(Ua, qa) : qa + Ua;
                        }
                        function Va(a) {
                            if (a == Ta && ya) return new Uint8Array(ya);
                            if (va) return va(a);
                            throw "both async and sync fetching of the wasm failed";
                        }
                        function Wa(a) {
                            if (!ya && (oa || pa)) {
                                if ("function" == typeof fetch && !a.startsWith("file://")) return fetch(a, {
                                    credentials: "same-origin"
                                }).then((b)=>{
                                    if (!b.ok) throw "failed to load wasm binary file at '" + a + "'";
                                    return b.arrayBuffer();
                                }).catch(()=>Va(a));
                                if (ua) return new Promise((b, c)=>{
                                    ua(a, (d)=>b(new Uint8Array(d)), c);
                                });
                            }
                            return Promise.resolve().then(()=>Va(a));
                        }
                        function Xa(a, b, c) {
                            return Wa(a).then((d)=>WebAssembly.instantiate(d, b)).then((d)=>d).then(c, (d)=>{
                                xa("failed to asynchronously prepare wasm: " + d);
                                Aa(d);
                            });
                        }
                        function Ya(a, b) {
                            var c = Ta;
                            return ya || "function" != typeof WebAssembly.instantiateStreaming || Sa(c) || c.startsWith("file://") || "function" != typeof fetch ? Xa(c, a, b) : fetch(c, {
                                credentials: "same-origin"
                            }).then((d)=>WebAssembly.instantiateStreaming(d, a).then(b, function(e) {
                                    xa("wasm streaming compile failed: " + e);
                                    xa("falling back to ArrayBuffer instantiation");
                                    return Xa(c, a, b);
                                }));
                        }
                        var Za, $a, db = {
                            448252: (a, b, c, d, e)=>{
                                if ("undefined" === typeof window || void 0 === (window.AudioContext || window.webkitAudioContext)) return 0;
                                if ("undefined" === typeof window.h) {
                                    window.h = {
                                        Aa: 0
                                    };
                                    window.h.I = {};
                                    window.h.I.ya = a;
                                    window.h.I.capture = b;
                                    window.h.I.La = c;
                                    window.h.ga = {};
                                    window.h.ga.stopped = d;
                                    window.h.ga.xb = e;
                                    let f = window.h;
                                    f.D = [];
                                    f.yc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (null == f.D[n]) return f.D[n] = g, n;
                                        }
                                        f.D.push(g);
                                        return f.D.length - 1;
                                    };
                                    f.Cb = function(g) {
                                        for(f.D[g] = null; 0 < f.D.length;){
                                            if (null == f.D[f.D.length - 1]) f.D.pop();
                                            else break;
                                        }
                                    };
                                    f.Sc = function(g) {
                                        for(var n = 0; n < f.D.length; ++n){
                                            if (f.D[n] == g) return f.Cb(n);
                                        }
                                    };
                                    f.ra = function(g) {
                                        return f.D[g];
                                    };
                                    f.Bb = [
                                        "touchend",
                                        "click"
                                    ];
                                    f.unlock = function() {
                                        for(var g = 0; g < f.D.length; ++g){
                                            var n = f.D[g];
                                            null != n && null != n.J && n.state === f.ga.xb && n.J.resume().then(()=>{
                                                ab(n.pb);
                                            }, (p)=>{
                                                console.error("Failed to resume audiocontext", p);
                                            });
                                        }
                                        f.Bb.map(function(p) {
                                            document.removeEventListener(p, f.unlock, !0);
                                        });
                                    };
                                    f.Bb.map(function(g) {
                                        document.addEventListener(g, f.unlock, !0);
                                    });
                                }
                                window.h.Aa += 1;
                                return 1;
                            },
                            450430: ()=>{
                                "undefined" !== typeof window.h && (--window.h.Aa, 0 === window.h.Aa && delete window.h);
                            },
                            450594: ()=>void 0 !== navigator.mediaDevices && void 0 !== navigator.mediaDevices.getUserMedia,
                            450698: ()=>{
                                try {
                                    var a = new (window.AudioContext || window.webkitAudioContext)(), b = a.sampleRate;
                                    a.close();
                                    return b;
                                } catch (c) {
                                    return 0;
                                }
                            },
                            450869: (a, b, c, d, e, f)=>{
                                if ("undefined" === typeof window.h) return -1;
                                var g = {}, n = {};
                                a == window.h.I.ya && 0 != c && (n.sampleRate = c);
                                g.J = new (window.AudioContext || window.webkitAudioContext)(n);
                                g.J.suspend();
                                g.state = window.h.ga.stopped;
                                c = 0;
                                a != window.h.I.ya && (c = b);
                                g.Z = g.J.createScriptProcessor(d, c, b);
                                g.Z.onaudioprocess = function(p) {
                                    if (null == g.sa || 0 == g.sa.length) g.sa = new Float32Array(Fa.buffer, e, d * b);
                                    if (a == window.h.I.capture || a == window.h.I.La) {
                                        for(var l = 0; l < b; l += 1)for(var u = p.inputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)v[x * b + l] = u[x];
                                        bb(f, d, e);
                                    }
                                    if (a == window.h.I.ya || a == window.h.I.La) {
                                        for(cb(f, d, e), l = 0; l < p.outputBuffer.numberOfChannels; ++l)for(u = p.outputBuffer.getChannelData(l), v = g.sa, x = 0; x < d; x += 1)u[x] = v[x * b + l];
                                    } else for(l = 0; l < p.outputBuffer.numberOfChannels; ++l)p.outputBuffer.getChannelData(l).fill(0.0);
                                };
                                a != window.h.I.capture && a != window.h.I.La || navigator.mediaDevices.getUserMedia({
                                    audio: !0,
                                    video: !1
                                }).then(function(p) {
                                    g.Da = g.J.createMediaStreamSource(p);
                                    g.Da.connect(g.Z);
                                    g.Z.connect(g.J.destination);
                                }).catch(function(p) {
                                    console.log("Failed to get user media: " + p);
                                });
                                a == window.h.I.ya && g.Z.connect(g.J.destination);
                                g.pb = f;
                                return window.h.yc(g);
                            },
                            453746: (a)=>window.h.ra(a).J.sampleRate,
                            453819: (a)=>{
                                a = window.h.ra(a);
                                void 0 !== a.Z && (a.Z.onaudioprocess = function() {}, a.Z.disconnect(), a.Z = void 0);
                                void 0 !== a.Da && (a.Da.disconnect(), a.Da = void 0);
                                a.J.close();
                                a.J = void 0;
                                a.pb = void 0;
                            },
                            454219: (a)=>{
                                window.h.Cb(a);
                            },
                            454269: (a)=>{
                                a = window.h.ra(a);
                                a.J.resume();
                                a.state = window.h.ga.xb;
                            },
                            454408: (a)=>{
                                a = window.h.ra(a);
                                a.J.suspend();
                                a.state = window.h.ga.stopped;
                            }
                        }, eb = (a)=>{
                            for(; 0 < a.length;)a.shift()(m);
                        }, fb = (a, b)=>{
                            for(var c = 0, d = a.length - 1; 0 <= d; d--){
                                var e = a[d];
                                "." === e ? a.splice(d, 1) : ".." === e ? (a.splice(d, 1), c++) : c && (a.splice(d, 1), c--);
                            }
                            if (b) for(; c; c--)a.unshift("..");
                            return a;
                        }, gb = (a)=>{
                            var b = "/" === a.charAt(0), c = "/" === a.substr(-1);
                            (a = fb(a.split("/").filter((d)=>!!d), !b).join("/")) || b || (a = ".");
                            a && c && (a += "/");
                            return (b ? "/" : "") + a;
                        }, hb = (a)=>{
                            var b = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(a).slice(1);
                            a = b[0];
                            b = b[1];
                            if (!a && !b) return ".";
                            b && (b = b.substr(0, b.length - 1));
                            return a + b;
                        }, ib = (a)=>{
                            if ("/" === a) return "/";
                            a = gb(a);
                            a = a.replace(/\/$/, "");
                            var b = a.lastIndexOf("/");
                            return -1 === b ? a : a.substr(b + 1);
                        }, jb = ()=>{
                            if ("object" == typeof crypto && "function" == typeof crypto.getRandomValues) return (a)=>crypto.getRandomValues(a);
                            Aa("initRandomDevice");
                        }, kb = (a)=>(kb = jb())(a);
                        function lb() {
                            for(var a = "", b = !1, c = arguments.length - 1; -1 <= c && !b; c--){
                                b = 0 <= c ? arguments[c] : "/";
                                if ("string" != typeof b) throw new TypeError("Arguments to path.resolve must be strings");
                                if (!b) return "";
                                a = b + "/" + a;
                                b = "/" === b.charAt(0);
                            }
                            a = fb(a.split("/").filter((d)=>!!d), !b).join("/");
                            return (b ? "/" : "") + a || ".";
                        }
                        var mb = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0, nb = (a, b, c)=>{
                            var d = b + c;
                            for(c = b; a[c] && !(c >= d);)++c;
                            if (16 < c - b && a.buffer && mb) return mb.decode(a.subarray(b, c));
                            for(d = ""; b < c;){
                                var e = a[b++];
                                if (e & 128) {
                                    var f = a[b++] & 63;
                                    if (192 == (e & 224)) d += String.fromCharCode((e & 31) << 6 | f);
                                    else {
                                        var g = a[b++] & 63;
                                        e = 224 == (e & 240) ? (e & 15) << 12 | f << 6 | g : (e & 7) << 18 | f << 12 | g << 6 | a[b++] & 63;
                                        65536 > e ? d += String.fromCharCode(e) : (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023));
                                    }
                                } else d += String.fromCharCode(e);
                            }
                            return d;
                        }, ob = [], pb = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                127 >= d ? b++ : 2047 >= d ? b += 2 : 55296 <= d && 57343 >= d ? (b += 4, ++c) : b += 3;
                            }
                            return b;
                        }, qb = (a, b, c, d)=>{
                            if (!(0 < d)) return 0;
                            var e = c;
                            d = c + d - 1;
                            for(var f = 0; f < a.length; ++f){
                                var g = a.charCodeAt(f);
                                if (55296 <= g && 57343 >= g) {
                                    var n = a.charCodeAt(++f);
                                    g = 65536 + ((g & 1023) << 10) | n & 1023;
                                }
                                if (127 >= g) {
                                    if (c >= d) break;
                                    b[c++] = g;
                                } else {
                                    if (2047 >= g) {
                                        if (c + 1 >= d) break;
                                        b[c++] = 192 | g >> 6;
                                    } else {
                                        if (65535 >= g) {
                                            if (c + 2 >= d) break;
                                            b[c++] = 224 | g >> 12;
                                        } else {
                                            if (c + 3 >= d) break;
                                            b[c++] = 240 | g >> 18;
                                            b[c++] = 128 | g >> 12 & 63;
                                        }
                                        b[c++] = 128 | g >> 6 & 63;
                                    }
                                    b[c++] = 128 | g & 63;
                                }
                            }
                            b[c] = 0;
                            return c - e;
                        };
                        function rb(a, b) {
                            var c = Array(pb(a) + 1);
                            a = qb(a, c, 0, c.length);
                            b && (c.length = a);
                            return c;
                        }
                        var sb = [];
                        function tb(a, b) {
                            sb[a] = {
                                input: [],
                                F: [],
                                V: b
                            };
                            ub(a, vb);
                        }
                        var vb = {
                            open: function(a) {
                                var b = sb[a.node.za];
                                if (!b) throw new O(43);
                                a.s = b;
                                a.seekable = !1;
                            },
                            close: function(a) {
                                a.s.V.qa(a.s);
                            },
                            qa: function(a) {
                                a.s.V.qa(a.s);
                            },
                            read: function(a, b, c, d) {
                                if (!a.s || !a.s.V.ib) throw new O(60);
                                for(var e = 0, f = 0; f < d; f++){
                                    try {
                                        var g = a.s.V.ib(a.s);
                                    } catch (n) {
                                        throw new O(29);
                                    }
                                    if (void 0 === g && 0 === e) throw new O(6);
                                    if (null === g || void 0 === g) break;
                                    e++;
                                    b[c + f] = g;
                                }
                                e && (a.node.timestamp = Date.now());
                                return e;
                            },
                            write: function(a, b, c, d) {
                                if (!a.s || !a.s.V.Oa) throw new O(60);
                                try {
                                    for(var e = 0; e < d; e++)a.s.V.Oa(a.s, b[c + e]);
                                } catch (f) {
                                    throw new O(29);
                                }
                                d && (a.node.timestamp = Date.now());
                                return e;
                            }
                        }, wb = {
                            ib: function() {
                                a: {
                                    if (!ob.length) {
                                        var a = null;
                                        "undefined" != typeof window && "function" == typeof window.prompt ? (a = window.prompt("Input: "), null !== a && (a += "\n")) : "function" == typeof readline && (a = readline(), null !== a && (a += "\n"));
                                        if (!a) {
                                            a = null;
                                            break a;
                                        }
                                        ob = rb(a, !0);
                                    }
                                    a = ob.shift();
                                }
                                return a;
                            },
                            Oa: function(a, b) {
                                null === b || 10 === b ? (wa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (wa(nb(a.F, 0)), a.F = []);
                            },
                            bc: function() {
                                return {
                                    Fc: 25856,
                                    Hc: 5,
                                    Ec: 191,
                                    Gc: 35387,
                                    Dc: [
                                        3,
                                        28,
                                        127,
                                        21,
                                        4,
                                        0,
                                        1,
                                        0,
                                        17,
                                        19,
                                        26,
                                        0,
                                        18,
                                        15,
                                        23,
                                        22,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0,
                                        0
                                    ]
                                };
                            },
                            cc: function() {
                                return 0;
                            },
                            dc: function() {
                                return [
                                    24,
                                    80
                                ];
                            }
                        }, xb = {
                            Oa: function(a, b) {
                                null === b || 10 === b ? (xa(nb(a.F, 0)), a.F = []) : 0 != b && a.F.push(b);
                            },
                            qa: function(a) {
                                a.F && 0 < a.F.length && (xa(nb(a.F, 0)), a.F = []);
                            }
                        };
                        function yb(a, b) {
                            var c = a.j ? a.j.length : 0;
                            c >= b || (b = Math.max(b, c * (1048576 > c ? 2.0 : 1.125) >>> 0), 0 != c && (b = Math.max(b, 256)), c = a.j, a.j = new Uint8Array(b), 0 < a.v && a.j.set(c.subarray(0, a.v), 0));
                        }
                        var P = {
                            O: null,
                            U () {
                                return P.createNode(null, "/", 16895, 0);
                            },
                            createNode (a, b, c, d) {
                                if (24576 === (c & 61440) || 4096 === (c & 61440)) throw new O(63);
                                P.O || (P.O = {
                                    dir: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ka: P.l.ka,
                                            va: P.l.va,
                                            ub: P.l.ub,
                                            Ab: P.l.Ab,
                                            vb: P.l.vb,
                                            sb: P.l.sb,
                                            Ea: P.l.Ea
                                        },
                                        stream: {
                                            ba: P.m.ba
                                        }
                                    },
                                    file: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: {
                                            ba: P.m.ba,
                                            read: P.m.read,
                                            write: P.m.write,
                                            pa: P.m.pa,
                                            lb: P.m.lb,
                                            nb: P.m.nb
                                        }
                                    },
                                    link: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P,
                                            ma: P.l.ma
                                        },
                                        stream: {}
                                    },
                                    $a: {
                                        node: {
                                            Y: P.l.Y,
                                            P: P.l.P
                                        },
                                        stream: zb
                                    }
                                });
                                c = Ab(a, b, c, d);
                                16384 === (c.mode & 61440) ? (c.l = P.O.dir.node, c.m = P.O.dir.stream, c.j = {}) : 32768 === (c.mode & 61440) ? (c.l = P.O.file.node, c.m = P.O.file.stream, c.v = 0, c.j = null) : 40960 === (c.mode & 61440) ? (c.l = P.O.link.node, c.m = P.O.link.stream) : 8192 === (c.mode & 61440) && (c.l = P.O.$a.node, c.m = P.O.$a.stream);
                                c.timestamp = Date.now();
                                a && (a.j[b] = c, a.timestamp = c.timestamp);
                                return c;
                            },
                            Kc (a) {
                                return a.j ? a.j.subarray ? a.j.subarray(0, a.v) : new Uint8Array(a.j) : new Uint8Array(0);
                            },
                            l: {
                                Y (a) {
                                    var b = {};
                                    b.Jc = 8192 === (a.mode & 61440) ? a.id : 1;
                                    b.Mc = a.id;
                                    b.mode = a.mode;
                                    b.Oc = 1;
                                    b.uid = 0;
                                    b.Lc = 0;
                                    b.za = a.za;
                                    16384 === (a.mode & 61440) ? b.size = 4096 : 32768 === (a.mode & 61440) ? b.size = a.v : 40960 === (a.mode & 61440) ? b.size = a.link.length : b.size = 0;
                                    b.Bc = new Date(a.timestamp);
                                    b.Nc = new Date(a.timestamp);
                                    b.Ic = new Date(a.timestamp);
                                    b.Jb = 4096;
                                    b.Cc = Math.ceil(b.size / b.Jb);
                                    return b;
                                },
                                P (a, b) {
                                    void 0 !== b.mode && (a.mode = b.mode);
                                    void 0 !== b.timestamp && (a.timestamp = b.timestamp);
                                    if (void 0 !== b.size && (b = b.size, a.v != b)) {
                                        if (0 == b) a.j = null, a.v = 0;
                                        else {
                                            var c = a.j;
                                            a.j = new Uint8Array(b);
                                            c && a.j.set(c.subarray(0, Math.min(b, a.v)));
                                            a.v = b;
                                        }
                                    }
                                },
                                ka () {
                                    throw Bb[44];
                                },
                                va (a, b, c, d) {
                                    return P.createNode(a, b, c, d);
                                },
                                ub (a, b, c) {
                                    if (16384 === (a.mode & 61440)) {
                                        try {
                                            var d = Cb(b, c);
                                        } catch (f) {}
                                        if (d) {
                                            for(var e in d.j)throw new O(55);
                                        }
                                    }
                                    delete a.parent.j[a.name];
                                    a.parent.timestamp = Date.now();
                                    a.name = c;
                                    b.j[c] = a;
                                    b.timestamp = a.parent.timestamp;
                                    a.parent = b;
                                },
                                Ab (a, b) {
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                vb (a, b) {
                                    var c = Cb(a, b), d;
                                    for(d in c.j)throw new O(55);
                                    delete a.j[b];
                                    a.timestamp = Date.now();
                                },
                                sb (a) {
                                    var b = [
                                        ".",
                                        ".."
                                    ], c;
                                    for(c in a.j)a.j.hasOwnProperty(c) && b.push(c);
                                    return b;
                                },
                                Ea (a, b, c) {
                                    a = P.createNode(a, b, 41471, 0);
                                    a.link = c;
                                    return a;
                                },
                                ma (a) {
                                    if (40960 !== (a.mode & 61440)) throw new O(28);
                                    return a.link;
                                }
                            },
                            m: {
                                read (a, b, c, d, e) {
                                    var f = a.node.j;
                                    if (e >= a.node.v) return 0;
                                    a = Math.min(a.node.v - e, d);
                                    if (8 < a && f.subarray) b.set(f.subarray(e, e + a), c);
                                    else for(d = 0; d < a; d++)b[c + d] = f[e + d];
                                    return a;
                                },
                                write (a, b, c, d, e, f) {
                                    b.buffer === C.buffer && (f = !1);
                                    if (!d) return 0;
                                    a = a.node;
                                    a.timestamp = Date.now();
                                    if (b.subarray && (!a.j || a.j.subarray)) {
                                        if (f) return a.j = b.subarray(c, c + d), a.v = d;
                                        if (0 === a.v && 0 === e) return a.j = b.slice(c, c + d), a.v = d;
                                        if (e + d <= a.v) return a.j.set(b.subarray(c, c + d), e), d;
                                    }
                                    yb(a, e + d);
                                    if (a.j.subarray && b.subarray) a.j.set(b.subarray(c, c + d), e);
                                    else for(f = 0; f < d; f++)a.j[e + f] = b[c + f];
                                    a.v = Math.max(a.v, e + d);
                                    return d;
                                },
                                ba (a, b, c) {
                                    1 === c ? b += a.position : 2 === c && 32768 === (a.node.mode & 61440) && (b += a.node.v);
                                    if (0 > b) throw new O(28);
                                    return b;
                                },
                                pa (a, b, c) {
                                    yb(a.node, b + c);
                                    a.node.v = Math.max(a.node.v, b + c);
                                },
                                lb (a, b, c, d, e) {
                                    if (32768 !== (a.node.mode & 61440)) throw new O(43);
                                    a = a.node.j;
                                    if (e & 2 || a.buffer !== C.buffer) {
                                        if (0 < c || c + b < a.length) a.subarray ? a = a.subarray(c, c + b) : a = Array.prototype.slice.call(a, c, c + b);
                                        c = !0;
                                        Aa();
                                        b = void 0;
                                        if (!b) throw new O(48);
                                        C.set(a, b);
                                    } else c = !1, b = a.byteOffset;
                                    return {
                                        o: b,
                                        M: c
                                    };
                                },
                                nb (a, b, c, d) {
                                    P.m.write(a, b, 0, d, c, !1);
                                    return 0;
                                }
                            }
                        };
                        function Db(a, b) {
                            var c = 0;
                            a && (c |= 365);
                            b && (c |= 146);
                            return c;
                        }
                        var Eb = null, Fb = {}, Gb = [], Hb = 1, Ib = null, Jb = !0, O = null, Bb = {}, Lb = (a, b = {})=>{
                            a = lb(a);
                            if (!a) return {
                                path: "",
                                node: null
                            };
                            b = Object.assign({
                                gb: !0,
                                Qa: 0
                            }, b);
                            if (8 < b.Qa) throw new O(32);
                            a = a.split("/").filter((g)=>!!g);
                            for(var c = Eb, d = "/", e = 0; e < a.length; e++){
                                var f = e === a.length - 1;
                                if (f && b.parent) break;
                                c = Cb(c, a[e]);
                                d = gb(d + "/" + a[e]);
                                c.wa && (!f || f && b.gb) && (c = c.wa.root);
                                if (!f || b.fb) for(f = 0; 40960 === (c.mode & 61440);){
                                    if (c = Kb(d), d = lb(hb(d), c), c = Lb(d, {
                                        Qa: b.Qa + 1
                                    }).node, 40 < f++) throw new O(32);
                                }
                            }
                            return {
                                path: d,
                                node: c
                            };
                        }, Mb = (a)=>{
                            for(var b;;){
                                if (a === a.parent) return a = a.U.mb, b ? "/" !== a[a.length - 1] ? `${a}/${b}` : a + b : a;
                                b = b ? `${a.name}/${b}` : a.name;
                                a = a.parent;
                            }
                        }, Nb = (a, b)=>{
                            for(var c = 0, d = 0; d < b.length; d++)c = (c << 5) - c + b.charCodeAt(d) | 0;
                            return (a + c >>> 0) % Ib.length;
                        }, Cb = (a, b)=>{
                            var c;
                            if (c = (c = Ob(a, "x")) ? c : a.l.ka ? 0 : 2) throw new O(c, a);
                            for(c = Ib[Nb(a.id, b)]; c; c = c.lc){
                                var d = c.name;
                                if (c.parent.id === a.id && d === b) return c;
                            }
                            return a.l.ka(a, b);
                        }, Ab = (a, b, c, d)=>{
                            a = new Pb(a, b, c, d);
                            b = Nb(a.parent.id, a.name);
                            a.lc = Ib[b];
                            return Ib[b] = a;
                        }, Qb = (a)=>{
                            var b = [
                                "r",
                                "w",
                                "rw"
                            ][a & 3];
                            a & 512 && (b += "w");
                            return b;
                        }, Ob = (a, b)=>{
                            if (Jb) return 0;
                            if (!b.includes("r") || a.mode & 292) {
                                if (b.includes("w") && !(a.mode & 146) || b.includes("x") && !(a.mode & 73)) return 2;
                            } else return 2;
                            return 0;
                        }, Rb = (a, b)=>{
                            try {
                                return Cb(a, b), 20;
                            } catch (c) {}
                            return Ob(a, "wx");
                        }, Sb = ()=>{
                            for(var a = 0; 4096 >= a; a++){
                                if (!Gb[a]) return a;
                            }
                            throw new O(33);
                        }, Tb = (a)=>{
                            a = Gb[a];
                            if (!a) throw new O(8);
                            return a;
                        }, Vb = (a, b = -1)=>{
                            Ub || (Ub = function() {
                                this.h = {};
                            }, Ub.prototype = {}, Object.defineProperties(Ub.prototype, {
                                object: {
                                    get () {
                                        return this.node;
                                    },
                                    set (c) {
                                        this.node = c;
                                    }
                                },
                                flags: {
                                    get () {
                                        return this.h.flags;
                                    },
                                    set (c) {
                                        this.h.flags = c;
                                    }
                                },
                                position: {
                                    get () {
                                        return this.h.position;
                                    },
                                    set (c) {
                                        this.h.position = c;
                                    }
                                }
                            }));
                            a = Object.assign(new Ub(), a);
                            -1 == b && (b = Sb());
                            a.X = b;
                            return Gb[b] = a;
                        }, zb = {
                            open: (a)=>{
                                a.m = Fb[a.node.za].m;
                                a.m.open && a.m.open(a);
                            },
                            ba: ()=>{
                                throw new O(70);
                            }
                        }, ub = (a, b)=>{
                            Fb[a] = {
                                m: b
                            };
                        }, Wb = (a, b)=>{
                            var c = "/" === b, d = !b;
                            if (c && Eb) throw new O(10);
                            if (!c && !d) {
                                var e = Lb(b, {
                                    gb: !1
                                });
                                b = e.path;
                                e = e.node;
                                if (e.wa) throw new O(10);
                                if (16384 !== (e.mode & 61440)) throw new O(54);
                            }
                            b = {
                                type: a,
                                Qc: {},
                                mb: b,
                                kc: []
                            };
                            a = a.U(b);
                            a.U = b;
                            b.root = a;
                            c ? Eb = a : e && (e.wa = b, e.U && e.U.kc.push(b));
                        }, S = (a, b, c)=>{
                            var d = Lb(a, {
                                parent: !0
                            }).node;
                            a = ib(a);
                            if (!a || "." === a || ".." === a) throw new O(28);
                            var e = Rb(d, a);
                            if (e) throw new O(e);
                            if (!d.l.va) throw new O(63);
                            return d.l.va(d, a, b, c);
                        }, Xb = (a, b, c)=>{
                            "undefined" == typeof c && (c = b, b = 438);
                            S(a, b | 8192, c);
                        }, cc = (a, b)=>{
                            if (!lb(a)) throw new O(44);
                            var c = Lb(b, {
                                parent: !0
                            }).node;
                            if (!c) throw new O(44);
                            b = ib(b);
                            var d = Rb(c, b);
                            if (d) throw new O(d);
                            if (!c.l.Ea) throw new O(63);
                            c.l.Ea(c, b, a);
                        }, Kb = (a)=>{
                            a = Lb(a).node;
                            if (!a) throw new O(44);
                            if (!a.l.ma) throw new O(28);
                            return lb(Mb(a.parent), a.l.ma(a));
                        }, ec = (a, b, c)=>{
                            if ("" === a) throw new O(44);
                            if ("string" == typeof b) {
                                var d = {
                                    r: 0,
                                    "r+": 2,
                                    w: 577,
                                    "w+": 578,
                                    a: 1089,
                                    "a+": 1090
                                }[b];
                                if ("undefined" == typeof d) throw Error(`Unknown file open mode: ${b}`);
                                b = d;
                            }
                            c = b & 64 ? ("undefined" == typeof c ? 438 : c) & 4095 | 32768 : 0;
                            if ("object" == typeof a) var e = a;
                            else {
                                a = gb(a);
                                try {
                                    e = Lb(a, {
                                        fb: !(b & 131072)
                                    }).node;
                                } catch (f) {}
                            }
                            d = !1;
                            if (b & 64) {
                                if (e) {
                                    if (b & 128) throw new O(20);
                                } else e = S(a, c, 0), d = !0;
                            }
                            if (!e) throw new O(44);
                            8192 === (e.mode & 61440) && (b &= -513);
                            if (b & 65536 && 16384 !== (e.mode & 61440)) throw new O(54);
                            if (!d && (c = e ? 40960 === (e.mode & 61440) ? 32 : 16384 === (e.mode & 61440) && ("r" !== Qb(b) || b & 512) ? 31 : Ob(e, Qb(b)) : 44)) throw new O(c);
                            if (b & 512 && !d) {
                                c = e;
                                c = "string" == typeof c ? Lb(c, {
                                    fb: !0
                                }).node : c;
                                if (!c.l.P) throw new O(63);
                                if (16384 === (c.mode & 61440)) throw new O(31);
                                if (32768 !== (c.mode & 61440)) throw new O(28);
                                if (d = Ob(c, "w")) throw new O(d);
                                c.l.P(c, {
                                    size: 0,
                                    timestamp: Date.now()
                                });
                            }
                            b &= -131713;
                            e = Vb({
                                node: e,
                                path: Mb(e),
                                flags: b,
                                seekable: !0,
                                position: 0,
                                m: e.m,
                                zc: [],
                                error: !1
                            });
                            e.m.open && e.m.open(e);
                            !m.logReadFiles || b & 1 || (dc || (dc = {}), a in dc || (dc[a] = 1));
                            return e;
                        }, fc = (a, b, c)=>{
                            if (null === a.X) throw new O(8);
                            if (!a.seekable || !a.m.ba) throw new O(70);
                            if (0 != c && 1 != c && 2 != c) throw new O(28);
                            a.position = a.m.ba(a, b, c);
                            a.zc = [];
                        }, gc = ()=>{
                            O || (O = function(a, b) {
                                this.name = "ErrnoError";
                                this.node = b;
                                this.pc = function(c) {
                                    this.aa = c;
                                };
                                this.pc(a);
                                this.message = "FS error";
                            }, O.prototype = Error(), O.prototype.constructor = O, [
                                44
                            ].forEach((a)=>{
                                Bb[a] = new O(a);
                                Bb[a].stack = "<generic error, no stack>";
                            }));
                        }, hc, jc = (a, b, c)=>{
                            a = gb("/dev/" + a);
                            var d = Db(!!b, !!c);
                            ic || (ic = 64);
                            var e = ic++ << 8 | 0;
                            ub(e, {
                                open: (f)=>{
                                    f.seekable = !1;
                                },
                                close: ()=>{
                                    c && c.buffer && c.buffer.length && c(10);
                                },
                                read: (f, g, n, p)=>{
                                    for(var l = 0, u = 0; u < p; u++){
                                        try {
                                            var v = b();
                                        } catch (x) {
                                            throw new O(29);
                                        }
                                        if (void 0 === v && 0 === l) throw new O(6);
                                        if (null === v || void 0 === v) break;
                                        l++;
                                        g[n + u] = v;
                                    }
                                    l && (f.node.timestamp = Date.now());
                                    return l;
                                },
                                write: (f, g, n, p)=>{
                                    for(var l = 0; l < p; l++)try {
                                        c(g[n + l]);
                                    } catch (u) {
                                        throw new O(29);
                                    }
                                    p && (f.node.timestamp = Date.now());
                                    return l;
                                }
                            });
                            Xb(a, d, e);
                        }, ic, kc = {}, Ub, dc, lc = void 0;
                        function mc() {
                            lc += 4;
                            return L[lc - 4 >> 2];
                        }
                        function nc(a) {
                            if (void 0 === a) return "_unknown";
                            a = a.replace(/[^a-zA-Z0-9_]/g, "$");
                            var b = a.charCodeAt(0);
                            return 48 <= b && 57 >= b ? `_${a}` : a;
                        }
                        function oc(a, b) {
                            a = nc(a);
                            return ({
                                [a]: function() {
                                    return b.apply(this, arguments);
                                }
                            })[a];
                        }
                        function pc() {
                            this.M = [
                                void 0
                            ];
                            this.hb = [];
                        }
                        var U = new pc(), qc = void 0;
                        function V(a) {
                            throw new qc(a);
                        }
                        var rc = (a)=>{
                            a || V("Cannot use deleted val. handle = " + a);
                            return U.get(a).value;
                        }, sc = (a)=>{
                            switch(a){
                                case void 0:
                                    return 1;
                                case null:
                                    return 2;
                                case !0:
                                    return 3;
                                case !1:
                                    return 4;
                                default:
                                    return U.pa({
                                        tb: 1,
                                        value: a
                                    });
                            }
                        };
                        function tc(a) {
                            var b = Error, c = oc(a, function(d) {
                                this.name = a;
                                this.message = d;
                                d = Error(d).stack;
                                void 0 !== d && (this.stack = this.toString() + "\n" + d.replace(/^Error(:[^\n]*)?\n/, ""));
                            });
                            c.prototype = Object.create(b.prototype);
                            c.prototype.constructor = c;
                            c.prototype.toString = function() {
                                return void 0 === this.message ? this.name : `${this.name}: ${this.message}`;
                            };
                            return c;
                        }
                        var uc = void 0, vc = void 0;
                        function W(a) {
                            for(var b = ""; E[a];)b += vc[E[a++]];
                            return b;
                        }
                        var wc = [];
                        function xc() {
                            for(; wc.length;){
                                var a = wc.pop();
                                a.g.fa = !1;
                                a["delete"]();
                            }
                        }
                        var yc = void 0, zc = {};
                        function Ac(a, b) {
                            for(void 0 === b && V("ptr should not be undefined"); a.A;)b = a.na(b), a = a.A;
                            return b;
                        }
                        var Bc = {};
                        function Cc(a) {
                            a = Dc(a);
                            var b = W(a);
                            Ec(a);
                            return b;
                        }
                        function Fc(a, b) {
                            var c = Bc[a];
                            void 0 === c && V(b + " has unknown type " + Cc(a));
                            return c;
                        }
                        function Gc() {}
                        var Hc = !1;
                        function Ic(a) {
                            --a.count.value;
                            0 === a.count.value && (a.G ? a.L.W(a.G) : a.u.i.W(a.o));
                        }
                        function Jc(a, b, c) {
                            if (b === c) return a;
                            if (void 0 === c.A) return null;
                            a = Jc(a, b, c.A);
                            return null === a ? null : c.Pb(a);
                        }
                        var Kc = {};
                        function Lc(a, b) {
                            b = Ac(a, b);
                            return zc[b];
                        }
                        var Mc = void 0;
                        function Nc(a) {
                            throw new Mc(a);
                        }
                        function Oc(a, b) {
                            b.u && b.o || Nc("makeClassHandle requires ptr and ptrType");
                            !!b.L !== !!b.G && Nc("Both smartPtrType and smartPtr must be specified");
                            b.count = {
                                value: 1
                            };
                            return Pc(Object.create(a, {
                                g: {
                                    value: b
                                }
                            }));
                        }
                        function Pc(a) {
                            if ("undefined" === typeof FinalizationRegistry) return Pc = (b)=>b, a;
                            Hc = new FinalizationRegistry((b)=>{
                                Ic(b.g);
                            });
                            Pc = (b)=>{
                                var c = b.g;
                                c.G && Hc.register(b, {
                                    g: c
                                }, b);
                                return b;
                            };
                            Gc = (b)=>{
                                Hc.unregister(b);
                            };
                            return Pc(a);
                        }
                        var Qc = {};
                        function Rc(a) {
                            for(; a.length;){
                                var b = a.pop();
                                a.pop()(b);
                            }
                        }
                        function Sc(a) {
                            return this.fromWireType(L[a >> 2]);
                        }
                        var Tc = {}, Uc = {};
                        function Y(a, b, c) {
                            function d(n) {
                                n = c(n);
                                n.length !== a.length && Nc("Mismatched type converter count");
                                for(var p = 0; p < a.length; ++p)Vc(a[p], n[p]);
                            }
                            a.forEach(function(n) {
                                Uc[n] = b;
                            });
                            var e = Array(b.length), f = [], g = 0;
                            b.forEach((n, p)=>{
                                Bc.hasOwnProperty(n) ? e[p] = Bc[n] : (f.push(n), Tc.hasOwnProperty(n) || (Tc[n] = []), Tc[n].push(()=>{
                                    e[p] = Bc[n];
                                    ++g;
                                    g === f.length && d(e);
                                }));
                            });
                            0 === f.length && d(e);
                        }
                        function Wc(a) {
                            switch(a){
                                case 1:
                                    return 0;
                                case 2:
                                    return 1;
                                case 4:
                                    return 2;
                                case 8:
                                    return 3;
                                default:
                                    throw new TypeError(`Unknown type size: ${a}`);
                            }
                        }
                        function Xc(a, b, c = {}) {
                            var d = b.name;
                            a || V(`type "${d}" must have a positive integer typeid pointer`);
                            if (Bc.hasOwnProperty(a)) {
                                if (c.$b) return;
                                V(`Cannot register type '${d}' twice`);
                            }
                            Bc[a] = b;
                            delete Uc[a];
                            Tc.hasOwnProperty(a) && (b = Tc[a], delete Tc[a], b.forEach((e)=>e()));
                        }
                        function Vc(a, b, c = {}) {
                            if (!("argPackAdvance" in b)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
                            Xc(a, b, c);
                        }
                        function Yc(a) {
                            V(a.g.u.i.name + " instance already deleted");
                        }
                        function Zc() {}
                        function $c(a, b, c) {
                            if (void 0 === a[b].B) {
                                var d = a[b];
                                a[b] = function() {
                                    a[b].B.hasOwnProperty(arguments.length) || V(`Function '${c}' called with an invalid number of arguments (${arguments.length}) - expects one of (${a[b].B})!`);
                                    return a[b].B[arguments.length].apply(this, arguments);
                                };
                                a[b].B = [];
                                a[b].B[d.ea] = d;
                            }
                        }
                        function ad(a, b, c) {
                            m.hasOwnProperty(a) ? ((void 0 === c || void 0 !== m[a].B && void 0 !== m[a].B[c]) && V(`Cannot register public name '${a}' twice`), $c(m, a, a), m.hasOwnProperty(c) && V(`Cannot register multiple overloads of a function with the same number of arguments (${c})!`), m[a].B[c] = b) : (m[a] = b, void 0 !== c && (m[a].Pc = c));
                        }
                        function bd(a, b, c, d, e, f, g, n) {
                            this.name = a;
                            this.constructor = b;
                            this.N = c;
                            this.W = d;
                            this.A = e;
                            this.Ub = f;
                            this.na = g;
                            this.Pb = n;
                            this.qb = [];
                        }
                        function cd(a, b, c) {
                            for(; b !== c;)b.na || V(`Expected null or instance of ${c.name}, got an instance of ${b.name}`), a = b.na(a), b = b.A;
                            return a;
                        }
                        function dd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function fd(a, b) {
                            if (null === b) {
                                this.Na && V(`null is not a valid ${this.name}`);
                                if (this.ua) {
                                    var c = this.Pa();
                                    null !== a && a.push(this.W, c);
                                    return c;
                                }
                                return 0;
                            }
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            !this.ta && b.g.u.ta && V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                            c = cd(b.g.o, b.g.u.i, this.i);
                            if (this.ua) switch(void 0 === b.g.G && V("Passing raw pointer to smart pointer is illegal"), this.tc){
                                case 0:
                                    b.g.L === this ? c = b.g.G : V(`Cannot convert argument of type ${b.g.L ? b.g.L.name : b.g.u.name} to parameter type ${this.name}`);
                                    break;
                                case 1:
                                    c = b.g.G;
                                    break;
                                case 2:
                                    if (b.g.L === this) c = b.g.G;
                                    else {
                                        var d = b.clone();
                                        c = this.oc(c, sc(function() {
                                            d["delete"]();
                                        }));
                                        null !== a && a.push(this.W, c);
                                    }
                                    break;
                                default:
                                    V("Unsupporting sharing policy");
                            }
                            return c;
                        }
                        function gd(a, b) {
                            if (null === b) return this.Na && V(`null is not a valid ${this.name}`), 0;
                            b.g || V(`Cannot pass "${ed(b)}" as a ${this.name}`);
                            b.g.o || V(`Cannot pass deleted object as a pointer of type ${this.name}`);
                            b.g.u.ta && V(`Cannot convert argument of type ${b.g.u.name} to parameter type ${this.name}`);
                            return cd(b.g.o, b.g.u.i, this.i);
                        }
                        function hd(a, b, c, d) {
                            this.name = a;
                            this.i = b;
                            this.Na = c;
                            this.ta = d;
                            this.ua = !1;
                            this.W = this.oc = this.Pa = this.rb = this.tc = this.nc = void 0;
                            void 0 !== b.A ? this.toWireType = fd : (this.toWireType = d ? dd : gd, this.K = null);
                        }
                        function jd(a, b, c) {
                            m.hasOwnProperty(a) || Nc("Replacing nonexistant public symbol");
                            void 0 !== m[a].B && void 0 !== c ? m[a].B[c] = b : (m[a] = b, m[a].ea = c);
                        }
                        var kd = [], ld = (a)=>{
                            var b = kd[a];
                            b || (a >= kd.length && (kd.length = a + 1), kd[a] = b = Ka.get(a));
                            return b;
                        }, md = (a, b)=>{
                            var c = [];
                            return function() {
                                c.length = 0;
                                Object.assign(c, arguments);
                                if (a.includes("j")) {
                                    var d = m["dynCall_" + a];
                                    d = c && c.length ? d.apply(null, [
                                        b
                                    ].concat(c)) : d.call(null, b);
                                } else d = ld(b).apply(null, c);
                                return d;
                            };
                        };
                        function Z(a, b) {
                            a = W(a);
                            var c = a.includes("j") ? md(a, b) : ld(b);
                            "function" != typeof c && V(`unknown function pointer with signature ${a}: ${b}`);
                            return c;
                        }
                        var nd = void 0;
                        function od(a, b) {
                            function c(f) {
                                e[f] || Bc[f] || (Uc[f] ? Uc[f].forEach(c) : (d.push(f), e[f] = !0));
                            }
                            var d = [], e = {};
                            b.forEach(c);
                            throw new nd(`${a}: ` + d.map(Cc).join([
                                ", "
                            ]));
                        }
                        function pd(a, b, c, d, e) {
                            var f = b.length;
                            2 > f && V("argTypes array size mismatch! Must at least get return value and 'this' types!");
                            var g = null !== b[1] && null !== c, n = !1;
                            for(c = 1; c < b.length; ++c)if (null !== b[c] && void 0 === b[c].K) {
                                n = !0;
                                break;
                            }
                            var p = "void" !== b[0].name, l = f - 2, u = Array(l), v = [], x = [];
                            return function() {
                                arguments.length !== l && V(`function ${a} called with ${arguments.length} arguments, expected ${l} args!`);
                                x.length = 0;
                                v.length = g ? 2 : 1;
                                v[0] = e;
                                if (g) {
                                    var k = b[1].toWireType(x, this);
                                    v[1] = k;
                                }
                                for(var t = 0; t < l; ++t)u[t] = b[t + 2].toWireType(x, arguments[t]), v.push(u[t]);
                                t = d.apply(null, v);
                                if (n) Rc(x);
                                else for(var r = g ? 1 : 2; r < b.length; r++){
                                    var B = 1 === r ? k : u[r - 2];
                                    null !== b[r].K && b[r].K(B);
                                }
                                k = p ? b[0].fromWireType(t) : void 0;
                                return k;
                            };
                        }
                        function sd(a, b) {
                            for(var c = [], d = 0; d < a; d++)c.push(N[b + 4 * d >> 2]);
                            return c;
                        }
                        function td(a, b, c) {
                            a instanceof Object || V(`${c} with invalid "this": ${a}`);
                            a instanceof b.i.constructor || V(`${c} incompatible with "this" of type ${a.constructor.name}`);
                            a.g.o || V(`cannot call emscripten binding method ${c} on deleted object`);
                            return cd(a.g.o, a.g.u.i, b.i);
                        }
                        function ud(a) {
                            a >= U.h && 0 === --U.get(a).tb && U.Zb(a);
                        }
                        function vd(a, b, c) {
                            switch(b){
                                case 0:
                                    return function(d) {
                                        return this.fromWireType((c ? C : E)[d]);
                                    };
                                case 1:
                                    return function(d) {
                                        return this.fromWireType((c ? Da : Ea)[d >> 1]);
                                    };
                                case 2:
                                    return function(d) {
                                        return this.fromWireType((c ? L : N)[d >> 2]);
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        function ed(a) {
                            if (null === a) return "null";
                            var b = typeof a;
                            return "object" === b || "array" === b || "function" === b ? a.toString() : "" + a;
                        }
                        function wd(a, b) {
                            switch(b){
                                case 2:
                                    return function(c) {
                                        return this.fromWireType(Fa[c >> 2]);
                                    };
                                case 3:
                                    return function(c) {
                                        return this.fromWireType(Ia[c >> 3]);
                                    };
                                default:
                                    throw new TypeError("Unknown float type: " + a);
                            }
                        }
                        function xd(a, b, c) {
                            switch(b){
                                case 0:
                                    return c ? function(d) {
                                        return C[d];
                                    } : function(d) {
                                        return E[d];
                                    };
                                case 1:
                                    return c ? function(d) {
                                        return Da[d >> 1];
                                    } : function(d) {
                                        return Ea[d >> 1];
                                    };
                                case 2:
                                    return c ? function(d) {
                                        return L[d >> 2];
                                    } : function(d) {
                                        return N[d >> 2];
                                    };
                                default:
                                    throw new TypeError("Unknown integer type: " + a);
                            }
                        }
                        var yd = "undefined" != typeof TextDecoder ? new TextDecoder("utf-16le") : void 0, zd = (a, b)=>{
                            var c = a >> 1;
                            for(var d = c + b / 2; !(c >= d) && Ea[c];)++c;
                            c <<= 1;
                            if (32 < c - a && yd) return yd.decode(E.subarray(a, c));
                            c = "";
                            for(d = 0; !(d >= b / 2); ++d){
                                var e = Da[a + 2 * d >> 1];
                                if (0 == e) break;
                                c += String.fromCharCode(e);
                            }
                            return c;
                        }, Ad = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (2 > c) return 0;
                            c -= 2;
                            var d = b;
                            c = c < 2 * a.length ? c / 2 : a.length;
                            for(var e = 0; e < c; ++e)Da[b >> 1] = a.charCodeAt(e), b += 2;
                            Da[b >> 1] = 0;
                            return b - d;
                        }, Bd = (a)=>2 * a.length, Cd = (a, b)=>{
                            for(var c = 0, d = ""; !(c >= b / 4);){
                                var e = L[a + 4 * c >> 2];
                                if (0 == e) break;
                                ++c;
                                65536 <= e ? (e -= 65536, d += String.fromCharCode(55296 | e >> 10, 56320 | e & 1023)) : d += String.fromCharCode(e);
                            }
                            return d;
                        }, Dd = (a, b, c)=>{
                            void 0 === c && (c = 2147483647);
                            if (4 > c) return 0;
                            var d = b;
                            c = d + c - 4;
                            for(var e = 0; e < a.length; ++e){
                                var f = a.charCodeAt(e);
                                if (55296 <= f && 57343 >= f) {
                                    var g = a.charCodeAt(++e);
                                    f = 65536 + ((f & 1023) << 10) | g & 1023;
                                }
                                L[b >> 2] = f;
                                b += 4;
                                if (b + 4 > c) break;
                            }
                            L[b >> 2] = 0;
                            return b - d;
                        }, Ed = (a)=>{
                            for(var b = 0, c = 0; c < a.length; ++c){
                                var d = a.charCodeAt(c);
                                55296 <= d && 57343 >= d && ++c;
                                b += 4;
                            }
                            return b;
                        }, Fd = {};
                        function Gd(a) {
                            var b = Fd[a];
                            return void 0 === b ? W(a) : b;
                        }
                        var Hd = [];
                        function Id(a) {
                            var b = Hd.length;
                            Hd.push(a);
                            return b;
                        }
                        function Jd(a, b) {
                            for(var c = Array(a), d = 0; d < a; ++d)c[d] = Fc(N[b + 4 * d >> 2], "parameter " + d);
                            return c;
                        }
                        var Kd = [], Ld = [], Md = {}, Od = ()=>{
                            if (!Nd) {
                                var a = {
                                    USER: "web_user",
                                    LOGNAME: "web_user",
                                    PATH: "/",
                                    PWD: "/",
                                    HOME: "/home/web_user",
                                    LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
                                    _: na || "./this.program"
                                }, b;
                                for(b in Md)void 0 === Md[b] ? delete a[b] : a[b] = Md[b];
                                var c = [];
                                for(b in a)c.push(`${b}=${a[b]}`);
                                Nd = c;
                            }
                            return Nd;
                        }, Nd, Pd = (a)=>0 === a % 4 && (0 !== a % 100 || 0 === a % 400), Qd = [
                            31,
                            29,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Rd = [
                            31,
                            28,
                            31,
                            30,
                            31,
                            30,
                            31,
                            31,
                            30,
                            31,
                            30,
                            31
                        ], Sd = (a, b, c, d)=>{
                            function e(k, t, r) {
                                for(k = "number" == typeof k ? k.toString() : k || ""; k.length < t;)k = r[0] + k;
                                return k;
                            }
                            function f(k, t) {
                                return e(k, t, "0");
                            }
                            function g(k, t) {
                                function r(D) {
                                    return 0 > D ? -1 : 0 < D ? 1 : 0;
                                }
                                var B;
                                0 === (B = r(k.getFullYear() - t.getFullYear())) && 0 === (B = r(k.getMonth() - t.getMonth())) && (B = r(k.getDate() - t.getDate()));
                                return B;
                            }
                            function n(k) {
                                switch(k.getDay()){
                                    case 0:
                                        return new Date(k.getFullYear() - 1, 11, 29);
                                    case 1:
                                        return k;
                                    case 2:
                                        return new Date(k.getFullYear(), 0, 3);
                                    case 3:
                                        return new Date(k.getFullYear(), 0, 2);
                                    case 4:
                                        return new Date(k.getFullYear(), 0, 1);
                                    case 5:
                                        return new Date(k.getFullYear() - 1, 11, 31);
                                    case 6:
                                        return new Date(k.getFullYear() - 1, 11, 30);
                                }
                            }
                            function p(k) {
                                var t = k.ca;
                                for(k = new Date(new Date(k.da + 1900, 0, 1).getTime()); 0 < t;){
                                    var r = k.getMonth(), B = (Pd(k.getFullYear()) ? Qd : Rd)[r];
                                    if (t > B - k.getDate()) t -= B - k.getDate() + 1, k.setDate(1), 11 > r ? k.setMonth(r + 1) : (k.setMonth(0), k.setFullYear(k.getFullYear() + 1));
                                    else {
                                        k.setDate(k.getDate() + t);
                                        break;
                                    }
                                }
                                r = new Date(k.getFullYear() + 1, 0, 4);
                                t = n(new Date(k.getFullYear(), 0, 4));
                                r = n(r);
                                return 0 >= g(t, k) ? 0 >= g(r, k) ? k.getFullYear() + 1 : k.getFullYear() : k.getFullYear() - 1;
                            }
                            var l = L[d + 40 >> 2];
                            d = {
                                wc: L[d >> 2],
                                vc: L[d + 4 >> 2],
                                Fa: L[d + 8 >> 2],
                                Sa: L[d + 12 >> 2],
                                Ga: L[d + 16 >> 2],
                                da: L[d + 20 >> 2],
                                R: L[d + 24 >> 2],
                                ca: L[d + 28 >> 2],
                                Rc: L[d + 32 >> 2],
                                uc: L[d + 36 >> 2],
                                xc: l ? l ? nb(E, l) : "" : ""
                            };
                            c = c ? nb(E, c) : "";
                            l = {
                                "%c": "%a %b %d %H:%M:%S %Y",
                                "%D": "%m/%d/%y",
                                "%F": "%Y-%m-%d",
                                "%h": "%b",
                                "%r": "%I:%M:%S %p",
                                "%R": "%H:%M",
                                "%T": "%H:%M:%S",
                                "%x": "%m/%d/%y",
                                "%X": "%H:%M:%S",
                                "%Ec": "%c",
                                "%EC": "%C",
                                "%Ex": "%m/%d/%y",
                                "%EX": "%H:%M:%S",
                                "%Ey": "%y",
                                "%EY": "%Y",
                                "%Od": "%d",
                                "%Oe": "%e",
                                "%OH": "%H",
                                "%OI": "%I",
                                "%Om": "%m",
                                "%OM": "%M",
                                "%OS": "%S",
                                "%Ou": "%u",
                                "%OU": "%U",
                                "%OV": "%V",
                                "%Ow": "%w",
                                "%OW": "%W",
                                "%Oy": "%y"
                            };
                            for(var u in l)c = c.replace(new RegExp(u, "g"), l[u]);
                            var v = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), x = "January February March April May June July August September October November December".split(" ");
                            l = {
                                "%a": (k)=>v[k.R].substring(0, 3),
                                "%A": (k)=>v[k.R],
                                "%b": (k)=>x[k.Ga].substring(0, 3),
                                "%B": (k)=>x[k.Ga],
                                "%C": (k)=>f((k.da + 1900) / 100 | 0, 2),
                                "%d": (k)=>f(k.Sa, 2),
                                "%e": (k)=>e(k.Sa, 2, " "),
                                "%g": (k)=>p(k).toString().substring(2),
                                "%G": (k)=>p(k),
                                "%H": (k)=>f(k.Fa, 2),
                                "%I": (k)=>{
                                    k = k.Fa;
                                    0 == k ? k = 12 : 12 < k && (k -= 12);
                                    return f(k, 2);
                                },
                                "%j": (k)=>{
                                    for(var t = 0, r = 0; r <= k.Ga - 1; t += (Pd(k.da + 1900) ? Qd : Rd)[r++]);
                                    return f(k.Sa + t, 3);
                                },
                                "%m": (k)=>f(k.Ga + 1, 2),
                                "%M": (k)=>f(k.vc, 2),
                                "%n": ()=>"\n",
                                "%p": (k)=>0 <= k.Fa && 12 > k.Fa ? "AM" : "PM",
                                "%S": (k)=>f(k.wc, 2),
                                "%t": ()=>"	",
                                "%u": (k)=>k.R || 7,
                                "%U": (k)=>f(Math.floor((k.ca + 7 - k.R) / 7), 2),
                                "%V": (k)=>{
                                    var t = Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7);
                                    2 >= (k.R + 371 - k.ca - 2) % 7 && t++;
                                    if (t) 53 == t && (r = (k.R + 371 - k.ca) % 7, 4 == r || 3 == r && Pd(k.da) || (t = 1));
                                    else {
                                        t = 52;
                                        var r = (k.R + 7 - k.ca - 1) % 7;
                                        (4 == r || 5 == r && Pd(k.da % 400 - 1)) && t++;
                                    }
                                    return f(t, 2);
                                },
                                "%w": (k)=>k.R,
                                "%W": (k)=>f(Math.floor((k.ca + 7 - (k.R + 6) % 7) / 7), 2),
                                "%y": (k)=>(k.da + 1900).toString().substring(2),
                                "%Y": (k)=>k.da + 1900,
                                "%z": (k)=>{
                                    k = k.uc;
                                    var t = 0 <= k;
                                    k = Math.abs(k) / 60;
                                    return (t ? "+" : "-") + String("0000" + (k / 60 * 100 + k % 60)).slice(-4);
                                },
                                "%Z": (k)=>k.xc,
                                "%%": ()=>"%"
                            };
                            c = c.replace(/%%/g, "\x00\x00");
                            for(u in l)c.includes(u) && (c = c.replace(new RegExp(u, "g"), l[u](d)));
                            c = c.replace(/\0\0/g, "%");
                            u = rb(c, !1);
                            if (u.length > b) return 0;
                            C.set(u, a);
                            return u.length - 1;
                        };
                        function Pb(a, b, c, d) {
                            a || (a = this);
                            this.parent = a;
                            this.U = a.U;
                            this.wa = null;
                            this.id = Hb++;
                            this.name = b;
                            this.mode = c;
                            this.l = {};
                            this.m = {};
                            this.za = d;
                        }
                        Object.defineProperties(Pb.prototype, {
                            read: {
                                get: function() {
                                    return 365 === (this.mode & 365);
                                },
                                set: function(a) {
                                    a ? this.mode |= 365 : this.mode &= -366;
                                }
                            },
                            write: {
                                get: function() {
                                    return 146 === (this.mode & 146);
                                },
                                set: function(a) {
                                    a ? this.mode |= 146 : this.mode &= -147;
                                }
                            }
                        });
                        gc();
                        Ib = Array(4096);
                        Wb(P, "/");
                        S("/tmp", 16895, 0);
                        S("/home", 16895, 0);
                        S("/home/web_user", 16895, 0);
                        (()=>{
                            S("/dev", 16895, 0);
                            ub(259, {
                                read: ()=>0,
                                write: (d, e, f, g)=>g
                            });
                            Xb("/dev/null", 259);
                            tb(1280, wb);
                            tb(1536, xb);
                            Xb("/dev/tty", 1280);
                            Xb("/dev/tty1", 1536);
                            var a = new Uint8Array(1024), b = 0, c = ()=>{
                                0 === b && (b = kb(a).byteLength);
                                return a[--b];
                            };
                            jc("random", c);
                            jc("urandom", c);
                            S("/dev/shm", 16895, 0);
                            S("/dev/shm/tmp", 16895, 0);
                        })();
                        (()=>{
                            S("/proc", 16895, 0);
                            var a = S("/proc/self", 16895, 0);
                            S("/proc/self/fd", 16895, 0);
                            Wb({
                                U: ()=>{
                                    var b = Ab(a, "fd", 16895, 73);
                                    b.l = {
                                        ka: (c, d)=>{
                                            var e = Tb(+d);
                                            c = {
                                                parent: null,
                                                U: {
                                                    mb: "fake"
                                                },
                                                l: {
                                                    ma: ()=>e.path
                                                }
                                            };
                                            return c.parent = c;
                                        }
                                    };
                                    return b;
                                }
                            }, "/proc/self/fd");
                        })();
                        Object.assign(pc.prototype, {
                            get (a) {
                                return this.M[a];
                            },
                            has (a) {
                                return void 0 !== this.M[a];
                            },
                            pa (a) {
                                var b = this.hb.pop() || this.M.length;
                                this.M[b] = a;
                                return b;
                            },
                            Zb (a) {
                                this.M[a] = void 0;
                                this.hb.push(a);
                            }
                        });
                        qc = m.BindingError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "BindingError";
                            }
                        };
                        U.M.push({
                            value: void 0
                        }, {
                            value: null
                        }, {
                            value: !0
                        }, {
                            value: !1
                        });
                        U.h = U.M.length;
                        m.count_emval_handles = function() {
                            for(var a = 0, b = U.h; b < U.M.length; ++b)void 0 !== U.M[b] && ++a;
                            return a;
                        };
                        uc = m.PureVirtualError = tc("PureVirtualError");
                        for(var Td = Array(256), Ud = 0; 256 > Ud; ++Ud)Td[Ud] = String.fromCharCode(Ud);
                        vc = Td;
                        m.getInheritedInstanceCount = function() {
                            return Object.keys(zc).length;
                        };
                        m.getLiveInheritedInstances = function() {
                            var a = [], b;
                            for(b in zc)zc.hasOwnProperty(b) && a.push(zc[b]);
                            return a;
                        };
                        m.flushPendingDeletes = xc;
                        m.setDelayFunction = function(a) {
                            yc = a;
                            wc.length && yc && yc(xc);
                        };
                        Mc = m.InternalError = class extends Error {
                            constructor(a){
                                super(a);
                                this.name = "InternalError";
                            }
                        };
                        Zc.prototype.isAliasOf = function(a) {
                            if (!(this instanceof Zc && a instanceof Zc)) return !1;
                            var b = this.g.u.i, c = this.g.o, d = a.g.u.i;
                            for(a = a.g.o; b.A;)c = b.na(c), b = b.A;
                            for(; d.A;)a = d.na(a), d = d.A;
                            return b === d && c === a;
                        };
                        Zc.prototype.clone = function() {
                            this.g.o || Yc(this);
                            if (this.g.ia) return this.g.count.value += 1, this;
                            var a = Pc, b = Object, c = b.create, d = Object.getPrototypeOf(this), e = this.g;
                            a = a(c.call(b, d, {
                                g: {
                                    value: {
                                        count: e.count,
                                        fa: e.fa,
                                        ia: e.ia,
                                        o: e.o,
                                        u: e.u,
                                        G: e.G,
                                        L: e.L
                                    }
                                }
                            }));
                            a.g.count.value += 1;
                            a.g.fa = !1;
                            return a;
                        };
                        Zc.prototype["delete"] = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            Gc(this);
                            Ic(this.g);
                            this.g.ia || (this.g.G = void 0, this.g.o = void 0);
                        };
                        Zc.prototype.isDeleted = function() {
                            return !this.g.o;
                        };
                        Zc.prototype.deleteLater = function() {
                            this.g.o || Yc(this);
                            this.g.fa && !this.g.ia && V("Object already scheduled for deletion");
                            wc.push(this);
                            1 === wc.length && yc && yc(xc);
                            this.g.fa = !0;
                            return this;
                        };
                        hd.prototype.Vb = function(a) {
                            this.rb && (a = this.rb(a));
                            return a;
                        };
                        hd.prototype.ab = function(a) {
                            this.W && this.W(a);
                        };
                        hd.prototype.argPackAdvance = 8;
                        hd.prototype.readValueFromPointer = Sc;
                        hd.prototype.deleteObject = function(a) {
                            if (null !== a) a["delete"]();
                        };
                        hd.prototype.fromWireType = function(a) {
                            function b() {
                                return this.ua ? Oc(this.i.N, {
                                    u: this.nc,
                                    o: c,
                                    L: this,
                                    G: a
                                }) : Oc(this.i.N, {
                                    u: this,
                                    o: a
                                });
                            }
                            var c = this.Vb(a);
                            if (!c) return this.ab(a), null;
                            var d = Lc(this.i, c);
                            if (void 0 !== d) {
                                if (0 === d.g.count.value) return d.g.o = c, d.g.G = a, d.clone();
                                d = d.clone();
                                this.ab(a);
                                return d;
                            }
                            d = this.i.Ub(c);
                            d = Kc[d];
                            if (!d) return b.call(this);
                            d = this.ta ? d.Kb : d.pointerType;
                            var e = Jc(c, this.i, d.i);
                            return null === e ? b.call(this) : this.ua ? Oc(d.i.N, {
                                u: d,
                                o: e,
                                L: this,
                                G: a
                            }) : Oc(d.i.N, {
                                u: d,
                                o: e
                            });
                        };
                        nd = m.UnboundTypeError = tc("UnboundTypeError");
                        var Xd = {
                            __syscall_fcntl64: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 0:
                                            var e = mc();
                                            return 0 > e ? -28 : Vb(d, e).X;
                                        case 1:
                                        case 2:
                                            return 0;
                                        case 3:
                                            return d.flags;
                                        case 4:
                                            return e = mc(), d.flags |= e, 0;
                                        case 5:
                                            return e = mc(), Da[e + 0 >> 1] = 2, 0;
                                        case 6:
                                        case 7:
                                            return 0;
                                        case 16:
                                        case 8:
                                            return -28;
                                        case 9:
                                            return L[Vd() >> 2] = 28, -1;
                                        default:
                                            return -28;
                                    }
                                } catch (f) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== f.name) throw f;
                                    return -f.aa;
                                }
                            },
                            __syscall_ioctl: function(a, b, c) {
                                lc = c;
                                try {
                                    var d = Tb(a);
                                    switch(b){
                                        case 21509:
                                            return d.s ? 0 : -59;
                                        case 21505:
                                            if (!d.s) return -59;
                                            if (d.s.V.bc) {
                                                b = [
                                                    3,
                                                    28,
                                                    127,
                                                    21,
                                                    4,
                                                    0,
                                                    1,
                                                    0,
                                                    17,
                                                    19,
                                                    26,
                                                    0,
                                                    18,
                                                    15,
                                                    23,
                                                    22,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0,
                                                    0
                                                ];
                                                var e = mc();
                                                L[e >> 2] = 25856;
                                                L[e + 4 >> 2] = 5;
                                                L[e + 8 >> 2] = 191;
                                                L[e + 12 >> 2] = 35387;
                                                for(var f = 0; 32 > f; f++)C[e + f + 17 >> 0] = b[f] || 0;
                                            }
                                            return 0;
                                        case 21510:
                                        case 21511:
                                        case 21512:
                                            return d.s ? 0 : -59;
                                        case 21506:
                                        case 21507:
                                        case 21508:
                                            if (!d.s) return -59;
                                            if (d.s.V.cc) for(e = mc(), b = [], f = 0; 32 > f; f++)b.push(C[e + f + 17 >> 0]);
                                            return 0;
                                        case 21519:
                                            if (!d.s) return -59;
                                            e = mc();
                                            return L[e >> 2] = 0;
                                        case 21520:
                                            return d.s ? -28 : -59;
                                        case 21531:
                                            e = mc();
                                            if (!d.m.ac) throw new O(59);
                                            return d.m.ac(d, b, e);
                                        case 21523:
                                            if (!d.s) return -59;
                                            d.s.V.dc && (f = [
                                                24,
                                                80
                                            ], e = mc(), Da[e >> 1] = f[0], Da[e + 2 >> 1] = f[1]);
                                            return 0;
                                        case 21524:
                                            return d.s ? 0 : -59;
                                        case 21515:
                                            return d.s ? 0 : -59;
                                        default:
                                            return -28;
                                    }
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return -g.aa;
                                }
                            },
                            __syscall_openat: function(a, b, c, d) {
                                lc = d;
                                try {
                                    b = b ? nb(E, b) : "";
                                    var e = b;
                                    if ("/" === e.charAt(0)) b = e;
                                    else {
                                        var f = -100 === a ? "/" : Tb(a).path;
                                        if (0 == e.length) throw new O(44);
                                        b = gb(f + "/" + e);
                                    }
                                    var g = d ? mc() : 0;
                                    return ec(b, c, g).X;
                                } catch (n) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== n.name) throw n;
                                    return -n.aa;
                                }
                            },
                            _embind_create_inheriting_constructor: function(a, b, c) {
                                a = W(a);
                                b = Fc(b, "wrapper");
                                c = rc(c);
                                var d = [].slice, e = b.i, f = e.N, g = e.A.N, n = e.A.constructor;
                                a = oc(a, function() {
                                    e.A.qb.forEach((function(l) {
                                        if (this[l] === g[l]) throw new uc(`Pure virtual function ${l} must be implemented in JavaScript`);
                                    }).bind(this));
                                    Object.defineProperty(this, "__parent", {
                                        value: f
                                    });
                                    this.__construct.apply(this, d.call(arguments));
                                });
                                f.__construct = function() {
                                    this === f && V("Pass correct 'this' to __construct");
                                    var l = n.implement.apply(void 0, [
                                        this
                                    ].concat(d.call(arguments)));
                                    Gc(l);
                                    var u = l.g;
                                    l.notifyOnDestruction();
                                    u.ia = !0;
                                    Object.defineProperties(this, {
                                        g: {
                                            value: u
                                        }
                                    });
                                    Pc(this);
                                    l = u.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? V(`Tried to register registered instance: ${l}`) : zc[l] = this;
                                };
                                f.__destruct = function() {
                                    this === f && V("Pass correct 'this' to __destruct");
                                    Gc(this);
                                    var l = this.g.o;
                                    l = Ac(e, l);
                                    zc.hasOwnProperty(l) ? delete zc[l] : V(`Tried to unregister unregistered instance: ${l}`);
                                };
                                a.prototype = Object.create(f);
                                for(var p in c)a.prototype[p] = c[p];
                                return sc(a);
                            },
                            _embind_finalize_value_object: function(a) {
                                var b = Qc[a];
                                delete Qc[a];
                                var c = b.Pa, d = b.W, e = b.eb, f = e.map((g)=>g.Yb).concat(e.map((g)=>g.rc));
                                Y([
                                    a
                                ], f, (g)=>{
                                    var n = {};
                                    e.forEach((p, l)=>{
                                        var u = g[l], v = p.Wb, x = p.Xb, k = g[l + e.length], t = p.qc, r = p.sc;
                                        n[p.Sb] = {
                                            read: (B)=>u.fromWireType(v(x, B)),
                                            write: (B, D)=>{
                                                var w = [];
                                                t(r, B, k.toWireType(w, D));
                                                Rc(w);
                                            }
                                        };
                                    });
                                    return [
                                        {
                                            name: b.name,
                                            fromWireType: function(p) {
                                                var l = {}, u;
                                                for(u in n)l[u] = n[u].read(p);
                                                d(p);
                                                return l;
                                            },
                                            toWireType: function(p, l) {
                                                for(var u in n){
                                                    if (!(u in l)) throw new TypeError(`Missing field: "${u}"`);
                                                }
                                                var v = c();
                                                for(u in n)n[u].write(v, l[u]);
                                                null !== p && p.push(d, v);
                                                return v;
                                            },
                                            argPackAdvance: 8,
                                            readValueFromPointer: Sc,
                                            K: d
                                        }
                                    ];
                                });
                            },
                            _embind_register_bigint: function() {},
                            _embind_register_bool: function(a, b, c, d, e) {
                                var f = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(g) {
                                        return !!g;
                                    },
                                    toWireType: function(g, n) {
                                        return n ? d : e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: function(g) {
                                        if (1 === c) var n = C;
                                        else if (2 === c) n = Da;
                                        else if (4 === c) n = L;
                                        else throw new TypeError("Unknown boolean type size: " + b);
                                        return this.fromWireType(n[g >> f]);
                                    },
                                    K: null
                                });
                            },
                            _embind_register_class: function(a, b, c, d, e, f, g, n, p, l, u, v, x) {
                                u = W(u);
                                f = Z(e, f);
                                n && (n = Z(g, n));
                                l && (l = Z(p, l));
                                x = Z(v, x);
                                var k = nc(u);
                                ad(k, function() {
                                    od(`Cannot construct ${u} due to unbound types`, [
                                        d
                                    ]);
                                });
                                Y([
                                    a,
                                    b,
                                    c
                                ], d ? [
                                    d
                                ] : [], function(t) {
                                    t = t[0];
                                    if (d) {
                                        var r = t.i;
                                        var B = r.N;
                                    } else B = Zc.prototype;
                                    t = oc(k, function() {
                                        if (Object.getPrototypeOf(this) !== D) throw new qc("Use 'new' to construct " + u);
                                        if (void 0 === w.$) throw new qc(u + " has no accessible constructor");
                                        var T = w.$[arguments.length];
                                        if (void 0 === T) throw new qc(`Tried to invoke ctor of ${u} with invalid number of parameters (${arguments.length}) - expected (${Object.keys(w.$).toString()}) parameters instead!`);
                                        return T.apply(this, arguments);
                                    });
                                    var D = Object.create(B, {
                                        constructor: {
                                            value: t
                                        }
                                    });
                                    t.prototype = D;
                                    var w = new bd(u, t, D, x, r, f, n, l);
                                    w.A && (void 0 === w.A.oa && (w.A.oa = []), w.A.oa.push(w));
                                    r = new hd(u, w, !0, !1);
                                    B = new hd(u + "*", w, !1, !1);
                                    var M = new hd(u + " const*", w, !1, !0);
                                    Kc[a] = {
                                        pointerType: B,
                                        Kb: M
                                    };
                                    jd(k, t);
                                    return [
                                        r,
                                        B,
                                        M
                                    ];
                                });
                            },
                            _embind_register_class_class_function: function(a, b, c, d, e, f, g) {
                                var n = sd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    function l() {
                                        od(`Cannot call ${u} due to unbound types`, n);
                                    }
                                    p = p[0];
                                    var u = `${p.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    var v = p.i.constructor;
                                    void 0 === v[b] ? (l.ea = c - 1, v[b] = l) : ($c(v, b, u), v[b].B[c - 1] = l);
                                    Y([], n, function(x) {
                                        x = pd(u, [
                                            x[0],
                                            null
                                        ].concat(x.slice(1)), null, f, g);
                                        void 0 === v[b].B ? (x.ea = c - 1, v[b] = x) : v[b].B[c - 1] = x;
                                        if (p.i.oa) for (const k of p.i.oa)k.constructor.hasOwnProperty(b) || (k.constructor[b] = x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_class_property: function(a, b, c, d, e, f, g, n) {
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(p) {
                                    p = p[0];
                                    var l = `${p.name}.${b}`, u = {
                                        get () {
                                            od(`Cannot access ${l} due to unbound types`, [
                                                c
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    u.set = n ? ()=>{
                                        od(`Cannot access ${l} due to unbound types`, [
                                            c
                                        ]);
                                    } : ()=>{
                                        V(`${l} is a read-only property`);
                                    };
                                    Object.defineProperty(p.i.constructor, b, u);
                                    Y([], [
                                        c
                                    ], function(v) {
                                        v = v[0];
                                        var x = {
                                            get () {
                                                return v.fromWireType(f(d));
                                            },
                                            enumerable: !0
                                        };
                                        n && (n = Z(g, n), x.set = (k)=>{
                                            var t = [];
                                            n(d, v.toWireType(t, k));
                                            Rc(t);
                                        });
                                        Object.defineProperty(p.i.constructor, b, x);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_constructor: function(a, b, c, d, e, f) {
                                var g = sd(b, c);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(n) {
                                    n = n[0];
                                    var p = `constructor ${n.name}`;
                                    void 0 === n.i.$ && (n.i.$ = []);
                                    if (void 0 !== n.i.$[b - 1]) throw new qc(`Cannot register multiple constructors with identical number of parameters (${b - 1}) for class '${n.name}'! Overload resolution is currently only performed using the parameter count, not actual type info!`);
                                    n.i.$[b - 1] = ()=>{
                                        od(`Cannot construct ${n.name} due to unbound types`, g);
                                    };
                                    Y([], g, function(l) {
                                        l.splice(1, 0, null);
                                        n.i.$[b - 1] = pd(p, l, null, e, f);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_function: function(a, b, c, d, e, f, g, n) {
                                var p = sd(c, d);
                                b = W(b);
                                f = Z(e, f);
                                Y([], [
                                    a
                                ], function(l) {
                                    function u() {
                                        od(`Cannot call ${v} due to unbound types`, p);
                                    }
                                    l = l[0];
                                    var v = `${l.name}.${b}`;
                                    b.startsWith("@@") && (b = Symbol[b.substring(2)]);
                                    n && l.i.qb.push(b);
                                    var x = l.i.N, k = x[b];
                                    void 0 === k || void 0 === k.B && k.className !== l.name && k.ea === c - 2 ? (u.ea = c - 2, u.className = l.name, x[b] = u) : ($c(x, b, v), x[b].B[c - 2] = u);
                                    Y([], p, function(t) {
                                        t = pd(v, t, l, f, g);
                                        void 0 === x[b].B ? (t.ea = c - 2, x[b] = t) : x[b].B[c - 2] = t;
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_class_property: function(a, b, c, d, e, f, g, n, p, l) {
                                b = W(b);
                                e = Z(d, e);
                                Y([], [
                                    a
                                ], function(u) {
                                    u = u[0];
                                    var v = `${u.name}.${b}`, x = {
                                        get () {
                                            od(`Cannot access ${v} due to unbound types`, [
                                                c,
                                                g
                                            ]);
                                        },
                                        enumerable: !0,
                                        configurable: !0
                                    };
                                    x.set = p ? ()=>{
                                        od(`Cannot access ${v} due to unbound types`, [
                                            c,
                                            g
                                        ]);
                                    } : ()=>{
                                        V(v + " is a read-only property");
                                    };
                                    Object.defineProperty(u.i.N, b, x);
                                    Y([], p ? [
                                        c,
                                        g
                                    ] : [
                                        c
                                    ], function(k) {
                                        var t = k[0], r = {
                                            get () {
                                                var D = td(this, u, v + " getter");
                                                return t.fromWireType(e(f, D));
                                            },
                                            enumerable: !0
                                        };
                                        if (p) {
                                            p = Z(n, p);
                                            var B = k[1];
                                            r.set = function(D) {
                                                var w = td(this, u, v + " setter"), M = [];
                                                p(l, w, B.toWireType(M, D));
                                                Rc(M);
                                            };
                                        }
                                        Object.defineProperty(u.i.N, b, r);
                                        return [];
                                    });
                                    return [];
                                });
                            },
                            _embind_register_emval: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(c) {
                                        var d = rc(c);
                                        ud(c);
                                        return d;
                                    },
                                    toWireType: function(c, d) {
                                        return sc(d);
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: null
                                });
                            },
                            _embind_register_enum: function(a, b, c, d) {
                                function e() {}
                                c = Wc(c);
                                b = W(b);
                                e.values = {};
                                Vc(a, {
                                    name: b,
                                    constructor: e,
                                    fromWireType: function(f) {
                                        return this.constructor.values[f];
                                    },
                                    toWireType: function(f, g) {
                                        return g.value;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: vd(b, c, d),
                                    K: null
                                });
                                ad(b, e);
                            },
                            _embind_register_enum_value: function(a, b, c) {
                                var d = Fc(a, "enum");
                                b = W(b);
                                a = d.constructor;
                                d = Object.create(d.constructor.prototype, {
                                    value: {
                                        value: c
                                    },
                                    constructor: {
                                        value: oc(`${d.name}_${b}`, function() {})
                                    }
                                });
                                a.values[c] = d;
                                a[b] = d;
                            },
                            _embind_register_float: function(a, b, c) {
                                c = Wc(c);
                                b = W(b);
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        return d;
                                    },
                                    toWireType: function(d, e) {
                                        return e;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: wd(b, c),
                                    K: null
                                });
                            },
                            _embind_register_function: function(a, b, c, d, e, f) {
                                var g = sd(b, c);
                                a = W(a);
                                e = Z(d, e);
                                ad(a, function() {
                                    od(`Cannot call ${a} due to unbound types`, g);
                                }, b - 1);
                                Y([], g, function(n) {
                                    jd(a, pd(a, [
                                        n[0],
                                        null
                                    ].concat(n.slice(1)), null, e, f), b - 1);
                                    return [];
                                });
                            },
                            _embind_register_integer: function(a, b, c, d, e) {
                                b = W(b);
                                -1 === e && (e = 4294967295);
                                e = Wc(c);
                                var f = (n)=>n;
                                if (0 === d) {
                                    var g = 32 - 8 * c;
                                    f = (n)=>n << g >>> g;
                                }
                                c = b.includes("unsigned") ? function(n, p) {
                                    return p >>> 0;
                                } : function(n, p) {
                                    return p;
                                };
                                Vc(a, {
                                    name: b,
                                    fromWireType: f,
                                    toWireType: c,
                                    argPackAdvance: 8,
                                    readValueFromPointer: xd(b, e, 0 !== d),
                                    K: null
                                });
                            },
                            _embind_register_memory_view: function(a, b, c) {
                                function d(f) {
                                    f >>= 2;
                                    var g = N;
                                    return new e(g.buffer, g[f + 1], g[f]);
                                }
                                var e = [
                                    Int8Array,
                                    Uint8Array,
                                    Int16Array,
                                    Uint16Array,
                                    Int32Array,
                                    Uint32Array,
                                    Float32Array,
                                    Float64Array
                                ][b];
                                c = W(c);
                                Vc(a, {
                                    name: c,
                                    fromWireType: d,
                                    argPackAdvance: 8,
                                    readValueFromPointer: d
                                }, {
                                    $b: !0
                                });
                            },
                            _embind_register_std_string: function(a, b) {
                                b = W(b);
                                var c = "std::string" === b;
                                Vc(a, {
                                    name: b,
                                    fromWireType: function(d) {
                                        var e = N[d >> 2], f = d + 4;
                                        if (c) for(var g = f, n = 0; n <= e; ++n){
                                            var p = f + n;
                                            if (n == e || 0 == E[p]) {
                                                g = g ? nb(E, g, p - g) : "";
                                                if (void 0 === l) var l = g;
                                                else l += String.fromCharCode(0), l += g;
                                                g = p + 1;
                                            }
                                        }
                                        else {
                                            l = Array(e);
                                            for(n = 0; n < e; ++n)l[n] = String.fromCharCode(E[f + n]);
                                            l = l.join("");
                                        }
                                        Ec(d);
                                        return l;
                                    },
                                    toWireType: function(d, e) {
                                        e instanceof ArrayBuffer && (e = new Uint8Array(e));
                                        var f = "string" == typeof e;
                                        f || e instanceof Uint8Array || e instanceof Uint8ClampedArray || e instanceof Int8Array || V("Cannot pass non-string to std::string");
                                        var g = c && f ? pb(e) : e.length;
                                        var n = Wd(4 + g + 1), p = n + 4;
                                        N[n >> 2] = g;
                                        if (c && f) qb(e, E, p, g + 1);
                                        else {
                                            if (f) for(f = 0; f < g; ++f){
                                                var l = e.charCodeAt(f);
                                                255 < l && (Ec(p), V("String has UTF-16 code units that do not fit in 8 bits"));
                                                E[p + f] = l;
                                            }
                                            else for(f = 0; f < g; ++f)E[p + f] = e[f];
                                        }
                                        null !== d && d.push(Ec, n);
                                        return n;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(d) {
                                        Ec(d);
                                    }
                                });
                            },
                            _embind_register_std_wstring: function(a, b, c) {
                                c = W(c);
                                if (2 === b) {
                                    var d = zd;
                                    var e = Ad;
                                    var f = Bd;
                                    var g = ()=>Ea;
                                    var n = 1;
                                } else 4 === b && (d = Cd, e = Dd, f = Ed, g = ()=>N, n = 2);
                                Vc(a, {
                                    name: c,
                                    fromWireType: function(p) {
                                        for(var l = N[p >> 2], u = g(), v, x = p + 4, k = 0; k <= l; ++k){
                                            var t = p + 4 + k * b;
                                            if (k == l || 0 == u[t >> n]) x = d(x, t - x), void 0 === v ? v = x : (v += String.fromCharCode(0), v += x), x = t + b;
                                        }
                                        Ec(p);
                                        return v;
                                    },
                                    toWireType: function(p, l) {
                                        "string" != typeof l && V(`Cannot pass non-string to C++ string type ${c}`);
                                        var u = f(l), v = Wd(4 + u + b);
                                        N[v >> 2] = u >> n;
                                        e(l, v + 4, u + b);
                                        null !== p && p.push(Ec, v);
                                        return v;
                                    },
                                    argPackAdvance: 8,
                                    readValueFromPointer: Sc,
                                    K: function(p) {
                                        Ec(p);
                                    }
                                });
                            },
                            _embind_register_value_object: function(a, b, c, d, e, f) {
                                Qc[a] = {
                                    name: W(b),
                                    Pa: Z(c, d),
                                    W: Z(e, f),
                                    eb: []
                                };
                            },
                            _embind_register_value_object_field: function(a, b, c, d, e, f, g, n, p, l) {
                                Qc[a].eb.push({
                                    Sb: W(b),
                                    Yb: c,
                                    Wb: Z(d, e),
                                    Xb: f,
                                    rc: g,
                                    qc: Z(n, p),
                                    sc: l
                                });
                            },
                            _embind_register_void: function(a, b) {
                                b = W(b);
                                Vc(a, {
                                    fc: !0,
                                    name: b,
                                    argPackAdvance: 0,
                                    fromWireType: function() {},
                                    toWireType: function() {}
                                });
                            },
                            _emscripten_get_now_is_monotonic: ()=>!0,
                            _emval_as: function(a, b, c) {
                                a = rc(a);
                                b = Fc(b, "emval::as");
                                var d = [], e = sc(d);
                                N[c >> 2] = e;
                                return b.toWireType(d, a);
                            },
                            _emval_call_method: function(a, b, c, d, e) {
                                a = Hd[a];
                                b = rc(b);
                                c = Gd(c);
                                var f = [];
                                N[d >> 2] = sc(f);
                                return a(b, c, f, e);
                            },
                            _emval_call_void_method: function(a, b, c, d) {
                                a = Hd[a];
                                b = rc(b);
                                c = Gd(c);
                                a(b, c, null, d);
                            },
                            _emval_decref: ud,
                            _emval_get_method_caller: function(a, b) {
                                var c = Jd(a, b), d = c[0];
                                b = d.name + "_$" + c.slice(1).map(function(g) {
                                    return g.name;
                                }).join("_") + "$";
                                var e = Kd[b];
                                if (void 0 !== e) return e;
                                var f = Array(a - 1);
                                e = Id((g, n, p, l)=>{
                                    for(var u = 0, v = 0; v < a - 1; ++v)f[v] = c[v + 1].readValueFromPointer(l + u), u += c[v + 1].argPackAdvance;
                                    g = g[n].apply(g, f);
                                    for(v = 0; v < a - 1; ++v)c[v + 1].Nb && c[v + 1].Nb(f[v]);
                                    if (!d.fc) return d.toWireType(p, g);
                                });
                                return Kd[b] = e;
                            },
                            _emval_get_module_property: function(a) {
                                a = Gd(a);
                                return sc(m[a]);
                            },
                            _emval_get_property: function(a, b) {
                                a = rc(a);
                                b = rc(b);
                                return sc(a[b]);
                            },
                            _emval_incref: function(a) {
                                4 < a && (U.get(a).tb += 1);
                            },
                            _emval_new_cstring: function(a) {
                                return sc(Gd(a));
                            },
                            _emval_new_object: function() {
                                return sc({});
                            },
                            _emval_run_destructors: function(a) {
                                var b = rc(a);
                                Rc(b);
                                ud(a);
                            },
                            _emval_set_property: function(a, b, c) {
                                a = rc(a);
                                b = rc(b);
                                c = rc(c);
                                a[b] = c;
                            },
                            _emval_take_value: function(a, b) {
                                a = Fc(a, "_emval_take_value");
                                a = a.readValueFromPointer(b);
                                return sc(a);
                            },
                            abort: ()=>{
                                Aa("");
                            },
                            emscripten_asm_const_int: (a, b, c)=>{
                                Ld.length = 0;
                                var d;
                                for(c >>= 2; d = E[b++];)c += 105 != d & c, Ld.push(105 == d ? L[c] : Ia[c++ >> 1]), ++c;
                                return db[a].apply(null, Ld);
                            },
                            emscripten_date_now: function() {
                                return Date.now();
                            },
                            emscripten_get_now: ()=>performance.now(),
                            emscripten_memcpy_big: (a, b, c)=>E.copyWithin(a, b, b + c),
                            emscripten_resize_heap: (a)=>{
                                var b = E.length;
                                a >>>= 0;
                                if (2147483648 < a) return !1;
                                for(var c = 1; 4 >= c; c *= 2){
                                    var d = b * (1 + 0.2 / c);
                                    d = Math.min(d, a + 100663296);
                                    var e = Math;
                                    d = Math.max(a, d);
                                    a: {
                                        e = e.min.call(e, 2147483648, d + (65536 - d % 65536) % 65536) - Ba.buffer.byteLength + 65535 >>> 16;
                                        try {
                                            Ba.grow(e);
                                            Ja();
                                            var f = 1;
                                            break a;
                                        } catch (g) {}
                                        f = void 0;
                                    }
                                    if (f) return !0;
                                }
                                return !1;
                            },
                            environ_get: (a, b)=>{
                                var c = 0;
                                Od().forEach(function(d, e) {
                                    var f = b + c;
                                    e = N[a + 4 * e >> 2] = f;
                                    for(f = 0; f < d.length; ++f)C[e++ >> 0] = d.charCodeAt(f);
                                    C[e >> 0] = 0;
                                    c += d.length + 1;
                                });
                                return 0;
                            },
                            environ_sizes_get: (a, b)=>{
                                var c = Od();
                                N[a >> 2] = c.length;
                                var d = 0;
                                c.forEach(function(e) {
                                    d += e.length + 1;
                                });
                                N[b >> 2] = d;
                                return 0;
                            },
                            fd_close: function(a) {
                                try {
                                    var b = Tb(a);
                                    if (null === b.X) throw new O(8);
                                    b.Ma && (b.Ma = null);
                                    try {
                                        b.m.close && b.m.close(b);
                                    } catch (c) {
                                        throw c;
                                    } finally{
                                        Gb[b.X] = null;
                                    }
                                    b.X = null;
                                    return 0;
                                } catch (c) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== c.name) throw c;
                                    return c.aa;
                                }
                            },
                            fd_read: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = C;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (1 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.read) throw new O(28);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.read(l, k, u, v, x);
                                            t || (l.position += r);
                                            var B = r;
                                            if (0 > B) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += B;
                                            if (B < p) break;
                                            "undefined" !== typeof f && (f += B);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            fd_seek: function(a, b, c, d, e) {
                                b = c + 2097152 >>> 0 < 4194305 - !!b ? (b >>> 0) + 4294967296 * c : NaN;
                                try {
                                    if (isNaN(b)) return 61;
                                    var f = Tb(a);
                                    fc(f, b, d);
                                    $a = [
                                        f.position >>> 0,
                                        (Za = f.position, 1.0 <= +Math.abs(Za) ? 0.0 < Za ? +Math.floor(Za / 4294967296.0) >>> 0 : ~~+Math.ceil((Za - +(~~Za >>> 0)) / 4294967296.0) >>> 0 : 0)
                                    ];
                                    L[e >> 2] = $a[0];
                                    L[e + 4 >> 2] = $a[1];
                                    f.Ma && 0 === b && 0 === d && (f.Ma = null);
                                    return 0;
                                } catch (g) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== g.name) throw g;
                                    return g.aa;
                                }
                            },
                            fd_write: function(a, b, c, d) {
                                try {
                                    a: {
                                        var e = Tb(a);
                                        a = b;
                                        for(var f, g = b = 0; g < c; g++){
                                            var n = N[a >> 2], p = N[a + 4 >> 2];
                                            a += 8;
                                            var l = e, u = n, v = p, x = f, k = C;
                                            if (0 > v || 0 > x) throw new O(28);
                                            if (null === l.X) throw new O(8);
                                            if (0 === (l.flags & 2097155)) throw new O(8);
                                            if (16384 === (l.node.mode & 61440)) throw new O(31);
                                            if (!l.m.write) throw new O(28);
                                            l.seekable && l.flags & 1024 && fc(l, 0, 2);
                                            var t = "undefined" != typeof x;
                                            if (!t) x = l.position;
                                            else if (!l.seekable) throw new O(70);
                                            var r = l.m.write(l, k, u, v, x, void 0);
                                            t || (l.position += r);
                                            var B = r;
                                            if (0 > B) {
                                                var D = -1;
                                                break a;
                                            }
                                            b += B;
                                            "undefined" !== typeof f && (f += B);
                                        }
                                        D = b;
                                    }
                                    N[d >> 2] = D;
                                    return 0;
                                } catch (w) {
                                    if ("undefined" == typeof kc || "ErrnoError" !== w.name) throw w;
                                    return w.aa;
                                }
                            },
                            strftime_l: (a, b, c, d)=>Sd(a, b, c, d)
                        };
                        (function() {
                            function a(c) {
                                z = c = c.exports;
                                Ba = z.memory;
                                Ja();
                                Ka = z.__indirect_function_table;
                                Ma.unshift(z.__wasm_call_ctors);
                                Pa--;
                                m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                                if (0 == Pa && (null !== Qa && (clearInterval(Qa), Qa = null), Ra)) {
                                    var d = Ra;
                                    Ra = null;
                                    d();
                                }
                                return c;
                            }
                            var b = {
                                env: Xd,
                                wasi_snapshot_preview1: Xd
                            };
                            Pa++;
                            m.monitorRunDependencies && m.monitorRunDependencies(Pa);
                            if (m.instantiateWasm) try {
                                return m.instantiateWasm(b, a);
                            } catch (c) {
                                xa("Module.instantiateWasm callback failed with error: " + c), ea(c);
                            }
                            Ya(b, function(c) {
                                a(c.instance);
                            }).catch(ea);
                            return {};
                        })();
                        var Ec = (a)=>(Ec = z.free)(a), Wd = (a)=>(Wd = z.malloc)(a), ab = m._ma_device__on_notification_unlocked = (a)=>(ab = m._ma_device__on_notification_unlocked = z.ma_device__on_notification_unlocked)(a);
                        m._ma_malloc_emscripten = (a, b)=>(m._ma_malloc_emscripten = z.ma_malloc_emscripten)(a, b);
                        m._ma_free_emscripten = (a, b)=>(m._ma_free_emscripten = z.ma_free_emscripten)(a, b);
                        var bb = m._ma_device_process_pcm_frames_capture__webaudio = (a, b, c)=>(bb = m._ma_device_process_pcm_frames_capture__webaudio = z.ma_device_process_pcm_frames_capture__webaudio)(a, b, c), cb = m._ma_device_process_pcm_frames_playback__webaudio = (a, b, c)=>(cb = m._ma_device_process_pcm_frames_playback__webaudio = z.ma_device_process_pcm_frames_playback__webaudio)(a, b, c), Vd = ()=>(Vd = z.__errno_location)(), Dc = (a)=>(Dc = z.__getTypeName)(a);
                        m.__embind_initialize_bindings = ()=>(m.__embind_initialize_bindings = z._embind_initialize_bindings)();
                        m.dynCall_iiji = (a, b, c, d, e)=>(m.dynCall_iiji = z.dynCall_iiji)(a, b, c, d, e);
                        m.dynCall_jiji = (a, b, c, d, e)=>(m.dynCall_jiji = z.dynCall_jiji)(a, b, c, d, e);
                        m.dynCall_iiiji = (a, b, c, d, e, f)=>(m.dynCall_iiiji = z.dynCall_iiiji)(a, b, c, d, e, f);
                        m.dynCall_iij = (a, b, c, d)=>(m.dynCall_iij = z.dynCall_iij)(a, b, c, d);
                        m.dynCall_jii = (a, b, c)=>(m.dynCall_jii = z.dynCall_jii)(a, b, c);
                        m.dynCall_viijii = (a, b, c, d, e, f, g)=>(m.dynCall_viijii = z.dynCall_viijii)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiij = (a, b, c, d, e, f, g)=>(m.dynCall_iiiiij = z.dynCall_iiiiij)(a, b, c, d, e, f, g);
                        m.dynCall_iiiiijj = (a, b, c, d, e, f, g, n, p)=>(m.dynCall_iiiiijj = z.dynCall_iiiiijj)(a, b, c, d, e, f, g, n, p);
                        m.dynCall_iiiiiijj = (a, b, c, d, e, f, g, n, p, l)=>(m.dynCall_iiiiiijj = z.dynCall_iiiiiijj)(a, b, c, d, e, f, g, n, p, l);
                        var Yd;
                        Ra = function Zd() {
                            Yd || $d();
                            Yd || (Ra = Zd);
                        };
                        function $d() {
                            function a() {
                                if (!Yd && (Yd = !0, m.calledRun = !0, !Ca)) {
                                    m.noFSInit || hc || (hc = !0, gc(), m.stdin = m.stdin, m.stdout = m.stdout, m.stderr = m.stderr, m.stdin ? jc("stdin", m.stdin) : cc("/dev/tty", "/dev/stdin"), m.stdout ? jc("stdout", null, m.stdout) : cc("/dev/tty", "/dev/stdout"), m.stderr ? jc("stderr", null, m.stderr) : cc("/dev/tty1", "/dev/stderr"), ec("/dev/stdin", 0), ec("/dev/stdout", 1), ec("/dev/stderr", 1));
                                    Jb = !1;
                                    eb(Ma);
                                    aa(m);
                                    if (m.onRuntimeInitialized) m.onRuntimeInitialized();
                                    if (m.postRun) for("function" == typeof m.postRun && (m.postRun = [
                                        m.postRun
                                    ]); m.postRun.length;){
                                        var b = m.postRun.shift();
                                        Na.unshift(b);
                                    }
                                    eb(Na);
                                }
                            }
                            if (!(0 < Pa)) {
                                if (m.preRun) for("function" == typeof m.preRun && (m.preRun = [
                                    m.preRun
                                ]); m.preRun.length;)Oa();
                                eb(La);
                                0 < Pa || (m.setStatus ? (m.setStatus("Running..."), setTimeout(function() {
                                    setTimeout(function() {
                                        m.setStatus("");
                                    }, 1);
                                    a();
                                }, 1)) : a());
                            }
                        }
                        if (m.preInit) for("function" == typeof m.preInit && (m.preInit = [
                            m.preInit
                        ]); 0 < m.preInit.length;)m.preInit.pop()();
                        $d();
                        return moduleArg.ready;
                    };
                })();
                /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = Rive;
            /***/ },
            /* 2 */ /***/ (module1)=>{
                module1.exports = /*#__PURE__*/ JSON.parse('{"name":"@rive-app/canvas","version":"2.26.4","description":"Rive\'s canvas based web api.","main":"rive.js","homepage":"https://rive.app","repository":{"type":"git","url":"https://github.com/rive-app/rive-wasm/tree/master/js"},"keywords":["rive","animation"],"author":"Rive","contributors":["Luigi Rosso <luigi@rive.app> (https://rive.app)","Maxwell Talbot <max@rive.app> (https://rive.app)","Arthur Vivian <arthur@rive.app> (https://rive.app)","Umberto Sonnino <umberto@rive.app> (https://rive.app)","Matthew Sullivan <matt.j.sullivan@gmail.com> (mailto:matt.j.sullivan@gmail.com)"],"license":"MIT","files":["rive.js","rive.js.map","rive.wasm","rive_fallback.wasm","rive.d.ts","rive_advanced.mjs.d.ts"],"typings":"rive.d.ts","dependencies":{},"browser":{"fs":false,"path":false}}');
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* reexport safe */ _Animation__WEBPACK_IMPORTED_MODULE_0__.Animation
                });
                /* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4);
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ Animation: ()=>/* binding */ Animation
                });
                /**
 * Represents an animation that can be played on an Artboard.
 * Wraps animations and instances from the runtime and keeps track of playback state.
 *
 * The `Animation` class manages the state and behavior of a single animation instance,
 * including its current time, loop count, and ability to scrub to a specific time.
 *
 * The class provides methods to advance the animation, apply its interpolated keyframe
 * values to the Artboard, and clean up the underlying animation instance when the
 * animation is no longer needed.
 */ var Animation = /** @class */ function() {
                    /**
     * Constructs a new animation
     * @constructor
     * @param {any} animation: runtime animation object
     * @param {any} instance: runtime animation instance object
     */ function Animation(animation, artboard, runtime, playing) {
                        this.animation = animation;
                        this.artboard = artboard;
                        this.playing = playing;
                        this.loopCount = 0;
                        /**
         * The time to which the animation should move to on the next render.
         * If not null, the animation will scrub to this time instead of advancing by the given time.
         */ this.scrubTo = null;
                        this.instance = new runtime.LinearAnimationInstance(animation, artboard);
                    }
                    Object.defineProperty(Animation.prototype, "name", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.animation.name;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "time", {
                        /**
         * Returns the animation's name
         */ get: function() {
                            return this.instance.time;
                        },
                        /**
         * Sets the animation's current time
         */ set: function(value) {
                            this.instance.time = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "loopValue", {
                        /**
         * Returns the animation's loop type
         */ get: function() {
                            return this.animation.loopValue;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Animation.prototype, "needsScrub", {
                        /**
         * Indicates whether the animation needs to be scrubbed.
         * @returns `true` if the animation needs to be scrubbed, `false` otherwise.
         */ get: function() {
                            return this.scrubTo !== null;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
     * Advances the animation by the give time. If the animation needs scrubbing,
     * time is ignored and the stored scrub value is used.
     * @param time the time to advance the animation by if no scrubbing required
     */ Animation.prototype.advance = function(time) {
                        if (this.scrubTo === null) this.instance.advance(time);
                        else {
                            this.instance.time = 0;
                            this.instance.advance(this.scrubTo);
                            this.scrubTo = null;
                        }
                    };
                    /**
     * Apply interpolated keyframe values to the artboard. This should be called after calling
     * .advance() on an animation instance so that new values are applied to properties.
     *
     * Note: This does not advance the artboard, which updates all objects on the artboard
     * @param mix - Mix value for the animation from 0 to 1
     */ Animation.prototype.apply = function(mix) {
                        this.instance.apply(mix);
                    };
                    /**
     * Deletes the backing Wasm animation instance; once this is called, this
     * animation is no more.
     */ Animation.prototype.cleanup = function() {
                        this.instance.delete();
                    };
                    return Animation;
                }();
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.BLANK_URL,
                    /* harmony export */ registerTouchInteractions: ()=>/* reexport safe */ _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__.registerTouchInteractions,
                    /* harmony export */ sanitizeUrl: ()=>/* reexport safe */ _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__.sanitizeUrl
                });
                /* harmony import */ var _registerTouchInteractions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
                /* harmony import */ var _sanitizeUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ registerTouchInteractions: ()=>/* binding */ registerTouchInteractions
                });
                var _this = undefined;
                /**
 * Returns the clientX and clientY properties from touch or mouse events. Also
 * calls preventDefault() on the event if it is a touchstart or touchmove to prevent
 * scrolling the page on mobile devices
 * @param event - Either a TouchEvent or a MouseEvent
 * @returns - Coordinates of the clientX and clientY properties from the touch/mouse event
 */ var getClientCoordinates = function(event, isTouchScrollEnabled) {
                    var _a, _b;
                    if ([
                        "touchstart",
                        "touchmove"
                    ].indexOf(event.type) > -1 && ((_a = event.touches) === null || _a === void 0 ? void 0 : _a.length)) {
                        // This flag, if false, prevents touch events on the canvas default behavior
                        // which may prevent scrolling if a drag motion on the canvas is performed
                        if (!isTouchScrollEnabled) event.preventDefault();
                        return {
                            clientX: event.touches[0].clientX,
                            clientY: event.touches[0].clientY
                        };
                    } else if (event.type === "touchend" && ((_b = event.changedTouches) === null || _b === void 0 ? void 0 : _b.length)) return {
                        clientX: event.changedTouches[0].clientX,
                        clientY: event.changedTouches[0].clientY
                    };
                    else return {
                        clientX: event.clientX,
                        clientY: event.clientY
                    };
                };
                /**
 * Registers mouse move/up/down callback handlers on the canvas to send meaningful coordinates to
 * the state machine pointer move/up/down functions based on cursor interaction
 */ var registerTouchInteractions = function(_a) {
                    var canvas = _a.canvas, artboard = _a.artboard, _b = _a.stateMachines, stateMachines = _b === void 0 ? [] : _b, renderer = _a.renderer, rive = _a.rive, fit = _a.fit, alignment = _a.alignment, _c = _a.isTouchScrollEnabled, isTouchScrollEnabled = _c === void 0 ? false : _c, _d = _a.layoutScaleFactor, layoutScaleFactor = _d === void 0 ? 1.0 : _d;
                    if (!canvas || !stateMachines.length || !renderer || !rive || !artboard || typeof window === "undefined") return null;
                    /**
     * After a touchend event, some browsers may fire synthetic mouse events
     * (mouseover, mousedown, mousemove, mouseup) if the touch interaction did not cause
     * any default action (such as scrolling).
     *
     * This is done to simulate the behavior of a mouse for applications that do not support
     * touch events.
     *
     * We're keeping track of the previous event to not send the synthetic mouse events if the
     * touch event was a click (touchstart -> touchend).
     *
     * This is only needed when `isTouchScrollEnabled` is false
     * When true, `preventDefault()` is called which prevents this behaviour.
     **/ var _prevEventType = null;
                    var _syntheticEventsActive = false;
                    var processEventCallback = function(event) {
                        // Exit early out of all synthetic mouse events
                        // https://stackoverflow.com/questions/9656990/how-to-prevent-simulated-mouse-events-in-mobile-browsers
                        // https://stackoverflow.com/questions/25572070/javascript-touchend-versus-click-dilemma
                        if (_syntheticEventsActive && event instanceof MouseEvent) {
                            // Synthetic event finished
                            if (event.type == "mouseup") _syntheticEventsActive = false;
                            return;
                        }
                        // Test if it's a "touch click". This could cause the browser to send
                        // synthetic mouse events.
                        _syntheticEventsActive = isTouchScrollEnabled && event.type === "touchend" && _prevEventType === "touchstart";
                        _prevEventType = event.type;
                        var boundingRect = event.currentTarget.getBoundingClientRect();
                        var _a = getClientCoordinates(event, isTouchScrollEnabled), clientX = _a.clientX, clientY = _a.clientY;
                        if (!clientX && !clientY) return;
                        var canvasX = clientX - boundingRect.left;
                        var canvasY = clientY - boundingRect.top;
                        var forwardMatrix = rive.computeAlignment(fit, alignment, {
                            minX: 0,
                            minY: 0,
                            maxX: boundingRect.width,
                            maxY: boundingRect.height
                        }, artboard.bounds, layoutScaleFactor);
                        var invertedMatrix = new rive.Mat2D();
                        forwardMatrix.invert(invertedMatrix);
                        var canvasCoordinatesVector = new rive.Vec2D(canvasX, canvasY);
                        var transformedVector = rive.mapXY(invertedMatrix, canvasCoordinatesVector);
                        var transformedX = transformedVector.x();
                        var transformedY = transformedVector.y();
                        transformedVector.delete();
                        invertedMatrix.delete();
                        canvasCoordinatesVector.delete();
                        forwardMatrix.delete();
                        switch(event.type){
                            /**
             * There's a 2px buffer for a hitRadius when translating the pointer coordinates
             * down to the state machine. In cases where the hitbox is about that much away
             * from the Artboard border, we don't have exact precision on determining pointer
             * exit. We're therefore adding to the translated coordinates on mouseout of a canvas
             * to ensure that we report the mouse has truly exited the hitarea.
             * https://github.com/rive-app/rive-cpp/blob/master/src/animation/state_machine_instance.cpp#L336
             *
             * We add/subtract 10000 to account for when the graphic goes beyond the canvas bound
             * due to for example, a fit: 'cover'. Not perfect, but helps reliably (for now) ensure
             * we report going out of bounds when the mouse is out of the canvas
             */ case "mouseout":
                                for(var _i = 0, stateMachines_1 = stateMachines; _i < stateMachines_1.length; _i++){
                                    var stateMachine = stateMachines_1[_i];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer moving/hovering on the canvas
                            case "touchmove":
                            case "mouseover":
                            case "mousemove":
                                for(var _b = 0, stateMachines_2 = stateMachines; _b < stateMachines_2.length; _b++){
                                    var stateMachine = stateMachines_2[_b];
                                    stateMachine.pointerMove(transformedX, transformedY);
                                }
                                break;
                            // Pointer click initiated but not released yet on the canvas
                            case "touchstart":
                            case "mousedown":
                                for(var _c = 0, stateMachines_3 = stateMachines; _c < stateMachines_3.length; _c++){
                                    var stateMachine = stateMachines_3[_c];
                                    stateMachine.pointerDown(transformedX, transformedY);
                                }
                                break;
                            // Pointer click released on the canvas
                            case "touchend":
                            case "mouseup":
                                for(var _d = 0, stateMachines_4 = stateMachines; _d < stateMachines_4.length; _d++){
                                    var stateMachine = stateMachines_4[_d];
                                    stateMachine.pointerUp(transformedX, transformedY);
                                }
                                break;
                            default:
                        }
                    };
                    var callback = processEventCallback.bind(_this);
                    canvas.addEventListener("mouseover", callback);
                    canvas.addEventListener("mouseout", callback);
                    canvas.addEventListener("mousemove", callback);
                    canvas.addEventListener("mousedown", callback);
                    canvas.addEventListener("mouseup", callback);
                    canvas.addEventListener("touchmove", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchstart", callback, {
                        passive: isTouchScrollEnabled
                    });
                    canvas.addEventListener("touchend", callback);
                    return function() {
                        canvas.removeEventListener("mouseover", callback);
                        canvas.removeEventListener("mouseout", callback);
                        canvas.removeEventListener("mousemove", callback);
                        canvas.removeEventListener("mousedown", callback);
                        canvas.removeEventListener("mouseup", callback);
                        canvas.removeEventListener("touchmove", callback);
                        canvas.removeEventListener("touchstart", callback);
                        canvas.removeEventListener("touchend", callback);
                    };
                };
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, __webpack_exports__, __webpack_require__)=>{
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ BLANK_URL: ()=>/* binding */ BLANK_URL,
                    /* harmony export */ sanitizeUrl: ()=>/* binding */ sanitizeUrl
                });
                // Reference: https://github.com/braintree/sanitize-url/tree/main
                var invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
                var htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
                var htmlCtrlEntityRegex = /&(newline|tab);/gi;
                var ctrlCharactersRegex = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
                var urlSchemeRegex = /^.+(:|&colon;)/gim;
                var relativeFirstCharacters = [
                    ".",
                    "/"
                ];
                var BLANK_URL = "about:blank";
                function isRelativeUrlWithoutProtocol(url) {
                    return relativeFirstCharacters.indexOf(url[0]) > -1;
                }
                // adapted from https://stackoverflow.com/a/29824550/2601552
                function decodeHtmlCharacters(str) {
                    var removedNullByte = str.replace(ctrlCharactersRegex, "");
                    return removedNullByte.replace(htmlEntitiesRegex, function(match, dec) {
                        return String.fromCharCode(dec);
                    });
                }
                function sanitizeUrl(url) {
                    if (!url) return BLANK_URL;
                    var sanitizedUrl = decodeHtmlCharacters(url).replace(htmlCtrlEntityRegex, "").replace(ctrlCharactersRegex, "").trim();
                    if (!sanitizedUrl) return BLANK_URL;
                    if (isRelativeUrlWithoutProtocol(sanitizedUrl)) return sanitizedUrl;
                    var urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
                    if (!urlSchemeParseResults) return sanitizedUrl;
                    var urlScheme = urlSchemeParseResults[0];
                    if (invalidProtocolRegex.test(urlScheme)) return BLANK_URL;
                    return sanitizedUrl;
                }
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/define property getters */ /******/ (()=>{
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = (exports, definition)=>{
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ })();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ (()=>{
            /******/ __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
        /******/ })();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ (()=>{
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = (exports)=>{
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ })();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry needs to be wrapped in an IIFE because it needs to be isolated against other modules in the chunk.
        (()=>{
            __webpack_require__.r(__webpack_exports__);
            /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                /* harmony export */ Alignment: ()=>/* binding */ Alignment,
                /* harmony export */ EventType: ()=>/* binding */ EventType,
                /* harmony export */ Fit: ()=>/* binding */ Fit,
                /* harmony export */ Layout: ()=>/* binding */ Layout,
                /* harmony export */ LoopType: ()=>/* binding */ LoopType,
                /* harmony export */ Rive: ()=>/* binding */ Rive,
                /* harmony export */ RiveEventType: ()=>/* binding */ RiveEventType,
                /* harmony export */ RiveFile: ()=>/* binding */ RiveFile,
                /* harmony export */ RuntimeLoader: ()=>/* binding */ RuntimeLoader,
                /* harmony export */ StateMachineInput: ()=>/* binding */ StateMachineInput,
                /* harmony export */ StateMachineInputType: ()=>/* binding */ StateMachineInputType,
                /* harmony export */ Testing: ()=>/* binding */ Testing,
                /* harmony export */ decodeAudio: ()=>/* binding */ decodeAudio,
                /* harmony export */ decodeFont: ()=>/* binding */ decodeFont,
                /* harmony export */ decodeImage: ()=>/* binding */ decodeImage
            });
            /* harmony import */ var _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
            /* harmony import */ var package_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
            /* harmony import */ var _animation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __awaiter = function(thisArg, _arguments, P, generator) {
                function adopt(value) {
                    return value instanceof P ? value : new P(function(resolve) {
                        resolve(value);
                    });
                }
                return new (P || (P = Promise))(function(resolve, reject) {
                    function fulfilled(value) {
                        try {
                            step(generator.next(value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function rejected(value) {
                        try {
                            step(generator["throw"](value));
                        } catch (e) {
                            reject(e);
                        }
                    }
                    function step(result) {
                        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
                    }
                    step((generator = generator.apply(thisArg, _arguments || [])).next());
                });
            };
            var __generator = function(thisArg, body) {
                var _ = {
                    label: 0,
                    sent: function() {
                        if (t[0] & 1) throw t[1];
                        return t[1];
                    },
                    trys: [],
                    ops: []
                }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
                return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
                    return this;
                }), g;
                function verb(n) {
                    return function(v) {
                        return step([
                            n,
                            v
                        ]);
                    };
                }
                function step(op) {
                    if (f) throw new TypeError("Generator is already executing.");
                    while(g && (g = 0, op[0] && (_ = 0)), _)try {
                        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                        if (y = 0, t) op = [
                            op[0] & 2,
                            t.value
                        ];
                        switch(op[0]){
                            case 0:
                            case 1:
                                t = op;
                                break;
                            case 4:
                                _.label++;
                                return {
                                    value: op[1],
                                    done: false
                                };
                            case 5:
                                _.label++;
                                y = op[1];
                                op = [
                                    0
                                ];
                                continue;
                            case 7:
                                op = _.ops.pop();
                                _.trys.pop();
                                continue;
                            default:
                                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                                    _ = 0;
                                    continue;
                                }
                                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                                    _.label = op[1];
                                    break;
                                }
                                if (op[0] === 6 && _.label < t[1]) {
                                    _.label = t[1];
                                    t = op;
                                    break;
                                }
                                if (t && _.label < t[2]) {
                                    _.label = t[2];
                                    _.ops.push(op);
                                    break;
                                }
                                if (t[2]) _.ops.pop();
                                _.trys.pop();
                                continue;
                        }
                        op = body.call(thisArg, _);
                    } catch (e) {
                        op = [
                            6,
                            e
                        ];
                        y = 0;
                    } finally{
                        f = t = 0;
                    }
                    if (op[0] & 5) throw op[1];
                    return {
                        value: op[0] ? op[1] : void 0,
                        done: true
                    };
                }
            };
            var RiveError = /** @class */ function(_super) {
                __extends(RiveError, _super);
                function RiveError() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isHandledError = true;
                    return _this;
                }
                return RiveError;
            }(Error);
            // #regions helpers
            var resolveErrorMessage = function(error) {
                return error && error.isHandledError ? error.message : "Problem loading file; may be corrupt!";
            };
            // #region layout
            // Fit options for the canvas
            var Fit;
            (function(Fit) {
                Fit["Cover"] = "cover";
                Fit["Contain"] = "contain";
                Fit["Fill"] = "fill";
                Fit["FitWidth"] = "fitWidth";
                Fit["FitHeight"] = "fitHeight";
                Fit["None"] = "none";
                Fit["ScaleDown"] = "scaleDown";
                Fit["Layout"] = "layout";
            })(Fit || (Fit = {}));
            // Alignment options for the canvas
            var Alignment;
            (function(Alignment) {
                Alignment["Center"] = "center";
                Alignment["TopLeft"] = "topLeft";
                Alignment["TopCenter"] = "topCenter";
                Alignment["TopRight"] = "topRight";
                Alignment["CenterLeft"] = "centerLeft";
                Alignment["CenterRight"] = "centerRight";
                Alignment["BottomLeft"] = "bottomLeft";
                Alignment["BottomCenter"] = "bottomCenter";
                Alignment["BottomRight"] = "bottomRight";
            })(Alignment || (Alignment = {}));
            // Alignment options for Rive animations in a HTML canvas
            var Layout = /** @class */ function() {
                function Layout(params) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    this.fit = (_a = params === null || params === void 0 ? void 0 : params.fit) !== null && _a !== void 0 ? _a : Fit.Contain;
                    this.alignment = (_b = params === null || params === void 0 ? void 0 : params.alignment) !== null && _b !== void 0 ? _b : Alignment.Center;
                    this.layoutScaleFactor = (_c = params === null || params === void 0 ? void 0 : params.layoutScaleFactor) !== null && _c !== void 0 ? _c : 1;
                    this.minX = (_d = params === null || params === void 0 ? void 0 : params.minX) !== null && _d !== void 0 ? _d : 0;
                    this.minY = (_e = params === null || params === void 0 ? void 0 : params.minY) !== null && _e !== void 0 ? _e : 0;
                    this.maxX = (_f = params === null || params === void 0 ? void 0 : params.maxX) !== null && _f !== void 0 ? _f : 0;
                    this.maxY = (_g = params === null || params === void 0 ? void 0 : params.maxY) !== null && _g !== void 0 ? _g : 0;
                }
                // Alternative constructor to build a Layout from an interface/object
                Layout.new = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    console.warn("This function is deprecated: please use `new Layout({})` instead");
                    return new Layout({
                        fit: fit,
                        alignment: alignment,
                        minX: minX,
                        minY: minY,
                        maxX: maxX,
                        maxY: maxY
                    });
                };
                /**
     * Makes a copy of the layout, replacing any specified parameters
     */ Layout.prototype.copyWith = function(_a) {
                    var fit = _a.fit, alignment = _a.alignment, layoutScaleFactor = _a.layoutScaleFactor, minX = _a.minX, minY = _a.minY, maxX = _a.maxX, maxY = _a.maxY;
                    return new Layout({
                        fit: fit !== null && fit !== void 0 ? fit : this.fit,
                        alignment: alignment !== null && alignment !== void 0 ? alignment : this.alignment,
                        layoutScaleFactor: layoutScaleFactor !== null && layoutScaleFactor !== void 0 ? layoutScaleFactor : this.layoutScaleFactor,
                        minX: minX !== null && minX !== void 0 ? minX : this.minX,
                        minY: minY !== null && minY !== void 0 ? minY : this.minY,
                        maxX: maxX !== null && maxX !== void 0 ? maxX : this.maxX,
                        maxY: maxY !== null && maxY !== void 0 ? maxY : this.maxY
                    });
                };
                // Returns fit for the Wasm runtime format
                Layout.prototype.runtimeFit = function(rive) {
                    if (this.cachedRuntimeFit) return this.cachedRuntimeFit;
                    var fit;
                    if (this.fit === Fit.Cover) fit = rive.Fit.cover;
                    else if (this.fit === Fit.Contain) fit = rive.Fit.contain;
                    else if (this.fit === Fit.Fill) fit = rive.Fit.fill;
                    else if (this.fit === Fit.FitWidth) fit = rive.Fit.fitWidth;
                    else if (this.fit === Fit.FitHeight) fit = rive.Fit.fitHeight;
                    else if (this.fit === Fit.ScaleDown) fit = rive.Fit.scaleDown;
                    else if (this.fit === Fit.Layout) fit = rive.Fit.layout;
                    else fit = rive.Fit.none;
                    this.cachedRuntimeFit = fit;
                    return fit;
                };
                // Returns alignment for the Wasm runtime format
                Layout.prototype.runtimeAlignment = function(rive) {
                    if (this.cachedRuntimeAlignment) return this.cachedRuntimeAlignment;
                    var alignment;
                    if (this.alignment === Alignment.TopLeft) alignment = rive.Alignment.topLeft;
                    else if (this.alignment === Alignment.TopCenter) alignment = rive.Alignment.topCenter;
                    else if (this.alignment === Alignment.TopRight) alignment = rive.Alignment.topRight;
                    else if (this.alignment === Alignment.CenterLeft) alignment = rive.Alignment.centerLeft;
                    else if (this.alignment === Alignment.CenterRight) alignment = rive.Alignment.centerRight;
                    else if (this.alignment === Alignment.BottomLeft) alignment = rive.Alignment.bottomLeft;
                    else if (this.alignment === Alignment.BottomCenter) alignment = rive.Alignment.bottomCenter;
                    else if (this.alignment === Alignment.BottomRight) alignment = rive.Alignment.bottomRight;
                    else alignment = rive.Alignment.center;
                    this.cachedRuntimeAlignment = alignment;
                    return alignment;
                };
                return Layout;
            }();
            // Runtime singleton; use getInstance to provide a callback that returns the
            // Rive runtime
            var RuntimeLoader = /** @class */ function() {
                // Class is never instantiated
                function RuntimeLoader() {}
                // Loads the runtime
                RuntimeLoader.loadRuntime = function() {
                    _rive_advanced_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]({
                        // Loads Wasm bundle
                        locateFile: function() {
                            return RuntimeLoader.wasmURL;
                        }
                    }).then(function(rive) {
                        var _a;
                        RuntimeLoader.runtime = rive;
                        // Fire all the callbacks
                        while(RuntimeLoader.callBackQueue.length > 0)(_a = RuntimeLoader.callBackQueue.shift()) === null || _a === void 0 || _a(RuntimeLoader.runtime);
                    }).catch(function(error) {
                        // Capture specific error details
                        var errorDetails = {
                            message: (error === null || error === void 0 ? void 0 : error.message) || "Unknown error",
                            type: (error === null || error === void 0 ? void 0 : error.name) || "Error",
                            // Some browsers may provide additional WebAssembly-specific details
                            wasmError: error instanceof WebAssembly.CompileError || error instanceof WebAssembly.RuntimeError,
                            originalError: error
                        };
                        // Log detailed error for debugging
                        console.debug("Rive WASM load error details:", errorDetails);
                        // In case unpkg fails, or the wasm was not supported, we try to load the fallback module from jsdelivr.
                        // This `rive_fallback.wasm` is compiled to support older architecture.
                        // TODO: (Gordon): preemptively test browser support and load the correct wasm file. Then use jsdelvr only if unpkg fails.
                        var backupJsdelivrUrl = "https://cdn.jsdelivr.net/npm/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive_fallback.wasm");
                        if (RuntimeLoader.wasmURL.toLowerCase() !== backupJsdelivrUrl) {
                            console.warn("Failed to load WASM from ".concat(RuntimeLoader.wasmURL, " (").concat(errorDetails.message, "), trying jsdelivr as a backup"));
                            RuntimeLoader.setWasmUrl(backupJsdelivrUrl);
                            RuntimeLoader.loadRuntime();
                        } else {
                            var errorMessage = [
                                "Could not load Rive WASM file from ".concat(RuntimeLoader.wasmURL, " or ").concat(backupJsdelivrUrl, "."),
                                "Possible reasons:",
                                "- Network connection is down",
                                "- WebAssembly is not supported in this environment",
                                "- The WASM file is corrupted or incompatible",
                                "\nError details:",
                                "- Type: ".concat(errorDetails.type),
                                "- Message: ".concat(errorDetails.message),
                                "- WebAssembly-specific error: ".concat(errorDetails.wasmError),
                                "\nTo resolve, you may need to:",
                                "1. Check your network connection",
                                "2. Set a new WASM source via RuntimeLoader.setWasmUrl()",
                                "3. Call RuntimeLoader.loadRuntime() again"
                            ].join("\n");
                            console.error(errorMessage);
                        }
                    });
                };
                // Provides a runtime instance via a callback
                RuntimeLoader.getInstance = function(callback) {
                    // If it's not loading, start loading runtime
                    if (!RuntimeLoader.isLoading) {
                        RuntimeLoader.isLoading = true;
                        RuntimeLoader.loadRuntime();
                    }
                    if (!RuntimeLoader.runtime) RuntimeLoader.callBackQueue.push(callback);
                    else callback(RuntimeLoader.runtime);
                };
                // Provides a runtime instance via a promise
                RuntimeLoader.awaitInstance = function() {
                    return new Promise(function(resolve) {
                        return RuntimeLoader.getInstance(function(rive) {
                            return resolve(rive);
                        });
                    });
                };
                // Manually sets the wasm url
                RuntimeLoader.setWasmUrl = function(url) {
                    RuntimeLoader.wasmURL = url;
                };
                // Gets the current wasm url
                RuntimeLoader.getWasmUrl = function() {
                    return RuntimeLoader.wasmURL;
                };
                // Flag to indicate that loading has started/completed
                RuntimeLoader.isLoading = false;
                // List of callbacks for the runtime that come in while loading
                RuntimeLoader.callBackQueue = [];
                // Path to the Wasm file; default path works for testing only;
                // if embedded wasm is used then this is never used.
                RuntimeLoader.wasmURL = "https://unpkg.com/".concat(package_json__WEBPACK_IMPORTED_MODULE_1__.name, "@").concat(package_json__WEBPACK_IMPORTED_MODULE_1__.version, "/rive.wasm");
                return RuntimeLoader;
            }();
            // #endregion
            // #region state machines
            var StateMachineInputType;
            (function(StateMachineInputType) {
                StateMachineInputType[StateMachineInputType["Number"] = 56] = "Number";
                StateMachineInputType[StateMachineInputType["Trigger"] = 58] = "Trigger";
                StateMachineInputType[StateMachineInputType["Boolean"] = 59] = "Boolean";
            })(StateMachineInputType || (StateMachineInputType = {}));
            /**
 * An input for a state machine
 */ var StateMachineInput = /** @class */ function() {
                function StateMachineInput(type, runtimeInput) {
                    this.type = type;
                    this.runtimeInput = runtimeInput;
                }
                Object.defineProperty(StateMachineInput.prototype, "name", {
                    /**
         * Returns the name of the input
         */ get: function() {
                        return this.runtimeInput.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachineInput.prototype, "value", {
                    /**
         * Returns the current value of the input
         */ get: function() {
                        return this.runtimeInput.value;
                    },
                    /**
         * Sets the value of the input
         */ set: function(value) {
                        this.runtimeInput.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Fires a trigger; does nothing on Number or Boolean input types
     */ StateMachineInput.prototype.fire = function() {
                    if (this.type === StateMachineInputType.Trigger) this.runtimeInput.fire();
                };
                /**
     * Deletes the input
     */ StateMachineInput.prototype.delete = function() {
                    this.runtimeInput = null;
                };
                return StateMachineInput;
            }();
            var RiveEventType;
            (function(RiveEventType) {
                RiveEventType[RiveEventType["General"] = 128] = "General";
                RiveEventType[RiveEventType["OpenUrl"] = 131] = "OpenUrl";
            })(RiveEventType || (RiveEventType = {}));
            var StateMachine = /** @class */ function() {
                /**
     * @constructor
     * @param stateMachine runtime state machine object
     * @param instance runtime state machine instance object
     */ function StateMachine(stateMachine, runtime, playing, artboard) {
                    this.stateMachine = stateMachine;
                    this.playing = playing;
                    this.artboard = artboard;
                    /**
         * Caches the inputs from the runtime
         */ this.inputs = [];
                    this.instance = new runtime.StateMachineInstance(stateMachine, artboard);
                    this.initInputs(runtime);
                }
                Object.defineProperty(StateMachine.prototype, "name", {
                    get: function() {
                        return this.stateMachine.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(StateMachine.prototype, "statesChanged", {
                    /**
         * Returns a list of state names that have changed on this frame
         */ get: function() {
                        var names = [];
                        for(var i = 0; i < this.instance.stateChangedCount(); i++)names.push(this.instance.stateChangedNameByIndex(i));
                        return names;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Advances the state machine instance by a given time.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advance = function(time) {
                    this.instance.advance(time);
                };
                /**
     * Advances the state machine instance by a given time and apply changes to artboard.
     * @param time - the time to advance the animation by in seconds
     */ StateMachine.prototype.advanceAndApply = function(time) {
                    this.instance.advanceAndApply(time);
                };
                /**
     * Returns the number of events reported from the last advance call
     * @returns Number of events reported
     */ StateMachine.prototype.reportedEventCount = function() {
                    return this.instance.reportedEventCount();
                };
                /**
     * Returns a RiveEvent object emitted from the last advance call at the given index
     * of a list of potentially multiple events. If an event at the index is not found,
     * undefined is returned.
     * @param i index of the event reported in a list of potentially multiple events
     * @returns RiveEvent or extended RiveEvent object returned, or undefined
     */ StateMachine.prototype.reportedEventAt = function(i) {
                    return this.instance.reportedEventAt(i);
                };
                /**
     * Fetches references to the state machine's inputs and caches them
     * @param runtime an instance of the runtime; needed for the SMIInput types
     */ StateMachine.prototype.initInputs = function(runtime) {
                    // Fetch the inputs from the runtime if we don't have them
                    for(var i = 0; i < this.instance.inputCount(); i++){
                        var input = this.instance.input(i);
                        this.inputs.push(this.mapRuntimeInput(input, runtime));
                    }
                };
                /**
     * Maps a runtime input to it's appropriate type
     * @param input
     */ StateMachine.prototype.mapRuntimeInput = function(input, runtime) {
                    if (input.type === runtime.SMIInput.bool) return new StateMachineInput(StateMachineInputType.Boolean, input.asBool());
                    else if (input.type === runtime.SMIInput.number) return new StateMachineInput(StateMachineInputType.Number, input.asNumber());
                    else if (input.type === runtime.SMIInput.trigger) return new StateMachineInput(StateMachineInputType.Trigger, input.asTrigger());
                };
                /**
     * Deletes the backing Wasm state machine instance; once this is called, this
     * state machine is no more.
     */ StateMachine.prototype.cleanup = function() {
                    this.inputs.forEach(function(input) {
                        input.delete();
                    });
                    this.inputs.length = 0;
                    this.instance.delete();
                };
                return StateMachine;
            }();
            // #endregion
            // #region animator
            /**
 * Manages animation
 */ var Animator = /** @class */ function() {
                /**
     * Constructs a new animator
     * @constructor
     * @param runtime Rive runtime; needed to instance animations & state machines
     * @param artboard the artboard that holds all animations and state machines
     * @param animations optional list of animations
     * @param stateMachines optional list of state machines
     */ function Animator(runtime, artboard, eventManager, animations, stateMachines) {
                    if (animations === void 0) animations = [];
                    if (stateMachines === void 0) stateMachines = [];
                    this.runtime = runtime;
                    this.artboard = artboard;
                    this.eventManager = eventManager;
                    this.animations = animations;
                    this.stateMachines = stateMachines;
                }
                /**
     * Adds animations and state machines by their names. If names are shared
     * between animations & state machines, then the first one found will be
     * created. Best not to use the same names for these in your Rive file.
     * @param animatable the name(s) of animations and state machines to add
     * @returns a list of names of the playing animations and state machines
     */ Animator.prototype.add = function(animatables, playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    animatables = mapToStringArray(animatables);
                    // If animatables is empty, play or pause everything
                    if (animatables.length === 0) {
                        this.animations.forEach(function(a) {
                            return a.playing = playing;
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.playing = playing;
                        });
                    } else {
                        // Play/pause already instanced items, or create new instances
                        var instancedAnimationNames = this.animations.map(function(a) {
                            return a.name;
                        });
                        var instancedMachineNames = this.stateMachines.map(function(m) {
                            return m.name;
                        });
                        for(var i = 0; i < animatables.length; i++){
                            var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                            var mIndex = instancedMachineNames.indexOf(animatables[i]);
                            if (aIndex >= 0 || mIndex >= 0) {
                                if (aIndex >= 0) // Animation is instanced, play/pause it
                                this.animations[aIndex].playing = playing;
                                else // State machine is instanced, play/pause it
                                this.stateMachines[mIndex].playing = playing;
                            } else {
                                // Try to create a new animation instance
                                var anim = this.artboard.animationByName(animatables[i]);
                                if (anim) {
                                    var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                    // Display the first frame of the specified animation
                                    newAnimation.advance(0);
                                    newAnimation.apply(1.0);
                                    this.animations.push(newAnimation);
                                } else {
                                    // Try to create a new state machine instance
                                    var sm = this.artboard.stateMachineByName(animatables[i]);
                                    if (sm) {
                                        var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                        this.stateMachines.push(newStateMachine);
                                    }
                                }
                            }
                        }
                    }
                    // Fire play/paused events for animations
                    if (fireEvent) {
                        if (playing) this.eventManager.fire({
                            type: EventType.Play,
                            data: this.playing
                        });
                        else this.eventManager.fire({
                            type: EventType.Pause,
                            data: this.paused
                        });
                    }
                    return playing ? this.playing : this.paused;
                };
                /**
     * Adds linear animations by their names.
     * @param animatables the name(s) of animations to add
     * @param playing whether animations should play on instantiation
     */ Animator.prototype.initLinearAnimations = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedAnimationNames = this.animations.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedAnimationNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.animations[aIndex].playing = playing;
                        else {
                            // Try to create a new animation instance
                            var anim = this.artboard.animationByName(animatables[i]);
                            if (anim) {
                                var newAnimation = new _animation__WEBPACK_IMPORTED_MODULE_2__.Animation(anim, this.artboard, this.runtime, playing);
                                // Display the first frame of the specified animation
                                newAnimation.advance(0);
                                newAnimation.apply(1.0);
                                this.animations.push(newAnimation);
                            }
                        }
                    }
                };
                /**
     * Adds state machines by their names.
     * @param animatables the name(s) of state machines to add
     * @param playing whether state machines should play on instantiation
     */ Animator.prototype.initStateMachines = function(animatables, playing) {
                    // Play/pause already instanced items, or create new instances
                    // This validation is kept to maintain compatibility with current behavior.
                    // But given that it this is called during artboard initialization
                    // it should probably be safe to remove.
                    var instancedStateMachineNames = this.stateMachines.map(function(a) {
                        return a.name;
                    });
                    for(var i = 0; i < animatables.length; i++){
                        var aIndex = instancedStateMachineNames.indexOf(animatables[i]);
                        if (aIndex >= 0) this.stateMachines[aIndex].playing = playing;
                        else {
                            // Try to create a new state machine instance
                            var sm = this.artboard.stateMachineByName(animatables[i]);
                            if (sm) {
                                var newStateMachine = new StateMachine(sm, this.runtime, playing, this.artboard);
                                this.stateMachines.push(newStateMachine);
                            } else // In order to maintain compatibility with current behavior, if a state machine is not found
                            // we look for an animation with the same name
                            this.initLinearAnimations([
                                animatables[i]
                            ], playing);
                        }
                    }
                };
                /**
     * Play the named animations/state machines
     * @param animatables the names of the animations/machines to play; plays all if empty
     * @returns a list of the playing items
     */ Animator.prototype.play = function(animatables) {
                    return this.add(animatables, true);
                };
                /**
     * Pauses named animations and state machines, or everything if nothing is
     * specified
     * @param animatables names of the animations and state machines to pause
     * @returns a list of names of the animations and state machines paused
     */ Animator.prototype.pause = function(animatables) {
                    return this.add(animatables, false);
                };
                /**
     * Set time of named animations
     * @param animations names of the animations to scrub
     * @param value time scrub value, a floating point number to which the playhead is jumped
     * @returns a list of names of the animations that were scrubbed
     */ Animator.prototype.scrub = function(animatables, value) {
                    var forScrubbing = this.animations.filter(function(a) {
                        return animatables.includes(a.name);
                    });
                    forScrubbing.forEach(function(a) {
                        return a.scrubTo = value;
                    });
                    return forScrubbing.map(function(a) {
                        return a.name;
                    });
                };
                Object.defineProperty(Animator.prototype, "playing", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * playing
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "paused", {
                    /**
         * Returns a list of names of all animations and state machines currently
         * paused
         */ get: function() {
                        return this.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        }));
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Stops and removes all named animations and state machines
     * @param animatables animations and state machines to remove
     * @returns a list of names of removed items
     */ Animator.prototype.stop = function(animatables) {
                    var _this = this;
                    animatables = mapToStringArray(animatables);
                    // If nothing's specified, wipe them out, all of them
                    var removedNames = [];
                    // Stop everything
                    if (animatables.length === 0) {
                        removedNames = this.animations.map(function(a) {
                            return a.name;
                        }).concat(this.stateMachines.map(function(m) {
                            return m.name;
                        }));
                        // Clean up before emptying the arrays
                        this.animations.forEach(function(a) {
                            return a.cleanup();
                        });
                        this.stateMachines.forEach(function(m) {
                            return m.cleanup();
                        });
                        // Empty out the arrays
                        this.animations.splice(0, this.animations.length);
                        this.stateMachines.splice(0, this.stateMachines.length);
                    } else {
                        // Remove only the named animations/state machines
                        var animationsToRemove = this.animations.filter(function(a) {
                            return animatables.includes(a.name);
                        });
                        animationsToRemove.forEach(function(a) {
                            a.cleanup();
                            _this.animations.splice(_this.animations.indexOf(a), 1);
                        });
                        var machinesToRemove = this.stateMachines.filter(function(m) {
                            return animatables.includes(m.name);
                        });
                        machinesToRemove.forEach(function(m) {
                            m.cleanup();
                            _this.stateMachines.splice(_this.stateMachines.indexOf(m), 1);
                        });
                        removedNames = animationsToRemove.map(function(a) {
                            return a.name;
                        }).concat(machinesToRemove.map(function(m) {
                            return m.name;
                        }));
                    }
                    this.eventManager.fire({
                        type: EventType.Stop,
                        data: removedNames
                    });
                    // Return the list of animations removed
                    return removedNames;
                };
                Object.defineProperty(Animator.prototype, "isPlaying", {
                    /**
         * Returns true if at least one animation is active
         */ get: function() {
                        return this.animations.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false) || this.stateMachines.reduce(function(acc, curr) {
                            return acc || curr.playing;
                        }, false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isPaused", {
                    /**
         * Returns true if all animations are paused and there's at least one animation
         */ get: function() {
                        return !this.isPlaying && (this.animations.length > 0 || this.stateMachines.length > 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Animator.prototype, "isStopped", {
                    /**
         * Returns true if there are no playing or paused animations/state machines
         */ get: function() {
                        return this.animations.length === 0 && this.stateMachines.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * If there are no animations or state machines, add the first one found
     * @returns the name of the animation or state machine instanced
     */ Animator.prototype.atLeastOne = function(playing, fireEvent) {
                    if (fireEvent === void 0) fireEvent = true;
                    var instancedName;
                    if (this.animations.length === 0 && this.stateMachines.length === 0) {
                        if (this.artboard.animationCount() > 0) // Add the first animation
                        this.add([
                            instancedName = this.artboard.animationByIndex(0).name
                        ], playing, fireEvent);
                        else if (this.artboard.stateMachineCount() > 0) // Add the first state machine
                        this.add([
                            instancedName = this.artboard.stateMachineByIndex(0).name
                        ], playing, fireEvent);
                    }
                    return instancedName;
                };
                /**
     * Checks if any animations have looped and if so, fire the appropriate event
     */ Animator.prototype.handleLooping = function() {
                    for(var _i = 0, _a = this.animations.filter(function(a) {
                        return a.playing;
                    }); _i < _a.length; _i++){
                        var animation = _a[_i];
                        // Emit if the animation looped
                        if (animation.loopValue === 0 && animation.loopCount) {
                            animation.loopCount = 0;
                            // This is a one-shot; if it has ended, delete the instance
                            this.stop(animation.name);
                        } else if (animation.loopValue === 1 && animation.loopCount) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.Loop
                                }
                            });
                            animation.loopCount = 0;
                        } else if (animation.loopValue === 2 && animation.loopCount > 1) {
                            this.eventManager.fire({
                                type: EventType.Loop,
                                data: {
                                    animation: animation.name,
                                    type: LoopType.PingPong
                                }
                            });
                            animation.loopCount = 0;
                        }
                    }
                };
                /**
     * Checks if states have changed in state machines and fires a statechange
     * event
     */ Animator.prototype.handleStateChanges = function() {
                    var statesChanged = [];
                    for(var _i = 0, _a = this.stateMachines.filter(function(sm) {
                        return sm.playing;
                    }); _i < _a.length; _i++){
                        var stateMachine = _a[_i];
                        statesChanged.push.apply(statesChanged, stateMachine.statesChanged);
                    }
                    if (statesChanged.length > 0) this.eventManager.fire({
                        type: EventType.StateChange,
                        data: statesChanged
                    });
                };
                Animator.prototype.handleAdvancing = function(time) {
                    this.eventManager.fire({
                        type: EventType.Advance,
                        data: time
                    });
                };
                return Animator;
            }();
            // #endregion
            // #region events
            /**
 * Supported event types triggered in Rive
 */ var EventType;
            (function(EventType) {
                EventType["Load"] = "load";
                EventType["LoadError"] = "loaderror";
                EventType["Play"] = "play";
                EventType["Pause"] = "pause";
                EventType["Stop"] = "stop";
                EventType["Loop"] = "loop";
                EventType["Draw"] = "draw";
                EventType["Advance"] = "advance";
                EventType["StateChange"] = "statechange";
                EventType["RiveEvent"] = "riveevent";
                EventType["AudioStatusChange"] = "audiostatuschange";
            })(EventType || (EventType = {}));
            /**
 * Looping types: one-shot, loop, and ping-pong
 */ var LoopType;
            (function(LoopType) {
                LoopType["OneShot"] = "oneshot";
                LoopType["Loop"] = "loop";
                LoopType["PingPong"] = "pingpong";
            })(LoopType || (LoopType = {}));
            // Manages Rive events and listeners
            var EventManager = /** @class */ function() {
                function EventManager(listeners) {
                    if (listeners === void 0) listeners = [];
                    this.listeners = listeners;
                }
                // Gets listeners of specified type
                EventManager.prototype.getListeners = function(type) {
                    return this.listeners.filter(function(e) {
                        return e.type === type;
                    });
                };
                // Adds a listener
                EventManager.prototype.add = function(listener) {
                    if (!this.listeners.includes(listener)) this.listeners.push(listener);
                };
                /**
     * Removes a listener
     * @param listener the listener with the callback to be removed
     */ EventManager.prototype.remove = function(listener) {
                    // We can't simply look for the listener as it'll be a different instance to
                    // one originally subscribed. Find all the listeners of the right type and
                    // then check their callbacks which should match.
                    for(var i = 0; i < this.listeners.length; i++){
                        var currentListener = this.listeners[i];
                        if (currentListener.type === listener.type) {
                            if (currentListener.callback === listener.callback) {
                                this.listeners.splice(i, 1);
                                break;
                            }
                        }
                    }
                };
                /**
     * Clears all listeners of specified type, or every listener if no type is
     * specified
     * @param type the type of listeners to clear, or all listeners if not
     * specified
     */ EventManager.prototype.removeAll = function(type) {
                    var _this = this;
                    if (!type) this.listeners.splice(0, this.listeners.length);
                    else this.listeners.filter(function(l) {
                        return l.type === type;
                    }).forEach(function(l) {
                        return _this.remove(l);
                    });
                };
                // Fires an event
                EventManager.prototype.fire = function(event) {
                    var eventListeners = this.getListeners(event.type);
                    eventListeners.forEach(function(listener) {
                        return listener.callback(event);
                    });
                };
                return EventManager;
            }();
            // Manages a queue of tasks
            var TaskQueueManager = /** @class */ function() {
                function TaskQueueManager(eventManager) {
                    this.eventManager = eventManager;
                    this.queue = [];
                }
                // Adds a task top the queue
                TaskQueueManager.prototype.add = function(task) {
                    this.queue.push(task);
                };
                // Processes all tasks in the queue
                TaskQueueManager.prototype.process = function() {
                    while(this.queue.length > 0){
                        var task = this.queue.shift();
                        if (task === null || task === void 0 ? void 0 : task.action) task.action();
                        if (task === null || task === void 0 ? void 0 : task.event) this.eventManager.fire(task.event);
                    }
                };
                return TaskQueueManager;
            }();
            // #endregion
            // #region Audio
            var SystemAudioStatus;
            (function(SystemAudioStatus) {
                SystemAudioStatus[SystemAudioStatus["AVAILABLE"] = 0] = "AVAILABLE";
                SystemAudioStatus[SystemAudioStatus["UNAVAILABLE"] = 1] = "UNAVAILABLE";
            })(SystemAudioStatus || (SystemAudioStatus = {}));
            // Class to handle audio context availability and status changes
            var AudioManager = /** @class */ function(_super) {
                __extends(AudioManager, _super);
                function AudioManager() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this._started = false;
                    _this._enabled = false;
                    _this._status = SystemAudioStatus.UNAVAILABLE;
                    return _this;
                }
                AudioManager.prototype.delay = function(time) {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, time);
                                })
                            ];
                        });
                    });
                };
                AudioManager.prototype.timeout = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                new Promise(function(_, reject) {
                                    return setTimeout(reject, 50);
                                })
                            ];
                        });
                    });
                };
                // Alerts animations on status changes and removes the listeners to avoid alerting twice.
                AudioManager.prototype.reportToListeners = function() {
                    this.fire({
                        type: EventType.AudioStatusChange
                    });
                    this.removeAll();
                };
                /**
     * The audio context has been resolved.
     * Alert any listeners that we can now play audio.
     * Rive will now play audio at the configured volume.
     */ AudioManager.prototype.enableAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            if (!this._enabled) {
                                this._enabled = true;
                                this._status = SystemAudioStatus.AVAILABLE;
                                this.reportToListeners();
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                /**
     * Check if we are able to play audio.
     *
     * We currently check the audio context, when resume() returns before a timeout we know that the
     * audio context is running and we can enable audio.
     */ AudioManager.prototype.testAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE && this._audioContext !== null)) return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                    _b.label = 1;
                                case 1:
                                    _b.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            this._audioContext.resume(),
                                            this.timeout()
                                        ])
                                    ];
                                case 2:
                                    _b.sent();
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 3:
                                    _a = _b.sent();
                                    return [
                                        3 /*break*/ ,
                                        4
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Establish audio for use with rive.
     * We both test if we can use audio intermittently and listen for user interaction.
     * The aim is to enable audio playback as soon as the browser allows this.
     */ AudioManager.prototype._establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            switch(_a.label){
                                case 0:
                                    if (!!this._started) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    this._started = true;
                                    if (!(typeof window == "undefined")) return [
                                        3 /*break*/ ,
                                        1
                                    ];
                                    this.enableAudio();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 1:
                                    this._audioContext = new AudioContext();
                                    this.listenForUserAction();
                                    _a.label = 2;
                                case 2:
                                    if (!(this._status === SystemAudioStatus.UNAVAILABLE)) return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.testAudio()
                                    ];
                                case 3:
                                    _a.sent();
                                    return [
                                        4 /*yield*/ ,
                                        this.delay(1000)
                                    ];
                                case 4:
                                    _a.sent();
                                    return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                case 5:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                AudioManager.prototype.listenForUserAction = function() {
                    var _this = this;
                    // NOTE: AudioContexts are ready immediately if requested in a ui callback
                    // we *could* re request one in this listener.
                    var _clickListener = function() {
                        return __awaiter(_this, void 0, void 0, function() {
                            return __generator(this, function(_a) {
                                // note this has "better" results than calling `await this.testAudio()`
                                // as we force audio to be enabled in the current thread, rather than chancing
                                // the thread to be passed over for some other async context
                                this.enableAudio();
                                return [
                                    2 /*return*/ 
                                ];
                            });
                        });
                    };
                    // NOTE: we should test this on mobile/pads
                    document.addEventListener("pointerdown", _clickListener, {
                        once: true
                    });
                };
                /**
     * Establish the audio context for rive, this lets rive know that we can play audio.
     */ AudioManager.prototype.establishAudio = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        return __generator(this, function(_a) {
                            this._establishAudio();
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                Object.defineProperty(AudioManager.prototype, "systemVolume", {
                    get: function() {
                        if (this._status === SystemAudioStatus.UNAVAILABLE) {
                            // We do an immediate test to avoid depending on the delay of the running test
                            this.testAudio();
                            return 0;
                        }
                        return 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AudioManager.prototype, "status", {
                    get: function() {
                        return this._status;
                    },
                    enumerable: false,
                    configurable: true
                });
                return AudioManager;
            }(EventManager);
            var audioManager = new AudioManager();
            var FakeResizeObserver = /** @class */ function() {
                function FakeResizeObserver() {}
                FakeResizeObserver.prototype.observe = function() {};
                FakeResizeObserver.prototype.unobserve = function() {};
                FakeResizeObserver.prototype.disconnect = function() {};
                return FakeResizeObserver;
            }();
            var MyResizeObserver = globalThis.ResizeObserver || FakeResizeObserver;
            /**
 * This class takes care of any observers that will be attached to an animation.
 * It should be treated as a singleton because observers are much more performant
 * when used for observing multiple elements by a single instance.
 */ var ObjectObservers = /** @class */ function() {
                function ObjectObservers() {
                    var _this = this;
                    this._elementsMap = new Map();
                    /**
         * Resize observers trigger both when the element changes its size and also when the
         * element is added or removed from the document.
         */ this._onObservedEntry = function(entry) {
                        var observed = _this._elementsMap.get(entry.target);
                        if (observed !== null) observed.onResize(entry.target.clientWidth == 0 || entry.target.clientHeight == 0);
                        else _this._resizeObserver.unobserve(entry.target);
                    };
                    this._onObserved = function(entries) {
                        entries.forEach(_this._onObservedEntry);
                    };
                    this._resizeObserver = new MyResizeObserver(this._onObserved);
                }
                // Adds an observable element
                ObjectObservers.prototype.add = function(element, onResize) {
                    var observed = {
                        onResize: onResize,
                        element: element
                    };
                    this._elementsMap.set(element, observed);
                    this._resizeObserver.observe(element);
                    return observed;
                };
                // Removes an observable element
                ObjectObservers.prototype.remove = function(observed) {
                    this._resizeObserver.unobserve(observed.element);
                    this._elementsMap.delete(observed.element);
                };
                return ObjectObservers;
            }();
            var observers = new ObjectObservers();
            var RiveFile = /** @class */ function() {
                function RiveFile(params) {
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    this.referenceCount = 0;
                    this.destroyed = false;
                    this.src = params.src;
                    this.buffer = params.buffer;
                    if (params.assetLoader) this.assetLoader = params.assetLoader;
                    this.enableRiveAssetCDN = typeof params.enableRiveAssetCDN == "boolean" ? params.enableRiveAssetCDN : true;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                }
                RiveFile.prototype.initData = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a, loader, _b;
                        var _c;
                        return __generator(this, function(_d) {
                            switch(_d.label){
                                case 0:
                                    if (!this.src) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        loadRiveFile(this.src)
                                    ];
                                case 1:
                                    _a.buffer = _d.sent();
                                    _d.label = 2;
                                case 2:
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    if (this.assetLoader) loader = new this.runtime.CustomFileAssetLoader({
                                        loadContents: this.assetLoader
                                    });
                                    // Load the Rive file
                                    _b = this;
                                    return [
                                        4 /*yield*/ ,
                                        this.runtime.load(new Uint8Array(this.buffer), loader, this.enableRiveAssetCDN)
                                    ];
                                case 3:
                                    // Load the Rive file
                                    _b.file = _d.sent();
                                    if (this.destroyed) {
                                        (_c = this.file) === null || _c === void 0 || _c.delete();
                                        this.file = null;
                                        return [
                                            2 /*return*/ 
                                        ];
                                    }
                                    if (this.file !== null) this.eventManager.fire({
                                        type: EventType.Load,
                                        data: this
                                    });
                                    else {
                                        this.eventManager.fire({
                                            type: EventType.LoadError,
                                            data: null
                                        });
                                        throw new Error(RiveFile.fileLoadErrorMessage);
                                    }
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                RiveFile.prototype.init = function() {
                    return __awaiter(this, void 0, void 0, function() {
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    // If no source file url specified, it's a bust
                                    if (!this.src && !this.buffer) throw new Error(RiveFile.missingErrorMessage);
                                    _a = this;
                                    return [
                                        4 /*yield*/ ,
                                        RuntimeLoader.awaitInstance()
                                    ];
                                case 1:
                                    _a.runtime = _b.sent();
                                    if (this.destroyed) return [
                                        2 /*return*/ 
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        this.initData()
                                    ];
                                case 2:
                                    _b.sent();
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ RiveFile.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ RiveFile.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                RiveFile.prototype.cleanup = function() {
                    var _a;
                    this.referenceCount -= 1;
                    if (this.referenceCount <= 0) {
                        this.removeAllRiveEventListeners();
                        (_a = this.file) === null || _a === void 0 || _a.delete();
                        this.file = null;
                        this.destroyed = true;
                    }
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ RiveFile.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                RiveFile.prototype.getInstance = function() {
                    if (this.file !== null) {
                        this.referenceCount += 1;
                        return this.file;
                    }
                };
                // Error message for missing source or buffer
                RiveFile.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for file load error
                RiveFile.fileLoadErrorMessage = "The file failed to load";
                return RiveFile;
            }();
            var Rive = /** @class */ function() {
                function Rive(params) {
                    var _this = this;
                    var _a;
                    // Tracks if a Rive file is loaded
                    this.loaded = false;
                    // Tracks if a Rive file is destroyed
                    this.destroyed = false;
                    // Reference of an object that handles any observers for the animation
                    this._observed = null;
                    /**
         * Tracks if a Rive file is loaded; we need this in addition to loaded as some
         * commands (e.g. contents) can be called as soon as the file is loaded.
         * However, playback commands need to be queued and run in order once initial
         * animations and autoplay has been sorted out. This applies to play, pause,
         * and start.
         */ this.readyForPlaying = false;
                    // Runtime artboard
                    this.artboard = null;
                    // place to clear up event listeners
                    this.eventCleanup = null;
                    this.shouldDisableRiveListeners = false;
                    this.automaticallyHandleEvents = false;
                    // Allow the runtime to automatically load assets hosted in Rive's runtime.
                    this.enableRiveAssetCDN = true;
                    // Keep a local value of the set volume to update it asynchronously
                    this._volume = 1;
                    // Keep a local value of the set width to update it asynchronously
                    this._artboardWidth = undefined;
                    // Keep a local value of the set height to update it asynchronously
                    this._artboardHeight = undefined;
                    // Keep a local value of the device pixel ratio used in rendering and canvas/artboard resizing
                    this._devicePixelRatioUsed = 1;
                    // Whether the canvas element's size is 0
                    this._hasZeroSize = false;
                    // Audio event listener
                    this._audioEventListener = null;
                    // draw method bound to the class
                    this._boundDraw = null;
                    // Durations to generate a frame for the last second. Used for performance profiling.
                    this.durations = [];
                    this.frameTimes = [];
                    this.frameCount = 0;
                    this.isTouchScrollEnabled = false;
                    this.onCanvasResize = function(hasZeroSize) {
                        var toggledDisplay = _this._hasZeroSize !== hasZeroSize;
                        _this._hasZeroSize = hasZeroSize;
                        if (!hasZeroSize) {
                            if (toggledDisplay) _this.resizeDrawingSurfaceToCanvas();
                        } else if (!_this._layout.maxX || !_this._layout.maxY) _this.resizeToCanvas();
                    };
                    /**
         * Used be draw to track when a second of active rendering time has passed.
         * Used for debugging purposes
         */ this.renderSecondTimer = 0;
                    this._boundDraw = this.draw.bind(this);
                    this.canvas = params.canvas;
                    if (params.canvas.constructor === HTMLCanvasElement) this._observed = observers.add(this.canvas, this.onCanvasResize);
                    this.src = params.src;
                    this.buffer = params.buffer;
                    this.riveFile = params.riveFile;
                    this.layout = (_a = params.layout) !== null && _a !== void 0 ? _a : new Layout();
                    this.shouldDisableRiveListeners = !!params.shouldDisableRiveListeners;
                    this.isTouchScrollEnabled = !!params.isTouchScrollEnabled;
                    this.automaticallyHandleEvents = !!params.automaticallyHandleEvents;
                    this.enableRiveAssetCDN = params.enableRiveAssetCDN === undefined ? true : params.enableRiveAssetCDN;
                    // New event management system
                    this.eventManager = new EventManager();
                    if (params.onLoad) this.on(EventType.Load, params.onLoad);
                    if (params.onLoadError) this.on(EventType.LoadError, params.onLoadError);
                    if (params.onPlay) this.on(EventType.Play, params.onPlay);
                    if (params.onPause) this.on(EventType.Pause, params.onPause);
                    if (params.onStop) this.on(EventType.Stop, params.onStop);
                    if (params.onLoop) this.on(EventType.Loop, params.onLoop);
                    if (params.onStateChange) this.on(EventType.StateChange, params.onStateChange);
                    if (params.onAdvance) this.on(EventType.Advance, params.onAdvance);
                    /**
         * @deprecated Use camelCase'd versions instead.
         */ if (params.onload && !params.onLoad) this.on(EventType.Load, params.onload);
                    if (params.onloaderror && !params.onLoadError) this.on(EventType.LoadError, params.onloaderror);
                    if (params.onplay && !params.onPlay) this.on(EventType.Play, params.onplay);
                    if (params.onpause && !params.onPause) this.on(EventType.Pause, params.onpause);
                    if (params.onstop && !params.onStop) this.on(EventType.Stop, params.onstop);
                    if (params.onloop && !params.onLoop) this.on(EventType.Loop, params.onloop);
                    if (params.onstatechange && !params.onStateChange) this.on(EventType.StateChange, params.onstatechange);
                    /**
         * Asset loading
         */ if (params.assetLoader) this.assetLoader = params.assetLoader;
                    // Hook up the task queue
                    this.taskQueue = new TaskQueueManager(this.eventManager);
                    this.init({
                        src: this.src,
                        buffer: this.buffer,
                        riveFile: this.riveFile,
                        autoplay: params.autoplay,
                        animations: params.animations,
                        stateMachines: params.stateMachines,
                        artboard: params.artboard,
                        useOffscreenRenderer: params.useOffscreenRenderer
                    });
                }
                // Alternative constructor to build a Rive instance from an interface/object
                Rive.new = function(params) {
                    console.warn("This function is deprecated: please use `new Rive({})` instead");
                    return new Rive(params);
                };
                // Event handler for when audio context becomes available
                Rive.prototype.onSystemAudioChanged = function() {
                    this.volume = this._volume;
                };
                // Initializes the Rive object either from constructor or load()
                Rive.prototype.init = function(_a) {
                    var _this = this;
                    var src = _a.src, buffer = _a.buffer, riveFile = _a.riveFile, animations = _a.animations, stateMachines = _a.stateMachines, artboard = _a.artboard, _b = _a.autoplay, autoplay = _b === void 0 ? false : _b, _c = _a.useOffscreenRenderer, useOffscreenRenderer = _c === void 0 ? false : _c;
                    if (this.destroyed) return;
                    this.src = src;
                    this.buffer = buffer;
                    this.riveFile = riveFile;
                    // If no source file url specified, it's a bust
                    if (!this.src && !this.buffer && !this.riveFile) throw new RiveError(Rive.missingErrorMessage);
                    // List of animations that should be initialized.
                    var startingAnimationNames = mapToStringArray(animations);
                    // List of state machines that should be initialized
                    var startingStateMachineNames = mapToStringArray(stateMachines);
                    // Ensure loaded is marked as false if loading new file
                    this.loaded = false;
                    this.readyForPlaying = false;
                    // Ensure the runtime is loaded
                    RuntimeLoader.awaitInstance().then(function(runtime) {
                        if (_this.destroyed) return;
                        _this.runtime = runtime;
                        _this.removeRiveListeners();
                        _this.deleteRiveRenderer();
                        // Get the canvas where you want to render the animation and create a renderer
                        _this.renderer = _this.runtime.makeRenderer(_this.canvas, useOffscreenRenderer);
                        // Initial size adjustment based on devicePixelRatio if no width/height are
                        // specified explicitly
                        if (!(_this.canvas.width || _this.canvas.height)) _this.resizeDrawingSurfaceToCanvas();
                        // Load Rive data from a source uri or a data buffer
                        _this.initData(artboard, startingAnimationNames, startingStateMachineNames, autoplay).then(function() {
                            return _this.setupRiveListeners();
                        }).catch(function(e) {
                            console.error(e);
                        });
                    }).catch(function(e) {
                        console.error(e);
                    });
                };
                /**
     * Setup Rive Listeners on the canvas
     * @param riveListenerOptions - Enables TouchEvent events on the canvas. Set to true to allow
     * touch scrolling on the canvas element on touch-enabled devices
     * i.e. { isTouchScrollEnabled: true }
     */ Rive.prototype.setupRiveListeners = function(riveListenerOptions) {
                    var _this = this;
                    if (this.eventCleanup) this.eventCleanup();
                    if (!this.shouldDisableRiveListeners) {
                        var activeStateMachines = (this.animator.stateMachines || []).filter(function(sm) {
                            return sm.playing && _this.runtime.hasListeners(sm.instance);
                        }).map(function(sm) {
                            return sm.instance;
                        });
                        var touchScrollEnabledOption = this.isTouchScrollEnabled;
                        if (riveListenerOptions && "isTouchScrollEnabled" in riveListenerOptions) touchScrollEnabledOption = riveListenerOptions.isTouchScrollEnabled;
                        this.eventCleanup = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.registerTouchInteractions)({
                            canvas: this.canvas,
                            artboard: this.artboard,
                            stateMachines: activeStateMachines,
                            renderer: this.renderer,
                            rive: this.runtime,
                            fit: this._layout.runtimeFit(this.runtime),
                            alignment: this._layout.runtimeAlignment(this.runtime),
                            isTouchScrollEnabled: touchScrollEnabledOption,
                            layoutScaleFactor: this._layout.layoutScaleFactor
                        });
                    }
                };
                /**
     * Remove Rive Listeners setup on the canvas
     */ Rive.prototype.removeRiveListeners = function() {
                    if (this.eventCleanup) {
                        this.eventCleanup();
                        this.eventCleanup = null;
                    }
                };
                /**
     * If the instance has audio and the system audio is not ready
     * we hook the instance to the audio manager
     */ Rive.prototype.initializeAudio = function() {
                    var _this = this;
                    var _a;
                    // Initialize audio if needed
                    if (audioManager.status == SystemAudioStatus.UNAVAILABLE) {
                        if (((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.hasAudio) && this._audioEventListener === null) {
                            this._audioEventListener = {
                                type: EventType.AudioStatusChange,
                                callback: function() {
                                    return _this.onSystemAudioChanged();
                                }
                            };
                            audioManager.add(this._audioEventListener);
                            audioManager.establishAudio();
                        }
                    }
                };
                Rive.prototype.initArtboardSize = function() {
                    if (!this.artboard) return;
                    // Use preset values if they are not undefined
                    this._artboardWidth = this.artboard.width = this._artboardWidth || this.artboard.width;
                    this._artboardHeight = this.artboard.height = this._artboardHeight || this.artboard.height;
                };
                // Initializes runtime with Rive data and preps for playing
                Rive.prototype.initData = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    return __awaiter(this, void 0, void 0, function() {
                        var error_1, msg;
                        var _a;
                        return __generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _b.trys.push([
                                        0,
                                        3,
                                        ,
                                        4
                                    ]);
                                    if (!(this.riveFile == null)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    this.riveFile = new RiveFile({
                                        src: this.src,
                                        buffer: this.buffer,
                                        enableRiveAssetCDN: this.enableRiveAssetCDN,
                                        assetLoader: this.assetLoader
                                    });
                                    return [
                                        4 /*yield*/ ,
                                        this.riveFile.init()
                                    ];
                                case 1:
                                    _b.sent();
                                    _b.label = 2;
                                case 2:
                                    // Check for riveFile in case it has been cleaned up while initializing;
                                    if (!this.riveFile) throw new RiveError(Rive.cleanupErrorMessage);
                                    this.file = this.riveFile.getInstance();
                                    // Initialize and draw frame
                                    this.initArtboard(artboardName, animationNames, stateMachineNames, autoplay);
                                    // Initialize the artboard size
                                    this.initArtboardSize();
                                    // Check for audio
                                    this.initializeAudio();
                                    // Everything's set up, emit a load event
                                    this.loaded = true;
                                    this.eventManager.fire({
                                        type: EventType.Load,
                                        data: (_a = this.src) !== null && _a !== void 0 ? _a : "buffer"
                                    });
                                    // Flag ready for playback commands and clear the task queue; this order
                                    // is important or it may infinitely recurse
                                    this.readyForPlaying = true;
                                    this.taskQueue.process();
                                    this.drawFrame();
                                    return [
                                        2 /*return*/ ,
                                        Promise.resolve()
                                    ];
                                case 3:
                                    error_1 = _b.sent();
                                    msg = resolveErrorMessage(error_1);
                                    console.warn(msg);
                                    this.eventManager.fire({
                                        type: EventType.LoadError,
                                        data: msg
                                    });
                                    return [
                                        2 /*return*/ ,
                                        Promise.reject(msg)
                                    ];
                                case 4:
                                    return [
                                        2 /*return*/ 
                                    ];
                            }
                        });
                    });
                };
                // Initialize for playback
                Rive.prototype.initArtboard = function(artboardName, animationNames, stateMachineNames, autoplay) {
                    if (!this.file) return;
                    // Fetch the artboard
                    var rootArtboard = artboardName ? this.file.artboardByName(artboardName) : this.file.defaultArtboard();
                    // Check we have a working artboard
                    if (!rootArtboard) {
                        var msg = "Invalid artboard name or no default artboard";
                        console.warn(msg);
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        return;
                    }
                    this.artboard = rootArtboard;
                    rootArtboard.volume = this._volume * audioManager.systemVolume;
                    // Check that the artboard has at least 1 animation
                    if (this.artboard.animationCount() < 1) {
                        var msg = "Artboard has no animations";
                        this.eventManager.fire({
                            type: EventType.LoadError,
                            data: msg
                        });
                        throw msg;
                    }
                    // Initialize the animator
                    this.animator = new Animator(this.runtime, this.artboard, this.eventManager);
                    // Initialize the animations; as loaded hasn't happened yet, we need to
                    // suppress firing the play/pause events until the load event has fired. To
                    // do this we tell the animator to suppress firing events, and add event
                    // firing to the task queue.
                    var instanceNames;
                    if (animationNames.length > 0 || stateMachineNames.length > 0) {
                        instanceNames = animationNames.concat(stateMachineNames);
                        this.animator.initLinearAnimations(animationNames, autoplay);
                        this.animator.initStateMachines(stateMachineNames, autoplay);
                    } else instanceNames = [
                        this.animator.atLeastOne(autoplay, false)
                    ];
                    // Queue up firing the playback events
                    this.taskQueue.add({
                        event: {
                            type: autoplay ? EventType.Play : EventType.Pause,
                            data: instanceNames
                        }
                    });
                };
                // Draws the current artboard frame
                Rive.prototype.drawFrame = function() {
                    var _a;
                    if ((_a = document === null || document === void 0 ? void 0 : document.timeline) === null || _a === void 0 ? void 0 : _a.currentTime) {
                        if (this.loaded && this.artboard && !this.frameRequestId) this._boundDraw(document.timeline.currentTime);
                    } else this.startRendering();
                };
                /**
     * Draw rendering loop; renders animation frames at the correct time interval.
     * @param time the time at which to render a frame
     */ Rive.prototype.draw = function(time, onSecond) {
                    // Clear the frameRequestId, as we're now rendering a fresh frame
                    this.frameRequestId = null;
                    var before = performance.now();
                    // On the first pass, make sure lastTime has a valid value
                    if (!this.lastRenderTime) this.lastRenderTime = time;
                    // Handle the onSecond callback
                    this.renderSecondTimer += time - this.lastRenderTime;
                    if (this.renderSecondTimer > 5000) {
                        this.renderSecondTimer = 0;
                        onSecond === null || onSecond === void 0 || onSecond();
                    }
                    // Calculate the elapsed time between frames in seconds
                    var elapsedTime = (time - this.lastRenderTime) / 1000;
                    this.lastRenderTime = time;
                    // - Advance non-paused animations by the elapsed number of seconds
                    // - Advance any animations that require scrubbing
                    // - Advance to the first frame even when autoplay is false
                    var activeAnimations = this.animator.animations.filter(function(a) {
                        return a.playing || a.needsScrub;
                    })// The scrubbed animations must be applied first to prevent weird artifacts
                    // if the playing animations conflict with the scrubbed animating attribuates.
                    .sort(function(first) {
                        return first.needsScrub ? -1 : 1;
                    });
                    for(var _i = 0, activeAnimations_1 = activeAnimations; _i < activeAnimations_1.length; _i++){
                        var animation = activeAnimations_1[_i];
                        animation.advance(elapsedTime);
                        if (animation.instance.didLoop) animation.loopCount += 1;
                        animation.apply(1.0);
                    }
                    // - Advance non-paused state machines by the elapsed number of seconds
                    // - Advance to the first frame even when autoplay is false
                    var activeStateMachines = this.animator.stateMachines.filter(function(a) {
                        return a.playing;
                    });
                    for(var _a = 0, activeStateMachines_1 = activeStateMachines; _a < activeStateMachines_1.length; _a++){
                        var stateMachine = activeStateMachines_1[_a];
                        // Check for events before the current frame's state machine advance
                        var numEventsReported = stateMachine.reportedEventCount();
                        if (numEventsReported) for(var i = 0; i < numEventsReported; i++){
                            var event_1 = stateMachine.reportedEventAt(i);
                            if (event_1) {
                                if (event_1.type === RiveEventType.OpenUrl) {
                                    this.eventManager.fire({
                                        type: EventType.RiveEvent,
                                        data: event_1
                                    });
                                    // Handle the event side effect if explicitly enabled
                                    if (this.automaticallyHandleEvents) {
                                        var newAnchorTag = document.createElement("a");
                                        var _b = event_1, url = _b.url, target = _b.target;
                                        var sanitizedUrl = (0, _utils__WEBPACK_IMPORTED_MODULE_3__.sanitizeUrl)(url);
                                        url && newAnchorTag.setAttribute("href", sanitizedUrl);
                                        target && newAnchorTag.setAttribute("target", target);
                                        if (sanitizedUrl && sanitizedUrl !== _utils__WEBPACK_IMPORTED_MODULE_3__.BLANK_URL) newAnchorTag.click();
                                    }
                                } else this.eventManager.fire({
                                    type: EventType.RiveEvent,
                                    data: event_1
                                });
                            }
                        }
                        stateMachine.advanceAndApply(elapsedTime);
                    // stateMachine.instance.apply(this.artboard);
                    }
                    // Once the animations have been applied to the artboard, advance it
                    // by the elapsed time.
                    if (this.animator.stateMachines.length == 0) this.artboard.advance(elapsedTime);
                    var renderer = this.renderer;
                    // Canvas must be wiped to prevent artifacts
                    renderer.clear();
                    renderer.save();
                    // Update the renderer alignment if necessary
                    this.alignRenderer();
                    // Do not draw on 0 canvas size
                    if (!this._hasZeroSize) this.artboard.draw(renderer);
                    renderer.restore();
                    renderer.flush();
                    // Check for any animations that looped
                    this.animator.handleLooping();
                    // Check for any state machines that had a state change
                    this.animator.handleStateChanges();
                    // Report advanced time
                    this.animator.handleAdvancing(elapsedTime);
                    // Add duration to create frame to durations array
                    this.frameCount++;
                    var after = performance.now();
                    this.frameTimes.push(after);
                    this.durations.push(after - before);
                    while(this.frameTimes[0] <= after - 1000){
                        this.frameTimes.shift();
                        this.durations.shift();
                    }
                    // Calling requestAnimationFrame will rerun draw() at the correct rate:
                    // https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Basic_animations
                    if (this.animator.isPlaying) // Request a new rendering frame
                    this.startRendering();
                    else if (this.animator.isPaused) // Reset the end time so on playback it starts at the correct frame
                    this.lastRenderTime = 0;
                    else if (this.animator.isStopped) // Reset animation instances, artboard and time
                    // TODO: implement this properly when we have instancing
                    // this.initArtboard();
                    // this.drawFrame();
                    this.lastRenderTime = 0;
                };
                /**
     * Align the renderer
     */ Rive.prototype.alignRenderer = function() {
                    var _a = this, renderer = _a.renderer, runtime = _a.runtime, _layout = _a._layout, artboard = _a.artboard;
                    // Align things up safe in the knowledge we can restore if changed
                    renderer.align(_layout.runtimeFit(runtime), _layout.runtimeAlignment(runtime), {
                        minX: _layout.minX,
                        minY: _layout.minY,
                        maxX: _layout.maxX,
                        maxY: _layout.maxY
                    }, artboard.bounds, this._devicePixelRatioUsed * _layout.layoutScaleFactor);
                };
                Object.defineProperty(Rive.prototype, "fps", {
                    get: function() {
                        return this.durations.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "frameTime", {
                    get: function() {
                        if (this.durations.length === 0) return 0;
                        return (this.durations.reduce(function(a, b) {
                            return a + b;
                        }, 0) / this.durations.length).toFixed(4);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Cleans up all Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances,
     * renderer instance, file and runtime.
     *
     * Once this is called, you will need to initialise a new instance of the
     * Rive class
     */ Rive.prototype.cleanup = function() {
                    var _a;
                    this.destroyed = true;
                    // Stop the renderer if it hasn't already been stopped.
                    this.stopRendering();
                    // Clean up any artboard, animation or state machine instances.
                    this.cleanupInstances();
                    // Remove from observer
                    if (this._observed !== null) observers.remove(this._observed);
                    this.removeRiveListeners();
                    if (this.file) {
                        (_a = this.riveFile) === null || _a === void 0 || _a.cleanup();
                        this.file = null;
                    }
                    this.riveFile = null;
                    this.deleteRiveRenderer();
                    if (this._audioEventListener !== null) {
                        audioManager.remove(this._audioEventListener);
                        this._audioEventListener = null;
                    }
                };
                /**
     * Cleans up the Renderer object. Only call this API if you no longer
     * need to render Rive content in your session.
     */ Rive.prototype.deleteRiveRenderer = function() {
                    var _a;
                    (_a = this.renderer) === null || _a === void 0 || _a.delete();
                    this.renderer = null;
                };
                /**
     * Cleans up any Wasm-generated objects that need to be manually destroyed:
     * artboard instances, animation instances, state machine instances.
     *
     * Once this is called, things will need to be reinitialized or bad things
     * might happen.
     */ Rive.prototype.cleanupInstances = function() {
                    if (this.eventCleanup !== null) this.eventCleanup();
                    // Delete all animation and state machine instances
                    this.stop();
                    if (this.artboard) {
                        this.artboard.delete();
                        this.artboard = null;
                    }
                };
                /**
     * Tries to query the setup Artboard for a text run node with the given name.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - TextValueRun node or undefined if the text run cannot be queried
     */ Rive.prototype.retrieveTextRun = function(textRunName) {
                    var _a;
                    if (!textRunName) {
                        console.warn("No text run name provided");
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text run, but the Artboard is null");
                        return;
                    }
                    var textRun = this.artboard.textRun(textRunName);
                    if (!textRun) {
                        console.warn("Could not access a text run with name '".concat(textRunName, "' in the '").concat((_a = this.artboard) === null || _a === void 0 ? void 0 : _a.name, "' Artboard. Note that you must rename a text run node in the Rive editor to make it queryable at runtime."));
                        return;
                    }
                    return textRun;
                };
                /**
     * Returns a string from a given text run node name, or undefined if the text run
     * cannot be queried.
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @returns - String value of the text run node or undefined
     */ Rive.prototype.getTextRunValue = function(textRunName) {
                    var textRun = this.retrieveTextRun(textRunName);
                    return textRun ? textRun.text : undefined;
                };
                /**
     * Sets a text value for a given text run node name if possible
     *
     * @param textRunName - Name of the text run node associated with a text object
     * @param textRunValue - String value to set on the text run node
     */ Rive.prototype.setTextRunValue = function(textRunName, textRunValue) {
                    var textRun = this.retrieveTextRun(textRunName);
                    if (textRun) textRun.text = textRunValue;
                };
                // Plays specified animations; if none specified, it unpauses everything.
                Rive.prototype.play = function(animationNames, autoplay) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, queue up the play
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.play(animationNames, autoplay);
                            }
                        });
                        return;
                    }
                    this.animator.play(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                    this.setupRiveListeners();
                    this.startRendering();
                };
                // Pauses specified animations; if none specified, pauses all.
                Rive.prototype.pause = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.pause(animationNames);
                            }
                        });
                        return;
                    }
                    if (this.eventCleanup) this.eventCleanup();
                    this.animator.pause(animationNames);
                };
                Rive.prototype.scrub = function(animationNames, value) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.scrub(animationNames, value);
                            }
                        });
                        return;
                    }
                    // Scrub the animation time; we draw a single frame here so that if
                    // nothing's currently playing, the scrubbed animation is still rendered/
                    this.animator.scrub(animationNames, value || 0);
                    this.drawFrame();
                };
                // Stops specified animations; if none specifies, stops them all.
                Rive.prototype.stop = function(animationNames) {
                    var _this = this;
                    animationNames = mapToStringArray(animationNames);
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.readyForPlaying) {
                        this.taskQueue.add({
                            action: function() {
                                return _this.stop(animationNames);
                            }
                        });
                        return;
                    }
                    // If there is no artboard, this.animator will be undefined
                    if (this.animator) this.animator.stop(animationNames);
                    if (this.eventCleanup) this.eventCleanup();
                };
                /**
     * Resets the animation
     * @param artboard the name of the artboard, or default if none given
     * @param animations the names of animations for playback
     * @param stateMachines the names of state machines for playback
     * @param autoplay whether to autoplay when reset, defaults to false
     *
     */ Rive.prototype.reset = function(params) {
                    var _a;
                    // Get the current artboard, animations, state machines, and playback states
                    var artBoardName = params === null || params === void 0 ? void 0 : params.artboard;
                    var animationNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.animations);
                    var stateMachineNames = mapToStringArray(params === null || params === void 0 ? void 0 : params.stateMachines);
                    var autoplay = (_a = params === null || params === void 0 ? void 0 : params.autoplay) !== null && _a !== void 0 ? _a : false;
                    // Stop everything and clean up
                    this.cleanupInstances();
                    // Reinitialize an artboard instance with the state
                    this.initArtboard(artBoardName, animationNames, stateMachineNames, autoplay);
                    this.taskQueue.process();
                };
                // Loads a new Rive file, keeping listeners in place
                Rive.prototype.load = function(params) {
                    this.file = null;
                    // Stop all animations
                    this.stop();
                    // Reinitialize
                    this.init(params);
                };
                Object.defineProperty(Rive.prototype, "layout", {
                    /**
         * Returns the current layout. Note that layout should be treated as
         * immutable. If you want to change the layout, create a new one use the
         * layout setter
         */ get: function() {
                        return this._layout;
                    },
                    // Sets a new layout
                    set: function(layout) {
                        this._layout = layout;
                        // If the maxX or maxY are 0, then set them to the canvas width and height
                        if (!layout.maxX || !layout.maxY) this.resizeToCanvas();
                        if (this.loaded && !this.animator.isPlaying) this.drawFrame();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the layout bounds to the current canvas size; this is typically called
     * when the canvas is resized
     */ Rive.prototype.resizeToCanvas = function() {
                    this._layout = this.layout.copyWith({
                        minX: 0,
                        minY: 0,
                        maxX: this.canvas.width,
                        maxY: this.canvas.height
                    });
                };
                /**
     * Accounts for devicePixelRatio as a multiplier to render the size of the canvas drawing surface.
     * Uses the size of the backing canvas to set new width/height attributes. Need to re-render
     * and resize the layout to match the new drawing surface afterwards.
     * Useful function for consumers to include in a window resize listener.
     *
     * This method will set the {@link devicePixelRatioUsed} property.
     *
     * Optionally, you can provide a {@link customDevicePixelRatio} to provide a
     * custom value.
     */ Rive.prototype.resizeDrawingSurfaceToCanvas = function(customDevicePixelRatio) {
                    if (this.canvas instanceof HTMLCanvasElement && !!window) {
                        var _a = this.canvas.getBoundingClientRect(), width = _a.width, height = _a.height;
                        var dpr = customDevicePixelRatio || window.devicePixelRatio || 1;
                        this.devicePixelRatioUsed = dpr;
                        this.canvas.width = dpr * width;
                        this.canvas.height = dpr * height;
                        this.resizeToCanvas();
                        this.drawFrame();
                        if (this.layout.fit === Fit.Layout) {
                            var scaleFactor = this._layout.layoutScaleFactor;
                            this.artboard.width = width / scaleFactor;
                            this.artboard.height = height / scaleFactor;
                        }
                    }
                };
                Object.defineProperty(Rive.prototype, "source", {
                    // Returns the animation source, which may be undefined
                    get: function() {
                        return this.src;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "activeArtboard", {
                    /**
         * Returns the name of the active artboard
         */ get: function() {
                        return this.artboard ? this.artboard.name : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "animationNames", {
                    // Returns a list of animation names on the chosen artboard
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var animationNames = [];
                        for(var i = 0; i < this.artboard.animationCount(); i++)animationNames.push(this.artboard.animationByIndex(i).name);
                        return animationNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "stateMachineNames", {
                    /**
         * Returns a list of state machine names from the current artboard
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded || !this.artboard) return [];
                        var stateMachineNames = [];
                        for(var i = 0; i < this.artboard.stateMachineCount(); i++)stateMachineNames.push(this.artboard.stateMachineByIndex(i).name);
                        return stateMachineNames;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the inputs for the specified instanced state machine, or an empty
     * list if the name is invalid or the state machine is not instanced
     * @param name the state machine name
     * @returns the inputs for the named state machine
     */ Rive.prototype.stateMachineInputs = function(name) {
                    // If the file's not loaded, early out, nothing to pause
                    if (!this.loaded) return;
                    var stateMachine = this.animator.stateMachines.find(function(m) {
                        return m.name === name;
                    });
                    return stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.inputs;
                };
                // Returns the input with the provided name at the given path
                Rive.prototype.retrieveInputAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No input name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access input: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var input = this.artboard.inputByPath(name, path);
                    if (!input) {
                        console.warn("Could not access an input with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return input;
                };
                /**
     * Set the boolean input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setBooleanStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Boolean) input.asBool().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a boolean"));
                };
                /**
     * Set the number input with the provided name at the given path with value
     * @param input the state machine input name
     * @param value the value to set the input to
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.setNumberStateAtPath = function(inputName, value, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Number) input.asNumber().value = value;
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a number"));
                };
                /**
     * Fire the trigger with the provided name at the given path
     * @param input the state machine input name
     * @param path the path the input is located at an artboard level
     */ Rive.prototype.fireStateAtPath = function(inputName, path) {
                    var input = this.retrieveInputAtPath(inputName, path);
                    if (!input) return;
                    if (input.type === StateMachineInputType.Trigger) input.asTrigger().fire();
                    else console.warn("Input with name: '".concat(inputName, "', at path:'").concat(path, "' is not a trigger"));
                };
                // Returns the TextValueRun object for the provided name at the given path
                Rive.prototype.retrieveTextAtPath = function(name, path) {
                    if (!name) {
                        console.warn("No text name provided for path '".concat(path, "'"));
                        return;
                    }
                    if (!path) {
                        console.warn("No path provided for text '".concat(name, "'"));
                        return;
                    }
                    if (!this.artboard) {
                        console.warn("Tried to access text: '".concat(name, "', at path: '").concat(path, "', but the Artboard is null"));
                        return;
                    }
                    var text = this.artboard.textByPath(name, path);
                    if (!text) {
                        console.warn("Could not access text with name: '".concat(name, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return text;
                };
                /**
     * Retrieves the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param path The path to the text run within the artboard
     * @returns The text value of the text run, or undefined if not found
     *
     * @example
     * // Get the text value for a text run named "title" at one nested artboard deep
     * const titleText = riveInstance.getTextRunValueAtPath("title", "artboard1");
     *
     * @example
     * // Get the text value for a text run named "subtitle" within a nested group two artboards deep
     * const subtitleText = riveInstance.getTextRunValueAtPath("subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.getTextRunValueAtPath = function(textName, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not get text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    return run.text;
                };
                /**
     * Sets the text value for a specified text run at a given path
     * @param textName The name of the text run
     * @param value The new text value to set
     * @param path The path to the text run within the artboard
     * @returns void
     *
     * @example
     * // Set the text value for a text run named "title" at one nested artboard deep
     * riveInstance.setTextRunValueAtPath("title", "New Title", "artboard1");
     *
     * @example
     * // Set the text value for a text run named "subtitle" within a nested group two artboards deep
     * riveInstance.setTextRunValueAtPath("subtitle", "New Subtitle", "group/nestedGroup");
     *
     * @remarks
     * If the text run cannot be found at the specified path, a warning will be logged to the console.
     */ Rive.prototype.setTextRunValueAtPath = function(textName, value, path) {
                    var run = this.retrieveTextAtPath(textName, path);
                    if (!run) {
                        console.warn("Could not set text with name: '".concat(textName, "', at path:'").concat(path, "'"));
                        return;
                    }
                    run.text = value;
                };
                Object.defineProperty(Rive.prototype, "playingStateMachineNames", {
                    // Returns a list of playing machine names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "playingAnimationNames", {
                    // Returns a list of playing animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedAnimationNames", {
                    // Returns a list of paused animation names
                    get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.animations.filter(function(a) {
                            return !a.playing;
                        }).map(function(a) {
                            return a.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "pausedStateMachineNames", {
                    /**
         *  Returns a list of paused machine names
         * @returns a list of state machine names that are paused
         */ get: function() {
                        // If the file's not loaded, we got nothing to return
                        if (!this.loaded) return [];
                        return this.animator.stateMachines.filter(function(m) {
                            return !m.playing;
                        }).map(function(m) {
                            return m.name;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPlaying", {
                    /**
         * @returns true if any animation is playing
         */ get: function() {
                        return this.animator.isPlaying;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isPaused", {
                    /**
         * @returns true if all instanced animations are paused
         */ get: function() {
                        return this.animator.isPaused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "isStopped", {
                    /**
         * @returns true if no animations are playing or paused
         */ get: function() {
                        return this.animator.isStopped;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "bounds", {
                    /**
         * @returns the bounds of the current artboard, or undefined if the artboard
         * isn't loaded yet.
         */ get: function() {
                        return this.artboard ? this.artboard.bounds : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Subscribe to Rive-generated events
     * @param type the type of event to subscribe to
     * @param callback callback to fire when the event occurs
     */ Rive.prototype.on = function(type, callback) {
                    this.eventManager.add({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @param type the type of event to unsubscribe from
     * @param callback the callback to unsubscribe
     */ Rive.prototype.off = function(type, callback) {
                    this.eventManager.remove({
                        type: type,
                        callback: callback
                    });
                };
                /**
     * Unsubscribes from a Rive-generated event
     * @deprecated
     * @param callback the callback to unsubscribe from
     */ Rive.prototype.unsubscribe = function(type, callback) {
                    console.warn("This function is deprecated: please use `off()` instead.");
                    this.off(type, callback);
                };
                /**
     * Unsubscribes all Rive listeners from an event type, or everything if no type is
     * given
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.removeAllRiveEventListeners = function(type) {
                    this.eventManager.removeAll(type);
                };
                /**
     * Unsubscribes all listeners from an event type, or everything if no type is
     * given
     * @deprecated
     * @param type the type of event to unsubscribe from, or all types if
     * undefined
     */ Rive.prototype.unsubscribeAll = function(type) {
                    console.warn("This function is deprecated: please use `removeAllRiveEventListeners()` instead.");
                    this.removeAllRiveEventListeners(type);
                };
                /**
     * Stops the rendering loop; this is different from pausing in that it doesn't
     * change the state of any animation. It stops rendering from occurring. This
     * is designed for situations such as when Rive isn't visible.
     *
     * The only way to start rendering again is to call `startRendering`.
     * Animations that are marked as playing will start from the position that
     * they would have been at if rendering had not been stopped.
     */ Rive.prototype.stopRendering = function() {
                    if (this.loaded && this.frameRequestId) {
                        if (this.runtime.cancelAnimationFrame) this.runtime.cancelAnimationFrame(this.frameRequestId);
                        else cancelAnimationFrame(this.frameRequestId);
                        this.frameRequestId = null;
                    }
                };
                /**
     * Starts the rendering loop if it has been previously stopped. If the
     * renderer is already active, then this will have zero effect.
     */ Rive.prototype.startRendering = function() {
                    if (this.loaded && this.artboard && !this.frameRequestId) {
                        if (this.runtime.requestAnimationFrame) this.frameRequestId = this.runtime.requestAnimationFrame(this._boundDraw);
                        else this.frameRequestId = requestAnimationFrame(this._boundDraw);
                    }
                };
                /**
     * Enables frames-per-second (FPS) reporting for the runtime
     * If no callback is provided, Rive will append a fixed-position div at the top-right corner of
     * the page with the FPS reading
     * @param fpsCallback - Callback from the runtime during the RAF loop that supplies the FPS value
     */ Rive.prototype.enableFPSCounter = function(fpsCallback) {
                    this.runtime.enableFPSCounter(fpsCallback);
                };
                /**
     * Disables frames-per-second (FPS) reporting for the runtime
     */ Rive.prototype.disableFPSCounter = function() {
                    this.runtime.disableFPSCounter();
                };
                Object.defineProperty(Rive.prototype, "contents", {
                    /**
         * Returns the contents of a Rive file: the artboards, animations, and state machines
         */ get: function() {
                        if (!this.loaded) return undefined;
                        var riveContents = {
                            artboards: []
                        };
                        for(var i = 0; i < this.file.artboardCount(); i++){
                            var artboard = this.file.artboardByIndex(i);
                            var artboardContents = {
                                name: artboard.name,
                                animations: [],
                                stateMachines: []
                            };
                            for(var j = 0; j < artboard.animationCount(); j++){
                                var animation = artboard.animationByIndex(j);
                                artboardContents.animations.push(animation.name);
                            }
                            for(var k = 0; k < artboard.stateMachineCount(); k++){
                                var stateMachine = artboard.stateMachineByIndex(k);
                                var name_1 = stateMachine.name;
                                var instance = new this.runtime.StateMachineInstance(stateMachine, artboard);
                                var inputContents = [];
                                for(var l = 0; l < instance.inputCount(); l++){
                                    var input = instance.input(l);
                                    inputContents.push({
                                        name: input.name,
                                        type: input.type
                                    });
                                }
                                artboardContents.stateMachines.push({
                                    name: name_1,
                                    inputs: inputContents
                                });
                            }
                            riveContents.artboards.push(artboardContents);
                        }
                        return riveContents;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "volume", {
                    /**
         * Getter / Setter for the volume of the artboard
         */ get: function() {
                        if (this.artboard && this.artboard.volume !== this._volume) this._volume = this.artboard.volume;
                        return this._volume;
                    },
                    set: function(value) {
                        this._volume = value;
                        if (this.artboard) this.artboard.volume = value * audioManager.systemVolume;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardWidth", {
                    /**
         * The width of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * width has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard width is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.width;
                        return (_a = this._artboardWidth) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardWidth = value;
                        if (this.artboard) this.artboard.width = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Rive.prototype, "artboardHeight", {
                    /**
         * The height of the artboard.
         *
         * This will return 0 if the artboard is not loaded yet and a custom
         * height has not been set.
         *
         * Do not set this value manually when using {@link resizeDrawingSurfaceToCanvas}
         * with a {@link Layout.fit} of {@link Fit.Layout}, as the artboard height is
         * automatically set.
         */ get: function() {
                        var _a;
                        if (this.artboard) return this.artboard.height;
                        return (_a = this._artboardHeight) !== null && _a !== void 0 ? _a : 0;
                    },
                    set: function(value) {
                        this._artboardHeight = value;
                        if (this.artboard) this.artboard.height = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Reset the artboard size to its original values.
     */ Rive.prototype.resetArtboardSize = function() {
                    if (this.artboard) {
                        this.artboard.resetArtboardSize();
                        this._artboardWidth = this.artboard.width;
                        this._artboardHeight = this.artboard.height;
                    } else {
                        // If the artboard isn't loaded, we need to reset the custom width and height
                        this._artboardWidth = undefined;
                        this._artboardHeight = undefined;
                    }
                };
                Object.defineProperty(Rive.prototype, "devicePixelRatioUsed", {
                    /**
         * The device pixel ratio used in rendering and canvas/artboard resizing.
         *
         * This value will be overidden by the device pixel ratio used in
         * {@link resizeDrawingSurfaceToCanvas}. If you use that method, do not set this value.
         */ get: function() {
                        return this._devicePixelRatioUsed;
                    },
                    set: function(value) {
                        this._devicePixelRatioUsed = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                // Error message for missing source or buffer
                Rive.missingErrorMessage = "Rive source file or data buffer required";
                // Error message for removed rive file
                Rive.cleanupErrorMessage = "Attempt to use file after calling cleanup.";
                return Rive;
            }();
            // Loads Rive data from a URI via fetch.
            var loadRiveFile = function(src) {
                return __awaiter(void 0, void 0, void 0, function() {
                    var req, res, buffer;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                req = new Request(src);
                                return [
                                    4 /*yield*/ ,
                                    fetch(req)
                                ];
                            case 1:
                                res = _a.sent();
                                return [
                                    4 /*yield*/ ,
                                    res.arrayBuffer()
                                ];
                            case 2:
                                buffer = _a.sent();
                                return [
                                    2 /*return*/ ,
                                    buffer
                                ];
                        }
                    });
                });
            };
            // #endregion
            // #region utility functions
            /*
 * Utility function to ensure an object is a string array
 */ var mapToStringArray = function(obj) {
                if (typeof obj === "string") return [
                    obj
                ];
                else if (obj instanceof Array) return obj;
                // If obj is undefined, return empty array
                return [];
            };
            // #endregion
            // #region testing utilities
            // Exports to only be used for tests
            var Testing = {
                EventManager: EventManager,
                TaskQueueManager: TaskQueueManager
            };
            // #endregion
            // #region asset loaders
            /**
 * Decodes bytes into an audio asset.
 *
 * Be sure to call `.unref()` on the audio once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeAudio = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeAudio(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into an image.
 *
 * Be sure to call `.unref()` on the image once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeImage = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeImage(bytes, resolve);
                    });
                });
            };
            /**
 * Decodes bytes into a font.
 *
 * Be sure to call `.unref()` on the font once it is no longer needed. This
 * allows the engine to clean it up when it is not used by any more animations.
 */ var decodeFont = function(bytes) {
                return new Promise(function(resolve) {
                    return RuntimeLoader.getInstance(function(rive) {
                        rive.decodeFont(bytes, resolve);
                    });
                });
            };
        // #endregion
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});


function $1650107b0b0ea012$var$n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
var $1650107b0b0ea012$var$i = /*#__PURE__*/ $1650107b0b0ea012$var$n($iSvIT), $1650107b0b0ea012$var$r = function() {
    return $1650107b0b0ea012$var$r = Object.assign || function(e) {
        for(var t, n = 1, i = arguments.length; n < i; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $1650107b0b0ea012$var$r.apply(this, arguments);
};
function $1650107b0b0ea012$var$o(e, t) {
    var n = {};
    for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(i = Object.getOwnPropertySymbols(e); r < i.length; r++)t.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[r]) && (n[i[r]] = e[i[r]]);
    }
    return n;
}
function $1650107b0b0ea012$var$a(e, t, n, i) {
    return new (n || (n = Promise))(function(r, o) {
        function a(e) {
            try {
                s(i.next(e));
            } catch (e) {
                o(e);
            }
        }
        function u(e) {
            try {
                s(i.throw(e));
            } catch (e) {
                o(e);
            }
        }
        function s(e) {
            var t;
            e.done ? r(e.value) : (t = e.value, t instanceof n ? t : new n(function(e) {
                e(t);
            })).then(a, u);
        }
        s((i = i.apply(e, t || [])).next());
    });
}
function $1650107b0b0ea012$var$u(e, t) {
    var n, i, r, o = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    }, a = Object.create(("function" == typeof Iterator ? Iterator : Object).prototype);
    return a.next = u(0), a.throw = u(1), a.return = u(2), "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function u(u) {
        return function(s) {
            return function(u) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a && (a = 0, u[0] && (o = 0)), o;)try {
                    if (n = 1, i && (r = 2 & u[0] ? i.return : u[0] ? i.throw || ((r = i.return) && r.call(i), 0) : i.next) && !(r = r.call(i, u[1])).done) return r;
                    switch(i = 0, r && (u = [
                        2 & u[0],
                        r.value
                    ]), u[0]){
                        case 0:
                        case 1:
                            r = u;
                            break;
                        case 4:
                            return o.label++, {
                                value: u[1],
                                done: !1
                            };
                        case 5:
                            o.label++, i = u[1], u = [
                                0
                            ];
                            continue;
                        case 7:
                            u = o.ops.pop(), o.trys.pop();
                            continue;
                        default:
                            if (!(r = o.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                                o = 0;
                                continue;
                            }
                            if (3 === u[0] && (!r || u[1] > r[0] && u[1] < r[3])) {
                                o.label = u[1];
                                break;
                            }
                            if (6 === u[0] && o.label < r[1]) {
                                o.label = r[1], r = u;
                                break;
                            }
                            if (r && o.label < r[2]) {
                                o.label = r[2], o.ops.push(u);
                                break;
                            }
                            r[2] && o.ops.pop(), o.trys.pop();
                            continue;
                    }
                    u = t.call(e, o);
                } catch (e) {
                    u = [
                        6,
                        e
                    ], i = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & u[0]) throw u[1];
                return {
                    value: u[0] ? u[1] : void 0,
                    done: !0
                };
            }([
                u,
                s
            ]);
        };
    }
}
function $1650107b0b0ea012$var$s(t) {
    var n = t || $1650107b0b0ea012$var$c(), i = $iSvIT.useState(n), r = i[0], o = i[1];
    return $iSvIT.useEffect(function() {
        if ("undefined" != typeof window && "matchMedia" in window) {
            var e = function() {
                var e = t || $1650107b0b0ea012$var$c();
                o(e);
            }, n = window.matchMedia("screen and (resolution: ".concat(r, "dppx)"));
            return n.hasOwnProperty("addEventListener") ? n.addEventListener("change", e) : n.addListener(e), function() {
                n.hasOwnProperty("removeEventListener") ? n.removeEventListener("change", e) : n.removeListener(e);
            };
        }
    }, [
        r,
        t
    ]), r;
}
function $1650107b0b0ea012$var$c() {
    var e = "undefined" != typeof window && "number" == typeof window.devicePixelRatio ? window.devicePixelRatio : 1;
    return Math.min(Math.max(1, e), 3);
}
"function" == typeof SuppressedError && SuppressedError;
var $1650107b0b0ea012$var$l = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}();
var $1650107b0b0ea012$var$f = globalThis.ResizeObserver || $1650107b0b0ea012$var$l, $1650107b0b0ea012$var$d = void 0 !== globalThis.ResizeObserver, $1650107b0b0ea012$var$v = !$1650107b0b0ea012$var$d;
function $1650107b0b0ea012$var$h(t, n) {
    void 0 === n && (n = !0);
    var i = $iSvIT.useState({
        width: 0,
        height: 0
    }), r = i[0], o = i[1];
    $iSvIT.useEffect(function() {
        if ("undefined" != typeof window && n) {
            var e = function() {
                o({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            };
            return $1650107b0b0ea012$var$v && (e(), window.addEventListener("resize", e)), function() {
                return window.removeEventListener("resize", e);
            };
        }
    }, []);
    var a, u, s, c = $iSvIT.useRef(new $1650107b0b0ea012$var$f((a = function(e) {
        $1650107b0b0ea012$var$d && o({
            width: e[e.length - 1].contentRect.width,
            height: e[e.length - 1].contentRect.height
        });
    }, u = 0, s = 0, function() {
        for(var e = this, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n];
        clearTimeout(s), s = window.setTimeout(function() {
            return a.apply(e, t);
        }, u);
    })));
    return $iSvIT.useEffect(function() {
        var e = c.current;
        if (n) {
            var i = t.current;
            return t.current && $1650107b0b0ea012$var$d && e.observe(t.current), function() {
                e.disconnect(), i && $1650107b0b0ea012$var$d && e.unobserve(i);
            };
        }
        e.disconnect();
    }, [
        t,
        c
    ]), r;
}
var $1650107b0b0ea012$var$p = {
    useDevicePixelRatio: !0,
    fitCanvasToArtboardHeight: !1,
    useOffscreenRenderer: !0,
    shouldResizeCanvasToContainer: !0
};
function $1650107b0b0ea012$var$b(e) {
    return Object.assign({}, $1650107b0b0ea012$var$p, e);
}
function $1650107b0b0ea012$var$w(t) {
    var n = t.riveLoaded, i = void 0 !== n && n, r = t.canvasElem, o = t.containerRef, a = t.options, u = void 0 === a ? {} : a, c = t.onCanvasHasResized, l = t.artboardBounds, f = $1650107b0b0ea012$var$b(u), d = $iSvIT.useState({
        height: 0,
        width: 0
    }), v = d[0], p = v.height, w = v.width, y = d[1], g = $iSvIT.useState({
        height: 0,
        width: 0
    }), m = g[0], R = m.height, C = m.width, E = g[1], O = $iSvIT.useState(!0), x = O[0], T = O[1], P = f.fitCanvasToArtboardHeight, L = f.shouldResizeCanvasToContainer, S = f.useDevicePixelRatio, k = f.customDevicePixelRatio, M = $1650107b0b0ea012$var$h(o, L), j = $1650107b0b0ea012$var$s(k), z = null != l ? l : {}, H = z.maxX, I = z.maxY, D = $iSvIT.useCallback(function() {
        var e, t, n, i, r = null !== (t = null === (e = o.current) || void 0 === e ? void 0 : e.clientWidth) && void 0 !== t ? t : 0, a = null !== (i = null === (n = o.current) || void 0 === n ? void 0 : n.clientHeight) && void 0 !== i ? i : 0;
        return P && l ? {
            width: r,
            height: r * (l.maxY / l.maxX)
        } : {
            width: r,
            height: a
        };
    }, [
        o,
        P,
        H,
        I
    ]);
    $iSvIT.useEffect(function() {
        if (L && o.current && i) {
            var e = D(), t = e.width, n = e.height, a = !1;
            if (r) {
                var u = t !== w || n !== p;
                if (f.fitCanvasToArtboardHeight && u && (o.current.style.height = n + "px", a = !0), f.useDevicePixelRatio) {
                    if (u || t * j !== C || n * j !== R) {
                        var s = j * t, l = j * n;
                        r.width = s, r.height = l, r.style.width = t + "px", r.style.height = n + "px", E({
                            width: s,
                            height: l
                        }), a = !0;
                    }
                } else u && (r.width = t, r.height = n, E({
                    width: t,
                    height: n
                }), a = !0);
                y({
                    width: t,
                    height: n
                });
            }
            c && (x || a) && c && c(), x && T(!1);
        }
    }, [
        r,
        o,
        M,
        j,
        D,
        x,
        T,
        R,
        C,
        p,
        w,
        c,
        L,
        P,
        S,
        i
    ]), $iSvIT.useEffect(function() {
        E({
            width: 0,
            height: 0
        });
    }, [
        r
    ]);
}
var $1650107b0b0ea012$var$y, $1650107b0b0ea012$var$g = function() {
    function e() {}
    return e.prototype.observe = function() {}, e.prototype.unobserve = function() {}, e.prototype.disconnect = function() {}, e;
}(), $1650107b0b0ea012$var$m = globalThis.IntersectionObserver || $1650107b0b0ea012$var$g, $1650107b0b0ea012$var$R = function() {
    function e() {
        var e = this;
        this.elementsMap = new Map, this.onObserved = function(t) {
            t.forEach(function(t) {
                var n = e.elementsMap.get(t.target);
                n && n(t);
            });
        }, this.observer = new $1650107b0b0ea012$var$m(this.onObserved);
    }
    return e.prototype.registerCallback = function(e, t) {
        this.observer.observe(e), this.elementsMap.set(e, t);
    }, e.prototype.removeCallback = function(e) {
        this.observer.unobserve(e), this.elementsMap.delete(e);
    }, e;
}(), $1650107b0b0ea012$var$C = function() {
    return $1650107b0b0ea012$var$y || ($1650107b0b0ea012$var$y = new $1650107b0b0ea012$var$R), $1650107b0b0ea012$var$y;
};
function $1650107b0b0ea012$var$E(e) {
    var t = e.setContainerRef, n = e.setCanvasRef, a = e.className, u = void 0 === a ? "" : a, s = e.style, c = e.children, l = $1650107b0b0ea012$var$o(e, [
        "setContainerRef",
        "setCanvasRef",
        "className",
        "style",
        "children"
    ]), f = $1650107b0b0ea012$var$r({
        width: "100%",
        height: "100%"
    }, s);
    return $1650107b0b0ea012$var$i.default.createElement("div", $1650107b0b0ea012$var$r({
        ref: t,
        className: u
    }, !u && {
        style: f
    }), $1650107b0b0ea012$var$i.default.createElement("canvas", $1650107b0b0ea012$var$r({
        ref: n,
        style: {
            verticalAlign: "top",
            width: 0,
            height: 0
        }
    }, l), c));
}
function $1650107b0b0ea012$var$O(n, o) {
    void 0 === o && (o = {});
    var a = $iSvIT.useState(null), u = a[0], c = a[1], l = $iSvIT.useRef(null), f = $iSvIT.useState(null), d = f[0], v = f[1], h = Boolean(n), p = $1650107b0b0ea012$var$b(o), y = $1650107b0b0ea012$var$s(), g = $iSvIT.useCallback(function() {
        if (d) {
            if (d.layout && d.layout.fit === $63e9c72ca9cb1165$exports.Fit.Layout && u) {
                var e = y * d.layout.layoutScaleFactor;
                d.devicePixelRatioUsed = y, d.artboardWidth = (null == u ? void 0 : u.width) / e, d.artboardHeight = (null == u ? void 0 : u.height) / e;
            }
            d.startRendering(), d.resizeToCanvas();
        }
    }, [
        d,
        y
    ]);
    $1650107b0b0ea012$var$w({
        riveLoaded: !!d,
        canvasElem: u,
        containerRef: l,
        options: p,
        onCanvasHasResized: g,
        artboardBounds: null == d ? void 0 : d.bounds
    });
    var m = $iSvIT.useCallback(function(e) {
        null === e && u && (u.height = 0, u.width = 0), c(e);
    }, []);
    $iSvIT.useEffect(function() {
        if (u && n) {
            var e, i = null != d;
            if (null == d) {
                var o = p.useOffscreenRenderer;
                (e = new $63e9c72ca9cb1165$exports.Rive($1650107b0b0ea012$var$r($1650107b0b0ea012$var$r({
                    useOffscreenRenderer: o
                }, n), {
                    canvas: u
                }))).on($63e9c72ca9cb1165$exports.EventType.Load, function() {
                    i = !0, u ? v(e) : e.cleanup();
                });
            }
            return function() {
                i || null == e || e.cleanup();
            };
        }
    }, [
        u,
        h,
        d
    ]);
    var R = $iSvIT.useCallback(function(e) {
        l.current = e;
    }, []), O = {
        observe: $iSvIT.useCallback(function(e, t) {
            $1650107b0b0ea012$var$C().registerCallback(e, t);
        }, []),
        unobserve: $iSvIT.useCallback(function(e) {
            $1650107b0b0ea012$var$C().removeCallback(e);
        }, [])
    }, x = O.observe, T = O.unobserve;
    $iSvIT.useEffect(function() {
        var e, t = !1, n = function() {
            if (u && t) {
                var e = u.getBoundingClientRect();
                e.width > 0 && e.height > 0 && e.top < (window.innerHeight || document.documentElement.clientHeight) && e.bottom > 0 && e.left < (window.innerWidth || document.documentElement.clientWidth) && e.right > 0 && (null == d || d.startRendering(), t = !1);
            }
        };
        return u && !1 !== p.shouldUseIntersectionObserver && x(u, function(i) {
            i.isIntersecting ? d && d.startRendering() : d && d.stopRendering(), t = !i.isIntersecting, clearTimeout(e), i.isIntersecting || 0 !== i.boundingClientRect.width || (e = setTimeout(n, 10));
        }), function() {
            u && T(u);
        };
    }, [
        x,
        T,
        d,
        u,
        p.shouldUseIntersectionObserver
    ]), $iSvIT.useEffect(function() {
        return function() {
            d && (d.cleanup(), v(null));
        };
    }, [
        d,
        u
    ]);
    var P = null == n ? void 0 : n.animations;
    $iSvIT.useEffect(function() {
        d && P && (d.isPlaying ? (d.stop(d.animationNames), d.play(P)) : d.isPaused && (d.stop(d.animationNames), d.pause(P)));
    }, [
        P,
        d
    ]);
    var L = $iSvIT.useCallback(function(e) {
        return $1650107b0b0ea012$var$i.default.createElement($1650107b0b0ea012$var$E, $1650107b0b0ea012$var$r({
            setContainerRef: R,
            setCanvasRef: m
        }, e));
    }, [
        m,
        R
    ]);
    return {
        canvas: u,
        container: l.current,
        setCanvasRef: m,
        setContainerRef: R,
        rive: d,
        RiveComponent: L
    };
}
$1650107b0b0ea012$exports.default = function(e) {
    var t = e.src, n = e.artboard, a = e.animations, u = e.stateMachines, s = e.layout, c = e.useOffscreenRenderer, l = void 0 === c || c, f = e.shouldDisableRiveListeners, d = void 0 !== f && f, v = e.shouldResizeCanvasToContainer, h = void 0 === v || v, p = e.automaticallyHandleEvents, b = void 0 !== p && p, w = e.children, y = $1650107b0b0ea012$var$o(e, [
        "src",
        "artboard",
        "animations",
        "stateMachines",
        "layout",
        "useOffscreenRenderer",
        "shouldDisableRiveListeners",
        "shouldResizeCanvasToContainer",
        "automaticallyHandleEvents",
        "children"
    ]), g = $1650107b0b0ea012$var$O({
        src: t,
        artboard: n,
        animations: a,
        layout: s,
        stateMachines: u,
        autoplay: !0,
        shouldDisableRiveListeners: d,
        automaticallyHandleEvents: b
    }, {
        useOffscreenRenderer: l,
        shouldResizeCanvasToContainer: h
    }).RiveComponent;
    return $1650107b0b0ea012$var$i.default.createElement(g, $1650107b0b0ea012$var$r({}, y), w);
}, $1650107b0b0ea012$exports.useResizeCanvas = $1650107b0b0ea012$var$w, $1650107b0b0ea012$exports.useRive = $1650107b0b0ea012$var$O, $1650107b0b0ea012$exports.useRiveFile = function(n) {
    var i = this, r = $iSvIT.useState(null), o = r[0], s = r[1], c = $iSvIT.useState("idle"), l = c[0], f = c[1];
    return $iSvIT.useEffect(function() {
        var e = null;
        return $1650107b0b0ea012$var$a(i, void 0, void 0, function() {
            return $1650107b0b0ea012$var$u(this, function(i) {
                try {
                    f("loading"), (e = new $63e9c72ca9cb1165$exports.RiveFile(n)).init(), e.on($63e9c72ca9cb1165$exports.EventType.Load, function() {
                        null == e || e.getInstance(), s(e), f("success");
                    }), e.on($63e9c72ca9cb1165$exports.EventType.LoadError, function() {
                        f("failed");
                    }), s(e);
                } catch (e) {
                    console.error(e), f("failed");
                }
                return [
                    2
                ];
            });
        }), function() {
            null == e || e.cleanup();
        };
    }, [
        n.src,
        n.buffer
    ]), {
        riveFile: o,
        status: l
    };
}, $1650107b0b0ea012$exports.useStateMachineInput = function(n, i, r, o) {
    var a = $iSvIT.useState(null), u = a[0], s = a[1];
    return $iSvIT.useEffect(function() {
        function e() {
            if (n && i && r || s(null), n && i && r) {
                var e = n.stateMachineInputs(i);
                if (e) {
                    var t = e.find(function(e) {
                        return e.name === r;
                    });
                    void 0 !== o && t && (t.value = o), s(t || null);
                }
            } else s(null);
        }
        e(), n && n.on($63e9c72ca9cb1165$exports.EventType.Load, function() {
            e();
        });
    }, [
        n
    ]), u;
}, Object.keys($63e9c72ca9cb1165$exports).forEach(function(e) {
    "default" === e || $1650107b0b0ea012$exports.hasOwnProperty(e) || Object.defineProperty($1650107b0b0ea012$exports, e, {
        enumerable: !0,
        get: function() {
            return $63e9c72ca9cb1165$exports[e];
        }
    });
});


const $8271b71211bdcf7e$export$e77ffad62888ca02 = ({ width: width, height: height, loadingElement: loadingElement = null, ...rest })=>{
    const [isLoading, setIsLoading] = (0, $iSvIT.useState)(true);
    const { RiveComponent: RiveComponent } = (0, $1650107b0b0ea012$exports.useRive)({
        ...rest,
        autoplay: true,
        onLoad: ()=>{
            setIsLoading(false);
        }
    });
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        style: {
            width: width,
            height: height
        },
        children: [
            isLoading && loadingElement,
            /*#__PURE__*/ (0, $loA2J.jsx)(RiveComponent, {})
        ]
    });
};


const $59184874f58c8d40$export$17e92986bb7fd081 = ({ src: src })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $8271b71211bdcf7e$export$e77ffad62888ca02), {
        src: src,
        height: "350px",
        width: "600px"
    });


const $4284aae4a2979d0b$export$be46c88e95f4d491 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/50miwctfdsfv7srn8cq3q65fs047esh8.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $a50c4190d6ebf296$export$ee89167f055f4c61 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/d8up4bbs57m1i281l14ghllan3w30h63.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $89b4ca154406c5fa$export$6955bcca4cd3539f = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/38q0358viy2mcd14c3tvx2s437634r53.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $fee92033bb0a5241$export$92e2b3062e1f1116 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/j2os26c533drhayq0qx6e705h5vh328b.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $bc6fa5eb23cfe838$export$2ada22cf838dec7d = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/e75324xa0uc61rda6s00p210neq15e57.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $614cc86ac355fb97$export$8929951f37b9096e = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8y40h4qsl1sj30uv326g405fh6rch485.riv"
    });



var $loA2J = parcelRequire("loA2J");

const $be53a9e58ae49265$export$164e79f76a2d9d14 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $59184874f58c8d40$export$17e92986bb7fd081), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/28nn7y04kk8jwnv45hr78c2d8o53510t.riv"
    });



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iSvIT = parcelRequire("iSvIT");
"use client";
var $478af79ecb9fb55b$var$__defProp = Object.defineProperty;
var $478af79ecb9fb55b$var$__defNormalProp = (obj, key, value)=>key in obj ? $478af79ecb9fb55b$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $478af79ecb9fb55b$var$__publicField = (obj, key, value)=>{
    $478af79ecb9fb55b$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $478af79ecb9fb55b$var$observerMap = /* @__PURE__ */ new Map();
var $478af79ecb9fb55b$var$RootIds = /* @__PURE__ */ new WeakMap();
var $478af79ecb9fb55b$var$rootId = 0;
var $478af79ecb9fb55b$var$unsupportedValue = void 0;
function $478af79ecb9fb55b$export$2ef3a60ee1f37bec(inView) {
    $478af79ecb9fb55b$var$unsupportedValue = inView;
}
function $478af79ecb9fb55b$var$getRootId(root) {
    if (!root) return "0";
    if ($478af79ecb9fb55b$var$RootIds.has(root)) return $478af79ecb9fb55b$var$RootIds.get(root);
    $478af79ecb9fb55b$var$rootId += 1;
    $478af79ecb9fb55b$var$RootIds.set(root, $478af79ecb9fb55b$var$rootId.toString());
    return $478af79ecb9fb55b$var$RootIds.get(root);
}
function $478af79ecb9fb55b$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $478af79ecb9fb55b$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $478af79ecb9fb55b$var$createObserver(options) {
    const id = $478af79ecb9fb55b$var$optionsToId(options);
    let instance = $478af79ecb9fb55b$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $478af79ecb9fb55b$var$observerMap.set(id, instance);
    }
    return instance;
}
function $478af79ecb9fb55b$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $478af79ecb9fb55b$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $478af79ecb9fb55b$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $478af79ecb9fb55b$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $478af79ecb9fb55b$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $478af79ecb9fb55b$export$a62107ca74432f44 = class extends $iSvIT.Component {
    constructor(props){
        super(props);
        $478af79ecb9fb55b$var$__publicField(this, "node", null);
        $478af79ecb9fb55b$var$__publicField(this, "_unobserveCb", null);
        $478af79ecb9fb55b$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $478af79ecb9fb55b$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$478af79ecb9fb55b$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $478af79ecb9fb55b$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $iSvIT.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $478af79ecb9fb55b$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $iSvIT.useState(null);
    const callback = $iSvIT.useRef();
    const [state, setState] = $iSvIT.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $iSvIT.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $478af79ecb9fb55b$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $iSvIT.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}





var $4LHd8 = parcelRequire("4LHd8");
// This is a magic string replaced by rollup
const $92e96da755c37185$export$31499a9cd224b78c = "9.15.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $1c9e486be4080d26$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $2d413ae5a393071a$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $2d413ae5a393071a$export$c8bfa33e4e8ae492((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1));
    return 0, $1c9e486be4080d26$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $2d413ae5a393071a$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $92e96da755c37185$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $92e96da755c37185$export$31499a9cd224b78c] = __SENTRY__[0, $92e96da755c37185$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $2d413ae5a393071a$export$7e223ec222791509(name, creator, obj = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $92e96da755c37185$export$31499a9cd224b78c] = __SENTRY__[0, $92e96da755c37185$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



// eslint-disable-next-line @typescript-eslint/unbound-method
const $64d77030f0d405c5$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$e6127cc7fe7395c3(wat) {
    switch($64d77030f0d405c5$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $64d77030f0d405c5$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$var$isBuiltin(wat, className) {
    return $64d77030f0d405c5$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$9f9636d330b71954(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$ef9e2056653f0c8e(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$12e869b2a583f783(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$844ec244b1367d54(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$c3825b437cbdea5c(wat) {
    return wat === null || $64d77030f0d405c5$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$53b83ca8eaab0383(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $64d77030f0d405c5$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $64d77030f0d405c5$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$49841c62b9eff15(wat) {
    return $64d77030f0d405c5$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $64d77030f0d405c5$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$bc2894c7158efbac(wat) {
    return $64d77030f0d405c5$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $64d77030f0d405c5$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $64d77030f0d405c5$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $64d77030f0d405c5$export$49034edbe6b62415(request, Request);
}



const $b3dd2fa7e571301f$var$WINDOW = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
const $b3dd2fa7e571301f$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b3dd2fa7e571301f$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b3dd2fa7e571301f$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b3dd2fa7e571301f$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b3dd2fa7e571301f$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($b3dd2fa7e571301f$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $64d77030f0d405c5$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $b3dd2fa7e571301f$export$1cfafeee2987818b() {
    try {
        return $b3dd2fa7e571301f$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b3dd2fa7e571301f$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b3dd2fa7e571301f$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b377edbb1b3d818a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






/** Prefix for logging strings */ const $398c2530c60234a2$var$PREFIX = "Sentry Logger ";
const $398c2530c60234a2$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $398c2530c60234a2$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $398c2530c60234a2$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($398c2530c60234a2$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $398c2530c60234a2$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $398c2530c60234a2$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $b377edbb1b3d818a$export$16a28057038b10ef) $398c2530c60234a2$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $398c2530c60234a2$export$cda52e2a8927a2ca(()=>{
                (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).console[name](`${$398c2530c60234a2$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $398c2530c60234a2$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $398c2530c60234a2$export$af88d00dbe7f521 = (0, $2d413ae5a393071a$export$7e223ec222791509)("logger", $398c2530c60234a2$var$makeLogger);



/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $e0c4ed16d3d4a5dd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $e0c4ed16d3d4a5dd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $e0c4ed16d3d4a5dd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $64d77030f0d405c5$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $e0c4ed16d3d4a5dd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $64d77030f0d405c5$export$844ec244b1367d54)(value)) return false;
    if ((0, $64d77030f0d405c5$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $64d77030f0d405c5$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$e0c4ed16d3d4a5dd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $ac73fe157e02a9a2$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $ac73fe157e02a9a2$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $ac73fe157e02a9a2$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $ac73fe157e02a9a2$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $ac73fe157e02a9a2$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $ac73fe157e02a9a2$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $ac73fe157e02a9a2$export$62ff257738bf57f5(value) {
    if ((0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$ac73fe157e02a9a2$var$getOwnProperties(value)
    };
    else if ((0, $64d77030f0d405c5$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $ac73fe157e02a9a2$var$serializeEventTarget(value.target),
            currentTarget: $ac73fe157e02a9a2$var$serializeEventTarget(value.currentTarget),
            ...$ac73fe157e02a9a2$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $64d77030f0d405c5$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $ac73fe157e02a9a2$var$serializeEventTarget(target) {
    try {
        return (0, $64d77030f0d405c5$export$45a5e7f76e0caa8d)(target) ? (0, $b3dd2fa7e571301f$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $ac73fe157e02a9a2$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $ac73fe157e02a9a2$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($ac73fe157e02a9a2$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $e0c4ed16d3d4a5dd$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $e0c4ed16d3d4a5dd$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $ac73fe157e02a9a2$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $ac73fe157e02a9a2$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $ac73fe157e02a9a2$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($ac73fe157e02a9a2$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($ac73fe157e02a9a2$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $ac73fe157e02a9a2$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $ac73fe157e02a9a2$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $ac73fe157e02a9a2$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $64d77030f0d405c5$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




function $5985640674d52865$var$getCrypto() {
    const gbl = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $5985640674d52865$export$19f53698e68b2496(crypto = $5985640674d52865$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $5985640674d52865$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $5985640674d52865$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $5985640674d52865$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $5985640674d52865$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $5985640674d52865$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $5985640674d52865$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $5985640674d52865$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $5985640674d52865$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $5985640674d52865$export$d364f2020ab30578(input) {
    const match = input.match($5985640674d52865$var$SEMVER_REGEXP) || [];
    const major = $5985640674d52865$var$_parseInt(match[1]);
    const minor = $5985640674d52865$var$_parseInt(match[2]);
    const patch = $5985640674d52865$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $5985640674d52865$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $e0c4ed16d3d4a5dd$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $e0c4ed16d3d4a5dd$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $e0c4ed16d3d4a5dd$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $5985640674d52865$export$6de4ffac6a2f1098(exception) {
    if ($5985640674d52865$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $5985640674d52865$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



const $741f7992b965e3b0$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $741f7992b965e3b0$export$7740643b9eeaf0c4() {
    return Date.now() / $741f7992b965e3b0$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $741f7992b965e3b0$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $741f7992b965e3b0$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $741f7992b965e3b0$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $741f7992b965e3b0$export$ee52dced521e3e18 = $741f7992b965e3b0$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $741f7992b965e3b0$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $741f7992b965e3b0$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $741f7992b965e3b0$export$baf075a948ffc0bf() {
    if (!$741f7992b965e3b0$var$cachedTimeOrigin) $741f7992b965e3b0$var$cachedTimeOrigin = $741f7992b965e3b0$var$getBrowserTimeOrigin();
    return $741f7992b965e3b0$var$cachedTimeOrigin[0];
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $8796e43ab70f6728$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $5985640674d52865$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$8796e43ab70f6728$var$sessionToJSON(session)
    };
    if (context) $8796e43ab70f6728$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $8796e43ab70f6728$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $5985640674d52865$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $8796e43ab70f6728$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $8796e43ab70f6728$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $8796e43ab70f6728$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}


/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $50154ff82f8353c6$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $50154ff82f8353c6$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $1783cf6bafc3a162$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1783cf6bafc3a162$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(scope, $1783cf6bafc3a162$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$1783cf6bafc3a162$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $1783cf6bafc3a162$export$91f063ebb8eff307(scope) {
    return scope[$1783cf6bafc3a162$var$SCOPE_SPAN_FIELD];
}






/**
 * Generate a random, valid trace ID.
 */ function $f63023dba381e7e1$export$dc6d7ea554bcce10() {
    return (0, $5985640674d52865$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $f63023dba381e7e1$export$295213bc4d0c54ad() {
    return (0, $5985640674d52865$export$19f53698e68b2496)().substring(16);
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $debd2a81681f2cab$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $debd2a81681f2cab$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $debd2a81681f2cab$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(newScope, (0, $1783cf6bafc3a162$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $8796e43ab70f6728$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $debd2a81681f2cab$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $64d77030f0d405c5$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $debd2a81681f2cab$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $741f7992b965e3b0$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $e0c4ed16d3d4a5dd$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $1783cf6bafc3a162$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $50154ff82f8353c6$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $5985640674d52865$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $5985640674d52865$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $5985640674d52865$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $90b60b03c1038d12$export$6f1b9191db9c4d5() {
    return (0, $2d413ae5a393071a$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $debd2a81681f2cab$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $90b60b03c1038d12$export$de9862929b76bf57() {
    return (0, $2d413ae5a393071a$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $debd2a81681f2cab$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $67e6fe5c47a24771$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $debd2a81681f2cab$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $debd2a81681f2cab$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $67e6fe5c47a24771$var$getAsyncContextStack() {
    const registry = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const sentry = (0, $2d413ae5a393071a$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $67e6fe5c47a24771$export$d36ec451f120cfba((0, $90b60b03c1038d12$export$6f1b9191db9c4d5)(), (0, $90b60b03c1038d12$export$de9862929b76bf57)());
}
function $67e6fe5c47a24771$var$withScope(callback) {
    return $67e6fe5c47a24771$var$getAsyncContextStack().withScope(callback);
}
function $67e6fe5c47a24771$var$withSetScope(scope, callback) {
    const stack = $67e6fe5c47a24771$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $67e6fe5c47a24771$var$withIsolationScope(callback) {
    return $67e6fe5c47a24771$var$getAsyncContextStack().withScope(()=>{
        return callback($67e6fe5c47a24771$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $67e6fe5c47a24771$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $67e6fe5c47a24771$var$withIsolationScope,
        withScope: $67e6fe5c47a24771$var$withScope,
        withSetScope: $67e6fe5c47a24771$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $67e6fe5c47a24771$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$67e6fe5c47a24771$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$67e6fe5c47a24771$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $38813f7928b7d824$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const sentry = (0, $2d413ae5a393071a$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $38813f7928b7d824$export$f639b0c2752203be(carrier) {
    const sentry = (0, $2d413ae5a393071a$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $67e6fe5c47a24771$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $35358b2c9a559011$export$c7be4b0125a10cba() {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $35358b2c9a559011$export$68f3af03034c9e90() {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $35358b2c9a559011$export$aa55d5ab8e05984f() {
    return (0, $2d413ae5a393071a$export$7e223ec222791509)("globalScope", ()=>new (0, $debd2a81681f2cab$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $35358b2c9a559011$export$ec58d9285c204497(...rest) {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $35358b2c9a559011$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $35358b2c9a559011$export$6bb76d6eba7e258c() {
    return $35358b2c9a559011$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $35358b2c9a559011$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $f63023dba381e7e1$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


function $8550c3151a99e1cc$export$823d4c94f9c66ca0(experimentName, value) {
    // Sentry FeatureFlagsIntegration only supports boolean flags (for now).
    if (typeof value !== "boolean") return;
    const flagsIntegration = $35358b2c9a559011$export$6bb76d6eba7e258c()?.getIntegrationByName("FeatureFlags");
    if (flagsIntegration) try {
        flagsIntegration.addFeatureFlag(experimentName, value);
    } catch (e) {
        // Something went wrong, check your DSN and/or integrations
        console.error(e);
    }
}


function $ed1e206bdea25d53$export$3331b5930c252bb2(featureFlag) {
    const { featureFlagName: featureFlagName } = featureFlag;
    const value = (0, $4LHd8.default).checkGate(featureFlagName);
    (0, $8550c3151a99e1cc$export$823d4c94f9c66ca0)(featureFlagName, value);
    return value;
}


const $206c60391d5bfbc4$export$e62953d023125748 = {
    wacSalesLeadsCtaGlobalNav: {
        featureFlagName: "wac_sales_leads_cta_global_nav",
        metadata: {
            description: "Flag to enable UI button to contact sales if user is determined to be an SMB inbound sales lead",
            expectedReleaseDate: "02/28/2025",
            expectedRuntime: "12 weeks",
            context: {
                urls: [
                    "/",
                    "/software/jira",
                    "/software/confluence"
                ]
            }
        }
    },
    salesWidgetBxpWebPlatform: {
        featureFlagName: "sales_widget_bxp_web_platform",
        metadata: {
            description: "Flag to enable sales widget on BXP web platform",
            expectedReleaseDate: "10/03/2026",
            expectedRuntime: "Indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    salesWidgetBxpWebPlatformDeveloper: {
        featureFlagName: "sales_widget_bxp_web_platform_dev",
        metadata: {
            description: "Flag to enable sales widget on BXP web platform for developers",
            expectedReleaseDate: "10/03/2026",
            expectedRuntime: "Indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    preloadAtlaskitStyles: {
        featureFlagName: "token-style-wrapper-wac-web-gate",
        metadata: {
            description: "Flag to enable optimized Atlas token head loading.",
            expectedReleaseDate: "08/30/2025",
            expectedRuntime: "Can be cleaned up after monitored in PROD and ensure no issues",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    castleIoEvent: {
        featureFlagName: "wac-castle-io-event",
        metadata: {
            description: "Feature gate to control Castle.io custom event sending",
            expectedReleaseDate: "2026-06-30",
            expectedRuntime: "4 weeks",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    uniformPersonalizationEnabled: {
        featureFlagName: "uniform_personalization_component_enabled",
        metadata: {
            description: "Feature gate to enable personalization of components in Uniform. Returns default when disabled",
            expectedReleaseDate: "8/15/2025",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    jsmPaidLpAuxiaIntegration: {
        featureFlagName: "jsm-paid-lp-auxia-integration",
        metadata: {
            description: "Feature gate to roll out Auxia integration for JSM Paid LP Anchor pages",
            expectedReleaseDate: "9/22/2025",
            expectedRuntime: "12 weeks",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    signupVisualAlignmentFeedback: {
        featureFlagName: "signup-visual-alignment-feedback",
        metadata: {
            description: "Design feedback to align appearance of signup components",
            expectedReleaseDate: "6/4/2026",
            expectedRuntime: "3 weeks",
            context: {
                urls: [
                    "/software/confluence",
                    "/software/jira",
                    "/software/jira/service-management",
                    "/try/cloud/signup",
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    spiceTemplateImgStyleFix: {
        featureFlagName: "spice-template-img-style-fix",
        metadata: {
            description: "Fix template illustration overflow on the Template Choice screen by preserving the image's intrinsic aspect ratio",
            expectedReleaseDate: "6/23/2026",
            expectedRuntime: "1 week",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    sxpFastshiftPortalEnableRollUpStatus: {
        featureFlagName: "sxp-fastshift-portal-enable-roll-up-status",
        metadata: {
            description: "Feature gate to enable roll up status in FastShift Portal",
            expectedReleaseDate: "01/31/2026",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/fastshift/**"
                ]
            }
        }
    },
    sxpFastshiftPortalUnder1kCustomerExperience: {
        featureFlagName: "sxp-fastshift-portal-under-1k-experience",
        metadata: {
            description: "Feature gate to enable a tailored experience for small customers with under 1k paid seats",
            expectedReleaseDate: "01/22/2026",
            expectedRuntime: "3 weeks",
            context: {
                urls: [
                    "/fastshift/**"
                ]
            }
        }
    },
    sxpFastshiftEnableGeneralAccess: {
        featureFlagName: "sxp-fastshift-enable-general-access",
        metadata: {
            description: "Feature gate to enable general access to FastShift Portal",
            expectedReleaseDate: "30/06/2026",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/fastshift/**"
                ]
            }
        }
    },
    sxpFastshiftPortalEnableMarathonRunbooks: {
        featureFlagName: "sxp-fastshift-portal-enable-marathon-runbooks",
        metadata: {
            description: "Feature gate for FastShift portal to enable marathon runbooks",
            expectedReleaseDate: "30/06/2026",
            expectedRuntime: "2 month",
            context: {
                urls: [
                    "/fastshift/**"
                ]
            }
        }
    },
    sxpFastshiftPortalMarathonRunbooksPhase2: {
        featureFlagName: "sxp-fastshift-portal-marathon-runbooks-phase2",
        metadata: {
            description: "Feature gate for FastShift portal to enable marathon runbook step actions",
            expectedReleaseDate: "30/06/2026",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/fastshift/**"
                ]
            }
        }
    },
    gwp1304AddIntercomToJpdProductTour: {
        featureFlagName: "gwp-1304-add-intercom-to-jpd-product-tour",
        metadata: {
            description: "Add Intercom to JPD Product Tour",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/jira/product-discovery"
                ]
            }
        }
    },
    jiraOnboardingAiMadlibV2: {
        featureFlagName: "jira-onboarding-ai-madlib-v2-gate",
        metadata: {
            description: "Feature gate for AI Madlib V2 iteration in Jira onboarding",
            expectedReleaseDate: "2/27/2026",
            expectedRuntime: "30 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    provisioningFunnelUfoImprovements: {
        featureFlagName: "provisioning-funnel-ufo-improvements",
        metadata: {
            description: "Feature gate to enable provisioningFunnelUfoImprovements for UFO tracking in provisioning UI",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    cfindOutroAnimationBeforeRedirect: {
        featureFlagName: "cfind_outro_animation_before_redirect",
        metadata: {
            description: "Defers the redirect until the outro animation and final message play on the Confluence provisioning page",
            expectedReleaseDate: "07/15/2026",
            expectedRuntime: "30 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    wacWebExtendedCachingOfBfldrAssetsForJsw: {
        featureFlagName: "wac-web-extended-caching-of-bfldr-assets-for-jsw",
        metadata: {
            description: "WAC Web Extended Caching of Bfldr Assets for JSW",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    wacWebTrafficAAGate: {
        featureFlagName: "wac-web-traffic-aa-gate",
        metadata: {
            description: "WAC Web Traffic AA Gate",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    wacWebLoggedInTrafficAAGate: {
        featureFlagName: "wac-web_a-a_gate_for_loggedin_users",
        metadata: {
            description: "WAC Web LoggedIn Traffic AA Gate",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp5158FocusProductAdd: {
        featureFlagName: "gwp-5158-focus-product-add",
        metadata: {
            description: "Adding Focus to global nav",
            expectedReleaseDate: "April 9, 2025",
            expectedRuntime: "Forever (gate to be used for Team launch, will be cleaned up)",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp4947Team25HeroHomepageTakeover: {
        featureFlagName: "gwp-4947-team-25-hero-homepage-takeover",
        metadata: {
            description: "Team 25 hero takeover",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: [
                    "/",
                    "/enterprise"
                ]
            }
        }
    },
    gwp5046TurboBannerEnterprise: {
        featureFlagName: "gwp-5046-turbo-banner-enterprise",
        metadata: {
            description: "Turbo racing banner",
            expectedReleaseDate: "February",
            expectedRuntime: "Until April 8th",
            context: {
                urls: [
                    "/enterprise"
                ]
            }
        }
    },
    gwp5381AddIntercomWidgetToUniform: {
        featureFlagName: "gwp-5381-add-intercom-widget-to-uniform",
        metadata: {
            description: "Add Intercom widget to Uniform Page component",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/customers/*"
                ]
            }
        }
    },
    wacProductsLoomURL: {
        featureFlagName: "wac-products-loom-url",
        metadata: {
            description: "Change loom URL",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    asyncArchitectureSiteCreation: {
        featureFlagName: "async-architecture-frontend-gate",
        metadata: {
            description: "Feature gate to enable async architecture site creation for JSM n2n",
            expectedReleaseDate: "03/31/2025",
            expectedRuntime: "",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    spice1602ActivateProductResponseMetadata: {
        featureFlagName: "spice_1602_activate_product_response_metadata",
        metadata: {
            description: "Feature gate to read product metadata (e.g. edition) from the activate-product response and forward it to the confirmation page",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    edgeLambdaCacheProductDiscovery: {
        featureFlagName: "edge-lambda-cache-product-discovery",
        metadata: {
            description: "Flag to enable edge lambda caching for product discovery page",
            expectedReleaseDate: "03/18/2025",
            expectedRuntime: "Indefinite",
            context: {
                urls: [
                    "/software/jira/product-discovery",
                    "/",
                    "/customers*",
                    "/software/confluence/templates*",
                    "/work-management*",
                    "/itsm*",
                    "/incident-management*",
                    "/agile*"
                ]
            }
        }
    },
    edgeCacheSourcetreapp: {
        featureFlagName: "edge-cache-sourcetreapp",
        metadata: {
            description: "Flag to enable edge caching for all sourcetreeapp.com domain paths",
            expectedReleaseDate: "05/05/2026",
            expectedRuntime: "Indefinite",
            context: {
                urls: [
                    // eslint-disable-next-line local/warn-wildcard-usage-eslint
                    "sourcetreeapp.com/**"
                ]
            }
        }
    },
    wacWebUseEsModulesScripts: {
        featureFlagName: "wac-web-use-esmodules-scripts",
        metadata: {
            description: "Use Esmodules script",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    signupPopBackBtn: {
        featureFlagName: "signup-pop-back-btn",
        metadata: {
            description: "Show back button in post order signup site picker page",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/buy/cloud/site-setup"
                ]
            }
        }
    },
    gwp5548Team25DuringEventBanner: {
        featureFlagName: "gwp-5548-team-25-during-event-banner",
        metadata: {
            description: "Team 25 During event banner",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "1 day",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp5421CollectionsHero: {
        featureFlagName: "gwp-5421-collections-hero",
        metadata: {
            description: "Collections hero takeover on homepage",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp8165EnterpriseContactServiceCollection: {
        featureFlagName: "gwp-8165-enterprise-contact-service-collection",
        metadata: {
            description: "Feature gate to enable Service Collection option in enterprise contact forms",
            expectedReleaseDate: "10/01/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    gwp9286ConfluenceAnchorUpdates: {
        featureFlagName: "gwp-9286-confluence-anchor-updates",
        metadata: {
            description: "Confluence Anchor Updates",
            expectedReleaseDate: "12/19/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/confluence"
                ]
            }
        }
    },
    gwp9287JSMAnchorUpdates: {
        featureFlagName: "gwp-9287-jsm-anchor-updates",
        metadata: {
            description: "JSM Anchor Updates",
            expectedReleaseDate: "12/15/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    gwp9473JSWAnchorUpdates: {
        featureFlagName: "gwp-9473-jsw-anchor-updates",
        metadata: {
            description: "Jira Anchor Updates",
            expectedReleaseDate: "12/19/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    voltronGupsDataInAnalyticsWrapper: {
        featureFlagName: "voltron-gups-data-in-analytics-wrapper",
        metadata: {
            description: "Add gups storage and retrieval of utm data in analytics wrapper",
            expectedReleaseDate: "4/11/2025",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp737EnableIntercomChatHome: {
        featureFlagName: "gwp-737-enable-intercom-chat-home",
        metadata: {
            description: "Triggers boot intercom on home page",
            expectedReleaseDate: "",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp737EnableIntercomChatJsw: {
        featureFlagName: "gwp-737-enable-intercom-chat-jsw",
        metadata: {
            description: "Triggers boot intercom on Jira Software pages",
            expectedReleaseDate: "",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    wacLiftedBannerSticky: {
        featureFlagName: "wac-lifted-banner-sticky",
        metadata: {
            description: "Lifted banner sticky",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/",
                    "/software/confluence",
                    "/jira",
                    "/software/jira/service-management",
                    "/software/jira"
                ]
            }
        }
    },
    gwp5682RemoveRovoFromPricingForm: {
        featureFlagName: "gwp-5682-remove-rovo-from-pricing-form",
        metadata: {
            description: "Remove rovo from pricing form",
            expectedReleaseDate: "4/9/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    gwp6474RemoveOpsgenieContactSalesForm: {
        featureFlagName: "gwp-6474-remove-opsgenie-contact-sales-form",
        metadata: {
            description: "Remove rovo from contact form",
            expectedReleaseDate: "06/04/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    gwp8238BannerAnnouncement: {
        featureFlagName: "gwp-8238-banner-announcement",
        metadata: {
            description: "GWP-8238 Banner announcement for homepage and Jira software page",
            expectedReleaseDate: "9/18/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/",
                    "/software/jira"
                ]
            }
        }
    },
    gwp6473JpdPremiumBanner: {
        featureFlagName: "gwp-5810-nonprofit-pricing-changes",
        metadata: {
            description: "JPD Premium Announcement",
            expectedReleaseDate: "6/03/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira/product-discovery",
                    "/software/jira/product-discovery/pricing"
                ]
            }
        }
    },
    wacUipButterBarJsmGate: {
        featureFlagName: "wac-uip-butter-bar-jsm-gate",
        metadata: {
            description: "Forrester banner",
            expectedReleaseDate: "unknown",
            expectedRuntime: "unknown",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    gwp6701ForresterBanner: {
        featureFlagName: "gwp-6701-forrester-banner",
        metadata: {
            description: "Forrester banner",
            expectedReleaseDate: "6/16/2025",
            expectedRuntime: "Two weeks",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    gwp6524OpsgenieSignupEol: {
        featureFlagName: "gwp-6524-opsgenie-signup-eol",
        metadata: {
            description: "Opsgenie EOL",
            expectedReleaseDate: "6/04/2025",
            expectedRuntime: "Operational Flag",
            context: {
                urls: [
                    "/try/cloud/signup?bundle=jira-service-desk"
                ]
            }
        }
    },
    confluencePricingPageWaeMigration: {
        featureFlagName: "confluence_pricing_wae_migration_exp_rerun_gate_1",
        metadata: {
            description: "migration of Confluence pricing page to WAE, rerun",
            expectedReleaseDate: "03/06/2026",
            expectedRuntime: "80 days",
            context: {
                urls: [
                    "/software/confluence/pricing"
                ]
            }
        }
    },
    gwp7856PricingPagesWaeMigrationM3: {
        featureFlagName: "gwp-7856-pricing-pages-wae-migration-m3-1",
        metadata: {
            description: "migration of pricing pages to WAE, milestone-3",
            expectedReleaseDate: "ongoing",
            expectedRuntime: "",
            context: {
                urls: [
                    "/collections/teamwork/pricing",
                    "/collections/strategy/pricing",
                    "/software/guard/pricing",
                    "/software/compass/pricing",
                    "/software/loom/pricing"
                ]
            }
        }
    },
    routingTable: {
        featureFlagName: "wac-routing-table-gate",
        metadata: {
            description: "Uses wac-routing-table to identify Uniform-supported pages in WACs",
            expectedReleaseDate: "8/07/2025",
            expectedRuntime: "",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    wacCompositionCutover: {
        featureFlagName: "wac_composition_cutover",
        metadata: {
            description: "Switches composition fetches from wac-uniform-promotion CloudFront to wac-management-service",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    wacRegenerationCutover: {
        featureFlagName: "wac_regeneration_cutover",
        metadata: {
            description: "Switches regeneration SQS messages from wac-uniform-promotion to wac-management-service",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    wacRoutingTableCutover: {
        featureFlagName: "wac_routing_table_cutover",
        metadata: {
            description: "Switches routing table fetches from wac-routing-table CloudFront to wac-management-service",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp7617JiraShortTermAiInfusionGate: {
        featureFlagName: "gwp-7617-jira-short-term-ai-infusion-gate",
        metadata: {
            description: "Short term updates to Jira page",
            expectedReleaseDate: "8/21/2025",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    gwp7999JiraFeatures: {
        featureFlagName: "gwp-7999-jira-features",
        metadata: {
            description: "Feature gate to conditionally hide tabs section on Jira features page",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/software/jira/features"
                ]
            }
        }
    },
    gwp8240ButterbarGuard: {
        featureFlagName: "gwp-8240-butterbar-guard",
        metadata: {
            description: "Guard workshop banner",
            expectedReleaseDate: "11/11/2025",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/guard/pricing"
                ]
            }
        }
    },
    enableBitbucketCcpProvisioningWac: {
        featureFlagName: "enable_bitbucket_ccp_provisioning_wac",
        metadata: {
            description: "Enable Bitbucket CCP provisioning in WAC",
            expectedReleaseDate: "9/08/2025",
            expectedRuntime: "5 weeks",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    bxpActivationCmtCcpIntegration: {
        featureFlagName: "bxp-activation-cmt-ccp-integration",
        metadata: {
            description: "Enable CMT signups through CCP by sending migrationId in /activate-product",
            expectedReleaseDate: "05/06/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    accountCreationTermsAndConditions: {
        featureFlagName: "account-creation-terms-and-conditions",
        metadata: {
            description: "show terms and conditions by default in AccountCreation",
            expectedReleaseDate: "2026-06-08",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/confluence",
                    "/software/jira",
                    "/software/jira/service-management",
                    "/try/cloud/signup"
                ]
            }
        }
    },
    bxpActivationBitbucketCmtCcpIntegration: {
        featureFlagName: "bxp-activation-bitbucket-cmt-ccp-integration",
        metadata: {
            description: "Force edition=premium for Bitbucket CMT signups so /activate-product receives the correct edition",
            expectedReleaseDate: "05/14/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    gwp7546ConfluencePricingCtaCtaUrlSource: {
        featureFlagName: "gwp-7546-confluence-pricing-cta-ctaurlsource",
        metadata: {
            description: "Change the Confluence pricing ctaUrlSource to productPlans",
            expectedReleaseDate: "8/22/2025",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/confluence/pricing"
                ]
            }
        }
    },
    gwp7518NavIconUpdates: {
        featureFlagName: "gwp-7518-nav-icon-updates",
        metadata: {
            description: "Update icons on global nav",
            expectedReleaseDate: "8/29/2025",
            expectedRuntime: "",
            context: {
                urls: [
                    "/*"
                ]
            }
        }
    },
    gwp7711Team25BannerPhase3: {
        featureFlagName: "gwp-7711-team-25-banner-phase-3",
        metadata: {
            description: "Team 25 banner phase 3",
            expectedReleaseDate: "9/1/2025",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp7456JpdStateOfProductBanner: {
        featureFlagName: "gwp-7456-jpd-state-of-product-banner",
        metadata: {
            description: "Enable JPD State of Product Banner",
            expectedReleaseDate: "9/3/2025",
            expectedRuntime: "7 days",
            context: {
                urls: [
                    "/software/jira/product-discovery"
                ]
            }
        }
    },
    gwp8038JpdBannerWebinar: {
        featureFlagName: "gwp-8038-jpd-banner-webinar",
        metadata: {
            description: "Enable JPD webinar banner to replace State of Product banner",
            expectedReleaseDate: "9/11/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira/product-discovery"
                ]
            }
        }
    },
    EnableJPDXflowLofiSignup: {
        featureFlagName: "gwp-7564-integrate-jpd-xflow-lofi-signup",
        metadata: {
            description: "Enable JPD Xflow Lofi Signup",
            expectedReleaseDate: "8/28/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    enableRovoDevBetaSignup: {
        featureFlagName: "rovo_dev_beta_signup_backup",
        metadata: {
            description: "Enable Rovo Dev Beta Signup",
            expectedReleaseDate: "09/19/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp7603UniformPageDwellTime: {
        featureFlagName: "gwp-7603-uniform-page-dwell-time",
        metadata: {
            description: "Enable Uniform Page Dwell Time Tracking",
            expectedReleaseDate: "9/04/2025",
            expectedRuntime: "1 week",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    dxpMigrationJiraProductTourGate: {
        featureFlagName: "dxp-migration-jira-product-tour-gate",
        metadata: {
            description: "Enable Jira Product Tour Migration for Team 25 EU",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira",
                    "/jira"
                ]
            }
        }
    },
    dxpMigrationConfluenceProductTourGate: {
        featureFlagName: "dxp-migration-confluence-product-tour-gate",
        metadata: {
            description: "Enable Confluence Product Tour Migration for Team 25 EU",
            expectedReleaseDate: "10/07/2025",
            expectedRuntime: "Forever (gate to be used for launch, will be cleaned up after)",
            context: {
                urls: [
                    "software/confluence"
                ]
            }
        }
    },
    gwpRovoProductTourStudioTab: {
        featureFlagName: "gwp-rovo-product-tour-studio-tab",
        metadata: {
            description: "Update copy and CTA for Rovo Product Tour Studio Tab on Oct 8",
            expectedReleaseDate: "10/08/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "software/rovo"
                ]
            }
        }
    },
    gwp7823AnimationOverlayOption: {
        featureFlagName: "gwp-7823-animation-overlay-option",
        metadata: {
            description: "Feature gate for animation overlay option",
            expectedReleaseDate: "10/03/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/rovo"
                ]
            }
        }
    },
    gwp8279CollectionHeroIntl: {
        featureFlagName: "gwp-8279-collection-hero-intl",
        metadata: {
            description: "Enables hardcoded translation strings in the collection-pricing-hero component",
            expectedReleaseDate: "10/06/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/collection/service/pricing",
                    "/collection/teamwork/pricing",
                    "/collection/strategy/pricing"
                ]
            }
        }
    },
    wacSearchIndexV3_2: {
        featureFlagName: "wac_search_index_v3-2",
        metadata: {
            description: "Feature gate for search index v3-2",
            expectedReleaseDate: "10/23/2025",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp8510AustinGrandPrixBanner: {
        featureFlagName: "gwp-5810-austin-grand-prix",
        metadata: {
            description: "Austin Grand Prix banner on homepage",
            expectedReleaseDate: "10/14/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp8577ServiceCollectionBanners: {
        featureFlagName: "gwp-8577-service-collection-banners",
        metadata: {
            description: "Feature gate for service collection banners",
            expectedReleaseDate: "11/03/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    gwp9038JdpAIWebinarBanner: {
        featureFlagName: "gwp-9038-jdp-ai-webinar-banner",
        metadata: {
            description: "Feature gate for GWP-9038",
            expectedReleaseDate: "11/17/2025",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira/product-discovery"
                ]
            }
        }
    },
    gwp9000NewRovoVideoHero: {
        featureFlagName: "gwp-9000-new-rovo-video-hero",
        metadata: {
            description: "showing rovo video",
            expectedReleaseDate: "2025-11-19",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/software/rovo"
                ]
            }
        }
    },
    gwp9226Team26Banner: {
        featureFlagName: "gwp-9226-team-26-banner",
        metadata: {
            description: "Team 26 Banners on WAC Homepage",
            expectedReleaseDate: "2026-01-05",
            expectedRuntime: "1 month",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp9034WacPricingCcpStaging: {
        featureFlagName: "gwp-9034-wac-pricing-ccp-staging",
        metadata: {
            description: "When enabled, WAC fetches its pricing data from the ccp_staging space in Contentful > Product Catalog",
            expectedReleaseDate: "11/20/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/*/pricing",
                    "/collections/*/pricing"
                ]
            }
        }
    },
    gwp9214HomepageScreenshots: {
        featureFlagName: "gwp-9214-homepage-screenshots",
        metadata: {
            description: "Updated screenshots for homepage scroll pinned sections",
            expectedReleaseDate: "12/03/2025",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    enableCsmAjLogo: {
        featureFlagName: "enable-csm-aj-logo",
        metadata: {
            description: "Enable Customer Service Management logo on CSM variant in JSM Anchor Journey",
            expectedReleaseDate: "12/08/2025",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    jiraPricingWaeMigrationExperimentRerunGate: {
        featureFlagName: "jira_pricing_wae_migration_exper_rerun_exp_1_gate",
        metadata: {
            description: "Rerun of migration of Jira pricing page to WAE",
            expectedReleaseDate: "03/06/2026",
            expectedRuntime: "43 days",
            context: {
                urls: [
                    "/software/jira/pricing"
                ]
            }
        }
    },
    waePricingDisableComparePlansEnhancer: {
        featureFlagName: "wae-pricing-disable-compare-plans-enhancer",
        metadata: {
            description: "Toggle ON to DISABLE server-side fetching of product catalog data for WAE pricing pages",
            expectedReleaseDate: "03/25/2026",
            expectedRuntime: "indefinte",
            context: {
                urls: [
                    "/software/*/pricing"
                ]
            }
        }
    },
    waePricingStripExcessData: {
        featureFlagName: "wae-pricing-strip-excess-data",
        metadata: {
            description: "Enable this for WAE enhancers to strip excess data from pricing page SSR payloads",
            expectedReleaseDate: "04/05/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/*/pricing"
                ]
            }
        }
    },
    waePricingGql: {
        featureFlagName: "gwp-11369-wae-pricing-gql",
        metadata: {
            description: "Enables GQL fetching on WAE pricing",
            expectedReleaseDate: "05/08/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/*/pricing",
                    "/collections/*/pricing"
                ]
            }
        }
    },
    wacIcLogin: {
        featureFlagName: "wac-ic-login",
        metadata: {
            description: "Feature gate to add application query parameter 'wac--ic' to enable IC logins",
            expectedReleaseDate: "01/12/2026",
            expectedRuntime: "04/01/2026",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    includeEntitlementIdCheckInCohortsGate: {
        featureFlagName: "astro_786_entitlement_id_check_in_cohort",
        metadata: {
            description: "Gate to introduce the check for entitlemnt Id and billing source system",
            expectedReleaseDate: "01/08/2026",
            expectedRuntime: "14 days",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    gwp9763BackupRestoreContactForm: {
        featureFlagName: "gwp-9763-backup-restore-contact-form",
        metadata: {
            description: "Feature gate to enable Backup and Restore product option",
            expectedReleaseDate: "01/22/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    jfind2379RtpAvatarsBugFix: {
        featureFlagName: "jfind-2379-rtp-avatars-bug-fix",
        metadata: {
            description: "Allow all sites to be fetched when number of user's existing sites is not exactly 1.",
            expectedReleaseDate: "03/23/2026",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    gwp9608AdditionalSandboxContactForm: {
        featureFlagName: "gwp-9608-enterprise-contact-additional-sandbox",
        metadata: {
            description: "Feature gate to enable Additional Sandbox product options in enterprise contact forms",
            expectedReleaseDate: "01/25/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    gwp11663AtlassianIsolatedCloudContactForm: {
        featureFlagName: "gwp-11663-atlassian-isolated-cloud-contact-form",
        metadata: {
            description: "Feature gate to enable Atlassian Isolated Cloud in enterprise contact forms",
            expectedReleaseDate: "06/01/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/enterprise/contact"
                ]
            }
        }
    },
    gwp9365TeamOnTourSydneyBanner: {
        featureFlagName: "gwp-9365-team-on-tour-sydney-homepage-banner-au-nz",
        metadata: {
            description: "Team on Tour Sydney Banner on WAC Homepage",
            expectedReleaseDate: "2026-02-04",
            expectedRuntime: "33 days",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp9191Team26HeroHomepageTakeover: {
        featureFlagName: "gwp-9191-team-26-hero-homepage-takeover",
        metadata: {
            description: "Team 26 hero takeover",
            expectedReleaseDate: "02/02/2026",
            expectedRuntime: "04/18/2026",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp10221RovoProductTourFixScrollAnimation: {
        featureFlagName: "gwp-10221-rovo-product-tour-fix-scroll-animation",
        metadata: {
            description: "Updated headline, reordered rovo section on homepage - converted from experiment to feature gate",
            expectedReleaseDate: "02/17/2025",
            expectedRuntime: "3 days",
            context: {
                urls: [
                    "/software/rovo"
                ]
            }
        }
    },
    rovoDevSignupFlowsCommerceDisclaimer: {
        featureFlagName: "rovo-dev-signup-flows-commerce-disclaimer",
        metadata: {
            description: "Update to the Rovo Dev sign-up flow legal text",
            expectedReleaseDate: "01/27/2026",
            expectedRuntime: "14 days",
            context: {
                urls: [
                    "/try/cloud/signup?bundle=devai"
                ]
            }
        }
    },
    gwp10027NonprofitPricingPage: {
        featureFlagName: "gwp-10027-nonprofit-pricing-page",
        metadata: {
            description: "Nonprofit pricing page changes FY26Q3",
            expectedReleaseDate: "02/25/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/teams/nonprofits/discount-pricing"
                ]
            }
        }
    },
    gwp10416DisableNonOperationalAnalyticsGateUip: {
        featureFlagName: "gwp-10416-disable-non-operational-analytics-uip",
        metadata: {
            description: "Feature gate to only enable operational analytics events in atl-analytics wrapper when users are opted out of performance cookies",
            expectedReleaseDate: "03/02/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp11138ServcoPricingIncreaseMaxUsers: {
        featureFlagName: "gwp-11138-servco-pricing-increase-max-users",
        metadata: {
            description: "Increase ServCo pricing max user limit from 20,000 to 100,000",
            expectedReleaseDate: "3/24/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/collections/service/pricing"
                ]
            }
        }
    },
    gwp11118UsageBasedPricingCalculator: {
        featureFlagName: "gwp-11118-usage-based-pricing-calculator",
        metadata: {
            description: "Feature gate to enable the Usage-Based Pricing Calculator",
            expectedReleaseDate: "05/05/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/usage-based-pricing/calculator"
                ]
            }
        }
    },
    gwp11139Confluence250kPricingUpdate: {
        featureFlagName: "gwp-11139-confluence-250k-pricing-update",
        metadata: {
            description: "Update Confluence pricing to show price for up to 250k users",
            expectedReleaseDate: "04/14/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/confluence/pricing",
                    "/licensing/confluence"
                ]
            }
        }
    },
    mlRecommendationSkeletonXflow: {
        featureFlagName: "mlrecommendation-skeleton-gate",
        metadata: {
            description: "Feature gate to enable the ML recommendation skeleton",
            expectedReleaseDate: "04/07/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    voltronMultiTouchAnalytics: {
        featureFlagName: "voltron-multi-touch-analytics-gate",
        metadata: {
            description: "Feature gate to enable voltron multi-touch tracking",
            expectedReleaseDate: "04/15/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    wacRefreshTeam26Gate: {
        featureFlagName: "wac_refresh_q4fy26_gate",
        metadata: {
            description: "Feature Gate to enable WAC Refresh",
            expectedReleaseDate: "05/05/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/",
                    "/software/jira",
                    "/software/confluence",
                    "/software/rovo",
                    "/collections/teamwork"
                ]
            }
        }
    },
    passLocaleInSignupContext: {
        featureFlagName: "pass_locale_in_signup_context",
        metadata: {
            description: "Feature gate to pass the WAC page locale into the signupContext field of signup API requests",
            expectedReleaseDate: "04/22/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    gwp10907JpdEnterpriseSku: {
        featureFlagName: "gwp-10907-jpd-enterprise-sku",
        metadata: {
            description: "Feature gate to roll out the new JPD Enterprise SKU column on the Jira Product Discovery pricing page",
            expectedReleaseDate: "05/06/2026",
            expectedRuntime: "12 weeks",
            context: {
                urls: [
                    "/software/jira/product-discovery/pricing"
                ]
            }
        }
    },
    gwpGlobalNavHoverVClick: {
        featureFlagName: "gwp-global-nav-hover-v-click",
        metadata: {
            description: "Toggle nav expand interaction model (click vs hover)",
            expectedReleaseDate: "05/06/2026",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    team26Keynote: {
        featureFlagName: "wac_team26_keynote",
        metadata: {
            description: "Feature Gate to enable Team 26 changes timed with Keynote",
            expectedReleaseDate: "05/06/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/",
                    "/software/confluence",
                    "/software/rovo",
                    "/enterprise/contact"
                ]
            }
        }
    },
    wacTeam26PromoteOnDemandBanner: {
        featureFlagName: "wac_team_26_promote_on_demand_banner",
        metadata: {
            description: "Post-Team On-Demand Banner",
            expectedReleaseDate: "2026-05-11",
            expectedRuntime: "",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp1072SunsetCompass: {
        featureFlagName: "gwp-10723-compass-gate",
        metadata: {
            description: "Feature gate to sunset Compass",
            expectedReleaseDate: "05/13/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    gwp9582ProductCollection: {
        featureFlagName: "gwp-9582-product-collection",
        metadata: {
            description: "Show product collections",
            expectedReleaseDate: "05/13/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    cmkRedirectExistingEntitlement: {
        featureFlagName: "cmk_redirect_existing_entitlement",
        metadata: {
            description: "Redirect users with existing CMK entitlement to CMK support page during post-order provisioning",
            expectedReleaseDate: "2026-06-15",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/buy/cloud/post-order-provisioning",
                    "/buy/cloud/org-setup"
                ]
            }
        }
    },
    jiraWacActivationChecklistGate: {
        featureFlagName: "wac-jira-activation-checklist-gate",
        metadata: {
            description: "Ops kill switch + ring-0 rollout lever in front of the WAC product activation checklist placement on /software/jira. Mounted directly below the user's most-recently-accessed Jira site card.",
            expectedReleaseDate: "2026-06-01",
            expectedRuntime: "indefinite (kill switch)",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    jiraWacActivationChecklistAaGate: {
        featureFlagName: "wac-jira-activation-checklist-aa-gate",
        metadata: {
            description: "Rollout lever for the WAC Jira activation checklist AA exposure validation on /software/jira. Does not render the checklist UI.",
            expectedReleaseDate: "2026-06-01",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    wacUnifiedTemplatesNavigation: {
        featureFlagName: "wac-unified-templates-navigation",
        metadata: {
            description: "Navigation to /templates",
            expectedReleaseDate: "2026-06-29",
            expectedRuntime: "2 weeks",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    wacDwellTimeTracking: {
        featureFlagName: "wac_dwell-time_tracking",
        metadata: {
            description: "Master switch for the dwell-time tracking system (DwellTimeContextProvider). When off, no tracker mounts and no analytics fire regardless of consumer opt-in.",
            expectedReleaseDate: "2026-06-26",
            expectedRuntime: "indefinite",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    team26EuAnnouncementBanner: {
        featureFlagName: "team26-eu-announcement-banner",
        metadata: {
            description: "Feature gate for banner announcing TEAM 26 EU event",
            expectedReleaseDate: "2026-06-16",
            expectedRuntime: "6 weeks",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    jiraFY27H1HoldoutExclusion: {
        featureFlagName: "spice-jira-fy27h1-holdout-exclusion",
        metadata: {
            description: "Feature gate to control firing the jiraFY27H1HoldoutExclusion event that populates the TAP trait for Jira FY27H1 agentic-template holdout exclusion.",
            expectedReleaseDate: "2026-07-31",
            expectedRuntime: "Indefinite",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    }
};


/**
 * We need this polyfill in order to generate uuids.
 *
 * The uuid package depends on crypto.getRandomValues
 * https://github.com/uuidjs/uuid#getrandomvalues-not-supported
 *
 * ...but the crypto-browserify package that we're using does not include this method:
 * https://github.com/browserify/crypto-browserify
 */ const $50ddae1ef20437fb$export$5c073f9c8bff1ad3 = ()=>{
    /**
   * TODO: I tried calling this immediately without the wrapper function, but it was causing
   * 'crypto is not defined' errors when the module is loaded. For some reason, the
   * crypto polyfill seems to be loaded _after_ this module so we have to do this lazily.
   */ if (typeof crypto.getRandomValues === "undefined") Object.defineProperty(crypto, "getRandomValues", {
        // @ts-ignore
        value: (arr)=>crypto.randomBytes(arr.length)
    });
};




var $6a55625674322039$export$2e2bcd8739ae039 = function(channel) {
    return function(payload) {
        return function(createAnalyticsEvent) {
            var consumerEvent = createAnalyticsEvent(payload);
            var clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };
    };
};










// src/patterns.json
var $e6956bfb052b4929$var$patterns_default = [
    " daum[ /]",
    " deusu/",
    "(?:^|[^g])news(?!sapphire)",
    "(?<! (?:channel/|google/))google(?!(app|/google| pixel))",
    "(?<! cu)bots?(?:\\b|_)",
    "(?<!(?:lib))http",
    "(?<!cam)scan",
    "24x7",
    "@[a-z][\\w-]+\\.",
    "\\(\\)",
    "\\.com\\b",
    "\\b\\w+\\.ai",
    "\\bmanus-user/",
    "\\bort/",
    "\\bperl\\b",
    "\\bplaywright\\b",
    "\\bsecurityheaders\\b",
    "\\bselenium\\b",
    "\\btime/",
    "\\|",
    "^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)",
    "^[\\w\\-]+/[\\w]+$",
    "^[^ ]{50,}$",
    "^\\d+\\b",
    "^\\W",
    "^\\w*search\\b",
    "^\\w+/[\\w\\(\\)]*$",
    "^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$",
    "^active",
    "^ad muncher",
    "^amaya",
    "^apache/",
    "^avsdevicesdk/",
    "^azure",
    "^biglotron",
    "^bot",
    "^bw/",
    "^clamav[ /]",
    "^client/",
    "^cobweb/",
    "^custom",
    "^ddg[_-]android",
    "^discourse",
    "^dispatch/\\d",
    "^downcast/",
    "^duckduckgo",
    "^email",
    "^facebook",
    "^getright/",
    "^gozilla/",
    "^hobbit",
    "^hotzonu",
    "^hwcdn/",
    "^igetter/",
    "^jeode/",
    "^jetty/",
    "^jigsaw",
    "^microsoft bits",
    "^movabletype",
    "^mozilla/\\d\\.\\d\\s[\\w\\.-]+$",
    "^mozilla/\\d\\.\\d\\s\\((?:compatible;)?(?:\\s?[\\w\\d-.]+\\/\\d+\\.\\d+)?\\)$",
    "^navermailapp",
    "^netsurf",
    "^offline",
    "^openai/",
    "^owler",
    "^php",
    "^postman",
    "^python",
    "^rank",
    "^read",
    "^reed",
    "^rest",
    "^rss",
    "^snapchat",
    "^space bison",
    "^svn",
    "^swcd ",
    "^taringa",
    "^thumbor/",
    "^track",
    "^w3c",
    "^webbandit/",
    "^webcopier",
    "^wget",
    "^whatsapp",
    "^wordpress",
    "^xenu link sleuth",
    "^yahoo",
    "^yandex",
    "^zdm/\\d",
    "^zoom marketplace/",
    "advisor",
    "agent\\b",
    "analyzer",
    "archive",
    "ask jeeves/teoma",
    "audit",
    "bit\\.ly/",
    "bluecoat drtr",
    "browsex",
    "burpcollaborator",
    "capture",
    "catch",
    "check\\b",
    "checker",
    "chrome-lighthouse",
    "chromeframe",
    "classifier",
    "cloudflare",
    "convertify",
    "crawl",
    "cypress/",
    "dareboost",
    "datanyze",
    "dejaclick",
    "detect",
    "dmbrowser",
    "download",
    "exaleadcloudview",
    "feed",
    "fetcher",
    "firephp",
    "functionize",
    "grab",
    "headless",
    "httrack",
    "hubspot marketing grader",
    "ibisbrowser",
    "infrawatch",
    "insight",
    "inspect",
    "iplabel",
    "java(?!;)",
    "library",
    "linkcheck",
    "mail\\.ru/",
    "manager",
    "measure",
    "monitor\\b",
    "neustar wpm",
    "node\\b",
    "nutch",
    "offbyone",
    "onetrust",
    "optimize",
    "pageburst",
    "pagespeed",
    "parser",
    "phantomjs",
    "pingdom",
    "powermarks",
    "preview",
    "proxy",
    "ptst[ /]\\d",
    "retriever",
    "rexx;",
    "rigor",
    "rss\\b",
    "scrape",
    "server",
    "sogou",
    "sparkler/",
    "speedcurve",
    "spider",
    "splash",
    "statuscake",
    "supercleaner",
    "synapse",
    "synthetic",
    "tools",
    "torrent",
    "transcoder",
    "url",
    "validator",
    "virtuoso",
    "wappalyzer",
    "webglance",
    "webkit2png",
    "whatcms/",
    "xtate/"
];
// src/pattern.ts
var $e6956bfb052b4929$var$fullPattern = " daum[ /]| deusu/|(?:^|[^g])news(?!sapphire)|(?<! (?:channel/|google/))google(?!(app|/google| pixel))|(?<! cu)bots?(?:\\b|_)|(?<!(?:lib))http|(?<!cam)scan|24x7|@[a-z][\\w-]+\\.|\\(\\)|\\.com\\b|\\b\\w+\\.ai|\\bmanus-user/|\\bort/|\\bperl\\b|\\bplaywright\\b|\\bsecurityheaders\\b|\\bselenium\\b|\\btime/|\\||^[\\w \\.\\-\\(?:\\):%]+(?:/v?\\d+(?:\\.\\d+)?(?:\\.\\d{1,10})*?)?(?:,|$)|^[\\w\\-]+/[\\w]+$|^[^ ]{50,}$|^\\d+\\b|^\\W|^\\w*search\\b|^\\w+/[\\w\\(\\)]*$|^\\w+/\\d\\.\\d\\s\\([\\w@]+\\)$|^active|^ad muncher|^amaya|^apache/|^avsdevicesdk/|^azure|^biglotron|^bot|^bw/|^clamav[ /]|^client/|^cobweb/|^custom|^ddg[_-]android|^discourse|^dispatch/\\d|^downcast/|^duckduckgo|^email|^facebook|^getright/|^gozilla/|^hobbit|^hotzonu|^hwcdn/|^igetter/|^jeode/|^jetty/|^jigsaw|^microsoft bits|^movabletype|^mozilla/\\d\\.\\d\\s[\\w\\.-]+$|^mozilla/\\d\\.\\d\\s\\((?:compatible;)?(?:\\s?[\\w\\d-.]+\\/\\d+\\.\\d+)?\\)$|^navermailapp|^netsurf|^offline|^openai/|^owler|^php|^postman|^python|^rank|^read|^reed|^rest|^rss|^snapchat|^space bison|^svn|^swcd |^taringa|^thumbor/|^track|^w3c|^webbandit/|^webcopier|^wget|^whatsapp|^wordpress|^xenu link sleuth|^yahoo|^yandex|^zdm/\\d|^zoom marketplace/|advisor|agent\\b|analyzer|archive|ask jeeves/teoma|audit|bit\\.ly/|bluecoat drtr|browsex|burpcollaborator|capture|catch|check\\b|checker|chrome-lighthouse|chromeframe|classifier|cloudflare|convertify|crawl|cypress/|dareboost|datanyze|dejaclick|detect|dmbrowser|download|exaleadcloudview|feed|fetcher|firephp|functionize|grab|headless|httrack|hubspot marketing grader|ibisbrowser|infrawatch|insight|inspect|iplabel|java(?!;)|library|linkcheck|mail\\.ru/|manager|measure|monitor\\b|neustar wpm|node\\b|nutch|offbyone|onetrust|optimize|pageburst|pagespeed|parser|phantomjs|pingdom|powermarks|preview|proxy|ptst[ /]\\d|retriever|rexx;|rigor|rss\\b|scrape|server|sogou|sparkler/|speedcurve|spider|splash|statuscake|supercleaner|synapse|synthetic|tools|torrent|transcoder|url|validator|virtuoso|wappalyzer|webglance|webkit2png|whatcms/|xtate/";
// src/index.ts
var $e6956bfb052b4929$var$naivePattern = /bot|crawl|http|lighthouse|scan|search|spider/i;
var $e6956bfb052b4929$var$pattern;
function $e6956bfb052b4929$export$2adb6bbc893073f4() {
    if ($e6956bfb052b4929$var$pattern instanceof RegExp) return $e6956bfb052b4929$var$pattern;
    try {
        $e6956bfb052b4929$var$pattern = new RegExp($e6956bfb052b4929$var$fullPattern, "i");
    } catch (error) {
        $e6956bfb052b4929$var$pattern = $e6956bfb052b4929$var$naivePattern;
    }
    return $e6956bfb052b4929$var$pattern;
}
var $e6956bfb052b4929$var$isNonEmptyString = (value)=>typeof value === "string" && value !== "";
var $e6956bfb052b4929$export$8837f4fc672e936d = $e6956bfb052b4929$var$patterns_default;
function $e6956bfb052b4929$export$353239a0a95facc4(userAgent) {
    return $e6956bfb052b4929$var$isNonEmptyString(userAgent) && $e6956bfb052b4929$export$2adb6bbc893073f4().test(userAgent);
}
var $e6956bfb052b4929$export$45b7009f916562f6 = (userAgent)=>$e6956bfb052b4929$var$isNonEmptyString(userAgent) && $e6956bfb052b4929$var$naivePattern.test(userAgent);
var $e6956bfb052b4929$export$310558728bbed3b4 = (customPattern)=>(userAgent)=>$e6956bfb052b4929$var$isNonEmptyString(userAgent) && customPattern.test(userAgent);
var $e6956bfb052b4929$export$cdec6abc0f81ec40 = (list2)=>{
    const pattern2 = new RegExp(list2.join("|"), "i");
    return (userAgent)=>$e6956bfb052b4929$var$isNonEmptyString(userAgent) && pattern2.test(userAgent);
};
var $e6956bfb052b4929$export$22f77009018b89bb = (userAgent)=>{
    var _a, _b;
    return (_b = (_a = userAgent == null ? void 0 : userAgent.match($e6956bfb052b4929$export$2adb6bbc893073f4())) == null ? void 0 : _a[0]) != null ? _b : null;
};
var $e6956bfb052b4929$export$d417bbbb5748c4c6 = (userAgent)=>$e6956bfb052b4929$export$8837f4fc672e936d.map((part)=>{
        var _a;
        return (_a = userAgent == null ? void 0 : userAgent.match(new RegExp(part, "i"))) == null ? void 0 : _a[0];
    }).filter($e6956bfb052b4929$var$isNonEmptyString);
var $e6956bfb052b4929$export$126fbb46d867761c = (userAgent)=>{
    var _a;
    return userAgent ? (_a = $e6956bfb052b4929$export$8837f4fc672e936d.find((pattern2)=>new RegExp(pattern2, "i").test(userAgent))) != null ? _a : null : null;
};
var $e6956bfb052b4929$export$6ad01fc2047d6909 = (userAgent)=>userAgent ? $e6956bfb052b4929$export$8837f4fc672e936d.filter((pattern2)=>new RegExp(pattern2, "i").test(userAgent)) : [];









/**
 * Internal module for initializing Snowplow and making Snowplow-specific event calls. Public init functions can be found in Initializer module
 * @module Gtm
 */ 


/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $6699f20558f1dc05$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $6699f20558f1dc05$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $6699f20558f1dc05$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $741f7992b965e3b0$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $9f8bd953fbcf4578$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;



const $af185f7d1bf09c29$export$849dbeeeda01ae98 = "production";







/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $61dce522664ed8d7$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($61dce522664ed8d7$var$States || ($61dce522664ed8d7$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $61dce522664ed8d7$export$1fda8aa4d135f8aa(value) {
    return new $61dce522664ed8d7$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $61dce522664ed8d7$export$78e43115b553f358(reason) {
    return new $61dce522664ed8d7$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $61dce522664ed8d7$export$6f292d4960313241 {
    constructor(executor){
        this._state = $61dce522664ed8d7$var$States.PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $61dce522664ed8d7$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $61dce522664ed8d7$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $61dce522664ed8d7$var$States.PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $61dce522664ed8d7$var$States.RESOLVED) handler[1](this._value);
            if (this._state === $61dce522664ed8d7$var$States.REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $61dce522664ed8d7$var$States.PENDING) return;
            if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($61dce522664ed8d7$var$States.RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($61dce522664ed8d7$var$States.REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $daa6c48e0bc4c791$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $61dce522664ed8d7$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && processor.id && result === null && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(result)) result.then((final)=>$daa6c48e0bc4c791$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $daa6c48e0bc4c791$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}




let $9a352af85cd40930$var$parsedStackResults;
let $9a352af85cd40930$var$lastKeysCount;
let $9a352af85cd40930$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 */ function $9a352af85cd40930$export$e069fee9c632ed00(stackParser) {
    const debugIdMap = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return {};
    const debugIdKeys = Object.keys(debugIdMap);
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($9a352af85cd40930$var$cachedFilenameDebugIds && debugIdKeys.length === $9a352af85cd40930$var$lastKeysCount) return $9a352af85cd40930$var$cachedFilenameDebugIds;
    $9a352af85cd40930$var$lastKeysCount = debugIdKeys.length;
    // Build a map of filename -> debug_id.
    $9a352af85cd40930$var$cachedFilenameDebugIds = debugIdKeys.reduce((acc, stackKey)=>{
        if (!$9a352af85cd40930$var$parsedStackResults) $9a352af85cd40930$var$parsedStackResults = {};
        const result = $9a352af85cd40930$var$parsedStackResults[stackKey];
        if (result) acc[result[0]] = result[1];
        else {
            const parsedStack = stackParser(stackKey);
            for(let i = parsedStack.length - 1; i >= 0; i--){
                const stackFrame = parsedStack[i];
                const filename = stackFrame?.filename;
                const debugId = debugIdMap[stackKey];
                if (filename && debugId) {
                    acc[filename] = debugId;
                    $9a352af85cd40930$var$parsedStackResults[stackKey] = [
                        filename,
                        debugId
                    ];
                    break;
                }
            }
        }
        return acc;
    }, {});
    return $9a352af85cd40930$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $9a352af85cd40930$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $9a352af85cd40930$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths)if (path && filenameDebugIdMap[path]) images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[path]
    });
    return images;
}





const $79681426e6433cce$var$STACKTRACE_FRAME_LIMIT = 50;
const $79681426e6433cce$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $79681426e6433cce$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $79681426e6433cce$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $79681426e6433cce$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $79681426e6433cce$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($79681426e6433cce$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $79681426e6433cce$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $79681426e6433cce$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $79681426e6433cce$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $79681426e6433cce$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $79681426e6433cce$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($79681426e6433cce$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($79681426e6433cce$var$STRIP_FRAME_REGEXP.test($79681426e6433cce$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($79681426e6433cce$var$STRIP_FRAME_REGEXP.test($79681426e6433cce$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $79681426e6433cce$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $79681426e6433cce$var$getLastStackFrame(localStack).filename,
            function: frame.function || $79681426e6433cce$export$27c7e15d453fc0ac
        }));
}
function $79681426e6433cce$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $79681426e6433cce$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $79681426e6433cce$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $79681426e6433cce$var$defaultFunctionName;
        return fn.name || $79681426e6433cce$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $79681426e6433cce$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $79681426e6433cce$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e493a5d50143afb5$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $e493a5d50143afb5$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $e493a5d50143afb5$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $e493a5d50143afb5$export$a3295358bff77e(object, depth);
    if ($e493a5d50143afb5$var$jsonSize(normalized) > maxSize) return $e493a5d50143afb5$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $e493a5d50143afb5$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $e493a5d50143afb5$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $e493a5d50143afb5$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $e493a5d50143afb5$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $ac73fe157e02a9a2$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $e493a5d50143afb5$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $e493a5d50143afb5$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $64d77030f0d405c5$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $64d77030f0d405c5$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $79681426e6433cce$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $e493a5d50143afb5$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $e493a5d50143afb5$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $e493a5d50143afb5$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e493a5d50143afb5$var$jsonSize(value) {
    return $e493a5d50143afb5$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $e493a5d50143afb5$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $e493a5d50143afb5$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}






/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $8f43a3b4d13a578f$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $8f43a3b4d13a578f$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $8f43a3b4d13a578f$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $8f43a3b4d13a578f$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $8f43a3b4d13a578f$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $8f43a3b4d13a578f$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $8f43a3b4d13a578f$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $8f43a3b4d13a578f$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $8f43a3b4d13a578f$export$1efec95406bbe327 = "sentry.profile_id";
const $8f43a3b4d13a578f$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $8f43a3b4d13a578f$export$b016f89ac1066ec = "cache.hit";
const $8f43a3b4d13a578f$export$3110e4c3f4386399 = "cache.key";
const $8f43a3b4d13a578f$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $8f43a3b4d13a578f$export$be7a251980e7e946 = "http.request.method";
const $8f43a3b4d13a578f$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $8f43a3b4d13a578f$export$ff77b5fd5b2d627b = "sentry.link.type";



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $1487c3c693f88da4$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $35358b2c9a559011$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $1487c3c693f88da4$export$5008da00b1b6dee6 = $1487c3c693f88da4$export$1f70765132c3c225;






const $d1cbe31bea560316$export$136e25984ba4a383 = 0;
const $d1cbe31bea560316$export$58f7963109c806fc = 1;
const $d1cbe31bea560316$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $d1cbe31bea560316$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $d1cbe31bea560316$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $d1cbe31bea560316$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $d1cbe31bea560316$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $d1cbe31bea560316$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $d1cbe31bea560316$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



const $dbcf9a18634e18af$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $dbcf9a18634e18af$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $dbcf9a18634e18af$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(span, $dbcf9a18634e18af$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(span, $dbcf9a18634e18af$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $dbcf9a18634e18af$export$c08fbc656a245d03(span) {
    return {
        scope: span[$dbcf9a18634e18af$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$dbcf9a18634e18af$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $4d1dc467e3505014$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}





const $690cb49b273612e1$export$6e69537d67fa20f = "sentry-";
const $690cb49b273612e1$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $690cb49b273612e1$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $690cb49b273612e1$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $690cb49b273612e1$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($690cb49b273612e1$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($690cb49b273612e1$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $690cb49b273612e1$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$690cb49b273612e1$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $690cb49b273612e1$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $690cb49b273612e1$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $64d77030f0d405c5$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $690cb49b273612e1$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $690cb49b273612e1$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $690cb49b273612e1$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $690cb49b273612e1$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $690cb49b273612e1$export$bdd844ddb2def819) {
            (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $b6af67124761d26b$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $b6af67124761d26b$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($b6af67124761d26b$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $b6af67124761d26b$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $b6af67124761d26b$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $690cb49b273612e1$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $b6af67124761d26b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $b6af67124761d26b$export$f35d907436da45cf(traceId = (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(), spanId = (0, $f63023dba381e7e1$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $b6af67124761d26b$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $4d1dc467e3505014$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $4d1dc467e3505014$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $1ee319bdc991c767$export$208d5b368507fb8b = 0x0;
const $1ee319bdc991c767$export$eb571cd9b5d98de8 = 0x1;
let $1ee319bdc991c767$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $1ee319bdc991c767$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $1ee319bdc991c767$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $1ee319bdc991c767$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $1ee319bdc991c767$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $dbcf9a18634e18af$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $f63023dba381e7e1$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $1ee319bdc991c767$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $1ee319bdc991c767$export$5caecac1caaf3a71(span);
    return (0, $b6af67124761d26b$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $1ee319bdc991c767$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $1ee319bdc991c767$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $1ee319bdc991c767$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $1ee319bdc991c767$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $1ee319bdc991c767$var$ensureTimestampInSeconds(input.getTime());
    return (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $1ee319bdc991c767$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $1ee319bdc991c767$export$92d8c23565496537(span) {
    if ($1ee319bdc991c767$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($1ee319bdc991c767$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $1ee319bdc991c767$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $1ee319bdc991c767$export$3f7581298f56c6d7(endTime) || undefined,
            status: $1ee319bdc991c767$export$e238a77ea3a8cd66(status),
            op: attributes[0, $8f43a3b4d13a578f$export$1a413bd9a88fdb09],
            origin: attributes[0, $8f43a3b4d13a578f$export$cca8dd30f57f805e],
            links: $1ee319bdc991c767$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $1ee319bdc991c767$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $1ee319bdc991c767$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $1ee319bdc991c767$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $1ee319bdc991c767$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $1ee319bdc991c767$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $d1cbe31bea560316$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $d1cbe31bea560316$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $1ee319bdc991c767$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $1ee319bdc991c767$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $1ee319bdc991c767$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$1ee319bdc991c767$var$ROOT_SPAN_FIELD] || span;
    (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(childSpan, $1ee319bdc991c767$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD]) span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(span, $1ee319bdc991c767$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $1ee319bdc991c767$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD]) span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $1ee319bdc991c767$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($1ee319bdc991c767$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD] ? Array.from(span[$1ee319bdc991c767$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $1ee319bdc991c767$export$c4c6a79b1260ca1b(span) {
    return span[$1ee319bdc991c767$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $1ee319bdc991c767$export$1be426a8e585c83e() {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $1783cf6bafc3a162$export$91f063ebb8eff307)((0, $35358b2c9a559011$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $1ee319bdc991c767$export$d11691ff45a3e535() {
    if (!$1ee319bdc991c767$var$hasShownSpanDropWarning) {
        (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $1ee319bdc991c767$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $1ee319bdc991c767$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $8f43a3b4d13a578f$export$d7a7d984b0791405)]: "custom",
        [(0, $8f43a3b4d13a578f$export$165ce9a229f6f050)]: name
    });
}





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $7d33670619390772$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $7d33670619390772$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(spanWithMaybeDsc, $7d33670619390772$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $7d33670619390772$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $af185f7d1bf09c29$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $7d33670619390772$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $7d33670619390772$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $7d33670619390772$export$a117f995597e25df(span) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $1ee319bdc991c767$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $8f43a3b4d13a578f$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$7d33670619390772$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $690cb49b273612e1$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $7d33670619390772$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $8f43a3b4d13a578f$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $1487c3c693f88da4$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $1ee319bdc991c767$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $dbcf9a18634e18af$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $7d33670619390772$export$95cf936fdacaff7b(span) {
    const dsc = $7d33670619390772$export$a117f995597e25df(span);
    return (0, $690cb49b273612e1$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $52e13e497f018b5e$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $52e13e497f018b5e$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $52e13e497f018b5e$var$applySpanToEvent(event, span);
    $52e13e497f018b5e$var$applyFingerprintToEvent(event, fingerprint);
    $52e13e497f018b5e$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $52e13e497f018b5e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $52e13e497f018b5e$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $52e13e497f018b5e$export$b1a120a2871faa46(data, "extra", extra);
    $52e13e497f018b5e$export$b1a120a2871faa46(data, "tags", tags);
    $52e13e497f018b5e$export$b1a120a2871faa46(data, "user", user);
    $52e13e497f018b5e$export$b1a120a2871faa46(data, "contexts", contexts);
    data.sdkProcessingMetadata = (0, $50154ff82f8353c6$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $52e13e497f018b5e$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $50154ff82f8353c6$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
function $52e13e497f018b5e$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== "transaction") event.transaction = transactionName;
}
function $52e13e497f018b5e$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $52e13e497f018b5e$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $52e13e497f018b5e$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $1ee319bdc991c767$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $7d33670619390772$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $1ee319bdc991c767$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === "transaction") event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $52e13e497f018b5e$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $576b9754bac8cb50$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $5985640674d52865$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $741f7992b965e3b0$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $576b9754bac8cb50$export$d7e04067a6fbc882(prepared, options);
    $576b9754bac8cb50$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit("applyFrameMetadata", event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $576b9754bac8cb50$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $576b9754bac8cb50$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $5985640674d52865$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $35358b2c9a559011$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $52e13e497f018b5e$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $52e13e497f018b5e$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $52e13e497f018b5e$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $daa6c48e0bc4c791$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $576b9754bac8cb50$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $576b9754bac8cb50$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $576b9754bac8cb50$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $af185f7d1bf09c29$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url) request.url = (0, $e0c4ed16d3d4a5dd$export$6a506b36fdea397d)(request.url, maxValueLength);
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $576b9754bac8cb50$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $9a352af85cd40930$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $576b9754bac8cb50$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $576b9754bac8cb50$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $576b9754bac8cb50$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $e493a5d50143afb5$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $e493a5d50143afb5$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $e493a5d50143afb5$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $e493a5d50143afb5$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $e493a5d50143afb5$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $e493a5d50143afb5$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $e493a5d50143afb5$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $576b9754bac8cb50$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $debd2a81681f2cab$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $576b9754bac8cb50$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($576b9754bac8cb50$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($576b9754bac8cb50$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $576b9754bac8cb50$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $debd2a81681f2cab$export$775b6bb06e53a214) || typeof hint === "function";
}
const $576b9754bac8cb50$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "propagationContext"
];
function $576b9754bac8cb50$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$576b9754bac8cb50$var$captureContextKeys.includes(key));
}







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $54ca942ea01c8aa7$export$f5282963edea4a68(exception, hint) {
    return (0, $35358b2c9a559011$export$c7be4b0125a10cba)().captureException(exception, (0, $576b9754bac8cb50$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $54ca942ea01c8aa7$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return (0, $35358b2c9a559011$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $54ca942ea01c8aa7$export$1462b974fdcf6ba2(event, hint) {
    return (0, $35358b2c9a559011$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $54ca942ea01c8aa7$export$2f04de43fe27971a(name, context) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $54ca942ea01c8aa7$export$bb4922da0dd51b92(extras) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $54ca942ea01c8aa7$export$8e8e7789d42ed61d(key, extra) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $54ca942ea01c8aa7$export$74a8fb34822092e6(tags) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $54ca942ea01c8aa7$export$a37d07ee78eb4569(key, value) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $54ca942ea01c8aa7$export$8b6bb3dd62a01be2(user) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $54ca942ea01c8aa7$export$5d4e9fd7fac8e617() {
    return (0, $35358b2c9a559011$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $54ca942ea01c8aa7$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!client) (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $5985640674d52865$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $54ca942ea01c8aa7$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $54ca942ea01c8aa7$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $54ca942ea01c8aa7$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $741f7992b965e3b0$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $35358b2c9a559011$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn("error");
            throw e;
        }
        if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn("ok");
        }, (e)=>{
            finishCheckIn("error");
            throw e;
        });
        else finishCheckIn("ok");
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $54ca942ea01c8aa7$export$4909b86c8034bf73(timeout) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $54ca942ea01c8aa7$export$8360e631d277ea4d(timeout) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $54ca942ea01c8aa7$export$3f95c6f800b78024() {
    return !!(0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $54ca942ea01c8aa7$export$3b029eb57ac4d562() {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $54ca942ea01c8aa7$export$9aac0b9f77928fbf(callback) {
    (0, $35358b2c9a559011$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $54ca942ea01c8aa7$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)();
    const currentScope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $8796e43ab70f6728$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === "ok") (0, $8796e43ab70f6728$export$531818e825e774db)(currentSession, {
        status: "exited"
    });
    $54ca942ea01c8aa7$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $54ca942ea01c8aa7$export$17a5be43989a0bc1() {
    const isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)();
    const currentScope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $8796e43ab70f6728$export$56521d9ba90f62ee)(session);
    $54ca942ea01c8aa7$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $54ca942ea01c8aa7$var$_sendSessionUpdate() {
    const isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)();
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $54ca942ea01c8aa7$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $54ca942ea01c8aa7$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $54ca942ea01c8aa7$var$_sendSessionUpdate();
}



class $d8b8b558d46670b1$export$9ab4d56492766a00 {
    /**
   * Initializes Google Tag Manager
   * @function initialize
   */ // eslint-disable-next-line complexity
    static initialize(writeKey) {
        // Add Sentry breadcrumb for debugging script loading issues
        $6699f20558f1dc05$export$efda9a273d7a036d({
            message: "GTM initialization started",
            data: {
                writeKey: writeKey,
                pathname: window.location.pathname,
                onetrustStatus: window.OnetrustActiveGroups !== undefined ? "ready" : "not ready",
                onetrustActiveGroups: window.OnetrustActiveGroups !== undefined ? window.OnetrustActiveGroups : "window.OnetrustActiveGroups undefined",
                dataLayerExists: !!window["dataLayer"]
            },
            level: "info",
            category: "gtm"
        });
        /* eslint-disable no-restricted-syntax -- GTM init must detect/polyfill raw localStorage for third-party script */ // Polyfill localStorage to prevent third-party script errors
        let isStorageInaccessible = false;
        try {
            if (!window.localStorage || typeof window.localStorage.setItem !== "function") isStorageInaccessible = true;
        } catch (error) {
            isStorageInaccessible = true;
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "localStorage not accessible, installed polyfill",
                data: {
                    error: error instanceof Error ? error.message : String(error)
                },
                level: "warning",
                category: "gtm"
            });
        }
        if (isStorageInaccessible) try {
            window.localStorage = {
                getItem: ()=>null,
                setItem: ()=>{
                /* no-op */ },
                removeItem: ()=>{
                /* no-op */ },
                clear: ()=>{
                /* no-op */ },
                length: 0,
                key: ()=>null
            };
        } catch (error) {
            // In some environments, the localStorage object cannot be reassigned, due to it's descriptor setter being undefined
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "localStorage could not be polyfilled",
                data: {
                    error: error instanceof Error ? error.message : String(error),
                    localStorageDescriptor: JSON.stringify(Object.getOwnPropertyDescriptor(window, "localStorage"))
                },
                level: "warning",
                category: "gtm"
            });
        }
        /* eslint-enable no-restricted-syntax */ const containerId = $d8b8b558d46670b1$export$9ab4d56492766a00.getContainerId(writeKey);
        $6699f20558f1dc05$export$efda9a273d7a036d({
            message: "GTM container ID resolved",
            data: {
                writeKey: writeKey,
                containerId: containerId
            },
            level: "info",
            category: "gtm"
        });
        if (containerId) {
            window["dataLayer"] = window["dataLayer"] || [];
            window["dataLayer"].push({
                "gtm.start": new Date().getTime(),
                "event": "gtm.js"
            });
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "GTM dataLayer initialized",
                data: {
                    containerId: containerId,
                    dataLayerLength: window["dataLayer"].length
                },
                level: "info",
                category: "gtm"
            });
            const firstScript = document.getElementsByTagName("script")[0];
            const gtmScript = document.createElement("script");
            gtmScript.async = true;
            gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + containerId;
            // Add error handling and monitoring for the GTM script
            gtmScript.onerror = (error)=>{
                const errorString = error instanceof Error ? error.toString() : String(error);
                const errorMessage = error instanceof Error ? error.message : String(error);
                $6699f20558f1dc05$export$efda9a273d7a036d({
                    message: "GTM script failed to load",
                    data: {
                        containerId: containerId,
                        src: gtmScript.src,
                        error: errorString
                    },
                    level: "error",
                    category: "gtm"
                });
                $54ca942ea01c8aa7$export$f5282963edea4a68(new Error(`GTM script load failed: ${errorMessage}`), {
                    tags: {
                        component: "gtm-integration",
                        containerId: containerId,
                        pathname: window.location.pathname
                    }
                });
            };
            gtmScript.onload = ()=>{
                $6699f20558f1dc05$export$efda9a273d7a036d({
                    message: "GTM script loaded successfully",
                    data: {
                        containerId: containerId,
                        src: gtmScript.src
                    },
                    level: "info",
                    category: "gtm"
                });
            };
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "Attempting to inject GTM script",
                data: {
                    containerId: containerId,
                    src: gtmScript.src,
                    hasFirstScript: !!firstScript,
                    parentNode: firstScript?.parentNode?.nodeName
                },
                level: "info",
                category: "gtm"
            });
            firstScript?.parentNode?.insertBefore(gtmScript, firstScript);
        } else $6699f20558f1dc05$export$efda9a273d7a036d({
            message: "GTM container ID not found",
            data: {
                writeKey: writeKey
            },
            level: "warning",
            category: "gtm"
        });
    }
    /**
   * Sends a gtm page call
   * @function page
   */ static page(name, category, data) {
        let event = "Loaded a Page";
        $d8b8b558d46670b1$export$9ab4d56492766a00.track(data, event);
        if (category) {
            event = "Viewed " + name + " " + category + " Page";
            $d8b8b558d46670b1$export$9ab4d56492766a00.track(data, event);
        }
        if (name) {
            event = "Viewed " + name + " Page";
            $d8b8b558d46670b1$export$9ab4d56492766a00.track(data, event);
        }
    }
    static track(data, event) {
        try {
            const props = typeof data !== "undefined" ? JSON.parse(JSON.stringify(data)) : {};
            const analyticsOptOut = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut;
            if (analyticsOptOut) return;
            const anonId = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).anonymousId;
            if (anonId) props.gasv3AnonymousId = anonId;
            if (event) props.event = event;
            const dataLayer = "dataLayer";
            window[dataLayer] = window[dataLayer] || [];
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "GTM track event",
                data: {
                    event: event,
                    dataLayerLength: window[dataLayer].length,
                    hasData: !!data,
                    pathname: window.location.pathname
                },
                level: "debug",
                category: "gtm"
            });
            window[dataLayer].push(props);
        } catch (error) {
            $6699f20558f1dc05$export$efda9a273d7a036d({
                message: "GTM track failed",
                data: {
                    event: event,
                    error: error instanceof Error ? error.message : String(error),
                    pathname: window.location.pathname
                },
                level: "error",
                category: "gtm"
            });
            $54ca942ea01c8aa7$export$f5282963edea4a68(error, {
                tags: {
                    component: "gtm-track",
                    event: event,
                    pathname: window.location.pathname
                }
            });
        }
    }
    static getContainerId(writeKey) {
        const containerIds = $d8b8b558d46670b1$export$9ab4d56492766a00.getContainerIdMapping();
        return containerIds[writeKey];
    }
    static getContainerIdMapping() {
        return {
            // Production
            "ycih1ygfsk": "GTM-MR6PJQR",
            // support.atlassian.com
            "9nfqb81km3": "GTM-TSGXFNC",
            // confluence.atlassian.com
            "kFTUHPhH9Q": "GTM-TRS3MV",
            // bitbucket
            "u7y09b0olq": "GTM-5VS67RK",
            // developer.atlassian.com
            "eNVsl3NOQquS5E0YXjD4prfiNVqVP3mr": "GTM-KZLJPX4",
            // opsgenie
            "bvsetm1g1y": "GTM-5RJSBR",
            // atlassian.com-cart
            "kiv6wyh2nw": "GTM-5RJSBR",
            // atlassian.com
            "r4n974s99s": "GTM-5RJSBR",
            // blogs.atlassian.com
            "swoogo": "GTM-5RJSBR",
            // events.atlassian.com
            "8oi64no": "GTM-K7MDT22",
            // statuspage.io
            "xjtlog1hqa": "GTM-KQ6R2C3",
            // marketplace.atlassian.com
            "bNSPpYAL9OiAkamBRvfRJoRu9YANW14I": "GTM-MGV77B",
            // docs.atlassian.com-aui
            "TNnhg0QuQfHEpBTzp27kJXNWZoMqSvkw": "GTM-TQZMFCL",
            // community.atlassian.com
            "trello": "GTM-PJ8M5SK",
            // trello
            // Test
            "4J6H7c3XTcpm1dbenkOILSyOachvf9It": "GTM-TQZMFCL",
            // community.stg.atlassian.com
            "SBLZG3ZYcSBcUMeLKLalrtyW8w1Caold": "GTM-TQZMFCL",
            // community.dev1.dev.atlassian.com
            "QVFu18jjHlCNaBXizZ3mtiqlBXVRkg1M": "GTM-TQZMFCL",
            // community.dev2.dev.atlassian.com
            "QmWM6iw7auEJw5gDQi6910Xk1wqyZ6bE": "GTM-TQZMFCL",
            // community.dev3.dev.atlassian.com
            "hWTszOAQMuItRdv8J30A3mNpCWd891bx": "GTM-TQZMFCL",
            // community.dev4.dev.atlassian.com
            "EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I": "GTM-5RJSBR",
            // qa-wac.internal.atlassian.com
            "Z2S07IGcRYkPJ7XHy3OIXcjpYoy9E6bs": "GTM-5RJSBR" // CXP Local Dev
        };
    }
}





class $b79cfbdb59125f3c$export$3672a9a17fd672c4 {
    static _getEventDomain() {
        return location && location.href ? new URL(location.href).hostname : "";
    }
    static _browserSupportsPromises() {
        return typeof Promise === "function";
    }
    static _userOptedOutOfTrackingCookies() {
        return window.OnetrustActiveGroups && !/,4,/.exec(window.OnetrustActiveGroups);
    }
    static _shouldUsePromise() {
        return $b79cfbdb59125f3c$export$3672a9a17fd672c4._browserSupportsPromises() && !$b79cfbdb59125f3c$export$3672a9a17fd672c4._userOptedOutOfTrackingCookies();
    }
    /**
   * Send a track/UI event
   * @method trackEvent
   * @param {string} event the name of the event
   * @param {object} data the properties to be sent with the event
   */ static trackEvent(event, data) {
        if ($b79cfbdb59125f3c$export$3672a9a17fd672c4._shouldUsePromise()) $b79cfbdb59125f3c$export$3672a9a17fd672c4.enrichEventDataPromise(data).then((enrichedData)=>$b79cfbdb59125f3c$export$3672a9a17fd672c4._trackEvent(event, enrichedData)).catch((e)=>{
            console.warn("enrich Event + tracking._trackEvent invocation failed", e);
        });
        else try {
            data = $b79cfbdb59125f3c$export$3672a9a17fd672c4.enrichEventData(data);
            $b79cfbdb59125f3c$export$3672a9a17fd672c4._trackEvent(event, data);
        } catch (e) {
            console.warn("enrich Event + tracking._trackEvent invocation failed", e);
        }
    }
    static _trackEvent(event, enrichedData) {
        (0, $039d497c173e44ba$export$d3e9576dd68d5e11).sendUIEvent(event, enrichedData);
        (0, $d8b8b558d46670b1$export$9ab4d56492766a00).track(enrichedData, event);
    }
    /**
   * send a page/screen event
   * @function pageView
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} pageViewOptions - optional, dictionary options to enable or disable specific integrations for the call (see: https://segment.com/docs/libraries/analytics.js/#page)
   * */ static pageView(pageViewProperties) {
        if ($b79cfbdb59125f3c$export$3672a9a17fd672c4._shouldUsePromise()) $b79cfbdb59125f3c$export$3672a9a17fd672c4.enrichEventDataPromise(pageViewProperties).then(function(enrichedPageViewProperties) {
            $b79cfbdb59125f3c$export$3672a9a17fd672c4._pageView(enrichedPageViewProperties);
        }).catch((e)=>{
            console.warn("enrich Event + tracking._pageView invocation failed", e);
        });
        else try {
            pageViewProperties = $b79cfbdb59125f3c$export$3672a9a17fd672c4.enrichEventData(pageViewProperties);
            $b79cfbdb59125f3c$export$3672a9a17fd672c4._pageView(pageViewProperties);
        } catch (e) {
            console.warn("enrich Event + tracking._pageView invocation failed", e);
        }
    }
    static _pageView(enrichedPageViewProperties) {
        enrichedPageViewProperties.wrapperName = "atl-global";
        enrichedPageViewProperties.destinationFlag = "gasv3";
        enrichedPageViewProperties.isBot = (0, $e6956bfb052b4929$export$353239a0a95facc4)(navigator.userAgent);
        if (!!window.cmsPageVariant) enrichedPageViewProperties.cmsPageVariant = window.cmsPageVariant;
        if (!!window.isUniform && window.compositionStatusCode !== 404) enrichedPageViewProperties.isUniform = window.isUniform;
        // AJ attributes — surfaced as top-level page view properties so they
        // are available on the page event itself (not nested inside
        // atl_first_visit).
        if (!!window.channel) enrichedPageViewProperties.page_channel = window.channel;
        if (!!window.anchor) enrichedPageViewProperties.page_anchor = window.anchor;
        if (!!window.subAnchor) enrichedPageViewProperties.page_subAnchor = window.subAnchor;
        if (!!window.keyword) enrichedPageViewProperties.page_aj_keyword = window.keyword;
        const isEnableOperationalEventWhenOptedOut = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) {
            enrichedPageViewProperties.sn_id = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).snId ?? "";
            enrichedPageViewProperties.atl_first_visit = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).atlFirstVisit ?? "{}";
            enrichedPageViewProperties.event = "page";
            enrichedPageViewProperties.eventComponent = "requested";
            (0, $039d497c173e44ba$export$d3e9576dd68d5e11).sendOperationalEvent(enrichedPageViewProperties);
        }
        if ((0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut) return;
        (0, $d8b8b558d46670b1$export$9ab4d56492766a00).page(null, null, enrichedPageViewProperties);
        (0, $039d497c173e44ba$export$d3e9576dd68d5e11).sendScreenEvent(null, enrichedPageViewProperties);
    }
    /**
   * Gets the pageViewId. Creates one if it doesn't exist
   * @function getPageViewId()
   */ static getPageViewId() {
        if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.pageViewId) $b79cfbdb59125f3c$export$3672a9a17fd672c4.pageViewId = (0, $6a2182f9463e3314$export$f6d5d4774149a3bf).guid();
        return $b79cfbdb59125f3c$export$3672a9a17fd672c4.pageViewId;
    }
    /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ static enrichEventDataPromise(data) {
        // If the data contains a href, then we have clicked a link and are navigating away
        // to a different page, so we don't have time to wait for the retry logic.
        const enableRetryForMarketoId = !data?.href && !data?.form;
        return new Promise((resolve)=>{
            (0, $74519792eed048a7$export$544bf02140fa9a77).getMarketoIdPromise(enableRetryForMarketoId).then((marketoId)=>{
                resolve($b79cfbdb59125f3c$export$3672a9a17fd672c4._enrichEventData(data, marketoId));
            });
        });
    }
    /**
   * adds common data attributes to all track/UI and page/screen events
   * @function enrichEventData
   * @param {object} data the data to enrich
   */ static enrichEventData(data) {
        return $b79cfbdb59125f3c$export$3672a9a17fd672c4._enrichEventData(data, (0, $74519792eed048a7$export$544bf02140fa9a77).getMarketoId());
    }
    static _enrichEventData(inputData, marketoId) {
        let data = {};
        if (typeof inputData !== "object" || inputData === null) {
            const dataValue = inputData;
            if (typeof dataValue !== "undefined") data["data"] = dataValue;
        } else data = inputData;
        // if not already done, read the request Id cookie set by bxp-gateway
        if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.bxpGatewayRequestId) $b79cfbdb59125f3c$export$3672a9a17fd672c4.bxpGatewayRequestId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("bxp_gateway_request_id");
        // Only set the property if the cookie was there and readCookie didn't return null
        if ($b79cfbdb59125f3c$export$3672a9a17fd672c4.bxpGatewayRequestId) data["bxpGatewayRequestId"] = $b79cfbdb59125f3c$export$3672a9a17fd672c4.bxpGatewayRequestId;
        data["pageViewId"] = $b79cfbdb59125f3c$export$3672a9a17fd672c4.getPageViewId();
        // add identity data, if not present
        data["atlEventId"] = (0, $6a2182f9463e3314$export$f6d5d4774149a3bf).guid();
        data["atlJSVersion"] = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).version || "1.0.0";
        data["browserLanguages"] = navigator.languages;
        // add category, if not present
        data["category"] = data["category"] || (document.title !== "undefined" ? document.title.trim().replace(/\W+/g, "_") : "");
        // add the cohort to the object
        data[0, $add74f19dfb8bf8a$export$69c4df819eb57a1b] = (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).readWriteAtlCohort();
        const utms = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).utms;
        if (!!utms) data["campaign"] = {
            "name": utms["utm_campaign"],
            "campaign": utms["utm_campaign"],
            "sfdc-campaign_id": utms["utm_sfdc-campaign_id"],
            "medium": utms["utm_medium"],
            "source": utms["utm_source"],
            "content": utms["utm_content"],
            "term": utms["utm_term"]
        };
        data["clientSessionId"] = $b79cfbdb59125f3c$export$3672a9a17fd672c4.readWriteSessionCookie();
        if ($b79cfbdb59125f3c$export$3672a9a17fd672c4.xid) data["atlXid"] = $b79cfbdb59125f3c$export$3672a9a17fd672c4.xid;
        data["marketoId"] = marketoId ? marketoId : "";
        data["onboardingJourney"] = JSON.parse((0, $2c637c10bc35918d$export$d3720feff416e85b)("onboarding-journey") || '""');
        return data;
    }
    /**
   * @function buildTrackEventProperties
   * @param {HTMLElement} el target element
   * @param {object} dataset takes data set from event.target.dataset
   * @param {string} label
   * @param {string} href
   * @returns {object} trackEventProperties
   */ static buildTrackEventProperties(el, dataset, label, href) {
        if (!dataset) return;
        const trackEventProperties = {
            label: label,
            href: href
        };
        if (el && el.nodeName === "BUTTON") {
            const form = el.getAttribute("form");
            if (form) trackEventProperties.form = form;
        }
        const expectedProperties = [
            "actionSubjectId",
            "eventContainer",
            "eventColumn",
            "eventComponent",
            "uuid",
            "event",
            "inputValue",
            "parentLabel",
            "label",
            "labelEnglish",
            "productKey",
            "productVersion",
            "productEdition",
            "productPlatform",
            "schemaVersion",
            "name"
        ];
        const isExpectedProperty = (value)=>expectedProperties.includes(value);
        const dataSetEntries = [];
        for(const dataProperty in dataset)if (dataProperty !== "track-event" && dataset.hasOwnProperty(dataProperty)) {
            const dataPropertyValue = dataset[dataProperty];
            if (dataPropertyValue) {
                if (isExpectedProperty(dataProperty)) trackEventProperties[dataProperty] = dataPropertyValue;
                else {
                    const dataEntry = {};
                    dataEntry[dataProperty] = dataPropertyValue;
                    dataSetEntries.push(dataEntry);
                }
            }
        }
        trackEventProperties.dataSet = dataSetEntries;
        return trackEventProperties;
    }
    /**
   * callback for auto track click events
   * @function _autoTrackClickEvent
   * @ignore
   */ // eslint-disable-next-line complexity
    static _autoTrackClickEvent(event) {
        try {
            const currentTargetElem = event.currentTarget;
            let targetElem = event.target;
            let rawText = targetElem.textContent;
            const isInput = (elem)=>elem.tagName === "INPUT";
            const isAnchor = (elem)=>elem.hasAttribute("href");
            const isSelect = (elem)=>elem.tagName === "SELECT";
            // handle form buttons differently
            if (isInput(targetElem)) // targetElem.value of an input text field is considered UGC and should not be tracked
            rawText = targetElem.type === "text" ? "[REDACTED]" : targetElem.value !== "" ? targetElem.value : targetElem.textContent;
            else if (isSelect(targetElem)) {
                targetElem = targetElem.options[targetElem.selectedIndex] || targetElem;
                rawText = targetElem.getAttribute("data-label") || targetElem.textContent || targetElem.ariaLabel || targetElem.className;
            } else if (rawText === "") rawText = targetElem.parentNode?.textContent || targetElem.title || targetElem.ariaLabel || targetElem.className;
            const href = isAnchor(targetElem) ? targetElem.href : isAnchor(currentTargetElem) ? currentTargetElem.href : "";
            const trackEventName = targetElem.getAttribute("data-track-event") || currentTargetElem.getAttribute("data-track-event") || "Clicked-Auto-CTA";
            const eventLabel = rawText ? rawText.toLowerCase().trim().replace(/ /g, "-") : "";
            const trackEventProperties = $b79cfbdb59125f3c$export$3672a9a17fd672c4.buildTrackEventProperties(currentTargetElem, currentTargetElem.dataset, eventLabel, href);
            //@ts-ignore
            $b79cfbdb59125f3c$export$3672a9a17fd672c4.trackEvent(trackEventName, trackEventProperties);
        } catch (err) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking click event");
        }
    }
    /**
   * queries the document for all selects and adds a change handler to them for tracking
   * @function autoTrackSelects
   */ static autoTrackSelects() {
        try {
            const selects = Array.from(document.querySelectorAll("select"));
            for (const select of selects)if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.isAutoTrackingDisabled(select)) {
                select.removeEventListener("change", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
                select.addEventListener("change", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking select event");
        }
    }
    /**
   * queries the document for all submit buttons and adds a click handler to them for tracking
   * @function autoTrackButtons
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ static autoTrackButtons(trackAll) {
        try {
            const selector = trackAll ? "button, input[type='submit'], input[type='button']" : "button, input[type='submit']";
            const btns = Array.from(document.querySelectorAll(selector));
            for (const btn of btns)if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.isAutoTrackingDisabled(btn)) {
                // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                btn.removeEventListener("click", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
                // add an event listener
                btn.addEventListener("click", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking button event");
        }
    }
    /**
   * queries the document for all links with a class of 'button', 'btn', 'cta' and 'external-link' and adds click handler for tracking
   * @function autoTrackLinks
   * @param {boolean} trackAll Indicates whether to use WAC's extended auto-tracking
   */ static autoTrackLinks(trackAll) {
        try {
            const links = [], selector = trackAll ? "a, .external-link" : "a[class*='button'], a[class*='btn'], .external-link", btnyLinks = Array.from(document.querySelectorAll(selector));
            for (const el of btnyLinks){
                const htmlEl = el;
                if (trackAll || htmlEl.offsetWidth >= 50 || el.className.includes("cta") || el.className.includes("external-link")) links.push(el);
            }
            for (const link of links)if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.isAutoTrackingDisabled(link)) {
                link.removeEventListener("click", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
                link.addEventListener("click", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking link event");
        }
    }
    /**
   * callback for auto track video events
   * @function _autoTrackVideoEvent
   * @ignore
   */ static _autoTrackVideoEvent(element, eventName) {
        try {
            const className = typeof element.className !== "undefined" ? element.className : element.parentElement?.className, eventLabel = typeof element.textContent !== "undefined" ? element.textContent : "", eventCategory = typeof document.title !== "undefined" ? document.title.replace(/\W+/g, "_").trim() : "";
            $b79cfbdb59125f3c$export$3672a9a17fd672c4.trackEvent(eventName, {
                className: className,
                category: eventCategory,
                label: eventLabel,
                _sio: (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("_sio") || "",
                _atl_path: (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("__atl_path") || ""
            });
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking video event");
        }
    }
    /**
   * queries the document for all divs with video open and close links and adds a click handler for tracking
   * @function autoTrackVideos
   */ static autoTrackVideos() {
        try {
            const videoOpenLinks = Array.from(document.querySelectorAll("div[class*='videoPlayButton'], .video-link, .video_link, .customer-story-video-link"));
            const videoCloseLinks = Array.from(document.querySelectorAll("div[class='overlay'], .modal.video .close"));
            const trackVideoOpenEvent = function(ev) {
                const currentTargetElem = ev.currentTarget;
                $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackVideoEvent(currentTargetElem, "Opened Video");
            };
            const trackVideoCloseEvent = function(ev) {
                const currentTargetElem = ev.currentTarget;
                $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackVideoEvent(currentTargetElem, "Closed Video");
            };
            for (const videoOpenLink of videoOpenLinks){
                videoOpenLink.removeEventListener("click", trackVideoOpenEvent);
                videoOpenLink.addEventListener("click", trackVideoOpenEvent);
            }
            for (const videoCloseLink of videoCloseLinks){
                videoCloseLink.removeEventListener("click", trackVideoCloseEvent);
                videoCloseLink.addEventListener("click", trackVideoCloseEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking video event");
        }
    }
    /**
   * queries the document for all role='tab' and adds a click handler to them for tracking
   * @function autoTrackTabs
   */ static autoTrackTabs() {
        try {
            const selector = "[role='tab']";
            const tabs = Array.from(document.querySelectorAll(selector));
            for (const tab of tabs)if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.isAutoTrackingDisabled(tab)) {
                // remove existing event listener (to prevent redundant listeners from useEffect hooks)
                tab.removeEventListener("select", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
                // add an event listener
                tab.addEventListener("select", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackClickEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking tab event");
        }
    }
    /**
   * queries the document for all details elements and adds a toggle handler to them for tracking
   * @function autoTrackDetails
   */ static autoTrackDetails() {
        try {
            const details = Array.from(document.querySelectorAll("details"));
            for (const detail of details)if (!$b79cfbdb59125f3c$export$3672a9a17fd672c4.isAutoTrackingDisabled(detail)) {
                detail.removeEventListener("toggle", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackToggleEvent);
                detail.addEventListener("toggle", $b79cfbdb59125f3c$export$3672a9a17fd672c4._autoTrackToggleEvent);
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking details event");
        }
    }
    /**
   * callback for auto track toggle events on details elements
   * @function _autoTrackToggleEvent
   * @ignore
   */ static _autoTrackToggleEvent(event) {
        try {
            const detailsElem = event.currentTarget;
            const summaryElem = detailsElem.querySelector("summary");
            const rawText = summaryElem?.textContent || detailsElem.textContent || "";
            const isOpen = detailsElem.open;
            const trackEventName = detailsElem.getAttribute("data-track-event") || "Toggled-Auto-Details";
            const eventLabel = rawText.toLowerCase().trim().replace(/ /g, "-");
            const trackEventProperties = $b79cfbdb59125f3c$export$3672a9a17fd672c4.buildTrackEventProperties(detailsElem, detailsElem.dataset, eventLabel, "");
            if (trackEventProperties) trackEventProperties.event = isOpen ? "opened" : "closed";
            //@ts-ignore
            $b79cfbdb59125f3c$export$3672a9a17fd672c4.trackEvent(trackEventName, trackEventProperties);
        } catch (err) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error auto-tracking toggle event");
        }
    }
    /**
   * check to see if the element in question contains class 'doNotAutoTrack'
   * @function isAutoTrackingDisabled
   * @param element
   */ static isAutoTrackingDisabled(element) {
        return element.classList.contains("doNotAutoTrack");
    }
    /**
   * return an existing session cookie
   * @function readWriteSessionCookie
   * @returns {string}
   */ static readWriteSessionCookie() {
        const cookie = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("atl_session");
        const name = "atl_session";
        const value = cookie || (0, $6a2182f9463e3314$export$f6d5d4774149a3bf).guid();
        const seconds = 1800;
        if ((0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookieInSeconds) (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookieInSeconds(name, value, seconds);
        return value;
    }
}


const $74519792eed048a7$var$TRELLO_USER_ID = "token";
const $74519792eed048a7$var$XID = "seg_xid";
const $74519792eed048a7$var$pageViewProperties = {};
const $74519792eed048a7$var$MARKETO_ID = "_mkto_trk";
const $74519792eed048a7$var$REFERRER_TRELLO_DOMAINS = [
    "trello.com",
    "trellis.coffee"
];
class $74519792eed048a7$export$544bf02140fa9a77 {
    /**
   * Sends a track event with known identifiers
   * @function identify
   * @param {string} userId - required
   * @param {object} traits - optional, dictionary of custom traits to send
   */ static identify(userId, traits) {
        traits = !!traits && typeof traits === "object" ? traits : {};
        const data = traits;
        data["atlassian_id"] = userId;
        data["atlJSVersion"] = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).version || "1.0.0";
        try {
            data["ga_clientid"] = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("_ga");
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error reading _ga cookie");
        }
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).trackEvent("known_identifiers", data);
    }
    /**
   * used internally to gather all known ids and call identify
   * @function autoIdentify
   */ static autoIdentify() {
        const emailDetected = (0, $60bf2125eaedf843$export$4dc2b60021baefca).emailAddressIsDetected();
        const userId = $74519792eed048a7$export$544bf02140fa9a77.getAtlassianUserId();
        const xid = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($74519792eed048a7$var$XID);
        if (emailDetected) {
            const integrations = {
                "All": false,
                "Google Analytics": true
            };
            if (!(0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).pageViewOptions) (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).pageViewOptions = {
                integrations: integrations
            };
            else (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).pageViewOptions["integrations"] = integrations;
            if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).urlContainsEmail(window.location.href)) (0, $60bf2125eaedf843$export$4dc2b60021baefca).addCleanedUrlAndPaths($74519792eed048a7$var$pageViewProperties);
            if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).urlContainsEmail(document.referrer)) (0, $60bf2125eaedf843$export$4dc2b60021baefca).addCleanedReferrer($74519792eed048a7$var$pageViewProperties);
        }
        try {
            $74519792eed048a7$var$pageViewProperties["anonymous_id"] = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).anonymousId;
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error reading segment anonymousId");
        }
        try {
            $74519792eed048a7$var$pageViewProperties[0, $add74f19dfb8bf8a$export$69c4df819eb57a1b] = (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).readWriteAtlCohort();
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error read / writing atlCohort cookie");
        }
        if (userId || xid) $74519792eed048a7$export$544bf02140fa9a77.identify(userId, $74519792eed048a7$var$pageViewProperties);
    }
    static getAtlassianUserId() {
        const userId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("__aid_user_id");
        if (userId) return decodeURIComponent(userId);
        return null;
    }
    static getTrelloUserId() {
        try {
            const page = location.href ? new URL(location.href) : null;
            // since the trello cookie is such a common name. check to make sure we're actually on a trello page
            if (page && (page.hostname.includes("trello.com") || page.hostname.includes("trellis.coffee"))) {
                const token = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($74519792eed048a7$var$TRELLO_USER_ID);
                if (token) return decodeURIComponent(token).split("/")[0];
            }
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("Error reading Trello userId");
        }
        return null;
    }
    static getMarketoId() {
        const marketoId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($74519792eed048a7$var$MARKETO_ID);
        if (marketoId) return decodeURIComponent(marketoId);
        return null;
    }
    static getMarketoIdPromise(enableRetry = true) {
        const waitCount = 0;
        const maxWait = enableRetry ? 5000 : 0;
        return new Promise((resolve)=>{
            $74519792eed048a7$export$544bf02140fa9a77._internalMarketoPromise(waitCount, maxWait, resolve);
        });
    }
    static _internalMarketoPromise(waitCount, maxWait, resolve) {
        const delay = 500;
        const marketoId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($74519792eed048a7$var$MARKETO_ID);
        // wait for up to 5 seconds for the marketo cookie to show up
        if (marketoId) resolve(decodeURIComponent(marketoId));
        else {
            waitCount += delay;
            if (waitCount >= maxWait) {
                (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("getMarketoIdPromise error");
                resolve("");
            } else setTimeout(function() {
                $74519792eed048a7$export$544bf02140fa9a77._internalMarketoPromise(waitCount, maxWait, resolve);
            }, delay);
        }
    }
    static isReferrerTrello() {
        if (!document.referrer) return false;
        const ref = new URL(document.referrer);
        return $74519792eed048a7$var$REFERRER_TRELLO_DOMAINS.includes(ref.hostname);
    }
}



const $2c687d16e9635ee0$var$routeTypes = {
    BOARD: "board",
    BOARD_BUTLER: "board-butler",
    BOARD_BUTLER_PAGE: "board-butler-page",
    BOARD_RECOMMEND: "board-recommend",
    CARD: "card",
    ENTERPRISE_ADMIN: "enterprise-admin",
    ENTERPRISE_ADMIN_TAB: "enterprise-admin-tab",
    ENTERPRISE_ADMIN_TAB_SUBSECTION: "enterprise-admin-tab-subsection",
    HOME: "home",
    TEMPLATES: "templates",
    TEMPLATES_CATEGORIES: "templates-categories",
    TEMPLATES_STORY: "templates-story",
    TEMPLATES_RECOMMEND: "templates-recommend",
    TEMPLATES_SUBMIT: "templates-submit",
    TEMPLATE: "template",
    USER: "user",
    USER_TABS: "user-tabs",
    USER_CARDS_WORKSPACE: "user-cards-workspace",
    VIEW: "view",
    WORKSPACE: "workspace",
    WORKSPACE_SECTION: "workspace-section",
    WORKSPACE_MEMBERS_SUBSECTION: "workspace-members-subsection",
    WORKSPACE_VIEWS_SUBSECTION: "workspace-views-subsection",
    POWER_UPS_HOME: "power-ups-home",
    POWER_UPS_ALL: "power-ups-all",
    POWER_UPS_TRELLO: "power-ups-trello",
    POWER_UPS_CATEGORIES: "power-ups-categories",
    UPGRADE_TEAM: "select-team-to-upgrade",
    SHORTCUTS: "shortcuts"
};
// Trello indices of non UGC/PII in the pathname depending on their route type
const $2c687d16e9635ee0$var$ALLOWLIST_INDICES = {
    ROUTE_IDENTIFIER: 0,
    ROUTE_SHORTLINK: 1,
    B_ROUTE_BUTLER: 3,
    B_ROUTE_BUTLER_PAGE: 4,
    B_ROUTE_RECOMMEND: 4,
    E_ROUTE_ADMIN: 2,
    E_ROUTE_ADMIN_TAB_NAME: 3,
    E_ROUTE_ADMIN_TAB_SUBSECTION_NAME: 4,
    POWER_UPS_ROUTE_PAGE: 1,
    POWER_UPS_ROUTE_CATEGORY: 1,
    POWER_UPS_ROUTE_CATEGORY_NAME: 2,
    TEMPLATES_ROUTE_PAGE: 1,
    TEMPLATES_ROUTE_CATEGORY: 1,
    TEMPLATES_ROUTE_TEMPLATE_NAME: 2,
    TEMPLATES_ROUTE_RECOMMEND: 4,
    U_ROUTE_TAB_NAME: 2,
    W_ROUTE_PAGE: 2,
    W_ROUTE_PAGE_SUBSECTION: 3
};
const $2c687d16e9635ee0$var$routePatternMap = new Map([
    [
        $2c687d16e9635ee0$var$routeTypes.BOARD_RECOMMEND,
        {
            id: $2c687d16e9635ee0$var$routeTypes.BOARD_RECOMMEND,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.B_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.BOARD_BUTLER_PAGE,
        {
            id: $2c687d16e9635ee0$var$routeTypes.BOARD_BUTLER_PAGE,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/(rules|card-buttons|board-buttons|schedule|on-dates|connected-apps)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER_PAGE
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.BOARD_BUTLER,
        {
            id: $2c687d16e9635ee0$var$routeTypes.BOARD_BUTLER,
            regExp: new RegExp("^/b/([^/]+)/([^/]+)/butler/$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.B_ROUTE_BUTLER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.BOARD,
        {
            id: $2c687d16e9635ee0$var$routeTypes.BOARD,
            regExp: new RegExp("^/b/([^/]+)(?:/(.*?))?$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.CARD,
        {
            id: $2c687d16e9635ee0$var$routeTypes.CARD,
            regExp: new RegExp("^/c/"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
        {
            id: $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN_TAB_SUBSECTION,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|boards)/(managed|boardguests|deactivated|non-enterprise|pending|public)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_SUBSECTION_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN_TAB,
        {
            id: $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN_TAB,
            regExp: new RegExp("^/e/([^/]+)/admin/(members|workspaces|settings|attachment-restrictions|boards|power-ups|auditlog|account-administration|sso|api-tokens)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN_TAB_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN,
        {
            id: $2c687d16e9635ee0$var$routeTypes.ENTERPRISE_ADMIN,
            regExp: new RegExp("^/e/([^/]+)/admin$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.E_ROUTE_ADMIN
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.POWER_UPS_HOME,
        {
            id: $2c687d16e9635ee0$var$routeTypes.POWER_UPS_HOME,
            regExp: new RegExp("^/power-ups$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.POWER_UPS_ALL,
        {
            id: $2c687d16e9635ee0$var$routeTypes.POWER_UPS_ALL,
            regExp: new RegExp("^/power-ups/all$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.POWER_UPS_TRELLO,
        {
            id: $2c687d16e9635ee0$var$routeTypes.POWER_UPS_TRELLO,
            regExp: new RegExp("^/power-ups/made-by-trello$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_PAGE
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.POWER_UPS_CATEGORIES,
        {
            id: $2c687d16e9635ee0$var$routeTypes.POWER_UPS_CATEGORIES,
            regExp: new RegExp("^/power-ups/category/(automation|analytics-reporting|board-utilities|communication-collaboration|developer-tools|file-management|hr-operations|it-project-management|marketing-social-media|product-design|sales-support)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.POWER_UPS_ROUTE_CATEGORY_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.HOME,
        {
            id: $2c687d16e9635ee0$var$routeTypes.HOME,
            regExp: new RegExp("^/$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.UPGRADE_TEAM,
        {
            id: $2c687d16e9635ee0$var$routeTypes.UPGRADE_TEAM,
            regExp: new RegExp("^/select-team-to-upgrade$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.SHORTCUTS,
        {
            id: $2c687d16e9635ee0$var$routeTypes.SHORTCUTS,
            regExp: new RegExp("^/shortcuts$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.TEMPLATES_SUBMIT,
        {
            id: $2c687d16e9635ee0$var$routeTypes.TEMPLATES_SUBMIT,
            regExp: new RegExp("^/templates/submit$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_PAGE
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.TEMPLATES_RECOMMEND,
        {
            id: $2c687d16e9635ee0$var$routeTypes.TEMPLATES_RECOMMEND,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)/([^/]+)/recommend$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_RECOMMEND
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.TEMPLATES_CATEGORIES,
        {
            id: $2c687d16e9635ee0$var$routeTypes.TEMPLATES_CATEGORIES,
            regExp: new RegExp("^/templates/(business|design|education|engineering|marketing|operations-hr|personal|productivity|product-management|project-management|remote-work|sales|support|team-management)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.TEMPLATES_STORY,
        {
            id: $2c687d16e9635ee0$var$routeTypes.TEMPLATES_STORY,
            regExp: new RegExp("^/templates/([^/]+)/([^/]+)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_CATEGORY,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.TEMPLATES_ROUTE_TEMPLATE_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.TEMPLATES,
        {
            id: $2c687d16e9635ee0$var$routeTypes.TEMPLATES,
            regExp: new RegExp("^/templates$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.USER_CARDS_WORKSPACE,
        {
            id: $2c687d16e9635ee0$var$routeTypes.USER_CARDS_WORKSPACE,
            regExp: new RegExp("^/u/([^/]+)/cards/([^/]+)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.USER_TABS,
        {
            id: $2c687d16e9635ee0$var$routeTypes.USER_TABS,
            regExp: new RegExp("^/u/([^/]+)/(profile|activity|boards|cards|labs|tasks)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.U_ROUTE_TAB_NAME
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.USER,
        {
            id: $2c687d16e9635ee0$var$routeTypes.USER,
            regExp: new RegExp("^/u/"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.VIEW,
        {
            id: $2c687d16e9635ee0$var$routeTypes.VIEW,
            regExp: new RegExp("^/v/"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_SHORTLINK
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.WORKSPACE_SECTION,
        {
            id: $2c687d16e9635ee0$var$routeTypes.WORKSPACE_SECTION,
            regExp: new RegExp("^/w/([^/]+)/(account|billing|home|export|free-trial|members|tables|getting-started|highlights|reports)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.W_ROUTE_PAGE
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
        {
            id: $2c687d16e9635ee0$var$routeTypes.WORKSPACE_MEMBERS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/members/(guests|requests)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
        {
            id: $2c687d16e9635ee0$var$routeTypes.WORKSPACE_VIEWS_SUBSECTION,
            regExp: new RegExp("^/w/([^/]+)/views/(table|calendar|)$"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.W_ROUTE_PAGE,
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.W_ROUTE_PAGE_SUBSECTION
            ]
        }
    ],
    [
        $2c687d16e9635ee0$var$routeTypes.WORKSPACE,
        {
            id: $2c687d16e9635ee0$var$routeTypes.WORKSPACE,
            regExp: new RegExp("^/w/"),
            allowlist: [
                $2c687d16e9635ee0$var$ALLOWLIST_INDICES.ROUTE_IDENTIFIER
            ]
        }
    ]
]);
class $2c687d16e9635ee0$export$6177d4ea0363b1de {
    static _determineRoute(urlPathname) {
        const routePatternArray = Array.from($2c687d16e9635ee0$var$routePatternMap.values());
        for (const routeDefinition of routePatternArray){
            if (routeDefinition.regExp.exec(urlPathname)) return routeDefinition;
        }
        return null;
    }
    // reconstructs the pathname to include sections that do NOT include UGC/PII
    static _reconstructPathname(pathnameSections, sectionsToKeep) {
        let reconstructedUrl = "";
        for(let i = 0; i < pathnameSections.length; i++)if (sectionsToKeep.includes(i)) reconstructedUrl += "/" + pathnameSections[i];
        return reconstructedUrl;
    }
    // finds the matching route for the pathname we want to include in our marketing
    // analytics and then sanitizes it of UGC/PII
    static scrubUrl(urlPathname, defaultPathname) {
        const matchingRoute = $2c687d16e9635ee0$export$6177d4ea0363b1de._determineRoute(urlPathname);
        // remove starting slash to allow matchers to use ^ properly
        const partialUrl = urlPathname.substring(1, urlPathname.length);
        const pathnameSections = partialUrl.split("/");
        // to avoid UGC/PII related HOTs, we should be extra cautious & return a
        // generic path for URLs that don't follow a known pattern
        return matchingRoute ? $2c687d16e9635ee0$export$6177d4ea0363b1de._reconstructPathname(pathnameSections, matchingRoute.allowlist) : defaultPathname;
    }
}


const $039d497c173e44ba$var$attributeWhiteList = [
    "atlCohort",
    "featureFlags"
];
const $039d497c173e44ba$var$ATL_USER_HASH = "atlUserHash";
class $039d497c173e44ba$export$d3e9576dd68d5e11 {
    /**
   * Sends a UI event to GASv3
   * @function sendUIEvent
   * @param {string} name
   * @param {object} data
   * @param {object} skipEnrichment - whether to add additional data
   */ static sendUIEvent(name, data, skipEnrichment) {
        if (!skipEnrichment) data = $039d497c173e44ba$export$d3e9576dd68d5e11.enrichEventData(data);
        data["trackEventName"] = name;
        data.href = data.href ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.signupUrl) : undefined;
        const source = $039d497c173e44ba$export$d3e9576dd68d5e11.setSource(data);
        const uiEvent = {
            // this will likely change
            action: data["event"] || "clicked",
            actionSubject: data["eventComponent"] || "component",
            actionSubjectId: data["actionSubjectId"] || undefined,
            source: source,
            attributes: data
        };
        this._createAndFireEvent("ui", uiEvent);
    }
    /**
   * Sends a page view operational event to GASv3
   * @param data - The data to send to GASv3
   * @param skipEnrichment - Whether to skip enrichment
   */ static sendOperationalEvent(data, skipEnrichment) {
        if (!skipEnrichment) data = $039d497c173e44ba$export$d3e9576dd68d5e11.enrichEventData(data);
        data.href = data.href ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.signupUrl) : undefined;
        const source = $039d497c173e44ba$export$d3e9576dd68d5e11.setSource(data);
        if ((0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut) {
            const fieldsToRemove = [
                "atlCohort",
                "name",
                "atlXid",
                "marketoId"
            ];
            const dataRecord = data;
            fieldsToRemove.forEach(function(key) {
                delete dataRecord[key];
            });
        }
        const operationalEvent = {
            // this will likely change
            action: data["event"] || "",
            actionSubject: data["eventComponent"] || "",
            actionSubjectId: data["actionSubjectId"] || undefined,
            source: source,
            attributes: data,
            ...(0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut ? {
                excludedProperties: {
                    anonymousId: true,
                    authenticatedUserId: true,
                    userId: true,
                    xid: true
                }
            } : {}
        };
        this._createAndFireEvent("operational", operationalEvent);
    }
    static _createAndFireEvent(eventType, payload) {
        if (!(0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).createAnalyticsEvent) return;
        // When user has opted out, only allow operational events (e.g. errors, diagnostics)
        if ((0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut && eventType !== "operational") return;
        const payloadToSend = {
            ...payload,
            eventType: eventType
        };
        (0, $6a55625674322039$export$2e2bcd8739ae039)("atl-global")(payloadToSend)((0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).createAnalyticsEvent);
    }
    /**
   * Sends a Screen event to GASv3
   * @function sendScreenEvent
   * @param {string} name
   * @param {object} data - GASv3 screen event attributes
   *                 data.screenNameOverride - special data attribute that overrides the screen name for the event, instead of the default 'page'.
   *                                           If used, this attribute will be stripped from the data before sending to GASv3.
   * @param {object} skipEnrichment - whether to add additional data
   */ static sendScreenEvent(name, data, skipEnrichment) {
        if (!skipEnrichment) data = $039d497c173e44ba$export$d3e9576dd68d5e11.enrichEventData(data);
        data.href = data.href ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.href) : undefined;
        data.signupUrl = data.signupUrl ? (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(data.signupUrl) : undefined;
        data["name"] = name;
        const screenName = typeof data !== "undefined" && data["screenNameOverride"] || "page";
        if (typeof data === "object") delete data["screenNameOverride"];
        this._createAndFireEvent("screen", {
            name: screenName,
            attributes: data
        });
        $039d497c173e44ba$export$d3e9576dd68d5e11.sendIdentityEvent();
    }
    /**
   *
   * @function sendIdentityEvent
   */ static sendIdentityEvent() {
        // load the identity hash cookie
        const atlUserHash = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($039d497c173e44ba$var$ATL_USER_HASH);
        // get the user identifiers
        const identifiers = $039d497c173e44ba$export$d3e9576dd68d5e11.getUserIdentifiers();
        // calculate the data hash of the known identifiers
        const calculatedHash = (0, $6a2182f9463e3314$export$f6d5d4774149a3bf).guidHashCode(JSON.stringify(identifiers)).toString();
        if (!atlUserHash || atlUserHash !== calculatedHash) {
            // save new hash and send UI event
            (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookie($039d497c173e44ba$var$ATL_USER_HASH, calculatedHash, 3650, true);
            const data = {
                event: "identified",
                eventComponent: "user",
                identifiers: identifiers,
                writeKey: (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).writeKey
            };
            $039d497c173e44ba$export$d3e9576dd68d5e11.sendUIEvent("", data, true);
        }
    }
    static getUserIdentifiers() {
        return {
            anonymousId: (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).anonymousId,
            atlassianAccountId: (0, $74519792eed048a7$export$544bf02140fa9a77).getAtlassianUserId(),
            crossDomainId: (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).xid,
            optimizelyEndUserId: null,
            trelloUserId: (0, $74519792eed048a7$export$544bf02140fa9a77).getTrelloUserId()
        };
    }
    static setSource(data) {
        let set = false;
        let source = "";
        if (data["eventContainer"]) {
            source += data["eventContainer"].split(" ")[0];
            set = true;
        }
        if (data["eventColumn"]) {
            source += data["eventColumn"].split(" ")[0];
            set = true;
        }
        if (!set) source = "none";
        return source;
    }
    // fix for hot-99118
    static getReferrerURL(ref) {
        if ((0, $74519792eed048a7$export$544bf02140fa9a77).isReferrerTrello()) {
            const referrer = new URL(ref);
            return referrer.hostname + (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(referrer.pathname, "");
        }
        return ref;
    }
    /**
   * This function is to specifically add data needed in Socrates but not provided by default in GASv3 like it is for Segment
   * @function enrichEventData
   * @param {object} inputData  // a dictionary of data to enrich
   */ // eslint-disable-next-line complexity
    static enrichEventData(inputData) {
        let data = {};
        if (typeof inputData !== "object" || inputData === null) {
            const dataValue = inputData;
            if (typeof dataValue !== "undefined") data.data = dataValue;
        } else data = inputData;
        const newData = JSON.parse(JSON.stringify(data));
        newData.writeKey = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).writeKey;
        newData.isMarketingEvent = $039d497c173e44ba$export$d3e9576dd68d5e11.isMarketingEvent;
        let page;
        let ref;
        let page_canonical_url;
        try {
            // convert all passed in values to string if they are currently objects
            Object.keys(newData).forEach((inputKey)=>{
                const key = inputKey;
                if (newData[key] && typeof newData[key] === "object" && !Array.isArray(newData[key]) && !$039d497c173e44ba$var$attributeWhiteList.includes(key)) // @ts-ignore
                newData[key] = JSON.stringify(newData[key]);
            });
            const href = $039d497c173e44ba$export$d3e9576dd68d5e11.getLocation();
            page = href ? new URL((0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(href)) : null;
            const referredByJiraDotCom = page?.searchParams.get("referer") === "jira.com";
            ref = referredByJiraDotCom ? new URL("https://www.jira.com") : document.referrer ? new URL((0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL(document.referrer)) : null;
            page_canonical_url = (0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL((0, $60bf2125eaedf843$export$4dc2b60021baefca).getCanonicalUrl());
            newData.page_title = newData.page_title || document.title || "";
            newData.page_domain = page ? page.hostname || "" : "";
            newData.page_subdomain = page ? page.hostname || "" : "";
            // referrer attributes
            newData.page_referrer_domain = ref ? ref.hostname || "" : "";
            newData.page_referrer_subdomain = ref ? ref.hostname || "" : "";
            if ((0, $74519792eed048a7$export$544bf02140fa9a77).isReferrerTrello()) {
                // fix for hot-99118
                newData.page_canonical_url = page ? (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(page.href, page.origin) || "" : "";
                newData.page_url = page ? (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(page.href, page.origin) || "" : "";
                newData.page_path = page ? (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(page.pathname, new URL(page.href).pathname) || "" : "";
                newData.page_url_parameters = page ? (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(page.search, "") : "";
                newData.page_url_params_json = page ? JSON.stringify($f2bbcecd7d3447b1$export$98e6a39c04603d36((0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(page.search, new URL(page.origin).pathname))) : "";
                newData.page_referrer_url_params_json = ref ? JSON.stringify($f2bbcecd7d3447b1$export$98e6a39c04603d36((0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(ref.search, new URL(ref.origin).pathname))) : "";
                newData.page_referrer_path = ref ? (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
                newData.page_referrer_url = ref ? ref.origin + (0, $2c687d16e9635ee0$export$6177d4ea0363b1de).scrubUrl(ref.pathname, new URL(ref.origin).pathname) || "" : "";
            } else {
                newData.page_canonical_url = page_canonical_url;
                newData.page_url = page ? page.href || "" : "";
                newData.page_path = page ? page.pathname || "" : "";
                newData.page_url_parameters = page ? page.search || "" : "";
                newData.page_url_params_json = page ? JSON.stringify($f2bbcecd7d3447b1$export$98e6a39c04603d36(page.search)) : "";
                newData.page_referrer_url_params_json = ref ? JSON.stringify($f2bbcecd7d3447b1$export$98e6a39c04603d36(ref.search)) : "";
                newData.page_referrer_path = ref ? ref.pathname || "" : "";
                newData.page_referrer_url = ref ? ref.href || "" : "";
            }
            newData.cookiesEnabled = window.navigator ? window.navigator.cookieEnabled : "unknown";
            newData.activeGroups = window.OnetrustActiveGroups ? window.OnetrustActiveGroups : "";
        } catch (e) {
            // fix for hot-99118
            const additionalData = {
                error: e instanceof Error ? e.message : JSON.stringify(e),
                href: location ? location.href : "no location",
                referrer: document ? document.referrer ? $039d497c173e44ba$export$d3e9576dd68d5e11.getReferrerURL(document.referrer) : "no referrer" : "no document"
            };
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("GASv3 enrichEventData error", JSON.stringify(additionalData));
        }
        return newData;
    }
    static getLocation() {
        return location.href;
    }
}




/**
 * Module for segment metrics tracking events.
 * @module Metrics
 */ 




var $7aaa8f64636160e1$export$4657ae8822aeedd;
(function(MetricKey) {
    MetricKey["TIME_TO_LOAD"] = "timeToLoad";
    MetricKey["TIME_TO_SEGMENT_LOAD"] = "timeToSegmentLoad";
    MetricKey["TIME_TO_AVAILABLE"] = "timeToAvailable";
    MetricKey["TIME_TO_READY"] = "timeToReady";
    MetricKey["TIME_TO_START_LOAD_XID"] = "timeToStartLoadXID";
    MetricKey["TIME_TO_START_GET_XID"] = "timeToStartGetXID";
    MetricKey["TIME_TO_LOAD_XID"] = "timeToLoadXID";
})($7aaa8f64636160e1$export$4657ae8822aeedd || ($7aaa8f64636160e1$export$4657ae8822aeedd = {}));
class $7aaa8f64636160e1$export$ed9166ec0f465b5e {
    static #_ = this.metricsData = {};
    /**
   * Store the value of a single performance metric
   * @function logMetrics
   * @param {MetricKey} metricKey - the metric to log
   * @param {number} mockDate - a mock timestamp
   */ static logMetric(metricKey, mockDate) {
        $7aaa8f64636160e1$export$ed9166ec0f465b5e.metricsData[metricKey] = mockDate || Date.now();
    }
    static setLoadTimestamp(loadTimestamp) {
        $7aaa8f64636160e1$export$ed9166ec0f465b5e.loadTimestamp = loadTimestamp;
    }
    /**
   * Logs an performance metrics track call to segment via the HTTP API
   * @function sendMetrics
   * @param {object} mockReq used in testing so we don't actually send anything to Segment
   */ static sendMetrics(mockReq) {
        const loadTimestamp = $7aaa8f64636160e1$export$ed9166ec0f465b5e.loadTimestamp;
        if (!loadTimestamp) return;
        // calculate all of the times
        Object.entries($7aaa8f64636160e1$export$ed9166ec0f465b5e.metricsData).forEach(([key, value])=>{
            if (value > 0) // Todo .. should this be > loadTimestamp ??
            $7aaa8f64636160e1$export$ed9166ec0f465b5e.metricsData[key] = value - loadTimestamp;
        });
        const cohort = (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).readAtlCohort();
        const properties = {
            event: "metrics",
            eventComponent: "atlGlobal",
            metrics: $7aaa8f64636160e1$export$ed9166ec0f465b5e.metricsData,
            atlJSVersion: (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).version,
            cohort: cohort ? cohort.bucketAll.index : null,
            host: mockReq ? mockReq.hostFake : window.location.host,
            path: mockReq ? mockReq.pathFake : (0, $60bf2125eaedf843$export$4dc2b60021baefca).dropEmailFromPath(window.location.pathname),
            pageViewId: (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).getPageViewId() // used to tie to other events
        };
        (0, $039d497c173e44ba$export$d3e9576dd68d5e11).sendUIEvent("", properties, true);
        $7aaa8f64636160e1$export$ed9166ec0f465b5e.resetMetrics();
    }
    // testing only
    static resetMetrics() {
        $7aaa8f64636160e1$export$ed9166ec0f465b5e.metricsData = {};
    }
}



class $cd1066d46ea94025$export$9e14a7677ef1423c {
    /**
   * Loads and initializes segment.io.
   * @function initWithPageAnalytics
   * @param {string} writeKey - required, Segment.io key
   * @param {object} pageViewProperties - optional, dictionary of properties of the page (see: https://segment.com/docs/libraries/analytics.js/#page)
   * @param {object} loadOptions - optional, object with a dictionary of which integrations to load (see: https://segment.com/docs/sources/website/analytics.js/#load-options)
   * @param {number} loadTimestamp - optional, the timestamp at which the initializing site loaded this script
   * @param {string} anonymousId - GASv3 analytics client anonymous id
   * @param {function} createAnalyticsEvent - analytics next CreateUIAnalyticsEvent
   */ static initWithPageAnalytics(writeKey, pageViewProperties, loadOptions, loadTimestamp, anonymousId, createAnalyticsEvent, analyticsOptOut) {
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).anonymousId = anonymousId;
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).analyticsOptOut = analyticsOptOut;
        // Always set createAnalyticsEvent so operational events can fire when opt-out
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).createAnalyticsEvent = createAnalyticsEvent;
        // set unpopulated params to empty objects
        if (typeof loadOptions !== "object" || loadOptions === null) loadOptions = {};
        if (typeof pageViewProperties !== "object" || pageViewProperties === null) pageViewProperties = {};
        $cd1066d46ea94025$export$9e14a7677ef1423c.captureUTMs();
        // adding marketing boolean if current product comes under marketing domain
        $cd1066d46ea94025$export$9e14a7677ef1423c.setIsMarketingEvent(pageViewProperties);
        // set load timestamp for calculating metrics
        (0, $7aaa8f64636160e1$export$ed9166ec0f465b5e).setLoadTimestamp(loadTimestamp);
        // store params for later reporting if necessary.
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).writeKey = writeKey;
        // TODO: pageViewOptions used to be passed in, but doesn't appear to be used outside of Segment.
        // Can we just delete this completely?
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).pageViewOptions = {};
        // auto-fire page view
        (0, $60bf2125eaedf843$export$4dc2b60021baefca).addActualUrl(pageViewProperties);
        const isEnableOperationalEventWhenOptedOut = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) {
            $cd1066d46ea94025$export$9e14a7677ef1423c.setSnIdAndAtlFirstVisit(writeKey, pageViewProperties);
            // updates the activeGroups property in atl_first_visit when window.OnetrustActiveGroups changes
            $cd1066d46ea94025$export$9e14a7677ef1423c.updateAtlFirstVisitActiveGroups();
            $cd1066d46ea94025$export$9e14a7677ef1423c.listenForActiveGroupsChange();
        }
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).pageView(pageViewProperties);
        if (!analyticsOptOut) {
            // TODO: Switch these params to dynamically config based on writeKey
            (0, $d8b8b558d46670b1$export$9ab4d56492766a00).initialize(writeKey);
            // add auto tracking and configure google analytics integration
            $cd1066d46ea94025$export$9e14a7677ef1423c.autoTrack();
            $cd1066d46ea94025$export$9e14a7677ef1423c.gaIntegration();
            $cd1066d46ea94025$export$9e14a7677ef1423c.globalCallReady();
        }
    }
    /**
   * Set SN_ID in the cookie
   */ static setSnIdAndAtlFirstVisit(writeKey, pageViewProperties) {
        // Get SN_ID from cookie, if doesn't exist make one
        let snId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("sn_id") ?? null;
        if (snId) // if sn_id cookie does exist, we verify to make sure the atl_first_visit local storage item is also present and not expired
        {
            if ($cd1066d46ea94025$export$9e14a7677ef1423c.isSetAtlFirstVisit()) $cd1066d46ea94025$export$9e14a7677ef1423c.setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties);
        } else {
            (0, $50ddae1ef20437fb$export$5c073f9c8bff1ad3)();
            snId = (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)();
            (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookie("sn_id", encodeURIComponent('"' + snId + '"'), 1, true);
            // if sn_id cookie doesn't exist or has expired, then we'll just create a new atl_first_visit locat storage item
            $cd1066d46ea94025$export$9e14a7677ef1423c.setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties);
        }
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).snId = decodeURIComponent(snId).replace(/['"]+/g, "");
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).atlFirstVisit = localStorage.getItem("atl_first_visit") || "{}";
    }
    /**
   * Check if atl_first_visit is missing and or has expired then we return true, else false
   * @returns boolean
   */ static isSetAtlFirstVisit() {
        const atl_first_visit_data = localStorage.getItem("atl_first_visit");
        if (atl_first_visit_data) {
            const parsedAtlFirstVisitData = JSON.parse(atl_first_visit_data);
            const expiresAt = parsedAtlFirstVisitData?.expiresAt;
            if (expiresAt === null) return true;
            if (new Date(expiresAt).getTime() < Date.now()) return true;
            return false;
        }
        return true;
    }
    /**
   * Set the atl_first_visit data in localStorage
   * @param {string} writeKey
   * @param pageViewProperties
   */ static setAtlFirstVisitInLocalStorage(writeKey, pageViewProperties) {
        const referrer = document.referrer || "about:blank";
        const refUrl = new URL(referrer);
        const atl_first_visit_data = $cd1066d46ea94025$export$9e14a7677ef1423c.buildAtlFirstVisitData(writeKey, pageViewProperties, refUrl);
        try {
            localStorage.setItem("atl_first_visit", JSON.stringify(atl_first_visit_data));
        } catch (e) {
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("atl_first_visit localStorage update failed", JSON.stringify(e));
        }
    }
    /**
   * Build the atl_first_visit data
   * @param {string} writeKey
   * @param pageViewProperties
   * @param refUrl
   * @returns
   */ // eslint-disable-next-line complexity
    static buildAtlFirstVisitData(writeKey, pageViewProperties, refUrl) {
        const expiry = 86400000; // 24 hours
        const orEmpty = (v)=>v !== null && v !== "" ? String(v) : "";
        const searchLogicEntries = JSON.stringify(Object.fromEntries(new URLSearchParams(window.location.search ?? "").entries()));
        const utms = (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).utms;
        const transformedUtms = {
            "name": utms?.["utm_campaign"] ?? "",
            "campaign": utms?.["utm_campaign"] ?? "",
            "sfdc-campaign_id": utms?.["utm_sfdc-campaign_id"] ?? "",
            "medium": utms?.["utm_medium"] ?? "",
            "source": utms?.["utm_source"] ?? "",
            "content": utms?.["utm_content"] ?? ""
        };
        return {
            "originProduct": pageViewProperties["originProduct"] ?? "",
            "campaign": transformedUtms,
            "page_url_params_json": searchLogicEntries,
            "page_url": orEmpty(window.location.href),
            "page_canonical_url": orEmpty((0, $60bf2125eaedf843$export$4dc2b60021baefca).maskURL((0, $60bf2125eaedf843$export$4dc2b60021baefca).getCanonicalUrl())),
            "page_path": orEmpty(window.location.pathname),
            "page_domain": orEmpty(window.location.hostname),
            "page_subdomain": orEmpty(window.location.hostname),
            "page_referrer_url": orEmpty(document.referrer),
            "page_referrer_domain": orEmpty(refUrl.hostname),
            "page_referrer_subdomain": orEmpty(refUrl.hostname),
            "page_url_parameters": orEmpty(window.location.search),
            "page_referrer_url_parameters": orEmpty(refUrl.search),
            "isMarketingEvent": (0, $039d497c173e44ba$export$d3e9576dd68d5e11).isMarketingEvent ?? false,
            "cookiesEnabled": window.navigator.cookieEnabled ?? "unknown",
            "activeGroups": orEmpty(window.OnetrustActiveGroups),
            "onboardingJourney": orEmpty(localStorage.getItem("onboarding-journey")),
            "cmsPageVariant": orEmpty(window.cmsPageVariant),
            "bxpGatewayRequestId": orEmpty((0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("bxp_gateway_request_id")),
            "user-agent": orEmpty(window.navigator.userAgent),
            "onboarding-journey": orEmpty(localStorage.getItem("onboarding-journey")),
            "writeKey": orEmpty(writeKey),
            "expiresAt": Date.now() + expiry
        };
    }
    static updateAtlFirstVisitActiveGroups() {
        const atl_first_visit_data = localStorage.getItem("atl_first_visit");
        if (atl_first_visit_data) {
            let parsedData;
            try {
                parsedData = JSON.parse(atl_first_visit_data);
                if (parsedData["activeGroups"] !== window.OnetrustActiveGroups) {
                    parsedData["activeGroups"] = window.OnetrustActiveGroups;
                    localStorage.setItem("atl_first_visit", JSON.stringify(parsedData));
                }
            } catch (e) {
                (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("atl_first_visit activeGroups update failed on page load", JSON.stringify(e));
            }
        }
    }
    static listenForActiveGroupsChange() {
        // listen for active groups change and update the atl_first_visit data
        let _activeGroups = window.OnetrustActiveGroups;
        try {
            Object.defineProperty(window, "OnetrustActiveGroups", {
                get: function() {
                    return _activeGroups;
                },
                set: function(newGroups) {
                    if (newGroups !== _activeGroups) {
                        _activeGroups = newGroups;
                        const atl_first_visit_data = localStorage.getItem("atl_first_visit");
                        if (atl_first_visit_data) {
                            let parsedData;
                            try {
                                parsedData = JSON.parse(atl_first_visit_data);
                            } catch  {
                                parsedData = {};
                            }
                            if (Object.keys(parsedData).length > 0) {
                                parsedData["activeGroups"] = newGroups;
                                localStorage.setItem("atl_first_visit", JSON.stringify(parsedData));
                            }
                        }
                    }
                },
                configurable: true
            });
        } catch (e) {
            const message = e instanceof Error ? e.message : String(e);
            (0, $60bf2125eaedf843$export$4dc2b60021baefca).sendWrapperLoadError("atl_first_visit activeGroups update failed", message);
        }
    }
    /**
   * Calls window functions that are awaiting a wrapper ready state
   * @function globalCallReady
   */ static globalCallReady() {
        if (typeof window.analyticsPageReady === "function") window.analyticsPageReady();
        (0, $7aaa8f64636160e1$export$ed9166ec0f465b5e).logMetric((0, $7aaa8f64636160e1$export$4657ae8822aeedd).TIME_TO_READY);
        (0, $7aaa8f64636160e1$export$ed9166ec0f465b5e).sendMetrics();
    }
    static captureAtlFirstVisitUTMs() {
        return {
            "utm_sfdc-campaign_id": "",
            "utm_campaign": "",
            "utm_medium": "",
            "utm_source": "",
            "utm_content": "",
            "utm_term": ""
        };
    }
    static captureUTMs() {
        const utmKeys = $cd1066d46ea94025$export$9e14a7677ef1423c.captureAtlFirstVisitUTMs();
        (0, $60fe77bbcb3e6704$export$4a20ceb938e79e70).utms = (0, $60bf2125eaedf843$export$4dc2b60021baefca).getAndSetUtms(utmKeys);
    }
    /**
   * Applies auto-tracking for select domains
   * @function autoTrack
   */ static autoTrack() {
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackButtons(true);
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackLinks(true);
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackVideos();
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackSelects();
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackTabs();
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).autoTrackDetails();
    }
    /**
   * Completes path overrides for Google Analytics
   * @function gaIntegration
   */ static gaIntegration() {
        const emailDetected = (0, $60bf2125eaedf843$export$4dc2b60021baefca).emailAddressIsDetected();
        const pathOverride = "/path-contained-email-address";
        if (typeof window.ga !== "undefined") {
            window.ga("require", "linker");
            window.ga("linker:autoLink", [
                "atlassian.com",
                "bitbucket.org",
                "hipchat.com",
                "attendease.com",
                "get.atlassian.com",
                "eegeventsite.secure.force.com",
                "atlassian.swoogo.com"
            ]);
            if (emailDetected) {
                // only override what is needed
                if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).urlContainsEmail(window.location.href)) {
                    window.ga("set", "location", window.location.origin + pathOverride);
                    window.ga("set", "path", pathOverride);
                }
                if ((0, $60bf2125eaedf843$export$4dc2b60021baefca).urlContainsEmail(document.referrer)) window.ga("set", "referrer", (0, $60bf2125eaedf843$export$4dc2b60021baefca).hostnameFromUrl(document.referrer) + pathOverride);
            }
        }
    }
    static setIsMarketingEvent(pageViewProperties) {
        if (typeof pageViewProperties["isMarketingEvent"] !== "boolean") (0, $039d497c173e44ba$export$d3e9576dd68d5e11).isMarketingEvent = true;
        else (0, $039d497c173e44ba$export$d3e9576dd68d5e11).isMarketingEvent = pageViewProperties["isMarketingEvent"];
    }
    static setXID(xid) {
        (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).xid = xid;
    }
}



var $iSvIT = parcelRequire("iSvIT");
function $0e732367c845567d$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $0e732367c845567d$export$bdc9792d96913679 = $0e732367c845567d$var$makeTypeChecker("Adg4Tab");
const $0e732367c845567d$export$9c326233b9ae5588 = $0e732367c845567d$var$makeTypeChecker("Adg4TabList");
const $0e732367c845567d$export$9e12445c79db89b = $0e732367c845567d$var$makeTypeChecker("Adg4TabPanel");
const $0e732367c845567d$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $0e732367c845567d$var$isTabChild(child) {
    return $0e732367c845567d$export$bdc9792d96913679(child) || $0e732367c845567d$export$9c326233b9ae5588(child) || $0e732367c845567d$export$9e12445c79db89b(child);
}
function $0e732367c845567d$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($0e732367c845567d$export$dbaa4172856e20ab(child)) return (0, $iSvIT.cloneElement)(child, {
        ...child.props,
        ...additionalProps
    });
    return child;
}
function $0e732367c845567d$export$ce7eaaed37329a1b(children, callback) {
    return (0, $iSvIT.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($0e732367c845567d$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $iSvIT.cloneElement)(child, {
            ...child.props,
            children: $0e732367c845567d$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $0e732367c845567d$export$519ada94592b97fc(children, callback) {
    return (0, $iSvIT.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($0e732367c845567d$export$bdc9792d96913679(child) || $0e732367c845567d$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($0e732367c845567d$export$9c326233b9ae5588(child)) callback(child, index);
            $0e732367c845567d$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}


const $8ff06814dab5c9d6$var$Adg4TabsContext = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $8ff06814dab5c9d6$export$8fc90cd28db43001 = ()=>{
    const context = (0, $iSvIT.useContext)($8ff06814dab5c9d6$var$Adg4TabsContext);
    if (!context) throw new Error("useAdg4TabsContext must be used within Adg4Tabs");
    return context;
};
let $8ff06814dab5c9d6$var$nextId = 0;
const $8ff06814dab5c9d6$export$e329eabcff0a2a4a = ({ id: id, initialTab: initialTab, loop: loop = true, children: children, tabSwitchInterval: tabSwitchInterval, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const [currentTab, setCurrentTab] = (0, $iSvIT.useState)(initialTab ?? 0);
    const [userSelected, setUserSelected] = (0, $iSvIT.useState)(false);
    const [focus, setFocus] = (0, $iSvIT.useState)(false);
    const tabIds = (0, $iSvIT.useRef)([]);
    const contextId = (0, $iSvIT.useRef)(`:tabs:${id ? id : $8ff06814dab5c9d6$var$nextId++}:`);
    const timerRef = (0, $iSvIT.useRef)();
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $478af79ecb9fb55b$export$2f62ee6831462844)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD,
        ...useInViewOptionsContainer
    });
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $478af79ecb9fb55b$export$2f62ee6831462844)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $0e732367c845567d$export$519ada94592b97fc)(children, (child)=>{
            if ((0, $0e732367c845567d$export$bdc9792d96913679)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - getTabsCount();
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $0e732367c845567d$export$ce7eaaed37329a1b)(children, (child)=>{
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? window.document.activeElement?.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $0e732367c845567d$export$9c326233b9ae5588)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $iSvIT.Children).toArray(child.props.children).filter((0, $0e732367c845567d$export$bdc9792d96913679)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, {
                    children: (0, $0e732367c845567d$export$ce7eaaed37329a1b)(child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $iSvIT.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $0e732367c845567d$export$9e12445c79db89b)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = {
                    ...existingProps,
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $iSvIT.cloneElement)(child, props);
            }
            return result;
        });
    }
    const goToTab = (tabIndex, clearTimer)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        if (clearTimer) {
            setUserSelected(true);
            clearInterval(timerRef.current);
        }
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $iSvIT.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $iSvIT.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Auto switch tabs effect
    (0, $iSvIT.useEffect)(()=>{
        // clear out any timer that exists
        if (timerRef.current) clearTimeout(timerRef.current);
        if (tabSwitchInterval && tabsContainerIsVisible && !userSelected) timerRef.current = setTimeout(goToNextTab, tabSwitchInterval);
        return ()=>{
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [
        currentTab,
        tabSwitchInterval,
        tabsContainerIsVisible,
        goToNextTab,
        userSelected
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $iSvIT.useEffect)(()=>{
        (0, $cd1066d46ea94025$export$9e14a7677ef1423c).autoTrack();
    }, [
        currentTab
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($8ff06814dab5c9d6$var$Adg4TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            ref: containerScrollRef,
            children: getChildren()
        })
    });
};



var $loA2J = parcelRequire("loA2J");
const $6e8a359f72c7aec9$export$79c66221ddbb3eb1 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "none",
        id: "icon-megaphone",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.5166 8.72656L16.2433 11.6366V19.3966L23.5166 22.3066V8.72656Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.1066 12.1201V18.9001H14.3033V23.2734H11.3933V18.9001H8.48328V12.1201H18.1066Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.1066 12.1201H16.2433V18.8968H18.1066V12.1201Z",
                fill: "#AE2A19"
            })
        ]
    });



var $loA2J = parcelRequire("loA2J");
const $6b72d7491e1de459$export$223f1f409e24a208 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        fill: "none",
        id: "icon-notepad",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.67 10.3564H8.02332V23.9998H21.6666V10.3564H21.67ZM10.95 14.7431H18.7466V13.2798H10.95V14.7431ZM10.95 17.9098H18.7466V16.4464H10.95V17.9098ZM15.8233 21.0764H10.95V19.6131H15.8233V21.0764Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.9833 15.1633L16 16L16.8367 13.0167L24.2767 5.57666L26.4233 7.72333L18.9833 15.1633Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.4967 10.3564L16.8367 13.0164L16.7633 13.2798H18.7467V14.7431H16.3533L16 15.9998L18.9833 15.1631L21.67 12.4764V10.3564H19.4967Z",
                fill: "#09326C"
            })
        ]
    });



var $loA2J = parcelRequire("loA2J");
const $9d96fa93db92bec9$export$c622ac6ddd491a46 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 33",
        fill: "none",
        id: "icon-rocket",
        width: size,
        height: size,
        version: "1.1",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.1933 16.3702L13.3067 14.2568L11.1933 12.1435L12.9567 10.3802H17.1867L20.36 7.20685H25.2933V12.1402L22.12 15.3135V19.5435L20.3567 21.3068L18.2433 19.1935L16.13 21.3068L14.1933 19.3702L16.5133 17.0502L15.4567 15.9935L13.1367 18.3135L11.1967 16.3735L11.1933 16.3702ZM22.8233 11.4368C22.3367 11.9235 21.5467 11.9235 21.06 11.4368C20.5733 10.9502 20.5733 10.1602 21.06 9.67351C21.5467 9.18685 22.3367 9.18685 22.8233 9.67351C23.31 10.1602 23.31 10.9502 22.8233 11.4368Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.8133 22.2068C14.69 24.3302 11.7067 25.7535 6.75333 25.6468C6.64333 20.6935 8.06667 17.7135 10.1933 15.5868C12.14 13.6402 15.17 13.2202 18.2233 14.1735C19.1767 17.2268 18.76 20.2568 16.81 22.2035L16.8133 22.2068Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.4367 19.3802L18.2467 19.1902L16.13 21.3035L14.1933 19.3669L16.5133 17.0469L15.4567 15.9902L13.1367 18.3102L11.1967 16.3702L13.31 14.2535L13.02 13.9635C14.5967 13.5235 16.4067 13.6069 18.2267 14.1735C18.7933 15.9935 18.8767 17.8035 18.4367 19.3802Z",
                fill: "#09326C"
            })
        ]
    });


/* content-type-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

/* raised-media.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $87cd6c26a4a4ed0a$var$raisedImage = null;
const $87cd6c26a4a4ed0a$export$bfa1278d9934b266 = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_16qs1qw3 _2rko1crf _1e0c1txw _1reo15vq _18m915vq",
            className
        ]),
        children: children
    });
};



/* column-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $iSvIT = parcelRequire("iSvIT");

var $5GZK9 = parcelRequire("5GZK9");


var $4LHd8 = parcelRequire("4LHd8");


var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
var $6c7e05446819bf8a$exports = {};
"use strict";
Object.defineProperty($6c7e05446819bf8a$exports, "__esModule", {
    value: true
});
$6c7e05446819bf8a$exports.parse = $6c7e05446819bf8a$var$parse;
$6c7e05446819bf8a$exports.serialize = $6c7e05446819bf8a$var$serialize;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $6c7e05446819bf8a$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $6c7e05446819bf8a$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $6c7e05446819bf8a$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $6c7e05446819bf8a$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
const $6c7e05446819bf8a$var$__toString = Object.prototype.toString;
const $6c7e05446819bf8a$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $6c7e05446819bf8a$var$parse(str, options) {
    const obj = new $6c7e05446819bf8a$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $6c7e05446819bf8a$var$decode;
    let index = 0;
    do {
        const eqIdx = str.indexOf("=", index);
        if (eqIdx === -1) break; // No more cookie pairs.
        const colonIdx = str.indexOf(";", index);
        const endIdx = colonIdx === -1 ? len : colonIdx;
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const keyStartIdx = $6c7e05446819bf8a$var$startIndex(str, index, eqIdx);
        const keyEndIdx = $6c7e05446819bf8a$var$endIndex(str, eqIdx, keyStartIdx);
        const key = str.slice(keyStartIdx, keyEndIdx);
        // only assign once
        if (obj[key] === undefined) {
            let valStartIdx = $6c7e05446819bf8a$var$startIndex(str, eqIdx + 1, endIdx);
            let valEndIdx = $6c7e05446819bf8a$var$endIndex(str, endIdx, valStartIdx);
            const value = dec(str.slice(valStartIdx, valEndIdx));
            obj[key] = value;
        }
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
function $6c7e05446819bf8a$var$startIndex(str, index, max) {
    do {
        const code = str.charCodeAt(index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index;
    }while (++index < max);
    return max;
}
function $6c7e05446819bf8a$var$endIndex(str, index, min) {
    while(index > min){
        const code = str.charCodeAt(--index);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) return index + 1;
    }
    return min;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 */ function $6c7e05446819bf8a$var$serialize(name, val, options) {
    const enc = options?.encode || encodeURIComponent;
    if (!$6c7e05446819bf8a$var$cookieNameRegExp.test(name)) throw new TypeError(`argument name is invalid: ${name}`);
    const value = enc(val);
    if (!$6c7e05446819bf8a$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${val}`);
    let str = name + "=" + value;
    if (!options) return str;
    if (options.maxAge !== undefined) {
        if (!Number.isInteger(options.maxAge)) throw new TypeError(`option maxAge is invalid: ${options.maxAge}`);
        str += "; Max-Age=" + options.maxAge;
    }
    if (options.domain) {
        if (!$6c7e05446819bf8a$var$domainValueRegExp.test(options.domain)) throw new TypeError(`option domain is invalid: ${options.domain}`);
        str += "; Domain=" + options.domain;
    }
    if (options.path) {
        if (!$6c7e05446819bf8a$var$pathValueRegExp.test(options.path)) throw new TypeError(`option path is invalid: ${options.path}`);
        str += "; Path=" + options.path;
    }
    if (options.expires) {
        if (!$6c7e05446819bf8a$var$isDate(options.expires) || !Number.isFinite(options.expires.valueOf())) throw new TypeError(`option expires is invalid: ${options.expires}`);
        str += "; Expires=" + options.expires.toUTCString();
    }
    if (options.httpOnly) str += "; HttpOnly";
    if (options.secure) str += "; Secure";
    if (options.partitioned) str += "; Partitioned";
    if (options.priority) {
        const priority = typeof options.priority === "string" ? options.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${options.priority}`);
        }
    }
    if (options.sameSite) {
        const sameSite = typeof options.sameSite === "string" ? options.sameSite.toLowerCase() : options.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${options.sameSite}`);
        }
    }
    return str;
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $6c7e05446819bf8a$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $6c7e05446819bf8a$var$isDate(val) {
    return $6c7e05446819bf8a$var$__toString.call(val) === "[object Date]";
}


const $d4ee4c82e6c358af$var$isCPRA = (locationData)=>{
    const country = locationData?.countryIsoCode?.toUpperCase();
    const state = locationData?.regionIsoCode?.toUpperCase();
    return country === "US" && state === "CA";
};
const $d4ee4c82e6c358af$export$29027ffe85b122de = (cookieString)=>{
    if (!cookieString) return undefined;
    const cookies = (0, $6c7e05446819bf8a$exports.parse)(cookieString);
    return cookies["OptanonConsent"];
};
const $d4ee4c82e6c358af$export$f31515c886c1288b = (optanonConsentCookie, locationData)=>{
    if (optanonConsentCookie === null || optanonConsentCookie === undefined) {
        if ($d4ee4c82e6c358af$var$isCPRA(locationData)) return false;
        return true;
    }
    const params = new URLSearchParams(optanonConsentCookie);
    const groups = params.get("groups");
    if (groups === null) return true;
    const groupPairs = groups.split(",");
    return groupPairs.includes("2:1");
};
const $d4ee4c82e6c358af$var$OneTrustContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    analyticsOptOut: true,
    isConsentLoaded: false
});
const $d4ee4c82e6c358af$export$b224af886b957a5e = ()=>{
    const context = (0, $iSvIT.useContext)($d4ee4c82e6c358af$var$OneTrustContext);
    if (!context) throw new Error("calls to useOneTrustContext must be wrapped in <OneTrustProvider>");
    return context;
};
const $d4ee4c82e6c358af$export$52310512b1bd7aec = ({ children: children, isUniformPlayground: isUniformPlayground = false })=>{
    // In Uniform Playground (preview authoring environment) we skip OneTrust entirely
    // and assume all cookies are accepted so the consent banner does not interrupt authors.
    const [analyticsOptOut, setAnalyticsOptOut] = (0, $iSvIT.useState)(!!!isUniformPlayground);
    // check if onetrust consent is loaded to GTM data layer
    const [isConsentLoaded, setIsConsentLoaded] = (0, $iSvIT.useState)(isUniformPlayground);
    (0, $iSvIT.useEffect)(()=>{
        // Skip OneTrust polling entirely in Uniform Playground — banner should never appear for authors.
        if (isUniformPlayground) return;
        const checkOnetrustActiveGroups = ()=>{
            if (window.OnetrustActiveGroups === undefined) return;
            const currentAnalyticsOptOut = !window.OnetrustActiveGroups.includes(",2,");
            if (analyticsOptOut !== currentAnalyticsOptOut) setAnalyticsOptOut(currentAnalyticsOptOut);
            /**
       * Clear the interval once the OneTrust has been initialized and only recheck every 1 sec if the optout status is still the default (true).
       */ clearInterval(setIntervalId);
            if (currentAnalyticsOptOut) setIntervalId = setInterval(checkOnetrustActiveGroups, 1000);
        };
        let setIntervalId = setInterval(checkOnetrustActiveGroups, 250);
        return ()=>{
            clearInterval(setIntervalId);
        };
    }, [
        analyticsOptOut,
        isUniformPlayground
    ]);
    (0, $iSvIT.useEffect)(()=>{
        // Skip data layer monitoring in Uniform Playground — consent is already assumed.
        if (isUniformPlayground) return;
        // Monitor data layer for consent update events
        const checkDataLayerForConsentUpdates = ()=>{
            if (!window.dataLayer) return;
            const dataLayer = window.dataLayer;
            for (const event of dataLayer){
                // Check for OneTrust consent update events which are arrays like
                if (event && event[0] && event[1]) {
                    if (event[0] === "consent" && event[1] === "update") {
                        setIsConsentLoaded(true);
                        clearInterval(dataLayerIntervalId);
                    }
                }
            }
        };
        // Check data layer for consent updates every 250ms
        const dataLayerIntervalId = setInterval(checkDataLayerForConsentUpdates, 250);
        return ()=>{
            clearInterval(dataLayerIntervalId);
        };
    }, [
        isConsentLoaded,
        isUniformPlayground
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($d4ee4c82e6c358af$var$OneTrustContext.Provider, {
        value: {
            analyticsOptOut: analyticsOptOut,
            isConsentLoaded: isConsentLoaded
        },
        children: children
    });
};


const $9e7dba6014f411d3$var$getAnonIdUsedByFeatureGatesClientInSSR = ()=>window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
const $9e7dba6014f411d3$var$AnalyticsWebClientContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    analyticsWebClientInstance: null
});
const $9e7dba6014f411d3$export$f84a51d6dd0d7383 = (props)=>{
    const [analyticsWebClientInstance, setAnalyticsWebClientInstance] = (0, $iSvIT.useState)(null);
    const { analyticsOptOut: analyticsOptOut } = (0, $d4ee4c82e6c358af$export$b224af886b957a5e)();
    (0, $iSvIT.useEffect)(()=>{
        if (!props.analyticsWebClient) return;
        if (!analyticsOptOut) {
            // If the FeatureGates and analytics clients are using different identifiers,
            // it means that the client already had an anonymousId in localStorage and/or cookies,
            // but SSR was unable to use it, either because the client had blocked sending cookies,
            // or because there was some issue extracting it.
            // An identifier mismatch means we won't be able to include this session in the experiment metrics.
            // We capture an operational event here as a way to tell how much data we've lost in our experiment results.
            const featureGatesAnonId = $9e7dba6014f411d3$var$getAnonIdUsedByFeatureGatesClientInSSR();
            if (featureGatesAnonId !== props.analyticsWebClient.getAnonymousId()) props.analyticsWebClient.sendOperationalEvent({
                action: "mismatched",
                actionSubject: "anonymousId",
                source: "awcInitialization",
                attributes: {
                    featureGatesAnonId: featureGatesAnonId,
                    route: props.location.pathname
                }
            });
            setAnalyticsWebClientInstance(props.analyticsWebClient);
            return;
        }
        const isEnableOperationalEventWhenOptedOut = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp10416DisableNonOperationalAnalyticsGateUip);
        if (isEnableOperationalEventWhenOptedOut) // Set client even when opted out so the listener can send operational events (e.g. page view)
        setAnalyticsWebClientInstance(props.analyticsWebClient);
    }, [
        analyticsOptOut,
        props.analyticsWebClient,
        props.location.pathname
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($9e7dba6014f411d3$var$AnalyticsWebClientContext.Provider, {
        value: {
            analyticsWebClientInstance: analyticsWebClientInstance
        },
        children: props.children
    });
};
const $9e7dba6014f411d3$export$923054f18cb06572 = ()=>{
    const context = (0, $iSvIT.useContext)($9e7dba6014f411d3$var$AnalyticsWebClientContext);
    if (!context) throw new Error("calls to useAnalyticsClient must be wrapped in <WacAnalyticsClientProvider>!");
    return context.analyticsWebClientInstance;
};



const $9c61cb62703e5ab5$var$firedExposures = new Map();
function $9c61cb62703e5ab5$export$633a89f47b4b506d(experimentName, group) {
    return $9c61cb62703e5ab5$var$firedExposures.get(experimentName)?.has(group) ?? false;
}
function $9c61cb62703e5ab5$export$f3fc467b2bb3ee62(experimentName, group) {
    const groups = $9c61cb62703e5ab5$var$firedExposures.get(experimentName) ?? new Set();
    if (groups.has(group)) return false;
    groups.add(group);
    $9c61cb62703e5ab5$var$firedExposures.set(experimentName, groups);
    return true;
}
function $9c61cb62703e5ab5$export$405f168c82b98ae9() {
    $9c61cb62703e5ab5$var$firedExposures.clear();
}



const $25ecfe45f85886e0$export$7184a614b8d5eae2 = {
    ENROLLED: "enrolled",
    NOT_ENROLLED: "notEnrolled",
    INDETERMINATE: "indeterminate"
};
function $25ecfe45f85886e0$var$getExperimentKeyValue(query, key) {
    if (!query.startsWith("?")) query = "?" + query;
    const params = new URLSearchParams(query);
    return params.get(key);
}
const $25ecfe45f85886e0$var$X_EXPERIMENTS_KEY = "X-Experiments-Key";
function $25ecfe45f85886e0$export$12481f4d12442b59(experiment, metadata) {
    const isInCohort = experiment.targeting.cohort();
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bc1d71a60bfff1c9$export$5bf35293e545f20c)();
    const analyticsClient = (0, $9e7dba6014f411d3$export$923054f18cb06572)();
    const hasFiredRef = (0, $iSvIT.useRef)(false);
    // Stabilize metadata to prevent unnecessary re-renders
    const stableMetadata = (0, $iSvIT.useMemo)(()=>metadata ?? {}, [
        metadata
    ]);
    const fireTrackingEvent = (0, $iSvIT.useCallback)((group, info)=>isInCohort ? $25ecfe45f85886e0$export$f86304593290690b(experimentName, analyticsClient, createAnalyticsEvent, {
            ...stableMetadata,
            ...info
        }, group) : ()=>console.warn(`${experimentName}: cannot fire tracking event; targeting criteria not met.`), [
        stableMetadata,
        isInCohort,
        experimentName,
        analyticsClient,
        createAnalyticsEvent
    ]);
    const experimentEnrollment = (0, $iSvIT.useMemo)(()=>{
        const status = $25ecfe45f85886e0$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, options);
        if (status.type === $25ecfe45f85886e0$export$7184a614b8d5eae2.ENROLLED) return {
            ...status,
            fireExposure: ()=>{
                if (!options.fireExperimentExposure) {
                    fireTrackingEvent(status.value, {
                        usingDefault: status.usingDefault
                    });
                    try {
                        (0, $4LHd8.default).manuallyLogExperimentExposure(experimentName);
                    } catch (error) {
                        console.warn(`Failed to fire exposure event for ${experimentName}: ${error}`);
                    }
                } else console.warn(`Exposure events for ${experimentName} are automatic and cannot be fired manually.`);
            }
        };
        return status;
    }, [
        isInCohort,
        experimentName,
        parameterName,
        defaultValue,
        options,
        fireTrackingEvent
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (typeof window !== "undefined" && experimentEnrollment.type === $25ecfe45f85886e0$export$7184a614b8d5eae2.ENROLLED) {
            const xExperimentsKey = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie($25ecfe45f85886e0$var$X_EXPERIMENTS_KEY);
            if (xExperimentsKey) {
                const decodedExperimentsKey = (0, (/*@__PURE__*/$parcel$interopDefault($5GZK9))).decompressFromBase64(xExperimentsKey.split("~")[1]);
                const evaluatedValueInExpKey = $25ecfe45f85886e0$var$getExperimentKeyValue(decodedExperimentsKey, experimentName);
                if (evaluatedValueInExpKey != null && String(experimentEnrollment.value) !== evaluatedValueInExpKey) {
                    const edgeTraceId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("X-Experiments-Trace-Id");
                    const featureGatesAnonIdUsedInSSR = window?.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
                    analyticsClient?.sendOperationalEvent({
                        action: "mismatched",
                        actionSubject: "experimentValue",
                        source: "useExperiment",
                        attributes: {
                            experimentName: experiment.experimentName,
                            route: window.location.pathname,
                            // @ts-ignore
                            anonIdUsedInSsrBeforeOverride: window?.ssrAnonId,
                            anonIdUsedInSSR: featureGatesAnonIdUsedInSSR,
                            anonIdInAnalyticsClient: analyticsClient.getAnonymousId(),
                            experimentKeyValue: evaluatedValueInExpKey,
                            traceId: edgeTraceId,
                            experimentValue: String(experimentEnrollment.value),
                            // @ts-ignore
                            fallback: window.IS_STATIC ? "true" : "false"
                        }
                    });
                }
            }
        }
        // fire tracking if automatic exposures are enabled.
        // Only fire once when user becomes enrolled, not on every state change
        if (experimentEnrollment.type === $25ecfe45f85886e0$export$7184a614b8d5eae2.ENROLLED && options.fireExperimentExposure && !hasFiredRef.current) {
            const enrolled = experimentEnrollment;
            fireTrackingEvent(enrolled.value, {
                usingDefault: enrolled.usingDefault
            });
            hasFiredRef.current = true;
        }
    }, [
        experimentEnrollment.type,
        options.fireExperimentExposure,
        fireTrackingEvent
    ]);
    return experimentEnrollment;
}
function $25ecfe45f85886e0$export$2f86411d819a755e(experiment) {
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const isInCohort = experiment.targeting.cohort();
    return $25ecfe45f85886e0$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, // Disable automatic firing of exposure events.
    {
        ...options,
        fireExperimentExposure: false
    });
}
function $25ecfe45f85886e0$export$37ab8203aaeb6e80(experiment) {
    const { experimentName: experimentName, parameterName: parameterName, defaultValue: defaultValue, options: options } = experiment;
    const isInCohort = experiment.targeting.cohort();
    return $25ecfe45f85886e0$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, // Automatically fire experiment exposures
    {
        ...options,
        fireExperimentExposure: true
    });
}
function $25ecfe45f85886e0$var$getExperimentStatus(experimentName, parameterName, defaultValue, isInCohort, options) {
    if (isInCohort === undefined) return {
        type: $25ecfe45f85886e0$export$7184a614b8d5eae2.INDETERMINATE
    };
    if (!isInCohort) return {
        type: $25ecfe45f85886e0$export$7184a614b8d5eae2.NOT_ENROLLED,
        value: defaultValue
    };
    const experimentValue = (0, $4LHd8.default).getExperimentValue(experimentName, parameterName, undefined, options);
    const usingDefault = experimentValue === undefined;
    const value = usingDefault ? defaultValue : experimentValue;
    return {
        type: $25ecfe45f85886e0$export$7184a614b8d5eae2.ENROLLED,
        parameterName: parameterName,
        value: value,
        usingDefault: usingDefault
    };
}
function $25ecfe45f85886e0$export$f86304593290690b(experimentName, analyticsClient, createAnalyticsEvent, metadata, group) {
    if (!analyticsClient) return;
    if (!(0, $9c61cb62703e5ab5$export$f3fc467b2bb3ee62)(experimentName, String(group))) return;
    // register feature flag exposure with Sentry client
    (0, $8550c3151a99e1cc$export$823d4c94f9c66ca0)(experimentName, group);
    const traceId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("X-Experiments-Trace-Id");
    // fire feature exposed event
    createAnalyticsEvent({
        source: experimentName,
        actionSubject: "feature",
        action: "exposed",
        actionSubjectId: experimentName,
        attributes: (0, $039d497c173e44ba$export$d3e9576dd68d5e11).enrichEventData({
            ...metadata,
            group: group,
            edgeTraceId: traceId ? traceId : undefined
        }),
        eventType: "track"
    }).fire();
}


/**
 * Standalone definitions for the four WAC Refresh Q4 FY26 experiments.
 *
 * These are intentionally kept OUT of `./manifest.ts` so that consumers
 * (notably `wac-refresh-context.tsx`, which is imported by foundation
 * components like `column-layout.tsx`) can reference them without
 * transitively pulling in the manifest's `@/components/user-context`
 * import — which causes a circular module-evaluation crash in tests
 * that load `signup/utils` while it is mid-evaluation.
 *
 * The manifest re-exports these so the rest of the codebase continues
 * to access them via `experiments.wacRefreshJira` etc. unchanged.
 *
 * Note: the `cohort` callbacks intentionally do NOT import from
 * `@/components/user-context` (which would re-introduce the circular
 * dependency). Instead we inline a local copy of `useSpecifiedPathnames`
 * — a 4-line helper that only reads the current pathname from the
 * location provider — see source at
 * `services/wac-web/src/components/user-context/helpers/cohorts.ts`.
 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $XAEGR = parcelRequire("XAEGR");
const $f24bb8cd7cd93d4c$export$e6a44b110a0c44d3 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $f24bb8cd7cd93d4c$export$5af065edda80e75c = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($f24bb8cd7cd93d4c$export$e6a44b110a0c44d3.Provider, {
        value: props.location,
        children: props.children
    });
};
/**
 * True when running in a non-production environment where useLocation() may run
 * without a LocationProvider (Jest, Gemini VR, Storybook). Production bundles
 * inline process.env.NODE_ENV as "production", so this branch is dead code in
 * deployed builds and useLocation still throws without a provider in production.
 */ function $f24bb8cd7cd93d4c$var$isNonProductionEnv() {
    if (typeof $XAEGR === "undefined") return false;
    const nodeEnv = "production";
    return nodeEnv === "test" || nodeEnv === "development";
}
const $f24bb8cd7cd93d4c$export$45d76561a5302f2b = ()=>{
    const location = (0, $iSvIT.useContext)($f24bb8cd7cd93d4c$export$e6a44b110a0c44d3);
    if (location) return location;
    if ($f24bb8cd7cd93d4c$var$isNonProductionEnv() && typeof window !== "undefined" && window.location) return window.location;
    throw new Error("useLocation must be used within a LocationProvider");
};


const $61da0903344e19a0$var$booleanTypeGuard = (value)=>typeof value === "boolean";
/**
 * Local copy of `useSpecifiedPathnames` from
 * `@/components/user-context/helpers/cohorts` — inlined here to avoid
 * re-introducing the circular import chain that this whole file exists
 * to break. Behaviour must stay in sync with the source.
 */ const $61da0903344e19a0$var$useSpecifiedPathnames = (pathnames)=>{
    const { pathname: currentPathname } = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    return pathnames.includes(currentPathname);
};
const $61da0903344e19a0$export$4fb3c8eb9a885607 = {
    experimentName: "wac-refresh-jira",
    parameterName: "isEnabled",
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $61da0903344e19a0$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $61da0903344e19a0$var$useSpecifiedPathnames([
                "/software/jira"
            ]);
        }
    },
    metadata: {
        description: "50/50 A/B test of the WAC Refresh design on the Jira Product Tour page",
        expectedReleaseDate: "06/02/2026",
        expectedRuntime: "19 days",
        context: {
            urls: [
                "/software/jira"
            ]
        }
    }
};
const $61da0903344e19a0$export$789dc19b5cc98fa8 = {
    experimentName: "wac-refresh-confluence",
    parameterName: "isEnabled",
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $61da0903344e19a0$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $61da0903344e19a0$var$useSpecifiedPathnames([
                "/software/confluence"
            ]);
        }
    },
    metadata: {
        description: "50/50 A/B test of the WAC Refresh design on the Confluence Product Tour page",
        expectedReleaseDate: "06/02/2026",
        expectedRuntime: "21 days",
        context: {
            urls: [
                "/software/confluence"
            ]
        }
    }
};
const $61da0903344e19a0$export$2e5d92ea3e9294ac = {
    experimentName: "wac-refresh-homepage",
    parameterName: "isEnabled",
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $61da0903344e19a0$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $61da0903344e19a0$var$useSpecifiedPathnames([
                "/"
            ]);
        }
    },
    metadata: {
        description: "50/50 A/B test of the WAC Refresh design on the Atlassian homepage",
        expectedReleaseDate: "06/02/2026",
        expectedRuntime: "23 days",
        context: {
            urls: [
                "/"
            ]
        }
    }
};
const $61da0903344e19a0$export$7e8138eb6f7646bb = {
    experimentName: "wac-refresh-twc-rovo",
    parameterName: "isEnabled",
    defaultValue: false,
    options: {
        fireExperimentExposure: true,
        typeGuard: $61da0903344e19a0$var$booleanTypeGuard
    },
    targeting: {
        cohort: ()=>{
            // oxlint-disable-next-line react-hooks/rules-of-hooks
            return $61da0903344e19a0$var$useSpecifiedPathnames([
                "/software/rovo",
                "/collections/teamwork"
            ]);
        }
    },
    metadata: {
        description: "50/50 A/B test of the WAC Refresh design on the Rovo and Teamwork Collection pages",
        expectedReleaseDate: "06/02/2026",
        expectedRuntime: "TBD",
        context: {
            urls: [
                "/software/rovo",
                "/collections/teamwork"
            ]
        }
    }
};




const $3163e49dcd7e5a60$var$WacRefreshContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    isWacRefresh: false
});
const $3163e49dcd7e5a60$export$9fac0d8112b57bab = ({ isWacRefresh: isWacRefreshOverride, children: children })=>{
    const isWACRefreshGateEnabled = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).wacRefreshTeam26Gate);
    // Get the experiments without firing exposures.
    // Exposures are fired in the Uniform experiment container (Jira, Confluence, TWC, Rovo)
    // and in get-route.tsx (Homepage)
    const jiraExperiment = (0, $25ecfe45f85886e0$export$2f86411d819a755e)((0, $61da0903344e19a0$export$4fb3c8eb9a885607));
    const confluenceExperiment = (0, $25ecfe45f85886e0$export$2f86411d819a755e)((0, $61da0903344e19a0$export$789dc19b5cc98fa8));
    const homepageExperiment = (0, $25ecfe45f85886e0$export$2f86411d819a755e)((0, $61da0903344e19a0$export$2e5d92ea3e9294ac));
    const twcRovoExperiment = (0, $25ecfe45f85886e0$export$2f86411d819a755e)((0, $61da0903344e19a0$export$7e8138eb6f7646bb));
    const wacRefreshExperimentEnabled = jiraExperiment.type === (0, $25ecfe45f85886e0$export$7184a614b8d5eae2).ENROLLED && jiraExperiment.value || confluenceExperiment.type === (0, $25ecfe45f85886e0$export$7184a614b8d5eae2).ENROLLED && confluenceExperiment.value || homepageExperiment.type === (0, $25ecfe45f85886e0$export$7184a614b8d5eae2).ENROLLED && homepageExperiment.value || twcRovoExperiment.type === (0, $25ecfe45f85886e0$export$7184a614b8d5eae2).ENROLLED && twcRovoExperiment.value;
    const value = (0, $iSvIT.useMemo)(()=>({
            isWacRefresh: isWacRefreshOverride ?? (isWACRefreshGateEnabled || wacRefreshExperimentEnabled)
        }), [
        isWacRefreshOverride,
        isWACRefreshGateEnabled,
        wacRefreshExperimentEnabled
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($3163e49dcd7e5a60$var$WacRefreshContext.Provider, {
        value: value,
        children: children
    });
};
const $3163e49dcd7e5a60$export$861b2ebd3848bc68 = ()=>{
    const { isWacRefresh: isWacRefresh } = (0, $iSvIT.useContext)($3163e49dcd7e5a60$var$WacRefreshContext);
    return isWacRefresh;
};


const $190830b8c61b7d0a$var$baseStyle = null;
const $190830b8c61b7d0a$var$fullWidthStyles = null;
const $190830b8c61b7d0a$var$xlDesktopBreakpointStyles = null;
const $190830b8c61b7d0a$var$layout10 = null;
const $190830b8c61b7d0a$var$layout8 = null;
const $190830b8c61b7d0a$var$layout84 = null;
const $190830b8c61b7d0a$var$layout48 = null;
const $190830b8c61b7d0a$var$layout93 = null;
const $190830b8c61b7d0a$var$layout39 = null;
const $190830b8c61b7d0a$var$layout66 = null;
const $190830b8c61b7d0a$var$layout75 = null;
const $190830b8c61b7d0a$var$layout57 = null;
const $190830b8c61b7d0a$var$layout336 = null;
const $190830b8c61b7d0a$var$layout633 = null;
const $190830b8c61b7d0a$var$layout444 = null;
const $190830b8c61b7d0a$var$layout3333 = null;
const $190830b8c61b7d0a$var$layout222222 = null;
const $190830b8c61b7d0a$var$layoutArticle = null;
const $190830b8c61b7d0a$var$layoutOverlay = null;
const $190830b8c61b7d0a$var$tabletLayout12 = null;
const $190830b8c61b7d0a$var$tabletLayout10 = null;
const $190830b8c61b7d0a$var$tabletLayout66 = null;
const $190830b8c61b7d0a$var$tabletLayout444 = null;
const $190830b8c61b7d0a$var$tabletLayout84 = null;
const $190830b8c61b7d0a$var$tabletLayout48 = null;
const $190830b8c61b7d0a$var$tabletLayout75 = null;
const $190830b8c61b7d0a$var$tabletLayout57 = null;
const $190830b8c61b7d0a$var$tabletLayout1266 = null;
const $190830b8c61b7d0a$var$tabletLayout6612 = null;
const $190830b8c61b7d0a$var$mobileLayout12 = null;
const $190830b8c61b7d0a$var$mobileLayout66 = null;
const $190830b8c61b7d0a$var$mobileLayout1266 = null;
const $190830b8c61b7d0a$var$mobileLayout6612 = null;
const $190830b8c61b7d0a$var$resetListStyles = null;
const $190830b8c61b7d0a$var$mobileReverseOrderStyles = null; // Compiled styling requires complex set of choices
const $190830b8c61b7d0a$export$c7e5bac7049eee2a = ({ layout: layout = "12", tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", horizontalAlignment: horizontalAlignment = "normal", renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder = false, children: children // eslint-disable-next-line complexity
 })=>{
    const paddingTopObject = {
        // @ts-ignore
        mobile: paddingTopv2?.mobile ?? paddingTopv2 ?? "0",
        tablet: // @ts-ignore
        paddingTopv2?.tablet ?? paddingTopv2?.mobile ?? paddingTopv2 ?? "0",
        desktop: // @ts-ignore
        paddingTopv2?.desktop ?? // @ts-ignore
        paddingTopv2?.tablet ?? // @ts-ignore
        paddingTopv2?.mobile ?? paddingTopv2 ?? "0"
    };
    const paddingBottomObject = {
        // @ts-ignore
        mobile: paddingBottomv2?.mobile ?? paddingBottomv2 ?? "0",
        tablet: // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? paddingBottomv2 ?? "0",
        desktop: // @ts-ignore
        paddingBottomv2?.desktop ?? // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? paddingBottomv2 ?? "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList ?? "div";
    const isWacRefresh = (0, $3163e49dcd7e5a60$export$861b2ebd3848bc68)();
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            renderAsList && "_qtt815ep _bozgidpf _1mouidpf _1xtx1txw _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            "_195g1wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
            isWacRefresh && "_12z7bv7e _14mbbv7e _1i7q107j",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp _1bahghyw",
            mobileReverseOrder && "_14ls11wp _pecscs5v _xt6dkb7n",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6",
            layout === "article" && "_z9r4exmx _1rqti0c8",
            layout === "overlay" && "_yv0ecx6w",
            tabletLayout && tabletLayout === "12" && "_1da7n7od _ju75n7od",
            tabletLayout && tabletLayout === "10" && "_1da7cx6w _ju75179g",
            tabletLayout && tabletLayout === "6-6" && "_1da7wxkt",
            tabletLayout && tabletLayout === "4-4-4" && "_1da716hb",
            tabletLayout && tabletLayout === "8-4" && "_rcp0exmx _1da71890",
            tabletLayout && tabletLayout === "4-8" && "_rcp0exmx _1da7i0c8",
            tabletLayout && tabletLayout === "7-5" && "_osdn12kr _1da7kxgm",
            tabletLayout && tabletLayout === "5-7" && "_osdn12kr _1da7dq95",
            tabletLayout && tabletLayout === "12, 6-6" && "_1da7cx6w _xkuwuufb _1p8l1xic",
            tabletLayout && tabletLayout === "6-6, 12" && "_1da7cx6w _10chuufb _1f0v1xic",
            mobileLayout && mobileLayout === "12" && "_19d7n7od _kw77n7od",
            mobileLayout && mobileLayout === "6-6" && "_19d7wxkt",
            mobileLayout && mobileLayout === "12, 6-6" && "_19d7cx6w _17y1uufb _17541xic",
            mobileLayout && mobileLayout === "6-6, 12" && "_19d7cx6w _yu5luufb _18kp1xic"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment),
            "--_1p6jxu0": (0, $43MIc.default)(horizontalAlignment)
        },
        children: children
    });
}; // intended for use within Column Layouts or other components that already have the 12 column grid defined
const $190830b8c61b7d0a$export$12bf7d6826410442 = ({ layout: layout = "12", tabletLayout: tabletLayout, mobileLayout: mobileLayout, paddingTopv2: paddingTopv2, paddingBottomv2: paddingBottomv2, verticalAlignment: verticalAlignment = "normal", renderAsList: renderAsList, mobileReverseOrder: mobileReverseOrder = false, children: children // eslint-disable-next-line complexity
 })=>{
    const paddingTopObject = {
        // @ts-ignore
        mobile: paddingTopv2?.mobile ?? "0",
        // @ts-ignore
        tablet: paddingTopv2?.tablet ?? paddingTopv2?.mobile ?? "0",
        desktop: // @ts-ignore
        paddingTopv2?.desktop ?? // @ts-ignore
        paddingTopv2?.tablet ?? // @ts-ignore
        paddingTopv2?.mobile ?? "0"
    };
    const paddingBottomObject = {
        // @ts-ignore
        mobile: paddingBottomv2?.mobile ?? "0",
        // @ts-ignore
        tablet: paddingBottomv2?.tablet ?? paddingBottomv2?.mobile ?? "0",
        // @ts-ignore
        desktop: // @ts-ignore
        paddingBottomv2?.desktop ?? // @ts-ignore
        paddingBottomv2?.tablet ?? // @ts-ignore
        paddingBottomv2?.mobile ?? "0"
    };
    const paddingStyles = null;
    const alignmentStyles = null;
    const Container = renderAsList ?? "div";
    return /*#__PURE__*/ (0, $loA2J.jsx)(Container, {
        className: (0, $esG4f.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _13ltwklj _1vsw1vi7 _99hyidpf",
            "_1q51aqwo _85i51jtx _1waf136c _1yd317nz _26vx1ut2 _40tu7014",
            "_4cvr1ekp",
            renderAsList && "_qtt815ep _bozgidpf _1mouidpf _1xtx1txw _1e7yidpf _go4ridpf _omn3idpf _s22yidpf _1eg6idpf _1xnlidpf _53osidpf _138kidpf",
            mobileReverseOrder && "_14ls11wp _pecscs5v _xt6dkb7n",
            layout === "10" && "_1j8bcx6w _klsv179g",
            layout === "8" && "_1j8bcx6w _klsveqnf",
            layout === "8-4" && "_19smexmx _1j8b1890",
            layout === "4-8" && "_19smexmx _1j8bi0c8",
            layout === "9-3" && "_1i4gqiai _1j8b1i9f",
            layout === "3-9" && "_1i4gqiai _1j8bvfzv",
            layout === "7-5" && "_13wb12kr _1j8bkxgm",
            layout === "5-7" && "_13wb12kr _1j8bdq95",
            layout === "6-6" && "_1j8bwxkt",
            layout === "4-4-4" && "_1j8b16hb",
            layout === "3-3-3-3" && "_1j8bwxkt _1rqt1ezz",
            layout === "2-2-2-2-2-2" && "_yv0ewxkt _1j8b1g7m",
            layout === "6-3-3" && "_1i4gqiai _1j8b1jr3",
            layout === "3-3-6" && "_1i4gqiai _1j8bmdi6",
            tabletLayout && tabletLayout === "12" && "_1da7n7od _ju75n7od",
            tabletLayout && tabletLayout === "10" && "_1da7cx6w _ju75179g",
            tabletLayout && tabletLayout === "6-6" && "_1da7wxkt",
            tabletLayout && tabletLayout === "4-4-4" && "_1da716hb",
            tabletLayout && tabletLayout === "8-4" && "_rcp0exmx _1da71890",
            tabletLayout && tabletLayout === "4-8" && "_rcp0exmx _1da7i0c8",
            tabletLayout && tabletLayout === "7-5" && "_osdn12kr _1da7kxgm",
            tabletLayout && tabletLayout === "5-7" && "_osdn12kr _1da7dq95",
            tabletLayout && tabletLayout === "12, 6-6" && "_1da7cx6w _xkuwuufb _1p8l1xic",
            tabletLayout && tabletLayout === "6-6, 12" && "_1da7cx6w _10chuufb _1f0v1xic",
            mobileLayout && mobileLayout === "12" && "_19d7n7od _kw77n7od",
            mobileLayout && mobileLayout === "6-6" && "_19d7wxkt",
            mobileLayout && mobileLayout === "12, 6-6" && "_19d7cx6w _17y1uufb _17541xic",
            mobileLayout && mobileLayout === "6-6, 12" && "_19d7cx6w _yu5luufb _18kp1xic"
        ]),
        style: {
            "--_x9jeny": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.mobile + ")"),
            "--_15jk1js": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.mobile + ")"),
            "--_d48zib": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.tablet + ")"),
            "--_8w0mk6": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.tablet + ")"),
            "--_1l28e2h": (0, $43MIc.default)("var(--ds-space-" + paddingTopObject.desktop + ")"),
            "--_14v99j0": (0, $43MIc.default)("var(--ds-space-" + paddingBottomObject.desktop + ")"),
            "--_1813xhc": (0, $43MIc.default)(verticalAlignment)
        },
        children: children
    });
}; // Both components are exported as named exports above


// WAC name for a token we created
const $bd80a416932970ed$export$dbddf1c117e75747 = [
    // Colors
    // Primary
    "color.primary.blue",
    "color.primary.lime",
    "color.primary.purple",
    "color.primary.saffron",
    "color.primary.black",
    // Secondary
    "color.secondary.navy",
    "color.secondary.green",
    "color.secondary.red",
    // Extended
    // Blues
    "color.extended.blue100",
    "color.extended.blue200",
    "color.extended.blue300",
    "color.extended.blue400",
    "color.extended.blue500",
    "color.extended.blue600",
    "color.extended.blue700",
    "color.extended.blue800",
    "color.extended.blue900",
    "color.extended.blue1000",
    // Limes
    "color.extended.lime100",
    "color.extended.lime200",
    "color.extended.lime300",
    "color.extended.lime400",
    "color.extended.lime500",
    "color.extended.lime600",
    "color.extended.lime700",
    "color.extended.lime800",
    "color.extended.lime900",
    "color.extended.lime1000",
    // Purples
    "color.extended.purple100",
    "color.extended.purple200",
    "color.extended.purple300",
    "color.extended.purple400",
    "color.extended.purple500",
    "color.extended.purple600",
    "color.extended.purple700",
    "color.extended.purple800",
    "color.extended.purple900",
    "color.extended.purple1000",
    // Saffrons
    "color.extended.saffron100",
    "color.extended.saffron200",
    "color.extended.saffron300",
    "color.extended.saffron400",
    "color.extended.saffron500",
    "color.extended.saffron600",
    "color.extended.saffron700",
    "color.extended.saffron800",
    "color.extended.saffron900",
    "color.extended.saffron1000",
    // Neutral Opaque
    "color.neutral.light0",
    "color.neutral.light100",
    "color.neutral.light200",
    "color.neutral.light300",
    "color.neutral.light400",
    "color.neutral.light500",
    "color.neutral.light600",
    "color.neutral.light700",
    "color.neutral.light800",
    "color.neutral.light900",
    "color.neutral.light1000",
    "color.neutral.light1100",
    // Dark Neutral Opaque
    "color.neutral.dark0",
    "color.neutral.dark100",
    "color.neutral.dark200",
    "color.neutral.dark250",
    "color.neutral.dark300",
    "color.neutral.dark350",
    "color.neutral.dark400",
    "color.neutral.dark500",
    "color.neutral.dark600",
    "color.neutral.dark700",
    "color.neutral.dark800",
    "color.neutral.dark900",
    "color.neutral.dark1000",
    "color.neutral.dark1100",
    // Yellows
    "color.extended.yellow100",
    "color.extended.yellow200",
    "color.extended.yellow300",
    "color.extended.yellow400",
    "color.extended.yellow500",
    "color.extended.yellow600",
    "color.extended.yellow700",
    "color.extended.yellow800",
    "color.extended.yellow900",
    "color.extended.yellow1000",
    // Oranges
    "color.extended.orange100",
    "color.extended.orange200",
    "color.extended.orange300",
    "color.extended.orange400",
    "color.extended.orange500",
    "color.extended.orange600",
    "color.extended.orange700",
    "color.extended.orange800",
    "color.extended.orange900",
    "color.extended.orange1000",
    // ASOW Primary
    "color.asow.primary.blue",
    "color.asow.primary.lime",
    "color.asow.primary.purple",
    "color.asow.primary.yellow",
    "color.asow.primary.orange",
    "color.asow.primary.neutral",
    // Typography
    "font.charlie.display",
    "font.charlie.text",
    // Corner Radius
    "corner.radius.pill",
    "corner.radius.card",
    // Motion Property
    "motion.property.fade-in",
    "motion.property.fade-up",
    "motion.property.scale-in",
    "motion.property.slide-in-top",
    "motion.property.slide-in-bottom",
    "motion.property.slide-in-left",
    "motion.property.slide-in-right",
    "motion.property.fade-out",
    "motion.property.scale-out",
    "motion.property.slide-out-top",
    "motion.property.slide-out-bottom",
    "motion.property.slide-out-left",
    "motion.property.slide-out-right",
    // Motion Duration
    "motion.duration.0ms",
    "motion.duration.50ms",
    "motion.duration.100ms",
    "motion.duration.150ms",
    "motion.duration.200ms",
    "motion.duration.250ms",
    "motion.duration.400ms",
    "motion.duration.750ms",
    "motion.duration.1000ms",
    "motion.duration.6400ms",
    // Motion Easing
    "motion.easing.ease40-out",
    "motion.easing.quick-entrance",
    "motion.easing.ease.cubic-out",
    "motion.easing.natural-entrance",
    "motion.easing.ease60-in",
    "motion.easing.slow-exit",
    "motion.easing.ease40-in-out",
    "motion.easing.ease-both",
    "motion.easing.linear",
    "motion.easing.constant",
    // Motion Delay
    "motion.delay.0ms",
    "motion.delay.50ms",
    "motion.delay.100ms",
    "motion.delay.150ms",
    "motion.delay.200ms",
    "motion.delay.250ms",
    "motion.delay.300ms",
    "motion.delay.350ms",
    "motion.delay.400ms",
    "motion.delay.450ms",
    "motion.delay.500ms",
    "motion.delay.550ms"
];
const $bd80a416932970ed$export$8f4a6bdcbe7cb2d3 = {
    // Typography
    "font.charlie.display": "var(--bxp-charlie-display-font-family)",
    "font.charlie.text": "var(--bxp-charlie-text-font-family)",
    // Corner Radius
    "corner.radius.card": "20px",
    "corner.radius.pill": "10000px",
    // Motion Property (animation names; @keyframes live in index.css)
    "motion.property.fade-in": "wac-fade-in",
    "motion.property.fade-up": "wac-fade-up",
    "motion.property.scale-in": "wac-scale-in",
    "motion.property.slide-in-top": "wac-slide-in-top",
    "motion.property.slide-in-bottom": "wac-slide-in-bottom",
    "motion.property.slide-in-left": "wac-slide-in-left",
    "motion.property.slide-in-right": "wac-slide-in-right",
    "motion.property.fade-out": "wac-fade-out",
    "motion.property.scale-out": "wac-scale-out",
    "motion.property.slide-out-top": "wac-slide-out-top",
    "motion.property.slide-out-bottom": "wac-slide-out-bottom",
    "motion.property.slide-out-left": "wac-slide-out-left",
    "motion.property.slide-out-right": "wac-slide-out-right",
    // Motion Duration
    "motion.duration.0ms": "0ms",
    "motion.duration.50ms": "50ms",
    "motion.duration.100ms": "100ms",
    "motion.duration.150ms": "150ms",
    "motion.duration.200ms": "200ms",
    "motion.duration.250ms": "250ms",
    "motion.duration.400ms": "400ms",
    "motion.duration.750ms": "750ms",
    "motion.duration.1000ms": "1000ms",
    "motion.duration.6400ms": "6400ms",
    // Motion Easing
    "motion.easing.ease40-out": "cubic-bezier(0, 0.4, 0, 1)",
    "motion.easing.quick-entrance": "cubic-bezier(0, 0.4, 0, 1)",
    "motion.easing.ease.cubic-out": "cubic-bezier(0.33, 1, 0.68, 1)",
    "motion.easing.natural-entrance": "cubic-bezier(0.33, 1, 0.68, 1)",
    "motion.easing.ease60-in": "cubic-bezier(0.6, 0.01, 0.8, 0.6)",
    "motion.easing.slow-exit": "cubic-bezier(0.6, 0.01, 0.8, 0.6)",
    "motion.easing.ease40-in-out": "cubic-bezier(0.4, 0, 0, 1)",
    "motion.easing.ease-both": "cubic-bezier(0.4, 0, 0, 1)",
    "motion.easing.linear": "cubic-bezier(0, 0, 1, 1)",
    "motion.easing.constant": "cubic-bezier(0, 0, 1, 1)",
    // Motion Delay
    "motion.delay.0ms": "0ms",
    "motion.delay.50ms": "50ms",
    "motion.delay.100ms": "100ms",
    "motion.delay.150ms": "150ms",
    "motion.delay.200ms": "200ms",
    "motion.delay.250ms": "250ms",
    "motion.delay.300ms": "300ms",
    "motion.delay.350ms": "350ms",
    "motion.delay.400ms": "400ms",
    "motion.delay.450ms": "450ms",
    "motion.delay.500ms": "500ms",
    "motion.delay.550ms": "550ms",
    // Primary
    "color.primary.blue": "#1868DB",
    "color.primary.lime": "#82B536",
    "color.primary.purple": "#BF63F3",
    "color.primary.saffron": "#FCA700",
    "color.primary.black": "#101214",
    // Secondary
    "color.secondary.navy": "#09326C",
    "color.secondary.green": "#164B35",
    "color.secondary.red": "#AE2A19",
    // Extended
    // Blues
    "color.extended.blue100": "#e9f2fe",
    "color.extended.blue200": "#cfe1fd",
    "color.extended.blue300": "#8fb8f6",
    "color.extended.blue400": "#669DF1",
    "color.extended.blue500": "#4D8Ced",
    "color.extended.blue600": "#357DE8",
    "color.extended.blue700": "#1868DB",
    "color.extended.blue800": "#1558BC",
    "color.extended.blue900": "#123263",
    "color.extended.blue1000": "#1C2B42",
    // Limes
    "color.extended.lime100": "#EFFFD6",
    "color.extended.lime200": "#D3F1A7",
    "color.extended.lime300": "#B3DF72",
    "color.extended.lime400": "#94C748",
    "color.extended.lime500": "#82B536",
    "color.extended.lime600": "#6A9A23",
    "color.extended.lime700": "#5B7F24",
    "color.extended.lime800": "#4C6B1F",
    "color.extended.lime900": "#37471F",
    "color.extended.lime1000": "#28311B",
    // Purples
    "color.extended.purple100": "#F8EEFE",
    "color.extended.purple200": "#EED7FC",
    "color.extended.purple300": "#D8A0F7",
    "color.extended.purple400": "#C97CF4",
    "color.extended.purple500": "#BF63F3",
    "color.extended.purple600": "#AF59E1",
    "color.extended.purple700": "#964AC0",
    "color.extended.purple800": "#803FA5",
    "color.extended.purple900": "#48245D",
    "color.extended.purple1000": "#35243F",
    // Saffrons
    "color.extended.saffron100": "#FFF5D4",
    "color.extended.saffron200": "#FFE48F",
    "color.extended.saffron300": "#FFC716",
    "color.extended.saffron400": "#FCA700",
    "color.extended.saffron500": "#FA8700",
    "color.extended.saffron600": "#E56910",
    "color.extended.saffron700": "#BD5B00",
    "color.extended.saffron800": "#9E4C00",
    "color.extended.saffron900": "#693200",
    "color.extended.saffron1000": "#3A2C1F",
    // Neutral Opaque
    "color.neutral.light0": "#FFFFFF",
    "color.neutral.light100": "#f8f8f8",
    "color.neutral.light200": "#F0F1F2",
    "color.neutral.light300": "#DDDEE1",
    "color.neutral.light400": "#B7B9BE",
    "color.neutral.light500": "#8C8F97",
    "color.neutral.light600": "#7D818A",
    "color.neutral.light700": "#6C6F77",
    "color.neutral.light800": "#505258",
    "color.neutral.light900": "#3B3D42",
    "color.neutral.light1000": "#292A2E",
    "color.neutral.light1100": "#1E1F21",
    // Dark Neutral Opaque
    "color.neutral.dark0": "#18191A",
    "color.neutral.dark100": "#1F1F21",
    "color.neutral.dark200": "#242528",
    "color.neutral.dark250": "#B2C2F",
    "color.neutral.dark300": "#303134",
    "color.neutral.dark350": "#3D3F43",
    "color.neutral.dark400": "#4B4D51",
    "color.neutral.dark500": "#63666B",
    "color.neutral.dark600": "#7E8188",
    "color.neutral.dark700": "#96999E",
    "color.neutral.dark800": "#A9ABAF",
    "color.neutral.dark900": "#BFC1C4",
    "color.neutral.dark1000": "#CECFD2",
    "color.neutral.dark1100": "#E2E3E4",
    // Yellows
    "color.extended.yellow100": "#FFF6CB",
    "color.extended.yellow200": "#FFE88C",
    "color.extended.yellow300": "#FFC716",
    "color.extended.yellow400": "#F2AC00",
    "color.extended.yellow500": "#DF9800",
    "color.extended.yellow600": "#CB7E00",
    "color.extended.yellow700": "#B87000",
    "color.extended.yellow800": "#905500",
    "color.extended.yellow900": "#623600",
    "color.extended.yellow1000": "#43281A",
    // Oranges
    "color.extended.orange100": "#FFF0D7",
    "color.extended.orange200": "#FFDA9C",
    "color.extended.orange300": "#FB9700",
    "color.extended.orange400": "#F47B00",
    "color.extended.orange500": "#E56E00",
    "color.extended.orange600": "#D45D00",
    "color.extended.orange700": "#C75300",
    "color.extended.orange800": "#A13D00",
    "color.extended.orange900": "#641A00",
    "color.extended.orange1000": "#4B1C17",
    // ASOW Primary
    "color.asow.primary.blue": "#1868DB",
    "color.asow.primary.lime": "#94C748",
    "color.asow.primary.purple": "#C97CF4",
    "color.asow.primary.yellow": "#FFC716",
    "color.asow.primary.orange": "#FB9700",
    "color.asow.primary.neutral": "#DDDEE1"
};
function $bd80a416932970ed$export$29f256318842afd6(wacToken) {
    return $bd80a416932970ed$export$8f4a6bdcbe7cb2d3[wacToken];
}


const $41c7880d9169a529$var$wacToken = (token)=>{
    return (0, $bd80a416932970ed$export$29f256318842afd6)(token);
};
var $41c7880d9169a529$export$2e2bcd8739ae039 = $41c7880d9169a529$var$wacToken;




/* feature-info.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");


var $loA2J = parcelRequire("loA2J");
const $ac9fe5530b4ba1ed$export$73598a4b20da4aa6 = ({ size: size })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 68 69",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.557 39.6214C19.5694 39.6016 19.5693 39.5658 19.5941 39.538C18.8722 39.1886 18.7897 38.3308 18.2329 37.8185L18.2122 37.7986C17.6471 37.6239 17.7997 37.0798 17.0985 37.0758C17.0985 37.0758 17.28 36.9884 17.2841 36.9884C16.1456 35.9003 13.3323 33.2276 13.3323 33.2276C13.2704 33.4699 13.7819 33.0489 14.2976 33.1204C14.2976 33.1204 14.3347 33.0291 14.3718 33.1006C15.6877 31.8655 17.1686 31.3929 18.8516 30.8051C19.6931 30.5867 19.821 28.2952 18.3814 29.2444C18.3649 29.2285 18.3277 29.2166 18.3112 29.1888C17.808 29.7527 16.9706 29.5462 16.3353 29.8401L16.3106 29.852L15.2545 30.3484C14.6812 30.5748 14.0005 30.7535 13.2869 30.9283C13.3075 30.9084 13.3282 30.8885 13.3488 30.8687C13.3488 30.8687 13.423 29.7686 13.4024 29.2245C13.4024 29.2245 14.1243 28.3509 13.8851 27.7512C14.2934 27.0483 15.7454 25.5113 14.4254 25.0745C13.9923 25.0745 13.654 24.7131 13.5055 25.3843C13.4808 25.3803 13.4478 25.3882 13.4148 25.3763C13.3364 26.0713 12.4826 26.5638 12.2474 27.223L12.2392 27.2508C12.2969 27.8147 11.8432 28.3707 11.8391 28.3707C11.6245 28.887 11.344 29.4509 11.047 30.0386C10.9233 29.7209 10.7872 29.439 10.651 29.2365C10.156 28.7202 10.3664 21.6671 8.53489 23.2239C8.62152 24.5543 9.05873 25.9403 8.70398 27.1237C8.53073 27.215 8.79473 27.6876 9.00923 28.0729C8.99273 28.5613 8.88961 28.8234 8.86073 29.5224C7.95323 28.891 3.9932 25.6941 4.23658 27.8465C4.66146 28.0649 4.97082 28.3151 5.19357 28.8234C5.39982 29.0419 7.21898 30.0268 7.27673 30.273C7.15711 30.6145 9.30628 30.8885 8.43589 31.1427C8.56377 31.4127 8.73701 31.6709 8.93914 31.9211C7.99863 32.0164 6.87247 32.2824 6.28258 32.6279C6.17946 32.7987 2.42566 33.029 1.0644 33.8749C0.251765 34.3158 -0.465956 34.5342 0.379678 35.1974C0.684931 34.9591 1.83168 35.3007 1.80693 34.9869C2.08743 35.0981 3.98496 34.3991 4.19534 34.5183C4.29847 34.6771 5.79171 33.8352 5.61433 34.2324C6.64971 34.5143 7.91198 34.284 9.22374 33.9623C8.70399 34.7566 8.19252 35.8884 8.12652 36.5913C7.68101 37.4928 6.50534 39.4864 6.12996 40.7096C5.5937 41.5992 5.77935 41.6706 6.45585 42.1273L6.46824 42.1393C6.60849 42.2306 6.45174 42.1392 6.98387 42.1591C6.93025 42.1114 6.85184 41.905 6.74872 41.9407C6.81884 41.8017 7.62737 41.6031 7.28912 41.4165C7.27675 41.3887 7.80475 40.9995 7.85838 40.5785C8.32863 39.0774 9.45477 38.3188 10.288 36.6072C10.2674 36.7859 11.6699 40.1496 11.6039 41.8255C11.5008 42.6515 13.5798 43.8827 13.2787 42.04C13.3034 42.032 13.324 42.0003 13.3612 41.9963C13.027 41.2378 13.4684 40.4554 13.2952 39.685L13.2869 39.6532C12.9115 39.1846 13.3447 38.7954 12.7507 38.4142C12.7507 38.4142 12.9528 38.434 12.9569 38.438C12.6929 37.3459 12.5279 36.0115 12.2804 34.8161C13.1673 35.5905 13.9469 36.4245 14.2687 37.3419L14.3099 37.2824C14.3099 37.3102 14.3718 37.33 14.3182 37.3935C15.0648 37.5444 15.3206 37.8463 15.861 38.0488C15.861 38.0488 16.4384 39.0535 17.1108 39.0893L18.1338 40.4832C18.5752 41.202 20.9554 40.789 19.5735 39.6373L19.557 39.6214Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.5669 2.2075C42.553 2.2157 42.5416 2.23755 42.5177 2.24667C42.8478 2.69041 42.625 3.24131 42.8023 3.73206L42.8086 3.7508C43.0986 4.03772 42.8319 4.32183 43.2595 4.54769C43.2595 4.54769 43.1207 4.54332 43.1182 4.54201C43.4678 5.57026 44.3369 8.10121 44.3369 8.10121C44.4519 7.97276 44.0049 8.06727 43.7123 7.85926C43.7123 7.85926 43.6606 7.90329 43.6606 7.84774C42.4623 8.18387 41.406 8.00108 40.1894 7.82434C39.6051 7.68982 38.7969 9.05056 39.9797 8.92873C39.9848 8.9437 40.0037 8.9628 40.0049 8.98506C40.4924 8.8005 40.9388 9.19363 41.4209 9.21628L41.4398 9.21687L42.2439 9.24972C42.6667 9.29395 43.1399 9.40149 43.6321 9.52199C43.6131 9.52756 43.5942 9.53313 43.5752 9.53871C43.5752 9.53871 43.1793 10.1879 43.0186 10.5272C43.0186 10.5272 42.2987 10.8315 42.254 11.2745C41.7803 11.5743 40.4025 12.0517 41.0707 12.7394C41.3356 12.8774 41.4273 13.2062 41.732 12.8431C41.7459 12.8534 41.7686 12.859 41.7849 12.8768C42.0543 12.4768 42.7334 12.4476 43.0873 12.1193L43.1012 12.1049C43.2455 11.7416 43.7002 11.5462 43.7027 11.5475C43.9984 11.3001 44.3496 11.0446 44.7185 10.7797C44.693 11.0135 44.6864 11.2292 44.7051 11.3965C44.8434 11.87 42.4676 16.1166 44.0838 15.748C44.4546 14.9068 44.6288 13.9198 45.2228 13.309C45.3579 13.3084 45.347 12.9352 45.3386 12.6313C45.5043 12.3378 45.6509 12.2103 45.8912 11.792C46.2451 12.4674 47.6485 15.6843 48.1854 14.2903C47.9952 14.0213 47.8857 13.7698 47.9114 13.3879C47.8548 13.1886 47.056 12.0066 47.0991 11.8376C47.2811 11.6669 46.054 10.8145 46.6673 10.9364C46.6751 10.7305 46.6514 10.5174 46.6075 10.3C47.2131 10.5413 47.9866 10.7374 48.4575 10.7141C48.5749 10.6425 50.9442 11.6976 52.0463 11.6139C52.6837 11.6032 53.1923 11.6983 52.8864 11.0233C52.6238 11.0717 52.0312 10.4975 51.9464 10.6973C51.8103 10.5399 50.427 10.3628 50.3363 10.2229C50.3239 10.0929 49.1423 10.1321 49.3774 9.94569C48.8339 9.44336 47.9885 9.18209 47.0838 8.96089C47.6547 8.64071 48.3281 8.11144 48.5925 7.70256C49.1522 7.29314 50.5064 6.44839 51.1257 5.81989C51.7371 5.44667 51.6463 5.34382 51.3781 4.84896L51.3743 4.83772C51.3176 4.73717 51.3844 4.84299 51.0652 4.66131C51.0829 4.70754 51.065 4.85881 51.1395 4.8698C51.0523 4.93247 50.4945 4.79633 50.6419 5.01826C50.6407 5.0392 50.1937 5.109 50.0268 5.34938C49.2609 6.11767 48.3305 6.22279 47.2755 7.00416C47.3451 6.90143 47.559 4.39732 48.1333 3.39336C48.4596 2.92101 47.5803 1.50565 47.1773 2.72859C47.1597 2.72556 47.1369 2.73843 47.113 2.72903C47.0757 3.2994 46.5565 3.63728 46.4169 4.16369L46.4119 4.18574C46.4922 4.59194 46.1032 4.69197 46.3451 5.11439C46.3451 5.11439 46.2278 5.03786 46.2265 5.03412C46.04 5.78618 45.7158 6.65485 45.4863 7.4648C45.1906 6.7086 44.9795 5.95015 45.075 5.28657L45.0308 5.30982C45.0397 5.29282 45.0082 5.261 45.0612 5.23922C44.6526 4.90904 44.5924 4.64294 44.3264 4.3469C44.3264 4.3469 44.2933 3.54841 43.8935 3.31232L43.7119 2.13385C43.671 1.5536 42.0836 1.04786 42.5619 2.19251L42.5669 2.2075Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M56.2986 51.5129C57.3201 51.4258 70.9872 48.1615 67.4022 47.4532C66.0723 47.8212 65.0389 47.4493 64.3739 48.4464C64.1817 47.2712 61.574 49.1468 61.1735 49.218C60.9932 48.3277 56.9075 50.6187 57.5043 49.7917C55.6497 49.8154 53.3465 50.4564 50.9512 51.2082C49.7775 50.4208 54.8086 44.8022 52.6936 46.0169C52.8418 45.7004 53.4106 44.3313 53.3345 45.2374C54.0034 44.4619 61.2856 32.5916 58.2574 34.6016C56.2145 37.0509 54.6804 41.1541 52.95 43.1799C51.2676 43.8645 50.102 49.7442 48.2274 49.1586C47.1338 47.8371 44.3139 31.6538 42.3111 33.0901C42.6596 34.3484 42.3431 35.4761 43.3165 36.0814C42.1268 36.2714 44.0255 38.8472 44.0976 39.2429C43.2164 39.4091 45.4996 43.4609 44.6784 42.8673C44.6944 44.0108 44.9548 45.3324 45.3313 46.7371C44.8306 46.3612 44.2819 45.5025 43.9654 45.3759C40.5927 44.0267 38.0371 40.9245 34.5242 39.2429C31.5721 42.9583 57.6766 52.3319 41.49 53.7326C38.4457 55.6952 34.4 55.9959 31.0033 57.8833C30.7109 61.9706 50.0739 50.6939 44.4861 57.1711C43.6169 59.9092 42.3271 62.9836 40.5446 65.6821C39.407 75.9737 49.0806 48.0151 48.68 58.6826C50.0139 61.2307 51.3037 64.3012 51.9646 67.4627C56.6952 74.3158 50.2382 56.1859 49.5612 53.6179C52.1248 52.5377 62.0347 64.7879 63.8292 62.857C63.9133 62.584 62.4873 61.0685 62.0547 60.9063C61.7623 61.0527 61.6141 61.1714 61.4418 60.9023C62.3111 60.0753 59.2628 59.0308 58.9744 58.7459C59.6153 58.1168 55.3734 56.0711 56.4028 56.1027C55.6097 55.0067 54.396 53.9028 53.0141 52.7909C55.4655 52.324 56.531 50.6147 56.3067 51.505L56.2986 51.5129Z",
                fill: "#101214"
            })
        ]
    });


const $fb5294f77b031b67$var$containerStyles = null;
const $fb5294f77b031b67$var$containerReverseStyles = null;
const $fb5294f77b031b67$var$contentStyles = null;
const $fb5294f77b031b67$var$textContentStyles = null;
const $fb5294f77b031b67$var$textSpaceStyles = null;
const $fb5294f77b031b67$var$asterisksStyle = null;
const $fb5294f77b031b67$var$eyebrowStyles = null;
const $fb5294f77b031b67$var$titleStyles = null;
const $fb5294f77b031b67$var$descriptionStyles = null;
const $fb5294f77b031b67$var$separatorStyles = null;
const $fb5294f77b031b67$var$iconTitleStyles = null;
const $fb5294f77b031b67$var$iconContainerStyles = null;
const $fb5294f77b031b67$var$iconAndTextStyles = null;
const $fb5294f77b031b67$var$iconStyles = null;
const $fb5294f77b031b67$var$buttonSpaceStyles = null;
const $fb5294f77b031b67$var$displayNoneBelowLg = null;
const $fb5294f77b031b67$var$topPaddingStyles = null;
const $fb5294f77b031b67$export$64a41dfe32d2aceb = ({ eyebrow: eyebrow, title: title, description: description, iconTitle: iconTitle, iconCollection: iconCollection, reverseLayout: reverseLayout, cta: cta, showAsterisks: showAsterisks, hideSeparator: hideSeparator, addPaddingAboveList: addPaddingAboveList, children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bahesu3 _p12f1fra _zulpzwfg _1s4p1osq _na0i1sxn _tnv2cd5j _2osnidpf _15951w8u _1vkh1w8u _11qb1w8u _15sj1vuk",
            reverseLayout && "_2lx21sbv _na0i1bp4",
            "container-styles"
        ]),
        style: {
            "--_7zbnls": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _ahbq1wug _12l21wug"
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_i0dl1r5k _2rkoqslr _11q7cd5j _1s4p1osq _1d2yr60k"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.neutral.light0"))
                },
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1q511crf",
                        "tab-text-content"
                    ]),
                    children: [
                        showAsterisks && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1mjbglyw"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ac9fe5530b4ba1ed$export$73598a4b20da4aa6), {
                                size: "64"
                            })
                        }),
                        eyebrow && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_6rth14y2",
                                "eyebrow-md"
                            ]),
                            children: eyebrow
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                            className: (0, $esG4f.default)([
                                "_1mouidpf",
                                "h3"
                            ]),
                            children: title
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                            className: (0, $esG4f.default)([
                                "_1wyb1k92 _1pfh7vkz _srwz7vkz",
                                "tab-text-content-description"
                            ]),
                            children: description
                        }),
                        !hideSeparator && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_4t3it94y _11q7mmjq _1pfhzwfg",
                                "_1mjbglyw"
                            ]),
                            style: {
                                "--_1ayut75": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.neutral.light500"))
                            }
                        }),
                        iconTitle && /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                            className: (0, $esG4f.default)([
                                "_1pfhzwfg _6rthrdoj _1bsbn8ye",
                                "_1mjbglyw",
                                "body-md"
                            ]),
                            children: iconTitle
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                            className: (0, $esG4f.default)([
                                "_1e0c116y _2lx21bp4 _4cvr1y6m _qtt8glyw _18zridpf _1mouidpf _zulpftgi _81641y44",
                                addPaddingAboveList && "_1q517vkz"
                            ]),
                            children: iconCollection.map((icon, index)=>/*#__PURE__*/ (0, $loA2J.jsxs)("li", {
                                    className: (0, $esG4f.default)([
                                        "_1e0c1txw _1bah1h6o _4cvr1y6m _15ueidpf _1uz3idpf"
                                    ]),
                                    children: [
                                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                                            className: (0, $esG4f.default)([
                                                "_1bsb1tcg _4t3i1tcg _y3gn1h6o _1o9zidpf"
                                            ]),
                                            children: icon.icon
                                        }),
                                        /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                                            className: "body-sm",
                                            children: icon.description
                                        })
                                    ]
                                }, index))
                        }),
                        cta && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1pfhzwfg _476d7vkz _srwz7vkz",
                                "tab-text-content-cta"
                            ]),
                            children: cta
                        })
                    ]
                })
            })
        ]
    });
};


const $4ea19f8be29b8ca3$var$imageStyle = null;
const $4ea19f8be29b8ca3$var$reusableImageStyle = null;
const $4ea19f8be29b8ca3$var$backgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuablePurpleBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuableGreenBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$reusuableOrangeBackgroundStyle = null;
const $4ea19f8be29b8ca3$var$videoStyle = null;
const $4ea19f8be29b8ca3$var$combinedVideoSizing = null;
const $4ea19f8be29b8ca3$var$iconSpacingOverride = null; // eslint-disable-next-line complexity
const $4ea19f8be29b8ca3$export$fcfc83b800268bb4 = ({ active: active, videoSrcMp4: videoSrcMp4, videoSrcWebm: videoSrcWebm, videoPreviewSrc: videoPreviewSrc, showBackground: showBackground, useSpecificBackgroundStyle: useSpecificBackgroundStyle = "none", isUseReusableXflowFeatureInfo: isUseReusableXflowFeatureInfo = false, addPaddingAboveListInReusableXflow: addPaddingAboveListInReusableXflow = false, ...props })=>{
    const { userSelected: userSelected, goToNextTab: goToNextTab } = (0, $8ff06814dab5c9d6$export$8fc90cd28db43001)();
    const { ref: containerRef, inView: sectionIsVisible } = (0, $478af79ecb9fb55b$export$2f62ee6831462844)({
        initialInView: true,
        threshold: 0.3
    });
    const videoRef = /*#__PURE__*/ (0, $iSvIT.createRef)();
    (0, $iSvIT.useEffect)(()=>{
        if (sectionIsVisible && active && videoRef.current && videoRef.current.play) {
            videoRef.current.autoplay = true;
            videoRef.current.currentTime = 0;
            videoRef.current.play().catch(()=>{});
        } else if (!active || !sectionIsVisible) {
            if (videoRef.current?.paused) return;
            videoRef.current?.pause();
        }
    }, [
        active,
        videoRef,
        sectionIsVisible
    ]);
    const FeatureInfoImageAndVideo = /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        ref: containerRef,
        className: (0, $esG4f.default)([
            isUseReusableXflowFeatureInfo ? "_1rjct7po _18zr16gx _kqswh2mm _1pbykb7n" : "_85i51tcg _26vx1tcg _d2ik1tcg",
            showBackground && useSpecificBackgroundStyle === "none" && "_1kt9b3bt _1rusowgw _1cs8stnw _qnec1hnc _1aukidpf _1mp411be _kfgt1osq _1g0v1mrw _tgsmyvst _11r71lk2 _1c9g1ghs _aw8s3pft _9n3r13va _8n7u1vuk _16ho16gx _b4lq13sl _lu7ho2qy _1kgg1w8u _1res9by0 _1hup12it _1knvgojt _11bbglyw _aetrb3bt _3p6mvjx7 _18postnw _19do1avk _1x881h6c _z0ai1iyx _1qdgypwq _idl91r5k _15cz1x1l _maqlscyu _j9q0qdsu _184p1nuc _15i6obt3 _jw3xx19p _1f4cyrmy _1606p1rm _1y3iglyw",
            showBackground && useSpecificBackgroundStyle === "purple" && "_1kt9b3bt _1ruscm6p _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsm1x17",
            showBackground && useSpecificBackgroundStyle === "green" && "_1kt9b3bt _1rusowgw _1cs8stnw _z5wtidpf _iajmidpf _1mp41osq _kfgt1osq _1g0v1mrw _tgsmhz6d",
            showBackground && useSpecificBackgroundStyle === "orange" && "_1kt9b3bt _1rustnrf _1cs8stnw _z5wtbz2e _iajmidpf _1mp41vuk _kfgt1osq _1g0v1mrw _tgsm8z3g"
        ]),
        style: {
            "--_1lpv4ka": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.primary.lime")),
            "--_1fb7i9d": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.primary.purple")),
            "--_jxcf9d": (0, $43MIc.default)((0, $41c7880d9169a529$export$2e2bcd8739ae039)("color.primary.saffron"))
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $87cd6c26a4a4ed0a$export$bfa1278d9934b266), {
            className: isUseReusableXflowFeatureInfo ? "reusable-xflow-video" : "",
            children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _tnru9hbq _1vkh1xbk _1dny1wug _1lxi1wug",
                    isUseReusableXflowFeatureInfo ? "reusable" : ""
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsxs)("video", {
                    playsInline: true,
                    muted: true,
                    preload: "auto",
                    poster: videoPreviewSrc,
                    autoPlay: !!active,
                    loop: userSelected,
                    ref: videoRef,
                    onEnded: ()=>{
                        if (!userSelected && !isUseReusableXflowFeatureInfo) goToNextTab();
                    },
                    onLoadedMetadata: (videoEvent)=>{
                        if (!active) return;
                        try {
                            videoEvent.currentTarget.currentTime = 0; // Set currentTime to workaround Safari not autplaying
                            if (videoEvent.currentTarget.parentElement) videoEvent.currentTarget.play().catch(()=>false); // Call play() as backup to ensure the video is playing
                        } catch (error) {
                            console.log("Error calling play method on video after onCanPlay is invoked.");
                        }
                    },
                    className: (0, $esG4f.default)([
                        "_p12f1osq"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcMp4,
                            type: `video/mp4`
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                            src: videoSrcWebm,
                            type: `video/webm`
                        })
                    ]
                })
            })
        })
    });
    return isUseReusableXflowFeatureInfo ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_pi1jftgi _w0qwidpf _8lhc1crf _1lre1osq _10mf1wug _1ya5idpf _445tidpf",
            "tab-content-image-container"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fb5294f77b031b67$export$64a41dfe32d2aceb), {
            ...props,
            reverseLayout: true,
            children: FeatureInfoImageAndVideo
        })
    }) : /*#__PURE__*/ (0, $loA2J.jsx)((0, $fb5294f77b031b67$export$64a41dfe32d2aceb), {
        ...props,
        reverseLayout: true,
        children: FeatureInfoImageAndVideo
    });
};


const $9fbed165fb1c2422$var$databaseVideoData = {
    videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR_reencode.mp4",
    videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Databases_LowBR.webm",
    videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Databases_Preview.webp"
};
const $9fbed165fb1c2422$var$whiteboardsVideoData = {
    videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR_reencode.mp4",
    videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Whiteboards_LowBR.webm",
    videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Whiteboards_Preview.webp"
};
const $9fbed165fb1c2422$var$pagesVideoData = {
    videoSrcMp4: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR_reencode.mp4",
    videoSrcWebm: "https://wac-cdn.atlassian.com/misc-assets/videos/confluence-product-tour/PT_CT_Pages_LowBR.webm",
    videoPreviewSrc: "https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/PT_CT_Pages_Preview.webp"
};
const $9fbed165fb1c2422$var$subAnchorMap = {
    "brainstorm": {
        pageId: "paid-lp-conf-sub-anchor-brainstorm",
        video: $9fbed165fb1c2422$var$whiteboardsVideoData,
        animation: (0, $be53a9e58ae49265$export$164e79f76a2d9d14)
    },
    "business plan": {
        pageId: "paid-lp-conf-sub-anchor-business-plan",
        video: $9fbed165fb1c2422$var$whiteboardsVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "coda": {
        pageId: "paid-lp-conf-keywords-competitors",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "collaboration tool": {
        pageId: "paid-lp-conf-sub-anchor-collaboration-tools",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "documentation tools": {
        pageId: "paid-lp-conf-keywords-documentation",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "google docs": {
        pageId: "paid-lp-conf-keywords-competitors",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "knowledge management": {
        pageId: "paid-lp-conf-sub-anchor-knowledge-management",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $a50c4190d6ebf296$export$ee89167f055f4c61)
    },
    "microsoft sharepoint": {
        pageId: "paid-lp-conf-keywords-competitors",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "microsoft teams": {
        pageId: "paid-lp-conf-keywords-competitors",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "notion": {
        pageId: "paid-lp-conf-keywords-competitors",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    },
    "organization chart": {
        pageId: "paid-lp-conf-sub-anchor-organization-chart",
        video: $9fbed165fb1c2422$var$whiteboardsVideoData,
        animation: (0, $614cc86ac355fb97$export$8929951f37b9096e)
    },
    "project management software": {
        pageId: "paid-lp-conf-sub-anchor-project-plan",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $4284aae4a2979d0b$export$be46c88e95f4d491)
    },
    "project management templates": {
        pageId: "paid-lp-conf-sub-anchor-project-plan",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $4284aae4a2979d0b$export$be46c88e95f4d491)
    },
    "project plan": {
        pageId: "paid-lp-conf-keywords-project-plan",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $4284aae4a2979d0b$export$be46c88e95f4d491)
    },
    "spreadsheet": {
        pageId: "paid-lp-conf-keywords-spreadsheets",
        video: $9fbed165fb1c2422$var$databaseVideoData,
        animation: (0, $bc6fa5eb23cfe838$export$2ada22cf838dec7d)
    },
    "task management": {
        pageId: "paid-lp-conf-keywords-task-list",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $bc6fa5eb23cfe838$export$2ada22cf838dec7d)
    },
    "whiteboard": {
        pageId: "paid-lp-conf-sub-anchor-whiteboard",
        video: $9fbed165fb1c2422$var$whiteboardsVideoData,
        animation: (0, $fee92033bb0a5241$export$92e2b3062e1f1116)
    },
    "wiki": {
        pageId: "paid-lp-conf-sub-anchor-wiki",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $a50c4190d6ebf296$export$ee89167f055f4c61)
    },
    "word editor": {
        pageId: "paid-lp-conf-keywords-documentation",
        video: $9fbed165fb1c2422$var$pagesVideoData,
        animation: (0, $89b4ca154406c5fa$export$6955bcca4cd3539f)
    }
};
const $9fbed165fb1c2422$export$ae62859ac3ba0a1d = (subAnchor = "")=>!!$9fbed165fb1c2422$var$subAnchorMap[subAnchor];
const $9fbed165fb1c2422$export$92331d2e4a7d36a8 = (subAnchor = "")=>[
        "brainstorm",
        "business plan",
        "coda",
        "collaboration tool",
        "documentation tools",
        "google docs",
        "knowledge management",
        "microsoft sharepoint",
        "microsoft teams",
        "notion",
        "online flowchart",
        "organization chart",
        "project management templates",
        "task management",
        "whiteboard",
        "wiki"
    ].includes(subAnchor);
const $9fbed165fb1c2422$export$bf10147d0ac61da9 = (subAnchor = "")=>[
        "analytics tools",
        "brainstorm",
        "business plan",
        "coda",
        "collaboration tools",
        "communication system",
        "content management",
        "digital diagram",
        "documentation tools",
        "file sharing",
        "gantt chart",
        "google docs",
        "intranet",
        "knowledge management",
        "organization chart",
        "other templates",
        "others",
        "process management",
        "project management software",
        "project management templates",
        "project plan",
        "project reporting",
        "remote",
        "spreadsheet",
        "task management",
        "team management",
        "time management",
        "whiteboard",
        "wiki",
        "word editor",
        "work management",
        "workflow"
    ].includes(subAnchor);
const $9fbed165fb1c2422$export$2ce6e339a89daf7a = (subAnchor = "")=>$9fbed165fb1c2422$var$subAnchorMap[subAnchor]?.pageId || "paid-lp-conf-keywords-documentation";
const $9fbed165fb1c2422$export$c2a9c65e5ab46a75 = (keyword = "", tab)=>{
    const videoProps = $9fbed165fb1c2422$var$subAnchorMap[keyword]?.video || $9fbed165fb1c2422$var$pagesVideoData;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $8ff06814dab5c9d6$export$e329eabcff0a2a4a), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ea19f8be29b8ca3$export$fcfc83b800268bb4), {
            ...videoProps,
            showBackground: true,
            active: true,
            showAsterisks: true,
            hideSeparator: true,
            title: tab.title,
            description: tab.description,
            iconCollection: Array.from(new DOMParser().parseFromString(tab.content, "text/html").querySelectorAll("p")).slice(0, 3).map((p, i)=>({
                    description: p.textContent || "",
                    icon: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $9d96fa93db92bec9$export$c622ac6ddd491a46), {
                            size: "small"
                        }, "Rocket"),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6e8a359f72c7aec9$export$79c66221ddbb3eb1), {
                            size: "small"
                        }, "Megaphone"),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $6b72d7491e1de459$export$223f1f409e24a208), {
                            size: "small"
                        }, "Notepad")
                    ][i]
                }))
        })
    });
};
const $9fbed165fb1c2422$export$2e051bef3a49a4ad = (subAnchor)=>{
    const riveAnimation = $9fbed165fb1c2422$var$subAnchorMap[subAnchor]?.animation;
    return riveAnimation ? {
        riveAnimation: riveAnimation
    } : undefined;
};



var $4LHd8 = parcelRequire("4LHd8");
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ced2179e9e0992ccb4af61b51b4f10a3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");
/* icon-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ 
var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $jxLBU = parcelRequire("jxLBU");

var $dQweN = parcelRequire("dQweN");
var $a3d1df678624450f$var$styles = {
    root: "_1e0c1o8l",
    TEMP_assets: "_9aea1fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $a3d1df678624450f$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $a3d1df678624450f$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $a3d1df678624450f$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $a3d1df678624450f$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $a3d1df678624450f$var$rovoDarkAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $a3d1df678624450f$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-enable @atlaskit/ui-styling-standard/no-unsafe-values */ var $a3d1df678624450f$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl",
    "12": "_4t3i1crf",
    "16": "_4t3i7vkz",
    "20": "_4t3igktf",
    "24": "_4t3i1tcg",
    "32": "_4t3izwfg"
};
function $a3d1df678624450f$export$be58b4326e23250f(_ref) {
    var _ref$size = _ref.size, size = _ref$size === void 0 ? "20" : _ref$size, label = _ref.label, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, userDefinedTestId = _ref.testId, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, customIconColor = _ref.iconColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? "tile" : _ref$type;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && customIconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-icon-color": customIconColor || "initial"
        },
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        "aria-hidden": label === "" ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $esG4f.default)([
            $a3d1df678624450f$var$styles.root,
            $a3d1df678624450f$var$sizeMap[size],
            colorMode === "dark" ? $a3d1df678624450f$var$dataCenterDarkAppearanceMap[appearance] : $a3d1df678624450f$var$dataCenterLightAppearanceMap[appearance],
            type === "rovo" ? colorMode === "dark" ? $a3d1df678624450f$var$rovoDarkAppearanceMap[appearance] : $a3d1df678624450f$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $a3d1df678624450f$var$cloudDarkAppearanceMap[appearance] : $a3d1df678624450f$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === "brand" && (0, $jxLBU.fg)("assets-platform-branding") && $a3d1df678624450f$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
var $17d0ee28619a9bd6$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.444 5h3.111l.98 2.61 2.75-.457 1.555 2.694L17.07 12l1.77 2.153-1.555 2.694-2.75-.457-.979 2.61h-3.11l-.98-2.61-2.75.457-1.555-2.694L6.931 12 5.16 9.847l1.555-2.694 2.75.457zM12 14.625a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25" clip-rule="evenodd"/>\n</svg>\n';
function $17d0ee28619a9bd6$export$ef8e5f836dd989d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Admin" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $17d0ee28619a9bd6$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::58c9ee3b4e44f14aa5c8a2e33c7dac51>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");
/* logo-wrapper.tsx generated by @compiled/babel-plugin v0.39.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $jxLBU = parcelRequire("jxLBU");

var $dQweN = parcelRequire("dQweN");
var $91f465b125aabec8$var$styles = {
    root: "_1e0c1o8l _vwz4idpf",
    TEMP_assets: "_9aea1fkg"
};
// These styles set the `color` property so that the child SVG can inherit the correct text color using "currentColor"
var $91f465b125aabec8$var$logoTextColorMap = {
    light: "_syazqlpt",
    dark: "_syazz6c6"
};
var $91f465b125aabec8$var$sizeMap = {
    xxsmall: "_4t3i7vkz",
    xsmall: "_4t3igktf",
    small: "_4t3i1tcg",
    medium: "_4t3izwfg",
    large: "_4t3i1ylp",
    xlarge: "_4t3ickbl"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$textLightAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1e01",
    inverse: "_1wycu67f",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$textDarkAppearanceMap = {
    brand: "_1wyci7uo",
    neutral: "_1wyc1gvk",
    inverse: "_1wyc5a6q",
    legacy: "_1wycu67f"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$cloudLightAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1e01 _9aea1fkg",
    inverse: "_1b3i5a6q _9aeau67f",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$cloudDarkAppearanceMap = {
    brand: "_1b3i18uv _9aea18uv",
    neutral: "_1b3i1gvk _9aea8hz0",
    inverse: "_1b3iu67f _9aea5a6q",
    legacy: "_1b3iu67f _9aeadoyu"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$dataCenterLightAppearanceMap = {
    brand: "_1b3idoyu _9aeau67f _3wu01fkg",
    neutral: "_1b3i1e01 _9aea1fkg _3wu01e01",
    inverse: "_1b3iu67f _9aeaqlpt _3wu0u67f",
    legacy: "_1b3idoyu _9aeau67f _3wu01fkg"
};
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ var $91f465b125aabec8$var$dataCenterDarkAppearanceMap = {
    brand: "_1b3idoyu _9aeaqlpt _3wu08hz0",
    neutral: "_1b3i1gvk _9aea8hz0 _3wu01gvk",
    inverse: "_1b3i1501 _9aeau67f _3wu01501",
    legacy: "_1b3idoyu _9aeaqlpt _3wu08hz0"
};
var $91f465b125aabec8$var$rovoDarkAppearanceMap = {
    brand: "_1703lrxy _1evoh727 _epb51yy8 _1osdxeun",
    neutral: "_17031gvk _1evo1gvk _epb51gvk _1osd1gvk",
    inverse: "_1703qlpt _1evoqlpt _epb5qlpt _1osdqlpt",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
var $91f465b125aabec8$var$rovoLightAppearanceMap = {
    brand: "_170318uv _1evo18uv _epb518uv _1osd18uv",
    neutral: "_17031e01 _1evo1e01 _epb51e01 _1osd1e01",
    inverse: "_1703u67f _1evou67f _epb5u67f _1osdu67f",
    legacy: "_1703doyu _1evodoyu _epb5doyu _1osddoyu"
};
function $91f465b125aabec8$export$f827d3c5a9c3f644(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$size = _ref.size, size = _ref$size === void 0 ? "small" : _ref$size, svg = _ref.svg, customThemeSvg = _ref.customThemeSvg, label = _ref.label, userDefinedTestId = _ref.testId, customIconColor = _ref.iconColor, customTextColor = _ref.textColor, _ref$isAssets = _ref.isAssets, isAssets = _ref$isAssets === void 0 ? false : _ref$isAssets, _ref$type = _ref.type, type = _ref$type === void 0 ? "tile" : _ref$type;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    var isCustomThemed = customThemeSvg && (customIconColor || customTextColor);
    return /*#__PURE__*/ $iSvIT.createElement("span", {
        style: {
            // Nav v3 passes in "inherit" incorrectly for iconColor, so we fall back to textColor when this happens.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-icon-color": customIconColor === "inherit" ? customTextColor : customIconColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            "--themed-text-color": customTextColor || "inherit"
        },
        "data-testid": testId,
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        "aria-hidden": label === "" ? true : undefined,
        dangerouslySetInnerHTML: {
            __html: isCustomThemed ? customThemeSvg : svg
        },
        className: (0, $esG4f.default)([
            $91f465b125aabec8$var$styles.root,
            // Setting the color so that the SVG can inherit the correct text color using "currentColor"
            $91f465b125aabec8$var$logoTextColorMap[colorMode !== null && colorMode !== void 0 ? colorMode : "light"],
            $91f465b125aabec8$var$sizeMap[size],
            colorMode === "dark" ? $91f465b125aabec8$var$textDarkAppearanceMap[appearance] : $91f465b125aabec8$var$textLightAppearanceMap[appearance],
            colorMode === "dark" ? $91f465b125aabec8$var$dataCenterDarkAppearanceMap[appearance] : $91f465b125aabec8$var$dataCenterLightAppearanceMap[appearance],
            type === "rovo" ? colorMode === "dark" ? $91f465b125aabec8$var$rovoDarkAppearanceMap[appearance] : $91f465b125aabec8$var$rovoLightAppearanceMap[appearance] : colorMode === "dark" ? $91f465b125aabec8$var$cloudDarkAppearanceMap[appearance] : $91f465b125aabec8$var$cloudLightAppearanceMap[appearance],
            isAssets && appearance === "brand" && (0, $jxLBU.fg)("assets-platform-branding") && $91f465b125aabec8$var$styles.TEMP_assets
        ])
    });
}


// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5cad28c678a91c04$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M124.84 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-20.15-10.4c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-14.07-8.52v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.85c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-22.02-4.01c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M13.826 6.4h4.255l1.338 3.569 3.76-.626 2.128 3.684-2.422 2.945 2.421 2.943L23.18 22.6l-3.76-.626-1.338 3.57h-4.255l-1.338-3.57-3.76.625L6.6 18.915l2.421-2.943L6.6 13.028l2.127-3.685 3.76.626zm2.128 13.16a3.59 3.59 0 1 0 0-7.178 3.59 3.59 0 0 0 0 7.179" clip-rule="evenodd"/>\n</svg>\n';
function $5cad28c678a91c04$export$61afcb38c001e19(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Admin" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $5cad28c678a91c04$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c308d558bb8f01b0a6c887a98e5347d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d2f6b82b197dcc06$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M18.545 18.545a4.49 4.49 0 0 0-4.48-4.48h-4.13v-3.78h-4.48v7.434c0 .576.25.826.826.826zM5.455 5.455a4.454 4.454 0 0 0 4.455 4.48h4.155v3.78h4.48V6.28q0-.825-.826-.826z"/>\n</svg>\n';
function $d2f6b82b197dcc06$export$70a0c2f5862937b6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Align" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $d2f6b82b197dcc06$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4d1c9f8765265019cd33e94ea5235515>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $5d55fef0fce9da25$var$svg = '<svg height="100%" viewBox="0 0 106 32">\n    <path fill="var(--text-color, #1e1f21)" d="M105.76 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-19.6 7.75v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52M68.73 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-2.54-.03c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM49.6 21.32c-1.53 0-3.1-.18-4.82-.52l-1.69 4.54H40l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.68 7.43 45.6 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M23.735 23.735c0-2.928-2.396-5.295-5.295-5.295h-4.88v-4.466H8.265v8.785c0 .68.296.976.976.976zM8.265 8.265c0 2.928 2.337 5.295 5.265 5.295h4.91v4.466h5.295V9.241q0-.976-.976-.976z"/>\n</svg>\n';
function $5d55fef0fce9da25$export$8b5103382c06639c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Align" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $5d55fef0fce9da25$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5edf47443601d30b199c36fbcc7b1d7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3e3579dc55277841$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.63 5.88v9.19h3.06v-9.2zM5.88 18.13h11.81v-1.75H5.87zm0-3.07v-4.81h3.06v4.81zm4.37-6.56v6.56h3.06V8.5z"/>\n</svg>\n';
function $3e3579dc55277841$export$af3460f51ce3602a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Analytics" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $3e3579dc55277841$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::843c7beab94f5191123277c61cbca79e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $835eb391f22ea82b$var$svg = '<svg height="100%" viewBox="0 0 161 32">\n    <path fill="var(--text-color, #1e1f21)" d="M160.66 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.6 1.41v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M129.13 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-7.46-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-14.12 3.77h-1.72L100.77 10h2.82l4.91 13.13L113.41 10h2.82l-5.8 14.84c-1.72 4.39-2.7 6.66-6.59 6.66-1.32 0-2.05-.12-2.82-.43V28.8c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.81m-7.8.94c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM79.5 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM74.1 16.35v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.63V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-24.66 4.97c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.5 7.83v12.25h4.08V7.83zM7.83 24.17h15.75v-2.33H7.83zm0-4.09v-6.42h4.08v6.42zm5.84-8.75v8.75h4.08v-8.75z"/>\n</svg>\n';
function $835eb391f22ea82b$export$f0bac2b7ac3e3504(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Analytics" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $835eb391f22ea82b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6ef8f48b1d072b5b8a0869540d1f52a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $3726f504d8da0940$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"/>\n</svg>\n';
var $3726f504d8da0940$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM7.432 14.704a2.273 2.273 0 1 0 .001 4.547 2.273 2.273 0 0 0-.001-4.547m9.545 0a2.274 2.274 0 1 0 .001 4.548 2.274 2.274 0 0 0 0-4.548m-6.364 1.364v1.819h3.183v-1.819zM7.887 4.25a3.637 3.637 0 0 0-1.365 7.009v2.537h1.819v-2.302a3.64 3.64 0 0 0 3.153-3.153h2.302V6.522h-2.537A3.64 3.64 0 0 0 7.887 4.25m8.181 6.363v3.183h1.819v-3.183zm.91-5.454a2.273 2.273 0 1 0 0 4.547 2.273 2.273 0 0 0 0-4.547M7.887 6.522a1.364 1.364 0 1 1-.002 2.729 1.364 1.364 0 0 1 .002-2.729"/>\n</svg>\n';
function $3726f504d8da0940$export$d89497e7f33ca6f5(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Assets" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $3726f504d8da0940$var$svg,
        customThemeSvg: $3726f504d8da0940$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e04e8bc884193d0eee2f110efb35733>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $38fb917581248aa2$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M125.8 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.77-.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.5c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.13-3.56c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63-.01c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-22.22.15c-1.53 0-3.1-.18-4.81-.52l-1.69 4.54h-3.1l7.94-20.15h3.5l7.94 20.15h-3.1l-1.69-4.57c-1.81.37-3.37.55-5 .55m0-2.45c1.29 0 2.61-.15 4.17-.4L49.53 7.43 45.45 18.5c1.5.25 2.76.37 3.99.37"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M11.667 15.425a4.335 4.335 0 0 0 3.758-3.758h2.742V9.5h-3.023A4.335 4.335 0 1 0 9.5 15.144v3.023h2.167zm-.542-2.675a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M24.67 10.58a2.71 2.71 0 1 1-5.42 0 2.71 2.71 0 0 1 5.42 0M10.58 24.67a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m11.38 0a2.71 2.71 0 1 0 0-5.42 2.71 2.71 0 0 0 0 5.42m-3.79-3.79h-3.79v2.17h3.79zm2.71-6.5v3.79h2.17v-3.79z"/>\n</svg>\n';
function $38fb917581248aa2$export$81c47abe19675c4c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Assets" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $38fb917581248aa2$var$svg,
        label: label,
        isAssets: true,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::74f0ca66b8bc3995f7a9817f08a67d6f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $26c9fa5005b5b583$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M9.215 12.652a2.75 2.75 0 0 0 2.749 2.742v4.205a6.964 6.964 0 0 1-6.849-5.727l-.049-.317zm9.26 0a.44.44 0 0 1 .436.468c-.222 3.311-2.783 5.989-6.043 6.414l-.904-4.14a2.75 2.75 0 0 0 2.723-2.37.44.44 0 0 1 .44-.372zM11.963 9.91a2.75 2.75 0 0 0-2.748 2.742H5v-.065c.033-3.495 2.668-6.374 6.059-6.816zm0-5.972a.436.436 0 0 1 .72-.33l4.824 4.138a.436.436 0 0 1 0 .662l-4.823 4.139a.436.436 0 0 1-.72-.331z"/>\n</svg>\n';
function $26c9fa5005b5b583$export$e812398311cab9a3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bamboo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $26c9fa5005b5b583$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5436ab9ea17c11b656095d6ae713006c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $0c24c0bceb41e168$var$svg = '<svg height="100%" viewBox="0 0 154 32">\n    <path fill="var(--text-color, #1e1f21)" d="M146 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-16.68 13.49c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-12.07 5.52c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-21.58-8.82v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.32.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.23-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M12.287 16.869a3.665 3.665 0 0 0 3.665 3.656v5.607c-4.71 0-8.602-3.52-9.196-8.06zm12.347 0a.584.584 0 0 1 .581.624c-.295 4.415-3.71 7.986-8.057 8.554l-1.206-5.521a3.67 3.67 0 0 0 3.63-3.161.59.59 0 0 1 .589-.496zm-8.683-3.656a3.664 3.664 0 0 0-3.665 3.656h-5.62v-.088c.044-4.66 3.557-8.498 8.078-9.088zm0-7.964a.58.58 0 0 1 .96-.44l6.432 5.518c.27.232.27.65 0 .883l-6.431 5.517a.581.581 0 0 1-.96-.44z"/>\n</svg>\n';
function $0c24c0bceb41e168$export$7c51958462d750e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bamboo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $0c24c0bceb41e168$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83bd991a11895fc697ec86ba4d2d82c2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b384fa1f703763fb$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="m17.898 11.353-.994 6.064c-.065.367-.324.583-.691.583H7.787c-.367 0-.627-.216-.691-.583L5.346 6.604C5.28 6.237 5.476 6 5.82 6h12.358c.346 0 .54.237.475.604l-.475 2.85c-.065.41-.303.582-.691.582h-7.432c-.109 0-.173.065-.152.194l.584 3.583c.021.086.086.151.172.151h2.68c.086 0 .15-.065.172-.151l.41-2.59c.044-.324.26-.453.563-.453H17.4c.432 0 .562.216.497.582"/>\n</svg>\n';
var $b384fa1f703763fb$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.821 6c-.345 0-.54.238-.475.604l1.75 10.813c.065.367.324.583.691.583h8.426c.367 0 .627-.216.691-.583l.994-6.065c.065-.366-.065-.582-.497-.582h-2.917c-.302 0-.518.13-.561.453l-.41 2.59c-.022.086-.087.15-.173.15h-2.68c-.086 0-.151-.064-.173-.15l-.583-3.583c-.021-.129.044-.194.152-.194h7.431c.39 0 .627-.173.692-.583l.475-2.849c.065-.366-.13-.604-.475-.604z"/>\n</svg>\n';
function $b384fa1f703763fb$export$5fc1066e677788d4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $b384fa1f703763fb$var$svg,
        customThemeSvg: $b384fa1f703763fb$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7131ffd6f745f530e9a82fe4842b6a8c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $51cbb651ef5c1063$var$svg = '<svg height="100%" viewBox="0 0 166 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.4-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.17-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.27 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.69 5.43z"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.029.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.572 0 .743.285.657.771"/>\n</svg>\n';
function $51cbb651ef5c1063$export$f7ef5e5488e4b430(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $51cbb651ef5c1063$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61dd349b817df11b196de45b8945fcdf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $ab89250c938dbb9d$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="m17.843 11.763-.986 6.024c-.065.365-.322.58-.686.58H7.81c-.365 0-.622-.215-.686-.58L5.387 7.047c-.064-.364.129-.6.472-.6h12.262c.343 0 .536.236.472.6l-.472 2.83c-.064.407-.3.579-.686.579h-7.374c-.107 0-.172.064-.15.193l.579 3.558c.021.086.085.15.171.15h2.658c.086 0 .15-.064.172-.15l.407-2.572c.043-.322.257-.45.558-.45h2.894c.428 0 .557.214.493.578"/>\n</svg>\n';
function $ab89250c938dbb9d$export$d3ab16bbf4f954ee(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $ab89250c938dbb9d$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::68c2bbf4fd6874e93c78c51b9065dc7c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $447009ae0399569b$var$svg = '<svg height="100%" viewBox="0 0 166 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.21 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-13.53-8.49c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-23.83.6h-2.64V3.59h2.64v13.59l6.6-7.18h3.44l-7.21 7.54 7.51 7.79h-3.59l-6.75-7.18zm-5.64-2.76v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.85-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-5.39-1.32c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-14.96-5.05c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zM61.33 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-9.83-9.04H45.8v6.29h6.26c2.64 0 3.83-.95 3.83-2.97 0-2.15-1.13-3.31-3.89-3.31m-.89-8.46h-5.3v6.01h5.31c2.61 0 3.68-1.2 3.68-3.13 0-1.96-1.16-2.88-3.68-2.88m-8.06 17.51V5.19h8.43c4.11 0 6.1 2.02 6.1 5.28 0 2.42-1.1 3.93-3.37 4.48 2.97.49 4.45 2.12 4.45 4.97 0 3.22-2.18 5.43-6.68 5.43z"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="m23.79 15.684-1.315 8.032c-.085.486-.428.772-.914.772H10.413c-.486 0-.829-.286-.915-.772L7.183 9.396c-.086-.486.172-.8.629-.8h16.35c.457 0 .714.314.629.8l-.63 3.773c-.085.543-.4.772-.914.772h-9.833c-.143 0-.228.086-.2.257l.772 4.745c.028.114.114.2.229.2h3.544c.114 0 .2-.086.229-.2l.543-3.43c.057-.429.343-.6.743-.6h3.859c.571 0 .743.285.657.771"/>\n</svg>\n';
function $447009ae0399569b$export$cc55e2a4c4b40552(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Bitbucket Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $447009ae0399569b$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a833c6410fabd244b1134a630f9a005>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $22a5b1daaee42b82$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.125 16.5h8.125V6H5.75v13zM12 12.125a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75m4-.875a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0m-7.125.875a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75" clip-rule="evenodd"/>\n</svg>\n';
function $22a5b1daaee42b82$export$52cd484a7ef4f2b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $22a5b1daaee42b82$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b3a55f079b563dca3c91045ce0a761dc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $16d8fa1823d1e1f7$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.65m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.167 21.834h-10.5l-5.833 3.5v-17.5h16.333zm-12.25-5.833a1.167 1.167 0 1 0 0-2.334 1.167 1.167 0 0 0 0 2.334M16 16a1.167 1.167 0 1 0 0-2.334A1.167 1.167 0 0 0 16 16m5.25-1.167a1.167 1.167 0 1 1-2.334 0 1.167 1.167 0 0 1 2.333 0" clip-rule="evenodd"/>\n</svg>\n';
function $16d8fa1823d1e1f7$export$a529e78951cd6709(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $16d8fa1823d1e1f7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ad5b8ef64559dc5207c779379dec44c9>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $47173031820dd2d5$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M18.563 16.688h-8.438L5.438 19.5V5.438h13.125zm-6.83-9.375-.255.647c-.362.92-.543 1.38-.878 1.727-.334.346-.787.543-1.694.938l-.388.17v.535l.388.17c.907.394 1.36.592 1.694.938.335.346.516.807.878 1.727l.255.648h.535l.255-.648c.362-.92.543-1.38.877-1.727.335-.346.788-.544 1.694-.939l.388-.169v-.535l-.388-.17c-.906-.395-1.36-.592-1.694-.938-.334-.347-.515-.807-.877-1.727l-.255-.647z" clip-rule="evenodd"/>\n</svg>\n';
function $47173031820dd2d5$export$402a257da320c93c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $47173031820dd2d5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1eb74baaf9574600817f9bd5473029df>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $525f96afbd01af75$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M97.51 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.94-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.1-8.98v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.95c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.22 5.43v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M24.75 22.25H13.5L7.25 26V7.25h17.5zm-9.107-12.5-.34.864c-.482 1.226-.724 1.84-1.17 2.302s-1.05.725-2.258 1.251l-.518.226v.714l.518.226c1.209.526 1.813.79 2.259 1.251.445.462.687 1.076 1.17 2.303l.34.863h.714l.34-.864c.482-1.227.724-1.84 1.17-2.302s1.049-.725 2.258-1.251l.517-.226v-.714l-.517-.226c-1.21-.526-1.813-.79-2.259-1.251-.445-.462-.687-1.075-1.17-2.302l-.34-.864z" clip-rule="evenodd"/>\n</svg>\n';
function $525f96afbd01af75$export$a3af32a9109d706d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Chat" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $525f96afbd01af75$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5ce5248a23a237688e2341559569305>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f80402a5a43af05e$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.75 7.877v-3.37l6.16-.007h.007a.59.59 0 0 1 .583.598v6.147h-3.366V7.877z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.75 14.615v-3.37h3.368v6.165a.59.59 0 0 1-.591.59H6.583A.59.59 0 0 1 6 17.402V8.467a.59.59 0 0 1 .591-.59h6.16v3.368H9.373v3.37z"/>\n</svg>\n';
function $f80402a5a43af05e$export$f7857fe64d7161d9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Compass" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $f80402a5a43af05e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bbcc7f43e0a51fb6caa253b27359fb22>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $63112a863c5a3044$var$svg = '<svg height="100%" viewBox="0 0 162 32">\n    <path fill="var(--text-color, #1e1f21)" d="M161.79 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.63 0c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-25.9-3.49c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01v-2.7h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97M89.5 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.83c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.69 15.16v4.24h-4.25v-4.24zv-4.24H8.93a.74.74 0 0 0-.74.74v11.25a.74.74 0 0 0 .74.75h11.26a.74.74 0 0 0 .75-.74v-7.76zm0-8.48v4.24h4.26v4.24h4.24V7.42a.74.74 0 0 0-.73-.75h-.01z"/>\n</svg>\n';
function $63112a863c5a3044$export$a16f50a81d183ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Compass" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $63112a863c5a3044$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2264fa822c5f74cedf4229a8911c73b4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $27bde9ecf5dee03a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M17.888 14.461c-4.039-1.953-5.219-2.245-6.92-2.245-1.997 0-3.699.831-5.219 3.165l-.25.382c-.204.314-.249.426-.249.561s.068.247.318.404l2.564 1.594c.136.09.25.135.363.135.136 0 .226-.068.363-.27l.408-.628c.635-.966 1.203-1.28 1.928-1.28.636 0 1.385.18 2.315.629l2.677 1.257c.272.134.567.067.704-.247l1.27-2.783c.136-.315.046-.517-.272-.674M6.112 9.545c4.039 1.953 5.219 2.245 6.92 2.245 1.997 0 3.699-.83 5.219-3.165l.25-.381c.204-.315.249-.427.249-.562 0-.134-.068-.247-.318-.404L15.87 5.685c-.137-.09-.25-.135-.364-.135-.136 0-.226.067-.363.27l-.408.628c-.635.965-1.203 1.28-1.928 1.28-.636 0-1.385-.18-2.315-.63L7.814 5.843c-.272-.135-.567-.068-.703.247L5.84 8.872c-.136.314-.045.516.272.673"/>\n</svg>\n';
var $27bde9ecf5dee03a$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-7.032 12.217c-1.997 0-3.699.83-5.219 3.165l-.249.38c-.204.315-.25.427-.25.562s.068.247.317.404l2.565 1.594c.136.09.249.135.362.135.136 0 .227-.068.363-.27l.409-.628c.635-.966 1.202-1.28 1.928-1.28.636 0 1.384.18 2.315.63l2.677 1.256c.273.134.568.067.704-.247l1.27-2.783c.136-.315.045-.517-.272-.674-4.039-1.953-5.219-2.244-6.92-2.244m4.538-6.667c-.136 0-.227.067-.363.27l-.409.628c-.635.965-1.202 1.28-1.928 1.28-.636 0-1.384-.18-2.315-.63L7.813 5.843c-.272-.135-.567-.067-.703.247L5.84 8.872c-.136.314-.045.517.272.674 4.039 1.953 5.219 2.244 6.92 2.244 1.997 0 3.699-.83 5.219-3.165l.249-.382c.204-.314.25-.426.25-.56s-.068-.248-.317-.405l-2.565-1.593c-.136-.09-.249-.135-.362-.135"/>\n</svg>\n';
function $27bde9ecf5dee03a$export$68f3db7f6af48bcb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $27bde9ecf5dee03a$var$svg,
        customThemeSvg: $27bde9ecf5dee03a$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90f8012e577da50adfff14718da1e4b3>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7a32f289d875b408$var$svg = '<svg height="100%" viewBox="0 0 188 32">\n    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.51-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.24 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.442 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.083.302.388.494l3.135 1.948c.167.11.305.165.444.165.166 0 .277-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.692.22 2.83.768l3.273 1.537c.333.165.693.083.86-.302l1.553-3.403c.167-.384.056-.63-.333-.823M8.761 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.305-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.691 8.29c-.167-.11-.306-.165-.444-.165-.167 0-.278.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.693-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302l-1.554 3.403c-.166.384-.055.63.333.823"/>\n</svg>\n';
function $7a32f289d875b408$export$a88b0b0da9ef63ce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $7a32f289d875b408$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::daf8acf7c1707ab5f837689f4e92f4a5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $1a73ddda9949ee9a$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M17.37 14.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.292.37l2.35 1.462c.125.083.23.124.333.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618M6.572 9.757c3.703 1.791 4.785 2.059 6.346 2.059 1.83 0 3.39-.762 4.785-2.902l.229-.35c.187-.288.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.061-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576L8.132 6.361c-.25-.123-.52-.061-.645.227L6.322 9.14c-.125.288-.041.473.25.617"/>\n</svg>\n';
function $1a73ddda9949ee9a$export$53305f1f2855d3be(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $1a73ddda9949ee9a$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86f2cdcf615e24dd3ad3f9b48bca5bf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7059ef99d50ae0cb$var$svg = '<svg height="100%" viewBox="0 0 188 32">\n    <path fill="var(--text-color, #1e1f21)" d="M181.16 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-14.5-6.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-29.1-5.74V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.23 6.31c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.2-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM96.82 8.38V10h3.96v2.45h-3.96v12.88h-2.58V12.45h-2.48V10h2.48V8.31c0-2.85 1.59-4.78 4.88-4.78.8 0 1.32.12 1.78.25V6.2a8.7 8.7 0 0 0-1.66-.15c-1.62 0-2.42.95-2.42 2.33m-7.32 7.97v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-23.34 9.28c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.23 9.63v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M23.16 19.02c-4.938-2.387-6.38-2.744-8.461-2.744-2.441 0-4.522 1.015-6.38 3.87l-.306.466c-.25.384-.305.521-.305.686s.084.302.389.494l3.134 1.948c.167.11.306.165.444.165.167 0 .278-.082.444-.33l.5-.768c.776-1.18 1.47-1.564 2.357-1.564.777 0 1.693.22 2.83.768l3.273 1.537c.333.165.694.083.86-.302l1.554-3.403c.166-.384.055-.63-.333-.823M8.762 13.01c4.938 2.388 6.38 2.744 8.461 2.744 2.441 0 4.522-1.015 6.38-3.87l.306-.466c.25-.384.305-.521.305-.686 0-.164-.083-.302-.388-.494L20.69 8.29c-.167-.11-.305-.165-.444-.165-.166 0-.277.082-.444.33l-.5.768c-.776 1.18-1.47 1.564-2.357 1.564-.777 0-1.692-.22-2.83-.768l-3.273-1.537c-.333-.165-.694-.083-.86.302L8.43 12.187c-.167.384-.056.63.332.823"/>\n</svg>\n';
function $7059ef99d50ae0cb$export$b3e508cb103e1f93(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Confluence Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $7059ef99d50ae0cb$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9928c9b96accda0f9234a11fc7ddaca0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $044e74068a3f67c6$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M18.71 7.463 12 4.993l-6.71 2.47a.44.44 0 0 0-.29.433l.14 3.807c.103 3.148 1.684 5.489 4.163 7.018a.446.446 0 0 0 .646-.204l1.445-3.412a.22.22 0 0 0-.14-.298 2.585 2.585 0 1 1 1.492 0 .22.22 0 0 0-.14.298l1.446 3.412a.446.446 0 0 0 .645.204c2.48-1.529 4.06-3.87 4.163-7.018L19 7.896a.44.44 0 0 0-.29-.433"/>\n</svg>\n';
function $044e74068a3f67c6$export$eaf73f391f7103bd(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Crowd" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $044e74068a3f67c6$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::206fa44ab9c6427ebeb6aaad7e53b58f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $9f9378c26488bca3$var$svg = '<svg height="100%" viewBox="0 0 126 32">\n    <path fill="var(--text-color, #1e1f21)" d="M113.97 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.72 0h-3.37l-2.64-7.42-1.41-4.72-1.41 4.72-2.64 7.42h-3.37L84.45 10h2.91l4.42 13 4.48-13h2.51l4.48 13 4.41-13h2.91zm-28.47.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.77 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-5.76 5.48v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M24.946 9.951 16 6.657 7.054 9.95a.59.59 0 0 0-.387.577l.187 5.076c.137 4.197 2.245 7.319 5.55 9.357.31.19.719.063.86-.272l1.928-4.55a.294.294 0 0 0-.185-.396 3.447 3.447 0 1 1 1.987 0 .294.294 0 0 0-.185.397l1.927 4.549c.142.335.55.463.86.272 3.305-2.038 5.413-5.16 5.55-9.357l.187-5.076a.59.59 0 0 0-.387-.577"/>\n</svg>\n';
function $9f9378c26488bca3$export$3c371bdbcdfcdce(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Crowd" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $9f9378c26488bca3$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2cbaafcea60527c20df8d8395e491b95>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $fdc7c9c4f0085df7$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.43 17.42A6.97 6.97 0 0 1 12 19H6.4v-.47l3.84-3.78a3.25 3.25 0 0 0 1.76.52c.65 0 1.25-.19 1.76-.51zm.99-.99A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43l-2.67 2.67c.33.51.52 1.11.52 1.76s-.19 1.25-.51 1.76zm-.99-9.85-2.67 2.67A3.25 3.25 0 0 0 12 8.73c-.65 0-1.25.19-1.76.52L7.57 6.58A6.97 6.97 0 0 1 12 5c1.68 0 3.22.59 4.43 1.58m-9.85.99A6.97 6.97 0 0 0 5 12c0 1.68.59 3.22 1.58 4.43l2.67-2.67A3.25 3.25 0 0 1 8.73 12c0-.65.19-1.25.52-1.76z"/>\n</svg>\n';
var $fdc7c9c4f0085df7$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.238 14.751a3.25 3.25 0 0 1-1.762.516 3.25 3.25 0 0 1-1.762-.515L6.4 18.533V19H12a6.97 6.97 0 0 0 4.43-1.58zM6.58 7.571A6.97 6.97 0 0 0 5 12a6.97 6.97 0 0 0 1.58 4.43l2.669-2.668A3.25 3.25 0 0 1 8.733 12c0-.649.19-1.253.516-1.762zm8.172 2.667c.326.508.515 1.113.515 1.762s-.189 1.254-.515 1.762l2.668 2.668A6.97 6.97 0 0 0 19 12a6.97 6.97 0 0 0-1.58-4.43zM12 5a6.97 6.97 0 0 0-4.43 1.58l2.668 2.668A3.25 3.25 0 0 1 12 8.733c.649 0 1.253.19 1.762.516L16.43 6.58A6.97 6.97 0 0 0 12 5"/>\n</svg>\n';
function $fdc7c9c4f0085df7$export$6da5aa77c402ba0f(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Customer Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $fdc7c9c4f0085df7$var$svg,
        customThemeSvg: $fdc7c9c4f0085df7$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7b7476897879e097648c054d2783409e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e6f57f81567b206d$var$svg = '<svg height="100%" viewBox="0 0 456 32">\n    <path fill="var(--text-color, #1e1f21)" d="M451.86 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.08-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.51-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.1-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M234.91 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.24 0h-3.53L217.69 10h2.76l4.97 13.09L230.36 10h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.65 2.45 6.65 6.07m-26.4-3.5v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.46-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H146.5c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.15-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.34 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M94.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45H94.1zm-6.7.58c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.89 2.79v2.67c-1.26.83-3.25 1.2-5.34 1.2-6.62 0-10.36-3.99-10.36-10.33 0-6.13 3.74-10.43 10.3-10.43 1.96 0 3.93.37 5.37 1.41v2.67c-1.44-.92-3.04-1.41-5.37-1.41-4.72 0-7.54 3.13-7.54 7.76s2.91 7.7 7.7 7.7c2.12 0 3.77-.49 5.24-1.23"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M21.91 23.23a9.3 9.3 0 0 1-5.91 2.1H8.53v-.62l5.12-5.04a4.34 4.34 0 0 0 2.35.69c.86 0 1.67-.25 2.35-.69zm1.32-1.32a9.3 9.3 0 0 0 2.1-5.91c0-2.24-.79-4.3-2.11-5.91l-3.56 3.56c.43.68.69 1.48.69 2.35s-.25 1.67-.69 2.35zM21.91 8.77l-3.56 3.56a4.34 4.34 0 0 0-2.35-.69c-.86 0-1.67.25-2.35.69l-3.56-3.56A9.3 9.3 0 0 1 16 6.67c2.24 0 4.3.79 5.91 2.11M8.77 10.09A9.3 9.3 0 0 0 6.67 16c0 2.24.79 4.3 2.11 5.91l3.56-3.56a4.34 4.34 0 0 1-.69-2.35c0-.86.25-1.67.69-2.35z"/>\n</svg>\n';
function $e6f57f81567b206d$export$f597f0f7fadce0b9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Customer Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $e6f57f81567b206d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe1275028f179c85adabcde30f1dc14d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $edee51b0cb228de0$var$svg = '<svg height="100%" viewBox="0 0 48 48">\n    <path fill="var(--tile-color,#94c748)" d="M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36z"/>\n    <path fill="var(--icon-color, #101214)" d="m36.22 26.75 4.9 7.25h-4.78c-.52-.6-1.02-1.31-1.47-1.98-.68-1.02-.68-2.41.03-3.41zm-7.3-5.5L24.02 14h4.78c.52.6 1.02 1.31 1.47 1.98.68 1.02.68 2.41-.02 3.41zm6.98-6.02c.5-.84 1.07-1.16 1.95-1.16l3.9-.07-12.68 19.27a1.46 1.46 0 0 1-1.22.67H23.6c4.07-6.25 8.37-12.37 12.31-18.7M8 33.94h6.89c6.16 0 9.92-3.88 9.92-9.94s-3.76-9.94-9.92-9.94H8l4.28 3.9h-1.76C9.13 17.96 8 19.12 8 20.55v13.38m4.41-3.9V17.96h2.46c3.52 0 5.49 2.38 5.49 6.04 0 3.65-1.97 6.04-5.46 6.04z"/>\n</svg>\n';
function $edee51b0cb228de0$export$9951d02c2d848122(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Dx" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $edee51b0cb228de0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c86bc4a90f7eb35fd36ae7c99f20011b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $5317cca9aa6e8da7$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M20.84 12.21a4.29 4.29 0 0 0-6.05 0l-1.394 1.393c-.77.769-2.02.769-2.789 0L9.45 12.445 6.424 15.47l1.158 1.158a6.25 6.25 0 0 0 8.838 0zm-17.68-.418a4.253 4.253 0 0 0 6.034.017l1.412-1.412a1.973 1.973 0 0 1 2.788 0l1.158 1.158 3.026-3.025-1.158-1.158a6.25 6.25 0 0 0-8.838 0l-4.42 4.419z"/>\n</svg>\n';
function $5317cca9aa6e8da7$export$1e02e7298035a77c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Focus" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $5317cca9aa6e8da7$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7aca4717e5f7edbaa74141430c7d1f8d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $94caef20e3dcf48d$var$svg = '<svg height="100%" viewBox="0 0 117 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.03 21.16c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.6-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-2.71 3.58v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M64.6 25.64c-4.6 0-7.3-3.4-7.3-8S60 9.7 64.6 9.7c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.97 5.67h-9.14v7.51h-2.76V5.19h12.94v2.64H45.49v7.36h9.14z"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M27.607 16.272c-2.176-2.176-5.712-2.152-7.865 0l-1.812 1.812c-1 1-2.625 1-3.625 0L12.8 16.578l-3.933 3.934 1.505 1.505a8.126 8.126 0 0 0 11.49 0zm-22.982-.541c2.176 2.175 5.668 2.196 7.844.02l1.834-1.834c1-1 2.625-1 3.625 0l1.505 1.505 3.934-3.933-1.505-1.505a8.126 8.126 0 0 0-11.49 0l-5.745 5.745z"/>\n</svg>\n';
function $94caef20e3dcf48d$export$3a6e8b37e069a69d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Focus" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $94caef20e3dcf48d$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::691ffc068fd79d2f7585ba74e9375893>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $23467da455b90f41$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.352 12a2.352 2.352 0 1 1-4.704 0 2.352 2.352 0 0 1 4.704 0"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12 18.563a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125M16.102 12a4.102 4.102 0 1 1-8.204 0 4.102 4.102 0 0 1 8.204 0" clip-rule="evenodd"/>\n</svg>\n';
function $23467da455b90f41$export$9eb74917ea768ed4(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Goals" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $23467da455b90f41$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4fcd237a4e74e8fc6ee2ed98ecae9d02>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $176191df78111552$var$svg = '<svg height="100%" viewBox="0 0 116 32">\n    <path fill="var(--text-color, #1e1f21)" d="M115.55 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-13.12 4.13c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M58.71 24.2c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.36 16a3.36 3.36 0 1 1-6.72 0 3.36 3.36 0 0 1 6.72 0"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M16 25.375a9.375 9.375 0 1 0 0-18.75 9.375 9.375 0 1 0 0 18.75M21.86 16a5.86 5.86 0 1 1-11.72 0 5.86 5.86 0 0 1 11.72 0" clip-rule="evenodd"/>\n</svg>\n';
function $176191df78111552$export$c527a545aa426db3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Goals" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $176191df78111552$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9271fe2e99ed03180fc112676167f42e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $0ea480666bad9f69$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M5.49 10.87h13.02c.374 0 .574-.2.574-.574V5.907c0-.374-.2-.574-.574-.574h-2.744c-.374 0-.573.2-.573.574v2.22h-1.247v-2.22c0-.374-.2-.574-.574-.574h-2.743c-.374 0-.574.2-.574.574v2.22H8.807v-2.22c0-.374-.2-.574-.573-.574H5.49c-.374 0-.573.2-.573.574v4.39c0 .373.2.573.573.573m.225 3.84a8.7 8.7 0 0 1-.5-2.493c-.024-.324.126-.499.475-.499h12.62c.349 0 .498.15.498.449a8.2 8.2 0 0 1-.523 2.544c-.15.399-.375.573-.799.573H6.513c-.424 0-.649-.174-.798-.573m11.547 2.07C16.065 18.253 14.095 19.2 12 19.2s-4.116-.948-5.288-2.42c-.299-.398-.15-.648.15-.648h10.275c.3 0 .45.25.125.649"/>\n</svg>\n';
function $0ea480666bad9f69$export$3f95fcfdc25a741d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Guard" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $0ea480666bad9f69$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db6984f13fa8a1f65e3a27814935822a>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $68fa865e53662a63$var$svg = '<svg height="100%" viewBox="0 0 120 32">\n    <path fill="var(--text-color, #1e1f21)" d="M108.4 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-17.8-9.04v9.05H96.7V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.86 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-27.42-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-3.98 5.21c-1.59.95-4.54 1.44-6.81 1.44-6.93 0-10.67-4.23-10.67-10.33 0-6.56 4.26-10.46 11.44-10.46 1.6 0 3.47.18 5.24.8v2.76c-1.53-.61-3.34-.89-5.21-.89-5.98 0-8.71 2.98-8.71 7.73 0 4.66 2.76 7.76 8.56 7.76.95 0 2.27-.09 3.4-.43v-5.61H50.8v-2.64h7.91z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M8.188 14.644h15.623c.449 0 .688-.24.688-.688V8.688c0-.449-.24-.688-.688-.688h-3.292c-.45 0-.689.24-.689.688v2.664h-1.496V8.688c0-.449-.24-.688-.688-.688h-3.293c-.448 0-.688.24-.688.688v2.664H12.17V8.688c0-.449-.24-.688-.689-.688H8.188c-.449 0-.688.24-.688.688v5.268c0 .449.24.688.688.688m.27 4.609a10.4 10.4 0 0 1-.599-2.993c-.03-.389.15-.598.569-.598H23.57c.42 0 .599.18.599.538q-.09 1.662-.629 3.053c-.18.479-.448.688-.957.688H9.415c-.508 0-.778-.21-.957-.688m13.856 2.484c-1.436 1.766-3.8 2.903-6.314 2.903s-4.939-1.137-6.345-2.903c-.36-.479-.18-.778.18-.778h12.33c.359 0 .538.3.15.778"/>\n</svg>\n';
function $68fa865e53662a63$export$2b896c4d595a4331(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Guard" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $68fa865e53662a63$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2dae141e789f6f860676eab772d48c16>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e138c7f41feb3036$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M5.875 10.688v7.437h4.375V13.75h3.5v4.375h4.375v-7.437L12 5z"/>\n</svg>\n';
function $e138c7f41feb3036$export$92c8767b874048d(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Home" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $e138c7f41feb3036$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f61715fd61f2481e52a0f7c7611f421f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f8fb604ca1efff18$var$svg = '<svg height="100%" viewBox="0 0 121 32">\n    <path fill="var(--text-color, #1e1f21)" d="M113.57 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM93.3 16.81v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-23.33 8.81c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M56.41 5.19h2.76v20.15h-2.76v-8.71H45.8v8.71h-2.76V5.19h2.76v8.8h10.61z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M7.25 14.125V24.75h6.25V18.5h5v6.25h6.25V14.125L16 6z"/>\n</svg>\n';
function $f8fb604ca1efff18$export$8b6b7f1b1b2367d3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Home" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $f8fb604ca1efff18$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::459e9cba95b1e0b094b9b0a89db30ecd>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7434d832b248b89c$var$svg = '<svg height="100%" viewBox="0 0 32 32">\n    <g clip-path="url(#clip0_95164_16219)">\n        <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n        <g clip-path="url(#clip1_95164_16219)">\n            <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>\n        </g>\n    </g>\n    <defs>\n        <clipPath id="clip0_95164_16219">\n            <path fill="var(--icon-color, white)" d="M0 0h32v32H0z"/>\n        </clipPath>\n        <clipPath id="clip1_95164_16219">\n            <path fill="var(--icon-color, white)" d="M2 2h28v28H2z"/>\n        </clipPath>\n    </defs>\n</svg>\n';
function $7434d832b248b89c$export$80b8b269d8b5014e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Hub" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $7434d832b248b89c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::edd23980285704c09d78f5241a37a99c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $50b286f7ea3c94ce$var$svg = '<svg height="100%" viewBox="0 0 95 32">\n    <path fill="var(--text-color, #1e1f21)" d="M91.61 17.67c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v2.7h-2.64V3.59h2.64v9.17c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-24.52-6.64V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65M56.4 5.19h2.76v20.15H56.4v-8.71H45.79v8.71h-2.76V5.19h2.76v8.8H56.4z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M9 25.333V6.667h14v18.666h-5.25V21.25h-3.5v4.083zm3.5-14.583h2.333V9H12.5zm4.667 0H19.5V9h-2.333zm-2.334 4.083H12.5v-1.75h2.333zM12.5 18.916h2.333v-1.75H12.5zm7-4.083h-2.333v-1.75H19.5zm-2.333 4.083H19.5v-1.75h-2.333z" clip-rule="evenodd"/>\n</svg>\n';
function $50b286f7ea3c94ce$export$7a38180641471460(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Hub" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $50b286f7ea3c94ce$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b225283860ba91a6c228b8f4fa0e1d39>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $b5ac2a4ca3ce583b$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M9.051 15.434H7.734c-1.988 0-3.413-1.218-3.413-3h7.085c.367 0 .605.26.605.63v7.13c-1.772 0-2.96-1.435-2.96-3.434zm3.5-3.543h-1.318c-1.987 0-3.413-1.196-3.413-2.978h7.085c.367 0 .627.239.627.608v7.13c-1.772 0-2.981-1.435-2.981-3.434zm3.52-3.522h-1.317c-1.987 0-3.413-1.217-3.413-3h7.085c.367 0 .605.262.605.61v7.129c-1.771 0-2.96-1.435-2.96-3.434z"/>\n</svg>\n';
var $b5ac2a4ca3ce583b$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM4.321 12.434c0 1.782 1.425 3 3.412 3h1.319v1.326c0 2 1.188 3.433 2.959 3.433v-7.129c0-.369-.238-.63-.605-.63zm3.5-3.52c0 1.781 1.425 2.977 3.412 2.977h1.318v1.326c0 2 1.21 3.433 2.98 3.433V9.521c0-.369-.259-.608-.626-.608zm3.52-3.544c0 1.782 1.426 3 3.413 3h1.317v1.304c0 2 1.188 3.433 2.96 3.433V5.98c0-.348-.238-.609-.605-.609z"/>\n</svg>\n';
function $b5ac2a4ca3ce583b$export$c4b5b1f965d8b3eb(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $b5ac2a4ca3ce583b$var$svg,
        customThemeSvg: $b5ac2a4ca3ce583b$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ed7d2f84cfdfe8bfef2a295bafed6da>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $6b850fd51a663f60$var$svg = '<svg height="100%" viewBox="0 0 83 32">\n    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M11.965 20.698h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.423 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.503 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.7zm4.818-4.82h-1.803c-2.72 0-4.67-1.665-4.67-4.104h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>\n</svg>\n';
function $6b850fd51a663f60$export$bf4c5f97b468e8d6(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $6b850fd51a663f60$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::61edfa3e375524991498620530471e0e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $d093d464013ca0c9$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color, white)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6 .5h12A5.5 5.5 0 0 1 23.5 6v12a5.5 5.5 0 0 1-5.5 5.5H6A5.5 5.5 0 0 1 .5 18V6A5.5 5.5 0 0 1 6 .5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M8.974 15.523H7.62c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.647v7.317c-1.817 0-3.036-1.472-3.036-3.525zm3.591-3.636h-1.352c-2.04 0-3.503-1.227-3.503-3.056h7.272c.376 0 .642.245.642.625v7.317c-1.817 0-3.059-1.473-3.059-3.525zm3.614-3.614h-1.353c-2.04 0-3.502-1.249-3.502-3.078h7.271c.377 0 .62.268.62.624v7.318c-1.817 0-3.036-1.473-3.036-3.525z"/>\n</svg>\n';
function $d093d464013ca0c9$export$f8455b5667a3ee0c(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $d093d464013ca0c9$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::193cafbd0d66aed78a8eae06654a150d>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $7b711b0b6f4773ee$var$svg = '<svg height="100%" viewBox="0 0 83 32">\n    <path fill="var(--text-color, #1e1f21)" d="M71.02 17.67c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M11.965 20.699h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.502 0 .827.357.827.863v9.756c-2.424 0-4.05-1.963-4.05-4.7zm4.788-4.848H14.95c-2.72 0-4.67-1.636-4.67-4.075h9.695c.502 0 .857.327.857.832v9.756c-2.424 0-4.079-1.963-4.079-4.699zm4.818-4.819h-1.803c-2.72 0-4.67-1.666-4.67-4.105h9.695c.503 0 .828.357.828.833v9.756c-2.424 0-4.05-1.963-4.05-4.7z"/>\n</svg>\n';
function $7b711b0b6f4773ee$export$3224b07bc93ef23e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $7b711b0b6f4773ee$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3b3ec3c590ed89c431e0f979daa3e25e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $fe03e1d5910d577e$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#c97cf4)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M13.467 4.882a9.47 9.47 0 0 0 5.422 0c.159-.035.265.07.23.229-.513 1.85-.513 3.558 0 5.408.035.14-.072.264-.23.211a10.1 10.1 0 0 0-5.422 0c-.142.053-.265-.07-.212-.211.476-1.85.476-3.559 0-5.408-.053-.159.07-.264.212-.23m.724 6.553v.3c0 1.39-.972 2.412-2.173 2.412a2.153 2.153 0 0 1-2.154-2.166c0-1.198.971-2.15 2.331-2.15h.353V5.62c-.176-.017-.353-.017-.53-.017a6.387 6.387 0 0 0-6.393 6.394 6.37 6.37 0 0 0 6.393 6.377c3.533 0 6.411-2.854 6.411-6.377v-.563z"/>\n</svg>\n';
var $fe03e1d5910d577e$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-5.981 5.604a6.387 6.387 0 0 0-6.394 6.394 6.373 6.373 0 0 0 6.394 6.377c3.532 0 6.41-2.854 6.41-6.377v-.563H14.19v.3c0 1.39-.97 2.412-2.171 2.413a2.154 2.154 0 0 1-2.156-2.168c0-1.197.973-2.148 2.332-2.148h.353v-4.21c-.177-.018-.353-.018-.53-.018m6.87-.722a9.47 9.47 0 0 1-5.422 0c-.141-.035-.265.07-.212.228.477 1.85.477 3.559 0 5.409-.053.14.07.264.212.211a10.1 10.1 0 0 1 5.422 0c.159.053.265-.07.23-.211-.513-1.85-.513-3.56 0-5.409.034-.158-.072-.263-.23-.228"/>\n</svg>\n';
function $fe03e1d5910d577e$export$21bfbeb62fdcce8d(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Product Discovery" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $fe03e1d5910d577e$var$svg,
        customThemeSvg: $fe03e1d5910d577e$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8e2d27dec964efc37c6ed5782c3fe57>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $2b4bc72c75c9104e$var$svg = '<svg height="100%" viewBox="0 0 327 32">\n    <path fill="var(--text-color, #1e1f21)" d="M317.88 24.35h-1.72L310.62 10h2.82l4.91 13.13 4.9-13.13h2.82l-5.8 14.84c-1.72 4.39-2.7 6.65-6.59 6.65-1.32 0-2.06-.12-2.82-.43v-2.27c.89.28 1.9.37 2.67.37 2.15 0 3.1-1.47 4.36-4.82m-13.25-8.05v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.72.6h-3.53L268.87 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-9.39 10.42v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-13.88-1.42c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.7-15.22c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zM207.68 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-13.41-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-27.86-3.59V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-14.99-1.32c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-20.7.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.78 4.14v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84h-4.02v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14h-3.71v8.28zm-27.87 1.56c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#c97cf4)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M17.448 6.967c2.544.746 5.113.746 7.656 0 .225-.05.375.1.325.323-.724 2.612-.724 5.025 0 7.637.05.199-.1.373-.325.298a14.3 14.3 0 0 0-7.656 0c-.2.075-.374-.1-.3-.298.674-2.612.674-5.025 0-7.637-.074-.223.1-.373.3-.323m1.023 9.253v.423c0 1.965-1.372 3.408-3.068 3.408a3.04 3.04 0 0 1-3.043-3.06c0-1.691 1.372-3.034 3.292-3.034h.5V8.012c-.25-.025-.5-.025-.749-.025a9.02 9.02 0 0 0-9.028 9.03c0 4.999 4.04 9.004 9.028 9.004s9.053-4.03 9.053-9.005v-.796z"/>\n</svg>\n';
function $2b4bc72c75c9104e$export$602140a6a10b02bf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Product Discovery" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $2b4bc72c75c9104e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cedb5d68059644a06a093aa74d8e3cc5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $adb22ec2008c261b$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M13.744 10.156h4.578c.688 0 .922.654.503 1.174l-7.16 8.837c-2.314-1.845-2.096-4.763-.402-6.892zm-3.538 3.521H5.63c-.688 0-.923-.654-.504-1.173l7.16-8.837c2.315 1.844 2.063 4.728.386 6.875z"/>\n</svg>\n';
var $adb22ec2008c261b$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zm-4.256 10.156-2.481 3.12c-1.694 2.129-1.912 5.047.402 6.891l7.16-8.837c.42-.52.185-1.174-.503-1.174zm-8.619 2.348c-.419.52-.183 1.174.504 1.174h4.577l2.465-3.136c1.677-2.146 1.928-5.03-.386-6.875z"/>\n</svg>\n';
function $adb22ec2008c261b$export$3c6158790f5e01c4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $adb22ec2008c261b$var$svg,
        customThemeSvg: $adb22ec2008c261b$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bcf1b6bc0c0712320d6fbdb868500ebb>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ae469cb27b32e626$var$svg = '<svg height="100%" viewBox="0 0 372 32">\n    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.98 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M52.22 5.95c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.25-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M18.268 13.604h5.951c.894 0 1.199.85.654 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.523-8.959zm-4.6 4.577h-5.95c-.894 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>\n</svg>\n';
function $ae469cb27b32e626$export$de148263c75d2bc1(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $ae469cb27b32e626$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b3684e2355c28ec62827d09d362b6cf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $058e08c5b2032942$var$svg = '<svg height="100%" viewBox="0 0 25 24">\n    <path fill="var(--tile-color, white)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" d="M6.417.5h12a5.5 5.5 0 0 1 5.5 5.5v12a5.5 5.5 0 0 1-5.5 5.5h-12a5.5 5.5 0 0 1-5.5-5.5V6a5.5 5.5 0 0 1 5.5-5.5Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M14.117 10.203h4.464c.67 0 .899.637.49 1.144l-6.98 8.616c-2.257-1.798-2.044-4.643-.393-6.72zm-3.45 3.433H6.205c-.67 0-.899-.638-.49-1.144l6.981-8.617c2.256 1.799 2.011 4.61.376 6.704z"/>\n</svg>\n';
function $058e08c5b2032942$export$65fae0eaf343f2ca(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $058e08c5b2032942$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d19396c378541211d8225aae490bcbcf>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $62a3e7cf00b45bb8$var$svg = '<svg height="100%" viewBox="0 0 372 32">\n    <path fill="var(--text-color, #1e1f21)" d="M367.07 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.32-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.27c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-26.16-7.92v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.43 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-22.92-4.74c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H289.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.97.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-14.07-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-28.33 1.31c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-31.44-11.01-2.76-7.48v18.49h-2.76V5.19h4.78l4.57 11.56 1.87 5.55 1.87-5.55 4.6-11.56h4.45v20.15h-2.76V7.06l-2.36 7.27-4.45 11.01h-2.67zm-21.52-2.23c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.09-2.16v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M150.12 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-8.23 0h-3.53L132.91 10h2.76l4.97 13.1 4.93-13.1h2.76zm-15.45-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-12.47-4.21c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.17-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07m-33.99-2.12c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.79-9.04v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93M52.22 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-6.42-5.95V5.19h2.76V19.2c0 3.71-1.63 6.26-5.43 6.26-1.44 0-2.55-.24-3.31-.52v-2.67c.83.34 1.84.52 2.85.52 2.33 0 3.13-1.41 3.13-3.4"/>\n    <path fill="var(--tile-color, white)" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667"/>\n    <path fill="none" stroke="var(--border-color, #dddee1)" stroke-width="1.333" d="M8 .667h16A7.333 7.333 0 0 1 31.333 8v16A7.333 7.333 0 0 1 24 31.333H8A7.333 7.333 0 0 1 .667 24V8A7.333 7.333 0 0 1 8 .667Z"/>\n    <path fill="var(--icon-color, #1868db)" d="M18.268 13.604h5.95c.895 0 1.2.85.655 1.526l-9.308 11.487c-3.008-2.397-2.725-6.19-.524-8.959zm-4.6 4.577h-5.95c-.895 0-1.2-.85-.655-1.526l9.308-11.488c3.009 2.398 2.682 6.148.502 8.938z"/>\n</svg>\n';
function $62a3e7cf00b45bb8$export$f64bc7a7f04428d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Jira Service Management Data Center" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $62a3e7cf00b45bb8$var$svg,
        label: label,
        type: "data-center",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::568f663154fd35333110385dd0c22e41>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $c62c997245debbcb$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>\n</svg>\n';
function $c62c997245debbcb$export$8d789f76fde3e05(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $c62c997245debbcb$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d69248f39a87c063a78e83a58b63bd7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $c497fdad0dc20881$var$svg = '<svg height="100%" viewBox="0 0 103 32">\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>\n</svg>\n';
function $c497fdad0dc20881$export$78c0b4d8be34c9b2(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $c497fdad0dc20881$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9f5d94b0d7bf822b6ab4c2ad26c21970>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $ada0de6468c9842c$var$svg = '<svg height="100%" viewBox="0 0 100 32">\n    <path fill="var(--icon-color, #101214)" d="M66.71 5.11c0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82 0 .39-.26.62-1.08.62-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.06 0 2.85-.92 2.85-2.26m0 .03c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.5c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16m26.29-2.11v7.32h1.57V4.81l.64 1.46 2.21 4.11h1.95V3.06h-1.54v4.73l-.59-1.39-1.77-3.34zm-9.91 0h-1.7v7.32h1.7zM79.45 8.2c0-1.28-.67-1.88-2.59-2.29-1.05-.23-1.31-.46-1.31-.8 0-.41.39-.59 1.08-.59.85 0 1.67.26 2.47.62V3.47c-.56-.28-1.41-.49-2.41-.49-1.9 0-2.88.82-2.88 2.16 0 1.08.49 1.93 2.47 2.31 1.16.26 1.41.44 1.41.82s-.26.62-1.08.62c-.95 0-2.08-.33-2.83-.77v1.75c.59.28 1.36.62 2.83.62 2.03 0 2.85-.92 2.85-2.29M53.5 3.06v7.32h3.49l.54-1.59h-2.34V3.06zm-6.91 0v1.57h1.88v5.75h1.72V4.63h2.03V3.06zm-2.49 0h-2.24l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95c-.03 0-2.57-7.32-2.57-7.32m-1.13 4.75c-.33 0-.64-.05-.93-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m20.06-4.75H60.8l-2.57 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zM61.9 7.81c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19c-.28.08-.59.13-.92.13m27.32-4.75h-2.23l-2.54 7.32h1.95l.36-1.23c.44.13.9.21 1.36.21s.93-.08 1.36-.21l.36 1.23h1.95zm-1.11 4.75c-.33 0-.64-.05-.92-.13l.93-3.19.93 3.19a3.7 3.7 0 0 1-.92.13"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.664-1.775-1.025-2.692 4.664V7.125h-2.048v5.385l-2.694-4.664-1.774 1.025 2.693 4.663-4.664-2.692-1.024 1.774 4.664 2.693H6.958v2.048h5.385L7.68 20.05l1.024 1.775 4.663-2.693-2.692 4.664 1.774 1.024 2.693-4.664v5.386h2.049v-5.385l2.692 4.663 1.774-1.024-2.692-4.664 4.663 2.693 1.025-1.775-4.664-2.692h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.594 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M39.32 27.74v-13.7h2.52v13.7zm24.13-9.31h2.4v1.14c.51-.91 1.7-1.4 2.72-1.4 1.27 0 2.29.55 2.76 1.55.74-1.14 1.72-1.55 2.95-1.55 1.72 0 3.37 1.04 3.37 3.54v6.04h-2.44v-5.53c0-1-.49-1.76-1.65-1.76-1.08 0-1.72.83-1.72 1.84v5.45h-2.49v-5.53c0-1-.51-1.76-1.65-1.76-1.1 0-1.74.81-1.74 1.84v5.45h-2.52zm-15.93 9.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.05 4.93-4.89 4.93m0-7.58a2.65 2.65 0 0 0-2.65 2.65 2.65 2.65 0 0 0 2.65 2.65c1.46 0 2.65-1.19 2.65-2.65a2.65 2.65 0 0 0-2.65-2.65m10.26 7.58c-2.83 0-4.89-2.1-4.89-4.93 0-2.78 2.05-4.93 4.89-4.93 2.85 0 4.89 2.17 4.89 4.93 0 2.8-2.06 4.93-4.89 4.93m0-7.61a2.69 2.69 0 0 0-2.68 2.68 2.69 2.69 0 0 0 2.68 2.68 2.69 2.69 0 0 0 2.68-2.68 2.69 2.69 0 0 0-2.68-2.68"/>\n</svg>\n';
function $ada0de6468c9842c$export$68d7391318cdef11(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom Attribution" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $ada0de6468c9842c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::45c3b4b2f73587dee325566fc7978684>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $6938191cb3110d10$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#625df5)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M19.083 11.212h-4.142l3.588-2.071-.788-1.365-3.588 2.071 2.07-3.587-1.364-.788-2.071 3.587V4.917h-1.576v4.142L9.141 5.472l-1.365.787 2.071 3.588L6.26 7.776 5.472 9.14l3.587 2.07H4.917v1.577h4.142l-3.587 2.071.788 1.365 3.587-2.07-2.071 3.587 1.365.787 2.07-3.587v4.142h1.577V14.94l2.07 3.587 1.365-.787-2.07-3.588 3.587 2.071.788-1.365-3.587-2.07h4.142zM12 14.143a2.151 2.151 0 1 1 0-4.302 2.151 2.151 0 0 1 0 4.302"/>\n</svg>\n';
function $6938191cb3110d10$export$38c7b37a3e5e8d70(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $6938191cb3110d10$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7f4fa46a3d520008396bf538a250ebef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $32e6c98dbbfc9103$var$svg = '<svg height="100%" viewBox="0 0 103 32">\n    <path fill="var(--tile-color,#625df5)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M25.375 15.31H19.99l4.664-2.693-1.024-1.775-4.664 2.693 2.692-4.663-1.775-1.025-2.692 4.663V7.125h-2.048v5.386l-2.694-4.664-1.774 1.024 2.693 4.664-4.664-2.693-1.024 1.774 4.664 2.693H6.959v2.049h5.384L7.68 20.05l1.024 1.774 4.663-2.692-2.692 4.664 1.774 1.024 2.693-4.664v5.385h2.049v-5.385l2.692 4.664 1.774-1.024-2.692-4.665 4.663 2.693 1.025-1.774-4.664-2.693h5.385zm-9.208 3.81a2.797 2.797 0 1 1 0-5.593 2.797 2.797 0 0 1 0 5.593"/>\n    <path fill="var(--text-color, #1e1f21)" d="M42.67 25.34V3.93h3.93v21.41zm37.7-14.55h3.75v1.78c.8-1.42 2.66-2.19 4.26-2.19 1.98 0 3.58.86 4.32 2.43 1.15-1.77 2.69-2.42 4.61-2.42 2.69 0 5.26 1.63 5.26 5.53v9.43h-3.81v-8.63c0-1.57-.77-2.75-2.57-2.75-1.68 0-2.69 1.3-2.69 2.87v8.52h-3.9v-8.63c0-1.57-.8-2.75-2.57-2.75-1.71 0-2.72 1.27-2.72 2.87v8.52h-3.93zM55.48 25.77c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.64-7.7 4.46 0 7.63 3.39 7.63 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.84a4.15 4.15 0 0 0-4.14 4.14 4.15 4.15 0 0 0 4.14 4.14 4.15 4.15 0 0 0 4.14-4.14 4.15 4.15 0 0 0-4.14-4.14m16.02 11.84c-4.43 0-7.63-3.28-7.63-7.7 0-4.34 3.2-7.7 7.63-7.7 4.46 0 7.64 3.39 7.64 7.7 0 4.38-3.21 7.7-7.63 7.7m0-11.89c-2.31 0-4.19 1.88-4.19 4.19s1.88 4.19 4.19 4.19 4.19-1.88 4.19-4.19-1.88-4.19-4.19-4.19"/>\n</svg>\n';
function $32e6c98dbbfc9103$export$71743a944cb62e48(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $32e6c98dbbfc9103$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2bf4732a418598faff0fcffc57f4a7b7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $830a746b3ceda507$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12.696 19.45c-.49.361-.749.336-1.24-.026-2.375-1.704-4.57-3.641-6.042-5.655-.155-.207-.078-.49.155-.62l2.685-1.678q.35-.233.62.077c1.033 1.188 2.04 2.35 3.202 3.176 1.162-.826 2.17-1.988 3.202-3.176q.272-.31.62-.078l2.686 1.679c.232.13.31.413.155.62-1.472 2.014-3.667 3.95-6.043 5.68m-.62-7.411c2.118 0 3.874-1.73 3.874-3.848s-1.756-3.9-3.874-3.9c-2.117 0-3.873 1.757-3.873 3.9s1.704 3.848 3.873 3.848"/>\n</svg>\n';
function $830a746b3ceda507$export$eeccc49dc7a12d9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Opsgenie" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $830a746b3ceda507$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::032f8fa95ed51413adb506dd076fd343>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $4455961c779ea9ff$var$svg = '<svg height="100%" viewBox="0 0 164 32">\n    <path fill="var(--text-color, #1e1f21)" d="M156.69 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM143.39 5.95c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-3.68-8.98v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.47-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.6 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.44.92 5.34.92 3.83 0 5.15-2.06 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-4.72 3.52c0 2.55-1.66 4.48-5.76 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.85-2.15-4.85-4.66 0-2.67 2.06-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-16.29-3.49c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3.01v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-20.11.01c-6.22 0-9.72-4.29-9.72-10.43 0-6.07 3.5-10.33 9.72-10.33 6.2 0 9.69 4.26 9.69 10.34 0 6.13-3.5 10.43-9.69 10.43m0-18.12c-4.97 0-6.96 3.53-6.96 7.7 0 4.26 1.99 7.79 6.96 7.79 4.94 0 6.93-3.53 6.93-7.79 0-4.17-1.99-7.7-6.93-7.7"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M16.905 25.684c-.638.47-.974.437-1.612-.033-3.088-2.216-5.942-4.734-7.855-7.352-.202-.269-.1-.638.201-.806l3.491-2.182q.454-.302.806.1c1.343 1.545 2.652 3.056 4.163 4.13 1.51-1.074 2.82-2.585 4.163-4.13q.352-.402.805-.1l3.491 2.182c.303.168.403.537.202.806-1.914 2.618-4.767 5.136-7.855 7.385m-.806-9.635c2.753 0 5.035-2.249 5.035-5.001s-2.282-5.07-5.035-5.07-5.036 2.283-5.036 5.07c0 2.786 2.216 5.001 5.036 5.001"/>\n</svg>\n';
function $4455961c779ea9ff$export$a5b9122e89b32ad3(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Opsgenie" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $4455961c779ea9ff$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bab74cd77291828d528d124967c3552>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $9e7dbb8c6527ff40$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m5.106 14.44 1.856-1.856-1.856-1.856L6.653 9.18h3.712l2.784-2.784h4.332v4.33l-2.785 2.785v3.712L13.15 18.77l-1.857-1.856-1.856 1.856-1.7-1.7 2.784-2.784-.928-.928-2.784 2.784zm10.209-4.331a1.094 1.094 0 1 1-1.547-1.546 1.094 1.094 0 0 1 1.547 1.546" clip-rule="evenodd"/>\n</svg>\n';
function $9e7dbb8c6527ff40$export$5ed3e1bb3b04fc02(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Projects" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $9e7dbb8c6527ff40$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::820b1edb3bac4a2b82da6f532724cb11>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $cd623f3c1e68a712$var$svg = '<svg height="100%" viewBox="0 0 145 32">\n    <path fill="var(--text-color, #1e1f21)" d="M144.54 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.17-.89-1.84-3.8-2.55-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-17.75-.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.66 1.99v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55M99.43 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM83.8 31.25v-2.36c.31.03.49.03.77.03 1.13 0 2.05-.49 2.05-1.87V10h2.64v17.36c0 2.82-1.59 4.02-4.11 4.02-.67 0-1.13-.06-1.35-.12m2.3-25.3c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84M76.07 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M62.3 16.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-5-4.4c0 4.39-2.45 6.84-7.48 6.84H45.8v6.59h-2.76V5.19h6.78c5.03 0 7.48 2.58 7.48 6.72m-7.79 4.2c3.56.12 4.94-1.56 4.94-4.14 0-2.45-1.38-4.14-4.94-4.14H45.8v8.28z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m6.152 19.486 2.651-2.652-2.651-2.651 2.21-2.21h5.303l3.977-3.977h6.187v6.187l-3.977 3.977v5.304l-2.21 2.21-2.652-2.652-2.651 2.651-2.429-2.428 3.978-3.978-1.326-1.325-3.978 3.977zM20.736 13.3a1.562 1.562 0 1 1-2.21-2.21 1.562 1.562 0 0 1 2.21 2.21" clip-rule="evenodd"/>\n</svg>\n';
function $cd623f3c1e68a712$export$e3d1678155aaab99(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Projects" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $cd623f3c1e68a712$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c09aee6cc96e54887271dd42a7eae172>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $245b5db7efa2068f$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1868db)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M11.057 5.257a1.57 1.57 0 0 1 1.539.015l4.621 2.668c.484.279.783.797.783 1.354v5.336a1.56 1.56 0 0 1-.782 1.355l-3.474 2.005a2 2 0 0 0 .12-.691v-5.337c0-.733-.39-1.409-1.026-1.774l-2.59-1.495V6.626q.001-.246.074-.473c.117-.364.366-.68.707-.877z"/>\n    <path fill="var(--icon-color, white)" d="M9.881 5.94 6.408 7.945A1.56 1.56 0 0 0 5.625 9.3v5.337c0 .557.3 1.075.783 1.354l4.621 2.668c.475.274 1.06.279 1.539.015l.027-.019a1.57 1.57 0 0 0 .781-1.35v-2.067l-2.589-1.495a2.05 2.05 0 0 1-1.026-1.775V6.631a2 2 0 0 1 .12-.691"/>\n</svg>\n';
function $245b5db7efa2068f$export$e23ae35269442b4f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $245b5db7efa2068f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29265478015ee48ec34dc1fd6eae4b81>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $b894f8be9b3238bc$var$svg = '<svg height="100%" viewBox="0 0 106 32">\n    <path fill="var(--text-color, #1e1f21)" d="M98.36 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.87 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#1868db)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896q.017-.046.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682.17-.527.529-.983 1.021-1.267h.002z"/>\n    <path fill="var(--icon-color, white)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>\n</svg>\n';
function $b894f8be9b3238bc$export$b0e15f0a1c9f4c55(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $b894f8be9b3238bc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0424c604e8fb1e51fac762a4e1efa562>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $84e6ea20963e55b1$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M11.26 4.71a1.7 1.7 0 0 1 1.666.017l5.006 2.89c.524.302.848.863.848 1.467v5.78a1.69 1.69 0 0 1-.848 1.467l-3.763 2.172.024-.07c.07-.216.107-.445.107-.679v-5.78c0-.794-.423-1.526-1.112-1.922l-2.805-1.62V6.195q.001-.267.08-.512c.126-.395.396-.737.765-.95l.002-.001z"/>\n    <path fill="var(--icon-color, #101214)" d="M9.986 5.45 6.223 7.623a1.69 1.69 0 0 0-.848 1.466v5.78c0 .605.324 1.166.848 1.468l5.006 2.89a1.7 1.7 0 0 0 1.666.016l.03-.02c.37-.214.64-.556.768-.95q.078-.247.079-.513v-2.24l-2.805-1.618a2.22 2.22 0 0 1-1.112-1.922V6.2a2.2 2.2 0 0 1 .13-.75"/>\n</svg>\n';
function $84e6ea20963e55b1$export$8b784b3227531b3e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $84e6ea20963e55b1$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0f280d200b0e27835aec655dfa5a41e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $f32c8716b41db1c5$var$svg = '<svg height="100%" viewBox="0 0 165 32">\n    <path fill="var(--text-color, #1e1f21)" d="M158.79 25.33h-3.53L149.32 10h2.76l4.97 13.1 4.93-13.1h2.76zm-17.64-13.24c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM121.91 7.82h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.19h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.26.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M84.34 25.33h-3.53L74.86 10h2.76l4.97 13.1L87.53 10h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M49.84 7.82h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.44-7.51H45.8v7.51h-2.76V5.19h7.12c4.81 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#94c748)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M15.013 6.281a2.26 2.26 0 0 1 2.222.021l6.674 3.854a2.26 2.26 0 0 1 1.131 1.956v7.707c0 .809-.43 1.553-1.13 1.956l-5.018 2.896.032-.093c.093-.289.142-.594.142-.906v-7.707a2.95 2.95 0 0 0-1.481-2.563l-3.74-2.158V8.258c0-.235.036-.465.105-.682a2.26 2.26 0 0 1 1.021-1.267h.002z"/>\n    <path fill="var(--icon-color, #101214)" d="m13.314 7.267-5.017 2.896a2.25 2.25 0 0 0-1.13 1.956v7.707c0 .806.432 1.553 1.13 1.956l6.675 3.854c.686.396 1.53.403 2.222.02l.04-.026c.493-.284.853-.74 1.023-1.267a2.3 2.3 0 0 0 .105-.683v-2.986l-3.74-2.158a2.96 2.96 0 0 1-1.482-2.563V8.266a3 3 0 0 1 .174-1"/>\n</svg>\n';
function $f32c8716b41db1c5$export$4145bd793c9ed1d0(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $f32c8716b41db1c5$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c56e9a05bb3a4c70bfd4cbcb5fa54ba2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $88611c352521b9a8$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#94c748)" d="M10.7.368a2.75 2.75 0 0 1 2.748 0l8.016 4.626a2.75 2.75 0 0 1 1.375 2.38v9.252c0 .982-.524 1.889-1.375 2.38l-8.016 4.626a2.75 2.75 0 0 1-2.749 0l-8.016-4.626a2.75 2.75 0 0 1-1.374-2.38V7.374c0-.982.524-1.889 1.374-2.38z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.181 6.096 6.777 8.06a1.53 1.53 0 0 0-.768 1.327v5.229c0 .547.294 1.054.768 1.327l.807.466 3.722 2.149a1.54 1.54 0 0 0 1.508.014l.027-.018a1.54 1.54 0 0 0 .766-1.323v-2.026l-1.97-1.137-.568-.327a2 2 0 0 1-1.006-1.74V6.775a2 2 0 0 1 .118-.678" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M12.842 5.441a1.54 1.54 0 0 0-1.508-.014l-.028.019a1.54 1.54 0 0 0-.765 1.323v2.025l1.91 1.102.628.362a2 2 0 0 1 1.006 1.74v5.228a2 2 0 0 1-.118.678l3.404-1.965c.476-.273.767-.778.767-1.327V9.383c0-.546-.293-1.054-.767-1.327l-.868-.501z" clip-rule="evenodd"/>\n</svg>\n';
function $88611c352521b9a8$export$813cff80931d9dbf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev Agent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $88611c352521b9a8$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ca2d332c134816706ee434029a355d3c>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $179c0ef69585846e$var$svg = '<svg height="100%" viewBox="0 0 160 32">\n    <path fill="var(--text-color, #1e1f21)" d="M153.94 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zM136.3 12.42c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-25.13-16.9h-4.54v14.87h4.69c4.6 0 6.9-2.42 6.9-7.3 0-4.91-2.18-7.57-7.05-7.57m-7.3 17.51V5.52h7.42c6.53 0 9.69 4.08 9.69 10.12 0 6.1-3.19 10.03-9.69 10.03zm-16.25.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.31c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M45 8.16h-4.05v7.36H45c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--tile-color,#94c748)" d="M12.52.49a3.67 3.67 0 0 1 3.666 0l10.688 6.17a3.66 3.66 0 0 1 1.833 3.173v12.336a3.66 3.66 0 0 1-1.833 3.173L16.186 31.51a3.67 3.67 0 0 1-3.665 0L1.833 25.341A3.66 3.66 0 0 1 0 22.168V9.832c0-1.309.7-2.519 1.833-3.173z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m11.83 8.128-4.54 2.62a2.04 2.04 0 0 0-1.022 1.77v6.972c0 .728.39 1.405 1.023 1.77l1.076.62 4.963 2.865a2.05 2.05 0 0 0 2.01.02l.037-.025c.445-.257.771-.67.925-1.146q.094-.297.095-.619v-2.7l-2.627-1.516-.757-.436a2.67 2.67 0 0 1-1.34-2.32v-6.97a2.7 2.7 0 0 1 .157-.904" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M15.377 7.255a2.05 2.05 0 0 0-2.01-.019l-.038.026c-.445.257-.77.67-.924 1.145a2 2 0 0 0-.095.618v2.7l2.545 1.47.839.483a2.67 2.67 0 0 1 1.34 2.319v6.972a2.7 2.7 0 0 1-.157.903l4.54-2.62a2.04 2.04 0 0 0 1.022-1.77v-6.971c0-.729-.39-1.405-1.023-1.77l-1.157-.668z" clip-rule="evenodd"/>\n</svg>\n';
function $179c0ef69585846e$export$58747af448450872(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo Dev Agent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $179c0ef69585846e$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b1fdf93317430cb701429972e6c41dc4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $7aafbe28d5215677$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m13.227 16.789-7.154 4.169-3.403-1.96a2.72 2.72 0 0 1-1.362-2.355V7.366c0-.973.518-1.87 1.361-2.354l6.044-3.487-.038.114a3.6 3.6 0 0 0-.172 1.088v9.278c0 1.274.68 2.45 1.786 3.085z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m11.296 15.671-7.193 4.153 6.607 3.812a2.73 2.73 0 0 0 2.676.026l.048-.033a2.73 2.73 0 0 0 1.232-1.525 2.7 2.7 0 0 0 .127-.822v-3.594z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="m21.477 5.003-4.404-2.539-5.904 4.89 2.69 1.556a3.56 3.56 0 0 1 1.785 3.086v9.277a3.6 3.6 0 0 1-.21 1.202l6.044-3.486a2.71 2.71 0 0 0 1.362-2.355V7.357c0-.97-.521-1.87-1.363-2.354" clip-rule="evenodd"/>\n    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="M12.74 8.266 9.353 6.312V2.718c0-.283.044-.56.127-.821A2.73 2.73 0 0 1 10.71.372V.37a.4.4 0 0 0 .048-.033 2.73 2.73 0 0 1 2.676.026l6.499 3.75z" clip-rule="evenodd"/>\n</svg>\n';
function $7aafbe28d5215677$export$9e62346a60cfb459(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $7aafbe28d5215677$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0e01ef8caae93929e35d346a5091c5ef>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $274106a9269394f9$var$svg = '<svg height="100%" viewBox="0 0 102 32">\n    <path fill="var(--text-color, #1e1f21)" d="M93.5 25.97c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M79.49 25.67h-3.53l-5.95-15.33h2.76l4.97 13.1 4.94-13.09h2.76zm-17.46.3c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M44.99 8.16h-4.05v7.36h4.05c3.59 0 4.69-1.38 4.69-3.68 0-2.18-1.13-3.68-4.69-3.68m7.45 3.62c0 3.04-1.29 5.09-3.96 5.95l4.94 7.94h-3.25l-4.45-7.51h-4.78v7.51h-2.76V5.52h7.11c4.82 0 7.15 2.39 7.15 6.26"/>\n    <path fill="var(--rovo-blue-color, #1868db)" fill-rule="evenodd" d="m15.892 22.385-9.538 5.559-4.538-2.613A3.63 3.63 0 0 1 0 22.19V9.821C0 8.524.69 7.33 1.816 6.682l8.058-4.649-.052.152a4.7 4.7 0 0 0-.228 1.452v12.37a4.74 4.74 0 0 0 2.38 4.113z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-green-color, #6a9a23)" fill-rule="evenodd" d="m13.318 20.895-9.591 5.538 8.809 5.082a3.64 3.64 0 0 0 3.568.034l.065-.043a3.63 3.63 0 0 0 1.642-2.034c.11-.35.17-.718.17-1.096v-4.792z" clip-rule="evenodd"/>\n    <path fill="var(--rovo-purple-color, #af59e1)" fill-rule="evenodd" d="M26.893 6.67 21.02 3.285l-7.873 6.52 3.587 2.075a4.74 4.74 0 0 1 2.38 4.115v12.369a4.7 4.7 0 0 1-.28 1.603l8.058-4.649a3.62 3.62 0 0 0 1.816-3.139V9.81a3.63 3.63 0 0 0-1.816-3.139" clip-rule="evenodd"/>\n    <path fill="var(--rovo-yellow-color, #fca700)" fill-rule="evenodd" d="m15.244 11.022-4.519-2.606V3.625c0-.378.059-.747.17-1.096a3.63 3.63 0 0 1 1.64-2.033l.002-.001.064-.044a3.64 3.64 0 0 1 3.569.034l8.665 5z" clip-rule="evenodd"/>\n</svg>\n';
function $274106a9269394f9$export$5e38d02efdb45577(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Rovo" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $274106a9269394f9$var$svg,
        label: label,
        type: "rovo",
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88ee37f21199df8c4f6de50b597bc415>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $f99f93427c4212ee$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M5 10.688a5.69 5.69 0 0 0 5.697 5.687c1.01 0 1.958-.262 2.78-.723L16.832 19 19 16.834l-3.347-3.341c.471-.828.74-1.785.74-2.806A5.69 5.69 0 0 0 10.697 5 5.69 5.69 0 0 0 5 10.688m2.191 0c0 1.932 1.57 3.5 3.506 3.5a3.503 3.503 0 0 0 3.505-3.5c0-1.933-1.57-3.5-3.505-3.5a3.503 3.503 0 0 0-3.506 3.5" clip-rule="evenodd"/>\n</svg>\n';
function $f99f93427c4212ee$export$82eafebb825fc23f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $f99f93427c4212ee$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4165d5d8279c6abbf1ec41290594700b>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $eedbe49b69e7d2fc$var$svg = '<svg height="100%" viewBox="0 0 130 32">\n    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.53c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.04 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.47-.74-3.99 0-5.61 2.51-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.68-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10H88v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M7.127 14.833a7.583 7.583 0 0 0 11.286 6.62l4.464 4.464 2.887-2.888-4.455-4.455a7.583 7.583 0 1 0-14.181-3.74m2.917 0a4.667 4.667 0 1 0 9.333 0 4.667 4.667 0 0 0-9.333 0" clip-rule="evenodd"/>\n</svg>\n';
function $eedbe49b69e7d2fc$export$fa08cbfe393f2a68(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $eedbe49b69e7d2fc$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fb81b6548e62d67fc83daf888114f8f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $35030180b63422ca$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6.625a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.76 17.176a5.791 5.791 0 1 1 5.038-2.935l3.403 3.403-2.205 2.204-3.409-3.408a5.77 5.77 0 0 1-2.827.736m-.274-9.37-.242.615c-.344.874-.516 1.312-.833 1.64-.318.33-.749.518-1.61.893l-.37.16v.51l.37.16c.861.376 1.292.563 1.61.893.317.329.49.766.833 1.64l.242.616h.51l.242-.616c.344-.874.516-1.311.834-1.64.317-.33.748-.517 1.61-.893l.368-.16v-.51l-.369-.16c-.861-.375-1.292-.563-1.61-.892-.317-.33-.489-.766-.833-1.64l-.242-.616z" clip-rule="evenodd"/>\n</svg>\n';
function $35030180b63422ca$export$3599582ddc9fc5cf(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $35030180b63422ca$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::12cecbe0aa290ffe5232721f12ef458f>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $e546016f161adc20$var$svg = '<svg height="100%" viewBox="0 0 130 32">\n    <path fill="var(--text-color, #1e1f21)" d="M128.82 16.35v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V3.59h2.64v8.96c1.01-1.81 2.85-2.85 5.06-2.85 3.44 0 5.34 2.33 5.34 6.66m-16.05 6.21v2.36c-.92.49-2.33.71-3.74.71-5.46 0-8-3.31-8-8 0-4.63 2.55-7.94 8-7.94 1.38 0 2.45.18 3.65.74v2.45c-.98-.46-2.02-.74-3.46-.74-3.99 0-5.61 2.52-5.61 5.49s1.66 5.49 5.67 5.49c1.56 0 2.55-.21 3.5-.55m-18.23-6.29v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93m-17.87 1.37c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM65.08 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.2c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-15.33-4.95c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.346 22.068a7.721 7.721 0 1 1 6.718-3.913l4.537 4.536-2.94 2.94-4.545-4.545a7.7 7.7 0 0 1-3.77.982m-.364-12.494-.323.82c-.459 1.167-.688 1.75-1.112 2.188-.423.44-.997.69-2.146 1.19l-.492.214v.68l.492.213c1.149.5 1.723.75 2.146 1.19.424.439.653 1.022 1.112 2.188l.323.82h.679l.323-.82c.459-1.166.688-1.75 1.111-2.188.424-.44.998-.69 2.147-1.19l.491-.214v-.679l-.491-.214c-1.149-.5-1.723-.75-2.147-1.19-.423-.438-.652-1.021-1.111-2.187l-.323-.82z" clip-rule="evenodd"/>\n</svg>\n';
function $e546016f161adc20$export$d669f6cbbb67e061(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Search" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $e546016f161adc20$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37c59c3ee979ff8acaf7525e576da094>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $5383f955374df52f$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#ffc716)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M12 9.796c-1.924 0-3.796.832-5.324 2.118q-.238.227-.475.227c-.132 0-.263-.076-.369-.202L3.908 9.771c-.105-.126-.158-.252-.158-.353 0-.151.08-.277.237-.429C6.307 7.023 9.127 5.914 12 5.914s5.693 1.109 8.013 3.075c.158.152.237.278.237.429 0 .1-.053.227-.158.353l-1.924 2.168c-.106.126-.238.202-.37.202q-.236 0-.474-.227c-1.529-1.286-3.4-2.118-5.324-2.118m0 8.118c-2.135 0-3.875-1.664-3.875-3.68 0-2.018 1.74-3.682 3.875-3.682s3.875 1.64 3.875 3.681-1.74 3.68-3.875 3.68"/>\n</svg>\n';
function $5383f955374df52f$export$f3f5aa321d88adf9(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Statuspage" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $5383f955374df52f$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4e31a509778b74933bf91345a74560c5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $12d1e313e16eae6a$var$svg = '<svg height="100%" viewBox="0 0 192 32">\n    <path fill="var(--text-color, #1e1f21)" d="M184.96 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2h-11.19c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-18.64-.62v-1.53c-.98 2.02-2.82 3.07-5.18 3.07-4.05 0-6.07-3.46-6.07-7.97 0-4.32 2.12-7.97 6.38-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.58v13.95c0 4.51-2.12 7.54-7.61 7.54-2.58 0-3.99-.34-5.46-.83v-2.58c1.69.55 3.43.92 5.34.92 3.83 0 5.15-2.05 5.15-4.91m-8.68-6.44c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m-16.96.03c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-16.09-7.66c0-3.68-1.47-5.52-4.2-5.52-2.36 0-4.48 1.5-4.48 4.91v1.23c0 3.4 1.93 4.91 4.17 4.91 2.98 0 4.51-1.96 4.51-5.52m-3.8 7.97c-2.24 0-3.96-1.01-4.88-3v8.68h-2.64V10h2.64v2.76c.98-2.02 2.82-3.07 5.18-3.07 4.08 0 6.13 3.47 6.13 7.97 0 4.32-2.15 7.97-6.44 7.97m-10.55-4.47c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.68-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-27.61-2.18V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19H85V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-18.95-2.91c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zm-17.26-4.75c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#ffc716)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M15.896 13.196c-2.464 0-4.86 1.114-6.817 2.835q-.303.304-.607.304c-.169 0-.338-.102-.473-.27l-2.463-2.902c-.135-.17-.202-.338-.202-.473 0-.202.1-.371.303-.573C8.607 9.484 12.217 8 15.896 8c3.678 0 7.29 1.484 10.259 4.117.202.202.303.37.303.573 0 .135-.067.304-.202.473l-2.463 2.902c-.135.168-.304.27-.473.27q-.303 0-.607-.304c-1.958-1.721-4.353-2.835-6.817-2.835m0 10.867c-2.733 0-4.96-2.228-4.96-4.927 0-2.7 2.227-4.927 4.96-4.927s4.96 2.193 4.96 4.927-2.227 4.927-4.96 4.927"/>\n</svg>\n';
function $12d1e313e16eae6a$export$2bc88a281410ffa7(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Statuspage" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $12d1e313e16eae6a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2be4b98bf6f70e39467c5c4d0f75c6d5>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $4a3a85d733d79f75$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M10.7 11.222V19h7.8v-7.778z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.6 7.609 10.05 5 5.5 7.609v5.217l3.64 2.087V9.667h5.46z"/>\n</svg>\n';
function $4a3a85d733d79f75$export$290a0f24614cde9f(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $4a3a85d733d79f75$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a96e3d2d2d3910fdbea7d20bda091bd2>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $07df3271d91e3cf0$var$svg = '<svg height="100%" viewBox="0 0 124 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.16.77-1.84 1.84-1.84s1.84.68 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.62 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.84 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.17 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97 0-1.78-1.1-2.73-4.94-3.65-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.84 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M14.125 14.125V24.75H24.75V14.125z"/>\n    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>\n</svg>\n';
function $07df3271d91e3cf0$export$273fd56580e523ae(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $07df3271d91e3cf0$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e6df92ef654dd711bfb690d95b2c06d7>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $66c7c050b1a81a59$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M10.594 18.563v-7.97h7.969v7.97zm3.808-6.488-.163.429c-.235.615-.352.922-.572 1.155s-.52.368-1.12.638l-.222.1v.357l.222.099c.6.27.9.405 1.12.638s.337.54.572 1.156l.163.428h.347l.163-.429c.235-.615.352-.922.572-1.155s.52-.368 1.12-.638l.221-.1v-.357l-.22-.1c-.601-.269-.901-.404-1.121-.637s-.337-.54-.572-1.155l-.164-.429z" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M14.813 7.195 10.125 4.5 5.438 7.195v5.39l3.75 2.157V9.187h5.625z"/>\n</svg>\n';
function $66c7c050b1a81a59$export$8bb9894377e04e04(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $66c7c050b1a81a59$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88f184410a9d6dcf22f1ca1246d077a0>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $57a5360c22b8212c$var$svg = '<svg height="100%" viewBox="0 0 124 32">\n    <path fill="var(--text-color, #1e1f21)" d="M116.71 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49m-13.48-6.2c0-1.17.77-1.84 1.84-1.84s1.84.67 1.84 1.84-.77 1.84-1.84 1.84-1.84-.67-1.84-1.84m.49 19.38V10h2.64v15.33zm-15.3-7.66c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V3.59h2.64v21.74zm-27.41-6.34V10h2.64v9.26c0 2.76 1.1 3.99 3.62 3.99 2.45 0 4.14-1.63 4.14-4.72V10h2.64v15.33h-2.64v-2.51c-.98 1.81-2.79 2.82-4.85 2.82-3.53 0-5.55-2.42-5.55-6.65m-7.16 1.59c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55a6.3 6.3 0 0 1-1.78.25c-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-6.89-.8c0 3.5-2.08 5.86-7.08 5.86-3.89 0-5.7-.77-7.27-1.56v-2.82c1.87.98 4.75 1.69 7.42 1.69 3.04 0 4.17-1.2 4.17-2.97s-1.1-2.73-4.94-3.65c-4.54-1.1-6.56-2.67-6.56-5.98 0-3.13 2.39-5.46 7.08-5.46 2.91 0 4.78.71 6.16 1.47v2.76c-2.02-1.16-4.2-1.53-6.29-1.53-2.64 0-4.2.92-4.2 2.76 0 1.66 1.29 2.48 4.85 3.37 4.26 1.07 6.66 2.45 6.66 6.07"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="M14.125 24.75V14.125H24.75V24.75zm5.078-8.65-.218.571c-.312.82-.469 1.23-.762 1.541s-.694.49-1.494.85l-.295.133v.476l.295.133c.8.36 1.2.54 1.494.85.293.311.45.721.762 1.541l.218.572h.462l.218-.572c.313-.82.469-1.23.762-1.54s.694-.491 1.494-.851l.295-.133v-.476l-.295-.132c-.8-.36-1.2-.54-1.494-.85-.293-.312-.45-.722-.762-1.542l-.218-.571z" clip-rule="evenodd"/>\n    <path fill="var(--icon-color, #101214)" d="M19.75 9.594 13.5 6 7.25 9.594v7.187l5 2.875V12.25h7.5z"/>\n</svg>\n';
function $57a5360c22b8212c$export$170353c338ac5f4a(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Studio" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $57a5360c22b8212c$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1d8fa09e3a068fb57474a844fe5ab56>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $a504bbca9fdd4b05$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#fb9700)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" fill-rule="evenodd" d="m9.297 8.753 2.277-5.073h.858l2.277 5.073 5.529.598.265.816-4.121 3.734 1.14 5.442-.695.505-4.824-2.766-4.824 2.766-.695-.505 1.14-5.442-4.121-3.733.265-.817zm.777 6.415v-.678a1.857 1.857 0 0 1 3.715 0v.613a3.6 3.6 0 0 1-1.886.548h-.053a3.6 3.6 0 0 1-1.776-.483m1.858-3.134a1.393 1.393 0 1 0 0-2.786 1.393 1.393 0 0 0 0 2.786" clip-rule="evenodd"/>\n</svg>\n';
function $a504bbca9fdd4b05$export$4b05688514531169(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Talent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $a504bbca9fdd4b05$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4af27131cfc453f0f255c3cbe65f158e>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $3e9d75e6bacee67b$var$svg = '<svg height="100%" viewBox="0 0 122 32">\n    <path fill="var(--text-color, #1e1f21)" d="M117.1 20.58c0 1.35.8 2.27 2.42 2.27.61 0 1.2-.12 1.66-.21v2.55c-.46.12-.98.25-1.78.25-3.28 0-4.88-1.93-4.88-4.78v-8.19h-2.48V10h2.48V6.75h2.58V10h4.08v2.45h-4.08zm-7.33-4.23v8.99h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.51c.98-1.81 2.79-2.82 4.85-2.82 3.53 0 5.55 2.42 5.55 6.66m-22.92-4.26c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H82.4c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-14.47.57c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-20.75-7.63c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.47-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#fb9700)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="m16.577 4.907 3.035 6.763 7.372.797.354 1.09-5.495 4.977 1.52 7.257-.927.672-6.431-3.687-6.433 3.687-.926-.672 1.52-7.257-5.495-4.978.353-1.089 7.372-.797 3.035-6.763zm-.668 11.936a2.476 2.476 0 0 0-2.476 2.477v.904a4.8 4.8 0 0 0 2.369.644h.07a4.8 4.8 0 0 0 2.514-.73v-.818a2.477 2.477 0 0 0-2.477-2.477m0-4.511a1.857 1.857 0 1 0 0 3.714 1.857 1.857 0 0 0 0-3.714"/>\n</svg>\n';
function $3e9d75e6bacee67b$export$1b3979d995ebbc6e(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Talent" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $3e9d75e6bacee67b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7cfe9311dc5f8070530ce9772b12f3fc>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $52070f2ac60a941b$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#dddee1)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, #101214)" d="M8.06 11.25a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m7.88 0a2.63 2.63 0 1 0 0-5.25 2.63 2.63 0 0 0 0 5.25m.17 1.31a2.89 2.89 0 0 1 2.89 2.9V18h-7.22l1.66-3.67a2.89 2.89 0 0 1 2.67-1.77M5 15.63V18h4.81l1.31-2.81a2.63 2.63 0 0 0-2.62-2.63h-.44A3.06 3.06 0 0 0 5 15.63"/>\n</svg>\n';
function $52070f2ac60a941b$export$1bcbc9c337da86da(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Teams" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $52070f2ac60a941b$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a9a7a0d4583e5a9f22d08a0d2f6ac1f1>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1922a735eb9a473a$var$svg = '<svg height="100%" viewBox="0 0 127 32">\n    <path fill="var(--text-color, #1e1f21)" d="M126.58 21.16c0 2.55-1.66 4.48-5.77 4.48-2.3 0-4.17-.52-5.34-1.13v-2.79c1.32.77 3.53 1.5 5.46 1.5 2.02 0 3.07-.83 3.07-2.02 0-1.16-.89-1.84-3.8-2.54-3.4-.83-4.84-2.15-4.84-4.66 0-2.67 2.05-4.29 5.55-4.29 1.99 0 3.8.49 4.94 1.1v2.73c-1.84-.92-3.34-1.41-4.97-1.41-1.93 0-2.97.67-2.97 1.87 0 1.07.74 1.75 3.56 2.42 3.4.83 5.12 2.09 5.12 4.75m-24.66-4.36v8.53h-2.64v-9.26c0-2.76-1.1-3.99-3.62-3.99-2.45 0-4.14 1.63-4.14 4.72v8.53h-2.64V10h2.64v2.52c.98-1.81 2.79-2.82 4.85-2.82 2.61 0 4.39 1.32 5.15 3.74.86-2.36 2.91-3.74 5.46-3.74 3.44 0 5.34 2.33 5.34 6.66v8.99h-2.64v-8.52c0-3.16-1.1-4.72-3.62-4.72-2.45 0-4.14 1.63-4.14 4.72m-28.33.84c0 3.68 1.47 5.52 4.2 5.52 2.36 0 4.48-1.5 4.48-4.91v-1.23c0-3.4-1.93-4.91-4.17-4.91-2.97 0-4.51 1.96-4.51 5.52m8.68 7.67v-2.76c-.98 2.02-2.82 3.07-5.18 3.07-4.08 0-6.13-3.46-6.13-7.97 0-4.32 2.15-7.97 6.44-7.97 2.24 0 3.96 1.01 4.88 3.01V10h2.64v15.33zM61.99 12.08c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.68-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H57.55c.37 2.61 2.06 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zM40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#dddee1)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, #101214)" d="M10.75 14.83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m10.5 0a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.23 1.75a3.86 3.86 0 0 1 3.86 3.86v3.72h-9.62l2.21-5.23a3.86 3.86 0 0 1 3.55-2.35M6.67 20.67v3.5h6.42l1.75-4.08a3.5 3.5 0 0 0-3.5-3.5h-.58a4.08 4.08 0 0 0-4.08 4.08"/>\n</svg>\n';
function $1922a735eb9a473a$export$bfd8d1c4da84ce71(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Teams" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $1922a735eb9a473a$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc7b25031952cd94704eefaa85d7de4>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
var $e1208027089940ea$var$svg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--tile-color,#1558bc)" d="M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"/>\n    <path fill="var(--icon-color, white)" d="M9.39 18.23a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95H5.38a.95.95 0 0 0-.95.95v11.91c0 .52.42.95.95.95zm9.23-5.46a.95.95 0 0 0 .95-.95V5.38a.95.95 0 0 0-.95-.95h-4.01a.95.95 0 0 0-.95.95v6.44c0 .52.42.95.95.95z"/>\n</svg>\n';
var $e1208027089940ea$var$customThemeSvg = '<svg height="100%" viewBox="0 0 24 24">\n    <path fill="var(--themed-icon-color, currentcolor)" d="M18 0a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6zM5.379 4.43a.95.95 0 0 0-.948.949v11.907c0 .523.424.948.948.948H9.39a.95.95 0 0 0 .947-.948V5.38a.95.95 0 0 0-.947-.948zm9.23 0a.95.95 0 0 0-.947.949v6.44c0 .523.423.948.947.949h4.012a.95.95 0 0 0 .948-.949V5.38a.95.95 0 0 0-.948-.948z"/>\n</svg>\n';
function $e1208027089940ea$export$4384da9b8b140bf4(_ref) {
    var iconColor = _ref.iconColor, size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Trello" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $a3d1df678624450f$export$be58b4326e23250f), {
        svg: $e1208027089940ea$var$svg,
        customThemeSvg: $e1208027089940ea$var$customThemeSvg,
        iconColor: iconColor,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}

/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b73a20da143650f747e32cb182c99798>>
 * @codegenCommand yarn workspace @atlaskit/logo generate:components
 */ 
var $iSvIT = parcelRequire("iSvIT");

// `height` is set to 100% to allow the SVG to scale with the parent element
// The text color is set to "currentColor" to allow the SVG to inherit the color set by the parent based on the theme.
var $1bc25fd991892865$var$svg = '<svg height="100%" viewBox="0 0 113 32">\n    <path fill="var(--text-color, #1e1f21)" d="M104.97 25.64c-4.6 0-7.3-3.4-7.3-8s2.7-7.94 7.3-7.94c4.57 0 7.24 3.34 7.24 7.94s-2.67 8-7.24 8m0-13.49c-3.28 0-4.72 2.58-4.72 5.49s1.44 5.55 4.72 5.55c3.25 0 4.66-2.64 4.66-5.55s-1.41-5.49-4.66-5.49M96.21 25.3c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zm-8 0c-.21.06-.67.12-1.35.12-2.51 0-4.11-1.19-4.11-4.02V3.59h2.64V21.1c0 1.38.92 1.87 2.06 1.87.28 0 .46 0 .77-.03zM72.86 12.09c-2.79 0-4.2 1.81-4.48 4.48h8.56c-.15-2.85-1.44-4.48-4.08-4.48m5.89 12.64c-1.26.67-3.19.92-4.75.92-5.73 0-8.25-3.31-8.25-8 0-4.63 2.58-7.94 7.24-7.94 4.72 0 6.62 3.28 6.62 7.94v1.2H68.42c.37 2.61 2.05 4.29 5.67 4.29 1.78 0 3.28-.34 4.66-.83zm-19.48-8.44v9.05h-2.58V10h2.58v2.7c.89-1.81 2.42-3.1 5.43-2.91v2.58c-3.37-.34-5.43.67-5.43 3.93M40.28 5.19h15.09v2.64H49.2v17.51h-2.76V7.82h-6.16z"/>\n    <path fill="var(--tile-color,#1558bc)" d="M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"/>\n    <path fill="var(--icon-color, white)" d="M12.9 24c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H8.13C7.51 8 7 8.49 7 9.1v13.8c0 .61.5 1.1 1.13 1.1zm10.97-6.34c.62 0 1.13-.49 1.13-1.1V9.1c0-.61-.5-1.1-1.13-1.1H19.1c-.62 0-1.13.49-1.13 1.1v7.47c0 .61.5 1.1 1.13 1.1z"/>\n</svg>\n';
function $1bc25fd991892865$export$1b13139dfc0336af(_ref) {
    var size = _ref.size, _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "brand" : _ref$appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Trello" : _ref$label, testId = _ref.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $91f465b125aabec8$export$f827d3c5a9c3f644), {
        svg: $1bc25fd991892865$var$svg,
        label: label,
        appearance: appearance,
        size: size,
        testId: testId
    });
}



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $17c74fe2d74a1d63$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $17c74fe2d74a1d63$export$84109e099492cb5f = function AtlassianAdminIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Admin" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $17c74fe2d74a1d63$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $d13bb10895612b0c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 295 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M294.31 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"\n        fill="'.concat(colors.textColor, '"\n      />\n      <path\n        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="').concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $d13bb10895612b0c$export$f845d9b9254f0541 = function AtlassianAdminLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Admin" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $d13bb10895612b0c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $41b01b373d929f9b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M27.545 24.378 16.96 3.208c-.208-.458-.417-.541-.667-.541-.208 0-.458.083-.708.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.042 13.794.334.667.584.792 1.167.792h7.335c.541 0 .833-.208.833-.625 0-.208-.042-.333-.25-.75M12.168 14.377c-.834-1.25-1.084-1.334-1.292-1.334s-.333.083-.708.834L4.875 24.46c-.167.334-.208.459-.208.625 0 .334.291.667.916.667h7.46c.5 0 .875-.416 1.083-1.208.25-1 .334-1.876.334-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $41b01b373d929f9b$export$74517ed253186308 = function AtlassianAdministrationIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Administration" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $41b01b373d929f9b$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $083777c57a844e8b$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 404 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M403.77 16.348v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-23.336 9.292c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.57 0 7.237 3.343 7.237 7.943s-2.667 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.489s1.442 5.55 4.723 5.55c3.251 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49zm-13.488-6.195c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-7.461-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.078v2.453h-4.078zm-18.943-2.913c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V10h2.637v15.333zm-17.793-9.046v9.046h-2.576V10h2.576v2.699c.89-1.81 2.423-3.098 5.428-2.914v2.576c-3.373-.337-5.428.675-5.428 3.926m-10.037 4.293c0 1.35.797 2.27 2.423 2.27.613 0 1.196-.123 1.656-.215v2.545c-.46.123-.982.245-1.779.245-3.281 0-4.876-1.932-4.876-4.784v-8.188h-2.484V10h2.484V6.75h2.576V10h4.079v2.453h-4.079zm-6.696.583c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.675-2.974 1.87 0 1.074.736 1.749 3.557 2.423 3.404.828 5.121 2.086 5.121 4.754M297.497 5.952c0-1.165.767-1.84 1.84-1.84 1.074 0 1.84.675 1.84 1.84s-.766 1.84-1.84 1.84c-1.073 0-1.84-.675-1.84-1.84m.491 19.381V10h2.637v15.333zm-3.678-8.985v8.985h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.982-1.81 2.791-2.822 4.846-2.822 3.526 0 5.55 2.423 5.55 6.655M274.168 5.952c0-1.165.766-1.84 1.84-1.84 1.073 0 1.84.675 1.84 1.84s-.767 1.84-1.84 1.84c-1.074 0-1.84-.675-1.84-1.84m.49 19.381V10h2.638v15.333zm-14.069-8.525v8.525h-2.637v-9.261c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.626-4.14 4.723v8.525h-2.637V10h2.637v2.515c.981-1.81 2.791-2.822 4.845-2.822 2.607 0 4.386 1.319 5.152 3.742.859-2.362 2.914-3.742 5.459-3.742 3.435 0 5.336 2.331 5.336 6.655v8.985h-2.637v-8.525c0-3.159-1.104-4.723-3.619-4.723-2.453 0-4.14 1.626-4.14 4.723m-28.327.859c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.227c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006V3.59h2.637v21.742zm-22.021-4.017c-1.533 0-3.097-.184-4.814-.521l-1.687 4.538h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.569c-1.809.368-3.373.552-4.999.552m0-2.453c1.288 0 2.607-.154 4.171-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369"\n        fill="'.concat(colors.textColor, '"\n      />\n      <path\n        d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.619 0-5.733-.92-7.785-2.123v4.812c1.627.779 3.751 1.699 7.785 1.699 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.299-2.902-.637-3.61-1.274-3.61-2.194 0-1.132 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.7V6.368c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.172h4.318V9.978l1.769 4.034 6.087 11.325h5.379V5.165h-4.247v13.023l-1.628-3.822-4.883-9.2zm-27.319 0h-4.671v20.172h4.671zm-10.05 14.155c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.707 6.795 1.698v-4.6c-1.557-.779-3.893-1.345-6.653-1.345-5.238 0-7.927 2.265-7.927 5.945 0 2.973 1.345 5.309 6.794 6.37 3.185.708 3.893 1.203 3.893 2.265s-.708 1.699-2.973 1.699c-2.618 0-5.733-.92-7.785-2.124v4.813c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.165v20.172h9.625l1.486-4.389h-6.44V5.165zm-19.039 0v4.318h5.167v15.854h4.741V9.483h5.592V5.165zm-6.866 0h-6.157L32 25.336h5.379l.99-3.397c1.204.354 2.478.566 3.752.566s2.548-.212 3.751-.566l.991 3.397h5.379c-.07 0-7.078-20.17-7.078-20.17zM42.05 18.26c-.92 0-1.77-.142-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354M97.326 5.165H91.17l-7.08 20.171h5.38l.99-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zM94.212 18.26c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.095h-6.157l-7.007 20.171h5.379l.991-3.397c1.203.354 2.477.566 3.751.566s2.548-.212 3.751-.566l.991 3.397h5.379zm-3.043 13.094c-.92 0-1.77-.142-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"\n        fill="').concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $083777c57a844e8b$export$833abe6c2ce5ebfd = function AtlassianAdministrationLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Administration" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $083777c57a844e8b$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $d05Rs = parcelRequire("d05Rs");

var $iSvIT = parcelRequire("iSvIT");
function $67df864366923ec5$export$f680877a34711e37() {
    // React uses `:` or `«»` in selectors which breaks `document.querySelector(…)`.
    // Replace with `_` to match future React 19 functionality.
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).useId().replace(/[:«»]/g, "_");
}
var $67df864366923ec5$export$6be90bcb437e928f = /*#__PURE__*/ (0, $iSvIT.forwardRef)(function(_ref, ref) {
    var children = _ref.children, _ref$postfix = _ref.postfix, postfix = _ref$postfix === void 0 ? "" : _ref$postfix, _ref$prefix = _ref.prefix, prefix = _ref$prefix === void 0 ? "" : _ref$prefix;
    var id = "".concat(prefix).concat($67df864366923ec5$export$f680877a34711e37()).concat(postfix);
    (0, $iSvIT.useEffect)(function() {
        if (!ref) return;
        switch((0, $d05Rs.default)(ref)){
            case "function":
                ref(id);
                break;
            case "object":
                ref.current = id;
                break;
            default:
                throw new Error('Unreachable case for unsupported type of ref "'.concat((0, $d05Rs.default)(ref), '"'));
        }
    }, [
        id,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, typeof children === "function" ? children({
        id: id
    }) : children);
});
function $67df864366923ec5$export$6ee17796e3d70de2() {
    var uid = $67df864366923ec5$export$f680877a34711e37();
    return function(id) {
        return "".concat(uid, "-").concat(id.toString());
    };
}



var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $e1a6147a97197d99$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return '<svg height="32" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <linearGradient id="'.concat(id, '-a" x1="12.595" x2="12.595" y1="40" y2="30" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient id="').concat(id, '-b" x1="28.595" x2="28.595" y1="40" y2="27" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient xlink:href="#').concat(id, '-b" id="').concat(id, '-c" x1="20.595" x2="20.595" y2="22"/>\n    <linearGradient xlink:href="#').concat(id, '-b" id="').concat(id, '-d" x1="36.595" x2="36.595" y2="20"/>\n  </defs>\n  <path d="M10.595 30h4v10h-4z" fill="url(#').concat(id, '-a)"/>\n  <path d="M26.595 27h4v13h-4z" fill="url(#').concat(id, '-b)"/>\n  <path d="M18.595 22h4v18h-4z" fill="url(#').concat(id, '-c)"/>\n  <path d="M34.595 20h4v20h-4z" fill="url(#').concat(id, '-d)"/>\n  <path fill="').concat(colors.iconColor, '" d="m9.009 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z" />\n</svg>');
};
var $e1a6147a97197d99$export$c42ad8a0b925c762 = function AtlassianAnalyticsIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Analytics" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, testId = _ref2.testId;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $67df864366923ec5$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $e1a6147a97197d99$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode, id),
        iconColor: iconColor,
        textColor: textColor,
        size: size,
        testId: testId
    });
};


var $iSvIT = parcelRequire("iSvIT");


var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $33c6e8567fbfe1a4$var$svg = function svg(_ref, colorMode, id) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconColor,
        iconGradientStop: iconColor,
        textColor: textColor,
        iconColor: iconColor,
        // We treat the word "Atlassian" differently to normal app logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearanceOldLogos)(appearance, colorMode);
    return '\n  <svg height="32" viewBox="0 0 477 48" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <linearGradient id="'.concat(id, '-a" x1="447.285" x2="447.285" y1="40" y2="30" gradientUnits="userSpaceOnUse">\n      <stop offset="0" stop-color="').concat(colors.iconGradientStart, '"/>\n      <stop offset="1" stop-color="').concat(colors.iconGradientStop, '"/>\n    </linearGradient>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-b" x1="463.285" x2="463.285" y2="27"/>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-c" x1="455.285" x2="455.285" y2="22"/>\n    <linearGradient xlink:href="#').concat(id, '-a" id="').concat(id, '-d" x1="471.285" x2="471.285" y2="20"/>\n  </defs>\n  <g fill="').concat(colors.atlassianLogoTextColor, '">\n    <path d="M106.72 18.359c0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835m0 0c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445M209.1 10.346v28.455h6.063V17.103l2.556 5.76 8.575 15.938h7.623V10.346h-6.064V28.71l-2.295-5.327-6.886-13.037H209.1zM163.909 10.346h6.626v28.455h-6.626zM156.263 30.399c0-4.981-2.642-7.319-10.091-8.922-4.114-.91-5.111-1.819-5.111-3.118 0-1.646 1.473-2.339 4.201-2.339 3.292 0 6.54.996 9.615 2.382v-6.54c-2.166-1.083-5.5-1.949-9.398-1.949-7.363 0-11.174 3.205-11.174 8.445 0 4.201 1.949 7.536 9.572 9.008 4.548.953 5.5 1.689 5.5 3.205 0 1.473-.953 2.425-4.158 2.425-3.725 0-8.142-1.256-11.044-2.988v6.843c2.295 1.126 5.327 2.382 10.957 2.382 7.969 0 11.131-3.551 11.131-8.835M55.243 10.346v28.455h13.62l2.145-6.15h-9.095V10.346h-6.67zM28.334 10.346v6.15h7.363v22.305h6.67V16.496h7.882v-6.15H28.334zM18.663 10.346h-8.74L0 38.801h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM92.344 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524ZM194.414 10.346h-8.74l-9.922 28.455h7.579l1.407-4.792a18.852 18.852 0 0 0 10.612 0l1.407 4.792h7.579l-9.922-28.455Zm-4.37 18.533c-1.267 0-2.49-.185-3.647-.524l3.647-12.422 3.647 12.422c-1.157.339-2.38.524-3.647.524Z"/>\n  </g>\n  <g fill="').concat(colors.textColor, '">\n    <path d="m254.776 31.987-2.53 6.809H247.6l11.916-30.225h5.244l11.916 30.225h-4.646l-2.53-6.855c-2.714.552-5.061.828-7.499.828-2.3 0-4.646-.276-7.223-.782Zm13.479-3.496-6.119-16.562-6.119 16.608c2.254.368 4.141.552 5.98.552 1.933 0 3.911-.23 6.257-.598ZM298.984 38.796h-3.957V24.902c0-4.141-1.656-5.981-5.428-5.981-3.681 0-6.211 2.438-6.211 7.085v12.79h-3.957V15.794h3.957v3.772c1.472-2.715 4.187-4.232 7.269-4.232 5.291 0 8.327 3.634 8.327 9.983v13.479ZM320.097 34.656c-1.472 3.036-4.232 4.6-7.775 4.6-6.119 0-9.201-5.199-9.201-11.961 0-6.486 3.22-11.961 9.661-11.961 3.358 0 5.935 1.518 7.314 4.508v-4.048h3.957v23.002h-3.957v-4.14Zm-6.717.92c3.542 0 6.717-2.254 6.717-7.361v-1.84c0-5.106-2.898-7.361-6.256-7.361-4.463 0-6.763 2.944-6.763 8.281 0 5.521 2.208 8.281 6.303 8.281ZM336.196 38.935c-3.772 0-6.165-1.794-6.165-6.027V6.179h3.957v26.269c0 2.07 1.38 2.806 3.083 2.806.414 0 .69 0 1.15-.046v3.542c-.322.092-1.012.184-2.024.184ZM347.328 37.324l-8.327-21.53h4.232l7.361 19.69 7.361-19.69h4.232l-8.695 22.267c-2.576 6.579-4.048 9.983-9.891 9.983-1.979 0-3.083-.184-4.232-.644v-3.404c1.334.414 2.852.552 4.002.552 3.22 0 4.646-2.208 6.533-7.223h-2.576ZM374.698 35.07c.92 0 1.794-.185 2.484-.322v3.818c-.69.184-1.472.368-2.668.368-4.923 0-7.315-2.898-7.315-7.177V19.473h-3.727v-3.68h3.727v-4.877h3.864v4.877h6.119v3.68h-6.119v12.191c0 2.024 1.196 3.405 3.635 3.405ZM384.265 6.961c1.61 0 2.76 1.012 2.76 2.76s-1.15 2.76-2.76 2.76-2.76-1.012-2.76-2.76 1.15-2.76 2.76-2.76Zm-2.024 8.833h3.957v23.002h-3.957V15.794ZM408.416 38.198c-1.38.736-3.496 1.058-5.612 1.058-8.189 0-12.007-4.968-12.007-12.007 0-6.947 3.818-11.915 12.007-11.915 2.07 0 3.68.276 5.475 1.104v3.681c-1.472-.69-3.037-1.104-5.199-1.104-5.98 0-8.419 3.772-8.419 8.235s2.484 8.235 8.511 8.235c2.346 0 3.818-.322 5.244-.828v3.542ZM420.144 39.256c-3.451 0-6.257-.782-8.005-1.702v-4.187c1.978 1.15 5.291 2.254 8.188 2.254 3.037 0 4.601-1.242 4.601-3.036 0-1.749-1.334-2.761-5.705-3.818-5.106-1.242-7.269-3.221-7.269-6.993 0-4.002 3.082-6.44 8.327-6.44 2.99 0 5.705.736 7.407 1.656v4.094c-2.76-1.38-5.014-2.117-7.453-2.117-2.898 0-4.462 1.013-4.462 2.807 0 1.61 1.104 2.622 5.336 3.635 5.106 1.242 7.683 3.128 7.683 7.13 0 3.819-2.484 6.717-8.649 6.717Z"/>\n  </g>\n  <path fill="url(#').concat(id, '-a)" d="M445.285 30h4v10h-4z"/>\n  <path fill="url(#').concat(id, '-b)" d="M461.285 27h4v13h-4z"/>\n  <path fill="url(#').concat(id, '-c)" d="M453.285 22h4v18h-4z"/>\n  <path fill="url(#').concat(id, '-d)" d="M469.285 20h4v20h-4z"/>\n  <path fill="').concat(colors.iconColor, '" d="m443.699 25.414-2.828-2.828 10.127-10.128a5 5 0 0 1 6.605-.411l4.471 3.477a1.5 1.5 0 0 0 1.982-.123l9.815-9.815 2.828 2.828-10.127 10.128a5 5 0 0 1-6.605.411l-4.471-3.477a1.5 1.5 0 0 0-1.982.123l-9.815 9.815Z"/>\n</svg>');
};
var $33c6e8567fbfe1a4$export$e6470bfc39010cc4 = function AtlassianAnalyticsLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian Analytics" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    var id = (0, $67df864366923ec5$export$f680877a34711e37)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        size: size,
        iconColor: iconColor,
        svg: $33c6e8567fbfe1a4$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode, id),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $d8fe4c2086b7cbb7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>\n    </svg>');
};
var $d8fe4c2086b7cbb7$export$5fc1066e677788d4 = function BitbucketIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $d8fe4c2086b7cbb7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $b250f467e56f24d0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
};
var $b250f467e56f24d0$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $b250f467e56f24d0$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $cd1c2e1626709598$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>\n      </svg>\n    ');
};
var $cd1c2e1626709598$export$f7857fe64d7161d9 = function CompassIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $cd1c2e1626709598$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $220b1201b843fc06$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
};
var $220b1201b843fc06$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $220b1201b843fc06$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $7fa4c2f178061b7d$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>\n    </svg>');
};
var $7fa4c2f178061b7d$export$68f3db7f6af48bcb = function ConfluenceIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $7fa4c2f178061b7d$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $006162242d6d4465$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>\n      <path fill="').concat(colors.textColor, '" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n    </svg>\n    ');
};
var $006162242d6d4465$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $006162242d6d4465$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $9dada665abfecf8c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 48 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n		<path fill="'.concat(colors.iconColor, '" d="M45.4277 24.5018C41.4108 20.4849 34.8821 20.5276 30.908 24.5018L27.5636 27.8462C25.717 29.6927 22.7177 29.6927 20.8712 27.8462L18.0925 25.0675L10.8309 32.3291L13.6096 35.1078C19.4658 40.9641 28.9654 40.9641 34.8216 35.1078L45.4277 24.5018ZM3 23.5018C7.01684 27.5186 13.4637 27.5578 17.4805 23.5409L20.8676 20.1538C22.7142 18.3073 25.7135 18.3073 27.56 20.1538L30.3387 22.9325L37.6003 15.6709L34.8216 12.8922C28.9654 7.03593 19.4658 7.03593 13.6096 12.8922L3.00356 23.4982L3 23.5018Z"/>\n		</svg>\n		');
};
var $9dada665abfecf8c$export$1e02e7298035a77c = function FocusIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Focus" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $9dada665abfecf8c$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $678c8e524988ae5e$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 168 48" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n		<path fill="'.concat(colors.iconColor, '" d="M42.4277 24.5018C38.4108 20.4849 31.8821 20.5276 27.908 24.5018L24.5636 27.8462C22.717 29.6927 19.7177 29.6927 17.8712 27.8462L15.0925 25.0675L7.83088 32.3291L10.6096 35.1078C16.4658 40.9641 25.9654 40.9641 31.8216 35.1078L42.4277 24.5018ZM0 23.5018C4.01684 27.5186 10.4637 27.5578 14.4805 23.5409L17.8676 20.1538C19.7142 18.3073 22.7135 18.3073 24.56 20.1538L27.3387 22.9325L34.6003 15.6709L31.8216 12.8922C25.9654 7.03593 16.4658 7.03593 10.6096 12.8922L0.00355592 23.4982L0 23.5018Z"/>\n		<path fill="').concat(colors.textColor, '" d="M167.405 31.746C167.405 35.564 164.921 38.462 158.757 38.462C155.307 38.462 152.501 37.68 150.753 36.76V32.574C152.731 33.724 156.043 34.828 158.941 34.828C161.977 34.828 163.541 33.586 163.541 31.792C163.541 30.044 162.207 29.032 157.837 27.974C152.731 26.732 150.569 24.754 150.569 20.982C150.569 16.98 153.651 14.542 158.895 14.542C161.885 14.542 164.599 15.278 166.301 16.198V20.292C163.541 18.912 161.287 18.176 158.849 18.176C155.951 18.176 154.387 19.188 154.387 20.982C154.387 22.592 155.491 23.604 159.723 24.616C164.829 25.858 167.405 27.744 167.405 31.746Z"/>\n		<path fill="').concat(colors.textColor, '" d="M126.009 28.48V15.002H129.965V28.894C129.965 33.034 131.621 34.874 135.393 34.874C139.073 34.874 141.603 32.436 141.603 27.79V15.002H145.559V38.002H141.603V34.23C140.131 36.944 137.417 38.462 134.335 38.462C129.045 38.462 126.009 34.828 126.009 28.48Z"/>\n		<path fill="').concat(colors.textColor, '" d="M121.953 33.862V37.404C120.573 38.14 118.457 38.462 116.341 38.462C108.153 38.462 104.335 33.494 104.335 26.456C104.335 19.51 108.153 14.542 116.341 14.542C118.411 14.542 120.021 14.818 121.815 15.646V19.326C120.343 18.636 118.779 18.222 116.617 18.222C110.637 18.222 108.199 21.994 108.199 26.456C108.199 30.918 110.683 34.69 116.709 34.69C119.055 34.69 120.527 34.368 121.953 33.862Z"/>\n		<path fill="').concat(colors.textColor, '" d="M90.2616 38.462C83.3616 38.462 79.3136 33.356 79.3136 26.456C79.3136 19.556 83.3616 14.542 90.2616 14.542C97.1156 14.542 101.118 19.556 101.118 26.456C101.118 33.356 97.1156 38.462 90.2616 38.462ZM90.2616 18.222C85.3396 18.222 83.1776 22.086 83.1776 26.456C83.1776 30.826 85.3396 34.782 90.2616 34.782C95.1376 34.782 97.2536 30.826 97.2536 26.456C97.2536 22.086 95.1376 18.222 90.2616 18.222Z"/>\n		<path fill="').concat(colors.textColor, '" d="M75.298 26.732H61.59V38.002H57.45V7.78003H76.862V11.736H61.59V22.776H75.298V26.732Z"/>\n		</svg>\n		');
};
var $678c8e524988ae5e$export$33908560ea1b226d = function FocusLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Focus" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $678c8e524988ae5e$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $2f2dcfcec68d0b50$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n      <path\n        d="M5.584 14.4h20.83c.599 0 .918-.32.918-.918V6.459c0-.599-.319-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v3.551h-1.995V6.46c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.917.32-.917.918v7.023c0 .599.319.918.917.918zm.36 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.199-.799.758-.799h20.191c.559 0 .798.24.798.719q-.12 2.214-.838 4.07c-.24.638-.598.918-1.277.918H7.221c-.679 0-1.038-.28-1.277-.918m18.475 3.312c-1.915 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.478-.638-.239-1.038.24-1.038h16.44c.48 0 .719.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n    </svg>');
};
var $2f2dcfcec68d0b50$export$3f95fcfdc25a741d = function GuardIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $2f2dcfcec68d0b50$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $e3d591a5f17159f7$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 32" focusable="false" aria-hidden="true">\n      <path\n        d="M.918 13.733h20.83c.598 0 .918-.32.918-.918V5.792c0-.599-.32-.918-.918-.918h-4.39c-.598 0-.918.32-.918.918v3.551h-1.995V5.792c0-.599-.319-.918-.918-.918H9.139c-.599 0-.918.32-.918.918v3.551H6.225V5.792c0-.599-.32-.918-.918-.918H.917c-.598 0-.917.32-.917.918v7.023c0 .599.32.918.918.918m.359 6.145a13.9 13.9 0 0 1-.798-3.99c-.04-.52.2-.799.758-.799h20.191c.56 0 .799.24.799.719q-.12 2.214-.838 4.07c-.24.638-.599.918-1.277.918H2.554c-.679 0-1.038-.28-1.277-.918m18.476 3.312c-1.916 2.354-5.068 3.87-8.42 3.87s-6.584-1.516-8.46-3.87c-.479-.638-.24-1.038.24-1.038h16.44c.479 0 .718.4.2 1.038"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M102.398 17.874c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.502 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52zm8.679 7.667v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.466-6.133-7.974 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005V3.798h2.637v21.743zm-17.793-9.047v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925m-17.869 1.381c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907v-1.227c0-3.404-1.932-4.906-4.17-4.906-2.976 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.637v15.333zM56.68 19.193v-8.985h2.637v9.261c0 2.76 1.105 3.987 3.62 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637v15.333h-2.638v-2.514c-.981 1.809-2.79 2.821-4.845 2.821-3.527 0-5.55-2.423-5.55-6.655zm-3.973 5.213c-1.595.951-4.539 1.442-6.808 1.442-6.931 0-10.672-4.232-10.672-10.335 0-6.563 4.262-10.457 11.438-10.457 1.595 0 3.466.184 5.244.797v2.76c-1.533-.613-3.342-.89-5.213-.89-5.98 0-8.71 2.975-8.71 7.729 0 4.661 2.76 7.758 8.557 7.758.95 0 2.269-.092 3.404-.429v-5.612h-5.152v-2.637h7.912z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $e3d591a5f17159f7$export$a4a891d202775deb = function GuardLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Guard" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $e3d591a5f17159f7$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $78916720da285d68$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.034 21.99h-2.22c-3.346 0-5.747-2.05-5.747-5.052h11.932c.619 0 1.019.44 1.019 1.062v12.007c-2.983 0-4.984-2.416-4.984-5.784zm5.893-5.967h-2.219c-3.347 0-5.748-2.013-5.748-5.015h11.933c.618 0 1.055.402 1.055 1.025V24.04c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.219c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.018.439 1.018 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n    </svg>');
};
var $78916720da285d68$export$c4b5b1f965d8b3eb = function JiraIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $78916720da285d68$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $9b7d364da4247059$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n      <path fill="').concat(colors.textColor, '" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>\n    </svg>');
};
var $9b7d364da4247059$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $9b7d364da4247059$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $940e8bed7454eb9f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg viewBox="0 0 32 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">\n    <path\n      fill="'.concat(colors.iconColor, '"\n      d="M25.52 25.727c0-3.604-2.949-6.517-6.517-6.517h-6.007v-5.497H6.48v10.813c0 .837.364 1.201 1.201 1.201zM6.48 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z"\n    />\n  </svg>');
};
var $940e8bed7454eb9f$export$407687b2dd89cc68 = function JiraAlignIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Align" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $940e8bed7454eb9f$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $e7636a34371a373c$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="'.concat(colors.iconColor, '"/>\n      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="').concat(colors.textColor, '"/>\n    </svg>\n  ');
};
var $e7636a34371a373c$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Align" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $e7636a34371a373c$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $d8375d3079d900a0$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M17.655 5.884a15.3 15.3 0 0 0 8.75 0c.257-.056.428.114.37.37-.826 2.985-.826 5.742 0 8.727.058.228-.113.427-.37.342a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.342.77-2.985.77-5.742 0-8.727-.086-.256.114-.426.342-.37m1.169 10.576v.483c0 2.246-1.568 3.894-3.506 3.894a3.474 3.474 0 0 1-3.477-3.496c0-1.933 1.567-3.468 3.762-3.468h.57V7.078c-.285-.028-.57-.028-.855-.028C9.618 7.05 5 11.655 5 17.37c0 5.713 4.617 10.29 10.318 10.29s10.346-4.605 10.346-10.29v-.91z"/>\n    </svg>');
};
var $d8375d3079d900a0$export$21bfbeb62fdcce8d = function JiraProductDiscoveryIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $d8375d3079d900a0$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $f333dea618313fea$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 318 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M12.655 5.218a15.3 15.3 0 0 0 8.75 0c.257-.057.428.114.37.37-.826 2.984-.826 5.742 0 8.727.058.227-.113.426-.37.341a16.33 16.33 0 0 0-8.75 0c-.228.085-.428-.114-.342-.341.77-2.985.77-5.743 0-8.727-.086-.256.114-.427.342-.37m1.169 10.575v.483c0 2.246-1.568 3.895-3.506 3.895a3.474 3.474 0 0 1-3.478-3.497c0-1.933 1.568-3.468 3.763-3.468h.57V6.412c-.285-.028-.57-.028-.855-.028C4.618 6.384 0 10.989 0 16.703s4.617 10.29 10.318 10.29 10.346-4.605 10.346-10.29v-.91z" />\n      <path fill="').concat(colors.textColor, '" d="M308.551 24.559h-1.718l-5.55-14.352h2.821l4.907 13.125 4.906-13.125h2.822l-5.796 14.843c-1.718 4.385-2.699 6.654-6.594 6.654-1.318 0-2.054-.122-2.821-.429v-2.27c.889.277 1.901.369 2.668.369 2.147 0 3.097-1.472 4.355-4.815m-13.247-8.065v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.422-3.097 5.428-2.913v2.576c-3.374-.338-5.428.674-5.428 3.925m-12.464-4.202c-2.79 0-4.201 1.81-4.477 4.478h8.556c-.153-2.852-1.441-4.478-4.079-4.478m5.888 12.635c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.943 7.237-7.943 4.723 0 6.624 3.282 6.624 7.943v1.196h-11.193c.368 2.607 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-19.717.613h-3.527l-5.949-15.333h2.76l4.968 13.095 4.937-13.095h2.76zm-17.462.307c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.281 0-4.723 2.576-4.723 5.49 0 2.912 1.442 5.55 4.723 5.55 3.251 0 4.661-2.638 4.661-5.55 0-2.914-1.41-5.49-4.661-5.49M242.16 22.78v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-13.872-1.41c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.135v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.889-1.84-3.802-2.545-3.404-.828-4.846-2.147-4.846-4.661 0-2.668 2.055-4.294 5.551-4.294 1.993 0 3.803.491 4.937 1.104v2.73c-1.84-.92-3.342-1.41-4.968-1.41-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.422 3.404.828 5.121 2.086 5.121 4.754M210.599 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.491 19.38V10.208h2.637v15.334zM198.344 8.03h-4.539v14.873h4.692c4.6 0 6.9-2.422 6.9-7.298 0-4.907-2.177-7.575-7.053-7.575m-7.299 17.51V5.394h7.422c6.532 0 9.69 4.078 9.69 10.12 0 6.102-3.189 10.028-9.69 10.028zm-13.411-4.753c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-6.66 1.993v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.943 8.004-7.943 1.38 0 2.454.184 3.65.736v2.454c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.514-5.612 5.49 0 2.974 1.656 5.488 5.674 5.488 1.564 0 2.545-.214 3.496-.552m-27.843-3.588v-8.985h2.637v9.261c0 2.76 1.104 3.987 3.619 3.987 2.453 0 4.14-1.625 4.14-4.723v-8.525h2.637V25.54h-2.637v-2.514c-.982 1.809-2.791 2.821-4.846 2.821-3.526 0-5.55-2.423-5.55-6.655m-14.987-1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.974 0-4.508 1.962-4.508 5.52m8.679 7.667v-2.76c-.981 2.023-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005V3.798h2.637V25.54zm-20.698.306c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.943 7.299-7.943c4.569 0 7.237 3.343 7.237 7.943s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49 0 2.912 1.441 5.55 4.723 5.55 3.25 0 4.661-2.638 4.661-5.55 0-2.914-1.411-5.49-4.661-5.49m-13.776 4.14v9.047h-2.576V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-5.002-4.385c0 4.385-2.454 6.838-7.483 6.838h-4.017v6.594h-2.76V5.393h6.777c5.03 0 7.483 2.576 7.483 6.716m-7.79 4.2c3.558.124 4.938-1.563 4.938-4.14 0-2.452-1.38-4.14-4.938-4.14h-3.71v8.28zM61.69 17.874c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.931-4.906-4.17-4.906-2.975 0-4.508 1.962-4.508 5.52m8.679 7.666v-2.76c-.982 2.024-2.822 3.067-5.183 3.067-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.974 6.44-7.974 2.24 0 3.957 1.012 4.877 3.006v-2.699h2.637V25.54zm-17.793-9.046v9.047H50V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.89 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.805 8 44.73 8s-1.84-.675-1.84-1.84m.491 19.38V10.208h2.638v15.334zm-6.428-5.949V5.393h2.76v14.014c0 3.71-1.625 6.256-5.428 6.256-1.441 0-2.545-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.331 0 3.128-1.41 3.128-3.404" />\n    </svg>');
};
var $f333dea618313fea$export$c49a2b642fe9eef4 = function JiraProductDiscoveryLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Product Discovery" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $f333dea618313fea$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $da718b9f58209fc9$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="M18.79 13.257h7.325c1.1 0 1.476 1.046.805 1.878L15.464 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H5.806c-1.1 0-1.476-1.046-.805-1.878L16.457 2.874c3.702 2.951 3.3 7.566.617 11z"/>\n    </svg>');
};
var $da718b9f58209fc9$export$3c6158790f5e01c4 = function JiraServiceManagementIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $da718b9f58209fc9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $2c94264a152ddf97$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 362 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' d="M14.124 13.257h7.325c1.1 0 1.475 1.046.804 1.878L10.798 29.274c-3.702-2.951-3.353-7.62-.644-11.027zm-5.66 5.634H1.138c-1.1 0-1.476-1.046-.805-1.878L11.79 2.874c3.703 2.951 3.3 7.566.617 11z" />\n      <path fill=').concat(colors.textColor, ' d="M357.074 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-7.327-4.231v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-26.152-7.912v8.525h-2.637V16.28c0-2.76-1.104-3.987-3.619-3.987-2.453 0-4.14 1.625-4.14 4.723v8.525h-2.637V10.208h2.637v2.514c.981-1.81 2.79-2.821 4.845-2.821 2.607 0 4.385 1.319 5.152 3.741.859-2.361 2.913-3.741 5.459-3.741 3.434 0 5.336 2.33 5.336 6.655v8.985h-2.638v-8.525c0-3.16-1.104-4.723-3.618-4.723-2.454 0-4.14 1.625-4.14 4.723m-22.921-4.723c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.577-7.943 7.238-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638V25.54zm-14.073-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-28.327 1.318c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-31.445-11.009-2.76-7.482V25.54h-2.76V5.393h4.784l4.569 11.56 1.871 5.552 1.87-5.551 4.6-11.561h4.447V25.54h-2.76V7.263l-2.361 7.268-4.447 11.01h-2.668zm-21.511-2.238c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zm-15.094-2.148v2.362c-.92.49-2.33.705-3.741.705-5.459 0-8.004-3.312-8.004-8.004 0-4.63 2.545-7.942 8.004-7.942 1.38 0 2.453.184 3.649.736v2.453c-.981-.46-2.024-.736-3.465-.736-3.987 0-5.612 2.515-5.612 5.49s1.656 5.489 5.673 5.489c1.564 0 2.546-.215 3.496-.552M140.124 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S143.037 8 141.964 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-8.233 0h-3.527l-5.949-15.332h2.76l4.968 13.094 4.937-13.094h2.76zm-15.455-9.046v9.047h-2.576V10.207h2.576v2.699c.889-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925m-12.463-4.201c-2.791 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.441-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.055 4.293 5.673 4.293 1.779 0 3.282-.337 4.662-.828zM95.024 19.99c0 3.496-2.085 5.857-7.084 5.857-3.894 0-5.704-.766-7.268-1.564v-2.821c1.87.981 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975s-1.104-2.73-4.937-3.65c-4.539-1.103-6.563-2.667-6.563-5.98 0-3.127 2.392-5.458 7.084-5.458 2.914 0 4.784.705 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.845 3.373 4.263 1.073 6.655 2.453 6.655 6.072m-34.001-2.116c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925M42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" />\n    </svg>');
};
var $2c94264a152ddf97$export$dabef2be6cd28c20 = function JiraServiceManagementLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Service Management" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $2c94264a152ddf97$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $1a41f2d5d84a6be8$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsForLoom)(appearance, colorMode);
    return '<svg\n    fill="none"\n    height="32"\n    viewBox="0 0 32 32"\n    xmlns="http://www.w3.org/2000/svg"\n    focusable="false"\n    aria-hidden="true"\n  >\n    <path\n      d="M27.333 15.508h-6.628l5.74-3.315-1.26-2.184-5.74 3.314 3.313-5.74-2.184-1.26-3.313 5.74V5.434h-2.522v6.628l-3.314-5.74-2.184 1.26 3.314 5.74-5.74-3.314-1.26 2.184 5.74 3.314H4.667v2.521h6.627l-5.74 3.314 1.261 2.184 5.74-3.313-3.314 5.74 2.184 1.26 3.314-5.74V28.1h2.521v-6.627l3.313 5.74 2.184-1.261-3.314-5.74 5.74 3.313 1.261-2.184-5.74-3.313h6.628zM16 20.198a3.442 3.442 0 1 1 0-6.885 3.442 3.442 0 0 1 0 6.884"\n      fill="'.concat(colors.iconColor, '"\n    />\n  </svg>');
};
var $1a41f2d5d84a6be8$export$8d789f76fde3e05 = function LoomIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $1a41f2d5d84a6be8$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $a8f42472e75e7eb1$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsForLoom)(appearance, colorMode);
    return '<svg\n      fill="none"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      viewBox="0 0 98 32"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <path\n        d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"\n        fill="'.concat(colors.iconColor, '"\n      />\n      <path\n        d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $a8f42472e75e7eb1$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $a8f42472e75e7eb1$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $hFZoE = parcelRequire("hFZoE");

var $3181b4741f4c7d1c$export$1bf47cdade1a9fcb = function LoomAttributionIcon(_ref) {
    var appearance = _ref.appearance, _ref$label = _ref.label, label = _ref$label === void 0 ? "Loom Attribution" : _ref$label, _ref$size = _ref.size, size = _ref$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref$size, testId = _ref.testId, _ref$iconColor = _ref.iconColor, iconColor = _ref$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref$iconColor, _ref$textColor = _ref.textColor, textColor = _ref$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $1a41f2d5d84a6be8$export$8d789f76fde3e05), {
        appearance: appearance,
        label: label,
        size: size,
        testId: testId,
        iconColor: iconColor,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $98c193d8483170cd$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsForLoom)(appearance, colorMode);
    return '<svg\n		fill="none"\n		height="32"\n		xmlns="http://www.w3.org/2000/svg"\n		focusable="false"\n		aria-hidden="true"\n		viewBox="0 0 88 32"\n	>\n		<path\n			d="M29.488 12.765h-8.983l7.78-4.344-1.544-2.585-7.78 4.344 4.492-7.523-2.674-1.493-4.491 7.522V0H13.2v8.687L8.71 1.164 6.035 2.657l4.49 7.522-7.778-4.343L1.204 8.42l7.779 4.344H0v2.986h8.982l-7.778 4.343 1.543 2.585 7.78-4.342-4.492 7.522 2.674 1.493L13.2 19.83v8.687h3.087v-8.873l4.574 7.663 2.507-1.4-4.575-7.663 7.946 4.437 1.544-2.586-7.779-4.343h8.982v-2.986h.001Zm-14.744 5.552c-2.318 0-4.197-1.817-4.197-4.059s1.88-4.059 4.197-4.059 4.198 1.817 4.198 4.06c0 2.24-1.88 4.058-4.198 4.058"\n			fill="'.concat(colors.iconColor, '"\n		/>\n		<path\n			d="M38.379 26.847V10.094h3.18v16.753zm30.503-11.79h3.036v1.438c.646-1.15 2.153-1.773 3.444-1.773 1.602 0 2.893.695 3.49 1.964.932-1.438 2.177-1.964 3.731-1.964 2.175 0 4.256 1.318 4.256 4.48v7.642h-3.084V19.85c0-1.27-.623-2.228-2.081-2.228-1.363 0-2.177 1.054-2.177 2.324v6.9h-3.155V19.85c0-1.27-.646-2.228-2.081-2.228-1.387 0-2.2 1.03-2.2 2.324v6.9h-3.18V15.057Zm-20.134 12.13c-3.582 0-6.176-2.66-6.176-6.234 0-3.517 2.585-6.242 6.176-6.242 3.609 0 6.177 2.75 6.177 6.242 0 3.547-2.596 6.234-6.177 6.234m0-9.59a3.357 3.357 0 0 0 0 6.713 3.357 3.357 0 0 0 0-6.713m12.966 9.59c-3.583 0-6.177-2.66-6.177-6.234 0-3.517 2.586-6.242 6.177-6.242 3.608 0 6.176 2.75 6.176 6.242 0 3.547-2.597 6.234-6.176 6.234m0-9.63a3.397 3.397 0 0 0-3.39 3.395 3.397 3.397 0 0 0 3.39 3.395 3.396 3.396 0 0 0 0-6.79M64.933 5.63c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473a4.46 4.46 0 0 1-2.197-.63v1.417c.483.263 1.233.473 2.197.473 1.5.052 2.197-.683 2.197-1.785Zm16.662-4.067v5.988h1.3V3.007l.542 1.23 1.841 3.368h1.626V1.563h-1.3v3.85l-.488-1.123-1.463-2.727zm-8.056 0h-1.465v6.042h1.465zm-23.981 0v6.042h2.863l.432-1.295h-1.945V1.563zm-5.671 0v1.295h1.604v4.747h1.44V2.858h1.715V1.563zm-2.177 0h-1.802l-2.066 6.042h1.59l.317-1.025a4 4 0 0 0 1.113.162q.556 0 1.113-.162l.318 1.025h1.59zm-.9 3.938a3 3 0 0 1-.743-.108l.742-2.643.742 2.643c-.265.054-.477.108-.742.108Zm16.577-3.938H55.53L53.4 7.605h1.638l.328-1.025q.573.162 1.146.162.574 0 1.147-.162l.328 1.025h1.638l-2.24-6.042Zm-.928 3.938c-.273 0-.546-.054-.765-.108l.765-2.643.764 2.643a3.3 3.3 0 0 1-.764.108m21.98-3.938h-1.857l-2.13 6.042h1.638l.328-1.025q.574.162 1.147.162c.573 0 .764-.054 1.146-.162l.328 1.025h1.638zm-.93 3.938c-.272 0-.545-.054-.763-.108l.764-2.643.765 2.643a3.3 3.3 0 0 1-.765.108Zm-6.894.129c0-1.102-.697-1.522-1.983-1.837-.803-.21-1.018-.368-1.018-.63q0-.473.804-.473c.643 0 1.286.21 1.93.473V1.798a4.5 4.5 0 0 0-1.876-.42c-1.447 0-2.25.682-2.25 1.785 0 1.05.696 1.575 1.928 1.838.804.157 1.072.315 1.072.682 0 .263-.215.473-.804.473-.75 0-1.608-.263-2.197-.63v1.417c.482.263 1.233.473 2.197.473 1.447.052 2.197-.683 2.197-1.785Z"\n			fill="').concat(colors.textColor, '"\n		/>\n	</svg>');
};
var $98c193d8483170cd$export$6e87ce8d41eda665 = function LoomAttributionLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom Attribution" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $98c193d8483170cd$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $f81a5890cbdab413$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M17.114 28.127c-.785.578-1.199.537-1.984-.041-3.8-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.992.124c1.652 1.9 3.264 3.76 5.123 5.082 1.86-1.322 3.47-3.181 5.123-5.082q.434-.495.992-.124l4.297 2.686c.372.206.496.66.248.991-2.355 3.223-5.867 6.322-9.668 9.09m-.992-11.858c3.388 0 6.198-2.768 6.198-6.156s-2.81-6.239-6.198-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>\n    </svg>');
};
var $f81a5890cbdab413$export$eeccc49dc7a12d9f = function OpsgenieIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Opsgenie" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $f81a5890cbdab413$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $e335cca6176d9a01$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>\n      <path fill="').concat(colors.textColor, '" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />\n    </svg>');
};
var $e335cca6176d9a01$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Opsgenie" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $e335cca6176d9a01$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $d10fd94ee99a9692$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true">\n    <g fill="'.concat(colors.iconColor, '" fill-rule="evenodd">\n      <path d="M17.06 4.246a2.79 2.79 0 0 0-2.736-.026l-.049.033-.002.001c-.605.35-1.048.91-1.256 1.558-.085.268-.13.552-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566a2.77 2.77 0 0 0 1.392-2.407v-9.487c0-.991-.532-1.912-1.392-2.408z"/>\n      <path d="m6.058 9 6.176-3.566a3.7 3.7 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155l4.604 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.851.47-1.89.461-2.735-.026L6.06 23.301a2.78 2.78 0 0 1-1.392-2.408v-9.486c0-.996.529-1.912 1.391-2.408z"/>\n    </g>\n  </svg>');
};
var $d10fd94ee99a9692$export$e23ae35269442b4f = function RovoIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        svg: $d10fd94ee99a9692$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        label: label,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $c859073eedf38d1f$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 100 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path\n        d="M12.393 4.246a2.79 2.79 0 0 0-2.735-.026.4.4 0 0 1-.05.033l-.001.001c-.606.35-1.048.91-1.257 1.558q-.129.404-.13.842v3.675l4.603 2.656a3.64 3.64 0 0 1 1.824 3.155v9.487a3.6 3.6 0 0 1-.214 1.23l6.175-3.566A2.77 2.77 0 0 0 22 20.884v-9.487c0-.991-.532-1.912-1.392-2.408z"\n        fill="'.concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="m1.391 9 6.176-3.566a3.6 3.6 0 0 0-.214 1.23v9.486c0 1.303.693 2.505 1.823 3.155h.001l4.603 2.657v3.674c0 .29-.045.575-.13.843a2.8 2.8 0 0 1-1.258 1.558.4.4 0 0 0-.05.033c-.85.47-1.89.461-2.734-.026l-8.216-4.743A2.78 2.78 0 0 1 0 20.893v-9.486c0-.996.529-1.912 1.391-2.408z"\n        fill="').concat(colors.iconColor, '"\n        fillRule="evenodd"\n      />\n      <path\n        d="M91.688 25.848c-4.6 0-7.298-3.404-7.298-8.004S87.088 9.9 91.688 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004zm0-13.494c-3.28 0-4.722 2.576-4.722 5.49 0 2.913 1.441 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.41-5.49-4.662-5.49M77.675 25.54H74.15L68.2 10.208h2.76l4.968 13.094 4.938-13.095h2.76zm-17.462.308c-4.6 0-7.299-3.404-7.299-8.004s2.7-7.943 7.3-7.943c4.568 0 7.236 3.342 7.236 7.942s-2.668 8.004-7.237 8.004zm0-13.494c-3.281 0-4.723 2.576-4.723 5.49 0 2.913 1.442 5.55 4.723 5.55 3.25 0 4.661-2.637 4.661-5.55 0-2.914-1.41-5.49-4.66-5.49zM43.177 8.03H39.13v7.36h4.048c3.588 0 4.692-1.38 4.692-3.68 0-2.177-1.134-3.68-4.692-3.68zm7.452 3.619c0 3.036-1.288 5.09-3.956 5.949l4.938 7.943H48.36l-4.447-7.514H39.13v7.514h-2.76V5.393h7.115c4.815 0 7.145 2.392 7.145 6.256z"\n        fill="').concat(colors.textColor, '"\n      />\n    </svg>');
};
var $c859073eedf38d1f$export$a0f6cb8061290bbb = function RovoLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Rovo" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        iconColor: iconColor,
        label: label,
        size: size,
        svg: $c859073eedf38d1f$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $91cd63b93ec6f876$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M16 12.604c-3.033 0-5.981 1.37-8.39 3.489q-.375.373-.748.373c-.208 0-.415-.124-.581-.332l-3.032-3.572c-.166-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706 3.655-3.24 8.1-5.067 12.627-5.067s8.97 1.827 12.626 5.067c.249.249.374.457.374.706 0 .166-.084.374-.25.581l-3.032 3.572c-.166.208-.373.332-.581.332q-.374 0-.748-.374c-2.409-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.365 0-6.106-2.742-6.106-6.064S12.635 13.85 16 13.85s6.106 2.7 6.106 6.064-2.741 6.063-6.105 6.063"/>\n    </svg>');
};
var $91cd63b93ec6f876$export$f3f5aa321d88adf9 = function StatuspageIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Statuspage" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $91cd63b93ec6f876$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $ab3bcc829a6ce4e2$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />\n      <path fill="').concat(colors.textColor, '" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />\n    </svg>');
};
var $ab3bcc829a6ce4e2$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Statuspage" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $ab3bcc829a6ce4e2$var$svg({
            appearance: appearance,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};



var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $1d54b1fbe6fd5f74$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor;
    var colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill='.concat(colors.iconColor, ' clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>\n    </svg>');
};
var $1d54b1fbe6fd5f74$export$4384da9b8b140bf4 = function TrelloIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        svg: $1d54b1fbe6fd5f74$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


var $iSvIT = parcelRequire("iSvIT");

var $dQweN = parcelRequire("dQweN");

var $hFZoE = parcelRequire("hFZoE");

var $eJjXw = parcelRequire("eJjXw");

var $3LDQa = parcelRequire("3LDQa");
var $59479a61b92978f5$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if (appearance) colors = (0, $3LDQa.getColorsFromAppearance)(appearance, colorMode);
    return '<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>\n      <path fill="').concat(colors.textColor, '" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>\n    </svg>');
};
var $59479a61b92978f5$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $hFZoE.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $hFZoE.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $hFZoE.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $dQweN.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eJjXw.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $59479a61b92978f5$var$svg({
            appearance: appearance,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};







var $eDSbX = parcelRequire("eDSbX");


var $5bCc2 = parcelRequire("5bCc2");

var $jUpi8 = parcelRequire("jUpi8");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");
var $86e2799fe85af47f$var$_excluded = [
    "size",
    "shouldUseNewLogoDesign"
], $86e2799fe85af47f$var$_excluded2 = [
    "size",
    "shouldUseNewLogoDesign"
], $86e2799fe85af47f$var$_excluded3 = [
    "shouldUseHexLogo"
], $86e2799fe85af47f$var$_excluded4 = [
    "size"
];
/**
 * Creates a feature flagged component that renders the legacy logo or the new logo
 * based on the platform-logo-rebrand feature flag.
 *
 * @param LegacyComponent - The legacy logo component.
 * @param NewComponent - The new logo component.
 * @returns A feature flagged component that renders the legacy logo or the new logo.
 */ var $86e2799fe85af47f$export$e30d2ddc605f6bb = function createFeatureFlaggedComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref) {
        var size = _ref.size, shouldUseNewLogoDesign = _ref.shouldUseNewLogoDesign, props = (0, $jUpi8.default)(_ref, $86e2799fe85af47f$var$_excluded);
        if ((0, $jxLBU.fg)("platform-logo-rebrand") || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(NewComponent, (0, $5bCc2.default)({
            size: size || "medium"
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LegacyComponent, (0, $5bCc2.default)({
            size: size
        }, props));
    };
};
var $86e2799fe85af47f$export$436fcf6e31fbacea = function createFeatureFlaggedServiceCollectionComponent(LegacyComponent, NewComponent) {
    // Note: textColor and iconColor aren't supported on all new logos
    // These props will be deprecated in the future
    return function(_ref2) {
        var size = _ref2.size, shouldUseNewLogoDesign = _ref2.shouldUseNewLogoDesign, props = (0, $jUpi8.default)(_ref2, $86e2799fe85af47f$var$_excluded2);
        if ((0, $jxLBU.fg)("platform-logo-rebrand-servco") || (0, $jxLBU.fg)("platform-logo-rebrand") || shouldUseNewLogoDesign) // Size defaults need to be set, as the temp library had different defaults
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(NewComponent, (0, $5bCc2.default)({
            size: size || "medium"
        }, props));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(LegacyComponent, (0, $5bCc2.default)({
            size: size
        }, props));
    };
};
var $86e2799fe85af47f$export$2469203854060337 = function createFeatureFlaggedRovoComponent(LegacyComponent, NewComponent, NewHexComponent) {
    var RovoHexWrapped = $86e2799fe85af47f$export$667425256e2e7296(NewHexComponent);
    var RovoServiceCollectionWrapped = $86e2799fe85af47f$export$436fcf6e31fbacea(LegacyComponent, NewComponent);
    return function(_ref3) {
        var shouldUseHexLogo = _ref3.shouldUseHexLogo, props = (0, $jUpi8.default)(_ref3, $86e2799fe85af47f$var$_excluded3);
        // Return hex logo if feature flag enabled. Otherwise revert to old set of components
        if ((0, $jxLBU.fg)("platform-logo-rebrand-rovo-hex") || shouldUseHexLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(RovoHexWrapped, props);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(RovoServiceCollectionWrapped, props);
    };
};
var $86e2799fe85af47f$export$667425256e2e7296 = function tempSizeWrapper(NewComponent) {
    return function(_ref4) {
        var size = _ref4.size, props = (0, $jUpi8.default)(_ref4, $86e2799fe85af47f$var$_excluded4);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(NewComponent, (0, $5bCc2.default)({
            size: size || "medium"
        }, props));
    };
};
var $86e2799fe85af47f$export$3fe521abfbbe6ab3 = function teamEUFlaggedIcon(LegacyComponent, NewComponent) {
    return function(props) {
        var Logo = (0, $jxLBU.fg)("platform-logo-rebrand-team-eu") ? $86e2799fe85af47f$export$667425256e2e7296(NewComponent) : $86e2799fe85af47f$export$667425256e2e7296(LegacyComponent);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(Logo, props);
    };
};
var $86e2799fe85af47f$export$172fd793eb6ecac4 = [
    // Program logos
    {
        name: "atlassian",
        type: "legacy",
        category: "program"
    },
    {
        name: "atlassian-access",
        type: "legacy",
        category: "program"
    },
    {
        name: "atlassian-marketplace",
        type: "legacy",
        category: "program"
    },
    // Home collection
    {
        name: "home",
        type: "new",
        category: "app"
    },
    {
        name: "hub",
        type: "new",
        category: "app"
    },
    // Teamwork collection
    {
        name: "confluence",
        type: "migration",
        category: "app"
    },
    {
        name: "jira",
        type: "migration",
        category: "app"
    },
    {
        name: "loom",
        type: "migration",
        category: "app"
    },
    {
        name: "loom-blurple",
        type: "new",
        category: "app",
        skipExample: true
    },
    {
        name: "loom-attribution",
        type: "migration",
        category: "app"
    },
    {
        name: "rovo",
        type: "rovo-hex",
        category: "app"
    },
    // Strategy collection
    {
        name: "align",
        type: "new",
        category: "app"
    },
    {
        name: "focus",
        type: "migration",
        category: "app"
    },
    {
        name: "talent",
        type: "new",
        category: "app"
    },
    // App collection
    {
        name: "jira-product-discovery",
        type: "migration",
        category: "app"
    },
    // Dev collection
    {
        name: "bitbucket",
        type: "migration",
        category: "app"
    },
    {
        name: "compass",
        type: "migration",
        category: "app"
    },
    {
        name: "dx",
        type: "new",
        category: "app",
        skipLogo: true
    },
    {
        name: "rovo-dev",
        type: "new",
        category: "app"
    },
    {
        name: "rovo-dev-agent",
        type: "new",
        category: "agent"
    },
    // Customer collection
    {
        name: "jira-service-management",
        type: "migration",
        category: "app"
    },
    {
        name: "assets",
        type: "new",
        category: "app"
    },
    {
        name: "customer-service-management",
        type: "new",
        category: "app"
    },
    {
        name: "opsgenie",
        type: "migration",
        category: "app"
    },
    {
        name: "statuspage",
        type: "migration",
        category: "app"
    },
    {
        name: "trello",
        type: "migration",
        category: "app"
    },
    // Platform Collection
    {
        name: "admin",
        type: "new",
        category: "app"
    },
    {
        name: "analytics",
        type: "new",
        category: "app"
    },
    {
        name: "chat",
        type: "new",
        category: "app"
    },
    {
        name: "goals",
        type: "new",
        category: "app"
    },
    {
        name: "guard",
        type: "migration",
        category: "app"
    },
    {
        name: "projects",
        type: "new",
        category: "app"
    },
    {
        name: "search",
        type: "new",
        category: "app"
    },
    {
        name: "studio",
        type: "new",
        category: "app"
    },
    {
        name: "teams",
        type: "new",
        category: "app"
    },
    // Data Center
    {
        name: "jira-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "jira-service-management-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "confluence-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "bitbucket-data-center",
        type: "new",
        category: "app"
    },
    {
        name: "bamboo",
        type: "new",
        category: "app"
    },
    {
        name: "crowd",
        type: "new",
        category: "app"
    },
    // Deprecated
    {
        name: "atlassian-administration",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlassian-admin",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlassian-analytics",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "atlas",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-align",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-software",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    },
    {
        name: "jira-work-management",
        type: "legacy",
        category: "app",
        skipExample: true,
        deprecated: true
    }
];
var $86e2799fe85af47f$export$62e1212796a86b1b = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "program" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $86e2799fe85af47f$export$e0dee4a765830f4d = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "app" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
});
var $86e2799fe85af47f$export$a13ce90e90d7bfc1 = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.category === "agent" && !logo.skipExample;
}).map(function(logo) {
    return logo.name;
}) || [];
var $86e2799fe85af47f$export$516fce44c502c1d3 = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "legacy";
});
var $86e2799fe85af47f$export$b805fae8e798ed39 = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "migration";
});
var $86e2799fe85af47f$export$3f9abd26214cd85f = $86e2799fe85af47f$export$172fd793eb6ecac4.filter(function(logo) {
    return logo.type === "new";
});


/**
 * __Admin icon__
 *
 * The Admin icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $9a880b7c693c8a13$export$ef8e5f836dd989d3 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $17d0ee28619a9bd6$export$ef8e5f836dd989d3));
var $9a880b7c693c8a13$export$ebcd30672e67406 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $5cad28c678a91c04$export$61afcb38c001e19));
var $9a880b7c693c8a13$export$af3460f51ce3602a = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $3e3579dc55277841$export$af3460f51ce3602a));
var $9a880b7c693c8a13$export$c8415b6abe4a8587 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $835eb391f22ea82b$export$f0bac2b7ac3e3504));
var $9a880b7c693c8a13$export$d89497e7f33ca6f5 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $3726f504d8da0940$export$d89497e7f33ca6f5));
var $9a880b7c693c8a13$export$48ca930f3071e3e4 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $38fb917581248aa2$export$81c47abe19675c4c));
var $9a880b7c693c8a13$export$52cd484a7ef4f2b9 = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $22a5b1daaee42b82$export$52cd484a7ef4f2b9), (0, $47173031820dd2d5$export$402a257da320c93c));
var $9a880b7c693c8a13$export$9ca9881809919df8 = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $16d8fa1823d1e1f7$export$a529e78951cd6709), (0, $525f96afbd01af75$export$a3af32a9109d706d));
/**
 * __Customer Service Management icon__
 *
 * The Customer service management icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $9a880b7c693c8a13$export$6da5aa77c402ba0f = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $fdc7c9c4f0085df7$export$6da5aa77c402ba0f));
var $9a880b7c693c8a13$export$abc95e6180bb1d88 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $e6f57f81567b206d$export$f597f0f7fadce0b9));
var $9a880b7c693c8a13$export$9eb74917ea768ed4 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $23467da455b90f41$export$9eb74917ea768ed4));
var $9a880b7c693c8a13$export$d2577aa28451395f = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $176191df78111552$export$c527a545aa426db3));
var $9a880b7c693c8a13$export$92c8767b874048d = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $e138c7f41feb3036$export$92c8767b874048d));
var $9a880b7c693c8a13$export$d5648119d5b68e90 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $f8fb604ca1efff18$export$8b6b7f1b1b2367d3));
var $9a880b7c693c8a13$export$80b8b269d8b5014e = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $7434d832b248b89c$export$80b8b269d8b5014e));
var $9a880b7c693c8a13$export$fc9bd6687b80fe3b = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $50b286f7ea3c94ce$export$7a38180641471460));
var $9a880b7c693c8a13$export$5ed3e1bb3b04fc02 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $9e7dbb8c6527ff40$export$5ed3e1bb3b04fc02));
var $9a880b7c693c8a13$export$aeefab651bcf2338 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $cd623f3c1e68a712$export$e3d1678155aaab99));
var $9a880b7c693c8a13$export$8b784b3227531b3e = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $84e6ea20963e55b1$export$8b784b3227531b3e));
var $9a880b7c693c8a13$export$f0750468d67c6902 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $f32c8716b41db1c5$export$4145bd793c9ed1d0));
var $9a880b7c693c8a13$export$813cff80931d9dbf = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $88611c352521b9a8$export$813cff80931d9dbf));
var $9a880b7c693c8a13$export$409b7a5b7f180eba = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $179c0ef69585846e$export$58747af448450872));
var $9a880b7c693c8a13$export$82eafebb825fc23f = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $f99f93427c4212ee$export$82eafebb825fc23f), (0, $35030180b63422ca$export$3599582ddc9fc5cf));
var $9a880b7c693c8a13$export$e4c5487c9a8ae3b1 = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $eedbe49b69e7d2fc$export$fa08cbfe393f2a68), (0, $e546016f161adc20$export$d669f6cbbb67e061));
var $9a880b7c693c8a13$export$290a0f24614cde9f = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $4a3a85d733d79f75$export$290a0f24614cde9f), (0, $66c7c050b1a81a59$export$8bb9894377e04e04));
var $9a880b7c693c8a13$export$8aceb78c659789b6 = (0, $86e2799fe85af47f$export$3fe521abfbbe6ab3)((0, $07df3271d91e3cf0$export$273fd56580e523ae), (0, $57a5360c22b8212c$export$170353c338ac5f4a));
/**
 * __Talent icon__
 *
 * The Talent icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */ var $9a880b7c693c8a13$export$4b05688514531169 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $a504bbca9fdd4b05$export$4b05688514531169));
var $9a880b7c693c8a13$export$4f6453e012279f89 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $3e9d75e6bacee67b$export$1b3979d995ebbc6e));
var $9a880b7c693c8a13$export$1bcbc9c337da86da = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $52070f2ac60a941b$export$1bcbc9c337da86da));
var $9a880b7c693c8a13$export$9b1a0a0c574cec2a = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $1922a735eb9a473a$export$bfd8d1c4da84ce71));
var $9a880b7c693c8a13$export$e812398311cab9a3 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $26c9fa5005b5b583$export$e812398311cab9a3));
var $9a880b7c693c8a13$export$765f5afcc1a5a7e3 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $0c24c0bceb41e168$export$7c51958462d750e));
var $9a880b7c693c8a13$export$d3ab16bbf4f954ee = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $ab89250c938dbb9d$export$d3ab16bbf4f954ee));
var $9a880b7c693c8a13$export$36044946916e84a0 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $447009ae0399569b$export$cc55e2a4c4b40552));
var $9a880b7c693c8a13$export$53305f1f2855d3be = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $1a73ddda9949ee9a$export$53305f1f2855d3be));
var $9a880b7c693c8a13$export$5e06396bce773a3 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $7059ef99d50ae0cb$export$b3e508cb103e1f93));
var $9a880b7c693c8a13$export$eaf73f391f7103bd = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $044e74068a3f67c6$export$eaf73f391f7103bd));
var $9a880b7c693c8a13$export$6128b385660fd3c6 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $9f9378c26488bca3$export$3c371bdbcdfcdce));
var $9a880b7c693c8a13$export$f8455b5667a3ee0c = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $d093d464013ca0c9$export$f8455b5667a3ee0c));
var $9a880b7c693c8a13$export$eb152ab3801b2ae3 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $7b711b0b6f4773ee$export$3224b07bc93ef23e));
var $9a880b7c693c8a13$export$65fae0eaf343f2ca = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $058e08c5b2032942$export$65fae0eaf343f2ca));
var $9a880b7c693c8a13$export$fffc0d480fb1ebf1 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $62a3e7cf00b45bb8$export$f64bc7a7f04428d0));
var $9a880b7c693c8a13$export$74517ed253186308 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $41b01b373d929f9b$export$74517ed253186308), (0, $17d0ee28619a9bd6$export$ef8e5f836dd989d3));
var $9a880b7c693c8a13$export$833abe6c2ce5ebfd = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $083777c57a844e8b$export$833abe6c2ce5ebfd), (0, $5cad28c678a91c04$export$61afcb38c001e19));
var $9a880b7c693c8a13$export$84109e099492cb5f = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $17c74fe2d74a1d63$export$84109e099492cb5f), (0, $17d0ee28619a9bd6$export$ef8e5f836dd989d3));
var $9a880b7c693c8a13$export$f845d9b9254f0541 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $d13bb10895612b0c$export$f845d9b9254f0541), (0, $5cad28c678a91c04$export$61afcb38c001e19));
var $9a880b7c693c8a13$export$c42ad8a0b925c762 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $e1a6147a97197d99$export$c42ad8a0b925c762), (0, $3e3579dc55277841$export$af3460f51ce3602a));
var $9a880b7c693c8a13$export$e6470bfc39010cc4 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $33c6e8567fbfe1a4$export$e6470bfc39010cc4), (0, $835eb391f22ea82b$export$f0bac2b7ac3e3504));
var $9a880b7c693c8a13$export$5fc1066e677788d4 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $d8fe4c2086b7cbb7$export$5fc1066e677788d4), (0, $b384fa1f703763fb$export$5fc1066e677788d4));
var $9a880b7c693c8a13$export$bd40525f5333524b = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $b250f467e56f24d0$export$bd40525f5333524b), (0, $51cbb651ef5c1063$export$f7ef5e5488e4b430));
var $9a880b7c693c8a13$export$f7857fe64d7161d9 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $cd1c2e1626709598$export$f7857fe64d7161d9), (0, $f80402a5a43af05e$export$f7857fe64d7161d9));
var $9a880b7c693c8a13$export$eb7d748e4f9c9676 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $220b1201b843fc06$export$eb7d748e4f9c9676), (0, $63112a863c5a3044$export$a16f50a81d183ce));
var $9a880b7c693c8a13$export$9951d02c2d848122 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $edee51b0cb228de0$export$9951d02c2d848122));
var $9a880b7c693c8a13$export$68f3db7f6af48bcb = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $7fa4c2f178061b7d$export$68f3db7f6af48bcb), (0, $27bde9ecf5dee03a$export$68f3db7f6af48bcb));
var $9a880b7c693c8a13$export$1b2e4fe6ef471556 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $006162242d6d4465$export$1b2e4fe6ef471556), (0, $7a32f289d875b408$export$a88b0b0da9ef63ce));
var $9a880b7c693c8a13$export$70a0c2f5862937b6 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $d2f6b82b197dcc06$export$70a0c2f5862937b6));
var $9a880b7c693c8a13$export$1b8596b4b0ef673b = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $5d55fef0fce9da25$export$8b5103382c06639c));
var $9a880b7c693c8a13$export$407687b2dd89cc68 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $940e8bed7454eb9f$export$407687b2dd89cc68), (0, $d2f6b82b197dcc06$export$70a0c2f5862937b6));
var $9a880b7c693c8a13$export$ee11e928d3d045fd = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $e7636a34371a373c$export$ee11e928d3d045fd), (0, $5d55fef0fce9da25$export$8b5103382c06639c));
var $9a880b7c693c8a13$export$c4b5b1f965d8b3eb = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $78916720da285d68$export$c4b5b1f965d8b3eb), (0, $b5ac2a4ca3ce583b$export$c4b5b1f965d8b3eb));
var $9a880b7c693c8a13$export$17d3acb0b4379d02 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $9b7d364da4247059$export$17d3acb0b4379d02), (0, $6b850fd51a663f60$export$bf4c5f97b468e8d6));
var $9a880b7c693c8a13$export$21bfbeb62fdcce8d = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $d8375d3079d900a0$export$21bfbeb62fdcce8d), (0, $fe03e1d5910d577e$export$21bfbeb62fdcce8d));
var $9a880b7c693c8a13$export$c49a2b642fe9eef4 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $f333dea618313fea$export$c49a2b642fe9eef4), (0, $2b4bc72c75c9104e$export$602140a6a10b02bf));
var $9a880b7c693c8a13$export$3c6158790f5e01c4 = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $da718b9f58209fc9$export$3c6158790f5e01c4), (0, $adb22ec2008c261b$export$3c6158790f5e01c4));
var $9a880b7c693c8a13$export$dabef2be6cd28c20 = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $2c94264a152ddf97$export$dabef2be6cd28c20), (0, $ae469cb27b32e626$export$de148263c75d2bc1));
var $9a880b7c693c8a13$export$8d789f76fde3e05 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $1a41f2d5d84a6be8$export$8d789f76fde3e05), (0, $c62c997245debbcb$export$8d789f76fde3e05));
var $9a880b7c693c8a13$export$94e206806e36c2ec = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $a8f42472e75e7eb1$export$94e206806e36c2ec), (0, $c497fdad0dc20881$export$78c0b4d8be34c9b2));
var $9a880b7c693c8a13$export$1bf47cdade1a9fcb = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $3181b4741f4c7d1c$export$1bf47cdade1a9fcb), (0, $c62c997245debbcb$export$8d789f76fde3e05));
var $9a880b7c693c8a13$export$6e87ce8d41eda665 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $98c193d8483170cd$export$6e87ce8d41eda665), (0, $ada0de6468c9842c$export$68d7391318cdef11));
var $9a880b7c693c8a13$export$e84e925618e0e5bc = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $32e6c98dbbfc9103$export$71743a944cb62e48));
var $9a880b7c693c8a13$export$1940ba72c868b663 = (0, $86e2799fe85af47f$export$667425256e2e7296)((0, $6938191cb3110d10$export$38c7b37a3e5e8d70));
var $9a880b7c693c8a13$export$eeccc49dc7a12d9f = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $f81a5890cbdab413$export$eeccc49dc7a12d9f), (0, $830a746b3ceda507$export$eeccc49dc7a12d9f));
var $9a880b7c693c8a13$export$a1c6484cdecc2c4b = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $e335cca6176d9a01$export$a1c6484cdecc2c4b), (0, $4455961c779ea9ff$export$a5b9122e89b32ad3));
var $9a880b7c693c8a13$export$f3f5aa321d88adf9 = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $91cd63b93ec6f876$export$f3f5aa321d88adf9), (0, $5383f955374df52f$export$f3f5aa321d88adf9));
var $9a880b7c693c8a13$export$bb4ae5b41b43be04 = (0, $86e2799fe85af47f$export$436fcf6e31fbacea)((0, $ab3bcc829a6ce4e2$export$bb4ae5b41b43be04), (0, $12d1e313e16eae6a$export$2bc88a281410ffa7));
var $9a880b7c693c8a13$export$4384da9b8b140bf4 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $1d54b1fbe6fd5f74$export$4384da9b8b140bf4), (0, $e1208027089940ea$export$4384da9b8b140bf4));
var $9a880b7c693c8a13$export$60e26212f3b61a28 = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $59479a61b92978f5$export$60e26212f3b61a28), (0, $1bc25fd991892865$export$1b13139dfc0336af));
var $9a880b7c693c8a13$export$e23ae35269442b4f = (0, $86e2799fe85af47f$export$2469203854060337)((0, $d10fd94ee99a9692$export$e23ae35269442b4f), (0, $245b5db7efa2068f$export$e23ae35269442b4f), (0, $7aafbe28d5215677$export$9e62346a60cfb459));
var $9a880b7c693c8a13$export$a0f6cb8061290bbb = (0, $86e2799fe85af47f$export$2469203854060337)((0, $c859073eedf38d1f$export$a0f6cb8061290bbb), (0, $b894f8be9b3238bc$export$b0e15f0a1c9f4c55), (0, $274106a9269394f9$export$5e38d02efdb45577));
var $9a880b7c693c8a13$export$3f95fcfdc25a741d = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $2f2dcfcec68d0b50$export$3f95fcfdc25a741d), (0, $0ea480666bad9f69$export$3f95fcfdc25a741d));
var $9a880b7c693c8a13$export$a4a891d202775deb = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $e3d591a5f17159f7$export$a4a891d202775deb), (0, $68fa865e53662a63$export$2b896c4d595a4331));
var $9a880b7c693c8a13$export$1e02e7298035a77c = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $9dada665abfecf8c$export$1e02e7298035a77c), (0, $5317cca9aa6e8da7$export$1e02e7298035a77c));
var $9a880b7c693c8a13$export$33908560ea1b226d = (0, $86e2799fe85af47f$export$e30d2ddc605f6bb)((0, $678c8e524988ae5e$export$33908560ea1b226d), (0, $94caef20e3dcf48d$export$3a6e8b37e069a69d));


const $4f402d6798da28f9$export$57570b1603cf6adb = (useDev)=>{
    // Don't check for `window` if in a node environment
    const isBrowser = Boolean(typeof window !== "undefined" && window.IS_STATIC);
    if (useDev && isBrowser && window.location.hostname.includes("local")) return "dev";
    return "production";
};


/* rovo-dev-agents-logo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");


const $0837d80a58b451e8$var$imageCSS = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover",
        width: "100%"
    } : {};
    return {
        maxWidth: "100%",
        ...aspectRatioCSS
    };
};
function $0837d80a58b451e8$export$54f5ec149fac9f45(src) {
    const extendCachingOfBfldrAssets = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).wacWebExtendedCachingOfBfldrAssetsForJsw);
    const maxAge = 31536000;
    if (extendCachingOfBfldrAssets && // eslint-disable-next-line local/no-brandfolder-images-eslint
    src.includes("wac-cdn-bfldr.atlassian.com")) try {
        const url = new URL(src);
        url.searchParams.append("max_age", maxAge.toString());
        return url.toString();
    } catch (error) {
        return src;
    }
    else return src;
}
const $0837d80a58b451e8$export$3e431a229df88919 = ({ src: src, alt: alt, aspectRatio: aspectRatio, ...rest })=>{
    let modifiedSrc = src;
    // eslint-disable-next-line local/no-brandfolder-images-eslint
    if (src.includes("wac-cdn-bfldr.atlassian.com")) modifiedSrc = $0837d80a58b451e8$export$54f5ec149fac9f45(src);
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        src: modifiedSrc,
        alt: alt,
        style: $0837d80a58b451e8$var$imageCSS(aspectRatio),
        ...rest
    }));
};
const $0837d80a58b451e8$export$ef1c8480e0b65584 = (src, width, height)=>{
    const extendCachingOfBfldrAssets = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).wacWebExtendedCachingOfBfldrAssetsForJsw);
    if (src.includes("dam-cdn.atl.orangelogic.com")) {
        if (width) {
            const srcSet = $0837d80a58b451e8$export$990d7fb4a6e407a3(src, width);
            return srcSet.length > 0 ? srcSet.join(",") : `${src}`;
        } else return `${src}`; // Return the original src if no width is provided
    } else if (extendCachingOfBfldrAssets) {
        const maxAge = 31536000;
        if (width) {
            const srcSet = $0837d80a58b451e8$export$7ab3f8b89543d628(src, width, [
                "auto=webp",
                `max_age=${maxAge}`
            ]);
            return srcSet.length > 0 ? srcSet.join(",") : `${src}?&max_age=${maxAge}`;
        } else if (height) return `${src}?auto=webp&height=${height}&max_age=${maxAge}`;
        else return `${src}?auto=webp&max_age=${maxAge}`;
    } else {
        if (width) {
            const srcSet = $0837d80a58b451e8$export$7ab3f8b89543d628(src, width, [
                "auto=webp"
            ]);
            return srcSet.length > 0 ? srcSet.join(",") : src;
        } else if (height) return `${src}?auto=webp&height=${height}`;
        else return `${src}?auto=webp`;
    }
};
const $0837d80a58b451e8$export$ada5537b2c061996 = (maxWidth, width, height)=>{
    if (width && height && width > maxWidth) return {
        width: maxWidth,
        height: Math.round(maxWidth * (height / width) * 100) / 100
    };
    else if (width && height) return {
        width: width,
        height: height
    };
    else if (width && width > maxWidth) return {
        width: maxWidth,
        height: maxWidth
    };
    else if (width) return {
        width: width,
        height: width
    };
    else return {
        width: maxWidth,
        height: maxWidth
    };
};
const $0837d80a58b451e8$export$f0d5dc2ce3e4cb5f = ({ sources: sources, image: { src: src, alt: alt, width: width, height: height, ...imageProps }, className: className, style: style, forceEagerLoad: forceEagerLoad = false })=>{
    const DECORATIVE_IMGS = [
        "https://dam-cdn.atl.orangelogic.com/AssetLink/504175ycu5d01061dg4evte5l0m72pea.svg",
        "https://dam-cdn.atl.orangelogic.com/AssetLink/q6j1k002cmxpvr2145m8q3u70gfrm2qt.svg",
        "https://dam-cdn.atl.orangelogic.com/AssetLink/0ho3162460jba51mgj0a16k3cpvy074s.svg",
        "https://dam-cdn.atl.orangelogic.com/AssetLink/3ixqjd5540sdn251h25h55i82occ48sa.svg",
        "https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp"
    ];
    const isDecorativeImg = DECORATIVE_IMGS.includes(src);
    const finalAlt = isDecorativeImg ? "" : alt ?? "";
    const loadingMethod = (0, $iSvIT.useMemo)(()=>forceEagerLoad ? {
            fetchpriority: "high",
            loading: "eager"
        } : {
            loading: "lazy"
        }, [
        forceEagerLoad
    ]);
    // SVG images are already optimized for responsiveness
    if (src && src.endsWith(".svg")) {
        const modifiedSrc = $0837d80a58b451e8$export$54f5ec149fac9f45(src);
        return(// eslint-disable-next-line no-restricted-syntax
        /*#__PURE__*/ (0, $loA2J.jsx)("img", {
            ...loadingMethod,
            ...imageProps,
            src: modifiedSrc,
            alt: finalAlt,
            width: width,
            height: height,
            style: {
                maxWidth: "100%",
                ...style
            },
            className: className
        }));
    }
    if (sources) {
        const modifiedSrc = $0837d80a58b451e8$export$54f5ec149fac9f45(src);
        return /*#__PURE__*/ (0, $loA2J.jsxs)("picture", {
            className: className,
            children: [
                sources.map((source, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("source", {
                        ...source
                    }, index)),
                /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    ...loadingMethod,
                    ...imageProps,
                    src: modifiedSrc,
                    alt: finalAlt,
                    width: width,
                    height: height,
                    style: {
                        maxWidth: "100%",
                        ...style
                    }
                })
            ]
        });
    }
    if (src && // eslint-disable-next-line local/no-brandfolder-images-eslint
    (src.includes("wac-cdn-bfldr.atlassian.com") || src.includes("dam-cdn.atl.orangelogic.com"))) {
        const { width: tabletWidth, height: tabletHeight } = $0837d80a58b451e8$export$ada5537b2c061996(768, width, height);
        const { width: mobileWidth, height: mobileHeight } = $0837d80a58b451e8$export$ada5537b2c061996(480, width, height);
        return /*#__PURE__*/ (0, $loA2J.jsxs)("picture", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    srcSet: $0837d80a58b451e8$export$ef1c8480e0b65584(src, mobileWidth, mobileHeight),
                    type: "image/webp",
                    media: "(max-width: 480px)",
                    width: mobileWidth,
                    height: mobileHeight
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("source", {
                    srcSet: $0837d80a58b451e8$export$ef1c8480e0b65584(src, tabletWidth, tabletHeight),
                    type: "image/webp",
                    media: "(max-width: 768px)",
                    width: tabletWidth,
                    height: tabletHeight
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                    ...loadingMethod,
                    ...imageProps,
                    src: $0837d80a58b451e8$export$ef1c8480e0b65584(src),
                    alt: finalAlt,
                    width: width,
                    height: height,
                    style: {
                        ...style
                    }
                })
            ]
        });
    }
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $loA2J.jsx)("img", {
        ...loadingMethod,
        ...imageProps,
        src: src,
        alt: finalAlt,
        width: width,
        height: height,
        style: {
            maxWidth: "100%",
            ...style
        },
        className: className
    }));
};
const $0837d80a58b451e8$export$7ab3f8b89543d628 = (src, baseWidth, queryPairs, widthKey = "width")=>{
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        const srcSetQueryPairs = [
            ...queryPairs,
            `${widthKey}=${Math.ceil(w)}`
        ];
        return `${src}?${srcSetQueryPairs.join("&")} ${i + 1}x`;
    });
};
// @ts-ignore
function $0837d80a58b451e8$var$separateUrlAndExtension(url) {
    const parsedUrl = new URL(url);
    const pathname = parsedUrl.pathname;
    const lastDotIndex = pathname.lastIndexOf(".");
    const extension = pathname.substring(lastDotIndex);
    const baseUrl = url.slice(0, url.length - extension.length);
    return {
        baseUrl: baseUrl,
        extension: extension
    };
}
const $0837d80a58b451e8$export$990d7fb4a6e407a3 = (src, baseWidth)=>{
    // @ts-ignore
    return [
        baseWidth,
        baseWidth * 1.8,
        baseWidth * 2.6
    ].map((w, i)=>{
        // const { baseUrl, extension } = separateUrlAndExtension(src);
        // const srcSetQueryPairs = `/t/re_w_${Math.ceil(w)}/`;
        // return `${baseUrl}${srcSetQueryPairs}${extension} ${i + 1}x`;
        return `${src} ${i + 1}x`;
    });
};


const $dc7080843c7d67a6$export$cfb19d3a192c6fe2 = ()=>{
    const cmsLogoStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $0837d80a58b451e8$export$f0d5dc2ce3e4cb5f), {
        image: {
            src: `https://dam-cdn.atl.orangelogic.com/AssetLink/5t47pkm4i4ohq647450a58xbtp5m5f08.svg`,
            alt: "Rovo Dev Logo"
        },
        className: (0, $esG4f.default)([
            "_4t3ickbl"
        ])
    }, "devai.ondemand");
};


var $bf209b22e9e1c13f$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["BITBUCKET"] = "com.atlassian.bitbucket";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["OPSGENIE"] = "opsgenie";
    ProductKey["JIRA_SERVICE_DESK"] = "jira-servicedesk.ondemand";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of JIRA_SERVICE_DESK
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_CORE"] = "jira-core.ondemand";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of JIRA_CORE
    ProductKey["JIRA_WORK_MANAGEMENT"] = "jira-core.ondemand";
    ProductKey["ACCESS"] = "com.atlassian.identity-manager";
    ProductKey["STATUSPAGE"] = "statuspage";
    ProductKey["CONFLUENCE_PLUGIN_QUESTIONS"] = "com.atlassian.confluence.plugins.confluence-questions.ondemand";
    ProductKey["CONFLUENCE_TEAM_CALENDARS"] = "team.calendars.confluence.ondemand";
    ProductKey["JIRA_ROADMAPS"] = "com.radiantminds.roadmaps-jira.ondemand";
    ProductKey["JIRA_BONFIRE"] = "bonfire.jira.ondemand";
    ProductKey["JIRA_REFAPP"] = "refapp";
    ProductKey["TEAM_CENTRAL"] = "townsquare";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
    ProductKey["COMPASS"] = "compass";
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values -- intentional alias of TEAM_CENTRAL
    ProductKey["ATLAS"] = "townsquare";
    ProductKey["FABRIC"] = "atlassian-whiteboard";
    ProductKey["BEACON"] = "beacon";
    ProductKey["LOOM"] = "loom";
    ProductKey["ROVO"] = "rovo.ondemand";
    ProductKey["DEVAI"] = "devai.ondemand";
    ProductKey["CUSTOMER_MANAGED_KEYS"] = "com.atlassian.customer-managed-keys";
    ProductKey["JIRA_CUSTOMER_SERVICE"] = "jira-customer-service";
    ProductKey["TEAMWORK_COLLECTION"] = "com.atlassian.teamwork-collection";
    ProductKey["SERVICE_COLLECTION"] = "com.atlassian.service-collection";
    ProductKey["STRATEGY_COLLECTION"] = "com.atlassian.strategy-collection";
})($bf209b22e9e1c13f$export$f3a53bd43617a593 || ($bf209b22e9e1c13f$export$f3a53bd43617a593 = {}));
const $bf209b22e9e1c13f$export$920b38c8c1070ab = (productKey)=>{
    if (productKey === "com.atlassian.service-collection") return $bf209b22e9e1c13f$export$d4e88a65c1af65bf["jira-servicedesk.ondemand"];
    if (productKey in $bf209b22e9e1c13f$export$d4e88a65c1af65bf) return $bf209b22e9e1c13f$export$d4e88a65c1af65bf[productKey];
    return $bf209b22e9e1c13f$export$d4e88a65c1af65bf["jira-software.ondemand"];
};
var $bf209b22e9e1c13f$var$PricingType;
(function(PricingType) {
    PricingType["FREE"] = "FREE";
    PricingType["PAID"] = "PAID";
    PricingType["LIMITED_FREE"] = "LIMITED_FREE";
})($bf209b22e9e1c13f$var$PricingType || ($bf209b22e9e1c13f$var$PricingType = {}));
const $bf209b22e9e1c13f$export$801c92020d021357 = [
    "beacon",
    "bitbucket",
    "compass",
    "confluence",
    "confluence-jira-service-management",
    "confluence-jira-software",
    "developer",
    "fabric",
    "jira",
    "jira-product-discovery",
    "jira-service-management",
    "jira-service-management-confluence",
    "jira-service-management-jira-software",
    "jira-service-management-jira-software-confluence",
    "jira-software",
    "jira-software-confluence",
    "jira-software-confluence-compass",
    "jira-software-jira-service-management",
    "jira-software-jira-service-management-confluence",
    "loom",
    "opsgenie",
    "statuspage",
    "devai",
    "service-collection",
    "teamwork-collection",
    "strategy-collection"
];
const $bf209b22e9e1c13f$export$d1f2f60c2544179d = [
    "free",
    "standard",
    "premium"
];
const $bf209b22e9e1c13f$export$d4e88a65c1af65bf = {
    ["confluence.ondemand"]: {
        productKey: "confluence.ondemand",
        productName: "Confluence",
        productLogo: (0, $9a880b7c693c8a13$export$1b2e4fe6ef471556)
    },
    ["devai.ondemand"]: {
        productKey: "devai.ondemand",
        productName: "Rovo Dev Agents",
        productLogo: (0, $dc7080843c7d67a6$export$cfb19d3a192c6fe2 // Placeholder, replace with actual Dev AI logo when available
        )
    },
    ["jira-servicedesk.ondemand"]: {
        productKey: "jira-servicedesk.ondemand",
        productName: "Jira Service Management",
        productLogo: (0, $9a880b7c693c8a13$export$dabef2be6cd28c20)
    },
    ["jira-software.ondemand"]: {
        productKey: "jira-software.ondemand",
        productName: "Jira",
        productLogo: (0, $9a880b7c693c8a13$export$17d3acb0b4379d02)
    },
    ["com.atlassian.teamwork-collection"]: {
        productKey: "com.atlassian.teamwork-collection",
        productName: "Teamwork Collection",
        productLogo: (0, $9a880b7c693c8a13$export$17d3acb0b4379d02 // Placeholder - can be updated when Teamwork Collection logo is available
        )
    },
    ["com.atlassian.service-collection"]: {
        productKey: "com.atlassian.service-collection",
        productName: "Service Collection",
        productLogo: (0, $9a880b7c693c8a13$export$17d3acb0b4379d02)
    },
    ["com.atlassian.strategy-collection"]: {
        productKey: "com.atlassian.strategy-collection",
        productName: "Strategy Collection",
        productLogo: (0, $9a880b7c693c8a13$export$17d3acb0b4379d02)
    },
    ["jira-product-discovery"]: {
        productKey: "jira-product-discovery",
        productName: "Jira Product Discovery",
        productLogo: (0, $9a880b7c693c8a13$export$c49a2b642fe9eef4)
    },
    ["jira-customer-service"]: {
        productKey: "jira-customer-service",
        productName: "Customer Service Management",
        productLogo: (0, $9a880b7c693c8a13$export$3c6158790f5e01c4)
    }
};
const $bf209b22e9e1c13f$var$OFFERING_IDS = {
    dev: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "agent"
            },
            standard: {
                offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent"
            },
            premium: {
                offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent"
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
                pricingPlanId: "7701f274-6c84-45cd-bdb0-493a67355e61",
                // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: "standard",
                chargeElement: "agent"
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["compass"]: {
            beta: {
                offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
                productKey: "compass",
                edition: "beta",
                chargeElement: "user"
            },
            free: {
                offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
                productKey: "compass",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
                productKey: "compass",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "4b41c4e3-7f26-4182-a12b-8ed7468350c4",
                productKey: "compass",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
                productKey: "townsquare",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: "essentials",
                chargeElement: "user"
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
                productKey: "statuspage",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: "d69d4faa-7677-48f2-a432-fda525d2e223",
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7618c3e4-2e84-4a47-b322-d2515835c55a",
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: "9705f74d-d4af-48e1-b443-94a8ae9dff54",
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "3e6a7923-6df0-4ab6-b819-2168e8decef3",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent"
            },
            premium: {
                offeringId: "24698695-2f89-495b-b266-109b3f5c2210",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent"
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: "666dec82-def0-4675-8abe-171d26c968a0",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7e16cb96-ade2-4220-9010-c71ef9a70cf2",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "b296663a-50d7-4e51-bc53-be058da00dad",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["loom"]: {
            free: {
                offeringId: "67737b67-caad-48af-ac36-01a64e9f220b",
                productKey: "loom",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "d009c283-d868-4d90-aa1e-17609d515f0f",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business",
                chargeElement: "user"
            },
            premium: {
                offeringId: "3f72cea3-aa1c-446c-a3e4-d09fed86a62c",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business-ai",
                chargeElement: "user"
            }
        }
    },
    staging: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            standard: {
                offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            premium: {
                offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "agent",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            standard: {
                offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            premium: {
                offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                // https://workbench.staging.atl-paas.net/offerings/396efb16-749b-41fa-9cd1-ad10cfefa1d0
                pricingPlanId: "7701f274-6c84-45cd-bdb0-493a67355e61",
                // https://workbench.staging.atl-paas.net/products/jira-servicedesk.ondemand/plans/7701f274-6c84-45cd-bdb0-493a67355e61
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: "standard",
                chargeElement: "agent"
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            standard: {
                offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user",
                jiraFamilyOfferingId: "009f8789-c10c-4366-9420-f712d02a6499"
            },
            premium: {
                offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["compass"]: {
            beta: {
                offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
                productKey: "compass",
                edition: "beta",
                chargeElement: "user"
            },
            free: {
                offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
                productKey: "compass",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
                productKey: "compass",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "4b41c4e3-7f26-4182-a12b-8ed7468350c4",
                productKey: "compass",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
                productKey: "townsquare",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: "essentials",
                chargeElement: "user"
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
                productKey: "statuspage",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: "d69d4faa-7677-48f2-a432-fda525d2e223",
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7618c3e4-2e84-4a47-b322-d2515835c55a",
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            }
        },
        ["com.atlassian.customer-managed-keys"]: {
            standard: {
                offeringId: "c8a6f3e4-0134-4cd3-9d23-63d834651c6b",
                productKey: "com.atlassian.customer-managed-keys",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: "9705f74d-d4af-48e1-b443-94a8ae9dff54",
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "3e6a7923-6df0-4ab6-b819-2168e8decef3",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent"
            },
            premium: {
                offeringId: "24698695-2f89-495b-b266-109b3f5c2210",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent"
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: "666dec82-def0-4675-8abe-171d26c968a0",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7e16cb96-ade2-4220-9010-c71ef9a70cf2",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "b296663a-50d7-4e51-bc53-be058da00dad",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["loom"]: {
            free: {
                offeringId: "67737b67-caad-48af-ac36-01a64e9f220b",
                productKey: "loom",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "d009c283-d868-4d90-aa1e-17609d515f0f",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business",
                chargeElement: "user"
            },
            premium: {
                offeringId: "3f72cea3-aa1c-446c-a3e4-d09fed86a62c",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business-ai",
                chargeElement: "user"
            }
        }
    },
    production: {
        ["jira-software.ondemand"]: {
            free: {
                offeringId: "de2887c9-8a55-41d5-b5cf-ad6a5589ebed",
                productKey: "jira-software.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "a70b5cbb-1ae1-4003-8f4a-9001a4a50526",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "6dd805b4-da75-4374-a7a7-cf0b12f7ea07",
                productKey: "jira-software.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["confluence.ondemand"]: {
            free: {
                offeringId: "7547cfd6-a804-4e42-8bed-e656d49ea09e",
                productKey: "confluence.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "2eda1119-fab4-4699-ab37-ff8f12052cde",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "06ef245c-5fa3-473b-8822-5e6fe072ae4b",
                productKey: "confluence.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-servicedesk.ondemand"]: {
            free: {
                offeringId: "2bad3c2f-d740-44a9-b08d-849202f11830",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "agent"
            },
            standard: {
                offeringId: "396efb16-749b-41fa-9cd1-ad10cfefa1d0",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent"
            },
            premium: {
                offeringId: "0c6683b4-4633-4673-beca-690d171de6a5",
                productKey: "jira-servicedesk.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent"
            },
            halp: {
                offeringId: `396efb16-749b-41fa-9cd1-ad10cfefa1d0`,
                pricingPlanId: "200b2088-934b-4669-b7c5-7ae6961c9368",
                // https://workbench.prod.atl-paas.net/products/jira-servicedesk.ondemand/plans/200b2088-934b-4669-b7c5-7ae6961c9368
                pricingType: "PAID",
                // pricing type for CCP
                productKey: "jira-servicedesk.ondemand",
                edition: "standard",
                chargeElement: "agent"
            }
        },
        ["jira-core.ondemand"]: {
            free: {
                offeringId: "769055e8-05f5-4b1a-ba1a-a1afc874ee6d",
                productKey: "jira-core.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "5ab35ef5-e441-493a-b6e0-ba2d21a72ac6",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "d8e9a61a-c83b-4e40-a757-997d5bae2bb2",
                productKey: "jira-core.ondemand",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["jira-product-discovery"]: {
            free: {
                offeringId: "d843dd9e-23c5-4d27-af44-5009d568cb6e",
                productKey: "jira-product-discovery",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "35b9268e-66e2-45fb-81d3-dacd1e31831a",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f0b24ca7-c3d8-4cac-b5ed-60f4152d4dcd",
                productKey: "jira-product-discovery",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["compass"]: {
            beta: {
                offeringId: "7af07cb3-d4e5-473e-87b3-3ae3bc9248a6",
                productKey: "compass",
                edition: "beta",
                chargeElement: "user"
            },
            free: {
                offeringId: "1d1951e5-881c-4f75-b0cd-3c6859dd5759",
                productKey: "compass",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "575abf20-6cac-4bbc-9666-1791fae8d822",
                productKey: "compass",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "4b41c4e3-7f26-4182-a12b-8ed7468350c4",
                productKey: "compass",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["townsquare"]: {
            free: {
                offeringId: "88064fa1-b573-4358-a9de-ec350aac1ddc",
                productKey: "townsquare",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "01c8ddad-8ea4-4da9-8127-71d6ff6de1c9",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "f7866043-d6e4-4d54-9c6a-4f82c6a1ebe5",
                productKey: "townsquare",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["opsgenie"]: {
            free: {
                offeringId: "d0c6ab1d-d8ea-49f8-8893-eafca2e05158",
                productKey: "opsgenie",
                pricingType: "FREE",
                edition: "essentials",
                chargeElement: "user"
            }
        },
        ["atlassian-whiteboard"]: {
            free: {
                offeringId: "b0c7b413-b264-4c01-8b67-c61aa2c3e455",
                productKey: "atlassian-whiteboard",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["statuspage"]: {
            free: {
                offeringId: "cff16c60-539b-11ea-8d77-2e728ce88125",
                productKey: "statuspage",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            }
        },
        ["com.atlassian.bitbucket"]: {
            free: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "00000000-0000-0000-0000-000000000000",
                productKey: "com.atlassian.bitbucket",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["devai.ondemand"]: {
            free: {
                offeringId: "d69d4faa-7677-48f2-a432-fda525d2e223",
                productKey: "devai.ondemand",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7618c3e4-2e84-4a47-b322-d2515835c55a",
                productKey: "devai.ondemand",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            }
        },
        ["com.atlassian.customer-managed-keys"]: {
            standard: {
                offeringId: "c8a6f3e4-0134-4cd3-9d23-63d834651c6b",
                productKey: "com.atlassian.customer-managed-keys",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            }
        },
        ["com.atlassian.service-collection"]: {
            free: {
                offeringId: "9705f74d-d4af-48e1-b443-94a8ae9dff54",
                productKey: "com.atlassian.service-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "3e6a7923-6df0-4ab6-b819-2168e8decef3",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "agent"
            },
            premium: {
                offeringId: "24698695-2f89-495b-b266-109b3f5c2210",
                productKey: "com.atlassian.service-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "agent"
            }
        },
        ["com.atlassian.teamwork-collection"]: {
            free: {
                offeringId: "666dec82-def0-4675-8abe-171d26c968a0",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "7e16cb96-ade2-4220-9010-c71ef9a70cf2",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "standard",
                chargeElement: "user"
            },
            premium: {
                offeringId: "b296663a-50d7-4e51-bc53-be058da00dad",
                productKey: "com.atlassian.teamwork-collection",
                pricingType: "PAID",
                edition: "premium",
                chargeElement: "user"
            }
        },
        ["loom"]: {
            free: {
                offeringId: "67737b67-caad-48af-ac36-01a64e9f220b",
                productKey: "loom",
                pricingType: "FREE",
                edition: "free",
                chargeElement: "user"
            },
            standard: {
                offeringId: "d009c283-d868-4d90-aa1e-17609d515f0f",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business",
                chargeElement: "user"
            },
            premium: {
                offeringId: "3f72cea3-aa1c-446c-a3e4-d09fed86a62c",
                productKey: "loom",
                pricingType: "PAID",
                edition: "business-ai",
                chargeElement: "user"
            }
        }
    }
};
var $bf209b22e9e1c13f$export$c654666118e350a8;
(function(OrgBasedProduct) {
    OrgBasedProduct["GUARD_PREMIUM"] = "GUARD_PREMIUM";
    OrgBasedProduct["GUARD_PREMIUM_DEMO"] = "GUARD_PREMIUM_DEMO";
    OrgBasedProduct["GUARD_STANDARD"] = "GUARD_STANDARD";
    OrgBasedProduct["ROVO_ORG"] = "ROVO_ORG";
    OrgBasedProduct["ROVO_ORG_DEMO"] = "ROVO_ORG_DEMO";
    OrgBasedProduct["ROVO_ORG_FREE"] = "ROVO_ORG_FREE";
    OrgBasedProduct["ROVO_CREDITS_PACK"] = "ROVO_CREDITS_PACK";
    OrgBasedProduct["ASSET_CREDITS_PACK"] = "ASSET_CREDITS_PACK";
    OrgBasedProduct["AUTOMATION_CREDITS_PACK"] = "AUTOMATION_CREDITS_PACK";
    OrgBasedProduct["CS_RESOLUTION_CREDITS_PACK"] = "CS_RESOLUTION_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_LFS_STORAGE_CREDITS_PACK"] = "BITBUCKET_LFS_STORAGE_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_BUILD_TIME_CREDITS_PACK"] = "BITBUCKET_BUILD_TIME_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK"] = "BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK";
    OrgBasedProduct["BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK"] = "BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK";
    OrgBasedProduct["INDEXED_OBJECTS_PACK"] = "INDEXED_OBJECTS_PACK";
    OrgBasedProduct["TWC_ORG_FREE"] = "TWC_ORG_FREE";
    OrgBasedProduct["TWC_ORG_STANDARD"] = "TWC_ORG_STANDARD";
    OrgBasedProduct["TWC_ORG_PREMIUM"] = "TWC_ORG_PREMIUM";
    OrgBasedProduct["TWC_ORG_PREMIUM_BILLED_SEPARATELY"] = "TWC_ORG_PREMIUM_BILLED_SEPARATELY";
    OrgBasedProduct["TWC_ORG_ENTERPRISE"] = "TWC_ORG_ENTERPRISE";
    OrgBasedProduct["STRATEGY_ORG_ENTERPRISE"] = "STRATEGY_ORG_ENTERPRISE";
    OrgBasedProduct["CUSTOMER_MANAGED_KEYS"] = "CUSTOMER_MANAGED_KEYS";
    OrgBasedProduct["CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY"] = "CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_FREE"] = "SERVICE_COLLECTION_ORG_FREE";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_STANDARD"] = "SERVICE_COLLECTION_ORG_STANDARD";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_PREMIUM"] = "SERVICE_COLLECTION_ORG_PREMIUM";
    OrgBasedProduct["SERVICE_COLLECTION_ORG_ENTERPRISE"] = "SERVICE_COLLECTION_ORG_ENTERPRISE";
})($bf209b22e9e1c13f$export$c654666118e350a8 || ($bf209b22e9e1c13f$export$c654666118e350a8 = {}));
const $bf209b22e9e1c13f$export$4b199ba4373834 = "https://support.atlassian.com/security-and-access-policies/docs/set-up-cmk-enabled-atlassian-apps/";
const $bf209b22e9e1c13f$export$470b3b1706479a64 = {
    GUARD_PREMIUM: "2f5e5808-d501-450a-b246-b0bd50a0b72a",
    GUARD_PREMIUM_DEMO: "2081c1b7-2ad6-3e40-a7c2-5a7f876a38a7",
    GUARD_STANDARD: "1ac3b7dd-7141-414e-bc00-c890acc458b0",
    ROVO_ORG: "e7de08be-3d20-423e-b928-dd1fd325da7a",
    ROVO_ORG_DEMO: "df531ba8-186a-3924-96a3-23056fa96f3f",
    ROVO_ORG_FREE: "71f2d378-1960-4336-8e7b-6af35174650c",
    ROVO_CREDITS_PACK: "918c0980-3992-4e57-a76e-0bde1c94e435",
    ASSET_CREDITS_PACK: "36a69b0a-bf2f-4d40-bb95-6b2a40d52718",
    AUTOMATION_CREDITS_PACK: "bf680870-2670-4487-8ba3-ba6c9c49eb63",
    CS_RESOLUTION_CREDITS_PACK: "2b89e53d-62e7-42da-9174-9177ad961054",
    BITBUCKET_LFS_STORAGE_CREDITS_PACK: "3912fe8d-5b2e-4c38-a3d8-84552ca5b9d0",
    BITBUCKET_BUILD_TIME_CREDITS_PACK: "6e224a30-1516-49c9-ae19-69c803f25df4",
    BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK: "050ca109-c952-45bf-ace9-3ecea0db8752",
    BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK: "2cbd0691-5925-43e6-93d8-da14e2570ee9",
    INDEXED_OBJECTS_PACK: "083e1434-9d6a-4478-8534-7e586038775c",
    TWC_ORG_STANDARD: "7e16cb96-ade2-4220-9010-c71ef9a70cf2",
    TWC_ORG_PREMIUM: "b296663a-50d7-4e51-bc53-be058da00dad",
    TWC_ORG_PREMIUM_BILLED_SEPARATELY: "17c64528-3ce0-3ce5-8d61-26726b323416",
    TWC_ORG_ENTERPRISE: "cf0b0103-2f08-4c87-97cf-a69448d6e69a",
    TWC_ORG_FREE: "666dec82-def0-4675-8abe-171d26c968a0",
    STRATEGY_ORG_ENTERPRISE: "b7da0afa-6941-4010-9c29-cc8739f6fbf8",
    CUSTOMER_MANAGED_KEYS: "c8a6f3e4-0134-4cd3-9d23-63d834651c6b",
    CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY: "742112ad-8294-302d-bcab-b08362e15dee",
    SERVICE_COLLECTION_ORG_FREE: "9705f74d-d4af-48e1-b443-94a8ae9dff54",
    SERVICE_COLLECTION_ORG_STANDARD: "3e6a7923-6df0-4ab6-b819-2168e8decef3",
    SERVICE_COLLECTION_ORG_PREMIUM: "24698695-2f89-495b-b266-109b3f5c2210",
    SERVICE_COLLECTION_ORG_ENTERPRISE: "c1b6f7ce-21f9-4e85-b136-91f4c484b95d"
};
const $bf209b22e9e1c13f$export$629756db0300364b = [
    $bf209b22e9e1c13f$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS,
    $bf209b22e9e1c13f$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY
];
const $bf209b22e9e1c13f$export$7d55d65617002a4c = new Set([
    $bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_FREE,
    $bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_STANDARD,
    $bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_PREMIUM,
    $bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_PREMIUM_BILLED_SEPARATELY,
    $bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_ENTERPRISE,
    $bf209b22e9e1c13f$export$470b3b1706479a64.STRATEGY_ORG_ENTERPRISE,
    $bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_FREE,
    $bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_STANDARD,
    $bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_PREMIUM,
    $bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_ENTERPRISE
]);
const $bf209b22e9e1c13f$export$a20d8b3133159060 = {
    [$bf209b22e9e1c13f$export$470b3b1706479a64.GUARD_PREMIUM]: "GUARD_PREMIUM",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.GUARD_PREMIUM_DEMO]: "GUARD_PREMIUM_DEMO",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.GUARD_STANDARD]: "GUARD_STANDARD",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.ROVO_ORG]: "ROVO_ORG",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.ROVO_ORG_DEMO]: "ROVO_ORG_DEMO",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.ROVO_ORG_FREE]: "ROVO_ORG_FREE",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.ROVO_CREDITS_PACK]: "ROVO_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.ASSET_CREDITS_PACK]: "ASSET_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.AUTOMATION_CREDITS_PACK]: "AUTOMATION_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.CS_RESOLUTION_CREDITS_PACK]: "CS_RESOLUTION_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.BITBUCKET_LFS_STORAGE_CREDITS_PACK]: "BITBUCKET_LFS_STORAGE_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.BITBUCKET_BUILD_TIME_CREDITS_PACK]: "BITBUCKET_BUILD_TIME_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK]: "BITBUCKET_PACKAGE_STORAGE_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK]: "BITBUCKET_PACKAGE_NETWORK_CREDITS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.INDEXED_OBJECTS_PACK]: "INDEXED_OBJECTS_PACK",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_FREE]: "TWC_ORG_FREE",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_STANDARD]: "TWC_ORG_STANDARD",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_PREMIUM]: "TWC_ORG_PREMIUM",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_PREMIUM_BILLED_SEPARATELY]: "TWC_ORG_PREMIUM_BILLED_SEPARATELY",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.TWC_ORG_ENTERPRISE]: "TWC_ORG_ENTERPRISE",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.STRATEGY_ORG_ENTERPRISE]: "STRATEGY_ORG_ENTERPRISE",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS]: "CUSTOMER_MANAGED_KEYS",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY]: "CUSTOMER_MANAGED_KEYS_BILLED_SEPARATELY",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_FREE]: "SERVICE_COLLECTION_ORG_FREE",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_STANDARD]: "SERVICE_COLLECTION_ORG_STANDARD",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_PREMIUM]: "SERVICE_COLLECTION_ORG_PREMIUM",
    [$bf209b22e9e1c13f$export$470b3b1706479a64.SERVICE_COLLECTION_ORG_ENTERPRISE]: "SERVICE_COLLECTION_ORG_ENTERPRISE"
};
const $bf209b22e9e1c13f$export$f9f96fa5fb066102 = ({ productKey: productKey, edition: edition, primaryCollectionProduct: primaryCollectionProduct })=>{
    const products = $bf209b22e9e1c13f$var$OFFERING_IDS[(0, $4f402d6798da28f9$export$57570b1603cf6adb)()];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- referenced as a type via `keyof typeof editions`
    const editions = $bf209b22e9e1c13f$var$OFFERING_IDS[(0, $4f402d6798da28f9$export$57570b1603cf6adb)()][productKey];
    const ccpProduct = products[productKey][edition];
    // Update JSM standard offeringId to the new one if feature gate is enabled
    // TODO: Remove this once successfully migrated to use the new offeringId
    if (ccpProduct.offeringId === "396efb16-749b-41fa-9cd1-ad10cfefa1d0") {
        const isNewJSMOfferingIdEnabled = (0, $4LHd8.default).checkGate("signup_update_jsm_standard_offeringid");
        if (isNewJSMOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: "99bcbf6c-4fff-4a45-8303-a854e7fbd17c"
            };
            return newCcpProduct;
        }
    } else if (ccpProduct.offeringId === "d843dd9e-23c5-4d27-af44-5009d568cb6e") {
        // JPD Free
        const isNewJPDOfferingIdEnabled = (0, $4LHd8.default).checkGate("signup_update_jpd_offeringids");
        if (isNewJPDOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: "d2b66d44-0754-4c89-8d3b-c8f9a8102184"
            };
            return newCcpProduct;
        }
    } else if (ccpProduct.offeringId === "35b9268e-66e2-45fb-81d3-dacd1e31831a") {
        // JPD Standard
        const isNewJPDOfferingIdEnabled = (0, $4LHd8.default).checkGate("signup_update_jpd_offeringids");
        if (isNewJPDOfferingIdEnabled) {
            const newCcpProduct = {
                ...ccpProduct,
                offeringId: "cb8bc8af-491f-41be-8502-ae5de94d04f0"
            };
            return newCcpProduct;
        }
    }
    // service collections with a primaryCollectionProduct prioritize that product first
    const childProductsForPriorityActivation = productKey === "com.atlassian.service-collection" && primaryCollectionProduct ? [
        primaryCollectionProduct
    ] : [];
    if (childProductsForPriorityActivation.length > 0) return {
        ...ccpProduct,
        childProductsForPriorityActivation: childProductsForPriorityActivation
    };
    return ccpProduct;
};
const $bf209b22e9e1c13f$export$1a4f641784fb4df4 = (offeringId)=>{
    const products = $bf209b22e9e1c13f$var$OFFERING_IDS[(0, $4f402d6798da28f9$export$57570b1603cf6adb)()];
    // Search through all productKeys and editions to find the matching offeringId
    for(const productKey in products){
        const productEditions = products[productKey];
        if (!productEditions) continue;
        for(const edition in productEditions){
            const ccpProduct = productEditions[edition];
            if (ccpProduct.offeringId === offeringId) return {
                productKey: ccpProduct.productKey,
                edition: ccpProduct.edition
            };
        }
    }
    return null;
};
const $bf209b22e9e1c13f$export$75ed3732be18be33 = {
    ["com.atlassian.teamwork-collection"]: "jira-software.ondemand",
    ["com.atlassian.service-collection"]: "jira-servicedesk.ondemand"
};
const $bf209b22e9e1c13f$export$5c5446db708910b8 = {
    ["jira-servicedesk.ondemand"]: "jira-servicedesk",
    ["jira-customer-service"]: "jira-customer-service",
    ["jira-software.ondemand"]: "jira-software",
    ["confluence.ondemand"]: "confluence",
    ["loom"]: "loom"
};
const $bf209b22e9e1c13f$export$c1955d02b55bd9be = {
    ["com.atlassian.service-collection"]: [
        "jira-servicedesk.ondemand",
        "jira-customer-service"
    ],
    ["com.atlassian.teamwork-collection"]: [
        "jira-software.ondemand",
        "confluence.ondemand",
        "loom"
    ]
};
const $bf209b22e9e1c13f$export$288c8597359c2277 = {
    "service-collection": "com.atlassian.service-collection",
    "teamwork-collection": "com.atlassian.teamwork-collection"
};
const $bf209b22e9e1c13f$export$d7e04b0ebb68822a = Object.entries($bf209b22e9e1c13f$export$288c8597359c2277).reduce((acc, [bundleName, productKey])=>{
    acc[productKey] = bundleName;
    return acc;
}, {});
const $bf209b22e9e1c13f$export$fe3cfcb5926c814e = {
    SimplifiedBasic: "com.pyxis.greenhopper.jira:gh-simplified-basic",
    Scrum: "com.pyxis.greenhopper.jira:gh-simplified-agility-scrum",
    Kanban: "com.pyxis.greenhopper.jira:gh-simplified-agility-kanban",
    WebDesignProcess: "com.atlassian.jira-core-project-templates:jira-work-management-web-design-process",
    GoToMarket: "com.atlassian.jira-core-project-templates:jira-work-management-go-to-market",
    SimplifiedProcessControl: "com.atlassian.jira-core-project-templates:jira-core-simplified-process-control",
    ProcessControlTeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-process-control-team-managed",
    SalesPipeline: "com.atlassian.jira-core-project-templates:jira-work-management-sales-pipeline",
    SimplifiedProcurement: "com.atlassian.jira-core-project-templates:jira-core-simplified-procurement",
    EmployeeOnboarding: "com.atlassian.jira-core-project-templates:jira-work-management-employee-onboarding",
    PersonalTaskPlanner: "com.atlassian.jira-core-project-templates:jira-work-management-personal-task-planner",
    CampaignManagement: "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management",
    CampaignManagementTeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed",
    CampaignManagementV2TeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-campaign-management-team-managed-v2",
    Recruitment: "com.atlassian.jira-core-project-templates:jira-core-simplified-recruitment",
    RecruitmentTeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-recruitment-team-managed",
    LeadTracking: "com.atlassian.jira-core-project-templates:jira-core-simplified-lead-tracking",
    LeadTrackingTeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-lead-tracking-team-managed",
    MonthEndClose: "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close",
    MonthEndCloseTeamManaged: "com.atlassian.jira-core-project-templates:jira-work-management-month-end-close-team-managed"
};



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
var $66ea79e9ce71ac40$export$a84bdc57c5122798 = {
    NAME: "Name",
    DOCUMENT: "Document",
    OPERATION_DEFINITION: "OperationDefinition",
    VARIABLE_DEFINITION: "VariableDefinition",
    SELECTION_SET: "SelectionSet",
    FIELD: "Field",
    ARGUMENT: "Argument",
    FRAGMENT_SPREAD: "FragmentSpread",
    INLINE_FRAGMENT: "InlineFragment",
    FRAGMENT_DEFINITION: "FragmentDefinition",
    VARIABLE: "Variable",
    INT: "IntValue",
    FLOAT: "FloatValue",
    STRING: "StringValue",
    BOOLEAN: "BooleanValue",
    NULL: "NullValue",
    ENUM: "EnumValue",
    LIST: "ListValue",
    OBJECT: "ObjectValue",
    OBJECT_FIELD: "ObjectField",
    DIRECTIVE: "Directive",
    NAMED_TYPE: "NamedType",
    LIST_TYPE: "ListType",
    NON_NULL_TYPE: "NonNullType"
};
var $66ea79e9ce71ac40$export$f58c50edb4aef9d4 = {
    QUERY: "query",
    MUTATION: "mutation",
    SUBSCRIPTION: "subscription"
};
class $66ea79e9ce71ac40$export$92d6ed0888e7cb7f extends Error {
    constructor(e, r, i, n, a, t, l){
        super(e);
        this.name = "GraphQLError";
        this.message = e;
        if (a) this.path = a;
        if (r) this.nodes = Array.isArray(r) ? r : [
            r
        ];
        if (i) this.source = i;
        if (n) this.positions = n;
        if (t) this.originalError = t;
        var o = l;
        if (!o && t) {
            var u = t.extensions;
            if (u && "object" == typeof u) o = u;
        }
        this.extensions = o || {};
    }
    toJSON() {
        return {
            ...this,
            message: this.message
        };
    }
    toString() {
        return this.message;
    }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
}
var $66ea79e9ce71ac40$var$i;
var $66ea79e9ce71ac40$var$n;
function $66ea79e9ce71ac40$var$error(e) {
    return new $66ea79e9ce71ac40$export$92d6ed0888e7cb7f(`Syntax Error: Unexpected token at ${$66ea79e9ce71ac40$var$n} in ${e}`);
}
function $66ea79e9ce71ac40$var$advance(e) {
    e.lastIndex = $66ea79e9ce71ac40$var$n;
    if (e.test($66ea79e9ce71ac40$var$i)) return $66ea79e9ce71ac40$var$i.slice($66ea79e9ce71ac40$var$n, $66ea79e9ce71ac40$var$n = e.lastIndex);
}
var $66ea79e9ce71ac40$var$a = / +(?=[^\s])/y;
function $66ea79e9ce71ac40$var$blockString(e) {
    var r = e.split("\n");
    var i = "";
    var n = 0;
    var t = 0;
    var l = r.length - 1;
    for(var o = 0; o < r.length; o++){
        $66ea79e9ce71ac40$var$a.lastIndex = 0;
        if ($66ea79e9ce71ac40$var$a.test(r[o])) {
            if (o && (!n || $66ea79e9ce71ac40$var$a.lastIndex < n)) n = $66ea79e9ce71ac40$var$a.lastIndex;
            t = t || o;
            l = o;
        }
    }
    for(var u = t; u <= l; u++){
        if (u !== t) i += "\n";
        i += r[u].slice(n).replace(/\\"""/g, '"""');
    }
    return i;
}
function $66ea79e9ce71ac40$var$ignored() {
    for(var e = 0 | $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++))if (35 === e) {
        while(10 !== (e = $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) && 13 !== e);
    }
    $66ea79e9ce71ac40$var$n--;
}
var $66ea79e9ce71ac40$var$t = /[_A-Za-z]\w*/y;
var $66ea79e9ce71ac40$var$l = new RegExp("(?:(null|true|false)|\\$(" + $66ea79e9ce71ac40$var$t.source + ')|(-?\\d+)((?:\\.\\d+)?[eE][+-]?\\d+|\\.\\d+)?|("""(?:"""|(?:[\\s\\S]*?[^\\\\])"""))|("(?:"|[^\\r\\n]*?[^\\\\]"))|(' + $66ea79e9ce71ac40$var$t.source + "))", "y");
var $66ea79e9ce71ac40$var$o = function(e) {
    e[e.Const = 1] = "Const";
    e[e.Var = 2] = "Var";
    e[e.Int = 3] = "Int";
    e[e.Float = 4] = "Float";
    e[e.BlockString = 5] = "BlockString";
    e[e.String = 6] = "String";
    e[e.Enum = 7] = "Enum";
    return e;
}($66ea79e9ce71ac40$var$o || {});
var $66ea79e9ce71ac40$var$u = /\\/g;
function $66ea79e9ce71ac40$var$value(e) {
    var r;
    var a;
    $66ea79e9ce71ac40$var$l.lastIndex = $66ea79e9ce71ac40$var$n;
    if (91 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        var d = [];
        while(93 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n))d.push($66ea79e9ce71ac40$var$value(e));
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        return {
            kind: "ListValue",
            values: d
        };
    } else if (123 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        var v = [];
        while(125 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)){
            if (null == (r = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("ObjectField");
            $66ea79e9ce71ac40$var$ignored();
            if (58 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("ObjectField");
            $66ea79e9ce71ac40$var$ignored();
            v.push({
                kind: "ObjectField",
                name: {
                    kind: "Name",
                    value: r
                },
                value: $66ea79e9ce71ac40$var$value(e)
            });
        }
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        return {
            kind: "ObjectValue",
            fields: v
        };
    } else if (null != (a = $66ea79e9ce71ac40$var$l.exec($66ea79e9ce71ac40$var$i))) {
        $66ea79e9ce71ac40$var$n = $66ea79e9ce71ac40$var$l.lastIndex;
        $66ea79e9ce71ac40$var$ignored();
        if (null != (r = a[$66ea79e9ce71ac40$var$o.Const])) return "null" === r ? {
            kind: "NullValue"
        } : {
            kind: "BooleanValue",
            value: "true" === r
        };
        else if (null != (r = a[$66ea79e9ce71ac40$var$o.Var])) {
            if (e) throw $66ea79e9ce71ac40$var$error("Variable");
            else return {
                kind: "Variable",
                name: {
                    kind: "Name",
                    value: r
                }
            };
        } else if (null != (r = a[$66ea79e9ce71ac40$var$o.Int])) {
            var s;
            if (null != (s = a[$66ea79e9ce71ac40$var$o.Float])) return {
                kind: "FloatValue",
                value: r + s
            };
            else return {
                kind: "IntValue",
                value: r
            };
        } else if (null != (r = a[$66ea79e9ce71ac40$var$o.BlockString])) return {
            kind: "StringValue",
            value: $66ea79e9ce71ac40$var$blockString(r.slice(3, -3)),
            block: !0
        };
        else if (null != (r = a[$66ea79e9ce71ac40$var$o.String])) return {
            kind: "StringValue",
            value: $66ea79e9ce71ac40$var$u.test(r) ? JSON.parse(r) : r.slice(1, -1),
            block: !1
        };
        else if (null != (r = a[$66ea79e9ce71ac40$var$o.Enum])) return {
            kind: "EnumValue",
            value: r
        };
    }
    throw $66ea79e9ce71ac40$var$error("Value");
}
function $66ea79e9ce71ac40$var$arguments_(e) {
    if (40 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
        var r = [];
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        var a;
        do {
            if (null == (a = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("Argument");
            $66ea79e9ce71ac40$var$ignored();
            if (58 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("Argument");
            $66ea79e9ce71ac40$var$ignored();
            r.push({
                kind: "Argument",
                name: {
                    kind: "Name",
                    value: a
                },
                value: $66ea79e9ce71ac40$var$value(e)
            });
        }while (41 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n));
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        return r;
    }
}
function $66ea79e9ce71ac40$var$directives(e) {
    if (64 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
        var r = [];
        var a;
        do {
            $66ea79e9ce71ac40$var$n++;
            if (null == (a = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("Directive");
            $66ea79e9ce71ac40$var$ignored();
            r.push({
                kind: "Directive",
                name: {
                    kind: "Name",
                    value: a
                },
                arguments: $66ea79e9ce71ac40$var$arguments_(e)
            });
        }while (64 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n));
        return r;
    }
}
function $66ea79e9ce71ac40$var$type() {
    var e;
    var r = 0;
    while(91 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)){
        r++;
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
    }
    if (null == (e = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("NamedType");
    $66ea79e9ce71ac40$var$ignored();
    var a = {
        kind: "NamedType",
        name: {
            kind: "Name",
            value: e
        }
    };
    do {
        if (33 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
            $66ea79e9ce71ac40$var$n++;
            $66ea79e9ce71ac40$var$ignored();
            a = {
                kind: "NonNullType",
                type: a
            };
        }
        if (r) {
            if (93 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("NamedType");
            $66ea79e9ce71ac40$var$ignored();
            a = {
                kind: "ListType",
                type: a
            };
        }
    }while (r--);
    return a;
}
var $66ea79e9ce71ac40$var$d = new RegExp("(?:(\\.{3})|(" + $66ea79e9ce71ac40$var$t.source + "))", "y");
var $66ea79e9ce71ac40$var$v = function(e) {
    e[e.Spread = 1] = "Spread";
    e[e.Name = 2] = "Name";
    return e;
}($66ea79e9ce71ac40$var$v || {});
function $66ea79e9ce71ac40$var$selectionSet() {
    var e = [];
    var r;
    var a;
    do {
        $66ea79e9ce71ac40$var$d.lastIndex = $66ea79e9ce71ac40$var$n;
        if (null != (a = $66ea79e9ce71ac40$var$d.exec($66ea79e9ce71ac40$var$i))) {
            $66ea79e9ce71ac40$var$n = $66ea79e9ce71ac40$var$d.lastIndex;
            if (null != a[$66ea79e9ce71ac40$var$v.Spread]) {
                $66ea79e9ce71ac40$var$ignored();
                var l = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t);
                if (null != l && "on" !== l) {
                    $66ea79e9ce71ac40$var$ignored();
                    e.push({
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: l
                        },
                        directives: $66ea79e9ce71ac40$var$directives(!1)
                    });
                } else {
                    $66ea79e9ce71ac40$var$ignored();
                    if ("on" === l) {
                        if (null == (l = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("NamedType");
                        $66ea79e9ce71ac40$var$ignored();
                    }
                    var o = $66ea79e9ce71ac40$var$directives(!1);
                    if (123 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("InlineFragment");
                    $66ea79e9ce71ac40$var$ignored();
                    e.push({
                        kind: "InlineFragment",
                        typeCondition: l ? {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: l
                            }
                        } : void 0,
                        directives: o,
                        selectionSet: $66ea79e9ce71ac40$var$selectionSet()
                    });
                }
            } else if (null != (r = a[$66ea79e9ce71ac40$var$v.Name])) {
                var u = void 0;
                $66ea79e9ce71ac40$var$ignored();
                if (58 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
                    $66ea79e9ce71ac40$var$n++;
                    $66ea79e9ce71ac40$var$ignored();
                    u = r;
                    if (null == (r = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("Field");
                    $66ea79e9ce71ac40$var$ignored();
                }
                var s = $66ea79e9ce71ac40$var$arguments_(!1);
                $66ea79e9ce71ac40$var$ignored();
                var c = $66ea79e9ce71ac40$var$directives(!1);
                var f = void 0;
                if (123 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
                    $66ea79e9ce71ac40$var$n++;
                    $66ea79e9ce71ac40$var$ignored();
                    f = $66ea79e9ce71ac40$var$selectionSet();
                }
                e.push({
                    kind: "Field",
                    alias: u ? {
                        kind: "Name",
                        value: u
                    } : void 0,
                    name: {
                        kind: "Name",
                        value: r
                    },
                    arguments: s,
                    directives: c,
                    selectionSet: f
                });
            }
        } else throw $66ea79e9ce71ac40$var$error("SelectionSet");
    }while (125 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n));
    $66ea79e9ce71ac40$var$n++;
    $66ea79e9ce71ac40$var$ignored();
    return {
        kind: "SelectionSet",
        selections: e
    };
}
function $66ea79e9ce71ac40$var$fragmentDefinition() {
    var e;
    var r;
    if (null == (e = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("FragmentDefinition");
    $66ea79e9ce71ac40$var$ignored();
    if ("on" !== $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t)) throw $66ea79e9ce71ac40$var$error("FragmentDefinition");
    $66ea79e9ce71ac40$var$ignored();
    if (null == (r = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("FragmentDefinition");
    $66ea79e9ce71ac40$var$ignored();
    var a = $66ea79e9ce71ac40$var$directives(!1);
    if (123 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("FragmentDefinition");
    $66ea79e9ce71ac40$var$ignored();
    return {
        kind: "FragmentDefinition",
        name: {
            kind: "Name",
            value: e
        },
        typeCondition: {
            kind: "NamedType",
            name: {
                kind: "Name",
                value: r
            }
        },
        directives: a,
        selectionSet: $66ea79e9ce71ac40$var$selectionSet()
    };
}
var $66ea79e9ce71ac40$var$s = /(?:query|mutation|subscription|fragment)/y;
function $66ea79e9ce71ac40$var$operationDefinition(e) {
    var r;
    var a;
    var l;
    if (e) {
        $66ea79e9ce71ac40$var$ignored();
        r = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t);
        a = function variableDefinitions() {
            $66ea79e9ce71ac40$var$ignored();
            if (40 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
                var e = [];
                $66ea79e9ce71ac40$var$n++;
                $66ea79e9ce71ac40$var$ignored();
                var r;
                do {
                    if (36 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("Variable");
                    if (null == (r = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$t))) throw $66ea79e9ce71ac40$var$error("Variable");
                    $66ea79e9ce71ac40$var$ignored();
                    if (58 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n++)) throw $66ea79e9ce71ac40$var$error("VariableDefinition");
                    $66ea79e9ce71ac40$var$ignored();
                    var a = $66ea79e9ce71ac40$var$type();
                    var l = void 0;
                    if (61 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
                        $66ea79e9ce71ac40$var$n++;
                        $66ea79e9ce71ac40$var$ignored();
                        l = $66ea79e9ce71ac40$var$value(!0);
                    }
                    $66ea79e9ce71ac40$var$ignored();
                    e.push({
                        kind: "VariableDefinition",
                        variable: {
                            kind: "Variable",
                            name: {
                                kind: "Name",
                                value: r
                            }
                        },
                        type: a,
                        defaultValue: l,
                        directives: $66ea79e9ce71ac40$var$directives(!0)
                    });
                }while (41 !== $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n));
                $66ea79e9ce71ac40$var$n++;
                $66ea79e9ce71ac40$var$ignored();
                return e;
            }
        }();
        l = $66ea79e9ce71ac40$var$directives(!1);
    }
    if (123 === $66ea79e9ce71ac40$var$i.charCodeAt($66ea79e9ce71ac40$var$n)) {
        $66ea79e9ce71ac40$var$n++;
        $66ea79e9ce71ac40$var$ignored();
        return {
            kind: "OperationDefinition",
            operation: e || "query",
            name: r ? {
                kind: "Name",
                value: r
            } : void 0,
            variableDefinitions: a,
            directives: l,
            selectionSet: $66ea79e9ce71ac40$var$selectionSet()
        };
    }
}
function $66ea79e9ce71ac40$export$98e6a39c04603d36(e, r) {
    $66ea79e9ce71ac40$var$i = "string" == typeof e.body ? e.body : e;
    $66ea79e9ce71ac40$var$n = 0;
    return function document() {
        var e;
        var r;
        $66ea79e9ce71ac40$var$ignored();
        var a = [];
        do {
            if ("fragment" === (e = $66ea79e9ce71ac40$var$advance($66ea79e9ce71ac40$var$s))) {
                $66ea79e9ce71ac40$var$ignored();
                a.push($66ea79e9ce71ac40$var$fragmentDefinition());
            } else if (null != (r = $66ea79e9ce71ac40$var$operationDefinition(e))) a.push(r);
            else throw $66ea79e9ce71ac40$var$error("Document");
        }while ($66ea79e9ce71ac40$var$n < $66ea79e9ce71ac40$var$i.length);
        return {
            kind: "Document",
            definitions: a
        };
    }();
}
function $66ea79e9ce71ac40$export$5303528d1070ff6f(e, r) {
    $66ea79e9ce71ac40$var$i = "string" == typeof e.body ? e.body : e;
    $66ea79e9ce71ac40$var$n = 0;
    $66ea79e9ce71ac40$var$ignored();
    return $66ea79e9ce71ac40$var$value(!1);
}
function $66ea79e9ce71ac40$export$28b8f402ccc88182(e, r) {
    $66ea79e9ce71ac40$var$i = "string" == typeof e.body ? e.body : e;
    $66ea79e9ce71ac40$var$n = 0;
    return $66ea79e9ce71ac40$var$type();
}
var $66ea79e9ce71ac40$export$a89c95c098ac2a58 = {};
function $66ea79e9ce71ac40$export$bf638b60ea8b89b7(e, r) {
    var i = [];
    var n = [];
    try {
        var a = function traverse(e, a, t) {
            var l = !1;
            var o = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
            var u = o && o.call(r, e, a, t, n, i);
            if (!1 === u) return e;
            else if (null === u) return null;
            else if (u === $66ea79e9ce71ac40$export$a89c95c098ac2a58) throw $66ea79e9ce71ac40$export$a89c95c098ac2a58;
            else if (u && "string" == typeof u.kind) {
                l = u !== e;
                e = u;
            }
            if (t) i.push(t);
            var d;
            var v = {
                ...e
            };
            for(var s in e){
                n.push(s);
                var f = e[s];
                if (Array.isArray(f)) {
                    var m = [];
                    for(var g = 0; g < f.length; g++)if (null != f[g] && "string" == typeof f[g].kind) {
                        i.push(e);
                        n.push(g);
                        d = traverse(f[g], g, f);
                        n.pop();
                        i.pop();
                        if (null == d) l = !0;
                        else {
                            l = l || d !== f[g];
                            m.push(d);
                        }
                    }
                    f = m;
                } else if (null != f && "string" == typeof f.kind) {
                    if (void 0 !== (d = traverse(f, s, e))) {
                        l = l || f !== d;
                        f = d;
                    }
                }
                n.pop();
                if (l) v[s] = f;
            }
            if (t) i.pop();
            var p = r[e.kind] && r[e.kind].leave || r.leave;
            var h = p && p.call(r, e, a, t, n, i);
            if (h === $66ea79e9ce71ac40$export$a89c95c098ac2a58) throw $66ea79e9ce71ac40$export$a89c95c098ac2a58;
            else if (void 0 !== h) return h;
            else if (void 0 !== u) return l ? v : u;
            else return l ? v : e;
        }(e);
        return void 0 !== a && !1 !== a ? a : e;
    } catch (r) {
        if (r !== $66ea79e9ce71ac40$export$a89c95c098ac2a58) throw r;
        return e;
    }
}
function $66ea79e9ce71ac40$var$mapJoin(e, r, i) {
    var n = "";
    for(var a = 0; a < e.length; a++){
        if (a) n += r;
        n += i(e[a]);
    }
    return n;
}
function $66ea79e9ce71ac40$export$3cdec7cf614a0ecc(e) {
    return JSON.stringify(e);
}
function $66ea79e9ce71ac40$export$adb6ca997eeb1f45(e) {
    return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}
var $66ea79e9ce71ac40$var$f = "\n";
var $66ea79e9ce71ac40$var$m = {
    OperationDefinition (e) {
        var r = e.operation;
        if (e.name) r += " " + e.name.value;
        if (e.variableDefinitions && e.variableDefinitions.length) {
            if (!e.name) r += " ";
            r += "(" + $66ea79e9ce71ac40$var$mapJoin(e.variableDefinitions, ", ", $66ea79e9ce71ac40$var$m.VariableDefinition) + ")";
        }
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        return "query" !== r ? r + " " + $66ea79e9ce71ac40$var$m.SelectionSet(e.selectionSet) : $66ea79e9ce71ac40$var$m.SelectionSet(e.selectionSet);
    },
    VariableDefinition (e) {
        var r = $66ea79e9ce71ac40$var$m.Variable(e.variable) + ": " + $66ea79e9ce71ac40$var$_print(e.type);
        if (e.defaultValue) r += " = " + $66ea79e9ce71ac40$var$_print(e.defaultValue);
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        return r;
    },
    Field (e) {
        var r = e.alias ? e.alias.value + ": " + e.name.value : e.name.value;
        if (e.arguments && e.arguments.length) {
            var i = $66ea79e9ce71ac40$var$mapJoin(e.arguments, ", ", $66ea79e9ce71ac40$var$m.Argument);
            if (r.length + i.length + 2 > 80) r += "(" + ($66ea79e9ce71ac40$var$f += "  ") + $66ea79e9ce71ac40$var$mapJoin(e.arguments, $66ea79e9ce71ac40$var$f, $66ea79e9ce71ac40$var$m.Argument) + ($66ea79e9ce71ac40$var$f = $66ea79e9ce71ac40$var$f.slice(0, -2)) + ")";
            else r += "(" + i + ")";
        }
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        if (e.selectionSet) r += " " + $66ea79e9ce71ac40$var$m.SelectionSet(e.selectionSet);
        return r;
    },
    StringValue (e) {
        if (e.block) return $66ea79e9ce71ac40$export$adb6ca997eeb1f45(e.value).replace(/\n/g, $66ea79e9ce71ac40$var$f);
        else return $66ea79e9ce71ac40$export$3cdec7cf614a0ecc(e.value);
    },
    BooleanValue: (e)=>"" + e.value,
    NullValue: (e)=>"null",
    IntValue: (e)=>e.value,
    FloatValue: (e)=>e.value,
    EnumValue: (e)=>e.value,
    Name: (e)=>e.value,
    Variable: (e)=>"$" + e.name.value,
    ListValue: (e)=>"[" + $66ea79e9ce71ac40$var$mapJoin(e.values, ", ", $66ea79e9ce71ac40$var$_print) + "]",
    ObjectValue: (e)=>"{" + $66ea79e9ce71ac40$var$mapJoin(e.fields, ", ", $66ea79e9ce71ac40$var$m.ObjectField) + "}",
    ObjectField: (e)=>e.name.value + ": " + $66ea79e9ce71ac40$var$_print(e.value),
    Document (e) {
        if (!e.definitions || !e.definitions.length) return "";
        return $66ea79e9ce71ac40$var$mapJoin(e.definitions, "\n\n", $66ea79e9ce71ac40$var$_print);
    },
    SelectionSet: (e)=>"{" + ($66ea79e9ce71ac40$var$f += "  ") + $66ea79e9ce71ac40$var$mapJoin(e.selections, $66ea79e9ce71ac40$var$f, $66ea79e9ce71ac40$var$_print) + ($66ea79e9ce71ac40$var$f = $66ea79e9ce71ac40$var$f.slice(0, -2)) + "}",
    Argument: (e)=>e.name.value + ": " + $66ea79e9ce71ac40$var$_print(e.value),
    FragmentSpread (e) {
        var r = "..." + e.name.value;
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        return r;
    },
    InlineFragment (e) {
        var r = "...";
        if (e.typeCondition) r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        return r += " " + $66ea79e9ce71ac40$var$m.SelectionSet(e.selectionSet);
    },
    FragmentDefinition (e) {
        var r = "fragment " + e.name.value;
        r += " on " + e.typeCondition.name.value;
        if (e.directives && e.directives.length) r += " " + $66ea79e9ce71ac40$var$mapJoin(e.directives, " ", $66ea79e9ce71ac40$var$m.Directive);
        return r + " " + $66ea79e9ce71ac40$var$m.SelectionSet(e.selectionSet);
    },
    Directive (e) {
        var r = "@" + e.name.value;
        if (e.arguments && e.arguments.length) r += "(" + $66ea79e9ce71ac40$var$mapJoin(e.arguments, ", ", $66ea79e9ce71ac40$var$m.Argument) + ")";
        return r;
    },
    NamedType: (e)=>e.name.value,
    ListType: (e)=>"[" + $66ea79e9ce71ac40$var$_print(e.type) + "]",
    NonNullType: (e)=>$66ea79e9ce71ac40$var$_print(e.type) + "!"
};
var $66ea79e9ce71ac40$var$_print = (e)=>$66ea79e9ce71ac40$var$m[e.kind](e);
function $66ea79e9ce71ac40$export$c2d084dc44961371(e) {
    $66ea79e9ce71ac40$var$f = "\n";
    return $66ea79e9ce71ac40$var$m[e.kind] ? $66ea79e9ce71ac40$var$m[e.kind](e) : "";
}
function $66ea79e9ce71ac40$export$448e0963aec9442f(e, r) {
    switch(e.kind){
        case "NullValue":
            return null;
        case "IntValue":
            return parseInt(e.value, 10);
        case "FloatValue":
            return parseFloat(e.value);
        case "StringValue":
        case "EnumValue":
        case "BooleanValue":
            return e.value;
        case "ListValue":
            var i = [];
            for (var n of e.values)i.push($66ea79e9ce71ac40$export$448e0963aec9442f(n, r));
            return i;
        case "ObjectValue":
            var a = Object.create(null);
            for (var t of e.fields)a[t.name.value] = $66ea79e9ce71ac40$export$448e0963aec9442f(t.value, r);
            return a;
        case "Variable":
            return r && r[e.name.value];
    }
}
function $66ea79e9ce71ac40$export$d7c3f1876e7bc864(e, r, i) {
    if ("Variable" === e.kind) return i ? $66ea79e9ce71ac40$export$d7c3f1876e7bc864(i[e.name.value], r, i) : void 0;
    else if ("NonNullType" === r.kind) return "NullValue" !== e.kind ? $66ea79e9ce71ac40$export$d7c3f1876e7bc864(e, r, i) : void 0;
    else if ("NullValue" === e.kind) return null;
    else if ("ListType" === r.kind) {
        if ("ListValue" === e.kind) {
            var n = [];
            for (var a of e.values){
                var t = $66ea79e9ce71ac40$export$d7c3f1876e7bc864(a, r.type, i);
                if (void 0 === t) return;
                else n.push(t);
            }
            return n;
        }
    } else if ("NamedType" === r.kind) switch(r.name.value){
        case "Int":
        case "Float":
        case "String":
        case "Bool":
            return r.name.value + "Value" === e.kind ? $66ea79e9ce71ac40$export$448e0963aec9442f(e, i) : void 0;
        default:
            return $66ea79e9ce71ac40$export$448e0963aec9442f(e, i);
    }
}



var $779416f751461a71$var$teardownPlaceholder = ()=>{};
var $779416f751461a71$var$e = $779416f751461a71$var$teardownPlaceholder;
function $779416f751461a71$var$start(e) {
    return {
        tag: 0,
        0: e
    };
}
function $779416f751461a71$var$push(e) {
    return {
        tag: 1,
        0: e
    };
}
var $779416f751461a71$var$asyncIteratorSymbol = ()=>"function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator";
var $779416f751461a71$var$observableSymbol = ()=>"function" == typeof Symbol && Symbol.observable || "@@observable";
var $779416f751461a71$var$identity = (e)=>e;
function $779416f751461a71$export$ab1029bcae9ddb4a(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $779416f751461a71$var$e;
            var n = $779416f751461a71$var$e;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    n(1);
                    if (a.length) i($779416f751461a71$var$push(a));
                    i(0);
                } else if (0 === e.tag) {
                    f = e[0];
                    r((e)=>{
                        if (l) ;
                        else if (0 === e) {
                            l = !0;
                            f(1);
                            if (a.length) i($779416f751461a71$var$push(a));
                            i(0);
                        } else if (0 === e.tag) n = e[0];
                        else if (a.length) {
                            var r = $779416f751461a71$var$push(a);
                            a = [];
                            i(r);
                        }
                    });
                } else {
                    a.push(e[0]);
                    if (!s) {
                        s = !0;
                        f(0);
                        n(0);
                    } else s = !1;
                }
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    f(1);
                    n(1);
                } else if (!l && !s) {
                    s = !0;
                    f(0);
                    n(0);
                }
            }));
        };
}
function $779416f751461a71$export$c28c8388be0ab31a(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $779416f751461a71$var$e;
            var n = $779416f751461a71$var$e;
            var s = !1;
            var l = !1;
            var u = !1;
            var o = !1;
            function applyInnerSource(e) {
                u = !0;
                e((e)=>{
                    if (0 === e) {
                        if (u) {
                            u = !1;
                            if (a.length) applyInnerSource(r(a.shift()));
                            else if (o) i(0);
                            else if (!s) {
                                s = !0;
                                f(0);
                            }
                        }
                    } else if (0 === e.tag) {
                        l = !1;
                        (n = e[0])(0);
                    } else if (u) {
                        i(e);
                        if (l) l = !1;
                        else n(0);
                    }
                });
            }
            t((e)=>{
                if (o) ;
                else if (0 === e) {
                    o = !0;
                    if (!u && !a.length) i(0);
                } else if (0 === e.tag) f = e[0];
                else {
                    s = !1;
                    if (u) a.push(e[0]);
                    else applyInnerSource(r(e[0]));
                }
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e) {
                    if (!o) {
                        o = !0;
                        f(1);
                    }
                    if (u) {
                        u = !1;
                        n(1);
                    }
                } else {
                    if (!o && !s) {
                        s = !0;
                        f(0);
                    }
                    if (u && !l) {
                        l = !0;
                        n(0);
                    }
                }
            }));
        };
}
function $779416f751461a71$export$b314777ae20abca9(e) {
    return $779416f751461a71$export$c28c8388be0ab31a($779416f751461a71$var$identity)(e);
}
function $779416f751461a71$export$ee1b3e54f0441b22(e) {
    return $779416f751461a71$export$b314777ae20abca9($779416f751461a71$export$571d59b505e6bb4e(e));
}
function $779416f751461a71$export$3dea766d36a8935f(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (!r(e[0])) a(0);
                else i(e);
            });
        };
}
function $779416f751461a71$export$871de8747c9eaa88(e) {
    return (r)=>(t)=>r((r)=>{
                if (0 === r || 0 === r.tag) t(r);
                else t($779416f751461a71$var$push(e(r[0])));
            });
}
function $779416f751461a71$export$6b9f6c0d32c093f9(r) {
    return (t)=>(i)=>{
            var a = [];
            var f = $779416f751461a71$var$e;
            var n = !1;
            var s = !1;
            t((t)=>{
                if (s) ;
                else if (0 === t) {
                    s = !0;
                    if (!a.length) i(0);
                } else if (0 === t.tag) f = t[0];
                else {
                    n = !1;
                    !function applyInnerSource(r) {
                        var t = $779416f751461a71$var$e;
                        r((e)=>{
                            if (0 === e) {
                                if (a.length) {
                                    var r = a.indexOf(t);
                                    if (r > -1) (a = a.slice()).splice(r, 1);
                                    if (!a.length) {
                                        if (s) i(0);
                                        else if (!n) {
                                            n = !0;
                                            f(0);
                                        }
                                    }
                                }
                            } else if (0 === e.tag) {
                                a.push(t = e[0]);
                                t(0);
                            } else if (a.length) {
                                i(e);
                                t(0);
                            }
                        });
                    }(r(t[0]));
                    if (!n) {
                        n = !0;
                        f(0);
                    }
                }
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e) {
                    if (!s) {
                        s = !0;
                        f(1);
                    }
                    for(var r = 0, t = a, i = a.length; r < i; r++)t[r](1);
                    a.length = 0;
                } else {
                    if (!s && !n) {
                        n = !0;
                        f(0);
                    } else n = !1;
                    for(var l = 0, u = a, o = a.length; l < o; l++)u[l](0);
                }
            }));
        };
}
function $779416f751461a71$export$bffa455ba8c619a6(e) {
    return $779416f751461a71$export$6b9f6c0d32c093f9($779416f751461a71$var$identity)(e);
}
function $779416f751461a71$export$4950aa0f605343fb(e) {
    return $779416f751461a71$export$bffa455ba8c619a6($779416f751461a71$export$571d59b505e6bb4e(e));
}
function $779416f751461a71$export$db4d2a4aed77becf(e) {
    return (r)=>(t)=>{
            var i = !1;
            r((r)=>{
                if (i) ;
                else if (0 === r) {
                    i = !0;
                    t(0);
                    e();
                } else if (0 === r.tag) {
                    var a = r[0];
                    t($779416f751461a71$var$start((r)=>{
                        if (1 === r) {
                            i = !0;
                            a(1);
                            e();
                        } else a(r);
                    }));
                } else t(r);
            });
        };
}
function $779416f751461a71$export$fff70a13d53402ec(e) {
    return (r)=>(t)=>{
            var i = !1;
            r((r)=>{
                if (i) ;
                else if (0 === r) {
                    i = !0;
                    t(0);
                } else if (0 === r.tag) {
                    var a = r[0];
                    t($779416f751461a71$var$start((e)=>{
                        if (1 === e) i = !0;
                        a(e);
                    }));
                } else {
                    e(r[0]);
                    t(r);
                }
            });
        };
}
function $779416f751461a71$export$aaa2d21dd8862419(e) {
    return (r)=>(t)=>r((r)=>{
                if (0 === r) t(0);
                else if (0 === r.tag) {
                    t(r);
                    e();
                } else t(r);
            });
}
function $779416f751461a71$export$4812e460280c6ef2(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = $779416f751461a71$var$e;
            var n;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    f(1);
                    i(0);
                } else if (0 === e.tag) a = e[0];
                else {
                    n = e[0];
                    if (!s) {
                        s = !0;
                        f(0);
                        a(0);
                    } else s = !1;
                }
            });
            r((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    a(1);
                    i(0);
                } else if (0 === e.tag) f = e[0];
                else if (void 0 !== n) {
                    var r = $779416f751461a71$var$push(n);
                    n = void 0;
                    i(r);
                }
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    a(1);
                    f(1);
                } else if (!l && !s) {
                    s = !0;
                    a(0);
                    f(0);
                }
            }));
        };
}
function $779416f751461a71$export$c87d910e63d22ed6(e, r) {
    return (t)=>(i)=>{
            var a = r;
            t((r)=>{
                if (0 === r) i(0);
                else if (0 === r.tag) i(r);
                else i($779416f751461a71$var$push(a = e(a, r[0])));
            });
        };
}
function $779416f751461a71$export$ed80d9de1d9df928(r) {
    var t = [];
    var i = $779416f751461a71$var$e;
    var a = !1;
    return (e)=>{
        t.push(e);
        if (1 === t.length) r((e)=>{
            if (0 === e) {
                for(var r = 0, f = t, n = t.length; r < n; r++)f[r](0);
                t.length = 0;
            } else if (0 === e.tag) i = e[0];
            else {
                a = !1;
                for(var s = 0, l = t, u = t.length; s < u; s++)l[s](e);
            }
        });
        e($779416f751461a71$var$start((r)=>{
            if (1 === r) {
                var f = t.indexOf(e);
                if (f > -1) (t = t.slice()).splice(f, 1);
                if (!t.length) i(1);
            } else if (!a) {
                a = !0;
                i(0);
            }
        }));
    };
}
function $779416f751461a71$export$955fc4a6c4be454d(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = r;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (f-- > 0) a(0);
                else i(e);
            });
        };
}
function $779416f751461a71$export$facc584867c26fde(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = $779416f751461a71$var$e;
            var n = !0;
            var s = !1;
            var l = !1;
            t((e)=>{
                if (l) ;
                else if (0 === e) {
                    l = !0;
                    if (n) f(1);
                    i(0);
                } else if (0 === e.tag) {
                    a = e[0];
                    r((e)=>{
                        if (0 === e) {
                            if (n) {
                                l = !0;
                                a(1);
                            }
                        } else if (0 === e.tag) (f = e[0])(0);
                        else {
                            n = !1;
                            f(1);
                        }
                    });
                } else if (!n) {
                    s = !1;
                    i(e);
                } else if (!s) {
                    s = !0;
                    a(0);
                    f(0);
                } else s = !1;
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e && !l) {
                    l = !0;
                    a(1);
                    if (n) f(1);
                } else if (!l && !s) {
                    s = !0;
                    if (n) f(0);
                    a(0);
                }
            }));
        };
}
function $779416f751461a71$export$175dedd748069215(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = !0;
            t((e)=>{
                if (0 === e) i(0);
                else if (0 === e.tag) {
                    a = e[0];
                    i(e);
                } else if (f) {
                    if (r(e[0])) a(0);
                    else {
                        f = !1;
                        i(e);
                    }
                } else i(e);
            });
        };
}
function $779416f751461a71$export$9f6ea8e48bc26eab(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = $779416f751461a71$var$e;
            var n = !1;
            var s = !1;
            var l = !1;
            var u = !1;
            t((t)=>{
                if (u) ;
                else if (0 === t) {
                    u = !0;
                    if (!l) i(0);
                } else if (0 === t.tag) a = t[0];
                else {
                    if (l) {
                        f(1);
                        f = $779416f751461a71$var$e;
                    }
                    if (!n) {
                        n = !0;
                        a(0);
                    } else n = !1;
                    !function applyInnerSource(e) {
                        l = !0;
                        e((e)=>{
                            if (!l) ;
                            else if (0 === e) {
                                l = !1;
                                if (u) i(0);
                                else if (!n) {
                                    n = !0;
                                    a(0);
                                }
                            } else if (0 === e.tag) {
                                s = !1;
                                (f = e[0])(0);
                            } else {
                                i(e);
                                if (!s) f(0);
                                else s = !1;
                            }
                        });
                    }(r(t[0]));
                }
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e) {
                    if (!u) {
                        u = !0;
                        a(1);
                    }
                    if (l) {
                        l = !1;
                        f(1);
                    }
                } else {
                    if (!u && !n) {
                        n = !0;
                        a(0);
                    }
                    if (l && !s) {
                        s = !0;
                        f(0);
                    }
                }
            }));
        };
}
function $779416f751461a71$export$6a45284a4b0bf33a(e) {
    return $779416f751461a71$export$9f6ea8e48bc26eab($779416f751461a71$var$identity)(e);
}
function $779416f751461a71$export$b7df5d561049483a(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = !1;
            var n = 0;
            t((e)=>{
                if (f) ;
                else if (0 === e) {
                    f = !0;
                    i(0);
                } else if (0 === e.tag) {
                    if (r <= 0) {
                        f = !0;
                        i(0);
                        e[0](1);
                    } else a = e[0];
                } else if (n++ < r) {
                    i(e);
                    if (!f && n >= r) {
                        f = !0;
                        i(0);
                        a(1);
                    }
                } else i(e);
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e && !f) {
                    f = !0;
                    a(1);
                } else if (0 === e && !f && n < r) a(0);
            }));
        };
}
function $779416f751461a71$export$1b47ad771ce5af5e(t) {
    return (i)=>(a)=>{
            var f = [];
            var n = $779416f751461a71$var$e;
            i((e)=>{
                if (0 === e) $779416f751461a71$export$571d59b505e6bb4e(f)(a);
                else if (0 === e.tag) {
                    if (t <= 0) {
                        e[0](1);
                        $779416f751461a71$export$571d59b505e6bb4e(f)(a);
                    } else (n = e[0])(0);
                } else {
                    if (f.length >= t && t) f.shift();
                    f.push(e[0]);
                    n(0);
                }
            });
        };
}
function $779416f751461a71$export$ac8dfd3a7ad06e80(r) {
    return (t)=>(i)=>{
            var a = $779416f751461a71$var$e;
            var f = $779416f751461a71$var$e;
            var n = !1;
            t((e)=>{
                if (n) ;
                else if (0 === e) {
                    n = !0;
                    f(1);
                    i(0);
                } else if (0 === e.tag) {
                    a = e[0];
                    r((e)=>{
                        if (0 === e) ;
                        else if (0 === e.tag) (f = e[0])(0);
                        else {
                            n = !0;
                            f(1);
                            a(1);
                            i(0);
                        }
                    });
                } else i(e);
            });
            i($779416f751461a71$var$start((e)=>{
                if (1 === e && !n) {
                    n = !0;
                    a(1);
                    f(1);
                } else if (!n) a(0);
            }));
        };
}
function $779416f751461a71$export$9384c7afe4015e42(r, t) {
    return (i)=>(a)=>{
            var f = $779416f751461a71$var$e;
            var n = !1;
            i((e)=>{
                if (n) ;
                else if (0 === e) {
                    n = !0;
                    a(0);
                } else if (0 === e.tag) {
                    f = e[0];
                    a(e);
                } else if (!r(e[0])) {
                    n = !0;
                    if (t) a(e);
                    a(0);
                    f(1);
                } else a(e);
            });
        };
}
function $779416f751461a71$export$61fc7d43ac8f84b0(e) {
    return (r)=>(t)=>{
            var i;
            var a = !1;
            var f = !1;
            r((r)=>{
                if (f) ;
                else if (0 === r) {
                    f = !0;
                    if (i) a = !0;
                    else t(0);
                } else if (0 === r.tag) {
                    var n = r[0];
                    t($779416f751461a71$var$start((e)=>{
                        if (1 === e && !f) {
                            f = !0;
                            a = !1;
                            if (i) clearTimeout(i);
                            n(1);
                        } else if (!f) n(0);
                    }));
                } else {
                    if (i) clearTimeout(i);
                    i = setTimeout(()=>{
                        i = void 0;
                        t(r);
                        if (a) t(0);
                    }, e(r[0]));
                }
            });
        };
}
function $779416f751461a71$export$1391212d75b2ee65(e) {
    return (r)=>(t)=>{
            var i = 0;
            r((r)=>{
                if (0 !== r && 0 === r.tag) t(r);
                else {
                    i++;
                    setTimeout(()=>{
                        if (i) {
                            i--;
                            t(r);
                        }
                    }, e);
                }
            });
        };
}
function $779416f751461a71$export$de363e709c412c8a(e) {
    return (r)=>(t)=>{
            var i = !1;
            var a;
            r((r)=>{
                if (0 === r) {
                    if (a) clearTimeout(a);
                    t(0);
                } else if (0 === r.tag) {
                    var f = r[0];
                    t($779416f751461a71$var$start((e)=>{
                        if (1 === e) {
                            if (a) clearTimeout(a);
                            f(1);
                        } else f(0);
                    }));
                } else if (!i) {
                    i = !0;
                    if (a) clearTimeout(a);
                    a = setTimeout(()=>{
                        a = void 0;
                        i = !1;
                    }, e(r[0]));
                    t(r);
                }
            });
        };
}
function $779416f751461a71$export$488013bae63b21da(e) {
    return (r)=>e()(r);
}
function $779416f751461a71$export$e073fccf36d78cc1(e) {
    return (r)=>{
        var t = e[$779416f751461a71$var$asyncIteratorSymbol()] && e[$779416f751461a71$var$asyncIteratorSymbol()]() || e;
        var i = !1;
        var a = !1;
        var f = !1;
        var n;
        r($779416f751461a71$var$start(async (e)=>{
            if (1 === e) {
                i = !0;
                if (t.return) t.return();
            } else if (a) f = !0;
            else {
                for(f = a = !0; f && !i;){
                    if ((n = await t.next()).done) {
                        i = !0;
                        if (t.return) await t.return();
                        r(0);
                    } else try {
                        f = !1;
                        r($779416f751461a71$var$push(n.value));
                    } catch (e) {
                        if (t.throw) {
                            if (i = !!(await t.throw(e)).done) r(0);
                        } else throw e;
                    }
                }
                a = !1;
            }
        }));
    };
}
function $779416f751461a71$export$dcccc29c315dd646(e) {
    if (e[Symbol.asyncIterator]) return $779416f751461a71$export$e073fccf36d78cc1(e);
    return (r)=>{
        var t = e[Symbol.iterator]();
        var i = !1;
        var a = !1;
        var f = !1;
        var n;
        r($779416f751461a71$var$start((e)=>{
            if (1 === e) {
                i = !0;
                if (t.return) t.return();
            } else if (a) f = !0;
            else {
                for(f = a = !0; f && !i;){
                    if ((n = t.next()).done) {
                        i = !0;
                        if (t.return) t.return();
                        r(0);
                    } else try {
                        f = !1;
                        r($779416f751461a71$var$push(n.value));
                    } catch (e) {
                        if (t.throw) {
                            if (i = !!t.throw(e).done) r(0);
                        } else throw e;
                    }
                }
                a = !1;
            }
        }));
    };
}
var $779416f751461a71$export$571d59b505e6bb4e = $779416f751461a71$export$dcccc29c315dd646;
function $779416f751461a71$export$5f36b26c3833b3ba(e) {
    return (r)=>{
        var t = !1;
        r($779416f751461a71$var$start((i)=>{
            if (1 === i) t = !0;
            else if (!t) {
                t = !0;
                r($779416f751461a71$var$push(e));
                r(0);
            }
        }));
    };
}
function $779416f751461a71$export$dd44f18ab656f3bb(e) {
    return (r)=>{
        var t = !1;
        var i = e({
            next (e) {
                if (!t) r($779416f751461a71$var$push(e));
            },
            complete () {
                if (!t) {
                    t = !0;
                    r(0);
                }
            }
        });
        r($779416f751461a71$var$start((e)=>{
            if (1 === e && !t) {
                t = !0;
                i();
            }
        }));
    };
}
function $779416f751461a71$export$c4c2a35435b4a722() {
    var e;
    var r;
    return {
        source: $779416f751461a71$export$ed80d9de1d9df928($779416f751461a71$export$dd44f18ab656f3bb((t)=>{
            e = t.next;
            r = t.complete;
            return $779416f751461a71$var$teardownPlaceholder;
        })),
        next (r) {
            if (e) e(r);
        },
        complete () {
            if (r) r();
        }
    };
}
var $779416f751461a71$export$6e22c362a0406a2c = (e)=>{
    var r = !1;
    e($779416f751461a71$var$start((t)=>{
        if (1 === t) r = !0;
        else if (!r) {
            r = !0;
            e(0);
        }
    }));
};
var $779416f751461a71$export$b3e22bcfd64c1022 = (r)=>{
    r($779416f751461a71$var$start($779416f751461a71$var$e));
};
function $779416f751461a71$export$3174cdbf0a0cbc84(e) {
    return $779416f751461a71$export$dd44f18ab656f3bb((r)=>{
        var t = 0;
        var i = setInterval(()=>r.next(t++), e);
        return ()=>clearInterval(i);
    });
}
function $779416f751461a71$export$abb8949c8e816a2c(e, r) {
    return $779416f751461a71$export$dd44f18ab656f3bb((t)=>{
        e.addEventListener(r, t.next);
        return ()=>e.removeEventListener(r, t.next);
    });
}
function $779416f751461a71$export$60f45028237c39d1(e) {
    return $779416f751461a71$export$dd44f18ab656f3bb((r)=>{
        e.then((e)=>{
            Promise.resolve(e).then(()=>{
                r.next(e);
                r.complete();
            });
        });
        return $779416f751461a71$var$teardownPlaceholder;
    });
}
function $779416f751461a71$export$ec068583843480e7(r) {
    return (t)=>{
        var i = $779416f751461a71$var$e;
        var a = !1;
        t((e)=>{
            if (0 === e) a = !0;
            else if (0 === e.tag) (i = e[0])(0);
            else if (!a) {
                r(e[0]);
                i(0);
            }
        });
        return {
            unsubscribe () {
                if (!a) {
                    a = !0;
                    i(1);
                }
            }
        };
    };
}
function $779416f751461a71$export$4b80e395e36b5a56(e) {
    return (r)=>{
        $779416f751461a71$export$ec068583843480e7(e)(r);
    };
}
function $779416f751461a71$export$89b472e03be495df(e) {
    $779416f751461a71$export$ec068583843480e7((e)=>{})(e);
}
var $779416f751461a71$var$t = {
    done: !0
};
var $779416f751461a71$export$b08ebdcf177203a0 = (r)=>{
    var i = [];
    var a = !1;
    var f = !1;
    var n = !1;
    var s = $779416f751461a71$var$e;
    var l;
    return {
        async next () {
            if (!f) {
                f = !0;
                r((e)=>{
                    if (a) ;
                    else if (0 === e) {
                        if (l) l = l($779416f751461a71$var$t);
                        a = !0;
                    } else if (0 === e.tag) {
                        n = !0;
                        (s = e[0])(0);
                    } else {
                        n = !1;
                        if (l) l = l({
                            value: e[0],
                            done: !1
                        });
                        else i.push(e[0]);
                    }
                });
            }
            if (a && !i.length) return $779416f751461a71$var$t;
            else if (!a && !n && i.length <= 1) {
                n = !0;
                s(0);
            }
            return i.length ? {
                value: i.shift(),
                done: !1
            } : new Promise((e)=>l = e);
        },
        async return () {
            if (!a) l = s(1);
            a = !0;
            return $779416f751461a71$var$t;
        },
        [$779416f751461a71$var$asyncIteratorSymbol()] () {
            return this;
        }
    };
};
function $779416f751461a71$export$45b10814cc054894(r) {
    var t = [];
    var i = $779416f751461a71$var$e;
    var a = !1;
    r((e)=>{
        if (0 === e) a = !0;
        else if (0 === e.tag) (i = e[0])(0);
        else {
            t.push(e[0]);
            i(0);
        }
    });
    if (!a) i(1);
    return t;
}
function $779416f751461a71$export$4dbaaf6c79705e6c(r) {
    return new Promise((t)=>{
        var i = $779416f751461a71$var$e;
        var a;
        r((e)=>{
            if (0 === e) Promise.resolve(a).then(t);
            else if (0 === e.tag) (i = e[0])(0);
            else {
                a = e[0];
                i(0);
            }
        });
    });
}
function $779416f751461a71$export$8901015135f2fb22(r) {
    var t = Object.keys(r).length;
    return (i)=>{
        var a = new Set;
        var f = Array.isArray(r) ? new Array(t).fill($779416f751461a71$var$e) : {};
        var n = Array.isArray(r) ? new Array(t) : {};
        var s = !1;
        var l = !1;
        var u = !1;
        var o = 0;
        var loop = function(v) {
            r[v]((c)=>{
                if (0 === c) {
                    if (o >= t - 1) {
                        u = !0;
                        i(0);
                    } else o++;
                } else if (0 === c.tag) f[v] = c[0];
                else if (!u) {
                    n[v] = c[0];
                    a.add(v);
                    if (!s && a.size < t) {
                        if (!l) {
                            for(var h in r)if (!a.has(h)) (f[h] || $779416f751461a71$var$e)(0);
                        } else l = !1;
                    } else {
                        s = !0;
                        l = !1;
                        i($779416f751461a71$var$push(Array.isArray(n) ? n.slice() : {
                            ...n
                        }));
                    }
                }
            });
        };
        for(var v in r)loop(v);
        i($779416f751461a71$var$start((e)=>{
            if (u) ;
            else if (1 === e) {
                u = !0;
                for(var r in f)f[r](1);
            } else if (!l) {
                l = !0;
                for(var t in f)f[t](0);
            }
        }));
    };
}
function $779416f751461a71$export$1be1fc439b849fdf(...e) {
    return $779416f751461a71$export$8901015135f2fb22(e);
}
function $779416f751461a71$export$4b2432e2d8723823(e) {
    return (r)=>{
        var t = (e[$779416f751461a71$var$observableSymbol()] ? e[$779416f751461a71$var$observableSymbol()]() : e).subscribe({
            next (e) {
                r($779416f751461a71$var$push(e));
            },
            complete () {
                r(0);
            },
            error (e) {
                throw e;
            }
        });
        r($779416f751461a71$var$start((e)=>{
            if (1 === e) t.unsubscribe();
        }));
    };
}
function $779416f751461a71$export$b5a21352c348fea9(r) {
    return {
        subscribe (t, i, a) {
            var f = "object" == typeof t ? t : {
                next: t,
                error: i,
                complete: a
            };
            var n = $779416f751461a71$var$e;
            var s = !1;
            r((e)=>{
                if (s) ;
                else if (0 === e) {
                    s = !0;
                    if (f.complete) f.complete();
                } else if (0 === e.tag) (n = e[0])(0);
                else {
                    f.next(e[0]);
                    n(0);
                }
            });
            var l = {
                closed: !1,
                unsubscribe () {
                    l.closed = !0;
                    s = !0;
                    n(1);
                }
            };
            return l;
        },
        [$779416f751461a71$var$observableSymbol()] () {
            return this;
        }
    };
}
function $779416f751461a71$export$24d5d3bb0066f63a(e) {
    return (r)=>{
        e(0, (e, t)=>{
            if (0 === e) r($779416f751461a71$var$start((e)=>{
                t(e + 1);
            }));
            else if (1 === e) r($779416f751461a71$var$push(t));
            else r(0);
        });
    };
}
function $779416f751461a71$export$95003814f91c442(e) {
    return (r, t)=>{
        if (0 === r) e((e)=>{
            if (0 === e) t(2);
            else if (0 === e.tag) t(0, (r)=>{
                if (r < 3) e[0](r - 1);
            });
            else t(1, e[0]);
        });
    };
}
var $779416f751461a71$export$a4627e546088548d = (...e)=>{
    var r = e[0];
    for(var t = 1, i = e.length; t < i; t++)r = e[t](r);
    return r;
};


var $d5e3207b2716e246$var$rehydrateGraphQlError = (r)=>{
    if (r && r.message && (r.extensions || "GraphQLError" === r.name)) return r;
    else if ("object" == typeof r && r.message) return new (0, $66ea79e9ce71ac40$export$92d6ed0888e7cb7f)(r.message, r.nodes, r.source, r.positions, r.path, r, r.extensions || {});
    else return new (0, $66ea79e9ce71ac40$export$92d6ed0888e7cb7f)(r);
};
class $d5e3207b2716e246$export$e7094788287c5e9b extends Error {
    constructor(e){
        var r = (e.graphQLErrors || []).map($d5e3207b2716e246$var$rehydrateGraphQlError);
        var t = ((e, r)=>{
            var t = "";
            if (e) return `[Network] ${e.message}`;
            if (r) for (var a of r){
                if (t) t += "\n";
                t += `[GraphQL] ${a.message}`;
            }
            return t;
        })(e.networkError, r);
        super(t);
        this.name = "CombinedError";
        this.message = t;
        this.graphQLErrors = r;
        this.networkError = e.networkError;
        this.response = e.response;
    }
    toString() {
        return this.message;
    }
}
var $d5e3207b2716e246$var$phash = (e, r)=>{
    var t = 0 | (r || 5381);
    for(var a = 0, o = 0 | e.length; a < o; a++)t = (t << 5) + t + e.charCodeAt(a);
    return t;
};
var $d5e3207b2716e246$var$i = new Set;
var $d5e3207b2716e246$var$f = new WeakMap;
var $d5e3207b2716e246$var$stringify = (e)=>{
    if (null === e || $d5e3207b2716e246$var$i.has(e)) return "null";
    else if ("object" != typeof e) return JSON.stringify(e) || "";
    else if (e.toJSON) return $d5e3207b2716e246$var$stringify(e.toJSON());
    else if (Array.isArray(e)) {
        var r = "[";
        for (var t of e){
            if (r.length > 1) r += ",";
            r += $d5e3207b2716e246$var$stringify(t) || "null";
        }
        return r += "]";
    } else if ($d5e3207b2716e246$var$l !== $d5e3207b2716e246$var$NoopConstructor && e instanceof $d5e3207b2716e246$var$l || $d5e3207b2716e246$var$c !== $d5e3207b2716e246$var$NoopConstructor && e instanceof $d5e3207b2716e246$var$c) return "null";
    var a = Object.keys(e).sort();
    if (!a.length && e.constructor && Object.getPrototypeOf(e).constructor !== Object.prototype.constructor) {
        var o = $d5e3207b2716e246$var$f.get(e) || Math.random().toString(36).slice(2);
        $d5e3207b2716e246$var$f.set(e, o);
        return $d5e3207b2716e246$var$stringify({
            __key: o
        });
    }
    $d5e3207b2716e246$var$i.add(e);
    var n = "{";
    for (var s of a){
        var d = $d5e3207b2716e246$var$stringify(e[s]);
        if (d) {
            if (n.length > 1) n += ",";
            n += $d5e3207b2716e246$var$stringify(s) + ":" + d;
        }
    }
    $d5e3207b2716e246$var$i.delete(e);
    return n += "}";
};
var $d5e3207b2716e246$var$extract = (e, r, t)=>{
    if (null == t || "object" != typeof t || t.toJSON || $d5e3207b2716e246$var$i.has(t)) ;
    else if (Array.isArray(t)) for(var a = 0, o = t.length; a < o; a++)$d5e3207b2716e246$var$extract(e, `${r}.${a}`, t[a]);
    else if (t instanceof $d5e3207b2716e246$var$l || t instanceof $d5e3207b2716e246$var$c) e.set(r, t);
    else {
        $d5e3207b2716e246$var$i.add(t);
        for (var n of Object.keys(t))$d5e3207b2716e246$var$extract(e, `${r}.${n}`, t[n]);
    }
};
var $d5e3207b2716e246$export$23f2a1d2818174ef = (e)=>{
    $d5e3207b2716e246$var$i.clear();
    return $d5e3207b2716e246$var$stringify(e);
};
class $d5e3207b2716e246$var$NoopConstructor {
}
var $d5e3207b2716e246$var$l = "undefined" != typeof File ? File : $d5e3207b2716e246$var$NoopConstructor;
var $d5e3207b2716e246$var$c = "undefined" != typeof Blob ? Blob : $d5e3207b2716e246$var$NoopConstructor;
var $d5e3207b2716e246$var$d = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;
var $d5e3207b2716e246$var$v = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g;
var $d5e3207b2716e246$var$replaceOutsideStrings = (e, r)=>r % 2 == 0 ? e.replace($d5e3207b2716e246$var$v, "\n") : e;
var $d5e3207b2716e246$var$sanitizeDocument = (e)=>e.split($d5e3207b2716e246$var$d).map($d5e3207b2716e246$var$replaceOutsideStrings).join("").trim();
var $d5e3207b2716e246$var$p = new Map;
var $d5e3207b2716e246$var$u = new Map;
var $d5e3207b2716e246$export$2408f22a0fab9ae5 = (e)=>{
    var t;
    if ("string" == typeof e) t = $d5e3207b2716e246$var$sanitizeDocument(e);
    else if (e.loc && $d5e3207b2716e246$var$u.get(e.__key) === e) t = e.loc.source.body;
    else {
        t = $d5e3207b2716e246$var$p.get(e) || $d5e3207b2716e246$var$sanitizeDocument((0, $66ea79e9ce71ac40$export$c2d084dc44961371)(e));
        $d5e3207b2716e246$var$p.set(e, t);
    }
    if ("string" != typeof e && !e.loc) e.loc = {
        start: 0,
        end: t.length,
        source: {
            body: t,
            name: "gql",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    };
    return t;
};
var $d5e3207b2716e246$var$hashDocument = (e)=>{
    var r = $d5e3207b2716e246$var$phash($d5e3207b2716e246$export$2408f22a0fab9ae5(e));
    if (e.definitions) {
        var t = $d5e3207b2716e246$var$getOperationName(e);
        if (t) r = $d5e3207b2716e246$var$phash(`\n# ${t}`, r);
    }
    return r;
};
var $d5e3207b2716e246$export$342063e11d6c3cad = (e)=>{
    var r;
    var a;
    if ("string" == typeof e) {
        r = $d5e3207b2716e246$var$hashDocument(e);
        a = $d5e3207b2716e246$var$u.get(r) || (0, $66ea79e9ce71ac40$export$98e6a39c04603d36)(e, {
            noLocation: !0
        });
    } else {
        r = e.__key || $d5e3207b2716e246$var$hashDocument(e);
        a = $d5e3207b2716e246$var$u.get(r) || e;
    }
    if (!a.loc) $d5e3207b2716e246$export$2408f22a0fab9ae5(a);
    a.__key = r;
    $d5e3207b2716e246$var$u.set(r, a);
    return a;
};
var $d5e3207b2716e246$export$dda1d9f60106f0e9 = (e, r, t)=>{
    var a = r || {};
    var o = $d5e3207b2716e246$export$342063e11d6c3cad(e);
    var n = $d5e3207b2716e246$export$23f2a1d2818174ef(a);
    var s = o.__key;
    if ("{}" !== n) s = $d5e3207b2716e246$var$phash(n, s);
    return {
        key: s,
        query: o,
        variables: a,
        extensions: t
    };
};
var $d5e3207b2716e246$var$getOperationName = (e)=>{
    for (var r of e.definitions){
        if (r.kind === (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).OPERATION_DEFINITION) return r.name ? r.name.value : void 0;
    }
};
var $d5e3207b2716e246$export$39b482c5e57630a8 = (e)=>{
    for (var r of e.definitions){
        if (r.kind === (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).OPERATION_DEFINITION) return r.operation;
    }
};
var $d5e3207b2716e246$export$953cecd6e717a553 = (e, r, t)=>{
    if (!("data" in r || "errors" in r && Array.isArray(r.errors))) throw new Error("No Content");
    var a = "subscription" === e.kind;
    return {
        operation: e,
        data: r.data,
        error: Array.isArray(r.errors) ? new $d5e3207b2716e246$export$e7094788287c5e9b({
            graphQLErrors: r.errors,
            response: t
        }) : void 0,
        extensions: r.extensions ? {
            ...r.extensions
        } : void 0,
        hasNext: null == r.hasNext ? a : r.hasNext,
        stale: !1
    };
};
var $d5e3207b2716e246$var$deepMerge = (e, r)=>{
    if ("object" == typeof e && null != e) {
        if (!e.constructor || e.constructor === Object || Array.isArray(e)) {
            e = Array.isArray(e) ? [
                ...e
            ] : {
                ...e
            };
            for (var t of Object.keys(r))e[t] = $d5e3207b2716e246$var$deepMerge(e[t], r[t]);
            return e;
        }
    }
    return r;
};
var $d5e3207b2716e246$export$db3b6bfb95261072 = (e, r, t, a)=>{
    var o = e.error ? e.error.graphQLErrors : [];
    var n = !!e.extensions || !!(r.payload || r).extensions;
    var s = {
        ...e.extensions,
        ...(r.payload || r).extensions
    };
    var i = r.incremental;
    if ("path" in r) i = [
        r
    ];
    var f = {
        data: e.data
    };
    if (i) {
        var _loop = function(e) {
            if (Array.isArray(e.errors)) o.push(...e.errors);
            if (e.extensions) {
                Object.assign(s, e.extensions);
                n = !0;
            }
            var r = "data";
            var t = f;
            var i = [];
            if (e.path) i = e.path;
            else if (a) {
                var l = a.find((r)=>r.id === e.id);
                if (e.subPath) i = [
                    ...l.path,
                    ...e.subPath
                ];
                else i = l.path;
            }
            for(var c = 0, d = i.length; c < d; r = i[c++])t = t[r] = Array.isArray(t[r]) ? [
                ...t[r]
            ] : {
                ...t[r]
            };
            if (e.items) {
                var v = +r >= 0 ? r : 0;
                for(var p = 0, u = e.items.length; p < u; p++)t[v + p] = $d5e3207b2716e246$var$deepMerge(t[v + p], e.items[p]);
            } else if (void 0 !== e.data) t[r] = $d5e3207b2716e246$var$deepMerge(t[r], e.data);
        };
        for (var l of i)_loop(l);
    } else {
        f.data = (r.payload || r).data || e.data;
        o = r.errors || r.payload && r.payload.errors || o;
    }
    return {
        operation: e.operation,
        data: f.data,
        error: o.length ? new $d5e3207b2716e246$export$e7094788287c5e9b({
            graphQLErrors: o,
            response: t
        }) : void 0,
        extensions: n ? s : void 0,
        hasNext: null != r.hasNext ? r.hasNext : e.hasNext,
        stale: !1
    };
};
var $d5e3207b2716e246$export$8b22cf2602fb60ce = (e, r, t)=>({
        operation: e,
        data: void 0,
        error: new $d5e3207b2716e246$export$e7094788287c5e9b({
            networkError: r,
            response: t
        }),
        extensions: void 0,
        hasNext: !1,
        stale: !1
    });
function $d5e3207b2716e246$export$407448d2b89b1813(e) {
    var r = {
        query: void 0,
        documentId: void 0,
        operationName: $d5e3207b2716e246$var$getOperationName(e.query),
        variables: e.variables || void 0,
        extensions: e.extensions
    };
    if ("documentId" in e.query && e.query.documentId && (!e.query.definitions || !e.query.definitions.length)) r.documentId = e.query.documentId;
    else if (!e.extensions || !e.extensions.persistedQuery || e.extensions.persistedQuery.miss) r.query = $d5e3207b2716e246$export$2408f22a0fab9ae5(e.query);
    return r;
}
var $d5e3207b2716e246$export$4368d992c4eafac0 = (e, r)=>{
    var t = "query" === e.kind && e.context.preferGetMethod;
    if (!t || !r) return e.context.url;
    var a = $d5e3207b2716e246$var$splitOutSearchParams(e.context.url);
    for(var o in r){
        var n = r[o];
        if (n) a[1].set(o, "object" == typeof n ? $d5e3207b2716e246$export$23f2a1d2818174ef(n) : n);
    }
    var s = a.join("?");
    if (s.length > 2047 && "force" !== t) {
        e.context.preferGetMethod = !1;
        return e.context.url;
    }
    return s;
};
var $d5e3207b2716e246$var$splitOutSearchParams = (e)=>{
    var r = e.indexOf("?");
    return r > -1 ? [
        e.slice(0, r),
        new URLSearchParams(e.slice(r + 1))
    ] : [
        e,
        new URLSearchParams
    ];
};
var $d5e3207b2716e246$var$serializeBody = (e, r)=>{
    if (r && !("query" === e.kind && !!e.context.preferGetMethod)) {
        var t = $d5e3207b2716e246$export$23f2a1d2818174ef(r);
        var a = ((e)=>{
            var r = new Map;
            if ($d5e3207b2716e246$var$l !== $d5e3207b2716e246$var$NoopConstructor || $d5e3207b2716e246$var$c !== $d5e3207b2716e246$var$NoopConstructor) {
                $d5e3207b2716e246$var$i.clear();
                $d5e3207b2716e246$var$extract(r, "variables", e);
            }
            return r;
        })(r.variables);
        if (a.size) {
            var o = new FormData;
            o.append("operations", t);
            o.append("map", $d5e3207b2716e246$export$23f2a1d2818174ef({
                ...[
                    ...a.keys()
                ].map((e)=>[
                        e
                    ])
            }));
            var n = 0;
            for (var s of a.values())o.append("" + n++, s);
            return o;
        }
        return t;
    }
};
var $d5e3207b2716e246$export$f1e1789686576879 = (e, r)=>{
    var t = {
        accept: "subscription" === e.kind ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
    };
    var a = ("function" == typeof e.context.fetchOptions ? e.context.fetchOptions() : e.context.fetchOptions) || {};
    if (a.headers) {
        if (((e)=>"has" in e && !Object.keys(e).length)(a.headers)) a.headers.forEach((e, r)=>{
            t[r] = e;
        });
        else if (Array.isArray(a.headers)) a.headers.forEach((e, r)=>{
            if (Array.isArray(e)) {
                if (t[e[0]]) t[e[0]] = `${t[e[0]]},${e[1]}`;
                else t[e[0]] = e[1];
            } else t[r] = e;
        });
        else for(var o in a.headers)t[o.toLowerCase()] = a.headers[o];
    }
    var n = $d5e3207b2716e246$var$serializeBody(e, r);
    if ("string" == typeof n && !t["content-type"]) t["content-type"] = "application/json";
    return {
        ...a,
        method: n ? "POST" : "GET",
        body: n,
        headers: t
    };
};
var $d5e3207b2716e246$var$y = "undefined" != typeof TextDecoder ? new TextDecoder : null;
var $d5e3207b2716e246$var$h = /boundary="?([^=";]+)"?/i;
var $d5e3207b2716e246$var$m = /data: ?([^\n]+)/;
var $d5e3207b2716e246$var$toString = (e)=>"Buffer" === e.constructor.name ? e.toString() : $d5e3207b2716e246$var$y.decode(e);
async function* $d5e3207b2716e246$var$streamBody(e) {
    if (e.body[Symbol.asyncIterator]) for await (var r of e.body)yield $d5e3207b2716e246$var$toString(r);
    else {
        var t = e.body.getReader();
        var a;
        try {
            while(!(a = await t.read()).done)yield $d5e3207b2716e246$var$toString(a.value);
        } finally{
            t.cancel();
        }
    }
}
async function* $d5e3207b2716e246$var$split(e, r) {
    var t = "";
    var a;
    for await (var o of e){
        t += o;
        while((a = t.indexOf(r)) > -1){
            yield t.slice(0, a);
            t = t.slice(a + r.length);
        }
    }
}
async function* $d5e3207b2716e246$var$fetchOperation(e, r, t) {
    var a = !0;
    var o = null;
    var n;
    try {
        yield await Promise.resolve();
        var s = (n = await (e.context.fetch || fetch)(r, t)).headers.get("Content-Type") || "";
        var i;
        if (/multipart\/mixed/i.test(s)) i = async function* parseMultipartMixed(e, r) {
            var t = e.match($d5e3207b2716e246$var$h);
            var a = "--" + (t ? t[1] : "-");
            var o = !0;
            var n;
            for await (var s of $d5e3207b2716e246$var$split($d5e3207b2716e246$var$streamBody(r), "\r\n" + a)){
                if (o) {
                    o = !1;
                    var i = s.indexOf(a);
                    if (i > -1) s = s.slice(i + a.length);
                    else continue;
                }
                try {
                    yield n = JSON.parse(s.slice(s.indexOf("\r\n\r\n") + 4));
                } catch (e) {
                    if (!n) throw e;
                }
                if (n && !1 === n.hasNext) break;
            }
            if (n && !1 !== n.hasNext) yield {
                hasNext: !1
            };
        }(s, n);
        else if (/text\/event-stream/i.test(s)) i = async function* parseEventStream(e) {
            var r;
            for await (var t of $d5e3207b2716e246$var$split($d5e3207b2716e246$var$streamBody(e), "\n\n")){
                var a = t.match($d5e3207b2716e246$var$m);
                if (a) {
                    var o = a[1];
                    try {
                        yield r = JSON.parse(o);
                    } catch (e) {
                        if (!r) throw e;
                    }
                    if (r && !1 === r.hasNext) break;
                }
            }
            if (r && !1 !== r.hasNext) yield {
                hasNext: !1
            };
        }(n);
        else if (!/text\//i.test(s)) i = async function* parseJSON(e) {
            yield JSON.parse(await e.text());
        }(n);
        else i = async function* parseMaybeJSON(e) {
            var r = await e.text();
            try {
                var t = JSON.parse(r);
                yield t;
            } catch (e) {
                throw new Error(r);
            }
        }(n);
        var f;
        for await (var l of i){
            if (l.pending && !o) f = l.pending;
            else if (l.pending) f = [
                ...f,
                ...l.pending
            ];
            o = o ? $d5e3207b2716e246$export$db3b6bfb95261072(o, l, n, f) : $d5e3207b2716e246$export$953cecd6e717a553(e, l, n);
            a = !1;
            yield o;
            a = !0;
        }
        if (!o) yield o = $d5e3207b2716e246$export$953cecd6e717a553(e, {}, n);
    } catch (r) {
        if (!a) throw r;
        yield $d5e3207b2716e246$export$8b22cf2602fb60ce(e, n && (n.status < 200 || n.status >= 300) && n.statusText ? new Error(n.statusText) : r, n);
    }
}
function $d5e3207b2716e246$export$2d1720544b23b823(e, r, t) {
    var a;
    if ("undefined" != typeof AbortController) t.signal = (a = new AbortController).signal;
    return (0, $779416f751461a71$export$db4d2a4aed77becf)(()=>{
        if (a) a.abort();
    })((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>!!e)((0, $779416f751461a71$export$e073fccf36d78cc1)($d5e3207b2716e246$var$fetchOperation(e, r, t))));
}



var $29e2e825db8416d8$var$collectTypes = (e, r)=>{
    if (Array.isArray(e)) for (var t of e)$29e2e825db8416d8$var$collectTypes(t, r);
    else if ("object" == typeof e && null !== e) {
        for(var n in e)if ("__typename" === n && "string" == typeof e[n]) r.add(e[n]);
        else $29e2e825db8416d8$var$collectTypes(e[n], r);
    }
    return r;
};
var $29e2e825db8416d8$var$formatNode = (r)=>{
    if ("definitions" in r) {
        var t = [];
        for (var n of r.definitions){
            var a = $29e2e825db8416d8$var$formatNode(n);
            t.push(a);
        }
        return {
            ...r,
            definitions: t
        };
    }
    if ("directives" in r && r.directives && r.directives.length) {
        var o = [];
        var i = {};
        for (var s of r.directives){
            var c = s.name.value;
            if ("_" !== c[0]) o.push(s);
            else c = c.slice(1);
            i[c] = s;
        }
        r = {
            ...r,
            directives: o,
            _directives: i
        };
    }
    if ("selectionSet" in r) {
        var u = [];
        var p = r.kind === (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).OPERATION_DEFINITION;
        if (r.selectionSet) {
            for (var d of r.selectionSet.selections || []){
                p = p || d.kind === (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).FIELD && "__typename" === d.name.value && !d.alias;
                var v = $29e2e825db8416d8$var$formatNode(d);
                u.push(v);
            }
            if (!p) u.push({
                kind: (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).FIELD,
                name: {
                    kind: (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).NAME,
                    value: "__typename"
                },
                _generated: !0
            });
            return {
                ...r,
                selectionSet: {
                    ...r.selectionSet,
                    selections: u
                }
            };
        }
    }
    return r;
};
var $29e2e825db8416d8$var$I = new Map;
var $29e2e825db8416d8$export$4d94eb8deda64786 = (e)=>{
    var t = (0, $d5e3207b2716e246$export$342063e11d6c3cad)(e);
    var n = $29e2e825db8416d8$var$I.get(t.__key);
    if (!n) {
        $29e2e825db8416d8$var$I.set(t.__key, n = $29e2e825db8416d8$var$formatNode(t));
        Object.defineProperty(n, "__key", {
            value: t.__key,
            enumerable: !1
        });
    }
    return n;
};
function $29e2e825db8416d8$var$withPromise(e) {
    var source$ = (r)=>e(r);
    source$.toPromise = ()=>(0, $779416f751461a71$export$4dbaaf6c79705e6c)((0, $779416f751461a71$export$b7df5d561049483a)(1)((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>!e.stale && !e.hasNext)(source$)));
    source$.then = (e, r)=>source$.toPromise().then(e, r);
    source$.subscribe = (e)=>(0, $779416f751461a71$export$ec068583843480e7)(e)(source$);
    return source$;
}
function $29e2e825db8416d8$export$dac456ae68957b8f(e, r, t) {
    return {
        ...r,
        kind: e,
        context: r.context ? {
            ...r.context,
            ...t
        } : t || r.context
    };
}
var $29e2e825db8416d8$var$addMetadata = (e, r)=>$29e2e825db8416d8$export$dac456ae68957b8f(e.kind, e, {
        meta: {
            ...e.context.meta,
            ...r
        }
    });
var $29e2e825db8416d8$var$noop = ()=>{};
function $29e2e825db8416d8$export$72e4926bf8358653(n) {
    var a = new Map;
    var o = [];
    var i = [];
    var s = Array.isArray(n) ? n[0] : n || "";
    for(var c = 1; c < arguments.length; c++){
        var u = arguments[c];
        if (u && u.definitions) i.push(u);
        else s += u;
        s += arguments[0][c];
    }
    i.unshift((0, $d5e3207b2716e246$export$342063e11d6c3cad)(s));
    for (var p of i){
        for (var d of p.definitions)if (d.kind === (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).FRAGMENT_DEFINITION) {
            var v = d.name.value;
            var f = (0, $d5e3207b2716e246$export$2408f22a0fab9ae5)(d);
            if (!a.has(v)) {
                a.set(v, f);
                o.push(d);
            }
        } else o.push(d);
    }
    return (0, $d5e3207b2716e246$export$342063e11d6c3cad)({
        kind: (0, $66ea79e9ce71ac40$export$a84bdc57c5122798).DOCUMENT,
        definitions: o
    });
}
var $29e2e825db8416d8$var$shouldSkip = ({ kind: e })=>"mutation" !== e && "query" !== e;
var $29e2e825db8416d8$var$mapTypeNames = (e)=>{
    var r = $29e2e825db8416d8$export$4d94eb8deda64786(e.query);
    if (r !== e.query) {
        var t = $29e2e825db8416d8$export$dac456ae68957b8f(e.kind, e);
        t.query = r;
        return t;
    } else return e;
};
var $29e2e825db8416d8$export$de01951d82452cab = ({ forward: e, client: r, dispatchDebug: t })=>{
    var a = new Map;
    var o = new Map;
    var isOperationCached = (e)=>"query" === e.kind && "network-only" !== e.context.requestPolicy && ("cache-only" === e.context.requestPolicy || a.has(e.key));
    return (i)=>{
        var s = (0, $779416f751461a71$export$871de8747c9eaa88)((e)=>{
            var o = a.get(e.key);
            var i = o || (0, $d5e3207b2716e246$export$953cecd6e717a553)(e, {
                data: null
            });
            i = {
                ...i,
                operation: e
            };
            if ("cache-and-network" === e.context.requestPolicy) {
                i.stale = !0;
                $29e2e825db8416d8$var$reexecuteOperation(r, e);
            }
            return i;
        })((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>!$29e2e825db8416d8$var$shouldSkip(e) && isOperationCached(e))(i));
        var c = (0, $779416f751461a71$export$fff70a13d53402ec)((e)=>{
            var { operation: n } = e;
            if (!n) return;
            var i = n.context.additionalTypenames || [];
            if ("subscription" !== e.operation.kind) i = ((e)=>[
                    ...$29e2e825db8416d8$var$collectTypes(e, new Set)
                ])(e.data).concat(i);
            if ("mutation" === e.operation.kind || "subscription" === e.operation.kind) {
                var s = new Set;
                for(var c = 0; c < i.length; c++){
                    var u = i[c];
                    var p = o.get(u);
                    if (!p) o.set(u, p = new Set);
                    for (var d of p.values())s.add(d);
                    p.clear();
                }
                for (var v of s.values())if (a.has(v)) {
                    n = a.get(v).operation;
                    a.delete(v);
                    $29e2e825db8416d8$var$reexecuteOperation(r, n);
                }
            } else if ("query" === n.kind && e.data) {
                a.set(n.key, e);
                for(var f = 0; f < i.length; f++){
                    var l = i[f];
                    var h = o.get(l);
                    if (!h) o.set(l, h = new Set);
                    h.add(n.key);
                }
            }
        })(e((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"query" !== e.kind || "cache-only" !== e.context.requestPolicy)((0, $779416f751461a71$export$871de8747c9eaa88)((e)=>e)((0, $779416f751461a71$export$4950aa0f605343fb)([
            (0, $779416f751461a71$export$871de8747c9eaa88)($29e2e825db8416d8$var$mapTypeNames)((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>!$29e2e825db8416d8$var$shouldSkip(e) && !isOperationCached(e))(i)),
            (0, $779416f751461a71$export$3dea766d36a8935f)((e)=>$29e2e825db8416d8$var$shouldSkip(e))(i)
        ])))));
        return (0, $779416f751461a71$export$4950aa0f605343fb)([
            s,
            c
        ]);
    };
};
var $29e2e825db8416d8$var$reexecuteOperation = (e, r)=>e.reexecuteOperation($29e2e825db8416d8$export$dac456ae68957b8f(r.kind, r, {
        requestPolicy: "network-only"
    }));
var $29e2e825db8416d8$var$T = new Set;
var $29e2e825db8416d8$export$5487dac036b20ecc = (e = {})=>{
    var r = !!e.staleWhileRevalidate;
    var t = !!e.includeExtensions;
    var n = {};
    var o = [];
    var invalidate = (e)=>{
        o.push(e.operation.key);
        if (1 === o.length) Promise.resolve().then(()=>{
            var e;
            while(e = o.shift())n[e] = null;
        });
    };
    var ssr = ({ client: o, forward: i })=>(s)=>{
            var c = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
            var u = i((0, $779416f751461a71$export$871de8747c9eaa88)($29e2e825db8416d8$var$mapTypeNames)((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" === e.kind || !n[e.key] || !!n[e.key].hasNext || "network-only" === e.context.requestPolicy)(s)));
            var p = (0, $779416f751461a71$export$871de8747c9eaa88)((e)=>{
                var i = ((e, r, t)=>({
                        operation: e,
                        data: r.data ? JSON.parse(r.data) : void 0,
                        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
                        error: r.error ? new (0, $d5e3207b2716e246$export$e7094788287c5e9b)({
                            networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
                            graphQLErrors: r.error.graphQLErrors
                        }) : void 0,
                        stale: !1,
                        hasNext: !!r.hasNext
                    }))(e, n[e.key], t);
                if (r && !$29e2e825db8416d8$var$T.has(e.key)) {
                    i.stale = !0;
                    $29e2e825db8416d8$var$T.add(e.key);
                    $29e2e825db8416d8$var$reexecuteOperation(o, e);
                }
                return {
                    ...i,
                    operation: e
                };
            })((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" !== e.kind && !!n[e.key] && "network-only" !== e.context.requestPolicy)(s));
            if (!c) u = (0, $779416f751461a71$export$fff70a13d53402ec)((e)=>{
                var { operation: r } = e;
                if ("mutation" !== r.kind) {
                    var a = ((e, r)=>{
                        var t = {
                            data: JSON.stringify(e.data),
                            hasNext: e.hasNext
                        };
                        if (void 0 !== e.data) t.data = JSON.stringify(e.data);
                        if (r && void 0 !== e.extensions) t.extensions = JSON.stringify(e.extensions);
                        if (e.error) {
                            t.error = {
                                graphQLErrors: e.error.graphQLErrors.map((e)=>{
                                    if (!e.path && !e.extensions) return e.message;
                                    return {
                                        message: e.message,
                                        path: e.path,
                                        extensions: e.extensions
                                    };
                                })
                            };
                            if (e.error.networkError) t.error.networkError = "" + e.error.networkError;
                        }
                        return t;
                    })(e, t);
                    n[r.key] = a;
                }
            })(u);
            else p = (0, $779416f751461a71$export$fff70a13d53402ec)(invalidate)(p);
            return (0, $779416f751461a71$export$4950aa0f605343fb)([
                u,
                p
            ]);
        };
    ssr.restoreData = (e)=>{
        for(var r in e)if (null !== n[r]) n[r] = e[r];
    };
    ssr.extractData = ()=>{
        var e = {};
        for(var r in n)if (null != n[r]) e[r] = n[r];
        return e;
    };
    if (e && e.initialState) ssr.restoreData(e.initialState);
    return ssr;
};
var $29e2e825db8416d8$export$d2bda267fe4a032e = ({ forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t })=>({ client: a, forward: i })=>{
        var u = t || ((e)=>"subscription" === e.kind || !!r && ("query" === e.kind || "mutation" === e.kind));
        return (r)=>{
            var t = (0, $779416f751461a71$export$6b9f6c0d32c093f9)((t)=>{
                var { key: i } = t;
                var u = (0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" === e.kind && e.key === i)(r);
                return (0, $779416f751461a71$export$ac8dfd3a7ad06e80)(u)(((r)=>{
                    var t = e((0, $d5e3207b2716e246$export$407448d2b89b1813)(r), r);
                    return (0, $779416f751461a71$export$dd44f18ab656f3bb)((e)=>{
                        var o = !1;
                        var i;
                        var u;
                        function nextResult(t) {
                            e.next(u = u ? (0, $d5e3207b2716e246$export$db3b6bfb95261072)(u, t) : (0, $d5e3207b2716e246$export$953cecd6e717a553)(r, t));
                        }
                        Promise.resolve().then(()=>{
                            if (o) return;
                            i = t.subscribe({
                                next: nextResult,
                                error (t) {
                                    if (Array.isArray(t)) nextResult({
                                        errors: t
                                    });
                                    else e.next((0, $d5e3207b2716e246$export$8b22cf2602fb60ce)(r, t));
                                    e.complete();
                                },
                                complete () {
                                    if (!o) {
                                        o = !0;
                                        if ("subscription" === r.kind) a.reexecuteOperation($29e2e825db8416d8$export$dac456ae68957b8f("teardown", r, r.context));
                                        if (u && u.hasNext) nextResult({
                                            hasNext: !1
                                        });
                                        e.complete();
                                    }
                                }
                            });
                        });
                        return ()=>{
                            o = !0;
                            if (i) i.unsubscribe();
                        };
                    });
                })(t));
            })((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" !== e.kind && u(e))(r));
            var p = i((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" === e.kind || !u(e))(r));
            return (0, $779416f751461a71$export$4950aa0f605343fb)([
                t,
                p
            ]);
        };
    };
var $29e2e825db8416d8$export$f088b66ceb324131 = ({ forward: e })=>{
    var r, e1, e2;
    return (r)=>e(r);
};
var $29e2e825db8416d8$export$7fed09527e654bc9 = ({ forward: e, dispatchDebug: r })=>(t)=>{
        var n = (0, $779416f751461a71$export$6b9f6c0d32c093f9)((e)=>{
            var n = (0, $d5e3207b2716e246$export$407448d2b89b1813)(e);
            var a = (0, $d5e3207b2716e246$export$4368d992c4eafac0)(e, n);
            var i = (0, $d5e3207b2716e246$export$f1e1789686576879)(e, n);
            var s = (0, $779416f751461a71$export$ac8dfd3a7ad06e80)((0, $779416f751461a71$export$3dea766d36a8935f)((r)=>"teardown" === r.kind && r.key === e.key)(t))((0, $d5e3207b2716e246$export$2d1720544b23b823)(e, a, i));
            var t1, n1;
            return s;
        })((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" !== e.kind && ("subscription" !== e.kind || !!e.context.fetchSubscriptions))(t));
        var a = e((0, $779416f751461a71$export$3dea766d36a8935f)((e)=>"teardown" === e.kind || "subscription" === e.kind && !e.context.fetchSubscriptions)(t));
        return (0, $779416f751461a71$export$4950aa0f605343fb)([
            n,
            a
        ]);
    };
var $29e2e825db8416d8$export$1e79974f5647c6ed = (e)=>({ client: r, forward: t, dispatchDebug: n })=>e.reduceRight((e, t)=>{
            var a = !1;
            return t({
                client: r,
                forward (r) {
                    return (0, $779416f751461a71$export$ed80d9de1d9df928)(e((0, $779416f751461a71$export$ed80d9de1d9df928)(r)));
                },
                dispatchDebug (e) {}
            });
        }, t);
var $29e2e825db8416d8$export$454d06fa782923cb = ({ onOperation: e, onResult: r, onError: t })=>({ forward: n })=>(a)=>(0, $779416f751461a71$export$6b9f6c0d32c093f9)((e)=>{
                if (t && e.error) t(e.error, e.operation);
                var n = r && r(e) || e;
                return "then" in n ? (0, $779416f751461a71$export$60f45028237c39d1)(n) : (0, $779416f751461a71$export$5f36b26c3833b3ba)(n);
            })(n((0, $779416f751461a71$export$6b9f6c0d32c093f9)((r)=>{
                var t = e && e(r) || r;
                return "then" in t ? (0, $779416f751461a71$export$60f45028237c39d1)(t) : (0, $779416f751461a71$export$5f36b26c3833b3ba)(t);
            })(a)));
var $29e2e825db8416d8$var$fallbackExchange = ({ dispatchDebug: e })=>(r)=>{
        var r1, t;
        return (0, $779416f751461a71$export$3dea766d36a8935f)((e)=>!1)(r);
    };
var $29e2e825db8416d8$export$1f2bb630327ac4b6 = function Client(e) {
    var r = 0;
    var t = new Map;
    var n = new Map;
    var a = new Set;
    var o = [];
    var i = {
        url: e.url,
        fetchSubscriptions: e.fetchSubscriptions,
        fetchOptions: e.fetchOptions,
        fetch: e.fetch,
        preferGetMethod: e.preferGetMethod,
        requestPolicy: e.requestPolicy || "cache-first"
    };
    var s = (0, $779416f751461a71$export$c4c2a35435b4a722)();
    function nextOperation(e) {
        if ("mutation" === e.kind || "teardown" === e.kind || !a.has(e.key)) {
            if ("teardown" === e.kind) a.delete(e.key);
            else if ("mutation" !== e.kind) a.add(e.key);
            s.next(e);
        }
    }
    var c = !1;
    function dispatchOperation(e) {
        if (e) nextOperation(e);
        if (!c) {
            c = !0;
            while(c && (e = o.shift()))nextOperation(e);
            c = !1;
        }
    }
    var makeResultSource = (e)=>{
        var r = (0, $779416f751461a71$export$ac8dfd3a7ad06e80)((0, $779416f751461a71$export$3dea766d36a8935f)((r)=>"teardown" === r.kind && r.key === e.key)(s.source))((0, $779416f751461a71$export$3dea766d36a8935f)((r)=>r.operation.kind === e.kind && r.operation.key === e.key && (!r.operation.context._instance || r.operation.context._instance === e.context._instance))(O));
        if ("query" !== e.kind) r = (0, $779416f751461a71$export$9384c7afe4015e42)((e)=>!!e.hasNext, !0)(r);
        else r = (0, $779416f751461a71$export$9f6ea8e48bc26eab)((r)=>{
            var t = (0, $779416f751461a71$export$5f36b26c3833b3ba)(r);
            return r.stale || r.hasNext ? t : (0, $779416f751461a71$export$4950aa0f605343fb)([
                t,
                (0, $779416f751461a71$export$871de8747c9eaa88)(()=>{
                    r.stale = !0;
                    return r;
                })((0, $779416f751461a71$export$b7df5d561049483a)(1)((0, $779416f751461a71$export$3dea766d36a8935f)((r)=>r.key === e.key)(s.source)))
            ]);
        })(r);
        if ("mutation" !== e.kind) r = (0, $779416f751461a71$export$db4d2a4aed77becf)(()=>{
            a.delete(e.key);
            t.delete(e.key);
            n.delete(e.key);
            c = !1;
            for(var r = o.length - 1; r >= 0; r--)if (o[r].key === e.key) o.splice(r, 1);
            nextOperation($29e2e825db8416d8$export$dac456ae68957b8f("teardown", e, e.context));
        })((0, $779416f751461a71$export$fff70a13d53402ec)((r)=>{
            if (r.stale) {
                for (var n of o)if (n.key === r.operation.key) {
                    a.delete(n.key);
                    break;
                }
            } else if (!r.hasNext) a.delete(e.key);
            t.set(e.key, r);
        })(r));
        else r = (0, $779416f751461a71$export$aaa2d21dd8862419)(()=>{
            nextOperation(e);
        })(r);
        return (0, $779416f751461a71$export$ed80d9de1d9df928)(r);
    };
    var u = this instanceof Client ? this : Object.create(Client.prototype);
    var p = Object.assign(u, {
        suspense: !!e.suspense,
        operations$: s.source,
        reexecuteOperation (e) {
            if ("teardown" === e.kind) dispatchOperation(e);
            else if ("mutation" === e.kind || n.has(e.key)) {
                var r = !1;
                for(var t = 0; t < o.length; t++)r = r || o[t].key === e.key;
                if (!r) a.delete(e.key);
                o.push(e);
                Promise.resolve().then(dispatchOperation);
            }
        },
        createRequestOperation (e, t, n) {
            if (!n) n = {};
            var a;
            return $29e2e825db8416d8$export$dac456ae68957b8f(e, t, {
                _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
                ...i,
                ...n,
                requestPolicy: n.requestPolicy || i.requestPolicy,
                suspense: n.suspense || !1 !== n.suspense && p.suspense
            });
        },
        executeRequestOperation (e) {
            if ("mutation" === e.kind) return $29e2e825db8416d8$var$withPromise(makeResultSource(e));
            return $29e2e825db8416d8$var$withPromise((0, $779416f751461a71$export$488013bae63b21da)(()=>{
                var r = n.get(e.key);
                if (!r) n.set(e.key, r = makeResultSource(e));
                r = (0, $779416f751461a71$export$aaa2d21dd8862419)(()=>{
                    dispatchOperation(e);
                })(r);
                var a = t.get(e.key);
                if ("query" === e.kind && a && (a.stale || a.hasNext)) return (0, $779416f751461a71$export$9f6ea8e48bc26eab)((0, $779416f751461a71$export$5f36b26c3833b3ba))((0, $779416f751461a71$export$4950aa0f605343fb)([
                    r,
                    (0, $779416f751461a71$export$3dea766d36a8935f)((r)=>r === t.get(e.key))((0, $779416f751461a71$export$5f36b26c3833b3ba)(a))
                ]));
                else return r;
            }));
        },
        executeQuery (e, r) {
            var t = p.createRequestOperation("query", e, r);
            return p.executeRequestOperation(t);
        },
        executeSubscription (e, r) {
            var t = p.createRequestOperation("subscription", e, r);
            return p.executeRequestOperation(t);
        },
        executeMutation (e, r) {
            var t = p.createRequestOperation("mutation", e, r);
            return p.executeRequestOperation(t);
        },
        readQuery (e, r, t) {
            var n = null;
            (0, $779416f751461a71$export$ec068583843480e7)((e)=>{
                n = e;
            })(p.query(e, r, t)).unsubscribe();
            return n;
        },
        query: (e, r, t)=>p.executeQuery((0, $d5e3207b2716e246$export$dda1d9f60106f0e9)(e, r), t),
        subscription: (e, r, t)=>p.executeSubscription((0, $d5e3207b2716e246$export$dda1d9f60106f0e9)(e, r), t),
        mutation: (e, r, t)=>p.executeMutation((0, $d5e3207b2716e246$export$dda1d9f60106f0e9)(e, r), t)
    });
    var d = $29e2e825db8416d8$var$noop;
    var l, x, e1;
    var w = $29e2e825db8416d8$export$1e79974f5647c6ed(e.exchanges);
    var O = (0, $779416f751461a71$export$ed80d9de1d9df928)(w({
        client: p,
        dispatchDebug: d,
        forward: $29e2e825db8416d8$var$fallbackExchange({
            dispatchDebug: d
        })
    })(s.source));
    (0, $779416f751461a71$export$89b472e03be495df)(O);
    return p;
};
var $29e2e825db8416d8$export$5d730b7aed1a3eb0 = $29e2e825db8416d8$export$1f2bb630327ac4b6;



const $d911a197e5612496$export$91e8019c72e4e6d = "https://www.atlassian.com/gateway/api/graphql";



const $89bc3b5305314604$export$402bbe2ae51bef4d = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment AccountUserProfileFragment on GrowthUnifiedProfileAccountProfileResult {
        userProfile {
            inferredTimezone
        }
    }
`;



const $1c4fb413f0c8541b$export$b6bf1ee6c55f99d9 = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment OnboardingContextFragment on GrowthUnifiedProfileResult {
        onboardingContext {
            jira {
                projectName
                teamType
                jobsToBeDone
                projectLandingSelection
            }
            confluence {
                jobsToBeDone
                template
            }
        }
    }
`;



const $ba431a20da754715$export$1842a5759f4be5bd = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment PaidChannelContextFragment on GrowthUnifiedProfileResult {
        paidChannelContext {
            jira {
                utm {
                    keyword
                    source
                    channel
                }
                anchor {
                    name
                    type
                }
                subAnchor
                teamType
                persona
                templates
            }
            confluence {
                utm {
                    keyword
                    source
                    channel
                }
                anchor {
                    name
                    type
                }
                subAnchor
                teamType
                persona
                templates
            }
            jsm {
                utm {
                    keyword
                    source
                    channel
                }
                anchor {
                    name
                    type
                }
                subAnchor
                teamType
                persona
                templates
            }
            jwm {
                utm {
                    keyword
                    source
                    channel
                }
                anchor {
                    name
                    type
                }
                subAnchor
                teamType
                persona
                templates
            }
            trello {
                utm {
                    keyword
                    source
                    channel
                }
                anchor {
                    name
                    type
                }
                subAnchor
                teamType
                persona
                templates
            }
        }
    }
`;



const $709e94a7aff34678$export$bc470c46a2aa5990 = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment RecommendationsFragment on GrowthUnifiedProfileAccountProfileResult {
        recommendations {
            nbp {
                key
                values
            }
        }
    }
`;



const $5ade5dcf0aaf0a49$export$e47282782f810d28 = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment SitesFragment on GrowthUnifiedProfileResult {
        sites {
            cloudId
            displayName
            hasAdminAccess
            url
            siteCreatedAt
            products {
                d0Eligible
                d1to6Eligible
                d0Active
                d1to6Active
                productEdition
                productKey
                productName
                provisionedAt
            }
        }
    }
`;



const $eb3257fa797532d6$export$3e6de26f62d6c5b = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment UserFootprintsFragment on GrowthUnifiedProfileResult {
        userFootprints {
            products
            hasAtlassianAccount
        }
    }
`;



const $26f30d71f780c614$export$4647326753384cf0 = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment UserProfileFragment on GrowthUnifiedProfileResult {
        userProfile {
            userType
            domainType
            teamType
            jobFunction
        }
    }
`;



const $88e8d619708c23f9$export$2d7883efb75f7523 = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
    fragment UserProfileJobFunctionFragment on GrowthUnifiedProfileResult {
        userProfile {
            jobFunction
        }
    }
`;


var $32fd1e468d40477e$export$89720e8460cd3d04;
(function(OptionalFields) {
    OptionalFields["SITES"] = "sites";
    OptionalFields["PAID_CHANNEL_CONTEXT"] = "paidChannelContext";
    OptionalFields["USER_FOOTPRINTS"] = "userFootprints";
    OptionalFields["ONBOARDING_CONTEXT"] = "onboardingContext";
    OptionalFields["USER_PROFILE"] = "userProfile";
    OptionalFields["USER_PROFILE_JOB_FUNCTION"] = "userProfileJobFunction";
})($32fd1e468d40477e$export$89720e8460cd3d04 || ($32fd1e468d40477e$export$89720e8460cd3d04 = {}));
var $32fd1e468d40477e$export$c52306273ead3f;
(function(AccountProfileOptionalFields) {
    AccountProfileOptionalFields["USER_PROFILE"] = "userProfile";
    AccountProfileOptionalFields["PAID_FEATURE_USAGE"] = "paidFeatureUsage";
    AccountProfileOptionalFields["RECOMMENDATIONS"] = "recommendations";
})($32fd1e468d40477e$export$c52306273ead3f || ($32fd1e468d40477e$export$c52306273ead3f = {}));


// Helper to check if error is an AbortError
const $76c319390ad3fbd7$var$isAbortError = (error)=>{
    // Check direct Error instances
    if (error instanceof Error && (error.name === "AbortError" || error.message?.includes("aborted"))) return true;
    // Check for urql CombinedError with wrapped networkError
    if (error && typeof error === "object" && "networkError" in error && error.networkError instanceof Error) {
        const networkError = error.networkError;
        return networkError.name === "AbortError" || networkError.message?.includes("aborted") || networkError.message?.includes("The user aborted a request");
    }
    return false;
};
class $76c319390ad3fbd7$export$d1ae200e149aadbf {
    constructor(options){
        /**
   * Get a unified profile
   * @param accountId
   * @returns { data, error }
   */ // eslint-disable-next-line complexity
        this.getProfile = async (args, optionalFields, optionalHeaderUseCase, abortSignal)=>{
            const { accountId: accountId, anonymousId: anonymousId, tenantId: tenantId } = args;
            const fragments = this.constructProfileQuery(optionalFields);
            const GET_PROFILE_QUERY = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
            query getUnifiedProfile($accountId: ID, $tenantId: ID, $anonymousId: ID) {
                growthUnifiedProfile_getUnifiedProfile(
                    accountId: $accountId
                    tenantId: $tenantId
                    anonymousId: $anonymousId
                ) {
                    ${fragments}
                }
            }
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).ONBOARDING_CONTEXT) ? (0, $1c4fb413f0c8541b$export$b6bf1ee6c55f99d9) : ""}
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).SITES) ? (0, $5ade5dcf0aaf0a49$export$e47282782f810d28) : ""}
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).PAID_CHANNEL_CONTEXT) ? (0, $ba431a20da754715$export$1842a5759f4be5bd) : ""}
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_FOOTPRINTS) ? (0, $eb3257fa797532d6$export$3e6de26f62d6c5b) : ""}
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE) ? (0, $26f30d71f780c614$export$4647326753384cf0) : ""}
            ${optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE_JOB_FUNCTION) ? (0, $88e8d619708c23f9$export$2d7883efb75f7523) : ""}
        `;
            const fetchContext = this.buildFetchContext(optionalHeaderUseCase, abortSignal);
            try {
                const { data: data, error: error } = await this.client.query(GET_PROFILE_QUERY, {
                    accountId: accountId,
                    tenantId: tenantId,
                    anonymousId: anonymousId
                }, {
                    fetchOptions: fetchContext
                });
                return {
                    data: data?.growthUnifiedProfile_getUnifiedProfile,
                    error: error
                };
            } catch (error) {
                // Re-throw AbortErrors as they're expected when requests are cancelled
                if ($76c319390ad3fbd7$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        /**
   * Create or update a unified profile
   * @param profile
   * @returns { data, error }
   */ this.updateProfile = async ({ profile: profile, abortSignal: abortSignal })=>{
            // Currently accountId is required, once anonymousId support
            // is added to the upstream service, this check can be removed
            if (!profile.accountId) throw new Error("accountId is required");
            const UPDATE_PROFILE_MUTATION = (0, $29e2e825db8416d8$export$72e4926bf8358653)`
            mutation createUnifiedProfile(
                $profile: GrowthUnifiedProfileCreateProfileInput!
            ) {
                growthUnifiedProfile_createUnifiedProfile(profile: $profile) {
                    ...OnboardingContextFragment
                }
            }
            ${(0, $1c4fb413f0c8541b$export$b6bf1ee6c55f99d9)}
        `;
            try {
                const { data: data, error: error } = await this.client.mutation(UPDATE_PROFILE_MUTATION, {
                    profile: profile
                }, {
                    fetchOptions: abortSignal ? {
                        signal: abortSignal
                    } : undefined
                });
                return {
                    data: data?.growthUnifiedProfile_createUnifiedProfile,
                    error: error
                };
            } catch (error) {
                // Re-throw AbortErrors as they're expected when requests are cancelled
                if ($76c319390ad3fbd7$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        /**
   * Get an account profile
   * @param args - Account profile arguments including accountId and optional PFU filter
   * @param optionalFields - Optional fields to query (USER_PROFILE, PAID_FEATURE_USAGE, RECOMMENDATIONS)
   * @param optionalHeaderUseCase - Optional header use case
   * @param abortSignal - Optional AbortSignal to cancel the request
   * @returns { data, error }
   * @note If PAID_FEATURE_USAGE is requested but pfuFilter is not provided, a default filter (90 days) will be used.
   *       The GraphQL schema requires a filter for paidFeatureUsage queries.
   */ this.getAccountProfile = async (args, optionalFields, optionalHeaderUseCase, abortSignal)=>{
            const { accountId: accountId, pfuFilter: pfuFilter } = args;
            const fragments = this.constructAccountProfileQuery(optionalFields);
            if (!fragments) return {
                data: undefined,
                error: new Error("At least one optional field must be specified: USER_PROFILE, PAID_FEATURE_USAGE, or RECOMMENDATIONS")
            };
            const includePfuFilter = this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).PAID_FEATURE_USAGE, optionalFields);
            const filterToUse = this.resolvePFUFilter(optionalFields, pfuFilter);
            const variables = includePfuFilter ? {
                accountId: accountId,
                pfuFilter: filterToUse
            } : {
                accountId: accountId
            };
            try {
                const { data: data, error: error } = await this.client.query(this.buildGetAccountProfileQuery(fragments, includePfuFilter, optionalFields), variables, {
                    fetchOptions: this.buildFetchContext(optionalHeaderUseCase, abortSignal)
                });
                return {
                    data: data?.growthUnifiedProfile_getAccountProfile,
                    error: error
                };
            } catch (error) {
                if ($76c319390ad3fbd7$var$isAbortError(error)) throw error;
                return {
                    data: undefined,
                    error: error
                };
            }
        };
        this.fetchOptions = options?.slauthToken ? {
            headers: {
                Authorization: `SLAUTH ${options.slauthToken || ""}`
            }
        } : {
            credentials: "include"
        };
        this.client = new (0, $29e2e825db8416d8$export$1f2bb630327ac4b6)({
            url: (0, $d911a197e5612496$export$91e8019c72e4e6d),
            exchanges: [
                (0, $29e2e825db8416d8$export$de01951d82452cab),
                (0, $29e2e825db8416d8$export$7fed09527e654bc9)
            ],
            fetchOptions: this.fetchOptions
        });
    }
    constructProfileQuery(optionalFields) {
        const fragments = [
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).ONBOARDING_CONTEXT) ? "...OnboardingContextFragment" : "",
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).SITES) ? "...SitesFragment" : "",
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).PAID_CHANNEL_CONTEXT) ? "...PaidChannelContextFragment" : "",
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_FOOTPRINTS) ? "...UserFootprintsFragment" : "",
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE) ? "...UserProfileFragment" : "",
            optionalFields?.includes((0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE_JOB_FUNCTION) ? "...UserProfileJobFunctionFragment" : ""
        ].filter(Boolean).join("\n");
        // If no optional fields are provided, default to onboarding context
        return fragments || "...OnboardingContextFragment";
    }
    constructAccountProfileQuery(optionalFields) {
        const fragments = [
            this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).USER_PROFILE, optionalFields) ? "...AccountUserProfileFragment" : "",
            this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).PAID_FEATURE_USAGE, optionalFields) ? `paidFeatureUsage(filter: $pfuFilter) {
                    featureType
                    featureName
                    featureSupportedEdition
                    usageSummary {
                        tenants {
                            tenantId
                            tenantType
                        }
                        products
                        entitlementIds
                        featureEngagementLevel
                        usageCount
                    }
                }` : "",
            this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).RECOMMENDATIONS, optionalFields) ? "...RecommendationsFragment" : ""
        ].filter(Boolean).join("\n");
        return fragments;
    }
    getDefaultPFUFilter() {
        const defaultStartDate = new Date(Date.now() - 7776000000).toISOString().split("T")[0]; // 90 days ago in YYYY-MM-DD format
        return {
            startDate: defaultStartDate
        };
    }
    resolvePFUFilter(optionalFields, pfuFilter) {
        const needsPFUFilter = optionalFields?.includes((0, $32fd1e468d40477e$export$c52306273ead3f).PAID_FEATURE_USAGE) && !pfuFilter;
        if (needsPFUFilter) return this.getDefaultPFUFilter();
        return pfuFilter || null;
    }
    hasAccountProfileField(field, optionalFields) {
        return optionalFields?.includes(field) ?? false;
    }
    buildFetchContext(optionalHeaderUseCase, abortSignal) {
        return {
            ...this.fetchOptions,
            headers: {
                ...this.fetchOptions?.headers || {},
                ...optionalHeaderUseCase ? {
                    "x-use-case": optionalHeaderUseCase
                } : {}
            },
            ...abortSignal ? {
                signal: abortSignal
            } : {}
        };
    }
    buildGetAccountProfileQuery(fragments, includePfuFilter, optionalFields) {
        return (0, $29e2e825db8416d8$export$72e4926bf8358653)`
            query getAccountProfile(
                $accountId: ID!
                ${includePfuFilter ? "$pfuFilter: GrowthUnifiedProfilePFUFilter" : ""}
            ) {
                growthUnifiedProfile_getAccountProfile(accountId: $accountId) {
                    ${fragments}
                }
            }
            ${this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).USER_PROFILE, optionalFields) ? (0, $89bc3b5305314604$export$402bbe2ae51bef4d) : ""}
            ${this.hasAccountProfileField((0, $32fd1e468d40477e$export$c52306273ead3f).RECOMMENDATIONS, optionalFields) ? (0, $709e94a7aff34678$export$bc470c46a2aa5990) : ""}
        `;
    }
}




var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");


var $dRxyd = parcelRequire("dRxyd");
const $2013190fd983e397$var$URL_STAGING_IDENTITY = "https://id.stg.internal.atlassian.com";
const $2013190fd983e397$var$URL_PRODUCTION_IDENTITY = "https://id.atlassian.com";
const $2013190fd983e397$var$URL_STAGING_WAC = "https://wac.stg.internal.atlassian.com";
const $2013190fd983e397$var$URL_PRODUCTION_WAC = "https://www.atlassian.com";
const $2013190fd983e397$var$URL_STAGING_API = "https://wac.stg.internal.atlassian.com/gateway/api";
const $2013190fd983e397$var$URL_PRODUCTION_API = "https://www.atlassian.com/gateway/api";
const $2013190fd983e397$export$d5d3d254f14e9a42 = typeof window !== "undefined" ? // @ts-ignore - Client side
`${window.CONTENTFUL_BASE_URL_GQL}/content/v1/spaces/${window.CONTENTFUL_SPACE_ID_PRODUCT_TEMPLATES}/environments/${window.CONTENTFUL_ENVIRONMENT_PRODUCT_TEMPLATES}` : // Server side
`${"https://graphql.contentful.com"}/content/v1/spaces/${"xjcz23wx147q"}/environments/${"master"}`;
const $2013190fd983e397$export$f15d00aa73aafac4 = ()=>// assume production when environment is unknown
    ![
        "dev",
        "development",
        "staging"
    ].includes(String("production"));
const $2013190fd983e397$export$752967ea6498a4b5 = ()=>$2013190fd983e397$export$f15d00aa73aafac4() ? $2013190fd983e397$var$URL_PRODUCTION_IDENTITY : $2013190fd983e397$var$URL_STAGING_IDENTITY;
const $2013190fd983e397$export$e844e0b5527ae7a6 = ()=>$2013190fd983e397$export$f15d00aa73aafac4() ? $2013190fd983e397$var$URL_PRODUCTION_WAC : $2013190fd983e397$var$URL_STAGING_WAC;
const $2013190fd983e397$export$4d28219d42798a75 = ()=>$2013190fd983e397$export$f15d00aa73aafac4() ? $2013190fd983e397$var$URL_PRODUCTION_API : $2013190fd983e397$var$URL_STAGING_API;
const $2013190fd983e397$export$9704458d7fccee2d = $2013190fd983e397$export$752967ea6498a4b5();
const $2013190fd983e397$export$422c73a9b9ad2bf3 = $2013190fd983e397$export$e844e0b5527ae7a6();
const $2013190fd983e397$export$882be03a94b7d874 = (bundleParam, productParam)=>{
    if (productParam) bundleParam = $2013190fd983e397$export$14416f7267a645f4(productParam);
    switch(bundleParam){
        case "confluence":
            return "Confluence";
        case "jira-service-management":
            return "Jira Service Management";
        case "jira-service-management-jira-software":
            return "Jira Service Management + Jira";
        case "compass":
            return "Compass";
        case "jira-product-discovery":
            return "Jira Product Discovery";
        case "loom":
            return "Loom";
        case "bitbucket":
            return "Bitbucket";
        case "jira-software":
        case "":
            return "Jira";
        default:
            return "";
    }
};
const $2013190fd983e397$export$14416f7267a645f4 = (productParam)=>{
    switch(productParam){
        case "jira-software.ondemand":
        case "":
            return "jira-software";
        case "jira-servicedesk.ondemand":
            return "jira-service-management";
        case "confluence.ondemand":
            return "confluence";
        case "jira-product-discovery":
            return "jira-product-discovery";
        case "jira-servicedesk.ondemand,jira-software.ondemand":
            return "jira-service-management-jira-software";
        case "compass.ondemand":
            return "compass";
        case "com.atlassian.bitbucket.manual":
            return "bitbucket";
        default:
            return "";
    }
};


const $fce0e8aa624a9920$var$IDENTITY_RECAPTCHA_KEY = "6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD";
const $fce0e8aa624a9920$var$IDENTITY_RECAPTCHA_KEY_TEST = "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN";
const $fce0e8aa624a9920$export$4682c216c5c4d5d7 = ()=>{
    return (0, $2013190fd983e397$export$f15d00aa73aafac4)() ? $fce0e8aa624a9920$var$IDENTITY_RECAPTCHA_KEY : $fce0e8aa624a9920$var$IDENTITY_RECAPTCHA_KEY_TEST;
};


const $8d086bea86f0235b$export$92fa52c125cc0e5 = "identity-platform";
const $8d086bea86f0235b$export$49ebef81048c4e68 = {
    CONFLUENCE: "confluence.ondemand",
    JIRA_CORE: "jira-core.ondemand",
    JIRA_BUSINESS: "jira-core.ondemand",
    JIRA_SOFTWARE: "jira-software.ondemand",
    JIRA_SERVICE_DESK: "jira-servicedesk.ondemand",
    BITBUCKET: "com.atlassian.bitbucket",
    OPSGENIE: "opsgenie",
    STATUSPAGE: "statuspage",
    TRELLO: "trello"
};



function $1a668ca05d5fb4c0$export$a284fd3cd35fac52() {
    let atlCohortId;
    try {
        const cookie = JSON.parse(decodeURIComponent((0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("atlCohort") || ""));
        atlCohortId = cookie["bucketAll"].index;
    } catch (e) {
        atlCohortId = "";
        console.warn("Cannot parse atlCohort cookie", e);
    }
    return atlCohortId;
}




/** Regular expression used to parse a Dsn. */ const $90913756af66a4e6$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $90913756af66a4e6$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $90913756af66a4e6$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $90913756af66a4e6$export$b892860177f70a30(str) {
    const match = $90913756af66a4e6$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $90913756af66a4e6$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $90913756af66a4e6$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $90913756af66a4e6$var$validateDsn(dsn) {
    if (!(0, $b377edbb1b3d818a$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$90913756af66a4e6$var$isValidProtocol(protocol)) {
        (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $90913756af66a4e6$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $90913756af66a4e6$export$b892860177f70a30(from) : $90913756af66a4e6$var$dsnFromComponents(from);
    if (!components || !$90913756af66a4e6$var$validateDsn(components)) return undefined;
    return components;
}


const $a4a00d49d83ad967$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $a4a00d49d83ad967$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $a4a00d49d83ad967$var$_getIngestEndpoint(dsn) {
    return `${$a4a00d49d83ad967$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $a4a00d49d83ad967$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $a4a00d49d83ad967$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $a4a00d49d83ad967$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$a4a00d49d83ad967$var$_getIngestEndpoint(dsn)}?${$a4a00d49d83ad967$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $a4a00d49d83ad967$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $90913756af66a4e6$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$a4a00d49d83ad967$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $90913756af66a4e6$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}












/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $8bfdedaf88c5689c$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $8bfdedaf88c5689c$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $8bfdedaf88c5689c$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $8bfdedaf88c5689c$export$604a45d95a155e2b(envelope, types) {
    return $8bfdedaf88c5689c$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $8bfdedaf88c5689c$var$encodeUTF8(input) {
    const carrier = (0, $2d413ae5a393071a$export$c8bfa33e4e8ae492)((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $8bfdedaf88c5689c$var$decodeUTF8(input) {
    const carrier = (0, $2d413ae5a393071a$export$c8bfa33e4e8ae492)((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $8bfdedaf88c5689c$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $8bfdedaf88c5689c$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $8bfdedaf88c5689c$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $e493a5d50143afb5$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $8bfdedaf88c5689c$var$concatBuffers(parts);
}
function $8bfdedaf88c5689c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $8bfdedaf88c5689c$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $8bfdedaf88c5689c$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($8bfdedaf88c5689c$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $8bfdedaf88c5689c$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $8bfdedaf88c5689c$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $8bfdedaf88c5689c$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $8bfdedaf88c5689c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security",
    otel_log: "log_item"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $8bfdedaf88c5689c$export$b11169581eeaf237(type) {
    return $8bfdedaf88c5689c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $8bfdedaf88c5689c$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $8bfdedaf88c5689c$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $90913756af66a4e6$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $dbe7a41cafcde3f0$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $dbe7a41cafcde3f0$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $8bfdedaf88c5689c$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $90913756af66a4e6$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $dbe7a41cafcde3f0$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $8bfdedaf88c5689c$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $dbe7a41cafcde3f0$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $8bfdedaf88c5689c$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $dbe7a41cafcde3f0$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $7d33670619390772$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $90913756af66a4e6$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $1ee319bdc991c767$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $1ee319bdc991c767$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $1ee319bdc991c767$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $8bfdedaf88c5689c$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(headers, items);
}





const $16575ede9e208d34$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $16575ede9e208d34$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $16575ede9e208d34$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $16575ede9e208d34$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $16575ede9e208d34$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $16575ede9e208d34$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $16575ede9e208d34$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $16575ede9e208d34$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($16575ede9e208d34$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $16575ede9e208d34$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $16575ede9e208d34$export$2d8f5188773bcddd(integration) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $16575ede9e208d34$export$2323046b9414659f(fn) {
    return fn;
}




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $915a9d110878d37d$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch (e) {
    // ignore errors here
    }
    return possibleMessages;
}








/**
 * Converts a transaction event to a span JSON object.
 */ function $544ccbc3b534371b$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? "",
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? "",
        origin: origin,
        profile_id: data?.[0, $8f43a3b4d13a578f$export$1efec95406bbe327],
        exclusive_time: data?.[0, $8f43a3b4d13a578f$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $544ccbc3b534371b$export$f2d8fce5ae150e92(span) {
    return {
        type: "transaction",
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $8f43a3b4d13a578f$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $8f43a3b4d13a578f$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $0f0e91cda7c10d68$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $741f7992b965e3b0$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}








/* eslint-disable max-lines */ const $b703f1cb6cbd1d60$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $b703f1cb6cbd1d60$var$MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const $b703f1cb6cbd1d60$var$INTERNAL_ERROR_SYMBOL = Symbol.for("SentryInternalError");
const $b703f1cb6cbd1d60$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for("SentryDoNotSendEventError");
function $b703f1cb6cbd1d60$var$_makeInternalError(message) {
    return {
        message: message,
        [$b703f1cb6cbd1d60$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $b703f1cb6cbd1d60$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$b703f1cb6cbd1d60$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $b703f1cb6cbd1d60$var$_isInternalError(error) {
    return !!error && typeof error === "object" && $b703f1cb6cbd1d60$var$INTERNAL_ERROR_SYMBOL in error;
}
function $b703f1cb6cbd1d60$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === "object" && $b703f1cb6cbd1d60$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $b703f1cb6cbd1d60$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $90913756af66a4e6$export$128827c3562ec0cb)(options.dsn);
        else (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $a4a00d49d83ad967$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $5985640674d52865$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $5985640674d52865$export$6de4ffac6a2f1098)(exception)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log($b703f1cb6cbd1d60$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $5985640674d52865$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $64d77030f0d405c5$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $64d77030f0d405c5$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $5985640674d52865$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $5985640674d52865$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log($b703f1cb6cbd1d60$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope));
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $8796e43ab70f6728$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit("flush");
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit("close");
            return result;
        });
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith("Spotlight"))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $16575ede9e208d34$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $16575ede9e208d34$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $dbe7a41cafcde3f0$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $8bfdedaf88c5689c$export$d650323442802f6f)(env, (0, $8bfdedaf88c5689c$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $af185f7d1bf09c29$export$849dbeeeda01ae98) } = this._options;
        if ("aggregates" in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn($b703f1cb6cbd1d60$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn($b703f1cb6cbd1d60$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit("beforeSendSession", session);
        const env = (0, $dbe7a41cafcde3f0$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hooks = this._hooks[hook] = this._hooks[hook] || [];
        // @ts-expect-error We assume the types are correct
        hooks.push(callback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            // @ts-expect-error We assume the types are correct
            const cbIndex = hooks.indexOf(callback);
            if (cbIndex > -1) hooks.splice(cbIndex, 1);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Error while sending envelope:", reason);
            return reason;
        });
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Transport disabled");
        return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $16575ede9e208d34$export$51abed9797baa598)(this, integrations);
        (0, $16575ede9e208d34$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = event.level === "fatal";
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism?.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $8796e43ab70f6728$export$531818e825e774db)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $61dce522664ed8d7$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $576b9754bac8cb50$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit("postprocessEvent", evt, hint);
            evt.contexts = {
                trace: (0, $35358b2c9a559011$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $7d33670619390772$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)(), isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)()) {
        if ((0, $9f8bd953fbcf4578$export$16a28057038b10ef) && $b703f1cb6cbd1d60$var$isErrorEvent(event)) (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Captured error event \`${(0, $915a9d110878d37d$export$d55a97c329cacfcc)(event)[0] || "<unknown>"}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $9f8bd953fbcf4578$export$16a28057038b10ef) {
                if ($b703f1cb6cbd1d60$var$_isDoNotSendEventError(reason)) (0, $398c2530c60234a2$export$af88d00dbe7f521).log(reason.message);
                else if ($b703f1cb6cbd1d60$var$_isInternalError(reason)) (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(reason.message);
                else (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $b703f1cb6cbd1d60$var$isTransactionEvent(event);
        const isError = $b703f1cb6cbd1d60$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === "undefined" ? undefined : (0, $4d1dc467e3505014$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === "number" && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent("sample_rate", "error");
            return (0, $61dce522664ed8d7$export$78e43115b553f358)($b703f1cb6cbd1d60$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory);
                throw $b703f1cb6cbd1d60$var$_makeDoNotSendEventError("An event processor returned `null`, will not send event.");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $b703f1cb6cbd1d60$var$processBeforeSend(this, options, prepared, hint);
            return $b703f1cb6cbd1d60$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent("before_send", "span", spanCount);
                }
                throw $b703f1cb6cbd1d60$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent("before_send", "span", droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($b703f1cb6cbd1d60$var$_isDoNotSendEventError(reason) || $b703f1cb6cbd1d60$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $b703f1cb6cbd1d60$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("Flushing outcomes...");
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("Sending outcomes:", outcomes);
        const envelope = (0, $0f0e91cda7c10d68$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $90913756af66a4e6$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
/**
 * @deprecated Use `Client` instead. This alias may be removed in a future major version.
 */ // TODO(v10): Remove
const $b703f1cb6cbd1d60$export$4f22f74eddb7716a = $b703f1cb6cbd1d60$export$1f2bb630327ac4b6;
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $b703f1cb6cbd1d60$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $64d77030f0d405c5$export$53b83ca8eaab0383)(event) && event !== null) throw $b703f1cb6cbd1d60$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $b703f1cb6cbd1d60$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $64d77030f0d405c5$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $b703f1cb6cbd1d60$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $b703f1cb6cbd1d60$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    let processedEvent = event;
    if ($b703f1cb6cbd1d60$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($b703f1cb6cbd1d60$var$isTransactionEvent(processedEvent)) {
        if (beforeSendSpan) {
            // process root span
            const processedRootSpanJson = beforeSendSpan((0, $544ccbc3b534371b$export$d9c6b2464b0a687e)(processedEvent));
            if (!processedRootSpanJson) (0, $1ee319bdc991c767$export$d11691ff45a3e535)();
            else // update event with processed root span values
            processedEvent = (0, $50154ff82f8353c6$export$4950aa0f605343fb)(event, (0, $544ccbc3b534371b$export$f2d8fce5ae150e92)(processedRootSpanJson));
            // process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                for (const span of processedEvent.spans){
                    const processedSpan = beforeSendSpan(span);
                    if (!processedSpan) {
                        (0, $1ee319bdc991c767$export$d11691ff45a3e535)();
                        processedSpans.push(span);
                    } else processedSpans.push(processedSpan);
                }
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $b703f1cb6cbd1d60$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $b703f1cb6cbd1d60$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/** Extract trace information from scope */ function $b703f1cb6cbd1d60$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    const span = (0, $1783cf6bafc3a162$export$91f063ebb8eff307)(scope);
    const traceContext = span ? (0, $1ee319bdc991c767$export$46c6fbd1d265ebf0)(span) : (0, $35358b2c9a559011$export$1e83db7ee4876dc4)(scope);
    const dynamicSamplingContext = span ? (0, $7d33670619390772$export$a117f995597e25df)(span) : (0, $7d33670619390772$export$89ef1736f08c6b2b)(client, scope);
    return [
        dynamicSamplingContext,
        traceContext
    ];
}







/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $5d101008206f348b$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};




/**
 * Creates OTEL log envelope item for a serialized OTEL log.
 *
 * @param log - The serialized OTEL log to include in the envelope.
 * @returns The created OTEL log envelope item.
 */ function $3e2f15a85596190d$export$3fb4f8e4a128d620(log) {
    return [
        {
            type: "otel_log"
        },
        log
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $3e2f15a85596190d$export$4324f1d0c59fd57b(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $90913756af66a4e6$export$44d472fbb931a776)(dsn);
    return (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(headers, logs.map($3e2f15a85596190d$export$3fb4f8e4a128d620));
}


const $164bace6043f275b$var$MAX_LOG_BUFFER_SIZE = 100;
const $164bace6043f275b$var$CLIENT_TO_LOG_BUFFER_MAP = new WeakMap();
/**
 * Converts a log attribute to a serialized log attribute.
 *
 * @param key - The key of the log attribute.
 * @param value - The value of the log attribute.
 * @returns The serialized log attribute.
 */ function $164bace6043f275b$export$84cb46f4adfc5d14(key, value) {
    switch(typeof value){
        case "number":
            return {
                key: key,
                value: {
                    doubleValue: value
                }
            };
        case "boolean":
            return {
                key: key,
                value: {
                    boolValue: value
                }
            };
        case "string":
            return {
                key: key,
                value: {
                    stringValue: value
                }
            };
        default:
            {
                let stringValue = "";
                try {
                    stringValue = JSON.stringify(value) ?? "";
                } catch  {
                // Do nothing
                }
                return {
                    key: key,
                    value: {
                        stringValue: stringValue
                    }
                };
            }
    }
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $164bace6043f275b$export$3ab3d16b9eebd986(beforeLog, client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)(), scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)()) {
    if (!client) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No client available to capture log.");
        return;
    }
    const { _experiments: _experiments, release: release, environment: environment } = client.getOptions();
    const { enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = _experiments ?? {};
    if (!enableLogs) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("logging option not enabled, log will not be captured.");
        return;
    }
    const [, traceContext] = (0, $b703f1cb6cbd1d60$export$fb7d833b3fdedf5f)(client, scope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    if (release) processedLogAttributes["sentry.release"] = release;
    if (environment) processedLogAttributes["sentry.environment"] = environment;
    const { sdk: sdk } = client.getSdkMetadata() ?? {};
    if (sdk) {
        processedLogAttributes["sentry.sdk.name"] = sdk.name;
        processedLogAttributes["sentry.sdk.version"] = sdk.version;
    }
    const beforeLogMessage = beforeLog.message;
    if ((0, $64d77030f0d405c5$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $1783cf6bafc3a162$export$91f063ebb8eff307)(scope);
    if (span) // Add the parent span ID to the log attributes for trace context
    processedLogAttributes["sentry.trace.parent_span_id"] = span.spanContext().spanId;
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit("beforeCaptureLog", processedLog);
    const log = beforeSendLog ? beforeSendLog(processedLog) : processedLog;
    if (!log) {
        client.recordDroppedEvent("before_send", "log_item", 1);
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("beforeSendLog returned null, log will not be captured.");
        return;
    }
    const { level: level, message: message, attributes: attributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        severityText: level,
        body: {
            stringValue: message
        },
        attributes: Object.entries(attributes).map(([key, value])=>$164bace6043f275b$export$84cb46f4adfc5d14(key, value)),
        timeUnixNano: `${new Date().getTime().toString()}000000`,
        traceId: traceContext?.trace_id,
        severityNumber: severityNumber ?? (0, $5d101008206f348b$export$4fb50c0840d636d1)[level]
    };
    const logBuffer = $164bace6043f275b$var$CLIENT_TO_LOG_BUFFER_MAP.get(client);
    if (logBuffer === undefined) $164bace6043f275b$var$CLIENT_TO_LOG_BUFFER_MAP.set(client, [
        serializedLog
    ]);
    else {
        logBuffer.push(serializedLog);
        if (logBuffer.length > $164bace6043f275b$var$MAX_LOG_BUFFER_SIZE) $164bace6043f275b$export$f8ed83d3b6a0b504(client, logBuffer);
    }
    client.emit("afterCaptureLog", log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $164bace6043f275b$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $164bace6043f275b$var$CLIENT_TO_LOG_BUFFER_MAP.get(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $3e2f15a85596190d$export$4324f1d0c59fd57b)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    logBuffer.length = 0;
    client.emit("flushLogs");
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 */ function $b2494d49fe3b0d96$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: "{{auto}}"
    };
}
/**
 * @internal
 */ function $b2494d49fe3b0d96$export$e8e2d07ba63e2b6c(session) {
    if ("aggregates" in session) {
        if (session.attrs?.["ip_address"] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: "{{auto}}"
        };
    } else if (session.ipAddress === undefined) session.ipAddress = "{{auto}}";
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $ca504204fb9d9dd1$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $92e96da755c37185$export$31499a9cd224b78c)
            })),
        version: (0, $92e96da755c37185$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $e7a1c244cbc55fa0$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $e7a1c244cbc55fa0$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return "npm";
}



/**
 * This function creates an exception from a JavaScript Error
 */ function $f8d0f64002600710$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $f8d0f64002600710$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $f8d0f64002600710$export$2e9ae379995d99e3(ex),
        value: $f8d0f64002600710$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $f8d0f64002600710$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $f8d0f64002600710$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $e493a5d50143afb5$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $f8d0f64002600710$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $64d77030f0d405c5$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $f8d0f64002600710$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $f8d0f64002600710$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $f8d0f64002600710$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $f8d0f64002600710$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $f8d0f64002600710$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const skipLines = $f8d0f64002600710$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $f8d0f64002600710$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $f8d0f64002600710$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $f8d0f64002600710$var$getSkipFirstStackStringLines(ex) {
    if (ex && $f8d0f64002600710$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $f8d0f64002600710$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === "number") return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $f8d0f64002600710$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $f8d0f64002600710$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $f8d0f64002600710$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $f8d0f64002600710$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($f8d0f64002600710$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return "wasm exception";
    }
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $f8d0f64002600710$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $f8d0f64002600710$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5985640674d52865$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $f8d0f64002600710$export$5425b53185d13d6c(stackParser, message, level = "info", hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $f8d0f64002600710$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $f8d0f64002600710$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $64d77030f0d405c5$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $f8d0f64002600710$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $64d77030f0d405c5$export$ef9e2056653f0c8e)(exception) || (0, $64d77030f0d405c5$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $f8d0f64002600710$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $64d77030f0d405c5$export$ef9e2056653f0c8e)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $f8d0f64002600710$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $5985640674d52865$export$f26508487bf83ee7)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $f8d0f64002600710$var$eventFromError(stackParser, exception);
    if ((0, $64d77030f0d405c5$export$53b83ca8eaab0383)(exception) || (0, $64d77030f0d405c5$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $f8d0f64002600710$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $5985640674d52865$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $f8d0f64002600710$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5985640674d52865$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $5985640674d52865$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $f8d0f64002600710$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $f8d0f64002600710$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $5985640674d52865$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $64d77030f0d405c5$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $f8d0f64002600710$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $ac73fe157e02a9a2$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $64d77030f0d405c5$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $64d77030f0d405c5$export$9671ea99bd126ace)(exception)) {
        const className = $f8d0f64002600710$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $f8d0f64002600710$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $f8d0f64002600710$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}



const $b719cbe9bf6aff6a$export$56d8a8a25bd48b81 = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
let $b719cbe9bf6aff6a$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $b719cbe9bf6aff6a$export$b79738ab10c590b2() {
    return $b719cbe9bf6aff6a$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $b719cbe9bf6aff6a$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $b719cbe9bf6aff6a$var$ignoreOnError++;
    setTimeout(()=>{
        $b719cbe9bf6aff6a$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $b719cbe9bf6aff6a$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === "function";
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === "function") return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $ac73fe157e02a9a2$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$b719cbe9bf6aff6a$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $b719cbe9bf6aff6a$export$1265a142ff5ba165();
            (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $5985640674d52865$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $5985640674d52865$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $54ca942ea01c8aa7$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $ac73fe157e02a9a2$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}


const $56366ed1565721b7$var$DEFAULT_FLUSH_INTERVAL = 5000;
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/core Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $56366ed1565721b7$export$1df9218a526d318d extends (0, $b703f1cb6cbd1d60$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $e7a1c244cbc55fa0$export$8ad33f488b1ab046)();
        (0, $ca504204fb9d9dd1$export$b9f95b027256052c)(opts, "browser", [
            "browser"
        ], sdkSource);
        super(opts);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const client = this;
        const { sendDefaultPii: sendDefaultPii, _experiments: _experiments } = client._options;
        const enableLogs = _experiments?.enableLogs;
        if (opts.sendClientReports && (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document) (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
            if ((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.visibilityState === "hidden") {
                this._flushOutcomes();
                if (enableLogs) (0, $164bace6043f275b$export$f8ed83d3b6a0b504)(client);
            }
        });
        if (enableLogs) {
            client.on("flush", ()=>{
                (0, $164bace6043f275b$export$f8ed83d3b6a0b504)(client);
            });
            client.on("afterCaptureLog", ()=>{
                if (client._logFlushIdleTimeout) clearTimeout(client._logFlushIdleTimeout);
                client._logFlushIdleTimeout = setTimeout(()=>{
                    (0, $164bace6043f275b$export$f8ed83d3b6a0b504)(client);
                }, $56366ed1565721b7$var$DEFAULT_FLUSH_INTERVAL);
            });
        }
        if (sendDefaultPii) {
            client.on("postprocessEvent", (0, $b2494d49fe3b0d96$export$3e12ad68afa434ac));
            client.on("beforeSendSession", (0, $b2494d49fe3b0d96$export$e8e2d07ba63e2b6c));
        }
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $f8d0f64002600710$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = "info", hint) {
        return (0, $f8d0f64002600710$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}







// We keep the handlers globally
const $113765a9da9fc745$var$handlers = {};
const $113765a9da9fc745$var$instrumented = {};
/** Add a handler function. */ function $113765a9da9fc745$export$a4e09611e30da72e(type, handler) {
    $113765a9da9fc745$var$handlers[type] = $113765a9da9fc745$var$handlers[type] || [];
    $113765a9da9fc745$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $113765a9da9fc745$export$b17eab759a1cb5fe() {
    Object.keys($113765a9da9fc745$var$handlers).forEach((key)=>{
        $113765a9da9fc745$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $113765a9da9fc745$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$113765a9da9fc745$var$instrumented[type]) {
        $113765a9da9fc745$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $113765a9da9fc745$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $113765a9da9fc745$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $79681426e6433cce$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $63015dd6bc837fa0$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $63015dd6bc837fa0$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $113765a9da9fc745$export$a4e09611e30da72e)(type, handler);
    (0, $113765a9da9fc745$export$e18d6c5462c01368)(type, $63015dd6bc837fa0$var$instrumentError);
}
function $63015dd6bc837fa0$var$instrumentError() {
    $63015dd6bc837fa0$var$_oldOnErrorHandler = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $113765a9da9fc745$export$b18c893e424d3127)("error", handlerData);
        if ($63015dd6bc837fa0$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $63015dd6bc837fa0$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}




let $ce8c28c424f04aec$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ce8c28c424f04aec$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $113765a9da9fc745$export$a4e09611e30da72e)(type, handler);
    (0, $113765a9da9fc745$export$e18d6c5462c01368)(type, $ce8c28c424f04aec$var$instrumentUnhandledRejection);
}
function $ce8c28c424f04aec$var$instrumentUnhandledRejection() {
    $ce8c28c424f04aec$var$_oldOnUnhandledRejectionHandler = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $113765a9da9fc745$export$b18c893e424d3127)("unhandledrejection", handlerData);
        if ($ce8c28c424f04aec$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $ce8c28c424f04aec$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}




let $a72aafe4e2ab71fe$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $a72aafe4e2ab71fe$export$b0914730ee1f6c80() {
    if ($a72aafe4e2ab71fe$var$errorsInstrumented) return;
    $a72aafe4e2ab71fe$var$errorsInstrumented = true;
    (0, $63015dd6bc837fa0$export$55b5c3ba2194f0c6)($a72aafe4e2ab71fe$var$errorCallback);
    (0, $ce8c28c424f04aec$export$8bf4fc6858821a4e)($a72aafe4e2ab71fe$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $a72aafe4e2ab71fe$var$errorCallback() {
    const activeSpan = (0, $1ee319bdc991c767$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = "internal_error";
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occurred`);
        rootSpan.setStatus({
            code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$a72aafe4e2ab71fe$var$errorCallback.tag = "sentry_tracingErrorCallback";












/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $bf604ce9a09041a2$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f63023dba381e7e1$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $1ee319bdc991c767$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}









/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $b0b16344a10224e3$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $b0b16344a10224e3$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $b0b16344a10224e3$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $64d77030f0d405c5$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}













/**
 * Print a log message for a started span.
 */ function $a6a5519ecdda4b00$export$2f3d84e767c9592b(span) {
    if (!(0, $9f8bd953fbcf4578$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $1ee319bdc991c767$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $1ee319bdc991c767$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $1ee319bdc991c767$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $a6a5519ecdda4b00$export$b77c830667a4d630(span) {
    if (!(0, $9f8bd953fbcf4578$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $1ee319bdc991c767$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $398c2530c60234a2$export$af88d00dbe7f521).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $8ade089ad3bed939$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $1487c3c693f88da4$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $4d1dc467e3505014$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}

















/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $de1249241011b35d$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $1ee319bdc991c767$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $8f43a3b4d13a578f$export$69cd5c610c7bb96a)]: value,
            [(0, $8f43a3b4d13a578f$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $de1249241011b35d$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $8f43a3b4d13a578f$export$f5f95cff026507b5];
        const value = attributes[0, $8f43a3b4d13a578f$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $3417f91dc0c855f8$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $3417f91dc0c855f8$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $f63023dba381e7e1$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $8f43a3b4d13a578f$export$cca8dd30f57f805e)]: "manual",
            [(0, $8f43a3b4d13a578f$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $1ee319bdc991c767$export$eb571cd9b5d98de8) : (0, $1ee319bdc991c767$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $1ee319bdc991c767$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $8f43a3b4d13a578f$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $1ee319bdc991c767$export$3f7581298f56c6d7)(endTimestamp);
        (0, $a6a5519ecdda4b00$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $8f43a3b4d13a578f$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $1ee319bdc991c767$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $8f43a3b4d13a578f$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $8f43a3b4d13a578f$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $8f43a3b4d13a578f$export$fea48ba9f4550879],
            measurements: (0, $de1249241011b35d$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $1ee319bdc991c767$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $3417f91dc0c855f8$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
        const attributes = $3417f91dc0c855f8$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $1ee319bdc991c767$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $3417f91dc0c855f8$var$sendSpanEnvelope((0, $dbe7a41cafcde3f0$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $dbcf9a18634e18af$export$c08fbc656a245d03)(this).scope || (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$3417f91dc0c855f8$var$isFullFinishedSpan((0, $1ee319bdc991c767$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $dbcf9a18634e18af$export$c08fbc656a245d03)(this);
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $1ee319bdc991c767$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$3417f91dc0c855f8$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $1ee319bdc991c767$export$92d8c23565496537)(span)).filter($3417f91dc0c855f8$var$isFullFinishedSpan);
        const source = this._attributes[0, $8f43a3b4d13a578f$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $8f43a3b4d13a578f$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $8f43a3b4d13a578f$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $1ee319bdc991c767$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $3417f91dc0c855f8$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $3417f91dc0c855f8$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $7d33670619390772$export$a117f995597e25df)(this)
            },
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $de1249241011b35d$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $3417f91dc0c855f8$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $3417f91dc0c855f8$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $3417f91dc0c855f8$var$isStandaloneSpan(span) {
    return span instanceof $3417f91dc0c855f8$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $3417f91dc0c855f8$var$sendSpanEnvelope(envelope) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $f1c0392c8b55e310$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f1c0392c8b55e310$export$a1bd95187356f372(options, callback) {
    const acs = $f1c0392c8b55e310$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $f1c0392c8b55e310$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $35358b2c9a559011$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $f1c0392c8b55e310$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
            const parentSpan = $f1c0392c8b55e310$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $bf604ce9a09041a2$export$d6636b700b76c516)() : $f1c0392c8b55e310$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $b0b16344a10224e3$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $1ee319bdc991c767$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f1c0392c8b55e310$export$c10292ad04b92aea(options, callback) {
    const acs = $f1c0392c8b55e310$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $f1c0392c8b55e310$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $35358b2c9a559011$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $f1c0392c8b55e310$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
            const parentSpan = $f1c0392c8b55e310$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $bf604ce9a09041a2$export$d6636b700b76c516)() : $f1c0392c8b55e310$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $b0b16344a10224e3$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $1ee319bdc991c767$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f1c0392c8b55e310$export$63dbba021a6b4047(options) {
    const acs = $f1c0392c8b55e310$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $f1c0392c8b55e310$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $35358b2c9a559011$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$f1c0392c8b55e310$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
        const parentSpan = $f1c0392c8b55e310$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $bf604ce9a09041a2$export$d6636b700b76c516)();
        return $f1c0392c8b55e310$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $f1c0392c8b55e310$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $b6af67124761d26b$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $f1c0392c8b55e310$export$e57ac09b143d92a2(span, callback) {
    const acs = $f1c0392c8b55e310$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
        (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $f1c0392c8b55e310$export$869298f9835abc68(callback) {
    const acs = $f1c0392c8b55e310$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$f1c0392c8b55e310$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $f1c0392c8b55e310$export$f90b03291402f553(callback) {
    return (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $f1c0392c8b55e310$export$e57ac09b143d92a2(null, callback);
    });
}
function $f1c0392c8b55e310$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $1487c3c693f88da4$export$1f70765132c3c225)()) {
        const span = new (0, $bf604ce9a09041a2$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $7d33670619390772$export$a117f995597e25df)(span)
            };
            (0, $7d33670619390772$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $35358b2c9a559011$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $f1c0392c8b55e310$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $1ee319bdc991c767$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $7d33670619390772$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $1ee319bdc991c767$export$5caecac1caaf3a71)(parentSpan);
        span = $f1c0392c8b55e310$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $7d33670619390772$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $f1c0392c8b55e310$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $7d33670619390772$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $a6a5519ecdda4b00$export$2f3d84e767c9592b)(span);
    (0, $dbcf9a18634e18af$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $f1c0392c8b55e310$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $1ee319bdc991c767$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $f1c0392c8b55e310$var$getAcs() {
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    return (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
}
function $f1c0392c8b55e310$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$f1c0392c8b55e310$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $8ade089ad3bed939$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        parentSampleRate: (0, $4d1dc467e3505014$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $3417f91dc0c855f8$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $8f43a3b4d13a578f$export$d7a7d984b0791405)]: "custom",
            [(0, $8f43a3b4d13a578f$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $f1c0392c8b55e310$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$f1c0392c8b55e310$var$SUPPRESS_TRACING_KEY] ? false : (0, $1ee319bdc991c767$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $3417f91dc0c855f8$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $bf604ce9a09041a2$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $1ee319bdc991c767$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $f1c0392c8b55e310$var$getParentSpan(scope) {
    const span = (0, $1783cf6bafc3a162$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $f1c0392c8b55e310$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $f1c0392c8b55e310$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}


const $e9a93295f98be17f$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $e9a93295f98be17f$var$FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const $e9a93295f98be17f$var$FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const $e9a93295f98be17f$var$FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const $e9a93295f98be17f$var$FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $e9a93295f98be17f$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $e9a93295f98be17f$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const _cleanupHooks = [];
    const { idleTimeout: idleTimeout = $e9a93295f98be17f$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $e9a93295f98be17f$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $e9a93295f98be17f$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!client || !(0, $1487c3c693f88da4$export$1f70765132c3c225)()) {
        const span = new (0, $bf604ce9a09041a2$export$d6636b700b76c516)();
        const dsc = {
            sample_rate: "0",
            sampled: "false",
            ...(0, $7d33670619390772$export$a117f995597e25df)(span)
        };
        (0, $7d33670619390772$export$7398c93e763ca9fd)(span, dsc);
        return span;
    }
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $1ee319bdc991c767$export$1be426a8e585c83e)();
    const span = $e9a93295f98be17f$var$_startIdleSpan(startSpanOptions);
    // We patch span.end to ensure we can run some things before the span is ended
    // eslint-disable-next-line @typescript-eslint/unbound-method
    span.end = new Proxy(span.end, {
        apply (target, thisArg, args) {
            if (beforeSpanEnd) beforeSpanEnd(span);
            // If the span is non-recording, nothing more to do here...
            // This is the case if tracing is enabled but this specific span was not sampled
            if (thisArg instanceof (0, $bf604ce9a09041a2$export$d6636b700b76c516)) return;
            // Just ensuring that this keeps working, even if we ever have more arguments here
            const [definedEndTimestamp, ...rest] = args;
            const timestamp = definedEndTimestamp || (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
            const spanEndTimestamp = (0, $1ee319bdc991c767$export$3f7581298f56c6d7)(timestamp);
            // Ensure we end with the last span timestamp, if possible
            const spans = (0, $1ee319bdc991c767$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
            // If we have no spans, we just end, nothing else to do here
            if (!spans.length) {
                onIdleSpanEnded(spanEndTimestamp);
                return Reflect.apply(target, thisArg, [
                    spanEndTimestamp,
                    ...rest
                ]);
            }
            const childEndTimestamps = spans.map((span)=>(0, $1ee319bdc991c767$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
            const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
            // In reality this should always exist here, but type-wise it may be undefined...
            const spanStartTimestamp = (0, $1ee319bdc991c767$export$92d8c23565496537)(span).start_timestamp;
            // The final endTimestamp should:
            // * Never be before the span start timestamp
            // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
            // * Otherwise be the passed end timestamp
            // Final timestamp can never be after finalTimeout
            const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
            onIdleSpanEnded(endTimestamp);
            return Reflect.apply(target, thisArg, [
                endTimestamp,
                ...rest
            ]);
        }
    });
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e9a93295f98be17f$var$FINISH_REASON_IDLE_TIMEOUT;
                span.end(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e9a93295f98be17f$var$FINISH_REASON_HEARTBEAT_FAILED;
                span.end(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $741f7992b965e3b0$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded(endTimestamp) {
        _finished = true;
        activities.clear();
        _cleanupHooks.forEach((cleanup)=>cleanup());
        (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $1ee319bdc991c767$export$92d8c23565496537)(span);
        const { start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!startTimestamp) return;
        const attributes = spanJSON.data;
        if (!attributes[0, $8f43a3b4d13a578f$export$ba73f34502b7a3b3]) span.setAttribute((0, $8f43a3b4d13a578f$export$ba73f34502b7a3b3), _finishReason);
        (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $1ee319bdc991c767$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
                    message: "cancelled"
                });
                childSpan.end(endTimestamp);
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $1ee319bdc991c767$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
            if (0, $9f8bd953fbcf4578$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $1ee319bdc991c767$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
    _cleanupHooks.push(client.on("spanStart", (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $1ee319bdc991c767$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $1ee319bdc991c767$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("spanEnd", (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
    }));
    _cleanupHooks.push(client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    }));
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
                message: "deadline_exceeded"
            });
            _finishReason = $e9a93295f98be17f$var$FINISH_REASON_FINAL_TIMEOUT;
            span.end();
        }
    }, finalTimeout);
    return span;
}
function $e9a93295f98be17f$var$_startIdleSpan(options) {
    const span = (0, $f1c0392c8b55e310$export$63dbba021a6b4047)(options);
    (0, $1783cf6bafc3a162$export$3f25fa50c18e20ca)((0, $35358b2c9a559011$export$c7be4b0125a10cba)(), span);
    (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log("[Tracing] Started span is an idle span");
    return span;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $3e94339ce228b519$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


// This is a magic string replaced by rollup
const $1e6a9e68e506a3a8$export$31499a9cd224b78c = "9.15.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $6529700b4f45af6c$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $6529700b4f45af6c$export$c8bfa33e4e8ae492((0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1));
    return 0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $6529700b4f45af6c$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $1e6a9e68e506a3a8$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $1e6a9e68e506a3a8$export$31499a9cd224b78c] = __SENTRY__[0, $1e6a9e68e506a3a8$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $6529700b4f45af6c$export$7e223ec222791509(name, creator, obj = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $1e6a9e68e506a3a8$export$31499a9cd224b78c] = __SENTRY__[0, $1e6a9e68e506a3a8$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}




/** Prefix for logging strings */ const $54bb708c4b877c1c$var$PREFIX = "Sentry Logger ";
const $54bb708c4b877c1c$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $54bb708c4b877c1c$export$77c4ce905194557b = {};
/** A Sentry Logger instance. */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $54bb708c4b877c1c$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($54bb708c4b877c1c$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $54bb708c4b877c1c$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $54bb708c4b877c1c$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $3e94339ce228b519$export$16a28057038b10ef) $54bb708c4b877c1c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = (...args)=>{
            if (enabled) $54bb708c4b877c1c$export$cda52e2a8927a2ca(()=>{
                (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1).console[name](`${$54bb708c4b877c1c$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $54bb708c4b877c1c$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 * The logger is a singleton on the carrier, to ensure that a consistent logger is used throughout the SDK.
 */ const $54bb708c4b877c1c$export$af88d00dbe7f521 = (0, $6529700b4f45af6c$export$7e223ec222791509)("logger", $54bb708c4b877c1c$var$makeLogger);


const $56a3da2c67ca3e0a$var$STACKTRACE_FRAME_LIMIT = 50;
const $56a3da2c67ca3e0a$export$27c7e15d453fc0ac = "?";
// Used to sanitize webpack (error: *) wrapped stack errors
const $56a3da2c67ca3e0a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $56a3da2c67ca3e0a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $56a3da2c67ca3e0a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $56a3da2c67ca3e0a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($56a3da2c67ca3e0a$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $56a3da2c67ca3e0a$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $56a3da2c67ca3e0a$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $56a3da2c67ca3e0a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $56a3da2c67ca3e0a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $56a3da2c67ca3e0a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($56a3da2c67ca3e0a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($56a3da2c67ca3e0a$var$STRIP_FRAME_REGEXP.test($56a3da2c67ca3e0a$var$getLastStackFrame(localStack).function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($56a3da2c67ca3e0a$var$STRIP_FRAME_REGEXP.test($56a3da2c67ca3e0a$var$getLastStackFrame(localStack).function || "")) localStack.pop();
    }
    return localStack.slice(0, $56a3da2c67ca3e0a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $56a3da2c67ca3e0a$var$getLastStackFrame(localStack).filename,
            function: frame.function || $56a3da2c67ca3e0a$export$27c7e15d453fc0ac
        }));
}
function $56a3da2c67ca3e0a$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $56a3da2c67ca3e0a$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $56a3da2c67ca3e0a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $56a3da2c67ca3e0a$var$defaultFunctionName;
        return fn.name || $56a3da2c67ca3e0a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $56a3da2c67ca3e0a$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $56a3da2c67ca3e0a$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch (_oO) {
            return undefined;
        }
    }
    return undefined;
}


// We keep the handlers globally
const $6be626ee95d0a821$var$handlers = {};
const $6be626ee95d0a821$var$instrumented = {};
/** Add a handler function. */ function $6be626ee95d0a821$export$a4e09611e30da72e(type, handler) {
    $6be626ee95d0a821$var$handlers[type] = $6be626ee95d0a821$var$handlers[type] || [];
    $6be626ee95d0a821$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $6be626ee95d0a821$export$b17eab759a1cb5fe() {
    Object.keys($6be626ee95d0a821$var$handlers).forEach((key)=>{
        $6be626ee95d0a821$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $6be626ee95d0a821$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$6be626ee95d0a821$var$instrumented[type]) {
        $6be626ee95d0a821$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $6be626ee95d0a821$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $6be626ee95d0a821$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $56a3da2c67ca3e0a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $682ef556f5df43ab$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$e6127cc7fe7395c3(wat) {
    switch($682ef556f5df43ab$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
        case "[object WebAssembly.Exception]":
            return true;
        default:
            return $682ef556f5df43ab$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$var$isBuiltin(wat, className) {
    return $682ef556f5df43ab$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$9f9636d330b71954(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$ef9e2056653f0c8e(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$12e869b2a583f783(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$844ec244b1367d54(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$c3825b437cbdea5c(wat) {
    return wat === null || $682ef556f5df43ab$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$53b83ca8eaab0383(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $682ef556f5df43ab$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $682ef556f5df43ab$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$49841c62b9eff15(wat) {
    return $682ef556f5df43ab$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $682ef556f5df43ab$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$bc2894c7158efbac(wat) {
    return $682ef556f5df43ab$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $682ef556f5df43ab$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $682ef556f5df43ab$export$6d3d1f317d7cda57(request) {
    return typeof Request !== "undefined" && $682ef556f5df43ab$export$49034edbe6b62415(request, Request);
}



const $8a17a2c5faee80df$var$WINDOW = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);
const $8a17a2c5faee80df$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8a17a2c5faee80df$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8a17a2c5faee80df$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8a17a2c5faee80df$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8a17a2c5faee80df$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($8a17a2c5faee80df$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $682ef556f5df43ab$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $8a17a2c5faee80df$export$1cfafeee2987818b() {
    try {
        return $8a17a2c5faee80df$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8a17a2c5faee80df$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8a17a2c5faee80df$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $37b654b5004401a2$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $37b654b5004401a2$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $37b654b5004401a2$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $682ef556f5df43ab$export$7916fad0ebc23f48)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $37b654b5004401a2$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $682ef556f5df43ab$export$844ec244b1367d54)(value)) return false;
    if ((0, $682ef556f5df43ab$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $682ef556f5df43ab$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $37b654b5004401a2$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$37b654b5004401a2$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $8f046eb992525fda$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== "function") return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $8f046eb992525fda$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $8f046eb992525fda$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $8f046eb992525fda$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $8f046eb992525fda$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $8f046eb992525fda$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $8f046eb992525fda$export$62ff257738bf57f5(value) {
    if ((0, $682ef556f5df43ab$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$8f046eb992525fda$var$getOwnProperties(value)
    };
    else if ((0, $682ef556f5df43ab$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $8f046eb992525fda$var$serializeEventTarget(value.target),
            currentTarget: $8f046eb992525fda$var$serializeEventTarget(value.currentTarget),
            ...$8f046eb992525fda$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $682ef556f5df43ab$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $8f046eb992525fda$var$serializeEventTarget(target) {
    try {
        return (0, $682ef556f5df43ab$export$45a5e7f76e0caa8d)(target) ? (0, $8a17a2c5faee80df$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $8f046eb992525fda$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $8f046eb992525fda$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($8f046eb992525fda$export$62ff257738bf57f5(exception));
    keys.sort();
    const firstKey = keys[0];
    if (!firstKey) return "[object has no keys]";
    if (firstKey.length >= maxLength) return (0, $37b654b5004401a2$export$6a506b36fdea397d)(firstKey, maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $37b654b5004401a2$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $8f046eb992525fda$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $8f046eb992525fda$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $8f046eb992525fda$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== "object") return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($8f046eb992525fda$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($8f046eb992525fda$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $8f046eb992525fda$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $8f046eb992525fda$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $8f046eb992525fda$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $682ef556f5df43ab$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




const $42d6ae1bbd19a79b$var$WINDOW = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$67fc34576016d6ec() {
    return "history" in $42d6ae1bbd19a79b$var$WINDOW && !!$42d6ae1bbd19a79b$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $42d6ae1bbd19a79b$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $42d6ae1bbd19a79b$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $42d6ae1bbd19a79b$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$42d6ae1bbd19a79b$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($42d6ae1bbd19a79b$export$d5f608b368e73f38($42d6ae1bbd19a79b$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $42d6ae1bbd19a79b$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $42d6ae1bbd19a79b$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$531055a6c684a70a() {
    return "ReportingObserver" in $42d6ae1bbd19a79b$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $42d6ae1bbd19a79b$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$42d6ae1bbd19a79b$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}



const $182fc35abbd0c773$export$56d8a8a25bd48b81 = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);


let $ef8ca1530ef1c35b$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ef8ca1530ef1c35b$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $6be626ee95d0a821$export$a4e09611e30da72e)(type, handler);
    (0, $6be626ee95d0a821$export$e18d6c5462c01368)(type, $ef8ca1530ef1c35b$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $ef8ca1530ef1c35b$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).addEventListener("popstate", ()=>{
        const to = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $ef8ca1530ef1c35b$var$lastHref;
        $ef8ca1530ef1c35b$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6be626ee95d0a821$export$b18c893e424d3127)("history", handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $42d6ae1bbd19a79b$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $ef8ca1530ef1c35b$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $ef8ca1530ef1c35b$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6be626ee95d0a821$export$b18c893e424d3127)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $8f046eb992525fda$export$9563e054e6f787fb)((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).history, "pushState", historyReplacementFunction);
    (0, $8f046eb992525fda$export$9563e054e6f787fb)((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).history, "replaceState", historyReplacementFunction);
}


const $528b979cf0f30a2b$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $528b979cf0f30a2b$export$7740643b9eeaf0c4() {
    return Date.now() / $528b979cf0f30a2b$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $528b979cf0f30a2b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);
    if (!performance?.now) return $528b979cf0f30a2b$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $528b979cf0f30a2b$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $528b979cf0f30a2b$export$ee52dced521e3e18 = $528b979cf0f30a2b$var$createUnixTimestampInSecondsFunc();
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $528b979cf0f30a2b$var$cachedTimeOrigin;
/**
 * Gets the time origin and the mode used to determine it.
 */ function $528b979cf0f30a2b$var$getBrowserTimeOrigin() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);
    if (!performance?.now) return [
        undefined,
        "none"
    ];
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) return [
            performance.timeOrigin,
            "timeOrigin"
        ];
        else return [
            navigationStart,
            "navigationStart"
        ];
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    return [
        dateNow,
        "dateNow"
    ];
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $528b979cf0f30a2b$export$baf075a948ffc0bf() {
    if (!$528b979cf0f30a2b$var$cachedTimeOrigin) $528b979cf0f30a2b$var$cachedTimeOrigin = $528b979cf0f30a2b$var$getBrowserTimeOrigin();
    return $528b979cf0f30a2b$var$cachedTimeOrigin[0];
}






function $a1e9951cf8b291e3$var$getCrypto() {
    const gbl = (0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $a1e9951cf8b291e3$export$19f53698e68b2496(crypto = $a1e9951cf8b291e3$var$getCrypto()) {
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto?.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto?.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $a1e9951cf8b291e3$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $a1e9951cf8b291e3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $a1e9951cf8b291e3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $a1e9951cf8b291e3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $a1e9951cf8b291e3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $a1e9951cf8b291e3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $a1e9951cf8b291e3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $a1e9951cf8b291e3$var$_parseInt(input) {
    return parseInt(input || "", 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $a1e9951cf8b291e3$export$d364f2020ab30578(input) {
    const match = input.match($a1e9951cf8b291e3$var$SEMVER_REGEXP) || [];
    const major = $a1e9951cf8b291e3$var$_parseInt(match[1]);
    const minor = $a1e9951cf8b291e3$var$_parseInt(match[2]);
    const patch = $a1e9951cf8b291e3$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $a1e9951cf8b291e3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $37b654b5004401a2$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $37b654b5004401a2$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $37b654b5004401a2$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $a1e9951cf8b291e3$export$6de4ffac6a2f1098(exception) {
    if ($a1e9951cf8b291e3$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $8f046eb992525fda$export$e73679ffaf56810e)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $a1e9951cf8b291e3$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e1b580affbe55c0d$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $528b979cf0f30a2b$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $a1e9951cf8b291e3$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e1b580affbe55c0d$var$sessionToJSON(session)
    };
    if (context) $e1b580affbe55c0d$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e1b580affbe55c0d$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $528b979cf0f30a2b$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $a1e9951cf8b291e3$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e1b580affbe55c0d$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $e1b580affbe55c0d$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e1b580affbe55c0d$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}


/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $40b76121f4ac8471$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $40b76121f4ac8471$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



const $6a3e52fbc3d4650d$var$SCOPE_SPAN_FIELD = "_sentrySpan";
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $6a3e52fbc3d4650d$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $8f046eb992525fda$export$e73679ffaf56810e)(scope, $6a3e52fbc3d4650d$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$6a3e52fbc3d4650d$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $6a3e52fbc3d4650d$export$91f063ebb8eff307(scope) {
    return scope[$6a3e52fbc3d4650d$var$SCOPE_SPAN_FIELD];
}






/**
 * Generate a random, valid trace ID.
 */ function $fd73118559ab89b8$export$dc6d7ea554bcce10() {
    return (0, $a1e9951cf8b291e3$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $fd73118559ab89b8$export$295213bc4d0c54ad() {
    return (0, $a1e9951cf8b291e3$export$19f53698e68b2496)().substring(16);
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $ad49023d58035baa$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $ad49023d58035baa$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $ad49023d58035baa$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $6a3e52fbc3d4650d$export$3f25fa50c18e20ca)(newScope, (0, $6a3e52fbc3d4650d$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $e1b580affbe55c0d$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $ad49023d58035baa$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $682ef556f5df43ab$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        (0, $6a3e52fbc3d4650d$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $ad49023d58035baa$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $528b979cf0f30a2b$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $37b654b5004401a2$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $6a3e52fbc3d4650d$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $40b76121f4ac8471$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $a1e9951cf8b291e3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $a1e9951cf8b291e3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $a1e9951cf8b291e3$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $0415d0a003f058ff$export$6f1b9191db9c4d5() {
    return (0, $6529700b4f45af6c$export$7e223ec222791509)("defaultCurrentScope", ()=>new (0, $ad49023d58035baa$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $0415d0a003f058ff$export$de9862929b76bf57() {
    return (0, $6529700b4f45af6c$export$7e223ec222791509)("defaultIsolationScope", ()=>new (0, $ad49023d58035baa$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $8fd52661ce4effa4$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $ad49023d58035baa$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $ad49023d58035baa$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $682ef556f5df43ab$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $8fd52661ce4effa4$var$getAsyncContextStack() {
    const registry = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const sentry = (0, $6529700b4f45af6c$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $8fd52661ce4effa4$export$d36ec451f120cfba((0, $0415d0a003f058ff$export$6f1b9191db9c4d5)(), (0, $0415d0a003f058ff$export$de9862929b76bf57)());
}
function $8fd52661ce4effa4$var$withScope(callback) {
    return $8fd52661ce4effa4$var$getAsyncContextStack().withScope(callback);
}
function $8fd52661ce4effa4$var$withSetScope(scope, callback) {
    const stack = $8fd52661ce4effa4$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $8fd52661ce4effa4$var$withIsolationScope(callback) {
    return $8fd52661ce4effa4$var$getAsyncContextStack().withScope(()=>{
        return callback($8fd52661ce4effa4$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $8fd52661ce4effa4$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $8fd52661ce4effa4$var$withIsolationScope,
        withScope: $8fd52661ce4effa4$var$withScope,
        withSetScope: $8fd52661ce4effa4$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $8fd52661ce4effa4$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$8fd52661ce4effa4$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$8fd52661ce4effa4$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $7d6cefe57a3645a9$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const sentry = (0, $6529700b4f45af6c$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $7d6cefe57a3645a9$export$f639b0c2752203be(carrier) {
    const sentry = (0, $6529700b4f45af6c$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $8fd52661ce4effa4$export$329d4d4d54e42710)();
}







/**
 * Get the currently active scope.
 */ function $c0d3f44efb0f3c56$export$c7be4b0125a10cba() {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $c0d3f44efb0f3c56$export$68f3af03034c9e90() {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $c0d3f44efb0f3c56$export$aa55d5ab8e05984f() {
    return (0, $6529700b4f45af6c$export$7e223ec222791509)("globalScope", ()=>new (0, $ad49023d58035baa$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $c0d3f44efb0f3c56$export$ec58d9285c204497(...rest) {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $c0d3f44efb0f3c56$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $c0d3f44efb0f3c56$export$6bb76d6eba7e258c() {
    return $c0d3f44efb0f3c56$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $c0d3f44efb0f3c56$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $fd73118559ab89b8$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $92e27a9fab466ddd$export$d7a7d984b0791405 = "sentry.source";
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $92e27a9fab466ddd$export$ccfe0a40627cc34b = "sentry.sample_rate";
/**
 * Use this attribute to represent the operation of a span.
 */ const $92e27a9fab466ddd$export$1a413bd9a88fdb09 = "sentry.op";
/**
 * Use this attribute to represent the origin of a span.
 */ const $92e27a9fab466ddd$export$cca8dd30f57f805e = "sentry.origin";
/** The reason why an idle span finished. */ const $92e27a9fab466ddd$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $92e27a9fab466ddd$export$f5f95cff026507b5 = "sentry.measurement_unit";
/** The value of a measurement, which may be stored as a TimedEvent. */ const $92e27a9fab466ddd$export$69cd5c610c7bb96a = "sentry.measurement_value";
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $92e27a9fab466ddd$export$165ce9a229f6f050 = "sentry.custom_span_name";
/**
 * The id of the profile that this span occurred in.
 */ const $92e27a9fab466ddd$export$1efec95406bbe327 = "sentry.profile_id";
const $92e27a9fab466ddd$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $92e27a9fab466ddd$export$b016f89ac1066ec = "cache.hit";
const $92e27a9fab466ddd$export$3110e4c3f4386399 = "cache.key";
const $92e27a9fab466ddd$export$86be76deee227ff2 = "cache.item_size";
/** TODO: Remove these once we update to latest semantic conventions */ const $92e27a9fab466ddd$export$be7a251980e7e946 = "http.request.method";
const $92e27a9fab466ddd$export$25dfd73e0e32c6e1 = "url.full";
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $92e27a9fab466ddd$export$ff77b5fd5b2d627b = "sentry.link.type";


const $ca59bae316f8754d$export$136e25984ba4a383 = 0;
const $ca59bae316f8754d$export$58f7963109c806fc = 1;
const $ca59bae316f8754d$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $ca59bae316f8754d$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $ca59bae316f8754d$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $ca59bae316f8754d$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $ca59bae316f8754d$export$f966a0446ece71e,
        message: "unknown_error"
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $ca59bae316f8754d$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $ca59bae316f8754d$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



const $92159b6863e41c19$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $92159b6863e41c19$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $92159b6863e41c19$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $8f046eb992525fda$export$e73679ffaf56810e)(span, $92159b6863e41c19$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $8f046eb992525fda$export$e73679ffaf56810e)(span, $92159b6863e41c19$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $92159b6863e41c19$export$c08fbc656a245d03(span) {
    return {
        scope: span[$92159b6863e41c19$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$92159b6863e41c19$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}






/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $9a9a3c9da0dde332$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}





const $521e2af83845e980$export$6e69537d67fa20f = "sentry-";
const $521e2af83845e980$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $521e2af83845e980$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $521e2af83845e980$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $521e2af83845e980$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($521e2af83845e980$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($521e2af83845e980$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $521e2af83845e980$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$521e2af83845e980$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $521e2af83845e980$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $521e2af83845e980$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $682ef556f5df43ab$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $521e2af83845e980$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $521e2af83845e980$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $521e2af83845e980$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $521e2af83845e980$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $521e2af83845e980$export$bdd844ddb2def819) {
            (0, $3e94339ce228b519$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $7b9cf718f8dd8fd4$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $7b9cf718f8dd8fd4$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($7b9cf718f8dd8fd4$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $7b9cf718f8dd8fd4$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $7b9cf718f8dd8fd4$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $521e2af83845e980$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)(),
        sampleRand: Math.random()
    };
    const sampleRand = $7b9cf718f8dd8fd4$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $7b9cf718f8dd8fd4$export$f35d907436da45cf(traceId = (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)(), spanId = (0, $fd73118559ab89b8$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $7b9cf718f8dd8fd4$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $9a9a3c9da0dde332$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $9a9a3c9da0dde332$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? Math.random() * parsedSampleRate : parsedSampleRate + Math.random() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return Math.random();
}



// These are aligned with OpenTelemetry trace flags
const $4660b91716a96fcf$export$208d5b368507fb8b = 0x0;
const $4660b91716a96fcf$export$eb571cd9b5d98de8 = 0x1;
let $4660b91716a96fcf$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $4660b91716a96fcf$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $4660b91716a96fcf$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $4660b91716a96fcf$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $4660b91716a96fcf$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $92159b6863e41c19$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $fd73118559ab89b8$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $4660b91716a96fcf$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $4660b91716a96fcf$export$5caecac1caaf3a71(span);
    return (0, $7b9cf718f8dd8fd4$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $4660b91716a96fcf$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $4660b91716a96fcf$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $4660b91716a96fcf$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $4660b91716a96fcf$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $4660b91716a96fcf$var$ensureTimestampInSeconds(input.getTime());
    return (0, $528b979cf0f30a2b$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $4660b91716a96fcf$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $4660b91716a96fcf$export$92d8c23565496537(span) {
    if ($4660b91716a96fcf$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($4660b91716a96fcf$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $4660b91716a96fcf$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $4660b91716a96fcf$export$3f7581298f56c6d7(endTime) || undefined,
            status: $4660b91716a96fcf$export$e238a77ea3a8cd66(status),
            op: attributes[0, $92e27a9fab466ddd$export$1a413bd9a88fdb09],
            origin: attributes[0, $92e27a9fab466ddd$export$cca8dd30f57f805e],
            links: $4660b91716a96fcf$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $4660b91716a96fcf$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $4660b91716a96fcf$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $4660b91716a96fcf$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $4660b91716a96fcf$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $4660b91716a96fcf$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $ca59bae316f8754d$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $ca59bae316f8754d$export$58f7963109c806fc)) return "ok";
    return status.message || "unknown_error";
}
const $4660b91716a96fcf$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $4660b91716a96fcf$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
/**
 * Adds an opaque child span reference to a span.
 */ function $4660b91716a96fcf$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$4660b91716a96fcf$var$ROOT_SPAN_FIELD] || span;
    (0, $8f046eb992525fda$export$e73679ffaf56810e)(childSpan, $4660b91716a96fcf$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD]) span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $8f046eb992525fda$export$e73679ffaf56810e)(span, $4660b91716a96fcf$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $4660b91716a96fcf$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD]) span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $4660b91716a96fcf$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($4660b91716a96fcf$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD] ? Array.from(span[$4660b91716a96fcf$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $4660b91716a96fcf$export$c4c6a79b1260ca1b(span) {
    return span[$4660b91716a96fcf$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $4660b91716a96fcf$export$1be426a8e585c83e() {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $6a3e52fbc3d4650d$export$91f063ebb8eff307)((0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $4660b91716a96fcf$export$d11691ff45a3e535() {
    if (!$4660b91716a96fcf$var$hasShownSpanDropWarning) {
        (0, $54bb708c4b877c1c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly.");
        });
        $4660b91716a96fcf$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $4660b91716a96fcf$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $92e27a9fab466ddd$export$d7a7d984b0791405)]: "custom",
        [(0, $92e27a9fab466ddd$export$165ce9a229f6f050)]: name
    });
}

// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $c0c425c759181a51$var$DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $c0c425c759181a51$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $c0c425c759181a51$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith("/");
    const base = urlBase ?? (isRelative ? $c0c425c759181a51$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $c0c425c759181a51$export$5339fcdc8e2a427c(url) {
    if ($c0c425c759181a51$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $c0c425c759181a51$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $c0c425c759181a51$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $c0c425c759181a51$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $22d5dde431646e59$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;





/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $7512c73a8402aa6c$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $4660b91716a96fcf$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $92e27a9fab466ddd$export$69cd5c610c7bb96a)]: value,
            [(0, $92e27a9fab466ddd$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $7512c73a8402aa6c$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $92e27a9fab466ddd$export$f5f95cff026507b5];
        const value = attributes[0, $92e27a9fab466ddd$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0ea1e843b9735ae3$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;




const $8ee020c393cf1243$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $8ee020c393cf1243$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $8ee020c393cf1243$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $a60bda32f1f3f1ae$export$407ea409d1f3b539 = ()=>{
    return `v4-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // sentry-specific change:
// add optional param to not check for responseStart (see comment below)
const $6784d3280d426bdc$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).performance?.getEntriesByType?.("navigation")[0];
    // Check to ensure the `responseStart` property is present and valid.
    // In some cases no value is reported by the browser (for
    // privacy/security reasons), and in other cases (bugs) the value is
    // negative or is larger than the current page time. Ignore these cases:
    // https://github.com/GoogleChrome/web-vitals/issues/137
    // https://github.com/GoogleChrome/web-vitals/issues/162
    // https://github.com/GoogleChrome/web-vitals/issues/275
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $96d3781462056436$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $6784d3280d426bdc$export$6431553786c94949)();
    return navEntry?.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $20af1dc0a383c9f6$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $6784d3280d426bdc$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.prerendering || (0, $96d3781462056436$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === "undefined" ? -1 : value,
        rating: "good",
        delta: 0,
        entries: entries,
        id: (0, $a60bda32f1f3f1ae$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $b15d200855dbe506$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Sentry-specific change:
// This function's logic was NOT updated to web-vitals 4.2.4 but we continue
// to use the web-vitals 3.5.2 due to us having stricter browser support.
// PR with context that made the changes: https://github.com/GoogleChrome/web-vitals/pull/442/files#r1530492402
// The PR removed listening to the `pagehide` event, in favour of only listening to `visibilitychange` event.
// This is "more correct" but some browsers we still support (Safari 12.1-14.0) don't fully support `visibilitychange`
// or have known bugs w.r.t the `visibilitychange` event.
// TODO (v9): If we decide to drop support for Safari 12.1-14.0, we can use the logic from web-vitals 4.2.4
// In this case, we also need to update the integration tests that currently trigger the `pagehide` event to
// simulate the page being hidden.
const $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb(event);
    };
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document) {
        addEventListener("visibilitychange", onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener("pagehide", onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $69a37cf506c43012$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return ()=>{
        if (!called) {
            cb();
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $bceed2da391084db$var$firstHiddenTime = -1;
const $bceed2da391084db$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    return (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && !(0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $bceed2da391084db$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document.visibilityState === "hidden" && $bceed2da391084db$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $bceed2da391084db$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        $bceed2da391084db$var$removeChangeListeners();
    }
};
const $bceed2da391084db$var$addChangeListeners = ()=>{
    addEventListener("visibilitychange", $bceed2da391084db$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener("prerenderingchange", $bceed2da391084db$var$onVisibilityUpdate, true);
};
const $bceed2da391084db$var$removeChangeListeners = ()=>{
    removeEventListener("visibilitychange", $bceed2da391084db$var$onVisibilityUpdate, true);
    removeEventListener("prerenderingchange", $bceed2da391084db$var$onVisibilityUpdate, true);
};
const $bceed2da391084db$export$443f86b2c77012c4 = ()=>{
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document && $bceed2da391084db$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $bceed2da391084db$var$firstHiddenTime = $bceed2da391084db$var$initHiddenTime();
        $bceed2da391084db$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $bceed2da391084db$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f6838e61a5330bf7$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $bd921df906acf937$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $bd921df906acf937$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $f6838e61a5330bf7$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bceed2da391084db$export$443f86b2c77012c4)();
        const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === "first-contentful-paint") {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $96d3781462056436$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $b15d200855dbe506$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $bd921df906acf937$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $b010e913223270ee$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $b010e913223270ee$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $bd921df906acf937$export$fe3c86b74e15d5de)((0, $69a37cf506c43012$export$b841d51e31c12bab)(()=>{
        const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("CLS", 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $b15d200855dbe506$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $b010e913223270ee$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $1cff7f6ce949dfa5$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $1cff7f6ce949dfa5$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $f6838e61a5330bf7$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bceed2da391084db$export$443f86b2c77012c4)();
        const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("FID");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $b15d200855dbe506$export$d1203567a167490e)("first-input", handleEntries);
        report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $1cff7f6ce949dfa5$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)((0, $69a37cf506c43012$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $95fd54e61c6fbd11$var$interactionCountEstimate = 0;
let $95fd54e61c6fbd11$var$minKnownInteractionId = Infinity;
let $95fd54e61c6fbd11$var$maxKnownInteractionId = 0;
const $95fd54e61c6fbd11$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $95fd54e61c6fbd11$var$minKnownInteractionId = Math.min($95fd54e61c6fbd11$var$minKnownInteractionId, e.interactionId);
            $95fd54e61c6fbd11$var$maxKnownInteractionId = Math.max($95fd54e61c6fbd11$var$maxKnownInteractionId, e.interactionId);
            $95fd54e61c6fbd11$var$interactionCountEstimate = $95fd54e61c6fbd11$var$maxKnownInteractionId ? ($95fd54e61c6fbd11$var$maxKnownInteractionId - $95fd54e61c6fbd11$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $95fd54e61c6fbd11$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $95fd54e61c6fbd11$export$8a962f2683a476d1 = ()=>{
    return $95fd54e61c6fbd11$var$po ? $95fd54e61c6fbd11$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $95fd54e61c6fbd11$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $95fd54e61c6fbd11$var$po) return;
    $95fd54e61c6fbd11$var$po = (0, $b15d200855dbe506$export$d1203567a167490e)("event", $95fd54e61c6fbd11$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER long.
const $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $1ae8dc85bcbbc480$export$7b86959c9ded44e2 = new Map();
// The default `durationThreshold` used across this library for observing
// `event` entries via PerformanceObserver.
const $1ae8dc85bcbbc480$export$9cebd8cf5d8d3416 = 40;
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
let $1ae8dc85bcbbc480$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $1ae8dc85bcbbc480$var$getInteractionCountForNavigation = ()=>{
    return (0, $95fd54e61c6fbd11$export$8a962f2683a476d1)() - $1ae8dc85bcbbc480$var$prevInteractionCount;
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $1ae8dc85bcbbc480$export$70cf089971ed4f82 = ()=>{
    const candidateInteractionIndex = Math.min($1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.length - 1, Math.floor($1ae8dc85bcbbc480$var$getInteractionCountForNavigation() / 50));
    return $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a[candidateInteractionIndex];
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $1ae8dc85bcbbc480$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
/**
 * A list of callback functions to run before each entry is processed.
 * Exposing this list allows the attribution build to hook into the
 * entry processing pipeline.
 */ const $1ae8dc85bcbbc480$export$1c74e929da1e189d = [];
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $1ae8dc85bcbbc480$export$6a7a48c2c643798f = (entry)=>{
    $1ae8dc85bcbbc480$export$1c74e929da1e189d.forEach((cb)=>cb(entry));
    // Skip further processing for entries that cannot be INP candidates.
    if (!(entry.interactionId || entry.entryType === "first-input")) return;
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a[$1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.length - 1];
    const existingInteraction = $1ae8dc85bcbbc480$export$7b86959c9ded44e2.get(entry.interactionId);
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.length < $1ae8dc85bcbbc480$var$MAX_INTERACTIONS_TO_CONSIDER || minLongestInteraction && entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            // If the new entry has a longer duration, replace the old entries,
            // otherwise add to the array.
            if (entry.duration > existingInteraction.latency) {
                existingInteraction.entries = [
                    entry
                ];
                existingInteraction.latency = entry.duration;
            } else if (entry.duration === existingInteraction.latency && entry.startTime === existingInteraction.entries[0]?.startTime) existingInteraction.entries.push(entry);
        } else {
            const interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $1ae8dc85bcbbc480$export$7b86959c9ded44e2.set(interaction.id, interaction);
            $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.sort((a, b)=>b.latency - a.latency);
        if ($1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.length > $1ae8dc85bcbbc480$var$MAX_INTERACTIONS_TO_CONSIDER) $1ae8dc85bcbbc480$export$fbb6a65efb09cd7a.splice($1ae8dc85bcbbc480$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>$1ae8dc85bcbbc480$export$7b86959c9ded44e2.delete(i.id));
    }
};









/*
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs the passed callback during the next idle period, or immediately
 * if the browser's visibility state is (or becomes) hidden.
 */ const $7eb3bab8ecc1e7e0$export$4d9952dcbf5b2792 = (cb)=>{
    const rIC = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).requestIdleCallback || (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).setTimeout;
    let handle = -1;
    // eslint-disable-next-line no-param-reassign
    cb = (0, $69a37cf506c43012$export$b841d51e31c12bab)(cb);
    // If the document is hidden, run the callback immediately, otherwise
    // race an idle callback with the next `visibilitychange` event.
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.visibilityState === "hidden") cb();
    else {
        handle = rIC(cb);
        (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)(cb);
    }
    return handle;
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $e26a63a6b542c59c$export$7f4cb060ded9173c = [
    200,
    500
];
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $e26a63a6b542c59c$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    // Return if the browser doesn't support all APIs needed to measure INP.
    if (!("PerformanceEventTiming" in (0, $182fc35abbd0c773$export$56d8a8a25bd48b81) && "interactionId" in PerformanceEventTiming.prototype)) return;
    (0, $f6838e61a5330bf7$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $95fd54e61c6fbd11$export$67d90cda6b78a2eb)();
        const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("INP");
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            // Queue the `handleEntries()` callback in the next idle task.
            // This is needed to increase the chances that all event entries that
            // occurred between the user interaction and the next paint
            // have been dispatched. Note: there is currently an experiment
            // running in Chrome (EventTimingKeypressAndCompositionInteractionId)
            // 123+ that if rolled out fully may make this no longer necessary.
            (0, $7eb3bab8ecc1e7e0$export$4d9952dcbf5b2792)(()=>{
                entries.forEach((0, $1ae8dc85bcbbc480$export$6a7a48c2c643798f));
                const inp = (0, $1ae8dc85bcbbc480$export$70cf089971ed4f82)();
                if (inp && inp.latency !== metric.value) {
                    metric.value = inp.latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $b15d200855dbe506$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : (0, $1ae8dc85bcbbc480$export$9cebd8cf5d8d3416)
        });
        report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $e26a63a6b542c59c$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // Also observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            po.observe({
                type: "first-input",
                buffered: true
            });
            (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};












/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $d5e25dd083821c1d$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $d5e25dd083821c1d$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $d5e25dd083821c1d$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $f6838e61a5330bf7$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $bceed2da391084db$export$443f86b2c77012c4)();
        const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("LCP");
        let report;
        const handleEntries = (entries)=>{
            // If reportAllChanges is set then call this function for each entry,
            // otherwise only consider the last one.
            if (!opts.reportAllChanges) // eslint-disable-next-line no-param-reassign
            entries = entries.slice(-1);
            entries.forEach((entry)=>{
                // Only report if the page wasn't hidden prior to LCP.
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was pre-rendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(entry.startTime - (0, $96d3781462056436$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            });
        };
        const po = (0, $b15d200855dbe506$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $d5e25dd083821c1d$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $69a37cf506c43012$export$b841d51e31c12bab)(()=>{
                if (!$d5e25dd083821c1d$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $d5e25dd083821c1d$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                "keydown",
                "click"
            ].forEach((type)=>{
                // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document) addEventListener(type, ()=>(0, $7eb3bab8ecc1e7e0$export$4d9952dcbf5b2792)(stopListening), {
                    once: true,
                    capture: true
                });
            });
            (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $19b950d7c99e898a$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $19b950d7c99e898a$var$whenReady = (callback)=>{
    if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.prerendering) (0, $f6838e61a5330bf7$export$8bdb38a5671b594e)(()=>$19b950d7c99e898a$var$whenReady(callback));
    else if ((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document?.readyState !== "complete") addEventListener("load", ()=>$19b950d7c99e898a$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $19b950d7c99e898a$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $20af1dc0a383c9f6$export$3c29b44508a0612b)("TTFB");
    const report = (0, $8ee020c393cf1243$export$17679dccdd551979)(onReport, metric, $19b950d7c99e898a$export$65c59ea8064668fc, opts.reportAllChanges);
    $19b950d7c99e898a$var$whenReady(()=>{
        const navigationEntry = (0, $6784d3280d426bdc$export$6431553786c94949)();
        if (navigationEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navigationEntry.responseStart - (0, $96d3781462056436$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $8d980b49ad0d4c02$var$handlers = {};
const $8d980b49ad0d4c02$var$instrumented = {};
let $8d980b49ad0d4c02$var$_previousCls;
let $8d980b49ad0d4c02$var$_previousFid;
let $8d980b49ad0d4c02$var$_previousLcp;
let $8d980b49ad0d4c02$var$_previousTtfb;
let $8d980b49ad0d4c02$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $8d980b49ad0d4c02$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $8d980b49ad0d4c02$var$addMetricObserver("cls", callback, $8d980b49ad0d4c02$var$instrumentCls, $8d980b49ad0d4c02$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $8d980b49ad0d4c02$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $8d980b49ad0d4c02$var$addMetricObserver("lcp", callback, $8d980b49ad0d4c02$var$instrumentLcp, $8d980b49ad0d4c02$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8d980b49ad0d4c02$export$2707d7471c0b918f(callback) {
    return $8d980b49ad0d4c02$var$addMetricObserver("fid", callback, $8d980b49ad0d4c02$var$instrumentFid, $8d980b49ad0d4c02$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $8d980b49ad0d4c02$export$699d9529c099a797(callback) {
    return $8d980b49ad0d4c02$var$addMetricObserver("ttfb", callback, $8d980b49ad0d4c02$var$instrumentTtfb, $8d980b49ad0d4c02$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8d980b49ad0d4c02$export$da3b76aa2022cbd7(callback) {
    return $8d980b49ad0d4c02$var$addMetricObserver("inp", callback, $8d980b49ad0d4c02$var$instrumentInp, $8d980b49ad0d4c02$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $8d980b49ad0d4c02$export$69816c1a049f8db6(type, callback) {
    $8d980b49ad0d4c02$var$addHandler(type, callback);
    if (!$8d980b49ad0d4c02$var$instrumented[type]) {
        $8d980b49ad0d4c02$var$instrumentPerformanceObserver(type);
        $8d980b49ad0d4c02$var$instrumented[type] = true;
    }
    return $8d980b49ad0d4c02$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $8d980b49ad0d4c02$var$triggerHandlers(type, data) {
    const typeHandlers = $8d980b49ad0d4c02$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $0ea1e843b9735ae3$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $56a3da2c67ca3e0a$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $8d980b49ad0d4c02$var$instrumentCls() {
    return (0, $b010e913223270ee$export$a7873055838e5ad8)((metric)=>{
        $8d980b49ad0d4c02$var$triggerHandlers("cls", {
            metric: metric
        });
        $8d980b49ad0d4c02$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $8d980b49ad0d4c02$var$instrumentFid() {
    return (0, $1cff7f6ce949dfa5$export$39705a25c49af873)((metric)=>{
        $8d980b49ad0d4c02$var$triggerHandlers("fid", {
            metric: metric
        });
        $8d980b49ad0d4c02$var$_previousFid = metric;
    });
}
function $8d980b49ad0d4c02$var$instrumentLcp() {
    return (0, $d5e25dd083821c1d$export$947b1626ab8d5632)((metric)=>{
        $8d980b49ad0d4c02$var$triggerHandlers("lcp", {
            metric: metric
        });
        $8d980b49ad0d4c02$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $8d980b49ad0d4c02$var$instrumentTtfb() {
    return (0, $19b950d7c99e898a$export$33a01e6c5f2c7e33)((metric)=>{
        $8d980b49ad0d4c02$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $8d980b49ad0d4c02$var$_previousTtfb = metric;
    });
}
function $8d980b49ad0d4c02$var$instrumentInp() {
    return (0, $e26a63a6b542c59c$export$7df4b36ecaed99e1)((metric)=>{
        $8d980b49ad0d4c02$var$triggerHandlers("inp", {
            metric: metric
        });
        $8d980b49ad0d4c02$var$_previousInp = metric;
    });
}
function $8d980b49ad0d4c02$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $8d980b49ad0d4c02$var$addHandler(type, callback);
    let stopListening;
    if (!$8d980b49ad0d4c02$var$instrumented[type]) {
        stopListening = instrumentFn();
        $8d980b49ad0d4c02$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $8d980b49ad0d4c02$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $8d980b49ad0d4c02$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === "event") options.durationThreshold = 0;
    (0, $b15d200855dbe506$export$d1203567a167490e)(type, (entries)=>{
        $8d980b49ad0d4c02$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $8d980b49ad0d4c02$var$addHandler(type, handler) {
    $8d980b49ad0d4c02$var$handlers[type] = $8d980b49ad0d4c02$var$handlers[type] || [];
    $8d980b49ad0d4c02$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $8d980b49ad0d4c02$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $8d980b49ad0d4c02$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
/**
 * Check if a PerformanceEntry is a PerformanceEventTiming by checking for the `duration` property.
 */ function $8d980b49ad0d4c02$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}








/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $1f21d30f3be1d8aa$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $1f21d30f3be1d8aa$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $1f21d30f3be1d8aa$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $682ef556f5df43ab$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $b93d6505505e56bc$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}
/**
 * @see JSDoc of `hasSpansEnabled`
 * @deprecated Use `hasSpansEnabled` instead, which is a more accurately named version of this function.
 * This function will be removed in the next major version of the SDK.
 */ // TODO(v10): Remove this export
const $b93d6505505e56bc$export$5008da00b1b6dee6 = $b93d6505505e56bc$export$1f70765132c3c225;








const $6842ffea8ca0c37e$export$849dbeeeda01ae98 = "production";









/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $e1a7a75cc40c6d4f$var$FROZEN_DSC_FIELD = "_frozenDsc";
/**
 * Freeze the given DSC on the given span.
 */ function $e1a7a75cc40c6d4f$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $8f046eb992525fda$export$e73679ffaf56810e)(spanWithMaybeDsc, $e1a7a75cc40c6d4f$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $e1a7a75cc40c6d4f$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $6842ffea8ca0c37e$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    };
    client.emit("createDsc", dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $e1a7a75cc40c6d4f$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $e1a7a75cc40c6d4f$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $e1a7a75cc40c6d4f$export$a117f995597e25df(span) {
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $4660b91716a96fcf$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $92e27a9fab466ddd$export$ccfe0a40627cc34b];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$e1a7a75cc40c6d4f$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get("sentry.dsc");
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $521e2af83845e980$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $e1a7a75cc40c6d4f$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $92e27a9fab466ddd$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $b93d6505505e56bc$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $4660b91716a96fcf$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $92159b6863e41c19$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $e1a7a75cc40c6d4f$export$95cf936fdacaff7b(span) {
    const dsc = $e1a7a75cc40c6d4f$export$a117f995597e25df(span);
    return (0, $521e2af83845e980$export$56766feef403f365)(dsc);
}





/**
 * Print a log message for a started span.
 */ function $f2712b8a9fb0ac03$export$2f3d84e767c9592b(span) {
    if (!(0, $22d5dde431646e59$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $4660b91716a96fcf$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $4660b91716a96fcf$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $4660b91716a96fcf$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join("\n  ")}`);
}
/**
 * Print a log message for an ended span.
 */ function $f2712b8a9fb0ac03$export$b77c830667a4d630(span) {
    if (!(0, $22d5dde431646e59$export$16a28057038b10ef)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $4660b91716a96fcf$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $f2527a88da765ead$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $b93d6505505e56bc$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $9a9a3c9da0dde332$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $a333ba4081cc7a4b$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $fd73118559ab89b8$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $4660b91716a96fcf$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}








/** Regular expression used to parse a Dsn. */ const $5207f0bebf5fc8cc$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $5207f0bebf5fc8cc$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $5207f0bebf5fc8cc$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $5207f0bebf5fc8cc$export$b892860177f70a30(str) {
    const match = $5207f0bebf5fc8cc$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $54bb708c4b877c1c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $5207f0bebf5fc8cc$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $5207f0bebf5fc8cc$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $5207f0bebf5fc8cc$var$validateDsn(dsn) {
    if (!(0, $3e94339ce228b519$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$5207f0bebf5fc8cc$var$isValidProtocol(protocol)) {
        (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $54bb708c4b877c1c$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $5207f0bebf5fc8cc$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $5207f0bebf5fc8cc$export$b892860177f70a30(from) : $5207f0bebf5fc8cc$var$dsnFromComponents(from);
    if (!components || !$5207f0bebf5fc8cc$var$validateDsn(components)) return undefined;
    return components;
}







/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $48d65d03e9e8d701$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $48d65d03e9e8d701$var$visit("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $48d65d03e9e8d701$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $48d65d03e9e8d701$export$a3295358bff77e(object, depth);
    if ($48d65d03e9e8d701$var$jsonSize(normalized) > maxSize) return $48d65d03e9e8d701$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $48d65d03e9e8d701$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $48d65d03e9e8d701$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "boolean",
        "string"
    ].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) return value;
    const stringified = $48d65d03e9e8d701$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $48d65d03e9e8d701$var$visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $8f046eb992525fda$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $48d65d03e9e8d701$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $48d65d03e9e8d701$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $682ef556f5df43ab$export$7916fad0ebc23f48)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $682ef556f5df43ab$export$bc2894c7158efbac)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === "function") return `[Function: ${(0, $56a3da2c67ca3e0a$export$aad197c7121a6651)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $48d65d03e9e8d701$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $48d65d03e9e8d701$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $48d65d03e9e8d701$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $48d65d03e9e8d701$var$jsonSize(value) {
    return $48d65d03e9e8d701$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $48d65d03e9e8d701$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
/**
 * Helper to decycle json objects
 */ function $48d65d03e9e8d701$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f6a8b674744e499c$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $f6a8b674744e499c$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $f6a8b674744e499c$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $f6a8b674744e499c$export$604a45d95a155e2b(envelope, types) {
    return $f6a8b674744e499c$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $f6a8b674744e499c$var$encodeUTF8(input) {
    const carrier = (0, $6529700b4f45af6c$export$c8bfa33e4e8ae492)((0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $f6a8b674744e499c$var$decodeUTF8(input) {
    const carrier = (0, $6529700b4f45af6c$export$c8bfa33e4e8ae492)((0, $6e431f7d8b2d22c0$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $f6a8b674744e499c$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $f6a8b674744e499c$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $f6a8b674744e499c$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $48d65d03e9e8d701$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $f6a8b674744e499c$var$concatBuffers(parts);
}
function $f6a8b674744e499c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $f6a8b674744e499c$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $f6a8b674744e499c$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($f6a8b674744e499c$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $f6a8b674744e499c$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $f6a8b674744e499c$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $f6a8b674744e499c$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $f6a8b674744e499c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    raw_security: "security",
    otel_log: "log_item"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $f6a8b674744e499c$export$b11169581eeaf237(type) {
    return $f6a8b674744e499c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $f6a8b674744e499c$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $f6a8b674744e499c$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5207f0bebf5fc8cc$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $6d38b9f6e0136e65$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $6d38b9f6e0136e65$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f6a8b674744e499c$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5207f0bebf5fc8cc$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $f6a8b674744e499c$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $6d38b9f6e0136e65$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $f6a8b674744e499c$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $6d38b9f6e0136e65$var$enhanceEventWithSdkInfo(event, metadata?.sdk);
    const envelopeHeaders = (0, $f6a8b674744e499c$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $f6a8b674744e499c$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $6d38b9f6e0136e65$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $e1a7a75cc40c6d4f$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $5207f0bebf5fc8cc$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client?.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $4660b91716a96fcf$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $4660b91716a96fcf$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $4660b91716a96fcf$export$92d8c23565496537);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $f6a8b674744e499c$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $f6a8b674744e499c$export$f93f7f385160c44e)(headers, items);
}











const $afaf2723a1c07b2b$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $afaf2723a1c07b2b$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $fd73118559ab89b8$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $528b979cf0f30a2b$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "manual",
            [(0, $92e27a9fab466ddd$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $4660b91716a96fcf$export$eb571cd9b5d98de8) : (0, $4660b91716a96fcf$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $4660b91716a96fcf$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $92e27a9fab466ddd$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $4660b91716a96fcf$export$3f7581298f56c6d7)(endTimestamp);
        (0, $f2712b8a9fb0ac03$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $92e27a9fab466ddd$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $4660b91716a96fcf$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $92e27a9fab466ddd$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $92e27a9fab466ddd$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $92e27a9fab466ddd$export$fea48ba9f4550879],
            measurements: (0, $7512c73a8402aa6c$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $4660b91716a96fcf$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log("[Tracing] Adding an event to span:", name);
        const time = $afaf2723a1c07b2b$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $528b979cf0f30a2b$export$ee52dced521e3e18)();
        const attributes = $afaf2723a1c07b2b$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $4660b91716a96fcf$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
        if (client) client.emit("spanEnd", this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $afaf2723a1c07b2b$var$sendSpanEnvelope((0, $6d38b9f6e0136e65$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $92159b6863e41c19$export$c08fbc656a245d03)(this).scope || (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$afaf2723a1c07b2b$var$isFullFinishedSpan((0, $4660b91716a96fcf$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $92159b6863e41c19$export$c08fbc656a245d03)(this);
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $4660b91716a96fcf$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$afaf2723a1c07b2b$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $4660b91716a96fcf$export$92d8c23565496537)(span)).filter($afaf2723a1c07b2b$var$isFullFinishedSpan);
        const source = this._attributes[0, $92e27a9fab466ddd$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $92e27a9fab466ddd$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $92e27a9fab466ddd$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $4660b91716a96fcf$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $afaf2723a1c07b2b$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $afaf2723a1c07b2b$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $e1a7a75cc40c6d4f$export$a117f995597e25df)(this)
            },
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $7512c73a8402aa6c$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $afaf2723a1c07b2b$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $afaf2723a1c07b2b$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $afaf2723a1c07b2b$var$isStandaloneSpan(span) {
    return span instanceof $afaf2723a1c07b2b$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $afaf2723a1c07b2b$var$sendSpanEnvelope(envelope) {
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $2c14b4f71cabe06c$var$SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $2c14b4f71cabe06c$export$a1bd95187356f372(options, callback) {
    const acs = $2c14b4f71cabe06c$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $2c14b4f71cabe06c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $2c14b4f71cabe06c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)();
            const parentSpan = $2c14b4f71cabe06c$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $a333ba4081cc7a4b$export$d6636b700b76c516)() : $2c14b4f71cabe06c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $6a3e52fbc3d4650d$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $1f21d30f3be1d8aa$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4660b91716a96fcf$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $ca59bae316f8754d$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $2c14b4f71cabe06c$export$c10292ad04b92aea(options, callback) {
    const acs = $2c14b4f71cabe06c$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $2c14b4f71cabe06c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $2c14b4f71cabe06c$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)();
            const parentSpan = $2c14b4f71cabe06c$var$getParentSpan(scope);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $a333ba4081cc7a4b$export$d6636b700b76c516)() : $2c14b4f71cabe06c$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $6a3e52fbc3d4650d$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $1f21d30f3be1d8aa$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $4660b91716a96fcf$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $ca59bae316f8754d$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $2c14b4f71cabe06c$export$63dbba021a6b4047(options) {
    const acs = $2c14b4f71cabe06c$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $2c14b4f71cabe06c$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $c0d3f44efb0f3c56$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$2c14b4f71cabe06c$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)();
        const parentSpan = $2c14b4f71cabe06c$var$getParentSpan(scope);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $a333ba4081cc7a4b$export$d6636b700b76c516)();
        return $2c14b4f71cabe06c$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $2c14b4f71cabe06c$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    const acs = (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $7b9cf718f8dd8fd4$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $2c14b4f71cabe06c$export$e57ac09b143d92a2(span, callback) {
    const acs = $2c14b4f71cabe06c$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)((scope)=>{
        (0, $6a3e52fbc3d4650d$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $2c14b4f71cabe06c$export$869298f9835abc68(callback) {
    const acs = $2c14b4f71cabe06c$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$2c14b4f71cabe06c$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $2c14b4f71cabe06c$export$f90b03291402f553(callback) {
    return (0, $c0d3f44efb0f3c56$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $fd73118559ab89b8$export$dc6d7ea554bcce10)(),
            sampleRand: Math.random()
        });
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).info(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $2c14b4f71cabe06c$export$e57ac09b143d92a2(null, callback);
    });
}
function $2c14b4f71cabe06c$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $b93d6505505e56bc$export$1f70765132c3c225)()) {
        const span = new (0, $a333ba4081cc7a4b$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: "false",
                sample_rate: "0",
                transaction: spanArguments.name,
                ...(0, $e1a7a75cc40c6d4f$export$a117f995597e25df)(span)
            };
            (0, $e1a7a75cc40c6d4f$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $c0d3f44efb0f3c56$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $2c14b4f71cabe06c$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $4660b91716a96fcf$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $e1a7a75cc40c6d4f$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $4660b91716a96fcf$export$5caecac1caaf3a71)(parentSpan);
        span = $2c14b4f71cabe06c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $e1a7a75cc40c6d4f$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $2c14b4f71cabe06c$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $e1a7a75cc40c6d4f$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $f2712b8a9fb0ac03$export$2f3d84e767c9592b)(span);
    (0, $92159b6863e41c19$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $2c14b4f71cabe06c$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $4660b91716a96fcf$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $2c14b4f71cabe06c$var$getAcs() {
    const carrier = (0, $6529700b4f45af6c$export$19eade501500c6c1)();
    return (0, $7d6cefe57a3645a9$export$f639b0c2752203be)(carrier);
}
function $2c14b4f71cabe06c$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "", attributes: attributes } = spanArguments;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$2c14b4f71cabe06c$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $f2527a88da765ead$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        parentSampleRate: (0, $9a9a3c9da0dde332$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $afaf2723a1c07b2b$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $92e27a9fab466ddd$export$d7a7d984b0791405)]: "custom",
            [(0, $92e27a9fab466ddd$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $22d5dde431646e59$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", "transaction");
    }
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $2c14b4f71cabe06c$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$2c14b4f71cabe06c$var$SUPPRESS_TRACING_KEY] ? false : (0, $4660b91716a96fcf$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $afaf2723a1c07b2b$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $a333ba4081cc7a4b$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $4660b91716a96fcf$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit("spanStart", childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit("spanEnd", childSpan);
    }
    return childSpan;
}
function $2c14b4f71cabe06c$var$getParentSpan(scope) {
    const span = (0, $6a3e52fbc3d4650d$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $2c14b4f71cabe06c$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $2c14b4f71cabe06c$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}



/**
 * Checks if a given value is a valid measurement value.
 */ function $a340b0900733c299$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $a340b0900733c299$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $4660b91716a96fcf$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $2c14b4f71cabe06c$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $2c14b4f71cabe06c$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/**
 * Starts an inactive, standalone span used to send web vital values to Sentry.
 * DO NOT use this for arbitrary spans, as these spans require special handling
 * during ingestion to extract metrics.
 *
 * This function adds a bunch of attributes and data to the span that's shared
 * by all web vital standalone spans. However, you need to take care of adding
 * the actual web vital value as an event to the span. Also, you need to assign
 * a transaction name and some other values that are specific to the web vital.
 *
 * Ultimately, you also need to take care of ending the span to send it off.
 *
 * @param options
 *
 * @returns an inactive, standalone and NOT YET ended span
 */ function $a340b0900733c299$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment, sendDefaultPii: sendDefaultPii } = client.getOptions();
    // We need to get the replay, user, and activeTransaction from the current scope
    // so that we can associate replay id, profile id, and a user display to the span
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    let profileId;
    try {
        // @ts-expect-error skip optional chaining to save bundle size with try catch
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {
    // do nothing
    }
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || undefined,
        profile_id: profileId || undefined,
        replay_id: replayId || undefined,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": sendDefaultPii ? "{{auto}}" : undefined,
        ...passedAttributes
    };
    return (0, $2c14b4f71cabe06c$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
/** Get the browser performance API. */ function $a340b0900733c299$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).addEventListener && (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $a340b0900733c299$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $a340b0900733c299$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}



/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value once
 *
 * - the page visibility is hidden
 * - a navigation span is started (to stop CLS measurement for SPA soft navigations)
 *
 * Once either of these events triggers, the CLS value is sent as a standalone span and we stop
 * measuring CLS.
 */ function $0b87c2460a8b68e1$export$585bab03c6c18c45() {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    let pageloadSpanId;
    if (!$0b87c2460a8b68e1$var$supportsLayoutShift()) return;
    let sentSpan = false;
    function _collectClsOnce() {
        if (sentSpan) return;
        sentSpan = true;
        if (pageloadSpanId) $0b87c2460a8b68e1$var$sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId);
        cleanupClsHandler();
    }
    const cleanupClsHandler = (0, $8d980b49ad0d4c02$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    // use pagehide event from web-vitals
    (0, $be1b7b0abbd1d3bc$export$91ec2be6fdd8f1b4)(()=>{
        _collectClsOnce();
    });
    // Since the call chain of this function is synchronous and evaluates before the SDK client is created,
    // we need to wait with subscribing to a client hook until the client is created. Therefore, we defer
    // to the next tick after the SDK setup.
    setTimeout(()=>{
        const client = (0, $c0d3f44efb0f3c56$export$6bb76d6eba7e258c)();
        if (!client) return;
        const unsubscribeStartNavigation = client.on("startNavigationSpan", ()=>{
            _collectClsOnce();
            unsubscribeStartNavigation?.();
        });
        const activeSpan = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        if (activeSpan) {
            const rootSpan = (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(activeSpan);
            const spanJSON = (0, $4660b91716a96fcf$export$92d8c23565496537)(rootSpan);
            if (spanJSON.op === "pageload") pageloadSpanId = rootSpan.spanContext().spanId;
        }
    }, 0);
}
function $0b87c2460a8b68e1$var$sendStandaloneClsSpan(clsValue, entry, pageloadSpanId) {
    (0, $0ea1e843b9735ae3$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).log(`Sending CLS span (${clsValue})`);
    const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $8a17a2c5faee80df$export$5647df6b7814ac86)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $92e27a9fab466ddd$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $92e27a9fab466ddd$export$fea48ba9f4550879)]: entry?.duration || 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId
    };
    const span = (0, $a340b0900733c299$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $92e27a9fab466ddd$export$f5f95cff026507b5)]: "",
            [(0, $92e27a9fab466ddd$export$69cd5c610c7bb96a)]: clsValue
        });
        // LayoutShift performance entries always have a duration of 0, so we don't need to add `entry.duration` here
        // see: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/duration
        span.end(startTime);
    }
}
function $0b87c2460a8b68e1$var$supportsLayoutShift() {
    try {
        return PerformanceObserver.supportedEntryTypes.includes("layout-shift");
    } catch  {
        return false;
    }
}







const $76d0462c99f715f1$var$MAX_INT_AS_BYTES = 2147483647;
let $76d0462c99f715f1$var$_performanceCursor = 0;
let $76d0462c99f715f1$var$_measurements = {};
let $76d0462c99f715f1$var$_lcpEntry;
let $76d0462c99f715f1$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $76d0462c99f715f1$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans }) {
    const performance = (0, $a340b0900733c299$export$f72a13c439a30cab)();
    if (performance && (0, $528b979cf0f30a2b$export$baf075a948ffc0bf)()) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).performance.mark("sentry-tracing-init");
        const fidCleanupCallback = $76d0462c99f715f1$var$_trackFID();
        const lcpCleanupCallback = $76d0462c99f715f1$var$_trackLCP();
        const ttfbCleanupCallback = $76d0462c99f715f1$var$_trackTtfb();
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $0b87c2460a8b68e1$export$585bab03c6c18c45)() : $76d0462c99f715f1$var$_trackCLS();
        return ()=>{
            fidCleanupCallback();
            lcpCleanupCallback();
            ttfbCleanupCallback();
            clsCleanupCallback?.();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $76d0462c99f715f1$export$f396d19077034ad2() {
    (0, $8d980b49ad0d4c02$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $4660b91716a96fcf$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $a340b0900733c299$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
/**
 * Start tracking long animation frames.
 */ function $76d0462c99f715f1$export$5b823ab2ccbc801d() {
    // NOTE: the current web-vitals version (3.5.2) does not support long-animation-frame, so
    // we directly observe `long-animation-frame` events instead of through the web-vitals
    // `observe` helper function.
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $4660b91716a96fcf$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $a340b0900733c299$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
/**
 * Start tracking interaction events.
 */ function $76d0462c99f715f1$export$e27543e0976315e4() {
    (0, $8d980b49ad0d4c02$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)() + entry.startTime);
            const duration = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $8a17a2c5faee80df$export$5647df6b7814ac86)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $8a17a2c5faee80df$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $a340b0900733c299$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
/**
 * Starts tracking the Cumulative Layout Shift on the current page and collects the value and last entry
 * to the `_measurements` object which ultimately is applied to the pageload span's measurements.
 */ function $76d0462c99f715f1$var$_trackCLS() {
    return (0, $8d980b49ad0d4c02$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $76d0462c99f715f1$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $76d0462c99f715f1$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $76d0462c99f715f1$var$_trackLCP() {
    return (0, $8d980b49ad0d4c02$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $76d0462c99f715f1$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $76d0462c99f715f1$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $76d0462c99f715f1$var$_trackFID() {
    return (0, $8d980b49ad0d4c02$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $a340b0900733c299$export$b4785dbd4a81b33f)((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)());
        const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.startTime);
        $76d0462c99f715f1$var$_measurements["fid"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $76d0462c99f715f1$var$_measurements["mark.fid"] = {
            value: timeOrigin + startTime,
            unit: "second"
        };
    });
}
function $76d0462c99f715f1$var$_trackTtfb() {
    return (0, $8d980b49ad0d4c02$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $76d0462c99f715f1$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
/** Add performance related spans to a transaction */ function $76d0462c99f715f1$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $a340b0900733c299$export$f72a13c439a30cab)();
    const origin = (0, $528b979cf0f30a2b$export$baf075a948ffc0bf)();
    if (!performance?.getEntries || !origin) // Gatekeeper if performance API not available
    return;
    const timeOrigin = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $4660b91716a96fcf$export$92d8c23565496537)(span);
    performanceEntries.slice($76d0462c99f715f1$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $76d0462c99f715f1$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                {
                    $76d0462c99f715f1$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $bceed2da391084db$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === "first-paint" && shouldRecord) $76d0462c99f715f1$var$_measurements["fp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    if (entry.name === "first-contentful-paint" && shouldRecord) $76d0462c99f715f1$var$_measurements["fcp"] = {
                        value: entry.startTime,
                        unit: "millisecond"
                    };
                    break;
                }
            case "resource":
                $76d0462c99f715f1$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $76d0462c99f715f1$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $76d0462c99f715f1$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === "pageload") {
        $76d0462c99f715f1$var$_addTtfbRequestTimeToMeasurements($76d0462c99f715f1$var$_measurements);
        const fidMark = $76d0462c99f715f1$var$_measurements["mark.fid"];
        if (fidMark && $76d0462c99f715f1$var$_measurements["fid"]) {
            // create span for FID
            (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $a340b0900733c299$export$b4785dbd4a81b33f)($76d0462c99f715f1$var$_measurements["fid"].value), {
                name: "first input delay",
                op: "ui.action",
                attributes: {
                    [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $76d0462c99f715f1$var$_measurements["mark.fid"];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        // TODO: Check if the first condition is still necessary: `onCLS` already only fires once `onFCP` was called.
        if (!("fcp" in $76d0462c99f715f1$var$_measurements) || !options.recordClsOnPageloadSpan) delete $76d0462c99f715f1$var$_measurements.cls;
        Object.entries($76d0462c99f715f1$var$_measurements).forEach(([measurementName, measurement])=>{
            (0, $7512c73a8402aa6c$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit);
        });
        // Set timeOrigin which denotes the timestamp which to base the LCP/FCP/FP/TTFB measurements on
        span.setAttribute("performance.timeOrigin", timeOrigin);
        // In prerendering scenarios, where a page might be prefetched and pre-rendered before the user clicks the link,
        // the navigation starts earlier than when the user clicks it. Web Vitals should always be based on the
        // user-perceived time, so they are not reported from the actual start of the navigation, but rather from the
        // time where the user actively started the navigation, for example by clicking a link.
        // This is user action is called "activation" and the time between navigation and activation is stored in
        // the `activationStart` attribute of the "navigation" PerformanceEntry.
        span.setAttribute("performance.activationStart", (0, $96d3781462056436$export$d3e828b3c7b5b845)());
        $76d0462c99f715f1$var$_setWebVitalAttributes(span);
    }
    $76d0462c99f715f1$var$_lcpEntry = undefined;
    $76d0462c99f715f1$var$_clsEntry = undefined;
    $76d0462c99f715f1$var$_measurements = {};
}
/**
 * Create measure related spans.
 * Exported only for tests.
 */ function $76d0462c99f715f1$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin) {
    const navEntry = (0, $6784d3280d426bdc$export$6431553786c94949)(false);
    const requestTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    // Because performance.measure accepts arbitrary timestamps it can produce
    // spans that happen before the browser even makes a request for the page.
    //
    // An example of this is the automatically generated Next.js-before-hydration
    // spans created by the Next.js framework.
    //
    // To prevent this we will pin the start timestamp to the request start time
    // This does make duration inaccurate, so if this does happen, we will add
    // an attribute to the span
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    // Measurements from third parties can be off, which would create invalid spans, dropping transactions in the process.
    if (measureStartTimestamp <= measureEndTimestamp) (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
/**
 * Instrument navigation entries
 * exported only for tests
 */ function $76d0462c99f715f1$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $76d0462c99f715f1$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $76d0462c99f715f1$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $76d0462c99f715f1$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $76d0462c99f715f1$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $76d0462c99f715f1$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $76d0462c99f715f1$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $76d0462c99f715f1$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, timeOrigin + (0, $a340b0900733c299$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $a340b0900733c299$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $76d0462c99f715f1$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
/** Create request and response related spans */ function $76d0462c99f715f1$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $a340b0900733c299$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
/**
 * Create resource-related spans.
 * Exported only for tests.
 */ function $76d0462c99f715f1$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const parsedUrl = (0, $c0c425c759181a51$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    $76d0462c99f715f1$var$setResourceEntrySizeData(attributes, entry, "transferSize", "http.response_transfer_size");
    $76d0462c99f715f1$var$setResourceEntrySizeData(attributes, entry, "encodedBodySize", "http.response_content_length");
    $76d0462c99f715f1$var$setResourceEntrySizeData(attributes, entry, "decodedBodySize", "http.decoded_response_content_length");
    // `deliveryType` is experimental and does not exist everywhere
    const deliveryType = entry.deliveryType;
    if (deliveryType != null) attributes["http.response_delivery_type"] = deliveryType;
    // Types do not reflect this property yet
    const renderBlockingStatus = entry.renderBlockingStatus;
    if (renderBlockingStatus) attributes["resource.render_blocking_status"] = renderBlockingStatus;
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).location.origin);
    const { name: name, version: version } = (0, $a340b0900733c299$export$57c6f824442f9fe1)(entry.nextHopProtocol);
    attributes["network.protocol.name"] = name;
    attributes["network.protocol.version"] = version;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $a340b0900733c299$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $182fc35abbd0c773$export$56d8a8a25bd48b81).location.origin, ""),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other",
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $76d0462c99f715f1$var$_trackNavigator(span) {
    const navigator = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute("effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute("connectionType", connection.type);
        if ((0, $a340b0900733c299$export$27169ccae1b439e3)(connection.rtt)) $76d0462c99f715f1$var$_measurements["connection.rtt"] = {
            value: connection.rtt,
            unit: "millisecond"
        };
    }
    if ((0, $a340b0900733c299$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    if ((0, $a340b0900733c299$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $76d0462c99f715f1$var$_setWebVitalAttributes(span) {
    if ($76d0462c99f715f1$var$_lcpEntry) {
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($76d0462c99f715f1$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $8a17a2c5faee80df$export$5647df6b7814ac86)($76d0462c99f715f1$var$_lcpEntry.element));
        if ($76d0462c99f715f1$var$_lcpEntry.id) span.setAttribute("lcp.id", $76d0462c99f715f1$var$_lcpEntry.id);
        if ($76d0462c99f715f1$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute("lcp.url", $76d0462c99f715f1$var$_lcpEntry.url.trim().slice(0, 200));
        if ($76d0462c99f715f1$var$_lcpEntry.loadTime != null) // loadTime is the time of LCP that's related to receiving the LCP element response..
        span.setAttribute("lcp.loadTime", $76d0462c99f715f1$var$_lcpEntry.loadTime);
        if ($76d0462c99f715f1$var$_lcpEntry.renderTime != null) // renderTime is loadTime + rendering time
        // it's 0 if the LCP element is loaded from a 3rd party origin that doesn't send the
        // `Timing-Allow-Origin` header.
        span.setAttribute("lcp.renderTime", $76d0462c99f715f1$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $76d0462c99f715f1$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($76d0462c99f715f1$var$_clsEntry?.sources) $76d0462c99f715f1$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $8a17a2c5faee80df$export$5647df6b7814ac86)(source.node)));
}
function $76d0462c99f715f1$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $76d0462c99f715f1$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $76d0462c99f715f1$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $6784d3280d426bdc$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}




const $2a04f991ee2ae672$var$LAST_INTERACTIONS = [];
const $2a04f991ee2ae672$var$INTERACTIONS_SPAN_MAP = new Map();
/**
 * Start tracking INP webvital events.
 */ function $2a04f991ee2ae672$export$f17d06681a4744a3() {
    const performance = (0, $a340b0900733c299$export$f72a13c439a30cab)();
    if (performance && (0, $528b979cf0f30a2b$export$baf075a948ffc0bf)()) {
        const inpCallback = $2a04f991ee2ae672$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $2a04f991ee2ae672$var$INP_ENTRY_MAP = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $2a04f991ee2ae672$var$_trackINP() {
    return (0, $8d980b49ad0d4c02$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $2a04f991ee2ae672$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const { interactionId: interactionId } = entry;
        const interactionType = $2a04f991ee2ae672$var$INP_ENTRY_MAP[entry.name];
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $a340b0900733c299$export$b4785dbd4a81b33f)((0, $528b979cf0f30a2b$export$baf075a948ffc0bf)() + entry.startTime);
        const duration = (0, $a340b0900733c299$export$b4785dbd4a81b33f)(metric.value);
        const activeSpan = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        // We first try to lookup the span from our INTERACTIONS_SPAN_MAP,
        // where we cache the route per interactionId
        const cachedSpan = interactionId != null ? $2a04f991ee2ae672$var$INTERACTIONS_SPAN_MAP.get(interactionId) : undefined;
        const spanToUse = cachedSpan || rootSpan;
        // Else, we try to use the active span.
        // Finally, we fall back to look at the transactionName on the scope
        const routeName = spanToUse ? (0, $4660b91716a96fcf$export$92d8c23565496537)(spanToUse).description : (0, $c0d3f44efb0f3c56$export$c7be4b0125a10cba)().getScopeData().transactionName;
        const name = (0, $8a17a2c5faee80df$export$5647df6b7814ac86)(entry.target);
        const attributes = {
            [(0, $92e27a9fab466ddd$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
            [(0, $92e27a9fab466ddd$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
            [(0, $92e27a9fab466ddd$export$fea48ba9f4550879)]: entry.duration
        };
        const span = (0, $a340b0900733c299$export$b71b9c7b60c5a4aa)({
            name: name,
            transaction: routeName,
            attributes: attributes,
            startTime: startTime
        });
        if (span) {
            span.addEvent("inp", {
                [(0, $92e27a9fab466ddd$export$f5f95cff026507b5)]: "millisecond",
                [(0, $92e27a9fab466ddd$export$69cd5c610c7bb96a)]: metric.value
            });
            span.end(startTime + duration);
        }
    });
}
/**
 * Register a listener to cache route information for INP interactions.
 */ function $2a04f991ee2ae672$export$e4e04d43e223cce2() {
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $4660b91716a96fcf$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $4660b91716a96fcf$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $8d980b49ad0d4c02$export$7affb50b622d8714)(entry) || !activeRootSpan) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            // If the interaction was already recorded before, nothing more to do
            if ($2a04f991ee2ae672$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            // We keep max. 10 interactions in the list, then remove the oldest one & clean up
            if ($2a04f991ee2ae672$var$LAST_INTERACTIONS.length > 10) {
                const last = $2a04f991ee2ae672$var$LAST_INTERACTIONS.shift();
                $2a04f991ee2ae672$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            // We add the interaction to the list of recorded interactions
            // and store the span for this interaction
            $2a04f991ee2ae672$var$LAST_INTERACTIONS.push(interactionId);
            $2a04f991ee2ae672$var$INTERACTIONS_SPAN_MAP.set(interactionId, activeRootSpan);
        });
    };
    (0, $8d980b49ad0d4c02$export$69816c1a049f8db6)("event", handleEntries);
    (0, $8d980b49ad0d4c02$export$69816c1a049f8db6)("first-input", handleEntries);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4f31ecb266c05841$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;






/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $f7da50af3ec88d16$export$6f18f55521af71a1() {
    if ((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document) (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $1ee319bdc991c767$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $1ee319bdc991c767$export$92d8c23565496537)(rootSpan);
            if (0, $4f31ecb266c05841$export$16a28057038b10ef) (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}













// 1h in seconds
const $49b1cea38d4d723a$export$c8d616af96ac729f = 3600;
// session storage key
const $49b1cea38d4d723a$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $49b1cea38d4d723a$export$237518aee8726f02 = "sentry.previous_trace";
/**
 * Adds a previous_trace span link to the passed span if the passed
 * previousTraceInfo is still valid.
 *
 * @returns the updated previous trace info (based on the current span/trace) to
 * be used on the next call
 */ function $49b1cea38d4d723a$export$ae31cf84cbfc630e(previousTraceInfo, span) {
    const spanJson = (0, $1ee319bdc991c767$export$92d8c23565496537)(span);
    if (!previousTraceInfo) return {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp
    };
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) // This means, we're still in the same trace so let's not update the previous trace info
    // or add a link to the current span.
    // Once we move away from the long-lived, route-based trace model, we can remove this cases
    return previousTraceInfo;
    // Only add the link if the startTimeStamp of the previous trace's root span is within
    // PREVIOUS_TRACE_MAX_DURATION (1h) of the current root span's startTimestamp
    // This is done to
    // - avoid adding links to "stale" traces
    // - enable more efficient querying for previous/next traces in Sentry
    if (Date.now() / 1000 - previousTraceInfo.startTimestamp <= $49b1cea38d4d723a$export$c8d616af96ac729f) {
        if (0, $4f31ecb266c05841$export$16a28057038b10ef) (0, $398c2530c60234a2$export$af88d00dbe7f521).info(`Adding previous_trace ${previousTraceSpanCtx} link to span ${{
            op: spanJson.op,
            ...span.spanContext()
        }}`);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $8f43a3b4d13a578f$export$ff77b5fd5b2d627b)]: "previous_trace"
            }
        });
        // TODO: Remove this once EAP can store span links. We currently only set this attribute so that we
        // can obtain the previous trace information from the EAP store. Long-term, EAP will handle
        // span links and then we should remove this again. Also throwing in a TODO(v10), to remind us
        // to check this at v10 time :)
        span.setAttribute($49b1cea38d4d723a$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${previousTraceSpanCtx.traceFlags === 0x1 ? 1 : 0}`);
    }
    return {
        spanContext: span.spanContext(),
        startTimestamp: (0, $1ee319bdc991c767$export$92d8c23565496537)(span).start_timestamp
    };
}
/**
 * Stores @param previousTraceInfo in sessionStorage.
 */ function $49b1cea38d4d723a$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).sessionStorage.setItem($49b1cea38d4d723a$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        // Ignore potential errors (e.g. if sessionStorage is not available)
        (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Could not store previous trace in sessionStorage", e);
    }
}
/**
 * Retrieves the previous trace from sessionStorage if available.
 */ function $49b1cea38d4d723a$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).sessionStorage?.getItem($49b1cea38d4d723a$export$16b6aa13b3c0f075);
        // @ts-expect-error - intentionally risking JSON.parse throwing when previousTraceInfo is null to save bundle size
        return JSON.parse(previousTraceInfo);
    } catch (e) {
        return undefined;
    }
}







const $3ec67e5bc0c0a1c0$var$WINDOW = (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$67fc34576016d6ec() {
    return "history" in $3ec67e5bc0c0a1c0$var$WINDOW && !!$3ec67e5bc0c0a1c0$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $3ec67e5bc0c0a1c0$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $3ec67e5bc0c0a1c0$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $3ec67e5bc0c0a1c0$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$3ec67e5bc0c0a1c0$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($3ec67e5bc0c0a1c0$export$d5f608b368e73f38($3ec67e5bc0c0a1c0$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $3ec67e5bc0c0a1c0$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $3ec67e5bc0c0a1c0$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $b377edbb1b3d818a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$531055a6c684a70a() {
    return "ReportingObserver" in $3ec67e5bc0c0a1c0$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $3ec67e5bc0c0a1c0$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$3ec67e5bc0c0a1c0$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $99fdad47f98ba4a1$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    (0, $113765a9da9fc745$export$a4e09611e30da72e)(type, handler);
    (0, $113765a9da9fc745$export$e18d6c5462c01368)(type, ()=>$99fdad47f98ba4a1$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $99fdad47f98ba4a1$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    (0, $113765a9da9fc745$export$a4e09611e30da72e)(type, handler);
    (0, $113765a9da9fc745$export$e18d6c5462c01368)(type, ()=>$99fdad47f98ba4a1$var$instrumentFetch($99fdad47f98ba4a1$var$streamHandler));
}
function $99fdad47f98ba4a1$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $3ec67e5bc0c0a1c0$export$c82d238e23c40b21)()) return;
    (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1), "fetch", function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $99fdad47f98ba4a1$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $741f7992b965e3b0$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $99fdad47f98ba4a1$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $113765a9da9fc745$export$b18c893e424d3127)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $113765a9da9fc745$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $741f7992b965e3b0$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $113765a9da9fc745$export$b18c893e424d3127)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $741f7992b965e3b0$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(error, "framesToPop", 1);
                }
                // We enhance the not-so-helpful "Failed to fetch" error messages with the host
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                if (error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url = new URL(handlerData.fetchData.url);
                    error.message = `${error.message} (${url.host})`;
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $99fdad47f98ba4a1$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch (error) {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $99fdad47f98ba4a1$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $99fdad47f98ba4a1$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $113765a9da9fc745$export$b18c893e424d3127)("fetch-body-resolved", {
            endTimestamp: (0, $741f7992b965e3b0$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $99fdad47f98ba4a1$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $99fdad47f98ba4a1$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($99fdad47f98ba4a1$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $99fdad47f98ba4a1$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $99fdad47f98ba4a1$var$getUrlFromResource(url),
            method: $99fdad47f98ba4a1$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $99fdad47f98ba4a1$var$getUrlFromResource(arg),
        method: $99fdad47f98ba4a1$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $99fdad47f98ba4a1$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $64d77030f0d405c5$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}














/**
 * Extracts trace propagation data from the current span or from the client's scope (via transaction or propagation
 * context) and serializes it to `sentry-trace` and `baggage` values to strings. These values can be used to propagate
 * a trace via our tracing Http headers or Html `<meta>` tags.
 *
 * This function also applies some validation to the generated sentry-trace and baggage values to ensure that
 * only valid strings are returned.
 *
 * @returns an object with the tracing data values. The object keys are the name of the tracing key to be used as header
 * or meta tag name.
 */ function $3896b31eb678ae4a$export$dec8f001b9d982cb(options = {}) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (!(0, $54ca942ea01c8aa7$export$3b029eb57ac4d562)() || !client) return {};
    const carrier = (0, $2d413ae5a393071a$export$19eade501500c6c1)();
    const acs = (0, $38813f7928b7d824$export$f639b0c2752203be)(carrier);
    if (acs.getTraceData) return acs.getTraceData(options);
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const span = options.span || (0, $1ee319bdc991c767$export$1be426a8e585c83e)();
    const sentryTrace = span ? (0, $1ee319bdc991c767$export$7e9f8ae9e4a328ab)(span) : $3896b31eb678ae4a$var$scopeToTraceHeader(scope);
    const dsc = span ? (0, $7d33670619390772$export$a117f995597e25df)(span) : (0, $7d33670619390772$export$89ef1736f08c6b2b)(client, scope);
    const baggage = (0, $690cb49b273612e1$export$56766feef403f365)(dsc);
    const isValidSentryTraceHeader = (0, $b6af67124761d26b$export$394a210812ba3012).test(sentryTrace);
    if (!isValidSentryTraceHeader) {
        (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Invalid sentry-trace data. Cannot generate trace data");
        return {};
    }
    return {
        "sentry-trace": sentryTrace,
        baggage: baggage
    };
}
/**
 * Get a sentry-trace header value for the given scope.
 */ function $3896b31eb678ae4a$var$scopeToTraceHeader(scope) {
    const { traceId: traceId, sampled: sampled, propagationSpanId: propagationSpanId } = scope.getPropagationContext();
    return (0, $b6af67124761d26b$export$f35d907436da45cf)(traceId, propagationSpanId, sampled);
}
















// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $a1feead10a53e4e1$var$DEFAULT_BASE_URL = "thismessage:/";
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $a1feead10a53e4e1$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $a1feead10a53e4e1$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.startsWith("/");
    const base = urlBase ?? (isRelative ? $a1feead10a53e4e1$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ("canParse" in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $a1feead10a53e4e1$export$5339fcdc8e2a427c(url) {
    if ($a1feead10a53e4e1$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $a1feead10a53e4e1$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $a1feead10a53e4e1$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $a1feead10a53e4e1$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}


/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $fce5ea0464ad428c$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = "auto.http.browser") {
    if (!handlerData.fetchData) return undefined;
    const { method: method, url: url } = handlerData.fetchData;
    const shouldCreateSpanResult = (0, $1487c3c693f88da4$export$1f70765132c3c225)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $fce5ea0464ad428c$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const hasParent = !!(0, $1ee319bdc991c767$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $f1c0392c8b55e310$export$63dbba021a6b4047)($fce5ea0464ad428c$var$getSpanStartOptions(url, method, spanOrigin)) : new (0, $bf604ce9a09041a2$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url)) {
        const request = handlerData.args[0];
        const options = handlerData.args[1] || {};
        const headers = $fce5ea0464ad428c$var$_addTracingHeadersToFetchRequest(request, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $1487c3c693f88da4$export$1f70765132c3c225)() && hasParent ? span : undefined);
        if (headers) {
            // Ensure this is actually set, if no options have been passed previously
            handlerData.args[1] = options;
            options.headers = headers;
        }
    }
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (client) {
        const fetchHint = {
            input: handlerData.args,
            response: handlerData.response,
            startTimestamp: handlerData.startTimestamp,
            endTimestamp: handlerData.endTimestamp
        };
        client.emit("beforeOutgoingRequestSpan", span, fetchHint);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers.
 */ function $fce5ea0464ad428c$var$_addTracingHeadersToFetchRequest(request, fetchOptionsObj, span) {
    const traceHeaders = (0, $3896b31eb678ae4a$export$dec8f001b9d982cb)({
        span: span
    });
    const sentryTrace = traceHeaders["sentry-trace"];
    const baggage = traceHeaders.baggage;
    // Nothing to do, when we return undefined here, the original headers will be used
    if (!sentryTrace) return undefined;
    const headers = fetchOptionsObj.headers || ((0, $64d77030f0d405c5$export$6d3d1f317d7cda57)(request) ? request.headers : undefined);
    if (!headers) return {
        ...traceHeaders
    };
    else if ($fce5ea0464ad428c$var$isHeaders(headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.set("sentry-trace", sentryTrace);
        if (baggage) {
            const prevBaggageHeader = newHeaders.get("baggage");
            if (prevBaggageHeader) {
                const prevHeaderStrippedFromSentryBaggage = $fce5ea0464ad428c$var$stripBaggageHeaderOfSentryBaggageValues(prevBaggageHeader);
                newHeaders.set("baggage", // If there are non-sentry entries (i.e. if the stripped string is non-empty/truthy) combine the stripped header and sentry baggage header
                // otherwise just set the sentry baggage header
                prevHeaderStrippedFromSentryBaggage ? `${prevHeaderStrippedFromSentryBaggage},${baggage}` : baggage);
            } else newHeaders.set("baggage", baggage);
        }
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers// Remove any existing sentry-trace headers
            .filter((header)=>{
                return !(Array.isArray(header) && header[0] === "sentry-trace");
            })// Get rid of previous sentry baggage values in baggage header
            .map((header)=>{
                if (Array.isArray(header) && header[0] === "baggage" && typeof header[1] === "string") {
                    const [headerName, headerValue, ...rest] = header;
                    return [
                        headerName,
                        $fce5ea0464ad428c$var$stripBaggageHeaderOfSentryBaggageValues(headerValue),
                        ...rest
                    ];
                } else return header;
            }),
            // Attach the new sentry-trace header
            [
                "sentry-trace",
                sentryTrace
            ]
        ];
        if (baggage) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            "baggage",
            baggage
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = "baggage" in headers ? headers.baggage : undefined;
        let newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders = existingBaggageHeader.map((headerItem)=>typeof headerItem === "string" ? $fce5ea0464ad428c$var$stripBaggageHeaderOfSentryBaggageValues(headerItem) : headerItem).filter((headerItem)=>headerItem === "");
        else if (existingBaggageHeader) newBaggageHeaders.push($fce5ea0464ad428c$var$stripBaggageHeaderOfSentryBaggageValues(existingBaggageHeader));
        if (baggage) newBaggageHeaders.push(baggage);
        return {
            ...headers,
            "sentry-trace": sentryTrace,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : undefined
        };
    }
}
function $fce5ea0464ad428c$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $d1cbe31bea560316$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response?.headers && handlerData.response.headers.get("content-length");
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute("http.response_content_length", contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $d1cbe31bea560316$export$f966a0446ece71e),
        message: "internal_error"
    });
    span.end();
}
function $fce5ea0464ad428c$var$stripBaggageHeaderOfSentryBaggageValues(baggageHeader) {
    return baggageHeader.split(",")// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .filter((baggageEntry)=>!baggageEntry.split("=")[0].startsWith((0, $690cb49b273612e1$export$6e69537d67fa20f))).join(",");
}
function $fce5ea0464ad428c$var$isHeaders(headers) {
    return typeof Headers !== "undefined" && (0, $64d77030f0d405c5$export$49034edbe6b62415)(headers, Headers);
}
function $fce5ea0464ad428c$var$getSpanStartOptions(url, method, spanOrigin) {
    const parsedUrl = (0, $a1feead10a53e4e1$export$2004d912a9ead694)(url);
    return {
        name: parsedUrl ? `${method} ${(0, $a1feead10a53e4e1$export$5339fcdc8e2a427c)(parsedUrl)}` : method,
        attributes: $fce5ea0464ad428c$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
    };
}
function $fce5ea0464ad428c$var$getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
    const attributes = {
        url: url,
        type: "fetch",
        "http.method": method,
        [(0, $8f43a3b4d13a578f$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $8f43a3b4d13a578f$export$1a413bd9a88fdb09)]: "http.client"
    };
    if (parsedUrl) {
        if (!(0, $a1feead10a53e4e1$export$e258e13805402ba7)(parsedUrl)) {
            attributes["http.url"] = parsedUrl.href;
            attributes["server.address"] = parsedUrl.host;
        }
        if (parsedUrl.search) attributes["http.query"] = parsedUrl.search;
        if (parsedUrl.hash) attributes["http.fragment"] = parsedUrl.hash;
    }
    return attributes;
}




const $46d6641fe3f28167$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $46d6641fe3f28167$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $6be626ee95d0a821$export$a4e09611e30da72e)(type, handler);
    (0, $6be626ee95d0a821$export$e18d6c5462c01368)(type, $46d6641fe3f28167$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $46d6641fe3f28167$export$c67d533bf77cbf54() {
    if (!(0, $182fc35abbd0c773$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $528b979cf0f30a2b$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $682ef556f5df43ab$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $46d6641fe3f28167$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$46d6641fe3f28167$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$46d6641fe3f28167$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $528b979cf0f30a2b$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $6be626ee95d0a821$export$b18c893e424d3127)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$46d6641fe3f28167$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $682ef556f5df43ab$export$844ec244b1367d54)(header) && (0, $682ef556f5df43ab$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$46d6641fe3f28167$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $528b979cf0f30a2b$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $6be626ee95d0a821$export$b18c893e424d3127)("xhr", handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $46d6641fe3f28167$var$parseXhrUrlArg(url) {
    if ((0, $682ef556f5df43ab$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}



/** Options for Request Instrumentation */ const $2459cf4f9489212a$var$responseToSpanId = new WeakMap();
const $2459cf4f9489212a$var$spanIdToEndTimestamp = new Map();
const $2459cf4f9489212a$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
/** Registers span creators for xhr and fetch requests  */ function $2459cf4f9489212a$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart } = {
        ...$2459cf4f9489212a$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$2459cf4f9489212a$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) {
        // Keeping track of http requests, whose body payloads resolved later than the initial resolved request
        // e.g. streaming using server sent events (SSE)
        client.addEventProcessor((event)=>{
            if (event.type === "transaction" && event.spans) event.spans.forEach((span)=>{
                if (span.op === "http.client") {
                    const updatedTimestamp = $2459cf4f9489212a$var$spanIdToEndTimestamp.get(span.span_id);
                    if (updatedTimestamp) {
                        span.timestamp = updatedTimestamp / 1000;
                        $2459cf4f9489212a$var$spanIdToEndTimestamp.delete(span.span_id);
                    }
                }
            });
            return event;
        });
        if (trackFetchStreamPerformance) (0, $99fdad47f98ba4a1$export$1a79663eb318fe6a)((handlerData)=>{
            if (handlerData.response) {
                const span = $2459cf4f9489212a$var$responseToSpanId.get(handlerData.response);
                if (span && handlerData.endTimestamp) $2459cf4f9489212a$var$spanIdToEndTimestamp.set(span, handlerData.endTimestamp);
            }
        });
        (0, $99fdad47f98ba4a1$export$f75d3c772c923df0)((handlerData)=>{
            const createdSpan = (0, $fce5ea0464ad428c$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
            if (handlerData.response && handlerData.fetchData.__span) $2459cf4f9489212a$var$responseToSpanId.set(handlerData.response, handlerData.fetchData.__span);
            // We cannot use `window.location` in the generic fetch instrumentation,
            // but we need it for reliable `server.address` attribute.
            // so we extend this in here
            if (createdSpan) {
                const fullUrl = $2459cf4f9489212a$var$getFullURL(handlerData.fetchData.url);
                const host = fullUrl ? (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)(fullUrl).host : undefined;
                createdSpan.setAttributes({
                    "http.url": fullUrl,
                    "server.address": host
                });
                if (enableHTTPTimings) $2459cf4f9489212a$var$addHTTPTimings(createdSpan);
                onRequestSpanStart?.(createdSpan, {
                    headers: handlerData.headers
                });
            }
        });
    }
    if (traceXHR) (0, $46d6641fe3f28167$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $2459cf4f9489212a$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (createdSpan) {
            if (enableHTTPTimings) $2459cf4f9489212a$var$addHTTPTimings(createdSpan);
            let headers;
            try {
                headers = new Headers(handlerData.xhr.__sentry_xhr_v3__?.request_headers);
            } catch  {
            // noop
            }
            onRequestSpanStart?.(createdSpan, {
                headers: headers
            });
        }
    });
}
function $2459cf4f9489212a$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $2459cf4f9489212a$var$addHTTPTimings(span) {
    const { url: url } = (0, $1ee319bdc991c767$export$92d8c23565496537)(span).data;
    if (!url || typeof url !== "string") return;
    const cleanup = (0, $8d980b49ad0d4c02$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($2459cf4f9489212a$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $2459cf4f9489212a$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
function $2459cf4f9489212a$var$getAbsoluteTime(time = 0) {
    return (((0, $741f7992b965e3b0$export$baf075a948ffc0bf)() || performance.timeOrigin) + time) / 1000;
}
function $2459cf4f9489212a$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = (0, $a340b0900733c299$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        "network.protocol.version",
        version
    ], [
        "network.protocol.name",
        name
    ]);
    if (!(0, $741f7992b965e3b0$export$baf075a948ffc0bf)()) return timingSpanData;
    return [
        ...timingSpanData,
        [
            "http.request.redirect_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            "http.request.fetch_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            "http.request.domain_lookup_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            "http.request.domain_lookup_end",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            "http.request.connect_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            "http.request.secure_connection_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            "http.request.connection_end",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            "http.request.request_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            "http.request.response_start",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            "http.request.response_end",
            $2459cf4f9489212a$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $2459cf4f9489212a$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $b3dd2fa7e571301f$export$1cfafeee2987818b)();
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $2459cf4f9489212a$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $46d6641fe3f28167$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $1487c3c693f88da4$export$1f70765132c3c225)() && shouldCreateSpan(url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $d1cbe31bea560316$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $2459cf4f9489212a$var$getFullURL(url);
    const parsedUrl = fullUrl ? (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)(fullUrl) : (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)(url);
    const urlForSpanName = (0, $a1feead10a53e4e1$export$ce084c78234bd35)(url);
    const hasParent = !!(0, $1ee319bdc991c767$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $f1c0392c8b55e310$export$63dbba021a6b4047)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: url,
            type: "xhr",
            "http.method": method,
            "http.url": fullUrl,
            "server.address": parsedUrl?.host,
            [(0, $8f43a3b4d13a578f$export$cca8dd30f57f805e)]: "auto.http.browser",
            [(0, $8f43a3b4d13a578f$export$1a413bd9a88fdb09)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $bf604ce9a09041a2$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders(url)) $2459cf4f9489212a$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $1487c3c693f88da4$export$1f70765132c3c225)() && hasParent ? span : undefined);
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $2459cf4f9489212a$var$addTracingHeadersToXhrRequest(xhr, span) {
    const { "sentry-trace": sentryTrace, baggage: baggage } = (0, $3896b31eb678ae4a$export$dec8f001b9d982cb)({
        span: span
    });
    if (sentryTrace) $2459cf4f9489212a$var$setHeaderOnXhr(xhr, sentryTrace, baggage);
}
function $2459cf4f9489212a$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader("baggage", sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $2459cf4f9489212a$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch  {
        return undefined;
    }
}


const $040cc7132a09aab4$export$bbd2089f30bd3708 = "BrowserTracing";
const $040cc7132a09aab4$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $e9a93295f98be17f$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    linkPreviousTrace: "in-memory",
    _experiments: {},
    ...(0, $2459cf4f9489212a$export$cc17fb3c0bc95cd7)
};
let $040cc7132a09aab4$var$_hasBeenInitialized = false;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $040cc7132a09aab4$export$b4109253475213e9 = (_options = {})=>{
    if ($040cc7132a09aab4$var$_hasBeenInitialized) (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn("Multiple browserTracingIntegration instances are not supported.");
    });
    $040cc7132a09aab4$var$_hasBeenInitialized = true;
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document;
    (0, $a72aafe4e2ab71fe$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, linkPreviousTrace: linkPreviousTrace, onRequestSpanStart: onRequestSpanStart } = {
        ...$040cc7132a09aab4$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $76d0462c99f715f1$export$7c69f0412d101b88)({
        recordClsStandaloneSpans: enableStandaloneClsSpans || false
    });
    if (enableInp) (0, $2a04f991ee2ae672$export$f17d06681a4744a3)();
    if (enableLongAnimationFrame && (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).PerformanceObserver && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes("long-animation-frame")) (0, $76d0462c99f715f1$export$5b823ab2ccbc801d)();
    else if (enableLongTask) (0, $76d0462c99f715f1$export$f396d19077034ad2)();
    if (enableInteractions) (0, $76d0462c99f715f1$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === "pageload";
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $8f43a3b4d13a578f$export$d7a7d984b0791405] = "custom";
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $8f43a3b4d13a578f$export$d7a7d984b0791405];
        const idleSpan = (0, $e9a93295f98be17f$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $76d0462c99f715f1$export$5f8fa6b3467a7443)(span, {
                    recordClsOnPageloadSpan: !enableStandaloneClsSpans
                });
                $040cc7132a09aab4$var$setActiveIdleSpan(client, undefined);
                // A trace should stay consistent over the entire timespan of one route - even after the pageload/navigation ended.
                // Only when another navigation happens, we want to create a new trace.
                // This way, e.g. errors that occur after the pageload span ended are still associated to the pageload trace.
                const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $1ee319bdc991c767$export$5caecac1caaf3a71)(idleSpan),
                    dsc: (0, $7d33670619390772$export$a117f995597e25df)(span)
                });
            }
        });
        $040cc7132a09aab4$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) client.emit("idleSpanEnableAutoFinish", idleSpan);
        }
        if (isPageloadTransaction && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", ()=>{
                emitFinish();
            });
            emitFinish();
        }
    }
    return {
        name: $040cc7132a09aab4$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let startingUrl = (0, $b3dd2fa7e571301f$export$1cfafeee2987818b)();
            function maybeEndActiveSpan() {
                const activeSpan = $040cc7132a09aab4$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $1ee319bdc991c767$export$92d8c23565496537)(activeSpan).timestamp) {
                    (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`[Tracing] Finishing current active span with op: ${(0, $1ee319bdc991c767$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open active span, we need to finish it before creating an new one.
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions)=>{
                if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                (0, $35358b2c9a559011$export$68f3af03034c9e90)().setPropagationContext({
                    traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                (0, $35358b2c9a559011$export$c7be4b0125a10cba)().setPropagationContext({
                    traceId: (0, $f63023dba381e7e1$export$dc6d7ea554bcce10)(),
                    sampleRand: Math.random()
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions
                });
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $040cc7132a09aab4$export$f147b32b03c9cf11("sentry-trace");
                const baggage = traceOptions.baggage || $040cc7132a09aab4$export$f147b32b03c9cf11("baggage");
                const propagationContext = (0, $b6af67124761d26b$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $35358b2c9a559011$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            if (linkPreviousTrace !== "off") {
                let inMemoryPreviousTraceInfo = undefined;
                client.on("spanStart", (span)=>{
                    if ((0, $1ee319bdc991c767$export$c4c6a79b1260ca1b)(span) !== span) return;
                    if (linkPreviousTrace === "session-storage") {
                        const updatedPreviousTraceInfo = (0, $49b1cea38d4d723a$export$ae31cf84cbfc630e)((0, $49b1cea38d4d723a$export$ef546bba8a402d99)(), span);
                        (0, $49b1cea38d4d723a$export$e3dcc2666496dd96)(updatedPreviousTraceInfo);
                    } else inMemoryPreviousTraceInfo = (0, $49b1cea38d4d723a$export$ae31cf84cbfc630e)(inMemoryPreviousTraceInfo, span);
                });
            }
            if ((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $741f7992b965e3b0$export$baf075a948ffc0bf)();
                    $040cc7132a09aab4$export$aa44a07f82af519f(client, {
                        name: (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1000 : undefined,
                        attributes: {
                            [(0, $8f43a3b4d13a578f$export$d7a7d984b0791405)]: "url",
                            [(0, $8f43a3b4d13a578f$export$cca8dd30f57f805e)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $ef8ca1530ef1c35b$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $040cc7132a09aab4$export$7d159749bd9969ad(client, {
                            name: (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $8f43a3b4d13a578f$export$d7a7d984b0791405)]: "url",
                                [(0, $8f43a3b4d13a578f$export$cca8dd30f57f805e)]: "auto.navigation.browser"
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $f7da50af3ec88d16$export$6f18f55521af71a1)();
            if (enableInteractions) $040cc7132a09aab4$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            if (enableInp) (0, $2a04f991ee2ae672$export$e4e04d43e223cce2)();
            (0, $2459cf4f9489212a$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                trackFetchStreamPerformance: trackFetchStreamPerformance,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $040cc7132a09aab4$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $35358b2c9a559011$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    return $040cc7132a09aab4$var$getActiveIdleSpan(client);
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $040cc7132a09aab4$export$7d159749bd9969ad(client, spanOptions) {
    client.emit("startNavigationSpan", spanOptions);
    (0, $35358b2c9a559011$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    return $040cc7132a09aab4$var$getActiveIdleSpan(client);
}
/** Returns the value of a meta tag */ function $040cc7132a09aab4$export$f147b32b03c9cf11(metaName) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || undefined;
}
/** Start listener for interaction transactions */ function $040cc7132a09aab4$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    /**
   * This is just a small wrapper that makes `document` optional.
   * We want to be extra-safe and always check that this exists, to ensure weird environments do not blow up.
   */ const optionalWindowDocument = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $040cc7132a09aab4$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $1ee319bdc991c767$export$92d8c23565496537)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $8f43a3b4d13a578f$export$ba73f34502b7a3b3), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $e9a93295f98be17f$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $8f43a3b4d13a578f$export$d7a7d984b0791405)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        once: false,
        capture: true
    });
}
// We store the active idle span on the client object, so we can access it from exported functions
const $040cc7132a09aab4$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $040cc7132a09aab4$var$getActiveIdleSpan(client) {
    return client[$040cc7132a09aab4$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $040cc7132a09aab4$var$setActiveIdleSpan(client, span) {
    (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(client, $040cc7132a09aab4$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}


const $deb2d89c0fb26d33$var$OPERA10_PRIORITY = 10;
const $deb2d89c0fb26d33$var$OPERA11_PRIORITY = 20;
const $deb2d89c0fb26d33$var$CHROME_PRIORITY = 30;
const $deb2d89c0fb26d33$var$WINJS_PRIORITY = 40;
const $deb2d89c0fb26d33$var$GECKO_PRIORITY = 50;
function $deb2d89c0fb26d33$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === "<anonymous>" ? (0, $79681426e6433cce$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $deb2d89c0fb26d33$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $deb2d89c0fb26d33$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $deb2d89c0fb26d33$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $deb2d89c0fb26d33$var$chromeStackParserFn = (line)=>{
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $deb2d89c0fb26d33$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $deb2d89c0fb26d33$var$createFrame(filename, (0, $79681426e6433cce$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $deb2d89c0fb26d33$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $deb2d89c0fb26d33$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $deb2d89c0fb26d33$var$extractSafariExtensionDetails(parts[1] || (0, $79681426e6433cce$export$27c7e15d453fc0ac), parts[2]);
        return $deb2d89c0fb26d33$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $deb2d89c0fb26d33$export$263a749fff749872 = [
    $deb2d89c0fb26d33$var$CHROME_PRIORITY,
    $deb2d89c0fb26d33$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $deb2d89c0fb26d33$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $deb2d89c0fb26d33$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $deb2d89c0fb26d33$var$gecko = (line)=>{
    const parts = $deb2d89c0fb26d33$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $deb2d89c0fb26d33$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $79681426e6433cce$export$27c7e15d453fc0ac);
        [func, filename] = $deb2d89c0fb26d33$var$extractSafariExtensionDetails(func, filename);
        return $deb2d89c0fb26d33$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $deb2d89c0fb26d33$export$cdba47a5dd2804d = [
    $deb2d89c0fb26d33$var$GECKO_PRIORITY,
    $deb2d89c0fb26d33$var$gecko
];
const $deb2d89c0fb26d33$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $deb2d89c0fb26d33$var$winjs = (line)=>{
    const parts = $deb2d89c0fb26d33$var$winjsRegex.exec(line);
    return parts ? $deb2d89c0fb26d33$var$createFrame(parts[2], parts[1] || (0, $79681426e6433cce$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $deb2d89c0fb26d33$export$179460296da408e8 = [
    $deb2d89c0fb26d33$var$WINJS_PRIORITY,
    $deb2d89c0fb26d33$var$winjs
];
const $deb2d89c0fb26d33$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $deb2d89c0fb26d33$var$opera10 = (line)=>{
    const parts = $deb2d89c0fb26d33$var$opera10Regex.exec(line);
    return parts ? $deb2d89c0fb26d33$var$createFrame(parts[2], parts[3] || (0, $79681426e6433cce$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $deb2d89c0fb26d33$export$f892b52c880ffc7a = [
    $deb2d89c0fb26d33$var$OPERA10_PRIORITY,
    $deb2d89c0fb26d33$var$opera10
];
const $deb2d89c0fb26d33$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $deb2d89c0fb26d33$var$opera11 = (line)=>{
    const parts = $deb2d89c0fb26d33$var$opera11Regex.exec(line);
    return parts ? $deb2d89c0fb26d33$var$createFrame(parts[5], parts[3] || parts[4] || (0, $79681426e6433cce$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $deb2d89c0fb26d33$export$af11af13f09fb0dc = [
    $deb2d89c0fb26d33$var$OPERA11_PRIORITY,
    $deb2d89c0fb26d33$var$opera11
];
const $deb2d89c0fb26d33$export$7197c0fe6554c079 = [
    $deb2d89c0fb26d33$export$263a749fff749872,
    $deb2d89c0fb26d33$export$cdba47a5dd2804d
];
const $deb2d89c0fb26d33$export$2b2b997d81bf3907 = (0, $79681426e6433cce$export$a5739666fb2d03d4)(...$deb2d89c0fb26d33$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $deb2d89c0fb26d33$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : (0, $79681426e6433cce$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





const $c6287212c014af6f$var$INTEGRATION_NAME = "Dedupe";
const $c6287212c014af6f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $c6287212c014af6f$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($c6287212c014af6f$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $c6287212c014af6f$export$6d39aa44cd0c7567 = (0, $16575ede9e208d34$export$2323046b9414659f)($c6287212c014af6f$var$_dedupeIntegration);
/** only exported for tests. */ function $c6287212c014af6f$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($c6287212c014af6f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($c6287212c014af6f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $c6287212c014af6f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$c6287212c014af6f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c6287212c014af6f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c6287212c014af6f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $c6287212c014af6f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $c6287212c014af6f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$c6287212c014af6f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c6287212c014af6f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c6287212c014af6f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $79681426e6433cce$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $79681426e6433cce$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $c6287212c014af6f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $c6287212c014af6f$var$_getExceptionFromEvent(event) {
    return event.exception?.values && event.exception.values[0];
}




let $5da8f55c0a121980$var$originalFunctionToString;
const $5da8f55c0a121980$var$INTEGRATION_NAME = "FunctionToString";
const $5da8f55c0a121980$var$SETUP_CLIENTS = new WeakMap();
const $5da8f55c0a121980$var$_functionToStringIntegration = ()=>{
    return {
        name: $5da8f55c0a121980$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $5da8f55c0a121980$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $ac73fe157e02a9a2$export$e6cc1e135e2092e5)(this);
                    const context = $5da8f55c0a121980$var$SETUP_CLIENTS.has((0, $35358b2c9a559011$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $5da8f55c0a121980$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $5da8f55c0a121980$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $5da8f55c0a121980$export$7918117e9202e4fb = (0, $16575ede9e208d34$export$2323046b9414659f)($5da8f55c0a121980$var$_functionToStringIntegration);







// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $357c9202e1ca2659$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $357c9202e1ca2659$var$INTEGRATION_NAME = "EventFilters";
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $357c9202e1ca2659$export$9a84f518c163c552 = (0, $16575ede9e208d34$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $357c9202e1ca2659$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $357c9202e1ca2659$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $357c9202e1ca2659$var$_mergeOptions(options, clientOptions);
            }
            return $357c9202e1ca2659$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $357c9202e1ca2659$export$cb3c5c2ceb9818ba = (0, $16575ede9e208d34$export$2323046b9414659f)((options = {})=>{
    return {
        ...$357c9202e1ca2659$export$9a84f518c163c552(options),
        name: "InboundFilters"
    };
});
function $357c9202e1ca2659$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $357c9202e1ca2659$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $357c9202e1ca2659$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($357c9202e1ca2659$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $5985640674d52865$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($357c9202e1ca2659$var$_isUselessError(event)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $5985640674d52865$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($357c9202e1ca2659$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $5985640674d52865$export$4157119e2b157127)(event)}.\nUrl: ${$357c9202e1ca2659$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$357c9202e1ca2659$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $5985640674d52865$export$4157119e2b157127)(event)}.\nUrl: ${$357c9202e1ca2659$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === "transaction") // Filter transactions
    {
        if ($357c9202e1ca2659$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $5985640674d52865$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $357c9202e1ca2659$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $915a9d110878d37d$export$d55a97c329cacfcc)(event).some((message)=>(0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $357c9202e1ca2659$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $357c9202e1ca2659$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $357c9202e1ca2659$var$_getEventFilterUrl(event);
    return !url ? false : (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $357c9202e1ca2659$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $357c9202e1ca2659$var$_getEventFilterUrl(event);
    return !url ? true : (0, $e0c4ed16d3d4a5dd$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $357c9202e1ca2659$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $357c9202e1ca2659$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $357c9202e1ca2659$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $5985640674d52865$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $357c9202e1ca2659$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== "Error" || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $e9dea091abe21853$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $9f8bd953fbcf4578$export$16a28057038b10ef) (0, $398c2530c60234a2$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $e9dea091abe21853$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $e9dea091abe21853$export$ecb76f41d43c0e43(client) {
    (0, $35358b2c9a559011$export$c7be4b0125a10cba)().setClient(client);
}









/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6c95b3333c2fdcdc$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $113765a9da9fc745$export$a4e09611e30da72e)(type, handler);
    (0, $113765a9da9fc745$export$e18d6c5462c01368)(type, $6c95b3333c2fdcdc$var$instrumentConsole);
}
function $6c95b3333c2fdcdc$var$instrumentConsole() {
    if (!("console" in (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1))) return;
    (0, $398c2530c60234a2$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).console)) return;
        (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $398c2530c60234a2$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $113765a9da9fc745$export$b18c893e424d3127)("console", handlerData);
                const log = (0, $398c2530c60234a2$export$77c4ce905194557b)[level];
                log?.apply((0, $1c9e486be4080d26$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $ed9e287f879c493f$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return "warning";
    else if (statusCode >= 500) return "error";
    else return undefined;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $60b5d275f2e163fb$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : [
        "fatal",
        "error",
        "warning",
        "log",
        "info",
        "debug"
    ].includes(level) ? level : "log";
}




const $f620d5a2059fcb89$var$DEBOUNCE_DURATION = 1000;
let $f620d5a2059fcb89$var$debounceTimerID;
let $f620d5a2059fcb89$var$lastCapturedEventType;
let $f620d5a2059fcb89$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f620d5a2059fcb89$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $6be626ee95d0a821$export$a4e09611e30da72e)(type, handler);
    (0, $6be626ee95d0a821$export$e18d6c5462c01368)(type, $f620d5a2059fcb89$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $f620d5a2059fcb89$export$3014bbf0af0e1d4a() {
    if (!(0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $6be626ee95d0a821$export$b18c893e424d3127).bind(null, "dom");
    const globalDOMEventHandler = $f620d5a2059fcb89$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document.addEventListener("click", globalDOMEventHandler, false);
    (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        const globalObject = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.("addEventListener")) return;
        (0, $8f046eb992525fda$export$9563e054e6f787fb)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $f620d5a2059fcb89$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $8f046eb992525fda$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $f620d5a2059fcb89$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $f620d5a2059fcb89$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $f620d5a2059fcb89$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $f620d5a2059fcb89$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $f620d5a2059fcb89$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $f620d5a2059fcb89$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($f620d5a2059fcb89$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $8f046eb992525fda$export$e73679ffaf56810e)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $8f046eb992525fda$export$e73679ffaf56810e)(target, "_sentryId", (0, $a1e9951cf8b291e3$export$19f53698e68b2496)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$f620d5a2059fcb89$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $f620d5a2059fcb89$var$lastCapturedEventType = event.type;
            $f620d5a2059fcb89$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($f620d5a2059fcb89$var$debounceTimerID);
        $f620d5a2059fcb89$var$debounceTimerID = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).setTimeout(()=>{
            $f620d5a2059fcb89$var$lastCapturedEventTargetId = undefined;
            $f620d5a2059fcb89$var$lastCapturedEventType = undefined;
        }, $f620d5a2059fcb89$var$DEBOUNCE_DURATION);
    };
}
function $f620d5a2059fcb89$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $7282385c3b342e3b$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $7282385c3b342e3b$var$INTEGRATION_NAME = "Breadcrumbs";
const $7282385c3b342e3b$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $7282385c3b342e3b$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v10): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $6c95b3333c2fdcdc$export$1d6e0d073f9e6723)($7282385c3b342e3b$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $f620d5a2059fcb89$export$5aeffd3db2cf9df7)($7282385c3b342e3b$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $46d6641fe3f28167$export$26ace48dd54c9aea)($7282385c3b342e3b$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $99fdad47f98ba4a1$export$f75d3c772c923df0)($7282385c3b342e3b$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $ef8ca1530ef1c35b$export$3f18c56c58114e75)($7282385c3b342e3b$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on("beforeSendEvent", $7282385c3b342e3b$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $7282385c3b342e3b$export$c079d904b326663a = (0, $16575ede9e208d34$export$2323046b9414659f)($7282385c3b342e3b$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $7282385c3b342e3b$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        (0, $6699f20558f1dc05$export$efda9a273d7a036d)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $5985640674d52865$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $7282385c3b342e3b$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $7282385c3b342e3b$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$7282385c3b342e3b$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$7282385c3b342e3b$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $7282385c3b342e3b$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $7282385c3b342e3b$var$_isEvent(event) ? event.target : event;
            target = (0, $b3dd2fa7e571301f$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b3dd2fa7e571301f$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $6699f20558f1dc05$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $7282385c3b342e3b$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $60b5d275f2e163fb$export$d771ef054122c30a)(handlerData.level),
            message: (0, $e0c4ed16d3d4a5dd$export$465e9d514283d4fd)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $e0c4ed16d3d4a5dd$export$465e9d514283d4fd)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $6699f20558f1dc05$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $7282385c3b342e3b$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $46d6641fe3f28167$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: "xhr",
            data: data,
            type: "http",
            level: (0, $ed9e287f879c493f$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
        (0, $6699f20558f1dc05$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $7282385c3b342e3b$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $6699f20558f1dc05$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: "fetch",
                data: data,
                type: "http",
                level: (0, $ed9e287f879c493f$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
            (0, $6699f20558f1dc05$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $7282385c3b342e3b$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $a1feead10a53e4e1$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $6699f20558f1dc05$export$efda9a273d7a036d)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $7282385c3b342e3b$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $dee268dff39ca98a$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $dee268dff39ca98a$var$INTEGRATION_NAME = "BrowserApiErrors";
const $dee268dff39ca98a$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $dee268dff39ca98a$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81), "setTimeout", $dee268dff39ca98a$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81), "setInterval", $dee268dff39ca98a$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)((0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81), "requestAnimationFrame", $dee268dff39ca98a$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81)) (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)(XMLHttpRequest.prototype, "send", $dee268dff39ca98a$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $dee268dff39ca98a$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($dee268dff39ca98a$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $dee268dff39ca98a$export$59bfe9f1c76150e = (0, $16575ede9e208d34$export$2323046b9414659f)($dee268dff39ca98a$var$_browserApiErrorsIntegration);
function $dee268dff39ca98a$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $b719cbe9bf6aff6a$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $79681426e6433cce$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
function $dee268dff39ca98a$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $b719cbe9bf6aff6a$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $79681426e6433cce$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $dee268dff39ca98a$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $79681426e6433cce$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $ac73fe157e02a9a2$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $79681426e6433cce$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $b719cbe9bf6aff6a$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $dee268dff39ca98a$var$_wrapEventTarget(target) {
    const globalObject = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.("addEventListener")) return;
    (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)(proto, "addEventListener", function(original) {
        return function(eventName, fn, options) {
            try {
                if ($dee268dff39ca98a$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $b719cbe9bf6aff6a$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $79681426e6433cce$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                (0, $b719cbe9bf6aff6a$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $79681426e6433cce$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $ac73fe157e02a9a2$export$9563e054e6f787fb)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $dee268dff39ca98a$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === "function";
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $a85a46a769effafb$export$1baa7880e357371c = (0, $16575ede9e208d34$export$2323046b9414659f)(()=>{
    return {
        name: "BrowserSession",
        setupOnce () {
            if (typeof (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document === "undefined") {
                (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $54ca942ea01c8aa7$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $54ca942ea01c8aa7$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $ef8ca1530ef1c35b$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $54ca942ea01c8aa7$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $54ca942ea01c8aa7$export$667e7b4d445d566b)();
                }
            });
        }
    };
});






const $71f0baf351937888$var$INTEGRATION_NAME = "GlobalHandlers";
const $71f0baf351937888$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $71f0baf351937888$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $71f0baf351937888$var$_installGlobalOnErrorHandler(client);
                $71f0baf351937888$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $71f0baf351937888$var$_installGlobalOnUnhandledRejectionHandler(client);
                $71f0baf351937888$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $71f0baf351937888$export$66acc70e8cf2b71a = (0, $16575ede9e208d34$export$2323046b9414659f)($71f0baf351937888$var$_globalHandlersIntegration);
function $71f0baf351937888$var$_installGlobalOnErrorHandler(client) {
    (0, $63015dd6bc837fa0$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $71f0baf351937888$var$getOptions();
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client || (0, $b719cbe9bf6aff6a$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $71f0baf351937888$var$_enhanceEventWithInitialFrame((0, $f8d0f64002600710$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $54ca942ea01c8aa7$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $71f0baf351937888$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $ce8c28c424f04aec$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $71f0baf351937888$var$getOptions();
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client || (0, $b719cbe9bf6aff6a$export$b79738ab10c590b2)()) return;
        const error = $71f0baf351937888$var$_getUnhandledRejectionError(e);
        const event = (0, $64d77030f0d405c5$export$c3825b437cbdea5c)(error) ? $71f0baf351937888$var$_eventFromRejectionWithPrimitive(error) : (0, $f8d0f64002600710$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $54ca942ea01c8aa7$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $71f0baf351937888$var$_getUnhandledRejectionError(error) {
    if ((0, $64d77030f0d405c5$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ("detail" in error && "reason" in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $71f0baf351937888$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $71f0baf351937888$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = (0, $64d77030f0d405c5$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $b3dd2fa7e571301f$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $79681426e6433cce$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $71f0baf351937888$var$globalHandlerLog(type) {
    (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $71f0baf351937888$var$getOptions() {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $f6c27f424b9ccf73$export$1378794447170364 = (0, $16575ede9e208d34$export$2323046b9414659f)(()=>{
    return {
        name: "HttpContext",
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).navigator && !(0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).location && !(0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request?.url || (0, $b3dd2fa7e571301f$export$1cfafeee2987818b)();
            const { referrer: referrer } = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request?.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $3b1d2a253ad1b873$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $64d77030f0d405c5$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $3b1d2a253ad1b873$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $3b1d2a253ad1b873$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $64d77030f0d405c5$export$49034edbe6b62415)(error[key], Error)) {
        $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $3b1d2a253ad1b873$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $64d77030f0d405c5$export$49034edbe6b62415)(childError, Error)) {
            $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $3b1d2a253ad1b873$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $3b1d2a253ad1b873$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $aa4713a685f056ef$var$DEFAULT_KEY = "cause";
const $aa4713a685f056ef$var$DEFAULT_LIMIT = 5;
const $aa4713a685f056ef$var$INTEGRATION_NAME = "LinkedErrors";
const $aa4713a685f056ef$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $aa4713a685f056ef$var$DEFAULT_LIMIT;
    const key = options.key || $aa4713a685f056ef$var$DEFAULT_KEY;
    return {
        name: $aa4713a685f056ef$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $3b1d2a253ad1b873$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $f8d0f64002600710$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $aa4713a685f056ef$export$ebabb00eb7f3a395 = (0, $16575ede9e208d34$export$2323046b9414659f)($aa4713a685f056ef$var$_linkedErrorsIntegration);







const $8aef2c00a1d11180$export$c8667f1887a128dc = Symbol.for("SentryBufferFullError");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $8aef2c00a1d11180$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0] || Promise.resolve(undefined);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $61dce522664ed8d7$export$78e43115b553f358)($8aef2c00a1d11180$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $61dce522664ed8d7$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $1fca082c96d04342$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $1fca082c96d04342$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $1fca082c96d04342$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $1fca082c96d04342$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $1fca082c96d04342$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $1fca082c96d04342$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $1fca082c96d04342$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.["x-sentry-rate-limits"];
    const retryAfterHeader = headers?.["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $1fca082c96d04342$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



const $dd8074104a80a0fa$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $dd8074104a80a0fa$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $8aef2c00a1d11180$export$85a4f67f852183e6)(options.bufferSize || $dd8074104a80a0fa$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $8bfdedaf88c5689c$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $8bfdedaf88c5689c$export$b11169581eeaf237)(type);
            if ((0, $1fca082c96d04342$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent("ratelimit_backoff", dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)({});
        const filteredEnvelope = (0, $8bfdedaf88c5689c$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $8bfdedaf88c5689c$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $8bfdedaf88c5689c$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $8bfdedaf88c5689c$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $1fca082c96d04342$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Encountered error running transport request:", error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $8aef2c00a1d11180$export$c8667f1887a128dc)) {
                (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $61dce522664ed8d7$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $6c0d73963c08fb00$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $6c0d73963c08fb00$export$e464f4a514ac28a8(name) {
    const cached = $6c0d73963c08fb00$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $42d6ae1bbd19a79b$export$d5f608b368e73f38)(impl)) return $6c0d73963c08fb00$var$cachedImplementations[name] = impl.bind((0, $182fc35abbd0c773$export$56d8a8a25bd48b81));
    const document = (0, $182fc35abbd0c773$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $0ea1e843b9735ae3$export$16a28057038b10ef) && (0, $54bb708c4b877c1c$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $6c0d73963c08fb00$var$cachedImplementations[name] = impl.bind((0, $182fc35abbd0c773$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $6c0d73963c08fb00$export$8aa36702e8c8978(name) {
    $6c0d73963c08fb00$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $6c0d73963c08fb00$export$e7aa7bc5c1b3cfb3(...rest) {
    return $6c0d73963c08fb00$export$e464f4a514ac28a8("fetch")(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $6c0d73963c08fb00$export$831dc9f2ab0a617b(...rest) {
    return $6c0d73963c08fb00$export$e464f4a514ac28a8("setTimeout")(...rest);
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $6cc958bf129f6662$export$b2311068c46d7cc8(options, nativeFetch = (0, $6c0d73963c08fb00$export$e464f4a514ac28a8)("fetch")) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "strict-origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $6c0d73963c08fb00$export$8aa36702e8c8978)("fetch");
            return (0, $61dce522664ed8d7$export$78e43115b553f358)("No fetch implementation available");
        }
        try {
            // TODO: This may need a `suppressTracing` call in the future when we switch the browser SDK to OTEL
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $6c0d73963c08fb00$export$8aa36702e8c8978)("fetch");
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $61dce522664ed8d7$export$78e43115b553f358)(e);
        }
    }
    return (0, $dd8074104a80a0fa$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $1ce9d2c01f92d810$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v10): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $357c9202e1ca2659$export$cb3c5c2ceb9818ba)(),
        (0, $5da8f55c0a121980$export$7918117e9202e4fb)(),
        (0, $dee268dff39ca98a$export$59bfe9f1c76150e)(),
        (0, $7282385c3b342e3b$export$c079d904b326663a)(),
        (0, $71f0baf351937888$export$66acc70e8cf2b71a)(),
        (0, $aa4713a685f056ef$export$ebabb00eb7f3a395)(),
        (0, $c6287212c014af6f$export$6d39aa44cd0c7567)(),
        (0, $f6c27f424b9ccf73$export$1378794447170364)(),
        (0, $a85a46a769effafb$export$1baa7880e357371c)()
    ];
}
/** Exported only for tests. */ function $1ce9d2c01f92d810$export$4e107b20a7f977(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $1ce9d2c01f92d810$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === "string" // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...$1ce9d2c01f92d810$var$dropTopLevelUndefinedKeys(optionsArg)
    };
}
/**
 * In contrast to the regular `dropUndefinedKeys` method,
 * this one does not deep-drop keys, but only on the top level.
 */ function $1ce9d2c01f92d810$var$dropTopLevelUndefinedKeys(obj) {
    const mutatetedObj = {};
    for (const k of Object.getOwnPropertyNames(obj)){
        const key = k;
        if (obj[key] !== undefined) mutatetedObj[key] = obj[key];
    }
    return mutatetedObj;
}
function $1ce9d2c01f92d810$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeExtension = typeof (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).window !== "undefined" && (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81);
    if (!windowWithMaybeExtension) // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const extensionKey = windowWithMaybeExtension.chrome ? "chrome" : "browser";
    const extensionObject = windowWithMaybeExtension[extensionKey];
    const runtimeId = extensionObject?.runtime?.id;
    const href = (0, $b3dd2fa7e571301f$export$1cfafeee2987818b)() || "";
    const extensionProtocols = [
        "chrome-extension:",
        "moz-extension:",
        "ms-browser-extension:",
        "safari-web-extension:"
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = !!runtimeId && (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81) === (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}//`));
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    const isNWjs = typeof windowWithMaybeExtension.nw !== "undefined";
    return !!runtimeId && !isDedicatedExtensionPage && !isNWjs;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $1ce9d2c01f92d810$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $1ce9d2c01f92d810$export$4e107b20a7f977(browserOptions);
    if (!options.skipBrowserExtensionCheck && $1ce9d2c01f92d810$var$shouldShowBrowserExtensionError()) {
        if (0, $4f31ecb266c05841$export$16a28057038b10ef) (0, $398c2530c60234a2$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error("[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/");
        });
        return;
    }
    if ((0, $4f31ecb266c05841$export$16a28057038b10ef) && !(0, $3ec67e5bc0c0a1c0$export$edf3cb81fd7d2a3e)()) (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.");
    const clientOptions = {
        ...options,
        stackParser: (0, $79681426e6433cce$export$1d5cf88b347146d4)(options.stackParser || (0, $deb2d89c0fb26d33$export$2b2b997d81bf3907)),
        integrations: (0, $16575ede9e208d34$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $6cc958bf129f6662$export$b2311068c46d7cc8)
    };
    return (0, $e9dea091abe21853$export$5333c3f1c58d9bc1)((0, $56366ed1565721b7$export$1df9218a526d318d), clientOptions);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $1ce9d2c01f92d810$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document) {
        (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Global document not defined in showReportDialog call");
        return;
    }
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client?.getDsn();
    if (!dsn) {
        (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $54ca942ea01c8aa7$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $a4a00d49d83ad967$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.head || (0, $b719cbe9bf6aff6a$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Not injecting report dialog. No injection point found in HTML");
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $1ce9d2c01f92d810$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $1ce9d2c01f92d810$export$4e4d8b287d028b6b(callback) {
    callback();
}

/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $5f9a85a811b2c02d$export$d92e61f5600202af(url, client) {
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    return $5f9a85a811b2c02d$var$checkDsn(url, dsn) || $5f9a85a811b2c02d$var$checkTunnel(url, tunnel);
}
function $5f9a85a811b2c02d$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $5f9a85a811b2c02d$var$removeTrailingSlash(url) === $5f9a85a811b2c02d$var$removeTrailingSlash(tunnel);
}
function $5f9a85a811b2c02d$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $5f9a85a811b2c02d$var$removeTrailingSlash(str) {
    return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}




const $e3117c1cbc73b349$var$INTEGRATION_NAME = "HttpClient";
const $e3117c1cbc73b349$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $e3117c1cbc73b349$var$INTEGRATION_NAME,
        setup (client) {
            $e3117c1cbc73b349$var$_wrapFetch(client, _options);
            $e3117c1cbc73b349$var$_wrapXHR(client, _options);
        }
    };
};
/**
 * Create events for failed client side HTTP requests.
 */ const $e3117c1cbc73b349$export$8a3b7aeb379b3907 = (0, $16575ede9e208d34$export$2323046b9414659f)($e3117c1cbc73b349$var$_httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function $e3117c1cbc73b349$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($e3117c1cbc73b349$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $e3117c1cbc73b349$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        if ($e3117c1cbc73b349$var$_shouldSendDefaultPii()) {
            [requestHeaders, requestCookies] = $e3117c1cbc73b349$var$_parseCookieHeaders("Cookie", request);
            [responseHeaders, responseCookies] = $e3117c1cbc73b349$var$_parseCookieHeaders("Set-Cookie", response);
        }
        const event = $e3117c1cbc73b349$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error
        });
        (0, $54ca942ea01c8aa7$export$1462b974fdcf6ba2)(event);
    }
}
function $e3117c1cbc73b349$var$_parseCookieHeaders(cookieHeader, obj) {
    const headers = $e3117c1cbc73b349$var$_extractFetchHeaders(obj.headers);
    let cookies;
    try {
        const cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
        if (cookieString) cookies = $e3117c1cbc73b349$var$_parseCookieString(cookieString);
    } catch  {
    // ignore it if parsing fails
    }
    return [
        headers,
        cookies
    ];
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function $e3117c1cbc73b349$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($e3117c1cbc73b349$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        if ($e3117c1cbc73b349$var$_shouldSendDefaultPii()) {
            try {
                const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || undefined;
                if (cookieString) responseCookies = $e3117c1cbc73b349$var$_parseCookieString(cookieString);
            } catch  {
            // ignore it if parsing fails
            }
            try {
                responseHeaders = $e3117c1cbc73b349$var$_getXHRResponseHeaders(xhr);
            } catch  {
            // ignore it if parsing fails
            }
            requestHeaders = headers;
        }
        const event = $e3117c1cbc73b349$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error
        });
        (0, $54ca942ea01c8aa7$export$1462b974fdcf6ba2)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function $e3117c1cbc73b349$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function $e3117c1cbc73b349$var$_parseCookieString(cookieString) {
    return cookieString.split("; ").reduce((acc, cookie)=>{
        const [key, value] = cookie.split("=");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function $e3117c1cbc73b349$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function $e3117c1cbc73b349$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function $e3117c1cbc73b349$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function $e3117c1cbc73b349$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function $e3117c1cbc73b349$var$_wrapFetch(client, options) {
    if (!(0, $3ec67e5bc0c0a1c0$export$c82d238e23c40b21)()) return;
    (0, $99fdad47f98ba4a1$export$f75d3c772c923df0)((handlerData)=>{
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $e3117c1cbc73b349$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function $e3117c1cbc73b349$var$_wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, $1c9e486be4080d26$export$f1a6cdb1459e81d1))) return;
    (0, $46d6641fe3f28167$export$26ace48dd54c9aea)((handlerData)=>{
        if ((0, $35358b2c9a559011$export$6bb76d6eba7e258c)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $46d6641fe3f28167$export$55b6bb1e45c6cf59];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $e3117c1cbc73b349$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("Error while extracting response event form XHR response", e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function $e3117c1cbc73b349$var$_shouldCaptureResponse(options, status, url) {
    return $e3117c1cbc73b349$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $e3117c1cbc73b349$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $5f9a85a811b2c02d$export$d92e61f5600202af)(url, (0, $35358b2c9a559011$export$6bb76d6eba7e258c)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function $e3117c1cbc73b349$var$_createEvent(data) {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : undefined;
    // Remove the first frame from the stack as it's the HttpClient call
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : undefined;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : undefined
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $e3117c1cbc73b349$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $5985640674d52865$export$c69a9a0313b03bb1)(event, {
        type: "http.client",
        handled: false
    });
    return event;
}
function $e3117c1cbc73b349$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $e3117c1cbc73b349$var$_shouldSendDefaultPii() {
    const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}


const $5d4926bb7a571eba$var$FASTSHIFT_BASE_URL_PROD = "https://fastshift.atlassian.com";
const $5d4926bb7a571eba$var$FASTSHIFT_BASE_URL_STAGING = "https://fastshift.stg.internal.atlassian.com";
const $5d4926bb7a571eba$var$FASTSHIFT_BASE_URL_DEV = "https://fastshift.dev.internal.atlassian.com";
const $5d4926bb7a571eba$export$3628946b822aa707 = $5d4926bb7a571eba$var$FASTSHIFT_BASE_URL_PROD;
const $5d4926bb7a571eba$export$bc91eef109fd258b = `${$5d4926bb7a571eba$export$3628946b822aa707}/gateway/api`;
const $5d4926bb7a571eba$var$SENTRY_PROJECT_NAME = "FASTSHIFT_PORTAL";
const $5d4926bb7a571eba$var$getFastshiftSentryClient = ()=>new (0, $56366ed1565721b7$export$1df9218a526d318d)({
        dsn: "https://7094bf0a2bc1951c62fadea8306b7ca2@o55978.ingest.us.sentry.io/4510151685242880",
        transport: (0, $6cc958bf129f6662$export$b2311068c46d7cc8),
        stackParser: (0, $deb2d89c0fb26d33$export$2b2b997d81bf3907),
        enabled: true,
        environment: "production",
        release: window.BUILD_KEY,
        dist: window.BUILD_KEY,
        integrations: [
            ...(0, $1ce9d2c01f92d810$export$5783b2920b1d62b9)({}),
            (0, $e3117c1cbc73b349$export$8a3b7aeb379b3907)(),
            (0, $040cc7132a09aab4$export$b4109253475213e9)()
        ],
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            "localhost",
            /^https:\/\/atlassian\.com/
        ]
    });
const $5d4926bb7a571eba$var$getFastshiftSentryScope = ()=>{
    const scope = new (0, $debd2a81681f2cab$export$775b6bb06e53a214)();
    scope.setClient($5d4926bb7a571eba$var$getFastshiftSentryClient());
    scope.setTag("projectName", $5d4926bb7a571eba$var$SENTRY_PROJECT_NAME);
    return scope;
};
const $5d4926bb7a571eba$export$cdfb2f8bf93ec458 = (errorMsg, httpStatus, statusText, url)=>{
    const fastshiftSentryScope = $5d4926bb7a571eba$var$getFastshiftSentryScope();
    (0, $35358b2c9a559011$export$ec58d9285c204497)(fastshiftSentryScope, ()=>{
        fastshiftSentryScope.setContext("response", {
            status: httpStatus,
            statusText: statusText,
            url: url
        });
        fastshiftSentryScope.captureException(new Error(errorMsg));
    });
};



function $6e969e08c9befeb1$export$659f3e5265115438({ name: name, value: value }) {
    return (0, $6c7e05446819bf8a$exports.serialize)(name, value);
}
function $6e969e08c9befeb1$export$2caf3886cd1c5ca7(cookie) {
    if (cookie) return {
        cookie: $6e969e08c9befeb1$export$659f3e5265115438(cookie)
    };
    else return {};
}





function $985edf64a00a34be$export$1179561ba14bdda9() {
    if (!window || !(0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp10416DisableNonOperationalAnalyticsGateUip)) return {};
    try {
        const atl_first_visit = (0, $2c637c10bc35918d$export$d3720feff416e85b)("atl_first_visit", true);
        const userMeta = atl_first_visit ? {
            userMeta: JSON.stringify({
                firstVisitActivationContext: JSON.parse(atl_first_visit)
            })
        } : {};
        return userMeta;
    } catch (error) {
        console.error("Error mapping local storage user meta to payload", error);
        return {};
    }
}
function $985edf64a00a34be$export$70e5dd9137813f23() {
    if (!window || !(0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).voltronMultiTouchAnalytics)) return {};
    try {
        const trace_id = (0, $2c637c10bc35918d$export$d3720feff416e85b)("trace_id", true);
        return trace_id && typeof trace_id === "string" ? {
            "x-wac-trace-id": trace_id
        } : {};
    } catch (error) {
        console.error("Error mapping local storage trace id to payload", error);
        return {};
    }
}


function $2b83507c21d11055$export$76c6404ebb3f2fbe({ account_id: account_id, ...others }) {
    return {
        accountId: account_id,
        ...others
    };
}


class $72e2dd731bbce2cc$export$da6dec65957b7041 extends Error {
    constructor({ message: message, response: response }){
        super(message ?? response.statusText);
        this.name = $72e2dd731bbce2cc$export$da6dec65957b7041.name;
        this.response = response;
    }
    get url() {
        return this.response.url;
    }
    get status() {
        return this.response.status;
    }
}
function $72e2dd731bbce2cc$export$24a0e392ef274e28(value) {
    return value.name === $72e2dd731bbce2cc$export$da6dec65957b7041.name;
}
class $72e2dd731bbce2cc$export$ef953687cf93d9ab extends $72e2dd731bbce2cc$export$da6dec65957b7041 {
    constructor(response){
        super({
            message: "Madlib content generation request was unsuccessful",
            response: response
        });
        this.name = $72e2dd731bbce2cc$export$ef953687cf93d9ab.name;
    }
}
class $72e2dd731bbce2cc$export$e8889cc9a6240378 extends $72e2dd731bbce2cc$export$da6dec65957b7041 {
    constructor(response){
        super({
            message: "Project create request was unsuccessful",
            response: response
        });
        this.name = $72e2dd731bbce2cc$export$e8889cc9a6240378.name;
    }
}


async function $783e9a753ed8da98$export$779c89bcd6b62ed(response) {
    if (response.ok) return await response.text();
    else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
        message: await $783e9a753ed8da98$var$mapResponseToMessage(response),
        response: response
    });
}
async function $783e9a753ed8da98$export$a1968f52311c9c2e(response) {
    if (response.ok) return await response.json();
    else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
        message: await $783e9a753ed8da98$var$mapResponseToMessage(response),
        response: response
    });
}
async function $783e9a753ed8da98$export$decf6f2c5b50afb9(response) {
    if (response.ok) return;
    throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
        message: await $783e9a753ed8da98$var$mapResponseToMessage(response),
        response: response
    });
}
async function $783e9a753ed8da98$var$mapResponseToMessage(response) {
    const { statusText: statusText } = response;
    const message = await response.text();
    if (message.length > 0) return `${statusText} ${message}`;
    else return statusText;
}
async function $783e9a753ed8da98$export$fb32ca1688c02097(response) {
    try {
        const errorResponse = await response.json();
        if (errorResponse.error) return errorResponse.error;
        return null;
    } catch  {
        return null;
    }
}
async function $783e9a753ed8da98$export$98010428730e71ea(response) {
    try {
        const errorText = await response.text();
        return errorText || null;
    } catch  {
        return null;
    }
}
async function $783e9a753ed8da98$export$82f46aa4e6535a45(response) {
    const errorMessageFromJson = await $783e9a753ed8da98$export$fb32ca1688c02097(response);
    if (errorMessageFromJson) return errorMessageFromJson;
    const errorMessageFromText = await $783e9a753ed8da98$export$98010428730e71ea(response);
    if (errorMessageFromText) return errorMessageFromText;
    return "";
}


const $41e6136240388aad$export$c7346ed3533fb878 = ({ site: site, includeInvalidBitbucketSite: includeInvalidBitbucketSite })=>{
    const ignoreSiteNames = [
        "servicedog",
        "ecosystem",
        "atlassiantraining",
        "Atlassian Stride",
        "volunteerhub",
        "atlassiantraining",
        "hello-staging",
        "ecosystem",
        "riskmanagement",
        "hello-staging3",
        "hello-staging6",
        "hello-staging9",
        "jdog",
        "sre-ehlo",
        "trello",
        "Trello"
    ];
    if (!includeInvalidBitbucketSite) ignoreSiteNames.push("bitbucket", "Bitbucket");
    if (ignoreSiteNames.includes(site.displayName)) return false;
    if (site.cloudId.startsWith("DUMMY")) return false;
    return true;
};



var $d89d37cb1202c93b$export$5699ee30bc277ff0;
(function(AuthenticationMethodsType) {
    AuthenticationMethodsType["PASSWORD"] = "password";
    AuthenticationMethodsType["GOOGLE"] = "google";
    AuthenticationMethodsType["SAML"] = "saml";
    AuthenticationMethodsType["MICROSOFT"] = "microsoft";
    AuthenticationMethodsType["APPLE"] = "apple";
    AuthenticationMethodsType["SLACK"] = "slack";
})($d89d37cb1202c93b$export$5699ee30bc277ff0 || ($d89d37cb1202c93b$export$5699ee30bc277ff0 = {}));
var $d89d37cb1202c93b$export$ff019c77e16f7f42;
(function(SampleDataVersion) {
    SampleDataVersion["MATURE"] = "MATURE";
    SampleDataVersion["WIZARD"] = "WIZARD";
    SampleDataVersion["GENERIC"] = "GENERIC";
    SampleDataVersion["MATUREV2"] = "MATUREV2";
    SampleDataVersion["SPACE_ONBOARDING"] = "SPACE_ONBOARDING";
})($d89d37cb1202c93b$export$ff019c77e16f7f42 || ($d89d37cb1202c93b$export$ff019c77e16f7f42 = {}));
var $d89d37cb1202c93b$export$13699c771a86789f;
(function(GetUserPermissionsIsPermittedRequestPermissionId) {
    GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCTS"] = "add-products";
    GetUserPermissionsIsPermittedRequestPermissionId["INVITE_USERS"] = "invite-users";
    GetUserPermissionsIsPermittedRequestPermissionId["MANAGE"] = "manage";
    GetUserPermissionsIsPermittedRequestPermissionId["WRITE"] = "write";
    /**
   * @deprecated ADD_PRODUCT is a legacy permissionId, use ADD_PRODUCTS instead.
   */ GetUserPermissionsIsPermittedRequestPermissionId["ADD_PRODUCT"] = "addProduct";
})($d89d37cb1202c93b$export$13699c771a86789f || ($d89d37cb1202c93b$export$13699c771a86789f = {}));
var $d89d37cb1202c93b$export$7f151cd797d132bd;
(function(AccessRequestCapability) {
    AccessRequestCapability["DIRECT_ACCESS"] = "DIRECT_ACCESS";
    AccessRequestCapability["REQUEST_ACCESS"] = "REQUEST_ACCESS";
    AccessRequestCapability["ACCESS_GRANTED"] = "ACCESS_GRANTED";
    AccessRequestCapability["ACCESS_EXISTS"] = "ACCESS_EXISTS";
    AccessRequestCapability["PENDING_REQUEST_CREATED"] = "PENDING_REQUEST_CREATED";
    AccessRequestCapability["PENDING_REQUEST_EXISTS"] = "PENDING_REQUEST_EXISTS";
    AccessRequestCapability["APPROVED_REQUEST_EXISTS"] = "APPROVED_REQUEST_EXISTS";
    AccessRequestCapability["DENIED_REQUEST_EXISTS"] = "DENIED_REQUEST_EXISTS";
    AccessRequestCapability["FORBIDDEN"] = "FORBIDDEN";
    AccessRequestCapability["VERIFICATION_REQUIRED"] = "VERIFICATION_REQUIRED";
    AccessRequestCapability["ERROR"] = "ERROR";
})($d89d37cb1202c93b$export$7f151cd797d132bd || ($d89d37cb1202c93b$export$7f151cd797d132bd = {}));
var $d89d37cb1202c93b$export$d017131e0710c5ee;
(function(AccessRole) {
    AccessRole["PRODUCT_MEMBER"] = "product/member";
    AccessRole["PRODUCT_HELPSEEKER"] = "product/helpseeker";
})($d89d37cb1202c93b$export$d017131e0710c5ee || ($d89d37cb1202c93b$export$d017131e0710c5ee = {}));
var $d89d37cb1202c93b$export$94ef2cab706385a3;
(function(JiraProjectCreateErrors) {
    JiraProjectCreateErrors["noSiteAccess"] = "noSiteAccess";
    JiraProjectCreateErrors["badRequest"] = "badRequest";
    JiraProjectCreateErrors["badGateway"] = "badGateway";
    JiraProjectCreateErrors["projectNameCollision"] = "projectNamingCollision";
    JiraProjectCreateErrors["projectKeyCollision"] = "projectKeyCollision";
    JiraProjectCreateErrors["noProjectCreateAccess"] = "noProjectCreateAccess";
})($d89d37cb1202c93b$export$94ef2cab706385a3 || ($d89d37cb1202c93b$export$94ef2cab706385a3 = {}));
const $d89d37cb1202c93b$export$889bc7d00388a53 = 45000;
class $d89d37cb1202c93b$export$4640a7cbf45425fa extends Error {
    constructor(message, { status: status, taskMessage: taskMessage, id: id }){
        super(message);
        this.status = status;
        this.id = id;
        this.taskMessage = taskMessage;
    }
}
var $d89d37cb1202c93b$export$21de27a5998af787;
(function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
})($d89d37cb1202c93b$export$21de27a5998af787 || ($d89d37cb1202c93b$export$21de27a5998af787 = {}));
const $d89d37cb1202c93b$export$e5fd4bbfb733272f = {
    NEEDS_ATTENTION: "NEEDS_ATTENTION",
    ON_TRACK: "ON_TRACK",
    COMPLETE: "COMPLETE"
};
const $d89d37cb1202c93b$export$aafef5252493cbb0 = {
    TO_DO: "TO_DO",
    ON_TRACK: "ON_TRACK",
    AT_RISK_ATLASSIAN_OWNED: "AT_RISK_ATLASSIAN_OWNED",
    AT_RISK_PARTNER_OWNED: "AT_RISK_PARTNER_OWNED",
    NEEDS_CUSTOMER_ATTENTION: "NEEDS_CUSTOMER_ATTENTION",
    COMPLETE: "COMPLETE"
};
const $d89d37cb1202c93b$export$c8519ead08e3777c = {
    CONSULT: "CONSULT",
    PLAN: "PLAN",
    SUPPORT_REQUEST: "SUPPORT_REQUEST",
    PROBLEM_REPORT: "PROBLEM_REPORT"
};
const $d89d37cb1202c93b$export$5eed94f884a35e8e = {
    JIRA: "JIRA",
    CONFLUENCE: "CONFLUENCE"
};
const $d89d37cb1202c93b$export$a139c884b248a52a = {
    DONE: "DONE",
    NOT_DONE: "NOT DONE"
};
const $d89d37cb1202c93b$export$7428175ef648f8bd = {
    NOT_FOUND: "NOT_FOUND",
    // 404 status
    NO_ACCESS: "NO_ACCESS" // 401 status
};
const $d89d37cb1202c93b$export$14701d34cfd76bf = {
    NO_ENGAGEMENT: "NO_ENGAGEMENT",
    // 404 status
    NO_ACCESS: "NO_ACCESS",
    // 401 status
    USER_NOT_PROVISIONED: "USER_NOT_PROVISIONED" // 403 status
};
const $d89d37cb1202c93b$export$2c57f6d935fc3dec = {
    NO_ELIGIBLE_LICENSE: "NO_ELIGIBLE_LICENSE",
    // 404 status
    NO_ACCESS: "NO_ACCESS" // 401 status
};
const $d89d37cb1202c93b$export$37fb66430ebc275 = {
    WAC_SIGNUP: "wac-signup"
};
const $d89d37cb1202c93b$export$30557b1912f2c86a = {
    PROVISIONING_COMPLETED: "PROVISIONING_COMPLETED",
    PROVISIONING_FAILED: "PROVISIONING_FAILED",
    PROVISIONING_IN_PROGRESS: "PROVISIONING_IN_PROGRESS",
    PROVISIONING_ABORTED: "PROVISIONING_ABORTED",
    PROVISIONING_PROCESS_NOT_FOUND: "PROVISIONING_PROCESS_NOT_FOUND",
    PROVISIONING_FAILED_COMPLETED: "PROVISIONING_FAILED_COMPLETED"
};
const $d89d37cb1202c93b$export$4e1ad3f3c6e5680c = {
    ACTIVATE: "activate",
    WAIT_FOR_ACTIVATION: "wait-for-activation",
    WAIT_FOR_JIRA: "wait-for-jira",
    CREATE_JIRA_PROJECT: "create-jira-project",
    ONBOARD_JPD_PROJECT: "onboard-jpd-project"
};


const $cd2194d8d3feda9a$var$BASE_URL = "https://www.atlassian.com/gateway/api";
const $cd2194d8d3feda9a$export$82617393f6a222b1 = new Set([
    "ap-southeast-1",
    "ap-southeast-2",
    "us-east-1",
    "us-west-2",
    "eu-west-1",
    "eu-central-1"
]);
const $cd2194d8d3feda9a$export$2f6f3c380745077 = new Set([
    "us-east-1",
    "us-west-2"
]);
const $cd2194d8d3feda9a$export$436826b9c15fad96 = new Set([
    "us-east-1"
]);
class $cd2194d8d3feda9a$export$963f114b487aad6d {
    constructor({ baseUrl: baseUrl }){
        this.baseUrl = baseUrl;
    }
    async fetch(urlPath, init, removeBaseUrl) {
        try {
            return fetch(removeBaseUrl ? urlPath : this.baseUrl + urlPath, init);
        } catch (error) {
            console.error("Fetch error:", error);
            return new Response(null, {
                status: 500,
                statusText: "Error"
            });
        }
    }
    async me({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        // note: not de-duping fetches like in asc-stargate
        const response = await this.fetch("/me", {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) return (0, $2b83507c21d11055$export$76c6404ebb3f2fbe)(await response.json());
        else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
            response: response
        });
    }
    // extended_profile defintion: https://bitbucket.org/atlassian/id-public-api-facade/src/b6dbac9d5f1b6951c88d93ebeda0c3b68283aa40/swagger.yaml#lines-2479:2493
    // DAC Docs: https://developer.atlassian.com/cloud/admin/user-management/rest/api-group-profile/#api-group-profile
    async updateIdentityProfile({ aaid: aaid, extendedProfile: extendedProfile }) {
        return (0, $783e9a753ed8da98$export$decf6f2c5b50afb9)(await this.fetch(`/users/${aaid}/manage/profile`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                extended_profile: {
                    ...extendedProfile
                }
            }),
            credentials: "include"
        }));
    }
    async getSignupServerXsrfToken() {
        return (0, $783e9a753ed8da98$export$779c89bcd6b62ed)(await this.fetch(`/bxp/signup/auth/xsrf`, {
            method: "GET",
            credentials: "include",
            headers: {
                "web-platform": "bxp-web-platform",
                "accept": "text/plain"
            }
        }));
    }
    /**
   * Get the authentication methods available to a given user.
   *
   * @see https://bxp-signup-server.us-west-2.prod.atl-paas.net/swagger/#/Identity/post_authentication_methods_available
   */ async checkAuthenticationMethodsAvailable({ email: email, application: application = "wac", successRedirect: successRedirect }) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/authentication/methods-available`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "web-platform": "bxp-web-platform",
                "X-Atl-Cohort-Id": atlCohortId,
                "x-b3-sampled": "1"
            },
            credentials: "include",
            body: JSON.stringify({
                email: email,
                application: application,
                continue: successRedirect
            })
        }));
    }
    async availableProducts({ cloudSessionTokenCookie: cloudSessionTokenCookie, removeNonAdminSites: removeNonAdminSites, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, makeS2sRequest: makeS2sRequest, userContext: userContext, retryAttempted: retryAttempted }) {
        let baseUrl = this.baseUrl ? `${this.baseUrl}/ais/available-products` : `/ais/available-products`;
        const headers = {
            ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
            "web-platform": "bxp-web-platform",
            "credentials": "include",
            "x-b3-sampled": "1"
        };
        if (makeS2sRequest && this.isSSR()) {
            //@ts-ignore
            const awsRegion = globalThis.ssrContext.awsRegion;
            // S2S calls only work if the downstream service exists in the same region that our tesseract runtime is in
            const downStreamServiceExistsInSameTesseractRuntimeRegion = $cd2194d8d3feda9a$export$82617393f6a222b1.has(awsRegion);
            if (!downStreamServiceExistsInSameTesseractRuntimeRegion) {
                console.log("Downstream service does not exist in the same region as current tesseract region. Current tesseract region: " + awsRegion);
                // Make non S2S call
                return await this.availableProducts({
                    cloudSessionTokenCookie: cloudSessionTokenCookie,
                    removeNonAdminSites: removeNonAdminSites,
                    includeInvalidSites: includeInvalidSites,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite,
                    makeS2sRequest: undefined
                });
            }
            headers["x-ssr-service-name"] = "bxp-express";
            // bxp-express service does not have any dev instances. So if it's dev -> we should point calls to stg
            const environmentType = //@ts-ignore
            globalThis.ssrContext.environmentType;
            if (environmentType === "dev") {
                // bxp-express service does not have any dev instances so when we're in dev, point to staging
                headers["x-ssr-service-env"] = "staging";
                headers["x-ssr-service-region"] = "us-east-1"; // Bxp-express service in staging only lives in us-east-1 or us-west-2
            }
            headers["user-context"] = userContext;
            baseUrl = "/ais/available-products";
        }
        let response;
        try {
            response = await this.fetch(baseUrl, {
                headers: headers
            }, true);
            if (response.ok) {
                const result = await response.json();
                let sites = result && result.sites || [];
                if (removeNonAdminSites) sites = sites.filter((site)=>site.adminAccess);
                if (!includeInvalidSites) sites = sites.filter((site)=>(0, $41e6136240388aad$export$c7346ed3533fb878)({
                        site: site,
                        includeInvalidBitbucketSite: includeInvalidBitbucketSite
                    }));
                return Promise.resolve({
                    sites: sites,
                    isNewUser: !!(result && result.isNewUser)
                });
            } else return Promise.resolve({
                sites: [],
                isNewUser: false,
                callFailed: true
            });
        } catch (error) {
            if (retryAttempted === false && makeS2sRequest === true) {
                console.log("There was an error making a call to available products for s2s call - retrying with non-s2s call");
                return await this.availableProducts({
                    cloudSessionTokenCookie: cloudSessionTokenCookie,
                    removeNonAdminSites: removeNonAdminSites,
                    includeInvalidSites: includeInvalidSites,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite,
                    makeS2sRequest: undefined,
                    userContext: undefined,
                    // This will automatically passed in as non-s2s calls will go through edge/stargate,
                    retryAttempted: true
                });
            }
            throw error;
        }
    }
    /**
   * The legacy get availableProducts call from IdentityClient
   */ async availableProductsLegacy({ cloudSessionTokenCookie: cloudSessionTokenCookie, includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
        const reqUrl = `${this.baseUrl}/available-products/api/available-products`;
        const response = await fetch(reqUrl, {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            let sites = result && result.sites || [];
            sites = (0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).remove((0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).map(sites, (site)=>{
                const products = (0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).map(site.availableProducts, (product)=>{
                    return (0, $8d086bea86f0235b$export$49ebef81048c4e68)[product.productType];
                }).filter((product)=>product !== undefined);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($dRxyd))).isEmpty(products)) return {
                    adminAccess: site.adminAccess,
                    cloudId: site.cloudId,
                    displayName: site.displayName,
                    url: site.url,
                    products: products
                };
                else return null;
            }), (site)=>site !== undefined && site !== null);
            if (!includeInvalidSites) sites = sites.filter((site)=>(0, $41e6136240388aad$export$c7346ed3533fb878)({
                    site: site,
                    includeInvalidBitbucketSite: includeInvalidBitbucketSite
                }));
            return Promise.resolve(sites);
        } else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
            response: response
        });
    }
    async activateProduct(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        const headers = (0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            "Content-Type": "application/json",
            "xsrf-token": xsrfToken,
            "X-Atl-Cohort-Id": atlCohortId,
            "web-platform": "bxp-web-platform",
            "x-b3-sampled": "1",
            "recaptcha-site-key": (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)(),
            ...(0, $985edf64a00a34be$export$70e5dd9137813f23)()
        });
        const body = {
            ...request,
            ...(0, $985edf64a00a34be$export$1179561ba14bdda9)()
        };
        const upstreamResponse = await (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/activate-product`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify(body)
        }));
        return upstreamResponse;
    }
    /**
   * Get a list of Bitbucket workspaces
   * @param nextUrl - override the request URL for pagination
   * bitbucket/user/permissions/workspaces?sort=workspace.slug
   */ async bitbucketWorkspaces({ nextUrl: nextUrl, cloudSessionTokenCookie: cloudSessionTokenCookie, urlQuery: urlQuery }) {
        let reqUrl = `${this.baseUrl}/bitbucket/user/permissions/workspaces`;
        if (nextUrl) reqUrl = nextUrl;
        if (urlQuery) reqUrl = `${reqUrl}?${urlQuery}`;
        const response = await fetch(reqUrl, {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) return Promise.resolve(await response.json());
        else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
            response: response
        });
    }
    async checkCloudNameAvailability({ cloudName: cloudName, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const headers = (0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie);
        Object.assign(headers, {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "web-platform": "bxp-web-platform"
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/hostname/cloud/availability/check`, {
            method: "post",
            body: JSON.stringify({
                cloudName: cloudName
            }),
            headers: headers,
            credentials: "include"
        }));
    }
    async getAvailableSites(request) {
        const { orderId: orderId, transactionAccount: transactionAccount } = request;
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bxp/signup/v1/order/${orderId}/available-sites`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                "X-Transaction-Account": transactionAccount,
                "x-b3-sampled": "1"
            },
            credentials: "include"
        }));
    }
    async getRecommendedSiteName(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        const headers = (0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            "Content-Type": "application/json",
            "xsrf-token": xsrfToken,
            "X-Atl-Cohort-Id": atlCohortId,
            "web-platform": "bxp-web-platform"
        });
        const response = await (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch("/bxp/signup/site/recommended-name", {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify(request)
        }));
        return response;
    }
    async getCloudStatus({ cloudId: cloudId, requestId: requestId }) {
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/cofs/${cloudId}/status/${requestId}`, {
            headers: {
                "Content-Type": "application/json",
                "X-Rate-Limit-Request-Id": requestId,
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        }));
    }
    async getProductActivationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/activate/status/${request.provisioningRequestId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "web-platform": "bxp-web-platform",
                "provision-polling-times": `${request.provisionPollingTimes}`,
                "x-b3-sampled": "1"
            },
            credentials: "include"
        }));
    }
    async getUserPermissionsIsPermitted({ permissionId: permissionId, resourceId: resourceId, dontRequirePrincipalInSite: dontRequirePrincipalInSite }) {
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/permissions/permitted`, {
            credentials: "include",
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                permissionId: permissionId,
                resourceId: resourceId,
                dontRequirePrincipalInSite: dontRequirePrincipalInSite
            })
        }));
    }
    async getUserProfile({ cloudSessionTokenCookie: cloudSessionTokenCookie, productName: productName, makeS2sRequest: makeS2sRequest, userContext: userContext }) {
        const queryString = productName ? `?${new URLSearchParams({
            productName: productName
        })}` : "";
        let baseUrl = this.baseUrl ? `${this.baseUrl}/bxp/signup/user/profile${queryString}` : `/bxp/signup/user/profile${queryString}`;
        const headers = {
            ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
            "web-platform": "bxp-web-platform"
        };
        if (makeS2sRequest && this.isSSR()) {
            //@ts-ignore
            const awsRegion = globalThis.ssrContext.awsRegion;
            const environmentType = //@ts-ignore
            globalThis.ssrContext.environmentType;
            if ($cd2194d8d3feda9a$export$2f6f3c380745077.has(awsRegion) && environmentType !== "dev") {
                headers["x-ssr-service-name"] = "bxp-signup-server";
                headers["x-ssr-service-region"] = awsRegion;
                headers["user-context"] = userContext;
                baseUrl = `/user/profile${queryString}`;
            } else if (environmentType === "dev") {
                headers["x-ssr-service-name"] = "bxp-signup-server";
                headers["x-ssr-service-region"] = "us-west-2";
                headers["user-context"] = userContext;
                baseUrl = `/user/profile${queryString}`;
            }
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(baseUrl, {
            headers: headers,
            credentials: "include",
            method: "GET"
        }, true));
    }
    async postExpandFreeValidation(request) {
        const { cloudId: cloudId, productKeys: productKeys } = request;
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/cloud/expand-free-validation`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform"
            },
            credentials: "include",
            body: JSON.stringify({
                cloudId: cloudId,
                productKeys: productKeys
            })
        }));
    }
    async getActivationAuthorization(request) {
        const { productKeys: productKeys, productEdition: productEdition, cloudId: cloudId, siteName: siteName } = request;
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/activation-authorization?${new URLSearchParams({
            productKeys: productKeys.join(","),
            productEdition: productEdition,
            cloudId: cloudId ?? "",
            siteName: siteName
        })}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Atl-Cohort-Id": atlCohortId,
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        }));
    }
    async getCcpHamsStatus(_getStatus) {
        return {
            service: "CCP"
        };
    }
    async getLicenceInformationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/cloud/${request.cloudId}/license-information`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        }));
    }
    async postProductActivate(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/product/activate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "web-platform": "bxp-web-platform",
                "x-b3-sampled": "1",
                "recaptcha-site-key": (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)()
            },
            credentials: "include",
            body: JSON.stringify(request)
        }));
    }
    async postCloudSignUp({ payload: payload }) {
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/cloud/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform"
            },
            body: JSON.stringify(payload),
            credentials: "include"
        }));
    }
    /**
   * For attaching a product to an existing site using COFS, xflow worked on the endpoint
   */ async postCOFSProductActivate(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const { cloudId: cloudId } = request;
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/xflow/${cloudId}/activate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "web-platform": "bxp-web-platform"
            },
            credentials: "include",
            body: JSON.stringify(request)
        }));
    }
    async user() {
        const response = await this.fetch("/bxp/signup/user", {
            headers: {
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            return Promise.resolve(result);
        }
        return Promise.resolve(undefined);
    }
    async userSignup(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/identity/user-signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "X-Atl-Cohort-Id": atlCohortId,
                "web-platform": "bxp-web-platform",
                "x-b3-sampled": "1",
                "recaptcha-site-key": (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)()
            },
            credentials: "include",
            body: JSON.stringify({
                ...request
            })
        }));
    }
    async getConsentConfig() {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/preferencesV2/consent-config`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                "xsrf-token": xsrfToken
            },
            credentials: "include"
        }));
    }
    async updateConsentPreferences(postData) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const preferencesV2Update = await this.fetch(`/preferencesV2/update`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken
            },
            credentials: "include",
            body: JSON.stringify(postData)
        });
        return preferencesV2Update.status;
    }
    async getInviteLink(postData) {
        return this.fetch(`/bxp/signup/experimental/confluence/product/onboarding/invitation_url`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform"
            },
            credentials: "include",
            body: JSON.stringify(postData)
        }).then((response)=>response.json());
    }
    async submitConfluenceOnboardingSelections(postData) {
        return this.fetch(`/bxp/signup/experimental/confluence/product/onboarding`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform"
            },
            credentials: "include",
            body: JSON.stringify(postData)
        }).then((response)=>response.json());
    }
    isSSR() {
        return typeof window === "undefined";
    }
    async getUserSegmentationRedirectAdvice(params) {
        const response = await this.fetch(`/user-seg-redirector/v1/redirect-advice?${params.userId}&${JSON.stringify(params.continue)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) return await response.json();
        else return {
            redirect: true,
            cloudId: "",
            duration: 0
        };
    }
    async postJiraProjectCreate(request) {
        const response = await this.fetch("/bxp/signup/experimental/jira/project/create", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(request)
        });
        if (response.ok) {
            const result = await response.json();
            return result;
        }
        let result;
        try {
            result = await response.json();
        } catch  {
            result = {
                error: "Body Empty"
            };
        }
        switch(response.status){
            case 400:
                if (result.error === "") throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).noProjectCreateAccess);
                if (result.error.includes("uses this project key")) throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).projectKeyCollision);
                if (result.error.includes("project with that name already exists")) throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).projectNameCollision);
                throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).badRequest);
            case 403:
                throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).noSiteAccess);
            case 500:
            default:
                throw new Error((0, $d89d37cb1202c93b$export$94ef2cab706385a3).badGateway);
        }
    }
    async postRequestAccessUserResource(params) {
        const response = await this.fetch("/bxp/signup/product/join", {
            method: "POST",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(params.cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform",
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(params.requestBody)
        });
        return response.json();
    }
    /* istanbul ignore next */ async getAccountOrgs({ cloudSessionTokenCookie: cloudSessionTokenCookie, skipNames: skipNames, getOrgType: getOrgType, includeDefaultDir: includeDefaultDir }) {
        const searchParams = new URLSearchParams({
            skipNames: skipNames ? "true" : "false",
            getOrgType: getOrgType ? "true" : "false",
            includeDefaultDir: includeDefaultDir ? "true" : "false"
        });
        const response = await this.fetch(`/bxp/signup/account/orgs?${searchParams}`, {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform",
                "x-b3-sampled": "1"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountOrgs: result
            };
        } else return {
            success: false
        };
    }
    async getAdminhubAccountOrgs({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/adminhub/organization/my3`, {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountOrgs: result
            };
        } else {
            (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching adminhub account orgs", response.status, response.statusText, response.url);
            return {
                success: false
            };
        }
    }
    async getAdminhubOrgDetails({ cloudSessionTokenCookie: cloudSessionTokenCookie, orgId: orgId }) {
        const response = await this.fetch(`/adminhub/organization/${orgId}`, {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                organization: result
            };
        } else return {
            success: false
        };
    }
    async getSignupAccountOrgDetails({ cloudSessionTokenCookie: cloudSessionTokenCookie, orgId: orgId, offeringIds: offeringIds }) {
        try {
            const response = await this.fetch(`/bxp/signup/v1/account/org?${new URLSearchParams({
                orgId: orgId,
                ...offeringIds && offeringIds.length > 0 ? {
                    offeringIds: offeringIds.join(",")
                } : {}
            })}`, {
                headers: {
                    ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                    "web-platform": "bxp-web-platform",
                    "x-b3-sampled": "1"
                },
                credentials: "include"
            });
            if (response.ok) {
                const result = await response.json();
                return {
                    success: true,
                    organization: {
                        id: orgId,
                        ...result
                    }
                };
            } else return {
                success: false
            };
        } catch (_error) {
            return {
                success: false
            };
        }
    }
    async activateDirectBuyOnOrg(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        const headers = (0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie);
        Object.assign(headers, {
            "Content-Type": "application/json",
            "xsrf-token": xsrfToken,
            "X-Atl-Cohort-Id": atlCohortId,
            "web-platform": "bxp-web-platform",
            "x-b3-sampled": "1"
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bxp/signup/activation`, {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify({
                timezone: request.timezone,
                region: request.region,
                orderId: request.orderId,
                orgId: request.orgId,
                transactionAccountId: request.transactionAccountId
            })
        }));
    }
    async getAccountProducts({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch("/bxp/signup/account/products", {
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            return {
                success: true,
                accountProducts: result
            };
        } else return {
            success: false
        };
    }
    async getActivationType({ orderId: orderId, transactionAccount: transactionAccount }) {
        const response = await this.fetch(`/bxp/signup/activation/type?orderId=${orderId}&transactionAccountId=${transactionAccount}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                "x-b3-sampled": "1"
            },
            credentials: "include"
        });
        if (response.ok) return response.json();
        else throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
            response: response
        });
    }
    /* istanbul ignore next */ async cofsCreateOrg(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bxp/signup/cofs-create-organization`, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "X-Atl-Cohort-Id": atlCohortId,
                "web-platform": request.webPlatform || "no-platform"
            },
            credentials: "include",
            body: JSON.stringify(request)
        }));
    }
    /* istanbul ignore next */ async bitbucketValidateWorkspaceSlug({ workspaceSlug: workspaceSlug }) {
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bitbucket/api/internal/workspace/slug/validate`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                workspace_slug: workspaceSlug
            })
        }));
    }
    async getCloudProductInfo(request) {
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bxp/signup/v1/cloud/${request.cloudId}/product-information`, {
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include"
        }));
    }
    async activateDirectBuyProduct(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await fetch(`${this.baseUrl}/bxp/signup/v1/order/${request.orderId}/activation`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xsrf-token": xsrfToken,
                "X-Transaction-Account": request.transactionAccountId,
                "web-platform": request.webPlatform || "no-platform",
                "x-b3-sampled": "1"
            },
            credentials: "include",
            body: JSON.stringify({
                timezone: request.timezone,
                region: request.region,
                site: request.site,
                ...request.orgId ? {
                    orgId: request.orgId
                } : {}
            })
        }));
    }
    async putThemePreference({ cloudId: cloudId, product: product, theme: theme }) {
        const updateThemePreference = await this.fetch(`/ex/jira/${cloudId}/rest/api/3/mypreferences?key=${product}.user.theme.preference`, {
            method: "PUT",
            headers: {
                "web-platform": "bxp-web-platform",
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                value: theme
            })
        });
        if (!updateThemePreference.ok) throw new Error(`Failed to update theme preference: ${updateThemePreference.statusText}`);
        return true;
    }
    async sampleProjectCreate({ cloudId: cloudId, template: template, teamType: teamType, issueTypes: issueTypes, statusNames: statusNames, projectName: projectName, projectKey: projectKey, customDetail: customDetail }) {
        const MAX_RETRIES = 5;
        const BACKOFF_DELAY = 1000; // Start with 1-second delay
        const postRequest = async ()=>{
            const createProjectResponse = await this.fetch(`/ex/jira/${cloudId}/rest/onboarding/v1/projects`, {
                method: "POST",
                headers: {
                    "web-platform": "bxp-web-platform",
                    "Content-Type": "application/json"
                },
                credentials: "include",
                body: JSON.stringify({
                    issueTypes: issueTypes,
                    statusNames: statusNames,
                    projectName: projectName,
                    projectKey: projectKey,
                    template: template,
                    teamType: teamType,
                    customDetail: customDetail
                })
            });
            if (!createProjectResponse.ok) throw new Error(`Failed to create project: ${createProjectResponse.statusText}`);
            const { taskId: taskId } = await createProjectResponse.json();
            const taskResponse = await this.pollTaskUntilComplete(taskId, cloudId);
            return {
                projectId: taskResponse.result.projectId || ""
            };
        };
        let retryCount = 0;
        while(retryCount < MAX_RETRIES)try {
            return await postRequest();
        } catch (error) {
            // task failures should not attempt a project creation again
            if (error instanceof (0, $d89d37cb1202c93b$export$4640a7cbf45425fa)) {
                console.error(`Task failed with status: ${error.status}, message: ${error.taskMessage}`);
                throw error;
            }
            retryCount++;
            if (retryCount >= MAX_RETRIES) {
                console.error(`Max retries reached. Unable to create the project.`);
                throw new Error(`Failed to create project after ${MAX_RETRIES} attempts.`);
            }
            // Exponential backoff
            const delay = BACKOFF_DELAY * Math.pow(2, retryCount - 1);
            console.warn(`Retrying sample project creation (attempt ${retryCount} of ${MAX_RETRIES}) in ${delay}ms...`);
            // Wait before retrying
            await this.delay(delay);
        }
        // This should never be reached because the loop either succeeds or throws
        throw new Error("Unexpected error in project creation.");
    }
    // Utility function to delay for a specified number of milliseconds
    async delay(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    }
    async wizardProjectCreate(payload) {
        const createProjectResponse = await this.fetch(`/ex/jira/${payload.cloudId}/rest/onboarding/v1/projects`, {
            method: "POST",
            headers: {
                "web-platform": "bxp-web-platform",
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                issueTypes: payload.issueTypes,
                statusNames: payload.statusNames,
                projectName: payload.projectName,
                projectKey: payload.projectKey,
                template: payload.template,
                teamType: payload.teamType,
                customDetail: payload.customDetail,
                sampleIssues: payload.sampleIssues,
                selectedAgentTools: payload.selectedAgentTools
            })
        });
        if (!createProjectResponse.ok) {
            const errorMessage = await (0, $783e9a753ed8da98$export$82f46aa4e6535a45)(createProjectResponse);
            throw new Error(`Failed to create project: ${createProjectResponse.statusText}, ${createProjectResponse.status}, ${errorMessage}`);
        }
        const { taskId: taskId } = await createProjectResponse.json();
        return {
            taskId: taskId
        };
    }
    async postProjectCreate(payload) {
        const createProjectResponse = await this.fetch(`/ex/jira/${payload.cloudId}/rest/onboarding/v1/projects`, {
            method: "POST",
            headers: {
                "web-platform": "bxp-web-platform",
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify({
                issueTypes: payload.issueTypes,
                statusNames: payload.statusNames,
                projectName: payload.projectName,
                projectKey: payload.projectKey,
                template: payload.template,
                teamType: payload.teamType,
                customDetail: payload.customDetail,
                sampleIssues: payload.sampleIssues
            })
        });
        if (!createProjectResponse.ok) throw new (0, $72e2dd731bbce2cc$export$e8889cc9a6240378)(createProjectResponse);
        const { taskId: taskId } = await createProjectResponse.json();
        return {
            taskId: taskId
        };
    }
    async putUserProperty({ tenantId: tenantId, propertyKey: propertyKey, data: data }) {
        const accountId = (0, $c3163505721bf9af$export$2e2bcd8739ae039).get("__aid_user_id");
        const response = await this.fetch(`/ex/jira/${tenantId}/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(data)
        });
        if (!response.ok) throw new Error(`Failed to create project: ${response.statusText}`);
        return response.ok;
    }
    async putSampleProjectUserProperties({ projectId: projectId, tenantId: tenantId }) {
        const propertyKey = `jira.onboarding.view.sample.project.cta.tenant.${tenantId}`;
        return this.putUserProperty({
            tenantId: tenantId,
            propertyKey: propertyKey,
            data: {
                status: "ENABLED",
                timestamp: Date.now(),
                projectIds: [
                    projectId
                ]
            }
        });
    }
    async pollTaskUntilComplete(taskId, cloudId, TIMEOUT = (0, $d89d37cb1202c93b$export$889bc7d00388a53)) {
        const abortController = new AbortController();
        const timeoutId = setTimeout(()=>abortController.abort(), TIMEOUT);
        const pollTask = async ()=>{
            try {
                const response = await this.fetchTask(taskId, cloudId);
                switch(response.status){
                    case "CANCEL_REQUESTED":
                    case "CANCELLED":
                    case "DEAD":
                    case "FAILED":
                        throw new (0, $d89d37cb1202c93b$export$4640a7cbf45425fa)("Task failed", {
                            id: taskId,
                            status: response.status,
                            taskMessage: response.message
                        });
                    case "ENQUEUED":
                    case "RUNNING":
                        await new Promise((resolve)=>setTimeout(resolve, 1000));
                        return pollTask();
                    case "COMPLETE":
                        clearTimeout(timeoutId);
                        return response;
                    default:
                        throw new (0, $d89d37cb1202c93b$export$4640a7cbf45425fa)("Unknown task status", {
                            id: taskId,
                            status: response.status,
                            taskMessage: response.message
                        });
                }
            } catch (error) {
                if (abortController.signal.aborted) throw new Error("Task polling timed out");
                throw error;
            }
        };
        return pollTask();
    }
    async fetchTask(taskId, cloudId) {
        return this.fetch(`/ex/jira/${cloudId}/rest/api/3/task/${taskId}`, {
            method: "GET",
            credentials: "include"
        }).then((response)=>response.json());
    }
    async fetchProjectRoles(cloudId, projectId) {
        return this.fetch(`/ex/jira/${cloudId}/rest/api/3/project/${projectId}/role`, {
            method: "GET",
            credentials: "include"
        }).then((response)=>response.json());
    }
    /* istanbul ignore next */ async asyncNewSiteActivation(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const atlCohortId = (0, $1a668ca05d5fb4c0$export$a284fd3cd35fac52)();
        const headers = {
            "Content-Type": "application/json",
            "xsrf-token": xsrfToken,
            "X-Atl-Cohort-Id": atlCohortId,
            "web-platform": "bxp-web-platform",
            "recaptcha-site-key": (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)()
        };
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/v1/activation-orchestration/new-site`, {
            method: "POST",
            credentials: "include",
            body: JSON.stringify(request),
            headers: headers
        }));
    }
    /* istanbul ignore next */ async asyncActivationStatus(request) {
        const xsrfToken = await this.getSignupServerXsrfToken();
        const headers = {
            "Content-Type": "application/json",
            "xsrf-token": xsrfToken,
            "web-platform": "bxp-web-platform"
        };
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(await this.fetch(`/bxp/signup/v1/activation-orchestration/status?workflowId=${request.workflowId}`, {
            method: "GET",
            credentials: "include",
            headers: headers
        }));
    }
    async getOrgServers({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/migrations/metadata/v1/org/${orgId}/server`, {
            method: "GET",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (response.ok) {
            const result = await response.json();
            if (result.data === undefined) return Promise.resolve({
                data: []
            });
            return Promise.resolve({
                data: result.data
            });
        } else {
            (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching org servers", response.status, response.statusText, response.url);
            throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
                message: "Error fetching org servers",
                response: response
            });
        }
    }
    async getL1Assessments({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/mcc/v2/orgs/${orgId}/l1-assessments/`, {
            method: "GET",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching l1 assessments", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getMigrationPlanTotals({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/migrations/planning/v1/org/${orgId}/totals/scope`, {
            method: "GET",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching migration plan totals", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getAvailableSitesForFastshift({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/app-switcher/api/available-products?product=WAC`, {
            method: "GET",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform"
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching available products", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getCspGraphqlRequest({ request: request, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/customer-support/csp/graphql`, {
            method: "POST",
            headers: {
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
                "web-platform": "bxp-web-platform",
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: request
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getInstances({ orgId: orgId, cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const response = await this.fetch(`/mcc/v1/orgs/${orgId}/discover/instances`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching MMA instances", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftUser(request) {
        const response = await this.fetch(`/fastshift-portal/v1/user`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) {
            if (response.status === 404) throw new Error((0, $d89d37cb1202c93b$export$2c57f6d935fc3dec).NO_ELIGIBLE_LICENSE);
            else if (response.status === 401) throw new Error((0, $d89d37cb1202c93b$export$2c57f6d935fc3dec).NO_ACCESS);
            else (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching user details", response.status, response.statusText, response.url);
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftUserAccess(request) {
        const response = await this.fetch(`/fastshift-portal/v1/user/access`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching user access", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftCustomerDomains(request) {
        const params = new URLSearchParams({
            page: request.page.toString(),
            size: request.size.toString()
        });
        if (request.sortBy) params.append("sortBy", request.sortBy);
        if (request.sortDirection) params.append("sortDirection", String(request.sortDirection));
        if (request.searchTerm) params.append("queryTerm", request.searchTerm);
        if (request.filters["status"]) params.append("status", request.filters["status"]);
        const response = await this.fetch(`/fastshift-portal/v1/user/domains?${params.toString()}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching customer domains list", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getUserBillingAdminTransactionAccounts({ cloudSessionTokenCookie: cloudSessionTokenCookie }) {
        const headers = {
            ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(cloudSessionTokenCookie),
            "web-platform": "bxp-web-platform"
        };
        const response = await this.fetch("/ccp/api/v1/transaction-accounts", {
            method: "GET",
            headers: headers,
            credentials: "include"
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftCustomerDomainEngagement(request) {
        const response = await this.fetch(`/fastshift-portal/v1/engagement/${request.customerDomainId}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) {
            if (response.status === 401) throw new Error((0, $d89d37cb1202c93b$export$14701d34cfd76bf).NO_ACCESS);
            else if (response.status === 403) throw new Error((0, $d89d37cb1202c93b$export$14701d34cfd76bf).USER_NOT_PROVISIONED);
            else if (response.status === 404) throw new Error((0, $d89d37cb1202c93b$export$14701d34cfd76bf).NO_ENGAGEMENT);
            else (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching customer domain engagement details", response.status, response.statusText, response.url);
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftCustomerDomain(request) {
        const response = await this.fetch(`/fastshift-portal/v1/user/domain/${request.customerDomainId}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) {
            if (response.status === 401) throw new Error((0, $d89d37cb1202c93b$export$7428175ef648f8bd).NO_ACCESS);
            else if (response.status === 404) throw new Error((0, $d89d37cb1202c93b$export$7428175ef648f8bd).NOT_FOUND);
            else (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching customer domain details", response.status, response.statusText, response.url);
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftSupportRequests(request) {
        const queryString = new URLSearchParams(request.queryParams).toString();
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.customerDomainId}${queryString ? `?${queryString}` : ""}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching support requests", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftTopSupportRequests(request) {
        const queryString = new URLSearchParams(request.queryParams).toString();
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.domainId}/top${queryString ? `?${queryString}` : ""}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching top support requests", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    // fetch whether the user has consented already
    async fetchFastshiftPortalConsentRequest(request) {
        const response = await this.fetch("/fastshift-portal/v1/consent/portal/fetch", {
            method: "POST",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie),
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(request.requestBody)
        });
        if (!response.ok) {
            (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching fastshift portal consent status", response.status, response.statusText, response.url);
            throw new Error("Error on fetching fastshift portal consent status");
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    // record the user's consent
    async sendFastshiftPortalConsent(request) {
        const response = await this.fetch("/fastshift-portal/v1/consent/portal", {
            method: "POST",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie),
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(request.requestBody)
        });
        if (!response.ok) {
            (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on sending fastshift portal consent acceptance", response.status, response.statusText, response.url);
            throw new Error("Error on sending fastshift portal consent acceptance");
        }
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftRunbooksBySupportTicketId(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching runbooks by support ticket id", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getFastshiftRunbook(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}`, {
            method: "GET",
            headers: {
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include"
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on fetching runbook", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async updateFastshiftRunbookStepStatus(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/status`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include",
            body: JSON.stringify({
                status: request.status,
                ...request.note ? {
                    note: request.note
                } : {},
                title: request.title,
                phase: request.phase,
                responsible: request.responsible
            })
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on updating runbook step status", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async updateFastshiftRunbookStepRisk(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/risk`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include",
            body: JSON.stringify({
                risk: request.risk
            })
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on updating runbook step risk", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async updateFastshiftRunbookStepDisabled(request) {
        const response = await this.fetch(`/fastshift-portal/v1/support-tickets/${request.supportTicketId}/runbooks/${request.runbookId}/steps/${request.stepId}/disabled`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "web-platform": "bxp-web-platform",
                ...(0, $6e969e08c9befeb1$export$2caf3886cd1c5ca7)(request.cloudSessionTokenCookie)
            },
            credentials: "include",
            body: JSON.stringify({
                disabled: request.disabled
            })
        });
        if (!response.ok) (0, $5d4926bb7a571eba$export$cdfb2f8bf93ec458)("Error on updating runbook step disabled state", response.status, response.statusText, response.url);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async activateProductCrossflowPlan(request) {
        const provisioningApiUrl = `/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/plan`;
        const response = await this.fetch(provisioningApiUrl, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request.context)
        });
        const data = await (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
        return data;
    }
    async activateProductCrossflow(request) {
        const provisioningApiUrl = `/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/start`;
        const response = await this.fetch(provisioningApiUrl, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request.context)
        });
        const data = await (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
        if (!data.started) throw new Error("Provisioning failed");
        return data;
    }
    async waitForActivateProductCrossflow(request) {
        const response = await this.fetch(`/xflow/provision/cloud/${request.cloudId}/product/${request.productKey}/job/${request.jobName}/status`, {
            method: "GET",
            credentials: "include"
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async postMadlibContentGeneration(cloudId, request) {
        const headers = {
            "web-platform": "bxp-web-platform",
            "Content-Type": "application/json",
            "X-Atlassian-CloudId": cloudId
        };
        const response = await this.fetch("/gcg/api/v1/generate/team_growth/jira_onboarding_madlibs_sample_issues", {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new (0, $72e2dd731bbce2cc$export$ef953687cf93d9ab)(response);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async postContentGenerationForJiraFfl(request) {
        const headers = {
            "web-platform": "bxp-web-platform",
            "Content-Type": "application/json",
            // Keep parity with activate-product calls which include recaptcha key as a header.
            "recaptcha-site-key": (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)()
        };
        const response = await this.fetch("/gcg/api/v1/generate/team_growth/jira_ffl_sample_issues", {
            method: "POST",
            headers: headers,
            credentials: "include",
            body: JSON.stringify(request)
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async getJiraFFLContentByCgsKey(cgsKey) {
        const headers = {
            "web-platform": "bxp-web-platform",
            "Content-Type": "application/json"
        };
        const response = await this.fetch(`/gcg/api/v1/generate/team_growth/jira_ffl_sample_issues/cache/${cgsKey}`, {
            method: "GET",
            headers: headers,
            credentials: "include"
        });
        if (!response.ok) throw new (0, $72e2dd731bbce2cc$export$ef953687cf93d9ab)(response);
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
    async postEmailInvite(cloudId, projectId, request) {
        const response = await this.fetch(`/ex/jira/${cloudId}/rest/internal/latest/invite-user/request-access/project/${projectId}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            credentials: "include",
            body: JSON.stringify(request)
        });
        if (!response.ok) throw new (0, $72e2dd731bbce2cc$export$da6dec65957b7041)({
            message: "Invite was unsuccessful",
            response: response
        });
        return (0, $783e9a753ed8da98$export$a1968f52311c9c2e)(response);
    }
}
const $cd2194d8d3feda9a$export$98ec7f86e3388cfc = ()=>{
    if (typeof window !== "undefined") return window.location.hostname.includes("fastshift") ? (0, $5d4926bb7a571eba$export$bc91eef109fd258b) : $cd2194d8d3feda9a$var$BASE_URL;
    // Add safety check for globalThis.location
    if (globalThis.location) return globalThis.location.hostname.includes("fastshift") ? (0, $5d4926bb7a571eba$export$bc91eef109fd258b) : $cd2194d8d3feda9a$var$BASE_URL;
    // Fallback if globalThis.location is not available
    return $cd2194d8d3feda9a$var$BASE_URL;
};
const $cd2194d8d3feda9a$var$BxpWebStargateClientContext = /*#__PURE__*/ (0, $iSvIT.createContext)(new $cd2194d8d3feda9a$export$963f114b487aad6d({
    baseUrl: $cd2194d8d3feda9a$export$98ec7f86e3388cfc()
}));
function $cd2194d8d3feda9a$export$ac42303986bb641e() {
    return (0, $iSvIT.useContext)($cd2194d8d3feda9a$var$BxpWebStargateClientContext);
}
const $cd2194d8d3feda9a$export$dc976c529d501f0c = (props)=>{
    const { children: children } = props;
    if ($cd2194d8d3feda9a$var$isBaseUrlStargateClientProviderProps(props)) return /*#__PURE__*/ (0, $loA2J.jsx)($cd2194d8d3feda9a$var$BxpWebStargateClientContext.Provider, {
        value: new $cd2194d8d3feda9a$export$963f114b487aad6d({
            baseUrl: props.baseUrl
        }),
        children: children
    });
    else return /*#__PURE__*/ (0, $loA2J.jsx)($cd2194d8d3feda9a$var$BxpWebStargateClientContext.Provider, {
        value: props.client,
        children: children
    });
};
function $cd2194d8d3feda9a$var$isBaseUrlStargateClientProviderProps(props) {
    return !!props?.baseUrl;
}



const $784ebd6898abdb6b$var$DEFAULT_USER_STATE = {
    isUserLoggedIn: false,
    requestInProgress: true
};
const $784ebd6898abdb6b$var$LoggedInUserContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    ...$784ebd6898abdb6b$var$DEFAULT_USER_STATE
});
const $784ebd6898abdb6b$export$aae23f3a65fbe750 = ()=>{
    const context = (0, $iSvIT.useContext)($784ebd6898abdb6b$var$LoggedInUserContext);
    if (!context) throw new Error("calls to useLoggedInUser must be wrapped in <LoggedInUserProvider>");
    return context;
};
const $784ebd6898abdb6b$export$164e91ee1eedc9fa = ({ children: children })=>{
    const stargateClient = (0, $cd2194d8d3feda9a$export$ac42303986bb641e)();
    const [loggedInUserInstance, setLoggedInUserInstance] = (0, $iSvIT.useState)({
        ...$784ebd6898abdb6b$var$DEFAULT_USER_STATE
    });
    (0, $iSvIT.useEffect)(()=>{
        (0, $iSvIT.startTransition)(()=>{
            // Check for login_user_detected cookie first (set during SSR).
            // As fallback, check for cloud.session.token directly (handles static fallback case).
            const loginUserDetectedCookie = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("login_user_detected") === "true";
            const cloudSessionToken = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("cloud.session.token") || (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("cloud.session.token.stg");
            const isUserLoggedIn = loginUserDetectedCookie || cloudSessionToken !== null;
            if (!isUserLoggedIn) {
                // If logged in user cookie isn't present, then we don't need to make a call to stargate.
                // This cookie is set by bxp-gateway to determine if the user is logged in or not.
                setLoggedInUserInstance({
                    ...$784ebd6898abdb6b$var$DEFAULT_USER_STATE,
                    requestInProgress: false
                });
                return;
            }
            const getUserProfile = async ()=>{
                return await stargateClient.me({});
            };
            getUserProfile().then((userProfile)=>{
                setLoggedInUserInstance({
                    requestInProgress: false,
                    isUserLoggedIn: true,
                    ...userProfile
                });
            }).catch((e)=>{
                console.warn("Error getting user profile: ", e);
                setLoggedInUserInstance({
                    ...$784ebd6898abdb6b$var$DEFAULT_USER_STATE,
                    requestInProgress: false
                });
            });
        });
    }, [
        stargateClient
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($784ebd6898abdb6b$var$LoggedInUserContext.Provider, {
        value: loggedInUserInstance,
        children: children
    });
};
const $784ebd6898abdb6b$export$baab3d3c6c1ba19c = ({ children: children, loggedInUser: loggedInUser })=>/*#__PURE__*/ (0, $loA2J.jsx)($784ebd6898abdb6b$var$LoggedInUserContext.Provider, {
        value: loggedInUser,
        children: children
    });



/* custom-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $4de1580172ce767e$var$styles = {
    container: "_1e0c1o8l _1o9zidpf",
    svg: "_p12f1osq _c71l1osq _s7n4yfq0 _lcxvglyw"
};
const $4de1580172ce767e$var$ITSupportGlyph = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 31 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0.53125 6.25V32.125L8.025 25.7H30.5187V6.25H0.53125Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.8496 7.01855C13.8496 5.1623 15.3309 3.6748 17.1621 3.6748C18.9934 3.6748 20.4746 5.15605 20.4746 7.01855C20.4746 7.9623 20.2496 8.39355 20.0434 8.66855C19.7996 8.9873 19.4934 9.2123 18.9559 9.60605C18.8684 9.6748 18.7684 9.74355 18.6621 9.81855C17.9934 10.3123 17.1434 10.9873 16.5059 12.1061C15.8621 13.2311 15.5059 14.6436 15.5059 16.5123H18.8184C18.8184 15.0623 19.0871 14.2561 19.3746 13.7623C19.6621 13.2561 20.0559 12.9123 20.6309 12.4873C20.6996 12.4373 20.7746 12.3811 20.8559 12.3248C21.3746 11.9498 22.1121 11.4186 22.6684 10.6873C23.3871 9.7498 23.7871 8.5748 23.7871 7.01855C23.7871 3.35605 20.8496 0.362305 17.1621 0.362305C13.4746 0.362305 10.5371 3.35605 10.5371 7.01855V8.67481H13.8496V7.01855Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.1625 19.0063C16.0188 19.0063 15.0938 19.9313 15.0938 21.0751C15.0938 22.2188 16.0188 23.1438 17.1625 23.1438C18.3063 23.1438 19.2313 22.2188 19.2313 21.0751C19.2313 19.9313 18.3063 19.0063 17.1625 19.0063Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.575 6.25H13.9375C13.875 6.49375 13.8437 6.75625 13.8437 7.01875V8.675H10.5312V7.01875C10.5312 6.7625 10.5437 6.50625 10.575 6.25Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.2312 21.0749C19.2312 22.2186 18.3062 23.1499 17.1624 23.1499C16.0187 23.1499 15.0874 22.2186 15.0874 21.0749C15.0874 19.9311 16.0187 19.0061 17.1624 19.0061C18.3062 19.0061 19.2312 19.9311 19.2312 21.0749Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M23.7871 7.01875C23.7871 8.58125 23.3871 9.75 22.6684 10.6875C22.1121 11.4187 21.3746 11.95 20.8559 12.325C20.7746 12.3875 20.6996 12.4375 20.6309 12.4875C20.0559 12.9187 19.6621 13.2625 19.3746 13.7687C19.0871 14.2687 18.8184 15.075 18.8184 16.5188H15.5059C15.5059 14.65 15.8559 13.2375 16.4996 12.1187C17.1434 11 17.9934 10.325 18.6559 9.825C18.7621 9.75 18.8621 9.68125 18.9496 9.6125C19.4934 9.2125 19.7934 8.99375 20.0371 8.675C20.2496 8.39375 20.4746 7.9625 20.4746 7.01875C20.4746 6.75625 20.4434 6.49375 20.3809 6.25H23.7434C23.7746 6.50625 23.7871 6.7625 23.7871 7.01875Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$var$DesignGlyph = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.6437 19.644C27.7437 19.0877 27.7938 18.4877 27.7938 17.8627C27.7938 17.2377 27.7438 16.6252 27.6375 16.0565C27.0313 12.6877 24.6938 10.6127 21.4062 10.0752C20.8438 9.98149 20.2563 9.93774 19.65 9.93774C19.0438 9.93774 18.4 9.98775 17.8188 10.0877C14.5375 10.6377 12.2 12.7065 11.5938 16.0565C11.4938 16.6252 11.4375 17.2252 11.4375 17.8627C11.4375 18.5002 11.4875 19.0877 11.5875 19.644C12.1875 22.9877 14.525 25.0627 17.8188 25.6127C18.4 25.7127 19.0125 25.7627 19.65 25.7627C20.2875 25.7627 20.85 25.719 21.4062 25.6252C24.6938 25.0877 27.0375 23.0127 27.6375 19.644H27.6437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M0.556152 16.9752L10.3062 0.262695L20.0562 16.9752H0.556152Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.2687 10.4875C13.8062 11.35 12.0937 13.2563 11.5937 16.0563C11.5375 16.3563 11.5 16.6563 11.4688 16.975H20.05L16.2687 10.4875Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.3748 19.3252H20.6748V33.0252H34.3748V19.3252Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.6748 19.3311V25.7186C20.9248 25.6936 21.1686 25.6623 21.4123 25.6248C24.6998 25.0936 27.0373 23.0123 27.6436 19.6436C27.6623 19.5436 27.6811 19.4373 27.6936 19.3311H20.6748Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$var$SoftwareDevelopmentGlyph = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "31",
        viewBox: "0 0 35 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.9626 0.581299H0.0375977V23.45H34.9626V0.581299Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.8816 26.5812V30.4687H8.11914V26.5812H14.3691V19.6062H20.6316V26.5812H26.8816Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.6316 19.6062H14.3691V23.4562H20.6316V19.6062Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.4997 17.4438C20.4959 17.4438 22.9247 15.0149 22.9247 12.0188C22.9247 9.02261 20.4959 6.59375 17.4997 6.59375C14.5036 6.59375 12.0747 9.02261 12.0747 12.0188C12.0747 15.0149 14.5036 17.4438 17.4997 17.4438Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$a8475ed0ad467766 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "28",
        viewBox: "0 0 29 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.5936 0.362549L14.9561 5.8188V20.3688L28.5936 25.825V0.362549Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.45 6.72485V19.4374H11.3187V27.6374H5.8625V19.4374H0.40625V6.72485H18.45Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.4498 6.72485H14.9561V19.4311H18.4498V6.72485Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$7a5074cf88127a64 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "37",
        viewBox: "0 0 42 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.3371 0.553483L22.3053 0.585025L24.7811 7.28206L31.8316 6.13992L35.7841 13.0563L31.2273 18.5555L35.7405 24.082L31.7333 30.9669L24.7007 29.769L22.1719 36.4462L14.2037 36.4147L11.7278 29.7176L4.68588 30.8598L0.733372 23.9434L5.29013 18.4528L0.776983 12.9263L4.78412 6.04139L11.8253 7.23932L14.3541 0.562091L14.3371 0.553483ZM18.2193 25.2168C21.9344 25.2315 24.9525 22.2372 24.9672 18.5221C24.9819 14.8071 21.9876 11.7889 18.2726 11.7742C14.5575 11.7595 11.5394 14.7539 11.5247 18.4689C11.5099 22.184 14.5043 25.2021 18.2193 25.2168Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.2269 18.547L35.7836 13.0564L31.8311 6.13999L24.7807 7.28213L22.3048 0.593637L14.3366 0.562095L11.7993 7.23075L4.76661 6.03286L0.759472 12.9177L5.27262 18.4442L0.715827 23.9434L4.66834 30.8598L11.7103 29.7091L14.1947 36.4061L22.1629 36.4377L24.6917 29.7605L28.5665 30.4249L31.7329 30.9669L35.74 24.082L33.9382 21.8714L31.2269 18.547ZM18.2189 25.2169C14.5123 25.2022 11.5095 22.1841 11.5242 18.469C11.5389 14.7539 14.5656 11.7596 18.2721 11.7743C21.9786 11.789 24.9814 14.8157 24.9668 18.5222C24.9521 22.2287 21.9339 25.2316 18.2189 25.2169Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M41.3728 26.2112C41.4574 25.7407 41.4997 25.2333 41.4997 24.7047C41.4997 24.1761 41.4574 23.6581 41.3675 23.1771C40.8548 20.328 38.8779 18.5731 36.0975 18.1185C35.6218 18.0392 35.1249 18.0022 34.6122 18.0022C34.0994 18.0022 33.555 18.0445 33.0634 18.1291C30.2883 18.5942 28.3114 20.3438 27.7987 23.1771C27.7141 23.6581 27.6665 24.1655 27.6665 24.7047C27.6665 25.2439 27.7088 25.7407 27.7934 26.2112C28.3008 29.0391 30.2777 30.794 33.0634 31.2592C33.555 31.3438 34.073 31.386 34.6122 31.386C35.1513 31.386 35.627 31.349 36.0975 31.2698C38.8779 30.8152 40.8601 29.0603 41.3675 26.2112H41.3728Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31.4713 18.4998L35.7119 23.6925L35.9706 24.0099L31.9635 30.8948L31.9371 30.8903L31.7897 30.865C29.6821 30.132 28.2195 28.5139 27.7934 26.1389C27.7088 25.6685 27.6665 25.1716 27.6665 24.6325C27.6665 24.0933 27.7141 23.5859 27.7987 23.1048C28.2069 20.8492 29.5431 19.2804 31.4713 18.4998Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.225 22.6846L33.5824 28.0872L30.667 25.2185L31.9257 24.0494L33.6039 25.6975L37.9878 21.5L39.2304 22.6897L39.225 22.6846Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$5a330511b92aac24 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "38",
        viewBox: "0 0 43 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.3876 3.30908C8.50444 3.30908 0.5 11.3214 0.5 21.1967C0.5 28.6407 5.0469 35.0269 11.5199 37.7187V33.4007C11.5199 29.6038 14.5986 26.533 18.3876 26.533C22.1767 26.533 25.2475 29.6116 25.2475 33.4007V37.7187C31.7205 35.0348 36.2753 28.6486 36.2753 21.1967C36.2753 11.3135 28.2629 3.30908 18.3876 3.30908ZM18.3876 24.599C15.1353 24.599 12.4988 21.9624 12.4988 18.7101C12.4988 15.4578 15.1274 12.8213 18.3876 12.8213C21.6478 12.8213 24.2686 15.4499 24.2686 18.7101C24.2686 21.9703 21.6399 24.599 18.3876 24.599Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.447 6.64839L23.1318 9.80597L29.447 12.9635L32.6045 19.2787L35.7621 12.9635L42.0773 9.80597L35.7621 6.64839L32.6045 0.333252L29.447 6.64839Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.9811 14.5266L32.605 19.2787L29.4475 12.9636L23.1323 9.80601L29.0607 6.83789C31.6814 8.79558 33.7497 11.4479 34.9811 14.5266Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.0607 6.83789L23.1323 9.80601L29.4475 12.9636L32.605 19.2787L34.9811 14.5266C33.7497 11.4479 31.6814 8.79558 29.0607 6.83789Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$2a1d70df8da1fa8a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "34",
        viewBox: "0 0 26 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.6161 33.4709H0V0H12.9505L25.6161 12.4757V33.4709Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M12.9453 0V12.4388H25.5793L12.9453 0Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.0179 16.543H12.9492V20.0773H20.0179V16.543Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.2369 20.6681C9.53918 20.6681 10.5949 19.6124 10.5949 18.3101C10.5949 17.0079 9.53918 15.9521 8.2369 15.9521C6.93462 15.9521 5.87891 17.0079 5.87891 18.3101C5.87891 19.6124 6.93462 20.6681 8.2369 20.6681Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.0179 25.458H12.9492V28.9924H20.0179V25.458Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M8.2369 29.5832C9.53918 29.5832 10.5949 28.5275 10.5949 27.2252C10.5949 25.9229 9.53918 24.8672 8.2369 24.8672C6.93462 24.8672 5.87891 25.9229 5.87891 27.2252C5.87891 28.5275 6.93462 29.5832 8.2369 29.5832Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$c3c91f9d6f32ce98 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "46",
        height: "28",
        viewBox: "0 0 46 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M45.5573 10.3687H11.3848V27.0656H45.5573V10.3687Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.9362 0H0.763672V16.6969H34.9362V0Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.9358 10.3687H11.3848V16.6966H34.9358V10.3687Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M14.2535 5.66825L6.8942 13.0275L3.0918 9.11988L4.73342 7.52736L6.92226 9.77232L12.6399 4.05469L14.2605 5.67527L14.2535 5.66825Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M43.4312 16.4021L36.0719 23.7614L32.2695 19.8538L33.9112 18.2612L36.1 20.5062L41.8176 14.7886L43.4382 16.4092L43.4312 16.4021Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$a9941a16640f105a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "30",
        viewBox: "0 0 36 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M35.9463 18.2911V14.6985C35.9463 13.7694 35.1039 13.0137 34.057 13.0137H12.8853C11.8385 13.0137 10.9961 13.7632 10.9961 14.6985V18.2911H35.9463Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M35.9463 20.6449H10.9961V28.0408C10.9961 28.9637 11.8385 29.7256 12.8853 29.7256H34.057C35.1039 29.7256 35.9463 28.9699 35.9463 28.0408V20.6449Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.7685 5.27746V1.68482C25.7685 0.75569 24.9261 0 23.8793 0H2.70759C1.66077 0 0.818359 0.749496 0.818359 1.68482V5.27746H25.7685Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.7685 7.63125H0.818359V15.0271C0.818359 15.95 1.66077 16.7119 2.70759 16.7119H23.8793C24.9261 16.7119 25.7685 15.9562 25.7685 15.0271V7.63125Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.7692 13.0078V15.0209C25.7692 15.9501 24.9268 16.7119 23.88 16.7119H10.9961V14.6988C10.9961 13.7635 11.8447 13.0078 12.8853 13.0078H25.7692Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$b81d861c2dc0475e = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "33",
        viewBox: "0 0 27 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27 5.5H0V32.9999H27V5.5Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7 27.844C7 25.6275 9.9081 23.833 13.5 23.833C17.0919 23.833 20 25.6275 20 27.844V32.9996H7V27.844Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18 17.875C18 20.1498 15.988 22 13.5 22C11.012 22 9 20.1556 9 17.875C9 15.5943 11.012 13.75 13.5 13.75C15.988 13.75 18 15.5943 18 17.875Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23 3.25947V10.0833H4V3.25947H9.58471C9.58471 1.45789 11.3374 0 13.5033 0C15.6692 0 17.4153 1.45789 17.4153 3.25947H23Z",
                fill: "#0C66E4"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23 5.5H4V10.0833H23V5.5Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$f2de52c1920eba82 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 275 275",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M53.72 68.75L43.27 229.76H223.49L229.02 68.75H53.72Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.3799 203.36L31.5199 186.23H200.17L207.6 203.36H31.3799Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.5199 186.23L31.3799 203.36H44.9899L46.0999 186.23H31.5199Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M194.57 146.02L243.17 50.7L229.24 43.79L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M129.43 164.74C130.22 166.72 130.29 169.1 130.74 171.52L130.83 172.09C130.91 172.46 130.99 173 131.3 173.68C131.47 174.02 131.68 174.4 132.05 174.74C132.4 175.1 132.92 175.34 133.43 175.48C134.49 175.69 135.48 175.49 136.46 175.17C138.52 174.44 139.95 172.74 141.15 171.38C142.35 169.98 143.45 168.84 144.42 168.25C145.7 167.65 147.21 167.65 148.67 167.89C150.14 168.13 151.6 168.6 153.11 169.01C156.15 169.83 159.36 170.14 162.52 169.85C162.52 169.85 164.5 169.62 166.67 169C168.85 168.41 171.22 167.53 172.28 167.03C173.6 166.39 174.42 165.87 174.55 165.58C174.68 165.28 174.08 165.22 172.56 165.52C171.04 165.8 168.64 166.57 165.14 167.41C165.05 167.4 164.76 167.43 164.72 167.39C161.04 168.32 157.29 168.13 153.72 167.12C151.91 166.62 150.01 165.89 147.75 165.7C146.63 165.61 145.42 165.68 144.21 166.1C142.99 166.52 141.99 167.26 141.17 168.01C141.36 168.04 141.2 168.32 140.97 168.45L140.91 168.25C139.92 169.33 139.16 170.28 138.4 171.05C137.65 171.82 136.92 172.41 136.2 172.76C135.56 173.08 134.52 173.33 134.01 173.27C133.74 173.24 133.63 173.22 133.43 173.06C133.23 172.89 133 172.51 132.8 172.03C132.8 172.05 133.16 172.41 133.16 172.4C132.9 171.66 132.79 170.63 132.69 169.58C132.59 168.51 132.5 167.37 132.31 166.17C132.1 164.97 131.8 163.69 131.1 162.45C130.44 161.2 129.23 160.1 127.89 159.53L126.89 159.18L126.39 159.01L125.86 158.92L124.79 158.77L123.71 158.8C123.53 158.8 123.35 158.81 123.17 158.83L122.65 158.93C122.3 159 121.95 159.07 121.61 159.15C120.97 159.4 120.27 159.58 119.69 159.91C117.24 161.11 115.2 162.81 113.34 164.59C111.48 166.38 109.77 168.28 108.07 170.1L106.8 171.45C106.72 171.51 106.77 171.49 106.67 171.48C106.59 171.42 106.59 171.44 106.59 171.36C106.69 170.78 106.8 170.2 106.9 169.62C107.79 164.8 108.86 160.11 109.85 155.68L109.8 155.76L109.78 155.71C109.49 156.51 108.82 158.84 108.23 160.98C107.65 163.12 107.16 165.07 107.16 165.07C107.35 162.03 108.1 158.89 108.98 155.73C109.87 152.57 110.82 149.39 111.63 146.28L111.85 146.38C111.13 149.07 110.68 151.47 110.54 152.47C110.87 151.27 111.23 149.92 111.63 148.46C112.04 147 112.49 145.42 112.91 143.73C113.74 140.36 114.57 136.59 114.52 132.63C114.48 130.66 114.21 128.61 113.41 126.71C112.64 124.8 111.24 123.11 109.58 122.09C108.77 121.55 107.9 121.19 107.06 120.9C106.65 120.78 106.24 120.66 105.84 120.55C105.44 120.45 105.03 120.38 104.64 120.3C103.06 120.03 101.58 120.01 100.31 120.14C100.45 120.25 101.3 120.09 102.23 120.17C102.69 120.17 103.17 120.24 103.57 120.35C103.97 120.45 104.3 120.58 104.47 120.77C101.94 120.29 99.3202 120.53 97.0202 121.14C96.9702 120.96 97.2902 120.8 97.6602 120.69C98.0302 120.6 98.4502 120.53 98.5802 120.47C98.0602 120.51 96.2302 120.75 93.7202 121.76C91.2202 122.79 88.1202 124.65 85.0802 127.33C78.9702 132.68 72.9602 141 69.1402 149.57C67.2102 153.83 65.7602 158.06 64.6002 161.79C63.4502 165.53 62.5902 168.78 61.9802 171.18C60.7802 175.98 60.6502 177.44 62.3802 172.89L62.4302 173.42C63.9102 168.63 65.1002 164.64 67.1302 159.84C67.3302 159.13 67.4002 159.07 67.2102 159C67.2502 158.81 67.3002 158.48 67.1902 158.53C66.7202 158.45 67.4302 156.97 67.6802 156.29C68.2402 156.95 69.6102 153.17 71.3702 149.12C72.2402 147.09 73.2502 145.01 74.1302 143.32C75.0202 141.64 75.7802 140.35 76.1202 139.89C76.9302 139.9 78.6802 136.25 79.8002 135.38C79.7602 135.47 79.5202 136.05 79.4902 136.13C80.0302 135.78 83.1402 131.48 86.4102 128.46C89.6402 125.39 92.8002 123.68 90.5902 125.5C93.1302 124.07 96.1002 122.77 99.3902 122.43C101.03 122.26 102.73 122.34 104.41 122.74C106.1 123.15 107.76 123.75 108.98 124.88C110.22 125.99 111.05 127.55 111.45 129.35C111.87 131.14 111.9 133.1 111.76 135.08C111.46 139.07 110.44 143.13 109.39 147.25C108.37 151.42 107.42 155.54 106.47 159.66C106 161.72 105.55 163.76 105.12 165.8C104.92 166.82 104.71 167.83 104.51 168.84C104.41 169.34 104.32 169.85 104.22 170.35L104.15 170.73L104.11 170.93L104.08 171.25C104.06 171.68 104.14 172.14 104.35 172.53C104.76 173.33 105.53 173.85 106.38 173.96C106.81 174.02 107.27 173.96 107.68 173.79C107.89 173.72 108.07 173.59 108.25 173.47C108.4 173.35 108.6 173.17 108.66 173.1C109.35 172.38 110.03 171.67 110.71 170.96C112.04 169.55 113.34 168.19 114.65 166.95C117.24 164.48 120.06 162.42 122.72 161.92L122.54 161.87C122.71 161.87 123.22 161.72 123.36 161.79C123.85 161.66 124.57 161.53 125.36 161.63C126.14 161.72 127.06 161.99 127.66 162.4C128.3 162.81 128.74 163.41 129.01 163.89C129.27 164.39 129.4 164.74 129.4 164.74H129.43ZM110.79 145.61C110.79 145.61 110.76 145.57 110.75 145.58C110.83 145.58 111.58 142.38 111.61 142.25L111.84 142.32C111.53 145.68 107.99 152.76 110.51 145.84C110.51 145.59 110.71 145.63 110.8 145.6L110.79 145.61ZM103.79 121.7C103.24 121.6 102.63 121.5 101.95 121.47C103.83 121.36 105.94 121.67 107.93 122.59C109.94 123.49 111.55 125.37 112.29 127.54C113.05 129.71 113.13 132.06 113.01 134.3C112.87 136.55 112.53 138.73 112.19 140.8C111.96 139.3 112.28 136.94 112.43 134.49C112.6 132.05 112.46 129.5 111.88 127.86C111.18 126.28 110.13 124.7 108.61 123.68C107.88 123.14 107.06 122.74 106.22 122.43C105.39 122.11 104.57 121.87 103.79 121.71V121.7ZM69.5802 152.33L69.6902 152.4L69.5902 152.65C69.5902 152.65 69.5402 152.59 69.5402 152.54C69.5402 152.49 69.5502 152.4 69.5802 152.34V152.33ZM127.83 161.64C127.37 161.48 125.5 160.81 126.88 160.87C127.21 161 128.17 161.35 127.83 161.64ZM95.3602 122.35C95.4202 122.53 94.8302 122.9 94.1902 123.16C93.5702 123.45 92.8902 123.64 92.7702 123.42C93.6202 122.98 94.4902 122.64 95.3602 122.35ZM138.7 172.93C138.97 172.13 139.12 172.61 139.48 172.62C139.31 172.72 138.78 173.16 138.76 172.92H138.69L138.7 172.93ZM149.64 167.37C149.87 167.2 150.63 167.25 150.97 167.33C151.81 167.7 150 167.62 149.64 167.37ZM170.7 167.14C170.67 166.91 171.13 166.69 171.33 166.87C171.33 167.05 170.77 167.36 170.61 167.12C170.61 167.12 170.65 167.14 170.7 167.14ZM84.0902 128.88C84.1502 127.83 86.4902 126.49 87.5102 125.51C87.6702 126.22 85.4202 127.42 84.7202 128.26C84.4502 128.51 84.2402 128.72 84.0902 128.88ZM109.97 169.04C109.5 168.65 111.82 166.87 112.4 166.09L112.56 166.27C111.61 167.34 111.14 168.06 110.01 169L109.97 169.04ZM108.64 121.87C109.3 121.92 110.03 122.71 110.49 123.11C110.37 123.24 109.83 122.87 109.32 122.57C108.84 122.23 108.37 121.95 108.64 121.86V121.87ZM112.26 144.9C111.87 144.92 112.33 143.83 112.37 143.49C112.39 143.74 112.51 144.22 112.44 144.49C112.39 144.68 112.34 144.72 112.26 144.9ZM109.43 169.96C109.06 170.36 108.67 170.78 108.28 171.2C107.9 171.58 107.44 172.14 107.16 172.27L107.07 172.05C107.13 172.01 107.19 171.97 107.25 171.92C107.32 171.86 107.44 171.73 107.53 171.63L108.12 171.02C108.51 170.61 108.89 170.19 109.28 169.79L109.43 169.97V169.96ZM106.92 166.91L107.15 166.96C107.05 168.58 106.42 168.64 106.91 166.95V166.91H106.92ZM120.33 160.26C120.17 160.33 119.91 160.44 119.76 160.51C118.68 161.07 118.79 160.78 119.2 160.45C119.61 160.12 120.32 159.77 120.33 160.25V160.26ZM131.49 164.28C131.59 164.51 131.76 164.82 131.81 165.08C132.13 166.79 131.23 165.04 131.49 164.28Z",
                fill: "#333437"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M229.02 68.75H216.51L180.64 139.11L180.66 139.12L177.37 163.2L194.57 146.03V146.02H194.58H194.57L228.66 79.16L229.02 68.75Z",
                fill: "#09326C"
            })
        ]
    });
const $4de1580172ce767e$export$816a17ab71a9c447 = ()=>/*#__PURE__*/ (0, $loA2J.jsx)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
            id: "Frame",
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                id: "Layer 1",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        id: "Vector",
                        d: "M31.6417 10.6006H8.3584V25.5076H31.6417V10.6006Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        id: "Vector_2",
                        d: "M26.2544 27.5486V30.0827H13.7461V27.5486H17.9128V23.002H22.0878V27.5486H26.2544Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        id: "Vector_3",
                        d: "M22.0881 23.002H17.9131V25.5116H22.0881V23.002Z",
                        fill: "#AE2A19"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        id: "Vector_4",
                        d: "M19.9995 21.5921C21.9969 21.5921 23.6161 20.0089 23.6161 18.0558C23.6161 16.1028 21.9969 14.5195 19.9995 14.5195C18.002 14.5195 16.3828 16.1028 16.3828 18.0558C16.3828 20.0089 18.002 21.5921 19.9995 21.5921Z",
                        fill: "white"
                    })
                ]
            })
        })
    });
const $4de1580172ce767e$export$b6c5d967ad9baf32 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.6757 9.37109H17.5632L18.784 12.6336L22.2215 12.0628L24.1632 15.4294L21.9507 18.1211L24.1632 20.8086L22.2215 24.1753L18.7882 23.6044L17.5673 26.8669H13.6798L12.459 23.6044L9.02565 24.1753L7.08398 20.8086L9.29648 18.1211L7.08398 15.4336L9.02565 12.0669L12.4632 12.6378L13.684 9.37526L13.6757 9.37109ZM15.6173 21.3961C17.4298 21.3961 18.8965 19.9294 18.8965 18.1169C18.8965 16.3044 17.4298 14.8378 15.6173 14.8378C13.8048 14.8378 12.3382 16.3044 12.3382 18.1169C12.3382 19.9294 13.8048 21.3961 15.6173 21.3961Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.629 17.1006H27.8373L28.8456 19.7923L31.6831 19.3214L33.2873 22.1006L31.4581 24.3214L33.2831 26.5423L31.679 29.3214L28.8415 28.8506L27.8331 31.5423H24.6248L23.6165 28.8506L20.779 29.3214L19.1748 26.5423L20.9998 24.3214L19.1748 22.1006L20.779 19.3214L23.6165 19.7923L24.6248 17.1006H24.629ZM26.2331 27.0298C27.729 27.0298 28.9415 25.8173 28.9415 24.3214C28.9415 22.8256 27.729 21.6131 26.2331 21.6131C24.7373 21.6131 23.5248 22.8256 23.5248 24.3214C23.5248 25.8173 24.7373 27.0298 26.2331 27.0298Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.9502 18.1167L24.1627 15.4292L22.221 12.0625L18.7835 12.6333L17.5627 9.375H13.6752L12.4502 12.6333L9.01686 12.0625L7.0752 15.4292L9.2877 18.1167L7.0752 20.8083L9.01686 24.175L12.4502 23.6L13.6752 26.8625H17.5627L18.7835 23.6L20.6752 23.9167L22.221 24.175L24.1627 20.8083L23.2794 19.7333L21.9502 18.1167ZM15.6169 21.3958C13.8085 21.3958 12.3377 19.9292 12.3377 18.1167C12.3377 16.3042 13.8085 14.8375 15.6169 14.8375C17.4252 14.8375 18.896 16.3083 18.896 18.1167C18.896 19.925 17.4294 21.3958 15.6169 21.3958Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.2797 19.7338L20.7839 19.3213L19.1797 22.1005L20.6755 23.9171L22.2214 24.1755L24.163 20.8088L23.2797 19.7338Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$89a8de63b42b4bf7 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.7919 10.4443L19.7002 14.0818V23.7818L28.7919 27.4193V10.4443Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.0292 14.6855V23.1605H17.275V28.6272H13.6375V23.1605H10V14.6855H22.0292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.0294 14.6855H19.7002V23.1564H22.0294V14.6855Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$27ec4a87867305fc = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.4292 21.0958C25.4958 20.725 25.5292 20.325 25.5292 19.9083C25.5292 19.4917 25.4958 19.0833 25.425 18.7042C25.0208 16.4583 23.4625 15.075 21.2708 14.7167C20.8958 14.6542 20.5042 14.625 20.1 14.625C19.6958 14.625 19.2667 14.6583 18.8792 14.725C16.6917 15.0917 15.1333 16.4708 14.7292 18.7042C14.6625 19.0833 14.625 19.4833 14.625 19.9083C14.625 20.3333 14.6583 20.725 14.725 21.0958C15.125 23.325 16.6833 24.7083 18.8792 25.075C19.2667 25.1417 19.675 25.175 20.1 25.175C20.525 25.175 20.9 25.1458 21.2708 25.0833C23.4625 24.725 25.025 23.3417 25.425 21.0958H25.4292Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M7.37109 19.3165L13.8711 8.1748L20.3711 19.3165H7.37109Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M17.8465 14.9912C16.2048 15.5662 15.0631 16.837 14.7298 18.7037C14.6923 18.9037 14.6673 19.1037 14.6465 19.3162H20.3673L17.8465 14.9912Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.9165 20.8828H20.7832V30.0161H29.9165V20.8828Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.7832 20.8867V25.1451C20.9499 25.1284 21.1124 25.1076 21.2749 25.0826C23.4665 24.7284 25.0249 23.3409 25.429 21.0951C25.4415 21.0284 25.454 20.9576 25.4624 20.8867H20.7832Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$a9d1d41ede76da88 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M33.2743 18.1211H12.9785V28.0378H33.2743V18.1211Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.9667 11.9629H6.6709V21.8796H26.9667V11.9629Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.966 18.1211H12.9785V21.8794H26.966V18.1211Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M14.6829 15.3294L10.312 19.7003L8.05371 17.3794L9.02871 16.4336L10.3287 17.7669L13.7245 14.3711L14.687 15.3336L14.6829 15.3294Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M32.012 21.7044L27.6411 26.0753L25.3828 23.7544L26.3578 22.8086L27.6578 24.1419L31.0536 20.7461L32.0161 21.7086L32.012 21.7044Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$a10f1df78def0898 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.4783 10.0306L21.0316 10.0486L22.4464 13.8755L26.4752 13.2228L28.7338 17.175L26.1299 20.3174L28.7088 23.4754L26.419 27.4096L22.4004 26.7251L20.9553 30.5407L16.4021 30.5227L14.9873 26.6958L10.9634 27.3484L8.70478 23.3962L11.3086 20.2587L8.7297 17.1007L11.0195 13.1665L15.043 13.851L16.4881 10.0355L16.4783 10.0306ZM18.6968 24.1239C20.8197 24.1323 22.5443 22.4213 22.5527 20.2984C22.5611 18.1755 20.8501 16.4508 18.7272 16.4424C16.6043 16.434 14.8796 18.1451 14.8712 20.268C14.8628 22.3909 16.5739 24.1155 18.6968 24.1239Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.1299 20.3126L28.7338 17.1751L26.4752 13.2229L22.4464 13.8755L21.0316 10.0535L16.4783 10.0355L15.0284 13.8461L11.0098 13.1616L8.71998 17.0959L11.2989 20.2539L8.69504 23.3962L10.9536 27.3485L14.9776 26.6909L16.3972 30.5178L20.9505 30.5358L22.3955 26.7203L24.6097 27.0999L26.4191 27.4097L28.7088 23.4754L27.6792 22.2123L26.1299 20.3126ZM18.6968 24.1239C16.5788 24.1156 14.8628 22.3909 14.8712 20.268C14.8796 18.1451 16.6092 16.4341 18.7272 16.4425C20.8452 16.4508 22.5611 18.1804 22.5527 20.2984C22.5443 22.4164 20.8197 24.1323 18.6968 24.1239Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M31.9279 24.6918C31.9762 24.423 32.0004 24.133 32.0004 23.831C32.0004 23.5289 31.9762 23.2329 31.9248 22.958C31.6319 21.33 30.5022 20.3272 28.9134 20.0674C28.6416 20.0221 28.3576 20.001 28.0646 20.001C27.7717 20.001 27.4605 20.0251 27.1796 20.0735C25.5939 20.3393 24.4642 21.3391 24.1712 22.958C24.1229 23.2329 24.0957 23.5229 24.0957 23.831C24.0957 24.1391 24.1199 24.423 24.1682 24.6918C24.4582 26.3078 25.5878 27.3106 27.1796 27.5764C27.4605 27.6247 27.7566 27.6489 28.0646 27.6489C28.3727 27.6489 28.6446 27.6277 28.9134 27.5824C30.5022 27.3227 31.6349 26.3199 31.9248 24.6918H31.9279Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.2701 20.2856L28.6925 23.252L28.8406 23.4336L26.5508 27.3679L26.5358 27.3653L26.448 27.3503C25.2457 26.9308 24.4115 26.0066 24.1682 24.651C24.1199 24.3822 24.0957 24.0982 24.0957 23.7901C24.0957 23.482 24.1229 23.1921 24.1712 22.9172C24.4045 21.6282 25.1681 20.7317 26.2701 20.2856Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.7008 22.6769L27.4765 25.7641L25.8105 24.1249L26.5298 23.4568L27.4888 24.3986L29.9939 22L30.7039 22.6798L30.7008 22.6769Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$e6598341d5f08715 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M10.0205 14.166V31.416L15.0163 27.1327H30.0122V14.166H10.0205Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.8997 14.6787C18.8997 13.4412 19.8872 12.4495 21.1081 12.4495C22.3289 12.4495 23.3164 13.437 23.3164 14.6787C23.3164 15.3079 23.1664 15.5954 23.0289 15.7787C22.8664 15.9912 22.6622 16.1412 22.3039 16.4037C22.2456 16.4495 22.1789 16.4954 22.1081 16.5454C21.6622 16.8745 21.0956 17.3245 20.6706 18.0704C20.2414 18.8204 20.0039 19.762 20.0039 21.0079H22.2122C22.2122 20.0412 22.3914 19.5037 22.5831 19.1745C22.7747 18.837 23.0372 18.6079 23.4206 18.3245C23.4664 18.2912 23.5164 18.2537 23.5706 18.2162C23.9164 17.9662 24.4081 17.612 24.7789 17.1245C25.2581 16.4995 25.5247 15.7162 25.5247 14.6787C25.5247 12.237 23.5664 10.2412 21.1081 10.2412C18.6497 10.2412 16.6914 12.237 16.6914 14.6787V15.7829H18.8997V14.6787Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.1087 22.6709C20.3462 22.6709 19.7295 23.2876 19.7295 24.0501C19.7295 24.8126 20.3462 25.4292 21.1087 25.4292C21.8712 25.4292 22.4878 24.8126 22.4878 24.0501C22.4878 23.2876 21.8712 22.6709 21.1087 22.6709Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.7167 14.166H18.9583C18.9167 14.3285 18.8958 14.5035 18.8958 14.6785V15.7827H16.6875V14.6785C16.6875 14.5077 16.6958 14.3368 16.7167 14.166Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.4871 24.0491C22.4871 24.8116 21.8704 25.4324 21.1079 25.4324C20.3454 25.4324 19.7246 24.8116 19.7246 24.0491C19.7246 23.2866 20.3454 22.6699 21.1079 22.6699C21.8704 22.6699 22.4871 23.2866 22.4871 24.0491Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.5247 14.6785C25.5247 15.7202 25.2581 16.4993 24.7789 17.1243C24.4081 17.6118 23.9164 17.966 23.5706 18.216C23.5164 18.2577 23.4664 18.291 23.4206 18.3243C23.0372 18.6118 22.7747 18.841 22.5831 19.1785C22.3914 19.5118 22.2122 20.0493 22.2122 21.0118H20.0039C20.0039 19.766 20.2372 18.8243 20.6664 18.0785C21.0956 17.3327 21.6622 16.8827 22.1039 16.5493C22.1747 16.4993 22.2414 16.4535 22.2997 16.4077C22.6622 16.141 22.8622 15.9952 23.0247 15.7827C23.1664 15.5952 23.3164 15.3077 23.3164 14.6785C23.3164 14.5035 23.2956 14.3285 23.2539 14.166H25.4956C25.5164 14.3368 25.5247 14.5077 25.5247 14.6785Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$10c57db1e3cf8326 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.2374 11.7456H11.7041V33.3456H28.2374V11.7456Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.6831 28.9165C16.6831 27.0124 18.2248 25.4707 20.1289 25.4707C22.0331 25.4707 23.5748 27.0124 23.5748 28.9165V33.3457H16.6831V28.9165Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.0831 21.0416C23.0831 22.6707 21.7623 23.9957 20.129 23.9957C18.4956 23.9957 17.1748 22.6749 17.1748 21.0416C17.1748 19.4082 18.4956 18.0874 20.129 18.0874C21.7623 18.0874 23.0831 19.4082 23.0831 21.0416Z",
                fill: "#164B35"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.908 9.95391V15.0831H14.0288V9.95391H17.5205C17.5205 8.59974 18.6163 7.50391 19.9705 7.50391C21.3246 7.50391 22.4163 8.59974 22.4163 9.95391H25.908Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.908 11.7456H14.0288V15.0831H25.908V11.7456Z",
                fill: "#164B35"
            })
        ]
    });
const $4de1580172ce767e$export$925c822e766a0944 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.2917 24.4C22.6583 28.5625 18.7708 31.425 14.6083 30.7917C10.4458 30.1583 7.58333 26.2708 8.21667 22.1083C8.85 17.9458 12.7375 15.0833 16.9 15.7167C21.0625 16.35 23.925 20.2375 23.2917 24.4ZM14.9208 21.475C15.0125 20.8792 14.6042 20.325 14.0083 20.2333C13.4125 20.1417 12.8583 20.55 12.7667 21.1458C12.675 21.7417 13.0833 22.2958 13.6792 22.3875C14.275 22.4792 14.8292 22.0708 14.9208 21.475ZM19.2292 22.1292C19.3208 21.5333 18.9125 20.9792 18.3167 20.8875C17.7208 20.7958 17.1667 21.2042 17.075 21.8C16.9833 22.3958 17.3917 22.95 17.9875 23.0417C18.5833 23.1333 19.1375 22.725 19.2292 22.1292ZM13.3083 25.05L12.825 24.3917L11.5083 25.3583L11.9917 26.0167C13.5208 28.0917 16.4417 28.5375 18.5208 27.0083L19.1792 26.525L18.2125 25.2083L17.5542 25.6917C16.2042 26.6833 14.3042 26.3958 13.3125 25.0458L13.3083 25.05Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M22.8419 9.2748C18.7044 10.0498 15.9752 14.0331 16.7502 18.1748C17.5252 22.3123 21.5085 25.0415 25.646 24.2665C29.7835 23.4915 32.5169 19.5081 31.7419 15.3706C30.9669 11.2331 26.9794 8.50396 22.8419 9.2748ZM25.8835 13.6915C26.4752 13.579 27.0419 13.9706 27.1544 14.5623C27.2669 15.154 26.8752 15.7206 26.2835 15.8331C25.6919 15.9456 25.1252 15.554 25.0127 14.9623C24.9002 14.3706 25.2919 13.804 25.8835 13.6915ZM21.6002 14.4915C22.1919 14.379 22.7585 14.7706 22.871 15.3623C22.9835 15.954 22.5919 16.5206 22.0002 16.6331C21.4085 16.7456 20.8419 16.354 20.7294 15.7623C20.6169 15.1706 21.0085 14.604 21.6002 14.4915ZM25.2335 22.054C23.1585 22.4415 21.1669 21.079 20.7794 19.0123L28.2752 17.6081C28.6627 19.679 27.296 21.6665 25.2294 22.054H25.2335Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M23.2626 21.8997C22.021 21.4664 21.0418 20.3997 20.7835 19.0122L21.9418 18.7956C20.7876 17.1914 19.0126 16.0372 16.9043 15.7164C16.8376 15.7081 16.7668 15.6956 16.7001 15.6914C16.5793 16.4956 16.5918 17.3331 16.7501 18.1747C16.9418 19.1872 17.321 20.1122 17.8501 20.9247C17.996 20.8789 18.1585 20.8664 18.321 20.8914C18.9126 20.9831 19.3251 21.5372 19.2335 22.1331C19.2168 22.2414 19.1835 22.3456 19.1418 22.4372C20.2876 23.4706 21.7376 24.1497 23.3043 24.3414C23.4251 23.5081 23.4043 22.6872 23.2626 21.8997Z",
                fill: "#09326C"
            })
        ]
    });
const $4de1580172ce767e$export$c0094cf6ece486f3 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.5832 13.6997H8.4165V16.9455H31.5832V13.6997Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.5832 26.6914H8.4165V29.9372H31.5832V26.6914Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.9248 29.9375V16.9458H10.1331V29.9375H13.9248Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.8955 29.9375V16.9458H18.1038V29.9375H21.8955Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.8291 29.9375V16.9458H26.0374V29.9375H29.8291Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M19.9998 8.4165L8.4165 16.9457H31.5832L19.9998 8.4165Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.5832 16.9455H8.4165L12.8248 13.6997H27.1748L31.5832 16.9455Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M13.9206 26.6958H10.1289V29.9375H13.9206V26.6958Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M21.8959 26.6958H18.1084V29.9375H21.8959V26.6958Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.8249 26.6958H26.0332V29.9375H29.8249V26.6958Z",
                fill: "#09326C"
            })
        ]
    });
const $4de1580172ce767e$export$526fd3870ee3978 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.9459 22.2458V19.8291C31.9459 19.2041 31.3793 18.6958 30.6751 18.6958H16.4334C15.7293 18.6958 15.1626 19.2 15.1626 19.8291V22.2458H31.9459Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.9459 23.8291H15.1626V28.8041C15.1626 29.425 15.7293 29.9375 16.4334 29.9375H30.6751C31.3793 29.9375 31.9459 29.4291 31.9459 28.8041V23.8291Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.1002 13.4919V11.0752C25.1002 10.4502 24.5336 9.94189 23.8294 9.94189H9.58773C8.88356 9.94189 8.31689 10.4461 8.31689 11.0752V13.4919H25.1002Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.1002 15.0752H8.31689V20.0502C8.31689 20.6711 8.88356 21.1836 9.58773 21.1836H23.8294C24.5336 21.1836 25.1002 20.6752 25.1002 20.0502V15.0752Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.1001 18.6919V20.0461C25.1001 20.6711 24.5334 21.1836 23.8293 21.1836H15.1626V19.8294C15.1626 19.2002 15.7334 18.6919 16.4334 18.6919H25.1001Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$6361c44213db83a2 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.1166 33.2749H9.8833V6.8374H20.1125L30.1166 16.6916V33.2749Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M20.1084 6.8374V16.6624H30.0876L20.1084 6.8374Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.6917 19.9043H20.1084V22.696H25.6917V19.9043Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.3874 23.1625C17.416 23.1625 18.2499 22.3286 18.2499 21.3C18.2499 20.2714 17.416 19.4375 16.3874 19.4375C15.3588 19.4375 14.5249 20.2714 14.5249 21.3C14.5249 22.3286 15.3588 23.1625 16.3874 23.1625Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M25.6917 26.9458H20.1084V29.7375H25.6917V26.9458Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.3874 30.204C17.416 30.204 18.2499 29.3701 18.2499 28.3415C18.2499 27.3129 17.416 26.479 16.3874 26.479C15.3588 26.479 14.5249 27.3129 14.5249 28.3415C14.5249 29.3701 15.3588 30.204 16.3874 30.204Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$b5a9699d43e96f3e = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M9.1792 9.18311V26.7998H26.7959V9.18311H9.1792ZM16.7292 12.9664H23.0209V14.8539H16.7292V12.9664ZM16.7292 17.0456H23.0209V18.9331H16.7292V17.0456ZM13.5875 12.6414C14.2792 12.6414 14.8459 13.2081 14.8459 13.8998C14.8459 14.5914 14.2792 15.1581 13.5875 15.1581C12.8959 15.1581 12.3292 14.5956 12.3292 13.8998C12.3292 13.2039 12.8917 12.6414 13.5875 12.6414ZM13.5875 16.7331C14.2792 16.7331 14.8459 17.2956 14.8459 17.9914C14.8459 18.6873 14.2792 19.2498 13.5875 19.2498C12.8959 19.2498 12.3292 18.6873 12.3292 17.9914C12.3292 17.2956 12.8917 16.7331 13.5875 16.7331Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M29.1873 20.0498V22.9706H16.729V28.9081H29.1873V32.4165L35.3665 26.229L29.1873 20.0498Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M16.729 22.9707V26.7999H26.7957V22.9707H16.729Z",
                fill: "#09326C"
            })
        ]
    });
const $4de1580172ce767e$export$9fe16602583dd125 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M18.2215 11.0342C12.574 11.0342 8 15.6127 8 21.2557C8 25.5094 10.5982 29.1586 14.2971 30.6968V28.2294C14.2971 26.0597 16.0563 24.305 18.2215 24.305C20.3867 24.305 22.1414 26.0642 22.1414 28.2294V30.6968C25.8403 29.1631 28.443 25.5139 28.443 21.2557C28.443 15.6081 23.8645 11.0342 18.2215 11.0342ZM18.2215 23.1998C16.3631 23.1998 14.8564 21.6932 14.8564 19.8348C14.8564 17.9763 16.3585 16.4697 18.2215 16.4697C20.0845 16.4697 21.5821 17.9718 21.5821 19.8348C21.5821 21.6977 20.08 23.1998 18.2215 23.1998Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.5408 12.9421L20.9321 14.7465L24.5408 16.5508L26.3451 20.1595L28.1494 16.5508L31.7581 14.7465L28.1494 12.9421L26.3451 9.3335L24.5408 12.9421Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.7034 17.4438L26.3456 20.1593L24.5413 16.5507L20.9326 14.7464L24.3202 13.0503C25.8178 14.169 26.9997 15.6846 27.7034 17.4438Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M24.3202 13.0503L20.9326 14.7464L24.5413 16.5507L26.3456 20.1593L27.7034 17.4438C26.9997 15.6846 25.8178 14.169 24.3202 13.0503Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$6c259bad890ba857 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M47.4626 15.5811H12.5376V38.4498H47.4626V15.5811Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M39.3811 41.581V45.4685H20.6187V41.581H26.8687V34.606H33.1311V41.581H39.3811Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M33.1312 34.606H26.8687V38.456H33.1312V34.606Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M30.0002 32.4438C32.9963 32.4438 35.4252 30.0149 35.4252 27.0188C35.4252 24.0226 32.9963 21.5938 30.0002 21.5938C27.0041 21.5938 24.5752 24.0226 24.5752 27.0188C24.5752 30.0149 27.0041 32.4438 30.0002 32.4438Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$50a598674e46acd6 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.0125 14.0562H26.8438L28.675 18.9499L33.8313 18.0937L36.7438 23.1437L33.425 27.1812L36.7438 31.2124L33.8313 36.2624L28.6812 35.4062L26.85 40.2999H21.0188L19.1875 35.4062L14.0375 36.2624L11.125 31.2124L14.4437 27.1812L11.125 23.1499L14.0375 18.0999L19.1938 18.9562L21.025 14.0624L21.0125 14.0562ZM23.925 32.0937C26.6437 32.0937 28.8438 29.8937 28.8438 27.1749C28.8438 24.4562 26.6437 22.2562 23.925 22.2562C21.2063 22.2562 19.0063 24.4562 19.0063 27.1749C19.0063 29.8937 21.2063 32.0937 23.925 32.0937Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M37.4435 25.6499H42.256L43.7685 29.6874L48.0247 28.9812L50.431 33.1499L47.6872 36.4812L50.4247 39.8124L48.0185 43.9812L43.7622 43.2749L42.2497 47.3124H37.4372L35.9247 43.2749L31.6685 43.9812L29.2622 39.8124L31.9997 36.4812L29.2622 33.1499L31.6685 28.9812L35.9247 29.6874L37.4372 25.6499H37.4435ZM39.8497 40.5437C42.0935 40.5437 43.9122 38.7249 43.9122 36.4812C43.9122 34.2374 42.0935 32.4187 39.8497 32.4187C37.606 32.4187 35.7872 34.2374 35.7872 36.4812C35.7872 38.7249 37.606 40.5437 39.8497 40.5437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.4248 27.175L36.7436 23.1437L33.8311 18.0938L28.6748 18.95L26.8436 14.0625H21.0123L19.1748 18.95L14.0248 18.0938L11.1123 23.1437L14.4311 27.175L11.1123 31.2125L14.0248 36.2625L19.1748 35.4L21.0123 40.2938H26.8436L28.6748 35.4L31.5123 35.875L33.8311 36.2625L36.7436 31.2125L35.4186 29.6L33.4248 27.175ZM23.9248 32.0938C21.2123 32.0938 19.0061 29.8937 19.0061 27.175C19.0061 24.4563 21.2123 22.2563 23.9248 22.2563C26.6373 22.2563 28.8436 24.4625 28.8436 27.175C28.8436 29.8875 26.6436 32.0938 23.9248 32.0938Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M35.4186 29.5997L31.6748 28.981L29.2686 33.1497L31.5123 35.8747L33.8311 36.2622L36.7436 31.2122L35.4186 29.5997Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$bc46f4026380149b = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44.5936 16.3623L30.9561 21.8186V36.3686L44.5936 41.8248V16.3623Z",
                fill: "#1868DA"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.45 22.7246V35.4371H27.3187V43.6371H21.8625V35.4371H16.4062V22.7246H34.45Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M34.4498 22.7246H30.9561V35.4309H34.4498V22.7246Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$2d48c6a000b33e3 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M38.1437 31.6438C38.2437 31.0875 38.2938 30.4875 38.2938 29.8625C38.2938 29.2375 38.2438 28.625 38.1375 28.0563C37.5313 24.6875 35.1938 22.6125 31.9062 22.075C31.3438 21.9813 30.7563 21.9375 30.15 21.9375C29.5438 21.9375 28.9 21.9875 28.3188 22.0875C25.0375 22.6375 22.7 24.7063 22.0938 28.0563C21.9938 28.625 21.9375 29.225 21.9375 29.8625C21.9375 30.5 21.9875 31.0875 22.0875 31.6438C22.6875 34.9875 25.025 37.0625 28.3188 37.6125C28.9 37.7125 29.5125 37.7625 30.15 37.7625C30.7875 37.7625 31.35 37.7188 31.9062 37.625C35.1938 37.0875 37.5375 35.0125 38.1375 31.6438H38.1437Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M11.0562 28.9752L20.8062 12.2627L30.5562 28.9752H11.0562Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M26.7688 22.4878C24.3063 23.3503 22.5937 25.2565 22.0937 28.0565C22.0375 28.3565 22 28.6565 21.9688 28.9753H30.55L26.7688 22.4878Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M44.8748 31.3252H31.1748V45.0252H44.8748V31.3252Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.1748 31.3315V37.719C31.4248 37.694 31.6686 37.6628 31.9123 37.6253C35.1998 37.094 37.5373 35.0128 38.1436 31.644C38.1623 31.544 38.1811 31.4378 38.1936 31.3315H31.1748Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$d2da7b6954e156a3 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M49.9125 27.1812H19.4688V42.0562H49.9125V27.1812Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M40.45 17.9438H10.0062V32.8188H40.45V17.9438Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M40.45 27.1812H19.4688V32.8187H40.45V27.1812Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.0249 22.9937L15.4687 29.5499L12.0812 26.0687L13.5437 24.6499L15.4937 26.6499L20.5874 21.5562L22.0312 22.9999L22.0249 22.9937Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M48.0187 32.5562L41.4625 39.1124L38.075 35.6312L39.5375 34.2124L41.4875 36.2124L46.5812 31.1187L48.025 32.5624L48.0187 32.5562Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$f6faf0bdc0af7562 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.7175 15.0458L31.5474 15.0729L33.6696 20.8132L39.7128 19.8342L43.1007 25.7626L39.1948 30.4761L43.0633 35.2131L39.6286 41.1144L33.6006 40.0877L31.433 45.811L24.6031 45.784L22.481 40.0437L16.445 41.0227L13.0572 35.0943L16.963 30.3881L13.0946 25.6511L16.5292 19.7498L22.5646 20.7766L24.7321 15.0532L24.7175 15.0458ZM28.0451 36.1858C31.2295 36.1985 33.8165 33.6319 33.8291 30.4475C33.8417 27.2632 31.2751 24.6762 28.0908 24.6636C24.9064 24.651 22.3195 27.2176 22.3068 30.4019C22.2942 33.5863 24.8608 36.1732 28.0451 36.1858Z",
                fill: "#82B536"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.1945 30.4688L43.1003 25.7626L39.7124 19.8343L33.6691 20.8133L31.5469 15.0803L24.7171 15.0532L22.5422 20.7692L16.5142 19.7424L13.0795 25.6438L16.948 30.3808L13.0421 35.0943L16.43 41.0227L22.466 40.0363L24.5954 45.7767L31.4253 45.8037L33.5929 40.0804L36.9141 40.6499L39.6282 41.1145L43.0628 35.2132L41.5184 33.3184L39.1945 30.4688ZM28.0447 36.1859C24.8677 36.1733 22.2938 33.5863 22.3064 30.402C22.319 27.2176 24.9133 24.6511 28.0904 24.6637C31.2674 24.6763 33.8412 27.2706 33.8287 30.4476C33.8161 33.6246 31.2291 36.1985 28.0447 36.1859Z",
                fill: "#FFA900"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                style: {
                    mixBlendMode: "multiply"
                },
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M47.8907 37.0382C47.9632 36.635 47.9995 36.2 47.9995 35.7469C47.9995 35.2939 47.9632 34.8499 47.8862 34.4376C47.4467 31.9955 45.7522 30.4913 43.3691 30.1016C42.9613 30.0337 42.5354 30.002 42.0959 30.002C41.6564 30.002 41.1898 30.0382 40.7684 30.1107C38.3898 30.5094 36.6953 32.0091 36.2558 34.4376C36.1833 34.8499 36.1425 35.2848 36.1425 35.7469C36.1425 36.2091 36.1787 36.635 36.2512 37.0382C36.6862 39.4622 38.3807 40.9664 40.7684 41.3651C41.1898 41.4376 41.6338 41.4738 42.0959 41.4738C42.558 41.4738 42.9658 41.4421 43.3691 41.3741C45.7522 40.9845 47.4513 39.4803 47.8862 37.0382H47.8907Z",
                    fill: "#0C66E4"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39.4038 30.4282L43.0336 34.8731L43.2603 35.1511L39.8256 41.0523L39.7036 41.0316L39.6768 41.027C37.8703 40.3987 36.6167 39.0117 36.2514 36.976C36.1789 36.5728 36.1426 36.1469 36.1426 35.6848C36.1426 35.2226 36.1834 34.7877 36.2559 34.3754C36.6058 32.442 37.7511 31.0973 39.4038 30.4282Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M46.0498 34.0153L41.2133 38.6462L38.7144 36.1873L39.7932 35.1852L41.2317 36.5978L44.9894 33L46.0544 34.0198L46.0498 34.0153Z",
                fill: "white"
            })
        ]
    });
const $4de1580172ce767e$export$edf22519467780de = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.0312 21.25V47.125L22.525 40.7H45.0187V21.25H15.0312Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M28.35 22.0186C28.35 20.1623 29.8312 18.6748 31.6625 18.6748C33.4937 18.6748 34.975 20.1561 34.975 22.0186C34.975 22.9623 34.75 23.3936 34.5437 23.6686C34.3 23.9873 33.9937 24.2123 33.4562 24.6061C33.3687 24.6748 33.2687 24.7436 33.1625 24.8186C32.4937 25.3123 31.6437 25.9873 31.0062 27.1061C30.3625 28.2311 30.0062 29.6436 30.0062 31.5123H33.3187C33.3187 30.0623 33.5875 29.2561 33.875 28.7623C34.1625 28.2561 34.5562 27.9123 35.1312 27.4873C35.2 27.4373 35.275 27.3811 35.3562 27.3248C35.875 26.9498 36.6125 26.4186 37.1687 25.6873C37.8875 24.7498 38.2875 23.5748 38.2875 22.0186C38.2875 18.3561 35.35 15.3623 31.6625 15.3623C27.975 15.3623 25.0375 18.3561 25.0375 22.0186V23.6748H28.35V22.0186Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M31.6625 34.0059C30.5188 34.0059 29.5938 34.9309 29.5938 36.0746C29.5938 37.2184 30.5188 38.1434 31.6625 38.1434C32.8063 38.1434 33.7313 37.2184 33.7313 36.0746C33.7313 34.9309 32.8063 34.0059 31.6625 34.0059Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.075 21.25H28.4375C28.375 21.4937 28.3437 21.7562 28.3437 22.0187V23.675H25.0312V22.0187C25.0312 21.7625 25.0437 21.5062 25.075 21.25Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M33.7313 36.0751C33.7313 37.2188 32.8063 38.1501 31.6625 38.1501C30.5188 38.1501 29.5875 37.2188 29.5875 36.0751C29.5875 34.9313 30.5188 34.0063 31.6625 34.0063C32.8063 34.0063 33.7313 34.9313 33.7313 36.0751Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M38.2875 22.0187C38.2875 23.5812 37.8875 24.75 37.1687 25.6875C36.6125 26.4187 35.875 26.95 35.3562 27.325C35.275 27.3875 35.2 27.4375 35.1312 27.4875C34.5562 27.9187 34.1625 28.2625 33.875 28.7687C33.5875 29.2687 33.3187 30.075 33.3187 31.5188H30.0062C30.0062 29.65 30.3562 28.2375 31 27.1187C31.6437 26 32.4937 25.325 33.1562 24.825C33.2625 24.75 33.3625 24.6813 33.45 24.6125C33.9937 24.2125 34.2937 23.9938 34.5375 23.675C34.75 23.3938 34.975 22.9625 34.975 22.0187C34.975 21.7562 34.9437 21.4937 34.8812 21.25H38.2437C38.275 21.5062 38.2875 21.7625 38.2875 22.0187Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$8c7409f1554738f7 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_5039)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M42.8564 17.6187H18.0564V50.0187H42.8564V17.6187Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M25.5249 43.3753C25.5249 40.519 27.8374 38.2065 30.6937 38.2065C33.5499 38.2065 35.8624 40.519 35.8624 43.3753V50.019H25.5249V43.3753Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M35.125 31.5626C35.125 34.0063 33.1437 35.9938 30.6937 35.9938C28.2437 35.9938 26.2625 34.0126 26.2625 31.5626C26.2625 29.1126 28.2437 27.1313 30.6937 27.1313C33.1437 27.1313 35.125 29.1126 35.125 31.5626Z",
                        fill: "#164B35"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M39.3624 14.9313V22.6251H21.5437V14.9313H26.7812C26.7812 12.9001 28.425 11.2563 30.4562 11.2563C32.4875 11.2563 34.1249 12.9001 34.1249 14.9313H39.3624Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M39.3624 17.6187H21.5437V22.6249H39.3624V17.6187Z",
                        fill: "#164B35"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_5039",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$b20b85b1cb35523d = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_4707)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.9375 36.6C33.9875 42.8438 28.1563 47.1375 21.9125 46.1875C15.6688 45.2375 11.375 39.4063 12.325 33.1625C13.275 26.9188 19.1063 22.625 25.35 23.575C31.5938 24.525 35.8875 30.3563 34.9375 36.6ZM22.3813 32.2125C22.5188 31.3188 21.9062 30.4875 21.0125 30.35C20.1188 30.2125 19.2875 30.825 19.15 31.7188C19.0125 32.6125 19.625 33.4438 20.5188 33.5813C21.4125 33.7188 22.2438 33.1063 22.3813 32.2125ZM28.8438 33.1938C28.9813 32.3 28.3688 31.4688 27.475 31.3313C26.5813 31.1938 25.75 31.8063 25.6125 32.7C25.475 33.5938 26.0875 34.425 26.9813 34.5625C27.875 34.7 28.7063 34.0875 28.8438 33.1938ZM19.9625 37.575L19.2375 36.5875L17.2625 38.0375L17.9875 39.025C20.2813 42.1375 24.6625 42.8063 27.7813 40.5125L28.7688 39.7875L27.3188 37.8125L26.3313 38.5375C24.3063 40.025 21.4563 39.5938 19.9688 37.5688L19.9625 37.575Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.2625 13.9127C28.0563 15.0752 23.9625 21.0502 25.125 27.2627C26.2875 33.4689 32.2625 37.5627 38.4688 36.4002C44.675 35.2377 48.775 29.2627 47.6125 23.0564C46.45 16.8502 40.4688 12.7564 34.2625 13.9127ZM38.825 20.5377C39.7125 20.3689 40.5625 20.9564 40.7313 21.8439C40.9 22.7314 40.3125 23.5814 39.425 23.7502C38.5375 23.9189 37.6875 23.3314 37.5188 22.4439C37.35 21.5564 37.9375 20.7064 38.825 20.5377ZM32.4 21.7377C33.2875 21.5689 34.1375 22.1564 34.3063 23.0439C34.475 23.9314 33.8875 24.7814 33 24.9502C32.1125 25.1189 31.2625 24.5314 31.0938 23.6439C30.925 22.7564 31.5125 21.9064 32.4 21.7377ZM37.85 33.0814C34.7375 33.6627 31.75 31.6189 31.1688 28.5189L42.4125 26.4127C42.9938 29.5189 40.9438 32.5002 37.8438 33.0814H37.85Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.894 32.8501C33.0315 32.2001 31.5627 30.6001 31.1752 28.5188L32.9127 28.1938C31.1815 25.7876 28.519 24.0563 25.3565 23.5751C25.2565 23.5626 25.1502 23.5438 25.0502 23.5376C24.869 24.7438 24.8877 26.0001 25.1252 27.2626C25.4127 28.7813 25.9815 30.1688 26.7752 31.3876C26.994 31.3188 27.2377 31.3001 27.4815 31.3376C28.369 31.4751 28.9877 32.3063 28.8502 33.2001C28.8252 33.3626 28.7752 33.5188 28.7127 33.6563C30.4315 35.2063 32.6065 36.2251 34.9565 36.5126C35.1377 35.2626 35.1065 34.0313 34.894 32.8501Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_4707",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$ab9f12136609e96a = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_5503)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M48.375 20.5498H13.625V25.4186H48.375V20.5498Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M48.375 40.0376H13.625V44.9063H48.375V40.0376Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M21.8877 44.9064V25.4189H16.2002V44.9064H21.8877Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M33.8438 44.9064V25.4189H28.1562V44.9064H33.8438Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M45.7437 44.9064V25.4189H40.0562V44.9064H45.7437Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M31 12.625L13.625 25.4187H48.375L31 12.625Z",
                        fill: "#82B536"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M48.375 25.4186H13.625L20.2375 20.5498H41.7625L48.375 25.4186Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M21.8813 40.0439H16.1938V44.9064H21.8813V40.0439Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M33.8438 40.0439H28.1626V44.9064H33.8438V40.0439Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M45.7373 40.0439H40.0498V44.9064H45.7373V40.0439Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_5503",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$8aaa0b75bd31bddc = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_6742)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M48.9187 33.369V29.7439C48.9187 28.8064 48.0687 28.0439 47.0124 28.0439H25.6499C24.5937 28.0439 23.7437 28.8002 23.7437 29.7439V33.369H48.9187Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M48.9187 35.744H23.7437V43.2064C23.7437 44.1377 24.5937 44.9064 25.6499 44.9064H47.0124C48.0687 44.9064 48.9187 44.1439 48.9187 43.2064V35.744Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.6501 20.2376V16.6126C38.6501 15.6751 37.8001 14.9126 36.7438 14.9126H15.3813C14.3251 14.9126 13.4751 15.6688 13.4751 16.6126V20.2376H38.6501Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.6501 22.6126H13.4751V30.0751C13.4751 31.0063 14.3251 31.7751 15.3813 31.7751H36.7438C37.8001 31.7751 38.6501 31.0126 38.6501 30.0751V22.6126Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
                        fill: "#09326C"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.6499 28.0376V30.0688C38.6499 31.0063 37.7999 31.7751 36.7437 31.7751H23.7437V29.7438C23.7437 28.8001 24.5999 28.0376 25.6499 28.0376H38.6499Z",
                        fill: "#AE2A19"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_6742",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white",
                        transform: "translate(0.5)"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$b61109ed43b719cd = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_5805)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M45.1752 49.9126H14.8252V10.2563H30.1689L45.1752 25.0376V49.9126Z",
                        fill: "#FCA700",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M30.1631 10.2563V24.9938H45.1318L30.1631 10.2563Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.5381 29.8564H30.1631V34.0439H38.5381V29.8564Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M24.5818 34.7438C26.1248 34.7438 27.3756 33.4929 27.3756 31.95C27.3756 30.4071 26.1248 29.1562 24.5818 29.1562C23.0389 29.1562 21.7881 30.4071 21.7881 31.95C21.7881 33.4929 23.0389 34.7438 24.5818 34.7438Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M38.5381 40.4189H30.1631V44.6064H38.5381V40.4189Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M24.5818 45.3062C26.1248 45.3062 27.3756 44.0554 27.3756 42.5125C27.3756 40.9696 26.1248 39.7188 24.5818 39.7188C23.0389 39.7188 21.7881 40.9696 21.7881 42.5125C21.7881 44.0554 23.0389 45.3062 24.5818 45.3062Z",
                        fill: "white"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_5805",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$89158573528fcad1 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                clipPath: "url(#clip0_1_6101)",
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.2686 13.7749V40.1999H40.6936V13.7749H14.2686ZM25.5936 19.4499H35.0311V22.2812H25.5936V19.4499ZM25.5936 25.5687H35.0311V28.3999H25.5936V25.5687ZM20.8811 18.9624C21.9186 18.9624 22.7686 19.8124 22.7686 20.8499C22.7686 21.8874 21.9186 22.7374 20.8811 22.7374C19.8436 22.7374 18.9936 21.8937 18.9936 20.8499C18.9936 19.8062 19.8373 18.9624 20.8811 18.9624ZM20.8811 25.0999C21.9186 25.0999 22.7686 25.9437 22.7686 26.9874C22.7686 28.0312 21.9186 28.8749 20.8811 28.8749C19.8436 28.8749 18.9936 28.0312 18.9936 26.9874C18.9936 25.9437 19.8373 25.0999 20.8811 25.0999Z",
                        fill: "#1868DB"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        d: "M44.2812 30.0747V34.456H25.5938V43.3622H44.2812V48.6247L53.55 39.3435L44.2812 30.0747Z",
                        fill: "#BF63F3"
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M25.5938 34.4561V40.1998H40.6937V34.4561H25.5938Z",
                        fill: "#09326C"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("clipPath", {
                    id: "clip0_1_6101",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                        width: "60",
                        height: "60",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $4de1580172ce767e$export$2957996a5f53a712 = ()=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true",
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.svg
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M27.8323 16.5508C19.3609 16.5508 12.5 23.4185 12.5 31.883C12.5 38.2636 16.3973 43.7375 21.9456 46.0447V42.3436C21.9456 39.0891 24.5845 36.457 27.8323 36.457C31.08 36.457 33.7121 39.0958 33.7121 42.3436V46.0447C39.2604 43.7442 43.1645 38.2704 43.1645 31.883C43.1645 23.4117 36.2968 16.5508 27.8323 16.5508ZM27.8323 34.7993C25.0446 34.7993 22.7847 32.5394 22.7847 29.7517C22.7847 26.964 25.0378 24.7041 27.8323 24.7041C30.6267 24.7041 32.8731 26.9572 32.8731 29.7517C32.8731 32.5461 30.6199 34.7993 27.8323 34.7993Z",
                fill: "#BF63F3"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M37.3114 19.413L31.8984 22.1195L37.3114 24.826L40.0179 30.2389L42.7244 24.826L48.1374 22.1195L42.7244 19.413L40.0179 14L37.3114 19.413Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M42.0555 26.1655L40.0189 30.2388L37.3124 24.8258L31.8994 22.1193L36.9808 19.5752C39.2272 21.2532 41 23.5267 42.0555 26.1655Z",
                fill: "#AE2A19"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                d: "M36.9808 19.5752L31.8994 22.1193L37.3124 24.8258L40.0189 30.2388L42.0555 26.1655C41 23.5267 39.2272 21.2532 36.9808 19.5752Z",
                fill: "#AE2A19"
            })
        ]
    });
const $4de1580172ce767e$export$cb277cd1c06981d4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$var$ITSupportGlyph, {})
    });
};
const $4de1580172ce767e$export$966748bc0ae8d9a2 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$var$DesignGlyph, {})
    });
};
const $4de1580172ce767e$export$ddb421af37c7fad5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$a8475ed0ad467766, {})
    });
};
const $4de1580172ce767e$export$1c5b0383ec045924 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$var$SoftwareDevelopmentGlyph, {})
    });
};
const $4de1580172ce767e$export$711ab9ba848867b8 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$7a5074cf88127a64, {})
    });
};
const $4de1580172ce767e$export$162047bea11a6282 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$5a330511b92aac24, {})
    });
};
const $4de1580172ce767e$export$982ea2d26785cb86 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$2a1d70df8da1fa8a, {})
    });
};
const $4de1580172ce767e$export$76f950842b166c42 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$c3c91f9d6f32ce98, {})
    });
};
const $4de1580172ce767e$export$a8119f2277c08f44 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$a9941a16640f105a, {})
    });
};
const $4de1580172ce767e$export$ae563fd41f5cca8a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$b81d861c2dc0475e, {})
    });
};
const $4de1580172ce767e$export$e809d817369bee46 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$f2de52c1920eba82, {})
    });
};
const $4de1580172ce767e$export$3f7b13292eed3fe1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$816a17ab71a9c447, {})
    });
};
const $4de1580172ce767e$export$e142eb117e369c8f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$b6c5d967ad9baf32, {})
    });
};
const $4de1580172ce767e$export$a53784039f0a17d0 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$89a8de63b42b4bf7, {})
    });
};
const $4de1580172ce767e$export$d8b6fe79c3f35976 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$27ec4a87867305fc, {})
    });
};
const $4de1580172ce767e$export$86f8858d201b0f9e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$a9d1d41ede76da88, {})
    });
};
const $4de1580172ce767e$export$2037b55ec364c78 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$a10f1df78def0898, {})
    });
};
const $4de1580172ce767e$export$ddadca1ef61d72f4 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$e6598341d5f08715, {})
    });
};
const $4de1580172ce767e$export$294977ef66033c05 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$10c57db1e3cf8326, {})
    });
};
const $4de1580172ce767e$export$f491740eeb057ed5 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$925c822e766a0944, {})
    });
};
const $4de1580172ce767e$export$8ab8d8da70776293 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$c0094cf6ece486f3, {})
    });
};
const $4de1580172ce767e$export$cf4b8a9193cf22e1 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$526fd3870ee3978, {})
    });
};
const $4de1580172ce767e$export$fd9729397ff432bf = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$6361c44213db83a2, {})
    });
};
const $4de1580172ce767e$export$a2e400cb60027285 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$b5a9699d43e96f3e, {})
    });
};
const $4de1580172ce767e$export$bace2d8ac2cf2caa = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$9fe16602583dd125, {})
    });
};
const $4de1580172ce767e$export$e11bc36dd8a99125 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$6c259bad890ba857, {})
    });
};
const $4de1580172ce767e$export$72976b44f07f811b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$50a598674e46acd6, {})
    });
};
const $4de1580172ce767e$export$bfad4d4e8f73e77e = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$bc46f4026380149b, {})
    });
};
const $4de1580172ce767e$export$d3f781ec209b4fd7 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$2d48c6a000b33e3, {})
    });
};
const $4de1580172ce767e$export$bababd42ef961024 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$d2da7b6954e156a3, {})
    });
};
const $4de1580172ce767e$export$6efd0fa33b4aa14d = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$f6faf0bdc0af7562, {})
    });
};
const $4de1580172ce767e$export$6c12f9ab3896c60b = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$edf22519467780de, {})
    });
};
const $4de1580172ce767e$export$6de851e46e3b87af = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$8c7409f1554738f7, {})
    });
};
const $4de1580172ce767e$export$ab663870e0e1a3cd = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$b20b85b1cb35523d, {})
    });
};
const $4de1580172ce767e$export$3fb457a290d0178f = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$ab9f12136609e96a, {})
    });
};
const $4de1580172ce767e$export$1b11a71dd9d8f914 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$8aaa0b75bd31bddc, {})
    });
};
const $4de1580172ce767e$export$f2bd611053c3be8a = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$b61109ed43b719cd, {})
    });
};
const $4de1580172ce767e$export$f7c6a6f312b0247 = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$89158573528fcad1, {})
    });
};
const $4de1580172ce767e$export$f8101b6de63ddffb = ()=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("span", {
        "aria-hidden": true,
        className: (0, $esG4f.default)([
            $4de1580172ce767e$var$styles.container
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)($4de1580172ce767e$export$2957996a5f53a712, {})
    });
};


const $ece4c9a946b9caa5$export$390f94ade23c5f40 = "all-roles-eligible";
const $ece4c9a946b9caa5$export$2f3f9640393bd078 = "unknown";
const $ece4c9a946b9caa5$export$4c9a72dac5ce80ae = "";
// Roles defined in user segmentation
const $ece4c9a946b9caa5$var$USER_SEGMENTATION_ROLE_DESIGNER = "designer";
const $ece4c9a946b9caa5$export$572242e58bd07594 = "customer-service";
const $ece4c9a946b9caa5$export$d7de553940261eba = "it-support";
const $ece4c9a946b9caa5$export$4c29d0d04c15e55d = "human-resources";
const $ece4c9a946b9caa5$export$3950f7f841bf94b6 = "finance";
const $ece4c9a946b9caa5$export$881249b988b6030f = "legal";
const $ece4c9a946b9caa5$export$e4824f74b9879164 = "marketing";
const $ece4c9a946b9caa5$export$4f3cb0844009af52 = "operations";
const $ece4c9a946b9caa5$export$1a65d50c4a641bb4 = "sales";
const $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2 = "data-science";
const $ece4c9a946b9caa5$export$b8b1ac856ba1434b = "software-development";
const $ece4c9a946b9caa5$export$4f54a09a24fd1d74 = "product-management";
const $ece4c9a946b9caa5$export$79685802e8ff1098 = "project-management";
const $ece4c9a946b9caa5$export$e5c438b7501b5a24 = "design";
const $ece4c9a946b9caa5$export$cbc0e551d91a692d = "other-personal";
const $ece4c9a946b9caa5$export$53d2a515d824b589 = "skip";
const $ece4c9a946b9caa5$export$c44124f57672abc9 = {
    [$ece4c9a946b9caa5$export$b8b1ac856ba1434b]: "Software Development",
    [$ece4c9a946b9caa5$export$4f54a09a24fd1d74]: "Product Management",
    [$ece4c9a946b9caa5$export$79685802e8ff1098]: "Project Management",
    [$ece4c9a946b9caa5$export$d7de553940261eba]: "IT Support",
    [$ece4c9a946b9caa5$export$e5c438b7501b5a24]: "Design",
    [$ece4c9a946b9caa5$export$572242e58bd07594]: "Customer Service",
    [$ece4c9a946b9caa5$export$4c29d0d04c15e55d]: "Human Resources",
    [$ece4c9a946b9caa5$export$e4824f74b9879164]: "Marketing",
    [$ece4c9a946b9caa5$export$4f3cb0844009af52]: "Operations",
    [$ece4c9a946b9caa5$export$1a65d50c4a641bb4]: "Sales",
    [$ece4c9a946b9caa5$export$9ee64e8fbd8b03a2]: "Data Science",
    [$ece4c9a946b9caa5$export$3950f7f841bf94b6]: "Finance",
    [$ece4c9a946b9caa5$export$881249b988b6030f]: "Legal",
    [$ece4c9a946b9caa5$export$cbc0e551d91a692d]: "Other or Personal",
    [$ece4c9a946b9caa5$export$53d2a515d824b589]: "Skip"
};
const $ece4c9a946b9caa5$export$ec1d3db93f52890f = (teamType)=>{
    for (const [key, value] of Object.entries($ece4c9a946b9caa5$export$c44124f57672abc9)){
        if (value === teamType) return key;
    }
    return undefined;
};
const $ece4c9a946b9caa5$export$d9b98775fefed139 = {
    [$ece4c9a946b9caa5$export$b8b1ac856ba1434b]: "DEV",
    [$ece4c9a946b9caa5$export$d7de553940261eba]: "ITS",
    [$ece4c9a946b9caa5$export$e5c438b7501b5a24]: "DES",
    [$ece4c9a946b9caa5$export$572242e58bd07594]: "CS",
    [$ece4c9a946b9caa5$export$4c29d0d04c15e55d]: "HR",
    [$ece4c9a946b9caa5$export$e4824f74b9879164]: "MKT",
    [$ece4c9a946b9caa5$export$4f3cb0844009af52]: "OPS",
    [$ece4c9a946b9caa5$export$1a65d50c4a641bb4]: "SAL",
    [$ece4c9a946b9caa5$export$3950f7f841bf94b6]: "FNC",
    [$ece4c9a946b9caa5$export$881249b988b6030f]: "LGL",
    [$ece4c9a946b9caa5$export$cbc0e551d91a692d]: "OTR",
    [$ece4c9a946b9caa5$export$4f54a09a24fd1d74]: "PDM",
    [$ece4c9a946b9caa5$export$79685802e8ff1098]: "PJM",
    [$ece4c9a946b9caa5$export$9ee64e8fbd8b03a2]: "DS"
};
const $ece4c9a946b9caa5$export$e93f47abc92c60f6 = (teamType)=>{
    for (const [key, value] of Object.entries($ece4c9a946b9caa5$export$d9b98775fefed139)){
        if (key === teamType) return value;
    }
    return teamType;
};
const $ece4c9a946b9caa5$export$4d2c8de1ac60304f = (teamType)=>{
    switch(teamType){
        case $ece4c9a946b9caa5$export$b8b1ac856ba1434b:
            return "Software Development";
        case $ece4c9a946b9caa5$export$d7de553940261eba:
            return "IT Support";
        case $ece4c9a946b9caa5$export$e5c438b7501b5a24:
            return "Design";
        case $ece4c9a946b9caa5$export$572242e58bd07594:
            return "Customer Service";
        case $ece4c9a946b9caa5$export$4c29d0d04c15e55d:
            return "Human Resources";
        case $ece4c9a946b9caa5$export$e4824f74b9879164:
            return "Marketing";
        case $ece4c9a946b9caa5$export$4f3cb0844009af52:
            return "Operations";
        case $ece4c9a946b9caa5$export$1a65d50c4a641bb4:
            return "Sales";
        case $ece4c9a946b9caa5$export$3950f7f841bf94b6:
            return "Finance";
        case $ece4c9a946b9caa5$export$881249b988b6030f:
            return "Legal";
        case $ece4c9a946b9caa5$export$cbc0e551d91a692d:
            return "Other or Personal";
        case $ece4c9a946b9caa5$export$4f54a09a24fd1d74:
            return "Product Management";
        case $ece4c9a946b9caa5$export$79685802e8ff1098:
            return "Project Management";
        case $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2:
            return "Data Science";
        case $ece4c9a946b9caa5$export$53d2a515d824b589:
            return "Skip";
        default:
            return teamType;
    }
};
const $ece4c9a946b9caa5$export$47e4406b75d4e3e6 = (teamType)=>{
    switch(teamType){
        case $ece4c9a946b9caa5$export$b8b1ac856ba1434b:
            return 0, $4de1580172ce767e$export$e11bc36dd8a99125;
        case $ece4c9a946b9caa5$export$d7de553940261eba:
            return 0, $4de1580172ce767e$export$6c12f9ab3896c60b;
        case $ece4c9a946b9caa5$export$e5c438b7501b5a24:
            return 0, $4de1580172ce767e$export$d3f781ec209b4fd7;
        case $ece4c9a946b9caa5$export$572242e58bd07594:
            return 0, $4de1580172ce767e$export$ab663870e0e1a3cd;
        case $ece4c9a946b9caa5$export$4c29d0d04c15e55d:
            return 0, $4de1580172ce767e$export$6de851e46e3b87af;
        case $ece4c9a946b9caa5$export$e4824f74b9879164:
            return 0, $4de1580172ce767e$export$bfad4d4e8f73e77e;
        case $ece4c9a946b9caa5$export$4f3cb0844009af52:
            return 0, $4de1580172ce767e$export$6efd0fa33b4aa14d;
        case $ece4c9a946b9caa5$export$1a65d50c4a641bb4:
            return 0, $4de1580172ce767e$export$f2bd611053c3be8a;
        case $ece4c9a946b9caa5$export$3950f7f841bf94b6:
            return 0, $4de1580172ce767e$export$1b11a71dd9d8f914;
        case $ece4c9a946b9caa5$export$881249b988b6030f:
            return 0, $4de1580172ce767e$export$3fb457a290d0178f;
        case $ece4c9a946b9caa5$export$cbc0e551d91a692d:
            return 0, $4de1580172ce767e$export$f8101b6de63ddffb;
        case $ece4c9a946b9caa5$export$4f54a09a24fd1d74:
            return 0, $4de1580172ce767e$export$72976b44f07f811b;
        case $ece4c9a946b9caa5$export$79685802e8ff1098:
            return 0, $4de1580172ce767e$export$bababd42ef961024;
        case $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2:
            return 0, $4de1580172ce767e$export$f7c6a6f312b0247;
        default:
            return null;
    }
};
const $ece4c9a946b9caa5$export$241841e14023c14a = (teamType, formatMessage)=>{
    switch(teamType){
        case $ece4c9a946b9caa5$export$b8b1ac856ba1434b:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.softwareDevelopment",
                defaultMessage: "Software development"
            });
        case $ece4c9a946b9caa5$export$d7de553940261eba:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.itSupport",
                defaultMessage: "IT support"
            });
        case $ece4c9a946b9caa5$export$e5c438b7501b5a24:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.design",
                defaultMessage: "Design"
            });
        case $ece4c9a946b9caa5$export$572242e58bd07594:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.customerService",
                defaultMessage: "Customer service"
            });
        case $ece4c9a946b9caa5$export$4c29d0d04c15e55d:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.humanResources",
                defaultMessage: "Human resources"
            });
        case $ece4c9a946b9caa5$export$e4824f74b9879164:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.marketing",
                defaultMessage: "Marketing"
            });
        case $ece4c9a946b9caa5$export$4f3cb0844009af52:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.operations",
                defaultMessage: "Operations"
            });
        case $ece4c9a946b9caa5$export$1a65d50c4a641bb4:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.sales",
                defaultMessage: "Sales"
            });
        case $ece4c9a946b9caa5$export$3950f7f841bf94b6:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.finance",
                defaultMessage: "Finance"
            });
        case $ece4c9a946b9caa5$export$881249b988b6030f:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.legal",
                defaultMessage: "Legal"
            });
        case $ece4c9a946b9caa5$export$cbc0e551d91a692d:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.otherOrPersonal",
                defaultMessage: "Other"
            });
        case $ece4c9a946b9caa5$export$4f54a09a24fd1d74:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.productManagement",
                defaultMessage: "Product management"
            });
        case $ece4c9a946b9caa5$export$79685802e8ff1098:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.projectManagement",
                defaultMessage: "Project management"
            });
        case $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2:
            return formatMessage({
                id: "UserSeg.teamTypeSelection.dataScience",
                defaultMessage: "Data science"
            });
        default:
            return teamType;
    }
};
const $ece4c9a946b9caa5$export$9b10a383fdd95886 = {
    [$ece4c9a946b9caa5$export$4c29d0d04c15e55d]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$3950f7f841bf94b6]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$881249b988b6030f]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$e4824f74b9879164]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$4f3cb0844009af52]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$1a65d50c4a641bb4]: [
        $ece4c9a946b9caa5$export$390f94ade23c5f40
    ],
    [$ece4c9a946b9caa5$export$b8b1ac856ba1434b]: [
        $ece4c9a946b9caa5$var$USER_SEGMENTATION_ROLE_DESIGNER
    ]
};
const $ece4c9a946b9caa5$export$7b099dc6b5bc8ba7 = [
    $ece4c9a946b9caa5$export$e4824f74b9879164,
    $ece4c9a946b9caa5$export$e5c438b7501b5a24,
    $ece4c9a946b9caa5$export$4f3cb0844009af52,
    $ece4c9a946b9caa5$export$79685802e8ff1098,
    $ece4c9a946b9caa5$export$4c29d0d04c15e55d,
    $ece4c9a946b9caa5$export$572242e58bd07594,
    $ece4c9a946b9caa5$export$881249b988b6030f,
    $ece4c9a946b9caa5$export$3950f7f841bf94b6,
    $ece4c9a946b9caa5$export$1a65d50c4a641bb4
];
const $ece4c9a946b9caa5$export$e762c1129e037c3c = [
    $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2,
    $ece4c9a946b9caa5$export$cbc0e551d91a692d,
    $ece4c9a946b9caa5$export$b8b1ac856ba1434b,
    $ece4c9a946b9caa5$export$4f54a09a24fd1d74,
    $ece4c9a946b9caa5$export$d7de553940261eba
];
const $ece4c9a946b9caa5$export$b07956d58f1245f1 = [
    $ece4c9a946b9caa5$export$4c29d0d04c15e55d,
    $ece4c9a946b9caa5$export$3950f7f841bf94b6,
    $ece4c9a946b9caa5$export$881249b988b6030f,
    $ece4c9a946b9caa5$export$e4824f74b9879164,
    $ece4c9a946b9caa5$export$4f3cb0844009af52,
    $ece4c9a946b9caa5$export$1a65d50c4a641bb4,
    $ece4c9a946b9caa5$export$b8b1ac856ba1434b
];
const $ece4c9a946b9caa5$export$3c81c899da0f27c0 = [
    $ece4c9a946b9caa5$export$b8b1ac856ba1434b,
    $ece4c9a946b9caa5$export$4f54a09a24fd1d74,
    $ece4c9a946b9caa5$export$d7de553940261eba,
    $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2,
    $ece4c9a946b9caa5$export$e5c438b7501b5a24,
    $ece4c9a946b9caa5$export$79685802e8ff1098,
    $ece4c9a946b9caa5$export$572242e58bd07594,
    $ece4c9a946b9caa5$export$cbc0e551d91a692d
];
const $ece4c9a946b9caa5$export$b33247277ad6a292 = [
    $ece4c9a946b9caa5$export$572242e58bd07594,
    $ece4c9a946b9caa5$export$d7de553940261eba,
    $ece4c9a946b9caa5$export$4c29d0d04c15e55d,
    $ece4c9a946b9caa5$export$3950f7f841bf94b6,
    $ece4c9a946b9caa5$export$881249b988b6030f,
    $ece4c9a946b9caa5$export$e4824f74b9879164,
    $ece4c9a946b9caa5$export$4f3cb0844009af52,
    $ece4c9a946b9caa5$export$1a65d50c4a641bb4,
    $ece4c9a946b9caa5$export$b8b1ac856ba1434b,
    $ece4c9a946b9caa5$export$e5c438b7501b5a24,
    $ece4c9a946b9caa5$export$4f54a09a24fd1d74,
    $ece4c9a946b9caa5$export$79685802e8ff1098,
    $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2,
    $ece4c9a946b9caa5$export$cbc0e551d91a692d,
    $ece4c9a946b9caa5$export$53d2a515d824b589
];
const $ece4c9a946b9caa5$export$3709503ef3102dbe = {
    [$ece4c9a946b9caa5$export$79685802e8ff1098]: [
        "Project Management"
    ],
    [$ece4c9a946b9caa5$export$4f54a09a24fd1d74]: [
        "Product Management"
    ],
    [$ece4c9a946b9caa5$export$9ee64e8fbd8b03a2]: [
        "Data Science"
    ],
    [$ece4c9a946b9caa5$export$cbc0e551d91a692d]: [
        "Other or Personal"
    ],
    [$ece4c9a946b9caa5$var$USER_SEGMENTATION_ROLE_DESIGNER]: [
        "Designer",
        "Disainer",
        "Dise\xf1ador",
        "Formgivare",
        "Nh\xe0 thi\u1EBFt k\u1EBF",
        "Projektant",
        "Suunnittelija",
        "Tasar\u0131mc\u0131",
        "Tervez\u0151",
        "\u0414\u0438\u0437\u0430\u0439\u043D\u0435\u0440",
        "\u0E19\u0E31\u0E01\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A",
        "\u30C7\u30B6\u30A4\u30CA\u30FC",
        "\u8A2D\u8A08\u5E2B",
        "\u8BBE\u8BA1\u5E08",
        "\uB514\uC790\uC774\uB108"
    ],
    [$ece4c9a946b9caa5$export$e5c438b7501b5a24]: [
        "Design"
    ],
    [$ece4c9a946b9caa5$export$572242e58bd07594]: [
        "Asiakaspalvelu",
        "Atendimento ao cliente",
        "Customer Service",
        "D\u1ECBch v\u1EE5 kh\xe1ch h\xe0ng",
        "Klantenservice",
        "Klienditeenindus",
        "Kundenservice",
        "Kundeservice",
        "Kundservice",
        "M\xfc\u015Fteri Hizmetleri",
        "Obs\u0142uga klienta",
        "Service \xe0 la client\xe8le",
        "Servicio de atenci\xf3n al cliente",
        "Servizio clienti",
        "Servi\xe7o de apoio ao cliente",
        "Z\xe1kaznick\xfd servis",
        "Z\xe1kazn\xedcky servis",
        "\xdcgyf\xe9lszolg\xe1lati",
        "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438 \u043A\u043B\u0456\u0454\u043D\u0442\u0456\u0432",
        "\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E25\u0E39\u0E01\u0E04\u0E49\u0E32",
        "\u30AB\u30B9\u30BF\u30DE\u30FC \u30B5\u30FC\u30D3\u30B9",
        "\u5BA2\u6237\u670D\u52A1",
        "\u9867\u5BA2\u670D\u52D9",
        "\uACE0\uAC1D \uC11C\uBE44\uC2A4"
    ],
    [$ece4c9a946b9caa5$export$d7de553940261eba]: [
        "Assistenza IT",
        "BT Deste\u011Fi",
        "H\u1ED7 tr\u1EE3 CNTT",
        "IT",
        "IT Support",
        "IT podpora",
        "IT \u30B5\u30DD\u30FC\u30C8",
        "IT \u652F\u6301",
        "IT \u652F\u63F4",
        "IT \uC9C0\uC6D0",
        "IT_Support",
        "IT_st\xf8tte",
        "IT_support",
        "IT_tugi",
        "IT_tuki",
        "Informatikai t\xe1mogat\xe1si",
        "Soporte de TI",
        "Suporte de TI",
        "Support\xa0IT",
        "Wsparcie IT",
        "\u0418\u0422-\u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0430",
        "\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u0435\u0445\u043D\u0456\u0447\u043D\u043E\u0457 \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u043A\u0438",
        "\u0E1D\u0E48\u0E32\u0E22\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19 IT"
    ],
    [$ece4c9a946b9caa5$export$3950f7f841bf94b6]: [
        "Ekonomi",
        "Finance",
        "Financeiro",
        "Financie",
        "Finans",
        "Finanse",
        "Finants",
        "Finanza",
        "Finanzas",
        "Finanzen",
        "Finan\xe7as",
        "P\xe9nz\xfcgyi",
        "Rahoitus",
        "T\xe0i ch\xednh",
        "\xd8konomi",
        "\u0424\u0438\u043D\u0430\u043D\u0441\u044B",
        "\u0424\u0456\u043D\u0430\u043D\u0441\u0438",
        "\u0E01\u0E32\u0E23\u0E40\u0E07\u0E34\u0E19",
        "\u8CA1\u52D9",
        "\u91D1\u878D",
        "\uC7AC\uBB34"
    ],
    [$ece4c9a946b9caa5$export$4c29d0d04c15e55d]: [
        "HR",
        "Henkil\xf6st\xf6hallinto",
        "Human Resources",
        "Human resources",
        "human-resources",
        // for Upaas
        "Lidsk\xe9 zdroje",
        "Menneskelige ressourcer",
        "Nh\xe2n s\u1EF1",
        "Personal",
        "Personalfr\xe5gor",
        "RH",
        "Recursos Humanos",
        "Recursos humanos",
        "Risorse umane",
        "Szem\xe9lyzeti",
        "Zasoby ludzkie",
        "\u0130nsan Kaynaklar\u0131",
        "\u013Dudsk\xe9 zdroje",
        "\u0412\u0456\u0434\u0434\u0456\u043B \u043A\u0430\u0434\u0440\u0456\u0432",
        "\u041A\u0430\u0434\u0440\u043E\u0432\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E32\u0E01\u0E23\u0E1A\u0E38\u0E04\u0E04\u0E25",
        "\u4EBA\u4E8B",
        "\u4EBA\u529B\u8CC7\u6E90",
        "\u4EBA\u529B\u8D44\u6E90",
        "\uC778\uC0AC"
    ],
    [$ece4c9a946b9caa5$export$881249b988b6030f]: [
        "Departamento jur\xeddico",
        "Hukuk",
        "Jogi",
        "Jura",
        "Juridik",
        "Juridisk",
        "Jur\xeddico",
        "Legal",
        "Legale",
        "Oikeudelliset asiat",
        "Ph\xe1p l\xfd",
        "Prawo",
        "Pr\xe1vne oddelenie",
        "Pr\xe1vn\xed odd\u011Blen\xed",
        "Rechtliches",
        "Service juridique",
        "\xd5igus",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u042E\u0440\u0438\u0434\u0438\u0447\u043D\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u0E01\u0E0E\u0E2B\u0E21\u0E32\u0E22",
        "\u6CD5\u52D9",
        "\u6CD5\u5F8B",
        "\uBC95\uB960"
    ],
    [$ece4c9a946b9caa5$export$e4824f74b9879164]: [
        "Markedsf\xf8ring",
        "Marketing",
        "Markkinointi",
        "Marknadsf\xf6ring",
        "Pazarlama",
        "Ti\u1EBFp th\u1ECB",
        "Turundus",
        "\u041C\u0430\u0440\u043A\u0435\u0442\u0438\u043D\u0433",
        "\u0E01\u0E32\u0E23\u0E15\u0E25\u0E32\u0E14",
        "\u30DE\u30FC\u30B1\u30C6\u30A3\u30F3\u30B0",
        "\u8425\u9500",
        "\u884C\u92B7",
        "\uB9C8\uCF00\uD305"
    ],
    [$ece4c9a946b9caa5$export$4f3cb0844009af52]: [
        "Drift",
        "Haldus",
        "Operacional",
        "Operaciones",
        "Operacje",
        "Operasyonlar",
        "Operations",
        "Operativer Betrieb",
        "Operazioni",
        "Opera\xe7\xf5es",
        "Op\xe9rations",
        "Prev\xe1dzka",
        "Provoz",
        "Toiminnot",
        "V\u1EADn h\xe0nh",
        "\xdczemeltet\xe9si",
        "\u0412\u0438\u0440\u043E\u0431\u043D\u0438\u0447\u0438\u0439 \u0432\u0456\u0434\u0434\u0456\u043B",
        "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B",
        "\u0E1D\u0E48\u0E32\u0E22\u0E1B\u0E0F\u0E34\u0E1A\u0E31\u0E15\u0E34\u0E01\u0E32\u0E23",
        "\u30AA\u30DA\u30EC\u30FC\u30B7\u30E7\u30F3",
        "\u71DF\u904B",
        "\u8FD0\u8425",
        "\uC6B4\uC601"
    ],
    [$ece4c9a946b9caa5$export$1a65d50c4a641bb4]: [
        "B\xe1n h\xe0ng",
        "F\xf6rs\xe4ljning",
        "Myynti",
        "M\xfc\xfck",
        "Predaj",
        "Prodej",
        "Sales",
        "Salg",
        "Sat\u0131\u015F",
        "Sprzeda\u017C",
        "Vendas",
        "Vendite",
        "Ventas",
        "Ventes",
        "Vertrieb",
        "\xc9rt\xe9kes\xedt\xe9si",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
        "\u041F\u0440\u043E\u0434\u0430\u0436\u0456",
        "\u0E1D\u0E48\u0E32\u0E22\u0E02\u0E32\u0E22",
        "\u30BB\u30FC\u30EB\u30B9",
        "\u92B7\u552E",
        "\u9500\u552E",
        "\uC601\uC5C5"
    ],
    [$ece4c9a946b9caa5$export$b8b1ac856ba1434b]: [
        "Desarrollo de software",
        "Desenvolvimento de software",
        "D\xe9veloppement logiciel",
        "Ohjelmistokehitys",
        "Ph\xe1t tri\u1EC3n ph\u1EA7n m\u1EC1m",
        "Programutveckling",
        "Programvareutvikling",
        "Software Development",
        "Softwareentwicklung",
        "Softwareontwikkeling",
        "Softwareudvikling",
        "Sviluppo software",
        "Szoftverfejleszt\u0151",
        "Tarkvaraarendus",
        "Tworzenie oprogramowania",
        "V\xfdvoj softv\xe9ru",
        "V\xfdvoj softwaru",
        "Yaz\u0131l\u0131m Geli\u015Ftirme",
        "\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0430 \u041F\u041E",
        "\u0420\u043E\u0437\u0440\u043E\u0431\u043A\u0430 \u041F\u0417",
        "\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C",
        "\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u958B\u767A",
        "\u8EDF\u9AD4\u958B\u767C",
        "\u8F6F\u4EF6\u5F00\u53D1",
        "\uC18C\uD504\uD2B8\uC6E8\uC5B4 \uAC1C\uBC1C"
    ]
};



var $iSvIT = parcelRequire("iSvIT");

const $2f0845e5c94f1a46$export$7383f122bf48ec30 = typeof window !== "undefined" && typeof Document !== "undefined" && typeof HTMLElement !== "undefined";
function $2f0845e5c94f1a46$export$f65ca476c09acec0(node) {
    if (!node && typeof node !== "undefined") return null;
    if (node) {
        if (node.ownerDocument) return node.ownerDocument;
        else if (typeof node.getRootNode === "function") {
            const root = node.getRootNode();
            if (root && "defaultView" in root) return root;
        }
    } else if (typeof document !== "undefined") return document;
    return null;
}
function $2f0845e5c94f1a46$export$38b2d434cce3ea22(node) {
    if (!node && typeof node !== "undefined") return null;
    if (node) {
        const document1 = $2f0845e5c94f1a46$export$f65ca476c09acec0(node);
        if (document1) return document1.defaultView;
    } else if (typeof window !== "undefined") return window;
    else if (typeof document !== "undefined") return document.defaultView;
    return null;
}
function $2f0845e5c94f1a46$export$b4f920f5692db1b8(node, type = Node) {
    if (node instanceof type) return true;
    const window1 = $2f0845e5c94f1a46$export$38b2d434cce3ea22(node);
    if (window1) type = window1[type.name] || type;
    return node instanceof type;
}
function $2f0845e5c94f1a46$export$20b9b571b379d631(node, predicate) {
    while(node){
        if (predicate(node)) return node;
        node = node.parentElement;
    }
    return null;
}
function $2f0845e5c94f1a46$export$f8c04f9996c8b964(node) {
    if (!$2f0845e5c94f1a46$export$7383f122bf48ec30) return null;
    if ($2f0845e5c94f1a46$export$b4f920f5692db1b8(node, Document)) node = node.documentElement;
    if (!$2f0845e5c94f1a46$export$b4f920f5692db1b8(node, HTMLElement)) return null;
    return $2f0845e5c94f1a46$export$20b9b571b379d631(node, (node)=>{
        const { overflowX: overflowX, overflowY: overflowY } = getComputedStyle(node);
        if (overflowX === "scroll") return true;
        if (overflowY === "scroll") return true;
        return false;
    });
}



const $840236e27dba5bd6$var$BXP_ANCHOR_COOKIE_NAME = "bxp_gateway_anchor";
const $840236e27dba5bd6$var$GWP_LOCAL_STORAGE_NAME = "onboarding-journey";
const $840236e27dba5bd6$var$COOKIE_EXPIRY = 604800; // 7 days
function $840236e27dba5bd6$export$4f045d9519647348(value) {
    (0, $iSvIT.useEffect)(()=>{
        updateLocalStorage(value);
    }, [
        value
    ]);
    return {
        getAnchorLocalStorage: ()=>{
            return (0, $2f0845e5c94f1a46$export$7383f122bf48ec30) && (0, $2c637c10bc35918d$export$d3720feff416e85b)($840236e27dba5bd6$var$GWP_LOCAL_STORAGE_NAME);
        },
        setAnchorLocalStorage: updateLocalStorage
    };
    /* Create or update localstorage.
   * create : Using bxp_anchor_cookie, if present, if not present, create with ampty anchor object {anchor: {}}
   * update : Using existing localstorage, or existing cookie and persona value passed.
   */ function updateLocalStorage(value) {
        if (0, $2f0845e5c94f1a46$export$7383f122bf48ec30) {
            const bxpGatewayAnchorCookie = (0, $c3163505721bf9af$export$2e2bcd8739ae039).get($840236e27dba5bd6$var$BXP_ANCHOR_COOKIE_NAME);
            const journeyLocalStorage = (0, $2c637c10bc35918d$export$d3720feff416e85b)($840236e27dba5bd6$var$GWP_LOCAL_STORAGE_NAME);
            try {
                const bxpGatewayAnchorObj = JSON.parse(bxpGatewayAnchorCookie || "null");
                const currentLocalStorageObj = JSON.parse(journeyLocalStorage || "null");
                const anchorStorage = currentLocalStorageObj ? {
                    ...currentLocalStorageObj,
                    ...value
                } : bxpGatewayAnchorObj ? {
                    anchor: {
                        name: bxpGatewayAnchorObj?.anchor,
                        type: bxpGatewayAnchorObj?.type
                    },
                    ...value
                } : {};
                (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)($840236e27dba5bd6$var$GWP_LOCAL_STORAGE_NAME, JSON.stringify(anchorStorage), $840236e27dba5bd6$var$COOKIE_EXPIRY);
            } catch (err) {
                console.error("Error creating local storage", err);
            }
        }
    }
}


const $9b5fc39e27a98d2d$export$c9702f0bb31ba3c1 = ()=>{
    const { getAnchorLocalStorage: getAnchorLocalStorage } = (0, $840236e27dba5bd6$export$4f045d9519647348)();
    const anchorLocalStorage = getAnchorLocalStorage();
    if (anchorLocalStorage) try {
        const localStorageObj = JSON.parse(anchorLocalStorage);
        return $9b5fc39e27a98d2d$export$e1cfb7bf8d6e409(localStorageObj.team);
    } catch (e) {
        return undefined;
    }
    return undefined;
};
const $9b5fc39e27a98d2d$export$e1cfb7bf8d6e409 = (teamType)=>{
    switch(teamType){
        case "Marketing":
            return "marketing";
        case "Operations":
            return "operations";
        case "HR":
            return "human-resources";
        case "Design":
            return "design";
        case "Program Management":
            return undefined;
        case "Software Engineering":
            return "software-engineering";
        case "Customer Service":
            return "customer-service";
        case "Legal":
            return "legal";
        case "Finance":
            return `finance`;
        case "Sales":
            return "sales";
        case "IT Support":
            return "it-support";
        case "Software Development":
            return "software-development";
        default:
            return undefined;
    }
};


const $dd36a66a5d1abea9$export$82f756bfe5bba24e = {
    [(0, $ece4c9a946b9caa5$export$b8b1ac856ba1434b)]: "SOFTWARE_DEVELOPMENT",
    [(0, $ece4c9a946b9caa5$export$d7de553940261eba)]: "IT_SUPPORT",
    [(0, $ece4c9a946b9caa5$export$e5c438b7501b5a24)]: "DESIGN",
    [(0, $ece4c9a946b9caa5$export$572242e58bd07594)]: "CUSTOMER_SERVICE",
    [(0, $ece4c9a946b9caa5$export$4c29d0d04c15e55d)]: "HUMAN_RESOURCES",
    [(0, $ece4c9a946b9caa5$export$4f3cb0844009af52)]: "OPERATIONS",
    [(0, $ece4c9a946b9caa5$export$1a65d50c4a641bb4)]: "SALES",
    [(0, $ece4c9a946b9caa5$export$3950f7f841bf94b6)]: "FINANCE",
    [(0, $ece4c9a946b9caa5$export$881249b988b6030f)]: "LEGAL",
    [(0, $ece4c9a946b9caa5$export$cbc0e551d91a692d)]: "OTHER",
    [(0, $ece4c9a946b9caa5$export$e4824f74b9879164)]: "MARKETING",
    [(0, $ece4c9a946b9caa5$export$9ee64e8fbd8b03a2)]: "DATA_SCIENCE",
    [(0, $ece4c9a946b9caa5$export$4f54a09a24fd1d74)]: "PRODUCT_MANAGEMENT",
    [(0, $ece4c9a946b9caa5$export$79685802e8ff1098)]: "PROJECT_MANAGEMENT",
    "software-engineering": "SOFTWARE_ENGINEERING"
};
const $dd36a66a5d1abea9$export$a1f86f8a748f57da = (jtbd)=>{
    return jtbd.filter(({ isChecked: isChecked })=>isChecked).map(({ value: value })=>value);
};
const $dd36a66a5d1abea9$export$644da7ba1500a73c = (teamType)=>{
    for (const [key, value] of Object.entries($dd36a66a5d1abea9$export$82f756bfe5bba24e)){
        if (key === teamType) return value;
    }
    return undefined;
};
function $dd36a66a5d1abea9$export$eb068a7cf20a51ae() {
    return (0, $iSvIT.useContext)($dd36a66a5d1abea9$var$GupsContext);
}
const $dd36a66a5d1abea9$var$GupsContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    addTeamTypeCallback: async ()=>undefined,
    getUserProfileJobFunctionCallback: async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        }),
    getFullProfileCallback: async ()=>({
            data: undefined,
            error: undefined
        }),
    addJtbdCallback: async ()=>undefined,
    addTemplateCallback: async ()=>undefined,
    addTenantIdCallback: async ()=>undefined,
    getProfileSitesCallback: async ()=>undefined,
    linkAccountToAnonymousIdCallback: async ()=>undefined,
    addTemplateCardCallback: async ()=>undefined,
    getProfileCallback: async ()=>undefined,
    getAnonProfileSitesCallback: async ()=>undefined,
    getAccountProfileRecommendationsCallback: async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        }),
    addMatureExampleProjectIdsCallback: async ()=>undefined
});
const $dd36a66a5d1abea9$export$a5989227294cd90a = ({ children: children })=>{
    const gupsClient = (0, $iSvIT.useMemo)(()=>new (0, $76c319390ad3fbd7$export$d1ae200e149aadbf)(), []);
    const { accountId: accountId } = (0, $784ebd6898abdb6b$export$aae23f3a65fbe750)();
    const client = (0, $9e7dba6014f411d3$export$923054f18cb06572)();
    const anonymousId = (0, $iSvIT.useMemo)(()=>client?.getAnonymousId() ?? undefined, [
        client
    ]);
    const teamTypeFromLocalStorage = (0, $9b5fc39e27a98d2d$export$c9702f0bb31ba3c1)();
    const addTeamTypeCallback = (0, $iSvIT.useCallback)(async (selectedTeamType)=>{
        try {
            const gupsTeamType = $dd36a66a5d1abea9$export$644da7ba1500a73c(selectedTeamType);
            if (!gupsTeamType) return {
                error: {
                    message: `There is not a GUPS mapping for team type ${selectedTeamType}`
                }
            };
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                teamType: gupsTeamType
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getUserProfileJobFunctionCallback = (0, $iSvIT.useCallback)(async (useCase)=>{
        if (!accountId) return {
            requestInProgress: true,
            data: undefined,
            error: undefined
        };
        const { data: profile, error: error } = await gupsClient.getProfile({
            accountId: accountId
        }, [
            (0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE_JOB_FUNCTION
        ], useCase);
        return {
            requestInProgress: false,
            data: profile?.userProfile,
            error: error
        };
    }, [
        gupsClient,
        accountId
    ]);
    const getFullProfileCallback = (0, $iSvIT.useCallback)(async ()=>{
        const { data: profile, error: error } = await gupsClient.getProfile({
            accountId: accountId
        }, [
            (0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_PROFILE,
            (0, $32fd1e468d40477e$export$89720e8460cd3d04).USER_FOOTPRINTS,
            (0, $32fd1e468d40477e$export$89720e8460cd3d04).SITES,
            (0, $32fd1e468d40477e$export$89720e8460cd3d04).ONBOARDING_CONTEXT
        ]);
        return {
            data: profile,
            error: error
        };
    }, [
        gupsClient,
        accountId
    ]);
    const addJtbdCallback = (0, $iSvIT.useCallback)(async (jtbd, template)=>{
        try {
            const gupsJtbd = $dd36a66a5d1abea9$export$a1f86f8a748f57da(jtbd);
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                jobsToBeDone: gupsJtbd,
                                template: template
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const addTemplateCallback = (0, $iSvIT.useCallback)(async (template)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                template: template
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const addTenantIdCallback = (0, $iSvIT.useCallback)(async (tenantId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    tenantId: tenantId,
                    unifiedProfile: {}
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId
    ]);
    const getProfileCallback = (0, $iSvIT.useCallback)(async (abortSignal)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                anonymousId: anonymousId
            }, [
                (0, $32fd1e468d40477e$export$89720e8460cd3d04).PAID_CHANNEL_CONTEXT
            ], undefined, // optionalHeaderUseCase
            abortSignal);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            // Don't log AbortErrors as they're expected when requests are cancelled
            if (error instanceof Error && error.name !== "AbortError") console.error("Error getting GUPS profile", error);
            return {
                error: error
            };
        }
    }, [
        anonymousId,
        gupsClient
    ]);
    const getProfileSitesCallback = (0, $iSvIT.useCallback)(async (accountId)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                accountId: accountId
            }, [
                (0, $32fd1e468d40477e$export$89720e8460cd3d04).SITES
            ]);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            console.error("Error getting profile sites GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const linkAccountToAnonymousIdCallback = (0, $iSvIT.useCallback)(async ()=>{
        try {
            if (accountId && anonymousId) {
                const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                    profile: {
                        accountId: accountId,
                        anonymousId: anonymousId,
                        unifiedProfile: {}
                    }
                });
                return {
                    updatedProfile: updatedProfile,
                    error: error
                };
            } else {
                console.info(`Account ID or Anonymous ID is missing, ${accountId} ${anonymousId}`);
                return;
            }
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getAnonProfileSitesCallback = (0, $iSvIT.useCallback)(async (anonymousId, useCase)=>{
        try {
            const { data: profile, error: error } = await gupsClient.getProfile({
                anonymousId: anonymousId
            }, [
                (0, $32fd1e468d40477e$export$89720e8460cd3d04).SITES
            ], useCase);
            return {
                data: profile,
                error: error
            };
        } catch (error) {
            console.error("Error getting profile sites GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const addTemplateCardCallback = (0, $iSvIT.useCallback)(async (templateId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    unifiedProfile: {
                        onboardingContext: {
                            confluence: {
                                template: templateId
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    const getAccountProfileRecommendationsCallback = (0, $iSvIT.useCallback)(async (accountId, useCase)=>{
        if (!accountId) return {
            requestInProgress: true,
            data: undefined,
            error: undefined
        };
        try {
            const { data: profile, error: error } = await gupsClient.getAccountProfile({
                accountId: accountId
            }, [
                (0, $32fd1e468d40477e$export$c52306273ead3f).RECOMMENDATIONS
            ], useCase);
            return {
                requestInProgress: false,
                data: profile?.recommendations,
                error: error
            };
        } catch (error) {
            console.error("Error getting account profile recommendations GUPS", error);
            return {
                requestInProgress: false,
                data: undefined,
                error: error
            };
        }
    }, [
        gupsClient
    ]);
    const addMatureExampleProjectIdsCallback = (0, $iSvIT.useCallback)(async (matureExampleProjectIds, tenantId)=>{
        try {
            const { data: updatedProfile, error: error } = await gupsClient.updateProfile({
                profile: {
                    accountId: accountId,
                    anonymousId: anonymousId,
                    tenantId: tenantId,
                    unifiedProfile: {
                        onboardingContext: {
                            jira: {
                                matureExampleProjectIds: matureExampleProjectIds ?? []
                            }
                        }
                    }
                }
            });
            return {
                updatedProfile: updatedProfile,
                error: error
            };
        } catch (error) {
            console.error("Error updating user profile in GUPS", error);
            return {
                error: error
            };
        }
    }, [
        gupsClient,
        accountId,
        anonymousId
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (teamTypeFromLocalStorage) addTeamTypeCallback(teamTypeFromLocalStorage);
    }, [
        teamTypeFromLocalStorage,
        addTeamTypeCallback
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($dd36a66a5d1abea9$var$GupsContext.Provider, {
        value: {
            addTeamTypeCallback: addTeamTypeCallback,
            getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback,
            getAccountProfileRecommendationsCallback: getAccountProfileRecommendationsCallback,
            getFullProfileCallback: getFullProfileCallback,
            addJtbdCallback: addJtbdCallback,
            addTemplateCallback: addTemplateCallback,
            getProfileSitesCallback: getProfileSitesCallback,
            addTenantIdCallback: addTenantIdCallback,
            linkAccountToAnonymousIdCallback: linkAccountToAnonymousIdCallback,
            addTemplateCardCallback: addTemplateCardCallback,
            getProfileCallback: getProfileCallback,
            getAnonProfileSitesCallback: getAnonProfileSitesCallback,
            addMatureExampleProjectIdsCallback: addMatureExampleProjectIdsCallback
        },
        children: children
    });
};
const $dd36a66a5d1abea9$export$f25f416c3b92de8 = ({ mockResponse: mockResponse, children: children })=>{
    const addTeamTypeCallback = async ()=>undefined;
    const getUserProfileJobFunctionCallback = async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        });
    const getFullProfileCallback = async ()=>({
            data: undefined,
            error: undefined
        });
    const addJtbdCallback = async ()=>undefined;
    const addTemplateCallback = async ()=>undefined;
    const addTenantIdCallback = async ()=>undefined;
    const getProfileSitesCallback = async ()=>undefined;
    const linkAccountToAnonymousIdCallback = async ()=>undefined;
    const addTemplateCardCallback = async ()=>undefined;
    const getProfileCallback = async ()=>undefined;
    const getAnonProfileSitesCallback = async ()=>{
        return Promise.resolve(mockResponse);
    };
    const getAccountProfileRecommendationsCallback = async ()=>({
            requestInProgress: true,
            data: undefined,
            error: undefined
        });
    const addMatureExampleProjectIdsCallback = async ()=>undefined;
    return /*#__PURE__*/ (0, $loA2J.jsx)($dd36a66a5d1abea9$var$GupsContext.Provider, {
        value: {
            addTeamTypeCallback: addTeamTypeCallback,
            getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback,
            getFullProfileCallback: getFullProfileCallback,
            addJtbdCallback: addJtbdCallback,
            addTemplateCallback: addTemplateCallback,
            getProfileSitesCallback: getProfileSitesCallback,
            addTenantIdCallback: addTenantIdCallback,
            linkAccountToAnonymousIdCallback: linkAccountToAnonymousIdCallback,
            addTemplateCardCallback: addTemplateCardCallback,
            getProfileCallback: getProfileCallback,
            getAnonProfileSitesCallback: getAnonProfileSitesCallback,
            getAccountProfileRecommendationsCallback: getAccountProfileRecommendationsCallback,
            addMatureExampleProjectIdsCallback: addMatureExampleProjectIdsCallback
        },
        children: children
    });
};






const $a69c6ceceedb3a08$var$isProductionEnvironment = true;
const $a69c6ceceedb3a08$var$commonLocales = [
    "br",
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "nl",
    "pl",
    "ru",
    "zh"
];
const $a69c6ceceedb3a08$var$nonProdLocales = [
    "xx",
    "zz"
];
const $a69c6ceceedb3a08$var$VALID_LOCALES = $a69c6ceceedb3a08$var$isProductionEnvironment ? $a69c6ceceedb3a08$var$commonLocales : [
    ...$a69c6ceceedb3a08$var$commonLocales,
    ...$a69c6ceceedb3a08$var$nonProdLocales
];
const $a69c6ceceedb3a08$export$b7c662043e31af59 = (locale)=>$a69c6ceceedb3a08$var$VALID_LOCALES.includes(locale);
const $a69c6ceceedb3a08$export$44f112d5a3138d7 = (pathname)=>{
    const regex = new RegExp(`^/(${$a69c6ceceedb3a08$var$VALID_LOCALES.join("|")})`);
    return pathname.replace(regex, "");
};
const $a69c6ceceedb3a08$export$ac1033a4026dfcef = (pathname_a, pathname_b)=>{
    if (!pathname_a || !pathname_b) return false;
    const a = $a69c6ceceedb3a08$export$44f112d5a3138d7(pathname_a);
    const b = $a69c6ceceedb3a08$export$44f112d5a3138d7(pathname_b);
    return a === b;
};




var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");



var $iSvIT = parcelRequire("iSvIT");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $4a217ebe5384b05a$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;





var $iSvIT = parcelRequire("iSvIT");
/**
 * See if React major version is 17+ by parsing version string.
 */ function $0c25a157220ae55c$export$a87138b73900f5b(reactVersion) {
    const reactMajor = reactVersion.match(/^([^.]+)/);
    return reactMajor !== null && parseInt(reactMajor[0]) >= 17;
}
/**
 * Recurse through `error.cause` chain to set cause on an error.
 */ function $0c25a157220ae55c$export$bc95048bc211a673(error, cause) {
    const seenErrors = new WeakSet();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) return;
        if (error.cause) {
            seenErrors.add(error);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * Captures an error that was thrown by a React ErrorBoundary or React root.
 *
 * @param error The error to capture.
 * @param errorInfo The errorInfo provided by React.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $0c25a157220ae55c$export$270be4195468cda9(// eslint-disable-next-line @typescript-eslint/no-explicit-any
error, { componentStack: componentStack }, hint) {
    // If on React version >= 17, create stack trace from componentStack param and links
    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
    // Linking errors requires the `LinkedErrors` integration be enabled.
    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
    //
    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
    // with non-error objects. This is why we need to check if the error is an error-like object.
    // See: https://github.com/getsentry/sentry-javascript/issues/6167
    if ($0c25a157220ae55c$export$a87138b73900f5b((0, $iSvIT.version)) && (0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(error) && componentStack) {
        const errorBoundaryError = new Error(error.message);
        errorBoundaryError.name = `React ErrorBoundary ${error.name}`;
        errorBoundaryError.stack = componentStack;
        // Using the `LinkedErrors` integration to link the errors together.
        $0c25a157220ae55c$export$bc95048bc211a673(error, errorBoundaryError);
    }
    return (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
        scope.setContext("react", {
            componentStack: componentStack
        });
        return (0, $54ca942ea01c8aa7$export$f5282963edea4a68)(error, hint);
    });
}
/**
 * Creates an error handler that can be used with the `onCaughtError`, `onUncaughtError`,
 * and `onRecoverableError` options in `createRoot` and `hydrateRoot` React DOM methods.
 *
 * @param callback An optional callback that will be called after the error is captured.
 * Use this to add custom handling for errors.
 *
 * @example
 *
 * ```JavaScript
 * const root = createRoot(container, {
 *  onCaughtError: Sentry.reactErrorHandler(),
 *  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
 *    console.warn('Caught error', error, errorInfo.componentStack);
 *  });
 * });
 * ```
 */ function $0c25a157220ae55c$export$1e6f045b27b3cfb1(// eslint-disable-next-line @typescript-eslint/no-explicit-any
callback) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (error, errorInfo)=>{
        const eventId = $0c25a157220ae55c$export$270be4195468cda9(error, errorInfo);
        if (callback) callback(error, errorInfo, eventId);
    };
}



var $lgqAv = parcelRequire("lgqAv");
// Ensure we use the default export from hoist-non-react-statics if available,
// falling back to the module itself. This handles both ESM and CJS usage.
const $3888747138cd6a4e$export$6c1f0397687d8b2 = $lgqAv.default || $lgqAv;


const $f69cc9a15d796ccd$export$6ef4c0367e27f2d5 = "unknown";
const $f69cc9a15d796ccd$var$INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
/**
 * A ErrorBoundary component that logs errors to Sentry.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ class $f69cc9a15d796ccd$export$e926676385687eaf extends $iSvIT.Component {
    constructor(props){
        super(props);
        this.state = $f69cc9a15d796ccd$var$INITIAL_STATE;
        this._openFallbackReportDialog = true;
        const client = (0, $35358b2c9a559011$export$6bb76d6eba7e258c)();
        if (client && props.showDialog) {
            this._openFallbackReportDialog = false;
            this._cleanupHook = client.on("afterSendEvent", (event)=>{
                if (!event.type && this._lastEventId && event.event_id === this._lastEventId) (0, $1ce9d2c01f92d810$export$3a8fd680da42627b)({
                    ...props.dialogOptions,
                    eventId: this._lastEventId
                });
            });
        }
    }
    componentDidCatch(error, errorInfo) {
        const { componentStack: componentStack } = errorInfo;
        const { beforeCapture: beforeCapture, onError: onError, showDialog: showDialog, dialogOptions: dialogOptions } = this.props;
        (0, $35358b2c9a559011$export$ec58d9285c204497)((scope)=>{
            if (beforeCapture) beforeCapture(scope, error, componentStack);
            const handled = this.props.handled != null ? this.props.handled : !!this.props.fallback;
            const eventId = (0, $0c25a157220ae55c$export$270be4195468cda9)(error, errorInfo, {
                mechanism: {
                    handled: handled
                }
            });
            if (onError) onError(error, componentStack, eventId);
            if (showDialog) {
                this._lastEventId = eventId;
                if (this._openFallbackReportDialog) (0, $1ce9d2c01f92d810$export$3a8fd680da42627b)({
                    ...dialogOptions,
                    eventId: eventId
                });
            }
            // componentDidCatch is used over getDerivedStateFromError
            // so that componentStack is accessible through state.
            this.setState({
                error: error,
                componentStack: componentStack,
                eventId: eventId
            });
        });
    }
    componentDidMount() {
        const { onMount: onMount } = this.props;
        if (onMount) onMount();
    }
    componentWillUnmount() {
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) {
            if (this.state === $f69cc9a15d796ccd$var$INITIAL_STATE) // If the error boundary never encountered an error, call onUnmount with null values
            onUnmount(null, null, null);
            else // `componentStack` and `eventId` are guaranteed to be non-null here because `onUnmount` is only called
            // when the error boundary has already encountered an error.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            onUnmount(error, componentStack, eventId);
        }
        if (this._cleanupHook) {
            this._cleanupHook();
            this._cleanupHook = undefined;
        }
    }
    resetErrorBoundary() {
        const { onReset: onReset } = this.props;
        const { error: error, componentStack: componentStack, eventId: eventId } = this.state;
        if (onReset) // `componentStack` and `eventId` are guaranteed to be non-null here because `onReset` is only called
        // when the error boundary has already encountered an error.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        onReset(error, componentStack, eventId);
        this.setState($f69cc9a15d796ccd$var$INITIAL_STATE);
    }
    render() {
        const { fallback: fallback, children: children } = this.props;
        const state = this.state;
        // `componentStack` is only null in the initial state, when no error has been captured.
        // If an error has been captured, `componentStack` will be a string.
        // We cannot check `state.error` because null can be thrown as an error.
        if (state.componentStack === null) return typeof children === "function" ? children() : children;
        const element = typeof fallback === "function" ? $iSvIT.createElement(fallback, {
            error: state.error,
            componentStack: state.componentStack,
            resetError: ()=>this.resetErrorBoundary(),
            eventId: state.eventId
        }) : fallback;
        if ($iSvIT.isValidElement(element)) return element;
        if (fallback) (0, $4a217ebe5384b05a$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).warn("fallback did not produce a valid ReactElement");
        // Fail gracefully if no fallback provided or is not valid
        return null;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f69cc9a15d796ccd$export$f0c7a449e0cfaec7(WrappedComponent, errorBoundaryOptions) {
    const componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || $f69cc9a15d796ccd$export$6ef4c0367e27f2d5;
    const Wrapped = (props)=>$iSvIT.createElement($f69cc9a15d796ccd$export$e926676385687eaf, {
            ...errorBoundaryOptions
        }, $iSvIT.createElement(WrappedComponent, {
            ...props
        }));
    Wrapped.displayName = `errorBoundary(${componentDisplayName})`;
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    (0, $3888747138cd6a4e$export$6c1f0397687d8b2)(Wrapped, WrappedComponent);
    return Wrapped;
}








const $c831f91244ac11cf$var$INTEGRATION_NAME = "ExtraErrorData";
/**
 * Extract additional data for from original exceptions.
 */ const $c831f91244ac11cf$var$_extraErrorDataIntegration = (options = {})=>{
    const { depth: depth = 3, captureErrorCause: captureErrorCause = true } = options;
    return {
        name: $c831f91244ac11cf$var$INTEGRATION_NAME,
        processEvent (event, hint, client) {
            const { maxValueLength: maxValueLength = 250 } = client.getOptions();
            return $c831f91244ac11cf$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause, maxValueLength);
        }
    };
};
const $c831f91244ac11cf$export$6e0872131894301d = (0, $16575ede9e208d34$export$2323046b9414659f)($c831f91244ac11cf$var$_extraErrorDataIntegration);
function $c831f91244ac11cf$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause, maxValueLength) {
    if (!hint.originalException || !(0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $c831f91244ac11cf$var$_extractErrorData(hint.originalException, captureErrorCause, maxValueLength);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $e493a5d50143afb5$export$a3295358bff77e)(errorData, depth);
        if ((0, $64d77030f0d405c5$export$53b83ca8eaab0383)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $ac73fe157e02a9a2$export$e73679ffaf56810e)(normalizedErrorData, "__sentry_skip_normalization__", true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $c831f91244ac11cf$var$_extractErrorData(error, captureErrorCause, maxValueLength) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            "name",
            "message",
            "stack",
            "line",
            "column",
            "fileName",
            "lineNumber",
            "columnNumber",
            "toJSON"
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(value) || typeof value === "string" ? (0, $e0c4ed16d3d4a5dd$export$6a506b36fdea397d)(`${value}`, maxValueLength) : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === "function") {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $64d77030f0d405c5$export$e6127cc7fe7395c3)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $9f8bd953fbcf4578$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error("Unable to extract extra data from the Error object:", oO);
    }
    return null;
}




/**
 * Ordered LRU cache for storing feature flags in the scope context. The name
 * of each flag in the buffer is unique, and the output of getAll() is ordered
 * from oldest to newest.
 */ /**
 * Max size of the LRU flag buffer stored in Sentry scope and event contexts.
 */ const $2784cf4dd7a9622b$export$b05e0452e895457f = 100;
/**
 * Copies feature flags that are in current scope context to the event context
 */ function $2784cf4dd7a9622b$export$3f36d80a1ce833bc(event) {
    const scope = (0, $35358b2c9a559011$export$c7be4b0125a10cba)();
    const flagContext = scope.getScopeData().contexts.flags;
    const flagBuffer = flagContext ? flagContext.values : [];
    if (!flagBuffer.length) return event;
    if (event.contexts === undefined) event.contexts = {};
    event.contexts.flags = {
        values: [
            ...flagBuffer
        ]
    };
    return event;
}
/**
 * Creates a feature flags values array in current context if it does not exist
 * and inserts the flag into a FeatureFlag array while maintaining ordered LRU
 * properties. Not thread-safe. After inserting:
 * - `flags` is sorted in order of recency, with the newest flag at the end.
 * - No other flags with the same name exist in `flags`.
 * - The length of `flags` does not exceed `maxSize`. The oldest flag is evicted
 *  as needed.
 *
 * @param name     Name of the feature flag to insert.
 * @param value    Value of the feature flag.
 * @param maxSize  Max number of flags the buffer should store. It's recommended
 *   to keep this consistent across insertions. Default is FLAG_BUFFER_SIZE
 */ function $2784cf4dd7a9622b$export$7f29556d51128184(name, value, maxSize = $2784cf4dd7a9622b$export$b05e0452e895457f) {
    const scopeContexts = (0, $35358b2c9a559011$export$c7be4b0125a10cba)().getScopeData().contexts;
    if (!scopeContexts.flags) scopeContexts.flags = {
        values: []
    };
    const flags = scopeContexts.flags.values;
    $2784cf4dd7a9622b$export$af975e54ae906042(flags, name, value, maxSize);
}
/**
 * Exported for tests. Currently only accepts boolean values (otherwise no-op).
 */ function $2784cf4dd7a9622b$export$af975e54ae906042(flags, name, value, maxSize) {
    if (typeof value !== "boolean") return;
    if (flags.length > maxSize) {
        (0, $4f31ecb266c05841$export$16a28057038b10ef) && (0, $398c2530c60234a2$export$af88d00dbe7f521).error(`[Feature Flags] insertToFlagBuffer called on a buffer larger than maxSize=${maxSize}`);
        return;
    }
    // Check if the flag is already in the buffer - O(n)
    const index = flags.findIndex((f)=>f.flag === name);
    if (index !== -1) // The flag was found, remove it from its current position - O(n)
    flags.splice(index, 1);
    if (flags.length === maxSize) // If at capacity, pop the earliest flag - O(n)
    flags.shift();
    // Push the flag to the end - O(1)
    flags.push({
        flag: name,
        result: value
    });
}


/**
 * Sentry integration for buffering feature flags manually with an API, and
 * capturing them on error events. We recommend you do this on each flag
 * evaluation. Flags are buffered per Sentry scope and limited to 100 per event.
 *
 * See the [feature flag documentation](https://develop.sentry.dev/sdk/expected-features/#feature-flags) for more information.
 *
 * @example
 * ```
 * import * as Sentry from '@sentry/browser';
 * import { type FeatureFlagsIntegration } from '@sentry/browser';
 *
 * // Setup
 * Sentry.init(..., integrations: [Sentry.featureFlagsIntegration()])
 *
 * // Verify
 * const flagsIntegration = Sentry.getClient()?.getIntegrationByName<FeatureFlagsIntegration>('FeatureFlags');
 * if (flagsIntegration) {
 *   flagsIntegration.addFeatureFlag('my-flag', true);
 * } else {
 *   // check your setup
 * }
 * Sentry.captureException(Exception('broke')); // 'my-flag' should be captured to this Sentry event.
 * ```
 */ const $f4b44d17526600c1$export$82a435367bc83944 = (0, $16575ede9e208d34$export$2323046b9414659f)(()=>{
    return {
        name: "FeatureFlags",
        processEvent (event, _hint, _client) {
            return (0, $2784cf4dd7a9622b$export$3f36d80a1ce833bc)(event);
        },
        addFeatureFlag (name, value) {
            (0, $2784cf4dd7a9622b$export$7f29556d51128184)(name, value);
        }
    };
});




var $iSvIT = parcelRequire("iSvIT");
/**
 * Inits the React SDK
 */ function $7435bd31779b056a$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $ca504204fb9d9dd1$export$b9f95b027256052c)(opts, "react");
    (0, $54ca942ea01c8aa7$export$2f04de43fe27971a)("react", {
        version: $iSvIT.version
    });
    return (0, $1ce9d2c01f92d810$export$2cd8252107eb640b)(opts);
}


/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $lgqAv = parcelRequire("lgqAv");

var $9z2vN = parcelRequire("9z2vN");

var $iSvIT = parcelRequire("iSvIT");

var $gnUbQ = parcelRequire("gnUbQ");

var $8NEa0 = parcelRequire("8NEa0");
function $c38e0ddda19098ca$export$45c4bbf6e55bba1f(intl) {
    (0, $gnUbQ.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $c38e0ddda19098ca$export$b52f8d6fc0d47415 = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $8NEa0.DEFAULT_INTL_CONFIG)), {
    textComponent: $iSvIT.Fragment
});
function $c38e0ddda19098ca$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($iSvIT.Children.toArray(parts));
    };
}
function $c38e0ddda19098ca$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}


function $6158b15813153029$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $6158b15813153029$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $iSvIT.createContext(null)) : $iSvIT.createContext(null);
var $6158b15813153029$var$IntlConsumer = $6158b15813153029$var$IntlContext.Consumer, $6158b15813153029$var$IntlProvider = $6158b15813153029$var$IntlContext.Provider;
var $6158b15813153029$export$2881499e37b75b9a = $6158b15813153029$var$IntlProvider;
var $6158b15813153029$export$841858b892ce1f4c = $6158b15813153029$var$IntlContext;
function $6158b15813153029$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $iSvIT.createElement($6158b15813153029$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $c38e0ddda19098ca$export$45c4bbf6e55bba1f)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $iSvIT.createElement(WrappedComponent, (0, $9z2vN.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($6158b15813153029$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))($iSvIT.forwardRef(function(props, ref) {
        return $iSvIT.createElement(WithIntl, (0, $9z2vN.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lgqAv)))(WithIntl, WrappedComponent);
}




var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");
var $6e1b5a8a085c6188$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "currencyDisplay",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem"
];
function $6e1b5a8a085c6188$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $8NEa0.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $8NEa0.filterProps)(options, $6e1b5a8a085c6188$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $6e1b5a8a085c6188$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e1b5a8a085c6188$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $6e1b5a8a085c6188$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $6e1b5a8a085c6188$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}



var $8NEa0 = parcelRequire("8NEa0");

var $oJsBd = parcelRequire("oJsBd");

var $lP6cc = parcelRequire("lP6cc");
var $26e1438fdb22b59f$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $26e1438fdb22b59f$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $8NEa0.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $8NEa0.filterProps)(options, $26e1438fdb22b59f$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $26e1438fdb22b59f$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $oJsBd.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $oJsBd.ErrorCode).MISSING_INTL_API));
    try {
        return $26e1438fdb22b59f$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}



var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");
var $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $36f41d4057fef16a$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $8NEa0.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $36f41d4057fef16a$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $36f41d4057fef16a$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $36f41d4057fef16a$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $8NEa0.filterProps)(options, $36f41d4057fef16a$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $lP6cc.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $36f41d4057fef16a$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $36f41d4057fef16a$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $36f41d4057fef16a$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $lP6cc.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}



var $8NEa0 = parcelRequire("8NEa0");

var $lP6cc = parcelRequire("lP6cc");

var $oJsBd = parcelRequire("oJsBd");
var $956a1411e62c10a5$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $956a1411e62c10a5$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $oJsBd.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $oJsBd.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $956a1411e62c10a5$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $lP6cc.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}



var $9z2vN = parcelRequire("9z2vN");

var $gnUbQ = parcelRequire("gnUbQ");

var $94939 = parcelRequire("94939");

var $lP6cc = parcelRequire("lP6cc");
parcelRequire("i2ZbQ");
var $jLPqv = parcelRequire("jLPqv");
function $e18381280b7ed4c1$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $e18381280b7ed4c1$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $94939.IntlMessageFormat).formats;
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, mfFormats), f1), {
        date: $e18381280b7ed4c1$var$deepMergeOptions($e18381280b7ed4c1$var$setTimeZoneInOptions(mfFormats.date, timeZone), $e18381280b7ed4c1$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $e18381280b7ed4c1$var$deepMergeOptions($e18381280b7ed4c1$var$setTimeZoneInOptions(mfFormats.time, timeZone), $e18381280b7ed4c1$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $e18381280b7ed4c1$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $gnUbQ.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $jLPqv.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, defaultRichTextElements), values || {});
    formats = $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $e18381280b7ed4c1$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $lP6cc.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $lP6cc.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $9z2vN.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lP6cc.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $lP6cc.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};



var $9z2vN = parcelRequire("9z2vN");

var $8NEa0 = parcelRequire("8NEa0");

var $oJsBd = parcelRequire("oJsBd");

var $lP6cc = parcelRequire("lP6cc");
var $60c0c779a0799aa5$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $60c0c779a0799aa5$var$now = Date.now();
function $60c0c779a0799aa5$var$generateToken(i) {
    return "".concat($60c0c779a0799aa5$var$now, "_").concat(i, "_").concat($60c0c779a0799aa5$var$now);
}
function $60c0c779a0799aa5$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $60c0c779a0799aa5$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $60c0c779a0799aa5$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $oJsBd.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $oJsBd.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $60c0c779a0799aa5$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $60c0c779a0799aa5$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $lP6cc.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}



var $8NEa0 = parcelRequire("8NEa0");

var $oJsBd = parcelRequire("oJsBd");

var $lP6cc = parcelRequire("lP6cc");
var $a5802b8e5e82fef6$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $a5802b8e5e82fef6$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $oJsBd.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $oJsBd.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $8NEa0.filterProps)(options, $a5802b8e5e82fef6$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $lP6cc.IntlFormatError)("Error formatting display name.", locale, e));
    }
}


function $d9b5b6d11e6fa77c$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $d9b5b6d11e6fa77c$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $d9b5b6d11e6fa77c$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $d9b5b6d11e6fa77c$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $8NEa0.createFormatters)(cache);
    var resolvedConfig = (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $8NEa0.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $lP6cc.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lP6cc.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $lP6cc.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $d9b5b6d11e6fa77c$var$verifyConfigMessages(resolvedConfig);
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $6e1b5a8a085c6188$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $6e1b5a8a085c6188$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $26e1438fdb22b59f$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $36f41d4057fef16a$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $36f41d4057fef16a$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $36f41d4057fef16a$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $36f41d4057fef16a$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $36f41d4057fef16a$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $956a1411e62c10a5$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $e18381280b7ed4c1$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $e18381280b7ed4c1$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $60c0c779a0799aa5$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $60c0c779a0799aa5$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $a5802b8e5e82fef6$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}


var $8NEa0 = parcelRequire("8NEa0");

var $j2lh9 = parcelRequire("j2lh9");
function $fdb2f4b8d9026d6d$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $fdb2f4b8d9026d6d$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $j2lh9.isFormatXMLElementFn)(v) ? (0, $c38e0ddda19098ca$export$cfec03d26465fa63)(v) : v;
        return acc;
    }, {});
}
var $fdb2f4b8d9026d6d$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $fdb2f4b8d9026d6d$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $e18381280b7ed4c1$export$25868d1e8e76735f).apply(void 0, (0, $9z2vN.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $iSvIT.Children.toArray(chunks);
    return chunks;
};
var $fdb2f4b8d9026d6d$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $9z2vN.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $fdb2f4b8d9026d6d$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $d9b5b6d11e6fa77c$export$7e4cbedfdd7b4c0d)((0, $9z2vN.__assign)((0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, (0, $c38e0ddda19098ca$export$b52f8d6fc0d47415)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $9z2vN.__assign)((0, $9z2vN.__assign)({}, coreIntl), {
        // @ts-expect-error fix this
        formatMessage: $fdb2f4b8d9026d6d$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $fdb2f4b8d9026d6d$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
var $fdb2f4b8d9026d6d$var$IntlProvider = /** @class */ function(_super) {
    (0, $9z2vN.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $8NEa0.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: $fdb2f4b8d9026d6d$export$7e4cbedfdd7b4c0d($fdb2f4b8d9026d6d$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $fdb2f4b8d9026d6d$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $fdb2f4b8d9026d6d$var$processIntlConfig(props);
        if (!(0, $c38e0ddda19098ca$export$d36bdfa510afb180)(prevConfig, config)) return {
            intl: $fdb2f4b8d9026d6d$export$7e4cbedfdd7b4c0d(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $c38e0ddda19098ca$export$45c4bbf6e55bba1f)(this.state.intl);
        return $iSvIT.createElement((0, $6158b15813153029$export$2881499e37b75b9a), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $c38e0ddda19098ca$export$b52f8d6fc0d47415);
    return IntlProvider;
}($iSvIT.PureComponent);
var $fdb2f4b8d9026d6d$export$2e2bcd8739ae039 = $fdb2f4b8d9026d6d$var$IntlProvider;


var $iSvIT = parcelRequire("iSvIT");


function $afebd26722242ed6$export$2e2bcd8739ae039() {
    var intl = $iSvIT.useContext((0, $6158b15813153029$export$841858b892ce1f4c));
    (0, $c38e0ddda19098ca$export$45c4bbf6e55bba1f)(intl);
    return intl;
}



function $6b7216eca35f2e84$export$6af88e6f54add681(allCookies) {
    let atlCohortId;
    try {
        const atlCohort = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("atlCohort", allCookies);
        atlCohortId = JSON.parse(atlCohort || "")?.bucketAll?.index;
        if (!atlCohortId) return undefined;
        const atlCohortInit = parseInt(atlCohortId);
        if (isNaN(atlCohortInit) || atlCohortInit < 0) return undefined;
        return atlCohortInit;
    } catch (error) {
        return undefined;
    }
}


function $1f12900928d868ac$var$getRawCookie(name, allCookies) {
    const value = `; ${allCookies}`;
    const parts = value.split(`; ${name}=`);
    return parts.length === 2 ? parts.pop() : undefined;
}
function $1f12900928d868ac$var$getEdgeTraceId(allCookies) {
    const edgeTraceIdValue = $1f12900928d868ac$var$getRawCookie("X-Experiments-Trace-Id", allCookies);
    if (edgeTraceIdValue) {
        // Get the portion before the next semicolon
        const cookieValue = edgeTraceIdValue.split(";").shift();
        return cookieValue;
    }
    return undefined;
}
function $1f12900928d868ac$var$getAnonymousId(allCookies) {
    const anonIdValue = $1f12900928d868ac$var$getRawCookie("ajs_anonymous_id", allCookies);
    if (anonIdValue) {
        // Get the portion before the next semicolon
        let cookieValue = anonIdValue.split(";").shift();
        // Check if cookieValue is not undefined and remove %22 before and 22% after
        if (cookieValue) cookieValue = cookieValue.replace(/%22/g, "");
        else console.log("Unable to retrieve a cookie value");
        return cookieValue;
    }
    return undefined;
}
function $1f12900928d868ac$export$48374a0929d11425() {
    try {
        const intl = (0, $afebd26722242ed6$export$2e2bcd8739ae039)();
        return intl.locale === "en";
    } catch (e) {
        console.error("Failed to determine current locale", e);
        return false;
    }
}
const $1f12900928d868ac$export$9784340db4c235a8 = (props)=>{
    (0, $iSvIT.useEffect)(()=>{
        $7435bd31779b056a$export$2cd8252107eb640b({
            dsn: "https://a48c5247caec7a2e0ad0b8ef86376ee1@o55978.ingest.sentry.io/4505919063457792",
            enabled: true,
            environment: "production",
            release: window.BUILD_KEY,
            dist: window.BUILD_KEY,
            integrations: [
                $040cc7132a09aab4$export$b4109253475213e9(),
                $c831f91244ac11cf$export$6e0872131894301d(),
                $f4b44d17526600c1$export$82a435367bc83944()
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0,
            // Capture 100% of the transactions, reduce in production!
            // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
            tracePropagationTargets: [
                "localhost",
                /^https:\/\/atlassian\.com/
            ],
            // https://github.com/getsentry/sentry-javascript/issues/2514#issuecomment-603971338
            beforeSend: (event, hint)=>{
                if (hint.originalException === "Timeout") return null;
                // Filter out AbortErrors as they're expected when users navigate away
                // Check direct AbortError
                if (hint.originalException instanceof Error && hint.originalException.name === "AbortError") return null;
                // Check for AbortError in message
                const errorMessage = String(event.exception?.values?.[0]?.value || "");
                if (errorMessage.includes("AbortError") || errorMessage.includes("The user aborted a request") || errorMessage.includes("user aborted")) return null;
                return event;
            },
            ignoreErrors: [
                /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/
            ]
        });
    }, []);
    try {
        // used to tag back first introduction of errors to a unique deploy / commit
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("BUILD_KEY", window.BUILD_KEY);
    } catch (e) {
        console.error("Failed to add BUILD KEY");
    }
    try {
        // used to help identify the route, page, and variant that the user is on.
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("entryName", window.entryName);
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("cmsPageVariant", window.cmsPageVariant);
    } catch (e) {
        console.error("Failed to add route info");
    }
    // Set the anonymousId tag for Sentry
    try {
        const anonymousId = $1f12900928d868ac$var$getAnonymousId(props.cookies ?? "");
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("anonymousId", anonymousId);
    } catch (e) {
        console.error("Failed to add anonymousId tag to Sentry");
    }
    // Set the edgeTraceId tag for Sentry
    try {
        const edgeTraceId = $1f12900928d868ac$var$getEdgeTraceId(props.cookies ?? "");
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("edgeTraceId", edgeTraceId);
    } catch (e) {
        console.error("Failed to add edgeTraceId tag to Sentry");
    }
    try {
        // Retrieve anonymousId from cookie
        const anonymousId = $1f12900928d868ac$var$getAnonymousId(props.cookies ?? "");
        const atlCohortId = (0, $6b7216eca35f2e84$export$6af88e6f54add681)(props.cookies) || -1;
        $54ca942ea01c8aa7$export$8b6bb3dd62a01be2({
            anonymousId: anonymousId,
            atlCohortId: atlCohortId
        });
        $54ca942ea01c8aa7$export$a37d07ee78eb4569("atlCohortId", atlCohortId);
    } catch (e) {
        console.error("Failed to add anonymousId and atlCohort tags to Sentry");
        console.error(e);
    }
    return /*#__PURE__*/ (0, $loA2J.jsx)($f69cc9a15d796ccd$export$e926676385687eaf, {
        //@ts-ignore
        beforeCapture: (scope)=>{
            scope.setTag("service", "wac-web-fe");
        },
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fdb2f4b8d9026d6d$export$2e2bcd8739ae039), {
            locale: props.locale,
            messages: props.messages,
            children: props.children
        })
    });
};



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
const $4afb343f3a1dfc96$var$SSRLoginStateContext = /*#__PURE__*/ (0, $iSvIT.createContext)({
    hasCloudSessionTokenCookie: false
});
const $4afb343f3a1dfc96$export$6576c6d702d8a9f7 = ()=>{
    const context = (0, $iSvIT.useContext)($4afb343f3a1dfc96$var$SSRLoginStateContext);
    if (!context) throw new Error("useSSRLoginState must be used within SSRLoginStateProvider");
    return context;
};
const $4afb343f3a1dfc96$export$936443f499340574 = ({ children: children, hasCloudSessionTokenCookie: hasCloudSessionTokenCookie = false, userAgent: userAgent })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)($4afb343f3a1dfc96$var$SSRLoginStateContext.Provider, {
        value: {
            hasCloudSessionTokenCookie: hasCloudSessionTokenCookie,
            userAgent: userAgent
        },
        children: children
    });
};



var $iSvIT = parcelRequire("iSvIT");
const $b96ee0edfbd3981f$export$2b96349243a56116 = (mobileWidthInPx = 640)=>{
    const [width, setWidth] = (0, $iSvIT.useState)(window.innerWidth);
    const handleWindowSizeChange = ()=>{
        setWidth(window.innerWidth);
    };
    (0, $iSvIT.useEffect)(()=>{
        window.addEventListener("resize", handleWindowSizeChange);
        return ()=>{
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, []);
    const isMobile = width <= mobileWidthInPx;
    return isMobile;
};



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
var $0408bc06a3af4f0c$export$994164cf3ae1cc9a = /*#__PURE__*/ function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
    return ExperienceTypes;
}({});
var $0408bc06a3af4f0c$export$cc26007c03242fff = /*#__PURE__*/ function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
    return ExperiencePerformanceTypes;
}({});

function $1de0794c104113b9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $1de0794c104113b9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1de0794c104113b9$export$2e2bcd8739ae039(o);
}



function $ed5b75582ec77fe2$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $1de0794c104113b9$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $1de0794c104113b9$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $1643d6e1f3a41da2$export$2e2bcd8739ae039(t) {
    var i = (0, $ed5b75582ec77fe2$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $1de0794c104113b9$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $839113eed049216c$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $1643d6e1f3a41da2$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $839113eed049216c$export$2e2bcd8739ae039(e, r, t) {
    return r && $839113eed049216c$var$_defineProperties(e.prototype, r), t && $839113eed049216c$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $43619c9bde236c7c$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $d2bedbf8ecb09049$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $3e33e5de1191bf4e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $1de0794c104113b9$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $d2bedbf8ecb09049$export$2e2bcd8739ae039)(t);
}


function $4c00befe917e94e5$export$2e2bcd8739ae039(t) {
    return $4c00befe917e94e5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $4c00befe917e94e5$export$2e2bcd8739ae039(t);
}


function $adfc1833ea13a525$export$2e2bcd8739ae039(t, e) {
    return $adfc1833ea13a525$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $adfc1833ea13a525$export$2e2bcd8739ae039(t, e);
}


function $eb3a12d72d57d08a$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $adfc1833ea13a525$export$2e2bcd8739ae039)(t, e);
}


function $fbb1ceeb982e72a2$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $de6e5986487d1f1e$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $fbb1ceeb982e72a2$export$2e2bcd8739ae039)(r);
}


function $3465594b4aa451b6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $d4658915d72b4e96$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $fbb1ceeb982e72a2$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $fbb1ceeb982e72a2$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $f9ee37605bf3bd31$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e348efdbedbe52e5$export$2e2bcd8739ae039(r) {
    return (0, $de6e5986487d1f1e$export$2e2bcd8739ae039)(r) || (0, $3465594b4aa451b6$export$2e2bcd8739ae039)(r) || (0, $d4658915d72b4e96$export$2e2bcd8739ae039)(r) || (0, $f9ee37605bf3bd31$export$2e2bcd8739ae039)();
}


function $67326748cb2694e4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $67326748cb2694e4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $67326748cb2694e4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $67326748cb2694e4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}





function $a29d2f74af926769$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $1643d6e1f3a41da2$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $874aead080e6b5b5$exports = {};
// TODO(Babel 8): Remove this file.

var $874aead080e6b5b5$var$runtime = (parcelRequire("8DOyJ"))();
$874aead080e6b5b5$exports = $874aead080e6b5b5$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $874aead080e6b5b5$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $874aead080e6b5b5$var$runtime;
    else Function("r", "regeneratorRuntime = r")($874aead080e6b5b5$var$runtime);
}


var $4ec87579fa058e6d$exports = {};
var $55e1719c49769f7f$exports = {};
var $a768e2ca68d9cc0d$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $a768e2ca68d9cc0d$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($a768e2ca68d9cc0d$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $a768e2ca68d9cc0d$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $a768e2ca68d9cc0d$exports = function whatwgRNG() {
        $a768e2ca68d9cc0d$var$getRandomValues($a768e2ca68d9cc0d$var$rnds8);
        return $a768e2ca68d9cc0d$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $a768e2ca68d9cc0d$var$rnds = new Array(16);
    $a768e2ca68d9cc0d$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $a768e2ca68d9cc0d$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $a768e2ca68d9cc0d$var$rnds;
    };
}


var $86009cfde4820d5f$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $86009cfde4820d5f$var$byteToHex = [];
for(var $86009cfde4820d5f$var$i = 0; $86009cfde4820d5f$var$i < 256; ++$86009cfde4820d5f$var$i)$86009cfde4820d5f$var$byteToHex[$86009cfde4820d5f$var$i] = ($86009cfde4820d5f$var$i + 0x100).toString(16).substr(1);
function $86009cfde4820d5f$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $86009cfde4820d5f$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$86009cfde4820d5f$exports = $86009cfde4820d5f$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $55e1719c49769f7f$var$_nodeId;
var $55e1719c49769f7f$var$_clockseq;
// Previous uuid creation time
var $55e1719c49769f7f$var$_lastMSecs = 0;
var $55e1719c49769f7f$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $55e1719c49769f7f$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $55e1719c49769f7f$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $55e1719c49769f7f$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $a768e2ca68d9cc0d$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $55e1719c49769f7f$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $55e1719c49769f7f$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $55e1719c49769f7f$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $55e1719c49769f7f$var$_lastMSecs + (nsecs - $55e1719c49769f7f$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $55e1719c49769f7f$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $55e1719c49769f7f$var$_lastMSecs = msecs;
    $55e1719c49769f7f$var$_lastNSecs = nsecs;
    $55e1719c49769f7f$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $86009cfde4820d5f$exports(b);
}
$55e1719c49769f7f$exports = $55e1719c49769f7f$var$v1;


var $eafaccec4f8b204f$exports = {};


function $eafaccec4f8b204f$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $a768e2ca68d9cc0d$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $86009cfde4820d5f$exports(rnds);
}
$eafaccec4f8b204f$exports = $eafaccec4f8b204f$var$v4;


var $4ec87579fa058e6d$var$uuid = $eafaccec4f8b204f$exports;
$4ec87579fa058e6d$var$uuid.v1 = $55e1719c49769f7f$exports;
$4ec87579fa058e6d$var$uuid.v4 = $eafaccec4f8b204f$exports;
$4ec87579fa058e6d$exports = $4ec87579fa058e6d$var$uuid;


// temp solution until we can get it automated
var $16b40791616af375$export$2295b861f318254a = "0.1.5";


var $e261388ac0cb72a6$export$15e172712955e18f = function isWindowObjectAvailable() {
    return typeof window !== "undefined";
};





var $3d6889659736da55$var$UFOLogger = /*#__PURE__*/ function() {
    function UFOLogger() {
        (0, $43619c9bde236c7c$export$2e2bcd8739ae039)(this, UFOLogger);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "enabled", false);
    }
    return (0, $839113eed049216c$export$2e2bcd8739ae039)(UFOLogger, [
        {
            key: "log",
            value: function log() {
                var _console;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                // eslint-disable-next-line no-console
                this.enabled && (_console = console).log.apply(_console, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "warn",
            value: function warn() {
                var _console2;
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                // eslint-disable-next-line no-console
                this.enabled && (_console2 = console).warn.apply(_console2, [
                    UFOLogger.UFOprefix
                ].concat(args));
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.enabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.enabled = false;
            }
        }
    ]);
}();
(0, $a29d2f74af926769$export$2e2bcd8739ae039)($3d6889659736da55$var$UFOLogger, "UFOprefix", "[ufo\uD83D\uDEF8]");
var $3d6889659736da55$export$4ab84f6f04f6566d = new $3d6889659736da55$var$UFOLogger();
var $3d6889659736da55$export$b4958caff08a0960 = function ufolog() {
    $3d6889659736da55$export$4ab84f6f04f6566d.log.apply($3d6889659736da55$export$4ab84f6f04f6566d, arguments);
};
var $3d6889659736da55$export$d53d07b6034c4560 = function ufowarn() {
    $3d6889659736da55$export$4ab84f6f04f6566d.warn.apply($3d6889659736da55$export$4ab84f6f04f6566d, arguments);
};


var $481100dea60a1fae$export$96253c35c37cf96b = /*#__PURE__*/ function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
    return UFOGlobalEventStreamEventType;
}({});
var $481100dea60a1fae$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
    return PageVisibleState;
}({});
var $481100dea60a1fae$export$66b33c055cbb625e = /*#__PURE__*/ function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
    return PageLoadMetrics;
}({});
var $481100dea60a1fae$export$3ce489cbe02dc21b = /*#__PURE__*/ function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
    return PageSegmentLoadMetrics;
}({});
var $481100dea60a1fae$export$341b330828bd3906 = /*#__PURE__*/ function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
    return InteractionMetrics;
}({});
var $481100dea60a1fae$export$b9b20160f581e4f8 = /*#__PURE__*/ function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
    return CustomMetrics;
}({});
var $481100dea60a1fae$export$79bf131685ad41d7 = "__SUBSCRIBE_ALL__";
var $481100dea60a1fae$export$9f2bf58999404c75 = "fmp";
var $481100dea60a1fae$export$837e0f79a8056912 = "inline-response";


var $5bf377bf6da75016$var$MAX_EARLY_QUEUE_LENGTH = 250;
var $5bf377bf6da75016$export$6123a44dc2384540 = function getGlobalEventStream() {
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        var earlyStream = function() {
            var stream = [];
            return {
                __buffer_only__: true,
                push: function push(event) {
                    if (stream.length < $5bf377bf6da75016$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: function getStream() {
                    return stream;
                }
            };
        }();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
var $5bf377bf6da75016$export$c1522520b417b066 = function setGlobalEventStream(eventStream) {
    var _globalThis$__UFO_GLO, _globalThis$__UFO_GLO2;
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !((_globalThis$__UFO_GLO = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO !== void 0 && _globalThis$__UFO_GLO.__buffer_only__)) {
        (0, $3d6889659736da55$export$d53d07b6034c4560)("Global Event Stream already initialised. Ignoring new event stream setup");
        return;
    }
    if ((_globalThis$__UFO_GLO2 = globalThis.__UFO_GLOBAL_EVENT_STREAM__) !== null && _globalThis$__UFO_GLO2 !== void 0 && _globalThis$__UFO_GLO2.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
var $5bf377bf6da75016$export$37863216db4b714d = function subscribeEvent(experienceId, callback) {
    return {
        type: (0, $481100dea60a1fae$export$96253c35c37cf96b).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $5bf377bf6da75016$export$ee1a7bd1fc9ea85e = function unsubscribeEvent(experienceId, callback) {
    return {
        type: (0, $481100dea60a1fae$export$96253c35c37cf96b).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
var $5bf377bf6da75016$export$7c957416596ca127 = function experiencePayloadEvent(data) {
    return {
        type: (0, $481100dea60a1fae$export$96253c35c37cf96b).EXPERIENCE_PAYLOAD,
        payload: data
    };
};







var $ada94fcb8609909e$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, $43619c9bde236c7c$export$2e2bcd8739ae039)(this, VisibilityChangeObserver);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "started", false);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "observers", []);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    return (0, $839113eed049216c$export$2e2bcd8739ae039)(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                if (this.started) return;
                this.started = true;
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ if ((0, $e261388ac0cb72a6$export$15e172712955e18f)()) window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
}();
var $ada94fcb8609909e$export$13e680397ec8f3eb = new $ada94fcb8609909e$var$VisibilityChangeObserver();



var $2d9bfebf1b96c469$export$5f490af6b2b115cf = function roundPerfNow() {
    return ~~performance.now();
};


var $d3e5766117d52aaf$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: "NOT_STARTED",
        final: true
    },
    STARTED: {
        id: "STARTED"
    },
    IN_PROGRESS: {
        id: "IN_PROGRESS"
    },
    BLOCKED: {
        id: "BLOCKED"
    },
    RECOVERED: {
        id: "RECOVERED"
    },
    // isn't recovered IN_PROGRESS?
    SUCCEEDED: {
        id: "SUCCEEDED",
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: "SUCCEEDED_WAITING_FOR_DEPS"
    },
    FAILED: {
        id: "FAILED",
        final: true
    },
    ABORTED: {
        id: "ABORTED",
        final: true
    }
};




var $6015cf18d62fc2d0$var$UFOStateAvailableTransitions = (0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)((0, $a29d2f74af926769$export$2e2bcd8739ae039)({}, (0, $d3e5766117d52aaf$export$81b70111112841a0).NOT_STARTED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).IN_PROGRESS.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).BLOCKED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).IN_PROGRESS.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).BLOCKED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).BLOCKED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).RECOVERED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).RECOVERED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED_WAITING_FOR_DEPS.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED.id,
    (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id
]), (0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED.id, [
    (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED.id
]);
var $6015cf18d62fc2d0$export$178881f329fdb81f = function canTransition(state1, state2) {
    return $6015cf18d62fc2d0$var$UFOStateAvailableTransitions[state1.id] && $6015cf18d62fc2d0$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};



function $8bdeef59fd9750b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8bdeef59fd9750b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8bdeef59fd9750b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $a29d2f74af926769$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8bdeef59fd9750b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8bdeef59fd9750b7$var$getPageVisibleState = function getPageVisibleState() {
    return !(0, $e261388ac0cb72a6$export$15e172712955e18f)() || !window.document || window.document.visibilityState === "visible" ? (0, $481100dea60a1fae$export$a12c67b37a306b13).VISIBLE : (0, $481100dea60a1fae$export$a12c67b37a306b13).HIDDEN;
};
var $8bdeef59fd9750b7$export$c753e8669d30c8ad = function perfNowOrTimestamp(timestamp) {
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $2d9bfebf1b96c469$export$5f490af6b2b115cf)();
};
var $8bdeef59fd9750b7$export$d31c89db257648c = /*#__PURE__*/ function() {
    function UFOAbstractExperience(id, config) {
        var _this = this;
        var instanceId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        (0, $43619c9bde236c7c$export$2e2bcd8739ae039)(this, UFOAbstractExperience);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "state", (0, $d3e5766117d52aaf$export$81b70111112841a0).NOT_STARTED);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "instanceId", null);
        // for concurrent
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "parent", null);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "category", null);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "metadata", {});
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "onDoneCallbacks", []);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "childExperiences", []);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "explicitTimings", {});
        // @todo move to page load experience when proper classes/inheritance prepared
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "isSSROutputAsFMP", false);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "uuid", null);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "_until", null);
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "metrics", {
            startTime: null,
            endTime: null,
            marks: []
        });
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "performanceConfig", {});
        (0, $a29d2f74af926769$export$2e2bcd8739ae039)(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = (0, $481100dea60a1fae$export$a12c67b37a306b13).MIXED;
            (0, $ada94fcb8609909e$export$13e680397ec8f3eb).unsubscribe(_this.setPageVisibleStateToMixed);
        });
        this.id = id;
        this.category = (config === null || config === void 0 ? void 0 : config.category) || null;
        this.until = (config === null || config === void 0 ? void 0 : config.until) || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $8bdeef59fd9750b7$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageLoad || config.performanceType === (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    return (0, $839113eed049216c$export$2e2bcd8739ae039)(UFOAbstractExperience, [
        {
            key: "transition",
            value: function() {
                var _transition = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee(newState, timestamp) {
                    var data;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $3d6889659736da55$export$b4958caff08a0960)("async transition", this.id, this.state.id, newState.id);
                                if (!(0, $6015cf18d62fc2d0$export$178881f329fdb81f)(this.state, newState)) {
                                    _context.next = 15;
                                    break;
                                }
                                (0, $3d6889659736da55$export$b4958caff08a0960)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " successful"), this.state.final, !newState.final);
                                if (newState === (0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED) this._reset();
                                if (this.state.final && !newState.final) {
                                    this.metrics.startTime = $8bdeef59fd9750b7$export$c753e8669d30c8ad(timestamp);
                                    this.uuid = (0, $4ec87579fa058e6d$exports.v4)();
                                }
                                this.state = newState;
                                if (!newState.final) {
                                    _context.next = 14;
                                    break;
                                }
                                this.metrics.endTime = $8bdeef59fd9750b7$export$c753e8669d30c8ad(timestamp);
                                if (!this._isManualStateEnabled()) (0, $5bf377bf6da75016$export$6123a44dc2384540)().push((0, $5bf377bf6da75016$export$ee1a7bd1fc9ea85e)((0, $481100dea60a1fae$export$79bf131685ad41d7), this.handleDoneBind));
                                _context.next = 11;
                                return this.exportData();
                            case 11:
                                data = _context.sent;
                                (0, $3d6889659736da55$export$b4958caff08a0960)("this.parent", this.parent);
                                (0, $5bf377bf6da75016$export$6123a44dc2384540)().push((0, $5bf377bf6da75016$export$7c957416596ca127)(data));
                            case 14:
                                return _context.abrupt("return", true);
                            case 15:
                                (0, $3d6889659736da55$export$b4958caff08a0960)("TRANSITION: ".concat(this.id, " from ").concat(this.state.id, " to ").concat(newState.id, " unsuccessful"));
                                (0, $3d6889659736da55$export$d53d07b6034c4560)("transition of ".concat(this.id, " from ").concat(this.state, " to ").concat(newState, " is not possible"));
                                return _context.abrupt("return", false);
                            case 18:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transition(_x, _x2) {
                    return _transition.apply(this, arguments);
                }
                return transition;
            }()
        },
        {
            key: "start",
            value: function() {
                var _start = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee2(startTime) {
                    var transitionSuccessful;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return this.transition((0, $d3e5766117d52aaf$export$81b70111112841a0).STARTED, startTime);
                            case 2:
                                transitionSuccessful = _context2.sent;
                                if (transitionSuccessful) {
                                    this.pageVisibleState = $8bdeef59fd9750b7$var$getPageVisibleState();
                                    (0, $ada94fcb8609909e$export$13e680397ec8f3eb).subscribe(this.setPageVisibleStateToMixed);
                                    if (!this._isManualStateEnabled()) {
                                        (0, $3d6889659736da55$export$b4958caff08a0960)("subscribed", this.id);
                                        (0, $5bf377bf6da75016$export$6123a44dc2384540)().push((0, $5bf377bf6da75016$export$37863216db4b714d)((0, $481100dea60a1fae$export$79bf131685ad41d7), this.handleDoneBind));
                                    }
                                }
                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function start(_x3) {
                    return _start.apply(this, arguments);
                }
                return start;
            }()
        },
        {
            key: "mark",
            value: function mark(name, timestamp) {
                if (name !== (0, $481100dea60a1fae$export$9f2bf58999404c75) && name !== (0, $481100dea60a1fae$export$837e0f79a8056912)) this._mark(name, timestamp);
                else (0, $3d6889659736da55$export$d53d07b6034c4560)("please use markFMP or markInlineResponse for specialised marks");
            }
        },
        {
            key: "_mark",
            value: function _mark(name, timestamp) {
                this.metrics.marks.push({
                    name: name,
                    time: $8bdeef59fd9750b7$export$c753e8669d30c8ad(timestamp)
                });
                this.transition((0, $d3e5766117d52aaf$export$81b70111112841a0).IN_PROGRESS);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                this._mark((0, $481100dea60a1fae$export$9f2bf58999404c75), timestamp);
            }
        },
        {
            key: "markInlineResponse",
            value: function markInlineResponse(timestamp) {
                this._mark((0, $481100dea60a1fae$export$837e0f79a8056912), timestamp);
            }
        },
        {
            key: "_isManualStateEnabled",
            value: function _isManualStateEnabled() {
                return this.until === null;
            }
        },
        {
            key: "_validateManualState",
            value: function _validateManualState() {
                if (!this._isManualStateEnabled()) {
                    (0, $3d6889659736da55$export$d53d07b6034c4560)('manual change of state not allowed as "until" is defined');
                    return false;
                }
                return true;
            }
        },
        {
            key: "switchToEndState",
            value: function switchToEndState(state, config) {
                if (!(config !== null && config !== void 0 && config.force) && !this._validateManualState()) return null;
                if (config !== null && config !== void 0 && config.metadata) this.addMetadata(config.metadata);
                (0, $ada94fcb8609909e$export$13e680397ec8f3eb).unsubscribe(this.setPageVisibleStateToMixed);
                return this.transition(state);
            }
        },
        {
            key: "success",
            value: function() {
                var _success = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee3(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", this.switchToEndState((0, $d3e5766117d52aaf$export$81b70111112841a0).SUCCEEDED, config));
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function success(_x4) {
                    return _success.apply(this, arguments);
                }
                return success;
            }()
        },
        {
            key: "failure",
            value: function() {
                var _failure = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee4(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                return _context4.abrupt("return", this.switchToEndState((0, $d3e5766117d52aaf$export$81b70111112841a0).FAILED, config));
                            case 1:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function failure(_x5) {
                    return _failure.apply(this, arguments);
                }
                return failure;
            }()
        },
        {
            key: "abort",
            value: function() {
                var _abort = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee5(config) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.switchToEndState((0, $d3e5766117d52aaf$export$81b70111112841a0).ABORTED, config));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function abort(_x6) {
                    return _abort.apply(this, arguments);
                }
                return abort;
            }()
        },
        {
            key: "addMetadata",
            value: function addMetadata(data) {
                Object.assign(this.metadata, data);
            }
        },
        {
            key: "_handleDoneExperience",
            value: function _handleDoneExperience(data) {
                (0, $3d6889659736da55$export$b4958caff08a0960)("_handleDoneExperience in", this.id, data.state, data, this._until);
                if (data.state.final) {
                    if (this._until !== null) {
                        var _this$_until = this._until(data), done = _this$_until.done, state = _this$_until.state;
                        if (done && !this.state.final) this.transition(state);
                    }
                }
            }
        },
        {
            key: "getId",
            value: function() {
                var _getId = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee6() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.id);
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getId() {
                    return _getId.apply(this, arguments);
                }
                return getId;
            }()
        },
        {
            key: "exportData",
            value: function() {
                var _exportData = (0, $67326748cb2694e4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).mark(function _callee7() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($874aead080e6b5b5$exports))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.getId();
                            case 2:
                                _context7.t0 = _context7.sent;
                                _context7.t1 = this.uuid;
                                _context7.t2 = this.type;
                                _context7.t3 = (0, $16b40791616af375$export$2295b861f318254a) || "unknown";
                                _context7.t4 = this.performanceType;
                                _context7.t5 = this.category;
                                _context7.t6 = this.state;
                                _context7.t7 = $8bdeef59fd9750b7$var$_objectSpread({}, this.metadata);
                                _context7.t8 = $8bdeef59fd9750b7$var$_objectSpread({}, this.metrics);
                                _context7.t9 = (0, $e348efdbedbe52e5$export$2e2bcd8739ae039)(this.childExperiences);
                                _context7.t10 = {
                                    success: !!this.state.success,
                                    startTime: this.metrics.startTime,
                                    duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
                                };
                                _context7.t11 = this.config.platform || null;
                                _context7.t12 = this.pageVisibleState;
                                _context7.t13 = this.featureFlags;
                                _context7.t14 = this.isSSROutputAsFMP;
                                _context7.t15 = this.timings;
                                _context7.t16 = this.explicitTimings;
                                _context7.t17 = this.performanceConfig;
                                return _context7.abrupt("return", {
                                    id: _context7.t0,
                                    uuid: _context7.t1,
                                    type: _context7.t2,
                                    schemaVersion: _context7.t3,
                                    performanceType: _context7.t4,
                                    category: _context7.t5,
                                    state: _context7.t6,
                                    metadata: _context7.t7,
                                    metrics: _context7.t8,
                                    children: _context7.t9,
                                    result: _context7.t10,
                                    platform: _context7.t11,
                                    pageVisibleState: _context7.t12,
                                    featureFlags: _context7.t13,
                                    isSSROutputAsFMP: _context7.t14,
                                    timings: _context7.t15,
                                    explicitTimings: _context7.t16,
                                    performanceConfig: _context7.t17
                                });
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function exportData() {
                    return _exportData.apply(this, arguments);
                }
                return exportData;
            }()
        },
        {
            key: "_reset",
            value: function _reset() {
                this.parent = null;
                this.metadata = {};
                this.onDoneCallbacks = [];
                this.childExperiences = [];
                this.metrics = {
                    startTime: null,
                    endTime: null,
                    marks: []
                };
                this._until = this.until ? this.until() : null;
            }
        }
    ]);
}();


function $7bb878f3cd1a6632$var$_callSuper(t, o, e) {
    return o = (0, $4c00befe917e94e5$export$2e2bcd8739ae039)(o), (0, $3e33e5de1191bf4e$export$2e2bcd8739ae039)(t, $7bb878f3cd1a6632$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $4c00befe917e94e5$export$2e2bcd8739ae039)(t).constructor) : o.apply(t, e));
}
function $7bb878f3cd1a6632$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7bb878f3cd1a6632$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $7bb878f3cd1a6632$export$c00d22927c60484a = /*#__PURE__*/ function(_UFOAbstractExperienc) {
    function UFOExperience() {
        (0, $43619c9bde236c7c$export$2e2bcd8739ae039)(this, UFOExperience);
        return $7bb878f3cd1a6632$var$_callSuper(this, UFOExperience, arguments);
    }
    (0, $eb3a12d72d57d08a$export$2e2bcd8739ae039)(UFOExperience, _UFOAbstractExperienc);
    return (0, $839113eed049216c$export$2e2bcd8739ae039)(UFOExperience);
}((0, $8bdeef59fd9750b7$export$d31c89db257648c));



var $iSvIT = parcelRequire("iSvIT");

var $5zPyl = parcelRequire("5zPyl");

var $4CDPb = parcelRequire("4CDPb");

var $hkP9U = parcelRequire("hkP9U");
function $a4514829326e693b$export$2e2bcd8739ae039(_ref) {
    var data = _ref.data;
    var interactionContext = (0, $iSvIT.useContext)((0, $5zPyl.default));
    (0, $iSvIT.useMemo)(function() {
        if (!interactionContext) return;
        if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === "function") interactionContext.addCustomData(globalThis.structuredClone(data));
        else interactionContext.addCustomData(data);
    }, [
        data,
        interactionContext
    ]);
    return null;
}
function $a4514829326e693b$export$d12f56a472cdbe6c(data) {
    var interactionId = (0, $4CDPb.getInteractionId)();
    var currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    if (typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.structuredClone) === "function") (0, $hkP9U.addCustomData)(currentInteractionId, [], globalThis.structuredClone(data));
    else (0, $hkP9U.addCustomData)(currentInteractionId, [], data);
}



var $hkP9U = parcelRequire("hkP9U");
function $76db23747c4a649c$export$5b689ca7b019e89f(interactionName, error) {
    var interaction = (0, $hkP9U.getActiveInteraction)();
    if (!interaction) return;
    if (interaction.ufoName !== interactionName) return;
    (0, $hkP9U.addError)(interaction.id, error.name, null, "Manual interaction error", error.errorMessage, undefined, true);
}


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $k18d6 = parcelRequire("k18d6");

var $2J5Gv = parcelRequire("2J5Gv");

var $bs6hr = parcelRequire("bs6hr");

var $9jPnd = parcelRequire("9jPnd");

var $4CDPb = parcelRequire("4CDPb");

var $hkP9U = parcelRequire("hkP9U");

var $527WA = parcelRequire("527WA");
function $85010dd7e6123a13$var$traceUFOInteraction(name, interactionType, startTime) {
    var _getMinorInteractions;
    if (!(0, $bs6hr.isUFOEnabled)()) return;
    var rate = (0, $bs6hr.getInteractionRate)(name, interactionType);
    var pressInteractionsList = (0, $bs6hr.getDoNotAbortActivePressInteraction)();
    var minorInteractions = (pressInteractionsList !== null && pressInteractionsList !== void 0 ? pressInteractionsList : []).concat((_getMinorInteractions = (0, $bs6hr.getMinorInteractions)()) !== null && _getMinorInteractions !== void 0 ? _getMinorInteractions : []);
    if (minorInteractions.includes(name)) {
        var _activeInteraction$mi;
        var activeInteraction = (0, $hkP9U.getActiveInteraction)();
        activeInteraction === null || activeInteraction === void 0 || (_activeInteraction$mi = activeInteraction.minorInteractions) === null || _activeInteraction$mi === void 0 || _activeInteraction$mi.push({
            name: name,
            startTime: startTime !== null && startTime !== void 0 ? startTime : performance.now()
        });
        return;
    } else (0, $hkP9U.abortAll)("new_interaction", name);
    if ((0, $2J5Gv.default)(rate)) {
        var startTimestamp = startTime !== null && startTime !== void 0 ? startTime : performance.now();
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $k18d6.v4)();
        (0, $4CDPb.DefaultInteractionID).current = newId;
        // covered experiences with tracing instrumentation:
        // inline-result.inline-card-create-submit
        (0, $9jPnd.setInteractionActiveTrace)(newId, interactionType);
        (0, $hkP9U.addNewInteraction)(newId, name, interactionType === "hover" ? "press" : interactionType, // TODO add dedicated type for hover, might change backend though
        startTimestamp, rate, [], (0, $527WA.default).current, (0, $9jPnd.getActiveTrace)());
    }
}
var $85010dd7e6123a13$export$2e2bcd8739ae039 = $85010dd7e6123a13$var$traceUFOInteraction;


function $9a58681f2b848a1d$var$traceUFOPress(name, timestamp) {
    return (0, $85010dd7e6123a13$export$2e2bcd8739ae039)(name, "press", timestamp);
}
var $9a58681f2b848a1d$export$2e2bcd8739ae039 = $9a58681f2b848a1d$var$traceUFOPress;


class $0a42a39ef9777cb1$export$8b22463170bb13fd {
    constructor(name){
        this.name = name;
        this.customData = {};
    }
    complete() {
        (0, $9a58681f2b848a1d$export$2e2bcd8739ae039)(this.name);
        (0, $a4514829326e693b$export$d12f56a472cdbe6c)(this.customData);
    }
    addCustomData(data) {
        this.customData = {
            ...this.customData,
            ...data
        };
    }
    error(options) {
        const { errorName: errorName, errorMessage: errorMessage } = options;
        this.complete();
        (0, $76db23747c4a649c$export$5b689ca7b019e89f)(this.name, {
            errorMessage: errorMessage,
            name: errorName
        });
    }
}


/* eslint-disable @typescript-eslint/no-explicit-any */ 

function $dfa5c50ef8a4edd1$export$1ca27ad470ab9a4c(error) {
    const errorResponse = error.message?.trim();
    // different browsers may have different error shapes
    const errorBody = errorResponse.startsWith("Forbidden") ? // Firefox, eg.'Forbidden {"redirectUrl":"https://some-url.com"}'
    errorResponse.substring(9).trim() : // Chrome and others, eg.'{"redirectUrl":"https://some-url.com"}'
    errorResponse;
    try {
        // extract redirect url from error body
        return JSON.parse(errorBody)?.redirectUrl;
    } catch (err) {
        console.warn("Shadow IT redirectUrl is not valid JSON");
        return "";
    }
}



// https://developer.atlassian.com/platform/ufo/ufo-core/intro-and-basics/taxonomy/
const $828dab91bece9c5e$export$c3292c0ecf9d1ed1 = {
    /**
   * Land Step — User can view signup pages
   * - Tome SLOs: https://tome.prod.atl-paas.net/capability/4cba7cce-f259-4957-b071-297d12f2a2e2
   **/ ENTER_SIGNUP_FLOW_SLO_SUCCEEDED: "enter-signup-flow.slo-succeeded",
    ENTER_SIGNUP_FLOW_SLO_FAILED: "enter-signup-flow.slo-failed",
    /**
   * Land Step — User can submit to start site and/or product activation
   * - Tome SLOs: https://tome.prod.atl-paas.net/capability/5eb87129-93bf-4299-bb87-647274daab95
   **/ // Default submit captured across bxpui and bxpkit
    DEFAULT_SIGNUP_SUBMIT_SLO_SUCCEEDED: "default-signup-submit.slo-succeeded",
    DEFAULT_SIGNUP_SUBMIT_SLO_FAILED: "default-signup-submit.slo-failed",
    BXPUI_SIGNUP_SUBMIT_SLO_SUCCEEDED: "bxpui-signup-submit.slo-succeeded",
    BXPUI_SIGNUP_SUBMIT_SLO_FAILED: "bxpui-signup-submit.slo-failed",
    BXPKIT_SIGNUP_SUBMIT_SLO_SUCCEEDED: "bxpkit-signup-form-submit.slo-succeeded",
    BXPKIT_SIGNUP_SUBMIT_SLO_FAILED: "bxpkit-signup-form-submit.slo-failed",
    /* Events */ ACTIVATE_PRODUCT_API_SUCCESS: "activate-product-api.success",
    ACTIVATE_PRODUCT_API_ERROR: "activate-product-api.error",
    /**
   * Experiment - Confluence set up over provisioning
   * - statsig setup: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/cfind-1054_confluence_set_up_over_provisioning/setup
   */ CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_INVITE_LINK_FETCH_ERROR: "cfind-1054-confluence-set-up-over-provisioning.invite-link-fetch-error",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_RECEIVED: "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-received",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_MISSING: "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-missing",
    CONFLUENCE_SETUP_OVER_SITE_PROVISIONING_ONBOARDING_RESPONSE_ERROR: "cfind-1054-confluence-set-up-over-provisioning.onboarding-response-error"
};
const $828dab91bece9c5e$export$d79b2e9dc301cf70 = {
    SUCCEEDED: "SUCCEEDED",
    ABORTED: "ABORTED"
};
const $828dab91bece9c5e$export$14a63aec7e354872 = {
    PAGE_LOAD: "page-load",
    PRESS: "press",
    TYPING: "typing",
    TRANSITION: "transition",
    CUSTOM: "custom"
};
const $828dab91bece9c5e$export$90a51f9e6068b063 = {
    STARGATE_AVAILABLE_PRODUCTS_API: "stargate_available_products_api",
    STARGATE_CONSENT_CONFIG_API: "stargate_consent_config_api",
    STARGATE_EXPAND_FREE_VALIDATION_API: "stargate_expand_free_validation_api",
    STARGATE_USER_API: "stargate_user_api",
    IDENTITY_USER_SIGNUP_API: "identity_user_signup_api",
    ACTIVATE_STATUS_CCP_POLLING_API: "activate_status_ccp_polling_api",
    CLOUD_STATUS_HAMS_POLLING_API: "cloud_status_hams_polling_api",
    ROBOTS_VIEW_DWELL_TIME: "robots_view_dwell_time",
    CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME: "confluence_default_circle_dwell_time",
    CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME: "confluence_onboarding_spinner_dwell_time",
    CONFLUENCE_ONBOARDING_STEPS_DWELL_TIME: "confluence_onboarding_steps_dwell_time",
    JIRA_ANIMATED_PROVISIONING_DWELL_TIME: "jira_animated_provisioning_dwell_time",
    JIRA_ONBOARDING_WIZARD_PROJECT_CREATE_DWELL_TIME: "jira_onboarding_wizard_project_create_dwell_time",
    JIRA_TEMPLATE_CHOICE_DWELL_TIME: "jira_template_choice_dwell_time",
    JIRA_USER_SEGMENTATION_DWELL_TIME: "jira_user_segmentation_dwell_time",
    JIRA_PRODUCT_DISCOVERY_ONBOARDING_SPINNER_DWELL_TIME: "jira_product_discovery_onboarding_spinner_dwell_time",
    USER_SEGMENTATION_DWELL_TIME: "user_segmentation_dwell_time",
    TIPS_VIEW_DWELL_TIME: "tips_view_dwell_time",
    GRAPHQL_WEBHOOK_SETUP: "graphql_webhook_setup",
    GRAPHQL_SUBSCRIPTION_ACK: "graphql_subscription_ack",
    GRAPHQL_WEBHOOK_PROVISIONING_LATENCY: "graphql_webhook_provisioning_latency",
    ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL: "onboarding-wizard.project-create-api",
    SERVICE_COLLECTION_PROVISIONING_VIEW_DWELL_TIME: "service_collection_provisioning_view_dwell_time",
    TWC_PROVISIONING_DWELL_TIME: "twc_provisioning_dwell_time",
    JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK: "JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK",
    JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES: "jira_onboarding_wizard_invite_fetching_roles",
    JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE: "jira_onboarding_wizard_invite_checking_license",
    JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS: "jira_onboarding_wizard_invite_inviting_users",
    RESOLVE_TENANT_ID: "resolve_tenant_id",
    JIRA_ONBOARDING_MADLIB_PROJECT_CREATE: "jira_onboarding_madlib_project_create",
    JIRA_ONBOARDING_DEFAULT_PROJECT_CREATE: "jira_onboarding_default_project_create",
    // Perceived provisioning funnel timings
    PERCEIVED_PROVISIONING_FUNNEL_TENANT_ID_RESOLUTION: "perceived_provisioning_funnel_tenant_id_resolution",
    PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS: "perceived_provisioning_funnel_provisioning_success",
    PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED: "perceived_provisioning_funnel_project_creation_initialized",
    PERCIEVED_PROVISIONING_FUNNEL_PROJECT_POLLING: "perceived_provisioning_funnel_project_polling",
    PERCEIVED_PROVISIONING_FUNNEL_INVITE_TEAMMATES: "perceived_provisioning_funnel_invite_teammates",
    PERCEIVED_PROVISIONING_FUNNEL_LAND_IN_PRODUCT: "perceived_provisioning_funnel_land_in_product"
};
const $828dab91bece9c5e$export$113d8f1bc5a68886 = {
    JIRA_SOFTWARE: "jira-software",
    CONFLUENCE: "confluence",
    JIRA_WORK_MANAGEMENT: "jira-work-management",
    JIRA_SERVICE_MANAGEMENT: "jira-service-management",
    JIRA_PRODUCT_DISCOVERY: "jira-product-discovery",
    OPSGENIE: "opsgenie",
    LOOM: "loom",
    OTHER: "other",
    NOT_FOUND: "not-found"
};
const $828dab91bece9c5e$export$92f8fdd7327872bb = {
    NEW_SITE_N2N: "new-site-n2n",
    EXISTING_SITE_N2E: "existing-site-n2e",
    NOT_FOUND: "not-found"
};
const $828dab91bece9c5e$export$be495791f9336453 = {
    DEVOPS: "devops",
    LOOM: "loom",
    JIRA_SERVICE_MANAGEMENT: "jira-service-management",
    NOT_FOUND: "not-found"
};
const $828dab91bece9c5e$export$8aac3a3734ca3f6 = {
    BXP_UI: "bxp-ui",
    BXPKIT: "bxpkit",
    UNKNOWN: "unknown"
};
const $828dab91bece9c5e$export$6e7cbf29070a70c4 = {
    FREE: "free",
    STANDARD: "standard",
    PREMIUM: "premium",
    UNKNOWN: "unknown"
};


function $9fc8af985927dd0f$export$f82411362e5e25ac(productKey) {
    if (!productKey) return "not-found";
    switch(productKey){
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE:
            return "confluence";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE:
            return "jira-software";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_WORK_MANAGEMENT:
            return "jira-work-management";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SERVICE_MANAGEMENT:
            return "jira-service-management";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_PRODUCT_DISCOVERY:
            return "jira-product-discovery";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).OPSGENIE:
            return "opsgenie";
        case (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).LOOM:
            return "loom";
        default:
            return "other";
    }
}
function $9fc8af985927dd0f$export$e9e1a9852ee51ca3(bundle) {
    if (!bundle) return "not-found";
    return bundle;
}
function $9fc8af985927dd0f$export$215523adca76f926(isNewSite) {
    const siteTypeCohort = isNewSite ? "new-site-n2n" : "existing-site-n2e";
    return siteTypeCohort;
}
function $9fc8af985927dd0f$export$8a62990a303cb185(webPlatform) {
    if (!webPlatform) return "unknown";
    return webPlatform;
}
function $9fc8af985927dd0f$export$acf25cbc735b9b90(edition) {
    if (!edition) return "unknown";
    return edition;
}
function $9fc8af985927dd0f$export$3f9ddfc12dcc1171(billingPlatform) {
    const timingKey = billingPlatform === "ccp" ? (0, $828dab91bece9c5e$export$90a51f9e6068b063).ACTIVATE_STATUS_CCP_POLLING_API : (0, $828dab91bece9c5e$export$90a51f9e6068b063).CLOUD_STATUS_HAMS_POLLING_API;
    const requestPath = billingPlatform === "ccp" ? "/activate/status/:provisioningRequestId" : "/cofs/:cloudId/status/:requestId";
    return {
        timingKey: timingKey,
        requestPath: requestPath
    };
}



class $aafc6c1f89d60dff$export$4f206ee089497514 {
    constructor(id, config = {}){
        this._customTimingKeys = [];
        this._customData = {};
        const { customTimingKeys: customTimingKeys = [] } = config;
        const defaultConfig = {
            performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
            type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
            platform: {
                component: `signup`
            }
        };
        const ufoConfig = {
            ...defaultConfig,
            ...config
        };
        /*
     * Custom timings are used to measure sub-durations of an experience or page load
     *    eg. latency of API calls, time spent in loading UI, etc
     */ this._customTimingKeys = customTimingKeys;
        const customTimings = customTimingKeys.map((key)=>({
                key: key,
                startMark: `${key}_start`,
                endMark: `${key}_end`
            }));
        const perfPortalCustomTimings = customTimingKeys.map((key)=>({
                key: `${key}_perf`,
                startMark: `${key}_perf_start`,
                endMark: `${key}_perf_end`
            }));
        /*
     * We emit two UFO events:
     *   (1) used to build alerts & SLI/SLOs via SignalFX
     *   (2) used to create aggregated dashboard via Performance Portal
     */ this._signupFunnelUFO = new (0, $7bb878f3cd1a6632$export$c00d22927c60484a)(id, {
            ...ufoConfig,
            timings: customTimings
        });
        this._performancePortalUFO = new (0, $7bb878f3cd1a6632$export$c00d22927c60484a)(`${id}.perf`, {
            ...ufoConfig,
            timings: perfPortalCustomTimings
        });
    }
    setCustomData(customData) {
        try {
            Object.assign(this._customData, customData);
        } catch (message) {
            console.error(message);
        }
    }
    _buildErrorLogs(options) {
        const { error: error, customData: customData = {} } = options;
        const { errorOrigin: errorOrigin = "" } = customData;
        const errorData = {
            atlTraceId: undefined,
            errorName: "none",
            errorMessage: "none",
            errorStack: "none",
            errorStatusCode: 0,
            errorReqPath: "none",
            errorOrigin: errorOrigin
        };
        // Build error data if error present
        if (error) {
            if (error.name) errorData.errorName = error.name;
            if (error.stack) errorData.errorStack = error.stack;
            if (error.response) {
                if (error.response.status) errorData.errorStatusCode = error.response.status;
                if (error.response.headers) errorData.atlTraceId = error.response.headers.get("atl-traceid");
                errorData.errorOrigin += ", HTTP Error";
            } else errorData.errorOrigin += ", FE Error";
            if (error.url && typeof error.url === "string") try {
                const errorUrl = new URL(error.url);
                errorData.errorReqPath = errorUrl ? new URL(errorUrl).pathname : "unknown";
            } catch (err) {
                console.log("error building UFO error custom data: ", err);
            }
            if (error.message) errorData.errorMessage = error.message;
        }
        return errorData;
    }
    _buildHttpLogs(options) {
        const { customData: customData = {} } = options;
        const { atlTraceId: atlTraceId = "unknown", errorMessage: errorMessage, errorStatusCode: errorStatusCode, errorReqPath: errorReqPath, reqPath: reqPath, statusCode: statusCode, message: message } = customData;
        const httpData = {
            atlTraceId: atlTraceId,
            reqPath: reqPath,
            statusCode: statusCode,
            message: message
        };
        if (!reqPath) httpData.reqPath = errorReqPath;
        if (!statusCode) httpData.statusCode = errorStatusCode;
        if (!message) httpData.message = errorMessage;
        return httpData;
    }
    static BuildCustomBaseData() {
        // We want to use 'analyticsAnonymousId' to link the interaction to the user via Splunk logs
        const analyticsAnonymousId = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("ajs_anonymous_id");
        // Build base stack for UFO logger
        const browserUrl = new URL(window?.location?.href);
        const browserPath = browserUrl?.pathname;
        const product = browserUrl.searchParams.get("product");
        const bundle = browserUrl.searchParams.get("bundle");
        const edition = browserUrl.searchParams.get("edition");
        const baseData = {
            ...analyticsAnonymousId ? {
                analyticsAnonymousId: analyticsAnonymousId
            } : {},
            ...browserPath ? {
                browserPath: browserPath
            } : {},
            ...product ? {
                product: product
            } : {},
            ...bundle ? {
                bundle: bundle
            } : {},
            ...edition ? {
                edition: edition
            } : {}
        };
        return baseData;
    }
    _buildCustomDataLogs(options) {
        const { customData: customData = {}, isPerformancePortal: isPerformancePortal = false } = options;
        const baseData = $aafc6c1f89d60dff$export$4f206ee089497514.BuildCustomBaseData();
        const productKey = this._customData["productKey"];
        if (productKey) baseData.product = productKey;
        const errorLogs = this._buildErrorLogs(options);
        const errorOrigin = errorLogs.errorOrigin;
        const httpLogs = this._buildHttpLogs({
            ...options,
            customData: {
                ...errorLogs,
                ...customData
            }
        });
        return {
            isPerformancePortal: isPerformancePortal,
            reactComponent: "unknown",
            ...baseData,
            ...errorLogs,
            ...httpLogs,
            ...this._customData,
            ...customData,
            ...errorOrigin ? {
                errorOrigin: errorOrigin
            } : {}
        };
    }
    _isValidBadEventSLI(error) {
        // Undefined errors are "valid bad events", eg. error UI rendered
        if (!error) return true;
        const isHttpError = Boolean(error.response);
        // Non-http errors are "valid bad events", ie. included in FE SLO/SLI
        if (!isHttpError) return true;
        const errorStatusCode = error.response.status;
        // Rate limit errors are "invalid bad events", ie. scrubbed from FE SLO/SLI
        if (errorStatusCode === 429) return false;
        // Blocked locale errors are "invalid bad events"
        if (errorStatusCode === 422) return false;
        //  "recaptcha and bans throw 400 invalid bad events."
        if (errorStatusCode === 400) return false;
        const isShadowItRedirectError = errorStatusCode === 403 && Boolean((0, $dfa5c50ef8a4edd1$export$1ca27ad470ab9a4c)(error));
        // Shadow IT redirect errors are "invalid bad events"
        if (isShadowItRedirectError) return false;
        // Exclude 403s from SLO and mark them as "invalid bad events"
        if (errorStatusCode === 403) return false;
        // Otherwise, all other http errors are "valid bad events"
        return true;
    }
    /*
   * Platform config is used to build `experienceKey` for UFO events,
   *    which is used to query logs, define good/bad events for FE SLOs, etc.
   *
   * Add cohorts to UFO for better observability breakdown (ie. metrics by product, etc.)
   */ setPlatformConfig(options = {}) {
        const { productKey: productKey, bundle: bundle, webPlatform: webPlatform, edition: edition, bundleProductKeys: bundleProductKeys } = options;
        /*
     * Build `experienceKey` with passed-in cohort values
     */ const productCohort = (0, $9fc8af985927dd0f$export$f82411362e5e25ac)(productKey);
        const bundleCohort = (0, $9fc8af985927dd0f$export$e9e1a9852ee51ca3)(bundle);
        const webPlatformCohort = (0, $9fc8af985927dd0f$export$8a62990a303cb185)(webPlatform);
        const editionCohort = (0, $9fc8af985927dd0f$export$acf25cbc735b9b90)(edition);
        // eg. ...[signup].some-event.slo
        let experienceKeyPrefix = `signup`;
        if (bundleProductKeys?.includes(",")) // eg. ...signup.bundle.some-event.slo
        experienceKeyPrefix += `.bundle`;
        else if (productCohort !== (0, $828dab91bece9c5e$export$113d8f1bc5a68886).NOT_FOUND) // eg. ...signup.[confluence].some-event.slo
        experienceKeyPrefix += `.${productCohort}`;
        else if (bundleCohort !== (0, $828dab91bece9c5e$export$be495791f9336453).NOT_FOUND) // eg. ...signup.[devops].some-event.slo
        experienceKeyPrefix += `.${bundleCohort}`;
        this._signupFunnelUFO.config.platform = {
            component: experienceKeyPrefix
        };
        // Force Perf Event to use `signup` as component to create aggregated dashboard
        this._performancePortalUFO.config.platform = {
            component: `signup`
        };
        // Set custom data
        this.setCustomData({
            productKey: productKey,
            productCohort: productCohort,
            bundle: bundle,
            bundleCohort: bundleCohort,
            webPlatform: webPlatform,
            webPlatformCohort: webPlatformCohort,
            edition: edition,
            editionCohort: editionCohort,
            bundleProductKeys: bundleProductKeys
        });
    }
    setErrorLogs(options) {
        try {
            const errorLogs = this._buildErrorLogs(options);
            const errorOrigin = errorLogs.errorOrigin;
            const httpLogs = this._buildHttpLogs({
                ...options,
                customData: {
                    ...errorLogs,
                    ...options.customData
                }
            });
            const customData = {
                ...options.customData,
                ...errorLogs,
                ...httpLogs,
                ...this._customData,
                ...errorOrigin ? {
                    errorOrigin: errorOrigin
                } : {}
            };
            this.setCustomData(customData);
        } catch (message) {
            console.error(message);
        }
    }
    async startSubstep(key, options = {}) {
        try {
            const { startTimestamp: startTimestamp } = options;
            const startMark = `${key}_start`;
            const perfStartMark = `${key}_perf_start`;
            this._signupFunnelUFO.mark(startMark, startTimestamp);
            this._performancePortalUFO.mark(perfStartMark, startTimestamp);
        } catch (message) {
            console.error(message);
        }
    }
    async endSubstep(key, options = {}) {
        try {
            const { endTimestamp: endTimestamp, error: error, customData: customData } = options;
            if (customData) this.setCustomData(customData);
            // Only update error logs if error present
            if (error) this.setErrorLogs({
                error: error,
                customData: customData
            });
            const endMark = `${key}_end`;
            const perfEndMark = `${key}_perf_end`;
            this._signupFunnelUFO.mark(endMark, endTimestamp);
            this._performancePortalUFO.mark(perfEndMark, endTimestamp);
        } catch (message) {
            console.error(message);
        }
    }
    async _endAllSubsteps() {
        try {
            const promises = this._customTimingKeys.map((key)=>this.endSubstep(key));
            await Promise.all(promises);
        } catch (message) {
            console.error(message);
        }
    }
    /**
   * Returns substep custom timings from the underlying UFO experience marks.
   * Only includes keys that have both start and end marks.
   */ getSubstepTimings() {
        const result = {};
        try {
            const { marks: marks = [] } = this._signupFunnelUFO.metrics ?? {};
            for (const key of this._customTimingKeys){
                const startMark = marks.find((m)=>m.name === `${key}_start`);
                const endMark = marks.find((m)=>m.name === `${key}_end`);
                if (!startMark || !endMark) continue;
                const startTime = startMark.time;
                const duration = endMark.time - startMark.time;
                result[key] = {
                    startTime: startTime,
                    duration: duration
                };
            }
        } catch (message) {
            console.error(message);
        }
        return result;
    }
    async start(options = {}) {
        try {
            // Add cohort to UFO event (ie. metrics by product)
            this.setPlatformConfig(options);
            await Promise.all([
                this._signupFunnelUFO.start(),
                this._performancePortalUFO.start()
            ]);
        } catch (message) {
            console.error(message);
        }
    }
    _setExplicitTiming(timing) {
        if (!this._performancePortalUFO.explicitTimings) this._performancePortalUFO.explicitTimings = {};
        if (!this._signupFunnelUFO.explicitTimings) this._signupFunnelUFO.explicitTimings = {};
        Object.assign(this._performancePortalUFO.explicitTimings, timing);
        Object.assign(this._signupFunnelUFO.explicitTimings, timing);
    }
    _addPageLoadTimings() {
        if (this._performancePortalUFO.config.performanceType === (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad && window?.performance) {
            const navigationPerformanceTime = window.performance?.getEntriesByType("navigation")?.[0];
            const performanceTimeOrigin = Math.round(window.performance.timeOrigin);
            if (performanceTimeOrigin && navigationPerformanceTime) {
                const domContentLoadedEventStart = Math.round(navigationPerformanceTime.domContentLoadedEventStart);
                const requestStart = Math.round(navigationPerformanceTime.requestStart);
                const responseStart = Math.round(navigationPerformanceTime.responseStart);
                const startTimeStamp = performanceTimeOrigin + requestStart;
                const fmpDurationMs = domContentLoadedEventStart;
                const fftbDurationMs = responseStart - requestStart;
                const ttiDuration = Math.round(navigationPerformanceTime.duration);
                this._setExplicitTiming({
                    fmp: {
                        startTime: performanceTimeOrigin,
                        duration: fmpDurationMs
                    }
                });
                this._setExplicitTiming({
                    ttfb: {
                        startTime: startTimeStamp,
                        duration: fftbDurationMs
                    }
                });
                this._setExplicitTiming({
                    tti: {
                        startTime: performanceTimeOrigin,
                        duration: ttiDuration
                    }
                });
            }
        }
    }
    async success(options = {}) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            // Time-to-first-byte (TTFB) timing for page load UFO events.
            this._addPageLoadTimings();
            await Promise.all([
                // `SUCCEEDED` UFO emitted for "good event", ie. included in FE SLO/SLI
                this._signupFunnelUFO.success({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.success({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
        } catch (message) {
            console.error(message);
        }
    }
    async failure(options) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            /*
       * Scrub errors that are "invalid bad events" from FE SLI/SLO
       *   eg. 429 rate limit, 422 blocked locale, 400 recaptcha
       */ const isValidBadEventSLI = this._isValidBadEventSLI(options?.error);
            if (isValidBadEventSLI) await Promise.all([
                // `FAILED` UFO emitted for "valid bad event", ie. included in FE SLO/SLI
                this._signupFunnelUFO.failure({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.failure({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
            else // "Aborted" UFO emitted for "invalid bad event", ie. scrubbed from FE SLO/SLI
            await this.abort(options);
        } catch (message) {
            console.error(message);
        }
    }
    async abort(options) {
        try {
            // Before completing the event, we end the sub-duration for all remaining sub-steps that have been started
            await this._endAllSubsteps();
            await Promise.all([
                // `ABORTED` UFO emitted for logging, ie. scrubbed from FE SLO/SLI
                this._signupFunnelUFO.abort({
                    metadata: this._buildCustomDataLogs(options)
                }),
                // UFO emitted for Performance Portal to breakdown metrics by cohort
                this._performancePortalUFO.abort({
                    metadata: this._buildCustomDataLogs({
                        ...options,
                        isPerformancePortal: true
                    })
                })
            ]);
        } catch (message) {
            console.error(message);
        }
    }
}



const $7298ade5588bc87b$export$5fcd84211e1a1b4a = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.account-signin.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).IDENTITY_USER_SIGNUP_API
    ],
    platform: {
        component: `signin`
    }
});
const $7298ade5588bc87b$export$4fe74aaece98f86 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.account-creation.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).IDENTITY_USER_SIGNUP_API
    ]
});
const $7298ade5588bc87b$export$b9ea4526e4381282 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpkit.account-creation.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).IDENTITY_USER_SIGNUP_API
    ]
});
const $7298ade5588bc87b$export$6e8b4d41cca771b7 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.new-site-n2n-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$9ae44d3cd9212530 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.get-sites-n2e.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$cf822340feac4687 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.get-user.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$21cc61280e75423 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.existing-site-n2e-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$2f235e71d30c6bb2 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpkit.new-site-n2n-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$fee84aabae7803f3 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpkit.new-site-n2n-paid-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$7a6c554b22f876b4 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpkit.existing-site-n2e-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$b5bbdb248b2b11c2 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpkit.existing-site-n2e-paid-submit.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$b164d3383b880fdc = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("get-user-profile.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$42d8764622431d53 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("company-expand.join-product.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$b92cb9b78a1af239 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("company-expand.user-segmentation-advice.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$56157be5ba064cfc = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("company-expand.create-project.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$40efcfb31ac1efa2 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.confirmation-page-status-polling.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$f2b36adc7ea3d4fb = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.confirmation-page-update-user-profile.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$93670d666aaba770 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.confirmation-page-team-type-selection.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$15729dc80d1b26cf = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.confirmation-page-template-selection-continue.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$b5b50a2ad76a9aa3 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.confirmation-page-template-selection-back.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$7483953e3b70c45 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("graphql-webook-setup.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$149824147e381b11 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("graphql-subscription-setup.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$37cf0a10d749cb69 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("graphql-get-provisioning-status.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$93808710b9120531 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.redirect-to-product-from-confirmation-page.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).ACTIVATE_STATUS_CCP_POLLING_API,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).CLOUD_STATUS_HAMS_POLLING_API,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).ROBOTS_VIEW_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).CONFLUENCE_ONBOARDING_STEPS_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).CONFLUENCE_ONBOARDING_SPINNER_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).CONFLUENCE_DEFAULT_CIRCLE_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ANIMATED_PROVISIONING_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_WIZARD_PROJECT_CREATE_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_TEMPLATE_CHOICE_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_USER_SEGMENTATION_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).USER_SEGMENTATION_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).TIPS_VIEW_DWELL_TIME,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).GRAPHQL_WEBHOOK_SETUP,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).GRAPHQL_SUBSCRIPTION_ACK,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).GRAPHQL_WEBHOOK_PROVISIONING_LATENCY
    ]
});
const $7298ade5588bc87b$export$8742107465d7ad8f = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.get-jira-sites-from-agg.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$363d2de92afe8e7 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.get-recaptcha-api.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$f81be27e62354595 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("try-cloud-signup.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad
});
const $7298ade5588bc87b$export$cd2c363597bd0b53 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("try-cloud-signup.available-products.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$a00b95b8df4c6ff8 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("try-cloud-signup.consent-config.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$7a7c3f59dea17f9 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("try-cloud-signup.expand-free-validation.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$d6d4aa47db9fc9bf = new (0, $7bb878f3cd1a6632$export$c00d22927c60484a)("bxpui.paid-signup-page-load.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad
});
const $7298ade5588bc87b$export$1b5a141920591df9 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.paid-signup-page-load-jsw.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad
});
const $7298ade5588bc87b$export$17da59807f19bcf5 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.paid-signup-page-load-confluence.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad
});
const $7298ade5588bc87b$export$2ade41d8cc00cdd1 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.paid-signup-page-load-jsm.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad
});
const $7298ade5588bc87b$export$fb25c6edcfccd1ee = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.bxp-gateway-anchor-parse", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Operation,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).Custom
});
const $7298ade5588bc87b$export$b455e85cb1a670d6 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.signup-form-load.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).STARGATE_AVAILABLE_PRODUCTS_API,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).STARGATE_USER_API
    ]
});
const $7298ade5588bc87b$export$b668a56466b07df6 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.site-name-form-load.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Load,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).PageSegmentLoad,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).STARGATE_AVAILABLE_PRODUCTS_API
    ]
});
const $7298ade5588bc87b$export$88a8b1f7795a4755 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("bxpui.site-name-availability.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$5efb77ab7d4924a2 = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.get-activation-type.slo");
const $7298ade5588bc87b$export$d32222d13d2012ed = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.existing-site-activation.slo");
const $7298ade5588bc87b$export$50bc2958e0690914 = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.new-site-activation.slo");
const $7298ade5588bc87b$export$7d2e3f087e40b0f6 = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.org-activation.slo");
const $7298ade5588bc87b$export$684c084e8c82e830 = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.account-org-list.slo");
const $7298ade5588bc87b$export$79d58b2886ef4485 = new (0, $0a42a39ef9777cb1$export$8b22463170bb13fd)("post-order.account-org-list-next-page.slo");
const $7298ade5588bc87b$export$569d81616e2bd8d = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("provisioning-status-cloud-id-availability.slo", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$dead11e4b6847b1e = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding-wizard.project-create", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$be09b4532561475c = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding-wizard.project-create-including-provisioning", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).ONBOARDING_WIZARD_PROJECT_CREATE_API_CALL
    ]
});
const $7298ade5588bc87b$export$22e6232eaf5bb2b6 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("async-architecture.new-site-activation", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$74415081c316e26 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("async-architecture.polling-status", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$993fa34c764c5b2d = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding.auto-select-theme-preference", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Operation,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult
});
const $7298ade5588bc87b$export$e21068351502f79 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding.resolve-tenant-id", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).RESOLVE_TENANT_ID
    ]
});
const $7298ade5588bc87b$export$edaa107857ee2d4d = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding.invite-users-step", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_WIZARD_INVITE_POLLING_PROJECT_CREATE_TASK,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_WIZARD_INVITE_FETCHING_ROLES,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_WIZARD_INVITE_INVITING_USERS,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_WIZARD_INVITE_CHECKING_LICENSE
    ]
});
const $7298ade5588bc87b$export$6f8fe3fb44db3f2d = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding.madlib-project-create", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_MADLIB_PROJECT_CREATE
    ]
});
const $7298ade5588bc87b$export$31bc284942dbe406 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("onboarding.skipped-madlib-project-create", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).JIRA_ONBOARDING_DEFAULT_PROJECT_CREATE
    ]
});
const $7298ade5588bc87b$export$9f70bbe5ec980f4 = new (0, $aafc6c1f89d60dff$export$4f206ee089497514)("percieved-provisioning-funnel", {
    type: (0, $0408bc06a3af4f0c$export$994164cf3ae1cc9a).Experience,
    performanceType: (0, $0408bc06a3af4f0c$export$cc26007c03242fff).InlineResult,
    customTimingKeys: [
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).PERCEIVED_PROVISIONING_FUNNEL_TENANT_ID_RESOLUTION,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).PERCEIVED_PROVISIONING_FUNNEL_PROVISIONING_SUCCESS,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).PERCEIVED_PROVISIONING_FUNNEL_PROJECT_CREATION_INITIALIZED,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).PERCIEVED_PROVISIONING_FUNNEL_PROJECT_POLLING,
        (0, $828dab91bece9c5e$export$90a51f9e6068b063).PERCEIVED_PROVISIONING_FUNNEL_INVITE_TEAMMATES
    ]
});






var $iSvIT = parcelRequire("iSvIT");

const $e4e5eadbc4abf3fb$export$a6f45672c1b02b97 = {
    "default": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand",
        bundleContent: {
            default: {
                heroImage: "https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg",
                headline: "Bundle Headline",
                socialProofImage: "https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg",
                featureList: "<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> "
            }
        }
    },
    "jira-software-confluence": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,confluence.ondemand"
    },
    "jira-software-confluence-compass": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            },
            {
                productKey: "compass",
                productName: "Compass",
                productLogoUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,confluence.ondemand,compass"
    },
    "jira-software-jira-service-desk-confluence": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand"
    },
    "jira-software-jira-service-management-confluence": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,jira-servicedesk.ondemand,confluence.ondemand"
    },
    "jira-software-jira-service-desk": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,jira-servicedesk.ondemand"
    },
    "jira-service-desk-jira-software": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,jira-software.ondemand"
    },
    "jira-service-management-jira-software": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,jira-software.ondemand"
    },
    "jira-software-jira-service-management": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,jira-servicedesk.ondemand"
    },
    "jira-service-desk-jira-software-confluence": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand"
    },
    "jira-service-management-jira-software-confluence": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,jira-software.ondemand,confluence.ondemand"
    },
    "jira-software": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand",
        bundleContent: {
            default: {
                heroImage: "https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg",
                headline: "Bundle Headline",
                socialProofImage: "https://atlassian.com/dam/jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd/Jira%20Logo.svg",
                featureList: "<ul> <li>Access all features</li> <li>Scale agile practices</li> <li>Consolidate workflows</li> <li>Plan, track, and release</li> </ul> "
            }
        }
    },
    "jira-service-desk": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand"
    },
    "jira-service-management": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand"
    },
    "jira-service-desk-confluence": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,confluence.ondemand"
    },
    "jira-service-management-confluence": {
        products: [
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-servicedesk.ondemand,confluence.ondemand"
    },
    "jira-core-confluence": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,confluence.ondemand"
    },
    "confluence": {
        products: [
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "confluence.ondemand"
    },
    "confluence-jira-service-desk": {
        products: [
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "confluence.ondemand,jira-servicedesk.ondemand"
    },
    "confluence-jira-service-management": {
        products: [
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            },
            {
                productKey: "jira-servicedesk.ondemand",
                productName: "Jira Service Management",
                productLogoUrl: "https://atlassian.com/dam/jcr:53775d00-13ed-4f7e-b9a0-aa16802f1161/jira%20service%20management-logo-gradient-blue.svg"
            }
        ],
        bundleProductKeys: "confluence.ondemand,jira-servicedesk.ondemand"
    },
    "developer": {
        products: [
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "com.atlassian.service-collection",
                productName: "Service Collection",
                productLogoUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/171f20t4om07135ujka42le40wvkp613.svg"
            }
        ],
        bundleProductKeys: "confluence.ondemand,jira-software.ondemand,com.atlassian.service-collection"
    },
    "confluence-jira-software": {
        products: [
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            },
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "confluence.ondemand,jira-software.ondemand"
    },
    "jira-software-bitbucket": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand"
    },
    "bitbucket-jira-software": {
        products: [
            {
                productKey: "com.atlassian.bitbucket",
                productName: "Bitbucket",
                productLogoUrl: "https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg"
            }
        ],
        bundleProductKeys: "com.atlassian.bitbucket"
    },
    "opsgenie": {
        products: [
            {
                productKey: "opsgenie",
                productName: "Opsgenie",
                productLogoUrl: "https://atlassian.com/dam/jcr:5b512ce6-164b-42c2-a615-00ea3c38f132/Opsgenie-blue-rgb.svg"
            }
        ],
        bundleProductKeys: "opsgenie"
    },
    "bitbucket": {
        products: [
            {
                productKey: "com.atlassian.bitbucket",
                productName: "Bitbucket",
                productLogoUrl: "https://atlassian.com/dam/jcr:bd56917e-e361-4f03-b672-9f5ef5b06e80/Bitbucket-blue.svg"
            }
        ],
        bundleProductKeys: "com.atlassian.bitbucket"
    },
    "statuspage": {
        products: [
            {
                productKey: "statuspage",
                productName: "Statuspage",
                productLogoUrl: "https://atlassian.com/dam/jcr:d909aeb4-b62e-4f59-8cf3-dc611bed6564/Statuspage-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:442a5960-4c84-4874-979e-3201b65f7e61/Statuspage-white.svg"
            }
        ],
        bundleProductKeys: "statuspage"
    },
    "team-central": {
        products: [
            {
                productKey: "townsquare",
                productName: "Team Central",
                productLogoUrl: "https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg"
            }
        ],
        bundleProductKeys: "townsquare"
    },
    "atlas": {
        products: [
            {
                productKey: "townsquare",
                productName: "Team Central",
                productLogoUrl: "https://atlassian.com/dam/jcr:3a87ab6e-771b-41ae-93fc-e7230641430c/atlas-beta-color.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:9c6be750-6612-4b30-acb2-1e2d6c1cea8f/atlas-logo-white.svg"
            }
        ],
        bundleProductKeys: "townsquare"
    },
    "beacon": {
        products: [
            {
                productKey: "beacon",
                productName: "Beacon",
                productLogoUrl: "https://atlassian.com/dam/jcr:ab20c8a3-0ba6-436a-9a00-42873c776738/beacon-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:563c3ec0-574d-4384-b60d-59987e5d83ee/beacon-white.svg"
            }
        ],
        bundleProductKeys: "beacon"
    },
    "fabric": {
        products: [
            {
                productKey: "atlassian-whiteboard",
                productName: "Fabric",
                productLogoUrl: "https://atlassian.com/dam/jcr:4fc54485-e365-4549-af5f-3610a970e5d2/Confluence_Whiteboards_logo_lockup_blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:13abb206-c43f-4d9e-9b76-631bcf9ae692/Confluence_Whiteboards_logo_lockup.svg"
            }
        ],
        bundleProductKeys: "atlassian-whiteboard"
    },
    "compass": {
        products: [
            {
                productKey: "compass",
                productName: "Compass",
                productLogoUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg"
            }
        ],
        bundleProductKeys: "compass"
    },
    "jira-software-compass-confluence-test": {
        products: [
            {
                productKey: "jira-software.ondemand",
                productName: "Jira Software",
                productLogoUrl: "https://atlassian.com/dam/jcr:75ba14ba-5e19-46c7-98ef-473289b982a7/Jira%20Software-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:01ede145-9e42-4103-a491-a389759fa0f2/Jira%20Software-white.svg"
            },
            {
                productKey: "compass",
                productName: "Compass",
                productLogoUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:d1f2bb70-4bce-48a4-ae05-f83adb30ac58/Avocado.svg"
            },
            {
                productKey: "confluence.ondemand",
                productName: "Confluence",
                productLogoUrl: "https://atlassian.com/dam/jcr:1b7f4009-27d0-4882-8629-cecae97fc00f/Confluence-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:354c3cfa-8e3e-4f6f-8699-063a78d73d69/Confluence_1-white.svg"
            }
        ],
        bundleProductKeys: "jira-software.ondemand,compass,confluence.ondemand"
    },
    "jira-product-discovery": {
        products: [
            {
                productKey: "jira-product-discovery",
                productName: "Jira Product Discovery",
                productLogoUrl: "https://atlassian.com/dam/jcr:47be17fd-8047-4a14-bc38-c1ebbb80e037/Jira%20Product%20Discovery-logo-blue.svg",
                productLogoWhiteUrl: "https://atlassian.com/dam/jcr:2d01e092-097f-4417-875b-8997fecb2318/jpd-white.svg"
            }
        ],
        bundleProductKeys: "jira-product-discovery"
    },
    "loom": {
        products: [
            {
                productKey: "loom",
                productName: "loom",
                productLogoUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/4o2u5s554348i6h5645mq8ar7ntw5450.svg"
            }
        ],
        bundleProductKeys: "loom"
    },
    "devai": {
        products: [
            {
                productKey: "devai.ondemand",
                productName: "Rovo Dev Agents",
                productLogoUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/417u1uw47033q7c71d0377515lniksis.svg",
                productLogoWhiteUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/027p7mh4up3fs845s7s5ac544n4q4dfy.svg"
            }
        ],
        bundleProductKeys: "devai"
    }
};
const $e4e5eadbc4abf3fb$export$c9799c6be3cce220 = {
    enableTintinMvp: true,
    provisionSecondPartyApps: false,
    enableBundlesAfterSignup: false,
    enableUseCodeAWSContent: false,
    enableDeferredSiteName: false,
    enableDeferredFullName: false,
    enableDefaultExpandedEmail: true,
    enableCutSignUpStepsInHalf: false,
    enableReverseTrial: "not_enrolled"
};
const $e4e5eadbc4abf3fb$export$ab4f92552796fc83 = {
    "WacSignupForm.migrationFeatureList": '<h4>Free cloud migration trial for our self-managed customers</h4>\n\n<ul>\n	<li>Try {productName} cloud at no cost</li>\n	<li>Up to {usageLimit} {userType}</li>\n	<li>No impact to your existing self-managed products</li>\n</ul>\n\n<p><a href="/migration/assess/cloud-migration-trial">Learn more</a></p>',
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFree": "Get started",
    "WacSignupForm.sideInfoHeaderBundleJSWBitbucket": "Automate your way to faster releases",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofImage": "jcr:f91dc7b8-ec95-4ae5-91e3-d5f6acc169dd",
    "WacSignupForm.customizeYourFreePlan": "Customize your free plan",
    "WacSignupForm.errorDomainLengthMinMsgDevops": "Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    "WacSignupForm.signupFormPostContent": "NO CREDIT CARD REQUIRED",
    "WacSignupForm.loginChooseSignup": "<p>Trying to access Confluence? <a href='https://id.atlassian.com/login'>Log in</a></p>",
    "WacSignupForm.cloudEulaText": '<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a>.</p>',
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeacon": "Unlimited free user invites",
    "WacSignupForm.sideInfoHeaderBundleDeveloperMode": "Cloud Developer Bundle",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeCanvas": "Express thoughts and ideas in more ways than ever before\nVisualize how ideas and work fits together throughout workflows\nSpend less time moving ideas to action with integrations\nEnjoy all features and give feedback with free early access",
    "WacSignupForm.existingSite": "Use an existing site",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJSD": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.socialSignUpButtonContinueWithMicrosoft": "Continue with Microsoft",
    "WacSignupForm.submitInitialLabel": "Start free trial now",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAlpha": "Get started",
    "WacSignupForm.passwordWeak": "Password Strength: Weak",
    "WacSignupForm.informMessageStartNewSiteSimplified": "Start a new site",
    "WacSignupForm.socialSignUpOr": "OR",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardBundleJSWBitbucket": "Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeta": "Get started",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAlpha": "Free during alpha",
    "WacSignupForm.submitInitialN2ELabel": "Start now",
    "WacSignupForm.infoBoxModal": '<p>A site is the unique URL where you access your Atlassian products&ndash;Confluence, Jira Software, Jira Service Management, or Jira Work Management.<br /><br />You access Bitbucket Cloud account on <a href="https://bitbucket.org/">bitbucket.org</a>.</p>',
    "WacSignupForm.infoBoxSiteJsw": "Select an existing site below and we\u2019ll create a new Bitbucket Cloud account for you using the same name.",
    "WacSignupForm.errorFirstNameMsg": "Please enter your first name.",
    "WacSignupForm.localeErrorButton": "Learn more",
    "WacSignupForm.errorDomainTakenMsg": "This site is already taken.",
    "WacSignupForm.errorName": "Full name can\u2019t use special characters.",
    "WacSignupForm.dropdownWithoutJiraSoftware": "Sites without Jira Software:",
    "WacSignupForm.signupOfferingTrialLengthTextExistingSite": "1-month free cloud trial",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTeamCentral": "Simplify your status reporting",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextTownsquare": "Simplify your status reporting",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeConfluence": "Free for up to 10 users",
    "WacSignupForm.opsgenieDataStorageInfoBoxCopy": '<p>Some of your data is automatically stored in the US. <a href="/software/opsgenie/tos">Learn more</a></p>',
    "WacSignupForm.premiumUpgradeHelpTooltipTrigger": "Site not listed?",
    "WacSignupForm.informMessageCouponError": '<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
    "WacSignupForm.freeBreachInfoBoxCopy": "<p><strong>Sorry, Cloud Free is limited to 10 users or 3 agents</strong><br />\nIt looks like this site has more than the allowed limit of users (or agents) for our Cloud Free plans. Please choose our Cloud Standard or Premium plans to accommodate the number of users (or agents) on this site.</p>",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardBundleDeveloperMode": "<p>You are signing up for free development sites&nbsp;of Atlassian cloud products. This gives you&nbsp;access to the standard versions of Jira Software, Service Collection, and Confluence, which are free forever.</p>\n\n<p>Free development sites are intended to be used for development and testing purposes only and have&nbsp;the usage limits noted below. Atlassian does not offer support for free development sites and reserves the right to delete such sites at any time without notice. Atlassian monitors the usage of such development sites and may cancel any site being used in an unauthorized or unintended manner.</p>\n\n<ul>\n	<li>Confluence: 5 users free</li>\n	<li>Jira Software: 5 users free</li>\n	<li>Service Collection: 1 agent free</li>\n	<li>All products: Up to 250 GB of file storage</li>\n	<li>All products: Advanced permissions</li>\n</ul>",
    "WacSignupForm.infoBoxBb": "You already have a Bitbucket Cloud account. Create a new site for Jira Software and they'll be automatically integrated.",
    "WacSignupForm.eulaCompassTooltip": "<p>The EAP products are considered &ldquo;Beta Versions&rdquo;, as set forth in Section 14 of the TOS and are subject to applicable terms, conditions, and disclaimers. Atlassian will use the information you provide on this sign-up form to contact you about the EAP program, including updates to the program, feedback requests, and offers.</p>",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCompass": "Create a better developer experience with Compass",
    "WacSignupForm.signupOfferingIncludesFeaturesStandard": "Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support",
    "WacSignupForm.errorPasswordMinMsg": "Password must be at least 8 characters long.",
    "WacSignupForm.socialSignUpLoadingText": "checking a few things...",
    "WacSignupForm.localeError": "We stand with Ukraine",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardJSD": "7-day free trial for up to 5,000 agents",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingIncentiveJSD": "10 free agents for 12 months",
    "WacSignupForm.signupFormPersonalizedGreeting": "Welcome back, {username}",
    "WacSignupForm.freeAndNoCreditCardNeeded": "Free for up to 10 users. No credit card needed.",
    "WacSignupForm.freeToGetStarted": "Free to get started, no credit card needed.",
    "WacSignupForm.passwordModerate": "Password Strength: Moderate",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumBitbucket": "<h4>Free cloud migration trials for our self-managed customers</h4>\n\n<ul>\n	<li>Unlimited users</li>\n	<li>CI/CD built-in</li>\n	<li>No impact to self-managed product</li>\n</ul>",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSWBitbucket": "Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeBeacon": "Increase your visibility and understanding of risks\nBridge the gap between technology and security experts\nExpedite detection, alerting, and response workflows",
    "WacSignupForm.signupOfferingIncludesFeaturesLoom": "Record your screen and camera. Create video messages for your coworkers or customers.\nPolish your videos without lifting a finger. Use Loom AI to generate video titles, summaries, and transcripts.\nEngage viewers easily. Add comments, react with emojis, and include CTA buttons to share relevant resources.\nUse Loom for feedback, onboarding, announcements, and presentation videos.",
    "WacSignupForm.socialSignUpButtonSignUpWithGoogle": "Sign up with Google",
    "WacSignupForm.freeBreachInfoBoxCopyJsmIncentive": '<p>Sorry, the number of agents on this site exceeds the total number allowed for the limited-time offer to get 10 free agents. Click <a href="https://atlassian.com/try/cloud/signup?bundle=jira-service-management&amp;edition=standard">here</a> to signup for a paid Standard plan instead.</p>',
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJSD": "Free for up to 3 agents",
    "WacSignupForm.devopsButtonText": "Sign up",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluence": "Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content",
    "WacSignupForm.noCreditCardNeeded": "No credit card needed.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSD": "Powering high-velocity service teams",
    "WacSignupForm.errorEmailInUseMsg": "Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBundlesLayout": "For up to 10 users",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJSDFI": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandardConfluence": "Start now",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJSD": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumBundleJSWBitbucket": "Automatic development updates in Jira\nInteract with Jira issues in Bitbucket and your IDE\nFree for up to 5 Bitbucket and 10 Jira users",
    "WacSignupForm.reCaptchaLegal": 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    "WacSignupForm.premiumUpgradeHelpTooltipText": '<p>To upgrade to Premium you must log in to your site as a site adminstrator and switch your plan from within billing administration. More information <a href="https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans" target="_blank">here</a>.</p>',
    "WacSignupForm.informMessageSwitchSiteSimplified": "Switch to a different site",
    "WacSignupForm.showPasswordLabel": "Show password",
    "WacSignupForm.claimedMigrationSource": '<h4>Your extended trial has already been activated</h4>\n\n<p>It looks like someone has already activated this trial.</p>\n\n<p>Log in to <a href="https://my.atlassian.com">my.atlassian.com</a> or contact your site administrator for more information.</p>',
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardConfluence": "7-day free trial for up to 50,000 users",
    "WacSignupForm.errorDomainIsAnnualMsg": "The Free plan is not yet available for annual subscriptions. Please select a site on a monthly subscription.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofText": "Trusted by over 65,000 teams worldwide",
    "WacSignupForm.siteNameLabel": "Site name",
    "WacSignupForm.siteNameSuiteLabel": "Name your suite",
    "WacSignupForm.warningTimeoutPending": "Something went wrong. Wait a few minutes, then try again.",
    "WacSignupForm.freeBreachInfoBoxConsiderTrial": "Consider a Standard trial",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeOpsgenie": "Alerting and on-call management\nAdd unlimited users\nStart with Essentials features\nUpgrade to another plan at any time",
    "WacSignupForm.errorNameLength": "Full name must not be greater than 255 characters.",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJira": "Acheive goals faster with project templates\nShare data, workflows, and automate tasks to stay connected\nCentralize reporting and roadmaps across teams\nCustomize Jira with integrations from the Atlassian Marketplace",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJiraCore": "jcr:f00e5006-4d17-4565-bf8b-89a0867d4388",
    "WacSignupForm.infoBoxSite": "You already have a site with other Atlassian products in which Jira Software will be added to. We'll create a new Bitbucket Cloud account for you using the same name.",
    "WacSignupForm.bitbucketAccountDuplicate": "Create a new Bitbucket Cloud account using the same name as the site above.",
    "WacSignupForm.emailPlaceholder": "sallysmith@email.com",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJSDFI": "Access all features\nResolve issues as a team\nQuickly answer common questions\nAutomate incident management",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJiraCore": "jcr:be8dde61-ffff-4cb6-85a7-a0ec682c77de",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageBitbucket": "jcr:28ba5f01-4096-429e-887f-3d9fc016b65a",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBitbucket": "Source code management & CI/CD",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageBitbucket": "jcr:32afaf4e-4665-4087-9a16-29b429a94336",
    "WacSignupForm.errorDomainLengthMinMsgDeferredSiteName": "Must be at least three characters (numerals or lowercase letters only). Can\u2019t start or end with a hyphen (-).",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBundlesLayout": "Get started for free",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJiraProductDiscovery": "Capture ideas and data from anywhere\nPrioritize the work that will make an impact\nKeep stakeholders informed and engaged\nFully integrated with Jira Software for delivery",
    "WacSignupForm.dropdownWithoutRecommended": "OTHER SITES",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextBeacon": "Threat detection for secure collaboration!",
    "WacSignupForm.freeBreachLimitExceededErrorJsmIncentive": "This site exceeds the number of agents eligible for the offer.",
    "WacSignupForm.signupOfferingTrialLengthTextNewSite": "7-day free cloud trial",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeBeacon": "Start Now",
    "WacSignupForm.siteNameOptional": "Site name (optional)",
    "WacSignupForm.errorDomainLengthMaxMsg": "That's a bit too long \u2014 try something 50 characters or less.",
    "WacSignupForm.passwordLabel": "Password",
    "WacSignupForm.jsmConfluenceNotice": "For the seamless setup of your knowledge base, we suggest adding Jira Service Management to a site that already has Confluence. You won\u2019t be able to link these sites later.",
    "WacSignupForm.errorValidationMessage": "Please review the highlighted fields below and try again.",
    "WacSignupForm.dropdownWithRecommended": "RECOMMENDED SITES",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeStatuspage": "Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeJiraProductDiscovery": "Free for up to 3 creators and unlimited contributors",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImage": "jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageConfluence": "jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97",
    "WacSignupForm.helpTooltipText": "Must be at least 3 lowercase characters, numbers and letters only.",
    "WacSignupForm.localeErrorMessage": "Following the Russian invasion of Ukraine, we are pausing the sale of new software in Russia and Belarus.",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeading": "Start now",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJSWFI": "Scale agile practices\nConsolidate workflows\nExpand visibility\nPlan, track, and release",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageJSD": "jcr:afd73b6a-2ece-4fa3-bfbd-ada0ba2bc2c1",
    "WacSignupForm.informMessageCouponSuccess": '<p>The coupon you requested is {{couponStatus}}, please <a href="/company/contact">contact us</a> for additional support.</p>',
    "WacSignupForm.siteNameSuiteDescriptionDevops": "* We\u2019ll use this to name your sites and workspaces",
    "WacSignupForm.eulaJsmIncentive": '<p>By clicking below, you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a> and <a href="https://atlassian.com/end-bsm-now/terms-and-conditions">Terms &amp; Conditions</a> of the offer.</p>',
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingIncentiveJSD": "Start now",
    "WacSignupForm.alwaysFreeForUpto": "Always free for up to 10 users.",
    "WacSignupForm.signupFormGreeting": "Create your account",
    "WacSignupForm.signupOfferingIncludesHeading": "Trial includes",
    "WacSignupForm.emailLabel": "Work email",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJSDFI": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.firstNameLabel": "First name",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraCore": "Connected teams work better together",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeConfluence": "Get started",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumStatuspage": "Free to set up. Launch it when you&rsquo;re ready.\nAccess to all features and capabilities\nZero obligation, no credit card required\nAdd up to 25 team members\nTechnical and sales support available",
    "WacSignupForm.siteNameInstructionsExperimentB": "This site name is just a suggestion. Feel free to change to something your team will recognize.",
    "WacSignupForm.yourBitbucketAccount": "Your Bitbucket Cloud account",
    "WacSignupForm.inputSiteNameMessage": "Your site name appears in the URL for your Atlassian products. Most people use their team or company name. You can change your site name later.",
    "WacSignupForm.marketingCommunicationsCheckboxSignupText": "Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJiraCore": "Access all features\nCustomize project templates\nTrack and automate every detail\nAnalyze team progress",
    "WacSignupForm.passwordVeryStrong": "Password Strength: Very strong",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeBundleJSD": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.socialSignUpErrorTextContactUs": '<div>If the problem persists, <a href="{contactUsUrl}">contact us</a>.</div>',
    "WacSignupForm.signupOfferingIncludesFeaturesFreeTeamCentral": "Connect work to outcomes\nGet updates with just enough context\nLet Atlas know everyone, so you can too\nLearn without knowing who to ask",
    "WacSignupForm.devopsCarouselButton": "Get started in {product}",
    "WacSignupForm.invalidMigrationSource": '<h4>Invalid trial activation</h4>\n\n<p>It looks like we weren&#39;t able to activate your cloud migration trial.</p>\n\n<p>Check with the site administrator, or login to <a href="https://my.atlassian.com">my.atlassian.com</a> to confirm your activation link is complete and correct, and that you have an eligible server or Data Center license.</p>',
    "WacSignupForm.infoBoxModalCta": "Understand site and Bitbucket Cloud account",
    "WacSignupForm.dropdownWithJiraSoftware": "Sites with Jira Software:",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingStandard": "Start now",
    "WacSignupForm.opsgenieDataRegionLabel": "Select the data center region to store your Opsgenie specific product data",
    "WacSignupForm.informDomainEmptyMsg": "Looking to add products to an existing site?",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeCompass": "Reduce context switching with a comprehensive software catalog\nKeep your architecture reliable, performant, and secure with scorecards and metrics\nConnect your existing tools and data and create custom integrations for a bespoke developer experience",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardAtlas": "14-day free trial for up to 35,000 users",
    "WacSignupForm.errorTimeout": '<p>It&#39;s taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <a href="/company/contact">contact us</a>.</p>',
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJiraCore": "Let teams collaborate at scale\nCustomize how work is tracked\nExpand visibility\nSave time with automation",
    "WacSignupForm.infoBoxDefault": "",
    "WacSignupForm.infoBoxSiteBb": "You already have a site with other Atlassian products in which Jira Software will be added to. You also have a Bitbucket Cloud account. They will be automatically integrated.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJiraProductDiscovery": "Transform product ideas into business impact",
    "WacSignupForm.deferredSiteNameTooltipText": "Your site name is the URL used to find your site, so try something your team will easily recognize.",
    "WacSignupForm.siteNameSuiteDescriptionLabel": "* We\u2019ll use this to name your site and workspaces",
    "WacSignupForm.socialSignUpOrSignUpWith": "Or sign up with",
    "WacSignupForm.submitN2ELabel": "Agree and start now",
    "WacSignupForm.socialSignUpButtonContinueWithGoogle": "Continue with Google",
    "WacSignupForm.eulaCutSignupInHalf": "<p>By clicking \"Sign up\" below, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJSDIncentive": "Get started with 10 agents for free for 12 months!*",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeBitbucket": "Included build minutes and Git LFS\nNative Jira integration\nEasily extensible\nSecure & reliable",
    "WacSignupForm.signupOfferingIncludesHeadingFree": "Subscription includes",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJSWFI": "\nAccess all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextConfluence": "Trusted by over 75,000 teams worldwide",
    "WacSignupForm.eulaCompass": '<p>By signing up for this Early Access Program (&ldquo;EAP&rdquo;), you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service" rel="noopener noreferrer" target="_blank">Cloud Terms of Service</a> (&ldquo;TOS&rdquo;) and acknowledge the Atlassian <a href="https://www.atlassian.com/legal/privacy-policy" rel="noopener noreferrer" target="_blank">Privacy Policy</a></p>',
    "WacSignupForm.informDomainIsUsersMsg": "Is it yours?",
    "WacSignupForm.errorDomainTakenMsgDeferredSiteName": "This site name is already taken.",
    "WacSignupForm.passwordPlaceholder": "Combine letters, numbers and symbols",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeAtlas": "Start Now",
    "WacSignupForm.fullNameLabel": "Full name",
    "WacSignupForm.passwordStrong": "Password Strength: Strong",
    "WacSignupForm.userTypeUsersLabel": "users",
    "WacSignupForm.socialSignUpSomethingWentWrong": "<h3>Something went wrong</h3>",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJSD": "Start now",
    "WacSignupForm.siteNameN2ELabel": "Your site",
    "WacSignupForm.errorLastNameMsg": "Please enter your last name.",
    "WacSignupForm.personalizedNameSiteMessage": "Let\u2019s name your site, {username}",
    "WacSignupForm.siteNamePlaceholder": "yoursite",
    "WacSignupForm.eulaChooseSignup": "<p>By clicking \u201CContinue\u201D below, you agree to the Atlassian Cloud <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Terms of Service</a> and acknowledge the Atlassian <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy</a>.</p>",
    "WacSignupForm.socialSignUpButtonSignUpWithEmail": "Sign up with email",
    "WacSignupForm.helpTooltipTextDevops": "Choose a name for the sites and workspaces that will make up your suite. Most teams use their company or organization.",
    "WacSignupForm.informEmailLoggedInMsg.link": '<a href="{switchAccountUrl}">Sign in with a different Atlassian account</a>',
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofImageConfluence": "jcr:53e25eff-e025-41d0-88ec-2f1420f89131",
    "WacSignupForm.errorCaptchaMsg": "Error with captcha verification.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofHeroImageJSD": "jcr:45864a30-5470-4cbe-be59-9aae63492229",
    "WacSignupForm.freeBreachLimitExceededError": "This site has more users than Free allows.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextCanvas": "A collaborative whiteboard for teams",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeBeta": "Free during beta",
    "WacSignupForm.errorDomainLengthMinMsg": "Your site name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeFabric": "Unlimited free users",
    "WacSignupForm.lastNameLabel": "Last name",
    "WacSignupForm.jswTrialNotice": "You'll get a 1-month free trial of Jira Software for this site.",
    "WacSignupForm.errorEmailInvalidMsg": "Please enter a valid email address.",
    "WacSignupForm.lastNamePlaceholder": "Last",
    "WacSignupForm.accountIdMisMatch": "<span>Something went wrong. Please refresh your page, then try again.</span>",
    "WacSignupForm.startButtonTextChooseSignup": "Continue",
    "WacSignupForm.selectOrganization": "Select your Atlassian organization",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJSWFI": "Access all features\nScale agile practices\nConsolidate workflows\nPlan, track, and release",
    "WacSignupForm.signupOfferingIncludesFeaturesPremium": "Full access to all features\nZero obligation, no credit card needed\nAdd up to 10,000 users\nAccess to sales and technical support",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormHeadingFreeJiraProductDiscovery": "Get started",
    "WacSignupForm.signupOfferingTrialLengthTextNewSiteOpsgenie": "14-day free Essentials trial",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluence": "Access all features\nKickstart team collaboration\nCapture all the knowledge\nBuild admirable content",
    "WacSignupForm.socialSignUpSorryForTheInconvenience": "<div>Sorry for the inconvenience</div>",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFreeAtlas": "Free up to 35,000 users",
    "WacSignupForm.freeBreachInfoBoxStartTrialCta": "Start a 30-day trial",
    "WacSignupForm.siteNameOptionalMessageN2E": "Choose an existing site below, or create a new one.",
    "WacSignupForm.siteNameInstructions": "Must be at least three characters (numbers or lowercase letters only) and can\u2019t start or end with a hyphen (-).",
    "WacSignupForm.siteNameOptionalMessageN2N": "Don't worry, you can change this later.",
    "WacSignupForm.firstNamePlaceholder": "First",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeJiraCore": "Calendar, list, timeline, and board views to track work\nQuickly create forms with a drag-and-drop builder\nSave your team&#39;s time with our automation library\nHelp teams stay in sync with customizable workflows",
    "WacSignupForm.submitCouponLabel": "Agree",
    "WacSignupForm.warningNetworkError": "Something went wrong. Please try again.",
    "WacSignupForm.userTypeAgentsLabel": "agents",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJSD": "Connect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandardBeacon": "Unlimited free users",
    "WacSignupForm.signupOfferingIncludesFeaturesFreeConfluence": "Kickstart team collaboration\nIncrease transparency\nCapture all the knowledge\nBuild admirable content",
    "WacSignupForm.errorEmailInUseLoginToContinueMsg": "Log in to continue.",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingStandard": "7-day free trial for up to 35,000 users",
    "WacSignupForm.signupOfferingIncludesFeaturesFree": "Access to Free features\n2 GB storage\nFor up to 10 users\nCommunity Support",
    "WacSignupForm.useDifferentAccountSignin.link": '<a href="{switchAccountUrl}">Use a different Atlassian account</a>',
    "WacSignupForm.informMessageDeveloperWarning": "<h4>You are signing up for a free development instance of Atlassian Cloud.</h4>\n\n<p>Free development instances are intended to be used for development and testing purposes only and has the usage limits noted below.Atlassian does not offer support for free development instances and reserves the right to delete such instances at any time without notice.Atlassian monitors the usage of such development instances and may cancel any instance being used in an unauthorized or unintended manner.</p>\n\nJira Software, Jira Core: 5 users free\nJira Service Desk: 1 agent free\nConfluence: 5 users free",
    "WacSignupForm.submitProcessingLabel": "Starting...",
    "WacSignupForm.signupOfferingIncludesFeaturesIncentiveJSD": "Access all features of our Standard plan\nConnect dev, IT Ops, and business teams on one platform\nDeliver great service experiences across teams, fast\nRespond to changes and keep services up and running\nCollaborate on one platform\nResolve incidents quickly\n\n<p>* After one year, convert to a paid plan or keep using Jira Service Management on the Free plan with up to 3 agents.</p>",
    "WacSignupForm.informDomainAddToExistingsMsg": "Add products to existing site",
    "WacSignupForm.signupOfferingIncludesFeaturesSignupFormSubheadingFree": "Free for up to 10 users \u2014 no credit card needed.",
    "WacSignupForm.signupOfferingIncludesFeaturesSocialProofTextJira": "Trusted by over 65,000 teams worldwide",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageTeamCentral": "jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b",
    "WacSignupForm.FirstImpressions.socialSignUpButtonSignUpWithEmail": "Sign up with email",
    "WacSignupForm.FirstImpressions.inputLabelFullName": "Full name",
    "WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductName": "Confluence",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImage": "jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674",
    "WacSignupForm.FirstImpressions.errorSsoInUse": "You must use single sign-on to access your account and continue signing up for your product. <a href='{redirectUrl}'>Login to continue</a>.",
    "WacSignupForm.FirstImpressions.inputLabelRequired": "Required",
    "WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormHeader": "Let get it started!",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageJSD": "jcr:45864a30-5470-4cbe-be59-9aae63492229",
    "WacSignupForm.FirstImpressions.firstImpressionsLoggedInFormHeader": "Welcome back, {userName}",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageConfluence": "jcr:ed997381-ade2-440b-8374-7d2095bd7b38",
    "WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductName": "Jira Software",
    "WacSignupForm.FirstImpressions.teamCentralLoggedOutViewFormHeader": "Hi there",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageJira": "jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageFabric": "jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageBeacon": "jcr:f82f862b-5d6b-49ec-9d95-886664208834",
    "WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonTitle": "Get it free",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJSD": "jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898",
    "WacSignupForm.FirstImpressions.inputLabelWorkEmail": "Work email",
    "WacSignupForm.FirstImpressions.submitButtonLabel": "Agree",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageTeamCentral": "jcr:9991958d-3d80-45fd-9af0-c53d15270ec8",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraProductDiscovery": "jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5",
    "WacSignupForm.FirstImpressions.teamCentralIneligibleViewSwitchAccountLink": "Sign in with a different Atlassian account",
    "WacSignupForm.FirstImpressions.noCreditCardRequiredFooter": "No credit card required",
    "BxpSignup.PaymentDetailsHeading": "Add your payment details",
    "BxpSignup.PaymentDetailsSubtitle": "to start a Rovo Dev 30 day free trial",
    "BxpSignup.PaymentDetailsBack": "Back",
    "BxpSignup.PaymentDetailsSubmit": "I've added my payment details",
    "BxpSignup.AddPaymentMethod.Title": "Add a payment method to start your trial",
    "BxpSignup.AddPaymentMethod.Intro": "We couldn't find a payment method for your site, a billing admin must add one before you start a trial.",
    "BxpSignup.AddPaymentMethod.NoChargeTitle": "No charge until trial ends",
    "BxpSignup.AddPaymentMethod.NoChargeBody": "There's no charge today, billing doesn't begin until the end of your trial.",
    "BxpSignup.AddPaymentMethod.CancelAnytimeTitle": "Cancel anytime",
    "BxpSignup.AddPaymentMethod.CancelAnytimeBody": "If you want to end your trial, cancel anytime in Atlassian Administration.",
    "BxpSignup.AddPaymentMethod.HowToTitle": "How to add a payment method",
    "BxpSignup.AddPaymentMethod.Step1Title": "Go to payment methods in Atlassian Administration",
    "BxpSignup.AddPaymentMethod.Step1Body": "Billing admin role required to add payment methods.",
    "BxpSignup.AddPaymentMethod.ReadAboutPermissions": "Read about permissions",
    "BxpSignup.AddPaymentMethod.OpenPaymentMethods": "Open payment methods",
    "BxpSignup.AddPaymentMethod.Step2Title": "Enter your billing details",
    "BxpSignup.AddPaymentMethod.Step2Body": "Add a billing address and payment method. We accept credit cards and PayPal.",
    "BxpSignup.AddPaymentMethod.Step3Title": "Close the payment methods tab",
    "BxpSignup.AddPaymentMethod.Step3Body": "When you're done, close the payment methods window and return here.",
    "BxpSignup.AddPaymentMethod.Step4Title": "Return and set up your trial",
    "BxpSignup.AddPaymentMethod.Step4Body": "After adding a payment method, return to where you started and set up your trial again.",
    "BxpSignup.AddPaymentMethod.CloseAndGoBack": "Close and go back",
    "WacSignupForm.FirstImpressions.socialSignUpButtonContinueWithGoogle": "Continue with Google",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageJiraCore": "jcr:f00e5006-4d17-4565-bf8b-89a0867d4388",
    "WacSignupForm.FirstImpressions.teamCentralIneligibleViewFormHeader": "Welcome back, {userName}",
    "WacSignupForm.FirstImpressions.firstImpressionsLoggedOutFormSubHeader": "Free for up to 10 users",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJira": "jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1",
    "WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonProductDescription": "Project and issue tracking",
    "WacSignupForm.FirstImpressions.teamCentralLoggedOutViewAlreadyHaveAccount": "if you already have an Atlassian account",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageCompass": "jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96",
    "WacSignupForm.FirstImpressions.teamCentralGetJiraFreeButtonTitle": "Get it free",
    "WacSignupForm.FirstImpressions.inputLabelFullNameLengthError": "Must be 255 characters or less",
    "WacSignupForm.FirstImpressions.inputLabelWorkEmailError": "Invalid email address",
    "WacSignupForm.FirstImpressions.firstImpressionBackgroundImage": "jcr:fa398d64-ddab-4e01-b3bf-90042efc7638",
    "WacSignupForm.FirstImpressions.firstImpressionsHeroImageConfluence": "jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97",
    "WacSignupForm.FirstImpressions.teamCentralLoggedOutViewLogIn": "Log in",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraProductDiscovery": "jcr:a8911809-1897-4fbc-9a7e-086e07e07199",
    "WacSignupForm.FirstImpressions.teamCentralSignUpForOtherProductsFirst": "Sign up for Jira or Confluence to coordinate and collaborate on Team Central",
    "WacSignupForm.FirstImpressions.firstImpressionsEula": "<p>By signing up, you agree to the Atlassian <a href='https://www.atlassian.com/legal/cloud-terms-of-service'>Cloud Terms of Service</a> and <a href='https://www.atlassian.com/legal/privacy-policy'>Privacy Policy.</a></p>",
    "WacSignupForm.FirstImpressions.teamCentralGetConfluenceFreeButtonProductDescription": "Document collaboration",
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImage": "jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1",
    "WacSignupForm.FirstImpressions.firstImpressionsRecaptcha": 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    "WacSignupForm.FirstImpressions.firstImpressionsSocialProofImageJiraCore": "jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654",
    "WacSignupForm.SimpleSignup.noCreditCardRequiredFooter": "Always free, no credit card needed.",
    "WacSignupForm.SimpleSignup.slideProductConfirmationProductsNew": "New Products",
    "WacSignupForm.SimpleSignup.jswMobileNavImage": "jcr:75a99fa9-2d9f-4eb6-b856-cb450b77f656",
    "WacSignupForm.SimpleSignup.productListBitbucketDescription": "Ship quality code as a team",
    "WacSignupForm.SimpleSignup.slideProductConfirmationHeader": "Review your toolchain",
    "WacSignupForm.SimpleSignup.inputLabelSitenameNew": "Name your suite",
    "WacSignupForm.SimpleSignup.socialSignUpButtonContinueWithGoogle": "Continue with Google",
    "WacSignupForm.SimpleSignup.slideExistingSiteSubHeader": "Start building your toolchain with our flagship products for free, then upgrade or add more third-party tools later.",
    "WacSignupForm.SimpleSignup.socialSignUpButtonSignUpWithEmail": "Sign up with email",
    "WacSignupForm.SimpleSignup.errorName": "Invalid name pattern.",
    "WacSignupForm.SimpleSignup.inputLabelFullName": "Full name",
    "WacSignupForm.SimpleSignup.errorEmailInUse": "Oops, an Atlassian account with this email already exists. If you are the owner of this account, please <a href='{signInAccountUrl}'>login to continue</a>.",
    "WacSignupForm.SimpleSignup.passwordWeak": "Weak",
    "WacSignupForm.SimpleSignup.inputDescriptionSitenameExisting": "The address your team will use to access Jira Software",
    "WacSignupForm.SimpleSignup.simpleSignupEula": 'By clicking "Sign up", you agree to the Atlassian <a href="https://www.atlassian.com/legal/cloud-terms-of-service">Cloud Terms of Service</a> and <a href="https://www.atlassian.com/legal/privacy-policy">Privacy Policy</a>.',
    "WacSignupForm.SimpleSignup.atlassianLogoImage": "jcr:fbe85a9f-3381-4a48-afbc-074287bc4ba9",
    "WacSignupForm.SimpleSignup.errorSsoInUse": "You must use single sign-on to access your account and continue signing up for your product. <a href='{signInAccountUrl}'>Login to continue.</a>",
    "WacSignupForm.SimpleSignup.productListOpsgenieDescription": "Streamline incident management",
    "WacSignupForm.SimpleSignup.submitButtonLoggedOut": "Sign up",
    "WacSignupForm.SimpleSignup.openDevOps": "Open DevOps",
    "WacSignupForm.SimpleSignup.slideConfirmationHeader": "You're almost there!",
    "WacSignupForm.SimpleSignup.errorSitenameUnavailable": "This suite is already taken.",
    "WacSignupForm.SimpleSignup.inputDescriptionSitenameNew": "",
    "WacSignupForm.SimpleSignup.inputLabelRequired": "Enter your email",
    "WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubmitError": "Something went wrong, please try again.",
    "WacSignupForm.SimpleSignup.slideExistingSiteSubHeaderTooltip": "If your chosen site does not include Jira software, we\u2019ll add and integrate it with your suite.",
    "WacSignupForm.SimpleSignup.slideConfirmationSubHeaderText": "Your new products are now connected to your site.",
    "WacSignupForm.SimpleSignup.noCard": "No Credit Card Required",
    "WacSignupForm.SimpleSignup.inputToggleSitenameExisting": "Use an existing site",
    "WacSignupForm.SimpleSignup.socialSignUpButtonSignupWithGoogle": "Sign up with Google",
    "WacSignupForm.SimpleSignup.socialSignUpOr": "OR",
    "WacSignupForm.SimpleSignup.welcomeMessageLoggedOut": "Create your account",
    "WacSignupForm.SimpleSignup.passwordStrength": "Password strength:",
    "WacSignupForm.SimpleSignup.slideProductConfirmationSubHeader": "You\u2019ll connect these products to your site. Remember, new products are free!",
    "WacSignupForm.SimpleSignup.errorSitenameInvalid": "Your suite name must be 3 or more lowercase letters and/or numbers. Hyphens are ok if they\u2019re in the middle.",
    "WacSignupForm.SimpleSignup.siteNameFormHeader": "Your site name will be in the URL to access your site, so pick a name that your team will recognize.",
    "WacSignupForm.SimpleSignup.slideExistingWorkspaceSubHeader": "Integrate Jira, Confluence and Opsgenie with Bitbucket for free, then upgrade or add more third-party tools later.",
    "WacSignupForm.SimpleSignup.slideConfirmationGetStarted": "Get started in {product}",
    "WacSignupForm.SimpleSignup.inputLabelWorkEmailError": "Invalid email address",
    "WacSignupForm.SimpleSignup.submitButtonLoggedIn": "Sign up",
    "WacSignupForm.SimpleSignup.inputLabelFirstName": "First name",
    "WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormSubHeader": "Your Free cloud plan supports up to 10 users and 2 GB of file storage.",
    "WacSignupForm.SimpleSignup.inputLabelEmail": "Work email",
    "WacSignupForm.SimpleSignup.simpleSignupLoggedOutFormHeader": "Let's get started",
    "WacSignupForm.SimpleSignup.passwordModerate": "Moderate",
    "WacSignupForm.SimpleSignup.productListConfluenceName": "Confluence Cloud",
    "WacSignupForm.SimpleSignup.slideExistingSiteHeader": "Let\u2019s get started",
    "WacSignupForm.SimpleSignup.productListOpsgenieName": "Opsgenie Cloud",
    "WacSignupForm.SimpleSignup.inputLabelSitenameExisting": "Select a site (or type a name to create a new one)",
    "WacSignupForm.SimpleSignup.errorTimeoutN2N": "<span>It's taking longer than expected to get you started. Please check your inbox to see if the request has completed successfully, or <a href='https://www.atlassian.com/company/contact'>contact us</a>.</span>",
    "WacSignupForm.SimpleSignup.simpleSignupSamlRequired": 'You must use single sign-on to access your account and continue signing up for your product. <a href="{loginUrl}">Login to continue</a>',
    "WacSignupForm.SimpleSignup.errorTimeoutN2E": "<span>It\u2019s taking longer than expected to get you started. Please refresh and try again or <a href='https://www.atlassian.com/company/contact' track-link-ga='error-contact-us'>contact us</a>.</span>",
    "WacSignupForm.SimpleSignup.inputLabelWorkspaceExisting": "Select a workspace (or type a name to create a new one)",
    "WacSignupForm.SimpleSignup.nextButton": "Next",
    "WacSignupForm.SimpleSignup.slideProductConfirmationProductsExisting": "Existing Products",
    "WacSignupForm.SimpleSignup.inputLabelWorkEmail": "Work email",
    "WacSignupForm.SimpleSignup.marketingConsent": "Yes! I would like to receive promotional emails including product news, events and more from Atlassian and its affiliates.",
    "WacSignupForm.SimpleSignup.inputLabelLastName": "Last name",
    "WacSignupForm.SimpleSignup.provisioningTakesTime": "Please wait a moment, this can take up to a minute...",
    "WacSignupForm.SimpleSignup.productListJiraSoftwareName": "Jira Software",
    "WacSignupForm.SimpleSignup.slideConfirmationCardText": "You can access your connected work in the <b>Pages</b>, <b>Code</b>, or <b>On-call</b> tabs of your project.",
    "WacSignupForm.SimpleSignup.inputLabelPassword": "Password",
    "WacSignupForm.SimpleSignup.submitButtonLabel": "Sign up",
    "WacSignupForm.SimpleSignup.productListConfluenceDescription": "Collaborate on important documents",
    "WacSignupForm.SimpleSignup.passwordStrong": "Strong",
    "WacSignupForm.SimpleSignup.simpleSignupRecaptcha": 'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.',
    "WacSignupForm.SimpleSignup.errorEmailInvalid": "Please enter a valid email address",
    "WacSignupForm.SimpleSignup.productListJiraSoftwareDescription": "Mission control for your entire team",
    "WacSignupForm.SimpleSignup.socialSignUpDividerLabel": "OR",
    "WacSignupForm.SimpleSignup.previousButton": "Prev",
    "WacSignupForm.SimpleSignup.productListBitbucketName": "Bitbucket Cloud",
    "WacSignupForm.SimpleSignup.inputSitenameExistingPlaceholder": "Select or create a new site",
    "WacSignupForm.SimpleSignup.inputToggleSitenameNew": "Start a new site",
    "WacSignupForm.SimpleSignup.passwordVeryStrong": "Very strong",
    "WacSignupForm.SimpleSignup.inputPlaceholderWorkEmail": "Eg: you@company.com",
    "WacSignupForm.SimpleSignup.slideConfirmationFooterText": "Next, dive into a project to start exploring Atlassian Open DevOps.",
    "WacSignupForm.SimpleSignup.errorPasswordMinMsg": "Password must be at least 8 characters long",
    "PasswordStrength.passwordWeak": "Password Strength: Weak",
    "PasswordStrength.passwordModerate": "Password Strength: Moderate",
    "PasswordStrength.passwordStrong": "Password Strength: Strong",
    "PasswordStrength.passwordVeryStrong": "Password Strength: Very strong",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardUpgradeTitle": "Upgrade to the Standard plan",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardBulletIntro": "The Standard plan also includes:",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceUpgradeBody": "Get a free 14-day trial of Confluence Standard for unlimited users, additional storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Title": "Page & user permissions",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet1Body": "Control space and page access",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Title": "Page insights",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet2Body": "Give content creators insights on page views and comments",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Title": "Business hour support",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardConfluenceBullet3Body": "Get support from Atlassian\u2019s team of experts",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmUpgradeBody": "Get a free 14-day trial of Jira Service Management Standard for unlimited agents, additional storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Title": "On-call management",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet1Body": "Create custom routing rules and escalation policies",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Title": "Unlimited email notifications",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet2Body": "Update everyone about activity on requests",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Title": "Business hour support",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJsmBullet3Body": "Get support from Atlassian\u2019s team of experts",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswUpgradeBody": "Get a free 14-day trial of Jira Standard for unlimited users, additional storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Title": "User roles & permissions",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet1Body": "Have more control over which users have access to different projects and actions.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Title": "Anonymous access",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet2Body": "Give secure access to people outside your team.",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Title": "Business hour support",
    "WacSignupForm.signupOfferingIncludesFeaturesStandardJswBullet3Body": "Get support from Atlassian\u2019s team of experts",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumUpgradeTitle": "Upgrade to the Premium plan",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumBulletIntro": "The Premium plan also includes:",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceUpgradeBody": "Get a free 30-day trial of Confluence Premium for unlimited users, unlimited storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Title": "Atlassian Intelligence (AI)",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet1Body": "AI to create value faster, turn insights into action, and communicate efficiently",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Title": "Unlimited whiteboards",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet2Body": "A digital whiteboard to brainstorm, plan, and action work like never before",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Title": "Premium support",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumConfluenceBullet3Body": "Get 24/7 support from Atlassian\u2019s team of experts",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmUpgradeBody": "Get a free 30-day trial of Jira Service Management Premium for unlimited agents, unlimited storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Title": "Atlassian Intelligence (AI)",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet1Body": "Deliver exceptional service experiences with AI-powered ITSM capabilities",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Title": "Advanced incident management",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet2Body": "Automate your major incident creation process",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Title": "Premium support",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJsmBullet3Body": "Get 24/7 support from Atlassian\u2019s team of experts",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswUpgradeBody": "Get a free 30-day trial of Jira Premium for unlimited users, unlimited storage, and much more. Cancel anytime.",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Title": "Atlassian Intelligence (AI)",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet1Body": "AI-powered features to help teams create value faster",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Title": "Advanced planning",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet2Body": "Plan work and track progress across multiple teams and projects",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Title": "Premium support",
    "WacSignupForm.signupOfferingIncludesFeaturesPremiumJswBullet3Body": "Get 24/7 support from Atlassian\u2019s team of experts",
    "WacSignupForm.bitbucketWorkspaceIdFieldLabelMessage": "Your new workspace",
    "WacSignupForm.bitbucketOrganizationIdFieldLabelMessage": "We'll create your workspace in this organization",
    "WacSignupForm.bitbucketWorkspaceIdFieldHelperMessage": "The workspace ID can only contain lowercase letters, numbers, dashes, and underscores.",
    "WacSignupForm.bitbucketSubmitButtonTextMessage": "Agree and create workspace",
    "WacSignupForm.bitbucketWorkspaceIdFieldErrorMessageCMT": "The workspace ID is invalid. Workspace IDs can only contain lowercase letters, numbers, dashes, and underscores.",
    "WacSignupForm.bitbucketWorkspaceIdTakenErrorMessageCMT": "This workspace ID is taken. Try another ID.",
    "WacSignupForm.bitbucketMissingOrgsInfoMessage": 'If an organization is not listed in the dropdown menu, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
    "WacSignupForm.bitbucketCreateNewOrgInfoMessage": 'We need to create a new Atlassian organization, because you currently do not have an organization in Atlassian\'s centralized user management. If you have any questions, <a href="{supportUrl}" target="_blank">contact our Support team for assistance</a>.',
    "WacSignupForm.bitbucketOrgCreationPreparingProductMessage": "We're preparing your product.",
    "WacSignupForm.bitbucketOrgCreationEstimatedTimeMessage": "This won't take more than a minute or two.",
    "WacSignupForm.productActivationFailureMessage": '<p>Something went wrong on our end. Please try again. If this keeps happening, <a href="https://support.atlassian.com/contact/">contact support</a>.</p>'
};
const $e4e5eadbc4abf3fb$export$624566d9bd207474 = {
    backgroundImage: "https://atlassian.com/dam/jcr:fa398d64-ddab-4e01-b3bf-90042efc7638/blue_wave_background.svg",
    jiraSoftware: {
        heroImage: "https://atlassian.com/dam/jcr:0c7fa8be-146c-4c6f-84de-de9fb3b84674/Jira%20Hero.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg"
    },
    jiraServiceDesk: {
        heroImage: "https://atlassian.com/dam/jcr:45864a30-5470-4cbe-be59-9aae63492229/JSD%20Hero.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:4bacc2d6-c0ff-4949-955e-50cde04a3898/jsm-social-proof-reel.svg"
    },
    confluence: {
        heroImage: "https://atlassian.com/dam/jcr:12b69d08-6ae8-4b14-ac1c-f3092ccaff97/Confluence%20Hero.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:ed997381-ade2-440b-8374-7d2095bd7b38/confluence-social-proof-reel.svg"
    },
    jiraCore: {
        heroImage: "https://atlassian.com/dam/jcr:f00e5006-4d17-4565-bf8b-89a0867d4388/Jira%20Core%20Hero.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:f2b4976d-a53a-42a0-93ec-def9b87fe654/jwm-social-proof-reel.svg"
    },
    teamCentral: {
        heroImage: "https://atlassian.com/dam/jcr:9991958d-3d80-45fd-9af0-c53d15270ec8/atlas-signup-hero.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:80e875ca-274f-44fd-b1d3-50e47c43a73b/atlas-logo-real-448x60-N50.png"
    },
    jiraProductDiscovery: {
        heroImage: "https://atlassian.com/dam/jcr:7cfe6bed-77da-410b-8fcc-2c3f3f78cef5/jpd-hero-image-v3.svg",
        socialProofImage: "https://atlassian.com/dam/jcr:a8911809-1897-4fbc-9a7e-086e07e07199/jpd-social-proof-reel.svg"
    },
    compass: {
        heroImage: "https://atlassian.com/dam/jcr:ddb40094-3568-4eee-84fb-adfd5b20ca96/Compass_SignUpPage_Illo%20(5).svg",
        socialProofImage: ""
    },
    fabric: {
        heroImage: "https://atlassian.com/dam/jcr:978c45e6-3cf7-40d1-9a42-172cc8e77e60/fabric-sign-up-hero-rev@2x.png",
        socialProofImage: ""
    },
    beacon: {
        heroImage: "https://atlassian.com/dam/jcr:f82f862b-5d6b-49ec-9d95-886664208834/beacon-hero.svg",
        socialProofImage: ""
    },
    jira: {
        heroImage: "https://atlassian.com/dam/jcr:775fdafc-0622-4a54-acdf-1c3ca0da5e83/jira-family-hero.png",
        socialProofImage: "https://atlassian.com/dam/jcr:37f44a00-1c5f-45e7-b3f5-a38ad08c46c1/jsw-social-proof-reel.svg"
    },
    bitbucket: {
        heroImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/j6ow7g6d0b514p5fa2265brhf5hyn43l.webp",
        socialProofImage: "https://dam-cdn.atl.orangelogic.com/AssetLink/f21tl4w4krcqx1j1n5b100x1h176wy64.svg"
    }
};





const $cf94e8102e664f13$export$ff7fa7230197689e = {
    bundle: "jira-software",
    description: "Jira",
    key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE,
    name: "jira"
};
const $cf94e8102e664f13$export$b6aad051bad07f12 = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE,
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE,
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SERVICE_MANAGEMENT,
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-service-desk",
        description: "Jira Service Management",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SERVICE_DESK,
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_PRODUCT_DISCOVERY,
        name: "jira-product-discovery"
    },
    {
        bundle: "beacon",
        description: "Beacon",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).BEACON,
        name: "beacon"
    },
    {
        bundle: "bitbucket",
        description: "Bitbucket",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).BITBUCKET,
        name: "bitbucket"
    },
    {
        bundle: "compass",
        description: "Compass",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).COMPASS,
        name: "compass"
    },
    {
        bundle: "fabric",
        description: "Fabric",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).FABRIC,
        name: "fabric"
    },
    {
        bundle: "loom",
        description: "Loom",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).LOOM,
        name: "loom"
    },
    {
        bundle: "opsgenie",
        description: "Opsgenie",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).OPSGENIE,
        name: "opsgenie"
    },
    {
        bundle: "statuspage",
        description: "Statuspage",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).STATUSPAGE,
        name: "statuspage"
    },
    {
        bundle: "devai",
        description: "Rovo Dev Agents",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).DEVAI,
        name: "devai"
    },
    {
        bundle: "rovo",
        description: "Rovo",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).ROVO,
        name: "rovo"
    },
    {
        bundle: "service-collection",
        description: "Service Collection",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION,
        name: "service-collection"
    },
    {
        bundle: "teamwork-collection",
        description: "Teamwork Collection",
        key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION,
        name: "teamwork-collection"
    }
];


const $515725dfc96f8adc$export$93cccec4b411f62 = (location)=>(0, $iSvIT.useMemo)(()=>$515725dfc96f8adc$export$d72c7d8040ef3582(location), [
        location
    ]);
const $515725dfc96f8adc$export$d72c7d8040ef3582 = (location)=>{
    let edition;
    let product;
    let bundle;
    let url;
    try {
        url = new URL(location);
    } catch (e) {
        return {
            edition: edition,
            product: product
        };
    }
    if (url.pathname.includes("/software/jira/product-discovery")) {
        product = {
            bundle: "jira-product-discovery",
            description: "Jira Product Discovery",
            key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_PRODUCT_DISCOVERY,
            name: "jira-product-discovery"
        };
        edition = "free";
    } else if (url.pathname.includes("/software/jira/service-management")) {
        product = {
            bundle: "service-collection",
            description: "Service Collection",
            key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION,
            name: "service-collection"
        };
        edition = "free";
    } else if (url.pathname.includes("/software/jira")) {
        product = {
            bundle: "jira-software",
            description: "Jira",
            key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE,
            name: "jira"
        };
        edition = "free";
    }
    if (url.pathname.includes("/software/confluence")) {
        product = {
            bundle: "confluence",
            description: "Confluence",
            key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE,
            name: "confluence"
        };
        edition = "free";
    }
    if (url.pathname.includes("/collections/teamwork")) {
        product = {
            bundle: "teamwork-collection",
            description: "Teamwork Collection",
            key: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION,
            name: "teamwork-collection"
        };
        edition = "premium";
    }
    const isSignupPage = url.pathname.endsWith("/try/cloud/signup");
    const isConfirmationPage = url.pathname.endsWith("/ondemand/signup/confirmation");
    // @ts-ignore
    if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
        // defaults for the signup page
        if (isSignupPage) {
            edition = "free";
            product = (0, $cf94e8102e664f13$export$ff7fa7230197689e);
            bundle = (0, $cf94e8102e664f13$export$ff7fa7230197689e).bundle;
        }
        // determine product
        if (url.searchParams.has("product")) {
            const foundProduct = (0, $cf94e8102e664f13$export$b6aad051bad07f12).find((product)=>product.key === url.searchParams.get("product"));
            if (foundProduct) {
                product = foundProduct;
                if (foundProduct.bundle) bundle = foundProduct.bundle;
            }
        } else if (url.searchParams.has("bundle")) {
            const bundleParam = url.searchParams.get("bundle");
            // validate bundle
            const collections = [
                "service-collection",
                "teamwork-collection"
            ];
            const isValidBundle = (0, $e4e5eadbc4abf3fb$export$a6f45672c1b02b97)[bundleParam] !== undefined || collections.includes(bundleParam);
            // only set bundle = param if valid param; this affects how we define product
            if (isValidBundle) bundle = bundleParam;
            product = (0, $cf94e8102e664f13$export$b6aad051bad07f12).find((product)=>product.bundle === bundle);
        } else if (url.searchParams.has("products")) product = (0, $cf94e8102e664f13$export$b6aad051bad07f12).find((product)=>product.key === url.searchParams.get("products")?.split(",")[0]);
        // bxpkit developer signup bundle
        if (url.searchParams.get("developer")) {
            product = undefined;
            bundle = "developer";
        }
        // opsgenie EOL
        if (bundle === "opsgenie" && (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp6524OpsgenieSignupEol)) bundle = "jira-service-management";
        // determine edition
        const editionParam = url.searchParams.get("edition");
        if (editionParam === "free") edition = "free";
        else if (editionParam === "standard") edition = "standard";
        else if (editionParam === "premium") edition = "premium";
        /**
     * Handle rovo dev standard signup experience
     */ if (bundle === "devai" && edition === "standard") product = {
            ...product,
            description: "Rovo Dev"
        };
    }
    return {
        edition: edition,
        product: product,
        bundle: bundle
    };
};


const $8c14082df14cf438$export$38ee920e59704589 = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $8c14082df14cf438$export$2e7f18b06f26b111 = ({ children: children, location: location = "https://www.atlassian.com/", referrer: referrer, meResponse: meResponse, meRequest: meRequest, userProfileResponse: userProfileResponse, userProfileRequest: userProfileRequest, loggedOutContext: loggedOutContext, loggedOutContextStatus: loggedOutContextStatus, loggedInContext: loggedInContext, loggedInContextStatus: loggedInContextStatus, transactionAccounts: transactionAccounts = [], utmCampaign: utmCampaign = null })=>{
    const meResponseProvided = (0, $iSvIT.useMemo)(()=>meRequest && meRequest.requested && meRequest.success, [
        meRequest
    ]);
    const userProfileProvided = (0, $iSvIT.useMemo)(()=>userProfileRequest && userProfileRequest.requested && userProfileRequest.success, [
        userProfileRequest
    ]);
    const loggedOutProfile = (0, $iSvIT.useMemo)(()=>loggedOutContextStatus?.requested && loggedOutContextStatus?.success ? loggedOutContext : undefined, [
        loggedOutContext,
        loggedOutContextStatus
    ]);
    const loggedInProfile = (0, $iSvIT.useMemo)(()=>loggedInContextStatus?.requested && loggedInContextStatus?.success ? loggedInContext : undefined, [
        loggedInContext,
        loggedInContextStatus
    ]);
    const clientUserProfileRequested = (0, $iSvIT.useRef)(userProfileRequest?.requested && userProfileRequest?.success ? "complete" : "notRequested");
    // If logged in user cookie isn't present, then we don't need to make a call to stargate.
    // This cookie is set by bxp-gateway to determine if the user is logged in or not.
    // However, when static fallback is served from edge cache, setHeaders() never runs and login_user_detected is not set.
    // As a fallback, check for cloud.session.token directly (which is the source of truth for login state).
    const loginUserDetectedCookie = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("login_user_detected") === "true";
    const cloudSessionToken = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("cloud.session.token") || (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("cloud.session.token.stg");
    const loginUserDetected = loginUserDetectedCookie || cloudSessionToken !== null;
    const [user, setUser] = (0, $iSvIT.useState)({
        ...meResponse,
        isUserLoggedIn: meResponseProvided ? !!meResponse : undefined,
        requestInProgress: !meResponseProvided
    });
    const [transactionAccountsState] = (0, $iSvIT.useState)(transactionAccounts);
    const [profile, setProfile] = (0, $iSvIT.useState)({
        ...userProfileResponse,
        requestInProgress: !userProfileProvided && !!userProfileRequest && userProfileRequest.requested && loginUserDetected
    });
    const stargateClient = (0, $cd2194d8d3feda9a$export$ac42303986bb641e)();
    const { product: product, edition: edition } = (0, $515725dfc96f8adc$export$93cccec4b411f62)(location);
    const clientSideUser = (0, $784ebd6898abdb6b$export$aae23f3a65fbe750)();
    const fetchUserProfile = (0, $iSvIT.useCallback)(()=>{
        if (!loginUserDetected || clientUserProfileRequested.current !== "notRequested") return;
        clientUserProfileRequested.current = "inProgress";
        setProfile((profile)=>({
                ...profile,
                requestInProgress: true
            }));
        (0, $7298ade5588bc87b$export$b164d3383b880fdc).start();
        stargateClient.getUserProfile({
            productName: product?.name
        }) // todo decide if it might be better to always send undefined
        .then((userProfile)=>{
            setProfile({
                ...userProfile,
                requestInProgress: false
            });
            (0, $7298ade5588bc87b$export$b164d3383b880fdc).success({
                customData: {
                    cohorts: userProfile.cohorts,
                    reactComponent: "UserContextProvider",
                    analyticsEvent: "succeeded",
                    productName: product?.name
                }
            });
        }).catch((error)=>{
            console.error("Failed to get user profile", error);
            (0, $7298ade5588bc87b$export$b164d3383b880fdc).failure({
                customData: {
                    reactComponent: "UserContextProvider",
                    analyticsEvent: "errored",
                    productName: product?.name
                },
                error: error
            });
            setProfile({
                requestInProgress: false
            });
        }).finally(()=>{
            clientUserProfileRequested.current = "complete";
        });
    }, [
        stargateClient,
        product,
        loginUserDetected
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (meResponseProvided || clientSideUser.requestInProgress) return;
        setUser(clientSideUser);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientSideUser.requestInProgress,
        meResponseProvided
    ]); // don't add clientSideUser to the dependency array to avoid infinite loop
    (0, $iSvIT.useEffect)(()=>{
        if (userProfileProvided || !userProfileRequest?.requested) return;
        fetchUserProfile();
    }, [
        userProfileProvided,
        fetchUserProfile,
        userProfileRequest?.requested
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($8c14082df14cf438$export$38ee920e59704589.Provider, {
        value: {
            edition: edition,
            loggedOutProfile: loggedOutProfile,
            loggedInProfile: loggedInProfile,
            product: product,
            profile: profile,
            referrer: referrer,
            user: user,
            transactionAccounts: transactionAccountsState,
            requestClientUserProfile: ()=>{
                if (clientUserProfileRequested.current === "notRequested" && !userProfileProvided && !profile.requestInProgress) fetchUserProfile();
            },
            utmCampaign: utmCampaign
        },
        children: children
    });
};
const $8c14082df14cf438$export$87c54b525b914dab = ()=>{
    const context = (0, $iSvIT.useContext)($8c14082df14cf438$export$38ee920e59704589);
    if (!context) throw new Error("useUserContext must be used within a UserContextProvider");
    context.requestClientUserProfile();
    return context;
};


const $455d55b083376cff$export$298b083a523e0c9c = (days)=>Date.now() - days * 86400000;



const $43d486b59dbc7425$export$f1a98e82c0c821bd = Object.freeze({
    NEW_USER: "new-user",
    EXISTING_USER: "existing-user",
    MANAGED_NEW_USER: "managed-new-user",
    MANAGED_USER: "managed-user",
    WEEK_ONE_USER: "week-one-user",
    UPGRADE_ELIGIBLE_USER: "upgrade-eligible-user",
    UPLIFT_ELIGIBLE_USER: "uplift-eligible-user",
    CURRENT_PRODUCT_JOINABLE_USER: "current-product-joinable-user",
    CURRENT_PRODUCT_USER: "current-product-user",
    CROSSFLOW_ELIGIBLE_USER: "crossflow-eligible-user"
});
const $43d486b59dbc7425$export$39f198badfd10683 = "developer";
const $43d486b59dbc7425$export$1f67603e8501a488 = (useContactExpandCohortLogic = false)=>{
    const { profile: profile, product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const isManaged = $43d486b59dbc7425$export$fa35732e6a6c6c71();
    const isManagedUser = $43d486b59dbc7425$export$33d0115fcc5e7239();
    const isWeekOneUser = $43d486b59dbc7425$export$deca29e2536116f5({
        productKey: product?.key
    });
    const isNewUser = $43d486b59dbc7425$export$d2349a5f3b162a3e();
    const isUpgradeEligible = $43d486b59dbc7425$export$626907243cad789();
    const isUpliftEligible = $43d486b59dbc7425$export$ced14a2b669aff9a();
    const isCurrentProductJoinableUser = $43d486b59dbc7425$export$f0f246e4b54f5cc8();
    const isCurrentProductUser = $43d486b59dbc7425$export$2ca4a5691b50e92f();
    const isCrossflowEligible = $43d486b59dbc7425$export$3ab50f0ad2618995();
    if (profile.requestInProgress) return undefined;
    if (useContactExpandCohortLogic) {
        if (isUpgradeEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.UPGRADE_ELIGIBLE_USER;
        if (isCurrentProductUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.CURRENT_PRODUCT_USER;
        if (isCurrentProductJoinableUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.CURRENT_PRODUCT_JOINABLE_USER;
        if (isUpliftEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.UPLIFT_ELIGIBLE_USER;
        if (isCrossflowEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.CROSSFLOW_ELIGIBLE_USER;
        if (isManaged) return $43d486b59dbc7425$export$f1a98e82c0c821bd.MANAGED_NEW_USER;
        return $43d486b59dbc7425$export$f1a98e82c0c821bd.NEW_USER;
    }
    if (isManagedUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.MANAGED_USER;
    if (isUpgradeEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.UPGRADE_ELIGIBLE_USER;
    if (isWeekOneUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.WEEK_ONE_USER;
    if (isCurrentProductUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.CURRENT_PRODUCT_USER;
    if (isUpliftEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.UPLIFT_ELIGIBLE_USER;
    if (isNewUser) return $43d486b59dbc7425$export$f1a98e82c0c821bd.NEW_USER;
    if (isCrossflowEligible) return $43d486b59dbc7425$export$f1a98e82c0c821bd.CROSSFLOW_ELIGIBLE_USER;
    return $43d486b59dbc7425$export$f1a98e82c0c821bd.EXISTING_USER;
};
const $43d486b59dbc7425$export$a99dbfe8dbbd7466 = ()=>{
    const d1to6ConfluenceSite = $43d486b59dbc7425$export$deca29e2536116f5({
        productKey: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE
    });
    return !d1to6ConfluenceSite ? d1to6ConfluenceSite : true;
};
const $43d486b59dbc7425$export$bed8abde9fdecb85 = ()=>{
    const { user: user } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (user["requestInProgress"]) return undefined;
    return (user["name"] ?? "").split(" ")[0];
};
const $43d486b59dbc7425$export$b55e4b5e174e7299 = ()=>{
    const d1toW2JiraSite = $43d486b59dbc7425$export$d7b83d5aca4ac99d();
    return !d1toW2JiraSite ? d1toW2JiraSite : true;
};
const $43d486b59dbc7425$export$e3d98c17bbadabcb = ()=>{
    const jiraD0to6Site = $43d486b59dbc7425$export$deca29e2536116f5({
        productKey: (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE
    });
    return !jiraD0to6Site ? jiraD0to6Site : true;
};
const $43d486b59dbc7425$export$d7b83d5aca4ac99d = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress }, referrer: referrer } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (attributes?.existingSites.length !== 1 || referrer !== "jira.com") return false;
        const twoWeeksAgo = (0, $455d55b083376cff$export$298b083a523e0c9c)(14);
        return attributes?.existingSites.find(({ siteCreatedAt: siteCreatedAt, products: products })=>siteCreatedAt > twoWeeksAgo && products.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE) && products.every((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE || product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).ROVO)) ?? false;
    }, [
        requestInProgress,
        referrer
    ]);
};
const $43d486b59dbc7425$export$d298000033f99943 = ()=>{
    const oneW2OrOlderJiraSite = $43d486b59dbc7425$export$d1d417f90015cc8d();
    const multipleJiraSites = $43d486b59dbc7425$export$6c60fb15c322899a();
    if (oneW2OrOlderJiraSite === undefined || multipleJiraSites === undefined) return undefined;
    return oneW2OrOlderJiraSite || multipleJiraSites;
};
const $43d486b59dbc7425$export$d1d417f90015cc8d = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const oneWeekAgo = (0, $455d55b083376cff$export$298b083a523e0c9c)(7);
        const matchingSitesCount = attributes?.existingSites.filter(({ siteCreatedAt: siteCreatedAt, products: products })=>siteCreatedAt < oneWeekAgo && products.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE)).length ?? 0;
        return matchingSitesCount === 1;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$6c60fb15c322899a = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const matchingSitesCount = attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE)).length ?? 0;
        return matchingSitesCount > 1;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$2f15ce1cde67833e = ()=>{
    const { user: { requestInProgress: requestInProgress, isUserLoggedIn: isUserLoggedIn } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const { hasCloudSessionTokenCookie: hasCloudSessionTokenCookie } = (0, $4afb343f3a1dfc96$export$6576c6d702d8a9f7)();
    if (typeof window === "undefined") // If SSR return if cloud session token cookie is present
    return hasCloudSessionTokenCookie === false;
    if (requestInProgress) {
        // Cloud session token cookie is created as http only cookie, so can't reference from browser's JS.
        // Instead, using login_user_detected cookie.
        const loginUserDetectedCookie = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("login_user_detected");
        return loginUserDetectedCookie === undefined || loginUserDetectedCookie !== "true";
    }
    return isUserLoggedIn === false;
};
const $43d486b59dbc7425$export$3b062b02b4537682 = ()=>{
    const { user: { requestInProgress: requestInProgress, isUserLoggedIn: isUserLoggedIn } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (requestInProgress) return undefined;
    return isUserLoggedIn;
};
const $43d486b59dbc7425$export$f15129e00889eb41 = ()=>{
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return loggedOutProfile?.sites?.some(({ products: products })=>products?.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE));
};
const $43d486b59dbc7425$export$18075269258eafed = ()=>{
    const confluence = $43d486b59dbc7425$export$c0fe219adfba1c8c();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    return confluence && loggedOut;
};
const $43d486b59dbc7425$export$eaaff87ad9e02759 = ()=>{
    const jira = $43d486b59dbc7425$export$5dc07a09424afaf8();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    return jira && loggedOut;
};
const $43d486b59dbc7425$export$b9541c4305527a4e = ()=>{
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return !loggedOutProfile || loggedOutProfile.sites?.every(({ products: products })=>!products?.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE));
};
const $43d486b59dbc7425$export$b0bf45fdefa54485 = ()=>{
    const jira = $43d486b59dbc7425$export$5dc07a09424afaf8();
    const free = $43d486b59dbc7425$export$cd55d04fc7ff1e12();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    return jira && free && loggedOut;
};
const $43d486b59dbc7425$export$d2349a5f3b162a3e = ()=>{
    const { profile: { requestInProgress: requestInProgress, cohorts: cohorts } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (requestInProgress) return undefined;
    return cohorts?.userType === "new-user";
};
const $43d486b59dbc7425$export$deca29e2536116f5 = ({ productKey: productKey })=>{
    const { profile: { requestInProgress: requestInProgress, attributes: attributes } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (attributes?.existingSites.length !== 1) return false;
        const oneWeekAgo = (0, $455d55b083376cff$export$298b083a523e0c9c)(7);
        // sites may only have the current productKey, rovo, project, or goal
        const weekOneProductKeys = [
            productKey,
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).ROVO,
            "project",
            "goal"
        ];
        return attributes?.existingSites.find(({ siteCreatedAt: siteCreatedAt, products: products })=>{
            const isRecent = siteCreatedAt > oneWeekAgo;
            const hasTargetProduct = products.some((product)=>product.productKey === productKey);
            const allProductsAllowed = products.every(({ productKey: productKey })=>weekOneProductKeys.includes(productKey));
            return isRecent && hasTargetProduct && allProductsAllowed;
        }) ?? false;
    }, [
        requestInProgress,
        productKey
    ]);
};
const $43d486b59dbc7425$export$6ece9302e262a8ba = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        if (!product?.key) return [];
        return attributes?.existingSites.filter((site)=>site.products.some(({ productKey: productKey, partOfCollection: partOfCollection })=>productKey === product?.key || partOfCollection === product?.key)) ?? [];
    }, [
        requestInProgress,
        attributes?.existingSites,
        product?.key
    ]);
};
const $43d486b59dbc7425$export$84a160b212c75a38 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.some((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$f205df8e360cbc3e = (cloudSiteId)=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const existingSites = attributes?.existingSites;
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        const oneDayAgo = (0, $455d55b083376cff$export$298b083a523e0c9c)(1);
        const fourteenDaysAgo = (0, $455d55b083376cff$export$298b083a523e0c9c)(14);
        return existingSites?.some(({ cloudId: cloudId, siteCreatedAt: siteCreatedAt, products: products })=>{
            if (cloudSiteId && cloudId !== cloudSiteId) return false;
            const siteIsD1ToD14 = siteCreatedAt >= fourteenDaysAgo && siteCreatedAt <= oneDayAgo;
            const siteHasJiraSoftware = products.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE);
            return siteIsD1ToD14 && siteHasJiraSoftware;
        }) ?? false;
    }, [
        cloudSiteId,
        existingSites,
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$485cf218c5871683 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$fc6f9a676ac2d20 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SERVICE_MANAGEMENT)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$90f6e3b3a7bfc07 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).LOOM)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$fb04b6df09d62152 = ()=>{
    const { profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (requestInProgress) return undefined;
        return attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_PRODUCT_DISCOVERY)) ?? false;
    }, [
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$9c796ff56b860b9 = ()=>{
    const hasJiraSites = $43d486b59dbc7425$export$84a160b212c75a38();
    const hasConfluenceSites = $43d486b59dbc7425$export$485cf218c5871683();
    return hasJiraSites && hasConfluenceSites;
};
const $43d486b59dbc7425$var$JSM_ELIGIBLE_JOB_FUNCTIONS = new Set([
    "engineering",
    "information technology",
    "customer service",
    "operations",
    "human resources",
    "data science"
]);
const $43d486b59dbc7425$var$LOOM_ELIGIBLE_JOB_FUNCTIONS = new Set([
    "program management",
    "finance",
    "legal",
    "c-suite",
    "other",
    "undefined",
    null,
    "sales",
    "marketing",
    "design"
]);
const $43d486b59dbc7425$var$JPD_ELIGIBLE_JOB_FUNCTIONS = new Set([
    "product management"
]);
const $43d486b59dbc7425$export$e2e44b7b9e61cc71 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dd36a66a5d1abea9$export$eb068a7cf20a51ae)();
    const [hasJSMJobFunction, setHasJSMJobFunction] = (0, $iSvIT.useState)(undefined);
    (0, $iSvIT.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback("homepage-xflow-job-function");
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction && $43d486b59dbc7425$var$JSM_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasJSMJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasJSMJobFunction;
};
const $43d486b59dbc7425$export$5f2f0baa902c1044 = ()=>{
    const hasJSMJobFunction = $43d486b59dbc7425$export$e2e44b7b9e61cc71();
    const hasJiraAndConfluence = $43d486b59dbc7425$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $1f12900928d868ac$export$48374a0929d11425)();
    return hasJSMJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $43d486b59dbc7425$export$17f3ceaf5eb291b7 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dd36a66a5d1abea9$export$eb068a7cf20a51ae)();
    const [hasJPDJobFunction, setHasJPDJobFunction] = (0, $iSvIT.useState)(undefined);
    (0, $iSvIT.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback("homepage-xflow-job-function");
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction && $43d486b59dbc7425$var$JPD_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasJPDJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasJPDJobFunction;
};
const $43d486b59dbc7425$export$6504d847bbe5528a = ()=>{
    const hasJPDJobFunction = $43d486b59dbc7425$export$17f3ceaf5eb291b7();
    const hasJiraAndConfluence = $43d486b59dbc7425$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $1f12900928d868ac$export$48374a0929d11425)();
    return hasJPDJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $43d486b59dbc7425$export$24267c23d03635b3 = ()=>{
    const { getUserProfileJobFunctionCallback: getUserProfileJobFunctionCallback } = (0, $dd36a66a5d1abea9$export$eb068a7cf20a51ae)();
    const [hasLoomJobFunction, setHasLoomJobFunction] = (0, $iSvIT.useState)(undefined);
    (0, $iSvIT.useEffect)(()=>{
        const checkTeamType = async ()=>{
            const result = await getUserProfileJobFunctionCallback("homepage-xflow-job-function");
            const jobFunction = result?.data?.jobFunction;
            const matches = jobFunction === null || jobFunction === undefined || $43d486b59dbc7425$var$LOOM_ELIGIBLE_JOB_FUNCTIONS.has(jobFunction);
            setHasLoomJobFunction(matches || false);
        };
        checkTeamType();
    }, [
        getUserProfileJobFunctionCallback
    ]);
    return hasLoomJobFunction;
};
const $43d486b59dbc7425$export$412a4b4f6068c934 = ()=>{
    const hasLoomJobFunction = $43d486b59dbc7425$export$24267c23d03635b3();
    const hasJiraAndConfluence = $43d486b59dbc7425$export$9c796ff56b860b9();
    const isEnglishLocale = (0, $1f12900928d868ac$export$48374a0929d11425)();
    return hasLoomJobFunction && hasJiraAndConfluence && isEnglishLocale;
};
const $43d486b59dbc7425$export$e197bb1368a4ef86 = ()=>{
    const hasJSMCohortQualification = $43d486b59dbc7425$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $43d486b59dbc7425$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $43d486b59dbc7425$export$6504d847bbe5528a();
    const hasJSM = $43d486b59dbc7425$export$fc6f9a676ac2d20();
    const hasLoom = $43d486b59dbc7425$export$90f6e3b3a7bfc07();
    const hasJPD = $43d486b59dbc7425$export$fb04b6df09d62152();
    if (// “JSM team types | job function” and no JSM entitlement
    hasJSMCohortQualification && !hasJSM) return true;
    else if (// “Loom team types | job function” and has loom and no JSM entitlement
    hasLoomCohortQualification && hasLoom && !hasJSM) return true;
    else if (// “JPD team types | job function” and has loom and JPD entitlement and no JSM entitlement
    hasJPDCohortQualification && hasLoom && hasJPD && !hasJSM) return true;
    return false;
};
const $43d486b59dbc7425$export$55a03ab347a6458a = ()=>{
    const hasJSMCohortQualification = $43d486b59dbc7425$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $43d486b59dbc7425$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $43d486b59dbc7425$export$6504d847bbe5528a();
    const hasJSM = $43d486b59dbc7425$export$fc6f9a676ac2d20();
    const hasLoom = $43d486b59dbc7425$export$90f6e3b3a7bfc07();
    const hasJPD = $43d486b59dbc7425$export$fb04b6df09d62152();
    if (// “JPD team types | job function” and no JPD entitlement
    hasJPDCohortQualification && !hasJPD) return true;
    else if (// “Loom team types | job function” and has loom and has JSM and no JPD entitlement
    hasLoomCohortQualification && hasLoom && hasJSM && !hasJPD) return true;
    else if (// “JSM team types | job function” and has JSM and has loom and no JPD entitlement
    hasJSMCohortQualification && hasJSM && hasLoom && !hasJPD) return true;
    return false;
};
const $43d486b59dbc7425$export$922f0a01637bf976 = ()=>{
    const hasJSMCohortQualification = $43d486b59dbc7425$export$5f2f0baa902c1044();
    const hasLoomCohortQualification = $43d486b59dbc7425$export$412a4b4f6068c934();
    const hasJPDCohortQualification = $43d486b59dbc7425$export$6504d847bbe5528a();
    const hasJSM = $43d486b59dbc7425$export$fc6f9a676ac2d20();
    const hasLoom = $43d486b59dbc7425$export$90f6e3b3a7bfc07();
    const hasJPD = $43d486b59dbc7425$export$fb04b6df09d62152();
    if (// "Loom team types | job function” and no Loom entitlement
    hasLoomCohortQualification && !hasLoom) return true;
    else if (// “JSM team types | job function” and has JSM and no Loom entitlement
    hasJSMCohortQualification && hasJSM && !hasLoom) return true;
    else if (// “JPD team types | job function” and has JPD and no Loom entitlement
    hasJPDCohortQualification && hasJPD && !hasLoom) return true;
    return false;
};
const $43d486b59dbc7425$export$6ee1c85a91cf2903 = ()=>{
    return $43d486b59dbc7425$export$16e080529ee7ce8e("dark");
};
const $43d486b59dbc7425$export$16e080529ee7ce8e = (color)=>{
    return window?.matchMedia && window?.matchMedia(`(prefers-color-scheme: ${color})`).matches ? true : false;
};
const $43d486b59dbc7425$export$842e95cf1a436387 = ()=>{
    const isConfluence = $43d486b59dbc7425$export$c0fe219adfba1c8c();
    const isFree = $43d486b59dbc7425$export$cd55d04fc7ff1e12();
    return isConfluence && isFree;
};
const $43d486b59dbc7425$export$af2d59ad7176b983 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).COMPASS;
};
const $43d486b59dbc7425$export$c0fe219adfba1c8c = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "confluence";
};
const $43d486b59dbc7425$export$cd55d04fc7ff1e12 = ()=>{
    const { edition: edition } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return edition === "free";
};
const $43d486b59dbc7425$export$38abfe23fcbef130 = ()=>{
    const { edition: edition } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return edition === "standard";
};
const $43d486b59dbc7425$export$8321978ac3198c2e = ()=>{
    const { edition: edition } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return edition === "premium";
};
const $43d486b59dbc7425$export$5dc07a09424afaf8 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "jira";
};
const $43d486b59dbc7425$export$10ee22f17966eb68 = ()=>{
    const { edition: edition, product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "jira" && edition === "free";
};
const $43d486b59dbc7425$export$3b2a64cf46b3c332 = ()=>{
    const isJiraServiceManagement = $43d486b59dbc7425$export$a0475dc95ccbcf50();
    const isFree = $43d486b59dbc7425$export$cd55d04fc7ff1e12();
    return isJiraServiceManagement && isFree;
};
const $43d486b59dbc7425$export$a0475dc95ccbcf50 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "jira-servicedesk";
};
const $43d486b59dbc7425$export$50cabacb4690842b = ()=>{
    const isJiraProductDiscovery = $43d486b59dbc7425$export$9631c56770d0fcbf();
    const isFree = $43d486b59dbc7425$export$cd55d04fc7ff1e12();
    return isJiraProductDiscovery && isFree;
};
const $43d486b59dbc7425$export$9631c56770d0fcbf = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "jira-product-discovery";
};
const $43d486b59dbc7425$export$aa30b981cc3856d4 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "devai";
};
const $43d486b59dbc7425$export$caf5e021ec9bba69 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return product?.name === "loom";
};
const $43d486b59dbc7425$export$182a2a33692f7de1 = ()=>{
    const { profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    // todo share with bxp-ui-signup's orgBasedOfferingIdMap
    const GUARD_PREMIUM = "2f5e5808-d501-450a-b246-b0bd50a0b72a";
    const GUARD_STANDARD = "1ac3b7dd-7141-414e-bc00-c890acc458b0";
    const GUARD_HAMS = "GUARD_HAMS";
    const GUARD_OFFERING_IDS = [
        GUARD_PREMIUM,
        GUARD_STANDARD,
        GUARD_HAMS
    ];
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.managingOrg?.offeringIds?.some((offeringId)=>GUARD_OFFERING_IDS.includes(offeringId));
};
const $43d486b59dbc7425$export$cf11cf307fde2f61 = ()=>{
    const { product: product, profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.filter(({ cloudId: cloudId, products: products })=>profile.attributes?.managingOrg?.cloudIds?.includes(cloudId) && products.some(({ productKey: productKey })=>productKey === product?.key));
};
const $43d486b59dbc7425$export$b5d9e6bb3dda68c5 = ()=>{
    const { product: product, profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>profile.attributes?.existingSites.filter(({ hasAdminAccess: hasAdminAccess, products: products })=>product && hasAdminAccess && !products.some(({ productKey: productKey })=>product.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION ? // exclude sites with servco constituent products from site activation crossflow
                [
                    (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SERVICE_MANAGEMENT,
                    (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_CUSTOMER_SERVICE
                ].includes(productKey) : productKey === product.key)) ?? [], [
        profile.attributes?.existingSites,
        product
    ]);
};
const $43d486b59dbc7425$export$3ab50f0ad2618995 = ()=>{
    const crossflowEligibleSites = $43d486b59dbc7425$export$b5d9e6bb3dda68c5();
    return crossflowEligibleSites?.length > 0;
};
const $43d486b59dbc7425$export$fa35732e6a6c6c71 = ()=>{
    const { profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (profile.requestInProgress) return undefined;
    return !!profile.attributes?.hasAccountManagedByOrg;
};
const $43d486b59dbc7425$export$33d0115fcc5e7239 = ()=>{
    const { profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const managingOrgHasGuard = $43d486b59dbc7425$export$182a2a33692f7de1();
    const managingOrgUserSites = $43d486b59dbc7425$export$cf11cf307fde2f61();
    if (profile.requestInProgress) return undefined;
    return managingOrgHasGuard && managingOrgUserSites?.length;
};
const $43d486b59dbc7425$export$b856a73c0ae1da63 = ()=>{
    const { profile: { requestInProgress: profileRequestInProgress, attributes: attributes }, user: { requestInProgress: userRequestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        // Checking for both user and profile request in progress,
        // since profileRequestInProgress is initially defined as 'false' and then gets updated to true when the request is made.
        // This is probably not needed since this experiment is wrapped within <LoggedInHeroContainer /> and has the same logic.
        // But adding it here incase this experiment is used outside of <LoggedInHeroContainer />
        if (userRequestInProgress || profileRequestInProgress) return undefined;
        return (attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE)) && !attributes?.existingSites.some((sites)=>sites.products.find((product)=>product.productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE))) ?? false;
    }, [
        userRequestInProgress,
        profileRequestInProgress
    ]);
};
const $43d486b59dbc7425$export$1f50eb8420f49d3e = (pathnames)=>{
    const { pathname: currentPathname } = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    if (pathnames.includes(currentPathname)) return true;
    return false;
};
const $43d486b59dbc7425$export$417ca7eef6ef89c7 = (pathnames)=>{
    const { pathname: currentPathname } = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    const delocalizedPathname = (0, $a69c6ceceedb3a08$export$44f112d5a3138d7)(currentPathname);
    return pathnames.some((pattern)=>{
        if (pattern.endsWith("/*")) {
            // Wildcard: match prefix
            const prefix = pattern.slice(0, -2); // Remove the /*
            return delocalizedPathname === prefix || delocalizedPathname.startsWith(`${prefix}/`);
        }
        return delocalizedPathname === pattern;
    });
};
const $43d486b59dbc7425$export$b30de9e5e1e6ddb6 = ()=>{
    const loggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const isMobile = (0, $b96ee0edfbd3981f$export$2b96349243a56116)();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const isConfluencePath = $43d486b59dbc7425$export$417ca7eef6ef89c7([
        "/software/confluence/*"
    ]);
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    if (typeof window !== "undefined" && window.cmsPageVariant) return false;
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isConfluencePath && isMobile && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE)) ?? false);
};
const $43d486b59dbc7425$export$da27afec777e5a82 = ()=>{
    const loggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const isMobile = (0, $b96ee0edfbd3981f$export$2b96349243a56116)();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const isJiraPath = $43d486b59dbc7425$export$417ca7eef6ef89c7([
        "/software/jira/*"
    ]);
    const isJiraProductDiscoveryPath = $43d486b59dbc7425$export$417ca7eef6ef89c7([
        "/software/jira/product-discovery/*"
    ]);
    const isJiraAgilePath = $43d486b59dbc7425$export$417ca7eef6ef89c7([
        "/software/jira/agile/*"
    ]);
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    if (typeof window !== "undefined" && window.cmsPageVariant) return false;
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isJiraPath && isMobile && !isJiraProductDiscoveryPath && !isJiraAgilePath && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE)) ?? false);
};
const $43d486b59dbc7425$export$626907243cad789 = ()=>{
    const { product: product, edition: edition } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const upgradableSites = $43d486b59dbc7425$export$f209e5281b75b7a1();
    // you need to be in a paid product edition flow
    if (!product || edition === "free") return undefined;
    return !!upgradableSites?.length;
};
const $43d486b59dbc7425$export$ced14a2b669aff9a = ()=>{
    const upliftableSites = $43d486b59dbc7425$export$9a364c26a41530c6();
    return !!upliftableSites?.length;
};
const $43d486b59dbc7425$export$cb6c82b1dd091b1 = ()=>{
    const upgradableStandardSites = $43d486b59dbc7425$export$d51a19bb23af218a();
    return !!upgradableStandardSites?.length;
};
const $43d486b59dbc7425$export$cc01f81ad039310f = ()=>{
    const isConfluenceIntent = $43d486b59dbc7425$export$c0fe219adfba1c8c();
    const isLoggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const isPremiumIntent = $43d486b59dbc7425$export$8321978ac3198c2e();
    const s2pUpgradeEligible = $43d486b59dbc7425$export$cb6c82b1dd091b1();
    return isConfluenceIntent && isLoggedIn && !(isPremiumIntent && s2pUpgradeEligible);
};
const $43d486b59dbc7425$export$3efd720c078c8268 = ()=>{
    const isJiraIntent = $43d486b59dbc7425$export$5dc07a09424afaf8();
    const isLoggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const isPremiumIntent = $43d486b59dbc7425$export$8321978ac3198c2e();
    const s2pUpgradeEligible = $43d486b59dbc7425$export$cb6c82b1dd091b1();
    return isJiraIntent && isLoggedIn && !(isPremiumIntent && s2pUpgradeEligible);
};
const $43d486b59dbc7425$export$d51a19bb23af218a = ()=>{
    const { product: product, edition: edition, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        const eligibleProducts = [
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE,
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE,
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_PRODUCT_DISCOVERY
        ];
        if (edition !== "premium" || !eligibleProducts.includes(product.key)) return undefined;
        return attributes?.existingSites.filter(({ hasAdminAccess: hasAdminAccess, products: products })=>hasAdminAccess && products.some(({ productKey: productKey, productEdition: productEdition, entitlementId: entitlementId, billingSourceSystem: billingSourceSystem })=>productKey === product.key && productEdition === "standard" && entitlementId !== undefined && billingSourceSystem !== undefined)) ?? [];
    }, [
        product?.key,
        edition,
        attributes?.existingSites,
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$f209e5281b75b7a1 = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const isGateEnabledForEntitlementCheck = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).includeEntitlementIdCheckInCohortsGate);
    return (0, $iSvIT.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        return attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey, productEdition: productEdition, partOfCollection: partOfCollection, entitlementId: entitlementId, billingSourceSystem: billingSourceSystem })=>isGateEnabledForEntitlementCheck ? (productKey === product.key || partOfCollection === product.key) && productEdition === "free" && entitlementId !== undefined && billingSourceSystem !== undefined : (productKey === product.key || partOfCollection === product.key) && productEdition === "free")) ?? [];
    }, [
        product?.key,
        attributes?.existingSites,
        requestInProgress,
        isGateEnabledForEntitlementCheck
    ]);
};
const $43d486b59dbc7425$export$9a364c26a41530c6 = ()=>{
    const { product: product, profile: { attributes: attributes, requestInProgress: requestInProgress } } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return (0, $iSvIT.useMemo)(()=>{
        if (!product?.key || requestInProgress) return undefined;
        // currently only applies to teamwork collection
        if (product.key !== (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION) return [];
        const constituentProducts = [
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).JIRA_SOFTWARE,
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).CONFLUENCE,
            (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).LOOM
        ];
        return attributes?.existingSites.filter(({ products: products })=>products.some(({ productKey: productKey, partOfCollection: partOfCollection })=>constituentProducts.includes(productKey) && !partOfCollection)) ?? [];
    }, [
        product?.key,
        attributes?.existingSites,
        requestInProgress
    ]);
};
const $43d486b59dbc7425$export$46259f1c5dadf021 = ()=>{
    const location = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    const { bundle: bundle } = (0, $515725dfc96f8adc$export$93cccec4b411f62)(location.href);
    return bundle === $43d486b59dbc7425$export$39f198badfd10683;
};
const $43d486b59dbc7425$export$3714723c568623ba = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (!product) return undefined;
    return product.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION;
};
const $43d486b59dbc7425$export$339db86d4934ad1f = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (!product) return undefined;
    return product.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).STATUSPAGE;
};
const $43d486b59dbc7425$export$d8884d6708cb94a7 = ()=>{
    const { product: product } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (!product) return undefined;
    return product.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION;
};
const $43d486b59dbc7425$export$7be2df8926e395bf = ()=>{
    const { profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ partOfCollection: partOfCollection })=>partOfCollection === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION));
};
const $43d486b59dbc7425$export$bc61bdb4c380dd8 = ()=>{
    const { profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ partOfCollection: partOfCollection })=>partOfCollection === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION));
};
const $43d486b59dbc7425$export$e31fbf0af7c148e4 = ()=>{
    const { userAgent: userAgent } = (0, $4afb343f3a1dfc96$export$6576c6d702d8a9f7)();
    const { isDesktop: isDesktop } = userAgent === undefined ? {} : (0, $7f3bb8df8d1300c9$exports.getSelectorsByUserAgent)(userAgent) ?? {};
    return isDesktop;
};
const $43d486b59dbc7425$export$f0f246e4b54f5cc8 = ()=>{
    const { product: product, profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (profile.requestInProgress) return undefined;
    return profile.attributes?.existingProductsFromOrg.some(({ productKey: productKey })=>productKey === product?.key);
};
const $43d486b59dbc7425$export$2ca4a5691b50e92f = ()=>{
    const { product: product, profile: profile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const hasServiceCollection = $43d486b59dbc7425$export$7be2df8926e395bf();
    const hasTeamworkCollection = $43d486b59dbc7425$export$bc61bdb4c380dd8();
    if (profile.requestInProgress) return undefined;
    if (product?.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).SERVICE_COLLECTION) return hasServiceCollection;
    if (product?.key === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION) return hasTeamworkCollection;
    return profile.attributes?.existingSites.some(({ products: products })=>products.some(({ productKey: productKey })=>productKey === product?.key));
};
const $43d486b59dbc7425$export$a810ea9e597e4b89 = ()=>{
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (loggedOut === undefined) return undefined;
    if (!loggedOut) return false;
    return loggedOutProfile?.sites && loggedOutProfile.sites.length > 0 && loggedOutProfile.sites.some(({ products: products })=>products && products.length > 0);
};
const $43d486b59dbc7425$export$8e74edbd6f6309e9 = ()=>{
    const isLoggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const { loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    if (isLoggedOut === undefined) return undefined;
    if (!isLoggedOut) return false;
    const hasSites = loggedOutProfile?.sites && loggedOutProfile.sites.length > 0 && loggedOutProfile.sites.some(({ products: products })=>products && products.length > 0);
    return !hasSites;
};
const $43d486b59dbc7425$export$1b0e0e9d76f07fbf = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    return transactionAccounts.length > 1;
};
const $43d486b59dbc7425$export$421bb31bf2b802f9 = ()=>{
    const { transactionAccounts: transactionAccounts } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const result = transactionAccounts.some((account)=>{
        const { partnerStatus: partnerStatus } = account;
        // Check if any field in partnerStatus is not null
        return partnerStatus.discountTier !== null || partnerStatus.programLevelGlobal !== null || partnerStatus.externalSystemIdentifier !== null || partnerStatus.programLevel !== null;
    });
    console.log("useHasPartnerStatusCohort result:", result, "transactionAccounts:", transactionAccounts);
    return result;
};
const $43d486b59dbc7425$export$724a9c1f66c780e = ()=>{
    const isLoggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const hasPartnerStatus = $43d486b59dbc7425$export$421bb31bf2b802f9();
    const hasMultipleAccounts = $43d486b59dbc7425$export$1b0e0e9d76f07fbf();
    return isLoggedIn && hasPartnerStatus && hasMultipleAccounts;
};
const $43d486b59dbc7425$export$5d6fa06f1d687f9c = ()=>{
    const loggedIn = $43d486b59dbc7425$export$3b062b02b4537682();
    const loggedOut = $43d486b59dbc7425$export$2f15ce1cde67833e();
    const { profile: profile, loggedOutProfile: loggedOutProfile } = (0, $8c14082df14cf438$export$87c54b525b914dab)();
    const { pathname: pathname } = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    if (loggedIn === undefined || loggedOut === undefined) return undefined;
    // Check if user is on the /software/rovo path (handles locale-prefixed paths like /en/software/rovo)
    // Ensure the path includes /software/rovo AND ends with it (no subpages or appended text)
    const isRovoPath = pathname.includes("/software/rovo") && pathname.endsWith("/software/rovo") || pathname.includes("/search");
    const sites = loggedIn ? profile.attributes?.existingSites : loggedOutProfile?.sites;
    return isRovoPath && (sites?.some((site)=>site.products?.some(({ productKey: productKey })=>productKey === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).ROVO)) ?? false);
};
const $43d486b59dbc7425$export$94261b4b0b38f1cd = ()=>{
    if (typeof window === "undefined") return false;
    const urlParams = new URLSearchParams(window.location.search);
    const templateId = urlParams.get("templateId");
    const supportedTemplates = new Set([
        (0, $bf209b22e9e1c13f$export$fe3cfcb5926c814e).Kanban,
        (0, $bf209b22e9e1c13f$export$fe3cfcb5926c814e).Scrum
    ]);
    if (templateId) return supportedTemplates.has(templateId);
    return !templateId;
};
const $43d486b59dbc7425$export$3bf16ac9e0f0f9a = ()=>{
    if (typeof window === "undefined") return false;
    const urlParams = new URLSearchParams(window.location.search);
    const products = urlParams.get("products");
    return products === "com.atlassian.teamwork-collection";
};
const $43d486b59dbc7425$export$79db58cc9c75d79 = ()=>{
    if (typeof window === "undefined") return false;
    const urlParams = new URLSearchParams(window.location.search);
    const products = urlParams.get("products");
    const edition = urlParams.get("edition");
    const isTWC = products === (0, $bf209b22e9e1c13f$export$f3a53bd43617a593).TEAMWORK_COLLECTION;
    const isPaidEdition = edition === "standard" || edition === "premium";
    return isTWC && isPaidEdition;
};
const $43d486b59dbc7425$export$c561bb579e60ca35 = ()=>{
    const { search: search } = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
    const params = search.split("&");
    const subAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("subAnchor"))[0]?.split("=")[1] || ""));
    return subAnchor;
};
const $43d486b59dbc7425$export$c7262d790750093d = ()=>{
    const subAnchor = $43d486b59dbc7425$export$c561bb579e60ca35();
    return (0, $9fbed165fb1c2422$export$bf10147d0ac61da9)(subAnchor);
};
const $43d486b59dbc7425$export$74b50ac429b5c3cf = ()=>{
    if (typeof window === "undefined") return false;
    const urlParams = new URLSearchParams(window.location.search);
    const teamType = urlParams.get("team_type");
    return !!teamType && (0, $ece4c9a946b9caa5$export$e762c1129e037c3c).includes(teamType);
};





const $097325fd420a348e$var$booleanTypeGuard = (value)=>typeof value === "boolean";
const $097325fd420a348e$export$367c0902ef62c425 = {
    gwp9322WacHomepageRefresh: {
        experimentName: "gwp-9322-wac-homepage-refresh-experiment",
        parameterName: "variantName",
        defaultValue: "control",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "test"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Teamwork Collection refresh changes on homepage",
            expectedReleaseDate: "01/15/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/"
                ]
            }
        }
    },
    cfind4782LandingPageSubAnchorV3: {
        experimentName: "cfind-4782-landing-page-sub-anchor-v3",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Test if personalizing the landing page off the sub anchor will increase d1to6",
            expectedReleaseDate: "07/14/2025",
            expectedRuntime: "6 weeks",
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    jiraOnboardingAiMadlibV2: {
        experimentName: "jira-onboarding-ai-madlib-v2",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$94261b4b0b38f1cd)
        },
        metadata: {
            description: "Enable AI Madlib during Jira onboarding experience V2 expanded iteration with all team types",
            expectedReleaseDate: "2/27/2026",
            expectedRuntime: "30 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    jfindSimplifiedListViewWithBasicTasks: {
        experimentName: "jfind-simplified-list-view-with-basic-tasks",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Simplifies the list view columns and adds basic sample tasks to the initial project",
            expectedReleaseDate: "17/06/2025",
            expectedRuntime: "131 days",
            context: {
                urls: []
            }
        }
    },
    jfindBasicSampleTasksForScrumOrSoftwareKanban: {
        experimentName: "jira-create-generic-tasks-and-minimize-quickstart",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Adds basic sample tasks to the initial project for Scrum or Software Kanban projects",
            expectedReleaseDate: "22/09/2025",
            expectedRuntime: "37 days",
            context: {
                urls: []
            }
        }
    },
    signupAddPaymentAb: {
        experimentName: "signup_trialing_add_payment_ab",
        parameterName: "cohort",
        defaultValue: "control",
        options: {
            // we need to fire our exposure event manually because we can't determine if the user is eligible from here
            fireExperimentExposure: false,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "test"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Experiment to enable users with valid sites to go to payment at the sign-up screen",
            expectedReleaseDate: "02/27/25",
            expectedRuntime: "TBD",
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    gwp5090ExperimentBannerConfluence: {
        experimentName: "gwp-5090-experiment-banner-confluence",
        parameterName: "variantName",
        defaultValue: "control",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "butterbar",
                    "lifted"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Testing butterbar vs lifted banner for Jira Service Management product tour",
            expectedReleaseDate: "02/18/25",
            expectedRuntime: "2 weeks",
            // TODO: GWP-5270 to fill these urls
            context: {
                urls: []
            }
        }
    },
    gwp7617JiraShortTermAiInfusionExperiment: {
        experimentName: "gwp-7617-jira-short-term-ai-infusion-experiment",
        parameterName: "variantName",
        defaultValue: "control",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "test"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Short term AI",
            expectedReleaseDate: "08/21/25",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    jfindMatureExampleProjectExperiment: {
        experimentName: "jfind-mature-example-project",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$d2349a5f3b162a3e)
        },
        metadata: {
            description: "Supports creating a new example project for Jira customers",
            expectedReleaseDate: "06/02/2025",
            expectedRuntime: "13 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    jfindMatureExampleProjectV2Experiment: {
        experimentName: "jfind-mature-example-project-v2",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Creates a V2 Mature Example Project for Jira customers",
            expectedReleaseDate: "03/23/2026",
            expectedRuntime: "24 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    gwp4948GartnerJiraProductTourExperiment: {
        experimentName: "gwp-4948-gartner-jira-product-tour-experiment",
        parameterName: "variantName",
        defaultValue: "control",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "test"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "gartner section on jira product tour",
            expectedReleaseDate: "April 2025",
            expectedRuntime: "2 weeks",
            clientOnly: true,
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    gwp6441ConfluenceTemplatesProductNavCta: {
        experimentName: "gwp-6441-confluence-templates-product-nav-cta",
        parameterName: "variant",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                // oxlint-disable-next-line react-hooks/rules-of-hooks
                return !(0, $43d486b59dbc7425$export$2f15ce1cde67833e)();
            }
        },
        metadata: {
            description: "Confluence Templates Product Nav CTA experiment",
            expectedReleaseDate: "undefined",
            expectedRuntime: "77 days",
            clientOnly: true,
            context: {
                urls: [
                    "/software/confluence/templates/*"
                ]
            }
        }
    },
    jiraOnboardingAutodetectSystemTheme: {
        experimentName: "jira-onboarding-autodetect-system-theme",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$6ee1c85a91cf2903)
        },
        metadata: {
            description: "Autodetect system theme and enroll users into experiment",
            expectedReleaseDate: "08/27/2025",
            expectedRuntime: "18 days",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    jfindOnboardingWizardInviteStep: {
        experimentName: "jfind-add-invite-step-to-onboarding-wizard",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Add invite step to the Jira onboarding wizard",
            expectedReleaseDate: "09/12/2025",
            expectedRuntime: "3 weeks",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    gwpAJContextualBanditsJiraBPS: {
        experimentName: "gwp-aj-contextual-bandits-jira-bps-v3",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                // oxlint-disable-next-line react-hooks/rules-of-hooks
                const location = (0, $f24bb8cd7cd93d4c$export$45d76561a5302f2b)();
                if (// oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$1f50eb8420f49d3e)([
                    "/software/jira"
                ]) && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$2f15ce1cde67833e)() && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $1f12900928d868ac$export$48374a0929d11425)() && location.search.includes("keyword") && (typeof window !== "undefined" ? window.anchor === "Brand (default)" : location.search.includes("anchor=Brand%20(default)"))) return true;
                return false;
            }
        },
        metadata: {
            description: "Contextual bandits for Jira BPS v2",
            expectedReleaseDate: "02/13/2026",
            expectedRuntime: "11 weeks",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    wacRoutingTableMvpPerf: {
        experimentName: "wac-routing-table-mvp",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>typeof value === "boolean"
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Measure performance degredation of wac-routing-table in wac-web",
            expectedReleaseDate: "08/28/2025",
            expectedRuntime: "5 days",
            context: {
                urls: [
                    "/software/jira/enterprise"
                ]
            }
        }
    },
    confluencePricingPageWaeMigration: {
        experimentName: "confluence_pricing_wae_migration_exp_rerun_exp_1",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Migration of Confluence pricing page to WAE, rerun",
            expectedReleaseDate: "03/06/2026",
            expectedRuntime: "80 days",
            context: {
                urls: [
                    "/software/confluence/pricing"
                ]
            }
        }
    },
    wacAISearchSummaryV2: {
        experimentName: "wac-ai-search-summary-v2",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                // oxlint-disable-next-line react-hooks/rules-of-hooks
                return (0, $43d486b59dbc7425$export$e31fbf0af7c148e4)();
            }
        },
        metadata: {
            description: "AI Search Summary Experiment V2",
            expectedReleaseDate: "N/A",
            expectedRuntime: "N/A",
            context: {
                // eslint-disable-next-line local/warn-wildcard-usage-eslint
                urls: [
                    "*"
                ]
            }
        }
    },
    gwp8288PersonalizingWacSoftwarePage: {
        experimentName: "gwp-8288-personalizing-wac-software-page",
        parameterName: "enrolled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Personalizing WAC Software Page Experiment",
            expectedReleaseDate: "10/30/2025",
            expectedRuntime: "6 weeks",
            context: {
                urls: [
                    "/software"
                ]
            }
        }
    },
    twcg790ContextualBackground: {
        experimentName: "twcg-790-contextual-backgrounds-wac-sign-in",
        parameterName: "cohort",
        defaultValue: "control",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "test"
                ].includes(value);
            }
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "adding atlOrigin and application query strings to IDAC login URL to enable contextual background on sign in page",
            expectedReleaseDate: "01/12/2025",
            expectedRuntime: "7 weeks",
            clientOnly: true,
            context: {
                // eslint-disable-next-line
                urls: [
                    "*"
                ]
            }
        }
    },
    jiraPricingWaeMigrationExperimentRerunExp: {
        experimentName: "jira_pricing_wae_migration_experiment_rerun_exp_1",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Rerun of migration of Jira pricing page to WAE",
            expectedReleaseDate: "03/06/2026",
            expectedRuntime: "43 days",
            context: {
                urls: [
                    "/software/jira/pricing"
                ]
            }
        }
    },
    dxpMigrationConfluenceAnchorJourney: {
        experimentName: "dxp_migration_confluence_anchor_journey",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Migration of Confluence anchor journey to DXP",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/software/confluence"
                ]
            }
        }
    },
    gwpAJContextualBanditsConfluenceSubAnchor: {
        experimentName: "gwp-aj-contextual-bandits-confluence-subanchor",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                if (// oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$1f50eb8420f49d3e)([
                    "/software/confluence"
                ]) && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$2f15ce1cde67833e)() && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $1f12900928d868ac$export$48374a0929d11425)()) return true;
                return false;
            }
        },
        metadata: {
            description: "Contextual bandits for Confluence sub anchor",
            expectedReleaseDate: "12/19/2025",
            expectedRuntime: "12 weeks",
            context: {
                urls: [
                    "/software/confluence"
                ]
            }
        }
    },
    gwp9508ConfluenceBannerIosNativeApp: {
        experimentName: "gwp-9508-confluence-banner-ios-native-app",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$b30de9e5e1e6ddb6)
        },
        metadata: {
            description: "Confluence Banner Ios Native App Experiment",
            expectedReleaseDate: "01/22/2026",
            expectedRuntime: "39 days",
            context: {
                urls: [
                    "/software/confluence/*"
                ]
            }
        }
    },
    gwp9507JiraBannerIosNativeApp: {
        experimentName: "gwp-9507-jira-banner-ios-native-app",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$da27afec777e5a82)
        },
        metadata: {
            description: "Jira Banner App Experiment",
            expectedReleaseDate: "01/22/2026",
            expectedRuntime: "60 days",
            context: {
                urls: [
                    "/software/jira/*"
                ]
            }
        }
    },
    cfind6469FrictionlessFirstLookJiraV3: {
        experimentName: "cfind-6469-frictionless-first-look-jira-v3",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "v3 of the Jira frictionless first look: Update the prompt box to be more intuitive",
            expectedReleaseDate: "06/18/2026",
            expectedRuntime: "",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    cfind6214WacLandingForAiNativeTeams: {
        experimentName: "cfind-6214-wac-landing-for-ai-native-teams",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            // Exposure is fired manually so that only logged-out branded
            // paid search (BPS) traffic on /software/jira is exposed.
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$2f15ce1cde67833e)
        },
        metadata: {
            description: "Split /software/jira traffic for logged-out branded paid search (BPS) users; treatment serves the WAE (Uniform) landing page.",
            expectedReleaseDate: "06/30/2026",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    cfind6214WacLandingForAiNativeTeamsPt: {
        experimentName: "cfind-6214-wac-landing-for-ai-native-teams-pt",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$2f15ce1cde67833e)
        },
        metadata: {
            description: "Split /software/jira traffic for logged-out PT users; treatment serves the WAE (Uniform) landing page.",
            expectedReleaseDate: "06/30/2026",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    d1d6DeferSiteNaming: {
        experimentName: "d1d6-defer-site-naming",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$eaaff87ad9e02759)
        },
        metadata: {
            description: "Remove the explicit site naming step from the Jira signup flow. In treatment, the continueUrl passes deferSiteNaming=true to the confirmation page, which auto-generates the site name and activates the product without a separate site naming step.",
            expectedReleaseDate: "TBD",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/software/jira",
                    "/try/cloud/signup"
                ]
            }
        }
    },
    jiraWacActivationChecklist: {
        experimentName: "wac-jira-activation-checklist",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$f205df8e360cbc3e)
        },
        metadata: {
            description: "Per-product activation checklist surfaced on wac.com/software/jira, rendered directly below the user's most recently accessed Jira site card. Hosts the @post-office/placements--growth-starburst/wac-product-activation-checklist placement.",
            expectedReleaseDate: "06/01/2026",
            expectedRuntime: "4 weeks",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    jiraWacActivationChecklistAa: {
        experimentName: "wac-jira-activation-checklist-aa",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$f205df8e360cbc3e)
        },
        metadata: {
            description: "AA test for the Jira activation checklist cohort on wac.com/software/jira. Uses the same D1-D14 Jira-site targeting as the launch experiment to validate exposure volume before rollout.",
            expectedReleaseDate: "06/01/2026",
            expectedRuntime: "2 weeks",
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    cfind6099JiraRemoveSocialSignups: {
        experimentName: "cfind-6099-jira-remove-social-signups",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$eaaff87ad9e02759)
        },
        metadata: {
            description: "On Jira try/cloud/signup for logged-out users, show Google social signup only (hide Microsoft, Apple, Slack).",
            expectedReleaseDate: "04/01/2026",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/try/cloud/signup"
                ]
            }
        }
    },
    gwp10724JiraAgentHeroChangesOnJiraPt: {
        experimentName: "gwp-10724-jira-agent-hero-changes-on-jira-pt",
        parameterName: "isEnabled",
        defaultValue: true,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Post-rollout retroactive experiment for visual changes above the fold on the Jira PT, related to Jira Agent release",
            expectedReleaseDate: "2026-03-18",
            expectedRuntime: "24 days",
            clientOnly: false,
            context: {
                urls: [
                    "/software/jira"
                ]
            }
        }
    },
    twcg947TwcLandAiLedOnboarding: {
        experimentName: "twcg-947_twc_land_ai-led_onboarding",
        parameterName: "cohort",
        defaultValue: "not-enrolled",
        options: {
            fireExperimentExposure: true,
            typeGuard: (value)=>{
                if (typeof value !== "string") return false;
                return [
                    "control",
                    "variation"
                ].includes(value);
            }
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$79db58cc9c75d79)
        },
        metadata: {
            description: "[TWCG-947] TWC LAND AI-Led Onboarding Experiment",
            expectedReleaseDate: "",
            // to be updated when known
            expectedRuntime: "",
            // to be updated when known
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    wacRefreshQ4Fy26AaTest: {
        experimentName: "wac_refresh_q4fy26_aa_test",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "AA test for WAC Refresh Q4 FY26",
            expectedReleaseDate: "Team26",
            expectedRuntime: "TBD",
            context: {
                urls: [
                    "/",
                    "/software/jira",
                    "/software/confluence",
                    "/software/rovo",
                    "/collections/teamwork"
                ]
            }
        }
    },
    softwareTryRovoCta: {
        experimentName: "try_rovo_cta",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$2f15ce1cde67833e)
        },
        metadata: {
            description: "Try rovo cta on /software page",
            expectedReleaseDate: "04/10/2026",
            expectedRuntime: "35 days",
            context: {
                urls: [
                    "/software"
                ]
            }
        }
    },
    gwpAJCBConfBPSv2: {
        experimentName: "gwp-aj-cb-conf-bps-v2",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>{
                if (// oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$1f50eb8420f49d3e)([
                    "/software/confluence"
                ]) && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $43d486b59dbc7425$export$2f15ce1cde67833e)() && // oxlint-disable-next-line react-hooks/rules-of-hooks
                (0, $1f12900928d868ac$export$48374a0929d11425)()) return true;
                return false;
            }
        },
        metadata: {
            description: "Contextual bandits for Confluence BPS v2 using sub anchor targeting",
            expectedReleaseDate: "04/10/2026",
            expectedRuntime: "10 weeks",
            context: {
                urls: [
                    "/software/confluence/*"
                ]
            }
        }
    },
    servCoLofiBackground: {
        experimentName: "gwp-9785-servco-lofi-background-signup",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Lofi background for servco signup pages",
            expectedReleaseDate: "04/30/2026",
            expectedRuntime: "4 weeks",
            context: {
                urls: [
                    "/try/cloud/signup?bundle=service-collection",
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    sparkSkipOnboardingWizard: {
        experimentName: "spark-jira-skip-onboarding-wizard",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "adding skip button to Jira onboarding wizard",
            expectedReleaseDate: "04/30/2026",
            expectedRuntime: "4 weeks",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    jfindSampleTasksForLandingGateNonTech: {
        experimentName: "jfind-sample-tasks-for-landing-gate-non-tech",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: false,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Provides sample task data during Jira onboarding for non-technical team types",
            expectedReleaseDate: "",
            expectedRuntime: "",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    twcg1935CodingAgentChoice: {
        experimentName: "spice-agentic-development-onboarding",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: (0, $43d486b59dbc7425$export$74b50ac429b5c3cf)
        },
        metadata: {
            description: "Show coding agent choice screen during Jira onboarding",
            expectedReleaseDate: "06/29/2026",
            expectedRuntime: "4 weeks",
            context: {
                urls: [
                    "/ondemand/signup/confirmation"
                ]
            }
        }
    },
    cfindTemplatesHeroIntentValueV6: {
        experimentName: "cfind_templates_hero_intent_value_v6",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Intent + Value Hero on Confluence templates page \u2014 optimize above-fold hero with intent-matched heading, value prop, social proof, and CTA",
            expectedReleaseDate: "06/15/2026",
            expectedRuntime: "3 weeks",
            context: {
                urls: [
                    "/software/confluence/templates"
                ]
            }
        }
    },
    jsmContextualBanditsInWae: {
        experimentName: "jsm-contextual-bandits-in-wae",
        parameterName: "isEnabled",
        defaultValue: false,
        options: {
            fireExperimentExposure: true,
            typeGuard: $097325fd420a348e$var$booleanTypeGuard
        },
        targeting: {
            cohort: ()=>true
        },
        metadata: {
            description: "Contextual bandits in WAE on the JSM product page",
            expectedReleaseDate: "06/25/2026",
            expectedRuntime: "indefinite",
            context: {
                urls: [
                    "/software/jira/service-management"
                ]
            }
        }
    },
    wacRefreshJira: $61da0903344e19a0$export$4fb3c8eb9a885607,
    wacRefreshConfluence: $61da0903344e19a0$export$789dc19b5cc98fa8,
    wacRefreshHomepage: $61da0903344e19a0$export$2e5d92ea3e9294ac,
    wacRefreshTwcRovo: $61da0903344e19a0$export$7e8138eb6f7646bb
};







var $be6a4272c8d3c72b$exports = {};
"use strict";
Object.defineProperty($be6a4272c8d3c72b$exports, "__esModule", {
    value: true
});
$be6a4272c8d3c72b$exports.ResponseError = $be6a4272c8d3c72b$exports.ClientError = $be6a4272c8d3c72b$exports.RequestErrorKind = $be6a4272c8d3c72b$exports.getClientInitializationValues = void 0;

var $cPUDX = parcelRequire("cPUDX");
Object.defineProperty($be6a4272c8d3c72b$exports, "RequestErrorKind", {
    enumerable: true,
    get: function() {
        return $cPUDX.RequestErrorKind;
    }
});
var $b9bea0ef8e41e33e$exports = {};
"use strict";
Object.defineProperty($b9bea0ef8e41e33e$exports, "__esModule", {
    value: true
});
$b9bea0ef8e41e33e$exports.ClientError = void 0;
/**
 * @class ClientError - Thrown when a client error occurred.
 * @extends Error
 * @param {string} message - The error message.
 * @param {RequestErrorKind} kind - The error kind.
 */ class $b9bea0ef8e41e33e$var$ClientError extends Error {
    constructor(message, kind){
        super(message);
        this.kind = kind;
    }
}
$b9bea0ef8e41e33e$exports.ClientError = $b9bea0ef8e41e33e$var$ClientError;


Object.defineProperty($be6a4272c8d3c72b$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $b9bea0ef8e41e33e$exports.ClientError;
    }
});

var $9jILv = parcelRequire("9jILv");
Object.defineProperty($be6a4272c8d3c72b$exports, "ResponseError", {
    enumerable: true,
    get: function() {
        return $9jILv.ResponseError;
    }
});
var $944ab05c6a752c76$exports = {};
"use strict";
Object.defineProperty($944ab05c6a752c76$exports, "__esModule", {
    value: true
});
$944ab05c6a752c76$exports.getClientInitializationValues = void 0;

var $cPUDX = parcelRequire("cPUDX");
var $20bef352d09ce9f4$exports = {};
"use strict";
Object.defineProperty($20bef352d09ce9f4$exports, "__esModule", {
    value: true
});
$20bef352d09ce9f4$exports.fetchExperimentValues = void 0;
var $82b8abf137b868ff$exports = {};
"use strict";
var $82b8abf137b868ff$var$__createBinding = $82b8abf137b868ff$exports && $82b8abf137b868ff$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $82b8abf137b868ff$var$__setModuleDefault = $82b8abf137b868ff$exports && $82b8abf137b868ff$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $82b8abf137b868ff$var$__importStar = $82b8abf137b868ff$exports && $82b8abf137b868ff$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $82b8abf137b868ff$var$__createBinding(result, mod, k);
    }
    $82b8abf137b868ff$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($82b8abf137b868ff$exports, "__esModule", {
    value: true
});
$82b8abf137b868ff$exports.getRequestUrl = $82b8abf137b868ff$exports.fetchExperimentValues = void 0;
var $8c7e0da4b95f244e$exports = {};
"use strict";
Object.defineProperty($8c7e0da4b95f244e$exports, "__esModule", {
    value: true
});
$8c7e0da4b95f244e$exports.FetcherExperimentsResponseSchema = void 0;
var $b79cf4725e7fe961$exports = {};
"use strict";
var $b79cf4725e7fe961$var$__createBinding = $b79cf4725e7fe961$exports && $b79cf4725e7fe961$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b79cf4725e7fe961$var$__setModuleDefault = $b79cf4725e7fe961$exports && $b79cf4725e7fe961$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b79cf4725e7fe961$var$__importStar = $b79cf4725e7fe961$exports && $b79cf4725e7fe961$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b79cf4725e7fe961$var$__createBinding(result, mod, k);
    }
    $b79cf4725e7fe961$var$__setModuleDefault(result, mod);
    return result;
};
var $b79cf4725e7fe961$var$__exportStar = $b79cf4725e7fe961$exports && $b79cf4725e7fe961$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b79cf4725e7fe961$var$__createBinding(exports1, m, p);
};
Object.defineProperty($b79cf4725e7fe961$exports, "__esModule", {
    value: true
});
$b79cf4725e7fe961$exports.z = void 0;

const $b79cf4725e7fe961$var$z = $b79cf4725e7fe961$var$__importStar((parcelRequire("guaR7")));
$b79cf4725e7fe961$exports.z = $b79cf4725e7fe961$var$z;

$b79cf4725e7fe961$var$__exportStar((parcelRequire("guaR7")), $b79cf4725e7fe961$exports);
$b79cf4725e7fe961$exports.default = $b79cf4725e7fe961$var$z;


$8c7e0da4b95f244e$exports.FetcherExperimentsResponseSchema = $b79cf4725e7fe961$exports.z.object({
    clientSdkKey: $b79cf4725e7fe961$exports.z.string(),
    experimentValues: $b79cf4725e7fe961$exports.z.record($b79cf4725e7fe961$exports.z.string(), $b79cf4725e7fe961$exports.z.unknown()),
    customAttributes: $b79cf4725e7fe961$exports.z.record($b79cf4725e7fe961$exports.z.string(), $b79cf4725e7fe961$exports.z.unknown())
});



var $684f3b9068ebfe3d$exports = {};
"use strict";
Object.defineProperty($684f3b9068ebfe3d$exports, "__esModule", {
    value: true
});
$684f3b9068ebfe3d$exports.CLIENT_VERSION = void 0;
$684f3b9068ebfe3d$exports.CLIENT_VERSION = "3.10.1";



const $82b8abf137b868ff$var$FetchRequest = $82b8abf137b868ff$var$__importStar((parcelRequire("hj6VI")));

var $cPUDX = parcelRequire("cPUDX");
var $04f816b9d9cf62ab$exports = {};
"use strict";
Object.defineProperty($04f816b9d9cf62ab$exports, "__esModule", {
    value: true
});
$04f816b9d9cf62ab$exports.safeTimeoutSignal = void 0;
/**
 * This method generates an AbortSignal to attach to a request.
 * It does some extremely cautious checks to determine what is supported
 * @todo replace this with an AbortSignal.timeout polyfill
 *
 * @param timeoutMillis - the number of millis to wait before timing out
 * @returns an instance of AbortSignal if it can find a supported way to do it, otherwise undefined
 */ const $04f816b9d9cf62ab$var$safeTimeoutSignal = (timeoutMillis)=>{
    if ("AbortSignal" in $parcel$global && "timeout" in AbortSignal) return AbortSignal.timeout(timeoutMillis);
    if ("AbortController" in $parcel$global) {
        const abortController = new AbortController();
        setTimeout(()=>abortController.abort(), timeoutMillis);
        return abortController.signal;
    }
    return undefined;
};
$04f816b9d9cf62ab$exports.safeTimeoutSignal = $04f816b9d9cf62ab$var$safeTimeoutSignal;


const $82b8abf137b868ff$var$REQUEST_TIMEOUT_MS = 2000;
async function $82b8abf137b868ff$var$fetchExperimentValues(apiKey, targetApp, identifiers, customAttributes) {
    const requestBody = {
        targetApp: targetApp,
        identifiers: identifiers,
        customAttributes: customAttributes
    };
    const response = await fetch($82b8abf137b868ff$var$getRequestUrl(), {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Client-Name": "feature-gate-node-client",
            "X-Client-Version": $684f3b9068ebfe3d$exports.CLIENT_VERSION,
            "X-API-KEY": apiKey
        },
        body: JSON.stringify(requestBody),
        signal: (0, $04f816b9d9cf62ab$exports.safeTimeoutSignal)($82b8abf137b868ff$var$REQUEST_TIMEOUT_MS)
    });
    const bodyString = await $82b8abf137b868ff$var$FetchRequest.handleResponse($82b8abf137b868ff$var$getRequestUrl(), response);
    return $82b8abf137b868ff$var$extractResponseBody(bodyString);
}
$82b8abf137b868ff$exports.fetchExperimentValues = $82b8abf137b868ff$var$fetchExperimentValues;
function $82b8abf137b868ff$var$getRequestUrl() {
    const baseUrl = "https://feature-flag-service.prod.atl-paas.net";
    if (!baseUrl) throw new $b9bea0ef8e41e33e$exports.ClientError("Service proxy base url MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL environment variable is not configured for your environment.", $cPUDX.RequestErrorKind.IllegalStateException);
    /*
     * Need to ensure that baseUrl ends with a '/' so that the URL constructor does not strip out `/flags` from
     * the MESH_DEPENDENCY_FEATURE_FLAG_SERVICE_BASE_URL env variable set by
     */ const parsedBaseUrl = baseUrl.endsWith("/") ? baseUrl : baseUrl + "/";
    return new URL("./api/v2/frontend/experimentValues", parsedBaseUrl).href;
}
$82b8abf137b868ff$exports.getRequestUrl = $82b8abf137b868ff$var$getRequestUrl;
function $82b8abf137b868ff$var$extractResponseBody(body) {
    const result = $8c7e0da4b95f244e$exports.FetcherExperimentsResponseSchema.safeParse(JSON.parse(body));
    if (!result.success) throw new $b9bea0ef8e41e33e$exports.ClientError(`Could not parse request response.`, $cPUDX.RequestErrorKind.BadResponseException);
    return result.data;
}


Object.defineProperty($20bef352d09ce9f4$exports, "fetchExperimentValues", {
    enumerable: true,
    get: function() {
        return $82b8abf137b868ff$exports.fetchExperimentValues;
    }
});




var $9jILv = parcelRequire("9jILv");
/**
* @since 1.0.0
* @async
* @static
* @param {ClientOptions} clientOptions
* @param {String} targetApp
* @param {Identifiers} identifiers
* @param {CustomAttributes} customAttributes
* @returns {FrontendExperimentsResponse | undefined}
* @throws {ClientError} {@link RequestErrorKind.BadRequestException}
* @throws {ClientError} {@link RequestErrorKind.UnknownException}
* @throws {ClientError} {@link RequestErrorKind.IllegalStateException}
* @throws {ResponseError} {@link RequestErrorKind.UnauthorisedRequestException}
* @throws {ResponseError} {@link RequestErrorKind.NotFoundException}
* @throws {ResponseError} {@link RequestErrorKind.NoContentException}
* @throws {ResponseError} {@link RequestErrorKind.BadResponseException}
* @throws {ResponseError} {@link RequestErrorKind.RateLimitedException}
* @summary This will fetch experiment values by calling out to feature-flag-service [fx3]{@link https://go.atlassian.com/fx3}
* @example
await FeatureGates.getClientInitializationValues(
{
            // This is an fx3 api key used to fetch the feature flag values.
            // Supported keys found at go/fx3/resources/api-keys
            apiKey: 'client-test',
            // This will be used to filter data to only a specific target app
            targetApp: 'jira_web',
       },
{
            // These are expected identifiers, you must provide them if they are relevant to your product and will be added to exposures events
            // At least one identifier must be provided
            analyticsAnonymousId: '<analyticsAnonymousId>',
            atlassianAccountId: '<aaid>',
            atlassianOrgId: '<orgid>',
            tenantId: '<tenantid>',
            transactionAccountId: '<transactionAccountId'>,
            trelloUserId: '<trelloUserId'>,
            trelloWorkspaceId: '<trelloWorkspaceId'>,
       },
{
            // These are additional custom attributes that can be used for targeting and will be added to exposure events
             exampleCustomAttribute: '<attributeValue>',
       }
);
* @example
A successful request will return a [FrontendExperimentsRequestResponse]{@link FrontendExperimentsRequestResponse}
{
        // The client sdk key
        clientSdkKey: string;
        // Experiment values
        experimentValues: Record<string, value>;
        // Custom attributes used to fetch experiment values. Includes Targeting + User Dimension TAP traits.
        customAttributes: Record<string, value>;
   }
*/ const $944ab05c6a752c76$var$getClientInitializationValues = async (clientOptions, targetApp, identifiers, customAttributes)=>{
    const { apiKey: apiKey } = clientOptions;
    try {
        $944ab05c6a752c76$var$validateRequest(identifiers);
        return await (0, $20bef352d09ce9f4$exports.fetchExperimentValues)(apiKey, targetApp, identifiers, customAttributes);
    } catch (error) {
        throw $944ab05c6a752c76$var$handleError(error);
    }
};
$944ab05c6a752c76$exports.getClientInitializationValues = $944ab05c6a752c76$var$getClientInitializationValues;
const $944ab05c6a752c76$var$validateRequest = (identifiers)=>{
    const noIdentifiers = Object.keys(identifiers).length == 0;
    if (noIdentifiers) throw new $b9bea0ef8e41e33e$exports.ClientError("No request identifiers supplied.", $cPUDX.RequestErrorKind.BadRequestException);
};
const $944ab05c6a752c76$var$handleError = (error)=>{
    const isResponseError = error instanceof $9jILv.ResponseError;
    const isClientError = error instanceof $b9bea0ef8e41e33e$exports.ClientError;
    if (isResponseError || isClientError) return error;
    const errMessage = error instanceof Error ? error.message : JSON.stringify(error);
    throw new $b9bea0ef8e41e33e$exports.ClientError(`An error occurred while trying to get initialization values for client: ${errMessage}`, $cPUDX.RequestErrorKind.UnknownException);
};


Object.defineProperty($be6a4272c8d3c72b$exports, "getClientInitializationValues", {
    enumerable: true,
    get: function() {
        return $944ab05c6a752c76$exports.getClientInitializationValues;
    }
});



/**
 * Validates a cloudId value read from URL query parameters to prevent Reflected XSS.
 */ const $92f6569dc639987f$var$CLOUD_ID_SAFE_PATTERN = /^[a-zA-Z0-9-]{1,128}$/;
function $92f6569dc639987f$export$a8ae1dc2f01c9aeb(raw) {
    if (raw == null || typeof raw !== "string") return "";
    const trimmed = raw.trim();
    return $92f6569dc639987f$var$CLOUD_ID_SAFE_PATTERN.test(trimmed) ? trimmed : "";
}



/**
 * Removes Personal Data (PD) from a URL query string before it is forwarded
 * to third-party systems such as Statsig as a user attribute.
 *
 * Atlassian's PD Standard
 * (https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617) classifies a
 * number of fields as Restricted/Confidential PD. Several of those fields are
 * frequently appended to wac.atlassian.com URLs by marketing campaigns,
 * onboarding redirects, sign-up flows, etc. (`?email=...`, `?firstName=...`,
 * `?phone=...`, ...), and were being sent verbatim to Statsig via the
 * `queryParams` user attribute.
 *
 * This utility scrubs the query string in two passes:
 *
 *   1. Drops any parameter whose **name** matches a known PD field name
 *      (case-insensitive, supports common separator variants such as
 *      `firstname`, `first_name`, `first-name`, `firstName`).
 *   2. Redacts any parameter whose **value** clearly looks like a PD value
 *      (currently: anything containing an `@` is treated as an email-shaped
 *      value, regardless of the key).
 *
 * The result preserves param ordering and is safe to use as a Statsig user
 * attribute. The function is intentionally pure and side-effect free so it can
 * be exercised on both server and client code paths
 * (see `feature-gates/bootstrapper.ts` and
 * `utils/fg-bootstrap-values-override-utils.ts`).
 */ /**
 * PD field names sourced from the "Atlassian PD Elements" table on
 * https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617#Atlassian-PD-Elements.
 *
 * Names are stored in a normalized form (lowercase, with `_` and `-` removed)
 * so that the lookup matches `firstName`, `first_name`, `first-name`, and
 * `firstname` without having to enumerate every variant.
 *
 * NOTE: this list is deliberately conservative — when in doubt, drop the
 * parameter. Adding a brand-new query param is cheap; leaking a PD value to a
 * third party is not.
 */ const $192e25669d899319$var$PD_PARAM_NAMES = new Set([
    // --- Direct identifiers ---
    "email",
    "emailaddress",
    "useremail",
    "personalemail",
    "workemail",
    "name",
    "fullname",
    "firstname",
    "lastname",
    "givenname",
    "familyname",
    "surname",
    "middlename",
    "displayname",
    "nickname",
    "username",
    "user",
    "userid",
    // Atlassian account IDs are PD; cloud identifiers come in
    //         on their own dedicated, validated `cloudId` param which
    //         is intentionally NOT scrubbed.
    "login",
    "loginid",
    "phone",
    "phonenumber",
    "mobile",
    "mobilenumber",
    "telephone",
    "tel",
    "fax",
    "address",
    "address1",
    "address2",
    "streetaddress",
    "street",
    "city",
    "state",
    "province",
    "postalcode",
    "postcode",
    "zip",
    "zipcode",
    "country",
    // request-derived geo is allowed via the dedicated
    //            `country`/`region` user attributes; we do NOT want
    //            user-supplied country values from the URL.
    "billingaddress",
    "shippingaddress",
    "passport",
    "passportnumber",
    "ssn",
    "taxid",
    "nationalid",
    "governmentid",
    "creditcard",
    "cardnumber",
    "ccnumber",
    "cvv",
    "cvc",
    "bankaccount",
    "iban",
    "profilephoto",
    "avatar",
    "avatarurl",
    "photo",
    "photourl",
    "biography",
    "bio",
    "aboutme",
    // --- Indirect identifiers (Restricted) ---
    "jobtitle",
    "title",
    "role",
    "dob",
    "dateofbirth",
    "birthday",
    "birthdate",
    "age",
    "gender",
    "genderidentity",
    "pronouns",
    "preferredpronouns",
    "race",
    "ethnicity",
    "sexualorientation",
    "disability",
    "disabilitystatus",
    "education",
    "educationlevel",
    "ip",
    "ipaddress",
    "ccexp",
    "ccexpiration",
    "creditcardexpiration",
    "creditcardtype",
    // --- Atlassian-specific PD ---
    "aaid",
    "atlassianaccountid",
    "accountid",
    "sen",
    "supportentitlementnumber"
].map($192e25669d899319$var$normalizeParamName));
/** Placeholder value substituted in for parameters whose value shape looks
 *  like PD (e.g. an email). The key is preserved so that downstream
 *  experiment targeting that already inspects "did this URL have an `x`
 *  param?" continues to work, but the actual PD value never leaves the
 *  process. */ const $192e25669d899319$var$REDACTED = "[REDACTED]";
/**
 * Normalizes a query-param name for deny-list comparison: lowercases, and
 * strips common separators so `first_name`, `first-name`, `firstName`, and
 * `firstname` all collapse to the same key.
 */ function $192e25669d899319$var$normalizeParamName(name) {
    return name.toLowerCase().replace(/[_\-\s]/g, "");
}
/** Returns true if a value looks like an email address. Intentionally cheap
 *  and conservative — we only need to catch obvious leakage, not validate
 *  RFC 5322. */ function $192e25669d899319$var$looksLikeEmail(value) {
    // Any "x@y" with no whitespace is treated as an email-shaped value.
    return /[^\s@]+@[^\s@]+/.test(value);
}
function $192e25669d899319$export$e24e095133c579b3(search) {
    if (!search) return "";
    const hasLeadingQuestionMark = search.startsWith("?");
    const raw = hasLeadingQuestionMark ? search.slice(1) : search;
    if (raw.length === 0) return hasLeadingQuestionMark ? "?" : "";
    // URLSearchParams handles decoding and re-encoding for us, and preserves
    // insertion order, which keeps the sanitized string stable for any
    // downstream targeting that hashes the value.
    let params;
    try {
        params = new URLSearchParams(raw);
    } catch  {
        // If the query string is malformed, the safest behaviour is to drop
        // it entirely rather than risk forwarding PD.
        return hasLeadingQuestionMark ? "?" : "";
    }
    const sanitized = new URLSearchParams();
    for (const [key, value] of params){
        if ($192e25669d899319$var$PD_PARAM_NAMES.has($192e25669d899319$var$normalizeParamName(key))) continue;
        if ($192e25669d899319$var$looksLikeEmail(value)) {
            sanitized.append(key, $192e25669d899319$var$REDACTED);
            continue;
        }
        sanitized.append(key, value);
    }
    const result = sanitized.toString();
    if (result.length === 0) return hasLeadingQuestionMark ? "?" : "";
    return hasLeadingQuestionMark ? `?${result}` : result;
}





/**
 * Removes trailing slashes from a route path for consistent matching
 * Preserves empty paths (root route)
 * @param path - The path to normalize
 * @returns The path without trailing slashes
 */ const $93b98cb8418c56a6$var$removeTrailingSlash = (path)=>{
    // Don't remove slash from empty paths (root "/")
    if (path.length <= 1) return path;
    // Remove single trailing slash
    return path.endsWith("/") ? path.slice(0, -1) : path;
};
const $93b98cb8418c56a6$export$e65c18714c4363a3 = (params)=>{
    // set defaults for feature flags
    const featureFlags = {
        enableBundlesAfterSignup: false,
        enableCutSignUpStepsInHalf: false,
        provisionSecondPartyApps: false
    };
    params[0] && (params[0] = params[0].replace(/^\?(.+)/, "$1"));
    params.forEach((param)=>{
        const [key, value] = param.split("=");
        switch(key){
            case "provisionSecondPartyApps":
                if (value === "enableProvisionSecondPartyApps") featureFlags.provisionSecondPartyApps = true;
                break;
        }
    });
    return featureFlags;
};
const $93b98cb8418c56a6$export$9bf1c8c94a38f6fb = (location)=>{
    // remove all leading slashes (server had 2 leading slashes, client has 1)
    const noSlashPrefixPath = location.pathname.replace(/^\/+/, "");
    if (noSlashPrefixPath === "index.html") // case for the unlocalized home page
    return {
        locale: "en",
        path: "",
        variant: undefined,
        search: "",
        featureFlags: {}
    };
    // check if the route has a locale prefix
    const potentialLocale = noSlashPrefixPath.split("/")[0] || "";
    const localeIsValid = (0, $a69c6ceceedb3a08$export$b7c662043e31af59)(potentialLocale);
    // if there is a locale prefix, set the locale variable and remove the prefix from the path
    // otherwise, set the locale to the default (en) and leave the path as is
    const locale = localeIsValid ? potentialLocale : "en";
    const pathWithoutLocale = localeIsValid ? noSlashPrefixPath.slice(locale.length + 1) : noSlashPrefixPath;
    // Remove trailing slashes for consistent route matching
    // This ensures /software/jira/ matches the same route as /software/jira
    const cleanedPath = $93b98cb8418c56a6$var$removeTrailingSlash(pathWithoutLocale);
    const params = (location.search ?? "").split("&");
    let cmsVariantValue = params.filter((param)=>param.includes("cmsVariant"))[0]?.split("=")[1];
    const rawPersona = params.filter((param)=>param.includes("persona"))[0]?.split("=")[1];
    const isUniformCanary = params.filter((param)=>param.includes("canary"))[0]?.split("=")[1];
    const keyword = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("keyword"))[0]?.split("=")[1] || ""));
    const channel = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("channel"))[0]?.split("=")[1] || ""));
    const anchor = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("anchor"))[0]?.split("=")[1] || ""));
    const subAnchor = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("subAnchor"))[0]?.split("=")[1] || ""));
    const mlTemplateIds = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("mlTemplateIds"))[0]?.split("=")[1] || "")).split(",").filter((i)=>i !== "");
    //if they were redirected from jira.com, set referrer to jira.com
    const referrer = params.filter((param)=>param.includes("referer"))[0]?.split("=")[1] === "jira.com" ? "jira.com" : "";
    const referralSource = decodeURIComponent(params.filter((param)=>param.includes("referralSource"))[0]?.split("=")[1] || "");
    // publicQueryParams is double encoded
    const publicQueryParams = decodeURIComponent(decodeURIComponent(params.filter((param)=>param.includes("publicQueryParams"))[0]?.split("=")[1] || ""));
    const clusterTag = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("anchor="))[0]?.split("=")[1] || ""));
    const utmMedium = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("utm_medium"))[0]?.split("=")[1] || ""));
    const utmContent = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("utm_content"))[0]?.split("=")[1] || ""));
    const utmCampaign = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("utm_campaign"))[0]?.split("=")[1] || ""));
    let persona = undefined;
    try {
        // if rawPersona is malformed or incidentally a unicode sequence, decodeURIComponent will throw an error
        persona = rawPersona ? decodeURIComponent(rawPersona) : undefined;
    } catch (e) {
        console.error("Error decoding persona parameter", e, rawPersona);
    }
    const teamType = (0, (/*@__PURE__*/$parcel$interopDefault($5a5e255be41ec1f1$exports)))(decodeURIComponent(params.filter((param)=>param.includes("team_type"))[0]?.split("=")[1] || ""));
    if (cleanedPath.includes("enterprise")) // Use formType parameter if cleanedPath contains 'enterprise'
    cmsVariantValue = params.filter((param)=>param.includes("formType"))[0]?.split("=")[1];
    const featureFlags = $93b98cb8418c56a6$export$e65c18714c4363a3(params);
    const bundleParam = decodeURIComponent(params.filter((param)=>param.includes("bundle"))[0]?.split("=")[1] || "");
    const productParam = decodeURIComponent(params.filter((param)=>param.includes("product"))[0]?.split("=")[1] || "");
    const product = (0, $2013190fd983e397$export$882be03a94b7d874)(bundleParam, productParam);
    return {
        path: cleanedPath,
        variant: cmsVariantValue,
        locale: locale,
        search: location.search,
        featureFlags: featureFlags,
        persona: persona,
        teamType: teamType,
        keyword: keyword,
        mlTemplateIds: mlTemplateIds,
        referrer: referrer,
        isUniformCanary: isUniformCanary,
        product: product,
        channel: channel,
        anchor: anchor,
        subAnchor: subAnchor,
        referralSource: referralSource,
        publicQueryParams: publicQueryParams,
        clusterTag: clusterTag,
        utmMedium: utmMedium,
        utmContent: utmContent,
        utmCampaign: utmCampaign
    };
};



const $8688f27476b81b24$export$121746a5cf7765d2 = "ajs_anonymous_id";
const $8688f27476b81b24$export$e2b09c9608af1474 = "__aid_user_id";
let $8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE = undefined;
let $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = undefined;
const $8688f27476b81b24$var$DEVICE_TYPE = "deviceType";
const $8688f27476b81b24$var$FETCH_TIMEOUT_MS = 5000;
// @ts-ignore
const $8688f27476b81b24$var$clientOptions = {
    apiKey: String("4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f"),
    products: []
};
const $8688f27476b81b24$export$c2257a35df1efe44 = async (request)=>{
    const requestHeaders = request.headers;
    const identifiers = $8688f27476b81b24$export$1a39186c5d79b4fa(requestHeaders);
    const customAttributes = $8688f27476b81b24$export$1ef2b1f78c9e40d9(request, identifiers.analyticsAnonymousId);
    // The Tesseract/snapvm SSR runtime exposes AbortSignal.timeout but does not
    // provide the `scheduler` global it depends on internally. The upstream
    // feature-gate-node-client-bootstrapper library checks for the method's
    // existence but not whether it works, so calling it throws. Remove the
    // broken method to force the library's AbortController-based fallback.
    if (typeof AbortSignal !== "undefined" && "timeout" in AbortSignal) try {
        AbortSignal.timeout(1);
    } catch  {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete AbortSignal.timeout;
    }
    let response;
    try {
        // The timeout inside getClientInitializationValues relies on the AbortSignal.timeout
        // and AbortController APIs, neither of which are currently supported during SSR.
        // This custom timeout can be replaced once it is supported.
        let timeoutId;
        const timeoutPromise = new Promise((_resolve, reject)=>{
            timeoutId = setTimeout(()=>reject(new Error(`getClientInitializationValues failed to complete within the ${$8688f27476b81b24$var$FETCH_TIMEOUT_MS}ms timeout`)), $8688f27476b81b24$var$FETCH_TIMEOUT_MS);
        });
        const fetchPromise = (0, $be6a4272c8d3c72b$exports.getClientInitializationValues)($8688f27476b81b24$var$clientOptions, (0, $05a33f5401262f31$export$5a16cf6d9176400b), identifiers, customAttributes).then((featureGateValues)=>{
            // Clean up server-only infrastructure attributes that client can't verify
            // These cause bootstrap mismatch warnings in Statsig because the client
            // has no way to compute/verify them
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const expValues = featureGateValues.experimentValues;
            if (expValues?.["user"]?.["custom"]) {
                const cleanedCustom = {
                    ...expValues["user"]["custom"]
                };
                // Remove infrastructure-specific attributes
                delete cleanedCustom.microsEnv;
                delete cleanedCustom.microsAwsAvailabilityZone;
                delete cleanedCustom.userAgent;
                delete cleanedCustom.appVersion;
                expValues["user"]["custom"] = cleanedCustom;
            }
            return {
                ...featureGateValues,
                identifiers: identifiers
            };
        }).finally(()=>{
            if (timeoutId) clearTimeout(timeoutId);
        });
        response = await Promise.race([
            fetchPromise,
            timeoutPromise
        ]);
    } catch (e) {
        const reason = e instanceof Error ? e.message : JSON.stringify(e);
        console.warn(`Could not fetch feature gate values, falling back to defaults. Reason: ${reason}`);
        response = {
            identifiers: identifiers
        };
    }
    return response;
};
const $8688f27476b81b24$export$1a39186c5d79b4fa = (headers)=>{
    // @ts-ignore
    const cookieHeader = headers["cookie"];
    const parsedCookies = cookieHeader ? (0, $6c7e05446819bf8a$exports.parse)(cookieHeader) : {};
    const rawCloudId = new URLSearchParams(window?.location?.search).get("cloudId");
    const tenantId = (0, $92f6569dc639987f$export$a8ae1dc2f01c9aeb)(rawCloudId) || undefined;
    return {
        // @ts-ignore
        analyticsAnonymousId: $8688f27476b81b24$var$getOrGenerateAnalyticsAnonymousId(parsedCookies),
        // @ts-ignore
        atlassianAccountId: $8688f27476b81b24$var$getAtlassianAccountId(parsedCookies),
        tenantId: tenantId
    };
};
const $8688f27476b81b24$export$74de76ff8df79f92 = ()=>$8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE;
const $8688f27476b81b24$export$30a84b3e63884abd = ()=>$8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
const $8688f27476b81b24$var$getOrGenerateAnalyticsAnonymousId = (parsedCookies)=>{
    const anonymousIdCookieValue = parsedCookies[$8688f27476b81b24$export$121746a5cf7765d2];
    if (anonymousIdCookieValue) {
        // The cookie value is wrapped in quotes, so we need to remove those.
        $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = decodeURIComponent(anonymousIdCookieValue).replace(/['"]+/g, "");
        return $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
    }
    (0, $50ddae1ef20437fb$export$5c073f9c8bff1ad3)();
    $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE = (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)();
    // Check for presence of lambda edge - check key
    if (parsedCookies["X-Experiments-Key"]) {
        const experimentsKey = parsedCookies["X-Experiments-Key"];
        if (window.location.pathname === // @ts-ignore
        experimentsKey.split("~")[0].split("=")[1]) // This console.log should never occur when request is through lambda edge.
        // Edge should be passing in the cookie
        console.log("Generating new anonymous id cookie value " + $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE);
    }
    return $8688f27476b81b24$var$ANALYTICS_ANONYMOUS_ID_COOKIE_VALUE;
};
/**
 * Get AtlCohort from cookie, if it doesn't exist, generate a new one
 * @param parsedCookies
 * @returns {"bucketAll":{"bucketedAtUTC":"2024-04-24T19:26:55.734Z","version":"2","index":74,"bucketId":0}}
 */ const $8688f27476b81b24$var$getOrGenerateAtlCohort = (parsedCookies, anonymousId)=>{
    const atlCohortCookieValue = parsedCookies[0, $add74f19dfb8bf8a$export$69c4df819eb57a1b];
    if (atlCohortCookieValue) try {
        $8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE = JSON.parse(decodeURIComponent(atlCohortCookieValue));
        return $8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE;
    } catch (e) {
        console.warn(`Could not parse ATL_COHORT cookie value: ${atlCohortCookieValue}, creating a new one.`, e);
    }
    const bucketAttribute = (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).createBucket("bucketAll", anonymousId);
    $8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE = {
        bucketAll: bucketAttribute
    };
    return $8688f27476b81b24$var$ATL_COHORT_COOKIE_VALUE;
};
const $8688f27476b81b24$var$getAtlassianAccountId = (parsedCookies)=>{
    const atlassianAccountIdCookieValue = parsedCookies[$8688f27476b81b24$export$e2b09c9608af1474];
    if (atlassianAccountIdCookieValue) return decodeURIComponent(atlassianAccountIdCookieValue);
    return undefined;
};
const $8688f27476b81b24$export$1ef2b1f78c9e40d9 = (request, anonymousId)=>{
    const data = {};
    const headers = request.headers;
    // @ts-ignore
    const cookieHeader = headers["cookie"];
    // @ts-ignore
    const cookieOverrideHeader = headers["cookieOverride"];
    // @ts-ignore
    const userAgent = headers["user-agent"] || "";
    const parsedCookies = cookieHeader ? (0, $6c7e05446819bf8a$exports.parse)(cookieHeader) : cookieOverrideHeader ? JSON.parse(cookieOverrideHeader) : {};
    const atlCohort = $8688f27476b81b24$var$getOrGenerateAtlCohort(parsedCookies, anonymousId);
    if (atlCohort) data[0, $add74f19dfb8bf8a$export$69c4df819eb57a1b] = atlCohort.bucketAll.index;
    const { isTablet: isTablet, isMobile: isMobile, isDesktop: isDesktop, browserName: browserName, browserVersion: browserVersion, osName: osName } = (0, $7f3bb8df8d1300c9$exports.getSelectorsByUserAgent)(userAgent) ?? {};
    if (isTablet) data[$8688f27476b81b24$var$DEVICE_TYPE] = "tablet";
    else if (isMobile) data[$8688f27476b81b24$var$DEVICE_TYPE] = "mobile";
    else if (isDesktop) data[$8688f27476b81b24$var$DEVICE_TYPE] = "desktop";
    else data[$8688f27476b81b24$var$DEVICE_TYPE] = "other";
    data.platform = "uip";
    data.browserName = browserName;
    data.browserVersion = browserVersion;
    data.browserOS = osName;
    // Scrub Personal Data from the query string before exposing it to Statsig
    // as a user attribute. See utils/sanitize-query-params.ts and the PD
    // standard at https://hello.atlassian.net/wiki/spaces/PMP/pages/139161617.
    data.queryParams = (0, $192e25669d899319$export$e24e095133c579b3)(location.search);
    data.requestPath = location.pathname;
    // @ts-expect-error - Tesseract Request type does not have referrer
    data.referer = request.referrer;
    data.locale = (0, $93b98cb8418c56a6$export$9bf1c8c94a38f6fb)(globalThis.location).locale;
    data.anchor = (0, $93b98cb8418c56a6$export$9bf1c8c94a38f6fb)(globalThis.location).anchor;
    data.subAnchor = (0, $93b98cb8418c56a6$export$9bf1c8c94a38f6fb)(globalThis.location).subAnchor;
    const cloudSessionToken = parsedCookies["cloud.session.token"] || parsedCookies["cloud.session.token.stg"];
    data.loginUserDetected = cloudSessionToken !== undefined;
    // @ts-ignore
    data.edgeTraceId = parsedCookies["X-Experiments-Trace-Id"];
    return data;
};


const $05a33f5401262f31$export$5a16cf6d9176400b = "bxp-web-platform_web";
const $05a33f5401262f31$var$getEnvironment = ()=>{
    return (0, $6GwB3.FeatureGateEnvironment).Production;
};
const $05a33f5401262f31$export$b8dcf00f0f359b67 = (experiments, targetName)=>{
    for(const key in experiments){
        if (experiments[key] && experiments[key].experimentName === targetName) return experiments[key];
    }
    return null;
};
const $05a33f5401262f31$export$44d6d69ba7841b6d = (featureFlags, targetName)=>{
    for(const key in featureFlags){
        if (featureFlags[key] && featureFlags[key].featureFlagName === targetName) return featureFlags[key];
    }
    return null;
};
const $05a33f5401262f31$export$933af3c61da21c8d = async (bootstrapValues, options = {
    overrideValues: {
        experimentOverrides: {},
        featureGateOverrides: {}
    }
})=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    if (!isStatic) {
        await (0, $4LHd8.default).initializeFromValues({
            ...options,
            environment: $05a33f5401262f31$var$getEnvironment(),
            targetApp: $05a33f5401262f31$export$5a16cf6d9176400b,
            sdkKey: bootstrapValues.clientSdkKey,
            eventLoggingApi: "https://xp.atlassian.com/v1/"
        }, bootstrapValues.identifiers, bootstrapValues.customAttributes, bootstrapValues.experimentValues);
        const overrideValues = options["overrideValues"];
        if (overrideValues && (overrideValues.experimentOverrides && Object.keys(overrideValues.experimentOverrides).length > 0 || overrideValues.featureGateOverrides && Object.keys(overrideValues.featureGateOverrides).length > 0)) {
            const overrideConfig = {
                configs: {},
                gates: {}
            };
            for (const experimentName of Object.keys(overrideValues.experimentOverrides)){
                const experiment = $05a33f5401262f31$export$b8dcf00f0f359b67((0, $097325fd420a348e$export$367c0902ef62c425), experimentName);
                if (!experiment) {
                    console.warn(`Experiment ${experimentName} not found`);
                    continue;
                }
                const { defaultValue: defaultValue, parameterName: parameterName } = experiment;
                const overrideValue = overrideValues.experimentOverrides[experimentName][parameterName];
                // Validate that experimentOverrideValue is a valid parameter
                if (typeof overrideValue === typeof defaultValue) overrideConfig.configs[experimentName] = overrideValues.experimentOverrides[experimentName];
                else console.warn(`Expected type ${typeof defaultValue} for experiment ${experimentName}, but received ${typeof overrideValue} ${overrideValue}. Attempted override will be skipped`);
            }
            const featureGateOverrides = overrideValues["featureGateOverrides"];
            for (const featureFlagName of Object.keys(featureGateOverrides)){
                const featureFlag = $05a33f5401262f31$export$44d6d69ba7841b6d((0, $206c60391d5bfbc4$export$e62953d023125748), featureFlagName);
                if (!featureFlag) {
                    console.warn(`Feature flag ${featureFlagName} not found`);
                    continue;
                }
                const overrideValue = featureGateOverrides[featureFlagName];
                if (typeof overrideValue === "boolean") overrideConfig.gates[featureFlagName] = overrideValue;
                else console.warn(`Expected boolean for feature flag ${featureFlagName}, but received ${typeof overrideValue} ${overrideValue}. Attempted override will be skipped`);
            }
            (0, $4LHd8.default).setOverrides(overrideConfig);
        } else (0, $4LHd8.default).setOverrides({
            configs: {},
            gates: {}
        });
    } else {
        /**
     * Client side initialization of FeatureGates.
     * On the browser, get values from cookies as request headers are not available.
     * If values don't exist in the cookie, create and set them in the cookie.
     *  This is mainly for new users landing for the first time.
     **/ if (!(0, $c3163505721bf9af$export$2e2bcd8739ae039).get((0, $8688f27476b81b24$export$121746a5cf7765d2))) (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).writeCookie((0, $8688f27476b81b24$export$121746a5cf7765d2), `%22${bootstrapValues.identifiers.analyticsAnonymousId}%22`, 3650, true);
        if (!(0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie((0, $add74f19dfb8bf8a$export$69c4df819eb57a1b))) (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).writeAtlCohort({
            bucketAll: (0, $add74f19dfb8bf8a$export$b76685d1b5a37732).createBucket("bucketAll")
        });
        const identifiers = {
            analyticsAnonymousId: decodeURIComponent((0, $c3163505721bf9af$export$2e2bcd8739ae039).get((0, $8688f27476b81b24$export$121746a5cf7765d2)) || "").replace(/['"]+/g, ""),
            atlassianAccountId: (0, $c3163505721bf9af$export$2e2bcd8739ae039).get((0, $8688f27476b81b24$export$e2b09c9608af1474))
        };
        const customAttributes = (0, $8688f27476b81b24$export$1ef2b1f78c9e40d9)({
            headers: {
                "user-agent": window.navigator.userAgent,
                "cookieOverride": JSON.stringify({
                    [(0, $add74f19dfb8bf8a$export$69c4df819eb57a1b)]: (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie((0, $add74f19dfb8bf8a$export$69c4df819eb57a1b)),
                    "cloud.session.token": (0, $c3163505721bf9af$export$2e2bcd8739ae039).get("cloud.session.token"),
                    "cloud.session.token.stg": (0, $c3163505721bf9af$export$2e2bcd8739ae039).get("cloud.session.token.stg")
                })
            }
        });
        await (0, $4LHd8.default).initialize({
            ...options,
            environment: $05a33f5401262f31$var$getEnvironment(),
            targetApp: $05a33f5401262f31$export$5a16cf6d9176400b,
            apiKey: "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f",
            eventLoggingApi: "https://xp.atlassian.com/v1/"
        }, identifiers, customAttributes);
    }
};
const $05a33f5401262f31$export$d9ae7fa24aec8e06 = async (bootstrapValues, updatedIdentifiers)=>{
    return (0, $4LHd8.default).updateUser(// @ts-ignore
    {
        environment: $05a33f5401262f31$var$getEnvironment(),
        targetApp: $05a33f5401262f31$export$5a16cf6d9176400b,
        apiKey: "4e18bcb9-52fb-4f76-b7b6-a0d9d8e56f8f"
    }, {
        ...bootstrapValues.identifiers,
        ...updatedIdentifiers
    }, bootstrapValues.customAttributes);
};
const $05a33f5401262f31$export$2502765481599a5c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bc1d71a60bfff1c9$export$5bf35293e545f20c)();
    return (0, $iSvIT.useCallback)(async ({ cloudId: cloudId })=>{
        if (typeof window !== "undefined" && window.featureGateBootstrapValues && cloudId) try {
            await $05a33f5401262f31$export$d9ae7fa24aec8e06(window.featureGateBootstrapValues, {
                tenantId: cloudId
            });
        } catch (error) {
            createAnalyticsEvent({
                action: "failed",
                actionSubject: "TenantAwareStatsigClientUpdaterProvider.updateStatsigClient",
                eventType: "operational",
                attributes: {
                    error: error instanceof Error ? error.message : ""
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent
    ]);
};




var $5GZK9 = parcelRequire("5GZK9");


const $a71889fc68f9e7b9$export$8022ee0ca9bf74d6 = (parsedRequestCookies)=>{
    const expOverride = "atlassian_exp_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === expOverride && parsedRequestCookies[expOverride]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies[expOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$219a3f64f0a96356 = (parsedRequestCookies)=>{
    const fgOverride = "atlassian_feature_gate_overrides";
    for (const cookieKey of Object.keys(parsedRequestCookies)){
        if (cookieKey === fgOverride && parsedRequestCookies[fgOverride]) return $a71889fc68f9e7b9$export$d180d40f1827eef7(parsedRequestCookies[fgOverride]);
    }
    return {}; // return empty overrides if none are found
};
const $a71889fc68f9e7b9$export$d180d40f1827eef7 = (cookie)=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5GZK9))).decompressFromBase64(cookie));
    } catch (e) {
        return {};
    }
};
const $a71889fc68f9e7b9$export$54e00feca1927558 = (parsedRequestCookies, userAgent, isPerfOnetrustEnabled)=>{
    const filteredParsedRequestCookies = Object.fromEntries(Object.entries(parsedRequestCookies).filter(([_, value])=>value !== undefined));
    const experimentOverrides = $a71889fc68f9e7b9$export$8022ee0ca9bf74d6(filteredParsedRequestCookies);
    const featureGateOverrides = $a71889fc68f9e7b9$export$219a3f64f0a96356(filteredParsedRequestCookies);
    const pollinatorCheck = userAgent.includes("Pollinator");
    const criterionCheck = userAgent.includes("Criterion");
    let finalExperimentOverrides = experimentOverrides;
    let finalFeatureGateOverrides = featureGateOverrides;
    if (pollinatorCheck || criterionCheck) {
        // @ts-ignore - Merge cookie overrides with defaults, cookie overrides take precedence
        finalExperimentOverrides = Object.values((0, $097325fd420a348e$export$367c0902ef62c425)).reduce((acc, experiment)=>{
            // @ts-ignore
            acc[experiment.experimentName] = {
                // @ts-ignore
                [experiment.parameterName]: experiment.defaultValue,
                // @ts-ignore
                ...experimentOverrides[experiment.experimentName] || {}
            };
            return acc;
        }, {});
        finalFeatureGateOverrides = Object.entries((0, $206c60391d5bfbc4$export$e62953d023125748)).reduce((acc, [, featureFlagObj])=>{
            acc[featureFlagObj.featureFlagName] = featureGateOverrides[featureFlagObj.featureFlagName] ?? false;
            return acc;
        }, {});
        console.log("Overriding ALL experiments to control and ALL feature gates to false, with cookie overrides applied");
    } else if (!isPerfOnetrustEnabled) {
        // @ts-ignore - Only merge cookie overrides with defaults, cookie overrides do NOT take precedence
        finalExperimentOverrides = Object.values((0, $097325fd420a348e$export$367c0902ef62c425)).reduce((acc, experiment)=>{
            // @ts-ignore
            acc[experiment.experimentName] = {
                // @ts-ignore
                [experiment.parameterName]: experiment.defaultValue
            };
            return acc;
        }, {});
        console.log("Overriding ALL experiments to control, ignoring cookie overrides");
    }
    return {
        finalExperimentOverrides: finalExperimentOverrides,
        finalFeatureGateOverrides: finalFeatureGateOverrides
    };
};


var $ca1a71da0caf16e6$exports = {};
"use strict";
Object.defineProperty($ca1a71da0caf16e6$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");

$9z2vN.__exportStar((parcelRequire("jgDTn")), $ca1a71da0caf16e6$exports);
var $4540b3d5b86097c4$exports = {};
"use strict";
Object.defineProperty($4540b3d5b86097c4$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");

var $4540b3d5b86097c4$var$promise_polyfill_1 = $9z2vN.__importDefault((parcelRequire("eujLS")));
var $683892aaaddafe34$exports = {};
"use strict";
Object.defineProperty($683892aaaddafe34$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");
var $ed69eb7245594f35$exports = {};
"use strict";
Object.defineProperty($ed69eb7245594f35$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");
var $ed69eb7245594f35$var$set = function(name, value, options) {
    var str = $ed69eb7245594f35$var$encode(name) + "=" + $ed69eb7245594f35$var$encode((value || "").toString());
    if (value == null) options.maxage = -1;
    var expiry;
    if (options.maxage) expiry = new Date(+new Date() + options.maxage);
    if (options.path) str += "; path=" + options.path;
    if (options.domain) str += "; domain=" + options.domain;
    if (expiry) str += "; expires=" + expiry.toUTCString();
    if (options.secure) str += "; secure";
    if (options.sameSite) str += "; samesite=" + options.sameSite;
    document.cookie = str;
    return str;
};
var $ed69eb7245594f35$var$all = function() {
    try {
        return $ed69eb7245594f35$var$parse(document.cookie);
    } catch (err) {
        if (typeof console !== "undefined" && typeof console.error === "function") console.error(err.stack || err);
        return {};
    }
};
function $ed69eb7245594f35$var$get(name) {
    return $ed69eb7245594f35$var$all()[name];
}
function $ed69eb7245594f35$var$parse(str) {
    var obj = {};
    var pairs = str.split(/ *; */);
    if (pairs[0] === "") return obj;
    pairs.forEach(function(item) {
        var pair = item.split("=");
        var key = $ed69eb7245594f35$var$decode(pair[0]);
        var value = $ed69eb7245594f35$var$decode(pair[1]);
        if (key && value) obj[key] = value;
    });
    return obj;
}
function $ed69eb7245594f35$var$encode(value) {
    try {
        return encodeURIComponent(value);
    } catch (e) {
        console.log("error `encode(%o)` - %o", value, e);
        return "";
    }
}
function $ed69eb7245594f35$var$decode(value) {
    try {
        return decodeURIComponent(value);
    } catch (e) {
        console.log("error `decode(%o)` - %o", value, e);
        return "";
    }
}
function $ed69eb7245594f35$var$getCookie(name) {
    return $ed69eb7245594f35$var$get(name);
}
$ed69eb7245594f35$exports.getCookie = $ed69eb7245594f35$var$getCookie;
function $ed69eb7245594f35$var$getAllCookies() {
    return $ed69eb7245594f35$var$all();
}
$ed69eb7245594f35$exports.getAllCookies = $ed69eb7245594f35$var$getAllCookies;
function $ed69eb7245594f35$var$setCookie(name, value, options) {
    var finalOption = $9z2vN.__assign({
        maxage: 31536000000,
        secure: true,
        path: "/",
        expires: null,
        domain: null,
        sameSite: "lax"
    }, options);
    return $ed69eb7245594f35$var$set(name, value, finalOption);
}
$ed69eb7245594f35$exports.setCookie = $ed69eb7245594f35$var$setCookie;
function $ed69eb7245594f35$var$getCrossDomainCookieOption() {
    var domain = window.location.hostname.split(".").slice(-2).join(".");
    return {
        sameSite: "None",
        domain: domain
    };
}
$ed69eb7245594f35$exports.getCrossDomainCookieOption = $ed69eb7245594f35$var$getCrossDomainCookieOption;



var $jgDTn = parcelRequire("jgDTn");
var $835054454c7cba72$exports = {};
"use strict";
Object.defineProperty($835054454c7cba72$exports, "__esModule", {
    value: true
});

var $5b15b4a57f2868fb$exports = {};
"use strict";
Object.defineProperty($5b15b4a57f2868fb$exports, "__esModule", {
    value: true
});

var $jgDTn = parcelRequire("jgDTn");
$5b15b4a57f2868fb$exports.checkXidValid = function(xid) {
    return (xid.type === $jgDTn.XIDItemType.UID || xid.type === $jgDTn.XIDItemType.XC) && !!xid.value && !!Date.parse(xid.createdAt);
};


var $835054454c7cba72$var$parseCachedXidItem = function(value) {
    try {
        var xid = JSON.parse(value);
        if (xid instanceof Array) {
            var valid = true;
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                valid = valid && $5b15b4a57f2868fb$exports.checkXidValid(entry);
            }
            return valid ? xid : undefined;
        } else return $5b15b4a57f2868fb$exports.checkXidValid(xid) ? xid : undefined;
    } catch (err) {
        return;
    }
};
function $835054454c7cba72$var$getFromLocalStorage(name) {
    try {
        return localStorage.getItem(name) || "";
    } catch (err) {}
}
function $835054454c7cba72$var$getXidFromCookie(name) {
    var cookieValue = $ed69eb7245594f35$exports.getCookie(name);
    return $835054454c7cba72$var$parseCachedXidItem(cookieValue);
}
$835054454c7cba72$exports.getXidFromCookie = $835054454c7cba72$var$getXidFromCookie;
function $835054454c7cba72$var$getXidFromLocalStorage(name) {
    var lsValue = "";
    try {
        lsValue = localStorage.getItem(name) || "";
    } catch (err) {}
    return $835054454c7cba72$var$parseCachedXidItem(lsValue);
}
$835054454c7cba72$exports.getXidFromLocalStorage = $835054454c7cba72$var$getXidFromLocalStorage;
function $835054454c7cba72$var$setLocalstorage(name, value) {
    try {
        localStorage.setItem(name, value);
    } catch (err) {}
}
$835054454c7cba72$exports.setLocalstorage = $835054454c7cba72$var$setLocalstorage;
function $835054454c7cba72$var$getCache(name) {
    return $ed69eb7245594f35$exports.getCookie(name) || $835054454c7cba72$var$getFromLocalStorage(name);
}
$835054454c7cba72$exports.getCache = $835054454c7cba72$var$getCache;
function $835054454c7cba72$var$getXidItemFromCache(name) {
    return $835054454c7cba72$var$getXidFromCookie(name) || $835054454c7cba72$var$getXidFromLocalStorage(name);
}
$835054454c7cba72$exports.getXidItemFromCache = $835054454c7cba72$var$getXidItemFromCache;


var $83a3861792dd6d88$exports = {};
"use strict";
Object.defineProperty($83a3861792dd6d88$exports, "__esModule", {
    value: true
});

var $c0b87dcc06cbc650$exports = {};
"use strict";
Object.defineProperty($c0b87dcc06cbc650$exports, "__esModule", {
    value: true
});
$c0b87dcc06cbc650$exports.parse = function(url) {
    var a = document.createElement("a");
    a.href = url;
    return {
        href: a.href,
        host: a.host || location.host,
        port: "0" === a.port || "" === a.port ? $c0b87dcc06cbc650$exports.port(a.protocol) : a.port,
        hash: a.hash,
        hostname: a.hostname || location.hostname,
        pathname: a.pathname.charAt(0) !== "/" ? "/" + a.pathname : a.pathname,
        protocol: !a.protocol || ":" === a.protocol ? location.protocol : a.protocol,
        search: a.search,
        query: a.search.slice(1)
    };
};
$c0b87dcc06cbc650$exports.isAbsolute = function(url) {
    return 0 === url.indexOf("//") || !!~url.indexOf("://");
};
$c0b87dcc06cbc650$exports.isRelative = function(url) {
    return !$c0b87dcc06cbc650$exports.isAbsolute(url);
};
$c0b87dcc06cbc650$exports.isCrossDomain = function(url) {
    var finalUrl = $c0b87dcc06cbc650$exports.parse(url);
    var location1 = $c0b87dcc06cbc650$exports.parse(window.location.href);
    return finalUrl.hostname !== location1.hostname || finalUrl.port !== location1.port || finalUrl.protocol !== location1.protocol;
};
$c0b87dcc06cbc650$exports.port = function(protocol) {
    switch(protocol){
        case "http:":
            return 80;
        case "https:":
            return 443;
        default:
            return location.port;
    }
};
$c0b87dcc06cbc650$exports.getParam = function(name) {
    var b = window.location.href.match("[?&]" + name + "=([^&#]+)");
    return b ? b.pop() : "";
};


var $83a3861792dd6d88$var$getLevels = function(url) {
    var host = $c0b87dcc06cbc650$exports.parse(url).hostname;
    var parts = host.split(".");
    var last = parts[parts.length - 1];
    var levels = [];
    if (parts.length === 4 && !isNaN(parseInt(last, 10))) return levels;
    if (parts.length <= 1) return levels;
    for(var i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join("."));
    return levels;
};
$83a3861792dd6d88$exports.domain = function(url) {
    var domainLevels = $83a3861792dd6d88$var$getLevels(url);
    for(var _i = 0, domainLevels_1 = domainLevels; _i < domainLevels_1.length; _i++){
        var domainLevel = domainLevels_1[_i];
        var cname = "__tld__";
        var opts = {
            domain: "." + domainLevel
        };
        $ed69eb7245594f35$exports.setCookie(cname, 1, opts);
        if ($ed69eb7245594f35$exports.getCookie(cname)) {
            $ed69eb7245594f35$exports.setCookie(cname, null, opts);
            return domainLevel;
        }
    }
    return "";
};
$83a3861792dd6d88$exports.inIframe = function() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
};
$83a3861792dd6d88$exports.isAtlassianComDomain = function() {
    return /atlassian\.com$/.test(window.location.hostname);
};


var $d1ffbadd10042b56$exports = {};
"use strict";
Object.defineProperty($d1ffbadd10042b56$exports, "__esModule", {
    value: true
});
$d1ffbadd10042b56$exports.uuidv4 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(char) {
        var random = Math.random() * 16 | 0;
        var uuid = char === "x" ? random : random & 0x3 | 0x8;
        return uuid.toString(16);
    });
};


var $683892aaaddafe34$var$UID_REFRESH_PERIOD = 604800000;
var $683892aaaddafe34$var$XC_REFRESH_PERIOD = 2592000000;
$683892aaaddafe34$exports.XC_CURRENT = "atl_xid.xc";
var $683892aaaddafe34$var$XID_REFRESHED_AT = "atl_xid.ts";
var $683892aaaddafe34$var$XID_CURRENT = "atl_xid.current";
var $683892aaaddafe34$var$UIDS_ALL = "atl_xid.uid";
var $683892aaaddafe34$var$UIDS_STORE_LIMIT = 20;
var $683892aaaddafe34$var$Storage = function() {
    function Storage() {}
    Storage.getCachedXID = function() {
        try {
            var currentXID = $835054454c7cba72$exports.getXidItemFromCache($683892aaaddafe34$var$XID_CURRENT);
            var refreshedAt = $835054454c7cba72$exports.getCache($683892aaaddafe34$var$XID_REFRESHED_AT);
            var isFresh = false;
            if (currentXID.length > 0 && currentXID[0].type === $jgDTn.XIDItemType.UID) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $683892aaaddafe34$var$UID_REFRESH_PERIOD;
            else if (currentXID.length > 0 && currentXID[0].type === $jgDTn.XIDItemType.XC) isFresh = parseInt(refreshedAt || "", 10) >= new Date().getTime() - $683892aaaddafe34$var$XC_REFRESH_PERIOD;
            if (isFresh) {
                for(var _i = 0, currentXID_1 = currentXID; _i < currentXID_1.length; _i++){
                    var entry = currentXID_1[_i];
                    entry.state = $jgDTn.XIDState.EXISTING;
                }
                return currentXID;
            } else return [];
        } catch (err) {
            return [];
        }
    };
    Storage.saveXid = function(xid) {
        try {
            $ed69eb7245594f35$exports.setCookie($683892aaaddafe34$var$XID_REFRESHED_AT, new Date().getTime());
            $835054454c7cba72$exports.setLocalstorage($683892aaaddafe34$var$XID_REFRESHED_AT, new Date().getTime().toString());
            var xidCache = [];
            for(var _i = 0, xid_1 = xid; _i < xid_1.length; _i++){
                var entry = xid_1[_i];
                if (entry.value && entry.createdAt) {
                    xidCache.push({
                        type: entry.type,
                        value: entry.value,
                        createdAt: entry.createdAt
                    });
                    break;
                }
            }
            $ed69eb7245594f35$exports.setCookie($683892aaaddafe34$var$XID_CURRENT, JSON.stringify(xidCache));
            $835054454c7cba72$exports.setLocalstorage($683892aaaddafe34$var$XID_CURRENT, JSON.stringify(xidCache));
        } catch (err) {
            console.error("Error setting xid cookie.");
        }
    };
    Storage.updateXc = function(env, xc) {
        try {
            if (env === $jgDTn.Environment.PROD && $83a3861792dd6d88$exports.isAtlassianComDomain()) return Storage.processAtlassianComDomainXc(xc);
            else Storage.saveXcLocalstorage(xc);
        } catch (err) {
            console.error("Error setting xc cookie.");
        }
        return xc;
    };
    Storage.getUids = function() {
        var uid = $835054454c7cba72$exports.getXidItemFromCache($683892aaaddafe34$var$UIDS_ALL) || [];
        for(var _i = 0, uid_1 = uid; _i < uid_1.length; _i++){
            var entry = uid_1[_i];
            entry.state = $jgDTn.XIDState.EXISTING;
        }
        return uid;
    };
    Storage.saveUids = function(uid) {
        try {
            var uidCache = [];
            for(var _i = 0, uid_2 = uid; _i < uid_2.length; _i++){
                var entry = uid_2[_i];
                if (entry.value && entry.createdAt) uidCache.push({
                    type: entry.type,
                    value: entry.value,
                    createdAt: entry.createdAt
                });
            }
            uidCache.slice(0, $683892aaaddafe34$var$UIDS_STORE_LIMIT);
            $835054454c7cba72$exports.setLocalstorage($683892aaaddafe34$var$UIDS_ALL, JSON.stringify(uidCache));
        } catch (err) {
            console.error("Error setting uid cookie.");
        }
    };
    Storage.saveXcLocalstorage = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $835054454c7cba72$exports.getXidFromLocalStorage($683892aaaddafe34$exports.XC_CURRENT);
            if (currentXcCache && currentXcCache.value === xc.value) return;
            else if (currentXcCache && currentXcCache.value !== xc.value) xc.state = $jgDTn.XIDState.CHANGED;
            var xidCache = {
                type: xc.type,
                value: xc.value,
                createdAt: xc.createdAt
            };
            $835054454c7cba72$exports.setLocalstorage($683892aaaddafe34$exports.XC_CURRENT, JSON.stringify(xidCache));
        }
    };
    Storage.processAtlassianComDomainXc = function(xc) {
        if (xc.value && xc.createdAt) {
            var currentXcCache = $835054454c7cba72$exports.getXidFromCookie($683892aaaddafe34$exports.XC_CURRENT);
            if (currentXcCache) {
                $ed69eb7245594f35$exports.setCookie($683892aaaddafe34$exports.XC_CURRENT, JSON.stringify(currentXcCache), $ed69eb7245594f35$exports.getCrossDomainCookieOption());
                var currentXc = $9z2vN.__assign({
                    state: $jgDTn.XIDState.EXISTING
                }, currentXcCache);
                Storage.saveXcLocalstorage(currentXc);
                return currentXc;
            } else {
                var newXcCache = {
                    value: $d1ffbadd10042b56$exports.uuidv4(),
                    createdAt: new Date().toISOString(),
                    type: $jgDTn.XIDItemType.XC
                };
                $ed69eb7245594f35$exports.setCookie($683892aaaddafe34$exports.XC_CURRENT, JSON.stringify(newXcCache), $ed69eb7245594f35$exports.getCrossDomainCookieOption());
                var newXc = $9z2vN.__assign({
                    state: $jgDTn.XIDState.NEW
                }, newXcCache);
                Storage.saveXcLocalstorage(newXc);
                return newXc;
            }
        } else return xc;
    };
    return Storage;
}();
$683892aaaddafe34$exports.Storage = $683892aaaddafe34$var$Storage;


var $d54c6cf9c1d36f4b$exports = {};
"use strict";
Object.defineProperty($d54c6cf9c1d36f4b$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");
var $9c7f61a93f8c0908$exports = {};
"use strict";
Object.defineProperty($9c7f61a93f8c0908$exports, "__esModule", {
    value: true
});
var $29deed952016f13d$exports = {};
"use strict";
Object.defineProperty($29deed952016f13d$exports, "__esModule", {
    value: true
});
var $67d674d0fc1e86ff$exports = {};
"use strict";
Object.defineProperty($67d674d0fc1e86ff$exports, "__esModule", {
    value: true
});
$67d674d0fc1e86ff$exports.UNAVAILABLE = "UNAVAILABLE";
$67d674d0fc1e86ff$exports.ERROR = "ERROR";
$67d674d0fc1e86ff$exports.YES = "YES";
$67d674d0fc1e86ff$exports.NO = "NO";


function $29deed952016f13d$var$browserDefaultEvalLength() {
    try {
        return eval.toString().length || 0;
    } catch (err) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$29deed952016f13d$exports.browserDefaultEvalLength = $29deed952016f13d$var$browserDefaultEvalLength;


$9c7f61a93f8c0908$exports.browserDefaultEvalLength = $29deed952016f13d$exports.browserDefaultEvalLength;
var $5d79129247d18b36$exports = {};
"use strict";
Object.defineProperty($5d79129247d18b36$exports, "__esModule", {
    value: true
});

function $5d79129247d18b36$var$canWriteCookie() {
    try {
        document.cookie = "cookietest=1";
        if (document.cookie.indexOf("cookietest=") !== -1) {
            document.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT";
            return $67d674d0fc1e86ff$exports.YES;
        }
        return $67d674d0fc1e86ff$exports.NO;
    } catch (t) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$5d79129247d18b36$exports.canWriteCookie = $5d79129247d18b36$var$canWriteCookie;


$9c7f61a93f8c0908$exports.canWriteCookie = $5d79129247d18b36$exports.canWriteCookie;
var $f048399d374fe3b1$exports = {};
"use strict";
Object.defineProperty($f048399d374fe3b1$exports, "__esModule", {
    value: true
});

function $f048399d374fe3b1$var$getBrowserVendor() {
    try {
        return navigator.vendor || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$f048399d374fe3b1$exports.getBrowserVendor = $f048399d374fe3b1$var$getBrowserVendor;


$9c7f61a93f8c0908$exports.getBrowserVendor = $f048399d374fe3b1$exports.getBrowserVendor;
var $52212f4b750191de$exports = {};
"use strict";
Object.defineProperty($52212f4b750191de$exports, "__esModule", {
    value: true
});
function $52212f4b750191de$var$getHardwareConcurrency() {
    try {
        var result = parseInt(navigator.hardwareConcurrency.toString(), 10);
        return isNaN(result) ? 1 : result;
    } catch (t) {
        return 1;
    }
}
$52212f4b750191de$exports.getHardwareConcurrency = $52212f4b750191de$var$getHardwareConcurrency;


$9c7f61a93f8c0908$exports.getHardwareConcurrency = $52212f4b750191de$exports.getHardwareConcurrency;
var $26dd85b972bbe6a7$exports = {};
"use strict";
Object.defineProperty($26dd85b972bbe6a7$exports, "__esModule", {
    value: true
});

function $26dd85b972bbe6a7$var$getLanguage() {
    try {
        return navigator.language || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$26dd85b972bbe6a7$exports.getLanguage = $26dd85b972bbe6a7$var$getLanguage;


$9c7f61a93f8c0908$exports.getLanguage = $26dd85b972bbe6a7$exports.getLanguage;
var $68f88f2c5f7dcb89$exports = {};
"use strict";
Object.defineProperty($68f88f2c5f7dcb89$exports, "__esModule", {
    value: true
});

function $68f88f2c5f7dcb89$var$getPlatform() {
    try {
        return navigator.platform || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$68f88f2c5f7dcb89$exports.getPlatform = $68f88f2c5f7dcb89$var$getPlatform;


$9c7f61a93f8c0908$exports.getPlatform = $68f88f2c5f7dcb89$exports.getPlatform;
var $225a906b22a79632$exports = {};
"use strict";
Object.defineProperty($225a906b22a79632$exports, "__esModule", {
    value: true
});

function $225a906b22a79632$var$getPlugins() {
    try {
        var MSIE = "Microsoft Internet Explorer";
        var NETSCAPE = "Netscape";
        var isIE = navigator.appName === MSIE;
        var isNetscape = navigator.appName === NETSCAPE;
        var isTrident = /Trident/.test(navigator.userAgent);
        if (isIE || isNetscape && isTrident) return $67d674d0fc1e86ff$exports.UNAVAILABLE;
        var navigatorPlugins = navigator.plugins;
        var s = "";
        for(var i = 0; i < navigatorPlugins.length; i++){
            var plugin = navigator.plugins[i];
            var name_1 = plugin.name;
            var fileName = plugin.filename;
            var pluginMimeTypes = plugin.length;
            for(var j = 0; j < pluginMimeTypes; j++){
                var o = plugin[j];
                if (o) s = s + name_1 + "," + fileName + "," + o.type + "|";
            }
        }
        return s;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$225a906b22a79632$exports.getPlugins = $225a906b22a79632$var$getPlugins;


$9c7f61a93f8c0908$exports.getPlugins = $225a906b22a79632$exports.getPlugins;
var $55468953793488df$exports = {};
"use strict";
Object.defineProperty($55468953793488df$exports, "__esModule", {
    value: true
});

function $55468953793488df$var$getProductSub() {
    try {
        return navigator.productSub || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$55468953793488df$exports.getProductSub = $55468953793488df$var$getProductSub;


$9c7f61a93f8c0908$exports.getProductSub = $55468953793488df$exports.getProductSub;
var $1c8935b8a621c9f8$exports = {};
"use strict";
Object.defineProperty($1c8935b8a621c9f8$exports, "__esModule", {
    value: true
});

function $1c8935b8a621c9f8$var$getTimeZone() {
    try {
        if (window.Intl && window.Intl.DateTimeFormat) return new window.Intl.DateTimeFormat().resolvedOptions().timeZone;
        return $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$1c8935b8a621c9f8$exports.getTimeZone = $1c8935b8a621c9f8$var$getTimeZone;


$9c7f61a93f8c0908$exports.getTimeZone = $1c8935b8a621c9f8$exports.getTimeZone;
var $84128cce15378d4a$exports = {};
"use strict";
Object.defineProperty($84128cce15378d4a$exports, "__esModule", {
    value: true
});

function $84128cce15378d4a$var$getTimeZoneOffset() {
    try {
        return new Date().getTimezoneOffset() || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$84128cce15378d4a$exports.getTimeZoneOffset = $84128cce15378d4a$var$getTimeZoneOffset;


$9c7f61a93f8c0908$exports.getTimeZoneOffset = $84128cce15378d4a$exports.getTimeZoneOffset;
var $3632c4fea7265d29$exports = {};
"use strict";
Object.defineProperty($3632c4fea7265d29$exports, "__esModule", {
    value: true
});

function $3632c4fea7265d29$var$getUserAgent() {
    try {
        return navigator.userAgent || $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (d) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$3632c4fea7265d29$exports.getUserAgent = $3632c4fea7265d29$var$getUserAgent;


$9c7f61a93f8c0908$exports.getUserAgent = $3632c4fea7265d29$exports.getUserAgent;
var $8985b41667f7c549$exports = {};
"use strict";
Object.defineProperty($8985b41667f7c549$exports, "__esModule", {
    value: true
});

function $8985b41667f7c549$var$isIndexedDBAvailable() {
    try {
        return window.indexedDB ? $67d674d0fc1e86ff$exports.YES : $67d674d0fc1e86ff$exports.NO;
    } catch (e) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$8985b41667f7c549$exports.isIndexedDBAvailable = $8985b41667f7c549$var$isIndexedDBAvailable;


$9c7f61a93f8c0908$exports.isIndexedDBAvailable = $8985b41667f7c549$exports.isIndexedDBAvailable;
var $ffc2d2b9d6604405$exports = {};
"use strict";
Object.defineProperty($ffc2d2b9d6604405$exports, "__esModule", {
    value: true
});

function $ffc2d2b9d6604405$var$isLocalStorageAvailable() {
    try {
        return window.localStorage ? $67d674d0fc1e86ff$exports.YES : $67d674d0fc1e86ff$exports.NO;
    } catch (e) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$ffc2d2b9d6604405$exports.isLocalStorageAvailable = $ffc2d2b9d6604405$var$isLocalStorageAvailable;


$9c7f61a93f8c0908$exports.isLocalStorageAvailable = $ffc2d2b9d6604405$exports.isLocalStorageAvailable;
var $15ace0f1d92984c7$exports = {};
"use strict";
Object.defineProperty($15ace0f1d92984c7$exports, "__esModule", {
    value: true
});

function $15ace0f1d92984c7$var$isSessionStorageAvailable() {
    try {
        return window.sessionStorage ? $67d674d0fc1e86ff$exports.YES : $67d674d0fc1e86ff$exports.NO;
    } catch (e) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$15ace0f1d92984c7$exports.isSessionStorageAvailable = $15ace0f1d92984c7$var$isSessionStorageAvailable;


$9c7f61a93f8c0908$exports.isSessionStorageAvailable = $15ace0f1d92984c7$exports.isSessionStorageAvailable;
var $c78c081c5a30700b$exports = {};
"use strict";
Object.defineProperty($c78c081c5a30700b$exports, "__esModule", {
    value: true
});

function $c78c081c5a30700b$var$isTestingBot() {
    try {
        var t = [
            "webdriver" in window,
            "_Selenium_IDE_Recorder" in window,
            "callSelenium" in window,
            "_selenium" in window,
            "__webdriver_script_fn" in document,
            "__driver_evaluate" in document,
            "__webdriver_evaluate" in document,
            "__selenium_evaluate" in document,
            "__fxdriver_evaluate" in document,
            "__driver_unwrapped" in document,
            "__webdriver_unwrapped" in document,
            "__selenium_unwrapped" in document,
            "__fxdriver_unwrapped" in document,
            "__webdriver_script_func" in document,
            null !== document.documentElement.getAttribute("selenium"),
            null !== document.documentElement.getAttribute("webdriver"),
            null !== document.documentElement.getAttribute("driver")
        ];
        return t.some(function(e) {
            return e === true;
        }) ? $67d674d0fc1e86ff$exports.YES : $67d674d0fc1e86ff$exports.NO;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$c78c081c5a30700b$exports.isTestingBot = $c78c081c5a30700b$var$isTestingBot;


$9c7f61a93f8c0908$exports.isTestingBot = $c78c081c5a30700b$exports.isTestingBot;
var $7f7c60d565a9d88a$exports = {};
"use strict";
Object.defineProperty($7f7c60d565a9d88a$exports, "__esModule", {
    value: true
});

function $7f7c60d565a9d88a$var$isWebDriver() {
    try {
        return navigator.webdriver ? $67d674d0fc1e86ff$exports.YES : $67d674d0fc1e86ff$exports.NO;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$7f7c60d565a9d88a$exports.isWebDriver = $7f7c60d565a9d88a$var$isWebDriver;


$9c7f61a93f8c0908$exports.isWebDriver = $7f7c60d565a9d88a$exports.isWebDriver;


var $006301c8a050cb85$exports = {};
"use strict";
Object.defineProperty($006301c8a050cb85$exports, "__esModule", {
    value: true
});
var $227f843b7c9b76e8$exports = {};
"use strict";
Object.defineProperty($227f843b7c9b76e8$exports, "__esModule", {
    value: true
});

function $227f843b7c9b76e8$var$studyPrint() {
    try {
        var canvasElement = document.createElement("canvas");
        canvasElement.width = 240;
        canvasElement.height = 140;
        canvasElement.style.display = "inline";
        var canvasContext = canvasElement.getContext("2d");
        if (canvasContext) {
            canvasContext.rect(0, 0, 10, 10);
            canvasContext.rect(2, 2, 6, 6);
            canvasContext.isPointInPath(5, 5, "evenodd");
            canvasContext.textBaseline = "alphabetic";
            canvasContext.fillStyle = "#f60";
            canvasContext.fillRect(125, 1, 62, 20);
            canvasContext.fillStyle = "#069";
            canvasContext.font = "11pt no-real-font-123";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 2, 15);
            canvasContext.fillStyle = "rgba(102, 204, 0, 0.2)";
            canvasContext.font = "18pt Arial";
            canvasContext.fillText("Cwm fjordbank \uD83D\uDE03 gly", 4, 45);
            canvasContext.globalCompositeOperation = "multiply";
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.beginPath();
            canvasContext.arc(50, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(0,255,255)";
            canvasContext.beginPath();
            canvasContext.arc(100, 50, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,255,0)";
            canvasContext.beginPath();
            canvasContext.arc(75, 100, 50, 0, 2 * Math.PI, !0);
            canvasContext.closePath();
            canvasContext.fill();
            canvasContext.fillStyle = "rgb(255,0,255)";
            canvasContext.arc(75, 75, 75, 0, 2 * Math.PI, !0);
            canvasContext.arc(75, 75, 25, 0, 2 * Math.PI, !0);
            canvasContext.fill("evenodd");
            return canvasElement.toDataURL();
        }
        return $67d674d0fc1e86ff$exports.UNAVAILABLE;
    } catch (error) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$227f843b7c9b76e8$exports.studyPrint = $227f843b7c9b76e8$var$studyPrint;


$006301c8a050cb85$exports.studyPrint = $227f843b7c9b76e8$exports.studyPrint;



var $7bea4ef702c7ca56$exports = {};
"use strict";
Object.defineProperty($7bea4ef702c7ca56$exports, "__esModule", {
    value: true
});
var $782a0fe041c52838$exports = {};
"use strict";
Object.defineProperty($782a0fe041c52838$exports, "__esModule", {
    value: true
});

var $005a232af8321be4$exports = {};
"use strict";
Object.defineProperty($005a232af8321be4$exports, "__esModule", {
    value: true
});
$005a232af8321be4$exports.fontsToCheck = [
    "Adobe Garamond",
    "Adobe Hebrew",
    "Agency FB",
    "Airstream",
    "Andale Mono",
    "Aparajita",
    "Arial",
    "BN Manson Nights",
    "Baskerville",
    "BlackChancery",
    "Book Antiqua",
    "Bookman Old Style",
    "CG Times",
    "Calibri",
    "Cambria",
    "Cambria Math",
    "Century",
    "Century Gothic",
    "Century Schoolbook",
    "Chalkboard",
    "Comic Sans",
    "Comic Sans MS",
    "Consolas",
    "Cooper Black",
    "Corbel",
    "Courier",
    "Courier New",
    "Curlz MT",
    "DS Sans Serif",
    "Degrassi",
    "Didot",
    "Ebrima",
    "GOST Common",
    "Geneva",
    "Georgia",
    "Gulim",
    "Heiti TC",
    "Helvetica",
    "Helvetica Neue",
    "Hoefler Text",
    "Impact",
    "Kalinga",
    "Letter Gothic",
    "Lithos Pro",
    "Lucida Bright",
    "Lucida Calligraphy",
    "Lucida Console",
    "Lucida Fax",
    "Lucida Handwriting",
    "Lucida Sans",
    "MS Gothic",
    "MS Outlook",
    "MS PGothic",
    "MYRIAD",
    "Malgun Gothic",
    "Mangal",
    "MapInfo Miscellaneous",
    "Meiryo UI",
    "Monaco",
    "Monotype Corsiva",
    "NSimSun",
    "OSAKA",
    "Palatino",
    "Pickwick",
    "Playbill",
    "Pristina",
    "Segoe Print",
    "Segoe Script",
    "Segoe UI",
    "Shonar Bangla",
    "Snell Roundhand",
    "Styllo",
    "Tahoma",
    "Times",
    "Times New Roman",
    "Trebuchet MS",
    "Verdana",
    "Wingdings"
];


var $782a0fe041c52838$var$DetectFonts = function() {
    function DetectFonts() {
        var _this = this;
        this.baseFonts = [
            "monospace",
            "sans-serif",
            "serif"
        ];
        this.testString = "mmmmmmmmmmlli";
        this.testSize = "72px";
        this.defaultWidth = {};
        this.defaultHeight = {};
        this.createSpan = function() {
            var s = document.createElement("span");
            s.style.position = "absolute";
            s.style.left = "-9999px";
            s.style.fontSize = _this.testSize;
            s.style.fontStyle = "normal";
            s.style.fontWeight = "normal";
            s.style.letterSpacing = "normal";
            s.style.lineBreak = "auto";
            s.style.lineHeight = "normal";
            s.style.textTransform = "none";
            s.style.textAlign = "left";
            s.style.textDecoration = "none";
            s.style.textShadow = "none";
            s.style.whiteSpace = "normal";
            s.style.wordBreak = "normal";
            s.style.wordSpacing = "normal";
            s.innerHTML = _this.testString;
            return s;
        };
        this.createSpanWithFonts = function(fontToDetect, baseFont) {
            var s = _this.createSpan();
            s.style.fontFamily = "'" + fontToDetect + "'," + baseFont;
            return s;
        };
        this.initializeBaseFontsSpans = function() {
            var spans = [];
            for(var _i = 0, _a = _this.baseFonts; _i < _a.length; _i++){
                var font = _a[_i];
                var s = _this.createSpan();
                s.style.fontFamily = font;
                _this.baseFontsDiv.appendChild(s);
                spans.push(s);
            }
            return spans;
        };
        this.initializeFontsSpans = function() {
            var spans = {};
            for(var _i = 0, fontsToCheck_2 = $005a232af8321be4$exports.fontsToCheck; _i < fontsToCheck_2.length; _i++){
                var fontToDetect = fontsToCheck_2[_i];
                var fontSpans = [];
                for(var _a = 0, _b = _this.baseFonts; _a < _b.length; _a++){
                    var baseFont = _b[_a];
                    var s = _this.createSpanWithFonts(fontToDetect, baseFont);
                    _this.fontsDiv.appendChild(s);
                    fontSpans.push(s);
                }
                var key = fontToDetect;
                spans[key] = fontSpans;
            }
            return spans;
        };
        this.isFontAvailable = function(fontSpans) {
            var detected = false;
            for(var i = 0; i < _this.baseFonts.length; i++){
                var fontWidth = fontSpans[i].offsetWidth;
                var fontDefaultWidth = _this.defaultWidth[_this.baseFonts[i]];
                var fontHeight = fontSpans[i].offsetHeight;
                var fontDefaultHeight = _this.defaultHeight[_this.baseFonts[i]];
                detected = fontWidth !== fontDefaultWidth || fontHeight !== fontDefaultHeight;
                if (detected) return detected;
            }
            return detected;
        };
        this.bodyElement = document.getElementsByTagName("body")[0];
        this.baseFontsDiv = document.createElement("div");
        this.fontsDiv = document.createElement("div");
    }
    DetectFonts.prototype.detect = function() {
        var baseFontsSpans = this.initializeBaseFontsSpans();
        this.bodyElement.appendChild(this.baseFontsDiv);
        for(var index = 0; index < this.baseFonts.length; index++){
            this.defaultWidth[this.baseFonts[index]] = baseFontsSpans[index].offsetWidth;
            this.defaultHeight[this.baseFonts[index]] = baseFontsSpans[index].offsetHeight;
        }
        var fontsSpans = this.initializeFontsSpans();
        this.bodyElement.appendChild(this.fontsDiv);
        var available = [];
        for(var _i = 0, fontsToCheck_3 = $005a232af8321be4$exports.fontsToCheck; _i < fontsToCheck_3.length; _i++){
            var fontToCheck = fontsToCheck_3[_i];
            var result = 0;
            if (this.isFontAvailable(fontsSpans[fontToCheck])) result = 1;
            available.push(result);
        }
        this.bodyElement.removeChild(this.fontsDiv);
        this.bodyElement.removeChild(this.baseFontsDiv);
        return available.join("|");
    };
    DetectFonts.prototype.result = function() {
        try {
            return this.detect();
        } catch (error) {
            return $67d674d0fc1e86ff$exports.ERROR;
        }
    };
    return DetectFonts;
}();
$782a0fe041c52838$exports.DetectFonts = $782a0fe041c52838$var$DetectFonts;


$7bea4ef702c7ca56$exports.DetectFonts = $782a0fe041c52838$exports.DetectFonts;


var $5b8ce0d268d98d29$exports = {};
"use strict";
Object.defineProperty($5b8ce0d268d98d29$exports, "__esModule", {
    value: true
});
var $9a36b50f4076ea1b$exports = {};
"use strict";
Object.defineProperty($9a36b50f4076ea1b$exports, "__esModule", {
    value: true
});

var $aab3ca9c719446d1$exports = {};
"use strict";
Object.defineProperty($aab3ca9c719446d1$exports, "__esModule", {
    value: true
});

function $aab3ca9c719446d1$var$getContext() {
    if (window.WebGLRenderingContext) {
        var canvasElement = document.createElement("canvas");
        var webGLcontexts = [
            "webgl",
            "experimental-webgl",
            "moz-webgl",
            "webkit-3d"
        ];
        for(var _i = 0, webGLcontexts_1 = webGLcontexts; _i < webGLcontexts_1.length; _i++){
            var contextName = webGLcontexts_1[_i];
            try {
                var canvasRenderingContext = canvasElement.getContext(contextName);
                if (canvasRenderingContext && canvasRenderingContext instanceof WebGLRenderingContext && typeof canvasRenderingContext.getParameter === "function") return {
                    name: contextName,
                    context: canvasRenderingContext
                };
            } catch (p) {
                return $67d674d0fc1e86ff$exports.ERROR;
            }
        }
    }
    return $67d674d0fc1e86ff$exports.UNAVAILABLE;
}
$aab3ca9c719446d1$exports.getContext = $aab3ca9c719446d1$var$getContext;


function $9a36b50f4076ea1b$var$getWebGL() {
    try {
        var gl = $aab3ca9c719446d1$exports.getContext();
        if (typeof gl === "undefined") return $67d674d0fc1e86ff$exports.UNAVAILABLE;
        if (gl && typeof gl === "object" && gl.context) {
            var glContext = gl.context;
            var rendererInfo = glContext.getExtension("WEBGL_debug_renderer_info");
            if (rendererInfo !== null) return [
                glContext.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL),
                glContext.getParameter(glContext.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
                glContext.getParameter(glContext.MAX_CUBE_MAP_TEXTURE_SIZE)
            ].join("|");
            return $67d674d0fc1e86ff$exports.UNAVAILABLE;
        }
    } catch (p) {
        return $67d674d0fc1e86ff$exports.ERROR;
    }
}
$9a36b50f4076ea1b$exports.getWebGL = $9a36b50f4076ea1b$var$getWebGL;


$5b8ce0d268d98d29$exports.getWebGL = $9a36b50f4076ea1b$exports.getWebGL;



var $f7128a72caa01db2$exports = {};
"use strict";
Object.defineProperty($f7128a72caa01db2$exports, "__esModule", {
    value: true
});
var $f7128a72caa01db2$var$x64Add = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] + n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] + n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] + n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] + n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $f7128a72caa01db2$var$x64Multiply = function(m, n) {
    m = [
        m[0] >>> 16,
        m[0] & 0xffff,
        m[1] >>> 16,
        m[1] & 0xffff
    ];
    n = [
        n[0] >>> 16,
        n[0] & 0xffff,
        n[1] >>> 16,
        n[1] & 0xffff
    ];
    var o = [
        0,
        0,
        0,
        0
    ];
    o[3] += m[3] * n[3];
    o[2] += o[3] >>> 16;
    o[3] &= 0xffff;
    o[2] += m[2] * n[3];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[2] += m[3] * n[2];
    o[1] += o[2] >>> 16;
    o[2] &= 0xffff;
    o[1] += m[1] * n[3];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[2] * n[2];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[1] += m[3] * n[1];
    o[0] += o[1] >>> 16;
    o[1] &= 0xffff;
    o[0] += m[0] * n[3] + m[1] * n[2] + m[2] * n[1] + m[3] * n[0];
    o[0] &= 0xffff;
    return [
        o[0] << 16 | o[1],
        o[2] << 16 | o[3]
    ];
};
var $f7128a72caa01db2$var$x64Rotl = function(m, n) {
    n %= 64;
    if (n === 32) return [
        m[1],
        m[0]
    ];
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n | m[0] >>> 32 - n
    ];
    else {
        n -= 32;
        return [
            m[1] << n | m[0] >>> 32 - n,
            m[0] << n | m[1] >>> 32 - n
        ];
    }
};
var $f7128a72caa01db2$var$x64LeftShift = function(m, n) {
    n %= 64;
    if (n === 0) return m;
    else if (n < 32) return [
        m[0] << n | m[1] >>> 32 - n,
        m[1] << n
    ];
    else return [
        m[1] << n - 32,
        0
    ];
};
var $f7128a72caa01db2$var$x64Xor = function(m, n) {
    return [
        m[0] ^ n[0],
        m[1] ^ n[1]
    ];
};
var $f7128a72caa01db2$var$x64Fmix = function(h) {
    h = $f7128a72caa01db2$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $f7128a72caa01db2$var$x64Multiply(h, [
        0xff51afd7,
        0xed558ccd
    ]);
    h = $f7128a72caa01db2$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    h = $f7128a72caa01db2$var$x64Multiply(h, [
        0xc4ceb9fe,
        0x1a85ec53
    ]);
    h = $f7128a72caa01db2$var$x64Xor(h, [
        0,
        h[0] >>> 1
    ]);
    return h;
};
$f7128a72caa01db2$exports.x64hash128 = function(key, seed) {
    key = key || "";
    seed = seed || 0;
    var remainder = key.length % 16;
    var bytes = key.length - remainder;
    var h1 = [
        0,
        seed
    ];
    var h2 = [
        0,
        seed
    ];
    var k1 = [
        0,
        0
    ];
    var k2 = [
        0,
        0
    ];
    var c1 = [
        0x87c37b91,
        0x114253d5
    ];
    var c2 = [
        0x4cf5ad43,
        0x2745937f
    ];
    for(var i = 0; i < bytes; i = i + 16){
        k1 = [
            key.charCodeAt(i + 4) & 0xff | (key.charCodeAt(i + 5) & 0xff) << 8 | (key.charCodeAt(i + 6) & 0xff) << 16 | (key.charCodeAt(i + 7) & 0xff) << 24,
            key.charCodeAt(i) & 0xff | (key.charCodeAt(i + 1) & 0xff) << 8 | (key.charCodeAt(i + 2) & 0xff) << 16 | (key.charCodeAt(i + 3) & 0xff) << 24
        ];
        k2 = [
            key.charCodeAt(i + 12) & 0xff | (key.charCodeAt(i + 13) & 0xff) << 8 | (key.charCodeAt(i + 14) & 0xff) << 16 | (key.charCodeAt(i + 15) & 0xff) << 24,
            key.charCodeAt(i + 8) & 0xff | (key.charCodeAt(i + 9) & 0xff) << 8 | (key.charCodeAt(i + 10) & 0xff) << 16 | (key.charCodeAt(i + 11) & 0xff) << 24
        ];
        k1 = $f7128a72caa01db2$var$x64Multiply(k1, c1);
        k1 = $f7128a72caa01db2$var$x64Rotl(k1, 31);
        k1 = $f7128a72caa01db2$var$x64Multiply(k1, c2);
        h1 = $f7128a72caa01db2$var$x64Xor(h1, k1);
        h1 = $f7128a72caa01db2$var$x64Rotl(h1, 27);
        h1 = $f7128a72caa01db2$var$x64Add(h1, h2);
        h1 = $f7128a72caa01db2$var$x64Add($f7128a72caa01db2$var$x64Multiply(h1, [
            0,
            5
        ]), [
            0,
            0x52dce729
        ]);
        k2 = $f7128a72caa01db2$var$x64Multiply(k2, c2);
        k2 = $f7128a72caa01db2$var$x64Rotl(k2, 33);
        k2 = $f7128a72caa01db2$var$x64Multiply(k2, c1);
        h2 = $f7128a72caa01db2$var$x64Xor(h2, k2);
        h2 = $f7128a72caa01db2$var$x64Rotl(h2, 31);
        h2 = $f7128a72caa01db2$var$x64Add(h2, h1);
        h2 = $f7128a72caa01db2$var$x64Add($f7128a72caa01db2$var$x64Multiply(h2, [
            0,
            5
        ]), [
            0,
            0x38495ab5
        ]);
    }
    k1 = [
        0,
        0
    ];
    k2 = [
        0,
        0
    ];
    var iX = bytes;
    switch(remainder){
        case 15:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 14)
            ], 48));
        case 14:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 13)
            ], 40));
        case 13:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 12)
            ], 32));
        case 12:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 11)
            ], 24));
        case 11:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 10)
            ], 16));
        case 10:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 9)
            ], 8));
        case 9:
            k2 = $f7128a72caa01db2$var$x64Xor(k2, [
                0,
                key.charCodeAt(iX + 8)
            ]);
            k2 = $f7128a72caa01db2$var$x64Multiply(k2, c2);
            k2 = $f7128a72caa01db2$var$x64Rotl(k2, 33);
            k2 = $f7128a72caa01db2$var$x64Multiply(k2, c1);
            h2 = $f7128a72caa01db2$var$x64Xor(h2, k2);
        case 8:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 7)
            ], 56));
        case 7:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 6)
            ], 48));
        case 6:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 5)
            ], 40));
        case 5:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 4)
            ], 32));
        case 4:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 3)
            ], 24));
        case 3:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 2)
            ], 16));
        case 2:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, $f7128a72caa01db2$var$x64LeftShift([
                0,
                key.charCodeAt(iX + 1)
            ], 8));
        case 1:
            k1 = $f7128a72caa01db2$var$x64Xor(k1, [
                0,
                key.charCodeAt(iX)
            ]);
            k1 = $f7128a72caa01db2$var$x64Multiply(k1, c1);
            k1 = $f7128a72caa01db2$var$x64Rotl(k1, 31);
            k1 = $f7128a72caa01db2$var$x64Multiply(k1, c2);
            h1 = $f7128a72caa01db2$var$x64Xor(h1, k1);
    }
    h1 = $f7128a72caa01db2$var$x64Xor(h1, [
        0,
        key.length
    ]);
    h2 = $f7128a72caa01db2$var$x64Xor(h2, [
        0,
        key.length
    ]);
    h1 = $f7128a72caa01db2$var$x64Add(h1, h2);
    h2 = $f7128a72caa01db2$var$x64Add(h2, h1);
    h1 = $f7128a72caa01db2$var$x64Fmix(h1);
    h2 = $f7128a72caa01db2$var$x64Fmix(h2);
    h1 = $f7128a72caa01db2$var$x64Add(h1, h2);
    h2 = $f7128a72caa01db2$var$x64Add(h2, h1);
    return ("00000000" + (h1[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h1[1] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[0] >>> 0).toString(16)).slice(-8) + ("00000000" + (h2[1] >>> 0).toString(16)).slice(-8);
};


var $d54c6cf9c1d36f4b$var$UIDGenerator = function() {
    function UIDGenerator() {}
    UIDGenerator.getDetails = function() {
        try {
            return {
                browser: {
                    browserDefaultEvalLength: $9c7f61a93f8c0908$exports.browserDefaultEvalLength(),
                    canWriteCookie: $9c7f61a93f8c0908$exports.canWriteCookie(),
                    getBrowserVendor: $9c7f61a93f8c0908$exports.getBrowserVendor(),
                    getHardwareConcurrency: $9c7f61a93f8c0908$exports.getHardwareConcurrency(),
                    getLanguage: $9c7f61a93f8c0908$exports.getLanguage(),
                    getPlatform: $9c7f61a93f8c0908$exports.getPlatform(),
                    getPlugins: $9c7f61a93f8c0908$exports.getPlugins(),
                    getProductSub: $9c7f61a93f8c0908$exports.getProductSub(),
                    getTimeZone: $9c7f61a93f8c0908$exports.getTimeZone(),
                    getTimeZoneOffset: $9c7f61a93f8c0908$exports.getTimeZoneOffset(),
                    getUserAgent: $9c7f61a93f8c0908$exports.getUserAgent(),
                    isIndexedDBAvailable: $9c7f61a93f8c0908$exports.isIndexedDBAvailable(),
                    isLocalStorageAvailable: $9c7f61a93f8c0908$exports.isLocalStorageAvailable(),
                    isSessionStorageAvailable: $9c7f61a93f8c0908$exports.isSessionStorageAvailable(),
                    isTestingBot: $9c7f61a93f8c0908$exports.isTestingBot(),
                    isWebDriver: $9c7f61a93f8c0908$exports.isWebDriver()
                },
                canvas: {
                    studyPrint: $006301c8a050cb85$exports.studyPrint()
                },
                font: {
                    jsFonts: new $7bea4ef702c7ca56$exports.DetectFonts().detect()
                },
                webGL: {
                    getWebGL: $5b8ce0d268d98d29$exports.getWebGL()
                }
            };
        } catch (err) {
            return $67d674d0fc1e86ff$exports.ERROR;
        }
    };
    UIDGenerator.getValue = function(cachedUids) {
        try {
            var values = [
                $9c7f61a93f8c0908$exports.browserDefaultEvalLength(),
                $9c7f61a93f8c0908$exports.canWriteCookie(),
                $9c7f61a93f8c0908$exports.getBrowserVendor(),
                $9c7f61a93f8c0908$exports.getHardwareConcurrency(),
                $9c7f61a93f8c0908$exports.getLanguage(),
                $9c7f61a93f8c0908$exports.getPlatform(),
                $9c7f61a93f8c0908$exports.getPlugins(),
                $9c7f61a93f8c0908$exports.getProductSub(),
                $9c7f61a93f8c0908$exports.getTimeZone(),
                $9c7f61a93f8c0908$exports.getTimeZoneOffset(),
                $9c7f61a93f8c0908$exports.getUserAgent(),
                $9c7f61a93f8c0908$exports.isIndexedDBAvailable(),
                $9c7f61a93f8c0908$exports.isLocalStorageAvailable(),
                $9c7f61a93f8c0908$exports.isSessionStorageAvailable(),
                $9c7f61a93f8c0908$exports.isTestingBot(),
                $9c7f61a93f8c0908$exports.isWebDriver(),
                $006301c8a050cb85$exports.studyPrint(),
                new $7bea4ef702c7ca56$exports.DetectFonts().result(),
                $5b8ce0d268d98d29$exports.getWebGL()
            ];
            var value = $f7128a72caa01db2$exports.x64hash128(values.join("|"), 64);
            var state = void 0;
            if (!cachedUids.length) state = $ca1a71da0caf16e6$exports.XIDState.NEW;
            else if (cachedUids[0].value === value) state = $ca1a71da0caf16e6$exports.XIDState.EXISTING;
            else state = $ca1a71da0caf16e6$exports.XIDState.CHANGED;
            return state === $ca1a71da0caf16e6$exports.XIDState.EXISTING ? cachedUids : $9z2vN.__spreadArrays([
                {
                    type: $ca1a71da0caf16e6$exports.XIDItemType.UID,
                    createdAt: new Date().toISOString(),
                    state: state,
                    value: value
                }
            ], cachedUids);
        } catch (err) {
            return [
                {
                    type: $ca1a71da0caf16e6$exports.XIDItemType.UID,
                    state: $ca1a71da0caf16e6$exports.XIDState.ERROR
                }
            ];
        }
    };
    return UIDGenerator;
}();
$d54c6cf9c1d36f4b$exports.UIDGenerator = $d54c6cf9c1d36f4b$var$UIDGenerator;


var $d468c5f17f4149f2$exports = {};
"use strict";
Object.defineProperty($d468c5f17f4149f2$exports, "__esModule", {
    value: true
});

var $9z2vN = parcelRequire("9z2vN");

var $d468c5f17f4149f2$var$promise_polyfill_1 = $9z2vN.__importDefault((parcelRequire("eujLS")));



var $d468c5f17f4149f2$var$TEST_HOST = "";
var $d468c5f17f4149f2$var$DEV_HOST = "xxid.dev.atl-paas.net";
var $d468c5f17f4149f2$var$STG_HOST = "xxid.staging.atl-paas.net";
var $d468c5f17f4149f2$var$PROD_FALLBACK_HOST = "xxid.atl-paas.net";
var $d468c5f17f4149f2$var$PROD_HOST = "xxid.atlassian.com";
var $d468c5f17f4149f2$var$defaultTimeout = 3000;
var $d468c5f17f4149f2$var$XCGenerator = function() {
    function XCGenerator() {}
    XCGenerator.getValue = function(env, timeout, isStorageEnabled) {
        if (timeout === void 0) timeout = $d468c5f17f4149f2$var$defaultTimeout;
        if (isStorageEnabled === void 0) isStorageEnabled = true;
        var xxidHost = XCGenerator.getHost(env);
        var xxidOrigin = xxidHost ? "https://" + xxidHost : "";
        var iframeUrl = xxidOrigin ? xxidOrigin + "?t=" + new Date().getTime() : "";
        var frame = XCGenerator.addFrame(iframeUrl);
        return new $d468c5f17f4149f2$var$promise_polyfill_1.default(function(resolve) {
            var listen = function(event) {
                if (event.data.type === "xcReady" && event.origin === xxidOrigin) {
                    var xc = XCGenerator.messageToXc(event);
                    if (isStorageEnabled) xc = $683892aaaddafe34$exports.Storage.updateXc(env, xc);
                    resolve(xc);
                    XCGenerator.removeFrame(frame, listen);
                }
            };
            window.addEventListener("message", listen);
            setTimeout(function() {
                resolve({
                    type: $ca1a71da0caf16e6$exports.XIDItemType.XC,
                    state: $ca1a71da0caf16e6$exports.XIDState.TIMEOUT
                });
                XCGenerator.removeFrame(frame, listen);
            }, timeout);
        });
    };
    XCGenerator.messageToXc = function(event) {
        var _a = event.data, xc = _a.xc, ts = _a.ts, state = _a.state;
        if (xc && !!Date.parse(ts) && state) return {
            type: $ca1a71da0caf16e6$exports.XIDItemType.XC,
            value: xc,
            createdAt: ts,
            state: state
        };
        else return {
            type: $ca1a71da0caf16e6$exports.XIDItemType.XC,
            state: state ? state : $ca1a71da0caf16e6$exports.XIDState.MALFORMED
        };
    };
    XCGenerator.addFrame = function(url) {
        var frame = document.createElement("iframe");
        frame.id = "xc-" + new Date().getTime();
        frame.src = url;
        frame.style.display = "none";
        frame.style.position = "fixed";
        document.body.appendChild(frame);
        return frame;
    };
    XCGenerator.removeFrame = function(frame, listen) {
        if (document.body.contains(frame)) {
            document.body.removeChild(frame);
            window.removeEventListener("message", listen);
        }
    };
    XCGenerator.getHost = function(env) {
        switch(env){
            case $ca1a71da0caf16e6$exports.Environment.STAGE:
                return $d468c5f17f4149f2$var$STG_HOST;
            case $ca1a71da0caf16e6$exports.Environment.PROD:
                return $83a3861792dd6d88$exports.isAtlassianComDomain() ? $d468c5f17f4149f2$var$PROD_FALLBACK_HOST : $d468c5f17f4149f2$var$PROD_HOST;
            case $ca1a71da0caf16e6$exports.Environment.TEST:
                return $d468c5f17f4149f2$var$TEST_HOST;
            case $ca1a71da0caf16e6$exports.Environment.LOCAL:
            case $ca1a71da0caf16e6$exports.Environment.DEV:
            default:
                return $d468c5f17f4149f2$var$DEV_HOST;
        }
    };
    return XCGenerator;
}();
$d468c5f17f4149f2$exports.XCGenerator = $d468c5f17f4149f2$var$XCGenerator;


var $e2b66f14e43f32d1$exports = {};
"use strict";
Object.defineProperty($e2b66f14e43f32d1$exports, "__esModule", {
    value: true
});

var $jgDTn = parcelRequire("jgDTn");
var $e2b66f14e43f32d1$var$maptoNewXidCandidate = function(item, promiseStartTime) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && (state === $jgDTn.XIDState.NEW || state === $jgDTn.XIDState.CHANGED)) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt,
        timeTaken: $e2b66f14e43f32d1$var$getCurrentTime() - promiseStartTime
    };
    return null;
};
var $e2b66f14e43f32d1$var$maptoExistingXid = function(item) {
    var state = item.state, type = item.type, value = item.value, createdAt = item.createdAt;
    if (item && state && type && value && createdAt && state === $jgDTn.XIDState.EXISTING) return {
        state: state,
        type: type,
        value: value,
        createdAt: createdAt
    };
    return null;
};
var $e2b66f14e43f32d1$var$mapToAmbiguousXid = function(item) {
    var state = item.state, type = item.type;
    if (item && state && type) switch(state){
        case $jgDTn.XIDState.TIMEOUT:
        case $jgDTn.XIDState.ERROR:
        case $jgDTn.XIDState.UNAVAILABLE:
        case $jgDTn.XIDState.UNKNOWN:
        case $jgDTn.XIDState.MALFORMED:
            return {
                type: type,
                state: state
            };
    }
    return null;
};
var $e2b66f14e43f32d1$var$mapToMalformedXid = function(item) {
    var type = item.type;
    if (item && type) return {
        type: type,
        state: $jgDTn.XIDState.MALFORMED
    };
    return null;
};
function $e2b66f14e43f32d1$var$promiseWithTimer(fn) {
    var addTimeTaken = function(item) {
        var fallbackXid = {
            type: $jgDTn.XIDItemType.UID,
            state: $jgDTn.XIDState.MALFORMED
        };
        return $e2b66f14e43f32d1$var$maptoNewXidCandidate(item, start) || $e2b66f14e43f32d1$var$maptoExistingXid(item) || $e2b66f14e43f32d1$var$mapToAmbiguousXid(item) || $e2b66f14e43f32d1$var$mapToMalformedXid(item) || fallbackXid;
    };
    var onPromiseDone = function(data) {
        return data.map(function(item) {
            return addTimeTaken(item);
        });
    };
    var start = $e2b66f14e43f32d1$var$getCurrentTime();
    return fn().then(onPromiseDone);
}
$e2b66f14e43f32d1$exports.promiseWithTimer = $e2b66f14e43f32d1$var$promiseWithTimer;
var $e2b66f14e43f32d1$var$getCurrentTime = function() {
    if (performance && performance.now) return performance.now();
    return new Date().getTime();
};



var $jgDTn = parcelRequire("jgDTn");
$4540b3d5b86097c4$exports.defaultTimeout = 5000;
var $4540b3d5b86097c4$var$delayUidGenerate = 1e3;
var $4540b3d5b86097c4$var$nonProdMaxTimeout = 30000;
var $4540b3d5b86097c4$var$prodMaxTimeout = 10000;
var $4540b3d5b86097c4$var$minTimeout = 2000;
var $4540b3d5b86097c4$var$XID = function() {
    function XID(env, timeout) {
        if (env === void 0) env = $jgDTn.Environment.LOCAL;
        if (timeout === void 0) timeout = $4540b3d5b86097c4$exports.defaultTimeout;
        this.storageEnabled = true;
        this.timeoutUid = {
            type: $jgDTn.XIDItemType.UID,
            state: $jgDTn.XIDState.TIMEOUT
        };
        if (!env) throw new Error("Missing env configuration");
        this.env = env;
        var maxTimeout = this.env === $jgDTn.Environment.PROD ? $4540b3d5b86097c4$var$prodMaxTimeout : $4540b3d5b86097c4$var$nonProdMaxTimeout;
        if (timeout >= $4540b3d5b86097c4$var$minTimeout && timeout <= maxTimeout) this.timeout = timeout;
        else {
            if (this.env !== $jgDTn.Environment.PROD) console.log("timeout configuration must be in the range of [" + $4540b3d5b86097c4$var$minTimeout + ", " + maxTimeout + "] seconds");
            this.timeout = $4540b3d5b86097c4$exports.defaultTimeout;
        }
    }
    XID.prototype.getTimeoutPromise = function(timeoutXid) {
        var _this = this;
        return new $4540b3d5b86097c4$var$promise_polyfill_1.default(function(resolve) {
            setTimeout(function() {
                resolve([
                    timeoutXid
                ]);
            }, (_this.timeout - $4540b3d5b86097c4$var$delayUidGenerate) / 2);
        });
    };
    XID.prototype.getXcPromiseAndSave = function() {
        var _this = this;
        return new $4540b3d5b86097c4$var$promise_polyfill_1.default(function(resolve) {
            _this.getXc().then(function(xc) {
                if (_this.storageEnabled) $683892aaaddafe34$exports.Storage.saveXid([
                    xc
                ]);
                resolve([
                    xc
                ]);
            });
        });
    };
    XID.prototype.getUidPromiseAndSave = function() {
        var _this = this;
        return new $4540b3d5b86097c4$var$promise_polyfill_1.default(function(resolve) {
            var handleUid = function() {
                var cachedUids = [];
                if (_this.storageEnabled) cachedUids = $683892aaaddafe34$exports.Storage.getUids();
                var uids = $d54c6cf9c1d36f4b$exports.UIDGenerator.getValue(cachedUids);
                if (_this.storageEnabled) {
                    $683892aaaddafe34$exports.Storage.saveUids(uids);
                    $683892aaaddafe34$exports.Storage.saveXid(uids);
                }
                resolve(uids);
            };
            var requestIdleCallback = window.requestIdleCallback;
            requestIdleCallback ? requestIdleCallback(handleUid) : setTimeout(handleUid, $4540b3d5b86097c4$var$delayUidGenerate);
        });
    };
    XID.prototype.getXidPromiseInXcUidOnly = function() {
        var _this = this;
        return this.getXcPromiseAndSave().then(function(xc) {
            if (xc && xc.length > 0 && xc[0].createdAt && xc[0].value) return xc;
            else return _this.getTimeoutPromise(_this.timeoutUid), _this.getUidPromiseAndSave().then(function(uid) {
                return $9z2vN.__spreadArrays(uid, xc);
            });
        });
    };
    XID.prototype.getXidCallbackForPromise = function(mode, storageEnabled) {
        if (mode === void 0) mode = $jgDTn.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        var transformedXids;
        var transform = function(xids) {
            if (transformedXids) return transformedXids;
            transformedXids = xids.map(function(xid) {
                if (xid.state === $jgDTn.XIDState.NEW || xid.state === $jgDTn.XIDState.CHANGED) return {
                    state: $jgDTn.XIDState.EXISTING,
                    type: xid.type,
                    createdAt: xid.createdAt,
                    value: xid.value
                };
                return xid;
            });
            return xids;
        };
        return this.getXidPromise(mode, storageEnabled).then(function(xid) {
            return function() {
                return transform(xid);
            };
        });
    };
    XID.prototype.getXidPromise = function(mode, storageEnabled) {
        var _this = this;
        if (mode === void 0) mode = $jgDTn.XIDGenerateMode.CACHE_XC_UID;
        if (storageEnabled === void 0) storageEnabled = true;
        this.storageEnabled = storageEnabled;
        var cachedXidValue = mode === $jgDTn.XIDGenerateMode.CACHE_ONLY || mode === $jgDTn.XIDGenerateMode.CACHE_XC_UID ? $683892aaaddafe34$exports.Storage.getCachedXID() : [];
        switch(mode){
            case $jgDTn.XIDGenerateMode.XC_ONLY:
                return $e2b66f14e43f32d1$exports.promiseWithTimer(function() {
                    return _this.getXcPromiseAndSave();
                });
            case $jgDTn.XIDGenerateMode.UID_ONLY:
                return $e2b66f14e43f32d1$exports.promiseWithTimer(function() {
                    return $4540b3d5b86097c4$var$promise_polyfill_1.default.race([
                        _this.getTimeoutPromise(_this.timeoutUid),
                        _this.getUidPromiseAndSave()
                    ]);
                });
            case $jgDTn.XIDGenerateMode.XC_UID:
                return $e2b66f14e43f32d1$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
            case $jgDTn.XIDGenerateMode.CACHE_ONLY:
                return $4540b3d5b86097c4$var$promise_polyfill_1.default.resolve(cachedXidValue);
            case $jgDTn.XIDGenerateMode.CACHE_XC_UID:
            default:
                return cachedXidValue.length > 0 ? $4540b3d5b86097c4$var$promise_polyfill_1.default.resolve(cachedXidValue) : $e2b66f14e43f32d1$exports.promiseWithTimer(function() {
                    return _this.getXidPromiseInXcUidOnly();
                });
        }
    };
    XID.prototype.getXc = function() {
        return $d468c5f17f4149f2$exports.XCGenerator.getValue(this.env, (this.timeout - $4540b3d5b86097c4$var$delayUidGenerate) / 2, this.storageEnabled);
    };
    XID.prototype.getUidDetails = function() {
        return $d54c6cf9c1d36f4b$exports.UIDGenerator.getDetails();
    };
    return XID;
}();
$4540b3d5b86097c4$exports.XID = $4540b3d5b86097c4$var$XID;


$ca1a71da0caf16e6$exports.XID = $4540b3d5b86097c4$exports.XID;


function $eb3ffeef278fd432$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $eb3ffeef278fd432$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $eb3ffeef278fd432$export$2e2bcd8739ae039(o);
}



function $60d553f649f6b275$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $eb3ffeef278fd432$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $eb3ffeef278fd432$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $080258f34bb03128$export$2e2bcd8739ae039(t) {
    var i = (0, $60d553f649f6b275$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $eb3ffeef278fd432$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $26075062244a15ae$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $080258f34bb03128$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $7e528f8fe8926776$exports = {};
var $457d413d4459106a$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $457d413d4459106a$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($457d413d4459106a$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $457d413d4459106a$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $457d413d4459106a$exports = function whatwgRNG() {
        $457d413d4459106a$var$getRandomValues($457d413d4459106a$var$rnds8);
        return $457d413d4459106a$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $457d413d4459106a$var$rnds = new Array(16);
    $457d413d4459106a$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $457d413d4459106a$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $457d413d4459106a$var$rnds;
    };
}


var $2e37d042e5bd57d1$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $2e37d042e5bd57d1$var$byteToHex = [];
for(var $2e37d042e5bd57d1$var$i = 0; $2e37d042e5bd57d1$var$i < 256; ++$2e37d042e5bd57d1$var$i)$2e37d042e5bd57d1$var$byteToHex[$2e37d042e5bd57d1$var$i] = ($2e37d042e5bd57d1$var$i + 0x100).toString(16).substr(1);
function $2e37d042e5bd57d1$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $2e37d042e5bd57d1$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$2e37d042e5bd57d1$exports = $2e37d042e5bd57d1$var$bytesToUuid;


function $7e528f8fe8926776$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $457d413d4459106a$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $2e37d042e5bd57d1$exports(rnds);
}
$7e528f8fe8926776$exports = $7e528f8fe8926776$var$v4;


// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $b44600d71695f28f$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $b44600d71695f28f$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $b44600d71695f28f$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $b44600d71695f28f$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $b44600d71695f28f$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["JA_WORKSPACE_ID"] = "jiraAlignWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $b44600d71695f28f$export$f49776dca27a2e7c = /*#__PURE__*/ function(productEmbedType) {
    productEmbedType["FIRST_PARTY"] = "FIRST_PARTY";
    productEmbedType["THIRD_PARTY"] = "THIRD_PARTY";
    return productEmbedType;
}({});
let $b44600d71695f28f$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["JA_USER_ID"] = "jiraAlign";
    userType["HALP"] = "halp";
    return userType;
}({});
let $b44600d71695f28f$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $b44600d71695f28f$export$809831be6c4c6227 = Object.freeze([
    $b44600d71695f28f$export$6b4f396210e539f3.DESKTOP,
    $b44600d71695f28f$export$6b4f396210e539f3.MAC,
    $b44600d71695f28f$export$6b4f396210e539f3.LINUX,
    $b44600d71695f28f$export$6b4f396210e539f3.WINDOWS
]);
const $b44600d71695f28f$export$19c579398ad213e7 = Object.freeze([
    $b44600d71695f28f$export$6b4f396210e539f3.WEB,
    $b44600d71695f28f$export$6b4f396210e539f3.MOBILE_WEB
]);
let $b44600d71695f28f$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $b44600d71695f28f$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $b44600d71695f28f$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $b44600d71695f28f$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $b44600d71695f28f$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $b44600d71695f28f$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $b44600d71695f28f$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});





class $a431c200e910cd58$export$2e2bcd8739ae039 {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
}


class $a0b449ccfcd0b084$export$2e2bcd8739ae039 {
    constructor(){
        this._performance = window.performance;
    }
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
}


function $2abf3fdb25b5bcce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2abf3fdb25b5bcce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2abf3fdb25b5bcce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2abf3fdb25b5bcce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $2abf3fdb25b5bcce$export$2e2bcd8739ae039 {
    constructor(onEvent, pageVisibility){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $2abf3fdb25b5bcce$var$_objectSpread($2abf3fdb25b5bcce$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $b44600d71695f28f$export$99b37380a464d794).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $b44600d71695f28f$export$99b37380a464d794).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $b44600d71695f28f$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$99b37380a464d794), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $b44600d71695f28f$export$99b37380a464d794).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $2abf3fdb25b5bcce$var$_objectSpread($2abf3fdb25b5bcce$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $a431c200e910cd58$export$2e2bcd8739ae039))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $a0b449ccfcd0b084$export$2e2bcd8739ae039)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($2abf3fdb25b5bcce$var$_objectSpread($2abf3fdb25b5bcce$var$_objectSpread($2abf3fdb25b5bcce$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
}


/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $fd3a934d161b401e$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $fd3a934d161b401e$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($fd3a934d161b401e$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};



const $815e0d72e56c9b1a$export$f56713ced121eb91 = (input)=>{
    return input.embeddedType === (0, $b44600d71695f28f$export$f49776dca27a2e7c).FIRST_PARTY && input.embeddedFromProduct !== undefined;
};
const $815e0d72e56c9b1a$export$ab34f90cc32c8960 = (input)=>{
    return input.embeddedType === (0, $b44600d71695f28f$export$f49776dca27a2e7c).THIRD_PARTY && input.embeddedFromTopLevelDomain !== undefined;
};




// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $40b8a0523e884625$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $40b8a0523e884625$var$isObjectObject(o) {
    return $40b8a0523e884625$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $40b8a0523e884625$export$53b83ca8eaab0383(o) {
    if ($40b8a0523e884625$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($40b8a0523e884625$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}


function $a96b95b16d5d0eae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a96b95b16d5d0eae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a96b95b16d5d0eae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a96b95b16d5d0eae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a96b95b16d5d0eae$var$libraryVersion = "5.1.0";
function $a96b95b16d5d0eae$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $a96b95b16d5d0eae$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $a96b95b16d5d0eae$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $a96b95b16d5d0eae$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $a96b95b16d5d0eae$var$buildAliases(aliases) {
    if ($a96b95b16d5d0eae$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $a96b95b16d5d0eae$var$buildGroups(groups) {
    if ($a96b95b16d5d0eae$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $a96b95b16d5d0eae$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $a96b95b16d5d0eae$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $a96b95b16d5d0eae$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $a96b95b16d5d0eae$var$getProductField(productInfo.env, overrides.env);
    const product = $a96b95b16d5d0eae$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $a96b95b16d5d0eae$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $a96b95b16d5d0eae$var$getProductField(productInfo.version, overrides.version);
    const origin = $a96b95b16d5d0eae$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $a96b95b16d5d0eae$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a96b95b16d5d0eae$var$isNotEmptyObject(obj) {
    return (0, $40b8a0523e884625$export$53b83ca8eaab0383)(obj) && Object.keys(obj).length > 0;
}
function $a96b95b16d5d0eae$var$buildAttributesWithName(name, attrObject) {
    return $a96b95b16d5d0eae$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $a96b95b16d5d0eae$var$buildAttributes(attributes) {
    return $a96b95b16d5d0eae$var$buildAttributesWithName("attributes", attributes);
}
function $a96b95b16d5d0eae$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $a96b95b16d5d0eae$export$f045f238d77c002a(containers) {
    if ($a96b95b16d5d0eae$var$isNotEmptyObject(containers)) {
        const validContainers = $a96b95b16d5d0eae$export$3f5115a568819c1a(containers);
        return $a96b95b16d5d0eae$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $a96b95b16d5d0eae$export$655ecf7241feac42(event, actionEventType) {
    return $a96b95b16d5d0eae$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $a96b95b16d5d0eae$export$f045f238d77c002a(event.containers));
}
function $a96b95b16d5d0eae$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $a96b95b16d5d0eae$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $a96b95b16d5d0eae$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $a96b95b16d5d0eae$var$buildProductFields(productInfo);
    const tenantFields = $a96b95b16d5d0eae$var$buildTenantFields(tenantInfo);
    const userFields = $a96b95b16d5d0eae$var$buildUserFields(userInfo);
    const orgFields = $a96b95b16d5d0eae$var$buildOrgFields(orgInfo);
    const workspaceFields = $a96b95b16d5d0eae$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $b44600d71695f28f$export$4c045e605d532c98).SCREEN
    };
    return $a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $a96b95b16d5d0eae$var$buildAttributes(attributes)), $a96b95b16d5d0eae$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $a96b95b16d5d0eae$export$f045f238d77c002a(containers)), $a96b95b16d5d0eae$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a96b95b16d5d0eae$var$buildAliases(aliases)), $a96b95b16d5d0eae$var$buildGroups(groups));
}
function $a96b95b16d5d0eae$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
let $a96b95b16d5d0eae$export$fbd92247fb4d6159 = /*#__PURE__*/ function(validationMode) {
    validationMode["QUIET"] = "quiet";
    validationMode["STANDARD"] = "standard";
    validationMode["COMPLETE"] = "complete";
    return validationMode;
}({});
function $a96b95b16d5d0eae$var$getDefaultValidationMode(productInfo) {
    const environment = productInfo.env;
    if (environment === undefined) return $a96b95b16d5d0eae$export$fbd92247fb4d6159.QUIET;
    if (environment.includes("prod")) return $a96b95b16d5d0eae$export$fbd92247fb4d6159.QUIET;
    return $a96b95b16d5d0eae$export$fbd92247fb4d6159.COMPLETE;
}
function $a96b95b16d5d0eae$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $a96b95b16d5d0eae$var$libraryVersion
            },
            validationMode: $a96b95b16d5d0eae$var$getDefaultValidationMode(productInfo)
        }
    };
}
function $a96b95b16d5d0eae$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a96b95b16d5d0eae$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $a96b95b16d5d0eae$var$buildProductFields(productInfo, $a96b95b16d5d0eae$export$e3d99b4bfec06f6e(event));
    const tenantFields = $a96b95b16d5d0eae$var$buildTenantFields(tenantInfo);
    const orgFields = $a96b95b16d5d0eae$var$buildOrgFields(orgInfo);
    const workspaceFields = $a96b95b16d5d0eae$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $a96b95b16d5d0eae$var$buildUserFields(userInfo);
    const actionFields = $a96b95b16d5d0eae$export$655ecf7241feac42(event, actionEventType);
    return $a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread($a96b95b16d5d0eae$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $a96b95b16d5d0eae$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a96b95b16d5d0eae$var$buildAliases(aliases)), $a96b95b16d5d0eae$var$buildGroups(groups));
}



const $ce266d798ae14304$export$cf090d5281b5ae06 = 10000;
const $ce266d798ae14304$export$8575e30be0feb909 = 30000;




/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $cfe4018516172a9d$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $cfe4018516172a9d$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $cfe4018516172a9d$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $cfe4018516172a9d$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $cfe4018516172a9d$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $cfe4018516172a9d$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$cfe4018516172a9d$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $cfe4018516172a9d$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);








const $729129a3d9b7a446$var$actionEventTypes = Object.freeze([
    (0, $b44600d71695f28f$export$4c045e605d532c98).OPERATIONAL,
    (0, $b44600d71695f28f$export$4c045e605d532c98).TRACK,
    (0, $b44600d71695f28f$export$4c045e605d532c98).UI
]);
function $729129a3d9b7a446$export$df8ff30e3c960006(container) {
    if (!(0, $40b8a0523e884625$export$53b83ca8eaab0383)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $729129a3d9b7a446$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$729129a3d9b7a446$export$df8ff30e3c960006(container));
}
function $729129a3d9b7a446$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $b44600d71695f28f$export$4c045e605d532c98).OPERATIONAL:
        case (0, $b44600d71695f28f$export$4c045e605d532c98).TRACK:
        case (0, $b44600d71695f28f$export$4c045e605d532c98).UI:
            return true;
        default:
            return false;
    }
}
function $729129a3d9b7a446$export$4a8d7476662aebcc(type) {
    if (!$729129a3d9b7a446$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$729129a3d9b7a446$var$actionEventTypes}]`);
    return true;
}
function $729129a3d9b7a446$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $729129a3d9b7a446$export$e63ea5d8477971d3(event.containers);
}
function $729129a3d9b7a446$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $729129a3d9b7a446$export$8c014fd74b0c8b99(event) {
    $729129a3d9b7a446$export$e0c121325c66ed4c(event);
}
function $729129a3d9b7a446$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $729129a3d9b7a446$export$e5bac0930c812e90(event) {
    $729129a3d9b7a446$export$e0c121325c66ed4c(event);
}
function $729129a3d9b7a446$export$1e561554275607ef(event) {
    $729129a3d9b7a446$export$e0c121325c66ed4c(event);
}
function $729129a3d9b7a446$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$1827adfd178b4870), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$1827adfd178b4870))}]`);
}
function $729129a3d9b7a446$export$801b46c35394d316(productInfo) {
    if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$6b4f396210e539f3), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$6b4f396210e539f3))}]`);
    if (productInfo.origin === (0, $b44600d71695f28f$export$f73e9fcd368bb695).DESKTOP && !(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$809831be6c4c6227), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $b44600d71695f28f$export$f73e9fcd368bb695).WEB && !(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$19c579398ad213e7), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}



class $3f993b49d8bc5a3c$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "canCompress", (event)=>{
            try {
                return event && (0, $729129a3d9b7a446$export$d19cebda16f7579a)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $cfe4018516172a9d$export$b29f828819edca8d)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $729129a3d9b7a446$export$4a8d7476662aebcc)(event.eventType);
                (0, $729129a3d9b7a446$export$e0c121325c66ed4c)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}


function $ec5703a793f2217f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec5703a793f2217f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec5703a793f2217f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec5703a793f2217f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $ec5703a793f2217f$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $a96b95b16d5d0eae$export$655ecf7241feac42)(event, event.eventType);
                    contextFields = (0, $cfe4018516172a9d$export$30a06c8d3562193f)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $cfe4018516172a9d$export$e9bab7fafb253603)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$ec5703a793f2217f$var$_objectSpread($ec5703a793f2217f$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $3f993b49d8bc5a3c$export$89b3253ddfd2e6e8))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}


// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $10f6243ae219ac21$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $10f6243ae219ac21$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $10f6243ae219ac21$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "size", ()=>this.eventArgs.length);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $10f6243ae219ac21$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $10f6243ae219ac21$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $cfe4018516172a9d$export$b29f828819edca8d)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $cfe4018516172a9d$export$e9bab7fafb253603)(group.userInfo, args.userInfo) && (0, $cfe4018516172a9d$export$e9bab7fafb253603)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $a96b95b16d5d0eae$export$9c5623a792efc9b0)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $ec5703a793f2217f$export$2e2bcd8739ae039)(compressionRules);
    }
}


let $961eff8954113231$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});


class $fee093b4521f35ad$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startLowPriorityEventDelay", (timeout = (0, $ce266d798ae14304$export$cf090d5281b5ae06), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $ce266d798ae14304$export$8575e30be0feb909)) : (0, $ce266d798ae14304$export$8575e30be0feb909);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $961eff8954113231$export$fa6e3729c21cb8f).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stopLowPriorityEventDelay", (reason = (0, $961eff8954113231$export$fa6e3729c21cb8f).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $10f6243ae219ac21$export$2e2bcd8739ae039)(fireDelayedEvent, compressors);
    }
}






let $036f5624e78da12a$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $036f5624e78da12a$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});



const $1ce98c00fb48a3c7$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $036f5624e78da12a$export$ecfa71cbc9b28241).ACK]: `${queuePrefix}.${queueId}.${(0, $036f5624e78da12a$export$ecfa71cbc9b28241).ACK}`,
        [(0, $036f5624e78da12a$export$ecfa71cbc9b28241).QUEUE]: `${queuePrefix}.${queueId}.${(0, $036f5624e78da12a$export$ecfa71cbc9b28241).QUEUE}`,
        [(0, $036f5624e78da12a$export$ecfa71cbc9b28241).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $036f5624e78da12a$export$ecfa71cbc9b28241).IN_PROGRESS}`,
        [(0, $036f5624e78da12a$export$ecfa71cbc9b28241).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $036f5624e78da12a$export$ecfa71cbc9b28241).RECLAIM_START}`,
        [(0, $036f5624e78da12a$export$ecfa71cbc9b28241).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $036f5624e78da12a$export$ecfa71cbc9b28241).RECLAIM_END}`
    });


// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $b2a946002b627198$var$validSuffixs = Object.values((0, $036f5624e78da12a$export$ecfa71cbc9b28241));
var $b2a946002b627198$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $b2a946002b627198$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $036f5624e78da12a$export$ecfa71cbc9b28241).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $1ce98c00fb48a3c7$export$8433d54f767cbec5)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};





function $8da58df0d8114687$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8da58df0d8114687$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8da58df0d8114687$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8da58df0d8114687$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $8da58df0d8114687$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $8da58df0d8114687$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $036f5624e78da12a$export$ecfa71cbc9b28241).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $036f5624e78da12a$export$8bb2c1fb2b1765a9).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $8da58df0d8114687$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $8da58df0d8114687$var$promisedSetTimeout((0, $036f5624e78da12a$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $036f5624e78da12a$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $8da58df0d8114687$var$promisedSetTimeout((0, $036f5624e78da12a$export$8bb2c1fb2b1765a9).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $036f5624e78da12a$export$8bb2c1fb2b1765a9).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $8da58df0d8114687$var$reclaim(options, callback);
};
const $8da58df0d8114687$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $8da58df0d8114687$var$_objectSpread($8da58df0d8114687$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $8da58df0d8114687$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $8da58df0d8114687$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $8da58df0d8114687$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $8da58df0d8114687$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))();
    const queuesToReclaim = $8da58df0d8114687$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$8da58df0d8114687$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $1ce98c00fb48a3c7$export$8433d54f767cbec5)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};


const $c9ed010eebcf1bb1$export$a409c8de90e11e14 = "CallbackProcessingError";
class $c9ed010eebcf1bb1$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $c9ed010eebcf1bb1$export$2e2bcd8739ae039.prototype);
        this.name = $c9ed010eebcf1bb1$export$a409c8de90e11e14;
    }
}

const $9eff708e18431e5b$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $9eff708e18431e5b$export$8cad224051643259 = "analytics-web-client";
const $9eff708e18431e5b$export$3d8420be07b276ab = "analytics-resilience";
const $9eff708e18431e5b$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $9eff708e18431e5b$export$89d9c1ff8ac91862 = "timeAdded";
const $9eff708e18431e5b$export$a37d385bcd713809 = "retryAttempts";
const $9eff708e18431e5b$export$6d8635fed0e4b14d = 15000;
let $9eff708e18431e5b$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $9eff708e18431e5b$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});


const $9d4a71b182013ef8$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $9d4a71b182013ef8$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $9d4a71b182013ef8$export$2e2bcd8739ae039.prototype);
        this.name = $9d4a71b182013ef8$export$fc14cf6dcea0f8ed;
    }
}

const $efeb69b72e967fd7$export$ba95206613c96b28 = "AbandonWriteError";
class $efeb69b72e967fd7$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $efeb69b72e967fd7$export$2e2bcd8739ae039.prototype);
        this.name = $efeb69b72e967fd7$export$ba95206613c96b28;
    }
}



const $2b408c8bd68b48f7$export$7e7aee9a953465ec = "InvalidPolicyError";
class $2b408c8bd68b48f7$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $2b408c8bd68b48f7$export$7e7aee9a953465ec;
    }
}


const $a597e862b6f0d6b0$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $efeb69b72e967fd7$export$ba95206613c96b28) || errorWithName.name === (0, $c9ed010eebcf1bb1$export$a409c8de90e11e14) || errorWithName.name === (0, $2b408c8bd68b48f7$export$7e7aee9a953465ec));
    }
    return false;
};


function $fd2c7c88defa205f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $4524e3c20906fc7e$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $fd2c7c88defa205f$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




const $02bb6a7633b9d32c$export$b6df3d334cec060f = 7;
const $02bb6a7633b9d32c$export$14ef152a03a4b6ee = 60000;
const $02bb6a7633b9d32c$export$da9ab7b2fd5998e8 = 10;
const $02bb6a7633b9d32c$export$1188664dfff364c8 = 5000;








const $19640e50bb3a392f$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $19640e50bb3a392f$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $02bb6a7633b9d32c$export$da9ab7b2fd5998e8),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $02bb6a7633b9d32c$export$1188664dfff364c8)
    });
const $19640e50bb3a392f$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $19640e50bb3a392f$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $19640e50bb3a392f$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $19640e50bb3a392f$export$2a5213bce1720b42(transaction);
};
const $19640e50bb3a392f$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};


class $788abbf1f368c127$export$2e2bcd8739ae039 {
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $9eff708e18431e5b$export$d21fbb25eb37b5bf));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $19640e50bb3a392f$export$85ceed0783e42041)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $9eff708e18431e5b$export$7710d69e6f450f20).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $19640e50bb3a392f$export$85ceed0783e42041)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $19640e50bb3a392f$export$feab8418f018df89)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $efeb69b72e967fd7$export$2e2bcd8739ae039)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $9eff708e18431e5b$export$d21fbb25eb37b5bf));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $19640e50bb3a392f$export$85ceed0783e42041)(request);
        return event.target.result;
    }
}



const $44788c8857ceb588$var$_excluded = [
    "item"
], $44788c8857ceb588$var$_excluded2 = [
    "items"
];
function $44788c8857ceb588$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44788c8857ceb588$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44788c8857ceb588$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44788c8857ceb588$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $44788c8857ceb588$export$2e2bcd8739ae039 {
    constructor(_namespace, _options = {}){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $9d4a71b182013ef8$export$2e2bcd8739ae039)());
                    }, (0, $9eff708e18431e5b$export$6d8635fed0e4b14d));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $9eff708e18431e5b$export$8cad224051643259), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $9eff708e18431e5b$export$3d8420be07b276ab), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $9eff708e18431e5b$export$a512a65455fce2a6), (0, $9eff708e18431e5b$export$a512a65455fce2a6), {
                            unique: false
                        });
                        store.createIndex((0, $9eff708e18431e5b$export$a37d385bcd713809), (0, $9eff708e18431e5b$export$a37d385bcd713809), {
                            unique: false
                        });
                        store.createIndex((0, $9eff708e18431e5b$export$89d9c1ff8ac91862), (0, $9eff708e18431e5b$export$89d9c1ff8ac91862), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $9eff708e18431e5b$export$d21fbb25eb37b5bf), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    request.onerror = function() {
                        reject(new (0, $9d4a71b182013ef8$export$2e2bcd8739ae039)());
                    };
                    try {
                        await (0, $19640e50bb3a392f$export$85ceed0783e42041)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $9d4a71b182013ef8$export$2e2bcd8739ae039)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $9d4a71b182013ef8$export$2e2bcd8739ae039)());
                }
            });
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "addItem", async (item, options = {}, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $19640e50bb3a392f$export$aec476f33d77be11)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE) throw new (0, $2b408c8bd68b48f7$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $a597e862b6f0d6b0$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "bulkAddItem", async (itemOptions, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, $4524e3c20906fc7e$export$2e2bcd8739ae039)(_ref, $44788c8857ceb588$var$_excluded);
                return (0, $19640e50bb3a392f$export$aec476f33d77be11)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $a597e862b6f0d6b0$export$74101021e0969375)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getItems", async (count = (0, $02bb6a7633b9d32c$export$b6df3d334cec060f))=>{
            const fixedCount = count > 0 ? count : (0, $02bb6a7633b9d32c$export$b6df3d334cec060f);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $9eff708e18431e5b$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $44788c8857ceb588$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $02bb6a7633b9d32c$export$14ef152a03a4b6ee);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $19640e50bb3a392f$export$342d941b6f724995)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $19640e50bb3a392f$export$342d941b6f724995)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $19640e50bb3a392f$export$feab8418f018df89)(transaction, this.logger);
            return getResult;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $19640e50bb3a392f$export$feab8418f018df89)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $9eff708e18431e5b$export$a512a65455fce2a6));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $19640e50bb3a392f$export$85ceed0783e42041)(request);
            await (0, $19640e50bb3a392f$export$feab8418f018df89)(transaction, this.logger);
            return event.target.result;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "processItems", async (processFn, count = (0, $02bb6a7633b9d32c$export$b6df3d334cec060f))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, $4524e3c20906fc7e$export$2e2bcd8739ae039)(_await$this$getItems, $44788c8857ceb588$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $c9ed010eebcf1bb1$export$2e2bcd8739ae039)(error);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $19640e50bb3a392f$export$85ceed0783e42041)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $9eff708e18431e5b$export$3d8420be07b276ab), mode);
            const objectStore = transaction.objectStore((0, $9eff708e18431e5b$export$3d8420be07b276ab));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $19640e50bb3a392f$export$ddc6718318090f71)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $9d4a71b182013ef8$export$2e2bcd8739ae039)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $788abbf1f368c127$export$2e2bcd8739ae039)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
    storeType() {
        return (0, $9eff708e18431e5b$export$39337ab5872e9457).INDEXEDDB;
    }
}










class $c36795878de22b44$export$2e2bcd8739ae039 {
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $9eff708e18431e5b$export$7710d69e6f450f20).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $efeb69b72e967fd7$export$2e2bcd8739ae039)((0, $9eff708e18431e5b$export$39337ab5872e9457).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
}



const $bc7097e18be21802$var$_excluded = [
    "item"
], $bc7097e18be21802$var$_excluded2 = [
    "items"
];
function $bc7097e18be21802$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bc7097e18be21802$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bc7097e18be21802$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bc7097e18be21802$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $bc7097e18be21802$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $19640e50bb3a392f$export$ddc6718318090f71)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $c36795878de22b44$export$2e2bcd8739ae039)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        if (policy === (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE) throw new (0, $2b408c8bd68b48f7$export$2e2bcd8739ae039)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $19640e50bb3a392f$export$aec476f33d77be11)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, $4524e3c20906fc7e$export$2e2bcd8739ae039)(_ref, $bc7097e18be21802$var$_excluded);
            return (0, $19640e50bb3a392f$export$aec476f33d77be11)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $02bb6a7633b9d32c$export$b6df3d334cec060f)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $02bb6a7633b9d32c$export$b6df3d334cec060f)) {
        const fixedCount = count > 0 ? count : (0, $02bb6a7633b9d32c$export$b6df3d334cec060f);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($bc7097e18be21802$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $02bb6a7633b9d32c$export$14ef152a03a4b6ee);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, $4524e3c20906fc7e$export$2e2bcd8739ae039)(_this$synchronousGetI, $bc7097e18be21802$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $c9ed010eebcf1bb1$export$2e2bcd8739ae039)(error);
        }
    }
    storeType() {
        return (0, $9eff708e18431e5b$export$39337ab5872e9457).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
}



class $20d057de5e0f45c7$export$2e2bcd8739ae039 {
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $19640e50bb3a392f$export$ddc6718318090f71)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $44788c8857ceb588$export$2e2bcd8739ae039)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $9d4a71b182013ef8$export$2e2bcd8739ae039))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $bc7097e18be21802$export$2e2bcd8739ae039)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $9eff708e18431e5b$export$7710d69e6f450f20).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $a597e862b6f0d6b0$export$74101021e0969375)(error)) throw error;
            else if (this.resilience.storeType() === (0, $9eff708e18431e5b$export$39337ab5872e9457).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $bc7097e18be21802$export$2e2bcd8739ae039)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
}




var $30ffffbcfb2dcc29$export$2e2bcd8739ae039 = (0, $20d057de5e0f45c7$export$2e2bcd8739ae039);



let $ec245e394da5ba09$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $ec245e394da5ba09$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});


class $9d576057019c0ac0$export$4b62ee5120ab50a8 {
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "resilienceMechanism", (0, $ec245e394da5ba09$export$c75161629e3ec34e).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "localstorageNumberOfFailedReclaims", 0);
    }
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
}
let $9d576057019c0ac0$var$cachedMetricsClient = null;
var $9d576057019c0ac0$export$2e2bcd8739ae039 = ()=>{
    if (!$9d576057019c0ac0$var$cachedMetricsClient) $9d576057019c0ac0$var$cachedMetricsClient = new $9d576057019c0ac0$export$4b62ee5120ab50a8();
    return $9d576057019c0ac0$var$cachedMetricsClient;
};



class $2131033b8781c22c$export$2e2bcd8739ae039 {
    constructor(networkChangeCallback){
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>networkChangeCallback((0, $ec245e394da5ba09$export$ee138fa712d11b84).OFFLINE));
            window.addEventListener("online", ()=>networkChangeCallback((0, $ec245e394da5ba09$export$ee138fa712d11b84).ONLINE));
        }
    }
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $ec245e394da5ba09$export$ee138fa712d11b84).ONLINE;
        return (0, $ec245e394da5ba09$export$ee138fa712d11b84).OFFLINE;
    }
}




let $7c2d941106e9eed3$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $7c2d941106e9eed3$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $7c2d941106e9eed3$export$590a718599f8f8b3 {
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "timeoutHandle", undefined);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "callbackStatus", $7c2d941106e9eed3$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $7c2d941106e9eed3$export$ef3353088fca369c.IDLE:
            case $7c2d941106e9eed3$export$ef3353088fca369c.TIMED_OUT:
            case $7c2d941106e9eed3$export$ef3353088fca369c.COMPLETED:
                if (event === $7c2d941106e9eed3$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $7c2d941106e9eed3$export$ef3353088fca369c.RUNNING;
                break;
            case $7c2d941106e9eed3$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $7c2d941106e9eed3$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $7c2d941106e9eed3$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $7c2d941106e9eed3$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $7c2d941106e9eed3$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $7c2d941106e9eed3$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $7c2d941106e9eed3$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $7c2d941106e9eed3$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $7c2d941106e9eed3$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
}


// Clients can optionally provide the callbackTimeoutPeriod parameter
let $f7c3828a322cf161$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});


const $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $463a79a535670664$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $463a79a535670664$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $463a79a535670664$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $463a79a535670664$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $463a79a535670664$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $463a79a535670664$export$8bb92baee001fc60.NONE;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getFailureCount", ()=>this.failureCount);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $f7c3828a322cf161$export$f93c40fda808dd0c).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $f7c3828a322cf161$export$f93c40fda808dd0c).ERROR || this.callbackTimer.getCallbackStatus() === (0, $7c2d941106e9eed3$export$ef3353088fca369c).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $f7c3828a322cf161$export$f93c40fda808dd0c).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $463a79a535670664$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $463a79a535670664$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $463a79a535670664$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $463a79a535670664$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $463a79a535670664$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $7c2d941106e9eed3$export$590a718599f8f8b3)(this.options.callbackTimeoutPeriod);
    }
}



function $a5c9670a5f02199f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5c9670a5f02199f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5c9670a5f02199f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5c9670a5f02199f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a5c9670a5f02199f$var$ONE_MINUTE = 60000;
const $a5c9670a5f02199f$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $a5c9670a5f02199f$var$ONE_MINUTE,
    minRetryDelay: $a5c9670a5f02199f$var$ONE_MINUTE,
    maxRetryDelay: $a5c9670a5f02199f$var$ONE_MINUTE
};
const $a5c9670a5f02199f$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $a5c9670a5f02199f$export$2e2bcd8739ae039 {
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $30ffffbcfb2dcc29$export$2e2bcd8739ae039)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $463a79a535670664$export$2e2bcd8739ae039)($a5c9670a5f02199f$var$_objectSpread($a5c9670a5f02199f$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $463a79a535670664$export$2e2bcd8739ae039)($a5c9670a5f02199f$var$_objectSpread($a5c9670a5f02199f$var$_objectSpread({}, $a5c9670a5f02199f$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $a5c9670a5f02199f$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $9d576057019c0ac0$export$2e2bcd8739ae039)();
        this.networkStatus = new (0, $2131033b8781c22c$export$2e2bcd8739ae039)((status)=>{
            if (status === (0, $ec245e394da5ba09$export$ee138fa712d11b84).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $9eff708e18431e5b$export$7710d69e6f450f20).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $ec245e394da5ba09$export$ee138fa712d11b84).OFFLINE) {
            done((0, $f7c3828a322cf161$export$f93c40fda808dd0c).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $c9ed010eebcf1bb1$export$a409c8de90e11e14)) {
                done((0, $f7c3828a322cf161$export$f93c40fda808dd0c).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $b2a946002b627198$export$2e2bcd8739ae039)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $8da58df0d8114687$export$2e2bcd8739ae039)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $9eff708e18431e5b$export$7710d69e6f450f20).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $f7c3828a322cf161$export$f93c40fda808dd0c).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $f7c3828a322cf161$export$f93c40fda808dd0c).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $f7c3828a322cf161$export$f93c40fda808dd0c).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $a5c9670a5f02199f$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $a5c9670a5f02199f$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $a5c9670a5f02199f$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $a5c9670a5f02199f$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $a5c9670a5f02199f$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $a5c9670a5f02199f$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $a5c9670a5f02199f$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $a5c9670a5f02199f$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $a5c9670a5f02199f$export$d219df4fe04c04a7.minRetryDelay
        };
    }
}



var $da7766cab604e35c$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $a5c9670a5f02199f$export$2e2bcd8739ae039)(retryQueuePrefix, product, options || {}, logger);
};




// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $ed2f55049b0dbd43$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $ed2f55049b0dbd43$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $ed2f55049b0dbd43$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});


function $52a7be140c02c122$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $52a7be140c02c122$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $52a7be140c02c122$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $52a7be140c02c122$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $52a7be140c02c122$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).PAGE || item.msg.type === (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $52a7be140c02c122$var$_objectSpread($52a7be140c02c122$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $52a7be140c02c122$var$_objectSpread($52a7be140c02c122$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $52a7be140c02c122$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$52a7be140c02c122$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}


const $2dcdb849f4d078e7$export$9175ce0e1c95daf2 = 10000; // 10 seconds


const $f0471dbfef1fd0d3$export$ba118f9de1e5ac63 = new Map([
    [
        200,
        "OK"
    ],
    [
        400,
        "Bad Request"
    ],
    [
        401,
        "Unauthorized"
    ],
    [
        402,
        "Payment Required"
    ],
    [
        403,
        "Forbidden"
    ],
    [
        404,
        "Not Found"
    ],
    [
        405,
        "Method Not Allowed"
    ],
    [
        406,
        "Not Acceptable"
    ],
    [
        407,
        "Proxy Authentication Required"
    ],
    [
        408,
        "Request Timeout"
    ],
    [
        409,
        "Conflict"
    ],
    [
        410,
        "Gone"
    ],
    [
        411,
        "Length Required"
    ],
    [
        412,
        "Precondition Failed"
    ],
    [
        413,
        "Payload Too Large"
    ],
    [
        414,
        "URI Too Long"
    ],
    [
        415,
        "Unsupported Media Type"
    ],
    [
        416,
        "Requested range not satisfiable"
    ],
    [
        417,
        "Expectation Failed"
    ],
    [
        418,
        "I'm a teapot"
    ],
    [
        422,
        "Unprocessable Entity"
    ],
    [
        423,
        "Locked"
    ],
    [
        424,
        "Failed Dependency"
    ],
    [
        425,
        "Too Early"
    ],
    [
        426,
        "Upgrade Required"
    ],
    [
        428,
        "Precondition Required"
    ],
    [
        429,
        "Too Many Requests"
    ],
    [
        431,
        "Request Header Fields Too Large"
    ],
    [
        451,
        "Unavailable For Legal Reasons"
    ],
    [
        500,
        "Internal Server Error"
    ],
    [
        501,
        "Not Implemented"
    ],
    [
        502,
        "Bad Gateway"
    ],
    [
        503,
        "Service Unavailable"
    ],
    [
        504,
        "Gateway Timeout"
    ],
    [
        505,
        "HTTP Version not supported"
    ],
    [
        506,
        "Variant Also Negotiates"
    ],
    [
        507,
        "Insufficient Storage"
    ],
    [
        508,
        "Loop Detected"
    ],
    [
        509,
        "Bandwidth Limit Exceeded"
    ],
    [
        510,
        "Not Extended"
    ],
    [
        511,
        "Network Authentication Required"
    ],
    [
        -1,
        "Unknown Status"
    ]
]);



var $b96cdb796e568e05$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $b96cdb796e568e05$var$isEqual(first, second) {
    if (first === second) return true;
    if ($b96cdb796e568e05$var$safeIsNaN(first) && $b96cdb796e568e05$var$safeIsNaN(second)) return true;
    return false;
}
function $b96cdb796e568e05$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$b96cdb796e568e05$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $b96cdb796e568e05$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $b96cdb796e568e05$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}


function $dd4c8e887af3e8e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dd4c8e887af3e8e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dd4c8e887af3e8e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dd4c8e887af3e8e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dd4c8e887af3e8e8$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $dd4c8e887af3e8e8$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $dd4c8e887af3e8e8$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $dd4c8e887af3e8e8$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $dd4c8e887af3e8e8$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $dd4c8e887af3e8e8$var$getCorsForUrl = (0, $b96cdb796e568e05$export$2e2bcd8739ae039)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});




function $7dc4f4dae2a0578e$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $3165fdc73cd1f2e6$export$2e2bcd8739ae039(argument) {
    (0, $7dc4f4dae2a0578e$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $eb3ffeef278fd432$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $b00b734033d8de3b$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}




function $4091bcc9db1b2076$export$2e2bcd8739ae039(dirtyDate) {
    (0, $7dc4f4dae2a0578e$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $3165fdc73cd1f2e6$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $38cf30993f3362ec$var$MILLISECONDS_IN_DAY = 86400000;
function $38cf30993f3362ec$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7dc4f4dae2a0578e$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $4091bcc9db1b2076$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $4091bcc9db1b2076$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $b00b734033d8de3b$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $b00b734033d8de3b$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $38cf30993f3362ec$var$MILLISECONDS_IN_DAY);
}



// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $4a5f646730194dba$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $4a5f646730194dba$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $7dc4f4dae2a0578e$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $3165fdc73cd1f2e6$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $3165fdc73cd1f2e6$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $4a5f646730194dba$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $38cf30993f3362ec$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($4a5f646730194dba$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}



let $8ae807f5b94fa454$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $8ae807f5b94fa454$var$CookieSchema {
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
}
const $8ae807f5b94fa454$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === "https:";
    } catch (err) {
        return false;
    }
};
const $8ae807f5b94fa454$export$d4cb17942ea57c95 = {
    [$8ae807f5b94fa454$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $8ae807f5b94fa454$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: $8ae807f5b94fa454$var$isSecure(),
        path: "/"
    }),
    [$8ae807f5b94fa454$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $8ae807f5b94fa454$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: $8ae807f5b94fa454$var$isSecure(),
        path: "/"
    }),
    [$8ae807f5b94fa454$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $8ae807f5b94fa454$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: $8ae807f5b94fa454$var$isSecure(),
        path: "/"
    })
};


var $3b044cef7cf53e20$exports = {};
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    $3b044cef7cf53e20$exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});




class $d36baf8968a60502$export$90e3e001bcac59c7 {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_data", {});
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "length", 0);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$d36baf8968a60502$export$2e2bcd8739ae039 = new $d36baf8968a60502$export$90e3e001bcac59c7();





const $27fe5b475ade8c6f$export$41c06fdd37b7e9a5 = "awc";
const $27fe5b475ade8c6f$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $27fe5b475ade8c6f$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $27fe5b475ade8c6f$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $27fe5b475ade8c6f$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getStore", ()=>this._store);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($27fe5b475ade8c6f$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "swapToInMemory", ()=>{
            if (this._store === (0, $d36baf8968a60502$export$2e2bcd8739ae039) || typeof window === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($27fe5b475ade8c6f$export$48c17662a6902497(window[$27fe5b475ade8c6f$export$770aa8bc07b3de03])) inMemoryStorage = window[$27fe5b475ade8c6f$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $d36baf8968a60502$export$2e2bcd8739ae039);
                if (!window[$27fe5b475ade8c6f$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$27fe5b475ade8c6f$export$770aa8bc07b3de03] = (0, $d36baf8968a60502$export$2e2bcd8739ae039);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clear", ()=>this._store.clear());
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "key", (index)=>this._store.key(index));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getPrefix", ()=>this._prefix);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($27fe5b475ade8c6f$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($27fe5b475ade8c6f$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}


class $f372987aa5e13e03$export$2e2bcd8739ae039 extends (0, $27fe5b475ade8c6f$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $d36baf8968a60502$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $d36baf8968a60502$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}


class $62fa4b3d802ceb1a$export$2e2bcd8739ae039 {
    constructor(){
        this.safeStorage = new (0, $f372987aa5e13e03$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
    }
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
}





const $3a800e81887287db$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $3a800e81887287db$export$eb80e1beaa8dacf8 = (0, $8ae807f5b94fa454$export$d4cb17942ea57c95).AWC_TLD_TEST.getKey();
const $3a800e81887287db$export$19164982d36535d8 = "tld_test";
const $3a800e81887287db$export$de6821eed3d5f32d = (0, $b96cdb796e568e05$export$2e2bcd8739ae039)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))).set($3a800e81887287db$export$eb80e1beaa8dacf8, $3a800e81887287db$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))).get($3a800e81887287db$export$eb80e1beaa8dacf8) === $3a800e81887287db$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))).remove($3a800e81887287db$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});


function $4082dbc39f5b2d88$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4082dbc39f5b2d88$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4082dbc39f5b2d88$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4082dbc39f5b2d88$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4082dbc39f5b2d88$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $3a800e81887287db$export$a9330601ee8f4d95)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))) : new (0, $62fa4b3d802ceb1a$export$2e2bcd8739ae039)();
    }
    set(name, value, options) {
        // no-op
        if (!(0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name].getKey(), value, $4082dbc39f5b2d88$var$_objectSpread($4082dbc39f5b2d88$var$_objectSpread({}, (0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $3a800e81887287db$export$de6821eed3d5f32d)()
        }, options));
    }
    get(name) {
        if (!(0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $8ae807f5b94fa454$export$d4cb17942ea57c95)[name].getKey(), $4082dbc39f5b2d88$var$_objectSpread({}, options));
    }
}



// Cookie is stale, if anonymousId was generated 7 days ago.
const $3c8b344901fb62bd$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $3c8b344901fb62bd$var$SAFE = "SAFE";
const $3c8b344901fb62bd$var$UNSAFE = "UNSAFE";
const $3c8b344901fb62bd$var$NOT_FOUND = "NOT_FOUND";
const $3c8b344901fb62bd$var$COOKIE = "COOKIE";
const $3c8b344901fb62bd$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $3c8b344901fb62bd$export$2e2bcd8739ae039 {
    constructor(disableCookiePersistence){
        this.store = new (0, $f372987aa5e13e03$export$2e2bcd8739ae039)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $4082dbc39f5b2d88$export$2e2bcd8739ae039)(disableCookiePersistence);
    }
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $8ae807f5b94fa454$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $8ae807f5b94fa454$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $3c8b344901fb62bd$var$LOCAL_STORAGE ? this.store.getItem((0, $8ae807f5b94fa454$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $8ae807f5b94fa454$export$202d555a5dbfd90c).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $3c8b344901fb62bd$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $3c8b344901fb62bd$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $3c8b344901fb62bd$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($3c8b344901fb62bd$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $4a5f646730194dba$export$2e2bcd8739ae039)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $3c8b344901fb62bd$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $3c8b344901fb62bd$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $3c8b344901fb62bd$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $3c8b344901fb62bd$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($3c8b344901fb62bd$var$COOKIE);
        switch(cookieValue.type){
            case $3c8b344901fb62bd$var$SAFE:
            case $3c8b344901fb62bd$var$UNSAFE:
                this.store.setItem((0, $8ae807f5b94fa454$export$d4cb17942ea57c95).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $3c8b344901fb62bd$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
}



var $836194d935ad1a41$exports = {};
"use strict";
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $99b55fa754e2ef0b$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $99b55fa754e2ef0b$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $99b55fa754e2ef0b$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$99b55fa754e2ef0b$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $99b55fa754e2ef0b$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$99b55fa754e2ef0b$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $99b55fa754e2ef0b$var$matcher.test(string);
};


/**
 * Expose `traverse`.
 */ $836194d935ad1a41$exports = $836194d935ad1a41$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $836194d935ad1a41$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $836194d935ad1a41$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $836194d935ad1a41$var$traverseArray(input, strict);
    else if ($99b55fa754e2ef0b$export$226b3eccf92c9ed9(input, strict)) return $99b55fa754e2ef0b$export$98e6a39c04603d36(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $836194d935ad1a41$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $836194d935ad1a41$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $836194d935ad1a41$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $836194d935ad1a41$var$traverse(value, strict);
    });
    return arr;
}


function $1e1eeed93c8db210$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e1eeed93c8db210$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e1eeed93c8db210$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e1eeed93c8db210$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1e1eeed93c8db210$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $1e1eeed93c8db210$var$_objectSpread($1e1eeed93c8db210$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $1e1eeed93c8db210$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $1e1eeed93c8db210$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($836194d935ad1a41$exports)))(propertiesWithoutUndefined);
};
const $1e1eeed93c8db210$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $1e1eeed93c8db210$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$1e1eeed93c8db210$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $1e1eeed93c8db210$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $1e1eeed93c8db210$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};


function $69cca12cf593f2db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $69cca12cf593f2db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $69cca12cf593f2db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $69cca12cf593f2db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $69cca12cf593f2db$var$AnalyticsAPIResponse {
    constructor(success, validationErrors, message, code, validationReports){
        this.success = success;
        this.validationErrors = validationErrors;
        this.message = message;
        this.code = code;
        this.validationReports = validationReports;
    }
    isSuccess() {
        return this.success;
    }
    getValidationErrors() {
        return this.validationErrors;
    }
    getMessage() {
        return this.message;
    }
    getCode() {
        return this.code;
    }
    getValidationReports() {
        return this.validationReports;
    }
}
class $69cca12cf593f2db$var$Message {
    constructor(error){
        this.error = error;
    }
}
class $69cca12cf593f2db$var$EventValidationReport {
    constructor(messageId, results){
        this.messageId = messageId;
        this.results = results;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
}
class $69cca12cf593f2db$export$133650fcdde1b226 {
    constructor(success, statusCode, message, eventResponseList){
        this.success = success;
        this.statusCode = statusCode;
        this.message = message;
        this.eventResponseList = eventResponseList;
    }
    isSuccess() {
        return this.success;
    }
    getStatusCode() {
        return this.statusCode;
    }
    getMessage() {
        return this.message;
    }
    getEventResponseList() {
        return this.eventResponseList;
    }
}
class $69cca12cf593f2db$var$EventResponse {
    constructor(messageId, results, segmentEvent){
        this.messageId = messageId;
        this.results = results;
        this.segmentEvent = segmentEvent;
    }
    getMessageId() {
        return this.messageId;
    }
    getResults() {
        return this.results;
    }
    getSegmentEvent() {
        return this.segmentEvent;
    }
}
class $69cca12cf593f2db$var$EventValidationResult {
    constructor(type, severity, propertyPath, message){
        this.type = type;
        this.severity = severity;
        this.propertyPath = propertyPath;
        this.message = message;
    }
    getType() {
        return this.type;
    }
    getSeverity() {
        return this.severity;
    }
    getPropertyPath() {
        return this.propertyPath;
    }
    getMessage() {
        return this.message;
    }
}
class $69cca12cf593f2db$export$2e2bcd8739ae039 {
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            const localResponseCallback = this.responseCallback;
            try {
                const response = await (0, $dd4c8e887af3e8e8$export$8e8f0180c1b41fad)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
                if (localResponseCallback !== null && response !== null) {
                    const analyticsAPIResponse = await response.clone().json();
                    const analyticsResponse = $69cca12cf593f2db$var$BatchInterceptor.toAnalyticsResponse(items, null, analyticsAPIResponse);
                    localResponseCallback(analyticsResponse);
                }
            } catch (error) {
                callback(error, null);
                if (localResponseCallback !== null && error !== null) {
                    const analyticsResponse = $69cca12cf593f2db$var$BatchInterceptor.toAnalyticsResponse(items, error, null);
                    localResponseCallback(analyticsResponse);
                }
            }
        });
        this.options = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $2dcdb849f4d078e7$export$9175ce0e1c95daf2),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $3c8b344901fb62bd$export$2e2bcd8739ae039)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $9d576057019c0ac0$export$2e2bcd8739ae039)();
        this.responseCallback = options.responseCallback;
        this.resilienceQueue = (0, $da7766cab604e35c$export$2e2bcd8739ae039)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).TRACK, builtEvent);
        const eventWithoutMessageId = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).TRACK,
            properties: (0, $1e1eeed93c8db210$export$44d22e5fb02cc68e)(builtEvent),
            event: eventName
        });
        const event = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).PAGE, builtEvent);
        const eventWithoutMessageId = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).PAGE,
            properties: (0, $1e1eeed93c8db210$export$44d22e5fb02cc68e)(builtEvent),
            name: eventName
        });
        const event = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $ed2f55049b0dbd43$export$ddf929981dc6feb3).IDENTIFY,
            traits: (0, $1e1eeed93c8db210$export$44d22e5fb02cc68e)(builtEvent)
        });
        const event = $69cca12cf593f2db$var$_objectSpread($69cca12cf593f2db$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $1e1eeed93c8db210$export$44d22e5fb02cc68e)(context);
        const segmentContext = (0, $1e1eeed93c8db210$export$3a7fe28f9bf4f3d9)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $52a7be140c02c122$export$c21270cab66ab290)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    setResponseCallback(responseCallback) {
        this.responseCallback = responseCallback;
    }
}
class $69cca12cf593f2db$var$BatchInterceptor {
    static toAnalyticsResponse(items, error, analyticsAPIResponse) {
        const eventResponseList = [];
        if (analyticsAPIResponse !== null) {
            const [statusCode, success] = [
                analyticsAPIResponse.code,
                analyticsAPIResponse.success
            ];
            if (statusCode >= 200 && statusCode <= 299) {
                var _analyticsAPIResponse;
                (_analyticsAPIResponse = analyticsAPIResponse.validationReports) === null || _analyticsAPIResponse === void 0 || _analyticsAPIResponse.forEach((report)=>{
                    const matchedEvent = items.find((item)=>item.msg.messageId === report.messageId);
                    if (matchedEvent) eventResponseList.push(new $69cca12cf593f2db$var$EventResponse(matchedEvent.msg.messageId, report.results, matchedEvent.msg));
                });
                return new $69cca12cf593f2db$export$133650fcdde1b226(success, statusCode, (0, $f0471dbfef1fd0d3$export$ba118f9de1e5ac63).get(statusCode), eventResponseList);
            } else if (statusCode >= 400 && statusCode <= 499) {
                var _analyticsAPIResponse2;
                // not exluding "HTTP 429 Too Many Requests error" as it is thrown as an error and handled below
                const errorMessage = ((_analyticsAPIResponse2 = analyticsAPIResponse.message) === null || _analyticsAPIResponse2 === void 0 ? void 0 : _analyticsAPIResponse2.error) !== null ? analyticsAPIResponse.message.error : (0, $f0471dbfef1fd0d3$export$ba118f9de1e5ac63).has(statusCode) ? (0, $f0471dbfef1fd0d3$export$ba118f9de1e5ac63).get(statusCode) : (0, $f0471dbfef1fd0d3$export$ba118f9de1e5ac63).get(-1);
                items.forEach((item)=>{
                    eventResponseList.push(new $69cca12cf593f2db$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $69cca12cf593f2db$export$133650fcdde1b226(success, statusCode, errorMessage, eventResponseList);
            }
        } else if (error !== null && error.message !== null) {
            const match = error.message.match($69cca12cf593f2db$var$BatchInterceptor.http_error_regex);
            if (match) {
                items.forEach((item)=>{
                    eventResponseList.push(new $69cca12cf593f2db$var$EventResponse(item.msg.messageId, [], item.msg));
                });
                return new $69cca12cf593f2db$export$133650fcdde1b226(false, Number(match[1]), match[2], eventResponseList);
            }
        }
        items.forEach((item)=>{
            eventResponseList.push(new $69cca12cf593f2db$var$EventResponse(item.msg.messageId, [], item.msg));
        });
        return new $69cca12cf593f2db$export$133650fcdde1b226(false, -1, (0, $f0471dbfef1fd0d3$export$ba118f9de1e5ac63).get(-1), eventResponseList);
    }
}
(0, $26075062244a15ae$export$2e2bcd8739ae039)($69cca12cf593f2db$var$BatchInterceptor, "http_error_regex", /HTTP Error\s([0-9]{3})\s\((.+)\)/);




var $bb648daaa834635d$export$f9380c9a627682d3;
var $bb648daaa834635d$export$98e6a39c04603d36;
var $bb648daaa834635d$export$fac44ee5b035f737;
var $bb648daaa834635d$export$7a5253c0f62e0150;
var $bb648daaa834635d$export$a8c1621ea79325d3;
var $bb648daaa834635d$export$357523c63a2253b9;
var $bb648daaa834635d$export$44c361b8ec72ef7f;
"use strict";

var $cBwPl = parcelRequire("cBwPl");

var $2RP26 = parcelRequire("2RP26");

var $888c8 = parcelRequire("888c8");

var $95zlx = parcelRequire("95zlx");
const $bb648daaa834635d$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $bb648daaa834635d$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $bb648daaa834635d$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            "[",
                            $bb648daaa834635d$var$encode(index, options),
                            "]=",
                            $bb648daaa834635d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            "[]=",
                            $bb648daaa834635d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            ":list=",
                            $bb648daaa834635d$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $bb648daaa834635d$var$encode(key, options),
                                keyValueSep,
                                $bb648daaa834635d$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $bb648daaa834635d$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $bb648daaa834635d$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $bb648daaa834635d$var$encode(key, options),
                            "=",
                            $bb648daaa834635d$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $bb648daaa834635d$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $bb648daaa834635d$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $bb648daaa834635d$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$bb648daaa834635d$var$decode(item, options)) : value === null ? value : $bb648daaa834635d$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $bb648daaa834635d$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$bb648daaa834635d$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $bb648daaa834635d$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $bb648daaa834635d$var$encode(value, options) {
    if (options.encode) return options.strict ? $cBwPl(value) : encodeURIComponent(value);
    return value;
}
function $bb648daaa834635d$var$decode(value, options) {
    if (options.decode) return $2RP26(value);
    return value;
}
function $bb648daaa834635d$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $bb648daaa834635d$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $bb648daaa834635d$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $bb648daaa834635d$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $bb648daaa834635d$var$extract(input) {
    input = $bb648daaa834635d$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $bb648daaa834635d$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $bb648daaa834635d$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $bb648daaa834635d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $bb648daaa834635d$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $888c8(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $bb648daaa834635d$var$decode(value, options);
        formatter($bb648daaa834635d$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $bb648daaa834635d$var$parseValue(value[k], options);
        else ret[key] = $bb648daaa834635d$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $bb648daaa834635d$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$bb648daaa834635d$export$f9380c9a627682d3 = $bb648daaa834635d$var$extract;
$bb648daaa834635d$export$98e6a39c04603d36 = $bb648daaa834635d$var$parse;
$bb648daaa834635d$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $bb648daaa834635d$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $bb648daaa834635d$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $bb648daaa834635d$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $bb648daaa834635d$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $bb648daaa834635d$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $bb648daaa834635d$var$encode(key, options) + "=" + $bb648daaa834635d$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$bb648daaa834635d$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $888c8(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $bb648daaa834635d$var$parse($bb648daaa834635d$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $bb648daaa834635d$var$decode(hash, options)
    } : {});
};
$bb648daaa834635d$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$bb648daaa834635d$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $bb648daaa834635d$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $bb648daaa834635d$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $bb648daaa834635d$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $bb648daaa834635d$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $bb648daaa834635d$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$bb648daaa834635d$var$encodeFragmentIdentifier] ? $bb648daaa834635d$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$bb648daaa834635d$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$bb648daaa834635d$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $bb648daaa834635d$export$7a5253c0f62e0150(input, options);
    return $bb648daaa834635d$export$a8c1621ea79325d3({
        url: url,
        query: $95zlx(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$bb648daaa834635d$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $bb648daaa834635d$export$357523c63a2253b9(input, exclusionFilter, options);
};



const $62ed181a873f4b6a$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $62ed181a873f4b6a$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $62ed181a873f4b6a$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $bb648daaa834635d$export$7a5253c0f62e0150)(removedFragmentURL);
    const captureParams = (0, $cfe4018516172a9d$export$b460b275d6c6aa0)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $cfe4018516172a9d$export$d7a617dda645b4e3)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $bb648daaa834635d$export$fac44ee5b035f737)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $62ed181a873f4b6a$export$2e2bcd8739ae039 = $62ed181a873f4b6a$var$urlParamExtractor;


class $db522542e8d2e8ec$export$2e2bcd8739ae039 {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $b44600d71695f28f$export$62a500c02dc63ee)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $62ed181a873f4b6a$export$2e2bcd8739ae039)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}




const $e8d7348ba4c0c2fd$var$PROD_HOST = "as.atlassian.com/api/v1";
const $e8d7348ba4c0c2fd$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $e8d7348ba4c0c2fd$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $e8d7348ba4c0c2fd$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $e8d7348ba4c0c2fd$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $e8d7348ba4c0c2fd$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $e8d7348ba4c0c2fd$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $e8d7348ba4c0c2fd$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $e8d7348ba4c0c2fd$var$STARGATE_PROXY_PATH = "/gateway/api/gasv3/api/v1";
const $e8d7348ba4c0c2fd$var$handleFedRampStagingDirect = ()=>{
    return $e8d7348ba4c0c2fd$var$FEDRAMP_STAGING_HOST;
};
const $e8d7348ba4c0c2fd$var$handleFedRampStagingStargate = ()=>{
    return $e8d7348ba4c0c2fd$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $e8d7348ba4c0c2fd$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).LOCAL || env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD ? $e8d7348ba4c0c2fd$var$FEDRAMP_PROD_HOST : $e8d7348ba4c0c2fd$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD ? $e8d7348ba4c0c2fd$var$STARGATE_FEDRAMP_PROD_HOST : $e8d7348ba4c0c2fd$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $e8d7348ba4c0c2fd$var$STARGATE_PROXY_PATH;
};
const $e8d7348ba4c0c2fd$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD ? $e8d7348ba4c0c2fd$var$PROD_HOST : $e8d7348ba4c0c2fd$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD ? $e8d7348ba4c0c2fd$var$STARGATE_PROD_HOST : $e8d7348ba4c0c2fd$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $e8d7348ba4c0c2fd$var$STARGATE_PROXY_PATH;
};
function $e8d7348ba4c0c2fd$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $b44600d71695f28f$export$bdd41749d2096e4b).FEDRAMP_MODERATE) return $e8d7348ba4c0c2fd$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $e8d7348ba4c0c2fd$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}




const $410fd2a82646d2e4$var$SESSION_ID_STORAGE_KEY = "session.id";
const $410fd2a82646d2e4$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $410fd2a82646d2e4$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $410fd2a82646d2e4$export$285f6bddd927a06d = 1800000; // 30 minutes
const $410fd2a82646d2e4$export$a92e915d70316eb2 = 5000; // 5 seconds
const $410fd2a82646d2e4$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $410fd2a82646d2e4$export$5702a91a6f42969f = ()=>{};
class $410fd2a82646d2e4$export$2e2bcd8739ae039 {
    constructor(options = {}){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($410fd2a82646d2e4$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($410fd2a82646d2e4$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $410fd2a82646d2e4$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $410fd2a82646d2e4$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $410fd2a82646d2e4$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $410fd2a82646d2e4$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $f372987aa5e13e03$export$2e2bcd8739ae039)();
    }
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($410fd2a82646d2e4$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($410fd2a82646d2e4$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$410fd2a82646d2e4$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
}




class $11c5ecdf7ad4bb16$export$2e2bcd8739ae039 extends (0, $27fe5b475ade8c6f$export$2e2bcd8739ae039) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $d36baf8968a60502$export$2e2bcd8739ae039);
        } catch (err) {
            storageToUse = (0, $d36baf8968a60502$export$2e2bcd8739ae039);
        }
        super(storageToUse, options);
    }
}





const $5cbfa842b91b27a5$var$STORAGE_KEY = "tab.id";
class $5cbfa842b91b27a5$export$2e2bcd8739ae039 {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))();
            this._safeSessionStorage.setItem($5cbfa842b91b27a5$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $11c5ecdf7ad4bb16$export$2e2bcd8739ae039)();
    }
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($5cbfa842b91b27a5$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
}









function $622003dbc8b71a13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $622003dbc8b71a13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $622003dbc8b71a13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $622003dbc8b71a13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $622003dbc8b71a13$var$STORAGE_KEY = "taskSessions";
const $622003dbc8b71a13$var$INIT_KEY = "taskSessionsInit";
const $622003dbc8b71a13$var$AWC_PARAM_PREFIX = "awc.";
const $622003dbc8b71a13$var$TASK_SESSION_RELOAD_TIME = 3000;
class $622003dbc8b71a13$export$2e2bcd8739ae039 {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($622003dbc8b71a13$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($622003dbc8b71a13$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($622003dbc8b71a13$var$INIT_KEY) || "0", 10) < currentTimestamp - $622003dbc8b71a13$var$TASK_SESSION_RELOAD_TIME);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($622003dbc8b71a13$var$AWC_PARAM_PREFIX)[1]);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($622003dbc8b71a13$var$AWC_PARAM_PREFIX));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($622003dbc8b71a13$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($622003dbc8b71a13$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $bb648daaa834635d$export$7a5253c0f62e0150)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $cfe4018516172a9d$export$357523c63a2253b9)(currentState, includedTaskSessions) : (0, $cfe4018516172a9d$export$30a06c8d3562193f)(currentState, Object.values((0, $b44600d71695f28f$export$62a500c02dc63ee)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $622003dbc8b71a13$var$_objectSpread($622003dbc8b71a13$var$_objectSpread({}, (0, $cfe4018516172a9d$export$781522908e4e76a1)(filteredTaskSessions, (_, taskSessionName)=>$622003dbc8b71a13$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $bb648daaa834635d$export$fac44ee5b035f737)(queryWithTaskSessions)}`;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $cfe4018516172a9d$export$781522908e4e76a1)((0, $62ed181a873f4b6a$export$2e2bcd8739ae039)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $11c5ecdf7ad4bb16$export$2e2bcd8739ae039)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($622003dbc8b71a13$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}





const $2f94cde79c12eeeb$var$MAX_CACHE_SIZE = 100;
const $2f94cde79c12eeeb$var$COOKIE_NAME = (0, $8ae807f5b94fa454$export$d4cb17942ea57c95).AWC_ANALYTICS_DEBUG.getKey();
const $2f94cde79c12eeeb$var$DEBUG_TAG = "synthetic";
const $2f94cde79c12eeeb$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))).get($2f94cde79c12eeeb$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($3b044cef7cf53e20$exports))).remove($2f94cde79c12eeeb$var$COOKIE_NAME);
    }
    return false;
};
class $2f94cde79c12eeeb$var$TestingCache {
    constructor(){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_bind", ()=>{
            if (typeof window === "undefined" || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_cache", (event)=>{
            if (typeof window === "undefined") return;
            if (window.testAnalytics.eventCache.length >= $2f94cde79c12eeeb$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($2f94cde79c12eeeb$var$DEBUG_TAG);
                else event.tags = [
                    $2f94cde79c12eeeb$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $2f94cde79c12eeeb$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $2f94cde79c12eeeb$export$2e2bcd8739ae039 = $2f94cde79c12eeeb$var$TestingCache;






const $1b06eca114828f33$var$_excluded = [
    "embeddedProduct"
];
function $1b06eca114828f33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1b06eca114828f33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1b06eca114828f33$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1b06eca114828f33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1b06eca114828f33$var$DEFAULT_DELAY = 2000; // 2 seconds
const $1b06eca114828f33$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $1b06eca114828f33$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $1b06eca114828f33$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $b44600d71695f28f$export$496f06ac2a964da2).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, $4524e3c20906fc7e$export$2e2bcd8739ae039)(_this$_getContext, $1b06eca114828f33$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $1b06eca114828f33$var$_objectSpread($1b06eca114828f33$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $1b06eca114828f33$var$_objectSpread($1b06eca114828f33$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $1b06eca114828f33$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $1b06eca114828f33$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $1b06eca114828f33$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $f372987aa5e13e03$export$2e2bcd8739ae039)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}



function $8e04a6156ed9bee5$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}


let $d9bd63cb79f1f1f4$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $d9bd63cb79f1f1f4$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});


const $ac2dea803615fb25$export$545bcbd53afabfa3 = 5000;
const $ac2dea803615fb25$export$af4087e36d63846 = ()=>[
        {
            type: (0, $d9bd63cb79f1f1f4$export$92ca0438bcb0d396).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $d9bd63cb79f1f1f4$export$92ca0438bcb0d396).UID,
            state: "TIMEOUT"
        }
    ];
const $ac2dea803615fb25$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $d9bd63cb79f1f1f4$export$92ca0438bcb0d396).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $d9bd63cb79f1f1f4$export$92ca0438bcb0d396).UID,
            state: "UNKNOWN"
        }
    ];


const $a6146ebe79efcca1$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $ac2dea803615fb25$export$af4087e36d63846)()), (0, $ac2dea803615fb25$export$545bcbd53afabfa3));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $ac2dea803615fb25$export$fa341d0c750d705b)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};


function $2b3eda7b74e3905d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2b3eda7b74e3905d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2b3eda7b74e3905d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $26075062244a15ae$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2b3eda7b74e3905d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2b3eda7b74e3905d$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $2b3eda7b74e3905d$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $2b3eda7b74e3905d$export$48361b6ed38f1b0 {
    static callback(response) {
        const statusCode = response.getStatusCode();
        if (statusCode >= 200 && statusCode <= 299) {
            if (response.getEventResponseList().length === 0) // eslint-disable-next-line no-console
            console.debug("Event(s) submitted to GASv3");
            else response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn("Validation report for event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        } else if (statusCode === 400 || statusCode === 404) {
            // eslint-disable-next-line no-console
            console.warn("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.getEventResponseList().forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.warn("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        } else {
            // eslint-disable-next-line no-console
            console.info("GASv3 submission failed with HTTP Status Code %d: %s", response.getStatusCode(), response.getMessage());
            response.eventResponseList.forEach((eventResponse)=>{
                // eslint-disable-next-line no-console
                console.debug("Event with message ID %s:\n", eventResponse.getMessageId(), eventResponse);
            });
        }
    }
}
class $2b3eda7b74e3905d$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_createSubproductGetter", (subproduct)=>(0, $fd3a934d161b401e$export$2e2bcd8739ae039)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $fd3a934d161b401e$export$2e2bcd8739ae039)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($2b3eda7b74e3905d$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($2b3eda7b74e3905d$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($2b3eda7b74e3905d$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $b44600d71695f28f$export$4c045e605d532c98).UI:
                case (0, $b44600d71695f28f$export$4c045e605d532c98).OPERATIONAL:
                case (0, $b44600d71695f28f$export$4c045e605d532c98).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $b44600d71695f28f$export$4c045e605d532c98).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $b44600d71695f28f$export$4c045e605d532c98).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $b44600d71695f28f$export$496f06ac2a964da2).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$496f06ac2a964da2), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$496f06ac2a964da2))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setUserInfo", (userIdType, userId)=>{
            (0, $729129a3d9b7a446$export$c16a4e16aa4026c0)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$a8c99e46b781d936), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$a8c99e46b781d936))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$e73680b18d9b7c6e), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$e73680b18d9b7c6e))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $2b3eda7b74e3905d$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $b44600d71695f28f$export$4c045e605d532c98).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $729129a3d9b7a446$export$dc993432a592dc27)(screenName);
            (0, $729129a3d9b7a446$export$e63ea5d8477971d3)(screenContainers);
            const builtEvent = (0, $a96b95b16d5d0eae$export$c7d9a5f56acc4b19)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $2b3eda7b74e3905d$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $8e04a6156ed9bee5$export$2e2bcd8739ae039)(callback, builtEventWithName));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendTrackEvent", (event, callback)=>{
            (0, $729129a3d9b7a446$export$8c014fd74b0c8b99)(event);
            const builtEvent = (0, $a96b95b16d5d0eae$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $b44600d71695f28f$export$4c045e605d532c98).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $a96b95b16d5d0eae$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $8e04a6156ed9bee5$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendUIEvent", (event, callback)=>{
            (0, $729129a3d9b7a446$export$e5bac0930c812e90)(event);
            const builtEvent = (0, $a96b95b16d5d0eae$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $b44600d71695f28f$export$4c045e605d532c98).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $a96b95b16d5d0eae$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $8e04a6156ed9bee5$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "sendOperationalEvent", (event, callback)=>{
            (0, $729129a3d9b7a446$export$1e561554275607ef)(event);
            const builtEvent = (0, $a96b95b16d5d0eae$export$7bf451af4a8e3dd9)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $b44600d71695f28f$export$4c045e605d532c98).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $a96b95b16d5d0eae$export$9c5623a792efc9b0)(event), builtEvent, this._context, (0, $8e04a6156ed9bee5$export$2e2bcd8739ae039)(callback, builtEvent));
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $1b06eca114828f33$export$2e2bcd8739ae039)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $b44600d71695f28f$export$4c045e605d532c98).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b44600d71695f28f$export$4c045e605d532c98).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b44600d71695f28f$export$4c045e605d532c98).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $b44600d71695f28f$export$4c045e605d532c98).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $b44600d71695f28f$export$4c045e605d532c98).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$4c045e605d532c98))}]`);
        });
        (0, $26075062244a15ae$export$2e2bcd8739ae039)(this, "setResponseCallback", (responseCallback)=>{
            this.eventProcessor.setResponseCallback(responseCallback);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$56ac8ebc9870b1b9), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$56ac8ebc9870b1b9))}]`);
        if (productInfo.perimeter && !(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$bdd41749d2096e4b), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$bdd41749d2096e4b))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $b44600d71695f28f$export$f73e9fcd368bb695).WEB;
        else if (!(0, $b44600d71695f28f$export$26b9f946b448f23e)((0, $b44600d71695f28f$export$f73e9fcd368bb695), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $b44600d71695f28f$export$ad1854f4a08c15f8)((0, $b44600d71695f28f$export$f73e9fcd368bb695))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $b44600d71695f28f$export$f73e9fcd368bb695).WEB ? (0, $b44600d71695f28f$export$6b4f396210e539f3).WEB : (0, $b44600d71695f28f$export$6b4f396210e539f3).DESKTOP;
        else (0, $729129a3d9b7a446$export$801b46c35394d316)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $2b3eda7b74e3905d$var$_objectSpread($2b3eda7b74e3905d$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        if (productInfo !== null && productInfo !== void 0 && productInfo.embeddedContext) {
            this._embeddedContext = productInfo.embeddedContext;
            if ((0, $815e0d72e56c9b1a$export$f56713ced121eb91)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromProduct: this._embeddedContext["embeddedFromProduct"],
                embeddedFromSubproduct: this._embeddedContext["embeddedFromSubproduct"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
            if ((0, $815e0d72e56c9b1a$export$ab34f90cc32c8960)(this._embeddedContext)) this.setUIViewedAttributes({
                embeddedType: this._embeddedContext["embeddedType"],
                embeddedFromTopLevelDomain: this._embeddedContext["embeddedFromTopLevelDomain"]
            });
        }
        this._context = (0, $a96b95b16d5d0eae$export$3a7fe28f9bf4f3d9)(this._productInfo);
        this._safeSessionStorage = new (0, $11c5ecdf7ad4bb16$export$2e2bcd8739ae039)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $e8d7348ba4c0c2fd$export$18c0b81944902eae)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $a6146ebe79efcca1$export$fbe53bbbe682bcdd)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $69cca12cf593f2db$export$2e2bcd8739ae039)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence,
            responseCallback: $2b3eda7b74e3905d$export$48361b6ed38f1b0.callback
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $a431c200e910cd58$export$2e2bcd8739ae039)();
        this._tabTracking = new (0, $5cbfa842b91b27a5$export$2e2bcd8739ae039)();
        this._sessionTracking = new (0, $410fd2a82646d2e4$export$2e2bcd8739ae039)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $622003dbc8b71a13$export$2e2bcd8739ae039)();
        this.originTracing = new (0, $db522542e8d2e8ec$export$2e2bcd8739ae039)();
        // Init Apdex
        this._apdexEvent = new (0, $2abf3fdb25b5bcce$export$2e2bcd8739ae039)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $62ed181a873f4b6a$export$600dd5bf1b049f11);
        this.eventDelayQueue = new (0, $fee093b4521f35ad$export$2e2bcd8739ae039)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $2f94cde79c12eeeb$export$2e2bcd8739ae039)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($7e528f8fe8926776$exports)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
    setEventValidationMode(eventValidationMode) {
        this._context.context.validationMode = eventValidationMode;
    }
}


const $ea73d90b445eaf0d$var$getAnonIdUsedByFeatureGatesClientInSSR = ()=>window.featureGateBootstrapValues?.identifiers?.analyticsAnonymousId ?? "";
const $ea73d90b445eaf0d$var$readCookieValue = (name)=>{
    const match = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`).exec(document.cookie);
    return match?.[1] !== undefined ? decodeURIComponent(match[1]) : null;
};
const $ea73d90b445eaf0d$var$getAtlassianUserId = ()=>{
    const userId = $ea73d90b445eaf0d$var$readCookieValue("__aid_user_id");
    if (userId) return decodeURIComponent(userId);
    return null;
};
const $ea73d90b445eaf0d$var$getGASv3Environment = ()=>{
    return (0, $b44600d71695f28f$export$56ac8ebc9870b1b9).PROD;
};
const $ea73d90b445eaf0d$var$getXidEnvironment = ()=>{
    return (0, $ca1a71da0caf16e6$exports.Environment).PROD;
};
const $ea73d90b445eaf0d$var$shouldUseStargate = ()=>{
    return true;
};
const $ea73d90b445eaf0d$var$getBuildVersion = ()=>"p-99779a3031";
const $ea73d90b445eaf0d$var$getApiHostProtocol = ()=>{
    if (typeof window !== "undefined" && window.location.protocol === "http:") return "http";
    return "https";
};
const $ea73d90b445eaf0d$export$ed4b549ef96c8511 = ()=>{
    const client = new (0, $2b3eda7b74e3905d$export$2e2bcd8739ae039)({
        env: $ea73d90b445eaf0d$var$getGASv3Environment(),
        product: "trello",
        version: $ea73d90b445eaf0d$var$getBuildVersion(),
        locale: "en-us"
    }, {
        useStargate: $ea73d90b445eaf0d$var$shouldUseStargate(),
        apiHostProtocol: $ea73d90b445eaf0d$var$getApiHostProtocol(),
        xidConsent: true,
        xidPromiseFn: ()=>new (0, $ca1a71da0caf16e6$exports.XID)($ea73d90b445eaf0d$var$getXidEnvironment()).getXidCallbackForPromise(),
        customAnonymousIdGenerator: $ea73d90b445eaf0d$var$getAnonIdUsedByFeatureGatesClientInSSR,
        flushWaitInterval: 100
    });
    const aaid = $ea73d90b445eaf0d$var$getAtlassianUserId();
    if (aaid) client.setUserInfo((0, $b44600d71695f28f$export$1827adfd178b4870).ATLASSIAN_ACCOUNT, aaid);
    return client;
};



var $iSvIT = parcelRequire("iSvIT");

var $jzYu7 = parcelRequire("jzYu7");

var $2sYxo = parcelRequire("2sYxo");

var $aKGMT = parcelRequire("aKGMT");
parcelRequire("f6ogN");
var $C3IJI = parcelRequire("C3IJI");

var $jxLBU = parcelRequire("jxLBU");

var $dB5ic = parcelRequire("dB5ic");

var $bs6hr = parcelRequire("bs6hr");

var $jyanA = parcelRequire("jyanA");

var $gjbIv = parcelRequire("gjbIv");

var $fhH6n = parcelRequire("fhH6n");

var $2TVum = parcelRequire("2TVum");

var $hkP9U = parcelRequire("hkP9U");

var $dqOGO = parcelRequire("dqOGO");

var $hkP9U = parcelRequire("hkP9U");
var $92aee28523351788$var$nameCache = new WeakMap();
function $92aee28523351788$var$getAttributeSelector(element, attributeName) {
    var attrValue = element.getAttribute(attributeName);
    if (!attrValue) return "";
    return "[".concat(attributeName, '="').concat(attrValue, '"]');
}
function $92aee28523351788$var$isValidSelector(selector) {
    try {
        document.querySelector(selector);
        return true;
    } catch (_unused) {
        return false;
    }
}
function $92aee28523351788$var$isSelectorUnique(selector) {
    return document.querySelectorAll(selector).length === 1;
}
function $92aee28523351788$var$getUniqueSelector(selectorConfig, element) {
    var currentElement = element;
    var parts = [];
    var MAX_DEPTH = 3;
    var currentDepth = 0;
    while(currentElement && currentElement.localName !== "body" && currentDepth <= MAX_DEPTH){
        var tagName = currentElement.localName;
        var selectorPart = tagName;
        if (selectorConfig.id && currentElement.id && $92aee28523351788$var$isValidSelector("#".concat(currentElement.id))) selectorPart += "#".concat(currentElement.id);
        else if (selectorConfig.dataVC) selectorPart += $92aee28523351788$var$getAttributeSelector(currentElement, "data-vc");
        else if (selectorConfig.testId) selectorPart += $92aee28523351788$var$getAttributeSelector(currentElement, "data-testid") || $92aee28523351788$var$getAttributeSelector(currentElement, "data-test-id");
        else if (selectorConfig.role) selectorPart += $92aee28523351788$var$getAttributeSelector(currentElement, "role");
        else if (selectorConfig.className && currentElement.className) {
            var classNames = Array.from(currentElement.classList).join(".");
            if (classNames) {
                if ($92aee28523351788$var$isValidSelector(".".concat(classNames))) selectorPart += ".".concat(classNames);
            }
        }
        parts.unshift(selectorPart);
        var _potentialSelector = parts.join(" > ").trim();
        if (_potentialSelector && $92aee28523351788$var$isSelectorUnique(_potentialSelector)) return _potentialSelector;
        currentElement = currentElement.parentElement;
        currentDepth++;
    }
    var potentialSelector = parts.join(" > ").trim();
    if (!potentialSelector) return "unknown";
    else if (!$92aee28523351788$var$isSelectorUnique(potentialSelector)) {
        var parentElement = element.parentElement;
        if (parentElement) return "".concat(potentialSelector, ":nth-child"); // NOTE: invalid DOM selector, but enough information for VC
    }
    return potentialSelector;
}
function $92aee28523351788$var$getElementName(selectorConfig, element) {
    if (!(element instanceof HTMLElement)) return "error";
    var cachedName = $92aee28523351788$var$nameCache.get(element);
    if (cachedName) return cachedName;
    var uniqueSelector = $92aee28523351788$var$getUniqueSelector(selectorConfig, element);
    $92aee28523351788$var$nameCache.set(element, uniqueSelector);
    return uniqueSelector;
}
var $92aee28523351788$export$2e2bcd8739ae039 = $92aee28523351788$var$getElementName;


function $87aec772ac244025$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87aec772ac244025$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87aec772ac244025$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87aec772ac244025$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $87aec772ac244025$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $87aec772ac244025$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $87aec772ac244025$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $87aec772ac244025$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $87aec772ac244025$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $87aec772ac244025$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $87aec772ac244025$var$performanceEventObserver;
var $87aec772ac244025$var$selectorConfig = {
    id: true,
    testId: true,
    role: true,
    className: true
};
function $87aec772ac244025$var$getTestIdName(memoizedProps) {
    if (memoizedProps["data-testid"]) return "[data-testid=".concat(memoizedProps["data-testid"], "]");
    else if (memoizedProps["data-test-id"]) return "[data-test-id=".concat(memoizedProps["data-testid"], "]");
    else if (memoizedProps["data-vc"]) return "[data-vc=".concat(memoizedProps["data-vc"], "]");
    return null;
}
function $87aec772ac244025$var$getUFOSegmentName(componentName, memoizedProps) {
    if (memoizedProps && memoizedProps["name"]) return "UFOSegment[name=".concat(memoizedProps["name"], "]");
    return componentName;
}
function $87aec772ac244025$var$getReactComponentHierarchy(element) {
    var componentHierarchy = [];
    // Function to traverse up the fiber tree
    function traverseFiber(fiber) {
        var currentFiber = fiber;
        while(currentFiber){
            if (currentFiber.type) {
                // Check if there's a display name or a function name
                var componentName = currentFiber.type.displayName || currentFiber.type.name;
                // checking when component name is bigger than the minimized name produced by react
                if (componentName && componentName.length > 2 && !componentName.includes("Listener") && !componentName.includes("Provider")) {
                    if (componentName === "UFOSegment") {
                        componentHierarchy.push($87aec772ac244025$var$getUFOSegmentName(componentName, currentFiber.memoizedProps));
                        break;
                    }
                    componentHierarchy.push(componentName);
                }
            }
            if (currentFiber.memoizedProps) {
                var dataIdInfo = $87aec772ac244025$var$getTestIdName(currentFiber.memoizedProps);
                if (dataIdInfo) {
                    componentHierarchy.push(dataIdInfo);
                    currentFiber = null;
                    continue;
                }
            }
            currentFiber = currentFiber.return;
        }
    }
    // Access the reactFiber node from the HTML element
    var reactFiberKey = Object.keys(element).find(function(key) {
        return key.startsWith("__reactFiber$");
    });
    if (reactFiberKey) {
        var fiber = element[reactFiberKey];
        traverseFiber(fiber);
    }
    return componentHierarchy.reverse().join(" > ");
}
var $87aec772ac244025$export$17afbba0f16b4b19 = function getPerformanceObserver() {
    $87aec772ac244025$var$performanceEventObserver = $87aec772ac244025$var$performanceEventObserver || new PerformanceObserver(function(entries) {
        var list = entries.getEntries();
        var _iterator = $87aec772ac244025$var$_createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var entry = _step.value;
                if (entry.name === "click") $87aec772ac244025$export$e6be05b411ce21a6(entry);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    });
    return $87aec772ac244025$var$performanceEventObserver;
};
var $87aec772ac244025$export$e6be05b411ce21a6 = function setInteractionPerformanceEvent(entry) {
    var interaction = (0, $hkP9U.getActiveInteraction)();
    if ((interaction === null || interaction === void 0 ? void 0 : interaction.type) === "press") {
        var _interaction$responsi;
        if (!((_interaction$responsi = interaction.responsiveness) !== null && _interaction$responsi !== void 0 && _interaction$responsi.experimentalInputToNextPaint)) {
            var _interaction$responsi2, _interaction$responsi3;
            interaction.responsiveness = $87aec772ac244025$var$_objectSpread($87aec772ac244025$var$_objectSpread({}, interaction.responsiveness), {}, {
                experimentalInputToNextPaint: ((_interaction$responsi2 = interaction.responsiveness) === null || _interaction$responsi2 === void 0 ? void 0 : _interaction$responsi2.experimentalInputToNextPaint) || entry.duration,
                inputDelay: ((_interaction$responsi3 = interaction.responsiveness) === null || _interaction$responsi3 === void 0 ? void 0 : _interaction$responsi3.inputDelay) || entry.processingStart - entry.startTime
            });
            if (interaction.ufoName === "unknown") {
                if (entry.target) {
                    var componentHierarchy = $87aec772ac244025$var$getReactComponentHierarchy(entry.target);
                    interaction.unknownElementHierarchy = componentHierarchy;
                }
                interaction.unknownElementName = (0, $92aee28523351788$export$2e2bcd8739ae039)($87aec772ac244025$var$selectorConfig, entry.target);
            }
        }
    }
};



var $iGJx8 = parcelRequire("iGJx8");

var $dqOGO = parcelRequire("dqOGO");

var $8pSiD = parcelRequire("8pSiD");

var $iSvIT = parcelRequire("iSvIT");

var $jxLBU = parcelRequire("jxLBU");

var $9jPnd = parcelRequire("9jPnd");

var $5zPyl = parcelRequire("5zPyl");

var $hkP9U = parcelRequire("hkP9U");

var $527WA = parcelRequire("527WA");
function $bdbf40b172c8a635$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bdbf40b172c8a635$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bdbf40b172c8a635$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bdbf40b172c8a635$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $bdbf40b172c8a635$var$sinkHandlerFn = function sinkHandlerFn() {};
function $bdbf40b172c8a635$export$e5fa3ac6dc44efff(fn) {
    $bdbf40b172c8a635$var$sinkHandlerFn = fn;
}
var $bdbf40b172c8a635$var$RELAY_NETWORK_ERRORS_NAME = "RelayNetwork";
var $bdbf40b172c8a635$export$1a949ef92fd30eca = function isRelayNetworkError(error) {
    return error.name === $bdbf40b172c8a635$var$RELAY_NETWORK_ERRORS_NAME;
};
var $bdbf40b172c8a635$var$isErrorObject = function isErrorObject(error) {
    return (0, $8pSiD.default)(error) === "object" && error !== null;
};
var $bdbf40b172c8a635$var$getErrorStatusCode = function getErrorStatusCode(error) {
    if (!$bdbf40b172c8a635$var$isErrorObject(error)) return undefined;
    if ($bdbf40b172c8a635$export$1a949ef92fd30eca(error)) {
        var _error$source;
        return (_error$source = error.source) === null || _error$source === void 0 || (_error$source = _error$source.errors) === null || _error$source === void 0 || (_error$source = _error$source[0]) === null || _error$source === void 0 || (_error$source = _error$source.extensions) === null || _error$source === void 0 ? void 0 : _error$source.statusCode;
    }
    if ("statusCode" in error && typeof error.statusCode === "number") return error.statusCode;
    return undefined;
};
var $bdbf40b172c8a635$var$getErrorTraceId = function getErrorTraceId(error) {
    return $bdbf40b172c8a635$var$isErrorObject(error) && "traceId" in error && typeof error.traceId === "string" ? error.traceId : undefined;
};
function $bdbf40b172c8a635$export$3e4fb24086cfb97a(error, additionalAttributes, labelStack) {
    var _error$message, _additionalAttributes, _getActiveTrace$trace, _getActiveTrace, _activeInteraction$uf, _activeInteraction$id, _activeInteraction$ty, _PreviousInteractionL, _PreviousInteractionL2, _PreviousInteractionL3, _UFORouteName$current;
    if (additionalAttributes !== null && additionalAttributes !== void 0 && additionalAttributes.isClientNetworkError) // Exclude client network errors from being reported to UFO
    return;
    var activeInteraction = (0, $hkP9U.getActiveInteraction)();
    var currentTime = performance.now();
    var baseErrorData = {
        errorType: error.name || "Error",
        errorMessage: ((_error$message = error.message) === null || _error$message === void 0 ? void 0 : _error$message.slice(0, 100)) || "Unknown error",
        timestamp: currentTime
    };
    var errorData = (0, $jxLBU.fg)("platform_ufo_terminal_errors_fix_missing_data") ? $bdbf40b172c8a635$var$_objectSpread($bdbf40b172c8a635$var$_objectSpread({}, baseErrorData), {}, {
        statusCode: (_additionalAttributes = additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.statusCode) !== null && _additionalAttributes !== void 0 ? _additionalAttributes : $bdbf40b172c8a635$var$getErrorStatusCode(error),
        // Fallback to traceId from error object if it exists (e.g. FetchError)
        traceId: (_getActiveTrace$trace = (_getActiveTrace = (0, $9jPnd.getActiveTrace)()) === null || _getActiveTrace === void 0 ? void 0 : _getActiveTrace.traceId) !== null && _getActiveTrace$trace !== void 0 ? _getActiveTrace$trace : $bdbf40b172c8a635$var$getErrorTraceId(error),
        teamName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.teamName,
        packageName: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.packageName,
        errorBoundaryId: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorBoundaryId,
        errorHash: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.errorHash,
        fallbackType: additionalAttributes === null || additionalAttributes === void 0 ? void 0 : additionalAttributes.fallbackType
    }) : $bdbf40b172c8a635$var$_objectSpread($bdbf40b172c8a635$var$_objectSpread({}, baseErrorData), additionalAttributes);
    // Calculate time since previous interaction
    var timeSincePreviousInteraction = (0, $hkP9U.PreviousInteractionLog).timestamp != null ? currentTime - (0, $hkP9U.PreviousInteractionLog).timestamp : null;
    var context = {
        labelStack: labelStack !== null && labelStack !== void 0 ? labelStack : null,
        activeInteractionName: (_activeInteraction$uf = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.ufoName) !== null && _activeInteraction$uf !== void 0 ? _activeInteraction$uf : null,
        activeInteractionId: (_activeInteraction$id = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.id) !== null && _activeInteraction$id !== void 0 ? _activeInteraction$id : null,
        activeInteractionType: (_activeInteraction$ty = activeInteraction === null || activeInteraction === void 0 ? void 0 : activeInteraction.type) !== null && _activeInteraction$ty !== void 0 ? _activeInteraction$ty : null,
        previousInteractionId: (_PreviousInteractionL = (0, $hkP9U.PreviousInteractionLog).id) !== null && _PreviousInteractionL !== void 0 ? _PreviousInteractionL : null,
        previousInteractionName: (_PreviousInteractionL2 = (0, $hkP9U.PreviousInteractionLog).name) !== null && _PreviousInteractionL2 !== void 0 ? _PreviousInteractionL2 : null,
        previousInteractionType: (_PreviousInteractionL3 = (0, $hkP9U.PreviousInteractionLog).type) !== null && _PreviousInteractionL3 !== void 0 ? _PreviousInteractionL3 : null,
        timeSincePreviousInteraction: timeSincePreviousInteraction,
        routeName: (_UFORouteName$current = (0, $527WA.default).current) !== null && _UFORouteName$current !== void 0 ? _UFORouteName$current : null
    };
    $bdbf40b172c8a635$var$sinkHandlerFn(errorData, context);
}
function $bdbf40b172c8a635$export$79ee0f0d40355053(error, additionalAttributes) {
    var interactionContext = (0, $5zPyl.useInteractionContext)();
    var hasReportedRef = (0, $iSvIT.useRef)(false);
    (0, $iSvIT.useEffect)(function() {
        if (error && !hasReportedRef.current) {
            hasReportedRef.current = true;
            $bdbf40b172c8a635$export$3e4fb24086cfb97a(error, additionalAttributes, interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack);
        }
    }, [
        error,
        additionalAttributes,
        interactionContext === null || interactionContext === void 0 ? void 0 : interactionContext.labelStack
    ]);
}



var $bgsrj = parcelRequire("bgsrj");

var $jxLBU = parcelRequire("jxLBU");
function $8826def9d323e3da$var$scheduleIdleCallback(work) {
    if (typeof window !== "undefined" && typeof window.requestIdleCallback === "function" && (0, $jxLBU.fg)("ufo_payload_use_idle_callback")) window.requestIdleCallback(work);
    else (0, $bgsrj.unstable_scheduleCallback)((0, $bgsrj.unstable_IdlePriority), work);
}
var $8826def9d323e3da$export$2e2bcd8739ae039 = $8826def9d323e3da$var$scheduleIdleCallback;


var $5d45b4c74211dc33$var$initialized = false;
function $5d45b4c74211dc33$var$sinkInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createPayloads(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === "function") devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $hkP9U.sinkInteractionHandler)(sinkFn);
}
function $5d45b4c74211dc33$var$sinkExperimentalInteractionMetrics(instance, payloadPackage) {
    function experimentalMetricsSinkFn(interactionId, interaction) {
        function experimentalMetricsOnIdle() {
            var payloadPromise = payloadPackage.createExperimentalMetricsPayload(interactionId, interaction);
            payloadPromise.then(function(payload) {
                if (payload) instance.sendOperationalEvent(payload);
            });
        }
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(experimentalMetricsOnIdle);
    }
    (0, $jyanA.sinkExperimentalHandler)(experimentalMetricsSinkFn);
}
function $5d45b4c74211dc33$var$sinkPostInteractionLog(instance, createPostInteractionLogPayload) {
    (0, $hkP9U.sinkPostInteractionLogHandler)(function(logOutput) {
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(function() {
            var payload = createPostInteractionLogPayload(logOutput);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5d45b4c74211dc33$var$sinkTerminalErrors(instance, createTerminalErrorPayload) {
    (0, $bdbf40b172c8a635$export$e5fa3ac6dc44efff)(function(errorData, context) {
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(function() {
            var payload = createTerminalErrorPayload(errorData, context);
            if (payload) instance.sendOperationalEvent(payload);
        });
    });
}
function $5d45b4c74211dc33$var$sinkInteractionExtraMetrics(instance, createInteractionExtraLogPayload) {
    (0, $hkP9U.interactionExtraMetrics).sinkHandler(function(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult) {
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $2sYxo.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).mark(function _callee() {
            var payload;
            return (0, (/*@__PURE__*/$parcel$interopDefault($aKGMT))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return createInteractionExtraLogPayload(interactionId, interaction, lastInteractionFinish, lastInteractionFinishVCResult);
                    case 2:
                        payload = _context.sent;
                        if (payload) instance.sendOperationalEvent(payload);
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    });
}
function $5d45b4c74211dc33$var$sinkExtraSearchPageInteraction(instance, payloadPackage) {
    function sinkFn(interactionId, interaction) {
        function onIdle() {
            payloadPackage.createExtraSearchPageInteractionPayload(interactionId, interaction).then(function(payloads) {
                // NOTE: This API is used by the UFO DevTool Chrome Extension and Criterion
                var devToolObserver = globalThis.__ufo_devtool_onUfoPayload;
                payloads === null || payloads === void 0 || payloads.forEach(function(payload) {
                    if (typeof devToolObserver === "function") devToolObserver === null || devToolObserver === void 0 || devToolObserver(payload);
                    instance.sendOperationalEvent(payload);
                });
            }).catch(function(error) {
                throw error;
            });
        }
        (0, $8826def9d323e3da$export$2e2bcd8739ae039)(onIdle);
    }
    (0, $gjbIv.sinkExtraSearchPageInteractionHandler)(sinkFn);
}




function $5d45b4c74211dc33$export$2cd8252107eb640b(analyticsWebClientAsync, config) {
    var _config$vc;
    if ($5d45b4c74211dc33$var$initialized) return;
    // Always set config first so isUFOEnabled() can check config.enabled
    (0, $bs6hr.setUFOConfig)(config);
    // If UFO is disabled via config, skip all initialization
    if (!(0, $bs6hr.isUFOEnabled)()) {
        $5d45b4c74211dc33$var$initialized = true;
        return;
    }
    // Initialize pressure observer for CPU usage monitoring
    (0, $iGJx8.initialisePressureObserver)();
    (0, $iGJx8.initialiseMemoryObserver)();
    if ((0, $jxLBU.fg)("platform_ufo_enable_otel_context_manager")) {
        // Configure global OTel context manager
        var contextManager = new (0, $fhH6n.UFOContextManager)();
        // set the contextmanager somewhere we can reference it later
        (0, $fhH6n.setContextManager)(contextManager);
        // Register the context manager with the global OTel API
        contextManager.enable();
        (0, $C3IJI.context).setGlobalContextManager(contextManager);
    }
    if ((_config$vc = config.vc) !== null && _config$vc !== void 0 && _config$vc.enabled) {
        var _config$experimentalI, _config$extraInteract;
        var vcOptions = {
            heatmapSize: config.vc.heatmapSize,
            oldDomUpdates: config.vc.oldDomUpdates,
            devToolsEnabled: config.vc.devToolsEnabled,
            selectorConfig: config.vc.selectorConfig,
            ssrEnablePageLayoutPlaceholder: config.vc.ssrEnablePageLayoutPlaceholder,
            trackLayoutShiftOffenders: config.vc.trackLayoutShiftOffenders
        };
        (0, $hkP9U.postInteractionLog).initializeVCObserver(vcOptions);
        if (config !== null && config !== void 0 && (_config$experimentalI = config.experimentalInteractionMetrics) !== null && _config$experimentalI !== void 0 && _config$experimentalI.enabled) (0, $jyanA.experimentalVC).initialize(vcOptions).start({
            startTime: 0
        });
        if (config !== null && config !== void 0 && (_config$extraInteract = config.extraInteractionMetrics) !== null && _config$extraInteract !== void 0 && _config$extraInteract.enabled) (0, $hkP9U.interactionExtraMetrics).initializeVCObserver(vcOptions);
    }
    (0, $2TVum.setupHiddenTimingCapture)();
    (0, $dB5ic.startLighthouseObserver)();
    (0, $2TVum.setupThrottleDetection)();
    $5d45b4c74211dc33$var$initialized = true;
    if (typeof PerformanceObserver !== "undefined") {
        var observer = (0, $87aec772ac244025$export$17afbba0f16b4b19)();
        observer.observe({
            type: "event",
            buffered: true,
            durationThreshold: 16
        });
    }
    Promise.all([
        analyticsWebClientAsync,
        (parcelRequire("kqzaL")),
        (parcelRequire("1fAwT")),
        (parcelRequire("cuj5u")),
        (parcelRequire("h7Bj2"))
    ]).then(function(_ref2) {
        var _ref3 = (0, $jzYu7.default)(_ref2, 5), awc = _ref3[0], payloadPackage = _ref3[1], createPostInteractionLogPayloadPackage = _ref3[2], createInteractionExtraMetricsPayloadPackage = _ref3[3], createTerminalErrorPayloadPackage = _ref3[4];
        if (awc.getAnalyticsWebClientPromise) awc.getAnalyticsWebClientPromise().then(function(client) {
            var _config$terminalError, _config$experimentalI2, _config$postInteracti, _config$extraInteract2, _config$extraSearchPa;
            var instance = client.getInstance();
            $5d45b4c74211dc33$var$sinkInteraction(instance, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError = config.terminalErrors) !== null && _config$terminalError !== void 0 && _config$terminalError.enabled && (0, $jxLBU.fg)("platform_ufo_enable_terminal_errors")) $5d45b4c74211dc33$var$sinkTerminalErrors(instance, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI2 = config.experimentalInteractionMetrics) !== null && _config$experimentalI2 !== void 0 && _config$experimentalI2.enabled) $5d45b4c74211dc33$var$sinkExperimentalInteractionMetrics(instance, payloadPackage);
            if ((_config$postInteracti = config.postInteractionLog) !== null && _config$postInteracti !== void 0 && _config$postInteracti.enabled) $5d45b4c74211dc33$var$sinkPostInteractionLog(instance, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract2 = config.extraInteractionMetrics) !== null && _config$extraInteract2 !== void 0 && _config$extraInteract2.enabled) $5d45b4c74211dc33$var$sinkInteractionExtraMetrics(instance, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa = config.extraSearchPageInteraction) !== null && _config$extraSearchPa !== void 0 && _config$extraSearchPa.enabled) $5d45b4c74211dc33$var$sinkExtraSearchPageInteraction(instance, payloadPackage);
        });
        else if (awc.sendOperationalEvent) {
            var _config$terminalError2, _config$experimentalI3, _config$postInteracti2, _config$extraInteract3, _config$extraSearchPa2;
            $5d45b4c74211dc33$var$sinkInteraction(awc, payloadPackage);
            if (config !== null && config !== void 0 && (_config$terminalError2 = config.terminalErrors) !== null && _config$terminalError2 !== void 0 && _config$terminalError2.enabled && (0, $jxLBU.fg)("platform_ufo_enable_terminal_errors")) $5d45b4c74211dc33$var$sinkTerminalErrors(awc, createTerminalErrorPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$experimentalI3 = config.experimentalInteractionMetrics) !== null && _config$experimentalI3 !== void 0 && _config$experimentalI3.enabled) $5d45b4c74211dc33$var$sinkExperimentalInteractionMetrics(awc, payloadPackage);
            if ((_config$postInteracti2 = config.postInteractionLog) !== null && _config$postInteracti2 !== void 0 && _config$postInteracti2.enabled) $5d45b4c74211dc33$var$sinkPostInteractionLog(awc, createPostInteractionLogPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraInteract3 = config.extraInteractionMetrics) !== null && _config$extraInteract3 !== void 0 && _config$extraInteract3.enabled) $5d45b4c74211dc33$var$sinkInteractionExtraMetrics(awc, createInteractionExtraMetricsPayloadPackage.default);
            if (config !== null && config !== void 0 && (_config$extraSearchPa2 = config.extraSearchPageInteraction) !== null && _config$extraSearchPa2 !== void 0 && _config$extraSearchPa2.enabled) $5d45b4c74211dc33$var$sinkExtraSearchPageInteraction(awc, payloadPackage);
        }
    });
}



var $exI7W = parcelRequire("exI7W");
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $k18d6 = parcelRequire("k18d6");

var $2J5Gv = parcelRequire("2J5Gv");

var $bs6hr = parcelRequire("bs6hr");

var $9jPnd = parcelRequire("9jPnd");

var $4CDPb = parcelRequire("4CDPb");

var $hkP9U = parcelRequire("hkP9U");

var $527WA = parcelRequire("527WA");
var $b96d15fdf8c6470f$var$AWAITING_PAGELOAD_NAME = "awaiting_pageload_name";
function $b96d15fdf8c6470f$var$traceUFOPageLoad(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    if (!(0, $bs6hr.isUFOEnabled)()) return;
    var activeInteraction = (0, $hkP9U.getActiveInteraction)();
    if (activeInteraction && !ufoName) return;
    (0, $527WA.default).current = routeName || null;
    var rate = ufoName ? (0, $bs6hr.getInteractionRate)(ufoName, "page_load") : 1;
    var enabledBySamplingRate = (0, $2J5Gv.default)(rate);
    if (enabledBySamplingRate && !activeInteraction) {
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        var newId = (0, $k18d6.v4)();
        (0, $4CDPb.DefaultInteractionID).current = newId;
        (0, $hkP9U.addNewInteraction)(newId, ufoName || "", "page_load", 0, rate, null, routeName, (0, $9jPnd.getActiveTrace)());
        if (!ufoName) // if no name is provided we add a hold to the interaction, it is removed if the name is provided while the interaction is holding
        (0, $hkP9U.addHoldByID)(newId, [], $b96d15fdf8c6470f$var$AWAITING_PAGELOAD_NAME, $b96d15fdf8c6470f$var$AWAITING_PAGELOAD_NAME, true);
    } else if (!enabledBySamplingRate && activeInteraction && activeInteraction.type === "page_load") // if there is an active interaction it will be aborted without initialising a new one because the coinflip returned false
    (0, $hkP9U.abort)(activeInteraction.id, "excluded_by_sampling");
    else if (ufoName && activeInteraction && !activeInteraction.ufoName && activeInteraction.type === "page_load") {
        (0, $hkP9U.updatePageLoadInteractionName)(ufoName, routeName);
        (0, $hkP9U.removeHoldByID)(activeInteraction.id, $b96d15fdf8c6470f$var$AWAITING_PAGELOAD_NAME);
    }
}
var $b96d15fdf8c6470f$export$2e2bcd8739ae039 = $b96d15fdf8c6470f$var$traceUFOPageLoad;
function $b96d15fdf8c6470f$export$d0f99433cd4f4028(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    if (!(0, $bs6hr.isUFOEnabled)()) return;
    var interaction = (0, $hkP9U.getActiveInteraction)();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    if (ufoName) {
        var rate = (0, $bs6hr.getInteractionRate)(ufoName, "page_load");
        (0, $hkP9U.updatePageLoadInteractionName)(ufoName, routeName);
        if ((0, $2J5Gv.default)(rate)) (0, $527WA.default).current = ufoName;
        else (0, $hkP9U.abort)(interaction.id, "excluded_by_sampling");
    }
    (0, $hkP9U.removeHoldByID)(interaction.id, $b96d15fdf8c6470f$var$AWAITING_PAGELOAD_NAME);
}


var $ee5a49db34875069$exports = {};
"use strict";
var $418ab7c9dfb70ff8$exports = {};
"use strict";
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $418ab7c9dfb70ff8$exports = function required(port, protocol) {
    protocol = protocol.split(":")[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case "http":
        case "ws":
            return port !== 80;
        case "https":
        case "wss":
            return port !== 443;
        case "ftp":
            return port !== 21;
        case "gopher":
            return port !== 70;
        case "file":
            return false;
    }
    return port !== 0;
};


var $c761a9e8131993fc$exports = {};

$parcel$export($c761a9e8131993fc$exports, "stringify", function () { return $c761a9e8131993fc$export$fac44ee5b035f737; }, function (v) { return $c761a9e8131993fc$export$fac44ee5b035f737 = v; });
$parcel$export($c761a9e8131993fc$exports, "parse", function () { return $c761a9e8131993fc$export$98e6a39c04603d36; }, function (v) { return $c761a9e8131993fc$export$98e6a39c04603d36 = v; });
//
// Expose the module.
//
var $c761a9e8131993fc$export$fac44ee5b035f737;
var $c761a9e8131993fc$export$98e6a39c04603d36;
"use strict";
var $c761a9e8131993fc$var$has = Object.prototype.hasOwnProperty, $c761a9e8131993fc$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $c761a9e8131993fc$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, " "));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $c761a9e8131993fc$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $c761a9e8131993fc$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $c761a9e8131993fc$var$decode(part[1]), value = $c761a9e8131993fc$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $c761a9e8131993fc$var$querystringify(obj, prefix) {
    prefix = prefix || "";
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ("string" !== typeof prefix) prefix = "?";
    for(key in obj)if ($c761a9e8131993fc$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $c761a9e8131993fc$var$undef || isNaN(value))) value = "";
        key = $c761a9e8131993fc$var$encode(key);
        value = $c761a9e8131993fc$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + "=" + value);
    }
    return pairs.length ? prefix + pairs.join("&") : "";
}
$c761a9e8131993fc$export$fac44ee5b035f737 = $c761a9e8131993fc$var$querystringify;
$c761a9e8131993fc$export$98e6a39c04603d36 = $c761a9e8131993fc$var$querystring;


var $ee5a49db34875069$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $ee5a49db34875069$var$CRHTLF = /[\n\r\t]/g, $ee5a49db34875069$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $ee5a49db34875069$var$port = /:\d+$/, $ee5a49db34875069$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $ee5a49db34875069$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $ee5a49db34875069$var$trimLeft(str) {
    return (str ? str : "").toString().replace($ee5a49db34875069$var$controlOrWhitespace, "");
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $ee5a49db34875069$var$rules = [
    [
        "#",
        "hash"
    ],
    [
        "?",
        "query"
    ],
    function sanitize(address, url) {
        return $ee5a49db34875069$var$isSpecial(url.protocol) ? address.replace(/\\/g, "/") : address;
    },
    [
        "/",
        "pathname"
    ],
    [
        "@",
        "auth",
        1
    ],
    [
        NaN,
        "host",
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        "port",
        undefined,
        1
    ],
    [
        NaN,
        "hostname",
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $ee5a49db34875069$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $ee5a49db34875069$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== "undefined") globalVar = window;
    else if (typeof $parcel$global !== "undefined") globalVar = $parcel$global;
    else if (typeof self !== "undefined") globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ("blob:" === loc.protocol) finaldestination = new $ee5a49db34875069$var$Url(unescape(loc.pathname), {});
    else if ("string" === type) {
        finaldestination = new $ee5a49db34875069$var$Url(loc, {});
        for(key in $ee5a49db34875069$var$ignore)delete finaldestination[key];
    } else if ("object" === type) {
        for(key in loc){
            if (key in $ee5a49db34875069$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $ee5a49db34875069$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $ee5a49db34875069$var$isSpecial(scheme) {
    return scheme === "file:" || scheme === "ftp:" || scheme === "http:" || scheme === "https:" || scheme === "ws:" || scheme === "wss:";
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $ee5a49db34875069$var$extractProtocol(address, location) {
    address = $ee5a49db34875069$var$trimLeft(address);
    address = address.replace($ee5a49db34875069$var$CRHTLF, "");
    location = location || {};
    var match = $ee5a49db34875069$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : "";
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === "file:") {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($ee5a49db34875069$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $ee5a49db34875069$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $ee5a49db34875069$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $ee5a49db34875069$var$resolve(relative, base) {
    if (relative === "") return base;
    var path = (base || "/").split("/").slice(0, -1).concat(relative.split("/")), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === ".") path.splice(i, 1);
        else if (path[i] === "..") {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift("");
    if (last === "." || last === "..") path.push("");
    return path.join("/");
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $ee5a49db34875069$var$Url(address, location, parser) {
    address = $ee5a49db34875069$var$trimLeft(address);
    address = address.replace($ee5a49db34875069$var$CRHTLF, "");
    if (!(this instanceof $ee5a49db34875069$var$Url)) return new $ee5a49db34875069$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $ee5a49db34875069$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ("object" !== type && "string" !== type) {
        parser = location;
        location = null;
    }
    if (parser && "function" !== typeof parser) parser = $c761a9e8131993fc$exports.parse;
    location = $ee5a49db34875069$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $ee5a49db34875069$var$extractProtocol(address || "", location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || "";
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === "file:" && (extracted.slashesCount !== 2 || $ee5a49db34875069$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$ee5a49db34875069$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        "pathname"
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === "function") {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ("string" === typeof parse) {
            index = parse === "@" ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ("number" === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || "" : "");
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== "/" && (url.pathname !== "" || location.pathname !== "")) url.pathname = $ee5a49db34875069$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== "/" && $ee5a49db34875069$var$isSpecial(url.protocol)) url.pathname = "/" + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$418ab7c9dfb70ff8$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = "";
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = "";
    if (url.auth) {
        index = url.auth.indexOf(":");
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ":" + url.password : url.username;
    }
    url.origin = url.protocol !== "file:" && $ee5a49db34875069$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $ee5a49db34875069$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case "query":
            if ("string" === typeof value && value.length) value = (fn || $c761a9e8131993fc$exports.parse)(value);
            url[part] = value;
            break;
        case "port":
            url[part] = value;
            if (!$418ab7c9dfb70ff8$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = "";
            } else if (value) url.host = url.hostname + ":" + value;
            break;
        case "hostname":
            url[part] = value;
            if (url.port) value += ":" + url.port;
            url.host = value;
            break;
        case "host":
            url[part] = value;
            if ($ee5a49db34875069$var$port.test(value)) {
                value = value.split(":");
                url.port = value.pop();
                url.hostname = value.join(":");
            } else {
                url.hostname = value;
                url.port = "";
            }
            break;
        case "protocol":
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case "pathname":
        case "hash":
            if (value) {
                var char = part === "pathname" ? "/" : "#";
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case "username":
        case "password":
            url[part] = encodeURIComponent(value);
            break;
        case "auth":
            var index = value.indexOf(":");
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $ee5a49db34875069$var$rules.length; i++){
        var ins = $ee5a49db34875069$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ":" + url.password : url.username;
    url.origin = url.protocol !== "file:" && $ee5a49db34875069$var$isSpecial(url.protocol) && url.host ? url.protocol + "//" + url.host : "null";
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $ee5a49db34875069$var$toString(stringify) {
    if (!stringify || "function" !== typeof stringify) stringify = $c761a9e8131993fc$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ":") protocol += ":";
    var result = protocol + (url.protocol && url.slashes || $ee5a49db34875069$var$isSpecial(url.protocol) ? "//" : "");
    if (url.username) {
        result += url.username;
        if (url.password) result += ":" + url.password;
        result += "@";
    } else if (url.password) {
        result += ":" + url.password;
        result += "@";
    } else if (url.protocol !== "file:" && $ee5a49db34875069$var$isSpecial(url.protocol) && !host && url.pathname !== "/") //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += "@";
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ":" || $ee5a49db34875069$var$port.test(url.hostname) && !url.port) host += ":";
    result += host + url.pathname;
    query = "object" === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += "?" !== query.charAt(0) ? "?" + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$ee5a49db34875069$var$Url.prototype = {
    set: $ee5a49db34875069$var$set,
    toString: $ee5a49db34875069$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$ee5a49db34875069$var$Url.extractProtocol = $ee5a49db34875069$var$extractProtocol;
$ee5a49db34875069$var$Url.location = $ee5a49db34875069$var$lolcation;
$ee5a49db34875069$var$Url.trimLeft = $ee5a49db34875069$var$trimLeft;
$ee5a49db34875069$var$Url.qs = $c761a9e8131993fc$exports;
$ee5a49db34875069$exports = $ee5a49db34875069$var$Url;


/**
 * Resource timing configuration for Trello UFO
 * Filters and sanitizes resource URLs before UFO captures them
 */ // Sanitize endpoints: replace UUIDs and IDs with placeholders
const $2abc08fc6bbf0d83$var$sanitiseEndpoints = (url)=>{
    try {
        const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($ee5a49db34875069$exports)))(url, true);
        const fileName = parsedUrl.pathname.replace(/[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}/gi, "<uuid>").replace(/\/\d+$/i, "/<id>");
        return fileName || null;
    } catch  {
        return null;
    }
};
// Map resource names for better readability
const $2abc08fc6bbf0d83$var$mapResources = (url)=>{
    try {
        if (url.includes("/gasv3/")) return "gasv3";
        if (url.includes("/analytics/")) return "analytics";
        if (url.includes("bifrost")) return "bifrost-assets";
        if (url.includes("stargate")) return "stargate-graphql";
        if (url.includes("atl-global")) return "atl-global";
        return $2abc08fc6bbf0d83$var$sanitiseEndpoints(url);
    } catch  {
        return null;
    }
};
// Check if resource has timing headers
const $2abc08fc6bbf0d83$var$hasTimingHeaders = (url)=>{
    // Track analytics, API calls, assets
    if (url.includes("/gasv3/") || url.includes("/analytics/") || url.includes("bifrost") || url.includes("stargate")) return true;
    return false;
};
// Filter XHR traffic
const $2abc08fc6bbf0d83$var$xhrFilter = (url)=>{
    // Track analytics, API calls, assets
    if (url.includes("/gasv3/") || url.includes("/analytics/") || url.includes("bifrost") || url.includes("stargate")) return true;
    return false;
};
function $2abc08fc6bbf0d83$export$d36bb5b27a3db2f8() {
    return {
        sanitiseEndpoints: $2abc08fc6bbf0d83$var$sanitiseEndpoints,
        mapResources: $2abc08fc6bbf0d83$var$mapResources,
        hasTimingHeaders: $2abc08fc6bbf0d83$var$hasTimingHeaders,
        xhrFilter: $2abc08fc6bbf0d83$var$xhrFilter
    };
}


let $163dd4a6d5327e25$var$isReactUFOInitialized = false;
const $163dd4a6d5327e25$var$config = {
    product: "trello",
    region: "unknown",
    kind: {
        page_load: 1,
        transition: 1,
        hover: 0,
        legacy: 1,
        typing: 0,
        press: 1
    },
    capability: {
        feature_flag_access: 100,
        react_profiler: 1
    },
    segmentPrefix: "ufo-",
    typingMethod: "timeout",
    vc: {
        enabled: true,
        heatmapSize: 200,
        oldDomUpdates: false,
        devToolsEnabled: true,
        selectorConfig: {
            id: false,
            role: true,
            className: true,
            testId: true
        }
    }
};
const $163dd4a6d5327e25$export$a0d0fe4ddcfb7311 = (analyticsClient, path)=>{
    if ($163dd4a6d5327e25$var$isReactUFOInitialized) return;
    try {
        (0, $exI7W.configure)((0, $2abc08fc6bbf0d83$export$d36bb5b27a3db2f8)());
        (0, $5d45b4c74211dc33$export$2cd8252107eb640b)(Promise.resolve(analyticsClient), $163dd4a6d5327e25$var$config);
        $163dd4a6d5327e25$var$isReactUFOInitialized = true;
        const routeKey = path.replace(/^\//, "").split("/")[0] || "home";
        const experienceName = `trello-portal-${routeKey}-load`;
        const normalizedPath = path.startsWith("/") ? path : `/${path}`;
        (0, $b96d15fdf8c6470f$export$2e2bcd8739ae039)(experienceName, normalizedPath);
        if (typeof window !== "undefined") {
            window.__ufoDebug = {
                setupAttemptedAt: Date.now(),
                initialized: true,
                initializedAt: Date.now(),
                hasAnalyticsClient: true
            };
            window.__ufoTrelloDebug = {
                trackedAt: Date.now(),
                path: path,
                experienceName: experienceName
            };
        }
    } catch (error) {
        console.error("[UFO Trello] Setup failed:", error);
    }
};
const $163dd4a6d5327e25$export$510e70d7181604a8 = /*#__PURE__*/ (0, $iSvIT.memo)(()=>null);
$163dd4a6d5327e25$export$510e70d7181604a8.displayName = "InitUFOTrello";



var $cExkZ = parcelRequire("cExkZ");
// @ts-nocheck - layout.tsx uses wac-web dependencies (@/) which are outside rootDir

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");


var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");










var $iSvIT = parcelRequire("iSvIT");

var $4J1z5 = parcelRequire("4J1z5");

var $lEO1D = parcelRequire("lEO1D");
function $f4471df31bd79056$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f4471df31bd79056$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $63f2a10b9e4b0779$export$2e2bcd8739ae039)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c9862f14105c0820$export$2e2bcd8739ae039)(this, result);
    };
}
function $f4471df31bd79056$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f4471df31bd79056$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4J1z5))).func
};
var $f4471df31bd79056$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f4471df31bd79056$var$AnalyticsListener = /*#__PURE__*/ function(_Component) {
    (0, $e99985525351953a$export$2e2bcd8739ae039)(AnalyticsListener, _Component);
    var _super = $f4471df31bd79056$var$_createSuper(AnalyticsListener);
    function AnalyticsListener(props) {
        var _this;
        (0, $4b1df5cc5052334c$export$2e2bcd8739ae039)(this, AnalyticsListener);
        _this = _super.call(this, props);
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext
            };
        });
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "getAnalyticsEventHandlers", function() {
            var _this$props = _this.props, channel = _this$props.channel, onEvent = _this$props.onEvent;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla === void 0 ? $f4471df31bd79056$var$noop : _this$context$getAtla;
            var handler = function handler(event, eventChannel) {
                if (channel === "*" || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler
            ].concat((0, $3a0da52d64e885cc$export$2e2bcd8739ae039)(getAtlaskitAnalyticsEventHandlers()));
        });
        (0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)((0, $d614dfe438fd8b4e$export$2e2bcd8739ae039)(_this), "getAtlaskitAnalyticsContext", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla2 === void 0 ? $f4471df31bd79056$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsContext();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $735859b934da068c$export$2e2bcd8739ae039)(AnalyticsListener, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsListener;
}((0, $iSvIT.Component));
(0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)($f4471df31bd79056$var$AnalyticsListener, "contextTypes", $f4471df31bd79056$var$ContextTypes);
(0, $4f3cde5c9cb9c65a$export$2e2bcd8739ae039)($f4471df31bd79056$var$AnalyticsListener, "childContextTypes", $f4471df31bd79056$var$ContextTypes);
var $f4471df31bd79056$export$2e2bcd8739ae039 = $f4471df31bd79056$var$AnalyticsListener;




var $iSvIT = parcelRequire("iSvIT");

var $lEO1D = parcelRequire("lEO1D");


var $iSvIT = parcelRequire("iSvIT");
var $678a78c13bc6d3c2$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $iSvIT.useRef)(value);
    (0, $iSvIT.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};


var $6778e8c1634fb537$var$AnalyticsListener = function AnalyticsListener(_ref) {
    var children = _ref.children, channel = _ref.channel, onEvent = _ref.onEvent;
    var analyticsContext = (0, $3e2d3fe0a97f2dff$export$d1f587f82ad51c4)();
    var onEventRef = (0, $678a78c13bc6d3c2$export$1d27a74659855e44)(onEvent);
    var channelRef = (0, $678a78c13bc6d3c2$export$1d27a74659855e44)(channel);
    var getAtlaskitAnalyticsEventHandlers = (0, $iSvIT.useCallback)(function() {
        var thisHandler = function thisHandler(event, eventChannel) {
            if (channelRef.current === "*" || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [].concat((0, $3a0da52d64e885cc$export$2e2bcd8739ae039)(analyticsContext.getAtlaskitAnalyticsEventHandlers()), [
            thisHandler
        ]);
    }, [
        analyticsContext,
        channelRef,
        onEventRef
    ]);
    var value = (0, $iSvIT.useMemo)(function() {
        return {
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
            getAtlaskitAnalyticsContext: analyticsContext.getAtlaskitAnalyticsContext
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $lEO1D.default).Provider, {
        value: value
    }, children);
};
var $6778e8c1634fb537$export$2e2bcd8739ae039 = $6778e8c1634fb537$var$AnalyticsListener;



var $XAEGR = parcelRequire("XAEGR");
var $aebb4b99b8aa446d$var$_process$env;
var $aebb4b99b8aa446d$var$ExportedAnalyticsListener;
if (typeof $XAEGR !== "undefined" && $XAEGR !== null && ($aebb4b99b8aa446d$var$_process$env = {}, true) && $aebb4b99b8aa446d$var$_process$env !== void 0 && $aebb4b99b8aa446d$var$_process$env["ANALYTICS_NEXT_MODERN_CONTEXT"]) $aebb4b99b8aa446d$var$ExportedAnalyticsListener = (0, $6778e8c1634fb537$export$2e2bcd8739ae039);
else $aebb4b99b8aa446d$var$ExportedAnalyticsListener = (0, $f4471df31bd79056$export$2e2bcd8739ae039);
var $aebb4b99b8aa446d$export$2e2bcd8739ae039 = $aebb4b99b8aa446d$var$ExportedAnalyticsListener;








const $3ac8e320c32641d0$export$cc11fd4b7198f590 = ({ children: children })=>{
    const analyticsClient = (0, $9e7dba6014f411d3$export$923054f18cb06572)();
    const { analyticsOptOut: analyticsOptOut, isConsentLoaded: isConsentLoaded } = (0, $d4ee4c82e6c358af$export$b224af886b957a5e)();
    const [loginUserDetected, setLoginUserDetected] = (0, $iSvIT.useState)("false");
    const queueRef = (0, $iSvIT.useRef)([]);
    const traceIdRef = (0, $iSvIT.useRef)(null);
    const isEnableOperationalEventWhenOptedOut = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).gwp10416DisableNonOperationalAnalyticsGateUip);
    const isReady = isEnableOperationalEventWhenOptedOut ? Boolean(analyticsClient && isConsentLoaded) : Boolean(analyticsClient);
    (0, $iSvIT.useEffect)(()=>{
        const isVoltronMultiTouchEnabled = (0, $ed1e206bdea25d53$export$3331b5930c252bb2)((0, $206c60391d5bfbc4$export$e62953d023125748).voltronMultiTouchAnalytics);
        if (isVoltronMultiTouchEnabled) {
            const generatedTraceId = (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)();
            traceIdRef.current = generatedTraceId;
            localStorage.setItem("trace_id", generatedTraceId);
        }
    }, []);
    (0, $iSvIT.useEffect)(()=>{
        const cookieValue = (0, $0c0b6320f31ec5e5$export$bd0cf18531183c14).readCookie("login_user_detected");
        if (cookieValue) setLoginUserDetected(cookieValue);
    }, []);
    const flush = (0, $iSvIT.useCallback)((payload, context, channel)=>{
        if (!analyticsClient) return;
        if (isEnableOperationalEventWhenOptedOut && analyticsOptOut && payload?.["eventType"] !== "operational") return;
        const traceid = traceIdRef.current;
        if (channel === "signup") {
            const analyticsDataList = [
                ...context,
                payload
            ];
            const analyticsEventMagnolia = analyticsDataList.reduce((mergedAnalyticsEvent, currentAnalyicsEvent)=>{
                return {
                    ...mergedAnalyticsEvent,
                    ...currentAnalyicsEvent,
                    ...traceid ? {
                        trace_id: traceid
                    } : {}
                };
            }, {});
            (0, $b79cfbdb59125f3c$export$3672a9a17fd672c4).trackEvent(analyticsEventMagnolia["eventName"], analyticsEventMagnolia);
            return;
        }
        const processedEventPayload = {
            actionSubject: "component",
            eventType: "ui",
            source: "default",
            ...payload,
            attributes: {
                ...payload?.["attributes"] || {},
                loginUserDetected: loginUserDetected,
                ...traceid ? {
                    trace_id: traceid
                } : {}
            }
        };
        if (!!window?.cmsPageVariant) processedEventPayload["attributes"].cmsPageVariant = window.cmsPageVariant;
        const ANALYTICS_TYPE = "gasv3";
        if (ANALYTICS_TYPE === "console") console.log({
            event: processedEventPayload
        });
        analyticsClient.onEvent(null, processedEventPayload);
    }, [
        analyticsClient,
        analyticsOptOut,
        loginUserDetected
    ]);
    (0, $iSvIT.useEffect)(()=>{
        if (!isReady || queueRef.current.length === 0) return;
        const q = queueRef.current;
        queueRef.current = [];
        q.forEach(({ payload: payload, context: context, channel: channel })=>flush(payload, context, channel));
    }, [
        isReady,
        flush
    ]);
    const onEvent = (0, $iSvIT.useCallback)((event, channel)=>{
        if (!isReady) {
            queueRef.current.push({
                payload: event.payload,
                context: event.context,
                channel: channel
            });
            return;
        }
        flush(event.payload, event.context, channel);
    }, [
        isReady,
        flush
    ]);
    return(/**
     * Current channels are:
     * - atl-global: For all auto-generated events from InitializeAutoAtlAnalytics
     * - marketing: For events generated via the React components themselves
     *
     * TODO - can add in the FabricEventsListeners to catch atlasKit and fabric components etc.
     */ /*#__PURE__*/ (0, $loA2J.jsx)((0, $aebb4b99b8aa446d$export$2e2bcd8739ae039), {
        channel: "*",
        onEvent: onEvent,
        children: children
    }));
};



var $loA2J = parcelRequire("loA2J");
// Data Plugin definition and utility types
var $7ed7b8e1acf8aa7c$export$a235a73f7b906dce = {
    GetContainers: "GetContainers",
    GetUsers: "GetUsers",
    GetSuggestedSiteNames: "GetSuggestedSiteNames",
    GetAvailableSites: "GetAvailableSites"
};
var $7ed7b8e1acf8aa7c$export$6e383182a26455ff = {
    BITBUCKET_WORKSPACE: "bitbucket-workspace",
    ATLASSIAN_CLOUD_ID: "ATLASSIAN_CLOUD_ID",
    JIRA_SOFTWARE_PROJECT: "JIRA_SOFTWARE_PROJECT"
};
var $7ed7b8e1acf8aa7c$export$e391bab95adb8396 = {
    ATLASSIAN_ACCOUNT_ID: "ATLASSIAN_ACCOUNT_ID",
    TRELLO_ID: "TRELLO_ID"
};
var $7ed7b8e1acf8aa7c$export$4f378ba35c571906 = {
    JIRA_BUSINESS: "JIRA_BUSINESS",
    JIRA_SERVICE_DESK: "JIRA_SERVICE_DESK",
    JIRA_SOFTWARE: "JIRA_SOFTWARE",
    CONFLUENCE: "CONFLUENCE",
    OPSGENIE: "OPSGENIE",
    BITBUCKET: "BITBUCKET",
    STATUSPAGE: "STATUSPAGE",
    TRELLO: "TRELLO",
    COMPASS: "COMPASS"
};


var $3cae5b2c0dd1938b$export$76378b0f825c024c = function createGetContainersPlugin(fetch) {
    return [
        (0, $7ed7b8e1acf8aa7c$export$a235a73f7b906dce).GetContainers,
        fetch
    ];
};
var $3cae5b2c0dd1938b$export$8feb7eae83cf8cd5 = function createGetUsersPlugin(fetch) {
    return [
        (0, $7ed7b8e1acf8aa7c$export$a235a73f7b906dce).GetUsers,
        fetch
    ];
};
var $3cae5b2c0dd1938b$export$21d120847be2aff4 = function createGetSuggestedSiteNamesPlugin(fetch) {
    return [
        (0, $7ed7b8e1acf8aa7c$export$a235a73f7b906dce).GetSuggestedSiteNames,
        fetch
    ];
};
var $3cae5b2c0dd1938b$export$d7c1699c6a2ca18a = function createGetAvailableSitesPlugin(fetch) {
    return [
        (0, $7ed7b8e1acf8aa7c$export$a235a73f7b906dce).GetAvailableSites,
        fetch
    ];
};


const $d35e3d0a4d82e921$var$getUsers = async (containerId)=>{
    const getUsersUrl = `/gateway/api/xflow/${containerId}/fetch-instance-users`;
    try {
        const response = await fetch(getUsersUrl, {
            credentials: "same-origin"
        });
        if (response.ok) {
            const data = await response.json();
            return data.map((value)=>({
                    id: value.id,
                    idType: (0, $7ed7b8e1acf8aa7c$export$e391bab95adb8396).ATLASSIAN_ACCOUNT_ID,
                    displayName: value.displayName
                }));
        }
        throw new Error(`Unexpected response from ${getUsersUrl} ${response.status} ${response.statusText}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Unable to fetch ${getUsersUrl} ${error.message}`);
    }
};
const $d35e3d0a4d82e921$export$7c44908d2777db01 = (0, $3cae5b2c0dd1938b$export$8feb7eae83cf8cd5)($d35e3d0a4d82e921$var$getUsers);



var $l3uAP = parcelRequire("l3uAP");

var $iSvIT = parcelRequire("iSvIT");

var $l3uAP = parcelRequire("l3uAP");

var $kl0zZ = parcelRequire("kl0zZ");

var $j6P2N = parcelRequire("j6P2N");

var $9H5Ac = parcelRequire("9H5Ac");

var $iSvIT = parcelRequire("iSvIT");
parcelRequire("aYNGK");
var $kQFoP = parcelRequire("kQFoP");
var $eWlfK = parcelRequire("eWlfK");

var $kl0zZ = parcelRequire("kl0zZ");

var $l4Fg9 = parcelRequire("l4Fg9");

var $jxLBU = parcelRequire("jxLBU");
var $06fd699b5d2e9974$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
/**
 * Contrast preferences: The system contrast preference
 */ var $06fd699b5d2e9974$var$themeContrastModes = [
    "more",
    "no-preference",
    "auto"
];
var $06fd699b5d2e9974$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
/**
 * Theme override ids: the equivalent of themeIds for theme overrides.
 * Theme overrides are temporary and there may not be any defined at times.
 */ var $06fd699b5d2e9974$var$themeOverrideIds = [];
var $06fd699b5d2e9974$export$92ba366331403db2 = [].concat($06fd699b5d2e9974$export$7d43e72a58e3283f, $06fd699b5d2e9974$var$themeOverrideIds);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $06fd699b5d2e9974$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $06fd699b5d2e9974$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $jxLBU.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $06fd699b5d2e9974$export$2e2bcd8739ae039 = $06fd699b5d2e9974$var$themeConfig;



var $7MLDa = parcelRequire("7MLDa");

var $j6P2N = parcelRequire("j6P2N");

var $6815627abd9b7b21$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $6815627abd9b7b21$var$customThemeOptions = "UNSAFE_themeOptions";
var $6815627abd9b7b21$var$isThemeKind = function isThemeKind(themeKind) {
    return $6815627abd9b7b21$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $6815627abd9b7b21$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $06fd699b5d2e9974$export$7d43e72a58e3283f).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $6815627abd9b7b21$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $6815627abd9b7b21$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([^]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, $j6P2N.default)(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $6815627abd9b7b21$var$isColorMode(id)) themeObject[kind] = id;
        if ($6815627abd9b7b21$var$isThemeKind(kind) && $6815627abd9b7b21$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $6815627abd9b7b21$var$customThemeOptions) try {
            themeObject[$6815627abd9b7b21$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $6815627abd9b7b21$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, $j6P2N.default)(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $6815627abd9b7b21$var$isColorMode(id) || // custom theme state
        kind === $6815627abd9b7b21$var$customThemeOptions && (0, $7MLDa.default)(id) === "object" || // other theme states
        $6815627abd9b7b21$var$isThemeKind(kind) && typeof id === "string" && $6815627abd9b7b21$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, $7MLDa.default)(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};


function $b1090430558fd951$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1090430558fd951$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1090430558fd951$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kl0zZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1090430558fd951$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b1090430558fd951$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $06fd699b5d2e9974$export$83993de8eb66733).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $b1090430558fd951$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $l4Fg9.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $l4Fg9.THEME_DATA_ATTRIBUTE)) || "";
    return $b1090430558fd951$var$_objectSpread($b1090430558fd951$var$_objectSpread({}, (0, $6815627abd9b7b21$export$f19b488f7c0547ee)(theme)), $b1090430558fd951$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $b1090430558fd951$export$2e2bcd8739ae039 = $b1090430558fd951$var$getGlobalTheme;



var $e6piB = parcelRequire("e6piB");
var $b5f38e09ac10996b$export$91b4dd3bfc301325 = function analyticsWrapper(analyticsClient) {
    return function(event) {
        return Promise.resolve(analyticsClient).then(function(client) {
            switch(event.eventType){
                case 0, $e6piB.UI_EVENT_TYPE:
                    client.sendUIEvent(event);
                    break;
                case 0, $e6piB.TRACK_EVENT_TYPE:
                    client.sendTrackEvent(event);
                    break;
                case 0, $e6piB.OPERATIONAL_EVENT_TYPE:
                    client.sendOperationalEvent(event);
                    break;
                case 0, $e6piB.SCREEN_EVENT_TYPE:
                    client.sendScreenEvent(event);
                    break;
            }
        });
    };
};



var $kl0zZ = parcelRequire("kl0zZ");

var $9H5Ac = parcelRequire("9H5Ac");

var $e6piB = parcelRequire("e6piB");
var $f083b143ddd893d3$var$_excluded = [
    "attributes"
];
function $f083b143ddd893d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f083b143ddd893d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f083b143ddd893d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kl0zZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f083b143ddd893d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f083b143ddd893d3$var$GROWTH_TAG = "growth";
var $f083b143ddd893d3$var$extractFromEventContext = function extractFromEventContext(propertyNames, context) {
    return context.reduce(function(acc, contextItem) {
        propertyNames.forEach(function(propertyName) {
            var navContextProp = contextItem ? contextItem[propertyName] : null;
            acc.push(navContextProp || contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
};
var $f083b143ddd893d3$var$getSources = function getSources(context) {
    return $f083b143ddd893d3$var$extractFromEventContext([
        "source"
    ], context);
};
var $f083b143ddd893d3$var$getExtraAttributes = function getExtraAttributes(context) {
    return context.reduce(function(ans, _ref) {
        var attributes = _ref.attributes, contextProps = (0, $9H5Ac.default)(_ref, $f083b143ddd893d3$var$_excluded);
        var newAttributes = $f083b143ddd893d3$var$_objectSpread($f083b143ddd893d3$var$_objectSpread({}, ans), contextProps);
        return attributes ? $f083b143ddd893d3$var$_objectSpread($f083b143ddd893d3$var$_objectSpread({}, newAttributes), attributes) : newAttributes;
    }, {});
};
var $f083b143ddd893d3$var$getPackageInfo = function getPackageInfo(context) {
    return context.map(function(contextItem) {
        return {
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        };
    }).filter(function(p) {
        return p.packageName;
    });
};
var $f083b143ddd893d3$var$last = function last(values) {
    return values[values.length - 1];
};
var $f083b143ddd893d3$export$3f40e8c44448be30 = function transformEvent(event) {
    var context = event.context, payload = event.payload;
    if (!payload) return null;
    var sources = $f083b143ddd893d3$var$getSources(context);
    var source = $f083b143ddd893d3$var$last(sources) || (0, $e6piB.DEFAULT_SOURCE);
    var extraAttributes = $f083b143ddd893d3$var$getExtraAttributes(context);
    var _ref2 = $f083b143ddd893d3$var$last($f083b143ddd893d3$var$getPackageInfo(context)) || {}, _ref2$packageName = _ref2.packageName, packageName = _ref2$packageName === void 0 ? undefined : _ref2$packageName, _ref2$packageVersion = _ref2.packageVersion, packageVersion = _ref2$packageVersion === void 0 ? undefined : _ref2$packageVersion;
    var _payload$eventType = payload.eventType, eventType = _payload$eventType === void 0 ? (0, $e6piB.UI_EVENT_TYPE) : _payload$eventType, action = payload.action, actionSubject = payload.actionSubject, actionSubjectId = payload.actionSubjectId, payloadAttributes = payload.attributes, name = payload.name;
    var attributes = $f083b143ddd893d3$var$_objectSpread($f083b143ddd893d3$var$_objectSpread({
        packageName: packageName,
        packageVersion: packageVersion
    }, extraAttributes), payloadAttributes);
    var tags = payload.tags || [];
    tags.push($f083b143ddd893d3$var$GROWTH_TAG);
    switch(eventType){
        case 0, $e6piB.UI_EVENT_TYPE:
        case 0, $e6piB.OPERATIONAL_EVENT_TYPE:
        case 0, $e6piB.TRACK_EVENT_TYPE:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: tags.slice(0)
            };
        case 0, $e6piB.SCREEN_EVENT_TYPE:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                source: source,
                tags: tags.slice(0)
            };
        default:
            break;
    }
    return null;
};



var $kl0zZ = parcelRequire("kl0zZ");
parcelRequire("hJmQE");
var $VyZuY = parcelRequire("VyZuY");
var $c12289fc66a794ca$export$c37558e5c67d2b01 = "https://qa-wac.internal.atlassian.com";
var $c12289fc66a794ca$export$f199baf8dfc7621e = "https://www.atlassian.com";
var $c12289fc66a794ca$export$fb1e43fdafe12e9b = "/software/opsgenie/try";
var $c12289fc66a794ca$export$e6c04a1dd86d1c14 = "/try/cloud/signup";
var $c12289fc66a794ca$export$2a45a00073911255 = "/software";


var $f1b1ea91536aeb5b$export$fc604aa353a97e10 = /*#__PURE__*/ function(UtmCampaign) {
    UtmCampaign["atlassian-switcher"] = "atlassian_switcher";
    return UtmCampaign;
}({});


var $d7f4ca146545d933$var$utmCampaignMap = {
    "atlassian-switcher": (0, $f1b1ea91536aeb5b$export$fc604aa353a97e10)["atlassian-switcher"]
};
var $d7f4ca146545d933$var$isBundledProduct = function isBundledProduct(productKey) {
    return [
        (0, $VyZuY.Targets).JIRA_SOFTWARE,
        (0, $VyZuY.Targets).JIRA_SERVICE_DESK,
        (0, $VyZuY.Targets).JIRA_CORE,
        (0, $VyZuY.Targets).CONFLUENCE
    ].includes(productKey);
};
var $d7f4ca146545d933$var$getBundleSignUpParams = function getBundleSignUpParams(productKey) {
    var bundles = (0, $kl0zZ.default)((0, $kl0zZ.default)((0, $kl0zZ.default)((0, $kl0zZ.default)({}, (0, $VyZuY.Targets).JIRA_SOFTWARE, "jira-software"), (0, $VyZuY.Targets).JIRA_SERVICE_DESK, "jira-service-desk"), (0, $VyZuY.Targets).JIRA_CORE, "jira-core"), (0, $VyZuY.Targets).CONFLUENCE, "confluence");
    // Bundles default to free
    return "bundle=".concat(bundles[productKey], "&edition=free");
};
var $d7f4ca146545d933$var$isProductWithCustomSignUpPath = function isProductWithCustomSignUpPath(productKey) {
    return [
        (0, $VyZuY.Targets).OPSGENIE
    ].includes(productKey);
};
var $d7f4ca146545d933$var$getProductCustomSignUpPath = function getProductCustomSignUpPath(productKey) {
    // Only Opsgenie. Trello, Bitbucket and Statuspage are handled by Product Store directly.
    var links = (0, $kl0zZ.default)({}, (0, $VyZuY.Targets).OPSGENIE, (0, $c12289fc66a794ca$export$fb1e43fdafe12e9b));
    return links[productKey];
};
var $d7f4ca146545d933$var$isSourceComponentWithUtmParams = function isSourceComponentWithUtmParams(sourceComponent) {
    return Boolean($d7f4ca146545d933$var$utmCampaignMap[sourceComponent]);
};
var $d7f4ca146545d933$var$getUtmParams = function getUtmParams(sourceComponent, sourceContext) {
    var utmParams = "";
    if (sourceComponent && $d7f4ca146545d933$var$isSourceComponentWithUtmParams(sourceComponent)) {
        utmParams = utmParams + "utm_campaign=".concat($d7f4ca146545d933$var$utmCampaignMap[sourceComponent], "&utm_medium=in_product_ad");
        if (sourceContext) utmParams = utmParams + "&utm_source=".concat(sourceContext);
    }
    return utmParams;
};
var $d7f4ca146545d933$export$39eab502fc96327d = function getProductSignUpLink(productKey, env, sourceComponent, sourceContext) {
    var wacUrl = env === "staging" ? (0, $c12289fc66a794ca$export$c37558e5c67d2b01) : (0, $c12289fc66a794ca$export$f199baf8dfc7621e);
    var utmParams = $d7f4ca146545d933$var$getUtmParams(sourceComponent, sourceContext);
    var queryParams = "";
    var bundleParams = "";
    var path = (0, $c12289fc66a794ca$export$2a45a00073911255);
    if ($d7f4ca146545d933$var$isBundledProduct(productKey)) {
        path = (0, $c12289fc66a794ca$export$e6c04a1dd86d1c14);
        bundleParams = $d7f4ca146545d933$var$getBundleSignUpParams(productKey);
    } else if ($d7f4ca146545d933$var$isProductWithCustomSignUpPath(productKey)) path = $d7f4ca146545d933$var$getProductCustomSignUpPath(productKey);
    if (!!bundleParams) queryParams = queryParams + "?".concat(bundleParams);
    if (!!utmParams) queryParams = queryParams + (!!queryParams ? "&" : "?") + utmParams;
    return wacUrl + path + queryParams;
};
var $d7f4ca146545d933$export$2827e2473cb9a346 = function setProductSignUpLocation(productKey) {
    var env = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "production";
    var sourceComponent = arguments.length > 2 ? arguments[2] : undefined;
    var sourceContext = arguments.length > 3 ? arguments[3] : undefined;
    var url = $d7f4ca146545d933$export$39eab502fc96327d(productKey, env, sourceComponent, sourceContext);
    window.open(url, "_blank");
};



var $5MfkQ = parcelRequire("5MfkQ");

var $iRbzA = parcelRequire("iRbzA");

var $4rxeI = parcelRequire("4rxeI");

var $1rjYj = parcelRequire("1rjYj");

var $RIgEX = parcelRequire("RIgEX");

var $kl0zZ = parcelRequire("kl0zZ");

var $iSvIT = parcelRequire("iSvIT");

var $b63pT = parcelRequire("b63pT");
var $e6piB = parcelRequire("e6piB");
function $fafc2911f0f29519$var$_callSuper(t, o, e) {
    return o = (0, $1rjYj.default)(o), (0, $4rxeI.default)(t, $fafc2911f0f29519$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $1rjYj.default)(t).constructor) : o.apply(t, e));
}
function $fafc2911f0f29519$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fafc2911f0f29519$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $fafc2911f0f29519$var$name = "@atlassiansox/cross-flow-support";
var $fafc2911f0f29519$var$version = "5.1.3";
var $fafc2911f0f29519$var$payload = {
    eventType: (0, $e6piB.OPERATIONAL_EVENT_TYPE),
    action: (0, $b63pT.errorBoundaryAction),
    actionSubject: (0, $b63pT.errorBoundaryActionSubject)
};
var $fafc2911f0f29519$var$context = [
    {
        source: (0, $b63pT.source)
    },
    {
        packageName: $fafc2911f0f29519$var$name,
        packageVersion: $fafc2911f0f29519$var$version
    }
];
var $fafc2911f0f29519$export$e926676385687eaf = /*#__PURE__*/ function(_Component) {
    function ErrorBoundary() {
        var _this;
        (0, $5MfkQ.default)(this, ErrorBoundary);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $fafc2911f0f29519$var$_callSuper(this, ErrorBoundary, [].concat(args));
        (0, $kl0zZ.default)(_this, "state", {
            hasError: false
        });
        return _this;
    }
    (0, $RIgEX.default)(ErrorBoundary, _Component);
    return (0, $iRbzA.default)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error) {
                this.props.onAnalyticsEvent({
                    payload: $fafc2911f0f29519$var$payload,
                    context: $fafc2911f0f29519$var$context
                });
                if (this.props.onError) this.props.onError(error);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) return null;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError() {
                return {
                    hasError: true
                };
            }
        }
    ]);
}((0, $iSvIT.Component));



var $kl0zZ = parcelRequire("kl0zZ");
function $e9f613acf56bda77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e9f613acf56bda77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e9f613acf56bda77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kl0zZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e9f613acf56bda77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e9f613acf56bda77$var$version = "5.1.3";
var $e9f613acf56bda77$export$84f9cf7ef89d4c26 = {
    version: $e9f613acf56bda77$var$version
};
var $e9f613acf56bda77$export$59518efab336a8b5 = function enrichWithPackageDetails(event) {
    var attributes = $e9f613acf56bda77$var$_objectSpread($e9f613acf56bda77$var$_objectSpread({}, event.attributes || {}), {}, {
        crossFlowSupport: $e9f613acf56bda77$export$84f9cf7ef89d4c26
    });
    return $e9f613acf56bda77$var$_objectSpread($e9f613acf56bda77$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};



var $kl0zZ = parcelRequire("kl0zZ");
function $576163c849389224$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $576163c849389224$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $576163c849389224$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kl0zZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $576163c849389224$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $576163c849389224$export$a5a156dc5df42f0 = function enrichWithRequestOptions(event, requestOptions) {
    if (!requestOptions) return event;
    var attributes = $576163c849389224$var$_objectSpread($576163c849389224$var$_objectSpread($576163c849389224$var$_objectSpread({}, requestOptions.extraAnalyticsAttributes || {}), event.attributes || {}), {}, {
        sourceComponent: requestOptions.sourceComponent,
        sourceContext: requestOptions.sourceContext
    });
    return $576163c849389224$var$_objectSpread($576163c849389224$var$_objectSpread({}, event), {}, {
        attributes: attributes
    });
};



var $b63pT = parcelRequire("b63pT");
var $e6piB = parcelRequire("e6piB");
var $cd15801113ef3266$var$_excluded = [
    "children",
    "analyticsClient",
    "originProduct",
    "redirectToWac",
    "env",
    "plugins",
    "globalExperimentalOptions",
    "onError"
];
function $cd15801113ef3266$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd15801113ef3266$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd15801113ef3266$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kl0zZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd15801113ef3266$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

var $cd15801113ef3266$var$IntegrationView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(function() {
    return (parcelRequire("23Zjb"));
});
var $cd15801113ef3266$export$79d79d8dd8574306 = function createCrossFlowProvider(IntegrationView) {
    return function(props) {
        var _requestOptions$zInde;
        var children = props.children, analyticsClient = props.analyticsClient, originProduct = props.originProduct, redirectToWac = props.redirectToWac, env = props.env, _props$plugins = props.plugins, plugins = _props$plugins === void 0 ? [] : _props$plugins, globalExperimentalOptions = props.globalExperimentalOptions, onError = props.onError, baseProviderProps = (0, $9H5Ac.default)(props, $cd15801113ef3266$var$_excluded);
        var onCloseResolver = (0, $iSvIT.useRef)();
        var _useState = (0, $iSvIT.useState)(false), _useState2 = (0, $j6P2N.default)(_useState, 2), firstHandshakeReceived = _useState2[0], setFirstHandshakeReceived = _useState2[1];
        var fireEvent = (0, $iSvIT.useMemo)(function() {
            return (0, $b5f38e09ac10996b$export$91b4dd3bfc301325)(analyticsClient);
        }, [
            analyticsClient
        ]);
        var _useState3 = (0, $iSvIT.useState)(), _useState4 = (0, $j6P2N.default)(_useState3, 2), requestOptions = _useState4[0], setRequestOptions = _useState4[1];
        var onAnalyticsEvent = (0, $iSvIT.useCallback)(function(payload) {
            var gasV3Event = (0, $f083b143ddd893d3$export$3f40e8c44448be30)(payload);
            if (gasV3Event) {
                var enrichedEvent = (0, $576163c849389224$export$a5a156dc5df42f0)((0, $e9f613acf56bda77$export$59518efab336a8b5)(gasV3Event), requestOptions);
                fireEvent(enrichedEvent);
            }
        }, [
            fireEvent,
            requestOptions
        ]);
        var onHandShake = (0, $iSvIT.useCallback)(function(appName) {
            if (!firstHandshakeReceived) {
                onAnalyticsEvent({
                    payload: {
                        eventType: (0, $e6piB.OPERATIONAL_EVENT_TYPE),
                        action: (0, $b63pT.uiInitialized),
                        actionSubject: (0, $b63pT.crossFlowActionSubject),
                        attributes: {
                            appName: appName
                        }
                    },
                    context: [
                        {
                            source: (0, $b63pT.source)
                        }
                    ]
                });
                setFirstHandshakeReceived(true);
            }
        }, [
            firstHandshakeReceived,
            onAnalyticsEvent
        ]);
        var onOpen = (0, $iSvIT.useCallback)(function(options) {
            /**
       * Reset first handshake state to ensure 1:1 value of open invoked and handshake received
       * Caveat that if open api is invoked while cross flow support UI is already mounted there will be mismatch of openInvoked events to uiInitialized events
       */ setFirstHandshakeReceived(false);
            var analyticsEvent = {
                // setRequestOptions does not update the state right away (updates on the next render) so for the openInvoked event we need to manually append the sourceComponent and sourceContext
                payload: (0, $576163c849389224$export$a5a156dc5df42f0)({
                    eventType: (0, $e6piB.OPERATIONAL_EVENT_TYPE),
                    action: (0, $b63pT.openInvoked),
                    actionSubject: (0, $b63pT.crossFlowActionSubject)
                }, options),
                context: [
                    {
                        source: (0, $b63pT.source)
                    }
                ]
            };
            onAnalyticsEvent(analyticsEvent);
            // Short circuit requestOptions for WAC expansions
            if (options.journey === (0, $kQFoP.Journeys).GET_STARTED && redirectToWac) {
                (0, $d7f4ca146545d933$export$2827e2473cb9a346)(options.targetProduct, env, options.sourceComponent, options.sourceContext);
                var _completionStatus = {};
                return Promise.resolve(_completionStatus);
            }
            var updatedExperimentalOptions = $cd15801113ef3266$var$_objectSpread($cd15801113ef3266$var$_objectSpread({}, globalExperimentalOptions || {}), options.experimentalOptions || {});
            options.experimentalOptions = updatedExperimentalOptions;
            setRequestOptions(options);
            return new Promise(function(resolve) {
                onCloseResolver.current = resolve;
            });
        }, [
            onAnalyticsEvent,
            env,
            redirectToWac,
            globalExperimentalOptions
        ]);
        var onClose = (0, $iSvIT.useCallback)(function(completionStatus) {
            setFirstHandshakeReceived(false);
            setRequestOptions(undefined);
            onCloseResolver.current && onCloseResolver.current(completionStatus);
        }, []);
        var _getGlobalTheme = (0, $b1090430558fd951$export$2e2bcd8739ae039)(), colorMode = _getGlobalTheme.colorMode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $eWlfK.BaseCrossFlowApiProvider), {
            onOpen: onOpen
        }, children, requestOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $fafc2911f0f29519$export$e926676385687eaf), {
            onAnalyticsEvent: onAnalyticsEvent,
            onError: onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $iSvIT.Suspense), {
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(IntegrationView, (0, $l3uAP.default)({}, baseProviderProps, requestOptions, {
            onAnalyticsEvent: onAnalyticsEvent,
            originProduct: originProduct,
            theme: colorMode,
            onClose: onClose,
            onHandShake: onHandShake,
            plugins: plugins,
            env: env,
            redirectToWac: redirectToWac,
            zIndex: (_requestOptions$zInde = requestOptions.zIndex) !== null && _requestOptions$zInde !== void 0 ? _requestOptions$zInde : 1000
        })))));
    };
};
var $cd15801113ef3266$export$d900e4062895cd7c = $cd15801113ef3266$export$79d79d8dd8574306($cd15801113ef3266$var$IntegrationView);



var $a3af8c0e980bcd22$export$a9d7aac09de99b5 = function WacProvider(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $cd15801113ef3266$export$d900e4062895cd7c), (0, $l3uAP.default)({}, props, {
        originProduct: "wac"
    }));
};
var $a3af8c0e980bcd22$export$2e2bcd8739ae039 = $a3af8c0e980bcd22$export$a9d7aac09de99b5;



const $ef56d09005ba07c9$export$d900e4062895cd7c = ({ children: children, cloudId: cloudId, locale: locale = "en" })=>{
    const analyticsClient = (0, $9e7dba6014f411d3$export$923054f18cb06572)();
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $a3af8c0e980bcd22$export$2e2bcd8739ae039), {
        cloudId: cloudId,
        // @ts-expect-error - TS2322 - Type 'Promise<typeof AnalyticsWebClient> | Promise<{ sendUIEvent: () => void; sendOperationalEvent: () => void; sendTrackEvent: () => void; sendScreenEvent: () => void; }>' is not assignable to type 'MaybePromise<AnalyticsWebClientInterface>'.
        analyticsClient: analyticsClient,
        locale: locale,
        plugins: [
            (0, $d35e3d0a4d82e921$export$7c44908d2777db01)
        ],
        children: children
    });
};



var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");
/* eslint-disable @typescript-eslint/explicit-member-accessibility */ 
var $iSvIT = parcelRequire("iSvIT");
function $83be539c05b4e856$export$cdf1dc76b55502e3(task, dependencies) {
    const [result, setResult] = (0, $iSvIT.useState)($83be539c05b4e856$export$3b98ae54dec9c881.pending());
    (0, $iSvIT.useEffect)(()=>{
        let inEffect = true;
        task().then((value)=>{
            if (inEffect) setResult($83be539c05b4e856$export$3b98ae54dec9c881.complete(value));
        }).catch((error)=>{
            if (inEffect) setResult($83be539c05b4e856$export$3b98ae54dec9c881.error(error));
        });
        return ()=>{
            inEffect = false;
        };
    }, dependencies);
    return result;
}
class $83be539c05b4e856$export$3b98ae54dec9c881 {
    static pending() {
        return new $83be539c05b4e856$var$PendingAsyncResult();
    }
    static complete(value) {
        return new $83be539c05b4e856$var$CompleteAsyncResult(value);
    }
    static error(error) {
        return new $83be539c05b4e856$var$ErrorAsyncResult(error);
    }
    static isPending(result) {
        return result.isPending === true;
    }
    static isComplete(result) {
        return result.isPending === false && result.error === undefined;
    }
    static isError(result) {
        return result.isPending === false && result.error !== undefined;
    }
    constructor(isPending){
        this.isPending = isPending;
    }
}
class $83be539c05b4e856$var$PendingAsyncResult extends $83be539c05b4e856$export$3b98ae54dec9c881 {
    constructor(){
        super(true);
    }
    map() {
        return new $83be539c05b4e856$var$PendingAsyncResult();
    }
    catch() {
        return this;
    }
    get value() {
        throw new Error("AsyncResult is pending...");
    }
}
class $83be539c05b4e856$var$CompleteAsyncResult extends $83be539c05b4e856$export$3b98ae54dec9c881 {
    constructor(value){
        super(false);
        this.value = value;
    }
    map(mapper) {
        return new $83be539c05b4e856$var$CompleteAsyncResult(mapper(this.value));
    }
    catch() {
        return this;
    }
}
class $83be539c05b4e856$var$ErrorAsyncResult extends $83be539c05b4e856$export$3b98ae54dec9c881 {
    constructor(error){
        super(false);
        this.error = error;
    }
    map() {
        return new $83be539c05b4e856$var$ErrorAsyncResult(this.error);
    }
    catch(catcher) {
        return new $83be539c05b4e856$var$CompleteAsyncResult(catcher(this.error));
    }
    get value() {
        throw new $83be539c05b4e856$export$36212ba89a98b1ce(this.error);
    }
}
class $83be539c05b4e856$export$36212ba89a98b1ce extends Error {
    constructor(cause){
        super(cause.message);
        this.cause = cause;
        this.name = $83be539c05b4e856$export$36212ba89a98b1ce.name;
    }
}




function $52d9d0d7feb7cad6$export$5afbfe6edea8e998({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite }) {
    const stargateClient = (0, $cd2194d8d3feda9a$export$ac42303986bb641e)();
    return (0, $83be539c05b4e856$export$cdf1dc76b55502e3)(()=>stargateClient.availableProductsLegacy({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite
        }), []);
}
function $52d9d0d7feb7cad6$export$3691a5908e1c8031({ includeInvalidSites: includeInvalidSites, includeInvalidBitbucketSite: includeInvalidBitbucketSite, removeNonAdminSites: removeNonAdminSites }) {
    const stargateClient = (0, $cd2194d8d3feda9a$export$ac42303986bb641e)();
    return (0, $83be539c05b4e856$export$cdf1dc76b55502e3)(()=>stargateClient.availableProducts({
            includeInvalidSites: includeInvalidSites,
            includeInvalidBitbucketSite: includeInvalidBitbucketSite,
            removeNonAdminSites: removeNonAdminSites
        }), []);
}


const $c2868f3eb82906a7$export$a35464c11db06d9a = /*#__PURE__*/ (0, $iSvIT.createContext)(null);
const $c2868f3eb82906a7$export$3b4b23553295d0ad = ()=>{
    const context = (0, $iSvIT.useContext)($c2868f3eb82906a7$export$a35464c11db06d9a);
    if (!context) throw new Error("useSitesContext must be used within a SitesContextProvider");
    return context;
};
const $c2868f3eb82906a7$export$d6c39dfd40fa7ff8 = ({ children: children })=>{
    const [sites, setSites] = (0, $iSvIT.useState)(undefined);
    const response = (0, $52d9d0d7feb7cad6$export$3691a5908e1c8031)({});
    (0, $iSvIT.useEffect)(()=>{
        if ((0, $83be539c05b4e856$export$3b98ae54dec9c881).isComplete(response)) setSites(response.value?.sites);
        else if ((0, $83be539c05b4e856$export$3b98ae54dec9c881).isError(response)) setSites([]);
    }, [
        response
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsx)($c2868f3eb82906a7$export$a35464c11db06d9a.Provider, {
        value: {
            sites: sites
        },
        children: children
    });
};




/* grid-overlay.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");


const $657d675628db56f1$export$e9c94d54c23374cb = ()=>{
    // this grid is rendered client side only and should wait until after hydration
    const [hasHydrated, setHasHydrated] = (0, $iSvIT.useState)(false);
    const [shouldShowGrid, setShouldShowGrid] = (0, $iSvIT.useState)(false);
    (0, $iSvIT.useEffect)(()=>{
        setHasHydrated(true);
        setShouldShowGrid(!!(0, $2c637c10bc35918d$export$d3720feff416e85b)("shouldShowGridOverlay", true));
    }, []);
    if (typeof window !== "undefined") // @ts-ignore
    window.toggleGrid = ()=>{
        if (!(0, $2c637c10bc35918d$export$d3720feff416e85b)("shouldShowGridOverlay", true)) {
            (0, $2c637c10bc35918d$export$1f73f60bdb811cb1)("shouldShowGridOverlay", "true");
            setShouldShowGrid(true);
        } else {
            (0, $2c637c10bc35918d$export$720fb0373088e6ec)("shouldShowGridOverlay");
            setShouldShowGrid(false);
        }
    };
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: hasHydrated && shouldShowGrid && /*#__PURE__*/ (0, $loA2J.jsx)($657d675628db56f1$export$1c41ff9dbe11e487, {})
    });
};
const $657d675628db56f1$export$1c41ff9dbe11e487 = ()=>{
    const gridOverlayStyle = null;
    const columnStyle = null;
    const columns = new Array(12).fill("").map((_, index)=>/*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1a6z _4t3i1kxc"
            ])
        }, `column-${index}`));
    return /*#__PURE__*/ (0, $loA2J.jsx)("div", {
        className: (0, $esG4f.default)([
            "_kqsw1n9t _1bsb1osq _1e021ssb _t9eczr6s _4t3i1kxc _1pbyhac1 _lcxvglyw _bfhk6ars _1gze1tkq _lkmrsxj9 _be1q1u8q _bp7od768 _1rsua5c7"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $190830b8c61b7d0a$export$c7e5bac7049eee2a), {
            layout: "overlay",
            children: columns
        })
    });
};







var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $XAEGR = parcelRequire("XAEGR");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $aea31fc1ed434cfd$var$s = function() {
    return $aea31fc1ed434cfd$var$s = Object.assign || function(e) {
        for(var t, r = 1, o = arguments.length; r < o; r++)for(var n in t = arguments[r])Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        return e;
    }, $aea31fc1ed434cfd$var$s.apply(this, arguments);
};
function $aea31fc1ed434cfd$var$u(e, t, r, o) {
    return new (r || (r = Promise))(function(n, a) {
        function c(e) {
            try {
                s(o.next(e));
            } catch (e) {
                a(e);
            }
        }
        function i(e) {
            try {
                s(o.throw(e));
            } catch (e) {
                a(e);
            }
        }
        function s(e) {
            var t;
            e.done ? n(e.value) : (t = e.value, t instanceof r ? t : new r(function(e) {
                e(t);
            })).then(c, i);
        }
        s((o = o.apply(e, t || [])).next());
    });
}
function $aea31fc1ed434cfd$var$l(e, t) {
    var r, o, n, a, c = {
        label: 0,
        sent: function() {
            if (1 & n[0]) throw n[1];
            return n[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: i(0),
        throw: i(1),
        return: i(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function i(a) {
        return function(i) {
            return function(a) {
                if (r) throw new TypeError("Generator is already executing.");
                for(; c;)try {
                    if (r = 1, o && (n = 2 & a[0] ? o.return : a[0] ? o.throw || ((n = o.return) && n.call(o), 0) : o.next) && !(n = n.call(o, a[1])).done) return n;
                    switch(o = 0, n && (a = [
                        2 & a[0],
                        n.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            n = a;
                            break;
                        case 4:
                            return c.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            c.label++, o = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(n = c.trys, (n = n.length > 0 && n[n.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                c = 0;
                                continue;
                            }
                            if (3 === a[0] && (!n || a[1] > n[0] && a[1] < n[3])) {
                                c.label = a[1];
                                break;
                            }
                            if (6 === a[0] && c.label < n[1]) {
                                c.label = n[1], n = a;
                                break;
                            }
                            if (n && c.label < n[2]) {
                                c.label = n[2], c.ops.push(a);
                                break;
                            }
                            n[2] && c.ops.pop(), c.trys.pop();
                            continue;
                    }
                    a = t.call(e, c);
                } catch (e) {
                    a = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    r = n = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                i
            ]);
        };
    }
}
var $aea31fc1ed434cfd$var$f, $aea31fc1ed434cfd$var$p = function(e) {
    var t;
    e ? function(e) {
        if (e) for(; e.lastChild;)e.lastChild.remove();
    }("string" == typeof e ? document.getElementById(e) : e) : (t = document.querySelector(".grecaptcha-badge")) && t.parentNode && document.body.removeChild(t.parentNode);
}, $aea31fc1ed434cfd$var$d = function(e, t) {
    $aea31fc1ed434cfd$var$p(t), window.___grecaptcha_cfg = void 0;
    var r = document.querySelector("#" + e);
    r && r.remove(), function() {
        var e = document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');
        e && e.remove();
    }();
}, $aea31fc1ed434cfd$var$y = function(e) {
    var t = e.render, r = e.onLoadCallbackName, o = e.language, n = e.onLoad, a = e.useRecaptchaNet, c = e.useEnterprise, i = e.scriptProps, s = void 0 === i ? {} : i, u = s.nonce, l = void 0 === u ? "" : u, f = s.defer, p = void 0 !== f && f, d = s.async, y = void 0 !== d && d, m = s.id, v = void 0 === m ? "" : m, b = s.appendTo, h = v || "google-recaptcha-v3";
    if (function(e) {
        return !!document.querySelector("#" + e);
    }(h)) n();
    else {
        var g = function(e) {
            return "https://www." + (e.useRecaptchaNet ? "recaptcha.net" : "google.com") + "/recaptcha/" + (e.useEnterprise ? "enterprise.js" : "api.js");
        }({
            useEnterprise: c,
            useRecaptchaNet: a
        }), S = document.createElement("script");
        S.id = h, S.src = g + "?render=" + t + ("explicit" === t ? "&onload=" + r : "") + (o ? "&hl=" + o : ""), l && (S.nonce = l), S.defer = !!p, S.async = !!y, S.onload = n, ("body" === b ? document.body : document.getElementsByTagName("head")[0]).appendChild(S);
    }
}, $aea31fc1ed434cfd$var$m = function(e) {
    "undefined" != typeof $XAEGR && $XAEGR.env, console.warn(e);
};
!function(e) {
    e.SCRIPT_NOT_AVAILABLE = "Recaptcha script is not available";
}($aea31fc1ed434cfd$var$f || ($aea31fc1ed434cfd$var$f = {}));
var $aea31fc1ed434cfd$export$dd93270ab0cf623c = (0, $iSvIT.createContext)({
    executeRecaptcha: function() {
        throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider");
    }
}), $aea31fc1ed434cfd$export$14d6311c3d83742b = $aea31fc1ed434cfd$export$dd93270ab0cf623c.Consumer;
function $aea31fc1ed434cfd$export$3d3872bfc53fd642(t) {
    var i = t.reCaptchaKey, u = t.useEnterprise, l = void 0 !== u && u, p = t.useRecaptchaNet, b = void 0 !== p && p, h = t.scriptProps, g = t.language, S = t.container, w = t.children, $ = (0, $iSvIT.useState)(null), C = $[0], P = $[1], x = (0, $iSvIT.useRef)(i), E = JSON.stringify(h), R = JSON.stringify(null == S ? void 0 : S.parameters);
    (0, $iSvIT.useEffect)(function() {
        if (i) {
            var e = (null == h ? void 0 : h.id) || "google-recaptcha-v3", t = (null == h ? void 0 : h.onLoadCallbackName) || "onRecaptchaLoadCallback";
            window[t] = function() {
                var e = l ? window.grecaptcha.enterprise : window.grecaptcha, t = $aea31fc1ed434cfd$var$s({
                    badge: "inline",
                    size: "invisible",
                    sitekey: i
                }, (null == S ? void 0 : S.parameters) || {});
                x.current = e.render(null == S ? void 0 : S.element, t);
            };
            return $aea31fc1ed434cfd$var$y({
                render: (null == S ? void 0 : S.element) ? "explicit" : i,
                onLoadCallbackName: t,
                useEnterprise: l,
                useRecaptchaNet: b,
                scriptProps: h,
                language: g,
                onLoad: function() {
                    if (window && window.grecaptcha) {
                        var e = l ? window.grecaptcha.enterprise : window.grecaptcha;
                        e.ready(function() {
                            P(e);
                        });
                    } else $aea31fc1ed434cfd$var$m("<GoogleRecaptchaProvider /> " + $aea31fc1ed434cfd$var$f.SCRIPT_NOT_AVAILABLE);
                },
                onError: function() {
                    $aea31fc1ed434cfd$var$m("Error loading google recaptcha script");
                }
            }), function() {
                $aea31fc1ed434cfd$var$d(e, null == S ? void 0 : S.element);
            };
        }
        $aea31fc1ed434cfd$var$m("<GoogleReCaptchaProvider /> recaptcha key not provided");
    }, [
        l,
        b,
        E,
        R,
        g,
        i,
        null == S ? void 0 : S.element
    ]);
    var M = (0, $iSvIT.useCallback)(function(e) {
        if (!C || !C.execute) throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");
        return C.execute(x.current, {
            action: e
        });
    }, [
        C,
        x
    ]), N = (0, $iSvIT.useMemo)(function() {
        return {
            executeRecaptcha: C ? M : void 0,
            container: null == S ? void 0 : S.element
        };
    }, [
        M,
        C,
        null == S ? void 0 : S.element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($aea31fc1ed434cfd$export$dd93270ab0cf623c.Provider, {
        value: N
    }, w);
}
var $aea31fc1ed434cfd$export$7f8feffd50fb5144 = function() {
    return (0, $iSvIT.useContext)($aea31fc1ed434cfd$export$dd93270ab0cf623c);
};
function $aea31fc1ed434cfd$export$d5aa16f6da947fbf(t) {
    var r = this, o = t.action, a = t.onVerify, c = t.refreshReCaptcha, i = $aea31fc1ed434cfd$export$7f8feffd50fb5144();
    (0, $iSvIT.useEffect)(function() {
        var e = i.executeRecaptcha;
        if (e) $aea31fc1ed434cfd$var$u(r, void 0, void 0, function() {
            var t;
            return $aea31fc1ed434cfd$var$l(this, function(r) {
                switch(r.label){
                    case 0:
                        return [
                            4,
                            e(o)
                        ];
                    case 1:
                        return t = r.sent(), a ? (a(t), [
                            2
                        ]) : ($aea31fc1ed434cfd$var$m("Please define an onVerify function"), [
                            2
                        ]);
                }
            });
        });
    }, [
        o,
        a,
        c,
        i
    ]);
    var s = i.container;
    return "string" == typeof s ? (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement("div", {
        id: s
    }) : null;
}
function $aea31fc1ed434cfd$var$w(e, t) {
    return e(t = {
        exports: {}
    }, t.exports), t.exports;
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ }
var $aea31fc1ed434cfd$var$$ = "function" == typeof Symbol && Symbol.for, $aea31fc1ed434cfd$var$C = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.element") : 60103, $aea31fc1ed434cfd$var$P = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.portal") : 60106, $aea31fc1ed434cfd$var$x = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.fragment") : 60107, $aea31fc1ed434cfd$var$E = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.strict_mode") : 60108, $aea31fc1ed434cfd$var$R = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.profiler") : 60114, $aea31fc1ed434cfd$var$M = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.provider") : 60109, $aea31fc1ed434cfd$var$N = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.context") : 60110, $aea31fc1ed434cfd$var$O = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.async_mode") : 60111, $aea31fc1ed434cfd$var$_ = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.concurrent_mode") : 60111, $aea31fc1ed434cfd$var$T = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.forward_ref") : 60112, $aea31fc1ed434cfd$var$j = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.suspense") : 60113, $aea31fc1ed434cfd$var$L = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.suspense_list") : 60120, $aea31fc1ed434cfd$var$k = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.memo") : 60115, $aea31fc1ed434cfd$var$F = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.lazy") : 60116, $aea31fc1ed434cfd$var$A = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.block") : 60121, $aea31fc1ed434cfd$var$V = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.fundamental") : 60117, $aea31fc1ed434cfd$var$z = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.responder") : 60118, $aea31fc1ed434cfd$var$G = $aea31fc1ed434cfd$var$$ ? Symbol.for("react.scope") : 60119;
function $aea31fc1ed434cfd$var$I(e) {
    if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch(t){
            case $aea31fc1ed434cfd$var$C:
                switch(e = e.type){
                    case $aea31fc1ed434cfd$var$O:
                    case $aea31fc1ed434cfd$var$_:
                    case $aea31fc1ed434cfd$var$x:
                    case $aea31fc1ed434cfd$var$R:
                    case $aea31fc1ed434cfd$var$E:
                    case $aea31fc1ed434cfd$var$j:
                        return e;
                    default:
                        switch(e = e && e.$$typeof){
                            case $aea31fc1ed434cfd$var$N:
                            case $aea31fc1ed434cfd$var$T:
                            case $aea31fc1ed434cfd$var$F:
                            case $aea31fc1ed434cfd$var$k:
                            case $aea31fc1ed434cfd$var$M:
                                return e;
                            default:
                                return t;
                        }
                }
            case $aea31fc1ed434cfd$var$P:
                return t;
        }
    }
}
function $aea31fc1ed434cfd$var$D(e) {
    return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$_;
}
var $aea31fc1ed434cfd$var$q = {
    AsyncMode: $aea31fc1ed434cfd$var$O,
    ConcurrentMode: $aea31fc1ed434cfd$var$_,
    ContextConsumer: $aea31fc1ed434cfd$var$N,
    ContextProvider: $aea31fc1ed434cfd$var$M,
    Element: $aea31fc1ed434cfd$var$C,
    ForwardRef: $aea31fc1ed434cfd$var$T,
    Fragment: $aea31fc1ed434cfd$var$x,
    Lazy: $aea31fc1ed434cfd$var$F,
    Memo: $aea31fc1ed434cfd$var$k,
    Portal: $aea31fc1ed434cfd$var$P,
    Profiler: $aea31fc1ed434cfd$var$R,
    StrictMode: $aea31fc1ed434cfd$var$E,
    Suspense: $aea31fc1ed434cfd$var$j,
    isAsyncMode: function(e) {
        return $aea31fc1ed434cfd$var$D(e) || $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$O;
    },
    isConcurrentMode: $aea31fc1ed434cfd$var$D,
    isContextConsumer: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$N;
    },
    isContextProvider: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$M;
    },
    isElement: function(e) {
        return "object" == typeof e && null !== e && e.$$typeof === $aea31fc1ed434cfd$var$C;
    },
    isForwardRef: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$T;
    },
    isFragment: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$x;
    },
    isLazy: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$F;
    },
    isMemo: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$k;
    },
    isPortal: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$P;
    },
    isProfiler: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$R;
    },
    isStrictMode: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$E;
    },
    isSuspense: function(e) {
        return $aea31fc1ed434cfd$var$I(e) === $aea31fc1ed434cfd$var$j;
    },
    isValidElementType: function(e) {
        return "string" == typeof e || "function" == typeof e || e === $aea31fc1ed434cfd$var$x || e === $aea31fc1ed434cfd$var$_ || e === $aea31fc1ed434cfd$var$R || e === $aea31fc1ed434cfd$var$E || e === $aea31fc1ed434cfd$var$j || e === $aea31fc1ed434cfd$var$L || "object" == typeof e && null !== e && (e.$$typeof === $aea31fc1ed434cfd$var$F || e.$$typeof === $aea31fc1ed434cfd$var$k || e.$$typeof === $aea31fc1ed434cfd$var$M || e.$$typeof === $aea31fc1ed434cfd$var$N || e.$$typeof === $aea31fc1ed434cfd$var$T || e.$$typeof === $aea31fc1ed434cfd$var$V || e.$$typeof === $aea31fc1ed434cfd$var$z || e.$$typeof === $aea31fc1ed434cfd$var$G || e.$$typeof === $aea31fc1ed434cfd$var$A);
    },
    typeOf: $aea31fc1ed434cfd$var$I
}, $aea31fc1ed434cfd$var$B = $aea31fc1ed434cfd$var$w(function(e, t) {}), $aea31fc1ed434cfd$var$J = ($aea31fc1ed434cfd$var$B.AsyncMode, $aea31fc1ed434cfd$var$B.ConcurrentMode, $aea31fc1ed434cfd$var$B.ContextConsumer, $aea31fc1ed434cfd$var$B.ContextProvider, $aea31fc1ed434cfd$var$B.Element, $aea31fc1ed434cfd$var$B.ForwardRef, $aea31fc1ed434cfd$var$B.Fragment, $aea31fc1ed434cfd$var$B.Lazy, $aea31fc1ed434cfd$var$B.Memo, $aea31fc1ed434cfd$var$B.Portal, $aea31fc1ed434cfd$var$B.Profiler, $aea31fc1ed434cfd$var$B.StrictMode, $aea31fc1ed434cfd$var$B.Suspense, $aea31fc1ed434cfd$var$B.isAsyncMode, $aea31fc1ed434cfd$var$B.isConcurrentMode, $aea31fc1ed434cfd$var$B.isContextConsumer, $aea31fc1ed434cfd$var$B.isContextProvider, $aea31fc1ed434cfd$var$B.isElement, $aea31fc1ed434cfd$var$B.isForwardRef, $aea31fc1ed434cfd$var$B.isFragment, $aea31fc1ed434cfd$var$B.isLazy, $aea31fc1ed434cfd$var$B.isMemo, $aea31fc1ed434cfd$var$B.isPortal, $aea31fc1ed434cfd$var$B.isProfiler, $aea31fc1ed434cfd$var$B.isStrictMode, $aea31fc1ed434cfd$var$B.isSuspense, $aea31fc1ed434cfd$var$B.isValidElementType, $aea31fc1ed434cfd$var$B.typeOf, $aea31fc1ed434cfd$var$w(function(e) {
    e.exports = $aea31fc1ed434cfd$var$q;
})), $aea31fc1ed434cfd$var$K = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $aea31fc1ed434cfd$var$U = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $aea31fc1ed434cfd$var$H = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $aea31fc1ed434cfd$var$Q = {};
function $aea31fc1ed434cfd$var$W(e) {
    return $aea31fc1ed434cfd$var$J.isMemo(e) ? $aea31fc1ed434cfd$var$H : $aea31fc1ed434cfd$var$Q[e.$$typeof] || $aea31fc1ed434cfd$var$K;
}
$aea31fc1ed434cfd$var$Q[$aea31fc1ed434cfd$var$J.ForwardRef] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $aea31fc1ed434cfd$var$Q[$aea31fc1ed434cfd$var$J.Memo] = $aea31fc1ed434cfd$var$H;
var $aea31fc1ed434cfd$var$X = Object.defineProperty, $aea31fc1ed434cfd$var$Y = Object.getOwnPropertyNames, $aea31fc1ed434cfd$var$Z = Object.getOwnPropertySymbols, $aea31fc1ed434cfd$var$ee = Object.getOwnPropertyDescriptor, $aea31fc1ed434cfd$var$te = Object.getPrototypeOf, $aea31fc1ed434cfd$var$re = Object.prototype;
var $aea31fc1ed434cfd$var$oe = function e(t, r, o) {
    if ("string" != typeof r) {
        if ($aea31fc1ed434cfd$var$re) {
            var n = $aea31fc1ed434cfd$var$te(r);
            n && n !== $aea31fc1ed434cfd$var$re && e(t, n, o);
        }
        var a = $aea31fc1ed434cfd$var$Y(r);
        $aea31fc1ed434cfd$var$Z && (a = a.concat($aea31fc1ed434cfd$var$Z(r)));
        for(var c = $aea31fc1ed434cfd$var$W(t), i = $aea31fc1ed434cfd$var$W(r), s = 0; s < a.length; ++s){
            var u = a[s];
            if (!($aea31fc1ed434cfd$var$U[u] || o && o[u] || i && i[u] || c && c[u])) {
                var l = $aea31fc1ed434cfd$var$ee(r, u);
                try {
                    $aea31fc1ed434cfd$var$X(t, u, l);
                } catch (e) {}
            }
        }
    }
    return t;
}, $aea31fc1ed434cfd$export$b641f6dbb7005cb7 = function(t) {
    var r = function(r) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement($aea31fc1ed434cfd$export$14d6311c3d83742b, null, function(o) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement(t, $aea31fc1ed434cfd$var$s({}, r, {
                googleReCaptchaProps: o
            }));
        });
    };
    return r.displayName = "withGoogleReCaptcha(" + (t.displayName || t.name || "Component") + ")", $aea31fc1ed434cfd$var$oe(r, t), r;
};



const $aa4b918858d193eb$export$93022c77e9af74dd = ({ children: children })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $aea31fc1ed434cfd$export$3d3872bfc53fd642), {
        reCaptchaKey: (0, $fce0e8aa624a9920$export$4682c216c5c4d5d7)(),
        useEnterprise: true,
        useRecaptchaNet: true,
        scriptProps: {
            async: true
        },
        children: children
    });
};




const $bbe5d5f40ba820cb$export$e65c18714c4363a3 = (params)=>{
    // set defaults for feature flags
    const featureFlags = {
        enableBundlesAfterSignup: false,
        enableCutSignUpStepsInHalf: false,
        provisionSecondPartyApps: false
    };
    params[0] && (params[0] = params[0].replace(/^\?(.+)/, "$1"));
    params.forEach((param)=>{
        const [key, value] = param.split("=");
        switch(key){
            case "provisionSecondPartyApps":
                if (value === "enableProvisionSecondPartyApps") featureFlags.provisionSecondPartyApps = true;
                break;
        }
    });
    return featureFlags;
};
const $bbe5d5f40ba820cb$export$9bf1c8c94a38f6fb = (location)=>{
    // remove all leading slashes (server had 2 leading slashes, client has 1)
    const noSlashPrefixPath = location.pathname.replace(/^\/+/, "");
    if (noSlashPrefixPath === "index.html" || noSlashPrefixPath === "") // case for the root/home page - redirect to trello
    return {
        locale: "en",
        path: "trello",
        variant: undefined,
        search: "",
        featureFlags: {}
    };
    // check if the route has a locale prefix
    const potentialLocale = noSlashPrefixPath.split("/")[0] || "";
    const localeIsValid = (0, $a69c6ceceedb3a08$export$b7c662043e31af59)(potentialLocale);
    // if there is a locale prefix, set the locale variable and remove the prefix from the path
    // otherwise, set the locale to the default (en) and leave the path as is
    const locale = localeIsValid ? potentialLocale : "en";
    const cleanedPath = localeIsValid ? noSlashPrefixPath.slice(locale.length + 1) : noSlashPrefixPath;
    const params = location.search.split("&");
    // Extract variant from query params (e.g., ?cmsVariant=some-variant)
    const cmsVariantValue = params.filter((param)=>param.includes("cmsVariant"))[0]?.split("=")[1];
    const featureFlags = $bbe5d5f40ba820cb$export$e65c18714c4363a3(params);
    return {
        path: cleanedPath,
        variant: cmsVariantValue,
        locale: locale,
        search: location.search,
        featureFlags: featureFlags
    };
};



// UFOSegment wrapper component that's safe for SSR
// UFOSegment uses @atlaskit/tokens which tries to access DOM during render
// We dynamically import it only on the client side to avoid SSR issues
const $26d99f0b55415e90$var$UFOWrapper = ({ children: children })=>{
    const [UFOSegmentComponent, setUFOSegmentComponent] = (0, $iSvIT.useState)(null);
    (0, $iSvIT.useEffect)(()=>{
        // Only import and set UFOSegment on the client side
        (parcelRequire("a1Odi")).then((mod)=>{
            setUFOSegmentComponent(()=>mod.default);
        });
    }, []);
    // During SSR or before the component loads, just render children
    if (!UFOSegmentComponent) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $loA2J.Fragment), {
        children: children
    });
    // On client side, wrap with UFOSegment
    return /*#__PURE__*/ (0, $loA2J.jsx)(UFOSegmentComponent, {
        name: "wac",
        children: children
    });
};
const $26d99f0b55415e90$export$c84671f46d6a1ca = (props)=>{
    const { locale: locale, path: path } = (0, $bbe5d5f40ba820cb$export$9bf1c8c94a38f6fb)(location);
    (0, $840236e27dba5bd6$export$4f045d9519647348)();
    (0, $iSvIT.useEffect)(()=>{
        // Send operational event when static fallback is detected
        if (window.IS_STATIC && props.analyticsWebClient) props.analyticsWebClient.sendOperationalEvent({
            action: "detected",
            actionSubject: "staticWACFallback",
            source: "layout",
            attributes: {
                route: window.location.pathname,
                userAgent: props.userAgent,
                anonymousId: props.analyticsWebClient.getAnonymousId()
            }
        });
    }, [
        props.analyticsWebClient,
        props.userAgent
    ]);
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $d4ee4c82e6c358af$export$52310512b1bd7aec), {
        children: [
            false,
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $9e7dba6014f411d3$export$f84a51d6dd0d7383), {
                analyticsWebClient: props.analyticsWebClient,
                location: props.location,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $f24bb8cd7cd93d4c$export$5af065edda80e75c), {
                    location: props.location,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)($26d99f0b55415e90$var$UFOWrapper, {
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $aa4b918858d193eb$export$93022c77e9af74dd), {
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cd2194d8d3feda9a$export$dc976c529d501f0c), {
                                baseUrl: (0, $cd2194d8d3feda9a$export$98ec7f86e3388cfc)(),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4afb343f3a1dfc96$export$936443f499340574), {
                                    hasCloudSessionTokenCookie: props.hasCloudSessionTokenCookie ?? false,
                                    userAgent: props.userAgent,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $784ebd6898abdb6b$export$164e91ee1eedc9fa), {
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3ac8e320c32641d0$export$cc11fd4b7198f590), {
                                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $ef56d09005ba07c9$export$d900e4062895cd7c), {
                                                locale: locale,
                                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $c2868f3eb82906a7$export$d6c39dfd40fa7ff8), {
                                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8c14082df14cf438$export$2e7f18b06f26b111), {
                                                        location: props.location.href,
                                                        meResponse: props.userProfile,
                                                        meRequest: props.userProfileStatus,
                                                        userProfileResponse: props.userContext,
                                                        userProfileRequest: props.userContextStatus,
                                                        loggedOutContext: props.loggedOutContext,
                                                        loggedOutContextStatus: props.loggedOutContextStatus,
                                                        loggedInContext: props.loggedInContext,
                                                        loggedInContextStatus: props.loggedInContextStatus,
                                                        children: /*#__PURE__*/ (0, $loA2J.jsx)(props.children, {
                                                            ...props,
                                                            pageModel: props.pageModel,
                                                            contentRendererParams: props.contentRendererParams
                                                        })
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};



var $loA2J = parcelRequire("loA2J");

var $9KLDf = parcelRequire("9KLDf");

var $dcmqH = parcelRequire("dcmqH");
parcelRequire("dg5xP");
var $g4xTJ = parcelRequire("g4xTJ");
var $5atKW = parcelRequire("5atKW");
var $kzY5l = parcelRequire("kzY5l");
var $8OmrV = parcelRequire("8OmrV");

var $fuZB8 = parcelRequire("fuZB8");

var $33PqJ = parcelRequire("33PqJ");
const $a17918a7d6b8e2e8$export$31641b61980e511f = ({ pageModel: pageModel } = {})=>{
    const header = pageModel?.content?.header;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            header && /*#__PURE__*/ (0, $loA2J.jsx)((0, $9KLDf.StaticRouter), {
                location: "/",
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $fuZB8.StaticLanguageProvider), {
                    language: "en",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $g4xTJ.AnalyticsAttributesProvider), {
                        value: {
                            eventContainer: "globalNav"
                        },
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $5atKW.RouteProvider), {
                            value: "/",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $kzY5l.AnalyticsProvider), {
                                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dcmqH.RendererProvider), {
                                    renderer: (0, $33PqJ.renderViewModel),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $8OmrV.FooterContextProvider), {
                                        children: (0, $33PqJ.renderViewModel)(header)
                                    })
                                })
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                id: "trello-root",
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "80px 24px",
                    minHeight: "400px",
                    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Noto Sans, Ubuntu, Droid Sans, 'Helvetica Neue', sans-serif",
                    // eslint-disable-next-line local/ensure-wac-token-usage
                    color: "#172b4d"
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                        style: {
                            fontSize: "20px",
                            fontWeight: 700,
                            marginBottom: "8px"
                        },
                        children: "Page not found."
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("p", {
                        style: {
                            fontSize: "16px",
                            margin: 0
                        },
                        children: [
                            "This page may be private. You may be able to view it by",
                            " ",
                            /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                href: "/login",
                                className: "js-login",
                                children: "logging in"
                            }),
                            "."
                        ]
                    })
                ]
            })
        ]
    });
};


window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $93c86ba4b7e7f969$export$2e2bcd8739ae039)()
    }
};
// Single component for SSR/hydration path
const $e57633d2a764242d$var$TrelloPageRenderer = (props)=>{
    if (props.isNotFound) return /*#__PURE__*/ (0, $loA2J.jsx)((0, $a17918a7d6b8e2e8$export$31641b61980e511f), {
        pageModel: props.pageModel
    });
    if (!props.pageModel) return null;
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $cExkZ.App), {
        defaultPageModel: props.pageModel
    });
};
const $e57633d2a764242d$export$2cd8252107eb640b = (_Page, props)=>{
    // Guard against SSR environment.
    if (typeof window === "undefined") return;
    // ---------------------------------------------------------------------
    const isStatic = window.IS_STATIC;
    // OneTrust / CPRA performance-cookie consent. If performance cookies
    // are disabled, exposure events must NOT be fired (privacy compliance).
    // LocationData is supplied by the SSR template via window.countryCode /
    // window.regionIsoCode (see trello-template.tsx); mirrors wac-web
    // init-streaming.tsx pattern.
    const locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $d4ee4c82e6c358af$export$f31515c886c1288b)((0, $d4ee4c82e6c358af$export$29027ffe85b122de)(document.cookie), locationData);
    // Keep production consent behavior, but allow local/dev debugging without OneTrust cookies.
    const shouldEnableAnalyticsClient = isPerfOnetrustEnabled;
    const analyticsWebClient = shouldEnableAnalyticsClient ? (0, $ea73d90b445eaf0d$export$ed4b549ef96c8511)() : null;
    // Initialize UFO imperatively BEFORE React renders — same pattern as wac-web init-streaming.tsx.
    // traceUFOPageLoad must fire AFTER initReactUFO so the subscriber is ready to capture it.
    if (analyticsWebClient) (0, $163dd4a6d5327e25$export$a0d0fe4ddcfb7311)(analyticsWebClient, window.location.pathname);
    const parsedClientCookies = document.cookie ? (0, $3tsVE.parse)(document.cookie) : {};
    const userAgent = window.navigator.userAgent;
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $a71889fc68f9e7b9$export$54e00feca1927558)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    (0, $05a33f5401262f31$export$933af3c61da21c8d)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // If performance cookies are disabled, run in localMode so the SDK
        // still resolves gate values but does NOT fire exposure events.
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const pageModel = props?.defaultPageModel || window.__PAGE_MODEL__ || null;
        const isNotFound = !!window.__IS_NOT_FOUND__;
        const rootElement = document.getElementById("trello-portal-root");
        // Filter out custom props that shouldn't be passed to DOM elements
        const shouldForwardProp = (prop)=>{
            const blockedProps = [
                "iconColorInitial",
                "themeInitial",
                "hoverColorInitial",
                "theme",
                "overflowingBreakpoints",
                "hideLanguageSelector"
            ];
            return !blockedProps.includes(prop);
        };
        const page = /*#__PURE__*/ (0, $loA2J.jsx)((0, $hYbro.StyleSheetManager), {
            shouldForwardProp: shouldForwardProp,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $26d99f0b55415e90$export$c84671f46d6a1ca), {
                analyticsWebClient: analyticsWebClient,
                location: window.location,
                userProfile: undefined,
                userProfileStatus: undefined,
                countryCode: undefined,
                hasCloudSessionTokenCookie: false,
                userAgent: navigator.userAgent,
                pageModel: pageModel,
                isNotFound: isNotFound,
                children: $e57633d2a764242d$var$TrelloPageRenderer
            })
        });
        if (isStatic) {
            const trelloElement = document.getElementById("trello");
            if (!trelloElement) throw new Error("Trello root element not found");
            const root = (0, $0053835da9e1d91f$export$882461b6382ed46c)(trelloElement);
            root.render(page);
        } else {
            if (!rootElement || !(rootElement instanceof Element)) throw new Error("[init-trello] trello-portal-root is not a valid DOM element. Type: " + typeof rootElement);
            (0, $0053835da9e1d91f$export$757ceba2d55c277e)(rootElement, page, {
                onRecoverableError: ()=>{
                    rootElement.setAttribute("hydration-error", "true");
                }
            });
        }
    });
};



var $cExkZ = parcelRequire("cExkZ");
// Wrap initialization to ensure it runs after DOM is ready
const $df2bd26af2a03f84$var$initializeApp = ()=>{
    // Get the page model from the window (set by SSR)
    const defaultPageModel = window.pageModel;
    // Initialize the app regardless - getRoute will return PlaceholderPage when needed
    (0, $e57633d2a764242d$export$2cd8252107eb640b)((0, $cExkZ.App), {
        defaultPageModel: defaultPageModel || undefined
    });
};
// Ensure DOM is ready before initializing
// Check multiple states since module scripts can load at different times
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", $df2bd26af2a03f84$var$initializeApp);
else if (document.readyState === "interactive" && !document.getElementById("trello-portal-root")) // DOM is being parsed but body might not be ready yet
document.addEventListener("DOMContentLoaded", $df2bd26af2a03f84$var$initializeApp);
else // DOM is ready (either interactive with body, or complete)
$df2bd26af2a03f84$var$initializeApp();


//# sourceMappingURL=trello-test-page.6eff0b61.js.map
